
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("5HvxH", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ff923158c0dee15$export$2e2bcd8739ae039);
$parcel$export(module.exports, "NavPlatformSidebar", () => $0ff923158c0dee15$export$7d687ab114dcac8a);

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");

var $TTcqD = parcelRequire("TTcqD");

var $10yQ6 = parcelRequire("10yQ6");

var $btoiF = parcelRequire("btoiF");


var $jM8x0 = parcelRequire("jM8x0");

var $dsVXF = parcelRequire("dsVXF");

var $bzSUP = parcelRequire("bzSUP");

var $4Onaa = parcelRequire("4Onaa");

var $4TntV = parcelRequire("4TntV");

var $19zz3 = parcelRequire("19zz3");

var $hmQJh = parcelRequire("hmQJh");

var $gDdYI = parcelRequire("gDdYI");

var $a8EUd = parcelRequire("a8EUd");

var $a3lK3 = parcelRequire("a3lK3");
const $0ff923158c0dee15$var$EMPTY_PROPS_OBJ = {};
var /**
 * Adding default export to support importCond() usage in PageContainer.
 */ $0ff923158c0dee15$export$2e2bcd8739ae039 = $0ff923158c0dee15$export$7d687ab114dcac8a;
function $0ff923158c0dee15$export$7d687ab114dcac8a() {
    /**
	 * The values returned by these hooks on the initial-render are what the useState ->C omponent uses
	 * until we change sidebars. This is by design. It keeps Component stable.
	 *
	 * Leaving useCurrentRoute() outside (of Component) means the stored component keeps the initial
	 * route via closure, so the sidebar stays stable across route changes.
	 *
	 * Moving useCurrentRoute() inside makes the stored component react to every navigation, which causes
	 * the sidebar subtree to update/remount during transitions, so the Spaces menu’s open state gets
	 * reset and you see it collapse then reopen.
	 */ const currentRoute = (0, $4Onaa.useCurrentRoute)();
    const paramsForGetNav4SidebarId = (0, $jM8x0.useGetParamsForGetNav4SidebarId)();
    const currentSidebarId = (0, $jM8x0.getNav4SidebarId)(paramsForGetNav4SidebarId);
    const currentEntryPointRef = (0, $btoiF.usePageLayoutEntryPoint)((0, $b666e36d39b806ff$export$50ea883ba6f28ff5));
    const isPageHydrating = (0, $TTcqD.useIsHydrateRenderMode)();
    const [sidebarConfig, setSidebarConfig] = (0, $euxye.useState)(()=>{
        // We want to avoid switching between the GlobalSideNavigationSidebarSelector and the sidebar entryPoint as we navigate through the SPA.
        // To do that, we need to keep using the __initial__ sidebar entryPoint if we haven't changed sidebars.
        // When we do switch sidebars, keep using GlobalSideNavigationSidebarSelector from that point onwards (for now).
        // When all of the sidebars are using entryPoints, we can deprecate the GlobalSideNavigationSidebarSelector.
        return {
            Component: ()=>{
                // When we are dealing with an anonymous user, immediately render the anonymous sidebar.
                // The Nav4 entrypoint selector doesn't do this early-exit.
                if (paramsForGetNav4SidebarId.isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $10yQ6.AnonymousSidebar), null);
                const extraEPRefPlaceholderProps = {
                    isSSRPlaceholderEnabled: !isPageHydrating ? currentRoute.entryPointOptions?.isSSRPlaceholderEnabled : undefined
                };
                return currentEntryPointRef && currentRoute.navigation?.sidebarId === currentSidebarId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
                    name: "gsn-sidebar-entrypoint"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
                    fallback: "flag",
                    id: "gsn-sidebar-entrypoint",
                    packageName: "nav-platform-integration"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dsVXF.EntryPointReferencePlaceholder), {
                    name: "gsn-sidebar-entrypoint-placeholder",
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4TntV.Skeleton), null),
                    entryPointReference: currentEntryPointRef,
                    isPlaceholderForPageLayoutComponent: true,
                    ...extraEPRefPlaceholderProps
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $n67Vb.EntryPointContainer), {
                    entryPointReference: currentEntryPointRef,
                    // oxlint-disable-next-line typescript/consistent-type-assertions
                    props: $0ff923158c0dee15$var$EMPTY_PROPS_OBJ
                })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0ff923158c0dee15$var$GlobalSideNavigationSidebarSelectorWithSuspense, null);
            },
            sidebarId: currentSidebarId
        };
    });
    // This is an inexpensive comparison (no need to use useEffect - in fact ESLint warns against doing so)
    if (sidebarConfig.sidebarId !== currentSidebarId) setSidebarConfig({
        Component: $0ff923158c0dee15$var$GlobalSideNavigationSidebarSelectorWithSuspense,
        sidebarId: currentSidebarId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0ff923158c0dee15$var$NavPlatWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(sidebarConfig.Component, null));
}
$0ff923158c0dee15$export$7d687ab114dcac8a.displayName = "NavPlatformSidebar";
const $0ff923158c0dee15$var$GlobalSideNavigationSidebarSelectorWithSuspense = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4.sidebar-global-side-navigation-sidebar-selector"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4-ignore.sidebar-global-side-navigation-sidebar-selector",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bzSUP.ReportSSRFailOnUse), {
            pageId: "navigation",
            fallbackId: "Sidebar",
            displayErrorInStaging: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a3lK3.GlobalSideNavigationSidebarSelector), null)));
$0ff923158c0dee15$var$GlobalSideNavigationSidebarSelectorWithSuspense.displayName = "GlobalSideNavigationSidebarSelectorWithSuspense";
// Both the content sidebar and the other sidebars use SidebarNav4ContextProvider.
// Therefore, it makes sense to
function $0ff923158c0dee15$var$NavPlatWrapper({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hmQJh.NavigateBackProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $19zz3.SidebarNav4ContextProvider), null, children));
}
$0ff923158c0dee15$var$NavPlatWrapper.displayName = "NavPlatWrapper";

});
parcelRegister("10yQ6", function(module, exports) {
$parcel$export(module.exports, "AnonymousSidebar", () => $975aade6563a1780$export$ad05f2e8bb7ab0b4);
/* AnonymousSidebar.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $dx7aH = parcelRequire("dx7aH");

var $6GljB = parcelRequire("6GljB");

var $9qH0V = parcelRequire("9qH0V");

var $a8EUd = parcelRequire("a8EUd");

var $gDdYI = parcelRequire("gDdYI");

var $f2wVS = parcelRequire("f2wVS");
const $975aade6563a1780$var$SIDEBAR_TEST_ID = 'page-layout.sidebar';
const $975aade6563a1780$var$EMPTY_CONFIG_OBJ = {};
const $975aade6563a1780$var$useMatchPath = (0, $f2wVS.createRouterSelector)((state)=>state.match.path);
function $975aade6563a1780$export$ad05f2e8bb7ab0b4() {
    const itemConfig = $975aade6563a1780$var$useItemConfig();
    return /*#__PURE__*/ $euxye.createElement((0, $gDdYI.default), {
        name: "sidebar.anonymous"
    }, /*#__PURE__*/ $euxye.createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "flag",
        id: "sidebars-anonymous",
        packageName: "jira-navigation-apps-sidebars-anonymous"
    }, /*#__PURE__*/ $euxye.createElement((0, $a8EUd.PlaceholderWithNativeSuspense), {
        name: "nav4-ignore.sidebar.anonymous"
    }, /*#__PURE__*/ $euxye.createElement((0, $9qH0V.GlobalSideNavigation), {
        app: "jira",
        appLabel: "Jira",
        customizationStore: "local",
        disableMenuCustomization: true,
        forYou: $975aade6563a1780$var$EMPTY_CONFIG_OBJ,
        isShortcutsStatic: true,
        items: itemConfig,
        testId: $975aade6563a1780$var$SIDEBAR_TEST_ID
    }))));
}
$975aade6563a1780$export$ad05f2e8bb7ab0b4.displayName = "AnonymousSidebar";
function $975aade6563a1780$var$useItemConfig() {
    const { formattedMessage: projectsMessage, icon: projectsIcon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).PROJECTS);
    const { formattedMessage: dashboardsMessage, icon: dashboardsIcon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).DASHBOARDS);
    const { formattedMessage: filtersMessage, icon: filtersIcon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).FILTERS);
    const path = $975aade6563a1780$var$useMatchPath();
    return (0, $euxye.useMemo)(()=>({
            [(0, $6GljB.L1_MENU_ID).PROJECTS]: {
                elemBefore: projectsIcon,
                href: '/jira/projects',
                isSelected: path.startsWith('/jira/projects'),
                label: projectsMessage,
                type: 'link'
            },
            [(0, $6GljB.L1_MENU_ID).FILTERS]: {
                elemBefore: filtersIcon,
                href: '/jira/filters',
                isSelected: path.startsWith('/jira/filters'),
                label: filtersMessage,
                type: 'link'
            },
            [(0, $6GljB.L1_MENU_ID).DASHBOARDS]: {
                elemBefore: dashboardsIcon,
                href: '/jira/dashboards',
                isSelected: path.startsWith('/jira/dashboards'),
                label: dashboardsMessage,
                type: 'link'
            }
        }), [
        dashboardsIcon,
        dashboardsMessage,
        filtersIcon,
        filtersMessage,
        path,
        projectsIcon,
        projectsMessage
    ]);
}

});
parcelRegister("dx7aH", function(module, exports) {
$parcel$export(module.exports, "useConfigurableMessageAndIconMap", () => $4ff7f136742857a0$export$783a136280b37c09);
$parcel$export(module.exports, "getConfigurableMessageAndIcon", () => $4ff7f136742857a0$export$56ffc7f3df8fae03);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");

var $2700E = parcelRequire("2700E");

var $bQpVj = parcelRequire("bQpVj");

var $KL7Bq = parcelRequire("KL7Bq");
const $4ff7f136742857a0$export$783a136280b37c09 = (menuId)=>{
    const { message: message, Icon: Icon } = $4ff7f136742857a0$export$56ffc7f3df8fae03(menuId);
    return (0, $KL7Bq.useFormattedMessageAndIcon)(message, Icon);
};
const $4ff7f136742857a0$export$56ffc7f3df8fae03 = (menuId)=>{
    const CONFIGURABLE_MESSAGE_AND_ICON_MAP = (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $bQpVj.CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM) : (0, $bQpVj.CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM);
    const SPACES_MESSAGE_AND_ICON_MAP = (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $bQpVj.SPACES_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM) : (0, $bQpVj.SPACES_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM);
    const { message: message, Icon: Icon } = menuId === (0, $5IkoH.CONFIGURABLE_MENU_ID).PROJECTS && (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? SPACES_MESSAGE_AND_ICON_MAP : CONFIGURABLE_MESSAGE_AND_ICON_MAP[menuId];
    return {
        message: message,
        Icon: Icon
    };
};

});
parcelRegister("KL7Bq", function(module, exports) {
$parcel$export(module.exports, "useFormattedMessageAndIcon", () => $cfc31b2dc2fa8902$export$efa1c7d3cd2d4f5c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");
const $cfc31b2dc2fa8902$export$efa1c7d3cd2d4f5c = (message, Icon)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const formattedMessage = formatMessage(message);
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Icon, {
        spacing: "spacious",
        color: "currentColor",
        "aria-hidden": "true"
    });
    return {
        formattedMessage: formattedMessage,
        icon: icon
    };
};

});



/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $b666e36d39b806ff$export$a9102b57dfd6b2a3 = '__pageLayoutPreviewPanel';
const $b666e36d39b806ff$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $b666e36d39b806ff$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $b666e36d39b806ff$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $b666e36d39b806ff$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $b666e36d39b806ff$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';
const $b666e36d39b806ff$export$5ef29550cd5a8266 = '___pageLayoutRedirect';
const $b666e36d39b806ff$export$22ce74854c620e75 = '__pageLayoutSpaContent';

parcelRegister("jM8x0", function(module, exports) {
$parcel$export(module.exports, "getNav4SidebarId", () => $e81ceed8113c875f$export$8cea2a93fc3986aa);
$parcel$export(module.exports, "useGetParamsForGetNav4SidebarId", () => $e81ceed8113c875f$export$e102a5137dc15645);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");








var $bfBRs = parcelRequire("bfBRs");

var $aoPm1 = parcelRequire("aoPm1");

var $f5Y0v = parcelRequire("f5Y0v");

var $cZS7p = parcelRequire("cZS7p");

var $7p0B1 = parcelRequire("7p0B1");

var $6HvWM = parcelRequire("6HvWM");

var $f2wVS = parcelRequire("f2wVS");

var $cvA2R = parcelRequire("cvA2R");

var $i860n = parcelRequire("i860n");
function $e81ceed8113c875f$export$8cea2a93fc3986aa(params) {
    const { configParam: configParam, isAnonymous: isAnonymous = false, isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive, isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive, isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive, routerState: routerState, shouldUseJSM: shouldUseJSM } = params;
    const sidebarId = routerState.route.navigation?.sidebarId;
    const pathname = routerState.location.pathname;
    const isChatOpsPath = pathname.includes('/jira-service-management-chatops-and-video-tools');
    const hasChatOpsTenantAccess = shouldUseJSM;
    if (isAnonymous) return 'ANONYMOUS';
    // Deal with the exceptions...
    if (sidebarId === (0, $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0)) {
        if (!pathname.includes('/discover')) return sidebarId;
        return 0, $6cc4c278d90305fc$export$373854fe102ad77c;
    }
    if (sidebarId === (0, $92d0e44258fe76a3$export$e8aa2912a0792727)) {
        if (isChatOpsPath && hasChatOpsTenantAccess) return 0, $6cc4c278d90305fc$export$373854fe102ad77c;
        return sidebarId;
    }
    // Project settings sidebars
    if (routerState.route.name === 'polaris-ideas' && routerState.match.params.section === 'settings' || isProjectSettingsConnectAppActive) return 0, $28266b9d90f7c617$export$624732ab55954dd9;
    // Board settings sidebar
    if (routerState.route.group === 'classic-software' && (0, $bfBRs.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(configParam)) return 0, $98344e6aff454659$export$c97893643d53b8ab;
    if (sidebarId === (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7) && (0, $i860n.fg)('csm_appification_standalone_navigation')) return 0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7;
    if (isGlobalAppsSettingsConnectItemActive) return 0, $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0;
    if (isGlobalSystemSettingsConnectItemActive) return 0, $1b7637cabf39cd90$export$e03d9e7e646baacb;
    return sidebarId || (0, $6cc4c278d90305fc$export$373854fe102ad77c);
}
function $e81ceed8113c875f$export$e102a5137dc15645(params = {}) {
    const { routerState: routerState = (0, $f2wVS.getRouterState)() } = params;
    const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, $f5Y0v.useGlobalAppsSettingsConnectItemActive)();
    const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, $cZS7p.useGlobalSystemSettingsConnectItemActive)();
    const { isActive: isProjectSettingsConnectAppActive } = (0, $7p0B1.useIsConnectAppActive)();
    const { shouldUseJSM: shouldUseJSM } = (0, $6HvWM.useOgTenantInfo)();
    const configParam = (0, $aoPm1.useMaybeConfigParam)() || '';
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    return (0, $euxye.useMemo)(()=>({
            configParam: configParam,
            isAnonymous: isAnonymous,
            isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive,
            isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive,
            isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive,
            routerState: routerState,
            shouldUseJSM: shouldUseJSM
        }), [
        configParam,
        isAnonymous,
        isGlobalAppsSettingsConnectItemActive,
        isGlobalSystemSettingsConnectItemActive,
        isProjectSettingsConnectAppActive,
        routerState,
        shouldUseJSM
    ]);
}

});
const $98344e6aff454659$export$c97893643d53b8ab = 'BOARD_SETTINGS';

const $6cc4c278d90305fc$export$373854fe102ad77c = 'CONTENT';

const $f11be1b6bfa50d8e$export$1590673d7ba4cdb7 = 'CSM_APP';

const $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0 = 'GLOBAL_APPS_SETTINGS';

const $92d0e44258fe76a3$export$e8aa2912a0792727 = 'GLOBAL_PRODUCTS_SETTINGS';

const $1b7637cabf39cd90$export$e03d9e7e646baacb = 'GLOBAL_SYSTEM_SETTINGS';

const $28266b9d90f7c617$export$624732ab55954dd9 = 'PROJECT_SETTINGS';

parcelRegister("aoPm1", function(module, exports) {
$parcel$export(module.exports, "useConfigParam", () => $eea7d7f13629eac4$export$b8842df7174e4acb);
$parcel$export(module.exports, "useMaybeConfigParam", () => $eea7d7f13629eac4$export$2135334620af5209);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $cZjb4 = parcelRequire("cZjb4");
var $2ffUK = parcelRequire("2ffUK");

var $bfBRs = parcelRequire("bfBRs");
function $eea7d7f13629eac4$export$b8842df7174e4acb() {
    const lastValidConfig = (0, $euxye.useRef)(null);
    const configParam = $eea7d7f13629eac4$export$2135334620af5209();
    const result = (0, $euxye.useMemo)(()=>{
        if (!configParam) {
            if (lastValidConfig.current) return lastValidConfig.current;
            throw new Error('No config param found');
        }
        return $eea7d7f13629eac4$var$isConfigQuery(configParam) ? configParam : null;
    }, [
        configParam
    ]);
    (0, $euxye.useEffect)(()=>{
        if (result) lastValidConfig.current = result;
    }, [
        result
    ]);
    return result;
}
function $eea7d7f13629eac4$export$2135334620af5209() {
    const [configPath] = (0, $cZjb4.usePathParam)('config');
    const [configQuery] = (0, $2ffUK.useQueryParam)('config');
    return configPath || configQuery;
}
const $eea7d7f13629eac4$var$isConfigQuery = (configQuery)=>(0, $bfBRs.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(configQuery);

});

parcelRegister("f5Y0v", function(module, exports) {
$parcel$export(module.exports, "useGlobalSettingsConnectItems", () => $78c6a5323457b8b7$export$f0785b98c99d344c);
$parcel$export(module.exports, "useIsAppsSettingsConnectAppModule", () => $78c6a5323457b8b7$export$8dd86b1eb9fdf786);
$parcel$export(module.exports, "useGlobalAppsSettingsConnectItemActive", () => $78c6a5323457b8b7$export$83008eebb9fccef3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $cn1qc = parcelRequire("cn1qc");

var $aXunP = parcelRequire("aXunP");

var $efbPr = parcelRequire("efbPr");

var $fioUk = parcelRequire("fioUk");

var $108JP = parcelRequire("108JP");

var $lh4YE = parcelRequire("lh4YE");

var $j3ksD = parcelRequire("j3ksD");
const $78c6a5323457b8b7$var$getItems = (d)=>(0, $108JP.getLinks)(d, [
        'admin_plugins_menu'
    ], {
        skipFilter: true
    }).filter((v)=>![
            'upm_section',
            'jpo-ws-admin'
        ].includes(v.id)) // remove sections also statically defined
    .map((0, $lh4YE.transformLink)) // Apply transformation to each link
    .filter(Boolean); // Remove falsy values
const $78c6a5323457b8b7$export$f0785b98c99d344c = ()=>{
    const { data: data, loading: loading, error: error } = (0, $j3ksD.useNavigationGlobalResource)();
    const items = (0, $euxye.useMemo)(()=>data && $78c6a5323457b8b7$var$getItems(data), [
        data
    ]);
    return {
        data: items,
        loading: loading,
        error: error
    };
};
const $78c6a5323457b8b7$export$ae997bf97ec22b71 = new Set([
    'configurePage',
    'postInstallPage'
]);
const $78c6a5323457b8b7$export$8dd86b1eb9fdf786 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $efbPr.useConnectGeneralResource)();
    return {
        isActive: $78c6a5323457b8b7$export$ae997bf97ec22b71.has(data?.moduleType),
        loading: loading,
        error: error
    };
};
const $78c6a5323457b8b7$export$83008eebb9fccef3 = ()=>{
    const location = (0, $cn1qc.useLocation)();
    const route = (0, $aXunP.useRoute)();
    const { data: data, loading: loading, error: error } = $78c6a5323457b8b7$export$f0785b98c99d344c();
    const { isActive: isAppsSettingsConnectAppModuleActive, loading: isAppsSettingsConnectAppModuleLoading, error: isAppsSettingsConnectAppModuleError } = $78c6a5323457b8b7$export$8dd86b1eb9fdf786();
    const isActive = (0, $euxye.useMemo)(()=>Boolean(route && data && (0, $fioUk.findItemAndStack)(data, route.name, location)?.selected), [
        data,
        route,
        location
    ]);
    return {
        isActive: isActive || isAppsSettingsConnectAppModuleActive,
        loading: loading || isAppsSettingsConnectAppModuleLoading,
        error: error || isAppsSettingsConnectAppModuleError
    };
};

});
parcelRegister("cn1qc", function(module, exports) {
$parcel$export(module.exports, "useLocation", () => $c6d45eb89906a7fc$export$45d76561a5302f2b);

var $f2wVS = parcelRequire("f2wVS");
const $c6d45eb89906a7fc$export$45d76561a5302f2b = (0, $f2wVS.createRouterSelector)((state)=>state.location);

});

parcelRegister("aXunP", function(module, exports) {
$parcel$export(module.exports, "useRoute", () => $d739b764bbc45279$export$3f79f0b98112cf57);

var $f2wVS = parcelRequire("f2wVS");
const $d739b764bbc45279$export$3f79f0b98112cf57 = (0, $f2wVS.createRouterSelector)((state)=>state.route);

});

parcelRegister("efbPr", function(module, exports) {
$parcel$export(module.exports, "connectGeneralResources", () => $0ab8c2274feecda9$export$f34ab0d904621847);
$parcel$export(module.exports, "useConnectGeneralResource", () => $0ab8c2274feecda9$export$53479840ec6d4024);

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");
const $0ab8c2274feecda9$var$RESOURCE_TYPE_CONNECT_GENERAL = 'CONNECT_GENERAL';

const $0ab8c2274feecda9$export$f34ab0d904621847 = (0, $7edbf.createResource)({
    type: $0ab8c2274feecda9$var$RESOURCE_TYPE_CONNECT_GENERAL,
    getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
        // spa-router/src/common/types.js:
        /** TODO we are supporting `undefined` here because we are currently using both
		 * this version of the `Match` type, and react-routers version (which allows for `undefined`)
		 * To fix this we should move `matchPath` to our own util so we can apply our own types, then
		 * decide if we want to support undefined types.
		 */ if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("c4d3X"))
});
const $0ab8c2274feecda9$export$53479840ec6d4024 = ()=>(0, $k6ufm.useResource)($0ab8c2274feecda9$export$f34ab0d904621847);

});
parcelRegister("c4d3X", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5mJ2M").then(()=>parcelRequire('iFZAj'));

});


parcelRegister("fioUk", function(module, exports) {
$parcel$export(module.exports, "findItemAndStack", () => $415aa84588c9cd04$export$751e2e6237002565);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bxhpq = parcelRequire("bxhpq");

var $9IsTH = parcelRequire("9IsTH");
// JSPA-1062 remove qs items that might not always be there
const $415aa84588c9cd04$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $415aa84588c9cd04$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $415aa84588c9cd04$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $9IsTH.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $415aa84588c9cd04$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $415aa84588c9cd04$var$splitRelevantQs(itemQs);
        const sameQuery = $415aa84588c9cd04$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $415aa84588c9cd04$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});
parcelRegister("9IsTH", function(module, exports) {
$parcel$export(module.exports, "CONNECT_ROUTES_SET", () => $4c467def67c2dfdc$export$c47bf667d3008c53);
$parcel$export(module.exports, "CSM_ONLY_BOARD_ROUTES_SET", () => $4c467def67c2dfdc$export$97b2975e0ed95e30);
$parcel$export(module.exports, "JSM_BOARD_ROUTES_SET", () => $4c467def67c2dfdc$export$50c2d6bcb0b94b74);
$parcel$export(module.exports, "JSM_BOARD_ROUTES_SET_OLD", () => $4c467def67c2dfdc$export$50071d01388d46a5);
/* eslint-disable jira/filename-case */ const $4c467def67c2dfdc$export$c47bf667d3008c53 = new Set([
    'connect-project',
    'connect-general',
    'connect-general-service-desk-project',
    'legacy-connect-project',
    'legacy-connect-general'
]);
const $4c467def67c2dfdc$export$97b2975e0ed95e30 = new Set([
    'csm-queues-views-config'
]);
const $4c467def67c2dfdc$export$50c2d6bcb0b94b74 = new Set([
    'servicedesk-boards',
    'servicedesk-queues-views-config',
    'servicedesk-practice-views-config',
    ...$4c467def67c2dfdc$export$97b2975e0ed95e30
]);
const $4c467def67c2dfdc$export$50071d01388d46a5 = new Set([
    'servicedesk-boards',
    'servicedesk-queues-views-config',
    'servicedesk-practice-views-config'
]);

});


parcelRegister("108JP", function(module, exports) {
$parcel$export(module.exports, "getLinks", () => $521fe687796a9a1b$export$8054dcb2b42da45c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hR2Wt = parcelRequire("hR2Wt");
const $521fe687796a9a1b$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
        if (item.id === legacyId) return item.links;
        return item.links && $521fe687796a9a1b$var$findChildLinks(item.links, legacyId);
    }).find(Boolean);
const $521fe687796a9a1b$var$getLinksFromSidebar = (sidebarConfig, legacyId)=>{
    const links = legacyId != null ? $521fe687796a9a1b$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
    return links || [];
};
const $521fe687796a9a1b$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
    const acc = [];
    locations.forEach((location)=>{
        const links = $521fe687796a9a1b$var$getLinksFromSidebar(sidebarConfig, location);
        if (omitSections === true) {
            // merge 2 arrays in good performance way
            Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
            return;
        }
        // merge 2 arrays in good performance way
        Array.prototype.push.apply(acc, links);
    });
    return acc.filter((item)=>{
        if (!item) return false;
        if (skipFilter === true) return true;
        const hasConnectPrefix = item.id && item.id.includes((0, $hR2Wt.connectPrefix));
        if (hasConnectPrefix) return true;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"sd-reports-addons" | "sd-queues-addons" | "com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent"'.
        const isConnectSection = (0, $hR2Wt.connectSections).includes(item.id);
        if (isConnectSection) return true;
        const isJsdConnectSection = item.id && item.id.includes((0, $hR2Wt.jsdConnectPrefix));
        if (isJsdConnectSection) return true;
        return false;
    });
};

});
parcelRegister("hR2Wt", function(module, exports) {
$parcel$export(module.exports, "connectPrefix", () => $8189455bec75978b$export$196d83ebd873fb40);
$parcel$export(module.exports, "jsdConnectPrefix", () => $8189455bec75978b$export$7fac8f726f52d70);
$parcel$export(module.exports, "connectSections", () => $8189455bec75978b$export$b1c2c1fc5d10280);
/* eslint-disable jira/filename-case */ 
var $bhya5 = parcelRequire("bhya5");
const $8189455bec75978b$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
const $8189455bec75978b$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
const $8189455bec75978b$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const $8189455bec75978b$var$jsdQueuesConnectSection = 'sd-queues-addons';
const $8189455bec75978b$export$b1c2c1fc5d10280 = [
    $8189455bec75978b$var$legacyAddonPanelLinkId,
    (0, $bhya5.REPORTS_IDS).REPORTS_ADDONS,
    $8189455bec75978b$var$jsdQueuesConnectSection
];

});


parcelRegister("lh4YE", function(module, exports) {
$parcel$export(module.exports, "transformLink", () => $d1a3b8d2c57ad05c$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $d1a3b8d2c57ad05c$export$27267b6b6650eaa5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $d1a3b8d2c57ad05c$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($d1a3b8d2c57ad05c$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $d1a3b8d2c57ad05c$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($d1a3b8d2c57ad05c$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});

parcelRegister("j3ksD", function(module, exports) {
$parcel$export(module.exports, "useNavigationGlobalResource", () => $3166c13d8746a7f5$export$1e1c317ed5b99faa);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /* eslint-disable import/order */ 
var $45Itd = parcelRequire("45Itd");

var $k6ufm = parcelRequire("k6ufm");
const $3166c13d8746a7f5$export$1e1c317ed5b99faa = ()=>{
    const { data: data, loading: loading, error: error } = (0, $k6ufm.useResource)((0, $45Itd.navigationSidebarGlobalResource));
    return {
        data: data && data.response,
        loading: loading,
        error: error
    };
};

});


parcelRegister("cZS7p", function(module, exports) {
$parcel$export(module.exports, "useGlobalSystemSettingsConnectItems", () => $b2c0fbc0d92e1017$export$68950d4e14439158);
$parcel$export(module.exports, "useGlobalSystemSettingsConnectItemActive", () => $b2c0fbc0d92e1017$export$5efb701a2106707a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $cn1qc = parcelRequire("cn1qc");

var $aXunP = parcelRequire("aXunP");

var $efbPr = parcelRequire("efbPr");

var $fioUk = parcelRequire("fioUk");

var $108JP = parcelRequire("108JP");

var $lh4YE = parcelRequire("lh4YE");

var $5mgOF = parcelRequire("5mgOF");

var $j3ksD = parcelRequire("j3ksD");
const $b2c0fbc0d92e1017$var$getItems = (d)=>(0, $108JP.getLinks)(d, [
        'admin_system_menu'
    ], {
        skipFilter: true
    }).map((0, $lh4YE.transformLink)) // Apply transformation to each link
    .filter(Boolean); // Remove falsy values
const $b2c0fbc0d92e1017$export$68950d4e14439158 = (0, $5mgOF.withThrowOnError)(()=>{
    // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
    const { data: data, loading: loading, error: error } = (0, $j3ksD.useNavigationGlobalResource)();
    const items = (0, $euxye.useMemo)(()=>data && $b2c0fbc0d92e1017$var$getItems(data), [
        data
    ]);
    return {
        data: items,
        loading: loading,
        error: error
    };
});
const $b2c0fbc0d92e1017$export$5efb701a2106707a = ()=>{
    const location = (0, $cn1qc.useLocation)();
    const route = (0, $aXunP.useRoute)();
    const { data: data, loading: loading, error: error } = $b2c0fbc0d92e1017$export$68950d4e14439158();
    const { data: connectGeneralData, loading: connectGeneralResourceLoading, error: connectGeneralResourceError } = (0, $efbPr.useConnectGeneralResource)();
    const isActive = (0, $euxye.useMemo)(()=>Boolean(route && data && (0, $fioUk.findItemAndStack)(data, route.name, location)?.selected), [
        data,
        route,
        location
    ]);
    return {
        isActive: isActive || connectGeneralData?.moduleType === 'adminPages',
        loading: loading || connectGeneralResourceLoading,
        error: error || connectGeneralResourceError
    };
};

});
parcelRegister("5mgOF", function(module, exports) {
$parcel$export(module.exports, "withThrowOnError", () => $0d2e14a428b14ab2$export$a018832f2ec4dc91);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $0d2e14a428b14ab2$var$isDataEmpty = (data)=>data == null;
function $0d2e14a428b14ab2$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $0d2e14a428b14ab2$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});


parcelRegister("7p0B1", function(module, exports) {
$parcel$export(module.exports, "useIsConnectAppActive", () => $eef09d6ac398388c$export$249b2e8512031cae);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $cn1qc = parcelRequire("cn1qc");

var $aXunP = parcelRequire("aXunP");

var $fioUk = parcelRequire("fioUk");

var $lGWdv = parcelRequire("lGWdv");
const $eef09d6ac398388c$export$249b2e8512031cae = ()=>{
    const location = (0, $cn1qc.useLocation)();
    const route = (0, $aXunP.useRoute)();
    const { data: connectApps, error: error, loading: loading } = (0, $lGWdv.useConnectApps)();
    const isActive = (0, $euxye.useMemo)(()=>Boolean((0, $fioUk.findItemAndStack)(connectApps, route.name, location)?.selected), [
        connectApps,
        location,
        route.name
    ]);
    return {
        isActive: isActive,
        loading: loading,
        error: error
    };
};

});
parcelRegister("lGWdv", function(module, exports) {
$parcel$export(module.exports, "useConnectApps", () => $d8076ccb5592eea0$export$4864478dcab77643);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $iFmc7 = parcelRequire("iFmc7");

var $lh4YE = parcelRequire("lh4YE");

var $a0PpC = parcelRequire("a0PpC");
const $d8076ccb5592eea0$export$4864478dcab77643 = ()=>{
    const { data: connectResourceItems, error: error, loading: loading } = (0, $iFmc7.useProjectSettingsSidebarConnectAddonsNavigationResource)();
    const connectApps = (0, $euxye.useMemo)(()=>{
        if (connectResourceItems == null) return [];
        const transformedConnectApps = [];
        for (const item of connectResourceItems){
            const transformedItem = (0, $lh4YE.transformLinkV4)(item);
            if (transformedItem && !(0, $a0PpC.LEGACY_CONNECT_ITEM_IDS).has(transformedItem.id)) transformedConnectApps.push(transformedItem);
        }
        return transformedConnectApps;
    }, [
        connectResourceItems
    ]);
    return {
        data: connectApps,
        loading: loading,
        error: error
    };
};

});
parcelRegister("a0PpC", function(module, exports) {
$parcel$export(module.exports, "LEGACY_CONNECT_ITEM_IDS", () => $4f63780b36ada487$export$911a3d81a5d162b6);
/* eslint-disable jira/filename-case */ // This is a list of known legacy connect item IDs that is used to filter out unecessary connect items
// from being rendered in the connect sections
const $4f63780b36ada487$export$911a3d81a5d162b6 = new Set([
    // Global Settings Static Legacy IDs
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy IDs
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation.moderate__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation',
    'com.codebarrel.addons.automation.moderate__cb-automation'
]);

});




parcelRegister("4TntV", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $7c60304cda8ae848$export$8f31e4c4a37b8e9c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6Elhl = parcelRequire("6Elhl");

var $c69sa = parcelRequire("c69sa");

var $kcJbW = parcelRequire("kcJbW");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");
const $7c60304cda8ae848$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.200",
        xcss: $7c60304cda8ae848$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $7c60304cda8ae848$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $7c60304cda8ae848$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kcJbW.Grid), {
        columnGap: "space.100",
        rowGap: "space.050",
        alignItems: "center",
        templateAreas: [
            'avatar name',
            'avatar type'
        ],
        templateColumns: "min-content 1fr",
        xcss: $7c60304cda8ae848$var$projectHeading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $7c60304cda8ae848$var$projectAvatar,
        style: {
            gridArea: 'avatar'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $7c60304cda8ae848$var$projectName,
        style: {
            gridArea: 'name'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $7c60304cda8ae848$var$projectType,
        style: {
            gridArea: 'type'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $7c60304cda8ae848$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $7c60304cda8ae848$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $7c60304cda8ae848$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $7c60304cda8ae848$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $7c60304cda8ae848$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $7c60304cda8ae848$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $7c60304cda8ae848$var$menuItem
    })));
$7c60304cda8ae848$export$8f31e4c4a37b8e9c.displayName = "Skeleton";
const $7c60304cda8ae848$var$containerStyles = (0, $fbAgj.xcss)({
    height: '100%',
    padding: 'space.200'
});
const $7c60304cda8ae848$var$backButton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small'
});
const $7c60304cda8ae848$var$headingSkeleton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small',
    flex: 1
});
const $7c60304cda8ae848$var$projectHeading = (0, $fbAgj.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $7c60304cda8ae848$var$projectAvatar = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small'
});
const $7c60304cda8ae848$var$projectName = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'radius.small'
});
const $7c60304cda8ae848$var$projectType = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-100, 8px)",
    borderRadius: 'radius.small'
});
const $7c60304cda8ae848$var$menuItem = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});

});

parcelRegister("19zz3", function(module, exports) {
$parcel$export(module.exports, "SidebarNav4ContextProvider", () => $9831d0b4044a98b7$export$ebf7cdfc2e83bcef);
$parcel$export(module.exports, "useSidebarNav4", () => $9831d0b4044a98b7$export$dc46c14934833db2);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $bc9Gj = parcelRequire("bc9Gj");

var $bkBsT = parcelRequire("bkBsT");

var $aK5Al = parcelRequire("aK5Al");

var $k0Ro9 = parcelRequire("k0Ro9");
const $9831d0b4044a98b7$var$SidebarNav4Context = /*#__PURE__*/ (0, $euxye.createContext)(null);
function $9831d0b4044a98b7$export$2854101beb9a2d8d(props) {
    const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
    const [routerContext] = (0, $bc9Gj.useRouter)();
    const initialSelectedPath = (0, $bkBsT.getInitialSelectedPath)(routerContext);
    const [selectedPath, setSelectedPath] = (0, $euxye.useState)(initialSelectedPath);
    // When the `routerContext` changes, we need to recalculate the selected path.
    // useLayoutEffect, so this happens before render.
    (0, $euxye.useLayoutEffect)(()=>{
        setSelectedPath((currentPath)=>{
            const newPath = (0, $k0Ro9.routeToSelectedPath)(routerContext);
            return currentPath.toString() === newPath.toString() ? currentPath : newPath;
        });
    }, [
        routerContext
    ]);
    const sidebarNav4Controller = (0, $euxye.useMemo)(()=>({
            isInitialSelectedPath: isInitialSelectedPath ?? (0, $aK5Al.isSelectedPath)(initialSelectedPath),
            isSelectedPath: (0, $aK5Al.isSelectedPath)(selectedPath)
        }), [
        initialSelectedPath,
        isInitialSelectedPath,
        selectedPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9831d0b4044a98b7$var$SidebarNav4Context.Provider, {
        value: sidebarNav4Controller
    }, children);
}
$9831d0b4044a98b7$export$2854101beb9a2d8d.displayName = "SidebarNav4ContextProviderOld";
function $9831d0b4044a98b7$export$ebf7cdfc2e83bcef(props) {
    const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
    const selectedPathData = (0, $k0Ro9.useRouteToSelectedPath)();
    const sidebarNav4Controller = (0, $euxye.useMemo)(()=>({
            isInitialSelectedPath: isInitialSelectedPath ?? (0, $aK5Al.isSelectedPath)(selectedPathData.initialSelectedPath),
            isSelectedPath: (0, $aK5Al.isSelectedPath)(selectedPathData.selectedPath)
        }), [
        isInitialSelectedPath,
        selectedPathData.initialSelectedPath,
        selectedPathData.selectedPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9831d0b4044a98b7$var$SidebarNav4Context.Provider, {
        value: sidebarNav4Controller
    }, children);
}
$9831d0b4044a98b7$export$ebf7cdfc2e83bcef.displayName = "SidebarNav4ContextProvider";
function $9831d0b4044a98b7$export$dc46c14934833db2() {
    const context = (0, $euxye.useContext)($9831d0b4044a98b7$var$SidebarNav4Context);
    if (context == null) throw new Error('useSidebarNav4 must be used inside a SidebarNav4ContextProvider');
    return context;
}

});

parcelRegister("hmQJh", function(module, exports) {
$parcel$export(module.exports, "useNavigateBack", () => $656e92f92e9e777b$export$7ce1f551d78f9130);
$parcel$export(module.exports, "NavigateBackProvider", () => $656e92f92e9e777b$export$e1e76f4ee7f8174d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3T5IC = parcelRequire("3T5IC");

var $cZjb4 = parcelRequire("cZjb4");

var $eWBug = parcelRequire("eWBug");
const $656e92f92e9e777b$var$STORAGE_KEY = 'back-button-url';
const $656e92f92e9e777b$var$NavigateBackContext = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
const $656e92f92e9e777b$export$7ce1f551d78f9130 = ()=>{
    const context = (0, $euxye.useContext)($656e92f92e9e777b$var$NavigateBackContext);
    if (!context) throw new Error('useNavigateBack must be used within a NavigateBackProvider');
    return context;
};
function $656e92f92e9e777b$export$e1e76f4ee7f8174d({ children: children }) {
    const [projectKey] = (0, $cZjb4.usePathParam)('projectKey');
    const defaultInitialUrl = projectKey ? `/projects/${projectKey}` : (0, $3T5IC.jiraHomeRoute).path;
    const [previousUrl, setPreviousUrl] = (0, $euxye.useState)(()=>(0, $eWBug.storageProvider).get($656e92f92e9e777b$var$STORAGE_KEY) ?? defaultInitialUrl);
    const saveCurrentRoute = (0, $euxye.useCallback)((currentUrl)=>{
        setPreviousUrl(currentUrl);
        // @browser-storage setter
        (0, $eWBug.storageProvider).setStrictlyNecessaryItem($656e92f92e9e777b$var$STORAGE_KEY, currentUrl);
    }, []);
    const value = (0, $euxye.useMemo)(()=>({
            saveCurrentRoute: saveCurrentRoute,
            previousUrl: previousUrl
        }), [
        saveCurrentRoute,
        previousUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($656e92f92e9e777b$var$NavigateBackContext.Provider, {
        value: value
    }, children);
}
$656e92f92e9e777b$export$e1e76f4ee7f8174d.displayName = "NavigateBackProvider";

});
parcelRegister("3T5IC", function(module, exports) {
$parcel$export(module.exports, "jiraHomeRoute", () => $39d9e83b0ce45394$export$11ebbd6d4e57759c);
const $39d9e83b0ce45394$export$11ebbd6d4e57759c = {
    name: 'for-you',
    path: '/jira/for-you'
};

});

parcelRegister("eWBug", function(module, exports) {
$parcel$export(module.exports, "storageProvider", () => $8143dcafb711532e$export$ce7751641b93537d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $cBnIS = parcelRequire("cBnIS");
const $8143dcafb711532e$export$ce7751641b93537d = (0, $cBnIS.createSessionStorageProvider)('sidebar-navigation');

});


parcelRegister("a3lK3", function(module, exports) {
$parcel$export(module.exports, "GlobalSideNavigationSidebarSelector", () => $a1f8c5ce20112525$export$4de626f5922d11d0);
/* GlobalSideNavigationSidebarSelector.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $56F5E = parcelRequire("56F5E");

var $jM8x0 = parcelRequire("jM8x0");

var $fXLAN = parcelRequire("fXLAN");

var $gq46S = parcelRequire("gq46S");

var $9OIox = parcelRequire("9OIox");
function $a1f8c5ce20112525$export$4de626f5922d11d0() {
    const { data: data } = (0, $fXLAN.useSuspenseResource)((0, $56F5E.navPlatformSidebarResource));
    const sidebarId = (0, $jM8x0.getNav4SidebarId)((0, $jM8x0.useGetParamsForGetNav4SidebarId)());
    if (sidebarId === 'CONTENT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9OIox.GSNForContentSidebar), {
        queryReference: data
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gq46S.GSNForOtherSidebars), {
        queryReference: data
    });
}
$a1f8c5ce20112525$export$4de626f5922d11d0.displayName = "GlobalSideNavigationSidebarSelector";

});
parcelRegister("gq46S", function(module, exports) {
$parcel$export(module.exports, "GSNForOtherSidebars", () => $e562b357b36e3c21$export$8c6d29ef23f67ed7);
$parcel$export(module.exports, "GSNForOtherSidebarsInner", () => $e562b357b36e3c21$export$e6690b6a9934123e);

var $6bcQF = parcelRequire("6bcQF");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $bZIAK = parcelRequire("bZIAK");

var $28RaS = parcelRequire("28RaS");

var $9qH0V = parcelRequire("9qH0V");

var $lw94j = parcelRequire("lw94j");

var $i0T2O = parcelRequire("i0T2O");

const $e562b357b36e3c21$var$styles = {
    root: "_19pkxmi2 _2hwxxmi2 _otyrxmi2 _18u0xmi2"
};
const $e562b357b36e3c21$var$EMPTY_CONFIG_OBJ = {};
function $e562b357b36e3c21$export$8c6d29ef23f67ed7(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lw94j.GSNQueryPreloader), {
        queryReference: props.queryReference,
        render: $e562b357b36e3c21$var$renderFn
    });
}
$e562b357b36e3c21$export$8c6d29ef23f67ed7.displayName = "GSNForOtherSidebars";
function $e562b357b36e3c21$var$renderFn(params) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e562b357b36e3c21$export$e6690b6a9934123e, {
        queryReference: params.queryReference
    });
}
function $e562b357b36e3c21$export$e6690b6a9934123e(props) {
    const { queryReference: queryReference, postMainElement: postMainElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            $e562b357b36e3c21$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bZIAK.SidebarSelector), null)) } = props; // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)(//  Even if we could just indicate that we only need the sidebar data (which we can't,
    //  because GSN expects all of the data), we have already requested it.
    // Need to disable this rule for fragments that are used by child components
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ /* eslint-disable @atlassian/relay/unused-fields */ (0, $6bcQF.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryReference);
    const networkStorageParamsPartial = (0, $i0T2O.useNetworkStorageParams)();
    const networkStorageParams = (0, $euxye.useMemo)(()=>{
        return {
            ...networkStorageParamsPartial,
            queryRef: data
        };
    }, [
        data,
        networkStorageParamsPartial
    ]); // Note: When Jira GSN adoption rolls out, it should rollout with "network-migration" for 3 months
    //  to give time for all old user settings to be stored in the new records.
    //
    //    - customizationStore="network-migration"
    //
    //  After 3 months of being rolled-out, create a new FG to:
    //   - Change customizationStore to "network"
    //   - @include(if: $fgVariable) for useNetworkSideNavUserData.
    //   - After that has rolled out,
    //
    const customizationStore = 'network';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9qH0V.GlobalSideNavigation), {
        app: "jira",
        appLabel: "Jira",
        customizationStore: customizationStore,
        disableMenuCustomization: true,
        forYou: $e562b357b36e3c21$var$EMPTY_CONFIG_OBJ,
        items: $e562b357b36e3c21$var$EMPTY_CONFIG_OBJ,
        networkStorageParams: networkStorageParams,
        postMainElem: postMainElement,
        testId: (0, $9a699b3f60b99670$export$d8c1419f135e1023),
        bottomElem: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $28RaS.Nav4JiraSideNavRecommendation), null)
    });
}
$e562b357b36e3c21$export$e6690b6a9934123e.displayName = "GSNForOtherSidebarsInner";

});
parcelRegister("6bcQF", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e0ef41eb559a361$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc7d26ae9fd640cb6e3a23b872a0832b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7e0ef41eb559a361$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
    }, v1 = [
        {
            "kind": "FragmentSpread",
            "name": "useNavSettingsService"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "fetchGlobalShortcutsAvailableProducts"
            },
            {
                "kind": "RootArgument",
                "name": "navPlatMenuDataEntityAri"
            },
            {
                "kind": "RootArgument",
                "name": "navPlatSidebarDataEntityAri"
            },
            {
                "kind": "RootArgument",
                "name": "ownerAri"
            }
        ],
        "kind": "Fragment",
        "name": "GSNForOtherSidebars",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "useNetworkSideNavUserData"
            },
            {
                "condition": "fetchGlobalShortcutsAvailableProducts",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "useGlobalShortcutsDataRelay"
                    }
                ]
            },
            {
                "alias": "navPlatL1MenuData",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "entityAri",
                        "variableName": "navPlatMenuDataEntityAri"
                    },
                    v0 /*: any*/ 
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": v1 /*: any*/ 
            },
            {
                "alias": "navPlatSidebarData",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "entityAri",
                        "variableName": "navPlatSidebarDataEntityAri"
                    },
                    v0 /*: any*/ 
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": v1 /*: any*/ 
            }
        ],
        "type": "Query"
    };
}();
$7e0ef41eb559a361$var$node.hash = "7b137a8654d440c1fd432204d4c9fbc5";
var $7e0ef41eb559a361$export$2e2bcd8739ae039 = $7e0ef41eb559a361$var$node;

});

parcelRegister("bZIAK", function(module, exports) {
$parcel$export(module.exports, "useIsNonRedirectRoute", () => $67b6f4cb0545f71a$export$7ea19f35e3a0b199);
$parcel$export(module.exports, "SidebarSelector", () => $67b6f4cb0545f71a$export$7937e2d32a777fcb);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $dJ2RR = parcelRequire("dJ2RR");

var $cn1qc = parcelRequire("cn1qc");














var $bfBRs = parcelRequire("bfBRs");

var $aoPm1 = parcelRequire("aoPm1");

var $6HvWM = parcelRequire("6HvWM");




var $hmQJh = parcelRequire("hmQJh");

var $gVkjO = parcelRequire("gVkjO");

var $36eko = parcelRequire("36eko");

var $eBmB7 = parcelRequire("eBmB7");

var $gKzwi = parcelRequire("gKzwi");

var $f5Y0v = parcelRequire("f5Y0v");

var $a2U5J = parcelRequire("a2U5J");

var $1aqMC = parcelRequire("1aqMC");

var $c1XB1 = parcelRequire("c1XB1");

var $hAefF = parcelRequire("hAefF");

var $bkrFd = parcelRequire("bkrFd");

var $cZS7p = parcelRequire("cZS7p");

var $6wqxj = parcelRequire("6wqxj");

var $8fBio = parcelRequire("8fBio");

var $ln7fJ = parcelRequire("ln7fJ");

var $9q6Mu = parcelRequire("9q6Mu");

var $leSe6 = parcelRequire("leSe6");

var $98b9S = parcelRequire("98b9S");

var $aa4B4 = parcelRequire("aa4B4");

var $jyKR4 = parcelRequire("jyKR4");

var $4TntV = parcelRequire("4TntV");

var $7p0B1 = parcelRequire("7p0B1");

var $b8w1S = parcelRequire("b8w1S");

var $aguDt = parcelRequire("aguDt");

var $gX1HT = parcelRequire("gX1HT");

var $7hxOw = parcelRequire("7hxOw");

var $31V0r = parcelRequire("31V0r");

var $bz2be = parcelRequire("bz2be");

var $2b39L = parcelRequire("2b39L");

var $hBxGd = parcelRequire("hBxGd");

var $aZMdt = parcelRequire("aZMdt");

var $f2wVS = parcelRequire("f2wVS");

var $f2wVS = parcelRequire("f2wVS");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");
const $67b6f4cb0545f71a$var$entitySettingsSidebarAnalyticsAttributes = {
    navigationLayer: (0, $fad9173ee481d7de$export$33d8c916a600c5e9)
};
const $67b6f4cb0545f71a$var$ProjectSettingsSidebarSelector = ()=>{
    const { data: project, loading: loading, error: error } = (0, $2b39L.useProjectContext)();
    let sidebar = null;
    if (loading) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4TntV.Skeleton), null);
    if (error) throw error;
    if (project?.projectType === (0, $f99M0.CORE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jyKR4.default), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aa4B4.default), {
        project: project
    });
    if (project?.projectType === (0, $f99M0.SOFTWARE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bz2be.default), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $31V0r.default), {
        project: project
    });
    if (project?.projectType === (0, $f99M0.PRODUCT_DISCOVERY_PROJECT)) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b8w1S.AsyncProjectSettingsSidebar), {
        project: project
    });
    if (project?.projectType === (0, $f99M0.CUSTOMER_SERVICE_PROJECT)) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7hxOw.AsyncJcsProjectSettingsSidebar), {
        project: project
    });
    if (project?.projectType === (0, $f99M0.SERVICE_DESK_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gX1HT.AsyncJsmTmpProjectSettingsSidebar), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aguDt.AsyncJsmCmpProjectSettingsSidebar), {
        project: project
    });
    if (!sidebar) throw new Error(`No project settings sidebar found for the project type: ${project?.projectType}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        containerId: project ? String(project.projectId) : undefined,
        containerType: "project",
        attributes: $67b6f4cb0545f71a$var$entitySettingsSidebarAnalyticsAttributes
    }, sidebar);
};
$67b6f4cb0545f71a$var$ProjectSettingsSidebarSelector.displayName = "ProjectSettingsSidebarSelector";
// The Agents Home route (SidebarIdSpaceAgents) is shared by admins and non-admins. Admins should
// see the full project Space Settings sidebar (which includes the gated "Agents" item), while
// non-admin members — who never see the Space Settings menu — get the standalone Agents sidebar.
const $67b6f4cb0545f71a$var$SpaceAgentsSidebarSelector = ()=>{
    const { data: project, loading: loading } = (0, $2b39L.useProjectContext)();
    const isRovoAiEnabled = (0, $hBxGd.useIsRovoAiEnabledForJiraProduct)('JIRA');
    // Gate: when the experiment is off or Rovo is not entitled, hold on the neutral placeholder.
    // The route itself already resolves to notFoundPageEntrypoint when the experiment is off, so
    // this is a safety net for direct deep-links / cached route state and for tenants without Rovo.
    if (!isRovoAiEnabled || !(0, $2700E.expVal)('yamato-agents-home-space-settings-beta', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4TntV.Skeleton), null);
    if (loading || !project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4TntV.Skeleton), null);
    // The non-admin AsyncSpaceAgentsSidebar carries its own SidebarBoundary. The admin path renders
    // ProjectSettingsSidebarSelector, which can throw (e.g. project-context error, or a project type
    // with no matching settings sidebar). Wrap it so a failure degrades to the sidebar fallback
    // instead of unmounting the whole nav on this shared Agents Home route.
    if (project.isProjectAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "space-agents.admin-settings-sidebar",
        packageName: "jiraNavigationAppsSidebarNav4SidebarSelector",
        ufoName: "space-agents.admin-settings-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($67b6f4cb0545f71a$var$ProjectSettingsSidebarSelector, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ln7fJ.default), null);
};
$67b6f4cb0545f71a$var$SpaceAgentsSidebarSelector.displayName = "SpaceAgentsSidebarSelector";
const $67b6f4cb0545f71a$var$ConnectAppSidebarSelector = ()=>{
    const { isActive: isProjectSettingsConnectAppActive } = (0, $7p0B1.useIsConnectAppActive)();
    return isProjectSettingsConnectAppActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($67b6f4cb0545f71a$var$ProjectSettingsSidebarSelector, null) : null;
};
$67b6f4cb0545f71a$var$ConnectAppSidebarSelector.displayName = "ConnectAppSidebarSelector";
const $67b6f4cb0545f71a$var$BoardSettingsSidebar = ()=>{
    const { data: project, loading: loading, error: error } = (0, $2b39L.useProjectContext)();
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gKzwi.Skeleton), null);
    if (error) throw error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        containerId: project ? String(project.projectId) : undefined,
        containerType: "project",
        attributes: $67b6f4cb0545f71a$var$entitySettingsSidebarAnalyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eBmB7.default), null));
};
$67b6f4cb0545f71a$var$BoardSettingsSidebar.displayName = "BoardSettingsSidebar";
const $67b6f4cb0545f71a$var$REDIRECT_ROUTES_NAMES = new Set([
    'browse-project-redirect',
    'servicedesk-redirect'
]);
const $67b6f4cb0545f71a$var$getSidebarForRoute = (state, { configParam: configParam, shouldUseJSM: shouldUseJSM, isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive, isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive, isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive })=>{
    const sidebarId = state.route.navigation?.sidebarId;
    const pathname = state.location.pathname;
    /**
	 * HEAR YE! HEAR YE!
	 *
	 * When making changes to this file, you MUST make corresponding changes to
	 * src/packages/navigation-apps/sidebar-nav4-sidebar-selector/src/common/logic.tsx
	 *
	 * The logic.tsx is used in two circumstances:
	 *  - for entrypoint routes in Nav4
	 *  - for the new global side navigation (GSN) component, which will (somewhat) replace sidebar-nav4
	 *
	 * In 2024, while building Nav4, we tried to replace this file entirely with the logic.tsx file.
	 * However, there were some differences in the logic, and the change was rolled back. We never
	 * got around to deprecating this file in favour of logic.tsx.
	 *
	 * GSN will force the deprecation of this file by exclusively using logic.tsx.
	 */ const isChatOpsPath = pathname.includes('/jira-service-management-chatops-and-video-tools');
    const hasChatOpsTenantAccess = shouldUseJSM;
    switch(sidebarId){
        case 0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7:
            if ((0, $i860n.fg)('csm_appification_standalone_navigation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8fBio.default), null);
            break;
        case 0, $0dab87234c301ee0$export$e52a1c4dceb4b708:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $98b9S.default), null);
        case 0, $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0:
            if (!pathname.includes('/discover')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a2U5J.default), null);
            break;
        case 0, $3be6781b85030612$export$e3e768cbcc0eeacd:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hAefF.default), null);
        case 0, $bffa4babd84e5355$export$f298f3c8b46adbeb:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1aqMC.default), null);
        case 0, $92d0e44258fe76a3$export$e8aa2912a0792727:
            if (isChatOpsPath && hasChatOpsTenantAccess) break;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c1XB1.SidebarContentWithRelayResource), null);
        case 0, $1b7637cabf39cd90$export$e03d9e7e646baacb:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6wqxj.default), null);
        case 0, $f5c10d229cf55438$export$8f20a381b96458f0:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $leSe6.default), null);
        case 0, $5ebee7b47d85aaa2$export$d816833364c45b3f:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9q6Mu.default), null);
        case 0, $326b5a4f81d4f584$export$b257d790d85197b2:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dJ2RR.default), null);
        case 0, $28266b9d90f7c617$export$624732ab55954dd9:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($67b6f4cb0545f71a$var$ProjectSettingsSidebarSelector, null);
        case 0, $d579872b9d7d689d$export$983f2e89073dd86:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($67b6f4cb0545f71a$var$SpaceAgentsSidebarSelector, null);
        case 0, $69db4b0f28295983$export$e0323f266e5e0bb8:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bkrFd.default), null);
        default:
            break;
    }
    if (state.route.name === 'polaris-ideas' && state.match.params.section === 'settings') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($67b6f4cb0545f71a$var$ProjectSettingsSidebarSelector, null);
    if (state.route.name === 'your-work') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $36eko.SidebarContent), null);
    if (isProjectSettingsConnectAppActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($67b6f4cb0545f71a$var$ConnectAppSidebarSelector, null);
    if (state.route.group === 'classic-software' && (0, $bfBRs.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(configParam)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($67b6f4cb0545f71a$var$BoardSettingsSidebar, null);
    if (isGlobalAppsSettingsConnectItemActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a2U5J.default), null);
    if (isGlobalSystemSettingsConnectItemActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6wqxj.default), null);
};
const $67b6f4cb0545f71a$export$ac727539f28734c4 = (state)=>{
    return !$67b6f4cb0545f71a$var$REDIRECT_ROUTES_NAMES.has(state.route.name);
};
const $67b6f4cb0545f71a$export$7ea19f35e3a0b199 = (0, $f2wVS.createRouterSelector)($67b6f4cb0545f71a$export$ac727539f28734c4);
const $67b6f4cb0545f71a$export$b1253b9403840da1 = ()=>{
    const { saveCurrentRoute: saveCurrentRoute } = (0, $hmQJh.useNavigateBack)();
    const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, $f5Y0v.useGlobalAppsSettingsConnectItemActive)();
    const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, $cZS7p.useGlobalSystemSettingsConnectItemActive)();
    const { isActive: isProjectSettingsConnectAppActive } = (0, $7p0B1.useIsConnectAppActive)();
    const { shouldUseJSM: shouldUseJSM } = (0, $6HvWM.useOgTenantInfo)();
    const isNonRedirectRoute = $67b6f4cb0545f71a$export$7ea19f35e3a0b199();
    const configParam = (0, $aoPm1.useMaybeConfigParam)() || '';
    const location = (0, $cn1qc.useLocation)();
    const [sidebar, setSidebar] = (0, $euxye.useState)($67b6f4cb0545f71a$var$getSidebarForRoute((0, $f2wVS.getRouterState)(), {
        configParam: configParam,
        shouldUseJSM: shouldUseJSM,
        isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive,
        isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive,
        isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive
    }));
    (0, $euxye.useEffect)(()=>{
        return (0, $f2wVS.addRouteListener)((state)=>{
            setSidebar($67b6f4cb0545f71a$var$getSidebarForRoute(state, {
                configParam: state.query.config || state.match.params.config || '',
                isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive,
                isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive,
                isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive,
                shouldUseJSM: shouldUseJSM
            }));
        });
    }, [
        isGlobalAppsSettingsConnectItemActive,
        isGlobalSystemSettingsConnectItemActive,
        isProjectSettingsConnectAppActive,
        shouldUseJSM
    ]);
    (0, $euxye.useEffect)(()=>{
        // NOTE: We need to AVOID saving the route if we're on a connect app...
        if (!sidebar && isNonRedirectRoute && !isProjectSettingsConnectAppActive) {
            const url = `${location.pathname}${location.search}${location.hash}`;
            saveCurrentRoute(url);
        }
        if (!sidebar && isProjectSettingsConnectAppActive) setSidebar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($67b6f4cb0545f71a$var$ConnectAppSidebarSelector, null));
    }, [
        isNonRedirectRoute,
        isProjectSettingsConnectAppActive,
        location,
        saveCurrentRoute,
        sidebar
    ]);
    if (sidebar) return sidebar;
    // Main nav (with "Your work", Starred, Recent items etc.)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $36eko.SidebarContent), null);
};
$67b6f4cb0545f71a$export$b1253b9403840da1.displayName = "InternalSidebarSelector";
const $67b6f4cb0545f71a$export$7937e2d32a777fcb = ()=>{
    const attributes = (0, $euxye.useMemo)(()=>({
            navigationLayer: (0, $fad9173ee481d7de$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $192a2eeaa0a1dbf6$export$2ee9e5a3556c1e43),
            navState: (0, $3b258ee19859baa5$export$2bd315ece9f68967)
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hmQJh.NavigateBackProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($67b6f4cb0545f71a$export$b1253b9403840da1, null)));
};
$67b6f4cb0545f71a$export$7937e2d32a777fcb.displayName = "SidebarSelector";

});
parcelRegister("dJ2RR", function(module, exports) {
$parcel$export(module.exports, "default", () => $510c1c1ceb98d4ec$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $f2wVS = parcelRequire("f2wVS");

var $4lDTu = parcelRequire("4lDTu");

/**
 * Lazy sidebar components per practice.
 * Each practice gets its own webpack chunk for code-splitting.
 * When SAM/CAM are ready, add their lazy sidebar here.
 */ const $510c1c1ceb98d4ec$var$LazyHamSidebar = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("6G6aE")), {
    moduleId: "./src/packages/itam/ham-settings/src/HamSettingsSideNavMain.tsx"
});
// const LazySamSidebar = lazyForPaint(() => import(...));
// const LazyCamSidebar = lazyForPaint(() => import(...));
/**
 * Practice-to-sidebar mapping.
 * Defaults to HAM when the practice param is missing or unrecognised.
 */ const $510c1c1ceb98d4ec$var$PRACTICE_SIDEBARS = {
    ham: $510c1c1ceb98d4ec$var$LazyHamSidebar
};
const $510c1c1ceb98d4ec$var$DEFAULT_SIDEBAR = $510c1c1ceb98d4ec$var$LazyHamSidebar;
const $510c1c1ceb98d4ec$var$useRouteParams = (0, $f2wVS.createRouterSelector)(({ match: match })=>match.params);
const $510c1c1ceb98d4ec$var$SidebarRouter = ()=>{
    const params = $510c1c1ceb98d4ec$var$useRouteParams();
    const practice = params?.practice || '';
    const SidebarContent = $510c1c1ceb98d4ec$var$PRACTICE_SIDEBARS[practice] ?? $510c1c1ceb98d4ec$var$DEFAULT_SIDEBAR;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(SidebarContent, null);
};
$510c1c1ceb98d4ec$var$SidebarRouter.displayName = "SidebarRouter";
const $510c1c1ceb98d4ec$var$asyncItamSettingsSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.itam-settings",
        packageName: "jiraNavigationAppsSidebarNav4ItamSettings",
        ufoName: "nav4.sidebar.itam-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.itam-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4lDTu.ItamSettingsSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($510c1c1ceb98d4ec$var$SidebarRouter, null)));
const $510c1c1ceb98d4ec$var$AsyncItamSettingsSidebar = /*#__PURE__*/ (0, $euxye.memo)($510c1c1ceb98d4ec$var$asyncItamSettingsSidebar);
var // eslint-disable-next-line jira/filename-case
$510c1c1ceb98d4ec$export$2e2bcd8739ae039 = $510c1c1ceb98d4ec$var$AsyncItamSettingsSidebar;

});
parcelRegister("gVkjO", function(module, exports) {
$parcel$export(module.exports, "SidebarBoundary", () => $92033b3f00f1afee$export$1edc778464f08256);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $868gB = parcelRequire("868gB");

var $cUnrZ = parcelRequire("cUnrZ");

var $41zzZ = parcelRequire("41zzZ");

var $gDdYI = parcelRequire("gDdYI");

var $7ehYC = parcelRequire("7ehYC");

var $7uGDP = parcelRequire("7uGDP");
const $92033b3f00f1afee$export$1edc778464f08256 = ({ children: children, id: id, packageName: packageName, teamName: teamName, ufoName: ufoName = '' })=>{
    const { experience: experience, attributes: attributes } = (0, $7ehYC.useSidebarExperience)();
    const onFail = (0, $cUnrZ.useExperienceFail)({
        experience: experience,
        attributes: attributes
    });
    const onAbort = (0, $868gB.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
    const userLocation = (0, $41zzZ.getUserLocation)();
    const isNotSSR = !false;
    const extraEventData = (0, $euxye.useMemo)(()=>({
            userLocation: userLocation
        }), [
        userLocation
    ]);
    const fallback = (0, $euxye.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7uGDP.Fallback), {
            error: error
        }), []);
    const handleError = (0, $euxye.useCallback)(// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    (location, error)=>{
        const { statusCode: statusCode } = error;
        if (statusCode >= 400 && statusCode < 500) onAbort('Sidebar failed with validation error', {
            error: error
        });
        else onFail(location, error);
    }, [
        onAbort,
        onFail
    ]);
    const UFOSegmentORFragment = ufoName ? (0, $gDdYI.default) : (0, $euxye.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(UFOSegmentORFragment, {
        name: ufoName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        extraEventData: extraEventData,
        fallback: fallback,
        teamName: teamName,
        onError: handleError
    }, isNotSSR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7ehYC.SidebarStart), null), children));
};
$92033b3f00f1afee$export$1edc778464f08256.displayName = "SidebarBoundary";

});
parcelRegister("868gB", function(module, exports) {
$parcel$export(module.exports, "useExperienceAbort", () => $875ac4dcc884f25e$export$cc92b7ce453f4403);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $6bEm8 = parcelRequire("6bEm8");

var $a5nxD = parcelRequire("a5nxD");

var $UlW5d = parcelRequire("UlW5d");
const $875ac4dcc884f25e$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $UlW5d.useExperienceContext)();
    const self = (0, $euxye.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $euxye.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        let shardAndRegionAttributes = {};
        shardAndRegionAttributes = {
            shard: (0, $6bEm8.default)('ajs-shard'),
            region: (0, $6bEm8.default)('ajs-region')
        };
        const holdoutAttributes = {
            customHoldout: (0, $a5nxD.getIsInJiraHoldoutData)().holdout
        };
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes,
                ...holdoutAttributes
            }
        });
    }, // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        self
    ]);
};

});

parcelRegister("cUnrZ", function(module, exports) {
$parcel$export(module.exports, "useExperienceFail", () => $85e9bbc4c2fc8179$export$606da7704d8eaf06);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $6bEm8 = parcelRequire("6bEm8");

var $lCetP = parcelRequire("lCetP");

var $8dImz = parcelRequire("8dImz");

var $a5nxD = parcelRequire("a5nxD");

var $UlW5d = parcelRequire("UlW5d");
const $85e9bbc4c2fc8179$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $UlW5d.useExperienceContext)();
    const self = (0, $euxye.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $euxye.useCallback)((location, error, extraAttributes = {})=>{
        const { current: current } = self;
        // ignore client side errors from impacting experience metrics
        if ((0, $8dImz.isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, $lCetP.isClientFetchError)(error)) return;
        const shardAndRegionAttributes = {
            shard: (0, $6bEm8.default)('ajs-shard'),
            region: (0, $6bEm8.default)('ajs-region')
        };
        const holdoutAttributes = {
            customHoldout: (0, $a5nxD.getIsInJiraHoldoutData)().holdout
        };
        current.experienceTracker.fail({
            name: current.name,
            error: error,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes,
                ...holdoutAttributes,
                location: location
            }
        });
    }, // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        self
    ]);
};

});

parcelRegister("7ehYC", function(module, exports) {
$parcel$export(module.exports, "useSidebarExperience", () => $bafa0d4d9f99c907$export$d4fa533dfe4d7583);
$parcel$export(module.exports, "SidebarStart", () => $bafa0d4d9f99c907$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarReady", () => $bafa0d4d9f99c907$export$a06ecbbe5820282);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $dtDO2 = parcelRequire("dtDO2");

var $lTQTl = parcelRequire("lTQTl");

var $4Onaa = parcelRequire("4Onaa");

var $60MZW = parcelRequire("60MZW");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $2yVPv = parcelRequire("2yVPv");

var $hYI7R = parcelRequire("hYI7R");
const $bafa0d4d9f99c907$export$d4fa533dfe4d7583 = ()=>{
    const pageId = (0, $2yVPv.usePageId)();
    return (0, $euxye.useMemo)(()=>({
            experience: 'viewSidebarNavigation',
            experienceId: pageId,
            analyticsSource: 'Sidebar',
            attributes: {
                sidebar: 'v4'
            }
        }), [
        pageId
    ]);
};
const $bafa0d4d9f99c907$export$6738d1299dc79710 = ()=>{
    const route = (0, $4Onaa.useCurrentRoute)();
    const { experience: experience, experienceId: experienceId, analyticsSource: analyticsSource } = $bafa0d4d9f99c907$export$d4fa533dfe4d7583();
    const onStartExperience = (0, $dtDO2.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource
    });
    (0, $euxye.useEffect)(()=>{
        if (route.isRedirect) return;
        onStartExperience();
    }, [
        onStartExperience,
        route
    ]);
    return null;
};
$bafa0d4d9f99c907$export$6738d1299dc79710.displayName = "SidebarStart";
const $bafa0d4d9f99c907$export$a06ecbbe5820282 = ()=>{
    const route = (0, $4Onaa.useCurrentRoute)();
    const { experience: experience, attributes: attributes } = $bafa0d4d9f99c907$export$d4fa533dfe4d7583();
    const onSuccessfulExperience = (0, $lTQTl.useExperienceSuccess)({
        experience: experience,
        attributes: attributes
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const doNotRunEffects = route.isRedirect || false;
    const sidebarId = route.navigation?.sidebarId ?? 'default';
    (0, $hYI7R.useEffectWithoutConcurrency)(()=>{
        if (doNotRunEffects) return;
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $aJ81Y.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        doNotRunEffects,
        routeName
    ]);
    (0, $hYI7R.useEffectWithoutConcurrency)(()=>{
        if (doNotRunEffects) return;
        onSuccessfulExperience();
    }, [
        doNotRunEffects,
        onSuccessfulExperience,
        route
    ]);
    const customData = (0, $euxye.useMemo)(()=>({
            sidebarType: sidebarId
        }), [
        sidebarId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $60MZW.default), {
        data: customData
    });
};
$bafa0d4d9f99c907$export$a06ecbbe5820282.displayName = "SidebarReady";

});
parcelRegister("hYI7R", function(module, exports) {
$parcel$export(module.exports, "useEffectWithoutConcurrency", () => $8e1c17f889077a08$export$e44126cd87ea434);

var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");

var $jiTLE = parcelRequire("jiTLE");
function $8e1c17f889077a08$export$e44126cd87ea434(effect, dependencies) {
    const effectCalledRef = (0, $euxye.useRef)(false);
    const depsRef = (0, $euxye.useRef)(dependencies);
    (0, $euxye.useEffect)(()=>{
        // If the dependencies have changed, reset the state of the ref.
        // This is how we catch the strict-mode execution.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(depsRef.current, dependencies)) {
            depsRef.current = dependencies;
            effectCalledRef.current = false;
        }
        // If the effect has already executed, we shouldn't be executing again unless we do a cleanup first.
        // This is the code that ignores the strict-mode update
        if (effectCalledRef.current) return;
        // Set this immediately
        effectCalledRef.current = true;
        const cleanup = effect();
        // If we do get a cleanup function, throw an error
        (0, $jiTLE.default)(typeof cleanup !== 'function', 'useEffectWithoutConcurrency() cannot be used with cleanup functions');
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

});


parcelRegister("7uGDP", function(module, exports) {
$parcel$export(module.exports, "Fallback", () => $dffddeee08bbad9e$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $eXdAp = parcelRequire("eXdAp");

var $42csL = parcelRequire("42csL");

var $2iotI = parcelRequire("2iotI");

var $ihEDU = parcelRequire("ihEDU");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $dffddeee08bbad9e$var$errorHeading = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-heading",
    defaultMessage: "Something went wrong"
});
const $dffddeee08bbad9e$var$errorBody = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-body",
    defaultMessage: "Try refreshing or navigating to another page."
});
const $dffddeee08bbad9e$var$errorHashDetails = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-hash-details",
    defaultMessage: "ERROR: {errorHash}"
});
const $dffddeee08bbad9e$var$styles = {
    wrapper: "_zulpu2gc _bfhki8nm _syazazsu _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o",
    error: "_2rkolb4i _bfhk7qp0 _syaz1rpy _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66"
};
const $dffddeee08bbad9e$export$fb8d7f40caaeea67 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        xcss: $dffddeee08bbad9e$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $42csL.default), {
        width: "40px",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "xsmall"
    }, formatMessage($dffddeee08bbad9e$var$errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($dffddeee08bbad9e$var$errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $dffddeee08bbad9e$var$styles.error
    }, formatMessage($dffddeee08bbad9e$var$errorHashDetails, {
        errorHash: (0, $eXdAp.getErrorHash)(error)
    })));
};
$dffddeee08bbad9e$export$fb8d7f40caaeea67.displayName = "Fallback";

});
parcelRegister("42csL", function(module, exports) {
$parcel$export(module.exports, "default", () => $9627fb77508a82c8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("8rj41")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3I5X8")))));
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = jx8k5z4r4cbqfnn3t56t46v9
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/jx8k5z4r4cbqfnn3t56t46v9

var $gboXr = parcelRequire("gboXr");

var $3I5X8 = parcelRequire("3I5X8");

var $8rj41 = parcelRequire("8rj41");
const $9627fb77508a82c8$var$Illustration = (0, $gboXr.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8rj41)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3I5X8))
});
var $9627fb77508a82c8$export$2e2bcd8739ae039 = $9627fb77508a82c8$var$Illustration;
// for advanced use only
const $9627fb77508a82c8$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("gboXr", function(module, exports) {
$parcel$export(module.exports, "Illustration", () => $fb47eccb8a624dcd$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $fb47eccb8a624dcd$export$4d00e7be716a0093);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $2Puum = parcelRequire("2Puum");
function $fb47eccb8a624dcd$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2Puum.AsImg), props);
}
$fb47eccb8a624dcd$export$d43c2e2ca9b2c105.displayName = "Illustration";
function $fb47eccb8a624dcd$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fb47eccb8a624dcd$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("2Puum", function(module, exports) {
$parcel$export(module.exports, "AsImg", () => $5b9c62be954f5950$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/naming/disallow-filenames */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $4C7HL = parcelRequire("4C7HL");
// Moved to src/packages/illustrations/illustration/src/ui/types.tsx to avoid circular dependency
// export interface AsImgProps extends IllustrationProps, ImgHTMLAttributes<HTMLImageElement>
// suggested defaults, the consumer is free to override
const $5b9c62be954f5950$var$defaultStyles = null;
const $5b9c62be954f5950$var$fillStyles = null;
const $5b9c62be954f5950$var$autoDarkModeStyles = null;
function $5b9c62be954f5950$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $4C7HL.default)();
    return /*#__PURE__*/ $euxye.createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $4jQY2.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_1r04idpf _kqswstnw _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}
$5b9c62be954f5950$export$75e378065cb7d6c0.displayName = "AsImg";

});


parcelRegister("3I5X8", function(module, exports) {
module.exports = new URL("generic-error-darkmode.3646797f.svg", import.meta.url).toString();

});

parcelRegister("8rj41", function(module, exports) {
module.exports = new URL("generic-error.f200ded6.svg", import.meta.url).toString();

});




parcelRegister("4lDTu", function(module, exports) {
$parcel$export(module.exports, "ItamSettingsSkeleton", () => $8d96c1c487e1cd02$export$36db9ad6303f05d3);
/* ItamSettingsSkeleton.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $2XXtG = parcelRequire("2XXtG");

var $3PC9r = parcelRequire("3PC9r");
const $8d96c1c487e1cd02$var$styles = {
    container: "_ca0qpxbi _n3tdpxbi _19bvpxbi _u5f3pxbi",
    backButton: "_2rko12b0 _bfhkizff _1bsb7vkz _4t3i7vkz",
    heading: "_2rko12b0 _bfhkizff _1bsb68cl _4t3i7vkz",
    icon: "_2rko12b0 _bfhkizff _1bsb1tcg _4t3i1tcg",
    menuItemText: "_2rko12b0 _bfhkizff _4t3i7vkz _1bsb1osq",
    menuItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
};
const $8d96c1c487e1cd02$var$MenuItemSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $8d96c1c487e1cd02$var$styles.icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $8d96c1c487e1cd02$var$styles.menuItemTextWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $8d96c1c487e1cd02$var$styles.menuItemText
    })));
$8d96c1c487e1cd02$var$MenuItemSkeleton.displayName = "MenuItemSkeleton";
const $8d96c1c487e1cd02$export$36db9ad6303f05d3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        space: "space.300",
        xcss: $8d96c1c487e1cd02$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $8d96c1c487e1cd02$var$styles.backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $8d96c1c487e1cd02$var$styles.heading
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d96c1c487e1cd02$var$MenuItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d96c1c487e1cd02$var$MenuItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d96c1c487e1cd02$var$MenuItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d96c1c487e1cd02$var$MenuItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d96c1c487e1cd02$var$MenuItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d96c1c487e1cd02$var$MenuItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d96c1c487e1cd02$var$MenuItemSkeleton, null)));
$8d96c1c487e1cd02$export$36db9ad6303f05d3.displayName = "ItamSettingsSkeleton";

});

parcelRegister("6G6aE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7VzJ6").then(()=>parcelRequire('1swrl'));

});


const $bffa4babd84e5355$export$f298f3c8b46adbeb = 'GLOBAL_ISSUES_SETTINGS';

const $3be6781b85030612$export$e3e768cbcc0eeacd = 'GLOBAL_PROJECTS_SETTINGS';

const $5ebee7b47d85aaa2$export$d816833364c45b3f = 'HELP_CENTER_SETTINGS';

const $326b5a4f81d4f584$export$b257d790d85197b2 = 'ITAM_SETTINGS';

const $f5c10d229cf55438$export$8f20a381b96458f0 = 'PERSONAL_SETTINGS';

const $0dab87234c301ee0$export$e52a1c4dceb4b708 = 'PLAN_SETTINGS';

const $d579872b9d7d689d$export$983f2e89073dd86 = 'SPACE_AGENTS';

const $69db4b0f28295983$export$e0323f266e5e0bb8 = 'OPERATIONS_GENERAL_CONFIGURATION';

/* eslint-disable jira/filename-case */ const $3b258ee19859baa5$export$d2aa6c54a5925f01 = 'v3';
const $3b258ee19859baa5$export$2bd315ece9f68967 = 'v4';

/* eslint-disable jira/filename-case */ const $192a2eeaa0a1dbf6$export$2ee9e5a3556c1e43 = 'sidebar';
const $192a2eeaa0a1dbf6$export$793ed84f5e13fedc = 'top';
const $192a2eeaa0a1dbf6$export$f1c9dd0f5207dd5e = 'tab';
const $192a2eeaa0a1dbf6$export$b83d0ee9325a2d0a = 'projectTitle';

/* eslint-disable jira/filename-case */ // TopNav or sidebar
const $fad9173ee481d7de$export$17ff3f7e02c6ac22 = 'global';
const $fad9173ee481d7de$export$33d8c916a600c5e9 = 'container';

parcelRegister("36eko", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "SidebarContent", () => $440e9330191572af$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "SidebarContentInnerAnonymous", () => $440e9330191572af$export$57e04c8c2365ae3b);
$parcel$export(module.exports, "SidebarContentInner", () => $440e9330191572af$export$a18798f247d81ed3);
$parcel$export(module.exports, "SidebarContentForEntryPoint", () => $440e9330191572af$export$ece6bd06aa8b2350);
$parcel$export(module.exports, "default", () => $440e9330191572af$export$2e2bcd8739ae039);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $3tHVQ = parcelRequire("3tHVQ");

var $6GljB = parcelRequire("6GljB");

var $7ehYC = parcelRequire("7ehYC");

var $dx7aH = parcelRequire("dx7aH");

var $htsFl = parcelRequire("htsFl");

var $djYhH = parcelRequire("djYhH");

var $e6rNk = parcelRequire("e6rNk");

var $kYJqR = parcelRequire("kYJqR");

var $a8EUd = parcelRequire("a8EUd");

var $cvA2R = parcelRequire("cvA2R");

var $gDdYI = parcelRequire("gDdYI");

var $bc9Gj = parcelRequire("bc9Gj");

var $a5nxD = parcelRequire("a5nxD");

var $hvbkB = parcelRequire("hvbkB");

var $gX64i = parcelRequire("gX64i");
const $440e9330191572af$export$49e8f7b58a4df4ea = ()=>{
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    const { queryReference: queryReference } = (0, $htsFl.useRelayResource)((0, $3tHVQ.sidebarNav4Resource));
    const queryReferenceRef = (0, $euxye.useRef)(null);
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($440e9330191572af$export$57e04c8c2365ae3b, null);
    // We don't want to use null query references. So only remember the non-null ones,
    // and pass the non-null query reference to the children.
    // From Slack: https://atlassian.slack.com/archives/C01E2MPPLE4/p1654736794416059?thread_ts=1654051102.548519&cid=C01E2MPPLE4
    if (queryReference) queryReferenceRef.current = queryReference;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($440e9330191572af$export$a18798f247d81ed3, {
        queryReference: queryReferenceRef.current
    });
};
$440e9330191572af$export$49e8f7b58a4df4ea.displayName = "SidebarContent";
function $440e9330191572af$export$ece6bd06aa8b2350(t0) {
    const $ = (0, $e7boj.c)(3);
    const { queries: t1 } = t0;
    const { nav4SidebarContentCore: nav4SidebarContentCore } = t1;
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    if (isAnonymous) {
        let t2;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($440e9330191572af$export$57e04c8c2365ae3b, null);
            $[0] = t2;
        } else t2 = $[0];
        return t2;
    }
    let t2;
    if ($[1] !== nav4SidebarContentCore) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($440e9330191572af$export$a18798f247d81ed3, {
            queryReference: nav4SidebarContentCore
        });
        $[1] = nav4SidebarContentCore;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
}
$440e9330191572af$export$ece6bd06aa8b2350.displayName = "SidebarContentForEntryPoint";
function $440e9330191572af$export$a18798f247d81ed3(t0) {
    const $ = (0, $e7boj.c)(8);
    const { queryReference: queryReference } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a5nxD.JiraHoldoutCustomData), null);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== queryReference) {
        t2 = queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gX64i.L1MenuItems), {
            queryReference: queryReference
        });
        $[1] = queryReference;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kYJqR.SideNavBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
            name: "l1-nav-menu-items",
            fallback: null
        }, t2)));
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7ehYC.SidebarReady), null);
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
            name: "nav4-sidebar-content"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            id: "l1-nav-menu-items",
            packageName: (0, $hvbkB.PACKAGE_NAME),
            teamName: (0, $hvbkB.TEAM_NAME)
        }, t3, t4));
        $[6] = t3;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
}
$440e9330191572af$export$a18798f247d81ed3.displayName = "SidebarContentInner";
function $440e9330191572af$export$57e04c8c2365ae3b() {
    const $ = (0, $e7boj.c)(25);
    const { formattedMessage: projectsMessage, icon: projectsIcon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).PROJECTS);
    const { formattedMessage: dashboardsMessage, icon: dashboardsIcon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).DASHBOARDS);
    const { formattedMessage: filtersMessage, icon: filtersIcon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).FILTERS);
    const [t0] = (0, $bc9Gj.useRouter)();
    const { match: match } = t0;
    let t1;
    if ($[0] !== match.path) {
        t1 = match.path.startsWith("/jira/projects");
        $[0] = match.path;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== projectsIcon || $[3] !== projectsMessage || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e6rNk.LinkMenuItem), {
            elemBefore: projectsIcon,
            href: "/jira/projects",
            isSelected: t1
        }, projectsMessage);
        $[2] = projectsIcon;
        $[3] = projectsMessage;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== match.path) {
        t3 = match.path === "/jira/filters" || match.path.startsWith("/issues/");
        $[6] = match.path;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== filtersIcon || $[9] !== filtersMessage || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e6rNk.LinkMenuItem), {
            elemBefore: filtersIcon,
            href: "/jira/filters",
            isSelected: t3
        }, filtersMessage);
        $[8] = filtersIcon;
        $[9] = filtersMessage;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== match.path) {
        t5 = match.path.startsWith("/jira/dashboards");
        $[12] = match.path;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== dashboardsIcon || $[15] !== dashboardsMessage || $[16] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e6rNk.LinkMenuItem), {
            elemBefore: dashboardsIcon,
            href: "/jira/dashboards",
            isSelected: t5
        }, dashboardsMessage);
        $[14] = dashboardsIcon;
        $[15] = dashboardsMessage;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== t2 || $[19] !== t4 || $[20] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kYJqR.SideNavBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
            name: "l1-nav-menu-items",
            fallback: null
        }, t2, t4, t6)));
        $[18] = t2;
        $[19] = t4;
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7ehYC.SidebarReady), null);
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== t7) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            id: "l1-nav-menu-items",
            packageName: (0, $hvbkB.PACKAGE_NAME),
            teamName: (0, $hvbkB.TEAM_NAME)
        }, t7, t8);
        $[23] = t7;
        $[24] = t9;
    } else t9 = $[24];
    return t9;
}
$440e9330191572af$export$57e04c8c2365ae3b.displayName = "SidebarContentInnerAnonymous";
var $440e9330191572af$export$2e2bcd8739ae039 = $440e9330191572af$export$ece6bd06aa8b2350;

});
parcelRegister("hvbkB", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $222e58cd800a4027$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $222e58cd800a4027$export$d57b6b390e78d90f);
$parcel$export(module.exports, "USER_NAVIGATION_CONFIGURATION_DEFAULT", () => $222e58cd800a4027$export$6f21b70acbf71216);
$parcel$export(module.exports, "USER_NAVIGATION_CONFIGURATION_DEFAULT_GOALS_TEAMS_SWITCHED", () => $222e58cd800a4027$export$6c0b16a0c07be58e);
$parcel$export(module.exports, "USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS", () => $222e58cd800a4027$export$c2614ebabc74446e);
$parcel$export(module.exports, "USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS_GOALS_TEAMS_SWITCHED", () => $222e58cd800a4027$export$f8e298c478de92d5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6GljB = parcelRequire("6GljB");
const $222e58cd800a4027$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4SidebarContent';
const $222e58cd800a4027$export$d57b6b390e78d90f = 'jira-cosmos';
const $222e58cd800a4027$export$6f21b70acbf71216 = {
    navKey: 'JIRA_SIDEBAR',
    navItems: [
        {
            menuId: (0, $6GljB.L1_MENU_ID).RECENT,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).STARRED,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).APPS,
            isVisible: true
        },
        // See https://jplat.jira.atlassian.cloud/browse/BLU-3307
        // For the Dogfooding phase of Nav4 we are going to intentionally hide the Goals menu item.
        // Keeping code in comments so it can be easily reintroduced during EAP
        // {
        // 	menuId: L1_MENU_ID.GOALS,
        // 	isVisible: true,
        // },
        {
            menuId: (0, $6GljB.L1_MENU_ID).ROADMAPS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).PLANS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).PROJECTS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).FILTERS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).DASHBOARDS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).OPERATIONS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).ITAM,
            isVisible: true
        },
        {
            /* remove this on
     * assets_as_an_app_v2 cleanup &&
     */ menuId: (0, $6GljB.L1_MENU_ID).ASSETS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).TEAMS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).CUSTOMERS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).HELP_CENTER_MANAGEMENT,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_LOOM,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_OPSGENIE,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_TEAMS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS,
            isVisible: true
        }
    ]
};
const $222e58cd800a4027$export$6c0b16a0c07be58e = {
    navKey: 'JIRA_SIDEBAR',
    navItems: [
        {
            menuId: (0, $6GljB.L1_MENU_ID).RECENT,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).STARRED,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).APPS,
            isVisible: true
        },
        // See https://jplat.jira.atlassian.cloud/browse/BLU-3307
        // For the Dogfooding phase of Nav4 we are going to intentionally hide the Goals menu item.
        // Keeping code in comments so it can be easily reintroduced during EAP
        // {
        // 	menuId: L1_MENU_ID.GOALS,
        // 	isVisible: true,
        // },
        {
            menuId: (0, $6GljB.L1_MENU_ID).ROADMAPS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).PLANS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).PROJECTS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).FILTERS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).DASHBOARDS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).OPERATIONS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).ITAM,
            isVisible: true
        },
        {
            /* remove this on
     * assets_as_an_app_v2 cleanup &&
     */ menuId: (0, $6GljB.L1_MENU_ID).ASSETS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).TEAMS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).CUSTOMERS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).HELP_CENTER_MANAGEMENT,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_LOOM,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_OPSGENIE,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_TEAMS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS,
            isVisible: true
        },
        {
            menuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS,
            isVisible: true
        }
    ]
};
const $222e58cd800a4027$export$c2614ebabc74446e = $222e58cd800a4027$export$6f21b70acbf71216.navItems.map(({ menuId: menuId })=>menuId);
const $222e58cd800a4027$export$f8e298c478de92d5 = $222e58cd800a4027$export$6c0b16a0c07be58e.navItems.map(({ menuId: menuId })=>menuId);

});

parcelRegister("gX64i", function(module, exports) {
$parcel$export(module.exports, "L1MenuItems", () => $2c87efe8416dc6b9$export$a1e3b15bccd7433c);

var $e7boj = parcelRequire("e7boj");

var $7Cxzw = parcelRequire("7Cxzw");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $MY51A = parcelRequire("MY51A");

var $4Elg6 = parcelRequire("4Elg6");
function $2c87efe8416dc6b9$export$a1e3b15bccd7433c(t0) {
    const $ = (0, $e7boj.c)(3);
    const { queryReference: queryReference } = t0;
    const l1MenuData = (0, $n67Vb.usePreloadedQuery)((0, $7Cxzw.default), queryReference);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $MY51A.YourWork), null);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== l1MenuData) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4Elg6.ConfigurableMenuItems), {
            menuData: l1MenuData
        }));
        $[1] = l1MenuData;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
}
$2c87efe8416dc6b9$export$a1e3b15bccd7433c.displayName = "L1MenuItems";

});
parcelRegister("MY51A", function(module, exports) {
$parcel$export(module.exports, "YourWork", () => $a4d85d7be2964a88$export$c7da207c25eb3776);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $bOwox = parcelRequire("bOwox");

var $5IkoH = parcelRequire("5IkoH");

var $aQCoC = parcelRequire("aQCoC");

var $KL7Bq = parcelRequire("KL7Bq");

var $3T5IC = parcelRequire("3T5IC");

var $lxN43 = parcelRequire("lxN43");

var $7eNDO = parcelRequire("7eNDO");
const $a4d85d7be2964a88$var$forYou = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-your-work.your-work.for-you",
    defaultMessage: "For you"
});
const $a4d85d7be2964a88$var$JIRA_HOME_PATH = (0, $3T5IC.jiraHomeRoute).path;
const $a4d85d7be2964a88$var$analytics = {
    actionSubjectId: (0, $bOwox.SECTION_ITEM_YOUR_WORK),
    itemId: 'yourWork',
    level: 1,
    // Note: Your work doesn't seem to be configurable via Customise sidebar - More menu
    isInMore: false
};
const $a4d85d7be2964a88$export$c7da207c25eb3776 = ()=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $KL7Bq.useFormattedMessageAndIcon)($a4d85d7be2964a88$var$forYou, (0, (/*@__PURE__*/$parcel$interopDefault($lxN43))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        analytics: $a4d85d7be2964a88$var$analytics,
        elemBefore: icon,
        href: $a4d85d7be2964a88$var$JIRA_HOME_PATH,
        menuId: (0, $5IkoH.MENU_ID_FOR_YOU)
    }, formattedMessage);
};
$a4d85d7be2964a88$export$c7da207c25eb3776.displayName = "YourWork";

});
parcelRegister("aQCoC", function(module, exports) {
$parcel$export(module.exports, "Nav4MenuLinkItem", () => $13d7b307e35666c1$export$3253d78f1560490f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $1ByIU = parcelRequire("1ByIU");

var $19zz3 = parcelRequire("19zz3");

var $1lRyZ = parcelRequire("1lRyZ");

var $dRtPJ = parcelRequire("dRtPJ");

var $jzXAj = parcelRequire("jzXAj");
/**
 * Nav4MenuLinkItem provides `menuId` instead of `isSelected`,
 * which is used to set the selected-state of the underlying
 * LinkMenuItem, using the useSidebarNav4() context-hook.
 */ const $13d7b307e35666c1$var$Nav4MenuLinkItemForwardRef = /*#__PURE__*/ (0, $euxye.forwardRef)($13d7b307e35666c1$var$Nav4MenuLinkItemContent);
const $13d7b307e35666c1$export$3253d78f1560490f = /*#__PURE__*/ (0, $euxye.memo)($13d7b307e35666c1$var$Nav4MenuLinkItemForwardRef, (0, $1ByIU.isShallowEqual));
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
function $13d7b307e35666c1$var$Nav4MenuLinkItemContent(props, ref) {
    const { menuId: menuId } = props;
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const { isSelectedPath: isSelectedPath } = (0, $19zz3.useSidebarNav4)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const { isControlledPath: isControlledPath } = (0, $1lRyZ.useSidebarNav4Controller)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        ref: ref,
        ...props,
        isSelected: isSelectedPath(menuId) || isControlledPath(menuId),
        testId: (0, $jzXAj.getTestId)(menuId)
    });
}
$13d7b307e35666c1$var$Nav4MenuLinkItemContent.displayName = "Nav4MenuLinkItemContent";

});
parcelRegister("dRtPJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9eaf76c4193a1dab$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");


var $e6rNk = parcelRequire("e6rNk");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
function $9eaf76c4193a1dab$var$LinkMenuItemWithAnalytics({ analytics: analytics, onClick: onClick, ...rest }, ref) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const handleClick = (0, $euxye.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
        }), actionSubjectId, analyticsAttributes);
    }, [
        analytics,
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e6rNk.LinkMenuItem), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
}
$9eaf76c4193a1dab$var$LinkMenuItemWithAnalytics.displayName = "LinkMenuItemWithAnalytics";
var // oxlint-disable-next-line typescript/consistent-type-assertions
$9eaf76c4193a1dab$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $euxye.forwardRef)($9eaf76c4193a1dab$var$LinkMenuItemWithAnalytics);

});
/* eslint-disable jira/filename-case */ const $6b2913942bd90807$export$6dd9406e478a1fe2 = 'navigationItem';
const $6b2913942bd90807$export$b887e88d8d0739f6 = 'button';
const $6b2913942bd90807$export$64fed82162bd367 = 'dropdownItem';
const $6b2913942bd90807$export$b0a8b257f1f878a2 = 'searchInput';


parcelRegister("jzXAj", function(module, exports) {
$parcel$export(module.exports, "getTestId", () => $973467f3949253ec$export$ec17b125bc42c229);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // By giving all of the Nav4-HTMLElements a test-id prefix, we can find them again,
// and even build a path from each leaf to the root. We do this in Storybook to
// simulate link-click-selection, since we are not using a real router in SB.
function $973467f3949253ec$export$ec17b125bc42c229(suffix) {
    return `NAV4_${suffix}`;
}

});



parcelRegister("4Elg6", function(module, exports) {
$parcel$export(module.exports, "ConfigurableMenuItems", () => $ef36c422083c3a14$export$4aa1992a31b27e16);

var $e7boj = parcelRequire("e7boj");

var $hivms = parcelRequire("hivms");

var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");

var $n67Vb = parcelRequire("n67Vb");

var $jTATq = parcelRequire("jTATq");

var $ggvFe = parcelRequire("ggvFe");

var $lL33O = parcelRequire("lL33O");

var $4BokK = parcelRequire("4BokK");

var $7l6jMC = parcelRequire("7l6jMC");

var $6ZLJT = parcelRequire("6ZLJT");

var $kIomd = parcelRequire("kIomd");

var $i860n = parcelRequire("i860n");

var $55BnK = parcelRequire("55BnK");

var $bGsfC = parcelRequire("bGsfC");

var $c3Eaw = parcelRequire("c3Eaw");

var $AXNe9 = parcelRequire("AXNe9");

var $95jMh = parcelRequire("95jMh");

var $6dvbm = parcelRequire("6dvbm");

var $fIlw4 = parcelRequire("fIlw4");

var $37Waq = parcelRequire("37Waq");

var $4wRyN = parcelRequire("4wRyN");

var $c4Kh9 = parcelRequire("c4Kh9");
const $ef36c422083c3a14$var$useShowRoadmapsUpsell = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jpd-roadmaps-in-jira'), ()=>(0, $jTATq.useShowRoadmapsUpsell)(), ()=>false);
const $ef36c422083c3a14$export$4aa1992a31b27e16 = /*#__PURE__*/ (0, $euxye.memo)($ef36c422083c3a14$var$ConfigurableMenuItemsInner);
function $ef36c422083c3a14$var$ConfigurableMenuItemsInner(t0) {
    const $ = (0, $e7boj.c)(56);
    const { menuData: menuData } = t0;
    const data = (0, $n67Vb.useFragment)((0, $hivms.default), menuData);
    const [getFilteredProductLinks, setGetFilteredProductLinks] = (0, $euxye.useState)(undefined);
    const globalAppLicense = (0, $7l6jMC.useGlobalApps)();
    const shouldShowRoadmapsUpsell = $ef36c422083c3a14$var$useShowRoadmapsUpsell();
    let t1;
    if ($[0] !== shouldShowRoadmapsUpsell) {
        t1 = {
            shouldShowRoadmapsUpsell: shouldShowRoadmapsUpsell
        };
        $[0] = shouldShowRoadmapsUpsell;
        $[1] = t1;
    } else t1 = $[1];
    const navItems = (0, $c3Eaw.useFilterL1MenuItemsByEditionAndLicense)((0, $AXNe9.useRefreshL1MenuItems)(data.jira?.userNavigationConfiguration?.navItems), t1);
    let t2;
    if ($[2] !== navItems) {
        t2 = (0, $lL33O.getConfigurableMenuIds)(navItems, true);
        $[2] = navItems;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== navItems) {
        t3 = (0, $lL33O.getConfigurableMenuIds)(navItems, false);
        $[4] = navItems;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== navItems) {
        t4 = (0, $4BokK.getProductItemsData)(navItems);
        $[6] = navItems;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== navItems || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = {
            navItems: navItems,
            visibleMenuIds: t2,
            moreMenuIds: t3,
            productItemsData: t4
        };
        $[8] = navItems;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    const navItemsContext = t5;
    let t6;
    if ($[13] !== getFilteredProductLinks || $[14] !== globalAppLicense || $[15] !== navItems) {
        t6 = (0, $4BokK.getAppItemsData)(navItems, globalAppLicense, getFilteredProductLinks);
        $[13] = getFilteredProductLinks;
        $[14] = globalAppLicense;
        $[15] = navItems;
        $[16] = t6;
    } else t6 = $[16];
    const appItemsDataUnstable = t6;
    const [appItemsDataStable, setAppItemsDataStable] = (0, $euxye.useState)(appItemsDataUnstable);
    let t7;
    let t8;
    if ($[17] !== appItemsDataStable || $[18] !== appItemsDataUnstable) {
        t7 = ()=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(appItemsDataStable, appItemsDataUnstable)) setAppItemsDataStable(appItemsDataUnstable);
        };
        t8 = [
            appItemsDataStable,
            appItemsDataUnstable
        ];
        $[17] = appItemsDataStable;
        $[18] = appItemsDataUnstable;
        $[19] = t7;
        $[20] = t8;
    } else {
        t7 = $[19];
        t8 = $[20];
    }
    (0, $euxye.useEffect)(t7, t8);
    let t9;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (fn)=>{
            setGetFilteredProductLinks(()=>fn);
        };
        $[21] = t9;
    } else t9 = $[21];
    const handleUpdateGetFilteredProductLinks = t9;
    const renderableShortcutMenuIds = (0, $c4Kh9.useRenderableShortcutMenuIds)();
    let t10;
    if ($[22] !== renderableShortcutMenuIds) {
        t10 = new Set(renderableShortcutMenuIds);
        $[22] = renderableShortcutMenuIds;
        $[23] = t10;
    } else t10 = $[23];
    const renderable = t10;
    let t11;
    if ($[24] !== appItemsDataStable || $[25] !== renderable) {
        let t12;
        if ($[27] !== renderable) {
            t12 = (item)=>renderable.has(item.menuId);
            $[27] = renderable;
            $[28] = t12;
        } else t12 = $[28];
        t11 = appItemsDataStable.filter(t12);
        $[24] = appItemsDataStable;
        $[25] = renderable;
        $[26] = t11;
    } else t11 = $[26];
    const modalAppItemsData = t11;
    let t12;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kIomd.TopLevelSpacer), null);
        $[29] = t12;
    } else t12 = $[29];
    let t13;
    if ($[30] !== appItemsDataStable) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, t12, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4wRyN.GlobalShortcutsWithInvitePeopleProvider), {
            appItemsData: appItemsDataStable,
            handleUpdateGetFilteredProductLinks: handleUpdateGetFilteredProductLinks
        }));
        $[30] = appItemsDataStable;
        $[31] = t13;
    } else t13 = $[31];
    const globalShortcuts = t13;
    let t14;
    if ($[32] !== getFilteredProductLinks) {
        t14 = (apsKey)=>{
            if (getFilteredProductLinks) {
                const result = getFilteredProductLinks(apsKey);
                return result.links[0]?.url;
            }
        };
        $[32] = getFilteredProductLinks;
        $[33] = t14;
    } else t14 = $[33];
    const getAppShortcutURL = t14;
    const { push: push } = (0, $55BnK.useRouterActions)();
    let t15;
    if ($[34] !== push) {
        t15 = (0, $i860n.fg)("ops-overview-disc-spotlights") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $95jMh.OperationsDiscoverabilitySpotlightForAdmins), {
            onClick: ()=>push("/jira/ops/overview")
        });
        $[34] = push;
        $[35] = t15;
    } else t15 = $[35];
    let t16;
    if ($[36] !== data || $[37] !== navItemsContext.visibleMenuIds) {
        let t17;
        if ($[39] !== data) {
            t17 = (menuId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bGsfC.ConfigurableMenuItem), {
                    key: menuId,
                    menuData: data,
                    menuId: menuId
                });
            $[39] = data;
            $[40] = t17;
        } else t17 = $[40];
        t16 = navItemsContext.visibleMenuIds.map(t17);
        $[36] = data;
        $[37] = navItemsContext.visibleMenuIds;
        $[38] = t16;
    } else t16 = $[38];
    let t17;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kIomd.TopLevelSpacer), null);
        $[41] = t17;
    } else t17 = $[41];
    let t18;
    if ($[42] !== data || $[43] !== getAppShortcutURL || $[44] !== modalAppItemsData || $[45] !== navItems || $[46] !== navItemsContext.productItemsData) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fIlw4.SidebarCustomization), {
            navItems: navItems,
            menuData: data,
            productItemsData: navItemsContext.productItemsData,
            appItemsData: modalAppItemsData,
            getAppShortcutURL: getAppShortcutURL
        });
        $[42] = data;
        $[43] = getAppShortcutURL;
        $[44] = modalAppItemsData;
        $[45] = navItems;
        $[46] = navItemsContext.productItemsData;
        $[47] = t18;
    } else t18 = $[47];
    let t19;
    if ($[48] !== globalShortcuts || $[49] !== t15 || $[50] !== t16 || $[51] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $37Waq.PeekMenuIdContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6dvbm.MoreMenuIsOpenContextProvider), null, t15, t16, globalShortcuts, t17, t18));
        $[48] = globalShortcuts;
        $[49] = t15;
        $[50] = t16;
        $[51] = t18;
        $[52] = t19;
    } else t19 = $[52];
    let t20;
    if ($[53] !== navItemsContext || $[54] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ggvFe.NavItemsContext).Provider, {
            value: navItemsContext
        }, t19);
        $[53] = navItemsContext;
        $[54] = t19;
        $[55] = t20;
    } else t20 = $[55];
    return t20;
}
$ef36c422083c3a14$var$ConfigurableMenuItemsInner.displayName = "ConfigurableMenuItemsInner";

});
parcelRegister("hivms", function(module, exports) {
$parcel$export(module.exports, "default", () => $472e3e7fcab62e8f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dc1391d9111afc9cf754690f0d499e80>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $472e3e7fcab62e8f$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "ConfigurableMenuItems",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudID",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "navKey",
                            "value": "NAV_SIDEBAR"
                        }
                    ],
                    "concreteType": "JiraUserNavigationConfiguration",
                    "kind": "LinkedField",
                    "name": "userNavigationConfiguration",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraConfigurableNavigationItem",
                            "kind": "LinkedField",
                            "name": "navItems",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "menuId"
                                    },
                                    "action": "THROW"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "isVisible"
                                    },
                                    "action": "THROW"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ConfigurableMenuItem"
        }
    ],
    "type": "Query"
};
$472e3e7fcab62e8f$var$node.hash = "186fc107bcd2a8ade003841f3137d27b";
var $472e3e7fcab62e8f$export$2e2bcd8739ae039 = $472e3e7fcab62e8f$var$node;

});

parcelRegister("jTATq", function(module, exports) {
$parcel$export(module.exports, "useShowRoadmapsUpsell", () => $bbf93afbfb65ac07$export$6a7d81db455652ad);

var $d8LhJ = parcelRequire("d8LhJ");

var $hJL79 = parcelRequire("hJL79");

var $b5YsQ = parcelRequire("b5YsQ");

var $8Uubk = parcelRequire("8Uubk");

var $ecGij = parcelRequire("ecGij");

var $35eqr = parcelRequire("35eqr");

var $cr9yX = parcelRequire("cr9yX");

var $41FAq = parcelRequire("41FAq");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $ccEzE = parcelRequire("ccEzE");

var $bs9jJ = parcelRequire("bs9jJ");

var $2HuOR = parcelRequire("2HuOR");

var $k6ufm = parcelRequire("k6ufm");

var $1yYbK = parcelRequire("1yYbK");
function $bbf93afbfb65ac07$var$traitListIndicatesOptOut(traits) {
    if (!traits) return false;
    for (const item of traits){
        if (!item || item.name !== 'optout_all_messages' && item.name !== 'optout_all_messages_user') continue;
        return item.value === 'true' || item.value === true;
    }
    return false;
}
function $bbf93afbfb65ac07$var$placementHasMessages(data) {
    return typeof data === 'object' && data !== null && 'messages' in data && Array.isArray(data.messages) && data.messages.length > 0;
}
const $bbf93afbfb65ac07$export$6a7d81db455652ad = ()=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    const isFedRampInstance = (0, $i860n.fg)('aem_roadmap_in_nav') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-roadmap-in-nav') : (0, $l1vE2.isFedRamp)();
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    const firstActivationDateMs = (0, $2HuOR.getFirstActivationDate)();
    const jiraSoftwareEdition = (0, $d8LhJ.getEdition)((0, $hJL79.JIRA_SOFTWARE), appEditions);
    const jpdEdition = (0, $d8LhJ.getEdition)((0, $hJL79.JIRA_PRODUCT_DISCOVERY), appEditions);
    const { isDismissed: isDismissed } = (0, $1yYbK.useRoadmapUpsellAdControls)();
    const wasSiteActivatedToday = firstActivationDateMs ? (0, $b5YsQ.default)(new Date(firstActivationDateMs)) : false;
    const { data: userTraitsData } = (0, $k6ufm.useResource)((0, $ecGij.fetchSiteUserTraitsResource));
    const { data: siteTraitsData } = (0, $k6ufm.useResource)((0, $8Uubk.fetchSiteTraitsResource));
    const hasOptedOut = $bbf93afbfb65ac07$var$traitListIndicatesOptOut(userTraitsData) || $bbf93afbfb65ac07$var$traitListIndicatesOptOut(siteTraitsData);
    const [nav4ProjectsSectionData] = (0, $cr9yX.usePlacementPreloadedData)((0, $35eqr.postOfficeNav4ProjectsSectionResource));
    const hasProjectsSectionRecommendation = $bbf93afbfb65ac07$var$placementHasMessages(nav4ProjectsSectionData);
    return !hasProjectsSectionRecommendation && !hasOptedOut && !wasSiteActivatedToday && !isFedRampInstance && !isDismissed && isSiteAdmin && jiraSoftwareEdition === (0, $d8LhJ.toEdition)((0, $d8LhJ.PREMIUM_EDITION)) && jpdEdition === (0, $d8LhJ.toEdition)((0, $d8LhJ.UNLICENSED)) && (0, $i860n.fg)('jpd-roadmaps-in-jira');
};

});
parcelRegister("1yYbK", function(module, exports) {
$parcel$export(module.exports, "useRoadmapUpsellAdControls", () => $bc4958cb9f88f991$export$bcafefdfe52805d2);
$parcel$export(module.exports, "useRoadmapUpsellAdAutoDismissal", () => $bc4958cb9f88f991$export$5a3f11724b592df2);

var $euxye = parcelRequire("euxye");

var $jWDKp = parcelRequire("jWDKp");
var $boO75 = parcelRequire("boO75");

var $hFtK7 = parcelRequire("hFtK7");

var $63gbl = parcelRequire("63gbl");

var $4r6rj = parcelRequire("4r6rj");

var $7Pr7y = parcelRequire("7Pr7y");

var $hYI7R = parcelRequire("hYI7R");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $3GN2r = parcelRequire("3GN2r");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $lCetP = parcelRequire("lCetP");
const $bc4958cb9f88f991$var$ROADMAPS_UPSELL_FIRST_SEEN_AT_USER_PROPERTY_KEY = 'jpd-roadmaps-upsell.firstSeenAt';
const $bc4958cb9f88f991$var$AUTO_DISMISS_AFTER_DAYS = 30;
const $bc4958cb9f88f991$var$isFirstSeenOlderThanAutoDismissThreshold = (firstSeenAt)=>(0, $jWDKp.default)(new Date(firstSeenAt), (0, $boO75.default)(new Date(), $bc4958cb9f88f991$var$AUTO_DISMISS_AFTER_DAYS));
const $bc4958cb9f88f991$var$ROADMAP_UPSELL_AD_CONTROL_CONFIG = {
    userPropertyKey: 'jpd-roadmaps-upsell.dismissed',
    analytics: {
        packageName: 'jiraRoadmapsUpsell',
        teamName: 'JPD - Juno',
        panelName: 'roadmaps-upsell'
    },
    fireDefaultEvent: true
};
const $bc4958cb9f88f991$var$initialState = {
    isDismissed: false
};
const $bc4958cb9f88f991$var$actions = {
    setIsDismissed: (value)=>({ setState: setState })=>{
            setState({
                isDismissed: value
            });
        }
};
const $bc4958cb9f88f991$var$Store = (0, $5QDqc.createStore)({
    name: 'RoadmapsUpsellVisibilityStore',
    initialState: $bc4958cb9f88f991$var$initialState,
    actions: $bc4958cb9f88f991$var$actions
});
const $bc4958cb9f88f991$export$8a5d0c82914cb1f1 = (0, $3h1FP.createHook)($bc4958cb9f88f991$var$Store);
const $bc4958cb9f88f991$export$bcafefdfe52805d2 = ()=>{
    const [{ isDismissed: isDismissed }, { setIsDismissed: setIsDismissed }] = $bc4958cb9f88f991$export$8a5d0c82914cb1f1();
    const { isDismissed: localIsDismissed, dismiss: actualDismiss } = (0, $4r6rj.useAdControlsFunctionality)($bc4958cb9f88f991$var$ROADMAP_UPSELL_AD_CONTROL_CONFIG);
    (0, $euxye.useEffect)(()=>{
        setIsDismissed(localIsDismissed);
    }, [
        localIsDismissed,
        setIsDismissed
    ]);
    const dismiss = (0, $euxye.useCallback)(async ()=>{
        await actualDismiss();
        setIsDismissed(true);
    }, [
        actualDismiss,
        setIsDismissed
    ]);
    return {
        isDismissed: isDismissed,
        dismiss: dismiss
    };
};
const $bc4958cb9f88f991$export$5a3f11724b592df2 = ()=>{
    const accountId = (0, $3GN2r.useAccountId)();
    const [firstSeenAt, setFirstSeenAt] = (0, $euxye.useState)(null);
    const { dismiss: dismiss } = (0, $4r6rj.useAdControlsFunctionality)($bc4958cb9f88f991$var$ROADMAP_UPSELL_AD_CONTROL_CONFIG);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    (0, $hYI7R.useEffectWithoutConcurrency)(()=>{
        if (!accountId || firstSeenAt !== null) return;
        (0, $kM0go.getUserProperty)(accountId, $bc4958cb9f88f991$var$ROADMAPS_UPSELL_FIRST_SEEN_AT_USER_PROPERTY_KEY).then((value)=>{
            setFirstSeenAt(value);
        }).catch((error)=>{
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const seenAt = new Date().toISOString();
                (0, $kM0go.setUserProperties)(accountId, $bc4958cb9f88f991$var$ROADMAPS_UPSELL_FIRST_SEEN_AT_USER_PROPERTY_KEY, JSON.stringify(seenAt)).then(()=>setFirstSeenAt(seenAt)).catch((saveError)=>{
                    const unknownErrorText = `Failed to save first seen at for "${$bc4958cb9f88f991$var$ROADMAPS_UPSELL_FIRST_SEEN_AT_USER_PROPERTY_KEY}" with account id "${accountId}"`;
                    (0, $hFtK7.fireErrorAnalytics)({
                        error: saveError instanceof Error ? saveError : new (0, $7Pr7y.UnknownError)(unknownErrorText, saveError),
                        meta: {
                            id: 'setUserProperties',
                            packageName: 'jiraRoadmapsUpsell',
                            teamName: 'JPD - Juno'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('jiraRoadmapsUpsell.error.setFirstSeenAt', 'Failed to save first seen at', saveError instanceof Error ? saveError : new (0, $7Pr7y.UnknownError)(unknownErrorText, saveError));
                });
                return;
            }
            if ((0, $lCetP.isClientFetchError)(error)) return;
            const unknownErrorText = `Failed to get first seen at for "${$bc4958cb9f88f991$var$ROADMAPS_UPSELL_FIRST_SEEN_AT_USER_PROPERTY_KEY}" with account id "${accountId}"`;
            (0, $hFtK7.fireErrorAnalytics)({
                error: new (0, $7Pr7y.UnknownError)(unknownErrorText, error),
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraRoadmapsUpsell',
                    teamName: 'JPD - Juno'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('jiraRoadmapsUpsell.error.getUserProperty', 'Failed to get first seen at', new (0, $7Pr7y.UnknownError)(unknownErrorText, error));
        });
    }, [
        accountId,
        firstSeenAt,
        setFirstSeenAt
    ]);
    (0, $hYI7R.useEffectWithoutConcurrency)(()=>{
        if (!accountId || firstSeenAt === null) return;
        if (!$bc4958cb9f88f991$var$isFirstSeenOlderThanAutoDismissThreshold(firstSeenAt)) return;
        (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'roadmapsUpsell autoDismissed', {
            firstSeenAt: firstSeenAt
        });
        dismiss();
    }, [
        accountId,
        firstSeenAt,
        dismiss,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("63gbl", function(module, exports) {
$parcel$export(module.exports, "logSafeErrorWithoutCustomerDataWrapper", () => $ff6977b216473ee6$export$ebd6466ba18b2f3a);

var $6CfY5 = parcelRequire("6CfY5");

var $75sVW = parcelRequire("75sVW");
const $ff6977b216473ee6$export$ebd6466ba18b2f3a = async (location, message, event)=>{
    let modifiedEvent = event;
    // Definies consumable shape for logging for ValidationError
    if (modifiedEvent instanceof (0, $75sVW.ValidationError)) modifiedEvent = {
        message: modifiedEvent.message,
        statusCode: modifiedEvent.statusCode,
        traceId: modifiedEvent.traceId,
        errors: JSON.stringify(modifiedEvent.errors),
        originalResponse: JSON.stringify(modifiedEvent.originalResponse)
    };
    if (modifiedEvent instanceof (0, $75sVW.default) && modifiedEvent.originalResponse && // We can't guarantee that response object is always in unread state when we try to log it
    !modifiedEvent.originalResponse?.bodyUsed) {
        const originalResponseText = await modifiedEvent.originalResponse.text();
        modifiedEvent.message = `${modifiedEvent.message} - ${originalResponseText}`;
        delete modifiedEvent.originalResponse;
    }
    (0, $6CfY5.default).safeErrorWithoutCustomerData(location, message, modifiedEvent);
    // Returning the modified error so the original response text can be used in the error handler
    return modifiedEvent;
};

});

parcelRegister("4r6rj", function(module, exports) {
$parcel$export(module.exports, "useAdControlsFunctionality", () => $39a7a877b01e4fcd$export$200d7892ced015e6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $iXN50 = parcelRequire("iXN50");

var $inMxE = parcelRequire("inMxE");

var $kM0go = parcelRequire("kM0go");

var $aJ81Y = parcelRequire("aJ81Y");

var $3GN2r = parcelRequire("3GN2r");
const $39a7a877b01e4fcd$var$AD_CONTROLS_FETCH_ERROR = 'adControlsFetchError';
const $39a7a877b01e4fcd$var$fireAdControlsError = (error, operation, userPropertyKey, analytics)=>{
    const errorMessage = `Failed to ${operation} user property: ${userPropertyKey}`;
    const wrappedError = new Error(errorMessage, {
        cause: error instanceof Error ? error : undefined
    });
    (0, $hFtK7.fireErrorAnalytics)({
        meta: {
            id: $39a7a877b01e4fcd$var$AD_CONTROLS_FETCH_ERROR,
            packageName: analytics.packageName,
            teamName: analytics.teamName
        },
        error: wrappedError
    });
};
const $39a7a877b01e4fcd$export$54fa2901bf4f90cf = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    return (0, $euxye.useCallback)((eventType, attributes = {}, actionSubject, actionSubjectId)=>{
        const baseEvent = createAnalyticsEvent({
            action: eventType === 'viewed' ? 'viewed' : 'clicked',
            actionSubject: actionSubject || 'adControl',
            actionSubjectId: actionSubjectId || 'jira-ad-controls'
        });
        (0, $aJ81Y.fireUIAnalytics)(baseEvent, eventType, attributes);
    }, [
        createAnalyticsEvent
    ]);
};
const $39a7a877b01e4fcd$export$200d7892ced015e6 = ({ onDismiss: onDismiss, userPropertyKey: userPropertyKey, analytics: analytics, fireDefaultEvent: fireDefaultEvent = true })=>{
    const accountId = (0, $3GN2r.useAccountId)() || '';
    const fireAdControlsAnalytics = $39a7a877b01e4fcd$export$54fa2901bf4f90cf();
    const internalLocalStorageKey = `jira-${userPropertyKey.split('.')[0]}`;
    // Use refs for mutable variables to avoid linter warnings
    const localCache = (0, $euxye.useRef)((0, $iXN50.createLocalStorageProvider)(internalLocalStorageKey));
    const isDismissedValueRef = (0, $euxye.useRef)(localCache.current.get(userPropertyKey) === 'true');
    const isDismissedLCSetRef = (0, $euxye.useRef)(localCache.current.get(userPropertyKey) !== null && localCache.current.get(userPropertyKey) !== undefined);
    // isPending is used to indicate that the ad controls are still fetching the user property
    const [isPending, setIsPending] = (0, $euxye.useState)(!isDismissedLCSetRef.current);
    const [isDismissed, setIsDismissed] = (0, $euxye.useState)(isDismissedValueRef.current);
    // Helper function to update all dismiss-related state consistently
    const updateDismissState = (0, $euxye.useCallback)((dismissed)=>{
        isDismissedValueRef.current = dismissed;
        setIsDismissed(dismissed);
        // @browser-storage setter
        localCache.current.set(userPropertyKey, String(dismissed));
        isDismissedLCSetRef.current = true;
    }, [
        userPropertyKey
    ]);
    const fetchUserProperties = (0, $euxye.useCallback)(async ()=>{
        if (!accountId) {
            setIsPending(false);
            // Track missing account ID
            fireAdControlsAnalytics('missingAccountId', {
                panelName: analytics.panelName
            });
            return;
        }
        try {
            setIsPending(true);
            const dismissedValue = await (0, $kM0go.getUserProperty)(accountId, userPropertyKey);
            updateDismissState(dismissedValue);
            // Track successful fetch
            fireAdControlsAnalytics('fetchSuccess', {
                panelName: analytics.panelName,
                isDismissed: dismissedValue
            });
        } catch (error) {
            if (error && typeof error === 'object' && 'statusCode' in error && error.statusCode === 404) updateDismissState(false);
            else $39a7a877b01e4fcd$var$fireAdControlsError(error, 'get', userPropertyKey, analytics);
        } finally{
            setIsPending(false);
        }
    }, [
        accountId,
        userPropertyKey,
        analytics,
        updateDismissState,
        fireAdControlsAnalytics
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isDismissedLCSetRef.current) fetchUserProperties();
    }, [
        fetchUserProperties
    ]);
    const dismiss = (0, $euxye.useCallback)(async ()=>{
        if (!accountId) {
            $39a7a877b01e4fcd$var$fireAdControlsError(new Error('Cannot dismiss ad controls without account ID'), 'set', userPropertyKey, analytics);
            return;
        }
        // Optimistically update all dismiss state
        updateDismissState(true);
        try {
            await (0, $kM0go.setUserProperties)(accountId, userPropertyKey, 'true');
            if (fireDefaultEvent) fireAdControlsAnalytics('notInterested', {
                panelName: analytics.panelName
            });
        } catch (error) {
            // Keep optimistic update - user has indicated they want to dismiss
            // Only log the error for monitoring purposes
            $39a7a877b01e4fcd$var$fireAdControlsError(error, 'set', userPropertyKey, analytics);
        } finally{
            onDismiss?.();
        }
    }, [
        accountId,
        updateDismissState,
        userPropertyKey,
        analytics,
        fireDefaultEvent,
        fireAdControlsAnalytics,
        onDismiss
    ]);
    return {
        isDismissed: isDismissed,
        dismiss: dismiss,
        isPending: isPending
    };
};

});

parcelRegister("7Pr7y", function(module, exports) {
$parcel$export(module.exports, "UnknownError", () => $c3b6c2d5a46aca42$export$ff4405149dbd0c5c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2KgJI = parcelRequire("2KgJI");
class $c3b6c2d5a46aca42$export$ff4405149dbd0c5c extends (0, $2KgJI.default) {
    constructor(message, details){
        super(message), this.name = 'UnknownError';
        this.details = details;
    }
}
$c3b6c2d5a46aca42$export$ff4405149dbd0c5c.displayName = "UnknownError";

});



parcelRegister("ggvFe", function(module, exports) {
$parcel$export(module.exports, "NavItemsContext", () => $42f3cffefd0d5903$export$a2018da95558f5c);
$parcel$export(module.exports, "PeekMenuIdContext", () => $42f3cffefd0d5903$export$390c771b9e3f4124);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");
const $42f3cffefd0d5903$export$a2018da95558f5c = /*#__PURE__*/ (0, $euxye.createContext)({
    navItems: [],
    visibleMenuIds: [],
    moreMenuIds: []
});
const $42f3cffefd0d5903$export$390c771b9e3f4124 = /*#__PURE__*/ (0, $euxye.createContext)({
    peekMenuId: undefined,
    setPeekMenuId: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
});

});

parcelRegister("lL33O", function(module, exports) {
$parcel$export(module.exports, "getConfigurableMenuIds", () => $b292dfa9251ec7a1$export$6071c13fba14d7fa);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bZXKt = parcelRequire("bZXKt");
const $b292dfa9251ec7a1$export$6071c13fba14d7fa = (navItems, isVisible)=>navItems.filter((navItem)=>navItem.isVisible === isVisible).map(({ menuId: menuId })=>menuId).filter((0, $bZXKt.isConfigurableMenuId));

});
parcelRegister("bZXKt", function(module, exports) {
$parcel$export(module.exports, "isConfigurableMenuId", () => $814568a3a7439aba$export$454094eefbaf1797);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bQpVj = parcelRequire("bQpVj");
const $814568a3a7439aba$export$454094eefbaf1797 = (value)=>(0, $bQpVj.CONFIGURABLE_MENU_IDS_AS_STRINGS).includes(value);

});


parcelRegister("4BokK", function(module, exports) {
$parcel$export(module.exports, "getProductItemsData", () => $90ced55289e00f17$export$92d3bf799aea2628);
$parcel$export(module.exports, "getAppItemsData", () => $90ced55289e00f17$export$153d0c6accbfb26a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");

var $i860n = parcelRequire("i860n");

var $2HuOR = parcelRequire("2HuOR");

var $6GljB = parcelRequire("6GljB");

var $af94c = parcelRequire("af94c");

var $7l6jMC = parcelRequire("7l6jMC");
const $90ced55289e00f17$export$92d3bf799aea2628 = (navItems)=>navItems.filter((navItem)=>(0, $7l6jMC.isSupportedMenuId)(navItem.menuId)).filter((navItem)=>!(0, $7l6jMC.isGlobalAppMenuId)(navItem.menuId)).filter((navItem)=>navItem.menuId !== (0, $6GljB.L1_MENU_ID).TEAMS).filter((navItem)=>{
        if (!(0, $i860n.fg)('itam_ftw')) return navItem.menuId !== (0, $6GljB.L1_MENU_ID).ITAM;
        return true;
    }).map((item)=>{
        return {
            menuId: item.menuId,
            visible: item.isVisible
        };
    });
const $90ced55289e00f17$export$153d0c6accbfb26a = (navItems, globalAppLicense, getFilteredProductLinks)=>{
    const USER_NAVIGATION_ITEM_LINKS = (0, $af94c.getUserNavigationItemLinks)();
    return navItems.filter((navItem)=>(0, $7l6jMC.isGlobalAppMenuId)(navItem.menuId)).filter((navItem)=>{
        // Metadata app licencing check
        if (!$90ced55289e00f17$var$isProductSupportedFromMetadata(navItem.menuId)) return false;
        if (getFilteredProductLinks) {
            if (navItem.menuId in (0, $5IkoH.GLOBAL_APP_MENU_ID_TO_APS_KEY)) {
                const apsKey = (0, $5IkoH.GLOBAL_APP_MENU_ID_TO_APS_KEY)[navItem.menuId];
                const fallbackUrl = USER_NAVIGATION_ITEM_LINKS[navItem.menuId];
                const filteredProducts = getFilteredProductLinks(apsKey);
                const statusDisabledOrComplete = filteredProducts.status === 'complete';
                if (statusDisabledOrComplete && !fallbackUrl && filteredProducts.links.length === 0) // If there are no filtered links, we don't want to show this item.
                return false;
            }
        }
        return true;
    }).filter((navItem)=>(0, $7l6jMC.hasGlobalAppLicense)(navItem.menuId, globalAppLicense)).map((item)=>{
        return {
            menuId: item.menuId,
            visible: item.isVisible
        };
    });
};
const $90ced55289e00f17$export$b7cc8dd7bef58aa3 = (navItems, globalAppLicense, getFilteredProductLinks)=>{
    const USER_NAVIGATION_ITEM_LINKS = (0, $af94c.getUserNavigationItemLinks)();
    return navItems.filter((navItem)=>navItem.isVisible).map(({ menuId: menuId })=>menuId).filter((0, $7l6jMC.isGlobalAppMenuId)).filter((navItem)=>{
        // Metadata app licencing check
        if (!$90ced55289e00f17$var$isProductSupportedFromMetadata(navItem)) return false;
        if (getFilteredProductLinks) {
            if (navItem in (0, $5IkoH.GLOBAL_APP_MENU_ID_TO_APS_KEY)) {
                const apsKey = (0, $5IkoH.GLOBAL_APP_MENU_ID_TO_APS_KEY)[navItem];
                const filteredProducts = getFilteredProductLinks(apsKey);
                const fallbackUrl = USER_NAVIGATION_ITEM_LINKS[navItem];
                const statusDisabledOrComplete = filteredProducts.status === 'complete';
                if (statusDisabledOrComplete && !fallbackUrl && filteredProducts.links.length === 0) // If there are no filtered links, we don't want to show this item.
                return false;
            }
        }
        return true;
    }).filter((menuId)=>(0, $7l6jMC.hasGlobalAppLicense)(menuId, globalAppLicense));
};
const $90ced55289e00f17$var$isProductSupportedFromMetadata = (menuId)=>{
    const products = (0, $2HuOR.getLicensedProducts)();
    switch(menuId){
        case (0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE:
            return !!products[(0, $2HuOR.LICENSED_PRODUCTS).CONFLUENCE];
        case (0, $6GljB.L1_MENU_ID).GLOBAL_APP_LOOM:
            return !!products[(0, $2HuOR.LICENSED_PRODUCTS).LOOM];
        default:
            return true;
    }
};

});
parcelRegister("af94c", function(module, exports) {
$parcel$export(module.exports, "getUserNavigationItemLinks", () => $ad199eb07876bc7d$export$1ed619da1e21182);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2PK8N = parcelRequire("2PK8N");

var $6GljB = parcelRequire("6GljB");
const $ad199eb07876bc7d$export$1ed619da1e21182 = ()=>{
    return {
        [(0, $6GljB.L1_MENU_ID).APPS]: '/jira/marketplace/discover?source=apps-menu',
        [(0, $6GljB.L1_MENU_ID).GOALS]: '/jira/your-work?goals',
        [(0, $6GljB.L1_MENU_ID).DASHBOARDS]: (0, $2PK8N.dashboardsDirectoryRoute).path,
        [(0, $6GljB.L1_MENU_ID).TEAMS]: '/jira/people/search',
        [(0, $6GljB.L1_MENU_ID).ROADMAPS]: '/jira/polaris/roadmaps',
        [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS]: '/jira/assets',
        [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS]: '',
        [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS]: '',
        [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: '',
        [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_LOOM]: '',
        [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: '',
        [(0, $6GljB.L1_MENU_ID).ITAM]: '/jira/itam/ham'
    };
};

});
parcelRegister("2PK8N", function(module, exports) {
$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $bbf238812ba5326c$export$41bba408475cab16);
const $bbf238812ba5326c$export$41bba408475cab16 = {
    name: 'dashboards-directory',
    path: '/jira/dashboards'
};

});


parcelRegister("7l6jMC", function(module, exports) {
$parcel$export(module.exports, "useGlobalApps", () => $aec326ce4b822dd5$export$3a835823210524f1);
$parcel$export(module.exports, "isSupportedMenuId", () => $aec326ce4b822dd5$export$54d4b2a367e2f9d);
$parcel$export(module.exports, "isGlobalAppMenuId", () => $aec326ce4b822dd5$export$4c0a3527505b04c5);
$parcel$export(module.exports, "hasGlobalAppLicense", () => $aec326ce4b822dd5$export$f97a769ad5c10cb4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $d8LhJ = parcelRequire("d8LhJ");

var $eBpdw = parcelRequire("eBpdw");

var $41FAq = parcelRequire("41FAq");

var $fS5dR = parcelRequire("fS5dR");

var $i860n = parcelRequire("i860n");

var $ccEzE = parcelRequire("ccEzE");

var $bQpVj = parcelRequire("bQpVj");

var $6GljB = parcelRequire("6GljB");

var $aieBA = parcelRequire("aieBA");
function $aec326ce4b822dd5$export$3a835823210524f1() {
    const appEditions = (0, $ccEzE.useAppEditions)();
    const shouldShowGoals = (appEditions.productDiscovery !== (0, $d8LhJ.UNLICENSED) || appEditions.software !== (0, $d8LhJ.UNLICENSED) || // JSM comes with a free core license. Goals don't display with JSM-only, so checking for unlicensed JSM
    appEditions.core !== (0, $d8LhJ.UNLICENSED) && appEditions.serviceDesk === (0, $d8LhJ.UNLICENSED)) && ((0, $i860n.fg)('aem_nav_common_core') ? (0, $41FAq.isFeatureEnabled)('jira', 'jira-goals-nav') : !(0, $fS5dR.isFedrampModerate)());
    const { isVisible: isAssetsVisible } = (0, $aieBA.useAssetsSidebarState)();
    const shouldShowAssets = isAssetsVisible && (0, $i860n.fg)('assets_as_an_app_v2') && (0, $eBpdw.isCMDBEnabledInEnvironment)();
    const globalAppShortcuts = (0, $euxye.useMemo)(()=>{
        if (appEditions.core !== (0, $d8LhJ.UNLICENSED)) {
            if (appEditions.serviceDesk !== (0, $d8LhJ.UNLICENSED)) return {
                confluence: true,
                loom: true,
                projects: false,
                teams: true,
                opsgenie: true
            };
            if (appEditions.productDiscovery !== (0, $d8LhJ.UNLICENSED)) return {
                confluence: true,
                loom: true,
                projects: false,
                teams: true,
                opsgenie: false
            };
        } else {
            if (appEditions.serviceDesk !== (0, $d8LhJ.UNLICENSED)) return {
                confluence: false,
                loom: false,
                projects: false,
                teams: true,
                opsgenie: true
            };
            if (appEditions.productDiscovery !== (0, $d8LhJ.UNLICENSED)) return {
                confluence: false,
                loom: false,
                projects: false,
                teams: true,
                opsgenie: false
            };
        }
        return {
            confluence: true,
            loom: true,
            projects: true,
            teams: true,
            opsgenie: false
        };
    }, [
        appEditions
    ]);
    return (0, $euxye.useMemo)(()=>{
        return {
            goals: shouldShowGoals,
            assets: shouldShowAssets,
            ...globalAppShortcuts
        };
    }, [
        globalAppShortcuts,
        shouldShowAssets,
        shouldShowGoals
    ]);
}
const $aec326ce4b822dd5$export$54d4b2a367e2f9d = (value)=>(0, $bQpVj.CONFIGURABLE_MENU_IDS_AS_STRINGS).includes(value);
const $aec326ce4b822dd5$export$4c0a3527505b04c5 = (value)=>(0, $bQpVj.GLOBAL_APP_MENU_IDS_AS_STRINGS).includes(value);
const $aec326ce4b822dd5$export$f97a769ad5c10cb4 = (value, globalAppLicense)=>{
    switch(value){
        case (0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS:
            return globalAppLicense.assets;
        case (0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS:
            return globalAppLicense.goals;
        case (0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE:
            return globalAppLicense.confluence;
        case (0, $6GljB.L1_MENU_ID).GLOBAL_APP_LOOM:
            return globalAppLicense.loom;
        case (0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS:
            return globalAppLicense.projects;
        case (0, $6GljB.L1_MENU_ID).GLOBAL_APP_TEAMS:
            return globalAppLicense.teams;
        default:
            return false;
    }
};

});
parcelRegister("aieBA", function(module, exports) {
$parcel$export(module.exports, "useAssetsSidebarState", () => $9373dd6e10b297a0$export$c5a8d4e4ef468a8f);

var $d8LhJ = parcelRequire("d8LhJ");

var $bOYO0 = parcelRequire("bOYO0");

var $d0iX2 = parcelRequire("d0iX2");

var $9FW2d = parcelRequire("9FW2d");

var $ccEzE = parcelRequire("ccEzE");

var $1KydW = parcelRequire("1KydW");

var $kt86l = parcelRequire("kt86l");

var $5rZe5 = parcelRequire("5rZe5");

var $bs9jJ = parcelRequire("bs9jJ");

var $i860n = parcelRequire("i860n");
const $9373dd6e10b297a0$export$c5a8d4e4ef468a8f = ()=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    const licensedProducts = (0, $5rZe5.useLicensedProducts)();
    const cloudId = (0, $kt86l.useCloudId)();
    const appPermissions = (0, $1KydW.useApplicationPermissions)();
    // `isSuccess` already implies the resolver gate is on (the hook is skipped when off);
    // `toResolvedAbsoluteUrl` is identity when not resolved.
    const { isSuccess: isUnitsResolved, toResolvedAbsoluteUrl: toResolvedAbsoluteUrl } = (0, $d0iX2.useAssetsWorkspaceHost)({
        cloudId: cloudId,
        productContext: (0, $9FW2d.getProductContext)({
            appPermissions: appPermissions
        }),
        skip: !(0, $i860n.fg)('astral_units_workspace_host_resolver')
    });
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    const isJsmFree = appEditions.serviceDesk === (0, $d8LhJ.FREE_EDITION);
    // `useApplicationPermissions` resolves to null until the tenant context store is populated,
    // and the nav renders before that on some routes.
    const hasJiraOrJsmProduct = Boolean(appPermissions?.hasServiceDeskAccess || appPermissions?.hasSoftwareAccess);
    const isEntitled = isUnitsResolved || (0, $bOYO0.hasAssetsEntitlement)({
        licensedProducts: licensedProducts
    });
    const isUpsell = !isEntitled && hasJiraOrJsmProduct && (0, $i860n.fg)('assets-platform-landing-page');
    const isJsmFreeSiteAdminUpsell = isSiteAdmin && isJsmFree;
    const isVisible = isEntitled || isUpsell || isJsmFreeSiteAdminUpsell;
    return {
        isVisible: isVisible,
        isEntitled: isEntitled,
        isUpsell: isUpsell,
        isJsmFreeSiteAdminUpsell: isJsmFreeSiteAdminUpsell,
        isUnitsResolved: isUnitsResolved,
        toResolvedAbsoluteUrl: toResolvedAbsoluteUrl
    };
};

});



parcelRegister("bGsfC", function(module, exports) {
$parcel$export(module.exports, "ConfigurableMenuItem", () => $a1efd46e32815971$export$5de02966decf8405);

var $e7boj = parcelRequire("e7boj");

var $eqUhA = parcelRequire("eqUhA");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $6GljB = parcelRequire("6GljB");

var $af94c = parcelRequire("af94c");

var $k3CK1 = parcelRequire("k3CK1");

var $rZMKj = parcelRequire("rZMKj");

var $2zFZk = parcelRequire("2zFZk");

var $gaQ4v = parcelRequire("gaQ4v");

var $jdVag = parcelRequire("jdVag");

var $3LwTA = parcelRequire("3LwTA");

var $hTFLW = parcelRequire("hTFLW");

var $4er6h = parcelRequire("4er6h");

var $9rz84 = parcelRequire("9rz84");

var $jhJde = parcelRequire("jhJde");

var $j951J = parcelRequire("j951J");

var $4S9lF = parcelRequire("4S9lF");

var $g4ceC = parcelRequire("g4ceC");

var $l0TTR = parcelRequire("l0TTR");

var $iXNX8 = parcelRequire("iXNX8");

var $i860n = parcelRequire("i860n");

var $7AcIC = parcelRequire("7AcIC");
const $a1efd46e32815971$export$5de02966decf8405 = /*#__PURE__*/ (0, $euxye.memo)($a1efd46e32815971$var$ConfigurableMenuItemInner);
function $a1efd46e32815971$var$ConfigurableMenuItemInner(t0) {
    const $ = (0, $e7boj.c)(32);
    const { isDefaultOpen: t1, menuData: menuData, menuId: menuId } = t0;
    const isDefaultOpen = t1 === undefined ? false : t1;
    const data = (0, $n67Vb.useFragment)((0, $eqUhA.default), menuData);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $af94c.getUserNavigationItemLinks)();
        $[0] = t2;
    } else t2 = $[0];
    const USER_NAVIGATION_ITEM_LINKS = t2;
    switch(menuId){
        case (0, $6GljB.L1_MENU_ID).APPS:
            {
                let t3;
                if ($[1] !== data || $[2] !== isDefaultOpen) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k3CK1.Nav4Apps), {
                        isExpanded: isDefaultOpen,
                        queryRef: data
                    });
                    $[1] = data;
                    $[2] = isDefaultOpen;
                    $[3] = t3;
                } else t3 = $[3];
                return t3;
            }
        case (0, $6GljB.L1_MENU_ID).ASSETS:
            {
                let t3;
                if ($[4] !== isDefaultOpen) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $rZMKj.Nav4Assets), {
                        isExpanded: isDefaultOpen
                    });
                    $[4] = isDefaultOpen;
                    $[5] = t3;
                } else t3 = $[5];
                return t3;
            }
        case (0, $6GljB.L1_MENU_ID).DASHBOARDS:
            {
                let t3;
                if ($[6] !== isDefaultOpen) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3LwTA.Nav4Dashboards), {
                        isExpanded: isDefaultOpen
                    });
                    $[6] = isDefaultOpen;
                    $[7] = t3;
                } else t3 = $[7];
                return t3;
            }
        case (0, $6GljB.L1_MENU_ID).FILTERS:
            {
                let t3;
                if ($[8] !== data || $[9] !== isDefaultOpen) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hTFLW.Nav4Filters), {
                        isExpanded: isDefaultOpen,
                        queryRef: data
                    });
                    $[8] = data;
                    $[9] = isDefaultOpen;
                    $[10] = t3;
                } else t3 = $[10];
                return t3;
            }
        case (0, $6GljB.L1_MENU_ID).GOALS:
            {
                let t3;
                if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7AcIC.Stub), {
                        menuId: (0, $6GljB.L1_MENU_ID).GOALS,
                        href: USER_NAVIGATION_ITEM_LINKS[(0, $6GljB.L1_MENU_ID).GOALS]
                    });
                    $[11] = t3;
                } else t3 = $[11];
                return t3;
            }
        case (0, $6GljB.L1_MENU_ID).OPERATIONS:
            {
                let t3;
                if ($[12] !== data || $[13] !== isDefaultOpen) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4er6h.Nav4Operations), {
                        isExpanded: isDefaultOpen,
                        queryRef: data
                    });
                    $[12] = data;
                    $[13] = isDefaultOpen;
                    $[14] = t3;
                } else t3 = $[14];
                return t3;
            }
        case (0, $6GljB.L1_MENU_ID).PLANS:
            {
                let t3;
                if ($[15] !== data || $[16] !== isDefaultOpen) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9rz84.Nav4Plans), {
                        isExpanded: isDefaultOpen,
                        queryRef: data
                    });
                    $[15] = data;
                    $[16] = isDefaultOpen;
                    $[17] = t3;
                } else t3 = $[17];
                return t3;
            }
        case (0, $6GljB.L1_MENU_ID).PROJECTS:
            {
                let t3;
                if ($[18] !== data || $[19] !== isDefaultOpen) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jhJde.Nav4Projects), {
                        isExpanded: isDefaultOpen,
                        queryRef: data
                    });
                    $[18] = data;
                    $[19] = isDefaultOpen;
                    $[20] = t3;
                } else t3 = $[20];
                return t3;
            }
        case (0, $6GljB.L1_MENU_ID).RECENT:
            {
                let t3;
                if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j951J.Recent), null);
                    $[21] = t3;
                } else t3 = $[21];
                return t3;
            }
        case (0, $6GljB.L1_MENU_ID).ROADMAPS:
            {
                if ((0, $i860n.fg)("jpd-enable-roadmaps-recents-fe")) {
                    let t3;
                    if ($[22] !== data || $[23] !== isDefaultOpen) {
                        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l0TTR.Nav4RoadmapsNewWithRecent), {
                            isExpanded: isDefaultOpen,
                            queryRef: data
                        });
                        $[22] = data;
                        $[23] = isDefaultOpen;
                        $[24] = t3;
                    } else t3 = $[24];
                    return t3;
                }
                let t3;
                if ($[25] !== isDefaultOpen) {
                    t3 = (0, $i860n.fg)("jpd-roadmaps-in-jira") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g4ceC.Nav4RoadmapsNew), {
                        isExpanded: isDefaultOpen
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4S9lF.Nav4Roadmaps), {
                        isExpanded: isDefaultOpen
                    });
                    $[25] = isDefaultOpen;
                    $[26] = t3;
                } else t3 = $[26];
                return t3;
            }
        case (0, $6GljB.L1_MENU_ID).STARRED:
            {
                let t3;
                if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iXNX8.Starred), null);
                    $[27] = t3;
                } else t3 = $[27];
                return t3;
            }
        case (0, $6GljB.L1_MENU_ID).TEAMS:
            return null;
        case (0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE:
            {
                let t3;
                if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2zFZk.CustomerService), null);
                    $[28] = t3;
                } else t3 = $[28];
                return t3;
            }
        case (0, $6GljB.L1_MENU_ID).CUSTOMERS:
            {
                let t3;
                if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gaQ4v.Customers), null);
                    $[29] = t3;
                } else t3 = $[29];
                return t3;
            }
        case (0, $6GljB.L1_MENU_ID).HELP_CENTER_MANAGEMENT:
            {
                let t3;
                if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jdVag.HelpCenterManagement), null);
                    $[30] = t3;
                } else t3 = $[30];
                return t3;
            }
        case (0, $6GljB.L1_MENU_ID).ITAM:
            {
                let t3;
                if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = (0, $i860n.fg)("itam_ftw") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7AcIC.Stub), {
                        menuId: (0, $6GljB.L1_MENU_ID).ITAM,
                        href: USER_NAVIGATION_ITEM_LINKS[(0, $6GljB.L1_MENU_ID).ITAM]
                    }) : null;
                    $[31] = t3;
                } else t3 = $[31];
                return t3;
            }
        default:
            return null;
    }
}
$a1efd46e32815971$var$ConfigurableMenuItemInner.displayName = "ConfigurableMenuItemInner";

});
parcelRegister("eqUhA", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bd34347b3217140$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4e7b300cc6654e06147ff97feea114d5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6bd34347b3217140$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfigurableMenuItem",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4Projects"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Filters"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Plans"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Apps"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Operations"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Roadmaps_query"
        }
    ],
    "type": "Query"
};
$6bd34347b3217140$var$node.hash = "6819bd0a98d8be3f1e4a0a09380ce499";
var $6bd34347b3217140$export$2e2bcd8739ae039 = $6bd34347b3217140$var$node;

});

parcelRegister("k3CK1", function(module, exports) {
$parcel$export(module.exports, "Nav4Apps", () => $49bc676ecdeefdec$export$8473036ee9e92881);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $gDdYI = parcelRequire("gDdYI");

var $87pPF = parcelRequire("87pPF");


var $iZS3n = parcelRequire("iZS3n");
const $49bc676ecdeefdec$export$8473036ee9e92881 = (props)=>{
    const getAttributes = (0, $euxye.useCallback)((error)=>(0, $iZS3n.createAttributes)({
            error: error,
            component: 'Nav4Apps'
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-apps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "flag",
        id: "apps-section",
        attributes: getAttributes,
        packageName: (0, $2bb20df175b75b35$export$b8b9d90f9e5bd72b),
        teamName: (0, $2bb20df175b75b35$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $87pPF.Nav4Apps), props)));
};
$49bc676ecdeefdec$export$8473036ee9e92881.displayName = "Nav4Apps";

});
parcelRegister("87pPF", function(module, exports) {
$parcel$export(module.exports, "Nav4Apps", () => $6917df47b7b5c253$export$8473036ee9e92881);

var $3nfNv = parcelRequire("3nfNv");

var $doa2A = parcelRequire("doa2A");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $5IkoH = parcelRequire("5IkoH");

var $19zz3 = parcelRequire("19zz3");

var $h54ru = parcelRequire("h54ru");

var $i860n = parcelRequire("i860n");

var $caTho = parcelRequire("caTho");

var $dcF7c = parcelRequire("dcF7c");

var $i8bC9 = parcelRequire("i8bC9");

var $13bUl = parcelRequire("13bUl");

var $fbaMB = parcelRequire("fbaMB");
function $6917df47b7b5c253$export$8473036ee9e92881(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fbaMB.Nav4AppsSpotlightWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($6917df47b7b5c253$var$Nav4AppsInner, props));
}
$6917df47b7b5c253$export$8473036ee9e92881.displayName = "Nav4Apps";
function $6917df47b7b5c253$var$Nav4AppsInner(props) {
    const { isExpanded: isExpanded, queryRef: queryRef, ...dndProps } = props;
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $19zz3.useSidebarNav4)();
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $doa2A.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    /* eslint-disable @atlassian/relay/unused-fields */ const globalAppNavigationItems = (0, $n67Vb.useFragment)((0, $3nfNv.default), data.jira);
    // $isAppsExpanded (in the query) is based on the same logic as in isInitialSelectedPath(MENU_ID_APPS).
    // However, below we filter out false positives based on extra data we retrieve from GraphQL.
    // We simply can't determine whether the general Connect app is a part of the "Apps" section or not without that extra data.
    // And we would like to avoid situations where the "Apps" section is expanded when it shouldn't be.
    // Keep in mind that global Connect app != general Connect app. Global app is a subset of the general app.
    // General app can be rendered in various contexts, while the global one only under the "Apps" section.
    const isMaybeAppsSectionRoute = isInitialSelectedPath((0, $5IkoH.MENU_ID_APPS));
    const isGeneralConnectRoute = (0, $h54ru.useIsGeneralConnectRoute)();
    const isGlobalConnectAppRoute = (0, $dcF7c.useIsGlobalConnectAppRoute)({
        data: globalAppNavigationItems
    });
    const isAppsSectionExpanded = isMaybeAppsSectionRoute && (isGeneralConnectRoute ? isGlobalConnectAppRoute : true);
    const isExpandedValue = (0, $i860n.fg)('navx-global-side-nav') ? !!dndProps.isExpandOrFlyoutOpen && isExpanded : isExpanded;
    const sectionActions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $caTho.SectionActions), null);
    return isAppsSectionExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $13bUl.Nav4AppsForLanding), {
        actionsOnHover: sectionActions,
        isExpanded: isExpandedValue,
        queryRef: data.jira,
        navigationCustomisationFragment: data.appsOrder,
        ...dndProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $i8bC9.Nav4AppsDefault), {
        actionsOnHover: sectionActions,
        isExpanded: isExpanded,
        ...dndProps
    });
}
$6917df47b7b5c253$var$Nav4AppsInner.displayName = "Nav4AppsInner";

});
parcelRegister("3nfNv", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb929e9b2cd1b65f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2533fc56f3c07a1662587e495c5ad70c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bb929e9b2cd1b65f$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "isAppsExpanded"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4Apps_GlobalAppsFragment",
        "selections": [
            {
                "condition": "isAppsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraNavigationItemConnection",
                        "kind": "LinkedField",
                        "name": "globalAppNavigationItems",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraNavigationItemEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "appType"
                                                    },
                                                    v0 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraAppSection",
                                                        "kind": "LinkedField",
                                                        "name": "sections",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraAppNavigationItemNestedLink",
                                                                "kind": "LinkedField",
                                                                "name": "links",
                                                                "plural": true,
                                                                "selections": [
                                                                    v0 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraAppNavigationItem"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$bb929e9b2cd1b65f$var$node.hash = "fcee4331eb5ce6a0f2c7ee593634458d";
var $bb929e9b2cd1b65f$export$2e2bcd8739ae039 = $bb929e9b2cd1b65f$var$node;

});

parcelRegister("doa2A", function(module, exports) {
$parcel$export(module.exports, "default", () => $192a70e26dfb767a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<58f11b88f97aa8656c0ef6e8ab15ffa0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $192a70e26dfb767a$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "entityAriApps"
        },
        {
            "kind": "RootArgument",
            "name": "isAppsExpanded"
        },
        {
            "kind": "RootArgument",
            "name": "ownerAri"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "skipOrderQuery"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Apps",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "isAppsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "Nav4AppsForLanding"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4Apps_GlobalAppsFragment"
                    }
                ]
            },
            "action": "THROW"
        },
        {
            "condition": "skipOrderQuery",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "condition": "isAppsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "appsOrder",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "entityAri",
                                    "variableName": "entityAriApps"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "ownerAri",
                                    "variableName": "ownerAri"
                                }
                            ],
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "Nav4AppsContent_navigationCustomisation"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$192a70e26dfb767a$var$node.hash = "c4548a7973b987d15b97b369b8bc4314";
var $192a70e26dfb767a$export$2e2bcd8739ae039 = $192a70e26dfb767a$var$node;

});

parcelRegister("h54ru", function(module, exports) {
$parcel$export(module.exports, "useIsGeneralConnectRoute", () => $54ddfb3c1a026416$export$db179b21b0be87a1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aXunP = parcelRequire("aXunP");
const $54ddfb3c1a026416$var$GENERAL_CONNECT_ROUTES = new Set([
    'connect-general',
    'connect-general-invalid',
    'legacy-connect-general',
    'connect-general-service-desk-project'
]);
const $54ddfb3c1a026416$var$UNCERTAIN_APPS_SECTION_ROUTES = $54ddfb3c1a026416$var$GENERAL_CONNECT_ROUTES;
const $54ddfb3c1a026416$var$CERTAIN_APPS_SECTION_ROUTES = new Set([
    'forge-spa-global',
    'marketplace-index'
]);
const $54ddfb3c1a026416$export$22e210b2ba662e30 = new Set([
    ...$54ddfb3c1a026416$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$54ddfb3c1a026416$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $54ddfb3c1a026416$export$db179b21b0be87a1() {
    const route = (0, $aXunP.useRoute)();
    return $54ddfb3c1a026416$var$GENERAL_CONNECT_ROUTES.has(route.name);
}

});

parcelRegister("caTho", function(module, exports) {
$parcel$export(module.exports, "SectionActions", () => $b18facb2848f8362$export$51f8029abf8c56ce);
/* SectionActions.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");



var $bOwox = parcelRequire("bOwox");

var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $hwodR = parcelRequire("hwodR");

var $2DbWL = parcelRequire("2DbWL");

var $gbTMi = parcelRequire("gbTMi");

var $lI0cf = parcelRequire("lI0cf");

var $g36LP = parcelRequire("g36LP");

var $cSR11 = parcelRequire("cSR11");

var $gBaKj = parcelRequire("gBaKj");

var $kHMXB = parcelRequire("kHMXB");

var $6RG3D = parcelRequire("6RG3D");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $eijVy = parcelRequire("eijVy");
const $b18facb2848f8362$var$manageApps = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.manage-apps",
    defaultMessage: "Manage apps"
});
const $b18facb2848f8362$var$appAuditLogs = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.app-audit-logs",
    defaultMessage: "App audit logs"
});
const $b18facb2848f8362$var$viewAppRequests = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.view-app-requests",
    defaultMessage: "View app requests"
});
const $b18facb2848f8362$var$apps = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.apps",
    defaultMessage: "Apps"
});
function $b18facb2848f8362$export$51f8029abf8c56ce({ onClose: onClose }) {
    const tenantContext = (0, $eijVy.useTenantContext)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = tenantContext;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const showManageApps = isAdmin || isSiteAdmin;
    const showAppAuditLogs = (0, $i860n.fg)('show_app_audit_logs_upm_dep') && (isAdmin || isSiteAdmin);
    const showViewAppRequests = (0, $2700E.expVal)('enduser-emcee-discover', 'value', true) && isSiteAdmin;
    const fireOpenEvent = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_APPS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
                itemId: 'meatballDropdown'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const showActions = showManageApps || showViewAppRequests;
    if (!showActions && (0, $i860n.fg)('navx-global-side-nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null); // Function return-type is JSX, rather than ReactNode, so gotta do this
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
        MenuItems: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b18facb2848f8362$var$MoreMenuItems, {
                showManageApps: showManageApps,
                showViewAppRequests: showViewAppRequests,
                showAppAuditLogs: showAppAuditLogs,
                ...props
            }),
        onOpen: fireOpenEvent,
        onClose: onClose,
        name: formatMessage($b18facb2848f8362$var$apps)
    });
}
$b18facb2848f8362$export$51f8029abf8c56ce.displayName = "SectionActions";
function $b18facb2848f8362$var$MoreMenuItems({ onClose: onClose, showManageApps: showManageApps, showViewAppRequests: showViewAppRequests, showAppAuditLogs: showAppAuditLogs }) {
    const tenantContext = (0, $eijVy.useTenantContext)();
    const { cloudId: cloudId } = tenantContext;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const adminHubAppRequestsUrl = `https://${(0, $6RG3D.getATLContextDomain)('admin')}/s/${cloudId}/user-connected-apps/tab/requested`;
    const viewAppRequestsLink = (0, $euxye.useMemo)(()=>(0, $i860n.fg)('should_redirect_to_admin-hub_for_app_requests') ? adminHubAppRequestsUrl : (0, $lI0cf.getAppRequestsLink)(), [
        adminHubAppRequestsUrl
    ]);
    const onCloseWithStopPropagation = (0, $hwodR.useStopPropagation)(onClose);
    const showTopSection = showManageApps || showViewAppRequests;
    const fireClickEvent = (0, $euxye.useCallback)((itemId)=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_APPS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                componentType: (0, $6e2f51712bb2e810$export$74712b62056d422e),
                itemId: itemId,
                parentItemId: (0, $bOwox.SECTION_ITEM_APPS)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, showTopSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: (0, $i860n.fg)('ditto-a11y-fix-nav-menu-items')
    }, showManageApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cSR11.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gBaKj))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)"
        }),
        href: "/plugins/servlet/upm",
        target: "_blank",
        onClick: (...args)=>{
            fireClickEvent('manageApps');
            onCloseWithStopPropagation(...args);
        }
    }, formatMessage($b18facb2848f8362$var$manageApps)), showAppAuditLogs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cSR11.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gBaKj))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)"
        }),
        href: "/plugins/servlet/upm/log",
        onClick: (...args)=>{
            onCloseWithStopPropagation(...args);
        },
        target: "_blank"
    }, formatMessage($b18facb2848f8362$var$appAuditLogs)), showViewAppRequests && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cSR11.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kHMXB))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)"
        }),
        href: viewAppRequestsLink,
        target: "_blank",
        onClick: (...args)=>{
            fireClickEvent('viewAppRequests');
            onCloseWithStopPropagation(...args);
        }
    }, formatMessage($b18facb2848f8362$var$viewAppRequests))), !(0, $i860n.fg)('navx-global-side-nav') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2DbWL.HideL1MenuItemSection), {
        menuId: (0, $6GljB.L1_MENU_ID).APPS,
        hasSeparator: showTopSection
    }));
}
$b18facb2848f8362$var$MoreMenuItems.displayName = "MoreMenuItems";

});
/* eslint-disable jira/filename-case */ const $6e2f51712bb2e810$export$4165a3d0da3bd147 = 'fixedItem';
const $6e2f51712bb2e810$export$95b0c331af13d819 = 'fixedItemButton';
const $6e2f51712bb2e810$export$74712b62056d422e = 'fixedItemAction';
const $6e2f51712bb2e810$export$3ac911b122986477 = 'customItem';
const $6e2f51712bb2e810$export$9bd6c21d500ae611 = 'customItemButton';
const $6e2f51712bb2e810$export$5374c2c2d3ece55e = 'customItemAction';
const $6e2f51712bb2e810$export$56981f28056f258e = 'customItemDropdownAction';
const $6e2f51712bb2e810$export$17bca95234dea43b = 'fixedItemDropdownAction';

/* eslint-disable jira/filename-case */ const $ef39084c605eb7e8$export$265c523d1a8f25cf = '1';
const $ef39084c605eb7e8$export$fe3b012b0224e4e1 = '2';
const $ef39084c605eb7e8$export$f9db6a58b4aabd18 = '3';
const $ef39084c605eb7e8$export$35ac629b8b943d5a = '4';

parcelRegister("hwodR", function(module, exports) {
$parcel$export(module.exports, "useStopPropagation", () => $bf0c32cd804fb036$export$f7bb512e68bcecd9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
const $bf0c32cd804fb036$export$f7bb512e68bcecd9 = (// oxlint-disable-next-line @typescript-eslint/no-explicit-any
onEvent)=>(0, $euxye.useCallback)((e, ...args)=>{
        try {
            onEvent?.(e, ...args);
        } finally{
            e?.stopPropagation();
        }
    }, [
        onEvent
    ]);

});

parcelRegister("2DbWL", function(module, exports) {
$parcel$export(module.exports, "HideL1MenuItemSection", () => $89f1b9762dda6f8b$export$a6246d2fccf72824);

var $7qO14 = parcelRequire("7qO14");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $8iIal = parcelRequire("8iIal");




var $bOwox = parcelRequire("bOwox");

var $c9cNX = parcelRequire("c9cNX");

var $g36LP = parcelRequire("g36LP");

var $ceqcm = parcelRequire("ceqcm");

var $8Sdzy = parcelRequire("8Sdzy");

var $jYd2W = parcelRequire("jYd2W");

var $iQPOZ = parcelRequire("iQPOZ");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aZMdt = parcelRequire("aZMdt");
var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $aJ81Y = parcelRequire("aJ81Y");

var $kt86l = parcelRequire("kt86l");

var $ggvFe = parcelRequire("ggvFe");

var $ix8t0 = parcelRequire("ix8t0");
const $89f1b9762dda6f8b$var$hideFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.hide-from-sidebar",
    defaultMessage: "Hide from sidebar"
});
const $89f1b9762dda6f8b$var$moveBackToSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.move-back-to-sidebar",
    defaultMessage: "Move back to sidebar"
});
/**
 * Delete this module, test, and all related messages when cleaning up navx-global-side-nav
 */ const $89f1b9762dda6f8b$var$HIDE_ROOT_MENU_ITEM_SUCCESS = 'HIDE_ROOT_MENU_ITEM_SUCCESS';
const $89f1b9762dda6f8b$var$RESTORE_ROOT_MENU_ITEM_SUCCESS = 'RESTORE_ROOT_MENU_ITEM_SUCCESS';
function $89f1b9762dda6f8b$var$HideL1MenuItemSectionInner(props) {
    const { menuId: menuId } = props;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { navItems: navItems } = (0, $euxye.useContext)((0, $ggvFe.NavItemsContext));
    const { peekMenuId: peekMenuId } = (0, $euxye.useContext)((0, $ggvFe.PeekMenuIdContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const cloudID = (0, $kt86l.useCloudId)();
    const [isHidden, setIsHidden] = (0, $euxye.useState)(false);
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $iQPOZ.useFlagsService)();
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $n67Vb.useMutation)((0, $7qO14.default));
    const onSave = (0, $euxye.useCallback)((newNavItems)=>{
        commit({
            variables: {
                input: {
                    cloudID: cloudID,
                    navKey: 'NAV_SIDEBAR',
                    navItems: newNavItems
                }
            }
        });
        (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebarNavItems changed', {
            originalNavItems: navItems,
            updatedNavItems: newNavItems,
            changedFrom: 'hideFromSidebarButton'
        });
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[menuId],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                componentType: (0, $6e2f51712bb2e810$export$17bca95234dea43b),
                parentItemId: (0, $bOwox.SECTION_ITEM_MAP)[menuId],
                itemId: 'hideFromSidebar'
            }
        });
    }, [
        cloudID,
        commit,
        createAnalyticsEvent,
        menuId,
        navItems
    ]);
    const toggleNavItemVisibility = (0, $euxye.useCallback)(({ isVisible: isVisible })=>{
        const newNavItems = navItems.map((item)=>{
            if (item.menuId === menuId) return {
                ...item,
                isVisible: isVisible
            };
            return {
                ...item
            };
        });
        return newNavItems;
    }, [
        menuId,
        navItems
    ]);
    const onRestoreRootMenuItem = ()=>{
        if (navItems !== undefined) {
            const newNavItems = toggleNavItemVisibility({
                isVisible: true
            });
            onSave(newNavItems);
            setIsHidden(false);
            showFlag({
                type: 'success',
                id: $89f1b9762dda6f8b$var$RESTORE_ROOT_MENU_ITEM_SUCCESS,
                title: (0, $ix8t0.getNavItemRestoredFromSideBarFlagTitle)(menuId),
                isAutoDismiss: true,
                // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
                messageId: 'navigation-apps-sidebar-nav4-sidebars-common-core.ui.hide-l1-menu-item-action.show-flag.success.restore-root-menu-item-success',
                messageType: 'transactional'
            });
        }
    };
    const onHideRootMenuItem = ()=>{
        if (navItems !== undefined) {
            const newNavItems = toggleNavItemVisibility({
                isVisible: false
            });
            onSave(newNavItems);
            setIsHidden(true);
            showFlag({
                type: 'success',
                id: $89f1b9762dda6f8b$var$HIDE_ROOT_MENU_ITEM_SUCCESS,
                title: (0, $ix8t0.getNavItemHiddenFromSideBarFlagTitle)(menuId),
                isAutoDismiss: true,
                // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
                messageId: 'navigation-apps-sidebar-nav4-sidebars-common-core.ui.hide-l1-menu-item-action.show-flag.success.hide-root-menu-item-success',
                messageType: 'transactional',
                actions: [
                    {
                        content: $89f1b9762dda6f8b$var$moveBackToSidebar,
                        onClick: ()=>{
                            onRestoreRootMenuItem();
                            dismissFlag($89f1b9762dda6f8b$var$HIDE_ROOT_MENU_ITEM_SUCCESS);
                        }
                    }
                ]
            });
        }
    };
    // When the peekend menu id is the same as the menu id, the menu item is disabled because it's not possible
    // to hide an already hidden menu item. Do indicate this we need to both disable the button and set the color
    // of the icon and text appropriately.
    const isDisabled = peekMenuId === menuId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8iIal.AnnouncerV2), {
        message: formatMessage((0, $ix8t0.getA11YAlert)(menuId)),
        shouldAnnounce: isHidden
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        interactionName: "nav4-sidebar-hide-from-sidebar-button",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jYd2W))), {
            label: formatMessage($89f1b9762dda6f8b$var$hideFromSidebar),
            color: isDisabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon, #292A2E)"
        }),
        onClick: onHideRootMenuItem,
        isDisabled: isDisabled,
        "aria-label": formatMessage((0, $ix8t0.getA11YLabel)(menuId))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        color: isDisabled ? 'color.text.disabled' : 'color.text'
    }, formatMessage($89f1b9762dda6f8b$var$hideFromSidebar))));
}
$89f1b9762dda6f8b$var$HideL1MenuItemSectionInner.displayName = "HideL1MenuItemSectionInner";
function $89f1b9762dda6f8b$export$a6246d2fccf72824(props) {
    const { hasSeparator: hasSeparator = true, hasSection: hasSection = true } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceName: (0, $b4c27ba6f7293911$export$a3821bc63538b210),
        sourceType: (0, $46f069e6c968f461$export$d1123261ca8831d2),
        containerId: (0, $b4c27ba6f7293911$export$3c19576bd92ff564),
        containerType: (0, $b4c27ba6f7293911$export$fba7c3adda5094d9)
    }, hasSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        hasSeparator: hasSeparator
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($89f1b9762dda6f8b$var$HideL1MenuItemSectionInner, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($89f1b9762dda6f8b$var$HideL1MenuItemSectionInner, props));
}
$89f1b9762dda6f8b$export$a6246d2fccf72824.displayName = "HideL1MenuItemSection";

});
parcelRegister("7qO14", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d4cd207a9978a9b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7248957b45ec2356e4da9e9a89ed657d>>
 * @relayHash 66baa10107c8516c24b8ed85cb97aa27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b23a1defc70b85ce697c0dc1d84377c11fe03c64d3dbd4d0cb309c2158ac9e77
const $9d4cd207a9978a9b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "JiraConfigurableNavigationItem",
        "kind": "LinkedField",
        "name": "navItems",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "menuId"
            },
            {
                "kind": "ScalarField",
                "name": "isVisible"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "hideL1MenuItemActionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserNavigationConfigurationPayload",
                            "kind": "LinkedField",
                            "name": "updateUserNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraUserNavigationConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userNavigationConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "hideL1MenuItemActionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserNavigationConfigurationPayload",
                            "kind": "LinkedField",
                            "name": "updateUserNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraUserNavigationConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userNavigationConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b23a1defc70b85ce697c0dc1d84377c11fe03c64d3dbd4d0cb309c2158ac9e77",
            "metadata": {},
            "name": "hideL1MenuItemActionMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9d4cd207a9978a9b$var$node.hash = "1b96ba09e281b673ec1bfa126587621b";
var $9d4cd207a9978a9b$export$2e2bcd8739ae039 = $9d4cd207a9978a9b$var$node;

});

parcelRegister("8iIal", function(module, exports) {
$parcel$export(module.exports, "AnnouncerV2", () => $050966b7145ef446$export$a43c8a2f4981e0e);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $kSWvv = parcelRequire("kSWvv");
const $050966b7145ef446$var$NON_BREAKING_SPACE = '\u00A0';
const $050966b7145ef446$export$a43c8a2f4981e0e = /*#__PURE__*/ (0, $euxye.memo)(({ message: message, liveMode: liveMode = 'polite', shouldAnnounce: shouldAnnounce = true, testId: testId })=>{
    const previousMessage = (0, $euxye.useRef)('');
    const setAlternatePolite = (0, $euxye.useRef)(false);
    const addSuffix = (0, $euxye.useRef)(false);
    const [oldMessage, setOldMessage] = (0, $euxye.useState)('');
    const [newMessage, setNewMessage] = (0, $euxye.useState)('');
    (0, $euxye.useEffect)(()=>{
        let messageToAnnounce = shouldAnnounce ? message : $050966b7145ef446$var$NON_BREAKING_SPACE;
        if (previousMessage.current === messageToAnnounce) {
            addSuffix.current = !addSuffix.current;
            if (addSuffix.current) messageToAnnounce += $050966b7145ef446$var$NON_BREAKING_SPACE;
        }
        setOldMessage(setAlternatePolite.current ? '' : messageToAnnounce);
        setNewMessage(setAlternatePolite.current ? messageToAnnounce : '');
        if (shouldAnnounce) setAlternatePolite.current = !setAlternatePolite.current;
        previousMessage.current = messageToAnnounce;
    }, [
        message,
        shouldAnnounce
    ]);
    // 2 aria-live containers needed to prevent bugs in browsers that will stop
    // announcing updates to the same div if these are too repetitive.
    return /*#__PURE__*/ $euxye.createElement("div", {
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ $euxye.createElement((0, $kSWvv.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, oldMessage), /*#__PURE__*/ $euxye.createElement((0, $kSWvv.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, newMessage));
});
const $050966b7145ef446$var$positionRelative = null;

});
parcelRegister("kSWvv", function(module, exports) {
$parcel$export(module.exports, "visuallyHiddenStyles", () => $f99ac6f5cd0e1858$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $f99ac6f5cd0e1858$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $f99ac6f5cd0e1858$export$200c8e5d652aa9af);
$parcel$export(module.exports, "ScreenReaderLegend", () => $f99ac6f5cd0e1858$export$dabfb48aa98ffd97);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $f99ac6f5cd0e1858$export$8dd524ceb40e3d16 = {
    width: '1px',
    height: '1px',
    padding: 0,
    position: 'absolute',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};
const $f99ac6f5cd0e1858$export$88fad6aa294f111c = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $euxye.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});
const $f99ac6f5cd0e1858$export$200c8e5d652aa9af = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $euxye.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});
const $f99ac6f5cd0e1858$export$dabfb48aa98ffd97 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "legend", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $euxye.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});

});


/* eslint-disable jira/filename-case */ const $b4c27ba6f7293911$export$a3821bc63538b210 = 'customiseSidebar';
const $b4c27ba6f7293911$export$fba7c3adda5094d9 = 'sidebar-nav4';
const $b4c27ba6f7293911$export$3c19576bd92ff564 = 'sidebar-content';

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("ix8t0", function(module, exports) {
$parcel$export(module.exports, "getA11YLabel", () => $b27e142c417f5db8$export$fcb002b66b92bf50);
$parcel$export(module.exports, "getA11YAlert", () => $b27e142c417f5db8$export$45edd6abaa8989eb);
$parcel$export(module.exports, "getNavItemHiddenFromSideBarFlagTitle", () => $b27e142c417f5db8$export$95caae642a80ad);
$parcel$export(module.exports, "getNavItemRestoredFromSideBarFlagTitle", () => $b27e142c417f5db8$export$d4ad18508eb0e1ec);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");

var $6GljB = parcelRequire("6GljB");
const $b27e142c417f5db8$var$hideFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.hide-from-sidebar",
    defaultMessage: "Hide from sidebar"
});
const $b27e142c417f5db8$var$a11YAlertHideDefaultFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-default-from-sidebar",
    defaultMessage: "Menu Item have been hidden from the sidebar"
});
const $b27e142c417f5db8$var$a11YHideAppsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-apps-from-sidebar",
    defaultMessage: "Hide apps from sidebar"
});
const $b27e142c417f5db8$var$a11YAlertHideAppsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-apps-from-sidebar",
    defaultMessage: "Apps have been hidden from the sidebar"
});
const $b27e142c417f5db8$var$a11YHideAssetsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-assets-from-sidebar",
    defaultMessage: "Hide assets from sidebar"
});
const $b27e142c417f5db8$var$a11YAlertHideAssetsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-assets-from-sidebar",
    defaultMessage: "Assets have been hidden from the sidebar"
});
const $b27e142c417f5db8$var$a11YHideDashboardsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-dashboards-from-sidebar",
    defaultMessage: "Hide dashboards from sidebar"
});
const $b27e142c417f5db8$var$a11YAlertHideDashboardsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-dashboards-from-sidebar",
    defaultMessage: "Dashboards have been hidden from the sidebar"
});
const $b27e142c417f5db8$var$a11YHideFiltersFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-filters-from-sidebar",
    defaultMessage: "Hide filters from sidebar"
});
const $b27e142c417f5db8$var$a11YAlertHideFiltersFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-filters-from-sidebar",
    defaultMessage: "Filters have been hidden from the sidebar"
});
const $b27e142c417f5db8$var$a11YHideGoalsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-goals-from-sidebar",
    defaultMessage: "Hide goals from sidebar"
});
const $b27e142c417f5db8$var$a11YAlertHideGoalsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-goals-from-sidebar",
    defaultMessage: "Goals have been hidden from the sidebar"
});
const $b27e142c417f5db8$var$a11YHideOperationsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-operations-from-sidebar",
    defaultMessage: "Hide operations from sidebar"
});
const $b27e142c417f5db8$var$a11YAlertHideOperationsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-operations-from-sidebar",
    defaultMessage: "Operations have been hidden from the sidebar"
});
const $b27e142c417f5db8$var$a11YHidePlansFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-plans-from-sidebar",
    defaultMessage: "Hide plans from sidebar"
});
const $b27e142c417f5db8$var$a11YAlertHidePlansFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-plans-from-sidebar",
    defaultMessage: "Plans have been hidden from the sidebar"
});
const $b27e142c417f5db8$var$a11YHideProjectsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-projects-from-sidebar",
    defaultMessage: "Hide projects from sidebar"
});
const $b27e142c417f5db8$var$a11YAlertHideProjectsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-projects-from-sidebar",
    defaultMessage: "Projects have been hidden from the sidebar"
});
const $b27e142c417f5db8$var$a11YHideTeamsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-teams-from-sidebar",
    defaultMessage: "Hide teams from sidebar"
});
const $b27e142c417f5db8$var$a11YAlertHideTeamsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-teams-from-sidebar",
    defaultMessage: "Teams have been hidden from the sidebar"
});
const $b27e142c417f5db8$var$a11YHideRoadmapsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-roadmaps-from-sidebar",
    defaultMessage: "Hide roadmaps from sidebar"
});
const $b27e142c417f5db8$var$a11YAlertHideRoadmapsFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-roadmaps-from-sidebar",
    defaultMessage: "Roadmaps have been hidden from the sidebar"
});
const $b27e142c417f5db8$var$defaultHiddenFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.default-hidden-from-sidebar",
    defaultMessage: "Hidden from sidebar"
});
const $b27e142c417f5db8$var$appsHiddenFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.apps-hidden-from-sidebar",
    defaultMessage: "Apps hidden from sidebar"
});
const $b27e142c417f5db8$var$assetsHiddenFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.assets-hidden-from-sidebar",
    defaultMessage: "Assets hidden from sidebar"
});
const $b27e142c417f5db8$var$dashboardsHiddenFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.dashboards-hidden-from-sidebar",
    defaultMessage: "Dashboards hidden from sidebar"
});
const $b27e142c417f5db8$var$goalsHiddenFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.goals-hidden-from-sidebar",
    defaultMessage: "Goals hidden from sidebar"
});
const $b27e142c417f5db8$var$operationsHiddenFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.operations-hidden-from-sidebar",
    defaultMessage: "Operations hidden from sidebar"
});
const $b27e142c417f5db8$var$plansHiddenFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.plans-hidden-from-sidebar",
    defaultMessage: "Plans hidden from sidebar"
});
const $b27e142c417f5db8$var$projectsHiddenFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-hidden-from-sidebar",
    defaultMessage: "Projects hidden from sidebar"
});
const $b27e142c417f5db8$var$teamsHiddenFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.teams-hidden-from-sidebar",
    defaultMessage: "Teams hidden from sidebar"
});
const $b27e142c417f5db8$var$roadmapsHiddenFromSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.roadmaps-hidden-from-sidebar",
    defaultMessage: "Roadmaps hidden from sidebar"
});
const $b27e142c417f5db8$var$defaultMovedBackToSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.default-moved-back-to-sidebar",
    defaultMessage: "Moved back to sidebar"
});
const $b27e142c417f5db8$var$appsMovedBackToSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.apps-moved-back-to-sidebar",
    defaultMessage: "Apps moved back to sidebar"
});
const $b27e142c417f5db8$var$assetsMovedBackToSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.assets-moved-back-to-sidebar",
    defaultMessage: "Assets moved back to sidebar"
});
const $b27e142c417f5db8$var$dashboardsMovedBackToSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.dashboards-moved-back-to-sidebar",
    defaultMessage: "Dashboards moved back to sidebar"
});
const $b27e142c417f5db8$var$filtersMovedBackToSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.filters-moved-back-to-sidebar",
    defaultMessage: "Filters moved back to sidebar"
});
const $b27e142c417f5db8$var$goalsMovedBackToSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.goals-moved-back-to-sidebar",
    defaultMessage: "Goals moved back to sidebar"
});
const $b27e142c417f5db8$var$operationsMovedBackToSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.operations-moved-back-to-sidebar",
    defaultMessage: "Operations moved back to sidebar"
});
const $b27e142c417f5db8$var$plansMovedBackToSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.plans-moved-back-to-sidebar",
    defaultMessage: "Plans moved back to sidebar"
});
const $b27e142c417f5db8$var$projectsMovedBackToSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-moved-back-to-sidebar",
    defaultMessage: "Projects moved back to sidebar"
});
const $b27e142c417f5db8$var$teamsMovedBackToSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.teams-moved-back-to-sidebar",
    defaultMessage: "Teams moved back to sidebar"
});
const $b27e142c417f5db8$var$roadmapsMovedBackToSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.roadmaps-moved-back-to-sidebar",
    defaultMessage: "Roadmaps moved back to sidebar"
});
const $b27e142c417f5db8$var$a11YHideProjectsFromSidebarGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-projects-from-sidebar-galaxia",
    defaultMessage: "Hide spaces from sidebar"
});
const $b27e142c417f5db8$var$a11YAlertHideProjectsFromSidebarGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-projects-from-sidebar-galaxia",
    defaultMessage: "Spaces have been hidden from the sidebar"
});
const $b27e142c417f5db8$var$projectsHiddenFromSidebarGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-hidden-from-sidebar-galaxia",
    defaultMessage: "Spaces hidden from sidebar"
});
const $b27e142c417f5db8$var$projectsMovedBackToSidebarGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-moved-back-to-sidebar-galaxia",
    defaultMessage: "Spaces moved back to sidebar"
});
const $b27e142c417f5db8$export$fcb002b66b92bf50 = (menuId)=>{
    const a11YHideProjectsFromSidebarGalaxia = (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $b27e142c417f5db8$var$a11YHideProjectsFromSidebarGalaxiaMessage : $b27e142c417f5db8$var$a11YHideProjectsFromSidebar;
    switch(menuId){
        case (0, $6GljB.L1_MENU_ID).APPS:
            return $b27e142c417f5db8$var$a11YHideAppsFromSidebar;
        case (0, $6GljB.L1_MENU_ID).GOALS:
            return $b27e142c417f5db8$var$a11YHideGoalsFromSidebar;
        case (0, $6GljB.L1_MENU_ID).ROADMAPS:
            return $b27e142c417f5db8$var$a11YHideRoadmapsFromSidebar;
        case (0, $6GljB.L1_MENU_ID).PLANS:
            return $b27e142c417f5db8$var$a11YHidePlansFromSidebar;
        case (0, $6GljB.L1_MENU_ID).PROJECTS:
            return a11YHideProjectsFromSidebarGalaxia;
        case (0, $6GljB.L1_MENU_ID).FILTERS:
            return $b27e142c417f5db8$var$a11YHideFiltersFromSidebar;
        case (0, $6GljB.L1_MENU_ID).DASHBOARDS:
            return $b27e142c417f5db8$var$a11YHideDashboardsFromSidebar;
        case (0, $6GljB.L1_MENU_ID).OPERATIONS:
            return $b27e142c417f5db8$var$a11YHideOperationsFromSidebar;
        case (0, $6GljB.L1_MENU_ID).ASSETS:
            return $b27e142c417f5db8$var$a11YHideAssetsFromSidebar;
        case (0, $6GljB.L1_MENU_ID).TEAMS:
            return $b27e142c417f5db8$var$a11YHideTeamsFromSidebar;
        default:
            return $b27e142c417f5db8$var$hideFromSidebar;
    }
};
const $b27e142c417f5db8$export$45edd6abaa8989eb = (menuId)=>{
    const a11YAlertHideProjectsFromSidebarGalaxia = (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $b27e142c417f5db8$var$a11YAlertHideProjectsFromSidebarGalaxiaMessage : $b27e142c417f5db8$var$a11YAlertHideProjectsFromSidebar;
    switch(menuId){
        case (0, $6GljB.L1_MENU_ID).APPS:
            return $b27e142c417f5db8$var$a11YAlertHideAppsFromSidebar;
        case (0, $6GljB.L1_MENU_ID).GOALS:
            return $b27e142c417f5db8$var$a11YAlertHideGoalsFromSidebar;
        case (0, $6GljB.L1_MENU_ID).ROADMAPS:
            return $b27e142c417f5db8$var$a11YAlertHideRoadmapsFromSidebar;
        case (0, $6GljB.L1_MENU_ID).PLANS:
            return $b27e142c417f5db8$var$a11YAlertHidePlansFromSidebar;
        case (0, $6GljB.L1_MENU_ID).PROJECTS:
            return a11YAlertHideProjectsFromSidebarGalaxia;
        case (0, $6GljB.L1_MENU_ID).FILTERS:
            return $b27e142c417f5db8$var$a11YAlertHideFiltersFromSidebar;
        case (0, $6GljB.L1_MENU_ID).DASHBOARDS:
            return $b27e142c417f5db8$var$a11YAlertHideDashboardsFromSidebar;
        case (0, $6GljB.L1_MENU_ID).OPERATIONS:
            return $b27e142c417f5db8$var$a11YAlertHideOperationsFromSidebar;
        case (0, $6GljB.L1_MENU_ID).ASSETS:
            return $b27e142c417f5db8$var$a11YAlertHideAssetsFromSidebar;
        case (0, $6GljB.L1_MENU_ID).TEAMS:
            return $b27e142c417f5db8$var$a11YAlertHideTeamsFromSidebar;
        default:
            return $b27e142c417f5db8$var$a11YAlertHideDefaultFromSidebar;
    }
};
const $b27e142c417f5db8$export$95caae642a80ad = (menuId)=>{
    const projectsHiddenFromSidebarGalaxia = (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $b27e142c417f5db8$var$projectsHiddenFromSidebarGalaxiaMessage : $b27e142c417f5db8$var$projectsHiddenFromSidebar;
    switch(menuId){
        case (0, $6GljB.L1_MENU_ID).APPS:
            return $b27e142c417f5db8$var$appsHiddenFromSidebar;
        case (0, $6GljB.L1_MENU_ID).GOALS:
            return $b27e142c417f5db8$var$goalsHiddenFromSidebar;
        case (0, $6GljB.L1_MENU_ID).ROADMAPS:
            return $b27e142c417f5db8$var$roadmapsHiddenFromSidebar;
        case (0, $6GljB.L1_MENU_ID).PLANS:
            return $b27e142c417f5db8$var$plansHiddenFromSidebar;
        case (0, $6GljB.L1_MENU_ID).PROJECTS:
            return projectsHiddenFromSidebarGalaxia;
        case (0, $6GljB.L1_MENU_ID).FILTERS:
            return $b27e142c417f5db8$var$filtersMovedBackToSidebar;
        case (0, $6GljB.L1_MENU_ID).DASHBOARDS:
            return $b27e142c417f5db8$var$dashboardsHiddenFromSidebar;
        case (0, $6GljB.L1_MENU_ID).OPERATIONS:
            return $b27e142c417f5db8$var$operationsHiddenFromSidebar;
        case (0, $6GljB.L1_MENU_ID).ASSETS:
            return $b27e142c417f5db8$var$assetsHiddenFromSidebar;
        case (0, $6GljB.L1_MENU_ID).TEAMS:
            return $b27e142c417f5db8$var$teamsHiddenFromSidebar;
        default:
            return $b27e142c417f5db8$var$defaultHiddenFromSidebar;
    }
};
const $b27e142c417f5db8$export$d4ad18508eb0e1ec = (menuId)=>{
    const projectsMovedBackToSidebarGalaxia = (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $b27e142c417f5db8$var$projectsMovedBackToSidebarGalaxiaMessage : $b27e142c417f5db8$var$projectsMovedBackToSidebar;
    switch(menuId){
        case (0, $6GljB.L1_MENU_ID).APPS:
            return $b27e142c417f5db8$var$appsMovedBackToSidebar;
        case (0, $6GljB.L1_MENU_ID).GOALS:
            return $b27e142c417f5db8$var$goalsMovedBackToSidebar;
        case (0, $6GljB.L1_MENU_ID).ROADMAPS:
            return $b27e142c417f5db8$var$roadmapsMovedBackToSidebar;
        case (0, $6GljB.L1_MENU_ID).PLANS:
            return $b27e142c417f5db8$var$plansMovedBackToSidebar;
        case (0, $6GljB.L1_MENU_ID).PROJECTS:
            return projectsMovedBackToSidebarGalaxia;
        case (0, $6GljB.L1_MENU_ID).FILTERS:
            return $b27e142c417f5db8$var$filtersMovedBackToSidebar;
        case (0, $6GljB.L1_MENU_ID).DASHBOARDS:
            return $b27e142c417f5db8$var$dashboardsMovedBackToSidebar;
        case (0, $6GljB.L1_MENU_ID).OPERATIONS:
            return $b27e142c417f5db8$var$operationsMovedBackToSidebar;
        case (0, $6GljB.L1_MENU_ID).ASSETS:
            return $b27e142c417f5db8$var$assetsMovedBackToSidebar;
        case (0, $6GljB.L1_MENU_ID).TEAMS:
            return $b27e142c417f5db8$var$teamsMovedBackToSidebar;
        default:
            return $b27e142c417f5db8$var$defaultMovedBackToSidebar;
    }
};

});


parcelRegister("gbTMi", function(module, exports) {
$parcel$export(module.exports, "MoreNavMenuButton", () => $048ceac544389c31$export$df3f5812ef8777cb);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gNzvf = parcelRequire("gNzvf");

var $5F8FY = parcelRequire("5F8FY");

var $b1JP5 = parcelRequire("b1JP5");

var $75DFw = parcelRequire("75DFw");
const $048ceac544389c31$export$df3f5812ef8777cb = /*#__PURE__*/ (0, $euxye.memo)(({ MenuItems: MenuItems, name: name, onOpen: onOpen, onClose: onCloseFlyout })=>{
    const { isOpen: isOpen, onClose: onCloseDropdown, onToggle: onToggle } = (0, $5F8FY.useOpenable)();
    const content = (0, $euxye.useCallback)((contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b1JP5.MoreNavMenuButtonSubmenu), {
            ...contentProps,
            MenuItems: MenuItems
        }), [
        MenuItems
    ]);
    const onClose = (0, $euxye.useCallback)((e)=>{
        try {
            onCloseFlyout?.(e);
        } finally{
            onCloseDropdown();
        }
    }, [
        onCloseFlyout,
        onCloseDropdown
    ]);
    const onTriggerClick = (0, $euxye.useCallback)(()=>{
        try {
            if (!isOpen) onOpen?.();
        } finally{
            onToggle();
        }
    }, [
        isOpen,
        onOpen,
        onToggle
    ]);
    const trigger = (0, $euxye.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $75DFw.MoreNavMenuButtonTrigger), {
            ...triggerProps,
            name: name,
            onClick: onTriggerClick,
            isSelected: isOpen,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "navigation-apps-sidebar-nav4-sidebars-common-core.ui.more-nav-menu-button.more-nav-menu-button-trigger"
        }), [
        isOpen,
        name,
        onTriggerClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNzvf.JiraPopup), {
        content: content,
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: "navigation-apps-sidebar-nav4-sidebars-common-core.ui.more-nav-menu-button.popup",
        messageType: "transactional",
        trigger: trigger,
        shouldRenderToParent: true
    });
});

});
parcelRegister("5F8FY", function(module, exports) {
$parcel$export(module.exports, "useOpenable", () => $64c52c2c3d9317ff$export$e07f550759260fd7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
const $64c52c2c3d9317ff$export$e07f550759260fd7 = (initialState = false)=>{
    const [isOpen, setIsOpen] = (0, $euxye.useState)(initialState);
    const onClose = (0, $euxye.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onOpen = (0, $euxye.useCallback)(()=>setIsOpen(true), [
        setIsOpen
    ]);
    const onToggle = (0, $euxye.useCallback)(()=>setIsOpen((value)=>!value), [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        onOpen: onOpen,
        onToggle: onToggle,
        setIsOpen: setIsOpen
    };
};

});

parcelRegister("b1JP5", function(module, exports) {
$parcel$export(module.exports, "MoreNavMenuButtonSubmenu", () => $2856e010e024be39$export$ac88f3e136748c4a);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");


var $72ldR = parcelRequire("72ldR");

var $ihEDU = parcelRequire("ihEDU");
const $2856e010e024be39$var$stopEventPropagation = (event)=>event.stopPropagation();
const $2856e010e024be39$export$ac88f3e136748c4a = ({ MenuItems: MenuItems, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        onMouseEnter: $2856e010e024be39$var$stopEventPropagation,
        onMouseLeave: $2856e010e024be39$var$stopEventPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), {
        minWidth: (0, $47916ea360432737$export$9c07662d9724277)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(MenuItems, {
        onClose: onClose
    })));
$2856e010e024be39$export$ac88f3e136748c4a.displayName = "MoreNavMenuButtonSubmenu";

});
const $47916ea360432737$export$9c07662d9724277 = 250;


parcelRegister("75DFw", function(module, exports) {
$parcel$export(module.exports, "MoreNavMenuButtonTrigger", () => $976bef20d573ec8b$export$c1fd214ac7085e79);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $7Fzpe = parcelRequire("7Fzpe");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $eO8S8 = parcelRequire("eO8S8");
const $976bef20d573ec8b$var$moreActions = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "More actions"
});
const $976bef20d573ec8b$var$moreActionsFor = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions-for",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "More actions for {name}"
});
const $976bef20d573ec8b$export$c1fd214ac7085e79 = /*#__PURE__*/ (0, $euxye.forwardRef)(// @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
({ name: name, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eO8S8.CommonNavMenuButton), {
        ...props,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Fzpe))), {
                ...iconProps,
                size: "small"
            }),
        label: name ? formatMessage($976bef20d573ec8b$var$moreActionsFor, {
            name: name
        }) : formatMessage($976bef20d573ec8b$var$moreActions),
        ref: ref,
        isTooltipDisabled: false,
        tooltip: {
            content: formatMessage($976bef20d573ec8b$var$moreActions),
            hideTooltipOnClick: true
        },
        interactionName: "nav4-sidebar-more-actions-button"
    });
});

});
parcelRegister("eO8S8", function(module, exports) {
$parcel$export(module.exports, "CommonNavMenuButton", () => $ae41020850b997ea$export$358f21998d56a71e);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");
const $ae41020850b997ea$export$358f21998d56a71e = /*#__PURE__*/ (0, $euxye.forwardRef)(({ onClick: onClick, icon: icon, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
        ...props,
        icon: icon,
        onClick: onClick,
        ref: ref,
        spacing: "compact",
        appearance: "subtle"
    });
});

});



parcelRegister("lI0cf", function(module, exports) {
$parcel$export(module.exports, "getEmceeDiscoverLink", () => $a49b804cf9bce28a$export$f26dabf284aefb17);
$parcel$export(module.exports, "getEmceeAppListingLink", () => $a49b804cf9bce28a$export$eb09695b9e9f6a3);
$parcel$export(module.exports, "getAppRequestsLink", () => $a49b804cf9bce28a$export$7ab8c48f9081e976);
$parcel$export(module.exports, "getManagePromotionsLink", () => $a49b804cf9bce28a$export$350ca33eed6a2742);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $a49b804cf9bce28a$var$sanitiseParams = (params)=>params ? Object.entries(params).reduce((res, [key, value])=>{
        if (value) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'EmceeQueryParams | JiraQueryParams'.
        res[key] = params[key];
        return res;
    }, {}) : {};
const $a49b804cf9bce28a$var$addQueryParamsToLink = (params, link)=>{
    // @ts-expect-error - TS2345 - Argument of type 'EmceeQueryParams | JiraQueryParams | null | undefined' is not assignable to parameter of type 'EmceeQueryParams | JiraQueryParams | undefined'.
    const queryParams = $a49b804cf9bce28a$var$sanitiseParams(params);
    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `${link}?${queryString}` : link;
};
const $a49b804cf9bce28a$export$f26dabf284aefb17 = (params)=>{
    const link = '/jira/marketplace/discover';
    return $a49b804cf9bce28a$var$addQueryParamsToLink(params, link);
};
const $a49b804cf9bce28a$export$eb09695b9e9f6a3 = (appKey, params, jiraQueryParams)=>$a49b804cf9bce28a$var$addQueryParamsToLink({
        ...jiraQueryParams,
        ...params
    }, `/jira/marketplace/discover/app/${appKey}`);
const $a49b804cf9bce28a$export$7ab8c48f9081e976 = (params)=>{
    const link = '/jira/marketplace/manage/app-requests';
    return $a49b804cf9bce28a$var$addQueryParamsToLink(params, link);
};
const $a49b804cf9bce28a$export$350ca33eed6a2742 = (params)=>{
    const link = '/jira/marketplace/manage/promotions';
    return $a49b804cf9bce28a$var$addQueryParamsToLink(params, link);
};

});

parcelRegister("kHMXB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::36b5d9e0c1cf0bb09f391b32453a197f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f12dcd5274151988$var$_react = $f12dcd5274151988$var$_interopRequireDefault((parcelRequire("euxye")));

var $f12dcd5274151988$var$_baseNew = $f12dcd5274151988$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $f12dcd5274151988$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "App".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/app
 * Usage guidance:
 * Single purpose - Reserved for marketplace apps and integrations across apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f12dcd5274151988$var$AppIcon = (props)=>/*#__PURE__*/ $f12dcd5274151988$var$_react.default.createElement($f12dcd5274151988$var$_baseNew.default, Object.assign({
        name: "AppIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 5.208a.5.5 0 0 0-.243-.429l-5-3a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.43v5.583a.5.5 0 0 0 .243.429l5 3a.5.5 0 0 0 .514 0l5-3a.5.5 0 0 0 .243-.429zm1.5 5.584a2 2 0 0 1-.97 1.715l-5 3a2 2 0 0 1-2.06 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .97-1.715l5-3a2 2 0 0 1 2.06 0l5 3A2 2 0 0 1 15 5.208z"/><path fill="currentcolor" d="M9.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>`
    }, props));
$f12dcd5274151988$var$AppIcon.displayName = 'AppIcon';
var $f12dcd5274151988$var$_default = module.exports.default = $f12dcd5274151988$var$AppIcon;

});


parcelRegister("dcF7c", function(module, exports) {
$parcel$export(module.exports, "useIsGlobalConnectAppRoute", () => $8b5a340f1df73154$export$32897ea1251cd6aa);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $21iIq = parcelRequire("21iIq");

var $cn1qc = parcelRequire("cn1qc");

var $hGQgp = parcelRequire("hGQgp");

var $fY8bV = parcelRequire("fY8bV");

var $2CuPf = parcelRequire("2CuPf");
const $8b5a340f1df73154$export$32897ea1251cd6aa = ({ data: data })=>{
    const location = (0, $cn1qc.useLocation)();
    const query = (0, $hGQgp.useQuery)();
    const locations = (0, $euxye.useMemo)(()=>(data?.globalAppNavigationItems?.edges || []).filter((edge)=>edge?.node?.appType === 'CONNECT').flatMap((edge)=>(edge?.node && (0, $2CuPf.canHaveSubpages)(edge?.node) && edge?.node?.sections || [
                {
                    links: [
                        {
                            url: edge?.node?.url
                        }
                    ]
                }
            ]).flatMap((section)=>(section?.links || []).map((link)=>(0, (/*@__PURE__*/$parcel$interopDefault($21iIq)))(link?.url || '/', true)))), [
        data
    ]);
    return (0, $euxye.useMemo)(()=>{
        const matcher = (0, $fY8bV.matchUrlExact)();
        const currentLocation = {
            ...location,
            query: query
        };
        // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
        return locations.some((loc)=>matcher(currentLocation, loc));
    }, [
        locations,
        location,
        query
    ]);
};

});
parcelRegister("hGQgp", function(module, exports) {
$parcel$export(module.exports, "useQuery", () => $c8218f356659a781$export$dd0a697e1782aedd);

var $f2wVS = parcelRequire("f2wVS");
const $c8218f356659a781$export$dd0a697e1782aedd = (0, $f2wVS.createRouterSelector)((state)=>state.query);

});

parcelRegister("fY8bV", function(module, exports) {
$parcel$export(module.exports, "matchPathname", () => $320938367c4219c1$export$b71b01274a8bb9ec);
$parcel$export(module.exports, "matchPartialUrlPathname", () => $320938367c4219c1$export$9870a2fa97808ed7);
$parcel$export(module.exports, "matchUrlExact", () => $320938367c4219c1$export$422d2a799c6e30b8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $de6m4 = parcelRequire("de6m4");
// Jira url paths are messy, so we have to try to clean them to avoid missing matches
// - pages urls sometimes have /secure, sometimes they don't
// - jspa pages urls sometimes have !action, sometimes they don't
const $320938367c4219c1$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
const $320938367c4219c1$export$b71b01274a8bb9ec = (currentUrlPath, itemUrlPath)=>$320938367c4219c1$var$cleanPath(currentUrlPath) === $320938367c4219c1$var$cleanPath(itemUrlPath);
const $320938367c4219c1$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$320938367c4219c1$export$b71b01274a8bb9ec(currentLocation.pathname, itemLocation.pathname);
const $320938367c4219c1$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
const $320938367c4219c1$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$320938367c4219c1$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, (/*@__PURE__*/$parcel$interopDefault($de6m4)))(currentLocation.query, itemLocation.query);
const $320938367c4219c1$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $320938367c4219c1$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);

});

parcelRegister("2CuPf", function(module, exports) {
$parcel$export(module.exports, "canHaveSubpages", () => $8855c9abccc1ffb3$export$352a285d5cb56873);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * The magic is copied from jira/src/packages/navigation-apps/sidebar/connect/src/common/utils/find-item-stack/index.tsx
 * No clue what that `s` query param stands for, just keeping the link comparison logic 1:1 to avoid regressions.
 */ 
var $bxhpq = parcelRequire("bxhpq");
// JSPA-1062 remove qs items that might not always be there
const $8855c9abccc1ffb3$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $8855c9abccc1ffb3$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $8855c9abccc1ffb3$var$parseUrl = (url = '')=>{
    const [pathname, qs = ''] = url.split('#')[0].split('?');
    return {
        pathname: pathname,
        query: $8855c9abccc1ffb3$var$splitRelevantQs(qs)
    };
};
function $8855c9abccc1ffb3$export$352a285d5cb56873(data) {
    const sections = data.sections || [];
    const { pathname: rootPagePathname, query: rootPageQuery } = $8855c9abccc1ffb3$var$parseUrl(data.url || '');
    for (const section of sections){
        if ((section?.links || []).some((link)=>{
            const { pathname: pathname, query: query } = $8855c9abccc1ffb3$var$parseUrl(link?.url || '');
            return rootPagePathname === pathname && $8855c9abccc1ffb3$var$isSameQuery(rootPageQuery, query);
        })) return true;
    }
    return false;
}

});


parcelRegister("i8bC9", function(module, exports) {
$parcel$export(module.exports, "Nav4AppsDefault", () => $ec41b7de9b26667c$export$3732a771b6ecd66d);

var $euxye = parcelRequire("euxye");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");


var $bOwox = parcelRequire("bOwox");

var $5IkoH = parcelRequire("5IkoH");

var $ggvFe = parcelRequire("ggvFe");

var $6GljB = parcelRequire("6GljB");

var $4VtOS = parcelRequire("4VtOS");

var $gEDfa = parcelRequire("gEDfa");

var $jzXAj = parcelRequire("jzXAj");

var $dx7aH = parcelRequire("dx7aH");

var $hDvet = parcelRequire("hDvet");

var $jepRN = parcelRequire("jepRN");

var $kFgCO = parcelRequire("kFgCO");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $kt86l = parcelRequire("kt86l");

var $fFNvS = parcelRequire("fFNvS");

var $2700E = parcelRequire("2700E");

var $h3LJR = parcelRequire("h3LJR");

var $lEazp = parcelRequire("lEazp");


var $iZS3n = parcelRequire("iZS3n");

var $44vv6 = parcelRequire("44vv6");
const $ec41b7de9b26667c$export$3732a771b6ecd66d = (0, $jepRN.componentWithFG)('navx-global-side-nav', $ec41b7de9b26667c$var$Nav4AppsDefaultGSN, $ec41b7de9b26667c$var$Nav4AppsDefaultNav4);
function $ec41b7de9b26667c$var$Nav4AppsDefaultGSN(props) {
    const { actionsOnHover: actionsOnHover, draggableRef: draggableRef, dropIndicator: dropIndicator, hasDragIndicator: hasDragIndicator, isDragging: isDragging, simulateLoading: simulateLoading = false, isExpanded: isExpanded = simulateLoading, onExpandFlyoutToggle: onExpandFlyoutToggle, visualContentRef: visualContentRef } = props;
    const cloudId = (0, $kt86l.useCloudId)();
    let accountId;
    let activationId;
    if ((0, $2700E.expVal)('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) {
        const { data: { user: { accountId: accountIdFromUser } } } = (0, $kFgCO.useCurrentUser)();
        // oxlint-disable-next-line react-hooks/rules-of-hooks
        activationId = (0, $h3LJR.useActivationId)();
        accountId = accountIdFromUser || undefined;
    }
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            accountId: accountId,
            activationId: activationId
        }), [
        cloudId,
        accountId,
        activationId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $44vv6.asyncNav4AppsContentViewQuery), entryPointParams);
    const triggerRef = (0, $hDvet.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).APPS);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $euxye.useContext)((0, $ggvFe.NavItemsContext));
    const getAttributes = (0, $euxye.useCallback)((error)=>(0, $iZS3n.createAttributes)({
            error: error,
            component: 'Nav4AppsDefault'
        }), []);
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $euxye.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    const menuId = (0, $5IkoH.MENU_ID_APPS);
    const handleExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $6GljB.L1_MENU_ID).APPS);
            (0, $aJ81Y.fireUIAnalytics)(event, (0, $bOwox.SECTION_ITEM_APPS), {
                isInMore: isInMore
            });
        }
        onExpandFlyoutToggle?.(hasExpanded);
    }, [
        createAnalyticsEvent,
        entryPointActions,
        moreMenuIds,
        onExpandFlyoutToggle
    ]);
    const handleSystemToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        dropTargetRef: visualContentRef,
        dropIndicator: dropIndicator,
        isDragging: isDragging,
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: handleExpansionToggle,
        onSystemToggle: handleSystemToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        hasDragIndicator: hasDragIndicator,
        interactionName: "nav4-sidebar-apps-default",
        isDragging: isDragging,
        ref: draggableRef ? (0, $fFNvS.mergeRefs)(triggerRef, draggableRef) : triggerRef,
        testId: (0, $jzXAj.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-apps-default",
        errorAttributes: getAttributes,
        packageName: (0, $2bb20df175b75b35$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $2bb20df175b75b35$export$d57b6b390e78d90f),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lEazp.ExploreMoreApps), null)));
}
$ec41b7de9b26667c$var$Nav4AppsDefaultGSN.displayName = "Nav4AppsDefaultGSN";
function $ec41b7de9b26667c$var$Nav4AppsDefaultNav4(props) {
    const { actionsOnHover: actionsOnHover, simulateLoading: simulateLoading = false, isExpanded: isExpanded = simulateLoading } = props;
    const cloudId = (0, $kt86l.useCloudId)();
    let accountId;
    let activationId;
    if ((0, $2700E.expVal)('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) {
        const { data: { user: { accountId: accountIdFromUser } } } = (0, $kFgCO.useCurrentUser)();
        // oxlint-disable-next-line react-hooks/rules-of-hooks
        activationId = (0, $h3LJR.useActivationId)();
        accountId = accountIdFromUser || undefined;
    }
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            accountId: accountId,
            activationId: activationId
        }), [
        cloudId,
        accountId,
        activationId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $44vv6.asyncNav4AppsContentViewQuery), entryPointParams);
    const triggerRef = (0, $hDvet.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).APPS);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $euxye.useContext)((0, $ggvFe.NavItemsContext));
    const getAttributes = (0, $euxye.useCallback)((error)=>(0, $iZS3n.createAttributes)({
            error: error,
            component: 'Nav4AppsDefault'
        }), []);
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $euxye.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    const menuId = (0, $5IkoH.MENU_ID_APPS);
    const onSystemToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const onExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $6GljB.L1_MENU_ID).APPS);
            (0, $aJ81Y.fireUIAnalytics)(event, (0, $bOwox.SECTION_ITEM_APPS), {
                isInMore: isInMore
            });
        }
    }, [
        createAnalyticsEvent,
        entryPointActions,
        moreMenuIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: onSystemToggle,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-apps-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $jzXAj.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-apps-default",
        errorAttributes: getAttributes,
        packageName: (0, $2bb20df175b75b35$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $2bb20df175b75b35$export$d57b6b390e78d90f),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lEazp.ExploreMoreApps), null)));
}
$ec41b7de9b26667c$var$Nav4AppsDefaultNav4.displayName = "Nav4AppsDefaultNav4";

});
parcelRegister("4VtOS", function(module, exports) {
$parcel$export(module.exports, "Nav4ExpandableMenuItem", () => $05954725a8293790$export$3c0db18b09c9af3e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $aJDWs = parcelRequire("aJDWs");

var $19zz3 = parcelRequire("19zz3");

var $1lRyZ = parcelRequire("1lRyZ");

var $hQxjT = parcelRequire("hQxjT");

var $fFNvS = parcelRequire("fFNvS");
const $05954725a8293790$export$3c0db18b09c9af3e = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)($05954725a8293790$var$Nav4ExpandableMenuItemView));
function $05954725a8293790$var$Nav4ExpandableMenuItemView(props, ref) {
    const { isSelectedPath: isSelectedPath, isInitialSelectedPath: isInitialSelectedPath } = (0, $19zz3.useSidebarNav4)();
    const { isControlledNav: isControlledNav, isControlledPath: isControlledPath } = (0, $1lRyZ.useSidebarNav4Controller)();
    const { children: children, isExpanded: isExpanded = false, expandedRef: expandedRef, collapsedRef: collapsedRef, dropIndicator: dropIndicator = null, dropTargetRef: dropTargetRef = null, isDragging: isDragging = false, menuId: menuId, onExpansionToggle: onExpansionToggle, onSystemToggle: onSystemToggle } = props;
    // controlled state, `isActuallyExpanded` decides whether the component is expanded or not (based on logic in this component and props.isExpanded)
    const [isActuallyExpanded, setActuallyExpanded] = (0, $euxye.useState)(isInitialSelectedPath(menuId) || isExpanded);
    const userCollapsedRef = (0, $euxye.useRef)(false);
    // By default, the expandable component is closed. When we want it to be initially open, we also need to trigger onExpansionToggle().
    (0, $euxye.useEffect)(()=>{
        if (isActuallyExpanded === true && isExpanded === false) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-live-state-to-parent
        onSystemToggle?.(isActuallyExpanded);
    // We want to run this only once, on init.
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If isSelectedPath changes (external change), update our internal state.
    (0, $euxye.useEffect)(()=>{
        // Skip auto-expand if user just manually collapsed this menu
        if (userCollapsedRef.current && (0, $aJDWs.isProjectsInJiraM2Enabled)()) {
            userCollapsedRef.current = false;
            return;
        }
        // Fyi, the following logic causes the component to _collapse_ when the selectedPath changes (preserved here for posterity):
        //   const localIsExpanded = isSelectedPath(menuId);
        // ...but this logic _keeps the component expanded_ (if it is) when the selectedPath changes. We can only auto-expand component, not auto-collapse it though (which is fine, for current UX):
        const localIsExpanded = isSelectedPath(menuId) || isActuallyExpanded;
        // Trigger the callbacks ONLY when the previous state doesn't match the new state.
        if (localIsExpanded !== isActuallyExpanded) {
            setActuallyExpanded(localIsExpanded);
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onSystemToggle?.(localIsExpanded);
        }
    // We only want to run this when isSelectedPath() changes, not when isActuallyExpanded changes.
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSelectedPath
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    (0, $euxye.useEffect)(()=>{
        if (!isControlledNav) return;
        // Skip auto-expand if user just manually collapsed this menu
        if (userCollapsedRef.current && (0, $aJDWs.isProjectsInJiraM2Enabled)()) {
            userCollapsedRef.current = false;
            return;
        }
        const localIsExpanded = isControlledPath(menuId);
        if (localIsExpanded !== isActuallyExpanded) {
            setActuallyExpanded(localIsExpanded);
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onSystemToggle?.(localIsExpanded);
        }
    // We only want to run this when isControlledPath() changes, not when isActuallyExpanded changes.
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isControlledPath
    ]);
    const expandableMenuItemRef = (0, $euxye.useMemo)(()=>{
        if (isActuallyExpanded) return expandedRef ?? ref;
        return collapsedRef ?? ref;
    }, [
        collapsedRef,
        expandedRef,
        isActuallyExpanded,
        ref
    ]);
    const onExpandableMenuItemToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        setActuallyExpanded(hasExpanded);
        onExpansionToggle?.(hasExpanded);
        // Track manual collapse to prevent auto-expand flicker on subsequent path changes
        // When user deliberately collapses, we skip one cycle of auto-expand
        if (!hasExpanded && (0, $aJDWs.isProjectsInJiraM2Enabled)()) userCollapsedRef.current = true;
    }, [
        onExpansionToggle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hQxjT.ExpandableMenuItem), {
        dropIndicator: dropIndicator,
        isExpanded: isActuallyExpanded && !isDragging,
        onExpansionToggle: onExpandableMenuItemToggle,
        ref: (0, $fFNvS.mergeRefs)(expandableMenuItemRef, dropTargetRef)
    }, children);
}
$05954725a8293790$var$Nav4ExpandableMenuItemView.displayName = "Nav4ExpandableMenuItemView";

});
parcelRegister("fFNvS", function(module, exports) {
$parcel$export(module.exports, "mergeRefs", () => $9f8c68ec1198f126$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $9f8c68ec1198f126$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
function $9f8c68ec1198f126$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // oxlint-disable-next-line typescript/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $9f8c68ec1198f126$export$2e2bcd8739ae039(...refs) {
    return (0, $euxye.useMemo)(()=>$9f8c68ec1198f126$export$c9058316764c140e(...refs), // oxlint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});


parcelRegister("gEDfa", function(module, exports) {
$parcel$export(module.exports, "SkeletonNavMenuItems", () => $248ea302557a129a$export$c3a3a246584433d7);
/* main.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $ggSJq = parcelRequire("ggSJq");

var $ar9gx = parcelRequire("ar9gx");

var $2D2gW = parcelRequire("2D2gW");

var $ihEDU = parcelRequire("ihEDU");

var $2XXtG = parcelRequire("2XXtG");
const $248ea302557a129a$var$styles = {
    flyoutWrapper: "_c71lr5sb _ca0q1b66 _n3td1b66 _19bv1b66 _u5f31b66",
    menuWrapper: "_ca0q1b66 _n3td1b66 _19bv1b66",
    projectAvatar: "_2rko12b0 _bfhkizff _1bsb1tcg _4t3i1tcg",
    flyoutMenuItem: "_2rko12b0 _bfhkizff _4t3izwfg _1bsb1osq _19pk12x7 _otyr12x7",
    menuItem: "_2rko12b0 _bfhkizff _4t3i1tcg _1bsb1osq",
    flyoutHeading: "_2rko12b0 _bfhkizff _4t3i7vkz _1bsbckbl _19pku2gc _otyrutpp",
    menuHeading: "_2rko12b0 _bfhkizff _4t3i7vkz _1bsbckbl _18u01b66 _19pku2gc _otyru2gc",
    bigSearch: "_2rko12b0 _4t3i14no _bfhkizff _1bsb1osq _19pk1b66 _otyrutpp _2hwx12x7",
    search: "_2rko12b0 _bfhkizff _4t3izwfg _1bsb1osq _19pk1b66 _otyrutpp _2hwx12x7",
    overflowingSection: "_18m91wug"
};
const $248ea302557a129a$var$ItemHeading = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $248ea302557a129a$var$styles.menuHeading
    });
$248ea302557a129a$var$ItemHeading.displayName = "ItemHeading";
const $248ea302557a129a$var$FlyoutHeading = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $248ea302557a129a$var$styles.flyoutHeading
    });
$248ea302557a129a$var$FlyoutHeading.displayName = "FlyoutHeading";
const $248ea302557a129a$export$36e4ba43c9afd7b0 = ({ withSubTitle: withSubTitle = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), {
        gap: "space.050",
        alignItems: "center",
        justifyContent: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $248ea302557a129a$var$styles.projectAvatar
    }), withSubTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $248ea302557a129a$var$styles.flyoutMenuItem
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $248ea302557a129a$var$styles.menuItem
    }));
$248ea302557a129a$export$36e4ba43c9afd7b0.displayName = "ItemWithIcon";
const $248ea302557a129a$var$L2MenuItemSectionSkeleton = ({ withHeading: withHeading, count: count = 5 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, withHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($248ea302557a129a$var$ItemHeading, null), (0, (/*@__PURE__*/$parcel$interopDefault($ggSJq)))(0, count).map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
            xcss: $248ea302557a129a$var$styles.menuWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($248ea302557a129a$export$36e4ba43c9afd7b0, null)))));
};
$248ea302557a129a$var$L2MenuItemSectionSkeleton.displayName = "L2MenuItemSectionSkeleton";
const $248ea302557a129a$var$Search = ({ isBig: isBig })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: isBig ? $248ea302557a129a$var$styles.bigSearch : $248ea302557a129a$var$styles.search
    });
$248ea302557a129a$var$Search.displayName = "Search";
const $248ea302557a129a$var$FlyoutSkeleton = ({ withHeading: withHeading, count: count = 5, withSearch: withSearch = false, withSubTitle: withSubTitle = false, withSubHeading: withSubHeading = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $248ea302557a129a$var$styles.flyoutWrapper
    }, withHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($248ea302557a129a$var$FlyoutHeading, null), withSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($248ea302557a129a$var$Search, {
        isBig: withSubTitle
    }), withSubHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($248ea302557a129a$var$FlyoutHeading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), {
        xcss: $248ea302557a129a$var$styles.overflowingSection,
        gap: withSubTitle ? 'space.050' : 'space.100',
        direction: "column",
        justifyContent: "start"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggSJq)))(0, count).map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($248ea302557a129a$export$36e4ba43c9afd7b0, {
            key: index,
            withSubTitle: withSubTitle
        }))));
};
$248ea302557a129a$var$FlyoutSkeleton.displayName = "FlyoutSkeleton";
const $248ea302557a129a$var$FancySkeleton = ({ count: count = 5, withHeading: withHeading, isFlyout: isFlyout, withSearch: withSearch, withSubTitle: withSubTitle, withSubHeading: withSubHeading })=>isFlyout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($248ea302557a129a$var$FlyoutSkeleton, {
        withHeading: withHeading,
        count: count,
        withSearch: withSearch,
        withSubTitle: withSubTitle,
        withSubHeading: withSubHeading
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($248ea302557a129a$var$L2MenuItemSectionSkeleton, {
        withHeading: withHeading,
        count: count
    });
$248ea302557a129a$var$FancySkeleton.displayName = "FancySkeleton";
const $248ea302557a129a$export$c3a3a246584433d7 = ({ count: count = 5, withHeading: withHeading, isFlyout: isFlyout, withSearch: withSearch, withSubTitle: withSubTitle, withSubHeading: withSubHeading })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
        name: "nav4-sidebar-menu-items-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($248ea302557a129a$var$FancySkeleton, {
        count: count,
        withHeading: withHeading,
        isFlyout: isFlyout,
        withSearch: withSearch,
        withSubTitle: withSubTitle,
        withSubHeading: withSubHeading
    }));
$248ea302557a129a$export$c3a3a246584433d7.displayName = "SkeletonNavMenuItems";

});
parcelRegister("ggSJq", function(module, exports) {

var $7Jsep = parcelRequire("7Jsep");

var $bd88988923232efe$var$func = $7Jsep('range', (parcelRequire("lzkcn")));

$bd88988923232efe$var$func.placeholder = (parcelRequire("gckmj"));
module.exports = $bd88988923232efe$var$func;

});
parcelRegister("7Jsep", function(module, exports) {

var $fjwH5 = parcelRequire("fjwH5");

var $pxG0E = parcelRequire("pxG0E");
/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $5a12a28f06c9cf84$var$convert(name, func, options) {
    return $fjwH5($pxG0E, name, func, options);
}
module.exports = $5a12a28f06c9cf84$var$convert;

});
parcelRegister("fjwH5", function(module, exports) {

var $dnHoh = parcelRequire("dnHoh");

var $gckmj = parcelRequire("gckmj");
/** Built-in value reference. */ var $02e08c59b45282a3$var$push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function $02e08c59b45282a3$var$baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function $02e08c59b45282a3$var$baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function $02e08c59b45282a3$var$cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function $02e08c59b45282a3$var$createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function $02e08c59b45282a3$var$flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) $02e08c59b45282a3$var$push.apply(otherArgs, array);
        if (start != lastIndex) $02e08c59b45282a3$var$push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function $02e08c59b45282a3$var$wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $02e08c59b45282a3$var$baseConvert(util, name, func, options) {
    var isLib = typeof name == 'function', isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        'cap': 'cap' in options ? options.cap : true,
        'curry': 'curry' in options ? options.curry : true,
        'fixed': 'fixed' in options ? options.fixed : true,
        'immutable': 'immutable' in options ? options.immutable : true,
        'rearg': 'rearg' in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : $gckmj, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        'ary': util.ary,
        'assign': util.assign,
        'clone': util.clone,
        'curry': util.curry,
        'forEach': util.forEach,
        'isArray': util.isArray,
        'isError': util.isError,
        'isFunction': util.isFunction,
        'isWeakMap': util.isWeakMap,
        'iteratee': util.iteratee,
        'keys': util.keys,
        'rearg': util.rearg,
        'toInteger': util.toInteger,
        'toPath': util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys($dnHoh.aryMethod);
    var wrappers = {
        'castArray': function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray($02e08c59b45282a3$var$cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        'iteratee': function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == 'number') {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : $02e08c59b45282a3$var$baseAry(result, arity);
                }
                return result;
            };
        },
        'mixin': function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        'nthArg': function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        'rearg': function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        'runInContext': function(runInContext) {
            return function(context) {
                return $02e08c59b45282a3$var$baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = $dnHoh.iterateeRearg[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && $dnHoh.iterateeAry[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !$dnHoh.skipFixed[name])) {
            var data = $dnHoh.methodSpread[name], start = data && data.start;
            return start === undefined ? ary(func, n) : $02e08c59b45282a3$var$flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !$dnHoh.skipRearg[name]) ? rearg(func, $dnHoh.methodRearg[name] || $dnHoh.aryRearg[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = $dnHoh.aliasToReal[name] || name, methodName = $dnHoh.remap[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return $02e08c59b45282a3$var$baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == 'function' ? $02e08c59b45282a3$var$baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return $02e08c59b45282a3$var$baseArity(rearg($02e08c59b45282a3$var$baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = $dnHoh.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if ($dnHoh.mutate.array[realName]) wrapped = $02e08c59b45282a3$var$wrapImmutable(func, $02e08c59b45282a3$var$cloneArray);
            else if ($dnHoh.mutate.object[realName]) wrapped = $02e08c59b45282a3$var$wrapImmutable(func, $02e08c59b45282a3$var$createCloner(func));
            else if ($dnHoh.mutate.set[realName]) wrapped = $02e08c59b45282a3$var$wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each($dnHoh.aryMethod[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = $dnHoh.methodSpread[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each($dnHoh.aryMethod[aryKey], function(key) {
            var func = _[$dnHoh.remap[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == 'function') {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each($dnHoh.realToAlias[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
module.exports = $02e08c59b45282a3$var$baseConvert;

});
parcelRegister("dnHoh", function(module, exports) {
$parcel$export(module.exports, "aliasToReal", () => $9bdf14cdb5bfcb1d$export$bd0f5e6e44efa6b4, (v) => $9bdf14cdb5bfcb1d$export$bd0f5e6e44efa6b4 = v);
$parcel$export(module.exports, "aryMethod", () => $9bdf14cdb5bfcb1d$export$85c665b4d7da9cb4, (v) => $9bdf14cdb5bfcb1d$export$85c665b4d7da9cb4 = v);
$parcel$export(module.exports, "aryRearg", () => $9bdf14cdb5bfcb1d$export$42564e045b285e32, (v) => $9bdf14cdb5bfcb1d$export$42564e045b285e32 = v);
$parcel$export(module.exports, "iterateeAry", () => $9bdf14cdb5bfcb1d$export$81e17196e6a22b07, (v) => $9bdf14cdb5bfcb1d$export$81e17196e6a22b07 = v);
$parcel$export(module.exports, "iterateeRearg", () => $9bdf14cdb5bfcb1d$export$30975ceb42167ebd, (v) => $9bdf14cdb5bfcb1d$export$30975ceb42167ebd = v);
$parcel$export(module.exports, "methodRearg", () => $9bdf14cdb5bfcb1d$export$8ceb0ad7e94d3801, (v) => $9bdf14cdb5bfcb1d$export$8ceb0ad7e94d3801 = v);
$parcel$export(module.exports, "methodSpread", () => $9bdf14cdb5bfcb1d$export$fbaeb3f87df3cf26, (v) => $9bdf14cdb5bfcb1d$export$fbaeb3f87df3cf26 = v);
$parcel$export(module.exports, "mutate", () => $9bdf14cdb5bfcb1d$export$57e795267c26e600, (v) => $9bdf14cdb5bfcb1d$export$57e795267c26e600 = v);
$parcel$export(module.exports, "realToAlias", () => $9bdf14cdb5bfcb1d$export$1eb71a7e27943e71, (v) => $9bdf14cdb5bfcb1d$export$1eb71a7e27943e71 = v);
$parcel$export(module.exports, "remap", () => $9bdf14cdb5bfcb1d$export$aee1dbae5de2db9d, (v) => $9bdf14cdb5bfcb1d$export$aee1dbae5de2db9d = v);
$parcel$export(module.exports, "skipFixed", () => $9bdf14cdb5bfcb1d$export$87ffbe4821a5d5e0, (v) => $9bdf14cdb5bfcb1d$export$87ffbe4821a5d5e0 = v);
$parcel$export(module.exports, "skipRearg", () => $9bdf14cdb5bfcb1d$export$b4d07413ce528c90, (v) => $9bdf14cdb5bfcb1d$export$b4d07413ce528c90 = v);
/** Used to map aliases to their real names. */ var $9bdf14cdb5bfcb1d$export$bd0f5e6e44efa6b4;
/** Used to map ary to method names. */ var $9bdf14cdb5bfcb1d$export$85c665b4d7da9cb4;
/** Used to map ary to rearg configs. */ var $9bdf14cdb5bfcb1d$export$42564e045b285e32;
/** Used to map method names to their iteratee ary. */ var $9bdf14cdb5bfcb1d$export$81e17196e6a22b07;
/** Used to map method names to iteratee rearg configs. */ var $9bdf14cdb5bfcb1d$export$30975ceb42167ebd;
/** Used to map method names to rearg configs. */ var $9bdf14cdb5bfcb1d$export$8ceb0ad7e94d3801;
/** Used to map method names to spread configs. */ var $9bdf14cdb5bfcb1d$export$fbaeb3f87df3cf26;
/** Used to identify methods which mutate arrays or objects. */ var $9bdf14cdb5bfcb1d$export$57e795267c26e600;
/** Used to map real names to their aliases. */ var $9bdf14cdb5bfcb1d$export$1eb71a7e27943e71;
/** Used to map method names to other names. */ var $9bdf14cdb5bfcb1d$export$aee1dbae5de2db9d;
/** Used to track methods that skip fixing their arity. */ var $9bdf14cdb5bfcb1d$export$87ffbe4821a5d5e0;
/** Used to track methods that skip rearranging arguments. */ var $9bdf14cdb5bfcb1d$export$b4d07413ce528c90;
$9bdf14cdb5bfcb1d$export$bd0f5e6e44efa6b4 = {
    // Lodash aliases.
    'each': 'forEach',
    'eachRight': 'forEachRight',
    'entries': 'toPairs',
    'entriesIn': 'toPairsIn',
    'extend': 'assignIn',
    'extendAll': 'assignInAll',
    'extendAllWith': 'assignInAllWith',
    'extendWith': 'assignInWith',
    'first': 'head',
    // Methods that are curried variants of others.
    'conforms': 'conformsTo',
    'matches': 'isMatch',
    'property': 'get',
    // Ramda aliases.
    '__': 'placeholder',
    'F': 'stubFalse',
    'T': 'stubTrue',
    'all': 'every',
    'allPass': 'overEvery',
    'always': 'constant',
    'any': 'some',
    'anyPass': 'overSome',
    'apply': 'spread',
    'assoc': 'set',
    'assocPath': 'set',
    'complement': 'negate',
    'compose': 'flowRight',
    'contains': 'includes',
    'dissoc': 'unset',
    'dissocPath': 'unset',
    'dropLast': 'dropRight',
    'dropLastWhile': 'dropRightWhile',
    'equals': 'isEqual',
    'identical': 'eq',
    'indexBy': 'keyBy',
    'init': 'initial',
    'invertObj': 'invert',
    'juxt': 'over',
    'omitAll': 'omit',
    'nAry': 'ary',
    'path': 'get',
    'pathEq': 'matchesProperty',
    'pathOr': 'getOr',
    'paths': 'at',
    'pickAll': 'pick',
    'pipe': 'flow',
    'pluck': 'map',
    'prop': 'get',
    'propEq': 'matchesProperty',
    'propOr': 'getOr',
    'props': 'at',
    'symmetricDifference': 'xor',
    'symmetricDifferenceBy': 'xorBy',
    'symmetricDifferenceWith': 'xorWith',
    'takeLast': 'takeRight',
    'takeLastWhile': 'takeRightWhile',
    'unapply': 'rest',
    'unnest': 'flatten',
    'useWith': 'overArgs',
    'where': 'conformsTo',
    'whereEq': 'isMatch',
    'zipObj': 'zipObject'
};
$9bdf14cdb5bfcb1d$export$85c665b4d7da9cb4 = {
    '1': [
        'assignAll',
        'assignInAll',
        'attempt',
        'castArray',
        'ceil',
        'create',
        'curry',
        'curryRight',
        'defaultsAll',
        'defaultsDeepAll',
        'floor',
        'flow',
        'flowRight',
        'fromPairs',
        'invert',
        'iteratee',
        'memoize',
        'method',
        'mergeAll',
        'methodOf',
        'mixin',
        'nthArg',
        'over',
        'overEvery',
        'overSome',
        'rest',
        'reverse',
        'round',
        'runInContext',
        'spread',
        'template',
        'trim',
        'trimEnd',
        'trimStart',
        'uniqueId',
        'words',
        'zipAll'
    ],
    '2': [
        'add',
        'after',
        'ary',
        'assign',
        'assignAllWith',
        'assignIn',
        'assignInAllWith',
        'at',
        'before',
        'bind',
        'bindAll',
        'bindKey',
        'chunk',
        'cloneDeepWith',
        'cloneWith',
        'concat',
        'conformsTo',
        'countBy',
        'curryN',
        'curryRightN',
        'debounce',
        'defaults',
        'defaultsDeep',
        'defaultTo',
        'delay',
        'difference',
        'divide',
        'drop',
        'dropRight',
        'dropRightWhile',
        'dropWhile',
        'endsWith',
        'eq',
        'every',
        'filter',
        'find',
        'findIndex',
        'findKey',
        'findLast',
        'findLastIndex',
        'findLastKey',
        'flatMap',
        'flatMapDeep',
        'flattenDepth',
        'forEach',
        'forEachRight',
        'forIn',
        'forInRight',
        'forOwn',
        'forOwnRight',
        'get',
        'groupBy',
        'gt',
        'gte',
        'has',
        'hasIn',
        'includes',
        'indexOf',
        'intersection',
        'invertBy',
        'invoke',
        'invokeMap',
        'isEqual',
        'isMatch',
        'join',
        'keyBy',
        'lastIndexOf',
        'lt',
        'lte',
        'map',
        'mapKeys',
        'mapValues',
        'matchesProperty',
        'maxBy',
        'meanBy',
        'merge',
        'mergeAllWith',
        'minBy',
        'multiply',
        'nth',
        'omit',
        'omitBy',
        'overArgs',
        'pad',
        'padEnd',
        'padStart',
        'parseInt',
        'partial',
        'partialRight',
        'partition',
        'pick',
        'pickBy',
        'propertyOf',
        'pull',
        'pullAll',
        'pullAt',
        'random',
        'range',
        'rangeRight',
        'rearg',
        'reject',
        'remove',
        'repeat',
        'restFrom',
        'result',
        'sampleSize',
        'some',
        'sortBy',
        'sortedIndex',
        'sortedIndexOf',
        'sortedLastIndex',
        'sortedLastIndexOf',
        'sortedUniqBy',
        'split',
        'spreadFrom',
        'startsWith',
        'subtract',
        'sumBy',
        'take',
        'takeRight',
        'takeRightWhile',
        'takeWhile',
        'tap',
        'throttle',
        'thru',
        'times',
        'trimChars',
        'trimCharsEnd',
        'trimCharsStart',
        'truncate',
        'union',
        'uniqBy',
        'uniqWith',
        'unset',
        'unzipWith',
        'without',
        'wrap',
        'xor',
        'zip',
        'zipObject',
        'zipObjectDeep'
    ],
    '3': [
        'assignInWith',
        'assignWith',
        'clamp',
        'differenceBy',
        'differenceWith',
        'findFrom',
        'findIndexFrom',
        'findLastFrom',
        'findLastIndexFrom',
        'getOr',
        'includesFrom',
        'indexOfFrom',
        'inRange',
        'intersectionBy',
        'intersectionWith',
        'invokeArgs',
        'invokeArgsMap',
        'isEqualWith',
        'isMatchWith',
        'flatMapDepth',
        'lastIndexOfFrom',
        'mergeWith',
        'orderBy',
        'padChars',
        'padCharsEnd',
        'padCharsStart',
        'pullAllBy',
        'pullAllWith',
        'rangeStep',
        'rangeStepRight',
        'reduce',
        'reduceRight',
        'replace',
        'set',
        'slice',
        'sortedIndexBy',
        'sortedLastIndexBy',
        'transform',
        'unionBy',
        'unionWith',
        'update',
        'xorBy',
        'xorWith',
        'zipWith'
    ],
    '4': [
        'fill',
        'setWith',
        'updateWith'
    ]
};
$9bdf14cdb5bfcb1d$export$42564e045b285e32 = {
    '2': [
        1,
        0
    ],
    '3': [
        2,
        0,
        1
    ],
    '4': [
        3,
        2,
        0,
        1
    ]
};
$9bdf14cdb5bfcb1d$export$81e17196e6a22b07 = {
    'dropRightWhile': 1,
    'dropWhile': 1,
    'every': 1,
    'filter': 1,
    'find': 1,
    'findFrom': 1,
    'findIndex': 1,
    'findIndexFrom': 1,
    'findKey': 1,
    'findLast': 1,
    'findLastFrom': 1,
    'findLastIndex': 1,
    'findLastIndexFrom': 1,
    'findLastKey': 1,
    'flatMap': 1,
    'flatMapDeep': 1,
    'flatMapDepth': 1,
    'forEach': 1,
    'forEachRight': 1,
    'forIn': 1,
    'forInRight': 1,
    'forOwn': 1,
    'forOwnRight': 1,
    'map': 1,
    'mapKeys': 1,
    'mapValues': 1,
    'partition': 1,
    'reduce': 2,
    'reduceRight': 2,
    'reject': 1,
    'remove': 1,
    'some': 1,
    'takeRightWhile': 1,
    'takeWhile': 1,
    'times': 1,
    'transform': 2
};
$9bdf14cdb5bfcb1d$export$30975ceb42167ebd = {
    'mapKeys': [
        1
    ],
    'reduceRight': [
        1,
        0
    ]
};
$9bdf14cdb5bfcb1d$export$8ceb0ad7e94d3801 = {
    'assignInAllWith': [
        1,
        0
    ],
    'assignInWith': [
        1,
        2,
        0
    ],
    'assignAllWith': [
        1,
        0
    ],
    'assignWith': [
        1,
        2,
        0
    ],
    'differenceBy': [
        1,
        2,
        0
    ],
    'differenceWith': [
        1,
        2,
        0
    ],
    'getOr': [
        2,
        1,
        0
    ],
    'intersectionBy': [
        1,
        2,
        0
    ],
    'intersectionWith': [
        1,
        2,
        0
    ],
    'isEqualWith': [
        1,
        2,
        0
    ],
    'isMatchWith': [
        2,
        1,
        0
    ],
    'mergeAllWith': [
        1,
        0
    ],
    'mergeWith': [
        1,
        2,
        0
    ],
    'padChars': [
        2,
        1,
        0
    ],
    'padCharsEnd': [
        2,
        1,
        0
    ],
    'padCharsStart': [
        2,
        1,
        0
    ],
    'pullAllBy': [
        2,
        1,
        0
    ],
    'pullAllWith': [
        2,
        1,
        0
    ],
    'rangeStep': [
        1,
        2,
        0
    ],
    'rangeStepRight': [
        1,
        2,
        0
    ],
    'setWith': [
        3,
        1,
        2,
        0
    ],
    'sortedIndexBy': [
        2,
        1,
        0
    ],
    'sortedLastIndexBy': [
        2,
        1,
        0
    ],
    'unionBy': [
        1,
        2,
        0
    ],
    'unionWith': [
        1,
        2,
        0
    ],
    'updateWith': [
        3,
        1,
        2,
        0
    ],
    'xorBy': [
        1,
        2,
        0
    ],
    'xorWith': [
        1,
        2,
        0
    ],
    'zipWith': [
        1,
        2,
        0
    ]
};
$9bdf14cdb5bfcb1d$export$fbaeb3f87df3cf26 = {
    'assignAll': {
        'start': 0
    },
    'assignAllWith': {
        'start': 0
    },
    'assignInAll': {
        'start': 0
    },
    'assignInAllWith': {
        'start': 0
    },
    'defaultsAll': {
        'start': 0
    },
    'defaultsDeepAll': {
        'start': 0
    },
    'invokeArgs': {
        'start': 2
    },
    'invokeArgsMap': {
        'start': 2
    },
    'mergeAll': {
        'start': 0
    },
    'mergeAllWith': {
        'start': 0
    },
    'partial': {
        'start': 1
    },
    'partialRight': {
        'start': 1
    },
    'without': {
        'start': 1
    },
    'zipAll': {
        'start': 0
    }
};
$9bdf14cdb5bfcb1d$export$57e795267c26e600 = {
    'array': {
        'fill': true,
        'pull': true,
        'pullAll': true,
        'pullAllBy': true,
        'pullAllWith': true,
        'pullAt': true,
        'remove': true,
        'reverse': true
    },
    'object': {
        'assign': true,
        'assignAll': true,
        'assignAllWith': true,
        'assignIn': true,
        'assignInAll': true,
        'assignInAllWith': true,
        'assignInWith': true,
        'assignWith': true,
        'defaults': true,
        'defaultsAll': true,
        'defaultsDeep': true,
        'defaultsDeepAll': true,
        'merge': true,
        'mergeAll': true,
        'mergeAllWith': true,
        'mergeWith': true
    },
    'set': {
        'set': true,
        'setWith': true,
        'unset': true,
        'update': true,
        'updateWith': true
    }
};
$9bdf14cdb5bfcb1d$export$1eb71a7e27943e71 = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = $9bdf14cdb5bfcb1d$export$bd0f5e6e44efa6b4, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
$9bdf14cdb5bfcb1d$export$aee1dbae5de2db9d = {
    'assignAll': 'assign',
    'assignAllWith': 'assignWith',
    'assignInAll': 'assignIn',
    'assignInAllWith': 'assignInWith',
    'curryN': 'curry',
    'curryRightN': 'curryRight',
    'defaultsAll': 'defaults',
    'defaultsDeepAll': 'defaultsDeep',
    'findFrom': 'find',
    'findIndexFrom': 'findIndex',
    'findLastFrom': 'findLast',
    'findLastIndexFrom': 'findLastIndex',
    'getOr': 'get',
    'includesFrom': 'includes',
    'indexOfFrom': 'indexOf',
    'invokeArgs': 'invoke',
    'invokeArgsMap': 'invokeMap',
    'lastIndexOfFrom': 'lastIndexOf',
    'mergeAll': 'merge',
    'mergeAllWith': 'mergeWith',
    'padChars': 'pad',
    'padCharsEnd': 'padEnd',
    'padCharsStart': 'padStart',
    'propertyOf': 'get',
    'rangeStep': 'range',
    'rangeStepRight': 'rangeRight',
    'restFrom': 'rest',
    'spreadFrom': 'spread',
    'trimChars': 'trim',
    'trimCharsEnd': 'trimEnd',
    'trimCharsStart': 'trimStart',
    'zipAll': 'zip'
};
$9bdf14cdb5bfcb1d$export$87ffbe4821a5d5e0 = {
    'castArray': true,
    'flow': true,
    'flowRight': true,
    'iteratee': true,
    'mixin': true,
    'rearg': true,
    'runInContext': true
};
$9bdf14cdb5bfcb1d$export$b4d07413ce528c90 = {
    'add': true,
    'assign': true,
    'assignIn': true,
    'bind': true,
    'bindKey': true,
    'concat': true,
    'difference': true,
    'divide': true,
    'eq': true,
    'gt': true,
    'gte': true,
    'isEqual': true,
    'lt': true,
    'lte': true,
    'matchesProperty': true,
    'merge': true,
    'multiply': true,
    'overArgs': true,
    'partial': true,
    'partialRight': true,
    'propertyOf': true,
    'random': true,
    'range': true,
    'rangeRight': true,
    'subtract': true,
    'zip': true,
    'zipObject': true,
    'zipObjectDeep': true
};

});

parcelRegister("gckmj", function(module, exports) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

});


parcelRegister("pxG0E", function(module, exports) {














module.exports = {
    'ary': (parcelRequire("atN2r")),
    'assign': (parcelRequire("28U6q")),
    'clone': (parcelRequire("OUkRG")),
    'curry': (parcelRequire("kHf9G")),
    'forEach': (parcelRequire("27HF8")),
    'isArray': (parcelRequire("jOlpf")),
    'isError': (parcelRequire("1WlyJ")),
    'isFunction': (parcelRequire("e7cHV")),
    'isWeakMap': (parcelRequire("8022d")),
    'iteratee': (parcelRequire("6dlXd")),
    'keys': (parcelRequire("iT1bQ")),
    'rearg': (parcelRequire("ey0U9")),
    'toInteger': (parcelRequire("4NLnC")),
    'toPath': (parcelRequire("axOCp"))
};

});
parcelRegister("atN2r", function(module, exports) {

var $xyVgB = parcelRequire("xyVgB");
/** Used to compose bitmasks for function metadata. */ var $7a12a6d1ea68ca8b$var$WRAP_ARY_FLAG = 128;
/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function $7a12a6d1ea68ca8b$var$ary(func, n, guard) {
    n = guard ? undefined : n;
    n = func && n == null ? func.length : n;
    return $xyVgB(func, $7a12a6d1ea68ca8b$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}
module.exports = $7a12a6d1ea68ca8b$var$ary;

});
parcelRegister("xyVgB", function(module, exports) {

var $jZ1e8 = parcelRequire("jZ1e8");

var $60DzR = parcelRequire("60DzR");

var $6tr10 = parcelRequire("6tr10");

var $2eUlK = parcelRequire("2eUlK");

var $2c8s5 = parcelRequire("2c8s5");

var $cMGSd = parcelRequire("cMGSd");

var $8EqVe = parcelRequire("8EqVe");

var $6NiAs = parcelRequire("6NiAs");

var $5oc10 = parcelRequire("5oc10");

var $4NLnC = parcelRequire("4NLnC");
/** Error message constants. */ var $064e2c1832d69827$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $064e2c1832d69827$var$WRAP_BIND_FLAG = 1, $064e2c1832d69827$var$WRAP_BIND_KEY_FLAG = 2, $064e2c1832d69827$var$WRAP_CURRY_FLAG = 8, $064e2c1832d69827$var$WRAP_CURRY_RIGHT_FLAG = 16, $064e2c1832d69827$var$WRAP_PARTIAL_FLAG = 32, $064e2c1832d69827$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $064e2c1832d69827$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $064e2c1832d69827$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $064e2c1832d69827$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($064e2c1832d69827$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($064e2c1832d69827$var$WRAP_PARTIAL_FLAG | $064e2c1832d69827$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $064e2c1832d69827$var$nativeMax($4NLnC(ary), 0);
    arity = arity === undefined ? arity : $4NLnC(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $064e2c1832d69827$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $cMGSd(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $8EqVe(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $064e2c1832d69827$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($064e2c1832d69827$var$WRAP_CURRY_FLAG | $064e2c1832d69827$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($064e2c1832d69827$var$WRAP_CURRY_FLAG | $064e2c1832d69827$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $064e2c1832d69827$var$WRAP_BIND_FLAG) var result = $60DzR(func, bitmask, thisArg);
    else if (bitmask == $064e2c1832d69827$var$WRAP_CURRY_FLAG || bitmask == $064e2c1832d69827$var$WRAP_CURRY_RIGHT_FLAG) result = $6tr10(func, bitmask, arity);
    else if ((bitmask == $064e2c1832d69827$var$WRAP_PARTIAL_FLAG || bitmask == ($064e2c1832d69827$var$WRAP_BIND_FLAG | $064e2c1832d69827$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $2c8s5(func, bitmask, thisArg, partials);
    else result = $2eUlK.apply(undefined, newData);
    var setter = data ? $jZ1e8 : $6NiAs;
    return $5oc10(setter(result, newData), func, bitmask);
}
module.exports = $064e2c1832d69827$var$createWrap;

});
parcelRegister("jZ1e8", function(module, exports) {

var $eSVkV = parcelRequire("eSVkV");

var $emNji = parcelRequire("emNji");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $e8c4aa7b29e4b237$var$baseSetData = !$emNji ? $eSVkV : function(func, data) {
    $emNji.set(func, data);
    return func;
};
module.exports = $e8c4aa7b29e4b237$var$baseSetData;

});

parcelRegister("60DzR", function(module, exports) {

var $fRtia = parcelRequire("fRtia");

var $eqXyn = parcelRequire("eqXyn");
/** Used to compose bitmasks for function metadata. */ var $4601716896e4994d$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $4601716896e4994d$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $4601716896e4994d$var$WRAP_BIND_FLAG, Ctor = $fRtia(func);
    function wrapper() {
        var fn = this && this !== $eqXyn && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $4601716896e4994d$var$createBind;

});
parcelRegister("fRtia", function(module, exports) {

var $1R5h4 = parcelRequire("1R5h4");

var $cslvQ = parcelRequire("cslvQ");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $b8c2870622a38761$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $1R5h4(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $cslvQ(result) ? result : thisBinding;
    };
}
module.exports = $b8c2870622a38761$var$createCtor;

});


parcelRegister("6tr10", function(module, exports) {

var $3GDE1 = parcelRequire("3GDE1");

var $fRtia = parcelRequire("fRtia");

var $2eUlK = parcelRequire("2eUlK");

var $haUN4 = parcelRequire("haUN4");

var $17C8c = parcelRequire("17C8c");

var $4qhh0 = parcelRequire("4qhh0");

var $eqXyn = parcelRequire("eqXyn");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $4b6a68256242eb1b$var$createCurry(func, bitmask, arity) {
    var Ctor = $fRtia(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $17C8c(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $4qhh0(args, placeholder);
        length -= holders.length;
        if (length < arity) return $haUN4(func, bitmask, $2eUlK, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $eqXyn && this instanceof wrapper ? Ctor : func;
        return $3GDE1(fn, this, args);
    }
    return wrapper;
}
module.exports = $4b6a68256242eb1b$var$createCurry;

});
parcelRegister("2eUlK", function(module, exports) {

var $eM5vV = parcelRequire("eM5vV");

var $2zXrz = parcelRequire("2zXrz");

var $2sy1W = parcelRequire("2sy1W");

var $fRtia = parcelRequire("fRtia");

var $haUN4 = parcelRequire("haUN4");

var $17C8c = parcelRequire("17C8c");

var $4MVZ3 = parcelRequire("4MVZ3");

var $4qhh0 = parcelRequire("4qhh0");

var $eqXyn = parcelRequire("eqXyn");
/** Used to compose bitmasks for function metadata. */ var $1a189976d23a3309$var$WRAP_BIND_FLAG = 1, $1a189976d23a3309$var$WRAP_BIND_KEY_FLAG = 2, $1a189976d23a3309$var$WRAP_CURRY_FLAG = 8, $1a189976d23a3309$var$WRAP_CURRY_RIGHT_FLAG = 16, $1a189976d23a3309$var$WRAP_ARY_FLAG = 128, $1a189976d23a3309$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $1a189976d23a3309$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $1a189976d23a3309$var$WRAP_ARY_FLAG, isBind = bitmask & $1a189976d23a3309$var$WRAP_BIND_FLAG, isBindKey = bitmask & $1a189976d23a3309$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($1a189976d23a3309$var$WRAP_CURRY_FLAG | $1a189976d23a3309$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $1a189976d23a3309$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $fRtia(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $17C8c(wrapper), holdersCount = $2sy1W(args, placeholder);
        if (partials) args = $eM5vV(args, partials, holders, isCurried);
        if (partialsRight) args = $2zXrz(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $4qhh0(args, placeholder);
            return $haUN4(func, bitmask, $1a189976d23a3309$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $4MVZ3(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $eqXyn && this instanceof wrapper) fn = Ctor || $fRtia(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $1a189976d23a3309$var$createHybrid;

});
parcelRegister("eM5vV", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $02c69c2edc2a1a5f$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $02c69c2edc2a1a5f$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $02c69c2edc2a1a5f$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $02c69c2edc2a1a5f$var$composeArgs;

});

parcelRegister("2zXrz", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1e0cf5ea31ee27c8$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $1e0cf5ea31ee27c8$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $1e0cf5ea31ee27c8$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $1e0cf5ea31ee27c8$var$composeArgsRight;

});

parcelRegister("2sy1W", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $1ca897fc06769b97$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $1ca897fc06769b97$var$countHolders;

});

parcelRegister("haUN4", function(module, exports) {

var $lvBLI = parcelRequire("lvBLI");

var $6NiAs = parcelRequire("6NiAs");

var $5oc10 = parcelRequire("5oc10");
/** Used to compose bitmasks for function metadata. */ var $c80f6c3e68ee0345$var$WRAP_BIND_FLAG = 1, $c80f6c3e68ee0345$var$WRAP_BIND_KEY_FLAG = 2, $c80f6c3e68ee0345$var$WRAP_CURRY_BOUND_FLAG = 4, $c80f6c3e68ee0345$var$WRAP_CURRY_FLAG = 8, $c80f6c3e68ee0345$var$WRAP_PARTIAL_FLAG = 32, $c80f6c3e68ee0345$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $c80f6c3e68ee0345$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $c80f6c3e68ee0345$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $c80f6c3e68ee0345$var$WRAP_PARTIAL_FLAG : $c80f6c3e68ee0345$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $c80f6c3e68ee0345$var$WRAP_PARTIAL_RIGHT_FLAG : $c80f6c3e68ee0345$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $c80f6c3e68ee0345$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($c80f6c3e68ee0345$var$WRAP_BIND_FLAG | $c80f6c3e68ee0345$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($lvBLI(func)) $6NiAs(result, newData);
    result.placeholder = placeholder;
    return $5oc10(result, func, bitmask);
}
module.exports = $c80f6c3e68ee0345$var$createRecurry;

});
parcelRegister("6NiAs", function(module, exports) {

var $jZ1e8 = parcelRequire("jZ1e8");

var $1CFVN = parcelRequire("1CFVN");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $4f25bcb1945c5c22$var$setData = $1CFVN($jZ1e8);
module.exports = $4f25bcb1945c5c22$var$setData;

});

parcelRegister("5oc10", function(module, exports) {

var $212L7 = parcelRequire("212L7");

var $1Nkrt = parcelRequire("1Nkrt");

var $gEB0r = parcelRequire("gEB0r");

var $h9tBC = parcelRequire("h9tBC");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $3ec8839fee1bd723$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $gEB0r(wrapper, $1Nkrt(source, $h9tBC($212L7(source), bitmask)));
}
module.exports = $3ec8839fee1bd723$var$setWrapToString;

});
parcelRegister("212L7", function(module, exports) {
/** Used to match wrap detail comments. */ var $177dd0a1d7b81c58$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $177dd0a1d7b81c58$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $177dd0a1d7b81c58$var$getWrapDetails(source) {
    var match = source.match($177dd0a1d7b81c58$var$reWrapDetails);
    return match ? match[1].split($177dd0a1d7b81c58$var$reSplitDetails) : [];
}
module.exports = $177dd0a1d7b81c58$var$getWrapDetails;

});

parcelRegister("1Nkrt", function(module, exports) {
/** Used to match wrap detail comments. */ var $14ea3972632bc950$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $14ea3972632bc950$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($14ea3972632bc950$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = $14ea3972632bc950$var$insertWrapDetails;

});

parcelRegister("h9tBC", function(module, exports) {

var $27HF8 = parcelRequire("27HF8");

var $bJC7w = parcelRequire("bJC7w");
/** Used to compose bitmasks for function metadata. */ var $c7ca3dfe86544cb3$var$WRAP_BIND_FLAG = 1, $c7ca3dfe86544cb3$var$WRAP_BIND_KEY_FLAG = 2, $c7ca3dfe86544cb3$var$WRAP_CURRY_FLAG = 8, $c7ca3dfe86544cb3$var$WRAP_CURRY_RIGHT_FLAG = 16, $c7ca3dfe86544cb3$var$WRAP_PARTIAL_FLAG = 32, $c7ca3dfe86544cb3$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $c7ca3dfe86544cb3$var$WRAP_ARY_FLAG = 128, $c7ca3dfe86544cb3$var$WRAP_REARG_FLAG = 256, $c7ca3dfe86544cb3$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $c7ca3dfe86544cb3$var$wrapFlags = [
    [
        'ary',
        $c7ca3dfe86544cb3$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $c7ca3dfe86544cb3$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $c7ca3dfe86544cb3$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $c7ca3dfe86544cb3$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $c7ca3dfe86544cb3$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $c7ca3dfe86544cb3$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $c7ca3dfe86544cb3$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $c7ca3dfe86544cb3$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $c7ca3dfe86544cb3$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $c7ca3dfe86544cb3$var$updateWrapDetails(details, bitmask) {
    $27HF8($c7ca3dfe86544cb3$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$bJC7w(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $c7ca3dfe86544cb3$var$updateWrapDetails;

});



parcelRegister("17C8c", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $0d1405fd125454e1$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $0d1405fd125454e1$var$getHolder;

});

parcelRegister("4MVZ3", function(module, exports) {

var $iM6Ha = parcelRequire("iM6Ha");

var $l7Anm = parcelRequire("l7Anm");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $37c89f757cda28dc$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $37c89f757cda28dc$var$reorder(array, indexes) {
    var arrLength = array.length, length = $37c89f757cda28dc$var$nativeMin(indexes.length, arrLength), oldArray = $iM6Ha(array);
    while(length--){
        var index = indexes[length];
        array[length] = $l7Anm(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $37c89f757cda28dc$var$reorder;

});

parcelRegister("4qhh0", function(module, exports) {
/** Used as the internal argument placeholder. */ var $3386fd412b5c69a9$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $3386fd412b5c69a9$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $3386fd412b5c69a9$var$PLACEHOLDER) {
            array[index] = $3386fd412b5c69a9$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $3386fd412b5c69a9$var$replaceHolders;

});



parcelRegister("2c8s5", function(module, exports) {

var $3GDE1 = parcelRequire("3GDE1");

var $fRtia = parcelRequire("fRtia");

var $eqXyn = parcelRequire("eqXyn");
/** Used to compose bitmasks for function metadata. */ var $1993422132c7e23d$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $1993422132c7e23d$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $1993422132c7e23d$var$WRAP_BIND_FLAG, Ctor = $fRtia(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $eqXyn && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $3GDE1(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $1993422132c7e23d$var$createPartial;

});

parcelRegister("8EqVe", function(module, exports) {

var $eM5vV = parcelRequire("eM5vV");

var $2zXrz = parcelRequire("2zXrz");

var $4qhh0 = parcelRequire("4qhh0");
/** Used as the internal argument placeholder. */ var $64c6f156dda796c4$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $64c6f156dda796c4$var$WRAP_BIND_FLAG = 1, $64c6f156dda796c4$var$WRAP_BIND_KEY_FLAG = 2, $64c6f156dda796c4$var$WRAP_CURRY_BOUND_FLAG = 4, $64c6f156dda796c4$var$WRAP_CURRY_FLAG = 8, $64c6f156dda796c4$var$WRAP_ARY_FLAG = 128, $64c6f156dda796c4$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $64c6f156dda796c4$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $64c6f156dda796c4$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($64c6f156dda796c4$var$WRAP_BIND_FLAG | $64c6f156dda796c4$var$WRAP_BIND_KEY_FLAG | $64c6f156dda796c4$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $64c6f156dda796c4$var$WRAP_ARY_FLAG && bitmask == $64c6f156dda796c4$var$WRAP_CURRY_FLAG || srcBitmask == $64c6f156dda796c4$var$WRAP_ARY_FLAG && bitmask == $64c6f156dda796c4$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($64c6f156dda796c4$var$WRAP_ARY_FLAG | $64c6f156dda796c4$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $64c6f156dda796c4$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $64c6f156dda796c4$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $64c6f156dda796c4$var$WRAP_BIND_FLAG ? 0 : $64c6f156dda796c4$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $eM5vV(partials, value, source[4]) : value;
        data[4] = partials ? $4qhh0(data[3], $64c6f156dda796c4$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $2zXrz(partials, value, source[6]) : value;
        data[6] = partials ? $4qhh0(data[5], $64c6f156dda796c4$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $64c6f156dda796c4$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $64c6f156dda796c4$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $64c6f156dda796c4$var$mergeData;

});



parcelRegister("OUkRG", function(module, exports) {

var $aisNj = parcelRequire("aisNj");
/** Used to compose bitmasks for cloning. */ var $09905eb07799281c$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $09905eb07799281c$var$clone(value) {
    return $aisNj(value, $09905eb07799281c$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $09905eb07799281c$var$clone;

});

parcelRegister("kHf9G", function(module, exports) {

var $xyVgB = parcelRequire("xyVgB");
/** Used to compose bitmasks for function metadata. */ var $f11394523f5295f5$var$WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function $f11394523f5295f5$var$curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $xyVgB(func, $f11394523f5295f5$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $f11394523f5295f5$var$curry.placeholder;
    return result;
}
// Assign default placeholders.
$f11394523f5295f5$var$curry.placeholder = {};
module.exports = $f11394523f5295f5$var$curry;

});

parcelRegister("1WlyJ", function(module, exports) {

var $3zZZC = parcelRequire("3zZZC");

var $czB45 = parcelRequire("czB45");

var $9Ym1f = parcelRequire("9Ym1f");
/** `Object#toString` result references. */ var $169bee67a8d5ce66$var$domExcTag = '[object DOMException]', $169bee67a8d5ce66$var$errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $169bee67a8d5ce66$var$isError(value) {
    if (!$czB45(value)) return false;
    var tag = $3zZZC(value);
    return tag == $169bee67a8d5ce66$var$errorTag || tag == $169bee67a8d5ce66$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$9Ym1f(value);
}
module.exports = $169bee67a8d5ce66$var$isError;

});

parcelRegister("8022d", function(module, exports) {

var $1GGsF = parcelRequire("1GGsF");

var $czB45 = parcelRequire("czB45");
/** `Object#toString` result references. */ var $5d2fe6e19115463d$var$weakMapTag = '[object WeakMap]';
/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function $5d2fe6e19115463d$var$isWeakMap(value) {
    return $czB45(value) && $1GGsF(value) == $5d2fe6e19115463d$var$weakMapTag;
}
module.exports = $5d2fe6e19115463d$var$isWeakMap;

});

parcelRegister("6dlXd", function(module, exports) {

var $aisNj = parcelRequire("aisNj");

var $9JUaE = parcelRequire("9JUaE");
/** Used to compose bitmasks for cloning. */ var $4864fc965446f177$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function $4864fc965446f177$var$iteratee(func) {
    return $9JUaE(typeof func == 'function' ? func : $aisNj(func, $4864fc965446f177$var$CLONE_DEEP_FLAG));
}
module.exports = $4864fc965446f177$var$iteratee;

});

parcelRegister("ey0U9", function(module, exports) {

var $xyVgB = parcelRequire("xyVgB");

var $5skZT = parcelRequire("5skZT");
/** Used to compose bitmasks for function metadata. */ var $02bbb14fd551ca8f$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var $02bbb14fd551ca8f$var$rearg = $5skZT(function(func, indexes) {
    return $xyVgB(func, $02bbb14fd551ca8f$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});
module.exports = $02bbb14fd551ca8f$var$rearg;

});

parcelRegister("axOCp", function(module, exports) {

var $bTATB = parcelRequire("bTATB");

var $iM6Ha = parcelRequire("iM6Ha");

var $jOlpf = parcelRequire("jOlpf");

var $6SfBs = parcelRequire("6SfBs");

var $ixA83 = parcelRequire("ixA83");

var $7I3m1 = parcelRequire("7I3m1");

var $lyiHY = parcelRequire("lyiHY");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $7ad44036eef389ae$var$toPath(value) {
    if ($jOlpf(value)) return $bTATB(value, $7I3m1);
    return $6SfBs(value) ? [
        value
    ] : $iM6Ha($ixA83($lyiHY(value)));
}
module.exports = $7ad44036eef389ae$var$toPath;

});



parcelRegister("lzkcn", function(module, exports) {

var $jQAgR = parcelRequire("jQAgR");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $fb3c88e0e31ee92a$var$range = $jQAgR();
module.exports = $fb3c88e0e31ee92a$var$range;

});
parcelRegister("jQAgR", function(module, exports) {

var $aNzRz = parcelRequire("aNzRz");

var $4qbYM = parcelRequire("4qbYM");

var $3aJ0r = parcelRequire("3aJ0r");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $e72f02499286c7a4$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $4qbYM(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $3aJ0r(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $3aJ0r(end);
        step = step === undefined ? start < end ? 1 : -1 : $3aJ0r(step);
        return $aNzRz(start, end, step, fromRight);
    };
}
module.exports = $e72f02499286c7a4$var$createRange;

});
parcelRegister("aNzRz", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7dca4c9e335f83ce$var$nativeCeil = Math.ceil, $7dca4c9e335f83ce$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $7dca4c9e335f83ce$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $7dca4c9e335f83ce$var$nativeMax($7dca4c9e335f83ce$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $7dca4c9e335f83ce$var$baseRange;

});





parcelRegister("hDvet", function(module, exports) {
$parcel$export(module.exports, "useExpandableEntryPointTrigger", () => $bc5662eed30c4386$export$569294f6ae10bba9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $6ouZy = parcelRequire("6ouZy");
const $bc5662eed30c4386$export$569294f6ae10bba9 = (actions, isActive = true)=>{
    // We don't want the click-handler, as ExpandableMenuItem handles the entry-point loading itself
    const eventMap = (0, $euxye.useMemo)(()=>Object.fromEntries(Object.entries((0, $6ouZy.getDefaultEntrypointActionEventMap)(actions)).filter(([key])=>key !== 'click')), [
        actions
    ]);
    return (0, $6ouZy.useEntryPointButtonTrigger)(actions, isActive, eventMap);
};

});

parcelRegister("lEazp", function(module, exports) {
$parcel$export(module.exports, "ExploreMoreApps", () => $79e9157d1f69d9a3$export$e3e10d2adcb07330);

var $euxye = parcelRequire("euxye");



var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $aQCoC = parcelRequire("aQCoC");

var $KL7Bq = parcelRequire("KL7Bq");

var $cnPua = parcelRequire("cnPua");

var $fOxy5 = parcelRequire("fOxy5");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $eijVy = parcelRequire("eijVy");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
const $79e9157d1f69d9a3$var$exploreMoreApps = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-apps.common.explore-more-apps.explore-more-apps",
    defaultMessage: "Explore more apps"
});
const $79e9157d1f69d9a3$var$pathToNavigate = '/jira/marketplace/discover';
function $79e9157d1f69d9a3$export$e3e10d2adcb07330() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const tenantContext = (0, $eijVy.useTenantContext)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = tenantContext;
    const Icon = (0, $i860n.fg)('use-marketplace-icon') ? (0, (/*@__PURE__*/$parcel$interopDefault($cnPua))) : (0, (/*@__PURE__*/$parcel$interopDefault($fOxy5)));
    const { formattedMessage: formattedMessage, icon: icon } = (0, $KL7Bq.useFormattedMessageAndIcon)($79e9157d1f69d9a3$var$exploreMoreApps, Icon);
    const onClick = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_APPS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                itemId: 'exploreMoreApps'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const showExploreMoreApps = isAdmin || isSiteAdmin ? (0, $2700E.expVal)('emcee-discover', 'value', true) : (0, $2700E.expVal)('enduser-emcee-discover', 'value', true);
    if (!showExploreMoreApps) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: icon,
        href: $79e9157d1f69d9a3$var$pathToNavigate,
        menuId: (0, $5IkoH.MENU_ID_APP_MARKETPLACE_DISCOVER),
        onClick: onClick
    }, formattedMessage);
}
$79e9157d1f69d9a3$export$e3e10d2adcb07330.displayName = "ExploreMoreApps";

});
parcelRegister("cnPua", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c76119748fdcd787276a176c9f7509f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $903f91ff04e1ddf7$var$_react = $903f91ff04e1ddf7$var$_interopRequireDefault((parcelRequire("euxye")));

var $903f91ff04e1ddf7$var$_baseNew = $903f91ff04e1ddf7$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $903f91ff04e1ddf7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Marketplace".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/marketplace
 * Usage guidance:
 * Single purpose - Reserved for Atlassian Marketplace.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $903f91ff04e1ddf7$var$MarketplaceIcon = (props)=>/*#__PURE__*/ $903f91ff04e1ddf7$var$_react.default.createElement($903f91ff04e1ddf7$var$_baseNew.default, Object.assign({
        name: "MarketplaceIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.789 1.513A.75.75 0 0 1 2.5 1h11a.75.75 0 0 1 .711.513l1.502 4.5a.8.8 0 0 1 .038.237A3.08 3.08 0 0 1 14 9.032V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.031A3.08 3.08 0 0 1 .25 6.25q0-.12.038-.237zM3.5 9.329V13a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9.33a3.08 3.08 0 0 1-2.166-1.064A3.08 3.08 0 0 1 8 9.334a3.08 3.08 0 0 1-2.334-1.068A3.08 3.08 0 0 1 3.5 9.329M4.916 6.25v.03a1.584 1.584 0 0 1-3.163.08l.037-.11zm1.5.038.005-.038h3.158l.004.038a1.584 1.584 0 0 1-3.166 0M9.413 4.75H6.588l.25-2.25h2.324zm1.672 1.5a1.584 1.584 0 0 0 3.164.11l-.037-.11zm2.626-1.5h-2.788l-.25-2.25h2.288zM5.33 2.5l-.25 2.25H2.29l.75-2.25z" clip-rule="evenodd"/>`
    }, props));
$903f91ff04e1ddf7$var$MarketplaceIcon.displayName = 'MarketplaceIcon';
var $903f91ff04e1ddf7$var$_default = module.exports.default = $903f91ff04e1ddf7$var$MarketplaceIcon;

});


/* eslint-disable jira/filename-case */ const $2bb20df175b75b35$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Apps';
const $2bb20df175b75b35$export$d57b6b390e78d90f = 'smite';

parcelRegister("iZS3n", function(module, exports) {
$parcel$export(module.exports, "createAttributes", () => $3e3afd22390330a7$export$c7c9603a6b1fd815);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6bEm8 = parcelRequire("6bEm8");

var $i860n = parcelRequire("i860n");

var $lCetP = parcelRequire("lCetP");
const $3e3afd22390330a7$var$isSynthetic = ()=>// Filter out synthetic tests using all known ways
    (0, $6bEm8.default)('ajs-is-synthetic') === 'true' || (0, $i860n.fg)('forge_ui_synthetic_check');
const $3e3afd22390330a7$var$FAILED_TO_FETCH = 'FAILED_TO_FETCH';
const $3e3afd22390330a7$var$getErrorType = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ((0, $lCetP.isClientFetchError)(error)) return $3e3afd22390330a7$var$FAILED_TO_FETCH;
    return 'OTHER';
};
const $3e3afd22390330a7$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $3e3afd22390330a7$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: $3e3afd22390330a7$var$isSynthetic(),
        isSSR: false
    };
    if (rawAttributes) {
        const { error: error } = rawAttributes;
        if (error) {
            attributes.error = $3e3afd22390330a7$export$78c6267359db7e73(error);
            attributes.errorType = $3e3afd22390330a7$var$getErrorType(error);
        }
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});

parcelRegister("44vv6", function(module, exports) {
$parcel$export(module.exports, "asyncNav4AppsContentViewQuery", () => $15ad92639169cd2e$export$3cc582e017e659a5);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $2NSbF = parcelRequire("2NSbF");

var $2700E = parcelRequire("2700E");

var $bZhC2 = parcelRequire("bZhC2");

var $i860n = parcelRequire("i860n");

var $18sMq = parcelRequire("18sMq");

var $gDydY = parcelRequire("gDydY");

const $15ad92639169cd2e$export$3cc582e017e659a5 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("ax8eK")), {
        moduleId: "aff3e00f",
        moduleName: "Nav4AppsContentViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.cloudId || '';
        const activationId = params.activationId || '';
        const variables = {
            cloudId: cloudId,
            entityAriApps: '',
            ownerAri: '',
            skipOrderQuery: true
        };
        if ((0, $2700E.expVal)('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) {
            const entityAriApps = (0, $i860n.fg)('navx-3660-fix-l2-l3-aris') ? (0, $18sMq.NavigationSettingAri).create({
                activationId: activationId,
                firstPartyApp: 'jira',
                settingId: 'jira-apps',
                siteId: cloudId
            }).toString() : (0, $bZhC2.JiraNavigationSettingsAri).create({
                siteId: cloudId,
                activationId: activationId,
                navigationSettingScope: 'apps'
            }).toString();
            const ownerAri = (0, $2NSbF.IdentityUserAri).create({
                userId: params.accountId || 'UNKNOWN'
            }).toString();
            variables.entityAriApps = entityAriApps;
            variables.ownerAri = ownerAri;
            variables.skipOrderQuery = false;
        }
        return {
            queries: {
                apps: {
                    parameters: $gDydY.default,
                    variables: variables
                }
            }
        };
    }
});

});
parcelRegister("gDydY", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f1344035f9e2a79$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<14e4ae28cb65da8f2a86d2ee966a3271>>
 * @relayHash 205d8656124320ceb37efacccc0a9807
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8d935fb2412a7dbc2071fcb8ca17c75dc2c7725330b2328d48969357d2e55218
const $4f1344035f9e2a79$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityAriApps"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ownerAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipOrderQuery"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "entityAriApps"
        },
        {
            "kind": "Variable",
            "name": "ownerAri",
            "variableName": "ownerAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "label"
    }, v4 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v5 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4AppsContentViewQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "Nav4AppsContent"
                            }
                        ]
                    },
                    "action": "THROW"
                },
                {
                    "condition": "skipOrderQuery",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": "appsOrder",
                            "args": v1 /*: any*/ ,
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "Nav4AppsContent_navigationCustomisation"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4AppsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraNavigationItemConnection",
                            "kind": "LinkedField",
                            "name": "globalAppNavigationItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraNavigationItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "envLabel"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "iconUrl"
                                                        },
                                                        v4 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraAppSection",
                                                            "kind": "LinkedField",
                                                            "name": "sections",
                                                            "plural": true,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "links",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "settingsUrl"
                                                        },
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "JiraAppNavigationItem"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "skipOrderQuery",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": "appsOrder",
                            "args": v1 /*: any*/ ,
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SettingsMenuItemConnection",
                                    "kind": "LinkedField",
                                    "name": "sidebar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "SettingsMenuItem",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "menuId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "visible"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8d935fb2412a7dbc2071fcb8ca17c75dc2c7725330b2328d48969357d2e55218",
            "metadata": {},
            "name": "Nav4AppsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4f1344035f9e2a79$var$node.hash = "c7cdbee2e919012c9f4e63ba00aef4da";
var $4f1344035f9e2a79$export$2e2bcd8739ae039 = $4f1344035f9e2a79$var$node;

});

parcelRegister("ax8eK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("F1Y72").then(()=>parcelRequire('kOMzQ'));

});



parcelRegister("13bUl", function(module, exports) {
$parcel$export(module.exports, "Nav4AppsForLanding", () => $e74b5379bcbbf881$export$889c9c34c80104b2);

var $7zJb7 = parcelRequire("7zJb7");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");


var $bOwox = parcelRequire("bOwox");

var $5IkoH = parcelRequire("5IkoH");

var $ggvFe = parcelRequire("ggvFe");

var $6GljB = parcelRequire("6GljB");

var $4VtOS = parcelRequire("4VtOS");

var $jzXAj = parcelRequire("jzXAj");

var $dx7aH = parcelRequire("dx7aH");

var $jepRN = parcelRequire("jepRN");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $gDdYI = parcelRequire("gDdYI");

var $lEazp = parcelRequire("lEazp");

var $OmFIT = parcelRequire("OmFIT");
function $e74b5379bcbbf881$export$889c9c34c80104b2(props) {
    const { queryRef: queryRef, navigationCustomisationFragment: navigationCustomisationFragment } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $euxye.useContext)((0, $ggvFe.NavItemsContext));
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).APPS);
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $7zJb7.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    const menuId = (0, $5IkoH.MENU_ID_APPS);
    const handleExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $6GljB.L1_MENU_ID).APPS);
            (0, $aJ81Y.fireUIAnalytics)(event, (0, $bOwox.SECTION_ITEM_APPS), {
                isInMore: isInMore
            });
        }
    }, [
        createAnalyticsEvent,
        moreMenuIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e74b5379bcbbf881$var$Nav4AppsForLandingInner, {
        ...props,
        formattedMessage: formattedMessage,
        handleExpansionToggle: handleExpansionToggle,
        icon: icon,
        menuId: menuId,
        queryRef: data,
        navigationCustomisationFragment: navigationCustomisationFragment
    });
}
$e74b5379bcbbf881$export$889c9c34c80104b2.displayName = "Nav4AppsForLanding";
const $e74b5379bcbbf881$var$Nav4AppsForLandingInner = (0, $jepRN.componentWithFG)('navx-global-side-nav', $e74b5379bcbbf881$var$Nav4AppsForLandingInnerGSN, $e74b5379bcbbf881$var$Nav4AppsForLandingInnerNav4);
function $e74b5379bcbbf881$var$Nav4AppsForLandingInnerGSN(props) {
    const { actionsOnHover: actionsOnHover, draggableRef: draggableRef, dropIndicator: dropIndicator, formattedMessage: formattedMessage, handleExpansionToggle: handleExpansionToggle, hasDragIndicator: hasDragIndicator, icon: icon, isDragging: isDragging, isExpanded: isExpanded, menuId: menuId, onExpandFlyoutToggle: onExpandFlyoutToggle, queryRef: queryRef, navigationCustomisationFragment: navigationCustomisationFragment, visualContentRef: visualContentRef } = props;
    const handleExpansionToggle2 = (0, $euxye.useCallback)((hasExpanded)=>{
        handleExpansionToggle(hasExpanded);
        onExpandFlyoutToggle?.(hasExpanded);
    }, [
        onExpandFlyoutToggle,
        handleExpansionToggle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        dropTargetRef: visualContentRef,
        dropIndicator: dropIndicator,
        isDragging: isDragging,
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: handleExpansionToggle2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        hasDragIndicator: hasDragIndicator,
        interactionName: "nav4-sidebar-apps-landing",
        isDragging: isDragging,
        ref: draggableRef,
        testId: (0, $jzXAj.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-apps-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $OmFIT.Nav4AppsContent), {
        queryRef: queryRef,
        navigationCustomisationFragment: navigationCustomisationFragment
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lEazp.ExploreMoreApps), null))));
}
$e74b5379bcbbf881$var$Nav4AppsForLandingInnerGSN.displayName = "Nav4AppsForLandingInnerGSN";
function $e74b5379bcbbf881$var$Nav4AppsForLandingInnerNav4(props) {
    const { actionsOnHover: actionsOnHover, formattedMessage: formattedMessage, handleExpansionToggle: handleExpansionToggle, icon: icon, isExpanded: isExpanded, menuId: menuId, queryRef: queryRef, navigationCustomisationFragment: navigationCustomisationFragment } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: handleExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        interactionName: "nav4-sidebar-apps-landing",
        testId: (0, $jzXAj.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-apps-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $OmFIT.Nav4AppsContent), {
        queryRef: queryRef,
        navigationCustomisationFragment: navigationCustomisationFragment
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lEazp.ExploreMoreApps), null))));
}
$e74b5379bcbbf881$var$Nav4AppsForLandingInnerNav4.displayName = "Nav4AppsForLandingInnerNav4";

});
parcelRegister("7zJb7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed10ae38b175084d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63603d5d3d43ffcefaad1a16fe7f44a1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ed10ae38b175084d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4AppsForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4AppsContent"
        }
    ],
    "type": "JiraQuery"
};
$ed10ae38b175084d$var$node.hash = "9c28cb4a0c92a920a58010f91f4f4f0e";
var $ed10ae38b175084d$export$2e2bcd8739ae039 = $ed10ae38b175084d$var$node;

});

parcelRegister("OmFIT", function(module, exports) {
$parcel$export(module.exports, "Nav4AppsContent", () => $9331913fb35bb811$export$aaf45d195a81792d);

var $a2Cqd = parcelRequire("a2Cqd");

var $sYNqN = parcelRequire("sYNqN");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");


var $1t7X3 = parcelRequire("1t7X3");

var $arK7p = parcelRequire("arK7p");

var $aHmTX = parcelRequire("aHmTX");

var $aAtKo = parcelRequire("aAtKo");

var $atwsb = parcelRequire("atwsb");

var $ar9gx = parcelRequire("ar9gx");

var $djYhH = parcelRequire("djYhH");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aeLE4 = parcelRequire("aeLE4");

var $8VQKB = parcelRequire("8VQKB");

var $7LgQz = parcelRequire("7LgQz");

var $kIU6u = parcelRequire("kIU6u");
const $9331913fb35bb811$var$yourApps = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-apps.common.content.your-apps",
    defaultMessage: "Your apps"
});
function $9331913fb35bb811$export$aaf45d195a81792d({ queryRef: queryRef, navigationCustomisationFragment: navigationCustomisationFragment }) {
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $sYNqN.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    const navigationCustomisation = (0, $n67Vb.useFragment)((0, $a2Cqd.default), navigationCustomisationFragment);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    let apps = {
        currentItems: [],
        currentOrder: [],
        list: []
    };
    if ((0, $2700E.expVal)('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) {
        // oxlint-disable-next-line react-hooks/rules-of-hooks
        const appNodes = (0, $euxye.useMemo)(()=>(data.globalAppNavigationItems?.edges?.filter((edge)=>edge != null && edge !== undefined)?.map((edge)=>edge.node).filter((node)=>node != null || node !== undefined).filter((node)=>{
                // Keep only Forge and Connect apps on the list
                if (node?.appType !== 'CONNECT' && node?.appType !== 'FORGE') return false;
                // Filter out system apps just like it was done in the old navigation
                return node?.appId !== (0, $09874aa233b24c7d$export$d61a3cd2f28931bc);
            }).filter((node)=>node).sort((a, b)=>(a?.label || '').localeCompare(b?.label || '')) || []) ?? [], [
            data.globalAppNavigationItems?.edges
        ]);
        // oxlint-disable-next-line react-hooks/rules-of-hooks
        apps = (0, $atwsb.useReorderableStarredItems)({
            favourites: appNodes,
            lastOrder: navigationCustomisation?.sidebar?.nodes,
            getId: (item)=>item.appId || '',
            getLabel: (item)=>item?.label?.toString() || '',
            getHasNextPage: ()=>Boolean(data.globalAppNavigationItems?.pageInfo?.hasNextPage),
            renderMenuItem: (node, currentItems, currentOrder, item)=>{
                switch(node?.appType){
                    case 'CONNECT':
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8VQKB.Nav4ConnectMenuItem), {
                            key: node.id,
                            queryRef: node,
                            currentItems: currentItems,
                            currentOrder: currentOrder,
                            item: item
                        });
                    case 'FORGE':
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7LgQz.Nav4ForgeMenuItem), {
                            key: node.id,
                            queryRef: node,
                            currentItems: currentItems,
                            currentOrder: currentOrder,
                            item: item
                        });
                    default:
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null);
                }
            },
            maxItems: 1000000
        });
    }
    const menuItemNodes = (0, $euxye.useMemo)(()=>(data?.globalAppNavigationItems?.edges || []).filter((edge)=>{
            // Keep only Forge and Connect apps on the list
            if (edge?.node?.appType !== 'CONNECT' && edge?.node?.appType !== 'FORGE') return false;
            // Filter out system apps just like it was done in the old navigation
            return edge?.node?.appId !== (0, $09874aa233b24c7d$export$d61a3cd2f28931bc);
        }).map((edge)=>edge?.node).sort((a, b)=>(a?.label || '').localeCompare(b?.label || '')) || [], [
        data?.globalAppNavigationItems
    ]);
    const renderedMenuItems = (0, $euxye.useMemo)(()=>menuItemNodes.map((node)=>{
            switch(node?.appType){
                case 'CONNECT':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8VQKB.Nav4ConnectMenuItem), {
                        key: node.id,
                        queryRef: node,
                        currentItems: undefined,
                        currentOrder: undefined,
                        item: undefined
                    });
                case 'FORGE':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7LgQz.Nav4ForgeMenuItem), {
                        key: node.id,
                        queryRef: node,
                        currentItems: undefined,
                        currentOrder: undefined,
                        item: undefined
                    });
                default:
                    return null;
            }
        }).filter(Boolean), [
        menuItemNodes
    ]);
    const hasForgeApps = (0, $euxye.useMemo)(()=>menuItemNodes.some((node)=>node?.appType === 'FORGE'), [
        menuItemNodes
    ]);
    const renderDiscoverAppsSection = ()=>{
        if (!(0, $i860n.fg)('jira_nav4_apps_menu_recommend')) return null;
        if ((0, $2700E.expVal)('enable_jira_sidenav_2p_app_recommendations', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aAtKo.AsyncDiscoverSectionPostOffice), null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aAtKo.AsyncDiscoverSection), null));
    };
    if ((0, $2700E.expVal)('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) {
        // On experiment cleanup it should to remove this lint suppression and move the hook to a safe place...
        // oxlint-disable-next-line react-hooks/rules-of-hooks
        const { entityAri: entityAri, ownerAri: ownerAri, group: group } = (0, $kIU6u.useAppReordering)();
        return apps.list.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9331913fb35bb811$var$ForgeAnalyticsWrapper, {
            shouldReport: hasForgeApps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($9331913fb35bb811$var$yourApps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aeLE4.NestedItemDropTarget), {
            currentItems: apps.currentItems,
            currentOrder: apps.currentOrder,
            entityAri: entityAri,
            group: group,
            ownerAri: ownerAri
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, apps.list, hasForgeApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1t7X3.ForgeScreenEvent), {
            attributes: {
                moduleType: (0, $aHmTX.GLOBAL_PAGE_MODULE)
            }
        }))))), renderDiscoverAppsSection()) : null;
    }
    return renderedMenuItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9331913fb35bb811$var$ForgeAnalyticsWrapper, {
        shouldReport: hasForgeApps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($9331913fb35bb811$var$yourApps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, renderedMenuItems, hasForgeApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1t7X3.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $aHmTX.GLOBAL_PAGE_MODULE)
        }
    })))), renderDiscoverAppsSection()) : null;
}
$9331913fb35bb811$export$aaf45d195a81792d.displayName = "Nav4AppsContent";
function $9331913fb35bb811$var$ForgeAnalyticsWrapper({ shouldReport: shouldReport, children: children }) {
    return shouldReport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $arK7p.TriggerAnalyticsWrapper), null, children) : children;
}
$9331913fb35bb811$var$ForgeAnalyticsWrapper.displayName = "ForgeAnalyticsWrapper";

});
parcelRegister("a2Cqd", function(module, exports) {
$parcel$export(module.exports, "default", () => $d74d1e8cac7753b5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a4e17b9b34910bdeb0580a071fec4b93>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d74d1e8cac7753b5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4AppsContent_navigationCustomisation",
    "selections": [
        {
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsMenuItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "menuId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "visible"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SettingsNavigationCustomisation"
};
$d74d1e8cac7753b5$var$node.hash = "7ec05a83945ca64d0514182d60812eca";
var $d74d1e8cac7753b5$export$2e2bcd8739ae039 = $d74d1e8cac7753b5$var$node;

});

parcelRegister("sYNqN", function(module, exports) {
$parcel$export(module.exports, "default", () => $af5a5af77d6b9414$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<64482114778f0d4cb4c5602d9cc716a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $af5a5af77d6b9414$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4AppsContent",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraNavigationItemConnection",
            "kind": "LinkedField",
            "name": "globalAppNavigationItems",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraNavigationItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            "action": "THROW"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appType"
                                                }
                                            ],
                                            "type": "JiraAppNavigationItem"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "Nav4ConnectMenuItem"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "Nav4ForgeMenuItem"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$af5a5af77d6b9414$var$node.hash = "e4a5ba59f2823f40da9513d3a41d72df";
var $af5a5af77d6b9414$export$2e2bcd8739ae039 = $af5a5af77d6b9414$var$node;

});

const $09874aa233b24c7d$export$d61a3cd2f28931bc = 'com.atlassian.jira.emcee__enduser-discover';

parcelRegister("1t7X3", function(module, exports) {
$parcel$export(module.exports, "ForgeScreenEvent", () => $cd342a8a305051f1$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $cd342a8a305051f1$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $cd342a8a305051f1$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $cd342a8a305051f1$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $cd342a8a305051f1$export$14e56d7f5d3f917c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $aHmTX = parcelRequire("aHmTX");

var $fcY55 = parcelRequire("fcY55");

var $dipKF = parcelRequire("dipKF");

var $aZMdt = parcelRequire("aZMdt");
var $aJ81Y = parcelRequire("aJ81Y");
var $aqPkH = parcelRequire("aqPkH");
var $4BBh0 = parcelRequire("4BBh0");

var $i860n = parcelRequire("i860n");

var $lz4O3 = parcelRequire("lz4O3");

var $9x0Ea = parcelRequire("9x0Ea");

var $e68p8 = parcelRequire("e68p8");

var $LViSn = parcelRequire("LViSn");

var $irM5O = parcelRequire("irM5O");

var $82B9c = parcelRequire("82B9c");
const $cd342a8a305051f1$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireScreenAnalytics), {
        attributes: (0, $9x0Ea.createAttributes)(attributes)
    });
$cd342a8a305051f1$export$92d758d83665314b.displayName = "ForgeScreenEvent";
const $cd342a8a305051f1$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $e68p8.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $cd342a8a305051f1$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $dipKF.useHasForgeAccess)();
    const analyticsAttributes = (0, $euxye.useMemo)(()=>(0, $9x0Ea.createAttributes)({
            ...attributes,
            hasForgeAccess: hasForgeAccess
        }), [
        attributes,
        hasForgeAccess
    ]);
    const fireEvent = (0, $euxye.useCallback)((analyticsEvent)=>{
        (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, (0, $irM5O.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4BBh0.MountEvent), {
        onMount: fireEvent
    });
};
$cd342a8a305051f1$export$4c46624a93517c10.displayName = "ForgeMountEvent";
const $cd342a8a305051f1$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceType: (0, $46f069e6c968f461$export$f636b5b56f1d624a),
        sourceName: `${(0, $lz4O3.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
$cd342a8a305051f1$export$f461e628d5e73fa0.displayName = "ForgeContextualAnalyticsData";
const $cd342a8a305051f1$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $euxye.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $euxye.useCallback)((error)=>(0, $9x0Ea.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $lz4O3.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
$cd342a8a305051f1$export$ac7e7464cefab440.displayName = "ForgeErrorBoundary";
const $cd342a8a305051f1$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $lz4O3.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $i860n.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $irM5O.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    }) : (0, $irM5O.getEventIdOld)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $euxye.useMemo)(()=>(0, $9x0Ea.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($cd342a8a305051f1$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($cd342a8a305051f1$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($cd342a8a305051f1$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
$cd342a8a305051f1$export$ad2a5d9127152fb8.displayName = "ForgeAnalyticsWrapper";
const $cd342a8a305051f1$var$extensionModulesMeasuredFromTriggerClick = [
    (0, $aHmTX.GLOBAL_PAGE_MODULE),
    (0, $aHmTX.ISSUE_ACTION_MODULE),
    (0, $aHmTX.ISSUE_ACTIVITY_MODULE),
    (0, $aHmTX.ISSUE_CONTEXT_MODULE),
    (0, $aHmTX.ISSUE_GLANCE_MODULE),
    (0, $aHmTX.ISSUE_NAVIGATOR_ACTION_MODULE),
    (0, $aHmTX.ISSUE_PANEL_MODULE),
    (0, $aHmTX.CUSTOM_FIELD_MODULE),
    (0, $aHmTX.CUSTOM_FIELD_TYPE_MODULE),
    (0, $aHmTX.PROJECT_PAGE_MODULE),
    (0, $aHmTX.ADMIN_PAGE_MODULE),
    (0, $aHmTX.PROJECT_SETTINGS_PAGE_MODULE),
    (0, $aHmTX.BACKLOG_ACTION_MODULE),
    (0, $aHmTX.BOARD_ACTION_MODULE),
    (0, $aHmTX.SPRINT_ACTION_MODULE),
    (0, $aHmTX.PERSONAL_SETTINGS_PAGE_MODULE)
];
function $cd342a8a305051f1$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    // Modules in the allow-list have their load metric started by the user/page trigger
    // before this HOC mounts. Starting again here would drop trigger-to-mount latency;
    // modules without that trigger start from this HOC mount. Custom fields and panels
    // are mixed-mode, so only edit fields outside issue-create and newly-added panels
    // use the trigger-start path. BM3 and WIV UFO share this timing boundary.
    if ((extensionModule === (0, $aHmTX.CUSTOM_FIELD_MODULE) || extensionModule === (0, $aHmTX.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $aHmTX.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return $cd342a8a305051f1$var$extensionModulesMeasuredFromTriggerClick.includes(extensionModule);
}
const $cd342a8a305051f1$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const startTime = (0, $euxye.useRef)(performance.now());
        const isLoadMetricPending = (0, $euxye.useRef)(false);
        const isCustomUI = (0, $fcY55.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $euxye.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, onInitialRender: onInitialRender, onLoad: onLoad, extension: extension, useWorkItemUfoKey: useWorkItemUfoKey = false } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $i860n.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $irM5O.getEventId)({
            module: module,
            entryPoint: entryPoint
        }) : (0, $irM5O.getEventIdOld)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $i860n.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $irM5O.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $fcY55.getForgeUIType)(extension, entryPoint)
        }) : (0, $irM5O.getBrowserMetricsEventIdOld)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $fcY55.getForgeUIType)(extension, entryPoint)
        });
        const loadMetricEventId = useWorkItemUfoKey ? (0, $82B9c.toWorkItemUfoKey)(browserMetricsEventId) : browserMetricsEventId;
        const attributes = (0, $euxye.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $LViSn.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // oxlint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        (0, $euxye.useEffect)(()=>{
            if (!$cd342a8a305051f1$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) {
                isLoadMetricPending.current = true;
                if (useWorkItemUfoKey) (0, $82B9c.startConcurrentWorkItemExperience)(extensionId, loadMetricEventId, {
                    startTime: startTime.current
                });
                else (0, $82B9c.forgeModulesConcurrentLoadTime)(extensionId).start({
                    startTime: startTime.current
                });
                return ()=>{
                    if (!isLoadMetricPending.current) return;
                    isLoadMetricPending.current = false;
                    if (useWorkItemUfoKey) (0, $82B9c.cancelConcurrentWorkItemExperience)(extensionId, loadMetricEventId);
                    else (0, $82B9c.forgeModulesConcurrentLoadTime)(extensionId).cancel();
                };
            }
        }, // We want to run this code only once on mount
        // oxlint-disable-next-line react-hooks/exhaustive-deps
        []);
        const onError = (0, $euxye.useCallback)(()=>{
            if (!extensionId) return;
            if (useWorkItemUfoKey) (0, $82B9c.cancelConcurrentWorkItemExperience)(extensionId, loadMetricEventId);
            else (0, $82B9c.forgeModulesConcurrentLoadTime)(extensionId).cancel();
            isLoadMetricPending.current = false;
        }, [
            extensionId,
            loadMetricEventId,
            useWorkItemUfoKey
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $euxye.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                if (extensionId) {
                    if (useWorkItemUfoKey) (0, $82B9c.stopConcurrentWorkItemExperience)(extensionId, loadMetricEventId, {
                        stopTime: performance.now() - stopTimeDeduction,
                        customData: {
                            eventId: loadMetricEventId
                        }
                    });
                    else (0, $82B9c.forgeModulesConcurrentLoadTime)(extensionId).stop({
                        stopTime: performance.now() - stopTimeDeduction,
                        customData: {
                            eventId: browserMetricsEventId
                        }
                    });
                    isLoadMetricPending.current = false;
                }
            } else {
                onError();
                (0, $e68p8.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            loadMetricEventId,
            onError,
            eventId,
            attributes,
            useWorkItemUfoKey,
            browserMetricsEventId
        ]);
        const onLoadCustomUiWithMetrics = (0, $euxye.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            if (extensionId) {
                if (useWorkItemUfoKey) (0, $82B9c.stopConcurrentWorkItemExperience)(extensionId, loadMetricEventId, {
                    stopTime: performance.now(),
                    customData: {
                        eventId: loadMetricEventId
                    }
                });
                else (0, $82B9c.forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now(),
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
                isLoadMetricPending.current = false;
            }
        // SMT-1418
        }, [
            extensionId,
            loadMetricEventId,
            onLoad,
            useWorkItemUfoKey,
            browserMetricsEventId
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($cd342a8a305051f1$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($cd342a8a305051f1$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("fcY55", function(module, exports) {
$parcel$export(module.exports, "getForgeUIType", () => $3adbe43566c3eb7f$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $3adbe43566c3eb7f$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $3adbe43566c3eb7f$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $3adbe43566c3eb7f$export$42b85bc9b386c977);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6jLTU = parcelRequire("6jLTU");
const $3adbe43566c3eb7f$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $3adbe43566c3eb7f$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$3adbe43566c3eb7f$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $3adbe43566c3eb7f$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$3adbe43566c3eb7f$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $3adbe43566c3eb7f$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(propsToOverride)) return extension;
    const { resource: resource, resolvedResourceEntry: resolvedResourceEntry } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        }
    };
    if (resource != null) {
        extensionCopy.properties.resource = resource;
        // A swapped-in (dynamic) resource can never keep the previous resource's entry, so the parent's
        // resolvedResourceEntry is always reset when the resource is overridden
        extensionCopy.properties.resolvedResourceEntry = resolvedResourceEntry;
    }
    return extensionCopy;
};

});

parcelRegister("dipKF", function(module, exports) {
$parcel$export(module.exports, "useHasForgeAccess", () => $6b0f86e820d049c3$export$fd7f94d3d2bac7f2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $6b0f86e820d049c3$export$fd7f94d3d2bac7f2 = ()=>{
    return true;
};

});

parcelRegister("e68p8", function(module, exports) {
$parcel$export(module.exports, "fireOperationalFailedEvent", () => $83dd83b163312446$export$add44f896fb31ba3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $lz4O3 = parcelRequire("lz4O3");

var $cXwmT = parcelRequire("cXwmT");
const $83dd83b163312446$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $cXwmT.fireOperationalEvent)((0, $lz4O3.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});

parcelRegister("LViSn", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $5bd0e396199799cf$export$5d3b06ab08af139e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fcY55 = parcelRequire("fcY55");

var $awsUf = parcelRequire("awsUf");
const $5bd0e396199799cf$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $awsUf.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $fcY55.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType,
        entryPoint: entryPoint
    };
};

});

parcelRegister("irM5O", function(module, exports) {
$parcel$export(module.exports, "getEventId", () => $00324c1eb5553f56$export$5639f6a927500d9);
$parcel$export(module.exports, "getEventIdOld", () => $00324c1eb5553f56$export$b2919e256f1e5dfc);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $00324c1eb5553f56$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getBrowserMetricsEventIdOld", () => $00324c1eb5553f56$export$66db5d4145894f38);
$parcel$export(module.exports, "getEventActionName", () => $00324c1eb5553f56$export$644ccb9a67b9a9c1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aHmTX = parcelRequire("aHmTX");

var $aoZbr = parcelRequire("aoZbr");

var $lz4O3 = parcelRequire("lz4O3");
const $00324c1eb5553f56$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $00324c1eb5553f56$var$prepareModuleMode = (entryPoint)=>`${$00324c1eb5553f56$var$capitalizeFirstLetter(entryPoint)}`;
const $00324c1eb5553f56$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $00324c1eb5553f56$var$prepareModuleName = (moduleName)=>(0, $aHmTX.SUPPORTED_MODULES).includes(moduleName) ? $00324c1eb5553f56$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $00324c1eb5553f56$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $lz4O3.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $aoZbr.toEventId)(`${$00324c1eb5553f56$var$prepareModuleName(module)}${eventNamePostfix}`);
    return (0, $aoZbr.toEventId)(`${$00324c1eb5553f56$var$prepareModuleName(module)}${$00324c1eb5553f56$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $00324c1eb5553f56$export$b2919e256f1e5dfc = ({ module: module, moduleType: moduleType = (0, $lz4O3.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $aoZbr.toEventId)(`${$00324c1eb5553f56$var$prepareModuleName(module)}${$00324c1eb5553f56$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $00324c1eb5553f56$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $aoZbr.toEventId)(`${$00324c1eb5553f56$var$prepareModuleName(module)}-${forgeUiType}`);
    return (0, $aoZbr.toEventId)(`${$00324c1eb5553f56$var$prepareModuleName(module)}${$00324c1eb5553f56$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $00324c1eb5553f56$export$66db5d4145894f38 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    return (0, $aoZbr.toEventId)(`${$00324c1eb5553f56$var$prepareModuleName(module)}${$00324c1eb5553f56$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $00324c1eb5553f56$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $lz4O3.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});


parcelRegister("arK7p", function(module, exports) {
$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $f39093125de789a6$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $f39093125de789a6$export$e1a79e3d472c925a);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $aHmTX = parcelRequire("aHmTX");

var $1t7X3 = parcelRequire("1t7X3");

var $lz4O3 = parcelRequire("lz4O3");
const $f39093125de789a6$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1t7X3.ForgeAnalyticsWrapper), {
        module: (0, $aHmTX.GLOBAL_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
$f39093125de789a6$export$c794eb4124961145.displayName = "ViewAnalyticsWrapper";
const $f39093125de789a6$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1t7X3.ForgeAnalyticsWrapper), {
        module: (0, $aHmTX.GLOBAL_PAGE_MODULE),
        moduleType: (0, $lz4O3.MODULE_TYPE_TRIGGER),
        ...props
    });
$f39093125de789a6$export$e1a79e3d472c925a.displayName = "TriggerAnalyticsWrapper";

});

parcelRegister("aAtKo", function(module, exports) {
$parcel$export(module.exports, "AsyncDiscoverSection", () => $c01270f626c77c99$export$45fe6164578a6f29);
$parcel$export(module.exports, "AsyncDiscoverSectionPostOffice", () => $c01270f626c77c99$export$ab2150bd3d64c3e6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $l8G1z = parcelRequire("l8G1z");

const $c01270f626c77c99$export$45fe6164578a6f29 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("eqoJY")).then((module)=>module.DiscoverSection), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-content-marketplace-recommendations/src/ui/discover-section/DiscoverSection.tsx"
});

const $c01270f626c77c99$export$ab2150bd3d64c3e6 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("1J7Bh")).then((module)=>module.DiscoverSectionPostOffice), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-content-marketplace-recommendations/src/ui/discover-section-post-office/DiscoverSectionPostOffice.tsx"
});

});
parcelRegister("eqoJY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ecH0b").then(()=>parcelRequire('9Tl4t'));

});

parcelRegister("1J7Bh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("76oxt").then(()=>parcelRequire('fgnU8'));

});


parcelRegister("atwsb", function(module, exports) {
$parcel$export(module.exports, "useReorderableStarredItems", () => $c1dbf9ed6816de84$export$b72ae34fb8e2338d);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
function $c1dbf9ed6816de84$export$b72ae34fb8e2338d({ favourites: favourites, lastOrder: lastOrder, getId: getId, getLabel: getLabel, getHasNextPage: getHasNextPage, maxItems: maxItems, renderMenuItem: renderMenuItem }) {
    const reorderableStarredItemData = (0, $euxye.useMemo)(()=>{
        const ids = favourites.map((favourite)=>getId(favourite)).filter(Boolean) ?? [];
        const preferredItemOrder = lastOrder?.map((node)=>({
                menuId: node?.menuId || '',
                visible: node?.visible || false
            })).filter((item)=>item.menuId) || [];
        const preferredItemIds = preferredItemOrder.map((item)=>item.menuId);
        // Filter out any previously ordered items that are no longer available...
        const filteredPreferredItemOrder = preferredItemOrder.filter((item)=>ids.includes(item.menuId));
        // Find any available items that weren't in the starred list (these will get added to the end)
        const newItemIds = ids.filter((id)=>!preferredItemIds.includes(id));
        // Combine the two to get the final order
        const finalItemOrderIds = [
            ...filteredPreferredItemOrder.map((item)=>item.menuId),
            ...newItemIds
        ];
        const list = [];
        const currentItems = [];
        finalItemOrderIds.forEach((itemId)=>{
            const itemEdge = favourites.find((edge)=>getId(edge) === itemId);
            if (itemEdge) {
                const item = {
                    id: getId(itemEdge) || '',
                    label: getLabel(itemEdge) || ''
                };
                currentItems.push(item);
                getId(itemEdge) && list.push(renderMenuItem(itemEdge, currentItems, preferredItemOrder, item));
            }
        });
        return {
            idSet: new Set(finalItemOrderIds),
            list: list.slice(0, maxItems),
            hasItems: Boolean(list.length),
            hasNextPage: getHasNextPage && getHasNextPage() || list.length > maxItems,
            currentOrder: preferredItemOrder,
            currentItems: currentItems
        };
    }, [
        favourites,
        lastOrder,
        getHasNextPage,
        getId,
        getLabel,
        renderMenuItem,
        maxItems
    ]);
    return reorderableStarredItemData;
}

});

parcelRegister("6w18e", function(module, exports) {
$parcel$export(module.exports, "MenuSection", () => $d7c94acd06277c52$export$4b1545b4f2016d26);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $gUxVT = parcelRequire("gUxVT");

var $ar9gx = parcelRequire("ar9gx");

var $jeZjl = parcelRequire("jeZjl");
const $d7c94acd06277c52$export$4b1545b4f2016d26 = ({ children: children, testId: testId, ariaLabel: ariaLabel, isMenuListItem: isMenuListItem = false })=>{
    const id = (0, $gUxVT.useId)();
    const content = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jeZjl.MenuSectionContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            role: "group",
            "aria-labelledby": `${id}-heading`,
            "aria-label": ariaLabel,
            children: children
        })
    });
    if (isMenuListItem) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ar9gx.MenuListItem), {
        testId: testId,
        children: content
    });
    // Legacy. isMenuListItem should become default.
    return content;
};
$d7c94acd06277c52$export$4b1545b4f2016d26.displayName = "MenuSection";

});
parcelRegister("jeZjl", function(module, exports) {
$parcel$export(module.exports, "MenuSectionContext", () => $e11aad659ffe7765$export$728ac99b9c7eea8a);
$parcel$export(module.exports, "useMenuSectionContext", () => $e11aad659ffe7765$export$8100cda602411810);

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");
const $e11aad659ffe7765$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $euxye.createContext)(null);
const $e11aad659ffe7765$export$8100cda602411810 = ()=>{
    const context = (0, $euxye.useContext)($e11aad659ffe7765$export$728ac99b9c7eea8a);
    (0, $jiTLE.default)(context, 'useMenuSectionContext must be used within a MenuSection');
    return context;
};

});


parcelRegister("5EY0v", function(module, exports) {
$parcel$export(module.exports, "MenuSectionHeading", () => $39543cd0097d1c11$export$5d3acdbf9237a364);
/* menu-section-heading.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $jeZjl = parcelRequire("jeZjl");
const $39543cd0097d1c11$var$styles = {
    root: "_11c8i4vh _1rjcu2gc _syaz1rpy _bozg12x7"
};
const $39543cd0097d1c11$export$5d3acdbf9237a364 = ({ children: children, headingLevel: headingLevel })=>{
    const id = (0, $jeZjl.useMenuSectionContext)();
    const HeadingTag = headingLevel ? `h${headingLevel}` : 'p';
    return /*#__PURE__*/ (0, $e79Pd.jsx)(HeadingTag, {
        id: `${id}-heading`,
        className: (0, $4jQY2.default)([
            $39543cd0097d1c11$var$styles.root
        ]),
        children: children
    });
};
$39543cd0097d1c11$export$5d3acdbf9237a364.displayName = "MenuSectionHeading";

});

parcelRegister("aeLE4", function(module, exports) {
$parcel$export(module.exports, "NestedItemDropTarget", () => $c272764ee770975d$export$f9a288e6c040b835);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4uPjr = parcelRequire("4uPjr");

var $jufsF = parcelRequire("jufsF");

var $9sYLJ = parcelRequire("9sYLJ");

var $li8uM = parcelRequire("li8uM");
function $c272764ee770975d$export$f9a288e6c040b835({ children: children, currentItems: currentItems, currentOrder: currentOrder, entityAri: entityAri, fireAnalyticsEvent: fireAnalyticsEvent, group: group, ownerAri: ownerAri, testId: testId }) {
    const mappedCurrentItems = currentItems.map((item)=>{
        return (0, $9sYLJ.createNestedItemData)({
            menuItemId: item.id,
            entityAri: entityAri,
            ownerAri: ownerAri,
            group: entityAri,
            label: item.label,
            isReorderable: true
        });
    });
    const { ref: ref, state: state } = (0, $li8uM.useNestedItemDropTarget)({
        entityAri: entityAri,
        ownerAri: ownerAri,
        currentItems: mappedCurrentItems,
        currentOrder: currentOrder,
        fireAnalyticsEvent: fireAnalyticsEvent,
        group: group
    });
    const elementRegistry = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>(0, $jufsF.createElementRegistry)(), []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4uPjr.GroupDropIndicator), {
        isActive: state === 'is-over',
        ref: ref,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jufsF.ElementRegistryProvider), {
            registry: elementRegistry,
            children: children
        })
    });
}
$c272764ee770975d$export$f9a288e6c040b835.displayName = "NestedItemDropTarget";

});
parcelRegister("4uPjr", function(module, exports) {
$parcel$export(module.exports, "GroupDropIndicator", () => $27e1c4ec22f9c743$export$cb7fd016127fc6fc);
/* group.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $27e1c4ec22f9c743$var$activeStyles = null;
const $27e1c4ec22f9c743$export$cb7fd016127fc6fc = /*#__PURE__*/ (0, $euxye.forwardRef)(function GroupDropIndicator({ children: children, isActive: isActive, testId: testId }, forwardedRef) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: forwardedRef,
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            isActive && "_2rkolb4i _bfhk19ip _1cwg12x7 _12y31dm9 _1qu2nqa1 _12jiq98m"
        ]),
        children: children
    });
});

});

parcelRegister("li8uM", function(module, exports) {
$parcel$export(module.exports, "useNestedItemDropTarget", () => $a47290928558a49e$export$958e27a7956cf369);

var $9sYLJ = parcelRequire("9sYLJ");

var $bbfoK = parcelRequire("bbfoK");

var $41NKP = parcelRequire("41NKP");
const $a47290928558a49e$export$958e27a7956cf369 = ({ entityAri: entityAri, ownerAri: ownerAri, currentItems: currentItems, currentOrder: currentOrder, fireAnalyticsEvent: fireAnalyticsEvent, group: group })=>{
    const updateOrder = (0, $bbfoK.useUpdateNestedItemOrder)();
    return (0, $41NKP.useDropTarget)({
        canDrop: (dropData)=>{
            return (0, $9sYLJ.isNestedItemData)(dropData) && dropData.entityAri === entityAri && dropData.group === group;
        },
        isDraggableItem: (dragData)=>{
            return (0, $9sYLJ.isNestedItemData)(dragData) && dragData.entityAri === entityAri && dragData.group === group;
        },
        performDropOperation: (operation, dragging, dropTargetData)=>{
            updateOrder({
                operation: operation,
                entityAri: entityAri,
                ownerAri: ownerAri,
                targetItemId: dragging.menuItemId,
                relativeItemId: dropTargetData.menuItemId,
                currentOrder: currentOrder,
                currentItems: currentItems,
                getItemId: (item)=>item.menuItemId,
                fireAnalyticsEvent: fireAnalyticsEvent
            });
        }
    });
};

});
parcelRegister("bbfoK", function(module, exports) {
$parcel$export(module.exports, "useUpdateNestedItemOrder", () => $f24ca06139c92fb6$export$4c81fdc7e4220cd7);

var $dMTJQ = parcelRequire("dMTJQ");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $eSAXC = parcelRequire("eSAXC");

var $gCfx2 = parcelRequire("gCfx2");
const $f24ca06139c92fb6$export$4c81fdc7e4220cd7 = ()=>{
    const [commitMutation] = (0, $n67Vb.useMutation)((0, $dMTJQ.default));
    // Helper function to calculate new order from provided current data
    const calculateNewOrderFromCurrentData = (0, $euxye.useCallback)((currentItems, getItemId, currentOrder, operation, targetItemId, relativeItemId)=>{
        const allItemIds = currentItems.map((item)=>getItemId(item));
        let latestOrder = [];
        // If we have existing order, use it to determine current order
        if (currentOrder && currentOrder.length > 0) {
            // Use order for items that exist in both preference and current items
            const orderedIds = currentOrder.filter((item)=>allItemIds.includes(getItemId(item))).map((item)=>getItemId(item));
            // Add any items not in preference order (newly added)
            const remainingIds = allItemIds.filter((id)=>!orderedIds.includes(id));
            latestOrder = [
                ...orderedIds,
                ...remainingIds
            ];
        } else // No previous order exists, use current items order
        latestOrder = allItemIds;
        // Calculate new order using the reorder utility
        // targetItemId is the item being moved/reordered, relativeItemId is the position reference
        const newOrder = (0, $eSAXC.reorderNestedItems)(operation, latestOrder, targetItemId, relativeItemId); // Convert back to sidebar format
        const result = newOrder.map((menuId)=>({
                menuId: menuId,
                visible: true // All boards are visible
            }));
        return result;
    }, []);
    const updateNavigationItemOrder = (0, $euxye.useCallback)(({ operation: operation, entityAri: entityAri, ownerAri: ownerAri, targetItemId: targetItemId, relativeItemId: relativeItemId, currentItems: currentItems, currentOrder: currentOrder, fireAnalyticsEvent: fireAnalyticsEvent, getItemId: getItemId, handleError: handleError })=>{
        // If current data is provided, calculate the new order without fetching
        let calculatedSidebarOrder = [];
        // First try to get fresh data from the store reader function
        let effectiveCurrentItems = currentItems;
        let effectiveCurrentSidebarOrder = currentOrder;
        if (effectiveCurrentItems && effectiveCurrentSidebarOrder) // Calculate new order using current data (either from store or props)
        calculatedSidebarOrder = calculateNewOrderFromCurrentData(effectiveCurrentItems, getItemId, effectiveCurrentSidebarOrder, operation, targetItemId, // The item being moved
        relativeItemId // The position reference (if any)
        );
        commitMutation({
            variables: {
                input: {
                    entityAri: entityAri,
                    ownerAri: ownerAri,
                    sidebar: calculatedSidebarOrder.length > 0 ? calculatedSidebarOrder : []
                }
            },
            optimisticResponse: {
                settings_updateNavigationCustomisation: {
                    id: `${entityAri}-sidebar-order`,
                    sidebar: {
                        nodes: calculatedSidebarOrder.length > 0 ? calculatedSidebarOrder : []
                    }
                }
            },
            optimisticUpdater: (storeProxy)=>{
                // Apply the optimistic update to the store for immediate UI feedback
                (0, $gCfx2.optimisticNestedItemUpdater)({
                    store: storeProxy,
                    operation: operation,
                    entityAri: entityAri,
                    ownerAri: ownerAri,
                    targetItemId: targetItemId,
                    relativeItemId: relativeItemId,
                    currentItems: effectiveCurrentItems,
                    getItemId: getItemId
                });
            },
            onCompleted: (_response, errors)=>{
                if (errors && errors.length > 0) handleError && handleError(new Error(errors[0].message));
                else fireAnalyticsEvent && fireAnalyticsEvent({
                    action: 'updated',
                    itemId: targetItemId,
                    operation: operation
                });
            },
            onError: (error)=>{
                handleError && handleError(error);
            }
        });
    }, [
        commitMutation,
        calculateNewOrderFromCurrentData
    ]);
    return updateNavigationItemOrder;
};

});
parcelRegister("dMTJQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f116ad5cca2ff70d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<59b899e8bd380d346b867003c71f8738>>
 * @relayHash 83ab3e1125e283dbf6e6390477296f1f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cfb52c9efc9b3c41fe1bcd31142566157d9f0551b2c0e16e355846a12a24f724
const $f116ad5cca2ff70d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "concreteType": "SettingsMenuItemConnection",
        "kind": "LinkedField",
        "name": "sidebar",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsMenuItem",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "menuId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "visible"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useUpdateNestedItemOrderMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_updateNavigationCustomisation",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useUpdateNestedItemOrderMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_updateNavigationCustomisation",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cfb52c9efc9b3c41fe1bcd31142566157d9f0551b2c0e16e355846a12a24f724",
            "metadata": {},
            "name": "useUpdateNestedItemOrderMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$f116ad5cca2ff70d$var$node.hash = "944a7b0270efd174321b0b4015219ece";
var $f116ad5cca2ff70d$export$2e2bcd8739ae039 = $f116ad5cca2ff70d$var$node;

});

parcelRegister("eSAXC", function(module, exports) {
$parcel$export(module.exports, "reorderNestedItems", () => $c52e5777782d3ee1$export$5df271f33953d7d3);

var $jFnbs = parcelRequire("jFnbs");

var $9sYLJ = parcelRequire("9sYLJ");
const $c52e5777782d3ee1$export$5df271f33953d7d3 = (operation, list, itemId, relativeItemId)=>{
    const currentIndex = list.indexOf(itemId);
    if (currentIndex === -1) // Item not found, return original list
    return list;
    let targetIndex;
    switch(operation){
        case (0, $9sYLJ.OPERATIONS).MOVE_TO_TOP:
            targetIndex = 0;
            break;
        case (0, $9sYLJ.OPERATIONS).MOVE_UP:
            targetIndex = Math.max(0, currentIndex - 1);
            break;
        case (0, $9sYLJ.OPERATIONS).MOVE_DOWN:
            targetIndex = Math.min(list.length - 1, currentIndex + 1);
            break;
        case (0, $9sYLJ.OPERATIONS).MOVE_TO_BOTTOM:
            targetIndex = list.length - 1;
            break;
        case (0, $9sYLJ.OPERATIONS).BEFORE:
            if (!relativeItemId) return list;
            // If trying to move item before itself, no change needed
            if (itemId === relativeItemId) return list;
            targetIndex = list.indexOf(relativeItemId);
            if (targetIndex === -1) return list;
            // If item is moving from after the target to before it
            if (currentIndex > targetIndex) break;
            else // Moving forward, adjust target index to account for removal
            targetIndex = Math.max(0, targetIndex - 1);
            break;
        case (0, $9sYLJ.OPERATIONS).AFTER:
            if (!relativeItemId) return list;
            // If trying to move item after itself, no change needed
            if (itemId === relativeItemId) return list;
            targetIndex = list.indexOf(relativeItemId);
            if (targetIndex === -1) return list;
            // If item is moving from before the target to after it
            if (currentIndex < targetIndex) break;
            else // Moving backward, target becomes after the relative item
            targetIndex = Math.min(list.length - 1, targetIndex + 1);
            break;
        default:
            return list;
    }
    // Use the platform's reorder utility
    return (0, $jFnbs.reorder)({
        list: list,
        startIndex: currentIndex,
        finishIndex: targetIndex
    });
};

});

parcelRegister("gCfx2", function(module, exports) {
$parcel$export(module.exports, "optimisticNestedItemUpdater", () => $ada3f207132b3ba2$export$bbbe264bff74cd6c);

var $eSAXC = parcelRequire("eSAXC");
function $ada3f207132b3ba2$export$e6c5d7a168cbebc6(nodes) {
    const menuItems = [];
    if (!nodes) return menuItems;
    nodes.forEach((node)=>{
        if (!node) return;
        const menuId = node.getValue('menuId');
        const visible = node.getValue('visible');
        if (typeof menuId === 'string' && typeof visible === 'boolean') menuItems.push({
            menuId: menuId,
            visible: visible
        });
    });
    return menuItems;
}
function $ada3f207132b3ba2$export$2ac72a5767eca4dc(value) {
    if (typeof value === 'number') return value.toString();
    if (typeof value === 'string') return value;
    return null;
}
function $ada3f207132b3ba2$export$8dbc6f6b44b04e92(menuItems) {
    return menuItems.filter((item)=>item.visible === true).map((item)=>item.menuId);
}
function $ada3f207132b3ba2$export$7e2a5d627e106af7(existingOrderFromSettings, currentOrderedIds) {
    if (existingOrderFromSettings.length === 0) return [
        ...currentOrderedIds
    ];
    const baseOrder = existingOrderFromSettings.filter((itemId)=>currentOrderedIds.includes(itemId));
    const missingItems = currentOrderedIds.filter((itemId)=>!existingOrderFromSettings.includes(itemId));
    return [
        ...baseOrder,
        ...missingItems
    ];
}
function $ada3f207132b3ba2$export$a966611512587a5c(reorderedIds, originalMenuItems) {
    const newMenuItems = reorderedIds.map((itemId)=>({
            menuId: itemId,
            visible: true
        }));
    // Add any items that were in the original settings
    originalMenuItems.forEach((item)=>{
        if (!reorderedIds.includes(item.menuId)) newMenuItems.push({
            menuId: item.menuId,
            visible: item.visible
        });
    });
    return newMenuItems;
}
function $ada3f207132b3ba2$export$532f2a2470270cca(store, entityAri, ownerAri) {
    // Access the settings_navigationCustomisation data
    const currentOrder = store.getRoot().getLinkedRecord('settings_navigationCustomisation', {
        entityAri: entityAri,
        ownerAri: ownerAri
    });
    // Access the sidebar nodes if the record exists
    const sidebar = currentOrder?.getLinkedRecord('sidebar');
    const nodes = sidebar?.getLinkedRecords('nodes');
    return $ada3f207132b3ba2$export$e6c5d7a168cbebc6(nodes);
}
const $ada3f207132b3ba2$export$fc29d4acf9cb4898 = ({ store: store, entityAri: entityAri, ownerAri: ownerAri, operation: operation, targetItemId: targetItemId, relativeItemId: relativeItemId, currentItems: currentItems, getItemId: getItemId })=>{
    const currentOrder = store.getRoot().getLinkedRecord('settings_navigationCustomisation', {
        entityAri: entityAri,
        ownerAri: ownerAri
    });
    const sidebar = currentOrder?.getLinkedRecord('sidebar');
    const nodes = sidebar?.getLinkedRecords('nodes');
    const originalMenuItems = $ada3f207132b3ba2$export$e6c5d7a168cbebc6(nodes);
    const existingOrderFromSettings = $ada3f207132b3ba2$export$8dbc6f6b44b04e92(originalMenuItems);
    const availableItems = currentItems?.map((item)=>getItemId(item)) || [];
    const baseOrder = $ada3f207132b3ba2$export$7e2a5d627e106af7(existingOrderFromSettings, availableItems);
    const newOrder = (0, $eSAXC.reorderNestedItems)(operation, baseOrder, targetItemId, relativeItemId);
    return $ada3f207132b3ba2$export$a966611512587a5c(newOrder, originalMenuItems);
};
function $ada3f207132b3ba2$export$88d0fa3ce465e944(store, menuItems, entityAri) {
    return menuItems.map((nodeData)=>{
        const nodeRecord = store.create(`SettingsMenuItem:${entityAri}:${nodeData.menuId}`, 'SettingsMenuItem');
        nodeRecord.setValue(nodeData.menuId, 'menuId');
        nodeRecord.setValue(nodeData.visible, 'visible');
        return nodeRecord;
    });
}
function $ada3f207132b3ba2$export$eb567412f59134ac(store, entityAri, ownerAri, menuItemRecords) {
    const currentOrder = store.getRoot().getLinkedRecord('settings_navigationCustomisation', {
        entityAri: entityAri,
        ownerAri: ownerAri
    });
    const sidebar = currentOrder?.getLinkedRecord('sidebar');
    if (sidebar) // Update existing sidebar
    sidebar.setLinkedRecords(menuItemRecords, 'nodes');
    else if (currentOrder) {
        // Create sidebar for existing currentOrder
        const newSidebar = store.create(`SettingsMenuItemConnection:${entityAri}`, 'SettingsMenuItemConnection');
        newSidebar.setLinkedRecords(menuItemRecords, 'nodes');
        currentOrder.setLinkedRecord(newSidebar, 'sidebar');
    } else {
        // Create entire structure from scratch
        const newOrderRecord = store.create(`SettingsNavigationCustomisation:${entityAri}:${ownerAri}`, 'SettingsNavigationCustomisation');
        const newSidebar = store.create(`SettingsMenuItemConnection:${entityAri}`, 'SettingsMenuItemConnection');
        newSidebar.setLinkedRecords(menuItemRecords, 'nodes');
        newOrderRecord.setLinkedRecord(newSidebar, 'sidebar');
        store.getRoot().setLinkedRecord(newOrderRecord, 'settings_navigationCustomisation', {
            entityAri: entityAri,
            ownerAri: ownerAri
        });
    }
}
const $ada3f207132b3ba2$export$bbbe264bff74cd6c = ({ store: store, operation: operation, entityAri: entityAri, ownerAri: ownerAri, targetItemId: targetItemId, relativeItemId: relativeItemId, currentItems: currentItems, getItemId: getItemId })=>{
    // Calculate the new order using the pure function
    const newMenuItems = $ada3f207132b3ba2$export$fc29d4acf9cb4898({
        store: store,
        entityAri: entityAri,
        ownerAri: ownerAri,
        operation: operation,
        targetItemId: targetItemId,
        relativeItemId: relativeItemId,
        currentItems: currentItems,
        getItemId: getItemId
    });
    // Update the store if we have menu items
    if (newMenuItems.length > 0) {
        const menuItemRecords = $ada3f207132b3ba2$export$88d0fa3ce465e944(store, newMenuItems, entityAri);
        $ada3f207132b3ba2$export$eb567412f59134ac(store, entityAri, ownerAri, menuItemRecords);
    }
};

});


parcelRegister("41NKP", function(module, exports) {
$parcel$export(module.exports, "useDropTarget", () => $0e899fe83e364992$export$5967d4bb72ce3c0);

var $euxye = parcelRequire("euxye");

var $ijI7P = parcelRequire("ijI7P");

var $6rsYi = parcelRequire("6rsYi");

var $3nfFb = parcelRequire("3nfFb");

var $9sYLJ = parcelRequire("9sYLJ");
function $0e899fe83e364992$export$5967d4bb72ce3c0({ canDrop: canDrop, fireAnalyticsEvent: fireAnalyticsEvent, isDraggableItem: isDraggableItem, performDropOperation: performDropOperation }) {
    const ref = (0, $euxye.useRef)(null);
    const [state, setState] = (0, $euxye.useState)('idle');
    (0, $euxye.useEffect)(()=>{
        const element = ref.current;
        // might have no items
        if (!element) return;
        return (0, $3nfFb.dropTargetForElements)({
            element: element,
            canDrop: ({ source: source })=>{
                const data = source.data;
                return canDrop(data);
            },
            onDragStart ({ source: source }) {
                // Set is-over state when drag starts from within this group
                // This handles the case where drag begins inside the drop zone
                const data = source.data;
                if (isDraggableItem(data)) setState('is-over');
                $0e899fe83e364992$export$34ac71ce24cddec2(fireAnalyticsEvent, 'dragStarted', data.menuItemId);
            },
            onDragEnter ({ source: source }) {
                setState('is-over');
                const data = source.data;
                $0e899fe83e364992$export$34ac71ce24cddec2(fireAnalyticsEvent, 'dragEntered', data.menuItemId);
            },
            onDragLeave ({ source: source }) {
                setState('idle');
                const data = source.data;
                $0e899fe83e364992$export$34ac71ce24cddec2(fireAnalyticsEvent, 'dragLeft', data.menuItemId);
            },
            onDrop ({ source: source, location: location }) {
                setState('idle');
                const dragging = source.data;
                const [innerMost] = location.current.dropTargets;
                const dropTargetData = innerMost.data;
                if (!isDraggableItem(dragging) || !isDraggableItem(dropTargetData)) {
                    $0e899fe83e364992$export$34ac71ce24cddec2(fireAnalyticsEvent, 'dragEnded', dragging.menuItemId, undefined, false);
                    return;
                }
                // Extract instruction from dropTargetData that has instruction property
                const instruction = (0, $6rsYi.extractInstruction)(dropTargetData);
                const operation = instruction && $0e899fe83e364992$var$instructionToOperation(instruction);
                if (operation) performDropOperation(operation, dragging, dropTargetData);
                if (source.element) (0, $ijI7P.triggerPostMoveFlash)(source.element);
                $0e899fe83e364992$export$34ac71ce24cddec2(fireAnalyticsEvent, 'dragEnded', dragging.menuItemId, operation || undefined, true);
            }
        });
    }, [
        canDrop,
        fireAnalyticsEvent,
        isDraggableItem,
        performDropOperation
    ]);
    return {
        ref: ref,
        state: state
    };
}
const $0e899fe83e364992$var$instructionToOperation = (instruction)=>{
    switch(instruction?.operation){
        case 'reorder-before':
            return (0, $9sYLJ.OPERATIONS).BEFORE;
        case 'reorder-after':
            return (0, $9sYLJ.OPERATIONS).AFTER;
        default:
            return null;
    }
};
const $0e899fe83e364992$export$34ac71ce24cddec2 = (fireAnalyticsEvent, action, itemId, operation, successfulReorder)=>{
    if (fireAnalyticsEvent) fireAnalyticsEvent({
        action: action,
        itemId: itemId,
        operation: operation,
        successfulReorder: successfulReorder
    });
};

});



parcelRegister("8VQKB", function(module, exports) {
$parcel$export(module.exports, "Nav4ConnectMenuItem", () => $856d9fd98f7eb196$export$d311b4cb0fdc0b92);

var $ktvgp = parcelRequire("ktvgp");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $k9IzM = parcelRequire("k9IzM");

var $5SfEA = parcelRequire("5SfEA");

var $2u8Zb = parcelRequire("2u8Zb");

var $2CuPf = parcelRequire("2CuPf");
function $856d9fd98f7eb196$export$d311b4cb0fdc0b92({ queryRef: queryRef, currentItems: currentItems, currentOrder: currentOrder, item: item }) {
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $ktvgp.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    const { addNew: addNew } = (0, $k9IzM.useConnectItemClickHistory)();
    const onClick = (0, $euxye.useCallback)((e, target, styleClass, url)=>{
        if (url == null) return;
        addNew(url);
        if (target == null) return;
        (0, $5SfEA.withConnectHost)((connectHost)=>{
            connectHost.triggerWebItem(target, styleClass, url);
        });
        if ((0, $5SfEA.isConnectDialogWebItem)(styleClass)) e.preventDefault();
    }, [
        addNew
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2u8Zb.Nav4AppMenuItem), {
        queryRef: data,
        onData: $856d9fd98f7eb196$var$transformData,
        onClick: onClick,
        currentItems: currentItems,
        currentOrder: currentOrder,
        item: item
    });
}
$856d9fd98f7eb196$export$d311b4cb0fdc0b92.displayName = "Nav4ConnectMenuItem";
/**
 * Data transformer for Connect.
 * We are going to convert multi-page Connect apps into single-page ones in case their subpages don't contain a url that matches the root one.
 * For more details, see {@link canHaveSubpages}.
 */ function $856d9fd98f7eb196$var$transformData(data) {
    return (0, $2CuPf.canHaveSubpages)(data) ? data : {
        ...data,
        sections: null
    };
}

});
parcelRegister("ktvgp", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c7140fcc511ef2f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<45f584d660aa5ebc1ce68c6307a0e676>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5c7140fcc511ef2f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4ConnectMenuItem",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4AppMenuItem"
        }
    ],
    "type": "JiraAppNavigationItem"
};
$5c7140fcc511ef2f$var$node.hash = "76baf08d707245f4a5aadd384fd44056";
var $5c7140fcc511ef2f$export$2e2bcd8739ae039 = $5c7140fcc511ef2f$var$node;

});

parcelRegister("k9IzM", function(module, exports) {
$parcel$export(module.exports, "useConnectItemClickHistory", () => $f54b07308e3c7b48$export$c251e3fda1cce4a3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $1uH7N = parcelRequire("1uH7N");
// A single instance for the entire SPA session
const $f54b07308e3c7b48$var$history = {
    unique: []
};
const $f54b07308e3c7b48$export$c251e3fda1cce4a3 = ()=>{
    (0, $1uH7N.di)(window);
    const addNew = (0, $euxye.useCallback)((historyItem)=>{
        // Here we want to store only unique items. For example, if the add-on updates Jira hash
        // and user clicks the same navigation link we consider it as a unique navigation action
        // so we can use this info later on to rerender the iframe
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.location.href.endsWith(historyItem) === false) // @ts-expect-error - TS2339 - Property 'push' does not exist on type 'readonly []'.
        $f54b07308e3c7b48$var$history.unique.push(historyItem);
    }, []);
    return (0, $euxye.useMemo)(()=>({
            history: $f54b07308e3c7b48$var$history,
            addNew: addNew
        }), [
        addNew
    ]);
};
const $f54b07308e3c7b48$export$ef04cd58bebb0345 = ()=>{
    // @ts-expect-error TS2540: Cannot assign to 'length' because it is a read-only property.
    $f54b07308e3c7b48$var$history.unique.length = 0;
};

});

parcelRegister("5SfEA", function(module, exports) {
$parcel$export(module.exports, "withConnectHost", () => $467c6f84bb555143$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $467c6f84bb555143$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $467c6f84bb555143$export$920fb4b46d4f2eec);
/* eslint-disable jira/filename-case */ 
var $flG6W = parcelRequire("flG6W");
const $467c6f84bb555143$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $flG6W.setupConnectJs)();
    action(connectHost);
};
const $467c6f84bb555143$export$186d423c00af146c = ()=>window.connectHost; // oxlint-disable-line @typescript-eslint/no-explicit-any
const $467c6f84bb555143$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("flG6W", function(module, exports) {
$parcel$export(module.exports, "setupConnectJs", () => $2ce08c8965ef4fcb$export$891414b605e5f038);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/wrm/no-load-bridge

var $8wV9L = parcelRequire("8wV9L");
var $erQjo = parcelRequire("erQjo");

var $h86j2 = parcelRequire("h86j2");

const $2ce08c8965ef4fcb$var$installConnectJs = async ()=>{
    // we need the heritage to load in order for WRM core and jQuery to exist.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $erQjo.waitForHeritage)();
    await (0, $h86j2.waitForJQuery)();
    const loader = await (parcelRequire("hN4ZQ"));
    await loader.performSideEffects();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};
let $2ce08c8965ef4fcb$var$installConnectJsPromise = null;
const $2ce08c8965ef4fcb$export$891414b605e5f038 = async ()=>{
    // Connect should never be loaded on SSR
    if (false) throw new Error('setupConnectJs should never be called in SSR');
    // Only pages in the SPA will benefit from modernising connect
    if ($2ce08c8965ef4fcb$var$installConnectJsPromise != null) return $2ce08c8965ef4fcb$var$installConnectJsPromise;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__SPA__) {
        if ($2ce08c8965ef4fcb$var$installConnectJsPromise === null) $2ce08c8965ef4fcb$var$installConnectJsPromise = $2ce08c8965ef4fcb$var$installConnectJs();
        return $2ce08c8965ef4fcb$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    $2ce08c8965ef4fcb$var$installConnectJsPromise = (0, $8wV9L.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    await $2ce08c8965ef4fcb$var$installConnectJsPromise;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};

});
parcelRegister("h86j2", function(module, exports) {
$parcel$export(module.exports, "getMeta", () => $e9aa265d3a850847$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $e9aa265d3a850847$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $e9aa265d3a850847$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $e9aa265d3a850847$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $e9aa265d3a850847$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $e9aa265d3a850847$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $e9aa265d3a850847$export$d690da9bc8146677);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

const $e9aa265d3a850847$export$c47913ca32a5c6f7 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $e9aa265d3a850847$export$7232a6dc780f9887 = ()=>AJS.$;
const $e9aa265d3a850847$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public @atlassian/atlassian-connect-js library.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window._AP;
const $e9aa265d3a850847$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $e9aa265d3a850847$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $e9aa265d3a850847$var$FIVE_MINUTES = 300000;
const $e9aa265d3a850847$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        if (false) throw new Error('waitForJQuery should never be called in SSR');
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.AJS?.$ || false) {
            resolve();
            return;
        }
        const interval = setInterval(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $e9aa265d3a850847$var$FIVE_MINUTES);
    });
const $e9aa265d3a850847$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $e9aa265d3a850847$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $e9aa265d3a850847$export$d690da9bc8146677 = [
    $e9aa265d3a850847$export$cb954c21735b28e4,
    $e9aa265d3a850847$export$7315c38dc71bd41f
];

});

parcelRegister("hN4ZQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1Loyv").then(()=>parcelRequire('6vmu6'));

});



parcelRegister("2u8Zb", function(module, exports) {
$parcel$export(module.exports, "Nav4AppMenuItem", () => $9bae82f5b86a76ec$export$549160040f86c542);

var $8cRmT = parcelRequire("8cRmT");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");




var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $1xxzH = parcelRequire("1xxzH");

var $4VtOS = parcelRequire("4VtOS");

var $aQCoC = parcelRequire("aQCoC");

var $jzXAj = parcelRequire("jzXAj");

var $fbAgT = parcelRequire("fbAgT");

var $ar9gx = parcelRequire("ar9gx");

var $djYhH = parcelRequire("djYhH");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $3tQu8 = parcelRequire("3tQu8");
var $6w18e = parcelRequire("6w18e");

var $fFNvS = parcelRequire("fFNvS");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $ffznM = parcelRequire("ffznM");

var $2700E = parcelRequire("2700E");

var $lBl0W = parcelRequire("lBl0W");

var $cFxOC = parcelRequire("cFxOC");

var $aNGij = parcelRequire("aNGij");

var $kIU6u = parcelRequire("kIU6u");
function $9bae82f5b86a76ec$export$549160040f86c542({ queryRef: queryRef, onData: onData, onClick: onClick, currentItems: currentItems, currentOrder: currentOrder, item: item }) {
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const rawData = (0, $n67Vb.useFragment)((0, $8cRmT.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    const data = (0, $euxye.useMemo)(()=>onData ? onData($9bae82f5b86a76ec$var$normalizeData(rawData)) : $9bae82f5b86a76ec$var$normalizeData(rawData), [
        onData,
        rawData
    ]);
    const icon = (0, $euxye.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cFxOC.AppIcon), {
            shouldChangeFillColor: !(0, $i860n.fg)('jira-nav-addon-icon-disable-color-filter'),
            iconUrl: data.iconUrl || ''
        }), [
        data.iconUrl
    ]);
    const withSeparators = (0, $euxye.useMemo)(()=>$9bae82f5b86a76ec$var$shouldUseSeparators(data), [
        data
    ]);
    const envLozenge = (0, $euxye.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lBl0W.EnvLozenge), {
            label: data.envLabel || ''
        }), [
        data.envLabel
    ]);
    let reorderActions;
    if (currentItems && currentOrder && item && (0, $2700E.expVal)('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) {
        // oxlint-disable-next-line react-hooks/rules-of-hooks
        const { entityAri: entityAri, ownerAri: ownerAri } = (0, $kIU6u.useAppReordering)();
        // oxlint-disable-next-line react-hooks/rules-of-hooks
        reorderActions = (0, $euxye.useCallback)((onClose)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fbAgT.ReorderActionsRenderer), {
                currentItems: currentItems,
                currentOrder: currentOrder,
                entityAri: entityAri,
                ownerAri: ownerAri,
                fireAnalyticsEvent: undefined,
                item: item,
                onClose: onClose
            }), [
            currentItems,
            currentOrder,
            entityAri,
            item,
            ownerAri
        ]);
    }
    const actionsOnHover = (0, $euxye.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aNGij.AppActions), {
            settingsUrl: data.settingsUrl || '',
            appId: data.appId || '',
            reorderActions: reorderActions
        }), [
        data.settingsUrl,
        data.appId,
        reorderActions
    ]);
    const expandable = (0, $euxye.useMemo)(()=>{
        if ((data.sections || []).length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9bae82f5b86a76ec$var$MaybeExpandable, {
            actionsOnHover: actionsOnHover,
            appId: data.appId || '',
            envLozenge: envLozenge,
            icon: icon,
            label: data.label || 'Unknown app',
            // oxlint-disable-next-line typescript/consistent-type-assertions
            menuIds: $9bae82f5b86a76ec$var$toExpandableMenuId(data.sections),
            itemId: data.appId || '',
            level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf)
        }, (data.sections || []).map((section, sectionIndex)=>(section?.links || []).length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), {
                key: `${sectionIndex}-${section?.label}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, withSeparators && sectionIndex > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3tQu8.Divider), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9bae82f5b86a76ec$var$MaybeExpandable, {
                appId: data.appId || '',
                label: section?.label || '',
                // oxlint-disable-next-line typescript/consistent-type-assertions
                menuIds: $9bae82f5b86a76ec$var$toExpandableMenuId([
                    {
                        links: section?.links
                    }
                ]),
                itemId: `section/${sectionIndex}`,
                level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1)
            }, (section?.links || []).map((link, linkIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9bae82f5b86a76ec$var$SimpleItem, {
                    appId: data.appId || '',
                    key: link?.url || '',
                    label: link?.label || '',
                    onClick: onClick,
                    styleClass: link?.styleClass || '',
                    url: link?.url == null ? null : $9bae82f5b86a76ec$var$removeTrailingSlash(link?.url),
                    itemId: `section/${sectionIndex}/link/${linkIndex}`,
                    level: section?.label ? (0, $ef39084c605eb7e8$export$f9db6a58b4aabd18) : (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1)
                })))))) : null));
    }, [
        data.sections,
        data.label,
        data.appId,
        icon,
        envLozenge,
        actionsOnHover,
        withSeparators,
        onClick
    ]);
    if (expandable) return expandable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9bae82f5b86a76ec$var$SimpleItem, {
        actionsOnHover: actionsOnHover,
        appId: data.appId || '',
        envLozenge: envLozenge,
        icon: icon,
        label: data.label || 'Unknown app',
        onClick: onClick,
        styleClass: data.styleClass || '',
        url: data.url == null ? null : $9bae82f5b86a76ec$var$removeTrailingSlash(data.url || ''),
        itemId: data.appId || '',
        level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf)
    });
}
$9bae82f5b86a76ec$export$549160040f86c542.displayName = "Nav4AppMenuItem";
function $9bae82f5b86a76ec$var$SimpleItem({ actionsOnHover: actionsOnHover, appId: appId, envLozenge: envLozenge, icon: icon, label: label, onClick: onClick, styleClass: styleClass, url: url, itemId: itemId, level: level }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const anchorElement = (0, $euxye.useRef)(null);
    const onItemClick = (0, $euxye.useCallback)((e)=>{
        $9bae82f5b86a76ec$var$fireAppClickEvent({
            event: createAnalyticsEvent({}),
            itemId: itemId,
            appId: appId,
            level: level
        });
        onClick?.(e, anchorElement.current, styleClass || '', url);
    }, [
        url,
        onClick,
        itemId,
        appId,
        level,
        styleClass,
        createAnalyticsEvent
    ]);
    let dragAndDropState;
    if ((0, $2700E.expVal)('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) {
        // oxlint-disable-next-line react-hooks/rules-of-hooks
        const { entityAri: entityAri, ownerAri: ownerAri, group: group } = (0, $kIU6u.useAppReordering)();
        // oxlint-disable-next-line react-hooks/rules-of-hooks
        dragAndDropState = (0, $ffznM.useNestedItemDragAndDrop)({
            entityAri: entityAri,
            ownerAri: ownerAri,
            data: {
                id: appId.toString(),
                label: label
            },
            group: group,
            item: undefined,
            isExpandable: false,
            isExpandOrFlyoutOpen: false,
            id: appId.toString(),
            isDragAndDropEnabled: true,
            onExpandFlyoutToggle: ()=>{
            // No op for dashboard menu item
            }
        });
    }
    const draggableRef = dragAndDropState?.draggableRef || null;
    // If a Connect app does NOT have a URL, we should use a MenuButtonItem instead.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: $9bae82f5b86a76ec$var$removeTrailingSlash(url ?? ''),
        elemBefore: icon,
        elemAfter: envLozenge,
        actionsOnHover: actionsOnHover,
        menuId: $9bae82f5b86a76ec$export$171d73a56172dba4(url ?? ''),
        ref: (0, $fFNvS.mergeRefs)(anchorElement, draggableRef),
        onClick: onItemClick,
        visualContentRef: dragAndDropState?.dropTargetRef,
        dropIndicator: dragAndDropState?.dropIndicator,
        isDragging: dragAndDropState?.isDragging,
        hasDragIndicator: dragAndDropState === undefined ? false : dragAndDropState.isItemDraggable
    }, label);
}
$9bae82f5b86a76ec$var$SimpleItem.displayName = "SimpleItem";
function $9bae82f5b86a76ec$var$MaybeExpandable(params) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { actionsOnHover: actionsOnHover, children: children, envLozenge: envLozenge, icon: icon, label: label, menuIds: menuIds, itemId: itemId, appId: appId, level: level } = params;
    const menuId = (0, $1xxzH.toMenuIdFromMenuIdList)(menuIds);
    const onClick = (0, $euxye.useCallback)(()=>{
        $9bae82f5b86a76ec$var$fireAppClickEvent({
            event: createAnalyticsEvent({}),
            itemId: itemId,
            appId: appId,
            level: level,
            isExpandable: true
        });
    }, [
        createAnalyticsEvent,
        itemId,
        appId,
        level
    ]);
    const onExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) onClick();
    }, [
        onClick
    ]);
    return label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        menuId: menuId,
        isExpanded: level !== (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        elemBefore: icon,
        elemAfter: envLozenge,
        testId: (0, $jzXAj.getTestId)(menuId),
        interactionName: "nav4-sidebar-apps"
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
}
$9bae82f5b86a76ec$var$MaybeExpandable.displayName = "MaybeExpandable";
function $9bae82f5b86a76ec$var$fireAppClickEvent(params) {
    const { event: event, itemId: itemId, appId: appId, level: level, isExpandable: isExpandable } = params;
    (0, $aJ81Y.fireUIAnalytics)(event, {
        action: 'clicked',
        actionSubject: 'navigationItem',
        actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_APPS],
        attributes: {
            level: level,
            componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
            itemId: itemId,
            isExpandable: isExpandable,
            section: 'yourApps',
            ...level === (0, $ef39084c605eb7e8$export$265c523d1a8f25cf) ? {
                itemType: (0, $687cb22024c607c7$export$c3d83ca6855fa0d0)
            } : {
                itemType: (0, $687cb22024c607c7$export$509e83d3c8d91279),
                parentItemId: appId,
                parentItemType: (0, $687cb22024c607c7$export$c3d83ca6855fa0d0)
            }
        }
    });
}
function $9bae82f5b86a76ec$var$shouldUseSeparators(data) {
    for (const section of data.sections || []){
        if (section?.label) return false;
    }
    return true;
}
/**
 * Common data transformer.
 * Filters out sections with empty links.
 */ function $9bae82f5b86a76ec$var$normalizeData(data) {
    return {
        ...data,
        sections: (data.sections || []).filter((section)=>(section?.links || []).length > 0)
    };
}
const $9bae82f5b86a76ec$var$removeTrailingSlash = (url = '')=>url.replace(/\/$/, '');
const $9bae82f5b86a76ec$var$removeQueryParams = (url)=>url.split('?')[0];
const $9bae82f5b86a76ec$var$removeHash = (url)=>url.split('#')[0];
const $9bae82f5b86a76ec$export$171d73a56172dba4 = (path_ = '')=>{
    let path = path_;
    // This is the format we ask Connect vendors to use: /plugins/servlet/ac/:addonKey/:moduleKey
    // However, there are Connect apps that do not follow our recommendations and add extra path segments.
    // As result they might look like this: /plugins/servlet/ac/:addonKey/:moduleKey/:extraPathSegment
    // Because of that we have issues with menu ids matching since the path created out of current route differs from the actual url.
    // To fix this we remove those extra path segments from the url.
    if (path.startsWith('/plugins/servlet/ac/')) path = path.split('/').slice(0, 6).join('/');
    return (0, $5IkoH.ENTITY_ID).APP($9bae82f5b86a76ec$var$removeTrailingSlash($9bae82f5b86a76ec$var$removeQueryParams($9bae82f5b86a76ec$var$removeHash(path))));
};
// Because of the apps nature, the parent url may differ from the child url.
// And if we want to make sure the expand state is properly calculated, we must pass down children menu ids.
const $9bae82f5b86a76ec$var$toExpandableMenuId = (sections)=>(sections || []).flatMap(({ links: links })=>(links || []).map((link)=>$9bae82f5b86a76ec$export$171d73a56172dba4(link.url)));

});
parcelRegister("8cRmT", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb16d905b6df9043$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9fbd901c97cf05ca391d7d01356f5f4a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cb16d905b6df9043$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "label"
    }, v1 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4AppMenuItem",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "appId"
            },
            {
                "kind": "ScalarField",
                "name": "envLabel"
            },
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "concreteType": "JiraAppSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "concreteType": "JiraAppNavigationItemNestedLink",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            v2 /*: any*/ ,
                            v1 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "settingsUrl"
            },
            v2 /*: any*/ 
        ],
        "type": "JiraAppNavigationItem"
    };
}();
$cb16d905b6df9043$var$node.hash = "fe622bd16e14b11ec5e3f21d8553bac3";
var $cb16d905b6df9043$export$2e2bcd8739ae039 = $cb16d905b6df9043$var$node;

});

/* eslint-disable jira/filename-case */ const $687cb22024c607c7$export$9b8283d5878d2491 = 'board';
const $687cb22024c607c7$export$c3d83ca6855fa0d0 = 'app';
const $687cb22024c607c7$export$c1c49903035a02df = 'filter';
const $687cb22024c607c7$export$6deee0e4f2fb784e = 'defaultFilter';
const $687cb22024c607c7$export$4695c1a423ffe431 = 'dashboard';
const $687cb22024c607c7$export$5828682c822c26e7 = 'queue';
const $687cb22024c607c7$export$fe791c4fa892e400 = 'project';
const $687cb22024c607c7$export$c303e491e026ebc6 = 'plan';
const $687cb22024c607c7$export$509e83d3c8d91279 = 'appSubpage';
const $687cb22024c607c7$export$a2e7d1d0a3d169f4 = 'asset';
const $687cb22024c607c7$export$b56168d831461ce2 = 'operation';
const $687cb22024c607c7$export$499a3e77858b7713 = 'translationGroup';
const $687cb22024c607c7$export$bb8a37ab8d9ba82b = 'roadmap';
const $687cb22024c607c7$export$9a778ca616c24a93 = 'projectRecommendation';
const $687cb22024c607c7$export$119dad133da0b4a = 'changeView';

parcelRegister("fbAgT", function(module, exports) {
$parcel$export(module.exports, "ReorderActionsRenderer", () => $8de09d08d82db136$export$f21261eb9031288e);

var $7EMok = parcelRequire("7EMok");
const $8de09d08d82db136$export$f21261eb9031288e = ({ currentItems: currentItems, currentOrder: currentOrder, entityAri: entityAri, ownerAri: ownerAri, fireAnalyticsEvent: fireAnalyticsEvent, item: item, onClose: onClose })=>{
    return (0, $7EMok.useNavigationItemActions)({
        currentItems: currentItems,
        currentOrder: currentOrder,
        entityAri: entityAri,
        ownerAri: ownerAri,
        fireAnalyticsEvent: fireAnalyticsEvent,
        // oxlint-disable-next-line typescript/consistent-type-assertions
        getItemId: (i)=>i.id,
        item: item,
        onActionComplete: onClose
    });
};
$8de09d08d82db136$export$f21261eb9031288e.displayName = "ReorderActionsRenderer";

});
parcelRegister("7EMok", function(module, exports) {
$parcel$export(module.exports, "useNavigationItemActions", () => $ed281d3437986cbb$export$362bebdb7fee48c2);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $MpNSO = parcelRequire("MpNSO");
const $ed281d3437986cbb$export$362bebdb7fee48c2 = ({ currentItems: currentItems, currentOrder: currentOrder, entityAri: entityAri, fireAnalyticsEvent: fireAnalyticsEvent, item: item, ownerAri: ownerAri, getItemId: getItemId, onActionComplete: onActionComplete })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $MpNSO.NestedItemsActionsAdapter), {
        currentItems: currentItems,
        currentOrder: currentOrder,
        entityAri: entityAri,
        fireAnalyticsEvent: fireAnalyticsEvent,
        item: item,
        ownerAri: ownerAri,
        getItemId: getItemId,
        onActionComplete: onActionComplete
    });
};

});
parcelRegister("MpNSO", function(module, exports) {
$parcel$export(module.exports, "NestedItemsActionsAdapter", () => $6c2c67b027c911d4$export$dc9d75d3fed31e6d);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $2YPKP = parcelRequire("2YPKP");

var $9sYLJ = parcelRequire("9sYLJ");

var $kTg6i = parcelRequire("kTg6i");

var $bbfoK = parcelRequire("bbfoK");

var $cnJaH = parcelRequire("cnJaH");
function $6c2c67b027c911d4$export$dc9d75d3fed31e6d({ currentItems: currentItems, currentOrder: currentOrder, entityAri: entityAri, fireAnalyticsEvent: fireAnalyticsEvent, item: item, ownerAri: ownerAri, getItemId: getItemId, onActionComplete: onActionComplete }) {
    (0, $1YIbA.default)();
    // Platform mutation hook for reordering
    const updateSidebarItemOrder = (0, $bbfoK.useUpdateNestedItemOrder)();
    // Calculate position capabilities using extracted utility
    const { canMoveUp: canMoveUp, canMoveDown: canMoveDown } = (0, $euxye.useMemo)(()=>(0, $kTg6i.calculateNestedItemPosition)({
            itemId: item.id,
            currentItems: currentItems,
            currentOrder: currentOrder,
            getItemId: getItemId
        }), [
        currentItems,
        currentOrder,
        getItemId,
        item.id
    ]);
    // Handle move operations
    const handleMove = (0, $euxye.useCallback)((operation)=>{
        updateSidebarItemOrder({
            currentItems: currentItems,
            currentOrder: currentOrder,
            entityAri: entityAri,
            fireAnalyticsEvent: fireAnalyticsEvent,
            operation: operation,
            ownerAri: ownerAri,
            targetItemId: item.id,
            getItemId: getItemId
        });
        onActionComplete?.();
    }, [
        updateSidebarItemOrder,
        currentItems,
        currentOrder,
        entityAri,
        fireAnalyticsEvent,
        ownerAri,
        item.id,
        getItemId,
        onActionComplete
    ]);
    // If there's nothing to reorder, don't render anything
    if (!canMoveUp && !canMoveDown) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cnJaH.NavItemReorderingMenu), {
        TriggerComponent: (0, $2YPKP.default),
        canMoveUp: canMoveUp,
        canMoveDown: canMoveDown,
        moveUp: ()=>handleMove((0, $9sYLJ.OPERATIONS).MOVE_UP),
        moveDown: ()=>handleMove((0, $9sYLJ.OPERATIONS).MOVE_DOWN),
        moveToTop: ()=>handleMove((0, $9sYLJ.OPERATIONS).MOVE_TO_TOP),
        moveToBottom: ()=>handleMove((0, $9sYLJ.OPERATIONS).MOVE_TO_BOTTOM)
    });
}
$6c2c67b027c911d4$export$dc9d75d3fed31e6d.displayName = "NestedItemsActionsAdapter";

});
parcelRegister("kTg6i", function(module, exports) {
$parcel$export(module.exports, "calculateNestedItemPosition", () => $86cf641563f84ecc$export$b9561472749d09b2);
const $86cf641563f84ecc$export$b9561472749d09b2 = ({ itemId: itemId, currentItems: currentItems, currentOrder: currentOrder, getItemId: getItemId })=>{
    let orderedItemIds;
    if (currentOrder && currentOrder.length > 0) {
        const itemIds = currentItems.map((currentItem)=>getItemId(currentItem));
        const orderedFromSidebar = currentOrder.filter((sidebarItem)=>itemIds.includes(sidebarItem.menuId)).map((sidebarItem)=>sidebarItem.menuId);
        const remainingIds = itemIds.filter((id)=>!orderedFromSidebar.includes(id));
        orderedItemIds = [
            ...orderedFromSidebar,
            ...remainingIds
        ];
    } else orderedItemIds = currentItems.map((currentItem)=>getItemId(currentItem));
    const itemIndex = orderedItemIds.indexOf(itemId);
    if (orderedItemIds.length <= 1) return {
        positionType: 'only',
        canMoveUp: false,
        canMoveDown: false
    };
    if (itemIndex === 0) return {
        positionType: 'first',
        canMoveUp: false,
        canMoveDown: true
    };
    if (itemIndex === orderedItemIds.length - 1) return {
        positionType: 'last',
        canMoveUp: true,
        canMoveDown: false
    };
    return {
        positionType: 'middle',
        canMoveUp: true,
        canMoveDown: true
    };
};

});

parcelRegister("cnJaH", function(module, exports) {
$parcel$export(module.exports, "NavItemReorderingMenu", () => $47ed08c78b2bdab4$export$622d0000825ebc97);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $jaPl6 = parcelRequire("jaPl6");
var $2YPKP = parcelRequire("2YPKP");
var $2Xkyn = parcelRequire("2Xkyn");

var $dUPUc = parcelRequire("dUPUc");

var $5oMqJ = parcelRequire("5oMqJ");

var $1Io8b = parcelRequire("1Io8b");

var $c752t = parcelRequire("c752t");

var $6HwCC = parcelRequire("6HwCC");
function $47ed08c78b2bdab4$export$622d0000825ebc97({ TriggerComponent: TriggerComponent = (0, $1Io8b.ButtonMenuItem), canMoveUp: canMoveUp, canMoveDown: canMoveDown, moveUp: moveUp, moveDown: moveDown, moveToTop: moveToTop, moveToBottom: moveToBottom, onOpenChange: onOpenChange, itemLabel: itemLabel, itemPosition: itemPosition, itemCount: itemCount }) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const announcementContext = (0, $c752t.useOptionalAnnouncements)();
    const label = itemLabel ?? '';
    const total = itemCount ?? 0;
    const isOnly = !canMoveUp && !canMoveDown;
    const [open, setOpen] = (0, $euxye.useState)(false);
    const listItemRef = (0, $euxye.useRef)(null);
    const onOpenChangeInternal = (0, $euxye.useCallback)((args)=>{
        setOpen(args.isOpen);
        onOpenChange?.(args);
    }, [
        onOpenChange
    ]);
    (0, $euxye.useEffect)(()=>{
        // Remove role="listitem" from the root component within ButtonMenuItem.
        // We add our own wrapper with role around the whole thing, to ensure that the menu is rendered inside the listitem/menuitem semantically.
        // Otherwise, it would be a sibling to it without the appropriate role, which is both an a11y violation and doesn't make semantic sense.
        // Also, this allows us to account for the expected parent roles of all supported trigger types.
        if (TriggerComponent === (0, $1Io8b.ButtonMenuItem)) {
            if (listItemRef.current) listItemRef.current.removeAttribute('role');
        }
    }, [
        TriggerComponent
    ]);
    /**
   * Set wrapper role based on the default semantics of the trigger component.
   * This is just so we can shuffle around where the role attribute is defined
   * to ensure semantics of the whole component are correct when the reordering menu is fully open.
   * We aren't messing with the roles themselves at this point
   * (e.g., making a ButtonMenuItem a "menuitem" not a "listitem"), though we could if there is a need to in the future.
   */ const wrapperRole = (0, $euxye.useMemo)(()=>{
        if (TriggerComponent === (0, $1Io8b.ButtonMenuItem)) return 'listitem';
        return undefined;
    }, [
        TriggerComponent
    ]);
    const handleMoveToTop = (0, $euxye.useCallback)(()=>{
        moveToTop();
        announcementContext?.setAnnouncement(formatMessage((0, $6HwCC.default).announcementMovedToTop, {
            itemLabel: label,
            position: 1,
            total: total
        }));
    }, [
        moveToTop,
        announcementContext,
        formatMessage,
        label,
        total
    ]);
    const handleMoveUp = (0, $euxye.useCallback)(()=>{
        moveUp();
        announcementContext?.setAnnouncement(formatMessage((0, $6HwCC.default).announcementMovedUp, {
            itemLabel: label,
            position: (itemPosition ?? 1) - 1,
            total: total
        }));
    }, [
        moveUp,
        announcementContext,
        formatMessage,
        label,
        itemPosition,
        total
    ]);
    const handleMoveDown = (0, $euxye.useCallback)(()=>{
        moveDown();
        announcementContext?.setAnnouncement(formatMessage((0, $6HwCC.default).announcementMovedDown, {
            itemLabel: label,
            position: (itemPosition ?? 1) + 1,
            total: total
        }));
    }, [
        moveDown,
        announcementContext,
        formatMessage,
        label,
        itemPosition,
        total
    ]);
    const handleMoveToBottom = (0, $euxye.useCallback)(()=>{
        moveToBottom();
        announcementContext?.setAnnouncement(formatMessage((0, $6HwCC.default).announcementMovedToBottom, {
            itemLabel: label,
            position: total,
            total: total
        }));
    }, [
        moveToBottom,
        announcementContext,
        formatMessage,
        label,
        total
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: wrapperRole,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jaPl6.default), {
            shouldRenderToParent: true,
            spacing: "compact",
            placement: "right-start",
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>{
                return /*#__PURE__*/ (0, $e79Pd.jsx)(TriggerComponent, {
                    elemBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5oMqJ))), {
                        label: ""
                    }),
                    elemAfter: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dUPUc))), {
                        color: "var(--ds-icon-subtle, #505258)",
                        label: "",
                        size: "small"
                    }),
                    ...triggerProps,
                    ref: triggerRef,
                    isDisabled: isOnly,
                    listItemRef: listItemRef,
                    children: formatMessage((0, $6HwCC.default).reorderingMenuTriggerLabel)
                });
            },
            onOpenChange: onOpenChangeInternal,
            isOpen: isOnly ? false : open,
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2Xkyn.default), {
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2YPKP.default), {
                        isDisabled: !canMoveUp,
                        onClick: handleMoveToTop,
                        children: formatMessage((0, $6HwCC.default).moveToTop)
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2YPKP.default), {
                        isDisabled: !canMoveUp,
                        onClick: handleMoveUp,
                        children: formatMessage((0, $6HwCC.default).moveUp)
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2YPKP.default), {
                        isDisabled: !canMoveDown,
                        onClick: handleMoveDown,
                        children: formatMessage((0, $6HwCC.default).moveDown)
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2YPKP.default), {
                        isDisabled: !canMoveDown,
                        onClick: handleMoveToBottom,
                        children: formatMessage((0, $6HwCC.default).moveToBottom)
                    })
                ]
            })
        })
    });
}
$47ed08c78b2bdab4$export$622d0000825ebc97.displayName = "NavItemReorderingMenu";

});
parcelRegister("5oMqJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdb43c090e89be1f8c2155133950489>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ee4c2d92af9e57a$var$_react = $3ee4c2d92af9e57a$var$_interopRequireDefault((parcelRequire("euxye")));

var $3ee4c2d92af9e57a$var$_baseNew = $3ee4c2d92af9e57a$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $3ee4c2d92af9e57a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/grow-vertical
 * Usage guidance:
 * Single purpose - Reserved for increasing the height of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3ee4c2d92af9e57a$var$GrowVerticalIcon = (props)=>/*#__PURE__*/ $3ee4c2d92af9e57a$var$_react.default.createElement($3ee4c2d92af9e57a$var$_baseNew.default, Object.assign({
        name: "GrowVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m7.47 15.78-3.5-3.5 1.06-1.06 2.22 2.22V9h1.5v4.44l2.22-2.22 1.06 1.06-3.5 3.5a.75.75 0 0 1-1.06 0M7.25 2.56 5.03 4.78 3.97 3.72l3.5-3.5a.75.75 0 0 1 1.06 0l3.5 3.5-1.06 1.06-2.22-2.22V7h-1.5z" clip-rule="evenodd"/>`
    }, props));
$3ee4c2d92af9e57a$var$GrowVerticalIcon.displayName = 'GrowVerticalIcon';
var $3ee4c2d92af9e57a$var$_default = module.exports.default = $3ee4c2d92af9e57a$var$GrowVerticalIcon;

});

parcelRegister("c752t", function(module, exports) {
$parcel$export(module.exports, "AnnouncementProvider", () => $738d80f8484b286c$export$1b7c44420a96a4dc);
$parcel$export(module.exports, "useOptionalAnnouncements", () => $738d80f8484b286c$export$ac0c87521aeea6a0);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");

var $hzLFd = parcelRequire("hzLFd");
const $738d80f8484b286c$export$890aea7f6e44b2fd = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
function $738d80f8484b286c$export$1b7c44420a96a4dc({ children: children, liveMode: liveMode, testId: testId = 'navigation-announcements' }) {
    const [announcement, setAnnouncement] = (0, $euxye.useState)('');
    const contextValue = (0, $euxye.useMemo)(()=>({
            setAnnouncement: setAnnouncement
        }), []);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)($738d80f8484b286c$export$890aea7f6e44b2fd.Provider, {
                value: contextValue,
                children: children
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hzLFd.default), {
                testId: testId,
                message: announcement,
                liveMode: liveMode
            })
        ]
    });
}
$738d80f8484b286c$export$1b7c44420a96a4dc.displayName = "AnnouncementProvider";
const $738d80f8484b286c$export$a5e42d0a22877fdb = ()=>{
    const announcementContext = (0, $euxye.useContext)($738d80f8484b286c$export$890aea7f6e44b2fd);
    (0, $jiTLE.default)(announcementContext, 'useAnnouncements must be used inside an initialized AnnouncementProvider');
    return announcementContext;
};
const $738d80f8484b286c$export$ac0c87521aeea6a0 = ()=>{
    return (0, $euxye.useContext)($738d80f8484b286c$export$890aea7f6e44b2fd);
};

});
parcelRegister("hzLFd", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5ddd75bf45ae2f9$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $apUrw = parcelRequire("apUrw");

function $f5ddd75bf45ae2f9$var$Announcer({ message: originalMessage, liveMode: liveMode = 'polite', shouldAnnounce: shouldAnnounce = true, testId: testId }) {
    const previousMessage = (0, $euxye.useRef)('');
    const setAlternatePolite = (0, $euxye.useRef)(false);
    const addSuffix = (0, $euxye.useRef)(false);
    const [oldMessage, setOldMessage] = (0, $euxye.useState)('');
    const [newMessage, setNewMessage] = (0, $euxye.useState)('');
    (0, $euxye.useEffect)(()=>{
        let message = shouldAnnounce ? originalMessage : (0, $2377b282bd9ed8ff$export$5692c2d0651ebabe);
        if (previousMessage.current === message) {
            addSuffix.current = !addSuffix.current;
            if (addSuffix.current) message += (0, $2377b282bd9ed8ff$export$5692c2d0651ebabe);
        }
        setOldMessage(setAlternatePolite.current ? '' : message);
        setNewMessage(setAlternatePolite.current ? message : '');
        if (shouldAnnounce) setAlternatePolite.current = !setAlternatePolite.current;
        previousMessage.current = originalMessage;
    }, [
        originalMessage,
        shouldAnnounce
    ]);
    // 2 aria-live containers needed to prevent bugs in browsers that will stop
    // announcing updates to the same div if these are too repetitive.
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
            "data-testid": testId,
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    role: "status",
                    "aria-live": liveMode,
                    "aria-relevant": "additions text",
                    "aria-atomic": "true",
                    children: oldMessage
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    role: "status",
                    "aria-live": liveMode,
                    "aria-relevant": "additions text",
                    "aria-atomic": "true",
                    children: newMessage
                })
            ]
        })
    });
}
$f5ddd75bf45ae2f9$var$Announcer.displayName = "Announcer";
const $f5ddd75bf45ae2f9$var$MemoizedAnnouncer = /*#__PURE__*/ (0, $euxye.memo)($f5ddd75bf45ae2f9$var$Announcer);
var $f5ddd75bf45ae2f9$export$2e2bcd8739ae039 = $f5ddd75bf45ae2f9$var$MemoizedAnnouncer;

});
const $2377b282bd9ed8ff$export$5692c2d0651ebabe = '\u00A0';



parcelRegister("6HwCC", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf7084e6dc13191f$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $bf7084e6dc13191f$var$_default_1 = (0, $7eNDO.defineMessages)({
    reorderingMenuTriggerLabel: {
        id: 'navigation.global-side-navigation.nav-item.actions.reordering.trigger-label',
        defaultMessage: 'Reorder menu item',
        description: 'Label for the button that opens the sub-menu for actions to reorder the menu'
    },
    moveToTop: {
        id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-to-top',
        defaultMessage: 'Move to top',
        description: 'Label for the actions menu item to move the item to the top of the menu'
    },
    moveUp: {
        id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-up',
        defaultMessage: 'Move up',
        description: 'Label for the actions menu item to move the item up one position in the menu'
    },
    moveDown: {
        id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-down',
        defaultMessage: 'Move down',
        description: 'Label for the actions menu item to move the item down one position in the menu'
    },
    moveToBottom: {
        id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-to-bottom',
        defaultMessage: 'Move to bottom',
        description: 'Label for the actions menu item to move the item to the bottom of the menu'
    },
    announcementMovedToTop: {
        id: 'navigation.global-side-navigation.nav-item.actions.reordering.announcement.moved-to-top',
        defaultMessage: '{itemLabel} moved to position {position} of {total}.',
        description: 'Screen reader announcement when a navigation item has been moved to the top of the menu. Position will be 1.'
    },
    announcementMovedUp: {
        id: 'navigation.global-side-navigation.nav-item.actions.reordering.announcement.moved-up',
        defaultMessage: '{itemLabel} moved to position {position} of {total}.',
        description: 'Screen reader announcement when a navigation item has been moved up one position in the menu'
    },
    announcementMovedDown: {
        id: 'navigation.global-side-navigation.nav-item.actions.reordering.announcement.moved-down',
        defaultMessage: '{itemLabel} moved to position {position} of {total}.',
        description: 'Screen reader announcement when a navigation item has been moved down one position in the menu'
    },
    announcementMovedToBottom: {
        id: 'navigation.global-side-navigation.nav-item.actions.reordering.announcement.moved-to-bottom',
        defaultMessage: '{itemLabel} moved to position {position} of {total}.',
        description: 'Screen reader announcement when a navigation item has been moved to the bottom of the menu. Position will equal total.'
    }
});
var $bf7084e6dc13191f$export$2e2bcd8739ae039 = $bf7084e6dc13191f$var$_default_1;

});





parcelRegister("3tQu8", function(module, exports) {
$parcel$export(module.exports, "Divider", () => $dffca69a9da57083$export$2e0a83ec2e27ecbb);
/* divider.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $dffca69a9da57083$var$styles = null;
const $dffca69a9da57083$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)("hr", {
        /**
 * The existing usage of these dividers is presentational,
 * so we are removing the separator semantics by default.
 *
 * In the future we may consider allowing opt-in separator semantics,
 * but it probably isn't necessary.
 */ role: "none",
        className: (0, $4jQY2.default)([
            "_h7alglyw _179rglyw _mqm2ia51 _1bsb1osq"
        ])
    });
$dffca69a9da57083$export$2e0a83ec2e27ecbb.displayName = "Divider";

});

parcelRegister("ffznM", function(module, exports) {
$parcel$export(module.exports, "useNestedItemDragAndDrop", () => $778a4cf11f128b98$export$e9dda5a37ab6aed4);

var $euxye = parcelRequire("euxye");

var $9sYLJ = parcelRequire("9sYLJ");

var $7UEMQ = parcelRequire("7UEMQ");
function $778a4cf11f128b98$export$e9dda5a37ab6aed4({ data: data, group: group, entityAri: entityAri, fireAnalyticsEvent: fireAnalyticsEvent, id: id, isDragAndDropEnabled: isDragAndDropEnabled, isExpandable: isExpandable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, item: item, onExpandFlyoutToggle: onExpandFlyoutToggle, ownerAri: ownerAri }) {
    const nestedItemData = (0, $euxye.useMemo)(()=>(0, $9sYLJ.createNestedItemData)({
            entityAri: entityAri,
            group: group,
            isReorderable: true,
            label: data.label,
            menuItemId: id,
            ownerAri: ownerAri
        }), [
        data.label,
        entityAri,
        group,
        id,
        ownerAri
    ]);
    const isItemDraggable = (0, $euxye.useCallback)(()=>{
        return isDragAndDropEnabled !== false && nestedItemData.entityAri === entityAri;
    }, [
        entityAri,
        isDragAndDropEnabled,
        nestedItemData.entityAri
    ]);
    return (0, $7UEMQ.useItemDragAndDrop)({
        data: nestedItemData,
        fireAnalyticsEvent: fireAnalyticsEvent,
        item: item,
        id: id,
        isExpandable: isExpandable,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle,
        isDragAndDropEnabled: isDragAndDropEnabled,
        isItemDraggable: isItemDraggable,
        group: group,
        getItemData: (0, $9sYLJ.getNestedItemData),
        isItemData: (0, $9sYLJ.isNestedItemData),
        isItemDataInGroup: (0, $9sYLJ.isNestedItemDataInGroup)
    });
}

});

parcelRegister("lBl0W", function(module, exports) {
$parcel$export(module.exports, "EnvLozenge", () => $21e8da20b681fdd9$export$61c90f482f9775c6);

var $euxye = parcelRequire("euxye");

var $d0F9p = parcelRequire("d0F9p");
function $21e8da20b681fdd9$export$61c90f482f9775c6({ label: label }) {
    return label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d0F9p.default), {
        text: label,
        color: label === 'Dev' ? 'standard' : 'orange',
        isRemovable: false,
        migration_fallback: "lozenge"
    }) : null;
}
$21e8da20b681fdd9$export$61c90f482f9775c6.displayName = "EnvLozenge";

});

parcelRegister("cFxOC", function(module, exports) {
$parcel$export(module.exports, "AppIcon", () => $2c3dbf615295e676$export$5153830bdfb71453);

var $euxye = parcelRequire("euxye");

var $kqIqB = parcelRequire("kqIqB");

var $kHMXB = parcelRequire("kHMXB");
function $2c3dbf615295e676$export$5153830bdfb71453({ iconUrl: iconUrl, shouldChangeFillColor: shouldChangeFillColor }) {
    return iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kqIqB.IconCustom), {
        url: iconUrl,
        shouldChangeFillColor: shouldChangeFillColor
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kHMXB))), {
        label: "",
        color: "var(--ds-icon, #292A2E)"
    });
}
$2c3dbf615295e676$export$5153830bdfb71453.displayName = "AppIcon";

});
parcelRegister("kqIqB", function(module, exports) {
$parcel$export(module.exports, "IconCustom", () => $a5c72f73248cfc56$export$5b6504ec6adf0047);

var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $atD2S = parcelRequire("atD2S");
// got this value through trial and error
// in the long term, we should change the color of icon generated for the conntect apps
const $a5c72f73248cfc56$var$colorMatrixValues = '0.08, 0, 0, 0, 0, 0, 0.1, 0, 0, 0, 0, 0,0.2, 0, 0, 0, 0, 0, 1, 0';
const $a5c72f73248cfc56$export$5b6504ec6adf0047 = ({ url: url, shouldChangeFillColor: shouldChangeFillColor = true, ariaLabelledBy: ariaLabelledBy })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $a5c72f73248cfc56$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        viewBox: "0 0 20 20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("filter", {
        id: "changeFillColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("feColorMatrix", {
        type: "matrix",
        values: $a5c72f73248cfc56$var$colorMatrixValues
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("image", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xlinkHref: url,
        width: "20",
        height: "20",
        x: "0",
        y: "0",
        filter: shouldChangeFillColor && (0, $atD2S.checkForSvg)(url) ? 'url(#changeFillColor)' : '',
        "aria-labelledby": ariaLabelledBy
    })));
};
$a5c72f73248cfc56$export$5b6504ec6adf0047.displayName = "IconCustom";
const $a5c72f73248cfc56$var$styles = (0, $fbAgj.xcss)({
    display: 'inline-block',
    margin: 'space.025',
    height: "var(--ds-space-250, 20px)",
    width: "var(--ds-space-250, 20px)"
});

});
parcelRegister("atD2S", function(module, exports) {
$parcel$export(module.exports, "checkForSvg", () => $7bb4790f9f39fa45$export$9a369805b0fabb72);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $7bb4790f9f39fa45$export$9a369805b0fabb72 = (url)=>{
    const fileType = url.split(/#|\?/)[0].split('.').pop();
    // falsey check is for Ts
    return fileType ? fileType.trim() === 'svg' : false;
};

});



parcelRegister("aNGij", function(module, exports) {
$parcel$export(module.exports, "AppActions", () => $537df63f6a820e1a$export$6b031ef628e5f9c2);

var $euxye = parcelRequire("euxye");




var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $gbTMi = parcelRequire("gbTMi");

var $g36LP = parcelRequire("g36LP");

var $cSR11 = parcelRequire("cSR11");

var $gBaKj = parcelRequire("gBaKj");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $2700E = parcelRequire("2700E");
const $537df63f6a820e1a$var$appSettings = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-apps.common.app-actions.app-settings",
    defaultMessage: "App settings"
});
const $537df63f6a820e1a$var$NavMenuItems = ({ onClose: onClose, onTrackClick: onTrackClick, settingsUrl: settingsUrl, reorderActions: reorderActions })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const handleClick = (0, $euxye.useCallback)((event)=>{
        onTrackClick();
        onClose?.(event);
    }, [
        onClose,
        onTrackClick
    ]);
    const handleSimpleClose = (0, $euxye.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    if ((0, $2700E.expVal)('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), null, settingsUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cSR11.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gBaKj))), {
            label: "",
            color: "var(--ds-icon, #292A2E)"
        }),
        href: settingsUrl,
        target: "_blank",
        onClick: handleClick
    }, formatMessage($537df63f6a820e1a$var$appSettings)), reorderActions?.(handleSimpleClose));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cSR11.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gBaKj))), {
            label: "",
            color: "var(--ds-icon, #292A2E)"
        }),
        href: settingsUrl,
        target: "_blank",
        onClick: handleClick
    }, formatMessage($537df63f6a820e1a$var$appSettings)));
};
$537df63f6a820e1a$var$NavMenuItems.displayName = "NavMenuItems";
function $537df63f6a820e1a$export$6b031ef628e5f9c2({ settingsUrl: settingsUrl, appId: appId, onClose: onClose, reorderActions: reorderActions }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireOpenEvent = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_APPS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                componentType: (0, $6e2f51712bb2e810$export$9bd6c21d500ae611),
                itemId: 'meatballDropdown',
                section: 'yourApps'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireClickEvent = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_APPS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$f9db6a58b4aabd18),
                componentType: (0, $6e2f51712bb2e810$export$5374c2c2d3ece55e),
                parentItemId: appId,
                parentItemType: (0, $687cb22024c607c7$export$c3d83ca6855fa0d0),
                itemId: 'appSettings',
                section: 'yourApps'
            }
        });
    }, [
        createAnalyticsEvent,
        appId
    ]);
    const MenuItems = (0, $euxye.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($537df63f6a820e1a$var$NavMenuItems, {
            onClose: props.onClose,
            onTrackClick: fireClickEvent,
            settingsUrl: settingsUrl,
            reorderActions: reorderActions
        }), [
        fireClickEvent,
        settingsUrl,
        reorderActions
    ]);
    if ((0, $2700E.expVal)('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) {
        if (!settingsUrl && !reorderActions) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
            MenuItems: MenuItems,
            onOpen: fireOpenEvent,
            onClose: onClose
        });
    }
    if (!settingsUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
        MenuItems: MenuItems,
        onOpen: fireOpenEvent,
        onClose: onClose
    });
}
$537df63f6a820e1a$export$6b031ef628e5f9c2.displayName = "AppActions";

});

parcelRegister("kIU6u", function(module, exports) {
$parcel$export(module.exports, "useAppReordering", () => $5a2ca995e3c00bef$export$7908185241d858ea);

var $kFgCO = parcelRequire("kFgCO");

var $2NSbF = parcelRequire("2NSbF");

var $kt86l = parcelRequire("kt86l");

var $bZhC2 = parcelRequire("bZhC2");

var $h3LJR = parcelRequire("h3LJR");
const $5a2ca995e3c00bef$export$7908185241d858ea = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const { data: { user: { accountId: accountId } } } = (0, $kFgCO.useCurrentUser)();
    const entityAri = (0, $bZhC2.JiraNavigationSettingsAri).create({
        siteId: cloudId,
        activationId: activationId,
        navigationSettingScope: 'apps'
    }).toString();
    const ownerAri = (0, $2NSbF.IdentityUserAri).create({
        userId: accountId || 'UNKNOWN'
    }).toString();
    return {
        entityAri: entityAri,
        ownerAri: ownerAri,
        group: 'SIDE_NAVIGATION_STARRED_APPS'
    };
};

});



parcelRegister("7LgQz", function(module, exports) {
$parcel$export(module.exports, "Nav4ForgeMenuItem", () => $441e39b379b3758b$export$9d5c2149f38ae387);

var $ixRgo = parcelRequire("ixRgo");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $2u8Zb = parcelRequire("2u8Zb");
function $441e39b379b3758b$export$9d5c2149f38ae387({ queryRef: queryRef, currentItems: currentItems, currentOrder: currentOrder, item: item }) {
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $ixRgo.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2u8Zb.Nav4AppMenuItem), {
        queryRef: data,
        currentItems: currentItems,
        currentOrder: currentOrder,
        item: item
    });
}
$441e39b379b3758b$export$9d5c2149f38ae387.displayName = "Nav4ForgeMenuItem";

});
parcelRegister("ixRgo", function(module, exports) {
$parcel$export(module.exports, "default", () => $337bc96fada1a416$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ba4eaacce81ae770c08d18ac93ecf34>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $337bc96fada1a416$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4ForgeMenuItem",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4AppMenuItem"
        }
    ],
    "type": "JiraAppNavigationItem"
};
$337bc96fada1a416$var$node.hash = "e6f8d3ee567e6cd74addae3ad5622034";
var $337bc96fada1a416$export$2e2bcd8739ae039 = $337bc96fada1a416$var$node;

});




parcelRegister("fbaMB", function(module, exports) {
$parcel$export(module.exports, "Nav4AppsSpotlightWrapper", () => $49042a6ef132359f$export$d148eb6657a374a);

var $euxye = parcelRequire("euxye");

var $kaENz = parcelRequire("kaENz");

var $11VMX = parcelRequire("11VMX");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");
function $49042a6ef132359f$export$d148eb6657a374a({ children: children }) {
    const [{ hasOpened: shouldShowNudge }] = (0, $11VMX.useHasOpened)();
    return !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $49042a6ef132359f$var$fullWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kaENz.NavigationAppsNavItemWrapperNudgeAsync), null, children)) : children;
}
$49042a6ef132359f$export$d148eb6657a374a.displayName = "Nav4AppsSpotlightWrapper";
const $49042a6ef132359f$var$fullWidthStyles = (0, $fbAgj.xcss)({
    width: '100%'
});

});
parcelRegister("kaENz", function(module, exports) {
$parcel$export(module.exports, "NavigationAppsNavItemWrapperNudgeAsync", () => $6293db1d84fd18dc$export$c143067f544307f);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");


var $4dhaE = parcelRequire("4dhaE");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6293db1d84fd18dc$var$NavigationAppsNavItemLazy = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("5iJIj")).then((exportedModule)=>exportedModule.NavigationAppsNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/NavigationAppsNavItemWrapperNudge.tsx"
});
const $6293db1d84fd18dc$export$c143067f544307f = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4dhaE.OnboardingNudgeErrorBoundary), {
        id: (0, $99cb2e6a234d7a1f$export$dd63d0099d95ba4f),
        fallback: children,
        attributes: {
            nudgeId: (0, $99cb2e6a234d7a1f$export$dd63d0099d95ba4f)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "navigation-apps-nav-item-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($6293db1d84fd18dc$var$NavigationAppsNavItemLazy, {
        nudgeId: (0, $99cb2e6a234d7a1f$export$dd63d0099d95ba4f),
        isInsideMenu: isInsideMenu
    }, children)));
$6293db1d84fd18dc$export$c143067f544307f.displayName = "NavigationAppsNavItemWrapperNudgeAsync";

});
/* eslint-disable jira/filename-case */ // Session storage constants used between going through initial onboarding screens
// and landing in JIRA
const $99cb2e6a234d7a1f$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $99cb2e6a234d7a1f$export$e3884212029f7bef = 'should-show-welcome-modal';
const $99cb2e6a234d7a1f$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $99cb2e6a234d7a1f$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $99cb2e6a234d7a1f$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $99cb2e6a234d7a1f$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $99cb2e6a234d7a1f$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $99cb2e6a234d7a1f$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $99cb2e6a234d7a1f$export$6e69f8dc03075ef8 = 'team-type';
const $99cb2e6a234d7a1f$export$c06666264cd35603 = 'team-type-shorthand';
const $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $99cb2e6a234d7a1f$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $99cb2e6a234d7a1f$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $99cb2e6a234d7a1f$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $99cb2e6a234d7a1f$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $99cb2e6a234d7a1f$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $99cb2e6a234d7a1f$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $99cb2e6a234d7a1f$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $99cb2e6a234d7a1f$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $99cb2e6a234d7a1f$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $99cb2e6a234d7a1f$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $99cb2e6a234d7a1f$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $99cb2e6a234d7a1f$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99cb2e6a234d7a1f$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $99cb2e6a234d7a1f$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99cb2e6a234d7a1f$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $99cb2e6a234d7a1f$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $99cb2e6a234d7a1f$export$468488291ccd988 = 'timelineAddItemNudge';
const $99cb2e6a234d7a1f$export$7a33548109ac931d = 'createFormNudge';
const $99cb2e6a234d7a1f$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $99cb2e6a234d7a1f$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $99cb2e6a234d7a1f$export$594d3436316492be = 'summaryViewNudge';
const $99cb2e6a234d7a1f$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $99cb2e6a234d7a1f$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99cb2e6a234d7a1f$export$699265ec8ad9a740 = 'Software Development';
const $99cb2e6a234d7a1f$export$e07d1fa2da8ed874 = 'Customer Service';
const $99cb2e6a234d7a1f$export$76dcec3f438d9e56 = 'IT Support';
const $99cb2e6a234d7a1f$export$9a574c301f67ba30 = 'Human Resources';
const $99cb2e6a234d7a1f$export$363ec144a94029c8 = 'Finance';
const $99cb2e6a234d7a1f$export$df0fb32d68ae1e78 = 'Legal';
const $99cb2e6a234d7a1f$export$d9c0e3e59442fb4 = 'Marketing';
const $99cb2e6a234d7a1f$export$27dbc7d7ce66e6e3 = 'Operations';
const $99cb2e6a234d7a1f$export$a5dce388adf922bd = 'Sales';
const $99cb2e6a234d7a1f$export$e1473b31a257caff = 'Data Science';
const $99cb2e6a234d7a1f$export$85657457db93c2c2 = 'Product Management';
const $99cb2e6a234d7a1f$export$c0c2d1dfaeba89dd = 'Project Management';
const $99cb2e6a234d7a1f$export$2e6a7ad3ab9c82a3 = 'Design';
const $99cb2e6a234d7a1f$export$7b60378c3b4372e9 = 'Other or Personal';
const $99cb2e6a234d7a1f$export$572242e58bd07594 = 'CS';
const $99cb2e6a234d7a1f$export$d7de553940261eba = 'ITS';
const $99cb2e6a234d7a1f$export$4c29d0d04c15e55d = 'HR';
const $99cb2e6a234d7a1f$export$3950f7f841bf94b6 = 'FNC';
const $99cb2e6a234d7a1f$export$881249b988b6030f = 'LGL';
const $99cb2e6a234d7a1f$export$e4824f74b9879164 = 'MKT';
const $99cb2e6a234d7a1f$export$4f3cb0844009af52 = 'OPS';
const $99cb2e6a234d7a1f$export$1a65d50c4a641bb4 = 'SAL';
const $99cb2e6a234d7a1f$export$9ee64e8fbd8b03a2 = 'DS';
const $99cb2e6a234d7a1f$export$b8b1ac856ba1434b = 'DEV';
const $99cb2e6a234d7a1f$export$4f54a09a24fd1d74 = 'PDM';
const $99cb2e6a234d7a1f$export$79685802e8ff1098 = 'PJM';
const $99cb2e6a234d7a1f$export$e5c438b7501b5a24 = 'DES';
const $99cb2e6a234d7a1f$export$cbc0e551d91a692d = 'OTR';

parcelRegister("4dhaE", function(module, exports) {
$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $c9f3e130b4fb2f28$export$3915a8814b99f0b);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3GXRL = parcelRequire("3GXRL");

var $5ZtCQ = parcelRequire("5ZtCQ");
const $c9f3e130b4fb2f28$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3GXRL.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $5ZtCQ.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};
$c9f3e130b4fb2f28$export$3915a8814b99f0b.displayName = "OnboardingNudgeErrorBoundary";

});
parcelRegister("3GXRL", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $e8fc8984665e0283$export$9171acf2e93b7d4d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $iuYkJ = parcelRequire("iuYkJ");
const $e8fc8984665e0283$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $iuYkJ.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};
$e8fc8984665e0283$export$9171acf2e93b7d4d.displayName = "ErrorBoundaryWithChunkErrorLogging";

});
parcelRegister("iuYkJ", function(module, exports) {
$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $638333d69388a906$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $638333d69388a906$export$807be5f3f1ea996);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8dImz = parcelRequire("8dImz");
const $638333d69388a906$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $8dImz.isLoaderError)(error)
    });
const $638333d69388a906$export$807be5f3f1ea996 = (attributes = {})=>(0, $euxye.useCallback)((error)=>({
            ...attributes,
            ...$638333d69388a906$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});


parcelRegister("5ZtCQ", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $e9ca6c00748e0698$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $e9ca6c00748e0698$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $e9ca6c00748e0698$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $e9ca6c00748e0698$export$b580da85daad7757);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $e9ca6c00748e0698$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $e9ca6c00748e0698$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $e9ca6c00748e0698$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $e9ca6c00748e0698$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $e9ca6c00748e0698$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $e9ca6c00748e0698$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $e9ca6c00748e0698$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $e9ca6c00748e0698$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $e9ca6c00748e0698$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $e9ca6c00748e0698$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $e9ca6c00748e0698$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $e9ca6c00748e0698$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $e9ca6c00748e0698$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "PLAN_TEAM_CAPACITY_TASK", () => $e9ca6c00748e0698$export$d324bd587f924f18);
$parcel$export(module.exports, "PLAN_PROGRAM_BOARD_TASK", () => $e9ca6c00748e0698$export$a253dd77ea687e0a);
$parcel$export(module.exports, "PLAN_RELEASE_MANAGEMENT_TASK", () => $e9ca6c00748e0698$export$bffdfa5c4de9d4b);
$parcel$export(module.exports, "PLAN_DEPENDENCY_TRACKING_TASK", () => $e9ca6c00748e0698$export$31928f71f777342f);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $e9ca6c00748e0698$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $e9ca6c00748e0698$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $e9ca6c00748e0698$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $e9ca6c00748e0698$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $e9ca6c00748e0698$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $e9ca6c00748e0698$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $e9ca6c00748e0698$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $e9ca6c00748e0698$export$3380e677209260fe);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $e9ca6c00748e0698$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $e9ca6c00748e0698$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $e9ca6c00748e0698$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $e9ca6c00748e0698$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $e9ca6c00748e0698$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $e9ca6c00748e0698$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $e9ca6c00748e0698$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $e9ca6c00748e0698$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $e9ca6c00748e0698$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $e9ca6c00748e0698$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $e9ca6c00748e0698$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $e9ca6c00748e0698$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $e9ca6c00748e0698$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $e9ca6c00748e0698$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $e9ca6c00748e0698$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $e9ca6c00748e0698$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $e9ca6c00748e0698$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $e9ca6c00748e0698$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $e9ca6c00748e0698$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $e9ca6c00748e0698$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $e9ca6c00748e0698$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $e9ca6c00748e0698$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $e9ca6c00748e0698$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $e9ca6c00748e0698$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $e9ca6c00748e0698$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $e9ca6c00748e0698$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $e9ca6c00748e0698$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $e9ca6c00748e0698$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $e9ca6c00748e0698$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $e9ca6c00748e0698$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $e9ca6c00748e0698$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $e9ca6c00748e0698$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $e9ca6c00748e0698$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $e9ca6c00748e0698$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $e9ca6c00748e0698$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $e9ca6c00748e0698$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $e9ca6c00748e0698$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $e9ca6c00748e0698$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $e9ca6c00748e0698$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $e9ca6c00748e0698$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $e9ca6c00748e0698$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $e9ca6c00748e0698$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $e9ca6c00748e0698$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $e9ca6c00748e0698$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $e9ca6c00748e0698$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $e9ca6c00748e0698$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $e9ca6c00748e0698$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $e9ca6c00748e0698$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $e9ca6c00748e0698$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $e9ca6c00748e0698$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $e9ca6c00748e0698$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $e9ca6c00748e0698$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $e9ca6c00748e0698$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $e9ca6c00748e0698$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $e9ca6c00748e0698$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $e9ca6c00748e0698$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $e9ca6c00748e0698$export$1de5766b7e640d6b);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $e9ca6c00748e0698$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $e9ca6c00748e0698$export$c8ab6996f562d0db);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $e9ca6c00748e0698$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $e9ca6c00748e0698$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $e9ca6c00748e0698$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $e9ca6c00748e0698$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $e9ca6c00748e0698$export$7578902c7f420a3);
$parcel$export(module.exports, "SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON", () => $e9ca6c00748e0698$export$5980f41aa657f9c7);
/* eslint-disable jira/filename-case */ const $e9ca6c00748e0698$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$var$completePlanTaskName = (taskId)=>`plan-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $e9ca6c00748e0698$export$2b3151a089bc8780 = 'jlove-makkuro';
const $e9ca6c00748e0698$export$6826d33e9a2c0119 = 320;
const $e9ca6c00748e0698$export$b580da85daad7757 = 'root';
const $e9ca6c00748e0698$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $e9ca6c00748e0698$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $e9ca6c00748e0698$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $e9ca6c00748e0698$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $e9ca6c00748e0698$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $e9ca6c00748e0698$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $e9ca6c00748e0698$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $e9ca6c00748e0698$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $e9ca6c00748e0698$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $e9ca6c00748e0698$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $e9ca6c00748e0698$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $e9ca6c00748e0698$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $e9ca6c00748e0698$export$63b0e55f9c6454ac = $e9ca6c00748e0698$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $e9ca6c00748e0698$export$d324bd587f924f18 = $e9ca6c00748e0698$var$completePlanTaskName('team-capacity-task');
const $e9ca6c00748e0698$export$a253dd77ea687e0a = $e9ca6c00748e0698$var$completePlanTaskName('program-board-task');
const $e9ca6c00748e0698$export$bffdfa5c4de9d4b = $e9ca6c00748e0698$var$completePlanTaskName('release-management-task');
const $e9ca6c00748e0698$export$31928f71f777342f = $e9ca6c00748e0698$var$completePlanTaskName('dependency-tracking-task');
const $e9ca6c00748e0698$export$77071b77e2801b18 = $e9ca6c00748e0698$var$completeJwmTaskName('jwm-create-project-task');
const $e9ca6c00748e0698$export$d37415ffddcf2142 = $e9ca6c00748e0698$var$completeJwmTaskName('build-form-task');
const $e9ca6c00748e0698$export$2aa6e7b6e24a04f5 = $e9ca6c00748e0698$var$completeJwmTaskName('calendar-task');
const $e9ca6c00748e0698$export$f3b53199b07af2a1 = $e9ca6c00748e0698$var$completeJwmTaskName('timeline-task');
const $e9ca6c00748e0698$export$b52a7c936684cfc5 = $e9ca6c00748e0698$var$completeJwmTaskName('trello-crossflow-import');
const $e9ca6c00748e0698$export$b5555f24061f9fb = $e9ca6c00748e0698$var$completeJwmTaskName('summary-and-reports-task');
const $e9ca6c00748e0698$export$ff25449f34b8abf = $e9ca6c00748e0698$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $e9ca6c00748e0698$export$3380e677209260fe = $e9ca6c00748e0698$var$completeJwmTaskName('trello-crossflow-key-differences');
const $e9ca6c00748e0698$export$da23b72d32bfad9e = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $e9ca6c00748e0698$export$4b064659282e0238 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $e9ca6c00748e0698$export$3ab51851f6d823e = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $e9ca6c00748e0698$export$e4a1a37a9a1350ad = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $e9ca6c00748e0698$export$b7f7da5e795f0327 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $e9ca6c00748e0698$export$80a401c1aa47a377 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $e9ca6c00748e0698$export$934ac7a251b26dc7 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $e9ca6c00748e0698$export$4634f6395df3ebbe = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $e9ca6c00748e0698$export$768fb41107a1e8d7 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $e9ca6c00748e0698$export$d797a81bace17184 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $e9ca6c00748e0698$export$746102c94db9df1f = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $e9ca6c00748e0698$export$5f1efd797d65e349 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $e9ca6c00748e0698$export$cccc812ccafbf11f = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $e9ca6c00748e0698$export$64822db87abd8a47 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $e9ca6c00748e0698$export$64f764d8be495c82 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $e9ca6c00748e0698$export$24eae23dc1c68bbd = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $e9ca6c00748e0698$export$50fa92eba6f82feb = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $e9ca6c00748e0698$export$4155d22fe3f14cd6 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $e9ca6c00748e0698$export$76813cbead887191 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $e9ca6c00748e0698$export$90aab2ff89daf770 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $e9ca6c00748e0698$export$a2bc0cbad2e6e605 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $e9ca6c00748e0698$export$f90872a1280728bb = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $e9ca6c00748e0698$export$bce644e96518cbd2 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $e9ca6c00748e0698$export$241aaebffac0a3e5 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $e9ca6c00748e0698$export$f9dfc43b5b31c4b7 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $e9ca6c00748e0698$export$79759e9e62fb9312 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $e9ca6c00748e0698$export$992d1e0dce255d19 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $e9ca6c00748e0698$export$d28c1b0e5b3e768 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $e9ca6c00748e0698$export$ca714ee197bed4ec = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $e9ca6c00748e0698$export$faae55ceea4b6073 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $e9ca6c00748e0698$export$200bc24cd120667e = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $e9ca6c00748e0698$export$a0d784a48b4e886c = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $e9ca6c00748e0698$export$baf5bd09b4b33b8a = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $e9ca6c00748e0698$export$4702007eedbca8ab = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $e9ca6c00748e0698$export$aa9d2d635ea63898 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $e9ca6c00748e0698$export$2ea449225c1f6cac = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $e9ca6c00748e0698$export$deb8b557e735e26a = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $e9ca6c00748e0698$export$d45754df44e4c309 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $e9ca6c00748e0698$export$78b2913b550edbb = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $e9ca6c00748e0698$export$71243272608c58ab = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $e9ca6c00748e0698$export$39a08f215c33bc39 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $e9ca6c00748e0698$export$d2377f6a6fa3b49c = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $e9ca6c00748e0698$export$befa8f6533309779 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $e9ca6c00748e0698$export$736b40db8701ba6c = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $e9ca6c00748e0698$export$11eff6ae2f70b67b = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $e9ca6c00748e0698$export$fb2d23e5315a67a9 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $e9ca6c00748e0698$export$32e794bb49d60b6 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $e9ca6c00748e0698$export$fed256238b27db06 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $e9ca6c00748e0698$export$132eecb4d35a590d = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $e9ca6c00748e0698$export$2579c51cadd45eca = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $e9ca6c00748e0698$export$4b1a0cefa966ea0 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $e9ca6c00748e0698$export$f6558daacc312a65 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $e9ca6c00748e0698$export$925efa2e24e86b88 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $e9ca6c00748e0698$export$40454d3e062dcd44 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $e9ca6c00748e0698$export$99b0e09ff6f00490 = $e9ca6c00748e0698$var$completeJsmTaskName('customize-your-request-types-task');
const $e9ca6c00748e0698$export$2a82344eb273eeff = $e9ca6c00748e0698$var$completeJsmTaskName('review-your-channels-task');
const $e9ca6c00748e0698$export$1de5766b7e640d6b = $e9ca6c00748e0698$var$completeJsmTaskName('invite-your-team-task');
const $e9ca6c00748e0698$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $e9ca6c00748e0698$export$c8ab6996f562d0db = 'accountId';
const $e9ca6c00748e0698$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $e9ca6c00748e0698$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $e9ca6c00748e0698$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $e9ca6c00748e0698$export$38fbac7a5bf4aa33 = [
    $e9ca6c00748e0698$export$2a82344eb273eeff,
    $e9ca6c00748e0698$export$99b0e09ff6f00490,
    $e9ca6c00748e0698$export$1de5766b7e640d6b
];
const $e9ca6c00748e0698$export$7578902c7f420a3 = [
    $e9ca6c00748e0698$export$63b0e55f9c6454ac,
    $e9ca6c00748e0698$export$77071b77e2801b18,
    $e9ca6c00748e0698$export$d37415ffddcf2142,
    $e9ca6c00748e0698$export$b52a7c936684cfc5,
    $e9ca6c00748e0698$export$b5555f24061f9fb,
    $e9ca6c00748e0698$export$ff25449f34b8abf,
    $e9ca6c00748e0698$export$3380e677209260fe,
    $e9ca6c00748e0698$export$da23b72d32bfad9e,
    $e9ca6c00748e0698$export$4b064659282e0238,
    $e9ca6c00748e0698$export$3ab51851f6d823e,
    $e9ca6c00748e0698$export$e4a1a37a9a1350ad,
    $e9ca6c00748e0698$export$b7f7da5e795f0327,
    $e9ca6c00748e0698$export$80a401c1aa47a377,
    $e9ca6c00748e0698$export$934ac7a251b26dc7,
    $e9ca6c00748e0698$export$4634f6395df3ebbe,
    $e9ca6c00748e0698$export$768fb41107a1e8d7,
    $e9ca6c00748e0698$export$d797a81bace17184,
    $e9ca6c00748e0698$export$746102c94db9df1f,
    $e9ca6c00748e0698$export$5f1efd797d65e349,
    $e9ca6c00748e0698$export$cccc812ccafbf11f,
    $e9ca6c00748e0698$export$64822db87abd8a47,
    $e9ca6c00748e0698$export$64f764d8be495c82,
    $e9ca6c00748e0698$export$24eae23dc1c68bbd,
    $e9ca6c00748e0698$export$50fa92eba6f82feb,
    $e9ca6c00748e0698$export$4155d22fe3f14cd6,
    $e9ca6c00748e0698$export$76813cbead887191,
    $e9ca6c00748e0698$export$90aab2ff89daf770,
    $e9ca6c00748e0698$export$a2bc0cbad2e6e605,
    $e9ca6c00748e0698$export$f90872a1280728bb,
    $e9ca6c00748e0698$export$bce644e96518cbd2,
    $e9ca6c00748e0698$export$241aaebffac0a3e5,
    $e9ca6c00748e0698$export$f9dfc43b5b31c4b7,
    $e9ca6c00748e0698$export$79759e9e62fb9312,
    $e9ca6c00748e0698$export$992d1e0dce255d19,
    $e9ca6c00748e0698$export$d28c1b0e5b3e768,
    $e9ca6c00748e0698$export$ca714ee197bed4ec,
    $e9ca6c00748e0698$export$faae55ceea4b6073,
    $e9ca6c00748e0698$export$200bc24cd120667e,
    $e9ca6c00748e0698$export$a0d784a48b4e886c,
    $e9ca6c00748e0698$export$baf5bd09b4b33b8a,
    $e9ca6c00748e0698$export$4702007eedbca8ab,
    $e9ca6c00748e0698$export$aa9d2d635ea63898,
    $e9ca6c00748e0698$export$2ea449225c1f6cac,
    $e9ca6c00748e0698$export$deb8b557e735e26a,
    $e9ca6c00748e0698$export$d45754df44e4c309,
    $e9ca6c00748e0698$export$78b2913b550edbb,
    $e9ca6c00748e0698$export$71243272608c58ab,
    $e9ca6c00748e0698$export$39a08f215c33bc39,
    $e9ca6c00748e0698$export$d2377f6a6fa3b49c,
    $e9ca6c00748e0698$export$befa8f6533309779,
    $e9ca6c00748e0698$export$736b40db8701ba6c,
    // Tailored onboarding M3
    $e9ca6c00748e0698$export$11eff6ae2f70b67b,
    $e9ca6c00748e0698$export$fb2d23e5315a67a9,
    $e9ca6c00748e0698$export$32e794bb49d60b6,
    $e9ca6c00748e0698$export$fed256238b27db06,
    $e9ca6c00748e0698$export$132eecb4d35a590d,
    $e9ca6c00748e0698$export$2579c51cadd45eca,
    $e9ca6c00748e0698$export$4b1a0cefa966ea0,
    $e9ca6c00748e0698$export$f6558daacc312a65,
    $e9ca6c00748e0698$export$925efa2e24e86b88,
    $e9ca6c00748e0698$export$40454d3e062dcd44
];
const $e9ca6c00748e0698$export$5980f41aa657f9c7 = [
    'SAM1'
];

});


parcelRegister("5iJIj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ehdp1").then(()=>parcelRequire('av908'));

});


parcelRegister("11VMX", function(module, exports) {
$parcel$export(module.exports, "useHasOpened", () => $cef4dc00e5865d98$export$cbaabcded53b5c1f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $5vUJG = parcelRequire("5vUJG");
const $cef4dc00e5865d98$var$actions = {
    setHasOpened: $5vUJG.setHasOpened
};
const $cef4dc00e5865d98$var$initialState = {
    hasOpened: false
};
const $cef4dc00e5865d98$var$Store = (0, $5QDqc.createStore)({
    initialState: $cef4dc00e5865d98$var$initialState,
    actions: $cef4dc00e5865d98$var$actions,
    name: 'jsw-onboarding-quickstart-has-opened'
});
const $cef4dc00e5865d98$export$cbaabcded53b5c1f = (0, $3h1FP.createHook)($cef4dc00e5865d98$var$Store);

});
parcelRegister("5vUJG", function(module, exports) {
$parcel$export(module.exports, "setHasOpened", () => $2af725793541a0e6$export$c4743c64a7c42294);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2af725793541a0e6$export$c4743c64a7c42294 = ()=>({ getState: getState, setState: setState })=>{
        const { hasOpened: hasOpened } = getState();
        if (hasOpened === true) // if state has been updated already return
        return;
        setState({
            hasOpened: true
        });
    };
var $2af725793541a0e6$export$2e2bcd8739ae039 = $2af725793541a0e6$export$c4743c64a7c42294;

});





parcelRegister("rZMKj", function(module, exports) {
$parcel$export(module.exports, "Nav4Assets", () => $f683e270844900d5$export$ae278c7655ee6005);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1ntzc = parcelRequire("1ntzc");

var $j65JU = parcelRequire("j65JU");

var $bOYO0 = parcelRequire("bOYO0");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $eijVy = parcelRequire("eijVy");

var $i860n = parcelRequire("i860n");

var $1cHgD = parcelRequire("1cHgD");

var $fBt6f = parcelRequire("fBt6f");
function $f683e270844900d5$export$ae278c7655ee6005({ isExpanded: isExpanded }) {
    const tenantContext = (0, $eijVy.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    // useInsightVisibility can help fetch WorkspaceId
    const _ = (0, $j65JU.useInsightVisibility)();
    const isPremiumUser = (0, $bOYO0.isLicensedPremiumUser)(tenantContext);
    const { workspaceId: workspaceId } = (0, $j65JU.useWorkspaceContext)();
    if (!isPremiumUser) {
        (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
            serviceDeskEdition: tenantContext.appEditions?.serviceDesk,
            isSiteAdmin: tenantContext.isSiteAdmin
        });
        if ((0, $i860n.fg)('assets_as_an_app_v2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fBt6f.AssetsAppItem), {
            showUpsell: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1cHgD.AssetsSingleMenuItem), {
            showUpsellLozenge: true
        });
    }
    if ((0, $i860n.fg)('assets_as_an_app_v2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fBt6f.AssetsAppItem), {
        showUpsell: false
    });
    return workspaceId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1ntzc.InsightGlobalConfigContainer), {
        isGlobal: true,
        workspaceId: workspaceId,
        createAnalyticsEvent: createAnalyticsEvent,
        disableOnInit: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1cHgD.AssetsMenu), {
        isExpanded: isExpanded
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1cHgD.AssetsSingleMenuItem), {
        showUpsellLozenge: false
    });
}
$f683e270844900d5$export$ae278c7655ee6005.displayName = "Nav4Assets";

});
parcelRegister("1ntzc", function(module, exports) {
$parcel$export(module.exports, "useInsightGlobalConfig", () => $089c2d1268f4fcc3$export$ee996472bb397b41);
$parcel$export(module.exports, "useInsightReferenceTypes", () => $089c2d1268f4fcc3$export$efb93af726a65b26);
$parcel$export(module.exports, "useInsightStatusTypes", () => $089c2d1268f4fcc3$export$7eefa9cea32e596a);
$parcel$export(module.exports, "useInsightIcons", () => $089c2d1268f4fcc3$export$8336b36336c9f3c8);
$parcel$export(module.exports, "useDataManager", () => $089c2d1268f4fcc3$export$143bcc72da01e561);
$parcel$export(module.exports, "useCommonDataModel", () => $089c2d1268f4fcc3$export$a6f0c60c6d8cb283);
$parcel$export(module.exports, "useNamedInsightIcons", () => $089c2d1268f4fcc3$export$979b264266dab4ed);
$parcel$export(module.exports, "useIsRestrictedSchema", () => $089c2d1268f4fcc3$export$d07372ba961b2bc5);
$parcel$export(module.exports, "InsightGlobalConfigContainer", () => $089c2d1268f4fcc3$export$c4c69c73d422ea06);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $i860n = parcelRequire("i860n");

var $5gueZ = parcelRequire("5gueZ");

var $71cdE = parcelRequire("71cdE");
const $089c2d1268f4fcc3$export$d4c72bab9d6cc13a = {
    loading: false,
    error: undefined,
    config: undefined,
    referenceTypes: {
        data: undefined,
        createLoading: false,
        createError: undefined,
        deleteLoading: false,
        deleteError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    statusTypes: {
        data: undefined,
        createLoading: false,
        createError: undefined,
        deleteLoading: false,
        deleteError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    icons: {
        data: undefined,
        deleteLoading: false,
        deleteError: undefined,
        addLoading: false,
        addError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    dataManager: {
        rolesData: undefined,
        rolesError: undefined,
        rolesLoading: false,
        rolesUpdateLoading: false,
        rolesUpdateError: undefined,
        tokensLoading: false,
        tokensData: undefined,
        tokensError: undefined,
        tokenRevokeLoading: false,
        tokenRevokeError: undefined,
        isProvisioned: undefined,
        provisioningLoading: false,
        provisioningError: undefined,
        provisioningUpdateLoading: false,
        provisioningUpdateError: undefined,
        myRoles: undefined,
        myRolesError: undefined,
        myRolesLoading: false,
        isDataManagerAvailable: undefined,
        isDataManagerAvailableLoading: false
    },
    cdm: {
        instantiations: undefined,
        tasks: []
    }
};
const $089c2d1268f4fcc3$var$Store = (0, $5QDqc.createStore)({
    initialState: $089c2d1268f4fcc3$export$d4c72bab9d6cc13a,
    actions: $5gueZ.actions
});
const $089c2d1268f4fcc3$export$ee996472bb397b41 = (0, $3h1FP.createHook)($089c2d1268f4fcc3$var$Store, {
    selector: (state)=>state
});
const $089c2d1268f4fcc3$export$efb93af726a65b26 = (0, $3h1FP.createHook)($089c2d1268f4fcc3$var$Store, {
    selector: ({ referenceTypes: referenceTypes })=>({
            ...referenceTypes,
            data: referenceTypes.data ? (0, $71cdE.sortReferenceTypes)(referenceTypes.data) : undefined
        })
});
const $089c2d1268f4fcc3$export$7eefa9cea32e596a = (0, $3h1FP.createHook)($089c2d1268f4fcc3$var$Store, {
    selector: ({ statusTypes: statusTypes })=>({
            ...statusTypes,
            data: statusTypes.data ? (0, $71cdE.sortStatusTypes)(statusTypes.data) : undefined
        })
});
const $089c2d1268f4fcc3$export$8336b36336c9f3c8 = (0, $3h1FP.createHook)($089c2d1268f4fcc3$var$Store, {
    selector: ({ icons: icons })=>icons
});
const $089c2d1268f4fcc3$export$143bcc72da01e561 = (0, $3h1FP.createHook)($089c2d1268f4fcc3$var$Store, {
    selector: ({ dataManager: dataManager })=>dataManager
});
const $089c2d1268f4fcc3$export$a6f0c60c6d8cb283 = (0, $3h1FP.createHook)($089c2d1268f4fcc3$var$Store, {
    selector: ({ cdm: cdm })=>cdm
});
const $089c2d1268f4fcc3$export$979b264266dab4ed = (0, $3h1FP.createStateHook)($089c2d1268f4fcc3$var$Store, {
    selector: ({ icons: icons })=>{
        const map = {};
        (icons.data ?? []).forEach((icon)=>{
            map[icon.name] = icon;
        });
        return map;
    }
});
const $089c2d1268f4fcc3$export$9c8eee3abcaa634e = (state, schemaId)=>{
    const restrictedObjectSchemaIds = state.config?.restrictedObjectSchemaIds ?? [];
    return restrictedObjectSchemaIds.includes(parseInt(schemaId, 10));
};
const $089c2d1268f4fcc3$export$d07372ba961b2bc5 = (0, $3h1FP.createHook)($089c2d1268f4fcc3$var$Store, {
    selector: $089c2d1268f4fcc3$export$9c8eee3abcaa634e
});
const $089c2d1268f4fcc3$var$autoFetchGlobalConfig = ()=>({ dispatch: dispatch, getState: getState }, { disableOnInit: disableOnInit })=>{
        const { loading: loading, error: error, config: config } = getState();
        if ((0, $i860n.fg)('data-manager-units-onboarding')) dispatch((0, $5gueZ.actions).fetchIsDataManagerAvailable());
        if (!disableOnInit && !loading && !error && !config) {
            dispatch((0, $5gueZ.actions).fetchGlobalConfig());
            if ((0, $i860n.fg)('assets_cdm_ui_flow')) dispatch((0, $5gueZ.actions).fetchCdm());
            if ((0, $i860n.fg)('assets_as_an_app_v2')) {
                dispatch((0, $5gueZ.actions).fetchProvisioningStatus());
                dispatch((0, $5gueZ.actions).fetchMyDataManagerRoles());
            }
        }
    };
const $089c2d1268f4fcc3$export$c4c69c73d422ea06 = (0, $dB6ay.createContainer)($089c2d1268f4fcc3$var$Store, {
    onInit: $089c2d1268f4fcc3$var$autoFetchGlobalConfig
});

});
parcelRegister("5gueZ", function(module, exports) {
$parcel$export(module.exports, "actions", () => $d1f52fb1bae763b0$export$e324594224ef24da);
/* eslint-disable jira/filename-case */ 
var $eGz9b = parcelRequire("eGz9b");

var $8CIHz = parcelRequire("8CIHz");

var $5ZX4K = parcelRequire("5ZX4K");

var $9Uk9U = parcelRequire("9Uk9U");

var $8KJoS = parcelRequire("8KJoS");

var $7EbKM = parcelRequire("7EbKM");

var $lOemx = parcelRequire("lOemx");

var $hacul = parcelRequire("hacul");

var $4giZE = parcelRequire("4giZE");

var $aH3eH = parcelRequire("aH3eH");

var $jMWz2 = parcelRequire("jMWz2");

var $1oJL8 = parcelRequire("1oJL8");

var $iRdQ0 = parcelRequire("iRdQ0");

var $6rM2B = parcelRequire("6rM2B");

var $81SnW = parcelRequire("81SnW");

var $iRSmJ = parcelRequire("iRSmJ");

var $8AE9F = parcelRequire("8AE9F");

var $gykY5 = parcelRequire("gykY5");

var $ghOtU = parcelRequire("ghOtU");
const $d1f52fb1bae763b0$export$e324594224ef24da = {
    addIcon: $eGz9b.addIcon,
    createReferenceType: $8CIHz.createReferenceType,
    createStatusType: $5ZX4K.createStatusType,
    deleteIcon: $9Uk9U.deleteIcon,
    deleteReferenceType: $8KJoS.deleteReferenceType,
    deleteStatusType: $7EbKM.deleteStatusType,
    fetchCdm: $iRdQ0.fetchCdm,
    fetchDataManagerTokens: $1oJL8.fetchDataManagerTokens,
    fetchGlobalConfig: $hacul.fetchGlobalConfig,
    fetchIsDataManagerAvailable: $lOemx.fetchIsDataManagerAvailable,
    fetchMyDataManagerRoles: $4giZE.fetchMyDataManagerRoles,
    fetchPrincipalsForRoles: $aH3eH.fetchPrincipalsForRoles,
    fetchProvisioningStatus: $jMWz2.fetchProvisioningStatus,
    installCdm: $6rM2B.installCdm,
    setIcon: $iRSmJ.setIcon,
    setReferenceType: $gykY5.setReferenceType,
    setStatusType: $ghOtU.setStatusType,
    updateDataManagerRole: $81SnW.updateDataManagerRole,
    updateIcon: $iRSmJ.updateIcon,
    updateProvisioningStatus: $8AE9F.updateProvisioningStatus,
    updateReferenceType: $gykY5.updateReferenceType,
    updateStatusType: $ghOtU.updateStatusType
};

});
parcelRegister("eGz9b", function(module, exports) {
$parcel$export(module.exports, "addIcon", () => $3ece78116f2692ba$export$3488242433cbedb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $aJ81Y = parcelRequire("aJ81Y");

var $keqWM = parcelRequire("keqWM");

var $1F4TY = parcelRequire("1F4TY");
const $3ece78116f2692ba$export$3488242433cbedb = (newIcon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                addLoading: true
            }
        });
        try {
            const uploadCredentials = await (0, $1F4TY.mediaInfoForUpload)(workspaceId);
            const uploadMediaResult = await (0, $1F4TY.mediaUploadFile)({
                mediaBaseUrl: (0, $keqWM.toMediaBaseUrl)(uploadCredentials.mediaBaseUrl),
                collectionId: (0, $keqWM.toCollectionId)(uploadCredentials.collectionId),
                fileName: (0, $keqWM.toFileName)(newIcon.fileName),
                clientId: (0, $keqWM.toMediaClientId)(uploadCredentials.clientId),
                mediaJwtToken: (0, $keqWM.toMediaJwt)(uploadCredentials.mediaJwtToken),
                blob: newIcon.blob
            });
            const mediaInfoForPullingResult = await (0, $1F4TY.mediaInfoForPulling)(workspaceId, (0, $keqWM.toMediaFileUuid)(uploadMediaResult.data.id));
            const pollMediaFileReady = ()=>{
                const getMediaFileStatus = ()=>(0, $1F4TY.mediaGetFileInfo)({
                        mediaBaseUrl: (0, $keqWM.toMediaBaseUrl)(mediaInfoForPullingResult.mediaBaseUrl),
                        mediaFileUuid: (0, $keqWM.toMediaFileUuid)(uploadMediaResult.data.id),
                        clientId: (0, $keqWM.toMediaClientId)(uploadCredentials.clientId),
                        mediaJwtToken: (0, $keqWM.toMediaJwt)(mediaInfoForPullingResult.mediaJwtToken)
                    });
                return new Promise((resolve, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
                reject)=>{
                    const poll = (attempt = 0)=>{
                        const statusPromise = getMediaFileStatus();
                        statusPromise.then((response)=>{
                            const status = response.data.processingStatus;
                            switch(status){
                                default:
                                case (0, $keqWM.MEDIA_PROCESS_STATUS).PENDING:
                                case (0, $keqWM.MEDIA_PROCESS_STATUS).RUNNING:
                                    return setTimeout(()=>{
                                        // 20 tries before throwing an error
                                        if (attempt > 20) return reject(new Error('Failed to add icon after 10 tries'));
                                        return poll(attempt + 1);
                                    }, 5000);
                                case (0, $keqWM.MEDIA_PROCESS_STATUS).SUCCEEDED:
                                    // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                                    return resolve();
                                case (0, $keqWM.MEDIA_PROCESS_STATUS).FAILED:
                                    return reject(new Error('Media services failed to process file!'));
                            }
                        }).catch((error)=>reject(new Error(error)));
                    };
                    poll();
                });
            };
            await pollMediaFileReady();
            const savedIconEntry = await (0, $1F4TY.publishNewIcon)(workspaceId, (0, $keqWM.toIconName)(newIcon.iconName), (0, $keqWM.toMediaFileUuid)(uploadMediaResult.data.id));
            // Make flow happy
            if (!Array.isArray(state.icons.data)) throw new Error('Invalid state! Icons data is not array!');
            const newIconsData = state.icons.data.slice(0);
            newIconsData.unshift(savedIconEntry);
            const newState = {
                ...state,
                icons: {
                    ...state.icons,
                    addLoading: false,
                    data: newIconsData
                }
            };
            setState(newState);
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'addIcon succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    addLoading: false,
                    addError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'addIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("keqWM", function(module, exports) {
$parcel$export(module.exports, "MEDIA_PROCESS_STATUS", () => $30f92c00723f594d$export$a760cae7c12e7f51);
$parcel$export(module.exports, "toMediaBaseUrl", () => $30f92c00723f594d$export$342e5c2fdd47297c);
$parcel$export(module.exports, "toCollectionId", () => $30f92c00723f594d$export$59b8a2c37e183bf5);
$parcel$export(module.exports, "toIconName", () => $30f92c00723f594d$export$41540e96af228b1a);
$parcel$export(module.exports, "toFileName", () => $30f92c00723f594d$export$249aa0c12095aafd);
$parcel$export(module.exports, "toMediaJwt", () => $30f92c00723f594d$export$dce78fe68aa68f20);
$parcel$export(module.exports, "toMediaFileUuid", () => $30f92c00723f594d$export$79083a8ab294d28e);
$parcel$export(module.exports, "toMediaClientId", () => $30f92c00723f594d$export$b105972f97cb69fa);
const $30f92c00723f594d$export$a760cae7c12e7f51 = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    PENDING: 'pending',
    RUNNING: 'running'
};
const $30f92c00723f594d$export$342e5c2fdd47297c = (url)=>url;
const $30f92c00723f594d$export$59b8a2c37e183bf5 = (uuid)=>uuid;
const $30f92c00723f594d$export$41540e96af228b1a = (iconName)=>iconName;
const $30f92c00723f594d$export$249aa0c12095aafd = (fileName)=>fileName;
const $30f92c00723f594d$export$9dd52a3c923cba73 = (mediaIssuer)=>mediaIssuer;
const $30f92c00723f594d$export$dce78fe68aa68f20 = (mediaIssuer)=>mediaIssuer;
const $30f92c00723f594d$export$79083a8ab294d28e = (mediaFileUuid)=>mediaFileUuid;
const $30f92c00723f594d$export$b105972f97cb69fa = (mediaClientId)=>mediaClientId;

});

parcelRegister("1F4TY", function(module, exports) {
$parcel$export(module.exports, "mediaInfoForUpload", () => $4defb81869c18198$export$c7944179dc1cb15d);
$parcel$export(module.exports, "mediaUploadFile", () => $4defb81869c18198$export$6fba374ded90c76b);
$parcel$export(module.exports, "mediaInfoForPulling", () => $4defb81869c18198$export$4138ca7fa1c5dcbc);
$parcel$export(module.exports, "mediaGetFileInfo", () => $4defb81869c18198$export$c607c6f99a3a53ca);
$parcel$export(module.exports, "publishNewIcon", () => $4defb81869c18198$export$a7fc7d8db8ccf9da);
/* eslint-disable jira/filename-case */ 
var $eh7eP = parcelRequire("eh7eP");

var $dBNCB = parcelRequire("dBNCB");

var $h2wCv = parcelRequire("h2wCv");
const $4defb81869c18198$export$336c36f125eba39c = ({ clientId: clientId, mediaJwtToken: mediaJwtToken })=>{
    return {
        'X-Client-Id': clientId,
        Authorization: `Bearer ${mediaJwtToken}`
    };
};
const $4defb81869c18198$export$c7944179dc1cb15d = (workspaceId)=>(0, $eh7eP.performCmdbGetRequest)((0, $dBNCB.getCmdbIconTokenUploadingUrl)(workspaceId));
const $4defb81869c18198$export$6fba374ded90c76b = ({ mediaBaseUrl: mediaBaseUrl, collectionId: collectionId, fileName: fileName, mediaJwtToken: mediaJwtToken, blob: blob, clientId: clientId })=>(0, $h2wCv.performPostRequest)(`${String(mediaBaseUrl)}/file/binary?collection=${String(collectionId)}&name=${String(fileName)}&deletable=true`, {
        headers: {
            ...$4defb81869c18198$export$336c36f125eba39c({
                clientId: clientId,
                mediaJwtToken: mediaJwtToken
            }),
            'Content-Type': blob.type
        },
        body: blob
    });
const $4defb81869c18198$export$4138ca7fa1c5dcbc = (workspaceId, fileUuid)=>(0, $eh7eP.performCmdbGetRequest)((0, $dBNCB.getCmdbIconTokenFetchingUrl)(workspaceId, fileUuid));
const $4defb81869c18198$export$c607c6f99a3a53ca = ({ mediaBaseUrl: mediaBaseUrl, mediaFileUuid: mediaFileUuid, mediaJwtToken: mediaJwtToken, clientId: clientId })=>(0, $h2wCv.performGetRequest)(`${String(mediaBaseUrl)}/file/${String(mediaFileUuid)}`, {
        headers: $4defb81869c18198$export$336c36f125eba39c({
            clientId: clientId,
            mediaJwtToken: mediaJwtToken
        })
    });
const $4defb81869c18198$export$a7fc7d8db8ccf9da = (workspaceId, iconName, mediaFileUuid)=>(0, $eh7eP.performCmdbPostRequest)((0, $dBNCB.getCmdbIconCreateUrl)(workspaceId), {
        body: JSON.stringify({
            name: iconName,
            mediaFileUuid: mediaFileUuid
        })
    });

});
parcelRegister("dBNCB", function(module, exports) {
$parcel$export(module.exports, "getCmdbIconCreateUrl", () => $2f0693206055e92f$export$4c6ff27b48881aba);
$parcel$export(module.exports, "getCmdbIconTokenFetchingUrl", () => $2f0693206055e92f$export$39e83f10cc93fe99);
$parcel$export(module.exports, "getCmdbIconTokenUploadingUrl", () => $2f0693206055e92f$export$7fdc9cd59a492763);
$parcel$export(module.exports, "getCmdbIconByIdUrl", () => $2f0693206055e92f$export$b881a625e1bc4876);
/* eslint-disable jira/filename-case */ 
var $iGhBm = parcelRequire("iGhBm");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/icon
 */ const $2f0693206055e92f$var$getCmdbIconUrl = (workspaceId)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/icon`;
const $2f0693206055e92f$export$4c6ff27b48881aba = (workspaceId)=>`${$2f0693206055e92f$var$getCmdbIconUrl(workspaceId)}/create`;
const $2f0693206055e92f$export$39e83f10cc93fe99 = (workspaceId, fileUuid)=>`${$2f0693206055e92f$var$getCmdbIconUrl(workspaceId)}/token-for-fetching-icon/${fileUuid}`;
const $2f0693206055e92f$export$7fdc9cd59a492763 = (workspaceId)=>`${$2f0693206055e92f$var$getCmdbIconUrl(workspaceId)}/token-for-uploading-icon`;
const $2f0693206055e92f$export$b881a625e1bc4876 = (workspaceId, iconId)=>`${$2f0693206055e92f$var$getCmdbIconUrl(workspaceId)}/${iconId}`;

});
parcelRegister("iGhBm", function(module, exports) {
$parcel$export(module.exports, "getCmdbRestBaseUrl", () => $4ac863ef10e91139$export$28b6c003daedf1c2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $4ac863ef10e91139$export$28b6c003daedf1c2 = (workspaceId)=>`/gateway/api/jsm/assets/workspace/${workspaceId}/v1`;

});




parcelRegister("8CIHz", function(module, exports) {
$parcel$export(module.exports, "createReferenceType", () => $dd4e7fd65fa07c62$export$ac28770630794807);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $aJ81Y = parcelRequire("aJ81Y");
const $dd4e7fd65fa07c62$export$ac28770630794807 = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                createLoading: true
            }
        });
        try {
            const response = await (0, $eh7eP.performCmdbPostRequest)((0, $el2ZZ.getCmdbConfigReferenceTypeUrl)(workspaceId), {
                body: JSON.stringify({
                    ...data,
                    color: data.color.replace('#', '')
                })
            });
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    createLoading: false,
                    data: [
                        ...state.referenceTypes.data ?? [],
                        response
                    ]
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'createReferenceType succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    createLoading: false,
                    createError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'createReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("el2ZZ", function(module, exports) {
$parcel$export(module.exports, "getCmdbConfigStatusTypeUrl", () => $f1cc21ab7fa8ef1a$export$3269d36b59c9d27f);
$parcel$export(module.exports, "getCmdbConfigStatusTypeByIdUrl", () => $f1cc21ab7fa8ef1a$export$229964acb6a55e5);
$parcel$export(module.exports, "getCmdbConfigStatusTypePickerUrl", () => $f1cc21ab7fa8ef1a$export$1991fb4d07b18469);
$parcel$export(module.exports, "getSitesPickerUrl", () => $f1cc21ab7fa8ef1a$export$15e2e023d82b7242);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeUrl", () => $f1cc21ab7fa8ef1a$export$ad07341c88d2bbab);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeByIdUrl", () => $f1cc21ab7fa8ef1a$export$293e2bfa6752a2aa);
$parcel$export(module.exports, "getCmdbConfigRoleByIdUrl", () => $f1cc21ab7fa8ef1a$export$225d5f547cc90d86);
$parcel$export(module.exports, "getCmdbConfigRoleObjectSchemaByIdUrl", () => $f1cc21ab7fa8ef1a$export$9c1d73050da32aae);
$parcel$export(module.exports, "getCmdbConfigRoleObjectTypeByIdUrl", () => $f1cc21ab7fa8ef1a$export$6583ed007df50d2b);
$parcel$export(module.exports, "getCmdbPermsPrincipalUrl", () => $f1cc21ab7fa8ef1a$export$a635e2e9382b1621);
$parcel$export(module.exports, "getCmdbPermsRoleAssignmentUrl", () => $f1cc21ab7fa8ef1a$export$b3cb4590859563b0);
$parcel$export(module.exports, "getCmdbPermsTokenStatusUrl", () => $f1cc21ab7fa8ef1a$export$8ae00db5fd7218c5);
$parcel$export(module.exports, "getMyDataManagerRolesUrl", () => $f1cc21ab7fa8ef1a$export$794aa3ae46133f30);
/* eslint-disable jira/filename-case */ 
var $bS1iz = parcelRequire("bS1iz");

var $iGhBm = parcelRequire("iGhBm");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/config
 */ const $f1cc21ab7fa8ef1a$var$getCmdbConfigUrl = (workspaceId)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/config`;
const $f1cc21ab7fa8ef1a$export$3269d36b59c9d27f = (workspaceId, queryParams)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/statustype${queryParams ? `?${(0, $bS1iz.stringify)(queryParams)}` : ''}`;
const $f1cc21ab7fa8ef1a$export$229964acb6a55e5 = (workspaceId, statusTypeId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/statustype/${statusTypeId}`;
const $f1cc21ab7fa8ef1a$export$1991fb4d07b18469 = (workspaceId, queryParams)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/statustype/picker?${(0, $bS1iz.stringify)(queryParams)}`;
const $f1cc21ab7fa8ef1a$export$15e2e023d82b7242 = (workspaceId)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/picker/sites`;
const $f1cc21ab7fa8ef1a$export$ad07341c88d2bbab = (workspaceId, queryParams)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/referencetype${queryParams ? `?${(0, $bS1iz.stringify)(queryParams)}` : ''}`;
const $f1cc21ab7fa8ef1a$export$293e2bfa6752a2aa = (workspaceId, referenceTypeId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/referencetype/${referenceTypeId}`;
const $f1cc21ab7fa8ef1a$export$225d5f547cc90d86 = (workspaceId, roleId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/role/${roleId}`;
const $f1cc21ab7fa8ef1a$export$9c1d73050da32aae = (workspaceId, objectSchemaId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/role/objectschema/${objectSchemaId}`;
const $f1cc21ab7fa8ef1a$export$6583ed007df50d2b = (workspaceId, objectTypeId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/role/objecttype/${objectTypeId}`;
const $f1cc21ab7fa8ef1a$export$a635e2e9382b1621 = (workspaceId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/perms/principal`;
const $f1cc21ab7fa8ef1a$export$b3cb4590859563b0 = (workspaceId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/perms/role-assignment`;
const $f1cc21ab7fa8ef1a$export$8ae00db5fd7218c5 = (workspaceId, token)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/perms/token-status?token=${token}`;
const $f1cc21ab7fa8ef1a$export$794aa3ae46133f30 = (workspaceId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/perms/my-roles`;

});


parcelRegister("5ZX4K", function(module, exports) {
$parcel$export(module.exports, "createStatusType", () => $7da8ce52c326ce62$export$8c874b16a69a1b9d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $aJ81Y = parcelRequire("aJ81Y");
const $7da8ce52c326ce62$export$8c874b16a69a1b9d = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                createLoading: true
            }
        });
        try {
            const response = await (0, $eh7eP.performCmdbPostRequest)((0, $el2ZZ.getCmdbConfigStatusTypeUrl)(workspaceId), {
                body: JSON.stringify(data)
            });
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    createLoading: false,
                    data: [
                        ...state.statusTypes.data ?? [],
                        response
                    ]
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({
                source: 'insightGlobalConfigStatuses',
                action: 'created',
                actionSubject: 'insightGlobalConfigStatuses'
            }), 'insightGlobalConfigStatuses created');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    createLoading: false,
                    createError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'createStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("9Uk9U", function(module, exports) {
$parcel$export(module.exports, "deleteIcon", () => $608629803746b3de$export$12d45ee5c2161b75);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $dBNCB = parcelRequire("dBNCB");

var $aJ81Y = parcelRequire("aJ81Y");
const $608629803746b3de$export$12d45ee5c2161b75 = (icon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                deleteLoading: true
            }
        });
        try {
            await (0, $eh7eP.performCmdbDeleteRequest)((0, $dBNCB.getCmdbIconByIdUrl)(workspaceId, icon.id));
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    deleteLoading: false,
                    data: state.icons.data ? state.icons.data.filter(({ id: id })=>id !== icon.id) : undefined
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteIcon succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("8KJoS", function(module, exports) {
$parcel$export(module.exports, "deleteReferenceType", () => $7caa42a59cb3cde1$export$432ee1f3819316e5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $aJ81Y = parcelRequire("aJ81Y");
const $7caa42a59cb3cde1$export$432ee1f3819316e5 = (referenceType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                deleteLoading: true
            }
        });
        try {
            await (0, $eh7eP.performCmdbDeleteRequest)((0, $el2ZZ.getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceType.id));
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    deleteLoading: false,
                    data: state.referenceTypes.data ? state.referenceTypes.data.filter(({ id: id })=>id !== referenceType.id) : undefined
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteReferenceType succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("7EbKM", function(module, exports) {
$parcel$export(module.exports, "deleteStatusType", () => $8b47e104d456bfa0$export$812423dc05f0fc3d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $aJ81Y = parcelRequire("aJ81Y");
const $8b47e104d456bfa0$export$812423dc05f0fc3d = (statusType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                deleteLoading: true
            }
        });
        try {
            await (0, $eh7eP.performCmdbDeleteRequest)((0, $el2ZZ.getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusType.id));
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    deleteLoading: false,
                    data: state.statusTypes.data ? state.statusTypes.data.filter(({ id: id })=>id !== statusType.id) : undefined
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteStatusType succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("lOemx", function(module, exports) {
$parcel$export(module.exports, "fetchIsDataManagerAvailable", () => $044f979474fc0c99$export$970c77d493672caa);

var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $zijvz = parcelRequire("zijvz");
const $044f979474fc0c99$export$970c77d493672caa = ()=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId })=>{
        const { dataManager: dataManager } = getState();
        if (dataManager.isDataManagerAvailableLoading || dataManager.isDataManagerAvailable !== undefined) return;
        setState({
            dataManager: {
                ...dataManager,
                isDataManagerAvailableLoading: true
            }
        });
        try {
            const { isSuccessful: isSuccessful } = await (0, $eh7eP.performCmdbGetRequest)((0, $zijvz.getDataManagerAccessibleSitesUrl)(workspaceId));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    isDataManagerAvailable: isSuccessful ?? false,
                    isDataManagerAvailableLoading: false
                }
            });
        } catch (error) {
            const normalizedError = error instanceof Error ? error : new Error(String(error));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    isDataManagerAvailable: false,
                    isDataManagerAvailableLoading: false
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchIsDataManagerAvailable',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: normalizedError
            });
        }
    };

});
parcelRegister("zijvz", function(module, exports) {
$parcel$export(module.exports, "getDataManagerGenerateContainerTokenUrl", () => $ab714630f0b39e95$export$5f42b4e80a66d7c);
$parcel$export(module.exports, "postDataManagerGenerateContainerTokenUrl", () => $ab714630f0b39e95$export$94451efd014960cd);
$parcel$export(module.exports, "delDataManagerContainerTokenUrl", () => $ab714630f0b39e95$export$ddc5a4cb751fae27);
$parcel$export(module.exports, "getDataManagerFetchContainerTokenUrl", () => $ab714630f0b39e95$export$591d877d695dbd95);
$parcel$export(module.exports, "getDataManagerProvisioningStatusUrl", () => $ab714630f0b39e95$export$1dd01c50c7948938);
$parcel$export(module.exports, "getDataManagerUserSearchUrl", () => $ab714630f0b39e95$export$25e2455e614ca5ce);
$parcel$export(module.exports, "getDataManagerRoleAssignmentUrl", () => $ab714630f0b39e95$export$168c36972b6ab523);
$parcel$export(module.exports, "getDataManagerPrincipalUrl", () => $ab714630f0b39e95$export$57226120ddd0a4e1);
$parcel$export(module.exports, "getDataManagerAccessibleSitesUrl", () => $ab714630f0b39e95$export$92002c1b11a7692a);

var $iGhBm = parcelRequire("iGhBm");
const $ab714630f0b39e95$export$5f42b4e80a66d7c = (workspaceId, label, type, duration)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${type}?label=${label}&duration=${duration}`;
const $ab714630f0b39e95$export$94451efd014960cd = (workspaceId, type)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${type}`;
const $ab714630f0b39e95$export$ddc5a4cb751fae27 = (workspaceId, tokenID)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${tokenID}`;
const $ab714630f0b39e95$export$591d877d695dbd95 = (workspaceId)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token`;
const $ab714630f0b39e95$export$1dd01c50c7948938 = (workspaceId)=>`${$ab714630f0b39e95$var$getAirtrackAppRestBaseUrl(workspaceId)}/config/sync/provisioningstatus`;
// Common function to build the data manager URL
const $ab714630f0b39e95$var$toDataManagerBaseUrl = (workspaceId, path)=>`${$ab714630f0b39e95$var$getAirtrackAppRestBaseUrl(workspaceId)}/${path}`;
const $ab714630f0b39e95$export$25e2455e614ca5ce = (workspaceId)=>$ab714630f0b39e95$var$toDataManagerBaseUrl(workspaceId, 'config/permission/data-manager-users');
const $ab714630f0b39e95$export$168c36972b6ab523 = (workspaceId)=>$ab714630f0b39e95$var$toDataManagerBaseUrl(workspaceId, 'config/permission/role-assignment');
const $ab714630f0b39e95$export$57226120ddd0a4e1 = (workspaceId)=>$ab714630f0b39e95$var$toDataManagerBaseUrl(workspaceId, 'config/permission/principal');
const $ab714630f0b39e95$export$92002c1b11a7692a = (workspaceId)=>$ab714630f0b39e95$var$toDataManagerBaseUrl(workspaceId, 'config/workspace/AccessibleSites');
const $ab714630f0b39e95$var$getAirtrackAppRestBaseUrl = (workspaceId)=>`/gateway/api/jsm/data-manager/workspace/${workspaceId}/app`;

});


parcelRegister("hacul", function(module, exports) {
$parcel$export(module.exports, "fetchGlobalConfig", () => $3e66823e4dca5e48$export$14c75ba3f0e48e21);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $jlg5B = parcelRequire("jlg5B");

var $aJ81Y = parcelRequire("aJ81Y");
const $3e66823e4dca5e48$export$14c75ba3f0e48e21 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().loading || !shouldRefetch && getState().config) return;
        setState({
            loading: true,
            error: undefined
        });
        try {
            const response = await (0, $eh7eP.performCmdbGetRequest)((0, $jlg5B.getCmdbGlobalConfigUrl)(workspaceId));
            const iconListWithServiceOTEntriesRemoved = response ? response.icons.filter((item)=>item.name !== 'Applications' && item.name !== 'Business Services' && item.name !== 'Capabilities' && item.name !== 'Software Services') : undefined;
            setState({
                ...getState(),
                loading: false,
                config: {
                    ...response,
                    restrictedObjectSchemaIds: response?.restrictedObjectSchemaIds ?? [],
                    icons: iconListWithServiceOTEntriesRemoved || []
                },
                referenceTypes: {
                    ...getState().referenceTypes,
                    data: response ? response.referenceTypes : undefined
                },
                statusTypes: {
                    ...getState().statusTypes,
                    data: response ? response.statusTypes : undefined
                },
                icons: {
                    ...getState().icons,
                    data: iconListWithServiceOTEntriesRemoved
                },
                dataManager: {
                    ...getState().dataManager
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchInsightGlobalConfig succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchInsightGlobalConfig',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("jlg5B", function(module, exports) {
$parcel$export(module.exports, "getCmdbGlobalConfigUrl", () => $d1df4cccb5d78e67$export$50437136a9a5e2d3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectUrl", () => $d1df4cccb5d78e67$export$73e58b72a1074528);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdUrl", () => $d1df4cccb5d78e67$export$e2019224257efde3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdPropertyUrl", () => $d1df4cccb5d78e67$export$d1b25f8feb06db8a);
/* eslint-disable jira/filename-case */ 
var $bS1iz = parcelRequire("bS1iz");

var $iGhBm = parcelRequire("iGhBm");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/global
 */ const $d1df4cccb5d78e67$var$getCmdbGlobalUrl = (workspaceId)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/global`;
const $d1df4cccb5d78e67$export$50437136a9a5e2d3 = (workspaceId)=>`${$d1df4cccb5d78e67$var$getCmdbGlobalUrl(workspaceId)}/config`;
const $d1df4cccb5d78e67$export$73e58b72a1074528 = (workspaceId, queryParams)=>`${$d1df4cccb5d78e67$var$getCmdbGlobalUrl(workspaceId)}/config/object?${(0, $bS1iz.stringify)(queryParams)}`;
const $d1df4cccb5d78e67$export$e2019224257efde3 = (workspaceId, objectSchemaId)=>`${$d1df4cccb5d78e67$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}`;
const $d1df4cccb5d78e67$export$d1b25f8feb06db8a = (workspaceId, objectSchemaId)=>`${$d1df4cccb5d78e67$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}/property`;

});


parcelRegister("4giZE", function(module, exports) {
$parcel$export(module.exports, "fetchMyDataManagerRoles", () => $1751e6c0dd362ee1$export$2211f294ebd95b92);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $aJ81Y = parcelRequire("aJ81Y");
const $1751e6c0dd362ee1$export$2211f294ebd95b92 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().dataManager.myRolesLoading || !shouldRefetch && getState().dataManager.myRoles) return;
        setState({
            dataManager: {
                ...getState().dataManager,
                myRolesLoading: true,
                myRolesError: undefined
            }
        });
        try {
            const myRoles = await (0, $eh7eP.performCmdbGetRequest)((0, $el2ZZ.getMyDataManagerRolesUrl)(workspaceId));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    myRoles: myRoles.results,
                    myRolesLoading: false
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchMyDataManagerRoles succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                dataManager: {
                    ...getState().dataManager,
                    myRolesLoading: false,
                    myRolesError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchMyDataManagerRoles',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("aH3eH", function(module, exports) {
$parcel$export(module.exports, "fetchPrincipalsForRoles", () => $b498242f6df33734$export$9c5110cfdcb72b5);

var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $zijvz = parcelRequire("zijvz");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
const $b498242f6df33734$export$9c5110cfdcb72b5 = (roleIds)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.rolesLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                rolesLoading: true
            }
        });
        try {
            const requestBody = {
                roleIds: roleIds,
                resourceId: `ari:cloud:cmdb::workspace/${workspaceId}`
            };
            const principalIdsForRoles = await (0, $eh7eP.performCmdbPostRequest)((0, $i860n.fg)('data-manager-units-onboarding') ? (0, $zijvz.getDataManagerPrincipalUrl)(workspaceId) : (0, $el2ZZ.getCmdbPermsPrincipalUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            setState({
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    rolesData: principalIdsForRoles.results,
                    rolesLoading: false
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchPrincipalsForRoles succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    rolesLoading: false,
                    rolesError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchPrincipalsForRoles',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("jMWz2", function(module, exports) {
$parcel$export(module.exports, "fetchProvisioningStatus", () => $4ab3d425a5f952fe$export$aa3ea988cce42be1);

var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $zijvz = parcelRequire("zijvz");

var $aJ81Y = parcelRequire("aJ81Y");
const $4ab3d425a5f952fe$export$aa3ea988cce42be1 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().dataManager.provisioningLoading || !shouldRefetch && // isProvisioned is a boolean so needs to specifically check undefined
        getState().dataManager.isProvisioned !== undefined) return;
        setState({
            dataManager: {
                ...getState().dataManager,
                provisioningLoading: true,
                provisioningError: undefined
            }
        });
        try {
            const result = await (0, $eh7eP.performCmdbGetRequest)((0, $zijvz.getDataManagerProvisioningStatusUrl)(workspaceId));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    isProvisioned: $4ab3d425a5f952fe$var$isProvisioned(result.enabled),
                    provisioningLoading: false
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchProvisioningStatus succeeded');
        } catch (error) {
            const normalizedError = error instanceof Error ? error : new Error(String(error));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    provisioningLoading: false,
                    provisioningError: normalizedError
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchProvisioningStatus',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: normalizedError
            });
            throw error;
        }
    };
const $4ab3d425a5f952fe$var$isProvisioned = (status)=>status === 'ON';

});

parcelRegister("1oJL8", function(module, exports) {
$parcel$export(module.exports, "fetchDataManagerTokens", () => $0d7ed8a71ea845aa$export$c6b3de84befa4259);

var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $zijvz = parcelRequire("zijvz");

var $aJ81Y = parcelRequire("aJ81Y");
const $0d7ed8a71ea845aa$export$c6b3de84befa4259 = ()=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.tokensLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                tokensLoading: true
            }
        });
        try {
            const tokenDetails = await (0, $eh7eP.performCmdbGetRequest)((0, $zijvz.getDataManagerFetchContainerTokenUrl)(workspaceId));
            setState({
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    tokensData: tokenDetails.tokens,
                    tokensLoading: false
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchDataManagerTokens succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    tokensLoading: false,
                    tokensError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchDataManagerTokens',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("iRdQ0", function(module, exports) {
$parcel$export(module.exports, "fetchCdm", () => $3a4b9bb1e559e1e7$export$dc14adeb4c2a88f9);

var $eh7eP = parcelRequire("eh7eP");

var $iGhBm = parcelRequire("iGhBm");

var $7cA7G = parcelRequire("7cA7G");

var $i860n = parcelRequire("i860n");
const $3a4b9bb1e559e1e7$var$getFetchCdmInstantiationsUrl = (workspaceId, type)=>{
    const base = (0, $iGhBm.getCmdbRestBaseUrl)(workspaceId);
    return `${base}/bundle/instantiated?type=${type}`;
};
const $3a4b9bb1e559e1e7$export$dc14adeb4c2a88f9 = ()=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId })=>{
        // First reset state to undefined to indicate loading
        const initialState = getState();
        setState({
            ...initialState,
            cdm: {
                ...initialState.cdm,
                instantiations: undefined
            }
        });
        let instantiationsResponse;
        try {
            const bundleType = (0, $i860n.fg)('assets_tempeh_update_cdm_to_foundations') ? 'foundations' : 'cdm';
            const apiResponse = await (0, $eh7eP.performCmdbGetRequest)($3a4b9bb1e559e1e7$var$getFetchCdmInstantiationsUrl(workspaceId, bundleType));
            instantiationsResponse = apiResponse?.instantiations || [];
        } catch (error) {
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                error: error instanceof Error ? error : new Error('Unknown error'),
                meta: {
                    id: 'fetchInstantiations',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                }
            });
            // TODO(KKT-103) : handle error scenario by surfacing it to the user or retrying
            instantiationsResponse = [];
        }
        const state = getState();
        setState({
            ...state,
            cdm: {
                ...state.cdm,
                instantiations: instantiationsResponse
            }
        });
    };

});

parcelRegister("6rM2B", function(module, exports) {
$parcel$export(module.exports, "installCdm", () => $3b6ff4cb3c212dc8$export$2f65091e2af212f7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $3b6ff4cb3c212dc8$export$2f65091e2af212f7 = ()=>async ({ setState: setState, getState: getState })=>{
        // TODO: Implement the actual CDM instantiation logic here
        // submitAsyncCdmBundleInstantiationTask
        // useCmdbAsyncBundleInstantiation
        const state = getState();
        // Fake CDM instantiation task
        setState({
            ...state,
            cdm: {
                ...state.cdm,
                tasks: [
                    ...state.cdm.tasks,
                    'instantiateBundle'
                ]
            }
        });
        // Wait 2 seconds
        await new Promise((resolve)=>setTimeout(resolve, 2000));
        // Remove the task and add mock instantiation
        setState({
            ...getState(),
            cdm: {
                instantiations: [
                    {
                        instantiationId: 'test-instantiation-id',
                        bundleId: 'test-bundle-id',
                        schemas: []
                    }
                ],
                tasks: []
            }
        });
    };

});

parcelRegister("81SnW", function(module, exports) {
$parcel$export(module.exports, "updateDataManagerRole", () => $780e5841772ce038$export$314337b594e79a51);

var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $zijvz = parcelRequire("zijvz");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
const $780e5841772ce038$export$93aad6482f82f57d = 5000;
const $780e5841772ce038$export$214f23982cabf5f8 = 1000;
const $780e5841772ce038$export$314337b594e79a51 = ({ principalIds: principalIds, roleId: roleId, useUnitsEndpoint: useUnitsEndpoint })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.rolesUpdateLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                rolesUpdateLoading: true
            }
        });
        try {
            const requestBody = {
                principalIds: principalIds,
                roleId: roleId,
                resourceType: 'workspace'
            };
            const updateRolesResponse = await (0, $eh7eP.performCmdbPutRequest)(useUnitsEndpoint && (0, $i860n.fg)('data-manager-units-onboarding') ? (0, $zijvz.getDataManagerRoleAssignmentUrl)(workspaceId) : (0, $el2ZZ.getCmdbPermsRoleAssignmentUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            const pollTimeoutTime = new Date(Date.now() + $780e5841772ce038$export$93aad6482f82f57d).getTime();
            // poll the checking of the token status for 5 seconds as updating of
            // Identity role assignments have eventually consistency
            const tryPollTokenStatus = async (resolve, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            reject)=>{
                if (Date.now() > pollTimeoutTime) {
                    reject(new Error('Some role assignments have failed or is still in progress'));
                    return;
                }
                try {
                    const url = (0, $el2ZZ.getCmdbPermsTokenStatusUrl)(workspaceId, updateRolesResponse.tokens[updateRolesResponse.tokens.length - 1]);
                    const updateRoleAssignmentToken = await (0, $eh7eP.performCmdbGetRequest)(url);
                    if (updateRoleAssignmentToken.isSuccessful) {
                        resolve();
                        return;
                    }
                    setTimeout(()=>{
                        tryPollTokenStatus(resolve, reject);
                    }, $780e5841772ce038$export$214f23982cabf5f8);
                // oxlint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    // Ignore unexpected network/server error and quickly retry
                    setTimeout(()=>{
                        tryPollTokenStatus(resolve, reject);
                    }, $780e5841772ce038$export$214f23982cabf5f8);
                }
            };
            // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            await new Promise((res, rej)=>tryPollTokenStatus(res, rej));
            setState({
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    rolesUpdateLoading: false
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateDataManagerRole succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    rolesUpdateLoading: false,
                    rolesUpdateError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateDataManagerRole',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'data-manager'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("iRSmJ", function(module, exports) {
$parcel$export(module.exports, "setIcon", () => $35c9a4a5999bdbf5$export$33914de34c28be6c);
$parcel$export(module.exports, "updateIcon", () => $35c9a4a5999bdbf5$export$89ea7ff652eb14dd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $dBNCB = parcelRequire("dBNCB");

var $aJ81Y = parcelRequire("aJ81Y");
const $35c9a4a5999bdbf5$export$33914de34c28be6c = (updatedIcon)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.icons.data?.map((icon)=>icon.id === updatedIcon.id ? updatedIcon : icon);
        setState({
            ...state,
            icons: {
                ...state.icons,
                data: updatedData
            }
        });
    };
const $35c9a4a5999bdbf5$export$89ea7ff652eb14dd = ({ iconId: iconId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $eh7eP.performCmdbPutRequest)((0, $dBNCB.getCmdbIconByIdUrl)(workspaceId, iconId), {
                body: JSON.stringify(updatedProperties)
            });
            const updatedState = getState();
            const updatedData = updatedState.icons.data?.map((icon)=>icon.id === response.id ? response : icon);
            setState({
                ...updatedState,
                icons: {
                    ...updatedState.icons,
                    updateLoading: false,
                    data: updatedData
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateIcon succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                icons: {
                    ...updatedState.icons,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("8AE9F", function(module, exports) {
$parcel$export(module.exports, "updateProvisioningStatus", () => $4e2d9a78df80e130$export$ae3c5292a85a06f4);

var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $zijvz = parcelRequire("zijvz");

var $aJ81Y = parcelRequire("aJ81Y");
const $4e2d9a78df80e130$export$ae3c5292a85a06f4 = ({ isEnabled: isEnabled })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.provisioningUpdateLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                isProvisioned: isEnabled,
                provisioningUpdateLoading: true
            }
        });
        try {
            const requestBody = {
                enabled: isEnabled
            };
            await (0, $eh7eP.performCmdbPutRequest)((0, $zijvz.getDataManagerProvisioningStatusUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            const result = await (0, $eh7eP.performCmdbGetRequest)((0, $zijvz.getDataManagerProvisioningStatusUrl)(workspaceId));
            setState({
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    isProvisioned: result.enabled === 'ON',
                    provisioningUpdateLoading: false
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateProvisioningStatus succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    provisioningUpdateLoading: false,
                    provisioningUpdateError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateProvisioningStatus',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("gykY5", function(module, exports) {
$parcel$export(module.exports, "setReferenceType", () => $da190aeff67d4661$export$7c6efce0302318d);
$parcel$export(module.exports, "updateReferenceType", () => $da190aeff67d4661$export$f9e29a0f21a33136);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
const $da190aeff67d4661$export$7c6efce0302318d = (updatedReferenceType)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.referenceTypes.data?.map((referenceType)=>referenceType.id === updatedReferenceType.id ? updatedReferenceType : referenceType);
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                data: updatedData
            }
        });
    };
const $da190aeff67d4661$export$f9e29a0f21a33136 = ({ referenceTypeId: referenceTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $eh7eP.performCmdbPutRequest)((0, $el2ZZ.getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceTypeId), {
                body: JSON.stringify({
                    ...updatedProperties,
                    color: updatedProperties.color !== undefined ? updatedProperties.color.replace('#', '') : undefined
                })
            });
            const updatedState = getState();
            let merged = response;
            if ((0, $i860n.fg)('cdm_display_name')) {
                const displayNameMerged = response.displayName !== undefined && response.displayName !== null ? response.displayName : updatedProperties.displayName;
                merged = {
                    ...response,
                    ...displayNameMerged !== undefined ? {
                        displayName: displayNameMerged
                    } : {}
                };
            }
            const updatedData = updatedState.referenceTypes.data?.map((referenceType)=>referenceType.id === response.id ? merged : referenceType);
            setState({
                ...updatedState,
                referenceTypes: {
                    ...updatedState.referenceTypes,
                    updateLoading: false,
                    data: updatedData || undefined
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateReferenceType succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                referenceTypes: {
                    ...updatedState.referenceTypes,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("ghOtU", function(module, exports) {
$parcel$export(module.exports, "setStatusType", () => $d9f182d5741839d5$export$80a24939e43be67c);
$parcel$export(module.exports, "updateStatusType", () => $d9f182d5741839d5$export$2174575c3f57e8f8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
const $d9f182d5741839d5$export$80a24939e43be67c = (updatedStatusType)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.statusTypes.data?.map((statusType)=>statusType.id === updatedStatusType.id ? updatedStatusType : statusType);
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                data: updatedData
            }
        });
    };
const $d9f182d5741839d5$export$2174575c3f57e8f8 = ({ statusTypeId: statusTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $eh7eP.performCmdbPutRequest)((0, $el2ZZ.getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusTypeId), {
                body: JSON.stringify(updatedProperties)
            });
            const updatedState = getState();
            let merged = response;
            if ((0, $i860n.fg)('cdm_display_name')) {
                const displayNameMerged = response.displayName !== undefined ? response.displayName : updatedProperties.displayName;
                merged = {
                    ...response,
                    ...displayNameMerged !== undefined ? {
                        displayName: displayNameMerged
                    } : {}
                };
            }
            const updatedData = updatedState.statusTypes.data?.map((statusType)=>statusType.id === response.id ? merged : statusType);
            setState({
                ...updatedState,
                statusTypes: {
                    ...updatedState.statusTypes,
                    updateLoading: false,
                    data: updatedData || undefined
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateStatusType succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                statusTypes: {
                    ...updatedState.statusTypes,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});


parcelRegister("71cdE", function(module, exports) {
$parcel$export(module.exports, "sortReferenceTypes", () => $8cf7bcb29c5a976b$export$7e55dd84e7cc0829);
$parcel$export(module.exports, "sortStatusTypes", () => $8cf7bcb29c5a976b$export$5f25bb3183b5823d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $8cf7bcb29c5a976b$export$7e55dd84e7cc0829 = (referenceTypes)=>referenceTypes.sort((a, b)=>a.name.localeCompare(b.name)).sort((a, b)=>{
        if (a.removable === b.removable) return 0;
        return a.removable ? 1 : -1;
    });
const $8cf7bcb29c5a976b$export$5f25bb3183b5823d = (statusTypes)=>statusTypes.sort((a, b)=>a.name.localeCompare(b.name));

});


parcelRegister("j65JU", function(module, exports) {
$parcel$export(module.exports, "useWorkspaceContext", () => $6945d6c9597f67b3$export$827d903316fc333c);
$parcel$export(module.exports, "useInsightVisibility", () => $6945d6c9597f67b3$export$74ebc9a49f60d38a);

var $euxye = parcelRequire("euxye");

var $eBpdw = parcelRequire("eBpdw");

var $zbgUa = parcelRequire("zbgUa");

var $k6ufm = parcelRequire("k6ufm");

var $bOYO0 = parcelRequire("bOYO0");

var $8ycTI = parcelRequire("8ycTI");
const $6945d6c9597f67b3$export$a0002067fa97246a = '/rest/servicedesk/cmdb/latest/workspace';
const $6945d6c9597f67b3$export$122fccf0bbbc9acc = 30000;
const $6945d6c9597f67b3$export$827d903316fc333c = ()=>{
    const { data: data, loading: loading, error: error, refresh: fetchWorkspaceId } = (0, $k6ufm.useResource)((0, $8ycTI.workspaceResource));
    const workspaceId = data ?? undefined;
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null | undefined'.
        error,
        workspaceId: workspaceId,
        fetchWorkspaceId: fetchWorkspaceId
    };
};
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
const $6945d6c9597f67b3$var$useInterval = (callback, delay)=>{
    const savedCallback = (0, $euxye.useRef)(callback);
    // Remember the latest callback.
    (0, $euxye.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, $euxye.useEffect)(()=>{
        const tick = ()=>{
            savedCallback.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
        return undefined;
    }, [
        delay
    ]);
};
const $6945d6c9597f67b3$export$74ebc9a49f60d38a = ()=>{
    const tenantContext = (0, $zbgUa.useAssetsTenantContext)();
    const { workspaceId: workspaceId, fetchWorkspaceId: fetchWorkspaceId, loading: loading } = $6945d6c9597f67b3$export$827d903316fc333c();
    // Optimistically set this true if user is premium and CMDB is enabled in environment - which will prevent a flash for the majority of users
    const [isVisible, setIsVisible] = (0, $euxye.useState)((0, $eBpdw.isCMDBEnabledInEnvironment)() && (0, $bOYO0.isAssetsUser)(tenantContext));
    const [shouldPollForWorkspaceId, setShouldPollForWorkspaceId] = (0, $euxye.useState)(false);
    const [hasFetchedWorkspaceId, setHasFetchedWorkspaceId] = (0, $euxye.useState)(false);
    // Can't test this component without a rerender on each poll — so am just increment a counter with each poll
    const [, setPollCount] = (0, $euxye.useState)(0);
    // Run an initial fetch of the workspaceId if the resource wasn't already fetched as
    // part of the route definition (like for the Insight menu in the global nav)
    (0, $euxye.useEffect)(()=>{
        if (!hasFetchedWorkspaceId && !workspaceId && (0, $bOYO0.isAssetsUser)(tenantContext) && (0, $eBpdw.isCMDBEnabledInEnvironment)()) {
            fetchWorkspaceId();
            setHasFetchedWorkspaceId(true);
        }
    }, [
        fetchWorkspaceId,
        hasFetchedWorkspaceId,
        tenantContext,
        workspaceId
    ]);
    // Starts/stops the polling of workspaceId
    $6945d6c9597f67b3$var$useInterval(()=>{
        fetchWorkspaceId();
        setPollCount((a)=>a + 1);
    }, shouldPollForWorkspaceId ? $6945d6c9597f67b3$export$122fccf0bbbc9acc : null);
    // Main check to see if insight should be visible
    // If user has premium subscription but no workspace ID, we begin polling for the
    // workspace ID as it means their Insight instance hasn’t completed provisioning yet
    (0, $euxye.useEffect)(()=>{
        if ((hasFetchedWorkspaceId || workspaceId) && !loading) {
            if ((0, $bOYO0.isAssetsUser)(tenantContext)) {
                if (workspaceId !== undefined) {
                    setIsVisible(true);
                    setShouldPollForWorkspaceId(false);
                } else {
                    setIsVisible(false);
                    setShouldPollForWorkspaceId(true);
                }
            } else {
                setIsVisible(false);
                setShouldPollForWorkspaceId(false);
            }
        }
    }, [
        tenantContext,
        workspaceId,
        loading,
        hasFetchedWorkspaceId
    ]);
    return isVisible;
};

});
parcelRegister("zbgUa", function(module, exports) {
$parcel$export(module.exports, "useAssetsTenantContext", () => $23aaf6244856386e$export$62e5cc6bee801405);
$parcel$export(module.exports, "useAssetsIsAdmin", () => $23aaf6244856386e$export$b9c4a86cf61f47ec);
$parcel$export(module.exports, "useAssetsIsSiteAdmin", () => $23aaf6244856386e$export$915edea0d2f62b4f);


var $7nWmb = parcelRequire("7nWmb");

var $eijVy = parcelRequire("eijVy");

var $i860n = parcelRequire("i860n");
const $23aaf6244856386e$export$62e5cc6bee801405 = ()=>{
    const [{ tenantContext: tenantContext }] = (0, $eijVy.useTenantContextHook)();
    const { isAssetsAdmin: isAssetsAdmin, isLicensedAssetsUser: isLicensedAssetsUser } = (0, $7nWmb.useAssetsUserPermission)();
    const hasAssetsEntitlement = tenantContext.licensedProducts && tenantContext.licensedProducts[0, $eb8cfa569eede1a9$export$a310f85340477585];
    // Override admin permissions with Assets-specific role when feature gate is enabled.
    // Assets-entitled sites use the kill-switch roles; Units secondary sites have no
    // local Assets entitlement but still resolve roles via the Assets permission API.
    if (hasAssetsEntitlement && (0, $i860n.fg)('aurum-997-license-kill-switch') || (0, $i860n.fg)('assets_access_workspace_source_of_truth')) return {
        ...tenantContext,
        isAdmin: !!isAssetsAdmin,
        isSiteAdmin: !!isAssetsAdmin,
        isLicensedAssetsUser: !!isLicensedAssetsUser
    };
    return tenantContext;
};
const $23aaf6244856386e$export$b9c4a86cf61f47ec = ()=>{
    const tenantContext = $23aaf6244856386e$export$62e5cc6bee801405();
    return tenantContext?.isAdmin ?? false;
};
const $23aaf6244856386e$export$915edea0d2f62b4f = ()=>{
    const tenantContext = $23aaf6244856386e$export$62e5cc6bee801405();
    return tenantContext?.isSiteAdmin ?? false;
};

});
/* eslint-disable jira/filename-case */ const $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $eb8cfa569eede1a9$export$e9c56aa3b027d98f = 'jira-customer-service';
const $eb8cfa569eede1a9$export$1346c9aa3cbb477d = 'jira-software';
const $eb8cfa569eede1a9$export$202f50ee62667e32 = 'jira-product-discovery';
const $eb8cfa569eede1a9$export$db515c8cec1e6f79 = 'jira-core';
const $eb8cfa569eede1a9$export$c811f21c9ad05dc2 = 'confluence';
const $eb8cfa569eede1a9$export$961148c98d198270 = 'opsgenie';
const $eb8cfa569eede1a9$export$a310f85340477585 = 'assets';
const $eb8cfa569eede1a9$export$d5e9b613bc4c47f = 'compass';

parcelRegister("7nWmb", function(module, exports) {
$parcel$export(module.exports, "assetsUserPermissionResource", () => $2e3564d96d02c4f6$export$c773b906583a11f4);
$parcel$export(module.exports, "useAssetsUserPermission", () => $2e3564d96d02c4f6$export$746e02f061868249);
$parcel$export(module.exports, "useAssetsUserPermissionLoading", () => $2e3564d96d02c4f6$export$45bd1b73ae7f62de);

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $i860n = parcelRequire("i860n");

var $fC6rO = parcelRequire("fC6rO");

var $5xxvQ = parcelRequire("5xxvQ");
const $2e3564d96d02c4f6$export$c773b906583a11f4 = (0, $7edbf.createResource)({
    type: (0, $fC6rO.RESOURCE_ASSETS_USER_PERMISSION),
    getKey: ()=>(0, $fC6rO.ASSETS_USER_PERMISSION_KEY),
    getData: async (_routerContext, customContext)=>{
        if (!(0, $i860n.fg)('aurum-997-license-kill-switch')) return 0, $fC6rO.emptyAssetsPermissionResponse;
        return (0, $5xxvQ.default)(customContext);
    },
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isCritical: true
});
const $2e3564d96d02c4f6$export$746e02f061868249 = ()=>{
    const { data: data } = (0, $k6ufm.useResource)($2e3564d96d02c4f6$export$c773b906583a11f4);
    return data ?? (0, $fC6rO.emptyAssetsPermissionResponse);
};
const $2e3564d96d02c4f6$export$45bd1b73ae7f62de = ()=>{
    const { loading: loading } = (0, $k6ufm.useResource)($2e3564d96d02c4f6$export$c773b906583a11f4);
    return loading ?? false;
};

});
parcelRegister("fC6rO", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_ASSETS_USER_PERMISSION", () => $7137f4db8ab03948$export$9cfbd747cbb4ae58);
$parcel$export(module.exports, "ASSETS_USER_PERMISSION_KEY", () => $7137f4db8ab03948$export$cd8f9faf718d106c);
$parcel$export(module.exports, "emptyAssetsPermissionResponse", () => $7137f4db8ab03948$export$e2a734575cf43186);
const $7137f4db8ab03948$export$9cfbd747cbb4ae58 = 'RESOURCE_ASSETS_USER_PERMISSION';
const $7137f4db8ab03948$export$cd8f9faf718d106c = 'ASSETS_USER_PERMISSION';
const $7137f4db8ab03948$export$e2a734575cf43186 = {
    isAssetsAdmin: false,
    isLicensedAssetsUser: false
};

});

parcelRegister("5xxvQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $58f392f39696d448$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $5csC1 = parcelRequire("5csC1");

var $6CfY5 = parcelRequire("6CfY5");

var $h2wCv = parcelRequire("h2wCv");

var $bYonX = parcelRequire("bYonX");

var $iixyn = parcelRequire("iixyn");

var $fC6rO = parcelRequire("fC6rO");
const $58f392f39696d448$var$packageName = 'jiraRouterResourcesAssetsUserPermission';
const $58f392f39696d448$var$teamName = 'astral';
const $58f392f39696d448$export$f449aa4e38ef0dc9 = async ({ tenantContext: tenantContext })=>{
    const { storeState: storeState } = (0, $bYonX.getResourceStore)();
    const state = storeState.getState();
    try {
        const workspaceId = await (0, $5csC1.extractResourceStatePromise)(state.data);
        if (!workspaceId || typeof workspaceId !== 'string') return 0, $fC6rO.emptyAssetsPermissionResponse;
        const { cloudId: cloudId } = tenantContext;
        const response = await (0, $h2wCv.performGetRequest)((0, $iixyn.getAssetsPermissionUrl)(workspaceId), {
            headers: (0, $iixyn.getAssetsPermissionHeaders)(workspaceId, cloudId)
        });
        return (0, $iixyn.transformAssetsPermissionResponse)(response, true);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const tenantContextMetadata = (0, $5csC1.getAssetsTenantContextMetadata)();
        (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$58f392f39696d448$var$packageName}.checkAssetsUserPermission`, error.message, {
            statusCode: error?.statusCode,
            errorName: error?.name,
            description: error?.originalResponse?.message,
            tenantContextMetadata: JSON.stringify(tenantContextMetadata || {})
        });
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'checkAssetsUserPermission',
                packageName: $58f392f39696d448$var$packageName,
                teamName: $58f392f39696d448$var$teamName
            },
            error: error
        });
        throw error;
    }
};
var $58f392f39696d448$export$2e2bcd8739ae039 = $58f392f39696d448$export$f449aa4e38ef0dc9;

});
parcelRegister("5csC1", function(module, exports) {
$parcel$export(module.exports, "extractResourceStatePromise", () => $e164ee73c9268a9a$export$5e6c0b0c6c71e3a7);
$parcel$export(module.exports, "mergeOptionsWithDefaults", () => $e164ee73c9268a9a$export$6f47ccd8898bd6b0);
$parcel$export(module.exports, "getAdminSettingsUrl", () => $e164ee73c9268a9a$export$13aeca3ca3499df1);
$parcel$export(module.exports, "getBannerSettingsUrl", () => $e164ee73c9268a9a$export$1e927bbb56fd29f2);
$parcel$export(module.exports, "getUserSettingsUrl", () => $e164ee73c9268a9a$export$8181cb1333632cf2);
$parcel$export(module.exports, "getLogoUrl", () => $e164ee73c9268a9a$export$976f80239b15365);
$parcel$export(module.exports, "getFaviconUrl", () => $e164ee73c9268a9a$export$179f5d628a6b9050);
$parcel$export(module.exports, "getAssetsAdminHeaders", () => $e164ee73c9268a9a$export$d59383f1577b7cb5);
$parcel$export(module.exports, "transformAdminSettingsResponse", () => $e164ee73c9268a9a$export$c8db903c3984d79e);
$parcel$export(module.exports, "transformBannerSettings", () => $e164ee73c9268a9a$export$5221f0c585bc0e45);
$parcel$export(module.exports, "getAssetsTenantContextMetadata", () => $e164ee73c9268a9a$export$bb50dff15b0d8612);
// eslint-disable-next-line jira/import-whitelist

var $6bEm8 = parcelRequire("6bEm8");

var $ff8AH = parcelRequire("ff8AH");

var $i860n = parcelRequire("i860n");

var $57UQ8 = parcelRequire("57UQ8");
const $e164ee73c9268a9a$export$5315eee73d0f8e = 'jsm-cmdb-gateway';
const $e164ee73c9268a9a$var$HEADER_X_SSR_SERVICE_NAME = 'x-ssr-service-name';
const $e164ee73c9268a9a$var$HEADER_ATL_WORKSPACEID = 'atl-workspaceid';
const $e164ee73c9268a9a$var$HEADER_X_SSR_ASAP_AUDIENCE = 'x-ssr-asap-audience';
const $e164ee73c9268a9a$var$HEADER_LINKED_ASSETS_WORKSPACE_ID = 'linked-assets-workspace-id';
// Single reference to server variable to minimize ratcheting count
const $e164ee73c9268a9a$var$isServer = false;
function $e164ee73c9268a9a$export$5e6c0b0c6c71e3a7(resourceState) {
    return resourceState?.[0, $57UQ8.RESOURCE_TYPE_WORKSPACE_CONTEXT]?.state?.promise;
}
const $e164ee73c9268a9a$export$6f47ccd8898bd6b0 = (url, options)=>{
    const defaultOptions = (0, $ff8AH.getDefaultOptions)(url);
    return {
        ...defaultOptions,
        ...options,
        headers: {
            ...defaultOptions.headers,
            ...options?.headers
        }
    };
};
const $e164ee73c9268a9a$export$13aeca3ca3499df1 = (workspaceId)=>{
    if ($e164ee73c9268a9a$var$isServer) return '/assets/api/v1/admin/settings';
    return `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/admin/settings`;
};
const $e164ee73c9268a9a$export$1e927bbb56fd29f2 = (workspaceId)=>{
    if ($e164ee73c9268a9a$var$isServer) return '/assets/api/v1/admin/banner-settings';
    return `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/admin/banner-settings`;
};
const $e164ee73c9268a9a$export$8181cb1333632cf2 = (workspaceId)=>{
    if ($e164ee73c9268a9a$var$isServer) return '/assets/api/v1/user/settings';
    return `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/user/settings`;
};
const $e164ee73c9268a9a$export$976f80239b15365 = (workspaceId)=>{
    if ($e164ee73c9268a9a$var$isServer) return '/assets/api/v1/assets-logo';
    return `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/assets-logo`;
};
const $e164ee73c9268a9a$export$179f5d628a6b9050 = (workspaceId)=>{
    if ($e164ee73c9268a9a$var$isServer) return '/assets/api/v1/admin/favicon';
    return `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/admin/favicon`;
};
const $e164ee73c9268a9a$export$d59383f1577b7cb5 = (workspaceId)=>{
    if ($e164ee73c9268a9a$var$isServer) return {
        [$e164ee73c9268a9a$var$HEADER_X_SSR_ASAP_AUDIENCE]: 'assets-tempeh-archetype',
        ...(0, $i860n.fg)('assets_tempeh_units_admin_primary_routing') ? {
            [$e164ee73c9268a9a$var$HEADER_LINKED_ASSETS_WORKSPACE_ID]: workspaceId
        } : {}
    };
    return {
        [$e164ee73c9268a9a$var$HEADER_X_SSR_SERVICE_NAME]: $e164ee73c9268a9a$export$5315eee73d0f8e,
        [$e164ee73c9268a9a$var$HEADER_ATL_WORKSPACEID]: workspaceId
    };
};
const $e164ee73c9268a9a$export$c8db903c3984d79e = (response)=>{
    return response.reduce((acc, setting)=>{
        acc[setting.key] = setting;
        return acc;
    }, {});
};
const $e164ee73c9268a9a$export$5221f0c585bc0e45 = (bannerSettings)=>{
    const { content: content, ...rest } = bannerSettings;
    const isContentString = content && typeof content === 'string';
    return {
        ...rest,
        content: isContentString ? JSON.parse(content) : JSON.stringify(content)
    };
};
const $e164ee73c9268a9a$export$bb50dff15b0d8612 = ()=>{
    try {
        const appPermissions = {
            hasSoftwareAccess: (0, $6bEm8.default)('ajs-has-jira-software') === 'true',
            hasServiceDeskAccess: (0, $6bEm8.default)('ajs-has-jira-service-desk') === 'true',
            hasCoreAccess: (0, $6bEm8.default)('ajs-has-jira-core') === 'true'
        };
        const licensedProducts = JSON.parse((0, $6bEm8.default)('ajs-licensed-products') || '{}');
        const appEditions = JSON.parse((0, $6bEm8.default)('ajs-product-editions') || '{}');
        return {
            appPermissions: appPermissions,
            licensedProducts: licensedProducts,
            appEditions: appEditions
        };
    } catch (error) {
        return {};
    }
};

});
parcelRegister("57UQ8", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_ASSETS_NAVIGATION_SETTINGS", () => $200d4a252ac4a668$export$858084c28938b25c);
$parcel$export(module.exports, "RESOURCE_ASSETS_NAVIGATION_SETTINGS_KEY", () => $200d4a252ac4a668$export$6c3a7ac5254a8135);
$parcel$export(module.exports, "RESOURCE_ASSETS_BANNER_SETTINGS", () => $200d4a252ac4a668$export$edf7b78eb8890aea);
$parcel$export(module.exports, "RESOURCE_ASSETS_BANNER_SETTINGS_KEY", () => $200d4a252ac4a668$export$9aedc6e738c8bf7f);
$parcel$export(module.exports, "RESOURCE_ASSETS_USER_SETTINGS", () => $200d4a252ac4a668$export$2954db1275a5f9fc);
$parcel$export(module.exports, "RESOURCE_ASSETS_USER_SETTINGS_KEY", () => $200d4a252ac4a668$export$25873f3f095f3e21);
$parcel$export(module.exports, "USER_SETTING_BANNER_DISMISSAL_KEY", () => $200d4a252ac4a668$export$c02653af996e853a);
$parcel$export(module.exports, "DEFAULT_HIGHLIGHT_COLOR", () => $200d4a252ac4a668$export$4b15acc9c405c4bd);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_COLOR", () => $200d4a252ac4a668$export$617cdcc6afaae4f7);
$parcel$export(module.exports, "NAVIGATION_SETTINGS_KEYS", () => $200d4a252ac4a668$export$8a78e43025de1286);
$parcel$export(module.exports, "DATE_TIME_SETTINGS_KEYS", () => $200d4a252ac4a668$export$ed0afda862e5b236);
$parcel$export(module.exports, "RESOURCE_TYPE_WORKSPACE_CONTEXT", () => $200d4a252ac4a668$export$3f183223d3598a56);
$parcel$export(module.exports, "ASSETS_ADMIN_SETTINGS_MAX_AGE", () => $200d4a252ac4a668$export$ce0c7383fedc84ce);
$parcel$export(module.exports, "emptyNavigationSettingsResponse", () => $200d4a252ac4a668$export$2175e487efc82f9);
$parcel$export(module.exports, "emptyBannerSettingsResponse", () => $200d4a252ac4a668$export$5b68b74d24ac7fdf);
$parcel$export(module.exports, "emptyUserSettingsResponse", () => $200d4a252ac4a668$export$a0651f3901a27441);
$parcel$export(module.exports, "RESOURCE_ASSETS_LOGO_FAVICON", () => $200d4a252ac4a668$export$ad7710b5c24d4d75);
$parcel$export(module.exports, "RESOURCE_ASSETS_LOGO_FAVICON_KEY", () => $200d4a252ac4a668$export$834ed0433343c2f8);
$parcel$export(module.exports, "emptyLogoResponse", () => $200d4a252ac4a668$export$566ad05831bc4e33);
$parcel$export(module.exports, "emptyFaviconResponse", () => $200d4a252ac4a668$export$e9d53d3287e3f0ba);
const $200d4a252ac4a668$export$858084c28938b25c = 'RESOURCE_ASSETS_NAVIGATION_SETTINGS';
const $200d4a252ac4a668$export$6c3a7ac5254a8135 = 'assets-navigation-settings';
const $200d4a252ac4a668$export$edf7b78eb8890aea = 'RESOURCE_ASSETS_BANNER_SETTINGS';
const $200d4a252ac4a668$export$9aedc6e738c8bf7f = 'assets-banner-settings';
const $200d4a252ac4a668$export$2954db1275a5f9fc = 'RESOURCE_ASSETS_USER_SETTINGS';
const $200d4a252ac4a668$export$25873f3f095f3e21 = 'assets-user-settings';
const $200d4a252ac4a668$export$c02653af996e853a = 'shouldShowBanner';
const $200d4a252ac4a668$export$4b15acc9c405c4bd = '#0052CC';
const $200d4a252ac4a668$export$617cdcc6afaae4f7 = '#FFFFFF';
const $200d4a252ac4a668$export$8a78e43025de1286 = {
    BG_COLOR: 'assets.navigation.bgcolour',
    HIGHLIGHT_COLOR: 'assets.navigation.highlightcolour',
    SITE_TITLE: 'assets.shouldShow.title'
};
const $200d4a252ac4a668$export$ed0afda862e5b236 = {
    TIMEZONE: 'assets.timezone'
};
const $200d4a252ac4a668$export$3f183223d3598a56 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $200d4a252ac4a668$export$ce0c7383fedc84ce = 3600000;
const $200d4a252ac4a668$export$2175e487efc82f9 = {
    backgroundColor: '',
    highlightColor: '',
    timezone: '',
    showSiteTitle: false,
    isDefaultBackground: true
};
const $200d4a252ac4a668$export$5b68b74d24ac7fdf = {
    id: '',
    content: {
        version: 1,
        type: 'doc',
        content: []
    },
    isDismissable: false,
    isEnabled: false,
    hashId: '',
    visibility: '',
    bgColor: ''
};
const $200d4a252ac4a668$export$a0651f3901a27441 = {};
const $200d4a252ac4a668$export$ad7710b5c24d4d75 = 'RESOURCE_ASSETS_LOGO_FAVICON';
const $200d4a252ac4a668$export$834ed0433343c2f8 = 'assets-logo-favicon';
const $200d4a252ac4a668$export$566ad05831bc4e33 = {
    workspaceId: '',
    logoUUID: '',
    logoFileName: '',
    isDefaultLogo: true,
    url16: '',
    url48: '',
    url72: '',
    url144: '',
    url288: ''
};
const $200d4a252ac4a668$export$e9d53d3287e3f0ba = {
    workspaceId: '',
    faviconUUID: '',
    faviconFileName: '',
    isDefaultFavicon: true,
    url16: '',
    url32: '',
    url48: '',
    url64: ''
};
const $200d4a252ac4a668$export$d57b6b390e78d90f = 'aurum';
const $200d4a252ac4a668$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesAssetsAdminSettings';

});


parcelRegister("iixyn", function(module, exports) {
$parcel$export(module.exports, "transformAssetsPermissionResponse", () => $f35e9b04e4df6ea9$export$d41639ea83979d03);
$parcel$export(module.exports, "getAssetsPermissionUrl", () => $f35e9b04e4df6ea9$export$f18fae06ad563eed);
$parcel$export(module.exports, "getAssetsPermissionHeaders", () => $f35e9b04e4df6ea9$export$1f4357abb80d67bb);

var $i860n = parcelRequire("i860n");
const $f35e9b04e4df6ea9$var$HEADER_X_SSR_SERVICE_NAME = 'x-ssr-service-name';
const $f35e9b04e4df6ea9$var$HEADER_ATL_WORKSPACEID = 'atl-workspaceid';
const $f35e9b04e4df6ea9$var$HEADER_X_SSR_ASAP_AUDIENCE = 'x-ssr-asap-audience';
const $f35e9b04e4df6ea9$var$HEADER_ATL_CLOUDID = 'atl-cloudid';
const $f35e9b04e4df6ea9$export$d41639ea83979d03 = (response, apiCallSuccess)=>{
    return {
        isAssetsAdmin: response.isAdmin,
        isLicensedAssetsUser: apiCallSuccess && response.hasAssetsAccess
    };
};
const $f35e9b04e4df6ea9$export$f18fae06ad563eed = (workspaceId)=>{
    // When on client, always use gateway URL
    if (!false) return `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/permissions/permitted`;
    // When on server, use hostname routing when new FG is enabled
    if ((0, $i860n.fg)('assets_permission_hostname_routing')) return '/assets/api/v1/permissions/permitted';
    // Default SSR fallback: use gateway internal route
    return '/internal/permissions/permitted';
};
const $f35e9b04e4df6ea9$export$1f4357abb80d67bb = (workspaceId, cloudId)=>{
    // When on client, always use gateway headers
    if (!false) return {
        [$f35e9b04e4df6ea9$var$HEADER_X_SSR_SERVICE_NAME]: 'jsm-cmdb-gateway',
        [$f35e9b04e4df6ea9$var$HEADER_ATL_WORKSPACEID]: workspaceId
    };
    // When on server, use hostname routing headers when new FG is enabled
    if ((0, $i860n.fg)('assets_permission_hostname_routing')) return {
        [$f35e9b04e4df6ea9$var$HEADER_X_SSR_ASAP_AUDIENCE]: 'assets-tempeh-archetype'
    };
    // Default SSR fallback: use gateway headers
    return {
        [$f35e9b04e4df6ea9$var$HEADER_ATL_CLOUDID]: cloudId,
        [$f35e9b04e4df6ea9$var$HEADER_X_SSR_SERVICE_NAME]: 'jsm-cmdb-gateway',
        [$f35e9b04e4df6ea9$var$HEADER_ATL_WORKSPACEID]: workspaceId
    };
};

});




parcelRegister("8ycTI", function(module, exports) {
$parcel$export(module.exports, "workspaceResource", () => $ccd5616b1e2a7c59$export$2f02c3f971168d17);

var $7edbf = parcelRequire("7edbf");

var $bOYO0 = parcelRequire("bOYO0");

const $ccd5616b1e2a7c59$export$2f02c3f971168d17 = (0, $7edbf.createResource)({
    type: (0, $356df43015490364$export$9b3a4d71d46e5ee7),
    getKey: ()=>(0, $356df43015490364$export$85f210522c337b0e),
    getData: async (_, routerContext)=>{
        const workspaceId = await (0, $bOYO0.default)(_, routerContext);
        return workspaceId;
    },
    maxAge: Infinity
});

});
/* eslint-disable jira/filename-case */ // Shared so workspaceResource (the resource definition) and fetchWorkspaceId (which reads the
// resolved value back out of the store) agree on the store type and key without importing each
// other — avoids the circular import that duplicated literals were previously working around.
const $356df43015490364$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $356df43015490364$export$85f210522c337b0e = 'state';



parcelRegister("1cHgD", function(module, exports) {
$parcel$export(module.exports, "AssetsMenu", () => $b43ae64680b98409$export$a578a9f5b9517a27);
$parcel$export(module.exports, "AssetsSingleMenuItem", () => $b43ae64680b98409$export$252d7ffe38b4e8ef);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $eiIY9 = parcelRequire("eiIY9");

var $1ntzc = parcelRequire("1ntzc");

var $1DL4e = parcelRequire("1DL4e");

var $bOwox = parcelRequire("bOwox");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $4VtOS = parcelRequire("4VtOS");

var $aQCoC = parcelRequire("aQCoC");

var $jzXAj = parcelRequire("jzXAj");

var $3rqDf = parcelRequire("3rqDf");

var $dx7aH = parcelRequire("dx7aH");

var $b6UH6 = parcelRequire("b6UH6");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $2EFuW = parcelRequire("2EFuW");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $bs9jJ = parcelRequire("bs9jJ");

var $2fEm7 = parcelRequire("2fEm7");

var $chvgc = parcelRequire("chvgc");

var $79CMK = parcelRequire("79CMK");
const $b43ae64680b98409$var$upsellLozengeText = (0, $7eNDO.defineMessage)({
    defaultMessage: "Premium",
    id: "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.upsell-lozenge-text"
});
function $b43ae64680b98409$export$a578a9f5b9517a27({ isExpanded: isExpanded }) {
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).ASSETS);
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    const { isByokCustomer: isByokCustomer } = (0, $eiIY9.useByokComplianceSettingWithInitialisation)();
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const [{ config: config, dataManager: dataManager, loading: loading }, { fetchGlobalConfig: fetchGlobalConfig, fetchProvisioningStatus: fetchProvisioningStatus, fetchMyDataManagerRoles: fetchMyDataManagerRoles }] = (0, $1ntzc.useInsightGlobalConfig)();
    const fetchAssetsConfig = (0, $euxye.useCallback)(async ()=>{
        fetchGlobalConfig(false);
        fetchProvisioningStatus(false);
        fetchMyDataManagerRoles(false);
    }, [
        fetchGlobalConfig,
        fetchMyDataManagerRoles,
        fetchProvisioningStatus
    ]);
    const menuId = (0, $5IkoH.MENU_ID_ASSETS);
    const showActionsMenu = (0, $i860n.fg)('navx-global-side-nav') ? config?.insightAdministrator : true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $6GljB.L1_MENU_ID).ASSETS,
                sectionItem: (0, $bOwox.SECTION_ITEM_ASSETS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        elemBefore: icon,
        actionsOnHover: showActionsMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $79CMK.SectionActions), {
            isInsightAdministrator: config?.insightAdministrator
        }) : undefined,
        testId: (0, $jzXAj.getTestId)(menuId),
        onClick: (_e, _a, { isExpanded: hasExpanded })=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $6GljB.L1_MENU_ID).ASSETS,
                sectionItem: (0, $bOwox.SECTION_ITEM_ASSETS)
            });
        },
        interactionName: "nav4-sidebar-assets"
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $chvgc.HeaderSchemasMenuItems), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b6UH6.L1ExpandableMenuItemSubmenu), {
        fetch: fetchAssetsConfig,
        isFetching: loading || dataManager.provisioningLoading || dataManager.myRolesLoading,
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2fEm7.AssetsMenuItems), {
                dataManagerIsProvisioned: dataManager.isProvisioned,
                dataManagerMyRoles: dataManager.myRoles,
                isSiteAdmin: isSiteAdmin,
                insightAdministrator: config?.insightAdministrator,
                insightReporting: config?.insightReporting,
                isByokCustomer: isByokCustomer
            }),
        skeletonCount: 2
    })));
}
$b43ae64680b98409$export$a578a9f5b9517a27.displayName = "AssetsMenu";
const $b43ae64680b98409$export$252d7ffe38b4e8ef = ({ showUpsellLozenge: showUpsellLozenge = false })=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).ASSETS);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        onClick: ()=>{
            sendSectionItemAnalyticsEvent({
                menuId: (0, $6GljB.L1_MENU_ID).ASSETS,
                sectionItem: (0, $bOwox.SECTION_ITEM_ASSETS)
            });
        },
        menuId: (0, $5IkoH.MENU_ID_ASSETS),
        elemBefore: icon,
        href: (0, $1DL4e.getLandingPageUrl)(),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $79CMK.SectionActions), {
            isInsightAdministrator: false
        })
    }, `${formattedMessage} `, showUpsellLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-menu.upsell-lozenge",
        appearance: "discovery"
    }, formatMessage($b43ae64680b98409$var$upsellLozengeText)));
};
$b43ae64680b98409$export$252d7ffe38b4e8ef.displayName = "AssetsSingleMenuItem";

});
parcelRegister("eiIY9", function(module, exports) {
$parcel$export(module.exports, "useByokComplianceSettingData", () => $a67f73c5539423fe$export$1972fcad574711bc);
$parcel$export(module.exports, "useByokComplianceSettingWithInitialisation", () => $a67f73c5539423fe$export$fb68f4844474e7cb);

var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $h2wCv = parcelRequire("h2wCv");

var $acwzf = parcelRequire("acwzf");
var $iQPOZ = parcelRequire("iQPOZ");

var $7eNDO = parcelRequire("7eNDO");

var $eijVy = parcelRequire("eijVy");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $a67f73c5539423fe$var$byokComplianceSettingEnabledSuccessTitle = (0, $7eNDO.defineMessage)({
    id: "products-jsm-compliance-main.services.byok-compliance-setting.byok-compliance-setting-enabled-success-title",
    defaultMessage: "HIPAA-compliant alert notifications turned on"
});
const $a67f73c5539423fe$var$byokComplianceSettingEnabledSuccessDescription = (0, $7eNDO.defineMessage)({
    id: "products-jsm-compliance-main.services.byok-compliance-setting.byok-compliance-setting-enabled-success-description",
    defaultMessage: "Let your team admins know about the recommended actions they can take."
});
const $a67f73c5539423fe$var$flagOk = (0, $7eNDO.defineMessage)({
    id: "products-jsm-compliance-main.services.byok-compliance-setting.flag-ok",
    defaultMessage: "Ok"
});
const $a67f73c5539423fe$var$flagLearnMore = (0, $7eNDO.defineMessage)({
    id: "products-jsm-compliance-main.services.byok-compliance-setting.flag-learn-more",
    defaultMessage: "Learn more"
});
const $a67f73c5539423fe$export$f907f15fb3e7d5a9 = (0, $acwzf.toFlagId)('byok-settings-enabled-success-flag-key');
const $a67f73c5539423fe$var$LEARN_MORE_ABOUT_BYOK_COMPLIANCE_SETTING_LINK = 'https://support.atlassian.com/security-and-access-policies/docs/data-managed-with-byok-encryption/24h';
const $a67f73c5539423fe$var$actions = {
    fetchByokComplianceSetting: (cloudId)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.loading === true) return;
            setState({
                ...state,
                loading: true
            });
            try {
                const { data: data } = await (0, $h2wCv.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/byok-setting`);
                setState({
                    ...state,
                    data: data,
                    loading: false,
                    error: undefined
                });
            // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...state,
                    loading: false,
                    error: error
                });
            }
        },
    updateByokComplianceSetting: (option, cloudId)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.loading === true) return;
            // oxlint-disable-next-line react-hooks/rules-of-hooks
            const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $iQPOZ.useFlagsService)(); // eslint-disable-line jira/react/no-usage-of-hooks-outside-components
            setState({
                ...state,
                loading: true
            });
            try {
                await (0, $h2wCv.performPatchRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/byok-setting`, {
                    body: JSON.stringify({
                        ugcPrimaryLogEnabledForByok: option
                    })
                });
                if (option) showFlag({
                    id: $a67f73c5539423fe$export$f907f15fb3e7d5a9,
                    title: $a67f73c5539423fe$var$byokComplianceSettingEnabledSuccessTitle,
                    type: 'success',
                    description: $a67f73c5539423fe$var$byokComplianceSettingEnabledSuccessDescription,
                    messageId: 'products-jsm-compliance.show-flag.success.byok-compliance-setting',
                    messageType: 'transactional',
                    actions: [
                        {
                            content: $a67f73c5539423fe$var$flagOk,
                            onClick: ()=>{
                                dismissFlag($a67f73c5539423fe$export$f907f15fb3e7d5a9);
                            }
                        },
                        {
                            content: $a67f73c5539423fe$var$flagLearnMore,
                            href: $a67f73c5539423fe$var$LEARN_MORE_ABOUT_BYOK_COMPLIANCE_SETTING_LINK,
                            target: '_blank'
                        }
                    ]
                });
                setState({
                    ...state,
                    data: {
                        byokCustomer: state.data?.byokCustomer ?? false,
                        ugcPrimaryLogEnabledForByok: option
                    },
                    loading: false,
                    error: undefined
                });
            // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...state,
                    loading: false,
                    error: error
                });
            }
        }
};
const $a67f73c5539423fe$var$Store = (0, $5QDqc.createStore)({
    initialState: {
        data: null,
        loading: false,
        error: undefined
    },
    actions: $a67f73c5539423fe$var$actions,
    name: 'BYOKComplianceSetting'
});
const $a67f73c5539423fe$export$1972fcad574711bc = (0, $3h1FP.createHook)($a67f73c5539423fe$var$Store);
const $a67f73c5539423fe$export$fb68f4844474e7cb = ()=>{
    const [ByokComplianceSettingState, { fetchByokComplianceSetting: fetchByokComplianceSetting, updateByokComplianceSetting: updateByokComplianceSetting }] = $a67f73c5539423fe$export$1972fcad574711bc();
    const { cloudId: cloudId } = (0, $eijVy.useTenantContext)();
    (0, $euxye.useEffect)(()=>{
        if (!ByokComplianceSettingState.data && (0, $i860n.fg)('audit-logs-byok-encrypted-data')) fetchByokComplianceSetting(cloudId);
    }, [
        ByokComplianceSettingState.data,
        cloudId,
        fetchByokComplianceSetting
    ]);
    return {
        loading: ByokComplianceSettingState.loading,
        error: ByokComplianceSettingState.error,
        data: ByokComplianceSettingState.data,
        isByokComplianceSettingEnabled: ByokComplianceSettingState.data?.ugcPrimaryLogEnabledForByok ?? false,
        isByokCustomer: ByokComplianceSettingState.data?.byokCustomer ?? false,
        enableSetting: ()=>updateByokComplianceSetting(true, cloudId),
        disableSetting: ()=>updateByokComplianceSetting(false, cloudId)
    };
};

});

parcelRegister("1DL4e", function(module, exports) {
$parcel$export(module.exports, "ASSETS_APP_ROUTE_PREFIX", () => $bb5bcae4198ae884$export$42e57fb76a904fc3);
$parcel$export(module.exports, "ASSETS_APP_OBJECT_ROUTE_PREFIX", () => $bb5bcae4198ae884$export$aede099f2ae23728);
$parcel$export(module.exports, "isInsightRoute", () => $bb5bcae4198ae884$export$296d80f3ce129968);
$parcel$export(module.exports, "getCreateServiceUrl", () => $bb5bcae4198ae884$export$1f9b8b558a361aaf);
$parcel$export(module.exports, "getRootPath", () => $bb5bcae4198ae884$export$5413f45d031c7806);
$parcel$export(module.exports, "getLandingPageUrl", () => $bb5bcae4198ae884$export$9366da5a373815e5);
$parcel$export(module.exports, "getGlobalConfigUrl", () => $bb5bcae4198ae884$export$20fd4a0aec335970);
$parcel$export(module.exports, "getAssetsSettingsUrl", () => $bb5bcae4198ae884$export$15f6d6ab94d89135);
$parcel$export(module.exports, "getDataManagerUrl", () => $bb5bcae4198ae884$export$c9b27b0d2e19d52f);
$parcel$export(module.exports, "getDataManagerGettingStartedUrl", () => $bb5bcae4198ae884$export$3d0380185f73b3d);
$parcel$export(module.exports, "getDataManagerObjectClassesUrl", () => $bb5bcae4198ae884$export$4c9768bc51c7a1a);
$parcel$export(module.exports, "getDataManagerVisualizationUrl", () => $bb5bcae4198ae884$export$6c3cb6f103b2324);
$parcel$export(module.exports, "getDataManagerAdaptersUrl", () => $bb5bcae4198ae884$export$cd6b35373ba077a);
$parcel$export(module.exports, "getAssetsReportsUrl", () => $bb5bcae4198ae884$export$c1909404b7ea317f);
$parcel$export(module.exports, "getAssetsDashboardsUrl", () => $bb5bcae4198ae884$export$da30a4c2eb7e2c58);
$parcel$export(module.exports, "getAssetsReportUrl", () => $bb5bcae4198ae884$export$272d35cbff1c220e);
$parcel$export(module.exports, "getAssetsForYouUrl", () => $bb5bcae4198ae884$export$ea8a41c5d5a50829);
$parcel$export(module.exports, "createObjectSchemasUrl", () => $bb5bcae4198ae884$export$c48ea1282c74411e);
$parcel$export(module.exports, "createObjectSchemaUrl", () => $bb5bcae4198ae884$export$3a0332e980fe56cf);
$parcel$export(module.exports, "createObjectTypeUrl", () => $bb5bcae4198ae884$export$cfefb90cfb86b528);
$parcel$export(module.exports, "createObjectSchemaConfigUrl", () => $bb5bcae4198ae884$export$f02479149ce3cac7);
$parcel$export(module.exports, "createObjectDetailUrl", () => $bb5bcae4198ae884$export$51e4229f2c7d3866);
$parcel$export(module.exports, "createObjectTypeSettingsUrl", () => $bb5bcae4198ae884$export$4b4b7d2c3df4fa58);
$parcel$export(module.exports, "createObjectTypeListWithObjectSelectedUrl", () => $bb5bcae4198ae884$export$c1790fa8f0d8e89a);
$parcel$export(module.exports, "getFeatureUsagePageUrl", () => $bb5bcae4198ae884$export$5ba89eed0cf60033);
$parcel$export(module.exports, "getFeatureUsageVirtualAgentPageUrl", () => $bb5bcae4198ae884$export$415502b49e27270d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bS1iz = parcelRequire("bS1iz");

var $i860n = parcelRequire("i860n");

var $6ibhc = parcelRequire("6ibhc");
const $bb5bcae4198ae884$export$ee637ecb2dfa4f6a = '/jira/servicedesk/service-modal';
const $bb5bcae4198ae884$export$42e57fb76a904fc3 = '/jira/assets';
const $bb5bcae4198ae884$export$80e512187a5e0d10 = '/jira/servicedesk/assets';
const $bb5bcae4198ae884$export$6d7574dbda22cf7 = '/jira/servicedesk/insight';
const $bb5bcae4198ae884$export$aede099f2ae23728 = '/jira/assets/object';
const $bb5bcae4198ae884$export$296d80f3ce129968 = (pathname)=>pathname.includes($bb5bcae4198ae884$export$6d7574dbda22cf7);
const $bb5bcae4198ae884$export$1f9b8b558a361aaf = ()=>$bb5bcae4198ae884$export$ee637ecb2dfa4f6a;
const $bb5bcae4198ae884$export$5413f45d031c7806 = ()=>(0, $i860n.fg)('assets_as_an_app_v2') ? $bb5bcae4198ae884$export$42e57fb76a904fc3 : $bb5bcae4198ae884$export$80e512187a5e0d10;
const $bb5bcae4198ae884$export$9366da5a373815e5 = ()=>$bb5bcae4198ae884$export$5413f45d031c7806();
const $bb5bcae4198ae884$export$20fd4a0aec335970 = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/configure/global`;
const $bb5bcae4198ae884$export$15f6d6ab94d89135 = ()=>`${$bb5bcae4198ae884$export$42e57fb76a904fc3}/configure/global`;
const $bb5bcae4198ae884$export$c9b27b0d2e19d52f = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/data-manager/`;
const $bb5bcae4198ae884$export$3d0380185f73b3d = ()=>`${$bb5bcae4198ae884$export$42e57fb76a904fc3}/data-manager/getting-started`;
const $bb5bcae4198ae884$export$4c9768bc51c7a1a = ()=>`${$bb5bcae4198ae884$export$42e57fb76a904fc3}/data-manager/object-classes`;
const $bb5bcae4198ae884$export$6c3cb6f103b2324 = ()=>`${$bb5bcae4198ae884$export$42e57fb76a904fc3}/data-manager/#/dashboards`;
const $bb5bcae4198ae884$export$cd6b35373ba077a = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/data-manager/adapters/`;
const $bb5bcae4198ae884$export$c1909404b7ea317f = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/reports`;
const $bb5bcae4198ae884$export$da30a4c2eb7e2c58 = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/dashboards`;
const $bb5bcae4198ae884$export$2b59e824c7ce8a63 = ()=>`${$bb5bcae4198ae884$export$42e57fb76a904fc3}/discover/data-manager`;
const $bb5bcae4198ae884$export$b386a8fb9ae3586f = ()=>`${$bb5bcae4198ae884$export$42e57fb76a904fc3}/configure/global?menu=data-manager`;
const $bb5bcae4198ae884$export$771825afb10f956f = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/analytics/data-view/create`;
const $bb5bcae4198ae884$export$272d35cbff1c220e = (reportId)=>`${$bb5bcae4198ae884$export$c1909404b7ea317f()}/${reportId}`;
const $bb5bcae4198ae884$export$97bfda8f5f38a121 = (query)=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/search${query ? `?${query}` : ''}`;
const $bb5bcae4198ae884$export$ea8a41c5d5a50829 = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/for-you`;
const $bb5bcae4198ae884$export$c48ea1282c74411e = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/object-schemas`;
const $bb5bcae4198ae884$export$3a0332e980fe56cf = (objectSchemaId)=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/object-schema/${objectSchemaId}`;
const $bb5bcae4198ae884$export$cfefb90cfb86b528 = (objectSchemaId, objectTypeId)=>`${$bb5bcae4198ae884$export$3a0332e980fe56cf(objectSchemaId)}?${(0, $6ibhc.SCHEMA_PAGE_QUERY_PARAMS).objectTypeId}=${objectTypeId}`;
const $bb5bcae4198ae884$export$f02479149ce3cac7 = (objectSchemaId)=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/configure/object-schema/${objectSchemaId}`;
const $bb5bcae4198ae884$export$51e4229f2c7d3866 = (objectId)=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/object/${objectId}`;
const $bb5bcae4198ae884$export$4b4b7d2c3df4fa58 = (objectTypeId)=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/configure/object-type/${objectTypeId}`;
const $bb5bcae4198ae884$export$c1790fa8f0d8e89a = (objectSchemaId, objectTypeId, objectId)=>`${$bb5bcae4198ae884$export$cfefb90cfb86b528(objectSchemaId, objectTypeId)}&view=list&objectId=${objectId}`;
const $bb5bcae4198ae884$export$6e21e6efe57484c5 = (queryParams = {})=>{
    const base = `${$bb5bcae4198ae884$export$42e57fb76a904fc3}/search`;
    if (Object.keys(queryParams).length > 0) {
        const encodedParams = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify(queryParams);
        return `${base}?${encodedParams}`;
    }
    return base;
};
const $bb5bcae4198ae884$export$5ba89eed0cf60033 = ({ showChangeLimitModal: showChangeLimitModal, hasAssetsEntitlement: hasAssetsEntitlement = false } = {})=>hasAssetsEntitlement && (0, $i860n.fg)('aurum-677-assets-usage-migration') ? '/jira/assets/configure/global?menu=app-usage' : `/jira/settings/products/servicedesk/feature-usage?feature=assets${showChangeLimitModal ? '&changeLimit=true' : ''}`;
const $bb5bcae4198ae884$export$415502b49e27270d = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=virtual-agent${showChangeLimitModal ? '&changeLimit=true' : ''}`;

});
parcelRegister("6ibhc", function(module, exports) {
$parcel$export(module.exports, "SCHEMA_PAGE_QUERY_PARAMS", () => $0b85c6f547327d33$export$a73deb42718b5c4);
$parcel$export(module.exports, "TAB_QUERY_PARAM_REFERENCE_TYPES", () => $0b85c6f547327d33$export$f7855185bab37329);
$parcel$export(module.exports, "TAB_QUERY_PARAM_STATUSES", () => $0b85c6f547327d33$export$3739ebbc7c6e87e8);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ICONS", () => $0b85c6f547327d33$export$2c22dc6c729ae0bd);
$parcel$export(module.exports, "TAB_QUERY_PARAM_DATA_MANAGER", () => $0b85c6f547327d33$export$f37b3a97acf56eaf);
$parcel$export(module.exports, "TAB_QUERY_PARAM_COMMON_DATA_MODEL", () => $0b85c6f547327d33$export$b5445f8b5c64a799);
$parcel$export(module.exports, "TAB_QUERY_PARAM_GENERAL", () => $0b85c6f547327d33$export$12ebb1d5017e1d6d);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ROLES", () => $0b85c6f547327d33$export$a77734d9ea30fe44);
$parcel$export(module.exports, "TAB_QUERY_PARAM_IMPORT", () => $0b85c6f547327d33$export$be37b820df30c947);
$parcel$export(module.exports, "TAB_QUERY_PARAM_INHERITANCE", () => $0b85c6f547327d33$export$670faa8ae93e0903);
$parcel$export(module.exports, "useUpdateQueryParams", () => $0b85c6f547327d33$export$e66acc5f4583ce1c);
$parcel$export(module.exports, "useObjectTypeIdQueryParam", () => $0b85c6f547327d33$export$f5a33d51dd6de08);
$parcel$export(module.exports, "useObjectIdQueryParam", () => $0b85c6f547327d33$export$a6e3187c87554a1e);
$parcel$export(module.exports, "useSchemaViewModeQueryParam", () => $0b85c6f547327d33$export$6abda0ad26022eff);
$parcel$export(module.exports, "useObjectViewModeQueryParam", () => $0b85c6f547327d33$export$1927b50f7d074492);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bS1iz = parcelRequire("bS1iz");

var $hFcQt = parcelRequire("hFcQt");

var $2ffUK = parcelRequire("2ffUK");
var $bc9Gj = parcelRequire("bc9Gj");
var $55BnK = parcelRequire("55BnK");
const $0b85c6f547327d33$export$a73deb42718b5c4 = {
    // Values are 'object' or 'attribute'
    schemaMode: 'mode',
    // Values are 'list' or undefined
    objectViewMode: 'view',
    // Both of these params are supported to set the object type ID. 'typeId' is preferred and is the one that is updated.
    // 'objecttypeid' is only used on initial load to support customers who have bookmarked this URL.
    objectTypeId: 'typeId',
    fallbackObjectTypeId: 'objecttypeid',
    objectId: 'objectId'
};
const $0b85c6f547327d33$export$f7855185bab37329 = 'reference-types';
const $0b85c6f547327d33$export$3739ebbc7c6e87e8 = 'statuses';
const $0b85c6f547327d33$export$2c22dc6c729ae0bd = 'icons';
const $0b85c6f547327d33$export$f37b3a97acf56eaf = 'data-manager';
const $0b85c6f547327d33$export$b5445f8b5c64a799 = 'common-data-model';
const $0b85c6f547327d33$export$12ebb1d5017e1d6d = 'general';
const $0b85c6f547327d33$export$a77734d9ea30fe44 = 'roles';
const $0b85c6f547327d33$export$be37b820df30c947 = 'import';
const $0b85c6f547327d33$export$670faa8ae93e0903 = 'inheritance';
const $0b85c6f547327d33$export$e66acc5f4583ce1c = ()=>{
    const { push: push } = (0, $55BnK.useRouterActions)();
    const [{ location: location }] = (0, $bc9Gj.useRouter)();
    const updateQueryParams = (0, $euxye.useCallback)((queryParams = {})=>{
        const { pathname: pathname, search: search } = location;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedQueryParams = {};
        Object.keys(queryParams).forEach((key)=>{
            updatedQueryParams[key] = queryParams[key] ?? undefined;
        });
        return `${pathname}?${(0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).parse(search),
            ...updatedQueryParams
        })}`;
    }, [
        location
    ]);
    const pushRouterAction = (0, $euxye.useCallback)((path)=>{
        push(path);
    }, [
        push
    ]);
    return [
        {
            updateQueryParams: updateQueryParams,
            pushRouterAction: pushRouterAction
        }
    ];
};
const $0b85c6f547327d33$export$f5a33d51dd6de08 = ()=>{
    const [objectTypeId, setObjectTypeId] = (0, $2ffUK.useQueryParam)($0b85c6f547327d33$export$a73deb42718b5c4.objectTypeId);
    const [fallbackObjectTypeId, setFallbackObjectTypeId] = (0, $2ffUK.useQueryParam)($0b85c6f547327d33$export$a73deb42718b5c4.fallbackObjectTypeId);
    (0, $euxye.useEffect)(()=>{
        if (fallbackObjectTypeId !== undefined) {
            setObjectTypeId((0, $hFcQt.toCmdbObjectTypeId)(fallbackObjectTypeId), 'replace');
            setFallbackObjectTypeId(undefined, 'replace');
        }
    }, [
        fallbackObjectTypeId,
        setObjectTypeId,
        setFallbackObjectTypeId
    ]);
    const nullableMain = objectTypeId !== undefined ? (0, $hFcQt.toCmdbObjectTypeId)(objectTypeId) : null;
    const nullableFallback = fallbackObjectTypeId !== undefined ? (0, $hFcQt.toCmdbObjectTypeId)(fallbackObjectTypeId) : null;
    const setter = (newObjectTypeId, updateType)=>{
        setObjectTypeId(newObjectTypeId !== null ? newObjectTypeId : undefined, updateType);
    };
    return [
        nullableMain !== null ? nullableMain : nullableFallback,
        setter
    ];
};
const $0b85c6f547327d33$export$a6e3187c87554a1e = ()=>{
    const [objectId, setObjectId] = (0, $2ffUK.useQueryParam)($0b85c6f547327d33$export$a73deb42718b5c4.objectId);
    const nullableObjectId = objectId !== undefined ? (0, $hFcQt.toCmdbObjectId)(objectId) : null;
    const setter = (newObjectId, updateType)=>{
        setObjectId(newObjectId !== null ? newObjectId : undefined, updateType);
    };
    return [
        nullableObjectId,
        setter
    ];
};
const $0b85c6f547327d33$export$6abda0ad26022eff = ()=>{
    const [rawParamValue, setSchemaMode] = (0, $2ffUK.useQueryParam)($0b85c6f547327d33$export$a73deb42718b5c4.schemaMode);
    const schemaMode = rawParamValue === 'attribute' ? 'attribute' : 'object';
    return [
        schemaMode,
        setSchemaMode
    ];
};
const $0b85c6f547327d33$export$1927b50f7d074492 = ()=>{
    const [rawParamValue, setObjectViewMode] = (0, $2ffUK.useQueryParam)($0b85c6f547327d33$export$a73deb42718b5c4.objectViewMode);
    const objectViewMode = rawParamValue === 'list' ? 'list' : 'details';
    const setter = (newValue, updateMode)=>{
        setObjectViewMode(newValue === 'list' ? 'list' : undefined, updateMode);
    };
    return [
        objectViewMode,
        setter
    ];
};

});
parcelRegister("hFcQt", function(module, exports) {
$parcel$export(module.exports, "toSchemaId", () => $7a187f41b88f8e4f$export$d577b7f3b832f656);
$parcel$export(module.exports, "toCmdbObjectId", () => $7a187f41b88f8e4f$export$1ba342595bc7be13);
$parcel$export(module.exports, "toCmdbObjectTypeId", () => $7a187f41b88f8e4f$export$b46e25afa2bab6a);
$parcel$export(module.exports, "toObjectCommentId", () => $7a187f41b88f8e4f$export$ece2917434bb0a8c);
$parcel$export(module.exports, "toObjectTypeAttributeId", () => $7a187f41b88f8e4f$export$cfd92c18cee8add7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $7a187f41b88f8e4f$export$d577b7f3b832f656 = (id)=>id;
const $7a187f41b88f8e4f$export$1ba342595bc7be13 = (id)=>id;
const $7a187f41b88f8e4f$export$b46e25afa2bab6a = (id)=>id;
const $7a187f41b88f8e4f$export$d002b8d7821b6b59 = (id)=>id;
const $7a187f41b88f8e4f$export$ece2917434bb0a8c = (id)=>id;
const $7a187f41b88f8e4f$export$cfd92c18cee8add7 = (id)=>id;

});



parcelRegister("3rqDf", function(module, exports) {
$parcel$export(module.exports, "useSectionItemAnalytics", () => $d176e0745413b899$export$88869d054e1fb00a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");


var $bOwox = parcelRequire("bOwox");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $ggvFe = parcelRequire("ggvFe");
const $d176e0745413b899$export$ee0f05907a733e87 = ({ sectionItem: sectionItem, menuId: menuId, moreMenuIds: moreMenuIds })=>{
    if (sectionItem === (0, $bOwox.SECTION_ITEM_CUSTOMIZE_SIDEBAR)) return moreMenuIds.length !== 0;
    if (menuId) return moreMenuIds.includes(menuId);
    return false;
};
function $d176e0745413b899$export$88869d054e1fb00a() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $euxye.useContext)((0, $ggvFe.NavItemsContext));
    const sendSectionItemAnalyticsEvent = (0, $euxye.useCallback)(({ menuId: menuId, sectionItem: sectionItem })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
        });
        const isInMore = $d176e0745413b899$export$ee0f05907a733e87({
            sectionItem: sectionItem,
            menuId: menuId,
            moreMenuIds: moreMenuIds
        });
        (0, $aJ81Y.fireUIAnalytics)(event, sectionItem, {
            isInMore: isInMore
        });
    }, [
        createAnalyticsEvent,
        moreMenuIds
    ]);
    return sendSectionItemAnalyticsEvent;
}

});

parcelRegister("b6UH6", function(module, exports) {
$parcel$export(module.exports, "L1ExpandableMenuItemSubmenu", () => $1446a5a45881e31d$export$a0d95f81c9ddf0e9);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $37OTd = parcelRequire("37OTd");
const $1446a5a45881e31d$export$a0d95f81c9ddf0e9 = (props)=>{
    const { fetch: fetch, Footer: Footer, isFetching: isFetching, MenuItems: MenuItems, skeletonCount: skeletonCount } = props;
    const expandableMenuItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(MenuItems, null);
    const expandableFooter = Footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Footer, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $37OTd.ExpandableMenuItemSubmenu), {
        fetch: fetch,
        footer: expandableFooter,
        isFetching: isFetching,
        menuItems: expandableMenuItems,
        skeletonCount: skeletonCount
    });
};
$1446a5a45881e31d$export$a0d95f81c9ddf0e9.displayName = "L1ExpandableMenuItemSubmenu";

});
parcelRegister("37OTd", function(module, exports) {
$parcel$export(module.exports, "ExpandableMenuItemSubmenu", () => $4ec830e36b9aed07$export$216998a85b3335a2);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3D7ce = parcelRequire("3D7ce");

var $4LedD = parcelRequire("4LedD");

var $gEDfa = parcelRequire("gEDfa");
const $4ec830e36b9aed07$export$216998a85b3335a2 = (props)=>{
    const { fetch: fetchMaybe, footer: footer, isFetching: isFetchingMaybe, menuItems: menuItems, skeletonCount: skeletonCount } = props;
    const { isFetching: isFetching, fetch: fetch } = (0, $4LedD.useFetchActual)(isFetchingMaybe, fetchMaybe);
    const isExpanded = (0, $3D7ce.useIsExpanded)();
    // Fetch on open to refresh.
    (0, $euxye.useEffect)(()=>{
        if (isExpanded && !isFetching) fetch();
    }, // Don't include `isFetching` or this effect will go into an endless loop.
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        isExpanded,
        fetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), {
        count: skeletonCount
    }) : menuItems, footer);
};
$4ec830e36b9aed07$export$216998a85b3335a2.displayName = "ExpandableMenuItemSubmenu";

});
parcelRegister("4LedD", function(module, exports) {
$parcel$export(module.exports, "useFetchActual", () => $617c6851a281d9d9$export$49f3bd519990bec7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
const $617c6851a281d9d9$export$49f3bd519990bec7 = (isFetchingMaybe, fetchMaybe)=>{
    const [isFetching, setIsFetching] = (0, $euxye.useState)(false);
    const fetch = (0, $euxye.useCallback)(async ()=>{
        if (!fetchMaybe) return;
        setIsFetching(true);
        try {
            await fetchMaybe();
        } finally{
            setIsFetching(false);
        }
    }, [
        fetchMaybe,
        setIsFetching
    ]);
    return {
        isFetching: !!isFetchingMaybe || isFetching,
        fetch: fetch
    };
};

});



parcelRegister("2fEm7", function(module, exports) {
$parcel$export(module.exports, "AssetsMenuItems", () => $5e22d9e38c209a3a$export$eca9d73b7de13f6a);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $41FAq = parcelRequire("41FAq");

var $cIBCk = parcelRequire("cIBCk");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $c7R7X = parcelRequire("c7R7X");

var $jGcte = parcelRequire("jGcte");

var $8GHRH = parcelRequire("8GHRH");
const $5e22d9e38c209a3a$export$eca9d73b7de13f6a = ({ dataManagerIsProvisioned: dataManagerIsProvisioned, dataManagerMyRoles: dataManagerMyRoles, isSiteAdmin: isSiteAdmin, insightAdministrator: insightAdministrator, insightReporting: insightReporting, isByokCustomer: isByokCustomer })=>{
    const showDataManagerLink = (0, $euxye.useCallback)(()=>{
        if (dataManagerIsProvisioned && dataManagerMyRoles) {
            const hasDMRoles = dataManagerMyRoles.some((myRole)=>(0, $cIBCk.DATA_MANAGER_ROLES).includes(myRole));
            const hasAdapterRoles = dataManagerMyRoles.some((myRole)=>(0, $cIBCk.DATA_MANAGER_ADAPTERS_ROLES).includes(myRole));
            if (hasDMRoles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jGcte.DataManagerMenuItems), null);
            if (hasAdapterRoles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c7R7X.DataManagerAdapterMenuItems), null);
        }
    }, [
        dataManagerIsProvisioned,
        dataManagerMyRoles
    ]);
    const isAssetsReportsByokSupported = isByokCustomer ? (0, $i860n.fg)('assets_reports_enabled_for_byok_customers') : true;
    const isInsightReportsEnabled = (0, $euxye.useCallback)(()=>(isSiteAdmin || insightAdministrator) && isAssetsReportsByokSupported && insightReporting, [
        insightAdministrator,
        insightReporting,
        isSiteAdmin,
        isAssetsReportsByokSupported
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, isInsightReportsEnabled() && ((0, $i860n.fg)('aem_migration_jira') ? (0, $41FAq.isFeatureEnabled)('assets', 'assets-reports') : !(0, $l1vE2.isFedRamp)()) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8GHRH.ReportsMenuItem), null), showDataManagerLink());
};
$5e22d9e38c209a3a$export$eca9d73b7de13f6a.displayName = "AssetsMenuItems";

});
parcelRegister("cIBCk", function(module, exports) {
$parcel$export(module.exports, "DATA_MANAGER_ADMIN", () => $6b66977dd3675a51$export$48abe9ccfdd98170);
$parcel$export(module.exports, "DATA_MANAGER_REPORT_VIEWER", () => $6b66977dd3675a51$export$8939b849d295aa4c);
$parcel$export(module.exports, "DATA_MANAGER_REPORT_EDITOR", () => $6b66977dd3675a51$export$4ca2081d195ddbdb);
$parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ADMIN", () => $6b66977dd3675a51$export$4c3d5fe6bdc107f1);
$parcel$export(module.exports, "DATA_MANAGER_ROLES", () => $6b66977dd3675a51$export$48703faa5030b273);
$parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ROLES", () => $6b66977dd3675a51$export$8b2dfd13f5f35ee4);
$parcel$export(module.exports, "ORDERED_ASSETS_DATA_MANAGER_ROLES", () => $6b66977dd3675a51$export$1d276f65230af2e);
$parcel$export(module.exports, "DATA_MANAGER_CLASS_SETTING_ROUTE_NAME", () => $6b66977dd3675a51$export$59f9384eee594cb2);
$parcel$export(module.exports, "DATA_MANAGER_OPEN_ROUTE_ALL_ROLES", () => $6b66977dd3675a51$export$a71025248fd03044);
/* eslint-disable jira/filename-case */ const $6b66977dd3675a51$export$48abe9ccfdd98170 = 'ari:cloud:cmdb::role/airtrack/admin';
const $6b66977dd3675a51$export$8939b849d295aa4c = 'ari:cloud:cmdb::role/airtrack/report-viewer';
const $6b66977dd3675a51$export$4ca2081d195ddbdb = 'ari:cloud:cmdb::role/airtrack/report-editor';
const $6b66977dd3675a51$export$4c3d5fe6bdc107f1 = 'ari:cloud:cmdb::role/airtrack-buoy/admin';
const $6b66977dd3675a51$export$48703faa5030b273 = [
    $6b66977dd3675a51$export$48abe9ccfdd98170,
    $6b66977dd3675a51$export$8939b849d295aa4c,
    $6b66977dd3675a51$export$4ca2081d195ddbdb
];
const $6b66977dd3675a51$export$8b2dfd13f5f35ee4 = [
    $6b66977dd3675a51$export$4c3d5fe6bdc107f1
];
const $6b66977dd3675a51$export$1d276f65230af2e = [
    $6b66977dd3675a51$export$48abe9ccfdd98170,
    $6b66977dd3675a51$export$4c3d5fe6bdc107f1,
    $6b66977dd3675a51$export$4ca2081d195ddbdb,
    $6b66977dd3675a51$export$8939b849d295aa4c
];
const $6b66977dd3675a51$export$59f9384eee594cb2 = 'assets-data-manager-object-class-settings';
const $6b66977dd3675a51$export$a71025248fd03044 = [
    'assets-data-manager-getting-started',
    'assets-data-manager-object-classes',
    'assets-data-manager-object-class-view',
    'assets-data-manager-data-source',
    'assets-data-manager-object-detail-view',
    $6b66977dd3675a51$export$59f9384eee594cb2
];

});

parcelRegister("c7R7X", function(module, exports) {
$parcel$export(module.exports, "DataManagerAdapterMenuItems", () => $3bd7fe900ad7e91e$export$f74d67a8d693b664);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $78f35 = parcelRequire("78f35");

var $1DL4e = parcelRequire("1DL4e");


var $KL7Bq = parcelRequire("KL7Bq");

var $b9reC = parcelRequire("b9reC");

var $2EFuW = parcelRequire("2EFuW");

var $defJG = parcelRequire("defJG");

var $e6rNk = parcelRequire("e6rNk");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $cgwwS = parcelRequire("cgwwS");
const $3bd7fe900ad7e91e$var$jsmAssetsDataManagerAdapters = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.jsm-assets-data-manager-adapters",
    defaultMessage: "Adapters"
});
const $3bd7fe900ad7e91e$var$jsmAssetsOpenDataManager = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.jsm-assets-open-data-manager",
    defaultMessage: "Open data manager"
});
const $3bd7fe900ad7e91e$var$assetsDataManagerBeta = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.assets-data-manager-beta",
    defaultMessage: "Beta"
});
const $3bd7fe900ad7e91e$export$f74d67a8d693b664 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { icon: formattedAdapterIcon } = (0, $KL7Bq.useFormattedMessageAndIcon)($3bd7fe900ad7e91e$var$jsmAssetsDataManagerAdapters, (0, $78f35.DataManagerAdaptersGlyph));
    const { icon: formattedOpenIcon } = (0, $KL7Bq.useFormattedMessageAndIcon)($3bd7fe900ad7e91e$var$jsmAssetsOpenDataManager, (0, (/*@__PURE__*/$parcel$interopDefault($b9reC))));
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $cgwwS.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e6rNk.LinkMenuItem), {
        elemBefore: formattedAdapterIcon,
        elemAfter: formattedOpenIcon,
        href: (0, $1DL4e.getDataManagerAdaptersUrl)(),
        target: "_blank",
        onClick: ()=>fireUINavigationItemAnalytics((0, $90c0351d239ffedb$export$ee52916f9ebd8000))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.Inline), {
        space: "space.050",
        alignBlock: "baseline"
    }, formatMessage($3bd7fe900ad7e91e$var$jsmAssetsDataManagerAdapters), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
        appearance: "discovery"
    }, formatMessage($3bd7fe900ad7e91e$var$assetsDataManagerBeta))));
};
$3bd7fe900ad7e91e$export$f74d67a8d693b664.displayName = "DataManagerAdapterMenuItems";

});
parcelRegister("78f35", function(module, exports) {
$parcel$export(module.exports, "DataManagerAdaptersGlyph", () => $7cb37a57e192e70d$export$cff497901afe8164);
/* eslint-disable jira/integration/test-id-by-folder-structure */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4qNCE = parcelRequire("4qNCE");

var $gxIqV = parcelRequire("gxIqV");

var $9zLjo = parcelRequire("9zLjo");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $2EFuW = parcelRequire("2EFuW");

var $jpPNt = parcelRequire("jpPNt");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $7cb37a57e192e70d$var$betaLabel = (0, $7eNDO.defineMessage)({
    id: "servicedesk-insight-landing-page.data-manager-link.beta-label",
    defaultMessage: "BETA"
});
const $7cb37a57e192e70d$export$fb5ad6208dd8d5f1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 6.5C7.5 7.05228 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5C7.05228 5.5 7.5 5.94772 7.5 6.5ZM7.5 17.5C7.5 18.0523 7.05228 18.5 6.5 18.5C5.94772 18.5 5.5 18.0523 5.5 17.5C5.5 16.9477 5.94772 16.5 6.5 16.5C7.05228 16.5 7.5 16.9477 7.5 17.5ZM18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11C18.0523 11 18.5 11.4477 18.5 12ZM8.88555 7.25C8.56698 8.26428 7.61941 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.61941 4 8.56698 4.73572 8.88555 5.75H10.5523C11.697 5.75 12.625 6.67797 12.625 7.82267V11.25H14.5H15.1145C15.433 10.2357 16.3806 9.5 17.5 9.5C18.8807 9.5 20 10.6193 20 12C20 13.3807 18.8807 14.5 17.5 14.5C16.3806 14.5 15.433 13.7643 15.1145 12.75H14.5H12.625V16.1773C12.625 17.322 11.697 18.25 10.5523 18.25H8.88555C8.56698 19.2643 7.61941 20 6.5 20C5.11929 20 4 18.8807 4 17.5C4 16.1193 5.11929 15 6.5 15C7.61941 15 8.56698 15.7357 8.88555 16.75H10.5523C10.8686 16.75 11.125 16.4936 11.125 16.1773V12.75V12V11.25V7.82267C11.125 7.50639 10.8686 7.25 10.5523 7.25H8.88555Z",
        fill: "#44546F"
    }));
$7cb37a57e192e70d$export$fb5ad6208dd8d5f1.displayName = "DataManagerGlyph";
const $7cb37a57e192e70d$export$cff497901afe8164 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        clipPath: "url(#clip0_2374_102539)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5076 15.8019C10.8212 16.0862 11 16.4898 11 16.913V18.5H13V16.913C13 16.4898 13.1788 16.0862 13.4924 15.8019L16.5 13.0745V9.5H7.5V13.0745L10.5076 15.8019ZM6 13.7391V9C6 8.44771 6.44772 8 7 8H17C17.5523 8 18 8.44772 18 9V13.7391L14.5 16.913V19C14.5 19.5523 14.0523 20 13.5 20H10.5C9.94772 20 9.5 19.5523 9.5 19V16.913L6 13.7391Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 9L9 4L10.5 4V9H9Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5 9V4L15 4V9H13.5Z",
        fill: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("clipPath", {
        id: "clip0_2374_102539"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "currentColor"
    }))));
$7cb37a57e192e70d$export$cff497901afe8164.displayName = "DataManagerAdaptersGlyph";
const $7cb37a57e192e70d$export$905e681c1cad3de = ({ children: children, onClick: onClick, testId: testId, to: to, app: app })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const getIcon = ()=>{
        if (app === 'data-manager') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9zLjo))), {
            label: "Data manager icon",
            size: "medium"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gxIqV))), {
            label: "Adapters icon",
            size: "medium"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $7cb37a57e192e70d$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
        href: to,
        component: (0, $jpPNt.Link),
        appearance: "subtle",
        iconBefore: getIcon(),
        testId: testId,
        onClick: (event, analyticsEvent)=>{
            onClick?.(analyticsEvent);
        },
        target: "_blank"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $7cb37a57e192e70d$var$lozengeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
        appearance: "discovery"
    }, formatMessage($7cb37a57e192e70d$var$betaLabel)))));
};
$7cb37a57e192e70d$export$905e681c1cad3de.displayName = "DataManagerLink";
const $7cb37a57e192e70d$var$lozengeStyles = (0, $fbAgj.xcss)({
    display: 'inline-block',
    marginLeft: 'space.050'
});
const $7cb37a57e192e70d$var$wrapperStyles = (0, $fbAgj.xcss)({});

});
parcelRegister("gxIqV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2527bb8f7226ee095a0c1ec684953102>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c0b231eaf604b3f1$var$_react = $c0b231eaf604b3f1$var$_interopRequireDefault((parcelRequire("euxye")));

var $c0b231eaf604b3f1$var$_baseNew = $c0b231eaf604b3f1$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $c0b231eaf604b3f1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PowerPlug".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/power-plug
 * Usage guidance:
 * Multi purpose - Known uses: plugins, add ons.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c0b231eaf604b3f1$var$PowerPlugIcon = (props)=>/*#__PURE__*/ $c0b231eaf604b3f1$var$_react.default.createElement($c0b231eaf604b3f1$var$_baseNew.default, Object.assign({
        name: "PowerPlugIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 4H2.75a.75.75 0 0 0-.75.75v3.9c0 .911.382 1.78 1.054 2.396L5 12.83V14a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1.17l1.946-1.784A3.25 3.25 0 0 0 14 8.65v-3.9a.75.75 0 0 0-.75-.75H11V0H9.5v4h-3V0H5zM3.5 5.5v3.15c0 .49.206.959.567 1.29l2.19 2.007a.75.75 0 0 1 .243.553V14a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1.5c0-.21.088-.41.243-.553l2.19-2.007c.361-.331.567-.8.567-1.29V5.5z" clip-rule="evenodd"/>`
    }, props));
$c0b231eaf604b3f1$var$PowerPlugIcon.displayName = 'PowerPlugIcon';
var $c0b231eaf604b3f1$var$_default = module.exports.default = $c0b231eaf604b3f1$var$PowerPlugIcon;

});

parcelRegister("9zLjo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::705403248b5ca36195743975c56a4dae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f8c15143bcb9579$var$_react = $6f8c15143bcb9579$var$_interopRequireDefault((parcelRequire("euxye")));

var $6f8c15143bcb9579$var$_baseNew = $6f8c15143bcb9579$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $6f8c15143bcb9579$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsDataManager".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-data-manager
 * Usage guidance:
 * Reserved for JSM Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6f8c15143bcb9579$var$AssetsDataManagerIcon = (props)=>/*#__PURE__*/ $6f8c15143bcb9579$var$_react.default.createElement($6f8c15143bcb9579$var$_baseNew.default, Object.assign({
        name: "AssetsDataManagerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.25 12V4a.5.5 0 0 0-.5-.5h-2V2h2a2 2 0 0 1 2 2v3.25h2.5v1.5h-2.5V12a2 2 0 0 1-2 2h-2v-1.5h2a.5.5 0 0 0 .5-.5"/><path fill="currentcolor" d="M13.25 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m0-1.5a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5M2.75 1.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m0-1.5a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5m0 12a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m0-1.5a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5"/>`
    }, props));
$6f8c15143bcb9579$var$AssetsDataManagerIcon.displayName = 'AssetsDataManagerIcon';
var $6f8c15143bcb9579$var$_default = module.exports.default = $6f8c15143bcb9579$var$AssetsDataManagerIcon;

});


/* eslint-disable jira/filename-case */ const $90c0351d239ffedb$export$f06dfcec5ff912e = 'meatballDropdown';
const $90c0351d239ffedb$export$7ae7abcf2c19d3e5 = 'removeFromStarred';
const $90c0351d239ffedb$export$78fd0bd637fe1684 = 'addToStarred';
const $90c0351d239ffedb$export$c540230986f848f6 = 'addPeople';
const $90c0351d239ffedb$export$44d67b522cbcce6d = 'projects';
const $90c0351d239ffedb$export$3cc9ab700c406a19 = 'projectSettings';
const $90c0351d239ffedb$export$dc23a793cf9e9de8 = 'archiveProject';
const $90c0351d239ffedb$export$a68d619e7022f2c3 = 'deleteBoard';
const $90c0351d239ffedb$export$22748439827110a4 = 'deleteProject';
const $90c0351d239ffedb$export$192d610b0b7719f4 = 'boardSettings';
const $90c0351d239ffedb$export$a65812b4aab631bb = 'alertSettings';
const $90c0351d239ffedb$export$36b5d4d0cb4e437 = 'moveInSidebar';
const $90c0351d239ffedb$export$ca6db12118be69a1 = 'schemas';
const $90c0351d239ffedb$export$f2eca6cf19c9a973 = 'reports';
const $90c0351d239ffedb$export$147264622218a553 = 'dataManager';
const $90c0351d239ffedb$export$ee52916f9ebd8000 = 'adapters';
const $90c0351d239ffedb$export$83d40997eb7cc5b7 = 'assetsGlobalConfiguration';
const $90c0351d239ffedb$export$5c09fa42f8d45ed8 = 'dismissRecommendation';
const $90c0351d239ffedb$export$de9ad1ebeca97ec1 = 'newDiscoveryProject';
const $90c0351d239ffedb$export$27e4092edca7bb97 = 'jwmSampleProject';
const $90c0351d239ffedb$export$ce0bea1467165424 = 'whyAmISeeingThis';
const $90c0351d239ffedb$export$98d08638c2a90c44 = 'starredAndRecentProjects';
const $90c0351d239ffedb$export$ed36b1ade72db400 = 'starredProjectsOnly';
const $90c0351d239ffedb$export$f8a73cc0211412ca = 'mostRecentProjectOnly';
const $90c0351d239ffedb$export$3e2efdbdb3eed97e = 'moreProjects';
const $90c0351d239ffedb$export$2de7e56f66635690 = 'viewAllProjects';
const $90c0351d239ffedb$export$e338c40e64df0640 = 'projectsSearch';
const $90c0351d239ffedb$export$5ff59e4f08b9b299 = 'moveToTop';
const $90c0351d239ffedb$export$9964b4a63620a911 = 'moveUp';
const $90c0351d239ffedb$export$2692a384035c5ef7 = 'moveDown';
const $90c0351d239ffedb$export$a5a45050b97fca24 = 'moveToBottom';
const $90c0351d239ffedb$export$792f6f6bb85dd3a4 = 'linkedTeams';

parcelRegister("b9reC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8d458034df571ed95bda84f71003b22c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81e5a93d441bebb3$var$_react = $81e5a93d441bebb3$var$_interopRequireDefault((parcelRequire("euxye")));

var $81e5a93d441bebb3$var$_baseNew = $81e5a93d441bebb3$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $81e5a93d441bebb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-up-right
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $81e5a93d441bebb3$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $81e5a93d441bebb3$var$_react.default.createElement($81e5a93d441bebb3$var$_baseNew.default, Object.assign({
        name: "ArrowUpRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$81e5a93d441bebb3$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $81e5a93d441bebb3$var$_default = module.exports.default = $81e5a93d441bebb3$var$ArrowUpRightIcon;

});

parcelRegister("cgwwS", function(module, exports) {
$parcel$export(module.exports, "useAssetsUIAnalytics", () => $f660157419e7c981$export$2eb4a7a38c92c87f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");




var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
const $f660157419e7c981$export$2eb4a7a38c92c87f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireUINavigationItemAnalytics = (0, $euxye.useCallback)((analyticsItemId)=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
        }), (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_ASSETS], {
            level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
            componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
            itemId: analyticsItemId
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireUINavigationItemAnalytics: fireUINavigationItemAnalytics
    };
};

});


parcelRegister("jGcte", function(module, exports) {
$parcel$export(module.exports, "DataManagerMenuItems", () => $501680df8d3ae3f7$export$34300598ca712097);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1DL4e = parcelRequire("1DL4e");

var $ihnWn = parcelRequire("ihnWn");


var $KL7Bq = parcelRequire("KL7Bq");

var $b9reC = parcelRequire("b9reC");

var $defJG = parcelRequire("defJG");

var $2EFuW = parcelRequire("2EFuW");

var $e6rNk = parcelRequire("e6rNk");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $cgwwS = parcelRequire("cgwwS");
const $501680df8d3ae3f7$var$assetsDataManager = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-data-manager",
    defaultMessage: "Data Manager"
});
const $501680df8d3ae3f7$var$assetsOpenDataManager = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-open-data-manager",
    defaultMessage: "Open Data Manager"
});
const $501680df8d3ae3f7$var$assetsDataManagerBeta = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-data-manager-beta",
    defaultMessage: "Beta"
});
const $501680df8d3ae3f7$export$34300598ca712097 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { icon: formattedOpenIcon } = (0, $KL7Bq.useFormattedMessageAndIcon)($501680df8d3ae3f7$var$assetsOpenDataManager, (0, (/*@__PURE__*/$parcel$interopDefault($b9reC))));
    const { icon: formattedDataManagerIcon } = (0, $KL7Bq.useFormattedMessageAndIcon)($501680df8d3ae3f7$var$assetsDataManager, (0, $ihnWn.default));
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $cgwwS.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e6rNk.LinkMenuItem), {
        elemBefore: formattedDataManagerIcon,
        elemAfter: formattedOpenIcon,
        href: (0, $1DL4e.getDataManagerUrl)(),
        target: "_blank",
        onClick: ()=>fireUINavigationItemAnalytics((0, $90c0351d239ffedb$export$147264622218a553))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.Inline), {
        space: "space.050",
        alignBlock: "baseline"
    }, formatMessage($501680df8d3ae3f7$var$assetsDataManager), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
        appearance: "discovery"
    }, formatMessage($501680df8d3ae3f7$var$assetsDataManagerBeta))));
};
$501680df8d3ae3f7$export$34300598ca712097.displayName = "DataManagerMenuItems";

});
parcelRegister("ihnWn", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd08ee79dab719e3$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */ 
var $euxye = parcelRequire("euxye");

var $9zLjo = parcelRequire("9zLjo");
const $fd08ee79dab719e3$var$JsmAssetsDataManagerIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9zLjo))), props);
$fd08ee79dab719e3$var$JsmAssetsDataManagerIcon.displayName = "JsmAssetsDataManagerIcon";
var $fd08ee79dab719e3$export$2e2bcd8739ae039 = $fd08ee79dab719e3$var$JsmAssetsDataManagerIcon;

});


parcelRegister("8GHRH", function(module, exports) {
$parcel$export(module.exports, "ReportsMenuItem", () => $147983bc56379e68$export$156f96ce3bb16879);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1DL4e = parcelRequire("1DL4e");


var $5IkoH = parcelRequire("5IkoH");

var $aQCoC = parcelRequire("aQCoC");

var $7f3lN = parcelRequire("7f3lN");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $cgwwS = parcelRequire("cgwwS");
const $147983bc56379e68$var$jsmAssetsReports = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-assets.common.reports.jsm-assets-reports",
    defaultMessage: "Reports"
});
const $147983bc56379e68$export$156f96ce3bb16879 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const reportsLink = (0, $euxye.useMemo)(()=>(0, $1DL4e.getAssetsReportsUrl)(), []);
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $cgwwS.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7f3lN))), {
            label: formatMessage($147983bc56379e68$var$jsmAssetsReports),
            color: "currentColor",
            spacing: "spacious"
        }),
        href: reportsLink,
        menuId: (0, $5IkoH.MENU_ID_ASSETS_REPORTS),
        onClick: ()=>fireUINavigationItemAnalytics((0, $90c0351d239ffedb$export$f2eca6cf19c9a973))
    }, formatMessage($147983bc56379e68$var$jsmAssetsReports));
};
$147983bc56379e68$export$156f96ce3bb16879.displayName = "ReportsMenuItem";

});
parcelRegister("7f3lN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46d82f4505e125f92f80e202b0776545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $545c8873f46f7916$var$_react = $545c8873f46f7916$var$_interopRequireDefault((parcelRequire("euxye")));

var $545c8873f46f7916$var$_baseNew = $545c8873f46f7916$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $545c8873f46f7916$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chart-bar
 * Usage guidance:
 * Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $545c8873f46f7916$var$ChartBarIcon = (props)=>/*#__PURE__*/ $545c8873f46f7916$var$_react.default.createElement($545c8873f46f7916$var$_baseNew.default, Object.assign({
        name: "ChartBarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$545c8873f46f7916$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $545c8873f46f7916$var$_default = module.exports.default = $545c8873f46f7916$var$ChartBarIcon;

});



parcelRegister("chvgc", function(module, exports) {
$parcel$export(module.exports, "HeaderSchemasMenuItems", () => $b54147144a616d2f$export$7243359973253e5);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1DL4e = parcelRequire("1DL4e");

var $bOYO0 = parcelRequire("bOYO0");

var $5cCXl = parcelRequire("5cCXl");


var $5IkoH = parcelRequire("5IkoH");

var $aQCoC = parcelRequire("aQCoC");

var $KL7Bq = parcelRequire("KL7Bq");

var $zbgUa = parcelRequire("zbgUa");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $cgwwS = parcelRequire("cgwwS");
const $b54147144a616d2f$var$jsmAssetsSchemas = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.schemas.jsm-assets-schemas",
    defaultMessage: "Schemas"
});
const $b54147144a616d2f$export$7243359973253e5 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const assetsTenantContext = (0, $zbgUa.useAssetsTenantContext)();
    const hasAssetsEntitlementEnabled = (0, $i860n.fg)('assets_for_you') && (0, $bOYO0.hasAssetsEntitlement)(assetsTenantContext);
    const schemasLink = (0, $euxye.useMemo)(()=>hasAssetsEntitlementEnabled ? `${(0, $1DL4e.getLandingPageUrl)()}/schemas` : (0, $1DL4e.getLandingPageUrl)(), [
        hasAssetsEntitlementEnabled
    ]);
    const { icon: formattedSchemasIcon } = (0, $KL7Bq.useFormattedMessageAndIcon)($b54147144a616d2f$var$jsmAssetsSchemas, (0, $5cCXl.default));
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $cgwwS.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        menuId: (0, $5IkoH.MENU_ID_ASSETS_SCHEMAS),
        elemBefore: formattedSchemasIcon,
        href: schemasLink,
        onClick: ()=>fireUINavigationItemAnalytics((0, $90c0351d239ffedb$export$ca6db12118be69a1))
    }, formatMessage($b54147144a616d2f$var$jsmAssetsSchemas));
};
$b54147144a616d2f$export$7243359973253e5.displayName = "HeaderSchemasMenuItems";

});
parcelRegister("5cCXl", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a5bc04e900a299e$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */ 
var $euxye = parcelRequire("euxye");

var $2atuI = parcelRequire("2atuI");
const $4a5bc04e900a299e$var$JsmAssetsSchemasIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2atuI))), props);
$4a5bc04e900a299e$var$JsmAssetsSchemasIcon.displayName = "JsmAssetsSchemasIcon";
var $4a5bc04e900a299e$export$2e2bcd8739ae039 = $4a5bc04e900a299e$var$JsmAssetsSchemasIcon;

});
parcelRegister("2atuI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83409fb643d49a937228924170dd715a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $194364e8ae2230a6$var$_react = $194364e8ae2230a6$var$_interopRequireDefault((parcelRequire("euxye")));

var $194364e8ae2230a6$var$_baseNew = $194364e8ae2230a6$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $194364e8ae2230a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsSchema".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-schema
 * Usage guidance:
 * Reserved for representing schema in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $194364e8ae2230a6$var$AssetsSchemaIcon = (props)=>/*#__PURE__*/ $194364e8ae2230a6$var$_react.default.createElement($194364e8ae2230a6$var$_baseNew.default, Object.assign({
        name: "AssetsSchemaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.75 11a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0-8a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M3 13.5a2 2 0 0 1-2-2V0h1.5v4H8v1.5H2.5v6a.5.5 0 0 0 .5.5h5v1.5zm9.75-4a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5m0-8a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5"/>`
    }, props));
$194364e8ae2230a6$var$AssetsSchemaIcon.displayName = 'AssetsSchemaIcon';
var $194364e8ae2230a6$var$_default = module.exports.default = $194364e8ae2230a6$var$AssetsSchemaIcon;

});



parcelRegister("79CMK", function(module, exports) {
$parcel$export(module.exports, "SectionActions", () => $5d1483a61de51391$export$51f8029abf8c56ce);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1DL4e = parcelRequire("1DL4e");




var $bOwox = parcelRequire("bOwox");

var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $hwodR = parcelRequire("hwodR");

var $2DbWL = parcelRequire("2DbWL");

var $gbTMi = parcelRequire("gbTMi");

var $defJG = parcelRequire("defJG");

var $g36LP = parcelRequire("g36LP");

var $cSR11 = parcelRequire("cSR11");

var $gBaKj = parcelRequire("gBaKj");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
const $5d1483a61de51391$var$jsmAssetsGlobalConfiguration = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.section-actions.jsm-assets-global-configuration",
    defaultMessage: "General configuration"
});
const $5d1483a61de51391$var$jsmAssetsSettingsIcon = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.section-actions.jsm-assets-settings-icon",
    defaultMessage: "Settings"
});
function $5d1483a61de51391$export$51f8029abf8c56ce({ onClose: onClose, isInsightAdministrator: isInsightAdministrator = false }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const onOpen = ()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_ASSETS], {
            level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
            componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
            itemId: (0, $90c0351d239ffedb$export$f06dfcec5ff912e)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
        MenuItems: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5d1483a61de51391$var$MoreMenuItems, {
                ...props,
                isInsightAdministrator: isInsightAdministrator
            }),
        onClose: onClose,
        onOpen: ()=>onOpen()
    });
}
$5d1483a61de51391$export$51f8029abf8c56ce.displayName = "SectionActions";
function $5d1483a61de51391$var$MoreMenuItems({ onClose: onClose, isInsightAdministrator: isInsightAdministrator = false }) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const configLink = (0, $euxye.useMemo)(()=>(0, $1DL4e.getGlobalConfigUrl)(), []);
    const onCloseWithStopPropagation = (0, $hwodR.useStopPropagation)(onClose);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const onClick = (e)=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_ASSETS], {
            level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
            componentType: (0, $6e2f51712bb2e810$export$74712b62056d422e),
            parentItemId: (0, $bOwox.SECTION_ITEM_ASSETS),
            itemId: (0, $90c0351d239ffedb$export$83d40997eb7cc5b7)
        });
        onCloseWithStopPropagation(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, isInsightAdministrator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cSR11.default), {
        href: configLink,
        onClick: (e)=>onClick(e)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gBaKj))), {
        label: formatMessage($5d1483a61de51391$var$jsmAssetsSettingsIcon),
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }), formatMessage($5d1483a61de51391$var$jsmAssetsGlobalConfiguration)))) : null, !(0, $i860n.fg)('navx-global-side-nav') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2DbWL.HideL1MenuItemSection), {
        menuId: (0, $6GljB.L1_MENU_ID).ASSETS
    }));
}
$5d1483a61de51391$var$MoreMenuItems.displayName = "MoreMenuItems";

});


parcelRegister("fBt6f", function(module, exports) {
$parcel$export(module.exports, "AssetsUpsellButton", () => $3f24e1142e74029f$export$a04ba1c400e85b23);
$parcel$export(module.exports, "AssetsAppItem", () => $3f24e1142e74029f$export$5803e5f720bc19ab);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $9XYjM = parcelRequire("9XYjM");

var $1DL4e = parcelRequire("1DL4e");

var $KL7Bq = parcelRequire("KL7Bq");

var $6GljB = parcelRequire("6GljB");

var $dx7aH = parcelRequire("dx7aH");

var $2DbWL = parcelRequire("2DbWL");

var $5IkoH = parcelRequire("5IkoH");

var $aQCoC = parcelRequire("aQCoC");

var $jVPlr = parcelRequire("jVPlr");

var $gbTMi = parcelRequire("gbTMi");



var $b9Jox = parcelRequire("b9Jox");

var $l6OQo = parcelRequire("l6OQo");

var $e10q0 = parcelRequire("e10q0");

var $fyJ3d = parcelRequire("fyJ3d");

var $4CTxE = parcelRequire("4CTxE");

var $2EFuW = parcelRequire("2EFuW");

var $a1Bqx = parcelRequire("a1Bqx");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");
const $3f24e1142e74029f$var$openAssetsApp = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.open-assets-app",
    defaultMessage: "Open Assets"
});
const $3f24e1142e74029f$var$upsellLozengeText = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.upsell-lozenge-text",
    defaultMessage: "Premium"
});
const $3f24e1142e74029f$var$actionsOnHover = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
    MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2DbWL.HideL1MenuItemSection), {
            menuId: (0, $6GljB.L1_MENU_ID).ASSETS
        })
});
const $3f24e1142e74029f$var$linkAnalytics = {
    actionSubjectId: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
    itemId: (0, $5IkoH.MENU_ID_ASSETS),
    level: 1
};
const $3f24e1142e74029f$var$upsellButtonAnalytics = {
    ...$3f24e1142e74029f$var$linkAnalytics,
    componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147)
};
const $3f24e1142e74029f$var$AssetsExternalLink = ()=>{
    const { formattedMessage: assetsMessage, icon: assetsIcon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).ASSETS);
    const { icon: openExternalLinkIcon } = (0, $KL7Bq.useFormattedMessageAndIcon)($3f24e1142e74029f$var$openAssetsApp, (0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: (0, $1DL4e.getRootPath)(),
        target: "_blank",
        menuId: (0, $5IkoH.MENU_ID_ASSETS),
        analytics: $3f24e1142e74029f$var$linkAnalytics,
        elemBefore: assetsIcon,
        elemAfter: openExternalLinkIcon,
        actionsOnHover: $3f24e1142e74029f$var$actionsOnHover
    }, assetsMessage);
};
$3f24e1142e74029f$var$AssetsExternalLink.displayName = "AssetsExternalLink";
const $3f24e1142e74029f$export$a04ba1c400e85b23 = ({ configurableMenuId: configurableMenuId, lozengeText: lozengeText })=>{
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    // The Drawer reads `document` on render, which is unsafe during SSR. Behind
    // assets-platform-landing-page (which surfaces this upsell in SSR-rendered nav) defer mounting it
    // until the client is ready; otherwise keep the prior always-mounted behaviour.
    const isClientReady = (0, $b9Jox.useIsClientReady)();
    const canRenderDrawer = !(0, $i860n.fg)('assets-platform-landing-page') || isClientReady;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const configurableMessageIcon = configurableMenuId ?? (0, $6GljB.L1_MENU_ID).ASSETS;
    const { formattedMessage: assetsMessage, icon: assetsIcon } = (0, $dx7aH.useConfigurableMessageAndIconMap)(configurableMessageIcon);
    const upsellText = lozengeText ?? formatMessage($3f24e1142e74029f$var$upsellLozengeText);
    const handleClose = (0, $euxye.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jVPlr.default), {
        elemBefore: assetsIcon,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.upsell-lozenge",
            appearance: "discovery"
        }, upsellText),
        analytics: $3f24e1142e74029f$var$upsellButtonAnalytics,
        onClick: ()=>{
            setIsOpen(true);
        },
        actionsOnHover: configurableMessageIcon === (0, $6GljB.L1_MENU_ID).ASSETS ? $3f24e1142e74029f$var$actionsOnHover : null,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.nav-4-menu-button-item"
    }, assetsMessage), canRenderDrawer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l6OQo.default), {
        isOpen: isOpen,
        onClose: handleClose,
        width: "full",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.drawer",
        label: assetsMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e10q0.DrawerSidebar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4CTxE.DrawerCloseButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fyJ3d.DrawerContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9XYjM.AsyncCmdbUpsellPage), null))));
};
$3f24e1142e74029f$export$a04ba1c400e85b23.displayName = "AssetsUpsellButton";
const $3f24e1142e74029f$export$5803e5f720bc19ab = ({ showUpsell: showUpsell })=>{
    if (showUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3f24e1142e74029f$export$a04ba1c400e85b23, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3f24e1142e74029f$var$AssetsExternalLink, null);
};
$3f24e1142e74029f$export$5803e5f720bc19ab.displayName = "AssetsAppItem";

});
parcelRegister("9XYjM", function(module, exports) {
$parcel$export(module.exports, "AsyncCmdbUpsellPage", () => $9a841ce4b3dddaa3$export$659eb30d49d6ed87);

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9a841ce4b3dddaa3$var$LazyCmdbUpsellPage = (0, $l8G1z.lazy)(()=>(parcelRequire("jX0al")).then((module)=>module.UpsellPage), {
    moduleId: "./src/packages/servicedesk/cmdb-upsell-page/src/UpsellPage.tsx"
});
const $9a841ce4b3dddaa3$export$659eb30d49d6ed87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "cmdb-upsell-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9a841ce4b3dddaa3$var$LazyCmdbUpsellPage, null));
$9a841ce4b3dddaa3$export$659eb30d49d6ed87.displayName = "AsyncCmdbUpsellPage";

});
parcelRegister("jX0al", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8stAx").then(()=>parcelRequire('akD60'));

});


parcelRegister("jVPlr", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c999cc1711b7dae$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $7Cd1x = parcelRequire("7Cd1x");

var $1Io8b = parcelRequire("1Io8b");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
const $9c999cc1711b7dae$var$ButtonMenuItemWithAnalytics = ({ analytics: analytics, onClick: onClick, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const stableAnalytics = (0, $7Cd1x.useShallowStableReference)(analytics);
    const handleClick = (0, $euxye.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (!stableAnalytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = stableAnalytics;
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), actionSubjectId, analyticsAttributes);
    }, [
        stableAnalytics,
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1Io8b.ButtonMenuItem), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
};
$9c999cc1711b7dae$var$ButtonMenuItemWithAnalytics.displayName = "ButtonMenuItemWithAnalytics";
const $9c999cc1711b7dae$var$ButtonMenuItemWithAnalyticsForwarded = /*#__PURE__*/ (0, $euxye.forwardRef)($9c999cc1711b7dae$var$ButtonMenuItemWithAnalytics);
var $9c999cc1711b7dae$export$2e2bcd8739ae039 = $9c999cc1711b7dae$var$ButtonMenuItemWithAnalyticsForwarded;

});

parcelRegister("l6OQo", function(module, exports) {
$parcel$export(module.exports, "Drawer", () => $22be6b11ab43e2f8$export$4071300121a182f5);
$parcel$export(module.exports, "default", () => $22be6b11ab43e2f8$export$4071300121a182f5);
/// <reference types="node" />
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $kt9Lz = parcelRequire("kt9Lz");

var $aZBDA = parcelRequire("aZBDA");

var $fLi8o = parcelRequire("fLi8o");

var $g54uT = parcelRequire("g54uT");

var $iqfTZ = parcelRequire("iqfTZ");

var $5PG2M = parcelRequire("5PG2M");

var $4oqVa = parcelRequire("4oqVa");

var $1EOHp = parcelRequire("1EOHp");

var $6yD0E = parcelRequire("6yD0E");
// escape close manager for layering
const $22be6b11ab43e2f8$var$EscapeCloseManager = ({ onClose: onClose })=>{
    // wrap so that we can cast the event to a React.KeyboardEvent
    const handleClose = (0, $euxye.useCallback)((evt)=>{
        onClose && onClose(evt);
    }, [
        onClose
    ]);
    (0, $g54uT.useCloseOnEscapePress)({
        onClose: handleClose
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {});
};
$22be6b11ab43e2f8$var$EscapeCloseManager.displayName = "EscapeCloseManager";
const $22be6b11ab43e2f8$var$DrawerBase = ({ width: width = 'narrow', isOpen: isOpen, isFocusLockEnabled: isFocusLockEnabled = true, shouldReturnFocus: shouldReturnFocus = true, autoFocusFirstElem: autoFocusFirstElem = true, onKeyDown: onKeyDown, testId: testId, children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, zIndex: zIndex = 'unset', label: label, titleId: titleId, enterFrom: enterFrom })=>{
    const handleClose = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'escKey'
        }
    });
    const handleKeyDown = (0, $euxye.useCallback)((evt)=>{
        onKeyDown && onKeyDown(evt);
    }, [
        onKeyDown
    ]);
    (0, $euxye.useEffect)(()=>{
        if (isOpen) window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleKeyDown,
        isOpen
    ]);
    const handleBlanketClick = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'blanket'
        }
    });
    const handleBackButtonClick = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'backButton'
        }
    });
    const body = (0, $kt9Lz.canUseDOM) ? document.querySelector('body') : undefined;
    if (!body) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $5PG2M.default), {
        zIndex: zIndex,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4oqVa.default), {
                isOpen: isOpen,
                onBlanketClicked: handleBlanketClick,
                testId: testId && `${testId}--blanket`
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1EOHp.DrawerPanel), {
                testId: testId,
                isOpen: isOpen,
                onClose: handleBackButtonClick,
                onCloseComplete: onCloseComplete,
                onOpenComplete: onOpenComplete,
                width: width,
                enterFrom: enterFrom,
                label: label,
                titleId: titleId,
                autoFocusFirstElem: autoFocusFirstElem,
                isFocusLockEnabled: isFocusLockEnabled,
                shouldReturnFocus: shouldReturnFocus,
                children: isOpen ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $fLi8o.Layering), {
                    isDisabled: false,
                    children: [
                        children,
                        /*#__PURE__*/ (0, $e79Pd.jsx)($22be6b11ab43e2f8$var$EscapeCloseManager, {
                            onClose: handleClose
                        })
                    ]
                }) : children
            })
        ]
    });
};
$22be6b11ab43e2f8$var$DrawerBase.displayName = "DrawerBase";
const $22be6b11ab43e2f8$export$4071300121a182f5 = (props)=>{
    if ((0, $iqfTZ.fg)('platform-dst-top-layer')) // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- internal implementation component takes the same DrawerProps
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6yD0E.DrawerTopLayer), {
        ...props
    });
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- internal implementation component takes the same DrawerProps
    return /*#__PURE__*/ (0, $e79Pd.jsx)($22be6b11ab43e2f8$var$DrawerBase, {
        ...props
    });
};
$22be6b11ab43e2f8$export$4071300121a182f5.displayName = "Drawer";

});
parcelRegister("4oqVa", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f9bcdd54fee8283$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");
parcelRequire("euxye");

var $zLbDw = parcelRequire("zLbDw");

var $8L2z6 = parcelRequire("8L2z6");
var $eCdE8 = parcelRequire("eCdE8");
const $3f9bcdd54fee8283$var$styles = {
    blanket: "_kqswh2mm"
};
/**
 * A wrapper around `@atlaskit/blanket` that adds a fade in/out transition.
 */ const $3f9bcdd54fee8283$var$Blanket = ({ isOpen: isOpen, onBlanketClicked: onBlanketClicked, testId: testId })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eCdE8.default), {
            /*
     * The fade out animation uses half the passed duration so it evens out.
     */ duration: "large",
            /**
     * We don't expose this on `FadeIn` but it does get passed down.
     * TODO: figure out how we want to handle this...
     */ // @ts-ignore
            animationTimingFunction: "ease-out",
            children: ({ className: className })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $3f9bcdd54fee8283$var$styles.blanket,
                        className
                    ]),
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $zLbDw.default), {
                        isTinted: true,
                        onBlanketClicked: onBlanketClicked,
                        testId: testId && testId
                    })
                })
        })
    });
};
$3f9bcdd54fee8283$var$Blanket.displayName = "Blanket";
var $3f9bcdd54fee8283$export$2e2bcd8739ae039 = $3f9bcdd54fee8283$var$Blanket;

});

parcelRegister("1EOHp", function(module, exports) {
$parcel$export(module.exports, "DrawerPanel", () => $fa7ef3c0645aee73$export$96114a266f19b4d0);
/* drawer-panel.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $8L2z6 = parcelRequire("8L2z6");
var $5kyyj = parcelRequire("5kyyj");

var $3TZRG = parcelRequire("3TZRG");

var $1u2qL = parcelRequire("1u2qL");

var $8Pzuw = parcelRequire("8Pzuw");
const $fa7ef3c0645aee73$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $fa7ef3c0645aee73$var$styles = {
    root: "_1reo15vq _18m915vq _1e0c1txw _4t3i1kxc _kqsw1n9t _1pbybfng _bfhk1bhr _1q1l1bhr _152tze3t _1e02ze3t _ect4ttxp",
    full: "_1bsbauwl",
    extended: "_1bsb1mwr",
    narrow: "_1bsb1gwv",
    medium: "_1bsb1y37",
    wide: "_1bsb1ogm"
}; /**
    * This wrapper is used to specify separate durations for enter and exit.
    */ 
const $fa7ef3c0645aee73$var$CustomSlideIn = ({ children: children, onFinish: onFinish, enterFrom: enterFrom })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5kyyj.default), {
        animationTimingFunction: "ease-out",
        duration: "small",
        enterFrom: enterFrom,
        exitTo: enterFrom,
        fade: "none",
        onFinish: onFinish,
        children: children
    });
}; /**
    * __Drawer panel__
    */ 
$fa7ef3c0645aee73$var$CustomSlideIn.displayName = "CustomSlideIn";
const $fa7ef3c0645aee73$export$96114a266f19b4d0 = ({ children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, testId: testId, isOpen: isOpen, shouldReturnFocus: shouldReturnFocus, autoFocusFirstElem: autoFocusFirstElem, isFocusLockEnabled: isFocusLockEnabled, width: width = 'narrow', label: label, titleId: titleId, enterFrom: enterFrom = 'left' })=>{
    /**
   * A ref to point to our wrapper, passed to `onCloseComplete` and `onOpenComplete` callbacks.
   */ const drawerRef = (0, $euxye.useRef)(null);
    const onFinish = (0, $euxye.useCallback)((state)=>{
        if (state === 'entering') onOpenComplete?.(drawerRef.current);
        else if (state === 'exiting') onCloseComplete?.(drawerRef.current);
    }, [
        onCloseComplete,
        onOpenComplete
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $e79Pd.jsx)($fa7ef3c0645aee73$var$CustomSlideIn, {
            onFinish: onFinish,
            enterFrom: enterFrom,
            children: ({ className: className })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Pzuw.default), {
                    autoFocusFirstElem: autoFocusFirstElem,
                    isFocusLockEnabled: isFocusLockEnabled,
                    shouldReturnFocus: shouldReturnFocus,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    , {
                        className: (0, $4jQY2.default)([
                            $fa7ef3c0645aee73$var$styles.root,
                            $fa7ef3c0645aee73$var$styles[width],
                            className
                        ]),
                        "data-testid": testId,
                        ref: drawerRef,
                        "aria-modal": true,
                        role: "dialog",
                        "aria-label": label,
                        "aria-labelledby": titleId,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3TZRG.EnsureIsInsideDrawerContext).Provider, {
                            value: true,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1u2qL.OnCloseContext).Provider, {
                                value: onClose,
                                children: children
                            })
                        })
                    })
                })
        })
    });
};
$fa7ef3c0645aee73$export$96114a266f19b4d0.displayName = "DrawerPanel";

});
parcelRegister("3TZRG", function(module, exports) {
$parcel$export(module.exports, "EnsureIsInsideDrawerContext", () => $83bace1627bcfb65$export$e3662b8677049786);

var $euxye = parcelRequire("euxye");
const $83bace1627bcfb65$export$e3662b8677049786 = /*#__PURE__*/ (0, $euxye.createContext)(false);

});

parcelRegister("1u2qL", function(module, exports) {
$parcel$export(module.exports, "OnCloseContext", () => $9c3a2c0b3408e9cc$export$7376ab1fc7707bdd);

var $euxye = parcelRequire("euxye");
const $9c3a2c0b3408e9cc$export$7376ab1fc7707bdd = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});

parcelRegister("8Pzuw", function(module, exports) {
$parcel$export(module.exports, "default", () => $3aa7794a9d82fd9e$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $g6TgS = parcelRequire("g6TgS");
/**
 * __Focus lock__
 *
 * Thin wrapper around react-focus-lock.
 */ const $3aa7794a9d82fd9e$var$FocusLock = ({ isFocusLockEnabled: isFocusLockEnabled = true, autoFocusFirstElem: autoFocusFirstElem = true, shouldReturnFocus: shouldReturnFocus = true, children: children })=>{
    const getFocusTarget = ()=>{
        if (typeof shouldReturnFocus === 'boolean') return shouldReturnFocus;
        return false;
    };
    const onDeactivation = ()=>{
        if (typeof shouldReturnFocus !== 'boolean') window.setTimeout(()=>{
            shouldReturnFocus?.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g6TgS.default), {
        disabled: !isFocusLockEnabled,
        autoFocus: autoFocusFirstElem,
        returnFocus: getFocusTarget(),
        onDeactivation: onDeactivation,
        children: children
    });
};
$3aa7794a9d82fd9e$var$FocusLock.displayName = "FocusLock";
var $3aa7794a9d82fd9e$export$2e2bcd8739ae039 = $3aa7794a9d82fd9e$var$FocusLock;

});


parcelRegister("6yD0E", function(module, exports) {
$parcel$export(module.exports, "DrawerTopLayer", () => $6dcb44a1854b4fb3$export$fe644b936906c1c3);
/* drawer-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $glbdM = parcelRequire("glbdM");

var $aZBDA = parcelRequire("aZBDA");

var $dTWzO = parcelRequire("dTWzO");
var $l5WnI = parcelRequire("l5WnI");

var $4syWN = parcelRequire("4syWN");

var $3TZRG = parcelRequire("3TZRG");

var $1u2qL = parcelRequire("1u2qL");
const $6dcb44a1854b4fb3$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $6dcb44a1854b4fb3$var$slideInKeyframes = null;
const $6dcb44a1854b4fb3$var$slideOutKeyframes = null;
const $6dcb44a1854b4fb3$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _152tidpf _1e02idpf _rjxp1wug _4t3i1496 _p12fauwl",
    enter: "_j7hqntq4",
    exit: "_j7hqcljl",
    surface: "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _4t3i1osq _bfhk1bhr _1q1l1bhr _ect4ttxp"
};
const $6dcb44a1854b4fb3$var$widthStyles = {
    narrow: "_1bsb1gwv",
    medium: "_1bsb1y37",
    wide: "_1bsb1ogm",
    extended: "_1bsb1mwr",
    full: "_1bsbauwl"
};
const $6dcb44a1854b4fb3$var$enterFromStyles = {
    left: "_1s8jpwvu _1c2rf1ug",
    right: "_1s8j1osq _1c2rf1ug",
    top: "_1s8jf1ug _1c2rpwvu",
    bottom: "_1s8jf1ug _1c2r1osq"
}; /**
    * Resolve the native `<dialog>` accessible name props. Prefer the consumer's
    * `label`, then their `titleId`. If neither is supplied (legacy allowed this),
    * fall back to a generic name so the dialog is never unlabelled. Note:
    * `@atlaskit/drawer` has no i18n setup, so this fallback is English only;
    * consumers should pass a localised `label` or `titleId`.
    */ 
function $6dcb44a1854b4fb3$var$getAccessibleName({ label: label, titleId: titleId }) {
    if (label) return {
        label: label
    };
    if (titleId) return {
        labelledBy: titleId
    };
    return {
        label: 'Drawer'
    };
} /**
   * **DrawerTopLayer**
   *
   * Top-layer (`platform-dst-top-layer`) implementation of `Drawer`. Renders a
   * native `<dialog>` via `@atlaskit/top-layer`, replacing Portal, Blanket,
   * react-focus-lock, react-scrolllock and `@atlaskit/layering` with native
   * modality, `::backdrop`, focus trap and return, and `DialogScrollLock`.
   *
   * The `Dialog` primitive owns the entry and exit animation lifecycle (it keeps
   * the host element mounted through the exit transition, then fires
   * `onExitFinish`), so no `ExitingPersistence` wrapper is needed: the drawer
   * renders `<Dialog isOpen={isOpen}>` directly. `useDrawerStack` tracks stack
   * depth so only the foreground drawer shows a `::backdrop`.
   *
   * `isFocusLockEnabled` is intentionally unsupported: a native modal `<dialog>`
   * always traps focus, so `isFocusLockEnabled={false}` is a no-op under this gate.
   */ 
function $6dcb44a1854b4fb3$export$fe644b936906c1c3({ width: width = 'narrow', isOpen: isOpen, shouldReturnFocus: shouldReturnFocus = true, onKeyDown: onKeyDown, testId: testId, children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, titleId: titleId, enterFrom: enterFrom = 'left' }) {
    /**
   * Points to the panel surface. Passed to `onOpenComplete` / `onCloseComplete`.
   */ const contentRef = (0, $euxye.useRef)(null); // Cache the last content element so `onCloseComplete` still receives a node
    // after children unmount (with reduced motion `contentRef` can clear before
    // `onExitFinish` fires).
    const lastContentElRef = (0, $euxye.useRef)(null); // Callback ref runs at commit (not during render), so both refs stay
    // populated without a render-time side effect. `lastContentElRef` only
    // overwrites with a non-null node, preserving it across the unmount.
    const setContentEl = (0, $euxye.useCallback)((el)=>{
        contentRef.current = el;
        if (el) lastContentElRef.current = el;
    }, []); // Analytics-wrapped close handlers, one per legacy trigger.
    const handleEscapeClose = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'escKey'
        }
    });
    const handleBlanketClose = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'blanket'
        }
    });
    const handleBackButtonClose = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'backButton'
        }
    }); // Bridge the Dialog primitive's `onClose({ reason })` to the legacy
    // `onClose(event, analyticsEvent)` contract via a synthetic event. Drawer
    // has no `shouldCloseOn*` props, so both reasons always forward.
    const handleDialogClose = (0, $euxye.useCallback)(({ reason: reason })=>{
        const event = (0, $dTWzO.createCloseEvent)({
            reason: reason
        });
        if (reason === 'escape') handleEscapeClose(event);
        else handleBlanketClose(event);
    }, [
        handleEscapeClose,
        handleBlanketClose
    ]); // Mirror the legacy window `keydown` listener so `onKeyDown` still fires
    // while the drawer is open.
    const handleKeyDown = (0, $euxye.useCallback)((evt)=>{
        onKeyDown?.(evt);
    }, [
        onKeyDown
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isOpen) return;
        return (0, $glbdM.bind)(window, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        isOpen,
        handleKeyDown
    ]); // `onOpenComplete` once the entry animation settles (via `Dialog`'s
    // `onEnterFinish`, which the underlying hook fires for animated,
    // non-animated and reduced-motion paths).
    const handleEnterFinish = (0, $euxye.useCallback)(()=>{
        onOpenComplete?.(contentRef.current);
    }, [
        onOpenComplete
    ]); // `onCloseComplete` once the exit animation settles (via `Dialog`'s
    // `onExitFinish`). This is also where a custom `shouldReturnFocus={ref}` is
    // honoured: native `<dialog>` restores focus to the trigger at the start of
    // close, so the consumer's ref is focused now that the exit is done.
    // `shouldReturnFocus={false}` is a documented best-effort limitation; native
    // always restores focus to the trigger.
    const handleExitFinish = (0, $euxye.useCallback)(()=>{
        onCloseComplete?.(contentRef.current ?? lastContentElRef.current);
        lastContentElRef.current = null;
        if (typeof shouldReturnFocus === 'object' && shouldReturnFocus?.current) shouldReturnFocus.current.focus();
    }, [
        onCloseComplete,
        shouldReturnFocus
    ]);
    const accessibleName = $6dcb44a1854b4fb3$var$getAccessibleName({
        label: label,
        titleId: titleId
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $l5WnI.Dialog), {
        isOpen: isOpen,
        onClose: handleDialogClose,
        onEnterFinish: handleEnterFinish,
        onExitFinish: handleExitFinish,
        shouldAnimate: true,
        xcss: (0, $9S1b6.cx)($6dcb44a1854b4fb3$var$styles.root, $6dcb44a1854b4fb3$var$widthStyles[width], $6dcb44a1854b4fb3$var$enterFromStyles[enterFrom]),
        enteringAnimationXcss: $6dcb44a1854b4fb3$var$styles.enter,
        exitingAnimationXcss: $6dcb44a1854b4fb3$var$styles.exit,
        testId: testId,
        ...accessibleName,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4syWN.DialogScrollLock), {
                isOpen: true
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                ref: setContentEl,
                className: (0, $4jQY2.default)([
                    $6dcb44a1854b4fb3$var$styles.surface
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3TZRG.EnsureIsInsideDrawerContext).Provider, {
                    value: true,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1u2qL.OnCloseContext).Provider, {
                        value: handleBackButtonClose,
                        children: children
                    })
                })
            })
        ]
    });
}
$6dcb44a1854b4fb3$export$fe644b936906c1c3.displayName = "DrawerTopLayer";

});


parcelRegister("e10q0", function(module, exports) {
$parcel$export(module.exports, "DrawerSidebar", () => $0ba544898c535158$export$25c48648e7980210);
/* drawer-sidebar.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $eYpfY = parcelRequire("eYpfY");
const $0ba544898c535158$var$styles = {
    default: "_4cvr1h6o _vchhusvi _syazazsu _1e0c1txw _1o9zidpf _2lx21bp4 _4t3i1kxc _85i5pxbi _1q511ejb _1bsbxncg"
};
const $0ba544898c535158$export$25c48648e7980210 = ({ children: children, xcss: xcss })=>{
    (0, $eYpfY.useEnsureIsInsideDrawer)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $0ba544898c535158$var$styles.default,
            xcss
        ]),
        "data-testid": "drawer-sidebar",
        children: children
    });
};
$0ba544898c535158$export$25c48648e7980210.displayName = "DrawerSidebar";

});
parcelRegister("eYpfY", function(module, exports) {
$parcel$export(module.exports, "useEnsureIsInsideDrawer", () => $4df8de78c9a1d407$export$780b9799f6bfecd8);

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");

var $3TZRG = parcelRequire("3TZRG");
const $4df8de78c9a1d407$export$780b9799f6bfecd8 = ()=>{
    const context = (0, $euxye.useContext)((0, $3TZRG.EnsureIsInsideDrawerContext));
    (0, $jiTLE.default)(context, 'Drawer sub-components must be used within a Drawer component.');
};

});


parcelRegister("fyJ3d", function(module, exports) {
$parcel$export(module.exports, "DrawerContent", () => $236d03e4326b5c61$export$57ca055474bc0056);
/* drawer-content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $jr1Vl = parcelRequire("jr1Vl");

var $50OIz = parcelRequire("50OIz");

var $iqfTZ = parcelRequire("iqfTZ");

var $eYpfY = parcelRequire("eYpfY");

var $lcARw = parcelRequire("lcARw");
const $236d03e4326b5c61$var$styles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug _19pk1ejb"
};
const $236d03e4326b5c61$var$DrawerContentBase = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, scrollContentLabel: scrollContentLabel = 'Scrollable content', xcss: xcss }, scrollableRef)=>{
    const [showContentFocus, setContentFocus] = (0, $euxye.useState)(false);
    const ref = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        const setLazyContentFocus = ()=>{
            const target = ref.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        };
        setLazyContentFocus();
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $236d03e4326b5c61$var$styles.default,
            xcss
        ]),
        ref: (0, $50OIz.mergeRefs)([
            ref,
            scrollableRef
        ]),
        // tabindex is allowed here so that keyboard users can scroll content
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? scrollContentLabel : undefined,
        "data-testid": "drawer-contents",
        children: children
    });
});
const $236d03e4326b5c61$export$57ca055474bc0056 = ({ children: children, scrollContentLabel: scrollContentLabel, xcss: xcss })=>{
    (0, $eYpfY.useEnsureIsInsideDrawer)();
    (0, $lcARw.default)();
    const content = /*#__PURE__*/ (0, $e79Pd.jsx)($236d03e4326b5c61$var$DrawerContentBase, {
        scrollContentLabel: scrollContentLabel,
        xcss: xcss,
        children: children
    });
    // Under the top-layer flag, background scroll is handled by `DialogScrollLock`
    // (rendered by `DrawerTopLayer`), so we skip `react-scrolllock` here to avoid
    // double-locking the body. See the top-layer migration scroll decision.
    if ((0, $iqfTZ.fg)('platform-dst-top-layer')) return content;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jr1Vl))), {
        children: content
    });
};
$236d03e4326b5c61$export$57ca055474bc0056.displayName = "DrawerContent";

});
parcelRegister("lcARw", function(module, exports) {
$parcel$export(module.exports, "default", () => $be4c93ddac53d205$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $iqfTZ = parcelRequire("iqfTZ");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 * ⚠️ This is copied from `packages/design-system/modal-dialog/src/internal/hooks/use-prevent-programmatic-scroll.tsx`
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $be4c93ddac53d205$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $be4c93ddac53d205$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $euxye.useState)(0);
    (0, $euxye.useLayoutEffect)(()=>{
        setScrollTopOffset($be4c93ddac53d205$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $euxye.useCallback)(()=>{
        if ($be4c93ddac53d205$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $euxye.useEffect)(()=>{
        // The top-layer drawer relies on native modality + `DialogScrollLock`; the
        // programmatic-scroll guard is intentionally dropped under the flag.
        if ((0, $iqfTZ.fg)('platform-dst-top-layer')) return;
        return (0, $glbdM.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("4CTxE", function(module, exports) {
$parcel$export(module.exports, "DrawerCloseButton", () => $e640051cc21f6b1b$export$d0c3a75c17ac0cab);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $6JMJ2 = parcelRequire("6JMJ2");

var $eYpfY = parcelRequire("eYpfY");

var $8JVZz = parcelRequire("8JVZz");
const $e640051cc21f6b1b$export$d0c3a75c17ac0cab = ({ icon: Icon, label: label = 'Close drawer', testId: testId = 'DrawerCloseButton' })=>{
    (0, $eYpfY.useEnsureIsInsideDrawer)();
    const onClose = (0, $8JVZz.useOnClose)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
        onClick: onClose,
        testId: testId,
        icon: Icon ? (iconProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
                ...iconProps,
                size: "large"
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($6JMJ2))),
        label: label,
        shape: "circle",
        appearance: "subtle"
    });
};
$e640051cc21f6b1b$export$d0c3a75c17ac0cab.displayName = "DrawerCloseButton";

});
parcelRegister("8JVZz", function(module, exports) {
$parcel$export(module.exports, "useOnClose", () => $fed5ed966a5d1fa7$export$c2b12c82f332a6fb);

var $euxye = parcelRequire("euxye");

var $1u2qL = parcelRequire("1u2qL");
const $fed5ed966a5d1fa7$export$c2b12c82f332a6fb = ()=>(0, $euxye.useContext)((0, $1u2qL.OnCloseContext));

});




parcelRegister("2zFZk", function(module, exports) {
$parcel$export(module.exports, "CustomerService", () => $24df2237e4874967$export$5c26f0ffd7a4820d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $gDdYI = parcelRequire("gDdYI");

var $3IPdZ = parcelRequire("3IPdZ");
const $24df2237e4874967$export$5c26f0ffd7a4820d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-customer-service"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "flag",
        id: "assets",
        packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCustomerService",
        teamName: "Boysenberry"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3IPdZ.CustomerExperiencesMenuItem), props)));
$24df2237e4874967$export$5c26f0ffd7a4820d.displayName = "CustomerService";

});
parcelRegister("3IPdZ", function(module, exports) {
$parcel$export(module.exports, "CustomerExperiencesMenuItem", () => $68db95018aa013cc$export$bbaea2d3cbc89c32);

var $euxye = parcelRequire("euxye");

var $2nex5 = parcelRequire("2nex5");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $4VtOS = parcelRequire("4VtOS");

var $dx7aH = parcelRequire("dx7aH");

var $jzXAj = parcelRequire("jzXAj");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $k6ufm = parcelRequire("k6ufm");

var $fNgVF = parcelRequire("fNgVF");

var $j7fit = parcelRequire("j7fit");

var $1dpwK = parcelRequire("1dpwK");
const $68db95018aa013cc$export$bbaea2d3cbc89c32 = (props)=>{
    const { draggableRef: draggableRef, dropIndicator: dropIndicator, hasDragIndicator: hasDragIndicator, isDragging: isDragging, visualContentRef: visualContentRef, onExpandFlyoutToggle: onExpandFlyoutToggle } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE);
    const ref = draggableRef;
    const [hasLoadedContent, setHasLoadedContent] = (0, $euxye.useState)(false);
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const { data: queryReference, loading: loading, error: error, refresh: refresh } = (0, $k6ufm.useResource)((0, $2nex5.customerExperiencesNavigationResource));
    const handleSystemToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            setHasLoadedContent(true);
            if (!queryReference && !loading && !error) refresh();
        }
    }, [
        queryReference,
        loading,
        error,
        refresh
    ]);
    const handleExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            setHasLoadedContent(true);
            if (!queryReference && !loading && !error) refresh();
        }
        onExpandFlyoutToggle?.(hasExpanded);
    }, [
        onExpandFlyoutToggle,
        queryReference,
        loading,
        error,
        refresh
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        dropTargetRef: visualContentRef,
        dropIndicator: dropIndicator,
        isDragging: isDragging,
        menuId: (0, $5IkoH.MENU_ID_CUSTOMER_SERVICE),
        onSystemToggle: handleSystemToggle,
        onExpansionToggle: handleExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        actionsOnHover: isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1dpwK.CreateExperienceButton), null) : undefined,
        "aria-label": formattedMessage,
        elemBefore: icon,
        hasDragIndicator: hasDragIndicator,
        interactionName: "nav4-sidebar-customer-service",
        isDragging: isDragging,
        ref: ref,
        testId: (0, $jzXAj.getTestId)((0, $5IkoH.MENU_ID_CUSTOMER_SERVICE))
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, hasLoadedContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j7fit.CustomerExperiencesExpandableMenu), {
        queryReference: queryReference
    })));
};
$68db95018aa013cc$export$bbaea2d3cbc89c32.displayName = "CustomerExperiencesMenuItem";

});
parcelRegister("2nex5", function(module, exports) {
$parcel$export(module.exports, "customerExperiencesNavigationResource", () => $14757851748a2bcc$export$7abebfa98e3c8a6d);

var $htsFl = parcelRequire("htsFl");

var $21xuP = parcelRequire("21xuP");
const $14757851748a2bcc$export$7abebfa98e3c8a6d = (0, $htsFl.createRelayResource)({
    type: 'CUSTOMER_EXPERIENCES_NAVIGATION_RESOURCE',
    getQuery (_routerContext, { tenantContext: { cloudId: cloudId, activationId: activationId } }) {
        return {
            parameters: (0, $21xuP.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudId: cloudId,
                workspaceAri: `ari:cloud:jira:${cloudId}:workspace/${activationId}`
            }
        };
    }
});

});
parcelRegister("21xuP", function(module, exports) {
$parcel$export(module.exports, "default", () => $603a8db457da192d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e6a6f3676cb7170d216f4a85a1fff043>>
 * @relayHash f9b1ea1a3ae84104acb695f184353f7a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9d25d292a81cd43d7f2e30b059cfb66ff3c67a1611301e5844916e368344d615
const $603a8db457da192d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workspaceAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 5
        },
        {
            "kind": "Literal",
            "name": "sortOrder",
            "value": "CREATED_DATE_DESCENDING"
        },
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "workspaceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CustomerExperiencesListQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "HelpCenterQueryApi",
                        "kind": "LinkedField",
                        "name": "helpCenter",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "HelpCenterQueryResultConnection",
                                    "kind": "LinkedField",
                                    "name": "customerExperiences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterQueryResultEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW"
                                                                },
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "FragmentSpread",
                                                                    "name": "CustomerExperienceMenuContent_helpCenter"
                                                                }
                                                            ],
                                                            "type": "HelpCenter"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CustomerExperiencesListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "customerExperiences",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "HelpCenterName",
                                                            "kind": "LinkedField",
                                                            "name": "name",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "default"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hoistedProjectKey"
                                                        }
                                                    ],
                                                    "type": "HelpCenter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9d25d292a81cd43d7f2e30b059cfb66ff3c67a1611301e5844916e368344d615",
            "metadata": {},
            "name": "CustomerExperiencesListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$603a8db457da192d$var$node.hash = "335974134dfcd6458237b44dca0c611b";
var $603a8db457da192d$export$2e2bcd8739ae039 = $603a8db457da192d$var$node;

});


parcelRegister("j7fit", function(module, exports) {
$parcel$export(module.exports, "CustomerExperiencesExpandableMenu", () => $b26fc483af029e4e$export$19b0e4edaef6ea64);

var $euxye = parcelRequire("euxye");

var $gEDfa = parcelRequire("gEDfa");

var $djYhH = parcelRequire("djYhH");

var $ar9gx = parcelRequire("ar9gx");

var $6w18e = parcelRequire("6w18e");

var $a8EUd = parcelRequire("a8EUd");

var $e1IYO = parcelRequire("e1IYO");

var $i1bYM = parcelRequire("i1bYM");
const $b26fc483af029e4e$export$19b0e4edaef6ea64 = ({ queryReference: queryReference })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.customer-service.customer-experiences",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), {
            count: 5
        })
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e1IYO.CustomerExperiencesList), {
        queryReference: queryReference
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), {
        count: 5
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $i1bYM.ViewAllExperiencesMenuItem), null));
};
$b26fc483af029e4e$export$19b0e4edaef6ea64.displayName = "CustomerExperiencesExpandableMenu";

});
parcelRegister("e1IYO", function(module, exports) {
$parcel$export(module.exports, "CustomerExperiencesList", () => $11c12abe1324ddc4$export$54813fcfcc38569c);

var $5Bm1v = parcelRequire("5Bm1v");

var $21xuP = parcelRequire("21xuP");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $d78Kw = parcelRequire("d78Kw");

var $ltjnz = parcelRequire("ltjnz");

var $biJuK = parcelRequire("biJuK");

var $8Sdzy = parcelRequire("8Sdzy");

var $5EY0v = parcelRequire("5EY0v");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $kt86l = parcelRequire("kt86l");

var $h3LJR = parcelRequire("h3LJR");

var $8QgKY = parcelRequire("8QgKY");
const $11c12abe1324ddc4$export$54813fcfcc38569c = ({ queryReference: queryReference })=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const match = (0, $d78Kw.useMatch)();
    const routeHelpCenterId = match.params?.helpCenterId;
    const prevHelpCenterIdRef = (0, $euxye.useRef)({
        value: undefined
    });
    const [_isPending, startTransition] = (0, $euxye.useTransition)();
    const queryData = (0, $n67Vb.usePreloadedQuery)((0, $21xuP.default), queryReference);
    const [currentCustomerExperienceData, refetch] = (0, $n67Vb.useRefetchableFragment)((0, $5Bm1v.default), null);
    (0, $euxye.useEffect)(()=>{
        if (routeHelpCenterId && routeHelpCenterId !== prevHelpCenterIdRef.current.value) {
            prevHelpCenterIdRef.current.value = routeHelpCenterId;
            const activeHelpCenterAri = `ari:cloud:help::help-center/${activationId}/${routeHelpCenterId}`;
            startTransition(()=>{
                refetch({
                    cloudId: cloudId,
                    currentCustomerExperienceAri: activeHelpCenterAri,
                    fetchCurrentCustomerExperience: true
                }, {
                    fetchPolicy: 'store-and-network'
                });
            });
        }
    }, [
        routeHelpCenterId,
        cloudId,
        activationId,
        refetch
    ]);
    const allCustomerExperiences = (0, $euxye.useMemo)(()=>{
        const edges = (0, $ltjnz.filterEdges)(queryData?.helpCenter?.customerExperiences?.edges ?? undefined);
        const top5Experiences = edges.filter((edge)=>edge.node.__typename === 'HelpCenter' && edge.node.type === 'CUSTOMER_SERVICE').map((edge)=>edge.node);
        const currentCustomerExperience = currentCustomerExperienceData?.helpCenter?.currentCustomerExperience;
        const allExperiences = [
            ...top5Experiences
        ];
        const currentHelpCenterAri = routeHelpCenterId && `ari:cloud:help::help-center/${activationId}/${routeHelpCenterId}`;
        if (currentHelpCenterAri && currentCustomerExperience?.__typename === 'HelpCenter' && currentCustomerExperience.type === 'CUSTOMER_SERVICE' && currentCustomerExperience.id === currentHelpCenterAri) allExperiences.push(currentCustomerExperience);
        const uniqueExperiences = Array.from(new Map(allExperiences.map((exp)=>[
                exp.id,
                exp
            ])).values());
        return uniqueExperiences;
    }, [
        queryData,
        currentCustomerExperienceData,
        routeHelpCenterId,
        activationId
    ]);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    if (allCustomerExperiences.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $biJuK.EmptyContentMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage($11c12abe1324ddc4$var$emptyExperiencesMessage)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($11c12abe1324ddc4$var$recentlyCreatedHeadingMessage)), allCustomerExperiences.map((experience)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8QgKY.CustomerExperienceMenuContent), {
            key: experience.id,
            helpCenterFragment: experience
        })));
};
$11c12abe1324ddc4$export$54813fcfcc38569c.displayName = "CustomerExperiencesList";
const $11c12abe1324ddc4$var$emptyExperiencesMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experiences-list.empty-experiences",
    defaultMessage: "Any customer experience you get access to will show up here."
});
const $11c12abe1324ddc4$var$recentlyCreatedHeadingMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experiences-expandable-menu.recently-created",
    defaultMessage: "Recently created"
});

});
parcelRegister("5Bm1v", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6598725c8fb1b64$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<57a0638f1a301a871d29175057bed2b7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $g3NVD = parcelRequire("g3NVD");
const $a6598725c8fb1b64$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentCustomerExperienceAri"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "fetchCurrentCustomerExperience"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $g3NVD.default)
        }
    },
    "name": "CustomerExperiencesList_currentCustomerExperience",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "HelpCenterQueryApi",
                "kind": "LinkedField",
                "name": "helpCenter",
                "plural": false,
                "selections": [
                    {
                        "condition": "fetchCurrentCustomerExperience",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "alias": "currentCustomerExperience",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "helpCenterAri",
                                        "variableName": "currentCustomerExperienceAri"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "helpCenterById",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                "action": "THROW"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "type"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "CustomerExperienceMenuContent_helpCenter"
                                            }
                                        ],
                                        "type": "HelpCenter"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "action": "THROW"
        }
    ],
    "type": "Query"
};
$a6598725c8fb1b64$var$node.hash = "a6ab31f88287b0373d7a9c77af235b6f";
var $a6598725c8fb1b64$export$2e2bcd8739ae039 = $a6598725c8fb1b64$var$node;

});
parcelRegister("g3NVD", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a14687dca53842d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1436cf83e9b93c8436c8af4db491afd5>>
 * @relayHash 108869bd4c06115f8f9f0ff8c9a127c5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f68c4c7707f381f1c3f0f1a3ee53e89ee13820c668a65595515e57da3f34c65f
const $3a14687dca53842d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentCustomerExperienceAri"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "fetchCurrentCustomerExperience"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CustomerExperiencesListRefetchQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "currentCustomerExperienceAri",
                            "variableName": "currentCustomerExperienceAri"
                        },
                        {
                            "kind": "Variable",
                            "name": "fetchCurrentCustomerExperience",
                            "variableName": "fetchCurrentCustomerExperience"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "CustomerExperiencesList_currentCustomerExperience"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CustomerExperiencesListRefetchQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "fetchCurrentCustomerExperience",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "currentCustomerExperience",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "helpCenterAri",
                                            "variableName": "currentCustomerExperienceAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "concreteType": "HelpCenterName",
                                                    "kind": "LinkedField",
                                                    "name": "name",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "default"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hoistedProjectKey"
                                                }
                                            ],
                                            "type": "HelpCenter"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f68c4c7707f381f1c3f0f1a3ee53e89ee13820c668a65595515e57da3f34c65f",
            "metadata": {},
            "name": "CustomerExperiencesListRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3a14687dca53842d$var$node.hash = "a6ab31f88287b0373d7a9c77af235b6f";
var $3a14687dca53842d$export$2e2bcd8739ae039 = $3a14687dca53842d$var$node;

});


parcelRegister("d78Kw", function(module, exports) {
$parcel$export(module.exports, "useMatch", () => $19eabb74731e3a36$export$6c330e8992e8a295);

var $f2wVS = parcelRequire("f2wVS");
const $19eabb74731e3a36$export$6c330e8992e8a295 = (0, $f2wVS.createRouterSelector)((state)=>state.match);

});

parcelRegister("ltjnz", function(module, exports) {
$parcel$export(module.exports, "filterEdges", () => $9d8677d6f3e406eb$export$a2bec2625e1efa5a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Use me when dealing with paginated data
 * I can filter out the edges that have a defined node
 *
 * @example
 *   const products = filterEdges(productConnections.edges);
 *             ^ { node: { readonly __typename: "CustomerServiceProduct"; } }[]
 */ const $9d8677d6f3e406eb$export$a2bec2625e1efa5a = (edges)=>edges?.filter((edge)=>edge.node !== null && edge.node !== undefined) || [];

});

parcelRegister("biJuK", function(module, exports) {
$parcel$export(module.exports, "EmptyContentMenuItem", () => $a1f1b48ff6ecaa4e$export$1d5b0e5e21ec7e84);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $ar9gx = parcelRequire("ar9gx");
const $a1f1b48ff6ecaa4e$var$styles = {
    box: "_18u01b66"
};
function $a1f1b48ff6ecaa4e$export$1d5b0e5e21ec7e84({ children: children }) {
    return /*#__PURE__*/ $euxye.createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ $euxye.createElement((0, $ihEDU.Box), {
        paddingInline: "space.050",
        xcss: $a1f1b48ff6ecaa4e$var$styles.box
    }, children));
}
$a1f1b48ff6ecaa4e$export$1d5b0e5e21ec7e84.displayName = "EmptyContentMenuItem";

});

parcelRegister("8QgKY", function(module, exports) {
$parcel$export(module.exports, "CustomerExperienceMenuContent", () => $31e896304a6991a5$export$64b59d1ef0398bed);

var $7XyRl = parcelRequire("7XyRl");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $e5ABF = parcelRequire("e5ABF");

var $cfRyQ = parcelRequire("cfRyQ");



var $aQCoC = parcelRequire("aQCoC");

var $4VtOS = parcelRequire("4VtOS");

var $5IkoH = parcelRequire("5IkoH");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $7mzpc = parcelRequire("7mzpc");

var $aNG0w = parcelRequire("aNG0w");

var $cggc1 = parcelRequire("cggc1");

var $f75WD = parcelRequire("f75WD");

var $bgKBB = parcelRequire("bgKBB");

var $10NJr = parcelRequire("10NJr");

var $ahixA = parcelRequire("ahixA");

var $kJM81 = parcelRequire("kJM81");

var $2OHo9 = parcelRequire("2OHo9");

var $2EFuW = parcelRequire("2EFuW");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");

var $inMxE = parcelRequire("inMxE");

var $ivTJy = parcelRequire("ivTJy");

var $1NA92 = parcelRequire("1NA92");

var $9hI8t = parcelRequire("9hI8t");
const $31e896304a6991a5$var$MENU_ID_CUSTOMER_EXPERIENCE_PREFIX = 'customer-experiences-';
const $31e896304a6991a5$export$64b59d1ef0398bed = ({ helpCenterFragment: helpCenterFragment })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const helpCenter = (0, $n67Vb.useFragment)((0, $7XyRl.default), helpCenterFragment);
    const helpCenterId = (0, $ivTJy.HelpHelpCenterAri).parse(helpCenter.id).helpCenterId;
    const projectKey = helpCenter.hoistedProjectKey || '';
    const experienceName = helpCenter.name?.default || formatMessage($31e896304a6991a5$var$defaultExperienceName);
    const [, isGetStartedPageEnabled] = (0, $e5ABF.useIsGetStartedPageEnabled)({
        matchParams: {
            projectKey: projectKey
        }
    });
    if (!helpCenterId || !projectKey) return null;
    const handleItemClick = (itemType)=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: `customerExperience${itemType}`,
            attributes: {
                level: (0, $ef39084c605eb7e8$export$f9db6a58b4aabd18),
                componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
                experienceId: helpCenterId,
                itemType: itemType
            }
        });
    };
    const baseUrl = (0, $i860n.fg)('csm_appification_standalone_navigation') ? `/jira/customer-service-management/experiences/${projectKey}/settings/${helpCenterId}` : `/jira/helpcenter/projects/${projectKey}/settings/${helpCenterId}`;
    const menuId = `${$31e896304a6991a5$var$MENU_ID_CUSTOMER_EXPERIENCE_PREFIX}${projectKey}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        key: helpCenter.id,
        menuId: menuId,
        testId: `customer-experience-expandable-${projectKey.toLowerCase()}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1NA92.NavCustomIcon), {
            helpCenterId: helpCenterId
        }),
        testId: `customer-experience-trigger-${projectKey.toLowerCase()}`,
        interactionName: "nav4-sidebar-customer-experience"
    }, experienceName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, isGetStartedPageEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: `${baseUrl}/get-started`,
        menuId: (0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'get-started'),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7mzpc))), {
            label: "",
            color: "currentColor"
        }),
        onClick: ()=>handleItemClick('GetStarted'),
        testId: `customer-experience-menu-get-started-${projectKey.toLowerCase()}`
    }, formatMessage($31e896304a6991a5$var$getStartedItemMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: `${baseUrl}/details`,
        menuId: (0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'details'),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))), {
            label: "",
            color: "currentColor"
        }),
        onClick: ()=>handleItemClick('Details'),
        testId: `customer-experience-menu-details-${projectKey.toLowerCase()}`
    }, formatMessage($31e896304a6991a5$var$overviewItemMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: `${baseUrl}/forms`,
        menuId: (0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'forms'),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cggc1))), {
            label: "",
            color: "currentColor"
        }),
        onClick: ()=>handleItemClick('Forms'),
        testId: `customer-experience-menu-forms-${projectKey.toLowerCase()}`
    }, formatMessage($31e896304a6991a5$var$formsItemMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: `${baseUrl}/articles`,
        menuId: (0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'articles'),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f75WD))), {
            label: "",
            color: "currentColor"
        }),
        onClick: ()=>handleItemClick('Articles'),
        testId: `customer-experience-menu-articles-${projectKey.toLowerCase()}`
    }, formatMessage($31e896304a6991a5$var$articlesItemMessage)), (0, $i860n.fg)('jcs-global-branding') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: `${baseUrl}/branding`,
        menuId: (0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'branding'),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bgKBB))), {
            label: "",
            color: "currentColor"
        }),
        onClick: ()=>handleItemClick('Branding'),
        testId: `customer-experience-menu-branding-${projectKey.toLowerCase()}`
    }, formatMessage($31e896304a6991a5$var$brandingItemMessage)), (0, $i860n.fg)('csm-omni-channel-live-chat-in-widget') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cfRyQ.JCSOfferingEdition), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: `${baseUrl}/chat`,
        menuId: (0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'chat'),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
            label: "",
            color: "currentColor"
        }),
        onClick: ()=>handleItemClick('Chat'),
        testId: `customer-experience-menu-chat-${projectKey.toLowerCase()}`,
        elemAfter: !(0, $i860n.fg)('csm-omni-hide-beta-lozenge') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
            appearance: "discovery"
        }, formatMessage($31e896304a6991a5$var$betaLozengeMessage)) : undefined
    }, formatMessage($31e896304a6991a5$var$chatItemMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9hI8t.ChannelsExpandableMenuItem), {
        helpCenterId: helpCenterId,
        projectKey: projectKey,
        baseUrl: baseUrl,
        onItemClick: handleItemClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: `${baseUrl}/customer-access`,
        menuId: (0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'customer-access'),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($10NJr))), {
            label: "",
            color: "currentColor"
        }),
        onClick: ()=>handleItemClick('CustomerAccess'),
        testId: `customer-experience-menu-customer-access-${projectKey.toLowerCase()}`
    }, formatMessage($31e896304a6991a5$var$customerAccessItemMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: `${baseUrl}/agent`,
        menuId: (0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'agent'),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ahixA))), {
            label: "",
            color: "currentColor"
        }),
        onClick: ()=>handleItemClick('Agent'),
        testId: `customer-experience-menu-agent-${projectKey.toLowerCase()}`
    }, formatMessage($31e896304a6991a5$var$aiAgentItemMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: `${baseUrl}/customer-notifications`,
        menuId: (0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'customer-notifications'),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2OHo9))), {
            label: "",
            color: "currentColor"
        }),
        onClick: ()=>handleItemClick('CustomerNotifications'),
        testId: `customer-experience-menu-customer-notifications-${projectKey.toLowerCase()}`
    }, formatMessage($31e896304a6991a5$var$customerNotificationsItemMessage))));
};
$31e896304a6991a5$export$64b59d1ef0398bed.displayName = "CustomerExperienceMenuContent";
const $31e896304a6991a5$var$getStartedItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.get-started-item",
    defaultMessage: "Get started"
});
const $31e896304a6991a5$var$defaultExperienceName = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.fallback-customer-experience-name",
    defaultMessage: "Customer experience"
});
const $31e896304a6991a5$var$overviewItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.overview-item",
    defaultMessage: "Overview"
});
const $31e896304a6991a5$var$formsItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.forms-item",
    defaultMessage: "Forms"
});
const $31e896304a6991a5$var$articlesItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.articles-item",
    defaultMessage: "Articles"
});
const $31e896304a6991a5$var$brandingItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.branding-item",
    defaultMessage: "Branding"
});
const $31e896304a6991a5$var$chatItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.chat-item",
    defaultMessage: "Chat"
});
const $31e896304a6991a5$var$customerAccessItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.customer-access-item",
    defaultMessage: "Customer access"
});
const $31e896304a6991a5$var$aiAgentItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.ai-agent-item",
    defaultMessage: "AI agent"
});
const $31e896304a6991a5$var$customerNotificationsItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.customer-notifications-item",
    defaultMessage: "Customer notifications"
});
const $31e896304a6991a5$var$betaLozengeMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.beta-lozenge",
    defaultMessage: "Beta"
});

});
parcelRegister("7XyRl", function(module, exports) {
$parcel$export(module.exports, "default", () => $96303c67670565de$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<591afc1922658f3d1a95583e905152aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $96303c67670565de$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CustomerExperienceMenuContent_helpCenter",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW"
        },
        {
            "concreteType": "HelpCenterName",
            "kind": "LinkedField",
            "name": "name",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "default"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "hoistedProjectKey"
        }
    ],
    "type": "HelpCenter"
};
$96303c67670565de$var$node.hash = "78a9ce0eeb31e4e91283984f1eb24eab";
var $96303c67670565de$export$2e2bcd8739ae039 = $96303c67670565de$var$node;

});

parcelRegister("e5ABF", function(module, exports) {
$parcel$export(module.exports, "useIsGetStartedPageEnabled", () => $956137e7876af877$export$a1e5ee64749f3e61);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $5q5DR = parcelRequire("5q5DR");

var $60cKq = parcelRequire("60cKq");

var $2b39L = parcelRequire("2b39L");

var $d7dm3 = parcelRequire("d7dm3");
const $956137e7876af877$export$a1e5ee64749f3e61 = (customContext)=>{
    const { data: data, loading: projectContextLoading } = (0, $2b39L.useProjectContext)(customContext) || {};
    const { simplified: isSimplified = false, isProjectAdmin: isProjectAdmin } = data || {};
    const { data: isGetStartedPageDisabled, loading: isGetStartedPageDisabledLoading } = (0, $d7dm3.useResourceWithCustomRouterContext)((0, $5q5DR.getStartedPropertyResource), customContext);
    const isJCS = (0, $60cKq.isJCSProjectType)(data?.projectType || '');
    const isDataLoading = projectContextLoading || isGetStartedPageDisabledLoading;
    return (0, $euxye.useMemo)(()=>[
            isDataLoading,
            !isDataLoading ? Boolean(isJCS && isProjectAdmin && !isSimplified && !isGetStartedPageDisabled) : false
        ], [
        isDataLoading,
        isProjectAdmin,
        isSimplified,
        isGetStartedPageDisabled,
        isJCS
    ]);
};

});
parcelRegister("5q5DR", function(module, exports) {
$parcel$export(module.exports, "PROPERTY_KEY", () => $68615b1c3d3e29c8$export$bb10a02fc2feb574);
$parcel$export(module.exports, "getStartedPropertyResource", () => $68615b1c3d3e29c8$export$5c15beabb6f8df9a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $75sVW = parcelRequire("75sVW");
var $4fhEY = parcelRequire("4fhEY");
const $68615b1c3d3e29c8$export$bb10a02fc2feb574 = 'csmGetStartedCustomerExperienceDisabled';
const $68615b1c3d3e29c8$var$getUrl = (projectKey, key)=>`/rest/api/3/project/${projectKey}/properties/${key}`;
const $68615b1c3d3e29c8$export$5c15beabb6f8df9a = (0, $7edbf.createResource)({
    type: 'CUSTOMER_SERVICE_GET_STARTED_PROPERTY_RESOURCE',
    getKey: ({ match: match })=>`customer-service-get-started-property-${match.params.projectKey}`,
    getData: async ({ match: match })=>{
        try {
            return await (0, $4fhEY.default)($68615b1c3d3e29c8$var$getUrl(match.params.projectKey || '', $68615b1c3d3e29c8$export$bb10a02fc2feb574));
        } catch (error) {
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) return false;
            throw error;
        }
    },
    maxAge: 86400000
});

});

parcelRegister("60cKq", function(module, exports) {
$parcel$export(module.exports, "isJCSProjectType", () => $cdfed2dea273ffc6$export$25e1541dd4631818);
$parcel$export(module.exports, "useIsJCSProjectType", () => $cdfed2dea273ffc6$export$b78b0f34fdacd97a);
$parcel$export(module.exports, "isJCSTemplate", () => $cdfed2dea273ffc6$export$afee907b7a66ef2b);

var $f99M0 = parcelRequire("f99M0");

var $lg2Jo = parcelRequire("lg2Jo");
const $cdfed2dea273ffc6$export$25e1541dd4631818 = (projectType)=>projectType === (0, $f99M0.CUSTOMER_SERVICE_PROJECT);
const $cdfed2dea273ffc6$export$4b74a6f22da4a0d2 = (projectType)=>projectType === (0, $f99M0.SERVICE_DESK_PROJECT) || $cdfed2dea273ffc6$export$25e1541dd4631818(projectType);
const $cdfed2dea273ffc6$export$b78b0f34fdacd97a = (projectType)=>$cdfed2dea273ffc6$export$25e1541dd4631818(projectType);
const $cdfed2dea273ffc6$export$927b5354181b3adf = ()=>{
    const { 'initial.project.template.name': initialProjectTemplate } = (0, $lg2Jo.useProjectProperties)([
        'initial.project.template.name'
    ]);
    return initialProjectTemplate === 'com.atlassian.jcs:customer-service-management';
};
const $cdfed2dea273ffc6$export$afee907b7a66ef2b = (template)=>template === 'com.atlassian.jcs:customer-service-management';

});
parcelRegister("lg2Jo", function(module, exports) {
$parcel$export(module.exports, "useProjectProperties", () => $ead6e061fb3b3b6d$export$58be98885c2d686a);
$parcel$export(module.exports, "useInitialProjectTemplate", () => $ead6e061fb3b3b6d$export$fdbcd6f9afee4bb3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $fNVDZ = parcelRequire("fNVDZ");

var $bxhpq = parcelRequire("bxhpq");

var $dAmGh = parcelRequire("dAmGh");

var $XssJM = parcelRequire("XssJM");

var $33SjG = parcelRequire("33SjG");

var $6ZLJT = parcelRequire("6ZLJT");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $i860n = parcelRequire("i860n");

var $flVbB = parcelRequire("flVbB");
const $ead6e061fb3b3b6d$export$d4c72bab9d6cc13a = {};
const $ead6e061fb3b3b6d$var$Store = (0, $5QDqc.createStore)({
    name: 'project-properties',
    initialState: $ead6e061fb3b3b6d$export$d4c72bab9d6cc13a,
    actions: $flVbB.actions
});
const $ead6e061fb3b3b6d$export$eebf791068e870dd = (0, $3h1FP.createHook)($ead6e061fb3b3b6d$var$Store);
const $ead6e061fb3b3b6d$export$58be98885c2d686a = (propertyKeys, projectIdOverride)=>{
    const { data: data } = (0, $XssJM.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const projectId = projectIdOverride !== undefined ? projectIdOverride : data?.id && `${data.id}`;
    const [state, { get: get }] = $ead6e061fb3b3b6d$export$eebf791068e870dd();
    const prevPropertyKeys = (0, $33SjG.usePrevious)(propertyKeys);
    (0, $euxye.useEffect)(()=>{
        if (projectId === undefined) (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraProjectPropertiesServices undefinedProjectId');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(propertyKeys, prevPropertyKeys) && !projectIdOverride) return;
        if (projectId) // oxlint-disable-next-line typescript/consistent-type-assertions
        get(projectId, propertyKeys);
    }, [
        projectId,
        propertyKeys,
        prevPropertyKeys,
        get,
        createAnalyticsEvent,
        projectIdOverride
    ]);
    return projectId !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($dAmGh)))(state[projectId], (_, key)=>(0, (/*@__PURE__*/$parcel$interopDefault($fNVDZ)))(propertyKeys, key)) : {};
};
const $ead6e061fb3b3b6d$var$useProjectPropertiesGated = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('initial-project-template-event-attr'), $ead6e061fb3b3b6d$export$58be98885c2d686a, ()=>({}));
const $ead6e061fb3b3b6d$export$fdbcd6f9afee4bb3 = (overrideProjectId)=>{
    const { 'initial.project.template.name': initialProjectTemplate } = $ead6e061fb3b3b6d$var$useProjectPropertiesGated([
        'initial.project.template.name'
    ], overrideProjectId);
    if ((0, $i860n.fg)('initial-project-template-event-attr')) return initialProjectTemplate;
    return undefined;
};

});
parcelRegister("fNVDZ", function(module, exports) {

var $a2PxD = parcelRequire("a2PxD");

var $dWb9x = parcelRequire("dWb9x");

var $fvHUg = parcelRequire("fvHUg");

var $4NLnC = parcelRequire("4NLnC");

var $3ViT3 = parcelRequire("3ViT3");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b81825895ae4d18e$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $b81825895ae4d18e$var$includes(collection, value, fromIndex, guard) {
    collection = $dWb9x(collection) ? collection : $3ViT3(collection);
    fromIndex = fromIndex && !guard ? $4NLnC(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $b81825895ae4d18e$var$nativeMax(length + fromIndex, 0);
    return $fvHUg(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $a2PxD(collection, value, fromIndex) > -1;
}
module.exports = $b81825895ae4d18e$var$includes;

});
parcelRegister("fvHUg", function(module, exports) {

var $3zZZC = parcelRequire("3zZZC");

var $jOlpf = parcelRequire("jOlpf");

var $czB45 = parcelRequire("czB45");
/** `Object#toString` result references. */ var $b4abcf30138f72fb$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $b4abcf30138f72fb$var$isString(value) {
    return typeof value == 'string' || !$jOlpf(value) && $czB45(value) && $3zZZC(value) == $b4abcf30138f72fb$var$stringTag;
}
module.exports = $b4abcf30138f72fb$var$isString;

});

parcelRegister("3ViT3", function(module, exports) {

var $74lYM = parcelRequire("74lYM");

var $k4FO8 = parcelRequire("k4FO8");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $2db5588cf5bf4dcf$var$values(object) {
    return object == null ? [] : $74lYM(object, $k4FO8(object));
}
module.exports = $2db5588cf5bf4dcf$var$values;

});
parcelRegister("74lYM", function(module, exports) {

var $bTATB = parcelRequire("bTATB");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $5259f4c148d74f06$var$baseValues(object, props) {
    return $bTATB(props, function(key) {
        return object[key];
    });
}
module.exports = $5259f4c148d74f06$var$baseValues;

});



parcelRegister("flVbB", function(module, exports) {
$parcel$export(module.exports, "actions", () => $5efee503782286ff$export$e324594224ef24da);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1cPNa = parcelRequire("1cPNa");
const $5efee503782286ff$export$e324594224ef24da = {
    get: $1cPNa.get
};

});
parcelRegister("1cPNa", function(module, exports) {
$parcel$export(module.exports, "get", () => $9fe677a1b06a7509$export$3988ae62b71be9a3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jvz1H = parcelRequire("jvz1H");

var $808aL = parcelRequire("808aL");

var $k4FO8 = parcelRequire("k4FO8");

var $hFtK7 = parcelRequire("hFtK7");

var $i860n = parcelRequire("i860n");

var $ev6gv = parcelRequire("ev6gv");
const $9fe677a1b06a7509$export$3988ae62b71be9a3 = (projectId, properties)=>({ getState: getState, setState: setState })=>{
        const currentProperties = getState()[projectId] || {};
        const missingProperties = (0, (/*@__PURE__*/$parcel$interopDefault($jvz1H)))(properties, (0, (/*@__PURE__*/$parcel$interopDefault($k4FO8)))(currentProperties));
        if (!missingProperties.length) return;
        if ((0, $i860n.fg)('project-properties-setter')) // Synchronously mark properties as in-flight BEFORE the async fetch.
        // This prevents concurrent callers (e.g. multiple components mounting simultaneously
        // and each calling get() in their useEffect) from all seeing the same empty state
        // and firing duplicate requests for the same properties.
        // `keys()` returns keys regardless of value, so setting a key to `undefined` here
        // is sufficient to exclude it from `missingProperties` in any concurrent call.
        setState({
            // oxlint-disable-next-line typescript/consistent-type-assertions
            [projectId]: {
                ...getState()[projectId],
                // oxlint-disable-next-line @typescript-eslint/no-explicit-any
                ...missingProperties.reduce((result, name)=>{
                    const inFlightResult = result;
                    inFlightResult[name] = undefined;
                    return inFlightResult;
                }, {})
            }
        });
        (0, $ev6gv.default)({
            projectId: projectId,
            properties: missingProperties
        }).then((fetchedProperties)=>{
            const latestProperties = getState()[projectId] || {};
            setState({
                // oxlint-disable-next-line typescript/consistent-type-assertions
                [projectId]: {
                    ...latestProperties,
                    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
                    ...missingProperties.reduce((result, name)=>{
                        const reducedResult = result;
                        const fetchedProperty = fetchedProperties?.[name];
                        // `undefined` inside state means the property is in-flight or was never requested.
                        // If value returned for the property is `undefined`, we will set it to `null`,
                        // to differentiate it from the in-flight/unrequested state. Otherwise, returned value will be set.
                        reducedResult[name] = (0, (/*@__PURE__*/$parcel$interopDefault($808aL)))(fetchedProperty) ? null : fetchedProperty;
                        return reducedResult;
                    }, {})
                }
            });
        }).catch((error)=>{
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'getProjectProperties',
                    packageName: 'jiraProjectPropertiesServices',
                    teamName: 'Sequoia'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        });
    };

});
parcelRegister("ev6gv", function(module, exports) {
$parcel$export(module.exports, "default", () => $6cfbcaca05cc5f69$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $kklcL = parcelRequire("kklcL");
const $6cfbcaca05cc5f69$var$remoteGet = async ({ projectId: projectId, properties: properties })=>{
    const { project: project } = await (0, $kklcL.get)({
        projectId: projectId,
        projectProperties: properties,
        consumerMeta: {
            id: 'remoteGet',
            packageName: 'jiraProjectPropertiesServices',
            teamName: 'jsd-shield'
        }
    });
    return project;
};
var $6cfbcaca05cc5f69$export$2e2bcd8739ae039 = $6cfbcaca05cc5f69$var$remoteGet;

});
parcelRegister("kklcL", function(module, exports) {
$parcel$export(module.exports, "get", () => $564bc4e4a83234d6$export$3988ae62b71be9a3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $cZa0l = parcelRequire("cZa0l");

var $dTOvG = parcelRequire("dTOvG");

var $hFtK7 = parcelRequire("hFtK7");

var $6Kdw4 = parcelRequire("6Kdw4");

var $lCetP = parcelRequire("lCetP");

var $h2wCv = parcelRequire("h2wCv");

var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");
let $564bc4e4a83234d6$var$ufoExperiencesMap = {};
const $564bc4e4a83234d6$var$getUfoExperience = (key)=>{
    if (!$564bc4e4a83234d6$var$ufoExperiencesMap[key]) $564bc4e4a83234d6$var$ufoExperiencesMap[key] = new (0, $jkqqC.UFOExperience)(key, {
        type: (0, $ipvkO.ExperienceTypes).Operation,
        performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
    });
    return $564bc4e4a83234d6$var$ufoExperiencesMap[key];
};
const $564bc4e4a83234d6$export$c907f169d33b2e25 = ()=>{
    $564bc4e4a83234d6$var$ufoExperiencesMap = {};
};
const $564bc4e4a83234d6$export$a5b7a8c3b1c6e775 = ({ userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $564bc4e4a83234d6$var$patchProperties = (response, propertiesPath)=>response && (0, (/*@__PURE__*/$parcel$interopDefault($cZa0l)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $564bc4e4a83234d6$export$3988ae62b71be9a3 = async (options)=>{
    const ufoExperience = $564bc4e4a83234d6$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($dTOvG)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($dTOvG)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $564bc4e4a83234d6$export$a5b7a8c3b1c6e775(options);
        const response = await (0, $h2wCv.performGetRequest)(url);
        if (response === null) (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'succeeded',
                actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                source: 'frontendConfigProperties',
                attributes: {
                    package: consumerMeta.packageName,
                    id: consumerMeta.id,
                    isNullResponse: true
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        $564bc4e4a83234d6$var$patchProperties(response, 'user');
        $564bc4e4a83234d6$var$patchProperties(response, 'instance');
        $564bc4e4a83234d6$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return response || {
            user: {},
            instance: {},
            project: {}
        };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $lCetP.isClientFetchError)(error) && (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});
parcelRegister("dTOvG", function(module, exports) {

var $f6GKc = parcelRequire("f6GKc");
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $a1e797a3f8950159$var$kebabCase = $f6GKc(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $a1e797a3f8950159$var$kebabCase;

});








parcelRegister("cfRyQ", function(module, exports) {
$parcel$export(module.exports, "JCSOfferingEdition", () => $c9b40956aa18acce$export$1a41792fe706e5b8);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $d8LhJ = parcelRequire("d8LhJ");

var $dB30l = parcelRequire("dB30l");

var $1KydW = parcelRequire("1KydW");

var $ccEzE = parcelRequire("ccEzE");
const $c9b40956aa18acce$export$1a41792fe706e5b8 = (t0)=>{
    const $ = (0, $e7boj.c)(4);
    const { children: children, showErrorPageOnNotFound: t1 } = t0;
    const showErrorPageOnNotFound = t1 === undefined ? false : t1;
    const { hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $1KydW.useApplicationPermissions)();
    const { customerService: customerService } = (0, $ccEzE.useAppEditions)();
    const isEligible = hasCustomerServiceAccess && customerService !== (0, $d8LhJ.UNLICENSED) && customerService !== (0, $d8LhJ.FREE_EDITION) && customerService !== (0, $d8LhJ.STANDARD_EDITION);
    if (!isEligible) {
        let t2;
        if ($[0] !== showErrorPageOnNotFound) {
            t2 = showErrorPageOnNotFound ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dB30l.ServiceHubNotFound), null) : null;
            $[0] = showErrorPageOnNotFound;
            $[1] = t2;
        } else t2 = $[1];
        return t2;
    }
    let t2;
    if ($[2] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
        $[2] = children;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
$c9b40956aa18acce$export$1a41792fe706e5b8.displayName = "JCSOfferingEdition";

});
parcelRegister("dB30l", function(module, exports) {
$parcel$export(module.exports, "ProjectNotFound", () => $2f831d6368ee950f$export$849d319c342682a2);
$parcel$export(module.exports, "ServiceHubNotFound", () => $2f831d6368ee950f$export$1fbf518ac538659c);
$parcel$export(module.exports, "GenericError", () => $2f831d6368ee950f$export$7d465be8efa67280);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $hH1fA = parcelRequire("hH1fA");

var $ccsIE = parcelRequire("ccsIE");

var $gfdnE = parcelRequire("gfdnE");

var $l8Dej = parcelRequire("l8Dej");

var $4FR7Y = parcelRequire("4FR7Y");

var $qqoKJ = parcelRequire("qqoKJ");

var $siTdT = parcelRequire("siTdT");

var $j26jU = parcelRequire("j26jU");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $anDmR = parcelRequire("anDmR");

var $c3pfo = parcelRequire("c3pfo");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $jpPNt = parcelRequire("jpPNt");

var $i860n = parcelRequire("i860n");
const $2f831d6368ee950f$var$notFoundDocumentTitleJsm = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
    defaultMessage: "Project not found - Service project"
});
const $2f831d6368ee950f$var$notFoundDocumentTitleJsmGalaxia = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm-galaxia",
    defaultMessage: "Space not found - Service space"
});
const $2f831d6368ee950f$var$notFoundTitle = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.not-found-title",
    defaultMessage: "This project isn't available"
});
const $2f831d6368ee950f$var$notFoundTitleGalaxia = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.not-found-title-galaxia",
    defaultMessage: "This space isn't available"
});
const $2f831d6368ee950f$var$notFoundDescription = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.not-found-description",
    defaultMessage: "It may have been deleted or your permissions may have changed"
});
const $2f831d6368ee950f$var$notFoundAction = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.not-found-action",
    defaultMessage: "View a list of all projects"
});
const $2f831d6368ee950f$var$notFoundActionGalaxia = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.not-found-action-galaxia",
    defaultMessage: "View a list of all spaces"
});
const $2f831d6368ee950f$var$genericDocumentTitleJsm = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
    defaultMessage: "Error - Service project"
});
const $2f831d6368ee950f$var$genericDocumentTitleJsmGalaxia = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm-galaxia",
    defaultMessage: "Error - Service space"
});
const $2f831d6368ee950f$var$genericErrorTitle = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.generic-error-title",
    defaultMessage: "An error occurred"
});
const $2f831d6368ee950f$var$genericErrorDescription = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.generic-error-description",
    defaultMessage: "An error occurred while loading this page"
});
const $2f831d6368ee950f$var$serviceHubNotFoundDocumentTitleJsm = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-document-title-jsm",
    defaultMessage: "Service hub not found - Service project"
});
const $2f831d6368ee950f$var$serviceHubNotFoundDocumentTitleJsmGalaxia = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-document-title-jsm-galaxia",
    defaultMessage: "Service hub not found - Service space"
});
const $2f831d6368ee950f$var$serviceHubNotFoundTitle = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-title",
    defaultMessage: "This service hub isn't available"
});
const $2f831d6368ee950f$var$serviceHubNotFoundDescription = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-description",
    defaultMessage: "It may have been deleted or your permissions may have changed"
});
const $2f831d6368ee950f$var$serviceHubNotFoundAction = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-action",
    defaultMessage: "View a list of all service hubs"
});
const $2f831d6368ee950f$var$customerHubNotFoundDocumentTitleJsm = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-document-title-jsm",
    defaultMessage: "Customer experience not found - Service project"
});
const $2f831d6368ee950f$var$customerHubNotFoundDocumentTitleJsmGalaxia = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-document-title-jsm-galaxia",
    defaultMessage: "Customer experience not found - Service space"
});
const $2f831d6368ee950f$var$customerHubNotFoundTitle = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-title",
    defaultMessage: "This customer experience isn't available"
});
const $2f831d6368ee950f$var$customerHubNotFoundDescription = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-description",
    defaultMessage: "It might have been deleted or your permissions may have changed."
});
const $2f831d6368ee950f$var$customerHubNotFoundAction = (0, $7eNDO.defineMessage)({
    id: "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-action",
    defaultMessage: "View all customer experiences"
});
const $2f831d6368ee950f$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c3pfo.DocumentTitle), {
        title: formatMessage((0, $i860n.fg)('itsm-project-renaming') ? $2f831d6368ee950f$var$notFoundDocumentTitleJsmGalaxia : $2f831d6368ee950f$var$notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j26jU.default), {
        renderImage: (0, $l8Dej.getAkEmptyStateRenderImageFn)((0, $gfdnE.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $i860n.fg)('itsm-project-renaming') ? $2f831d6368ee950f$var$notFoundTitleGalaxia : $2f831d6368ee950f$var$notFoundTitle),
        description: formatMessage($2f831d6368ee950f$var$notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jpPNt.Link), {
            to: projectsPath
        }, formatMessage((0, $i860n.fg)('itsm-project-renaming') ? $2f831d6368ee950f$var$notFoundActionGalaxia : $2f831d6368ee950f$var$notFoundAction))
    }));
};
$2f831d6368ee950f$export$849d319c342682a2.displayName = "ProjectNotFound";
const $2f831d6368ee950f$export$1fbf518ac538659c = ()=>{
    const projectsPath = '/jira/projects';
    const customerHubsPath = '/jira/helpcenter';
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const getDocumentTitleMessage = ()=>{
        if ((0, $i860n.fg)('jcs_project_type_m3')) return (0, $i860n.fg)('itsm-project-renaming') ? $2f831d6368ee950f$var$customerHubNotFoundDocumentTitleJsmGalaxia : $2f831d6368ee950f$var$customerHubNotFoundDocumentTitleJsm;
        return (0, $i860n.fg)('itsm-project-renaming') ? $2f831d6368ee950f$var$serviceHubNotFoundDocumentTitleJsmGalaxia : $2f831d6368ee950f$var$serviceHubNotFoundDocumentTitleJsm;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c3pfo.DocumentTitle), {
        title: formatMessage(getDocumentTitleMessage())
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j26jU.default), {
        renderImage: (0, $l8Dej.getAkEmptyStateRenderImageFn)((0, $gfdnE.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $i860n.fg)('jcs_project_type_m3') ? $2f831d6368ee950f$var$customerHubNotFoundTitle : $2f831d6368ee950f$var$serviceHubNotFoundTitle),
        description: formatMessage((0, $i860n.fg)('jcs_project_type_m3') ? $2f831d6368ee950f$var$customerHubNotFoundDescription : $2f831d6368ee950f$var$serviceHubNotFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jpPNt.Link), {
            to: (0, $i860n.fg)('jcs_project_type_m3') ? customerHubsPath : projectsPath
        }, formatMessage((0, $i860n.fg)('jcs_project_type_m3') ? $2f831d6368ee950f$var$customerHubNotFoundAction : $2f831d6368ee950f$var$serviceHubNotFoundAction))
    }));
};
$2f831d6368ee950f$export$1fbf518ac538659c.displayName = "ServiceHubNotFound";
const $2f831d6368ee950f$export$7d465be8efa67280 = ({ interactionForcedError: interactionForcedError })=>{
    const interactionId = (0, $euxye.useContext)((0, $qqoKJ.default)).current;
    const labelStack = (0, $euxye.useContext)((0, $4FR7Y.default))?.labelStack;
    const traceId = (0, $euxye.useMemo)(()=>{
        const traceContext = (0, $anDmR.getActiveTrace)();
        return traceContext?.traceId;
    }, []);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    let description = formatMessage($2f831d6368ee950f$var$genericErrorDescription);
    if (traceId) {
        const error = new Error('An error occurred while loading this page');
        description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: $2f831d6368ee950f$var$styles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hH1fA.ErrorHashAndTraceId), {
            error: error,
            traceId: traceId
        })));
        const name = 'serviceDeskGenericError';
        if (interactionId) {
            (0, $siTdT.addError)(interactionId, name, labelStack ?? null, error.name, error.message, error.stack, interactionForcedError);
            // NOTE: to account for awaiting BM3 TTI in UFO code, however we don't need to wait for BM3 TTI when there is an error
            // https://atlassian.slack.com/archives/C01AY8132S3/p1736380314352749?thread_ts=1736377740.484469&cid=C01AY8132S3
            const activeInteraction = (0, $siTdT.getActiveInteraction)();
            activeInteraction?.holdActive.forEach((_, holdId)=>{
                (0, $siTdT.removeHoldByID)(activeInteraction.id, holdId);
            });
        } else (0, $siTdT.addErrorToAll)(name, labelStack ?? null, error.name, error.message, error.stack);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c3pfo.DocumentTitle), {
        title: formatMessage((0, $i860n.fg)('itsm-project-renaming') ? $2f831d6368ee950f$var$genericDocumentTitleJsmGalaxia : $2f831d6368ee950f$var$genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j26jU.default), {
        renderImage: (0, $l8Dej.getAkEmptyStateRenderImageFn)((0, $ccsIE.default)),
        maxImageWidth: 120,
        header: formatMessage($2f831d6368ee950f$var$genericErrorTitle),
        description: description
    }));
};
$2f831d6368ee950f$export$7d465be8efa67280.displayName = "GenericError";
const $2f831d6368ee950f$var$styles = (0, $fbAgj.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("hH1fA", function(module, exports) {
$parcel$export(module.exports, "ErrorHashAndTraceId", () => $d1ec8eb296f69d2d$export$61354a7dde2c2d3c);

var $euxye = parcelRequire("euxye");

var $eXdAp = parcelRequire("eXdAp");

var $aqPkH = parcelRequire("aqPkH");

var $j0sBk = parcelRequire("j0sBk");
const $d1ec8eb296f69d2d$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
    const errorHash = (0, $eXdAp.getErrorHash)(error);
    const source = `Hash ${errorHash}\nTrace ${traceId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireOperationalAnalytics), {
        action: "rendered",
        actionSubject: "errorHashAndTraceId",
        attributes: {
            errorHash: errorHash,
            traceId: traceId
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        role: "note"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j0sBk.CodeBlockWithCopyButton), {
        source: source,
        copyCodeActionSubjectId: "copyErrorHashAndTraceId"
    })));
};
$d1ec8eb296f69d2d$export$61354a7dde2c2d3c.displayName = "ErrorHashAndTraceId";

});
parcelRegister("j0sBk", function(module, exports) {
$parcel$export(module.exports, "CodeBlockWithCopyButton", () => $37456d75984f951a$export$ced1fc74d907d387);

var $euxye = parcelRequire("euxye");

var $ahSro = parcelRequire("ahSro");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $ijlWY = parcelRequire("ijlWY");
const $37456d75984f951a$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $37456d75984f951a$var$wrapperStyles,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ijlWY.ActionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ijlWY.CopyAction), {
        source: source,
        actionSubjectId: copyCodeActionSubjectId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ahSro.default), {
        text: source,
        showLineNumbers: false,
        shouldWrapLongLines: false
    })));
$37456d75984f951a$export$ced1fc74d907d387.displayName = "CodeBlockWithCopyButton";
const $37456d75984f951a$var$wrapperStyles = (0, $fbAgj.xcss)({
    width: '100%',
    position: 'relative'
});

});
parcelRegister("ahSro", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f645e96059f1330$export$2e2bcd8739ae039);
/* code-block.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $glbdM = parcelRequire("glbdM");

var $1qU3G = parcelRequire("1qU3G");

var $iqfTZ = parcelRequire("iqfTZ");

var $2E2Gj = parcelRequire("2E2Gj");

var $2767r = parcelRequire("2767r");

var $aFw1x = parcelRequire("aFw1x");

var $kMyNx = parcelRequire("kMyNx");
const $2f645e96059f1330$var$getCodeBlockStyles = {
    rootT26Shape: "_2rko1mok",
    root: "_11c819w5 _2rko12b0 _1dqoglyw _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhk187e _syazi7uo _1ozdn7od _7xinn7od _t7aun7od _r28du2gc _tajqu2gc _1ohiu2gc _m802u2gc _i6ntu2gc _1w2xu2gc _1hmyegat _vblregat _vbulegat _196q1j08 _1vbw1j08 _1v9c1j08 _1srnt0uh _18r6myb0 _vyvc1n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _ra6gsb9t _13cdh2mm _1pp0126e _zvy9f705 _qcxof705 _qzn01a66 _j0l11wug _1weckb7n _1na21hna _vsnzgrf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909i8nm _scgayz1z _ipl81e17 _40uk1l04 _i81p1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _pyovu2gc _ccm6u2gc _1ascu2gc _1yuau2gc _xr0w1a66 _4io21a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgc124n _bu7z124n _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3wu06 _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eihtd5cb _t9zbd5cb _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t36i7uo _137bh55r _1k7di7uo _97li16jw _12nh9lu1 _1g0517qg _i2igqmo9 _326zi7uo _113p1rpy _1n6t16jw _tgu817qg _1k4716jw _g0lxi7uo _ys4e1rpy _7gp8h55r _1yvqqmo9 _1vwwqmo9 _1rjuqmo9 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o6qmo9 _kxov17qg _1np517qg _m2f517qg _1b9t16jw _1tq616jw _1rd216jw _1pbk16jw _k3li16jw _13zt1rpy _2g12fb2s _k86bqmo9 _b5iy1rpy _gti31rpy _1f0g16jw _9d3e17qg _qdia16jw _72uv16jw",
    showLineNumbers: "_1707bror _1i3h1txw _16noidpf _h4fuidpf _pp6yidpf _1g4tidpf _11wmidpf _1bx8idpf",
    dontShowLineNumbers: "_1i3h1ule _16nou2gc _h4fuu2gc _pp6yu2gc _1g4tu2gc _11wmu2gc _1bx8u2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $2f645e96059f1330$var$CodeBlock = /*#__PURE__*/ (0, $euxye.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, shouldShowLineNumbers: shouldShowLineNumbers, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' }) {
    const scrollableRef = (0, $euxye.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $euxye.useState)(false);
    // Use children if provided, otherwise fall back to deprecated text prop
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $2767r.getLineNumWidth)(numLines) : 0;
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $euxye.useEffect)(()=>{
        const schedule = (0, $1qU3G.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $glbdM.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $2E2Gj.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $euxye.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $euxye.useMemo)(()=>(0, $aFw1x.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kMyNx.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: shouldShowLineNumbersValue,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: shouldShowBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $4jQY2.default)([
            $2f645e96059f1330$var$getCodeBlockStyles.root,
            (0, $iqfTZ.fg)('platform-dst-shape-theme-default') && $2f645e96059f1330$var$getCodeBlockStyles.rootT26Shape,
            shouldWrapLongLines ? $2f645e96059f1330$var$getCodeBlockStyles.shouldWrapLongLines : $2f645e96059f1330$var$getCodeBlockStyles.dontWrapLongLines,
            shouldShowLineNumbersValue ? $2f645e96059f1330$var$getCodeBlockStyles.showLineNumbers : $2f645e96059f1330$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $2f645e96059f1330$export$2e2bcd8739ae039 = $2f645e96059f1330$var$CodeBlock;

});
parcelRegister("2E2Gj", function(module, exports) {
$parcel$export(module.exports, "useHighlightLines", () => $315b73259a054470$export$84415a200bdf33ed);

var $euxye = parcelRequire("euxye");
const $315b73259a054470$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $315b73259a054470$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$315b73259a054470$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $315b73259a054470$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $315b73259a054470$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $euxye.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $euxye.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $315b73259a054470$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$315b73259a054470$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $315b73259a054470$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("2767r", function(module, exports) {
$parcel$export(module.exports, "getLineNumWidth", () => $41f9d678a00cfe68$export$cb7aec0206b595d2);
const $41f9d678a00cfe68$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};

});

parcelRegister("aFw1x", function(module, exports) {
$parcel$export(module.exports, "normalizeLanguage", () => $8890448de8bf5119$export$f38728011c178796);

var $emCaV = parcelRequire("emCaV");

var $kaNnc = parcelRequire("kaNnc");
const $8890448de8bf5119$export$f38728011c178796 = (0, $emCaV.default)((language)=>{
    if (!language) return '';
    const match = (0, $kaNnc.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("kaNnc", function(module, exports) {
$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $5fa5f4b2c73e2eba$export$7c77c3a9bb93870d);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ // The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $5fa5f4b2c73e2eba$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];

});


parcelRegister("kMyNx", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc3cdeff6ee99af3$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $aymFe = parcelRequire("aymFe");
var $dc3cdeff6ee99af3$export$2e2bcd8739ae039 = (0, $aymFe.default);

});
parcelRegister("aymFe", function(module, exports) {
$parcel$export(module.exports, "default", () => $14daeeb825f89a76$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $5CYN6 = parcelRequire("5CYN6");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $14daeeb825f89a76$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $5CYN6.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $e79Pd.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $14daeeb825f89a76$var$asyncGenerator = $14daeeb825f89a76$var$generator({
    loader: ()=>(parcelRequire("czUi3")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $14daeeb825f89a76$export$2e2bcd8739ae039 = $14daeeb825f89a76$var$asyncGenerator;

});
parcelRegister("5CYN6", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7a3f16c209dd1f0$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $l0wpG = parcelRequire("l0wpG");

var $opOff = parcelRequire("opOff");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $f7a3f16c209dd1f0$var$Highlight = /*#__PURE__*/ (0, $euxye.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $l0wpG.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $opOff.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $f7a3f16c209dd1f0$export$2e2bcd8739ae039 = $f7a3f16c209dd1f0$var$Highlight;

});
parcelRegister("l0wpG", function(module, exports) {
$parcel$export(module.exports, "default", () => $babf311a7f864b46$export$2e2bcd8739ae039);

var $iTxjC = parcelRequire("iTxjC");

var $40DFJ = parcelRequire("40DFJ");

var $kZqCA = parcelRequire("kZqCA");

var $1WvN5 = parcelRequire("1WvN5");
const $babf311a7f864b46$var$newLineRegex = /\n/g;
function $babf311a7f864b46$var$getNewLines(str) {
    return str.match($babf311a7f864b46$var$newLineRegex);
}
function $babf311a7f864b46$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $1WvN5.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $iTxjC.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $kZqCA.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $babf311a7f864b46$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $40DFJ.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $40DFJ.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("iTxjC", function(module, exports) {
$parcel$export(module.exports, "default", () => $ecc3428763186fb1$export$2e2bcd8739ae039);

var $40DFJ = parcelRequire("40DFJ");

var $gM7kA = parcelRequire("gM7kA");
function $ecc3428763186fb1$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $40DFJ.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $gM7kA.default)(lineNumber));
            return children;
        }
    };
}
var $ecc3428763186fb1$export$2e2bcd8739ae039 = $ecc3428763186fb1$var$createLineGenerator;

});
parcelRegister("40DFJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $54685ac5f5a720f5$export$2e2bcd8739ae039);

var $gM7kA = parcelRequire("gM7kA");
function $54685ac5f5a720f5$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, shouldShowLineNumbers: shouldShowLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    // Use new prop if provided, otherwise fall back to deprecated prop
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && shouldShowLineNumbersValue) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $gM7kA.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $gM7kA.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("gM7kA", function(module, exports) {
$parcel$export(module.exports, "default", () => $89aee3d8f83a17e8$export$2e2bcd8739ae039);
function $89aee3d8f83a17e8$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("kZqCA", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ec7a72e58863c36$export$2e2bcd8739ae039);

var $iqfTZ = parcelRequire("iqfTZ");

var $40DFJ = parcelRequire("40DFJ");
function $7ec7a72e58863c36$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $40DFJ.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            // If this node is a re-highlighted fenced code-block wrapper (added by
            // rehighlightFencedBlocks in get-code-tree.tsx), reset the accumulated
            // class list instead of concatenating onto ancestors.  Without this,
            // every token inside the fenced block inherits all ancestor classes
            // (e.g. "token code token code-block language-jsx token plain-text").
            const nodeClasses = node.properties.className || [];
            const isCodeBlock = (0, $iqfTZ.fg)('platform-code-highlight-markdown-safe') && nodeClasses.includes('code-block');
            // When entering a re-highlighted fenced code-block wrapper, reset the
            // accumulated ancestor classes to empty so children only carry their
            // own token classes (not the full ancestor chain).
            const classNames = isCodeBlock ? [] : className.concat(nodeClasses);
            $7ec7a72e58863c36$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("1WvN5", function(module, exports) {
$parcel$export(module.exports, "default", () => $f265199868961edd$export$2e2bcd8739ae039);

var $iqfTZ = parcelRequire("iqfTZ");
/**
 * Extract the plain text content from a list of RefractorNodes.
 */ function $f265199868961edd$var$extractText(nodes) {
    return nodes.map((n)=>{
        if (n.type === 'text') return n.value;
        return n.children ? $f265199868961edd$var$extractText(n.children) : '';
    }).join('');
}
/**
 * Walk the safe-highlighted AST and, for every fenced code block (a `token code`
 * span), replace the raw text child with a properly highlighted `token code-block
 * language-{lang}` span so that inner tokens carry the correct classes.
 */ function $f265199868961edd$var$rehighlightFencedBlocks(nodes, astGenerator) {
    const refractorLike = astGenerator;
    return nodes.map((node)=>{
        if (node.type !== 'element') return node;
        const classes = node.properties?.className ?? [];
        const isCodeToken = classes.includes('token') && classes.includes('code');
        if (!isCodeToken || !node.children) return {
            ...node,
            children: $f265199868961edd$var$rehighlightFencedBlocks(node.children ?? [], astGenerator)
        };
        // Find the code-language child to determine which sub-language to use.
        const langNode = node.children.find((c)=>c.type === 'element' && c.properties?.className?.includes('code-language'));
        const subLang = langNode && langNode.type === 'element' ? $f265199868961edd$var$extractText(langNode.children ?? []).trim() : null;
        // Find the raw text child that holds the fenced block content (after the
        // opening ``` line and before the closing ```).
        const children = node.children.map((child)=>{
            // This is the raw code content
            // eslint-disable-next-line @repo/internal/react/no-children-properties-access
            const rawContent = 'value' in child ? child.value : undefined;
            if (!subLang || !rawContent) return child;
            // Only re-highlight when the sub-language is registered with refractor to
            // avoid an uncaught exception.
            const isRegistered = typeof refractorLike.registered === 'function' ? refractorLike.registered(subLang) : Boolean(refractorLike.languages?.[subLang]);
            if (!isRegistered) return child;
            let highlighted;
            try {
                highlighted = astGenerator.highlight(rawContent, subLang);
            } catch  {
                return child;
            }
            // Wrap in a `token code-block language-{lang}` span to match what the
            // normal (non-safe) markdown highlight would produce.
            const codeBlockNode = {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: [
                        'token',
                        'code-block',
                        `language-${subLang}`
                    ]
                },
                children: highlighted
            };
            return codeBlockNode;
        });
        return {
            ...node,
            children: children
        };
    });
}
function $f265199868961edd$var$highlightMarkdownSafely(code, astGenerator) {
    const refractorLike = astGenerator;
    const markdownCodeToken = refractorLike.languages?.markdown?.code;
    const fencedToken = Array.isArray(markdownCodeToken) ? markdownCodeToken[1] : undefined;
    const originalInside = fencedToken?.inside;
    const canDisableEmbeddedCodeBlock = originalInside && 'code-block' in originalInside;
    if (canDisableEmbeddedCodeBlock) {
        const patchedInside = {
            ...originalInside
        };
        delete patchedInside['code-block'];
        fencedToken.inside = patchedInside;
    }
    let result;
    try {
        result = astGenerator.highlight(code, 'markdown');
    } finally{
        if (canDisableEmbeddedCodeBlock) fencedToken.inside = originalInside;
    }
    // Re-highlight inner fenced code blocks so tokens carry proper classes.
    return $f265199868961edd$var$rehighlightFencedBlocks(result, astGenerator);
}
function $f265199868961edd$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        if (language === 'markdown' && (0, $iqfTZ.fg)('platform-code-highlight-markdown-safe')) return $f265199868961edd$var$highlightMarkdownSafely(code, astGenerator);
        return astGenerator.highlight(code, language);
    } catch  {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("opOff", function(module, exports) {
$parcel$export(module.exports, "default", () => $e191eddd5c966911$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $6gBs7 = parcelRequire("6gBs7");
function $e191eddd5c966911$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $6gBs7.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}
$e191eddd5c966911$export$2e2bcd8739ae039.displayName = "ReactRenderer";

});
parcelRegister("6gBs7", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a0f762e76b970a4$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iDZQS = parcelRequire("iDZQS");

var $6oFfP = parcelRequire("6oFfP");

var $aKC6k = parcelRequire("aKC6k");
function $4a0f762e76b970a4$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $4a0f762e76b970a4$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $6oFfP.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $iDZQS.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    isTooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $aKC6k.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $4a0f762e76b970a4$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("iDZQS", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec19a1143acfcf49$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hZDXn = parcelRequire("hZDXn");

var $7xcDT = parcelRequire("7xcDT");
function $ec19a1143acfcf49$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        content: label,
        tag: $ec19a1143acfcf49$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7xcDT.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: shouldSkip ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7xcDT.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: shouldSkip ? null : bidiCharacter
    });
}
$ec19a1143acfcf49$export$2e2bcd8739ae039.displayName = "BidiWarning";
const $ec19a1143acfcf49$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("7xcDT", function(module, exports) {
$parcel$export(module.exports, "Decorator", () => $8b37923a5cfdea42$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $apUrw = parcelRequire("apUrw");
const $8b37923a5cfdea42$var$decoration = {
    root: "_kqswh2mm _szplfhey _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6rzzfg _1uakf6fq _1kt9y7el _is061xn9 _1rus1917 _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rba1xn9 _1xqc19zu"
};
function $8b37923a5cfdea42$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $8b37923a5cfdea42$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $4jQY2.default)([
                    $8b37923a5cfdea42$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
$8b37923a5cfdea42$export$a592b67c93d52467.displayName = "Decorator";
function $8b37923a5cfdea42$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("6oFfP", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca665731a3a0db5c$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $a80to = parcelRequire("a80to");
function $ca665731a3a0db5c$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll((0, $a80to.bidiCharacterRegex))
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});
parcelRegister("a80to", function(module, exports) {
$parcel$export(module.exports, "bidiCharacterRegex", () => $c0849c5afe74040f$export$ecb256e6a1f5ee7e);
const $c0849c5afe74040f$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;

});


parcelRegister("aKC6k", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe2c77ca8ac6249a$export$2e2bcd8739ae039);

var $6gBs7 = parcelRequire("6gBs7");
function $fe2c77ca8ac6249a$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $6gBs7.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("czUi3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7NVS2").then(()=>parcelRequire('2PnWa'));

});




parcelRegister("ijlWY", function(module, exports) {
$parcel$export(module.exports, "CopyAction", () => $2824b38b066ffd08$export$958df07cbf9735fc);
$parcel$export(module.exports, "ActionContainer", () => $2824b38b066ffd08$export$37ab3bdebc286ca);

var $euxye = parcelRequire("euxye");

var $a9o4s = parcelRequire("a9o4s");

var $1Unjk = parcelRequire("1Unjk");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $aJ81Y = parcelRequire("aJ81Y");

var $2OVXG = parcelRequire("2OVXG");
const $2824b38b066ffd08$export$2ce9877c9c1aa16 = {
    PROMPT: 'Copy',
    SUCCESS: 'Copied!',
    FAILURE: 'Copy to clipboard failed'
};
const $2824b38b066ffd08$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
    const [tooltipMessage, setTooltipMessage] = (0, $euxye.useState)($2824b38b066ffd08$export$2ce9877c9c1aa16.PROMPT);
    const handleSuccess = (0, $euxye.useCallback)(()=>{
        setTooltipMessage($2824b38b066ffd08$export$2ce9877c9c1aa16.SUCCESS);
    }, [
        setTooltipMessage
    ]);
    const handleError = (0, $euxye.useCallback)(()=>{
        setTooltipMessage($2824b38b066ffd08$export$2ce9877c9c1aa16.FAILURE);
    }, [
        setTooltipMessage
    ]);
    const writeToClipboard = (0, $euxye.useCallback)((_, analyticsEvent)=>{
        actionSubjectId && (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(source).then(handleSuccess, handleError);
    }, [
        source,
        handleSuccess,
        handleError,
        actionSubjectId
    ]);
    const resetMessage = (0, $euxye.useCallback)(()=>{
        setTooltipMessage($2824b38b066ffd08$export$2ce9877c9c1aa16.PROMPT);
    }, [
        setTooltipMessage
    ]);
    function shouldRender() {
        if (typeof document !== 'undefined') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return Boolean(navigator?.clipboard?.writeText);
    }
    return shouldRender() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2OVXG.Action), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Unjk))),
        label: tooltipMessage,
        onClick: writeToClipboard,
        onMouseOver: resetMessage,
        onFocus: resetMessage,
        "aria-live": "assertive",
        "aria-atomic": "true",
        name: "Copy"
    }) : null;
};
$2824b38b066ffd08$export$958df07cbf9735fc.displayName = "CopyAction";
const $2824b38b066ffd08$var$stopPropagation = (event)=>event.stopPropagation();
const $2824b38b066ffd08$export$37ab3bdebc286ca = ({ children: children })=>/**
	 * This element uses an `onMouseDown` to block event propagation
	 * to its parent but is not itself interactive.
	 */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $2824b38b066ffd08$var$absolutePositionWrapperStyles,
        onMouseDown: $2824b38b066ffd08$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), {
        label: "actions"
    }, children));
$2824b38b066ffd08$export$37ab3bdebc286ca.displayName = "ActionContainer";
const $2824b38b066ffd08$var$absolutePositionWrapperStyles = (0, $fbAgj.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    padding: 'space.050',
    zIndex: 'flag'
});

});
parcelRegister("1Unjk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14bdce01d37a11560d25cb9029d3aa79>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $163d1a70b689d0d2$var$_react = $163d1a70b689d0d2$var$_interopRequireDefault((parcelRequire("euxye")));

var $163d1a70b689d0d2$var$_baseNew = $163d1a70b689d0d2$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $163d1a70b689d0d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/copy
 * Usage guidance:
 * Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $163d1a70b689d0d2$var$CopyIcon = (props)=>/*#__PURE__*/ $163d1a70b689d0d2$var$_react.default.createElement($163d1a70b689d0d2$var$_baseNew.default, Object.assign({
        name: "CopyIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$163d1a70b689d0d2$var$CopyIcon.displayName = 'CopyIcon';
var $163d1a70b689d0d2$var$_default = module.exports.default = $163d1a70b689d0d2$var$CopyIcon;

});

parcelRegister("2OVXG", function(module, exports) {
$parcel$export(module.exports, "Action", () => $8dea8475a0d3a2be$export$e19cd5f9376f8cee);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $hZDXn = parcelRequire("hZDXn");
const $8dea8475a0d3a2be$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
    const updateTooltip = (0, $euxye.useRef)();
    (0, $euxye.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        tooltipLabel,
        label
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel || label;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
        isLoading: isLoading,
        appearance: "subtle",
        icon: icon,
        label: label,
        spacing: "compact",
        ...buttonProps
    }));
};
$8dea8475a0d3a2be$export$e19cd5f9376f8cee.displayName = "Action";

});




parcelRegister("ccsIE", function(module, exports) {
$parcel$export(module.exports, "default", () => $c36919487905f41d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $c36919487905f41d$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("YizKh")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("gkkMX")))));
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $gboXr = parcelRequire("gboXr");

var $gkkMX = parcelRequire("gkkMX");

var $YizKh = parcelRequire("YizKh");
const $c36919487905f41d$var$Illustration = (0, $gboXr.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($YizKh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($gkkMX))
});
var $c36919487905f41d$export$2e2bcd8739ae039 = $c36919487905f41d$var$Illustration;
// for advanced use only
const $c36919487905f41d$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("gkkMX", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("YizKh", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("gfdnE", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ec3550aa001c5ed$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3xTLb")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3xTLb")))));
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $gboXr = parcelRequire("gboXr");

var $3xTLb = parcelRequire("3xTLb");
const $4ec3550aa001c5ed$var$Illustration = (0, $gboXr.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3xTLb)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3xTLb))
});
var $4ec3550aa001c5ed$export$2e2bcd8739ae039 = $4ec3550aa001c5ed$var$Illustration;
// for advanced use only
const $4ec3550aa001c5ed$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("3xTLb", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("l8Dej", function(module, exports) {
$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $bbba4ff607b9e670$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
var $8w7Yz = parcelRequire("8w7Yz");

var $8Agip = parcelRequire("8Agip");
function $bbba4ff607b9e670$export$ebf64b9217c1b2a3(JiraIllustration = (0, $8Agip.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $8w7Yz.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $8w7Yz.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $4jQY2.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _19pkidpf _2hwx1wug _otyr1ejb _18u01wug",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("8Agip", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6acedb2d5723b78$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3sUgu")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("kfedV")))));
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $gboXr = parcelRequire("gboXr");

var $kfedV = parcelRequire("kfedV");

var $3sUgu = parcelRequire("3sUgu");
const $a6acedb2d5723b78$var$Illustration = (0, $gboXr.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3sUgu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kfedV))
});
var $a6acedb2d5723b78$export$2e2bcd8739ae039 = $a6acedb2d5723b78$var$Illustration;
// for advanced use only
const $a6acedb2d5723b78$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("kfedV", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("3sUgu", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



parcelRegister("c3pfo", function(module, exports) {
$parcel$export(module.exports, "DocumentTitle", () => $fbcf97721ceb4a61$export$dd5ad0b65cf665da);

var $ea1FV = parcelRequire("ea1FV");
const $fbcf97721ceb4a61$export$dd5ad0b65cf665da = (0, $ea1FV.DocumentTitleHelper);

});



parcelRegister("7mzpc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ea49917c92593285532eb8de72c9e50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $55c60d4384ed4c96$var$_react = $55c60d4384ed4c96$var$_interopRequireDefault((parcelRequire("euxye")));

var $55c60d4384ed4c96$var$_baseNew = $55c60d4384ed4c96$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $55c60d4384ed4c96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Compass".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/compass
 * Usage guidance:
 * Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $55c60d4384ed4c96$var$CompassIcon = (props)=>/*#__PURE__*/ $55c60d4384ed4c96$var$_react.default.createElement($55c60d4384ed4c96$var$_baseNew.default, Object.assign({
        name: "CompassIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m11.78-3.78a.75.75 0 0 1 .155.834l-2 4.5a.75.75 0 0 1-.38.381l-4.5 2a.75.75 0 0 1-.99-.99l2-4.5a.75.75 0 0 1 .38-.38l4.5-2a.75.75 0 0 1 .835.154M6.992 8.051l.955.956-1.72.764zm2.016-.105-.956-.955 1.72-.765z" clip-rule="evenodd"/>`
    }, props));
$55c60d4384ed4c96$var$CompassIcon.displayName = 'CompassIcon';
var $55c60d4384ed4c96$var$_default = module.exports.default = $55c60d4384ed4c96$var$CompassIcon;

});

parcelRegister("cggc1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f980aa850a765b817eeee03433658425>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ed38a3a58c5780c$var$_react = $8ed38a3a58c5780c$var$_interopRequireDefault((parcelRequire("euxye")));

var $8ed38a3a58c5780c$var$_baseNew = $8ed38a3a58c5780c$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $8ed38a3a58c5780c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldCheckboxGroup".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/field-checkbox-group
 * Usage guidance:
 * Known uses: Checkbox group field type in Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ed38a3a58c5780c$var$FieldCheckboxGroupIcon = (props)=>/*#__PURE__*/ $8ed38a3a58c5780c$var$_react.default.createElement($8ed38a3a58c5780c$var$_baseNew.default, Object.assign({
        name: "FieldCheckboxGroupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 2.75A.75.75 0 0 1 1.75 2h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5A.75.75 0 0 1 1 6.25zm1.5.75v2h2v-2zM16 5.25H8v-1.5h8zM1 9.75A.75.75 0 0 1 1.75 9h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75zm1.5.75v2h2v-2zM16 12.25H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$8ed38a3a58c5780c$var$FieldCheckboxGroupIcon.displayName = 'FieldCheckboxGroupIcon';
var $8ed38a3a58c5780c$var$_default = module.exports.default = $8ed38a3a58c5780c$var$FieldCheckboxGroupIcon;

});

parcelRegister("bgKBB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4c54b6d29d504c6ad8900af2bbcc304b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83455732429326d4$var$_react = $83455732429326d4$var$_interopRequireDefault((parcelRequire("euxye")));

var $83455732429326d4$var$_baseNew = $83455732429326d4$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $83455732429326d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintPalette".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/paint-palette
 * Usage guidance:
 * Multi purpose - Known usages: Customize.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83455732429326d4$var$PaintPaletteIcon = (props)=>/*#__PURE__*/ $83455732429326d4$var$_react.default.createElement($83455732429326d4$var$_baseNew.default, Object.assign({
        name: "PaintPaletteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.932.274a8 8 0 0 1 4.14 15.455 1 1 0 0 1-.097.02c-.908.118-1.72.055-2.29-.438-.573-.498-.672-1.24-.682-1.85-.011-.672-.309-1.152-.72-1.426-.42-.279-1.016-.384-1.682-.169-1.006.325-1.93.458-2.717.158-.837-.32-1.308-1.042-1.597-1.909l-.012-.043A8 8 0 0 1 5.932.274M14.28 6.32A6.5 6.5 0 0 0 1.718 9.66c.218.647.464.871.701.962.29.11.796.116 1.72-.182 1.061-.344 2.14-.209 2.974.346.84.56 1.371 1.507 1.39 2.65.009.546.112.695.166.742.058.05.291.181 1.064.088a6.5 6.5 0 0 0 4.547-7.947"/><path fill="currentcolor" d="M10.87 5.68a1.13 1.13 0 1 1 .58 2.17 1.13 1.13 0 0 1-.58-2.17m-6.49-.07a1.13 1.13 0 1 1 .58 2.17 1.13 1.13 0 0 1-.58-2.17m3.3-2.18a1.13 1.13 0 1 1 .58 2.17 1.13 1.13 0 0 1-.58-2.17"/>`
    }, props));
$83455732429326d4$var$PaintPaletteIcon.displayName = 'PaintPaletteIcon';
var $83455732429326d4$var$_default = module.exports.default = $83455732429326d4$var$PaintPaletteIcon;

});

parcelRegister("10NJr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ecce27880645537302fdbdc3f16ef72c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0bcc5e406ce6f84f$var$_react = $0bcc5e406ce6f84f$var$_interopRequireDefault((parcelRequire("euxye")));

var $0bcc5e406ce6f84f$var$_baseNew = $0bcc5e406ce6f84f$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $0bcc5e406ce6f84f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person-add
 * Usage guidance:
 * Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0bcc5e406ce6f84f$var$PersonAddIcon = (props)=>/*#__PURE__*/ $0bcc5e406ce6f84f$var$_react.default.createElement($0bcc5e406ce6f84f$var$_baseNew.default, Object.assign({
        name: "PersonAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 12.75A3.75 3.75 0 0 1 4.75 9H9v1.5H4.75a2.25 2.25 0 0 0-2.25 2.25V15H1zM9.5 4a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M11 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0m2.75 6v2.25H16v1.5h-2.25V16h-1.5v-2.25H10v-1.5h2.25V10z"/>`
    }, props));
$0bcc5e406ce6f84f$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $0bcc5e406ce6f84f$var$_default = module.exports.default = $0bcc5e406ce6f84f$var$PersonAddIcon;

});

parcelRegister("ahixA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b61ce493f971edcb4f538b1e68000bb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $77b9dfb105b64e54$var$_react = $77b9dfb105b64e54$var$_interopRequireDefault((parcelRequire("euxye")));

var $77b9dfb105b64e54$var$_baseNew = $77b9dfb105b64e54$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $77b9dfb105b64e54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Premium".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/premium
 * Usage guidance:
 * Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $77b9dfb105b64e54$var$PremiumIcon = (props)=>/*#__PURE__*/ $77b9dfb105b64e54$var$_react.default.createElement($77b9dfb105b64e54$var$_baseNew.default, Object.assign({
        name: "PremiumIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 3v1.5H3V3h1.5V1.5H3V0H1.5v1.5H0V3zM8 1c.31 0 .587.19.699.478l1.63 4.193 4.193 1.63a.75.75 0 0 1 0 1.398l-4.193 1.63-1.63 4.193a.75.75 0 0 1-1.398 0l-1.63-4.193L1.478 8.7a.75.75 0 0 1 0-1.398l4.193-1.63L7.3 1.478A.75.75 0 0 1 8 1m0 2.82L6.949 6.521a.75.75 0 0 1-.427.427L3.819 8l2.703 1.051a.75.75 0 0 1 .427.427L8 12.181l1.051-2.703a.75.75 0 0 1 .427-.427L12.181 8 9.478 6.949a.75.75 0 0 1-.427-.427zm5 10.68V16h1.5v-1.5H16V13h-1.5v-1.5H13V13h-1.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$77b9dfb105b64e54$var$PremiumIcon.displayName = 'PremiumIcon';
var $77b9dfb105b64e54$var$_default = module.exports.default = $77b9dfb105b64e54$var$PremiumIcon;

});

parcelRegister("ivTJy", function(module, exports) {
$parcel$export(module.exports, "HelpHelpCenterAri", () => $d7a65ad0ecca9cae$export$a75f3c98d930b258);

var $2b094 = parcelRequire("2b094");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/help/help-center/manifest.ts
var $d7a65ad0ecca9cae$var$helpHelpCenterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $2b094.HelpHelpCenterAriResourceOwner),
    resourceType: (0, $2b094.HelpHelpCenterAriResourceType),
    resourceIdSlug: "{activationId}/{helpCenterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        helpCenterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/help/help-center/index.ts
var $d7a65ad0ecca9cae$export$a75f3c98d930b258 = class _HelpHelpCenterAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._helpCenterId = opts.resourceIdSegmentValues.helpCenterId;
    }
    get activationId() {
        return this._activationId;
    }
    get helpCenterId() {
        return this._helpCenterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d7a65ad0ecca9cae$var$helpHelpCenterAriStaticOpts.qualifier,
            platformQualifier: $d7a65ad0ecca9cae$var$helpHelpCenterAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $d7a65ad0ecca9cae$var$helpHelpCenterAriStaticOpts.resourceOwner,
            resourceType: $d7a65ad0ecca9cae$var$helpHelpCenterAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.helpCenterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                helpCenterId: opts.helpCenterId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $d7a65ad0ecca9cae$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $d7a65ad0ecca9cae$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            helpCenterId: this.helpCenterId
        };
    }
};

});
parcelRegister("2b094", function(module, exports) {
$parcel$export(module.exports, "HelpHelpCenterAriResourceOwner", () => $195cb8ba47e4f94d$export$a4af98a27b4568ee);
$parcel$export(module.exports, "HelpHelpCenterAriResourceType", () => $195cb8ba47e4f94d$export$f6271ed6947e9084);
// src/help/help-center/types.ts
var $195cb8ba47e4f94d$export$a4af98a27b4568ee = "help", $195cb8ba47e4f94d$export$f6271ed6947e9084 = "help-center";

});


parcelRegister("1NA92", function(module, exports) {
$parcel$export(module.exports, "NavCustomIcon", () => $dbe63e7f77f563b4$export$a28b5b938c71ae38);

var $eyZel = parcelRequire("eyZel");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");

var $bfbbl = parcelRequire("bfbbl");

var $9ufZj = parcelRequire("9ufZj");

var $ihEDU = parcelRequire("ihEDU");

var $a8EUd = parcelRequire("a8EUd");

var $kt86l = parcelRequire("kt86l");

var $h3LJR = parcelRequire("h3LJR");
const $dbe63e7f77f563b4$var$styles = {
    iconSkeleton: "_2rko12b0 _bfhkizff _1bsb1tcg _4t3i1tcg"
};
const $dbe63e7f77f563b4$var$IconSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $dbe63e7f77f563b4$var$styles.iconSkeleton
    });
$dbe63e7f77f563b4$var$IconSkeleton.displayName = "IconSkeleton";
const $dbe63e7f77f563b4$var$iconFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bfbbl.CustomerExperienceIcon), {
        size: "small"
    });
const $dbe63e7f77f563b4$var$NavCustomIconInnerWrapper = ({ helpCenterId: helpCenterId })=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const { customerService: customerService } = (0, $n67Vb.useLazyLoadQuery)((0, $eyZel.default), {
        cloudId: cloudId,
        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
    }, {
        fetchPolicy: 'store-or-network'
    });
    const branding = customerService?.brandingByEntityType;
    if (branding && '__typename' in branding && branding.__typename === 'CustomerServiceBranding') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9ufZj.BrandTileIcon), {
        brandingFragment: branding,
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bfbbl.CustomerExperienceIcon), {
        size: "small"
    });
};
$dbe63e7f77f563b4$var$NavCustomIconInnerWrapper.displayName = "NavCustomIconInnerWrapper";
const $dbe63e7f77f563b4$export$a28b5b938c71ae38 = ({ helpCenterId: helpCenterId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "NavCustomIcon",
        packageName: "jiraNavigationAppsSidebarNav4CustomerService",
        teamName: "boysenberry",
        sendToPrivacyUnsafeSplunk: true,
        fallback: $dbe63e7f77f563b4$var$iconFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav-custom-icon",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($dbe63e7f77f563b4$var$IconSkeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($dbe63e7f77f563b4$var$NavCustomIconInnerWrapper, {
        helpCenterId: helpCenterId
    })));
$dbe63e7f77f563b4$export$a28b5b938c71ae38.displayName = "NavCustomIcon";

});
parcelRegister("eyZel", function(module, exports) {
$parcel$export(module.exports, "default", () => $58e823b1113c1f59$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b6258fe0f5eade873f9bbd899fda968>>
 * @relayHash c1c4e71f20959aaa9cd20b7c9e9124d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0cfbbcc384b9fb870e75f735a20e543515db7cc1238dcfab060da390ccfbbfe9
const $58e823b1113c1f59$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "entityType",
            "value": "CUSTOMER_HUB"
        },
        {
            "kind": "Variable",
            "name": "helpCenterId",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NavCustomIconQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "brandingByEntityType",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "BrandTileIcon_branding"
                                        }
                                    ],
                                    "type": "CustomerServiceBranding"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NavCustomIconQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "brandingByEntityType",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceBrandingTile",
                                            "kind": "LinkedField",
                                            "name": "tile",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "CustomerServiceBranding"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0cfbbcc384b9fb870e75f735a20e543515db7cc1238dcfab060da390ccfbbfe9",
            "metadata": {},
            "name": "NavCustomIconQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$58e823b1113c1f59$var$node.hash = "af1be8b00d15b9b3afb2dfd91f546dbd";
var $58e823b1113c1f59$export$2e2bcd8739ae039 = $58e823b1113c1f59$var$node;

});

parcelRegister("bfbbl", function(module, exports) {
$parcel$export(module.exports, "CustomerExperienceIcon", () => $b9324294a24f63d1$export$63977fada59b69bf);
/* CustomerExperienceIcon.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage, jira/naming/disallow-filenames */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");
const $b9324294a24f63d1$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $b9324294a24f63d1$var$svgStyles = null;
const $b9324294a24f63d1$var$CustomerExperienceCustomIcon = ({ size: size = 'medium' })=>/*#__PURE__*/ $euxye.createElement((0, $c69sa.Box), {
        xcss: $b9324294a24f63d1$var$iconStyles
    }, /*#__PURE__*/ $euxye.createElement("svg", {
        viewBox: "-4 -4 24 24",
        role: "presentation",
        color: "var(--ds-icon)",
        className: (0, $4jQY2.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $b9324294a24f63d1$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $euxye.createElement("path", {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M1.789 1.513A.75.75 0 0 1 2.5 1h11a.75.75 0 0 1 .711.513l1.502 4.5a.8.8 0 0 1 .038.237A3.08 3.08 0 0 1 14 9.032V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.031A3.08 3.08 0 0 1 .25 6.25q0-.12.038-.237zM3.5 9.329V13a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9.33a3.08 3.08 0 0 1-2.166-1.064A3.08 3.08 0 0 1 8 9.334a3.08 3.08 0 0 1-2.334-1.068A3.08 3.08 0 0 1 3.5 9.329M4.916 6.25v.03a1.584 1.584 0 0 1-3.163.08l.037-.11zm1.5.038.005-.038h3.158l.004.038a1.584 1.584 0 0 1-3.166 0M9.413 4.75H6.588l.25-2.25h2.324zm1.672 1.5a1.584 1.584 0 0 0 3.164.11l-.037-.11zm2.626-1.5h-2.788l-.25-2.25h2.288zM5.33 2.5l-.25 2.25H2.29l.75-2.25z",
        clipRule: "evenodd"
    })));
$b9324294a24f63d1$var$CustomerExperienceCustomIcon.displayName = "CustomerExperienceCustomIcon";
const $b9324294a24f63d1$var$iconStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.accent.orange.subtlest.pressed'
});
const $b9324294a24f63d1$export$63977fada59b69bf = $b9324294a24f63d1$var$CustomerExperienceCustomIcon;

});

parcelRegister("9ufZj", function(module, exports) {
$parcel$export(module.exports, "BrandTileIcon", () => $1d19700817fa9fab$export$b7882788039897cb);

var $cBveG = parcelRequire("cBveG");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $9S1b6 = parcelRequire("9S1b6");

var $n67Vb = parcelRequire("n67Vb");

var $ihEDU = parcelRequire("ihEDU");

var $bfbbl = parcelRequire("bfbbl");
const $1d19700817fa9fab$var$styles = {
    iconHidden: "_1e0cglyw",
    iconVisible: "_1e0c1ule",
    image: "_1bsb1osq _4t3i1wug",
    iconContainerSmall: "_1bsb7vkz _4t3i7vkz",
    iconContainerMedium: "_1bsb1tcg _4t3i1tcg",
    iconContainerLarge: "_1bsbzwfg _4t3izwfg"
};
const $1d19700817fa9fab$var$sizeStyleMap = {
    small: $1d19700817fa9fab$var$styles.iconContainerSmall,
    medium: $1d19700817fa9fab$var$styles.iconContainerMedium,
    large: $1d19700817fa9fab$var$styles.iconContainerLarge
};
const $1d19700817fa9fab$export$b7882788039897cb = ({ brandingFragment: brandingFragment, size: size = 'medium' })=>{
    const [loaded, setLoaded] = (0, $euxye.useState)(false);
    const branding = (0, $n67Vb.useFragment)((0, $cBveG.default), brandingFragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: (0, $9S1b6.cx)($1d19700817fa9fab$var$sizeStyleMap[size], loaded ? $1d19700817fa9fab$var$styles.iconVisible : $1d19700817fa9fab$var$styles.iconHidden)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("img", {
        src: branding?.tile?.url ?? undefined,
        alt: "",
        onLoad: ()=>setLoaded(true),
        className: (0, $4jQY2.default)([
            $1d19700817fa9fab$var$styles.image
        ])
    })), !loaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bfbbl.CustomerExperienceIcon), {
        size: size
    }));
};
$1d19700817fa9fab$export$b7882788039897cb.displayName = "BrandTileIcon";

});
parcelRegister("cBveG", function(module, exports) {
$parcel$export(module.exports, "default", () => $64bdbc5e8809c459$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a496ec20d20f082ac795f237770515e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $64bdbc5e8809c459$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BrandTileIcon_branding",
    "selections": [
        {
            "concreteType": "CustomerServiceBrandingTile",
            "kind": "LinkedField",
            "name": "tile",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "url"
                }
            ]
        }
    ],
    "type": "CustomerServiceBranding"
};
$64bdbc5e8809c459$var$node.hash = "de388716609f5d80310df1e713c995ad";
var $64bdbc5e8809c459$export$2e2bcd8739ae039 = $64bdbc5e8809c459$var$node;

});



parcelRegister("9hI8t", function(module, exports) {
$parcel$export(module.exports, "ChannelsExpandableMenuItem", () => $597eae1412281da2$export$25da0a9d59bf7733);

var $euxye = parcelRequire("euxye");

var $4VtOS = parcelRequire("4VtOS");

var $aQCoC = parcelRequire("aQCoC");

var $5IkoH = parcelRequire("5IkoH");

var $g8Aut = parcelRequire("g8Aut");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");
const $597eae1412281da2$export$25da0a9d59bf7733 = ({ helpCenterId: helpCenterId, projectKey: projectKey, baseUrl: baseUrl, onItemClick: onItemClick })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        menuId: (0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCES_CHANNELS(helpCenterId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-customer-experience-channels",
        testId: `customer-experience-menu-channels-${projectKey.toLowerCase()}`,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g8Aut))), {
            label: "",
            color: "currentColor"
        })
    }, formatMessage($597eae1412281da2$var$channelsExpandableItemMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: `${baseUrl}/support-website/overview`,
        menuId: (0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'support-website'),
        onClick: ()=>onItemClick('SupportWebsite'),
        testId: `customer-experience-menu-support-website-${projectKey.toLowerCase()}`
    }, formatMessage($597eae1412281da2$var$supportWebsiteItemMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: `${baseUrl}/email`,
        menuId: (0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'email'),
        onClick: ()=>onItemClick('Email'),
        testId: `customer-experience-menu-email-${projectKey.toLowerCase()}`
    }, formatMessage($597eae1412281da2$var$emailItemMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: `${baseUrl}/embed`,
        menuId: (0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'embed'),
        onClick: ()=>onItemClick('Embed'),
        testId: `customer-experience-menu-embed-${projectKey.toLowerCase()}`
    }, formatMessage($597eae1412281da2$var$embedItemMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: `${baseUrl}/phone`,
        menuId: (0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'phone'),
        onClick: ()=>onItemClick('Voice'),
        testId: `customer-experience-menu-phone-${projectKey.toLowerCase()}`
    }, formatMessage($597eae1412281da2$var$voiceItemMessage)), (0, $i860n.fg)('csm-omni-whatsapp-support') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: `${baseUrl}/messaging-apps`,
        menuId: (0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'messaging-apps'),
        onClick: ()=>onItemClick('MessagingApps'),
        testId: `customer-experience-menu-messaging-apps-${projectKey.toLowerCase()}`
    }, formatMessage($597eae1412281da2$var$messagingAppsItemMessage))));
};
$597eae1412281da2$export$25da0a9d59bf7733.displayName = "ChannelsExpandableMenuItem";
const $597eae1412281da2$var$channelsExpandableItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.channels-expandable-item",
    defaultMessage: "Channels"
});
const $597eae1412281da2$var$supportWebsiteItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.support-website-item",
    defaultMessage: "Support website"
});
const $597eae1412281da2$var$emailItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.email-item",
    defaultMessage: "Email"
});
const $597eae1412281da2$var$embedItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.embed-item",
    defaultMessage: "Embed"
});
const $597eae1412281da2$var$voiceItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.voice-item",
    defaultMessage: "Voice"
});
const $597eae1412281da2$var$messagingAppsItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.customer-experience-menu.messaging-apps-item",
    defaultMessage: "Messaging apps"
});

});
parcelRegister("g8Aut", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b91be0c0d8036a327d36beba8328d06>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bbf9b2ef54c86644$var$_react = $bbf9b2ef54c86644$var$_interopRequireDefault((parcelRequire("euxye")));

var $bbf9b2ef54c86644$var$_baseNew = $bbf9b2ef54c86644$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $bbf9b2ef54c86644$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/changes
 * Usage guidance:
 * Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bbf9b2ef54c86644$var$ChangesIcon = (props)=>/*#__PURE__*/ $bbf9b2ef54c86644$var$_react.default.createElement($bbf9b2ef54c86644$var$_baseNew.default, Object.assign({
        name: "ChangesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$bbf9b2ef54c86644$var$ChangesIcon.displayName = 'ChangesIcon';
var $bbf9b2ef54c86644$var$_default = module.exports.default = $bbf9b2ef54c86644$var$ChangesIcon;

});




parcelRegister("i1bYM", function(module, exports) {
$parcel$export(module.exports, "ViewAllExperiencesMenuItem", () => $90d21c4ed3b22321$export$c15ad54560bc1b35);

var $euxye = parcelRequire("euxye");



var $5IkoH = parcelRequire("5IkoH");

var $bEZ9g = parcelRequire("bEZ9g");

var $djYhH = parcelRequire("djYhH");

var $ar9gx = parcelRequire("ar9gx");

var $6w18e = parcelRequire("6w18e");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $inMxE = parcelRequire("inMxE");

var $aJ81Y = parcelRequire("aJ81Y");

var $i860n = parcelRequire("i860n");

var $5aSWy = parcelRequire("5aSWy");
const $90d21c4ed3b22321$var$CSM_EXPERIENCES_HREF = '/jira/customer-service-management/experiences';
const $90d21c4ed3b22321$export$c15ad54560bc1b35 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const href = (0, $i860n.fg)('csm_appification_standalone_navigation') ? $90d21c4ed3b22321$var$CSM_EXPERIENCES_HREF : (0, $5aSWy.CUSTOMER_SERVICE_HREF);
    const viewAllExperiencesClickHandler = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'customerExperiencesViewAllMenuItem',
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                itemId: 'viewAllExperiences'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEZ9g.ViewAllEntityMenuItem), {
        href: href,
        menuId: (0, $5IkoH.MENU_ID_CUSTOMER_EXPERIENCES_VIEW_ALL),
        onClick: viewAllExperiencesClickHandler
    }, formatMessage($90d21c4ed3b22321$var$viewAllExperiencesMessage)))));
};
$90d21c4ed3b22321$export$c15ad54560bc1b35.displayName = "ViewAllExperiencesMenuItem";
const $90d21c4ed3b22321$var$viewAllExperiencesMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps.sidebar-nav4.customer-service.view-all-experiences",
    defaultMessage: "View all experiences"
});

});
parcelRegister("bEZ9g", function(module, exports) {
$parcel$export(module.exports, "ViewAllEntityMenuItem", () => $848c0ddf1ac89b94$export$505e81ff2081288b);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $aNG0w = parcelRequire("aNG0w");

var $aQCoC = parcelRequire("aQCoC");
function $848c0ddf1ac89b94$export$505e81ff2081288b(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        ...props,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))), {
            label: "",
            color: "currentColor"
        })
    });
}
$848c0ddf1ac89b94$export$505e81ff2081288b.displayName = "ViewAllEntityMenuItem";

});

parcelRegister("5aSWy", function(module, exports) {
$parcel$export(module.exports, "CUSTOMER_SERVICE_HREF", () => $071705522752d89a$export$208752a9164e5a6d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $aQCoC = parcelRequire("aQCoC");

var $dx7aH = parcelRequire("dx7aH");

var $2DbWL = parcelRequire("2DbWL");

var $gbTMi = parcelRequire("gbTMi");

var $c9cNX = parcelRequire("c9cNX");

var $hKd0r = parcelRequire("hKd0r");

var $jepRN = parcelRequire("jepRN");

var $72ldR = parcelRequire("72ldR");
const $071705522752d89a$export$208752a9164e5a6d = '/jira/helpcenter';
const $071705522752d89a$export$276375fee74f0f11 = (0, $jepRN.componentWithFG)('navx-global-side-nav', $071705522752d89a$var$CustomerServiceMenuLinkItemNEW, $071705522752d89a$var$CustomerServiceMenuLinkItemOLD);
function $071705522752d89a$var$CustomerServiceMenuLinkItemNEW(props) {
    const { draggableRef: draggableRef, dropIndicator: dropIndicator, hasDragIndicator: hasDragIndicator, isDragging: isDragging, visualContentRef: visualContentRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE);
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const ref = draggableRef;
    const analytics = (0, $hKd0r.getMenuItemAnalytics)({
        actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_CUSTOMER_SERVICE],
        itemId: 'customer-experiences',
        level: 1
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        analytics: analytics,
        dropIndicator: dropIndicator,
        elemBefore: icon,
        hasDragIndicator: hasDragIndicator,
        href: $071705522752d89a$export$208752a9164e5a6d,
        isDragging: isDragging,
        menuId: (0, $5IkoH.MENU_ID_CUSTOMER_SERVICE),
        ref: ref,
        visualContentRef: visualContentRef
    }, formattedMessage);
}
$071705522752d89a$var$CustomerServiceMenuLinkItemNEW.displayName = "CustomerServiceMenuLinkItemNEW";
function $071705522752d89a$var$CustomerServiceMenuLinkItemOLD() {
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE);
    const analytics = (0, $hKd0r.getMenuItemAnalytics)({
        actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_CUSTOMER_SERVICE],
        itemId: 'customer-experiences',
        level: 1
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.ui.sidenav-customer-service",
        href: $071705522752d89a$export$208752a9164e5a6d,
        menuId: (0, $5IkoH.MENU_ID_CUSTOMER_SERVICE),
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
            MenuItems: $071705522752d89a$var$MenuItems,
            name: formattedMessage
        }),
        analytics: analytics
    }, formattedMessage);
}
$071705522752d89a$var$CustomerServiceMenuLinkItemOLD.displayName = "CustomerServiceMenuLinkItemOLD";
const $071705522752d89a$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2DbWL.HideL1MenuItemSection), {
        menuId: (0, $5IkoH.MENU_ID_CUSTOMER_SERVICE),
        hasSeparator: false
    }));
$071705522752d89a$var$MenuItems.displayName = "MenuItems";

});
parcelRegister("hKd0r", function(module, exports) {
$parcel$export(module.exports, "getMenuItemAnalytics", () => $fa720c6f2e4e3f79$export$2425daf64d04c16b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
const $fa720c6f2e4e3f79$export$2425daf64d04c16b = ({ componentType: componentType = (0, $6e2f51712bb2e810$export$4165a3d0da3bd147), itemId: itemId, ...restAttrs })=>({
        componentType: componentType,
        itemId: itemId,
        ...restAttrs
    });

});




parcelRegister("1dpwK", function(module, exports) {
$parcel$export(module.exports, "CreateExperienceButton", () => $0b456e279b8a955c$export$78181ba767903483);

var $euxye = parcelRequire("euxye");

var $eO8S8 = parcelRequire("eO8S8");

var $aVsrW = parcelRequire("aVsrW");

var $hVV7V = parcelRequire("hVV7V");

var $8b7jh = parcelRequire("8b7jh");

var $ikOED = parcelRequire("ikOED");

var $hZDXn = parcelRequire("hZDXn");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");

var $881dx = parcelRequire("881dx");
var $55BnK = parcelRequire("55BnK");

var $i860n = parcelRequire("i860n");
const $0b456e279b8a955c$var$createExperienceButtonIcon = (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ikOED))), {
        ...iconProps,
        size: "small"
    });
const $0b456e279b8a955c$export$78181ba767903483 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { push: push } = (0, $55BnK.useRouterActions)();
    const onClick = (0, $euxye.useCallback)((_e, analyticsEvent)=>{
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'customerExperiencesAddCustomerExperience', {
            entry: 'Nav4Sidebar'
        });
    }, []);
    const handleCreateHub = (0, $euxye.useCallback)((data)=>{
        if (data) {
            const path = (0, $881dx.generatePath)((0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $hVV7V.csmExperienceDetailsRoute).path : (0, $8b7jh.helpCenterSettingsDetailsRoute).path, {
                helpCenterId: data.customerHubId,
                projectKey: data.projectKey
            });
            push(path);
        }
    }, [
        push
    ]);
    const entryPointProps = (0, $euxye.useMemo)(()=>({
            onCreateHub: handleCreateHub
        }), [
        handleCreateHub
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aVsrW.CreateHubModalTrigger), {
        entryPointProps: entryPointProps
    }, ({ buttonRef: buttonRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
            content: formatMessage($0b456e279b8a955c$var$createExperienceMessage)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eO8S8.CommonNavMenuButton), {
            ref: buttonRef,
            icon: $0b456e279b8a955c$var$createExperienceButtonIcon,
            label: formatMessage($0b456e279b8a955c$var$createExperienceMessage),
            onClick: onClick
        })));
};
$0b456e279b8a955c$export$78181ba767903483.displayName = "CreateExperienceButton";
const $0b456e279b8a955c$var$createExperienceMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.ui.create-experience",
    defaultMessage: "Create experience"
});

});
parcelRegister("aVsrW", function(module, exports) {
$parcel$export(module.exports, "CreateHubModalTrigger", () => $0196769064adeb61$export$802e83557210267b);

var $euxye = parcelRequire("euxye");

var $6mSn8 = parcelRequire("6mSn8");

var $fFNvS = parcelRequire("fFNvS");

var $lJ5Hr = parcelRequire("lJ5Hr");
const $0196769064adeb61$export$802e83557210267b = ({ children: children, entryPointProps: entryPointProps })=>{
    const renderTrigger = ({ ref: ref })=>{
        return children({
            buttonRef: (0, $fFNvS.mergeRefs)(ref)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6mSn8.FullScreenModalTrigger), {
        entryPoint: (0, $lJ5Hr.createHubModalEntryPoint),
        entryPointProps: entryPointProps
    }, renderTrigger);
};
$0196769064adeb61$export$802e83557210267b.displayName = "CreateHubModalTrigger";

});
parcelRegister("6mSn8", function(module, exports) {
$parcel$export(module.exports, "FullScreenModalTrigger", () => $4dcb41686f65c51d$export$ad55650562d4c65b);

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $fsEVO = parcelRequire("fsEVO");

var $2oRWW = parcelRequire("2oRWW");

var $khR7F = parcelRequire("khR7F");

var $iqfTZ = parcelRequire("iqfTZ");

var $63Rm5 = parcelRequire("63Rm5");

var $8EpkY = parcelRequire("8EpkY");

var $gAEFP = parcelRequire("gAEFP");

var $cxpqA = parcelRequire("cxpqA");

var $jp9KZ = parcelRequire("jp9KZ");

var $75ag9 = parcelRequire("75ag9");

var $kvOpQ = parcelRequire("kvOpQ");
const $4dcb41686f65c51d$var$emptyEntryPointParams = {};
const $4dcb41686f65c51d$var$emptyEntryPointProps = {};
function $4dcb41686f65c51d$export$ad55650562d4c65b({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, preloadOnFocus: preloadOnFocus = true, loadingText: loadingText }) {
    const { openModal: openModal } = (0, $euxye.useContext)((0, $jp9KZ.ModalContext));
    const environmentProvider = (0, $cxpqA.useRelayEnvironmentProvider)();
    const { GlobalModalErrorFallback: GlobalModalErrorFallback } = (0, $63Rm5.useEntryPointConfig)();
    const modalRef = (0, $euxye.useRef)(null);
    const metricName = (0, $euxye.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $euxye.useCallback)(()=>(0, $n67Vb.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $4dcb41686f65c51d$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $euxye.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gAEFP.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(GlobalModalErrorFallback, {
                        error: error,
                        closeModal: (0, $iqfTZ.fg)('platform_dst-a11y_move-close-modal') ? closeModal : (0, $2oRWW.default)
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                    if (!(0, $iqfTZ.fg)('platform_dst-a11y_move-close-modal')) closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Fallback, {
                    onClose: closeModal
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kvOpQ.Loading), {
                    title: title,
                    loadingText: loadingText
                }),
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $4dcb41686f65c51d$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
                }
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $khR7F.FullScreenModalDialog), {
                ...modalProps,
                onClose: onClose,
                ref: modalRef,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress
            }, container, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $75ag9.FocusInsideOnLoad), {
                entryPointReference: entryPointReference,
                autoFocusRef: modalProps?.autoFocus,
                modalRef: modalRef
            }));
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        GlobalModalErrorFallback,
        onError,
        loadingText
    ]);
    const triggerRef = (0, $8EpkY.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $fsEVO.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}
$4dcb41686f65c51d$export$ad55650562d4c65b.displayName = "FullScreenModalTrigger";

});
parcelRegister("khR7F", function(module, exports) {
$parcel$export(module.exports, "FullScreenModalDialog", () => $ac998934656e8526$export$103e9686fdc354e8);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4GQwg = parcelRequire("4GQwg");

var $9imxF = parcelRequire("9imxF");

var $gpyJM = parcelRequire("gpyJM");

var $dNPnD = parcelRequire("dNPnD");

var $2v3yi = parcelRequire("2v3yi");

const $ac998934656e8526$export$103e9686fdc354e8 = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4GQwg.default), {
        ...props,
        /**
			 * Making this an internal-only prop and exposing it through a facade
			 * component so that we can keep public types simple.
			 *
			 * Otherwise we need complex conditional types that are harder to
			 * understand / maintain and aren't actually any better for consumers.
			 */ isFullScreen: true,
        /**
			 * Setting width and height to 100% because the `isFullScreen` prop just
			 * removes the spacing around the modal. We still need to set the size to
			 * be 100%.
			 *
			 * Intentionally reusing the existing internals as much as possible to
			 * keep complexity low and avoid duplication. It also makes the fullscreen
			 * changes easier to remove.
			 */ width: "100%",
        height: "100%",
        /**
			 * Full screen modals only support body scrolling, so that the header
			 * and close button will always stay visible.
			 */ shouldScrollInViewport: false,
        /**
			 * This prop is a noop for fullscreen modals, so we aren't exposing it to consumers.
			 * Using `false` internally to avoid potential bugs.
			 */ shouldCloseOnOverlayClick: false,
        /**
			 * The blanket is only briefly visible for fullscreen modals when fading in,
			 * but provides a bit more of a visual cue that it has appeared on top.
			 *
			 * We don't want consumers to disable it.
			 */ isBlanketHidden: false,
        ref: ref
    });
});
$ac998934656e8526$export$103e9686fdc354e8.displayName = 'FullScreenModalDialog';

});


parcelRegister("lJ5Hr", function(module, exports) {
$parcel$export(module.exports, "createHubModalEntryPoint", () => $83b11518ef5d6024$export$3cd48aa2c8d22491);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $83b11518ef5d6024$export$3cd48aa2c8d22491 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("iSr3r")), {
        moduleId: "ed526ea8",
        moduleName: "CreateHubModalEntryPoint",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iSr3r", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8bQAZ").then(()=>parcelRequire('647yi'));

});



parcelRegister("hVV7V", function(module, exports) {
$parcel$export(module.exports, "csmExperienceDetailsRoute", () => $ad3a7f6a4b638509$export$14069bf3c105b03d);
const $ad3a7f6a4b638509$export$14069bf3c105b03d = {
    name: 'csm-experience-details',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/details',
    exact: true
};

});

parcelRegister("8b7jh", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsDetailsRoute", () => $0e3d6232bc48ef20$export$f54c1546ddea019b);
const $0e3d6232bc48ef20$export$f54c1546ddea019b = {
    name: 'helpcenter-settings-details',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/details',
    exact: true
};

});




parcelRegister("gaQ4v", function(module, exports) {
$parcel$export(module.exports, "Customers", () => $fe0e8786a4088bac$export$d697df66e097e160);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $gDdYI = parcelRequire("gDdYI");

var $cFXok = parcelRequire("cFXok");
const $fe0e8786a4088bac$export$d697df66e097e160 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-customers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "flag",
        id: "assets",
        packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCustomers",
        teamName: "Boysenberry"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cFXok.CustomersMenuLinkItem), props)));
$fe0e8786a4088bac$export$d697df66e097e160.displayName = "Customers";

});
parcelRegister("cFXok", function(module, exports) {
$parcel$export(module.exports, "CustomersMenuLinkItem", () => $a2e65f91dfd8970a$export$a2f8bc926cb9a0fa);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $5IkoH = parcelRequire("5IkoH");

var $aQCoC = parcelRequire("aQCoC");

var $dx7aH = parcelRequire("dx7aH");

var $2DbWL = parcelRequire("2DbWL");

var $gbTMi = parcelRequire("gbTMi");

var $cqZ9R = parcelRequire("cqZ9R");

var $hKd0r = parcelRequire("hKd0r");

var $c9cNX = parcelRequire("c9cNX");

var $jepRN = parcelRequire("jepRN");

var $km8ee = parcelRequire("km8ee");

var $72ldR = parcelRequire("72ldR");

var $i860n = parcelRequire("i860n");

var $881dx = parcelRequire("881dx");
const $a2e65f91dfd8970a$export$a2f8bc926cb9a0fa = (0, $jepRN.componentWithFG)('navx-global-side-nav', $a2e65f91dfd8970a$var$CustomersMenuLinkItemNEW, $a2e65f91dfd8970a$var$CustomersMenuLinkItemOLD);
function $a2e65f91dfd8970a$var$CustomersMenuLinkItemNEW(props) {
    const { draggableRef: draggableRef, dropIndicator: dropIndicator, hasDragIndicator: hasDragIndicator, isDragging: isDragging, visualContentRef: visualContentRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $5IkoH.MENU_ID_CUSTOMERS));
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const ref = draggableRef;
    const analytics = (0, $hKd0r.getMenuItemAnalytics)({
        actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_CUSTOMERS],
        itemId: 'customers',
        level: 1
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        analytics: analytics,
        dropIndicator: dropIndicator,
        elemBefore: icon,
        hasDragIndicator: hasDragIndicator,
        href: (0, $881dx.generatePath)((0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $km8ee.csmCustomersRoute).path : (0, $cqZ9R.customerServiceCustomersRoute).path),
        isDragging: isDragging,
        menuId: (0, $5IkoH.MENU_ID_CUSTOMERS),
        ref: ref,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-content-customers.ui.sidenav-customers",
        visualContentRef: visualContentRef
    }, formattedMessage);
}
$a2e65f91dfd8970a$var$CustomersMenuLinkItemNEW.displayName = "CustomersMenuLinkItemNEW";
function $a2e65f91dfd8970a$var$CustomersMenuLinkItemOLD() {
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $5IkoH.MENU_ID_CUSTOMERS));
    const analytics = (0, $hKd0r.getMenuItemAnalytics)({
        actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_CUSTOMERS],
        itemId: 'customers',
        level: 1
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-content-customers.ui.sidenav-customers",
        href: (0, $881dx.generatePath)((0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $km8ee.csmCustomersRoute).path : (0, $cqZ9R.customerServiceCustomersRoute).path),
        menuId: (0, $5IkoH.MENU_ID_CUSTOMERS),
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
            MenuItems: $a2e65f91dfd8970a$var$MenuItems,
            name: formattedMessage
        }),
        analytics: analytics
    }, formattedMessage);
}
$a2e65f91dfd8970a$var$CustomersMenuLinkItemOLD.displayName = "CustomersMenuLinkItemOLD";
const $a2e65f91dfd8970a$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2DbWL.HideL1MenuItemSection), {
        menuId: (0, $5IkoH.MENU_ID_CUSTOMERS),
        hasSeparator: false
    }));
$a2e65f91dfd8970a$var$MenuItems.displayName = "MenuItems";

});
parcelRegister("cqZ9R", function(module, exports) {
$parcel$export(module.exports, "customerServiceCustomersRoute", () => $ad00136a2b6489b8$export$2391fb29392d13ce);
const $ad00136a2b6489b8$export$2391fb29392d13ce = {
    name: 'customer-service-customers',
    path: '/jira/customer-service/customers',
    exact: true
};

});

parcelRegister("km8ee", function(module, exports) {
$parcel$export(module.exports, "csmCustomersRoute", () => $ffc1093330261a12$export$7a2a93fccf51b432);
const $ffc1093330261a12$export$7a2a93fccf51b432 = {
    name: 'csm-customers',
    path: '/jira/customer-service-management/customers',
    exact: true
};

});



parcelRegister("jdVag", function(module, exports) {
$parcel$export(module.exports, "HelpCenterManagement", () => $7a942566a8488d5f$export$13604ad2569bbee1);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $gDdYI = parcelRequire("gDdYI");

var $2cnNT = parcelRequire("2cnNT");
const $7a942566a8488d5f$export$13604ad2569bbee1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-help-center-management"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "flag",
        id: "helpCenterManagement",
        packageName: "jiraNavigationAppsSidebarNav4SidebarsContentHelpCenterManagement",
        teamName: "jsm-megatron"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2cnNT.HelpCenterManagementMenuLinkItem), props)));
$7a942566a8488d5f$export$13604ad2569bbee1.displayName = "HelpCenterManagement";

});
parcelRegister("2cnNT", function(module, exports) {
$parcel$export(module.exports, "HelpCenterManagementMenuLinkItem", () => $30fbfebd687d89a6$export$54b4213bc74ce492);

var $euxye = parcelRequire("euxye");

var $5IkoH = parcelRequire("5IkoH");

var $aQCoC = parcelRequire("aQCoC");

var $dx7aH = parcelRequire("dx7aH");

var $hKd0r = parcelRequire("hKd0r");

var $c9cNX = parcelRequire("c9cNX");

var $gVLP4 = parcelRequire("gVLP4");

var $881dx = parcelRequire("881dx");
const $30fbfebd687d89a6$export$54b4213bc74ce492 = (props)=>{
    const { draggableRef: draggableRef, dropIndicator: dropIndicator, hasDragIndicator: hasDragIndicator, isDragging: isDragging, visualContentRef: visualContentRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $5IkoH.MENU_ID_HELP_CENTER_MANAGEMENT));
    const analytics = (0, $euxye.useMemo)(()=>(0, $hKd0r.getMenuItemAnalytics)({
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_HELP_CENTER_MANAGEMENT],
            itemId: 'helpCenterManagement',
            level: 1
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        analytics: analytics,
        dropIndicator: dropIndicator,
        elemBefore: icon,
        hasDragIndicator: hasDragIndicator,
        href: (0, $881dx.generatePath)((0, $gVLP4.helpCenterManagementRoute).path),
        isDragging: isDragging,
        menuId: (0, $5IkoH.MENU_ID_HELP_CENTER_MANAGEMENT),
        // oxlint-disable-next-line typescript/consistent-type-assertions
        ref: draggableRef,
        testId: "sidebar-nav4-sidebars-content-help-center-management.sidenav-help-center-management",
        visualContentRef: visualContentRef
    }, formattedMessage);
};
$30fbfebd687d89a6$export$54b4213bc74ce492.displayName = "HelpCenterManagementMenuLinkItem";

});
parcelRegister("gVLP4", function(module, exports) {
$parcel$export(module.exports, "helpCenterManagementRoute", () => $f9a49a05a87561f1$export$d653ef5139e58346);
const $f9a49a05a87561f1$export$d653ef5139e58346 = {
    exact: true,
    name: 'helpcenter-management',
    path: '/jira/helpcenter-management'
};

});



parcelRegister("3LwTA", function(module, exports) {
$parcel$export(module.exports, "Nav4Dashboards", () => $f01b58f61feb3868$export$14aa7c6c8f362b5b);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $gDdYI = parcelRequire("gDdYI");

var $1nXcF = parcelRequire("1nXcF");

var $2NPCN = parcelRequire("2NPCN");

const $f01b58f61feb3868$export$14aa7c6c8f362b5b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-dashboards"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "flag",
        id: "dashboards-section",
        packageName: (0, $00c4a880251c1b35$export$b8b9d90f9e5bd72b),
        teamName: (0, $00c4a880251c1b35$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2NPCN.AnalyticContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1nXcF.Nav4Dashboards), props))));
$f01b58f61feb3868$export$14aa7c6c8f362b5b.displayName = "Nav4Dashboards";

});
parcelRegister("1nXcF", function(module, exports) {
$parcel$export(module.exports, "Nav4Dashboards", () => $1381f236cf3caa93$export$14aa7c6c8f362b5b);

var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $l3eoS = parcelRequire("l3eoS");

var $hO97P = parcelRequire("hO97P");
function $1381f236cf3caa93$export$14aa7c6c8f362b5b(props) {
    const actionButtons = (0, $euxye.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l3eoS.ActionButtons), null), []);
    const isExpandedValue = (0, $i860n.fg)('navx-global-side-nav') ? !!props.isExpandOrFlyoutOpen && props.isExpanded : props.isExpanded;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hO97P.DashboardsDefault), {
        actionsOnHover: actionButtons,
        ...props,
        isExpanded: isExpandedValue
    });
}
$1381f236cf3caa93$export$14aa7c6c8f362b5b.displayName = "Nav4Dashboards";

});
parcelRegister("l3eoS", function(module, exports) {
$parcel$export(module.exports, "ActionButtons", () => $286e6f94409bfee7$export$88c65d2d98aab183);

var $euxye = parcelRequire("euxye");

var $2qjhu = parcelRequire("2qjhu");

var $6GljB = parcelRequire("6GljB");

var $eO8S8 = parcelRequire("eO8S8");

var $2DbWL = parcelRequire("2DbWL");

var $gbTMi = parcelRequire("gbTMi");

var $4Onaa = parcelRequire("4Onaa");

var $gRWK8 = parcelRequire("gRWK8");

var $hZDXn = parcelRequire("hZDXn");

var $72ldR = parcelRequire("72ldR");

var $ikOED = parcelRequire("ikOED");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $881dx = parcelRequire("881dx");
var $55BnK = parcelRequire("55BnK");

var $i860n = parcelRequire("i860n");


var $2NPCN = parcelRequire("2NPCN");
const $286e6f94409bfee7$var$createDashboard = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.action-buttons.create-dashboard",
    defaultMessage: "Create dashboard"
});
const $286e6f94409bfee7$var$dashboards = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.action-buttons.dashboards",
    defaultMessage: "Dashboards"
});
function $286e6f94409bfee7$export$88c65d2d98aab183() {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [, { off: modalClose }] = (0, $gRWK8.useSwitchModals)('DASHBOARD_CREATE');
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const { path: path } = (0, $4Onaa.useRouteByName)('dashboard-edit') ?? {};
    const { push: push } = (0, $55BnK.useRouterActions)();
    const onSuccess = (0, $euxye.useCallback)((_, { id: id })=>{
        path && push((0, $881dx.generatePath)(path, {
            dashboardId: id
        }));
        setIsOpen(false);
        modalClose();
    }, [
        modalClose,
        path,
        push
    ]);
    const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton } = (0, $euxye.useContext)((0, $2NPCN.AnalyticContext));
    const onCancelCreateDashboardModal = (0, $euxye.useCallback)(()=>{
        setIsOpen(false);
        modalClose();
    }, [
        modalClose
    ]);
    const onClickCommonNavMenuButton = (0, $euxye.useCallback)(()=>{
        fireUIAnalyticForFixButton({
            itemId: (0, $00c4a880251c1b35$export$7be02fe416808d26)
        });
        setIsOpen(true);
    }, [
        fireUIAnalyticForFixButton
    ]);
    const onOpenMoreNavMenuButton = (0, $euxye.useCallback)(()=>fireUIAnalyticForFixButton({
            itemId: (0, $00c4a880251c1b35$export$f06dfcec5ff912e)
        }), [
        fireUIAnalyticForFixButton
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2qjhu.default), {
        onSuccess: onSuccess,
        onCancel: onCancelCreateDashboardModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        content: formatMessage($286e6f94409bfee7$var$createDashboard)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eO8S8.CommonNavMenuButton), {
        interactionName: "nav4-sidebar-dashboards-create-button",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ikOED))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage($286e6f94409bfee7$var$createDashboard),
        onClick: onClickCommonNavMenuButton
    })), !(0, $i860n.fg)('navx-global-side-nav') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
        onOpen: onOpenMoreNavMenuButton,
        MenuItems: $286e6f94409bfee7$var$MenuItems,
        name: formatMessage($286e6f94409bfee7$var$dashboards)
    }));
}
$286e6f94409bfee7$export$88c65d2d98aab183.displayName = "ActionButtons";
const $286e6f94409bfee7$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2DbWL.HideL1MenuItemSection), {
        menuId: (0, $6GljB.L1_MENU_ID).DASHBOARDS,
        hasSeparator: false
    }));
$286e6f94409bfee7$var$MenuItems.displayName = "MenuItems";

});
/* eslint-disable jira/filename-case */ const $00c4a880251c1b35$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Dashboards';
const $00c4a880251c1b35$export$d57b6b390e78d90f = 'jira-cosmos';
const $00c4a880251c1b35$export$65b778215f917c60 = 'viewAllDashboards';
const $00c4a880251c1b35$export$7be02fe416808d26 = 'createDashboard';
const $00c4a880251c1b35$export$f06dfcec5ff912e = 'meatballDropdown';

parcelRegister("2NPCN", function(module, exports) {
$parcel$export(module.exports, "AnalyticContext", () => $a16cc230bec02539$export$da0556bf821b3494);
$parcel$export(module.exports, "AnalyticContextProvider", () => $a16cc230bec02539$export$aea8e3edcdec81e3);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");




var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

const $a16cc230bec02539$export$da0556bf821b3494 = /*#__PURE__*/ (0, $euxye.createContext)({
    fireUIAnalyticForFixMenuItem: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    fireUIAnalyticForFixButton: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    fireUIAnalyticForFavouriteToggle: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    fireUIAnalyticForDashboardItems: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
});
const $a16cc230bec02539$export$aea8e3edcdec81e3 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireUIAnalyticForFixMenuItem = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                itemId: (0, $00c4a880251c1b35$export$65b778215f917c60)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFixButton = (0, $euxye.useCallback)(({ itemId: itemId })=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
                itemId: itemId
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFavouriteToggle = (0, $euxye.useCallback)(({ starType: starType, parentItemId: parentItemId })=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                componentType: (0, $6e2f51712bb2e810$export$74712b62056d422e),
                parentItemId: parentItemId,
                parentItemType: 'dashboard',
                itemId: starType
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForDashboardItems = (0, $euxye.useCallback)(({ itemId: itemId, section: section })=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
                itemType: (0, $687cb22024c607c7$export$4695c1a423ffe431).toLowerCase(),
                itemId: itemId,
                section: section
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const memoValue = (0, $euxye.useMemo)(()=>({
            fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem,
            fireUIAnalyticForFixButton: fireUIAnalyticForFixButton,
            fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle,
            fireUIAnalyticForDashboardItems: fireUIAnalyticForDashboardItems
        }), [
        fireUIAnalyticForDashboardItems,
        fireUIAnalyticForFavouriteToggle,
        fireUIAnalyticForFixButton,
        fireUIAnalyticForFixMenuItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a16cc230bec02539$export$da0556bf821b3494.Provider, {
        value: memoValue
    }, children);
};
$a16cc230bec02539$export$aea8e3edcdec81e3.displayName = "AnalyticContextProvider";

});


parcelRegister("hO97P", function(module, exports) {
$parcel$export(module.exports, "DashboardsDefault", () => $b33755d188d10be0$export$bffc92c7e4f51e0b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jreC0 = parcelRequire("jreC0");

var $bOwox = parcelRequire("bOwox");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $4VtOS = parcelRequire("4VtOS");

var $gEDfa = parcelRequire("gEDfa");

var $jzXAj = parcelRequire("jzXAj");

var $3rqDf = parcelRequire("3rqDf");

var $dx7aH = parcelRequire("dx7aH");

var $hDvet = parcelRequire("hDvet");


var $btoiF = parcelRequire("btoiF");

var $f1JKW = parcelRequire("f1JKW");

var $kFgCO = parcelRequire("kFgCO");

var $jepRN = parcelRequire("jepRN");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $h3LJR = parcelRequire("h3LJR");

var $fFNvS = parcelRequire("fFNvS");

var $kt86l = parcelRequire("kt86l");


var $jSP8C = parcelRequire("jSP8C");

var $h3uMu = parcelRequire("h3uMu");
const $b33755d188d10be0$var$DashboardsDefaultInner = (0, $jepRN.componentWithFG)('navx-global-side-nav', $b33755d188d10be0$var$DashboardsDefaultInnerNEW, $b33755d188d10be0$var$DashboardsDefaultInnerOLD);
const $b33755d188d10be0$export$bffc92c7e4f51e0b = /*#__PURE__*/ (0, $euxye.memo)($b33755d188d10be0$var$DashboardsDefaultInner);
function $b33755d188d10be0$var$DashboardsDefaultInnerNEW(props) {
    const { actionsOnHover: actionsOnHover, draggableRef: draggableRef, dropIndicator: dropIndicator, hasDragIndicator: hasDragIndicator, isDragging: isDragging, isExpanded: isExpanded, onExpandFlyoutToggle: onExpandFlyoutToggle, visualContentRef: visualContentRef } = props;
    const cloudId = (0, $kt86l.useCloudId)();
    const { data: { user: { accountId: accountId } } } = (0, $kFgCO.useCurrentUser)();
    const activationId = (0, $h3LJR.useActivationId)();
    // Ignore this error as our component does not need the context.
    // @ts-expect-error - Property 'context' is missing in type '{ tenantContext: { cloudId: string; }; }' but required in type 'EntryPointRouteParams'.ts(2741)
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId,
                atlassianAccountId: accountId,
                activationId: activationId
            }
        }), [
        cloudId,
        accountId,
        activationId
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const leftSidebarEPRef = (0, $btoiF.usePageLayoutEntryPoint)((0, $b666e36d39b806ff$export$50ea883ba6f28ff5));
    const dashboardsEPRef = leftSidebarEPRef?.entryPoints?.dashboards;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $h3uMu.nav4DashboardsContentEntryPoint), entryPointParams);
    const triggerRef = (0, $hDvet.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).DASHBOARDS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const epContainerProps = (0, $euxye.useMemo)(()=>({
            id: 'nav4-sidebar-dashboards-default',
            packageName: (0, $00c4a880251c1b35$export$b8b9d90f9e5bd72b),
            teamName: (0, $00c4a880251c1b35$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), {
                withHeading: true
            }),
            // oxlint-disable-next-line typescript/consistent-type-assertions
            runtimeProps: entryPointParams
        }), [
        entryPointParams
    ]);
    // This callback makes sure that the EP is loaded when the _system_ determines that the expandable
    // should be open.
    const handleSystemToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const handleExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            sendSectionItemAnalyticsEvent({
                menuId: (0, $6GljB.L1_MENU_ID).DASHBOARDS,
                sectionItem: (0, $bOwox.SECTION_ITEM_DASHBOARDS)
            });
        }
        onExpandFlyoutToggle?.(hasExpanded);
    }, [
        entryPointActions,
        onExpandFlyoutToggle,
        sendSectionItemAnalyticsEvent
    ]);
    const menuId = (0, $5IkoH.MENU_ID_DASHBOARDS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        dropTargetRef: visualContentRef,
        dropIndicator: dropIndicator,
        isDragging: isDragging,
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: handleSystemToggle,
        onExpansionToggle: handleExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-dashboards-default",
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        hasDragIndicator: hasDragIndicator,
        isDragging: isDragging,
        ref: draggableRef ? (0, $fFNvS.mergeRefs)(triggerRef, draggableRef) : triggerRef,
        testId: (0, $jzXAj.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f1JKW.RouteEntryPointContainer), {
        epContainerProps: epContainerProps,
        jiraEPRef: entryPointReferenceSubject,
        nestedEPRef: dashboardsEPRef,
        placeholderEntryPoint: (0, $h3uMu.nav4DashboardsContentEntryPoint)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jSP8C.Footer), null)));
}
$b33755d188d10be0$var$DashboardsDefaultInnerNEW.displayName = "DashboardsDefaultInnerNEW";
function $b33755d188d10be0$var$DashboardsDefaultInnerOLD(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded } = props;
    const cloudId = (0, $kt86l.useCloudId)();
    const { data: { user: { accountId: accountId } } } = (0, $kFgCO.useCurrentUser)();
    const activationId = (0, $h3LJR.useActivationId)();
    // Ignore this error as our component does not need the context.
    // @ts-expect-error - Property 'context' is missing in type '{ tenantContext: { cloudId: string; }; }' but required in type 'EntryPointRouteParams'.ts(2741)
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId,
                atlassianAccountId: accountId,
                activationId: activationId
            }
        }), [
        cloudId,
        accountId,
        activationId
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const leftSidebarEPRef = (0, $btoiF.usePageLayoutEntryPoint)((0, $b666e36d39b806ff$export$50ea883ba6f28ff5));
    const dashboardsEPRef = leftSidebarEPRef?.entryPoints?.dashboards;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $h3uMu.nav4DashboardsContentEntryPoint), entryPointParams);
    const triggerRef = (0, $hDvet.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).DASHBOARDS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const epContainerProps = (0, $euxye.useMemo)(()=>({
            id: 'nav4-sidebar-dashboards-default',
            packageName: (0, $00c4a880251c1b35$export$b8b9d90f9e5bd72b),
            teamName: (0, $00c4a880251c1b35$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), {
                withHeading: true
            }),
            // oxlint-disable-next-line typescript/consistent-type-assertions
            runtimeProps: entryPointParams
        }), [
        entryPointParams
    ]);
    // This callback makes sure that the EP is loaded when the _system_ determines that the expandable
    // should be open.
    const onSystemToggleFn = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const onExpansionToggleFn = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            sendSectionItemAnalyticsEvent({
                menuId: (0, $6GljB.L1_MENU_ID).DASHBOARDS,
                sectionItem: (0, $bOwox.SECTION_ITEM_DASHBOARDS)
            });
        }
    }, [
        entryPointActions,
        sendSectionItemAnalyticsEvent
    ]);
    const menuId = (0, $5IkoH.MENU_ID_DASHBOARDS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: onSystemToggleFn,
        onExpansionToggle: onExpansionToggleFn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-dashboards-default",
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $jzXAj.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f1JKW.RouteEntryPointContainer), {
        epContainerProps: epContainerProps,
        jiraEPRef: entryPointReferenceSubject,
        nestedEPRef: dashboardsEPRef,
        placeholderEntryPoint: (0, $h3uMu.nav4DashboardsContentEntryPoint)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jSP8C.Footer), null)));
}
$b33755d188d10be0$var$DashboardsDefaultInnerOLD.displayName = "DashboardsDefaultInnerOLD";

});
parcelRegister("f1JKW", function(module, exports) {
$parcel$export(module.exports, "RouteEntryPointContainer", () => $73feb40f1b97e8bd$export$3e4cdfb894377bc9);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");

var $dsVXF = parcelRequire("dsVXF");

var $7nEKi = parcelRequire("7nEKi");

var $gDdYI = parcelRequire("gDdYI");

var $a5nxD = parcelRequire("a5nxD");
const $73feb40f1b97e8bd$export$3e4cdfb894377bc9 = /*#__PURE__*/ (0, $euxye.memo)(({ epContainerProps: epContainerProps, jiraEPRef: jiraEPRef, nestedEPRef: nestedEPRef, shouldRenderNestedEntryPoint: shouldRenderNestedEntryPoint = true })=>{
    // If the route is an entryPoint, and the initialRoute was an entryPoint, use EntryPointContainer.
    // Otherwise, use the JiraEntryPointContainer.
    return shouldRenderNestedEntryPoint && nestedEPRef ? // eslint-disable-next-line jira/ufo/valid-labels
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: `${epContainerProps.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a5nxD.JiraHoldoutCustomData), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        attributes: epContainerProps.errorAttributes,
        fallback: epContainerProps.errorFallback,
        id: epContainerProps.id,
        packageName: epContainerProps.packageName,
        teamName: epContainerProps.teamName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dsVXF.EntryPointReferencePlaceholder), {
        name: `${epContainerProps.id || 'route-entrypoint-adapter'}-entrypoint-placeholder`,
        fallback: epContainerProps.fallback,
        entryPointReference: nestedEPRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $n67Vb.EntryPointContainer), {
        entryPointReference: nestedEPRef,
        // oxlint-disable-next-line typescript/consistent-type-assertions
        props: {}
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        ...epContainerProps,
        entryPointReferenceSubject: jiraEPRef
    });
});

});

parcelRegister("jSP8C", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $a38982b12b0d30ac$export$a06f1c675e846f6f);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $5IkoH = parcelRequire("5IkoH");

var $bEZ9g = parcelRequire("bEZ9g");

var $2PK8N = parcelRequire("2PK8N");

var $djYhH = parcelRequire("djYhH");

var $ar9gx = parcelRequire("ar9gx");

var $6w18e = parcelRequire("6w18e");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $2NPCN = parcelRequire("2NPCN");
const $a38982b12b0d30ac$var$viewAllDashboards = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.footer.view-all-dashboards",
    defaultMessage: "View all dashboards"
});
const $a38982b12b0d30ac$var$VIEW_ALL_DASHBOARDS_HREF = (0, $2PK8N.dashboardsDirectoryRoute).path;
const $a38982b12b0d30ac$export$a06f1c675e846f6f = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem } = (0, $euxye.useContext)((0, $2NPCN.AnalyticContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEZ9g.ViewAllEntityMenuItem), {
        href: $a38982b12b0d30ac$var$VIEW_ALL_DASHBOARDS_HREF,
        menuId: (0, $5IkoH.MENU_ID_DASHBOARDS_VIEW_ALL),
        onClick: (e)=>{
            fireUIAnalyticForFixMenuItem();
            onClose?.(e);
        }
    }, formatMessage($a38982b12b0d30ac$var$viewAllDashboards)))));
};
$a38982b12b0d30ac$export$a06f1c675e846f6f.displayName = "Footer";

});

parcelRegister("h3uMu", function(module, exports) {
$parcel$export(module.exports, "nav4DashboardsContentEntryPoint", () => $ad3b38cedfe1bf31$export$d6e6956d3748383b);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $bZhC2 = parcelRequire("bZhC2");

var $2NSbF = parcelRequire("2NSbF");

var $i860n = parcelRequire("i860n");

var $18sMq = parcelRequire("18sMq");

var $iegjk = parcelRequire("iegjk");

var $fDVI0 = parcelRequire("fDVI0");

var $2700E = parcelRequire("2700E");

var $3gt6d = parcelRequire("3gt6d");

const $ad3b38cedfe1bf31$export$d6e6956d3748383b = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("86Y7Z")), {
        moduleId: "a69e7d05",
        moduleName: "DashboardsContentViewQuery",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId || '';
        const activationId = params.tenantContext?.activationId || '';
        const entityAri = (0, $i860n.fg)('navx-3660-fix-l2-l3-aris') ? (0, $18sMq.NavigationSettingAri).create({
            activationId: activationId,
            firstPartyApp: 'jira',
            settingId: 'dashboards',
            siteId: cloudId
        }).toString() : (0, $bZhC2.JiraNavigationSettingsAri).create({
            siteId: cloudId,
            activationId: activationId,
            navigationSettingScope: 'dashboards'
        }).toString();
        const variables = {
            cloudId: cloudId,
            entityAri: entityAri,
            ownerAri: (0, $2NSbF.IdentityUserAri).create({
                userId: params.tenantContext.atlassianAccountId || 'UNKNOWN'
            }).toString(),
            skipOrderQuery: false
        };
        return {
            queries: {
                queryRef: {
                    parameters: $3gt6d.default,
                    variables: variables
                },
                ...(0, $2700E.expVal)('platform_avp_jd_merged_directory_afm', 'isEnabled', false) ? {
                    avpQueryRef: {
                        parameters: (0, $iegjk.default),
                        variables: {
                            cloudId: cloudId,
                            workspaceAri: (0, $fDVI0.JiraWorkspaceAri).create({
                                siteId: cloudId,
                                activationId: activationId
                            }).toString()
                        },
                        options: {
                            fetchPolicy: 'store-and-network'
                        }
                    }
                } : {}
            }
        };
    }
});

});
parcelRegister("iegjk", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ad696f0c924de73$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0a21e16b82f27d1f6ed87d1056dd67f6>>
 * @relayHash 80ab77cb5bfdc03ecef8d33426926d48
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c5f1cbccdff8100441a4961dee1cc490bb58d274129bf4fd4ec80d8dc0d9e59
const $7ad696f0c924de73$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1c5f1cbccdff8100441a4961dee1cc490bb58d274129bf4fd4ec80d8dc0d9e59",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "avp_getDashboardsByStatus"
                    ]
                }
            ]
        },
        "name": "MergedDashboardsContent_dashboardsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7ad696f0c924de73$export$2e2bcd8739ae039 = $7ad696f0c924de73$var$node;

});

parcelRegister("3gt6d", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ee302eb08d354d3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3ec2a895ceddd3487d6c416e6555d507>>
 * @relayHash b787391dfecb60b98d70bd21d1a966cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 92634ac69886405bf93a0c1c5090a69c60dffd5712989db97cba22531f4d0381

var $bafxb = parcelRequire("bafxb");
const $6ee302eb08d354d3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "92634ac69886405bf93a0c1c5090a69c60dffd5712989db97cba22531f4d0381",
        "metadata": {},
        "name": "DashboardsContentViewQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcplatformAvpJdMergedDirectoryAfmRelayProvidertsx": (0, $bafxb.default)
        }
    }
};
var $6ee302eb08d354d3$export$2e2bcd8739ae039 = $6ee302eb08d354d3$var$node;

});
parcelRegister("bafxb", function(module, exports) {
$parcel$export(module.exports, "default", () => $883a11298174b594$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $883a11298174b594$var$platformAvpJdMergedDirectoryAfmRelayProvider = {
    get () {
        return (0, $2700E.expVal)('platform_avp_jd_merged_directory_afm', 'isEnabled', false);
    }
};
var $883a11298174b594$export$2e2bcd8739ae039 = $883a11298174b594$var$platformAvpJdMergedDirectoryAfmRelayProvider;

});


parcelRegister("86Y7Z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lQCfJ").then(()=>parcelRequire('8Yoty'));

});





parcelRegister("hTFLW", function(module, exports) {
$parcel$export(module.exports, "Nav4Filters", () => $e0d19385b95072ec$export$caf6e58bb8560bb2);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $gDdYI = parcelRequire("gDdYI");

var $EcWtx = parcelRequire("EcWtx");

var $kACtV = parcelRequire("kACtV");
const $e0d19385b95072ec$export$caf6e58bb8560bb2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "flag",
        id: "filters-section",
        packageName: (0, $kACtV.PACKAGE_NAME),
        teamName: (0, $kACtV.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $EcWtx.Nav4Filters), props)));
$e0d19385b95072ec$export$caf6e58bb8560bb2.displayName = "Nav4Filters";

});
parcelRegister("EcWtx", function(module, exports) {
$parcel$export(module.exports, "Nav4Filters", () => $886886f7c65330f7$export$caf6e58bb8560bb2);

var $7GciJ = parcelRequire("7GciJ");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $5IkoH = parcelRequire("5IkoH");

var $19zz3 = parcelRequire("19zz3");

var $i860n = parcelRequire("i860n");

var $8JkHf = parcelRequire("8JkHf");

var $g5hKm = parcelRequire("g5hKm");

var $7clrn = parcelRequire("7clrn");
function $886886f7c65330f7$export$caf6e58bb8560bb2(props) {
    const { isExpanded: isExpanded, queryRef: queryRef, ...dndProps } = props;
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $7GciJ.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $19zz3.useSidebarNav4)();
    const actionButtons = (0, $euxye.useMemo)(()=>(0, $i860n.fg)('navx-global-side-nav') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8JkHf.ActionButtons), null), []);
    const isExpandedValue = (0, $i860n.fg)('navx-global-side-nav') ? !!dndProps.isExpandOrFlyoutOpen && isExpanded : isExpanded;
    if (!data.jira?.hasIsFiltersExpanded && isInitialSelectedPath((0, $5IkoH.MENU_ID_FILTERS))) // We need to make sure that we're only passing the conditional fragment when it is actually
    // available. Due to a lack of support the @alias Relay directive, we need to use another mechanism
    // and in this case we're using a hardcoded __typename to check if the fragment is available.
    // This is a workaround until we can use the @alias directive in Relay. If the hasIsProjectsExpanded
    // attribute is not available, then the fragment won't be either and we shouldn't pass it.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7clrn.Nav4FiltersDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpandedValue,
        ...dndProps
    });
    return isInitialSelectedPath((0, $5IkoH.MENU_ID_FILTERS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g5hKm.Nav4FiltersForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpandedValue,
        queryRef: data,
        ...dndProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7clrn.Nav4FiltersDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpandedValue,
        ...dndProps
    });
}
$886886f7c65330f7$export$caf6e58bb8560bb2.displayName = "Nav4Filters";

});
parcelRegister("7GciJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c09b24101795124d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70a9c59f25b0c8b3b7bacc60d05af3c6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c09b24101795124d$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isFiltersExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Filters",
    "selections": [
        {
            "condition": "isFiltersExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4FiltersForLanding"
                }
            ]
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "hasIsFiltersExpanded",
                            "kind": "ScalarField",
                            "name": "__typename"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$c09b24101795124d$var$node.hash = "f71f6cd06a5f57478bea303bf60bd049";
var $c09b24101795124d$export$2e2bcd8739ae039 = $c09b24101795124d$var$node;

});

parcelRegister("8JkHf", function(module, exports) {
$parcel$export(module.exports, "ActionButtons", () => $a4d72df30ced0fac$export$88c65d2d98aab183);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");





var $6GljB = parcelRequire("6GljB");

var $2DbWL = parcelRequire("2DbWL");

var $gbTMi = parcelRequire("gbTMi");

var $72ldR = parcelRequire("72ldR");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $dGnxe = parcelRequire("dGnxe");
const $a4d72df30ced0fac$var$filters = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.action-buttons.filters",
    defaultMessage: "Filters"
});
const $a4d72df30ced0fac$export$88c65d2d98aab183 = /*#__PURE__*/ (0, $euxye.memo)(({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const sendFilterAnalytics = (0, $dGnxe.useFilterActionsAnalytics)();
    const sendMeatballAnalytics = (0, $euxye.useCallback)(()=>{
        sendFilterAnalytics((0, $6b2913942bd90807$export$b887e88d8d0739f6), {
            level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
            componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
            itemId: (0, $90c0351d239ffedb$export$f06dfcec5ff912e)
        });
    }, [
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
        onOpen: sendMeatballAnalytics,
        MenuItems: $a4d72df30ced0fac$var$MoreMenuItems,
        onClose: onClose,
        name: formatMessage($a4d72df30ced0fac$var$filters)
    });
});
function $a4d72df30ced0fac$var$MoreMenuItems(_) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2DbWL.HideL1MenuItemSection), {
        menuId: (0, $6GljB.L1_MENU_ID).FILTERS,
        hasSeparator: false
    }));
}
$a4d72df30ced0fac$var$MoreMenuItems.displayName = "MoreMenuItems";

});
parcelRegister("dGnxe", function(module, exports) {
$parcel$export(module.exports, "useFilterActionsAnalytics", () => $f74ead49f77b01fb$export$97e99df7fbddf9f6);
$parcel$export(module.exports, "getFilterActionAttributes", () => $f74ead49f77b01fb$export$b06742bfd24ebf9f);
$parcel$export(module.exports, "getFilterMeatBallAttributes", () => $f74ead49f77b01fb$export$b8e6b9b84ba340a2);
$parcel$export(module.exports, "getRecentAndFavouriteFilterAttributes", () => $f74ead49f77b01fb$export$2108e20c9691c7e4);
$parcel$export(module.exports, "getDefaulFilterAttributes", () => $f74ead49f77b01fb$export$15e07b997aa6036a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");





var $bOwox = parcelRequire("bOwox");

var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
const $f74ead49f77b01fb$export$97e99df7fbddf9f6 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireFilterActionAnalytics = (0, $euxye.useCallback)((actionSubject, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: actionSubject
        });
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_FILTERS], attributes);
    }, [
        createAnalyticsEvent
    ]);
    return fireFilterActionAnalytics;
};
const $f74ead49f77b01fb$var$systemFilterNameMap = [
    {
        name: 'myOpenIssues',
        id: '-1'
    },
    {
        name: 'reportedByMe',
        id: '-2'
    },
    {
        name: 'allIssues',
        id: '-4'
    },
    {
        name: 'openIssues',
        id: '-5'
    },
    {
        name: 'doneIssues',
        id: '-9'
    },
    {
        name: 'viewedRecently',
        id: '-3'
    },
    {
        name: 'resolvedRecently',
        id: '-7'
    },
    {
        name: 'updatedRecently',
        id: '-8'
    },
    {
        name: 'createdRecently',
        id: '-6'
    }
];
const $f74ead49f77b01fb$export$c8c77a62dd73e040 = (id)=>{
    const systemFilter = $f74ead49f77b01fb$var$systemFilterNameMap.find((filter)=>filter.id === id);
    return systemFilter?.name || '';
};
const $f74ead49f77b01fb$var$getSection = (isCustom, isFavourite)=>{
    let section;
    if (!isCustom && !isFavourite) section = 'defaultFilters';
    else if (isFavourite) section = (0, $bOwox.SECTION_ITEM_STARRED);
    else section = (0, $bOwox.SECTION_ITEM_RECENT);
    return section;
};
const $f74ead49f77b01fb$var$getFilterId = (isCustom, filterId)=>{
    if (!filterId) return null;
    return (0, $5IkoH.ENTITY_ID).FILTER(isCustom ? filterId : $f74ead49f77b01fb$export$c8c77a62dd73e040(filterId));
};
const $f74ead49f77b01fb$export$b06742bfd24ebf9f = ({ itemId: itemId, isCustom: isCustom, isFavourite: isFavourite, filterId: filterId })=>{
    const section = $f74ead49f77b01fb$var$getSection(isCustom, Boolean(isFavourite));
    return {
        itemId: itemId,
        section: section,
        level: section === 'defaultFilters' ? (0, $ef39084c605eb7e8$export$35ac629b8b943d5a) : (0, $ef39084c605eb7e8$export$f9db6a58b4aabd18),
        componentType: isCustom ? (0, $6e2f51712bb2e810$export$5374c2c2d3ece55e) : (0, $6e2f51712bb2e810$export$74712b62056d422e),
        parentItemType: isCustom ? (0, $687cb22024c607c7$export$c1c49903035a02df) : (0, $687cb22024c607c7$export$6deee0e4f2fb784e),
        parentItemId: $f74ead49f77b01fb$var$getFilterId(isCustom, filterId)
    };
};
const $f74ead49f77b01fb$export$b8e6b9b84ba340a2 = ({ isCustom: isCustom, isFavourite: isFavourite, filterId: filterId })=>{
    const section = $f74ead49f77b01fb$var$getSection(isCustom, Boolean(isFavourite));
    return {
        section: section,
        level: section === 'defaultFilters' ? (0, $ef39084c605eb7e8$export$f9db6a58b4aabd18) : (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
        componentType: isCustom ? (0, $6e2f51712bb2e810$export$9bd6c21d500ae611) : (0, $6e2f51712bb2e810$export$95b0c331af13d819),
        itemId: (0, $90c0351d239ffedb$export$f06dfcec5ff912e),
        parentItemType: isCustom ? (0, $687cb22024c607c7$export$c1c49903035a02df) : (0, $687cb22024c607c7$export$6deee0e4f2fb784e),
        parentItemId: $f74ead49f77b01fb$var$getFilterId(isCustom, filterId)
    };
};
const $f74ead49f77b01fb$export$2108e20c9691c7e4 = ({ isCustom: isCustom, filterId: filterId, section: section })=>{
    return {
        level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
        section: section,
        componentType: isCustom ? (0, $6e2f51712bb2e810$export$3ac911b122986477) : (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
        itemId: $f74ead49f77b01fb$var$getFilterId(isCustom, filterId),
        itemType: isCustom ? (0, $687cb22024c607c7$export$c1c49903035a02df) : (0, $687cb22024c607c7$export$6deee0e4f2fb784e)
    };
};
const $f74ead49f77b01fb$export$15e07b997aa6036a = ({ filterId: filterId })=>{
    return {
        level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
        itemId: $f74ead49f77b01fb$var$getFilterId(false, filterId),
        section: 'defaultFilters',
        componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
        itemType: (0, $687cb22024c607c7$export$6deee0e4f2fb784e)
    };
};

});


parcelRegister("g5hKm", function(module, exports) {
$parcel$export(module.exports, "Nav4FiltersForLanding", () => $42dbde1905c970bf$export$90658bd06cecabd4);

var $9Glt1 = parcelRequire("9Glt1");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");

var $bOwox = parcelRequire("bOwox");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $4VtOS = parcelRequire("4VtOS");

var $jzXAj = parcelRequire("jzXAj");

var $3rqDf = parcelRequire("3rqDf");

var $dx7aH = parcelRequire("dx7aH");

var $jepRN = parcelRequire("jepRN");

var $i860n = parcelRequire("i860n");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $gDdYI = parcelRequire("gDdYI");

var $dXzWx = parcelRequire("dXzWx");

var $kACtV = parcelRequire("kACtV");

var $lIdfF = parcelRequire("lIdfF");

var $lUF7f = parcelRequire("lUF7f");
function $42dbde1905c970bf$export$90658bd06cecabd4(props) {
    const { queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).FILTERS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $9Glt1.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    const handleExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $6GljB.L1_MENU_ID).FILTERS,
                sectionItem: (0, $bOwox.SECTION_ITEM_FILTERS)
            });
        }
    }, [
        sendSectionItemAnalyticsEvent
    ]);
    const menuId = (0, $5IkoH.MENU_ID_FILTERS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($42dbde1905c970bf$var$Nav4FiltersForLandingInner, {
        ...props,
        formattedMessage: formattedMessage,
        handleExpansionToggle: handleExpansionToggle,
        icon: icon,
        menuId: menuId,
        queryRef: data
    });
}
$42dbde1905c970bf$export$90658bd06cecabd4.displayName = "Nav4FiltersForLanding";
const $42dbde1905c970bf$var$Nav4FiltersForLandingInner = (0, $jepRN.componentWithFG)('navx-global-side-nav', $42dbde1905c970bf$var$Nav4FiltersForLandingGSN, $42dbde1905c970bf$var$Nav4FiltersForLandingNav4);
function $42dbde1905c970bf$var$Nav4FiltersForLandingGSN(props) {
    const { actionsOnHover: actionsOnHover, draggableRef: draggableRef, dropIndicator: dropIndicator, formattedMessage: formattedMessage, handleExpansionToggle: handleExpansionToggle, hasDragIndicator: hasDragIndicator, icon: icon, isDragging: isDragging, isExpanded: isExpanded, menuId: menuId, onExpandFlyoutToggle: onExpandFlyoutToggle, queryRef: queryRef, visualContentRef: visualContentRef } = props;
    const handleExpansionToggle2 = (0, $euxye.useCallback)((hasExpanded)=>{
        handleExpansionToggle(hasExpanded);
        onExpandFlyoutToggle?.(hasExpanded);
    }, [
        onExpandFlyoutToggle,
        handleExpansionToggle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        dropTargetRef: visualContentRef,
        dropIndicator: dropIndicator,
        isDragging: isDragging,
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: handleExpansionToggle2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        hasDragIndicator: hasDragIndicator,
        interactionName: "nav4-sidebar-filters-landing",
        isDragging: isDragging,
        ref: draggableRef,
        testId: (0, $jzXAj.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lUF7f.Header), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-filters-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "nav4-sidebar-filters-landing",
        packageName: (0, $kACtV.PACKAGE_NAME),
        teamName: (0, $kACtV.TEAM_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dXzWx.Nav4FiltersContent), {
        queryRef: queryRef,
        navigationCustomisationFragment: (0, $i860n.fg)('hot-305275-fix-filters-reordering-gsn') ? queryRef.filtersOrder ?? undefined : undefined
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lIdfF.Footer), null)));
}
$42dbde1905c970bf$var$Nav4FiltersForLandingGSN.displayName = "Nav4FiltersForLandingGSN";
function $42dbde1905c970bf$var$Nav4FiltersForLandingNav4(props) {
    const { actionsOnHover: actionsOnHover, formattedMessage: formattedMessage, handleExpansionToggle: handleExpansionToggle, icon: icon, isExpanded: isExpanded, menuId: menuId, queryRef: queryRef } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: handleExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-filters-landing",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon + text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $jzXAj.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lUF7f.Header), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-filters-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "nav4-sidebar-filters-landing",
        packageName: (0, $kACtV.PACKAGE_NAME),
        teamName: (0, $kACtV.TEAM_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dXzWx.Nav4FiltersContent), {
        queryRef: queryRef,
        navigationCustomisationFragment: queryRef.filtersOrder ?? undefined
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lIdfF.Footer), null)));
}
$42dbde1905c970bf$var$Nav4FiltersForLandingNav4.displayName = "Nav4FiltersForLandingNav4";

});
parcelRegister("9Glt1", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c6d8a8b4eb3843e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<abb5d3dddd5bf9628014ca9bc8211159>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7c6d8a8b4eb3843e$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "entityAriFilters"
        },
        {
            "kind": "RootArgument",
            "name": "ownerAri"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "skipOrderQuery"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4FiltersForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4FiltersContent"
        },
        {
            "condition": "skipOrderQuery",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "alias": "filtersOrder",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "entityAriFilters"
                        },
                        {
                            "kind": "Variable",
                            "name": "ownerAri",
                            "variableName": "ownerAri"
                        }
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "Nav4FiltersContent_navigationCustomisation"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$7c6d8a8b4eb3843e$var$node.hash = "76768f5ef86f410a026b69a8406deb64";
var $7c6d8a8b4eb3843e$export$2e2bcd8739ae039 = $7c6d8a8b4eb3843e$var$node;

});

parcelRegister("dXzWx", function(module, exports) {
$parcel$export(module.exports, "Nav4FiltersContent", () => $2390d07e5df0563b$export$e0cd6afcf36dd0ac);

var $hAyJE = parcelRequire("hAyJE");

var $bIZX0 = parcelRequire("bIZX0");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $g1b31 = parcelRequire("g1b31");

var $jk1MO = parcelRequire("jk1MO");




var $bOwox = parcelRequire("bOwox");

var $5IkoH = parcelRequire("5IkoH");

var $19zz3 = parcelRequire("19zz3");

var $aQCoC = parcelRequire("aQCoC");

var $9AhSr = parcelRequire("9AhSr");

var $gLXQg = parcelRequire("gLXQg");

var $atwsb = parcelRequire("atwsb");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $ar9gx = parcelRequire("ar9gx");

var $djYhH = parcelRequire("djYhH");

var $hQxjT = parcelRequire("hQxjT");
var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $2700E = parcelRequire("2700E");

var $cvA2R = parcelRequire("cvA2R");

var $kt86l = parcelRequire("kt86l");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aeLE4 = parcelRequire("aeLE4");

var $eNr3t = parcelRequire("eNr3t");

var $5PrC4 = parcelRequire("5PrC4");

var $1pVaL = parcelRequire("1pVaL");

var $lmcfF = parcelRequire("lmcfF");

var $dGnxe = parcelRequire("dGnxe");

var $9CdX7 = parcelRequire("9CdX7");
const $2390d07e5df0563b$var$recentMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.recent",
    defaultMessage: "Recent"
});
const $2390d07e5df0563b$var$starredMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.starred",
    defaultMessage: "Starred"
});
const $2390d07e5df0563b$var$viewAllStarred = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.view-all-starred",
    defaultMessage: "View all starred items"
});
const $2390d07e5df0563b$var$viewAllStarredFilters = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.view-all-starred-filters",
    defaultMessage: "View all starred filters"
});
const $2390d07e5df0563b$var$defaultFilters = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.default-filters",
    defaultMessage: "Default filters"
});
const $2390d07e5df0563b$var$MAX_RECENT_FILTERS = 5;
const $2390d07e5df0563b$export$1f869c99ead9db5f = 15;
const $2390d07e5df0563b$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
const $2390d07e5df0563b$var$VIEW_ALL_STARRED_FILTERS_HREF = '/jira/filters?sortKey=favourite&sortOrder=DESC';
const $2390d07e5df0563b$var$defaultFiltersRequiringLogin = [
    {
        id: '-1'
    },
    {
        id: '-2'
    },
    {
        id: '-3'
    }
];
const $2390d07e5df0563b$var$entityTypenames = [
    'JiraCustomFilter',
    'JiraSystemFilter'
];
function $2390d07e5df0563b$export$e0cd6afcf36dd0ac({ queryRef: queryRef, navigationCustomisationFragment: navigationCustomisationFragment }) {
    const cloudId = (0, $kt86l.useCloudId)();
    const { isSelectedPath: isSelectedPath } = (0, $19zz3.useSidebarNav4)();
    const [{ isInitialRender: isInitialRender }] = (0, $eNr3t.useSpaStateTransition)();
    const isSelectedPathOnTransition = (0, $euxye.useCallback)((menuId)=>!isInitialRender && isSelectedPath(menuId), [
        isInitialRender,
        isSelectedPath
    ]);
    // We intentionally request 15 starred and 20 recent filters.
    // Recent filters should exclude system/default filters.
    // Then, if all 15 starred filters were recently visited, we still show 5 recent filters as well.
    const [jira, refetch] = (0, $n67Vb.useRefetchableFragment)((0, $bIZX0.default), queryRef);
    const navigationCustomisation = (0, $n67Vb.useFragment)((0, $hAyJE.default), navigationCustomisationFragment);
    (0, $g1b31.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPathOnTransition,
        QUERY: $9CdX7.default,
        refetch: refetch,
        menuId: (0, $5IkoH.MENU_ID_FILTERS)
    });
    const refetchOnChange = (0, $euxye.useCallback)(({ onComplete: onComplete })=>{
        refetch({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        cloudId,
        refetch
    ]);
    (0, $9AhSr.useSubscribeAndUpdateFavorites)({
        entityTypename: $2390d07e5df0563b$var$entityTypenames,
        favouriteConnectionId: jira?.jira.favouriteFilters.__id || '',
        recentConnectionId: jira?.jira.recentFilters.__id || '',
        refetch: refetchOnChange
    });
    const { subscribe: subscribe, unsubscribe: unsubscribe } = (0, $jk1MO.useDeleteChangeActions)();
    // allows the sidebar to reflect filter changes when a filter is deleted from the filters directory page
    (0, $euxye.useEffect)(()=>{
        subscribe(refetchOnChange);
        return ()=>{
            unsubscribe(refetchOnChange);
        };
    }, [
        refetchOnChange,
        subscribe,
        unsubscribe
    ]);
    if ((0, $2700E.expVal)('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($2390d07e5df0563b$var$Nav4FiltersContentInnerNew, {
        jira: jira,
        refetchOnChange: refetchOnChange,
        navigationCustomisation: navigationCustomisation
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($2390d07e5df0563b$var$Nav4FiltersContentInnerOld, {
        jira: jira.jira,
        refetchOnChange: refetchOnChange
    });
}
$2390d07e5df0563b$export$e0cd6afcf36dd0ac.displayName = "Nav4FiltersContent";
const $2390d07e5df0563b$var$Nav4FiltersContentInnerOld = (props)=>{
    const { jira: { favouriteFilters: favouriteFilters, recentFilters: recentFilters, systemFilters: systemFilters }, refetchOnChange: refetchOnChange } = props;
    const { getStableItems: getStableItems } = (0, $gLXQg.useStableItems)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const starred = formatMessage($2390d07e5df0563b$var$starredMessage);
    const recent = formatMessage($2390d07e5df0563b$var$recentMessage);
    const sendFilterAnalytics = (0, $dGnxe.useFilterActionsAnalytics)();
    const sendFavouriteFilterAnalytics = (0, $euxye.useCallback)((isCustom, filterId)=>{
        if (!filterId) return;
        sendFilterAnalytics((0, $6b2913942bd90807$export$6dd9406e478a1fe2), (0, $dGnxe.getRecentAndFavouriteFilterAttributes)({
            isCustom: isCustom,
            filterId: filterId,
            section: (0, $bOwox.SECTION_ITEM_STARRED)
        }));
    }, [
        sendFilterAnalytics
    ]);
    const favorites = (0, $euxye.useMemo)(()=>{
        const edges = favouriteFilters.edges?.filter(Boolean) ?? [];
        const ids = [];
        const list = [];
        for (const edge of edges)if (edge.node.filterId) {
            ids.push(edge.node.filterId);
            const isCustom = edge.node.__typename === 'JiraCustomFilter';
            const filterId = edge.node.filterId;
            list.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5PrC4.Nav4FilterMenuItem), {
                key: filterId,
                queryRef: edge.node,
                onRefetch: refetchOnChange,
                onClick: ()=>sendFavouriteFilterAnalytics(isCustom, filterId)
            }));
        }
        return {
            idSet: new Set(ids),
            list: list.slice(0, $2390d07e5df0563b$export$1f869c99ead9db5f),
            hasItems: Boolean(list.length),
            hasMore: favouriteFilters.pageInfo?.hasNextPage || list.length > $2390d07e5df0563b$export$1f869c99ead9db5f
        };
    }, [
        favouriteFilters.edges,
        favouriteFilters.pageInfo?.hasNextPage,
        refetchOnChange,
        sendFavouriteFilterAnalytics
    ]);
    const sendRecentFilterAnalytics = (0, $euxye.useCallback)((filterId)=>{
        if (!filterId) return;
        sendFilterAnalytics((0, $6b2913942bd90807$export$6dd9406e478a1fe2), (0, $dGnxe.getRecentAndFavouriteFilterAttributes)({
            isCustom: true,
            filterId: filterId,
            section: (0, $bOwox.SECTION_ITEM_RECENT)
        }));
    }, [
        sendFilterAnalytics
    ]);
    const recentItems = (0, $euxye.useMemo)(()=>{
        const edges = recentFilters.edges?.filter(Boolean) ?? [];
        const filteredNodes = [];
        for (const edge of edges)if (edge.node.filterId && !favorites.idSet.has(edge.node.filterId)) {
            filteredNodes.push(edge.node);
            if (filteredNodes.length >= $2390d07e5df0563b$var$MAX_RECENT_FILTERS) break;
        }
        const stableOrderedNodes = getStableItems({
            nodes: filteredNodes,
            idKey: 'filterId'
        });
        const list = [];
        for (const node of stableOrderedNodes)if (node.filterId) {
            const filterId = node.filterId;
            list.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5PrC4.Nav4FilterMenuItem), {
                key: filterId,
                queryRef: node,
                onRefetch: refetchOnChange,
                onClick: ()=>sendRecentFilterAnalytics(filterId)
            }));
        }
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        recentFilters.edges,
        getStableItems,
        favorites.idSet,
        refetchOnChange,
        sendRecentFilterAnalytics
    ]);
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    const sendDefaultFilterAnalytics = (0, $euxye.useCallback)((filterId)=>{
        if (!filterId) return;
        sendFilterAnalytics((0, $6b2913942bd90807$export$6dd9406e478a1fe2), (0, $dGnxe.getDefaulFilterAttributes)({
            filterId: filterId
        }));
    }, [
        sendFilterAnalytics
    ]);
    const defaultItems = (0, $euxye.useMemo)(()=>{
        const filterIds = [];
        const edges = systemFilters.edges ?? [];
        const list = [];
        for (const edge of edges)if (edge?.node?.filterId && !favorites.idSet.has(edge.node.filterId) && (!isAnonymous || !$2390d07e5df0563b$var$defaultFiltersRequiringLogin.find((filter)=>filter.id === edge.node?.filterId))) {
            filterIds.push(edge.node.filterId);
            const filterId = edge.node.filterId;
            list.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5PrC4.Nav4FilterMenuItem), {
                key: filterId,
                queryRef: edge.node,
                onRefetch: refetchOnChange,
                onClick: ()=>sendDefaultFilterAnalytics(filterId)
            }));
        }
        return {
            list: list,
            hasItems: Boolean(list.length),
            filterIds: filterIds
        };
    }, [
        systemFilters.edges,
        favorites.idSet,
        isAnonymous,
        refetchOnChange,
        sendDefaultFilterAnalytics
    ]);
    const sendViewAllStarredAnalytics = (0, $euxye.useCallback)(()=>{
        sendFilterAnalytics((0, $6b2913942bd90807$export$6dd9406e478a1fe2), {
            level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
            componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
            itemId: 'viewAllStarred'
        });
    }, [
        sendFilterAnalytics
    ]);
    const sendDefaultFilterDropdownAnalytics = (0, $euxye.useCallback)(()=>{
        sendFilterAnalytics((0, $6b2913942bd90807$export$b887e88d8d0739f6), {
            level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
            componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
            itemId: 'defaultFilters'
        });
    }, [
        sendFilterAnalytics
    ]);
    const onExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) sendDefaultFilterDropdownAnalytics();
    }, [
        sendDefaultFilterDropdownAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, favorites.list))), favouriteFilters.pageInfo?.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: (0, $2700E.expVal)('jjj5-cosmos-navigation', 'isEnabled', false) ? $2390d07e5df0563b$var$VIEW_ALL_STARRED_FILTERS_HREF : $2390d07e5df0563b$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $5IkoH.MENU_ID_FILTERS_VIEW_ALL_STARRED),
        onClick: sendViewAllStarredAnalytics
    }, formatMessage((0, $2700E.expVal)('jjj5-cosmos-navigation', 'isEnabled', false) ? $2390d07e5df0563b$var$viewAllStarredFilters : $2390d07e5df0563b$var$viewAllStarred))), recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, recentItems.list))), defaultItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hQxjT.ExpandableMenuItem), {
        isDefaultExpanded: true,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-filters-default-filters"
    }, formatMessage($2390d07e5df0563b$var$defaultFilters)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, defaultItems.list)));
};
$2390d07e5df0563b$var$Nav4FiltersContentInnerOld.displayName = "Nav4FiltersContentInnerOld";
const $2390d07e5df0563b$var$Nav4FiltersContentInnerNew = (props)=>{
    const { jira: jiraData, refetchOnChange: refetchOnChange, navigationCustomisation: navigationCustomisation } = props;
    const { favouriteFilters: favouriteFilters, recentFilters: recentFilters, systemFilters: systemFilters } = jiraData.jira;
    const { getStableItems: getStableItems } = (0, $gLXQg.useStableItems)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const starred = formatMessage($2390d07e5df0563b$var$starredMessage);
    const recent = formatMessage($2390d07e5df0563b$var$recentMessage);
    const sendFilterAnalytics = (0, $dGnxe.useFilterActionsAnalytics)();
    const { entityAri: entityAri, ownerAri: ownerAri, group: group } = (0, $lmcfF.useFilterReorderingIds)();
    const filtersOrder = navigationCustomisation || null;
    const sendFavouriteFilterAnalytics = (0, $euxye.useCallback)((isCustom, filterId)=>{
        if (!filterId) return;
        sendFilterAnalytics((0, $6b2913942bd90807$export$6dd9406e478a1fe2), (0, $dGnxe.getRecentAndFavouriteFilterAttributes)({
            isCustom: isCustom,
            filterId: filterId,
            section: (0, $bOwox.SECTION_ITEM_STARRED)
        }));
    }, [
        sendFilterAnalytics
    ]);
    const filterNodes = (0, $euxye.useMemo)(()=>{
        const edges = favouriteFilters.edges ?? [];
        const nodes = [];
        for (const edge of edges)if (edge != null && edge !== undefined && edge.node != null && edge.node !== undefined) nodes.push(edge.node);
        return nodes;
    }, [
        favouriteFilters.edges
    ]);
    const renderMenuItem = (0, $euxye.useCallback)((edge, currentItems, currentOrder, item)=>{
        const isCustom = edge.__typename === 'JiraCustomFilter';
        const edgeId = edge.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1pVaL.Nav4FilterMenuItemRefactored), {
            key: edgeId,
            queryRef: edge,
            onRefetch: refetchOnChange,
            onClick: ()=>sendFavouriteFilterAnalytics(isCustom, edgeId),
            currentItems: currentItems,
            currentOrder: currentOrder,
            item: item
        });
    }, [
        refetchOnChange,
        sendFavouriteFilterAnalytics
    ]);
    const favorites = (0, $atwsb.useReorderableStarredItems)({
        favourites: filterNodes,
        lastOrder: filtersOrder?.sidebar?.nodes,
        getId: (item)=>item.id || '',
        getLabel: (item)=>item?.name?.toString() || '',
        getHasNextPage: ()=>Boolean(favouriteFilters?.pageInfo?.hasNextPage),
        renderMenuItem: renderMenuItem,
        maxItems: $2390d07e5df0563b$export$1f869c99ead9db5f
    });
    const sendRecentFilterAnalytics = (0, $euxye.useCallback)((filterId)=>{
        if (!filterId) return;
        sendFilterAnalytics((0, $6b2913942bd90807$export$6dd9406e478a1fe2), (0, $dGnxe.getRecentAndFavouriteFilterAttributes)({
            isCustom: true,
            filterId: filterId,
            section: (0, $bOwox.SECTION_ITEM_RECENT)
        }));
    }, [
        sendFilterAnalytics
    ]);
    const recentItems = (0, $euxye.useMemo)(()=>{
        const edges = recentFilters.edges?.filter(Boolean) ?? [];
        const filteredNodes = [];
        for (const edge of edges)if (edge.node.id && !favorites.idSet.has(edge.node.id)) {
            filteredNodes.push(edge.node);
            if (filteredNodes.length >= $2390d07e5df0563b$var$MAX_RECENT_FILTERS) break;
        }
        const stableOrderedNodes = getStableItems({
            nodes: filteredNodes,
            idKey: 'filterId'
        });
        const list = [];
        for (const node of stableOrderedNodes)if (node.filterId) {
            const filterId = node.filterId;
            list.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1pVaL.Nav4FilterMenuItemRefactored), {
                key: filterId,
                queryRef: node,
                onRefetch: refetchOnChange,
                onClick: ()=>sendRecentFilterAnalytics(filterId)
            }));
        }
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        recentFilters.edges,
        getStableItems,
        favorites.idSet,
        refetchOnChange,
        sendRecentFilterAnalytics
    ]);
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    const sendDefaultFilterAnalytics = (0, $euxye.useCallback)((filterId)=>{
        if (!filterId) return;
        sendFilterAnalytics((0, $6b2913942bd90807$export$6dd9406e478a1fe2), (0, $dGnxe.getDefaulFilterAttributes)({
            filterId: filterId
        }));
    }, [
        sendFilterAnalytics
    ]);
    const defaultItems = (0, $euxye.useMemo)(()=>{
        const filterIds = [];
        const edges = systemFilters.edges ?? [];
        const list = [];
        for (const edge of edges)if (edge?.node?.id && edge?.node?.filterId && !favorites.idSet.has(edge.node.id) && (!isAnonymous || !$2390d07e5df0563b$var$defaultFiltersRequiringLogin.find((filter)=>filter.id === edge.node?.id))) {
            filterIds.push(edge.node.id);
            const filterId = edge.node.filterId;
            list.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1pVaL.Nav4FilterMenuItemRefactored), {
                key: filterId,
                queryRef: edge.node,
                onRefetch: refetchOnChange,
                onClick: ()=>sendDefaultFilterAnalytics(filterId)
            }));
        }
        return {
            list: list,
            hasItems: Boolean(list.length),
            filterIds: filterIds
        };
    }, [
        systemFilters.edges,
        favorites.idSet,
        isAnonymous,
        refetchOnChange,
        sendDefaultFilterAnalytics
    ]);
    const sendViewAllStarredAnalytics = (0, $euxye.useCallback)(()=>{
        sendFilterAnalytics((0, $6b2913942bd90807$export$6dd9406e478a1fe2), {
            level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
            componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
            itemId: 'viewAllStarred'
        });
    }, [
        sendFilterAnalytics
    ]);
    const sendDefaultFilterDropdownAnalytics = (0, $euxye.useCallback)(()=>{
        sendFilterAnalytics((0, $6b2913942bd90807$export$b887e88d8d0739f6), {
            level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
            componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
            itemId: 'defaultFilters'
        });
    }, [
        sendFilterAnalytics
    ]);
    const onExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) sendDefaultFilterDropdownAnalytics();
    }, [
        sendDefaultFilterDropdownAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aeLE4.NestedItemDropTarget), {
        currentItems: favorites.currentItems,
        currentOrder: favorites.currentOrder,
        entityAri: entityAri,
        group: group,
        ownerAri: ownerAri
    }, favorites.list)))), favouriteFilters.pageInfo?.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: (0, $2700E.expVal)('jjj5-cosmos-navigation', 'isEnabled', false) ? $2390d07e5df0563b$var$VIEW_ALL_STARRED_FILTERS_HREF : $2390d07e5df0563b$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $5IkoH.MENU_ID_FILTERS_VIEW_ALL_STARRED),
        onClick: sendViewAllStarredAnalytics
    }, formatMessage((0, $2700E.expVal)('jjj5-cosmos-navigation', 'isEnabled', false) ? $2390d07e5df0563b$var$viewAllStarredFilters : $2390d07e5df0563b$var$viewAllStarred))), recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, recentItems.list))), defaultItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hQxjT.ExpandableMenuItem), {
        isDefaultExpanded: true,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-filters-default-filters"
    }, formatMessage($2390d07e5df0563b$var$defaultFilters)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, defaultItems.list)));
};
$2390d07e5df0563b$var$Nav4FiltersContentInnerNew.displayName = "Nav4FiltersContentInnerNew";

});
parcelRegister("hAyJE", function(module, exports) {
$parcel$export(module.exports, "default", () => $47508b27f2e9636c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fb8c1f0d9e72757a9d176db03af67f84>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $47508b27f2e9636c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FiltersContent_navigationCustomisation",
    "selections": [
        {
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsMenuItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "menuId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "visible"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SettingsNavigationCustomisation"
};
$47508b27f2e9636c$var$node.hash = "ce2c25c2e7d6bf7f7dae1f540021c99d";
var $47508b27f2e9636c$export$2e2bcd8739ae039 = $47508b27f2e9636c$var$node;

});

parcelRegister("bIZX0", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cfdd729070594fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2231bf12278fff5f7fce80dd6515b951>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $9CdX7 = parcelRequire("9CdX7");
const $3cfdd729070594fe$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "FragmentSpread",
        "name": "Nav4FilterMenuItem"
    }, v5 = {
        "kind": "FragmentSpread",
        "name": "Nav4FilterMenuItemRefactored"
    }, v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $9CdX7.default)
            }
        },
        "name": "Nav4FiltersContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "favouriteFilters",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "FILTER"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v1 /*: any*/ ,
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW"
                                            }
                                        ]
                                    },
                                    v6 /*: any*/ 
                                ]
                            },
                            "action": "THROW"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "recentFilters",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "currentURL",
                                        "variableName": "currentURL"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "FILTER"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                v1 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ],
                                                            "type": "JiraCustomFilter"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW"
                                            }
                                        ]
                                    },
                                    v6 /*: any*/ 
                                ]
                            },
                            "action": "THROW"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    v0 /*: any*/ 
                                ],
                                "concreteType": "JiraSystemFilterConnection",
                                "kind": "LinkedField",
                                "name": "systemFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSystemFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                "action": "THROW"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                },
                "action": "THROW"
            }
        ],
        "type": "Query"
    };
}();
$3cfdd729070594fe$var$node.hash = "3f2c652ff4b3b6620f4d64beb5fb3443";
var $3cfdd729070594fe$export$2e2bcd8739ae039 = $3cfdd729070594fe$var$node;

});
parcelRegister("9CdX7", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b322e44425781f6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<44cdcc46cc71e0c70be85963cb8b4ad7>>
 * @relayHash 5461fd7150254ec3bfb7756392ff2167
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e8b4068692b2e7425d6052ed7c426fce3f2915f2035bb72438a6f55dd5fe8de2
const $5b322e44425781f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v4 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v10 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4FiltersContentQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "Nav4FiltersContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4FiltersContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouriteFilters",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "FILTER"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentFilters",
                            "args": [
                                v2 /*: any*/ ,
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "FILTER"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v2 /*: any*/ 
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e8b4068692b2e7425d6052ed7c426fce3f2915f2035bb72438a6f55dd5fe8de2",
            "metadata": {},
            "name": "Nav4FiltersContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5b322e44425781f6$var$node.hash = "3f2c652ff4b3b6620f4d64beb5fb3443";
var $5b322e44425781f6$export$2e2bcd8739ae039 = $5b322e44425781f6$var$node;

});


parcelRegister("g1b31", function(module, exports) {
$parcel$export(module.exports, "useRefetchWhenIsSelected", () => $3e2043960403e698$export$ed209ae428704c56);

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $i860n = parcelRequire("i860n");

var $9h4A8 = parcelRequire("9h4A8");
function $3e2043960403e698$export$ed209ae428704c56(params) {
    const { cloudId: cloudId, isSelectedPath: isSelectedPath, menuId: menuId, refetch: refetch, queryVariables: queryVariables, QUERY: QUERY } = params;
    const environment = (0, $n67Vb.useRelayEnvironment)();
    const currentURL = (0, $9h4A8.useGetCurrentUrl)();
    const currentURLPath = (0, $9h4A8.useGetCurrentUrlPath)();
    const isInitialEffect = (0, $euxye.useRef)(true);
    (0, $euxye.useEffect)(()=>{
        // The first render is usually hydrated from server-preloaded data.
        // Skipping the initial run avoids an immediate duplicate network request on page load.
        if (isInitialEffect.current && (0, $i860n.fg)('nike_skip_initial_nav4projectscontentquery_refetch')) {
            isInitialEffect.current = false;
            return;
        }
        if (isSelectedPath(menuId)) (0, $n67Vb.fetchQuery)(environment, QUERY, {
            cloudId: cloudId,
            currentURL: currentURL,
            currentURLPath: currentURLPath,
            ...queryVariables
        }).subscribe({
            complete: ()=>{
                refetch({
                    cloudId: cloudId,
                    currentURL: currentURL,
                    ...queryVariables
                }, {
                    fetchPolicy: 'store-only'
                });
            }
        });
    }, [
        cloudId,
        isSelectedPath,
        menuId,
        refetch,
        currentURL,
        currentURLPath,
        environment,
        queryVariables,
        QUERY
    ]);
}

});
parcelRegister("9h4A8", function(module, exports) {
$parcel$export(module.exports, "useGetCurrentUrl", () => $0dbf5bdc9b206a93$export$d758ec3f153761c1);
$parcel$export(module.exports, "useGetCurrentUrlPath", () => $0dbf5bdc9b206a93$export$f61d14d754da11cc);

var $f2wVS = parcelRequire("f2wVS");

var $d78Kw = parcelRequire("d78Kw");

var $hGQgp = parcelRequire("hGQgp");
function $0dbf5bdc9b206a93$export$d758ec3f153761c1() {
    const match = (0, $d78Kw.useMatch)();
    const query = (0, $hGQgp.useQuery)();
    const searchParams = new URLSearchParams(query ?? {});
    const url = new URL(`http://example.com${match.url}/?${searchParams.toString()}`);
    return url.toString();
}
const $0dbf5bdc9b206a93$export$f61d14d754da11cc = (0, $f2wVS.createRouterSelector)((routerContext)=>{
    const url = new URL(`http://example.com${routerContext.match.url}`);
    return url.toString();
});

});


parcelRegister("jk1MO", function(module, exports) {
$parcel$export(module.exports, "useDeleteChangeActions", () => $60432eba8a4a988e$export$ebbca0408972222d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $60432eba8a4a988e$var$initialState = {
    callbacks: []
};
const $60432eba8a4a988e$export$e324594224ef24da = {
    subscribe: (callback)=>({ getState: getState, setState: setState })=>{
            if (!getState().callbacks.includes(callback)) setState({
                callbacks: [
                    ...getState().callbacks,
                    callback
                ]
            });
        },
    unsubscribe: (callback)=>({ getState: getState, setState: setState })=>{
            if (getState().callbacks.includes(callback)) setState({
                callbacks: getState().callbacks.filter((item)=>item !== callback)
            });
        },
    publish: ()=>({ getState: getState })=>{
            getState().callbacks.forEach((callback)=>callback({
                    onComplete: ()=>undefined
                }));
        }
};
const $60432eba8a4a988e$var$Store = (0, $5QDqc.createStore)({
    initialState: $60432eba8a4a988e$var$initialState,
    actions: $60432eba8a4a988e$export$e324594224ef24da
});
const $60432eba8a4a988e$export$440b46140bc86b64 = (0, $3h1FP.createStateHook)($60432eba8a4a988e$var$Store);
const $60432eba8a4a988e$export$ebbca0408972222d = (0, $3h1FP.createActionsHook)($60432eba8a4a988e$var$Store);

});

parcelRegister("9AhSr", function(module, exports) {
$parcel$export(module.exports, "useSubscribeAndUpdateFavorites", () => $1d0faa3cbc10e184$export$1032774f8dab9cec);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $lIGkE = parcelRequire("lIGkE");

var $7V240 = parcelRequire("7V240");
const $1d0faa3cbc10e184$export$923c488bb9fac2df = (favouriteConnectionId, recentConnectionId)=>(0, $euxye.useCallback)(({ store: store, dataId: dataId, isFavourite: isFavourite })=>{
        const node = store.get(dataId);
        const favorites = store.get(favouriteConnectionId);
        // Exit if we can't find the relevant data to optimistically update
        if (!node || !favorites) return false;
        if (isFavourite) {
            const recentEdges = store.get(recentConnectionId)?.getLinkedRecords('edges') ?? [];
            const existingEdge = recentEdges.find((edge)=>edge.getLinkedRecord('node')?.getDataID() === dataId);
            // Only optimistically insert a new favorite edge if it exists in the recent connection so we know it
            // has required fragment data.
            if (!existingEdge) return false;
            const edge = (0, $lIGkE.ConnectionHandler).createEdge(store, favorites, node, 'JiraFavouriteEdge');
            (0, $lIGkE.ConnectionHandler).insertEdgeBefore(favorites, edge);
        } else (0, $lIGkE.ConnectionHandler).deleteNode(favorites, dataId);
        return true;
    }, [
        favouriteConnectionId,
        recentConnectionId
    ]);
const $1d0faa3cbc10e184$export$1032774f8dab9cec = ({ entityTypename: entityTypename, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId, refetch: refetch })=>{
    const updateFavoriteConnection = $1d0faa3cbc10e184$export$923c488bb9fac2df(favouriteConnectionId, recentConnectionId);
    const pendingRefetch = (0, $euxye.useRef)(false); // Track in-flight refetch requests
    const trailingRefetch = (0, $euxye.useRef)(false); // Track queued refetch requests
    const onRefetch = (0, $euxye.useCallback)(()=>{
        // If there is already an in-flight refetch then wait until the request is complete before fetching again
        // Relay will dedupe refetch calls with matching variables. Therefore, we need to wait until any pending request
        // has finished before executing the latest refetch
        if (pendingRefetch.current) {
            trailingRefetch.current = true;
            return;
        }
        pendingRefetch.current = true;
        trailingRefetch.current = false;
        refetch({
            onComplete: ()=>{
                pendingRefetch.current = false;
                // Recursively refetch if it has been queued while a request was in-flight.
                if (trailingRefetch.current) // Wait for Relay to delete the cached request before refetching
                setTimeout(onRefetch, 0);
            }
        });
    }, [
        refetch
    ]);
    const subscriber = (0, $euxye.useCallback)((payload)=>{
        if (payload.type === 'MUTATION') {
            // If we successfully updated the connection or it's an optimistic update, exit without further action
            const success = updateFavoriteConnection(payload);
            if (payload.isOptimistic) return;
            if (success) {
                // If un-starring and not optimistic, trigger a refetch to update sidebar content
                if (!payload.isFavourite) onRefetch();
                return;
            }
        }
        // If we can't update the record directly in the Relay store then perform a refetch
        onRefetch();
    }, [
        onRefetch,
        updateFavoriteConnection
    ]);
    (0, $7V240.useSubscribeToFavorite)(entityTypename, subscriber);
};

});

parcelRegister("gLXQg", function(module, exports) {
$parcel$export(module.exports, "useStableItems", () => $f6deb5ffdc1bfeb8$export$cb9e0e36b6d0277e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
const $f6deb5ffdc1bfeb8$export$cb9e0e36b6d0277e = ()=>{
    const stableIdMapRef = (0, $euxye.useRef)(new Map());
    const getStableItems = (0, $euxye.useCallback)(({ nodes: nodes, idKey: idKey })=>{
        const getStringId = (node)=>`${node[idKey]}`;
        const intersectedNodes = nodes.filter((node)=>stableIdMapRef.current.has(getStringId(node))).sort((nodeA, nodeB)=>{
            const indexA = stableIdMapRef.current.get(getStringId(nodeA)) ?? 0;
            const indexB = stableIdMapRef.current.get(getStringId(nodeB)) ?? 0;
            return indexA - indexB;
        });
        const hasIntersectedNodes = Boolean(intersectedNodes.length);
        const stableOrderedNodes = hasIntersectedNodes ? nodes.reduceRight((acc, node, index, array)=>{
            if (!stableIdMapRef.current.has(getStringId(node))) {
                const addToStart = index + 1 !== array.length;
                addToStart ? acc.unshift(node) : acc.push(node);
            }
            return acc;
        }, intersectedNodes) : nodes;
        stableIdMapRef.current = new Map(stableOrderedNodes.map((node, index)=>[
                getStringId(node),
                index
            ]));
        return stableOrderedNodes;
    }, []);
    return {
        getStableItems: getStableItems
    };
};

});

parcelRegister("5PrC4", function(module, exports) {
$parcel$export(module.exports, "Nav4FilterMenuItem", () => $478fd9cba6a3cf52$export$6c93ee534b1d4d10);

var $64guj = parcelRequire("64guj");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $cvA2R = parcelRequire("cvA2R");

var $8P3zZ = parcelRequire("8P3zZ");

var $aZs9d = parcelRequire("aZs9d");
function $478fd9cba6a3cf52$export$6c93ee534b1d4d10({ queryRef: queryRef, onRefetch: onRefetch, onClick: onClick }) {
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $64guj.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZs9d.SimpleFilterMenuItem), {
        actionsOnHover: !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8P3zZ.Nav4FilterActions), {
            queryRef: data,
            onRefetch: onRefetch
        }),
        filterId: data.filterId,
        name: data.name,
        onClick: onClick
    });
}
$478fd9cba6a3cf52$export$6c93ee534b1d4d10.displayName = "Nav4FilterMenuItem";

});
parcelRegister("64guj", function(module, exports) {
$parcel$export(module.exports, "default", () => $07aea3e784de49a7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b8af6a58632ee68b0966c8c1b35de39>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $07aea3e784de49a7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FilterMenuItem",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4FilterActions"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$07aea3e784de49a7$var$node.hash = "db4e5c3fb6fe1fa05a10eea572e428b4";
var $07aea3e784de49a7$export$2e2bcd8739ae039 = $07aea3e784de49a7$var$node;

});

parcelRegister("8P3zZ", function(module, exports) {
$parcel$export(module.exports, "Nav4FilterActions", () => $8aa9a9ac707066fa$export$7077dee41f8ad33d);

var $hSPnC = parcelRequire("hSPnC");

var $euxye = parcelRequire("euxye");

var $bS1iz = parcelRequire("bS1iz");

var $n67Vb = parcelRequire("n67Vb");

var $2VfJf = parcelRequire("2VfJf");



var $9d48B = parcelRequire("9d48B");

var $gbTMi = parcelRequire("gbTMi");

var $9CNRl = parcelRequire("9CNRl");

var $2zU0a = parcelRequire("2zU0a");

var $eezi8 = parcelRequire("eezi8");

var $cEwjN = parcelRequire("cEwjN");

var $1Unjk = parcelRequire("1Unjk");

var $2bpNg = parcelRequire("2bpNg");

var $d8bZ5 = parcelRequire("d8bZ5");

var $2EZ2h = parcelRequire("2EZ2h");

var $lWRvF = parcelRequire("lWRvF");

var $ceqcm = parcelRequire("ceqcm");

var $cSR11 = parcelRequire("cSR11");

var $g36LP = parcelRequire("g36LP");

var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $3GN2r = parcelRequire("3GN2r");

var $fNgVF = parcelRequire("fNgVF");

var $55BnK = parcelRequire("55BnK");

var $kt86l = parcelRequire("kt86l");

var $h3LJR = parcelRequire("h3LJR");

var $isqzs = parcelRequire("isqzs");

var $dGnxe = parcelRequire("dGnxe");

var $gYDzv = parcelRequire("gYDzv");

var $itFBm = parcelRequire("itFBm");

var $7zGx8 = parcelRequire("7zGx8");
const $8aa9a9ac707066fa$var$manageSubscription = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.manage-subscription",
    defaultMessage: "Manage subscriptions"
});
const $8aa9a9ac707066fa$var$copyFilter = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter",
    defaultMessage: "Copy filter"
});
const $8aa9a9ac707066fa$var$copyFilterDialogTitle = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter-dialog-title",
    defaultMessage: "Copy filter"
});
const $8aa9a9ac707066fa$var$edit = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.edit",
    defaultMessage: "Edit filter"
});
const $8aa9a9ac707066fa$var$changeOwner = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.change-owner",
    defaultMessage: "Change owner"
});
const $8aa9a9ac707066fa$var$deleteMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.delete",
    defaultMessage: "Delete filter"
});
const $8aa9a9ac707066fa$var$manageSubscriptionWithName = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.manage-subscription-with-name",
    defaultMessage: "Manage subscriptions for {name}"
});
const $8aa9a9ac707066fa$var$copyFilterWithName = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter-with-name",
    defaultMessage: "Copy filter {name}"
});
const $8aa9a9ac707066fa$var$editWithName = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.edit-with-name",
    defaultMessage: "Edit filter {name}"
});
const $8aa9a9ac707066fa$var$changeOwnerWithName = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.change-owner-with-name",
    defaultMessage: "Change owner for {name}"
});
const $8aa9a9ac707066fa$var$deleteWithName = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.delete-with-name",
    defaultMessage: "Delete filter {name}"
});
const $8aa9a9ac707066fa$export$7077dee41f8ad33d = ({ queryRef: queryRef, onRefetch: onRefetch })=>{
    const { __typename: __typename, isEditable: isEditable, isFavourite: isFavourite, name: name, owner: owner, id: id, filterId: filterId } = (0, $n67Vb.useFragment)((0, $hSPnC.default), queryRef);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const accountId = (0, $3GN2r.useAccountId)();
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const sendFilterAnalytics = (0, $dGnxe.useFilterActionsAnalytics)();
    const { isOpen: isChangeOwnerModalOpen, onOpen: openChangeOwnerModal, onClose: closeChangeOwnerModal } = (0, $7zGx8.useModalState)(false);
    const { isOpen: isDeleteFilterModalOpen, onOpen: openDeleteFilterModal, onClose: closeDeleteFilterModal } = (0, $7zGx8.useModalState)(false);
    const { push: push } = (0, $55BnK.useRouterActions)();
    const onFilterSave = (0, $euxye.useCallback)((copiedFilterId)=>{
        push(`/issues/?filter=${copiedFilterId}`);
    }, [
        push
    ]);
    const isCustom = __typename === 'JiraCustomFilter';
    const isOwner = owner?.accountId && owner.accountId === accountId;
    const sendFilterActionAnalytics = (0, $euxye.useCallback)((itemId)=>{
        sendFilterAnalytics((0, $6b2913942bd90807$export$64fed82162bd367), (0, $dGnxe.getFilterActionAttributes)({
            itemId: itemId,
            isCustom: isCustom,
            isFavourite: isFavourite,
            filterId: filterId
        }));
    }, [
        filterId,
        isCustom,
        isFavourite,
        sendFilterAnalytics
    ]);
    const modalProps = (0, $euxye.useMemo)(()=>({
            width: 'medium',
            shouldScrollInViewport: true
        }), []);
    const saveFilterEntryPointProps = (0, $euxye.useMemo)(()=>({
            filterId: filterId,
            onFilterSave: onFilterSave,
            title: formatMessage($8aa9a9ac707066fa$var$copyFilterDialogTitle)
        }), [
        filterId,
        onFilterSave,
        formatMessage
    ]);
    const updateFilterEntryPointProps = (0, $euxye.useMemo)(()=>({
            filterId: filterId ?? ''
        }), [
        filterId
    ]);
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            filterAri: filterId !== null && filterId !== undefined ? (0, $2zU0a.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'filter',
                resourceId: filterId,
                activationId: activationId
            }) : undefined
        }), [
        filterId,
        cloudId,
        activationId
    ]);
    const MenuItems = (0, $euxye.useCallback)(({ onClose: onClose })=>{
        const getManageSubscriptionsUrl = (actionType)=>{
            const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify({
                atl_token: (0, $9CNRl.default)(),
                returnUrl: 'ManageFilters.jspa',
                filterId: filterId
            });
            return `/${actionType}!default.jspa?${parsed}`;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
            isList: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9d48B.FavoriteToggleButton), {
            entityId: id,
            defaultIsStarred: Boolean(isFavourite),
            entityTypeName: (0, $2VfJf.isFavoritableItemTypename)(__typename) ? __typename : 'JiraCustomFilter',
            onClick: ()=>sendFilterActionAnalytics(isFavourite ? (0, $90c0351d239ffedb$export$7ae7abcf2c19d3e5) : (0, $90c0351d239ffedb$export$78fd0bd637fe1684)),
            name: name
        }), isCustom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cSR11.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2EZ2h))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #292A2E)"
            }),
            href: getManageSubscriptionsUrl('ViewSubscriptions'),
            "aria-label": formatMessage($8aa9a9ac707066fa$var$manageSubscriptionWithName, {
                name: name
            }),
            onClick: ()=>sendFilterActionAnalytics('manageSubscription')
        }, formatMessage($8aa9a9ac707066fa$var$manageSubscription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $isqzs.ModalEntryPointPressableTrigger), {
            modalProps: modalProps,
            entryPoint: (0, $eezi8.saveFilterDialogEntryPoint),
            entryPointProps: saveFilterEntryPointProps,
            entryPointParams: entryPointParams,
            interactionName: "jiraSaveFilterDialog.SaveFilter",
            useInternalModal: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
                onClick: (e)=>{
                    sendFilterActionAnalytics('copyFilter');
                    onClose && onClose(e);
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Unjk))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #292A2E)"
                }),
                "aria-label": formatMessage($8aa9a9ac707066fa$var$copyFilterWithName, {
                    name: name
                }),
                ref: ref
            }, formatMessage($8aa9a9ac707066fa$var$copyFilter))), isCustom && (isOwner || isEditable) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $isqzs.ModalEntryPointPressableTrigger), {
            modalProps: modalProps,
            entryPoint: (0, $cEwjN.updateFilterDialogEntryPoint),
            entryPointProps: updateFilterEntryPointProps,
            entryPointParams: entryPointParams,
            interactionName: "jiraSaveFilterDialog.UpdateFilterDetails",
            useInternalModal: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
                onClick: (e)=>{
                    sendFilterActionAnalytics('editFilter');
                    onClose && onClose(e);
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8bZ5))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #292A2E)"
                }),
                "aria-label": formatMessage($8aa9a9ac707066fa$var$editWithName, {
                    name: name
                }),
                ref: ref
            }, formatMessage($8aa9a9ac707066fa$var$edit))), isCustom && (isOwner || isAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
            onClick: (e)=>{
                openChangeOwnerModal();
                sendFilterActionAnalytics('changeOwner');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lWRvF))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #292A2E)"
            }),
            "aria-label": formatMessage($8aa9a9ac707066fa$var$changeOwnerWithName, {
                name: name
            })
        }, formatMessage($8aa9a9ac707066fa$var$changeOwner))), isCustom && (isOwner || isAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
            onClick: (e)=>{
                openDeleteFilterModal();
                sendFilterActionAnalytics('deleteFilter');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bpNg))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            }),
            "aria-label": formatMessage($8aa9a9ac707066fa$var$deleteWithName, {
                name: name
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
            color: "color.text.danger"
        }, formatMessage($8aa9a9ac707066fa$var$deleteMessage)))));
    }, [
        id,
        isFavourite,
        __typename,
        name,
        isCustom,
        formatMessage,
        isOwner,
        isEditable,
        isAdmin,
        filterId,
        sendFilterActionAnalytics,
        openChangeOwnerModal,
        openDeleteFilterModal,
        modalProps,
        saveFilterEntryPointProps,
        updateFilterEntryPointProps,
        entryPointParams
    ]);
    const sendMeatballAnalytics = (0, $euxye.useCallback)(()=>{
        sendFilterAnalytics((0, $6b2913942bd90807$export$b887e88d8d0739f6), (0, $dGnxe.getFilterMeatBallAttributes)({
            isCustom: isCustom,
            isFavourite: isFavourite,
            filterId: filterId
        }));
    }, [
        filterId,
        isCustom,
        isFavourite,
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
        onOpen: sendMeatballAnalytics,
        MenuItems: MenuItems,
        name: name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gYDzv.ChangeOwnerModal), {
        isOpen: isChangeOwnerModalOpen,
        filterId: filterId,
        onRefetch: onRefetch,
        onClose: closeChangeOwnerModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $itFBm.DeleteFilterModal), {
        isOpen: isDeleteFilterModalOpen,
        name: name,
        filterId: filterId,
        onRefetch: onRefetch,
        onClose: closeDeleteFilterModal
    }));
};
$8aa9a9ac707066fa$export$7077dee41f8ad33d.displayName = "Nav4FilterActions";

});
parcelRegister("hSPnC", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ef4299c0795c0de$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb55446a0d01ed6665dd6598c68ade97>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ef4299c0795c0de$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FilterActions",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        }
                    ]
                }
            ],
            "type": "JiraCustomFilter"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$6ef4299c0795c0de$var$node.hash = "fc1df3dea8f781b871d9be816b6279fc";
var $6ef4299c0795c0de$export$2e2bcd8739ae039 = $6ef4299c0795c0de$var$node;

});

parcelRegister("2VfJf", function(module, exports) {
$parcel$export(module.exports, "isFavoritableItemTypename", () => $4493932d9ab96279$export$2bcd2af12bfc25b5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $970ZW = parcelRequire("970ZW");
const $4493932d9ab96279$export$2bcd2af12bfc25b5 = (typename)=>(0, $970ZW.VALID_ITEM_TYPENAMES).some((itemTypename)=>itemTypename === typename);

});

parcelRegister("9d48B", function(module, exports) {
$parcel$export(module.exports, "FavoriteToggleButton", () => $6d916b7927d941e6$export$b01f3062fe4ad89b);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $ip3FN = parcelRequire("ip3FN");

var $fZT95 = parcelRequire("fZT95");

var $cXTqc = parcelRequire("cXTqc");

var $ceqcm = parcelRequire("ceqcm");

var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $hwodR = parcelRequire("hwodR");
const $6d916b7927d941e6$var$addToStarred = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred",
    defaultMessage: "Add to starred"
});
const $6d916b7927d941e6$var$removeFromStarred = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred",
    defaultMessage: "Remove from starred"
});
const $6d916b7927d941e6$var$addToStarredWithName = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred-with-name",
    defaultMessage: "Add \"{name}\" to starred"
});
const $6d916b7927d941e6$var$removeFromStarredWithName = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred-with-name",
    defaultMessage: "Remove \"{name}\" from starred"
});
const $6d916b7927d941e6$var$UnstarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cXTqc))), {
    label: "",
    color: "currentColor",
    spacing: "spacious"
});
const $6d916b7927d941e6$var$StarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fZT95))), {
    label: "",
    color: "var(--ds-icon-accent-yellow, #B38600)",
    spacing: "spacious"
});
const $6d916b7927d941e6$export$b01f3062fe4ad89b = ({ entityId: entityId, entityTypeName: entityTypeName, defaultIsStarred: defaultIsStarred = false, name: name, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [isStarred, setIsStarred] = (0, $euxye.useState)(defaultIsStarred);
    const { changeFavoriteMutation: changeFavoriteMutation } = (0, $ip3FN.useChangeFavorite)();
    const handleOnClick = (0, $euxye.useCallback)(()=>{
        setIsStarred((prevIsStarred)=>!prevIsStarred);
        onClick?.();
    }, [
        onClick
    ]);
    (0, $euxye.useEffect)(()=>{
        if (isStarred !== defaultIsStarred) changeFavoriteMutation({
            id: entityId,
            typename: entityTypeName,
            value: isStarred
        });
    }, [
        entityId,
        entityTypeName,
        isStarred,
        defaultIsStarred,
        changeFavoriteMutation
    ]);
    const handleOnClickWithStopPropagation = (0, $hwodR.useStopPropagation)(handleOnClick);
    return isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        iconBefore: $6d916b7927d941e6$var$StarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage($6d916b7927d941e6$var$removeFromStarredWithName, {
            name: name
        }) : formatMessage($6d916b7927d941e6$var$removeFromStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        color: "color.text"
    }, formatMessage($6d916b7927d941e6$var$removeFromStarred))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        iconBefore: $6d916b7927d941e6$var$UnstarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage($6d916b7927d941e6$var$addToStarredWithName, {
            name: name
        }) : formatMessage($6d916b7927d941e6$var$addToStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        color: "color.text"
    }, formatMessage($6d916b7927d941e6$var$addToStarred)));
};
$6d916b7927d941e6$export$b01f3062fe4ad89b.displayName = "FavoriteToggleButton";

});
parcelRegister("fZT95", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c322cb443b1343016361f8579459466e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba575441968c4bed$var$_react = $ba575441968c4bed$var$_interopRequireDefault((parcelRequire("euxye")));

var $ba575441968c4bed$var$_baseNew = $ba575441968c4bed$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $ba575441968c4bed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/star-starred
 * Usage guidance:
 * Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba575441968c4bed$var$StarStarredIcon = (props)=>/*#__PURE__*/ $ba575441968c4bed$var$_react.default.createElement($ba575441968c4bed$var$_baseNew.default, Object.assign({
        name: "StarStarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$ba575441968c4bed$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $ba575441968c4bed$var$_default = module.exports.default = $ba575441968c4bed$var$StarStarredIcon;

});


parcelRegister("eezi8", function(module, exports) {
$parcel$export(module.exports, "saveFilterDialogEntryPoint", () => $5e76bb9c34244831$export$7485e0220e11838f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $bpFqF = parcelRequire("bpFqF");

const $5e76bb9c34244831$export$7485e0220e11838f = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("h7SH9")), {
        moduleId: "6b7b6fa9",
        priority: "interaction"
    }),
    getPreloadProps: ({ filterAri: filterAri })=>({
            queries: {
                filterDataQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $bpFqF.default,
                    variables: {
                        filterAri: filterAri ?? '',
                        includeFilter: !!filterAri
                    }
                }
            }
        })
});

});
parcelRegister("bpFqF", function(module, exports) {
$parcel$export(module.exports, "default", () => $480c547552c48e3e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3ff6cb0845a1830b8fbf0f1c32684c6d>>
 * @relayHash 16cf2817ba9995def1dd99137aedf193
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a759e5523ae3d9df771a1e69c25ddb486a989da6f175642a661e28640b9b016c
const $480c547552c48e3e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v8 = {
        "kind": "RequiredField",
        "field": {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v2 /*: any*/ ,
                    "action": "THROW"
                },
                v3 /*: any*/ ,
                v7 /*: any*/ 
            ]
        },
        "action": "THROW"
    }, v9 = {
        "kind": "ScalarField",
        "name": "roleId"
    }, v10 = {
        "kind": "RequiredField",
        "field": {
            "concreteType": "JiraRole",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v3 /*: any*/ 
            ]
        },
        "action": "THROW"
    }, v11 = {
        "concreteType": "JiraGroup",
        "kind": "LinkedField",
        "name": "group",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v3 /*: any*/ 
        ]
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "RequiredField",
                "field": v11 /*: any*/ ,
                "action": "THROW"
            }
        ],
        "type": "JiraShareableEntityGroupGrant"
    }, v13 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v13 /*: any*/ ,
                        v3 /*: any*/ ,
                        v14 /*: any*/ 
                    ]
                },
                "action": "THROW"
            }
        ],
        "type": "JiraShareableEntityUserGrant"
    }, v16 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v7 /*: any*/ 
        ]
    }, v17 = {
        "kind": "RequiredField",
        "field": v16 /*: any*/ ,
        "action": "THROW"
    }, v18 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v6 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v16 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityProjectGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v16 /*: any*/ ,
                        {
                            "concreteType": "JiraRole",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v3 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraShareableEntityProjectRoleGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v11 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityGroupGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v13 /*: any*/ ,
                                v3 /*: any*/ ,
                                v14 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraShareableEntityUserGrant"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SaveFilterDialogBaseQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraShareableEntityShareGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "shareGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityShareGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v10 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectRoleGrant"
                                                                        },
                                                                        v12 /*: any*/ ,
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraShareableEntityEditGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "editGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityEditGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v17 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v17 /*: any*/ ,
                                                                                v10 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectRoleGrant"
                                                                        },
                                                                        v12 /*: any*/ ,
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SaveFilterDialogBaseQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraShareableEntityShareGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "shareGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityShareGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": v18 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraShareableEntityEditGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "editGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityEditGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": v18 /*: any*/ 
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a759e5523ae3d9df771a1e69c25ddb486a989da6f175642a661e28640b9b016c",
            "metadata": {},
            "name": "SaveFilterDialogBaseQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$480c547552c48e3e$var$node.hash = "13c80ddfcaeb532571af08e52058efee";
var $480c547552c48e3e$export$2e2bcd8739ae039 = $480c547552c48e3e$var$node;

});

parcelRegister("h7SH9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5qnTS").then(()=>parcelRequire('ehNbi'));

});


parcelRegister("cEwjN", function(module, exports) {
$parcel$export(module.exports, "updateFilterDialogEntryPoint", () => $b6609b23a5886b3f$export$89f63332d1b5f8db);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $bpFqF = parcelRequire("bpFqF");

const $b6609b23a5886b3f$export$89f63332d1b5f8db = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("dUqdr")), {
        moduleId: "a40748cc",
        priority: "interaction"
    }),
    getPreloadProps: ({ filterAri: filterAri })=>({
            queries: {
                filterDataQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $bpFqF.default,
                    variables: {
                        filterAri: filterAri ?? '',
                        includeFilter: !!filterAri
                    }
                }
            }
        })
});

});
parcelRegister("dUqdr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9dWQ6").then(()=>parcelRequire('6WkRe'));

});


parcelRegister("2bpNg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d66dd1931c60e88592e7dfad0d4d211>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $19709de73da72c31$var$_react = $19709de73da72c31$var$_interopRequireDefault((parcelRequire("euxye")));

var $19709de73da72c31$var$_baseNew = $19709de73da72c31$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $19709de73da72c31$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/delete
 * Usage guidance:
 * Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $19709de73da72c31$var$DeleteIcon = (props)=>/*#__PURE__*/ $19709de73da72c31$var$_react.default.createElement($19709de73da72c31$var$_baseNew.default, Object.assign({
        name: "DeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$19709de73da72c31$var$DeleteIcon.displayName = 'DeleteIcon';
var $19709de73da72c31$var$_default = module.exports.default = $19709de73da72c31$var$DeleteIcon;

});

parcelRegister("d8bZ5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70bedda7793532bc09590636c1f0d31e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98f551873407a443$var$_react = $98f551873407a443$var$_interopRequireDefault((parcelRequire("euxye")));

var $98f551873407a443$var$_baseNew = $98f551873407a443$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $98f551873407a443$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/edit
 * Usage guidance:
 * Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98f551873407a443$var$EditIcon = (props)=>/*#__PURE__*/ $98f551873407a443$var$_react.default.createElement($98f551873407a443$var$_baseNew.default, Object.assign({
        name: "EditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$98f551873407a443$var$EditIcon.displayName = 'EditIcon';
var $98f551873407a443$var$_default = module.exports.default = $98f551873407a443$var$EditIcon;

});

parcelRegister("2EZ2h", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c4d62b6a54e91ab28f0d0966b8288ea9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1efea9a312374b56$var$_react = $1efea9a312374b56$var$_interopRequireDefault((parcelRequire("euxye")));

var $1efea9a312374b56$var$_baseNew = $1efea9a312374b56$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $1efea9a312374b56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/email
 * Usage guidance:
 * Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1efea9a312374b56$var$EmailIcon = (props)=>/*#__PURE__*/ $1efea9a312374b56$var$_react.default.createElement($1efea9a312374b56$var$_baseNew.default, Object.assign({
        name: "EmailIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$1efea9a312374b56$var$EmailIcon.displayName = 'EmailIcon';
var $1efea9a312374b56$var$_default = module.exports.default = $1efea9a312374b56$var$EmailIcon;

});

parcelRegister("isqzs", function(module, exports) {
$parcel$export(module.exports, "ModalEntryPointPressableTrigger", () => $707df5d2287fd6c2$export$defad645fcc21c0a);

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $k6sZT = parcelRequire("k6sZT");

var $4GGtd = parcelRequire("4GGtd");

var $b5Dgx = parcelRequire("b5Dgx");

var $55cpN = parcelRequire("55cpN");

var $kENFC = parcelRequire("kENFC");

var $2v3yi = parcelRequire("2v3yi");

var $gpyJM = parcelRequire("gpyJM");

var $4vluQ = parcelRequire("4vluQ");

var $dNPnD = parcelRequire("dNPnD");

var $3PC9r = parcelRequire("3PC9r");

var $am8wf = parcelRequire("am8wf");

var $DIqjH = parcelRequire("DIqjH");

var $fFNvS = parcelRequire("fFNvS");

var $i860n = parcelRequire("i860n");

var $552Md = parcelRequire("552Md");
const $707df5d2287fd6c2$var$emptyObject = {};
const $707df5d2287fd6c2$export$defad645fcc21c0a = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, title: title, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef, hasCloseButton: hasCloseButton })=>{
    const { openModal: openModal } = (0, $euxye.useContext)((0, $b5Dgx.ModalContext));
    const environmentProvider = (0, $55cpN.useJiraRelayEnvironmentProvider)();
    const metricName = (0, $euxye.useMemo)(()=>{
        if (interactionName) return interactionName;
        // @ts-expect-error Need to fix the types on this
        return entryPoint?.root?.getModuleName() ?? 'unknown';
    }, [
        entryPoint,
        interactionName
    ]);
    // eslint-disable-next-line jira/ufo/valid-labels
    const pressTracing = (0, $am8wf.default)(metricName);
    const load = (0, $euxye.useCallback)(()=>(0, $n67Vb.loadEntryPoint)(environmentProvider, entryPoint, // @ts-expect-error TS cannot infer that emptyObject is the correct params
        // type for TEntryPoint even when performing an explicit undefined check
        entryPointParams ?? $707df5d2287fd6c2$var$emptyObject), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onBeforeLoad = (0, $euxye.useCallback)(()=>{
        if (interactionName) pressTracing();
    }, [
        interactionName,
        pressTracing
    ]);
    const onLoad = (0, $euxye.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = ()=>{
                entryPointProps?.onClose?.();
                closeModal();
                dispose();
            };
            const defaultFallbackInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gpyJM.default), {
                hasCloseButton: (0, $i860n.fg)('platform_relay_use_hasclosebutton') && hasCloseButton
            }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dNPnD.default), null, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
                grow: "fill"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v3yi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4vluQ.default), null));
            const defaultFallback = useInternalModal ? defaultFallbackInner : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $DIqjH.JiraModal), {
                messageId: "modal-entry-point-pressable-trigger.modal.fallback",
                messageType: "transactional",
                onClose: closeModal,
                width: modalProps?.width,
                height: modalProps?.height
            }, defaultFallbackInner);
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4GGtd.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorAttributes: errorAttributes,
                errorFallback: "flag",
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                // @ts-expect-error Some type mismatch, should fix it one day
                runtimeProps: {
                    ...entryPointProps ?? $707df5d2287fd6c2$var$emptyObject,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return useInternalModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k6sZT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $DIqjH.JiraModal), {
                ...modalProps,
                messageId: "modal-entry-point-pressable-trigger.modal",
                messageType: "transactional",
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress
            }, container)) : container;
        });
    }, [
        openModal,
        title,
        useInternalModal,
        modalProps,
        errorAttributes,
        Fallback,
        metricName,
        entryPointProps,
        hasCloseButton
    ]);
    const triggerRef = (0, $552Md.usePressablePreloadRef)({
        load: load,
        onBeforeLoad: onBeforeLoad,
        onLoad: onLoad
    });
    const mergedRef = (0, $fFNvS.default)(triggerRef, forwardedRef ?? triggerRef);
    const ref = forwardedRef != null ? mergedRef : triggerRef;
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return children({
        ref: ref
    });
};
$707df5d2287fd6c2$export$defad645fcc21c0a.displayName = "ModalEntryPointPressableTrigger";

});
parcelRegister("am8wf", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5b941f8658fd4cb$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $Cs8MU = parcelRequire("Cs8MU");
function $c5b941f8658fd4cb$export$2e2bcd8739ae039(name) {
    const context = (0, $euxye.useContext)((0, $Cs8MU.default));
    const handleClick = (0, $euxye.useCallback)((timeStamp)=>{
        if (context) {
            const time = timeStamp || performance.now();
            context.tracePress(name, time);
        }
    }, [
        context,
        name
    ]);
    return handleClick;
}

});

parcelRegister("DIqjH", function(module, exports) {
$parcel$export(module.exports, "JiraModal", () => $ec9c8252741dc248$export$3782fcca1f68992e);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gu6Rp = parcelRequire("gu6Rp");

var $7Odw0 = parcelRequire("7Odw0");

var $7tY81 = parcelRequire("7tY81");

var $33qBb = parcelRequire("33qBb");
const $ec9c8252741dc248$export$3782fcca1f68992e = (props)=>{
    if ((0, $gu6Rp.shouldBeChoreographed)(props)) {
        if ((0, $7Odw0.isSupportedUserAgent)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $33qBb.ChoreographerModal), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7tY81.default), rest);
};
$ec9c8252741dc248$export$3782fcca1f68992e.displayName = "JiraModal";
$ec9c8252741dc248$export$3782fcca1f68992e.displayName = 'JiraModal';

});
parcelRegister("33qBb", function(module, exports) {
$parcel$export(module.exports, "ChoreographerModal", () => $08690ae685adb2be$export$3f5d627caa6fc630);
/* eslint-disable jira/filename-case */ 
var $l6b8t = parcelRequire("l6b8t");

var $7tY81 = parcelRequire("7tY81");
const $08690ae685adb2be$export$3f5d627caa6fc630 = (0, $l6b8t.withChoreographedRender)((0, $7tY81.default));

});
parcelRegister("l6b8t", function(module, exports) {
$parcel$export(module.exports, "withChoreographedRender", () => $ed662011ea2e0ae7$export$c1160fdac17030e);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1or3J = parcelRequire("1or3J");

var $aAuB6 = parcelRequire("aAuB6");
function $ed662011ea2e0ae7$export$c1160fdac17030e(Component) {
    function ChoreographedComponent(props) {
        const { messageId: messageId, onMessageDisposition: onMessageDisposition } = props;
        const shouldRender = (0, $aAuB6.useChoreographedRender)({
            messageId: messageId,
            onMessageDisposition: onMessageDisposition
        });
        if (shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1or3J.ChoreographerContextProvider), {
            isChoreographed: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, props));
        return null;
    }
    ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
    function WithChoreographedRenderComponent(props) {
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $1or3J.useChoreographedStatusContext)();
        if (isAlreadyChoreographedAtAncestor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ChoreographedComponent, props);
    }
    WithChoreographedRenderComponent.displayName = `WithChoreographedRender${Component.displayName ?? 'Component'}`;
    return WithChoreographedRenderComponent;
}

});



parcelRegister("552Md", function(module, exports) {
$parcel$export(module.exports, "usePressablePreloadRef", () => $6284439970384832$export$1ff47f24e06a5d2d);

var $euxye = parcelRequire("euxye");
const $6284439970384832$var$PRELOAD_MAX_AGE = 2000;
const $6284439970384832$var$TIME_TO_INTENT = 200;
function $6284439970384832$export$1ff47f24e06a5d2d({ load: load, onBeforeLoad: onBeforeLoad, onLoad: onLoad }) {
    const ref = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $6284439970384832$var$PRELOAD_MAX_AGE);
            }, $6284439970384832$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    return ref;
}

});


parcelRegister("gYDzv", function(module, exports) {
$parcel$export(module.exports, "ChangeOwnerModal", () => $54dda1c9a2b2541d$export$fe3f500d38bfe0df);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $igWOa = parcelRequire("igWOa");
const $54dda1c9a2b2541d$export$fe3f500d38bfe0df = ({ isOpen: isOpen, filterId: filterId, onRefetch: onRefetch, onClose: onClose })=>{
    const onSuccess = (0, $euxye.useCallback)(()=>{
        onRefetch({
            onComplete: ()=>undefined
        });
        onClose();
    }, [
        onRefetch,
        onClose
    ]);
    return isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $igWOa.default), {
        id: filterId,
        onInitiateSuccess: ()=>undefined,
        onSuccess: onSuccess,
        onCancel: onClose,
        onInitiateFailed: ()=>undefined
    });
};
$54dda1c9a2b2541d$export$fe3f500d38bfe0df.displayName = "ChangeOwnerModal";

});
parcelRegister("igWOa", function(module, exports) {
$parcel$export(module.exports, "default", () => $a512f6490c1da7f9$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $zLbDw = parcelRequire("zLbDw");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a512f6490c1da7f9$var$NoLazyAsyncChangeOwnerFilterModal = (0, $l8G1z.lazy)(()=>(parcelRequire("bX6PC")), {
    moduleId: "./src/packages/global-pages/directories-filters-directory-v2-change-owner-filter-modal/src/index.tsx"
});
const $a512f6490c1da7f9$var$AsyncChangeOwnerFilterModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "configure-owner-modal",
        packageName: "filter",
        fallback: "flag",
        teamName: "endeavour"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "change-owner-filter-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $zLbDw.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a512f6490c1da7f9$var$NoLazyAsyncChangeOwnerFilterModal, props)));
$a512f6490c1da7f9$var$AsyncChangeOwnerFilterModal.displayName = "AsyncChangeOwnerFilterModal";
var $a512f6490c1da7f9$export$2e2bcd8739ae039 = $a512f6490c1da7f9$var$AsyncChangeOwnerFilterModal;

});
parcelRegister("bX6PC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6H6aC").then(()=>parcelRequire('4rLvK'));

});



parcelRegister("itFBm", function(module, exports) {
$parcel$export(module.exports, "DeleteFilterModal", () => $26a8c3339ba30652$export$7eeb027d3dbb72df);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $iUhWU = parcelRequire("iUhWU");

var $iQPOZ = parcelRequire("iQPOZ");

var $2ffUK = parcelRequire("2ffUK");
var $55BnK = parcelRequire("55BnK");

var $7eNDO = parcelRequire("7eNDO");
const $26a8c3339ba30652$var$filterDeletedModalTitleSuccessNonFinal = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-title-success-non-final",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "{name} was deleted"
});
const $26a8c3339ba30652$var$filterDeletedModalTitleErrorNonFinal = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-title-error-non-final",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "We couldn't delete filter"
});
const $26a8c3339ba30652$var$filterDeletedModalDescriptionErrorNonFinal = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-description-error-non-final",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "There was an error, please try again."
});
const $26a8c3339ba30652$export$7eeb027d3dbb72df = ({ isOpen: isOpen, name: name, filterId: filterId, onClose: onClose, onRefetch: onRefetch })=>{
    const { showFlag: showFlag } = (0, $iQPOZ.useFlagService)();
    const { push: push } = (0, $55BnK.useRouterActions)();
    const [filterQueryParam] = (0, $2ffUK.useQueryParam)('filter');
    const onSuccess = (0, $euxye.useCallback)(()=>{
        onRefetch({
            onComplete: ()=>undefined
        });
        if (filterQueryParam === filterId) push('/jira/filters');
        onClose();
        showFlag({
            id: 'filter-deleted',
            title: [
                $26a8c3339ba30652$var$filterDeletedModalTitleSuccessNonFinal,
                {
                    name: name
                }
            ],
            type: 'success',
            // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
            messageId: 'navigation-apps-sidebar-nav4-sidebars-content-filters.common.ui.filter-actions.delete-filter-modal.show-flag.success',
            messageType: 'transactional'
        });
    }, [
        filterId,
        filterQueryParam,
        name,
        onClose,
        onRefetch,
        push,
        showFlag
    ]);
    const onFailure = (0, $euxye.useCallback)(()=>{
        onClose();
        showFlag({
            id: 'filter-delete-failed',
            title: $26a8c3339ba30652$var$filterDeletedModalTitleErrorNonFinal,
            description: $26a8c3339ba30652$var$filterDeletedModalDescriptionErrorNonFinal,
            type: 'error',
            // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
            messageId: 'navigation-apps-sidebar-nav4-sidebars-content-filters.common.ui.filter-actions.delete-filter-modal.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        onClose,
        showFlag
    ]);
    const filter = {
        name: name,
        id: filterId
    };
    return isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iUhWU.default), {
        filter: filter,
        onFilterDeleted: onSuccess,
        onFilterDeleteFailed: onFailure,
        onFilterInitiateFailed: onFailure,
        onCancel: onClose
    });
};
$26a8c3339ba30652$export$7eeb027d3dbb72df.displayName = "DeleteFilterModal";

});
parcelRegister("iUhWU", function(module, exports) {
$parcel$export(module.exports, "default", () => $2aa7e90fac1d7c80$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $dCJKF = parcelRequire("dCJKF");

var $bx8kK = parcelRequire("bx8kK");

var $lK2hH = parcelRequire("lK2hH");

var $kwMul = parcelRequire("kwMul");


var $9z7w4 = parcelRequire("9z7w4");

var $4qkcw = parcelRequire("4qkcw");

var $1PYT2 = parcelRequire("1PYT2");

var $14oCL = parcelRequire("14oCL");

// eslint-disable-next-line jira/react/no-class-components
class $2aa7e90fac1d7c80$var$DeleteModal extends (0, $euxye.Component) {
    static{
        this.defaultProps = {
            onInitialised: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
            onFilterDeleted: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $1PYT2.default)((0, $9z7w4.default));
        this.store.dispatch((0, $4qkcw.setAppProps)(this.props));
        this.store.dispatch((0, $4qkcw.getAssociatedItems)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kwMul.Provider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dCJKF.ReportErrors), {
            id: "unhandled",
            packageName: "jiraDeleteFiltersModal",
            teamName: "jira-cosmos"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lK2hH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $14oCL.default), null))));
    }
}
$2aa7e90fac1d7c80$var$DeleteModal.displayName = "DeleteModal";
const $2aa7e90fac1d7c80$var$DeleteFiltersModal = (0, $bx8kK.AnalyticsSource)('deleteFilter', (0, $46f069e6c968f461$export$1171103ea9083ffa))($2aa7e90fac1d7c80$var$DeleteModal);
var $2aa7e90fac1d7c80$export$2e2bcd8739ae039 = $2aa7e90fac1d7c80$var$DeleteFiltersModal;

});
parcelRegister("lK2hH", function(module, exports) {
$parcel$export(module.exports, "default", () => $46fd3158003be625$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $46fd3158003be625$var$AppStyle = ({ children: children })=>/*#__PURE__*/ $euxye.createElement("div", {
        className: (0, $4jQY2.default)([
            "_11c8fhey _4t3i1kw7"
        ])
    }, children);
$46fd3158003be625$var$AppStyle.displayName = "AppStyle";
const $46fd3158003be625$var$appStyles = null;
var $46fd3158003be625$export$2e2bcd8739ae039 = $46fd3158003be625$var$AppStyle;

});

parcelRegister("9z7w4", function(module, exports) {
$parcel$export(module.exports, "default", () => $571f3fdeed02a2d4$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $esROC = parcelRequire("esROC");

var $k99Eu = parcelRequire("k99Eu");

var $cNgOW = parcelRequire("cNgOW");
const $571f3fdeed02a2d4$var$DeleteFiltersModalOps = (0, $esROC.combineEpics)((0, $k99Eu.default), (0, $cNgOW.default));
var $571f3fdeed02a2d4$export$2e2bcd8739ae039 = $571f3fdeed02a2d4$var$DeleteFiltersModalOps;

});
parcelRegister("k99Eu", function(module, exports) {
$parcel$export(module.exports, "default", () => $f75a92ca0e562080$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
parcelRequire("2Sm07");
parcelRequire("2Jqao");
parcelRequire("2cT7B");
parcelRequire("aMktH");

var $dmX0B = parcelRequire("dmX0B");

var $6CfY5 = parcelRequire("6CfY5");

var $fsPBA = parcelRequire("fsPBA");

var $4qkcw = parcelRequire("4qkcw");

var $69ula = parcelRequire("69ula");
const $f75a92ca0e562080$var$deleteEpic = (action$, store)=>action$.ofType((0, $4qkcw.DELETE_FILTER)).mergeMap(({ onComplete: onComplete })=>{
        const state = store.getState();
        const filter = (0, $69ula.getFilter)(state);
        return (0, $dmX0B.Observable).fromPromise((0, $fsPBA.default)(filter.id)).mergeMap(()=>{
            (0, $69ula.getOnFilterDeleted)(state)(filter);
            onComplete?.();
            return (0, $dmX0B.Observable).of((0, $4qkcw.filterDeleted)());
        }).catch((error)=>{
            (0, $6CfY5.default).safeErrorWithoutCustomerData('directories.filters-v2.delete-modal.ops.delete-filter', error.message, error);
            (0, $69ula.getOnFilterDeleteFailed)(state)(filter);
            return (0, $dmX0B.Observable).of((0, $4qkcw.deleteFilterFailed)());
        });
    });
var $f75a92ca0e562080$export$2e2bcd8739ae039 = $f75a92ca0e562080$var$deleteEpic;

});
parcelRegister("fsPBA", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d2e14be47ed88ef$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $13Ytn = parcelRequire("13Ytn");
const $8d2e14be47ed88ef$var$deleteFilterService = (filterId)=>(0, $13Ytn.default)(filterId);
var $8d2e14be47ed88ef$export$2e2bcd8739ae039 = $8d2e14be47ed88ef$var$deleteFilterService;

});
parcelRegister("13Ytn", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9819caeb4063106$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $e9819caeb4063106$export$7138c24907de3954 = (filterId)=>`/rest/api/3/filter/${filterId}`;
const $e9819caeb4063106$var$deleteRest = (filterId)=>(0, $h2wCv.performDeleteRequest)($e9819caeb4063106$export$7138c24907de3954(filterId));
var $e9819caeb4063106$export$2e2bcd8739ae039 = $e9819caeb4063106$var$deleteRest;

});


parcelRegister("4qkcw", function(module, exports) {
$parcel$export(module.exports, "SET_APP_PROPS", () => $a9a1e4952530140d$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $a9a1e4952530140d$export$cfda7627848a58cd);
$parcel$export(module.exports, "GET_ASSOCIATED_ITEMS", () => $a9a1e4952530140d$export$30d51c320095bdf2);
$parcel$export(module.exports, "getAssociatedItems", () => $a9a1e4952530140d$export$41e54fd4a1e5f9ba);
$parcel$export(module.exports, "ASSOCIATED_ITEMS_RETRIEVED", () => $a9a1e4952530140d$export$ba1e7147572f059);
$parcel$export(module.exports, "associatedItemsRetrieved", () => $a9a1e4952530140d$export$25e9475c64e5eda0);
$parcel$export(module.exports, "GET_ASSOCIATED_ITEMS_FAILED", () => $a9a1e4952530140d$export$4c7da338bde02996);
$parcel$export(module.exports, "getAssociatedItemsFailed", () => $a9a1e4952530140d$export$bc1efa3ceb08db7b);
$parcel$export(module.exports, "DELETE_FILTER", () => $a9a1e4952530140d$export$c90b00f6f11adca7);
$parcel$export(module.exports, "deleteFilter", () => $a9a1e4952530140d$export$d80cc0328fcc6685);
$parcel$export(module.exports, "DELETE_FILTER_FAILED", () => $a9a1e4952530140d$export$d3f2a09b0efe5b07);
$parcel$export(module.exports, "deleteFilterFailed", () => $a9a1e4952530140d$export$e303ddf5f6d63378);
$parcel$export(module.exports, "FILTER_DELETED", () => $a9a1e4952530140d$export$c8cf94be5a7baff9);
$parcel$export(module.exports, "filterDeleted", () => $a9a1e4952530140d$export$9411fafcb56b5a87);
/* eslint-disable jira/filename-case */ const $a9a1e4952530140d$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $a9a1e4952530140d$export$cfda7627848a58cd = (payload)=>({
        type: $a9a1e4952530140d$export$8aefe701a6f431e0,
        payload: payload
    });
const $a9a1e4952530140d$export$30d51c320095bdf2 = 'state.GET_ASSOCIATED_ITEMS';
const $a9a1e4952530140d$export$41e54fd4a1e5f9ba = ()=>({
        type: $a9a1e4952530140d$export$30d51c320095bdf2
    });
const $a9a1e4952530140d$export$ba1e7147572f059 = 'state.ASSOCIATED_ITEMS_RETRIEVED';
const $a9a1e4952530140d$export$25e9475c64e5eda0 = (payload)=>({
        type: $a9a1e4952530140d$export$ba1e7147572f059,
        payload: payload
    });
const $a9a1e4952530140d$export$4c7da338bde02996 = 'state.GET_ASSOCIATED_ITEMS_FAILED';
const $a9a1e4952530140d$export$bc1efa3ceb08db7b = ()=>({
        type: $a9a1e4952530140d$export$4c7da338bde02996
    });
const $a9a1e4952530140d$export$c90b00f6f11adca7 = 'state.DELETE_FILTER';
const $a9a1e4952530140d$export$d80cc0328fcc6685 = (onComplete)=>({
        type: $a9a1e4952530140d$export$c90b00f6f11adca7,
        onComplete: onComplete
    });
const $a9a1e4952530140d$export$d3f2a09b0efe5b07 = 'state.DELETE_FILTER_FAILED';
const $a9a1e4952530140d$export$e303ddf5f6d63378 = ()=>({
        type: $a9a1e4952530140d$export$d3f2a09b0efe5b07
    });
const $a9a1e4952530140d$export$c8cf94be5a7baff9 = 'state.FILTER_DELETED';
const $a9a1e4952530140d$export$9411fafcb56b5a87 = ()=>({
        type: $a9a1e4952530140d$export$c8cf94be5a7baff9
    });

});

parcelRegister("69ula", function(module, exports) {
$parcel$export(module.exports, "getFilter", () => $640ef2d9f8aaba25$export$61ec8404f465cd36);
$parcel$export(module.exports, "getFilterName", () => $640ef2d9f8aaba25$export$b055b0a980ec5c8b);
$parcel$export(module.exports, "getOnInitialised", () => $640ef2d9f8aaba25$export$47263859bc15a8b8);
$parcel$export(module.exports, "getOnFilterDeleted", () => $640ef2d9f8aaba25$export$f5f4c932a633fd32);
$parcel$export(module.exports, "getOnFilterDeleteFailed", () => $640ef2d9f8aaba25$export$eb50a3cf06607a3c);
$parcel$export(module.exports, "getOnFilterInitiateFailed", () => $640ef2d9f8aaba25$export$9ef18d2a82ac120);
$parcel$export(module.exports, "getOnCancel", () => $640ef2d9f8aaba25$export$2c6267c00ffc9906);
$parcel$export(module.exports, "isDeleteInProgress", () => $640ef2d9f8aaba25$export$906c0d65e4ece39d);
$parcel$export(module.exports, "isDataRetrieved", () => $640ef2d9f8aaba25$export$a9211cdc0a6969f);
$parcel$export(module.exports, "getAssociatedBoards", () => $640ef2d9f8aaba25$export$2de9e9ee805a66);
$parcel$export(module.exports, "getAssociatedUsers", () => $640ef2d9f8aaba25$export$4004cc0feaedb1d1);
$parcel$export(module.exports, "getAssociatedGroups", () => $640ef2d9f8aaba25$export$4f21761c9913ab49);
$parcel$export(module.exports, "getCanDelete", () => $640ef2d9f8aaba25$export$e31d21defdc79bd5);
/* eslint-disable jira/filename-case */ const $640ef2d9f8aaba25$export$61ec8404f465cd36 = (state)=>state.appProps.filter;
const $640ef2d9f8aaba25$export$b055b0a980ec5c8b = (state)=>state.appProps.filter.name;
const $640ef2d9f8aaba25$export$47263859bc15a8b8 = (state)=>state.appProps.onInitialised;
const $640ef2d9f8aaba25$export$f5f4c932a633fd32 = (state)=>state.appProps.onFilterDeleted;
const $640ef2d9f8aaba25$export$eb50a3cf06607a3c = (state)=>state.appProps.onFilterDeleteFailed;
const $640ef2d9f8aaba25$export$9ef18d2a82ac120 = (state)=>state.appProps.onFilterInitiateFailed;
const $640ef2d9f8aaba25$export$2c6267c00ffc9906 = (state)=>state.appProps.onCancel;
const $640ef2d9f8aaba25$export$906c0d65e4ece39d = (state)=>state.isDeleteInProgress;
const $640ef2d9f8aaba25$export$a9211cdc0a6969f = (state)=>state.isDataRetrieved;
const $640ef2d9f8aaba25$export$2de9e9ee805a66 = (state)=>state.boards;
const $640ef2d9f8aaba25$export$4004cc0feaedb1d1 = (state)=>state.users;
const $640ef2d9f8aaba25$export$4f21761c9913ab49 = (state)=>state.groups;
const $640ef2d9f8aaba25$export$e31d21defdc79bd5 = (state)=>Array.isArray(state.boards) && state.boards.length === 0;

});


parcelRegister("cNgOW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b727c59220e8deb$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
parcelRequire("2Sm07");
parcelRequire("2Jqao");
parcelRequire("BAW9Z");
parcelRequire("21M0S");
parcelRequire("2cT7B");
parcelRequire("aMktH");

var $dmX0B = parcelRequire("dmX0B");

var $6CfY5 = parcelRequire("6CfY5");

var $kW2ne = parcelRequire("kW2ne");

var $lXRd6 = parcelRequire("lXRd6");

var $4qkcw = parcelRequire("4qkcw");

var $69ula = parcelRequire("69ula");
const $8b727c59220e8deb$var$getItems = (action$, store)=>action$.ofType((0, $4qkcw.GET_ASSOCIATED_ITEMS)).mergeMap(()=>{
        const state = store.getState();
        const filter = (0, $69ula.getFilter)(state);
        return (0, $dmX0B.Observable).forkJoin((0, $dmX0B.Observable).fromPromise((0, $kW2ne.default)(filter.id)), (0, $dmX0B.Observable).fromPromise((0, $lXRd6.default)(filter.id))) // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        .map(([boards, subscriptions])=>{
            const { users: users, groups: groups } = subscriptions;
            (0, $69ula.getOnInitialised)(state)();
            return (0, $4qkcw.associatedItemsRetrieved)({
                boards: boards,
                users: users,
                groups: groups
            });
        }).catch((error)=>{
            (0, $6CfY5.default).safeErrorWithoutCustomerData('directories.filters-v2.delete-modal.ops.get-associated-items', error.message, error);
            (0, $69ula.getOnFilterInitiateFailed)(state)(filter);
            return (0, $dmX0B.Observable).of((0, $4qkcw.getAssociatedItemsFailed)());
        });
    });
var $8b727c59220e8deb$export$2e2bcd8739ae039 = $8b727c59220e8deb$var$getItems;

});
parcelRegister("kW2ne", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0eb2bc6e6a0e6df$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $870J9 = parcelRequire("870J9");

var $addA3 = parcelRequire("addA3");
const $c0eb2bc6e6a0e6df$var$getBoards = async (filterId)=>{
    const response = await (0, $870J9.default)(filterId);
    return (0, $addA3.transformResponse)(response);
};
var $c0eb2bc6e6a0e6df$export$2e2bcd8739ae039 = $c0eb2bc6e6a0e6df$var$getBoards;

});
parcelRegister("870J9", function(module, exports) {
$parcel$export(module.exports, "default", () => $54e837fa13d917c8$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4fhEY = parcelRequire("4fhEY");
const $54e837fa13d917c8$export$7138c24907de3954 = (filterId)=>`/rest/agile/1.0/board/filter/${filterId}`;
const $54e837fa13d917c8$var$getBoards = (filterId)=>(0, $4fhEY.default)($54e837fa13d917c8$export$7138c24907de3954(filterId));
var $54e837fa13d917c8$export$2e2bcd8739ae039 = $54e837fa13d917c8$var$getBoards;

});

parcelRegister("addA3", function(module, exports) {
$parcel$export(module.exports, "transformResponse", () => $56b22509f09dfd89$export$3361e9be8093ddcc);
/* eslint-disable jira/filename-case */ const $56b22509f09dfd89$export$b708cb7873d8352c = (id)=>`/secure/RapidBoard.jspa?rapidView=${id}&useStoredSettings=true`;
const $56b22509f09dfd89$export$3361e9be8093ddcc = (response)=>{
    const boards = response && response.values || [];
    return boards.map((board)=>{
        const { name: name, id: id } = board;
        const href = $56b22509f09dfd89$export$b708cb7873d8352c(id);
        return {
            name: name,
            id: id,
            href: href
        };
    });
};

});


parcelRegister("lXRd6", function(module, exports) {
$parcel$export(module.exports, "default", () => $cad0914f018689b3$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7A5rW = parcelRequire("7A5rW");

var $hmPb7 = parcelRequire("hmPb7");
const $cad0914f018689b3$var$getAssociatedSubscriptions = async (filterId)=>{
    const response = await (0, $7A5rW.default)(filterId);
    return (0, $hmPb7.transformResponse)(response);
};
var $cad0914f018689b3$export$2e2bcd8739ae039 = $cad0914f018689b3$var$getAssociatedSubscriptions;

});
parcelRegister("7A5rW", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd0047fdaf4555b4$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4fhEY = parcelRequire("4fhEY");
const $dd0047fdaf4555b4$export$7138c24907de3954 = (filterId)=>`/rest/api/3/filter/${filterId}?expand=subscriptions`;
const $dd0047fdaf4555b4$var$getAssociatedSubscription = (filterId)=>(0, $4fhEY.default)($dd0047fdaf4555b4$export$7138c24907de3954(filterId));
var $dd0047fdaf4555b4$export$2e2bcd8739ae039 = $dd0047fdaf4555b4$var$getAssociatedSubscription;

});

parcelRegister("hmPb7", function(module, exports) {
$parcel$export(module.exports, "transformResponse", () => $6944584a6b779d26$export$3361e9be8093ddcc);
/* eslint-disable jira/filename-case */ 
var $3LhWS = parcelRequire("3LhWS");

var $i860n = parcelRequire("i860n");
const $6944584a6b779d26$export$d62b55bf0ad74ba2 = (id)=>{
    if ((0, $i860n.fg)('jira-adopt-teams-nav-config')) {
        const { href: href } = (0, $3LhWS.getNavigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: id
            }
        });
        return href;
    }
    return `/jira/people/${id}`;
};
const $6944584a6b779d26$export$3361e9be8093ddcc = (response)=>{
    const subscriptions = response && response.subscriptions && response.subscriptions.items || [];
    const users = [];
    const groups = [];
    subscriptions.forEach((subscription)=>{
        const { user: user, group: group } = subscription;
        if (group) return groups.push({
            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'never'.
            name: group.name
        });
        // @ts-expect-error - TS2339 - Property 'accountId' does not exist on type 'never'.
        const href = $6944584a6b779d26$export$d62b55bf0ad74ba2(user.accountId);
        return user && users.push({
            // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'never'.
            displayName: user.displayName,
            href: href
        });
    });
    return {
        users: users,
        groups: groups
    };
};

});
parcelRegister("3LhWS", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => $161b4cbc0fa390d9$export$520a42ab062954ec);
$parcel$export(module.exports, "getNavigateToTeamsApp", () => $161b4cbc0fa390d9$export$cfadab73fb247145);
$parcel$export(module.exports, "useTransformToTeamsAppUrl", () => $161b4cbc0fa390d9$export$dc7e633fb6368a43);
$parcel$export(module.exports, "toTeamsAppURL", () => $161b4cbc0fa390d9$export$196b2cec97b1c87c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6zTYs = parcelRequire("6zTYs");

var $6bEm8 = parcelRequire("6bEm8");

var $cM6Cj = parcelRequire("cM6Cj");

var $kt86l = parcelRequire("kt86l");

var $55BnK = parcelRequire("55BnK");
const $161b4cbc0fa390d9$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    const cloudId = (0, $kt86l.useCloudId)();
    const { push: push } = (0, $55BnK.useRouterActions)();
    if (!orgId && !cloudId) throw new Error('Org ID or Cloud ID is required to navigate to Teams App');
    return (0, $cM6Cj.navigateToTeamsApp)({
        push: push,
        hostProduct: 'jira',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
const $161b4cbc0fa390d9$export$cfadab73fb247145 = (navActionPayload, shouldOpenInSameTab)=>{
    const orgId = (0, $6bEm8.default)('ajs-org-id');
    const cloudId = (0, $6bEm8.default)('ajs-cloud-id');
    return (0, $cM6Cj.navigateToTeamsApp)({
        hostProduct: 'jira',
        orgId: orgId || '',
        cloudId: cloudId || undefined,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
const $161b4cbc0fa390d9$export$dc7e633fb6368a43 = (path, search = '')=>{
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    const cloudId = (0, $kt86l.useCloudId)();
    return (0, $cM6Cj.toTeamsAppURL)(path, search, {
        orgId: orgId,
        cloudId: cloudId
    });
};
const $161b4cbc0fa390d9$export$196b2cec97b1c87c = (path, search = '')=>{
    const orgId = (0, $6bEm8.default)('ajs-org-id');
    const cloudId = (0, $6bEm8.default)('ajs-cloud-id');
    return (0, $cM6Cj.toTeamsAppURL)(path, search, {
        orgId: orgId ?? '',
        cloudId: cloudId ?? ''
    });
};

});
parcelRegister("cM6Cj", function(module, exports) {
$parcel$export(module.exports, "navigateToTeamsApp", () => $ba7f8f8fdf84fd70$export$cd99a4ca8e852372);
$parcel$export(module.exports, "toTeamsAppURL", () => $ba7f8f8fdf84fd70$export$196b2cec97b1c87c);

var $051xe = parcelRequire("051xe");

var $jciiq = parcelRequire("jciiq");
const $ba7f8f8fdf84fd70$export$cd99a4ca8e852372 = (action)=>{
    const { hostProduct: hostProduct, shouldOpenInSameTab: shouldOpenInSameTab } = action;
    const actionWithDefaults = {
        ...action,
        /**
		 * If teams app is enabled, default to opening in new tab.
		 */ shouldOpenInSameTab: shouldOpenInSameTab === undefined ? !(0, $051xe.isTeamsAppEnabled)(action) : shouldOpenInSameTab,
        hostProduct: hostProduct || (0, $jciiq.getHostProductFromPath)()
    };
    const { path: path, query: query } = (0, $jciiq.getPathAndQuery)(actionWithDefaults);
    const href = (0, $jciiq.generatePath)(path, actionWithDefaults, query);
    const onNavigate = (0, $jciiq.onNavigateBase)(href, actionWithDefaults);
    const result = {
        onNavigate: onNavigate,
        href: href,
        target: actionWithDefaults.shouldOpenInSameTab ? '_self' : '_blank'
    };
    return result;
};
const $ba7f8f8fdf84fd70$export$196b2cec97b1c87c = (path, search, config)=>{
    return (0, $jciiq.generateTeamsAppPath)(path, config, new URLSearchParams(search));
};

});
parcelRegister("051xe", function(module, exports) {
$parcel$export(module.exports, "isTeamsAppEnabled", () => $dfd8b9302c128542$export$5921b2a93a401547);
function $dfd8b9302c128542$export$5921b2a93a401547(_config) {
    return true;
}

});

parcelRegister("jciiq", function(module, exports) {
$parcel$export(module.exports, "generateTeamsAppPath", () => $f64dda48260a8a78$export$9665cb78fbba2c92);
$parcel$export(module.exports, "generatePath", () => $f64dda48260a8a78$export$82476f982757e71e);
$parcel$export(module.exports, "onNavigateBase", () => $f64dda48260a8a78$export$39f25014273b0a58);
$parcel$export(module.exports, "getPathAndQuery", () => $f64dda48260a8a78$export$b406f12e2156b3fe);
$parcel$export(module.exports, "getHostProductFromPath", () => $f64dda48260a8a78$export$a792d22ca73cc3ca);

var $gLXcp = parcelRequire("gLXcp");

var $1MzVa = parcelRequire("1MzVa");

var $l1vE2 = parcelRequire("l1vE2");

var $lRYAe = parcelRequire("lRYAe");

var $XSGFc = parcelRequire("XSGFc");

var $051xe = parcelRequire("051xe");
function $f64dda48260a8a78$export$9665cb78fbba2c92(path, config, query = new URLSearchParams(), anchor) {
    if (config.cloudId) query.set('cloudId', config.cloudId);
    const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`;
    const pathWithPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash : `/people${pathWithLeadingSlash}`;
    const pathWithoutPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash.replace(/^\/people\//, '/') : pathWithLeadingSlash;
    // URLSearchParams.size doesn't work in jest
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    // Home & therefore the Teams app, is not deployed to FedRamp, instead we have deployed Standalone directory.
    // At some point, likely both Commercial & FedRamp will follow the same URL convention and we can remove this,
    // but for now, we need to generate a different URL for FedRamp.
    if ((0, $l1vE2.isFedRamp)()) // We can't use getATLContextUrl here as the URL doesn't yet exist in commercial. When it does, we should properly define it there.
    return `https://teams${$f64dda48260a8a78$export$a9f2c34176fff494() ? '.stg' : ''}.atlassian-us-gov-mod.com${pathWithoutPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
    const orgIdString = config.orgId ? `/o/${config.orgId}` : '';
    if ((0, $lRYAe.isIsolatedCloud)()) return `${(0, $1MzVa.getUrlForDomainInContext)('home', $f64dda48260a8a78$export$57570b1603cf6adb())}${orgIdString}${pathWithPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
    return `${(0, $gLXcp.getATLContextUrl)('home')}${orgIdString}${pathWithPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
}
const $f64dda48260a8a78$export$57570b1603cf6adb = ()=>{
    // @ts-expect-error
    return document.querySelector('meta[name=ajs-environment]')?.content === 'staging' ? 'staging' : 'prod';
};
function $f64dda48260a8a78$export$82476f982757e71e(path, config, query = new URLSearchParams(), anchor) {
    if ((0, $051xe.isTeamsAppEnabled)(config) || config.hostProduct === 'home' || !config.hostProduct) return $f64dda48260a8a78$export$9665cb78fbba2c92(path, config, query, anchor);
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    return `${(0, $XSGFc.origin)()}/${config.hostProduct === 'confluence' ? 'wiki' : 'jira'}/people/${path}${queryString}`;
}
const $f64dda48260a8a78$export$39f25014273b0a58 = (href, config)=>(e)=>{
        if (e) e.preventDefault();
        if ((0, $051xe.isTeamsAppEnabled)(config)) {
            if (config.shouldOpenInSameTab) {
                (0, $XSGFc.redirect)(href);
                return;
            }
            (0, $XSGFc.openInNewTab)(href);
            return;
        } else if (config.shouldOpenInSameTab) {
            if (config.push) {
                config.push(href);
                return;
            }
            (0, $XSGFc.redirect)(href);
            return;
        } else {
            (0, $XSGFc.openInNewTab)(href);
            return;
        }
    };
function $f64dda48260a8a78$var$stripAriFromId(id) {
    // Return everything after the last slash
    return id.includes('/') ? id.split('/').pop() || '' : id;
}
function $f64dda48260a8a78$export$b406f12e2156b3fe(action) {
    switch(action.type){
        case 'LANDING':
        case 'DIRECTORY':
            return {
                path: ''
            };
        case 'USER':
            // Safety check for undefined userId, just redirect to the landing page as the profile redirect will fail
            if (!action.payload?.userId) return {
                path: ''
            };
            return {
                path: `${$f64dda48260a8a78$var$stripAriFromId(action.payload.userId)}`,
                anchor: action.payload.section
            };
        case 'TEAM':
            // Safety check for undefined teamId, just redirect to the landing page as the team redirect will fail
            if (!action.payload?.teamId) return {
                path: ''
            };
            return {
                path: `team/${$f64dda48260a8a78$var$stripAriFromId(action.payload.teamId)}`
            };
        case 'AGENT':
            // Safety check for undefined agentId, just redirect to the landing page as the agent redirect will fail
            if (!action.payload?.agentId) return {
                path: ''
            };
            return {
                path: `agent/${$f64dda48260a8a78$var$stripAriFromId(action.payload.agentId)}`
            };
        case 'KUDOS':
            // Safety check for undefined kudosId, just redirect to the landing page as the kudos redirect will fail
            if (!action.payload?.kudosId) return {
                path: ''
            };
            return {
                path: `kudos/${$f64dda48260a8a78$var$stripAriFromId(action.payload.kudosId)}`
            };
        case 'TEAMS_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_TEAMS'
                })
            };
        case 'PEOPLE_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_PEOPLE'
                })
            };
        case 'USER_WORK':
            return {
                path: `${$f64dda48260a8a78$var$stripAriFromId(action.payload.userId)}/work`
            };
        case 'CURRENT_USER_PROFILE':
            return {
                path: 'me'
            };
        default:
            return {
                path: ''
            };
    }
}
function $f64dda48260a8a78$export$a9f2c34176fff494() {
    const host = (0, $XSGFc.hostname)();
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (host.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return true;
    // *.atlassian-stg-fedm.net
    if (host.match(/atlassian-stg-fedm\.net/)) return true;
    return false;
}
function $f64dda48260a8a78$export$a792d22ca73cc3ca() {
    const path = (0, $XSGFc.pathname)();
    if (path.startsWith('/wiki')) return 'confluence';
    if (path.startsWith('/jira')) return 'jira';
    if ((0, $XSGFc.hostname)().startsWith('home')) return 'home';
    return undefined;
}

});
parcelRegister("gLXcp", function(module, exports) {
$parcel$export(module.exports, "getATLContextUrl", () => $9a687b36fbddcdd1$export$45d6512913ef41b4);

var $6RG3D = parcelRequire("6RG3D");
function $9a687b36fbddcdd1$export$45d6512913ef41b4(domain) {
    return `${globalThis.location?.protocol ?? 'https:'}//${(0, $6RG3D.getATLContextDomain)(domain)}`;
}

});

parcelRegister("XSGFc", function(module, exports) {
$parcel$export(module.exports, "redirect", () => $05649115c0f37b8f$export$89e12c5b50f7529d);
$parcel$export(module.exports, "openInNewTab", () => $05649115c0f37b8f$export$9e52b10d57ddf9e3);
$parcel$export(module.exports, "hostname", () => $05649115c0f37b8f$export$640106f6dc7d2706);
$parcel$export(module.exports, "origin", () => $05649115c0f37b8f$export$f710a83a91838a36);
$parcel$export(module.exports, "pathname", () => $05649115c0f37b8f$export$7333db99aa99d383);
function $05649115c0f37b8f$export$89e12c5b50f7529d(url) {
    window.location.href = url;
}
const $05649115c0f37b8f$export$9e52b10d57ddf9e3 = (url)=>window.open(url, '_blank', 'noopener noreferrer');
const $05649115c0f37b8f$export$640106f6dc7d2706 = ()=>globalThis.location?.hostname;
const $05649115c0f37b8f$export$f710a83a91838a36 = ()=>globalThis.location?.origin;
const $05649115c0f37b8f$export$7333db99aa99d383 = ()=>globalThis.location?.pathname;

});








parcelRegister("1PYT2", function(module, exports) {
$parcel$export(module.exports, "default", () => $75fb69b52e85549a$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux

var $6772o = parcelRequire("6772o");

var $cJiqy = parcelRequire("cJiqy");
const $75fb69b52e85549a$var$createStore = (rootEpic)=>(0, $6772o.default)({
        appName: 'directories/filters-v2/delete-modal',
        rootReducer: $cJiqy.default,
        rootEpic: rootEpic
    });
var $75fb69b52e85549a$export$2e2bcd8739ae039 = $75fb69b52e85549a$var$createStore;

});
parcelRegister("cJiqy", function(module, exports) {
$parcel$export(module.exports, "default", () => $c72b3972b3ba3250$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $4qkcw = parcelRequire("4qkcw");
const $c72b3972b3ba3250$export$49d5fc8cba920a0 = {
    // oxlint-disable-next-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
    appProps: undefined,
    boards: [],
    users: [],
    groups: [],
    isDataRetrieved: false,
    isDeleteInProgress: false
};
const $c72b3972b3ba3250$var$reducer = (state = $c72b3972b3ba3250$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $4qkcw.SET_APP_PROPS:
            return {
                ...state,
                appProps: action.payload
            };
        case 0, $4qkcw.DELETE_FILTER:
            return {
                ...state,
                isDeleteInProgress: true
            };
        case 0, $4qkcw.FILTER_DELETED:
        case 0, $4qkcw.DELETE_FILTER_FAILED:
            return {
                ...state,
                isDeleteInProgress: false
            };
        case 0, $4qkcw.ASSOCIATED_ITEMS_RETRIEVED:
            {
                const { boards: boards, users: users, groups: groups } = action.payload;
                return {
                    ...state,
                    isDataRetrieved: true,
                    ...boards ? {
                        boards: boards
                    } : undefined,
                    ...users ? {
                        users: users
                    } : undefined,
                    ...groups ? {
                        groups: groups
                    } : undefined
                };
            }
        case 0, $4qkcw.GET_ASSOCIATED_ITEMS_FAILED:
        case 0, $4qkcw.GET_ASSOCIATED_ITEMS:
            return state;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $c72b3972b3ba3250$export$2e2bcd8739ae039 = $c72b3972b3ba3250$var$reducer;

});


parcelRegister("14oCL", function(module, exports) {
$parcel$export(module.exports, "default", () => $205bd92bb748cab7$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $kwMul = parcelRequire("kwMul");

var $69ula = parcelRequire("69ula");

var $1zilF = parcelRequire("1zilF");

var $e2sl7 = parcelRequire("e2sl7");

var $a1oxT = parcelRequire("a1oxT");
const $205bd92bb748cab7$var$mapStateToProps = (state)=>({
        Content: $1zilF.default,
        Footer: $e2sl7.default,
        name: (0, $69ula.getFilterName)(state),
        onCancel: (0, $69ula.getOnCancel)(state),
        isOpen: (0, $69ula.isDataRetrieved)(state)
    });
const $205bd92bb748cab7$var$DeleteFiltersModalView = (0, $kwMul.connect)($205bd92bb748cab7$var$mapStateToProps, {})((0, $a1oxT.default));
var $205bd92bb748cab7$export$2e2bcd8739ae039 = $205bd92bb748cab7$var$DeleteFiltersModalView;

});
parcelRegister("1zilF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bdc3257b9eeff10$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux

var $kwMul = parcelRequire("kwMul");

var $69ula = parcelRequire("69ula");

var $aewNw = parcelRequire("aewNw");
const $2bdc3257b9eeff10$var$mapStateToProps = (state)=>({
        filter: (0, $69ula.getFilter)(state),
        boards: (0, $69ula.getAssociatedBoards)(state),
        users: (0, $69ula.getAssociatedUsers)(state),
        groups: (0, $69ula.getAssociatedGroups)(state)
    });
const $2bdc3257b9eeff10$var$DeleteFiltersModalContentView = (0, $kwMul.connect)($2bdc3257b9eeff10$var$mapStateToProps, {})((0, $aewNw.default));
var $2bdc3257b9eeff10$export$2e2bcd8739ae039 = $2bdc3257b9eeff10$var$DeleteFiltersModalContentView;

});
parcelRegister("aewNw", function(module, exports) {
$parcel$export(module.exports, "default", () => $df42a8b45388daf2$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-disable-next-line jira/filename-case

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $hzWaA = parcelRequire("hzWaA");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $df42a8b45388daf2$var$noSubscriptionsAndBoards = (0, $7eNDO.defineMessage)({
    id: "directories.filters-v2.delete-modal.content.no-subscriptions-and-boards",
    defaultMessage: "Are you sure you want to delete this filter?"
});
const $df42a8b45388daf2$var$associatedItems = (0, $7eNDO.defineMessage)({
    id: "directories.filters-v2.delete-modal.content.associated-items",
    defaultMessage: "This filter is used elsewhere. Deleting it may impact other people's work."
});
const $df42a8b45388daf2$var$multipleSubscriptions = (0, $7eNDO.defineMessage)({
    id: "directories.filters-v2.delete-modal.content.multiple-subscriptions",
    defaultMessage: "This filter has currently {number} subscriptions:"
});
const $df42a8b45388daf2$var$singleSubscription = (0, $7eNDO.defineMessage)({
    id: "directories.filters-v2.delete-modal.content.single-subscription",
    defaultMessage: "This filter has a subscription for "
});
const $df42a8b45388daf2$var$singleSubscriptionWarning = (0, $7eNDO.defineMessage)({
    id: "directories.filters-v2.delete-modal.content.single-subscription-warning",
    defaultMessage: "Deleting this filter will cause subscription emails for {subscriptionName} to no longer be delivered."
});
const $df42a8b45388daf2$var$multipleSubscriptionsWarning = (0, $7eNDO.defineMessage)({
    id: "directories.filters-v2.delete-modal.content.multiple-subscriptions-warning",
    defaultMessage: "Deleting this filter will cause subscription emails for these users and groups to no longer be delivered."
});
const $df42a8b45388daf2$var$multipleBoards = (0, $7eNDO.defineMessage)({
    id: "directories.filters-v2.delete-modal.content.multiple-boards",
    defaultMessage: "This filter is currently being used by {number} boards:"
});
const $df42a8b45388daf2$var$singleBoard = (0, $7eNDO.defineMessage)({
    id: "directories.filters-v2.delete-modal.content.single-board",
    defaultMessage: "This filter is currently being used by "
});
const $df42a8b45388daf2$var$multipleBoardsWarning = (0, $7eNDO.defineMessage)({
    id: "directories.filters-v2.delete-modal.content.multiple-boards-warning",
    defaultMessage: "You'll need to remove this filters associations to the boards before it can be removed."
});
const $df42a8b45388daf2$var$formattedName = (0, $7eNDO.defineMessage)({
    id: "directories.filters-v2.delete-modal.content.formatted-name",
    defaultMessage: "{name}."
});
const $df42a8b45388daf2$var$ContentWithoutBoardsAndSubscriptions = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($df42a8b45388daf2$var$noSubscriptionsAndBoards));
};
$df42a8b45388daf2$var$ContentWithoutBoardsAndSubscriptions.displayName = "ContentWithoutBoardsAndSubscriptions";
const $df42a8b45388daf2$var$ContentWithAssociatedSubscriptions = ({ groups: groups, users: users })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const totalSubscriptions = users.length + groups.length;
    const hasSingleUser = users.length === 1 && groups.length === 0;
    const hasSingleGroup = users.length === 0 && groups.length === 1;
    if (hasSingleUser) {
        const [{ displayName: displayName, href: href }] = users;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
            space: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($df42a8b45388daf2$var$singleSubscription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
            href: href
        }, formatMessage($df42a8b45388daf2$var$formattedName, {
            name: displayName
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
            className: (0, $4jQY2.default)([
                "_19pk12x7"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($df42a8b45388daf2$var$singleSubscriptionWarning, {
            subscriptionName: displayName
        }))));
    }
    if (hasSingleGroup) {
        const [{ name: name }] = groups;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
            space: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($df42a8b45388daf2$var$singleSubscription), formatMessage($df42a8b45388daf2$var$formattedName, {
            name: name
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
            className: (0, $4jQY2.default)([
                "_19pk12x7"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($df42a8b45388daf2$var$singleSubscriptionWarning, {
            subscriptionName: name
        }))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($df42a8b45388daf2$var$multipleSubscriptions, {
        number: totalSubscriptions
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        as: "ul"
    }, users.map(({ displayName: displayName, href: href }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("li", {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
            href: href
        }, displayName))), groups.map(({ name: name }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("li", {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, name)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            "_19pkutpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($df42a8b45388daf2$var$multipleSubscriptionsWarning))));
};
$df42a8b45388daf2$var$ContentWithAssociatedSubscriptions.displayName = "ContentWithAssociatedSubscriptions";
const $df42a8b45388daf2$var$ContentWithAssociatedBoards = ({ boards: boards })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    if (boards.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($df42a8b45388daf2$var$singleBoard), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
        href: boards[0].href
    }, formatMessage($df42a8b45388daf2$var$formattedName, {
        name: boards[0].name
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($df42a8b45388daf2$var$multipleBoardsWarning)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($df42a8b45388daf2$var$multipleBoards, {
        number: boards.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        as: "ul"
    }, boards.map(({ name: name, href: href }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("li", {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
            href: href
        }, name)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            "_19pkutpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($df42a8b45388daf2$var$multipleBoardsWarning))));
};
$df42a8b45388daf2$var$ContentWithAssociatedBoards.displayName = "ContentWithAssociatedBoards";
const $df42a8b45388daf2$export$7c6e2c02157bb7d2 = ({ boards: boards, groups: groups, users: users })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    if (users.length === 0 && groups.length === 0 && boards.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($df42a8b45388daf2$var$ContentWithoutBoardsAndSubscriptions, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($df42a8b45388daf2$var$associatedItems)), boards.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($df42a8b45388daf2$var$ContentWithAssociatedBoards, {
        boards: boards
    }), (users.length > 0 || groups.length > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($df42a8b45388daf2$var$ContentWithAssociatedSubscriptions, {
        users: users,
        groups: groups
    }));
};
$df42a8b45388daf2$export$7c6e2c02157bb7d2.displayName = "Content";
const $df42a8b45388daf2$var$singleItemStyles = null;
const $df42a8b45388daf2$var$textStyles = null;
var $df42a8b45388daf2$export$2e2bcd8739ae039 = $df42a8b45388daf2$export$7c6e2c02157bb7d2;

});


parcelRegister("e2sl7", function(module, exports) {
$parcel$export(module.exports, "default", () => $67bd75e633f8d742$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4B1S7 = parcelRequire("4B1S7");

var $gK5hg = parcelRequire("gK5hg");

var $kwMul = parcelRequire("kwMul");

var $4qkcw = parcelRequire("4qkcw");

var $69ula = parcelRequire("69ula");

var $41qCf = parcelRequire("41qCf");
const $67bd75e633f8d742$var$mapStateToProps = (state)=>({
        filter: (0, $69ula.getFilter)(state),
        canDelete: (0, $69ula.getCanDelete)(state),
        deleteInProgress: (0, $69ula.isDeleteInProgress)(state),
        onCancel: (0, $69ula.getOnCancel)(state)
    });
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $67bd75e633f8d742$var$FooterConnected = (0, (/*@__PURE__*/$parcel$interopDefault($4B1S7)))((0, $gK5hg.default)({
    onDelete: 'filterDeleted',
    onCancel: 'filterDeleteCanceled'
}), (0, $kwMul.connect)($67bd75e633f8d742$var$mapStateToProps, {
    onDelete: (0, $4qkcw.deleteFilter)
}))((0, $41qCf.default));
var $67bd75e633f8d742$export$2e2bcd8739ae039 = $67bd75e633f8d742$var$FooterConnected;

});
parcelRegister("gK5hg", function(module, exports) {
$parcel$export(module.exports, "default", () => $44a2b74159fdbd7d$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $7iRBQ = parcelRequire("7iRBQ");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $44a2b74159fdbd7d$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $7iRBQ.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $7iRBQ.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>/* oxlint-disable typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any */ /* oxlint-disable typescript/consistent-type-assertions */ // eslint-disable-next-line jira/react/no-class-components
        class WithAnalytics extends (0, $euxye.Component) {
            static{
                /* oxlint-enable typescript/consistent-type-assertions */ // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // oxlint-disable-line @typescript-eslint/no-explicit-any
/* oxlint-enable typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any */ };
var $44a2b74159fdbd7d$export$2e2bcd8739ae039 = $44a2b74159fdbd7d$var$fireWithUIAnalytics;

});

parcelRegister("41qCf", function(module, exports) {
$parcel$export(module.exports, "default", () => $13ffed4b999fb609$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $fcq2N = parcelRequire("fcq2N");

var $4qNCE = parcelRequire("4qNCE");

var $a9o4s = parcelRequire("a9o4s");

var $4vluQ = parcelRequire("4vluQ");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $abhF2 = parcelRequire("abhF2");

var $7eNDO = parcelRequire("7eNDO");

var $1jztF = parcelRequire("1jztF");

var $jk1MO = parcelRequire("jk1MO");
const $13ffed4b999fb609$var$deleteMessage = (0, $7eNDO.defineMessage)({
    id: "directories.filters-v2.delete-modal.footer.delete",
    defaultMessage: "Delete"
});
const $13ffed4b999fb609$var$cancelButtonCaption = (0, $7eNDO.defineMessage)({
    id: "directories.filters-v2.delete-modal.footer.cancel-button-caption",
    defaultMessage: "Cancel"
});
const $13ffed4b999fb609$var$Footer = ({ intl: { formatMessage: formatMessage }, canDelete: canDelete = true, deleteInProgress: deleteInProgress = false, onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))), onDelete: onDelete = (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))) })=>{
    const { publish: publish } = (0, $jk1MO.useDeleteChangeActions)();
    const onDeleteWithEvent = (event, analyticsEvent)=>{
        // additional args aside from event & analyticsEvent that you wish to pass down needs to be passed as the first argument
        onDelete(publish, event, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4vluQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($13ffed4b999fb609$var$Container, null, deleteInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $13ffed4b999fb609$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
        appearance: "danger",
        type: "submit",
        isDisabled: !canDelete,
        onClick: onDeleteWithEvent
    }, formatMessage($13ffed4b999fb609$var$deleteMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
        appearance: "subtle-link",
        isDisabled: deleteInProgress,
        onClick: onCancel
    }, formatMessage($13ffed4b999fb609$var$cancelButtonCaption)))));
};
$13ffed4b999fb609$var$Footer.displayName = "Footer";
const $13ffed4b999fb609$var$DeleteFiltersModalFooterView = (0, $1jztF.default)($13ffed4b999fb609$var$Footer);
var $13ffed4b999fb609$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $13ffed4b999fb609$var$DeleteFiltersModalFooterView;
const $13ffed4b999fb609$var$Container = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $13ffed4b999fb609$var$spinnerContainerStyles = (0, $fbAgj.xcss)({
    marginRight: 'space.200'
});

});


parcelRegister("a1oxT", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2013b40a05c22e3$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $b39hj = parcelRequire("b39hj");

var $fi8pR = parcelRequire("fi8pR");

var $k6sZT = parcelRequire("k6sZT");

var $9imxF = parcelRequire("9imxF");

var $2v3yi = parcelRequire("2v3yi");

var $dNPnD = parcelRequire("dNPnD");

var $gpyJM = parcelRequire("gpyJM");

var $7eNDO = parcelRequire("7eNDO");

var $1jztF = parcelRequire("1jztF");
/* eslint-disable jira/filename-case */ // eslint-disable-next-line no-restricted-imports
const $b2013b40a05c22e3$var$title = (0, $7eNDO.defineMessage)({
    id: "directories.filters-v2.delete-modal.title",
    defaultMessage: "Delete {name}"
});
const $b2013b40a05c22e3$var$DeleteModal = ({ intl: { formatMessage: formatMessage }, isOpen: isOpen, Content: Content, Footer: Footer, onCancel: onCancel, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9imxF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k6sZT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b39hj.ModalDialog), {
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: "delete-filters-modal.modal-dialog",
        messageType: "transactional",
        width: "small",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gpyJM.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dNPnD.default), {
        appearance: "danger"
    }, formatMessage($b2013b40a05c22e3$var$title, {
        name: name
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v3yi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fi8pR.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Footer, {
        onClose: onCancel
    }))));
$b2013b40a05c22e3$var$DeleteModal.displayName = "DeleteModal";
const $b2013b40a05c22e3$var$DeleteFiltersModalView = (0, $1jztF.default)($b2013b40a05c22e3$var$DeleteModal);
var $b2013b40a05c22e3$export$2e2bcd8739ae039 = $b2013b40a05c22e3$var$DeleteFiltersModalView;

});
parcelRegister("b39hj", function(module, exports) {
$parcel$export(module.exports, "ModalDialog", () => $17f25add58d91534$export$1fa217be60c2f188);
/* eslint-disable jira/choreographer/message-id-by-folder-structure */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $DIqjH = parcelRequire("DIqjH");

var $2700E = parcelRequire("2700E");

var $83rxq = parcelRequire("83rxq");
const $17f25add58d91534$export$1fa217be60c2f188 = ({ shouldReturnFocus: shouldReturnFocus, ...rest })=>{
    const returnFocusTarget = (0, $83rxq.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $83rxq.useModalDialogActions)();
    (0, $euxye.useEffect)(()=>()=>{
            if (returnFocusTarget?.current) {
                if (!shouldReturnFocus && (0, $2700E.expVal)('jjj-board-and-backlog-a11y-focus-management-fixes', 'isEnabled', false)) {
                    // Defer past react-focus-lock cleanup, which fires synchronously on unmount
                    // and overrides an immediate .focus() call by returning focus to document.body
                    const targetEl = returnFocusTarget.current;
                    setTimeout(()=>{
                        targetEl.focus();
                    }, 0);
                } else if (!shouldReturnFocus) returnFocusTarget.current.focus();
                setReturnFocusTo(null);
            }
        }, [
        returnFocusTarget,
        setReturnFocusTo,
        shouldReturnFocus
    ]);
    /**
	 *  when shouldReturnFocus is defined,
	 * 	we won't handle passing focus back to this element
	 *	we will ignore the returnFocusTarget
	 */ const returnFocus = shouldReturnFocus ?? !returnFocusTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $DIqjH.JiraModal), {
        shouldReturnFocus: returnFocus,
        ...rest,
        messageId: rest.messageId ?? 'software.modal-dialog.ui.ak-modal-dialog',
        messageType: rest.messageType ?? 'transactional'
    });
};
$17f25add58d91534$export$1fa217be60c2f188.displayName = "ModalDialog";

});
parcelRegister("83rxq", function(module, exports) {
$parcel$export(module.exports, "useModalDialogActions", () => $d1049359056308d1$export$3cf2e4b6d3541465);
$parcel$export(module.exports, "useReturnFocusTo", () => $d1049359056308d1$export$217308a4ece853b2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $8bhjl = parcelRequire("8bhjl");

var $glUVH = parcelRequire("glUVH");

var $hlpnM = parcelRequire("hlpnM");
const $d1049359056308d1$var$Store = (0, $5QDqc.createStore)({
    name: 'JiraSoftwareModalDialog',
    initialState: $8bhjl.initialState,
    actions: $glUVH.actions
});
const $d1049359056308d1$export$3cf2e4b6d3541465 = (0, $3h1FP.createActionsHook)($d1049359056308d1$var$Store);
const $d1049359056308d1$export$217308a4ece853b2 = (0, $3h1FP.createStateHook)($d1049359056308d1$var$Store, {
    selector: (0, $hlpnM.getReturnFocusTo)
});

});
parcelRegister("8bhjl", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $5015164c9ba7a965$export$d4c72bab9d6cc13a);
/* eslint-disable jira/filename-case */ const $5015164c9ba7a965$export$d4c72bab9d6cc13a = {
    returnFocusTo: null
};

});

parcelRegister("glUVH", function(module, exports) {
$parcel$export(module.exports, "actions", () => $e8b059f52cf35d71$export$e324594224ef24da);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e8b059f52cf35d71$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
        setState({
            returnFocusTo: returnFocusTo
        });
    };
const $e8b059f52cf35d71$export$e324594224ef24da = {
    setReturnFocusTo: $e8b059f52cf35d71$export$b263d1e638b131c2
};

});

parcelRegister("hlpnM", function(module, exports) {
$parcel$export(module.exports, "getReturnFocusTo", () => $1c794f49364d0840$export$d5f8692765ccd209);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $1c794f49364d0840$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;

});



parcelRegister("fi8pR", function(module, exports) {
$parcel$export(module.exports, "default", () => $f771b4bec4e89dd0$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $kY2zM = parcelRequire("kY2zM");

var $kTviw = parcelRequire("kTviw");

var $7iRBQ = parcelRequire("7iRBQ");
// eslint-disable-next-line jira/react/no-class-components
class $f771b4bec4e89dd0$var$ViewTracker extends (0, $euxye.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
$f771b4bec4e89dd0$var$ViewTracker.displayName = "ViewTracker";
const $f771b4bec4e89dd0$var$ViewTrackerWithAnalytics = (0, $kY2zM.default)({
    componentName: 'view-tracker'
})((0, $kTviw.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $7iRBQ.PAGE_EVENT_ACTION)
        }).fire()
})($f771b4bec4e89dd0$var$ViewTracker));
const $f771b4bec4e89dd0$var$ViewTrackerWithNoopOnMount = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f771b4bec4e89dd0$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
    });
$f771b4bec4e89dd0$var$ViewTrackerWithNoopOnMount.displayName = "ViewTrackerWithNoopOnMount";
var $f771b4bec4e89dd0$export$2e2bcd8739ae039 = $f771b4bec4e89dd0$var$ViewTrackerWithNoopOnMount;

});





parcelRegister("7zGx8", function(module, exports) {
$parcel$export(module.exports, "useModalState", () => $aa52c499011de772$export$baa48889c42cc6cb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
const $aa52c499011de772$export$baa48889c42cc6cb = (defaultOpen = false)=>{
    const [isOpen, setIsOpen] = (0, $euxye.useState)(defaultOpen);
    const onClose = (0, $euxye.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onOpen = (0, $euxye.useCallback)(()=>setIsOpen(true), [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        onOpen: onOpen
    };
};

});


parcelRegister("aZs9d", function(module, exports) {
$parcel$export(module.exports, "SimpleFilterMenuItem", () => $83382661f8087fab$export$608d42ceb4060968);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $5IkoH = parcelRequire("5IkoH");

var $aQCoC = parcelRequire("aQCoC");

var $8A8fZ = parcelRequire("8A8fZ");

var $kACtV = parcelRequire("kACtV");
function $83382661f8087fab$export$608d42ceb4060968({ actionsOnHover: actionsOnHover, filterId: filterId, name: name, onClick: onClick }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        actionsOnHover: actionsOnHover,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8A8fZ))), {
            label: "",
            color: "currentColor"
        }),
        href: (0, $kACtV.FILTER_HREF)(filterId),
        menuId: (0, $5IkoH.ENTITY_ID).FILTER(filterId),
        onClick: onClick
    }, name);
}
$83382661f8087fab$export$608d42ceb4060968.displayName = "SimpleFilterMenuItem";

});
parcelRegister("kACtV", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $eac9ecbfcbf6423d$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $eac9ecbfcbf6423d$export$d57b6b390e78d90f);
$parcel$export(module.exports, "FILTER_HREF", () => $eac9ecbfcbf6423d$export$eb8ea569a05b0e5b);
$parcel$export(module.exports, "SEARCH_ISSUES_HREF", () => $eac9ecbfcbf6423d$export$e0230f89cdb01064);
/* eslint-disable jira/filename-case */ const $eac9ecbfcbf6423d$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Filters';
const $eac9ecbfcbf6423d$export$d57b6b390e78d90f = 'jira-cosmos';
const $eac9ecbfcbf6423d$var$createIssueNavigatorHref = (to)=>({
        to: to,
        prefetch: 'hover'
    });
const $eac9ecbfcbf6423d$export$eb8ea569a05b0e5b = (filterId)=>$eac9ecbfcbf6423d$var$createIssueNavigatorHref(`/issues/?filter=${filterId}`);
const $eac9ecbfcbf6423d$export$e0230f89cdb01064 = $eac9ecbfcbf6423d$var$createIssueNavigatorHref('/issues/?jql=created%20%3E%3D%20-30d%20order%20by%20created%20DESC');

});



parcelRegister("1pVaL", function(module, exports) {
$parcel$export(module.exports, "Nav4FilterMenuItemRefactored", () => $0bd05fa293e179ef$export$dbcffa8337e4fcbc);

var $dI5r6 = parcelRequire("dI5r6");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $5IkoH = parcelRequire("5IkoH");

var $aQCoC = parcelRequire("aQCoC");

var $8A8fZ = parcelRequire("8A8fZ");

var $cvA2R = parcelRequire("cvA2R");

var $ffznM = parcelRequire("ffznM");

var $8P3zZ = parcelRequire("8P3zZ");

var $lmcfF = parcelRequire("lmcfF");

var $kACtV = parcelRequire("kACtV");

var $7XxFO = parcelRequire("7XxFO");
function $0bd05fa293e179ef$export$dbcffa8337e4fcbc(props) {
    const { queryRef: queryRef, currentItems: currentItems, currentOrder: currentOrder, item: item, onClick: onClick, onRefetch: onRefetch } = props;
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $dI5r6.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    const { filterId: filterId, id: id, isFavourite: isFavourite, name: name } = data;
    if (isFavourite && currentItems && currentOrder && item) {
        const actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7XxFO.Nav4FilterActionsRefactored), {
            queryRef: data,
            onRefetch: onRefetch,
            currentItems: currentItems,
            currentOrder: currentOrder,
            item: item
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0bd05fa293e179ef$var$DraggableFilterMenuItem, {
            actionsOnHover: actions,
            filterId: filterId,
            id: id,
            isStarred: isFavourite,
            filterTitle: name,
            onClick: onClick
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0bd05fa293e179ef$export$608d42ceb4060968, {
        actionsOnHover: !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8P3zZ.Nav4FilterActions), {
            queryRef: data,
            onRefetch: onRefetch
        }),
        filterId: data.filterId,
        name: data.name,
        onClick: onClick
    });
}
$0bd05fa293e179ef$export$dbcffa8337e4fcbc.displayName = "Nav4FilterMenuItemRefactored";
function $0bd05fa293e179ef$export$608d42ceb4060968({ actionsOnHover: actionsOnHover, filterId: filterId, name: name, onClick: onClick }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        actionsOnHover: actionsOnHover,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8A8fZ))), {
            label: "",
            color: "currentColor"
        }),
        href: (0, $kACtV.FILTER_HREF)(filterId),
        menuId: (0, $5IkoH.ENTITY_ID).FILTER(filterId),
        onClick: onClick
    }, name);
}
$0bd05fa293e179ef$export$608d42ceb4060968.displayName = "SimpleFilterMenuItem";
const $0bd05fa293e179ef$var$DraggableFilterMenuItem = ({ actionsOnHover: actionsOnHover, id: id, filterId: filterId, filterTitle: filterTitle, onClick: onClick })=>{
    const { entityAri: entityAri, ownerAri: ownerAri, group: group } = (0, $lmcfF.useFilterReorderingIds)();
    const dragAndDropState = (0, $ffznM.useNestedItemDragAndDrop)({
        entityAri: entityAri,
        ownerAri: ownerAri,
        data: {
            id: id.toString(),
            label: filterTitle
        },
        group: group,
        item: undefined,
        isExpandable: false,
        isExpandOrFlyoutOpen: false,
        id: id,
        isDragAndDropEnabled: true,
        onExpandFlyoutToggle: ()=>{
        // No op for dashboard menu item
        }
    });
    const draggableRef = dragAndDropState?.draggableRef || null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        // analytics={analytics}
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8A8fZ))), {
            label: "",
            color: "currentColor"
        }),
        href: (0, $kACtV.FILTER_HREF)(filterId),
        menuId: (0, $5IkoH.ENTITY_ID).FILTER(filterId),
        ref: draggableRef,
        actionsOnHover: actionsOnHover,
        visualContentRef: dragAndDropState?.dropTargetRef,
        dropIndicator: dragAndDropState?.dropIndicator,
        isDragging: dragAndDropState?.isDragging,
        hasDragIndicator: true,
        onClick: onClick
    }, filterTitle), dragAndDropState && dragAndDropState.maybeDragPreview);
};
$0bd05fa293e179ef$var$DraggableFilterMenuItem.displayName = "DraggableFilterMenuItem";

});
parcelRegister("dI5r6", function(module, exports) {
$parcel$export(module.exports, "default", () => $077a3531d1758878$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3fa707f817861eabe44c3fc64165d77f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $077a3531d1758878$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FilterMenuItemRefactored",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4FilterActions"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4FilterActionsRefactored"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$077a3531d1758878$var$node.hash = "1a9c987b188f5a1537fae0e4f99f0d9c";
var $077a3531d1758878$export$2e2bcd8739ae039 = $077a3531d1758878$var$node;

});

parcelRegister("lmcfF", function(module, exports) {
$parcel$export(module.exports, "useFilterReorderingIds", () => $30edc435f3f48eda$export$e4d28af260310d20);
// eslint-disable-next-line jira/filename-case

var $kFgCO = parcelRequire("kFgCO");

var $2NSbF = parcelRequire("2NSbF");

var $kt86l = parcelRequire("kt86l");

var $bZhC2 = parcelRequire("bZhC2");

var $h3LJR = parcelRequire("h3LJR");
const $30edc435f3f48eda$export$e4d28af260310d20 = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const { data: { user: { accountId: accountId } } } = (0, $kFgCO.useCurrentUser)();
    const entityAri = (0, $bZhC2.JiraNavigationSettingsAri).create({
        siteId: cloudId,
        activationId: activationId,
        navigationSettingScope: 'filters'
    }).toString();
    const ownerAri = (0, $2NSbF.IdentityUserAri).create({
        userId: accountId || 'UNKNOWN'
    }).toString();
    return {
        entityAri: entityAri,
        ownerAri: ownerAri,
        group: 'SIDE_NAVIGATION_STARRED_FILTERS'
    };
};

});

parcelRegister("7XxFO", function(module, exports) {
$parcel$export(module.exports, "Nav4FilterActionsRefactored", () => $0ce5f666f2891f66$export$7f118792ba72e33a);

var $1zfn8 = parcelRequire("1zfn8");

var $euxye = parcelRequire("euxye");

var $bS1iz = parcelRequire("bS1iz");

var $n67Vb = parcelRequire("n67Vb");

var $2VfJf = parcelRequire("2VfJf");



var $9d48B = parcelRequire("9d48B");

var $gbTMi = parcelRequire("gbTMi");

var $9CNRl = parcelRequire("9CNRl");

var $2zU0a = parcelRequire("2zU0a");

var $eezi8 = parcelRequire("eezi8");

var $cEwjN = parcelRequire("cEwjN");

var $fbAgT = parcelRequire("fbAgT");

var $1Unjk = parcelRequire("1Unjk");

var $2bpNg = parcelRequire("2bpNg");

var $d8bZ5 = parcelRequire("d8bZ5");

var $2EZ2h = parcelRequire("2EZ2h");

var $lWRvF = parcelRequire("lWRvF");

var $ceqcm = parcelRequire("ceqcm");

var $cSR11 = parcelRequire("cSR11");

var $g36LP = parcelRequire("g36LP");

var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $3GN2r = parcelRequire("3GN2r");

var $fNgVF = parcelRequire("fNgVF");

var $55BnK = parcelRequire("55BnK");

var $kt86l = parcelRequire("kt86l");

var $h3LJR = parcelRequire("h3LJR");

var $isqzs = parcelRequire("isqzs");

var $dGnxe = parcelRequire("dGnxe");

var $lmcfF = parcelRequire("lmcfF");

var $gYDzv = parcelRequire("gYDzv");

var $itFBm = parcelRequire("itFBm");

var $7zGx8 = parcelRequire("7zGx8");
const $0ce5f666f2891f66$var$manageSubscription = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.manage-subscription",
    defaultMessage: "Manage subscriptions"
});
const $0ce5f666f2891f66$var$copyFilter = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter",
    defaultMessage: "Copy filter"
});
const $0ce5f666f2891f66$var$copyFilterDialogTitle = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter-dialog-title",
    defaultMessage: "Copy filter"
});
const $0ce5f666f2891f66$var$edit = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.edit",
    defaultMessage: "Edit filter"
});
const $0ce5f666f2891f66$var$changeOwner = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.change-owner",
    defaultMessage: "Change owner"
});
const $0ce5f666f2891f66$var$deleteMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.delete",
    defaultMessage: "Delete filter"
});
const $0ce5f666f2891f66$var$manageSubscriptionWithName = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.manage-subscription-with-name",
    defaultMessage: "Manage subscriptions for {name}"
});
const $0ce5f666f2891f66$var$copyFilterWithName = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter-with-name",
    defaultMessage: "Copy filter {name}"
});
const $0ce5f666f2891f66$var$editWithName = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.edit-with-name",
    defaultMessage: "Edit filter {name}"
});
const $0ce5f666f2891f66$var$changeOwnerWithName = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.change-owner-with-name",
    defaultMessage: "Change owner for {name}"
});
const $0ce5f666f2891f66$var$deleteWithName = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.delete-with-name",
    defaultMessage: "Delete filter {name}"
});
const $0ce5f666f2891f66$export$7f118792ba72e33a = ({ queryRef: queryRef, onRefetch: onRefetch, currentItems: currentItems, currentOrder: currentOrder, item: item })=>{
    const { __typename: __typename, isEditable: isEditable, isFavourite: isFavourite, name: name, owner: owner, id: id, filterId: filterId } = (0, $n67Vb.useFragment)((0, $1zfn8.default), queryRef);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const accountId = (0, $3GN2r.useAccountId)();
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const sendFilterAnalytics = (0, $dGnxe.useFilterActionsAnalytics)();
    const { isOpen: isChangeOwnerModalOpen, onOpen: openChangeOwnerModal, onClose: closeChangeOwnerModal } = (0, $7zGx8.useModalState)(false);
    const { isOpen: isDeleteFilterModalOpen, onOpen: openDeleteFilterModal, onClose: closeDeleteFilterModal } = (0, $7zGx8.useModalState)(false);
    const { push: push } = (0, $55BnK.useRouterActions)();
    const onFilterSave = (0, $euxye.useCallback)((copiedFilterId)=>{
        push(`/issues/?filter=${copiedFilterId}`);
    }, [
        push
    ]);
    const isCustom = __typename === 'JiraCustomFilter';
    const isOwner = owner?.accountId && owner.accountId === accountId;
    const sendFilterActionAnalytics = (0, $euxye.useCallback)((itemId)=>{
        sendFilterAnalytics((0, $6b2913942bd90807$export$64fed82162bd367), (0, $dGnxe.getFilterActionAttributes)({
            itemId: itemId,
            isCustom: isCustom,
            isFavourite: isFavourite,
            filterId: filterId
        }));
    }, [
        filterId,
        isCustom,
        isFavourite,
        sendFilterAnalytics
    ]);
    const modalProps = (0, $euxye.useMemo)(()=>({
            width: 'medium',
            shouldScrollInViewport: true
        }), []);
    const saveFilterEntryPointProps = (0, $euxye.useMemo)(()=>({
            filterId: filterId,
            onFilterSave: onFilterSave,
            title: formatMessage($0ce5f666f2891f66$var$copyFilterDialogTitle)
        }), [
        filterId,
        onFilterSave,
        formatMessage
    ]);
    const updateFilterEntryPointProps = (0, $euxye.useMemo)(()=>({
            filterId: filterId ?? ''
        }), [
        filterId
    ]);
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            filterAri: filterId !== null && filterId !== undefined ? (0, $2zU0a.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'filter',
                resourceId: filterId,
                activationId: activationId
            }) : undefined
        }), [
        filterId,
        cloudId,
        activationId
    ]);
    const { entityAri: entityAri, ownerAri: ownerAri } = (0, $lmcfF.useFilterReorderingIds)();
    const reorderActions = (0, $euxye.useCallback)((onClose)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fbAgT.ReorderActionsRenderer), {
            currentItems: currentItems,
            currentOrder: currentOrder,
            entityAri: entityAri,
            ownerAri: ownerAri,
            fireAnalyticsEvent: undefined,
            item: item,
            onClose: onClose
        }), [
        currentItems,
        currentOrder,
        entityAri,
        item,
        ownerAri
    ]);
    const MenuItems = (0, $euxye.useCallback)(({ onClose: onClose })=>{
        const handleClose = ()=>onClose?.(null);
        const getManageSubscriptionsUrl = (actionType)=>{
            const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify({
                atl_token: (0, $9CNRl.default)(),
                returnUrl: 'ManageFilters.jspa',
                filterId: filterId
            });
            return `/${actionType}!default.jspa?${parsed}`;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
            isList: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9d48B.FavoriteToggleButton), {
            entityId: id,
            defaultIsStarred: Boolean(isFavourite),
            entityTypeName: (0, $2VfJf.isFavoritableItemTypename)(__typename) ? __typename : 'JiraCustomFilter',
            onClick: ()=>sendFilterActionAnalytics(isFavourite ? (0, $90c0351d239ffedb$export$7ae7abcf2c19d3e5) : (0, $90c0351d239ffedb$export$78fd0bd637fe1684)),
            name: name
        }), reorderActions && reorderActions(handleClose), isCustom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cSR11.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2EZ2h))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #292A2E)"
            }),
            href: getManageSubscriptionsUrl('ViewSubscriptions'),
            "aria-label": formatMessage($0ce5f666f2891f66$var$manageSubscriptionWithName, {
                name: name
            }),
            onClick: ()=>sendFilterActionAnalytics('manageSubscription')
        }, formatMessage($0ce5f666f2891f66$var$manageSubscription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $isqzs.ModalEntryPointPressableTrigger), {
            modalProps: modalProps,
            entryPoint: (0, $eezi8.saveFilterDialogEntryPoint),
            entryPointProps: saveFilterEntryPointProps,
            entryPointParams: entryPointParams,
            interactionName: "jiraSaveFilterDialog.SaveFilter",
            useInternalModal: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
                onClick: (e)=>{
                    sendFilterActionAnalytics('copyFilter');
                    onClose && onClose(e);
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Unjk))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #292A2E)"
                }),
                "aria-label": formatMessage($0ce5f666f2891f66$var$copyFilterWithName, {
                    name: name
                }),
                ref: ref
            }, formatMessage($0ce5f666f2891f66$var$copyFilter))), isCustom && (isOwner || isEditable) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $isqzs.ModalEntryPointPressableTrigger), {
            modalProps: modalProps,
            entryPoint: (0, $cEwjN.updateFilterDialogEntryPoint),
            entryPointProps: updateFilterEntryPointProps,
            entryPointParams: entryPointParams,
            interactionName: "jiraSaveFilterDialog.UpdateFilterDetails",
            useInternalModal: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
                onClick: (e)=>{
                    sendFilterActionAnalytics('editFilter');
                    onClose && onClose(e);
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8bZ5))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #292A2E)"
                }),
                "aria-label": formatMessage($0ce5f666f2891f66$var$editWithName, {
                    name: name
                }),
                ref: ref
            }, formatMessage($0ce5f666f2891f66$var$edit))), isCustom && (isOwner || isAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
            onClick: (e)=>{
                openChangeOwnerModal();
                sendFilterActionAnalytics('changeOwner');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lWRvF))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #292A2E)"
            }),
            "aria-label": formatMessage($0ce5f666f2891f66$var$changeOwnerWithName, {
                name: name
            })
        }, formatMessage($0ce5f666f2891f66$var$changeOwner))), isCustom && (isOwner || isAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
            onClick: (e)=>{
                openDeleteFilterModal();
                sendFilterActionAnalytics('deleteFilter');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bpNg))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            }),
            "aria-label": formatMessage($0ce5f666f2891f66$var$deleteWithName, {
                name: name
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
            color: "color.text.danger"
        }, formatMessage($0ce5f666f2891f66$var$deleteMessage)))));
    }, [
        id,
        isFavourite,
        __typename,
        name,
        reorderActions,
        isCustom,
        formatMessage,
        modalProps,
        saveFilterEntryPointProps,
        entryPointParams,
        isOwner,
        isEditable,
        updateFilterEntryPointProps,
        isAdmin,
        filterId,
        sendFilterActionAnalytics,
        openChangeOwnerModal,
        openDeleteFilterModal
    ]);
    const sendMeatballAnalytics = (0, $euxye.useCallback)(()=>{
        sendFilterAnalytics((0, $6b2913942bd90807$export$b887e88d8d0739f6), (0, $dGnxe.getFilterMeatBallAttributes)({
            isCustom: isCustom,
            isFavourite: isFavourite,
            filterId: filterId
        }));
    }, [
        filterId,
        isCustom,
        isFavourite,
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
        onOpen: sendMeatballAnalytics,
        MenuItems: MenuItems,
        name: name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gYDzv.ChangeOwnerModal), {
        isOpen: isChangeOwnerModalOpen,
        filterId: filterId,
        onRefetch: onRefetch,
        onClose: closeChangeOwnerModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $itFBm.DeleteFilterModal), {
        isOpen: isDeleteFilterModalOpen,
        name: name,
        filterId: filterId,
        onRefetch: onRefetch,
        onClose: closeDeleteFilterModal
    }));
};
$0ce5f666f2891f66$export$7f118792ba72e33a.displayName = "Nav4FilterActionsRefactored";

});
parcelRegister("1zfn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $f60bc97cbe4b26af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7722a0a292f1c0e3bcf8540fc3eafdac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f60bc97cbe4b26af$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FilterActionsRefactored",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        }
                    ]
                }
            ],
            "type": "JiraCustomFilter"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$f60bc97cbe4b26af$var$node.hash = "cc403d3352895d01f0127d958555957e";
var $f60bc97cbe4b26af$export$2e2bcd8739ae039 = $f60bc97cbe4b26af$var$node;

});




parcelRegister("lIdfF", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $a5290641566e2dd9$export$a06f1c675e846f6f);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");




var $5IkoH = parcelRequire("5IkoH");

var $bEZ9g = parcelRequire("bEZ9g");

var $7AmPM = parcelRequire("7AmPM");

var $6w18e = parcelRequire("6w18e");

var $ar9gx = parcelRequire("ar9gx");

var $djYhH = parcelRequire("djYhH");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $dGnxe = parcelRequire("dGnxe");
const $a5290641566e2dd9$var$viewAllFilters = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.footer.view-all-filters",
    defaultMessage: "View all filters"
});
const $a5290641566e2dd9$var$VIEW_ALL_FILTERS_PATH = (0, $7AmPM.filtersDirectoryRoute).path;
function $a5290641566e2dd9$export$a06f1c675e846f6f() {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const sendFilterAnalytics = (0, $dGnxe.useFilterActionsAnalytics)();
    const sendDefaultFilterDropdownAnalytics = (0, $euxye.useCallback)(()=>{
        sendFilterAnalytics((0, $6b2913942bd90807$export$6dd9406e478a1fe2), {
            level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
            componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
            itemId: 'viewAllFilters'
        });
    }, [
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEZ9g.ViewAllEntityMenuItem), {
        onClick: sendDefaultFilterDropdownAnalytics,
        href: $a5290641566e2dd9$var$VIEW_ALL_FILTERS_PATH,
        menuId: (0, $5IkoH.MENU_ID_FILTERS_VIEW_ALL)
    }, formatMessage($a5290641566e2dd9$var$viewAllFilters)))));
}
$a5290641566e2dd9$export$a06f1c675e846f6f.displayName = "Footer";

});
parcelRegister("7AmPM", function(module, exports) {
$parcel$export(module.exports, "filtersDirectoryRoute", () => $cded721d6d923091$export$6350f52c8b40042d);
const $cded721d6d923091$export$6350f52c8b40042d = {
    name: 'filters-directory',
    path: '/jira/filters'
};

});


parcelRegister("lUF7f", function(module, exports) {
$parcel$export(module.exports, "Header", () => $607bf0a343410bf0$export$8b251419efc915eb);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");




var $5IkoH = parcelRequire("5IkoH");

var $aQCoC = parcelRequire("aQCoC");

var $eAQb7 = parcelRequire("eAQb7");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $kACtV = parcelRequire("kACtV");

var $dGnxe = parcelRequire("dGnxe");
const $607bf0a343410bf0$var$searchAllIssues = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.header.search-all-issues",
    defaultMessage: "Search issues"
});
const $607bf0a343410bf0$var$searchAllIssuesIssueTermRefresh = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-filters.common.header.search-all-issues-issue-term-refresh",
    defaultMessage: "Search work items"
});
const $607bf0a343410bf0$export$8b251419efc915eb = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const sendFilterAnalytics = (0, $dGnxe.useFilterActionsAnalytics)();
    const handleOnClick = (0, $euxye.useCallback)((event)=>{
        sendFilterAnalytics((0, $6b2913942bd90807$export$6dd9406e478a1fe2), {
            level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
            componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
            itemId: 'searchAllIssues'
        });
        onClose?.(event);
    }, [
        onClose,
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        href: (0, $kACtV.SEARCH_ISSUES_HREF),
        onClick: handleOnClick,
        menuId: (0, $5IkoH.MENU_ID_FILTERS_SEARCH),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eAQb7))), {
            label: "",
            color: "currentColor"
        })
    }, formatMessage((0, $i860n.fg)('jira-issue-terminology-refresh-m3') ? $607bf0a343410bf0$var$searchAllIssuesIssueTermRefresh : $607bf0a343410bf0$var$searchAllIssues));
};
$607bf0a343410bf0$export$8b251419efc915eb.displayName = "Header";

});


parcelRegister("7clrn", function(module, exports) {
$parcel$export(module.exports, "Nav4FiltersDefault", () => $75dd1272ae0d843b$export$c9a2a24425c3fa5e);

var $euxye = parcelRequire("euxye");

var $9h4A8 = parcelRequire("9h4A8");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $bOwox = parcelRequire("bOwox");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $4VtOS = parcelRequire("4VtOS");

var $gEDfa = parcelRequire("gEDfa");

var $jzXAj = parcelRequire("jzXAj");

var $3rqDf = parcelRequire("3rqDf");

var $dx7aH = parcelRequire("dx7aH");

var $hDvet = parcelRequire("hDvet");

var $jepRN = parcelRequire("jepRN");

var $kFgCO = parcelRequire("kFgCO");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $fFNvS = parcelRequire("fFNvS");

var $kt86l = parcelRequire("kt86l");

var $h3LJR = parcelRequire("h3LJR");

var $kACtV = parcelRequire("kACtV");

var $lIdfF = parcelRequire("lIdfF");

var $lUF7f = parcelRequire("lUF7f");

var $2KVtK = parcelRequire("2KVtK");
const $75dd1272ae0d843b$export$c9a2a24425c3fa5e = (0, $jepRN.componentWithFG)('navx-global-side-nav', $75dd1272ae0d843b$var$Nav4FiltersDefaultGSN, $75dd1272ae0d843b$var$Nav4FiltersDefaultNav4);
function $75dd1272ae0d843b$var$Nav4FiltersDefaultGSN(props) {
    const { actionsOnHover: actionsOnHover, draggableRef: draggableRef, dropIndicator: dropIndicator, hasDragIndicator: hasDragIndicator, isDragging: isDragging, isExpanded: isExpanded, onExpandFlyoutToggle: onExpandFlyoutToggle, simulateLoading: simulateLoading = false, visualContentRef: visualContentRef } = props;
    const cloudId = (0, $kt86l.useCloudId)();
    const currentURL = (0, $9h4A8.useGetCurrentUrl)();
    const { data: { user: { accountId: accountId } } } = (0, $kFgCO.useCurrentUser)();
    const activationId = (0, $h3LJR.useActivationId)();
    // Ignore this error as our component does not need the context.
    // @ts-expect-error - Property 'context' is missing in type '{ tenantContext: { cloudId: string; }; }' but required in type 'EntryPointRouteParams'.ts(2741)
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            accountId: accountId,
            activationId: activationId,
            currentURL: currentURL
        }), [
        cloudId,
        accountId,
        activationId,
        currentURL
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $2KVtK.asyncFiltersContentViewQuery), entryPointParams);
    const triggerRef = (0, $hDvet.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).FILTERS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $euxye.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    // This callback makes sure that the EP is loaded when the _system_ determines that the expandable
    // should be open.
    const onSystemToggleFn = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const handleExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            sendSectionItemAnalyticsEvent({
                menuId: (0, $6GljB.L1_MENU_ID).FILTERS,
                sectionItem: (0, $bOwox.SECTION_ITEM_FILTERS)
            });
        }
        onExpandFlyoutToggle?.(hasExpanded);
    }, [
        entryPointActions,
        onExpandFlyoutToggle,
        sendSectionItemAnalyticsEvent
    ]);
    const menuId = (0, $5IkoH.MENU_ID_FILTERS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        dropTargetRef: visualContentRef,
        dropIndicator: dropIndicator,
        isDragging: isDragging,
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: onSystemToggleFn,
        onExpansionToggle: handleExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        hasDragIndicator: hasDragIndicator,
        interactionName: "nav4-sidebar-filters-default",
        isDragging: isDragging,
        ref: draggableRef ? (0, $fFNvS.mergeRefs)(triggerRef, draggableRef) : triggerRef,
        testId: (0, $jzXAj.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lUF7f.Header), null), simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-filters-default",
        packageName: (0, $kACtV.PACKAGE_NAME),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $kACtV.TEAM_NAME),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lIdfF.Footer), null)));
}
$75dd1272ae0d843b$var$Nav4FiltersDefaultGSN.displayName = "Nav4FiltersDefaultGSN";
function $75dd1272ae0d843b$var$Nav4FiltersDefaultNav4(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, simulateLoading: simulateLoading = false } = props;
    const cloudId = (0, $kt86l.useCloudId)();
    const currentURL = (0, $9h4A8.useGetCurrentUrl)();
    const { data: { user: { accountId: accountId } } } = (0, $kFgCO.useCurrentUser)();
    const activationId = (0, $h3LJR.useActivationId)();
    // Ignore this error as our component does not need the context.
    // @ts-expect-error - Property 'context' is missing in type '{ tenantContext: { cloudId: string; }; }' but required in type 'EntryPointRouteParams'.ts(2741)
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            accountId: accountId,
            activationId: activationId,
            currentURL: currentURL
        }), [
        cloudId,
        accountId,
        activationId,
        currentURL
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $2KVtK.asyncFiltersContentViewQuery), entryPointParams);
    const triggerRef = (0, $hDvet.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).FILTERS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $euxye.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    const menuId = (0, $5IkoH.MENU_ID_FILTERS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: (0, $euxye.useCallback)((hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        }, [
            entryPointActions
        ]),
        onExpansionToggle: (0, $euxye.useCallback)((hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $6GljB.L1_MENU_ID).FILTERS,
                    sectionItem: (0, $bOwox.SECTION_ITEM_FILTERS)
                });
            }
        }, [
            entryPointActions,
            sendSectionItemAnalyticsEvent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-filters-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $jzXAj.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lUF7f.Header), null), simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-filters-default",
        packageName: (0, $kACtV.PACKAGE_NAME),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $kACtV.TEAM_NAME),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lIdfF.Footer), null)));
}
$75dd1272ae0d843b$var$Nav4FiltersDefaultNav4.displayName = "Nav4FiltersDefaultNav4";

});
parcelRegister("2KVtK", function(module, exports) {
$parcel$export(module.exports, "asyncFiltersContentViewQuery", () => $450a6c5953591114$export$fae48e64221e5e6e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $bZhC2 = parcelRequire("bZhC2");

var $2NSbF = parcelRequire("2NSbF");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $18sMq = parcelRequire("18sMq");

var $9XGAw = parcelRequire("9XGAw");

const $450a6c5953591114$export$fae48e64221e5e6e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("hVNta")), {
        moduleId: "6c3ec119",
        moduleName: "Nav4FiltersContentViewQuery",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.cloudId;
        const entityAriFilters = (0, $i860n.fg)('navx-3660-fix-l2-l3-aris') ? (0, $18sMq.NavigationSettingAri).create({
            activationId: params.activationId || '',
            firstPartyApp: 'jira',
            settingId: 'filters',
            siteId: cloudId
        }).toString() : (0, $bZhC2.JiraNavigationSettingsAri).create({
            siteId: cloudId,
            activationId: params.activationId || '',
            navigationSettingScope: 'filters'
        }).toString();
        const variables = (0, $2700E.expVal)('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false) ? {
            cloudId: cloudId,
            currentURL: params.currentURL,
            ownerAri: (0, $2NSbF.IdentityUserAri).create({
                userId: params.accountId || 'UNKNOWN'
            }).toString(),
            entityAriFilters: entityAriFilters,
            skipOrderQuery: false
        } : {
            cloudId: cloudId,
            currentURL: params.currentURL,
            entityAriFilters: '',
            ownerAri: '',
            skipOrderQuery: true
        };
        return {
            queries: {
                queryRef: {
                    parameters: $9XGAw.default,
                    variables: variables
                }
            }
        };
    }
});

});
parcelRegister("9XGAw", function(module, exports) {
$parcel$export(module.exports, "default", () => $581dc9483f8aa8cd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d0041189c6e6143e977ae53580e3d5dd>>
 * @relayHash e0cfbeec7ab21c4537cc345b57415164
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 751f380d183acb8583bba4ad6166f3ef0ff8802f77c9de73c1817f5dd54c1ccd
const $581dc9483f8aa8cd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "currentURL"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriFilters"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipOrderQuery"
    }, v5 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "entityAriFilters"
        },
        {
            "kind": "Variable",
            "name": "ownerAri",
            "variableName": "ownerAri"
        }
    ], v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v13 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v9 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v15 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4FiltersContentViewQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "Nav4FiltersContent"
                },
                {
                    "condition": "skipOrderQuery",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": "filtersOrder",
                            "args": v6 /*: any*/ ,
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "Nav4FiltersContent_navigationCustomisation"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "Nav4FiltersContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouriteFilters",
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "FILTER"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                v14 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v15 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentFilters",
                            "args": [
                                v7 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "FILTER"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                v14 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v15 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v7 /*: any*/ 
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "skipOrderQuery",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": "filtersOrder",
                            "args": v6 /*: any*/ ,
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SettingsMenuItemConnection",
                                    "kind": "LinkedField",
                                    "name": "sidebar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "SettingsMenuItem",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "menuId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "visible"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "751f380d183acb8583bba4ad6166f3ef0ff8802f77c9de73c1817f5dd54c1ccd",
            "metadata": {},
            "name": "Nav4FiltersContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$581dc9483f8aa8cd$var$node.hash = "d4b665b65964e2ddaba79547452785c6";
var $581dc9483f8aa8cd$export$2e2bcd8739ae039 = $581dc9483f8aa8cd$var$node;

});

parcelRegister("hVNta", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1GORd").then(()=>parcelRequire('bJIKs'));

});





parcelRegister("4er6h", function(module, exports) {
$parcel$export(module.exports, "Nav4Operations", () => $222d67c7ac74057f$export$bc4d01c843cee95e);

var $8WuH7 = parcelRequire("8WuH7");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $6d5EB = parcelRequire("6d5EB");

var $h8QGu = parcelRequire("h8QGu");

var $jyCdG = parcelRequire("jyCdG");

var $5IkoH = parcelRequire("5IkoH");

var $19zz3 = parcelRequire("19zz3");

var $i860n = parcelRequire("i860n");


var $9O114 = parcelRequire("9O114");

var $coWZk = parcelRequire("coWZk");

var $2sxBx = parcelRequire("2sxBx");
const $222d67c7ac74057f$export$bc4d01c843cee95e = (props)=>{
    const { isExpanded: isExpanded, queryRef: queryRef, ...dndProps } = props;
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $8WuH7.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $19zz3.useSidebarNav4)();
    const isExpandedValue = (0, $i860n.fg)('navx-global-side-nav') ? !!props.isExpandOrFlyoutOpen && props.isExpanded : props.isExpanded;
    const contents = isInitialSelectedPath((0, $5IkoH.MENU_ID_OPERATIONS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $coWZk.OperationsMenuForLanding), {
        isExpanded: isExpandedValue,
        queryRef: data,
        ...dndProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9O114.OperationsMenuDefault), {
        isExpanded: isExpandedValue,
        ...dndProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jyCdG.default), {
        name: "nav4-sidebar-operations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "flag",
        id: "operations-section",
        packageName: (0, $a66b0cdc8b7869ef$export$b8b9d90f9e5bd72b),
        teamName: (0, $a66b0cdc8b7869ef$export$d57b6b390e78d90f)
    }, (0, $i860n.fg)('communications_status_page_manage_spotlight') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2sxBx.AlertsPopoutStoreContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6d5EB.Placement), null), contents) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2sxBx.AlertsPopoutStoreContainer), {
        isGlobal: true
    }, contents)));
};
$222d67c7ac74057f$export$bc4d01c843cee95e.displayName = "Nav4Operations";

});
parcelRegister("8WuH7", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7b7ca3365cc6055$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<12f168b778b5bb5b1945ea341a7aa5d8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e7b7ca3365cc6055$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isOperationsExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Operations",
    "selections": [
        {
            "condition": "isOperationsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "OperationsMenuForLanding"
                }
            ]
        }
    ],
    "type": "Query"
};
$e7b7ca3365cc6055$var$node.hash = "3ba981daf80c70dad77a979656f4a679";
var $e7b7ca3365cc6055$export$2e2bcd8739ae039 = $e7b7ca3365cc6055$var$node;

});

parcelRegister("6d5EB", function(module, exports) {
$parcel$export(module.exports, "Placement", () => $4dff1e812e195124$export$af2bcbdc04a2d456);
// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

var $866rq = parcelRequire("866rq");

var $dsFZ4 = parcelRequire("dsFZ4");

var $b0xoT = parcelRequire("b0xoT");
const $4dff1e812e195124$var$messageFrontends = [
    (0, $866rq.MessageFrontend)({
        messageTemplateId: 'statuspage-navigation-spotlight'
    })
];
const $4dff1e812e195124$export$7b621692a0aa2333 = (0, $dsFZ4.PlacementFrontend).createPlacementFrontendComponent({
    messageTemplates: $4dff1e812e195124$var$messageFrontends
});
const $4dff1e812e195124$export$af2bcbdc04a2d456 = (0, $b0xoT.withI18n)($4dff1e812e195124$export$7b621692a0aa2333);
const $4dff1e812e195124$export$7d3d92a960f07a28 = $4dff1e812e195124$export$7b621692a0aa2333;

});
parcelRegister("866rq", function(module, exports) {
$parcel$export(module.exports, "MessageFrontend", () => $e2afa4f686ac1b66$export$fa9bb46961aca2cc);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
parcelRequire("44Zv4");
var $8hQRz = parcelRequire("8hQRz");
var $8hQRz = parcelRequire("8hQRz");

var $dsFZ4 = parcelRequire("dsFZ4");

var $5inXb = parcelRequire("5inXb");

var $fGrpH = parcelRequire("fGrpH");

var $iKPvC = parcelRequire("iKPvC");

var $kdOoc = parcelRequire("kdOoc");

var $8Sdzy = parcelRequire("8Sdzy");

var $i2sOf = parcelRequire("i2sOf");

var $55qdj = parcelRequire("55qdj");

var $6bYIG = parcelRequire("6bYIG");

var $6IaSB = parcelRequire("6IaSB");

var $77u08 = parcelRequire("77u08");

var $jukA2 = parcelRequire("jukA2");

var $54cWg = parcelRequire("54cWg");

var $413te = parcelRequire("413te");

var $KcP1c = parcelRequire("KcP1c");

var $7okqc = parcelRequire("7okqc");

var $8guPH = parcelRequire("8guPH");

var $8qQ8A = parcelRequire("8qQ8A");

var $8CDnU = parcelRequire("8CDnU");

var $liP0D = parcelRequire("liP0D");

var $jFNyB = parcelRequire("jFNyB");

var $5Gxfr = parcelRequire("5Gxfr");

var $g5k19 = parcelRequire("g5k19");

var $fxLck = parcelRequire("fxLck");
const $e2afa4f686ac1b66$export$e7843a8f64a8d87c = (0, $dsFZ4.PlacementBackend).createMessageBackend((0, $8hQRz.defaultMessageBackend));
const $e2afa4f686ac1b66$export$5528407cf598adde = '#statuspage-navigation-spotlight-target';
const $e2afa4f686ac1b66$export$b3890eb0ae9dca99 = (0, $dsFZ4.PlacementFrontend).createFrontendStage({
    type: 'render',
    validate: (0, $8hQRz.noValidation)(),
    Component: ({ onDismiss: onDismiss, waitForTrigger: waitForTrigger })=>{
        const { messageDismissed: messageDismissed } = (0, $kdOoc.useMessageEvent)();
        const { messageInstanceClicked: messageInstanceClicked } = (0, $iKPvC.useMessageInstanceEvent)();
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
        const spotlightTarget = (0, $77u08.useHtmlSelector)({
            selector: $e2afa4f686ac1b66$export$5528407cf598adde
        });
        const htmlElementExists = !!spotlightTarget;
        const renderInline = (0, $5inXb.useMountToHtmlElement)({
            selectors: $e2afa4f686ac1b66$export$5528407cf598adde,
            as: 'inline',
            position: 'inside'
        });
        const dismiss = (0, $euxye.useCallback)((e)=>{
            e.preventDefault();
            e.stopPropagation();
            messageDismissed();
            messageInstanceClicked({
                messageEventType: 'clicked',
                clickedElement: {
                    clickIdentifier: 'spotlight-dismissed',
                    clickedElement: 'button',
                    buttonType: 'secondary'
                },
                action: {
                    actionType: 'dismiss'
                },
                additionalMetadataFromFrontend: {}
            });
            fireAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'statuspageNavigationSpotlightDismiss'
            });
            onDismiss?.();
        }, [
            messageDismissed,
            messageInstanceClicked,
            fireAnalyticsEvent,
            onDismiss
        ]);
        const handlePrimaryAction = (0, $euxye.useCallback)((e)=>{
            e.preventDefault();
            e.stopPropagation();
            messageDismissed();
            messageInstanceClicked({
                messageEventType: 'clicked',
                clickedElement: {
                    clickIdentifier: 'go-to-status-pages',
                    clickedElement: 'button',
                    buttonType: 'primary'
                },
                action: {
                    actionType: 'dismiss'
                },
                additionalMetadataFromFrontend: {
                    actionTaken: true
                }
            });
            fireAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'statuspageNavigationSpotlightGoToStatusPages'
            });
            globalThis.open('https://support.atlassian.com/jira-service-management-cloud/docs/manage-and-customize-your-status-pages/', '_blank');
            onDismiss?.();
        }, [
            messageDismissed,
            messageInstanceClicked,
            fireAnalyticsEvent,
            onDismiss
        ]);
        if (!waitForTrigger) return null;
        const messageContent = /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            children: renderInline(/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $g5k19.PopoverProvider), {
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5Gxfr.PopoverTarget), {
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {})
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fxLck.PopoverContent), {
                        dismiss: dismiss,
                        placement: "right-end",
                        isVisible: true,
                        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8CDnU.SpotlightCard), {
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $KcP1c.SpotlightHeader), {
                                    children: [
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $413te.SpotlightHeadline), {
                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                ...(0, $6IaSB.messages).statusPageSpotlightNavigationHeading
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8qQ8A.SpotlightControls), {
                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8guPH.SpotlightDismissControl), {
                                                autoFocus: false,
                                                onClick: dismiss
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $54cWg.SpotlightMedia), {
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $i2sOf.default), {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6bYIG))),
                                        alt: "Create and manage status pages"
                                    })
                                }),
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $liP0D.SpotlightBody), {
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                            ...(0, $6IaSB.messages).statusPageSpotlightNavigationBody
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7okqc.SpotlightFooter), {
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jFNyB.SpotlightActions), {
                                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jukA2.SpotlightPrimaryAction), {
                                            onClick: handlePrimaryAction,
                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                ...(0, $6IaSB.messages).statusPageSpotlightNavigationAction
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }))
        });
        return waitForTrigger({
            isTriggerActive: htmlElementExists,
            messageContent: messageContent
        });
    }
});
const $e2afa4f686ac1b66$export$fa9bb46961aca2cc = (0, $dsFZ4.PlacementFrontend).createMessageFrontend({
    render: $e2afa4f686ac1b66$export$b3890eb0ae9dca99
});

});
parcelRegister("44Zv4", function(module, exports) {
$parcel$export(module.exports, "defaultMessageBackend", () => (parcelRequire("8hQRz")).defaultMessageBackend);

var $2vhMr = parcelRequire("2vhMr");
var $3SSnx = parcelRequire("3SSnx");

var $8hQRz = parcelRequire("8hQRz");



const $51353d880b38c426$export$8df14aa07a2fe864 = {
    createMessageBackend: (stages)=>(0, $3SSnx.createPlacementMessageBackend)(stages),
    withDefaultMessageBackend: ()=>(0, $3SSnx.createPlacementMessageBackend)((0, $8hQRz.defaultMessageBackend))
};

});

parcelRegister("dsFZ4", function(module, exports) {
$parcel$export(module.exports, "PlacementFrontend", () => $bf41701aa302d851$export$55486c2b6964dcf2);
$parcel$export(module.exports, "PlacementBackend", () => $bf41701aa302d851$export$d90b37843c84d1c3);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2vhMr = parcelRequire("2vhMr");

var $8VhoU = parcelRequire("8VhoU");
const $bf41701aa302d851$var$placement = (0, $2vhMr.createPlacement)({
    placementId: 'statuspage-navigation-spotlight-placement',
    options: {
        choreographer: {
            isDefaultEnabled: true
        }
    }
});
const $bf41701aa302d851$export$81df3aa6753d44e2 = $bf41701aa302d851$var$placement.createFrontend;
const $bf41701aa302d851$export$da912f58cb37a643 = $bf41701aa302d851$var$placement.createBackend;
const $bf41701aa302d851$export$55486c2b6964dcf2 = $bf41701aa302d851$export$81df3aa6753d44e2((Messages)=>()=>{
        const [dismissedIds, setDismissedIds] = (0, $euxye.useState)(new Set());
        const { data: data, error: error, isLoading: isLoading } = (0, $8VhoU.usePlacementApi)('/', {
            autoRefetch: {
                isEnabled: true,
                updateKey: 'statuspage-navigation-spotlight-placement'
            }
        });
        const messages = data?.messages;
        const visibleMessages = messages?.filter((message)=>!dismissedIds.has(message.messageInstanceId))?.slice?.(0, 1);
        const handleDismiss = (messageInstanceId)=>{
            setDismissedIds((prev)=>new Set([
                    ...Array.from(prev),
                    messageInstanceId
                ]));
        };
        if (error) throw error;
        if (isLoading) return null;
        if (!visibleMessages || visibleMessages.length === 0) return null;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
            children: visibleMessages.map((message)=>/*#__PURE__*/ (0, $e79Pd.jsx)(Messages.render, {
                    onDismiss: ()=>handleDismiss(message.messageInstanceId),
                    ...message
                }, message.messageInstanceId))
        });
    });
const $bf41701aa302d851$export$d90b37843c84d1c3 = $bf41701aa302d851$export$da912f58cb37a643();

});

parcelRegister("5inXb", function(module, exports) {
$parcel$export(module.exports, "useMountToHtmlElement", () => $6478f4686afce728$export$81e9e5f51d0d0a61);
$parcel$export(module.exports, "useElement", () => $6478f4686afce728$export$93e1bc7222cfbdc8);
$parcel$export(module.exports, "useInlineNearElement", () => $6478f4686afce728$export$4c5bbb39f448bd4b);

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");
const $6478f4686afce728$export$81e9e5f51d0d0a61 = (params)=>{
    const { as: as, selectors: selectors, position: position = 'after', observeRoot: observeRoot, rootDocument: rootDocument } = params ?? {};
    const targetElement = $6478f4686afce728$export$93e1bc7222cfbdc8({
        selectors: selectors,
        observeRoot: observeRoot,
        rootDocument: rootDocument
    });
    const renderPortal = $6478f4686afce728$var$usePortalNearElement({
        targetElement: targetElement,
        position: position
    });
    const renderInline = $6478f4686afce728$export$4c5bbb39f448bd4b({
        targetElement: targetElement,
        position: position
    });
    if (as === 'inline') return renderInline;
    return renderPortal;
};
const $6478f4686afce728$export$93e1bc7222cfbdc8 = ({ selectors: selectors, observeRoot: observeRoot, rootDocument: rootDocument })=>{
    const knownEls = (0, $euxye.useRef)({});
    const [el, setEl] = (0, $euxye.useState)();
    (0, $euxye.useEffect)(()=>{
        const doc = rootDocument ?? globalThis.document;
        if (typeof doc === 'undefined' || !selectors) {
            setEl(undefined);
            return;
        }
        if (knownEls.current?.[selectors]) {
            setEl(knownEls.current[selectors]);
            return;
        }
        const element = doc.querySelector(selectors) ?? undefined;
        knownEls.current[selectors] = element;
        setEl(element);
        if (observeRoot) {
            const observer = new MutationObserver(()=>{
                const foundElement = doc.querySelector(selectors);
                if (foundElement) {
                    setEl(foundElement);
                    observer.disconnect();
                }
            });
            observer.observe(observeRoot, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }
        return;
    }, [
        selectors,
        observeRoot,
        rootDocument
    ]);
    return el;
};
const $6478f4686afce728$var$usePortalNearElement = ({ targetElement: targetElement, position: position = 'after' })=>{
    const [portalContainer, setPortalContainer] = (0, $euxye.useState)(null);
    (0, $euxye.useEffect)(()=>{
        if (typeof document === 'undefined') return;
        if (!targetElement) {
            setPortalContainer(null);
            return;
        }
        const container = targetElement.ownerDocument.createElement('div');
        container.style.position = 'absolute';
        if (position === 'after') targetElement.parentNode?.insertBefore(container, targetElement.nextSibling);
        else if (position === 'before') targetElement.parentNode?.insertBefore(container, targetElement);
        else if (position === 'inside') targetElement.appendChild(container);
        setPortalContainer(container);
        return ()=>{
            container.remove();
        };
    }, [
        targetElement,
        position
    ]);
    const renderPortal = (children)=>{
        return portalContainer ? (0, $85XPu.createPortal)(children, portalContainer) : null;
    };
    return renderPortal;
};
const $6478f4686afce728$export$4c5bbb39f448bd4b = ({ targetElement: targetElement, position: position = 'after', containerTag: containerTag = 'div' })=>{
    const [inlineContainer, setInlineContainer] = (0, $euxye.useState)(null);
    (0, $euxye.useEffect)(()=>{
        if (typeof document === 'undefined') return;
        if (!targetElement) {
            setInlineContainer(null);
            return;
        }
        const container = targetElement.ownerDocument.createElement(containerTag);
        if (position === 'after') targetElement.parentNode?.insertBefore(container, targetElement.nextSibling);
        else if (position === 'before') targetElement.parentNode?.insertBefore(container, targetElement);
        else if (position === 'inside') targetElement.appendChild(container);
        setInlineContainer(container);
        return ()=>{
            container.remove();
        };
    }, [
        targetElement,
        position
    ]);
    const renderInline = (children)=>{
        return inlineContainer ? (0, $85XPu.createPortal)(children, inlineContainer) : null;
    };
    return renderInline;
};

});

parcelRegister("6bYIG", function(module, exports) {
module.exports = new URL("create-status-page-spotlight.568bb613.png", import.meta.url).toString();

});

parcelRegister("6IaSB", function(module, exports) {
$parcel$export(module.exports, "messages", () => $bea4da3fe7d82983$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $bea4da3fe7d82983$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    statusPageSpotlightNavigationHeading: {
        defaultMessage: 'Create and manage status pages',
        description: 'Heading for the Statuspage navigation spotlight',
        id: 'statuspage.navigation-spotlight.heading'
    },
    statusPageSpotlightNavigationBody: {
        defaultMessage: 'Post real-time updates and customize your status pages directly from here, without switching platforms.',
        description: 'Body text for the Statuspage navigation spotlight',
        id: 'statuspage.navigation-spotlight.body'
    },
    statusPageSpotlightNavigationAction: {
        defaultMessage: 'About status pages',
        description: 'Primary action button for the Statuspage navigation spotlight',
        id: 'statuspage.navigation-spotlight.action'
    }
});

});

parcelRegister("77u08", function(module, exports) {
$parcel$export(module.exports, "useHtmlSelector", () => $2f687f495e1f6f62$export$77f643f8af923189);

var $euxye = parcelRequire("euxye");
const $2f687f495e1f6f62$export$77f643f8af923189 = ({ selector: selector })=>{
    const [el, setEl] = (0, $euxye.useState)();
    (0, $euxye.useEffect)(()=>{
        if (typeof globalThis.document === 'undefined' || !selector) {
            setEl(undefined);
            return;
        }
        const check = ()=>{
            const element = globalThis.document.querySelector(selector);
            setEl(element ?? undefined);
        };
        check();
        const observer = new MutationObserver(check);
        observer.observe(globalThis.document.body, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        selector
    ]);
    return el;
};

});


parcelRegister("b0xoT", function(module, exports) {
$parcel$export(module.exports, "withI18n", () => $7b498a8681e02c88$export$bfba3ccd9d9038f9);

var $2I9KJ = parcelRequire("2I9KJ");

var $3ozRQ = parcelRequire("3ozRQ");
const $7b498a8681e02c88$export$bfba3ccd9d9038f9 = (0, $2I9KJ.createWithI18n)((0, $3ozRQ.messagesLoader));

});


/* eslint-disable jira/filename-case */ const $a66b0cdc8b7869ef$export$337d30e19f17af0f = 'fetchError';
const $a66b0cdc8b7869ef$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4SidebarsContentOperations';
const $a66b0cdc8b7869ef$export$d57b6b390e78d90f = 'alexstrasza';

parcelRegister("9O114", function(module, exports) {
$parcel$export(module.exports, "OperationsMenuDefault", () => $36b4f41356141235$export$ef19d9521d85a60a);

var $euxye = parcelRequire("euxye");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $gEDfa = parcelRequire("gEDfa");

var $hDvet = parcelRequire("hDvet");

var $jepRN = parcelRequire("jepRN");

var $kt86l = parcelRequire("kt86l");

var $5q34V = parcelRequire("5q34V");

var $d4scW = parcelRequire("d4scW");

var $2sxBx = parcelRequire("2sxBx");
const $36b4f41356141235$export$ef19d9521d85a60a = (0, $jepRN.componentWithFG)('navx-global-side-nav', $36b4f41356141235$var$OperationsMenuDefaultGSN, $36b4f41356141235$var$OperationsMenuDefaultNav4);
function $36b4f41356141235$var$OperationsMenuDefaultGSN(props) {
    const { isExpanded: isExpanded, ...dndProps } = props;
    const cloudId = (0, $kt86l.useCloudId)();
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $5q34V.asyncAlertsContentViewQuery), entryPointParams);
    const triggerRef = (0, $hDvet.useExpandableEntryPointTrigger)(entryPointActions);
    const { state: { lastVisitedSearch: lastVisitedSearch }, setContent: setContent } = (0, $2sxBx.useAlertsPopoutStore)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $euxye.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    (0, $euxye.useEffect)(()=>{
        if (lastVisitedSearch) setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubject,
            // Required props for error JSErrorBoundary.
            id: "operations-menu-default",
            packageName: "jiraNavigationAppsSidebarNav4Operations",
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: "platform-united",
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: {
                ...entryPointParams,
                location: 'popOutPanel'
            }
        }));
    }, [
        entryPointParams,
        entryPointReferenceSubject,
        lastVisitedSearch,
        setContent
    ]);
    const handleAnyToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d4scW.OperationsExpandableMenuItem), {
        AlertsMenuItemContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubject,
            // Required props for error JSErrorBoundary.
            id: "operations-menu-default",
            packageName: "jiraNavigationAppsSidebarNav4Operations",
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: "platform-united",
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: {
                ...entryPointParams,
                location: 'sidenav'
            }
        }),
        isExpanded: isExpanded,
        onExpansionToggle: handleAnyToggle,
        onSystemToggle: handleAnyToggle,
        triggerRef: triggerRef,
        ...dndProps
    });
}
$36b4f41356141235$var$OperationsMenuDefaultGSN.displayName = "OperationsMenuDefaultGSN";
function $36b4f41356141235$var$OperationsMenuDefaultNav4(props) {
    const { isExpanded: isExpanded } = props;
    const cloudId = (0, $kt86l.useCloudId)();
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $5q34V.asyncAlertsContentViewQuery), entryPointParams);
    const triggerRef = (0, $hDvet.useExpandableEntryPointTrigger)(entryPointActions);
    const { state: { lastVisitedSearch: lastVisitedSearch }, setContent: setContent } = (0, $2sxBx.useAlertsPopoutStore)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $euxye.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    (0, $euxye.useEffect)(()=>{
        if (lastVisitedSearch) setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubject,
            // Required props for error JSErrorBoundary.
            id: "operations-menu-default",
            packageName: "jiraNavigationAppsSidebarNav4Operations",
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: "platform-united",
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: {
                ...entryPointParams,
                location: 'popOutPanel'
            }
        }));
    }, [
        entryPointParams,
        entryPointReferenceSubject,
        lastVisitedSearch,
        setContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d4scW.OperationsExpandableMenuItem), {
        isExpanded: props.isExpanded,
        onSystemToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        triggerRef: triggerRef,
        AlertsMenuItemContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubject,
            // Required props for error JSErrorBoundary.
            id: "operations-menu-default",
            packageName: "jiraNavigationAppsSidebarNav4Operations",
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: "platform-united",
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: {
                ...entryPointParams,
                location: 'sidenav'
            }
        })
    });
}
$36b4f41356141235$var$OperationsMenuDefaultNav4.displayName = "OperationsMenuDefaultNav4";

});
parcelRegister("5q34V", function(module, exports) {
$parcel$export(module.exports, "asyncAlertsContentViewQuery", () => $3dd7fa5af974f9fe$export$182f7de76119e38a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $bPg8b = parcelRequire("bPg8b");

const $3dd7fa5af974f9fe$export$182f7de76119e38a = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("kyNLl")), {
        moduleId: "6ef18548",
        moduleName: "AlertsContentViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryRef: {
                    parameters: $bPg8b.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("bPg8b", function(module, exports) {
$parcel$export(module.exports, "default", () => $82d9f6899a679131$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1dfb655e982d2595dfd334637b4d3201>>
 * @relayHash 61b0c864f4ac793a8d9ec854f480e261
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 50ab07d34bce5f0d58d834c318c1bb2d66298686f4c390deb34deb3e3718a6f7
const $82d9f6899a679131$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AlertsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "AlertsMenuItemContentNew"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "AlertsMenuItemContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AlertsContentViewQuery",
            "selections": [
                {
                    "concreteType": "OpsgenieQuery",
                    "kind": "LinkedField",
                    "name": "opsgenie",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "OpsgenieSavedSearches",
                            "kind": "LinkedField",
                            "name": "savedSearches",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "OpsgenieSavedSearch",
                                    "kind": "LinkedField",
                                    "name": "starred",
                                    "plural": true,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "OpsgenieSavedSearch",
                                    "kind": "LinkedField",
                                    "name": "sharedWithMe",
                                    "plural": true,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "OpsgenieSavedSearch",
                                    "kind": "LinkedField",
                                    "name": "createdByMe",
                                    "plural": true,
                                    "selections": v1 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "50ab07d34bce5f0d58d834c318c1bb2d66298686f4c390deb34deb3e3718a6f7",
            "metadata": {},
            "name": "AlertsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$82d9f6899a679131$var$node.hash = "879968e67a244943ed377d7fb5da054d";
var $82d9f6899a679131$export$2e2bcd8739ae039 = $82d9f6899a679131$var$node;

});

parcelRegister("kyNLl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("92QPS").then(()=>parcelRequire('KXPEy'));

});


parcelRegister("d4scW", function(module, exports) {
$parcel$export(module.exports, "OperationsExpandableMenuItem", () => $81b6d5a91ffb4286$export$a04d9e9cc5ec19d3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");


var $cqFwm = parcelRequire("cqFwm");

var $krnGE = parcelRequire("krnGE");




var $bOwox = parcelRequire("bOwox");

var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $4VtOS = parcelRequire("4VtOS");

var $aQCoC = parcelRequire("aQCoC");

var $jzXAj = parcelRequire("jzXAj");

var $KL7Bq = parcelRequire("KL7Bq");

var $3rqDf = parcelRequire("3rqDf");

var $dx7aH = parcelRequire("dx7aH");

var $223zC = parcelRequire("223zC");

var $f4N10 = parcelRequire("f4N10");

var $jepRN = parcelRequire("jepRN");

var $6HvWM = parcelRequire("6HvWM");

var $1Pip6 = parcelRequire("1Pip6");

var $2EFuW = parcelRequire("2EFuW");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $e8fyN = parcelRequire("e8fyN");

var $eD6MF = parcelRequire("eD6MF");

var $jYG4S = parcelRequire("jYG4S");

var $g8Aut = parcelRequire("g8Aut");

var $5rdPH = parcelRequire("5rdPH");

var $kmVc3 = parcelRequire("kmVc3");

var $7f3lN = parcelRequire("7f3lN");

var $aNG0w = parcelRequire("aNG0w");

var $apw2M = parcelRequire("apw2M");

var $fFNvS = parcelRequire("fFNvS");

var $i860n = parcelRequire("i860n");

var $f2wVS = parcelRequire("f2wVS");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $eijVy = parcelRequire("eijVy");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $dxrRh = parcelRequire("dxrRh");

var $iP4dn = parcelRequire("iP4dn");

var $eC98G = parcelRequire("eC98G");

var $2dFbg = parcelRequire("2dFbg");

var $2sxBx = parcelRequire("2sxBx");
const $81b6d5a91ffb4286$var$homeMenuMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.home",
    defaultMessage: "Home"
});
const $81b6d5a91ffb4286$var$onCallSchedulesMenuMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.on-call-schedules",
    defaultMessage: "On-call schedules"
});
const $81b6d5a91ffb4286$var$servicesMenuMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.services",
    defaultMessage: "Services"
});
const $81b6d5a91ffb4286$var$reportsMenuMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.reports",
    defaultMessage: "Reports"
});
const $81b6d5a91ffb4286$var$reportsLegacyMenuMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.reports-legacy",
    defaultMessage: "Reports (Legacy)"
});
const $81b6d5a91ffb4286$var$reportsNewBadgeMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.reports-new-badge",
    defaultMessage: "New"
});
const $81b6d5a91ffb4286$var$statusPagesMenuMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.statuspages",
    defaultMessage: "Status pages"
});
const $81b6d5a91ffb4286$var$communicationsMenuMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.communications",
    defaultMessage: "Communications"
});
const $81b6d5a91ffb4286$var$changesMenuMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.changes",
    defaultMessage: "Changes"
});
const $81b6d5a91ffb4286$var$incidentsMenuMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.incidents",
    defaultMessage: "Incidents"
});
const $81b6d5a91ffb4286$var$operationsMessages = {
    home: $81b6d5a91ffb4286$var$homeMenuMessage,
    onCallSchedules: $81b6d5a91ffb4286$var$onCallSchedulesMenuMessage,
    services: $81b6d5a91ffb4286$var$servicesMenuMessage,
    reports: $81b6d5a91ffb4286$var$reportsMenuMessage,
    reportsLegacy: $81b6d5a91ffb4286$var$reportsLegacyMenuMessage,
    reportsNew: $81b6d5a91ffb4286$var$reportsMenuMessage,
    reportsNewBadge: $81b6d5a91ffb4286$var$reportsNewBadgeMessage,
    statusPages: $81b6d5a91ffb4286$var$statusPagesMenuMessage,
    communications: $81b6d5a91ffb4286$var$communicationsMenuMessage,
    changes: $81b6d5a91ffb4286$var$changesMenuMessage,
    incidents: $81b6d5a91ffb4286$var$incidentsMenuMessage
};
const $81b6d5a91ffb4286$var$alertsMessageDefinition = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-operations.alerts",
    defaultMessage: "Alerts"
});
const $81b6d5a91ffb4286$export$a04d9e9cc5ec19d3 = (0, $jepRN.componentWithFG)('navx-global-side-nav', $81b6d5a91ffb4286$var$OperationsExpandableMenuItemGSN, $81b6d5a91ffb4286$var$OperationsExpandableMenuItemNav4);
function $81b6d5a91ffb4286$var$OperationsExpandableMenuItemGSN(props) {
    const { AlertsMenuItemContent: AlertsMenuItemContent, draggableRef: draggableRef, dropIndicator: dropIndicator, hasDragIndicator: hasDragIndicator, isDragging: isDragging, isExpanded: isExpanded, onExpandFlyoutToggle: onExpandFlyoutToggle, onExpansionToggle: onExpansionToggle, onSystemToggle: onSystemToggle, triggerRef: triggerRef, visualContentRef: visualContentRef } = props;
    const isAlertsRoute = (0, $f2wVS.useIsActiveRoute)(new Set([
        (0, $223zC.eocGlobalAlertListRoute).name,
        (0, $f4N10.eocTeamAlertDetailRoute).name
    ]));
    const isChangesRoute = (0, $f2wVS.useIsActiveRoute)(new Set([
        (0, $cqFwm.eocChangesRoute).name
    ]));
    const isIncidentsRoute = (0, $f2wVS.useIsActiveRoute)(new Set([
        (0, $krnGE.eocIncidentsRoute).name
    ]));
    const { hasReports: hasReports, isOperationReportsEnabled: isOperationReportsEnabled, showCommunicationsMenu: showCommunicationsMenu, showStatuspageMenu: showStatuspageMenu, isStatusPageDraftOnly: isStatusPageDraftOnly } = (0, $dxrRh.useFeatures)();
    const { icon: alertsIcon, formattedMessage: alertsMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$alertsMessageDefinition, (0, (/*@__PURE__*/$parcel$interopDefault($apw2M))));
    const { icon: homeIcon, formattedMessage: homeMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.home, (0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))));
    const { icon: oncallSchedulesIcon, formattedMessage: oncallSchedulesMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.onCallSchedules, (0, (/*@__PURE__*/$parcel$interopDefault($eD6MF))));
    const { icon: servicesIcon, formattedMessage: servicesMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.services, (0, (/*@__PURE__*/$parcel$interopDefault($e8fyN))));
    const { icon: reportsIcon, formattedMessage: reportsMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.reports, (0, (/*@__PURE__*/$parcel$interopDefault($7f3lN))));
    const { icon: reportsNewIcon, formattedMessage: reportsNewMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.reportsNew, (0, (/*@__PURE__*/$parcel$interopDefault($7f3lN))));
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).OPERATIONS);
    const { icon: statusPageIcon, formattedMessage: statusPageMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.statusPages, (0, (/*@__PURE__*/$parcel$interopDefault($kmVc3))));
    const { icon: communicationsIcon, formattedMessage: communicationsMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.communications, (0, (/*@__PURE__*/$parcel$interopDefault($5rdPH))));
    const { icon: changesIcon, formattedMessage: changesMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.changes, (0, (/*@__PURE__*/$parcel$interopDefault($g8Aut))));
    const { icon: incidentsIcon, formattedMessage: incidentsMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.incidents, (0, (/*@__PURE__*/$parcel$interopDefault($jYG4S))));
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { state: { lastVisitedSearch: lastVisitedSearch }, syncLastVisitedSearch: syncLastVisitedSearch } = (0, $2sxBx.useAlertsPopoutStore)();
    // This state is lifted from the ActionsButtons component, as we don't want to show the "..."
    // menu when it will contain no content.
    const tenantContext = (0, $eijVy.useTenantContext)();
    const { isOpsAdmin: isOpsAdmin } = (0, $6HvWM.useOgTenantInfo)();
    const shouldShowGeneralConfiguration = (tenantContext.isAdmin || isOpsAdmin) && tenantContext.licensedProducts[0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61];
    (0, $euxye.useEffect)(()=>{
        syncLastVisitedSearch();
    }, [
        syncLastVisitedSearch
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const onClickAlerts = (0, $euxye.useCallback)((_e, _a, { isExpanded: hasExpanded })=>{
        if (hasExpanded) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'alerts'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const alertsChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, lastVisitedSearch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2dFbg.PopoutToggleButton), null),
        elemBefore: alertsIcon,
        href: lastVisitedSearch,
        menuId: (0, $i860n.fg)('ops-alerts-popout-selection-fix') ? (0, $5IkoH.MENU_ID_OPS_ALERTS) : (0, $5IkoH.MENU_ID_OPS_OVERVIEW)
    }, alertsMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-operations-alerts",
        actions: isAlertsRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2dFbg.PopoutToggleButton), null) : undefined,
        onClick: onClickAlerts,
        elemBefore: alertsIcon,
        testId: (0, $jzXAj.getTestId)((0, $5IkoH.MENU_ID_OPS_ALERTS))
    }, alertsMessage), !lastVisitedSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, AlertsMenuItemContent));
    const handleOnExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) sendSectionItemAnalyticsEvent({
            menuId: (0, $6GljB.L1_MENU_ID).OPERATIONS,
            sectionItem: (0, $bOwox.SECTION_ITEM_OPERATIONS)
        });
        onExpansionToggle?.(hasExpanded);
        onExpandFlyoutToggle?.(hasExpanded);
    }, [
        onExpandFlyoutToggle,
        onExpansionToggle,
        sendSectionItemAnalyticsEvent
    ]);
    const onClickOverview = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'overview'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickServices = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'services'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickOnCallSchedules = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'onCallSchedules'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickStatusPages = (0, $euxye.useCallback)(()=>{
        // Standard sidebar nav event (fired for every tenant that can see the item —
        // enterprise + premium experiment). The isStatusPageDraftOnly attribute lets
        // analytics distinguish the premium-experiment (draft-only) cohort.
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'statusPages',
                isStatusPageDraftOnly: isStatusPageDraftOnly
            }
        });
    }, [
        createAnalyticsEvent,
        isStatusPageDraftOnly
    ]);
    const onClickReports = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'reports'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickReportsNew = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'reportsNew'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickChanges = (0, $euxye.useCallback)((_e, _a, { isExpanded: hasExpanded })=>{
        if (hasExpanded) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'changes'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickIncidents = (0, $euxye.useCallback)((_e, _a, { isExpanded: hasExpanded })=>{
        if (hasExpanded) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'incidents'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const COMMUNICATIONS_STAKEHOLDERS_HREF = '/jira/communications/stakeholders';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        dropTargetRef: visualContentRef,
        dropIndicator: dropIndicator,
        isDragging: isDragging,
        isExpanded: isExpanded,
        menuId: (0, $5IkoH.MENU_ID_OPERATIONS),
        onExpansionToggle: handleOnExpansionToggle,
        onSystemToggle: onSystemToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        actionsOnHover: shouldShowGeneralConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2dFbg.ActionButtons), null),
        elemBefore: icon,
        hasDragIndicator: hasDragIndicator,
        interactionName: "nav4-sidebar-operations",
        isDragging: isDragging,
        // oxlint-disable-next-line typescript/no-non-null-assertion
        ref: (0, $fFNvS.mergeRefs)(triggerRef, draggableRef),
        testId: (0, $jzXAj.getTestId)((0, $5IkoH.MENU_ID_OPERATIONS))
    }, (0, $i860n.fg)('ops-overview-disc-spotlights') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        id: "operations-overview-discoverability-spotlight-target"
    }, formattedMessage) : formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: homeIcon,
        href: "/jira/ops/overview",
        menuId: (0, $5IkoH.MENU_ID_OPS_OVERVIEW),
        onClick: onClickOverview
    }, homeMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        menuId: (0, $5IkoH.MENU_ID_OPS_ALERTS)
    }, alertsChildren), (0, $2700E.expVal)('changes-and-incidents-under-operations', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        menuId: (0, $5IkoH.MENU_ID_OPS_CHANGES)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-operations-changes",
        onClick: onClickChanges,
        elemBefore: changesIcon,
        href: "/jira/ops/changes",
        isSelected: isChangesRoute,
        testId: (0, $jzXAj.getTestId)((0, $5IkoH.MENU_ID_OPS_CHANGES))
    }, changesMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iP4dn.ChangesContent), null)), (0, $2700E.expVal)('changes-and-incidents-under-operations', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        menuId: (0, $5IkoH.MENU_ID_OPS_INCIDENTS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-operations-incidents",
        onClick: onClickIncidents,
        elemBefore: incidentsIcon,
        href: "/jira/ops/incidents",
        isSelected: isIncidentsRoute,
        testId: (0, $jzXAj.getTestId)((0, $5IkoH.MENU_ID_OPS_INCIDENTS))
    }, incidentsMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eC98G.IncidentsContent), null)), (0, $i860n.fg)('service-list-sidebar-item') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: servicesIcon,
        href: "/jira/ops/services",
        menuId: (0, $5IkoH.MENU_ID_OPS_SERVICES),
        onClick: onClickServices
    }, servicesMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: oncallSchedulesIcon,
        href: "/jira/ops/who-is-on-call",
        menuId: (0, $5IkoH.MENU_ID_OPS_ON_CALL),
        onClick: onClickOnCallSchedules
    }, oncallSchedulesMessage), showStatuspageMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: statusPageIcon,
        ...isStatusPageDraftOnly ? {
            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Pip6))), {
                label: "",
                color: "var(--ds-icon-accent-purple, #AF59E1)",
                spacing: "none",
                testId: "sidebar-nav4-sidebars-content-operations.ui.operations-expandable-menu-item.premium-diamond"
            })
        } : {},
        href: "/jira/communications/status-page",
        menuId: (0, $5IkoH.MENU_ID_OPS_STATUS_PAGES),
        onClick: onClickStatusPages
    }, (0, $i860n.fg)('communications_status_page_manage_spotlight') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        id: "statuspage-navigation-spotlight-target"
    }, statusPageMessage) : statusPageMessage), showCommunicationsMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: communicationsIcon,
        href: COMMUNICATIONS_STAKEHOLDERS_HREF,
        menuId: (0, $5IkoH.MENU_ID_COMMUNICATIONS_STAKEHOLDERS)
    }, communicationsMessage), hasReports && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: reportsIcon,
        href: "/jira/ops/reports",
        menuId: (0, $5IkoH.MENU_ID_OPS_REPORTS),
        onClick: onClickReports
    }, (0, $i860n.fg)('platform_avp_jira_ops_reporting') ? formatMessage($81b6d5a91ffb4286$var$operationsMessages.reportsLegacy) : reportsMessage), isOperationReportsEnabled && (0, $i860n.fg)('platform_avp_jira_ops_reporting') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: reportsNewIcon,
        href: "/jira/ops/reports-new",
        menuId: (0, $5IkoH.MENU_ID_OPS_REPORTS_NEW),
        onClick: onClickReportsNew,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
            appearance: "discovery"
        }, formatMessage($81b6d5a91ffb4286$var$operationsMessages.reportsNewBadge))
    }, reportsNewMessage)));
}
$81b6d5a91ffb4286$var$OperationsExpandableMenuItemGSN.displayName = "OperationsExpandableMenuItemGSN";
function $81b6d5a91ffb4286$var$OperationsExpandableMenuItemNav4(props) {
    const isAlertsRoute = (0, $f2wVS.useIsActiveRoute)(new Set([
        (0, $223zC.eocGlobalAlertListRoute).name,
        (0, $f4N10.eocTeamAlertDetailRoute).name
    ]));
    const isChangesRoute = (0, $f2wVS.useIsActiveRoute)(new Set([
        (0, $cqFwm.eocChangesRoute).name
    ]));
    const isIncidentsRoute = (0, $f2wVS.useIsActiveRoute)(new Set([
        (0, $krnGE.eocIncidentsRoute).name
    ]));
    const { AlertsMenuItemContent: AlertsMenuItemContent, isExpanded: isExpanded, onExpansionToggle: onExpansionToggle, onSystemToggle: onSystemToggle, triggerRef: triggerRef } = props;
    const { hasReports: hasReports, isOperationReportsEnabled: isOperationReportsEnabled, showCommunicationsMenu: showCommunicationsMenu, showStatuspageMenu: showStatuspageMenu, isStatusPageDraftOnly: isStatusPageDraftOnly } = (0, $dxrRh.useFeatures)();
    const { icon: alertsIcon, formattedMessage: alertsMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$alertsMessageDefinition, (0, (/*@__PURE__*/$parcel$interopDefault($apw2M))));
    const { icon: homeIcon, formattedMessage: homeMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.home, (0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))));
    const { icon: oncallSchedulesIcon, formattedMessage: oncallSchedulesMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.onCallSchedules, (0, (/*@__PURE__*/$parcel$interopDefault($eD6MF))));
    const { icon: servicesIcon, formattedMessage: servicesMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.services, (0, (/*@__PURE__*/$parcel$interopDefault($e8fyN))));
    const { icon: reportsIcon, formattedMessage: reportsMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.reports, (0, (/*@__PURE__*/$parcel$interopDefault($7f3lN))));
    const { icon: reportsNewIcon, formattedMessage: reportsNewMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.reportsNew, (0, (/*@__PURE__*/$parcel$interopDefault($7f3lN))));
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).OPERATIONS);
    const { icon: statusPageIcon, formattedMessage: statusPageMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.statusPages, (0, (/*@__PURE__*/$parcel$interopDefault($kmVc3))));
    const { icon: communicationsIcon, formattedMessage: communicationsMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.communications, (0, (/*@__PURE__*/$parcel$interopDefault($5rdPH))));
    const { icon: changesIcon, formattedMessage: changesMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.changes, (0, (/*@__PURE__*/$parcel$interopDefault($g8Aut))));
    const { icon: incidentsIcon, formattedMessage: incidentsMessage } = (0, $KL7Bq.useFormattedMessageAndIcon)($81b6d5a91ffb4286$var$operationsMessages.incidents, (0, (/*@__PURE__*/$parcel$interopDefault($jYG4S))));
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { state: { lastVisitedSearch: lastVisitedSearch }, syncLastVisitedSearch: syncLastVisitedSearch } = (0, $2sxBx.useAlertsPopoutStore)();
    (0, $euxye.useEffect)(()=>{
        syncLastVisitedSearch();
    }, [
        syncLastVisitedSearch
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const onClickAlerts = (0, $euxye.useCallback)((_e, _a, { isExpanded: hasExpanded })=>{
        if (hasExpanded) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'alerts'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const alertsChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, lastVisitedSearch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2dFbg.PopoutToggleButton), null),
        elemBefore: alertsIcon,
        href: lastVisitedSearch,
        menuId: (0, $i860n.fg)('ops-alerts-popout-selection-fix') ? (0, $5IkoH.MENU_ID_OPS_ALERTS) : (0, $5IkoH.MENU_ID_OPS_OVERVIEW)
    }, alertsMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-operations-alerts",
        actions: isAlertsRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2dFbg.PopoutToggleButton), null) : undefined,
        onClick: onClickAlerts,
        elemBefore: alertsIcon,
        testId: (0, $jzXAj.getTestId)((0, $5IkoH.MENU_ID_OPS_ALERTS))
    }, alertsMessage), !lastVisitedSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, AlertsMenuItemContent));
    const handleOnExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) sendSectionItemAnalyticsEvent({
            menuId: (0, $6GljB.L1_MENU_ID).OPERATIONS,
            sectionItem: (0, $bOwox.SECTION_ITEM_OPERATIONS)
        });
        onExpansionToggle?.(hasExpanded);
    }, [
        onExpansionToggle,
        sendSectionItemAnalyticsEvent
    ]);
    const onClickOverview = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'overview'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickServices = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'services'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickOnCallSchedules = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'onCallSchedules'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickStatusPages = (0, $euxye.useCallback)(()=>{
        // Standard sidebar nav event (fired for every tenant that can see the item —
        // enterprise + premium experiment). The isStatusPageDraftOnly attribute lets
        // analytics distinguish the premium-experiment (draft-only) cohort.
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'statusPages',
                isStatusPageDraftOnly: isStatusPageDraftOnly
            }
        });
    }, [
        createAnalyticsEvent,
        isStatusPageDraftOnly
    ]);
    const onClickReports = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'reports'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickReportsNew = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'reportsNew'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickChanges = (0, $euxye.useCallback)((_e, _a, { isExpanded: hasExpanded })=>{
        if (hasExpanded) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'changes'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickIncidents = (0, $euxye.useCallback)((_e, _a, { isExpanded: hasExpanded })=>{
        if (hasExpanded) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: 'incidents'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const COMMUNICATIONS_STAKEHOLDERS_HREF = '/jira/communications/stakeholders';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: (0, $5IkoH.MENU_ID_OPERATIONS),
        onExpansionToggle: handleOnExpansionToggle,
        onSystemToggle: onSystemToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-operations",
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2dFbg.ActionButtons), null),
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $jzXAj.getTestId)((0, $5IkoH.MENU_ID_OPERATIONS))
    }, (0, $i860n.fg)('ops-overview-disc-spotlights') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        id: "operations-overview-discoverability-spotlight-target"
    }, formattedMessage) : formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: homeIcon,
        href: "/jira/ops/overview",
        menuId: (0, $5IkoH.MENU_ID_OPS_OVERVIEW),
        onClick: onClickOverview
    }, homeMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        menuId: (0, $5IkoH.MENU_ID_OPS_ALERTS)
    }, alertsChildren), (0, $2700E.expVal)('changes-and-incidents-under-operations', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        menuId: (0, $5IkoH.MENU_ID_OPS_CHANGES)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-operations-changes",
        onClick: onClickChanges,
        elemBefore: changesIcon,
        href: "/jira/ops/changes",
        isSelected: isChangesRoute,
        testId: (0, $jzXAj.getTestId)((0, $5IkoH.MENU_ID_OPS_CHANGES))
    }, changesMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iP4dn.ChangesContent), null)), (0, $2700E.expVal)('changes-and-incidents-under-operations', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        menuId: (0, $5IkoH.MENU_ID_OPS_INCIDENTS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-operations-incidents",
        onClick: onClickIncidents,
        elemBefore: incidentsIcon,
        href: "/jira/ops/incidents",
        isSelected: isIncidentsRoute,
        testId: (0, $jzXAj.getTestId)((0, $5IkoH.MENU_ID_OPS_INCIDENTS))
    }, incidentsMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eC98G.IncidentsContent), null)), (0, $i860n.fg)('service-list-sidebar-item') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: servicesIcon,
        href: "/jira/ops/services",
        menuId: (0, $5IkoH.MENU_ID_OPS_SERVICES),
        onClick: onClickServices
    }, servicesMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: oncallSchedulesIcon,
        href: "/jira/ops/who-is-on-call",
        menuId: (0, $5IkoH.MENU_ID_OPS_ON_CALL),
        onClick: onClickOnCallSchedules
    }, oncallSchedulesMessage), showStatuspageMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: statusPageIcon,
        ...isStatusPageDraftOnly ? {
            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Pip6))), {
                label: "",
                color: "var(--ds-icon-accent-purple, #AF59E1)",
                spacing: "none",
                testId: "sidebar-nav4-sidebars-content-operations.ui.operations-expandable-menu-item.premium-diamond"
            })
        } : {},
        href: "/jira/communications/status-page",
        menuId: (0, $5IkoH.MENU_ID_OPS_STATUS_PAGES),
        onClick: onClickStatusPages
    }, (0, $i860n.fg)('communications_status_page_manage_spotlight') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        id: "statuspage-navigation-spotlight-target"
    }, statusPageMessage) : statusPageMessage), showCommunicationsMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: communicationsIcon,
        href: COMMUNICATIONS_STAKEHOLDERS_HREF,
        menuId: (0, $5IkoH.MENU_ID_COMMUNICATIONS_STAKEHOLDERS)
    }, communicationsMessage), hasReports && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: reportsIcon,
        href: "/jira/ops/reports",
        menuId: (0, $5IkoH.MENU_ID_OPS_REPORTS),
        onClick: onClickReports
    }, (0, $i860n.fg)('platform_avp_jira_ops_reporting') ? formatMessage($81b6d5a91ffb4286$var$operationsMessages.reportsLegacy) : reportsMessage), isOperationReportsEnabled && (0, $i860n.fg)('platform_avp_jira_ops_reporting') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: reportsNewIcon,
        href: "/jira/ops/reports-new",
        menuId: (0, $5IkoH.MENU_ID_OPS_REPORTS_NEW),
        onClick: onClickReportsNew,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
            appearance: "discovery"
        }, formatMessage($81b6d5a91ffb4286$var$operationsMessages.reportsNewBadge))
    }, reportsNewMessage)));
}
$81b6d5a91ffb4286$var$OperationsExpandableMenuItemNav4.displayName = "OperationsExpandableMenuItemNav4";

});
parcelRegister("cqFwm", function(module, exports) {
$parcel$export(module.exports, "eocChangesRoute", () => $c0fd9628bf566327$export$57223732bd0f219);
const $c0fd9628bf566327$export$57223732bd0f219 = {
    name: 'eoc-changes',
    path: '/jira/ops/changes',
    exact: true
};

});

parcelRegister("krnGE", function(module, exports) {
$parcel$export(module.exports, "eocIncidentsRoute", () => $1d761ceaa13b9cde$export$90099e3647cc6f65);
const $1d761ceaa13b9cde$export$90099e3647cc6f65 = {
    name: 'eoc-incidents',
    path: '/jira/ops/incidents',
    exact: true
};

});

parcelRegister("223zC", function(module, exports) {
$parcel$export(module.exports, "eocGlobalAlertListRoute", () => $ebfd48a396613cf9$export$29721341dde2ed3d);
const $ebfd48a396613cf9$export$29721341dde2ed3d = {
    name: 'eoc-global-alerts',
    path: '/jira/ops/alerts',
    exact: true
};

});

parcelRegister("f4N10", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertDetailRoute", () => $21622db4a730ed2e$export$ac102dc13a0f4aff);
const $21622db4a730ed2e$export$ac102dc13a0f4aff = {
    name: 'eoc-team-alert-detail',
    path: '/jira/ops/teams/:teamId/alerts/:id',
    exact: true
};

});

parcelRegister("e8fyN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::99f06dcd028cae5d89da508f21f7cf88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a49de201a7d8bbe7$var$_react = $a49de201a7d8bbe7$var$_interopRequireDefault((parcelRequire("euxye")));

var $a49de201a7d8bbe7$var$_baseNew = $a49de201a7d8bbe7$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $a49de201a7d8bbe7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Service".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/service
 * Usage guidance:
 * Reserved for roadmaps service.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a49de201a7d8bbe7$var$ServiceIcon = (props)=>/*#__PURE__*/ $a49de201a7d8bbe7$var$_react.default.createElement($a49de201a7d8bbe7$var$_baseNew.default, Object.assign({
        name: "ServiceIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 12.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m0-9.5a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.5 0a2.75 2.75 0 0 1-5.394.75H8.74c-.371 0-.719.183-.928.49L5.408 8l2.403 3.51c.21.307.557.49.928.49h1.867a2.749 2.749 0 0 1 5.394.75 2.75 2.75 0 0 1-5.394.75H8.74a2.63 2.63 0 0 1-2.167-1.143L4.104 8.75H0v-1.5h4.104l2.468-3.607A2.63 2.63 0 0 1 8.74 2.5h1.867A2.749 2.749 0 0 1 16 3.25"/>`
    }, props));
$a49de201a7d8bbe7$var$ServiceIcon.displayName = 'ServiceIcon';
var $a49de201a7d8bbe7$var$_default = module.exports.default = $a49de201a7d8bbe7$var$ServiceIcon;

});

parcelRegister("eD6MF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f95a338da93454f590a06141dce3364b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02bfa509c2db6617$var$_react = $02bfa509c2db6617$var$_interopRequireDefault((parcelRequire("euxye")));

var $02bfa509c2db6617$var$_baseNew = $02bfa509c2db6617$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $02bfa509c2db6617$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Phone".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/phone
 * Usage guidance:
 * Multi purpose - Known uses: call us, phone number input.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02bfa509c2db6617$var$PhoneIcon = (props)=>/*#__PURE__*/ $02bfa509c2db6617$var$_react.default.createElement($02bfa509c2db6617$var$_baseNew.default, Object.assign({
        name: "PhoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L4.29 7.86c.975 1.55 2.3 2.875 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 1 1.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM3.56 6.516 5.27 5.09a.25.25 0 0 0 .08-.261L4.684 2.5H2.525A11.4 11.4 0 0 0 3.56 6.516" clip-rule="evenodd"/>`
    }, props));
$02bfa509c2db6617$var$PhoneIcon.displayName = 'PhoneIcon';
var $02bfa509c2db6617$var$_default = module.exports.default = $02bfa509c2db6617$var$PhoneIcon;

});

parcelRegister("jYG4S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3db83228322d23ded0024258be55e9e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8b442aa56ed6bf9$var$_react = $e8b442aa56ed6bf9$var$_interopRequireDefault((parcelRequire("euxye")));

var $e8b442aa56ed6bf9$var$_baseNew = $e8b442aa56ed6bf9$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $e8b442aa56ed6bf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/incident
 * Usage guidance:
 * Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e8b442aa56ed6bf9$var$IncidentIcon = (props)=>/*#__PURE__*/ $e8b442aa56ed6bf9$var$_react.default.createElement($e8b442aa56ed6bf9$var$_baseNew.default, Object.assign({
        name: "IncidentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$e8b442aa56ed6bf9$var$IncidentIcon.displayName = 'IncidentIcon';
var $e8b442aa56ed6bf9$var$_default = module.exports.default = $e8b442aa56ed6bf9$var$IncidentIcon;

});

parcelRegister("5rdPH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3d8a1ea0fa8d5b6548c4fb416043d1d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f5a344ee4548910$var$_react = $3f5a344ee4548910$var$_interopRequireDefault((parcelRequire("euxye")));

var $3f5a344ee4548910$var$_baseNew = $3f5a344ee4548910$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $3f5a344ee4548910$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/comment
 * Usage guidance:
 * Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f5a344ee4548910$var$CommentIcon = (props)=>/*#__PURE__*/ $3f5a344ee4548910$var$_react.default.createElement($3f5a344ee4548910$var$_baseNew.default, Object.assign({
        name: "CommentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$3f5a344ee4548910$var$CommentIcon.displayName = 'CommentIcon';
var $3f5a344ee4548910$var$_default = module.exports.default = $3f5a344ee4548910$var$CommentIcon;

});

parcelRegister("kmVc3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6cecb0468a39a738c91a80df6c1f60cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed423a22463e4822$var$_react = $ed423a22463e4822$var$_interopRequireDefault((parcelRequire("euxye")));

var $ed423a22463e4822$var$_baseNew = $ed423a22463e4822$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $ed423a22463e4822$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pulse".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/pulse
 * Usage guidance:
 * Single purpose - Known uses: work health in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed423a22463e4822$var$PulseIcon = (props)=>/*#__PURE__*/ $ed423a22463e4822$var$_react.default.createElement($ed423a22463e4822$var$_baseNew.default, Object.assign({
        name: "PulseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 1a.75.75 0 0 1 .722.548l2.778 9.92 1.028-3.67a.75.75 0 0 1 .722-.548H16v1.5h-3.931l-1.597 5.702a.75.75 0 0 1-1.444 0L6.25 4.532l-1.028 3.67a.75.75 0 0 1-.722.548H0v-1.5h3.931l1.597-5.702A.75.75 0 0 1 6.25 1" clip-rule="evenodd"/>`
    }, props));
$ed423a22463e4822$var$PulseIcon.displayName = 'PulseIcon';
var $ed423a22463e4822$var$_default = module.exports.default = $ed423a22463e4822$var$PulseIcon;

});

parcelRegister("apw2M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c700a4b4555247cec194f8cfd22350e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79451869d8542c24$var$_react = $79451869d8542c24$var$_interopRequireDefault((parcelRequire("euxye")));

var $79451869d8542c24$var$_baseNew = $79451869d8542c24$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $79451869d8542c24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Alert".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/alert
 * Usage guidance:
 * Single purpose - Reserved for alerts in JSM and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $79451869d8542c24$var$AlertIcon = (props)=>/*#__PURE__*/ $79451869d8542c24$var$_react.default.createElement($79451869d8542c24$var$_baseNew.default, Object.assign({
        name: "AlertIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 0v3h-1.5V0zM2.123 1.063 4.172 3.11 3.11 4.17 1.063 2.124zm12.814 1.06L12.89 4.172 11.83 3.11l2.047-2.048zM4.195 5.875A1.5 1.5 0 0 1 5.69 4.5h4.62a1.5 1.5 0 0 1 1.495 1.375l.635 7.625H14V15H2v-1.5h1.56zm.87 7.625h5.87L10.31 6H5.69z" clip-rule="evenodd"/>`
    }, props));
$79451869d8542c24$var$AlertIcon.displayName = 'AlertIcon';
var $79451869d8542c24$var$_default = module.exports.default = $79451869d8542c24$var$AlertIcon;

});

parcelRegister("dxrRh", function(module, exports) {
$parcel$export(module.exports, "useFeatures", () => $7639f7b0c8fec916$export$4a39035bacc4ed76);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eiIY9 = parcelRequire("eiIY9");

var $d8LhJ = parcelRequire("d8LhJ");


var $5XZMW = parcelRequire("5XZMW");

var $dSAmw = parcelRequire("dSAmw");

var $41FAq = parcelRequire("41FAq");

var $6HvWM = parcelRequire("6HvWM");

var $khV8g = parcelRequire("khV8g");

var $ccEzE = parcelRequire("ccEzE");

var $fNgVF = parcelRequire("fNgVF");

var $bs9jJ = parcelRequire("bs9jJ");

var $5rZe5 = parcelRequire("5rZe5");

var $i860n = parcelRequire("i860n");

var $eijVy = parcelRequire("eijVy");

var $lRYAe = parcelRequire("lRYAe");
const $7639f7b0c8fec916$export$4a39035bacc4ed76 = ()=>{
    const { isByokCustomer: isByokCustomer } = (0, $eiIY9.useByokComplianceSettingWithInitialisation)();
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const licensedProducts = (0, $5rZe5.useLicensedProducts)();
    const { shouldUseJSM: shouldUseJSM, loading: ogTenantInfoLoading, isOpsAdmin: isOpsAdmin } = (0, $6HvWM.useOgTenantInfo)();
    const appEditions = (0, $ccEzE.useAppEditions)();
    const { hasAccess: hasAccess, isDraftOnly: isStatusPageDraftOnly } = (0, $5XZMW.usePermissions)((0, $dSAmw.FEATURES).STATUS_PAGES);
    const { data: opsReportingConfig, loading: opsReportingConfigLoading } = (0, $khV8g.useOpsReportingConfigWithLoadOnMount)();
    const isAdminUser = isAdmin || isOpsAdmin;
    const opsReportsAdminCheck = (0, $i860n.fg)('operations_reports_not_visible_to_ops_admins') ? isAdminUser : isSiteAdmin || isAdmin;
    const hasReports = !ogTenantInfoLoading && opsReportsAdminCheck && !isByokCustomer && shouldUseJSM && !!licensedProducts[0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61] && appEditions.serviceDesk !== (0, $d8LhJ.FREE_EDITION) && ((0, $i860n.fg)('use_frontend_feature_encoding_sdk_remaining') ? (0, $41FAq.isFeatureEnabled)('jira', 'jira-oasis-reports') : !((0, $i860n.fg)('hide_reports_for_oasis') && (0, $lRYAe.isIsolatedCloud)()));
    const isOperationReportsEnabled = !opsReportingConfigLoading && Boolean(opsReportingConfig?.isOperationReportsEnabled);
    const tenantContext = (0, $eijVy.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    // Check if user has premium edition
    const isPremium = appEditions?.serviceDesk === (0, $d8LhJ.PREMIUM_EDITION);
    // Check if user has specific product license
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    const showCommunicationsMenu = isAdminUser && isPremium && isJSMUser;
    const showStatuspageMenu = hasAccess === (0, $5XZMW.PERMISSION_STATE).TRUE;
    return {
        hasReports: hasReports,
        isOperationReportsEnabled: isOperationReportsEnabled,
        showCommunicationsMenu: showCommunicationsMenu,
        showStatuspageMenu: showStatuspageMenu,
        isStatusPageDraftOnly: isStatusPageDraftOnly
    };
};

});
parcelRegister("5XZMW", function(module, exports) {
$parcel$export(module.exports, "PERMISSION_STATE", () => $78f18de2bd452780$export$13cd47aafc051bcc);
$parcel$export(module.exports, "usePermissions", () => $78f18de2bd452780$export$dde803638a7db51f);
// eslint-disable-next-line jira/filename-case

var $fNgVF = parcelRequire("fNgVF");

var $i860n = parcelRequire("i860n");

var $dSAmw = parcelRequire("dSAmw");

var $kkaec = parcelRequire("kkaec");
const $78f18de2bd452780$export$13cd47aafc051bcc = {
    LOADING: 'LOADING',
    TRUE: 'TRUE',
    FALSE: 'FALSE'
};
const $78f18de2bd452780$export$dde803638a7db51f = (featureName)=>{
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const { loading: loading, features: features } = (0, $kkaec.useCommsFeatures)();
    let hasAccess = $78f18de2bd452780$export$13cd47aafc051bcc.LOADING;
    if (loading) hasAccess = $78f18de2bd452780$export$13cd47aafc051bcc.LOADING;
    else if (features[featureName]) hasAccess = $78f18de2bd452780$export$13cd47aafc051bcc.TRUE;
    else hasAccess = $78f18de2bd452780$export$13cd47aafc051bcc.FALSE;
    const hasWriteAccess = isAdmin === true;
    const isDraftOnly = (0, $i860n.fg)('status_page_premium_exp_kill_switch') ? features[(0, $dSAmw.FEATURES).STATUS_PAGES_DRAFT_ONLY] ?? false : false;
    return {
        hasAccess: hasAccess,
        hasWriteAccess: hasWriteAccess,
        isDraftOnly: isDraftOnly
    };
};

});
parcelRegister("dSAmw", function(module, exports) {
$parcel$export(module.exports, "FEATURES", () => $19e8bf3c2d4dae2d$export$d6a5c11f04f75862);
/* eslint-disable jira/filename-case */ const $19e8bf3c2d4dae2d$export$d6a5c11f04f75862 = {
    STATUS_PAGES: 'STATUS_PAGES',
    STATUS_PAGES_DRAFT_ONLY: 'STATUS_PAGES_DRAFT_ONLY',
    STATUS_PAGES_SEND_UPDATE: 'STATUS_PAGES_SEND_UPDATE',
    SUGGEST_STAKEHOLDERS: 'SUGGEST_STAKEHOLDERS'
};

});

parcelRegister("kkaec", function(module, exports) {
$parcel$export(module.exports, "useCommsFeatures", () => $be635081122f2057$export$d1a368c9b8d9a68c);

var $kPP9E = parcelRequire("kPP9E");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $6HvWM = parcelRequire("6HvWM");

var $ccEzE = parcelRequire("ccEzE");

var $fNgVF = parcelRequire("fNgVF");

var $kt86l = parcelRequire("kt86l");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $dSAmw = parcelRequire("dSAmw");
const $be635081122f2057$export$d1a368c9b8d9a68c = ()=>{
    const relayEnvironment = (0, $n67Vb.useRelayEnvironment)();
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const { isOpsAdmin: isOpsAdmin } = (0, $6HvWM.useOgTenantInfo)();
    const appEditions = (0, $ccEzE.useAppEditions)();
    const cloudId = (0, $kt86l.useCloudId)();
    const [loading, setLoading] = (0, $euxye.useState)(false);
    const [isEnterpriseFromLicense, setIsEnterpriseFromLicense] = (0, $euxye.useState)(false);
    const isPremiumJsm = appEditions.serviceDesk === 'PREMIUM_EDITION';
    const fetchSiteTransformerData = (0, $euxye.useCallback)(async ()=>{
        try {
            setLoading(true);
            const res = await (0, $n67Vb.fetchQuery)(relayEnvironment, (0, $kPP9E.default), {
                cloudId: cloudId
            }, {
                fetchPolicy: 'store-or-network'
            }).toPromise();
            setIsEnterpriseFromLicense(res?.stakeholderComms_getStakeholderCommsTransformerRecord?.transformerRecord?.jsmProductDetail?.license === 'enterprise');
        } catch  {
        // err
        } finally{
            setLoading(false);
        }
    }, [
        relayEnvironment,
        cloudId
    ]);
    const shouldSkipApiCall = (0, $2700E.expVal)('communications_status_pages_enterprise_feature', 'value', false) || !isPremiumJsm;
    (0, $euxye.useEffect)(()=>{
        if (shouldSkipApiCall) return;
        // eslint-disable-next-line react-hooks/set-state-in-effect
        fetchSiteTransformerData();
    }, [
        shouldSkipApiCall,
        fetchSiteTransformerData
    ]);
    const isEnterprise = (0, $2700E.expVal)('communications_status_pages_enterprise_feature', 'value', false) || isEnterpriseFromLicense;
    const enterpriseStatusPages = isEnterprise && (isOpsAdmin || isAdmin) && (0, $i860n.fg)('communications_status_page_manage_platform');
    const isPremiumAdmin = appEditions.serviceDesk === 'PREMIUM_EDITION' && (isOpsAdmin || isAdmin);
    let statusPagesDraftOnly = false;
    let statusPages = enterpriseStatusPages;
    if ((0, $i860n.fg)('status_page_premium_exp_kill_switch')) {
        const isPremiumEligible = isPremiumAdmin && (0, $2700E.expVal)('communications_status_page_premium_exp_config', 'value', false);
        if (!loading && isPremiumEligible) statusPagesDraftOnly = true;
        if (!statusPages && isPremiumEligible) statusPages = true;
    }
    return {
        loading: shouldSkipApiCall ? false : loading,
        features: {
            [(0, $dSAmw.FEATURES).STATUS_PAGES_DRAFT_ONLY]: statusPagesDraftOnly,
            [(0, $dSAmw.FEATURES).STATUS_PAGES]: statusPages,
            [(0, $dSAmw.FEATURES).STATUS_PAGES_SEND_UPDATE]: isEnterprise && (0, $i860n.fg)('communications_status_page_manage_platform'),
            [(0, $dSAmw.FEATURES).SUGGEST_STAKEHOLDERS]: appEditions.serviceDesk === 'PREMIUM_EDITION'
        }
    };
};

});
parcelRegister("kPP9E", function(module, exports) {
$parcel$export(module.exports, "default", () => $35f8a7e1c0dc2f4b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<625cb703df7c645bf7e3ec3aaecccfcc>>
 * @relayHash fe8226dd520c633c0bf22376318fa2b6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 054695c660b333aa47f394d904493232dfdc2ef042f8bf5b0494439fafa74ec1
const $35f8a7e1c0dc2f4b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "StakeholderCommsTransformerRecordResponse",
            "kind": "LinkedField",
            "name": "stakeholderComms_getStakeholderCommsTransformerRecord",
            "plural": false,
            "selections": [
                {
                    "concreteType": "StakeholderCommsTransformerRecord",
                    "kind": "LinkedField",
                    "name": "transformerRecord",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "StakeholderCommsJsmProductDetail",
                            "kind": "LinkedField",
                            "name": "jsmProductDetail",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "license"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCommsFeaturesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCommsFeaturesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "054695c660b333aa47f394d904493232dfdc2ef042f8bf5b0494439fafa74ec1",
            "metadata": {},
            "name": "useCommsFeaturesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$35f8a7e1c0dc2f4b$var$node.hash = "0640218939a9c850a22d200c8feade76";
var $35f8a7e1c0dc2f4b$export$2e2bcd8739ae039 = $35f8a7e1c0dc2f4b$var$node;

});



parcelRegister("khV8g", function(module, exports) {
$parcel$export(module.exports, "opsReportingConfigResource", () => $f216dd914bad7700$export$871ee4a251175e93);
$parcel$export(module.exports, "useOpsReportingConfig", () => $f216dd914bad7700$export$6fb76aee0f098e94);
$parcel$export(module.exports, "useOpsReportingConfigWithLoadOnMount", () => $f216dd914bad7700$export$df10749f80604d28);

var $euxye = parcelRequire("euxye");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $h2wCv = parcelRequire("h2wCv");

var $i860n = parcelRequire("i860n");
const $f216dd914bad7700$export$c54eca5c711effcc = 'OPS_REPORTING_CONFIG';
const $f216dd914bad7700$export$871ee4a251175e93 = (0, $7edbf.createResource)({
    type: $f216dd914bad7700$export$c54eca5c711effcc,
    getKey: ()=>$f216dd914bad7700$export$c54eca5c711effcc,
    getData: async (_, { tenantContext: { activationId: workspaceId } })=>{
        if (!(0, $i860n.fg)('platform_avp_jira_ops_reporting')) return {
            isOperationReportsEnabled: false
        };
        const url = typeof window === 'undefined' ? '/api/v1/config' : `/gateway/api/jsm/reporting/opsgenie/workspace/${workspaceId}/config`;
        return (0, $h2wCv.performGetRequest)(url, {
            headers: {
                'x-ssr-service-name': 'jsm-reporting',
                'atl-workspaceid': workspaceId,
                'atl-workspacetype': 'opsgenie'
            }
        });
    },
    maxAge: 86400000
});
const $f216dd914bad7700$export$6fb76aee0f098e94 = ()=>(0, $k6ufm.useResource)($f216dd914bad7700$export$871ee4a251175e93);
const $f216dd914bad7700$export$df10749f80604d28 = ()=>{
    const resource = (0, $k6ufm.useResource)($f216dd914bad7700$export$871ee4a251175e93);
    const { data: data, loading: loading, error: error, refresh: refresh } = resource;
    (0, $euxye.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return resource;
};

});


parcelRegister("iP4dn", function(module, exports) {
$parcel$export(module.exports, "ChangesContent", () => $e75fa6361cc94f51$export$7752d5335c667b54);

var $euxye = parcelRequire("euxye");

var $4VtOS = parcelRequire("4VtOS");

var $aQCoC = parcelRequire("aQCoC");

var $jzXAj = parcelRequire("jzXAj");

var $KL7Bq = parcelRequire("KL7Bq");

var $1xxzH = parcelRequire("1xxzH");

var $5IkoH = parcelRequire("5IkoH");

var $OFy3z = parcelRequire("OFy3z");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $3Ga7I = parcelRequire("3Ga7I");
const $e75fa6361cc94f51$var$changesMenuMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.changes",
    defaultMessage: "Changes"
});
const $e75fa6361cc94f51$var$changesDefaultFiltersMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.default-filters",
    defaultMessage: "Default filters"
});
const $e75fa6361cc94f51$export$7752d5335c667b54 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { icon: pagesIcon } = (0, $KL7Bq.useFormattedMessageAndIcon)($e75fa6361cc94f51$var$changesMenuMessage, (0, (/*@__PURE__*/$parcel$interopDefault($OFy3z))));
    const defaultFiltersMenuId = (0, $1xxzH.toMenuIdFromMenuIdList)((0, $3Ga7I.default).map(({ changeSearchQuery: changeSearchQuery })=>(0, $5IkoH.ENTITY_ID).CHANGE(changeSearchQuery)));
    const onExpandDefaultFilters = (0, $euxye.useCallback)((isExpanded)=>{
        if (isExpanded) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'opsChangesDefaultFilters',
            attributes: {
                itemId: 'changesDefaultFilters'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickFilter = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'opsChangesFilter',
            attributes: {
                itemId: 'changesFilter'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        menuId: defaultFiltersMenuId,
        onExpansionToggle: onExpandDefaultFilters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-operations-changes-default-filters",
        testId: (0, $jzXAj.getTestId)(defaultFiltersMenuId)
    }, formatMessage($e75fa6361cc94f51$var$changesDefaultFiltersMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, (0, $3Ga7I.default).map((filter)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
            key: filter.id,
            menuId: (0, $5IkoH.ENTITY_ID).CHANGE(filter.changeSearchQuery),
            href: `/jira/ops/changes?jql=${encodeURIComponent(filter.changeSearchQuery)}`,
            elemBefore: pagesIcon,
            onClick: onClickFilter
        }, formatMessage(filter.label))))));
};
$e75fa6361cc94f51$export$7752d5335c667b54.displayName = "ChangesContent";

});
parcelRegister("OFy3z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45f4d253357e101ffa297ef9c3637fd5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0984e640d7b19bfd$var$_react = $0984e640d7b19bfd$var$_interopRequireDefault((parcelRequire("euxye")));

var $0984e640d7b19bfd$var$_baseNew = $0984e640d7b19bfd$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $0984e640d7b19bfd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/pages
 * Usage guidance:
 * Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0984e640d7b19bfd$var$PagesIcon = (props)=>/*#__PURE__*/ $0984e640d7b19bfd$var$_react.default.createElement($0984e640d7b19bfd$var$_baseNew.default, Object.assign({
        name: "PagesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$0984e640d7b19bfd$var$PagesIcon.displayName = 'PagesIcon';
var $0984e640d7b19bfd$var$_default = module.exports.default = $0984e640d7b19bfd$var$PagesIcon;

});

parcelRegister("3Ga7I", function(module, exports) {
$parcel$export(module.exports, "default", () => $02a7bd27b507dec0$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $02a7bd27b507dec0$var$allChangesMessage = (0, $7eNDO.defineMessage)({
    id: "operations.changes.defaultFilters.all",
    defaultMessage: "All"
});
const $02a7bd27b507dec0$var$openChangesMessage = (0, $7eNDO.defineMessage)({
    id: "operations.changes.defaultFilters.open",
    defaultMessage: "Open"
});
const $02a7bd27b507dec0$var$closedChangesMessage = (0, $7eNDO.defineMessage)({
    id: "operations.changes.defaultFilters.closed",
    defaultMessage: "Closed"
});
const $02a7bd27b507dec0$var$defaultFilters = [
    {
        id: 'all',
        label: $02a7bd27b507dec0$var$allChangesMessage,
        changeSearchQuery: ''
    },
    {
        id: 'open',
        label: $02a7bd27b507dec0$var$openChangesMessage,
        changeSearchQuery: 'resolution = Unresolved'
    },
    {
        id: 'closed',
        label: $02a7bd27b507dec0$var$closedChangesMessage,
        changeSearchQuery: 'resolution = Done'
    }
];
var $02a7bd27b507dec0$export$2e2bcd8739ae039 = $02a7bd27b507dec0$var$defaultFilters;

});


parcelRegister("eC98G", function(module, exports) {
$parcel$export(module.exports, "IncidentsContent", () => $222e37ca415113fe$export$a473456f5f7e07f9);

var $euxye = parcelRequire("euxye");

var $4VtOS = parcelRequire("4VtOS");

var $aQCoC = parcelRequire("aQCoC");

var $jzXAj = parcelRequire("jzXAj");

var $KL7Bq = parcelRequire("KL7Bq");

var $1xxzH = parcelRequire("1xxzH");

var $5IkoH = parcelRequire("5IkoH");

var $OFy3z = parcelRequire("OFy3z");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $bQA5x = parcelRequire("bQA5x");
const $222e37ca415113fe$var$incidentsMenuMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.incidents",
    defaultMessage: "Incidents"
});
const $222e37ca415113fe$var$incidentsDefaultFiltersMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.default-filters",
    defaultMessage: "Default filters"
});
const $222e37ca415113fe$export$a473456f5f7e07f9 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { icon: pagesIcon } = (0, $KL7Bq.useFormattedMessageAndIcon)($222e37ca415113fe$var$incidentsMenuMessage, (0, (/*@__PURE__*/$parcel$interopDefault($OFy3z))));
    const defaultFiltersMenuId = (0, $1xxzH.toMenuIdFromMenuIdList)((0, $bQA5x.default).map(({ incidentSearchQuery: incidentSearchQuery })=>(0, $5IkoH.ENTITY_ID).INCIDENT(incidentSearchQuery)));
    const onExpandDefaultFilters = (0, $euxye.useCallback)((isExpanded)=>{
        if (isExpanded) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'opsIncidentsDefaultFilters',
            attributes: {
                itemId: 'incidentsDefaultFilters'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onClickFilter = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'opsIncidentsFilter',
            attributes: {
                itemId: 'incidentsFilter'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        menuId: defaultFiltersMenuId,
        onExpansionToggle: onExpandDefaultFilters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-operations-incidents-default-filters",
        testId: (0, $jzXAj.getTestId)(defaultFiltersMenuId)
    }, formatMessage($222e37ca415113fe$var$incidentsDefaultFiltersMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, (0, $bQA5x.default).map((filter)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
            key: filter.id,
            menuId: (0, $5IkoH.ENTITY_ID).INCIDENT(filter.incidentSearchQuery),
            href: `/jira/ops/incidents?jql=${encodeURIComponent(filter.incidentSearchQuery)}`,
            elemBefore: pagesIcon,
            onClick: onClickFilter
        }, formatMessage(filter.label))))));
};
$222e37ca415113fe$export$a473456f5f7e07f9.displayName = "IncidentsContent";

});
parcelRegister("bQA5x", function(module, exports) {
$parcel$export(module.exports, "default", () => $16a3b8fcb2b6b385$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $16a3b8fcb2b6b385$var$allIncidentsMessage = (0, $7eNDO.defineMessage)({
    id: "operations.incidents.defaultFilters.all",
    defaultMessage: "All"
});
const $16a3b8fcb2b6b385$var$openIncidentsMessage = (0, $7eNDO.defineMessage)({
    id: "operations.incidents.defaultFilters.open",
    defaultMessage: "Open"
});
const $16a3b8fcb2b6b385$var$majorIncidentsMessage = (0, $7eNDO.defineMessage)({
    id: "operations.incidents.defaultFilters.major",
    defaultMessage: "Major"
});
const $16a3b8fcb2b6b385$var$assignedToMeIncidentsMessage = (0, $7eNDO.defineMessage)({
    id: "operations.incidents.defaultFilters.assignedToMe",
    defaultMessage: "Assigned to me"
});
const $16a3b8fcb2b6b385$var$closedIncidentsMessage = (0, $7eNDO.defineMessage)({
    id: "operations.incidents.defaultFilters.closed",
    defaultMessage: "Closed"
});
const $16a3b8fcb2b6b385$var$defaultFilters = [
    {
        id: 'all',
        label: $16a3b8fcb2b6b385$var$allIncidentsMessage,
        incidentSearchQuery: ''
    },
    {
        id: 'open',
        label: $16a3b8fcb2b6b385$var$openIncidentsMessage,
        incidentSearchQuery: 'resolution = Unresolved'
    },
    {
        id: 'major',
        label: $16a3b8fcb2b6b385$var$majorIncidentsMessage,
        incidentSearchQuery: '"Major incident" is not EMPTY'
    },
    {
        id: 'assignedToMe',
        label: $16a3b8fcb2b6b385$var$assignedToMeIncidentsMessage,
        incidentSearchQuery: 'assignee = currentUser() AND resolution = Unresolved'
    },
    {
        id: 'closed',
        label: $16a3b8fcb2b6b385$var$closedIncidentsMessage,
        incidentSearchQuery: 'resolution = Done'
    }
];
var $16a3b8fcb2b6b385$export$2e2bcd8739ae039 = $16a3b8fcb2b6b385$var$defaultFilters;

});


parcelRegister("2dFbg", function(module, exports) {
$parcel$export(module.exports, "ActionButtons", () => $68dee677e30a7338$export$88c65d2d98aab183);
$parcel$export(module.exports, "PopoutToggleButton", () => $68dee677e30a7338$export$a9edf85e3b30c33a);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");


var $6HvWM = parcelRequire("6HvWM");





var $bOwox = parcelRequire("bOwox");

var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $2DbWL = parcelRequire("2DbWL");

var $gbTMi = parcelRequire("gbTMi");

var $hwodR = parcelRequire("hwodR");

var $m9iwH = parcelRequire("m9iwH");

var $hZDXn = parcelRequire("hZDXn");

var $g36LP = parcelRequire("g36LP");

var $cSR11 = parcelRequire("cSR11");

var $gBaKj = parcelRequire("gBaKj");

var $f2wVS = parcelRequire("f2wVS");

var $eijVy = parcelRequire("eijVy");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $2W90l = parcelRequire("2W90l");

var $2sxBx = parcelRequire("2sxBx");
const $68dee677e30a7338$var$generalConfiguration = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.general-configuration",
    defaultMessage: "General configuration"
});
const $68dee677e30a7338$var$popOutLabel = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-out-label",
    defaultMessage: "Pop out operations alert searches"
});
const $68dee677e30a7338$var$popOutTooltip = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-out-tooltip",
    defaultMessage: "Pop out from sidebar"
});
const $68dee677e30a7338$var$popInLabel = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-in-label",
    defaultMessage: "Pop in operations alert searches"
});
const $68dee677e30a7338$var$popInTooltip = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-in-tooltip",
    defaultMessage: "Move back to sidebar"
});
const $68dee677e30a7338$var$operations = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.operations",
    defaultMessage: "Operations"
});
function $68dee677e30a7338$export$88c65d2d98aab183({ onClose: onClose }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const handleNavMenuOpen = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$b887e88d8d0739f6),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                itemId: (0, $90c0351d239ffedb$export$f06dfcec5ff912e)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
        onOpen: handleNavMenuOpen,
        MenuItems: $68dee677e30a7338$var$MoreMenuItems,
        onClose: onClose,
        name: formatMessage($68dee677e30a7338$var$operations)
    });
}
$68dee677e30a7338$export$88c65d2d98aab183.displayName = "ActionButtons";
function $68dee677e30a7338$var$MoreMenuItems({ onClose: onClose }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const onCloseWithStopPropagation = (0, $hwodR.useStopPropagation)((event)=>{
        onClose?.(event);
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$64fed82162bd367),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$17bca95234dea43b),
                level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                itemId: 'generalConfiguration',
                parentItemId: (0, $bOwox.SECTION_ITEM_OPERATIONS)
            }
        });
    });
    const tenantContext = (0, $eijVy.useTenantContext)();
    const { isOpsAdmin: isOpsAdmin } = (0, $6HvWM.useOgTenantInfo)();
    const shouldShowGeneralConfiguration = (tenantContext.isAdmin || isOpsAdmin) && tenantContext.licensedProducts[0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, shouldShowGeneralConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cSR11.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gBaKj))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)"
        }),
        href: "/jira/settings/products/ops/jira-service-management-audit-logs",
        onClick: onCloseWithStopPropagation
    }, formatMessage($68dee677e30a7338$var$generalConfiguration))) : null, !(0, $i860n.fg)('navx-global-side-nav') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2DbWL.HideL1MenuItemSection), {
        menuId: (0, $6GljB.L1_MENU_ID).OPERATIONS,
        hasSeparator: shouldShowGeneralConfiguration
    }));
}
$68dee677e30a7338$var$MoreMenuItems.displayName = "MoreMenuItems";
const $68dee677e30a7338$var$usePath = (0, $f2wVS.createRouterSelector)((state)=>`${state.location.pathname}${state.location.search}`);
const $68dee677e30a7338$export$a9edf85e3b30c33a = ({ onClick: onClick })=>{
    const { state: { lastVisitedSearch: lastVisitedSearch }, togglePoppedOut: togglePoppedOut } = (0, $2sxBx.useAlertsPopoutStore)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const path = $68dee677e30a7338$var$usePath();
    const handleToggle = (_, analyticsEvent)=>{
        onClick?.();
        togglePoppedOut(path);
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'jsmOperationsAlertsPopoutButtonToggle', {
            isPoppedOut: lastVisitedSearch
        });
    };
    const iconButtonLabel = lastVisitedSearch ? formatMessage($68dee677e30a7338$var$popInLabel) : formatMessage($68dee677e30a7338$var$popOutLabel);
    const tooltipContent = lastVisitedSearch ? formatMessage($68dee677e30a7338$var$popInTooltip) : formatMessage($68dee677e30a7338$var$popOutTooltip);
    const Icon = lastVisitedSearch ? (0, $2W90l.PopinIcon) : (0, $2W90l.PopoutIcon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        content: tooltipContent
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
            ...tooltipProps,
            label: iconButtonLabel,
            onClick: handleToggle,
            icon: Icon,
            spacing: "compact",
            appearance: "subtle"
        }));
};
$68dee677e30a7338$export$a9edf85e3b30c33a.displayName = "PopoutToggleButton";

});
parcelRegister("2W90l", function(module, exports) {
$parcel$export(module.exports, "PopoutIcon", () => $5afee97c6af13276$export$a837275bb5fcc92e);
$parcel$export(module.exports, "PopinIcon", () => $5afee97c6af13276$export$5b106f296c88ef0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $b3BBX = parcelRequire("b3BBX");

var $dmdBV = parcelRequire("dmdBV");
const $5afee97c6af13276$export$a837275bb5fcc92e = (0, (/*@__PURE__*/$parcel$interopDefault($b3BBX)));
const $5afee97c6af13276$export$5b106f296c88ef0 = (0, (/*@__PURE__*/$parcel$interopDefault($dmdBV)));

});
parcelRegister("b3BBX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::120a58a5c519b69860ff0e469a1aa022>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80cd264f8d216df5$var$_react = $80cd264f8d216df5$var$_interopRequireDefault((parcelRequire("euxye")));

var $80cd264f8d216df5$var$_baseNew = $80cd264f8d216df5$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $80cd264f8d216df5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QueuePopOut".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/queue-pop-out
 * Usage guidance:
 * Reserved for JSM queue navigation to pop out from sidebar
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $80cd264f8d216df5$var$QueuePopOutIcon = (props)=>/*#__PURE__*/ $80cd264f8d216df5$var$_react.default.createElement($80cd264f8d216df5$var$_baseNew.default, Object.assign({
        name: "QueuePopOutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2h8.5a2 2 0 0 0 2-2V8H12v5a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4.5A.5.5 0 0 1 3 4h5V2.5z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M15 6V1.75a.75.75 0 0 0-.75-.75H10v1.5h2.44L8.97 5.97l1.06 1.06 3.47-3.47V6zM7.5 9v5.25H9V9a2 2 0 0 0-2-2H1.75v1.5H7a.5.5 0 0 1 .5.5" clip-rule="evenodd"/>`
    }, props));
$80cd264f8d216df5$var$QueuePopOutIcon.displayName = 'QueuePopOutIcon';
var $80cd264f8d216df5$var$_default = module.exports.default = $80cd264f8d216df5$var$QueuePopOutIcon;

});

parcelRegister("dmdBV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dd9a568c707f2848c8422a8fb4dd8738>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b97e33bc1a31705$var$_react = $9b97e33bc1a31705$var$_interopRequireDefault((parcelRequire("euxye")));

var $9b97e33bc1a31705$var$_baseNew = $9b97e33bc1a31705$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $9b97e33bc1a31705$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QueuePopIn".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/queue-pop-in
 * Usage guidance:
 * Reserved for JSM queue navigation to move back to sidebar
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b97e33bc1a31705$var$QueuePopInIcon = (props)=>/*#__PURE__*/ $9b97e33bc1a31705$var$_react.default.createElement($9b97e33bc1a31705$var$_baseNew.default, Object.assign({
        name: "QueuePopInIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2h8.5a2 2 0 0 0 2-2v-2.75H12V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4.5A.5.5 0 0 1 3 4h3V2.5z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M6 8.94V6.5H4.5v4.25a.75.75 0 0 0 .75.75H9.5V10H7.06l2.22-2.22-1.06-1.06z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M14 8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2zm.5-2a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5z" clip-rule="evenodd"/>`
    }, props));
$9b97e33bc1a31705$var$QueuePopInIcon.displayName = 'QueuePopInIcon';
var $9b97e33bc1a31705$var$_default = module.exports.default = $9b97e33bc1a31705$var$QueuePopInIcon;

});


parcelRegister("2sxBx", function(module, exports) {
$parcel$export(module.exports, "AlertsPopoutStoreContainer", () => $3f3a3553d9a55f72$export$c37792f744809959);
$parcel$export(module.exports, "useAlertsPopoutStore", () => $3f3a3553d9a55f72$export$f89494880a713101);

var $iXN50 = parcelRequire("iXN50");

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $3f3a3553d9a55f72$var$LOCAL_STORAGE_KEY_LAST_VISITED_SEARCH = 'jira-ops-alert-filters-last-visited-search';
const $3f3a3553d9a55f72$var$localStorageProvider = (0, $iXN50.createLocalStorageProvider)('alert_filters_popout');
const $3f3a3553d9a55f72$var$setAlertFiltersLastVisitedInLocalStorage = (value)=>{
    try {
        // @browser-storage setter
        $3f3a3553d9a55f72$var$localStorageProvider.set($3f3a3553d9a55f72$var$LOCAL_STORAGE_KEY_LAST_VISITED_SEARCH, value);
    } catch (_) {
        return false;
    }
    return true;
};
const $3f3a3553d9a55f72$var$getAlertFiltersLastVisitedFromLocalStorage = ()=>{
    let item;
    try {
        item = $3f3a3553d9a55f72$var$localStorageProvider.get($3f3a3553d9a55f72$var$LOCAL_STORAGE_KEY_LAST_VISITED_SEARCH);
    } catch (_) {
        return undefined;
    }
    return item;
};
const $3f3a3553d9a55f72$var$getOnInit = ()=>{
    return {
        lastVisitedSearch: $3f3a3553d9a55f72$var$getAlertFiltersLastVisitedFromLocalStorage()
    };
};
const $3f3a3553d9a55f72$var$actions = {
    setLastVisitedSearch: (value)=>({ getState: getState, setState: setState })=>{
            if (getState().lastVisitedSearch) {
                setState({
                    ...getState(),
                    lastVisitedSearch: value
                });
                $3f3a3553d9a55f72$var$setAlertFiltersLastVisitedInLocalStorage(value);
            }
        },
    togglePoppedOut: (value)=>({ getState: getState, setState: setState })=>{
            if (!getState().lastVisitedSearch) {
                setState({
                    ...getState(),
                    lastVisitedSearch: value
                });
                $3f3a3553d9a55f72$var$setAlertFiltersLastVisitedInLocalStorage(value);
            } else {
                setState({
                    ...getState(),
                    lastVisitedSearch: null
                });
                $3f3a3553d9a55f72$var$setAlertFiltersLastVisitedInLocalStorage(null);
            }
        },
    syncLastVisitedSearch: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                lastVisitedSearch: $3f3a3553d9a55f72$var$getAlertFiltersLastVisitedFromLocalStorage()
            });
        },
    setContent: (content)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                content: content
            });
        }
};
const $3f3a3553d9a55f72$var$Store = (0, $5QDqc.createStore)({
    initialState: {
        content: null,
        lastVisitedSearch: ' '
    },
    actions: $3f3a3553d9a55f72$var$actions,
    name: 'AlertsPopoutStore'
});
const $3f3a3553d9a55f72$export$c37792f744809959 = (0, $dB6ay.createContainer)($3f3a3553d9a55f72$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState($3f3a3553d9a55f72$var$getOnInit());
        }
});
const $3f3a3553d9a55f72$var$useHook = (0, $3h1FP.createHook)($3f3a3553d9a55f72$var$Store);
const $3f3a3553d9a55f72$export$f89494880a713101 = ()=>{
    const [state, hookActions] = $3f3a3553d9a55f72$var$useHook();
    return {
        state: state,
        ...hookActions
    };
};

});




parcelRegister("coWZk", function(module, exports) {
$parcel$export(module.exports, "OperationsMenuForLanding", () => $cdfd76ae3dce315d$export$b37dd5cf3b893940);

var $gitA6 = parcelRequire("gitA6");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $gDdYI = parcelRequire("gDdYI");

var $a3z0u = parcelRequire("a3z0u");

var $d4scW = parcelRequire("d4scW");

var $j4Fdk = parcelRequire("j4Fdk");

var $2sxBx = parcelRequire("2sxBx");
const $cdfd76ae3dce315d$export$b37dd5cf3b893940 = (props)=>{
    const { isExpanded: isExpanded, queryRef: queryRef, ...dndProps } = props;
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $gitA6.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    const { state: { lastVisitedSearch: lastVisitedSearch }, setContent: setContent } = (0, $2sxBx.useAlertsPopoutStore)();
    (0, $euxye.useEffect)(()=>{
        if (lastVisitedSearch) setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a3z0u.AlertsMenuItemContent), {
            queryRef: data
        }));
    }, [
        data,
        lastVisitedSearch,
        setContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-operations-trigger-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d4scW.OperationsExpandableMenuItem), {
        AlertsMenuItemContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
            name: "nav4-sidebar-operations-expanded-items"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j4Fdk.AlertsMenuItemContentNew), {
            queryRef: data
        })),
        isExpanded: isExpanded,
        ...dndProps
    }));
};
$cdfd76ae3dce315d$export$b37dd5cf3b893940.displayName = "OperationsMenuForLanding";

});
parcelRegister("gitA6", function(module, exports) {
$parcel$export(module.exports, "default", () => $4485b85558a7ebf8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<370ea781cea76156ba88d7a84645c247>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4485b85558a7ebf8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "OperationsMenuForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "AlertsMenuItemContentNew"
        },
        {
            "kind": "FragmentSpread",
            "name": "AlertsMenuItemContent"
        }
    ],
    "type": "Query"
};
$4485b85558a7ebf8$var$node.hash = "539a9dffb7945e99bc6a650607eca8e4";
var $4485b85558a7ebf8$export$2e2bcd8739ae039 = $4485b85558a7ebf8$var$node;

});

parcelRegister("a3z0u", function(module, exports) {
$parcel$export(module.exports, "AlertsMenuItemContent", () => $44306f6e350a603d$export$fcbb0679bb6c6da1);

var $87f0z = parcelRequire("87f0z");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");




var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $1xxzH = parcelRequire("1xxzH");

var $19zz3 = parcelRequire("19zz3");

var $4VtOS = parcelRequire("4VtOS");

var $aQCoC = parcelRequire("aQCoC");

var $jzXAj = parcelRequire("jzXAj");

var $KL7Bq = parcelRequire("KL7Bq");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $OFy3z = parcelRequire("OFy3z");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $9fOfL = parcelRequire("9fOfL");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $3GN2r = parcelRequire("3GN2r");

var $gDdYI = parcelRequire("gDdYI");

var $2ffUK = parcelRequire("2ffUK");

var $1Pd0K = parcelRequire("1Pd0K");

var $2sxBx = parcelRequire("2sxBx");

var $gfy2D = parcelRequire("gfy2D");

var $bdriB = parcelRequire("bdriB");
const $44306f6e350a603d$var$allSearchMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.all-search",
    defaultMessage: "All"
});
const $44306f6e350a603d$var$openSearchMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.open-search",
    defaultMessage: "Open"
});
const $44306f6e350a603d$var$closedSearchMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.closed-search",
    defaultMessage: "Closed"
});
const $44306f6e350a603d$var$unackedSearchMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.unacked-search",
    defaultMessage: "Unacknowledged"
});
const $44306f6e350a603d$var$notSeenSearchMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.not-seen-search",
    defaultMessage: "Not seen"
});
const $44306f6e350a603d$var$assignedToMeSearchMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.assigned-to-me-search",
    defaultMessage: "Assigned to me"
});
const $44306f6e350a603d$var$defaultFiltersMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.default-filters",
    defaultMessage: "Default filters"
});
const $44306f6e350a603d$var$sharedWithMeMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.shared-with-me",
    defaultMessage: "Shared with me"
});
const $44306f6e350a603d$var$createdByMeMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.created-by-me",
    defaultMessage: "Created by me"
});
// const starredMessage = defineMessage({
// 	id: 'navigation-apps-sidebar-nav4-sidebars-content-operations.starred',
// 	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
// 	defaultMessage: 'Starred',
// 	description:
// 		'Menu item label displayed in the operations sidebar. When clicked, shows only alerts that the user has marked as favorites.',
// });
// const allAlertsMessage = defineMessage({
// 	id: 'navigation-apps-sidebar-nav4-sidebars-content-operations.all-alerts',
// 	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
// 	defaultMessage: 'All alerts',
// 	description:
// 		'Link label displayed in the operations sidebar navigation. When clicked, shows the complete list of alerts without any filters applied.',
// });
// const myAlertsMessage = defineMessage({
// 	id: 'navigation-apps-sidebar-nav4-sidebars-content-operations.my-alerts',
// 	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
// 	defaultMessage: 'My alerts',
// 	description: 'The label of alerts that assigned to me link',
// });
const $44306f6e350a603d$var$alertsMessageDefinition = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-operations.alerts",
    defaultMessage: "Alerts"
});
function $44306f6e350a603d$export$fcbb0679bb6c6da1({ queryRef: queryRef }) {
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $87f0z.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    const [selectedFilter, setSelectedFilter] = (0, $euxye.useState)('');
    const { isSelectedPath: isSelectedPath } = (0, $19zz3.useSidebarNav4)();
    const { sharedWithMe: sharedWithMe, createdByMe: createdByMe, starred: starred } = data?.opsgenie?.savedSearches || {};
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const accountId = (0, $3GN2r.useAccountId)();
    const [savedSearchIdFromURL] = (0, $2ffUK.useQueryParam)('filter');
    const [viewType] = (0, $2ffUK.useQueryParam)('view');
    const { icon: pagesIcon } = (0, $KL7Bq.useFormattedMessageAndIcon)($44306f6e350a603d$var$alertsMessageDefinition, (0, (/*@__PURE__*/$parcel$interopDefault($OFy3z))));
    const { setLastVisitedSearch: setLastVisitedSearch } = (0, $2sxBx.useAlertsPopoutStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const defaultFilters = [
        {
            id: 'all',
            name: formatMessage($44306f6e350a603d$var$allSearchMessage),
            alertSearchQuery: ''
        },
        {
            id: 'open',
            name: formatMessage($44306f6e350a603d$var$openSearchMessage),
            alertSearchQuery: `${(0, $9fOfL.IDENTIFIER_STATUS)}${(0, $9fOfL.OPERATOR_EQUAL_TO)} ${(0, $9fOfL.STRING_LITERAL_STATUS_OPEN)}`
        },
        {
            id: 'closed',
            name: formatMessage($44306f6e350a603d$var$closedSearchMessage),
            alertSearchQuery: `${(0, $9fOfL.IDENTIFIER_STATUS)}${(0, $9fOfL.OPERATOR_EQUAL_TO)} ${(0, $9fOfL.STRING_LITERAL_STATUS_CLOSED)}`
        },
        {
            id: 'unacked',
            name: formatMessage($44306f6e350a603d$var$unackedSearchMessage),
            alertSearchQuery: `${(0, $9fOfL.IDENTIFIER_STATUS)}${(0, $9fOfL.OPERATOR_EQUAL_TO)} ${(0, $9fOfL.STRING_LITERAL_STATUS_OPEN)} ${(0, $9fOfL.LOGICAL_OPERATOR_AND)} ${(0, $9fOfL.IDENTIFIER_ACKNOWLEDGED)}${(0, $9fOfL.OPERATOR_EQUAL_TO)} ${(0, $9fOfL.BOOLEAN_LITERAL_FALSE)}`
        },
        {
            id: 'notSeen',
            name: formatMessage($44306f6e350a603d$var$notSeenSearchMessage),
            alertSearchQuery: `${(0, $9fOfL.IDENTIFIER_IS_SEEN)}${(0, $9fOfL.OPERATOR_EQUAL_TO)} ${(0, $9fOfL.BOOLEAN_LITERAL_FALSE)}`
        },
        {
            id: 'assignedToMe',
            name: formatMessage($44306f6e350a603d$var$assignedToMeSearchMessage),
            alertSearchQuery: `${(0, $9fOfL.IDENTIFIER_ASSIGNEE)}${(0, $9fOfL.OPERATOR_EQUAL_TO)} "${accountId || 'me'}"`
        }
    ];
    const defaultFilterMenuIds = $44306f6e350a603d$var$getParentMenuId(defaultFilters);
    const sharedWithMeMenuIds = $44306f6e350a603d$var$getParentMenuId(sharedWithMe, savedSearchIdFromURL);
    const createdByMeMenuIds = $44306f6e350a603d$var$getParentMenuId(createdByMe, savedSearchIdFromURL);
    const starredIds = (0, $euxye.useMemo)(()=>starred?.map((item)=>item.id) ?? [], [
        starred
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isSelectedPath((0, $5IkoH.MENU_ID_OPS_ALERTS)) && selectedFilter !== '') setSelectedFilter('');
    }, [
        isSelectedPath,
        selectedFilter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4.sidebar.operations.alerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bdriB.StarSection), {
        starred: starred ?? [],
        viewType: viewType,
        savedSearchIdFromURL: savedSearchIdFromURL,
        setSelectedFilter: setSelectedFilter,
        setLastVisitedSearch: setLastVisitedSearch
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        menuId: defaultFilterMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                    level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                    itemId: 'defaultFilters',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        testId: (0, $jzXAj.getTestId)(defaultFilterMenuIds),
        interactionName: "nav4-sidebar-operations-alerts"
    }, formatMessage($44306f6e350a603d$var$defaultFiltersMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, defaultFilters.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            key: item.id,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`,
            menuId: (0, $5IkoH.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter(item.id);
                setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}${item.alertSearchQuery ? `&query=${item.alertSearchQuery}` : ''}`);
                (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                        level: (0, $ef39084c605eb7e8$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        parentItemId: 'defaultFilters',
                        itemType: 'defaultFilter'
                    }
                });
            }
        }, item.name)))), sharedWithMe && sharedWithMe.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        menuId: sharedWithMeMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                    level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                    itemId: 'sharedWithMe',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        testId: (0, $jzXAj.getTestId)(sharedWithMeMenuIds),
        interactionName: "nav4-sidebar-operations-alerts-shared-with-me"
    }, formatMessage($44306f6e350a603d$var$sharedWithMeMessage), sharedWithMe.some((filter)=>isSelectedPath(filter.alertSearchQuery))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, sharedWithMe.map((item)=>{
        const savedSearchId = item.id ? (0, $1Pd0K.OpsgenieSavedSearchAri).parse(item.id).savedSearchId : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
            key: item.id,
            elemBefore: pagesIcon,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`,
            menuId: (0, $5IkoH.ENTITY_ID).ALARM_QUEUE(savedSearchIdFromURL ? savedSearchId : item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter('');
                setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`);
                (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
                        level: (0, $ef39084c605eb7e8$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        itemType: 'savedSearch',
                        parentItemId: 'sharedWithMe'
                    }
                });
            },
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gfy2D.SavedSearchActionButtons), {
                savedSearch: item,
                isStarred: starredIds.includes(item.id),
                savedSearchType: "sharedWithMe"
            })
        }, item.name);
    }))), createdByMe && createdByMe.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        menuId: createdByMeMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                    level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                    itemId: 'createdByMe',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        testId: (0, $jzXAj.getTestId)(createdByMeMenuIds)
    }, formatMessage($44306f6e350a603d$var$createdByMeMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, createdByMe.map((item)=>{
        const savedSearchId = item.id ? (0, $1Pd0K.OpsgenieSavedSearchAri).parse(item.id).savedSearchId : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
            key: item.id,
            elemBefore: pagesIcon,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`,
            menuId: (0, $5IkoH.ENTITY_ID).ALARM_QUEUE(savedSearchIdFromURL ? savedSearchId : item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter('');
                setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`);
                (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
                        level: (0, $ef39084c605eb7e8$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        itemType: 'savedSearch',
                        parentItemId: 'createdByMe'
                    }
                });
            },
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gfy2D.SavedSearchActionButtons), {
                savedSearch: item,
                isStarred: starredIds.includes(item.id),
                savedSearchType: "createdByMe"
            })
        }, item.name);
    }))));
}
$44306f6e350a603d$export$fcbb0679bb6c6da1.displayName = "AlertsMenuItemContent";
function $44306f6e350a603d$var$getParentMenuId(arr, savedSearchId) {
    return (0, $1xxzH.toMenuIdFromMenuIdList)((arr || []).map((i)=>(0, $5IkoH.ENTITY_ID).ALARM_QUEUE(savedSearchId ? (0, $1Pd0K.OpsgenieSavedSearchAri).parse(i.id).savedSearchId : i.alertSearchQuery)));
}

});
parcelRegister("87f0z", function(module, exports) {
$parcel$export(module.exports, "default", () => $f53c285e93534327$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c336c865db76b6208ffd7fc4b6b48456>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f53c285e93534327$var$node = function() {
    var v0 = [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "alertSearchQuery"
            },
            "action": "THROW"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "AlertsMenuItemContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "OpsgenieQuery",
                    "kind": "LinkedField",
                    "name": "opsgenie",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "OpsgenieSavedSearches",
                                "kind": "LinkedField",
                                "name": "savedSearches",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "starred",
                                            "plural": true,
                                            "selections": v0 /*: any*/ 
                                        },
                                        "action": "THROW"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": v0 /*: any*/ 
                                        },
                                        "action": "THROW"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": v0 /*: any*/ 
                                        },
                                        "action": "LOG"
                                    }
                                ]
                            },
                            "action": "LOG"
                        }
                    ]
                },
                "action": "LOG"
            }
        ],
        "type": "Query"
    };
}();
$f53c285e93534327$var$node.hash = "8fd09387c46253d01b80dce6b0b047b9";
var $f53c285e93534327$export$2e2bcd8739ae039 = $f53c285e93534327$var$node;

});

parcelRegister("9fOfL", function(module, exports) {
$parcel$export(module.exports, "TOKEN_TYPES", () => $af4a99e80de9a632$export$e92b897d610f2aba);
$parcel$export(module.exports, "LEFT_PARENTHESIS", () => $af4a99e80de9a632$export$9ce7f372949a1546);
$parcel$export(module.exports, "RIGHT_PARENTHESIS", () => $af4a99e80de9a632$export$bbbb3f477a9839e0);
$parcel$export(module.exports, "OPERATOR_EQUAL_TO", () => $af4a99e80de9a632$export$ea7497008076d6d2);
$parcel$export(module.exports, "OPERATOR_GROUP_FOR_ASSISTANT", () => $af4a99e80de9a632$export$e75c84803c67e1f4);
$parcel$export(module.exports, "LOGICAL_OPERATOR_AND", () => $af4a99e80de9a632$export$61308b2610174a70);
$parcel$export(module.exports, "LOGICAL_OPERATOR_OR", () => $af4a99e80de9a632$export$1de654320eb3e523);
$parcel$export(module.exports, "BOOLEAN_LITERAL_TRUE", () => $af4a99e80de9a632$export$ff7eed6ac2251302);
$parcel$export(module.exports, "BOOLEAN_LITERAL_FALSE", () => $af4a99e80de9a632$export$4b436fec6f13b741);
$parcel$export(module.exports, "BOOLEAN_LITERAL_GROUP", () => $af4a99e80de9a632$export$8cbc171ac4843075);
$parcel$export(module.exports, "STRING_LITERAL_DOUBLE_QUOTE", () => $af4a99e80de9a632$export$347c7cb6285a1d61);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_OPEN", () => $af4a99e80de9a632$export$910131ff5cd3d496);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_CLOSED", () => $af4a99e80de9a632$export$2aa0d26cb4549272);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_ACKED", () => $af4a99e80de9a632$export$572cec90aa166025);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_SNOOZED", () => $af4a99e80de9a632$export$f94109650ec67751);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_GROUP", () => $af4a99e80de9a632$export$3a3a37e9da45a2a4);
$parcel$export(module.exports, "STRING_LITERAL_PRIORITY_GROUP", () => $af4a99e80de9a632$export$9ef3f42fa10fce44);
$parcel$export(module.exports, "NULL_LITERAL", () => $af4a99e80de9a632$export$c2b6d31a7a2d40ba);
$parcel$export(module.exports, "IDENTIFIER_ALIAS", () => $af4a99e80de9a632$export$21c480ed86e9d13);
$parcel$export(module.exports, "IDENTIFIER_CLOSED_BY", () => $af4a99e80de9a632$export$534c195089710c34);
$parcel$export(module.exports, "IDENTIFIER_DEDUPLICATION", () => $af4a99e80de9a632$export$4699ad3805947d4d);
$parcel$export(module.exports, "IDENTIFIER_ENTITY", () => $af4a99e80de9a632$export$2a30b5099ba66c99);
$parcel$export(module.exports, "IDENTIFIER_IS_SEEN", () => $af4a99e80de9a632$export$7926b4c2836db847);
$parcel$export(module.exports, "IDENTIFIER_MESSAGE", () => $af4a99e80de9a632$export$5a8895646b1d5248);
$parcel$export(module.exports, "IDENTIFIER_ASSIGNEE", () => $af4a99e80de9a632$export$4047502bdab1e205);
$parcel$export(module.exports, "IDENTIFIER_PRIORITY", () => $af4a99e80de9a632$export$5922c06b76ebb57d);
$parcel$export(module.exports, "IDENTIFIER_COMPONENTS", () => $af4a99e80de9a632$export$1122634b5d555f05);
$parcel$export(module.exports, "IDENTIFIER_SERVICES", () => $af4a99e80de9a632$export$ec912454cd7d858a);
$parcel$export(module.exports, "IDENTIFIER_RESPONDERS", () => $af4a99e80de9a632$export$44673ddac1790242);
$parcel$export(module.exports, "IDENTIFIER_SOURCE", () => $af4a99e80de9a632$export$f250d53474e801dc);
$parcel$export(module.exports, "IDENTIFIER_STATUS", () => $af4a99e80de9a632$export$43181828ba8680e4);
$parcel$export(module.exports, "IDENTIFIER_TAG", () => $af4a99e80de9a632$export$8242733866920892);
$parcel$export(module.exports, "IDENTIFIER_TINY_ID", () => $af4a99e80de9a632$export$c833829cf31052f0);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED", () => $af4a99e80de9a632$export$5f1e5c89a704810f);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED_BY", () => $af4a99e80de9a632$export$89d93eb7117999c0);
$parcel$export(module.exports, "IDENTIFIER_TEAMS", () => $af4a99e80de9a632$export$a79eb1864dd7b745);
$parcel$export(module.exports, "IDENTIFIER_SNR_CLASSIFICATION", () => $af4a99e80de9a632$export$d21cb4c48fd902e9);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALERT", () => $af4a99e80de9a632$export$888a9cda49b5e18c);
$parcel$export(module.exports, "IDENTIFIER_BOOLEAN_GROUP", () => $af4a99e80de9a632$export$60745b712d37edf9);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALL", () => $af4a99e80de9a632$export$b38df7dc61d42293);
$parcel$export(module.exports, "splitToTokensRegex", () => $af4a99e80de9a632$export$28041d1d2a85f002);
$parcel$export(module.exports, "isKeywordRegex", () => $af4a99e80de9a632$export$290f3472231a2ca1);
$parcel$export(module.exports, "isModifierRegex", () => $af4a99e80de9a632$export$56079d3966b6b26c);
$parcel$export(module.exports, "isComplexOperatorRegex", () => $af4a99e80de9a632$export$3f6ac43c2355116b);
$parcel$export(module.exports, "isWSRegex", () => $af4a99e80de9a632$export$b1b0fc0dc5c83a12);
$parcel$export(module.exports, "isIdentifierRegex", () => $af4a99e80de9a632$export$218cf3eb73c65394);
$parcel$export(module.exports, "isLogicalOperatorRegex", () => $af4a99e80de9a632$export$a46484930d6fa80f);
$parcel$export(module.exports, "isOperatorRegex", () => $af4a99e80de9a632$export$d48805fc5b137dc9);
/**
 * Token types
 */ const $af4a99e80de9a632$export$e92b897d610f2aba = [
    'WHITE_SPACE',
    'SEPARATOR',
    'IDENTIFIER',
    'MODIFIER',
    'KEYWORD',
    'LOGICAL_OPERATOR',
    'STRING_LITERAL',
    'NUMBER_LITERAL',
    'BOOLEAN_LITERAL',
    'NULL_LITERAL',
    'OPERATOR'
];
const $af4a99e80de9a632$export$9ce7f372949a1546 = '(';
const $af4a99e80de9a632$export$bbbb3f477a9839e0 = ')';
const $af4a99e80de9a632$export$adbc66edc544fda9 = '=';
const $af4a99e80de9a632$export$fbd271ef020db0c = '!=';
const $af4a99e80de9a632$export$ea7497008076d6d2 = ':';
const $af4a99e80de9a632$export$6d44219c9e0c2567 = '!:';
const $af4a99e80de9a632$export$f8636d23c210043c = '<';
const $af4a99e80de9a632$export$1892bd0c818db570 = '<=';
const $af4a99e80de9a632$export$386b1ae18a32d690 = '>';
const $af4a99e80de9a632$export$44a62afa61d82568 = '>=';
const $af4a99e80de9a632$export$e75c84803c67e1f4 = [
    $af4a99e80de9a632$export$adbc66edc544fda9,
    $af4a99e80de9a632$export$f8636d23c210043c,
    $af4a99e80de9a632$export$1892bd0c818db570,
    $af4a99e80de9a632$export$386b1ae18a32d690,
    $af4a99e80de9a632$export$44a62afa61d82568
];
const $af4a99e80de9a632$export$61308b2610174a70 = 'AND';
const $af4a99e80de9a632$export$1de654320eb3e523 = 'OR';
const $af4a99e80de9a632$export$184522872a5410fc = 'not';
const $af4a99e80de9a632$export$ff7eed6ac2251302 = 'true';
const $af4a99e80de9a632$export$4b436fec6f13b741 = 'false';
const $af4a99e80de9a632$export$8cbc171ac4843075 = [
    $af4a99e80de9a632$export$ff7eed6ac2251302,
    $af4a99e80de9a632$export$4b436fec6f13b741
];
const $af4a99e80de9a632$export$347c7cb6285a1d61 = '"';
const $af4a99e80de9a632$export$d84ab70dc909b702 = "'";
const $af4a99e80de9a632$export$910131ff5cd3d496 = `${$af4a99e80de9a632$export$347c7cb6285a1d61}open${$af4a99e80de9a632$export$347c7cb6285a1d61}`;
const $af4a99e80de9a632$export$2aa0d26cb4549272 = `${$af4a99e80de9a632$export$347c7cb6285a1d61}closed${$af4a99e80de9a632$export$347c7cb6285a1d61}`;
const $af4a99e80de9a632$export$572cec90aa166025 = `${$af4a99e80de9a632$export$347c7cb6285a1d61}acknowledged${$af4a99e80de9a632$export$347c7cb6285a1d61}`;
const $af4a99e80de9a632$export$f94109650ec67751 = `${$af4a99e80de9a632$export$347c7cb6285a1d61}snoozed${$af4a99e80de9a632$export$347c7cb6285a1d61}`;
const $af4a99e80de9a632$export$3a3a37e9da45a2a4 = [
    $af4a99e80de9a632$export$910131ff5cd3d496,
    $af4a99e80de9a632$export$2aa0d26cb4549272,
    $af4a99e80de9a632$export$572cec90aa166025,
    $af4a99e80de9a632$export$f94109650ec67751
];
const $af4a99e80de9a632$export$928c1edd572e94f0 = 'P1';
const $af4a99e80de9a632$export$22202070e5f64c55 = 'P2';
const $af4a99e80de9a632$export$537865d58d2072a3 = 'P3';
const $af4a99e80de9a632$export$3d5cfea3feefee83 = 'P4';
const $af4a99e80de9a632$export$fe945cac89cd21a5 = 'P5';
const $af4a99e80de9a632$export$9ef3f42fa10fce44 = [
    $af4a99e80de9a632$export$928c1edd572e94f0,
    $af4a99e80de9a632$export$22202070e5f64c55,
    $af4a99e80de9a632$export$537865d58d2072a3,
    $af4a99e80de9a632$export$3d5cfea3feefee83,
    $af4a99e80de9a632$export$fe945cac89cd21a5
];
const $af4a99e80de9a632$export$c2b6d31a7a2d40ba = 'null';
const $af4a99e80de9a632$export$5a484b762b542c13 = 'actions';
const $af4a99e80de9a632$export$21c480ed86e9d13 = 'alias';
const $af4a99e80de9a632$export$534c195089710c34 = 'closedBy';
const $af4a99e80de9a632$export$4699ad3805947d4d = 'count';
const $af4a99e80de9a632$export$7c3401d7874d69f5 = 'createdAt';
const $af4a99e80de9a632$export$afffcbd5b444e040 = 'description';
const $af4a99e80de9a632$export$e1e61c3bf43fff11 = 'details.key';
const $af4a99e80de9a632$export$aa35da9746edbfe2 = 'details.value';
const $af4a99e80de9a632$export$b620b7163533b409 = 'detailsPair';
const $af4a99e80de9a632$export$2a30b5099ba66c99 = 'entity';
const $af4a99e80de9a632$export$2bfb49435a331d16 = 'integration.name';
const $af4a99e80de9a632$export$feced558810f4b3e = 'integration.type';
const $af4a99e80de9a632$export$7926b4c2836db847 = 'isSeen';
const $af4a99e80de9a632$export$5a8895646b1d5248 = 'message';
const $af4a99e80de9a632$export$4047502bdab1e205 = 'owner';
const $af4a99e80de9a632$export$5922c06b76ebb57d = 'priority';
const $af4a99e80de9a632$export$1122634b5d555f05 = 'components';
const $af4a99e80de9a632$export$ec912454cd7d858a = 'services';
const $af4a99e80de9a632$export$44673ddac1790242 = 'responders';
const $af4a99e80de9a632$export$f250d53474e801dc = 'source';
const $af4a99e80de9a632$export$43181828ba8680e4 = 'status';
const $af4a99e80de9a632$export$a1959e1b76e880dd = 'sync.name';
const $af4a99e80de9a632$export$8417ff61f7a57db6 = 'sync.type';
const $af4a99e80de9a632$export$8242733866920892 = 'tags';
const $af4a99e80de9a632$export$c833829cf31052f0 = 'tinyId';
const $af4a99e80de9a632$export$78d4faf48faf13c2 = 'updatedAt';
const $af4a99e80de9a632$export$5f1e5c89a704810f = 'acknowledged';
const $af4a99e80de9a632$export$89d93eb7117999c0 = 'acknowledgedBy';
const $af4a99e80de9a632$export$1ee0ad656333fc23 = 'aggregatorIds';
const $af4a99e80de9a632$export$d42da2034504d6de = 'alertId';
const $af4a99e80de9a632$export$8464a15b62fb09bb = 'alertType';
const $af4a99e80de9a632$export$2f7ba2848fc019c6 = 'encrypted';
const $af4a99e80de9a632$export$86e4b68c61c8cca5 = 'encryptionId';
const $af4a99e80de9a632$export$cd9dc7ab4d04d11c = 'lastOccurredAt';
const $af4a99e80de9a632$export$8508b76d4c14d7e = 'notify';
const $af4a99e80de9a632$export$e73ddf8d219f28b7 = 'snoozedUntil';
const $af4a99e80de9a632$export$a79eb1864dd7b745 = 'teams';
const $af4a99e80de9a632$export$d21cb4c48fd902e9 = 'snrClassification';
const $af4a99e80de9a632$export$888a9cda49b5e18c = [
    $af4a99e80de9a632$export$5f1e5c89a704810f,
    $af4a99e80de9a632$export$89d93eb7117999c0,
    $af4a99e80de9a632$export$1ee0ad656333fc23,
    $af4a99e80de9a632$export$d42da2034504d6de,
    $af4a99e80de9a632$export$8464a15b62fb09bb,
    $af4a99e80de9a632$export$2f7ba2848fc019c6,
    $af4a99e80de9a632$export$86e4b68c61c8cca5,
    $af4a99e80de9a632$export$cd9dc7ab4d04d11c,
    $af4a99e80de9a632$export$8508b76d4c14d7e,
    $af4a99e80de9a632$export$e73ddf8d219f28b7,
    $af4a99e80de9a632$export$a79eb1864dd7b745,
    $af4a99e80de9a632$export$5a484b762b542c13,
    $af4a99e80de9a632$export$21c480ed86e9d13,
    $af4a99e80de9a632$export$534c195089710c34,
    $af4a99e80de9a632$export$4699ad3805947d4d,
    $af4a99e80de9a632$export$7c3401d7874d69f5,
    $af4a99e80de9a632$export$afffcbd5b444e040,
    $af4a99e80de9a632$export$e1e61c3bf43fff11,
    $af4a99e80de9a632$export$aa35da9746edbfe2,
    $af4a99e80de9a632$export$b620b7163533b409,
    $af4a99e80de9a632$export$2a30b5099ba66c99,
    $af4a99e80de9a632$export$2bfb49435a331d16,
    $af4a99e80de9a632$export$feced558810f4b3e,
    $af4a99e80de9a632$export$7926b4c2836db847,
    $af4a99e80de9a632$export$5a8895646b1d5248,
    $af4a99e80de9a632$export$4047502bdab1e205,
    $af4a99e80de9a632$export$5922c06b76ebb57d,
    $af4a99e80de9a632$export$44673ddac1790242,
    $af4a99e80de9a632$export$1122634b5d555f05,
    $af4a99e80de9a632$export$ec912454cd7d858a,
    $af4a99e80de9a632$export$f250d53474e801dc,
    $af4a99e80de9a632$export$43181828ba8680e4,
    $af4a99e80de9a632$export$a1959e1b76e880dd,
    $af4a99e80de9a632$export$8417ff61f7a57db6,
    $af4a99e80de9a632$export$8242733866920892,
    $af4a99e80de9a632$export$c833829cf31052f0,
    $af4a99e80de9a632$export$78d4faf48faf13c2,
    $af4a99e80de9a632$export$d21cb4c48fd902e9
];
const $af4a99e80de9a632$export$60745b712d37edf9 = [
    $af4a99e80de9a632$export$5f1e5c89a704810f,
    $af4a99e80de9a632$export$7926b4c2836db847
];
const $af4a99e80de9a632$export$b38df7dc61d42293 = [
    ...$af4a99e80de9a632$export$888a9cda49b5e18c
];
/**
 * Regex definitions
 */ // The main regex to split any given query into smaller tokens.
// Please be aware that token order has a meaning here.
const $af4a99e80de9a632$var$splitToTokensCases = [
    // 1. Split single and double quotes
    ...[
        $af4a99e80de9a632$export$d84ab70dc909b702,
        $af4a99e80de9a632$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*?${i})`),
    ...[
        $af4a99e80de9a632$export$d84ab70dc909b702,
        $af4a99e80de9a632$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*)`),
    // 2. Split operators and separators
    ...[
        $af4a99e80de9a632$export$9ce7f372949a1546,
        $af4a99e80de9a632$export$bbbb3f477a9839e0,
        $af4a99e80de9a632$export$adbc66edc544fda9,
        $af4a99e80de9a632$export$fbd271ef020db0c,
        $af4a99e80de9a632$export$ea7497008076d6d2,
        $af4a99e80de9a632$export$6d44219c9e0c2567,
        $af4a99e80de9a632$export$44a62afa61d82568,
        $af4a99e80de9a632$export$386b1ae18a32d690,
        $af4a99e80de9a632$export$1892bd0c818db570,
        $af4a99e80de9a632$export$f8636d23c210043c
    ].map((i)=>`(\\${i})`),
    // 3. Split the exact keywords when it's a known literal
    // Known issue: The word boundary in the beginning does not capture letters except latin chars, digits and underscore, i.e. "+and" results to STRING_LITERAL + BOOLEAN_LITERAL
    ...[
        $af4a99e80de9a632$export$61308b2610174a70,
        $af4a99e80de9a632$export$1de654320eb3e523,
        $af4a99e80de9a632$export$ff7eed6ac2251302,
        $af4a99e80de9a632$export$4b436fec6f13b741,
        $af4a99e80de9a632$export$184522872a5410fc,
        `is\\s*null`,
        `is\\s*not\\s*null`
    ].map((i)=>`(\\b${i}(?=\\s|$))`),
    // 4. Empty spaces
    '(\\s+)'
];
const $af4a99e80de9a632$export$28041d1d2a85f002 = new RegExp($af4a99e80de9a632$var$splitToTokensCases.join('|'), 'gi');
const $af4a99e80de9a632$export$290f3472231a2ca1 = /^(is(  *)not(  *)null)$|^(is(  *)null)$/i;
const $af4a99e80de9a632$export$56079d3966b6b26c = /^not$/i;
const $af4a99e80de9a632$export$3f6ac43c2355116b = /^<=$|^>=$|^!=$|^!:$/;
const $af4a99e80de9a632$export$b1b0fc0dc5c83a12 = /^\s+$/;
const $af4a99e80de9a632$export$218cf3eb73c65394 = new RegExp($af4a99e80de9a632$export$b38df7dc61d42293.map((i)=>`^${i}$`).join('|'));
const $af4a99e80de9a632$export$a46484930d6fa80f = /^and$|^or$/i;
const $af4a99e80de9a632$export$d48805fc5b137dc9 = /^[=:<>]$/;

});

parcelRegister("1Pd0K", function(module, exports) {
$parcel$export(module.exports, "OpsgenieSavedSearchAri", () => $1544a59c4b2fb1ce$export$1dc7f741fb628a10);

var $dbYrE = parcelRequire("dbYrE");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/opsgenie/saved-search/manifest.ts
var $1544a59c4b2fb1ce$var$opsgenieSavedSearchAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $dbYrE.OpsgenieSavedSearchAriResourceOwner),
    resourceType: (0, $dbYrE.OpsgenieSavedSearchAriResourceType),
    resourceIdSlug: "{workspaceId}/{savedSearchId}",
    resourceIdSegmentFormats: {
        workspaceId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        savedSearchId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/opsgenie/saved-search/index.ts
var $1544a59c4b2fb1ce$export$1dc7f741fb628a10 = class _OpsgenieSavedSearchAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._workspaceId = opts.resourceIdSegmentValues.workspaceId, this._savedSearchId = opts.resourceIdSegmentValues.savedSearchId;
    }
    get workspaceId() {
        return this._workspaceId;
    }
    get savedSearchId() {
        return this._savedSearchId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1544a59c4b2fb1ce$var$opsgenieSavedSearchAriStaticOpts.qualifier,
            platformQualifier: $1544a59c4b2fb1ce$var$opsgenieSavedSearchAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $1544a59c4b2fb1ce$var$opsgenieSavedSearchAriStaticOpts.resourceOwner,
            resourceType: $1544a59c4b2fb1ce$var$opsgenieSavedSearchAriStaticOpts.resourceType,
            resourceId: `${opts.workspaceId}/${opts.savedSearchId}`,
            resourceIdSegmentValues: {
                workspaceId: opts.workspaceId,
                savedSearchId: opts.savedSearchId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $1544a59c4b2fb1ce$var$opsgenieSavedSearchAriStaticOpts);
        return new _OpsgenieSavedSearchAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $1544a59c4b2fb1ce$var$opsgenieSavedSearchAriStaticOpts);
        return new _OpsgenieSavedSearchAri(opts);
    }
    getVariables() {
        return {
            workspaceId: this.workspaceId,
            savedSearchId: this.savedSearchId
        };
    }
};

});
parcelRegister("dbYrE", function(module, exports) {
$parcel$export(module.exports, "OpsgenieSavedSearchAriResourceOwner", () => $99ab3091392fbb95$export$7416cc1df15f6b85);
$parcel$export(module.exports, "OpsgenieSavedSearchAriResourceType", () => $99ab3091392fbb95$export$1db52fe39936618e);
// src/opsgenie/saved-search/types.ts
var $99ab3091392fbb95$export$7416cc1df15f6b85 = "opsgenie", $99ab3091392fbb95$export$1db52fe39936618e = "saved-search";

});


parcelRegister("gfy2D", function(module, exports) {
$parcel$export(module.exports, "SavedSearchActionButtons", () => $0b431127fbd21166$export$78ee2939aff842cb);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");





var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $hwodR = parcelRequire("hwodR");

var $gbTMi = parcelRequire("gbTMi");

var $1mQ7r = parcelRequire("1mQ7r");

var $6HvWM = parcelRequire("6HvWM");

var $ceqcm = parcelRequire("ceqcm");

var $g36LP = parcelRequire("g36LP");

var $2bpNg = parcelRequire("2bpNg");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $acwzf = parcelRequire("acwzf");
var $iQPOZ = parcelRequire("iQPOZ");

var $4chZx = parcelRequire("4chZx");

var $8QyNX = parcelRequire("8QyNX");

var $2BntI = parcelRequire("2BntI");

var $1Pd0K = parcelRequire("1Pd0K");


var $kYcMD = parcelRequire("kYcMD");
const $0b431127fbd21166$var$deleteSavedSearchMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.delete-saved-search",
    defaultMessage: "Delete"
});
const $0b431127fbd21166$var$confirmTrashHeading = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.confirm-trash-heading",
    defaultMessage: "Delete saved search"
});
const $0b431127fbd21166$var$confirmTrashMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.confirm-trash-message",
    defaultMessage: "Are you sure you want to delete this saved search?"
});
const $0b431127fbd21166$var$errorTitle = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.error-title",
    defaultMessage: "Error"
});
const $0b431127fbd21166$var$errorMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.error-message",
    defaultMessage: "Something went wrong. Please try again."
});
const $0b431127fbd21166$var$deleteModalMessageDescriptors = {
    title: $0b431127fbd21166$var$confirmTrashHeading,
    description: $0b431127fbd21166$var$confirmTrashMessage
};
const $0b431127fbd21166$export$78ee2939aff842cb = ({ onClose: onClose, savedSearch: savedSearch, savedSearchType: savedSearchType, isStarred: isStarred = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { starSavedSearch: starSavedSearch, unstarSavedSearch: unstarSavedSearch } = (0, $kYcMD.useStarredSearchService)();
    const { isOpsAdmin: isOpsAdmin } = (0, $6HvWM.useOgTenantInfo)();
    const handleNavMenuOpen = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$b887e88d8d0739f6),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
                level: (0, $ef39084c605eb7e8$export$f9db6a58b4aabd18),
                itemId: (0, $90c0351d239ffedb$export$a65812b4aab631bb),
                parentItemType: 'savedSearch',
                parentItemId: savedSearch.id
            }
        });
    }, [
        createAnalyticsEvent,
        savedSearch.id
    ]);
    const MenuItems = (0, $euxye.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0b431127fbd21166$var$MoreMenuItems, {
            onClose: props.onClose,
            savedSearch: savedSearch,
            isStarred: isStarred,
            savedSearchType: savedSearchType
        }), [
        savedSearch,
        isStarred,
        savedSearchType
    ]);
    const canDelete = savedSearchType === 'createdByMe' || isOpsAdmin;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1mQ7r.default), {
        isFavorite: isStarred,
        isSmall: true,
        onClick: ()=>{
            if (isStarred) unstarSavedSearch(savedSearch);
            else starSavedSearch(savedSearch);
        }
    }), canDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
        onOpen: handleNavMenuOpen,
        MenuItems: MenuItems,
        onClose: onClose,
        name: savedSearch.name
    }));
};
$0b431127fbd21166$export$78ee2939aff842cb.displayName = "SavedSearchActionButtons";
const $0b431127fbd21166$var$MoreMenuItems = ({ onClose: onClose, savedSearch: savedSearch, isStarred: isStarred = false, savedSearchType: savedSearchType })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [modalType, setModalType] = (0, $euxye.useState)(undefined);
    const onCloseWithStopPropagation = (0, $hwodR.useStopPropagation)(onClose);
    const { removeSavedSearchFromCreatedByMe: removeSavedSearchFromCreatedByMe, removeSavedSearchFromSharedWithMe: removeSavedSearchFromSharedWithMe } = (0, $8QyNX.useSavedSearchRelayUtils)();
    const { showFlag: showFlag } = (0, $iQPOZ.useFlagsService)();
    const [isLoading, setIsLoading] = (0, $euxye.useState)(false);
    const { removeStarredSearchFromCache: removeStarredSearchFromCache } = (0, $kYcMD.useStarredSearchService)();
    const deleteSavedSearch = (0, $euxye.useCallback)((e)=>{
        setIsLoading(true);
        const savedSearchId = (0, $1Pd0K.OpsgenieSavedSearchAri).parse(savedSearch.id).savedSearchId;
        (0, $4chZx.deleteSearchEndpoint)(savedSearchId).then(()=>{
            if (savedSearchType === 'sharedWithMe') removeSavedSearchFromSharedWithMe(savedSearch.id);
            else removeSavedSearchFromCreatedByMe(savedSearch.id);
            if (isStarred) removeStarredSearchFromCache(savedSearch.id);
        }).catch(()=>{
            showFlag({
                key: (0, $acwzf.toFlagId)((0, $a66b0cdc8b7869ef$export$337d30e19f17af0f)),
                type: 'error',
                title: $0b431127fbd21166$var$errorTitle,
                description: $0b431127fbd21166$var$errorMessage,
                // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
                messageId: 'navigation-apps-sidebar-nav4-sidebars-content-operations.ui.alerts-content.alerts-menu-item.action-button.show-flag.error',
                messageType: 'transactional'
            });
        }).finally(()=>{
            setIsLoading(false);
            if (onClose) onClose(e);
        });
    }, [
        savedSearch,
        onClose,
        removeSavedSearchFromCreatedByMe,
        removeSavedSearchFromSharedWithMe,
        savedSearchType,
        showFlag,
        removeStarredSearchFromCache,
        isStarred
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const handleClick = (0, $euxye.useCallback)((event)=>{
        event.preventDefault();
        setModalType('delete');
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$64fed82162bd367),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $6e2f51712bb2e810$export$56981f28056f258e),
                level: (0, $ef39084c605eb7e8$export$35ac629b8b943d5a),
                itemId: 'deleteSavedSearch',
                parentItemType: 'savedSearch',
                parentItemId: savedSearch.id
            }
        });
    }, [
        createAnalyticsEvent,
        savedSearch.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bpNg))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: ""
        }),
        onClick: handleClick
    }, formatMessage($0b431127fbd21166$var$deleteSavedSearchMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2BntI.DeleteModal), {
        messageDescriptors: $0b431127fbd21166$var$deleteModalMessageDescriptors,
        isDeleteDialogOpen: modalType === 'delete',
        onDeleteAttemptCancel: onCloseWithStopPropagation,
        isLoading: isLoading,
        onDelete: deleteSavedSearch
    }));
};
$0b431127fbd21166$var$MoreMenuItems.displayName = "MoreMenuItems";

});
parcelRegister("1mQ7r", function(module, exports) {
$parcel$export(module.exports, "FavoriteButtonWrapper", () => $f59b48bea7de07d4$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $f59b48bea7de07d4$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $4B1S7 = parcelRequire("4B1S7");

var $fcq2N = parcelRequire("fcq2N");

var $gK5hg = parcelRequire("gK5hg");

var $4qNCE = parcelRequire("4qNCE");

var $fZT95 = parcelRequire("fZT95");

var $cXTqc = parcelRequire("cXTqc");

var $2D2gW = parcelRequire("2D2gW");

var $hZDXn = parcelRequire("hZDXn");

var $7eNDO = parcelRequire("7eNDO");
var $1jztF = parcelRequire("1jztF");
const $f59b48bea7de07d4$var$addToStarred = (0, $7eNDO.defineMessage)({
    id: "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
    defaultMessage: "Add to Starred"
});
const $f59b48bea7de07d4$var$removeFromStarred = (0, $7eNDO.defineMessage)({
    id: "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
    defaultMessage: "Remove from Starred"
});
const $f59b48bea7de07d4$var$toggleStarred = (0, $7eNDO.defineMessage)({
    id: "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
    defaultMessage: "Star"
});
const $f59b48bea7de07d4$var$toggleStarredWithItemName = (0, $7eNDO.defineMessage)({
    id: "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
    defaultMessage: "Star {itemName}"
});
const $f59b48bea7de07d4$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $f59b48bea7de07d4$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper'; // eslint-disable-next-line jira/react/no-class-components
class $f59b48bea7de07d4$export$f8ad2acf0ec4860f extends (0, $euxye.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $f59b48bea7de07d4$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f59b48bea7de07d4$export$db65185b5889c83, {
            "data-testid": $f59b48bea7de07d4$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$f59b48bea7de07d4$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $f59b48bea7de07d4$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const renderIcon = ()=>{
            const StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($fZT95))) : (0, (/*@__PURE__*/$parcel$interopDefault($cXTqc)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(StarIconComponent, {
                color: "currentColor",
                label: "",
                size: isSmall ? 'small' : 'medium'
            });
        };
        const tooltipContent = isFavorite ? formatMessage($f59b48bea7de07d4$var$removeFromStarred) : formatMessage($f59b48bea7de07d4$var$addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage($f59b48bea7de07d4$var$toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage($f59b48bea7de07d4$var$toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f59b48bea7de07d4$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f59b48bea7de07d4$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon()))));
    }
    constructor(...args){
        super(...args), this.state = {
            isAnimating: false
        }, this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        }, this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
$f59b48bea7de07d4$export$f8ad2acf0ec4860f.displayName = "FavoriteButtonStateless";
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $f59b48bea7de07d4$var$FavoriteButtonStatelessConnected = (0, (/*@__PURE__*/$parcel$interopDefault($4B1S7)))((0, $gK5hg.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $1jztF.default))($f59b48bea7de07d4$export$f8ad2acf0ec4860f);
var $f59b48bea7de07d4$export$2e2bcd8739ae039 = $f59b48bea7de07d4$var$FavoriteButtonStatelessConnected;
const $f59b48bea7de07d4$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $f59b48bea7de07d4$export$bb1478fee6cd5f0c = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
/*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f59b48bea7de07d4$var$FavoriteIconWrapperBase = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f59b48bea7de07d4$var$FavIconWrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = $f59b48bea7de07d4$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "",
            __cmplp.isFavorite ? "_syaz1oqg" : "_syazdgkc",
            __cmplp.isFavorite ? "_30l31vop" : "_30l31q3r",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $f59b48bea7de07d4$export$db65185b5889c83 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
/*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4chZx", function(module, exports) {
$parcel$export(module.exports, "getSavedSearchesEndpoint", () => $144e9eebed253129$export$3b7b44889eb94cd0);
$parcel$export(module.exports, "createSavedSearchEndpoint", () => $144e9eebed253129$export$4976332c0ec66407);
$parcel$export(module.exports, "deleteSearchEndpoint", () => $144e9eebed253129$export$401da4a793944201);

var $hG5S4 = parcelRequire("hG5S4");
const $144e9eebed253129$export$3b7b44889eb94cd0 = ()=>{
    return (0, $hG5S4.eocFetch)('/v1/alerts/saved-searches');
};
const $144e9eebed253129$export$4976332c0ec66407 = (data)=>{
    return (0, $hG5S4.eocFetch)('/v1/alerts/saved-searches', {
        method: 'POST',
        body: data
    });
};
const $144e9eebed253129$export$401da4a793944201 = (id)=>{
    return (0, $hG5S4.eocFetch)(`/v1/alerts/saved-searches/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};

});

parcelRegister("8QyNX", function(module, exports) {
$parcel$export(module.exports, "useSavedSearchRelayUtils", () => $df30e7bfd26f834d$export$e07c40a7acca4305);

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $1Pd0K = parcelRequire("1Pd0K");

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $7nxyA = parcelRequire("7nxyA");

var $dp0Rz = parcelRequire("dp0Rz");

var $2SzSq = parcelRequire("2SzSq");
const $df30e7bfd26f834d$export$e07c40a7acca4305 = ()=>{
    const relayEnvironment = (0, $n67Vb.useRelayEnvironment)();
    const cloudId = (0, $7nxyA.getMeta)('ajs-cloud-id') ?? (0, $2SzSq.getCloudIdForDevEnvironment)();
    (0, $7Ljuo.assert)(!!cloudId, new (0, $jpT5w.AssertionError)('cloudId', 'useSavedSarchRelayUtils: cloudId is undefined'));
    const removeSavedSearch = (0, $euxye.useCallback)((savedSearchId, key)=>{
        (0, $n67Vb.commitLocalUpdate)(relayEnvironment, (store)=>{
            const root = store.getRoot();
            const opsgenieRecord = root.getLinkedRecord('opsgenie');
            if (opsgenieRecord) {
                const savedSearches = opsgenieRecord.getLinkedRecord('savedSearches', {
                    cloudId: cloudId
                });
                if (savedSearches) {
                    const removeItem = savedSearches.getLinkedRecords(key);
                    if (removeItem) {
                        const filteredItems = removeItem.filter((record)=>record.getValue('id') !== savedSearchId);
                        savedSearches.setLinkedRecords(filteredItems, key);
                    }
                }
            }
        });
    }, [
        cloudId,
        relayEnvironment
    ]);
    const addSavedSearch = (0, $euxye.useCallback)((savedSearch, key)=>{
        (0, $n67Vb.commitLocalUpdate)(relayEnvironment, (store)=>{
            const newSavedSearchId = (0, $1Pd0K.OpsgenieSavedSearchAri).create({
                workspaceId: cloudId,
                savedSearchId: savedSearch.id
            }).toString();
            const newSavedSearchIdDataID = (0, $dp0Rz.default)({
                id: newSavedSearchId
            }, 'OpsgenieSavedSearch');
            if (!newSavedSearchIdDataID) throw new Error('Failed to create new saved search data ID');
            const newSavedSearch = store.create(newSavedSearchIdDataID, 'OpsgenieSavedSearch');
            newSavedSearch.setValue(newSavedSearchId, 'id');
            newSavedSearch.setValue(savedSearch.name, 'name');
            newSavedSearch.setValue(savedSearch.query, 'alertSearchQuery');
            const root = store.getRoot();
            const opsgenieRecord = root.getLinkedRecord('opsgenie');
            if (opsgenieRecord) {
                const savedSearches = opsgenieRecord.getLinkedRecord('savedSearches', {
                    cloudId: cloudId
                });
                if (savedSearches) {
                    const savedSearchesList = savedSearches.getLinkedRecords(key) || [];
                    const updatedSavedSearches = [
                        ...savedSearchesList,
                        newSavedSearch
                    ];
                    savedSearches.setLinkedRecords(updatedSavedSearches, key);
                }
            }
        });
    }, [
        cloudId,
        relayEnvironment
    ]);
    const addSavedSearchToCreatedByMe = (0, $euxye.useCallback)((savedSearch)=>{
        addSavedSearch(savedSearch, 'createdByMe');
    }, [
        addSavedSearch
    ]);
    const removeSavedSearchFromCreatedByMe = (0, $euxye.useCallback)((savedSearchId)=>{
        removeSavedSearch(savedSearchId, 'createdByMe');
    }, [
        removeSavedSearch
    ]);
    const removeSavedSearchFromSharedWithMe = (0, $euxye.useCallback)((savedSearchId)=>{
        removeSavedSearch(savedSearchId, 'sharedWithMe');
    }, [
        removeSavedSearch
    ]);
    return {
        addSavedSearchToCreatedByMe: addSavedSearchToCreatedByMe,
        removeSavedSearchFromCreatedByMe: removeSavedSearchFromCreatedByMe,
        removeSavedSearchFromSharedWithMe: removeSavedSearchFromSharedWithMe
    };
};

});
parcelRegister("7Ljuo", function(module, exports) {
$parcel$export(module.exports, "assert", () => $74115108c9b52c1d$export$a7a9523472993e97);

var $jpT5w = parcelRequire("jpT5w");
/**
 * Throws when the condition is true
 * @param condition Condition to assert - can use type assertions thanks to ts's "asserts condition"
 * @param err An AssertionError object extending js error object
 */ const $74115108c9b52c1d$export$a7a9523472993e97 = function(condition, err) {
    if (!condition) throw err;
};

});
parcelRegister("jpT5w", function(module, exports) {
$parcel$export(module.exports, "AssertionError", () => $200613c788ada549$export$7750cdfb4db2c3d);
class $200613c788ada549$export$7750cdfb4db2c3d extends Error {
    constructor(id, message){
        super(`[${id}] ${message}`), this.id = id;
    }
}

});


parcelRegister("2SzSq", function(module, exports) {
$parcel$export(module.exports, "validateTimeInput", () => $79146ce34efdfc15$export$8880da3ae4274888);
$parcel$export(module.exports, "validateBetweenInput", () => $79146ce34efdfc15$export$57c3e855fbf300fa);
$parcel$export(module.exports, "isInvalidDateValue", () => $79146ce34efdfc15$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "removeQuotes", () => $79146ce34efdfc15$export$dd2bdf5049bf0915);
$parcel$export(module.exports, "withQuote", () => $79146ce34efdfc15$export$8708814d32e406db);
$parcel$export(module.exports, "calculateTimes", () => $79146ce34efdfc15$export$b362bc6892126b7a);
$parcel$export(module.exports, "getDefaultFilterQuery", () => $79146ce34efdfc15$export$16cce822d8159876);
$parcel$export(module.exports, "isResponderAlert", () => $79146ce34efdfc15$export$78656db4ffc3ccd8);
$parcel$export(module.exports, "isGroupAlert", () => $79146ce34efdfc15$export$be2243d4df51c704);
$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $79146ce34efdfc15$export$81c70e0016508593);
$parcel$export(module.exports, "getCloudIdForDevEnvironment", () => $79146ce34efdfc15$export$fc6ce7ac2248d7f5);

var $dGdlo = parcelRequire("dGdlo");

var $7cCLc = parcelRequire("7cCLc");

var $9Ctw7 = parcelRequire("9Ctw7");

var $iqfTZ = parcelRequire("iqfTZ");

var $7nxyA = parcelRequire("7nxyA");

var $kFsUA = parcelRequire("kFsUA");
var $9fOfL = parcelRequire("9fOfL");

var $a7bbm = parcelRequire("a7bbm");

var $ev5JY = parcelRequire("ev5JY");
var $2wjE9 = parcelRequire("2wjE9");

var $gIMgJ = parcelRequire("gIMgJ");
const $79146ce34efdfc15$export$8880da3ae4274888 = (intl, timeDigits, timeUnit)=>{
    if (!timeDigits) return;
    const timeDigitsNumber = parseInt(timeDigits);
    if (isNaN(timeDigitsNumber)) return intl.formatMessage((0, $a7bbm.default).validNumber);
    if (timeUnit === 'hours' && (timeDigitsNumber < 1 || timeDigitsNumber > 99999)) return intl.formatMessage((0, $a7bbm.default).hoursNotInRange);
    if (timeUnit === 'days' && (timeDigitsNumber < 1 || timeDigitsNumber > 9999)) return intl.formatMessage((0, $a7bbm.default).daysNotInRange);
    if (timeUnit === 'weeks' && (timeDigitsNumber < 1 || timeDigitsNumber > 999)) return intl.formatMessage((0, $a7bbm.default).weeksNotInRange);
    if (timeUnit === 'months' && (timeDigitsNumber < 1 || timeDigitsNumber > 99)) return intl.formatMessage((0, $a7bbm.default).monthsNotInRange);
    if (timeUnit === 'years' && (timeDigitsNumber < 1 || timeDigitsNumber > 9)) return intl.formatMessage((0, $a7bbm.default).yearsNotInRange);
};
const $79146ce34efdfc15$export$57c3e855fbf300fa = (intl, value)=>{
    if ((0, $iqfTZ.fg)('alx-242-between-filter-strict-validation')) {
        const startDate = value?.startDate ?? '';
        const endDate = value?.endDate ?? '';
        const isStartValid = !!startDate && !$79146ce34efdfc15$export$f18cd4bc58b99a27(startDate);
        const isEndValid = !!endDate && !$79146ce34efdfc15$export$f18cd4bc58b99a27(endDate);
        if (!isStartValid && !isEndValid) return intl.formatMessage((0, $a7bbm.default).validationMessageMissingDate);
        if (isStartValid && isEndValid && new Date(startDate) > new Date(endDate)) return intl.formatMessage((0, $a7bbm.default).validationMessageBeforeGreaterThanAfter);
        return;
    }
    if (value) {
        const { startDate: startDate, endDate: endDate } = value;
        if (!startDate && !endDate) return;
        if (startDate && endDate && new Date(startDate) > new Date(endDate)) return intl.formatMessage((0, $a7bbm.default).validationMessageBeforeGreaterThanAfter);
        if (value && (startDate !== '' && !(0, $dGdlo.default)(new Date(startDate)) || endDate !== '' && !(0, $dGdlo.default)(new Date(endDate)))) return intl.formatMessage((0, $a7bbm.default).validationMessageInvalidDateFormat);
    }
    return;
};
const $79146ce34efdfc15$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $dGdlo.default)((0, $7cCLc.default)(value)) && value !== '';
};
const $79146ce34efdfc15$export$dd2bdf5049bf0915 = (value)=>{
    return value.replace(/^"(.*)"$/, '$1');
};
const $79146ce34efdfc15$export$d4aae9ad13afd6c = (data)=>{
    return {
        ...data,
        label: data.name,
        value: data.id
    };
};
const $79146ce34efdfc15$export$8708814d32e406db = (value)=>{
    if ((0, $kFsUA.hasSpaceRegEx).test(value) || (0, $kFsUA.hasColonRegex).test(value)) {
        if ((0, $kFsUA.hasStartingQuotesRegex).test(value) && (0, $kFsUA.hasEndingQuotesRegex).test(value) && (0, $iqfTZ.fg)('alx-10642-operations-alert-list-search-quotation')) return value;
        return `${0, $9fOfL.STRING_LITERAL_DOUBLE_QUOTE}${value}${0, $9fOfL.STRING_LITERAL_DOUBLE_QUOTE}`;
    } else return value;
};
const $79146ce34efdfc15$export$b362bc6892126b7a = (time)=>{
    if (!time) return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'all') return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'custom') return {
        from: time.from,
        to: time.to
    };
    const now = new Date();
    const subAmount = {
        [time.range]: time.value
    };
    return {
        from: (0, $9Ctw7.default)(now, subAmount).getTime(),
        to: now.getTime()
    };
};
const $79146ce34efdfc15$export$16cce822d8159876 = (query, teamId)=>{
    if (teamId) {
        if (query) return `${0, $9fOfL.IDENTIFIER_RESPONDERS}: ${teamId} ${0, $9fOfL.LOGICAL_OPERATOR_AND} ${query}`;
        return `${0, $9fOfL.IDENTIFIER_RESPONDERS}: ${teamId}`;
    }
    return query;
};
const $79146ce34efdfc15$export$78656db4ffc3ccd8 = (alert)=>alert && alert.alertType === 'responder';
const $79146ce34efdfc15$export$be2243d4df51c704 = (alert)=>alert.entityType === 'group';
const $79146ce34efdfc15$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $7nxyA.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};
const $79146ce34efdfc15$var$isDevEnvironment = ()=>{
    return typeof $gIMgJ !== 'undefined' && ($gIMgJ?.env?.STORYBOOK === 'true' || $gIMgJ?.env?.NODE_ENV === 'development') || window.location.hostname === 'localhost';
};
const $79146ce34efdfc15$export$fc6ce7ac2248d7f5 = ()=>{
    if ($79146ce34efdfc15$var$isDevEnvironment()) return 'abc-def-ghi-jkl';
    return undefined;
};

});
parcelRegister("kFsUA", function(module, exports) {
$parcel$export(module.exports, "TAB_KEY", () => $a8400b5568cdf89d$export$da8c7facc28740b1);
$parcel$export(module.exports, "ENTER_KEY", () => $a8400b5568cdf89d$export$4162dbd8c730437);
$parcel$export(module.exports, "ESCAPE_KEY", () => $a8400b5568cdf89d$export$728705b4513abbb5);
$parcel$export(module.exports, "SPACE_KEY", () => $a8400b5568cdf89d$export$a47625ee19580f99);
$parcel$export(module.exports, "LEFT_KEY", () => $a8400b5568cdf89d$export$ba950c21a0561bed);
$parcel$export(module.exports, "UP_KEY", () => $a8400b5568cdf89d$export$16859d5882a95fea);
$parcel$export(module.exports, "RIGHT_KEY", () => $a8400b5568cdf89d$export$4b96cad863d88376);
$parcel$export(module.exports, "DOWN_KEY", () => $a8400b5568cdf89d$export$fc0cf2556509233e);
$parcel$export(module.exports, "hasSpaceRegEx", () => $a8400b5568cdf89d$export$a07ca273fbeffcb8);
$parcel$export(module.exports, "hasStartingQuotesRegex", () => $a8400b5568cdf89d$export$a3aaedcec21ac282);
$parcel$export(module.exports, "hasEndingQuotesRegex", () => $a8400b5568cdf89d$export$e5ad519d04ef012a);
$parcel$export(module.exports, "hasNewLinesRegex", () => $a8400b5568cdf89d$export$7645e556e9948ecd);
$parcel$export(module.exports, "EMAIL_REGEX", () => $a8400b5568cdf89d$export$7b7637218245c8a);
$parcel$export(module.exports, "hasColonRegex", () => $a8400b5568cdf89d$export$65a2b373cb60e599);
const $a8400b5568cdf89d$export$da8c7facc28740b1 = 'Tab';
const $a8400b5568cdf89d$export$4162dbd8c730437 = 'Enter';
const $a8400b5568cdf89d$export$728705b4513abbb5 = 'Escape';
const $a8400b5568cdf89d$export$a47625ee19580f99 = ' ';
const $a8400b5568cdf89d$export$ba950c21a0561bed = 'ArrowLeft';
const $a8400b5568cdf89d$export$16859d5882a95fea = 'ArrowUp';
const $a8400b5568cdf89d$export$4b96cad863d88376 = 'ArrowRight';
const $a8400b5568cdf89d$export$fc0cf2556509233e = 'ArrowDown';
const $a8400b5568cdf89d$export$a07ca273fbeffcb8 = /\s/;
const $a8400b5568cdf89d$export$8866d083cd03ffd7 = /^\s|\s$/;
const $a8400b5568cdf89d$export$a3aaedcec21ac282 = /^('|")/;
const $a8400b5568cdf89d$export$e5ad519d04ef012a = /('|")$/;
const $a8400b5568cdf89d$export$7645e556e9948ecd = /(\r\n|\n|\r)/gm;
const $a8400b5568cdf89d$export$7b7637218245c8a = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $a8400b5568cdf89d$export$65a2b373cb60e599 = /:/;

});

parcelRegister("a7bbm", function(module, exports) {
$parcel$export(module.exports, "default", () => $49733607d15169b2$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $49733607d15169b2$var$messages = (0, $7eNDO.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.alert-list.common.utils.validation-message-before-greater-than-after`,
        defaultMessage: "'Before' field cannot be later than 'After' field.",
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.alert-list.common.utils.validation-message-invalid-date-format`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validationMessageMissingDate: {
        id: `eoc.alert-list.common.utils.validation-message-missing-date`,
        defaultMessage: 'Please provide at least one valid date.',
        description: 'Validation message shown in the alert list time filter "Between" mode when neither the from date nor the to date has been provided with a valid value.'
    },
    validNumber: {
        id: `eoc.alert-list.common.utils.validation-not-number`,
        defaultMessage: 'Enter a valid number.',
        description: 'The error message that shown when user write different chars other than numeric chars.'
    },
    hoursNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-hours-not-in-range`,
        defaultMessage: 'Enter a number between 1-99999.',
        description: 'Message displayed to the user when hours value is not in range'
    },
    daysNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-days-not-in-range`,
        defaultMessage: 'Enter a number between 1-9999.',
        description: 'Message displayed to the user when days value is not in range'
    },
    weeksNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-weeks-not-in-range`,
        defaultMessage: 'Enter a number between 1-999.',
        description: 'Message displayed to the user when weeks value is not in range'
    },
    monthsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-months-not-in-range`,
        defaultMessage: 'Enter a number between 1-99.',
        description: 'Message displayed to the user when months value is not in range'
    },
    yearsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-years-not-in-range`,
        defaultMessage: 'Enter a number between 1-9.',
        description: 'Message displayed to the user when years value is not in range'
    }
});
var $49733607d15169b2$export$2e2bcd8739ae039 = $49733607d15169b2$var$messages;

});

parcelRegister("ev5JY", function(module, exports) {
$parcel$export(module.exports, "useAllActions", () => $fde200b4dbe7c5e5$export$acd577492a98befc);

var $euxye = parcelRequire("euxye");

var $d5Cgz = parcelRequire("d5Cgz");
const $fde200b4dbe7c5e5$export$acd577492a98befc = ({ alertId: alertId, bulkLoadingState: bulkLoadingState, actionsController: actionsController })=>{
    const { processingBulkIds: processingBulkIds, isBulkSnoozeLoading: isBulkSnoozeLoading, isBulkAssignLoading: isBulkAssignLoading, isBulkCloseLoading: isBulkCloseLoading, isBulkDeleteLoading: isBulkDeleteLoading, isBulkUnacknowledgeLoading: isBulkUnacknowledgeLoading, isBulkAckLoading: isBulkAckLoading, isBulkAddResponderLoading: isBulkAddResponderLoading, isBulkTakeOwnershipLoading: isBulkTakeOwnershipLoading } = bulkLoadingState;
    const { handleAck: handleAck, handleClose: handleClose, handleAssign: handleAssign, handleTakeOwnership: handleTakeOwnership, handleEscalate: handleEscalate, handleAddResponder: handleAddResponder, handleReopen: handleReopen, handleSnooze: handleSnooze, handleDelete: handleDelete, handleUnack: handleUnack, isAssigneeUpdateLoading: isAssigneeUpdateLoading, isRespondersUpdateLoading: isRespondersUpdateLoading, isAckLoading: isAckLoading, isUnackLoading: isUnackLoading, isReopenLoading: isReopenLoading, isDeleteLoading: isDeleteLoading, isSnoozeLoading: isSnoozeLoading, isCloseLoading: isCloseLoading, isEscalateLoading: isEscalateLoading } = actionsController;
    const isBulkProcessing = (0, $euxye.useMemo)(()=>processingBulkIds.includes(alertId), [
        processingBulkIds,
        alertId
    ]);
    const allActions = [
        {
            label: (0, $d5Cgz.default).acknowledge,
            onClick: handleAck,
            actionId: 'acknowledge',
            isLoading: isAckLoading || isBulkProcessing && isBulkAckLoading
        },
        {
            label: (0, $d5Cgz.default).close,
            onClick: handleClose,
            actionId: 'close',
            isLoading: isCloseLoading || isBulkProcessing && isBulkCloseLoading
        },
        {
            label: (0, $d5Cgz.default).reopen,
            onClick: handleReopen,
            actionId: 'reopen',
            isLoading: isReopenLoading
        },
        {
            label: (0, $d5Cgz.default).assign,
            onClick: handleAssign,
            actionId: 'assign',
            isLoading: isAssigneeUpdateLoading || isBulkProcessing && isBulkAssignLoading
        },
        {
            label: (0, $d5Cgz.default).unacknowledge,
            onClick: handleUnack,
            actionId: 'unacknowledge',
            isLoading: isUnackLoading || isBulkProcessing && isBulkUnacknowledgeLoading
        },
        {
            label: (0, $d5Cgz.default).takeOwnership,
            onClick: handleTakeOwnership,
            actionId: 'takeOwnership',
            isLoading: isAssigneeUpdateLoading || isBulkProcessing && isBulkTakeOwnershipLoading
        },
        {
            label: (0, $d5Cgz.default).escalateToNext,
            onClick: handleEscalate,
            actionId: 'escalateToNext',
            isLoading: isEscalateLoading
        },
        {
            label: (0, $d5Cgz.default).addResponder,
            onClick: handleAddResponder,
            actionId: 'addResponder',
            isLoading: isRespondersUpdateLoading || isBulkProcessing && isBulkAddResponderLoading
        },
        {
            label: (0, $d5Cgz.default).snooze,
            onClick: handleSnooze,
            actionId: 'snooze',
            isLoading: isSnoozeLoading || isBulkProcessing && isBulkSnoozeLoading
        },
        {
            label: (0, $d5Cgz.default).delete,
            onClick: handleDelete,
            actionId: 'delete',
            isLoading: isDeleteLoading || isBulkProcessing && isBulkDeleteLoading
        }
    ];
    return allActions;
};

});
parcelRegister("d5Cgz", function(module, exports) {
$parcel$export(module.exports, "default", () => $65a24e2c2d5cc6b6$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $65a24e2c2d5cc6b6$var$messages = (0, $7eNDO.defineMessages)({
    errorTitle: {
        id: 'eoc.alert-list.flag.error-title',
        defaultMessage: 'Error',
        description: 'Title of error message that will be displayed in the flag'
    },
    successTitle: {
        id: 'eoc.alert-list.flag.success-title',
        defaultMessage: 'Success',
        description: 'Title of success message that will be displayed in the flag'
    },
    acknowledge: {
        id: 'eoc.alert-list.actions.acknowledge',
        defaultMessage: 'Ack',
        description: 'Button label to acknowledge an alert in the alert list actions menu.'
    },
    reopen: {
        id: 'eoc.alert-list.actions.reopen',
        defaultMessage: 'Reopen',
        description: 'Button label to reopen a closed alert in the alert list actions menu.'
    },
    unacknowledge: {
        id: 'eoc.alert-list.actions.unacknowledge',
        defaultMessage: 'Open',
        description: 'Unacknowledge(open) action button'
    },
    snooze: {
        id: 'eoc.alert-list.actions.snooze',
        defaultMessage: 'Snooze',
        description: 'Button label to snooze an alert in the alert list actions menu.'
    },
    close: {
        id: 'eoc.alert-list.actions.close',
        defaultMessage: 'Close',
        description: 'Button label to close an alert in the alert list actions menu.'
    },
    delete: {
        id: 'eoc.alert-list.actions.delete',
        defaultMessage: ' Delete',
        description: 'Button label to delete an alert in the alert list actions menu.'
    },
    escalateToNext: {
        id: 'eoc.alert-list.actions.escalateToNext',
        defaultMessage: 'Escalate to next',
        description: 'Escalate to next action button'
    },
    assign: {
        id: 'eoc.alert-list.actions.assign',
        defaultMessage: 'Assign',
        description: 'Button label to assign an alert to a user in the alert list actions menu.'
    },
    addResponder: {
        id: 'eoc.alert-list.actions.add-responder',
        defaultMessage: 'Add responder',
        description: 'Button label to add a responder to an alert in the alert list actions menu.'
    },
    takeOwnership: {
        id: 'eoc.alert-list.actions.takeOwnership',
        defaultMessage: 'Assign to me',
        description: 'Button label to assign an alert to the current user in the alert list actions menu.'
    },
    addTag: {
        id: 'eoc.alert-list.actions.add-tag',
        defaultMessage: 'Add tag',
        description: 'Button label to add a tag to an alert in the alert list actions menu.'
    },
    addNote: {
        id: 'eoc.alert-list.actions.add-note',
        defaultMessage: 'Add note',
        description: 'Button label to add a note to an alert in the alert list actions menu.'
    },
    empty: {
        id: `eoc.alert-list.empty`,
        defaultMessage: "We couldn\u2019t find any alerts matching your search",
        description: 'Alerts can be symptoms of potential incidents or issues. Integrate your applications so you never miss a critical alert.'
    },
    noAlerts: {
        id: `eoc.alert-list.no-alerts`,
        defaultMessage: "You don\u2019t have any alerts, yet",
        description: 'Message displayed when there is no alerts'
    },
    learnMore: {
        id: `eoc.alert-list.no-alerts.learn-more`,
        defaultMessage: 'Read how alerts are created',
        description: 'Message displayed for redirecting user to alert create docs'
    },
    emptyDescription: {
        id: `eoc.alert-list.no-alerts.description`,
        defaultMessage: 'Adjust your search filters and try again. You can also create an alert to notify your team about anything critical.',
        description: 'Message displayed as description when there is no alerts with given search'
    },
    noAlertsDescription: {
        id: `eoc.alert-list.no-alerts.description`,
        defaultMessage: 'Alerts can be symptoms of potential incidents or issues. Integrate your applications so you never miss a critical alert.',
        description: 'Message displayed when there is no alerts'
    },
    error: {
        id: `eoc.alert-list.error`,
        defaultMessage: "We couldn\u2019t load the alerts",
        description: 'Message displayed when there is an error on fetching alerts'
    },
    errorDescription: {
        id: `eoc.alert-list.error.description`,
        defaultMessage: 'Something went wrong while we were loading the alerts. Try searching again.',
        description: 'Message displayed as description when there is an error on fetching alerts'
    },
    pageTitle: {
        id: 'eoc.alert-list.page.title',
        defaultMessage: 'Alerts',
        description: 'Page title displayed in the browser tab for the alerts list page.'
    },
    emptyAIViewTitle: {
        id: 'eoc.alert-list.flag.error-title',
        defaultMessage: 'Looking for alerts to group',
        description: 'Title ofthe message that will be displayed when no groups are present'
    },
    emptyAIViewDescription: {
        id: 'eoc.alert-list.flag.success-title',
        defaultMessage: 'Rovo is working behind the scenes and will update this space as soon as new groups are identified.',
        description: 'Description of the message that will be displayed when no groups are present'
    },
    dareAIViewTitle: {
        id: 'eoc.alert-list.flag.dare-title',
        defaultMessage: 'Starting fresh to group alerts',
        description: 'Title of the message that will be displayed when no groups are present because of DaRe'
    },
    dareAIViewDescription: {
        id: 'eoc.alert-list.flag.dare-description',
        defaultMessage: 'Since you changed your data residency location, previous alert groups were deleted. Rovo is working behind the scenes and will update this space as soon as new groups are identified.',
        description: 'Description of the message that will be displayed when no groups are present'
    },
    notEnabledAIViewTitle: {
        id: 'eoc.smart-alert-list.flag.not-enabled',
        defaultMessage: "We couldn\u2019t find what you\u2019re looking for",
        description: 'Title of the message that will be displayed when AI view is not enabled'
    },
    notEnabledAIViewDescription: {
        id: 'eoc.smart-alert-list.flag.not-enabled',
        defaultMessage: "We looked everywhere, but it doesn\u2019t exist.",
        description: 'Description of the message that will be displayed when AI view is not enabled'
    },
    readMoreAlertGrouping: {
        id: 'eoc.alert-list.flag.success-title',
        defaultMessage: 'Read more about alert grouping',
        description: 'Message for read more that will be displayed when no groups are present'
    },
    requiredFieldsInformMessage: {
        id: 'eoc.alert-list.modal.required-fields-inform-message',
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Message to give information to users about required fields'
    },
    ariaLiveMessageFilters: {
        id: `eoc.alert-list.filters.aria-live-message`,
        defaultMessage: `{removedValue, select,
      true { Option {label} deselected. {numOfAlerts} matching alerts found. }
      other { Option {label} selected. {numOfAlerts} matching alerts found. }
    }`,
        description: 'The message to be announced when user selects an option from one of the filters.'
    },
    buttonAriaLabelToIndicateTableModification: {
        id: `eoc.alert-list.filters.update-button`,
        defaultMessage: '{buttonText}. The table will be modified.',
        description: 'The message to be announced before user press update filter button.'
    },
    acceptAIPrediction: {
        id: 'eoc.alert-list.unified-bulk-actions.accept-ai-prediction',
        defaultMessage: 'Accept classification',
        description: 'Button label for accepting AI prediction in bulk actions'
    },
    acknowledgeAll: {
        id: 'eoc.unified-list.actions.acknowledge',
        defaultMessage: 'Ack all',
        description: 'The text is shown on a bulk action button in the alert list toolbar that acknowledges all selected alerts at once.'
    },
    snoozeAll: {
        id: 'eoc.unified-list.actions.snooze',
        defaultMessage: 'Snooze all',
        description: 'The text is shown on a bulk action button in the alert list toolbar that snoozes all selected alerts at once.'
    },
    closeAll: {
        id: 'eoc.unified-list.actions.close',
        defaultMessage: 'Close all',
        description: 'The text is shown on a bulk action button in the alert list toolbar that closes all selected alerts at once.'
    },
    deleteAll: {
        id: 'eoc.unified-list.actions.delete',
        defaultMessage: 'Delete all',
        description: 'The text is shown on a bulk action button in the alert list toolbar that deletes all selected alerts at once.'
    },
    assignToMe: {
        id: 'eoc.unified-list.actions.assignToMe',
        defaultMessage: 'Assign to me',
        description: 'The text is shown on a bulk action button in the alert list toolbar that assigns all selected alerts to the currently signed-in user.'
    },
    acceptPrediction: {
        id: 'eoc.unified-list.actions.acceptPrediction',
        defaultMessage: 'Accept classification',
        description: 'The text is shown on a bulk action button in the alert list toolbar that accepts the ML-suggested noise classification for all selected alerts.'
    },
    moreAriaLabel: {
        id: 'eoc.unified-list.actions.more-aria-label',
        defaultMessage: 'More actions for {tinyId}',
        description: 'The text is shown as the aria-label on the "More actions" menu button in each alert list row. The placeholder {tinyId} will be substituted with the short identifier of the alert (e.g. "P-123").'
    },
    summaryMoreAriaLabel: {
        id: 'eoc.alert-list.summary-actions.more-aria-label',
        defaultMessage: 'More actions for alert {tinyId}',
        description: 'Aria label for the more actions button in summary'
    },
    deleteModalTitle: {
        id: 'eoc.alert-list.summary-actions.delete-modal-title',
        defaultMessage: 'Delete alert',
        description: 'The text is shown as the heading of the delete confirmation modal dialog that appears when a user requests to delete an alert from the alert list.'
    },
    deleteModalDescription: {
        id: 'eoc.alert-list.summary-actions.delete-modal-description',
        defaultMessage: 'Are you sure you want to delete this alert? This action cannot be undone.',
        description: 'Description for the delete confirmation modal'
    },
    filterInfo: {
        id: 'eoc.alert-list.header.filter-info',
        defaultMessage: "The results include groups that have alerts matching your filter criteria. The group's overall priority may differ.",
        description: 'Filter info in the alert smart table header'
    },
    snrAdd: {
        id: 'eoc.alert-list.actions.snr-add',
        defaultMessage: 'Classify',
        description: 'The text is shown on an action button in the alert list that opens a dialog to classify an alert using the signal-to-noise ratio (SNR) classification feature.'
    },
    snrAddSignal: {
        id: 'eoc.alert-list.actions.snr-add-signal',
        defaultMessage: 'Classify as signal',
        description: 'SNR Add classification as signal action button'
    },
    snrAddNoise: {
        id: 'eoc.alert-list.actions.snr-add-noise',
        defaultMessage: 'Classify as noise',
        description: 'SNR Add classification as noise action button'
    },
    snrUpdate: {
        id: 'eoc.alert-list.actions.snr-update',
        defaultMessage: 'Update classification',
        description: 'The text is shown on an action button in the alert list that opens a dialog to update an existing SNR noise classification for an alert.'
    },
    snrUpdateSignal: {
        id: 'eoc.alert-list.actions.snr-update-signal',
        defaultMessage: 'Update as signal',
        description: 'SNR Update classification as signal action button'
    },
    snrUpdateNoise: {
        id: 'eoc.alert-list.actions.snr-update-noise',
        defaultMessage: 'Update as noise',
        description: 'SNR Update classification as noise action button'
    },
    snrAccept: {
        id: 'eoc.alert-list.actions.snr-accept',
        defaultMessage: 'Accept classification',
        description: 'The text is shown on an action button in the alert list that accepts the ML-suggested SNR noise classification for a single alert.'
    }
});
var $65a24e2c2d5cc6b6$export$2e2bcd8739ae039 = $65a24e2c2d5cc6b6$var$messages;

});


parcelRegister("2wjE9", function(module, exports) {
$parcel$export(module.exports, "useAllGroupActions", () => $96bf25ad5d236fea$export$8df8e9de2e51cb58);

var $euxye = parcelRequire("euxye");

var $d5Cgz = parcelRequire("d5Cgz");
const $96bf25ad5d236fea$export$8df8e9de2e51cb58 = ({ groupId: groupId, bulkLoadingState: bulkLoadingState, groupActionsController: groupActionsController, snrClassification: snrClassification })=>{
    const { processingBulkIds: processingBulkIds } = bulkLoadingState;
    const { action: action, isCountLoading: isCountLoading, isAckAllLoading: isAckAllLoading, isCloseAllLoading: isCloseAllLoading, isSnoozeAllLoading: isSnoozeAllLoading, isDeleteAllLoading: isDeleteAllLoading, isAssignLoading: isAssignLoading, isAssignToMeLoading: isAssignToMeLoading, isAcceptAIClassificationLoading: isAcceptAIClassificationLoading, initiateAckAll: initiateAckAll, initiateCloseAll: initiateCloseAll, initiateSnoozeAll: initiateSnoozeAll, initiateDeleteAll: initiateDeleteAll, initiateAssign: initiateAssign, initiateAssignToMe: initiateAssignToMe, initiateAcceptAIClassification: initiateAcceptAIClassification, performAckAll: performAckAll, performCloseAll: performCloseAll, performSnoozeAll: performSnoozeAll, performDeleteAll: performDeleteAll, performAssign: performAssign } = groupActionsController;
    const isBulkProcessing = (0, $euxye.useMemo)(()=>processingBulkIds.includes(groupId), [
        processingBulkIds,
        groupId
    ]);
    const allActions = [
        {
            label: (0, $d5Cgz.default).acknowledgeAll,
            onClick: initiateAckAll,
            actionId: 'acknowledgeAll',
            requiresAlertCount: true,
            isLoading: action === 'acknowledgeAll' && isCountLoading || isAckAllLoading || isBulkProcessing && bulkLoadingState.isBulkAckLoading,
            onSubmit: performAckAll
        },
        {
            label: (0, $d5Cgz.default).closeAll,
            onClick: initiateCloseAll,
            actionId: 'closeAll',
            requiresAlertCount: true,
            isLoading: action === 'closeAll' && isCountLoading || isCloseAllLoading || isBulkProcessing && bulkLoadingState.isBulkCloseLoading,
            onSubmit: performCloseAll
        },
        {
            label: (0, $d5Cgz.default).assign,
            onClick: initiateAssign,
            actionId: 'assign',
            requiresAlertCount: false,
            isLoading: isAssignLoading || isBulkProcessing && bulkLoadingState.isBulkAssignLoading,
            onSubmit: performAssign
        },
        {
            label: (0, $d5Cgz.default).assignToMe,
            onClick: initiateAssignToMe,
            actionId: 'assignToMe',
            requiresAlertCount: false,
            isLoading: isAssignToMeLoading || isBulkProcessing && bulkLoadingState.isBulkAssignToMeLoading,
            onSubmit: undefined
        },
        {
            label: (0, $d5Cgz.default).snoozeAll,
            onClick: initiateSnoozeAll,
            actionId: 'snooze',
            requiresAlertCount: true,
            isLoading: action === 'snooze' && isCountLoading || isSnoozeAllLoading || isBulkProcessing && bulkLoadingState.isBulkSnoozeLoading,
            onSubmit: performSnoozeAll
        },
        {
            label: (0, $d5Cgz.default).deleteAll,
            onClick: initiateDeleteAll,
            actionId: 'delete',
            requiresAlertCount: true,
            isLoading: action === 'delete' && isCountLoading || isDeleteAllLoading || isBulkProcessing && bulkLoadingState.isBulkDeleteLoading,
            onSubmit: performDeleteAll
        },
        {
            label: (0, $d5Cgz.default).acceptPrediction,
            onClick: ()=>initiateAcceptAIClassification({
                    prediction: snrClassification
                }),
            actionId: 'aiPrediction',
            requiresAlertCount: false,
            isLoading: isAcceptAIClassificationLoading || isBulkProcessing && bulkLoadingState.isBulkAcceptAIClassificationLoading,
            onSubmit: undefined
        }
    ];
    return allActions;
};

});



parcelRegister("2BntI", function(module, exports) {
$parcel$export(module.exports, "DeleteModal", () => $d31ec1104ccd6307$export$73392e09138fecd6);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $4qNCE = parcelRequire("4qNCE");
var $1D4ep = parcelRequire("1D4ep");

var $2v3yi = parcelRequire("2v3yi");

var $7tY81 = parcelRequire("7tY81");

var $4vluQ = parcelRequire("4vluQ");

var $gpyJM = parcelRequire("gpyJM");

var $dNPnD = parcelRequire("dNPnD");

var $9imxF = parcelRequire("9imxF");

var $iqfTZ = parcelRequire("iqfTZ");

var $lnlFs = parcelRequire("lnlFs");
const $d31ec1104ccd6307$export$73392e09138fecd6 = ({ isDeleteDialogOpen: isDeleteDialogOpen, onDeleteAttemptCancel: onDeleteAttemptCancel, onDelete: onDelete, isLoading: isLoading, messageDescriptors: messageDescriptors, returnFocusRef: returnFocusRef })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9imxF.default), {
        children: isDeleteDialogOpen && /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $7tY81.default), {
            shouldCloseOnOverlayClick: !isLoading,
            onClose: onDeleteAttemptCancel,
            shouldReturnFocus: returnFocusRef,
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gpyJM.default), {
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dNPnD.default), {
                        appearance: "danger",
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                            ...messageDescriptors.title
                        })
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2v3yi.default), {
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                        ...messageDescriptors.description
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $4vluQ.default), {
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4qNCE.default), {
                            isDisabled: isLoading,
                            appearance: "subtle",
                            onClick: onDeleteAttemptCancel,
                            autoFocus: (0, $iqfTZ.fg)('alx-346-a11y-alert-details'),
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                ...(0, $lnlFs.messages).cancelButton
                            })
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1D4ep.default), {
                            appearance: "danger",
                            onClick: onDelete,
                            autoFocus: !(0, $iqfTZ.fg)('alx-346-a11y-alert-details'),
                            isLoading: isLoading,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                ...(0, $lnlFs.messages).deleteButton
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$d31ec1104ccd6307$export$73392e09138fecd6.displayName = "DeleteModal";

});
parcelRegister("lnlFs", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c9bf5a9c5ecc174f$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $c9bf5a9c5ecc174f$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    cancelButton: {
        id: 'eoc.alert-detail.delete-modal.cancel-button',
        defaultMessage: 'Cancel',
        description: 'The text will be displayed in the delete modal footer for cancel button.'
    },
    deleteButton: {
        id: 'eoc.alert-detail.extra-property.delete-modal.delete-button',
        defaultMessage: 'Delete',
        description: 'The text will be displayed in the delete modal footer for delete button.'
    }
});

});


parcelRegister("kYcMD", function(module, exports) {
$parcel$export(module.exports, "useStarredSearchService", () => $0855e8cbb26bd24c$export$408fb52d8305f8a5);

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $kt86l = parcelRequire("kt86l");

var $iQPOZ = parcelRequire("iQPOZ");

var $41zCK = parcelRequire("41zCK");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $1Pd0K = parcelRequire("1Pd0K");

var $dp0Rz = parcelRequire("dp0Rz");

var $gD9HZ = parcelRequire("gD9HZ");
const $0855e8cbb26bd24c$var$starSavedSearchError = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations-service-use-starred-search.star-saved-search-error",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Failed to star saved search"
});
const $0855e8cbb26bd24c$var$unstarSavedSearchError = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations-service-use-starred-search.unstar-saved-search-error",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Failed to unstar saved search"
});
const $0855e8cbb26bd24c$export$408fb52d8305f8a5 = ()=>{
    const environment = (0, $n67Vb.useRelayEnvironment)();
    const cloudId = (0, $kt86l.useCloudId)();
    const { showFlag: showFlag } = (0, $iQPOZ.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const getSearchIdFromAriOrPredefined = (search)=>{
        const searchId = (0, $1Pd0K.OpsgenieSavedSearchAri).parse(search).savedSearchId;
        if (!searchId) throw new Error('Invalid saved search ID');
        return searchId;
    };
    const removeStarredSearchFromCache = (0, $euxye.useCallback)((searchId)=>{
        (0, $n67Vb.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const opsgenie = root.getLinkedRecord('opsgenie');
            if (opsgenie) {
                const savedSearches = opsgenie.getLinkedRecord('savedSearches', {
                    cloudId: cloudId
                });
                if (savedSearches) {
                    const starred = savedSearches.getLinkedRecords('starred') || [];
                    const newStarred = starred.filter((item)=>item?.getValue('id') !== searchId);
                    savedSearches.setLinkedRecords(newStarred, 'starred');
                }
            }
        });
    }, [
        environment,
        cloudId
    ]);
    const starSavedSearch = (0, $euxye.useCallback)(async (savedSearch)=>{
        await (0, $gD9HZ.updateStarredSavedSearch)(getSearchIdFromAriOrPredefined(savedSearch.id)).then(()=>{
            (0, $n67Vb.commitLocalUpdate)(environment, (store)=>{
                const root = store.getRoot();
                const opsgenie = root.getLinkedRecord('opsgenie');
                if (opsgenie) {
                    const savedSearches = opsgenie.getLinkedRecord('savedSearches', {
                        cloudId: cloudId
                    });
                    if (savedSearches) {
                        const savedSearchId = (0, $dp0Rz.default)({
                            id: savedSearch.id
                        }, 'OpsgenieSavedSearch');
                        if (!savedSearchId) throw new Error('Saved search ID not found');
                        const existingSavedSearch = store.get(savedSearchId);
                        if (existingSavedSearch) {
                            const starred = savedSearches.getLinkedRecords('starred') ?? [];
                            savedSearches.setLinkedRecords([
                                ...starred,
                                existingSavedSearch
                            ], 'starred');
                        } else throw new Error('Saved search not found');
                    }
                }
                (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'savedSearch starred', {
                    opsgenieSavedSearchId: savedSearch.id
                });
            });
        }).catch((error)=>{
            (0, $41zCK.default)({
                meta: {
                    id: 'starSavedSearch',
                    packageName: 'jiraNavigationAppsSidebarNav4SidebarsContentOperations',
                    teamName: 'Alexstrasza'
                },
                error: error
            });
            showFlag({
                type: 'error',
                title: formatMessage($0855e8cbb26bd24c$var$starSavedSearchError),
                // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
                messageId: 'navigation-apps-sidebar-nav4-sidebars-content-operations.service.use-starred-search.show-flag.error.star-saved-search',
                messageType: 'transactional'
            });
        });
    }, [
        environment,
        createAnalyticsEvent,
        cloudId,
        showFlag,
        formatMessage
    ]);
    const unstarSavedSearch = (0, $euxye.useCallback)(async (savedSearch)=>{
        await (0, $gD9HZ.deleteStarredSavedSearch)(getSearchIdFromAriOrPredefined(savedSearch.id)).then(()=>{
            removeStarredSearchFromCache(savedSearch.id);
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'savedSearch unstarred', {
                opsgenieSavedSearchId: savedSearch.id
            });
        }).catch((error)=>{
            (0, $41zCK.default)({
                meta: {
                    id: 'unstarSavedSearch',
                    packageName: 'jiraNavigationAppsSidebarNav4SidebarsContentOperations',
                    teamName: 'Alexstrasza'
                },
                error: error
            });
            showFlag({
                type: 'error',
                title: formatMessage($0855e8cbb26bd24c$var$unstarSavedSearchError),
                // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
                messageId: 'navigation-apps-sidebar-nav4-sidebars-content-operations.service.use-starred-search.show-flag.error.unstar-saved-search',
                messageType: 'transactional'
            });
        });
    }, [
        createAnalyticsEvent,
        formatMessage,
        showFlag,
        removeStarredSearchFromCache
    ]);
    return {
        starSavedSearch: starSavedSearch,
        unstarSavedSearch: unstarSavedSearch,
        removeStarredSearchFromCache: removeStarredSearchFromCache
    };
};

});
parcelRegister("41zCK", function(module, exports) {
$parcel$export(module.exports, "initialiseErrorAnalyticsClient", () => $4ee08a7cdff60118$export$d4079397f9611138);
$parcel$export(module.exports, "default", () => $4ee08a7cdff60118$export$2e2bcd8739ae039);

var $6jLTU = parcelRequire("6jLTU");

var $3irVK = parcelRequire("3irVK");

var $i8cjP = parcelRequire("i8cjP");
var $2dPVE = parcelRequire("2dPVE");

var $4eC2O = parcelRequire("4eC2O");
let $4ee08a7cdff60118$var$analyticsClient;
const $4ee08a7cdff60118$export$d4079397f9611138 = (client)=>{
    $4ee08a7cdff60118$var$analyticsClient = client;
};
const $4ee08a7cdff60118$export$bf406c01a195b215 = ()=>{
    $4ee08a7cdff60118$var$analyticsClient = undefined;
};
const $4ee08a7cdff60118$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (false) {
        if (error) throw error;
        else {
            const payload = event && (0, $i8cjP.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($3irVK)))({
            ...attributes,
            packageName: packageName,
            teamName: teamName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6jLTU))));
        if (event && event.context) {
            const fullEvent = (0, $i8cjP.extractAWCDataFromEvent)(event);
            (0, $4eC2O.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $4eC2O.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $2dPVE.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($4ee08a7cdff60118$var$analyticsClient && $4ee08a7cdff60118$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $4ee08a7cdff60118$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $4eC2O.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $4ee08a7cdff60118$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $4ee08a7cdff60118$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $4ee08a7cdff60118$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $4ee08a7cdff60118$export$2e2bcd8739ae039 = $4ee08a7cdff60118$var$fireErrorAnalytics;

});
parcelRegister("i8cjP", function(module, exports) {
$parcel$export(module.exports, "extractAWCDataFromEvent", () => $4d7500ef840abd33$export$1c850cf68c053906);
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $808aL = parcelRequire("808aL");

var $3irVK = parcelRequire("3irVK");


var $2EioZ = parcelRequire("2EioZ");
const $4d7500ef840abd33$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $2EioZ.getAnalyticsType)(castedEvent);
    const attributes = (0, $2EioZ.getAttributes)(castedEvent);
    const source = (0, $2EioZ.getSource)(castedEvent);
    const actionSubject = (0, $2EioZ.getActionSubject)(castedEvent);
    if (analyticsType === (0, $e65b8f9d551f9806$export$f1d537d508d2945a)) return {
        type: (0, $e65b8f9d551f9806$export$f1d537d508d2945a),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $e65b8f9d551f9806$export$a1562d08625f5d7e:
        case 0, $e65b8f9d551f9806$export$947dac6c72b26f81:
        case 0, $e65b8f9d551f9806$export$12346a674644c156:
            {
                const action = (0, $2EioZ.getAction)(castedEvent);
                const actionSubjectId = (0, $2EioZ.getActionSubjectId)(castedEvent);
                const containerId = (0, $2EioZ.getContainerId)(castedEvent);
                const containerType = (0, $2EioZ.getContainerType)(castedEvent);
                const objectId = (0, $2EioZ.getObjectId)(castedEvent);
                const objectType = (0, $2EioZ.getObjectType)(castedEvent);
                const tags = (0, $2EioZ.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($3irVK)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($808aL))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};

});
const $e65b8f9d551f9806$export$f636b5b56f1d624a = 'Screen';
const $e65b8f9d551f9806$export$9d2de6eebf7462b5 = 'Drawer';
const $e65b8f9d551f9806$export$1171103ea9083ffa = 'Modal';
const $e65b8f9d551f9806$export$cae2783c9279926 = 'InlineDialog';
const $e65b8f9d551f9806$export$d1123261ca8831d2 = 'Dropdown';
const $e65b8f9d551f9806$export$a1562d08625f5d7e = 'UI';
const $e65b8f9d551f9806$export$947dac6c72b26f81 = 'TRACK';
const $e65b8f9d551f9806$export$f1d537d508d2945a = 'SCREEN';
const $e65b8f9d551f9806$export$12346a674644c156 = 'OPERATIONAL';
const $e65b8f9d551f9806$export$2ceccf177fae277c = 'analyticsBridge';

parcelRegister("2EioZ", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsType", () => $8963ff3bda378ab5$export$a3569ac53b82a914);
$parcel$export(module.exports, "getAttributes", () => $8963ff3bda378ab5$export$fe94072fee8a6976);
$parcel$export(module.exports, "getSource", () => $8963ff3bda378ab5$export$dd2b6e807fb37ba3);
$parcel$export(module.exports, "getActionSubject", () => $8963ff3bda378ab5$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getAction", () => $8963ff3bda378ab5$export$6ca3170acb89054);
$parcel$export(module.exports, "getActionSubjectId", () => $8963ff3bda378ab5$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getContainerId", () => $8963ff3bda378ab5$export$7c8178cc9001d237);
$parcel$export(module.exports, "getContainerType", () => $8963ff3bda378ab5$export$acc6f3e19803b3dc);
$parcel$export(module.exports, "getObjectId", () => $8963ff3bda378ab5$export$fa986b91291934c7);
$parcel$export(module.exports, "getObjectType", () => $8963ff3bda378ab5$export$11cc42aebef2ef3a);
$parcel$export(module.exports, "getTags", () => $8963ff3bda378ab5$export$af63d7414243dad3);

var $cIPCk = parcelRequire("cIPCk");

var $808aL = parcelRequire("808aL");

var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

var $3irVK = parcelRequire("3irVK");

var $9O1Qa = parcelRequire("9O1Qa");
const $8963ff3bda378ab5$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $8963ff3bda378ab5$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $8963ff3bda378ab5$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $8963ff3bda378ab5$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $8963ff3bda378ab5$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($3irVK)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($808aL))));
};
const $8963ff3bda378ab5$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))($8963ff3bda378ab5$var$extractFromContext(event, 'source').filter(Boolean));
const $8963ff3bda378ab5$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))($8963ff3bda378ab5$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))($8963ff3bda378ab5$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $8963ff3bda378ab5$export$6ca3170acb89054 = (event)=>event.payload.action;
const $8963ff3bda378ab5$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $8963ff3bda378ab5$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))($8963ff3bda378ab5$var$extractFromContext(event, 'containerId').filter(Boolean));
const $8963ff3bda378ab5$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))($8963ff3bda378ab5$var$extractFromContext(event, 'containerType').filter(Boolean));
const $8963ff3bda378ab5$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))($8963ff3bda378ab5$var$extractFromContext(event, 'objectId').filter(Boolean));
const $8963ff3bda378ab5$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))($8963ff3bda378ab5$var$extractFromContext(event, 'objectType').filter(Boolean));
const $8963ff3bda378ab5$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($9O1Qa)))((0, (/*@__PURE__*/$parcel$interopDefault($cIPCk)))($8963ff3bda378ab5$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};

});


parcelRegister("2dPVE", function(module, exports) {
$parcel$export(module.exports, "fireAnalytics", () => $a814fa3596099bc4$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $a814fa3596099bc4$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $a814fa3596099bc4$export$13990ad4625571ed);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $a814fa3596099bc4$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireScreenAnalytics", () => $a814fa3596099bc4$export$6f46fb37ad7d962b);

var $hlxpN = parcelRequire("hlxpN");


var $9VfpG = parcelRequire("9VfpG");
const $a814fa3596099bc4$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $e65b8f9d551f9806$export$2ceccf177fae277c));
};
const $a814fa3596099bc4$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $a814fa3596099bc4$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $9VfpG.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $a814fa3596099bc4$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $a814fa3596099bc4$export$34ac71ce24cddec2(event, (0, $e65b8f9d551f9806$export$a1562d08625f5d7e), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $a814fa3596099bc4$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $9VfpG.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $a814fa3596099bc4$export$34ac71ce24cddec2(event, (0, $e65b8f9d551f9806$export$947dac6c72b26f81), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $a814fa3596099bc4$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $9VfpG.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $a814fa3596099bc4$export$34ac71ce24cddec2(event, (0, $e65b8f9d551f9806$export$12346a674644c156), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $a814fa3596099bc4$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $9VfpG.getImperativeAnalyticsDataFromArguments)(rest);
    $a814fa3596099bc4$export$34ac71ce24cddec2(event, (0, $e65b8f9d551f9806$export$f1d537d508d2945a), {
        attributes: attributes
    });
};

});
parcelRegister("9VfpG", function(module, exports) {
$parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", () => $2b0dbe8536be4236$export$e6baab532ef8c6bf);
const $2b0dbe8536be4236$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $2b0dbe8536be4236$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $2b0dbe8536be4236$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $2b0dbe8536be4236$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $2b0dbe8536be4236$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $2b0dbe8536be4236$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $2b0dbe8536be4236$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $2b0dbe8536be4236$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $2b0dbe8536be4236$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $2b0dbe8536be4236$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $2b0dbe8536be4236$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $2b0dbe8536be4236$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

});


parcelRegister("4eC2O", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $2ba52ebd8b9a1d8a$export$f5282963edea4a68);

var $fX5Kd = parcelRequire("fX5Kd");
const $2ba52ebd8b9a1d8a$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $fX5Kd.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $2ba52ebd8b9a1d8a$export$f5282963edea4a68 = (location, error, details = {})=>(0, $fX5Kd.default).captureException(location, error, details);

});
parcelRegister("fX5Kd", function(module, exports) {
$parcel$export(module.exports, "default", () => $264e866f35d806f4$export$2e2bcd8739ae039);
// This is the only file that should directly import Raven.

var $6nrSE = parcelRequire("6nrSE");
var $fdv6x = parcelRequire("fdv6x");
var $h9BXt = parcelRequire("h9BXt");

var $80ILg = parcelRequire("80ILg");
var $5HREu = parcelRequire("5HREu");
var $3FT1D = parcelRequire("3FT1D");
var $bDBth = parcelRequire("bDBth");

var $9O1Qa = parcelRequire("9O1Qa");
const $264e866f35d806f4$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($9O1Qa)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $264e866f35d806f4$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $264e866f35d806f4$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $264e866f35d806f4$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $264e866f35d806f4$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $fdv6x.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $264e866f35d806f4$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$264e866f35d806f4$var$getFilteredIntegrations(integrations),
                new $5HREu.Dedupe(),
                new $3FT1D.ExtraErrorData(),
                new $bDBth.Transaction(),
                new $80ILg.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $h9BXt.init({
        ...defaultConfig,
        ...config
    });
    try {
        $6nrSE.setExtras(getExtraContext());
    } catch (e) {
        $6nrSE.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $264e866f35d806f4$var$tags = [
    'packageName',
    'teamName'
];
const $264e866f35d806f4$var$captureException = (location, error, details)=>{
    $6nrSE.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($264e866f35d806f4$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $6nrSE.captureException(error);
};
const $264e866f35d806f4$var$sentryErrorHandler = {
    installGlobalHandler: $264e866f35d806f4$var$installGlobalHandler,
    captureException: $264e866f35d806f4$var$captureException
};
var $264e866f35d806f4$export$2e2bcd8739ae039 = $264e866f35d806f4$var$sentryErrorHandler;

});
parcelRegister("6nrSE", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $4a4a848bd9a94a37$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $4a4a848bd9a94a37$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $4a4a848bd9a94a37$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $4a4a848bd9a94a37$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $4a4a848bd9a94a37$export$efda9a273d7a036d);
$parcel$export(module.exports, "setContext", () => $4a4a848bd9a94a37$export$2f04de43fe27971a);
$parcel$export(module.exports, "setExtras", () => $4a4a848bd9a94a37$export$bb4922da0dd51b92);
$parcel$export(module.exports, "setTags", () => $4a4a848bd9a94a37$export$74a8fb34822092e6);
$parcel$export(module.exports, "setExtra", () => $4a4a848bd9a94a37$export$8e8e7789d42ed61d);
$parcel$export(module.exports, "setTag", () => $4a4a848bd9a94a37$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $4a4a848bd9a94a37$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "withScope", () => $4a4a848bd9a94a37$export$ec58d9285c204497);
$parcel$export(module.exports, "startTransaction", () => $4a4a848bd9a94a37$export$e262da7ae6480481);

var $j9yrT = parcelRequire("j9yrT");

var $fdv6x = parcelRequire("fdv6x");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4a4a848bd9a94a37$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $fdv6x.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $j9yrT.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $4a4a848bd9a94a37$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return $4a4a848bd9a94a37$var$callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $4a4a848bd9a94a37$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $4a4a848bd9a94a37$var$callOnHub('captureMessage', message, level, (0, $j9yrT.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $4a4a848bd9a94a37$export$1462b974fdcf6ba2(event) {
    return $4a4a848bd9a94a37$var$callOnHub('captureEvent', event);
}
function $4a4a848bd9a94a37$export$99d44f04437e9cb8(callback) {
    $4a4a848bd9a94a37$var$callOnHub('configureScope', callback);
}
function $4a4a848bd9a94a37$export$efda9a273d7a036d(breadcrumb) {
    $4a4a848bd9a94a37$var$callOnHub('addBreadcrumb', breadcrumb);
}
function $4a4a848bd9a94a37$export$2f04de43fe27971a(name, context) {
    $4a4a848bd9a94a37$var$callOnHub('setContext', name, context);
}
function $4a4a848bd9a94a37$export$bb4922da0dd51b92(extras) {
    $4a4a848bd9a94a37$var$callOnHub('setExtras', extras);
}
function $4a4a848bd9a94a37$export$74a8fb34822092e6(tags) {
    $4a4a848bd9a94a37$var$callOnHub('setTags', tags);
}
function $4a4a848bd9a94a37$export$8e8e7789d42ed61d(key, extra) {
    $4a4a848bd9a94a37$var$callOnHub('setExtra', key, extra);
}
function $4a4a848bd9a94a37$export$a37d07ee78eb4569(key, value) {
    $4a4a848bd9a94a37$var$callOnHub('setTag', key, value);
}
function $4a4a848bd9a94a37$export$8b6bb3dd62a01be2(user) {
    $4a4a848bd9a94a37$var$callOnHub('setUser', user);
}
function $4a4a848bd9a94a37$export$ec58d9285c204497(callback) {
    $4a4a848bd9a94a37$var$callOnHub('withScope', callback);
}
function $4a4a848bd9a94a37$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $4a4a848bd9a94a37$var$callOnHub.apply(void 0, (0, $j9yrT.__spread)([
        '_invokeClient',
        method
    ], args));
}
function $4a4a848bd9a94a37$export$e262da7ae6480481(context, customSamplingContext) {
    return $4a4a848bd9a94a37$var$callOnHub('startTransaction', (0, $j9yrT.__assign)({}, context), customSamplingContext);
}

});
parcelRegister("fdv6x", function(module, exports) {
$parcel$export(module.exports, "Hub", () => $b14032a1f2441bca$export$8c41bb232f1008b1);
$parcel$export(module.exports, "makeMain", () => $b14032a1f2441bca$export$4188a14ad302d1bc);
$parcel$export(module.exports, "getHubFromCarrier", () => $b14032a1f2441bca$export$bfa8a924a84a76b7);
$parcel$export(module.exports, "getCurrentHub", () => $b14032a1f2441bca$export$a07cdf6544bbd7c);

var $j9yrT = parcelRequire("j9yrT");
parcelRequire("2bF1o");
var $dzKCt = parcelRequire("dzKCt");
var $k7YwO = parcelRequire("k7YwO");
var $8g860 = parcelRequire("8g860");
var $1PyaG = parcelRequire("1PyaG");
var $707qy = parcelRequire("707qy");

var $hL3dv = parcelRequire("hL3dv");

var $jhDCe = parcelRequire("jhDCe");

var $fUIBL = parcelRequire("fUIBL");
var $b14032a1f2441bca$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $b14032a1f2441bca$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $b14032a1f2441bca$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $jhDCe.Scope)();
        if (_version === void 0) _version = $b14032a1f2441bca$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $jhDCe.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $707qy.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $707qy.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $707qy.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $b14032a1f2441bca$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $k7YwO.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $j9yrT.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $dzKCt.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $b14032a1f2441bca$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $b14032a1f2441bca$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $hL3dv.IS_DEBUG_BUILD) && (0, $dzKCt.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $8g860.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $fUIBL.Session)((0, $j9yrT.__assign)((0, $j9yrT.__assign)((0, $j9yrT.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $j9yrT.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $b14032a1f2441bca$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $hL3dv.IS_DEBUG_BUILD) && (0, $dzKCt.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $b14032a1f2441bca$export$19eade501500c6c1() {
    var carrier = (0, $8g860.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $b14032a1f2441bca$export$4188a14ad302d1bc(hub) {
    var registry = $b14032a1f2441bca$export$19eade501500c6c1();
    var oldHub = $b14032a1f2441bca$export$bfa8a924a84a76b7(registry);
    $b14032a1f2441bca$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $b14032a1f2441bca$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $b14032a1f2441bca$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$b14032a1f2441bca$var$hasHubOnCarrier(registry) || $b14032a1f2441bca$export$bfa8a924a84a76b7(registry).isOlderThan($b14032a1f2441bca$export$24a86ef7798177e4)) $b14032a1f2441bca$export$849f05434e95d2f2(registry, new $b14032a1f2441bca$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $1PyaG.isNodeEnv)()) return $b14032a1f2441bca$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $b14032a1f2441bca$export$bfa8a924a84a76b7(registry);
}
function $b14032a1f2441bca$export$1c4d656130202699() {
    (0, $hL3dv.IS_DEBUG_BUILD) && (0, $dzKCt.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = $b14032a1f2441bca$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $b14032a1f2441bca$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $b14032a1f2441bca$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $b14032a1f2441bca$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$b14032a1f2441bca$var$hasHubOnCarrier(activeDomain) || $b14032a1f2441bca$export$bfa8a924a84a76b7(activeDomain).isOlderThan($b14032a1f2441bca$export$24a86ef7798177e4)) {
            var registryHubTopStack = $b14032a1f2441bca$export$bfa8a924a84a76b7(registry).getStackTop();
            $b14032a1f2441bca$export$849f05434e95d2f2(activeDomain, new $b14032a1f2441bca$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $jhDCe.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $b14032a1f2441bca$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $b14032a1f2441bca$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $b14032a1f2441bca$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $b14032a1f2441bca$export$bfa8a924a84a76b7(carrier) {
    return (0, $8g860.getGlobalSingleton)('hub', function() {
        return new $b14032a1f2441bca$export$8c41bb232f1008b1();
    }, carrier);
}
function $b14032a1f2441bca$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("2bF1o", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("8g860")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("8g860")).getGlobalSingleton);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("7ZChr")).isPlainObject);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("7ZChr")).isThenable);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("dzKCt")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("dzKCt")).logger);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("707qy")).uuid4);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("aSEMY")).dropUndefinedKeys);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("3tqiy")).SyncPromise);





parcelRequire("8g860");

parcelRequire("7ZChr");
parcelRequire("dzKCt");

parcelRequire("707qy");

var $1PyaG = parcelRequire("1PyaG");

parcelRequire("aSEMY");







parcelRequire("3tqiy");

var $k7YwO = parcelRequire("k7YwO");





$parcel$exportWildcard(module.exports, $1PyaG);
$parcel$exportWildcard(module.exports, $k7YwO);

});
parcelRegister("8g860", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $60361904fcb8b4ae$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $60361904fcb8b4ae$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $1PyaG = parcelRequire("1PyaG");
var $60361904fcb8b4ae$var$fallbackGlobalObject = {};
function $60361904fcb8b4ae$export$256479dc0cea61c4() {
    return (0, $1PyaG.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $60361904fcb8b4ae$var$fallbackGlobalObject;
}
function $60361904fcb8b4ae$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $60361904fcb8b4ae$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("1PyaG", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $7Ea7A = parcelRequire("7Ea7A");

var $gIMgJ = parcelRequire("gIMgJ");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $7Ea7A.isBrowserBundle)() && Object.prototype.toString.call(typeof $gIMgJ !== 'undefined' ? $gIMgJ : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("7Ea7A", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $59141ebc4909ee1c$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $59141ebc4909ee1c$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("7ZChr", function(module, exports) {
$parcel$export(module.exports, "isError", () => $5d1bec9b3e722551$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $5d1bec9b3e722551$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $5d1bec9b3e722551$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $5d1bec9b3e722551$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $5d1bec9b3e722551$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $5d1bec9b3e722551$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $5d1bec9b3e722551$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $5d1bec9b3e722551$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $5d1bec9b3e722551$export$f5b060c2914b97c8);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $5d1bec9b3e722551$var$objectToString = Object.prototype.toString;
function $5d1bec9b3e722551$export$e6127cc7fe7395c3(wat) {
    switch($5d1bec9b3e722551$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $5d1bec9b3e722551$export$49034edbe6b62415(wat, Error);
    }
}
function $5d1bec9b3e722551$var$isBuiltin(wat, ty) {
    return $5d1bec9b3e722551$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $5d1bec9b3e722551$export$9f9636d330b71954(wat) {
    return $5d1bec9b3e722551$var$isBuiltin(wat, 'ErrorEvent');
}
function $5d1bec9b3e722551$export$ef9e2056653f0c8e(wat) {
    return $5d1bec9b3e722551$var$isBuiltin(wat, 'DOMError');
}
function $5d1bec9b3e722551$export$12e869b2a583f783(wat) {
    return $5d1bec9b3e722551$var$isBuiltin(wat, 'DOMException');
}
function $5d1bec9b3e722551$export$844ec244b1367d54(wat) {
    return $5d1bec9b3e722551$var$isBuiltin(wat, 'String');
}
function $5d1bec9b3e722551$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $5d1bec9b3e722551$export$53b83ca8eaab0383(wat) {
    return $5d1bec9b3e722551$var$isBuiltin(wat, 'Object');
}
function $5d1bec9b3e722551$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $5d1bec9b3e722551$export$49034edbe6b62415(wat, Event);
}
function $5d1bec9b3e722551$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $5d1bec9b3e722551$export$49034edbe6b62415(wat, Element);
}
function $5d1bec9b3e722551$export$49841c62b9eff15(wat) {
    return $5d1bec9b3e722551$var$isBuiltin(wat, 'RegExp');
}
function $5d1bec9b3e722551$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $5d1bec9b3e722551$export$bc2894c7158efbac(wat) {
    return $5d1bec9b3e722551$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $5d1bec9b3e722551$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $5d1bec9b3e722551$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("dzKCt", function(module, exports) {
$parcel$export(module.exports, "consoleSandbox", () => $9e22b4f0a07409a4$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $9e22b4f0a07409a4$export$af88d00dbe7f521);

var $j9yrT = parcelRequire("j9yrT");

var $cqCDT = parcelRequire("cqCDT");

var $8g860 = parcelRequire("8g860");
// TODO: Implement different loggers for different environments
var $9e22b4f0a07409a4$var$global = (0, $8g860.getGlobalObject)();
/** Prefix for logging strings */ var $9e22b4f0a07409a4$var$PREFIX = 'Sentry Logger ';
var $9e22b4f0a07409a4$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $9e22b4f0a07409a4$export$cda52e2a8927a2ca(callback) {
    var global = (0, $8g860.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $9e22b4f0a07409a4$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $9e22b4f0a07409a4$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $cqCDT.IS_DEBUG_BUILD) $9e22b4f0a07409a4$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $9e22b4f0a07409a4$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $9e22b4f0a07409a4$var$global.console)[name].apply(_a, (0, $j9yrT.__spread)([
                    $9e22b4f0a07409a4$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $9e22b4f0a07409a4$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $9e22b4f0a07409a4$export$af88d00dbe7f521;
if (0, $cqCDT.IS_DEBUG_BUILD) $9e22b4f0a07409a4$export$af88d00dbe7f521 = (0, $8g860.getGlobalSingleton)('logger', $9e22b4f0a07409a4$var$makeLogger);
else $9e22b4f0a07409a4$export$af88d00dbe7f521 = $9e22b4f0a07409a4$var$makeLogger();

});
parcelRegister("cqCDT", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $90c5e358c26daf3f$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $90c5e358c26daf3f$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("707qy", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $518e4b62a7f3ae8b$export$19f53698e68b2496);

var $j9yrT = parcelRequire("j9yrT");

var $8g860 = parcelRequire("8g860");

var $aSEMY = parcelRequire("aSEMY");

var $4D1ol = parcelRequire("4D1ol");
function $518e4b62a7f3ae8b$export$19f53698e68b2496() {
    var global = (0, $8g860.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $518e4b62a7f3ae8b$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $518e4b62a7f3ae8b$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $518e4b62a7f3ae8b$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $518e4b62a7f3ae8b$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $518e4b62a7f3ae8b$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $518e4b62a7f3ae8b$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $518e4b62a7f3ae8b$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $j9yrT.__assign)((0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $518e4b62a7f3ae8b$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $518e4b62a7f3ae8b$export$d364f2020ab30578(input) {
    var match = input.match($518e4b62a7f3ae8b$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $518e4b62a7f3ae8b$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $4D1ol.snipLine)(line, 0);
    });
    frame.context_line = (0, $4D1ol.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $4D1ol.snipLine)(line, 0);
    });
}
function $518e4b62a7f3ae8b$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $518e4b62a7f3ae8b$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $aSEMY.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});
parcelRegister("aSEMY", function(module, exports) {
$parcel$export(module.exports, "addNonEnumerableProperty", () => $7ebe96552bdb12a3$export$e73679ffaf56810e);
$parcel$export(module.exports, "dropUndefinedKeys", () => $7ebe96552bdb12a3$export$d25f2688db1bb433);

var $j9yrT = parcelRequire("j9yrT");

var $gNYW1 = parcelRequire("gNYW1");

var $7ZChr = parcelRequire("7ZChr");

var $4D1ol = parcelRequire("4D1ol");
function $7ebe96552bdb12a3$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $7ebe96552bdb12a3$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $7ebe96552bdb12a3$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $7ebe96552bdb12a3$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $7ebe96552bdb12a3$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $7ebe96552bdb12a3$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $7ebe96552bdb12a3$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $7ebe96552bdb12a3$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $7ZChr.isError)(value)) newObj = (0, $j9yrT.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $7ebe96552bdb12a3$var$getOwnProperties(value));
    else if ((0, $7ZChr.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $j9yrT.__assign)({
            type: event_1.type,
            target: $7ebe96552bdb12a3$var$serializeEventTarget(event_1.target),
            currentTarget: $7ebe96552bdb12a3$var$serializeEventTarget(event_1.currentTarget)
        }, $7ebe96552bdb12a3$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $7ZChr.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $7ebe96552bdb12a3$var$serializeEventTarget(target) {
    try {
        return (0, $7ZChr.isElement)(target) ? (0, $gNYW1.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $7ebe96552bdb12a3$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $7ebe96552bdb12a3$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($7ebe96552bdb12a3$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $4D1ol.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $4D1ol.truncate)(serialized, maxLength);
    }
    return '';
}
function $7ebe96552bdb12a3$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $7ZChr.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $j9yrT.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $7ebe96552bdb12a3$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($7ebe96552bdb12a3$export$d25f2688db1bb433);
    return val;
}
function $7ebe96552bdb12a3$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $7ZChr.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("gNYW1", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $c3c07d599e9cf475$export$5647df6b7814ac86);

var $8g860 = parcelRequire("8g860");

var $7ZChr = parcelRequire("7ZChr");
function $c3c07d599e9cf475$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $c3c07d599e9cf475$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $c3c07d599e9cf475$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $7ZChr.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $c3c07d599e9cf475$export$1cfafeee2987818b() {
    var global = (0, $8g860.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});

parcelRegister("4D1ol", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $35ebe24eee1819b7$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $35ebe24eee1819b7$export$4215662d762d6f9d);

var $7ZChr = parcelRequire("7ZChr");
function $35ebe24eee1819b7$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $35ebe24eee1819b7$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $35ebe24eee1819b7$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $35ebe24eee1819b7$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $7ZChr.isString)(value)) return false;
    if ((0, $7ZChr.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $35ebe24eee1819b7$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});



parcelRegister("3tqiy", function(module, exports) {
$parcel$export(module.exports, "SyncPromise", () => $28787ad1856f7979$export$6f292d4960313241);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7ZChr = parcelRequire("7ZChr");
function $28787ad1856f7979$export$1fda8aa4d135f8aa(value) {
    return new $28787ad1856f7979$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $28787ad1856f7979$export$78e43115b553f358(reason) {
    return new $28787ad1856f7979$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $28787ad1856f7979$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $7ZChr.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});

parcelRegister("k7YwO", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);

var $8g860 = parcelRequire("8g860");

var $1PyaG = parcelRequire("1PyaG");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $8g860.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $1PyaG.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $1PyaG.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $8g860.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});


parcelRegister("hL3dv", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $ced9523c14144e5d$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $ced9523c14144e5d$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("jhDCe", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $e09e55b62fb0e0a6$export$775b6bb06e53a214);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $e09e55b62fb0e0a6$export$8e4e25f54d456511);

var $j9yrT = parcelRequire("j9yrT");
parcelRequire("2bF1o");
var $k7YwO = parcelRequire("k7YwO");
var $8g860 = parcelRequire("8g860");
var $7ZChr = parcelRequire("7ZChr");
var $3tqiy = parcelRequire("3tqiy");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $e09e55b62fb0e0a6$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $e09e55b62fb0e0a6$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $j9yrT.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $j9yrT.__assign)({}, scope._tags);
            newScope._extra = (0, $j9yrT.__assign)({}, scope._extra);
            newScope._contexts = (0, $j9yrT.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $j9yrT.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $7ZChr.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $e09e55b62fb0e0a6$var$MAX_BREADCRUMBS) : $e09e55b62fb0e0a6$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $j9yrT.__assign)({
            timestamp: (0, $k7YwO.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $j9yrT.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $j9yrT.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $j9yrT.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $j9yrT.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $j9yrT.__spread)($e09e55b62fb0e0a6$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $3tqiy.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, $j9yrT.__assign)({}, event), hint);
                if ((0, $7ZChr.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $e09e55b62fb0e0a6$var$getGlobalEventProcessors() {
    return (0, $8g860.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function $e09e55b62fb0e0a6$export$8e4e25f54d456511(callback) {
    $e09e55b62fb0e0a6$var$getGlobalEventProcessors().push(callback);
}

});

parcelRegister("fUIBL", function(module, exports) {
$parcel$export(module.exports, "Session", () => $b95eb0353adc8ef0$export$1fb4852a55678982);
parcelRequire("2bF1o");
var $aSEMY = parcelRequire("aSEMY");
var $k7YwO = parcelRequire("k7YwO");
var $707qy = parcelRequire("707qy");
/**
 * @inheritdoc
 */ var $b95eb0353adc8ef0$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $707qy.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $k7YwO.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $k7YwO.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $707qy.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $aSEMY.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

});



parcelRegister("h9BXt", function(module, exports) {
$parcel$export(module.exports, "init", () => $c7d0b8aa8996c720$export$2cd8252107eb640b);

var $j9yrT = parcelRequire("j9yrT");

var $fdv6x = parcelRequire("fdv6x");
var $12tLa = parcelRequire("12tLa");
var $9TgNM = parcelRequire("9TgNM");
parcelRequire("3vRyE");
var $gOtgI = parcelRequire("gOtgI");
var $fsUz1 = parcelRequire("fsUz1");
var $exDIp = parcelRequire("exDIp");
var $bJ4ny = parcelRequire("bJ4ny");

var $kNIG0 = parcelRequire("kNIG0");

var $gXBaL = parcelRequire("gXBaL");

var $cjIFI = parcelRequire("cjIFI");

var $04KEt = parcelRequire("04KEt");
var $9E5Pa = parcelRequire("9E5Pa");
var $12eoL = parcelRequire("12eoL");
var $7UL7Z = parcelRequire("7UL7Z");
var $amw85 = parcelRequire("amw85");
var $2g5Rp = parcelRequire("2g5Rp");
var $c7d0b8aa8996c720$export$5ef831fccfce35e5 = [
    new (0, $9TgNM).InboundFilters(),
    new (0, $9TgNM).FunctionToString(),
    new (0, $amw85.TryCatch)(),
    new (0, $04KEt.Breadcrumbs)(),
    new (0, $12eoL.GlobalHandlers)(),
    new (0, $7UL7Z.LinkedErrors)(),
    new (0, $9E5Pa.Dedupe)(),
    new (0, $2g5Rp.UserAgent)()
];
function $c7d0b8aa8996c720$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $c7d0b8aa8996c720$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $fsUz1.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, $12tLa.initAndBind)((0, $kNIG0.BrowserClient), options);
    if (options.autoSessionTracking) $c7d0b8aa8996c720$var$startSessionTracking();
}
function $c7d0b8aa8996c720$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    var hub = (0, $fdv6x.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function $c7d0b8aa8996c720$export$5d4e9fd7fac8e617() {
    return (0, $fdv6x.getCurrentHub)().lastEventId();
}
function $c7d0b8aa8996c720$export$a3f323d81eede727() {
// Noop
}
function $c7d0b8aa8996c720$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $c7d0b8aa8996c720$export$4909b86c8034bf73(timeout) {
    var client = (0, $fdv6x.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, $gXBaL.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn('Cannot flush events. No client defined.');
    return (0, $bJ4ny.resolvedSyncPromise)(false);
}
function $c7d0b8aa8996c720$export$8360e631d277ea4d(timeout) {
    var client = (0, $fdv6x.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, $gXBaL.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $bJ4ny.resolvedSyncPromise)(false);
}
function $c7d0b8aa8996c720$export$4997ffc0176396a6(fn) {
    return (0, $cjIFI.wrap)(fn)();
}
function $c7d0b8aa8996c720$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $c7d0b8aa8996c720$var$startSessionTracking() {
    var window = (0, $fsUz1.getGlobalObject)();
    var document = window.document;
    if (typeof document === 'undefined') {
        (0, $gXBaL.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0, $fdv6x.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $c7d0b8aa8996c720$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $gOtgI.addInstrumentationHandler)('history', function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $c7d0b8aa8996c720$var$startSessionOnHub((0, $fdv6x.getCurrentHub)());
    });
}

});
parcelRegister("12tLa", function(module, exports) {
$parcel$export(module.exports, "initAndBind", () => $0c1d1005a3739005$export$5333c3f1c58d9bc1);

var $fdv6x = parcelRequire("fdv6x");
parcelRequire("3vRyE");
var $exDIp = parcelRequire("exDIp");

var $6uyOS = parcelRequire("6uyOS");
function $0c1d1005a3739005$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $6uyOS.IS_DEBUG_BUILD) (0, $exDIp.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    var hub = (0, $fdv6x.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

});
parcelRegister("3vRyE", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("inw3d")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("dSRLC")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("dSRLC")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("jZMY4")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("jZMY4")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("gfbw6")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("fsUz1")).getGlobalObject);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("gOtgI")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("60nuy")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("60nuy")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("60nuy")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("60nuy")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("60nuy")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("60nuy")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("60nuy")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("60nuy")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("60nuy")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("60nuy")).isThenable);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("exDIp")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("exDIp")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("iPdhn")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("iPdhn")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("iPdhn")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("iPdhn")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("iPdhn")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("iPdhn")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("4vsZe")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("4vsZe")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("k4PX7")).addNonEnumerableProperty);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("k4PX7")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("k4PX7")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("k4PX7")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("k4PX7")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("k4PX7")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("9zp5C")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("gx7D6")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("7YeiV")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("7YeiV")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("2KX1g")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("9QXUt")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("9QXUt")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("9QXUt")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("es4t5")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("es4t5")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("es4t5")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("bJ4ny")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("bJ4ny")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("bJ4ny")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("9vBQH")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("9vBQH")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("9vBQH")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("2qGnf")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("1cp6Y")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("1cp6Y")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("1cp6Y")).updateRateLimits);
parcelRequire("inw3d");
parcelRequire("dSRLC");
parcelRequire("jZMY4");

parcelRequire("gfbw6");
parcelRequire("fsUz1");
parcelRequire("gOtgI");
parcelRequire("60nuy");
parcelRequire("exDIp");

parcelRequire("iPdhn");

var $f0szJ = parcelRequire("f0szJ");
parcelRequire("4vsZe");
parcelRequire("k4PX7");

parcelRequire("9zp5C");
parcelRequire("gx7D6");
parcelRequire("7YeiV");
parcelRequire("2KX1g");
parcelRequire("9QXUt");
parcelRequire("es4t5");
parcelRequire("bJ4ny");

var $6XKQ3 = parcelRequire("6XKQ3");


parcelRequire("9vBQH");
parcelRequire("2qGnf");
parcelRequire("1cp6Y");
$parcel$exportWildcard(module.exports, $f0szJ);
$parcel$exportWildcard(module.exports, $6XKQ3);

});
parcelRegister("inw3d", function(module, exports) {
$parcel$export(module.exports, "forget", () => $d6133ca0a1ab6167$export$93c25f2590a5b540);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d6133ca0a1ab6167$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("dSRLC", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $a1ba06834385329b$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $a1ba06834385329b$export$1cfafeee2987818b);

var $fsUz1 = parcelRequire("fsUz1");

var $60nuy = parcelRequire("60nuy");
function $a1ba06834385329b$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $a1ba06834385329b$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $a1ba06834385329b$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $60nuy.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $a1ba06834385329b$export$1cfafeee2987818b() {
    var global = (0, $fsUz1.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});
parcelRegister("fsUz1", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $b42558ee7af69b61$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $b42558ee7af69b61$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $f0szJ = parcelRequire("f0szJ");
var $b42558ee7af69b61$var$fallbackGlobalObject = {};
function $b42558ee7af69b61$export$256479dc0cea61c4() {
    return (0, $f0szJ.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $b42558ee7af69b61$var$fallbackGlobalObject;
}
function $b42558ee7af69b61$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $b42558ee7af69b61$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("f0szJ", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $cNpe6 = parcelRequire("cNpe6");

var $gIMgJ = parcelRequire("gIMgJ");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $cNpe6.isBrowserBundle)() && Object.prototype.toString.call(typeof $gIMgJ !== 'undefined' ? $gIMgJ : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("cNpe6", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $950da1104d00a00f$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $950da1104d00a00f$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("60nuy", function(module, exports) {
$parcel$export(module.exports, "isError", () => $45f4f7275c108dff$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $45f4f7275c108dff$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $45f4f7275c108dff$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $45f4f7275c108dff$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $45f4f7275c108dff$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $45f4f7275c108dff$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $45f4f7275c108dff$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $45f4f7275c108dff$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $45f4f7275c108dff$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $45f4f7275c108dff$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $45f4f7275c108dff$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $45f4f7275c108dff$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $45f4f7275c108dff$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $45f4f7275c108dff$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $45f4f7275c108dff$var$objectToString = Object.prototype.toString;
function $45f4f7275c108dff$export$e6127cc7fe7395c3(wat) {
    switch($45f4f7275c108dff$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $45f4f7275c108dff$export$49034edbe6b62415(wat, Error);
    }
}
function $45f4f7275c108dff$var$isBuiltin(wat, ty) {
    return $45f4f7275c108dff$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $45f4f7275c108dff$export$9f9636d330b71954(wat) {
    return $45f4f7275c108dff$var$isBuiltin(wat, 'ErrorEvent');
}
function $45f4f7275c108dff$export$ef9e2056653f0c8e(wat) {
    return $45f4f7275c108dff$var$isBuiltin(wat, 'DOMError');
}
function $45f4f7275c108dff$export$12e869b2a583f783(wat) {
    return $45f4f7275c108dff$var$isBuiltin(wat, 'DOMException');
}
function $45f4f7275c108dff$export$844ec244b1367d54(wat) {
    return $45f4f7275c108dff$var$isBuiltin(wat, 'String');
}
function $45f4f7275c108dff$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $45f4f7275c108dff$export$53b83ca8eaab0383(wat) {
    return $45f4f7275c108dff$var$isBuiltin(wat, 'Object');
}
function $45f4f7275c108dff$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $45f4f7275c108dff$export$49034edbe6b62415(wat, Event);
}
function $45f4f7275c108dff$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $45f4f7275c108dff$export$49034edbe6b62415(wat, Element);
}
function $45f4f7275c108dff$export$49841c62b9eff15(wat) {
    return $45f4f7275c108dff$var$isBuiltin(wat, 'RegExp');
}
function $45f4f7275c108dff$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $45f4f7275c108dff$export$bc2894c7158efbac(wat) {
    return $45f4f7275c108dff$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $45f4f7275c108dff$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $45f4f7275c108dff$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("jZMY4", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $e8e9b2d72cc75f9a$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $e8e9b2d72cc75f9a$export$128827c3562ec0cb);

var $j9yrT = parcelRequire("j9yrT");

var $gfbw6 = parcelRequire("gfbw6");

var $bF6QC = parcelRequire("bF6QC");
/** Regular expression used to parse a Dsn. */ var $e8e9b2d72cc75f9a$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $e8e9b2d72cc75f9a$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $e8e9b2d72cc75f9a$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $e8e9b2d72cc75f9a$var$dsnFromString(str) {
    var match = $e8e9b2d72cc75f9a$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $gfbw6.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $j9yrT.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $e8e9b2d72cc75f9a$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $e8e9b2d72cc75f9a$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $e8e9b2d72cc75f9a$var$validateDsn(dsn) {
    if (!(0, $bF6QC.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $gfbw6.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $gfbw6.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$e8e9b2d72cc75f9a$var$isValidProtocol(protocol)) throw new (0, $gfbw6.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $gfbw6.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $e8e9b2d72cc75f9a$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $e8e9b2d72cc75f9a$var$dsnFromString(from) : $e8e9b2d72cc75f9a$var$dsnFromComponents(from);
    $e8e9b2d72cc75f9a$var$validateDsn(components);
    return components;
}

});
parcelRegister("gfbw6", function(module, exports) {
$parcel$export(module.exports, "SentryError", () => $bd36fb0662b89537$export$5949942ba2a7c0e2);

var $j9yrT = parcelRequire("j9yrT");

var $77NFJ = parcelRequire("77NFJ");
/** An error emitted by Sentry SDKs and related utilities. */ var $bd36fb0662b89537$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $77NFJ.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("77NFJ", function(module, exports) {
$parcel$export(module.exports, "setPrototypeOf", () => $52ffb7b4f0e0c6ba$export$1cb0d91350beb6cc);
var $52ffb7b4f0e0c6ba$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $52ffb7b4f0e0c6ba$var$setProtoOf : $52ffb7b4f0e0c6ba$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $52ffb7b4f0e0c6ba$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $52ffb7b4f0e0c6ba$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});


parcelRegister("bF6QC", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $87d8d5dcc1344791$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $87d8d5dcc1344791$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("gOtgI", function(module, exports) {
$parcel$export(module.exports, "addInstrumentationHandler", () => $c3d8050343a6b30c$export$285b9172a3741fb7);

var $j9yrT = parcelRequire("j9yrT");

var $bF6QC = parcelRequire("bF6QC");

var $fsUz1 = parcelRequire("fsUz1");

var $60nuy = parcelRequire("60nuy");

var $exDIp = parcelRequire("exDIp");

var $k4PX7 = parcelRequire("k4PX7");

var $7YeiV = parcelRequire("7YeiV");

var $es4t5 = parcelRequire("es4t5");
var $c3d8050343a6b30c$var$global = (0, $fsUz1.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $c3d8050343a6b30c$var$handlers = {};
var $c3d8050343a6b30c$var$instrumented = {};
/** Instruments given API */ function $c3d8050343a6b30c$var$instrument(type) {
    if ($c3d8050343a6b30c$var$instrumented[type]) return;
    $c3d8050343a6b30c$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $c3d8050343a6b30c$var$instrumentConsole();
            break;
        case 'dom':
            $c3d8050343a6b30c$var$instrumentDOM();
            break;
        case 'xhr':
            $c3d8050343a6b30c$var$instrumentXHR();
            break;
        case 'fetch':
            $c3d8050343a6b30c$var$instrumentFetch();
            break;
        case 'history':
            $c3d8050343a6b30c$var$instrumentHistory();
            break;
        case 'error':
            $c3d8050343a6b30c$var$instrumentError();
            break;
        case 'unhandledrejection':
            $c3d8050343a6b30c$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $bF6QC.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $c3d8050343a6b30c$export$285b9172a3741fb7(type, callback) {
    $c3d8050343a6b30c$var$handlers[type] = $c3d8050343a6b30c$var$handlers[type] || [];
    $c3d8050343a6b30c$var$handlers[type].push(callback);
    $c3d8050343a6b30c$var$instrument(type);
}
/** JSDoc */ function $c3d8050343a6b30c$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$c3d8050343a6b30c$var$handlers[type]) return;
    try {
        for(var _b = (0, $j9yrT.__values)($c3d8050343a6b30c$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $bF6QC.IS_DEBUG_BUILD) && (0, $exDIp.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $7YeiV.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $c3d8050343a6b30c$var$instrumentConsole() {
    if (!('console' in $c3d8050343a6b30c$var$global)) return;
    (0, $exDIp.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $c3d8050343a6b30c$var$global.console)) return;
        (0, $k4PX7.fill)($c3d8050343a6b30c$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $c3d8050343a6b30c$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($c3d8050343a6b30c$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $c3d8050343a6b30c$var$instrumentFetch() {
    if (!(0, $es4t5.supportsNativeFetch)()) return;
    (0, $k4PX7.fill)($c3d8050343a6b30c$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $c3d8050343a6b30c$var$getFetchMethod(args),
                    url: $c3d8050343a6b30c$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $c3d8050343a6b30c$var$triggerHandlers('fetch', (0, $j9yrT.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($c3d8050343a6b30c$var$global, args).then(function(response) {
                $c3d8050343a6b30c$var$triggerHandlers('fetch', (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $c3d8050343a6b30c$var$triggerHandlers('fetch', (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $c3d8050343a6b30c$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $c3d8050343a6b30c$var$global && (0, $60nuy.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $c3d8050343a6b30c$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $c3d8050343a6b30c$var$global && (0, $60nuy.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $c3d8050343a6b30c$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $c3d8050343a6b30c$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $k4PX7.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $60nuy.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $60nuy.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $c3d8050343a6b30c$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $k4PX7.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $k4PX7.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $c3d8050343a6b30c$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $c3d8050343a6b30c$var$lastHref;
/** JSDoc */ function $c3d8050343a6b30c$var$instrumentHistory() {
    if (!(0, $es4t5.supportsHistory)()) return;
    var oldOnPopState = $c3d8050343a6b30c$var$global.onpopstate;
    $c3d8050343a6b30c$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $c3d8050343a6b30c$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $c3d8050343a6b30c$var$lastHref;
        $c3d8050343a6b30c$var$lastHref = to;
        $c3d8050343a6b30c$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $c3d8050343a6b30c$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $c3d8050343a6b30c$var$lastHref = to;
                $c3d8050343a6b30c$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $k4PX7.fill)($c3d8050343a6b30c$var$global.history, 'pushState', historyReplacementFunction);
    (0, $k4PX7.fill)($c3d8050343a6b30c$var$global.history, 'replaceState', historyReplacementFunction);
}
var $c3d8050343a6b30c$var$debounceDuration = 1000;
var $c3d8050343a6b30c$var$debounceTimerID;
var $c3d8050343a6b30c$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $c3d8050343a6b30c$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $c3d8050343a6b30c$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $c3d8050343a6b30c$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $c3d8050343a6b30c$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($c3d8050343a6b30c$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($c3d8050343a6b30c$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $c3d8050343a6b30c$var$lastCapturedEvent = event;
        } else if ($c3d8050343a6b30c$var$shouldShortcircuitPreviousDebounce($c3d8050343a6b30c$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $c3d8050343a6b30c$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($c3d8050343a6b30c$var$debounceTimerID);
        $c3d8050343a6b30c$var$debounceTimerID = $c3d8050343a6b30c$var$global.setTimeout(function() {
            $c3d8050343a6b30c$var$debounceTimerID = undefined;
        }, $c3d8050343a6b30c$var$debounceDuration);
    };
}
/** JSDoc */ function $c3d8050343a6b30c$var$instrumentDOM() {
    if (!('document' in $c3d8050343a6b30c$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $c3d8050343a6b30c$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $c3d8050343a6b30c$var$makeDOMEventHandler(triggerDOMHandler, true);
    $c3d8050343a6b30c$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $c3d8050343a6b30c$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $c3d8050343a6b30c$var$global[target] && $c3d8050343a6b30c$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $k4PX7.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $c3d8050343a6b30c$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $k4PX7.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $c3d8050343a6b30c$var$_oldOnErrorHandler = null;
/** JSDoc */ function $c3d8050343a6b30c$var$instrumentError() {
    $c3d8050343a6b30c$var$_oldOnErrorHandler = $c3d8050343a6b30c$var$global.onerror;
    $c3d8050343a6b30c$var$global.onerror = function(msg, url, line, column, error) {
        $c3d8050343a6b30c$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($c3d8050343a6b30c$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $c3d8050343a6b30c$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $c3d8050343a6b30c$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $c3d8050343a6b30c$var$instrumentUnhandledRejection() {
    $c3d8050343a6b30c$var$_oldOnUnhandledRejectionHandler = $c3d8050343a6b30c$var$global.onunhandledrejection;
    $c3d8050343a6b30c$var$global.onunhandledrejection = function(e) {
        $c3d8050343a6b30c$var$triggerHandlers('unhandledrejection', e);
        if ($c3d8050343a6b30c$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $c3d8050343a6b30c$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("exDIp", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $a962f45f7a43a862$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "logger", () => $a962f45f7a43a862$export$af88d00dbe7f521);

var $j9yrT = parcelRequire("j9yrT");

var $bF6QC = parcelRequire("bF6QC");

var $fsUz1 = parcelRequire("fsUz1");
// TODO: Implement different loggers for different environments
var $a962f45f7a43a862$var$global = (0, $fsUz1.getGlobalObject)();
/** Prefix for logging strings */ var $a962f45f7a43a862$var$PREFIX = 'Sentry Logger ';
var $a962f45f7a43a862$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $a962f45f7a43a862$export$cda52e2a8927a2ca(callback) {
    var global = (0, $fsUz1.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $a962f45f7a43a862$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $a962f45f7a43a862$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $bF6QC.IS_DEBUG_BUILD) $a962f45f7a43a862$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $a962f45f7a43a862$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $a962f45f7a43a862$var$global.console)[name].apply(_a, (0, $j9yrT.__spread)([
                    $a962f45f7a43a862$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $a962f45f7a43a862$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $a962f45f7a43a862$export$af88d00dbe7f521;
if (0, $bF6QC.IS_DEBUG_BUILD) $a962f45f7a43a862$export$af88d00dbe7f521 = (0, $fsUz1.getGlobalSingleton)('logger', $a962f45f7a43a862$var$makeLogger);
else $a962f45f7a43a862$export$af88d00dbe7f521 = $a962f45f7a43a862$var$makeLogger();

});

parcelRegister("k4PX7", function(module, exports) {
$parcel$export(module.exports, "fill", () => $e9dc7b11cecf9191$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $e9dc7b11cecf9191$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $e9dc7b11cecf9191$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $e9dc7b11cecf9191$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $e9dc7b11cecf9191$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $e9dc7b11cecf9191$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $e9dc7b11cecf9191$export$b0244d5063c0b61b);

var $j9yrT = parcelRequire("j9yrT");

var $dSRLC = parcelRequire("dSRLC");

var $60nuy = parcelRequire("60nuy");

var $9QXUt = parcelRequire("9QXUt");
function $e9dc7b11cecf9191$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $e9dc7b11cecf9191$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $e9dc7b11cecf9191$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $e9dc7b11cecf9191$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $e9dc7b11cecf9191$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $e9dc7b11cecf9191$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $e9dc7b11cecf9191$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $e9dc7b11cecf9191$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $60nuy.isError)(value)) newObj = (0, $j9yrT.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $e9dc7b11cecf9191$var$getOwnProperties(value));
    else if ((0, $60nuy.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $j9yrT.__assign)({
            type: event_1.type,
            target: $e9dc7b11cecf9191$var$serializeEventTarget(event_1.target),
            currentTarget: $e9dc7b11cecf9191$var$serializeEventTarget(event_1.currentTarget)
        }, $e9dc7b11cecf9191$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $60nuy.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $e9dc7b11cecf9191$var$serializeEventTarget(target) {
    try {
        return (0, $60nuy.isElement)(target) ? (0, $dSRLC.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $e9dc7b11cecf9191$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $e9dc7b11cecf9191$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($e9dc7b11cecf9191$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $9QXUt.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $9QXUt.truncate)(serialized, maxLength);
    }
    return '';
}
function $e9dc7b11cecf9191$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $60nuy.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $j9yrT.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $e9dc7b11cecf9191$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($e9dc7b11cecf9191$export$d25f2688db1bb433);
    return val;
}
function $e9dc7b11cecf9191$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $60nuy.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("9QXUt", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $72c7713f1528bae5$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $72c7713f1528bae5$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $72c7713f1528bae5$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $72c7713f1528bae5$export$cdded5b28a5f8c6d);

var $60nuy = parcelRequire("60nuy");
function $72c7713f1528bae5$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $72c7713f1528bae5$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $72c7713f1528bae5$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $72c7713f1528bae5$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $60nuy.isString)(value)) return false;
    if ((0, $60nuy.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $72c7713f1528bae5$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("7YeiV", function(module, exports) {
$parcel$export(module.exports, "createStackParser", () => $5cd93b8c176e01c9$export$a5739666fb2d03d4);
$parcel$export(module.exports, "getFunctionName", () => $5cd93b8c176e01c9$export$aad197c7121a6651);

var $j9yrT = parcelRequire("j9yrT");
var $5cd93b8c176e01c9$var$STACKTRACE_LIMIT = 50;
function $5cd93b8c176e01c9$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $j9yrT.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $j9yrT.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $5cd93b8c176e01c9$export$c55c24c0eeba0205(frames);
    };
}
function $5cd93b8c176e01c9$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $5cd93b8c176e01c9$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $5cd93b8c176e01c9$var$defaultFunctionName = '<anonymous>';
function $5cd93b8c176e01c9$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $5cd93b8c176e01c9$var$defaultFunctionName;
        return fn.name || $5cd93b8c176e01c9$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $5cd93b8c176e01c9$var$defaultFunctionName;
    }
}

});

parcelRegister("es4t5", function(module, exports) {
$parcel$export(module.exports, "supportsFetch", () => $a85725836739aa8d$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $a85725836739aa8d$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $a85725836739aa8d$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReferrerPolicy", () => $a85725836739aa8d$export$2d308b428295192f);
$parcel$export(module.exports, "supportsHistory", () => $a85725836739aa8d$export$67fc34576016d6ec);

var $bF6QC = parcelRequire("bF6QC");

var $fsUz1 = parcelRequire("fsUz1");

var $exDIp = parcelRequire("exDIp");
function $a85725836739aa8d$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $a85725836739aa8d$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $a85725836739aa8d$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $a85725836739aa8d$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $fsUz1.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $a85725836739aa8d$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $a85725836739aa8d$export$c82d238e23c40b21() {
    if (!$a85725836739aa8d$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $fsUz1.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($a85725836739aa8d$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $a85725836739aa8d$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $bF6QC.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $a85725836739aa8d$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $fsUz1.getGlobalObject)();
}
function $a85725836739aa8d$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$a85725836739aa8d$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $a85725836739aa8d$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $fsUz1.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("iPdhn", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $0389686cef8be9df$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $0389686cef8be9df$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $0389686cef8be9df$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $0389686cef8be9df$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $0389686cef8be9df$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $0389686cef8be9df$export$6de4ffac6a2f1098);

var $j9yrT = parcelRequire("j9yrT");

var $fsUz1 = parcelRequire("fsUz1");

var $k4PX7 = parcelRequire("k4PX7");

var $9QXUt = parcelRequire("9QXUt");
function $0389686cef8be9df$export$19f53698e68b2496() {
    var global = (0, $fsUz1.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $0389686cef8be9df$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $0389686cef8be9df$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $0389686cef8be9df$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $0389686cef8be9df$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $0389686cef8be9df$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $0389686cef8be9df$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $0389686cef8be9df$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $j9yrT.__assign)((0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $0389686cef8be9df$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $0389686cef8be9df$export$d364f2020ab30578(input) {
    var match = input.match($0389686cef8be9df$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $0389686cef8be9df$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $9QXUt.snipLine)(line, 0);
    });
    frame.context_line = (0, $9QXUt.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $9QXUt.snipLine)(line, 0);
    });
}
function $0389686cef8be9df$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $0389686cef8be9df$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $k4PX7.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});

parcelRegister("4vsZe", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $34808ad545099175$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $34808ad545099175$export$23fbbb20bed71033);

var $j9yrT = parcelRequire("j9yrT");

var $60nuy = parcelRequire("60nuy");

var $8cNEb = parcelRequire("8cNEb");

var $k4PX7 = parcelRequire("k4PX7");

var $7YeiV = parcelRequire("7YeiV");
function $34808ad545099175$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $34808ad545099175$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $34808ad545099175$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $34808ad545099175$export$a3295358bff77e(object, depth);
    if ($34808ad545099175$var$jsonSize(normalized) > maxSize) return $34808ad545099175$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $34808ad545099175$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $8cNEb.memoBuilder)();
    var _a = (0, $j9yrT.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $60nuy.isNaN)(value)) return value;
    var stringified = $34808ad545099175$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $60nuy.isError)(value) || (0, $60nuy.isEvent)(value) ? (0, $k4PX7.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $34808ad545099175$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $34808ad545099175$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $60nuy.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $7YeiV.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $34808ad545099175$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $34808ad545099175$var$jsonSize(value) {
    return $34808ad545099175$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("8cNEb", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $5f95f49dbc82d87d$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $5f95f49dbc82d87d$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("9zp5C", function(module, exports) {
$parcel$export(module.exports, "makePromiseBuffer", () => $6f7ad838e9c99b55$export$85a4f67f852183e6);

var $gfbw6 = parcelRequire("gfbw6");

var $bJ4ny = parcelRequire("bJ4ny");
function $6f7ad838e9c99b55$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $bJ4ny.rejectedSyncPromise)(new (0, $gfbw6.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $bJ4ny.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $bJ4ny.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});
parcelRegister("bJ4ny", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", () => $88974b435f0ab339$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $88974b435f0ab339$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $88974b435f0ab339$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $60nuy = parcelRequire("60nuy");
function $88974b435f0ab339$export$1fda8aa4d135f8aa(value) {
    return new $88974b435f0ab339$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $88974b435f0ab339$export$78e43115b553f358(reason) {
    return new $88974b435f0ab339$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $88974b435f0ab339$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $60nuy.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});


parcelRegister("gx7D6", function(module, exports) {
$parcel$export(module.exports, "severityFromString", () => $c095a57c6c13cb91$export$e01cef29b4327697);

var $4et5w = parcelRequire("4et5w");

var $gSHoU = parcelRequire("gSHoU");
function $c095a57c6c13cb91$var$isSupportedSeverity(level) {
    return (0, $gSHoU.SeverityLevels).indexOf(level) !== -1;
}
function $c095a57c6c13cb91$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $4et5w.Severity).Warning;
    if ($c095a57c6c13cb91$var$isSupportedSeverity(level)) return level;
    return (0, $4et5w.Severity).Log;
}

});
parcelRegister("4et5w", function(module, exports) {
$parcel$export(module.exports, "Severity", () => $314f0881fa18a76d$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $314f0881fa18a76d$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($314f0881fa18a76d$export$918a9776c0a3cf27 || ($314f0881fa18a76d$export$918a9776c0a3cf27 = {}));
var $314f0881fa18a76d$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("gSHoU", function(module, exports) {
$parcel$export(module.exports, "SeverityLevels", () => $c4a35afd4a6d6370$export$484b1ea9aec914c);
var $c4a35afd4a6d6370$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("2KX1g", function(module, exports) {
$parcel$export(module.exports, "eventStatusFromHttpCode", () => $201da8aad180cfc4$export$82713360d763c449);
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $201da8aad180cfc4$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

});

parcelRegister("6XKQ3", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);

var $fsUz1 = parcelRequire("fsUz1");

var $f0szJ = parcelRequire("f0szJ");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $fsUz1.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $f0szJ.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $f0szJ.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $fsUz1.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("9vBQH", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $6ec45e53785863fc$export$f93f7f385160c44e);
$parcel$export(module.exports, "getEnvelopeType", () => $6ec45e53785863fc$export$d84939284bbafcd4);
$parcel$export(module.exports, "serializeEnvelope", () => $6ec45e53785863fc$export$32f9b428425aac85);

var $j9yrT = parcelRequire("j9yrT");

var $60nuy = parcelRequire("60nuy");
function $6ec45e53785863fc$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $6ec45e53785863fc$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $j9yrT.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $j9yrT.__spread)(items, [
            newItem
        ])
    ];
}
function $6ec45e53785863fc$export$d84939284bbafcd4(envelope) {
    var _a = (0, $j9yrT.__read)(envelope, 2), _b = (0, $j9yrT.__read)(_a[1], 1), _c = (0, $j9yrT.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $6ec45e53785863fc$export$32f9b428425aac85(envelope) {
    var _a = (0, $j9yrT.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $j9yrT.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $60nuy.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("2qGnf", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $1c4ee115f2ce01ff$export$f3b9ed77c03eeb00);

var $9vBQH = parcelRequire("9vBQH");

var $6XKQ3 = parcelRequire("6XKQ3");
function $1c4ee115f2ce01ff$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $6XKQ3.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $9vBQH.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("1cp6Y", function(module, exports) {
$parcel$export(module.exports, "disabledUntil", () => $0dfa6412ea33e257$export$b89fc7b2e4c799e7);
$parcel$export(module.exports, "isRateLimited", () => $0dfa6412ea33e257$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $0dfa6412ea33e257$export$699aff705e0d49d4);

var $j9yrT = parcelRequire("j9yrT");
var $0dfa6412ea33e257$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $0dfa6412ea33e257$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $0dfa6412ea33e257$export$b09ce39faaeb1e7c;
}
function $0dfa6412ea33e257$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $0dfa6412ea33e257$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $0dfa6412ea33e257$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $0dfa6412ea33e257$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $j9yrT.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $j9yrT.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $j9yrT.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $0dfa6412ea33e257$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});


parcelRegister("6uyOS", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $4ba08de1655cb1fa$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $4ba08de1655cb1fa$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("9TgNM", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("6zSLu")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("1ONGC")).InboundFilters);

var $6zSLu = parcelRequire("6zSLu");

var $1ONGC = parcelRequire("1ONGC");

});
parcelRegister("6zSLu", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => $4ca07e246c9709cd$export$da4704525c20ae79);
parcelRequire("3vRyE");
var $k4PX7 = parcelRequire("k4PX7");
var $4ca07e246c9709cd$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $4ca07e246c9709cd$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $4ca07e246c9709cd$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, $k4PX7.getOriginalFunction)(this) || this;
            return $4ca07e246c9709cd$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();

});

parcelRegister("1ONGC", function(module, exports) {
$parcel$export(module.exports, "InboundFilters", () => $153100a59bc45fe3$export$2ffbb5359dcc6be4);

var $j9yrT = parcelRequire("j9yrT");
parcelRequire("3vRyE");
var $iPdhn = parcelRequire("iPdhn");
var $9QXUt = parcelRequire("9QXUt");
var $exDIp = parcelRequire("exDIp");

var $6uyOS = parcelRequire("6uyOS");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $153100a59bc45fe3$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $153100a59bc45fe3$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $153100a59bc45fe3$export$6620a151868b99aa(self_1._options, clientOptions);
                    return $153100a59bc45fe3$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();
function $153100a59bc45fe3$export$6620a151868b99aa(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, $j9yrT.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, $j9yrT.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, $j9yrT.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], $153100a59bc45fe3$var$DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $153100a59bc45fe3$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $153100a59bc45fe3$var$_isSentryError(event)) {
        (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $iPdhn.getEventDescription)(event));
        return true;
    }
    if ($153100a59bc45fe3$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $iPdhn.getEventDescription)(event));
        return true;
    }
    if ($153100a59bc45fe3$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $iPdhn.getEventDescription)(event) + ".\nUrl: " + $153100a59bc45fe3$var$_getEventFilterUrl(event));
        return true;
    }
    if (!$153100a59bc45fe3$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $iPdhn.getEventDescription)(event) + ".\nUrl: " + $153100a59bc45fe3$var$_getEventFilterUrl(event));
        return true;
    }
    return false;
}
function $153100a59bc45fe3$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $153100a59bc45fe3$var$_getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, $9QXUt.isMatchingPattern)(message, pattern);
        });
    });
}
function $153100a59bc45fe3$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $153100a59bc45fe3$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, $9QXUt.isMatchingPattern)(url, pattern);
    });
}
function $153100a59bc45fe3$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $153100a59bc45fe3$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, $9QXUt.isMatchingPattern)(url, pattern);
    });
}
function $153100a59bc45fe3$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).error("Cannot extract message for event " + (0, $iPdhn.getEventDescription)(event));
        return [];
    }
    return [];
}
function $153100a59bc45fe3$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $153100a59bc45fe3$var$_getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $153100a59bc45fe3$var$_getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return $153100a59bc45fe3$var$_getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? $153100a59bc45fe3$var$_getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).error("Cannot extract url for event " + (0, $iPdhn.getEventDescription)(event));
        return null;
    }
}

});


parcelRegister("kNIG0", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $f24b0a170fb8c368$export$1df9218a526d318d);

var $j9yrT = parcelRequire("j9yrT");

var $kYmER = parcelRequire("kYmER");
var $2lWPU = parcelRequire("2lWPU");
parcelRequire("3vRyE");
var $fsUz1 = parcelRequire("fsUz1");
var $exDIp = parcelRequire("exDIp");

var $j3fMY = parcelRequire("j3fMY");

var $gXBaL = parcelRequire("gXBaL");

var $cjIFI = parcelRequire("cjIFI");

var $04KEt = parcelRequire("04KEt");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $f24b0a170fb8c368$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $2lWPU.SDK_VERSION)
                }
            ],
            version: (0, $2lWPU.SDK_VERSION)
        };
        _this = _super.call(this, (0, $j3fMY.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $fsUz1.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $gXBaL.IS_DEBUG_BUILD) && (0, $exDIp.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $cjIFI.injectReportDialog)((0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $04KEt.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $kYmER.BaseClient));

});
parcelRegister("kYmER", function(module, exports) {
$parcel$export(module.exports, "BaseClient", () => $f44afcab2c19b198$export$4f22f74eddb7716a);

var $j9yrT = parcelRequire("j9yrT");

var $jhDCe = parcelRequire("jhDCe");
parcelRequire("3vRyE");
var $iPdhn = parcelRequire("iPdhn");
var $6XKQ3 = parcelRequire("6XKQ3");
var $60nuy = parcelRequire("60nuy");
var $exDIp = parcelRequire("exDIp");
var $jZMY4 = parcelRequire("jZMY4");
var $4vsZe = parcelRequire("4vsZe");
var $bJ4ny = parcelRequire("bJ4ny");
var $gfbw6 = parcelRequire("gfbw6");
var $9QXUt = parcelRequire("9QXUt");

var $6uyOS = parcelRequire("6uyOS");

var $72jZK = parcelRequire("72jZK");
var $f44afcab2c19b198$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $f44afcab2c19b198$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $jZMY4.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $iPdhn.checkOrSetAlreadyCaught)(exception)) {
            (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).log($f44afcab2c19b198$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $60nuy.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $iPdhn.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).log($f44afcab2c19b198$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $72jZK.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $j9yrT.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $bJ4ny.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $iPdhn.uuid4)()),
            timestamp: event.timestamp || (0, $6XKQ3.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $jhDCe.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $bJ4ny.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $4vsZe.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $j9yrT.__assign)((0, $j9yrT.__assign)((0, $j9yrT.__assign)((0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, b), b.data && {
                    data: (0, $4vsZe.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $4vsZe.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $4vsZe.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $4vsZe.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $9QXUt.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $9QXUt.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $9QXUt.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $j9yrT.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $bJ4ny.rejectedSyncPromise)(new (0, $gfbw6.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $bJ4ny.rejectedSyncPromise)(new (0, $gfbw6.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $gfbw6.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $f44afcab2c19b198$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $gfbw6.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $gfbw6.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $gfbw6.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $f44afcab2c19b198$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $60nuy.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $60nuy.isPlainObject)(event) || event === null)) throw new (0, $gfbw6.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $gfbw6.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $60nuy.isPlainObject)(rv) || rv === null)) throw new (0, $gfbw6.SentryError)(nullErr);
    return rv;
}

});
parcelRegister("72jZK", function(module, exports) {
$parcel$export(module.exports, "setupIntegrations", () => $51f83ae0ef904972$export$51abed9797baa598);

var $j9yrT = parcelRequire("j9yrT");

var $jhDCe = parcelRequire("jhDCe");
var $fdv6x = parcelRequire("fdv6x");
parcelRequire("3vRyE");
var $k4PX7 = parcelRequire("k4PX7");
var $exDIp = parcelRequire("exDIp");

var $6uyOS = parcelRequire("6uyOS");
var $51f83ae0ef904972$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $51f83ae0ef904972$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $51f83ae0ef904972$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $j9yrT.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $j9yrT.__spread)($51f83ae0ef904972$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $j9yrT.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $51f83ae0ef904972$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $j9yrT.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $51f83ae0ef904972$export$e7390a03b70a6f2f(integration) {
    if ($51f83ae0ef904972$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $jhDCe.addGlobalEventProcessor), (0, $fdv6x.getCurrentHub));
    $51f83ae0ef904972$export$b14a8888f80a0b3e.push(integration.name);
    (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).log("Integration installed: " + integration.name);
}
function $51f83ae0ef904972$export$51abed9797baa598(options) {
    var integrations = {};
    $51f83ae0ef904972$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $51f83ae0ef904972$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $k4PX7.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}

});


parcelRegister("2lWPU", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $1b6b2e95f50a21b0$export$31499a9cd224b78c);
var $1b6b2e95f50a21b0$export$31499a9cd224b78c = '6.19.7';

});

parcelRegister("j3fMY", function(module, exports) {
$parcel$export(module.exports, "BrowserBackend", () => $ddea8b7e4de0e834$export$2526e21aec9d0ce7);

var $j9yrT = parcelRequire("j9yrT");

var $1Qoj0 = parcelRequire("1Qoj0");
var $8f0wF = parcelRequire("8f0wF");

var $4et5w = parcelRequire("4et5w");
parcelRequire("3vRyE");
var $es4t5 = parcelRequire("es4t5");

var $243j5 = parcelRequire("243j5");

var $fYDg5 = parcelRequire("fYDg5");
var $6vn8r = parcelRequire("6vn8r");
var $9Xq0D = parcelRequire("9Xq0D");
var $026Oq = parcelRequire("026Oq");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $ddea8b7e4de0e834$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $243j5.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $4et5w.Severity).Info;
        return (0, $243j5.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $8f0wF.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $8f0wF.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $es4t5.supportsFetch)()) {
            var requestOptions = (0, $j9yrT.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $6vn8r.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $fYDg5.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $9Xq0D.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $026Oq.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $1Qoj0.BaseBackend));

});
parcelRegister("1Qoj0", function(module, exports) {
$parcel$export(module.exports, "BaseBackend", () => $157d8056eca295b8$export$8f43a53a38d7e95f);

var $j9yrT = parcelRequire("j9yrT");
parcelRequire("3vRyE");
var $exDIp = parcelRequire("exDIp");
var $gfbw6 = parcelRequire("gfbw6");

var $8f0wF = parcelRequire("8f0wF");

var $6uyOS = parcelRequire("6uyOS");

var $dpwOv = parcelRequire("dpwOv");

var $77EdA = parcelRequire("77EdA");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $157d8056eca295b8$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $gfbw6.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $gfbw6.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $8f0wF.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $dpwOv.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $8f0wF.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $j9yrT.__read)((0, $dpwOv.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $6uyOS.IS_DEBUG_BUILD) && (0, $exDIp.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $77EdA.NoopTransport)();
    };
    return BaseBackend;
}();

});
parcelRegister("8f0wF", function(module, exports) {
$parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", () => $600021da27d2634c$export$c1677e22ac2217a5);
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $600021da27d2634c$export$9964600bfe84e6a3);
$parcel$export(module.exports, "initAPIDetails", () => $600021da27d2634c$export$ad00a06efb2a29cb);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $600021da27d2634c$export$671c7ed8e40a7a57);
parcelRequire("3vRyE");
var $jZMY4 = parcelRequire("jZMY4");
var $k4PX7 = parcelRequire("k4PX7");
var $600021da27d2634c$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $600021da27d2634c$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $jZMY4.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $600021da27d2634c$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $600021da27d2634c$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $600021da27d2634c$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $600021da27d2634c$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $600021da27d2634c$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $jZMY4.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $600021da27d2634c$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $600021da27d2634c$var$_getIngestEndpoint(dsn, target) {
    return "" + $600021da27d2634c$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $600021da27d2634c$var$_encodedAuth(dsn) {
    return (0, $k4PX7.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $600021da27d2634c$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $600021da27d2634c$var$getStoreEndpoint(dsn) {
    return $600021da27d2634c$var$_getIngestEndpoint(dsn, 'store');
}
function $600021da27d2634c$export$c1677e22ac2217a5(dsn) {
    return $600021da27d2634c$var$getStoreEndpoint(dsn) + "?" + $600021da27d2634c$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $600021da27d2634c$var$_getEnvelopeEndpoint(dsn) {
    return $600021da27d2634c$var$_getIngestEndpoint(dsn, 'envelope');
}
function $600021da27d2634c$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $600021da27d2634c$var$_getEnvelopeEndpoint(dsn) + "?" + $600021da27d2634c$var$_encodedAuth(dsn);
}
function $600021da27d2634c$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $600021da27d2634c$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $600021da27d2634c$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $jZMY4.makeDsn)(dsnLike);
    var endpoint = $600021da27d2634c$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $jZMY4.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

});

parcelRegister("dpwOv", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", () => $9c37103ced000ea5$export$124b03c077baa2f3);
$parcel$export(module.exports, "sessionToSentryRequest", () => $9c37103ced000ea5$export$977ee6eda1884ec3);
$parcel$export(module.exports, "createEventEnvelope", () => $9c37103ced000ea5$export$c31057337a18010f);
$parcel$export(module.exports, "eventToSentryRequest", () => $9c37103ced000ea5$export$2006389de558b996);

var $j9yrT = parcelRequire("j9yrT");
parcelRequire("3vRyE");
var $9vBQH = parcelRequire("9vBQH");
var $jZMY4 = parcelRequire("jZMY4");
var $4vsZe = parcelRequire("4vsZe");

var $8f0wF = parcelRequire("8f0wF");
/** Extract sdk info from from the API metadata */ function $9c37103ced000ea5$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $9c37103ced000ea5$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $j9yrT.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $j9yrT.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $9c37103ced000ea5$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $9c37103ced000ea5$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $jZMY4.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $9vBQH.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $9c37103ced000ea5$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $j9yrT.__read)($9c37103ced000ea5$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $9vBQH.serializeEnvelope)(envelope),
        type: type,
        url: (0, $8f0wF.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $9c37103ced000ea5$export$c31057337a18010f(event, api) {
    var sdkInfo = $9c37103ced000ea5$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $9c37103ced000ea5$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $jZMY4.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $9vBQH.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $9c37103ced000ea5$export$2006389de558b996(event, api) {
    var sdkInfo = $9c37103ced000ea5$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $9c37103ced000ea5$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $4vsZe.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $8f0wF.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $8f0wF.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $jZMY4.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $9vBQH.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $9vBQH.serializeEnvelope)(envelope);
    }
    return req;
}

});

parcelRegister("77EdA", function(module, exports) {
$parcel$export(module.exports, "NoopTransport", () => $52f86252160ab7f5$export$6f2767450ea1346c);
parcelRequire("3vRyE");
var $bJ4ny = parcelRequire("bJ4ny");
/** Noop transport */ var $52f86252160ab7f5$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $bJ4ny.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $bJ4ny.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

});


parcelRegister("243j5", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $180e852c0ea96e07$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $180e852c0ea96e07$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $180e852c0ea96e07$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $180e852c0ea96e07$export$5425b53185d13d6c);

var $j9yrT = parcelRequire("j9yrT");

var $4et5w = parcelRequire("4et5w");
parcelRequire("3vRyE");
var $iPdhn = parcelRequire("iPdhn");
var $7YeiV = parcelRequire("7YeiV");
var $k4PX7 = parcelRequire("k4PX7");
var $60nuy = parcelRequire("60nuy");
var $4vsZe = parcelRequire("4vsZe");
var $bJ4ny = parcelRequire("bJ4ny");

var $9fy79 = parcelRequire("9fy79");
function $180e852c0ea96e07$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $180e852c0ea96e07$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $180e852c0ea96e07$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $180e852c0ea96e07$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $60nuy.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $k4PX7.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $4vsZe.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $180e852c0ea96e07$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $180e852c0ea96e07$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $180e852c0ea96e07$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $180e852c0ea96e07$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $180e852c0ea96e07$var$getPopSize(ex);
    try {
        return (0, $7YeiV.createStackParser)((0, $9fy79.opera10StackParser), (0, $9fy79.opera11StackParser), (0, $9fy79.chromeStackParser), (0, $9fy79.winjsStackParser), (0, $9fy79.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $180e852c0ea96e07$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $180e852c0ea96e07$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($180e852c0ea96e07$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $180e852c0ea96e07$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $180e852c0ea96e07$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $180e852c0ea96e07$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $iPdhn.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $4et5w.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $bJ4ny.resolvedSyncPromise)(event);
}
function $180e852c0ea96e07$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $4et5w.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $180e852c0ea96e07$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $bJ4ny.resolvedSyncPromise)(event);
}
function $180e852c0ea96e07$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $60nuy.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $180e852c0ea96e07$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $60nuy.isDOMError)(exception) || (0, $60nuy.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $180e852c0ea96e07$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $60nuy.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $180e852c0ea96e07$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $iPdhn.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $60nuy.isError)(exception)) // we have a real Error object, do nothing
    return $180e852c0ea96e07$export$73fbea5a0a5234af(exception);
    if ((0, $60nuy.isPlainObject)(exception) || (0, $60nuy.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $180e852c0ea96e07$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $iPdhn.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $180e852c0ea96e07$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $iPdhn.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $iPdhn.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $180e852c0ea96e07$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $180e852c0ea96e07$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

});
parcelRegister("9fy79", function(module, exports) {
$parcel$export(module.exports, "chromeStackParser", () => $6bbffa26d837ac2a$export$c693d9295441d8f9);
$parcel$export(module.exports, "geckoStackParser", () => $6bbffa26d837ac2a$export$c9ddf1e2b5d48bff);
$parcel$export(module.exports, "winjsStackParser", () => $6bbffa26d837ac2a$export$b6d155d85c1dcba5);
$parcel$export(module.exports, "opera10StackParser", () => $6bbffa26d837ac2a$export$966ec832d9699d6);
$parcel$export(module.exports, "opera11StackParser", () => $6bbffa26d837ac2a$export$989a1824b4734ce6);

var $j9yrT = parcelRequire("j9yrT");
// global reference to slice
var $6bbffa26d837ac2a$var$UNKNOWN_FUNCTION = '?';
var $6bbffa26d837ac2a$var$OPERA10_PRIORITY = 10;
var $6bbffa26d837ac2a$var$OPERA11_PRIORITY = 20;
var $6bbffa26d837ac2a$var$CHROME_PRIORITY = 30;
var $6bbffa26d837ac2a$var$WINJS_PRIORITY = 40;
var $6bbffa26d837ac2a$var$GECKO_PRIORITY = 50;
function $6bbffa26d837ac2a$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $6bbffa26d837ac2a$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $6bbffa26d837ac2a$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $6bbffa26d837ac2a$var$chrome = function(line) {
    var parts = $6bbffa26d837ac2a$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $6bbffa26d837ac2a$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $j9yrT.__read)($6bbffa26d837ac2a$var$extractSafariExtensionDetails(parts[1] || $6bbffa26d837ac2a$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $6bbffa26d837ac2a$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $6bbffa26d837ac2a$export$c693d9295441d8f9 = [
    $6bbffa26d837ac2a$var$CHROME_PRIORITY,
    $6bbffa26d837ac2a$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $6bbffa26d837ac2a$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $6bbffa26d837ac2a$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $6bbffa26d837ac2a$var$gecko = function(line) {
    var _a;
    var parts = $6bbffa26d837ac2a$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $6bbffa26d837ac2a$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $6bbffa26d837ac2a$var$UNKNOWN_FUNCTION;
        _a = (0, $j9yrT.__read)($6bbffa26d837ac2a$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $6bbffa26d837ac2a$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $6bbffa26d837ac2a$export$c9ddf1e2b5d48bff = [
    $6bbffa26d837ac2a$var$GECKO_PRIORITY,
    $6bbffa26d837ac2a$var$gecko
];
var $6bbffa26d837ac2a$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $6bbffa26d837ac2a$var$winjs = function(line) {
    var parts = $6bbffa26d837ac2a$var$winjsRegex.exec(line);
    return parts ? $6bbffa26d837ac2a$var$createFrame(parts[2], parts[1] || $6bbffa26d837ac2a$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $6bbffa26d837ac2a$export$b6d155d85c1dcba5 = [
    $6bbffa26d837ac2a$var$WINJS_PRIORITY,
    $6bbffa26d837ac2a$var$winjs
];
var $6bbffa26d837ac2a$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $6bbffa26d837ac2a$var$opera10 = function(line) {
    var parts = $6bbffa26d837ac2a$var$opera10Regex.exec(line);
    return parts ? $6bbffa26d837ac2a$var$createFrame(parts[2], parts[3] || $6bbffa26d837ac2a$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $6bbffa26d837ac2a$export$966ec832d9699d6 = [
    $6bbffa26d837ac2a$var$OPERA10_PRIORITY,
    $6bbffa26d837ac2a$var$opera10
];
var $6bbffa26d837ac2a$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $6bbffa26d837ac2a$var$opera11 = function(line) {
    var parts = $6bbffa26d837ac2a$var$opera11Regex.exec(line);
    return parts ? $6bbffa26d837ac2a$var$createFrame(parts[5], parts[3] || parts[4] || $6bbffa26d837ac2a$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $6bbffa26d837ac2a$export$989a1824b4734ce6 = [
    $6bbffa26d837ac2a$var$OPERA11_PRIORITY,
    $6bbffa26d837ac2a$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $6bbffa26d837ac2a$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $6bbffa26d837ac2a$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});


parcelRegister("fYDg5", function(module, exports) {
$parcel$export(module.exports, "FetchTransport", () => $ba1ae9875bd0e3ca$export$2bdee3f9b92f4e82);

var $j9yrT = parcelRequire("j9yrT");
parcelRequire("3vRyE");
var $gfbw6 = parcelRequire("gfbw6");
var $es4t5 = parcelRequire("es4t5");
var $bJ4ny = parcelRequire("bJ4ny");

var $fKJI8 = parcelRequire("fKJI8");

var $iqZ6r = parcelRequire("iqZ6r");
/** `fetch` based transport */ var $ba1ae9875bd0e3ca$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $iqZ6r.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $es4t5.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $bJ4ny.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $gfbw6.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $fKJI8.BaseTransport));

});
parcelRegister("fKJI8", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => $b77e9c20cdf5b06f$export$74b99d619e90f481);

var $j9yrT = parcelRequire("j9yrT");

var $dpwOv = parcelRequire("dpwOv");
var $8f0wF = parcelRequire("8f0wF");
parcelRequire("3vRyE");
var $2qGnf = parcelRequire("2qGnf");
var $1cp6Y = parcelRequire("1cp6Y");
var $jZMY4 = parcelRequire("jZMY4");
var $2KX1g = parcelRequire("2KX1g");
var $fsUz1 = parcelRequire("fsUz1");
var $exDIp = parcelRequire("exDIp");
var $9zp5C = parcelRequire("9zp5C");
var $9vBQH = parcelRequire("9vBQH");

var $gXBaL = parcelRequire("gXBaL");

var $iqZ6r = parcelRequire("iqZ6r");
function $b77e9c20cdf5b06f$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $b77e9c20cdf5b06f$var$global = (0, $fsUz1.getGlobalObject)();
/** Base Transport class implementation */ var $b77e9c20cdf5b06f$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $9zp5C.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $8f0wF.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $8f0wF.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $b77e9c20cdf5b06f$var$global.document) $b77e9c20cdf5b06f$var$global.document.addEventListener('visibilitychange', function() {
            if ($b77e9c20cdf5b06f$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $dpwOv.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $dpwOv.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $b77e9c20cdf5b06f$var$requestTypeToCategory(category) + ":" + reason;
        (0, $gXBaL.IS_DEBUG_BUILD) && (0, $exDIp.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $gXBaL.IS_DEBUG_BUILD) && (0, $exDIp.logger).log('No outcomes to flush');
            return;
        }
        (0, $gXBaL.IS_DEBUG_BUILD) && (0, $exDIp.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $8f0wF.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $j9yrT.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $2qGnf.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $jZMY4.dsnToString)(this._api.dsn));
        try {
            (0, $iqZ6r.sendReport)(url, (0, $9vBQH.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $gXBaL.IS_DEBUG_BUILD) && (0, $exDIp.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $2KX1g.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $1cp6Y.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $gXBaL.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $exDIp.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $b77e9c20cdf5b06f$var$requestTypeToCategory(requestType);
        return new Date((0, $1cp6Y.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $b77e9c20cdf5b06f$var$requestTypeToCategory(requestType);
        return (0, $1cp6Y.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

});
parcelRegister("gXBaL", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $c58efdbf45043d48$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $c58efdbf45043d48$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("iqZ6r", function(module, exports) {
$parcel$export(module.exports, "getNativeFetchImplementation", () => $d6ba0d7a1930a7de$export$8be2119ce08e3379);
$parcel$export(module.exports, "sendReport", () => $d6ba0d7a1930a7de$export$84bb63b2c17ec44d);
parcelRequire("3vRyE");
var $inw3d = parcelRequire("inw3d");
var $fsUz1 = parcelRequire("fsUz1");
var $es4t5 = parcelRequire("es4t5");
var $exDIp = parcelRequire("exDIp");

var $gXBaL = parcelRequire("gXBaL");
var $d6ba0d7a1930a7de$var$global = (0, $fsUz1.getGlobalObject)();
var $d6ba0d7a1930a7de$var$cachedFetchImpl;
function $d6ba0d7a1930a7de$export$8be2119ce08e3379() {
    if ($d6ba0d7a1930a7de$var$cachedFetchImpl) return $d6ba0d7a1930a7de$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $es4t5.isNativeFetch)($d6ba0d7a1930a7de$var$global.fetch)) return $d6ba0d7a1930a7de$var$cachedFetchImpl = $d6ba0d7a1930a7de$var$global.fetch.bind($d6ba0d7a1930a7de$var$global);
    var document = $d6ba0d7a1930a7de$var$global.document;
    var fetchImpl = $d6ba0d7a1930a7de$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $gXBaL.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $d6ba0d7a1930a7de$var$cachedFetchImpl = fetchImpl.bind($d6ba0d7a1930a7de$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $d6ba0d7a1930a7de$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($d6ba0d7a1930a7de$var$global && $d6ba0d7a1930a7de$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $d6ba0d7a1930a7de$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $d6ba0d7a1930a7de$var$global.navigator.sendBeacon.bind($d6ba0d7a1930a7de$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $es4t5.supportsFetch)()) {
        var fetch_1 = $d6ba0d7a1930a7de$export$8be2119ce08e3379();
        return (0, $inw3d.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}

});



parcelRegister("6vn8r", function(module, exports) {
$parcel$export(module.exports, "makeNewFetchTransport", () => $4bc79579e3061b9a$export$1c57e6bfd09bad13);

var $j9yrT = parcelRequire("j9yrT");

var $adn5y = parcelRequire("adn5y");

var $iqZ6r = parcelRequire("iqZ6r");
function $4bc79579e3061b9a$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $iqZ6r.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $j9yrT.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $adn5y.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});
parcelRegister("adn5y", function(module, exports) {
$parcel$export(module.exports, "createTransport", () => $76fd072d43d38695$export$d09f50d9ab7f7b69);
parcelRequire("3vRyE");
var $1cp6Y = parcelRequire("1cp6Y");
var $2KX1g = parcelRequire("2KX1g");
var $9vBQH = parcelRequire("9vBQH");
var $9zp5C = parcelRequire("9zp5C");
var $bJ4ny = parcelRequire("bJ4ny");
var $76fd072d43d38695$export$d8a725a7dce95622 = 'error';
var $76fd072d43d38695$export$99adc6fe67a3c63e = 'transaction';
var $76fd072d43d38695$export$9d7ad34f132fe68f = 'attachment';
var $76fd072d43d38695$export$42d9e7b5fc564c45 = 'session';
var $76fd072d43d38695$export$e515cf6dfd2f98b8 = 30;
function $76fd072d43d38695$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $9zp5C.makePromiseBuffer)(options.bufferSize || $76fd072d43d38695$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $9vBQH.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $9vBQH.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $1cp6Y.isRateLimited)(rateLimits, category)) return (0, $bJ4ny.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $76fd072d43d38695$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $2KX1g.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $1cp6Y.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $bJ4ny.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $bJ4ny.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $76fd072d43d38695$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $76fd072d43d38695$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $1cp6Y.disabledUntil)(rateLimits, category)).toISOString();
}

});


parcelRegister("9Xq0D", function(module, exports) {
$parcel$export(module.exports, "makeNewXHRTransport", () => $73fdcc9d50f509c7$export$4c0ac1dd4bbf4921);

var $adn5y = parcelRequire("adn5y");
parcelRequire("3vRyE");
var $bJ4ny = parcelRequire("bJ4ny");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $73fdcc9d50f509c7$var$XHR_READYSTATE_DONE = 4;
function $73fdcc9d50f509c7$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $bJ4ny.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $73fdcc9d50f509c7$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $adn5y.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});

parcelRegister("026Oq", function(module, exports) {
$parcel$export(module.exports, "XHRTransport", () => $006578ce00c7d9f3$export$874a283af77e8e62);

var $j9yrT = parcelRequire("j9yrT");
parcelRequire("3vRyE");
var $gfbw6 = parcelRequire("gfbw6");
var $bJ4ny = parcelRequire("bJ4ny");

var $fKJI8 = parcelRequire("fKJI8");
/** `XHR` based transport */ var $006578ce00c7d9f3$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $bJ4ny.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $gfbw6.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $fKJI8.BaseTransport));

});


parcelRegister("cjIFI", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreOnError", () => $8f79e94d7334ebb1$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $8f79e94d7334ebb1$export$4997ffc0176396a6);
$parcel$export(module.exports, "injectReportDialog", () => $8f79e94d7334ebb1$export$deb9aac8ea0b576c);

var $j9yrT = parcelRequire("j9yrT");

var $6nrSE = parcelRequire("6nrSE");
var $8f0wF = parcelRequire("8f0wF");
parcelRequire("3vRyE");
var $iPdhn = parcelRequire("iPdhn");
var $k4PX7 = parcelRequire("k4PX7");
var $fsUz1 = parcelRequire("fsUz1");
var $exDIp = parcelRequire("exDIp");

var $gXBaL = parcelRequire("gXBaL");
var $8f79e94d7334ebb1$var$global = (0, $fsUz1.getGlobalObject)();
var $8f79e94d7334ebb1$var$ignoreOnError = 0;
function $8f79e94d7334ebb1$export$b79738ab10c590b2() {
    return $8f79e94d7334ebb1$var$ignoreOnError > 0;
}
function $8f79e94d7334ebb1$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $8f79e94d7334ebb1$var$ignoreOnError += 1;
    setTimeout(function() {
        $8f79e94d7334ebb1$var$ignoreOnError -= 1;
    });
}
function $8f79e94d7334ebb1$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $k4PX7.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $8f79e94d7334ebb1$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $8f79e94d7334ebb1$export$1265a142ff5ba165();
            (0, $6nrSE.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $iPdhn.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $iPdhn.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $6nrSE.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $k4PX7.markFunctionWrapped)(sentryWrapped, fn);
    (0, $k4PX7.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $8f79e94d7334ebb1$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$8f79e94d7334ebb1$var$global.document) return;
    if (!options.eventId) {
        (0, $gXBaL.IS_DEBUG_BUILD) && (0, $exDIp.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $gXBaL.IS_DEBUG_BUILD) && (0, $exDIp.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $8f79e94d7334ebb1$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $8f0wF.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $8f79e94d7334ebb1$var$global.document.head || $8f79e94d7334ebb1$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

});

parcelRegister("04KEt", function(module, exports) {
$parcel$export(module.exports, "Breadcrumbs", () => $00e48fe8fc2f4862$export$2dc68d50d56fbbd);

var $j9yrT = parcelRequire("j9yrT");

var $fdv6x = parcelRequire("fdv6x");

var $4et5w = parcelRequire("4et5w");
parcelRequire("3vRyE");
var $gOtgI = parcelRequire("gOtgI");
var $iPdhn = parcelRequire("iPdhn");
var $fsUz1 = parcelRequire("fsUz1");
var $dSRLC = parcelRequire("dSRLC");
var $9QXUt = parcelRequire("9QXUt");
var $gx7D6 = parcelRequire("gx7D6");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $00e48fe8fc2f4862$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $j9yrT.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $fdv6x.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $iPdhn.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $gOtgI.addInstrumentationHandler)('console', $00e48fe8fc2f4862$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $gOtgI.addInstrumentationHandler)('dom', $00e48fe8fc2f4862$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $gOtgI.addInstrumentationHandler)('xhr', $00e48fe8fc2f4862$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $gOtgI.addInstrumentationHandler)('fetch', $00e48fe8fc2f4862$var$_fetchBreadcrumb);
        if (this._options.history) (0, $gOtgI.addInstrumentationHandler)('history', $00e48fe8fc2f4862$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $00e48fe8fc2f4862$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $dSRLC.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $dSRLC.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $fdv6x.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $00e48fe8fc2f4862$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $gx7D6.severityFromString)(handlerData.level),
        message: (0, $9QXUt.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $9QXUt.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $fdv6x.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $00e48fe8fc2f4862$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $fdv6x.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $00e48fe8fc2f4862$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $fdv6x.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $4et5w.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $fdv6x.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $00e48fe8fc2f4862$var$_historyBreadcrumb(handlerData) {
    var global = (0, $fsUz1.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $iPdhn.parseUrl)(global.location.href);
    var parsedFrom = (0, $iPdhn.parseUrl)(from);
    var parsedTo = (0, $iPdhn.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $fdv6x.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}

});


parcelRegister("9E5Pa", function(module, exports) {
$parcel$export(module.exports, "Dedupe", () => $705c5e13060dd1dd$export$688d98c249d31ad3);
parcelRequire("3vRyE");
var $exDIp = parcelRequire("exDIp");

var $gXBaL = parcelRequire("gXBaL");
/** Deduplication filter */ var $705c5e13060dd1dd$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($705c5e13060dd1dd$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, $gXBaL.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
/** JSDoc */ function $705c5e13060dd1dd$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($705c5e13060dd1dd$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($705c5e13060dd1dd$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $705c5e13060dd1dd$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$705c5e13060dd1dd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$705c5e13060dd1dd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $705c5e13060dd1dd$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $705c5e13060dd1dd$var$_getExceptionFromEvent(previousEvent);
    var currentException = $705c5e13060dd1dd$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$705c5e13060dd1dd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$705c5e13060dd1dd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $705c5e13060dd1dd$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $705c5e13060dd1dd$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $705c5e13060dd1dd$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $705c5e13060dd1dd$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $705c5e13060dd1dd$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $705c5e13060dd1dd$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});

parcelRegister("12eoL", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => $0c11258f00341a93$export$204155decbc90e5a);

var $j9yrT = parcelRequire("j9yrT");

var $fdv6x = parcelRequire("fdv6x");

var $4et5w = parcelRequire("4et5w");
parcelRequire("3vRyE");
var $iPdhn = parcelRequire("iPdhn");
var $gOtgI = parcelRequire("gOtgI");
var $dSRLC = parcelRequire("dSRLC");
var $60nuy = parcelRequire("60nuy");
var $exDIp = parcelRequire("exDIp");

var $243j5 = parcelRequire("243j5");

var $gXBaL = parcelRequire("gXBaL");

var $cjIFI = parcelRequire("cjIFI");
/** Global handlers */ var $0c11258f00341a93$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: $0c11258f00341a93$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $0c11258f00341a93$var$_installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, $j9yrT.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $0c11258f00341a93$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();
/** JSDoc */ function $0c11258f00341a93$var$_installGlobalOnErrorHandler() {
    (0, $gOtgI.addInstrumentationHandler)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, $j9yrT.__read)($0c11258f00341a93$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($0c11258f00341a93$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $cjIFI.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $60nuy.isString)(msg) ? $0c11258f00341a93$var$_eventFromIncompleteOnError(msg, url, line, column) : $0c11258f00341a93$var$_enhanceEventWithInitialFrame((0, $243j5.eventFromUnknownInput)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, $4et5w.Severity).Error;
        $0c11258f00341a93$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $0c11258f00341a93$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $gOtgI.addInstrumentationHandler)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, $j9yrT.__read)($0c11258f00341a93$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($0c11258f00341a93$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $cjIFI.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, $60nuy.isPrimitive)(error) ? $0c11258f00341a93$var$_eventFromRejectionWithPrimitive(error) : (0, $243j5.eventFromUnknownInput)(error, undefined, attachStacktrace, true);
        event.level = (0, $4et5w.Severity).Error;
        $0c11258f00341a93$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $0c11258f00341a93$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0c11258f00341a93$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $60nuy.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $0c11258f00341a93$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0c11258f00341a93$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $60nuy.isString)(url) && url.length > 0 ? url : (0, $dSRLC.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $0c11258f00341a93$var$globalHandlerLog(type) {
    (0, $gXBaL.IS_DEBUG_BUILD) && (0, $exDIp.logger).log("Global Handler attached: " + type);
}
function $0c11258f00341a93$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $iPdhn.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $0c11258f00341a93$var$getHubAndAttachStacktrace() {
    var hub = (0, $fdv6x.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
}

});

parcelRegister("7UL7Z", function(module, exports) {
$parcel$export(module.exports, "LinkedErrors", () => $5c3251f62514a68a$export$8d1e60aaf616fb4f);

var $j9yrT = parcelRequire("j9yrT");

var $jhDCe = parcelRequire("jhDCe");
var $fdv6x = parcelRequire("fdv6x");
parcelRequire("3vRyE");
var $60nuy = parcelRequire("60nuy");

var $243j5 = parcelRequire("243j5");
var $5c3251f62514a68a$var$DEFAULT_KEY = 'cause';
var $5c3251f62514a68a$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $5c3251f62514a68a$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $5c3251f62514a68a$var$DEFAULT_KEY;
        this._limit = options.limit || $5c3251f62514a68a$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $jhDCe.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $fdv6x.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? $5c3251f62514a68a$export$7bd713d0612d8839(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();
function $5c3251f62514a68a$export$7bd713d0612d8839(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $60nuy.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $5c3251f62514a68a$export$e4e3ecf6f8f76c75(limit, hint.originalException, key);
    event.exception.values = (0, $j9yrT.__spread)(linkedErrors, event.exception.values);
    return event;
}
function $5c3251f62514a68a$export$e4e3ecf6f8f76c75(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, $60nuy.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $243j5.exceptionFromError)(error[key]);
    return $5c3251f62514a68a$export$e4e3ecf6f8f76c75(limit, error[key], key, (0, $j9yrT.__spread)([
        exception
    ], stack));
}

});

parcelRegister("amw85", function(module, exports) {
$parcel$export(module.exports, "TryCatch", () => $78b4e1b6b67dcfc7$export$f1a018517668e6d3);

var $j9yrT = parcelRequire("j9yrT");
parcelRequire("3vRyE");
var $k4PX7 = parcelRequire("k4PX7");
var $7YeiV = parcelRequire("7YeiV");
var $fsUz1 = parcelRequire("fsUz1");

var $cjIFI = parcelRequire("cjIFI");
var $78b4e1b6b67dcfc7$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $78b4e1b6b67dcfc7$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $j9yrT.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $fsUz1.getGlobalObject)();
        if (this._options.setTimeout) (0, $k4PX7.fill)(global, 'setTimeout', $78b4e1b6b67dcfc7$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $k4PX7.fill)(global, 'setInterval', $78b4e1b6b67dcfc7$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $k4PX7.fill)(global, 'requestAnimationFrame', $78b4e1b6b67dcfc7$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) (0, $k4PX7.fill)(XMLHttpRequest.prototype, 'send', $78b4e1b6b67dcfc7$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $78b4e1b6b67dcfc7$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($78b4e1b6b67dcfc7$var$_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = 'TryCatch';
    return TryCatch;
}();
/** JSDoc */ function $78b4e1b6b67dcfc7$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, $cjIFI.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $7YeiV.getFunctionName)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $78b4e1b6b67dcfc7$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $cjIFI.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $7YeiV.getFunctionName)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $78b4e1b6b67dcfc7$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $k4PX7.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $7YeiV.getFunctionName)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $k4PX7.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $7YeiV.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $cjIFI.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $78b4e1b6b67dcfc7$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, $fsUz1.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $k4PX7.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') fn.handleEvent = (0, $cjIFI.wrap)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $7YeiV.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $cjIFI.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $7YeiV.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $k4PX7.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("2g5Rp", function(module, exports) {
$parcel$export(module.exports, "UserAgent", () => $1a519f282a20947e$export$5fba5e10934a4faf);

var $j9yrT = parcelRequire("j9yrT");

var $jhDCe = parcelRequire("jhDCe");
var $fdv6x = parcelRequire("fdv6x");
parcelRequire("3vRyE");
var $fsUz1 = parcelRequire("fsUz1");
var $1a519f282a20947e$var$global = (0, $fsUz1.getGlobalObject)();
/** UserAgent */ var $1a519f282a20947e$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $jhDCe.addGlobalEventProcessor)(function(event) {
            if ((0, $fdv6x.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$1a519f282a20947e$var$global.navigator && !$1a519f282a20947e$var$global.location && !$1a519f282a20947e$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $1a519f282a20947e$var$global.location && $1a519f282a20947e$var$global.location.href;
                var referrer = ($1a519f282a20947e$var$global.document || {}).referrer;
                var userAgent = ($1a519f282a20947e$var$global.navigator || {}).userAgent;
                var headers = (0, $j9yrT.__assign)((0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    'User-Agent': userAgent
                });
                var request = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = 'UserAgent';
    return UserAgent;
}();

});


parcelRegister("80ILg", function(module, exports) {
$parcel$export(module.exports, "CaptureConsole", () => $5d510b821f3ec7b0$export$25a43cb5b5c58c08);
parcelRequire("3vRyE");
var $exDIp = parcelRequire("exDIp");
var $k4PX7 = parcelRequire("k4PX7");
var $fsUz1 = parcelRequire("fsUz1");
var $9QXUt = parcelRequire("9QXUt");
var $gx7D6 = parcelRequire("gx7D6");
var $5d510b821f3ec7b0$var$global = (0, $fsUz1.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $5d510b821f3ec7b0$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $exDIp.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $5d510b821f3ec7b0$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $5d510b821f3ec7b0$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $k4PX7.fill)($5d510b821f3ec7b0$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $gx7D6.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $9QXUt.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $9QXUt.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($5d510b821f3ec7b0$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();

});

parcelRegister("5HREu", function(module, exports) {
$parcel$export(module.exports, "Dedupe", () => $427a96109acaa663$export$688d98c249d31ad3);
parcelRequire("3vRyE");
var $exDIp = parcelRequire("exDIp");

var $bkybD = parcelRequire("bkybD");
/** Deduplication filter */ var $427a96109acaa663$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($427a96109acaa663$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $bkybD.IS_DEBUG_BUILD) && (0, $exDIp.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $427a96109acaa663$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($427a96109acaa663$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($427a96109acaa663$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $427a96109acaa663$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$427a96109acaa663$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$427a96109acaa663$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $427a96109acaa663$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $427a96109acaa663$var$_getExceptionFromEvent(previousEvent);
    var currentException = $427a96109acaa663$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$427a96109acaa663$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$427a96109acaa663$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $427a96109acaa663$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $427a96109acaa663$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $427a96109acaa663$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $427a96109acaa663$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $427a96109acaa663$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $427a96109acaa663$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});
parcelRegister("bkybD", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $83fc14ba361a9898$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $83fc14ba361a9898$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("3FT1D", function(module, exports) {
$parcel$export(module.exports, "ExtraErrorData", () => $2acfe251977acc25$export$56d961ef3a52a072);

var $j9yrT = parcelRequire("j9yrT");
parcelRequire("3vRyE");
var $60nuy = parcelRequire("60nuy");
var $exDIp = parcelRequire("exDIp");
var $4vsZe = parcelRequire("4vsZe");

var $bkybD = parcelRequire("bkybD");
/** Patch toString calls to return proper name for wrapped functions */ var $2acfe251977acc25$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $j9yrT.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $60nuy.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $j9yrT.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $4vsZe.normalize)(errorData, this._options.depth);
            if ((0, $60nuy.isPlainObject)(normalizedErrorData)) contexts = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $j9yrT.__assign)({}, normalizedErrorData), _a));
            return (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $j9yrT.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $60nuy.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $j9yrT.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $60nuy.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $bkybD.IS_DEBUG_BUILD) && (0, $exDIp.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();

});

parcelRegister("bDBth", function(module, exports) {
$parcel$export(module.exports, "Transaction", () => $87906740fed3e83d$export$febc5573c75cefb0);
/** Add node transaction to the event */ var $87906740fed3e83d$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();

});




parcelRegister("gD9HZ", function(module, exports) {
$parcel$export(module.exports, "updateStarredSavedSearch", () => $15d3fab78f9777c6$export$82034d9e49b8fd69);
$parcel$export(module.exports, "deleteStarredSavedSearch", () => $15d3fab78f9777c6$export$110d95467eefe557);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hG5S4 = parcelRequire("hG5S4");
const $15d3fab78f9777c6$export$82034d9e49b8fd69 = (savedSearchId = '')=>(0, $hG5S4.eocFetch)('/v1/alerts/ui-preferences/starredSearches', {
        method: 'POST',
        body: {
            id: savedSearchId
        }
    });
const $15d3fab78f9777c6$export$110d95467eefe557 = (savedSearchId = '')=>(0, $hG5S4.eocFetch)(`/v1/alerts/ui-preferences/starredSearches?savedSearchId=${savedSearchId}`, {
        method: 'DELETE',
        responseType: 'text'
    });

});



parcelRegister("bdriB", function(module, exports) {
$parcel$export(module.exports, "StarSection", () => $6b93ba8cd9dad572$export$1f2b462fc43ffc58);

var $euxye = parcelRequire("euxye");

var $aQCoC = parcelRequire("aQCoC");

var $1mQ7r = parcelRequire("1mQ7r");

var $5IkoH = parcelRequire("5IkoH");

var $KL7Bq = parcelRequire("KL7Bq");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $djYhH = parcelRequire("djYhH");

var $OFy3z = parcelRequire("OFy3z");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $1Pd0K = parcelRequire("1Pd0K");

var $kYcMD = parcelRequire("kYcMD");
const $6b93ba8cd9dad572$var$starredSectionMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.starred",
    defaultMessage: "Starred"
});
const $6b93ba8cd9dad572$var$alertsMessageDefinition = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-operations.alerts",
    defaultMessage: "Alerts"
});
const $6b93ba8cd9dad572$export$1f2b462fc43ffc58 = ({ starred: starred, viewType: viewType, savedSearchIdFromURL: savedSearchIdFromURL, setSelectedFilter: setSelectedFilter, setLastVisitedSearch: setLastVisitedSearch })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { unstarSavedSearch: unstarSavedSearch } = (0, $kYcMD.useStarredSearchService)();
    const { icon: pagesIcon } = (0, $KL7Bq.useFormattedMessageAndIcon)($6b93ba8cd9dad572$var$alertsMessageDefinition, (0, (/*@__PURE__*/$parcel$interopDefault($OFy3z))));
    if (!starred || starred.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), {
        isMenuListItem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($6b93ba8cd9dad572$var$starredSectionMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, starred.map((item)=>{
        const savedSearchId = (0, $1Pd0K.OpsgenieSavedSearchAri).parse(item.id).savedSearchId;
        const href = `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}&filter=${savedSearchId}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
            key: item.id,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}&filter=${savedSearchId}`,
            elemBefore: pagesIcon,
            menuId: (0, $5IkoH.ENTITY_ID).ALARM_QUEUE(savedSearchIdFromURL ? savedSearchId : item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter(item.id);
                setLastVisitedSearch(href);
            },
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1mQ7r.default), {
                isFavorite: true,
                isSmall: true,
                pending: false,
                onClick: ()=>unstarSavedSearch(item)
            })
        }, item.name);
    })));
};
$6b93ba8cd9dad572$export$1f2b462fc43ffc58.displayName = "StarSection";

});


parcelRegister("j4Fdk", function(module, exports) {
$parcel$export(module.exports, "AlertsMenuItemContentNew", () => $e68b681aebb5ad75$export$f0f13aaf6210507e);

var $kVYXb = parcelRequire("kVYXb");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");




var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $1xxzH = parcelRequire("1xxzH");

var $4VtOS = parcelRequire("4VtOS");

var $aQCoC = parcelRequire("aQCoC");

var $jzXAj = parcelRequire("jzXAj");

var $KL7Bq = parcelRequire("KL7Bq");

var $223zC = parcelRequire("223zC");

var $f4N10 = parcelRequire("f4N10");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $8jEW8 = parcelRequire("8jEW8");

var $OFy3z = parcelRequire("OFy3z");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $3GN2r = parcelRequire("3GN2r");

var $gDdYI = parcelRequire("gDdYI");

var $f2wVS = parcelRequire("f2wVS");
var $2ffUK = parcelRequire("2ffUK");

var $1Pd0K = parcelRequire("1Pd0K");

var $bUCC9 = parcelRequire("bUCC9");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $9fOfL = parcelRequire("9fOfL");

var $2sxBx = parcelRequire("2sxBx");

var $1Fgaa = parcelRequire("1Fgaa");

var $gfy2D = parcelRequire("gfy2D");

var $bdriB = parcelRequire("bdriB");
const $e68b681aebb5ad75$var$allSearchMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.all-search",
    defaultMessage: "All"
});
const $e68b681aebb5ad75$var$openSearchMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.open-search",
    defaultMessage: "Open"
});
const $e68b681aebb5ad75$var$closedSearchMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.closed-search",
    defaultMessage: "Closed"
});
const $e68b681aebb5ad75$var$unackedSearchMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.unacked-search",
    defaultMessage: "Unacknowledged"
});
const $e68b681aebb5ad75$var$notSeenSearchMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.not-seen-search",
    defaultMessage: "Not seen"
});
const $e68b681aebb5ad75$var$assignedToMeSearchMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.assigned-to-me-search",
    defaultMessage: "Assigned to me"
});
const $e68b681aebb5ad75$var$defaultFiltersMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.default-filters",
    defaultMessage: "Default filters"
});
const $e68b681aebb5ad75$var$alertsMessageDefinition = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-operations.alerts",
    defaultMessage: "Alerts"
});
function $e68b681aebb5ad75$export$f0f13aaf6210507e({ queryRef: queryRef }) {
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $kVYXb.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    const [savedSearchIdFromURL] = (0, $2ffUK.useQueryParam)('filter');
    const [alertSearchQueryFromURL] = (0, $2ffUK.useQueryParam)('query');
    const [selectedFilter, setSelectedFilter] = (0, $euxye.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const accountId = (0, $3GN2r.useAccountId)();
    const [viewType] = (0, $2ffUK.useQueryParam)('view');
    const { icon: pagesIcon } = (0, $KL7Bq.useFormattedMessageAndIcon)($e68b681aebb5ad75$var$alertsMessageDefinition, (0, (/*@__PURE__*/$parcel$interopDefault($OFy3z))));
    const isAlertsRoute = (0, $f2wVS.useIsActiveRoute)(new Set([
        (0, $223zC.eocGlobalAlertListRoute).name,
        (0, $f4N10.eocTeamAlertDetailRoute).name
    ]));
    const { setLastVisitedSearch: setLastVisitedSearch } = (0, $2sxBx.useAlertsPopoutStore)();
    const { sharedWithMe: sharedWithMe, createdByMe: createdByMe, starred: starred } = data?.opsgenie?.savedSearches || {};
    const defaultFilters = (0, $euxye.useMemo)(()=>[
            {
                id: 'all',
                name: formatMessage($e68b681aebb5ad75$var$allSearchMessage),
                alertSearchQuery: ''
            },
            {
                id: 'open',
                name: formatMessage($e68b681aebb5ad75$var$openSearchMessage),
                alertSearchQuery: `${(0, $9fOfL.IDENTIFIER_STATUS)}${(0, $9fOfL.OPERATOR_EQUAL_TO)} ${(0, $9fOfL.STRING_LITERAL_STATUS_OPEN)}`
            },
            {
                id: 'closed',
                name: formatMessage($e68b681aebb5ad75$var$closedSearchMessage),
                alertSearchQuery: `${(0, $9fOfL.IDENTIFIER_STATUS)}${(0, $9fOfL.OPERATOR_EQUAL_TO)} ${(0, $9fOfL.STRING_LITERAL_STATUS_CLOSED)}`
            },
            {
                id: 'unacked',
                name: formatMessage($e68b681aebb5ad75$var$unackedSearchMessage),
                alertSearchQuery: `${(0, $9fOfL.IDENTIFIER_STATUS)}${(0, $9fOfL.OPERATOR_EQUAL_TO)} ${(0, $9fOfL.STRING_LITERAL_STATUS_OPEN)} ${(0, $9fOfL.LOGICAL_OPERATOR_AND)} ${(0, $9fOfL.IDENTIFIER_ACKNOWLEDGED)}${(0, $9fOfL.OPERATOR_EQUAL_TO)} ${(0, $9fOfL.BOOLEAN_LITERAL_FALSE)}`
            },
            {
                id: 'notSeen',
                name: formatMessage($e68b681aebb5ad75$var$notSeenSearchMessage),
                alertSearchQuery: `${(0, $9fOfL.IDENTIFIER_IS_SEEN)}${(0, $9fOfL.OPERATOR_EQUAL_TO)} ${(0, $9fOfL.BOOLEAN_LITERAL_FALSE)}`
            },
            {
                id: 'assignedToMe',
                name: formatMessage($e68b681aebb5ad75$var$assignedToMeSearchMessage),
                alertSearchQuery: `${(0, $9fOfL.IDENTIFIER_ASSIGNEE)}${(0, $9fOfL.OPERATOR_EQUAL_TO)} "${accountId || 'me'}"`
            }
        ], [
        formatMessage,
        accountId
    ]);
    const defaultFilterMenuIds = $e68b681aebb5ad75$var$getParentMenuId(defaultFilters);
    const starredIds = (0, $euxye.useMemo)(()=>starred ? starred.map((item)=>item.id) : [], [
        starred
    ]);
    const defaultFilterWithComponentList = $e68b681aebb5ad75$var$getComponentAddedSearchObjects(defaultFilters, pagesIcon, viewType, 'default', savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute, starredIds);
    const sharedWithMeWithComponentList = $e68b681aebb5ad75$var$getComponentAddedSearchObjects(sharedWithMe || [], pagesIcon, viewType, 'sharedWithMe', savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute, starredIds);
    const createdByMeWithComponentList = $e68b681aebb5ad75$var$getComponentAddedSearchObjects(createdByMe || [], pagesIcon, viewType, 'createdByMe', savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute, starredIds);
    const allFiltersWithComponentList = (0, $euxye.useMemo)(()=>[
            ...defaultFilterWithComponentList,
            ...sharedWithMeWithComponentList,
            ...createdByMeWithComponentList
        ], [
        createdByMeWithComponentList,
        defaultFilterWithComponentList,
        sharedWithMeWithComponentList
    ]);
    const getSelectedFilterComponentIfNotDefault = (0, $euxye.useMemo)(()=>(filterId)=>{
            if (defaultFilters.find((item)=>item.id === filterId) || starred?.find((item)=>item.id === filterId)) return;
            const foundComponent = [
                ...sharedWithMeWithComponentList,
                ...createdByMeWithComponentList
            ].find((item)=>item.id === filterId)?.component;
            return foundComponent;
        }, [
        createdByMeWithComponentList,
        defaultFilters,
        sharedWithMeWithComponentList,
        starred
    ]);
    (0, $euxye.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        if (selectedFilter === '') {
            const customSearches = [
                ...createdByMeWithComponentList,
                ...sharedWithMeWithComponentList
            ];
            if (savedSearchIdFromURL) {
                const matchedItem = customSearches.find((item)=>(0, $1Pd0K.OpsgenieSavedSearchAri).parse(item.id).savedSearchId === savedSearchIdFromURL);
                if (matchedItem) {
                    setSelectedFilter(matchedItem.id);
                    return;
                }
            }
            if (alertSearchQueryFromURL) {
                const matchedItem = customSearches.find((item)=>item.alertSearchQuery === alertSearchQueryFromURL);
                if (matchedItem) setSelectedFilter(matchedItem.id);
            }
        }
    }, [
        alertSearchQueryFromURL,
        allFiltersWithComponentList,
        createdByMeWithComponentList,
        savedSearchIdFromURL,
        selectedFilter,
        sharedWithMeWithComponentList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4.sidebar.operations.alerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8jEW8.default), {
        name: (0, $bUCC9.ALERT_LIST_SPOTLIGHT_TARGETS).sidebar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bdriB.StarSection), {
        starred: starred ?? [],
        viewType: viewType,
        savedSearchIdFromURL: savedSearchIdFromURL,
        setSelectedFilter: setSelectedFilter,
        setLastVisitedSearch: setLastVisitedSearch
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        menuId: defaultFilterMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                    level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                    itemId: 'defaultFilters',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        testId: (0, $jzXAj.getTestId)(defaultFilterMenuIds),
        interactionName: "nav4-sidebar-operations-alerts"
    }, formatMessage($e68b681aebb5ad75$var$defaultFiltersMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, defaultFilters.map((item)=>{
        const href = `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            key: item.id,
            href: href,
            menuId: (0, $5IkoH.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter(item.id);
                setLastVisitedSearch(href);
                (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                        level: (0, $ef39084c605eb7e8$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        parentItemId: 'defaultFilters',
                        itemType: 'defaultFilter'
                    }
                });
            }
        }, item.name);
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, getSelectedFilterComponentIfNotDefault(selectedFilter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1Fgaa.AlertsFlyoutMenuItem), {
        defaultFilterWithComponentList: defaultFilterWithComponentList,
        sharedWithMeWithComponentList: sharedWithMeWithComponentList,
        createdByMeWithComponentList: createdByMeWithComponentList,
        allFiltersWithComponentList: allFiltersWithComponentList
    }))));
}
$e68b681aebb5ad75$export$f0f13aaf6210507e.displayName = "AlertsMenuItemContentNew";
function $e68b681aebb5ad75$var$getParentMenuId(arr) {
    return (0, $1xxzH.toMenuIdFromMenuIdList)((arr || []).map((i)=>(0, $5IkoH.ENTITY_ID).ALARM_QUEUE(i.alertSearchQuery)));
}
function $e68b681aebb5ad75$var$getComponentAddedSearchObjects(arrayList, pagesIcon, viewType, savedSearchType, savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute, starredIds) {
    return arrayList.map((item)=>{
        const requiresSavedSearchId = item.id && savedSearchType !== 'default';
        const savedSearchId = requiresSavedSearchId ? (0, $1Pd0K.OpsgenieSavedSearchAri).parse(item.id).savedSearchId : '';
        const href = `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${requiresSavedSearchId ? `&filter=${savedSearchId}` : ''}`;
        return {
            ...item,
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
                elemBefore: pagesIcon,
                key: item.id,
                href: href,
                menuId: (0, $5IkoH.ENTITY_ID).ALARM_QUEUE(savedSearchIdFromURL ? savedSearchId : item.alertSearchQuery),
                onClick: ()=>{
                    setSelectedFilter(item.id);
                    if (isAlertsRoute) setLastVisitedSearch(href);
                    (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
                        action: 'clicked',
                        actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
                        actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_OPERATIONS],
                        attributes: {
                            componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                            level: (0, $ef39084c605eb7e8$export$f9db6a58b4aabd18),
                            itemId: item.id,
                            parentItemId: 'defaultFilters',
                            itemType: 'defaultFilter'
                        }
                    });
                },
                actionsOnHover: savedSearchType !== 'default' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gfy2D.SavedSearchActionButtons), {
                    savedSearchType: savedSearchType,
                    savedSearch: item,
                    isStarred: starredIds.includes(item.id)
                }) : undefined
            }, item.name)
        };
    });
}

});
parcelRegister("kVYXb", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9a27562ceefcd6d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7412dfdf9010a377d9ac591ce40c4a59>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c9a27562ceefcd6d$var$node = function() {
    var v0 = [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "alertSearchQuery"
            },
            "action": "THROW"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "AlertsMenuItemContentNew",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "OpsgenieQuery",
                    "kind": "LinkedField",
                    "name": "opsgenie",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "OpsgenieSavedSearches",
                                "kind": "LinkedField",
                                "name": "savedSearches",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "starred",
                                            "plural": true,
                                            "selections": v0 /*: any*/ 
                                        },
                                        "action": "THROW"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": v0 /*: any*/ 
                                        },
                                        "action": "THROW"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": v0 /*: any*/ 
                                        },
                                        "action": "THROW"
                                    }
                                ]
                            },
                            "action": "LOG"
                        }
                    ]
                },
                "action": "LOG"
            }
        ],
        "type": "Query"
    };
}();
$c9a27562ceefcd6d$var$node.hash = "bd4e1308e60d32924440a27f61ed4f9a";
var $c9a27562ceefcd6d$export$2e2bcd8739ae039 = $c9a27562ceefcd6d$var$node;

});

parcelRegister("bUCC9", function(module, exports) {
$parcel$export(module.exports, "QUERY_PARAMETER_QUERY_LABEL", () => $e844f3078e35139d$export$19f7845e9b507cf2);
$parcel$export(module.exports, "QUERY_PARAMETER_VIEW_LABEL", () => $e844f3078e35139d$export$8540b2e79718c77f);
$parcel$export(module.exports, "QUERY_PARAMETER_ONLY_ALERTS_LABEL", () => $e844f3078e35139d$export$d0190736add6775e);
$parcel$export(module.exports, "BASE_URL", () => $e844f3078e35139d$export$ca6dda5263526f75);
$parcel$export(module.exports, "ALERT_LIST_SPOTLIGHT_TARGETS", () => $e844f3078e35139d$export$84fe9cd6ee892532);
const $e844f3078e35139d$export$19f7845e9b507cf2 = 'query';
const $e844f3078e35139d$export$8540b2e79718c77f = 'view';
const $e844f3078e35139d$export$d0190736add6775e = 'onlyAlerts';
const $e844f3078e35139d$export$ca6dda5263526f75 = '/jira/ops';
const $e844f3078e35139d$export$84fe9cd6ee892532 = {
    sidebar: 'operations-alert-sidebar-target',
    alertHeader: 'operations-alert-header-target',
    alertActions: 'operations-alert-actions-target',
    alertSources: 'operations-alert-sources-target',
    alertResponders: 'operations-alert-responders-target'
};

});

parcelRegister("1Fgaa", function(module, exports) {
$parcel$export(module.exports, "AlertsFlyoutMenuItem", () => $41d07abe8fe6e06d$export$22af2a033e73b845);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $7aCqr = parcelRequire("7aCqr");

var $c69sa = parcelRequire("c69sa");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");

var $eAQb7 = parcelRequire("eAQb7");

var $aNG0w = parcelRequire("aNG0w");

var $2iotI = parcelRequire("2iotI");

var $i5BFC = parcelRequire("i5BFC");

var $4e1Ev = parcelRequire("4e1Ev");
var $ah8fM = parcelRequire("ah8fM");
var $4U30j = parcelRequire("4U30j");
var $iozCP = parcelRequire("iozCP");
var $02ogW = parcelRequire("02ogW");

var $6w18e = parcelRequire("6w18e");

var $djYhH = parcelRequire("djYhH");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $i860n = parcelRequire("i860n");
const $41d07abe8fe6e06d$var$alertsFlyoutTitleMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts",
    defaultMessage: "Alerts"
});
const $41d07abe8fe6e06d$var$alertsFlyoutCloseButtonMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.close-button",
    defaultMessage: "Close alerts menu"
});
const $41d07abe8fe6e06d$var$alertsFlyoutSearchPlaceholderMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.view-all-filters-search-placeholder",
    defaultMessage: "Search"
});
const $41d07abe8fe6e06d$var$alertsFlyoutViewAllButtonMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.view-all-filters-popup-menu-button-text",
    defaultMessage: "View all"
});
const $41d07abe8fe6e06d$var$alertsFlyoutDefaultFiltersMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.default-filters",
    defaultMessage: "Default filters"
});
const $41d07abe8fe6e06d$var$alertsFlyoutSharedWithMeMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.shared-with-me",
    defaultMessage: "Shared with me"
});
const $41d07abe8fe6e06d$var$alertsFlyoutCreatedByMeMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.created-by-me",
    defaultMessage: "Created by me"
});
const $41d07abe8fe6e06d$var$alertsFlyoutNoResultsFoundMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-operations.view-all-filters-no-results-found-text",
    defaultMessage: "No search results found"
});
const $41d07abe8fe6e06d$export$22af2a033e73b845 = ({ defaultFilterWithComponentList: defaultFilterWithComponentList, sharedWithMeWithComponentList: sharedWithMeWithComponentList, createdByMeWithComponentList: createdByMeWithComponentList, allFiltersWithComponentList: allFiltersWithComponentList })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [textFilterValue, setTextFilterValue] = (0, $euxye.useState)('');
    const [foundItems, setFoundItems] = (0, $euxye.useState)([]);
    const handleChange = (0, $euxye.useCallback)((event)=>{
        const value = event.currentTarget.value;
        setTextFilterValue(value);
        const foundItemsList = allFiltersWithComponentList.filter((item)=>item.name.toLowerCase().includes(value.toLowerCase()));
        const components = foundItemsList.map((item)=>item.component);
        setFoundItems(components);
    }, [
        allFiltersWithComponentList
    ]);
    const onStopSavedSearch = (0, $euxye.useCallback)(()=>{
        const savedSearchesEvent = createAnalyticsEvent({
            action: 'blurred',
            actionSubject: 'jsmViewAllSavedSearchesFlyoutSearch'
        });
        (0, $aJ81Y.fireUIAnalytics)(savedSearchesEvent, 'stopViewAllQueueSearch');
    }, [
        createAnalyticsEvent
    ]);
    // New header component for the flyout menu behind fg('platform_dst_nav4_flyout_menu_slots_close_button')
    const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ah8fM.FlyoutHeader), {
        title: formatMessage($41d07abe8fe6e06d$var$alertsFlyoutTitleMessage),
        closeButtonLabel: formatMessage($41d07abe8fe6e06d$var$alertsFlyoutCloseButtonMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
        isCompact: true,
        value: textFilterValue,
        onChange: handleChange,
        "aria-label": formatMessage($41d07abe8fe6e06d$var$alertsFlyoutSearchPlaceholderMessage),
        placeholder: formatMessage($41d07abe8fe6e06d$var$alertsFlyoutSearchPlaceholderMessage),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eAQb7))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }),
        onBlur: onStopSavedSearch
    }));
    const MenuSectionBehindFG = (0, $i860n.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? (0, $euxye.Fragment) : (0, $6w18e.MenuSection);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4U30j.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $02ogW.FlyoutMenuItemTrigger), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        })
    }, formatMessage($41d07abe8fe6e06d$var$alertsFlyoutViewAllButtonMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iozCP.FlyoutMenuItemContent), {
        maxHeight: (0, $i860n.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? 460 : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $i5BFC.default), {
        value: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(MenuSectionBehindFG, null, (0, $i860n.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? header : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $41d07abe8fe6e06d$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "xsmall"
    }, formatMessage($41d07abe8fe6e06d$var$alertsFlyoutTitleMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $41d07abe8fe6e06d$var$textfieldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
        isCompact: true,
        value: textFilterValue,
        onChange: handleChange,
        "aria-label": formatMessage($41d07abe8fe6e06d$var$alertsFlyoutSearchPlaceholderMessage),
        placeholder: formatMessage($41d07abe8fe6e06d$var$alertsFlyoutSearchPlaceholderMessage),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eAQb7))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }),
        onBlur: onStopSavedSearch
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($41d07abe8fe6e06d$var$StackWrapper, null, !textFilterValue.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $i5BFC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "xxsmall"
    }, formatMessage($41d07abe8fe6e06d$var$alertsFlyoutDefaultFiltersMessage))), (0, $i860n.fg)('jsm-corecaps-ally-fixes-batch-6') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, defaultFilterWithComponentList.map((item)=>item.component)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, defaultFilterWithComponentList.map((item)=>item.component))), sharedWithMeWithComponentList && sharedWithMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $i5BFC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "xxsmall"
    }, formatMessage($41d07abe8fe6e06d$var$alertsFlyoutSharedWithMeMessage))), (0, $i860n.fg)('jsm-corecaps-ally-fixes-batch-6') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, sharedWithMeWithComponentList.map((item)=>item.component)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, sharedWithMeWithComponentList.map((item)=>item.component))), createdByMeWithComponentList && createdByMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $i5BFC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "xxsmall"
    }, formatMessage($41d07abe8fe6e06d$var$alertsFlyoutCreatedByMeMessage))), (0, $i860n.fg)('jsm-corecaps-ally-fixes-batch-6') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, createdByMeWithComponentList.map((item)=>item.component)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, createdByMeWithComponentList.map((item)=>item.component)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, foundItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        key: "no-item-found",
        paddingBlock: "space.100",
        xcss: $41d07abe8fe6e06d$var$noSearchResultsFoundStyles
    }, formatMessage($41d07abe8fe6e06d$var$alertsFlyoutNoResultsFoundMessage)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($41d07abe8fe6e06d$var$SearchResults, {
        foundItems: foundItems
    })))))));
};
$41d07abe8fe6e06d$export$22af2a033e73b845.displayName = "AlertsFlyoutMenuItem";
const $41d07abe8fe6e06d$var$SearchResults = ({ foundItems: foundItems })=>(0, $i860n.fg)('jsm-corecaps-ally-fixes-batch-6') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, foundItems) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, foundItems);
$41d07abe8fe6e06d$var$SearchResults.displayName = "SearchResults";
const $41d07abe8fe6e06d$var$StackWrapper = ({ children: children })=>(0, $i860n.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4e1Ev.FlyoutBody), null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.050",
        xcss: $41d07abe8fe6e06d$var$flyoutContentStyles
    }, children);
$41d07abe8fe6e06d$var$StackWrapper.displayName = "StackWrapper";
const $41d07abe8fe6e06d$var$headerStyles = (0, $fbAgj.xcss)({
    marginBottom: 'space.150',
    backgroundColor: 'utility.elevation.surface.current'
});
const $41d07abe8fe6e06d$var$textfieldStyles = (0, $fbAgj.xcss)({
    paddingRight: 'space.100'
});
const $41d07abe8fe6e06d$var$noSearchResultsFoundStyles = (0, $fbAgj.xcss)({
    fontStyle: 'italic'
});
const $41d07abe8fe6e06d$var$flyoutContentStyles = (0, $fbAgj.xcss)({
    maxHeight: '500px',
    overflowY: 'auto'
});

});
parcelRegister("i5BFC", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee23fe11475dbf1c$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $5LifH = parcelRequire("5LifH");

var $jZMJE = parcelRequire("jZMJE");
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ const $ee23fe11475dbf1c$var$HeadingLevelContextProvider = ({ children: children, value: value })=>{
    const parentHeadingLevel = (0, $jZMJE.useHeadingLevel)();
    const headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5LifH.HeadingLevelContext).Provider, {
        value: value || headingLevel,
        children: children
    });
};
$ee23fe11475dbf1c$var$HeadingLevelContextProvider.displayName = "HeadingLevelContextProvider";
var $ee23fe11475dbf1c$export$2e2bcd8739ae039 = $ee23fe11475dbf1c$var$HeadingLevelContextProvider;

});

parcelRegister("4e1Ev", function(module, exports) {
$parcel$export(module.exports, "FlyoutBody", () => $0de25c4041b7514f$export$eb3b7066b3f4b3d0);
/* flyout-body.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");
const $0de25c4041b7514f$var$bodyStyles = {
    root: "_1e0c1txw _2lx21bp4 _kqswh2mm _18m91wug _4t3i1osq _1bahv2br _ahbqx0bf _12l2x0bf _6rthx0bf _bozgu2gc _y4tiu2gc _1q511b66 _85i5u2gc"
};
const $0de25c4041b7514f$export$eb3b7066b3f4b3d0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef((props, ref)=>{
    const { children: children, testId: testId, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onBlurCapture: onBlurCapture } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: ref,
        "data-testid": testId,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onBlurCapture: onBlurCapture,
        role: "presentation",
        className: (0, $4jQY2.default)([
            $0de25c4041b7514f$var$bodyStyles.root
        ]),
        children: children
    });
});

});

parcelRegister("ah8fM", function(module, exports) {
$parcel$export(module.exports, "FlyoutHeader", () => $7538aacf7ebd2488$export$b6594823f0d869c);
/* flyout-header.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $2iotI = parcelRequire("2iotI");

var $2XXtG = parcelRequire("2XXtG");

var $ck5tE = parcelRequire("ck5tE");

var $hvEIh = parcelRequire("hvEIh");
const $7538aacf7ebd2488$var$headerStyles = {
    root: "_zulp12x7 _bozg1b66 _85i5v77o _1e0c1txw _2lx21bp4",
    hasChildren: "_85i51b66",
    flex: "_zulppxbi _1bah1yb4 _2lx21sbv _4cvr1h6o _1bsb1osq _bozgv77o"
};
const $7538aacf7ebd2488$export$b6594823f0d869c = (props)=>{
    const { children: children, testId: testId, title: title, closeButtonLabel: closeButtonLabel } = props;
    const id = (0, $hvEIh.useTitleId)();
    const onCloseRef = (0, $euxye.useContext)((0, $hvEIh.OnCloseContext));
    const handleClose = (0, $euxye.useCallback)((event)=>{
        onCloseRef.current?.(event, 'close-button');
    }, [
        onCloseRef
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            $7538aacf7ebd2488$var$headerStyles.root,
            Boolean(children) && $7538aacf7ebd2488$var$headerStyles.hasChildren
        ]),
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2XXtG.Flex), {
                xcss: $7538aacf7ebd2488$var$headerStyles.flex,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ck5tE.CloseButton), {
                        label: closeButtonLabel,
                        onClick: handleClose,
                        testId: testId && `${testId}--close-button`
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                        size: "xsmall",
                        as: "h2",
                        id: id,
                        children: title
                    })
                ]
            }),
            children
        ]
    });
};
$7538aacf7ebd2488$export$b6594823f0d869c.displayName = "FlyoutHeader";

});
parcelRegister("ck5tE", function(module, exports) {
$parcel$export(module.exports, "CloseButton", () => $30eed35bbb5220a4$export$de65de8213222d10);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $i68tN = parcelRequire("i68tN");
const $30eed35bbb5220a4$export$de65de8213222d10 = ({ label: label, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
        testId: testId,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i68tN))),
        label: label,
        onClick: onClick
    });
$30eed35bbb5220a4$export$de65de8213222d10.displayName = "CloseButton";

});






parcelRegister("9rz84", function(module, exports) {
$parcel$export(module.exports, "Nav4Plans", () => $b2a3a5473d4aa2a9$export$a9599e1720ee6c82);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $4UGAB = parcelRequire("4UGAB");

var $gDdYI = parcelRequire("gDdYI");

var $i860n = parcelRequire("i860n");


var $gWyrs = parcelRequire("gWyrs");

var $ash72 = parcelRequire("ash72");
function $b2a3a5473d4aa2a9$export$a9599e1720ee6c82(props) {
    const isStandardOrFree = (0, $4UGAB.useIsStandardOrFreeJSW)();
    const isUnlicensedJsw = (0, $4UGAB.useIsUnlicensedJSW)();
    if (isUnlicensedJsw) return null;
    if (isStandardOrFree) {
        const actualProps = (0, $i860n.fg)('navx-global-side-nav') ? props : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ash72.Nav4PlansPremiumUpsellFeatureGate), actualProps);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4.sidebar.plans"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "flag",
        id: "plans-section",
        packageName: (0, $3aac2bcbb88c830d$export$b8b9d90f9e5bd72b),
        teamName: (0, $3aac2bcbb88c830d$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gWyrs.Nav4Plans), props)));
}
$b2a3a5473d4aa2a9$export$a9599e1720ee6c82.displayName = "Nav4Plans";

});
parcelRegister("4UGAB", function(module, exports) {
$parcel$export(module.exports, "useIsStandardOrFreeJSW", () => $7d8ae93a2a8b11c5$export$5edaea31b41b30b);
$parcel$export(module.exports, "useIsPremiumJSW", () => $7d8ae93a2a8b11c5$export$d245a3118a8b4004);
$parcel$export(module.exports, "useIsUnlicensedJSW", () => $7d8ae93a2a8b11c5$export$47ec61465121ff53);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");

var $hJL79 = parcelRequire("hJL79");

var $ccEzE = parcelRequire("ccEzE");
const $7d8ae93a2a8b11c5$export$a55cc88b2381611c = ()=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    const jswEdition = appEditions ? (0, $d8LhJ.getEdition)((0, $hJL79.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $d8LhJ.FREE_EDITION);
};
const $7d8ae93a2a8b11c5$export$5edaea31b41b30b = ()=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    const jswEdition = appEditions ? (0, $d8LhJ.getEdition)((0, $hJL79.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $d8LhJ.STANDARD_EDITION) || jswEdition === (0, $d8LhJ.FREE_EDITION);
};
const $7d8ae93a2a8b11c5$export$d245a3118a8b4004 = ()=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    const jswEdition = appEditions ? (0, $d8LhJ.getEdition)((0, $hJL79.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $d8LhJ.PREMIUM_EDITION);
};
const $7d8ae93a2a8b11c5$export$47ec61465121ff53 = ()=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    const jswEdition = appEditions ? (0, $d8LhJ.getEdition)((0, $hJL79.JIRA_SOFTWARE), appEditions) : undefined;
    return !jswEdition || jswEdition === (0, $d8LhJ.UNLICENSED);
};

});

/* eslint-disable jira/filename-case */ const $3aac2bcbb88c830d$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Plans';
const $3aac2bcbb88c830d$export$d57b6b390e78d90f = 'jet-chronos-team';

parcelRegister("gWyrs", function(module, exports) {
$parcel$export(module.exports, "Nav4Plans", () => $1aef2a6c0d0b844e$export$a9599e1720ee6c82);

var $9QJlq = parcelRequire("9QJlq");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $4UGAB = parcelRequire("4UGAB");

var $5IkoH = parcelRequire("5IkoH");

var $19zz3 = parcelRequire("19zz3");

var $eFqFr = parcelRequire("eFqFr");

var $i860n = parcelRequire("i860n");

var $7OqZ6 = parcelRequire("7OqZ6");

var $hCfCe = parcelRequire("hCfCe");

var $emfXh = parcelRequire("emfXh");

var $ash72 = parcelRequire("ash72");
function $1aef2a6c0d0b844e$export$a9599e1720ee6c82(props) {
    const { isExpanded: isExpanded, queryRef: queryRef, ...dndProps } = props;
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $9QJlq.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    const hasEditPermissions = data.jira?.advancedRoadmapsNavigation?.hasEditPermissions ?? false;
    const hasCreateSamplePlanPermissions = data.jira?.advancedRoadmapsNavigation?.hasCreateSamplePlanPermissions ?? false;
    const hasGlobalPlansAdminPermissions = data.jira?.advancedRoadmapsNavigation?.hasGlobalPlansAdminPermissions ?? false;
    const actionButtons = (0, $euxye.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7OqZ6.Nav4PlansActionButtons), {
            hasEditPermissions: hasEditPermissions,
            hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
            hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
        }), [
        hasEditPermissions,
        hasCreateSamplePlanPermissions,
        hasGlobalPlansAdminPermissions
    ]);
    const [shouldRender] = (0, $eFqFr.useNavigationPlansVisibility)();
    const isPremium = (0, $4UGAB.useIsPremiumJSW)();
    if (!shouldRender) return null;
    if (!isPremium) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ash72.Nav4PlansPremiumUpsellFeatureGate), dndProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($1aef2a6c0d0b844e$var$Nav4PlansComponent, {
        actionButtons: actionButtons,
        data: data,
        isExpanded: isExpanded,
        hasFragment: data.jira?.hasIsPlansExpanded === 'JiraQuery',
        ...dndProps
    });
}
$1aef2a6c0d0b844e$export$a9599e1720ee6c82.displayName = "Nav4Plans";
const $1aef2a6c0d0b844e$var$Nav4PlansComponent = (props)=>{
    const { actionButtons: actionButtons, isExpanded: isExpanded, data: data, hasFragment: hasFragment, ...dndProps } = props;
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $19zz3.useSidebarNav4)();
    const isExpandedValue = (0, $i860n.fg)('navx-global-side-nav') ? !!dndProps.isExpandOrFlyoutOpen && isExpanded : isExpanded;
    return isInitialSelectedPath((0, $5IkoH.MENU_ID_PLANS)) && hasFragment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $emfXh.Nav4PlansForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpandedValue,
        queryRef: data,
        ...dndProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hCfCe.Nav4PlansDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpandedValue,
        ...dndProps
    });
};
$1aef2a6c0d0b844e$var$Nav4PlansComponent.displayName = "Nav4PlansComponent";

});
parcelRegister("9QJlq", function(module, exports) {
$parcel$export(module.exports, "default", () => $35c39ffd67c81c64$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<288d50e47daa7606b7083e561a61526e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $35c39ffd67c81c64$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "isPlansExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Plans",
    "selections": [
        {
            "condition": "isPlansExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4PlansForLanding"
                }
            ]
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "hasIsPlansExpanded",
                            "kind": "ScalarField",
                            "name": "__typename"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraAdvancedRoadmapsNavigation",
                    "kind": "LinkedField",
                    "name": "advancedRoadmapsNavigation",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasEditPermissions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCreateSamplePlanPermissions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasGlobalPlansAdminPermissions"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$35c39ffd67c81c64$var$node.hash = "d4eb6e77059dc70179f1a9c3a44735c3";
var $35c39ffd67c81c64$export$2e2bcd8739ae039 = $35c39ffd67c81c64$var$node;

});

parcelRegister("7OqZ6", function(module, exports) {
$parcel$export(module.exports, "Nav4PlansActionButtons", () => $b0e699d01bb10516$export$a7d6536605f62394);

var $euxye = parcelRequire("euxye");

var $jrw4U = parcelRequire("jrw4U");

var $gfC9d = parcelRequire("gfC9d");
const $b0e699d01bb10516$export$a7d6536605f62394 = ({ hasEditPermissions: hasEditPermissions, hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, hasEditPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jrw4U.CreatePlanMenuButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gfC9d.MoreMenuButton), {
        hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
        hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
    }));
};
$b0e699d01bb10516$export$a7d6536605f62394.displayName = "Nav4PlansActionButtons";

});
parcelRegister("jrw4U", function(module, exports) {
$parcel$export(module.exports, "CreatePlanMenuButton", () => $5b2c590105d557a6$export$fd3582c8dd19f9f6);

var $euxye = parcelRequire("euxye");



var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $eO8S8 = parcelRequire("eO8S8");

var $jqO0i = parcelRequire("jqO0i");

var $hZDXn = parcelRequire("hZDXn");

var $ikOED = parcelRequire("ikOED");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $inMxE = parcelRequire("inMxE");

var $aJ81Y = parcelRequire("aJ81Y");
const $5b2c590105d557a6$var$createPlan = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.create-plan-menu-button.create-plan",
    defaultMessage: "Create plan"
});
const $5b2c590105d557a6$export$fd3582c8dd19f9f6 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [, { openDrawer: openCreateNewPlanWizardDrawer }] = (0, $jqO0i.useCreateNewPlanWizardDrawer)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const clickHandler = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_PLANS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
                itemId: 'createPlan'
            }
        });
        openCreateNewPlanWizardDrawer();
    }, [
        openCreateNewPlanWizardDrawer,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        content: formatMessage($5b2c590105d557a6$var$createPlan)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eO8S8.CommonNavMenuButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ikOED))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage($5b2c590105d557a6$var$createPlan),
        onClick: clickHandler
    }));
};
$5b2c590105d557a6$export$fd3582c8dd19f9f6.displayName = "CreatePlanMenuButton";

});
parcelRegister("jqO0i", function(module, exports) {
$parcel$export(module.exports, "useCreateNewPlanWizardDrawer", () => $8f2c09f94003beef$export$f3e7d3fc94eda89a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $VoOhq = parcelRequire("VoOhq");

var $1YIbA = parcelRequire("1YIbA");

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $8f2c09f94003beef$var$CONTROLLER_NAME = 'create-new-plan-wizard-drawer';
const $8f2c09f94003beef$var$initialState = {
    isOpen: false,
    plan: undefined,
    isPlanCreationComplete: false,
    hasPlanInvitePermission: false,
    scenarioId: undefined
};
const $8f2c09f94003beef$var$Store = (0, $5QDqc.createStore)({
    name: $8f2c09f94003beef$var$CONTROLLER_NAME,
    initialState: $8f2c09f94003beef$var$initialState,
    actions: {
        openDrawer: (plan)=>{
            (0, $VoOhq.default)('arj-create-plan-wizard-drawer');
            return ({ setState: setState })=>setState({
                    isOpen: true,
                    plan: plan,
                    isPlanCreationComplete: false
                });
        },
        closeDrawer: ()=>({ setState: setState })=>setState({
                    isOpen: false,
                    plan: undefined,
                    scenarioId: undefined
                }),
        setIsPlanCreationComplete: (plan, hasPlanInvitePermission, isPlanCreationComplete = true, scenarioId)=>({ setState: setState })=>setState({
                    isPlanCreationComplete: isPlanCreationComplete,
                    plan: plan,
                    hasPlanInvitePermission: hasPlanInvitePermission,
                    scenarioId: scenarioId
                })
    }
});
const $8f2c09f94003beef$export$f3e7d3fc94eda89a = (0, $3h1FP.createHook)($8f2c09f94003beef$var$Store);
const $8f2c09f94003beef$export$9ec7b5762fb72de2 = (0, $dB6ay.createContainer)($8f2c09f94003beef$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen, plan: plan })=>{
            setState({
                isOpen: isOpen,
                plan: plan
            });
        }
});
const $8f2c09f94003beef$var$EXCLUDED_I18N_FILES = [
    'index',
    'languages',
    'en'
];
const $8f2c09f94003beef$var$FALLBACK_INTL_MESSAGES = Object.freeze({});
const $8f2c09f94003beef$export$19442c17ab279a67 = async (rawlocale = 'en')=>{
    // Filter out country code as the AFE i18n does not use them e.g en => en-US
    const locale = rawlocale.split('-')[0];
    if (!locale || $8f2c09f94003beef$var$EXCLUDED_I18N_FILES.includes(locale)) return {
        default: $8f2c09f94003beef$var$FALLBACK_INTL_MESSAGES
    };
    const packageName = 'jira-portfolio-3-plan-wizard';
    try {
        {
            // eslint-disable-next-line jira/import/webpack-magic-comment-entries
            const i18nModule = await import(`@atlassian/${packageName}/dist/esm/i18n/*.js`);
            const result = i18nModule[locale]();
            return result;
        }
        // eslint-disable-next-line jira/import/webpack-magic-comment-entries
        const result = await import(`@atlassian/${packageName}/dist/cjs/i18n/${locale}`);
        return result;
    } catch  {
        return {
            default: $8f2c09f94003beef$var$FALLBACK_INTL_MESSAGES
        };
    }
};
const $8f2c09f94003beef$export$52303468eeac3ad0 = ()=>{
    const { locale: locale } = (0, $1YIbA.default)();
    const [state, setState] = (0, $euxye.useState)({
        locale: locale,
        loading: true,
        intlMessages: undefined
    });
    (0, $euxye.useEffect)(()=>{
        let mounted = true;
        const load = async ()=>{
            setState((messageState)=>({
                    ...messageState,
                    loading: true
                }));
            const { default: intlMessages } = await $8f2c09f94003beef$export$19442c17ab279a67(locale);
            if (!mounted) return;
            setState((messageState)=>({
                    ...messageState,
                    loading: false,
                    intlMessages: intlMessages
                }));
        };
        load();
        return ()=>{
            mounted = false;
        };
    }, [
        locale
    ]);
    return state;
};

});


parcelRegister("gfC9d", function(module, exports) {
$parcel$export(module.exports, "MoreMenuButton", () => $9893dba426e5488b$export$b13d6ccdb9a8b0c5);

var $euxye = parcelRequire("euxye");



var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $2DbWL = parcelRequire("2DbWL");

var $gbTMi = parcelRequire("gbTMi");

var $dvAxx = parcelRequire("dvAxx");

var $5PNZe = parcelRequire("5PNZe");

var $ceqcm = parcelRequire("ceqcm");

var $cSR11 = parcelRequire("cSR11");

var $g36LP = parcelRequire("g36LP");

var $72ldR = parcelRequire("72ldR");

var $gBaKj = parcelRequire("gBaKj");

var $ikOED = parcelRequire("ikOED");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $inMxE = parcelRequire("inMxE");

var $aJ81Y = parcelRequire("aJ81Y");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");
const $9893dba426e5488b$var$adminSettings = (0, $7eNDO.defineMessage)({
    defaultMessage: "Admin configuration",
    id: "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.admin-settings"
});
const $9893dba426e5488b$var$plansMoreMenu = (0, $7eNDO.defineMessage)({
    defaultMessage: "Plans",
    id: "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.plans-more-menu"
});
const $9893dba426e5488b$var$createDemoPlan = (0, $7eNDO.defineMessage)({
    defaultMessage: "Create demo plan",
    id: "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.create-demo-plan"
});
const $9893dba426e5488b$var$MoreMenuItems = ({ hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [{ hasBeenInitialised: hasBeenInitialised }, { open: openCreateSamplePlanModal }] = (0, $dvAxx.useCreateSamplePlan)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const createDemoPlanClickHandler = (0, $euxye.useCallback)((event)=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_PLANS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
                itemId: 'createDemoPlan'
            }
        });
        // Close the dropdown popup before opening the modal so the popup's
        // focus trap is torn down first; otherwise the modal's FocusLock
        // cannot move focus into the dialog (A11Y-29104, WCAG 2.4.3).
        if ((0, $2700E.expVal)('a11y-29104_demo_plan_modal_autofocus_fix', 'isEnabled', false)) onClose?.(event);
        openCreateSamplePlanModal();
    }, [
        onClose,
        openCreateSamplePlanModal,
        createAnalyticsEvent
    ]);
    const adminSettingsClickHandler = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_PLANS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
                itemId: 'adminSettings'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), null, (hasCreateSamplePlanPermissions || hasGlobalPlansAdminPermissions) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true
    }, hasCreateSamplePlanPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ikOED))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)"
        }),
        onClick: createDemoPlanClickHandler,
        isDisabled: !hasBeenInitialised
    }, formatMessage($9893dba426e5488b$var$createDemoPlan)), hasGlobalPlansAdminPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cSR11.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gBaKj))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)"
        }),
        href: "/jira/plans/settings/permissions",
        onClick: adminSettingsClickHandler
    }, formatMessage($9893dba426e5488b$var$adminSettings))), !(0, $i860n.fg)('navx-global-side-nav') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2DbWL.HideL1MenuItemSection), {
        menuId: (0, $6GljB.L1_MENU_ID).PLANS
    }));
};
$9893dba426e5488b$var$MoreMenuItems.displayName = "MoreMenuItems";
const $9893dba426e5488b$export$b13d6ccdb9a8b0c5 = ({ hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const clickHandler = (0, $euxye.useCallback)(()=>{
        // Warm the modal chunk while the menu is open.
        (0, $5PNZe.preloadCreateSamplePlanContent)();
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_PLANS],
            attributes: {
                level: '1',
                componentType: 'fixedItemButton',
                itemId: 'meatballDropdown'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const MenuItems = (0, $euxye.useCallback)(({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9893dba426e5488b$var$MoreMenuItems, {
            hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
            hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions,
            onClose: onClose
        }), [
        hasCreateSamplePlanPermissions,
        hasGlobalPlansAdminPermissions
    ]);
    if (!hasCreateSamplePlanPermissions && !hasGlobalPlansAdminPermissions && (0, $i860n.fg)('navx-global-side-nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
        MenuItems: MenuItems,
        name: formatMessage($9893dba426e5488b$var$plansMoreMenu),
        onOpen: clickHandler
    });
};
$9893dba426e5488b$export$b13d6ccdb9a8b0c5.displayName = "MoreMenuButton";

});
parcelRegister("dvAxx", function(module, exports) {
$parcel$export(module.exports, "useCreateSamplePlan", () => $3b4ebb03268634fd$export$53d6fde96f096b86);
$parcel$export(module.exports, "CreateSamplePlanProvider", () => $3b4ebb03268634fd$export$88b99aa46c223622);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $1NHMY = parcelRequire("1NHMY");

var $6xTnX = parcelRequire("6xTnX");
const $3b4ebb03268634fd$var$CONTROLLER_NAME = 'create-sample-plan';
const $3b4ebb03268634fd$var$initialState = {
    /**
	 * This field controls modal dismissible status
	 */ isOpen: false,
    /**
	 * This field is only used to redirect the user to plan page if the modal is not closed.
	 */ planId: null,
    /**
	 * This field is used to detect the correct redirection creation session,
	 * without this field, we don't know which creation session needs to be redirected
	 * e.g. the user started multiple sample creation and stays on the last one - in this case,
	 * only the last creation needs to be redirected.
	 */ taskId: null,
    /**
	 * Progress of the ongoing task
	 */ progressPercentage: null,
    /**
	 * Once this field has been set to `true`, we'll know we can call the actions returned
	 * by our useCreateSamplePlan hook.
	 */ hasBeenInitialised: false
};
const $3b4ebb03268634fd$var$actions = {
    open: ()=>({ setState: setState })=>{
            setState({
                isOpen: true
            });
        },
    close: ()=>({ setState: setState })=>{
            const nextState = (({ hasBeenInitialised: hasBeenInitialised, ...rest })=>rest)($3b4ebb03268634fd$var$initialState);
            setState(nextState);
        },
    setPlanId: (planId)=>({ setState: setState })=>{
            setState({
                planId: planId
            });
        },
    setTaskId: (taskId)=>({ setState: setState })=>{
            setState({
                taskId: taskId
            });
        },
    setProgressPercentage: (progressPercentage)=>({ setState: setState })=>{
            setState({
                progressPercentage: progressPercentage
            });
        },
    submitSamplePlan: ({ planName: planName, flags: { success: SuccessFlag, error: ErrorFlag } })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { showFlag: showFlag, redirectToPlan: redirectToPlan, leadAccountId: leadAccountId })=>{
            try {
                const taskId = await (0, $6xTnX.createSamplePlanAsync)({
                    body: JSON.stringify({
                        title: planName,
                        leadAccountId: leadAccountId
                    })
                });
                setState({
                    taskId: taskId
                });
                const response = await (0, $6xTnX.pollCreateSamplePlan)(taskId, (progressPercentage)=>{
                    const { taskId: latestTaskId } = getState();
                    // progressPercentage should reflect the progress of the most recent taskId
                    // If they don't match, skip updating
                    if (taskId !== latestTaskId) return;
                    setState({
                        progressPercentage: progressPercentage
                    });
                });
                const { plan: plan } = response.samplePlan;
                const currentState = getState();
                // We only want to redirect them if the taskId for the current modal is the same as the one for this request
                // Else it might belong to a previous modal
                if (currentState.isOpen && taskId === currentState.taskId) {
                    redirectToPlan(plan.id);
                    dispatch($3b4ebb03268634fd$var$actions.close());
                } else {
                    const flagId = (0, $1NHMY.CREATE_SUCCESS_FLAG_ID) + plan.id;
                    showFlag({
                        id: flagId,
                        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(SuccessFlag, {
                                id: flagId,
                                planName: plan.name,
                                planId: plan.id
                            })
                    });
                }
            // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                // we only want to track errors unrelated to user settings
                if (!(0, $1NHMY.USER_SETTINGS_ERRORS).includes(err.message)) (0, $hFtK7.fireErrorAnalytics)({
                    error: err,
                    meta: {
                        id: `${(0, $1NHMY.ERROR_REPORTING_PACKAGE)}SubmitFailed`,
                        packageName: (0, $1NHMY.ERROR_REPORTING_PACKAGE),
                        teamName: (0, $1NHMY.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                const props = {
                    id: (0, $1NHMY.CREATE_ERROR_FLAG_ID),
                    errorCode: err.message
                };
                showFlag({
                    id: (0, $1NHMY.CREATE_ERROR_FLAG_ID),
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ErrorFlag, props)
                });
                dispatch($3b4ebb03268634fd$var$actions.close());
            }
        }
};
const $3b4ebb03268634fd$var$Store = (0, $5QDqc.createStore)({
    name: $3b4ebb03268634fd$var$CONTROLLER_NAME,
    initialState: $3b4ebb03268634fd$var$initialState,
    actions: $3b4ebb03268634fd$var$actions
});
const $3b4ebb03268634fd$export$53d6fde96f096b86 = (0, $3h1FP.createHook)($3b4ebb03268634fd$var$Store);
const $3b4ebb03268634fd$export$88b99aa46c223622 = (0, $dB6ay.createContainer)($3b4ebb03268634fd$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen = false })=>{
            setState({
                isOpen: isOpen,
                hasBeenInitialised: true
            });
        }
});

});
parcelRegister("1NHMY", function(module, exports) {
$parcel$export(module.exports, "ERROR_REPORTING_PACKAGE", () => $40055f737cf76646$export$f27a837467ec20e5);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $40055f737cf76646$export$cfeee2ee86ead336);
$parcel$export(module.exports, "MAX_PLAN_NAME_LENGTH", () => $40055f737cf76646$export$62da4a2465b3b309);
$parcel$export(module.exports, "CREATE_SUCCESS_FLAG_ID", () => $40055f737cf76646$export$d526356745046017);
$parcel$export(module.exports, "CREATE_ERROR_FLAG_ID", () => $40055f737cf76646$export$abd17266df221a92);
$parcel$export(module.exports, "UNKNOWN_EXCEPTION", () => $40055f737cf76646$export$cfba07bc71f884c1);
$parcel$export(module.exports, "USER_SETTINGS_ERRORS", () => $40055f737cf76646$export$4a3e779cd3c10125);
$parcel$export(module.exports, "ERROR_CODE_TITLE_MAPPING", () => $40055f737cf76646$export$91ec80863c2c2030);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING", () => $40055f737cf76646$export$c43e20911e13ca0);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING_ISSUE_TERM_REFRESH", () => $40055f737cf76646$export$525cba92c9b435f4);
$parcel$export(module.exports, "ERROR_LINK_MAPPING", () => $40055f737cf76646$export$2c5a783ab3215ce1);
/* eslint-disable jira/filename-case */ 
var $7eNDO = parcelRequire("7eNDO");
const $40055f737cf76646$var$configurationErrorTitle = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.configuration-error-title",
    defaultMessage: "Your demo plan couldn't be created because of a configuration error"
});
const $40055f737cf76646$var$permissionErrorTitle = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.permission-error-title",
    defaultMessage: "Your demo plan couldn't be created because you\u2019re missing a required permission"
});
const $40055f737cf76646$var$tryAgainErrorTitle = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.try-again-error-title",
    defaultMessage: "Try to create your demo plan again"
});
const $40055f737cf76646$var$requiredFieldsConfiguredOnIssueError = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error",
    defaultMessage: "Your issues have required fields which blocked your demo plan from being created. {readMoreLink}"
});
const $40055f737cf76646$var$emptyIssueLinksError = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.empty-issue-links-error",
    defaultMessage: "Your site doesn't have issue links configured, which are required to create a demo plan. {readMoreLink}"
});
const $40055f737cf76646$var$noBrowseProjectsPermissionError = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.no-browse-projects-permission-error",
    defaultMessage: "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Browse Projects</permission-type> permission. {readMoreLink}"
});
const $40055f737cf76646$var$noCreateIssuesPermissionError = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.no-create-issues-permission-error",
    defaultMessage: "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create Issues</permission-type> permission. {readMoreLink}"
});
const $40055f737cf76646$var$noTransitionIssuesPermissionError = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error",
    defaultMessage: "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition Issues</permission-type> permission. {readMoreLink}"
});
const $40055f737cf76646$var$noEditIssuesPermissionError = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error",
    defaultMessage: "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit Issues</permission-type> permission. {readMoreLink}"
});
const $40055f737cf76646$var$watchingDisabledError = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.watching-disabled-error",
    defaultMessage: "Your demo plan couldn't be created because you have issue watching disabled. {readMoreLink}"
});
const $40055f737cf76646$var$unknownExceptionError = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.unknown-exception-error",
    defaultMessage: "Your demo plan couldn't be created, but we\u2019re not sure why. If the problem persists, contact Atlassian support. {readMoreLink}"
});
const $40055f737cf76646$var$learnMore = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.learn-more",
    defaultMessage: "Learn more"
});
const $40055f737cf76646$var$contactSupport = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.contact-support",
    defaultMessage: "Contact Atlassian support"
});
const $40055f737cf76646$var$requiredFieldsConfiguredOnIssueErrorIssueTermRefresh = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error-issue-term-refresh",
    defaultMessage: "Your work items have required fields which blocked your demo plan from being created. {readMoreLink}"
});
const $40055f737cf76646$var$emptyIssueLinksErrorIssueTermRefresh = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.empty-issue-links-error-issue-term-refresh",
    defaultMessage: "Your site doesn't have work item links configured, which are required to create a demo plan. {readMoreLink}"
});
const $40055f737cf76646$var$noCreateIssuesPermissionErrorIssueTermRefresh = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.no-create-issues-permission-error-issue-term-refresh",
    defaultMessage: "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create work items</permission-type> permission. {readMoreLink}"
});
const $40055f737cf76646$var$noTransitionIssuesPermissionErrorIssueTermRefresh = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error-issue-term-refresh",
    defaultMessage: "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition work items</permission-type> permission. {readMoreLink}"
});
const $40055f737cf76646$var$noEditIssuesPermissionErrorIssueTermRefresh = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error-issue-term-refresh",
    defaultMessage: "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit work items</permission-type> permission. {readMoreLink}"
});
const $40055f737cf76646$var$watchingDisabledErrorIssueTermRefresh = (0, $7eNDO.defineMessage)({
    id: "portfolio-3-create-sample-plan.common.watching-disabled-error-issue-term-refresh",
    defaultMessage: "Your demo plan couldn't be created because you have work item watching disabled. {readMoreLink}"
});
const $40055f737cf76646$export$f27a837467ec20e5 = 'jiraPortfolio3CreateSamplePlan';
const $40055f737cf76646$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $40055f737cf76646$var$CONTACT_SUPPORT_URL = 'https://support.atlassian.com/contact';
const $40055f737cf76646$var$LEARN_MORE_URL = 'https://support.atlassian.com/jira-software-cloud/docs/view-a-sample-advanced-roadmaps-plan/';
const $40055f737cf76646$export$62da4a2465b3b309 = 255;
const $40055f737cf76646$export$d526356745046017 = 'samplePlanCreatedSuccessfully';
const $40055f737cf76646$export$abd17266df221a92 = 'samplePlanError';
const $40055f737cf76646$export$e6515d2009b1dba7 = 'REQUIRED_FIELDS_CONFIGURED_ON_ISSUE';
const $40055f737cf76646$var$EMPTY_ISSUE_LINKS = 'EMPTY_ISSUE_LINKS';
const $40055f737cf76646$var$NO_BROWSE_PROJECTS_PERMISSION = 'NO_BROWSE_PROJECTS_PERMISSION';
const $40055f737cf76646$var$NO_CREATE_ISSUES_PERMISSION = 'NO_CREATE_ISSUES_PERMISSION';
const $40055f737cf76646$var$NO_TRANSITION_ISSUES_PERMISSION = 'NO_TRANSITION_ISSUES_PERMISSION';
const $40055f737cf76646$var$NO_EDIT_ISSUES_PERMISSION = 'NO_EDIT_ISSUES_PERMISSION';
const $40055f737cf76646$var$WATCHING_DISABLED = 'WATCHING_DISABLED';
const $40055f737cf76646$export$cfba07bc71f884c1 = 'UNKNOWN_EXCEPTION';
const $40055f737cf76646$export$4a3e779cd3c10125 = [
    $40055f737cf76646$export$e6515d2009b1dba7,
    $40055f737cf76646$var$EMPTY_ISSUE_LINKS,
    $40055f737cf76646$var$NO_BROWSE_PROJECTS_PERMISSION,
    $40055f737cf76646$var$NO_CREATE_ISSUES_PERMISSION,
    $40055f737cf76646$var$NO_TRANSITION_ISSUES_PERMISSION,
    $40055f737cf76646$var$NO_EDIT_ISSUES_PERMISSION,
    $40055f737cf76646$var$WATCHING_DISABLED
];
const $40055f737cf76646$export$91ec80863c2c2030 = {
    [$40055f737cf76646$export$e6515d2009b1dba7]: $40055f737cf76646$var$configurationErrorTitle,
    [$40055f737cf76646$var$EMPTY_ISSUE_LINKS]: $40055f737cf76646$var$configurationErrorTitle,
    [$40055f737cf76646$var$NO_BROWSE_PROJECTS_PERMISSION]: $40055f737cf76646$var$permissionErrorTitle,
    [$40055f737cf76646$var$NO_CREATE_ISSUES_PERMISSION]: $40055f737cf76646$var$permissionErrorTitle,
    [$40055f737cf76646$var$NO_TRANSITION_ISSUES_PERMISSION]: $40055f737cf76646$var$permissionErrorTitle,
    [$40055f737cf76646$var$NO_EDIT_ISSUES_PERMISSION]: $40055f737cf76646$var$permissionErrorTitle,
    [$40055f737cf76646$var$WATCHING_DISABLED]: $40055f737cf76646$var$configurationErrorTitle,
    [$40055f737cf76646$export$cfba07bc71f884c1]: $40055f737cf76646$var$tryAgainErrorTitle
};
const $40055f737cf76646$export$c43e20911e13ca0 = {
    [$40055f737cf76646$export$e6515d2009b1dba7]: $40055f737cf76646$var$requiredFieldsConfiguredOnIssueError,
    [$40055f737cf76646$var$EMPTY_ISSUE_LINKS]: $40055f737cf76646$var$emptyIssueLinksError,
    [$40055f737cf76646$var$NO_BROWSE_PROJECTS_PERMISSION]: $40055f737cf76646$var$noBrowseProjectsPermissionError,
    [$40055f737cf76646$var$NO_CREATE_ISSUES_PERMISSION]: $40055f737cf76646$var$noCreateIssuesPermissionError,
    [$40055f737cf76646$var$NO_TRANSITION_ISSUES_PERMISSION]: $40055f737cf76646$var$noTransitionIssuesPermissionError,
    [$40055f737cf76646$var$NO_EDIT_ISSUES_PERMISSION]: $40055f737cf76646$var$noEditIssuesPermissionError,
    [$40055f737cf76646$var$WATCHING_DISABLED]: $40055f737cf76646$var$watchingDisabledError,
    [$40055f737cf76646$export$cfba07bc71f884c1]: $40055f737cf76646$var$unknownExceptionError
};
const $40055f737cf76646$export$525cba92c9b435f4 = {
    [$40055f737cf76646$export$e6515d2009b1dba7]: $40055f737cf76646$var$requiredFieldsConfiguredOnIssueErrorIssueTermRefresh,
    [$40055f737cf76646$var$EMPTY_ISSUE_LINKS]: $40055f737cf76646$var$emptyIssueLinksErrorIssueTermRefresh,
    [$40055f737cf76646$var$NO_BROWSE_PROJECTS_PERMISSION]: $40055f737cf76646$var$noBrowseProjectsPermissionError,
    [$40055f737cf76646$var$NO_CREATE_ISSUES_PERMISSION]: $40055f737cf76646$var$noCreateIssuesPermissionErrorIssueTermRefresh,
    [$40055f737cf76646$var$NO_TRANSITION_ISSUES_PERMISSION]: $40055f737cf76646$var$noTransitionIssuesPermissionErrorIssueTermRefresh,
    [$40055f737cf76646$var$NO_EDIT_ISSUES_PERMISSION]: $40055f737cf76646$var$noEditIssuesPermissionErrorIssueTermRefresh,
    [$40055f737cf76646$var$WATCHING_DISABLED]: $40055f737cf76646$var$watchingDisabledErrorIssueTermRefresh,
    [$40055f737cf76646$export$cfba07bc71f884c1]: $40055f737cf76646$var$unknownExceptionError
};
const $40055f737cf76646$export$2c5a783ab3215ce1 = {
    [$40055f737cf76646$export$e6515d2009b1dba7]: {
        text: $40055f737cf76646$var$learnMore,
        href: $40055f737cf76646$var$LEARN_MORE_URL
    },
    [$40055f737cf76646$var$EMPTY_ISSUE_LINKS]: {
        text: $40055f737cf76646$var$learnMore,
        href: $40055f737cf76646$var$LEARN_MORE_URL
    },
    [$40055f737cf76646$var$NO_BROWSE_PROJECTS_PERMISSION]: {
        text: $40055f737cf76646$var$learnMore,
        href: $40055f737cf76646$var$LEARN_MORE_URL
    },
    [$40055f737cf76646$var$NO_CREATE_ISSUES_PERMISSION]: {
        text: $40055f737cf76646$var$learnMore,
        href: $40055f737cf76646$var$LEARN_MORE_URL
    },
    [$40055f737cf76646$var$NO_TRANSITION_ISSUES_PERMISSION]: {
        text: $40055f737cf76646$var$learnMore,
        href: $40055f737cf76646$var$LEARN_MORE_URL
    },
    [$40055f737cf76646$var$NO_EDIT_ISSUES_PERMISSION]: {
        text: $40055f737cf76646$var$learnMore,
        href: $40055f737cf76646$var$LEARN_MORE_URL
    },
    [$40055f737cf76646$var$WATCHING_DISABLED]: {
        text: $40055f737cf76646$var$learnMore,
        href: $40055f737cf76646$var$LEARN_MORE_URL
    },
    [$40055f737cf76646$export$cfba07bc71f884c1]: {
        text: $40055f737cf76646$var$contactSupport,
        href: $40055f737cf76646$var$CONTACT_SUPPORT_URL
    }
};

});

parcelRegister("6xTnX", function(module, exports) {
$parcel$export(module.exports, "createSamplePlanAsync", () => $079de1de59300b55$export$fed9130b90cf6213);
$parcel$export(module.exports, "pollCreateSamplePlan", () => $079de1de59300b55$export$5d240a69af545c0d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Consider moving into service
 */ 
var $hFtK7 = parcelRequire("hFtK7");

var $hnaxl = parcelRequire("hnaxl");

var $75sVW = parcelRequire("75sVW");

var $h2wCv = parcelRequire("h2wCv");

var $1NHMY = parcelRequire("1NHMY");
const $079de1de59300b55$var$throwIfNotOk = async (response)=>{
    if (response.ok) return response;
    if (response.status === 500) throw new (0, $75sVW.default)(response.status, (0, $1NHMY.UNKNOWN_EXCEPTION), response.headers.get((0, $hnaxl.TRACE_ID_HEADER)) ?? undefined, response);
};
const $079de1de59300b55$var$throwIfFailed = (result)=>{
    if (result.samplePlan && !result.samplePlan.success) throw new Error(result.samplePlan.error);
};
const $079de1de59300b55$var$delay = (ms = 3000)=>new Promise((res)=>setTimeout(res, ms));
const $079de1de59300b55$export$fed9130b90cf6213 = async (data)=>{
    const response = await (0, $h2wCv.performPostRequest)('/rest/jpo/1.0/plans/sampleplan/async', data);
    const { taskId: taskId } = response;
    if (!taskId) throw new Error('Invalid response from createSamplePlan');
    return taskId;
};
const $079de1de59300b55$export$5d240a69af545c0d = async (taskId, onUpdate)=>{
    const url = `/rest/jpo/1.0/plans/sampleplan/async/${taskId}`;
    try {
        const response = await fetch(url);
        await $079de1de59300b55$var$throwIfNotOk(response);
        // oxlint-disable-next-line typescript/consistent-type-assertions
        const raw = await response.json();
        $079de1de59300b55$var$throwIfFailed(raw);
        onUpdate(raw.progressPercent);
        if (raw.done) return raw;
        await $079de1de59300b55$var$delay();
        return $079de1de59300b55$export$5d240a69af545c0d(taskId, onUpdate);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // we only want to track errors unrelated to user settings
        if (!(0, $1NHMY.USER_SETTINGS_ERRORS).includes(error.message)) (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: `${(0, $1NHMY.ERROR_REPORTING_PACKAGE)}PollingFailed`,
                packageName: (0, $1NHMY.ERROR_REPORTING_PACKAGE),
                teamName: (0, $1NHMY.ERROR_REPORTING_TEAM)
            },
            attributes: {
                message: 'Polling create sample plan failed'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: error?.statusCode === 500
        });
        throw error;
    }
};

});


parcelRegister("5PNZe", function(module, exports) {
$parcel$export(module.exports, "preloadCreateSamplePlanContent", () => $6fa008f69c869b7f$export$da81023c56ce3631);
$parcel$export(module.exports, "default", () => $6fa008f69c869b7f$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $l8G1z = parcelRequire("l8G1z");

const $6fa008f69c869b7f$var$CreateSamplePlanContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7a3iU")).then((module)=>module.default), {
    moduleId: "./src/packages/portfolio-3/create-sample-plan/src/ui/content/index.tsx"
});
const $6fa008f69c869b7f$export$da81023c56ce3631 = ()=>{
    $6fa008f69c869b7f$var$CreateSamplePlanContent.preload();
};
var $6fa008f69c869b7f$export$2e2bcd8739ae039 = $6fa008f69c869b7f$var$CreateSamplePlanContent;

});
parcelRegister("7a3iU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6oJDg").then(()=>parcelRequire('f8KkT'));

});




parcelRegister("hCfCe", function(module, exports) {
$parcel$export(module.exports, "Nav4PlansDefault", () => $2c07479d9c507e07$export$8edda76b63bd4bcb);

var $euxye = parcelRequire("euxye");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $bOwox = parcelRequire("bOwox");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $4VtOS = parcelRequire("4VtOS");

var $gEDfa = parcelRequire("gEDfa");

var $jzXAj = parcelRequire("jzXAj");

var $3rqDf = parcelRequire("3rqDf");

var $dx7aH = parcelRequire("dx7aH");

var $hDvet = parcelRequire("hDvet");

var $kFgCO = parcelRequire("kFgCO");

var $jepRN = parcelRequire("jepRN");

var $6ZLJT = parcelRequire("6ZLJT");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $kt86l = parcelRequire("kt86l");

var $2700E = parcelRequire("2700E");

var $h3LJR = parcelRequire("h3LJR");

var $fFNvS = parcelRequire("fFNvS");


var $9Cx9X = parcelRequire("9Cx9X");

var $iGBxp = parcelRequire("iGBxp");
const $2c07479d9c507e07$var$useCurrentUserAndActivationId = (0, $6ZLJT.functionUnionWithCondition)(()=>(0, $2700E.expVal)('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false), ()=>{
    const { data: { user: { accountId: accountIdFromUser } } } = (0, $kFgCO.useCurrentUser)();
    const activationId = (0, $h3LJR.useActivationId)();
    return {
        accountId: accountIdFromUser || undefined,
        activationId: activationId
    };
}, ()=>({
        accountId: undefined,
        activationId: undefined
    }));
const $2c07479d9c507e07$export$8edda76b63bd4bcb = (0, $jepRN.componentWithFG)('navx-global-side-nav', $2c07479d9c507e07$var$Nav4PlansDefaultGSN, $2c07479d9c507e07$var$Nav4PlansDefaultNav4);
function $2c07479d9c507e07$var$Nav4PlansDefaultGSN(props) {
    const { actionsOnHover: actionsOnHover, draggableRef: draggableRef, dropIndicator: dropIndicator, hasDragIndicator: hasDragIndicator, isDragging: isDragging, isExpanded: isExpanded, onExpandFlyoutToggle: onExpandFlyoutToggle, visualContentRef: visualContentRef } = props;
    const cloudId = (0, $kt86l.useCloudId)();
    const { accountId: accountId, activationId: activationId } = $2c07479d9c507e07$var$useCurrentUserAndActivationId();
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            accountId: accountId,
            activationId: activationId
        }), [
        cloudId,
        accountId,
        activationId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $iGBxp.asyncPlansSectionPlanListViewQuery), entryPointParams);
    const triggerRef = (0, $hDvet.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).PLANS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const menuId = (0, $5IkoH.MENU_ID_PLANS);
    // remove the entire useEffect when cleaning up nav4-show-plans-when-hidden-by-default
    // we should be using the route based entry point approach instead
    // https://hello.atlassian.net/wiki/spaces/UAF/pages/2754170095/Tutorial+EntryPoints+in+Routing
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $euxye.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        isExpanded,
        entryPointActions
    ]);
    const handleSystemToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const handleExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            sendSectionItemAnalyticsEvent({
                menuId: (0, $6GljB.L1_MENU_ID).PLANS,
                sectionItem: (0, $bOwox.SECTION_ITEM_PLANS)
            });
        }
        onExpandFlyoutToggle?.(hasExpanded);
    }, [
        entryPointActions,
        onExpandFlyoutToggle,
        sendSectionItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        dropTargetRef: visualContentRef,
        dropIndicator: dropIndicator,
        isDragging: isDragging,
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: handleExpansionToggle,
        onSystemToggle: handleSystemToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        hasDragIndicator: hasDragIndicator,
        interactionName: "nav4-sidebar-plans-default",
        isDragging: isDragging,
        ref: draggableRef ? (0, $fFNvS.mergeRefs)(triggerRef, draggableRef) : triggerRef,
        testId: (0, $jzXAj.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-plans-default",
        packageName: (0, $3aac2bcbb88c830d$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $3aac2bcbb88c830d$export$d57b6b390e78d90f),
        // Fallback for Suspense
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null),
        // Props for the root component
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9Cx9X.Nav4PlansFooter), null)));
}
$2c07479d9c507e07$var$Nav4PlansDefaultGSN.displayName = "Nav4PlansDefaultGSN";
function $2c07479d9c507e07$var$Nav4PlansDefaultNav4({ actionsOnHover: actionsOnHover, isExpanded: isExpanded }) {
    const cloudId = (0, $kt86l.useCloudId)();
    const { accountId: accountId, activationId: activationId } = $2c07479d9c507e07$var$useCurrentUserAndActivationId();
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            accountId: accountId,
            activationId: activationId
        }), [
        cloudId,
        accountId,
        activationId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $iGBxp.asyncPlansSectionPlanListViewQuery), entryPointParams);
    const triggerRef = (0, $hDvet.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).PLANS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const menuId = (0, $5IkoH.MENU_ID_PLANS);
    // remove the entire useEffect when cleaning up nav4-show-plans-when-hidden-by-default
    // we should be using the route based entry point approach instead
    // https://hello.atlassian.net/wiki/spaces/UAF/pages/2754170095/Tutorial+EntryPoints+in+Routing
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $euxye.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        isExpanded,
        entryPointActions
    ]);
    const onSystemToggleCallBack = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const onExpansionToggleCallBack = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            sendSectionItemAnalyticsEvent({
                menuId: (0, $6GljB.L1_MENU_ID).PLANS,
                sectionItem: (0, $bOwox.SECTION_ITEM_PLANS)
            });
        }
    }, [
        entryPointActions,
        sendSectionItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        onSystemToggle: onSystemToggleCallBack,
        onExpansionToggle: onExpansionToggleCallBack,
        menuId: menuId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-plans-default",
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $jzXAj.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-plans-default",
        packageName: (0, $3aac2bcbb88c830d$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $3aac2bcbb88c830d$export$d57b6b390e78d90f),
        // Fallback for Suspense
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null),
        // Props for the root component
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9Cx9X.Nav4PlansFooter), null)));
}
$2c07479d9c507e07$var$Nav4PlansDefaultNav4.displayName = "Nav4PlansDefaultNav4";

});
parcelRegister("9Cx9X", function(module, exports) {
$parcel$export(module.exports, "Nav4PlansFooter", () => $3f74e523f507abdd$export$484b1d8ed55fea0a);

var $euxye = parcelRequire("euxye");



var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $bEZ9g = parcelRequire("bEZ9g");

var $kYsVS = parcelRequire("kYsVS");

var $djYhH = parcelRequire("djYhH");

var $ar9gx = parcelRequire("ar9gx");

var $6w18e = parcelRequire("6w18e");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $inMxE = parcelRequire("inMxE");

var $aJ81Y = parcelRequire("aJ81Y");
const $3f74e523f507abdd$var$viewAllPlans = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-plans.plans.common.footer.view-all-plans",
    defaultMessage: "View all plans"
});
const $3f74e523f507abdd$var$VIEW_ALL_PLANS_HREF = (0, $kYsVS.plansDirectoryRoute).path;
const $3f74e523f507abdd$export$484b1d8ed55fea0a = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const viewAllPlansClickHandler = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_PLANS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                itemId: 'viewAllPlans'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEZ9g.ViewAllEntityMenuItem), {
        href: $3f74e523f507abdd$var$VIEW_ALL_PLANS_HREF,
        menuId: (0, $5IkoH.MENU_ID_PLANS_VIEW_ALL),
        onClick: viewAllPlansClickHandler
    }, formatMessage($3f74e523f507abdd$var$viewAllPlans)))));
};
$3f74e523f507abdd$export$484b1d8ed55fea0a.displayName = "Nav4PlansFooter";

});
parcelRegister("kYsVS", function(module, exports) {
$parcel$export(module.exports, "plansDirectoryRoute", () => $c9ef692ca2c5b7cd$export$143b4a1ef2ffc051);
const $c9ef692ca2c5b7cd$export$143b4a1ef2ffc051 = {
    name: 'plans-directory',
    path: '/jira/plans'
};

});


parcelRegister("iGBxp", function(module, exports) {
$parcel$export(module.exports, "asyncPlansSectionPlanListViewQuery", () => $a7cd580d7017a6e2$export$c2f76ac2cce77bea);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $2700E = parcelRequire("2700E");

var $2NSbF = parcelRequire("2NSbF");

var $bZhC2 = parcelRequire("bZhC2");

var $i860n = parcelRequire("i860n");

var $18sMq = parcelRequire("18sMq");

var $5Tvw7 = parcelRequire("5Tvw7");

const $a7cd580d7017a6e2$export$c2f76ac2cce77bea = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("a7nLJ")), {
        moduleId: "49a59c40",
        moduleName: "Nav4PlansListViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.cloudId;
        const variables = (0, $2700E.expVal)('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false) ? (()=>{
            const activationId = params.activationId || '';
            const entityAriPlans = (0, $i860n.fg)('navx-3660-fix-l2-l3-aris') ? (0, $18sMq.NavigationSettingAri).create({
                activationId: activationId,
                firstPartyApp: 'jira',
                settingId: 'plans',
                siteId: cloudId
            }).toString() : (0, $bZhC2.JiraNavigationSettingsAri).create({
                siteId: cloudId,
                activationId: activationId,
                navigationSettingScope: 'plans'
            }).toString();
            return {
                cloudId: cloudId,
                ownerAri: (0, $2NSbF.IdentityUserAri).create({
                    userId: params.accountId || 'UNKNOWN'
                }).toString(),
                entityAriPlans: entityAriPlans,
                skipOrderQuery: false
            };
        })() : {
            cloudId: cloudId,
            ownerAri: '',
            entityAriPlans: '',
            skipOrderQuery: true
        };
        return {
            queries: {
                queryRef: {
                    parameters: $5Tvw7.default,
                    variables: variables
                }
            }
        };
    }
});

});
parcelRegister("5Tvw7", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ef01683b789677d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5d3276b6ae58c3ca66851e4d042cacf4>>
 * @relayHash 6a943875be9a9e20a8d55f074d71a87a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7969afb33e1add772c6509ac511888fd62d5c465cea0be5703a799588a371039
const $3ef01683b789677d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityAriPlans"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ownerAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipOrderQuery"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "entityAriPlans"
        },
        {
            "kind": "Variable",
            "name": "ownerAri",
            "variableName": "ownerAri"
        }
    ], v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v6 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ],
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v5 /*: any*/ 
            ]
        }
    ], v7 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4PlansListViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "PlansList"
                },
                {
                    "condition": "skipOrderQuery",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": "plansOrder",
                            "args": v1 /*: any*/ ,
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "PlansList_navigationCustomisation"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4PlansListViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouritePlans",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "PLAN"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v6 /*: any*/ 
                                },
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentPlans",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "PLAN"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v6 /*: any*/ 
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "skipOrderQuery",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": "plansOrder",
                            "args": v1 /*: any*/ ,
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SettingsMenuItemConnection",
                                    "kind": "LinkedField",
                                    "name": "sidebar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "SettingsMenuItem",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "menuId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "visible"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7969afb33e1add772c6509ac511888fd62d5c465cea0be5703a799588a371039",
            "metadata": {},
            "name": "Nav4PlansListViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3ef01683b789677d$var$node.hash = "fe8a75d3d82ce3e2f317a38c8573362c";
var $3ef01683b789677d$export$2e2bcd8739ae039 = $3ef01683b789677d$var$node;

});

parcelRegister("a7nLJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("J9hkf").then(()=>parcelRequire('iLHP1'));

});



parcelRegister("emfXh", function(module, exports) {
$parcel$export(module.exports, "Nav4PlansForLanding", () => $2deee91ff7152b58$export$5e6b364538aa2f20);

var $8BAda = parcelRequire("8BAda");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $bOwox = parcelRequire("bOwox");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $4VtOS = parcelRequire("4VtOS");

var $jzXAj = parcelRequire("jzXAj");

var $3rqDf = parcelRequire("3rqDf");

var $dx7aH = parcelRequire("dx7aH");

var $jepRN = parcelRequire("jepRN");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $9Cx9X = parcelRequire("9Cx9X");

var $bcduD = parcelRequire("bcduD");
function $2deee91ff7152b58$export$5e6b364538aa2f20(props) {
    const { queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).PLANS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $8BAda.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    const menuId = (0, $5IkoH.MENU_ID_PLANS);
    const handleExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) sendSectionItemAnalyticsEvent({
            menuId: (0, $6GljB.L1_MENU_ID).PLANS,
            sectionItem: (0, $bOwox.SECTION_ITEM_PLANS)
        });
    }, [
        sendSectionItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($2deee91ff7152b58$var$Nav4PlansForLandingInner, {
        ...props,
        formattedMessage: formattedMessage,
        handleExpansionToggle: handleExpansionToggle,
        icon: icon,
        menuId: menuId,
        queryRef: data
    });
}
$2deee91ff7152b58$export$5e6b364538aa2f20.displayName = "Nav4PlansForLanding";
const $2deee91ff7152b58$var$Nav4PlansForLandingInner = (0, $jepRN.componentWithFG)('navx-global-side-nav', $2deee91ff7152b58$var$Nav4PlansForLandingInnerGSN, $2deee91ff7152b58$var$Nav4PlansForLandingInnerNav4);
function $2deee91ff7152b58$var$Nav4PlansForLandingInnerGSN(props) {
    const { actionsOnHover: actionsOnHover, draggableRef: draggableRef, dropIndicator: dropIndicator, formattedMessage: formattedMessage, handleExpansionToggle: handleExpansionToggle, hasDragIndicator: hasDragIndicator, icon: icon, isDragging: isDragging, isExpanded: isExpanded, menuId: menuId, onExpandFlyoutToggle: onExpandFlyoutToggle, queryRef: queryRef, visualContentRef: visualContentRef } = props;
    const handleExpansionToggle2 = (0, $euxye.useCallback)((hasExpanded)=>{
        handleExpansionToggle(hasExpanded);
        onExpandFlyoutToggle?.(hasExpanded);
    }, [
        onExpandFlyoutToggle,
        handleExpansionToggle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        dropTargetRef: visualContentRef,
        dropIndicator: dropIndicator,
        isDragging: isDragging,
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: handleExpansionToggle2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        elemBefore: icon,
        hasDragIndicator: hasDragIndicator,
        interactionName: "nav4-sidebar-plans-landing",
        isDragging: isDragging,
        ref: draggableRef,
        testId: (0, $jzXAj.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bcduD.PlansList), {
        fragmentRef: queryRef,
        navigationCustomisationFragment: queryRef.plansOrder ?? undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9Cx9X.Nav4PlansFooter), null)));
}
$2deee91ff7152b58$var$Nav4PlansForLandingInnerGSN.displayName = "Nav4PlansForLandingInnerGSN";
function $2deee91ff7152b58$var$Nav4PlansForLandingInnerNav4(props) {
    const { actionsOnHover: actionsOnHover, formattedMessage: formattedMessage, handleExpansionToggle: handleExpansionToggle, icon: icon, isExpanded: isExpanded, menuId: menuId, queryRef: queryRef } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: handleExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-plans-landing",
        actionsOnHover: actionsOnHover,
        elemBefore: icon,
        testId: (0, $jzXAj.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bcduD.PlansList), {
        fragmentRef: queryRef,
        navigationCustomisationFragment: queryRef.plansOrder ?? undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9Cx9X.Nav4PlansFooter), null)));
}
$2deee91ff7152b58$var$Nav4PlansForLandingInnerNav4.displayName = "Nav4PlansForLandingInnerNav4";

});
parcelRegister("8BAda", function(module, exports) {
$parcel$export(module.exports, "default", () => $73144c5e8c47d154$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<87568f3e24ab055faf2a69ddf1fcfa38>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $73144c5e8c47d154$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "entityAriPlans"
        },
        {
            "kind": "RootArgument",
            "name": "ownerAri"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "skipOrderQuery"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4PlansForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PlansList"
        },
        {
            "condition": "skipOrderQuery",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "alias": "plansOrder",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "entityAriPlans"
                        },
                        {
                            "kind": "Variable",
                            "name": "ownerAri",
                            "variableName": "ownerAri"
                        }
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "PlansList_navigationCustomisation"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$73144c5e8c47d154$var$node.hash = "ad64684e81b02d75805fc1651695e692";
var $73144c5e8c47d154$export$2e2bcd8739ae039 = $73144c5e8c47d154$var$node;

});

parcelRegister("bcduD", function(module, exports) {
$parcel$export(module.exports, "PlansList", () => $a90d36c8d6064847$export$610289543b80d1e7);

var $3rwPy = parcelRequire("3rwPy");

var $3ObD6 = parcelRequire("3ObD6");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $g1b31 = parcelRequire("g1b31");

var $5IkoH = parcelRequire("5IkoH");

var $19zz3 = parcelRequire("19zz3");

var $9AhSr = parcelRequire("9AhSr");

var $gLXQg = parcelRequire("gLXQg");

var $atwsb = parcelRequire("atwsb");

var $eOjwK = parcelRequire("eOjwK");

var $ar9gx = parcelRequire("ar9gx");

var $djYhH = parcelRequire("djYhH");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $kt86l = parcelRequire("kt86l");

var $aeLE4 = parcelRequire("aeLE4");

var $2700E = parcelRequire("2700E");

var $bJUXt = parcelRequire("bJUXt");

var $cHKM8 = parcelRequire("cHKM8");

var $9I8v0 = parcelRequire("9I8v0");
const $a90d36c8d6064847$var$recentMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-plans.plans.common.plans-list.recent",
    defaultMessage: "Recent"
});
const $a90d36c8d6064847$var$starredMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-plans.plans.common.plans-list.starred",
    defaultMessage: "Starred"
});
const $a90d36c8d6064847$var$MAX_RECENT_PLANS = 5;
const $a90d36c8d6064847$export$610289543b80d1e7 = ({ fragmentRef: fragmentRef, navigationCustomisationFragment: navigationCustomisationFragment })=>{
    const { isSelectedPath: isSelectedPath } = (0, $19zz3.useSidebarNav4)();
    const cloudId = (0, $kt86l.useCloudId)();
    const [data, refetch] = (0, $n67Vb.useRefetchableFragment)((0, $3ObD6.default), fragmentRef);
    const navigationCustomisation = (0, $n67Vb.useFragment)((0, $3rwPy.default), navigationCustomisationFragment);
    (0, $g1b31.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $cHKM8.default,
        refetch: refetch,
        menuId: (0, $5IkoH.MENU_ID_PLANS)
    });
    const refetchOnChange = (0, $euxye.useCallback)(({ onComplete: onComplete })=>{
        refetch({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        cloudId,
        refetch
    ]);
    (0, $9AhSr.useSubscribeAndUpdateFavorites)({
        entityTypename: 'JiraPlan',
        favouriteConnectionId: data?.jira.favouritePlans.__id || '',
        recentConnectionId: data?.jira.recentPlans.__id || '',
        refetch: refetchOnChange
    });
    if (navigationCustomisation && (0, $2700E.expVal)('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a90d36c8d6064847$var$PlansListInnerNew, {
        data: data,
        navigationCustomisation: navigationCustomisation
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a90d36c8d6064847$var$PlansListInnerOld, {
        data: data
    });
};
$a90d36c8d6064847$export$610289543b80d1e7.displayName = "PlansList";
const $a90d36c8d6064847$var$PlansListInnerOld = (props)=>{
    const { data: data } = props;
    const { getStableItems: getStableItems } = (0, $gLXQg.useStableItems)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const starred = formatMessage($a90d36c8d6064847$var$starredMessage);
    const recent = formatMessage($a90d36c8d6064847$var$recentMessage);
    const favorites = (0, $euxye.useMemo)(()=>{
        if (!data) return {
            idSet: new Set(),
            list: [],
            hasItems: false
        };
        const ids = [];
        const list = [];
        data.jira.favouritePlans.edges?.forEach((edge)=>{
            if (edge) {
                if (edge.node.id) ids.push(edge.node.id);
                list.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9I8v0.PlanMenuItem), {
                    key: edge.node.planId,
                    fragmentRef: edge.node,
                    favouriteConnectionId: data.jira.favouritePlans.__id
                }));
            }
        });
        return {
            idSet: new Set(ids),
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        data
    ]);
    const recentPlans = (0, $euxye.useMemo)(()=>{
        if (!data) return {
            list: [],
            hasItems: false
        };
        const nodes = [];
        data.jira.recentPlans.edges?.forEach((edge)=>{
            if (edge && edge.node.id && !favorites.idSet.has(edge.node.id)) nodes.push(edge.node);
        });
        const limitedNodes = nodes.slice(0, $a90d36c8d6064847$var$MAX_RECENT_PLANS);
        const stableOrderedNodes = getStableItems({
            nodes: limitedNodes,
            idKey: 'id'
        });
        const list = stableOrderedNodes.map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9I8v0.PlanMenuItem), {
                key: node.planId,
                fragmentRef: node,
                favouriteConnectionId: data.jira.favouritePlans.__id
            }));
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        data,
        favorites.idSet,
        getStableItems
    ]);
    if (!favorites.hasItems && !recentPlans.hasItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bJUXt.PlansEmptyContent), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, favorites.list))), recentPlans.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, recentPlans.list))));
};
$a90d36c8d6064847$var$PlansListInnerOld.displayName = "PlansListInnerOld";
const $a90d36c8d6064847$var$PlansListInnerNew = (props)=>{
    const { data: data, navigationCustomisation: navigationCustomisation } = props;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { getStableItems: getStableItems } = (0, $gLXQg.useStableItems)();
    const starred = formatMessage($a90d36c8d6064847$var$starredMessage);
    const recent = formatMessage($a90d36c8d6064847$var$recentMessage);
    const { entityAri: entityAri, ownerAri: ownerAri, group: group } = (0, $eOjwK.usePlanReorderingIds)();
    const favouritePlans = data?.jira.favouritePlans;
    const planOrder = navigationCustomisation || null;
    const planNodes = (0, $euxye.useMemo)(()=>{
        const nodes = [];
        favouritePlans?.edges?.forEach((edge)=>{
            if (edge != null && edge !== undefined && edge.node != null && edge.node !== undefined) nodes.push(edge.node);
        });
        return nodes;
    }, [
        favouritePlans?.edges
    ]);
    const favorites = (0, $atwsb.useReorderableStarredItems)({
        favourites: planNodes,
        lastOrder: planOrder?.sidebar?.nodes,
        getId: (item)=>item.id || '',
        getLabel: (item)=>item?.title?.toString() || '',
        getHasNextPage: ()=>Boolean(favouritePlans?.pageInfo?.hasNextPage),
        renderMenuItem: (edge, currentItems, currentOrder, item)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9I8v0.PlanMenuItem), {
                key: edge.id,
                fragmentRef: edge,
                favouriteConnectionId: data?.jira.favouritePlans.__id || '',
                currentItems: currentItems,
                currentOrder: currentOrder,
                item: item
            });
        },
        maxItems: 15
    });
    const recentPlans = (0, $euxye.useMemo)(()=>{
        if (!data) return {
            list: [],
            hasItems: false
        };
        const nodes = [];
        data.jira.recentPlans.edges?.forEach((edge)=>{
            if (edge && edge.node.id && !favorites.idSet.has(edge.node.id)) nodes.push(edge.node);
        });
        const limitedNodes = nodes.slice(0, $a90d36c8d6064847$var$MAX_RECENT_PLANS);
        const stableOrderedNodes = getStableItems({
            nodes: limitedNodes,
            idKey: 'id'
        });
        const list = stableOrderedNodes.map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9I8v0.PlanMenuItem), {
                key: node.planId,
                fragmentRef: node,
                favouriteConnectionId: data.jira.favouritePlans.__id
            }));
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        data,
        favorites.idSet,
        getStableItems
    ]);
    if (!favorites.hasItems && !recentPlans.hasItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bJUXt.PlansEmptyContent), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aeLE4.NestedItemDropTarget), {
        currentItems: favorites.currentItems,
        currentOrder: favorites.currentOrder,
        entityAri: entityAri,
        group: group,
        ownerAri: ownerAri
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, favorites.list)))), recentPlans.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, recentPlans.list))));
};
$a90d36c8d6064847$var$PlansListInnerNew.displayName = "PlansListInnerNew";

});
parcelRegister("3rwPy", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ba635d1a27954bb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3450cb92a413bedee309c83871168423>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7ba635d1a27954bb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PlansList_navigationCustomisation",
    "selections": [
        {
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsMenuItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "menuId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "visible"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SettingsNavigationCustomisation"
};
$7ba635d1a27954bb$var$node.hash = "4a2365d41e4dcdcefc0564da02f00873";
var $7ba635d1a27954bb$export$2e2bcd8739ae039 = $7ba635d1a27954bb$var$node;

});

parcelRegister("3ObD6", function(module, exports) {
$parcel$export(module.exports, "default", () => $343597d2be53ab62$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aeaff25e02c1f13ecd339a2688184666>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $cHKM8 = parcelRequire("cHKM8");
const $343597d2be53ab62$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "RequiredField",
        "field": {
            "kind": "ScalarField",
            "name": "id"
        },
        "action": "LOG"
    }, v2 = {
        "kind": "ScalarField",
        "name": "planId"
    }, v3 = {
        "kind": "FragmentSpread",
        "name": "PlanMenuItem"
    }, v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURLPath"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $cHKM8.default)
            }
        },
        "name": "PlansList",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "favouritePlans",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "PLAN"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraPlan"
                                                        }
                                                    ]
                                                },
                                                "action": "LOG"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "LOG"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "recentPlans",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "currentURL",
                                        "variableName": "currentURLPath"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "PLAN"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraPlan"
                                                        }
                                                    ]
                                                },
                                                "action": "LOG"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "LOG"
                        }
                    ]
                },
                "action": "LOG"
            }
        ],
        "type": "Query"
    };
}();
$343597d2be53ab62$var$node.hash = "4536d10af216e5c7e6bd1206d1769b37";
var $343597d2be53ab62$export$2e2bcd8739ae039 = $343597d2be53ab62$var$node;

});
parcelRegister("cHKM8", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef9231d1d3324176$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d51a09abdc0c0c661e164e0f34abb2b>>
 * @relayHash 182ac07882e7e66442292493fa58a01f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e95527363d0a7d81c24a9491e8a3aab311f7a87d0ca0172b665488a2f68adc9
const $ef9231d1d3324176$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURLPath"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v5 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ],
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v4 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v4 /*: any*/ 
            ]
        }
    ], v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PlanListQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "currentURLPath",
                            "variableName": "currentURLPath"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "PlansList"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PlanListQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouritePlans",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "PLAN"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v5 /*: any*/ 
                                },
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentPlans",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "currentURL",
                                    "variableName": "currentURLPath"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "PLAN"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v5 /*: any*/ 
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5e95527363d0a7d81c24a9491e8a3aab311f7a87d0ca0172b665488a2f68adc9",
            "metadata": {},
            "name": "PlanListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ef9231d1d3324176$var$node.hash = "4536d10af216e5c7e6bd1206d1769b37";
var $ef9231d1d3324176$export$2e2bcd8739ae039 = $ef9231d1d3324176$var$node;

});


parcelRegister("eOjwK", function(module, exports) {
$parcel$export(module.exports, "usePlanReorderingIds", () => $9d9494343dbdea1b$export$72ec87994f7af51c);
// eslint-disable-next-line jira/filename-case

var $kFgCO = parcelRequire("kFgCO");

var $2NSbF = parcelRequire("2NSbF");

var $kt86l = parcelRequire("kt86l");

var $bZhC2 = parcelRequire("bZhC2");

var $h3LJR = parcelRequire("h3LJR");
const $9d9494343dbdea1b$export$72ec87994f7af51c = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const { data: { user: { accountId: accountId } } } = (0, $kFgCO.useCurrentUser)();
    const entityAri = (0, $bZhC2.JiraNavigationSettingsAri).create({
        siteId: cloudId,
        activationId: activationId,
        navigationSettingScope: 'plans'
    }).toString();
    const ownerAri = (0, $2NSbF.IdentityUserAri).create({
        userId: accountId || 'UNKNOWN'
    }).toString();
    return {
        entityAri: entityAri,
        ownerAri: ownerAri,
        group: 'SIDE_NAVIGATION_STARRED_PLANS'
    };
};

});

parcelRegister("bJUXt", function(module, exports) {
$parcel$export(module.exports, "PlansEmptyContent", () => $8d1214bc293b1edc$export$2b2efe96e6f14be5);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $biJuK = parcelRequire("biJuK");

var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $8d1214bc293b1edc$var$noPlans = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-plans.plans.common.empty-content.no-plans",
    defaultMessage: "Once you open or create plans, they'll show up here."
});
function $8d1214bc293b1edc$export$2b2efe96e6f14be5() {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $biJuK.EmptyContentMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage($8d1214bc293b1edc$var$noPlans)));
}
$8d1214bc293b1edc$export$2b2efe96e6f14be5.displayName = "PlansEmptyContent";

});

parcelRegister("9I8v0", function(module, exports) {
$parcel$export(module.exports, "PlanMenuItem", () => $a2743f844088a88d$export$5805f023607bba3d);

var $kGaG0 = parcelRequire("kGaG0");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");



var $bOwox = parcelRequire("bOwox");

var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $aQCoC = parcelRequire("aQCoC");

var $gND04 = parcelRequire("gND04");

var $kYsVS = parcelRequire("kYsVS");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $2UM84 = parcelRequire("2UM84");

var $fbAgT = parcelRequire("fbAgT");

var $alDF5 = parcelRequire("alDF5");

var $881dx = parcelRequire("881dx");

var $h3LJR = parcelRequire("h3LJR");

var $kt86l = parcelRequire("kt86l");

var $ffznM = parcelRequire("ffznM");

var $fFNvS = parcelRequire("fFNvS");


var $gwwQq = parcelRequire("gwwQq");

var $dLby9 = parcelRequire("dLby9");
const $a2743f844088a88d$var$VIEW_ALL_PLANS_HREF = (0, $kYsVS.plansDirectoryRoute).path;
const $a2743f844088a88d$export$5805f023607bba3d = ({ fragmentRef: fragmentRef, favouriteConnectionId: favouriteConnectionId, currentItems: currentItems, currentOrder: currentOrder, item: item // oxlint-disable-next-line @typescript-eslint/no-explicit-any
 })=>{
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $kGaG0.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    fragmentRef);
    const planId = data?.planId;
    const isStarred = data?.favouriteValue?.isFavourite ?? false;
    const scenarioId = data.scenario.scenarioId;
    const planTitle = data.title || '';
    const planUrl = data.defaultNavigationItem?.url || (0, $881dx.generatePath)((0, $gND04.softwarePlanTimelineRoute).path, {
        planId: planId,
        scenarioId: scenarioId
    });
    const isReadOnly = data.isReadOnly || false;
    const isArchived = data.planStatus === 'ARCHIVED';
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const analytics = (0, $euxye.useMemo)(()=>({
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_PLANS],
            level: 1,
            componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
            itemId: (0, $687cb22024c607c7$export$c303e491e026ebc6),
            planId: planId ?? undefined,
            // TODO BLU-5544 send section via a single <ContextualAnalyticsData instead (which wraps the Starred or Recent panel). Use static object or useMemo, not to have rerendering issues.
            section: isStarred ? (0, $bOwox.SECTION_ITEM_STARRED) : (0, $bOwox.SECTION_ITEM_RECENT)
        }), [
        planId,
        isStarred
    ]);
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            planId: planId,
            scenarioId: scenarioId,
            planTitle: planTitle,
            isReadOnly: isReadOnly,
            isArchived: isArchived,
            isStarred: isStarred,
            isUsedForSidebarNav: true,
            favouriteConnectionId: favouriteConnectionId,
            cloudId: cloudId,
            activationId: activationId
        }), [
        planId,
        scenarioId,
        planTitle,
        isReadOnly,
        isArchived,
        isStarred,
        favouriteConnectionId,
        cloudId,
        activationId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $gwwQq.asyncPlanActionMenu), entryPointParams);
    const triggerRef = (0, $2UM84.useHoverEntryPointTrigger)(entryPointActions);
    if (!data) return null;
    if (isStarred && currentItems && currentOrder && item) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a2743f844088a88d$var$DraggablePlanMenuItem, {
        currentItems: currentItems,
        currentOrder: currentOrder,
        id: data.id,
        item: item,
        analytics: analytics,
        isStarred: isStarred,
        scenarioId: scenarioId,
        planId: planId,
        planTitle: planTitle,
        isReadOnly: isReadOnly,
        isArchived: isArchived,
        planUrl: planUrl,
        favouriteConnectionId: favouriteConnectionId,
        entryPointParams: entryPointParams
    });
    return planId && scenarioId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        analytics: analytics,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($alDF5))), {
            label: "",
            color: "currentColor"
        }),
        href: planUrl || $a2743f844088a88d$var$VIEW_ALL_PLANS_HREF,
        menuId: (0, $5IkoH.ENTITY_ID).PLAN(String(planId)),
        ref: triggerRef,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-sidebar-plan-action-menu",
            packageName: (0, $3aac2bcbb88c830d$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $3aac2bcbb88c830d$export$d57b6b390e78d90f),
            runtimeProps: entryPointParams
        })
    }, planTitle);
};
$a2743f844088a88d$export$5805f023607bba3d.displayName = "PlanMenuItem";
const $a2743f844088a88d$var$DraggablePlanMenuItem = ({ analytics: analytics, currentItems: currentItems, currentOrder: currentOrder, id: id, item: item, planId: planId, planTitle: planTitle, planUrl: planUrl, entryPointParams: entryPointParams })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $gwwQq.asyncPlanActionMenu), entryPointParams);
    const triggerRef = (0, $2UM84.useHoverEntryPointTrigger)(entryPointActions);
    const { entityAri: entityAri, ownerAri: ownerAri, group: group } = (0, $dLby9.usePlanReorderingIds)();
    const dragAndDropState = (0, $ffznM.useNestedItemDragAndDrop)({
        entityAri: entityAri,
        ownerAri: ownerAri,
        data: {
            id: id.toString(),
            label: planTitle
        },
        group: group,
        item: undefined,
        isExpandable: false,
        isExpandOrFlyoutOpen: false,
        id: id,
        isDragAndDropEnabled: true,
        onExpandFlyoutToggle: ()=>{
        // No op for dashboard menu item
        }
    });
    const reorderActions = (0, $euxye.useCallback)((onClose)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fbAgT.ReorderActionsRenderer), {
            currentItems: currentItems,
            currentOrder: currentOrder,
            entityAri: entityAri,
            ownerAri: ownerAri,
            fireAnalyticsEvent: undefined,
            item: item,
            onClose: onClose
        }), [
        currentItems,
        currentOrder,
        entityAri,
        item,
        ownerAri
    ]);
    const runtimeProps = (0, $euxye.useMemo)(()=>({
            ...entryPointParams,
            reorderActions: reorderActions
        }), [
        entryPointParams,
        reorderActions
    ]);
    const draggableRef = dragAndDropState?.draggableRef || null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        analytics: analytics,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($alDF5))), {
            label: "",
            color: "currentColor"
        }),
        href: planUrl || $a2743f844088a88d$var$VIEW_ALL_PLANS_HREF,
        menuId: (0, $5IkoH.ENTITY_ID).PLAN(String(planId)),
        ref: (0, $fFNvS.mergeRefs)(triggerRef, draggableRef),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-sidebar-plan-action-menu",
            packageName: (0, $3aac2bcbb88c830d$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $3aac2bcbb88c830d$export$d57b6b390e78d90f),
            runtimeProps: runtimeProps
        }),
        visualContentRef: dragAndDropState?.dropTargetRef,
        dropIndicator: dragAndDropState?.dropIndicator,
        isDragging: dragAndDropState?.isDragging,
        hasDragIndicator: true
    }, planTitle), dragAndDropState && dragAndDropState.maybeDragPreview);
};
$a2743f844088a88d$var$DraggablePlanMenuItem.displayName = "DraggablePlanMenuItem";

});
parcelRegister("kGaG0", function(module, exports) {
$parcel$export(module.exports, "default", () => $741a402a9e3d4099$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<17460d48f2eb6a03fd3e6efec0399edb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $741a402a9e3d4099$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PlanMenuItem",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "planId"
            },
            "action": "THROW"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "isReadOnly"
        },
        {
            "kind": "ScalarField",
            "name": "planStatus"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                }
            ]
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraScenario",
                "kind": "LinkedField",
                "name": "scenario",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "scenarioId"
                        },
                        "action": "THROW"
                    }
                ]
            },
            "action": "THROW"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraSoftwareBuiltInNavigationItem"
                }
            ]
        }
    ],
    "type": "JiraPlan"
};
$741a402a9e3d4099$var$node.hash = "17bd68a58ffb8cc75cae9686ba724392";
var $741a402a9e3d4099$export$2e2bcd8739ae039 = $741a402a9e3d4099$var$node;

});

parcelRegister("gND04", function(module, exports) {
$parcel$export(module.exports, "softwarePlanTimelineRoute", () => $4f44a3bf572fb82f$export$61abeb6a03d23dd3);
const $4f44a3bf572fb82f$export$61abeb6a03d23dd3 = {
    name: 'software-plan-timeline',
    path: '/jira/plans/:planId/scenarios/:scenarioId/timeline'
};

});

parcelRegister("2UM84", function(module, exports) {
$parcel$export(module.exports, "useHoverEntryPointTrigger", () => $5a0ca6af1eadcf4d$export$129b8109f51bc05b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $6ouZy = parcelRequire("6ouZy");
const $5a0ca6af1eadcf4d$export$129b8109f51bc05b = (actions, isActive = true)=>{
    const eventMap = (0, $euxye.useMemo)(()=>({
            mouseenter: actions.load,
            focusin: actions.load
        }), [
        actions
    ]);
    return (0, $6ouZy.useEntryPointButtonTrigger)(actions, isActive, eventMap);
};

});

parcelRegister("gwwQq", function(module, exports) {
$parcel$export(module.exports, "asyncPlanActionMenu", () => $1e9a085759f0655f$export$62f1bed3a2f7698);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $bqyE0 = parcelRequire("bqyE0");

var $jXERH = parcelRequire("jXERH");

const $1e9a085759f0655f$export$62f1bed3a2f7698 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("bgA9V")), {
        moduleId: "05821076",
        moduleName: "AsyncPlanActionMenuContent",
        priority: "interaction"
    }),
    getPreloadProps: (params)=>{
        const planAri = (0, $bqyE0.JiraPlanAri).create({
            siteId: params.cloudId,
            activationId: params.activationId,
            planId: String(params.planId)
        }).toString();
        return {
            queries: {
                invitePermissionRef: {
                    parameters: $jXERH.default,
                    variables: {
                        planAri: planAri
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("jXERH", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1a51f2cf7b92f77$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<22992e911c08a368a6b30215146c38c1>>
 * @relayHash 544ad72d40227b17bb78df91426dec70
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6afc87c0f4c803f5822834c59a9fb77fd6fcdadf8bc242b9934286d8276bad4f
const $f1a51f2cf7b92f77$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "planAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "planAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "hasPlanInvitePermission"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AsyncPlanActionMenuContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPlan",
                            "kind": "LinkedField",
                            "name": "planById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AsyncPlanActionMenuContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPlan",
                            "kind": "LinkedField",
                            "name": "planById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6afc87c0f4c803f5822834c59a9fb77fd6fcdadf8bc242b9934286d8276bad4f",
            "metadata": {},
            "name": "AsyncPlanActionMenuContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f1a51f2cf7b92f77$var$node.hash = "99b6991c2dc7a7c9859f3c1d055fe43c";
var $f1a51f2cf7b92f77$export$2e2bcd8739ae039 = $f1a51f2cf7b92f77$var$node;

});

parcelRegister("bgA9V", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("eamze")),
    $4cvLQ("cbSl3")
]).then(()=>parcelRequire('jZ6jC'));

});
parcelRegister("6IImj", function(module, exports) {
"use strict";

var $5hjMu = parcelRequire("5hjMu");
module.exports = $5hjMu(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("5hjMu", function(module, exports) {
"use strict";
let $3d7de26527ef7bdf$var$cachedBundles = {};
let $3d7de26527ef7bdf$var$cachedPreloads = {};
let $3d7de26527ef7bdf$var$cachedPrefetches = {};
function $3d7de26527ef7bdf$var$getCache(type) {
    switch(type){
        case 'preload':
            return $3d7de26527ef7bdf$var$cachedPreloads;
        case 'prefetch':
            return $3d7de26527ef7bdf$var$cachedPrefetches;
        default:
            return $3d7de26527ef7bdf$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $3d7de26527ef7bdf$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("dLby9", function(module, exports) {
$parcel$export(module.exports, "usePlanReorderingIds", () => $71022127ded6a8e3$export$72ec87994f7af51c);
// eslint-disable-next-line jira/filename-case

var $kFgCO = parcelRequire("kFgCO");

var $2NSbF = parcelRequire("2NSbF");

var $kt86l = parcelRequire("kt86l");

var $bZhC2 = parcelRequire("bZhC2");

var $h3LJR = parcelRequire("h3LJR");
const $71022127ded6a8e3$export$72ec87994f7af51c = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const { data: { user: { accountId: accountId } } } = (0, $kFgCO.useCurrentUser)();
    const entityAri = (0, $bZhC2.JiraNavigationSettingsAri).create({
        siteId: cloudId,
        activationId: activationId,
        navigationSettingScope: 'plans'
    }).toString();
    const ownerAri = (0, $2NSbF.IdentityUserAri).create({
        userId: accountId || 'UNKNOWN'
    }).toString();
    return {
        entityAri: entityAri,
        ownerAri: ownerAri,
        group: 'SIDE_NAVIGATION_STARRED_PLANS'
    };
};

});




parcelRegister("ash72", function(module, exports) {
$parcel$export(module.exports, "Nav4PlansPremiumUpsellFeatureGate", () => $a551fe8c53abf45e$export$87c172423f26b2a0);
/* Nav4PlansPremiumUpsellFeatureGate.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $cEQkc = parcelRequire("cEQkc");

var $9ovx7 = parcelRequire("9ovx7");

var $6GljB = parcelRequire("6GljB");

var $dx7aH = parcelRequire("dx7aH");

var $h5Y6i = parcelRequire("h5Y6i");

var $4U30j = parcelRequire("4U30j");
var $iozCP = parcelRequire("iozCP");
var $02ogW = parcelRequire("02ogW");

var $9ufM9 = parcelRequire("9ufM9");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $55qdj = parcelRequire("55qdj");

var $aZMdt = parcelRequire("aZMdt");
var $aqPkH = parcelRequire("aqPkH");
var $aJ81Y = parcelRequire("aJ81Y");
const $a551fe8c53abf45e$var$LEARN_MORE_LINK = 'https://www.atlassian.com/software/jira/guides/advanced-roadmaps/overview#what-are-advanced-roadmaps';
const $a551fe8c53abf45e$var$PremiumFeatureGateNew = ()=>{
    const onClickCTA = (0, $euxye.useCallback)((_, analyticsEvent)=>{
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'tryItFree'
        });
    }, []);
    const onClickLearnMore = (0, $euxye.useCallback)((_, analyticsEvent)=>{
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'readTheGuide'
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceName: "plansPremiumFeatureGate",
        sourceType: "Modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cEQkc.PlansUpsellCard), {
        primaryButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h5Y6i.PremiumUpgradeModalEntryPointButton), {
            onClick: onClickCTA,
            appearance: "primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55qdj.default), {
            id: "navigation-apps-sidebar-nav4-sidebars-content-plans.ui.plans.premium-upsell-feature-gate.try-it-free",
            defaultMessage: "Try it free"
        })),
        secondaryButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9ufM9.default), {
            href: $a551fe8c53abf45e$var$LEARN_MORE_LINK,
            target: "_blank",
            appearance: "subtle",
            onClick: onClickLearnMore
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55qdj.default), {
            id: "navigation-apps-sidebar-nav4-sidebars-content-plans.ui.plans.premium-upsell-feature-gate.learn-more",
            defaultMessage: "Learn more"
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireScreenAnalytics), null));
};
$a551fe8c53abf45e$var$PremiumFeatureGateNew.displayName = "PremiumFeatureGateNew";
const $a551fe8c53abf45e$var$FeatureGateContent = ()=>{
    const attributes = (0, $euxye.useMemo)(()=>({
            'experiment-twcg-1814': (0, $2700E.expVal)('luna-twcg-1814-modernise-jira-upsell-ui', 'cohort', 'not-enrolled')
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        attributes: attributes
    }, (0, $2700E.expVal)('luna-twcg-1814-modernise-jira-upsell-ui', 'cohort', 'not-enrolled') !== 'variation' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9ovx7.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a551fe8c53abf45e$var$PremiumFeatureGateNew, null));
};
$a551fe8c53abf45e$var$FeatureGateContent.displayName = "FeatureGateContent";
const $a551fe8c53abf45e$export$87c172423f26b2a0 = (props)=>{
    const { draggableRef: draggableRef, dropIndicator: dropIndicator, hasDragIndicator: hasDragIndicator, isDragging: isDragging, visualContentRef: visualContentRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).PLANS); // oxlint-disable-next-line typescript/consistent-type-assertions
    const dragRef = draggableRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4U30j.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $02ogW.FlyoutMenuItemTrigger), {
        interactionName: "nav4-sidebar-plans-premium-upsell",
        elemBefore: icon,
        hasDragIndicator: hasDragIndicator,
        ref: dragRef,
        isDragging: isDragging,
        dropIndicator: dropIndicator,
        visualContentRef: visualContentRef
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iozCP.FlyoutMenuItemContent), {
        maxHeight: (0, $i860n.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? 460 : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a551fe8c53abf45e$var$FeatureGateContent, null)));
};
$a551fe8c53abf45e$export$87c172423f26b2a0.displayName = "Nav4PlansPremiumUpsellFeatureGate";

});
parcelRegister("cEQkc", function(module, exports) {
$parcel$export(module.exports, "PlansUpsellCard", () => $28a6334b92b49b6d$export$566a0e03a191084d);
/* PlansUpsellCard.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $gboXr = parcelRequire("gboXr");

var $55qdj = parcelRequire("55qdj");

var $cDVhN = parcelRequire("cDVhN");

var $bLa91 = parcelRequire("bLa91");

var $69ORP = parcelRequire("69ORP");
const $28a6334b92b49b6d$var$PlansIllustration = (0, $gboXr.createIllustration)({
    srcLight: (0, (/*@__PURE__*/$parcel$interopDefault($bLa91))),
    srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($69ORP)))
});
const $28a6334b92b49b6d$export$566a0e03a191084d = ({ primaryButton: primaryButton, secondaryButton: secondaryButton })=>/*#__PURE__*/ $euxye.createElement((0, $cDVhN.JiraUpsellCard), {
        appearance: "embedded",
        heading: /*#__PURE__*/ $euxye.createElement((0, $55qdj.default), {
            id: "growth.feature-gates.upsell-card.plans-heading",
            defaultMessage: "See all your timelines in one plan"
        }),
        body: /*#__PURE__*/ $euxye.createElement((0, $55qdj.default), {
            id: "growth.feature-gates.upsell-card.plans-body",
            defaultMessage: "Align all your timelines and teams in one view. Try free for 30 days with Premium."
        }),
        illustration: $28a6334b92b49b6d$var$PlansIllustration,
        primaryButton: primaryButton,
        secondaryButton: secondaryButton
    });
$28a6334b92b49b6d$export$566a0e03a191084d.displayName = "PlansUpsellCard";

});
parcelRegister("cDVhN", function(module, exports) {
$parcel$export(module.exports, "JiraUpsellCard", () => $627472eabe969526$export$75d137230d493a08);
/* JiraUpsellCard.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $ihEDU = parcelRequire("ihEDU");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $2iotI = parcelRequire("2iotI");

var $a9o4s = parcelRequire("a9o4s");

var $i860n = parcelRequire("i860n");
const $627472eabe969526$var$styles = {
    standaloneCard: "_2rko1qi0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1kdj _bfhkvuon _16qs130s",
    embeddedCard: "",
    embeddedImageLegacyRadius: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x",
    embeddedImageShapeRadius: "_2rko1mok _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x",
    contentPaddingEmbedded: "_18zru2gc _1q51pxbi _85i5u2gc",
    contentPaddingStandalone: "_18zrpxbi _1q51pxbi _85i5pxbi"
};
const $627472eabe969526$export$75d137230d493a08 = ({ heading: heading, body: body, illustration: Illustration, primaryButton: primaryButton, secondaryButton: secondaryButton, appearance: appearance = 'standalone' })=>{
    const isEmbedded = appearance === 'embedded';
    const illustration = isEmbedded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: (0, $i860n.fg)('platform-dst-shape-theme-default') ? $627472eabe969526$var$styles.embeddedImageShapeRadius : $627472eabe969526$var$styles.embeddedImageLegacyRadius
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Illustration, {
        alt: "",
        height: 192,
        testId: "feature-gates.image"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Illustration, {
        alt: "",
        width: 400,
        height: 135,
        testId: "feature-gates.image"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: (0, $1MNmN.cx)(appearance === 'embedded' && $627472eabe969526$var$styles.embeddedCard, appearance === 'standalone' && $627472eabe969526$var$styles.standaloneCard),
        testId: "feature-gates.upsell-card"
    }, illustration, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: isEmbedded ? $627472eabe969526$var$styles.contentPaddingEmbedded : $627472eabe969526$var$styles.contentPaddingStandalone
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        space: isEmbedded ? 'space.075' : 'space.200'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: isEmbedded ? 'xsmall' : 'small'
    }, heading), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        as: "p"
    }, body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.Inline), {
        alignBlock: "center",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), null, secondaryButton, primaryButton)))));
};
$627472eabe969526$export$75d137230d493a08.displayName = "JiraUpsellCard";

});

parcelRegister("bLa91", function(module, exports) {
module.exports = new URL("plans-light.fc0e3aaa.svg", import.meta.url).toString();

});

parcelRegister("69ORP", function(module, exports) {
module.exports = new URL("plans-dark.4803c106.svg", import.meta.url).toString();

});


parcelRegister("9ovx7", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1c9cd4253d98c52$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $l4UMm = parcelRequire("l4UMm");

var $h5Y6i = parcelRequire("h5Y6i");

var $4YhY5 = parcelRequire("4YhY5");

var $2iotI = parcelRequire("2iotI");

var $4e1Ev = parcelRequire("4e1Ev");
var $ah8fM = parcelRequire("ah8fM");

var $ahixA = parcelRequire("ahixA");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $4C7HL = parcelRequire("4C7HL");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aZMdt = parcelRequire("aZMdt");
var $aqPkH = parcelRequire("aqPkH");
var $aJ81Y = parcelRequire("aJ81Y");
const $d1c9cd4253d98c52$var$plansHeading = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation.plans.menu.premium-feature-gate.plans-heading",
    defaultMessage: "Plans"
});
const $d1c9cd4253d98c52$var$title = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation.plans.menu.premium-feature-gate.title",
    defaultMessage: "Unlock advanced planning tools"
});
const $d1c9cd4253d98c52$var$imageAlt = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation.plans.menu.premium-feature-gate.image-alt",
    defaultMessage: "Upgrade to Jira Premium"
});
const $d1c9cd4253d98c52$var$description = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation.plans.menu.premium-feature-gate.description",
    defaultMessage: "Boost agility with capacity planning, dependency mapping, and more. Try Jira Premium's high-level cross-team planning tools."
});
const $d1c9cd4253d98c52$var$learnMoreLink = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation.plans.menu.premium-feature-gate.learn-more-link",
    defaultMessage: "Read the guide"
});
const $d1c9cd4253d98c52$var$startTrialButton = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation.plans.menu.premium-feature-gate.start-trial-button",
    defaultMessage: "Try it free"
});
const $d1c9cd4253d98c52$var$closeButton = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation.plans.menu.premium-feature-gate.close-button",
    defaultMessage: "Close plans menu"
});
const $d1c9cd4253d98c52$var$LEARN_MORE_LINK = 'https://www.atlassian.com/software/jira/guides/advanced-roadmaps/overview#what-are-advanced-roadmaps';
const $d1c9cd4253d98c52$var$PremiumFeatureGate = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { colorMode: colorMode } = (0, $4C7HL.default)();
    const onStartTrialClick = (_, analyticsEvent)=>{
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'tryItFree'
        });
    };
    const onLearnMoreClick = (_, analyticsEvent)=>{
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'readTheGuide'
        });
    };
    const FlyoutBodyBehindFG = (0, $i860n.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? (0, $4e1Ev.FlyoutBody) : (0, $euxye.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceName: "plansPremiumFeatureGate",
        sourceType: "Modal"
    }, (0, $i860n.fg)('platform_dst_nav4_flyout_menu_slots_close_button') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ah8fM.FlyoutHeader), {
        title: formatMessage($d1c9cd4253d98c52$var$plansHeading),
        closeButtonLabel: formatMessage($d1c9cd4253d98c52$var$closeButton)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(FlyoutBodyBehindFG, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d1c9cd4253d98c52$var$MenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d1c9cd4253d98c52$var$MenuHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l4UMm.FeatureGateLogo), {
        alt: "",
        colorMode: colorMode
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d1c9cd4253d98c52$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "small",
        as: "h2"
    }, formatMessage($d1c9cd4253d98c52$var$title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $d1c9cd4253d98c52$var$contentDescriptionStyles
    }, formatMessage($d1c9cd4253d98c52$var$description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d1c9cd4253d98c52$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d1c9cd4253d98c52$var$LearnMoreButton, {
        appearance: "link",
        href: $d1c9cd4253d98c52$var$LEARN_MORE_LINK,
        target: "_blank",
        onClick: onLearnMoreClick
    }, formatMessage($d1c9cd4253d98c52$var$learnMoreLink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d1c9cd4253d98c52$var$TryPremiumButton, {
        onClick: onStartTrialClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ahixA))), {
            label: formatMessage($d1c9cd4253d98c52$var$imageAlt),
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    }, formatMessage($d1c9cd4253d98c52$var$startTrialButton))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireScreenAnalytics), null));
};
$d1c9cd4253d98c52$var$PremiumFeatureGate.displayName = "PremiumFeatureGate";
var $d1c9cd4253d98c52$export$2e2bcd8739ae039 = $d1c9cd4253d98c52$var$PremiumFeatureGate;
const $d1c9cd4253d98c52$var$TryPremiumButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h5Y6i.PremiumUpgradeModalEntryPointButton), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #964AC0)"}, ${"var(--ds-background-brand-bold, #1868DB)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-radius-small, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
$d1c9cd4253d98c52$var$TryPremiumButton.displayName = "TryPremiumButton";
const $d1c9cd4253d98c52$var$LearnMoreButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4YhY5.default), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    maxWidth: '250px',
                    marginRight: "var(--ds-space-200, 16px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
$d1c9cd4253d98c52$var$LearnMoreButton.displayName = "LearnMoreButton";
const $d1c9cd4253d98c52$var$MenuContainer = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_2rko12b0 _11q71dke _189ee4h9 _1dqonqa1 _1h6d3acm _vchhusvi _qjkjusvi _1y1m18uv _p12f4lgm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d1c9cd4253d98c52$var$MenuHeaderContainer = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_11q7rjn8 _2rko14xi _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3il1r9 _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d1c9cd4253d98c52$var$ContentContainer = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_11q7vuon _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $d1c9cd4253d98c52$var$contentDescriptionStyles = (0, $fbAgj.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d1c9cd4253d98c52$var$FooterContainer = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_11q7vuon _2rko8p36 _ca0qidpf _u5f31ejb _n3td1ejb _19bv1ejb _1e0c1txw _4cvr1h6o _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("l4UMm", function(module, exports) {
$parcel$export(module.exports, "FeatureGateLogo", () => $52d95abf7b90bced$export$83d4ce06fb8c3c0);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $i2sOf = parcelRequire("i2sOf");

var $itm3P = parcelRequire("itm3P");

var $kca6C = parcelRequire("kca6C");
const $52d95abf7b90bced$export$83d4ce06fb8c3c0 = ({ colorMode: colorMode, alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $i2sOf.default), {
        src: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($itm3P))) : (0, (/*@__PURE__*/$parcel$interopDefault($kca6C))),
        alt: alt
    });
$52d95abf7b90bced$export$83d4ce06fb8c3c0.displayName = "FeatureGateLogo";

});
parcelRegister("itm3P", function(module, exports) {
module.exports = new URL("plans-standard-dark.fce82c99.svg", import.meta.url).toString();

});

parcelRegister("kca6C", function(module, exports) {
module.exports = new URL("plans-standard-light.fde35b0d.svg", import.meta.url).toString();

});


parcelRegister("h5Y6i", function(module, exports) {
$parcel$export(module.exports, "PremiumUpgradeModalEntryPointButton", () => $535a7d155b27d6ee$export$9901be7804227da7);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6ouZy = parcelRequire("6ouZy");

var $7FW6G = parcelRequire("7FW6G");

var $jreC0 = parcelRequire("jreC0");

var $4YhY5 = parcelRequire("4YhY5");

var $2NmMZ = parcelRequire("2NmMZ");
const $535a7d155b27d6ee$var$entryPointParams = {};
const $535a7d155b27d6ee$export$9901be7804227da7 = (buttonProps)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $2NmMZ.entryPointPremiumUpgradeModal), $535a7d155b27d6ee$var$entryPointParams);
    const buttonTrigger = (0, $6ouZy.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4YhY5.default), {
        ...buttonProps,
        ref: buttonTrigger
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7FW6G.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jira-premium-upgrade-modal",
        packageName: "jiraPremiumUpgradeModal",
        errorFallback: "flag",
        runtimeProps: {
            onClose: entryPointActions.unload
        },
        entryPointActions: entryPointActions
    }));
};
$535a7d155b27d6ee$export$9901be7804227da7.displayName = "PremiumUpgradeModalEntryPointButton";

});
parcelRegister("7FW6G", function(module, exports) {
$parcel$export(module.exports, "ModalEntryPointContainer", () => $bc39b25b80a78e6d$export$4d67c6ee49f3d14d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3mLKJ = parcelRequire("3mLKJ");

var $4GGtd = parcelRequire("4GGtd");

var $9imxF = parcelRequire("9imxF");
const $bc39b25b80a78e6d$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
    const entryPointReference = (0, $3mLKJ.useEntryPointSubscription)(entryPointReferenceSubject);
    const props = (0, $euxye.useMemo)(()=>// oxlint-disable-next-line typescript/consistent-type-assertions
        ({
            ...runtimeProps,
            onClose () {
                runtimeProps.onClose?.();
                unload();
            }
        }), [
        runtimeProps,
        unload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9imxF.default), null, entryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4GGtd.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        errorFallback: errorFallback || 'flag',
        placeholderName: "modal-entry-point-container",
        runtimeProps: props
    }));
};
$bc39b25b80a78e6d$export$4d67c6ee49f3d14d.displayName = "ModalEntryPointContainer";

});

parcelRegister("2NmMZ", function(module, exports) {
$parcel$export(module.exports, "entryPointPremiumUpgradeModal", () => $e5c8413c530a4ea0$export$7116d5b1a93db8d6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $e5c8413c530a4ea0$export$7116d5b1a93db8d6 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("1UwsN")), {
        moduleId: "1102b440",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1UwsN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("aDjyj")
]).then(()=>parcelRequire('6BAD6'));

});







parcelRegister("jhJde", function(module, exports) {
$parcel$export(module.exports, "Nav4Projects", () => $b20c657fc6e38d87$export$5baf9fa0c4742f3f);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $gDdYI = parcelRequire("gDdYI");

var $a5nxD = parcelRequire("a5nxD");

var $2qwYT = parcelRequire("2qwYT");

const $b20c657fc6e38d87$export$5baf9fa0c4742f3f = (props)=>{
    const $ = (0, $e7boj.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a5nxD.JiraHoldoutCustomData), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
            name: "nav4-sidebar-projects"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            fallback: "flag",
            id: "projects-section",
            packageName: (0, $ed925264ba1585a6$export$b8b9d90f9e5bd72b),
            teamName: (0, $ed925264ba1585a6$export$d57b6b390e78d90f)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2qwYT.Nav4Projects), props)));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
$b20c657fc6e38d87$export$5baf9fa0c4742f3f.displayName = "Nav4Projects";

});
parcelRegister("2qwYT", function(module, exports) {
$parcel$export(module.exports, "Nav4Projects", () => $a5bc2dc7e3fdf412$export$5baf9fa0c4742f3f);

var $e7boj = parcelRequire("e7boj");

var $4CgEz = parcelRequire("4CgEz");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $5IkoH = parcelRequire("5IkoH");

var $19zz3 = parcelRequire("19zz3");

var $i860n = parcelRequire("i860n");

var $54HKM = parcelRequire("54HKM");

var $1UdBI = parcelRequire("1UdBI");

var $e0fqP = parcelRequire("e0fqP");
function $a5bc2dc7e3fdf412$export$5baf9fa0c4742f3f(props) {
    const $ = (0, $e7boj.c)(23);
    let dndProps;
    let isExpanded;
    let queryRef;
    if ($[0] !== props) {
        ({ isExpanded: isExpanded, queryRef: queryRef, ...dndProps } = props);
        $[0] = props;
        $[1] = dndProps;
        $[2] = isExpanded;
        $[3] = queryRef;
    } else {
        dndProps = $[1];
        isExpanded = $[2];
        queryRef = $[3];
    }
    const data = (0, $n67Vb.useFragment)((0, $4CgEz.default), queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $19zz3.useSidebarNav4)();
    const canCreateProject = !!data?.jira?.canCreateProject;
    const shouldDisplayCreateProject = !!data?.jira?.shouldDisplay;
    let t0;
    if ($[4] !== shouldDisplayCreateProject) {
        t0 = (0, $i860n.fg)("allow_end_users_to_access_custom_templates") ? {
            shouldDisplayCreateProject: shouldDisplayCreateProject
        } : {};
        $[4] = shouldDisplayCreateProject;
        $[5] = t0;
    } else t0 = $[5];
    let t1;
    if ($[6] !== canCreateProject || $[7] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $54HKM.ActionButtons), {
            canCreateProject: canCreateProject,
            ...t0
        });
        $[6] = canCreateProject;
        $[7] = t0;
        $[8] = t1;
    } else t1 = $[8];
    const actionButtons = t1;
    let t2;
    if ($[9] !== dndProps || $[10] !== isExpanded) {
        t2 = (0, $i860n.fg)("navx-global-side-nav") ? !!dndProps.isExpandOrFlyoutOpen && isExpanded : isExpanded;
        $[9] = dndProps;
        $[10] = isExpanded;
        $[11] = t2;
    } else t2 = $[11];
    const isExpandedValue = t2;
    if (!data.jira?.hasIsProjectsExpanded && isInitialSelectedPath((0, $5IkoH.MENU_ID_PROJECTS))) {
        let t3;
        if ($[12] !== actionButtons || $[13] !== dndProps || $[14] !== isExpandedValue) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1UdBI.Nav4ProjectsDefault), {
                actionsOnHover: actionButtons,
                isExpanded: isExpandedValue,
                ...dndProps
            });
            $[12] = actionButtons;
            $[13] = dndProps;
            $[14] = isExpandedValue;
            $[15] = t3;
        } else t3 = $[15];
        return t3;
    }
    let t3;
    if ($[16] !== actionButtons || $[17] !== data || $[18] !== dndProps || $[19] !== isExpanded || $[20] !== isExpandedValue || $[21] !== isInitialSelectedPath) {
        t3 = isInitialSelectedPath((0, $5IkoH.MENU_ID_PROJECTS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e0fqP.Nav4ProjectsForLanding), {
            actionsOnHover: actionButtons,
            isExpanded: isExpandedValue,
            queryRef: data,
            ...dndProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1UdBI.Nav4ProjectsDefault), {
            actionsOnHover: actionButtons,
            isExpanded: isExpanded,
            ...dndProps
        });
        $[16] = actionButtons;
        $[17] = data;
        $[18] = dndProps;
        $[19] = isExpanded;
        $[20] = isExpandedValue;
        $[21] = isInitialSelectedPath;
        $[22] = t3;
    } else t3 = $[22];
    return t3;
}
$a5bc2dc7e3fdf412$export$5baf9fa0c4742f3f.displayName = "Nav4Projects";

});
parcelRegister("4CgEz", function(module, exports) {
$parcel$export(module.exports, "default", () => $46a01ffc1ab2f402$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f508faf3f7324d29dace995e1368f928>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $46a01ffc1ab2f402$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            },
            {
                "kind": "RootArgument",
                "name": "isProjectsExpanded"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4Projects",
        "selections": [
            {
                "condition": "isProjectsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "currentURL",
                                "variableName": "currentURL"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "Nav4ProjectsForLanding"
                    }
                ]
            },
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "isProjectsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "alias": "hasIsProjectsExpanded",
                                "kind": "ScalarField",
                                "name": "__typename"
                            }
                        ]
                    },
                    {
                        "alias": "canCreateProject",
                        "args": [
                            v0 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "CREATE_PROJECT"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "canPerform"
                    },
                    {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "alias": "shouldDisplay",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "VIEW_PROJECT_CREATION_ENTRY"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "canPerform"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$46a01ffc1ab2f402$var$node.hash = "61e5b212ad9a8e9276808e7027b4245a";
var $46a01ffc1ab2f402$export$2e2bcd8739ae039 = $46a01ffc1ab2f402$var$node;

});

parcelRegister("54HKM", function(module, exports) {
$parcel$export(module.exports, "ActionButtons", () => $7b768beeb747ae6b$export$88c65d2d98aab183);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $gkFFZ = parcelRequire("gkFFZ");

var $33tfd = parcelRequire("33tfd");

var $4Kt0R = parcelRequire("4Kt0R");

var $1McjC = parcelRequire("1McjC");

var $l2lUd = parcelRequire("l2lUd");

var $hL4Cp = parcelRequire("hL4Cp");

var $ekhRy = parcelRequire("ekhRy");

var $6Qg24 = parcelRequire("6Qg24");

var $gcovh = parcelRequire("gcovh");


var $6GljB = parcelRequire("6GljB");

var $eO8S8 = parcelRequire("eO8S8");

var $hwodR = parcelRequire("hwodR");

var $2DbWL = parcelRequire("2DbWL");

var $gbTMi = parcelRequire("gbTMi");

var $gRWK8 = parcelRequire("gRWK8");

var $hZDXn = parcelRequire("hZDXn");

var $cSR11 = parcelRequire("cSR11");

var $g36LP = parcelRequire("g36LP");

var $72ldR = parcelRequire("72ldR");

var $ikOED = parcelRequire("ikOED");

var $gBaKj = parcelRequire("gBaKj");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");
const $7b768beeb747ae6b$var$createProject = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.create-project",
    defaultMessage: "Create project"
});
const $7b768beeb747ae6b$var$manageProjects = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.manage-projects",
    defaultMessage: "Manage projects"
});
const $7b768beeb747ae6b$var$projects = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.projects",
    defaultMessage: "projects"
});
const $7b768beeb747ae6b$var$createProjectGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.create-project-galaxia",
    defaultMessage: "Create space"
});
const $7b768beeb747ae6b$var$manageProjectsGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.manage-projects-galaxia",
    defaultMessage: "Manage spaces"
});
const $7b768beeb747ae6b$var$projectsGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.projects-galaxia",
    defaultMessage: "spaces"
});
const $7b768beeb747ae6b$var$CREATE_PROJECT_BUTTON_TEST_ID = 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.action-buttons.create-project-button';
function $7b768beeb747ae6b$export$88c65d2d98aab183(t0) {
    const $ = (0, $e7boj.c)(19);
    const { onClose: onClose, canCreateProject: canCreateProject, shouldDisplayCreateProject: shouldDisplayCreateProject } = t0;
    const projectsGalaxia = (0, $2700E.expVal)("project-terminology-refresh", "isEnabled", false) ? $7b768beeb747ae6b$var$projectsGalaxiaMessage : $7b768beeb747ae6b$var$projects;
    const createProjectGalaxia = (0, $2700E.expVal)("project-terminology-refresh", "isEnabled", false) ? $7b768beeb747ae6b$var$createProjectGalaxiaMessage : $7b768beeb747ae6b$var$createProject;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [, t1] = (0, $gRWK8.useSwitchModals)((0, $4Kt0R.MODAL_ID).PROJECT_CREATE);
    const { on: openProjectCreateDrawer } = t1;
    const { sendMeatBallDropDownAnalyticsEvent: sendMeatBallDropDownAnalyticsEvent, sendCreateProjectAnalyticsEvent: sendCreateProjectAnalyticsEvent } = (0, $ekhRy.useProjectsAnalyticsL1)();
    let t2;
    if ($[0] !== openProjectCreateDrawer || $[1] !== sendCreateProjectAnalyticsEvent) {
        t2 = ()=>{
            if ((0, $i860n.fg)("solution_composer_master")) (0, $33tfd.removeRovoCreateViewSpaceSource)();
            openProjectCreateDrawer();
            sendCreateProjectAnalyticsEvent();
        };
        $[0] = openProjectCreateDrawer;
        $[1] = sendCreateProjectAnalyticsEvent;
        $[2] = t2;
    } else t2 = $[2];
    const onClick = t2;
    let t3;
    if ($[3] !== sendMeatBallDropDownAnalyticsEvent) {
        t3 = ()=>{
            sendMeatBallDropDownAnalyticsEvent();
        };
        $[3] = sendMeatBallDropDownAnalyticsEvent;
        $[4] = t3;
    } else t3 = $[4];
    const onOpen = t3;
    const showProjectCreateButton = (0, $i860n.fg)("allow_end_users_to_access_custom_templates") ? shouldDisplayCreateProject : canCreateProject;
    let t4;
    if ($[5] !== formatMessage || $[6] !== onClick || $[7] !== showProjectCreateButton) {
        t4 = showProjectCreateButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
            content: formatMessage(createProjectGalaxia)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eO8S8.CommonNavMenuButton), {
            icon: $7b768beeb747ae6b$var$_temp,
            label: formatMessage(createProjectGalaxia),
            onClick: onClick,
            ...(0, $i860n.fg)("solution_composer_master") ? {
                testId: $7b768beeb747ae6b$var$CREATE_PROJECT_BUTTON_TEST_ID
            } : {}
        })) : null;
        $[5] = formatMessage;
        $[6] = onClick;
        $[7] = showProjectCreateButton;
        $[8] = t4;
    } else t4 = $[8];
    const createButton = t4;
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $i860n.fg)("solution_composer_master") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gkFFZ.RovoAiProjectModalListener), null);
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== formatMessage) {
        t6 = formatMessage(projectsGalaxia);
        $[10] = formatMessage;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== onClose || $[13] !== onOpen || $[14] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
            name: t6,
            onOpen: onOpen,
            MenuItems: $7b768beeb747ae6b$var$MoreMenuItems,
            onClose: onClose
        });
        $[12] = onClose;
        $[13] = onOpen;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== createButton || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, createButton, t5, t7);
        $[16] = createButton;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
}
$7b768beeb747ae6b$export$88c65d2d98aab183.displayName = "ActionButtons";
function $7b768beeb747ae6b$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ikOED))), {
        ...iconProps,
        size: "small"
    });
}
function $7b768beeb747ae6b$var$MoreMenuItems(t0) {
    const $ = (0, $e7boj.c)(21);
    const { onClose: onClose } = t0;
    const manageProjectsGalaxia = (0, $2700E.expVal)("project-terminology-refresh", "isEnabled", false) ? $7b768beeb747ae6b$var$manageProjectsGalaxiaMessage : $7b768beeb747ae6b$var$manageProjects;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1McjC.getProjectsNavigationPaths)();
        $[0] = t1;
    } else t1 = $[0];
    const href = t1.projectsViewProjects;
    const { sendMeatBallDropDownManageProjectsAnalyticsEvent: sendMeatBallDropDownManageProjectsAnalyticsEvent, sendChangeViewAnalyticsEvent: sendChangeViewAnalyticsEvent } = (0, $6Qg24.useProjectsAnalyticsL2)();
    const { sendChangeViewViewOptionAnalyticsEvent: sendChangeViewViewOptionAnalyticsEvent } = (0, $gcovh.useProjectsAnalyticsL3)();
    let t2;
    if ($[1] !== onClose || $[2] !== sendMeatBallDropDownManageProjectsAnalyticsEvent) {
        t2 = (e)=>{
            sendMeatBallDropDownManageProjectsAnalyticsEvent();
            onClose?.(e);
        };
        $[1] = onClose;
        $[2] = sendMeatBallDropDownManageProjectsAnalyticsEvent;
        $[3] = t2;
    } else t2 = $[3];
    const onCloseWithStopPropagation = (0, $hwodR.useStopPropagation)(t2);
    let t3;
    if ($[4] !== sendChangeViewViewOptionAnalyticsEvent) {
        t3 = (viewOptionValue)=>{
            const getItemId = ()=>{
                switch(viewOptionValue){
                    case (0, $hL4Cp.ViewOptions).STARRED:
                        return 0, $90c0351d239ffedb$export$ed36b1ade72db400;
                    case (0, $hL4Cp.ViewOptions).STARRED_AND_RECENT:
                        return 0, $90c0351d239ffedb$export$98d08638c2a90c44;
                    case (0, $hL4Cp.ViewOptions).MOST_RECENT_ONLY:
                        return 0, $90c0351d239ffedb$export$f8a73cc0211412ca;
                    default:
                        return 0, $90c0351d239ffedb$export$98d08638c2a90c44;
                }
            };
            sendChangeViewViewOptionAnalyticsEvent({
                itemId: getItemId()
            });
        };
        $[4] = sendChangeViewViewOptionAnalyticsEvent;
        $[5] = t3;
    } else t3 = $[5];
    const onChangeViewOptionChange = t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gBaKj))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)"
        });
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== formatMessage) {
        t5 = formatMessage(manageProjectsGalaxia);
        $[7] = formatMessage;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== onCloseWithStopPropagation || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
            isList: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cSR11.default), {
            iconBefore: t4,
            href: href,
            onClick: onCloseWithStopPropagation
        }, t5));
        $[9] = onCloseWithStopPropagation;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== onChangeViewOptionChange || $[13] !== sendChangeViewAnalyticsEvent) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l2lUd.ChangeViewMenuItem), {
            onOpen: sendChangeViewAnalyticsEvent,
            onChange: onChangeViewOptionChange
        });
        $[12] = onChangeViewOptionChange;
        $[13] = sendChangeViewAnalyticsEvent;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = !(0, $i860n.fg)("navx-global-side-nav") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2DbWL.HideL1MenuItemSection), {
            hasSeparator: false,
            menuId: (0, $6GljB.L1_MENU_ID).PROJECTS,
            hasSection: false
        });
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== t7) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
            hasSeparator: true,
            isList: true
        }, t7, t8);
        $[16] = t7;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== t6 || $[19] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), null, t6, t9);
        $[18] = t6;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    return t10;
}
$7b768beeb747ae6b$var$MoreMenuItems.displayName = "MoreMenuItems";

});
parcelRegister("gkFFZ", function(module, exports) {
$parcel$export(module.exports, "RovoAiProjectModalListener", () => $7cf0acf3a02a4af7$export$89436f4999e3c44d);

var $euxye = parcelRequire("euxye");

var $jepRN = parcelRequire("jepRN");

var $6mSn8 = parcelRequire("6mSn8");

var $fFNvS = parcelRequire("fFNvS");

var $4ilq6 = parcelRequire("4ilq6");

var $bufGv = parcelRequire("bufGv");
const $7cf0acf3a02a4af7$export$31bb3fe8e29cbbe = 'solcom-create-space-spotlight:get-started';
const $7cf0acf3a02a4af7$var$emptyEntryPointParams = {};
const $7cf0acf3a02a4af7$var$emptyEntryPointProps = {};
function $7cf0acf3a02a4af7$var$RovoAiProjectModalListenerEnabled() {
    const triggerRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (!globalThis.window) return;
        const handleGetStarted = ()=>{
            triggerRef.current?.click();
        };
        globalThis.window.addEventListener($7cf0acf3a02a4af7$export$31bb3fe8e29cbbe, handleGetStarted);
        return ()=>{
            globalThis.window.removeEventListener($7cf0acf3a02a4af7$export$31bb3fe8e29cbbe, handleGetStarted);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6mSn8.FullScreenModalTrigger), {
        entryPoint: (0, $bufGv.rovoAiProjectSpotlightModalEntryPoint),
        entryPointParams: $7cf0acf3a02a4af7$var$emptyEntryPointParams,
        entryPointProps: $7cf0acf3a02a4af7$var$emptyEntryPointProps,
        Fallback: (0, $4ilq6.RovoAiProjectModalLoadingFallback)
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("span", {
            ref: (0, $fFNvS.mergeRefs)(ref, triggerRef),
            "aria-hidden": "true",
            hidden: true
        }));
}
$7cf0acf3a02a4af7$var$RovoAiProjectModalListenerEnabled.displayName = "RovoAiProjectModalListenerEnabled";
function $7cf0acf3a02a4af7$var$RovoAiProjectModalListenerDisabled() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null);
}
$7cf0acf3a02a4af7$var$RovoAiProjectModalListenerDisabled.displayName = "RovoAiProjectModalListenerDisabled";
const $7cf0acf3a02a4af7$export$89436f4999e3c44d = (0, $jepRN.componentWithFG)('solcom_create_space_jira_admin_spotlight', $7cf0acf3a02a4af7$var$RovoAiProjectModalListenerEnabled, $7cf0acf3a02a4af7$var$RovoAiProjectModalListenerDisabled);

});
parcelRegister("4ilq6", function(module, exports) {
$parcel$export(module.exports, "RovoAiProjectModalLoadingFallback", () => $91c4ce0dedfa84aa$export$9fb568e3650924bd);
$parcel$export(module.exports, "RovoAiProjectPermissionModal", () => $91c4ce0dedfa84aa$export$26cc865e608d78e0);
/* RovoAiProjectPermissionModal.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $aAMI9 = parcelRequire("aAMI9");

var $m9iwH = parcelRequire("m9iwH");

var $9ufM9 = parcelRequire("9ufM9");

var $2iotI = parcelRequire("2iotI");

var $i68tN = parcelRequire("i68tN");

var $a1Bqx = parcelRequire("a1Bqx");

var $ihEDU = parcelRequire("ihEDU");

var $2XXtG = parcelRequire("2XXtG");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $abhF2 = parcelRequire("abhF2");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aqPkH = parcelRequire("aqPkH");
var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $ejDIb = parcelRequire("ejDIb");
const $91c4ce0dedfa84aa$var$contactAdminLink = '/jira/contact-administrator';
const $91c4ce0dedfa84aa$var$permissionModalUIAnalyticsAttributes = {
    location: 'rovoAiProjectPermissionModal',
    ...(0, $ejDIb.solutionComposerAnalyticsAttributes)
};
const $91c4ce0dedfa84aa$var$permissionModalTitle = (0, $7eNDO.defineMessage)({
    id: "servicedesk-solution-composer.rovo-ai-project-modal-listener.permission-modal-title",
    defaultMessage: "Only admins can create a space with Rovo"
});
const $91c4ce0dedfa84aa$var$permissionModalBody = (0, $7eNDO.defineMessage)({
    id: "servicedesk-solution-composer.rovo-ai-project-modal-listener.permission-modal-body",
    defaultMessage: "Rovo only supports creating company-managed spaces. Contact your admin to get started."
});
const $91c4ce0dedfa84aa$var$permissionModalContactAdmin = (0, $7eNDO.defineMessage)({
    id: "servicedesk-solution-composer.rovo-ai-project-modal-listener.permission-modal-contact-admin",
    defaultMessage: "Contact admin"
});
const $91c4ce0dedfa84aa$var$permissionModalClose = (0, $7eNDO.defineMessage)({
    id: "servicedesk-solution-composer.rovo-ai-project-modal-listener.permission-modal-close",
    defaultMessage: "Close"
});
const $91c4ce0dedfa84aa$var$permissionModalLoading = (0, $7eNDO.defineMessage)({
    id: "servicedesk-solution-composer.rovo-ai-project-modal-listener.permission-modal-loading",
    defaultMessage: "Loading Solution Composer"
});
const $91c4ce0dedfa84aa$var$styles = {
    loadingFallback: "_1bsb1osq _4t3i1osq",
    modalBackdrop: "_vchhusvi _1bsb1osq _4t3i1osq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _bfhkhfxm",
    modalFrame: "_1reo15vq _18m915vq _2rkopb1k _1e0c1txw _2lx21bp4 _1bsb1osq _4t3i1osq _bfhk1bhr _16qs130s",
    modalHeader: "_18zrpxbi _vchhusvi _kqswh2mm _1pbykb7n _1o9zidpf _ca0qpxbi _n3tdu2gc",
    modalHeaderRow: "_18zrutpp _1rjc1b66 _vchhusvi _1e0c1txw _4cvr1h6o _1bahh9n0 _1bsb1osq _4t3i1osq",
    modalRoot: "_kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1osq _4t3i1wug _1tkeidpf _16jlkb7n",
    content: "_vchhusvi _1bsb1fdn _p12f1osq _ca0qoahv _u5f3oahv _n3tdoahv _19bvoahv",
    copyWrapper: "_1bsb1osq"
};
function $91c4ce0dedfa84aa$export$9fb568e3650924bd() {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $91c4ce0dedfa84aa$var$styles.loadingFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
        size: "large",
        label: formatMessage($91c4ce0dedfa84aa$var$permissionModalLoading)
    }));
}
$91c4ce0dedfa84aa$export$9fb568e3650924bd.displayName = "RovoAiProjectModalLoadingFallback";
function $91c4ce0dedfa84aa$var$PermissionModalFrame({ children: children, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $91c4ce0dedfa84aa$var$styles.modalBackdrop,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $91c4ce0dedfa84aa$var$styles.modalFrame
    }, children));
}
$91c4ce0dedfa84aa$var$PermissionModalFrame.displayName = "PermissionModalFrame";
function $91c4ce0dedfa84aa$export$26cc865e608d78e0({ onClose: onClose }) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const handleClose = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            attributes: $91c4ce0dedfa84aa$var$permissionModalUIAnalyticsAttributes
        }), 'closeButton');
        onClose();
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const handleContactAdminClick = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            attributes: $91c4ce0dedfa84aa$var$permissionModalUIAnalyticsAttributes
        }), 'contactAdminLink');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireScreenAnalytics), {
        attributes: (0, $ejDIb.solutionComposerAnalyticsAttributes)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($91c4ce0dedfa84aa$var$PermissionModalFrame, {
        testId: "solution-composer.permission-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $91c4ce0dedfa84aa$var$styles.modalHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $91c4ce0dedfa84aa$var$styles.modalHeaderRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i68tN))),
        label: formatMessage($91c4ce0dedfa84aa$var$permissionModalClose),
        appearance: "default",
        shape: "circle",
        isTooltipDisabled: false,
        onClick: handleClose,
        testId: "solution-composer.permission-modal-close-button"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        xcss: $91c4ce0dedfa84aa$var$styles.modalRoot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        alignInline: "center",
        space: "space.800",
        xcss: $91c4ce0dedfa84aa$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aAMI9.default), {
        alt: "",
        width: "84",
        height: "117"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        alignInline: "center",
        space: "space.300",
        xcss: $91c4ce0dedfa84aa$var$styles.copyWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        alignInline: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "large"
    }, formatMessage($91c4ce0dedfa84aa$var$permissionModalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        align: "center"
    }, formatMessage($91c4ce0dedfa84aa$var$permissionModalBody))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.Inline), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9ufM9.default), {
        appearance: "primary",
        href: $91c4ce0dedfa84aa$var$contactAdminLink,
        target: "_blank",
        rel: "noopener noreferrer",
        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))),
        onClick: handleContactAdminClick
    }, formatMessage($91c4ce0dedfa84aa$var$permissionModalContactAdmin))))))));
}
$91c4ce0dedfa84aa$export$26cc865e608d78e0.displayName = "RovoAiProjectPermissionModal";

});
parcelRegister("aAMI9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ff9871b7e7702b8$export$2e2bcd8739ae039);

var $gboXr = parcelRequire("gboXr");

var $8U5P5 = parcelRequire("8U5P5");

var $cNaJY = parcelRequire("cNaJY");
const $7ff9871b7e7702b8$var$AdminPermissionLockIllustration = (0, $gboXr.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($cNaJY)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8U5P5))
});
var $7ff9871b7e7702b8$export$2e2bcd8739ae039 = $7ff9871b7e7702b8$var$AdminPermissionLockIllustration;

});
parcelRegister("8U5P5", function(module, exports) {
module.exports = new URL("admin-permission-lock-darkmode.b3deb85d.svg", import.meta.url).toString();

});

parcelRegister("cNaJY", function(module, exports) {
module.exports = new URL("admin-permission-lock.bbb58f3c.svg", import.meta.url).toString();

});


parcelRegister("ejDIb", function(module, exports) {
$parcel$export(module.exports, "solutionComposerAnalyticsAttributes", () => $57a0cca42ea7ac42$export$8644e3a7c62467f3);
$parcel$export(module.exports, "getHasCMPCreatePermissionFromProjectTemplates", () => $57a0cca42ea7ac42$export$70deb1037190ab33);
$parcel$export(module.exports, "fireCMPCreatePermissionCheckErrorAnalytics", () => $57a0cca42ea7ac42$export$3409746d7b4f50c7);

var $lCetP = parcelRequire("lCetP");

var $h2wCv = parcelRequire("h2wCv");

var $hFtK7 = parcelRequire("hFtK7");
const $57a0cca42ea7ac42$var$projectTemplatesEndpoint = '/rest/simplified/2.0/project-templates';
const $57a0cca42ea7ac42$export$8644e3a7c62467f3 = {
    inProductExperience: 'jsmComposer'
};
const $57a0cca42ea7ac42$export$70deb1037190ab33 = async ()=>{
    const response = await (0, $h2wCv.performGetRequest)($57a0cca42ea7ac42$var$projectTemplatesEndpoint);
    return response.templates?.some((template)=>template.projectTypeTemplates?.companyManaged?.canCreate === true) ?? false;
};
const $57a0cca42ea7ac42$export$3409746d7b4f50c7 = (e)=>{
    (0, $hFtK7.fireErrorAnalytics)({
        meta: {
            id: 'rovoAiProjectSpotlightModalPermissionCheck',
            packageName: 'servicedeskSolutionComposer',
            teamName: 'jsm-nebula'
        },
        error: e instanceof Error ? e : new Error(String(e)),
        attributes: {
            skipSentry: (0, $lCetP.isBackendAPIError)(e),
            ...$57a0cca42ea7ac42$export$8644e3a7c62467f3
        }
    });
};

});


parcelRegister("bufGv", function(module, exports) {
$parcel$export(module.exports, "rovoAiProjectSpotlightModalEntryPoint", () => $ad7542e4f0d6a2c0$export$200275caa0fabf68);

var $5ox7t = parcelRequire("5ox7t");

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $ad7542e4f0d6a2c0$export$200275caa0fabf68 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("a0VfG")), {
        moduleId: "371aff25",
        moduleName: "RovoAiProjectSpotlightModal",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            entryPoints: {
                rovoAiProjectEntryPoint: {
                    entryPoint: (0, $5ox7t.rovoAiProjectEntryPoint),
                    entryPointParams: {}
                }
            }
        })
});

});
parcelRegister("5ox7t", function(module, exports) {
$parcel$export(module.exports, "rovoAiProjectEntryPoint", () => $7862d7a13f087d87$export$9a3b20e51c30a09);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $7862d7a13f087d87$export$9a3b20e51c30a09 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("41fVN")), {
        moduleId: "1cd27a63",
        moduleName: "RovoAiProjectEntryPointWrapper",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("41fVN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("iZe2c"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("5geQX"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("e47VO")
]).then(()=>parcelRequire('2nZlA'));

});


parcelRegister("a0VfG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bwPBm").then(()=>parcelRequire('9zVGz'));

});



parcelRegister("33tfd", function(module, exports) {
$parcel$export(module.exports, "removeRovoCreateViewSpaceSource", () => $15550293887ec287$export$a6b8b26cacb56363);
const $15550293887ec287$var$ROVO_CREATE_VIEW_SPACE_SOURCE = 'rovo-create-view-space';
const $15550293887ec287$export$a6b8b26cacb56363 = ()=>{
    if (typeof globalThis.window === 'undefined') return;
    const url = new URL(globalThis.window.location.href);
    if (url.searchParams.get('source') !== $15550293887ec287$var$ROVO_CREATE_VIEW_SPACE_SOURCE) return;
    url.searchParams.delete('source');
    globalThis.window.history.replaceState(globalThis.window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
};

});

parcelRegister("1McjC", function(module, exports) {
$parcel$export(module.exports, "getProjectsNavigationPaths", () => $c877e0ed3107a7cf$export$5b37488a9fd89879);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $c877e0ed3107a7cf$export$5b37488a9fd89879 = ()=>({
        projectsViewProjects: '/jira/settings/projects/manage',
        projectsViewCategories: '/secure/admin/projectcategories/ViewProjectCategories!default.jspa',
        projectsPolicies: '/jira/settings/projects/policies',
        projectsTrashedProjects: '/jira/settings/projects/trash',
        projectsArchivedProjects: '/jira/settings/projects/archive'
    });

});

parcelRegister("l2lUd", function(module, exports) {
$parcel$export(module.exports, "ChangeViewMenuItem", () => $19dfb02ca2eba8ed$export$3bc1c3c28804a19b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $6ouZy = parcelRequire("6ouZy");

var $dUPUc = parcelRequire("dUPUc");

var $dwO1n = parcelRequire("dwO1n");

var $ceqcm = parcelRequire("ceqcm");

var $fFNvS = parcelRequire("fFNvS");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $gNzvf = parcelRequire("gNzvf");

var $kt86l = parcelRequire("kt86l");

var $a1fWU = parcelRequire("a1fWU");

var $1fPSX = parcelRequire("1fPSX");
const $19dfb02ca2eba8ed$var$changeViewMenuItemLabel = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-display-settings.change-view-action.change-view-menu-item-label",
    defaultMessage: "Change view"
});
const $19dfb02ca2eba8ed$var$listBulletedIcon = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-display-settings.change-view-action.list-bulleted-icon",
    defaultMessage: "List bulleted icon"
});
const $19dfb02ca2eba8ed$var$chevronRightIcon = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-display-settings.change-view-action.chevron-right-icon",
    defaultMessage: "Chevron right icon"
});
const $19dfb02ca2eba8ed$var$FOCUS_RETURNING_KEYS = [
    'Tab',
    'Escape',
    'Esc'
];
function $19dfb02ca2eba8ed$export$3bc1c3c28804a19b({ onOpen: onOpen, onChange: onChange }) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const cloudId = (0, $kt86l.useCloudId)();
    const onChangeViewMenuItemClick = ()=>{
        if (!isOpen && onOpen) onOpen();
        setIsOpen(!isOpen);
    };
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $1fPSX.ProjectsViewOptionsEntrypoint), {
        cloudId: cloudId,
        onChange: onChange
    });
    const entrypointRef = (0, $6ouZy.useEntryPointButtonTrigger)(entryPointActions);
    const triggerRef = (0, $euxye.useRef)(null);
    // Disabling the focus lock also disables AtlasKit's focus restoration, so the trigger reclaims it.
    const onPopupClose = (0, $euxye.useCallback)((event)=>{
        setIsOpen(false);
        if (event === null || !('key' in event) || !$19dfb02ca2eba8ed$var$FOCUS_RETURNING_KEYS.includes(event.key)) return;
        // Tab would otherwise move focus onwards before the trigger reclaims it.
        if (event.key === 'Tab') event.preventDefault();
        triggerRef.current?.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNzvf.JiraPopup), {
        isOpen: isOpen,
        onClose: onPopupClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "display-settings-menu-popup-content",
                packageName: "jira-navigation-apps-sidebar-nav4-display-settings",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a1fWU.Skeleton), null),
                runtimeProps: {},
                errorFallback: "flag"
            }),
        placement: "right-start",
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: "navigation-apps-sidebar-nav4-display-settings.ui.change-view-menu-item.popup",
        messageType: "transactional",
        shouldRenderToParent: true,
        ...(0, $2700E.expVal)('sea-3302-arrow-key-nav-proj-sidebar-view-options', 'isEnabled', false) ? {
            shouldDisableFocusLock: true
        } : {},
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
                ...triggerProps,
                ref: (0, $fFNvS.default)(ref, entrypointRef, triggerRef),
                isSelected: isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwO1n))), {
                    label: formatMessage($19dfb02ca2eba8ed$var$listBulletedIcon),
                    spacing: "spacious",
                    color: "var(--ds-icon, #292A2E)"
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dUPUc))), {
                    label: formatMessage($19dfb02ca2eba8ed$var$chevronRightIcon),
                    size: "small"
                }),
                onClick: onChangeViewMenuItemClick,
                "aria-label": formatMessage($19dfb02ca2eba8ed$var$changeViewMenuItemLabel),
                "aria-expanded": isOpen,
                "aria-haspopup": "true",
                // eslint-disable-next-line jira/integration/test-id-by-folder-structure
                testId: "navigation-apps-sidebar-nav4-display-settings.ui.change-view-menu-item.button"
            }, formatMessage($19dfb02ca2eba8ed$var$changeViewMenuItemLabel))
    });
}
$19dfb02ca2eba8ed$export$3bc1c3c28804a19b.displayName = "ChangeViewMenuItem";

});
parcelRegister("dwO1n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efb8f5139240fae402384ecfa3fe1805>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d9510b0e9c0d7b3$var$_react = $9d9510b0e9c0d7b3$var$_interopRequireDefault((parcelRequire("euxye")));

var $9d9510b0e9c0d7b3$var$_baseNew = $9d9510b0e9c0d7b3$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $9d9510b0e9c0d7b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/list-bulleted
 * Usage guidance:
 * Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d9510b0e9c0d7b3$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $9d9510b0e9c0d7b3$var$_react.default.createElement($9d9510b0e9c0d7b3$var$_baseNew.default, Object.assign({
        name: "ListBulletedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$9d9510b0e9c0d7b3$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $9d9510b0e9c0d7b3$var$_default = module.exports.default = $9d9510b0e9c0d7b3$var$ListBulletedIcon;

});

parcelRegister("a1fWU", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $5000c242d83ab8fa$export$8f31e4c4a37b8e9c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");


var $kENFC = parcelRequire("kENFC");

var $72ldR = parcelRequire("72ldR");

var $g36LP = parcelRequire("g36LP");
const $5000c242d83ab8fa$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), {
        minWidth: (0, $47916ea360432737$export$9c07662d9724277)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), null)));
$5000c242d83ab8fa$export$8f31e4c4a37b8e9c.displayName = "Skeleton";

});

parcelRegister("1fPSX", function(module, exports) {
$parcel$export(module.exports, "ProjectsViewOptionsEntrypoint", () => $74191164a8545322$export$cd53b98c3c72dc78);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $cmlNj = parcelRequire("cmlNj");

const $74191164a8545322$export$cd53b98c3c72dc78 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("hwciE")), {
        moduleId: "7fe819e5",
        moduleName: "ProjectsViewOptions",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, onChange: onChange })=>({
            queries: {
                projectsViewOptions: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $cmlNj.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            },
            extraProps: {
                onChange: onChange
            }
        })
});

});
parcelRegister("cmlNj", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa065d1c50c2f827$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0b4107d195cc09e351a6f65ff92a02f7>>
 * @relayHash 0e6b913da3ca80570d2232453a460c1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dcfe9939769b56d8b4a5c327dde03375eb0d9a2639a738ce027c3f4c80b09d70
const $fa065d1c50c2f827$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "displayMode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ProjectsViewOptionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ProjectsViewOptionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dcfe9939769b56d8b4a5c327dde03375eb0d9a2639a738ce027c3f4c80b09d70",
            "metadata": {},
            "name": "ProjectsViewOptionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fa065d1c50c2f827$var$node.hash = "878985a959db09740786f4815e3cda55";
var $fa065d1c50c2f827$export$2e2bcd8739ae039 = $fa065d1c50c2f827$var$node;

});

parcelRegister("hwciE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("e5xuD").then(()=>parcelRequire('c40hl'));

});



parcelRegister("hL4Cp", function(module, exports) {
$parcel$export(module.exports, "ViewOptions", () => $dc644612198f6920$export$8cd3967b7c246658);
$parcel$export(module.exports, "DefaultViewOption", () => $dc644612198f6920$export$8df870734bca67fa);
/* eslint-disable jira/filename-case */ const $dc644612198f6920$var$STARRED_AND_RECENT = 'STARRED_AND_RECENT';
const $dc644612198f6920$var$STARRED = 'STARRED';
const $dc644612198f6920$var$MOST_RECENT_ONLY = 'MOST_RECENT_ONLY';
const $dc644612198f6920$export$8cd3967b7c246658 = {
    STARRED_AND_RECENT: $dc644612198f6920$var$STARRED_AND_RECENT,
    STARRED: $dc644612198f6920$var$STARRED,
    MOST_RECENT_ONLY: $dc644612198f6920$var$MOST_RECENT_ONLY
};
const $dc644612198f6920$export$8df870734bca67fa = $dc644612198f6920$export$8cd3967b7c246658.STARRED_AND_RECENT;

});

parcelRegister("ekhRy", function(module, exports) {
$parcel$export(module.exports, "useProjectsAnalyticsL1", () => $9e4bdea268ac664f$export$7d9a1a79b1bd1338);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $lg2Jo = parcelRequire("lg2Jo");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");







var $2HCrv = parcelRequire("2HCrv");
const $9e4bdea268ac664f$export$7d9a1a79b1bd1338 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const initialProjectTemplate = (0, $lg2Jo.useInitialProjectTemplate)();
    // `initialProjectTemplate` resolves AFTER hydration (undefined -> value) from
    // a client-side project-property fetch. Including it directly in
    // `commonAttributes` changes that object's identity once it loads, which
    // invalidates every analytics `useCallback` below and cascades unnecessary
    // re-renders into the sidebar (measured via Chippy). The template is only
    // read at event-FIRE time (all events fire on user interaction, after load),
    // so we read it lazily via a ref to keep `commonAttributes` identity stable.
    const initialProjectTemplateRef = (0, $euxye.useRef)(initialProjectTemplate);
    // This runs for both sides of the gate (intentional)
    (0, $euxye.useEffect)(()=>{
        initialProjectTemplateRef.current = initialProjectTemplate;
    }, [
        initialProjectTemplate
    ]);
    const commonAttributes = (0, $euxye.useMemo)(()=>({
            level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
            navigationLayer: (0, $fad9173ee481d7de$export$17ff3f7e02c6ac22),
            // Getter reads the latest value at fire time, keeping object identity stable.
            get initialProjectTemplate () {
                return initialProjectTemplateRef.current;
            }
        }), // Intentionally empty: identity must remain stable; the template is read
    // lazily through the ref above.
    []);
    // fixed item - view all projects link
    const sendViewAllProjectsAnalyticsEvent = (0, $euxye.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
            itemId: (0, $90c0351d239ffedb$export$2de7e56f66635690)
        };
        (0, $aJ81Y.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - more projects flyout trigger
    const sendMoreProjectsAnalyticsEvent = (0, $euxye.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
            parentItemId: (0, $90c0351d239ffedb$export$44d67b522cbcce6d),
            itemId: (0, $90c0351d239ffedb$export$3e2efdbdb3eed97e)
        };
        (0, $aJ81Y.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - meatball icon button on projects menu (top level)
    const sendMeatBallDropDownAnalyticsEvent = (0, $euxye.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
            itemId: (0, $90c0351d239ffedb$export$f06dfcec5ff912e)
        };
        (0, $aJ81Y.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - create project (+) button on projects menu (top level)
    const sendCreateProjectAnalyticsEvent = (0, $euxye.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
            itemId: 'createProject'
        };
        (0, $aJ81Y.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // custom item - project menu item that displays project name (can be expandable menu or a link)
    const sendProjectMenuItemAnalyticsEvent = (0, $euxye.useCallback)(({ starred: starred, recent: recent, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
            itemType: (0, $687cb22024c607c7$export$fe791c4fa892e400),
            itemId: projectId,
            projectType: projectType,
            section: (0, $2HCrv.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $aJ81Y.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendProjectMenuContentAnalyticsEvent = (0, $euxye.useCallback)(()=>{
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
            itemId: 'projectsNavigationMenuItemContent'
        };
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'projectsNavigationMenuItemContent rendered', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendViewAllProjectsAnalyticsEvent: sendViewAllProjectsAnalyticsEvent,
        sendMoreProjectsAnalyticsEvent: sendMoreProjectsAnalyticsEvent,
        sendMeatBallDropDownAnalyticsEvent: sendMeatBallDropDownAnalyticsEvent,
        sendCreateProjectAnalyticsEvent: sendCreateProjectAnalyticsEvent,
        sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent,
        sendProjectMenuContentAnalyticsEvent: sendProjectMenuContentAnalyticsEvent
    };
};

});
parcelRegister("2HCrv", function(module, exports) {
$parcel$export(module.exports, "getSectionByStarredOrRecent", () => $32ee4146a1e66602$export$542854f16c0127e7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bOwox = parcelRequire("bOwox");
const $32ee4146a1e66602$export$542854f16c0127e7 = ({ starred: starred, recent: recent })=>{
    if (starred) return 0, $bOwox.SECTION_ITEM_STARRED;
    if (recent) return 0, $bOwox.SECTION_ITEM_RECENT;
    return '';
};

});


parcelRegister("6Qg24", function(module, exports) {
$parcel$export(module.exports, "useProjectsAnalyticsL2", () => $90df5ba7b5e158b8$export$1e04fadc2cea284c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $lg2Jo = parcelRequire("lg2Jo");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");







var $2HCrv = parcelRequire("2HCrv");
const $90df5ba7b5e158b8$export$1e04fadc2cea284c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const initialProjectTemplate = (0, $lg2Jo.useInitialProjectTemplate)();
    // `initialProjectTemplate` comes from a client-side project-property fetch
    // that resolves AFTER hydration (undefined -> value). Including it directly
    // in `commonAttributes` means that object's identity changes once the
    // property loads, which invalidates every analytics `useCallback` below and
    // cascades unnecessary re-renders into the sidebar menu items (measured via
    // Chippy). Since the template is only ever read at event-FIRE time (every
    // consumer spreads `commonAttributes` inside the callback body, and all
    // events fire on user interaction, well after load), we can read it lazily
    // via a ref so `commonAttributes` keeps a stable identity for the hook's
    // lifetime.
    const initialProjectTemplateRef = (0, $euxye.useRef)(initialProjectTemplate);
    (0, $euxye.useEffect)(()=>{
        initialProjectTemplateRef.current = initialProjectTemplate;
    }, [
        initialProjectTemplate
    ]);
    const commonAttributes = (0, $euxye.useMemo)(()=>({
            level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
            // Getter reads the latest value at fire time, keeping object identity stable.
            get initialProjectTemplate () {
                return initialProjectTemplateRef.current;
            }
        }), // Intentionally empty: identity must remain stable; the template is read
    // lazily through the ref above.
    []);
    const sendMeatBallDropDownManageProjectsAnalyticsEvent = (0, $euxye.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$17bca95234dea43b),
            itemId: 'manageProjects',
            parentItemId: (0, $90c0351d239ffedb$export$f06dfcec5ff912e)
        };
        (0, $aJ81Y.fireUIAnalytics)(event, (0, $47ad9e6c8e8002a4$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // board navigation item under each project when project is expandable menu
    const sendBoardNavigationItemInsideProjectsAnalyticsEvent = (0, $euxye.useCallback)(({ boardId: boardId, projectId: projectId, recent: recent, starred: starred, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
            itemId: boardId,
            itemType: (0, $687cb22024c607c7$export$9b8283d5878d2491),
            parentItemId: projectId,
            parentItemType: (0, $687cb22024c607c7$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $2HCrv.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $aJ81Y.fireUIAnalytics)(event, (0, $47ad9e6c8e8002a4$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // meatball menu on projects
    const getMeatBallDropDownOnProjectsAnalytics = (0, $euxye.useCallback)(({ recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        return {
            ...commonAttributes,
            actionSubjectId: (0, $47ad9e6c8e8002a4$export$8d155d2412839524),
            componentType: (0, $6e2f51712bb2e810$export$9bd6c21d500ae611),
            itemId: (0, $90c0351d239ffedb$export$f06dfcec5ff912e),
            parentItemId: projectId,
            parentItemType: (0, $687cb22024c607c7$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $2HCrv.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
    }, [
        commonAttributes
    ]);
    /** @deprecated, replace with getMeatBallDropDownOnProjectsAnalytics  */ const sendMeatBallDropDownOnProjectsAnalyticsEvent = (0, $euxye.useCallback)((params)=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$b887e88d8d0739f6)
        });
        const { actionSubjectId: actionSubjectId, ...attributes } = getMeatBallDropDownOnProjectsAnalytics(params);
        (0, $aJ81Y.fireUIAnalytics)(event, actionSubjectId, attributes);
    }, [
        createAnalyticsEvent,
        getMeatBallDropDownOnProjectsAnalytics
    ]);
    // create board button
    const sendCreateBoardOnBoardMenuItemAnalyticsEvent = (0, $euxye.useCallback)(({ recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$9bd6c21d500ae611),
            itemId: 'createBoard',
            parentItemId: projectId,
            parentItemType: (0, $687cb22024c607c7$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $2HCrv.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $aJ81Y.fireUIAnalytics)(event, (0, $47ad9e6c8e8002a4$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - view all boards link
    const sendViewAllBoardsAnalyticsEvent = (0, $euxye.useCallback)(({ projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
            itemId: 'viewAllBoards',
            parentItemId: projectId,
            parentItemType: (0, $687cb22024c607c7$export$fe791c4fa892e400),
            projectType: projectType
        };
        (0, $aJ81Y.fireUIAnalytics)(event, (0, $47ad9e6c8e8002a4$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - Change View in Meatball Menu on Projects section
    const sendChangeViewAnalyticsEvent = (0, $euxye.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$17bca95234dea43b),
            parentItemId: (0, $90c0351d239ffedb$export$44d67b522cbcce6d),
            itemId: (0, $687cb22024c607c7$export$119dad133da0b4a)
        };
        (0, $aJ81Y.fireUIAnalytics)(event, (0, $47ad9e6c8e8002a4$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - View All Projects in More Projects flyout
    const sendViewAllProjectsAnalyticsEvent = (0, $euxye.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$17bca95234dea43b),
            parentItemId: (0, $90c0351d239ffedb$export$3e2efdbdb3eed97e),
            itemId: (0, $90c0351d239ffedb$export$2de7e56f66635690)
        };
        (0, $aJ81Y.fireUIAnalytics)(event, (0, $47ad9e6c8e8002a4$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // custom item - project in More Projects flyout
    const sendMoreProjectsFlyoutProjectAnalyticsEvent = (0, $euxye.useCallback)(({ projectId: projectId, sectionType: sectionType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
            parentItemId: (0, $90c0351d239ffedb$export$3e2efdbdb3eed97e),
            itemType: (0, $687cb22024c607c7$export$fe791c4fa892e400),
            itemId: projectId,
            moreProjectsSection: sectionType
        };
        (0, $aJ81Y.fireUIAnalytics)(event, (0, $47ad9e6c8e8002a4$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendProjectMenuContentSectionAnalyticsEvent = (0, $euxye.useCallback)(({ projectSection: projectSection, canCreateProject: canCreateProject })=>{
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
            itemId: projectSection,
            canCreateProject: canCreateProject
        };
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'projectsNavigationContentSection rendered', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendMoreProjectsFlyoutProjectsSearchEnteredAnalyticsEvent = (0, $euxye.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'entered',
            actionSubject: (0, $6b2913942bd90807$export$b0a8b257f1f878a2)
        });
        const attributes = {
            ...commonAttributes,
            parentItemId: (0, $90c0351d239ffedb$export$3e2efdbdb3eed97e),
            itemId: (0, $90c0351d239ffedb$export$e338c40e64df0640)
        };
        (0, $aJ81Y.fireUIAnalytics)(event, (0, $47ad9e6c8e8002a4$export$8ebfc84e07851700), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownManageProjectsAnalyticsEvent: sendMeatBallDropDownManageProjectsAnalyticsEvent,
        sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent,
        sendBoardNavigationItemInsideProjectsAnalyticsEvent: sendBoardNavigationItemInsideProjectsAnalyticsEvent,
        sendCreateBoardOnBoardMenuItemAnalyticsEvent: sendCreateBoardOnBoardMenuItemAnalyticsEvent,
        sendViewAllBoardsAnalyticsEvent: sendViewAllBoardsAnalyticsEvent,
        sendChangeViewAnalyticsEvent: sendChangeViewAnalyticsEvent,
        sendViewAllProjectsAnalyticsEvent: sendViewAllProjectsAnalyticsEvent,
        sendMoreProjectsFlyoutProjectAnalyticsEvent: sendMoreProjectsFlyoutProjectAnalyticsEvent,
        sendProjectMenuContentSectionAnalyticsEvent: sendProjectMenuContentSectionAnalyticsEvent,
        sendMoreProjectsFlyoutProjectsSearchEnteredAnalyticsEvent: sendMoreProjectsFlyoutProjectsSearchEnteredAnalyticsEvent
    };
};

});
/* eslint-disable jira/filename-case */ const $47ad9e6c8e8002a4$export$8d155d2412839524 = 'projectsNavigationMenuItem';
const $47ad9e6c8e8002a4$export$13171e509c859bbf = 'projectSettingsNavigationMenuItem';
const $47ad9e6c8e8002a4$export$8ebfc84e07851700 = 'moreProjectsSearch';


parcelRegister("gcovh", function(module, exports) {
$parcel$export(module.exports, "useProjectsAnalyticsL3", () => $c447473a10246a2a$export$619b8904be99ed7c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $lg2Jo = parcelRequire("lg2Jo");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");






var $2HCrv = parcelRequire("2HCrv");

const $c447473a10246a2a$export$619b8904be99ed7c = (overrideProjectId)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const initialProjectTemplate = (0, $lg2Jo.useInitialProjectTemplate)((0, $i860n.fg)('initial-project-template-event-attr') ? overrideProjectId : undefined);
    const commonAttributes = (0, $euxye.useMemo)(()=>({
            level: (0, $ef39084c605eb7e8$export$f9db6a58b4aabd18),
            initialProjectTemplate: initialProjectTemplate
        }), [
        initialProjectTemplate
    ]);
    // actions inside meatball menu on projects
    const sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent = (0, $euxye.useCallback)(({ itemId: itemId, recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: projectId,
            parentItemType: (0, $687cb22024c607c7$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $2HCrv.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $aJ81Y.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // meatball menu on boards
    const sendMeatBallDropDownOnBoardsAnalyticsEvent = (0, $euxye.useCallback)(({ recent: recent, starred: starred, boardId: boardId, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$9bd6c21d500ae611),
            itemId: (0, $90c0351d239ffedb$export$f06dfcec5ff912e),
            projectId: projectId,
            parentItemId: boardId,
            parentItemType: (0, $687cb22024c607c7$export$9b8283d5878d2491),
            projectType: projectType,
            section: (0, $2HCrv.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $aJ81Y.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendChangeViewViewOptionAnalyticsEvent = (0, $euxye.useCallback)(({ itemId: itemId })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$17bca95234dea43b),
            itemId: itemId,
            parentItemId: (0, $687cb22024c607c7$export$119dad133da0b4a)
        };
        (0, $aJ81Y.fireUIAnalytics)(event, (0, $47ad9e6c8e8002a4$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent: sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent,
        sendMeatBallDropDownOnBoardsAnalyticsEvent: sendMeatBallDropDownOnBoardsAnalyticsEvent,
        sendChangeViewViewOptionAnalyticsEvent: sendChangeViewViewOptionAnalyticsEvent
    };
};

});


parcelRegister("1UdBI", function(module, exports) {
$parcel$export(module.exports, "Nav4ProjectsDefault", () => $eaf67d195e4d2546$export$373934ae259d74df);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $9h4A8 = parcelRequire("9h4A8");

var $jreC0 = parcelRequire("jreC0");

var $bOwox = parcelRequire("bOwox");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $4VtOS = parcelRequire("4VtOS");

var $gEDfa = parcelRequire("gEDfa");

var $jzXAj = parcelRequire("jzXAj");

var $3rqDf = parcelRequire("3rqDf");

var $dx7aH = parcelRequire("dx7aH");

var $hDvet = parcelRequire("hDvet");

var $btoiF = parcelRequire("btoiF");


var $f1JKW = parcelRequire("f1JKW");

var $jepRN = parcelRequire("jepRN");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $fFNvS = parcelRequire("fFNvS");

var $kt86l = parcelRequire("kt86l");

var $h3LJR = parcelRequire("h3LJR");

var $3GN2r = parcelRequire("3GN2r");


var $dBNbj = parcelRequire("dBNbj");
const $eaf67d195e4d2546$export$373934ae259d74df = (0, $jepRN.componentWithFG)('navx-global-side-nav', $eaf67d195e4d2546$var$Nav4ProjectsDefaultGSN, $eaf67d195e4d2546$var$Nav4ProjectsDefaultNav4);
function $eaf67d195e4d2546$var$Nav4ProjectsDefaultGSN(props) {
    const $ = (0, $e7boj.c)(50);
    const { actionsOnHover: actionsOnHover, draggableRef: draggableRef, dropIndicator: dropIndicator, isDragging: isDragging, isExpanded: isExpanded, hasDragIndicator: hasDragIndicator, simulateLoading: t0, onExpandFlyoutToggle: onExpandFlyoutToggle, visualContentRef: visualContentRef } = props;
    const simulateLoading = t0 === undefined ? false : t0;
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const atlassianAccountId = (0, $3GN2r.useAccountId)();
    const currentURL = (0, $9h4A8.useGetCurrentUrl)();
    let t1;
    if ($[0] !== activationId || $[1] !== atlassianAccountId || $[2] !== cloudId || $[3] !== currentURL) {
        t1 = {
            cloudId: cloudId,
            currentURL: currentURL,
            activationId: activationId,
            atlassianAccountId: atlassianAccountId
        };
        $[0] = activationId;
        $[1] = atlassianAccountId;
        $[2] = cloudId;
        $[3] = currentURL;
        $[4] = t1;
    } else t1 = $[4];
    const entryPointParamsOld = t1;
    let t2;
    if ($[5] !== activationId || $[6] !== atlassianAccountId || $[7] !== cloudId) {
        t2 = {
            tenantContext: {
                cloudId: cloudId,
                activationId: activationId,
                atlassianAccountId: atlassianAccountId
            }
        };
        $[5] = activationId;
        $[6] = atlassianAccountId;
        $[7] = cloudId;
        $[8] = t2;
    } else t2 = $[8];
    const entryPointParams = t2;
    const leftSidebarEPRef = (0, $btoiF.usePageLayoutEntryPoint)((0, $b666e36d39b806ff$export$50ea883ba6f28ff5));
    const projectsEPRef = leftSidebarEPRef?.entryPoints?.projects;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $dBNbj.nav4ProjectsContentEntryPoint), entryPointParams);
    const triggerRef = (0, $hDvet.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).PROJECTS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    let t3;
    let t4;
    if ($[9] !== entryPointActions || $[10] !== isExpanded || $[11] !== projectsEPRef) {
        t3 = ()=>{
            if (!projectsEPRef && isExpanded) entryPointActions.load();
        };
        t4 = [
            entryPointActions,
            projectsEPRef,
            isExpanded
        ];
        $[9] = entryPointActions;
        $[10] = isExpanded;
        $[11] = projectsEPRef;
        $[12] = t3;
        $[13] = t4;
    } else {
        t3 = $[12];
        t4 = $[13];
    }
    (0, $euxye.useEffect)(t3, t4);
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), {
            count: 6,
            withHeading: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), {
            count: 6,
            withHeading: true
        }));
        $[14] = t5;
    } else t5 = $[14];
    const skeleton = t5;
    let t6;
    if ($[15] !== entryPointParamsOld || $[16] !== entryPointReferenceSubject || $[17] !== projectsEPRef) {
        t6 = ()=>{
            const epContainerProps = {
                id: "nav4-sidebar-projects-default",
                packageName: (0, $ed925264ba1585a6$export$b8b9d90f9e5bd72b),
                teamName: (0, $ed925264ba1585a6$export$d57b6b390e78d90f),
                errorFallback: "flag",
                fallback: skeleton,
                runtimeProps: entryPointParamsOld
            };
            return {
                Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f1JKW.RouteEntryPointContainer), {
                        epContainerProps: epContainerProps,
                        jiraEPRef: entryPointReferenceSubject,
                        nestedEPRef: projectsEPRef,
                        placeholderEntryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
                    })
            };
        };
        $[15] = entryPointParamsOld;
        $[16] = entryPointReferenceSubject;
        $[17] = projectsEPRef;
        $[18] = t6;
    } else t6 = $[18];
    const [entryPointConfig] = (0, $euxye.useState)(t6);
    let t7;
    if ($[19] !== entryPointConfig.Component) {
        t7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(entryPointConfig.Component, null);
        $[19] = entryPointConfig.Component;
        $[20] = t7;
    } else t7 = $[20];
    const content = t7;
    let t8;
    if ($[21] !== entryPointActions) {
        t8 = (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        };
        $[21] = entryPointActions;
        $[22] = t8;
    } else t8 = $[22];
    const handleSystemToggle = t8;
    let t9;
    if ($[23] !== entryPointActions || $[24] !== onExpandFlyoutToggle || $[25] !== sendSectionItemAnalyticsEvent) {
        t9 = (hasExpanded_0)=>{
            if (hasExpanded_0) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $6GljB.L1_MENU_ID).PROJECTS,
                    sectionItem: (0, $bOwox.SECTION_ITEM_PROJECTS)
                });
            }
            onExpandFlyoutToggle?.(hasExpanded_0);
        };
        $[23] = entryPointActions;
        $[24] = onExpandFlyoutToggle;
        $[25] = sendSectionItemAnalyticsEvent;
        $[26] = t9;
    } else t9 = $[26];
    const handleExpansionToggle = t9;
    let t10;
    if ($[27] !== draggableRef || $[28] !== triggerRef) {
        t10 = draggableRef ? (0, $fFNvS.mergeRefs)(triggerRef, draggableRef) : triggerRef;
        $[27] = draggableRef;
        $[28] = triggerRef;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $jzXAj.getTestId)((0, $5IkoH.MENU_ID_PROJECTS));
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== actionsOnHover || $[32] !== formattedMessage || $[33] !== hasDragIndicator || $[34] !== icon || $[35] !== isDragging || $[36] !== t10) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            hasDragIndicator: hasDragIndicator,
            interactionName: "nav4-sidebar-projects-default",
            isDragging: isDragging,
            ref: t10,
            testId: t11
        }, formattedMessage);
        $[31] = actionsOnHover;
        $[32] = formattedMessage;
        $[33] = hasDragIndicator;
        $[34] = icon;
        $[35] = isDragging;
        $[36] = t10;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== content || $[39] !== simulateLoading) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, simulateLoading ? skeleton : content());
        $[38] = content;
        $[39] = simulateLoading;
        $[40] = t13;
    } else t13 = $[40];
    let t14;
    if ($[41] !== dropIndicator || $[42] !== handleExpansionToggle || $[43] !== handleSystemToggle || $[44] !== isDragging || $[45] !== isExpanded || $[46] !== t12 || $[47] !== t13 || $[48] !== visualContentRef) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
            dropTargetRef: visualContentRef,
            dropIndicator: dropIndicator,
            isDragging: isDragging,
            isExpanded: isExpanded,
            menuId: (0, $5IkoH.MENU_ID_PROJECTS),
            onSystemToggle: handleSystemToggle,
            onExpansionToggle: handleExpansionToggle
        }, t12, t13);
        $[41] = dropIndicator;
        $[42] = handleExpansionToggle;
        $[43] = handleSystemToggle;
        $[44] = isDragging;
        $[45] = isExpanded;
        $[46] = t12;
        $[47] = t13;
        $[48] = visualContentRef;
        $[49] = t14;
    } else t14 = $[49];
    return t14;
}
$eaf67d195e4d2546$var$Nav4ProjectsDefaultGSN.displayName = "Nav4ProjectsDefaultGSN";
function $eaf67d195e4d2546$var$Nav4ProjectsDefaultNav4(props) {
    const $ = (0, $e7boj.c)(41);
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, simulateLoading: t0 } = props;
    const simulateLoading = t0 === undefined ? false : t0;
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const atlassianAccountId = (0, $3GN2r.useAccountId)();
    const currentURL = (0, $9h4A8.useGetCurrentUrl)();
    let t1;
    if ($[0] !== activationId || $[1] !== atlassianAccountId || $[2] !== cloudId || $[3] !== currentURL) {
        t1 = {
            cloudId: cloudId,
            currentURL: currentURL,
            activationId: activationId,
            atlassianAccountId: atlassianAccountId
        };
        $[0] = activationId;
        $[1] = atlassianAccountId;
        $[2] = cloudId;
        $[3] = currentURL;
        $[4] = t1;
    } else t1 = $[4];
    const entryPointParamsOld = t1;
    let t2;
    if ($[5] !== activationId || $[6] !== atlassianAccountId || $[7] !== cloudId) {
        t2 = {
            tenantContext: {
                cloudId: cloudId,
                activationId: activationId,
                atlassianAccountId: atlassianAccountId
            }
        };
        $[5] = activationId;
        $[6] = atlassianAccountId;
        $[7] = cloudId;
        $[8] = t2;
    } else t2 = $[8];
    const entryPointParams = t2;
    const leftSidebarEPRef = (0, $btoiF.usePageLayoutEntryPoint)((0, $b666e36d39b806ff$export$50ea883ba6f28ff5));
    const projectsEPRef = leftSidebarEPRef?.entryPoints?.projects;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $dBNbj.nav4ProjectsContentEntryPoint), entryPointParams);
    const triggerRef = (0, $hDvet.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).PROJECTS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    let t3;
    let t4;
    if ($[9] !== entryPointActions || $[10] !== isExpanded || $[11] !== projectsEPRef) {
        t3 = ()=>{
            if (!projectsEPRef && isExpanded) entryPointActions.load();
        };
        t4 = [
            entryPointActions,
            projectsEPRef,
            isExpanded
        ];
        $[9] = entryPointActions;
        $[10] = isExpanded;
        $[11] = projectsEPRef;
        $[12] = t3;
        $[13] = t4;
    } else {
        t3 = $[12];
        t4 = $[13];
    }
    (0, $euxye.useEffect)(t3, t4);
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), {
            count: 6,
            withHeading: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), {
            count: 6,
            withHeading: true
        }));
        $[14] = t5;
    } else t5 = $[14];
    const skeleton = t5;
    let t6;
    if ($[15] !== entryPointParamsOld || $[16] !== entryPointReferenceSubject || $[17] !== projectsEPRef) {
        t6 = ()=>{
            const epContainerProps = {
                id: "nav4-sidebar-projects-default",
                packageName: (0, $ed925264ba1585a6$export$b8b9d90f9e5bd72b),
                teamName: (0, $ed925264ba1585a6$export$d57b6b390e78d90f),
                errorFallback: "flag",
                fallback: skeleton,
                runtimeProps: entryPointParamsOld
            };
            return {
                Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f1JKW.RouteEntryPointContainer), {
                        epContainerProps: epContainerProps,
                        jiraEPRef: entryPointReferenceSubject,
                        nestedEPRef: projectsEPRef,
                        placeholderEntryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
                    })
            };
        };
        $[15] = entryPointParamsOld;
        $[16] = entryPointReferenceSubject;
        $[17] = projectsEPRef;
        $[18] = t6;
    } else t6 = $[18];
    const [entryPointConfig] = (0, $euxye.useState)(t6);
    let t7;
    if ($[19] !== entryPointConfig.Component) {
        t7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(entryPointConfig.Component, null);
        $[19] = entryPointConfig.Component;
        $[20] = t7;
    } else t7 = $[20];
    const content = t7;
    let t8;
    if ($[21] !== entryPointActions) {
        t8 = (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        };
        $[21] = entryPointActions;
        $[22] = t8;
    } else t8 = $[22];
    const t9 = t8;
    let t10;
    if ($[23] !== entryPointActions || $[24] !== sendSectionItemAnalyticsEvent) {
        t10 = (hasExpanded_0)=>{
            if (hasExpanded_0) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $6GljB.L1_MENU_ID).PROJECTS,
                    sectionItem: (0, $bOwox.SECTION_ITEM_PROJECTS)
                });
            }
        };
        $[23] = entryPointActions;
        $[24] = sendSectionItemAnalyticsEvent;
        $[25] = t10;
    } else t10 = $[25];
    const t11 = t10;
    let t12;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $jzXAj.getTestId)((0, $5IkoH.MENU_ID_PROJECTS));
        $[26] = t12;
    } else t12 = $[26];
    let t13;
    if ($[27] !== actionsOnHover || $[28] !== formattedMessage || $[29] !== icon || $[30] !== triggerRef) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
            interactionName: "nav4-sidebar-projects-default",
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            ref: triggerRef,
            testId: t12
        }, formattedMessage);
        $[27] = actionsOnHover;
        $[28] = formattedMessage;
        $[29] = icon;
        $[30] = triggerRef;
        $[31] = t13;
    } else t13 = $[31];
    let t14;
    if ($[32] !== content || $[33] !== simulateLoading) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, simulateLoading ? skeleton : content());
        $[32] = content;
        $[33] = simulateLoading;
        $[34] = t14;
    } else t14 = $[34];
    let t15;
    if ($[35] !== isExpanded || $[36] !== t11 || $[37] !== t13 || $[38] !== t14 || $[39] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            menuId: (0, $5IkoH.MENU_ID_PROJECTS),
            onSystemToggle: t9,
            onExpansionToggle: t11
        }, t13, t14);
        $[35] = isExpanded;
        $[36] = t11;
        $[37] = t13;
        $[38] = t14;
        $[39] = t9;
        $[40] = t15;
    } else t15 = $[40];
    return t15;
}
$eaf67d195e4d2546$var$Nav4ProjectsDefaultNav4.displayName = "Nav4ProjectsDefaultNav4";

});
/* eslint-disable jira/filename-case */ const $ed925264ba1585a6$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Projects';
const $ed925264ba1585a6$export$d57b6b390e78d90f = 'jira-cosmos';

parcelRegister("dBNbj", function(module, exports) {
$parcel$export(module.exports, "nav4ProjectsContentEntryPoint", () => $7e411bd621490ce6$export$a457f9fdcd1ea5d3);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $bYKD2 = parcelRequire("bYKD2");

const $7e411bd621490ce6$export$a457f9fdcd1ea5d3 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("gdFxb")), {
        moduleId: "d341df68",
        moduleName: "Nav4ProjectsContentViewQuery",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId || '';
        return {
            queries: {
                projects: {
                    parameters: $bYKD2.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("bYKD2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b251e0d9621b829$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<db56b8ee49ceec2eb3e5bc87288721c6>>
 * @relayHash 1611de19321c3f301e694a38bac8da80
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4cf4616a53f4992083c4142aad58043a0629a880927311ba99a612c363e7fd82

var $25bhx = parcelRequire("25bhx");

var $fpAD9 = parcelRequire("fpAD9");

var $lIGkE = parcelRequire("lIGkE");
const $5b251e0d9621b829$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v7 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v11 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v3 /*: any*/ 
                ],
                "type": "Node",
                "abstractKey": "__isNode"
            }
        ]
    }, v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v13 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v14 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v15 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v16 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "alias": "subspaceCount",
                        "kind": "ScalarField",
                        "name": "subspaceCount_cse"
                    }
                ]
            }
        ]
    }, v17 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v18 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v17 /*: any*/ 
            }
        ]
    }, v19 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4ProjectsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4ProjectsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx"
                }
            ],
            "kind": "Operation",
            "name": "Nav4ProjectsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "mostRecent",
                            "plural": false,
                            "selections": v17 /*: any*/ 
                        },
                        {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "mostRecentFromHistory",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v10 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                v18 /*: any*/ ,
                                v19 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "recents",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                v19 /*: any*/ 
                            ],
                            "storageKey": "recents(first:20)"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "favouriteLimit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "recentLimit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "displayMode"
                        },
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "4cf4616a53f4992083c4142aad58043a0629a880927311ba99a612c363e7fd82",
            "metadata": {},
            "name": "Nav4ProjectsContentViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": (0, $fpAD9.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx": (0, $25bhx.default)
            }
        }
    };
}();
$5b251e0d9621b829$var$node.hash = "81c030f5ee4efc947c27b112f9d8730c";
(0, $lIGkE.PreloadableQueryRegistry).set($5b251e0d9621b829$var$node.params.id, $5b251e0d9621b829$var$node);
var $5b251e0d9621b829$export$2e2bcd8739ae039 = $5b251e0d9621b829$var$node;

});

parcelRegister("gdFxb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ewkq8")
]).then(()=>parcelRequire('6oIAV'));

});



parcelRegister("e0fqP", function(module, exports) {
$parcel$export(module.exports, "Nav4ProjectsForLanding", () => $f65a05892c928e5e$export$8c948b59812f90e9);

var $e7boj = parcelRequire("e7boj");

var $1FziV = parcelRequire("1FziV");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");

var $bOwox = parcelRequire("bOwox");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $4VtOS = parcelRequire("4VtOS");

var $jzXAj = parcelRequire("jzXAj");

var $3rqDf = parcelRequire("3rqDf");

var $dx7aH = parcelRequire("dx7aH");

var $jepRN = parcelRequire("jepRN");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $gDdYI = parcelRequire("gDdYI");

var $a5nxD = parcelRequire("a5nxD");

var $i860n = parcelRequire("i860n");

var $e6pfw = parcelRequire("e6pfw");


var $fyRT9 = parcelRequire("fyRT9");
function $f65a05892c928e5e$export$8c948b59812f90e9(props) {
    const $ = (0, $e7boj.c)(8);
    const { queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).PROJECTS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const data = (0, $n67Vb.useFragment)((0, $1FziV.default), queryRef);
    let t0;
    if ($[0] !== sendSectionItemAnalyticsEvent) {
        t0 = (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $6GljB.L1_MENU_ID).PROJECTS,
                sectionItem: (0, $bOwox.SECTION_ITEM_PROJECTS)
            });
        };
        $[0] = sendSectionItemAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const handleExpansionToggle = t0;
    let t1;
    if ($[2] !== data || $[3] !== formattedMessage || $[4] !== handleExpansionToggle || $[5] !== icon || $[6] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f65a05892c928e5e$var$Nav4ProjectsForLandingInner, {
            ...props,
            formattedMessage: formattedMessage,
            handleExpansionToggle: handleExpansionToggle,
            icon: icon,
            menuId: (0, $5IkoH.MENU_ID_PROJECTS),
            queryRef: data
        });
        $[2] = data;
        $[3] = formattedMessage;
        $[4] = handleExpansionToggle;
        $[5] = icon;
        $[6] = props;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
}
$f65a05892c928e5e$export$8c948b59812f90e9.displayName = "Nav4ProjectsForLanding";
const $f65a05892c928e5e$var$Nav4ProjectsForLandingInner = (0, $jepRN.componentWithFG)('navx-global-side-nav', $f65a05892c928e5e$var$Nav4ProjectsForLandingInnerGSN, $f65a05892c928e5e$var$Nav4ProjectsForLandingInnerNav4);
function $f65a05892c928e5e$var$Nav4ProjectsForLandingInnerGSN(props) {
    const $ = (0, $e7boj.c)(30);
    const { actionsOnHover: actionsOnHover, draggableRef: draggableRef, dropIndicator: dropIndicator, formattedMessage: formattedMessage, handleExpansionToggle: handleExpansionToggle, hasDragIndicator: hasDragIndicator, icon: icon, isDragging: isDragging, isExpanded: isExpanded, menuId: menuId, onExpandFlyoutToggle: onExpandFlyoutToggle, queryRef: queryRef, visualContentRef: visualContentRef } = props;
    const onError = (0, $e6pfw.useRequiredErrorAnalytics)();
    let t0;
    if ($[0] !== handleExpansionToggle || $[1] !== onExpandFlyoutToggle) {
        t0 = (hasExpanded)=>{
            handleExpansionToggle(hasExpanded);
            onExpandFlyoutToggle?.(hasExpanded);
        };
        $[0] = handleExpansionToggle;
        $[1] = onExpandFlyoutToggle;
        $[2] = t0;
    } else t0 = $[2];
    const handleExpansionToggle2 = t0;
    let t1;
    if ($[3] !== menuId) {
        t1 = (0, $jzXAj.getTestId)(menuId);
        $[3] = menuId;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== actionsOnHover || $[6] !== draggableRef || $[7] !== formattedMessage || $[8] !== hasDragIndicator || $[9] !== icon || $[10] !== isDragging || $[11] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            hasDragIndicator: hasDragIndicator,
            interactionName: "nav4-sidebar-projects-landing",
            isDragging: isDragging,
            ref: draggableRef,
            testId: t1
        }, formattedMessage);
        $[5] = actionsOnHover;
        $[6] = draggableRef;
        $[7] = formattedMessage;
        $[8] = hasDragIndicator;
        $[9] = icon;
        $[10] = isDragging;
        $[11] = t1;
        $[12] = t2;
    } else t2 = $[12];
    let t3;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a5nxD.JiraHoldoutCustomData), null);
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== onError) {
        t4 = (0, $i860n.fg)("add_analytics_track_event_for_required_error") ? {
            onError: onError
        } : {};
        $[14] = onError;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== queryRef) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fyRT9.Nav4ProjectsContent), {
            queryRef: queryRef
        });
        $[16] = queryRef;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== t4 || $[19] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
            name: "nav4-sidebar-projects-landing"
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            id: "nav4-sidebar-projects-landing",
            packageName: (0, $ed925264ba1585a6$export$b8b9d90f9e5bd72b),
            teamName: (0, $ed925264ba1585a6$export$d57b6b390e78d90f),
            fallback: "flag",
            ...t4
        }, t5)));
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
    } else t6 = $[20];
    let t7;
    if ($[21] !== dropIndicator || $[22] !== handleExpansionToggle2 || $[23] !== isDragging || $[24] !== isExpanded || $[25] !== menuId || $[26] !== t2 || $[27] !== t6 || $[28] !== visualContentRef) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
            dropTargetRef: visualContentRef,
            dropIndicator: dropIndicator,
            isDragging: isDragging,
            isExpanded: isExpanded,
            menuId: menuId,
            onExpansionToggle: handleExpansionToggle2
        }, t2, t6);
        $[21] = dropIndicator;
        $[22] = handleExpansionToggle2;
        $[23] = isDragging;
        $[24] = isExpanded;
        $[25] = menuId;
        $[26] = t2;
        $[27] = t6;
        $[28] = visualContentRef;
        $[29] = t7;
    } else t7 = $[29];
    return t7;
}
$f65a05892c928e5e$var$Nav4ProjectsForLandingInnerGSN.displayName = "Nav4ProjectsForLandingInnerGSN";
function $f65a05892c928e5e$var$Nav4ProjectsForLandingInnerNav4(props) {
    const $ = (0, $e7boj.c)(21);
    const { actionsOnHover: actionsOnHover, formattedMessage: formattedMessage, handleExpansionToggle: handleExpansionToggle, icon: icon, isExpanded: isExpanded, menuId: menuId, queryRef: queryRef } = props;
    const onError = (0, $e6pfw.useRequiredErrorAnalytics)();
    let t0;
    if ($[0] !== menuId) {
        t0 = (0, $jzXAj.getTestId)(menuId);
        $[0] = menuId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== actionsOnHover || $[3] !== formattedMessage || $[4] !== icon || $[5] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            testId: t0,
            interactionName: "nav4-sidebar-projects-landing"
        }, formattedMessage);
        $[2] = actionsOnHover;
        $[3] = formattedMessage;
        $[4] = icon;
        $[5] = t0;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a5nxD.JiraHoldoutCustomData), null);
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== onError) {
        t3 = (0, $i860n.fg)("add_analytics_track_event_for_required_error") ? {
            onError: onError
        } : {};
        $[8] = onError;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== queryRef) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fyRT9.Nav4ProjectsContent), {
            queryRef: queryRef
        });
        $[10] = queryRef;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== t3 || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
            name: "nav4-sidebar-projects-landing"
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            id: "nav4-sidebar-projects-landing",
            packageName: (0, $ed925264ba1585a6$export$b8b9d90f9e5bd72b),
            teamName: (0, $ed925264ba1585a6$export$d57b6b390e78d90f),
            fallback: "flag",
            ...t3
        }, t4)));
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== handleExpansionToggle || $[16] !== isExpanded || $[17] !== menuId || $[18] !== t1 || $[19] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
            isExpanded: isExpanded,
            menuId: menuId,
            onExpansionToggle: handleExpansionToggle
        }, t1, t5);
        $[15] = handleExpansionToggle;
        $[16] = isExpanded;
        $[17] = menuId;
        $[18] = t1;
        $[19] = t5;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
}
$f65a05892c928e5e$var$Nav4ProjectsForLandingInnerNav4.displayName = "Nav4ProjectsForLandingInnerNav4";

});
parcelRegister("1FziV", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fb40f684bef2e65$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<89864ae43f4f70b66a76924bb90a35a5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1fb40f684bef2e65$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4ProjectsForLanding",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "currentURL",
                    "variableName": "currentURL"
                }
            ],
            "kind": "FragmentSpread",
            "name": "Nav4ProjectsContent"
        }
    ],
    "type": "Query"
};
$1fb40f684bef2e65$var$node.hash = "a133f4f2dee068a96d8b17f4cc9743e5";
var $1fb40f684bef2e65$export$2e2bcd8739ae039 = $1fb40f684bef2e65$var$node;

});

parcelRegister("e6pfw", function(module, exports) {
$parcel$export(module.exports, "useRequiredErrorAnalytics", () => $a50831d92fc5801c$export$432bf775a9d73adf);

var $e7boj = parcelRequire("e7boj");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
// The Relay `@required` failure in `Nav4ProjectsContent` reports far more terminal errors than
// matching UFO experience failures, creating an attribution blindspot. Fire a dedicated track
// event when the boundary catches it so the affected sessions can be traced in Amplitude via
// session replays. See go/terminal-errors-investigation for context.
const $a50831d92fc5801c$var$isMissingRequiredValueError = (error)=>error.message.includes("Missing @required value at path 'jira_projectsSidebarMenu'");
const $a50831d92fc5801c$export$432bf775a9d73adf = ()=>{
    const $ = (0, $e7boj.c)(2);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (location, error, attributes)=>{
            if (!$a50831d92fc5801c$var$isMissingRequiredValueError(error)) return;
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), "sidebarProjects missingRequiredValueErrorCaught", {
                location: location,
                errorName: error.name,
                errorMessage: error.message,
                errorHash: attributes.hash ?? null
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};

});

parcelRegister("fyRT9", function(module, exports) {
$parcel$export(module.exports, "Nav4ProjectsContent", () => $9d8b66c062a9fb6b$export$74ce18a8a4837259);

var $e7boj = parcelRequire("e7boj");

var $jEDne = parcelRequire("jEDne");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $g1b31 = parcelRequire("g1b31");

var $8ROIL = parcelRequire("8ROIL");

var $ekhRy = parcelRequire("ekhRy");

var $5IkoH = parcelRequire("5IkoH");

var $19zz3 = parcelRequire("19zz3");

var $hL4Cp = parcelRequire("hL4Cp");

var $700A6 = parcelRequire("700A6");

var $9AhSr = parcelRequire("9AhSr");

var $gLXQg = parcelRequire("gLXQg");

var $fibcG = parcelRequire("fibcG");

var $9imxF = parcelRequire("9imxF");

var $kt86l = parcelRequire("kt86l");

var $9cGgF = parcelRequire("9cGgF");

var $9BXzG = parcelRequire("9BXzG");

var $iGqlP = parcelRequire("iGqlP");

var $aWtym = parcelRequire("aWtym");

var $gfpqC = parcelRequire("gfpqC");
function $9d8b66c062a9fb6b$var$Nav4ProjectsContentInternal(t0) {
    const $ = (0, $e7boj.c)(79);
    const { queryRef: queryRef } = t0;
    const cloudId = (0, $kt86l.useCloudId)();
    const { getStableItems: getStableItems } = (0, $gLXQg.useStableItems)();
    const { isSelectedPath: isSelectedPath } = (0, $19zz3.useSidebarNav4)();
    const [projectToRestore, setProjectToRestore] = (0, $euxye.useState)(null);
    const { sendProjectMenuContentAnalyticsEvent: sendProjectMenuContentAnalyticsEvent } = (0, $ekhRy.useProjectsAnalyticsL1)();
    let t1;
    let t2;
    if ($[0] !== sendProjectMenuContentAnalyticsEvent) {
        t1 = ()=>{
            sendProjectMenuContentAnalyticsEvent();
        };
        t2 = [
            sendProjectMenuContentAnalyticsEvent
        ];
        $[0] = sendProjectMenuContentAnalyticsEvent;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $euxye.useEffect)(t1, t2);
    const data = (0, $n67Vb.useRefetchableFragment)((0, $jEDne.default), queryRef);
    const [t3, refetch] = data;
    const { jira: jira, jira_projectsSidebarMenu: projectsSidebarMenu } = t3;
    const { jwmLicensing: jwmLicensing, canCreateProject: canCreateProject } = jira;
    const favouriteLimit = projectsSidebarMenu?.favouriteLimit;
    const recentLimit = projectsSidebarMenu?.recentLimit;
    const favouriteProjects = projectsSidebarMenu?.favourites;
    const recentProjects = projectsSidebarMenu?.recents;
    if (!favouriteProjects || !recentProjects) throw new Error("JiraProjectConnection is missing in Nav4ProjectsContent for favourite or recent projects");
    const mostRecentProject = projectsSidebarMenu?.mostRecent;
    const mostRecentFromHistory = projectsSidebarMenu?.mostRecentFromHistory;
    const displayMode = projectsSidebarMenu?.displayMode;
    let t4;
    if ($[3] !== isSelectedPath || $[4] !== mostRecentFromHistory) {
        t4 = mostRecentFromHistory && isSelectedPath((0, $5IkoH.ENTITY_ID).PROJECT(mostRecentFromHistory.projectKey));
        $[3] = isSelectedPath;
        $[4] = mostRecentFromHistory;
        $[5] = t4;
    } else t4 = $[5];
    const isMostRecentFromHistorySelected = t4;
    let t5;
    if ($[6] !== cloudId) {
        t5 = {
            cloudId: cloudId
        };
        $[6] = cloudId;
        $[7] = t5;
    } else t5 = $[7];
    const queryVariables = t5;
    let t6;
    if ($[8] !== cloudId || $[9] !== isSelectedPath || $[10] !== queryVariables || $[11] !== refetch) {
        t6 = {
            cloudId: cloudId,
            isSelectedPath: isSelectedPath,
            QUERY: $aWtym.default,
            refetch: refetch,
            menuId: (0, $5IkoH.MENU_ID_PROJECTS),
            queryVariables: queryVariables
        };
        $[8] = cloudId;
        $[9] = isSelectedPath;
        $[10] = queryVariables;
        $[11] = refetch;
        $[12] = t6;
    } else t6 = $[12];
    (0, $g1b31.useRefetchWhenIsSelected)(t6);
    let t7;
    if ($[13] !== queryVariables || $[14] !== refetch) {
        t7 = (t8)=>{
            const { onComplete: onComplete } = t8;
            refetch(queryVariables, {
                fetchPolicy: "store-and-network",
                onComplete: onComplete
            });
        };
        $[13] = queryVariables;
        $[14] = refetch;
        $[15] = t7;
    } else t7 = $[15];
    const refetchOnChange = t7;
    let t8;
    if ($[16] !== favouriteProjects.__id || $[17] !== recentProjects.__id || $[18] !== refetchOnChange) {
        t8 = {
            entityTypename: "JiraProject",
            favouriteConnectionId: favouriteProjects.__id,
            recentConnectionId: recentProjects.__id,
            refetch: refetchOnChange
        };
        $[16] = favouriteProjects.__id;
        $[17] = recentProjects.__id;
        $[18] = refetchOnChange;
        $[19] = t8;
    } else t8 = $[19];
    (0, $9AhSr.useSubscribeAndUpdateFavorites)(t8);
    (0, $700A6.useSyncChangeFavourites)();
    let hasNextPage;
    let list;
    let t10;
    let t9;
    if ($[20] !== displayMode || $[21] !== favouriteLimit || $[22] !== favouriteProjects.edges || $[23] !== favouriteProjects.pageInfo?.hasNextPage || $[24] !== isMostRecentFromHistorySelected || $[25] !== jwmLicensing?.currentUserSeatEdition || $[26] !== mostRecentFromHistory) {
        const favoritesList = favouriteProjects.edges?.filter(Boolean).map($9d8b66c062a9fb6b$var$_temp) ?? [];
        let t11;
        if ($[31] !== mostRecentFromHistory?.id) {
            t11 = (project)=>project.id === mostRecentFromHistory?.id;
            $[31] = mostRecentFromHistory?.id;
            $[32] = t11;
        } else t11 = $[32];
        const isMostRecentFromHistoryInFavoritesList = favoritesList.some(t11);
        const shouldShowStarredSection = displayMode === (0, $hL4Cp.ViewOptions).STARRED_AND_RECENT || displayMode === (0, $hL4Cp.ViewOptions).STARRED;
        const shouldAddMostRecentFromHistoryToFavouritesList = mostRecentFromHistory && mostRecentFromHistory.isFavourite && shouldShowStarredSection && isMostRecentFromHistorySelected && favoritesList.length > 0 && !isMostRecentFromHistoryInFavoritesList;
        if (shouldAddMostRecentFromHistoryToFavouritesList) {
            favoritesList.pop();
            favoritesList.push(mostRecentFromHistory);
        }
        const ids = favoritesList.map($9d8b66c062a9fb6b$var$_temp2).filter(Boolean) ?? [];
        list = favoritesList.map((project_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iGqlP.Nav4ProjectMenuItem), {
                key: project_1.projectKey,
                queryRef: project_1,
                isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === "PREMIUM",
                setProjectToRestore: setProjectToRestore
            })) ?? [];
        hasNextPage = favouriteProjects.pageInfo?.hasNextPage || (favouriteLimit ? list.length > favouriteLimit : false);
        t9 = new Set(ids);
        t10 = list.slice(0, favouriteLimit ?? Infinity);
        $[20] = displayMode;
        $[21] = favouriteLimit;
        $[22] = favouriteProjects.edges;
        $[23] = favouriteProjects.pageInfo?.hasNextPage;
        $[24] = isMostRecentFromHistorySelected;
        $[25] = jwmLicensing?.currentUserSeatEdition;
        $[26] = mostRecentFromHistory;
        $[27] = hasNextPage;
        $[28] = list;
        $[29] = t10;
        $[30] = t9;
    } else {
        hasNextPage = $[27];
        list = $[28];
        t10 = $[29];
        t9 = $[30];
    }
    const t11 = Boolean(list.length);
    let t12;
    if ($[33] !== hasNextPage || $[34] !== t10 || $[35] !== t11 || $[36] !== t9) {
        t12 = {
            idSet: t9,
            list: t10,
            hasItems: t11,
            hasNextPage: hasNextPage
        };
        $[33] = hasNextPage;
        $[34] = t10;
        $[35] = t11;
        $[36] = t9;
        $[37] = t12;
    } else t12 = $[37];
    const favorites = t12;
    let t13;
    if ($[38] !== displayMode || $[39] !== favorites.idSet || $[40] !== getStableItems || $[41] !== isMostRecentFromHistorySelected || $[42] !== jwmLicensing?.currentUserSeatEdition || $[43] !== mostRecentFromHistory || $[44] !== recentLimit || $[45] !== recentProjects.edges) {
        t13 = ()=>{
            const isStarredOnlyMode = displayMode === (0, $hL4Cp.ViewOptions).STARRED;
            const shouldAddMostRecentFromHistoryToRecentList = mostRecentFromHistory && !mostRecentFromHistory.isFavourite && isStarredOnlyMode && isMostRecentFromHistorySelected && (recentProjects.edges?.length ?? 0) === 0;
            const nodes = shouldAddMostRecentFromHistoryToRecentList ? [
                mostRecentFromHistory
            ] : recentProjects.edges?.filter(Boolean).filter((edge_0)=>edge_0.node.id && !favorites.idSet.has(edge_0.node.id)).map($9d8b66c062a9fb6b$var$_temp3).slice(0, recentLimit ?? Infinity) ?? [];
            const stableOrderedNodes = getStableItems({
                nodes: nodes,
                idKey: "id"
            });
            const list_0 = stableOrderedNodes.map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iGqlP.Nav4ProjectMenuItem), {
                    key: node.projectKey,
                    queryRef: node,
                    isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === "PREMIUM",
                    setProjectToRestore: setProjectToRestore
                }));
            return {
                list: list_0,
                hasItems: Boolean(list_0.length)
            };
        };
        $[38] = displayMode;
        $[39] = favorites.idSet;
        $[40] = getStableItems;
        $[41] = isMostRecentFromHistorySelected;
        $[42] = jwmLicensing?.currentUserSeatEdition;
        $[43] = mostRecentFromHistory;
        $[44] = recentLimit;
        $[45] = recentProjects.edges;
        $[46] = t13;
    } else t13 = $[46];
    jwmLicensing?.currentUserSeatEdition;
    let t14;
    if ($[47] !== t13) {
        t14 = t13();
        $[47] = t13;
        $[48] = t14;
    } else t14 = $[48];
    const recentItems = t14;
    jwmLicensing?.currentUserSeatEdition;
    let t15;
    if ($[49] !== jwmLicensing?.currentUserSeatEdition || $[50] !== mostRecentProject) {
        t15 = mostRecentProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iGqlP.Nav4ProjectMenuItem), {
            key: mostRecentProject.projectKey,
            queryRef: mostRecentProject,
            isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === "PREMIUM",
            setProjectToRestore: setProjectToRestore
        }) : null;
        $[49] = jwmLicensing?.currentUserSeatEdition;
        $[50] = mostRecentProject;
        $[51] = t15;
    } else t15 = $[51];
    const mostRecentProjectItem = t15;
    let t16;
    if ($[52] !== projectToRestore || $[53] !== queryVariables || $[54] !== refetch) {
        t16 = ()=>{
            if (projectToRestore) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9imxF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fibcG.default), {
                ...projectToRestore,
                onProjectRestoreSuccess: ()=>{
                    setProjectToRestore(null);
                    refetch(queryVariables, {
                        fetchPolicy: "store-and-network"
                    });
                },
                onProjectRestoreFailure: ()=>{
                    setProjectToRestore(null);
                },
                onClose: ()=>setProjectToRestore(null)
            }));
        };
        $[52] = projectToRestore;
        $[53] = queryVariables;
        $[54] = refetch;
        $[55] = t16;
    } else t16 = $[55];
    const restoreProjectModal = t16;
    if (!favorites.hasItems && !recentItems.hasItems && !mostRecentProject) {
        let t17;
        if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
            t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9cGgF.Nav4ProjectsEmptyContent), null);
            $[56] = t17;
        } else t17 = $[56];
        let t18;
        if ($[57] !== restoreProjectModal) {
            t18 = restoreProjectModal();
            $[57] = restoreProjectModal;
            $[58] = t18;
        } else t18 = $[58];
        let t19;
        if ($[59] !== canCreateProject) {
            t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9BXzG.Footer), {
                canCreateProject: canCreateProject
            });
            $[59] = canCreateProject;
            $[60] = t19;
        } else t19 = $[60];
        let t20;
        if ($[61] !== t18 || $[62] !== t19) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, t17, t18, t19);
            $[61] = t18;
            $[62] = t19;
            $[63] = t20;
        } else t20 = $[63];
        return t20;
    }
    const t17 = favouriteProjects.__id;
    const t18 = recentProjects.__id;
    let t19;
    if ($[64] !== canCreateProject || $[65] !== favorites || $[66] !== mostRecentProjectItem || $[67] !== recentItems) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gfpqC.Nav4ProjectsSections), {
            favoriteItems: favorites,
            recentItems: recentItems,
            mostRecentProjectItem: mostRecentProjectItem,
            canCreateProject: canCreateProject
        });
        $[64] = canCreateProject;
        $[65] = favorites;
        $[66] = mostRecentProjectItem;
        $[67] = recentItems;
        $[68] = t19;
    } else t19 = $[68];
    let t20;
    if ($[69] !== restoreProjectModal) {
        t20 = restoreProjectModal();
        $[69] = restoreProjectModal;
        $[70] = t20;
    } else t20 = $[70];
    let t21;
    if ($[71] !== canCreateProject) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9BXzG.Footer), {
            canCreateProject: canCreateProject
        });
        $[71] = canCreateProject;
        $[72] = t21;
    } else t21 = $[72];
    let t22;
    if ($[73] !== favouriteProjects.__id || $[74] !== recentProjects.__id || $[75] !== t19 || $[76] !== t20 || $[77] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8ROIL.UpdateProjectsProvider), {
            favouriteConnectionId: t17,
            recentConnectionId: t18
        }, t19, t20, t21);
        $[73] = favouriteProjects.__id;
        $[74] = recentProjects.__id;
        $[75] = t19;
        $[76] = t20;
        $[77] = t21;
        $[78] = t22;
    } else t22 = $[78];
    return t22;
}
$9d8b66c062a9fb6b$var$Nav4ProjectsContentInternal.displayName = "Nav4ProjectsContentInternal";
function $9d8b66c062a9fb6b$var$_temp3(edge_1) {
    return edge_1.node;
}
function $9d8b66c062a9fb6b$var$_temp2(project_0) {
    return project_0.id;
}
function $9d8b66c062a9fb6b$var$_temp(edge) {
    return edge.node;
}
const $9d8b66c062a9fb6b$export$74ce18a8a4837259 = /*#__PURE__*/ (0, $euxye.memo)($9d8b66c062a9fb6b$var$Nav4ProjectsContentInternal);

});
parcelRegister("jEDne", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a7b82c077a831f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfab35a67434e51f7e691672cbdf532c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $aWtym = parcelRequire("aWtym");
const $6a7b82c077a831f8$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "RequiredField",
        "field": {
            "kind": "ScalarField",
            "name": "id"
        },
        "action": "THROW"
    }, v2 = {
        "kind": "RequiredField",
        "field": {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        },
        "action": "THROW"
    }, v3 = {
        "kind": "FragmentSpread",
        "name": "Nav4ProjectMenuItem"
    }, v4 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ 
    ], v5 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": v4 /*: any*/ 
                },
                "action": "THROW"
            }
        ]
    }, v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $aWtym.default)
            }
        },
        "name": "Nav4ProjectsContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "args": [
                                v0 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        v0 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "currentURL",
                            "variableName": "currentURL"
                        }
                    ],
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "mostRecent",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "mostRecentFromHistory",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ 
                                ],
                                "storageKey": "favourites(first:15)"
                            },
                            "action": "THROW"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    }
                                ],
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "recents",
                                "plural": false,
                                "selections": [
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ 
                                ],
                                "storageKey": "recents(first:20)"
                            },
                            "action": "THROW"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "favouriteLimit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "recentLimit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "displayMode"
                        }
                    ]
                },
                "action": "THROW"
            }
        ],
        "type": "Query"
    };
}();
$6a7b82c077a831f8$var$node.hash = "a836bf506bd69077713668e8d8cbc27c";
var $6a7b82c077a831f8$export$2e2bcd8739ae039 = $6a7b82c077a831f8$var$node;

});
parcelRegister("aWtym", function(module, exports) {
$parcel$export(module.exports, "default", () => $82f3895f88b15bc7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0ac82655a6f3175c44682ee2ea827a61>>
 * @relayHash 2ef67b721c25f3b2813599bd4bdb1834
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6c5846937fa7535a8251f300e408c0eb5ddca85c8b79a19c1f9939ca5b466521

var $25bhx = parcelRequire("25bhx");

var $fpAD9 = parcelRequire("fpAD9");
const $82f3895f88b15bc7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "currentURL"
    }, v2 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v8 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v12 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v4 /*: any*/ 
                ],
                "type": "Node",
                "abstractKey": "__isNode"
            }
        ]
    }, v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v15 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v16 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v17 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "alias": "subspaceCount",
                        "kind": "ScalarField",
                        "name": "subspaceCount_cse"
                    }
                ]
            }
        ]
    }, v18 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        v17 /*: any*/ 
    ], v19 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v18 /*: any*/ 
            }
        ]
    }, v20 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4ProjectsContentQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "Nav4ProjectsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx"
                }
            ],
            "kind": "Operation",
            "name": "Nav4ProjectsContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "args": [
                                v3 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": [
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ],
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "mostRecent",
                            "plural": false,
                            "selections": v18 /*: any*/ 
                        },
                        {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "mostRecentFromHistory",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v11 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                v19 /*: any*/ ,
                                v20 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "recents",
                            "plural": false,
                            "selections": [
                                v19 /*: any*/ ,
                                v20 /*: any*/ 
                            ],
                            "storageKey": "recents(first:20)"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "favouriteLimit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "recentLimit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "displayMode"
                        },
                        v4 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "6c5846937fa7535a8251f300e408c0eb5ddca85c8b79a19c1f9939ca5b466521",
            "metadata": {},
            "name": "Nav4ProjectsContentQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": (0, $fpAD9.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx": (0, $25bhx.default)
            }
        }
    };
}();
$82f3895f88b15bc7$var$node.hash = "a836bf506bd69077713668e8d8cbc27c";
var $82f3895f88b15bc7$export$2e2bcd8739ae039 = $82f3895f88b15bc7$var$node;

});


parcelRegister("8ROIL", function(module, exports) {
$parcel$export(module.exports, "UpdateProjectsProvider", () => $cc64571f0f4d3808$export$a50917f7cd2aeeda);
$parcel$export(module.exports, "useUpdateProjectsInRelayStoreContext", () => $cc64571f0f4d3808$export$5105901d98bfdbf1);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");
const $cc64571f0f4d3808$var$UpdateProjectsContext = /*#__PURE__*/ (0, $euxye.createContext)(null);
const $cc64571f0f4d3808$export$c80374615e2c5b2 = ({ environment: environment, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId })=>{
    const removeProjectRecord = (projectDataId)=>{
        (0, $n67Vb.commitLocalUpdate)(environment, (store)=>{
            const favorites = store.get(favouriteConnectionId);
            const recents = store.get(recentConnectionId);
            if (favorites && projectDataId) (0, $n67Vb.ConnectionHandler).deleteNode(favorites, projectDataId);
            if (recents && projectDataId) (0, $n67Vb.ConnectionHandler).deleteNode(recents, projectDataId);
        });
    };
    const archiveProject = (projectDataId)=>{
        (0, $n67Vb.commitLocalUpdate)(environment, (store)=>{
            store.get(projectDataId)?.setValue('ARCHIVED', 'status');
        });
    };
    return {
        deleteProject: removeProjectRecord,
        archiveProject: archiveProject
    };
};
const $cc64571f0f4d3808$export$a50917f7cd2aeeda = ({ children: children, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId })=>{
    const environment = (0, $n67Vb.useRelayEnvironment)();
    const updateRelayStore = $cc64571f0f4d3808$export$c80374615e2c5b2({
        environment: environment,
        favouriteConnectionId: favouriteConnectionId,
        recentConnectionId: recentConnectionId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($cc64571f0f4d3808$var$UpdateProjectsContext.Provider, {
        value: updateRelayStore
    }, children);
};
$cc64571f0f4d3808$export$a50917f7cd2aeeda.displayName = "UpdateProjectsProvider";
const $cc64571f0f4d3808$export$5105901d98bfdbf1 = ()=>(0, $euxye.useContext)($cc64571f0f4d3808$var$UpdateProjectsContext);

});

parcelRegister("700A6", function(module, exports) {
$parcel$export(module.exports, "useSyncChangeFavourites", () => $73d11c1e0cdcb47b$export$5f8a0bc021135735);

var $cCwdh = parcelRequire("cCwdh");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $7V240 = parcelRequire("7V240");

var $i8BNs = parcelRequire("i8BNs");

var $2700E = parcelRequire("2700E");

var $kt86l = parcelRequire("kt86l");
function $73d11c1e0cdcb47b$export$5f8a0bc021135735() {
    const cloudId = (0, $kt86l.useCloudId)();
    const [commitMutation] = (0, $n67Vb.useMutation)((0, $cCwdh.default));
    const moveFavouriteToTop = (0, $euxye.useCallback)((payload)=>{
        // Prevent optimistic updates from triggering setting custom order
        if (payload.type === 'MUTATION' && payload.isOptimistic) return;
        if (payload.isFavourite && ((0, $2700E.expVal)('fix_error_when_starring_project_from_jfy_page', 'isEnabled', false) ? (0, $i8BNs.JiraProjectAri).check(payload.entityId) : true)) {
            const itemId = (0, $i8BNs.JiraProjectAri).parse(payload.entityId).projectId;
            commitMutation({
                variables: {
                    input: {
                        cloudId: cloudId,
                        reorderMode: 'MOVE_TO_TOP',
                        menuItem: {
                            itemId: // eslint-disable-next-line jira/relay/mutation-variables-from-relay-data
                            itemId
                        }
                    }
                }
            });
        }
    }, [
        cloudId,
        commitMutation
    ]);
    (0, $7V240.useSubscribeToFavorite)('JiraProject', moveFavouriteToTop);
}

});
parcelRegister("cCwdh", function(module, exports) {
$parcel$export(module.exports, "default", () => $28ba35e914f8e846$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a05f07f94dfc3c93ddeccb318761260d>>
 * @relayHash b6c6e5fcf34b29914e3ffee7bfac0a54
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 91d0f45308135901c28f5eda9ddcf6e8811cac2307a2de1996de6218025f4f2d

var $25bhx = parcelRequire("25bhx");

var $fpAD9 = parcelRequire("fpAD9");
const $28ba35e914f8e846$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 15
        }
    ], v4 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v5 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSyncChangeFavouritesMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "Nav4ProjectMenuItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx"
                }
            ],
            "kind": "Operation",
            "name": "useSyncChangeFavouritesMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "large"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "defaultNavigationItem",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "url"
                                                                }
                                                            ],
                                                            "type": "JiraNavigationItem",
                                                            "abstractKey": "__isJiraNavigationItem"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v2 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "softwareBoardCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "alias": "subspaceCount",
                                                                    "kind": "ScalarField",
                                                                    "name": "subspaceCount_cse"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "91d0f45308135901c28f5eda9ddcf6e8811cac2307a2de1996de6218025f4f2d",
            "metadata": {},
            "name": "useSyncChangeFavouritesMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": (0, $fpAD9.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx": (0, $25bhx.default)
            }
        }
    };
}();
$28ba35e914f8e846$var$node.hash = "0bc215ec8f9afc0553a13bec6bde53dd";
var $28ba35e914f8e846$export$2e2bcd8739ae039 = $28ba35e914f8e846$var$node;

});


parcelRegister("fibcG", function(module, exports) {
$parcel$export(module.exports, "default", () => $06caf25898acb8f6$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $f99M0 = parcelRequire("f99M0");

var $b39hj = parcelRequire("b39hj");

var $k6sZT = parcelRequire("k6sZT");

var $inMxE = parcelRequire("inMxE");

var $4qNCE = parcelRequire("4qNCE");

var $1D4ep = parcelRequire("1D4ep");

var $2v3yi = parcelRequire("2v3yi");

var $4vluQ = parcelRequire("4vluQ");

var $gpyJM = parcelRequire("gpyJM");

var $dNPnD = parcelRequire("dNPnD");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");

var $5Ez9w = parcelRequire("5Ez9w");

var $1jztF = parcelRequire("1jztF");

var $aZMdt = parcelRequire("aZMdt");
var $aqPkH = parcelRequire("aqPkH");
var $aJ81Y = parcelRequire("aJ81Y");

var $6l0WL = parcelRequire("6l0WL");

var $5bTfl = parcelRequire("5bTfl");

var $6T7am = parcelRequire("6T7am");
const $06caf25898acb8f6$var$modalHeader = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.modal-header",
    defaultMessage: "Restore project?"
});
const $06caf25898acb8f6$var$jsmModalHeader = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.jsm-modal-header",
    defaultMessage: "Restore this service project?"
});
const $06caf25898acb8f6$var$confirmRestoreButton = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.confirm-restore-button",
    defaultMessage: "Restore"
});
const $06caf25898acb8f6$var$cancelRestoreButton = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.cancel-restore-button",
    defaultMessage: "Cancel"
});
const $06caf25898acb8f6$var$restoreSuccessMessageTitle = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.restore-success-message-title",
    defaultMessage: "Project successfully restored"
});
const $06caf25898acb8f6$var$restoreServiceDeskSuccessMessageTitle = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.restore-service-desk-success-message-title",
    defaultMessage: "Service project restored"
});
const $06caf25898acb8f6$var$restoreServiceDeskSuccessMessageContent = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.restore-service-desk-success-message-content",
    defaultMessage: "You may need to turn on email support for your service project to work as normal."
});
const $06caf25898acb8f6$var$restoreServiceDeskSuccessMessageActionEmailSettings = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.restore-service-desk-success-message-action-email-settings",
    defaultMessage: "Go to email settings"
});
const $06caf25898acb8f6$var$restoreErrorMessageTitle = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.restore-error-message-title",
    defaultMessage: "Something went wrong"
});
const $06caf25898acb8f6$var$restoreErrorMessageDescription = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.restore-error-message-description",
    defaultMessage: "We couldn\u2019t restore the \u201C{projectName}\u201D project. Try again."
});
const $06caf25898acb8f6$var$restoreErrorMessageDescriptionRenderError = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.restore-error-message-description-render-error",
    defaultMessage: "We couldn\u2019t restore the \u201C{projectName}\u201D project.{br}{error}"
});
const $06caf25898acb8f6$var$restoreSuccessMessageTitleGalaxia = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.restore-success-message-title-galaxia",
    defaultMessage: "Space successfully restored"
});
const $06caf25898acb8f6$var$restoreServiceDeskSuccessMessageTitleGalaxia = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.restore-service-desk-success-message-title-galaxia",
    defaultMessage: "Service space restored"
});
const $06caf25898acb8f6$var$restoreServiceDeskSuccessMessageContentGalaxia = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.restore-service-desk-success-message-content-galaxia",
    defaultMessage: "You may need to turn on email support for your service space to work as normal."
});
const $06caf25898acb8f6$var$restoreErrorMessageDescriptionGalaxia = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.restore-error-message-description-galaxia",
    defaultMessage: "We couldn\u2019t restore the \u201C{projectName}\u201D space. Try again."
});
const $06caf25898acb8f6$var$restoreErrorMessageDescriptionRenderErrorGalaxia = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.restore-error-message-description-render-error-galaxia",
    defaultMessage: "We couldn\u2019t restore the \u201C{projectName}\u201D space.{br}{error}"
});
const $06caf25898acb8f6$var$modalHeaderGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.modal-header-galaxia",
    defaultMessage: "Restore space?"
});
const $06caf25898acb8f6$var$jsmModalHeaderGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.jsm-modal-header-galaxia",
    defaultMessage: "Restore this service space?"
});
const $06caf25898acb8f6$export$a43ae427db1e9df7 = 'restore-from-trash';
const $06caf25898acb8f6$export$ec2a19e79c04c9d2 = 'restore-from-archive';
const $06caf25898acb8f6$export$cee26a329c363b31 = (props)=>{
    const jsmModalHeaderGalaxia = (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $06caf25898acb8f6$var$jsmModalHeaderGalaxiaMessage : $06caf25898acb8f6$var$jsmModalHeader;
    const modalHeaderGalaxia = (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $06caf25898acb8f6$var$modalHeaderGalaxiaMessage : $06caf25898acb8f6$var$modalHeader;
    const { isProjectSimplified: isProjectSimplified, projectType: projectType, projectName: projectName, projectId: projectId, projectKey: projectKey, projectInactiveDate: projectInactiveDate, intl: { formatMessage: formatMessage }, onClose: onClose, onProjectRestoreSuccess: onProjectRestoreSuccess, onProjectRestoreFailure: onProjectRestoreFailure, flagService: { showFlag: showFlag } } = props;
    const [isRestoring, restoreProject] = (0, $6l0WL.useProjectRestoreService)({
        projectId: projectId
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const attributes = {
        projectType: projectType,
        isProjectSimplified: isProjectSimplified
    };
    const onSuccess = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'restored'
        });
        (0, $aJ81Y.fireTrackAnalytics)(analyticsEvent, 'project restored', projectId.toString(), {
            ...attributes,
            durationInTrash: projectInactiveDate ? (0, $6T7am.getDurationInTrash)(projectInactiveDate) : undefined
        });
        onProjectRestoreSuccess();
        if (projectType === (0, $f99M0.SERVICE_DESK_PROJECT)) showFlag({
            messageId: 'project-restore-modal.ui.show-flag.success.restore-service-desk-success',
            messageType: 'transactional',
            type: 'success',
            title: (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $06caf25898acb8f6$var$restoreServiceDeskSuccessMessageTitleGalaxia : $06caf25898acb8f6$var$restoreServiceDeskSuccessMessageTitle,
            description: (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $06caf25898acb8f6$var$restoreServiceDeskSuccessMessageContentGalaxia : $06caf25898acb8f6$var$restoreServiceDeskSuccessMessageContent,
            testId: 'project-restore-modal.ui.flags.success-flag',
            actions: [
                {
                    content: $06caf25898acb8f6$var$restoreServiceDeskSuccessMessageActionEmailSettings,
                    href: `/jira/servicedesk/projects/${projectKey}/settings/email`
                }
            ]
        });
        else showFlag({
            messageId: 'project-restore-modal.ui.show-flag.success.restore-success',
            messageType: 'transactional',
            type: 'success',
            title: (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $06caf25898acb8f6$var$restoreSuccessMessageTitleGalaxia : $06caf25898acb8f6$var$restoreSuccessMessageTitle,
            testId: 'project-restore-modal.ui.flags.success-flag'
        });
    };
    const onFailure = (error)=>{
        onProjectRestoreFailure(error);
        if (// oxlint-disable-next-line typescript/consistent-type-assertions
        error.statusCode?.toString().startsWith('4') && error.message) showFlag({
            messageId: 'project-restore-modal.ui.show-flag.error.restore-error',
            messageType: 'transactional',
            type: 'error',
            title: [
                $06caf25898acb8f6$var$restoreErrorMessageTitle,
                {
                    projectName: projectName
                }
            ],
            description: [
                (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $06caf25898acb8f6$var$restoreErrorMessageDescriptionRenderErrorGalaxia : $06caf25898acb8f6$var$restoreErrorMessageDescriptionRenderError,
                {
                    projectName: projectName,
                    error: error.message,
                    br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("br", null)
                }
            ],
            testId: 'project-restore-modal.ui.flags.failure-flag'
        });
        else showFlag({
            messageId: 'project-restore-modal.ui.show-flag.error.restore-error.1',
            messageType: 'transactional',
            type: 'error',
            title: [
                $06caf25898acb8f6$var$restoreErrorMessageTitle,
                {
                    projectName: projectName
                }
            ],
            description: [
                (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $06caf25898acb8f6$var$restoreErrorMessageDescriptionGalaxia : $06caf25898acb8f6$var$restoreErrorMessageDescription,
                {
                    projectName: projectName
                }
            ],
            testId: 'project-restore-modal.ui.flags.failure-flag'
        });
    };
    const onRestore = (e, analyticsEvent)=>{
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'restoreProjectButton');
        restoreProject({
            onSuccess: onSuccess,
            onFailure: onFailure
        });
    };
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // oxlint-disable-next-line react/no-unstable-nested-components
    const ModalDialogDescription = ()=>// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5bTfl.ModalMessageContent), {
            projectType: projectType
        }));
    const onCancelOrNoop = !isRestoring ? onClose : (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceName: "restoreProject",
        sourceType: (0, $46f069e6c968f461$export$1171103ea9083ffa),
        attributes: attributes,
        containerId: `${projectId}`,
        containerType: "project"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k6sZT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b39hj.ModalDialog), {
        messageId: "project-restore-modal.ui.modal-dialog",
        messageType: "transactional",
        onClose: onCancelOrNoop,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gpyJM.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dNPnD.default), null, formatMessage(projectType === (0, $f99M0.SERVICE_DESK_PROJECT) ? jsmModalHeaderGalaxia : modalHeaderGalaxia, {
        projectName: projectName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v3yi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ModalDialogDescription, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4vluQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
        appearance: "subtle-link",
        onClick: onCancelOrNoop,
        isDisabled: isRestoring,
        testId: "project-restore-modal.ui.close-button-wrapper"
    }, formatMessage($06caf25898acb8f6$var$cancelRestoreButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1D4ep.default), {
        appearance: "primary",
        onClick: onRestore,
        isDisabled: isRestoring,
        isLoading: isRestoring,
        testId: "project-restore-modal.ui.restore-button-wrapper"
    }, formatMessage($06caf25898acb8f6$var$confirmRestoreButton))))));
};
$06caf25898acb8f6$export$cee26a329c363b31.displayName = "ProjectRestoreModal";
const $06caf25898acb8f6$export$9c21a3269931e1e6 = {
    isRestoring: false,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
};
const $06caf25898acb8f6$var$ExportedComponent = (0, $1jztF.default)((0, $5Ez9w.default)($06caf25898acb8f6$export$cee26a329c363b31));
var $06caf25898acb8f6$export$2e2bcd8739ae039 = $06caf25898acb8f6$var$ExportedComponent;

});
parcelRegister("5Ez9w", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bc509c365d32782$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $iQPOZ = parcelRequire("iQPOZ");
/**
 * The types for this aren't quite right - use with caution.
 * @deprecated Use `useFlagService` instead. HOCs are deprecated.
 */ const $7bc509c365d32782$var$withFlagService = (WrappedComponent)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $iQPOZ.flagService)
        });
var $7bc509c365d32782$export$2e2bcd8739ae039 = $7bc509c365d32782$var$withFlagService;

});

parcelRegister("6l0WL", function(module, exports) {
$parcel$export(module.exports, "useProjectRestoreService", () => $ba97d72581b72b16$export$3726936b35df382d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $4DNj5 = parcelRequire("4DNj5");
const $ba97d72581b72b16$export$3726936b35df382d = ({ projectId: projectId })=>{
    const [loading, setLoading] = (0, $euxye.useState)(false);
    const restoreProject = ({ onSuccess: onSuccess, onFailure: onFailure })=>{
        const url = (0, $4DNj5.getProjectRestoreUrl)(projectId);
        setLoading(true);
        (0, $h2wCv.performPostRequest)(url).then(()=>{
            setLoading(false);
            onSuccess();
        }).catch((error)=>{
            if (!(error.statusCode === 409)) (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'useProjectRestoreService',
                    packageName: 'jiraProjectRestoreModal'
                },
                error: error,
                attributes: {
                    projectId: projectId,
                    errorStatusCode: error.statusCode
                }
            });
            setLoading(false);
            onFailure(error);
        });
    };
    return [
        loading,
        restoreProject
    ];
};

});
parcelRegister("4DNj5", function(module, exports) {
$parcel$export(module.exports, "getProjectRestoreUrl", () => $e5b9af89ba46d4bd$export$f120ca318b319edc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $e5b9af89ba46d4bd$export$f120ca318b319edc = (projectId)=>`/rest/api/2/project/${projectId}/restore`;

});


parcelRegister("5bTfl", function(module, exports) {
$parcel$export(module.exports, "ModalMessageContent", () => $f6a990876fafeb83$export$6c33ff8e4ab0adf4);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3SDrv = parcelRequire("3SDrv");

var $f99M0 = parcelRequire("f99M0");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

const $f6a990876fafeb83$var$explainWhatProjectRestoreDoesPart1 = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.modal-message.explain-what-project-restore-does-part-1",
    defaultMessage: "The project along with its issues, Jira components, attachments, and versions will be restored."
});
const $f6a990876fafeb83$var$jsmExplainWhatProjectRestoreDoes = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.modal-message.jsm-explain-what-project-restore-does",
    defaultMessage: "Once restored, this service project will appear in directories and its issues will appear in search results. You may need to turn on email support for this service project to work as normal."
});
const $f6a990876fafeb83$var$jsmLearnMoreAboutTrashAndRestore = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.modal-message.jsm-learn-more-about-trash-and-restore",
    defaultMessage: "Learn more about trash and restore."
});
const $f6a990876fafeb83$var$explainWhatProjectRestoreDoesPart1IssueTermRefresh = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.modal-message.explain-what-project-restore-does-part-1-issue-term-refresh",
    defaultMessage: "The project along with its work items, Jira components, attachments, and versions will be restored"
});
const $f6a990876fafeb83$var$jsmExplainWhatProjectRestoreDoesIssueTermRefresh = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.modal-message.jsm-explain-what-project-restore-does-issue-term-refresh",
    defaultMessage: "Once restored, this service project will appear in directories and its work items will appear in search results. You may need to turn on email support for this service project to work as normal."
});
const $f6a990876fafeb83$var$explainWhatProjectRestoreDoesPart1IssueTermRefreshGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.modal-message.explain-what-project-restore-does-part-1-issue-term-refresh-galaxia",
    defaultMessage: "The space along with its work items, Jira components, attachments, and versions will be restored"
});
const $f6a990876fafeb83$var$jsmExplainWhatProjectRestoreDoesIssueTermRefreshGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "project-restore-modal.modal-message.jsm-explain-what-project-restore-does-issue-term-refresh-galaxia",
    defaultMessage: "Once restored, this service space will appear in directories and its work items will appear in search results. You may need to turn on email support for this service space to work as normal."
});
const $f6a990876fafeb83$var$isServiceDesk = (projectType)=>projectType === (0, $f99M0.SERVICE_DESK_PROJECT);
const $f6a990876fafeb83$export$49587436f0d2c314 = ({ projectType: projectType })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const getMessage = ()=>{
        const jsmExplainWhatProjectRestoreDoesIssueTermRefreshGalaxia = (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $f6a990876fafeb83$var$jsmExplainWhatProjectRestoreDoesIssueTermRefreshGalaxiaMessage : $f6a990876fafeb83$var$jsmExplainWhatProjectRestoreDoesIssueTermRefresh;
        const explainWhatProjectRestoreDoesPart1IssueTermRefreshGalaxia = (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $f6a990876fafeb83$var$explainWhatProjectRestoreDoesPart1IssueTermRefreshGalaxiaMessage : $f6a990876fafeb83$var$explainWhatProjectRestoreDoesPart1IssueTermRefresh;
        let message;
        if ((0, $2700E.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) message = $f6a990876fafeb83$var$isServiceDesk(projectType) ? jsmExplainWhatProjectRestoreDoesIssueTermRefreshGalaxia : explainWhatProjectRestoreDoesPart1IssueTermRefreshGalaxia;
        else message = $f6a990876fafeb83$var$isServiceDesk(projectType) ? $f6a990876fafeb83$var$jsmExplainWhatProjectRestoreDoes : $f6a990876fafeb83$var$explainWhatProjectRestoreDoesPart1;
        return message;
    };
    const formattedMessage = formatMessage(getMessage());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("span", null, formattedMessage, "\xa0");
};
$f6a990876fafeb83$export$49587436f0d2c314.displayName = "ModalText";
const $f6a990876fafeb83$export$d608ae2ec728a3cf = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3SDrv.default), {
        href: (0, $63da4b5b80a5e506$export$367c841df4ac5730),
        target: "_blank"
    }, formatMessage($f6a990876fafeb83$var$jsmLearnMoreAboutTrashAndRestore));
};
$f6a990876fafeb83$export$d608ae2ec728a3cf.displayName = "LearnMoreLink";
const $f6a990876fafeb83$export$6c33ff8e4ab0adf4 = ({ projectType: projectType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f6a990876fafeb83$export$49587436f0d2c314, {
        projectType: projectType
    }), $f6a990876fafeb83$var$isServiceDesk(projectType) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f6a990876fafeb83$export$d608ae2ec728a3cf, null));
$f6a990876fafeb83$export$6c33ff8e4ab0adf4.displayName = "ModalMessageContent";

});
parcelRegister("3SDrv", function(module, exports) {
$parcel$export(module.exports, "default", () => $535749713c9cb8e0$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $lpTWz = parcelRequire("lpTWz");

var $jpPNt = parcelRequire("jpPNt");
function $535749713c9cb8e0$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jpPNt.Link), rest, children);
}
$535749713c9cb8e0$var$Link.displayName = "Link";
const $535749713c9cb8e0$var$LinkWithAnalytics = (0, $lpTWz.default)('link', {
    onClick: 'clicked'
})($535749713c9cb8e0$var$Link);
var $535749713c9cb8e0$export$2e2bcd8739ae039 = $535749713c9cb8e0$var$LinkWithAnalytics;

});

/* eslint-disable jira/filename-case */ const $63da4b5b80a5e506$export$37312a67c3e314c6 = 'PROJECT_RESTORE_MODAL_LOAD_START_MARK_KEY';
const $63da4b5b80a5e506$export$367c841df4ac5730 = 'https://support.atlassian.com/jira-service-management-cloud/docs/trash-and-restore-a-project/';


parcelRegister("6T7am", function(module, exports) {
$parcel$export(module.exports, "getDurationInTrash", () => $fa06ce5325caa6e2$export$d40938201f7514c5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fZkaH = parcelRequire("fZkaH");

var $dGdlo = parcelRequire("dGdlo");

var $7cCLc = parcelRequire("7cCLc");
const $fa06ce5325caa6e2$export$d40938201f7514c5 = (projectTrashedDate)=>{
    const parsedProjectTrashedDate = (0, $dGdlo.default)((0, $7cCLc.default)(projectTrashedDate)) ? (0, $7cCLc.default)(projectTrashedDate) : new Date(projectTrashedDate);
    return (0, $fZkaH.default)(new Date(), parsedProjectTrashedDate);
};

});


parcelRegister("9cGgF", function(module, exports) {
$parcel$export(module.exports, "Nav4ProjectsEmptyContent", () => $ca1859c41cc373f8$export$7a7cd6cdc84cf8eb);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $biJuK = parcelRequire("biJuK");

var $8Sdzy = parcelRequire("8Sdzy");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $ca1859c41cc373f8$var$emptyProjectsMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.empty-content.empty-projects-message",
    defaultMessage: "Once you visit or create projects, they'll show up here."
});
const $ca1859c41cc373f8$var$emptyProjectsMessageGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.empty-content.empty-projects-message-galaxia",
    defaultMessage: "Once you visit or create spaces, they'll show up here."
});
function $ca1859c41cc373f8$export$7a7cd6cdc84cf8eb() {
    const $ = (0, $e7boj.c)(4);
    const emptyProjectsMessageGalaxia = (0, $2700E.expVal)("project-terminology-refresh", "isEnabled", false) ? $ca1859c41cc373f8$var$emptyProjectsMessageGalaxiaMessage : $ca1859c41cc373f8$var$emptyProjectsMessage;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage(emptyProjectsMessageGalaxia);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ $euxye.createElement((0, $biJuK.EmptyContentMenuItem), null, /*#__PURE__*/ $euxye.createElement((0, $8Sdzy.Text), {
            size: "small",
            color: "color.text.subtle"
        }, t0));
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
}
$ca1859c41cc373f8$export$7a7cd6cdc84cf8eb.displayName = "Nav4ProjectsEmptyContent";

});

parcelRegister("9BXzG", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $6cf27f4599b18306$export$a06f1c675e846f6f);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $ekhRy = parcelRequire("ekhRy");

var $9Rltc = parcelRequire("9Rltc");

var $7IpXK = parcelRequire("7IpXK");

var $gyzjO = parcelRequire("gyzjO");

var $6w18e = parcelRequire("6w18e");

var $djYhH = parcelRequire("djYhH");

var $ar9gx = parcelRequire("ar9gx");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $caJ3S = parcelRequire("caJ3S");

var $g3FiF = parcelRequire("g3FiF");
const $6cf27f4599b18306$var$moreProjects = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.more-projects",
    defaultMessage: "More projects"
});
const $6cf27f4599b18306$var$moreProjectsGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.more-projects-galaxia",
    defaultMessage: "More spaces"
});
function $6cf27f4599b18306$var$FooterInternal(t0) {
    const $ = (0, $e7boj.c)(15);
    const { canCreateProject: t1 } = t0;
    const canCreateProject = t1 === undefined ? false : t1;
    const moreProjectsGalaxia = (0, $2700E.expVal)("project-terminology-refresh", "isEnabled", false) ? $6cf27f4599b18306$var$moreProjectsGalaxiaMessage : $6cf27f4599b18306$var$moreProjects;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { sendMoreProjectsAnalyticsEvent: sendMoreProjectsAnalyticsEvent } = (0, $ekhRy.useProjectsAnalyticsL1)();
    let t2;
    bb0: {
        if (!canCreateProject) {
            t2 = null;
            break bb0;
        }
        let t3;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $i860n.fg)("jsmgrowth-459_temporary_gate") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gyzjO.Nav4ProjectsSectionPlacement), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $caJ3S.Nav4Recommendations), null);
            $[0] = t3;
        } else t3 = $[0];
        t2 = t3;
    }
    const recommendations = t2;
    let t3;
    if ($[1] !== formatMessage) {
        t3 = formatMessage(moreProjectsGalaxia);
        $[1] = formatMessage;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== sendMoreProjectsAnalyticsEvent || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9Rltc.MoreProjectsFlyout), {
            onClick: sendMoreProjectsAnalyticsEvent
        }, t3);
        $[3] = sendMoreProjectsAnalyticsEvent;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== canCreateProject) {
        t5 = canCreateProject && (0, $2700E.expVal)("jsmgrowth_547_rerun_browse_templates_in_sidenav", "isEnabled", false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7IpXK.BrowseTemplatesMenuItem), null);
        $[6] = canCreateProject;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== canCreateProject) {
        t6 = canCreateProject && (0, $i860n.fg)("jfind-retest-left-nav-import-killswitch") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g3FiF.ImportWorkMenuItem), null);
        $[8] = canCreateProject;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== recommendations || $[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, t4, recommendations, t5, t6)));
        $[10] = recommendations;
        $[11] = t4;
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
}
$6cf27f4599b18306$var$FooterInternal.displayName = "FooterInternal";
const $6cf27f4599b18306$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $euxye.memo)($6cf27f4599b18306$var$FooterInternal);

});
parcelRegister("9Rltc", function(module, exports) {
$parcel$export(module.exports, "MoreProjectsFlyout", () => $7faa5ec551d9c8b2$export$35a66c7368b171ff);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $9h4A8 = parcelRequire("9h4A8");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $6ouZy = parcelRequire("6ouZy");

var $gEDfa = parcelRequire("gEDfa");

var $4U30j = parcelRequire("4U30j");
var $iozCP = parcelRequire("iozCP");
var $02ogW = parcelRequire("02ogW");

var $aNG0w = parcelRequire("aNG0w");

var $i860n = parcelRequire("i860n");

var $kt86l = parcelRequire("kt86l");

var $41J1Q = parcelRequire("41J1Q");

function $7faa5ec551d9c8b2$export$35a66c7368b171ff(props) {
    const cloudId = (0, $kt86l.useCloudId)();
    const currentURL = (0, $9h4A8.useGetCurrentUrl)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $41J1Q.MoreProjectsEntrypoint), {
        cloudId: cloudId,
        currentURL: currentURL
    });
    const triggerRef = (0, $6ouZy.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4U30j.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $02ogW.FlyoutMenuItemTrigger), {
        ...props,
        ref: triggerRef,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))), {
            label: "",
            color: "currentColor"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iozCP.FlyoutMenuItemContent), {
        maxHeight: (0, $i860n.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? 460 : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "sidebar-nav4-more-projects-flyout",
        packageName: (0, $19853af4eadc9215$export$b8b9d90f9e5bd72b),
        teamName: (0, $19853af4eadc9215$export$d57b6b390e78d90f),
        errorFallback: "flag",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), {
            withSearch: true,
            withSubHeading: true,
            isFlyout: true,
            count: 10
        }),
        runtimeProps: {}
    })));
}
$7faa5ec551d9c8b2$export$35a66c7368b171ff.displayName = "MoreProjectsFlyout";

});
parcelRegister("41J1Q", function(module, exports) {
$parcel$export(module.exports, "MoreProjectsEntrypoint", () => $9f970aab25c3adb4$export$40b84ce4e7e6a96a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $efTF2 = parcelRequire("efTF2");

const $9f970aab25c3adb4$export$40b84ce4e7e6a96a = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("kXP91")), {
        moduleId: "2d973d10",
        moduleName: "MoreProjects",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, currentURL: currentURL })=>({
            queries: {
                moreProjects: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $efTF2.default,
                    variables: {
                        cloudId: cloudId,
                        currentURL: currentURL
                    }
                }
            },
            extraProps: {}
        })
});

});
parcelRegister("efTF2", function(module, exports) {
$parcel$export(module.exports, "default", () => $36dd6963a7c7eb4c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6401ce4a1a1be8716fa9fe995e180204>>
 * @relayHash d0dbef5acfff74401db3652df16d5065
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID daea719398027db8cfdb2263b69e1474888939a638d60e328d30514fb8792bb4
const $36dd6963a7c7eb4c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "alias": "canBrowseProjects",
                "args": [
                    v1 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "BROWSE_PROJECTS"
                    }
                ],
                "concreteType": "JiraPermission",
                "kind": "LinkedField",
                "name": "permission",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "hasPermission"
                    }
                ]
            }
        ]
    }, v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "currentURL",
            "variableName": "currentURL"
        }
    ], v4 = [
        {
            "concreteType": "JiraProjectEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ProjectSection_projectNode"
                }
            ]
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "concreteType": "JiraProjectEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        },
                        {
                            "alias": "projectKey",
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ],
                                    "type": "JiraNavigationItem",
                                    "abstractKey": "__isJiraNavigationItem"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoreProjectsQuery",
            "selections": [
                v2 /*: any*/ ,
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreFavourites",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreRecents",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "otherItems",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoreProjectsQuery",
            "selections": [
                v2 /*: any*/ ,
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreFavourites",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        },
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreRecents",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        },
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "otherItems",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        },
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "daea719398027db8cfdb2263b69e1474888939a638d60e328d30514fb8792bb4",
            "metadata": {},
            "name": "MoreProjectsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$36dd6963a7c7eb4c$var$node.hash = "a553136d07c4397aa2eec1d98cfc9bbe";
var $36dd6963a7c7eb4c$export$2e2bcd8739ae039 = $36dd6963a7c7eb4c$var$node;

});

parcelRegister("kXP91", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d48FL").then(()=>parcelRequire('besQh'));

});


/* eslint-disable jira/filename-case */ const $19853af4eadc9215$export$b8b9d90f9e5bd72b = 'jira-navigation-apps-sidebar-nav4-more-projects';
const $19853af4eadc9215$export$d57b6b390e78d90f = 'jira-cosmos';


parcelRegister("7IpXK", function(module, exports) {
$parcel$export(module.exports, "BrowseTemplatesMenuItem", () => $2a54a5ec92656461$export$c26343bcab17172c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4Kt0R = parcelRequire("4Kt0R");

var $jVPlr = parcelRequire("jVPlr");

var $4xzHg = parcelRequire("4xzHg");

var $gRWK8 = parcelRequire("gRWK8");

var $aNG0w = parcelRequire("aNG0w");

var $7eNDO = parcelRequire("7eNDO");
var $55qdj = parcelRequire("55qdj");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
const $2a54a5ec92656461$var$browseTemplates = (0, $7eNDO.defineMessage)({
    id: "jira.navigation.apps.sidebar-nav4.sidebars.content.projects.browse-templates.ui.browse-templates",
    defaultMessage: "Browse templates"
});
const $2a54a5ec92656461$export$c26343bcab17172c = ()=>{
    const [, { on: openProjectCreateDrawer }] = (0, $gRWK8.useSwitchModals)((0, $4Kt0R.MODAL_ID).PROJECT_CREATE);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const browseTemplatesAnalytics = (0, $4xzHg.getProjectMenuItemAnalytics)({
        itemId: 'browseTemplates'
    });
    (0, $euxye.useEffect)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'browseTemplateButton'
        }));
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jVPlr.default), {
        onClick: openProjectCreateDrawer,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))), {
            label: "",
            color: "currentColor"
        }),
        analytics: browseTemplatesAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55qdj.default), $2a54a5ec92656461$var$browseTemplates));
};
$2a54a5ec92656461$export$c26343bcab17172c.displayName = "BrowseTemplatesMenuItem";

});
parcelRegister("4xzHg", function(module, exports) {
$parcel$export(module.exports, "getProjectMenuItemAnalytics", () => $5564ed231f809d55$export$acf0bd7d5f3c11ce);


var $hKd0r = parcelRequire("hKd0r");
const $5564ed231f809d55$export$acf0bd7d5f3c11ce = ({ level: level = 2, ...attrs })=>(0, $hKd0r.getMenuItemAnalytics)({
        actionSubjectId: (0, $47ad9e6c8e8002a4$export$8d155d2412839524),
        level: level,
        // menuId can't be used as itemId, as it has projectKey in it (so it will be different values for different projects).
        ...attrs
    });

});


parcelRegister("gyzjO", function(module, exports) {
$parcel$export(module.exports, "Nav4ProjectsSectionPlacement", () => $76787bc9038f3910$export$1a9d150d05db1e80);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $gDdYI = parcelRequire("gDdYI");

var $h8QGu = parcelRequire("h8QGu");

var $cr9yX = parcelRequire("cr9yX");

var $bxVe8 = parcelRequire("bxVe8");

var $35eqr = parcelRequire("35eqr");

var $6Rf9W = parcelRequire("6Rf9W");

var $euxye = parcelRequire("euxye");
const $76787bc9038f3910$export$1a9d150d05db1e80 = /*#__PURE__*/ (0, $euxye.memo)(()=>{
    const [preloadedInitialData] = (0, $cr9yX.usePlacementPreloadedData)((0, $35eqr.postOfficeNav4ProjectsSectionResource));
    const memoizedPlacementProps = (0, $euxye.useMemo)(()=>({
            // oxlint-disable-next-line typescript/consistent-type-assertions
            preloadedInitialData: preloadedInitialData
        }), [
        preloadedInitialData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "jira-growth-nav-4-projects-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "growthNav4ProjectsSection",
        packageName: "@jira/growth__nav-4-projects-section",
        teamName: "Sequoia",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bxVe8.PlacementFetchProvider), {
        resource: (0, $35eqr.postOfficeNav4ProjectsSectionResource)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Rf9W.SSRPlacement), memoizedPlacementProps))));
});

});
parcelRegister("6Rf9W", function(module, exports) {
$parcel$export(module.exports, "SSRPlacement", () => $7ad0756389c14d3e$export$7d3d92a960f07a28);
// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

var $hL4BS = parcelRequire("hL4BS");

var $c9qK7 = parcelRequire("c9qK7");

var $1udHD = parcelRequire("1udHD");
const $7ad0756389c14d3e$var$messageFrontends = [
    (0, $hL4BS.MessageFrontend)({
        messageTemplateId: 'nav-4-projects-section-recommendation'
    })
];
const $7ad0756389c14d3e$export$7b621692a0aa2333 = (0, $c9qK7.PlacementFrontend).createPlacementFrontendComponent({
    messageTemplates: $7ad0756389c14d3e$var$messageFrontends
});
const $7ad0756389c14d3e$export$af2bcbdc04a2d456 = (0, $1udHD.withI18n)($7ad0756389c14d3e$export$7b621692a0aa2333);
const $7ad0756389c14d3e$export$7d3d92a960f07a28 = $7ad0756389c14d3e$export$7b621692a0aa2333;

});
parcelRegister("hL4BS", function(module, exports) {
$parcel$export(module.exports, "MessageFrontend", () => $d80e0aabb0c4fa3b$export$fa9bb46961aca2cc);

var $e79Pd = parcelRequire("e79Pd");

var $8hQRz = parcelRequire("8hQRz");

var $c9qK7 = parcelRequire("c9qK7");

var $lonFZ = parcelRequire("lonFZ");

var $jouY6 = parcelRequire("jouY6");

var $kdy7J = parcelRequire("kdy7J");

var $bh3q1 = parcelRequire("bh3q1");

var $lfqQU = parcelRequire("lfqQU");
const $d80e0aabb0c4fa3b$var$hydrate = (0, $c9qK7.PlacementBackend).createBackendStage({
    type: 'hydrate',
    validate: (0, $8hQRz.noValidation)(),
    async stage ({ message: message, request: request }) {
        const { context: { entityId: entityId } } = message;
        if (entityId !== (0, $jouY6.IT_SERVICE_MANAGEMENT)) return message.context;
        try {
            const tcsResponse = await request.restApiClients.tcsClient.cloud.getTcsRecord(`${request.orchestrationContext.tenantId}.xflow.license.information`);
            const isPremium = [
                'premium',
                'business'
            ].includes(tcsResponse.data.products[(0, $kdy7J.ProductKey).JIRA_SOFTWARE]?.edition ?? '');
            return {
                ...message.context,
                entityId: isPremium ? (0, $jouY6.SIMPLIFIED_IT_SERVICE_MANAGEMENT_ADVANCED) : (0, $jouY6.SIMPLIFIED_IT_SERVICE_MANAGEMENT_BASIC)
            };
        } catch (error) {
            request.logger.error({
                error: error
            }, `Error occurred when retrieving license information from TCS`);
            throw new Error('Something went wrong fetching license information from TCS');
        }
    }
});
const $d80e0aabb0c4fa3b$var$transformMetadata = (0, $c9qK7.PlacementBackend).createBackendStage({
    type: 'transformMetadata',
    validate: (0, $8hQRz.noValidation)(),
    stage ({ message: message }) {
        const targetProduct = message.context.productKey === (0, $lfqQU.Targets).JIRA_SERVICE_DESK ? [
            (0, $bh3q1.JiraServiceManagementCcpId)
        ] : [
            (0, $bh3q1.JiraProductDiscoveryCcpId)
        ];
        return {
            goalMetadata: {
                primaryGoal: {
                    goalId: 'd1to6ai',
                    targetProduct: targetProduct,
                    edition: [
                        (0, $bh3q1.ValidEdition).AnyEdition
                    ]
                }
            }
        };
    }
});
const $d80e0aabb0c4fa3b$export$e7843a8f64a8d87c = (0, $c9qK7.PlacementBackend).createMessageBackend(()=>({
        transformMetadata: $d80e0aabb0c4fa3b$var$transformMetadata,
        hydrate: $d80e0aabb0c4fa3b$var$hydrate
    }));
const $d80e0aabb0c4fa3b$var$render = (0, $c9qK7.PlacementFrontend).createFrontendStage({
    type: 'render',
    validate: (0, $8hQRz.noValidation)(),
    Component: (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $lonFZ.Nav4Recommendation), {
            ...props
        })
});
const $d80e0aabb0c4fa3b$export$fa9bb46961aca2cc = (0, $c9qK7.PlacementFrontend).createMessageFrontend({
    render: $d80e0aabb0c4fa3b$var$render
});

});
parcelRegister("c9qK7", function(module, exports) {
$parcel$export(module.exports, "PlacementBackend", () => $827b5f0a9f9f6eb1$export$d90b37843c84d1c3);
$parcel$export(module.exports, "PlacementFrontend", () => $827b5f0a9f9f6eb1$export$55486c2b6964dcf2);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $aQEaU = parcelRequire("aQEaU");

var $2vhMr = parcelRequire("2vhMr");

var $3eBpX = parcelRequire("3eBpX");

var $1wUjh = parcelRequire("1wUjh");

var $8VhoU = parcelRequire("8VhoU");

var $55qdj = parcelRequire("55qdj");
const $827b5f0a9f9f6eb1$var$styles = {
    root: "_11c8i4vh _1rjcu2gc _syaz1rpy _bozg12x7"
};
const $827b5f0a9f9f6eb1$var$placement = (0, $2vhMr.createPlacement)({
    placementId: 'nav-4-projects-section',
    options: {
        choreographer: {
            isDefaultEnabled: false
        }
    }
});
const $827b5f0a9f9f6eb1$export$81df3aa6753d44e2 = $827b5f0a9f9f6eb1$var$placement.createFrontend;
const $827b5f0a9f9f6eb1$export$da912f58cb37a643 = $827b5f0a9f9f6eb1$var$placement.createBackend;
const $827b5f0a9f9f6eb1$var$getRecommendationsQuery = (0, $aQEaU.gql)`
	query Nav4RecommendationsQuery(
		$cloudId: ID!
		$rerankCandidateList: [GrowthRecRerankCandidate!]!
	) {
		jira {
			canCreateProject: canPerform(type: CREATE_PROJECT, cloudId: $cloudId) @optIn(to: "JiraAction")
		}
		growthRecommendations {
			recommendations(
				context: {
					useCase: "jiraProjectMenuRecommendations"
					tenantId: $cloudId
					product: "jira"
					custom: { version: "v3" }
				}
				first: 1
				rerank: $rerankCandidateList
			) {
				... on GrowthRecRecommendations {
					data {
						... on GrowthRecJiraTemplateRecommendation {
							entityId
						}
					}
					context {
						sessionId
					}
				}
			}
		}
	}
`;
const $827b5f0a9f9f6eb1$export$d90b37843c84d1c3 = $827b5f0a9f9f6eb1$export$da912f58cb37a643({
    customMiddleware: (0, $3eBpX.placementMiddlewareWithCacheControlNav),
    params: {
        sortingMethod: undefined,
        dataRetrivalType: 'implicit-only'
    },
    stages: ({ hydrate: hydrate, transformMetadata: transformMetadata })=>({
            init: (0, $1wUjh.defaultBackendPlacementStages)({
                hydrate: hydrate,
                transformMetadata: transformMetadata
            }).init,
            postInit: async (input)=>{
                const { data: data, request: request } = input;
                // Hydrate the original messages
                const { messages: messages } = await hydrate?.(input) ?? data;
                const nav4ProjectsRecommendationsMessages = messages.filter((message)=>message.messageTemplateId === 'nav-4-projects-section-recommendation');
                request.logger.info({
                    nav4ProjectsRecommendationsMessages: nav4ProjectsRecommendationsMessages
                }, 'Nav-4 projects recommendations messages received for postInit stage');
                // If there is no recommendation message, we don't need to fetch recommendations
                if (nav4ProjectsRecommendationsMessages.length === 0) {
                    request.logger.info({
                        nav4ProjectsRecommendationsMessages: nav4ProjectsRecommendationsMessages
                    }, 'No message available for nav-4-projects-section-recommendation');
                    return {
                        messages: messages
                    };
                }
                const enableXForwardedHostHeader = request.statsig.checkGate({
                    identifiers: {
                        atlassianAccountId: request.orchestrationContext.recipient.userId
                    }
                }, 'post-office_enable_x-forwarded-host-header');
                // Use the implicit messages from nav-4-projects-section-recommendation as the rerank list
                // Filter out messages with null/undefined entityId to avoid GraphQL validation errors
                const rerankCandidateList = nav4ProjectsRecommendationsMessages.filter((message)=>message.context?.entityId).map((message)=>({
                        entityId: message.context.entityId
                    }));
                if (rerankCandidateList.length === 0) {
                    request.logger.info({
                        rerankCandidateList: rerankCandidateList
                    }, 'No rerank candidate list found for nav-4-projects-section-recommendation');
                    return {
                        messages: messages.filter((message)=>message.messageTemplateId !== 'nav-4-projects-section-recommendation')
                    };
                }
                let queryResult;
                try {
                    queryResult = await request.graphqlClients.cachedGraphqlGateway.query({
                        query: $827b5f0a9f9f6eb1$var$getRecommendationsQuery,
                        variables: {
                            cloudId: request.orchestrationContext.tenantId,
                            rerankCandidateList: rerankCandidateList
                        },
                        context: {
                            headers: {
                                ...enableXForwardedHostHeader && request.headers?.['x-forwarded-host'] ? {
                                    'x-forwarded-host': request.headers['x-forwarded-host']
                                } : {}
                            }
                        }
                    }, {});
                } catch (error) {
                    // Do not throw on 403 or other GraphQL/network errors; treat as no recommendations
                    request.logger.error({
                        error: error
                    }, 'GraphQL request failed for nav-4-projects-section-recommendation, skipping recommendations');
                    return {
                        messages: messages.filter((message)=>message.messageTemplateId !== 'nav-4-projects-section-recommendation')
                    };
                }
                const { data: recommendation, errors: errors, error: error } = queryResult;
                if (error || errors?.length) {
                    request.logger.error({
                        error: error,
                        errors: errors,
                        recommendation: recommendation
                    }, 'Error fetching recommendations for nav-4-projects-section-recommendation');
                    // Ignore nav-4-projects-section-recommendation if anything wrong with the GRS call
                    return {
                        messages: messages.filter((message)=>message.messageTemplateId !== 'nav-4-projects-section-recommendation')
                    };
                }
                if (!recommendation.jira?.canCreateProject) {
                    request.logger.info({
                        recommendation: recommendation
                    }, 'User does not have permission to create project for nav-4-projects-section-recommendation');
                    // Ignore nav-4-projects-section-recommendation if no recommendation returned from the GRS call
                    return {
                        messages: messages.filter((message)=>message.messageTemplateId !== 'nav-4-projects-section-recommendation')
                    };
                }
                if (!recommendation.growthRecommendations?.recommendations?.context?.sessionId) {
                    request.logger.info({
                        recommendation: recommendation
                    }, 'No sessionId returned for nav-4-projects-section-recommendation');
                    // Ignore nav-4-projects-section-recommendation if no recommendation returned from the GRS call
                    return {
                        messages: messages.filter((message)=>message.messageTemplateId !== 'nav-4-projects-section-recommendation')
                    };
                }
                if (!recommendation.growthRecommendations?.recommendations?.data?.length) {
                    request.logger.info({
                        nav4ProjectsRecommendationsMessages: nav4ProjectsRecommendationsMessages
                    }, 'No recommendations found for nav-4-projects-section-recommendation, use the first message in the original list as a fallback');
                    return {
                        messages: [
                            ...messages.filter((message)=>message.messageTemplateId !== 'nav-4-projects-section-recommendation'),
                            nav4ProjectsRecommendationsMessages[0]
                        ]
                    };
                }
                const recommendedMessages = nav4ProjectsRecommendationsMessages// We only want the recommended template to be returned
                .filter((message)=>recommendation.growthRecommendations?.recommendations?.data?.some((r)=>r.entityId === message.context.entityId)).map((message)=>({
                        ...message,
                        context: {
                            ...message.context,
                            // Add recommendationSessionId returned from GRS into the message context which is passed into CFFE.
                            recommendationSessionId: recommendation.growthRecommendations?.recommendations?.context?.sessionId ?? ''
                        }
                    }));
                request.logger.info({
                    recommendedMessages: recommendedMessages
                }, 'Recommended messages for nav-4-projects-section-recommendation');
                return {
                    messages: [
                        ...messages.filter((message)=>message.messageTemplateId !== 'nav-4-projects-section-recommendation'),
                        ...recommendedMessages
                    ]
                };
            }
        })
});
const $827b5f0a9f9f6eb1$export$55486c2b6964dcf2 = $827b5f0a9f9f6eb1$export$81df3aa6753d44e2((Messages)=>({ preloadedInitialData: preloadedInitialData })=>{
        const [{ messages: messages, status: status }, setMessagesState] = (0, $euxye.useState)(()=>{
            if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? {
                status: 'done',
                messages: preloadedInitialData?.messages
            } : {
                messages: undefined,
                status: 'done'
            };
            return {
                messages: undefined,
                status: 'loading'
            };
        });
        const isDone = status === 'done';
        const { data: data, error: error, isLoading: isLoading } = (0, $8VhoU.usePlacementApi)('/', {
            autoRefetch: {
                isEnabled: !isDone,
                updateKey: 'nav-4-projects-section'
            }
        });
        const handleDismiss = (0, $euxye.useCallback)((messageInstanceId)=>{
            setMessagesState(()=>{
                if (!messages) return {
                    messages: undefined,
                    status: 'done'
                };
                const filteredMessages = messages.filter((message)=>messageInstanceId !== message.messageInstanceId);
                return {
                    messages: filteredMessages,
                    status: 'done'
                };
            });
        }, [
            messages
        ]);
        (0, $euxye.useEffect)(()=>{
            if (!isLoading && !isDone) setMessagesState({
                messages: data?.messages,
                status: 'done'
            });
        }, [
            isLoading,
            isDone,
            data
        ]);
        if (error) return null;
        if (status === 'loading') return null;
        return Array.isArray(messages) && messages.length > 0 ? /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            role: "list",
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
                role: "group",
                "aria-labelledby": "nav-4-projects-section-menu-section",
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)("h2", {
                        id: "nav-4-projects-section-menu-section-heading",
                        className: (0, $4jQY2.default)([
                            $827b5f0a9f9f6eb1$var$styles.root
                        ]),
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                            id: "post-office.nav-4-projects-recommendations.section-heading",
                            defaultMessage: "Recommended",
                            description: "heading for nav4 projects recommendations section"
                        })
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        role: "listitem",
                        children: messages?.map((props, index)=>/*#__PURE__*/ (0, $e79Pd.jsx)(Messages.render, {
                                dismiss: ()=>handleDismiss(props.messageInstanceId),
                                ...props
                            }, `${props.messageInstanceId}-${index}`))
                    })
                ]
            })
        }) : null;
    });

});
parcelRegister("aQEaU", function(module, exports) {
$parcel$export(module.exports, "gql", () => $7e5deca18cf87380$export$72e4926bf8358653);
$parcel$export(module.exports, "default", () => $7e5deca18cf87380$export$2e2bcd8739ae039);

var $j9yrT = parcelRequire("j9yrT");

var $hWigb = parcelRequire("hWigb");
var $7e5deca18cf87380$var$docCache = new Map();
var $7e5deca18cf87380$var$fragmentSourceMap = new Map();
var $7e5deca18cf87380$var$printFragmentWarnings = true;
var $7e5deca18cf87380$var$experimentalFragmentVariables = false;
function $7e5deca18cf87380$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $7e5deca18cf87380$var$cacheKeyFromLoc(loc) {
    return $7e5deca18cf87380$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $7e5deca18cf87380$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $7e5deca18cf87380$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $7e5deca18cf87380$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($7e5deca18cf87380$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $7e5deca18cf87380$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, ast), {
        definitions: definitions
    });
}
function $7e5deca18cf87380$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $7e5deca18cf87380$var$parseDocument(source) {
    var cacheKey = $7e5deca18cf87380$var$normalize(source);
    if (!$7e5deca18cf87380$var$docCache.has(cacheKey)) {
        var parsed = (0, $hWigb.parse)(source, {
            experimentalFragmentVariables: $7e5deca18cf87380$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $7e5deca18cf87380$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $7e5deca18cf87380$var$docCache.set(cacheKey, $7e5deca18cf87380$var$stripLoc($7e5deca18cf87380$var$processFragments(parsed)));
    }
    return $7e5deca18cf87380$var$docCache.get(cacheKey);
}
function $7e5deca18cf87380$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $7e5deca18cf87380$var$parseDocument(result);
}
function $7e5deca18cf87380$export$657554ef4dc7ac2d() {
    $7e5deca18cf87380$var$docCache.clear();
    $7e5deca18cf87380$var$fragmentSourceMap.clear();
}
function $7e5deca18cf87380$export$e4294e638636c6ab() {
    $7e5deca18cf87380$var$printFragmentWarnings = false;
}
function $7e5deca18cf87380$export$78cf889af350c840() {
    $7e5deca18cf87380$var$experimentalFragmentVariables = true;
}
function $7e5deca18cf87380$export$5290df9bbbd3cfa() {
    $7e5deca18cf87380$var$experimentalFragmentVariables = false;
}
var $7e5deca18cf87380$var$extras = {
    gql: $7e5deca18cf87380$export$72e4926bf8358653,
    resetCaches: $7e5deca18cf87380$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $7e5deca18cf87380$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $7e5deca18cf87380$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $7e5deca18cf87380$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $7e5deca18cf87380$var$extras.gql, gql_1.resetCaches = $7e5deca18cf87380$var$extras.resetCaches, gql_1.disableFragmentWarnings = $7e5deca18cf87380$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $7e5deca18cf87380$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $7e5deca18cf87380$var$extras.disableExperimentalFragmentVariables;
})($7e5deca18cf87380$export$72e4926bf8358653 || ($7e5deca18cf87380$export$72e4926bf8358653 = {}));
$7e5deca18cf87380$export$72e4926bf8358653["default"] = $7e5deca18cf87380$export$72e4926bf8358653;
var $7e5deca18cf87380$export$2e2bcd8739ae039 = $7e5deca18cf87380$export$72e4926bf8358653;

});
parcelRegister("hWigb", function(module, exports) {
$parcel$export(module.exports, "parse", () => $d0f60483ad99b30a$export$98e6a39c04603d36);

var $kkfVQ = parcelRequire("kkfVQ");

var $aYIth = parcelRequire("aYIth");

var $1Z2fJ = parcelRequire("1Z2fJ");

var $kdiHB = parcelRequire("kdiHB");

var $8GpI0 = parcelRequire("8GpI0");

var $7vCaO = parcelRequire("7vCaO");

var $iFDGL = parcelRequire("iFDGL");
function $d0f60483ad99b30a$export$98e6a39c04603d36(source, options) {
    var parser = new $d0f60483ad99b30a$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $d0f60483ad99b30a$export$5303528d1070ff6f(source, options) {
    var parser = new $d0f60483ad99b30a$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $kdiHB.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $kdiHB.TokenKind).EOF);
    return value;
}
function $d0f60483ad99b30a$export$28b8f402ccc88182(source, options) {
    var parser = new $d0f60483ad99b30a$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $kdiHB.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $kdiHB.TokenKind).EOF);
    return type;
}
var $d0f60483ad99b30a$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $8GpI0.isSource)(source) ? source : new (0, $8GpI0.Source)(source);
        this._lexer = new (0, $iFDGL.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $kdiHB.TokenKind).NAME);
        return {
            kind: (0, $aYIth.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
    ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $aYIth.Kind).DOCUMENT,
            definitions: this.many((0, $kdiHB.TokenKind).SOF, this.parseDefinition, (0, $kdiHB.TokenKind).EOF),
            loc: this.loc(start)
        };
    };
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $kdiHB.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $kdiHB.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
    ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $kdiHB.TokenKind).BRACE_L)) return {
            kind: (0, $aYIth.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $kdiHB.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $aYIth.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $kdiHB.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    };
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $kdiHB.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $kdiHB.TokenKind).PAREN_R);
    };
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $aYIth.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $kdiHB.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $kdiHB.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    };
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $kdiHB.TokenKind).DOLLAR);
        return {
            kind: (0, $aYIth.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    };
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $aYIth.Kind).SELECTION_SET,
            selections: this.many((0, $kdiHB.TokenKind).BRACE_L, this.parseSelection, (0, $kdiHB.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $kdiHB.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    };
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $kdiHB.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $aYIth.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $kdiHB.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    };
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $kdiHB.TokenKind).PAREN_L, item, (0, $kdiHB.TokenKind).PAREN_R);
    };
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $kdiHB.TokenKind).COLON);
        return {
            kind: (0, $aYIth.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $aYIth.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $kdiHB.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
    ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $kdiHB.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $kdiHB.TokenKind).NAME)) return {
            kind: (0, $aYIth.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $aYIth.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $aYIth.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $aYIth.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
    ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $kdiHB.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $kdiHB.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $kdiHB.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $aYIth.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $kdiHB.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $aYIth.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $kdiHB.TokenKind).STRING:
            case (0, $kdiHB.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $kdiHB.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $aYIth.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $aYIth.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $aYIth.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $aYIth.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $kdiHB.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $aYIth.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $kdiHB.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    };
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $aYIth.Kind).LIST,
            values: this.any((0, $kdiHB.TokenKind).BRACKET_L, item, (0, $kdiHB.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $aYIth.Kind).OBJECT,
            fields: this.any((0, $kdiHB.TokenKind).BRACE_L, item, (0, $kdiHB.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $kdiHB.TokenKind).COLON);
        return {
            kind: (0, $aYIth.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
    ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $kdiHB.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    };
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $kdiHB.TokenKind).AT);
        return {
            kind: (0, $aYIth.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
    ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $kdiHB.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $kdiHB.TokenKind).BRACKET_R);
            type = {
                kind: (0, $aYIth.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $kdiHB.TokenKind).BANG)) return {
            kind: (0, $aYIth.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    };
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $aYIth.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
    ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $kdiHB.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $kdiHB.TokenKind).STRING) || this.peek((0, $kdiHB.TokenKind).BLOCK_STRING);
    };
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    };
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $kdiHB.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $kdiHB.TokenKind).BRACE_R);
        return {
            kind: (0, $aYIth.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $kdiHB.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $aYIth.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $aYIth.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $aYIth.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $kdiHB.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $kdiHB.TokenKind).AMP) || this.peek((0, $kdiHB.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $kdiHB.TokenKind).AMP, this.parseNamedType);
    };
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $kdiHB.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $kdiHB.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $kdiHB.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $kdiHB.TokenKind).BRACE_R);
    };
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $kdiHB.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $aYIth.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $kdiHB.TokenKind).PAREN_L, this.parseInputValueDef, (0, $kdiHB.TokenKind).PAREN_R);
    };
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $kdiHB.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $kdiHB.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $aYIth.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $aYIth.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $aYIth.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $kdiHB.TokenKind).EQUALS) ? this.delimitedMany((0, $kdiHB.TokenKind).PIPE, this.parseNamedType) : [];
    };
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $aYIth.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $kdiHB.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $kdiHB.TokenKind).BRACE_R);
    };
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $aYIth.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $aYIth.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $kdiHB.TokenKind).BRACE_L, this.parseInputValueDef, (0, $kdiHB.TokenKind).BRACE_R);
    };
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $kdiHB.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $kdiHB.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $kdiHB.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $aYIth.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $aYIth.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $aYIth.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $aYIth.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $aYIth.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $aYIth.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $aYIth.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $kdiHB.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $aYIth.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $kdiHB.TokenKind).PIPE, this.parseDirectiveLocation);
    };
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $7vCaO.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
    ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $1Z2fJ.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    };
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    };
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $kkfVQ.syntaxError)(this._lexer.source, token.start, "Expected ".concat($d0f60483ad99b30a$var$getTokenKindDesc(kind), ", found ").concat($d0f60483ad99b30a$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    };
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $kdiHB.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $kkfVQ.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($d0f60483ad99b30a$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $kdiHB.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    };
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $kkfVQ.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($d0f60483ad99b30a$var$getTokenDesc(token), "."));
    };
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    };
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    };
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    };
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $d0f60483ad99b30a$var$getTokenDesc(token) {
    var value = token.value;
    return $d0f60483ad99b30a$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $d0f60483ad99b30a$var$getTokenKindDesc(kind) {
    return (0, $iFDGL.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("kkfVQ", function(module, exports) {
$parcel$export(module.exports, "syntaxError", () => $ecc208aa3b9cfc06$export$bbee0c6176c019d4);

var $gIpya = parcelRequire("gIpya");
function $ecc208aa3b9cfc06$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $gIpya.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("gIpya", function(module, exports) {
$parcel$export(module.exports, "GraphQLError", () => $c2b4931f2fb4f78c$export$92d6ed0888e7cb7f);

var $hG9Ej = parcelRequire("hG9Ej");

var $b1rPm = parcelRequire("b1rPm");

var $aW1KX = parcelRequire("aW1KX");

var $4ym5Y = parcelRequire("4ym5Y");

var $kRsTO = parcelRequire("kRsTO");
function $c2b4931f2fb4f78c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c2b4931f2fb4f78c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c2b4931f2fb4f78c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c2b4931f2fb4f78c$var$_typeof(obj);
}
function $c2b4931f2fb4f78c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c2b4931f2fb4f78c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c2b4931f2fb4f78c$var$ownKeys(Object(source), true).forEach(function(key) {
            $c2b4931f2fb4f78c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c2b4931f2fb4f78c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c2b4931f2fb4f78c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c2b4931f2fb4f78c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c2b4931f2fb4f78c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c2b4931f2fb4f78c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c2b4931f2fb4f78c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c2b4931f2fb4f78c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c2b4931f2fb4f78c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c2b4931f2fb4f78c$var$_setPrototypeOf(subClass, superClass);
}
function $c2b4931f2fb4f78c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c2b4931f2fb4f78c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c2b4931f2fb4f78c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c2b4931f2fb4f78c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c2b4931f2fb4f78c$var$_possibleConstructorReturn(this, result);
    };
}
function $c2b4931f2fb4f78c$var$_possibleConstructorReturn(self, call) {
    if (call && ($c2b4931f2fb4f78c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c2b4931f2fb4f78c$var$_assertThisInitialized(self);
}
function $c2b4931f2fb4f78c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c2b4931f2fb4f78c$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $c2b4931f2fb4f78c$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$c2b4931f2fb4f78c$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $c2b4931f2fb4f78c$var$_construct(Class, arguments, $c2b4931f2fb4f78c$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $c2b4931f2fb4f78c$var$_setPrototypeOf(Wrapper, Class);
    };
    return $c2b4931f2fb4f78c$var$_wrapNativeSuper(Class);
}
function $c2b4931f2fb4f78c$var$_construct(Parent, args, Class) {
    if ($c2b4931f2fb4f78c$var$_isNativeReflectConstruct()) $c2b4931f2fb4f78c$var$_construct = Reflect.construct;
    else $c2b4931f2fb4f78c$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $c2b4931f2fb4f78c$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $c2b4931f2fb4f78c$var$_construct.apply(null, arguments);
}
function $c2b4931f2fb4f78c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c2b4931f2fb4f78c$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $c2b4931f2fb4f78c$var$_setPrototypeOf(o, p) {
    $c2b4931f2fb4f78c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c2b4931f2fb4f78c$var$_setPrototypeOf(o, p);
}
function $c2b4931f2fb4f78c$var$_getPrototypeOf(o) {
    $c2b4931f2fb4f78c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c2b4931f2fb4f78c$var$_getPrototypeOf(o);
}
var $c2b4931f2fb4f78c$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $c2b4931f2fb4f78c$var$_inherits(GraphQLError, _Error);
    var _super = $c2b4931f2fb4f78c$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $c2b4931f2fb4f78c$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $c2b4931f2fb4f78c$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $c2b4931f2fb4f78c$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $4ym5Y.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $4ym5Y.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $b1rPm.default)(originalExtensions)) _this.extensions = $c2b4931f2fb4f78c$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($c2b4931f2fb4f78c$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($c2b4931f2fb4f78c$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $c2b4931f2fb4f78c$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($c2b4931f2fb4f78c$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($c2b4931f2fb4f78c$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $c2b4931f2fb4f78c$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $c2b4931f2fb4f78c$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $c2b4931f2fb4f78c$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $aW1KX.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $c2b4931f2fb4f78c$var$_wrapNativeSuper(Error));
function $c2b4931f2fb4f78c$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $c2b4931f2fb4f78c$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $kRsTO.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $kRsTO.printSourceLocation)(error.source, location);
    }
    return output;
}
function $c2b4931f2fb4f78c$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $hG9Ej.default)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 

});
parcelRegister("hG9Ej", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdedd8107279042b$export$2e2bcd8739ae039);
function $cdedd8107279042b$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("b1rPm", function(module, exports) {
$parcel$export(module.exports, "default", () => $80655fa8cc2508f2$export$2e2bcd8739ae039);
function $80655fa8cc2508f2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $80655fa8cc2508f2$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $80655fa8cc2508f2$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $80655fa8cc2508f2$var$_typeof(obj);
}
function $80655fa8cc2508f2$export$2e2bcd8739ae039(value) {
    return $80655fa8cc2508f2$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("aW1KX", function(module, exports) {
$parcel$export(module.exports, "SYMBOL_ITERATOR", () => $7f60aef62383930f$export$f6cdee3c26d6da57);
$parcel$export(module.exports, "SYMBOL_ASYNC_ITERATOR", () => $7f60aef62383930f$export$8d0083df0471478e);
$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $7f60aef62383930f$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $7f60aef62383930f$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $7f60aef62383930f$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $7f60aef62383930f$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("4ym5Y", function(module, exports) {
$parcel$export(module.exports, "getLocation", () => $350b7a15930174c6$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $350b7a15930174c6$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("kRsTO", function(module, exports) {
$parcel$export(module.exports, "printLocation", () => $f2ff2cabff7c2998$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $f2ff2cabff7c2998$export$867940333fd9f869);

var $4ym5Y = parcelRequire("4ym5Y");
function $f2ff2cabff7c2998$export$96a9681e539deed(location) {
    return $f2ff2cabff7c2998$export$867940333fd9f869(location.source, (0, $4ym5Y.getLocation)(location.source, location.start));
}
function $f2ff2cabff7c2998$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $f2ff2cabff7c2998$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $f2ff2cabff7c2998$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $f2ff2cabff7c2998$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $f2ff2cabff7c2998$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $f2ff2cabff7c2998$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $f2ff2cabff7c2998$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $f2ff2cabff7c2998$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $f2ff2cabff7c2998$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $f2ff2cabff7c2998$var$leftPad(len, str) {
    return $f2ff2cabff7c2998$var$whitespace(len - str.length) + str;
}

});



parcelRegister("aYIth", function(module, exports) {
$parcel$export(module.exports, "Kind", () => $7fe201054dbfd4f5$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $7fe201054dbfd4f5$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("1Z2fJ", function(module, exports) {
$parcel$export(module.exports, "Location", () => $171d3c517d99883a$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $171d3c517d99883a$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $171d3c517d99883a$export$8ee0fc9ee280b4ee);

var $2FEq2 = parcelRequire("2FEq2");
var $171d3c517d99883a$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $2FEq2.default)($171d3c517d99883a$export$18a2be9195644f38);
var $171d3c517d99883a$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $2FEq2.default)($171d3c517d99883a$export$50792b0e93539fde);
function $171d3c517d99883a$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("2FEq2", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f1ec37de1e4703c$export$2e2bcd8739ae039);

var $aY1r8 = parcelRequire("aY1r8");

var $h0bVs = parcelRequire("h0bVs");
function $1f1ec37de1e4703c$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $aY1r8.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $h0bVs.default) classObject.prototype[0, $h0bVs.default] = fn;
}

});
parcelRegister("aY1r8", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fc09f47ad9a7488$export$2e2bcd8739ae039);
function $7fc09f47ad9a7488$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});

parcelRegister("h0bVs", function(module, exports) {
$parcel$export(module.exports, "default", () => $c60baff3a599fd17$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $c60baff3a599fd17$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $c60baff3a599fd17$export$2e2bcd8739ae039 = $c60baff3a599fd17$var$nodejsCustomInspectSymbol;

});



parcelRegister("kdiHB", function(module, exports) {
$parcel$export(module.exports, "TokenKind", () => $eb73876a9fda9332$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $eb73876a9fda9332$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("8GpI0", function(module, exports) {
$parcel$export(module.exports, "Source", () => $65263036549a221e$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $65263036549a221e$export$75135ee9ed6e435b);

var $aW1KX = parcelRequire("aW1KX");

var $1anI3 = parcelRequire("1anI3");

var $hG9Ej = parcelRequire("hG9Ej");

var $53oW6 = parcelRequire("53oW6");
function $65263036549a221e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $65263036549a221e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $65263036549a221e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $65263036549a221e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $65263036549a221e$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $hG9Ej.default)(0, "Body must be a string. Received: ".concat((0, $1anI3.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $hG9Ej.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $hG9Ej.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $65263036549a221e$var$_createClass(Source, [
        {
            key: (0, $aW1KX.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $65263036549a221e$export$75135ee9ed6e435b(source) {
    return (0, $53oW6.default)(source, $65263036549a221e$export$1d2df86270c81ecb);
}

});
parcelRegister("1anI3", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d991dd7997cd6cd$export$2e2bcd8739ae039);

var $h0bVs = parcelRequire("h0bVs");
function $0d991dd7997cd6cd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0d991dd7997cd6cd$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0d991dd7997cd6cd$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0d991dd7997cd6cd$var$_typeof(obj);
}
var $0d991dd7997cd6cd$var$MAX_ARRAY_LENGTH = 10;
var $0d991dd7997cd6cd$var$MAX_RECURSIVE_DEPTH = 2;
function $0d991dd7997cd6cd$export$2e2bcd8739ae039(value) {
    return $0d991dd7997cd6cd$var$formatValue(value, []);
}
function $0d991dd7997cd6cd$var$formatValue(value, seenValues) {
    switch($0d991dd7997cd6cd$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $0d991dd7997cd6cd$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $0d991dd7997cd6cd$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $0d991dd7997cd6cd$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $0d991dd7997cd6cd$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $0d991dd7997cd6cd$var$formatArray(value, seenValues);
    return $0d991dd7997cd6cd$var$formatObject(value, seenValues);
}
function $0d991dd7997cd6cd$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $0d991dd7997cd6cd$var$MAX_RECURSIVE_DEPTH) return '[' + $0d991dd7997cd6cd$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $0d991dd7997cd6cd$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $0d991dd7997cd6cd$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $0d991dd7997cd6cd$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($0d991dd7997cd6cd$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($0d991dd7997cd6cd$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $0d991dd7997cd6cd$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $h0bVs.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $0d991dd7997cd6cd$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});

parcelRegister("53oW6", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ae0935ec1e2f735$export$2e2bcd8739ae039);

function $3ae0935ec1e2f735$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3ae0935ec1e2f735$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3ae0935ec1e2f735$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3ae0935ec1e2f735$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$3ae0935ec1e2f735$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("7vCaO", function(module, exports) {
$parcel$export(module.exports, "DirectiveLocation", () => $57790a1647e08b42$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $57790a1647e08b42$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("iFDGL", function(module, exports) {
$parcel$export(module.exports, "Lexer", () => $d97ad7b284de9c14$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $d97ad7b284de9c14$export$59ac0f4da287406a);

var $kkfVQ = parcelRequire("kkfVQ");

var $1Z2fJ = parcelRequire("1Z2fJ");

var $kdiHB = parcelRequire("kdiHB");

var $kn9OA = parcelRequire("kn9OA");
var $d97ad7b284de9c14$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    };
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $kdiHB.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $d97ad7b284de9c14$var$readToken(this, token);
        }while (token.kind === (0, $kdiHB.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $d97ad7b284de9c14$export$59ac0f4da287406a(kind) {
    return kind === (0, $kdiHB.TokenKind).BANG || kind === (0, $kdiHB.TokenKind).DOLLAR || kind === (0, $kdiHB.TokenKind).AMP || kind === (0, $kdiHB.TokenKind).PAREN_L || kind === (0, $kdiHB.TokenKind).PAREN_R || kind === (0, $kdiHB.TokenKind).SPREAD || kind === (0, $kdiHB.TokenKind).COLON || kind === (0, $kdiHB.TokenKind).EQUALS || kind === (0, $kdiHB.TokenKind).AT || kind === (0, $kdiHB.TokenKind).BRACKET_L || kind === (0, $kdiHB.TokenKind).BRACKET_R || kind === (0, $kdiHB.TokenKind).BRACE_L || kind === (0, $kdiHB.TokenKind).PIPE || kind === (0, $kdiHB.TokenKind).BRACE_R;
}
function $d97ad7b284de9c14$var$printCharCode(code) {
    return isNaN(code) ? (0, $kdiHB.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $d97ad7b284de9c14$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $d97ad7b284de9c14$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $d97ad7b284de9c14$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $d97ad7b284de9c14$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $d97ad7b284de9c14$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $d97ad7b284de9c14$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $kkfVQ.syntaxError)(source, pos, $d97ad7b284de9c14$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $d97ad7b284de9c14$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($d97ad7b284de9c14$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($d97ad7b284de9c14$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $d97ad7b284de9c14$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $d97ad7b284de9c14$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $kkfVQ.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($d97ad7b284de9c14$var$printCharCode(code), "."));
    } else {
        position = $d97ad7b284de9c14$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $d97ad7b284de9c14$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $d97ad7b284de9c14$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $d97ad7b284de9c14$var$isNameStart(code)) throw (0, $kkfVQ.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($d97ad7b284de9c14$var$printCharCode(code), "."));
    return new (0, $1Z2fJ.Token)(isFloat ? (0, $kdiHB.TokenKind).FLOAT : (0, $kdiHB.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $d97ad7b284de9c14$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $kkfVQ.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($d97ad7b284de9c14$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $d97ad7b284de9c14$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $kkfVQ.syntaxError)(source, position, "Invalid character within String: ".concat($d97ad7b284de9c14$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $d97ad7b284de9c14$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $kkfVQ.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $kkfVQ.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $kkfVQ.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $d97ad7b284de9c14$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $kn9OA.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $kkfVQ.syntaxError)(source, position, "Invalid character within String: ".concat($d97ad7b284de9c14$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $kkfVQ.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $d97ad7b284de9c14$var$uniCharCode(a, b, c, d) {
    return $d97ad7b284de9c14$var$char2hex(a) << 12 | $d97ad7b284de9c14$var$char2hex(b) << 8 | $d97ad7b284de9c14$var$char2hex(c) << 4 | $d97ad7b284de9c14$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $d97ad7b284de9c14$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $d97ad7b284de9c14$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $1Z2fJ.Token)((0, $kdiHB.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $d97ad7b284de9c14$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});
parcelRegister("kn9OA", function(module, exports) {
$parcel$export(module.exports, "dedentBlockStringValue", () => $ed4d91a64db7476c$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $ed4d91a64db7476c$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $ed4d91a64db7476c$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $ed4d91a64db7476c$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $ed4d91a64db7476c$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $ed4d91a64db7476c$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $ed4d91a64db7476c$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $ed4d91a64db7476c$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $ed4d91a64db7476c$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});




parcelRegister("3eBpX", function(module, exports) {
$parcel$export(module.exports, "INTERACTION_PLACEMENT_MIDDLEWARE_CACHE_CONTROL", () => $18d575e50ebd1bff$export$c81528d4fcbfbe9f);
$parcel$export(module.exports, "placementMiddlewareWithCacheControlNav", () => $18d575e50ebd1bff$export$5379d5ee2ecb6877);

var $GUJN3 = parcelRequire("GUJN3");
const $18d575e50ebd1bff$export$cf9a3fbf9c3c14ce = (headers)=>(config)=>async (opts)=>{
            const isPostOfficeSynthetic = opts.request.orchestrationContext.recipient?.userId && opts.request.statsig.checkGate({
                identifiers: {
                    atlassianAccountId: opts.request.orchestrationContext.recipient.userId
                }
            }, 'post-office-is-post-office-synthetic');
            if (!isPostOfficeSynthetic) opts.koa.ctx.set(headers);
            return (0, $GUJN3.defaultPlacementMiddleware)(config)(opts);
        };
const $18d575e50ebd1bff$export$80d235e32c5248a6 = 'private, max-age=300, stale-while-revalidate=600, stale-if-error=900';
const $18d575e50ebd1bff$export$dc0291b7f6e541b = 'private, max-age=120, stale-while-revalidate=300, stale-if-error=900';
const $18d575e50ebd1bff$export$c81528d4fcbfbe9f = 'private, max-age=600, stale-while-revalidate=900, stale-if-error=900';
const $18d575e50ebd1bff$export$49b0f46a7b9264ff = $18d575e50ebd1bff$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $18d575e50ebd1bff$export$80d235e32c5248a6
});
const $18d575e50ebd1bff$export$f90e17deb35ce39f = $18d575e50ebd1bff$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $18d575e50ebd1bff$export$80d235e32c5248a6
});
const $18d575e50ebd1bff$export$86309966c8dcb8f0 = $18d575e50ebd1bff$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $18d575e50ebd1bff$export$80d235e32c5248a6
});
const $18d575e50ebd1bff$export$d70cd3c2d3a8b23f = $18d575e50ebd1bff$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $18d575e50ebd1bff$export$dc0291b7f6e541b
});
const $18d575e50ebd1bff$export$5379d5ee2ecb6877 = $18d575e50ebd1bff$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $18d575e50ebd1bff$export$dc0291b7f6e541b
});
const $18d575e50ebd1bff$export$c499d39834887909 = $18d575e50ebd1bff$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $18d575e50ebd1bff$export$c81528d4fcbfbe9f
});

});


parcelRegister("lonFZ", function(module, exports) {
$parcel$export(module.exports, "Nav4Recommendation", () => $8fcb79c48c6aed07$export$7f848320b087945d);

var $e79Pd = parcelRequire("e79Pd");

var $4LDqh = parcelRequire("4LDqh");

var $2EFuW = parcelRequire("2EFuW");

var $4C7HL = parcelRequire("4C7HL");


var $6mSn8 = parcelRequire("6mSn8");

var $6LigW = parcelRequire("6LigW");

var $8oFkF = parcelRequire("8oFkF");
var $lfqQU = parcelRequire("lfqQU");

var $j142y = parcelRequire("j142y");

var $3gxI9 = parcelRequire("3gxI9");

var $brCQu = parcelRequire("brCQu");

var $caA13 = parcelRequire("caA13");

var $iKPvC = parcelRequire("iKPvC");

var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");
var $1YIbA = parcelRequire("1YIbA");

var $b7Nzv = parcelRequire("b7Nzv");

var $kaM6I = parcelRequire("kaM6I");

var $508xd = parcelRequire("508xd");

var $4AGx5 = parcelRequire("4AGx5");

var $9kbOy = parcelRequire("9kbOy");

var $7FO8U = parcelRequire("7FO8U");

var $94exK = parcelRequire("94exK");

var $23vA4 = parcelRequire("23vA4");

var $jouY6 = parcelRequire("jouY6");

var $bH7tU = parcelRequire("bH7tU");
const $8fcb79c48c6aed07$var$JSMGROWTH_462_EXPERIMENT_KEY = 'jsmgrowth_462_improve_switcher_signups_v2';
const $8fcb79c48c6aed07$var$itsmLogoByTheme = (colorMode = 'light')=>{
    return colorMode === 'light' ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7FO8U.JsmItsmLightIcon), {}) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9kbOy.JsmItsmDarkIcon), {});
};
const $8fcb79c48c6aed07$var$workRequestLogoByTheme = (colorMode = 'light')=>{
    return colorMode === 'light' ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $23vA4.JsmWorkRequestsLightIcon), {}) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $94exK.JsmWorkRequestsDarkIcon), {});
};
const $8fcb79c48c6aed07$var$jpdRoadmapLogoByTheme = (colorMode = 'light')=>{
    return colorMode === 'light' ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4AGx5.JpdRoadmapLightIcon), {}) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $508xd.JpdRoadmapDarkIcon), {});
};
const $8fcb79c48c6aed07$var$jpdPrioritizationLogoByTheme = (colorMode = 'light')=>{
    return colorMode === 'light' ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kaM6I.JpdPrioritizationLightIcon), {}) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $b7Nzv.JpdPrioritizationDarkIcon), {});
};
const $8fcb79c48c6aed07$var$iconMap = {
    [(0, $jouY6.COMPANY_MANAGED_GENERAL_SERVICE_PROJECT)]: $8fcb79c48c6aed07$var$workRequestLogoByTheme,
    [(0, $jouY6.SIMPLIFIED_IT_SERVICE_MANAGEMENT_BASIC)]: $8fcb79c48c6aed07$var$itsmLogoByTheme,
    [(0, $jouY6.SIMPLIFIED_IT_SERVICE_MANAGEMENT_ADVANCED)]: $8fcb79c48c6aed07$var$itsmLogoByTheme,
    [(0, $jouY6.JIRA_POLARIS_DISCOVERY)]: $8fcb79c48c6aed07$var$jpdRoadmapLogoByTheme,
    [(0, $jouY6.JIRA_POLARIS_ROADMAP)]: $8fcb79c48c6aed07$var$jpdRoadmapLogoByTheme,
    [(0, $jouY6.JIRA_POLARIS_PRIORITIZATION)]: $8fcb79c48c6aed07$var$jpdPrioritizationLogoByTheme
};
const $8fcb79c48c6aed07$var$templateNameMap = {
    [(0, $jouY6.COMPANY_MANAGED_GENERAL_SERVICE_PROJECT)]: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "cross-flow-work-requests-template.jsm.title",
        defaultMessage: "Collect requests",
        description: "Jira Service Management Work Requests template display name"
    }),
    [(0, $jouY6.SIMPLIFIED_IT_SERVICE_MANAGEMENT_BASIC)]: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "cross-flow-itsm-template.jsm.title",
        defaultMessage: "Collect IT requests",
        description: "Jira Service Management ITSM template display name"
    }),
    [(0, $jouY6.SIMPLIFIED_IT_SERVICE_MANAGEMENT_ADVANCED)]: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "cross-flow-itsm-template.jsm.title",
        defaultMessage: "Collect IT requests",
        description: "Jira Service Management ITSM template display name"
    }),
    [(0, $jouY6.JIRA_POLARIS_DISCOVERY)]: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "cross-flow-product-roadmap-template.jpd.title",
        defaultMessage: "Create a roadmap",
        description: "Jira Product Discovery product roadmap template display name"
    }),
    [(0, $jouY6.JIRA_POLARIS_ROADMAP)]: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "cross-flow-product-roadmap-template.jpd.title",
        defaultMessage: "Create a roadmap",
        description: "Jira Product Discovery product roadmap template display name"
    }),
    [(0, $jouY6.JIRA_POLARIS_PRIORITIZATION)]: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "cross-flow-product-prioritization-template.jpd.title",
        defaultMessage: "Prioritize ideas",
        description: "Jira Product Discovery product prioritization template display name"
    })
};
const $8fcb79c48c6aed07$var$productNameMap = {
    [(0, $lfqQU.Targets).JIRA_SERVICE_DESK]: 'Jira Service Management',
    [(0, $lfqQU.Targets).JIRA_PRODUCT_DISCOVERY]: 'Jira Product Discovery'
};
const $8fcb79c48c6aed07$export$7f848320b087945d = ({ productKey: productKey, entityId: entityId, recommendationSessionId: recommendationSessionId, dismiss: dismiss })=>{
    const { colorMode: colorMode } = (0, $4C7HL.default)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [ssrSafeColorMode, setSsrSafeColorMode] = (0, $euxye.useState)(undefined);
    const icon = $8fcb79c48c6aed07$var$iconMap[entityId]?.(ssrSafeColorMode);
    const templateName = $8fcb79c48c6aed07$var$templateNameMap[entityId];
    const crossFlow = (0, $8oFkF.useCrossFlow)();
    const { isSiteAdmin: isSiteAdmin } = (0, $j142y.usePostOfficeContext)();
    const isJsmOrJpdProduct = productKey === (0, $lfqQU.Targets).JIRA_SERVICE_DESK || productKey === (0, $lfqQU.Targets).JIRA_PRODUCT_DISCOVERY;
    const [isModalVariation, setIsModalVariation] = (0, $euxye.useState)(false);
    const crossFlowModalContextParams = (0, $euxye.useMemo)(()=>(0, $caA13.getProjectCreationContextParams)({
            targetProduct: productKey,
            templateKey: entityId,
            formatMessage: formatMessage
        }), [
        entityId,
        formatMessage,
        productKey
    ]);
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $6LigW.useFireCrossFlowAnalyticsEvents)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $iKPvC.useMessageInstanceEvent)();
    const adControlsRef = (0, $euxye.useRef)(null);
    const wrapTriggerRef = (0, $euxye.useCallback)((ref)=>(el)=>{
            if (el) {
                const origAdd = el.addEventListener.bind(el);
                const origRemove = el.removeEventListener.bind(el);
                const listenerMap = new WeakMap();
                el.addEventListener = function(type, fn, opts) {
                    if ((type === 'click' || type === 'mousedown') && typeof fn === 'function') {
                        const wrapped = (e)=>{
                            if (adControlsRef.current?.contains(e.target)) return;
                            fn.call(el, e);
                        };
                        listenerMap.set(fn, wrapped);
                        return origAdd(type, wrapped, opts);
                    }
                    return origAdd(type, fn, opts);
                };
                el.removeEventListener = function(type, fn, opts) {
                    if ((type === 'click' || type === 'mousedown') && typeof fn === 'function') {
                        const wrapped = listenerMap.get(fn);
                        if (wrapped) {
                            listenerMap.delete(fn);
                            return origRemove(type, wrapped, opts);
                        }
                    }
                    return origRemove(type, fn, opts);
                };
            }
            if (typeof ref === 'function') ref(el);
            else if (ref && typeof ref === 'object') ref.current = el;
        }, []);
    (0, $euxye.useEffect)(()=>{
        setSsrSafeColorMode(colorMode);
    }, [
        colorMode
    ]);
    (0, $euxye.useEffect)(()=>{
        setIsModalVariation(Boolean(isSiteAdmin && isJsmOrJpdProduct && (0, $4LDqh.default).getExperimentValue($8fcb79c48c6aed07$var$JSMGROWTH_462_EXPERIMENT_KEY, 'isEnabled', false, {
            fireExperimentExposure: false
        })));
    }, [
        isJsmOrJpdProduct,
        isSiteAdmin
    ]);
    (0, $euxye.useEffect)(()=>{
        fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'projectsMenu'
        }, {
            source: 'projectsMenuSection',
            recommendedProductIds: [
                productKey
            ],
            recommendationSession: {
                id: recommendationSessionId,
                type: 'appRec'
            }
        }, {
            sqa1052Enabled: true,
            templateId: entityId
        });
    }, [
        entityId,
        fireViewedUIEvent,
        productKey,
        recommendationSessionId
    ]);
    const handleClick = (0, $euxye.useCallback)(()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'recommendation',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'react'
            },
            additionalMetadataFromFrontend: {
                sqa1052Enabled: true,
                templateId: entityId
            }
        });
        if (isSiteAdmin && isJsmOrJpdProduct) (0, $4LDqh.default).manuallyLogExperimentExposure($8fcb79c48c6aed07$var$JSMGROWTH_462_EXPERIMENT_KEY);
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryThisRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: productKey,
            recommendationSession: {
                id: recommendationSessionId,
                type: 'appRec'
            },
            recommendedProductIds: [
                productKey
            ]
        }, {
            sqa1052Enabled: true,
            templateId: entityId
        });
        if (!isModalVariation && crossFlow.isEnabled) crossFlow.apiV1.open({
            v1: true,
            sourceComponent: 'projectsMenu',
            sourceContext: 'tryThisRecommendation',
            targetProduct: productKey,
            journey: (0, $8oFkF.Journeys).GET_STARTED,
            extensions: {
                provisioningPageOptions: {
                    actions: {
                        primary: {
                            behaviour: 'land',
                            prompt: 'next',
                            options: {
                                targetTab: 'same',
                                urlParams: {
                                    templateId: entityId
                                }
                            }
                        }
                    }
                },
                recommendationContext: {
                    recommendationSessionId: recommendationSessionId,
                    entityId: entityId
                }
            }
        });
    }, [
        crossFlow,
        entityId,
        fireInteractedUIEvent,
        messageInstanceClicked,
        productKey,
        recommendationSessionId,
        isModalVariation,
        isJsmOrJpdProduct,
        isSiteAdmin
    ]);
    const handleDismiss = (0, $euxye.useCallback)(()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {
                sqa1052Enabled: true,
                templateId: entityId
            }
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'dismissRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: productKey,
            recommendationSession: {
                id: recommendationSessionId,
                type: 'appRec'
            },
            recommendedProductIds: [
                productKey
            ]
        }, {
            sqa1052Enabled: true,
            templateId: entityId
        });
        dismiss();
    }, [
        dismiss,
        entityId,
        messageInstanceClicked,
        recommendationSessionId,
        productKey,
        fireInteractedUIEvent
    ]);
    const itemContent = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bH7tU.MenuItemBase), {
        ariaDescribedby: "try-this-recommendation-lozenge",
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2EFuW.default), {
            appearance: "new",
            isBold: false,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                id: "try-this-recommendation-lozenge",
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                    id: "post-office.nav-4-projects-recommendations.cta-button-lozenge-try",
                    defaultMessage: "Try",
                    description: "A lozenge to display the try button"
                })
            })
        }),
        onClick: handleClick,
        actionsOnHover: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            ref: adControlsRef,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3gxI9.AdControls), {
                iconSize: "small",
                spacing: "compact",
                onDismissed: handleDismiss,
                showWhyAmISeeingThis: true,
                whyAmISeeingThisModalContent: {
                    message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                        id: "post-office.nav-4-projects-recommendations.reasons-modal-explanation",
                        defaultMessage: "We think {productName} will improve your team's productivity. The recommendation is based on:",
                        description: "Explanation as to why the placeholder template is being shown",
                        values: {
                            productName: /*#__PURE__*/ (0, $e79Pd.jsx)("strong", {
                                children: $8fcb79c48c6aed07$var$productNameMap[productKey]
                            })
                        }
                    }),
                    reasons: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                            id: "post-office.nav-4-projects-recommendations.reasons-modal-bullet-one-spork",
                            defaultMessage: "the tools you use (Jira)",
                            description: "First bullet point of the reasons modal"
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                            id: "post-office.nav-4-projects-recommendations.reasons-modal-bullet-two-appify",
                            defaultMessage: "the way you use your existing tools and apps",
                            description: "Second bullet point of the reasons modal"
                        })
                    ]
                },
                additionalAnalyticsAttributes: {
                    source: 'projectsMenuSection',
                    targetProductId: productKey,
                    sqa1052Enabled: 'true'
                },
                ariaLabelledby: "nav-4-projects-recommendation-message-title"
            })
        }),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
            id: "nav-4-projects-recommendation-message-title",
            children: templateName
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "listitem",
        children: isModalVariation ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mSn8.FullScreenModalTrigger), {
            entryPoint: (0, $brCQu.crossFlowModalEntryPoint),
            entryPointParams: {},
            entryPointProps: {
                sourceComponent: 'projectsMenu',
                sourceContext: 'tryThisRecommendation',
                targetProduct: productKey,
                shouldRedirectOnSuccess: true,
                fakeBackground: 'jira',
                contextParams: crossFlowModalContextParams,
                width: (0, $04338d7cb52f2d4c$export$a907de02f9639d20),
                height: (0, $04338d7cb52f2d4c$export$3ff3f7444e69a59d)
            },
            modalProps: {
                shouldCloseOnEscapePress: true
            },
            children: ({ ref: ref })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    ref: wrapTriggerRef(ref),
                    children: itemContent
                })
        }) : itemContent
    });
};
$8fcb79c48c6aed07$export$7f848320b087945d.displayName = "Nav4Recommendation";

});
const $04338d7cb52f2d4c$export$a907de02f9639d20 = 968;
const $04338d7cb52f2d4c$export$3ff3f7444e69a59d = 620;

parcelRegister("6LigW", function(module, exports) {
$parcel$export(module.exports, "useFireCrossFlowAnalyticsEvents", () => $bd94da7e42cd4225$export$c2095165ae2bdcda);

var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $aHm5X = parcelRequire("aHm5X");

var $3YIFa = parcelRequire("3YIFa");
function $bd94da7e42cd4225$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $euxye.useRef)();
    const firedViewedUIEventId = (0, $euxye.useRef)();
    const mapToCcpProductKeys = (0, $euxye.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $aHm5X.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $aHm5X.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $euxye.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $3YIFa.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $3YIFa.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $euxye.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $3YIFa.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $3YIFa.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $euxye.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $3YIFa.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $3YIFa.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}

});
parcelRegister("aHm5X", function(module, exports) {
$parcel$export(module.exports, "FIRST_PARTY_CCP_PRODUCT_IDS", () => $72b26f49a89d23c4$export$6c053e1694ef181c);
$parcel$export(module.exports, "SURFACE_ANALYTICS_PRODUCT_MAP", () => $72b26f49a89d23c4$export$54e3fc09a2a3347a);
const $72b26f49a89d23c4$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $72b26f49a89d23c4$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $72b26f49a89d23c4$export$6c053e1694ef181c = {
    prod: $72b26f49a89d23c4$export$31048cb2a0753b12,
    staging: $72b26f49a89d23c4$export$9d8f18312db80469
};
const $72b26f49a89d23c4$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};

});

parcelRegister("3YIFa", function(module, exports) {
$parcel$export(module.exports, "CROSS_FLOW_CHANNEL", () => $e0a2c6a320df2bd1$export$c536a7e29a0739b8);
$parcel$export(module.exports, "eventTypes", () => $e0a2c6a320df2bd1$export$285f3d0989f9023f);
const $e0a2c6a320df2bd1$export$c536a7e29a0739b8 = 'crossFlow';
var $e0a2c6a320df2bd1$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});

});


parcelRegister("3gxI9", function(module, exports) {
$parcel$export(module.exports, "AdControls", () => $f33d48027c40aef6$export$c25b8b7217045de9);

var $e79Pd = parcelRequire("e79Pd");

var $m9iwH = parcelRequire("m9iwH");

var $jaPl6 = parcelRequire("jaPl6");

var $7Fzpe = parcelRequire("7Fzpe");

var $hZDXn = parcelRequire("hZDXn");

var $fGrpH = parcelRequire("fGrpH");

var $lK7pY = parcelRequire("lK7pY");

var $iKPvC = parcelRequire("iKPvC");

var $kdOoc = parcelRequire("kdOoc");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $bQorF = parcelRequire("bQorF");

var $a8eN6 = parcelRequire("a8eN6");

var $8jSoK = parcelRequire("8jSoK");
const $f33d48027c40aef6$var$DropdownTrigger = ({ triggerRef: triggerRef, name: name, iconSize: iconSize = 'small', iconColor: iconColor, spacing: spacing = 'default', ariaLabelledby: ariaLabelledby, ...triggerProps })=>{
    const intl = (0, $1YIbA.default)();
    const ariaLabel = intl.formatMessage({
        id: 'post-office.ad-controls.dropdown-menu-trigger.aria-label',
        defaultMessage: '{messageInstanceId} options menu',
        description: 'Aria label for the ad controls options dropdown menu trigger button, including the message instance ID'
    }, {
        messageInstanceId: name
    });
    const tooltip = intl.formatMessage({
        id: 'post-office.ad-controls.dropdown-menu-trigger.tooltip',
        defaultMessage: 'More actions',
        description: 'Tooltip for ad-controls dropdown'
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $hZDXn.default), {
        content: tooltip,
        isScreenReaderAnnouncementDisabled: true,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                hidden: true,
                children: ariaLabel
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
                ...triggerProps,
                label: tooltip,
                id: "ad-controls-trigger",
                appearance: "subtle",
                ref: triggerRef,
                spacing: spacing,
                icon: (iconProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7Fzpe))), {
                        ...iconProps,
                        color: iconColor,
                        size: iconSize
                    }),
                "aria-labelledby": ariaLabelledby ? `${ariaLabelledby} ad-controls-trigger` : 'ad-controls-trigger'
            })
        ]
    });
};
$f33d48027c40aef6$var$DropdownTrigger.displayName = "DropdownTrigger";
const $f33d48027c40aef6$export$c25b8b7217045de9 = ({ onDismissed: onDismissed, onRemindMeLater: onRemindMeLater, iconSize: iconSize, iconColor: iconColor, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, showWhyAmISeeingThis: showWhyAmISeeingThis, showRemindMeLater: showRemindMeLater, additionalAnalyticsAttributes: additionalAnalyticsAttributes = {}, zIndex: zIndex, spacing: spacing = 'default', customDropdownItems: customDropdownItems, ariaLabelledby: ariaLabelledby })=>{
    const [isWhyAmISeeingThisModelOpened, setIsWhyAmISeeingThisModelOpened] = (0, $euxye.useState)(false);
    const { messageDismissed: messageDismissed, messageAcknowledged: messageAcknowledged } = (0, $kdOoc.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $iKPvC.useMessageInstanceEvent)();
    const { messageInstanceId: messageInstanceId } = (0, $lK7pY.useMessageContext)();
    const [currIconColor, setCurrIconColor] = (0, $euxye.useState)(iconColor);
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    const [showDismissedFlag, setShowDismissedFlag] = (0, $euxye.useState)(false);
    const { messageSnoozed: messageSnoozed } = (0, $kdOoc.useMessageEvent)();
    const handleRemindMeLater = async ()=>{
        // https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/pre-defined-filters/#snooze-check-filter
        messageSnoozed(1); // DEPRECATED, but used alongside the messageInstanceClicked function just in case. See above page for documentation
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'remindMeLater',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'snooze',
                snoozeDuration: 1 // Snooze message for 1 day
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'remindMeLater'
        }, {
            ...additionalAnalyticsAttributes
        });
        if (messageInstanceId && typeof onRemindMeLater === 'function') // integrating with useMessagePlacementHooks removes the need to pass this callback
        onRemindMeLater(messageInstanceId);
        setShowDismissedFlag(true);
    };
    const handleNotInterested = async ()=>{
        await messageDismissed();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'notInterested',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'notInterested'
        }, {
            ...additionalAnalyticsAttributes
        });
        if (messageInstanceId && typeof onDismissed === 'function') // integrating with useMessagePlacementHooks removes the need to pass this callback
        onDismissed(messageInstanceId);
        setShowDismissedFlag(true);
    };
    const handleWhyAmISeeingThis = async ()=>{
        setIsWhyAmISeeingThisModelOpened(true);
        await messageAcknowledged();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'adControlsReasons',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsReasons'
        }, {
            ...additionalAnalyticsAttributes
        });
    };
    const fireDropdownMenuOpenAnalyticsEvent = (0, $euxye.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsDropdown'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        fireAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jaPl6.default), {
                testId: "post-office-ad-controls-dropdown",
                trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $e79Pd.jsx)($f33d48027c40aef6$var$DropdownTrigger, {
                        name: messageInstanceId,
                        triggerRef: triggerRef,
                        iconSize: iconSize,
                        iconColor: currIconColor,
                        spacing: spacing,
                        ariaLabelledby: ariaLabelledby,
                        ...triggerProps
                    }),
                ...zIndex && {
                    zIndex: zIndex
                },
                onOpenChange: (args)=>{
                    if (args.isOpen) {
                        fireDropdownMenuOpenAnalyticsEvent();
                        setCurrIconColor("var(--ds-icon-selected, #1868DB)");
                    } else setCurrIconColor(iconColor);
                },
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $a8eN6.AdControlsDropdown), {
                    onNotInterested: handleNotInterested,
                    onWhyAmISeeingThis: handleWhyAmISeeingThis,
                    onRemindMeLater: handleRemindMeLater,
                    showWhyAmISeeingThis: showWhyAmISeeingThis,
                    showRemindMeLater: showRemindMeLater ? true : false,
                    customDropdownItems: customDropdownItems
                })
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8jSoK.WhyAmISeeingThisModal), {
                content: whyAmISeeingThisModalContent,
                isOpen: isWhyAmISeeingThisModelOpened,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes,
                onClose: ()=>{
                    setIsWhyAmISeeingThisModelOpened(false);
                    fireAnalyticsEvent({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'adControlsReasonsClose'
                    }, {
                        ...additionalAnalyticsAttributes
                    });
                }
            }),
            showDismissedFlag && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bQorF.AdControlsFlag), {
                messageInstanceId: messageInstanceId,
                onCloseFlag: ()=>setShowDismissedFlag(false)
            })
        ]
    });
};
$f33d48027c40aef6$export$c25b8b7217045de9.displayName = "AdControls";

});
parcelRegister("bQorF", function(module, exports) {
$parcel$export(module.exports, "AdControlsFlag", () => $cc50855376ad4ff5$export$6eb98925a948bca3);
/* dismissalFlag.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $63XI1 = parcelRequire("63XI1");
var $8RTvC = parcelRequire("8RTvC");

var $8Qvei = parcelRequire("8Qvei");

var $ihEDU = parcelRequire("ihEDU");

var $55qdj = parcelRequire("55qdj");

var $jzzoU = parcelRequire("jzzoU");
const $cc50855376ad4ff5$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER = 'post-office-ad-controls-flag-wrapper';
/**-Title--**/ const $cc50855376ad4ff5$var$titleContainerStyles = {
    font: "_11c81qyo"
};
const $cc50855376ad4ff5$var$Title = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $cc50855376ad4ff5$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.ad-controls.dismiss-flag.not-interested.title",
            defaultMessage: "Got it, thanks for letting us know",
            description: "The title for a flag which is displayed when the Not Interested button is pressed. https://hello.atlassian.net/l/cp/ssoqm2Fq"
        })
    });
$cc50855376ad4ff5$var$Title.displayName = "Title";
/**--Description--**/ const $cc50855376ad4ff5$var$Description = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "post-office.ad-controls.dismiss-flag.not-interested.subtitle",
        defaultMessage: "You won\u2019t see this here as often.",
        description: "The subtitle for a flag which is displayed when the Not Interested button is pressed. https://hello.atlassian.net/l/cp/ssoqm2Fq"
    });
$cc50855376ad4ff5$var$Description.displayName = "Description";
/**--Confirm Icon--*/ const $cc50855376ad4ff5$var$ConfirmIcon = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Qvei))), {
        spacing: "spacious",
        label: "Success",
        color: "var(--ds-icon-success, #36B37E)"
    });
$cc50855376ad4ff5$var$ConfirmIcon.displayName = "ConfirmIcon";
const $cc50855376ad4ff5$export$6eb98925a948bca3 = ({ messageInstanceId: messageInstanceId, onCloseFlag: onCloseFlag })=>{
    (0, $jzzoU.portalZIndexFix)($cc50855376ad4ff5$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8RTvC.default), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            id: $cc50855376ad4ff5$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $63XI1.default), {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)($cc50855376ad4ff5$var$ConfirmIcon, {}),
                title: /*#__PURE__*/ (0, $e79Pd.jsx)($cc50855376ad4ff5$var$Title, {}),
                description: /*#__PURE__*/ (0, $e79Pd.jsx)($cc50855376ad4ff5$var$Description, {}),
                id: messageInstanceId,
                onDismissed: ()=>onCloseFlag()
            }, messageInstanceId)
        })
    });
};
$cc50855376ad4ff5$export$6eb98925a948bca3.displayName = "AdControlsFlag";

});
parcelRegister("jzzoU", function(module, exports) {
$parcel$export(module.exports, "portalZIndexFix", () => $c3e1b0a39372f5d8$export$cef2f5415067aeab);
const $c3e1b0a39372f5d8$var$collectionHas = (all, curr)=>{
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
};
const $c3e1b0a39372f5d8$var$findParentBySelector = (elm, selector)=>{
    const all = globalThis.document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$c3e1b0a39372f5d8$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
};
const $c3e1b0a39372f5d8$export$cef2f5415067aeab = (wrapperId)=>{
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    setTimeout(()=>{
        if (globalThis.document) {
            const modalContent = globalThis.document.getElementById(wrapperId);
            const portalSelector = '.atlaskit-portal';
            const parentPortal = $c3e1b0a39372f5d8$var$findParentBySelector(modalContent, portalSelector);
            if (parentPortal) parentPortal.setAttribute('style', 'z-index:900;');
        }
    });
// DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
};

});


parcelRegister("a8eN6", function(module, exports) {
$parcel$export(module.exports, "AdControlsDropdown", () => $c5dace43a34a1356$export$ba7539b3ac68f9f1);

var $e79Pd = parcelRequire("e79Pd");

var $2YPKP = parcelRequire("2YPKP");
var $2Xkyn = parcelRequire("2Xkyn");

var $55qdj = parcelRequire("55qdj");
const $c5dace43a34a1356$export$99f2c116e7ad8950 = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $2YPKP.default), {
        ...props,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label",
            defaultMessage: "Why am I seeing this?",
            description: "The text for the button which opens a modal showing the reasons a message has been displayed."
        })
    });
$c5dace43a34a1356$export$99f2c116e7ad8950.displayName = "WhyAmISeeingThis";
const $c5dace43a34a1356$export$80eb3e3679dfe382 = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $2YPKP.default), {
        ...props,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.ad-controls.dropdown-item.not-interested.label",
            defaultMessage: "Not interested",
            description: "The text for the button which removes a message from a placement."
        })
    });
$c5dace43a34a1356$export$80eb3e3679dfe382.displayName = "NotInterested";
const $c5dace43a34a1356$export$c3a3ff4a62111967 = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $2YPKP.default), {
        ...props,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.ad-controls.dropdown-item.remind-me-later.label",
            defaultMessage: "Remind me later",
            description: "The text for the button which removes a message from a placement and makes it reappear at a later date."
        })
    });
$c5dace43a34a1356$export$c3a3ff4a62111967.displayName = "RemindMeLater";
const $c5dace43a34a1356$export$ba7539b3ac68f9f1 = ({ onWhyAmISeeingThis: onWhyAmISeeingThis, onNotInterested: onNotInterested, onRemindMeLater: onRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis = true, showRemindMeLater: showRemindMeLater, customDropdownItems: customDropdownItems })=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2Xkyn.default), {
        children: [
            customDropdownItems?.map((item)=>item),
            showRemindMeLater && /*#__PURE__*/ (0, $e79Pd.jsx)($c5dace43a34a1356$export$c3a3ff4a62111967, {
                testId: "ad-controls-dropdown-remind-me-later",
                onClick: onRemindMeLater
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)($c5dace43a34a1356$export$80eb3e3679dfe382, {
                testId: "ad-controls-dropdown-not-interested",
                onClick: onNotInterested
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $e79Pd.jsx)($c5dace43a34a1356$export$99f2c116e7ad8950, {
                testId: "ad-controls-dropdown-why-am-I-seeing-this",
                onClick: onWhyAmISeeingThis
            })
        ]
    });
$c5dace43a34a1356$export$ba7539b3ac68f9f1.displayName = "AdControlsDropdown";

});

parcelRegister("8jSoK", function(module, exports) {
$parcel$export(module.exports, "WhyAmISeeingThisModal", () => $58149e831a925b8d$export$b29014abf8076d54);
/* modal.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $4qNCE = parcelRequire("4qNCE");

var $hzWaA = parcelRequire("hzWaA");

var $7tY81 = parcelRequire("7tY81");

var $2v3yi = parcelRequire("2v3yi");

var $4vluQ = parcelRequire("4vluQ");

var $gpyJM = parcelRequire("gpyJM");

var $dNPnD = parcelRequire("dNPnD");

var $9imxF = parcelRequire("9imxF");

var $ihEDU = parcelRequire("ihEDU");

var $fGrpH = parcelRequire("fGrpH");

var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $jzzoU = parcelRequire("jzzoU");
const $58149e831a925b8d$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT = 'why-am-i-seeing-this-modal-content';
const $58149e831a925b8d$export$2b77a92f1a5ad772 = ({ children: children, isOpen: isOpen, onClose: onClose })=>{
    (0, $jzzoU.portalZIndexFix)($58149e831a925b8d$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9imxF.default), {
        children: isOpen && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7tY81.default), {
            shouldCloseOnEscapePress: true,
            onClose: onClose,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                id: $58149e831a925b8d$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT,
                children: children
            })
        })
    });
};
$58149e831a925b8d$export$2b77a92f1a5ad772.displayName = "Modal";
const $58149e831a925b8d$var$AcceptButton = ({ onClick: onClick })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $4qNCE.default), {
        appearance: "primary",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.ad-controls.reasons-modal.accept-button.label-ok",
            defaultMessage: "OK",
            description: "The text on the button that dismisses a modal which provides reasons a message has been displayed"
        })
    });
$58149e831a925b8d$var$AcceptButton.displayName = "AcceptButton";
/*--Title--*/ const $58149e831a925b8d$var$titleContainerStyles = {
    font: "_11c81af2"
};
const $58149e831a925b8d$var$Title = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $58149e831a925b8d$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.ad-controls.reasons-modal.title",
            defaultMessage: "Why am I seeing this?",
            description: "The title for a modal that displays the reasons a message was displayed."
        })
    });
$58149e831a925b8d$var$Title.displayName = "Title";
/*--Body--*/ const $58149e831a925b8d$var$DefaultBody = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)("p", {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.ad-controls.reasons-modal.body",
            defaultMessage: "We think you'd find this relevant. This is based on:",
            description: "Explanation of why we think the message will be releavant to the customer."
        })
    });
$58149e831a925b8d$var$DefaultBody.displayName = "DefaultBody";
const $58149e831a925b8d$var$reasonsListStyles = null;
const $58149e831a925b8d$var$ReasonsList = ({ reasons: reasons })=>/*#__PURE__*/ (0, $e79Pd.jsx)("ul", {
        className: (0, $4jQY2.default)([
            "_2mzu1wth _19bvv47k _19pkutpp"
        ]),
        children: reasons.map((reason, index)=>/*#__PURE__*/ (0, $e79Pd.jsx)("li", {
                children: reason
            }, index))
    });
$58149e831a925b8d$var$ReasonsList.displayName = "ReasonsList";
const $58149e831a925b8d$var$privacyPolicyLinkWrapperStyles = null;
const $58149e831a925b8d$export$fdd773f48aebb8ab = ({ onClick: onClick })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_19pkutpp"
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hzWaA.default), {
            href: 'https://www.atlassian.com/legal/privacy-policy',
            target: "_blank",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "post-office.ad-controls.reasons-modal.privacy-policy-link.text",
                defaultMessage: "Learn more about your data privacy with Atlassian",
                description: "The text linking to Atlassian's privacy policy. https://hello.atlassian.net/l/cp/ssoqm2Fq"
            })
        })
    });
$58149e831a925b8d$export$fdd773f48aebb8ab.displayName = "PrivacyPolicyLink";
const $58149e831a925b8d$var$ReasonsModalDefaultBody = ({ onClose: onClose, content: content, additionalAnalyticsAttributes: additionalAnalyticsAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'adControlsReasonsModal'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        fireAnalyticsEvent,
        additionalAnalyticsAttributes
    ]);
    const handleOnPrivacyPolicy = (0, $euxye.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'adControlsPrivacyPolicy'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        fireAnalyticsEvent,
        additionalAnalyticsAttributes
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gpyJM.default), {
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dNPnD.default), {
                    children: content?.title || /*#__PURE__*/ (0, $e79Pd.jsx)($58149e831a925b8d$var$Title, {})
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2v3yi.default), {
                children: content?.body || /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                    children: [
                        content?.message || /*#__PURE__*/ (0, $e79Pd.jsx)($58149e831a925b8d$var$DefaultBody, {}),
                        content?.reasons && /*#__PURE__*/ (0, $e79Pd.jsx)($58149e831a925b8d$var$ReasonsList, {
                            reasons: content.reasons
                        }),
                        content?.privacyPolicy || /*#__PURE__*/ (0, $e79Pd.jsx)($58149e831a925b8d$export$fdd773f48aebb8ab, {
                            onClick: ()=>handleOnPrivacyPolicy()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4vluQ.default), {
                children: /*#__PURE__*/ (0, $e79Pd.jsx)($58149e831a925b8d$var$AcceptButton, {
                    onClick: onClose
                })
            })
        ]
    });
};
$58149e831a925b8d$var$ReasonsModalDefaultBody.displayName = "ReasonsModalDefaultBody";
const $58149e831a925b8d$export$b29014abf8076d54 = (props)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)($58149e831a925b8d$export$2b77a92f1a5ad772, {
        isOpen: props.isOpen,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($58149e831a925b8d$var$ReasonsModalDefaultBody, {
            ...props
        })
    });
};
$58149e831a925b8d$export$b29014abf8076d54.displayName = "WhyAmISeeingThisModal";

});


parcelRegister("brCQu", function(module, exports) {
$parcel$export(module.exports, "crossFlowModalEntryPoint", () => $2fb8d546318e2c2e$export$339fed52d8b037b0);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $2fb8d546318e2c2e$export$339fed52d8b037b0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("iDvHC")), {
        moduleId: "880484c6",
        priority: "interaction",
        moduleId: 'post-office-cross-flow-modal'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iDvHC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4C6Ru").then(()=>parcelRequire('jj7em'));

});


parcelRegister("caA13", function(module, exports) {
$parcel$export(module.exports, "getProjectCreationContextParams", () => $b67372ff35432221$export$5c75876f63f298f7);

var $lfqQU = parcelRequire("lfqQU");
const $b67372ff35432221$var$JSM_GENERAL_SERVICE_MANAGEMENT_KEY = 'jsm.general-service-management';
const $b67372ff35432221$var$JSM_GENERAL_SERVICE_MANAGEMENT_CMP_KEY = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $b67372ff35432221$var$JSM_IT_SERVICE_MANAGEMENT_KEY = 'jsm.it-service-management';
const $b67372ff35432221$var$JSM_IT_SERVICE_MANAGEMENT_BASIC_KEY = 'jsm.it-service-management-basic';
const $b67372ff35432221$var$JSM_IT_SERVICE_MANAGEMENT_ADVANCED_KEY = 'jsm.it-service-management-advanced';
const $b67372ff35432221$var$JSM_BLANK_SERVICE_MANAGEMENT_KEY = 'jsm.blank-service-management';
const $b67372ff35432221$var$JSM_IT_SERVICE_MANAGEMENT_BASIC_CMP_KEY = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $b67372ff35432221$var$JSM_IT_SERVICE_MANAGEMENT_ADVANCED_CMP_KEY = 'com.atlassian.servicedesk:simplified-it-service-management';
const $b67372ff35432221$var$JSM_CUSTOMER_SERVICE_MANAGEMENT_KEY = 'jsm.customer-service-management';
const $b67372ff35432221$var$JSM_CUSTOMER_SERVICE_MANAGEMENT_CMP_KEY = 'com.atlassian.jcs:customer-service-management';
const $b67372ff35432221$var$JIRA_CUSTOMER_SERVICE_TARGET = 'jira-customer-service';
const $b67372ff35432221$var$JPD_PRODUCT_DISCOVERY_KEY = 'jpd.product-discovery';
const $b67372ff35432221$var$JPD_PRODUCT_DISCOVERY_TMP_KEY = 'jira.polaris:discovery';
const $b67372ff35432221$var$JPD_PRODUCT_ROADMAP_KEY = 'jpd.product-roadmap';
const $b67372ff35432221$var$JPD_PRODUCT_ROADMAP_TMP_KEY = 'jira.polaris:roadmap';
const $b67372ff35432221$var$JPD_PRIORITIZATION_KEY = 'jpd.prioritization';
const $b67372ff35432221$var$JPD_PRIORITIZATION_TMP_KEY = 'jira.polaris:prioritization';
const $b67372ff35432221$var$projectNameMessages = {
    support: {
        id: 'jsm-auto-create-project-name.support',
        description: 'This is the name for a project that is automatically created when cross-flowing to JSM. This will be the name used for the "General service management for IT teams" template',
        defaultMessage: 'Support'
    },
    requests: {
        id: 'jsm-auto-create-project-name.requests',
        description: 'This is the name for a project that is automatically created when cross-flowing to JSM. This will be the name used for the "General service management for business teams" template',
        defaultMessage: 'Requests'
    },
    customerService: {
        id: 'jsm-auto-create-project-name.customer-service',
        description: 'This is the name for a project that is automatically created when cross-flowing to JSM. This will be the name used for the "Customer service management" template',
        defaultMessage: 'Customer service'
    },
    ideas: {
        id: 'jpd-auto-create-project-name.ideas',
        description: 'This is the name for a project that is automatically created when cross-flowing to JPD. This will be the name used for the "Product discovery" template',
        defaultMessage: 'My discovery project'
    },
    prioritization: {
        id: 'jpd-auto-create-project-name.prioritization',
        description: 'This is the name for a project that is automatically created when cross-flowing to JPD. This will be the name used for the "Prioritization" template',
        defaultMessage: 'Prioritization'
    }
};
const $b67372ff35432221$var$jsmSupportTemplateKeys = new Set([
    $b67372ff35432221$var$JSM_GENERAL_SERVICE_MANAGEMENT_KEY,
    $b67372ff35432221$var$JSM_GENERAL_SERVICE_MANAGEMENT_CMP_KEY,
    $b67372ff35432221$var$JSM_IT_SERVICE_MANAGEMENT_KEY,
    $b67372ff35432221$var$JSM_IT_SERVICE_MANAGEMENT_BASIC_KEY,
    $b67372ff35432221$var$JSM_IT_SERVICE_MANAGEMENT_ADVANCED_KEY,
    $b67372ff35432221$var$JSM_BLANK_SERVICE_MANAGEMENT_KEY,
    $b67372ff35432221$var$JSM_IT_SERVICE_MANAGEMENT_BASIC_CMP_KEY,
    $b67372ff35432221$var$JSM_IT_SERVICE_MANAGEMENT_ADVANCED_CMP_KEY
]);
const $b67372ff35432221$var$csmTemplateKeys = new Set([
    $b67372ff35432221$var$JSM_CUSTOMER_SERVICE_MANAGEMENT_KEY,
    $b67372ff35432221$var$JSM_CUSTOMER_SERVICE_MANAGEMENT_CMP_KEY
]);
const $b67372ff35432221$var$jpdProjectNameMessageByTemplateKey = new Map([
    [
        $b67372ff35432221$var$JPD_PRODUCT_DISCOVERY_KEY,
        $b67372ff35432221$var$projectNameMessages.ideas
    ],
    [
        $b67372ff35432221$var$JPD_PRODUCT_DISCOVERY_TMP_KEY,
        $b67372ff35432221$var$projectNameMessages.ideas
    ],
    // Keep roadmap aligned with growth-kit control:
    // cross-flow-frontend/src/common/services/create-project/constants.ts maps
    // PRODUCT_ROADMAP_KEY and PRODUCT_ROADMAP_TMP_KEY to messages.ideas.
    [
        $b67372ff35432221$var$JPD_PRODUCT_ROADMAP_KEY,
        $b67372ff35432221$var$projectNameMessages.ideas
    ],
    [
        $b67372ff35432221$var$JPD_PRODUCT_ROADMAP_TMP_KEY,
        $b67372ff35432221$var$projectNameMessages.ideas
    ],
    [
        $b67372ff35432221$var$JPD_PRIORITIZATION_KEY,
        $b67372ff35432221$var$projectNameMessages.prioritization
    ],
    [
        $b67372ff35432221$var$JPD_PRIORITIZATION_TMP_KEY,
        $b67372ff35432221$var$projectNameMessages.prioritization
    ]
]);
const $b67372ff35432221$var$defaultProjectNameMessageByTargetProduct = new Map([
    [
        (0, $lfqQU.Targets).JIRA_SERVICE_DESK,
        $b67372ff35432221$var$projectNameMessages.requests
    ],
    [
        (0, $lfqQU.Targets).JIRA_PRODUCT_DISCOVERY,
        $b67372ff35432221$var$projectNameMessages.ideas
    ],
    [
        $b67372ff35432221$var$JIRA_CUSTOMER_SERVICE_TARGET,
        $b67372ff35432221$var$projectNameMessages.customerService
    ]
]);
const $b67372ff35432221$var$getProjectNameMessage = (targetProduct, templateKey)=>{
    if (targetProduct === (0, $lfqQU.Targets).JIRA_SERVICE_DESK && $b67372ff35432221$var$jsmSupportTemplateKeys.has(templateKey)) return $b67372ff35432221$var$projectNameMessages.support;
    if (targetProduct === $b67372ff35432221$var$JIRA_CUSTOMER_SERVICE_TARGET && $b67372ff35432221$var$csmTemplateKeys.has(templateKey)) return $b67372ff35432221$var$projectNameMessages.customerService;
    if (targetProduct === (0, $lfqQU.Targets).JIRA_PRODUCT_DISCOVERY) return $b67372ff35432221$var$jpdProjectNameMessageByTemplateKey.get(templateKey) ?? $b67372ff35432221$var$defaultProjectNameMessageByTargetProduct.get(targetProduct);
    return $b67372ff35432221$var$defaultProjectNameMessageByTargetProduct.get(targetProduct);
};
const $b67372ff35432221$export$5c75876f63f298f7 = ({ targetProduct: targetProduct, templateKey: templateKey, formatMessage: formatMessage })=>{
    if (!templateKey) return undefined;
    const projectNameMessage = $b67372ff35432221$var$getProjectNameMessage(targetProduct, templateKey);
    const projectName = projectNameMessage ? formatMessage(projectNameMessage) : undefined;
    return {
        templateKey: templateKey,
        ...projectName ? {
            projectName: projectName
        } : {}
    };
};

});

parcelRegister("b7Nzv", function(module, exports) {
$parcel$export(module.exports, "JpdPrioritizationDarkIcon", () => $2b116382a1eb2461$export$979c0ddd3e576ea8);

var $e79Pd = parcelRequire("e79Pd");
const $2b116382a1eb2461$export$979c0ddd3e576ea8 = ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "4",
                fill: "#48245d"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M16.635 9.804H6.487v4.958h10.148z",
                fill: "#bf63f3"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M13.481 6.724H3.333v4.959h10.148z",
                fill: "#fca700"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M13.481 9.804H6.487v1.879h6.994z",
                fill: "#ae2a19"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m16.004 11.595-2.185 2.186-1.13-1.16.488-.474.65.667 1.698-1.698.481.481z",
                fill: "#fff"
            })
        ]
    });
$2b116382a1eb2461$export$979c0ddd3e576ea8.displayName = "JpdPrioritizationDarkIcon";

});

parcelRegister("kaM6I", function(module, exports) {
$parcel$export(module.exports, "JpdPrioritizationLightIcon", () => $1da80b7fa168c15b$export$57283dc889982ca9);

var $e79Pd = parcelRequire("e79Pd");
const $1da80b7fa168c15b$export$57283dc889982ca9 = ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "4",
                fill: "#eed7fc"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M16.635 9.804H6.487v4.958h10.148z",
                fill: "#bf63f3"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M13.481 6.724H3.333v4.959h10.148z",
                fill: "#fca700"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M13.481 9.804H6.487v1.879h6.994z",
                fill: "#ae2a19"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m16.004 11.595-2.185 2.186-1.13-1.16.488-.474.65.667 1.698-1.698.481.481z",
                fill: "#fff"
            })
        ]
    });
$1da80b7fa168c15b$export$57283dc889982ca9.displayName = "JpdPrioritizationLightIcon";

});

parcelRegister("508xd", function(module, exports) {
$parcel$export(module.exports, "JpdRoadmapDarkIcon", () => $9b9eec9c3dc55f57$export$b69a0be5f6e4769e);

var $e79Pd = parcelRequire("e79Pd");
const $9b9eec9c3dc55f57$export$b69a0be5f6e4769e = ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "4",
                fill: "#48245d"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M6.286 5.158h5.52a2.858 2.858 0 0 1 0 5.714H8.379a1.333 1.333 0 1 0 0 2.667H13.9v1.523H8.38a2.858 2.858 0 0 1 0-5.714h3.428a1.333 1.333 0 1 0 0-2.667H6.286z",
                fill: "#1868db"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M6.286 8.186A2.284 2.284 0 0 0 8.57 5.901a2.284 2.284 0 0 0-2.285-2.286A2.284 2.284 0 0 0 4 5.901a2.284 2.284 0 0 0 2.286 2.285M16 12.195h-4.19v4.19H16z",
                fill: "#fca700"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M8.445 5.158A2.26 2.26 0 0 1 8.43 6.68H6.286V5.158z",
                fill: "#09326c"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M8.569 5.898c0 .276-.049.54-.14.783H6.286V5.158h2.16q.121.35.123.74m4.931 10.16v-.998h-1.69v-1.524h1.69v-.998l1.757 1.76z",
                fill: "#09326c"
            })
        ]
    });
$9b9eec9c3dc55f57$export$b69a0be5f6e4769e.displayName = "JpdRoadmapDarkIcon";

});

parcelRegister("4AGx5", function(module, exports) {
$parcel$export(module.exports, "JpdRoadmapLightIcon", () => $9b85884c8e94e015$export$be223adc9c973302);

var $e79Pd = parcelRequire("e79Pd");
const $9b85884c8e94e015$export$be223adc9c973302 = ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "4",
                fill: "#eed7fc"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M6.286 5.158h5.52a2.858 2.858 0 0 1 0 5.714H8.379a1.333 1.333 0 1 0 0 2.667H13.9v1.523H8.38a2.858 2.858 0 0 1 0-5.714h3.428a1.333 1.333 0 1 0 0-2.667H6.286z",
                fill: "#1868db"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M6.286 8.186A2.284 2.284 0 0 0 8.57 5.901a2.284 2.284 0 0 0-2.285-2.286A2.284 2.284 0 0 0 4 5.901a2.284 2.284 0 0 0 2.286 2.285M16 12.195h-4.19v4.19H16z",
                fill: "#fca700"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M8.445 5.158A2.26 2.26 0 0 1 8.43 6.68H6.286V5.158z",
                fill: "#09326c"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M8.569 5.898c0 .276-.049.54-.14.783H6.286V5.158h2.16q.121.35.123.74m4.931 10.16v-.998h-1.69v-1.524h1.69v-.998l1.757 1.76z",
                fill: "#09326c"
            })
        ]
    });
$9b85884c8e94e015$export$be223adc9c973302.displayName = "JpdRoadmapLightIcon";

});

parcelRegister("9kbOy", function(module, exports) {
$parcel$export(module.exports, "JsmItsmDarkIcon", () => $c7946ba9a6e9073f$export$cf305ef8885e007f);

var $e79Pd = parcelRequire("e79Pd");
const $c7946ba9a6e9073f$export$cf305ef8885e007f = ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                x: "2",
                y: "2",
                width: "20",
                height: "20",
                rx: "4",
                fill: "#48245D"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M17.82 7.194H6.18v7.623h11.64z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M15.127 15.86v1.296H8.873V15.86h2.083v-2.325h2.088v2.325z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M13.044 13.535h-2.088v1.284h2.088z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M12 12.815a1.808 1.808 0 1 0 0-3.617 1.808 1.808 0 0 0 0 3.617",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M18.082 7.28c.172-.015 2.48-.563 1.875-.681-.224.061-.399-.001-.511.166-.033-.197-.473.118-.54.13-.031-.15-.721.235-.62.096-.314.004-.703.112-1.108.238-.198-.132.652-1.075.295-.872.025-.053.12-.282.108-.13.113-.13 1.343-2.123.832-1.785-.345.41-.605 1.1-.897 1.44-.284.114-.481 1.101-.798 1.003-.184-.222-.66-2.938-.999-2.697.059.211.005.4.17.502-.201.032.12.464.132.53-.15.029.237.708.098.609.003.192.047.414.11.65-.084-.064-.177-.208-.23-.23-.57-.226-1.002-.746-1.595-1.028-.499.623 3.91 2.196 1.176 2.431-.514.33-1.197.38-1.771.697-.05.686 3.221-1.207 2.277-.12-.146.46-.364.976-.665 1.429-.192 1.727 1.442-2.965 1.374-1.175.225.428.443.943.555 1.474.799 1.15-.292-1.893-.406-2.324.433-.181 2.107 1.875 2.41 1.55.014-.045-.227-.3-.3-.327-.05.025-.074.045-.103 0 .146-.14-.369-.315-.417-.362.108-.106-.608-.45-.435-.444-.134-.184-.339-.37-.572-.556.414-.078.594-.365.556-.216z",
                fill: "#CECFD2"
            })
        ]
    });
$c7946ba9a6e9073f$export$cf305ef8885e007f.displayName = "JsmItsmDarkIcon";

});

parcelRegister("7FO8U", function(module, exports) {
$parcel$export(module.exports, "JsmItsmLightIcon", () => $a65154d5109cf02b$export$c9a0cb94b7717280);

var $e79Pd = parcelRequire("e79Pd");
const $a65154d5109cf02b$export$c9a0cb94b7717280 = ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                x: "2",
                y: "2",
                width: "20",
                height: "20",
                rx: "4",
                fill: "#EED7FC"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M17.82 7.194H6.18v7.623h11.64z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M15.127 15.86v1.296H8.873V15.86h2.083v-2.325h2.088v2.325z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M13.044 13.535h-2.088v1.284h2.088z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M12 12.815a1.808 1.808 0 1 0 0-3.617 1.808 1.808 0 0 0 0 3.617",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M18.082 7.28c.172-.015 2.48-.563 1.875-.681-.224.061-.399-.001-.511.166-.033-.197-.473.118-.54.13-.031-.15-.721.235-.62.096-.314.004-.703.112-1.108.238-.198-.132.652-1.075.295-.872.025-.053.12-.282.108-.13.113-.13 1.343-2.123.832-1.785-.345.41-.605 1.1-.897 1.44-.284.114-.481 1.101-.798 1.003-.184-.222-.66-2.938-.999-2.697.059.211.005.4.17.502-.201.032.12.464.132.53-.15.029.237.708.098.609.003.192.047.414.11.65-.084-.064-.177-.208-.23-.23-.57-.226-1.002-.746-1.595-1.028-.499.623 3.91 2.196 1.176 2.431-.514.33-1.197.38-1.771.697-.05.686 3.221-1.207 2.277-.12-.146.46-.364.976-.665 1.429-.192 1.727 1.442-2.965 1.374-1.175.225.428.443.943.555 1.474.799 1.15-.292-1.893-.406-2.324.433-.181 2.107 1.875 2.41 1.55.014-.045-.227-.3-.3-.327-.05.025-.074.045-.103 0 .146-.14-.369-.315-.417-.362.108-.106-.608-.45-.435-.444-.134-.184-.339-.37-.572-.556.414-.078.594-.365.556-.216z",
                fill: "#101214"
            })
        ]
    });
$a65154d5109cf02b$export$c9a0cb94b7717280.displayName = "JsmItsmLightIcon";

});

parcelRegister("94exK", function(module, exports) {
$parcel$export(module.exports, "JsmWorkRequestsDarkIcon", () => $07c4f46130167368$export$f55a45601bcb44f0);

var $e79Pd = parcelRequire("e79Pd");
const $07c4f46130167368$export$f55a45601bcb44f0 = ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                x: "2",
                y: "2",
                width: "20",
                height: "20",
                rx: "4",
                fill: "#48245D"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M6.59 6.592V15.4h8.808V6.592zm3.775 1.891h3.145v.944h-3.145zm0 2.04h3.145v.944h-3.145zM8.794 8.32c.346 0 .629.283.629.629s-.283.63-.63.63a.63.63 0 0 1 0-1.26m0 2.046a.63.63 0 1 1-.002 1.26.63.63 0 0 1 .002-1.26",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M16.594 12.025v1.46h-6.23v2.97h6.23v1.753l3.09-3.093z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M10.365 13.485V15.4h5.033v-1.915z",
                fill: "#09326C"
            })
        ]
    });
$07c4f46130167368$export$f55a45601bcb44f0.displayName = "JsmWorkRequestsDarkIcon";

});

parcelRegister("23vA4", function(module, exports) {
$parcel$export(module.exports, "JsmWorkRequestsLightIcon", () => $d2665fd83dca0e6f$export$1847837dcfca048);

var $e79Pd = parcelRequire("e79Pd");
const $d2665fd83dca0e6f$export$1847837dcfca048 = ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                x: "2",
                y: "2",
                width: "20",
                height: "20",
                rx: "4",
                fill: "#EED7FC"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M6.59 6.592V15.4h8.808V6.592zm3.775 1.891h3.145v.944h-3.145zm0 2.04h3.145v.944h-3.145zM8.794 8.32c.346 0 .629.283.629.629s-.283.63-.63.63a.63.63 0 0 1 0-1.26m0 2.046a.63.63 0 1 1-.002 1.26.63.63 0 0 1 .002-1.26",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M16.594 12.025v1.46h-6.23v2.97h6.23v1.753l3.09-3.093z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M10.365 13.485V15.4h5.033v-1.915z",
                fill: "#09326C"
            })
        ]
    });
$d2665fd83dca0e6f$export$1847837dcfca048.displayName = "JsmWorkRequestsLightIcon";

});

parcelRegister("jouY6", function(module, exports) {
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT", () => $33a5a041ea9a046e$export$c3e144a7c0c15eeb);
$parcel$export(module.exports, "SIMPLIFIED_IT_SERVICE_MANAGEMENT_BASIC", () => $33a5a041ea9a046e$export$8234a0b97fcd98f7);
$parcel$export(module.exports, "SIMPLIFIED_IT_SERVICE_MANAGEMENT_ADVANCED", () => $33a5a041ea9a046e$export$1b43fa0c28045e5d);
$parcel$export(module.exports, "COMPANY_MANAGED_GENERAL_SERVICE_PROJECT", () => $33a5a041ea9a046e$export$caba3a012f3ef052);
$parcel$export(module.exports, "JIRA_POLARIS_ROADMAP", () => $33a5a041ea9a046e$export$473248b9a001708);
$parcel$export(module.exports, "JIRA_POLARIS_PRIORITIZATION", () => $33a5a041ea9a046e$export$b20cfecc4079b831);
$parcel$export(module.exports, "JIRA_POLARIS_DISCOVERY", () => $33a5a041ea9a046e$export$4c63fcaece809b21);

var $lfqQU = parcelRequire("lfqQU");
const $33a5a041ea9a046e$export$c3e144a7c0c15eeb = 'jsm.it-service-management';
const $33a5a041ea9a046e$export$8234a0b97fcd98f7 = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $33a5a041ea9a046e$export$1b43fa0c28045e5d = 'com.atlassian.servicedesk:simplified-it-service-management';
const $33a5a041ea9a046e$export$caba3a012f3ef052 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $33a5a041ea9a046e$export$473248b9a001708 = 'jira.polaris:roadmap';
const $33a5a041ea9a046e$export$b20cfecc4079b831 = 'jira.polaris:prioritization';
const $33a5a041ea9a046e$export$4c63fcaece809b21 = 'jira.polaris:discovery';
const $33a5a041ea9a046e$var$rerankCandidateList = [
    {
        entityId: $33a5a041ea9a046e$export$4c63fcaece809b21,
        productKey: (0, $lfqQU.Targets).JIRA_PRODUCT_DISCOVERY,
        recommendationSessionId: 'placeholder'
    },
    {
        entityId: $33a5a041ea9a046e$export$473248b9a001708,
        productKey: (0, $lfqQU.Targets).JIRA_PRODUCT_DISCOVERY,
        recommendationSessionId: 'placeholder'
    },
    {
        entityId: $33a5a041ea9a046e$export$b20cfecc4079b831,
        productKey: (0, $lfqQU.Targets).JIRA_PRODUCT_DISCOVERY,
        recommendationSessionId: 'placeholder'
    },
    {
        entityId: $33a5a041ea9a046e$export$caba3a012f3ef052,
        productKey: (0, $lfqQU.Targets).JIRA_SERVICE_DESK,
        recommendationSessionId: 'placeholder'
    },
    {
        entityId: $33a5a041ea9a046e$export$c3e144a7c0c15eeb,
        productKey: (0, $lfqQU.Targets).JIRA_SERVICE_DESK,
        recommendationSessionId: 'placeholder'
    }
];
const $33a5a041ea9a046e$export$cdc76cfd02c28c33 = async (requestContext)=>{
    const { logger: logger, orchestrationContext: orchestrationContext } = requestContext;
    const tenantId = orchestrationContext.tenantId;
    const userId = orchestrationContext.recipient.userId;
    if (!tenantId) {
        logger.error('JSMGROWTH-204 experiment tenantId is not available');
        return [];
    }
    if (!userId) {
        logger.error('JSMGROWTH-204 experiment userId is not available');
        return [];
    }
    return $33a5a041ea9a046e$var$rerankCandidateList.filter((candidate)=>candidate.entityId !== $33a5a041ea9a046e$export$4c63fcaece809b21).map((recommendation)=>({
            messageTemplateContext: recommendation,
            messageInstanceSeed: {
                value: `nav-4-projects-section-recommendation.${recommendation.entityId}`,
                version: '1'
            }
        }));
};

});

parcelRegister("bH7tU", function(module, exports) {
$parcel$export(module.exports, "MenuItemBase", () => $3b71040028798abb$export$859b390bf71e044e);
/* menu-item.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $hAt2p = parcelRequire("hAt2p");

var $ljVHR = parcelRequire("ljVHR");

var $9MWap = parcelRequire("9MWap");
var $6mEZn = parcelRequire("6mEZn");
var $8Sdzy = parcelRequire("8Sdzy");

var $hZDXn = parcelRequire("hZDXn");
var $8qjTI = parcelRequire("8qjTI");

var $9S1b6 = parcelRequire("9S1b6");

var $euxye = parcelRequire("euxye");

var $euYHK = parcelRequire("euYHK");
const $3b71040028798abb$var$tooltipStyles = {
    root: "_2rko12b0 _11c8wadc _1e0c1txw _2lx21bp4 _1bah1h6o _1tkezwfg _p12f1pna _vchhusvi _1q51v77o _y4ti12x7 _85i5v77o _bozg12x7 _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _slp31hna"
};
const $3b71040028798abb$var$MenuItemTooltip = /*#__PURE__*/ (0, $euxye.forwardRef)(function MenuItemTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8qjTI.default), {
        ...rest,
        // Manually passing on `className` so it gets merged correctly in the build output.
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $4jQY2.default)([
            $3b71040028798abb$var$tooltipStyles.root,
            className
        ]),
        // "css" does not "exist" - it gets transformed into "className" by compiled
        ref: ref,
        children: children
    });
});
function $3b71040028798abb$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $3b71040028798abb$var$defaultAvatarValues = {
    size: 'small'
};
const $3b71040028798abb$var$elemAfterDisplayVar = '--elem-after-display';
const $3b71040028798abb$var$actionsOnHoverDisplayVar = '--actions-on-hover-display';
const $3b71040028798abb$var$notchColorVar = '--notch-color';
/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. drop indicators for drag and drop
 * 3. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */ const $3b71040028798abb$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
};
/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */ const $3b71040028798abb$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
};
const $3b71040028798abb$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup="true"])';
const $3b71040028798abb$var$containerStyles = {
    root: "_2rko12b0 _vchhusvi _1e0c11p5 _yv0e7dup _2z05hkll _1lmcu4vt _1ul9t9kd _4t3izwfg _4cvr1h6o _uiztglyw _syazazsu _ek6gglyw _1yyu3acm _91ju1txw _1swv19i6 _1ojv1txw _irr319i6 _1brr1txw _109x1txw",
    removeElemAfter: "_91juglyw",
    showHoverActions: "_ek6g1txw",
    removeElemAfterOnHover: "_1mfcglyw _1sjuglyw",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1djyglyw _1mfcglyw _1sjuglyw",
    selected: "_bfhk15s3 _syaz6x5g _1yyujmqp _1swvufnl _30l36x5g _irr3ufnl",
    disabled: "_syaz1gmx _irr3n7od",
    hasDescription: "_4t3ickbl"
};
const $3b71040028798abb$var$buttonOrAnchorStyles = {
    root: "_2rko12b0 _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _2z05nbh3 _y4ti1b66 _bozg1b66 _1q511b66 _85i51b66 _bfhk18uv _syazazsu _4cvr1h6o _y3gnv2br _14iu13ro",
    selected: "_syaz6x5g _14iunozp"
};
const $3b71040028798abb$var$extendButtonOrAnchorStyles = {
    root: "_1r04ze3t _kqswstnw"
};
const $3b71040028798abb$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
const $3b71040028798abb$var$actionStyles = {
    root: "_zulp1b66 _nd5lbc26 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $3b71040028798abb$var$actionsOnHoverStyles = {
    root: "_nd5l16dh _zulp1b66 _1reo15vq _18m915vq _1e0c1c3z _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $3b71040028798abb$var$textStyles = {
    root: "_zulpv77o _1reo15vq _18m915vq _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
    noElemBeforeIndent: "_bozg12x7"
};
const $3b71040028798abb$var$elemBeforeStyles = {
    root: "_nd5l17zh _1reo15vq _18m915vq _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh18uv _1guo18uv _12s918uv"
};
const $3b71040028798abb$var$elemAfterStyles = {
    root: "_nd5l16dh _1reo15vq _18m915vq _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
/**
 * We are using a wrapping element for our interactive content
 * even though only the `Text` element is the only thing not using `position:absolute`
 *
 * Rationale:
 * - Super clear that everything inside the interactive content should be in a specific slot in the grid
 * - To work around a browser bug in Safari where it does not work well with `position:absolute`
 *   on a subgrid child.
 *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
 */ const $3b71040028798abb$var$interactiveContentStyles = {
    root: "_nd5l19l3 _1e0c1txw _2lx21bp4 _ae4v1h6o"
};
function $3b71040028798abb$var$getTextColor({ isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'color.text.disabled';
    if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
}
const $3b71040028798abb$export$859b390bf71e044e = ({ testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: descriptionProp, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, ariaDescribedby: ariaDescribedby })=>{
    const isLink = typeof href !== 'undefined';
    const labelRef = (0, $euxye.useRef)(null);
    const descriptionRef = (0, $euxye.useRef)(null);
    const tooltipOnClick = (0, $euxye.useRef)(null);
    const handleClick = (0, $euxye.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        tooltipOnClick.current?.(event);
    }, [
        onClick
    ]);
    /**
   * Show the tooltip if _either_ label or description is truncated
   */ const canTooltipAppear = (0, $euxye.useCallback)(()=>{
        if (isContentTooltipDisabled) return false;
        // Show tooltip if _either_ label or description are clamped
        const label = labelRef.current;
        const description = descriptionRef.current;
        if (label && $3b71040028798abb$var$isTextClamped(label)) return true;
        return Boolean(description && $3b71040028798abb$var$isTextClamped(description));
    }, [
        isContentTooltipDisabled
    ]);
    // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $euYHK.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        className: (0, $4jQY2.default)([
            $3b71040028798abb$var$interactiveContentStyles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                "aria-hidden": "true",
                className: (0, $4jQY2.default)([
                    $3b71040028798abb$var$extendButtonOrAnchorStyles.root
                ])
            }),
            /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
                className: (0, $4jQY2.default)([
                    $3b71040028798abb$var$textStyles.root,
                    !showElemBefore && $3b71040028798abb$var$textStyles.noElemBeforeIndent
                ]),
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                        weight: "medium",
                        maxLines: 1,
                        color: $3b71040028798abb$var$getTextColor({
                            isDisabled: isDisabled,
                            isSelected: isSelected
                        }),
                        ref: labelRef,
                        children: children
                    }),
                    descriptionProp && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                        color: isDisabled ? 'color.text.disabled' : 'color.text.subtle',
                        size: "small",
                        maxLines: 1,
                        ref: descriptionRef,
                        children: descriptionProp
                    })
                ]
            })
        ]
    });
    /**
   *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
   *
   * Note: we also remove the `elemAfter` when showing `actionsOnHover`
   */ const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hAt2p.AvatarContext).Provider, {
        value: $3b71040028798abb$var$defaultAvatarValues,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
            ref: visualContentRef,
            "data-testid": testId ? `${testId}-container` : undefined,
            "data-selected": isSelected,
            className: (0, $4jQY2.default)([
                $3b71040028798abb$var$containerStyles.root,
                isSelected && $3b71040028798abb$var$containerStyles.selected,
                descriptionProp && $3b71040028798abb$var$containerStyles.hasDescription,
                showHoverActionsWhenNotHovered && $3b71040028798abb$var$containerStyles.showHoverActions,
                showHoverActionsWhenNotHovered && elemAfter && $3b71040028798abb$var$containerStyles.removeElemAfter,
                actionsOnHover && elemAfter && $3b71040028798abb$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
                isDisabled && $3b71040028798abb$var$containerStyles.disabled
            ]),
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
                    content: ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                                    children: children
                                }),
                                descriptionProp ? /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                                    children: descriptionProp
                                }) : null
                            ]
                        }),
                    position: "right",
                    // NOTE: Types in React 18 have changed and `forwardRef(() => <TooltipPrimitive>)` no longer appears to match 100%
                    component: $3b71040028798abb$var$MenuItemTooltip,
                    ignoreTooltipPointerEvents: true,
                    hideTooltipOnMouseDown: true,
                    // We don't need a duplicate hidden element containing tooltip content
                    // as the content of the tooltip matches what is rendered for the menu item.
                    isScreenReaderAnnouncementDisabled: true,
                    canAppear: canTooltipAppear,
                    children: (tooltipProps)=>{
                        // Putting the tooltip onClick into a ref.
                        // This way we don't need to create a new `onClick` function on each
                        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
                        tooltipOnClick.current = tooltipProps.onClick;
                        const sharedProps = {
                            ...tooltipProps,
                            'aria-controls': ariaControls,
                            'aria-haspopup': ariaHasPopup,
                            ref: (0, $ljVHR.default)([
                                tooltipProps.ref
                            ]),
                            testId: testId,
                            interactionName: interactionName
                        };
                        return isLink ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $9MWap.Anchor), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $9S1b6.cx)($3b71040028798abb$var$buttonOrAnchorStyles.root, $3b71040028798abb$var$topLevelSiblingStyles.root, isSelected && $3b71040028798abb$var$buttonOrAnchorStyles.selected),
                            // Needed to override Anchor style due to a compiled/emotion conflict
                            style: {
                                textDecoration: 'none'
                            },
                            "aria-current": isSelected ? 'page' : undefined,
                            href: href,
                            target: target,
                            "aria-describedby": ariaDescribedby,
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: (0, $4jQY2.default)([
                                        $3b71040028798abb$var$notchStyles.root
                                    ])
                                }),
                                interactiveElemContent
                            ]
                        }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.Pressable), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $9S1b6.cx)($3b71040028798abb$var$buttonOrAnchorStyles.root, $3b71040028798abb$var$topLevelSiblingStyles.root, isSelected && $3b71040028798abb$var$buttonOrAnchorStyles.selected),
                            "aria-expanded": ariaExpanded,
                            isDisabled: isDisabled,
                            "aria-describedby": ariaDescribedby,
                            children: interactiveElemContent
                        });
                    }
                }),
                showElemBefore && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $3b71040028798abb$var$elemBeforeStyles.root,
                        $3b71040028798abb$var$topLevelSiblingStyles.root,
                        $3b71040028798abb$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemBefore
                }),
                actionsOnHover && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $3b71040028798abb$var$actionsOnHoverStyles.root
                    ]),
                    children: actionsOnHover
                }),
                elemAfter && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $3b71040028798abb$var$elemAfterStyles.root,
                        $3b71040028798abb$var$topLevelSiblingStyles.root,
                        $3b71040028798abb$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemAfter
                }),
                actions && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $3b71040028798abb$var$actionStyles.root,
                        $3b71040028798abb$var$topLevelSiblingStyles.root,
                        $3b71040028798abb$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: actions
                })
            ]
        })
    });
};
$3b71040028798abb$export$859b390bf71e044e.displayName = "MenuItemBase";

});
parcelRegister("euYHK", function(module, exports) {
$parcel$export(module.exports, "COLLAPSE_ELEM_BEFORE", () => $0279274ea359be56$export$f4b8e24fae579c6f);
/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */ const $0279274ea359be56$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');

});



parcelRegister("kdy7J", function(module, exports) {
$parcel$export(module.exports, "ProductKey", () => $eb7f7dcc861f8ea3$export$f3a53bd43617a593);
//#region src/http-client.ts
let $eb7f7dcc861f8ea3$export$e2e108cbe2e4f865 = /* @__PURE__ */ function(ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
    return ContentType;
}({});
var $eb7f7dcc861f8ea3$export$8c6ee871e681f0f4 = class {
    instance;
    format;
    slauthEgress;
    slauthAudience;
    extraHeaders;
    constructor({ format: format, axiosInstance: axiosInstance, slauthEgress: slauthEgress, slauthAudience: slauthAudience, extraHeaders: extraHeaders }){
        this.instance = axiosInstance;
        this.format = format;
        this.slauthEgress = slauthEgress;
        this.slauthAudience = slauthAudience;
        this.extraHeaders = extraHeaders;
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) return JSON.stringify(formItem);
        else return `${formItem}`;
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key)=>{
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [
                property
            ];
            for (const formItem of propertyContent){
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ path: path, type: type, query: query, format: format, body: body, ...params })=>{
        const requestParams = params;
        const responseFormat = format || this.format || void 0;
        if (type === "multipart/form-data" && body && typeof body === "object") body = this.createFormData(body);
        if (type === "text/plain" && body && typeof body !== "string") body = JSON.stringify(body);
        return this.instance.request({
            ...requestParams,
            headers: {
                ...this.extraHeaders || {},
                ...requestParams.headers || {},
                ...type && type !== "multipart/form-data" ? {
                    "Content-Type": type
                } : {},
                "user-agent": "go/postoffice",
                ...this.slauthEgress ? {
                    "X-Slauth-Egress": "true"
                } : {},
                ...this.slauthAudience ? {
                    "X-Slauth-Audience": this.slauthAudience
                } : {}
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path
        });
    };
};
//#endregion
//#region src/data-contracts.ts
const $eb7f7dcc861f8ea3$export$f3a53bd43617a593 = {
    CONFLUENCE: "confluence.ondemand",
    JIRA_SERVICE_DESK: "jira-servicedesk.ondemand",
    JIRA_SOFTWARE: "jira-software.ondemand",
    JIRA_PRODUCT_DISCOVERY: "jira-product-discovery",
    JIRA_WORK_MANAGEMENT: "jira-core.ondemand",
    OPSGENIE: "opsgenie",
    STATUSPAGE: "statuspage",
    TEAM_CENTRAL: "townsquare",
    COMPASS: "compass",
    ANALYTICS: "atlassian-analytics-free",
    BEACON: "beacon",
    LOOM: "loom",
    ROVO: "rovo.ondemand",
    PROJECT: "project",
    GOAL: "goal"
};
const $eb7f7dcc861f8ea3$export$ba2804af63c49f13 = {
    JIRA_SOFTWARE: "jira"
};
const $eb7f7dcc861f8ea3$export$e3db5efcae244a16 = {
    confluence: "ari:cloud:confluence::site/",
    jira: "ari:cloud:jira::site/",
    townsquare: "ari:cloud:townsquare::site/",
    loom: "ari:cloud:loom::site/",
    rovo: "ari:cloud:rovo::site/",
    watermelon: "ari:cloud:townsquare::site/",
    atlas: "ari:cloud:townsquare::site/"
};
//#endregion
//#region src/TcsSidecarApi.ts
var $eb7f7dcc861f8ea3$export$dc8687402b6c41ee = class {
    tcsHttp;
    cryptorHttp;
    constructor(tcsHttp, cryptorHttp){
        this.tcsHttp = tcsHttp;
        this.cryptorHttp = cryptorHttp;
    }
    async healthCheck() {
        await this.tcsHttp.request({
            path: "/healthcheck",
            method: "GET",
            timeout: 3e3
        });
    }
    organization = {
        getTcsRecord: (key, params = {})=>this.tcsHttp.request({
                path: `/entity/organization/${key}`,
                method: "GET",
                ...params
            })
    };
    cloud = {
        getTcsRecord: (key, params = {})=>this.tcsHttp.request({
                path: `/entity/cloud/${key}`,
                method: "GET",
                ...params
            })
    };
    routing = {
        getTcsRecord: (key, params = {})=>this.tcsHttp.request({
                path: `/entity/routing/${key}`,
                method: "GET",
                ...params
            })
    };
    resourceLink = {
        getCcLinks: (resourceAri, params = {})=>this.tcsHttp.request({
                path: `/entity/CC_RESOURCE_LINK/${resourceAri}.cc-links`,
                method: "GET",
                ...params
            })
    };
    ccDirectory = {
        getCcDirectory: (resourceAri, params = {})=>this.tcsHttp.request({
                path: `/entity/CC_RESOURCE_DIRECTORY/${resourceAri}.cc-directory`,
                method: "GET",
                ...params
            })
    };
    settingsService = {
        getCustomEmailFooter: (orgId, appName, params = {})=>this.tcsHttp.request({
                path: "/entity/settings_service/" + encodeURIComponent(`ari:cloud:platform::custom-email-footer/${orgId}/${appName}`).replace(/-/g, "%2D") + "/email-notification-footer",
                method: "GET",
                ...params
            }),
        getRovoOnboardingStateOrgLevel: (orgId, params = {})=>this.tcsHttp.request({
                path: "/entity/settings_service/" + encodeURIComponent(`ari:cloud:platform::rovo-onboarding-state-org-level/${orgId}`).replace(/-/g, "%2D"),
                method: "GET",
                ...params
            })
    };
    cryptor = {
        encryptString: (args)=>this.cryptorHttp.request({
                path: `/cryptor/encrypt/${args.keyAlias}`,
                method: "POST",
                body: {
                    plainText: args.plainText,
                    encryptionContext: args.encryptionContext
                }
            }),
        decryptString: (args)=>this.cryptorHttp.request({
                path: `/cryptor/decrypt`,
                method: "POST",
                body: {
                    cipherText: args.cipherText,
                    encryptionContext: args.encryptionContext
                }
            })
    };
};
const $eb7f7dcc861f8ea3$var$DEFAULT_CRYPTOR_CLIENT_ID = "post-office";
async function $eb7f7dcc861f8ea3$export$db186a82b4ca0a5e(axiosClient, opts, config, tcsSidecarApiOptions) {
    const tcsBaseUrl = undefined;
    const tcsHttpClient = new $eb7f7dcc861f8ea3$export$8c6ee871e681f0f4({
        axiosInstance: await axiosClient({
            name: "tcs-sidecar",
            ...opts
        }, {
            baseURL: tcsBaseUrl,
            ...config
        }),
        slauthEgress: false,
        slauthAudience: "",
        extraHeaders: void 0
    });
    const cryptorBaseUrl = undefined;
    return new $eb7f7dcc861f8ea3$export$dc8687402b6c41ee(tcsHttpClient, new $eb7f7dcc861f8ea3$export$8c6ee871e681f0f4({
        axiosInstance: await axiosClient({
            name: "tcs-sidecar",
            ...opts
        }, {
            baseURL: cryptorBaseUrl,
            ...config
        }),
        slauthEgress: false,
        slauthAudience: "",
        extraHeaders: {
            "X-Cryptor-Client": tcsSidecarApiOptions?.cryptorClientId ?? $eb7f7dcc861f8ea3$var$DEFAULT_CRYPTOR_CLIENT_ID,
            "Content-Type": "application/json; charset=utf-8"
        }
    }));
}

});


parcelRegister("1udHD", function(module, exports) {
$parcel$export(module.exports, "withI18n", () => $cbb10b42111b1138$export$bfba3ccd9d9038f9);

var $2I9KJ = parcelRequire("2I9KJ");

var $iL0ky = parcelRequire("iL0ky");
const $cbb10b42111b1138$export$bfba3ccd9d9038f9 = (0, $2I9KJ.createWithI18n)((0, $iL0ky.messagesLoader));

});



parcelRegister("caJ3S", function(module, exports) {
$parcel$export(module.exports, "Nav4Recommendations", () => $b1743fd45fe8521f$export$dfe7a31b75b5edeb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $a8EUd = parcelRequire("a8EUd");


var $hbVME = parcelRequire("hbVME");
const $b1743fd45fe8521f$export$dfe7a31b75b5edeb = /*#__PURE__*/ (0, $euxye.memo)($b1743fd45fe8521f$var$RecommendationsQuery);
function $b1743fd45fe8521f$var$RecommendationsQuery(props = {}) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "growth-recommendations",
        fallback: "unmount",
        packageName: (0, $f857fff48be59ab5$export$b8b9d90f9e5bd72b),
        teamName: (0, $f857fff48be59ab5$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "recommendations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hbVME.Nav4Recommendations), props || {})));
}
$b1743fd45fe8521f$var$RecommendationsQuery.displayName = "RecommendationsQuery";

});
/* eslint-disable jira/filename-case */ const $f857fff48be59ab5$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4GrowthRecommendations';
const $f857fff48be59ab5$export$d57b6b390e78d90f = 'jira-cosmos';
const $f857fff48be59ab5$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';

parcelRegister("hbVME", function(module, exports) {
$parcel$export(module.exports, "Nav4Recommendations", () => $9ff013ba2c963df5$export$dfe7a31b75b5edeb);

var $2jdnD = parcelRequire("2jdnD");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $eRQIr = parcelRequire("eRQIr");

var $kt86l = parcelRequire("kt86l");

var $3GN2r = parcelRequire("3GN2r");

var $ieqhY = parcelRequire("ieqhY");
/*
At the moment, growthRecommendations fragment in GQL returns different response each time. This results in a behaviour where recommendation component in UI sometimes appear and disappear
as user interacts with the page.

Further observations were:
1) User clicks on a page. It may causes a change in url. this results in the refetch of Nav4ProjectsContent fragment to keep projects recent section up-to-date.
As part of this refetch, growthRecommendations is also refetched as it is part of the same fragment.

2) On each refetch, backend returns different entity ids for recommendations.
3) As a result, It causes the behavior where a recommendation appears and then disappears on different user interactions.

In order to solve it, a below cache is implemented. The purpose of which is to cache the first response and then use it to render the recommendations component which will also be wrapped
in a memo to avoid further re-renders.
*/ const $9ff013ba2c963df5$var$cache = {
    growthRecommendations: []
};
function $9ff013ba2c963df5$export$dfe7a31b75b5edeb(props = {}) {
    const [queryRef, loadQuery] = (0, $n67Vb.useQueryLoader)((0, $2jdnD.default));
    const cloudId = (0, $kt86l.useCloudId)();
    const userId = (0, $3GN2r.useAccountId)();
    (0, $euxye.useEffect)(()=>{
        if (cloudId) loadQuery({
            cloudId: cloudId
        });
    }, [
        cloudId,
        loadQuery
    ]);
    if (!queryRef) return null;
    if (props?.isOptoutAllMessagesDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ff013ba2c963df5$var$Nav4RecommendationsInner, {
        queryRef: queryRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eRQIr.default), {
        touchpointId: "grw-1467-jpd-recommendation-nav4",
        cloudId: cloudId,
        userId: userId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ff013ba2c963df5$var$Nav4RecommendationsInner, {
        queryRef: queryRef
    }));
}
$9ff013ba2c963df5$export$dfe7a31b75b5edeb.displayName = "Nav4Recommendations";
const $9ff013ba2c963df5$var$Nav4RecommendationsInner = ({ queryRef: queryRef })=>{
    const data = (0, $n67Vb.usePreloadedQuery)((0, $2jdnD.default), queryRef);
    const canCreateProject = data?.jira?.canCreateProject ?? false;
    const recommendations = (0, $euxye.useMemo)(()=>{
        const appRecommendations = data?.growthRecommendations?.recommendations?.data?.map((item)=>item.entityId).filter(Boolean) ?? [];
        if ($9ff013ba2c963df5$var$cache.growthRecommendations.length === 0 && appRecommendations.length > 0) $9ff013ba2c963df5$var$cache.growthRecommendations = appRecommendations;
        /*
    	if user has no permission for creating a project, then we want early return to performance benefit.
    	This is because, currently there are only one recommendations 1) JPD Recommendation
    	Which requires create project permission before user can be considered eligible
    */ return Boolean(canCreateProject) && $9ff013ba2c963df5$var$cache.growthRecommendations.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ieqhY.Recommendations), {
            appRecommendations: $9ff013ba2c963df5$var$cache.growthRecommendations,
            sessionId: data?.growthRecommendations?.recommendations?.context?.sessionId
        });
    }, [
        canCreateProject,
        data
    ]);
    return recommendations;
};
$9ff013ba2c963df5$var$Nav4RecommendationsInner.displayName = "Nav4RecommendationsInner";

});
parcelRegister("2jdnD", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb58c9d855007fc9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<12a3efa4ee2ca8787df1a3187a570d04>>
 * @relayHash 50aff49926920514ba3020db082cce38
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1713f82b1ea505ce5b37f6edc5acf8c734f1c5803d49ce12d4f2f3353d89c981
const $bb58c9d855007fc9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "alias": "canCreateProject",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    },
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "CREATE_PROJECT"
                    }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ]
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "product",
                    "value": "jira"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Literal",
                    "name": "useCase",
                    "value": "jiraProjectMenuRecommendations"
                }
            ],
            "kind": "ObjectValue",
            "name": "context"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 2
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "entityId"
            }
        ],
        "type": "GrowthRecJiraTemplateRecommendation"
    }, v4 = {
        "concreteType": "GrowthRecContextResult",
        "kind": "LinkedField",
        "name": "context",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sessionId"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4RecommendationsQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        v4 /*: any*/ 
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4RecommendationsQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        v4 /*: any*/ 
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1713f82b1ea505ce5b37f6edc5acf8c734f1c5803d49ce12d4f2f3353d89c981",
            "metadata": {},
            "name": "Nav4RecommendationsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bb58c9d855007fc9$var$node.hash = "8583b77d3fe5ee2fc7422c8b304ac609";
var $bb58c9d855007fc9$export$2e2bcd8739ae039 = $bb58c9d855007fc9$var$node;

});

parcelRegister("eRQIr", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a421bb3f99f1657$export$2e2bcd8739ae039);

var $bmM7w = parcelRequire("bmM7w");
function $1a421bb3f99f1657$export$2e2bcd8739ae039({ touchpointId: touchpointId, cloudId: cloudId, userId: userId, children: children, fallback: fallback, options: options }) {
    const { optoutStatus: optoutStatus } = (0, $bmM7w.useIsOptoutAllMessages)(touchpointId, cloudId, userId, options);
    if (options?.isDisabled) return children;
    if (optoutStatus !== 'no-opt-out') {
        if (fallback) {
            if (typeof fallback === 'function') return fallback({
                optoutStatus: optoutStatus
            });
            return fallback;
        }
        return null;
    }
    return children;
}
$1a421bb3f99f1657$export$2e2bcd8739ae039.displayName = "OptoutAllMessagesWrapper";

});
parcelRegister("bmM7w", function(module, exports) {
$parcel$export(module.exports, "useIsOptoutAllMessages", () => $beb701c20ba1513f$export$7d4c6b519725ba3b);

var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

const $beb701c20ba1513f$var$getTraceId = (response)=>{
    const traceIdHeader = [
        'atl-traceid',
        'x-trace-id'
    ].find((header)=>response.headers?.has(header));
    return traceIdHeader === undefined ? undefined : response.headers.get(traceIdHeader) ?? undefined;
};
class $beb701c20ba1513f$var$FetchError extends Error {
    constructor(statusCode, message, traceId, originalResponse){
        super(message || `Fetch call failed with status code: ${statusCode}`);
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.originalResponse = originalResponse;
        this.skipSentry = statusCode === 401;
        if (traceId) this.traceId = traceId;
    }
}
$beb701c20ba1513f$var$FetchError.displayName = "FetchError";
const $beb701c20ba1513f$var$getDevHostname = ()=>{
    const envDns = undefined;
    return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
};
const $beb701c20ba1513f$var$getProxyServerPort = ()=>{
    return 9000;
};
const $beb701c20ba1513f$var$LOCAL_URL = new URL(`${'http'}://${$beb701c20ba1513f$var$getDevHostname()}:${$beb701c20ba1513f$var$getProxyServerPort()}`);
const $beb701c20ba1513f$var$getReroutableURL = (pathOrURL)=>{
    var e;
    return pathOrURL;
};
const $beb701c20ba1513f$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};
let $beb701c20ba1513f$var$cachedFetches = {};
let $beb701c20ba1513f$var$siteOptoutStatuses = {};
let $beb701c20ba1513f$var$siteUserOptoutStatuses = {};
let $beb701c20ba1513f$var$firedAnalyticsEvents = {};
let $beb701c20ba1513f$var$isAnalyticsDebounceEnabled = true;
const $beb701c20ba1513f$export$d2adf65b87e47523 = ()=>{
    $beb701c20ba1513f$var$siteOptoutStatuses = {};
    $beb701c20ba1513f$var$siteUserOptoutStatuses = {};
    $beb701c20ba1513f$var$cachedFetches = {};
};
const $beb701c20ba1513f$var$clearFetchCacheForUrl = (url)=>{
    delete $beb701c20ba1513f$var$cachedFetches[url];
};
const $beb701c20ba1513f$var$fetchJsonWithCache = (url, options = {})=>{
    let fetchPromise = $beb701c20ba1513f$var$cachedFetches[url];
    if (fetchPromise) return fetchPromise;
    fetchPromise = fetch($beb701c20ba1513f$var$getReroutableURL(url), {
        ...$beb701c20ba1513f$var$defaultOptions,
        ...options
    });
    $beb701c20ba1513f$var$cachedFetches[url] = fetchPromise;
    return fetchPromise;
};
const $beb701c20ba1513f$var$fetchJson = (url, options = {})=>$beb701c20ba1513f$var$fetchJsonWithCache(url, options).then((response)=>{
        if (!response.ok) {
            const traceId = $beb701c20ba1513f$var$getTraceId(response);
            if (traceId !== undefined && traceId.length > 0) throw new $beb701c20ba1513f$var$FetchError(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
            else throw new $beb701c20ba1513f$var$FetchError(response.status, undefined, undefined, response);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.clone().json();
    });
const $beb701c20ba1513f$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $beb701c20ba1513f$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $beb701c20ba1513f$var$parseOptoutTraitStatus = (attributes, attributeName)=>{
    const optoutValue = attributes.find(({ name: name })=>name === attributeName)?.value;
    return optoutValue ? 'is-opted-out' : 'no-opt-out';
};
const $beb701c20ba1513f$var$parseSiteOptoutTraitStatus = (attributes)=>{
    return $beb701c20ba1513f$var$parseOptoutTraitStatus(attributes, (0, $20df9579cedcaea8$export$a4c96b4ef1bf8976));
};
const $beb701c20ba1513f$var$parseSiteUserOptoutTraitStatus = (attributes)=>{
    return $beb701c20ba1513f$var$parseOptoutTraitStatus(attributes, (0, $20df9579cedcaea8$export$f64870f8abb59f0b));
};
const $beb701c20ba1513f$var$fetchSiteTraitData = async (cloudId)=>{
    if (Boolean($beb701c20ba1513f$var$siteOptoutStatuses[cloudId]) && ($beb701c20ba1513f$var$siteOptoutStatuses[cloudId] === 'is-opted-out' || $beb701c20ba1513f$var$siteOptoutStatuses[cloudId] === 'no-opt-out')) return {
        optoutStatus: $beb701c20ba1513f$var$siteOptoutStatuses[cloudId],
        cached: true
    };
    try {
        const url = $beb701c20ba1513f$var$getPersonalizationSiteTraitsUrl(cloudId);
        if ($beb701c20ba1513f$var$siteOptoutStatuses[cloudId] === 'error') $beb701c20ba1513f$var$clearFetchCacheForUrl(url);
        const { attributes: attributes } = await $beb701c20ba1513f$var$fetchJson(url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'x-atlassian-mau-ignore': 'true'
            }
        });
        $beb701c20ba1513f$var$siteOptoutStatuses[cloudId] = $beb701c20ba1513f$var$parseSiteOptoutTraitStatus(attributes);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching site personalization:', error);
        $beb701c20ba1513f$var$siteOptoutStatuses[cloudId] = 'error';
        throw error;
    }
    return {
        optoutStatus: $beb701c20ba1513f$var$siteOptoutStatuses[cloudId],
        cached: false
    };
};
const $beb701c20ba1513f$var$fetchSiteUserTraitData = async (cloudId, userId)=>{
    if (Boolean($beb701c20ba1513f$var$siteUserOptoutStatuses[cloudId]?.[userId]) && ($beb701c20ba1513f$var$siteUserOptoutStatuses[cloudId]?.[userId] === 'is-opted-out' || $beb701c20ba1513f$var$siteUserOptoutStatuses[cloudId]?.[userId] === 'no-opt-out')) return {
        optoutStatus: $beb701c20ba1513f$var$siteUserOptoutStatuses[cloudId]?.[userId],
        cached: true
    };
    try {
        const url = $beb701c20ba1513f$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId);
        if ($beb701c20ba1513f$var$siteUserOptoutStatuses[cloudId]?.[userId] === 'error') $beb701c20ba1513f$var$clearFetchCacheForUrl(url);
        const { attributes: attributes } = await $beb701c20ba1513f$var$fetchJson(url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'x-atlassian-mau-ignore': 'true'
            }
        });
        $beb701c20ba1513f$var$siteUserOptoutStatuses[cloudId] = {
            ...$beb701c20ba1513f$var$siteUserOptoutStatuses[cloudId] ?? {},
            [userId]: $beb701c20ba1513f$var$parseSiteUserOptoutTraitStatus(attributes)
        };
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching site user personalization:', error);
        $beb701c20ba1513f$var$siteUserOptoutStatuses[cloudId] = {
            ...$beb701c20ba1513f$var$siteUserOptoutStatuses[cloudId] ?? {},
            [userId]: 'error'
        };
        throw error;
    }
    return {
        optoutStatus: $beb701c20ba1513f$var$siteUserOptoutStatuses[cloudId][userId],
        cached: false
    };
};
/**
 * | Site / Site user | initial      | is-opted-out | no-opt-out   | error        |
 * |------------------|--------------|--------------|--------------|--------------|
 * | initial          | initial      | is-opted-out | initial      | initial      |
 * | is-opted-out     | is-opted-out | is-opted-out | is-opted-out | is-opted-out |
 * | no-opt-out       | initial      | is-opted-out | no-opt-out   | error        |
 * | error            | initial      | is-opted-out | error        | error        |
 * @param siteOptoutValue
 * @param siteUserOptoutValue
 */ const $beb701c20ba1513f$var$combineOptoutValue = (siteOptoutValue, siteUserOptoutValue)=>{
    const matrix = {
        initial: {
            initial: 'initial',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'initial',
            error: 'initial'
        },
        'is-opted-out': {
            initial: 'is-opted-out',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'is-opted-out',
            error: 'is-opted-out'
        },
        'no-opt-out': {
            initial: 'initial',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'no-opt-out',
            error: 'error'
        },
        error: {
            initial: 'initial',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'error',
            error: 'error'
        }
    };
    return matrix[siteOptoutValue][siteUserOptoutValue] || 'initial';
};
const $beb701c20ba1513f$export$433d05f24f06f81a = (enabled)=>{
    $beb701c20ba1513f$var$isAnalyticsDebounceEnabled = enabled;
};
const $beb701c20ba1513f$var$isAnalyticsEventFiredWithinDebounceWindow = (eventName, touchpointId)=>{
    const currentTime = Date.now();
    const lastFiredTime = $beb701c20ba1513f$var$firedAnalyticsEvents[eventName]?.[touchpointId] ?? 0;
    if (currentTime - lastFiredTime < (0, $20df9579cedcaea8$export$338a9c38f183f620)) return true;
    $beb701c20ba1513f$var$firedAnalyticsEvents[eventName] = {
        ...$beb701c20ba1513f$var$firedAnalyticsEvents[eventName] ?? {},
        [touchpointId]: currentTime
    };
    return false;
};
const $beb701c20ba1513f$var$fireTrackAnalytics = (analyticsEvent, eventName, attributes)=>{
    if ($beb701c20ba1513f$var$isAnalyticsDebounceEnabled && attributes.touchpointId && $beb701c20ba1513f$var$isAnalyticsEventFiredWithinDebounceWindow(eventName, attributes.touchpointId)) return;
    const clonedEvent = analyticsEvent.clone();
    if (clonedEvent) {
        const [actionSubject, action] = eventName.split(' ');
        clonedEvent.update({
            eventType: (0, $20df9579cedcaea8$export$947dac6c72b26f81),
            actionSubject: actionSubject,
            action: action,
            attributes: {
                ...clonedEvent.payload?.attributes ?? {},
                ...attributes ?? {}
            }
        });
        clonedEvent.fire((0, $20df9579cedcaea8$export$85183a312807388d));
    }
};
const $beb701c20ba1513f$export$9af97c6b33df5bae = async (touchpointId, cloudId, analyticsEvent, options)=>{
    let optoutStatus = 'initial';
    try {
        const fetchResult = await $beb701c20ba1513f$var$fetchSiteTraitData(cloudId);
        optoutStatus = fetchResult.optoutStatus;
        if (analyticsEvent) $beb701c20ba1513f$var$fireTrackAnalytics(analyticsEvent, (0, $20df9579cedcaea8$export$5ede056addcc7dcf), {
            cloudId: cloudId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus,
            cached: fetchResult.cached
        });
    } catch (error) {
        if (analyticsEvent) $beb701c20ba1513f$var$fireTrackAnalytics(analyticsEvent, (0, $20df9579cedcaea8$export$a16c0f38ba8f83e8), {
            error: error instanceof $beb701c20ba1513f$var$FetchError ? error.message : 'Unknown error',
            traceId: error instanceof $beb701c20ba1513f$var$FetchError ? error.traceId : undefined,
            cloudId: cloudId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus
        });
        options?.onError?.(error);
        return {
            optoutStatus: 'error'
        };
    }
    return {
        optoutStatus: optoutStatus
    };
};
const $beb701c20ba1513f$export$a9e7c50f402a03d2 = async (touchpointId, cloudId, userId, analyticsEvent, options)=>{
    let optoutStatus = 'initial';
    try {
        const fetchResult = await $beb701c20ba1513f$var$fetchSiteUserTraitData(cloudId, userId);
        optoutStatus = fetchResult.optoutStatus;
        if (analyticsEvent) $beb701c20ba1513f$var$fireTrackAnalytics(analyticsEvent, (0, $20df9579cedcaea8$export$2b6f8d7fd154b638), {
            cloudId: cloudId,
            userId: userId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus,
            cached: fetchResult.cached
        });
    } catch (error) {
        if (analyticsEvent) $beb701c20ba1513f$var$fireTrackAnalytics(analyticsEvent, (0, $20df9579cedcaea8$export$74a38b22acdaeea2), {
            error: error instanceof $beb701c20ba1513f$var$FetchError ? error.message : 'Unknown error',
            traceId: error instanceof $beb701c20ba1513f$var$FetchError ? error.traceId : undefined,
            cloudId: cloudId,
            userId: userId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus
        });
        options?.onError?.(error);
        return {
            optoutStatus: 'error'
        };
    }
    return {
        optoutStatus: optoutStatus
    };
};
const $beb701c20ba1513f$export$aa440d3a24a2d79a = async (touchpointId, cloudId, userId, analyticsEvent, options)=>{
    if (userId) {
        const [siteOptoutPayload, siteUserOptoutPayload] = await Promise.all([
            $beb701c20ba1513f$export$9af97c6b33df5bae(touchpointId, cloudId, analyticsEvent, options),
            $beb701c20ba1513f$export$a9e7c50f402a03d2(touchpointId, cloudId, userId, analyticsEvent, options)
        ]);
        try {
            return {
                optoutStatus: $beb701c20ba1513f$var$combineOptoutValue(siteOptoutPayload.optoutStatus, siteUserOptoutPayload.optoutStatus)
            };
        } catch (error) {
            options?.onError?.(error);
            return {
                optoutStatus: 'error'
            };
        }
    }
    return $beb701c20ba1513f$export$9af97c6b33df5bae(touchpointId, cloudId, analyticsEvent, options);
};
const $beb701c20ba1513f$export$ef6308b7e747ceec = (touchpointId, cloudId, options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const isDisabled = options?.isDisabled ?? false;
    const onError = options?.onError ?? null;
    const siteTraits = options?.siteTraits ?? null;
    const hasSiteTraits = siteTraits !== null && siteTraits !== undefined;
    const derivedSiteOptoutStatus = hasSiteTraits ? $beb701c20ba1513f$var$parseSiteOptoutTraitStatus(siteTraits) : 'initial';
    const [optoutStatus, setOptoutStatus] = (0, $euxye.useState)(derivedSiteOptoutStatus);
    (0, $euxye.useEffect)(()=>{
        if (hasSiteTraits) {
            $beb701c20ba1513f$var$siteOptoutStatuses[cloudId] = derivedSiteOptoutStatus;
            setOptoutStatus(derivedSiteOptoutStatus);
            return;
        }
        if (!isDisabled) $beb701c20ba1513f$export$9af97c6b33df5bae(touchpointId, cloudId, createAnalyticsEvent({}), {
            onError: onError
        }).then(({ optoutStatus: status })=>{
            setOptoutStatus(status);
        });
    }, [
        cloudId,
        isDisabled,
        touchpointId,
        createAnalyticsEvent,
        onError,
        hasSiteTraits,
        derivedSiteOptoutStatus
    ]);
    return {
        optoutStatus: optoutStatus
    };
};
const $beb701c20ba1513f$export$e5b57ebc3eed2ecb = (touchpointId, cloudId, userId, options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const isDisabled = options?.isDisabled ?? false;
    const onError = options?.onError ?? null;
    const siteUserTraits = options?.siteUserTraits ?? null;
    const hasSiteUserTraits = siteUserTraits !== null && siteUserTraits !== undefined;
    const derivedSiteUserOptoutStatus = hasSiteUserTraits ? $beb701c20ba1513f$var$parseSiteUserOptoutTraitStatus(siteUserTraits) : 'initial';
    const [optoutStatus, setOptoutStatus] = (0, $euxye.useState)(derivedSiteUserOptoutStatus);
    (0, $euxye.useEffect)(()=>{
        if (hasSiteUserTraits) {
            $beb701c20ba1513f$var$siteUserOptoutStatuses[cloudId] = {
                ...$beb701c20ba1513f$var$siteUserOptoutStatuses[cloudId] ?? {},
                [userId]: derivedSiteUserOptoutStatus
            };
            setOptoutStatus(derivedSiteUserOptoutStatus);
            return;
        }
        if (!isDisabled) $beb701c20ba1513f$export$a9e7c50f402a03d2(touchpointId, cloudId, userId, createAnalyticsEvent({}), {
            onError: onError
        }).then(({ optoutStatus: status })=>{
            setOptoutStatus(status);
        });
    }, [
        cloudId,
        userId,
        isDisabled,
        touchpointId,
        createAnalyticsEvent,
        onError,
        hasSiteUserTraits,
        derivedSiteUserOptoutStatus
    ]);
    return {
        optoutStatus: optoutStatus
    };
};
const $beb701c20ba1513f$export$7d4c6b519725ba3b = (touchpointId, cloudId, userId, options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const isDisabled = options?.isDisabled ?? false;
    const onError = options?.onError ?? null;
    const siteTraits = options?.siteTraits ?? null;
    const siteUserTraits = options?.siteUserTraits ?? null;
    const hasSiteTraits = siteTraits !== null && siteTraits !== undefined;
    const hasSiteUserTraits = siteUserTraits !== null && siteUserTraits !== undefined;
    const requiresSiteUser = Boolean(userId);
    const canDeriveFromTraits = hasSiteTraits && (!requiresSiteUser || hasSiteUserTraits);
    const derivedSiteOptoutStatus = hasSiteTraits ? $beb701c20ba1513f$var$parseSiteOptoutTraitStatus(siteTraits) : 'initial';
    const derivedSiteUserOptoutStatus = hasSiteUserTraits ? $beb701c20ba1513f$var$parseSiteUserOptoutTraitStatus(siteUserTraits) : 'initial';
    const derivedOptoutStatus = canDeriveFromTraits ? requiresSiteUser ? $beb701c20ba1513f$var$combineOptoutValue(derivedSiteOptoutStatus, derivedSiteUserOptoutStatus) : derivedSiteOptoutStatus : 'initial';
    const [optoutStatus, setOptoutStatus] = (0, $euxye.useState)(derivedOptoutStatus);
    (0, $euxye.useEffect)(()=>{
        if (canDeriveFromTraits) {
            $beb701c20ba1513f$var$siteOptoutStatuses[cloudId] = derivedSiteOptoutStatus;
            if (requiresSiteUser && userId) $beb701c20ba1513f$var$siteUserOptoutStatuses[cloudId] = {
                ...$beb701c20ba1513f$var$siteUserOptoutStatuses[cloudId] ?? {},
                [userId]: derivedSiteUserOptoutStatus
            };
            setOptoutStatus(derivedOptoutStatus);
            return;
        }
        if (!isDisabled) $beb701c20ba1513f$export$aa440d3a24a2d79a(touchpointId, cloudId, userId, createAnalyticsEvent({}), {
            onError: onError
        }).then(({ optoutStatus: status })=>{
            setOptoutStatus(status);
        }).catch((error)=>{
            onError?.(error);
        });
    }, [
        cloudId,
        userId,
        isDisabled,
        touchpointId,
        createAnalyticsEvent,
        onError,
        canDeriveFromTraits,
        requiresSiteUser,
        derivedSiteOptoutStatus,
        derivedSiteUserOptoutStatus,
        derivedOptoutStatus
    ]);
    return {
        optoutStatus: optoutStatus
    };
};

});
const $20df9579cedcaea8$export$a4c96b4ef1bf8976 = 'optout_all_messages';
const $20df9579cedcaea8$export$f64870f8abb59f0b = 'optout_all_messages_user';
const $20df9579cedcaea8$export$48e1d3fa57b0a2d5 = 'optoutAllMessages';
const $20df9579cedcaea8$export$5ede056addcc7dcf = `${$20df9579cedcaea8$export$48e1d3fa57b0a2d5}.fetchSiteOptout succeeded`;
const $20df9579cedcaea8$export$a16c0f38ba8f83e8 = `${$20df9579cedcaea8$export$48e1d3fa57b0a2d5}.fetchSiteOptout failed`;
const $20df9579cedcaea8$export$2b6f8d7fd154b638 = `${$20df9579cedcaea8$export$48e1d3fa57b0a2d5}.fetchSiteUserOptout succeeded`;
const $20df9579cedcaea8$export$74a38b22acdaeea2 = `${$20df9579cedcaea8$export$48e1d3fa57b0a2d5}.fetchSiteUserOptout failed`;
const $20df9579cedcaea8$export$85183a312807388d = 'postOffice';
const $20df9579cedcaea8$export$947dac6c72b26f81 = 'track';
const $20df9579cedcaea8$export$338a9c38f183f620 = 100; // 0.1 second



parcelRegister("ieqhY", function(module, exports) {
$parcel$export(module.exports, "Recommendations", () => $436ca7433295433e$export$ebd86fc7badb9a5d);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $ar9gx = parcelRequire("ar9gx");

var $djYhH = parcelRequire("djYhH");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aqPkH = parcelRequire("aqPkH");

var $cOxml = parcelRequire("cOxml");

var $bHmst = parcelRequire("bHmst");
const $436ca7433295433e$var$sectionTitle = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-growth-recommendations.section-title",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Recommended"
});
const $436ca7433295433e$export$ebd86fc7badb9a5d = ({ appRecommendations: appRecommendations, sessionId: sessionId })=>{
    const [isDismissed, setIsDismissed] = (0, $euxye.useState)(false);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const selectedRecommendationState = (0, $cOxml.useSelectedRecommendation)({
        appRecommendations: appRecommendations
    });
    const onDismissRecommendation = (0, $euxye.useCallback)(()=>{
        setIsDismissed(true);
    }, []);
    if (!selectedRecommendationState?.recommendationKey) return null;
    const selectedRecommendation = (0, $bHmst.recommendationsList).find((recommendation)=>recommendation.key === selectedRecommendationState.recommendationKey);
    return selectedRecommendation && !isDismissed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($436ca7433295433e$var$sectionTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(selectedRecommendation.Component, {
        recommendationKey: selectedRecommendation.key,
        dismissRecommendation: onDismissRecommendation,
        sessionId: sessionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireScreenAnalytics), {
        attributes: {
            recommendationType: selectedRecommendation.key
        }
    })))));
};
$436ca7433295433e$export$ebd86fc7badb9a5d.displayName = "Recommendations";

});
parcelRegister("cOxml", function(module, exports) {
$parcel$export(module.exports, "useSelectedRecommendation", () => $cec968ac63be664e$export$6a60b75e3f5ce2aa);
// import shuffle from 'lodash/shuffle';

var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $bHmst = parcelRequire("bHmst");

var $6rqnq = parcelRequire("6rqnq");
const $cec968ac63be664e$export$6a60b75e3f5ce2aa = ({ appRecommendations: appRecommendations })=>{
    const recommendationContext = (0, $6rqnq.useRecommendationContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    // NOTE: having shufle here will cause different order of data on SSR and client resulting in a UI change after first render
    // which may not seem like a good UX
    // const shuffledRecommendations = shuffle(recommendations);
    /* 	useMemo here prevents running this code each time user navigates a different route which triggers
		re-render of projects which then re-renders Recommendations component.
		memoisation also prevents sending operational analytics on each re-render
	*/ const recommendationStatus = (0, $euxye.useMemo)(()=>(0, $bHmst.recommendationsList).map((recommendation)=>{
            if (!recommendationContext) return {
                key: recommendation.key,
                isEnabled: false
            };
            const isEnabled = recommendation.shouldRender(recommendationContext, createAnalyticsEvent({}), appRecommendations);
            return {
                key: recommendation.key,
                isEnabled: isEnabled
            };
        }), [
        appRecommendations,
        createAnalyticsEvent,
        recommendationContext
    ]);
    if (!recommendationContext) return {
        recommendationKey: null
    };
    const selectedRecommendation = recommendationStatus.find((result)=>result.isEnabled);
    return {
        recommendationKey: selectedRecommendation?.key || null
    };
};

});
parcelRegister("bHmst", function(module, exports) {
$parcel$export(module.exports, "recommendationsList", () => $f73b78500e5bc8cd$export$2ff783c2bb2ac3b1);

var $5AfaD = parcelRequire("5AfaD");
const $f73b78500e5bc8cd$var$createRecommendationsList = ()=>{
    const recommendationsList = [];
    recommendationsList.push((0, $5AfaD.jpdRecommendation));
    // Add your own templates
    return recommendationsList;
};
const $f73b78500e5bc8cd$export$2ff783c2bb2ac3b1 = $f73b78500e5bc8cd$var$createRecommendationsList();

});
parcelRegister("5AfaD", function(module, exports) {
$parcel$export(module.exports, "jpdRecommendation", () => $5e3a93db00258621$export$f0837513113a320d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $52xkc = parcelRequire("52xkc");

var $8oFkF = parcelRequire("8oFkF");

var $lfqQU = parcelRequire("lfqQU");

var $hFtK7 = parcelRequire("hFtK7");







var $aQCoC = parcelRequire("aQCoC");

var $8Sdzy = parcelRequire("8Sdzy");

var $2EFuW = parcelRequire("2EFuW");

var $4qNCE = parcelRequire("4qNCE");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $kM0go = parcelRequire("kM0go");

var $3GN2r = parcelRequire("3GN2r");

var $k5P9q = parcelRequire("k5P9q");

var $6LigW = parcelRequire("6LigW");

var $i860n = parcelRequire("i860n");

var $gIUBz = parcelRequire("gIUBz");


var $fmZ1S = parcelRequire("fmZ1S");

var $cVlZS = parcelRequire("cVlZS");

var $klVZM = parcelRequire("klVZM");

var $5azn7 = parcelRequire("5azn7");
const $5e3a93db00258621$var$projectTitleProductRoadmap = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation-recommendations.jpd-recommendation.project-title-product-roadmap",
    defaultMessage: "Create a roadmap"
});
const $5e3a93db00258621$var$lozengeText = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation-recommendations.jpd-recommendation.lozenge-text",
    defaultMessage: "try"
});
const $5e3a93db00258621$var$reasonsModalTitle = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
    defaultMessage: "Why am I seeing this?"
});
const $5e3a93db00258621$var$reasonsModalExplanation = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
    defaultMessage: "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
});
const $5e3a93db00258621$var$reasonsModalBulletOneSpork = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
    defaultMessage: "the tools you use (Jira)"
});
const $5e3a93db00258621$var$reasonsModalBulletTwo = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
    defaultMessage: "the way you use your existing tools and products"
});
const $5e3a93db00258621$var$privacyPolicy = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
    defaultMessage: "Learn more about your data privacy with Atlassian"
});
const $5e3a93db00258621$var$reasonsModalButtonOk = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
    defaultMessage: "Ok"
});
const $5e3a93db00258621$var$reasonsModalBulletTwoAppifyMessage = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two-appify",
    defaultMessage: "the way you use your existing tools and apps"
});
const $5e3a93db00258621$export$da956fe610b96f73 = ({ recommendationKey: recommendationKey, dismissRecommendation: dismissRecommendation, sessionId: sessionId })=>{
    const reasonsModalBulletTwoAppify = (0, $i860n.fg)('product-terminology-refresh') ? $5e3a93db00258621$var$reasonsModalBulletTwoAppifyMessage : $5e3a93db00258621$var$reasonsModalBulletTwo;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const crossFlow = (0, $8oFkF.useCrossFlow)();
    const accountId = (0, $3GN2r.useAccountId)();
    const environment = (0, $k5P9q.useEnvironment)();
    const jpdCloudCCPProductID = (0, $fmZ1S.getProductTypeCcpReferenceIdMapForEnv)(environment).PRODUCT_DISCOVERY;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $6LigW.useFireCrossFlowAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        if (crossFlow.isEnabled) fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'projectsMenu'
        }, {
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            source: 'projectsMenuSection',
            recommendationSession: {
                id: sessionId ?? '',
                type: 'appRec'
            }
        }, {
            navigationVersion: 'v4',
            projectKey: (0, $fmZ1S.JPD_ROADMAP_KEY)
        });
        else (0, $hFtK7.fireErrorAnalytics)({
            error: new Error(crossFlow.reason),
            meta: {
                id: crossFlow.reason,
                packageName: 'jiraAtlassianNavigationRecommendations'
            }
        });
    }, [
        createAnalyticsEvent,
        crossFlow,
        fireViewedUIEvent,
        jpdCloudCCPProductID,
        sessionId
    ]);
    const jpdRecommendationContent = (0, $euxye.useMemo)(()=>{
        return {
            projectTitle: $5e3a93db00258621$var$projectTitleProductRoadmap,
            projectKey: (0, $fmZ1S.JPD_ROADMAP_KEY),
            projectAvatar: (0, $klVZM.default)
        };
    }, []);
    const onLearnMoreClicked = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $6b2913942bd90807$export$64fed82162bd367),
            action: 'clicked'
        }), (0, $47ad9e6c8e8002a4$export$8d155d2412839524), {
            level: (0, $ef39084c605eb7e8$export$f9db6a58b4aabd18),
            componentType: (0, $6e2f51712bb2e810$export$56981f28056f258e),
            parentItemType: (0, $687cb22024c607c7$export$9a778ca616c24a93),
            parentItemId: (0, $90c0351d239ffedb$export$de9ad1ebeca97ec1),
            itemId: (0, $90c0351d239ffedb$export$ce0bea1467165424),
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            recommendationSession: {
                id: sessionId ?? '',
                type: 'appRec'
            }
        }, {
            navigationVersion: 'v4'
        });
    }, [
        createAnalyticsEvent,
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        sessionId
    ]);
    const onDismissClicked = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $6b2913942bd90807$export$64fed82162bd367),
            action: 'clicked'
        }), (0, $47ad9e6c8e8002a4$export$8d155d2412839524), {
            level: (0, $ef39084c605eb7e8$export$f9db6a58b4aabd18),
            componentType: (0, $6e2f51712bb2e810$export$56981f28056f258e),
            parentItemType: (0, $687cb22024c607c7$export$9a778ca616c24a93),
            parentItemId: (0, $90c0351d239ffedb$export$de9ad1ebeca97ec1),
            itemId: (0, $90c0351d239ffedb$export$5c09fa42f8d45ed8),
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'dismissRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            recommendationSession: {
                id: sessionId ?? '',
                type: 'appRec'
            }
        }, {
            navigationVersion: 'v4'
        });
        dismissRecommendation();
        if (accountId) (0, $kM0go.setUserProperties)(accountId, (0, $fmZ1S.JPD_RECOMMENDATION_DISMISS_USER_PROPERTY), 'true').catch((error)=>{
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'dismissJpdRecommendation',
                    packageName: (0, $f857fff48be59ab5$export$b8b9d90f9e5bd72b),
                    teamName: 'navigation'
                }
            });
        });
    }, [
        accountId,
        createAnalyticsEvent,
        dismissRecommendation,
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        sessionId
    ]);
    const openCrossFlow = (0, $euxye.useCallback)(async (templateId)=>{
        const extensions = (0, $52xkc.createProvisioningPageExtensions)({
            actions: {
                primary: {
                    behaviour: (0, $5azn7.Behaviours).LAND,
                    prompt: (0, $5azn7.Prompts).NEXT,
                    options: {
                        targetTab: (0, $5azn7.TargetTabs).SAME,
                        urlParams: {
                            templateId: templateId
                        }
                    }
                }
            }
        });
        if (crossFlow.isEnabled) // eslint-disable-next-line @atlassian/growth/no-deprecated-apis
        crossFlow.api.open({
            journey: (0, $8oFkF.Journeys).GET_STARTED,
            targetProduct: (0, $lfqQU.Targets).JIRA_PRODUCT_DISCOVERY,
            sourceComponent: 'projectsMenu',
            sourceContext: 'tryThisRecommendation',
            extensions: extensions
        });
    }, [
        crossFlow
    ]);
    const onRecommendationClicked = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            action: 'clicked'
        }), (0, $47ad9e6c8e8002a4$export$8d155d2412839524), {
            level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
            componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
            itemType: (0, $687cb22024c607c7$export$9a778ca616c24a93),
            itemId: (0, $90c0351d239ffedb$export$de9ad1ebeca97ec1),
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryThisRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            recommendationSession: {
                id: sessionId ?? '',
                type: 'appRec'
            }
        }, {
            navigationVersion: 'v4'
        });
        openCrossFlow(jpdRecommendationContent.projectKey);
    }, [
        createAnalyticsEvent,
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        jpdRecommendationContent.projectKey,
        openCrossFlow,
        sessionId
    ]);
    const recommendationActionMenuClickHandler = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), (0, $47ad9e6c8e8002a4$export$8d155d2412839524), {
            level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
            componentType: (0, $6e2f51712bb2e810$export$9bd6c21d500ae611),
            parentItemType: (0, $687cb22024c607c7$export$9a778ca616c24a93),
            parentItemId: (0, $90c0351d239ffedb$export$de9ad1ebeca97ec1),
            itemId: (0, $90c0351d239ffedb$export$f06dfcec5ff912e)
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(jpdRecommendationContent.projectAvatar, null),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
            appearance: "discovery",
            isBold: false
        }, formatMessage($5e3a93db00258621$var$lozengeText)),
        href: "",
        menuId: recommendationKey,
        onClick: onRecommendationClicked,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gIUBz.RecommendationActionMenu), {
            onClick: recommendationActionMenuClickHandler,
            onLearnMoreClicked: onLearnMoreClicked,
            onDismissClicked: onDismissClicked,
            primaryCta: formatMessage($5e3a93db00258621$var$reasonsModalButtonOk),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, formatMessage($5e3a93db00258621$var$reasonsModalExplanation, {
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
                        as: "strong"
                    }, chunks)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("li", null, formatMessage($5e3a93db00258621$var$reasonsModalBulletOneSpork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("li", null, formatMessage(reasonsModalBulletTwoAppify))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
                appearance: "link",
                spacing: "none",
                href: (0, $f857fff48be59ab5$export$aefe1c8741b24a28),
                target: "_blank"
            }, formatMessage($5e3a93db00258621$var$privacyPolicy))),
            title: formatMessage($5e3a93db00258621$var$reasonsModalTitle)
        })
    }, formatMessage(jpdRecommendationContent.projectTitle)));
};
$5e3a93db00258621$export$da956fe610b96f73.displayName = "JpdRecommendation";
const $5e3a93db00258621$var$checkEligibility = (recommendationContext, appRecommendations)=>{
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled, licensedProducts: licensedProducts, accountId: accountId, jpdRecommendationDismissed: jpdRecommendationDismissed } = recommendationContext;
    if (!accountId) return {
        isEligible: false,
        reason: 'Account Id is null'
    };
    if (!areProductSuggestionsEnabled) return {
        isEligible: false,
        reason: 'Product suggestions are disabled'
    };
    if ((0, $cVlZS.hasJpdLicense)(licensedProducts)) return {
        isEligible: false,
        reason: 'Instance has JPD license'
    };
    if (jpdRecommendationDismissed) return {
        isEligible: false,
        reason: 'JPD recommendation dismissed'
    };
    if (!appRecommendations?.some((entityId)=>entityId === (0, $fmZ1S.JPD_ENTITY_ID))) return {
        isEligible: false,
        reason: 'JPD was not in the recommend apps'
    };
    return {
        isEligible: true,
        reason: 'Pass all checks'
    };
};
const $5e3a93db00258621$export$f0837513113a320d = {
    key: (0, $fmZ1S.JPD_RECOMMENDATION_KEY),
    shouldRender: (recommendationContext, analyticsEvent, appRecommendations)=>{
        const { isEligible: isEligible, reason: reason } = $5e3a93db00258621$var$checkEligibility(recommendationContext, appRecommendations);
        if ((0, $i860n.fg)('pm_jpd_reco_operational_event_activated')) (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.loadJpdRecommendation succeeded', {
            reason: reason,
            isEligible: isEligible
        });
        return isEligible;
    },
    Component: $5e3a93db00258621$export$da956fe610b96f73
};

});
parcelRegister("52xkc", function(module, exports) {
$parcel$export(module.exports, "createProvisioningPageExtensions", () => $ba98ffd1be1b856b$export$f05508383d0ca130);

var $cD4as = parcelRequire("cD4as");
const $ba98ffd1be1b856b$export$99f81e179e225ceb = [
    'provisioningPageOptions'
];
const $ba98ffd1be1b856b$export$f05508383d0ca130 = (options)=>(0, $cD4as.createProductExtensions)($ba98ffd1be1b856b$export$99f81e179e225ceb)({
        provisioningPageOptions: options
    });

});
parcelRegister("cD4as", function(module, exports) {
$parcel$export(module.exports, "createProductExtensions", () => $f2e82b903e184894$export$42e62ee12e8ced48);

var $lfqQU = parcelRequire("lfqQU");
const $f2e82b903e184894$export$9143c254bff9f7b7 = (object, propertyNames)=>propertyNames.reduce((accumulator, property)=>{
        const value = object[property];
        if (value !== undefined) accumulator[property] = value;
        return accumulator;
    }, {});
const $f2e82b903e184894$export$42e62ee12e8ced48 = (extensionsWhitelist)=>(options)=>{
        const filteredOptions = $f2e82b903e184894$export$9143c254bff9f7b7(options, extensionsWhitelist);
        return new (0, $lfqQU.CrossFlowExtensions)(filteredOptions);
    };
const $f2e82b903e184894$export$86a865d89ef3c690 = (...extensions)=>{
    const combinedOptions = Object.assign({}, ...extensions);
    return new (0, $lfqQU.CrossFlowExtensions)(combinedOptions);
};

});


parcelRegister("gIUBz", function(module, exports) {
$parcel$export(module.exports, "RecommendationActionMenu", () => $b6037e2ff33e86dc$export$ff27431731859712);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $ldysw = parcelRequire("ldysw");

var $kCVHZ = parcelRequire("kCVHZ");

var $kza8k = parcelRequire("kza8k");

var $6H8Ah = parcelRequire("6H8Ah");

var $7Fzpe = parcelRequire("7Fzpe");

var $72ldR = parcelRequire("72ldR");

var $g36LP = parcelRequire("g36LP");

var $ceqcm = parcelRequire("ceqcm");

var $hZDXn = parcelRequire("hZDXn");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $isqzs = parcelRequire("isqzs");
const $b6037e2ff33e86dc$var$whyAmISeeingThis = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.why-am-i-seeing-this",
    defaultMessage: "Why am I seeing this?"
});
const $b6037e2ff33e86dc$var$moreActions = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.more-actions",
    defaultMessage: "More actions"
});
const $b6037e2ff33e86dc$var$dismissButtonText = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.dismiss-button-text",
    defaultMessage: "Not interested"
});
const $b6037e2ff33e86dc$var$MENU_TEST_ID = 'recommendations-common.ui.recommendation-popup-menu.menu-group';
// @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
const $b6037e2ff33e86dc$var$CustomTrigger = /*#__PURE__*/ (0, $euxye.forwardRef)(({ ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        hideTooltipOnClick: true,
        content: formatMessage($b6037e2ff33e86dc$var$moreActions),
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6H8Ah.ThemedButtonOld), {
        ...props,
        ref: ref,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Fzpe))), {
            label: formatMessage($b6037e2ff33e86dc$var$moreActions),
            color: "currentColor",
            spacing: "spacious"
        }),
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-content-growth-recommendations.common.ui.recommendation-action-menu.themed-button"
    }));
});
const $b6037e2ff33e86dc$var$LearnMoreTrigger = /*#__PURE__*/ (0, $euxye.forwardRef)(({ onLearnMoreClicked: onLearnMoreClicked }, ref)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        ref: ref,
        onClick: onLearnMoreClicked
    }, formatMessage($b6037e2ff33e86dc$var$whyAmISeeingThis));
});
const $b6037e2ff33e86dc$export$ff27431731859712 = ({ onClick: onClick, onLearnMoreClicked: onLearnMoreClicked, onDismissClicked: onDismissClicked, body: body, primaryCta: primaryCta, title: title })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            body: body,
            primaryCta: primaryCta,
            title: title
        }), [
        body,
        primaryCta,
        title
    ]);
    const modalProps = (0, $euxye.useMemo)(()=>({
            width: 400,
            height: 440
        }), []);
    const MenuItems = (0, $euxye.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), {
            testId: $b6037e2ff33e86dc$var$MENU_TEST_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
            isList: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
            onClick: ()=>onDismissClicked()
        }, formatMessage($b6037e2ff33e86dc$var$dismissButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $isqzs.ModalEntryPointPressableTrigger), {
            entryPoint: (0, $ldysw.GrowthRecommendationsEntrypoint),
            entryPointProps: entryPointParams,
            modalProps: modalProps,
            useInternalModal: false
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b6037e2ff33e86dc$var$LearnMoreTrigger, {
                // oxlint-disable-next-line typescript/consistent-type-assertions
                ref: ref,
                onLearnMoreClicked: onLearnMoreClicked
            }))));
    }, [
        entryPointParams,
        formatMessage,
        modalProps,
        onDismissClicked,
        onLearnMoreClicked
    ]);
    const content = (contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kza8k.MenuContent), {
            ...contentProps,
            MenuItems: MenuItems
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kCVHZ.MenuContainer), {
        content: content,
        onClick: onClick,
        CustomTrigger: $b6037e2ff33e86dc$var$CustomTrigger
    });
};
$b6037e2ff33e86dc$export$ff27431731859712.displayName = "RecommendationActionMenu";

});
parcelRegister("ldysw", function(module, exports) {
$parcel$export(module.exports, "GrowthRecommendationsEntrypoint", () => $cb51a3179301f67a$export$f926c2f51211d688);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $cb51a3179301f67a$export$f926c2f51211d688 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("7LTp8")), {
        moduleId: "996a7b71",
        moduleName: "GrowthRecommendationModal",
        priority: "interaction"
    }),
    getPreloadProps: (props)=>({
            queries: {},
            props: props
        })
});

});
parcelRegister("7LTp8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dYZpz").then(()=>parcelRequire('ilLkG'));

});


parcelRegister("kCVHZ", function(module, exports) {
$parcel$export(module.exports, "MenuContainer", () => $a39a17e72e21e387$export$b286f91cddfedb5a);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $5F8FY = parcelRequire("5F8FY");

var $4Onaa = parcelRequire("4Onaa");

var $gNzvf = parcelRequire("gNzvf");

var $ep5yh = parcelRequire("ep5yh");
const $a39a17e72e21e387$export$b286f91cddfedb5a = ({ content: content, CustomTrigger: CustomTrigger, onClick: onClick, onClose: onCloseCustom, buttonTriggerRef: buttonTriggerRef, shouldRenderToParent: shouldRenderToParent = true, projectName: projectName, actionMenuId: actionMenuId })=>{
    const { isOpen: isOpen, onClose: onClose, onToggle: onToggle } = (0, $5F8FY.useOpenable)();
    const route = (0, $4Onaa.useCurrentRoute)();
    const handleClose = (0, $euxye.useCallback)((e)=>{
        try {
            onCloseCustom?.(e);
        } finally{
            onClose();
        }
    }, [
        onCloseCustom,
        onClose
    ]);
    const onClickHandler = (0, $euxye.useCallback)(()=>{
        onToggle();
        onClick?.();
    }, [
        onClick,
        onToggle
    ]);
    const trigger = (triggerProps)=>{
        const { ref: ref, ...restTriggerProps } = triggerProps;
        return CustomTrigger ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(CustomTrigger, {
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ep5yh.MenuTriggerButton), {
            name: projectName,
            actionMenuId: actionMenuId,
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNzvf.JiraPopup), {
        content: content,
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-start",
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: "navigation-project-action-menu.ui.menu-container.popup",
        messageType: "transactional",
        trigger: trigger,
        shouldRenderToParent: route.name.includes('legacy') ? false : shouldRenderToParent,
        strategy: "absolute"
    });
};
$a39a17e72e21e387$export$b286f91cddfedb5a.displayName = "MenuContainer";

});
parcelRegister("ep5yh", function(module, exports) {
$parcel$export(module.exports, "MenuTriggerButton", () => $3c5c2a46ab5008f8$export$a24e6f6ddd974e33);

var $euxye = parcelRequire("euxye");

var $7Fzpe = parcelRequire("7Fzpe");

var $m9iwH = parcelRequire("m9iwH");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $3c5c2a46ab5008f8$var$projectActionsMenu = (0, $7eNDO.defineMessage)({
    id: "navigation-project-action-menu.menu-container.project-actions-menu",
    defaultMessage: "More actions"
});
const $3c5c2a46ab5008f8$var$projectActionsMenuName = (0, $7eNDO.defineMessage)({
    id: "navigation-project-action-menu.menu-container.project-actions-menu-name",
    defaultMessage: "More actions for {name}"
});
const $3c5c2a46ab5008f8$export$a24e6f6ddd974e33 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ onClick: onClick, name: name, actionMenuId: actionMenuId, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
        ...props,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Fzpe))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)",
                size: "small"
            }),
        label: formatMessage($3c5c2a46ab5008f8$var$projectActionsMenuName, {
            name: name
        }),
        onClick: onClick,
        ref: ref,
        spacing: "compact",
        appearance: "subtle",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-project-action-menu.ui.menu-container.themed-button",
        id: actionMenuId,
        isTooltipDisabled: false,
        tooltip: {
            content: formatMessage($3c5c2a46ab5008f8$var$projectActionsMenu),
            hideTooltipOnClick: true
        }
    });
});

});


parcelRegister("kza8k", function(module, exports) {
$parcel$export(module.exports, "MenuContent", () => $e6d058d335977d7a$export$479f0f2f71193efe);

var $euxye = parcelRequire("euxye");


var $72ldR = parcelRequire("72ldR");

var $ihEDU = parcelRequire("ihEDU");
const $e6d058d335977d7a$var$stopEventPropagation = (event)=>event.stopPropagation();
const $e6d058d335977d7a$export$479f0f2f71193efe = ({ MenuItems: MenuItems, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        onMouseEnter: $e6d058d335977d7a$var$stopEventPropagation,
        onMouseLeave: $e6d058d335977d7a$var$stopEventPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), {
        minWidth: (0, $47916ea360432737$export$9c07662d9724277)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(MenuItems, {
        onClose: onClose
    })));
$e6d058d335977d7a$export$479f0f2f71193efe.displayName = "MenuContent";

});

parcelRegister("6H8Ah", function(module, exports) {
$parcel$export(module.exports, "ThemedButtonOld", () => $e8374eaf5a354537$export$4efcee10858edfbc);
/* ThemedButtonOld.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $1D4ep = parcelRequire("1D4ep");
const $e8374eaf5a354537$export$4efcee10858edfbc = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(({ as: as, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e8374eaf5a354537$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e8374eaf5a354537$var$CustomButton = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = (0, $1D4ep.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
            __cmplp.className
        ])
    });
});

});


parcelRegister("fmZ1S", function(module, exports) {
$parcel$export(module.exports, "JPD_RECOMMENDATION_KEY", () => $143a4b0eaced16fb$export$3e6ff24c4f517c4f);
$parcel$export(module.exports, "JPD_ROADMAP_KEY", () => $143a4b0eaced16fb$export$c11145b8eb60b18b);
$parcel$export(module.exports, "JPD_RECOMMENDATION_DISMISS_USER_PROPERTY", () => $143a4b0eaced16fb$export$52b9dedc0088f8);
$parcel$export(module.exports, "JPD_ENTITY_ID", () => $143a4b0eaced16fb$export$909712ccf16883d);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $143a4b0eaced16fb$export$29629758934356a6);
/* eslint-disable jira/filename-case */ 
var $aHm5X = parcelRequire("aHm5X");
const $143a4b0eaced16fb$export$3e6ff24c4f517c4f = 'jpd-recommendation';
const $143a4b0eaced16fb$export$a9c4e38d8a74acd2 = 'jpd.product-discovery';
const $143a4b0eaced16fb$export$c11145b8eb60b18b = 'jpd.product-roadmap';
const $143a4b0eaced16fb$export$52b9dedc0088f8 = 'JpdRecommendationDismissed';
const $143a4b0eaced16fb$export$909712ccf16883d = 'jira.polaris:discovery';
const $143a4b0eaced16fb$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $aHm5X.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $aHm5X.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $aHm5X.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $aHm5X.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("cVlZS", function(module, exports) {
$parcel$export(module.exports, "hasJpdLicense", () => $9c2768278f0f4f0c$export$2ea69a0925803655);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $9c2768278f0f4f0c$export$2ea69a0925803655 = (licensedProducts)=>licensedProducts['jira-product-discovery'] === true;

});

parcelRegister("klVZM", function(module, exports) {
$parcel$export(module.exports, "default", () => $73a3ecc677647587$export$2e2bcd8739ae039);
/* product-roadmap-project-avatar.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $8z2GW = parcelRequire("8z2GW");

var $2Cf1i = parcelRequire("2Cf1i");
const $73a3ecc677647587$var$ProductRoadmapProjectAvatar = ()=>{
    return /*#__PURE__*/ $euxye.createElement((0, $8z2GW.default), {
        appearance: "square",
        borderColor: "transparent",
        size: "small",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2Cf1i)))
    });
};
$73a3ecc677647587$var$ProductRoadmapProjectAvatar.displayName = "ProductRoadmapProjectAvatar";
var $73a3ecc677647587$export$2e2bcd8739ae039 = $73a3ecc677647587$var$ProductRoadmapProjectAvatar;

});
parcelRegister("2Cf1i", function(module, exports) {
module.exports = new URL("template-roadmap-icon.72864c5e.svg", import.meta.url).toString();

});


parcelRegister("5azn7", function(module, exports) {
$parcel$export(module.exports, "Behaviours", () => $a489209a79e1edee$export$993d0f36af4bf76f);
$parcel$export(module.exports, "TargetTabs", () => $a489209a79e1edee$export$c57f0d43fd595f43);
$parcel$export(module.exports, "Prompts", () => $a489209a79e1edee$export$d1609d6291f3d60d);
const $a489209a79e1edee$export$696c71818ae3f184 = {
    FREE: 'free',
    STANDARD: 'standard',
    PREMIUM: 'premium',
    ESSENTIALS: 'essentials',
    ENTERPRISE: 'enterprise'
};
const $a489209a79e1edee$export$993d0f36af4bf76f = {
    LAND: 'land',
    CLOSE: 'close'
};
const $a489209a79e1edee$export$c57f0d43fd595f43 = {
    SAME: 'same',
    NEW: 'new'
};
const $a489209a79e1edee$export$d1609d6291f3d60d = {
    NEXT: 'next',
    CLOSE: 'close',
    GO_TO_PRODUCT: 'go-to-product',
    RETURN_TO_PRODUCT: 'return-to-product'
};

});



parcelRegister("6rqnq", function(module, exports) {
$parcel$export(module.exports, "useRecommendationContext", () => $dc9c14da42e9650c$export$3321c0b02f750bcc);

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $8Uubk = parcelRequire("8Uubk");

var $ecGij = parcelRequire("ecGij");

var $2NAMr = parcelRequire("2NAMr");

var $3GN2r = parcelRequire("3GN2r");

var $ccEzE = parcelRequire("ccEzE");

var $gQJGQ = parcelRequire("gQJGQ");

var $eijVy = parcelRequire("eijVy");

var $k6ufm = parcelRequire("k6ufm");
const $dc9c14da42e9650c$export$3321c0b02f750bcc = ()=>{
    const locale = (0, $gQJGQ.useLocale)();
    const accountId = (0, $3GN2r.useAccountId)();
    const { cloudId: cloudId, licensedProducts: licensedProducts, firstActivationDateMs: firstActivationDateMs, areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $eijVy.useTenantContext)();
    const { software: edition, serviceDesk: jsmEdition, customerService: customerServiceEdition, core: coreEdition } = (0, $ccEzE.useAppEditions)();
    const environment = (0, $n67Vb.useRelayEnvironment)();
    const jpdRecommendationDismissedResourceData = (0, $k6ufm.useResource)((0, $2NAMr.jpdRecommendationDismissedResource));
    const jpdRecommendationDismissed = jpdRecommendationDismissedResourceData?.data?.hasDismissed ?? false;
    const { data: userTraitsData } = (0, $k6ufm.useResource)((0, $ecGij.fetchSiteUserTraitsResource));
    const { data: siteTraitsData } = (0, $k6ufm.useResource)((0, $8Uubk.fetchSiteTraitsResource));
    return (0, $euxye.useMemo)(()=>({
            locale: locale,
            cloudId: cloudId,
            accountId: accountId,
            licensedProducts: licensedProducts,
            edition: edition,
            jsmEdition: jsmEdition,
            coreEdition: coreEdition,
            customerServiceEdition: customerServiceEdition,
            firstActivationDateMs: firstActivationDateMs,
            areProductSuggestionsEnabled: areProductSuggestionsEnabled,
            environment: environment,
            jpdRecommendationDismissed: jpdRecommendationDismissed,
            userTraitsData: userTraitsData,
            siteTraitsData: siteTraitsData
        }), [
        locale,
        cloudId,
        accountId,
        licensedProducts,
        edition,
        jsmEdition,
        coreEdition,
        customerServiceEdition,
        firstActivationDateMs,
        areProductSuggestionsEnabled,
        environment,
        jpdRecommendationDismissed,
        userTraitsData,
        siteTraitsData
    ]);
};

});





parcelRegister("g3FiF", function(module, exports) {
$parcel$export(module.exports, "ImportWorkMenuItem", () => $cef8d8bcba311862$export$e993559687b4ce2c);

var $euxye = parcelRequire("euxye");

var $jVPlr = parcelRequire("jVPlr");

var $4xzHg = parcelRequire("4xzHg");

var $6bGyp = parcelRequire("6bGyp");

var $fnvbx = parcelRequire("fnvbx");

var $7Odw0 = parcelRequire("7Odw0");

var $46mPk = parcelRequire("46mPk");

var $7eNDO = parcelRequire("7eNDO");
var $55qdj = parcelRequire("55qdj");

var $2700E = parcelRequire("2700E");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $5jbOX = parcelRequire("5jbOX");

var $fnDfj = parcelRequire("fnDfj");
const $cef8d8bcba311862$var$importWork = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-import-work.menu-item.label",
    defaultMessage: "Import work"
});
const $cef8d8bcba311862$export$e993559687b4ce2c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [isModalOpen, setIsModalOpen] = (0, $euxye.useState)(false);
    // Hooks must be called unconditionally, before any early return below.
    const { data: rovoEntitlement } = (0, $6bGyp.useRovoEntitlementResource)();
    const activationDateMs = (0, $5jbOX.useFirstActivationDateMs)();
    const isRovoLLMEnabled = rovoEntitlement?.isRovoLLMEnabled ?? false;
    const isSiteWithin7Days = typeof activationDateMs === 'number' ? (0, $fnvbx.isWithinLast)({
        days: 7
    })(activationDateMs) : false;
    // expVal is intentionally short-circuited behind the checks above (not a hook,
    // so this is safe) — it must only be evaluated for the truly eligible population,
    // otherwise we'd pollute the experiment's exposure logging with ineligible users.
    // The desktop check has to sit on this side of expVal for the same reason.
    const isInExperiment = isRovoLLMEnabled && isSiteWithin7Days && !(0, $7Odw0.default)() && (0, $2700E.expVal)('jfind-retest-left-nav-import', 'isEnabled', false);
    const importWorkAnalytics = (0, $4xzHg.getProjectMenuItemAnalytics)({
        itemId: 'importWork'
    });
    (0, $euxye.useEffect)(()=>{
        if (!isInExperiment) return;
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'importWorkMenuItem'
        }));
    }, [
        isInExperiment,
        createAnalyticsEvent
    ]);
    const handleClick = (0, $euxye.useCallback)(()=>{
        // ButtonMenuItemWithAnalytics already fires the generic `navigationItem clicked`
        // event that every sidenav item emits. This dedicated event is fired alongside it
        // so the experiment funnel can be measured without having to filter that shared
        // event down by `itemId`, and so it pairs 1:1 with `importWorkMenuItem viewed`.
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'importWorkMenuItem'
        }));
        setIsModalOpen(true);
    }, [
        createAnalyticsEvent
    ]);
    const handleModalClose = (0, $euxye.useCallback)(()=>{
        setIsModalOpen(false);
    }, []);
    if (!isInExperiment) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jVPlr.default), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($46mPk))), {
            label: "",
            color: "currentColor"
        }),
        analytics: importWorkAnalytics,
        "data-testid": "sidebar-nav4-sidebars-content-projects-import-work.menu-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55qdj.default), $cef8d8bcba311862$var$importWork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fnDfj.ImportChoiceModal), {
        isOpen: isModalOpen,
        onClose: handleModalClose
    }));
};
$cef8d8bcba311862$export$e993559687b4ce2c.displayName = "ImportWorkMenuItem";

});
parcelRegister("fnvbx", function(module, exports) {
$parcel$export(module.exports, "isWithinLast", () => $fe8e5f4f17b7c9ae$export$15bc1a874225842d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4SepQ = parcelRequire("4SepQ");

var $8zUrb = parcelRequire("8zUrb");

var $24Kpr = parcelRequire("24Kpr");
const $fe8e5f4f17b7c9ae$export$15bc1a874225842d = (duration)=>(date)=>{
        if (!(0, $4SepQ.default)(date)) return false;
        const end = Date.now();
        const start = (0, $24Kpr.default)(duration)(end);
        // `isValid` precludes a nullable date.
        // oxlint-disable-next-line typescript/no-non-null-assertion
        return (0, $8zUrb.default)({
            start: start,
            end: end
        })(date);
    };

});
parcelRegister("4SepQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $38c7633f4435949f$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

var $dGdlo = parcelRequire("dGdlo");

var $asvYR = parcelRequire("asvYR");
var $38c7633f4435949f$export$2e2bcd8739ae039 = (0, $asvYR.default)((0, $dGdlo.default), 1);

});
parcelRegister("asvYR", function(module, exports) {
$parcel$export(module.exports, "default", () => $79d55393d645b348$export$2e2bcd8739ae039);
function $79d55393d645b348$export$2e2bcd8739ae039(fn, arity) {
    var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    if (a.length >= arity) return fn.apply(null, a.slice(0, arity).reverse());
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return $79d55393d645b348$export$2e2bcd8739ae039(fn, arity, a.concat(args));
    };
}

});


parcelRegister("8zUrb", function(module, exports) {
$parcel$export(module.exports, "default", () => $63ed5ee5960770fd$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

var $dtlih = parcelRequire("dtlih");

var $asvYR = parcelRequire("asvYR");
var $63ed5ee5960770fd$export$2e2bcd8739ae039 = (0, $asvYR.default)((0, $dtlih.default), 2);

});

parcelRegister("24Kpr", function(module, exports) {
$parcel$export(module.exports, "default", () => $182ff46e8677bb1e$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

var $9Ctw7 = parcelRequire("9Ctw7");

var $asvYR = parcelRequire("asvYR");
var $182ff46e8677bb1e$export$2e2bcd8739ae039 = (0, $asvYR.default)((0, $9Ctw7.default), 2);

});


parcelRegister("5jbOX", function(module, exports) {
$parcel$export(module.exports, "useFirstActivationDateMs", () => $c91adcf203d38774$export$9df3a539e50a284b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $c91adcf203d38774$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});

parcelRegister("fnDfj", function(module, exports) {
$parcel$export(module.exports, "ImportChoiceModal", () => $4b6758a6236ea267$export$ce9820bdd64df01c);

var $euxye = parcelRequire("euxye");

var $5u9Wt = parcelRequire("5u9Wt");

var $hFtK7 = parcelRequire("hFtK7");

var $9imxF = parcelRequire("9imxF");

var $gpyJM = parcelRequire("gpyJM");

var $2v3yi = parcelRequire("2v3yi");

var $4vluQ = parcelRequire("4vluQ");

var $dNPnD = parcelRequire("dNPnD");

var $keJFr = parcelRequire("keJFr");

var $iOfms = parcelRequire("iOfms");

var $abhF2 = parcelRequire("abhF2");

var $aybNy = parcelRequire("aybNy");

var $7DcTT = parcelRequire("7DcTT");
var $c69sa = parcelRequire("c69sa");
var $6Elhl = parcelRequire("6Elhl");
var $jYEcG = parcelRequire("jYEcG");
var $gNHJ8 = parcelRequire("gNHJ8");
var $fbAgj = parcelRequire("fbAgj");

var $9ll9z = parcelRequire("9ll9z");

var $DIqjH = parcelRequire("DIqjH");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $klNTX = parcelRequire("klNTX");

var $apTXu = parcelRequire("apTXu");
const $4b6758a6236ea267$var$ROVO_FILE_UPLOAD_URL = '/gateway/api/assist/rovo/v1/chat/message/file';
// Mirrors STATUS_CODES from @atlassian/conversation-assistant-service-api/constants.
// 415 = the file extension/mime type itself isn't supported by the service.
// 406 = FILE_RAI_POLICY_VIOLATION — a Responsible AI / content-safety scan (run on
// the file's actual content, post-upload) flagged the file. This is NOT a file-type
// allow-list check, which is why the exact same file type can succeed once and be
// rejected another time depending on the specific file's content.
const $4b6758a6236ea267$var$UNSUPPORTED_FILE_TYPE_STATUS = 415;
const $4b6758a6236ea267$var$FILE_RAI_POLICY_VIOLATION_STATUS = 406;
class $4b6758a6236ea267$var$RovoFileUploadError extends Error {
    constructor(statusCode, message){
        super(message);
        this.statusCode = statusCode;
    }
}
$4b6758a6236ea267$var$RovoFileUploadError.displayName = "RovoFileUploadError";
const $4b6758a6236ea267$var$uploadFileToRovoAssistanceService = async (file)=>{
    const formData = new FormData();
    formData.append('files', file);
    const response = await fetch($4b6758a6236ea267$var$ROVO_FILE_UPLOAD_URL, {
        method: 'POST',
        headers: {
            'x-product': 'jira',
            'x-experience-id': 'ai-mate'
        },
        credentials: 'include',
        body: formData
    });
    if (!response.ok) throw new $4b6758a6236ea267$var$RovoFileUploadError(response.status, `Rovo file upload failed with status ${response.status}`);
    const json = await response.json();
    return json.data;
};
const $4b6758a6236ea267$var$titleMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-import-work.choice-modal.title",
    defaultMessage: "Add work to your project"
});
const $4b6758a6236ea267$var$createFromFilesOptionMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-import-work.choice-modal.create-from-files-option",
    defaultMessage: "Create work from files"
});
const $4b6758a6236ea267$var$createFromFilesDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-import-work.choice-modal.create-from-files-description",
    defaultMessage: "Upload a csv, brief or photo. Rovo AI will draft tasks for you to review."
});
const $4b6758a6236ea267$var$bringYourProjectOptionMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-import-work.choice-modal.bring-your-project-option",
    defaultMessage: "Migrate your project"
});
const $4b6758a6236ea267$var$bringYourProjectDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-import-work.choice-modal.bring-your-project-description",
    defaultMessage: "Moving from another tool? We\u2019ll bring over your work and structure."
});
const $4b6758a6236ea267$var$mcpFooterTextMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-import-work.choice-modal.mcp-footer-text",
    defaultMessage: "Working with AI agents?"
});
const $4b6758a6236ea267$var$mcpFooterLinkMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-import-work.choice-modal.mcp-footer-link",
    defaultMessage: "<link>Connect the Atlassian MCP</link> so your agent can create and update work."
});
const $4b6758a6236ea267$var$cancelMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-import-work.choice-modal.cancel",
    defaultMessage: "Cancel"
});
const $4b6758a6236ea267$var$closeButtonLabelMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-import-work.choice-modal.close-button-label",
    defaultMessage: "Close"
});
const $4b6758a6236ea267$var$uploadingLabelMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-import-work.choice-modal.uploading-label",
    defaultMessage: "Uploading your file\u2026"
});
const $4b6758a6236ea267$var$uploadErrorGenericMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-import-work.choice-modal.upload-error-generic",
    defaultMessage: "We couldn't upload your file. Please try again."
});
const $4b6758a6236ea267$var$uploadErrorUnsupportedTypeMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-import-work.choice-modal.upload-error-unsupported-type",
    defaultMessage: "This file type isn't supported. Try a different file."
});
const $4b6758a6236ea267$var$uploadErrorRaiPolicyMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-import-work.choice-modal.upload-error-rai-policy",
    defaultMessage: "The file might not comply with our Acceptable Use Policy. Try a different file."
});
const $4b6758a6236ea267$var$IMPORT_CHOICE_MODAL_TEST_ID = 'sidebar-nav4-sidebars-content-projects-import-work.import-choice-modal';
/**
 * The modal reports Escape and blanket-click dismissals through the same `onClose`
 * callback, distinguished only by the event it passes: a KeyboardEvent for Escape
 * and a MouseEvent for the blanket. Both the top-layer and legacy modal
 * implementations follow this contract (the top-layer one synthesises the event via
 * `createCloseEvent`), so keying off `key` works on either path.
 */ const $4b6758a6236ea267$var$isEscapeKeyEvent = (event)=>'key' in event && event.key === 'Escape';
/**
 * Single source of truth for how an upload failure is both surfaced to the user
 * and recorded in analytics, so the banner someone sees and the `failureReason` we
 * chart can't drift apart as new status codes are handled.
 */ const $4b6758a6236ea267$var$getUploadFailure = (statusCode)=>{
    switch(statusCode){
        case $4b6758a6236ea267$var$UNSUPPORTED_FILE_TYPE_STATUS:
            return {
                failureReason: 'unsupportedFileType',
                message: $4b6758a6236ea267$var$uploadErrorUnsupportedTypeMessage
            };
        case $4b6758a6236ea267$var$FILE_RAI_POLICY_VIOLATION_STATUS:
            return {
                failureReason: 'raiPolicyViolation',
                message: $4b6758a6236ea267$var$uploadErrorRaiPolicyMessage
            };
        default:
            return {
                // No status code means we never got a response — a dropped connection,
                // an aborted request, or a client-side throw. That's an availability
                // problem on our side, not the service refusing the file, so it must
                // not be lumped in with genuine server rejections.
                failureReason: statusCode == null ? 'networkOrClientError' : 'serverError',
                message: $4b6758a6236ea267$var$uploadErrorGenericMessage
            };
    }
};
const $4b6758a6236ea267$export$ce9820bdd64df01c = ({ isOpen: isOpen, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const fileInputRef = (0, $euxye.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const publish = (0, $9ll9z.usePublish)('ai-mate');
    const [isUploading, setIsUploading] = (0, $euxye.useState)(false);
    const [uploadErrorMessage, setUploadErrorMessage] = (0, $euxye.useState)(null);
    (0, $euxye.useEffect)(()=>{
        if (!isOpen) return;
        // Denominator for every other modal event in the funnel (option selection
        // rate, abandonment rate). Keyed on `isOpen` rather than mount because this
        // component stays mounted across open/close cycles — see handleClose.
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'importChoiceModal'
        }));
    }, [
        isOpen,
        createAnalyticsEvent
    ]);
    const handleClose = (0, $euxye.useCallback)(()=>{
        // This component stays mounted between opens (only the inner Modal
        // unmounts), so transient state would otherwise survive a close/reopen
        // cycle — leaving a stale error banner, or a stale spinner if the modal
        // was dismissed mid-upload. Reset both here so every reopen starts clean.
        // All close paths route through this handler to keep that guarantee.
        setUploadErrorMessage(null);
        setIsUploading(false);
        onClose();
    }, [
        onClose
    ]);
    // Deliberately separate from handleClose: a close that follows an option
    // selection is a conversion, not an abandonment. Only the paths that leave the
    // modal without choosing anything fire `dismissed`, so the abandonment metric
    // stays meaningful.
    const handleDismiss = (0, $euxye.useCallback)((dismissMethod)=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dismissed',
            actionSubject: 'importChoiceModal',
            attributes: {
                dismissMethod: dismissMethod
            }
        }));
        handleClose();
    }, [
        createAnalyticsEvent,
        handleClose
    ]);
    const handleCancelClick = (0, $euxye.useCallback)(()=>{
        handleDismiss('cancelButton');
    }, [
        handleDismiss
    ]);
    const handleCloseButtonClick = (0, $euxye.useCallback)(()=>{
        handleDismiss('closeButton');
    }, [
        handleDismiss
    ]);
    // The modal's own onClose only fires for the two dismissals it owns: Escape and
    // a click on the blanket outside the dialog. The Cancel and X buttons are wired
    // to their own handlers above, so they never reach here.
    const handleModalDismiss = (0, $euxye.useCallback)((event)=>{
        handleDismiss($4b6758a6236ea267$var$isEscapeKeyEvent(event) ? 'escapeKey' : 'outsideClick');
    }, [
        handleDismiss
    ]);
    const handleCreateFromFilesClick = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'importChoiceModalCreateFromFiles'
        }));
        setUploadErrorMessage(null);
        fileInputRef.current?.click();
    }, [
        createAnalyticsEvent
    ]);
    const handleFileSelected = (0, $euxye.useCallback)(async (event)=>{
        const file = event.target.files?.[0];
        if (file == null) return;
        setIsUploading(true);
        setUploadErrorMessage(null);
        try {
            const uploadedFiles = await $4b6758a6236ea267$var$uploadFileToRovoAssistanceService(file);
            const uploadedFile = uploadedFiles[0];
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
                action: 'uploaded',
                actionSubject: 'importChoiceModalCreateFromFiles'
            }));
            // Open the Rovo chat sidebar with the uploaded file attached and a
            // guided prompt, so the user lands directly on a pre-filled request
            // rather than an empty chat. `data.files` (not `attachments`) is the
            // contract the ai-mate chat surface expects — matches the existing
            // working implementation in ImportWorkCardRovo.tsx.
            publish({
                type: 'chat-new',
                product: 'jira',
                openChatMode: 'mini-modal',
                source: 'jira-navigation-apps-import-work-create-from-files',
                data: {
                    dialogues: [],
                    prompt: 'Create tasks from this file',
                    files: uploadedFile ? [
                        {
                            id: uploadedFile.id,
                            name: uploadedFile.name,
                            size: uploadedFile.size,
                            type: uploadedFile.type,
                            isLoading: false,
                            fileObject: file
                        }
                    ] : []
                }
            });
            // Bottom of the funnel we own: the file is uploaded and the chat request
            // has been handed off to Rovo. Everything past this point is emitted by
            // the Rovo platform itself (`rovoChatContext added file`,
            // `aiInteraction initiated`, `button clicked createWorkItemsBulkCreate`),
            // so this event is what those platform events get joined back to.
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
                action: 'triggered',
                actionSubject: 'rovoFileUploadTask',
                // MIME type only — the file name is user-generated content and must
                // not be sent to analytics.
                attributes: {
                    fileType: file.type
                }
            }));
            handleClose();
        } catch (err) {
            const statusCode = err instanceof $4b6758a6236ea267$var$RovoFileUploadError ? err.statusCode : undefined;
            const { failureReason: failureReason, message: message } = $4b6758a6236ea267$var$getUploadFailure(statusCode);
            // The counterpart to `rovoFileUploadTask triggered` — together they give
            // the success rate of the Rovo handoff, and `failureReason` says whether
            // a drop-off is us (availability) or the file (rejected content/type).
            // This is the product/funnel view of the failure.
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
                action: 'failed',
                actionSubject: 'importChoiceModalCreateFromFiles',
                // MIME type only — the file name is user-generated content and must
                // not be sent to analytics.
                attributes: {
                    statusCode: statusCode,
                    failureReason: failureReason,
                    fileType: file.type
                }
            }));
            // ...and this is the reliability view. fireErrorAnalytics emits an
            // operational event, so it lands in Splunk and the SignalFX reliability
            // dashboards where the UI event above is not visible. Both are needed:
            // one answers "is this experiment converting?", the other "is this
            // feature healthy in production right now?".
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'uploadFileToRovoAssistanceService',
                    packageName: 'jiraNavigationAppsSidebarNav4SidebarsContentProjectsImportWork',
                    teamName: 'growth-jira-find'
                },
                attributes: {
                    failureReason: failureReason,
                    statusCode: statusCode
                },
                error: err instanceof Error ? err : new Error(String(err)),
                // A status code means the service saw the request and answered: a
                // rejected file (415/406) is working as designed and a 5xx is already
                // alerted on server-side, so neither belongs in Sentry. No status code
                // means the request never completed, which can be a real client-side
                // bug and is the one case worth capturing.
                //
                // Note this is a top-level field, not an attribute — passing it inside
                // `attributes` (as the handling-errors skill example does) is silently
                // ignored and everything still reaches Sentry.
                skipSentry: statusCode != null
            });
            setUploadErrorMessage(message);
        } finally{
            setIsUploading(false);
            // Reset so selecting the same file again still fires a change event.
            if (fileInputRef.current != null) fileInputRef.current.value = '';
        }
    }, [
        createAnalyticsEvent,
        handleClose,
        publish
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5u9Wt.ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>{
        const handleBringProjectClick = ()=>{
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'importChoiceModalBringYourProject'
            }));
            // Open the drawer BEFORE closing our own modal. Closing first would
            // unmount this modal (and the ProjectCreateDrawerConsumer subtree)
            // in the same tick the drawer is asked to open, which can leave the
            // X2C wizard stuck in a loading state. This mirrors the previously
            // working direct-open implementation.
            open({
                isImportProjectOpenInitially: true
            });
            handleClose();
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9imxF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $DIqjH.JiraModal), {
            messageId: "sidebar-nav4-sidebars-content-projects-import-work.modal.navigation-apps-sidebar-nav4-sidebars-content-projects-import-work.choice-modal",
            messageType: "transactional",
            shouldCloseOnEscapePress: true,
            onClose: handleModalDismiss,
            width: 600,
            testId: $4b6758a6236ea267$var$IMPORT_CHOICE_MODAL_TEST_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("style", null, `
									[data-testid="${$4b6758a6236ea267$var$IMPORT_CHOICE_MODAL_TEST_ID}--positioner"][data-testid="${$4b6758a6236ea267$var$IMPORT_CHOICE_MODAL_TEST_ID}--positioner"] {
										justify-content: center;
									}
									/*
										The design spec's 322px is a *resting* height, not a fixed
										one \u{2014} using Modal's \`height\` prop would lock it, forcing the
										body to scroll when the conditional upload-error banner
										appears. min-height keeps the spec size when there's no
										banner, while still letting the dialog grow to fit it.

										The transform nudges the card 11px up from its centered
										resting position; transform doesn't affect layout (unlike
										inset/top properties), so it's a pure visual offset that
										doesn't disturb the centering above.
									*/
									[data-testid="${$4b6758a6236ea267$var$IMPORT_CHOICE_MODAL_TEST_ID}"][data-testid="${$4b6758a6236ea267$var$IMPORT_CHOICE_MODAL_TEST_ID}"] {
										min-height: 322px;
										transform: translateY(-11px);
									}
								`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gpyJM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: $4b6758a6236ea267$var$headerContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dNPnD.default), null, formatMessage($4b6758a6236ea267$var$titleMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $keJFr.CloseButton), {
            onClick: handleCloseButtonClick,
            label: formatMessage($4b6758a6236ea267$var$closeButtonLabelMessage)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v3yi.default), null, uploadErrorMessage != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: $4b6758a6236ea267$var$errorBannerWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aybNy.default), {
            appearance: "error",
            testId: "sidebar-nav4-sidebars-content-projects-import-work.upload-error"
        }, formatMessage(uploadErrorMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: $4b6758a6236ea267$var$optionsAreaStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: isUploading ? $4b6758a6236ea267$var$contentHiddenStyles : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.Flex), {
            gap: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jYEcG.Pressable), {
            xcss: $4b6758a6236ea267$var$optionCardStyles,
            onClick: handleCreateFromFilesClick,
            isDisabled: isUploading,
            testId: "sidebar-nav4-sidebars-content-projects-import-work.create-from-files-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: $4b6758a6236ea267$var$optionIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klNTX.CreateFromFilesIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: $4b6758a6236ea267$var$optionTextStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNHJ8.Text), {
            weight: "bold",
            size: "medium",
            as: "p"
        }, formatMessage($4b6758a6236ea267$var$createFromFilesOptionMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNHJ8.Text), {
            as: "p",
            color: "color.text.subtle",
            size: "small"
        }, formatMessage($4b6758a6236ea267$var$createFromFilesDescriptionMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jYEcG.Pressable), {
            xcss: $4b6758a6236ea267$var$optionCardStyles,
            onClick: handleBringProjectClick,
            testId: "sidebar-nav4-sidebars-content-projects-import-work.bring-project-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: $4b6758a6236ea267$var$optionIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $apTXu.BringYourProjectIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: $4b6758a6236ea267$var$optionTextStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNHJ8.Text), {
            weight: "bold",
            size: "medium",
            as: "p"
        }, formatMessage($4b6758a6236ea267$var$bringYourProjectOptionMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNHJ8.Text), {
            as: "p",
            color: "color.text.subtle",
            size: "small"
        }, formatMessage($4b6758a6236ea267$var$bringYourProjectDescriptionMessage))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: $4b6758a6236ea267$var$mcpFooterTextStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNHJ8.Text), {
            size: "small",
            color: "color.text.subtle"
        }, formatMessage($4b6758a6236ea267$var$mcpFooterTextMessage), ' ', formatMessage($4b6758a6236ea267$var$mcpFooterLinkMessage, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7DcTT.Anchor), {
                    href: "https://developer.atlassian.com/cloud/jira/platform/mcp/",
                    target: "_blank"
                }, chunks)
        })))), isUploading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: $4b6758a6236ea267$var$uploadingOverlayStyles,
            role: "status",
            testId: "sidebar-nav4-sidebars-content-projects-import-work.uploading-state"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
            size: "large"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNHJ8.Text), {
            color: "color.text.subtle"
        }, formatMessage($4b6758a6236ea267$var$uploadingLabelMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: $4b6758a6236ea267$var$hiddenInputStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("input", {
            ref: fileInputRef,
            type: "file",
            // Intentionally no `accept` restriction, matching the real Rovo
            // chat's own file input (see useConversationFiles.tsx): the
            // assistance service supports a broad range of file types and
            // validates server-side, so we let the user pick anything and
            // surface a precise error if the service rejects it (see
            // UNSUPPORTED_FILE_TYPE_STATUS / FILE_RAI_POLICY_VIOLATION_STATUS
            // handling in handleFileSelected).
            disabled: isUploading,
            onChange: handleFileSelected,
            "data-testid": "sidebar-nav4-sidebars-content-projects-import-work.file-input"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4vluQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: $4b6758a6236ea267$var$footerButtonWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
            appearance: "subtle",
            onClick: handleCancelClick
        }, formatMessage($4b6758a6236ea267$var$cancelMessage))))));
    });
};
$4b6758a6236ea267$export$ce9820bdd64df01c.displayName = "ImportChoiceModal";
// SectionMessage (appearance="error") already provides the background color,
// icon, and internal padding matching the design spec — this wrapper only
// adds the bottom margin needed to separate it from the option cards below.
const $4b6758a6236ea267$var$errorBannerWrapperStyles = (0, $fbAgj.xcss)({
    marginBlockEnd: 'space.150'
});
// Layout-only styles for the content nested inside ModalHeader/ModalFooter.
// No padding here — ModalHeader/ModalFooter already apply the design system's
// standard padding, so adding our own would double it up.
const $4b6758a6236ea267$var$headerContentStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 'space.200',
    width: '100%'
});
// ModalFooter's own default styles (see modal-footer.tsx) already provide
// justifyContent: 'flex-end', paddingInline: 'space.300', and
// paddingBlockStart: 'space.200' — matching the requested 300 side / 200
// top-bottom footer spacing. Its paddingBlockEnd defaults to 'space.300'
// though, so this negative margin trims that down to the requested
// symmetric 'space.200' top/bottom padding without needing to override
// ModalFooter's internal styles directly (no style-override prop is exposed).
const $4b6758a6236ea267$var$footerButtonWrapperStyles = (0, $fbAgj.xcss)({
    marginBlockEnd: 'space.negative.100'
});
// Below both option cards, with 'space.200' top spacing separating it from
// the cards above.
const $4b6758a6236ea267$var$mcpFooterTextStyles = (0, $fbAgj.xcss)({
    marginBlockStart: 'space.200'
});
const $4b6758a6236ea267$var$optionCardStyles = (0, $fbAgj.xcss)({
    flex: '1',
    padding: 'space.200',
    borderRadius: 'radius.large',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    cursor: 'pointer',
    backgroundColor: 'color.background.neutral.subtle',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'space.150',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
// Positioning context for the upload spinner, which is overlaid on top of the
// (hidden) cards rather than replacing them, so the modal keeps its height.
const $4b6758a6236ea267$var$optionsAreaStyles = (0, $fbAgj.xcss)({
    position: 'relative'
});
const $4b6758a6236ea267$var$contentHiddenStyles = (0, $fbAgj.xcss)({
    visibility: 'hidden'
});
const $4b6758a6236ea267$var$uploadingOverlayStyles = (0, $fbAgj.xcss)({
    position: 'absolute',
    inset: '0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'space.150'
});
const $4b6758a6236ea267$var$optionIconStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    // Keep the 32x32 icon from being compressed by the flex row when space is tight.
    flexShrink: 0
});
const $4b6758a6236ea267$var$optionTextStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
    gap: 'space.100'
});
const $4b6758a6236ea267$var$hiddenInputStyles = (0, $fbAgj.xcss)({
    display: 'none'
});

});
parcelRegister("7DcTT", function(module, exports) {
$parcel$export(module.exports, "Anchor", () => $c45470667263a4bb$export$b688253958b8dfe7);
$parcel$export(module.exports, "default", () => $c45470667263a4bb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $jiTLE = parcelRequire("jiTLE");

var $aZBDA = parcelRequire("aZBDA");

var $5atpW = parcelRequire("5atpW");

var $2oRWW = parcelRequire("2oRWW");

var $gUxVT = parcelRequire("gUxVT");

var $Cs8MU = parcelRequire("Cs8MU");

var $apUrw = parcelRequire("apUrw");

var $9yerk = parcelRequire("9yerk");

var $eqqK5 = parcelRequire("eqqK5");

var $7olFJ = parcelRequire("7olFJ");

var $7vAAT = parcelRequire("7vAAT");

var $f7B36 = parcelRequire("f7B36");

var $kEbCQ = parcelRequire("kEbCQ");
function $c45470667263a4bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $c45470667263a4bb$var$focusRingStyles = /*#__PURE__*/ (0, $hStPE.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $eqqK5.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $kEbCQ.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $7olFJ.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $7olFJ.borderWidthMap)['border.width']} solid`
        }
    }
});
const $c45470667263a4bb$var$baseStyles = {
    name: "9ge06c",
    styles: "box-sizing:border-box;text-decoration:underline"
};
const $c45470667263a4bb$var$positionStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $c45470667263a4bb$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $c45470667263a4bb$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $c45470667263a4bb$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $c45470667263a4bb$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $2oRWW.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $euxye.useContext)((0, $Cs8MU.default));
    const handleClick = (0, $euxye.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $gUxVT.useId)();
    const onClick = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $f7B36.parseXcss)(xcss);
    const RouterLink = (0, $5atpW.useRouterLink)();
    const isExternal = typeof href === 'string' && $c45470667263a4bb$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $c45470667263a4bb$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $jiTLE.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $hStPE.jsx)(Component, {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $c45470667263a4bb$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $c45470667263a4bb$var$baseStyles,
            $c45470667263a4bb$var$positionStyles,
            $c45470667263a4bb$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $9yerk.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $7vAAT.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $7vAAT.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $7vAAT.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $7vAAT.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $7vAAT.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $7vAAT.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $7vAAT.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $hStPE.jsx)((0, $apUrw.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $c45470667263a4bb$var$OPENS_NEW_WINDOW_LABEL}`));
};
$c45470667263a4bb$var$AnchorNoRef.displayName = "AnchorNoRef";
const $c45470667263a4bb$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $euxye.forwardRef)($c45470667263a4bb$var$AnchorNoRef);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$c45470667263a4bb$export$2e2bcd8739ae039 = $c45470667263a4bb$export$b688253958b8dfe7;

});

parcelRegister("klNTX", function(module, exports) {
$parcel$export(module.exports, "CreateFromFilesIcon", () => $494a606df1ce4189$export$1675443d62c3a34f);
/* CreateFromFilesIcon.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");
const $494a606df1ce4189$var$maskStyle = null;
const $494a606df1ce4189$export$1675443d62c3a34f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "#051524",
        fillOpacity: "0.06"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("mask", {
        id: "mask0_20132_12351",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "8",
        width: "18",
        height: "16",
        className: (0, $4jQY2.default)([
            "_13ae18uv"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M23.2552 19.8191C23.498 19.309 23.7037 18.7495 23.8682 18.1447C24.0328 17.5399 24.1439 16.9351 24.1933 16.3674C24.4936 12.965 22.7862 10.3525 19.7664 8.97837C19.2522 8.74387 18.6968 8.54639 18.1126 8.38594C17.5284 8.22549 16.8989 8.10618 16.3106 8.04858C13.0069 7.71533 10.2134 9.09768 8.75288 12.1627C8.50604 12.6811 8.29621 13.2447 8.12753 13.8619C7.95885 14.479 7.856 15.0508 7.80663 15.6186C7.51041 18.9963 9.21367 21.6088 12.2376 22.9994C12.7724 23.2462 13.3484 23.456 13.9614 23.6206C14.5744 23.7852 15.1257 23.888 15.6893 23.9497C18.993 24.2953 21.7947 22.9089 23.2552 19.8274V19.8191Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        mask: "url(#mask0_20132_12351)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M45.7441 -9.55063L-8.14844 -12.1016L-10.4498 36.5184L43.4427 39.0694L45.7441 -9.55063Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M29.4475 -10.3201L-8.15162 -12.1016L-8.90039 3.73789C-4.29666 9.53883 2.42585 13.4473 10.6253 15.2164C12.2628 15.5702 13.9619 15.8417 15.7145 16.0227C16.6608 16.1215 17.6276 16.1955 18.6068 16.2408C21.281 16.3683 23.8564 16.286 26.329 16.0022C33.644 15.167 39.988 12.5545 44.9044 8.30048L45.7519 -9.55079L29.4599 -10.3243L29.4475 -10.3201Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M29.4474 -10.3242C23.161 -6.07842 18.6848 0.393126 16.7224 8.91763C16.2081 11.1475 15.8667 13.5172 15.7103 16.0228C15.6939 16.2778 15.6815 16.5329 15.6692 16.7921C15.5375 19.5445 15.6445 22.1528 15.9695 24.6213C16.6401 29.7146 18.2446 34.1908 20.6432 37.9923L43.4396 39.0743L44.896 8.30462L45.7436 -9.54665L29.4516 -10.3201L29.4474 -10.3242Z",
        fill: "#6A9A23"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M26.3211 16.0043C40.8152 14.3463 51.4956 5.7313 54.8239 -8.86568C55.334 -11.0997 55.6714 -13.4735 55.8236 -15.9873C54.9761 -16.0695 54.1163 -16.1354 53.2482 -16.1765C50.4588 -16.3082 47.7764 -16.2135 45.2091 -15.9091C30.7274 -14.1935 20.0758 -5.61551 16.7269 8.91976C16.2127 11.1496 15.8712 13.5194 15.7148 16.0249C16.6611 16.1236 17.6279 16.1977 18.6071 16.2429C21.2813 16.3705 23.8567 16.2882 26.3293 16.0043H26.3211Z",
        fill: "#AF59E1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M10.666 15.7734L21.3381 16.2095",
        stroke: "white",
        strokeWidth: "1.75674",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M16.2203 10.6484L15.7842 21.3205",
        stroke: "white",
        strokeWidth: "1.75674",
        strokeMiterlimit: "10"
    }));
$494a606df1ce4189$export$1675443d62c3a34f.displayName = "CreateFromFilesIcon";

});

parcelRegister("apTXu", function(module, exports) {
$parcel$export(module.exports, "BringYourProjectIcon", () => $d3d0fe2428f9f663$export$1d14513c58b900c7);

var $euxye = parcelRequire("euxye");
const $d3d0fe2428f9f663$export$1d14513c58b900c7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "#051524",
        fillOpacity: "0.06"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0001 9H17.2501C17.6643 9 18.0001 9.33579 18.0001 9.75V15H16.5001V11.5607L10.0304 18.0303L8.96973 16.9697L15.4394 10.5H12.0001V9ZM15.5001 20.4393L21.9697 13.9697L23.0304 15.0303L16.5607 21.5H20.0001V23H14.7501C14.3358 23 14.0001 22.6642 14.0001 22.25V17H15.5001V20.4393Z",
        fill: "#505258"
    }));
$d3d0fe2428f9f663$export$1d14513c58b900c7.displayName = "BringYourProjectIcon";

});




parcelRegister("iGqlP", function(module, exports) {
$parcel$export(module.exports, "Nav4ProjectMenuItem", () => $74094212a985c9de$export$6a41b9c2eac627cc);

var $e7boj = parcelRequire("e7boj");

var $dJFjv = parcelRequire("dJFjv");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $f99M0 = parcelRequire("f99M0");

var $4pKBe = parcelRequire("4pKBe");

var $icsYg = parcelRequire("icsYg");

var $bFKrx = parcelRequire("bFKrx");

var $2QZiJ = parcelRequire("2QZiJ");

var $f54oL = parcelRequire("f54oL");

var $kGgTY = parcelRequire("kGgTY");

var $3jutG = parcelRequire("3jutG");
const $74094212a985c9de$export$6a41b9c2eac627cc = /*#__PURE__*/ (0, $euxye.memo)((t0)=>{
    const $ = (0, $e7boj.c)(8);
    const { queryRef: queryRef, setProjectToRestore: setProjectToRestore, isCorePremiumUserSeat: t1 } = t0;
    const isCorePremiumUserSeat = t1 === undefined ? false : t1;
    const data = (0, $n67Vb.useFragment)((0, $dJFjv.default), queryRef);
    if (!data) return null;
    if (data.status === "ARCHIVED") return null;
    let t2;
    if ($[0] !== data || $[1] !== isCorePremiumUserSeat) {
        t2 = ()=>{
            switch(data.projectType){
                case 0, $f99M0.JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bFKrx.AsyncJsmProjectMenu), {
                        projectData: data
                    });
                case 0, $f99M0.JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2QZiJ.JcsProjectMenu), {
                        projectData: data
                    });
                case 0, $f99M0.JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $icsYg.JpdProjectMenuLoader), {
                        projectFragment: data
                    });
                case 0, $f99M0.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f54oL.JswProjectMenu), {
                        projectData: data
                    });
                case 0, $f99M0.JIRA_PROJECT_TYPE_CORE_PROJECT:
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4pKBe.JiraBusinessProjectMenu), {
                        projectData: data,
                        isCorePremiumUserSeat: isCorePremiumUserSeat
                    });
            }
        };
        $[0] = data;
        $[1] = isCorePremiumUserSeat;
        $[2] = t2;
    } else t2 = $[2];
    const renderMenuItem = t2;
    let t3;
    if ($[3] !== renderMenuItem) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3jutG.ContentWithDragAndDrop), null, renderMenuItem());
        $[3] = renderMenuItem;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== setProjectToRestore || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kGgTY.ProjectRestoreContext).Provider, {
            value: setProjectToRestore
        }, t3);
        $[5] = setProjectToRestore;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
});

});
parcelRegister("dJFjv", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb47b1f30c45e743$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63efc1134fb045ae977fb248500ff77d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bb47b1f30c45e743$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4ProjectMenuItem",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "status"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraBusinessProjectMenu"
        },
        {
            "kind": "FragmentSpread",
            "name": "JsmProjectMenu"
        },
        {
            "kind": "FragmentSpread",
            "name": "JpdProjectMenu"
        },
        {
            "kind": "FragmentSpread",
            "name": "JswProjectMenu"
        },
        {
            "kind": "FragmentSpread",
            "name": "JcsProjectMenu"
        },
        {
            "kind": "FragmentSpread",
            "name": "JpdProjectMenuLoader_project"
        }
    ],
    "type": "JiraProject"
};
$bb47b1f30c45e743$var$node.hash = "5f6f4ebdcbc612c4d3122fb14077c5b9";
var $bb47b1f30c45e743$export$2e2bcd8739ae039 = $bb47b1f30c45e743$var$node;

});

parcelRegister("4pKBe", function(module, exports) {
$parcel$export(module.exports, "JiraBusinessProjectMenu", () => $c443bbef86129c1d$export$6145b58afae943e6);

var $je93u = parcelRequire("je93u");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $aJDWs = parcelRequire("aJDWs");

var $6Qg24 = parcelRequire("6Qg24");

var $5IkoH = parcelRequire("5IkoH");

var $aQCoC = parcelRequire("aQCoC");

var $8MkrP = parcelRequire("8MkrP");

var $dWplX = parcelRequire("dWplX");

var $2v6ed = parcelRequire("2v6ed");

var $fFNvS = parcelRequire("fFNvS");

var $kUZQu = parcelRequire("kUZQu");
const $c443bbef86129c1d$export$6145b58afae943e6 = ({ projectData: projectData, isCorePremiumUserSeat: isCorePremiumUserSeat = false, menuItemAnchorRef: menuItemAnchorRef })=>{
    const { sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent } = (0, $6Qg24.useProjectsAnalyticsL2)();
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    const project = (0, $n67Vb.useFragment)((0, $je93u.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    projectData);
    let isTargetSameAsCurrentLocation = false;
    if (typeof window !== 'undefined') isTargetSameAsCurrentLocation = window.location.pathname === project.defaultNavigationItem?.url;
    const projectUrl = project.defaultNavigationItem?.url ?? `/browse/${project.projectKey}`;
    const routerLinkConfig = (0, $euxye.useMemo)(()=>({
            to: projectUrl,
            prefetch: isTargetSameAsCurrentLocation ? false : 'hover'
        }), [
        isTargetSameAsCurrentLocation,
        projectUrl
    ]);
    const projectActionMenuOnClickHandler = (0, $euxye.useCallback)(()=>{
        const isFavourite = project.isFavourite;
        const projectId = project.projectId;
        const projectType = project.projectType;
        sendMeatBallDropDownOnProjectsAnalyticsEvent({
            // TODO BLU-5544 send section via <ContextualAnalyticsData instead (which wraps the Starred or Recent panel; and each project). Use static object or useMemo, not to have rerendering issues. Then you can also use static object for meatBallDropDownOnProjectsAnalytics. See Jsm and Wanjel components
            starred: isFavourite ?? false,
            recent: !isFavourite,
            projectId: projectId,
            projectType: projectType
        });
    }, [
        project.isFavourite,
        project.projectId,
        project.projectType,
        sendMeatBallDropDownOnProjectsAnalyticsEvent
    ]);
    // Memoize the inline JSX passed to the menu item. Without this, `elemBefore`
    // and `actionsOnHover` are fresh React elements on every render, so even when
    // their content is identical they force the menu-item subtree
    // (IconButton/button-base/pressable) to re-render on every parent render —
    // the SSR→boot re-render waste measured via Chippy.
    const elemBefore = (0, $euxye.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v6ed.ContainerAvatar), {
            src: project.avatar.large || ''
        }), [
        project.avatar.large
    ]);
    const actionsOnHover = (0, $euxye.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8MkrP.ProjectActionMenu), {
            isProjectMenuReorderingEnabled: Boolean(project.isFavourite),
            projectKey: project.projectKey,
            isCorePremiumUserSeat: isCorePremiumUserSeat,
            onClick: projectActionMenuOnClickHandler,
            projectName: project.name
        }), [
        project.isFavourite,
        project.projectKey,
        project.name,
        isCorePremiumUserSeat,
        projectActionMenuOnClickHandler
    ]);
    const { projectId: projectId, projectKey: projectKey, isFavourite: isFavourite, name: name, avatar: avatar } = project;
    const { state: state, draggableAnchorRef: draggableAnchorRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, dragPreview: dragPreview, hasDragIndicator: hasDragIndicator } = (0, $dWplX.useProjectMenuItemDragAndDrop)({
        projectId: projectId,
        projectKey: projectKey,
        isFavourite: isFavourite,
        name: name,
        avatar: avatar,
        isEnabled: !!isFavourite
    });
    if (project.subspaceCount && project.subspaceCount > 0 && (0, $aJDWs.isProjectsInJiraM2Enabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kUZQu.JiraBusinessProjectExpandableMenu), {
        ref: (0, $fFNvS.mergeRefs)(menuItemAnchorRef || null, draggableAnchorRef),
        visualContentRef: dropTargetRef,
        dropIndicator: dropIndicator,
        isDragging: state.type === 'dragging',
        hasDragIndicator: hasDragIndicator,
        elemBefore: elemBefore,
        href: routerLinkConfig,
        menuId: (0, $5IkoH.ENTITY_ID).PROJECT(project.projectKey),
        projectKey: project.projectKey,
        projectUrl: projectUrl,
        actionsOnHover: actionsOnHover
    }, project.name), dragPreview);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        ref: (0, $fFNvS.mergeRefs)(menuItemAnchorRef || null, draggableAnchorRef),
        visualContentRef: dropTargetRef,
        dropIndicator: dropIndicator,
        isDragging: state.type === 'dragging',
        hasDragIndicator: hasDragIndicator,
        elemBefore: elemBefore,
        href: routerLinkConfig,
        menuId: (0, $5IkoH.ENTITY_ID).PROJECT(project.projectKey),
        actionsOnHover: actionsOnHover
    }, project.name), dragPreview);
};
$c443bbef86129c1d$export$6145b58afae943e6.displayName = "JiraBusinessProjectMenu";

});
parcelRegister("je93u", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5cdc5a431a86199$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7c9d56ad8aff4fcf7852c9b37f37867d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e5cdc5a431a86199$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "JiraBusinessProjectMenu",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW"
                    }
                ]
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraNavigationItem",
                    "abstractKey": "__isJiraNavigationItem"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "alias": "subspaceCount",
                            "kind": "ScalarField",
                            "name": "subspaceCount_cse"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$e5cdc5a431a86199$var$node.hash = "fadcce9e27f89d8eeedccd75bf5fe066";
var $e5cdc5a431a86199$export$2e2bcd8739ae039 = $e5cdc5a431a86199$var$node;

});

parcelRegister("8MkrP", function(module, exports) {
$parcel$export(module.exports, "ProjectActionMenu", () => $839a7a0b68cd68ad$export$b71a0a4e7f29cfd6);

var $euxye = parcelRequire("euxye");

var $6H8Ah = parcelRequire("6H8Ah");

var $7Fzpe = parcelRequire("7Fzpe");

var $hZDXn = parcelRequire("hZDXn");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $cvA2R = parcelRequire("cvA2R");

var $k5jxB = parcelRequire("k5jxB");
const $839a7a0b68cd68ad$var$moreActions = (0, $7eNDO.defineMessage)({
    id: "navigation-project-action-menu.more-actions",
    defaultMessage: "More actions"
});
// @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
const $839a7a0b68cd68ad$var$CustomTrigger = /*#__PURE__*/ (0, $euxye.forwardRef)(({ ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const triggerButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6H8Ah.ThemedButtonOld), {
        ...props,
        ref: ref,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Fzpe))), {
            label: formatMessage($839a7a0b68cd68ad$var$moreActions),
            color: "currentColor",
            spacing: "spacious"
        }),
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-project-action-menu.ui.themed-button"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        content: formatMessage($839a7a0b68cd68ad$var$moreActions),
        hideTooltipOnClick: true
    }, triggerButton);
});
const $839a7a0b68cd68ad$export$b71a0a4e7f29cfd6 = ({ additionalMenuItems: additionalMenuItems, isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled = false, isCorePremiumUserSeat: isCorePremiumUserSeat = false, withThemedTrigger: withThemedTrigger = false, projectKey: projectKey, projectId: projectId, onClick: onClick, shouldRenderToParent: shouldRenderToParent, actionMenuId: actionMenuId, projectName: projectName, shouldHandleQueryParamModal: shouldHandleQueryParamModal = false })=>{
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    // Anonymous users have no project actions available, so hide the meatball trigger and popup
    // entirely when the experiment is enabled rather than surfacing an unauthorised menu.
    if (isAnonymous && (0, $2700E.expVal)('remove_space_menu_access_for_anonymous_users', 'isEnabled', false)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k5jxB.EntryPointContent), {
        projectName: projectName,
        isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
        additionalMenuItems: additionalMenuItems,
        onClick: onClick,
        isCorePremiumUserSeat: isCorePremiumUserSeat,
        CustomTrigger: withThemedTrigger ? $839a7a0b68cd68ad$var$CustomTrigger : undefined,
        projectKey: projectKey,
        projectId: projectId,
        shouldRenderToParent: shouldRenderToParent,
        actionMenuId: actionMenuId,
        source: withThemedTrigger ? 'horizontal-nav' : 'sidebar-nav',
        shouldHandleQueryParamModal: shouldHandleQueryParamModal
    });
};
$839a7a0b68cd68ad$export$b71a0a4e7f29cfd6.displayName = "ProjectActionMenu";

});
parcelRegister("k5jxB", function(module, exports) {
$parcel$export(module.exports, "EntryPointContent", () => $3ca3dfcd2f5da780$export$912f81dce8d58e46);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6ouZy = parcelRequire("6ouZy");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $kt86l = parcelRequire("kt86l");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $2ffUK = parcelRequire("2ffUK");

var $ba7pw = parcelRequire("ba7pw");

var $gnprg = parcelRequire("gnprg");

var $kCVHZ = parcelRequire("kCVHZ");

var $aOMAw = parcelRequire("aOMAw");
const $3ca3dfcd2f5da780$export$912f81dce8d58e46 = ({ CustomTrigger: CustomTrigger, onClick: onClick, additionalMenuItems: additionalMenuItems, isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled = false, isCorePremiumUserSeat: isCorePremiumUserSeat = false, projectKey: projectKey, projectId: projectId, shouldRenderToParent: shouldRenderToParent, actionMenuId: actionMenuId, projectName: projectName, source: source, shouldHandleQueryParamModal: shouldHandleQueryParamModal = false })=>{
    const cloudId = (0, $kt86l.useCloudId)();
    // Receiver for the deep-link `?editCustomTemplateForProject=<projectId>`.
    // The query param carries the target project's numeric id so that — even
    // though `shouldHandleQueryParamModal` is true on every sidebar
    // `ProjectActionMenu` (one per project) — only the instance whose
    // `projectId` matches the param value mounts the secondary entry-point
    // container and renders the modal. This prevents N modals from popping
    // when the sidebar has N custom-template projects listed.
    const [editCustomTemplateForProjectParam, setEditCustomTemplateForProject] = (0, $2ffUK.useQueryParam)('editCustomTemplateForProject');
    const isEditingCustomTemplate = // eslint-disable-next-line jira/ff/no-preconditioning
    shouldHandleQueryParamModal && projectId != null && editCustomTemplateForProjectParam === projectId && (0, $i860n.fg)('jira_custom_templates_ux') && (0, $2700E.expVal)('custom_templates_rich_text_details_and_avatar', 'isEnabled', false);
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $ba7pw.projectActionMenuEntryPoint), entryPointParams);
    const buttonTriggerRef = (0, $6ouZy.useEntryPointButtonTrigger)(entryPointActions);
    // Build the project ARI inline (the established pattern across the codebase
    // — see e.g. `OpsGenieSettingsUi`, `DriverField`) so the deep-link URL
    // itself stays short and human-readable while Relay still receives the
    // fully-qualified `id` argument it requires for `jiraProject(id:)`.
    const editTemplateEntryPointParams = (0, $euxye.useMemo)(()=>({
            projectAri: projectId ? `ari:cloud:jira:${cloudId}:project/${projectId}` : ''
        }), [
        cloudId,
        projectId
    ]);
    const { entryPointActions: editTemplateModalActions, entryPointReferenceSubject: editTemplateModalReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $gnprg.editCustomTemplateQueryParamEntryPoint), editTemplateEntryPointParams);
    if (isEditingCustomTemplate) editTemplateModalActions.load();
    const clearEditCustomTemplateParam = (0, $euxye.useCallback)(()=>{
        setEditCustomTemplateForProject(undefined);
    }, [
        setEditCustomTemplateForProject
    ]);
    const content = (0, $euxye.useCallback)((contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "project-actions-menu-popup-content",
            packageName: "jira-navigation-apps-project-action-menu",
            // oxlint-disable-next-line react-hooks/rules-of-hooks
            runtimeProps: (0, $euxye.useMemo)(()=>({
                    isCorePremiumUserSeat: isCorePremiumUserSeat,
                    additionalMenuItems: additionalMenuItems,
                    isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
                    contentProps: contentProps,
                    source: source
                }), [
                contentProps
            ]),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aOMAw.Skeleton), null)
        }), [
        entryPointReferenceSubject,
        additionalMenuItems,
        isCorePremiumUserSeat,
        isProjectMenuReorderingEnabled,
        source
    ]);
    const queryParamRuntimeProps = (0, $euxye.useMemo)(()=>({
            onClose: clearEditCustomTemplateParam
        }), [
        clearEditCustomTemplateParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, isEditingCustomTemplate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        entryPointReferenceSubject: editTemplateModalReferenceSubject,
        id: "project-actions-menu-query-param-modal",
        packageName: "jira-navigation-apps-project-action-menu",
        runtimeProps: queryParamRuntimeProps,
        fallback: null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kCVHZ.MenuContainer), {
        projectName: projectName,
        content: content,
        CustomTrigger: CustomTrigger,
        onClick: onClick,
        buttonTriggerRef: buttonTriggerRef,
        shouldRenderToParent: shouldRenderToParent,
        actionMenuId: actionMenuId
    }));
};
$3ca3dfcd2f5da780$export$912f81dce8d58e46.displayName = "EntryPointContent";

});
parcelRegister("ba7pw", function(module, exports) {
$parcel$export(module.exports, "projectActionMenuEntryPoint", () => $984d74996828afb6$export$30ec6de22da54fa0);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $fiVog = parcelRequire("fiVog");

var $k4brt = parcelRequire("k4brt");

const $984d74996828afb6$export$30ec6de22da54fa0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("kEfvn")), {
        moduleId: "f5b6857d",
        moduleName: "AsyncMenuWithQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>{
        const projectActionMenuQuery = {
            parameters: (0, $k4brt.default),
            variables: {
                cloudId: cloudId,
                projectKey: projectKey,
                isPlanCreationFromSourceEnabled: (0, $2700E.expVal)('plan_creation_from_other_surface_areas', 'isEnabled', false),
                isSpaceAgentsNonAdminViewEnabled: // eslint-disable-next-line jira/ff/no-preconditioning
                (0, $i860n.fg)('space-agent-settings-allow-non-admin-view') && (0, $2700E.expVal)('yamato-agents-home-space-settings-beta', 'isEnabled', false)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
        return {
            queries: {
                projectActionMenuQuery: projectActionMenuQuery
            }
        };
    }
});

});
parcelRegister("k4brt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca3d1ddec5682637$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<467d9005a09f003111fc375d18e2ec97>>
 * @relayHash a99f1bb480a0c3cd903df82079f26a67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b33bb91d8fba2bc3c62f53047f514c0277f7d4ffc5f126c563d08850b4b7242
const $ca3d1ddec5682637$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8b33bb91d8fba2bc3c62f53047f514c0277f7d4ffc5f126c563d08850b4b7242",
        "metadata": {},
        "name": "AsyncMenuWithQueryQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ca3d1ddec5682637$export$2e2bcd8739ae039 = $ca3d1ddec5682637$var$node;

});

parcelRegister("kEfvn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("5CG1y")
]).then(()=>parcelRequire('1f9r8'));

});


parcelRegister("gnprg", function(module, exports) {
$parcel$export(module.exports, "editCustomTemplateQueryParamEntryPoint", () => $cc35b87a7bc2580f$export$aa1dd3f15222620f);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $7qq9R = parcelRequire("7qq9R");

const $cc35b87a7bc2580f$export$aa1dd3f15222620f = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("hUe9H")), {
        moduleId: "0053e7be",
        moduleName: "EditCustomTemplateQueryParamModal",
        priority: "interaction"
    }),
    getPreloadProps: ({ projectAri: projectAri })=>({
            queries: {
                editCustomTemplateQuery: {
                    parameters: (0, $7qq9R.default),
                    variables: {
                        projectAri: projectAri
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("7qq9R", function(module, exports) {
$parcel$export(module.exports, "default", () => $baadb0eaf8e2cc51$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2392d98317ffb5fa1d9dbf69d02af323>>
 * @relayHash c71162808b0aaf43193218edf0425393
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2d6da81210d378d9b19f81d60b00cb6affccdfc19e1560d90980dc9c42a7e4b1
const $baadb0eaf8e2cc51$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2d6da81210d378d9b19f81d60b00cb6affccdfc19e1560d90980dc9c42a7e4b1",
        "metadata": {},
        "name": "EditCustomTemplateQueryParamModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $baadb0eaf8e2cc51$export$2e2bcd8739ae039 = $baadb0eaf8e2cc51$var$node;

});

parcelRegister("hUe9H", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("cUD3g")
]).then(()=>parcelRequire('5LPUV'));

});


parcelRegister("aOMAw", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $2b5e9d40d91f402a$export$8f31e4c4a37b8e9c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");


var $kENFC = parcelRequire("kENFC");

var $72ldR = parcelRequire("72ldR");

var $g36LP = parcelRequire("g36LP");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $6Elhl = parcelRequire("6Elhl");
const $2b5e9d40d91f402a$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $2b5e9d40d91f402a$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), {
        minWidth: (0, $47916ea360432737$export$9c07662d9724277)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $2b5e9d40d91f402a$var$projectTileSkeleton
    }))));
$2b5e9d40d91f402a$export$8f31e4c4a37b8e9c.displayName = "Skeleton";
const $2b5e9d40d91f402a$var$wrapperStyles = (0, $fbAgj.xcss)({
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $47916ea360432737$export$9c07662d9724277)}px`
});
const $2b5e9d40d91f402a$var$projectTileSkeleton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-600, 48px)",
    flex: 1
});

});



parcelRegister("dWplX", function(module, exports) {
$parcel$export(module.exports, "useProjectMenuItemDragAndDrop", () => $edb5bcdece372ce0$export$1496323130e2da11);

var $euxye = parcelRequire("euxye");

var $aYssY = parcelRequire("aYssY");

var $2v6ed = parcelRequire("2v6ed");

var $3mtaC = parcelRequire("3mtaC");

var $jo8j7 = parcelRequire("jo8j7");
const $edb5bcdece372ce0$export$1496323130e2da11 = (props)=>{
    const { projectId: projectId, projectKey: projectKey, isFavourite: isFavourite, name: name, avatar: avatar, isEnabled: isEnabled = false } = props;
    /* isEnabled is used to determine if drag and drop functionality should be enabled – this is used to turn on the feature only for starred projects.
	By using this to pass undefined to draggable and dropTarget the useMenuItemDragAndDrop hook does not run its effects to attach event listeners.
	The drag and drop functionality is effectively disabled, while still setting up the refs which are required for consistent rendering. */ const { state: state, draggableButtonRef: draggableButtonRef, dropTargetRef: dropTargetRef, draggableAnchorRef: draggableAnchorRef, dragPreview: dragPreview, dropIndicator: dropIndicator } = (0, $aYssY.useMenuItemDragAndDrop)({
        draggable: isEnabled ? {
            getInitialData: ()=>({
                    id: projectId,
                    key: projectKey,
                    isFavourite: isFavourite,
                    name: name,
                    avatar: avatar.large || '',
                    type: (0, $3mtaC.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP)
                }),
            getDragPreviewPieces: ()=>({
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v6ed.ContainerAvatar), {
                        src: avatar.large || ''
                    }),
                    content: name
                })
        } : undefined,
        dropTarget: isEnabled ? {
            getData: ()=>({
                    id: projectId,
                    key: projectKey,
                    isFavourite: isFavourite,
                    name: name,
                    avatar: avatar.large || '',
                    type: (0, $3mtaC.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP)
                }),
            getOperations: ()=>({
                    'reorder-after': 'available',
                    'reorder-before': 'available'
                }),
            canDrop: ({ source: source })=>source.data.type === (0, $3mtaC.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP)
        } : undefined
    });
    const { shouldRestoreFocus: shouldRestoreFocus, clearRestoreFocus: clearRestoreFocus } = (0, $euxye.useContext)((0, $jo8j7.FocusRestorationContext));
    (0, $euxye.useEffect)(()=>{
        if (shouldRestoreFocus && isEnabled) // .focus() seems to be more reliable in the next task when used with VoiceOver
        setTimeout(()=>{
            (draggableButtonRef.current ?? draggableAnchorRef.current)?.focus();
            clearRestoreFocus();
        });
    }, [
        clearRestoreFocus,
        draggableAnchorRef,
        draggableButtonRef,
        isEnabled,
        shouldRestoreFocus
    ]);
    return {
        state: state,
        draggableButtonRef: draggableButtonRef,
        dropTargetRef: dropTargetRef,
        draggableAnchorRef: draggableAnchorRef,
        dragPreview: isEnabled ? dragPreview : null,
        dropIndicator: isEnabled ? dropIndicator : null,
        hasDragIndicator: isEnabled
    };
};

});
parcelRegister("2v6ed", function(module, exports) {
$parcel$export(module.exports, "ContainerAvatar", () => $d3236bba58e8d4ac$export$f35a2d11bd6ae97);
/* container-avatar.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $d3236bba58e8d4ac$var$styles = {
    root: "_2rko12b0 _vchhusvi _4t3igktf _1bsbgktf"
};
const $d3236bba58e8d4ac$export$f35a2d11bd6ae97 = ({ src: src })=>/*#__PURE__*/ (0, $e79Pd.jsx)("img", {
        src: src,
        alt: "",
        className: (0, $4jQY2.default)([
            $d3236bba58e8d4ac$var$styles.root
        ])
    });
$d3236bba58e8d4ac$export$f35a2d11bd6ae97.displayName = "ContainerAvatar";

});

parcelRegister("3mtaC", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $83ce6f9fee56b60e$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $83ce6f9fee56b60e$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ANALYTIC_PAYLOAD", () => $83ce6f9fee56b60e$export$4a2242445a67aef7);
$parcel$export(module.exports, "NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP", () => $83ce6f9fee56b60e$export$e320e335fe38c28a);
/* eslint-disable jira/filename-case */ 



var $bOwox = parcelRequire("bOwox");


const $83ce6f9fee56b60e$export$b8b9d90f9e5bd72b = 'jira-navigation-apps-sidebar-nav4-projects-customise-order';
const $83ce6f9fee56b60e$export$d57b6b390e78d90f = 'jira-cosmos';
const $83ce6f9fee56b60e$export$4a2242445a67aef7 = {
    UPDATED_ORDER: {
        action: 'updated',
        actionSubject: 'sidebarNavigationItems',
        actionSubjectId: (0, $47ad9e6c8e8002a4$export$8d155d2412839524)
    },
    ATTRIBUTES: {
        level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
        componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
        itemType: (0, $687cb22024c607c7$export$fe791c4fa892e400),
        section: (0, $bOwox.SECTION_ITEM_STARRED)
    },
    DRAG_STARTED: {
        action: 'dragStarted',
        actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
        actionSubjectId: (0, $47ad9e6c8e8002a4$export$8d155d2412839524)
    },
    DRAG_LEFT: {
        action: 'dragLeft',
        actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
        actionSubjectId: (0, $47ad9e6c8e8002a4$export$8d155d2412839524)
    },
    DRAG_ENTERED: {
        action: 'dragEntered',
        actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
        actionSubjectId: (0, $47ad9e6c8e8002a4$export$8d155d2412839524)
    },
    DRAG_ENDED: {
        action: 'dragEnded',
        actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
        actionSubjectId: (0, $47ad9e6c8e8002a4$export$8d155d2412839524)
    }
};
const $83ce6f9fee56b60e$export$e320e335fe38c28a = 'nav4-sidebar-project-menu-item-drag-and-drop';

});

parcelRegister("jo8j7", function(module, exports) {
$parcel$export(module.exports, "FocusRestorationContext", () => $3bae9d223f51f40b$export$ee843363a931c6f7);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");
const $3bae9d223f51f40b$export$ee843363a931c6f7 = /*#__PURE__*/ (0, $euxye.createContext)({
    shouldRestoreFocus: false,
    enableRestoreFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    clearRestoreFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
});

});


parcelRegister("kUZQu", function(module, exports) {
$parcel$export(module.exports, "JiraBusinessProjectExpandableMenu", () => $8d8821d169ec17d9$export$258946d51354bda3);

var $euxye = parcelRequire("euxye");

var $4VtOS = parcelRequire("4VtOS");

var $c4aX7 = parcelRequire("c4aX7");

var $6YVc9 = parcelRequire("6YVc9");

var $kFgCO = parcelRequire("kFgCO");

var $gEDfa = parcelRequire("gEDfa");

var $jreC0 = parcelRequire("jreC0");

var $hDvet = parcelRequire("hDvet");

var $f1JKW = parcelRequire("f1JKW");


var $btoiF = parcelRequire("btoiF");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $h3LJR = parcelRequire("h3LJR");

var $kt86l = parcelRequire("kt86l");

var $fFNvS = parcelRequire("fFNvS");

function $8d8821d169ec17d9$var$JiraBusinessProjectExpandableMenuContent({ visualContentRef: visualContentRef, dropIndicator: dropIndicator, isDragging: isDragging, hasDragIndicator: hasDragIndicator, elemBefore: elemBefore, menuId: menuId, actionsOnHover: actionsOnHover, children: children, projectKey: projectKey, projectUrl: projectUrl, ...triggerProps }, expandableRef) {
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const { data: { user: { accountId: accountId } } } = (0, $kFgCO.useCurrentUser)();
    // Best available entrypoint pattern https://hello.atlassian.net/wiki/spaces/UAF/pages/2718064036/EntryPoints+FAQs#TS2345-%3A-Argument-type-%E2%80%A6getPreloadProps%3A-()-%3D%3E-%7B%7D%3B-%7D-is-not-assignable-to-parameter-of-type-'never'.
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const entryPointParams = (0, $euxye.useMemo)(// oxlint-disable-line typescript/consistent-type-assertions
    ()=>({
            tenantContext: {
                cloudId: cloudId,
                activationId: activationId,
                atlassianAccountId: accountId || ''
            },
            context: {
                match: {
                    params: {
                        projectKey: projectKey
                    }
                }
            }
        }), [
        accountId,
        activationId,
        cloudId,
        projectKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $6YVc9.subspaceEntryPoint), entryPointParams);
    const triggerRef = (0, $hDvet.useExpandableEntryPointTrigger)(entryPointActions);
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const leftSidebarEPRef = (0, $btoiF.usePageLayoutEntryPoint)((0, $b666e36d39b806ff$export$50ea883ba6f28ff5)); // oxlint-disable-line typescript/consistent-type-assertions
    const subspacesEPRef = leftSidebarEPRef?.entryPoints?.subspaces;
    const expandableMenuItemTriggerRef = (0, $fFNvS.default)(expandableRef, triggerRef);
    const epContainerProps = (0, $euxye.useMemo)(()=>({
            id: 'business-expandable-project',
            packageName: (0, $1630b67077db9f8b$export$b8b9d90f9e5bd72b),
            teamName: (0, $1630b67077db9f8b$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null),
            // oxlint-disable-next-line typescript/consistent-type-assertions
            runtimeProps: {}
        }), []);
    // Compute isSelected based on current path
    const { getLinkProps: getLinkProps } = (0, $c4aX7.useGetLinkProps)();
    const { isSelected: isSelected } = getLinkProps(projectUrl);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        dropTargetRef: visualContentRef,
        dropIndicator: dropIndicator,
        isDragging: isDragging,
        menuId: menuId,
        onExpansionToggle: ()=>{
            entryPointActions.load();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        elemBefore: elemBefore,
        actionsOnHover: actionsOnHover,
        ref: expandableMenuItemTriggerRef,
        interactionName: "nav4-sidebar-business-expandable-project",
        isSelected: isSelected,
        ...triggerProps
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f1JKW.RouteEntryPointContainer), {
        epContainerProps: epContainerProps,
        jiraEPRef: entryPointReferenceSubject,
        nestedEPRef: subspacesEPRef,
        placeholderEntryPoint: (0, $6YVc9.subspaceEntryPoint)
    })));
}
$8d8821d169ec17d9$var$JiraBusinessProjectExpandableMenuContent.displayName = "JiraBusinessProjectExpandableMenuContent";
const $8d8821d169ec17d9$export$258946d51354bda3 = /*#__PURE__*/ (0, $euxye.forwardRef)($8d8821d169ec17d9$var$JiraBusinessProjectExpandableMenuContent);

});
parcelRegister("c4aX7", function(module, exports) {
$parcel$export(module.exports, "useGetLinkProps", () => $97d1f91a68357928$export$a3307878c8496d13);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $cn1qc = parcelRequire("cn1qc");

var $881dx = parcelRequire("881dx");
const $97d1f91a68357928$export$a3307878c8496d13 = ()=>{
    const location = (0, $cn1qc.useLocation)();
    const getLinkProps = (0, $euxye.useCallback)((menuItemPath, options)=>$97d1f91a68357928$var$getMenuLinkPropsFromUrlPath({
            currentPath: location.pathname,
            menuItemPath: menuItemPath,
            options: options
        }), [
        location.pathname
    ]);
    const getLinkPropsFromRoute = (0, $euxye.useCallback)((menuItemRoute, pathParamValues = {}, options)=>{
        const menuItemPath = (0, $881dx.generatePath)(menuItemRoute.path, pathParamValues);
        return getLinkProps(menuItemPath, options);
    }, [
        getLinkProps
    ]);
    return {
        getLinkPropsFromRoute: getLinkPropsFromRoute,
        getLinkProps: /**
		 * Consider using getLinkPropsFromRoute instead, to be able to reuse the page route object, rather than copying its url path around.
		 */ getLinkProps
    };
};
const $97d1f91a68357928$var$defaultOptions = {
    shouldMatchExactPath: true
};
const $97d1f91a68357928$var$getMenuLinkPropsFromUrlPath = ({ currentPath: currentPath, menuItemPath: menuItemPath, options: options })=>{
    const { shouldMatchExactPath: shouldMatchExactPath } = {
        ...$97d1f91a68357928$var$defaultOptions,
        ...options
    };
    return {
        href: menuItemPath,
        isSelected: shouldMatchExactPath ? currentPath.replace(/\/$/, '') === menuItemPath.replace(/\/$/, '') : currentPath.includes(menuItemPath.replace(/\/$/, ''))
    };
};

});

parcelRegister("6YVc9", function(module, exports) {
$parcel$export(module.exports, "subspaceEntryPoint", () => $6f3009339f822600$export$f29fc5a65705d8e3);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $i0CFV = parcelRequire("i0CFV");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $2NSbF = parcelRequire("2NSbF");

var $18sMq = parcelRequire("18sMq");

var $y9N9w = parcelRequire("y9N9w");

const $6f3009339f822600$export$f29fc5a65705d8e3 = (0, $fiVog.createEntryPoint)({
    // TODO: register this entrypoint in the routes file issueNavigatorPageEntryPointWithNested
    // https://jplat.atlassian.net/browse/ANIP-912
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("elzoF")), {
        moduleId: "833b1b3d",
        moduleName: "SubspacesQuery",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId ?? '';
        let projectKey = '';
        if (params.context?.match.params?.projectKey) projectKey = params.context.match.params.projectKey;
        else if (params.context?.match.params?.issueKey && (0, $i860n.fg)('move-issue-view-to-entrypoint')) projectKey = (0, $i0CFV.getProjectKey)(params.context.match, params.context.query);
        const activationId = params.tenantContext?.activationId ?? '';
        const entityAri = (0, $18sMq.NavigationSettingAri).create({
            activationId: activationId,
            firstPartyApp: 'jira',
            siteId: cloudId,
            settingId: `project-${projectKey.toLowerCase()}-subcontainer`
        }).toString();
        const ownerAri = (0, $2NSbF.IdentityUserAri).create({
            userId: params.tenantContext.atlassianAccountId || 'UNKNOWN'
        }).toString();
        return {
            queries: {
                projects: {
                    parameters: $y9N9w.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        entityAri: entityAri,
                        ownerAri: ownerAri,
                        noOfBoardsToFetch: 0,
                        skipOrderQuery: false
                    }
                }
            },
            extraProps: {
                entityAri: entityAri,
                ownerAri: ownerAri
            }
        };
    }
});

});
parcelRegister("y9N9w", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5b687302313f447$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c09c160e348987608133cd5068d9c77a>>
 * @relayHash 0fb7ba9477a850ce9061cd47921a39ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eb3ad1062789e90dfa25be000f11f17180ea080141de678232bb21cc5390c6ea
const $b5b687302313f447$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "eb3ad1062789e90dfa25be000f11f17180ea080141de678232bb21cc5390c6ea",
        "metadata": {},
        "name": "SubspacesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b5b687302313f447$export$2e2bcd8739ae039 = $b5b687302313f447$var$node;

});

parcelRegister("elzoF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gfpNi").then(()=>parcelRequire('dglCa'));

});


/* eslint-disable jira/filename-case */ const $1630b67077db9f8b$export$b8b9d90f9e5bd72b = '@jira/navigation-apps__sidebar-nav4-sidebars-content-projects-jira-business-project-menu';
const $1630b67077db9f8b$export$d57b6b390e78d90f = 'jira-cosmos';



parcelRegister("icsYg", function(module, exports) {
$parcel$export(module.exports, "JpdProjectMenuLoader", () => $cf5ddd3ce416fe69$export$dbd7aa9c4d7e9816);

var $1PihV = parcelRequire("1PihV");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $2IL92 = parcelRequire("2IL92");

var $5F8FY = parcelRequire("5F8FY");

var $cZjb4 = parcelRequire("cZjb4");
var $55BnK = parcelRequire("55BnK");

var $6fsuc = parcelRequire("6fsuc");

var $8JMRb = parcelRequire("8JMRb");

var $1VxeX = parcelRequire("1VxeX");

var $chido = parcelRequire("chido");
const $cf5ddd3ce416fe69$export$dbd7aa9c4d7e9816 = ({ projectFragment: projectFragment, menuItemButtonRef: menuItemButtonRef })=>{
    const { push: push } = (0, $55BnK.useRouterActions)();
    const [projectKeyFromUrl] = (0, $cZjb4.usePathParam)('projectKey');
    const projectKeyRef = (0, $euxye.useRef)(projectKeyFromUrl);
    (0, $euxye.useEffect)(()=>{
        projectKeyRef.current = projectKeyFromUrl;
    }, [
        projectKeyFromUrl
    ]);
    const project = (0, $n67Vb.useFragment)((0, $1PihV.default), projectFragment);
    const navigationProject = (0, $euxye.useMemo)(()=>{
        const navigationProjectData = {
            projectId: project.id,
            projectKey: project.projectKey,
            isFavourite: project.isFavourite ?? false,
            // oxlint-disable-next-line typescript/consistent-type-assertions
            projectType: project.projectType
        };
        try {
            return {
                ...navigationProjectData,
                projectId: (0, $6fsuc.AnyAri).parse(project.id).resourceId
            };
        } catch  {
            return navigationProjectData;
        }
    }, [
        project.id,
        project.isFavourite,
        project.projectKey,
        project.projectType
    ]);
    const isProjectSelected = project.projectKey ? projectKeyFromUrl === project.projectKey : false;
    const isProjectChanged = projectKeyRef.current !== projectKeyFromUrl;
    // Track project expansion state, selected project is expanded by default
    const { isOpen: isProjectExpanded, onToggle: onToggle } = (0, $5F8FY.useOpenable)(isProjectSelected);
    const onViewCreated = (0, $euxye.useCallback)((view)=>{
        if (isProjectSelected) return;
        push((0, $8JMRb.getViewUrl)({
            container: navigationProject,
            view: view
        }));
    }, [
        isProjectSelected,
        push,
        navigationProject
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2IL92.ProjectExpandableMenuItem), {
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1VxeX.AsyncActionButtons), {
            projectKey: project.projectKey,
            onViewCreated: onViewCreated,
            isProjectExpanded: isProjectExpanded,
            navigationProject: navigationProject
        }),
        projectData: project,
        menuItemButtonRef: menuItemButtonRef,
        onToggle: onToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $chido.AsyncJpdProjectMenuContent), {
        navigationProject: navigationProject,
        onViewCreated: onViewCreated,
        isProjectSelected: isProjectSelected,
        isProjectChanged: isProjectChanged
    }));
};
$cf5ddd3ce416fe69$export$dbd7aa9c4d7e9816.displayName = "JpdProjectMenuLoader";

});
parcelRegister("1PihV", function(module, exports) {
$parcel$export(module.exports, "default", () => $f93e4930ee384b2c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<da9335d1fa3db41d5d77b3d041b0e66b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f93e4930ee384b2c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JpdProjectMenuLoader_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "FragmentSpread",
            "name": "ProjectExpandableMenuItem"
        }
    ],
    "type": "JiraProject"
};
$f93e4930ee384b2c$var$node.hash = "c174cdb45912f322052132f5018e2639";
var $f93e4930ee384b2c$export$2e2bcd8739ae039 = $f93e4930ee384b2c$var$node;

});

parcelRegister("2IL92", function(module, exports) {
$parcel$export(module.exports, "ProjectExpandableMenuItem", () => $2c07ba810382cad8$export$a065ca52207bd220);

var $2Srvk = parcelRequire("2Srvk");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $TTcqD = parcelRequire("TTcqD");

var $ekhRy = parcelRequire("ekhRy");

var $5IkoH = parcelRequire("5IkoH");

var $4VtOS = parcelRequire("4VtOS");

var $jzXAj = parcelRequire("jzXAj");

var $dWplX = parcelRequire("dWplX");

var $2v6ed = parcelRequire("2v6ed");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $f2wVS = parcelRequire("f2wVS");

var $i860n = parcelRequire("i860n");

var $fFNvS = parcelRequire("fFNvS");
const $2c07ba810382cad8$var$FRAGMENT_KEY = 'jsm-project-menu-item';
function $2c07ba810382cad8$export$a065ca52207bd220({ projectData: projectData, children: children, actionsOnHover: actionsOnHover, menuItemButtonRef: menuItemButtonRef, onToggle: onToggle }) {
    const { sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent } = (0, $ekhRy.useProjectsAnalyticsL1)();
    const ssrPlaceholderEnabledRoutes = new Set([
        'servicedesk-queues-custom-view',
        'servicedesk-practice-custom-and-issue',
        'csm-queues-custom-view'
    ]);
    const ssrPlaceholderEnabledRoutesOld = new Set([
        'servicedesk-queues-custom-view',
        'servicedesk-practice-custom-and-issue'
    ]);
    const shouldWrapWithPlaceholder = (0, $f2wVS.useIsActiveRoute)((0, $i860n.fg)('csm_appification_standalone_navigation') ? ssrPlaceholderEnabledRoutes : ssrPlaceholderEnabledRoutesOld);
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    const project = (0, $n67Vb.useFragment)((0, $2Srvk.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    projectData);
    const onTriggerClick = (0, $euxye.useCallback)(()=>{
        sendProjectMenuItemAnalyticsEvent({
            starred: project.isFavourite ?? false,
            recent: !project.isFavourite,
            projectId: project.projectId,
            projectType: project.projectType
        });
    }, [
        sendProjectMenuItemAnalyticsEvent,
        project?.isFavourite,
        project?.projectId,
        project?.projectType
    ]);
    const onExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        onToggle && onToggle();
        if (hasExpanded) onTriggerClick();
    }, [
        onToggle,
        onTriggerClick
    ]);
    const { state: state, draggableButtonRef: draggableButtonRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, dragPreview: dragPreview, hasDragIndicator: hasDragIndicator } = (0, $dWplX.useProjectMenuItemDragAndDrop)({
        projectId: project.projectId,
        projectKey: project.projectKey,
        isFavourite: project.isFavourite,
        name: project.name,
        avatar: project.avatar,
        isEnabled: !!project.isFavourite
    });
    const isPageHydrating = (0, $TTcqD.useIsHydrateRenderMode)();
    const displaySsrPlaceholderAttrs = (0, $TTcqD.useSsrPlaceholders)();
    // `<Avatar src={project.avatar.large} />` is otherwise re-created on every
    // render, giving `elemBefore` a new identity and re-rendering the menu-item
    // trigger subtree unnecessarily (measured via Chippy). `project` is a stable
    // Relay fragment reference, so memoizing on `avatar.large` keeps the element
    // identity stable across parent re-renders.
    const avatarSrc = project?.avatar?.large;
    const elemBefore = (0, $euxye.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v6ed.ContainerAvatar), {
            src: avatarSrc
        }), [
        avatarSrc
    ]);
    if (!project) return null;
    const menuId = (0, $5IkoH.ENTITY_ID).PROJECT(project.projectKey);
    const menuItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        menuId: menuId,
        onExpansionToggle: onExpansionToggle,
        dropIndicator: dropIndicator,
        dropTargetRef: dropTargetRef,
        isDragging: state.type === 'dragging'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        ref: (0, $fFNvS.mergeRefs)(draggableButtonRef, menuItemButtonRef || null),
        actionsOnHover: actionsOnHover,
        elemBefore: elemBefore,
        testId: (0, $jzXAj.getTestId)(menuId),
        isDragging: state.type === 'dragging',
        hasDragIndicator: hasDragIndicator,
        interactionName: "nav4-sidebar-projects"
    }, project.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, children)), dragPreview);
    // The data-ssr-placeholder has to be unique for each project in the sidebar
    const FRAGMENT_KEY_NEW = `jsm-project-menu-item-${project.projectKey}`;
    // This is the fallback we need until we have implemented all of the Jira project types.
    return shouldWrapWithPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-vc": `${$2c07ba810382cad8$var$FRAGMENT_KEY}${false && !isPageHydrating ? '-ssr' : ''}`,
        ...false && displaySsrPlaceholderAttrs && {
            'data-ssr-placeholder': FRAGMENT_KEY_NEW
        },
        ...!false && displaySsrPlaceholderAttrs && {
            'data-ssr-placeholder-replace': FRAGMENT_KEY_NEW
        }
    }, menuItem) : menuItem;
}
$2c07ba810382cad8$export$a065ca52207bd220.displayName = "ProjectExpandableMenuItem";

});
parcelRegister("2Srvk", function(module, exports) {
$parcel$export(module.exports, "default", () => $18e812e5d7eba9c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ffc502d5713447b5434aecc822b7217a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $18e812e5d7eba9c3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ProjectExpandableMenuItem",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW"
                    }
                ]
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ],
    "type": "JiraProject"
};
$18e812e5d7eba9c3$var$node.hash = "12cc08f1c0e66ef33794188ba0f98544";
var $18e812e5d7eba9c3$export$2e2bcd8739ae039 = $18e812e5d7eba9c3$var$node;

});


parcelRegister("8JMRb", function(module, exports) {
$parcel$export(module.exports, "getViewUrl", () => $db6c71066fa9017d$export$bdccd6a672e4a607);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
const $db6c71066fa9017d$export$bdccd6a672e4a607 = ({ container: container, view: view })=>{
    const viewSlug = (0, $i860n.fg)('jpd-aurora-view-uuid-migration') ? view.id : view.polarisId;
    return `/jira/polaris/projects/${container.projectKey}/ideas/view/${viewSlug}`;
};

});

parcelRegister("1VxeX", function(module, exports) {
$parcel$export(module.exports, "AsyncActionButtons", () => $3694de0be86297dd$export$5ee2efc69b61be44);

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $3694de0be86297dd$var$LazyActionButtons = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("2n4ed")).then(({ ActionButtons: ActionButtons })=>ActionButtons), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-content-projects-jpd-project-menu/src/ui/action-buttons/index.tsx"
});
const $3694de0be86297dd$export$5ee2efc69b61be44 = /*#__PURE__*/ (0, $euxye.memo)(({ navigationProject: navigationProject, isProjectExpanded: isProjectExpanded, isProjectSelected: isProjectSelected, onViewCreated: onViewCreated, projectKey: projectKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.jpd-project-action-buttons"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3694de0be86297dd$var$LazyActionButtons, {
        navigationProject: navigationProject,
        isProjectExpanded: isProjectExpanded,
        isProjectSelected: isProjectSelected,
        onViewCreated: onViewCreated,
        projectKey: projectKey
    })));

});
parcelRegister("2n4ed", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3vrLT").then(()=>parcelRequire('aOjld'));

});


parcelRegister("chido", function(module, exports) {
$parcel$export(module.exports, "AsyncJpdProjectMenuContent", () => $18062cb9cb75cc94$export$5ed32f588aaa953a);

var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $gEDfa = parcelRequire("gEDfa");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");
const $18062cb9cb75cc94$var$Skeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null);
$18062cb9cb75cc94$var$Skeleton.displayName = "Skeleton";

const $18062cb9cb75cc94$var$LazyJpdProjectMenuContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("c2vKq")).then(({ JpdProjectMenuContent: JpdProjectMenuContent })=>JpdProjectMenuContent), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-content-projects-jpd-project-menu/src/ui/JpdProjectMenuContent.tsx"
});
const $18062cb9cb75cc94$export$5ed32f588aaa953a = /*#__PURE__*/ (0, $euxye.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.jpd-project-menu",
        packageName: "jiraNavigationAppsSidebarNav4JPDProjectMenu",
        ufoName: "nav4.sidebar.jpd-project-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.jpd-project-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($18062cb9cb75cc94$var$Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($18062cb9cb75cc94$var$LazyJpdProjectMenuContent, props))));

});
parcelRegister("c2vKq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("5geQX"),
    $4cvLQ("7xTsk")
]).then(()=>parcelRequire('6Fw9b'));

});



parcelRegister("bFKrx", function(module, exports) {
$parcel$export(module.exports, "AsyncJsmProjectMenu", () => $f86dda8c30e43682$export$bf0d7afec25f82d7);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $gEDfa = parcelRequire("gEDfa");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");
const $f86dda8c30e43682$var$Skeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), {
        count: 1
    });
$f86dda8c30e43682$var$Skeleton.displayName = "Skeleton";

const $f86dda8c30e43682$var$LazySidebarContentWrapper = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("lu26M")).then(({ JsmProjectMenuWrapper: JsmProjectMenuWrapper })=>JsmProjectMenuWrapper), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-content-projects-jsm-project-menu/src/ui/project-menu/JsmProjectMenuWrapper.tsx"
});
const $f86dda8c30e43682$export$bf0d7afec25f82d7 = /*#__PURE__*/ (0, $euxye.memo)(({ projectData: projectData, menuItemButtonRef: menuItemButtonRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.jsm-project-menu",
        packageName: "jiraNavigationAppsSidebarNav4JsmProjectMenu",
        teamName: "jsm-grape-soju",
        ufoName: "nav4.sidebar.jsm-project-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.jsm-project-menu.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f86dda8c30e43682$var$Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f86dda8c30e43682$var$LazySidebarContentWrapper, {
        projectData: projectData,
        menuItemButtonRef: menuItemButtonRef
    }))));

});
parcelRegister("lu26M", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cHc9k").then(()=>parcelRequire('adwXa'));

});


parcelRegister("2QZiJ", function(module, exports) {
$parcel$export(module.exports, "JcsProjectMenu", () => $2ea6c80423104bf3$export$2d6552c0aef54d);

var $lnmiq = parcelRequire("lnmiq");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $4NgYT = parcelRequire("4NgYT");

var $7ehYC = parcelRequire("7ehYC");

var $dXmF1 = parcelRequire("dXmF1");

var $2IL92 = parcelRequire("2IL92");

var $9bydH = parcelRequire("9bydH");
const $2ea6c80423104bf3$var$analyticsAttributes = {
    navState: 'v4'
};
const $2ea6c80423104bf3$export$2d6552c0aef54d = ({ projectData: projectData, menuItemButtonRef: menuItemButtonRef })=>{
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    const project = (0, $n67Vb.useFragment)((0, $lnmiq.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    projectData);
    // `<ProjectActions>` is otherwise re-created on every render, giving the
    // `actionsOnHover` prop a new identity and re-rendering the menu-item trigger
    // subtree unnecessarily (measured via Chippy). `project` is a stable Relay
    // fragment reference, so memoizing keeps the element identity stable across
    // parent re-renders.
    const actionsOnHover = (0, $euxye.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dXmF1.ProjectActions), {
            projectFragment: project
        }), [
        project
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4NgYT.ContextualAnalyticsData), {
        menuId: "project/service-desk",
        attributes: $2ea6c80423104bf3$var$analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2IL92.ProjectExpandableMenuItem), {
        projectData: project,
        actionsOnHover: actionsOnHover,
        menuItemButtonRef: menuItemButtonRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9bydH.AsyncJcsProjectMenuContent), {
        projectFragment: project
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7ehYC.SidebarReady), null));
};
$2ea6c80423104bf3$export$2d6552c0aef54d.displayName = "JcsProjectMenu";

});
parcelRegister("lnmiq", function(module, exports) {
$parcel$export(module.exports, "default", () => $0762d1661a24d2f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b3a6c613c4e304ae5085729272a64be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0762d1661a24d2f8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JcsProjectMenu",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectExpandableMenuItem"
        },
        {
            "kind": "FragmentSpread",
            "name": "AsyncJcsProjectMenuContent_jiraProject"
        },
        {
            "kind": "FragmentSpread",
            "name": "ProjectActions"
        }
    ],
    "type": "JiraProject"
};
$0762d1661a24d2f8$var$node.hash = "f77866a9d2f2a3f30e3aa9a12a8119eb";
var $0762d1661a24d2f8$export$2e2bcd8739ae039 = $0762d1661a24d2f8$var$node;

});

parcelRegister("4NgYT", function(module, exports) {
$parcel$export(module.exports, "ContextualAnalyticsData", () => $be36f3553874e748$export$198470770171c65);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $6OFDk = parcelRequire("6OFDk");

var $aZMdt = parcelRequire("aZMdt");

var $XssJM = parcelRequire("XssJM");

var $iPraH = parcelRequire("iPraH");
const $be36f3553874e748$export$198470770171c65 = (t0)=>{
    const $ = (0, $e7boj.c)(14);
    let attributes;
    let menuId;
    let rest;
    let t1;
    if ($[0] !== t0) {
        ({ attributes: attributes, menuId: menuId, stack: t1, ...rest } = t0);
        $[0] = t0;
        $[1] = attributes;
        $[2] = menuId;
        $[3] = rest;
        $[4] = t1;
    } else {
        attributes = $[1];
        menuId = $[2];
        rest = $[3];
        t1 = $[4];
    }
    const stack = t1 === undefined ? (0, $6OFDk.defaultProps).emptyArray : t1;
    let t2;
    if ($[5] !== menuId || $[6] !== stack) {
        t2 = (0, $iPraH.generateViewId)(menuId, ...stack);
        $[5] = menuId;
        $[6] = stack;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== attributes || $[9] !== t2) {
        t3 = {
            viewId: t2,
            navigationLayer: "container",
            ...attributes
        };
        $[8] = attributes;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== rest || $[12] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
            ...rest,
            attributes: t3
        });
        $[11] = rest;
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
};
$be36f3553874e748$export$198470770171c65.displayName = "ContextualAnalyticsData";
const $be36f3553874e748$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: useProject = (0, $XssJM.useProject), ...rest })=>{
    const { data: project } = useProject();
    const projectConfig = (project?.isSimplified ? (0, $f99M0.ProjectStyle).NEXT_GEN : (0, $f99M0.ProjectStyle).CLASSIC) || undefined;
    const projectType = project?.type || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            projectConfig: projectConfig,
            projectType: projectType,
            navigatorScope: navigatorScope
        }
    });
};
$be36f3553874e748$export$bc7f6eebc16e6127.displayName = "IssuesContextualAnalyticsData";

});
parcelRegister("iPraH", function(module, exports) {
$parcel$export(module.exports, "generateViewId", () => $566a22c2c2a91374$export$5b5545ed894dc47a);
/* eslint-disable jira/filename-case */ const $566a22c2c2a91374$export$5b5545ed894dc47a = (...ids)=>ids.join('/');

});


parcelRegister("dXmF1", function(module, exports) {
$parcel$export(module.exports, "ProjectActions", () => $8e48fc76aa136e06$export$7f68bfd3564d5c6f);

var $ljG4N = parcelRequire("ljG4N");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $2bEgS = parcelRequire("2bEgS");

var $6Qg24 = parcelRequire("6Qg24");

var $eO8S8 = parcelRequire("eO8S8");

var $8MkrP = parcelRequire("8MkrP");

var $ikOED = parcelRequire("ikOED");

var $2XXtG = parcelRequire("2XXtG");

var $hZDXn = parcelRequire("hZDXn");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $kVWDZ = parcelRequire("kVWDZ");
const $8e48fc76aa136e06$var$createBoard = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-common.project-actions.create-board",
    defaultMessage: "Create board"
});
const $8e48fc76aa136e06$var$Trigger = ({ triggerRef: triggerRef, isFavourite: isFavourite, projectId: projectId, projectType: projectType, setCreateBoardButtonRef: setCreateBoardButtonRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { sendCreateBoardOnBoardMenuItemAnalyticsEvent: sendCreateBoardOnBoardMenuItemAnalyticsEvent } = (0, $6Qg24.useProjectsAnalyticsL2)();
    // callback to set button element to local ref.
    // to be used as prop for setting focus back to button after modal close.
    const setRef = (0, $euxye.useCallback)((buttonElement)=>{
        setCreateBoardButtonRef(buttonElement);
        if (typeof triggerRef === 'function') triggerRef(buttonElement);
    }, [
        setCreateBoardButtonRef,
        triggerRef
    ]);
    const onCommonNavMenuButtonClick = (0, $euxye.useCallback)((event)=>{
        const { onClick: onClick } = props;
        onClick?.(event);
        sendCreateBoardOnBoardMenuItemAnalyticsEvent({
            starred: isFavourite ?? false,
            recent: !isFavourite,
            projectId: projectId,
            projectType: projectType
        });
    }, [
        isFavourite,
        projectId,
        projectType,
        props,
        sendCreateBoardOnBoardMenuItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        content: formatMessage($8e48fc76aa136e06$var$createBoard)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eO8S8.CommonNavMenuButton), {
        ...props,
        onClick: onCommonNavMenuButtonClick,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ikOED))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage($8e48fc76aa136e06$var$createBoard),
        ref: setRef
    }));
};
$8e48fc76aa136e06$var$Trigger.displayName = "Trigger";
const $8e48fc76aa136e06$export$7f68bfd3564d5c6f = ({ projectFragment: projectFragment, isCorePremiumUserSeat: isCorePremiumUserSeat = false, actionMenuId: actionMenuId })=>{
    const { sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent } = (0, $6Qg24.useProjectsAnalyticsL2)();
    const createBoardButtonRef = (0, $euxye.useRef)(null);
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    const project = (0, $n67Vb.useFragment)((0, $ljG4N.default), projectFragment);
    const onProjectActionMenuClick = (0, $euxye.useCallback)(()=>{
        sendMeatBallDropDownOnProjectsAnalyticsEvent({
            starred: project.isFavourite ?? false,
            recent: !project.isFavourite,
            projectId: project.projectId,
            projectType: project.projectType
        });
    }, [
        project.isFavourite,
        project.projectId,
        project.projectType,
        sendMeatBallDropDownOnProjectsAnalyticsEvent
    ]);
    const projectActionMenu = (0, $euxye.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8MkrP.ProjectActionMenu), {
            projectName: project.name,
            onClick: onProjectActionMenuClick,
            projectKey: project.projectKey,
            projectId: project.projectId,
            isCorePremiumUserSeat: isCorePremiumUserSeat,
            isProjectMenuReorderingEnabled: project?.isFavourite === true,
            actionMenuId: actionMenuId,
            shouldHandleQueryParamModal: true
        });
    }, [
        project.name,
        project.projectKey,
        project.projectId,
        project.isFavourite,
        onProjectActionMenuClick,
        isCorePremiumUserSeat,
        actionMenuId
    ]);
    const setCreateBoardButtonRef = (0, $euxye.useCallback)((instance)=>{
        createBoardButtonRef.current = instance;
    }, [
        createBoardButtonRef
    ]);
    const renderTrigger = (0, $euxye.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8e48fc76aa136e06$var$Trigger, {
            ...props,
            isFavourite: project.isFavourite ?? false,
            projectId: project.projectId,
            projectType: project.projectType,
            setCreateBoardButtonRef: setCreateBoardButtonRef
        }), [
        project.isFavourite,
        project.projectId,
        project.projectType,
        setCreateBoardButtonRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), {
        gap: "space.050",
        alignItems: "center"
    }, (0, $kVWDZ.isCompanyManagedSoftwareProject)(project.projectStyle, project.projectType) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2bEgS.BoardCreate), {
        projectId: project.projectId,
        projectAvatar: project.avatar?.large || undefined,
        triggerRef: createBoardButtonRef,
        renderTrigger: renderTrigger
    })), projectActionMenu);
};
$8e48fc76aa136e06$export$7f68bfd3564d5c6f.displayName = "ProjectActions";

});
parcelRegister("ljG4N", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f3e0eee8eae0584$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3c28b10981a3bf7694d3432e0677c060>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5f3e0eee8eae0584$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ProjectActions",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$5f3e0eee8eae0584$var$node.hash = "dbfcf2c77a0754cf534d4fb94e5b53b3";
var $5f3e0eee8eae0584$export$2e2bcd8739ae039 = $5f3e0eee8eae0584$var$node;

});

parcelRegister("2bEgS", function(module, exports) {
$parcel$export(module.exports, "BoardCreate", () => $262d884ae39d6e19$export$c753ba73bc24874c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $axHjD = parcelRequire("axHjD");

var $jaRzH = parcelRequire("jaRzH");
const $262d884ae39d6e19$export$c753ba73bc24874c = ({ projectId: projectId, projectAvatar: projectAvatar, renderTrigger: renderTrigger, triggerRef: triggerRef })=>{
    if (!projectId) {
        (0, $axHjD.fireBoardCreateErrorAnalytics)({
            error: new Error('Failed to load board create flyout menu: projectId undefined'),
            attributes: {
                projectId: projectId
            },
            id: 'loadFlyoutMenu'
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jaRzH.BoardCreateFlyoutMenu), {
        renderTrigger: renderTrigger,
        projectId: projectId,
        projectAvatar: projectAvatar,
        triggerRef: triggerRef
    });
};
$262d884ae39d6e19$export$c753ba73bc24874c.displayName = "BoardCreate";

});
parcelRegister("axHjD", function(module, exports) {
$parcel$export(module.exports, "fireBoardCreateErrorAnalytics", () => $f97de39bb1e6221b$export$77dbc1f87d29b068);
$parcel$export(module.exports, "descriptionMapping", () => $f97de39bb1e6221b$export$56900bfb74887fe8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $7eNDO = parcelRequire("7eNDO");

var $9ml7h = parcelRequire("9ml7h");
const $f97de39bb1e6221b$var$scrumBoardCreationDescription = (0, $7eNDO.defineMessage)({
    id: "software-board-create.common.scrum-board-creation-description",
    defaultMessage: "Sprint towards your team objectives with a board, backlog, and reports."
});
const $f97de39bb1e6221b$var$kanbanBoardCreationDescription = (0, $7eNDO.defineMessage)({
    id: "software-board-create.common.kanban-board-creation-description",
    defaultMessage: "Manage a continuous delivery of work with a kanban board and reports."
});
const $f97de39bb1e6221b$export$77dbc1f87d29b068 = ({ attributes: attributes, id: id, error: error })=>{
    (0, $hFtK7.fireErrorAnalytics)({
        error: error,
        attributes: attributes,
        meta: {
            id: `jiraSoftwareBoardCreate_${id}`,
            packageName: (0, $9ml7h.BOARD_CREATE_PACKAGE_NAME),
            teamName: (0, $9ml7h.TEAM_NAME)
        },
        skipSentry: true
    });
};
const $f97de39bb1e6221b$export$56900bfb74887fe8 = {
    [(0, $9ml7h.BOARD_TYPES).KANBAN]: $f97de39bb1e6221b$var$kanbanBoardCreationDescription,
    [(0, $9ml7h.BOARD_TYPES).SCRUM]: $f97de39bb1e6221b$var$scrumBoardCreationDescription
};

});
parcelRegister("9ml7h", function(module, exports) {
$parcel$export(module.exports, "FLYOUT_MENU_CONTENT_ID", () => $f5add486ced8d558$export$ff67d81ebedcc801);
$parcel$export(module.exports, "BOARD_CREATE_PACKAGE_NAME", () => $f5add486ced8d558$export$3df8123340981894);
$parcel$export(module.exports, "TEAM_NAME", () => $f5add486ced8d558$export$d57b6b390e78d90f);
$parcel$export(module.exports, "BOARD_TYPES", () => $f5add486ced8d558$export$165dc6fdd115b0c1);
$parcel$export(module.exports, "BOARD_SOURCE_FIELDS", () => $f5add486ced8d558$export$318250ad9945de5c);
$parcel$export(module.exports, "BOARD_SOURCE_FIELDS_JQLTERM", () => $f5add486ced8d558$export$9f85086c10bd31f5);
$parcel$export(module.exports, "PICKER_SEARCH_DEBOUNCE_TIME", () => $f5add486ced8d558$export$f487cf015ececc3a);
$parcel$export(module.exports, "VALIDATION_ERROR_EMPTY", () => $f5add486ced8d558$export$7b060a5763a6e199);
$parcel$export(module.exports, "BOARD_NAME_LIMIT", () => $f5add486ced8d558$export$d760e95d248dc3a3);
/* eslint-disable jira/filename-case */ const $f5add486ced8d558$export$edded98b84a6f50f = 'jsw-board-create';
const $f5add486ced8d558$export$ff67d81ebedcc801 = 'jsw-board-create-flyout-menu-content';
const $f5add486ced8d558$export$3df8123340981894 = 'jiraSoftwareBoardCreate';
const $f5add486ced8d558$export$d57b6b390e78d90f = 'a4t-pandora';
const $f5add486ced8d558$export$165dc6fdd115b0c1 = {
    KANBAN: 'KANBAN',
    SCRUM: 'SCRUM'
};
const $f5add486ced8d558$export$318250ad9945de5c = {
    TEAM: 'team',
    ISSUE_TYPES: 'issueTypes',
    LABELS: 'labels',
    SAVED_FILTER: 'savedFilter'
};
const $f5add486ced8d558$export$9f85086c10bd31f5 = {
    [$f5add486ced8d558$export$318250ad9945de5c.ISSUE_TYPES]: 'type',
    [$f5add486ced8d558$export$318250ad9945de5c.LABELS]: 'labels'
};
const $f5add486ced8d558$export$f487cf015ececc3a = 500;
const $f5add486ced8d558$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
const $f5add486ced8d558$export$d760e95d248dc3a3 = 155;

});


parcelRegister("jaRzH", function(module, exports) {
$parcel$export(module.exports, "BoardCreateFlyoutMenu", () => $b162d7429b108544$export$6a893f4168172b4e);
/* BoardCreateFlyoutMenu.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $jaPl6 = parcelRequire("jaPl6");

var $ikOED = parcelRequire("ikOED");

var $6TGIc = parcelRequire("6TGIc");
const $b162d7429b108544$export$a27652ddcad2c9dc = ({ triggerRef: triggerRef, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
        ...props,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ikOED))),
        label: "create board",
        ref: triggerRef,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "software-board-create.ui.flyout-menu.trigger"
    });
};
$b162d7429b108544$export$a27652ddcad2c9dc.displayName = "DefaultTrigger";
const $b162d7429b108544$export$6a893f4168172b4e = ({ renderTrigger: Trigger = $b162d7429b108544$export$a27652ddcad2c9dc, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jaPl6.default), {
        trigger: Trigger,
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6TGIc.AsyncFlyoutMenuContent), props));
$b162d7429b108544$export$6a893f4168172b4e.displayName = "BoardCreateFlyoutMenu";

});
parcelRegister("6TGIc", function(module, exports) {
$parcel$export(module.exports, "AsyncFlyoutMenuContent", () => $112006541916af1d$export$3f0e1916911c9d6a);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $9ml7h = parcelRequire("9ml7h");

var $4aRQe = parcelRequire("4aRQe");

var $bSAZj = parcelRequire("bSAZj");
const $112006541916af1d$var$entryPointParams = {};
const $112006541916af1d$export$3f0e1916911c9d6a = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $4aRQe.flyoutMenuContentEntryPoint), $112006541916af1d$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $euxye.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        id: (0, $9ml7h.FLYOUT_MENU_CONTENT_ID),
        packageName: (0, $9ml7h.BOARD_CREATE_PACKAGE_NAME),
        teamName: (0, $9ml7h.TEAM_NAME),
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bSAZj.FlyoutMenuContentFallback), null),
        errorFallback: "flag",
        runtimeProps: props
    });
};
$112006541916af1d$export$3f0e1916911c9d6a.displayName = "AsyncFlyoutMenuContent";

});
parcelRegister("4aRQe", function(module, exports) {
$parcel$export(module.exports, "flyoutMenuContentEntryPoint", () => $35997f196fe6f947$export$e6b36ab0519985d7);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $35997f196fe6f947$export$e6b36ab0519985d7 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("9fNci"))), {
        moduleId: "01bf503f",
        moduleName: "MemoizedBoardCreateFlyoutMenuContent",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9fNci", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "FlyoutContentContainer", () => $94db8b773b770ce6$export$b7a36d8992ebabdb);
$parcel$export(module.exports, "default", () => $94db8b773b770ce6$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $2Xkyn = parcelRequire("2Xkyn");

var $j1V7P = parcelRequire("j1V7P");

var $c0DBG = parcelRequire("c0DBG");

var $fbAgj = parcelRequire("fbAgj");

var $c69sa = parcelRequire("c69sa");

var $lHkho = parcelRequire("lHkho");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $9ml7h = parcelRequire("9ml7h");

var $a8Y2W = parcelRequire("a8Y2W");
const $94db8b773b770ce6$var$boardCreationTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.common.board-creation-title",
    defaultMessage: "Create a board"
});
const $94db8b773b770ce6$var$scrumBoardCreationHeader = (0, $7eNDO.defineMessage)({
    id: "software-board-create.common.scrum-board-creation-header",
    defaultMessage: "Scrum"
});
const $94db8b773b770ce6$var$scrumBoardCreationDescription = (0, $7eNDO.defineMessage)({
    id: "software-board-create.common.scrum-board-creation-description",
    defaultMessage: "Sprint towards your team objectives with a board, backlog, and reports."
});
const $94db8b773b770ce6$var$kanbanBoardCreationHeader = (0, $7eNDO.defineMessage)({
    id: "software-board-create.common.kanban-board-creation-header",
    defaultMessage: "Kanban"
});
const $94db8b773b770ce6$var$kanbanBoardCreationDescription = (0, $7eNDO.defineMessage)({
    id: "software-board-create.common.kanban-board-creation-description",
    defaultMessage: "Manage a continuous delivery of work with a kanban board and reports."
});
const $94db8b773b770ce6$export$b7a36d8992ebabdb = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $94db8b773b770ce6$var$menuContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $94db8b773b770ce6$var$headerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $94db8b773b770ce6$var$headerStyles
    }, formatMessage($94db8b773b770ce6$var$boardCreationTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lHkho.Bleed), {
        block: "space.050"
    }, children));
};
$94db8b773b770ce6$export$b7a36d8992ebabdb.displayName = "FlyoutContentContainer";
const $94db8b773b770ce6$var$BoardCreateFlyoutMenuContent = ({ props: { projectId: projectId, projectAvatar: projectAvatar, triggerRef: triggerRef } })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const dropdownItems = (0, $euxye.useMemo)(()=>{
        const items = [
            {
                boardType: (0, $9ml7h.BOARD_TYPES).SCRUM,
                title: formatMessage($94db8b773b770ce6$var$scrumBoardCreationHeader),
                description: formatMessage($94db8b773b770ce6$var$scrumBoardCreationDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c0DBG))), {
                    label: "",
                    color: "var(--ds-icon, #292A2E)"
                })
            },
            {
                boardType: (0, $9ml7h.BOARD_TYPES).KANBAN,
                title: formatMessage($94db8b773b770ce6$var$kanbanBoardCreationHeader),
                description: formatMessage($94db8b773b770ce6$var$kanbanBoardCreationDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j1V7P))), {
                    label: "",
                    color: "var(--ds-icon, #292A2E)"
                })
            }
        ];
        return items.map(({ boardType: boardType, ...props }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8Y2W.DropdownItemContainer), {
                key: boardType,
                entryPointProps: {
                    boardType: boardType,
                    projectId: projectId,
                    projectAvatar: projectAvatar,
                    triggerRef: triggerRef
                },
                index: index,
                ...props
            }));
    }, [
        formatMessage,
        projectId,
        projectAvatar,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($94db8b773b770ce6$export$b7a36d8992ebabdb, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2Xkyn.default), null, dropdownItems));
};
$94db8b773b770ce6$var$BoardCreateFlyoutMenuContent.displayName = "BoardCreateFlyoutMenuContent";
const $94db8b773b770ce6$var$MemoizedBoardCreateFlyoutMenuContent = /*#__PURE__*/ (0, $euxye.memo)($94db8b773b770ce6$var$BoardCreateFlyoutMenuContent);
var $94db8b773b770ce6$export$2e2bcd8739ae039 = $94db8b773b770ce6$var$MemoizedBoardCreateFlyoutMenuContent;
const $94db8b773b770ce6$var$headerStyles = (0, $fbAgj.xcss)({
    font: 'font.heading.xxsmall',
    color: 'color.text.subtlest'
});
const $94db8b773b770ce6$var$menuContainerStyles = (0, $fbAgj.xcss)({
    width: '273px',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $94db8b773b770ce6$var$headerContainerStyles = (0, $fbAgj.xcss)({
    height: 'space.200',
    padding: 'space.200',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});
parcelRegister("j1V7P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cd8cf77b6f39e79b9ac020b21e73e17>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddaa6c34c01f26b3$var$_react = $ddaa6c34c01f26b3$var$_interopRequireDefault((parcelRequire("euxye")));

var $ddaa6c34c01f26b3$var$_baseNew = $ddaa6c34c01f26b3$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $ddaa6c34c01f26b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/board
 * Usage guidance:
 * Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ddaa6c34c01f26b3$var$BoardIcon = (props)=>/*#__PURE__*/ $ddaa6c34c01f26b3$var$_react.default.createElement($ddaa6c34c01f26b3$var$_baseNew.default, Object.assign({
        name: "BoardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$ddaa6c34c01f26b3$var$BoardIcon.displayName = 'BoardIcon';
var $ddaa6c34c01f26b3$var$_default = module.exports.default = $ddaa6c34c01f26b3$var$BoardIcon;

});

parcelRegister("c0DBG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::493336d4c8282919ec0a9182a18e013b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8be43532bcc94c55$var$_react = $8be43532bcc94c55$var$_interopRequireDefault((parcelRequire("euxye")));

var $8be43532bcc94c55$var$_baseNew = $8be43532bcc94c55$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $8be43532bcc94c55$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sprint
 * Usage guidance:
 * Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8be43532bcc94c55$var$SprintIcon = (props)=>/*#__PURE__*/ $8be43532bcc94c55$var$_react.default.createElement($8be43532bcc94c55$var$_baseNew.default, Object.assign({
        name: "SprintIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A4.75 4.75 0 0 0 8 11h5.44l-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H0V11h3.938A6.25 6.25 0 1 1 14.25 6.25h-1.5A4.75 4.75 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$8be43532bcc94c55$var$SprintIcon.displayName = 'SprintIcon';
var $8be43532bcc94c55$var$_default = module.exports.default = $8be43532bcc94c55$var$SprintIcon;

});

parcelRegister("lHkho", function(module, exports) {
$parcel$export(module.exports, "Bleed", () => $a88f6ea0f64b4d69$export$a8307195dd50fcbf);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $f7B36 = parcelRequire("f7B36");
function $a88f6ea0f64b4d69$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a88f6ea0f64b4d69$var$baseStyles = {
    name: "1khn195",
    styles: "box-sizing:border-box"
};
const $a88f6ea0f64b4d69$var$blockBleedMap = {
    'space.025': {
        name: "9w2fxh",
        styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "1qhe0y6",
        styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "s0o2nz",
        styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "151e4o3",
        styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "16sn062",
        styles: "margin-block:var(--ds-space-negative-200, -1rem)"
    }
};
const $a88f6ea0f64b4d69$var$inlineBleedMap = {
    'space.025': {
        name: "16oxh68",
        styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "tdc6fz",
        styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "crujrn",
        styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "y28d58",
        styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "1vfkteg",
        styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
    }
};
const $a88f6ea0f64b4d69$export$a8307195dd50fcbf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    const resolvedStyles = (0, $f7B36.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $a88f6ea0f64b4d69$var$baseStyles,
            (inline || all) && $a88f6ea0f64b4d69$var$inlineBleedMap[inline || all],
            (block || all) && $a88f6ea0f64b4d69$var$blockBleedMap[block || all],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId
    }, children);
});
$a88f6ea0f64b4d69$export$a8307195dd50fcbf.displayName = 'Bleed';

});

parcelRegister("a8Y2W", function(module, exports) {
$parcel$export(module.exports, "DropdownItemContainer", () => $35ce9b084151101f$export$cfb1162696b4c012);
/* eslint-disable jira/integration/test-id-by-folder-structure */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1wAvh = parcelRequire("1wAvh");

var $2iotI = parcelRequire("2iotI");

var $fbAgj = parcelRequire("fbAgj");

var $2BUXh = parcelRequire("2BUXh");

var $5BP41 = parcelRequire("5BP41");

var $gNHJ8 = parcelRequire("gNHJ8");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $9ml7h = parcelRequire("9ml7h");

var $5wxrg = parcelRequire("5wxrg");

var $p5RXc = parcelRequire("p5RXc");
const $35ce9b084151101f$var$createBoardLabel = (0, $7eNDO.defineMessage)({
    id: "software-board-create.flyout-menu.flyout-menu-content.dropdown-item-container.create-board-label",
    defaultMessage: "Create a {boardType} board"
});
const $35ce9b084151101f$export$cfb1162696b4c012 = ({ entryPointProps: entryPointProps, title: title, description: description, icon: icon, index: index })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const triggerRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (index === 0 && triggerRef.current) triggerRef.current.focus();
    }, [
        index
    ]);
    const handleOnDropdownItemClick = (0, $euxye.useCallback)(()=>{
        const boardTypePascalCase = entryPointProps.boardType === (0, $9ml7h.BOARD_TYPES).SCRUM ? 'Scrum' : 'Kanban';
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'dropdownItem',
            action: 'clicked'
        }), `create${boardTypePascalCase}Board`);
    }, [
        createAnalyticsEvent,
        entryPointProps.boardType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1wAvh.ModalEntryPointDropdownItemTrigger), {
        "aria-label": formatMessage($35ce9b084151101f$var$createBoardLabel, {
            boardType: entryPointProps.boardType.toLowerCase()
        }),
        forwardedRef: triggerRef,
        entryPoint: (0, $5wxrg.boardCreateModalEntryPoint),
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "software-board-create.ui.flyout-menu.flyout-menu-content.dropdown-item-container.dropdown-item-trigger",
        interactionName: "open-create-board-modal",
        entryPointProps: entryPointProps,
        Fallback: (0, $p5RXc.BoardCreateModalFallback),
        onClick: handleOnDropdownItemClick,
        useInternalModal: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2BUXh.default), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2BUXh.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $35ce9b084151101f$var$itemIconBackgroundStyles
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "xsmall",
        as: "h3"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNHJ8.default), {
        size: "medium"
    }, description))));
};
$35ce9b084151101f$export$cfb1162696b4c012.displayName = "DropdownItemContainer";
const $35ce9b084151101f$var$ICON_BACKGROUND_CONTAINER_SIZE = '32px';
const $35ce9b084151101f$var$itemIconBackgroundStyles = (0, $fbAgj.xcss)({
    backgroundColor: 'color.background.neutral',
    width: $35ce9b084151101f$var$ICON_BACKGROUND_CONTAINER_SIZE,
    height: $35ce9b084151101f$var$ICON_BACKGROUND_CONTAINER_SIZE,
    borderRadius: "var(--ds-radius-xsmall, 3px)",
    padding: 'space.050',
    flexShrink: 0
});

});
parcelRegister("1wAvh", function(module, exports) {
$parcel$export(module.exports, "ModalEntryPointDropdownItemTrigger", () => $351c0fb521c413b9$export$82b29db923c97084);

var $euxye = parcelRequire("euxye");

var $2YPKP = parcelRequire("2YPKP");

var $isqzs = parcelRequire("isqzs");
const $351c0fb521c413b9$export$82b29db923c97084 = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, modalTitle: modalTitle, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef, ...dropdownProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $isqzs.ModalEntryPointPressableTrigger), {
        forwardedRef: forwardedRef,
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        errorAttributes: errorAttributes,
        Fallback: Fallback,
        interactionName: interactionName,
        title: modalTitle,
        modalProps: modalProps,
        useInternalModal: useInternalModal
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2YPKP.default), {
            ref: ref,
            ...dropdownProps
        }, children));
};
$351c0fb521c413b9$export$82b29db923c97084.displayName = "ModalEntryPointDropdownItemTrigger";

});

parcelRegister("5wxrg", function(module, exports) {
$parcel$export(module.exports, "boardCreateModalEntryPoint", () => $be2b48139a7e5e85$export$ae34a65266b8e906);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $be2b48139a7e5e85$export$ae34a65266b8e906 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("p5RXc"))), {
        moduleId: "f9936d75",
        moduleName: "MemoizedBoardCreateModalWithContext",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("p5RXc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "BoardCreateModalFallback", () => $3ef8d9c13b43e52f$export$303db58b19f6b446);
$parcel$export(module.exports, "default", () => $3ef8d9c13b43e52f$export$2e2bcd8739ae039);
/* MemoizedBoardCreateModalWithContext.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/choreographer/message-id-by-folder-structure */ /* eslint-disable jira/integration/test-id-by-folder-structure */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $k6sZT = parcelRequire("k6sZT");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $DIqjH = parcelRequire("DIqjH");

var $aZMdt = parcelRequire("aZMdt");
var $aqPkH = parcelRequire("aqPkH");
var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $axHjD = parcelRequire("axHjD");

var $12jTK = parcelRequire("12jTK");

var $W3LHl = parcelRequire("W3LHl");
const $3ef8d9c13b43e52f$var$boardCreationTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.common.board-creation-title",
    defaultMessage: "Create a board"
});
const $3ef8d9c13b43e52f$var$loadingLabel = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.loading-label",
    defaultMessage: "Loading"
});
const $3ef8d9c13b43e52f$var$MODAL_WIDTH = 1000;
const $3ef8d9c13b43e52f$var$MODAL_HEIGHT = 551;
const $3ef8d9c13b43e52f$export$303db58b19f6b446 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $DIqjH.JiraModal), {
        height: $3ef8d9c13b43e52f$var$MODAL_HEIGHT,
        width: $3ef8d9c13b43e52f$var$MODAL_WIDTH,
        label: formatMessage($3ef8d9c13b43e52f$var$loadingLabel),
        messageId: "software-board-create.ui.modal.modal.board-create-modal-fallback",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $W3LHl.BoardCreateFormFallback), null));
};
$3ef8d9c13b43e52f$export$303db58b19f6b446.displayName = "BoardCreateModalFallback";
const $3ef8d9c13b43e52f$var$BoardCreateModal = ({ boardType: boardType, projectId: projectId, onClose: onClose, triggerRef: triggerRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const handleOnClose = (_mouseEvent, _analyticEvent, didSubmit)=>{
        const event = createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'modalDialog'
        });
        (0, $aJ81Y.fireUIAnalytics)(event, 'createNewBoardModal', {
            didSubmit: !!didSubmit,
            boardType: boardType.toLowerCase()
        });
        onClose?.();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $DIqjH.JiraModal // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    ), {
        testId: "software-board-create.ui.modal",
        onClose: handleOnClose,
        width: $3ef8d9c13b43e52f$var$MODAL_WIDTH,
        height: $3ef8d9c13b43e52f$var$MODAL_HEIGHT,
        messageId: "software-board-create.ui.modal.modal.board-create-modal",
        messageType: "transactional",
        label: `${formatMessage($3ef8d9c13b43e52f$var$boardCreationTitle)}. ${formatMessage((0, $axHjD.descriptionMapping)[boardType])}`,
        shouldReturnFocus: triggerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $W3LHl.BoardCreateForm), {
        projectId: projectId,
        boardType: boardType,
        onClose: handleOnClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireScreenAnalytics), {
        attributes: {
            boardType: boardType.toLowerCase()
        }
    }));
};
$3ef8d9c13b43e52f$var$BoardCreateModal.displayName = "BoardCreateModal";
const $3ef8d9c13b43e52f$var$BoardCreateModalWithContext = ({ props: { projectAvatar: projectAvatar, ...restProps } })=>{
    const value = (0, $euxye.useMemo)(()=>({
            projectId: restProps.projectId,
            projectAvatar: projectAvatar
        }), [
        restProps.projectId,
        projectAvatar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $12jTK.BoardCreateContext).Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k6sZT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceName: "createNewBoard",
        sourceType: (0, $46f069e6c968f461$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3ef8d9c13b43e52f$var$BoardCreateModal, restProps))));
};
$3ef8d9c13b43e52f$var$BoardCreateModalWithContext.displayName = "BoardCreateModalWithContext";
const $3ef8d9c13b43e52f$var$MemoizedBoardCreateModalWithContext = /*#__PURE__*/ (0, $euxye.memo)($3ef8d9c13b43e52f$var$BoardCreateModalWithContext);
var $3ef8d9c13b43e52f$export$2e2bcd8739ae039 = $3ef8d9c13b43e52f$var$MemoizedBoardCreateModalWithContext;

});
parcelRegister("12jTK", function(module, exports) {
$parcel$export(module.exports, "BoardCreateContext", () => $0f21b1ca658580a3$export$5169319147995508);
$parcel$export(module.exports, "useBoardCreateContext", () => $0f21b1ca658580a3$export$768ffccd7d71d6d9);
// oxlint-disable-next-line import/newline-after-import

var $euxye = parcelRequire("euxye");
const $0f21b1ca658580a3$var$initialContext = {
    projectId: undefined,
    projectAvatar: undefined
};
const $0f21b1ca658580a3$export$5169319147995508 = /*#__PURE__*/ (0, $euxye.createContext)($0f21b1ca658580a3$var$initialContext);
const $0f21b1ca658580a3$export$768ffccd7d71d6d9 = ()=>(0, $euxye.useContext)($0f21b1ca658580a3$export$5169319147995508);

});

parcelRegister("W3LHl", function(module, exports) {
$parcel$export(module.exports, "BoardCreateFormFallback", () => $61f50f966701ec0a$export$efb232229a99ba7b);
$parcel$export(module.exports, "BoardCreateForm", () => $61f50f966701ec0a$export$bc90d453a0e513ff);
/* BoardCreateForm.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $fWb5q = parcelRequire("fWb5q");

var $hiKld = parcelRequire("hiKld");

var $2kZKn = parcelRequire("2kZKn");

var $c69sa = parcelRequire("c69sa");

var $6Elhl = parcelRequire("6Elhl");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");

var $3NRLa = parcelRequire("3NRLa");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $40ADv = parcelRequire("40ADv");

var $lIFZU = parcelRequire("lIFZU");

var $lGY8o = parcelRequire("lGY8o");

var $cMsbQ = parcelRequire("cMsbQ");

var $bJoLV = parcelRequire("bJoLV");

var $fzjFG = parcelRequire("fzjFG");

var $lrxAF = parcelRequire("lrxAF");

var $5cWMt = parcelRequire("5cWMt");
const $61f50f966701ec0a$export$efb232229a99ba7b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        xcss: $61f50f966701ec0a$var$formContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        gap: "space.1000",
        xcss: $61f50f966701ec0a$var$formContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        xcss: $61f50f966701ec0a$var$columnStyles,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "150px",
        height: "20px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "100%",
        height: "12px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "20%",
        height: "12px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "100px",
        height: "12px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "100%",
        height: "30px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "200px",
        height: "12px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "100%",
        height: "30px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "70px",
        height: "32px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "70px",
        height: "32px"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        xcss: $61f50f966701ec0a$var$columnStyles,
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "150px",
        height: "20px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "412px",
        height: "307px",
        borderRadius: "var(--ds-radius-xxlarge, 16px)"
    }))));
};
$61f50f966701ec0a$export$efb232229a99ba7b.displayName = "BoardCreateFormFallback";
const $61f50f966701ec0a$export$bc90d453a0e513ff = ({ boardType: boardType, projectId: projectId, onClose: onClose })=>{
    const { submit: submit } = (0, $40ADv.useBoardCreateController)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const handleOnSubmit = (0, $euxye.useCallback)(async (data)=>{
        const errors = (0, $5cWMt.validateFormData)(data);
        const hasValidationErrors = errors.boardName || errors.sourceType || errors.sourceValue;
        let sourceValueLength = 0;
        if (data.sourceValue != null) sourceValueLength = Array.isArray(data.sourceValue) ? data.sourceValue.length : 1;
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $aJ81Y.fireUIAnalytics)(event, 'createNewBoard', {
            sourceType: data.sourceType,
            sourceValueLength: sourceValueLength,
            errors: hasValidationErrors && errors
        });
        if (hasValidationErrors) return errors;
        await submit({
            boardType: boardType,
            formValues: data,
            locationProjectId: projectId ?? '',
            onSuccess: ()=>onClose(undefined, undefined, true)
        });
    }, [
        createAnalyticsEvent,
        submit,
        boardType,
        projectId,
        onClose
    ]);
    const resetSourceValue = (0, $euxye.useCallback)((setFieldValue)=>()=>setFieldValue((0, $lrxAF.SOURCE_VALUE_FIELD_NAME), undefined), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        xcss: $61f50f966701ec0a$var$formContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fWb5q.default), {
        onSubmit: handleOnSubmit
    }, ({ formProps: formProps, submitting: submitting, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("form", {
            ...formProps,
            noValidate: true,
            className: (0, $4jQY2.default)([
                "_18m91wug _1bsb1osq"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
            gap: "space.1000",
            xcss: $61f50f966701ec0a$var$formContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
            xcss: $61f50f966701ec0a$var$columnStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lIFZU.ModalHeader), {
            type: boardType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: $61f50f966701ec0a$var$formFieldsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2kZKn.FormSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bJoLV.BoardNameField), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2kZKn.FormSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fzjFG.SourceTypePicker), {
            resetSourceValue: resetSourceValue(setFieldValue)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lrxAF.SourceValuePicker), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: $61f50f966701ec0a$var$buttonGroupContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hiKld.FormFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cMsbQ.FormActions), {
            submitting: submitting,
            onClose: onClose
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
            xcss: $61f50f966701ec0a$var$columnStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lGY8o.ModalIllustration), null))))));
};
$61f50f966701ec0a$export$bc90d453a0e513ff.displayName = "BoardCreateForm";
const $61f50f966701ec0a$var$formStyles = null;
const $61f50f966701ec0a$var$formContentStyles = (0, $fbAgj.xcss)({
    height: '100%',
    width: '100%'
});
const $61f50f966701ec0a$var$columnStyles = (0, $fbAgj.xcss)({
    width: 'calc(50% - 40px)',
    // space.1000 is 80px, thus 40px is the space on each side
    flex: 'none',
    paddingTop: 'space.200'
});
const $61f50f966701ec0a$var$formFieldsContainerStyles = (0, $fbAgj.xcss)({
    flexGrow: 1
});
const $61f50f966701ec0a$var$buttonGroupContainerStyles = (0, $fbAgj.xcss)({
    alignSelf: 'end',
    justifySelf: 'end'
});
const $61f50f966701ec0a$var$formContainerStyles = (0, $fbAgj.xcss)({
    paddingTop: 'space.600',
    paddingLeft: 'space.600',
    paddingRight: 'space.600',
    paddingBottom: 'space.500',
    height: '100%'
});

});
parcelRegister("hiKld", function(module, exports) {
$parcel$export(module.exports, "FormFooter", () => $037f4a53d03118c6$export$e7277fd05612133d);
/* form-footer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $037f4a53d03118c6$var$formFooterWrapperStyles = null;
const $037f4a53d03118c6$var$justifyContentStyles = null;
function $037f4a53d03118c6$export$e7277fd05612133d({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("footer", {
        className: (0, $4jQY2.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}
$037f4a53d03118c6$export$e7277fd05612133d.displayName = "FormFooter";

});

parcelRegister("2kZKn", function(module, exports) {
$parcel$export(module.exports, "FormSection", () => $def0b751cc8285bf$export$b5ff61ac8b0a660f);
/* form-section.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2iotI = parcelRequire("2iotI");
const $def0b751cc8285bf$var$formSectionDescriptionStyles = null;
const $def0b751cc8285bf$var$formSectionWrapperStyles = null;
const $def0b751cc8285bf$var$FormSectionWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_1pfh1ejb"
        ]),
        children: children
    });
};
$def0b751cc8285bf$var$FormSectionWrapper.displayName = "FormSectionWrapper";
const $def0b751cc8285bf$var$FormSectionDescription = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_1pfhu2gc"
        ]),
        children: children
    });
};
$def0b751cc8285bf$var$FormSectionDescription.displayName = "FormSectionDescription";
const $def0b751cc8285bf$export$b5ff61ac8b0a660f = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsxs)($def0b751cc8285bf$var$FormSectionWrapper, {
        children: [
            title && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                size: "medium",
                children: title
            }),
            description && /*#__PURE__*/ (0, $e79Pd.jsx)($def0b751cc8285bf$var$FormSectionDescription, {
                children: description
            }),
            children
        ]
    });
};
$def0b751cc8285bf$export$b5ff61ac8b0a660f.displayName = "FormSection";

});

parcelRegister("40ADv", function(module, exports) {
$parcel$export(module.exports, "useBoardCreateController", () => $0e27806ad82b1fd1$export$b1247ee6c4be437f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $852zE = parcelRequire("852zE");

var $dtDO2 = parcelRequire("dtDO2");

var $lTQTl = parcelRequire("lTQTl");

var $cUnrZ = parcelRequire("cUnrZ");

var $fMgNj = parcelRequire("fMgNj");

var $i8BNs = parcelRequire("i8BNs");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $kt86l = parcelRequire("kt86l");

var $55BnK = parcelRequire("55BnK");

var $dp0Rz = parcelRequire("dp0Rz");

var $axHjD = parcelRequire("axHjD");

var $9ml7h = parcelRequire("9ml7h");

var $6xA11 = parcelRequire("6xA11");

var $6YZHw = parcelRequire("6YZHw");

var $9xlHX = parcelRequire("9xlHX");
const $0e27806ad82b1fd1$var$NO_OF_BOARDS_TO_SHOW = 25;
const $0e27806ad82b1fd1$var$successTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.controllers.use-board-create-controller.success-title",
    defaultMessage: "Board successfully created"
});
const $0e27806ad82b1fd1$var$errorTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.controllers.use-board-create-controller.error-title",
    defaultMessage: "We couldn\u2019t create the board"
});
const $0e27806ad82b1fd1$var$errorDescription = (0, $7eNDO.defineMessage)({
    id: "software-board-create.controllers.use-board-create-controller.error-description",
    defaultMessage: "Refresh the page and try again."
});
const $0e27806ad82b1fd1$var$EXPERIENCE = 'createBoard';
const $0e27806ad82b1fd1$export$43cdff4ae424f89f = ()=>{
    const environment = (0, $n67Vb.useRelayEnvironment)();
    const cloudId = (0, $kt86l.useCloudId)();
    return (0, $euxye.useCallback)(({ id: id, projectId: projectId })=>{
        (0, $n67Vb.commitLocalUpdate)(environment, (store)=>{
            try {
                if (!id) throw new Error('Failed to add board to project, missing id');
                if (!projectId) throw new Error('Failed to add board to project, missing projectId');
                const projectRelayDataId = (0, $dp0Rz.default)({
                    id: (0, $i8BNs.JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: String(projectId)
                    })
                }, 'JiraProject');
                if (!projectRelayDataId) throw new Error(`Failed to create project relay data id, projectId: ${projectId}`);
                const project = store.get(projectRelayDataId);
                if (!project) throw new Error(`Failed to find the project, projectId: ${projectId}`);
                const projectBoardsConnection = project.getLinkedRecord('boards', {
                    first: $0e27806ad82b1fd1$var$NO_OF_BOARDS_TO_SHOW
                });
                if (!projectBoardsConnection) throw new Error('Failed to find the project-boards connection');
                const newNode = store.get(id);
                if (!newNode) throw new Error(`Failed to find the new board, id: ${id}`);
                const newEdge = (0, $n67Vb.ConnectionHandler).createEdge(store, projectBoardsConnection, newNode, 'JiraBoardEdge');
                (0, $n67Vb.ConnectionHandler).insertEdgeBefore(projectBoardsConnection, newEdge);
            } catch (error) {
                (0, $axHjD.fireBoardCreateErrorAnalytics)({
                    id: 'addBoardToProject',
                    error: error instanceof Error ? error : new Error(`Failed to add board to project: ${error}`)
                });
            }
        });
    }, [
        environment,
        cloudId
    ]);
};
const $0e27806ad82b1fd1$export$b1247ee6c4be437f = ()=>{
    const { handleMutation: handleMutation } = (0, $6xA11.useBoardCreateMutationUseBoardCreateMutation)();
    const { showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag } = (0, $6YZHw.useBoardCreateFlag)();
    const { push: push } = (0, $55BnK.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const addBoardToProject = $0e27806ad82b1fd1$export$43cdff4ae424f89f();
    const isBacklogRoute = (0, $852zE.useIsBacklogRoute)();
    const onExperienceStart = (0, $dtDO2.useExperienceStart)({
        experience: $0e27806ad82b1fd1$var$EXPERIENCE,
        analyticsSource: (0, $9ml7h.BOARD_CREATE_PACKAGE_NAME)
    });
    const onExperienceSuccess = (0, $lTQTl.useExperienceSuccess)({
        experience: $0e27806ad82b1fd1$var$EXPERIENCE
    });
    const onExperienceFail = (0, $cUnrZ.useExperienceFail)({
        experience: $0e27806ad82b1fd1$var$EXPERIENCE
    });
    const submit = (0, $euxye.useCallback)(async ({ boardType: boardType, locationProjectId: locationProjectId, formValues: formValues, onSuccess: onSuccess, onError: onError })=>{
        const input = (0, $9xlHX.transformInput)({
            boardType: boardType,
            locationProjectId: locationProjectId,
            formValues: formValues
        });
        try {
            onExperienceStart();
            const result = await handleMutation(input);
            if (!result?.jira?.createBoard?.success) throw result?.jira?.createBoard?.errors?.length ? new (0, $fMgNj.MutationError)(result?.jira?.createBoard?.errors?.[0]) : new Error('Failed to create board');
            onSuccess?.(result);
            showSuccessFlag({
                title: formatMessage($0e27806ad82b1fd1$var$successTitle)
            });
            addBoardToProject({
                projectId: locationProjectId,
                id: result.jira?.createBoard?.board?.__id
            });
            onExperienceSuccess();
            const resultBoardId = result?.jira?.createBoard?.board?.boardId;
            const resultBoardType = result?.jira?.createBoard?.board?.boardType;
            const boardUrl = (0, $9xlHX.buildBoardUrl)(result?.jira?.createBoard?.board?.boardUrl, resultBoardType);
            if (!boardUrl) (0, $axHjD.fireBoardCreateErrorAnalytics)({
                error: new Error('Failed to generate board URL after board creation'),
                attributes: {
                    boardId: resultBoardId,
                    boardType: resultBoardType
                },
                id: 'generateUrl'
            });
            else resultBoardType === 'SCRUM' && isBacklogRoute ? (0, $9xlHX.redirectToBacklog)(boardUrl) : push(boardUrl);
        } catch (error) {
            let errMsg;
            if (error instanceof (0, $fMgNj.MutationError) && error.message) errMsg = error.message;
            onError?.(errMsg || error);
            showErrorFlag({
                title: formatMessage($0e27806ad82b1fd1$var$errorTitle),
                description: errMsg || formatMessage($0e27806ad82b1fd1$var$errorDescription)
            });
            (0, $axHjD.fireBoardCreateErrorAnalytics)({
                error: new Error(`Failed to create board: ${errMsg || error}`, {
                    cause: error
                }),
                id: 'createBoard'
            });
            onExperienceFail((0, $9ml7h.BOARD_CREATE_PACKAGE_NAME), // oxlint-disable-next-line no-nested-ternary
            errMsg ? new Error(errMsg) : error instanceof Error ? error : new Error(String(error)));
        }
    }, [
        onExperienceStart,
        handleMutation,
        showSuccessFlag,
        formatMessage,
        addBoardToProject,
        onExperienceSuccess,
        isBacklogRoute,
        push,
        showErrorFlag,
        onExperienceFail
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("852zE", function(module, exports) {
$parcel$export(module.exports, "useIsBacklogRoute", () => $6ff7ca388bf3102d$export$1894da4846b402db);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $4Onaa = parcelRequire("4Onaa");
const $6ff7ca388bf3102d$export$1894da4846b402db = ()=>{
    const { name: name } = (0, $4Onaa.useCurrentRoute)();
    return (0, $euxye.useMemo)(()=>name === 'rapidboard-backlog' || name === 'rapidboard-user-backlog' || name === 'rapidboard-backlog-embed', [
        name
    ]);
};

});

parcelRegister("fMgNj", function(module, exports) {
$parcel$export(module.exports, "MutationError", () => $ec4474232ed626cf$export$10c788363424e94e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ class $ec4474232ed626cf$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
        this.errorType = payload.extensions?.errorType ?? null;
    }
}
$ec4474232ed626cf$export$10c788363424e94e.displayName = "MutationError";

});

parcelRegister("6xA11", function(module, exports) {
$parcel$export(module.exports, "useBoardCreateMutationUseBoardCreateMutation", () => $8daf26752b436876$export$7e29f2f3d0c11a41);

var $f7MU6 = parcelRequire("f7MU6");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $kt86l = parcelRequire("kt86l");
const $8daf26752b436876$export$7e29f2f3d0c11a41 = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const [commit] = (0, $n67Vb.useMutation)((0, $f7MU6.default));
    const handleMutation = (0, $euxye.useCallback)(async (input)=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    cloudId: cloudId,
                    input: input
                },
                onCompleted: (result)=>{
                    resolve(result);
                },
                onError: (error)=>{
                    reject(error);
                }
            });
        }), [
        cloudId,
        commit
    ]);
    return {
        handleMutation: handleMutation
    };
};

});
parcelRegister("f7MU6", function(module, exports) {
$parcel$export(module.exports, "default", () => $a352e9592e5317e1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<560a73d09ecdae61f3bf4f234c056435>>
 * @relayHash 695981f2abe893fe5dc9b010759768a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b685969d95b4a5f834408344b10d34fbb7a5b28800d8c250af7f494580320653
const $a352e9592e5317e1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "JiraBoard",
        "kind": "LinkedField",
        "name": "board",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "boardId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "boardType"
            },
            {
                "kind": "ScalarField",
                "name": "boardUrl"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useBoardCreateMutationUseBoardCreateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCreateBoardPayload",
                            "kind": "LinkedField",
                            "name": "createBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useBoardCreateMutationUseBoardCreateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCreateBoardPayload",
                            "kind": "LinkedField",
                            "name": "createBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b685969d95b4a5f834408344b10d34fbb7a5b28800d8c250af7f494580320653",
            "metadata": {},
            "name": "useBoardCreateMutationUseBoardCreateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a352e9592e5317e1$var$node.hash = "6eb43d009e445cc60fd2bd47fc2adb71";
var $a352e9592e5317e1$export$2e2bcd8739ae039 = $a352e9592e5317e1$var$node;

});


parcelRegister("6YZHw", function(module, exports) {
$parcel$export(module.exports, "useBoardCreateFlag", () => $0a86c3fdbeae7210$export$b93e10fcc9489915);
/* eslint-disable jira/choreographer/message-id-by-folder-structure */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $iQPOZ = parcelRequire("iQPOZ");
const $0a86c3fdbeae7210$export$b93e10fcc9489915 = ()=>{
    const { showFlag: showFlag } = (0, $iQPOZ.useFlagService)();
    const showSuccessFlag = (0, $euxye.useCallback)(({ title: title, description: description })=>{
        showFlag({
            type: 'success',
            title: title,
            description: description,
            isAutoDismiss: true,
            // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
            messageId: 'software-board-create.controllers.use-board-create-flag.show-flag.success',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    const showErrorFlag = (0, $euxye.useCallback)(({ title: title, description: description })=>{
        showFlag({
            type: 'error',
            title: title,
            description: description,
            isAutoDismiss: true,
            // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
            messageId: 'software-board-create.controllers.use-board-create-flag.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    return {
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag
    };
};

});

parcelRegister("9xlHX", function(module, exports) {
$parcel$export(module.exports, "transformInput", () => $eb5d084883f5b61b$export$28b8f0b21b2796a2);
$parcel$export(module.exports, "buildBoardUrl", () => $eb5d084883f5b61b$export$d807737c3f4eaba6);
$parcel$export(module.exports, "redirectToBacklog", () => $eb5d084883f5b61b$export$594b405ab77720dc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $9ml7h = parcelRequire("9ml7h");
const $eb5d084883f5b61b$var$formatFieldInput = (input)=>{
    if (!input.sourceType || input.sourceType === (0, $9ml7h.BOARD_SOURCE_FIELDS).SAVED_FILTER || !input.sourceValue) return null;
    const { sourceType: sourceType, sourceValue: sourceValue } = input;
    switch(sourceType){
        case (0, $9ml7h.BOARD_SOURCE_FIELDS).TEAM:
            return {
                teams: [
                    {
                        teamId: sourceValue.id
                    }
                ]
            };
        case (0, $9ml7h.BOARD_SOURCE_FIELDS).ISSUE_TYPES:
            return {
                issueTypes: sourceValue.map(({ value: value })=>({
                        issueTypeId: value
                    }))
            };
        case (0, $9ml7h.BOARD_SOURCE_FIELDS).LABELS:
            return {
                labels: sourceValue.map(({ value: value })=>({
                        name: value
                    }))
            };
        default:
            {
                const _exhaustiveCheck = sourceType;
                return null;
            }
    }
};
const $eb5d084883f5b61b$var$getCreateBoardSource = (formValues, locationProjectId)=>{
    if (formValues?.sourceType === (0, $9ml7h.BOARD_SOURCE_FIELDS).SAVED_FILTER) return {
        savedFilterId: formValues.sourceValue?.value ? Number(formValues.sourceValue.value) : null
    };
    return {
        fieldInput: {
            projects: [
                {
                    projectId: locationProjectId
                }
            ],
            ...formValues.sourceType && formValues.sourceValue && $eb5d084883f5b61b$var$formatFieldInput(formValues)
        }
    };
};
const $eb5d084883f5b61b$export$28b8f0b21b2796a2 = ({ boardType: boardType, locationProjectId: locationProjectId, formValues: formValues })=>({
        createBoardSource: $eb5d084883f5b61b$var$getCreateBoardSource(formValues, locationProjectId),
        location: {
            locationId: locationProjectId,
            locationType: 'PROJECT'
        },
        name: formValues.boardName,
        preset: boardType
    });
const $eb5d084883f5b61b$export$d807737c3f4eaba6 = (boardUrl, boardType)=>{
    if (!boardUrl) return null;
    return `${boardUrl}${boardType === 'SCRUM' ? '/backlog' : ''}`;
};
const $eb5d084883f5b61b$export$594b405ab77720dc = (backlogUrl)=>{
    // This is a temporary fix for the redirection issue and will be addressed in BLU-5254
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = backlogUrl;
};

});


parcelRegister("lIFZU", function(module, exports) {
$parcel$export(module.exports, "ModalHeader", () => $c05ec172e87fef5a$export$f50a68e3694789ee);
/* ModalHeader.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage, jira/naming/disallow-filenames */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $axHjD = parcelRequire("axHjD");
const $c05ec172e87fef5a$var$boardCreationTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.common.board-creation-title",
    defaultMessage: "Create a board"
});
const $c05ec172e87fef5a$var$requiredFieldsHeader = (0, $7eNDO.defineMessage)({
    id: "software-board-create.common.required-fields-header",
    defaultMessage: "Required fields are marked with an asterisk *"
});
const $c05ec172e87fef5a$export$f50a68e3694789ee = ({ type: type })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ $euxye.createElement((0, $3PC9r.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $euxye.createElement("h4", {
        className: (0, $4jQY2.default)([
            "_11c81af2 _k48pwu06 _syazi7uo"
        ])
    }, formatMessage($c05ec172e87fef5a$var$boardCreationTitle)), /*#__PURE__*/ $euxye.createElement((0, $8Sdzy.Text), {
        size: "medium",
        color: "color.text.accent.gray.bolder"
    }, (0, $axHjD.descriptionMapping)[type] && formatMessage((0, $axHjD.descriptionMapping)[type])), /*#__PURE__*/ $euxye.createElement((0, $8Sdzy.Text), {
        as: "em",
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage($c05ec172e87fef5a$var$requiredFieldsHeader)));
};
$c05ec172e87fef5a$export$f50a68e3694789ee.displayName = "ModalHeader";
const $c05ec172e87fef5a$var$modalHeaderStyles = null;

});

parcelRegister("lGY8o", function(module, exports) {
$parcel$export(module.exports, "ModalIllustration", () => $de0b8f415341d4b6$export$dc26d3e21d436b08);
/* ModalIllustration.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $6QELW = parcelRequire("6QELW");

var $iY9aj = parcelRequire("iY9aj");

var $3PC9r = parcelRequire("3PC9r");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $de0b8f415341d4b6$var$illustrationPlaceHolderHeader = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.illustration.illustration-place-holder-header",
    defaultMessage: "New board"
});
const $de0b8f415341d4b6$var$illustrationAltText = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.illustration.illustration-alt-text",
    defaultMessage: "Bug and task cards in a board column"
});
const $de0b8f415341d4b6$export$dc26d3e21d436b08 = ()=>{
    const state = (0, $iY9aj.useFormState)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("h5", {
        className: (0, $4jQY2.default)([
            "_11c81e3o _1reo15vq _18m915vq _k48p1pd9 _syazazsu _18u01axu _1bto1l2s _o5721q9c _p12fp3fh"
        ])
    }, state?.values.boardName?.trim() || formatMessage($de0b8f415341d4b6$var$illustrationPlaceHolderHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6QELW.default), {
        alt: formatMessage($de0b8f415341d4b6$var$illustrationAltText),
        height: "334px"
    })));
};
$de0b8f415341d4b6$export$dc26d3e21d436b08.displayName = "ModalIllustration";
const $de0b8f415341d4b6$var$modalIllustrationHeaderStyles = null;

});
parcelRegister("6QELW", function(module, exports) {
$parcel$export(module.exports, "default", () => $495d29ddfce7d8d8$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $gboXr = parcelRequire("gboXr");

var $2mWCd = parcelRequire("2mWCd");
const $495d29ddfce7d8d8$var$Illustration = (0, $gboXr.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($2mWCd)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2mWCd))
});
var $495d29ddfce7d8d8$export$2e2bcd8739ae039 = $495d29ddfce7d8d8$var$Illustration;
const $495d29ddfce7d8d8$export$a179c88182cb9d56 = [
    0,
    0,
    448,
    334
];

});
parcelRegister("2mWCd", function(module, exports) {
module.exports = new URL("bug-and-task-cards-in-a-column.455dfa61.svg", import.meta.url).toString();

});


parcelRegister("iY9aj", function(module, exports) {
$parcel$export(module.exports, "useFormState", () => $2a6e5a3979297f0f$export$606f11b2eb45ecc6);

var $euxye = parcelRequire("euxye");

var $edeJn = parcelRequire("edeJn");
// Constantized to avoid a new object reference built every call
const $2a6e5a3979297f0f$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const $2a6e5a3979297f0f$var$getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const $2a6e5a3979297f0f$export$606f11b2eb45ecc6 = (subscriptionConfig = $2a6e5a3979297f0f$var$defaultSubscriptionConfig)=>{
    const { subscribe: subscribe } = (0, $euxye.useContext)((0, $edeJn.FormContext));
    const [state, setState] = (0, $euxye.useState)();
    /**
	 * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
	 * We avoid computing the hash if the subscription config has referential equality altogether.
	 */ const subscriptionConfigHash = (0, $euxye.useMemo)(()=>$2a6e5a3979297f0f$var$getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
	 * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
	 * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
	 * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
	 */ const config = (0, $euxye.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $euxye.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};

});


parcelRegister("cMsbQ", function(module, exports) {
$parcel$export(module.exports, "FormActions", () => $a182fae7f3543370$export$9494d5a5e5299081);
/* eslint-disable jira/integration/test-id-by-folder-structure */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $a9o4s = parcelRequire("a9o4s");

var $iOfms = parcelRequire("iOfms");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $a182fae7f3543370$var$modalConfirmButton = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.actions.modal-confirm-button",
    defaultMessage: "Create"
});
const $a182fae7f3543370$var$modalCancelButton = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.actions.modal-cancel-button",
    defaultMessage: "Cancel"
});
const $a182fae7f3543370$export$9494d5a5e5299081 = ({ onClose: onClose, submitting: submitting })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $a182fae7f3543370$var$buttonGroupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
        appearance: "subtle",
        isDisabled: submitting,
        onClick: onClose,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "software-board-create.ui.modal.form.actions.board-create-cancel-button"
    }, formatMessage($a182fae7f3543370$var$modalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
        appearance: "primary",
        type: "submit",
        isLoading: submitting,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "software-board-create.ui.modal.form.actions.board-create-confirm-button"
    }, formatMessage($a182fae7f3543370$var$modalConfirmButton))));
};
$a182fae7f3543370$export$9494d5a5e5299081.displayName = "FormActions";
const $a182fae7f3543370$var$buttonGroupContainerStyles = (0, $fbAgj.xcss)({
    paddingBottom: 'space.100'
});

});

parcelRegister("bJoLV", function(module, exports) {
$parcel$export(module.exports, "BoardNameField", () => $477851a05e7926db$export$f710d048b5529d22);
/* eslint-disable jira/integration/test-id-by-folder-structure */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $eVMQF = parcelRequire("eVMQF");

var $1W2Av = parcelRequire("1W2Av");

var $hO3zy = parcelRequire("hO3zy");

var $bEwPd = parcelRequire("bEwPd");

var $iY9aj = parcelRequire("iY9aj");

var $7aCqr = parcelRequire("7aCqr");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $9ml7h = parcelRequire("9ml7h");
const $477851a05e7926db$var$boardNameFieldLabel = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.board-name.board-name-field-label",
    defaultMessage: "Name this board"
});
const $477851a05e7926db$var$boardNameFieldPlaceholder = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.board-name.board-name-field-placeholder",
    defaultMessage: "Enter a name for this board"
});
const $477851a05e7926db$var$boardNameEmptyError = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.board-name.board-name-empty-error",
    defaultMessage: "Enter a board name"
});
const $477851a05e7926db$var$boardNameMaxChars = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.board-name.board-name-max-chars",
    defaultMessage: "Maximum {maxLength, plural, one {# character} other {# characters}}"
});
const $477851a05e7926db$export$f710d048b5529d22 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const formState = (0, $iY9aj.useFormState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [value, setValue] = (0, $euxye.useState)('');
    const hasEdited = (0, $euxye.useRef)(false);
    const debouncedHandleOnChange = (0, $euxye.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($eVMQF)))(()=>{
        if (!hasEdited.current) {
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'input'
            }), 'boardName');
            hasEdited.current = true;
        }
    }, 300)).current;
    const handleOnChange = (0, $euxye.useCallback)((event)=>{
        setValue(event.currentTarget.value);
        const newValue = event.currentTarget.value;
        setValue(newValue);
        debouncedHandleOnChange();
    }, [
        debouncedHandleOnChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        label: formatMessage($477851a05e7926db$var$boardNameFieldLabel),
        name: "boardName",
        isRequired: true
    }, ({ fieldProps: { onChange: onChange, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            ...rest,
            placeholder: formatMessage($477851a05e7926db$var$boardNameFieldPlaceholder),
            maxLength: (0, $9ml7h.BOARD_NAME_LIMIT),
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "software-board-create.ui.modal.form.board-name.board-name-input",
            value: value,
            onChange: (event)=>{
                handleOnChange(event);
                onChange(event);
            }
        }), error === (0, $9ml7h.VALIDATION_ERROR_EMPTY) && // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hO3zy.ErrorMessage), {
            testId: "software-board-create.ui.modal.form.board-name.board-name-error"
        }, formatMessage($477851a05e7926db$var$boardNameEmptyError)), formState?.values.boardName && formState.values.boardName.length >= (0, $9ml7h.BOARD_NAME_LIMIT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEwPd.HelperMessage), null, formatMessage($477851a05e7926db$var$boardNameMaxChars, {
            maxLength: (0, $9ml7h.BOARD_NAME_LIMIT)
        }))));
};
$477851a05e7926db$export$f710d048b5529d22.displayName = "BoardNameField";

});

parcelRegister("fzjFG", function(module, exports) {
$parcel$export(module.exports, "SourceTypePicker", () => $ca27942798d3ac91$export$879aac32ab2e56ba);
/* SourceTypePicker.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $cIPCk = parcelRequire("cIPCk");

var $fcq2N = parcelRequire("fcq2N");

var $2CZtS = parcelRequire("2CZtS");

var $8z2GW = parcelRequire("8z2GW");

var $1W2Av = parcelRequire("1W2Av");

var $hO3zy = parcelRequire("hO3zy");

var $6Elhl = parcelRequire("6Elhl");

var $5BP41 = parcelRequire("5BP41");

var $gNHJ8 = parcelRequire("gNHJ8");

var $fbAgj = parcelRequire("fbAgj");

var $baIdH = parcelRequire("baIdH");

var $3xX0E = parcelRequire("3xX0E");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $12jTK = parcelRequire("12jTK");

var $7QLB2 = parcelRequire("7QLB2");
const $ca27942798d3ac91$var$selectPlaceholder = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.select-placeholder",
    defaultMessage: "Select"
});
const $ca27942798d3ac91$var$sourceTypeFieldLabel = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.source-type-field-label",
    defaultMessage: "Choose what to include in this board"
});
const $ca27942798d3ac91$var$sourceTypePickerAriaLabel = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.source-type-picker-aria-label",
    defaultMessage: "Select what to include in this board"
});
const $ca27942798d3ac91$var$sourceTypeEmptyError = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.source-type-empty-error",
    defaultMessage: "Select what to include in this board"
});
const $ca27942798d3ac91$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
const $ca27942798d3ac91$var$formatOptionLabel = (option)=>{
    const { icon: Icon, title: title, description: description } = option;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        alignItems: "center",
        gap: "space.150",
        xcss: $ca27942798d3ac91$var$optionStyles
    }, typeof Icon === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8z2GW.default), {
        src: Icon,
        size: "xxsmall",
        appearance: "square",
        borderColor: "transparent"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Icon, {
        label: "",
        name: "projectIcon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNHJ8.default), null, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNHJ8.default), {
        size: "small",
        color: "color.text.subtlest"
    }, description)));
};
const $ca27942798d3ac91$var$SingleValue = (props)=>{
    const { data: { selectedTitle: selectedTitle, icon: Icon } } = props;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3xX0E.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        alignItems: "center",
        gap: "space.100"
    }, typeof Icon === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8z2GW.default), {
        src: Icon,
        size: "xxsmall",
        appearance: "square",
        name: "avatar"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Icon, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNHJ8.default), null, formatMessage(selectedTitle, {
        strong: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNHJ8.default), {
                as: "strong"
            }, children)
    }))));
};
$ca27942798d3ac91$var$SingleValue.displayName = "SingleValue";
const $ca27942798d3ac91$export$77e74af9508bfdeb = ()=>(0, $euxye.useState)();
const $ca27942798d3ac91$var$controlStyles = {
    focused: "_1u6lxp8v _4cvx1v1w _1dbzt7xp"
};
const $ca27942798d3ac91$var$groupStyles = {
    root: "_1ved1dm9 _fgngnqa1 _1itx1l7x"
};
const $ca27942798d3ac91$export$879aac32ab2e56ba = ({ resetSourceValue: resetSourceValue })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [selected, setSelected] = $ca27942798d3ac91$export$77e74af9508bfdeb();
    const { projectAvatar: projectAvatar } = (0, $12jTK.useBoardCreateContext)();
    const optionGroups = (0, $euxye.useMemo)(()=>(0, $7QLB2.getOptionGroups)({
            formatMessage: formatMessage,
            projectAvatar: projectAvatar
        }), [
        formatMessage,
        projectAvatar
    ]);
    const flattenedOptions = (0, $euxye.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cIPCk)))(optionGroups.map((group)=>group.options)), [
        optionGroups
    ]);
    const handleChange = (0, $euxye.useCallback)((onFieldChange)=>(value)=>{
            const option = value?.value || null;
            resetSourceValue();
            setSelected(option);
            onFieldChange(option);
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'select',
                action: 'changed'
            }), 'boardSourceType', {
                sourceType: option
            });
        }, [
        createAnalyticsEvent,
        resetSourceValue,
        setSelected
    ]);
    const handleOnMenuOpen = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'select',
            action: 'opened'
        }), 'boardSourceType');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: "sourceType",
        label: formatMessage($ca27942798d3ac91$var$sourceTypeFieldLabel),
        defaultValue: undefined,
        isRequired: true
    }, ({ fieldProps: { onChange: onFieldChange, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2CZtS.default), {
            onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $baIdH.default), {
            ...rest,
            "aria-label": formatMessage($ca27942798d3ac91$var$sourceTypePickerAriaLabel),
            options: optionGroups,
            isSearchable: false,
            formatOptionLabel: $ca27942798d3ac91$var$formatOptionLabel,
            components: {
                SingleValue: $ca27942798d3ac91$var$SingleValue,
                Control: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3xX0E.components).Control, {
                        ...props,
                        xcss: props.isFocused && $ca27942798d3ac91$var$controlStyles.focused
                    }),
                Group: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3xX0E.components).Group, {
                        ...props,
                        xcss: $ca27942798d3ac91$var$groupStyles.root
                    })
            },
            placeholder: formatMessage($ca27942798d3ac91$var$selectPlaceholder),
            menuPosition: "fixed",
            classNamePrefix: "source-type-picker",
            onChange: handleChange(onFieldChange),
            value: flattenedOptions.find((option)=>option.value === selected),
            styles: {
                control: (base, state)=>({
                        ...base,
                        borderColor: state.isFocused ? "var(--ds-border-focused, #4688EC)" : base.borderColor,
                        ':focus-within': {
                            boxShadow: state.isFocused ? `inset 0px 0px 0px 1px ${"var(--ds-border-focused, #4688EC)"}` : base.boxShadow
                        },
                        ':hover': {
                            borderColor: state.isFocused ? "var(--ds-border-focused, #4688EC)" : base.borderColor,
                            boxShadow: state.isFocused ? 'elevation.shadow.raised' : base.boxShadow
                        }
                    }),
                option: (base)=>({
                        ...base,
                        // padding inside the option so hover covers the element
                        padding: `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-300, 24px)"}`
                    }),
                group: (base)=>({
                        ...base,
                        padding: 0,
                        ':not(:last-of-type)': {
                            borderBottomWidth: "var(--ds-border-width-selected, 2px)",
                            borderBottomStyle: 'solid',
                            borderBottomColor: "var(--ds-border, #0B120E24)"
                        }
                    }),
                groupHeading: (base)=>({
                        ...base,
                        margin: 0
                    }),
                menuList: (base)=>({
                        ...base,
                        padding: 0,
                        maxHeight: 325
                    })
            },
            onMenuOpen: handleOnMenuOpen
        })), error === $ca27942798d3ac91$export$7b060a5763a6e199 && // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hO3zy.ErrorMessage), {
            testId: "software-board-create.ui.modal.form.source-type-picker.error"
        }, formatMessage($ca27942798d3ac91$var$sourceTypeEmptyError))));
};
$ca27942798d3ac91$export$879aac32ab2e56ba.displayName = "SourceTypePicker";
const $ca27942798d3ac91$var$optionStyles = (0, $fbAgj.xcss)({
    minHeight: '40px'
});

});
parcelRegister("2CZtS", function(module, exports) {
$parcel$export(module.exports, "default", () => $12253e2b23cb7801$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $8DJJV = parcelRequire("8DJJV");
class $12253e2b23cb7801$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    static{
        this.defaultProps = {
            onEscape: null,
            onEnter: null,
            onBlur: null,
            className: undefined
        };
    }
    componentDidMount() {
        // AK Modal uses document.addEventListener() so we also have to use addEventListener.
        // We can't rely on React Synthetic events as stopPropagation won't work
        // This is due to the way React handles events
        // https://github.com/facebook/react/issues/7094
        if (this.ref) this.ref.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        if (this.ref) this.ref.removeEventListener('keydown', this.handleKeyDown);
    }
    render() {
        return(// @ts-expect-error - TS2322 - Type '(() => void) | null' is not assignable to type 'FocusEventHandler<HTMLDivElement> | undefined'.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
            onBlur: this.props.onBlur,
            ref: this.setRef,
            className: this.props.className
        }, this.props.children));
    }
    constructor(...args){
        super(...args), this.setRef = (ref)=>{
            this.ref = ref;
        }, this.handleKeyDown = (event)=>{
            switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($8DJJV)))('escape'):
                    if (this.props.onEscape) {
                        this.props.onEscape(event);
                        event.stopPropagation();
                    }
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($8DJJV)))('enter'):
                    if (this.props.onEnter) {
                        this.props.onEnter(event);
                        event.stopPropagation();
                    }
                    break;
                default:
                    break;
            }
        };
    }
}
$12253e2b23cb7801$export$2e2bcd8739ae039.displayName = "EnterEscapeHandler";

});
parcelRegister("8DJJV", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});


parcelRegister("7QLB2", function(module, exports) {
$parcel$export(module.exports, "getOptionGroups", () => $b95d0e4e0254dc1f$export$eec1253b95a159cc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $8A8fZ = parcelRequire("8A8fZ");

var $eYjNM = parcelRequire("eYjNM");

var $dqXyB = parcelRequire("dqXyB");

var $4Olij = parcelRequire("4Olij");

var $faDlH = parcelRequire("faDlH");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");

var $9ml7h = parcelRequire("9ml7h");
const $b95d0e4e0254dc1f$var$teamTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.team-title",
    defaultMessage: "Team"
});
const $b95d0e4e0254dc1f$var$teamSelectedTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.team-selected-title",
    defaultMessage: "Issues based on <strong>Team</strong>"
});
const $b95d0e4e0254dc1f$var$teamDescription = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.team-description",
    defaultMessage: "Show all issues assigned to a team"
});
const $b95d0e4e0254dc1f$var$issueTypesTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.issue-types-title",
    defaultMessage: "Issue type"
});
const $b95d0e4e0254dc1f$var$issueTypesSelectedTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.issue-types-selected-title",
    defaultMessage: "Issues based on <strong>Issue type</strong>"
});
const $b95d0e4e0254dc1f$var$issueTypesDescription = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.issue-types-description",
    defaultMessage: "Show all issues associated with an issue type"
});
const $b95d0e4e0254dc1f$var$labelsTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.labels-title",
    defaultMessage: "Label"
});
const $b95d0e4e0254dc1f$var$labelsSelectedTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.labels-selected-title",
    defaultMessage: "Issues based on <strong>Label</strong>"
});
const $b95d0e4e0254dc1f$var$labelsDescription = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.labels-description",
    defaultMessage: "Show all issues tagged with a specific label"
});
const $b95d0e4e0254dc1f$var$allIssuesFromProjectTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.all-issues-from-project-title",
    defaultMessage: "All issues from your project"
});
const $b95d0e4e0254dc1f$var$allIssuesFromProjectSelectedTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title",
    defaultMessage: "Issues based on <strong>All issues from your project</strong>"
});
const $b95d0e4e0254dc1f$var$savedFilterTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.saved-filter-title",
    defaultMessage: "Advanced"
});
const $b95d0e4e0254dc1f$var$savedFilterSelectedTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.saved-filter-selected-title",
    defaultMessage: "Issues based on a <strong>Saved filter</strong>"
});
const $b95d0e4e0254dc1f$var$savedFilterDescription = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.saved-filter-description",
    defaultMessage: "Show issues from a saved JQL filter"
});
const $b95d0e4e0254dc1f$var$teamSelectedTitleIssueTerminologyRefreshM4 = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.team-selected-title-issue-terminology-refresh-m4",
    defaultMessage: "Work items based on <strong>Team</strong>"
});
const $b95d0e4e0254dc1f$var$teamDescriptionIssueTerminologyRefreshM4 = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.team-description-issue-terminology-refresh-m4",
    defaultMessage: "Show all work items assigned to a team"
});
const $b95d0e4e0254dc1f$var$issueTypesTitleIssueTerminologyRefreshM4 = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.issue-types-title-issue-terminology-refresh-m4",
    defaultMessage: "Work type"
});
const $b95d0e4e0254dc1f$var$issueTypesSelectedTitleIssueTerminologyRefreshM4 = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.issue-types-selected-title-issue-terminology-refresh-m4",
    defaultMessage: "Work items based on <strong>work type</strong>"
});
const $b95d0e4e0254dc1f$var$issueTypesDescriptionIssueTerminologyRefreshM4 = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.issue-types-description-issue-terminology-refresh-m4",
    defaultMessage: "Show all work items associated with a work type"
});
const $b95d0e4e0254dc1f$var$labelsSelectedTitleIssueTerminologyRefreshM4 = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.labels-selected-title-issue-terminology-refresh-m4",
    defaultMessage: "Work items based on <strong>label</strong>"
});
const $b95d0e4e0254dc1f$var$labelsDescriptionIssueTerminologyRefreshM4 = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.labels-description-issue-terminology-refresh-m4",
    defaultMessage: "Show all work items tagged with a specific label"
});
const $b95d0e4e0254dc1f$var$allIssuesFromProjectTitleIssueTerminologyRefreshM4 = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.all-issues-from-project-title-issue-terminology-refresh-m4",
    defaultMessage: "All work items from your project"
});
const $b95d0e4e0254dc1f$var$allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4 = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title-issue-terminology-refresh-m4",
    defaultMessage: "Work items based on <strong>All work items from your project</strong>"
});
const $b95d0e4e0254dc1f$var$savedFilterSelectedTitleIssueTerminologyRefreshM4 = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.saved-filter-selected-title-issue-terminology-refresh-m4",
    defaultMessage: "Work items based on a <strong>Saved filter</strong>"
});
const $b95d0e4e0254dc1f$var$savedFilterDescriptionIssueTerminologyRefreshM4 = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.saved-filter-description-issue-terminology-refresh-m4",
    defaultMessage: "Show work items from a saved JQL filter"
});
const $b95d0e4e0254dc1f$var$allIssuesFromProjectTitleIssueTerminologyRefreshM4Galaxia = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.all-issues-from-project-title-issue-terminology-refresh-m4-galaxia",
    defaultMessage: "All work items from your space"
});
const $b95d0e4e0254dc1f$var$allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Galaxia = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title-issue-terminology-refresh-m4-galaxia",
    defaultMessage: "Work items based on <strong>All work items from your space</strong>"
});
const $b95d0e4e0254dc1f$export$eec1253b95a159cc = ({ formatMessage: formatMessage, projectAvatar: projectAvatar })=>{
    const allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Replacement = (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $b95d0e4e0254dc1f$var$allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Galaxia : $b95d0e4e0254dc1f$var$allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4;
    const allIssuesFromProjectTitleIssueTerminologyRefreshM4Replacement = (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $b95d0e4e0254dc1f$var$allIssuesFromProjectTitleIssueTerminologyRefreshM4Galaxia : $b95d0e4e0254dc1f$var$allIssuesFromProjectTitleIssueTerminologyRefreshM4;
    const allIssuesFromProjectTitleMessage = (0, $i860n.fg)('jira-issue-terminology-update-m4') ? allIssuesFromProjectTitleIssueTerminologyRefreshM4Replacement : $b95d0e4e0254dc1f$var$allIssuesFromProjectTitle;
    const allIssuesFromProjectSelectedTitleMessage = (0, $i860n.fg)('jira-issue-terminology-update-m4') ? allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Replacement : $b95d0e4e0254dc1f$var$allIssuesFromProjectSelectedTitle;
    const teamSelectedTitleMessage = (0, $i860n.fg)('jira-issue-terminology-update-m4') ? $b95d0e4e0254dc1f$var$teamSelectedTitleIssueTerminologyRefreshM4 : $b95d0e4e0254dc1f$var$teamSelectedTitle;
    const teamDescriptionMessage = (0, $i860n.fg)('jira-issue-terminology-update-m4') ? $b95d0e4e0254dc1f$var$teamDescriptionIssueTerminologyRefreshM4 : $b95d0e4e0254dc1f$var$teamDescription;
    const issueTypesTitleMessage = (0, $i860n.fg)('jira-issue-terminology-update-m4') ? $b95d0e4e0254dc1f$var$issueTypesTitleIssueTerminologyRefreshM4 : $b95d0e4e0254dc1f$var$issueTypesTitle;
    const issueTypesSelectedTitleMessage = (0, $i860n.fg)('jira-issue-terminology-update-m4') ? $b95d0e4e0254dc1f$var$issueTypesSelectedTitleIssueTerminologyRefreshM4 : $b95d0e4e0254dc1f$var$issueTypesSelectedTitle;
    const issueTypesDescriptionMessage = (0, $i860n.fg)('jira-issue-terminology-update-m4') ? $b95d0e4e0254dc1f$var$issueTypesDescriptionIssueTerminologyRefreshM4 : $b95d0e4e0254dc1f$var$issueTypesDescription;
    const labelsSelectedTitleMessage = (0, $i860n.fg)('jira-issue-terminology-update-m4') ? $b95d0e4e0254dc1f$var$labelsSelectedTitleIssueTerminologyRefreshM4 : $b95d0e4e0254dc1f$var$labelsSelectedTitle;
    const labelsDescriptionMessage = (0, $i860n.fg)('jira-issue-terminology-update-m4') ? $b95d0e4e0254dc1f$var$labelsDescriptionIssueTerminologyRefreshM4 : $b95d0e4e0254dc1f$var$labelsDescription;
    const savedFilterSelectedTitleMessage = (0, $i860n.fg)('jira-issue-terminology-update-m4') ? $b95d0e4e0254dc1f$var$savedFilterSelectedTitleIssueTerminologyRefreshM4 : $b95d0e4e0254dc1f$var$savedFilterSelectedTitle;
    const savedFilterDescriptionMessage = (0, $i860n.fg)('jira-issue-terminology-update-m4') ? $b95d0e4e0254dc1f$var$savedFilterDescriptionIssueTerminologyRefreshM4 : $b95d0e4e0254dc1f$var$savedFilterDescription;
    return [
        {
            options: [
                {
                    label: formatMessage(allIssuesFromProjectTitleMessage),
                    title: formatMessage(allIssuesFromProjectTitleMessage),
                    selectedTitle: allIssuesFromProjectSelectedTitleMessage,
                    value: null,
                    icon: projectAvatar || (0, (/*@__PURE__*/$parcel$interopDefault($faDlH)))
                }
            ]
        },
        {
            options: [
                {
                    label: formatMessage($b95d0e4e0254dc1f$var$teamTitle),
                    title: formatMessage($b95d0e4e0254dc1f$var$teamTitle),
                    selectedTitle: teamSelectedTitleMessage,
                    description: formatMessage(teamDescriptionMessage),
                    value: (0, $9ml7h.BOARD_SOURCE_FIELDS).TEAM,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4Olij)))
                },
                {
                    label: formatMessage(issueTypesTitleMessage),
                    title: formatMessage(issueTypesTitleMessage),
                    selectedTitle: issueTypesSelectedTitleMessage,
                    description: formatMessage(issueTypesDescriptionMessage),
                    value: (0, $9ml7h.BOARD_SOURCE_FIELDS).ISSUE_TYPES,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($eYjNM)))
                },
                {
                    label: formatMessage($b95d0e4e0254dc1f$var$labelsTitle),
                    title: formatMessage($b95d0e4e0254dc1f$var$labelsTitle),
                    selectedTitle: labelsSelectedTitleMessage,
                    description: formatMessage(labelsDescriptionMessage),
                    value: (0, $9ml7h.BOARD_SOURCE_FIELDS).LABELS,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dqXyB)))
                }
            ]
        },
        {
            options: [
                {
                    label: formatMessage($b95d0e4e0254dc1f$var$savedFilterTitle),
                    title: formatMessage($b95d0e4e0254dc1f$var$savedFilterTitle),
                    selectedTitle: savedFilterSelectedTitleMessage,
                    description: formatMessage(savedFilterDescriptionMessage),
                    value: (0, $9ml7h.BOARD_SOURCE_FIELDS).SAVED_FILTER,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($8A8fZ)))
                }
            ]
        }
    ];
};

});
parcelRegister("dqXyB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92d25973bebe527e96d6f3e854e8f605>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c7be6deda372a19$var$_react = $9c7be6deda372a19$var$_interopRequireDefault((parcelRequire("euxye")));

var $9c7be6deda372a19$var$_baseNew = $9c7be6deda372a19$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $9c7be6deda372a19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/tag
 * Usage guidance:
 * Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c7be6deda372a19$var$TagIcon = (props)=>/*#__PURE__*/ $9c7be6deda372a19$var$_react.default.createElement($9c7be6deda372a19$var$_baseNew.default, Object.assign({
        name: "TagIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentcolor" fill-rule="evenodd" d="M9.286 1a3.25 3.25 0 0 0-2.299.952L1.604 7.336a2 2 0 0 0 0 2.828l4.232 4.232a2 2 0 0 0 2.828 0l5.384-5.383A3.25 3.25 0 0 0 15 6.714V3a2 2 0 0 0-2-2zM8.048 3.013A1.75 1.75 0 0 1 9.286 2.5H13a.5.5 0 0 1 .5.5v3.714c0 .465-.184.91-.513 1.238l-5.383 5.384a.5.5 0 0 1-.708 0L2.664 9.104a.5.5 0 0 1 0-.708z" clip-rule="evenodd"/>`
    }, props));
$9c7be6deda372a19$var$TagIcon.displayName = 'TagIcon';
var $9c7be6deda372a19$var$_default = module.exports.default = $9c7be6deda372a19$var$TagIcon;

});



parcelRegister("lrxAF", function(module, exports) {
$parcel$export(module.exports, "SOURCE_VALUE_FIELD_NAME", () => $51d24964d17085fa$export$2acdb7270c211b02);
$parcel$export(module.exports, "SourceValuePicker", () => $51d24964d17085fa$export$427e84d70337182b);
/* eslint-disable jira/integration/test-id-by-folder-structure */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1W2Av = parcelRequire("1W2Av");

var $iY9aj = parcelRequire("iY9aj");

var $hO3zy = parcelRequire("hO3zy");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $axHjD = parcelRequire("axHjD");

var $5xtCb = parcelRequire("5xtCb");
const $51d24964d17085fa$var$sourceValueEmptyError = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-value-picker.source-value-empty-error",
    defaultMessage: "Please select a value"
});
const $51d24964d17085fa$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
const $51d24964d17085fa$export$2acdb7270c211b02 = 'sourceValue';
const $51d24964d17085fa$export$427e84d70337182b = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const formState = (0, $iY9aj.useFormState)();
    const sourceType = formState?.values.sourceType;
    if (!sourceType) return null;
    const boardSource = (0, $i860n.fg)('jira-issue-terminology-update-m4') ? (0, $5xtCb.boardSourceFieldComponentMap) : (0, $5xtCb.boardSourceFieldComponentMapOld);
    const mappedSource = boardSource[sourceType];
    if (!mappedSource) {
        (0, $axHjD.fireBoardCreateErrorAnalytics)({
            error: new Error(`No source field component found for ${sourceType}`),
            id: 'unmappedSourceType'
        });
        return null;
    }
    const { component: PickerComponent, extraProps: extraProps, label: label } = mappedSource;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        key: `sourceValue-${sourceType}`,
        name: $51d24964d17085fa$export$2acdb7270c211b02,
        label: formatMessage(label),
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(PickerComponent, {
            key: `sourceValue-${sourceType}-picker`,
            label: formatMessage(label),
            ...fieldProps,
            ...extraProps
        }), error === $51d24964d17085fa$export$7b060a5763a6e199 && // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hO3zy.ErrorMessage), {
            testId: "software-board-create.ui.modal.form.source-value-picker.error"
        }, formatMessage($51d24964d17085fa$var$sourceValueEmptyError))));
};
$51d24964d17085fa$export$427e84d70337182b.displayName = "SourceValuePicker";

});
parcelRegister("5xtCb", function(module, exports) {
$parcel$export(module.exports, "boardSourceFieldComponentMap", () => $d4b83057dabb8862$export$69996e7483e1a92f);
$parcel$export(module.exports, "boardSourceFieldComponentMapOld", () => $d4b83057dabb8862$export$c6355b6dd89ea597);

var $7eNDO = parcelRequire("7eNDO");

var $9ml7h = parcelRequire("9ml7h");

var $gDeCN = parcelRequire("gDeCN");

var $boWey = parcelRequire("boWey");

var $htYvv = parcelRequire("htYvv");
const $d4b83057dabb8862$var$issueTypeFieldLabel = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-value-picker.issue-type-field-label",
    defaultMessage: "Issue type"
});
const $d4b83057dabb8862$var$teamFieldLabel = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-value-picker.team-field-label",
    defaultMessage: "Team"
});
const $d4b83057dabb8862$var$labelsFieldLabel = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-value-picker.labels-field-label",
    defaultMessage: "Label"
});
const $d4b83057dabb8862$var$savedFilterLabel = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-value-picker.saved-filter-label",
    defaultMessage: "Select a saved filter"
});
const $d4b83057dabb8862$var$issueTypeFieldLabelIssueTerminologyRefreshM4 = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-value-picker.issue-type-field-label-issue-terminology-refresh-m4",
    defaultMessage: "Work type"
});
const $d4b83057dabb8862$export$69996e7483e1a92f = {
    [(0, $9ml7h.BOARD_SOURCE_FIELDS).ISSUE_TYPES]: {
        component: (0, $gDeCN.GenericPicker),
        label: $d4b83057dabb8862$var$issueTypeFieldLabelIssueTerminologyRefreshM4,
        id: (0, $9ml7h.BOARD_SOURCE_FIELDS).ISSUE_TYPES,
        extraProps: {
            jqlTerm: (0, $9ml7h.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $9ml7h.BOARD_SOURCE_FIELDS).ISSUE_TYPES]
        }
    },
    [(0, $9ml7h.BOARD_SOURCE_FIELDS).TEAM]: {
        component: (0, $htYvv.TeamPicker),
        label: $d4b83057dabb8862$var$teamFieldLabel,
        id: (0, $9ml7h.BOARD_SOURCE_FIELDS).TEAM
    },
    [(0, $9ml7h.BOARD_SOURCE_FIELDS).LABELS]: {
        component: (0, $gDeCN.GenericPicker),
        label: $d4b83057dabb8862$var$labelsFieldLabel,
        id: (0, $9ml7h.BOARD_SOURCE_FIELDS).LABELS,
        extraProps: {
            jqlTerm: (0, $9ml7h.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $9ml7h.BOARD_SOURCE_FIELDS).LABELS]
        }
    },
    [(0, $9ml7h.BOARD_SOURCE_FIELDS).SAVED_FILTER]: {
        component: (0, $boWey.SavedFilterPicker),
        label: $d4b83057dabb8862$var$savedFilterLabel,
        id: (0, $9ml7h.BOARD_SOURCE_FIELDS).SAVED_FILTER
    }
};
const $d4b83057dabb8862$export$c6355b6dd89ea597 = {
    [(0, $9ml7h.BOARD_SOURCE_FIELDS).ISSUE_TYPES]: {
        component: (0, $gDeCN.GenericPicker),
        label: $d4b83057dabb8862$var$issueTypeFieldLabel,
        id: (0, $9ml7h.BOARD_SOURCE_FIELDS).ISSUE_TYPES,
        extraProps: {
            jqlTerm: (0, $9ml7h.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $9ml7h.BOARD_SOURCE_FIELDS).ISSUE_TYPES]
        }
    },
    [(0, $9ml7h.BOARD_SOURCE_FIELDS).TEAM]: {
        component: (0, $htYvv.TeamPicker),
        label: $d4b83057dabb8862$var$teamFieldLabel,
        id: (0, $9ml7h.BOARD_SOURCE_FIELDS).TEAM
    },
    [(0, $9ml7h.BOARD_SOURCE_FIELDS).LABELS]: {
        component: (0, $gDeCN.GenericPicker),
        label: $d4b83057dabb8862$var$labelsFieldLabel,
        id: (0, $9ml7h.BOARD_SOURCE_FIELDS).LABELS,
        extraProps: {
            jqlTerm: (0, $9ml7h.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $9ml7h.BOARD_SOURCE_FIELDS).LABELS]
        }
    },
    [(0, $9ml7h.BOARD_SOURCE_FIELDS).SAVED_FILTER]: {
        component: (0, $boWey.SavedFilterPicker),
        label: $d4b83057dabb8862$var$savedFilterLabel,
        id: (0, $9ml7h.BOARD_SOURCE_FIELDS).SAVED_FILTER
    }
};

});
parcelRegister("gDeCN", function(module, exports) {
$parcel$export(module.exports, "GenericPicker", () => $dcebee7598535f1f$export$37d6fee5be00e6be);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $eVMQF = parcelRequire("eVMQF");

var $fcq2N = parcelRequire("fcq2N");

var $2CZtS = parcelRequire("2CZtS");

var $8z2GW = parcelRequire("8z2GW");

var $6Elhl = parcelRequire("6Elhl");

var $fbAgj = parcelRequire("fbAgj");

var $c69sa = parcelRequire("c69sa");

var $iGHbj = parcelRequire("iGHbj");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $9ml7h = parcelRequire("9ml7h");

var $9noKc = parcelRequire("9noKc");
const $dcebee7598535f1f$var$genericPickerPlaceholder = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-value-picker.generic-picker.generic-picker-placeholder",
    defaultMessage: "Select"
});
const $dcebee7598535f1f$var$formatOptionLabel = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        alignItems: "center"
    }, option.avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        xcss: $dcebee7598535f1f$var$imgStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8z2GW.default), {
        appearance: "square",
        size: "xxsmall",
        src: option.avatar,
        borderColor: "transparent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $dcebee7598535f1f$var$optionStyles
    }, option.label));
const $dcebee7598535f1f$export$37d6fee5be00e6be = ({ onChange: onChange, value: value, jqlTerm: jqlTerm, isInvalid: isInvalid, label: label })=>{
    const { loadOptions: loadOptions, isLoading: isLoading } = (0, $9noKc.useLoadOptionsController)();
    const [defaultOptions, setDefaultOptions] = (0, $euxye.useState)();
    const [menuIsOpen, setMenuIsOpen] = (0, $euxye.useState)(false);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    (0, $euxye.useEffect)(()=>{
        loadOptions(jqlTerm)('').then((options)=>setDefaultOptions(options));
    }, [
        jqlTerm,
        loadOptions
    ]);
    const debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($eVMQF)))((searchString, callback)=>loadOptions(jqlTerm)(searchString).then((options)=>callback(options)), (0, $9ml7h.PICKER_SEARCH_DEBOUNCE_TIME));
    const handleOnKeyDown = (0, $euxye.useCallback)((event)=>{
        if (!menuIsOpen && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) setMenuIsOpen(true);
        // close the menu when focusing on multi value to prevent enter key from propagating
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') setMenuIsOpen(false);
        // prevent form submission error
        if (event.key === 'Enter' && !menuIsOpen) event.preventDefault();
    }, [
        menuIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2CZtS.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iGHbj.default), {
        "aria-label": label,
        isMulti: true,
        isLoading: isLoading,
        formatOptionLabel: $dcebee7598535f1f$var$formatOptionLabel,
        defaultOptions: defaultOptions,
        loadOptions: debouncedLoadOptions,
        onChange: onChange,
        value: value,
        placeholder: formatMessage($dcebee7598535f1f$var$genericPickerPlaceholder),
        menuPosition: "fixed",
        classNamePrefix: "source-value-picker",
        isInvalid: isInvalid,
        onFocus: ()=>setMenuIsOpen(true),
        onBlur: ()=>setMenuIsOpen(false),
        menuIsOpen: menuIsOpen,
        blurInputOnSelect: false,
        onKeyDown: handleOnKeyDown
    }));
};
$dcebee7598535f1f$export$37d6fee5be00e6be.displayName = "GenericPicker";
const $dcebee7598535f1f$var$imgStyles = (0, $fbAgj.xcss)({
    paddingRight: 'space.100'
});
const $dcebee7598535f1f$var$optionStyles = (0, $fbAgj.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});

});
parcelRegister("iGHbj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6de47f5770b3f3c1$export$2e2bcd8739ae039);

var $36lJ8 = parcelRequire("36lJ8");

var $c0vzW = parcelRequire("c0vzW");
const $6de47f5770b3f3c1$var$AsyncSelect = (0, $c0vzW.default)((0, $36lJ8.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6de47f5770b3f3c1$export$2e2bcd8739ae039 = $6de47f5770b3f3c1$var$AsyncSelect;

});

parcelRegister("9noKc", function(module, exports) {
$parcel$export(module.exports, "useLoadOptionsController", () => $ceffa034ee85542f$export$50422aa3bb02e176);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $9ml7h = parcelRequire("9ml7h");

var $axHjD = parcelRequire("axHjD");

var $3sbqe = parcelRequire("3sbqe");

var $12jTK = parcelRequire("12jTK");

var $6YZHw = parcelRequire("6YZHw");
const $ceffa034ee85542f$var$failedToLoadIssueTypesTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-title",
    defaultMessage: "We can\u2019t load issue types right now"
});
const $ceffa034ee85542f$var$failedToLoadIssueTypesDescription = (0, $7eNDO.defineMessage)({
    id: "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-description",
    defaultMessage: "Refresh the page and try again."
});
const $ceffa034ee85542f$var$failedToLoadLabelsTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.controllers.use-load-options-controller.failed-to-load-labels-title",
    defaultMessage: "We can\u2019t load labels right now"
});
const $ceffa034ee85542f$var$failedToLoadLabelsDescription = (0, $7eNDO.defineMessage)({
    id: "software-board-create.controllers.use-load-options-controller.failed-to-load-labels-description",
    defaultMessage: "Refresh the page and try again."
});
const $ceffa034ee85542f$var$failedToLoadOptionsTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.controllers.use-load-options-controller.failed-to-load-options-title",
    defaultMessage: "Something went wrong"
});
const $ceffa034ee85542f$var$failedToLoadIssueTypesTitleIssueTerminologyRefreshM4 = (0, $7eNDO.defineMessage)({
    id: "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-title-issue-terminology-refresh-m4",
    defaultMessage: "We can\u2019t load work types right now"
});
const $ceffa034ee85542f$var$errorMessageMapOld = {
    [(0, $9ml7h.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $9ml7h.BOARD_SOURCE_FIELDS).ISSUE_TYPES]]: {
        title: $ceffa034ee85542f$var$failedToLoadIssueTypesTitle,
        description: $ceffa034ee85542f$var$failedToLoadIssueTypesDescription
    },
    [(0, $9ml7h.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $9ml7h.BOARD_SOURCE_FIELDS).LABELS]]: {
        title: $ceffa034ee85542f$var$failedToLoadLabelsTitle,
        description: $ceffa034ee85542f$var$failedToLoadLabelsDescription
    },
    DEFAULT: {
        title: $ceffa034ee85542f$var$failedToLoadOptionsTitle,
        description: $ceffa034ee85542f$var$failedToLoadOptionsTitle
    }
};
const $ceffa034ee85542f$var$errorMessageMap = {
    [(0, $9ml7h.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $9ml7h.BOARD_SOURCE_FIELDS).ISSUE_TYPES]]: {
        title: $ceffa034ee85542f$var$failedToLoadIssueTypesTitleIssueTerminologyRefreshM4,
        description: $ceffa034ee85542f$var$failedToLoadIssueTypesDescription
    },
    [(0, $9ml7h.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $9ml7h.BOARD_SOURCE_FIELDS).LABELS]]: {
        title: $ceffa034ee85542f$var$failedToLoadLabelsTitle,
        description: $ceffa034ee85542f$var$failedToLoadLabelsDescription
    },
    DEFAULT: {
        title: $ceffa034ee85542f$var$failedToLoadOptionsTitle,
        description: $ceffa034ee85542f$var$failedToLoadOptionsTitle
    }
};
const $ceffa034ee85542f$export$4dface15d86304a4 = ()=>(0, $euxye.useState)(false);
const $ceffa034ee85542f$export$50422aa3bb02e176 = ()=>{
    const { projectId: projectId } = (0, $12jTK.useBoardCreateContext)();
    const jqlBuilderFetch = (0, $3sbqe.useJQLBuilderFetch)({
        projectId: projectId
    });
    const [isLoading, setIsLoading] = $ceffa034ee85542f$export$4dface15d86304a4();
    const { showErrorFlag: showErrorFlag } = (0, $6YZHw.useBoardCreateFlag)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const loadOptions = (0, $euxye.useCallback)((jqlTerm)=>async (searchString)=>{
            setIsLoading(true);
            const errorMessages = (0, $i860n.fg)('jira-issue-terminology-update-m4') ? $ceffa034ee85542f$var$errorMessageMap : $ceffa034ee85542f$var$errorMessageMapOld;
            return jqlBuilderFetch(jqlTerm, searchString).catch((error)=>{
                const errorText = errorMessages[jqlTerm] || errorMessages.DEFAULT;
                showErrorFlag({
                    title: formatMessage(errorText.title),
                    description: formatMessage(errorText.description)
                });
                (0, $axHjD.fireBoardCreateErrorAnalytics)({
                    error: new Error(`Failed to fetch picker options: ${error}`),
                    attributes: {
                        jqlTerm: jqlTerm
                    },
                    id: 'fetchPickerOptions'
                });
                return [];
            }).finally(()=>{
                setIsLoading(false);
            });
        }, [
        formatMessage,
        jqlBuilderFetch,
        setIsLoading,
        showErrorFlag
    ]);
    return {
        loadOptions: loadOptions,
        isLoading: isLoading
    };
};

});
parcelRegister("3sbqe", function(module, exports) {
$parcel$export(module.exports, "useJQLBuilderFetch", () => $081a273a2b755c6b$export$a8efb2384cee4751);

var $3MVHz = parcelRequire("3MVHz");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $kt86l = parcelRequire("kt86l");
const $081a273a2b755c6b$export$a8efb2384cee4751 = ({ projectId: projectId })=>{
    if (projectId === undefined) throw new Error('Project ID is undefined');
    const cloudId = (0, $kt86l.useCloudId)();
    const environment = (0, $n67Vb.useRelayEnvironment)();
    return (0, $euxye.useCallback)(async (jqlTerm, searchString)=>(0, $n67Vb.fetchQuery)(environment, (0, $3MVHz.default), {
            cloudId: cloudId,
            jqlTerm: jqlTerm,
            jql: `project = ${projectId}`,
            searchString: searchString
        }).toPromise().then((response)=>{
            if (response?.jira?.jqlBuilder?.fieldValues?.edges) {
                const data = response.jira.jqlBuilder.fieldValues.edges.map((edge)=>{
                    if (jqlTerm === 'type') return {
                        label: edge?.node?.displayName || '',
                        value: edge?.node?.issueTypes && edge?.node?.issueTypes[0]?.issueTypeId || '',
                        avatar: edge?.node?.issueTypes && edge?.node?.issueTypes[0].avatar?.small || ''
                    };
                    return {
                        label: edge?.node?.displayName || '',
                        value: edge?.node?.displayName || ''
                    };
                }) || [];
                return data;
            }
            throw new Error('No response');
        }), [
        cloudId,
        environment,
        projectId
    ]);
};

});
parcelRegister("3MVHz", function(module, exports) {
$parcel$export(module.exports, "default", () => $d903c8eb3bac2673$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<db03727863a50b6d2c4ee21da08305fc>>
 * @relayHash d1d298bca46ec4b6383711b33f893fa6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ef2d509a98c86832afdacca779d61ce3ccb21fc39cb0a11415558f5ead565413
const $d903c8eb3bac2673$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v8 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ 
        ],
        "type": "JiraJqlLabelFieldValue"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useJQLBuilderFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useJQLBuilderFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v10 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ef2d509a98c86832afdacca779d61ce3ccb21fc39cb0a11415558f5ead565413",
            "metadata": {},
            "name": "useJQLBuilderFetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d903c8eb3bac2673$var$node.hash = "7815049dd1a80d54d0594b76d8c22cae";
var $d903c8eb3bac2673$export$2e2bcd8739ae039 = $d903c8eb3bac2673$var$node;

});




parcelRegister("boWey", function(module, exports) {
$parcel$export(module.exports, "SavedFilterPicker", () => $66269e9aed894ed6$export$7408ad1ebc985020);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $eVMQF = parcelRequire("eVMQF");

var $fcq2N = parcelRequire("fcq2N");

var $2CZtS = parcelRequire("2CZtS");

var $8A8fZ = parcelRequire("8A8fZ");

var $2XXtG = parcelRequire("2XXtG");

var $iGHbj = parcelRequire("iGHbj");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $9ml7h = parcelRequire("9ml7h");

var $g2dhB = parcelRequire("g2dhB");
const $66269e9aed894ed6$var$savedFilterPickerPlaceholder = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-value-picker.saved-filter-picker.saved-filter-picker-placeholder",
    defaultMessage: "Select"
});
const $66269e9aed894ed6$var$formatOptionLabel = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8A8fZ))), {
        spacing: "spacious",
        label: option.label
    }), option.label);
const $66269e9aed894ed6$export$7408ad1ebc985020 = ({ onChange: onChange, value: value, isInvalid: isInvalid, label: label })=>{
    const { loadOptions: loadOptions, isLoading: isLoading } = (0, $g2dhB.useLoadSavedFiltersController)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($eVMQF)))((searchString, callback)=>loadOptions(searchString).then((options)=>callback(options)), (0, $9ml7h.PICKER_SEARCH_DEBOUNCE_TIME));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2CZtS.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iGHbj.default), {
        "aria-label": label,
        isLoading: isLoading,
        formatOptionLabel: $66269e9aed894ed6$var$formatOptionLabel,
        defaultOptions: true,
        loadOptions: debouncedLoadOptions,
        onChange: onChange,
        value: value,
        placeholder: formatMessage($66269e9aed894ed6$var$savedFilterPickerPlaceholder),
        menuPosition: "fixed",
        classNamePrefix: "source-value-picker",
        isInvalid: isInvalid
    }));
};
$66269e9aed894ed6$export$7408ad1ebc985020.displayName = "SavedFilterPicker";

});
parcelRegister("g2dhB", function(module, exports) {
$parcel$export(module.exports, "useLoadSavedFiltersController", () => $b13413c484aaa0e6$export$bb3a63b49faf836c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $axHjD = parcelRequire("axHjD");

var $6YFLR = parcelRequire("6YFLR");

var $6YZHw = parcelRequire("6YZHw");
const $b13413c484aaa0e6$var$loadSavedFiltersErrorTitle = (0, $7eNDO.defineMessage)({
    id: "software-board-create.common.load-saved-filters-error-title",
    defaultMessage: "We can't load saved filters right now"
});
const $b13413c484aaa0e6$var$loadSavedFiltersErrorDescription = (0, $7eNDO.defineMessage)({
    id: "software-board-create.common.load-saved-filters-error-description",
    defaultMessage: "Refresh the page and try again."
});
const $b13413c484aaa0e6$export$4dface15d86304a4 = ()=>(0, $euxye.useState)(false);
const $b13413c484aaa0e6$export$bb3a63b49faf836c = ()=>{
    const savedFiltersFetch = (0, $6YFLR.useSavedFiltersFetch)();
    const [isLoading, setIsLoading] = $b13413c484aaa0e6$export$4dface15d86304a4();
    const { showErrorFlag: showErrorFlag } = (0, $6YZHw.useBoardCreateFlag)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const loadOptions = (0, $euxye.useCallback)(async (searchString)=>{
        setIsLoading(true);
        return savedFiltersFetch(searchString).catch((error)=>{
            showErrorFlag({
                title: formatMessage($b13413c484aaa0e6$var$loadSavedFiltersErrorTitle),
                description: formatMessage($b13413c484aaa0e6$var$loadSavedFiltersErrorDescription)
            });
            (0, $axHjD.fireBoardCreateErrorAnalytics)({
                error: new Error(`Failed to fetch saved filters: ${error}`),
                id: 'fetchSavedFilters'
            });
            return [];
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        formatMessage,
        savedFiltersFetch,
        setIsLoading,
        showErrorFlag
    ]);
    return {
        loadOptions: loadOptions,
        isLoading: isLoading
    };
};

});
parcelRegister("6YFLR", function(module, exports) {
$parcel$export(module.exports, "useSavedFiltersFetch", () => $8b24f57a27983bb2$export$919a4c273fb6b0e5);

var $5DXql = parcelRequire("5DXql");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $kt86l = parcelRequire("kt86l");
const $8b24f57a27983bb2$export$919a4c273fb6b0e5 = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const environment = (0, $n67Vb.useRelayEnvironment)();
    return (0, $euxye.useCallback)(async (searchString)=>{
        return (0, $n67Vb.fetchQuery)(environment, (0, $5DXql.default), {
            cloudId: cloudId,
            searchString: searchString
        }).toPromise().then((response)=>{
            if (response?.jira?.savedFilters?.edges) {
                const data = response.jira.savedFilters.edges.map((edge)=>{
                    return {
                        label: edge?.node?.name || '',
                        value: edge?.node?.filterId || ''
                    };
                }) || [];
                return data;
            }
            throw new Error('No response');
        });
    }, [
        cloudId,
        environment
    ]);
};

});
parcelRegister("5DXql", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe3a083e2869e191$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b141fb300ff099218fb2c30857bdbe18>>
 * @relayHash 6e5fec99171872e06e6faef5354994ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c54fe404b07b4a4533c203ab6c68bf936d5a086953aa1a446da9bec5a0a67f5
const $fe3a083e2869e191$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchString"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "keyword",
            "variableName": "searchString"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "filterId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ],
        "type": "JiraCustomFilter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSavedFiltersFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraFilterConnection",
                                "kind": "LinkedField",
                                "name": "savedFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                "action": "THROW"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSavedFiltersFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraFilterConnection",
                            "kind": "LinkedField",
                            "name": "savedFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1c54fe404b07b4a4533c203ab6c68bf936d5a086953aa1a446da9bec5a0a67f5",
            "metadata": {},
            "name": "useSavedFiltersFetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fe3a083e2869e191$var$node.hash = "69a6cd0661c8d852b37f79d9513a1db0";
var $fe3a083e2869e191$export$2e2bcd8739ae039 = $fe3a083e2869e191$var$node;

});




parcelRegister("htYvv", function(module, exports) {
$parcel$export(module.exports, "TeamPicker", () => $9dc6d539132068b0$export$3529dc978be43e9d);
/* TeamPicker.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $fcq2N = parcelRequire("fcq2N");

var $bKMxc = parcelRequire("bKMxc");

var $2wmyf = parcelRequire("2wmyf");

var $kSWvv = parcelRequire("kSWvv");

var $2CZtS = parcelRequire("2CZtS");

var $cCE2Z = parcelRequire("cCE2Z");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $kt86l = parcelRequire("kt86l");
const $9dc6d539132068b0$var$placeholder = (0, $7eNDO.defineMessage)({
    id: "software-board-create.modal.form.source-value-picker.team-picker.placeholder",
    defaultMessage: "Select"
});
const $9dc6d539132068b0$var$TEAM_A11Y_LABEL_ID = 'software-board-create.source-value.team';
const $9dc6d539132068b0$export$3529dc978be43e9d = ({ onChange: onChange, value: value, isInvalid: isInvalid, label: label })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const cloudId = (0, $kt86l.useCloudId)();
    const handleOnCreate = (0, $euxye.useCallback)((team)=>{
        if (!team) return;
        // wait for the team to be created before updating the value
        setTimeout(()=>{
            onChange(team);
        }, 1000);
    }, [
        onChange
    ]);
    const [createTeamDialog, createTeamDialogTrigger] = (0, $bKMxc.useCreateTeamDialog)({
        onCreate: handleOnCreate
    });
    const handleChange = (team)=>{
        // oxlint-disable-next-line typescript/consistent-type-assertions
        onChange?.(team || null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9dc6d539132068b0$var$TeamPickerEditWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kSWvv.ScreenReaderText), {
        id: $9dc6d539132068b0$var$TEAM_A11Y_LABEL_ID
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2CZtS.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2wmyf.TeamPickerEdit), {
        siteId: cloudId,
        isCompact: false,
        hasNoTeamOption: false,
        createTeamDialogTrigger: createTeamDialogTrigger,
        placeholder: formatMessage($9dc6d539132068b0$var$placeholder),
        onChange: handleChange,
        defaultValue: value,
        isDropdownMenuFixedAndLayered: true,
        isInvalid: isInvalid,
        isClearable: false,
        "aria-labelledby": $9dc6d539132068b0$var$TEAM_A11Y_LABEL_ID
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: "board-create-team-create-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("form", {
        tabIndex: -1,
        name: "create-team-dialog-form",
        onSubmit: (e)=>{
            e.stopPropagation();
        },
        className: (0, $4jQY2.default)([
            "_1e0cglyw"
        ])
    }, createTeamDialog)));
};
$9dc6d539132068b0$export$3529dc978be43e9d.displayName = "TeamPicker";
const $9dc6d539132068b0$var$removeFormSpaceStyle = null; // TODO: remove this after select compiled migration
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $9dc6d539132068b0$var$TeamPickerEditWrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_b9cj1fu0 _t0z71fu0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bKMxc", function(module, exports) {
$parcel$export(module.exports, "useCreateTeamDialog", () => $0bff06cb49da6082$export$e8b8170429d616be);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $6zTYs = parcelRequire("6zTYs");

var $3LhWS = parcelRequire("3LhWS");

var $kFgCO = parcelRequire("kFgCO");

var $eVacJ = parcelRequire("eVacJ");

var $iQPOZ = parcelRequire("iQPOZ");

var $fw5T5 = parcelRequire("fw5T5");

var $e35Ix = parcelRequire("e35Ix");

var $j5bEH = parcelRequire("j5bEH");

var $1YIbA = parcelRequire("1YIbA");

var $a8EUd = parcelRequire("a8EUd");

var $eijVy = parcelRequire("eijVy");

var $i860n = parcelRequire("i860n");

var $gYZoW = parcelRequire("gYZoW");

var $l8G1z = parcelRequire("l8G1z");
const $0bff06cb49da6082$var$openInNewTab = (url)=>{
    if (typeof window !== 'undefined') window.open(url, '_blank');
};

const $0bff06cb49da6082$export$75096afde50756fd = (0, $l8G1z.lazy)(()=>(parcelRequire("M2KQ6")).then((module)=>module.TeamCreateDialog), {
    moduleId: "../platform/packages/people-and-teams/people-teams/src/index.ts"
});
const $0bff06cb49da6082$export$e8b8170429d616be = (t0)=>{
    const $ = (0, $e7boj.c)(27);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const props = t1;
    const { locale: locale } = (0, $1YIbA.default)();
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const [inputTeamName, setInputTeamName] = (0, $euxye.useState)("");
    const { showFlag: showFlag } = (0, $iQPOZ.useFlagsService)();
    const { handleAdditionalActionStart: handleAdditionalActionStart } = props;
    const tenantContext = (0, $eijVy.useTenantContext)();
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = tenantContext;
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    const { data: t2 } = (0, $kFgCO.useCurrentUser)();
    const { user: user } = t2;
    if (!atlassianAccountId && !user.accountId) throw new Error("Missing current user id");
    const navigateTo = $0bff06cb49da6082$var$_temp;
    let t3;
    if ($[2] !== showFlag) {
        t3 = (t4)=>{
            const { appearance: appearance, ...flagProps } = t4;
            if (appearance === "success" || appearance === "normal") showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e35Ix.default), {
                    messageId: "issue-field-create-team-dialog.ui.use-create-team-dialog.success-flag",
                    messageType: "transactional",
                    ...flagProps,
                    ...serviceProps
                }));
            if (appearance === "warning") showFlag((serviceProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j5bEH.default), {
                    messageId: "issue-field-create-team-dialog.ui.use-create-team-dialog.warning-flag",
                    messageType: "transactional",
                    ...flagProps,
                    ...serviceProps_0
                }));
            if (appearance === "error") showFlag((serviceProps_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fw5T5.default), {
                    messageId: "issue-field-create-team-dialog.ui.use-create-team-dialog.error-flag",
                    messageType: "transactional",
                    ...flagProps,
                    ...serviceProps_1
                }));
        };
        $[2] = showFlag;
        $[3] = t3;
    } else t3 = $[3];
    const addFlag = t3;
    let t4;
    if ($[4] !== props) {
        t4 = {
            onCancel: $0bff06cb49da6082$var$_temp2,
            ...props
        };
        $[4] = props;
        $[5] = t4;
    } else t4 = $[5];
    const { onCancel: onCancel } = t4;
    let t5;
    if ($[6] !== handleAdditionalActionStart) {
        t5 = (teamName)=>{
            setInputTeamName(teamName);
            setIsOpen(true);
            handleAdditionalActionStart?.();
        };
        $[6] = handleAdditionalActionStart;
        $[7] = t5;
    } else t5 = $[7];
    const callback = t5;
    let t6;
    if ($[8] !== onCancel) {
        t6 = ()=>{
            setIsOpen(false);
            onCancel();
        };
        $[8] = onCancel;
        $[9] = t6;
    } else t6 = $[9];
    const handleOnClose = t6;
    let t7;
    if ($[10] !== props) {
        t7 = (team)=>{
            const formattedTeam = {
                ...team,
                name: team.displayName
            };
            props.onCreate?.(formattedTeam);
        };
        $[10] = props;
        $[11] = t7;
    } else t7 = $[11];
    const handleOnCreate = t7;
    let t8;
    if ($[12] !== addFlag || $[13] !== atlassianAccountId || $[14] !== cloudId || $[15] !== handleOnClose || $[16] !== handleOnCreate || $[17] !== inputTeamName || $[18] !== isOpen || $[19] !== locale || $[20] !== orgId || $[21] !== props.analyticsCtx || $[22] !== user) {
        t8 = isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
            key: "team-create-dialog",
            name: "team-create-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gYZoW.PeopleAndTeamsConfigurationProvider), {
            product: "jira",
            locale: (0, $eVacJ.default)(locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0bff06cb49da6082$export$75096afde50756fd, {
            cloudId: cloudId,
            orgId: orgId,
            product: "jira",
            principalId: atlassianAccountId || user.accountId || "",
            onClose: handleOnClose,
            onCreateTeamSuccess: handleOnCreate,
            extraAnalyticsAttrs: props.analyticsCtx,
            enableMembershipSettingsChoice: true,
            currentUser: user.accountId ? {
                id: user.accountId,
                fullName: user.userFullname,
                avatarUrl: "avatarUrls" in user && user.avatarUrls && user.avatarUrls["48x48"] || undefined,
                email: "emailAddress" in user && user.emailAddress ? user.emailAddress : undefined,
                ...user
            } : undefined,
            prepopulatedFields: {
                teamName: inputTeamName
            },
            pushRoute: navigateTo,
            addFlag: addFlag,
            ...(0, $i860n.fg)("platform_create_work_item_modernization") ? {
                headingAs: "h1"
            } : {}
        }))) : null;
        $[12] = addFlag;
        $[13] = atlassianAccountId;
        $[14] = cloudId;
        $[15] = handleOnClose;
        $[16] = handleOnCreate;
        $[17] = inputTeamName;
        $[18] = isOpen;
        $[19] = locale;
        $[20] = orgId;
        $[21] = props.analyticsCtx;
        $[22] = user;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== callback || $[25] !== t8) {
        t9 = [
            t8,
            callback
        ];
        $[24] = callback;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
};
function $0bff06cb49da6082$var$_temp(url) {
    $0bff06cb49da6082$var$openInNewTab((0, $3LhWS.toTeamsAppURL)(url.replace("/jira", "")));
}
function $0bff06cb49da6082$var$_temp2() {
    return null;
}

});
parcelRegister("fw5T5", function(module, exports) {
$parcel$export(module.exports, "default", () => $75b6bf636f9c6e44$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3mYdc = parcelRequire("3mYdc");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$75b6bf636f9c6e44$export$2e2bcd8739ae039 = (0, $3mYdc.ErrorFlag);

});

parcelRegister("e35Ix", function(module, exports) {
$parcel$export(module.exports, "default", () => $6edf7f93b14acbe1$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3mYdc = parcelRequire("3mYdc");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$6edf7f93b14acbe1$export$2e2bcd8739ae039 = (0, $3mYdc.SuccessFlag);

});

parcelRegister("j5bEH", function(module, exports) {
$parcel$export(module.exports, "default", () => $36b702e001430bcd$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3mYdc = parcelRequire("3mYdc");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$36b702e001430bcd$export$2e2bcd8739ae039 = (0, $3mYdc.WarningFlag);

});

parcelRegister("gYZoW", function(module, exports) {
$parcel$export(module.exports, "PeopleAndTeamsConfigurationProvider", () => $938adaabd9103fcc$export$d3f5bd36d1c6597e);
$parcel$export(module.exports, "usePeopleAndTeamsConfigurationContext", () => $938adaabd9103fcc$export$130340d16a670190);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4mree = parcelRequire("4mree");

var $jgXhS = parcelRequire("jgXhS");

var $kIT1z = parcelRequire("kIT1z");

var $53T0l = parcelRequire("53T0l");
const $938adaabd9103fcc$export$8a37839ac1e08b25 = /*#__PURE__*/ (0, $euxye.createContext)((0, $kIT1z.DEFAULT_CONTEXT));
const $938adaabd9103fcc$export$3bf19eb896b777b8 = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, orgId: orgId, teamPermissionCheckEnabled: teamPermissionCheckEnabled = false })=>{
    const overrides = (0, $53T0l.usePeopleAndTeamsConfigurationOverrides)(teamPermissionCheckEnabled, orgId, teamPermissions);
    const artifact = (0, $jgXhS.usePeopleAndTeamsRemoteArtifact)(product, locale, overrides);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($938adaabd9103fcc$export$8a37839ac1e08b25.Provider, {
        value: artifact || (0, $kIT1z.DEFAULT_CONTEXT),
        children: children
    });
};
$938adaabd9103fcc$export$3bf19eb896b777b8.displayName = "PeopleAndTeamsBasicConfigurationProvider";
const $938adaabd9103fcc$export$d3f5bd36d1c6597e = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, teamPermissionCheckEnabled: teamPermissionCheckEnabled, orgId: orgId, ...flightDeckProps })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4mree.FlightDeckProvider), {
        product: product,
        ...flightDeckProps,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($938adaabd9103fcc$export$3bf19eb896b777b8, {
            locale: locale,
            product: product,
            teamPermissions: teamPermissions,
            teamPermissionCheckEnabled: teamPermissionCheckEnabled,
            orgId: orgId,
            children: children
        })
    });
};
$938adaabd9103fcc$export$d3f5bd36d1c6597e.displayName = "PeopleAndTeamsConfigurationProvider";
const $938adaabd9103fcc$export$130340d16a670190 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useContext($938adaabd9103fcc$export$8a37839ac1e08b25);

});
parcelRegister("4mree", function(module, exports) {
$parcel$export(module.exports, "FlightDeckProvider", () => $32ce5683d7cf088e$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "useFlightDeckContext", () => $32ce5683d7cf088e$export$73c96350a5e69ec);
$parcel$export(module.exports, "useFlightDeckArtifact", () => $32ce5683d7cf088e$export$3b241cde208d2c5e);

var $euxye = parcelRequire("euxye");

var $2ejVE = parcelRequire("2ejVE");
const $32ce5683d7cf088e$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createContext({
    getArtifact: null
});
function $32ce5683d7cf088e$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>{
        return new (0, $2ejVE.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            },
            expiryMS: config === null || config === void 0 ? void 0 : config.artifactExpiryMS
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($32ce5683d7cf088e$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $32ce5683d7cf088e$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useContext($32ce5683d7cf088e$export$ca1b33377afa620);
function $32ce5683d7cf088e$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useState();
    const { getArtifact: getArtifact } = $32ce5683d7cf088e$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}

});

parcelRegister("jgXhS", function(module, exports) {
$parcel$export(module.exports, "usePeopleAndTeamsRemoteArtifact", () => $9cb8337152794870$export$233293b7afb7b362);

var $euxye = parcelRequire("euxye");

var $4mree = parcelRequire("4mree");

var $bhBIJ = parcelRequire("bhBIJ");
const $9cb8337152794870$var$transformArtifactsWithOverrides = (artifact, overrideKeys)=>{
    if (!artifact?.overrides?.length || overrideKeys.length === 0) return artifact;
    return overrideKeys.reduce((acc, overrideKey)=>{
        return {
            ...acc,
            ...artifact.overrides && artifact.overrides.find((override)=>override.key === overrideKey)?.item || null
        };
    }, artifact);
};
const $9cb8337152794870$export$233293b7afb7b362 = (product, locale, overridesKeys)=>{
    const dimensions = (0, $euxye.useMemo)(()=>({
            ...(0, $bhBIJ.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        }), [
        locale
    ]);
    const artifact = (0, $4mree.useFlightDeckArtifact)((0, $bhBIJ.FD_CLIENT_FETCH_PROPS).name, dimensions);
    /**
	 * FlightDeck doesn't allow custom, a 'product', dimension so we must handle this ourselves.
	 * We can probably remove this memo once that functionality is available
	 */ return (0, $euxye.useMemo)(()=>{
        const productArtifact = artifact ? product in artifact['people-menu'] ? artifact['people-menu'][product] : artifact['people-menu'].default : null;
        return {
            ['people-menu']: $9cb8337152794870$var$transformArtifactsWithOverrides(productArtifact, overridesKeys ? overridesKeys['people-menu'] : [])
        };
    }, [
        artifact,
        product,
        overridesKeys
    ]);
};

});
parcelRegister("bhBIJ", function(module, exports) {
$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $6eeb811137c4d977$export$c270c412a04ff3e6);

var $l1vE2 = parcelRequire("l1vE2");
const $6eeb811137c4d977$export$953923d576277fd6 = 'people-and-teams-configuration-service';
const $6eeb811137c4d977$export$71f196808ce40e60 = 'prod';
const $6eeb811137c4d977$export$6392ca3738ed1e9 = 'fedramp-moderate';
const $6eeb811137c4d977$export$e836203c1e95eac3 = 'commercial';
const $6eeb811137c4d977$export$c270c412a04ff3e6 = {
    name: $6eeb811137c4d977$export$953923d576277fd6,
    dimensions: {
        environmentType: $6eeb811137c4d977$export$71f196808ce40e60,
        perimeter: (0, $l1vE2.isFedRamp)() ? $6eeb811137c4d977$export$6392ca3738ed1e9 : $6eeb811137c4d977$export$e836203c1e95eac3
    }
};

});


parcelRegister("kIT1z", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $76674261bcdbb1b2$export$9c542858adf7dcd0);
const $76674261bcdbb1b2$export$9c542858adf7dcd0 = {
    ['people-menu']: null
};

});

parcelRegister("53T0l", function(module, exports) {
$parcel$export(module.exports, "usePeopleAndTeamsConfigurationOverrides", () => $6fbac658e10134cf$export$66d7d96ce076bcd6);

var $5Q8dB = parcelRequire("5Q8dB");

var $hXmqP = parcelRequire("hXmqP");
const $6fbac658e10134cf$export$66d7d96ce076bcd6 = (teamPermissionCheckEnabled, orgId, teamPermissionsProps)=>{
    const { permissions: teamPermissionsFromHook } = (0, $5Q8dB.useTeamsPermissionsService)(orgId, {
        enabled: teamPermissionCheckEnabled && !teamPermissionsProps
    });
    const teamPermissions = teamPermissionsProps || teamPermissionsFromHook;
    return {
        'people-menu': [
            ...!teamPermissions?.canCreateTeams ? [
                (0, $hXmqP.PeopleMenuOverrides).createTeamsDisabled
            ] : [],
            ...!teamPermissions?.canViewTeams ? [
                (0, $hXmqP.PeopleMenuOverrides).viewTeamsDisabled
            ] : []
        ]
    };
};

});
parcelRegister("5Q8dB", function(module, exports) {
$parcel$export(module.exports, "useTeamsPermissionsService", () => $acbfe789daf4a058$export$b24dcbe1ec677a8);

var $euxye = parcelRequire("euxye");

var $knogv = parcelRequire("knogv");

var $6I2Pe = parcelRequire("6I2Pe");
const $acbfe789daf4a058$export$b24dcbe1ec677a8 = (scope, { enabled: enabled, attributes: attributes } = {
    enabled: false,
    attributes: {}
})=>{
    // backwards compatibility allow orgId to be passed as a string
    const { orgId: orgId, cloudId: cloudId } = typeof scope === 'string' || !scope ? {
        orgId: scope,
        cloudId: undefined
    } : scope;
    const [state, { getPermissions: getPermissions }] = (0, $6I2Pe.useTeamsPermissionsStore)();
    const { fireEvent: fireEvent } = (0, $knogv.useAnalyticsEvents)();
    const fetchData = (0, $euxye.useCallback)(async ()=>{
        getPermissions({
            orgId: orgId,
            cloudId: cloudId,
            enabled: enabled
        }, {
            onFetch: ()=>{
                // @ts-expect-error - hyphenated event names are not supported in the analytics spec
                fireEvent('operational.use-team-permissions.fetched', {
                    userId: attributes?.userId,
                    orgId: orgId,
                    cloudId: cloudId
                });
            }
        });
    }, [
        orgId,
        cloudId,
        enabled,
        getPermissions,
        attributes?.userId,
        fireEvent
    ]);
    (0, $euxye.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissionsResponse,
        error: state.error,
        ...state
    };
};

});
parcelRegister("knogv", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $e6ae37f37ce3e818$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::8fac3764027ac11183c7483636135d9a>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen teams-app-internal-analytics
 */ 
var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");


var $hdpuB = parcelRequire("hdpuB");
const $e6ae37f37ce3e818$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireEvent = (0, $euxye.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $hdpuB.default)(...params));
        event.fire((0, $e565d78ac1c084ee$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $e565d78ac1c084ee$export$3f072f06b90c3985 = 'peopleTeams';

parcelRegister("hdpuB", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c314bbc1a715803$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::d33f3d33520a5e35881ec61f3c089abb>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen teams-app-internal-analytics
 */ const $5c314bbc1a715803$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $5c314bbc1a715803$export$2e2bcd8739ae039 = $5c314bbc1a715803$var$createEventPayload;

});


parcelRegister("6I2Pe", function(module, exports) {
$parcel$export(module.exports, "useTeamsPermissionsStore", () => $411fa60c02054f39$export$4e7a1c55cba5a168);

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $8EKfm = parcelRequire("8EKfm");
var $7M3zm = parcelRequire("7M3zm");

var $eFLEa = parcelRequire("eFLEa");
const $411fa60c02054f39$var$actions = {
    getPermissions: ({ orgId: orgId, cloudId: cloudId, enabled: enabled }, { onFetch: onFetch })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading } = getState();
            if (hasLoaded || isLoading || !enabled || !orgId || !cloudId) return;
            try {
                setState({
                    isLoading: true
                });
                (0, $7M3zm.teamsClient).setContext({
                    orgId: orgId,
                    cloudId: cloudId
                });
                const response = await (0, $7M3zm.teamsClient).getPermissions();
                dispatch($411fa60c02054f39$var$actions.setPermissions(response.permissions));
                onFetch?.();
            } catch (error) {
                dispatch($411fa60c02054f39$var$actions.setError(error instanceof (0, $8EKfm.HttpError) ? error : new Error('Failed to fetch permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: (0, $eFLEa.transformPermissions)(permissions),
                permissionsResponse: {
                    permissions: permissions
                }
            });
        }
};
const $411fa60c02054f39$var$Store = (0, $5QDqc.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {
            canCreateTeams: true,
            canViewTeams: true,
            canAdminTeams: false
        }
    },
    actions: $411fa60c02054f39$var$actions,
    name: 'teams-permissions'
});
const $411fa60c02054f39$export$4e7a1c55cba5a168 = (0, $3h1FP.createHook)($411fa60c02054f39$var$Store);

});
parcelRegister("8EKfm", function(module, exports) {
$parcel$export(module.exports, "StatusCode", () => $185299df2291f94b$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $185299df2291f94b$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $185299df2291f94b$export$9677d7c364ada66c);
$parcel$export(module.exports, "DefaultError", () => $185299df2291f94b$export$c73ca302efeda3b4);
$parcel$export(module.exports, "SLOIgnoreError", () => $185299df2291f94b$export$d87f401f8106d7a2);
$parcel$export(module.exports, "HttpError", () => $185299df2291f94b$export$65bd6083489bd8bb);
$parcel$export(module.exports, "SLOIgnoreHttpError", () => $185299df2291f94b$export$826a3d65b8435adf);
$parcel$export(module.exports, "GraphQLError", () => $185299df2291f94b$export$92d6ed0888e7cb7f);
$parcel$export(module.exports, "isNetworkError", () => $185299df2291f94b$export$476aa014e2fd89d5);
var $185299df2291f94b$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
var $185299df2291f94b$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $185299df2291f94b$export$cde1786a482f9a1c(error) {
    return $185299df2291f94b$export$9677d7c364ada66c(401, error) || $185299df2291f94b$export$9677d7c364ada66c(403, error);
}
function $185299df2291f94b$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}
function $185299df2291f94b$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
var $185299df2291f94b$export$c33cd4757598521c = /*#__PURE__*/ function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    return TeamErrorType;
}({});
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $185299df2291f94b$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message || 'UnknownError';
        this.stack = new Error(message).stack || '';
    }
}
class $185299df2291f94b$export$c73ca302efeda3b4 extends $185299df2291f94b$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $185299df2291f94b$export$c73ca302efeda3b4.prototype);
    }
}
class $185299df2291f94b$export$d87f401f8106d7a2 extends $185299df2291f94b$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $185299df2291f94b$export$d87f401f8106d7a2.prototype);
    }
}
class $185299df2291f94b$export$65bd6083489bd8bb extends $185299df2291f94b$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId, path: path }){
        super(message);
        Object.setPrototypeOf(this, $185299df2291f94b$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
        this.path = path;
    }
}
class $185299df2291f94b$export$826a3d65b8435adf extends $185299df2291f94b$export$65bd6083489bd8bb {
    constructor(props){
        super(props);
        Object.setPrototypeOf(this, $185299df2291f94b$export$826a3d65b8435adf.prototype);
    }
}
class $185299df2291f94b$export$92d6ed0888e7cb7f extends $185299df2291f94b$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $185299df2291f94b$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $185299df2291f94b$export$92d6ed0888e7cb7f(errorData);
        };
    }
}
function $185299df2291f94b$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}

});

parcelRegister("7M3zm", function(module, exports) {
$parcel$export(module.exports, "teamsClient", () => $741ccbf353ac9a1d$export$5ed932c3646b89c6);

var $64jqu = parcelRequire("64jqu");

var $gMOu4 = parcelRequire("gMOu4");

var $laiix = parcelRequire("laiix");

var $i3m7i = parcelRequire("i3m7i");

var $7TN9i = parcelRequire("7TN9i");

var $dRLvv = parcelRequire("dRLvv");

var $3Lo3f = parcelRequire("3Lo3f");

var $awdTv = parcelRequire("awdTv");

var $gSw7z = parcelRequire("gSw7z");

var $gOYld = parcelRequire("gOYld");

var $bFgTl = parcelRequire("bFgTl");

var $17Zgd = parcelRequire("17Zgd");

var $3D4pj = parcelRequire("3D4pj");

var $j6Q5F = parcelRequire("j6Q5F");

var $h35fJ = parcelRequire("h35fJ");

var $aR6cl = parcelRequire("aR6cl");
class $741ccbf353ac9a1d$export$db59823f35bf78ce {
    constructor(/**
		 * @param {ClientContextProps} context - Context including CloudId & OrgId to be used for all requests
		 */ context){
        this._aggClient = (0, $gMOu4.aggClient);
        this._directoryClient = (0, $i3m7i.directoryClient);
        this._legionClient = (0, $3Lo3f.defaultLegionClient);
        this._mutabilityClient = (0, $awdTv.default);
        this._permsClient = (0, $gOYld.default);
        this._publicApiClient = (0, $bFgTl.default);
        this._invitationsClient = (0, $dRLvv.default);
        this._userPreferencesClient = (0, $aR6cl.default);
        this._objectResolverClient = (0, $gSw7z.default);
        this._teamsInSlackClient = (0, $h35fJ.default);
        this._collaborationGraphClient = (0, $laiix.default);
        this._identityClient = (0, $7TN9i.default);
        this._teamCentralClient = (0, $j6Q5F.default);
        this._replinesClient = (0, $17Zgd.default);
        this._reportingLinesClient = (0, $3D4pj.default);
        if (context) this.setContext(context);
    }
    async measurePerformance(name, fn) {
        const exp = (0, $64jqu.TEAMS_CLIENT_EXPERIENCES).get(name);
        if (!exp) return fn();
        exp.start();
        try {
            const result = await fn();
            exp.success();
            return result;
        } catch (e) {
            exp.failWithError(e);
            throw e;
        }
    }
    /**
	 * Sets the base URL to be used in the client requests
	 * @param {string} baseUrl - The new base URL
	 */ setBaseUrl(baseUrl) {
        this._aggClient.setBaseUrl(baseUrl);
        this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Sets context including CloudId & OrgId to be used for all requests
	 */ setContext(context) {
        this._aggClient.setContext(context);
        this._directoryClient.setContext(context);
        this._legionClient.setContext(context);
        this._permsClient.setContext(context);
        this._mutabilityClient.setContext(context);
        this._publicApiClient.setContext(context);
        this._invitationsClient.setContext(context);
        this._replinesClient.setContext(context);
    }
    setTeamCentralContext(baseUrl, context) {
        this._teamCentralClient.setContext(context);
        this._teamCentralClient.setBaseUrl(baseUrl);
    }
    /**
	 * @private
	 * @deprecated use setBaseUrl instead
	 */ setDirectoryBaseUrl(baseUrl) {
        // eslint-disable-next-line no-console
        console.warn('setDirectoryBaseUrl is deprecated, use setBaseUrl instead');
        return this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Fetches Browse user settings
	 */ async querySettings(cloudId, product) {
        if (cloudId) {
            const previousContext = this._legionClient.getContext();
            this.setContext({
                ...previousContext,
                cloudId: cloudId
            });
        }
        return this.measurePerformance('querySettings', async ()=>{
            if (!product) throw new Error('Product is required');
            const response = await this._legionClient.retrieveBrowseUserPermission(product);
            return {
                'internal.browse-users-allowed': response.canSearchUsers
            };
        });
    }
    /**
	 * This will return all of the teams-related permissions that your user has for the org and site in the client context.
	 */ async getPermissions() {
        return this.measurePerformance('getPermissions', ()=>this._legionClient.getPermissions());
    }
    /**
	 * Fetches feature flags from Directory
	 * @deprecated As part of decommisioning pf-directoy
	 */ async queryFeatureFlags(...args) {
        return this.measurePerformance('queryFeatureFlags', ()=>this._directoryClient.queryFeatureFlags(...args));
    }
    /**
	 * Get user information of members of a team, paginated
	 * @param {string} teamId
	 * @returns {Promise}
	 */ async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        return this._aggClient.queryTeamMemberships(teamId, membershipState, pageInfo);
    }
    /**
	 * Get user information given an user id
	 * @param {string} userId
	 * @returns {Promise}
	 */ async queryAGGUser(userId) {
        return this._aggClient.queryAGGUser(userId);
    }
    /**
	 * Get the agents associated with the team
	 * @param {string} userId
	 * @returns {Promise}
	 */ async queryTeamHasAgents(teamId) {
        return this._aggClient.queryTeamHasAgents(teamId);
    }
    /**
	 * Get containers associated with the team
	 * @param {string} teamId
	 * @returns {Promise<TeamContainers>}
	 */ async getTeamContainers(teamId) {
        return this._aggClient.getTeamContainers(teamId);
    }
    /**
	 * Unlink a container from a team
	 * @param {string} teamId
	 * @param {string} containerId
	 * @returns {Promise}
	 */ async unlinkTeamContainer(teamId, containerId) {
        return this._aggClient.unlinkTeamContainer(teamId, containerId);
    }
    /**
	 * Get the number of teams connected to a container
	 * @param {string} containerId
	 * @returns {Promise<number>}
	 */ async queryNumberOfTeamConnectedToContainer(containerId) {
        return this._aggClient.queryNumberOfTeamConnectedToContainer(containerId);
    }
    /**
	 * Get the number of teams connected to a container (Confluence space or Jira project)
	 * @param {string} containerId
	 * @returns {Promise<number>}
	 */ async getNumberOfConnectedTeams(containerId) {
        return this.queryNumberOfTeamConnectedToContainer(containerId);
    }
    /**
	 * Get teams connected to a container
	 * @param {string} containerId
	 * @returns {Promise<TeamWithMemberships[]>}
	 */ async queryTeamsConnectedToContainer(containerId) {
        return this._aggClient.queryTeamsConnectedToContainer(containerId);
    }
    /**
	 * Get teams connected to a container (Confluence space or Jira project)
	 * @param {string} containerId
	 * @returns {Promise<TeamWithMemberships[]>}
	 */ async getConnectedTeams(containerId) {
        return this.queryTeamsConnectedToContainer(containerId);
    }
    /**
	 * Get user information of a member of a team
	 * @param {string} userId
	 * @returns {Promise<CloudUser>}
	 */ queryUser(...args) {
        return this.measurePerformance('queryUser', ()=>this._directoryClient.queryUser(...args));
    }
    setLegionRootUrl(url) {
        return this._legionClient.setRootUrl(url);
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<TeamWithImageUrls>}
	 */ async getTeamById(teamId, cloudId) {
        return this.measurePerformance('getTeamById', ()=>this._legionClient.getTeamById(teamId, cloudId));
    }
    /**
	 * Search teams based on query
	 */ async getAllTeams(...args) {
        return this.measurePerformance('getAllTeams', ()=>this._legionClient.getAllTeams(...args));
    }
    /**
	 * Update team details
	 */ async updateTeamById(...args) {
        return this.measurePerformance('updateTeamById', ()=>this._legionClient.updateTeamById(...args));
    }
    /**
	 * @private
	 * @deprecated use addUsersToTeam instead
	 */ async inviteUsersToTeam(...args) {
        return this.measurePerformance('inviteUsersToTeam', ()=>this._legionClient.inviteUsersToTeam(...args));
    }
    /**
	 * Get the current user's team membership
	 */ async getMyTeamMembership(...args) {
        return this.measurePerformance('getMyTeamMembership', ()=>this._legionClient.getMyTeamMembership(...args));
    }
    /**
	 * Get a teams "Links"
	 */ async getTeamLinksByTeamId(teamId) {
        return this.measurePerformance('getTeamLinksByTeamId', ()=>this._legionClient.getTeamLinksByTeamId(teamId));
    }
    /**
	 * Create a team link
	 */ async createTeamLink(...args) {
        return this.measurePerformance('createTeamLink', ()=>this._legionClient.createTeamLink(...args));
    }
    /**
	 * Update a team link
	 */ async updateTeamLink(...args) {
        return this.measurePerformance('updateTeamLink', ()=>this._legionClient.updateTeamLink(...args));
    }
    /**
	 * Delete a team link
	 */ async deleteTeamLink(...args) {
        return this.measurePerformance('deleteTeamLink', ()=>this._legionClient.deleteTeamLink(...args));
    }
    /**
	 * Reorder a team link
	 */ async reorderTeamLink(...args) {
        return this.measurePerformance('reorderTeamLink', ()=>this._legionClient.reorderTeamLink(...args));
    }
    /**
	 * Get org's eligibility for managed teams
	 */ async getOrgEligibilityForManagedTeams() {
        return this.measurePerformance('getOrgEligibilityForManagedTeams', ()=>this._legionClient.getOrgEligibilityForManagedTeams());
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Accept a team invitation
	 */ async acceptTeamInvitation(...args) {
        return this.measurePerformance('acceptTeamInvitation', ()=>this._legionClient.acceptTeamInvitation(...args));
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Decline a team invitation
	 */ async declineTeamInvitation(...args) {
        return this.measurePerformance('declineTeamInvitation', ()=>this._legionClient.declineTeamInvitation(...args));
    }
    /**
	 * Add current user to a team
	 */ async selfJoinTeam(...args) {
        return this.measurePerformance('selfJoinTeam', ()=>this._legionClient.selfJoinTeam(...args));
    }
    /**
	 * Add agent to a team
	 */ async addAgentsToTeam(...args) {
        return this.measurePerformance('addAgentToTeam', ()=>this._legionClient.addAgentsToTeam(...args));
    }
    async removeAgentTeamAssociation(...args) {
        return this.measurePerformance('removeAgentTeamAssociation', ()=>this._legionClient.removeAgentTeamAssociation(...args));
    }
    /**
	 * Cancel a join request to a private team
	 */ async cancelJoinRequest(teamId) {
        return this.measurePerformance('cancelJoinRequest', ()=>this._legionClient.cancelJoinRequest(teamId));
    }
    /**
	 * Accept a join request to a private team
	 */ async acceptJoinRequest(...args) {
        return this.measurePerformance('acceptJoinRequest', ()=>this._legionClient.acceptJoinRequest(...args));
    }
    /**
	 * Decline a join request to a private team
	 */ async declineJoinRequest(...args) {
        return this.measurePerformance('declineJoinRequest', ()=>this._legionClient.declineJoinRequest(...args));
    }
    /**
	 * @deprecated use removeTeamMemberships instead
	 */ async deleteTeamMembership(...args) {
        return this.measurePerformance('deleteTeamMembership', ()=>this._legionClient.deleteTeamMembership(...args));
    }
    /**
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(...args) {
        return this.measurePerformance('revokeTeamInvite', ()=>this._legionClient.revokeTeamInvite(...args));
    }
    /**
	 * Delete a team
	 */ async deleteTeam(teamId) {
        return this.measurePerformance('deleteTeam', ()=>this._legionClient.deleteTeam(teamId));
    }
    /**
	 * Archive a team
	 */ async archiveTeam(teamId) {
        return this.measurePerformance('archiveTeam', ()=>this._legionClient.archiveTeam(teamId));
    }
    /**
	 * Unarchive a team
	 */ async unarchiveTeam(teamId) {
        return this.measurePerformance('unarchiveTeam', ()=>this._legionClient.unArchiveTeam(teamId));
    }
    /**
	 * Unlink a team from group
	 */ async unlinkTeamFromGroup(teamId) {
        return this.measurePerformance('unlinkTeamFromGroup', ()=>this._legionClient.unlinkTeamFromGroup(teamId, 'MEMBER_INVITE'));
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        return this._legionClient.isSingleFullMemberTeam(teamId);
    }
    /**
	 * Create a team
	 */ async createTeam(...args) {
        return this.measurePerformance('createTeam', ()=>this._legionClient.createTeam(...args));
    }
    /**
	 * Create containers for a team
	 */ async createTeamContainers(...args) {
        return this.measurePerformance('createTeamContainers', ()=>this._legionClient.createTeamContainers(...args));
    }
    /**
	 * Create a external team
	 * @param {string} groupDescription - The description of the group, which will be used as the team description. The group name will be fetched from the identity service, so it does not need to be provided.
	 * @param {ExternalReference} externalReference
	 */ async createExternalTeam(...args) {
        return this.measurePerformance('createExternalTeam', ()=>this._legionClient.createExternalTeam(...args));
    }
    /**
	 * Get linked teams for a groups in bulk
	 * @param {string} groupIds - The group ids to fetch linked teams for
	 */ async getLinkedTeamsBulk(...args) {
        return this.measurePerformance('getLinkedTeamsBulk', ()=>this._legionClient.getLinkedTeamsBulk(...args));
    }
    /**
	 * Get Org scope
	 */ async getOrgScope(...args) {
        return this.measurePerformance('getOrgScope', ()=>this._legionClient.getOrgScope(...args));
    }
    /**
	 * Restore soft-deleted team and sync to group
	 */ async restoreTeamToSyncedGroup(...args) {
        return this.measurePerformance('restoreTeamToSyncedGroup', ()=>this._legionClient.restoreTeamToSyncedGroup(...args));
    }
    /**
	 * Get the difference between a team and a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 * @returns {Promise<TeamAndGroupDifference>}
	 */ async getTeamAndGroupDiff(...args) {
        return this.measurePerformance('getTeamAndGroupDiff', ()=>this._legionClient.getTeamAndGroupDiff(...args));
    }
    /**
	 * Link an existing team to a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 */ async linkExistingTeamToGroup(...args) {
        return this.measurePerformance('linkExistingTeamToGroup', ()=>this._legionClient.linkExistingTeamToGroup(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<LinkedTeamsProfileDetails>}
	 */ async getTeamProfileDetailsByTeamId(...args) {
        return this.measurePerformance('getTeamProfileDetails', ()=>this._legionClient.getTeamProfileDetails(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getSoftDeletdTeamById(teamId) {
        return this.measurePerformance('getSoftDeletedTeamById', ()=>this._legionClient.getSoftDeletedTeamById(teamId));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 * @param userId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getUserInSiteUserBase(userId) {
        return this.measurePerformance('getUserInSiteUserBase', ()=>this._legionClient.getUserInSiteUserBase(userId));
    }
    trimTeamARI(teamId = '') {
        return this._legionClient.trimTeamARI(teamId);
    }
    /**
	 * Get user profile with mutability constraints
	 */ async getProfileWithMutability(...args) {
        return this.measurePerformance('getProfileWithMutability', ()=>this._mutabilityClient.getProfileWithMutability(...args));
    }
    /**
	 * Get enabled sites for a team
	 */ async getTeamEnabledSites(...args) {
        return this.measurePerformance('getTeamEnabledSites', ()=>this._legionClient.getTeamEnabledSites(...args));
    }
    /**
	 * Assign teams to sites
	 * @param migrations
	 * @returns {Promise<AssignTeamsToSitesResponse>}
	 */ async assignTeamsToSites(...args) {
        return this.measurePerformance('assignTeamsToSites', ()=>this._legionClient.assignTeamsToSites(...args));
    }
    /**
	 * Get assigned teams
	 * @param orgId
	 * @param cursor
	 * @param displayNameContains
	 * @param count - number of teams to return
	 */ async getAssignedTeams(...args) {
        return this.measurePerformance('getAssignedTeams', ()=>this._legionClient.getAssignedTeams(...args));
    }
    /**
	 * Get unassigned teams
	 * @param orgId
	 * @param count - number of teams to return
	 * @param cursor - cursor to the next page of results
	 * @param query - query to filter teams by
	 */ async getUnassignedTeams(...args) {
        return this.measurePerformance('getUnassignedTeams', ()=>this._legionClient.getUnassignedTeams(...args));
    }
    /**
	 * Set team site assignment permission
	 * @param orgId
	 * @param alignmentPermission - 'ALL_USERS' | 'ORG_ADMIN'
	 */ async setTeamSiteAssignmentPermission(...args) {
        return this.measurePerformance('setTeamSiteAssignmentPermission', ()=>this._legionClient.setTeamSiteAssignmentPermission(...args));
    }
    /**
	 * Get team site assignment org details
	 */ async getTeamSiteAssignmentOrgDetails(...args) {
        return this.measurePerformance('getTeamSiteAssignmentOrgDetails', ()=>this._legionClient.getTeamSiteAssignmentOrgDetails(...args));
    }
    /**
	 * Get teams to be cloned to JSM sites
	 */ async getTeamsToBeClonedToJsmSites(...args) {
        return this.measurePerformance('getTeamsToBeClonedToJsmSites', ()=>this._legionClient.getTeamsToBeClonedToJsmSites(...args));
    }
    /**
	 * Is the current user a site admin
	 */ getIsSiteAdmin(...args) {
        return this.measurePerformance('getIsSiteAdmin', ()=>this._permsClient.getIsSiteAdmin(...args));
    }
    /**
	 * Add users to a team
	 */ addUsersToTeam(...args) {
        return this.measurePerformance('addUsersToTeam', ()=>this._publicApiClient.addUsersToTeam(...args));
    }
    /**
	 * Remove users from a team
	 */ removeTeamMemberships(...args) {
        return this.measurePerformance('removeTeamMemberships', ()=>this._publicApiClient.removeTeamMemberships(...args));
    }
    /**
	 * Restore a deleted team
	 */ restoreTeam(...args) {
        return this.measurePerformance('restoreTeam', ()=>this._publicApiClient.restoreTeam(...args));
    }
    getRecommendedProducts(...args) {
        return this.measurePerformance('getRecommendedProducts', ()=>this._invitationsClient.getProductRecommendations(...args));
    }
    joinOrRequestDefaultAccessToProductsBulk(...args) {
        return this.measurePerformance('joinOrRequestDefaultAccessToProductsBulk', ()=>this._invitationsClient.joinOrRequestDefaultAccessToProductsBulk(...args));
    }
    /**
	 * Get token to upload media for a team
	 */ async getWriteTeamMediaToken() {
        return this.measurePerformance('getWriteTeamMediaToken', ()=>this._legionClient.getWriteMediaToken());
    }
    /**
	 * Get token to read media for a user
	 */ async getReadMediaToken(...args) {
        return this.measurePerformance('getReadMediaToken', ()=>this._userPreferencesClient.getReadMediaToken(...args));
    }
    /**
	 * Get token to upload media for a user
	 */ async getWriteUserMediaToken() {
        return this.measurePerformance('getWriteUserMediaToken', ()=>this._userPreferencesClient.getWriteMediaToken());
    }
    /**
	 * Update header image for a user
	 */ async updateUserHeaderImage(headerImageId) {
        return this.measurePerformance('updateUserHeaderImage', ()=>this._userPreferencesClient.updateUserHeaderImage(headerImageId));
    }
    /**
	 * Fetch user containers from collboration graph
	 */ async getUserContainers(...args) {
        return this.measurePerformance('getUserContainers', ()=>this._collaborationGraphClient.getUserContainers(...args));
    }
    /**
	 * Fetch recommended users from collaboration graph
	 */ async getRecommendedUsers(...args) {
        return this.measurePerformance('getRecommendedUsers', ()=>this._collaborationGraphClient.getRecommendedUsers(...args));
    }
    /**
	 * Fetch mutatability of external managed user fields
	 */ async getUserManageConfig(...args) {
        return this.measurePerformance('getUserManageConfig', ()=>this._identityClient.getUserManageConfig(...args));
    }
    /**
	 * Fetch user avatar uploaded status
	 */ async getMyAvatarUploadedStatus(...args) {
        return this.measurePerformance('getMyAvatarUploadedStatus', ()=>this._identityClient.getMyAvatarUploadedStatus(...args));
    }
    /**
	 * Delete user avatar
	 */ async deleteAvatar(...args) {
        return this.measurePerformance('deleteUserAvatar', ()=>this._identityClient.deleteAvatar(...args));
    }
    async fetchUserAvatarInfo(...args) {
        return this.measurePerformance('fetchUserAvatarInfo', ()=>this._identityClient.fetchUserAvatarInfo(...args));
    }
    /**
	 * Fetch Team link icons
	 */ async getTeamLinkIcons(...args) {
        return this.measurePerformance('getTeamLinkIcons', ()=>this._objectResolverClient.getTeamLinkIcons(...args));
    }
    /**
	 * Fetch ARI from URL
	 */ async getAriFromUrl(...args) {
        return this.measurePerformance('getAriFromUrl', ()=>this._objectResolverClient.getAriFromUrl(...args));
    }
    /**
	 * Fetch web link title
	 */ async getWebLinkTitle(...args) {
        return this.measurePerformance('getWebLinkTitle', ()=>this._objectResolverClient.getWebLinkTitle(...args));
    }
    /**
	 * Fetch team in slack details
	 */ async getTeamInSlack(...args) {
        return this.measurePerformance('getTeamInSlack', ()=>this._teamsInSlackClient.getTeamInSlack(...args));
    }
    /**
	 * Delete team in slack
	 */ async disconnectTeamInSlack(...args) {
        return this.measurePerformance('disconnectTeamInSlack', ()=>this._teamsInSlackClient.disconnectTeamInSlack(...args));
    }
    /**
	 * Update team in slack
	 */ async updateTeamInSlack(...args) {
        return this.measurePerformance('updateTeamInSlack', ()=>this._teamsInSlackClient.updateTeamInSlack(...args));
    }
    /**
	 * Update user details
	 */ async updateUser(...args) {
        return this.measurePerformance('updateUser', ()=>this._identityClient.updateUser(...args));
    }
    async updateUserAvatar(...args) {
        return this.measurePerformance('updateUserAvatar', ()=>this._identityClient.updateUserAvatar(...args));
    }
    async addTeamWatcher(...args) {
        return this._teamCentralClient.addTeamWatcher(...args);
    }
    async isTeamWatcher(...args) {
        return this._teamCentralClient.isTeamWatcher(...args);
    }
    async removeTeamWatcher(...args) {
        return this._teamCentralClient.removeTeamWatcher(...args);
    }
    async deleteKudos(...args) {
        return this._teamCentralClient.deleteKudos(...args);
    }
    async queryTagList(...args) {
        return this._teamCentralClient.queryTagList(...args);
    }
    async createTag(...args) {
        return this._teamCentralClient.createTag(...args);
    }
    async createHelpPointer(...args) {
        return this._teamCentralClient.createHelpPointer(...args);
    }
    async updateHelpPointer(...args) {
        return this._teamCentralClient.updateHelpPointer(...args);
    }
    async deleteHelpPointer(...args) {
        return this._teamCentralClient.deleteHelpPointer(...args);
    }
    async getUserTenure(...args) {
        return this.measurePerformance('getUserTenure', ()=>this._replinesClient.getUserTenure(...args));
    }
    async checkOrgFullAlignmentStatus(...args) {
        return this._legionClient.checkOrgFullAlignmentStatus(...args);
    }
    async getTeamStatesInBulk(...args) {
        return this._legionClient.getTeamStatesInBulk(...args);
    }
    async getReportingLines(...args) {
        return this.measurePerformance('getReportingLines', ()=>this._reportingLinesClient.getReportingLines(...args));
    }
}
const $741ccbf353ac9a1d$export$5ed932c3646b89c6 = new $741ccbf353ac9a1d$export$db59823f35bf78ce();

});
parcelRegister("64jqu", function(module, exports) {
$parcel$export(module.exports, "TEAMS_CLIENT_EXPERIENCES", () => $08737bd23d07c313$export$879344107b04120c);

var $3nsUD = parcelRequire("3nsUD");

var $k6APU = parcelRequire("k6APU");
const $08737bd23d07c313$var$TeamsClientExperienceKeyList = [
    'getAllTeams',
    'getTeamById',
    'updateTeamById',
    'querySettings',
    'queryFeatureFlags',
    'queryTeamMemberships',
    'queryUser',
    'inviteUsersToTeam',
    'getMyTeamMembership',
    'getTeamLinksByTeamId',
    'createTeamLink',
    'updateTeamLink',
    'deleteTeamLink',
    'reorderTeamLink',
    'acceptTeamInvitation',
    'declineTeamInvitation',
    'selfJoinTeam',
    'cancelJoinRequest',
    'acceptJoinRequest',
    'declineJoinRequest',
    'deleteTeamMembership',
    'revokeTeamInvite',
    'deleteTeam',
    'archiveTeam',
    'unarchiveTeam',
    'unlinkTeamFromGroup',
    'isSingleFullMemberTeam',
    'createTeam',
    'createTeamContainers',
    'createExternalTeam',
    'getProfileWithMutability',
    'getIsSiteAdmin',
    'addUsersToTeam',
    'removeTeamMemberships',
    'getRecommendedProducts',
    'joinOrRequestDefaultAccessToProductsBulk',
    'getReadMediaToken',
    'getWriteUserMediaToken',
    'updateUserHeaderImage',
    'getWriteTeamMediaToken',
    'getSoftDeletedTeamById',
    'restoreTeam',
    'getUserInSiteUserBase',
    'getLinkedTeamsBulk',
    'getTeamProfileDetails',
    'getUserContainers',
    'getRecommendedUsers',
    'getPermissions',
    'getUserManageConfig',
    'getMyAvatarUploadedStatus',
    'deleteUserAvatar',
    'getTeamLinkIcons',
    'getTeamInSlack',
    'getOrgScope',
    'restoreTeamToSyncedGroup',
    'getTeamAndGroupDiff',
    'linkExistingTeamToGroup',
    'fetchUserAvatarInfo',
    'getOrgEligibilityForManagedTeams',
    'updateUser',
    'updateUserAvatar',
    'disconnectTeamInSlack',
    'updateTeamInSlack',
    'getUserTenure',
    'getAriFromUrl',
    'getWebLinkTitle',
    'addAgentToTeam',
    'getTeamEnabledSites',
    'assignTeamsToSites',
    'removeAgentTeamAssociation',
    'getAssignedTeams',
    'setTeamSiteAssignmentPermission',
    'getUnassignedTeams',
    'getTeamSiteAssignmentOrgDetails',
    'getTeamsToBeClonedToJsmSites',
    'getReportingLines'
];
const $08737bd23d07c313$export$879344107b04120c = new Map([
    ...$08737bd23d07c313$var$TeamsClientExperienceKeyList.map((key)=>[
            key,
            // camelCase to kebab-case
            new (0, $k6APU.TeamsUFOExperience)(`teams-client-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`, {
                type: (0, $3nsUD.ExperienceTypes).Operation,
                performanceType: (0, $3nsUD.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'people'
                }
            })
        ])
]);

});
parcelRegister("k6APU", function(module, exports) {
$parcel$export(module.exports, "TeamsUFOExperience", () => $10770b7fd73f22a8$export$9a18529d1e90e81a);

var $1fOu9 = parcelRequire("1fOu9");

var $8EKfm = parcelRequire("8EKfm");

var $c4zuL = parcelRequire("c4zuL");
class $10770b7fd73f22a8$export$9a18529d1e90e81a extends (0, $1fOu9.UFOExperience) {
    abortWithError(error, reason) {
        return super.abort({
            metadata: {
                error: (0, $c4zuL.createErrorMetadata)(error),
                reason: reason
            }
        });
    }
    failWithError(error) {
        if (error instanceof Error) {
            if ((0, $8EKfm.isAuthError)(error)) return this.abortWithError(error, 'Abort due to user unauthenticated');
            if ((0, $8EKfm.isErrorStatusCode)((0, $8EKfm.StatusCode).GONE, error)) return this.abortWithError(error, 'Abort due to unavailable resource');
            if ((0, $c4zuL.isIgnoredError)(error)) return this.abortWithError(error, 'Abort due to an error in ignore list');
            if ((0, $8EKfm.isNetworkError)(error)) return this.abortWithError(error, 'Abort due to network error');
            return super.failure({
                metadata: {
                    error: (0, $c4zuL.createErrorMetadata)(error),
                    packageVersion: "0.0.0-use.local",
                    packageName: "platform-pkg"
                }
            });
        }
        return super.failure({
            metadata: {
                error: 'unknown error',
                packageVersion: "0.0.0-use.local",
                packageName: "platform-pkg"
            }
        });
    }
}

});
parcelRegister("c4zuL", function(module, exports) {
$parcel$export(module.exports, "createErrorMetadata", () => $165353eaa1f7d2db$export$7286a0fb7b5aab6b);
$parcel$export(module.exports, "isIgnoredError", () => $165353eaa1f7d2db$export$a8da197a8bcc7e95);

var $8EKfm = parcelRequire("8EKfm");
const $165353eaa1f7d2db$export$7286a0fb7b5aab6b = (error)=>({
        error: {
            name: error.name,
            message: error.message,
            stack: error.stack,
            traceId: error instanceof (0, $8EKfm.HttpError) ? error.traceId : undefined,
            status: error instanceof (0, $8EKfm.HttpError) ? error.status : undefined
        }
    });
const $165353eaa1f7d2db$var$ignoredErrors = [
    'SLOIgnoreError',
    'SLOIgnoreHttpError'
];
const $165353eaa1f7d2db$export$a8da197a8bcc7e95 = (error)=>{
    const errorName = error?.constructor.name;
    if (!errorName) return false;
    return $165353eaa1f7d2db$var$ignoredErrors.includes(errorName);
};

});



parcelRegister("gMOu4", function(module, exports) {
$parcel$export(module.exports, "aggClient", () => $25efb590a6d71ca6$export$464c991dbf0b2393);

var $f35lS = parcelRequire("f35lS");

var $aggzG = parcelRequire("aggzG");

var $hCAQL = parcelRequire("hCAQL");

var $gsIZ0 = parcelRequire("gsIZ0");

var $jpdFw = parcelRequire("jpdFw");

var $4jmXS = parcelRequire("4jmXS");

var $8af8e = parcelRequire("8af8e");

var $2cY28 = parcelRequire("2cY28");

var $7KVM4 = parcelRequire("7KVM4");

var $de6R9 = parcelRequire("de6R9");

var $btB82 = parcelRequire("btB82");

var $1tCw5 = parcelRequire("1tCw5");
class $25efb590a6d71ca6$export$b44e5dafe13af7b3 extends (0, $hCAQL.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/graphql`);
    }
    async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        const response = await this.makeGraphQLRequest({
            query: (0, $de6R9.default),
            variables: {
                teamId: teamId,
                membershipState: membershipState,
                siteId: this.getCloudId(),
                ...pageInfo
            }
        }, {
            operationName: 'TeamMembership'
        });
        return {
            edges: response.team.teamV2.members.edges.map(({ node: node })=>({
                    membershipId: {
                        teamId: teamId,
                        memberId: (0, $f35lS.toUserId)(node.member.id)
                    },
                    state: node.state,
                    role: node.role,
                    user: {
                        id: (0, $f35lS.toUserId)(node.member.id),
                        fullName: node.member.name,
                        avatarUrl: node.member.picture,
                        status: node.member.accountStatus,
                        title: node.member.extendedProfile?.jobTitle ?? undefined,
                        userType: (0, $1tCw5.toUserType)({
                            appType: node.member.appType
                        })
                    }
                })),
            pageInfo: response.team.teamV2.members.pageInfo
        };
    }
    async queryAGGUser(userId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $btB82.TeamsUserQuery),
            variables: {
                userId: userId
            }
        }, {
            operationName: 'TeamsUserQuery'
        });
        return response.user;
    }
    async queryTeamHasAgents(teamId) {
        const teamAri = (0, $f35lS.toTeamARI)(teamId);
        const response = await this.makeGraphQLRequest({
            query: (0, $7KVM4.TeamHasAgentsQuery),
            variables: {
                id: teamAri
            }
        }, {
            operationName: 'TeamHasAgentsQuery'
        });
        return this.processTeamHasAgentsResponse(teamId, response.graphStore);
    }
    processTeamHasAgentsResponse(teamId, response) {
        return response.teamHasAgents.edges.map(({ node: node })=>({
                associationId: {
                    teamId: teamId,
                    accountId: (0, $f35lS.toUserId)(node.id)
                },
                agent: {
                    id: node.id,
                    fullName: node.name,
                    avatarUrl: node.picture
                }
            }));
    }
    async getTeamContainers(teamId) {
        const teamAri = (0, $f35lS.toTeamARI)(teamId);
        const cypherQuery = `MATCH (team:IdentityTeam {ari: '${teamAri}'})-[:team_connected_to_container]->(container) RETURN container`;
        const response = await this.makeGraphQLRequest({
            query: (0, $2cY28.TeamContainersQueryV2),
            variables: {
                cypherQuery: cypherQuery,
                params: {
                    id: teamAri
                }
            }
        }, {
            operationName: 'TeamContainersQueryV2'
        });
        return this.processV2Response(response);
    }
    processV2Response(response) {
        const containersResult = response.graphStore.cypherQueryV2.edges.reduce((containers, edge)=>{
            edge.node.columns.forEach((column)=>{
                const containerData = column.value?.data;
                if (!containerData) return;
                if (containerData?.__typename === 'ConfluenceSpace') containers.push({
                    id: containerData.id,
                    type: containerData.__typename,
                    name: containerData.confluenceSpaceName || '',
                    icon: `${containerData.links.base}${containerData.icon.path}`,
                    createdDate: new Date(containerData.createdDate),
                    link: `${containerData.links.base}${containerData.links.webUi}`,
                    containerTypeProperties: {
                        subType: undefined,
                        name: undefined
                    }
                });
                else if (containerData?.__typename === 'JiraProject') containers.push({
                    id: containerData.id,
                    type: containerData.__typename,
                    name: containerData.jiraProjectName,
                    icon: containerData.avatar.medium,
                    createdDate: new Date(containerData.created),
                    link: containerData.webUrl,
                    containerTypeProperties: {
                        subType: containerData.projectType || '',
                        name: containerData.projectTypeName || ''
                    }
                });
                else if (containerData?.__typename === 'LoomSpace') containers.push({
                    id: containerData.id,
                    type: containerData.__typename,
                    name: containerData.loomSpaceName,
                    icon: '',
                    link: containerData.url
                });
            });
            return containers;
        }, []);
        return containersResult;
    }
    async unlinkTeamContainer(teamId, containerId) {
        const teamAri = (0, $f35lS.toTeamARI)(teamId);
        const response = await this.makeGraphQLRequest({
            query: (0, $jpdFw.UnlinkContainerMutation),
            variables: {
                containerId: containerId,
                teamId: teamAri
            }
        }, {
            operationName: 'UnlinkContainerMutation'
        });
        return response.graphStore;
    }
    async queryNumberOfTeamConnectedToContainer(containerId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $4jmXS.NumberOfTeamConnectedToContainerQuery),
            variables: {
                containerId: containerId
            }
        }, {
            operationName: 'NumberOfTeamConnectedToContainerQuery'
        });
        return response?.graphStore?.teamConnectedToContainerInverse?.edges?.length;
    }
    async queryTeamsConnectedToContainer(containerId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $8af8e.TeamConnectedToContainerQuery),
            variables: {
                containerId: containerId
            }
        }, {
            operationName: 'TeamConnectedToContainerQuery'
        });
        return response?.graphStore?.teamConnectedToContainerInverse?.edges?.map(({ node: node })=>({
                id: node.id,
                displayName: node.displayName,
                description: node.description,
                state: node.state,
                membershipSettings: node.membershipSettings,
                organizationId: node.organizationId,
                creatorId: node.creator?.id,
                isVerified: node.isVerified,
                members: node.members?.nodes.map(({ member: member })=>({
                        id: member?.id ? (0, $f35lS.toUserId)(member?.id) : '',
                        fullName: member?.name ?? '',
                        avatarUrl: member?.picture,
                        status: member?.accountStatus
                    })) ?? [],
                includesYou: false,
                // to-do - this needs to be computed - https://product-fabric.atlassian.net/browse/CCECO-4368
                memberCount: node.members?.nodes.length ?? 0,
                largeAvatarImageUrl: node.largeAvatarImageUrl,
                smallAvatarImageUrl: node.smallAvatarImageUrl,
                largeHeaderImageUrl: node.largeHeaderImageUrl,
                smallHeaderImageUrl: node.smallHeaderImageUrl,
                restriction: 'ORG_MEMBERS' // deprecated field, kept for backwards compatibility
            }));
    }
}
const $25efb590a6d71ca6$export$464c991dbf0b2393 = new $25efb590a6d71ca6$export$b44e5dafe13af7b3((0, $aggzG.DEFAULT_CONFIG).stargateRoot, {
    logException: $gsIZ0.logException
});

});
parcelRegister("f35lS", function(module, exports) {
$parcel$export(module.exports, "toUserId", () => $24ab5bbe1a078f7a$export$1d0eef1d33b05366);
$parcel$export(module.exports, "isTeamARI", () => $24ab5bbe1a078f7a$export$7b81d5dfd83c8166);
$parcel$export(module.exports, "toTeamId", () => $24ab5bbe1a078f7a$export$e78216c959b9f3af);
$parcel$export(module.exports, "toTeamARI", () => $24ab5bbe1a078f7a$export$2bcc6e4924859c6f);

const $24ab5bbe1a078f7a$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $8669fbce7e137a6d$export$470b0d72e4fdc43a));
const $24ab5bbe1a078f7a$export$1d0eef1d33b05366 = (ari)=>{
    if ($24ab5bbe1a078f7a$export$caac29844ad91f64(ari)) return ari.replace((0, $8669fbce7e137a6d$export$470b0d72e4fdc43a), '');
    throw new Error('Invalid UserARI');
};
const $24ab5bbe1a078f7a$export$fca6a88adb58674a = (userId)=>{
    return $24ab5bbe1a078f7a$export$caac29844ad91f64(userId) ? userId : `${0, $8669fbce7e137a6d$export$470b0d72e4fdc43a}${userId}`;
};
const $24ab5bbe1a078f7a$export$7b81d5dfd83c8166 = (ari)=>ari.startsWith((0, $8669fbce7e137a6d$export$cfedc369802e0c68));
const $24ab5bbe1a078f7a$export$e78216c959b9f3af = (ari)=>{
    if ($24ab5bbe1a078f7a$export$7b81d5dfd83c8166(ari)) return ari.replace((0, $8669fbce7e137a6d$export$cfedc369802e0c68), '');
    throw new Error('Invalid TeamARI');
};
const $24ab5bbe1a078f7a$export$2bcc6e4924859c6f = (teamId)=>{
    return $24ab5bbe1a078f7a$export$7b81d5dfd83c8166(teamId) ? teamId : `${0, $8669fbce7e137a6d$export$cfedc369802e0c68}${teamId}`;
};

});
const $8669fbce7e137a6d$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $8669fbce7e137a6d$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';


parcelRegister("aggzG", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CONFIG", () => $96a3641a462828ca$export$c2f8e0cc249a8d8f);
const $96a3641a462828ca$export$c2f8e0cc249a8d8f = {
    stargateRoot: '/gateway/api',
    permsServiceUrl: '/gateway/api/permissions',
    publicApiRoot: '/gateway/api/public',
    invitationsServiceUrl: '/gateway/api/invitations',
    collaborationGraphUrl: '/gateway/api/collaboration'
};

});

parcelRegister("hCAQL", function(module, exports) {
$parcel$export(module.exports, "BaseGraphQlClient", () => $d453532351d64c71$export$42f6d6baced34b2d);

var $8EKfm = parcelRequire("8EKfm");

var $5zMz6 = parcelRequire("5zMz6");

var $35vAR = parcelRequire("35vAR");
/**
 * Validates that a siteId (cloudId) conforms to the format expected by
 * PlatformSiteAri from `@atlassian/ari/platform`.
 *
 * We inline this instead of importing `@atlassian/ari` because that package
 * is private and `teams-client` is a public package - public packages cannot
 * depend on private packages.
 *
 * The regex matches the `resourceIdSegmentFormats.siteId` rule from the
 * PlatformSiteAri manifest: `/[a-zA-Z0-9_\-.]{1,255}/`
 */ const $d453532351d64c71$var$SITE_ID_PATTERN = /^[a-zA-Z0-9_\-.]{1,255}$/;
function $d453532351d64c71$var$createPlatformSiteAri(siteId) {
    if (!$d453532351d64c71$var$SITE_ID_PATTERN.test(siteId)) throw new Error(`Invalid siteId: ${siteId}`);
    return `ari:cloud:platform::site/${siteId}`;
}
class $d453532351d64c71$export$42f6d6baced34b2d extends (0, $5zMz6.BaseClient) {
    constructor(serviceUrl, config){
        super(config);
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    /**
	 * Creates query context headers if cloudId is available and valid.
	 * Validates the cloudId before constructing the ARI, preventing invalid
	 * ARIs like `ari:cloud:platform::site/None` from being sent.
	 */ createQueryContextHeaders(cloudId) {
        if (!cloudId) return undefined;
        try {
            const ari = $d453532351d64c71$var$createPlatformSiteAri(cloudId);
            return {
                'X-Query-Context': ari
            };
        } catch  {
            return undefined;
        }
    }
    async makeGraphQLRequest(body, options = {}) {
        try {
            // Automatically add X-Query-Context header if cloudId is available in context
            const cloudId = this.getCloudId();
            const queryContextHeaders = this.createQueryContextHeaders(cloudId);
            // Merge headers: query context headers first, then provided headers (provided headers take precedence)
            const mergedOptions = {
                ...options,
                headers: {
                    ...queryContextHeaders,
                    ...options.headers
                }
            };
            return (0, $35vAR.handleGraphQLRequest)(this.serviceUrl, body, mergedOptions);
        } catch (error) {
            if (error instanceof (0, $8EKfm.GraphQLError)) throw error;
            this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
            throw new (0, $8EKfm.DefaultError)({});
        }
    }
}

});
parcelRegister("5zMz6", function(module, exports) {
$parcel$export(module.exports, "BaseClient", () => $a97470f82930cb67$export$4f22f74eddb7716a);

var $gsIZ0 = parcelRequire("gsIZ0");
class $a97470f82930cb67$export$4f22f74eddb7716a {
    constructor(config){
        this.cache = {};
        this.logException = (ex, name, context)=>{
            (0, $gsIZ0.logException)(ex, name, context);
            this.config.logException(ex, name, context);
        };
        this.config = config;
        this.context = {
            cloudId: ''
        };
    }
    setContext(context) {
        this.context = {
            ...context,
            cloudId: context.cloudId || ''
        };
    }
    getContext() {
        return this.context;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getOrgId(localValue) {
        const orgId = localValue || this.getContext().orgId;
        if (!orgId) {
            const err = new Error('No orgId set');
            this.logException(err, 'No orgId set');
            throw err;
        }
        return orgId;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getCloudId(localValue) {
        return localValue || this.getContext().cloudId;
    }
    keyWithContext(key) {
        return `${this.getContext().cloudId}-${this.getContext().orgId ?? 'no-org-id'}-${this.getContext().userId ?? 'no-user-id'}-${key}`;
    }
    // Default expiration is 5 minutes
    cacheValue(key, value, expiryMs = 300000) {
        this.cache[this.keyWithContext(key)] = {
            data: value,
            expiration: Date.now() + expiryMs
        };
    }
    getCachedValue(key) {
        const record = this.cache[this.keyWithContext(key)];
        if (record && record.expiration > Date.now()) return record.data;
        return undefined;
    }
}

});
parcelRegister("gsIZ0", function(module, exports) {
$parcel$export(module.exports, "logException", () => $f66eed055a6eebae$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logInfoMessage", () => $f66eed055a6eebae$export$386587bcf05ee8ea);
$parcel$export(module.exports, "logExceptionWithPackageContext", () => $f66eed055a6eebae$export$7208e9272a946c36);
$parcel$export(module.exports, "logErrorMessageWithPackageContext", () => $f66eed055a6eebae$export$dbd2da61a76fb8d2);
$parcel$export(module.exports, "logInfoMessageWithPackageContext", () => $f66eed055a6eebae$export$f242834c5699e597);
$parcel$export(module.exports, "createErrorHandlerWithPackageContext", () => $f66eed055a6eebae$export$6b2a307bf7c6c1dc);
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript

var $5NCjz = parcelRequire("5NCjz");
function $f66eed055a6eebae$var$decorateScope(scope, context) {
    const { tags: tags, ...otherContext } = context;
    if (tags) scope.setTags(tags);
    if (Object.keys(otherContext).length) scope.setExtras(otherContext);
    return scope;
}
async function $f66eed055a6eebae$export$f86b2a1a2ce291b3(ex, name, context = {}) {
    try {
        const sentryClient = await (0, $5NCjz.getSentryClient)();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            $f66eed055a6eebae$var$decorateScope(scope, context);
            scope.setTag('name', name);
            scope.setTag('packageName', context.packageName ?? 'unknown');
            scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
            sentryClient.captureException(ex, scope);
        });
    } catch  {
    // silence sentry exceptions
    }
}
async function $f66eed055a6eebae$var$logMessage(severity, message, context = {}) {
    const sentryClient = await (0, $5NCjz.getSentryClient)();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        $f66eed055a6eebae$var$decorateScope(scope, context);
        // The Severity enum is being replaced by SeverityLevel type in v7 anyway
        scope.setLevel(severity);
        scope.setTag('packageName', context.packageName ?? 'unknown');
        scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
        sentryClient.captureMessage(message, scope);
    });
}
function $f66eed055a6eebae$export$ece28f5cfa04608(message, context = {}) {
    $f66eed055a6eebae$var$logMessage('error', message, context).catch(()=>{});
}
function $f66eed055a6eebae$export$386587bcf05ee8ea(message, context = {}) {
    $f66eed055a6eebae$var$logMessage('info', message, context).catch(()=>{});
}
const $f66eed055a6eebae$export$9edc7d6f1c33ddc = (details)=>{
    return (error, message, tags = {})=>{
        $f66eed055a6eebae$export$f86b2a1a2ce291b3(error, message, {
            tags: {
                ...details,
                ...tags
            }
        });
    };
};
const $f66eed055a6eebae$export$7208e9272a946c36 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $f66eed055a6eebae$export$f86b2a1a2ce291b3(args[0], args[1], {
            ...args[2],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $f66eed055a6eebae$export$dbd2da61a76fb8d2 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $f66eed055a6eebae$export$ece28f5cfa04608(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $f66eed055a6eebae$export$f242834c5699e597 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $f66eed055a6eebae$export$386587bcf05ee8ea(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $f66eed055a6eebae$export$6b2a307bf7c6c1dc = (packageContext)=>(...args)=>$f66eed055a6eebae$export$9edc7d6f1c33ddc({
            ...args[0],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
async function $f66eed055a6eebae$export$efda9a273d7a036d(crumb) {
    const sentryClient = await (0, $5NCjz.getSentryClient)();
    sentryClient.withScope((scope)=>{
        scope.addBreadcrumb(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
    });
}

});
parcelRegister("5NCjz", function(module, exports) {
$parcel$export(module.exports, "sentryClient", () => $4b7d4cba5f458aec$export$ac71c212168fcd2b);
$parcel$export(module.exports, "setSentryClient", () => $4b7d4cba5f458aec$export$7d446c6f4e54de82);
$parcel$export(module.exports, "getSentryClient", () => $4b7d4cba5f458aec$export$f553e8b08ef59d31);
$parcel$export(module.exports, "setupSentryClient", () => $4b7d4cba5f458aec$export$d8bd0edf6c978788);

var $6Se9P = parcelRequire("6Se9P");

var $1hsTO = parcelRequire("1hsTO");
let $4b7d4cba5f458aec$export$ac71c212168fcd2b;
const $4b7d4cba5f458aec$export$7d446c6f4e54de82 = (client)=>{
    $4b7d4cba5f458aec$export$ac71c212168fcd2b = client;
};
const $4b7d4cba5f458aec$export$f553e8b08ef59d31 = async ()=>{
    if (!$4b7d4cba5f458aec$export$ac71c212168fcd2b) await $4b7d4cba5f458aec$export$d8bd0edf6c978788({});
    return $4b7d4cba5f458aec$export$ac71c212168fcd2b;
};
async function $4b7d4cba5f458aec$export$d8bd0edf6c978788({ appName: appName, env: env }) {
    const sentryClient = await $4b7d4cba5f458aec$var$requireSentryLib();
    if (!sentryClient) return;
    // initialiseSentry sets the sentry client
    (0, $1hsTO.initialiseSentry)(sentryClient, {
        initialScope: {
            tags: {
                renderMode: appName || 'unknown',
                productBuild: // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || 'unknown',
                product: $4b7d4cba5f458aec$var$getProduct()
            }
        },
        env: env,
        noGlobals: true,
        dsn: (0, $6Se9P.SENTRY_DSN),
        attachStacktrace: true
    });
}

async function $4b7d4cba5f458aec$var$requireSentryLib() {
    // saving ~40K
    try {
        return (parcelRequire("9G4ZU"));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Ignoring rejected promise when loading sentry resource.', error);
        return undefined;
    }
}
function $4b7d4cba5f458aec$var$getProduct() {
    const path = window.location.pathname;
    if (path.includes('/jira/people')) return 'jira';
    else if (path.includes('/wiki/people')) return 'confluence';
    return 'unknown';
}

});
parcelRegister("6Se9P", function(module, exports) {
$parcel$export(module.exports, "SENTRY_DSN", () => $98401a3ee1378366$export$6faa4a850bc4d0ce);

var $l1vE2 = parcelRequire("l1vE2");
const $98401a3ee1378366$export$9cf97fd92bea5d81 = '1dc056d49dfe4df8961dc1b810e4620d';
const $98401a3ee1378366$export$68c35ed3898e185a = '5988845';
const $98401a3ee1378366$export$b03be5cdb5af5197 = '067abcc494be9a87b3cdf9416f2b97d5';
const $98401a3ee1378366$export$97db6664a1e55fa6 = '47';
const $98401a3ee1378366$var$SENTRY_COMMERCIAL_DSN = `https://${$98401a3ee1378366$export$9cf97fd92bea5d81}@o55978.ingest.sentry.io/${$98401a3ee1378366$export$68c35ed3898e185a}`;
const $98401a3ee1378366$var$SENTRY_FEDRAMP_DSN = `https://${$98401a3ee1378366$export$b03be5cdb5af5197}@sentry.atlassian-us-gov-mod.com/${$98401a3ee1378366$export$97db6664a1e55fa6}`;
const $98401a3ee1378366$export$6faa4a850bc4d0ce = (0, $l1vE2.isFedRamp)() ? $98401a3ee1378366$var$SENTRY_FEDRAMP_DSN : $98401a3ee1378366$var$SENTRY_COMMERCIAL_DSN;

});

parcelRegister("1hsTO", function(module, exports) {
$parcel$export(module.exports, "initialiseSentry", () => $4caa1050d86c60f5$export$357606956af25316);

var $ejQ4x = parcelRequire("ejQ4x");

var $5NCjz = parcelRequire("5NCjz");
const $4caa1050d86c60f5$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
async function $4caa1050d86c60f5$export$357606956af25316(client, options) {
    if (0, $5NCjz.sentryClient) return;
    if (!client) return;
    (0, $5NCjz.setSentryClient)(client);
    const sentryConfig = (0, $ejQ4x.getSentryConfig)(options);
    (0, $5NCjz.sentryClient).init({
        ...sentryConfig,
        integrations: function(integrations) {
            return integrations.filter(function(integration) {
                return $4caa1050d86c60f5$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        }
    });
}

});
parcelRegister("ejQ4x", function(module, exports) {
$parcel$export(module.exports, "getSentryConfig", () => $91135099a460ae58$export$5580e6304e95c792);

var $6Se9P = parcelRequire("6Se9P");
const $91135099a460ae58$var$DEFAULT_SENTRY_CONFIG = {
    whitelistUrls: [
        /atl-paas.net/,
        // test local host
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/,
        // Network related errors
        'The operation was aborted',
        'Software caused connection abort',
        'GraphQL error: Failed to fetch',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'AbortError: The user aborted a request.',
        /^network error/i,
        /^network failure/i,
        /^NetworkError/i,
        /^Unexpected token ..*/
    ],
    ignoreUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
    ],
    dsn: (0, $6Se9P.SENTRY_DSN),
    attachStacktrace: true
};
function $91135099a460ae58$export$5580e6304e95c792(options) {
    const { env: env, version: version, noGlobals: _, ...otherOptions } = options;
    return {
        ...otherOptions,
        ...$91135099a460ae58$var$DEFAULT_SENTRY_CONFIG,
        // Standalone __VERSION__ is set from `bin/set-release-version.sh`
        // when building to deploy to production
        release: `${"platform-pkg"}@${"0.0.0-use.local"}` || // @ts-ignore Jira  - window.BUILD_KEY
        window.BUILD_KEY || // @ts-ignore Confluence - window.__buildInfo
        window.__buildInfo?.FRONTEND_VERSION || '---',
        environment: env || 'prod'
    };
}

});


parcelRegister("9G4ZU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("foCkS").then(()=>parcelRequire('3FNVj'));

});




parcelRegister("35vAR", function(module, exports) {
$parcel$export(module.exports, "handleGraphQLRequest", () => $f00c8f9bf4db5a4a$export$7feffc86760ee7ce);

var $8EKfm = parcelRequire("8EKfm");

var $9B4iC = parcelRequire("9B4iC");

var $38ARv = parcelRequire("38ARv");
async function $f00c8f9bf4db5a4a$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
    const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
    const errorPolicy = options.errorPolicy || 'none';
    const url = serviceUrl + operationNameQuery;
    const request = fetch(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json',
            ...options.headers || {}
        }),
        credentials: 'include',
        body: JSON.stringify(body)
    }).then((res)=>{
        if (res.status < 300 || res.status === 400) return res.json();
        else throw res;
    });
    try {
        const response = await request;
        const errors = response.errors;
        if (errors) {
            if (errorPolicy === 'none') throw (0, $8EKfm.GraphQLError).from(errors);
            else if (errorPolicy === 'all') // Set timeout will postpone error throwing and de-touch it to another event loop,
            // so we can return data along with throwing error
            return new Promise((_resolve, reject)=>{
                setTimeout(()=>{
                    reject((0, $8EKfm.GraphQLError).from(errors));
                }, 0);
            });
        }
        return response.data;
    } catch (error) {
        if (error instanceof Response) return {
            response: error
        };
        if (Object(error).hasOwnProperty('response')) throw error;
        return error;
    }
}
async function $f00c8f9bf4db5a4a$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
    const makeGraphQLRequestWithRetries = (0, $9B4iC.withExponentialBackoff)($f00c8f9bf4db5a4a$export$93d33e3b46bf00e7, {
        initial: (0, $9B4iC.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
        jitter: (0, $9B4iC.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
        max: (0, $9B4iC.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
        retryIf: (data)=>{
            return (0, $9B4iC.isFetchResponse)(data) && (0, $9B4iC.is5xx)(data.response.status);
        }
    });
    const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
    const response = result?.response;
    if (response) {
        const status = response.status;
        const statusText = response.statusText;
        const traceId = response.headers.get('atl-traceid');
        (0, $38ARv.handleResponse)(response);
        if (status > 400 && status <= 599) throw new (0, $8EKfm.HttpError)({
            message: statusText,
            status: status,
            traceId: traceId ?? undefined
        });
    }
    return result;
}

});
parcelRegister("9B4iC", function(module, exports) {
$parcel$export(module.exports, "EXPONENTIAL_BACKOFF_RETRY_POLICY", () => $03e9f0974b3c1855$export$8f4286bf21155381);
$parcel$export(module.exports, "is5xx", () => $03e9f0974b3c1855$export$55b2fbd5d4a32495);
$parcel$export(module.exports, "isFetchResponse", () => $03e9f0974b3c1855$export$81f27058be86d7ea);
$parcel$export(module.exports, "withExponentialBackoff", () => $03e9f0974b3c1855$export$20eaa22f2295996f);
$parcel$export(module.exports, "fetchWithExponentialBackoff", () => $03e9f0974b3c1855$export$b4c0bf5325504bf3);
const $03e9f0974b3c1855$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $03e9f0974b3c1855$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
function $03e9f0974b3c1855$export$81f27058be86d7ea(data) {
    if (!data || !data.hasOwnProperty('response')) return false;
    return data.response instanceof Response;
}
// tslint:disable-next-line no-any
const $03e9f0974b3c1855$var$defaultRetryIfCallback = (a)=>!a;
const $03e9f0974b3c1855$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $03e9f0974b3c1855$var$defaultRetryIfCallback
};
function $03e9f0974b3c1855$export$20eaa22f2295996f(toTry, hofOptions = $03e9f0974b3c1855$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
const $03e9f0974b3c1855$export$b4c0bf5325504bf3 = $03e9f0974b3c1855$export$20eaa22f2295996f((url, init)=>fetch(url, init), {
    initial: $03e9f0974b3c1855$export$8f4286bf21155381.INITIAL_DELAY,
    jitter: $03e9f0974b3c1855$export$8f4286bf21155381.JITTER,
    max: $03e9f0974b3c1855$export$8f4286bf21155381.MAX_RETRIES,
    retryIf: (response)=>$03e9f0974b3c1855$export$55b2fbd5d4a32495(response.status)
});

});

parcelRegister("38ARv", function(module, exports) {
$parcel$export(module.exports, "handleResponse", () => $cf000df8f1707ce8$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $cf000df8f1707ce8$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $cf000df8f1707ce8$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $cf000df8f1707ce8$export$8c005e458e12d501.handlers = handlers;
    }
};
function $cf000df8f1707ce8$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $cf000df8f1707ce8$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});



parcelRegister("jpdFw", function(module, exports) {
$parcel$export(module.exports, "UnlinkContainerMutation", () => $d1dea82a3a55df3b$export$74f3ccf149f124b);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $d1dea82a3a55df3b$export$74f3ccf149f124b = (0, $3a78v.print)((0, $aQEaU.default)`
	mutation unlinkTeamToContainerMutation($teamId: ID!, $containerId: ID!) {
		graphStore @optIn(to: ["GraphStoreMutation"]) {
			deleteTeamConnectedToContainer(
				input: { relationships: [{ from: $teamId, to: $containerId }] }
			) @optIn(to: ["GraphStoreTeamConnectedToContainer"]) {
				errors {
					message
					extensions {
						statusCode
						errorType
					}
				}
				success
			}
		}
	}
`);

});
parcelRegister("3a78v", function(module, exports) {
$parcel$export(module.exports, "print", () => $24d7d75da9b67471$export$c2d084dc44961371);

var $jg9tn = parcelRequire("jg9tn");

var $kn9OA = parcelRequire("kn9OA");
function $24d7d75da9b67471$export$c2d084dc44961371(ast) {
    return (0, $jg9tn.visit)(ast, {
        leave: $24d7d75da9b67471$var$printDocASTReducer
    });
}
var $24d7d75da9b67471$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $24d7d75da9b67471$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $24d7d75da9b67471$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $24d7d75da9b67471$var$wrap('(', $24d7d75da9b67471$var$join(node.variableDefinitions, ', '), ')');
        var directives = $24d7d75da9b67471$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $24d7d75da9b67471$var$join([
            op,
            $24d7d75da9b67471$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $24d7d75da9b67471$var$wrap(' = ', defaultValue) + $24d7d75da9b67471$var$wrap(' ', $24d7d75da9b67471$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $24d7d75da9b67471$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $24d7d75da9b67471$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $24d7d75da9b67471$var$wrap('(', $24d7d75da9b67471$var$join(args, ', '), ')');
        if (argsLine.length > $24d7d75da9b67471$var$MAX_LINE_LENGTH) argsLine = prefix + $24d7d75da9b67471$var$wrap('(\n', $24d7d75da9b67471$var$indent($24d7d75da9b67471$var$join(args, '\n')), '\n)');
        return $24d7d75da9b67471$var$join([
            argsLine,
            $24d7d75da9b67471$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $24d7d75da9b67471$var$wrap(' ', $24d7d75da9b67471$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $24d7d75da9b67471$var$join([
            '...',
            $24d7d75da9b67471$var$wrap('on ', typeCondition),
            $24d7d75da9b67471$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($24d7d75da9b67471$var$wrap('(', $24d7d75da9b67471$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($24d7d75da9b67471$var$wrap('', $24d7d75da9b67471$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $kn9OA.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $24d7d75da9b67471$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $24d7d75da9b67471$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $24d7d75da9b67471$var$wrap('(', $24d7d75da9b67471$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $24d7d75da9b67471$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $24d7d75da9b67471$var$join([
            'schema',
            $24d7d75da9b67471$var$join(directives, ' '),
            $24d7d75da9b67471$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $24d7d75da9b67471$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $24d7d75da9b67471$var$join([
            'scalar',
            name,
            $24d7d75da9b67471$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $24d7d75da9b67471$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $24d7d75da9b67471$var$join([
            'type',
            name,
            $24d7d75da9b67471$var$wrap('implements ', $24d7d75da9b67471$var$join(interfaces, ' & ')),
            $24d7d75da9b67471$var$join(directives, ' '),
            $24d7d75da9b67471$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $24d7d75da9b67471$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($24d7d75da9b67471$var$hasMultilineItems(args) ? $24d7d75da9b67471$var$wrap('(\n', $24d7d75da9b67471$var$indent($24d7d75da9b67471$var$join(args, '\n')), '\n)') : $24d7d75da9b67471$var$wrap('(', $24d7d75da9b67471$var$join(args, ', '), ')')) + ': ' + type + $24d7d75da9b67471$var$wrap(' ', $24d7d75da9b67471$var$join(directives, ' '));
    }),
    InputValueDefinition: $24d7d75da9b67471$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $24d7d75da9b67471$var$join([
            name + ': ' + type,
            $24d7d75da9b67471$var$wrap('= ', defaultValue),
            $24d7d75da9b67471$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $24d7d75da9b67471$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $24d7d75da9b67471$var$join([
            'interface',
            name,
            $24d7d75da9b67471$var$wrap('implements ', $24d7d75da9b67471$var$join(interfaces, ' & ')),
            $24d7d75da9b67471$var$join(directives, ' '),
            $24d7d75da9b67471$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $24d7d75da9b67471$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $24d7d75da9b67471$var$join([
            'union',
            name,
            $24d7d75da9b67471$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $24d7d75da9b67471$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $24d7d75da9b67471$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $24d7d75da9b67471$var$join([
            'enum',
            name,
            $24d7d75da9b67471$var$join(directives, ' '),
            $24d7d75da9b67471$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $24d7d75da9b67471$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $24d7d75da9b67471$var$join([
            name,
            $24d7d75da9b67471$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $24d7d75da9b67471$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $24d7d75da9b67471$var$join([
            'input',
            name,
            $24d7d75da9b67471$var$join(directives, ' '),
            $24d7d75da9b67471$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $24d7d75da9b67471$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($24d7d75da9b67471$var$hasMultilineItems(args) ? $24d7d75da9b67471$var$wrap('(\n', $24d7d75da9b67471$var$indent($24d7d75da9b67471$var$join(args, '\n')), '\n)') : $24d7d75da9b67471$var$wrap('(', $24d7d75da9b67471$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $24d7d75da9b67471$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $24d7d75da9b67471$var$join([
            'extend schema',
            $24d7d75da9b67471$var$join(directives, ' '),
            $24d7d75da9b67471$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $24d7d75da9b67471$var$join([
            'extend scalar',
            name,
            $24d7d75da9b67471$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $24d7d75da9b67471$var$join([
            'extend type',
            name,
            $24d7d75da9b67471$var$wrap('implements ', $24d7d75da9b67471$var$join(interfaces, ' & ')),
            $24d7d75da9b67471$var$join(directives, ' '),
            $24d7d75da9b67471$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $24d7d75da9b67471$var$join([
            'extend interface',
            name,
            $24d7d75da9b67471$var$wrap('implements ', $24d7d75da9b67471$var$join(interfaces, ' & ')),
            $24d7d75da9b67471$var$join(directives, ' '),
            $24d7d75da9b67471$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $24d7d75da9b67471$var$join([
            'extend union',
            name,
            $24d7d75da9b67471$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $24d7d75da9b67471$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $24d7d75da9b67471$var$join([
            'extend enum',
            name,
            $24d7d75da9b67471$var$join(directives, ' '),
            $24d7d75da9b67471$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $24d7d75da9b67471$var$join([
            'extend input',
            name,
            $24d7d75da9b67471$var$join(directives, ' '),
            $24d7d75da9b67471$var$block(fields)
        ], ' ');
    }
};
function $24d7d75da9b67471$var$addDescription(cb) {
    return function(node) {
        return $24d7d75da9b67471$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $24d7d75da9b67471$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $24d7d75da9b67471$var$block(array) {
    return $24d7d75da9b67471$var$wrap('{\n', $24d7d75da9b67471$var$indent($24d7d75da9b67471$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $24d7d75da9b67471$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $24d7d75da9b67471$var$indent(str) {
    return $24d7d75da9b67471$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $24d7d75da9b67471$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $24d7d75da9b67471$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($24d7d75da9b67471$var$isMultiline);
}

});
parcelRegister("jg9tn", function(module, exports) {
$parcel$export(module.exports, "BREAK", () => $e056dc0cfb5a2ed0$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $e056dc0cfb5a2ed0$export$bf638b60ea8b89b7);
$parcel$export(module.exports, "getVisitFn", () => $e056dc0cfb5a2ed0$export$c9c25cca74db6e70);
$parcel$export(module.exports, "visitInParallel", () => $e056dc0cfb5a2ed0$export$728beebeea393478);

var $1anI3 = parcelRequire("1anI3");

var $1Z2fJ = parcelRequire("1Z2fJ");
var $e056dc0cfb5a2ed0$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $e056dc0cfb5a2ed0$export$a89c95c098ac2a58 = Object.freeze({});
function $e056dc0cfb5a2ed0$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $e056dc0cfb5a2ed0$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $1Z2fJ.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $1anI3.default)(node), "."));
            var visitFn = $e056dc0cfb5a2ed0$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $e056dc0cfb5a2ed0$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $1Z2fJ.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $e056dc0cfb5a2ed0$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $e056dc0cfb5a2ed0$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $e056dc0cfb5a2ed0$export$a89c95c098ac2a58) skipping[i] = $e056dc0cfb5a2ed0$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $e056dc0cfb5a2ed0$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $e056dc0cfb5a2ed0$export$a89c95c098ac2a58) skipping[i] = $e056dc0cfb5a2ed0$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $e056dc0cfb5a2ed0$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});



parcelRegister("4jmXS", function(module, exports) {
$parcel$export(module.exports, "NumberOfTeamConnectedToContainerQuery", () => $11b70a50bd24ab88$export$6c9c309d551311e);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $11b70a50bd24ab88$export$6c9c309d551311e = (0, $3a78v.print)((0, $aQEaU.default)`
	query getNumberOfTeamsForContainer($containerId: ID!) {
		graphStore @optIn(to: "GraphStore") {
			teamConnectedToContainerInverse(id: $containerId, consistentRead: true)
				@optIn(to: "GraphStoreTeamConnectedToContainer") {
				edges {
					id
				}
			}
		}
	}
`);

});

parcelRegister("8af8e", function(module, exports) {
$parcel$export(module.exports, "TeamConnectedToContainerQuery", () => $df021fb152ab7fa1$export$8e179b6008492526);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $df021fb152ab7fa1$export$8e179b6008492526 = (0, $3a78v.print)((0, $aQEaU.default)`
	query getTeamsForContainer($containerId: ID!) {
		graphStore @optIn(to: "GraphStore") {
			teamConnectedToContainerInverse(id: $containerId, consistentRead: true)
				@optIn(to: "GraphStoreTeamConnectedToContainer") {
				edges {
					node {
						... on TeamV2 {
							id
							description
							displayName
							creator {
								id
							}
							smallAvatarImageUrl
							smallHeaderImageUrl
							largeAvatarImageUrl
							largeHeaderImageUrl
							members {
								nodes {
									member {
										id
										name
										picture
										accountStatus
										... on AtlassianAccountUser {
											extendedProfile {
												jobTitle
											}
										}
										... on AppUser {
											appType
										}
									}
									role
									state
								}
								pageInfo {
									endCursor
									hasNextPage
								}
							}
							organizationId
							membershipSettings
							isVerified
							state
						}
					}
				}
			}
		}
	}
`);

});

parcelRegister("2cY28", function(module, exports) {
$parcel$export(module.exports, "TeamContainersQueryV2", () => $d834cd507041c717$export$dc2f639827051505);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $d834cd507041c717$export$dc2f639827051505 = (0, $3a78v.print)((0, $aQEaU.default)`
	query TeamContainersQueryV2($cypherQuery: String!, $params: JSON!) {
		graphStore @optIn(to: ["GraphStore", "GraphStoreCypherQueryV2"]) {
			cypherQueryV2(query: $cypherQuery, params: $params) {
				edges {
					node {
						columns {
							key
							value {
								... on GraphStoreCypherQueryV2AriNode {
									data {
										__typename
										... on ConfluenceSpace {
											id
											confluenceSpaceName: name
											type
											createdDate
											links {
												base
												webUi
											}
											icon {
												path
											}
										}
										... on JiraProject {
											id
											jiraProjectName: name
											webUrl
											created
											avatar {
												medium
											}
											projectType
											projectTypeName
										}
										... on LoomSpace {
											id
											loomSpaceName: name
											url
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`);

});

parcelRegister("7KVM4", function(module, exports) {
$parcel$export(module.exports, "TeamHasAgentsQuery", () => $888cf718a79c389e$export$5a63c9c7b444f1f5);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $888cf718a79c389e$export$5a63c9c7b444f1f5 = (0, $3a78v.print)((0, $aQEaU.default)`
	query serviceName_TeamHasAgentsQuery($id: ID!) {
		graphStore @optIn(to: "GraphStore") {
			teamHasAgents(id: $id) @optIn(to: "GraphStoreTeamHasAgents") {
				edges {
					node {
						... on AppUser {
							id
							name
							picture
						}
					}
					cursor
				}
				pageInfo {
					hasNextPage
					endCursor
				}
			}
		}
	}
`);

});

parcelRegister("de6R9", function(module, exports) {
$parcel$export(module.exports, "default", () => $f15bfed7ee355416$export$2e2bcd8739ae039);
const $f15bfed7ee355416$var$TeamMembershipQuery = `query app_user_characteristics($teamId: ID!, $siteId: String!, $membershipState: [TeamMembershipState!]!, $first: Int!, $after: String) {
    team {
      teamV2(
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        members(state: $membershipState, first: $first, after: $after) {
          edges {
            node {
              member {
                id
                name
                picture
                accountStatus
                ... on AtlassianAccountUser {
                  extendedProfile {
                    jobTitle
                  }
                }
                ... on AppUser {
                  appType
                }
              }
              role
              state
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }`;
var $f15bfed7ee355416$export$2e2bcd8739ae039 = $f15bfed7ee355416$var$TeamMembershipQuery;

});

parcelRegister("btB82", function(module, exports) {
$parcel$export(module.exports, "TeamsUserQuery", () => $4aca88238432d505$export$9963ed3cbf7b791c);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $4aca88238432d505$export$9963ed3cbf7b791c = (0, $3a78v.print)((0, $aQEaU.default)`
	query TeamsUserQuery($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				locale
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					department
					location
					phoneNumbers {
						type
						value
					}
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				locale
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`);

});

parcelRegister("1tCw5", function(module, exports) {
$parcel$export(module.exports, "toUserType", () => $7e5be8d8601db72d$export$6b53fef091c7e27d);
function $7e5be8d8601db72d$export$6b53fef091c7e27d({ isBot: isBot, appType: appType }) {
    // Note, the order of these checks is important
    if (appType?.toLocaleLowerCase() === 'agent') return 'agent';
    if (isBot) return 'bot';
    return 'user';
}

});


parcelRegister("laiix", function(module, exports) {
$parcel$export(module.exports, "default", () => $331652bbddfe26d8$export$2e2bcd8739ae039);

var $aggzG = parcelRequire("aggzG");

var $87xLf = parcelRequire("87xLf");
var $331652bbddfe26d8$var$CONTAINER_TYPE = /*#__PURE__*/ function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CONTAINER_TYPE;
}($331652bbddfe26d8$var$CONTAINER_TYPE || {});
var $331652bbddfe26d8$var$ENTITY_TYPE = /*#__PURE__*/ function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
    return ENTITY_TYPE;
}($331652bbddfe26d8$var$ENTITY_TYPE || {});
class $331652bbddfe26d8$export$cd5b4a06db0ea4e2 extends (0, $87xLf.RestClient) {
    getUserContainers({ userId: userId, principalId: principalId, siteId: siteId, sessionId: sessionId, maxNumberOfResults: maxNumberOfResults }) {
        return this.postResource('/v1/collaborationgraph/user/container', {
            context: {
                contextType: 'atlassianDirectory',
                principalId: principalId,
                siteId: siteId,
                sessionId: sessionId
            },
            containerTypes: [
                'confluenceSpace',
                'jiraProject'
            ],
            maxNumberOfResults: maxNumberOfResults,
            userId: userId,
            expanded: true
        });
    }
    getRecommendedUsers({ accountId: accountId, cloudId: cloudId, maxNumberOfResults: maxNumberOfResults = 12, filter: filter = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:"app")' }) {
        return this.postResource('/v2/recommend/user', {
            context: {
                userId: accountId,
                tenantId: cloudId
            },
            modelRequestParams: {
                experience: 'CgUserNearbyUser',
                caller: 'atlas'
            },
            requestingUserId: accountId,
            expand: 'existing',
            maxNumberOfResults: maxNumberOfResults,
            filter: filter
        });
    }
}
const $331652bbddfe26d8$var$_default_1 = new $331652bbddfe26d8$export$cd5b4a06db0ea4e2({
    serviceUrl: (0, $aggzG.DEFAULT_CONFIG).collaborationGraphUrl
});
var $331652bbddfe26d8$export$2e2bcd8739ae039 = $331652bbddfe26d8$var$_default_1;

});
parcelRegister("87xLf", function(module, exports) {
$parcel$export(module.exports, "RestClient", () => $87386918b4ec8cd1$export$ea8b5b3aea9558ce);

var $5vPx9 = parcelRequire("5vPx9");

var $8EKfm = parcelRequire("8EKfm");

var $9B4iC = parcelRequire("9B4iC");

var $38ARv = parcelRequire("38ARv");

var $5zMz6 = parcelRequire("5zMz6");

var $lgkRr = parcelRequire("lgkRr");

var $12A5a = parcelRequire("12A5a");

var $kj9Ye = parcelRequire("kj9Ye");

var $d5pPg = parcelRequire("d5pPg");
const $87386918b4ec8cd1$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
let $87386918b4ec8cd1$var$incrementRedirectCount;
let $87386918b4ec8cd1$var$clearRedirectCount;
$87386918b4ec8cd1$export$7a0fc52d8c359feb();
function $87386918b4ec8cd1$export$7a0fc52d8c359feb() {
    $87386918b4ec8cd1$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($5vPx9)))(()=>(0, $lgkRr.setCookie)((0, $lgkRr.REDIRECT_COUNT), (0, $lgkRr.getCookieAsInteger)((0, $lgkRr.REDIRECT_COUNT)) + 1));
    $87386918b4ec8cd1$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($5vPx9)))(()=>(0, $lgkRr.clearCookie)((0, $lgkRr.REDIRECT_COUNT)));
}
class $87386918b4ec8cd1$export$ea8b5b3aea9558ce extends (0, $5zMz6.BaseClient) {
    constructor({ serviceUrl: serviceUrl = '', config: config = {
        logException: ()=>{}
    } }){
        super(config), /**
	 * This function is necessary for if `statusCodeHandler` prescribes a login
	 * redirect upon a 401 response.
	 * While the default redirect behaviour may be overriden, this function has
	 * been kept separate to ensure it cannot be overriden, lest a host
	 * application supply embeddable-directory with a custom handler that suffers
	 * the infinite redirect bug.
	 */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $87386918b4ec8cd1$var$incrementRedirectCount();
            } else $87386918b4ec8cd1$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async getResource(path, fetchOptions = {}) {
        return this.makeRequest(path, fetchOptions);
    }
    async getResourceCached(path, fetchOptions = {}, cacheOptions) {
        const cacheKey = path;
        const cacheRecord = this.getCachedValue(cacheKey);
        if (cacheRecord) return cacheRecord;
        const response = await this.getResource(path, fetchOptions);
        this.cacheValue(cacheKey, response, cacheOptions?.expiration);
        return response;
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
			 * PATCH must be uppercase as per fetch spec only
			 * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
			 * are normalised to uppercase.
			 *
			 * https://github.com/github/fetch/issues/37
			 * https://fetch.spec.whatwg.org/#methods
			 */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {
        shouldLogError: (e)=>e.status !== 429
    }) {
        const url = this.serviceUrl + path;
        const options = {
            ...$87386918b4ec8cd1$var$defaultFetchOptions,
            ...additionalFetchOptions
        };
        const response = await (0, $9B4iC.fetchWithExponentialBackoff)(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $38ARv.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $8EKfm.SLOIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await (0, $12A5a.parseErrorMessage)(response);
                const httpError = new (0, $8EKfm.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined,
                    path: path
                });
                if (options.shouldLogError && options.shouldLogError(httpError)) this.logException(httpError, (0, $d5pPg.stripUUIDFromPath)(path), {
                    method: options.method || 'GET',
                    url: url,
                    status: responseStatusCode
                });
                throw httpError;
            }
        }
        // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
        return additionalFetchOptions.ignoreResponse ? null : (0, $kj9Ye.parseResponse)(response);
    }
}

});
parcelRegister("lgkRr", function(module, exports) {
$parcel$export(module.exports, "REDIRECT_COUNT", () => $d161286638ce0ac8$export$f6101897f0230549);
$parcel$export(module.exports, "setCookie", () => $d161286638ce0ac8$export$110700823644f4a6);
$parcel$export(module.exports, "getCookieAsInteger", () => $d161286638ce0ac8$export$6a289e5003f59269);
$parcel$export(module.exports, "clearCookie", () => $d161286638ce0ac8$export$ad3506281d5a5e5d);
const $d161286638ce0ac8$export$f6101897f0230549 = 'redirectCount';
const $d161286638ce0ac8$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $d161286638ce0ac8$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $d161286638ce0ac8$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $d161286638ce0ac8$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});

parcelRegister("12A5a", function(module, exports) {
$parcel$export(module.exports, "parseErrorMessage", () => $6e3c8e1902d60254$export$91c32f1b22d29b2d);
async function $6e3c8e1902d60254$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.error) return `${json.status || 'UNKNOWN_STATUS'} ${json.error || 'MISSING_ERROR_MESSAGE'}`;
    else if (json.status) return `${json.status} MISSING_ERROR_MESSAGE`;
    else if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || 'MISSING_ERROR_MESSAGE');
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}

});

parcelRegister("kj9Ye", function(module, exports) {
$parcel$export(module.exports, "parseResponse", () => $77d63412f95369ec$export$ba14d9a5a581e827);
function $77d63412f95369ec$export$ba14d9a5a581e827(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}

});

parcelRegister("d5pPg", function(module, exports) {
$parcel$export(module.exports, "stripUUIDFromPath", () => $806455e0541db764$export$6bd073e2c6dda996);
const $806455e0541db764$var$UUID_REGEX = new RegExp(/((\w{4,12}-?)){5}/g);
const $806455e0541db764$export$6bd073e2c6dda996 = (path)=>{
    return path.replace($806455e0541db764$var$UUID_REGEX, '<UUID>');
};

});



parcelRegister("i3m7i", function(module, exports) {
$parcel$export(module.exports, "directoryClient", () => $0f890e4aa1eeea7b$export$ead519165de472de);

var $aggzG = parcelRequire("aggzG");

var $hCAQL = parcelRequire("hCAQL");

var $gsIZ0 = parcelRequire("gsIZ0");
const $0f890e4aa1eeea7b$export$28456d095a642fd = 'internal.browse-users-allowed';
const $0f890e4aa1eeea7b$var$buildTeamMembershipQuery = (teamId, membershipState)=>({
        query: `query TeamMembership($teamId: String!, $membershipState: [TeamMembershipStatus]) {
    TeamMembership: TeamMembership(teamId: $teamId, membershipStates: $membershipState) {
      user: profile {
        id,
        fullName,
        title,
        avatarUrl,
        timezone,
        status
      },
      state:membershipStatus,
      role,
      membershipId {
        teamId, memberId
      }
    }
  }`,
        variables: {
            teamId: teamId,
            membershipState: membershipState
        }
    });
const $0f890e4aa1eeea7b$var$buildUserQuery = (userId, cloudId)=>({
        query: `query CloudUser($userId: String!, $cloudId: String!) {
    CloudUser(userId: $userId, cloudId: $cloudId) {
      avatarUrl
      id
      fullName
      title
    }
  }`,
        variables: {
            userId: userId,
            cloudId: cloudId
        }
    });
const $0f890e4aa1eeea7b$var$delay = (millis)=>new Promise((resolve)=>{
        setTimeout(resolve, millis);
    });
class $0f890e4aa1eeea7b$export$c8a50bf6c196fc10 extends (0, $hCAQL.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/directory/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/directory/graphql`);
    }
    async queryFeatureFlags(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId, flags) {
        const queryFeatureFlags = {
            query: `query FeatureFlags($cloudId: String!, $flags: [String]!) {
        FeatureFlags(cloudId: $cloudId, flags: $flags) {
          flag
          enabled
        }
      }`,
            variables: {
                cloudId: this.getCloudId(cloudId),
                flags: flags
            }
        };
        const { FeatureFlags: FeatureFlags } = await this.makeGraphQLRequest(queryFeatureFlags, {
            operationName: 'FeatureFlags'
        });
        return FeatureFlags.map(({ flag: flag, enabled: enabled })=>[
                flag,
                enabled
            ]).reduce((acc, val)=>(acc[val[0]] = val[1], acc), {});
    }
    canRetryError(pendingRetries, error) {
        return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
    }
    /**
   * Get user information of all members of a team
   * @param {string} teamId
   * @returns {Promise}
   * @private
   * @deprecated use AGG instead
   */ queryTeamMemberships(teamId, membershipStatus = [
        'FULL_MEMBER'
    ]) {
        // eslint-disable-next-line no-console
        console.warn('Directory queryTeamMemberships is deprecated, use AGG instead');
        const teamMembershipsQuery = $0f890e4aa1eeea7b$var$buildTeamMembershipQuery(teamId, membershipStatus);
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(teamMembershipsQuery, {
                    operationName: 'TeamMembership'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $0f890e4aa1eeea7b$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest().then(({ TeamMembership: TeamMembership })=>TeamMembership);
    }
    /**
   * Get user information of all members of a team
   * @param {string} userId
   * @returns {Promise}
   */ queryUser(userId, /**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId) {
        const userQuery = $0f890e4aa1eeea7b$var$buildUserQuery(userId, this.getCloudId(cloudId));
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(userQuery, {
                    operationName: 'CloudUser'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $0f890e4aa1eeea7b$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest();
    }
}
const $0f890e4aa1eeea7b$export$ead519165de472de = new $0f890e4aa1eeea7b$export$c8a50bf6c196fc10((0, $aggzG.DEFAULT_CONFIG).stargateRoot, {
    logException: $gsIZ0.logException
});

});

parcelRegister("7TN9i", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1644d056a00d085$export$2e2bcd8739ae039);

var $aggzG = parcelRequire("aggzG");

var $87xLf = parcelRequire("87xLf");

var $3f5xI = parcelRequire("3f5xI");
const $f1644d056a00d085$var$defaultConfig = {
    serviceUrl: `${(0, $aggzG.DEFAULT_CONFIG).stargateRoot}/users`
};
class $f1644d056a00d085$export$f9c003efee04f318 extends (0, $87xLf.RestClient) {
    constructor(config = {}){
        super({
            ...$f1644d056a00d085$var$defaultConfig,
            ...config
        });
    }
    async getUserManageConfig(userId) {
        return this.getResourceCached(`/${userId}/manage`).then((resp)=>{
            return (0, $3f5xI.transformUserManageConfig)(resp);
        });
    }
    /**
	 * @deprecated
	 * User fetchUserAvatarInfo instead
	 */ async getMyAvatarUploadedStatus(userId) {
        return this.fetchUserAvatarInfo(userId);
    }
    async deleteAvatar(userId) {
        return this.deleteResource(`/${userId}/manage/avatar`);
    }
    async fetchUserAvatarInfo(userId) {
        return this.getResource(`/${userId}/manage/avatar`);
    }
    async updateUser({ id: id, ...user }) {
        return this.patchResource(`/${id}/manage/profile`, (0, $3f5xI.toManageAPIInput)(user));
    }
    async updateUserAvatar({ id: id, fileURI: fileURI }) {
        const fileObject = (0, $3f5xI.dataURItoFile)(fileURI);
        const formData = new FormData();
        formData.append('file', fileObject);
        const response = await this.makeRequest(`/${id}/manage/avatar`, {
            method: 'PUT',
            body: formData
        });
        return response.url;
    }
}
const $f1644d056a00d085$var$_default_1 = new $f1644d056a00d085$export$f9c003efee04f318();
var $f1644d056a00d085$export$2e2bcd8739ae039 = $f1644d056a00d085$var$_default_1;

});
parcelRegister("3f5xI", function(module, exports) {
$parcel$export(module.exports, "transformUserManageConfig", () => $98ba4eb8a36b8c58$export$d7725d3d27b80a68);
$parcel$export(module.exports, "toManageAPIInput", () => $98ba4eb8a36b8c58$export$7b103107c889cb67);
$parcel$export(module.exports, "dataURItoFile", () => $98ba4eb8a36b8c58$export$80d19edb7b1ae293);

var $eT4u6 = parcelRequire("eT4u6");
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $98ba4eb8a36b8c58$var$PROFILE_PROPS_MAP = new Map([
    [
        'id',
        'account_id'
    ],
    [
        'fullName',
        'name'
    ],
    [
        'nickname',
        'nickname'
    ],
    [
        'timezone',
        'zoneinfo'
    ],
    [
        'locale',
        'locale'
    ],
    [
        'avatarUrl',
        'picture'
    ],
    [
        'email',
        'email'
    ]
]);
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $98ba4eb8a36b8c58$var$EXTENDED_PROFILE_PROPS_MAP = new Map([
    [
        'title',
        'job_title'
    ],
    [
        'department',
        'department'
    ],
    [
        'companyName',
        'organization'
    ],
    [
        'location',
        'location'
    ],
    [
        'phoneNumber',
        'phone_number'
    ],
    [
        'aboutMe',
        'about_me'
    ],
    [
        'pronouns',
        'pronouns'
    ]
]);
const $98ba4eb8a36b8c58$export$5299664357e4f3dd = (res)=>{
    const data = res.account;
    const extendedData = data && data.extended_profile || {};
    if (!data) return null;
    const timeZone = data.zoneinfo;
    const localTime = ({ format: format })=>{
        if (!timeZone) return null;
        try {
            return (0, $eT4u6.formatInTimeZone)(new Date(), timeZone, format);
        } catch (error) {
            // TODO: PTC-4908 send error to sentry for reporting
            return null;
        }
    };
    const profileProps = Array.from($98ba4eb8a36b8c58$var$PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($98ba4eb8a36b8c58$var$PROFILE_PROPS_MAP.has(key)) acc[key] = data[$98ba4eb8a36b8c58$var$PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    const extendedProfileProps = Array.from($98ba4eb8a36b8c58$var$EXTENDED_PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($98ba4eb8a36b8c58$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) acc[key] = extendedData[$98ba4eb8a36b8c58$var$EXTENDED_PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    return {
        ...profileProps,
        ...extendedProfileProps,
        localTime: localTime
    };
};
var $98ba4eb8a36b8c58$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType["FullName"] = "fullName";
    FieldType["Nickname"] = "nickname";
    FieldType["Title"] = "title";
    FieldType["Department"] = "department";
    FieldType["CompanyName"] = "companyName";
    FieldType["Location"] = "location";
    FieldType["Timezone"] = "timezone";
    FieldType["Email"] = "email";
    FieldType["PhoneNumber"] = "phoneNumber";
    FieldType["Avatar"] = "picture";
    FieldType["Language"] = "language";
    FieldType["LocalTime"] = "localTime";
    FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
    FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
    FieldType["RemoteTimeString"] = "remoteTimeString";
    return FieldType;
}({});
const $98ba4eb8a36b8c58$export$78158d2c2c6998d9 = {
    fullName: 'name',
    nickname: 'nickname',
    timezone: 'zoneinfo',
    locale: 'locale',
    email: 'email',
    // extended profile
    title: 'extended_profile.job_title',
    phoneNumber: 'extended_profile.phone_number',
    companyName: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $98ba4eb8a36b8c58$export$2ff7b92b9e1bb4d2 = {
    email: 'email.initiateChange',
    picture: 'avatar'
};
const $98ba4eb8a36b8c58$var$getFieldConfig = (data, field)=>{
    if ((field === 'email' || field === 'picture') && $98ba4eb8a36b8c58$export$2ff7b92b9e1bb4d2[field]) return data[$98ba4eb8a36b8c58$export$2ff7b92b9e1bb4d2[field]];
    const mappedFieldKey = field in $98ba4eb8a36b8c58$export$78158d2c2c6998d9 ? $98ba4eb8a36b8c58$export$78158d2c2c6998d9[field] : undefined;
    if (!mappedFieldKey) return undefined;
    const profileWrite = data['profile.write'];
    return profileWrite[mappedFieldKey];
};
const $98ba4eb8a36b8c58$var$convertFieldKeyToFieldType = (key)=>{
    // Check if the key can be mapped to a FieldType value
    if (Object.values($98ba4eb8a36b8c58$export$ed12481c953b8653).includes(key)) return key;
    return undefined;
};
const $98ba4eb8a36b8c58$var$getMutabilityConstraintFor = (data, field)=>{
    const fieldConfig = $98ba4eb8a36b8c58$var$getFieldConfig(data, field);
    if (!fieldConfig || fieldConfig.allowed) return undefined;
    const convertedField = $98ba4eb8a36b8c58$var$convertFieldKeyToFieldType(field);
    if (!convertedField) return undefined;
    const reason = fieldConfig.reason;
    return {
        field: convertedField,
        reason: reason && reason.key || null
    };
};
const $98ba4eb8a36b8c58$export$d7725d3d27b80a68 = (data)=>({
        mutabilityConstraints: Object.keys($98ba4eb8a36b8c58$export$78158d2c2c6998d9).map((field)=>$98ba4eb8a36b8c58$var$getMutabilityConstraintFor(data, field)).filter((constraint)=>constraint !== undefined)
    });
const $98ba4eb8a36b8c58$export$7b103107c889cb67 = (input)=>{
    const output = {
        extended_profile: {}
    };
    Object.keys(input).forEach((key)=>{
        if ($98ba4eb8a36b8c58$var$PROFILE_PROPS_MAP.has(key)) output[$98ba4eb8a36b8c58$var$PROFILE_PROPS_MAP.get(key)] = input[key];
        if ($98ba4eb8a36b8c58$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) output.extended_profile[$98ba4eb8a36b8c58$var$EXTENDED_PROFILE_PROPS_MAP.get(key)] = input[key];
    });
    return output;
};
function $98ba4eb8a36b8c58$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const byteString = dataURI.split(',')[0].includes('base64') ? atob(dataURI.split(',')[1]) : decodeURIComponent(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        mimeString = 'unknown';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 and Safari does not support the File constructor.
        return blob;
    }
}

});


parcelRegister("dRLvv", function(module, exports) {
$parcel$export(module.exports, "default", () => $167f0afef3480635$export$2e2bcd8739ae039);

var $aggzG = parcelRequire("aggzG");

var $87xLf = parcelRequire("87xLf");

var $gsIZ0 = parcelRequire("gsIZ0");

var $6N1KP = parcelRequire("6N1KP");
const $167f0afef3480635$var$PRODUCT_RECCOMENDATIONS = '/v1/product-recommendations';
const $167f0afef3480635$var$PRODUCT_JOIN_OR_REQUEST_BULK = '/v1/access-requests/bulk/request';
const $167f0afef3480635$var$ALL_SUPPORTED_PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-servicedesk',
    'jira-software',
    'jira-incident-manager',
    'jira-product-discovery',
    'opsgenie',
    'statuspage',
    'avocado',
    'townsquare',
    'compass',
    'avp',
    'beacon',
    'mercury'
];
class $167f0afef3480635$export$3209eb31343f39d extends (0, $87xLf.RestClient) {
    constructor(serviceUrl, config){
        super({
            serviceUrl: serviceUrl,
            config: config
        });
    }
    async getProductRecommendationsInner(supportedProducts = $167f0afef3480635$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        try {
            const orgId = this.getOrgId();
            const queryProducts = supportedProducts && supportedProducts.length > 0 ? supportedProducts : $167f0afef3480635$var$ALL_SUPPORTED_PRODUCTS;
            const productQueryParams = queryProducts.map((product)=>`product=${product}`).join('&');
            const capabilityQueryParams = capabilities && capabilities.length > 0 ? '&' + capabilities.map((capability)=>`capability=${capability}`).join('&') : '';
            const url = `${$167f0afef3480635$var$PRODUCT_RECCOMENDATIONS}?orgId=${orgId}&${productQueryParams}${capabilityQueryParams}`;
            return await this.getResource(url);
        } catch (error) {
            this.logException(error, 'An error occurred while getting product recommendations.');
            throw error;
        }
    }
    async getProductRecommendations(supportedProducts = $167f0afef3480635$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        // This endpoint may return duplicate resource ARIs with a different mode.
        const result = await this.getProductRecommendationsInner(supportedProducts, capabilities);
        try {
            const deduplicatedResult = (0, $6N1KP.removeDuplicateRecommendations)(result);
            return deduplicatedResult;
        } catch (error) {
            this.logException(error, 'An error occurred while deduplicating product recommendations.');
            throw error;
        }
    }
    async joinOrRequestDefaultAccessToProductsBulk(simplifiedRequest) {
        if (simplifiedRequest.productAris.length === 0) return Promise.resolve([]);
        try {
            const resources = simplifiedRequest.productAris.map((ari)=>({
                    ari: ari,
                    role: 'product/member'
                }));
            const request = {
                resources: resources,
                note: simplifiedRequest.note,
                accessMode: simplifiedRequest.accessMode,
                source: simplifiedRequest.source
            };
            return await this.postResource($167f0afef3480635$var$PRODUCT_JOIN_OR_REQUEST_BULK, request);
        } catch (error) {
            this.logException(error, 'An error occurred while joining or requesting access to products.');
            throw error;
        }
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $167f0afef3480635$var$_default_1 = new $167f0afef3480635$export$3209eb31343f39d((0, $aggzG.DEFAULT_CONFIG).invitationsServiceUrl, {
    logException: $gsIZ0.logException
});
var $167f0afef3480635$export$2e2bcd8739ae039 = $167f0afef3480635$var$_default_1;

});
parcelRegister("6N1KP", function(module, exports) {
$parcel$export(module.exports, "removeDuplicateRecommendations", () => $a52fee58a08ceea0$export$d9d1c981635dd213);
/**
 * Determines which capability is more desirable.
 * Users desire direct access over request access since it's instant.
 * @returns 0 if equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $a52fee58a08ceea0$var$compareCapability = (a, b)=>{
    if (a === b) return 0;
    return a === 'DIRECT_ACCESS' ? -1 : 1;
};
/**
 * Determines which mode is more desirable.
 * Atlassian prefers to provide open access over domain restricted access.
 * Both of these modes have already been enabled by an admin.
 * If mode is undefined, it is deemed least desirable.
 * @returns 0 if equal, -1 if a is more open, 1 if b is more open.
 */ const $a52fee58a08ceea0$var$compareMode = (a, b)=>{
    if (a === b) return 0;
    if (!a) return 1;
    if (!b) return -1;
    return a === 'OPEN' ? -1 : 1;
};
/**
 * Determine if a recommendation is more desirable than another.
 * Atlassian prefers a better capability over any mode setting.
 * The mode will only be compared if the capabilities are equal.
 * If both capability and mode are equal, the recommendations are considered the same.
 *
 * Assumes recommendations have the same resource ID.
 * Do not compare recommendations with different resource IDs, as it does not make sense.
 *
 * @returns 0 if capability and mode are equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $a52fee58a08ceea0$var$compareRecommendations = (a, b)=>{
    if (a.resourceId !== b.resourceId) throw new Error('Recommendations must have the same resource ID');
    if ($a52fee58a08ceea0$var$compareCapability(a.capability, b.capability) < 0) return -1;
    else if ($a52fee58a08ceea0$var$compareCapability(a.capability, b.capability) > 0) return 1;
    else if ($a52fee58a08ceea0$var$compareMode(a.mode, b.mode) < 0) return -1;
    else if ($a52fee58a08ceea0$var$compareMode(a.mode, b.mode) > 0) return 1;
    return 0;
};
const $a52fee58a08ceea0$var$toRecommendation = (recommendation)=>{
    const { capability: capability, ...rest } = recommendation;
    return {
        ...rest
    };
};
const $a52fee58a08ceea0$export$d9d1c981635dd213 = (recommendations)=>{
    const { DIRECT_ACCESS: DIRECT_ACCESS, REQUEST_ACCESS: REQUEST_ACCESS } = recommendations.capability;
    const uniqueRecommendations = {};
    const allRecommendations = [
        ...DIRECT_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'DIRECT_ACCESS'
            })),
        ...REQUEST_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'REQUEST_ACCESS'
            }))
    ];
    allRecommendations.forEach((recommendation)=>{
        const existing = uniqueRecommendations[recommendation.resourceId];
        if (existing && $a52fee58a08ceea0$var$compareRecommendations(existing, recommendation) <= 0) return;
        uniqueRecommendations[recommendation.resourceId] = recommendation;
    });
    const allUniqueRecommendations = Object.values(uniqueRecommendations);
    return {
        capability: {
            DIRECT_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'DIRECT_ACCESS').map($a52fee58a08ceea0$var$toRecommendation),
            REQUEST_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'REQUEST_ACCESS').map($a52fee58a08ceea0$var$toRecommendation)
        }
    };
};

});


parcelRegister("3Lo3f", function(module, exports) {
$parcel$export(module.exports, "defaultLegionClient", () => $0ee15fca28d044a8$export$95c697fe95d86a77);

var $aggzG = parcelRequire("aggzG");

var $87xLf = parcelRequire("87xLf");
const $0ee15fca28d044a8$var$v3UrlPath = `/v3/teams`;
const $0ee15fca28d044a8$var$v4UrlPath = `/v4/teams`;
class $0ee15fca28d044a8$export$68a6a391e3cf23be extends (0, $87xLf.RestClient) {
    constructor(serviceUrl){
        super({
            serviceUrl: serviceUrl
        });
        this.serviceUrlRoot = serviceUrl;
    }
    setRootUrl(url) {
        if (url === this.serviceUrlRoot) return;
        this.serviceUrlRoot = url;
        this.setServiceUrl(url);
    }
    async getTeamById(teamId, cloudId) {
        const siteId = this.getCloudId(cloudId);
        const teamResponse = await this.getResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}?siteId=${siteId}`);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    async getAllTeams(allTeamsQuery) {
        try {
            const orgId = this.getOrgId(allTeamsQuery.orgId);
            const siteId = this.getCloudId();
            const enablePagination = allTeamsQuery.enablePagination ?? true;
            const { entities: entities, cursor: cursor } = await this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/search`, {
                organizationId: orgId,
                siteId: siteId,
                limit: allTeamsQuery.limit,
                query: allTeamsQuery.searchQuery,
                sortBy: allTeamsQuery.useDefaultSort ? null : allTeamsQuery.sortBy && allTeamsQuery.sortBy.length > 0 ? allTeamsQuery.sortBy : [
                    {
                        field: 'displayName',
                        order: 'asc'
                    }
                ],
                membership: {
                    memberAccountIds: allTeamsQuery.memberAccountIds
                },
                showEmptyTeams: allTeamsQuery.showEmptyTeams,
                teamTypeIdsFilter: allTeamsQuery.teamTypeIdsFilter,
                enablePagination: enablePagination,
                ...enablePagination && allTeamsQuery.cursor ? {
                    cursor: allTeamsQuery.cursor
                } : {}
            });
            const teams = entities.map((t)=>this.mapTeamSearchResponseV4ToTeamWithMembership(t));
            return {
                cursor: cursor,
                teams: teams
            };
        } catch (error) {
            this.logException(error, 'getAllTeams');
            return {
                cursor: '',
                teams: [],
                error: error instanceof Error ? error : undefined
            };
        }
    }
    async updateTeamById(teamId, data) {
        const teamResponse = await this.patchResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, data);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.addUsersToTeam instead
	 */ async inviteUsersToTeam(teamId, users, originQuery) {
        if (!users || users.length === 0) return Promise.resolve([]);
        const emails = [];
        const ids = [];
        users.forEach((user)=>{
            if (user.id) ids.push(user.id);
            else if (user.email) emails.push(user.email);
        });
        const url = `${$0ee15fca28d044a8$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/invite?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url, {
            emailAddresses: emails,
            atlassianAccounts: ids
        });
    }
    async getMyTeamMembership(teamId) {
        return this.getResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/me?siteId=${this.getCloudId()}`, {
            shouldLogError: (e)=>e.status !== 400
        });
    }
    async getTeamLinksByTeamId(teamId) {
        let siteId = this.getCloudId();
        let response = await this.getResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links?siteId=${siteId}`);
        return this.mapLegionTeamLinksResponseV4ToTeamLinkResponse(response);
    }
    async createTeamLink(teamId, link) {
        const sanitisedTeamLink = {
            contentTitle: link.contentTitle.trim(),
            linkUri: link.linkUri.trim(),
            description: link.description.trim(),
            ...link.creationTime ? {
                creationTime: link.creationTime.trim()
            } : {},
            ...link.teamId ? {
                teamId: link.teamId.trim()
            } : {}
        };
        const response = await this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links`, sanitisedTeamLink);
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async updateTeamLink(teamId, linkId, { linkUri: linkUri, ...linkFields }) {
        const response = await this.putResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`, {
            linkUri: linkUri.trim(),
            ...linkFields
        });
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async deleteTeamLink(teamId, linkId) {
        return this.deleteResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`);
    }
    async reorderTeamLink(teamId, linkId, newPosition) {
        const queryArgs = `?linkId=${linkId}&newPosition=${newPosition}`;
        return this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/order${queryArgs}`);
    }
    async getOrgEligibilityForManagedTeams() {
        const orgId = this.getOrgId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgEligibilityForManagedTeams');
            throw err;
        }
        return this.getResourceCached(`${$0ee15fca28d044a8$var$v4UrlPath}/org/${orgId}/premium/eligibility`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async acceptTeamInvitation(teamId) {
        return this.postResource(`${$0ee15fca28d044a8$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/accept`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async declineTeamInvitation(teamId) {
        return this.postResource(`${$0ee15fca28d044a8$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/decline`);
    }
    async selfJoinTeam(// TODO Test me
    teamId, originQuery) {
        const url = `${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/join?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url);
    }
    async addAgentsToTeam(teamId, agents) {
        if (!agents || agents.length === 0) {
            const missingAgentsError = new Error('Missing agents to add');
            this.logException(missingAgentsError, 'addAgentToTeam');
            throw missingAgentsError;
        }
        try {
            const url = `${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/agents`;
            return this.postResource(url, {
                agents: agents
            });
        } catch (e) {
            this.logException(e, 'addAgentToTeam');
            throw e;
        }
    }
    async removeAgentTeamAssociation(teamId, agentId) {
        try {
            const url = `${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/agents/${agentId}`;
            return this.deleteResource(url);
        } catch (e) {
            this.logException(e, 'removeAgentTeamAssociation');
            throw e;
        }
    }
    async cancelJoinRequest(teamId) {
        return this.deleteResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/request`);
    }
    async acceptJoinRequest(teamId, memberId) {
        return this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/accept`);
    }
    async declineJoinRequest(teamId, memberId) {
        return this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/decline`);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.removeTeamMemberships instead
	 */ async deleteTeamMembership(teamId, memberId) {
        return this.deleteResource(`${$0ee15fca28d044a8$var$v3UrlPath}/${this.trimTeamARI(teamId)}/members/${memberId}`);
    }
    /**
	 * @private
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(teamId, memberId) {
        return this.deleteResource(`${$0ee15fca28d044a8$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/${memberId}/revoke`);
    }
    async deleteTeam(teamId) {
        return this.deleteResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}`);
    }
    async archiveTeam(teamId) {
        const siteId = this.getCloudId();
        return this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/archive?siteId=${siteId}`);
    }
    async unArchiveTeam(teamId) {
        const siteId = this.getCloudId();
        return this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/unarchive?siteId=${siteId}`);
    }
    async unlinkTeamFromGroup(teamId, membershipSettings) {
        return this.patchResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, {
            membershipSettings: membershipSettings
        });
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        // This is still not working...
        const members = await this.getResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/members?size=2&membershipState=FULL_MEMBER&siteId=${this.getCloudId()}`);
        return members.entities.length === 1;
    }
    async createTeam(displayName, originQuery, members, membershipSettings = 'OPEN', typeId) {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$0ee15fca28d044a8$var$v4UrlPath}?${this.constructProductOriginParams(originQuery)}`;
        const legionTeam = await this.postResource(url, {
            displayName: displayName,
            description: '',
            membershipSettings: membershipSettings,
            siteId: this.getCloudId(),
            organizationId: organizationId,
            members: [
                ...new Set(members)
            ],
            typeId: typeId
        });
        return this.mapTeamCreateResponseV4ToTeam(legionTeam);
    }
    async createExternalTeam(description, externalReference, teamName, siteId) {
        const organizationId = this.getContext().orgId;
        const cloudId = this.getContext().cloudId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$0ee15fca28d044a8$var$v4UrlPath}/external?origin.cloudId=${encodeURIComponent(this.getCloudId(siteId || cloudId))}`;
        const legionExternalTeam = await this.postResource(url, {
            description: description,
            externalReference: externalReference,
            organizationId: organizationId,
            siteId: siteId || cloudId,
            displayName: teamName
        });
        return this.mapTeamCreateResponseV4ToTeam(legionExternalTeam);
    }
    async getTeamAndGroupDiff(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/diff`, {
            siteId: siteId,
            externalReference: externalReference
        });
    }
    async linkExistingTeamToGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/link`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async getWriteMediaToken() {
        return this.getResource('/v4/teams/header-image/media-upload').then((response)=>({
                ...response,
                baseUrl: response.baseUrl?.endsWith('/') ? response.baseUrl.slice(0, -1) : response.baseUrl
            }));
    }
    async getSoftDeletedTeamById(teamId) {
        const orgId = this.getOrgId();
        const siteId = this.getCloudId();
        return this.getResource(`${$0ee15fca28d044a8$var$v4UrlPath}/org/${orgId}/soft-deleted/${this.trimTeamARI(teamId)}?siteId=${siteId}`).then((response)=>({
                ...response.teamResponse,
                id: teamId
            }));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 */ async getUserInSiteUserBase(userId) {
        const siteId = this.getCloudId();
        return this.getResource(`/teams/site/${siteId}/users/${userId}/exists`, {
            headers: {
                Accept: 'application/json',
                'X-header-client-id': 'ptc-fe'
            }
        });
    }
    async retrieveBrowseUserPermission(product) {
        return this.getResourceCached(`/teams/site/${this.getCloudId()}/canSearchUsers?product=${product}`, undefined, // 2 minute expiration, resolves duplicate calls in initial load
        {
            expiration: 120000
        });
    }
    async getPermissions() {
        const orgId = this.getContext().orgId;
        const siteId = this.getCloudId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getPermissions');
            throw err;
        }
        return this.getResourceCached(`${$0ee15fca28d044a8$var$v4UrlPath}/permission/self/organization/${orgId}?siteId=${siteId}`);
    }
    async getLinkedTeamsBulk(groupIds) {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getLinkedTeamsBulk');
            throw err;
        }
        const legionExternalTeam = await this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/external/bulk`, {
            organizationId: organizationId,
            source: 'ATLASSIAN_GROUP',
            externalIds: groupIds
        });
        return legionExternalTeam;
    }
    async getTeamProfileDetails(teamId, siteId) {
        const finalSiteId = siteId || this.getCloudId();
        if (!finalSiteId) {
            const err = new Error('Site ID is required');
            this.logException(err, 'getTeamProfileDetails');
            throw err;
        }
        const linkedTeamsProfileDetails = await this.getResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${teamId}/profile?siteId=${finalSiteId}`);
        return linkedTeamsProfileDetails;
    }
    async getOrgScope() {
        const orgId = this.getContext().orgId;
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgScope');
            throw err;
        }
        const orgScope = await this.getResourceCached(`${$0ee15fca28d044a8$var$v4UrlPath}/org/${orgId}/scope`);
        return orgScope;
    }
    async restoreTeamToSyncedGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return await this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/${teamId}/external/restore`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async createTeamContainers(payload) {
        return this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/containers`, {
            ...payload
        });
    }
    async getTeamEnabledSites(teamId) {
        const teamEnabledSites = await this.getResourceCached(`${$0ee15fca28d044a8$var$v4UrlPath}/migrations/scope/${teamId}`);
        return teamEnabledSites;
    }
    async assignTeamsToSites(migrations) {
        const assignTeamsToSitesResponse = await this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/migrations/scope`, {
            originOrgId: this.getContext().orgId,
            migrations: migrations
        });
        return assignTeamsToSitesResponse;
    }
    async getTeamsToBeClonedToJsmSites(teamsToSiteScope) {
        return this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/migrations/scope/review`, {
            orgId: this.getContext().orgId,
            teamsToSiteScope: teamsToSiteScope
        });
    }
    async setTeamSiteAssignmentPermission(orgId, alignmentPermission) {
        return this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/migrations/scope/permissions`, {
            orgId: orgId,
            alignmentPermission: alignmentPermission
        });
    }
    async getAssignedTeams(orgId, count, cursor, displayNameContains) {
        const assignedTeamsResponse = await this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/migrations/scope/aligned/search`, {
            orgId: orgId,
            count: count,
            cursor: cursor,
            displayNameContains: displayNameContains
        });
        return assignedTeamsResponse;
    }
    async getUnassignedTeams(orgId, count, cursor, query) {
        const unassignedTeamsResponse = await this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/migrations/scope/unaligned/search`, {
            orgId: orgId,
            count: count,
            cursor: cursor,
            query: query
        });
        return unassignedTeamsResponse;
    }
    async getTeamSiteAssignmentOrgDetails() {
        const orgId = this.getContext().orgId;
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getTeamSiteAssignmentOrgDetails');
            throw err;
        }
        return this.getResource(`${$0ee15fca28d044a8$var$v4UrlPath}/migrations/scope/details/${orgId}`);
    }
    // some Legion APIs return team id with the team ARI
    trimTeamARI(teamId = '') {
        const OLD_TEAM_ARI_PREFIX = 'ari:cloud:teams::team/';
        const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
        return teamId.replace(TEAM_ARI_PREFIX, '').replace(OLD_TEAM_ARI_PREFIX, ''); // PTC-4213 will remove the references to the old team ARI
    }
    constructProductOriginParams(originQuery) {
        const product = (originQuery.product || '').toUpperCase();
        const queries = [
            `origin.cloudId=${encodeURIComponent(this.getCloudId(originQuery.cloudId))}`
        ];
        if (product) queries.push(`origin.product=${encodeURIComponent(product)}`);
        return queries.join('&');
    }
    mapTeamResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            scopeMode: teamResponse.scopeMode,
            isVerified: teamResponse.isVerified,
            ...teamResponse.externalReference && {
                externalReference: {
                    id: teamResponse.externalReference.id,
                    source: teamResponse.externalReference.source
                }
            }
        };
    }
    mapTeamCreateResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            memberIds: teamResponse.membership?.members?.map((m)=>m.membershipId.memberId) || [],
            membership: teamResponse.membership
        };
    }
    mapTeamSearchResponseV4ToTeamWithMembership(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            memberCount: teamResponse.memberCount,
            includesYou: teamResponse.includesYou,
            memberIds: [],
            members: [],
            membership: {
                members: [],
                errors: []
            },
            isVerified: teamResponse.isVerified
        };
    }
    mapLegionTeamLinksResponseV3ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV3ToTeamLink)
        };
    }
    mapLegionTeamLinksResponseV4ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV4ToTeamLink)
        };
    }
    mapLegionTeamLinkResponseV3ToTeamLink(legionLinkResponseV3) {
        return {
            contentTitle: legionLinkResponseV3.contentTitle,
            description: legionLinkResponseV3.description,
            creationTime: legionLinkResponseV3.creationTime,
            linkUri: legionLinkResponseV3.linkUri,
            linkId: legionLinkResponseV3.linkId,
            teamId: legionLinkResponseV3.teamId
        };
    }
    mapLegionTeamLinkResponseV4ToTeamLink(legionLinkResponseV4) {
        return {
            contentTitle: legionLinkResponseV4.contentTitle,
            description: legionLinkResponseV4.description,
            linkUri: legionLinkResponseV4.linkUri,
            linkId: legionLinkResponseV4.linkId,
            teamId: legionLinkResponseV4.teamId
        };
    }
    checkOrgFullAlignmentStatus(orgId) {
        try {
            return this.getResource(`${$0ee15fca28d044a8$var$v4UrlPath}/migrations/scope/${orgId}/fully-aligned`);
        } catch (e) {
            this.logException(e, 'checkOrgFullAlignmentStatus');
            throw e;
        }
    }
    async getTeamStatesInBulk(orgId, teamIds) {
        try {
            return this.postResource(`${$0ee15fca28d044a8$var$v4UrlPath}/adminhub/states/bulk`, {
                orgId: orgId,
                teamIds: teamIds
            });
        } catch (e) {
            this.logException(e, 'getTeamStatesInBulk');
            throw e;
        }
    }
}
const $0ee15fca28d044a8$export$95c697fe95d86a77 = new $0ee15fca28d044a8$export$68a6a391e3cf23be((0, $aggzG.DEFAULT_CONFIG).stargateRoot);

});

parcelRegister("awdTv", function(module, exports) {
$parcel$export(module.exports, "default", () => $6542e6150afaf749$export$2e2bcd8739ae039);

var $8EKfm = parcelRequire("8EKfm");

var $aggzG = parcelRequire("aggzG");

var $87xLf = parcelRequire("87xLf");
const $6542e6150afaf749$var$defaultConfig = {
    serviceUrl: `${(0, $aggzG.DEFAULT_CONFIG).stargateRoot}/users/manage`
};
const $6542e6150afaf749$var$NOT_EDITABLE = 'not_editable';
const $6542e6150afaf749$var$NOT_EDITABLE_FIELD = 'field';
const $6542e6150afaf749$var$NOT_EDITABLE_REASON = 'reason';
class $6542e6150afaf749$export$1f387592ab3ca6d0 extends (0, $87xLf.RestClient) {
    constructor(config = {}){
        super({
            ...$6542e6150afaf749$var$defaultConfig,
            ...config
        });
    }
    async getProfileWithMutability(userId) {
        return this.getResource(`/${userId}/profile`).then((resp)=>{
            return $6542e6150afaf749$var$mapToMutabilityConstraints(resp);
        });
    }
}
function $6542e6150afaf749$var$mapToMutabilityConstraints(json) {
    let constraints = [];
    if (json[$6542e6150afaf749$var$NOT_EDITABLE] != null) for (const value of json[$6542e6150afaf749$var$NOT_EDITABLE])constraints = constraints.concat({
        field: value[$6542e6150afaf749$var$NOT_EDITABLE_FIELD],
        reason: $6542e6150afaf749$var$determineReason(value[$6542e6150afaf749$var$NOT_EDITABLE_REASON])
    });
    return constraints;
}
function $6542e6150afaf749$var$determineReason(value) {
    switch(value){
        case 'managed':
        case 'ext.dir.scim':
        case 'ext.dir.google':
            return value;
        default:
            throw new (0, $8EKfm.DefaultError)({
                message: `Unknown mutability constraint reason: ${value}`
            });
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $6542e6150afaf749$var$_default_1 = new $6542e6150afaf749$export$1f387592ab3ca6d0();
var $6542e6150afaf749$export$2e2bcd8739ae039 = $6542e6150afaf749$var$_default_1;

});

parcelRegister("gSw7z", function(module, exports) {
$parcel$export(module.exports, "default", () => $66652dec235f03cd$export$2e2bcd8739ae039);

var $aggzG = parcelRequire("aggzG");

var $87xLf = parcelRequire("87xLf");

var $cMzVv = parcelRequire("cMzVv");
const $66652dec235f03cd$var$defaultConfig = {
    serviceUrl: `${(0, $aggzG.DEFAULT_CONFIG).stargateRoot}`
};
class $66652dec235f03cd$export$a78b00aedb6cb3e9 extends (0, $87xLf.RestClient) {
    constructor(config = {}){
        super({
            ...$66652dec235f03cd$var$defaultConfig,
            ...config
        });
    }
    async getTeamLinkIcons(teamLinkUrls) {
        const requestBody = teamLinkUrls.map((url)=>({
                resourceUrl: url
            }));
        return this.postResourceRaw(`/object-resolver/resolve/batch`, JSON.stringify(requestBody)).then((0, $cMzVv.transformIconData));
    }
    async getAriFromUrl(url) {
        return this.postResourceRaw(`/object-resolver/converter/toAri`, JSON.stringify({
            resourceUrl: url
        })).then((response)=>response?.data?.ari);
    }
    async getWebLinkTitle(webLinkUrl) {
        try {
            const response = await this.postResourceRaw('/object-resolver/resolve', JSON.stringify({
                resourceUrl: webLinkUrl
            }));
            if (response && 'data' in response) {
                if (response.data?.name) return response.data.name;
            }
            if (response && 'meta' in response && (response.meta?.visibility === 'restricted' || response.meta?.visibility === 'unauthorized')) {
                const auth = response.meta.auth?.[0];
                if (auth?.displayName) return auth.displayName;
            }
            return;
        } catch (error) {
            return;
        }
    }
}
const $66652dec235f03cd$var$_default_1 = new $66652dec235f03cd$export$a78b00aedb6cb3e9();
var $66652dec235f03cd$export$2e2bcd8739ae039 = $66652dec235f03cd$var$_default_1;

});
parcelRegister("cMzVv", function(module, exports) {
$parcel$export(module.exports, "transformIconData", () => $eaded71c25627eec$export$39f4468adf4cb57c);

var $dMeIP = parcelRequire("dMeIP");
const $eaded71c25627eec$export$c64ca1c808335e8b = (jsonLd)=>{
    const { url: url, generator: { name: name, icon: icon } } = jsonLd;
    switch(name){
        case (0, $dMeIP.ProviderNames).CONFLUENCE:
            return {
                linkUrl: url,
                iconUrl: $eaded71c25627eec$var$getConfluenceFavicon(url),
                productName: name
            };
        case (0, $dMeIP.ProviderNames).JIRA:
            return {
                linkUrl: url,
                iconUrl: $eaded71c25627eec$var$getJiraFavicon(url),
                productName: name
            };
        default:
            return {
                linkUrl: url,
                iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                productName: name
            };
    }
};
const $eaded71c25627eec$var$isIconItemSuccess = (response)=>{
    return response.status === 200;
};
const $eaded71c25627eec$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($eaded71c25627eec$var$isIconItemSuccess).map((resp)=>resp.body.data).map($eaded71c25627eec$export$c64ca1c808335e8b).filter((linkIconData)=>linkIconData.iconUrl !== undefined);
const $eaded71c25627eec$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
const $eaded71c25627eec$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;

});
parcelRegister("dMeIP", function(module, exports) {
$parcel$export(module.exports, "ProviderNames", () => $f965f3db138f7fda$export$132d457a8475f4c8);
/**
 * This type matches the props for the TeamLinkIcon component in embeddable-directory
 */ var $f965f3db138f7fda$export$132d457a8475f4c8 = /*#__PURE__*/ function(ProviderNames) {
    ProviderNames["CONFLUENCE"] = "Confluence";
    ProviderNames["JIRA"] = "Jira";
    return ProviderNames;
}({});

});



parcelRegister("gOYld", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a450cc9674219d2$export$2e2bcd8739ae039);

var $aggzG = parcelRequire("aggzG");

var $87xLf = parcelRequire("87xLf");
class $3a450cc9674219d2$export$23820d8d740dd467 extends (0, $87xLf.RestClient) {
    getIsSiteAdmin(/**
		 * @private
		 * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
		 */ cloudId) {
        return this.postResource('/permitted', {
            permissionId: 'manage',
            resourceId: `ari:cloud:platform::site/${this.getCloudId(cloudId)}`
        }).then((response)=>response.permitted);
    }
}
/**
 * REST Client to make calls to resources on the activity service.
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
const $3a450cc9674219d2$var$_default_1 = new $3a450cc9674219d2$export$23820d8d740dd467({
    serviceUrl: (0, $aggzG.DEFAULT_CONFIG).permsServiceUrl
});
var $3a450cc9674219d2$export$2e2bcd8739ae039 = $3a450cc9674219d2$var$_default_1;

});

parcelRegister("bFgTl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb42bb8acb39f893$export$2e2bcd8739ae039);

var $8EKfm = parcelRequire("8EKfm");

var $aggzG = parcelRequire("aggzG");

var $87xLf = parcelRequire("87xLf");
const $fb42bb8acb39f893$var$V1_URL = '/teams/v1';
const $fb42bb8acb39f893$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE = [
    'TEAM_NOT_FOUND'
];
class $fb42bb8acb39f893$export$38575d07403d67c extends (0, $87xLf.RestClient) {
    constructor(serviceUrlRoot){
        super({
            serviceUrl: serviceUrlRoot
        });
    }
    async addUsersToTeam(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to add');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$fb42bb8acb39f893$var$V1_URL}/org/${orgId}/teams/${teamId}/members/add`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'addUsersToTeam');
            if (e instanceof (0, $8EKfm.HttpError) && $fb42bb8acb39f893$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE.includes(e.message)) throw new (0, $8EKfm.SLOIgnoreHttpError)(e);
            throw e;
        }
    }
    async removeTeamMemberships(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to remove');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$fb42bb8acb39f893$var$V1_URL}/org/${orgId}/teams/${teamId}/members/remove`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'removeTeamMemberships');
            throw e;
        }
    }
    async getTeamDetails(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$fb42bb8acb39f893$var$V1_URL}/org/${orgId}/teams/${teamId}`;
            const response = await this.getResource(url);
            return response;
        } catch (e) {
            this.logException(e, 'getTeamDetails');
            throw e;
        }
    }
    async getTeamMembers(teamId, first = 50, after) {
        try {
            const orgId = this.getOrgId();
            const url = `${$fb42bb8acb39f893$var$V1_URL}/org/${orgId}/teams/${teamId}/members`;
            const response = await this.postResource(url, {
                after: after,
                first: first
            });
            return response;
        } catch (e) {
            this.logException(e, 'getTeamMembers');
            throw e;
        }
    }
    async restoreTeam(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$fb42bb8acb39f893$var$V1_URL}/org/${orgId}/teams/${teamId}/restore`;
            return this.postResource(url);
        } catch (e) {
            this.logException(e, 'restoreTeam');
            throw e;
        }
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $fb42bb8acb39f893$var$_default_1 = new $fb42bb8acb39f893$export$38575d07403d67c((0, $aggzG.DEFAULT_CONFIG).publicApiRoot);
var $fb42bb8acb39f893$export$2e2bcd8739ae039 = $fb42bb8acb39f893$var$_default_1;

});

parcelRegister("17Zgd", function(module, exports) {
$parcel$export(module.exports, "default", () => $61d4ef20e2998ccd$export$2e2bcd8739ae039);

var $aggzG = parcelRequire("aggzG");

var $87xLf = parcelRequire("87xLf");
const $61d4ef20e2998ccd$var$defaultConfig = {
    serviceUrl: `${(0, $aggzG.DEFAULT_CONFIG).stargateRoot}/user-tenure/v1`
};
class $61d4ef20e2998ccd$export$e019a6241c871c27 extends (0, $87xLf.RestClient) {
    constructor(config = {}){
        super({
            ...$61d4ef20e2998ccd$var$defaultConfig,
            ...config
        });
    }
    async getUserTenure(userId) {
        const orgId = this.getOrgId();
        return this.getResource(`/${orgId}/${userId}`).then((response)=>({
                ...response,
                userHireDate: new Date(response.userHireDate)
            })).catch((_error)=>{
            throw new Error('Failed to fetch user tenure');
        });
    }
}
const $61d4ef20e2998ccd$var$_default_1 = new $61d4ef20e2998ccd$export$e019a6241c871c27();
var $61d4ef20e2998ccd$export$2e2bcd8739ae039 = $61d4ef20e2998ccd$var$_default_1;

});

parcelRegister("3D4pj", function(module, exports) {
$parcel$export(module.exports, "default", () => $660eb7f54d1c2a3e$export$2e2bcd8739ae039);

var $aggzG = parcelRequire("aggzG");

var $hCAQL = parcelRequire("hCAQL");

var $gsIZ0 = parcelRequire("gsIZ0");

var $lR87V = parcelRequire("lR87V");
const $660eb7f54d1c2a3e$var$SERVICE_URL = `${(0, $aggzG.DEFAULT_CONFIG).stargateRoot}/watermelon/graphql`;
class $660eb7f54d1c2a3e$export$59b34df773148edd extends (0, $hCAQL.BaseGraphQlClient) {
    constructor(config){
        super($660eb7f54d1c2a3e$var$SERVICE_URL, config);
    }
    async getReportingLines(userId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $lR87V.default),
            variables: {
                aaid: userId
            }
        }, {
            operationName: 'ReportingLines'
        });
        return response;
    }
}
const $660eb7f54d1c2a3e$var$_default_1 = new $660eb7f54d1c2a3e$export$59b34df773148edd({
    logException: $gsIZ0.logException
});
var $660eb7f54d1c2a3e$export$2e2bcd8739ae039 = $660eb7f54d1c2a3e$var$_default_1;

});
parcelRegister("lR87V", function(module, exports) {
$parcel$export(module.exports, "default", () => $25057b6d1b5c180f$export$2e2bcd8739ae039);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $25057b6d1b5c180f$var$_default_1 = (0, $3a78v.print)((0, $aQEaU.default)`
	fragment ReportingLinesUserPII on UserPII {
		name
		picture
		accountStatus
		extendedProfile {
			jobTitle
		}
	}

	fragment ReportingLinesUserFragment on ReportingLinesUser {
		accountIdentifier
		identifierType
		numberOfDirectReports
		numberOfTotalReports
		pii {
			...ReportingLinesUserPII
		}
	}

	query ReportingLines($aaid: String) {
		reportingLines(aaidOrHash: $aaid) {
			lastModifiedDate
			user {
				...ReportingLinesUserFragment
			}
			managers {
				...ReportingLinesUserFragment
			}
			peers {
				...ReportingLinesUserFragment
			}
			reports {
				...ReportingLinesUserFragment
			}
		}
	}
`);
var $25057b6d1b5c180f$export$2e2bcd8739ae039 = $25057b6d1b5c180f$var$_default_1;

});


parcelRegister("j6Q5F", function(module, exports) {
$parcel$export(module.exports, "default", () => $97b96e0dad4011eb$export$2e2bcd8739ae039);

var $aggzG = parcelRequire("aggzG");

var $hCAQL = parcelRequire("hCAQL");

var $gsIZ0 = parcelRequire("gsIZ0");

var $gl98Q = parcelRequire("gl98Q");

var $1E0LM = parcelRequire("1E0LM");

var $rz2n7 = parcelRequire("rz2n7");

var $1uzMP = parcelRequire("1uzMP");

var $6uigj = parcelRequire("6uigj");

var $l9lcq = parcelRequire("l9lcq");

var $gIiSq = parcelRequire("gIiSq");

var $gIs6L = parcelRequire("gIs6L");

var $9Hc0Z = parcelRequire("9Hc0Z");

var $kw6Uf = parcelRequire("kw6Uf");
class $97b96e0dad4011eb$export$de0359e19b851166 extends (0, $hCAQL.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super((0, $kw6Uf.getUnshardedTeamCentralGraphqlUrl)(baseUrl), config);
    }
    // Team central url is a bit special, that it depends on cloudId.
    setBaseUrl(baseUrl) {
        const cloudId = this.getCloudId();
        this.setServiceUrl(cloudId && cloudId !== 'None' ? (0, $kw6Uf.getTeamCentralGraphqlUrl)(baseUrl, cloudId) : (0, $kw6Uf.getUnshardedTeamCentralGraphqlUrl)(baseUrl));
    }
    async isTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $gIs6L.IsTeamWatcherQuery),
            variables: {
                teamId: teamId.replace('ari:cloud:identity::team/', ''),
                cloudId: cloudId || 'None'
            }
        }, {
            operationName: 'isTeamWatcher'
        });
        return response.isTeamWatcher;
    }
    async addTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $gl98Q.AddTeamWatcherMutation),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'addTeamWatcher'
        });
        return response.addTeamWatcher;
    }
    async removeTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $gIiSq.RemoveTeamWatcherMutation),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'removeTeamWatcher'
        });
        return response.removeTeamWatcher;
    }
    async deleteKudos(id) {
        const response = await this.makeGraphQLRequest({
            query: (0, $l9lcq.KudosDeleteMutation),
            variables: {
                id: id
            }
        }, {
            operationName: 'DeleteKudos'
        });
        return response.deleteKudos;
    }
    async queryTagList(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $9Hc0Z.TagListQuery),
            variables: variables
        }, {
            operationName: 'TagListByCloudId'
        });
        return response.tagSearchByCloudId;
    }
    async createTag(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $1E0LM.CreateTagMutation),
            variables: variables
        }, {
            operationName: 'createTagForCloudId'
        });
        return response.createTagForCloudId;
    }
    async createHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $rz2n7.HelpPointerCreateMutation),
            variables: variables
        }, {
            operationName: 'CreateHelpPointer'
        });
        return response.createHelpPointer;
    }
    async updateHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $6uigj.HelpPointerUpdateMutation),
            variables: variables
        }, {
            operationName: 'UpdateHelpPointer'
        });
        return response.updateHelpPointer;
    }
    async deleteHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $1uzMP.HelpPointerDeleteMutation),
            variables: variables
        }, {
            operationName: 'DeleteHelpPointer'
        });
        return response.deleteHelpPointer;
    }
}
const $97b96e0dad4011eb$var$_default_1 = new $97b96e0dad4011eb$export$de0359e19b851166((0, $aggzG.DEFAULT_CONFIG).stargateRoot, {
    logException: $gsIZ0.logException
});
var $97b96e0dad4011eb$export$2e2bcd8739ae039 = $97b96e0dad4011eb$var$_default_1;

});
parcelRegister("gl98Q", function(module, exports) {
$parcel$export(module.exports, "AddTeamWatcherMutation", () => $68f439b1539adc16$export$2af9f827ad8bcf83);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $68f439b1539adc16$export$2af9f827ad8bcf83 = (0, $3a78v.print)((0, $aQEaU.default)`
	mutation addTeamWatcher($teamId: String!, $cloudId: String) {
		addTeamWatcher(input: { teamId: $teamId, cloudId: $cloudId }) {
			isWatching
			__typename
		}
	}
`);

});

parcelRegister("1E0LM", function(module, exports) {
$parcel$export(module.exports, "CreateTagMutation", () => $c20f3db78e50c427$export$5e59562b4f09e8ef);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $c20f3db78e50c427$export$5e59562b4f09e8ef = (0, $3a78v.print)((0, $aQEaU.default)`
	mutation createTagForCloudId($name: String!, $cloudId: String!) {
		createTagForCloudId(input: { name: $name, cloudId: $cloudId }) {
			tag {
				id
				uuid
				name
			}
		}
	}
`);

});

parcelRegister("rz2n7", function(module, exports) {
$parcel$export(module.exports, "HelpPointerCreateMutation", () => $e5fcf401f1853a1b$export$a563da8c932d52b1);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $e5fcf401f1853a1b$export$a563da8c932d52b1 = (0, $3a78v.print)((0, $aQEaU.default)`
	mutation CreateHelpPointer(
		$cloudId: String!
		$description: String
		$icon: IconInput
		$tagUuids: [UUID]
		$link: String!
		$name: String!
		$teamId: String!
		$type: HelpPointerType!
	) {
		createHelpPointer(
			input: {
				cloudId: $cloudId
				description: $description
				icon: $icon
				tagUuids: $tagUuids
				link: $link
				name: $name
				teamId: $teamId
				type: $type
			}
		) {
			helpPointer {
				id
			}
		}
	}
`);

});

parcelRegister("1uzMP", function(module, exports) {
$parcel$export(module.exports, "HelpPointerDeleteMutation", () => $5a0720dcf8957364$export$558c9434019572a1);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $5a0720dcf8957364$export$558c9434019572a1 = (0, $3a78v.print)((0, $aQEaU.default)`
	mutation DeleteHelpPointer($id: ID!) {
		deleteHelpPointer(input: { id: $id }) {
			success
		}
	}
`);

});

parcelRegister("6uigj", function(module, exports) {
$parcel$export(module.exports, "HelpPointerUpdateMutation", () => $2471cd5c8998f1ac$export$95b572ae48a37250);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $2471cd5c8998f1ac$export$95b572ae48a37250 = (0, $3a78v.print)((0, $aQEaU.default)`
	mutation UpdateHelpPointer(
		$id: ID!
		$description: String
		$teamId: String
		$newTeamName: String
		$icon: IconInput
		$tagUuids: [UUID]
		$link: String
		$name: String
		$type: HelpPointerType
	) {
		updateHelpPointer(
			input: {
				id: $id
				description: $description
				icon: $icon
				tagUuids: $tagUuids
				link: $link
				teamId: $teamId
				newTeamName: $newTeamName
				name: $name
				type: $type
			}
		) {
			helpPointer {
				id
			}
		}
	}
`);

});

parcelRegister("l9lcq", function(module, exports) {
$parcel$export(module.exports, "KudosDeleteMutation", () => $a9c2134845f2bfa1$export$fc4c702e715ad2a4);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $a9c2134845f2bfa1$export$fc4c702e715ad2a4 = (0, $3a78v.print)((0, $aQEaU.default)`
	mutation DeleteKudos($id: ID!) {
		deleteKudos(input: { id: $id }) {
			success
			kudos {
				id
			}
		}
	}
`);

});

parcelRegister("gIiSq", function(module, exports) {
$parcel$export(module.exports, "RemoveTeamWatcherMutation", () => $a9e175678c56c4a8$export$d1957676c49feb6a);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $a9e175678c56c4a8$export$d1957676c49feb6a = (0, $3a78v.print)((0, $aQEaU.default)`
	mutation removeTeamWatcher($teamId: String!, $cloudId: String) {
		removeTeamWatcher(input: { teamId: $teamId, cloudId: $cloudId }) {
			isWatching
			__typename
		}
	}
`);

});

parcelRegister("gIs6L", function(module, exports) {
$parcel$export(module.exports, "IsTeamWatcherQuery", () => $3fb7c31f79b9f8cc$export$5deef0b43df462bc);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $3fb7c31f79b9f8cc$export$5deef0b43df462bc = (0, $3a78v.print)((0, $aQEaU.default)`
	query IsTeamWatcher($teamId: String!, $cloudId: String!) {
		isTeamWatcher: teamByTeamId(teamId: $teamId, cloudId: $cloudId) {
			watching
		}
	}
`);

});

parcelRegister("9Hc0Z", function(module, exports) {
$parcel$export(module.exports, "TagListQuery", () => $e30d0b6f1a90a3a0$export$2c592b5c06672873);

var $3a78v = parcelRequire("3a78v");

var $aQEaU = parcelRequire("aQEaU");
const $e30d0b6f1a90a3a0$export$2c592b5c06672873 = (0, $3a78v.print)((0, $aQEaU.default)`
	query TagListByCloudId($q: String!, $cloudId: String!, $first: Int) {
		tagSearchByCloudId(q: $q, cloudId: $cloudId, first: $first) {
			edges {
				node {
					id
					uuid
					name
					projects {
						count
					}

					goals {
						count
					}

					helpLinks {
						count
					}
				}
			}
		}
	}
`);

});

parcelRegister("kw6Uf", function(module, exports) {
$parcel$export(module.exports, "getTeamCentralGraphqlUrl", () => $f465f7583254603c$export$ada1892306a6b676);
$parcel$export(module.exports, "getUnshardedTeamCentralGraphqlUrl", () => $f465f7583254603c$export$71356c4826ea823a);
const $f465f7583254603c$export$ada1892306a6b676 = (baseUrl, cloudId)=>`${baseUrl}/townsquare/s/${cloudId}/graphql`;
const $f465f7583254603c$export$71356c4826ea823a = (baseUrl)=>`${baseUrl}/watermelon/graphql`;

});


parcelRegister("h35fJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a7e1ca5768d358a$export$2e2bcd8739ae039);

var $aggzG = parcelRequire("aggzG");

var $87xLf = parcelRequire("87xLf");
const $9a7e1ca5768d358a$var$defaultConfig = {
    serviceUrl: `${(0, $aggzG.DEFAULT_CONFIG).stargateRoot}/teamsslack/api/team`
};
class $9a7e1ca5768d358a$export$9509cbc6b0605446 extends (0, $87xLf.RestClient) {
    constructor(config = {}){
        super({
            ...$9a7e1ca5768d358a$var$defaultConfig,
            ...config
        });
    }
    async getTeamInSlack(teamId, teamName) {
        return this.getResource(`/${teamId}?teamName=${encodeURIComponent(teamName)}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async disconnectTeamInSlack(teamId) {
        return this.deleteResource(`/${teamId}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async updateTeamInSlack(teamId, channelId, usergroupHandle) {
        return this.postResource(`/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
}
const $9a7e1ca5768d358a$var$_default_1 = new $9a7e1ca5768d358a$export$9509cbc6b0605446();
var $9a7e1ca5768d358a$export$2e2bcd8739ae039 = $9a7e1ca5768d358a$var$_default_1;

});

parcelRegister("aR6cl", function(module, exports) {
$parcel$export(module.exports, "default", () => $3dcf2983fbd9b29d$export$2e2bcd8739ae039);

var $aggzG = parcelRequire("aggzG");

var $87xLf = parcelRequire("87xLf");
const $3dcf2983fbd9b29d$var$buildGetReadTokenURL = (accountId)=>`/api/user-image/${accountId}/header-image/read`;
class $3dcf2983fbd9b29d$export$3c27e20d1b94924 extends (0, $87xLf.RestClient) {
    async getReadMediaToken(accountId) {
        return this.getResource($3dcf2983fbd9b29d$var$buildGetReadTokenURL(accountId)).then((response)=>response);
    }
    async getWriteMediaToken() {
        return this.getResource('/api/user-image/header-image/write').then((response)=>response);
    }
    async updateUserHeaderImage(headerImageId) {
        return await this.putResource('/api/user-image/self/header-image', {
            headerImageId: headerImageId
        });
    }
}
const $3dcf2983fbd9b29d$var$_default_1 = new $3dcf2983fbd9b29d$export$3c27e20d1b94924({
    serviceUrl: (0, $aggzG.DEFAULT_CONFIG).stargateRoot
});
var $3dcf2983fbd9b29d$export$2e2bcd8739ae039 = $3dcf2983fbd9b29d$var$_default_1;

});


parcelRegister("eFLEa", function(module, exports) {
$parcel$export(module.exports, "transformPermissions", () => $530571ea97139c16$export$7fe0bfa353103198);
const $530571ea97139c16$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        switch(permission){
            case 'CAN_CREATE_TEAMS':
                return {
                    ...acc,
                    canCreateTeams: true
                };
            case 'CAN_VIEW_TEAMS':
                return {
                    ...acc,
                    canViewTeams: true
                };
            case 'CAN_ADMIN_TEAMS':
                return {
                    ...acc,
                    canAdminTeams: true
                };
            default:
                return acc;
        }
    }, {
        canCreateTeams: false,
        canViewTeams: false,
        canAdminTeams: false
    });
};

});



parcelRegister("hXmqP", function(module, exports) {
$parcel$export(module.exports, "PeopleMenuOverrides", () => $b058f625a3d3ebb2$export$c6e6fe52d34907dc);
var $b058f625a3d3ebb2$export$c6e6fe52d34907dc = /*#__PURE__*/ function(PeopleMenuOverrides) {
    PeopleMenuOverrides["createTeamsDisabled"] = "create-teams-disabled";
    PeopleMenuOverrides["viewTeamsDisabled"] = "view-teams-disabled";
    return PeopleMenuOverrides;
}({});

});



parcelRegister("M2KQ6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("iZe2c"),
    $4cvLQ("1hjuy")
]).then(()=>parcelRequire('fyzsg'));

});


parcelRegister("2wmyf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "TeamPickerEdit", () => $072708af00eb0049$export$cb5f622bec189851);
$parcel$export(module.exports, "TeamPickerEditEntryPointContent", () => $072708af00eb0049$export$93a79bad2594cfb5);
$parcel$export(module.exports, "default", () => $072708af00eb0049$export$2e2bcd8739ae039);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $l3GYm = parcelRequire("l3GYm");

var $6zTYs = parcelRequire("6zTYs");

var $2b39L = parcelRequire("2b39L");

var $aY2Yz = parcelRequire("aY2Yz");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $i8BNs = parcelRequire("i8BNs");


var $qfZuH = parcelRequire("qfZuH");

var $6cePc = parcelRequire("6cePc");

var $47ukV = parcelRequire("47ukV");

var $53rpp = parcelRequire("53rpp");
// FIXME: These are overrides for @atlaskit/select@15.6 -> react-select@4.3.x
//        Once @atlaskit/select@15.6 resolution has been removed from package.json
//        these should be removed as well. See PTC-6238.
const $072708af00eb0049$var$stylesOverrides = {
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    valueContainer: (base)=>({
            ...base,
            display: 'grid'
        }),
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    placeholder: (base)=>({
            ...base,
            position: undefined,
            top: undefined,
            left: undefined,
            transform: undefined
        })
};
const $072708af00eb0049$var$placeholderTeamEditSelectorMessage = (0, $7eNDO.defineMessage)({
    id: "issue-field-team.placeholder-team-edit-selector",
    defaultMessage: "Choose a team"
});
const $072708af00eb0049$var$defaultNoValueTextMessage = (0, $7eNDO.defineMessage)({
    id: "issue-field-team.default-no-value-text",
    defaultMessage: "None"
});
const $072708af00eb0049$export$cb5f622bec189851 = (props)=>{
    const $ = (0, $e7boj.c)(112);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    let ariaDescribedBy;
    let createTeamDialogTrigger;
    let defaultValue;
    let description;
    let fieldProps;
    let height;
    let menuPortalTarget;
    let name;
    let noValueText;
    let onBlur;
    let onChange;
    let siteId;
    let styles;
    let t0;
    let t1;
    let t10;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[0] !== props) {
        ({ siteId: siteId, defaultValue: defaultValue, isClearable: t0, isDisabled: t1, isInvalid: t2, autoFocus: t3, width: t4, height: height, debounceTime: t5, onChange: onChange, onBlur: onBlur, placeholder: t6, isDropdownMenuFixedAndLayered: t7, isMenuPositionFixed: t8, styles: styles, noValueText: noValueText, createTeamDialogTrigger: createTeamDialogTrigger, isCompact: t9, hasNoTeamOption: t10, description: description, name: name, menuPortalTarget: menuPortalTarget, ariaDescribedBy: ariaDescribedBy, ...fieldProps } = props);
        $[0] = props;
        $[1] = ariaDescribedBy;
        $[2] = createTeamDialogTrigger;
        $[3] = defaultValue;
        $[4] = description;
        $[5] = fieldProps;
        $[6] = height;
        $[7] = menuPortalTarget;
        $[8] = name;
        $[9] = noValueText;
        $[10] = onBlur;
        $[11] = onChange;
        $[12] = siteId;
        $[13] = styles;
        $[14] = t0;
        $[15] = t1;
        $[16] = t10;
        $[17] = t2;
        $[18] = t3;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
        $[22] = t7;
        $[23] = t8;
        $[24] = t9;
    } else {
        ariaDescribedBy = $[1];
        createTeamDialogTrigger = $[2];
        defaultValue = $[3];
        description = $[4];
        fieldProps = $[5];
        height = $[6];
        menuPortalTarget = $[7];
        name = $[8];
        noValueText = $[9];
        onBlur = $[10];
        onChange = $[11];
        siteId = $[12];
        styles = $[13];
        t0 = $[14];
        t1 = $[15];
        t10 = $[16];
        t2 = $[17];
        t3 = $[18];
        t4 = $[19];
        t5 = $[20];
        t6 = $[21];
        t7 = $[22];
        t8 = $[23];
        t9 = $[24];
    }
    const isClearable = t0 === undefined ? true : t0;
    const isDisabled = t1 === undefined ? false : t1;
    const isInvalid = t2 === undefined ? false : t2;
    const autoFocus = t3 === undefined ? false : t3;
    const width = t4 === undefined ? "100%" : t4;
    const debounceTime = t5 === undefined ? 300 : t5;
    let t11;
    if ($[25] !== formatMessage || $[26] !== t6) {
        t11 = t6 === undefined ? formatMessage($072708af00eb0049$var$placeholderTeamEditSelectorMessage) : t6;
        $[25] = formatMessage;
        $[26] = t6;
        $[27] = t11;
    } else t11 = $[27];
    const placeholder = t11;
    const isDropdownMenuFixedAndLayered = t7 === undefined ? false : t7;
    const isMenuPositionFixed = t8 === undefined ? false : t8;
    const isCompact = t9 === undefined ? true : t9;
    const hasNoTeamOption = t10 === undefined ? true : t10;
    const [isCreateButtonFocused, setIsCreateButtonFocused] = (0, $euxye.useState)(false);
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    const [isFooterFocused, setIsFooterFocused] = (0, $euxye.useState)(false);
    const [hasTeams, setHasTeams] = (0, $euxye.useState)(true);
    const [teamsFilter, setTeamsFilter] = (0, $euxye.useState)(null);
    let t12;
    bb0: {
        if (!(0, $i860n.fg)("enable_filter_settings_for_teams_field")) {
            t12 = false;
            break bb0;
        }
        t12 = teamsFilter === "ONLY_VERIFIED";
    }
    const isManagedTeamsEnabled = t12;
    let t13;
    if ($[28] !== formatMessage) {
        t13 = formatMessage($072708af00eb0049$var$defaultNoValueTextMessage);
        $[28] = formatMessage;
        $[29] = t13;
    } else t13 = $[29];
    const formattedNoValueText = t13;
    const [updatedPlaceholder, setUpdatedPlaceholder] = (0, $euxye.useState)(placeholder);
    const [inputQuery, setInputQuery] = (0, $euxye.useState)("");
    let t14;
    if ($[30] !== styles) {
        t14 = styles || {};
        $[30] = styles;
        $[31] = t14;
    } else t14 = $[31];
    let t15;
    if ($[32] !== t14) {
        t15 = {
            ...(0, $l3GYm.defaultSelectStyles),
            ...t14,
            ...$072708af00eb0049$var$stylesOverrides
        };
        $[32] = t14;
        $[33] = t15;
    } else t15 = $[33];
    const finalStyles = t15;
    const { data: project } = (0, $2b39L.useProjectContext)();
    let t16;
    if ($[34] !== name || $[35] !== project || $[36] !== siteId) {
        t16 = ()=>{
            if (name && siteId && (0, $i860n.fg)("enable_filter_settings_for_teams_field")) {
                const projectId = project?.projectId && (0, $i860n.fg)("_managed_team_graphql_fix_ken_4267") ? (0, $i8BNs.JiraProjectAri).create({
                    siteId: siteId,
                    projectId: project.projectId.toString()
                }).toString() : "";
                (0, $qfZuH.fetchTeamsFilter)(name, siteId, projectId).then(setTeamsFilter);
            }
        };
        $[34] = name;
        $[35] = project;
        $[36] = siteId;
        $[37] = t16;
    } else t16 = $[37];
    const t17 = project?.projectId;
    let t18;
    if ($[38] !== name || $[39] !== siteId || $[40] !== t17) {
        t18 = [
            name,
            siteId,
            t17
        ];
        $[38] = name;
        $[39] = siteId;
        $[40] = t17;
        $[41] = t18;
    } else t18 = $[41];
    (0, $euxye.useEffect)(t16, t18);
    let t19;
    if ($[42] !== defaultValue || $[43] !== formattedNoValueText || $[44] !== hasNoTeamOption || $[45] !== noValueText) {
        t19 = (users, query)=>{
            setHasTeams(!(users.length === 0 && query.length === 0));
            if (query === "" && !!defaultValue && hasNoTeamOption) return [
                {
                    id: (0, $972e0d003317efb6$export$53782b65600ab96d),
                    name: noValueText ?? formattedNoValueText,
                    isVerified: false,
                    type: "team"
                }
            ].concat(users);
            setIsCreateButtonFocused(query.length > 0 && users.length === 0);
            return users;
        };
        $[42] = defaultValue;
        $[43] = formattedNoValueText;
        $[44] = hasNoTeamOption;
        $[45] = noValueText;
        $[46] = t19;
    } else t19 = $[46];
    const maybeAddNoTeamOption = t19;
    let t20;
    if ($[47] !== formattedNoValueText || $[48] !== onChange || $[49] !== placeholder) {
        t20 = (newValue, actionType)=>{
            if (Array.isArray(newValue)) return;
            if (onChange) {
                onChange(newValue?.id === (0, $972e0d003317efb6$export$53782b65600ab96d) || !newValue ? null : newValue, actionType);
                setUpdatedPlaceholder(newValue?.id === (0, $972e0d003317efb6$export$53782b65600ab96d) || !newValue ? formattedNoValueText : placeholder);
            }
        };
        $[47] = formattedNoValueText;
        $[48] = onChange;
        $[49] = placeholder;
        $[50] = t20;
    } else t20 = $[50];
    const handleOnChange = t20;
    let t21;
    if ($[51] !== createTeamDialogTrigger || $[52] !== inputQuery) {
        t21 = ()=>{
            createTeamDialogTrigger(inputQuery);
        };
        $[51] = createTeamDialogTrigger;
        $[52] = inputQuery;
        $[53] = t21;
    } else t21 = $[53];
    const handleCreateTeam = t21;
    let t22;
    if ($[54] !== handleCreateTeam || $[55] !== isCreateButtonFocused || $[56] !== isManagedTeamsEnabled) {
        t22 = (event)=>{
            if (!isManagedTeamsEnabled && isCreateButtonFocused && event.key === "Enter") handleCreateTeam();
        };
        $[54] = handleCreateTeam;
        $[55] = isCreateButtonFocused;
        $[56] = isManagedTeamsEnabled;
        $[57] = t22;
    } else t22 = $[57];
    const handleOnKeyDown = t22;
    let t23;
    if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = (query_0)=>{
            setInputQuery(query_0 || "");
        };
        $[58] = t23;
    } else t23 = $[58];
    const handleOnInputChange = t23;
    let t24;
    if ($[59] !== handleCreateTeam || $[60] !== hasTeams || $[61] !== isCreateButtonFocused || $[62] !== isManagedTeamsEnabled) {
        t24 = hasTeams && (isManagedTeamsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $53rpp.VerifiedTeamFooter), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6cePc.CreateTeamOption), {
            isFocused: isCreateButtonFocused,
            onClick: handleCreateTeam,
            setIsFooterFocused: setIsFooterFocused
        }));
        $[59] = handleCreateTeam;
        $[60] = hasTeams;
        $[61] = isCreateButtonFocused;
        $[62] = isManagedTeamsEnabled;
        $[63] = t24;
    } else t24 = $[63];
    const footer = t24;
    let t25;
    if ($[64] !== handleCreateTeam || $[65] !== hasTeams) {
        t25 = !hasTeams ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $47ukV.TeamPickerEmptyState), {
                onActionClick: handleCreateTeam
            }) : undefined;
        $[64] = handleCreateTeam;
        $[65] = hasTeams;
        $[66] = t25;
    } else t25 = $[66];
    const noOptionsMessage = t25;
    let t26;
    if ($[67] !== hasTeams) {
        t26 = !hasTeams ? {
            menuList: $072708af00eb0049$var$_temp
        } : {};
        $[67] = hasTeams;
        $[68] = t26;
    } else t26 = $[68];
    const menuListStyle = t26;
    let t27;
    if ($[69] !== isDropdownMenuFixedAndLayered || $[70] !== isMenuPositionFixed) {
        t27 = ()=>{
            if (isMenuPositionFixed) return "fixed";
            return isDropdownMenuFixedAndLayered ? "absolute" : undefined;
        };
        $[69] = isDropdownMenuFixedAndLayered;
        $[70] = isMenuPositionFixed;
        $[71] = t27;
    } else t27 = $[71];
    const getMenuPosition = t27;
    const t28 = isCompact ? "compact" : "normal";
    let t29;
    if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
        t29 = (0, $2700E.expValEquals)("ai-a11y-exp-26553-open-on-focus", "cohort", "test") ? {
            openMenuOnFocus: false
        } : {};
        $[72] = t29;
    } else t29 = $[72];
    let t30;
    if ($[73] !== getMenuPosition) {
        t30 = getMenuPosition();
        $[73] = getMenuPosition;
        $[74] = t30;
    } else t30 = $[74];
    let t31;
    if ($[75] !== finalStyles || $[76] !== menuListStyle) {
        t31 = {
            ...finalStyles,
            ...menuListStyle
        };
        $[75] = finalStyles;
        $[76] = menuListStyle;
        $[77] = t31;
    } else t31 = $[77];
    const t32 = `${updatedPlaceholder} ${description}`;
    const t33 = fieldProps["aria-labelledby"];
    let t34;
    if ($[78] !== ariaDescribedBy) {
        t34 = ariaDescribedBy ? {
            ariaDescribedBy: ariaDescribedBy
        } : {};
        $[78] = ariaDescribedBy;
        $[79] = t34;
    } else t34 = $[79];
    let t35;
    if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
        t35 = (0, $i860n.fg)("a11y-create-team-is-not-focusable-and-has-no-btn") && {
            setIsFooterFocused: setIsFooterFocused
        };
        $[80] = t35;
    } else t35 = $[80];
    let t36;
    if ($[81] !== isFooterFocused) {
        t36 = (0, $i860n.fg)("a11y-create-team-is-not-focusable-and-has-no-btn") && {
            isFooterFocused: isFooterFocused
        };
        $[81] = isFooterFocused;
        $[82] = t36;
    } else t36 = $[82];
    let t37;
    if ($[83] !== isManagedTeamsEnabled) {
        t37 = isManagedTeamsEnabled && {
            verifiedTeams: true
        };
        $[83] = isManagedTeamsEnabled;
        $[84] = t37;
    } else t37 = $[84];
    let t38;
    if ($[85] !== autoFocus || $[86] !== debounceTime || $[87] !== defaultValue || $[88] !== footer || $[89] !== handleOnChange || $[90] !== handleOnKeyDown || $[91] !== height || $[92] !== isClearable || $[93] !== isDisabled || $[94] !== isInvalid || $[95] !== maybeAddNoTeamOption || $[96] !== menuPortalTarget || $[97] !== noOptionsMessage || $[98] !== onBlur || $[99] !== orgId || $[100] !== siteId || $[101] !== t28 || $[102] !== t30 || $[103] !== t31 || $[104] !== t32 || $[105] !== t33 || $[106] !== t34 || $[107] !== t36 || $[108] !== t37 || $[109] !== updatedPlaceholder || $[110] !== width) {
        t38 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aY2Yz.default), {
            width: width,
            height: height,
            autoFocus: autoFocus,
            appearance: t28,
            debounceTime: debounceTime,
            fieldId: "team",
            filterOptions: maybeAddNoTeamOption,
            footer: footer,
            includeGroups: false,
            includeTeams: true,
            includeUsers: false,
            isClearable: isClearable,
            isMulti: false,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            ...t29,
            productKey: "jira",
            siteId: siteId,
            value: defaultValue,
            onChange: handleOnChange,
            onBlur: onBlur,
            orgId: orgId,
            placeholder: updatedPlaceholder,
            menuPosition: t30,
            menuPortalTarget: menuPortalTarget,
            styles: t31,
            onInputChange: handleOnInputChange,
            onKeyDown: handleOnKeyDown,
            noOptionsMessage: noOptionsMessage,
            ariaLabel: t32,
            ariaLabelledBy: t33,
            ...t34,
            placeholderAvatar: "team",
            ...t35,
            ...t36,
            ...t37
        });
        $[85] = autoFocus;
        $[86] = debounceTime;
        $[87] = defaultValue;
        $[88] = footer;
        $[89] = handleOnChange;
        $[90] = handleOnKeyDown;
        $[91] = height;
        $[92] = isClearable;
        $[93] = isDisabled;
        $[94] = isInvalid;
        $[95] = maybeAddNoTeamOption;
        $[96] = menuPortalTarget;
        $[97] = noOptionsMessage;
        $[98] = onBlur;
        $[99] = orgId;
        $[100] = siteId;
        $[101] = t28;
        $[102] = t30;
        $[103] = t31;
        $[104] = t32;
        $[105] = t33;
        $[106] = t34;
        $[107] = t36;
        $[108] = t37;
        $[109] = updatedPlaceholder;
        $[110] = width;
        $[111] = t38;
    } else t38 = $[111];
    return t38;
};
$072708af00eb0049$export$cb5f622bec189851.displayName = "TeamPickerEdit";
const $072708af00eb0049$export$93a79bad2594cfb5 = (t0)=>{
    const $ = (0, $e7boj.c)(2);
    const { props: props } = t0;
    let t1;
    if ($[0] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($072708af00eb0049$export$cb5f622bec189851, props);
        $[0] = props;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
$072708af00eb0049$export$93a79bad2594cfb5.displayName = "TeamPickerEditEntryPointContent";
var $072708af00eb0049$export$2e2bcd8739ae039 = $072708af00eb0049$export$93a79bad2594cfb5;
function $072708af00eb0049$var$_temp(base) {
    return {
        ...base,
        maxHeight: "350px"
    };
}

});
parcelRegister("l3GYm", function(module, exports) {
$parcel$export(module.exports, "defaultSelectStyles", () => $9881b15c4596e6b1$export$b12192ea1a215e5f);
$parcel$export(module.exports, "indicatorFixSelectStyles", () => $9881b15c4596e6b1$export$eca30945eaf474dd);
$parcel$export(module.exports, "workItemViewLoadingIndicatorFix", () => $9881b15c4596e6b1$export$fa5628893bd15003);

var $9kKfd = parcelRequire("9kKfd");
const $9881b15c4596e6b1$export$b12192ea1a215e5f = {
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $9kKfd.layers).modal
        }),
    menu: (base)=>({
            ...base,
            zIndex: (0, $9kKfd.layers).modal
        })
};
const $9881b15c4596e6b1$var$inputIconPaddingLeft = "var(--ds-space-025, 2px)";
const $9881b15c4596e6b1$var$inputIconPaddingRight = "var(--ds-space-050, 4px)";
const $9881b15c4596e6b1$export$eca30945eaf474dd = {
    // need to apply same padding to both loadingIndicator and clearIndicator - not to have input query jumping between lines e.g. in multi-select
    loadingIndicator: (base)=>({
            ...base,
            paddingLeft: $9881b15c4596e6b1$var$inputIconPaddingLeft,
            paddingRight: $9881b15c4596e6b1$var$inputIconPaddingRight
        }),
    clearIndicator: (base)=>({
            ...base,
            paddingLeft: $9881b15c4596e6b1$var$inputIconPaddingLeft,
            paddingRight: $9881b15c4596e6b1$var$inputIconPaddingRight
        })
};
const $9881b15c4596e6b1$export$fa5628893bd15003 = {
    loadingIndicator: (base)=>({
            ...base,
            paddingTop: 0,
            paddingBottom: 0
        })
};
const $9881b15c4596e6b1$export$a9f371909ef7b4d6 = {
    container: (base)=>({
            ...base,
            border: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-danger, #E2483D)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        })
};

});
parcelRegister("9kKfd", function(module, exports) {
$parcel$export(module.exports, "layers", () => $439b574ab6a8cb7f$export$7be255094ccdc533);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/restricted/@atlaskit+theme

var $akMu8 = parcelRequire("akMu8");
const $439b574ab6a8cb7f$var$mobileBannerIndex = 100;
const $439b574ab6a8cb7f$export$7be255094ccdc533 = {
    banner: (0, $akMu8.layers).navigation(),
    card: (0, $akMu8.layers).card(),
    dialog: (0, $akMu8.layers).dialog(),
    navigation: (0, $akMu8.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $akMu8.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $akMu8.layers).navigation() - 1,
    layer: (0, $akMu8.layers).layer(),
    blanket: (0, $akMu8.layers).blanket(),
    modal: (0, $akMu8.layers).modal(),
    flag: (0, $akMu8.layers).flag(),
    spotlight: (0, $akMu8.layers).spotlight(),
    tooltip: (0, $akMu8.layers).tooltip(),
    mobileBanner: $439b574ab6a8cb7f$var$mobileBannerIndex
};

});


parcelRegister("aY2Yz", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef7b778de6cf3ac6$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1XpRC = parcelRequire("1XpRC");

var $iIpBG = parcelRequire("iIpBG");

var $lmLyy = parcelRequire("lmLyy");
const $ef7b778de6cf3ac6$var$SmartUserPickerWithIntlProvider = (props)=>{
    const ufoId = props.inputId || props.fieldId;
    (0, $lmLyy.useUFOConcurrentExperience)((0, $lmLyy.smartUserPickerRenderedUfoExperience), ufoId);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lmLyy.UfoErrorBoundary), {
        id: ufoId,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iIpBG.default), {
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1XpRC.SmartUserPicker), {
                ...props
            })
        })
    });
};
$ef7b778de6cf3ac6$var$SmartUserPickerWithIntlProvider.displayName = "SmartUserPickerWithIntlProvider";
var $ef7b778de6cf3ac6$export$2e2bcd8739ae039 = $ef7b778de6cf3ac6$var$SmartUserPickerWithIntlProvider;

});
parcelRegister("1XpRC", function(module, exports) {
$parcel$export(module.exports, "SmartUserPicker", () => $22d5a025153193e6$export$9eedb6e5d313efdb);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $eVMQF = parcelRequire("eVMQF");

var $7TA2J = parcelRequire("7TA2J");

var $kTviw = parcelRequire("kTviw");

var $emCaV = parcelRequire("emCaV");

var $1jztF = parcelRequire("1jztF");

var $ff1v8 = parcelRequire("ff1v8");

var $jU3Mq = parcelRequire("jU3Mq");
var $1KHUB = parcelRequire("1KHUB");
var $gp9sb = parcelRequire("gp9sb");

var $iqfTZ = parcelRequire("iqfTZ");

var $korPW = parcelRequire("korPW");

var $iIpBG = parcelRequire("iIpBG");

var $hOUPX = parcelRequire("hOUPX");

var $hJiIs = parcelRequire("hJiIs");
var $67xwM = parcelRequire("67xwM");

var $lmLyy = parcelRequire("lmLyy");
const $22d5a025153193e6$var$DEFAULT_DEBOUNCE_TIME_MS = 150;
const $22d5a025153193e6$var$ufoEndStateConfig = (fieldId)=>{
    return {
        metadata: {
            contextType: fieldId
        }
    };
};
const $22d5a025153193e6$var$hasContextChanged = (oldContext, newContext)=>oldContext.siteId !== newContext.siteId || oldContext.orgId !== newContext.orgId || oldContext.userbaseId !== newContext.userbaseId || oldContext.productKey !== newContext.productKey || oldContext.principalId !== newContext.principalId || oldContext.containerId !== newContext.containerId || oldContext.objectId !== newContext.objectId || oldContext.childObjectId !== newContext.childObjectId;
const $22d5a025153193e6$var$stringContains = (str, substr)=>{
    if (str === null || str === undefined) return false;
    if (substr === null || substr === '' || substr === undefined) return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $22d5a025153193e6$var$getUsersForAnalytics = (users)=>(users || []).map(({ id: id, type: type })=>({
            id: id,
            type: type
        }));
const $22d5a025153193e6$var$checkIf500Event = (statusCode)=>500 <= statusCode && statusCode < 600;
const $22d5a025153193e6$var$isEmailQuery = (query)=>{
    return (0, $gp9sb.isValidEmail)(query.trim()) === 'VALID';
};
class $22d5a025153193e6$export$9b9bd453d1d4e4ce extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    static{
        this.defaultProps = {
            baseUrl: '',
            includeUsers: true,
            includeGroups: false,
            includeTeams: false,
            includeTeamsUpdates: false,
            includeNonLicensedUsers: false,
            displayEmailInByline: false,
            prefetch: false,
            principalId: 'Context',
            debounceTime: $22d5a025153193e6$var$DEFAULT_DEBOUNCE_TIME_MS,
            userResolvers: [],
            enableEmailSearch: false,
            allowEmailSelectionWhenEmailMatched: true,
            verifiedTeams: false
        };
    }
    constructor(props){
        super(props), this.state = {
            users: [],
            loading: false,
            closed: true,
            query: '',
            defaultValue: [],
            bootstrapOptions: []
        }, // Track if the last search was an email search that found matches
        this.lastEmailSearchFoundMatches = false, // Track if the domain-suggested email (`<query>@<suggestEmailsForDomain>`) for a partial
        // query already belongs to a returned user, in which case the suggestion is redundant
        this.lastDomainSuggestionMatchedUser = false, this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $ff1v8.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $korPW.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, ...args))(createAnalyticsEvent);
        }, this.filterOptions = (users, query, propFilterOptions)=>propFilterOptions ? propFilterOptions(users, query) : users, this.memoizedFilterOptions = (0, $emCaV.default)(this.filterOptions), this.getUsers = (0, (/*@__PURE__*/$parcel$interopDefault($eVMQF)))(async ()=>{
            const { query: query, sessionId: sessionId, closed: closed } = this.state;
            const { baseUrl: baseUrl, childObjectId: childObjectId, containerId: containerId, fieldId: fieldId, includeGroups: includeGroups, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, includeUsers: includeUsers, includeNonLicensedUsers: includeNonLicensedUsers, intl: intl, fetchOptions: fetchOptions, maxOptions: maxOptions, objectId: objectId, onEmpty: onEmpty, onError: onError, overrideByline: overrideByline, displayEmailInByline: displayEmailInByline, verifiedTeams: verifiedTeams, orgId: orgId, userbaseId: userbaseId, principalId: principalId, productAttributes: productAttributes, productKey: productKey, restrictTo: restrictTo, searchQueryFilter: searchQueryFilter, siteId: siteId, isTeamSyncedToGroupDirectoryFilter: isTeamSyncedToGroupDirectoryFilter, transformOptions: transformOptions, userResolvers: userResolvers, enableEmailSearch: enableEmailSearch } = this.props;
            const maxNumberOfResults = maxOptions || 100;
            const startTime = window.performance.now();
            // Check if this is an email search
            const isEmail = enableEmailSearch && $22d5a025153193e6$var$isEmailQuery(query);
            const recommendationsRequest = {
                baseUrl: baseUrl,
                context: {
                    containerId: containerId,
                    contextType: fieldId,
                    objectId: objectId,
                    principalId: principalId,
                    productKey: productKey,
                    siteId: siteId,
                    organizationId: orgId,
                    userbaseId: userbaseId,
                    childObjectId: childObjectId,
                    sessionId: sessionId,
                    productAttributes: productAttributes
                },
                includeUsers: includeUsers,
                includeGroups: // For email searches, disable groups and teams
                includeGroups,
                includeTeams: includeTeams,
                includeNonLicensedUsers: includeNonLicensedUsers,
                maxNumberOfResults: maxNumberOfResults,
                query: query,
                searchEmail: isEmail,
                ...verifiedTeams === true && {
                    verifiedTeams: true
                },
                /*
				For email-based searches, we have decided to filter out apps.
				Also - because the other 2 filters ((NOT not_mentionable:true) AND (account_status:active)) are included
				when filter is empty, they have been added here to maintain consistency.

				Further ref: https://developer.atlassian.com/platform/user-recommendations/guides/frequently-asked-questions/#filter-behavior
			 */ searchQueryFilter: isEmail && !searchQueryFilter ? '(NOT not_mentionable:true) AND (account_status:active) AND (NOT account_type:app)' : searchQueryFilter,
                ...restrictTo && {
                    restrictTo: restrictTo
                },
                ...isTeamSyncedToGroupDirectoryFilter === true && {
                    isTeamSyncedToGroupDirectoryFilter: true
                }
            };
            try {
                const { query: query } = this.state;
                this.fireEvent((0, $korPW.requestUsersEvent));
                let recommendedUsers;
                if (fetchOptions && (0, $iqfTZ.fg)('smart-user-picker-load-options-gate')) recommendedUsers = await fetchOptions(query);
                else {
                    const userRecommendationsPromise = (0, $hJiIs.default)(recommendationsRequest, intl);
                    const userResolversPromises = (userResolvers ?? []).map((resolver)=>resolver(query).catch((error)=>{
                            this.fireEvent((0, $korPW.failedUserResolversEvent), {
                                resolverName: resolver.name,
                                error: error
                            });
                            return [];
                        }));
                    const [mainRecommendations, ...userResolverResults] = await Promise.all([
                        userRecommendationsPromise,
                        ...userResolversPromises
                    ]);
                    recommendedUsers = [
                        mainRecommendations,
                        ...userResolverResults
                    ].flat();
                }
                if (overrideByline) {
                    for (let option of recommendedUsers)if ((0, $1KHUB.isUser)(option) || (0, $1KHUB.isExternalUser)(option) || (0, $1KHUB.isTeam)(option)) option.byline = overrideByline(option);
                }
                if (displayEmailInByline) {
                    for (let option of recommendedUsers)if ((0, $1KHUB.isUser)(option) || (0, $1KHUB.isExternalUser)(option)) {
                        if (option.userType === (0, $hOUPX.UserEntityType).DEFAULT || option.userType === (0, $hOUPX.UserEntityType).CUSTOMER) // Respect existing byline if present
                        {
                            if (option.email && !option.byline) option.byline = option.email;
                        }
                    }
                }
                if (includeTeamsUpdates) {
                    for (let option of recommendedUsers)if ((0, $1KHUB.isGroup)(option) || (0, $1KHUB.isTeam)(option)) option.includeTeamsUpdates = includeTeamsUpdates;
                }
                // Track if email search found matches for conditional allowEmail logic
                if (isEmail) {
                    // Only count user/external user matches, not teams or groups
                    const userMatches = recommendedUsers.filter((user)=>(0, $1KHUB.isUser)(user) || (0, $1KHUB.isExternalUser)(user));
                    this.lastEmailSearchFoundMatches = userMatches.length > 0;
                } else this.lastEmailSearchFoundMatches = false;
                // For a partial query with a suggested domain, check whether the email we would
                // synthesize (`<query>@<domain>`) already belongs to one of the returned users. If so,
                // the real user option is shown instead and the email suggestion is suppressed.
                const { suggestEmailsForDomain: suggestEmailsForDomain } = this.props;
                if (suggestEmailsForDomain && !isEmail && query) {
                    const suggestedEmail = `${query}@${suggestEmailsForDomain}`.toLowerCase();
                    this.lastDomainSuggestionMatchedUser = recommendedUsers.some((option)=>((0, $1KHUB.isUser)(option) || (0, $1KHUB.isExternalUser)(option)) && option.email?.toLowerCase() === suggestedEmail);
                } else this.lastDomainSuggestionMatchedUser = false;
                const elapsedTimeMilli = window.performance.now() - startTime;
                const transformedOptions = transformOptions ? await transformOptions(recommendedUsers, query) : recommendedUsers;
                const displayedUsers = transformedOptions.length === 0 && onEmpty ? await onEmpty(query) ?? [] : transformedOptions;
                this.setState((state)=>{
                    const applicable = state.query === query;
                    const users = applicable ? displayedUsers : state.users;
                    const loading = !applicable;
                    this.fireEvent((0, $korPW.successfulRequestUsersEvent), {
                        users: $22d5a025153193e6$var$getUsersForAnalytics(recommendedUsers),
                        elapsedTimeMilli: elapsedTimeMilli,
                        displayedUsers: $22d5a025153193e6$var$getUsersForAnalytics(displayedUsers),
                        productAttributes: productAttributes,
                        applicable: applicable,
                        userResolvers: Array.isArray(userResolvers) ? userResolvers.map((resolver)=>resolver.name) : []
                    });
                    return {
                        users: users,
                        loading: loading
                    };
                });
            } catch (e) {
                if (this.state.query !== query && (0, $iqfTZ.fg)('smart-user-picker-fetch-error-fix')) {
                    // The query has moved on since this request was sent, so its results are not the ones
                    // on screen. Applying the failure here would clear the options and fail the UFO
                    // experience that belong to the newer query.
                    this.fireEvent((0, $korPW.failedRequestUsersEvent), {
                        elapsedTimeMilli: window.performance.now() - startTime,
                        productAttributes: productAttributes
                    });
                    return;
                }
                const is5xxEvent = $22d5a025153193e6$var$checkIf500Event(e.statusCode);
                if (!closed && !onError && is5xxEvent) // If the user lookup fails while the menu is open, and the consumer is not providing a
                // fallback data source via the onError prop, then send UFO failure
                this.optionsShownUfoExperienceInstance.failure($22d5a025153193e6$var$ufoEndStateConfig(this.props.fieldId));
                this.setState({
                    users: []
                });
                let onErrorProducedError = false;
                let defaultUsers = [];
                try {
                    defaultUsers = onError ? await onError(e, recommendationsRequest) || [] : [];
                } catch  {
                    onErrorProducedError = true;
                }
                if (onErrorProducedError && is5xxEvent) // Log error from fallback data source `onError` to UFO
                this.optionsShownUfoExperienceInstance.failure($22d5a025153193e6$var$ufoEndStateConfig(this.props.fieldId));
                if (!is5xxEvent && (!onError && !closed || onErrorProducedError)) this.abortOptionsShownUfoExperience();
                this.setState({
                    users: defaultUsers,
                    loading: false
                });
                const elapsedTimeMilli = window.performance.now() - startTime;
                this.fireEvent((0, $korPW.failedRequestUsersEvent), {
                    elapsedTimeMilli: elapsedTimeMilli,
                    productAttributes: productAttributes
                });
            }
        }, this.props.debounceTime ?? 0), this.onInputChange = (newQuery, sessionId)=>{
            const query = newQuery || '';
            const { closed: closed } = this.state;
            if (query === this.state.query) return;
            if (!closed) {
                // If the input has been typed into and the dropdown has not been closed
                // (i.e. input blurred) then start the UFO timer.
                // If there's a previous UFO timer running for the same "options shown" experience,
                // it will be aborted first.
                this.startOptionsShownUfoExperience();
                this.setState({
                    loading: true,
                    query: query,
                    sessionId: sessionId
                });
                if (this.props.onInputChange) this.props.onInputChange(query, sessionId);
            }
        }, this.filterUsers = ()=>{
            const { loading: loading, users: users, query: query } = this.state;
            const filteredUsers = this.memoizedFilterOptions(users, query, this.props.filterOptions);
            //If bootstrapOptions have been passed in and it is bootstrap
            if (this.props.bootstrapOptions && this.props.bootstrapOptions.length !== 0 && query === '') {
                const bootstrapFilteredUsers = this.memoizedFilterOptions(this.props.bootstrapOptions, query, this.props.filterOptions);
                this.fireEvent((0, $korPW.filterUsersEvent), {
                    filtered: $22d5a025153193e6$var$getUsersForAnalytics(bootstrapFilteredUsers),
                    all: $22d5a025153193e6$var$getUsersForAnalytics(this.props.bootstrapOptions)
                });
                return bootstrapFilteredUsers;
            }
            // while when not loading just return already filtered result from server.
            if (!loading) return filteredUsers;
            const queryFilteredUsers = filteredUsers.filter((user)=>$22d5a025153193e6$var$stringContains(user.name, query));
            this.fireEvent((0, $korPW.filterUsersEvent), {
                filtered: $22d5a025153193e6$var$getUsersForAnalytics(queryFilteredUsers),
                all: $22d5a025153193e6$var$getUsersForAnalytics(users)
            });
            // when loading filter previous result.
            return filteredUsers;
        }, this.onFocus = (sessionId)=>{
            const state = {
                closed: false
            };
            this.startOptionsShownUfoExperience();
            if (this.state.users.length === 0) {
                state.sessionId = sessionId;
                state.loading = true;
            } else this.fireEvent((0, $korPW.preparedUsersLoadedEvent), {
                users: $22d5a025153193e6$var$getUsersForAnalytics(this.state.users),
                preparedSessionId: this.state.sessionId,
                sessionId: sessionId
            });
            this.setState((currentState)=>({
                    ...currentState,
                    ...state
                }));
            if (this.props.onFocus) this.props.onFocus(sessionId);
        }, this.onBlur = (sessionId)=>{
            this.getUsers.cancel();
            this.abortOptionsShownUfoExperience();
            // clear old users if query is populated so that on refocus,
            // the old list is not shown
            const users = this.state.query.length === 0 ? this.state.users : [];
            this.setState({
                loading: false,
                closed: true,
                users: users
            });
            if (this.props.onBlur) this.props.onBlur(sessionId);
        };
        this.optionsShownUfoExperienceInstance = (0, $lmLyy.smartUserPickerOptionsShownUfoExperience).getInstance(props.inputId || props.fieldId);
    }
    async componentDidMount() {
        try {
            const value = await (0, $67xwM.default)(this.props.baseUrl, this.props.defaultValue, this.props.productKey, this.props.siteId, {
                tenantId: this.props.siteId,
                activationId: this.props.activationId
            });
            this.setState({
                defaultValue: value
            });
        } catch (e) {
            const defaultValue = await (this.props.onValueError ? this.props.onValueError(e, this.props.defaultValue) || Promise.resolve([]) : Promise.resolve([]));
            this.setState({
                defaultValue: defaultValue
            });
        }
        const { prefetch: prefetch } = this.props;
        if (prefetch) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const sessionId = (0, $7TA2J.v4)();
            this.fireEvent((0, $korPW.mountedWithPrefetchEvent), {
                sessionId: sessionId
            });
            this.setState({
                sessionId: sessionId
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if ($22d5a025153193e6$var$hasContextChanged(prevProps, this.props) || this.props.fieldId !== prevProps.fieldId) this.setState({
            users: []
        });
        if ((this.state.sessionId !== prevState.sessionId || this.state.query !== prevState.query) && (this.state.query !== '' || !this.props.bootstrapOptions)) this.getUsers();
        else if (!this.state.closed && !this.state.loading) // If the component has rendered (including its dropdown list) and it
        // is not loading anything further, send the success UFO event
        {
            if (![
                (0, $ff1v8.UFOExperienceState).FAILED.id,
                (0, $ff1v8.UFOExperienceState).SUCCEEDED.id,
                (0, $ff1v8.UFOExperienceState).ABORTED.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success($22d5a025153193e6$var$ufoEndStateConfig(this.props.fieldId));
        }
    }
    render() {
        const { allowEmail: allowEmail, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, suggestEmailsForDomain: suggestEmailsForDomain, ...restProps } = this.props;
        // Determine whether to allow email selection based on allowEmailSelectionWhenEmailMatched, if needed
        let shouldAllowEmail = allowEmail;
        // When suggestEmailsForDomain is active, partial (non-email) input must still reach the base
        // picker's domain-suggestion creatable logic, so the isEmailQuery restriction is relaxed for
        // those queries only. Full email queries that matched an existing user remain suppressed.
        const isDomainSuggestionEnabled = (0, $iqfTZ.fg)('smart_user_picker_suggest_emails_for_domain') && !!suggestEmailsForDomain;
        if (allowEmail && enableEmailSearch && !allowEmailSelectionWhenEmailMatched) {
            const isCurrentQueryEmail = $22d5a025153193e6$var$isEmailQuery(this.state.query);
            if (isDomainSuggestionEnabled) // Allow email for partial queries so the "<query>@<domain>" suggestion can render,
            // but still suppress selection when a full email query matched an existing user,
            // or when the synthesized "<query>@<domain>" is itself an existing user's email.
            shouldAllowEmail = isCurrentQueryEmail ? !this.lastEmailSearchFoundMatches // full email: suppress when user matched
             : !this.lastDomainSuggestionMatchedUser; // partial: suppress when synth email matched a user
            else // Only allow email selection when:
            // 1. The query matches email format (validated by regex)
            // 2. No user/external user matches were found (only teams/groups suggested)
            shouldAllowEmail = isCurrentQueryEmail && !this.lastEmailSearchFoundMatches;
        }
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iIpBG.default), {
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jU3Mq.UserPicker), {
                ...restProps,
                allowEmail: shouldAllowEmail,
                suggestEmailsForDomain: suggestEmailsForDomain,
                onInputChange: this.onInputChange,
                onBlur: this.onBlur,
                onFocus: this.onFocus,
                defaultValue: this.state.defaultValue,
                isLoading: this.props.isLoading || this.state.loading && !this.state.closed && (!this.props.bootstrapOptions || this.state.query !== ''),
                options: this.filterUsers(),
                menuIsOpen: this.props.menuIsOpen
            })
        });
    }
}
$22d5a025153193e6$export$9b9bd453d1d4e4ce.displayName = "SmartUserPickerWithoutAnalytics";
const $22d5a025153193e6$export$9eedb6e5d313efdb = (0, $kTviw.default)()((0, $1jztF.default)($22d5a025153193e6$export$9b9bd453d1d4e4ce));

});
parcelRegister("jU3Mq", function(module, exports) {
$parcel$export(module.exports, "UserPicker", () => $b8e6acd930b76f34$export$83e0c73b09b3a9cd);
/* UserPicker.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $kTviw = parcelRequire("kTviw");

var $jQR5X = parcelRequire("jQR5X");
var $baIdH = parcelRequire("baIdH");

var $ff1v8 = parcelRequire("ff1v8");

var $euxye = parcelRequire("euxye");

var $9vfDp = parcelRequire("9vfDp");

var $izN9o = parcelRequire("izN9o");

var $g3DsG = parcelRequire("g3DsG");

var $eYbgp = parcelRequire("eYbgp");

var $gCEkc = parcelRequire("gCEkc");

var $330y8 = parcelRequire("330y8");

var $cBTht = parcelRequire("cBTht");

var $7lJSi = parcelRequire("7lJSi");

var $7TA2J = parcelRequire("7TA2J");

var $iqfTZ = parcelRequire("iqfTZ");
class $b8e6acd930b76f34$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    constructor(props){
        super(props);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.ufoId = (0, $7TA2J.v4)();
        const experienceForId = (0, $7lJSi.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $ff1v8.UFOExperienceState).IN_PROGRESS.id,
            (0, $ff1v8.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
    static{
        this.defaultProps = {
            width: 350,
            isMulti: false
        };
    }
    componentDidMount() {
        const experienceForId = (0, $7lJSi.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $ff1v8.UFOExperienceState).IN_PROGRESS.id,
            (0, $ff1v8.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, menuIsOpen: menuIsOpen, required: required = false, showClearIndicator: showClearIndicator = false, includeTeamsUpdates: includeTeamsUpdates = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $jQR5X.default) : (0, $baIdH.default);
        const creatableProps = suggestEmailsForDomain ? (0, $gCEkc.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $eYbgp.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required,
            includeTeamsUpdates: includeTeamsUpdates,
            menuIsOpen: menuIsOpen
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7lJSi.UfoErrorBoundary), {
            id: this.ufoId,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $330y8.default), {
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cBTht.ExusUserSourceProvider), {
                    fetchUserSource: loadUserSource,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9vfDp.BaseUserPickerWithoutAnalytics), {
                        ...this.props,
                        forwardedRef: this.props.forwardedRef,
                        width: width,
                        SelectComponent: SelectComponent,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        styles: (0, $izN9o.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, (0, $iqfTZ.fg)('platform-component-visual-refresh'), false, this.props.height, this.props.minHeight),
                        components: (0, $g3DsG.getComponents)(isMulti, anchor, showClearIndicator, this.props?.components ? this.props.components : {}),
                        pickerProps: pickerProps
                    })
                })
            })
        });
    }
}
$b8e6acd930b76f34$export$164f4d95e5d7e2f5.displayName = "UserPickerWithoutAnalytics";
const $b8e6acd930b76f34$export$83e0c73b09b3a9cd = (0, $kTviw.default)()($b8e6acd930b76f34$export$164f4d95e5d7e2f5);

});
parcelRegister("jQR5X", function(module, exports) {
$parcel$export(module.exports, "default", () => $db879bf8d494f750$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ 
var $6pR0T = parcelRequire("6pR0T");

var $c0vzW = parcelRequire("c0vzW");
const $db879bf8d494f750$var$CreatableSelect = (0, $c0vzW.default)((0, $6pR0T.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db879bf8d494f750$export$2e2bcd8739ae039 = $db879bf8d494f750$var$CreatableSelect;

});
parcelRegister("6pR0T", function(module, exports) {
$parcel$export(module.exports, "default", () => $85348db68afe09b2$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $e2muV = parcelRequire("e2muV");

var $1z06Q = parcelRequire("1z06Q");

var $8LfFe = parcelRequire("8LfFe");
const $85348db68afe09b2$var$CreatableSelect = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const creatableProps = (0, $8LfFe.default)(props);
    const selectProps = (0, $1z06Q.default)(creatableProps);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e2muV.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$85348db68afe09b2$export$2e2bcd8739ae039 = $85348db68afe09b2$var$CreatableSelect;

});
parcelRegister("1z06Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $5afa4c2257eddb5a$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $eRXjC = parcelRequire("eRXjC");

var $bk0jE = parcelRequire("bk0jE");

var $369bp = parcelRequire("369bp");

var $dC0e5 = parcelRequire("dC0e5");
const $5afa4c2257eddb5a$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $5afa4c2257eddb5a$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$5afa4c2257eddb5a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$5afa4c2257eddb5a$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $5afa4c2257eddb5a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $5afa4c2257eddb5a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $5afa4c2257eddb5a$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $5afa4c2257eddb5a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $bk0jE.getOptionValue), getOptionLabel: getOptionLabel = (0, $eRXjC.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $euxye.useMemo)(()=>isValidNewOption(inputValue, (0, $369bp.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $euxye.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $euxye.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $dC0e5.valueTernary)(isMulti, [
                    ...(0, $369bp.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});



parcelRegister("9vfDp", function(module, exports) {
$parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", () => $548e1aa4ef862e44$export$b4ff48c8d43b18c3);

var $e79Pd = parcelRequire("e79Pd");

var $iqfTZ = parcelRequire("iqfTZ");

var $kTviw = parcelRequire("kTviw");

var $ff1v8 = parcelRequire("ff1v8");

var $eVMQF = parcelRequire("eVMQF");

var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $7TA2J = parcelRequire("7TA2J");

var $dbkle = parcelRequire("dbkle");

var $ieUAe = parcelRequire("ieUAe");

var $h4CIG = parcelRequire("h4CIG");

var $1KHUB = parcelRequire("1KHUB");

var $ZAz94 = parcelRequire("ZAz94");

var $7lJSi = parcelRequire("7lJSi");
const $548e1aa4ef862e44$var$loadingMessage = ()=>null;
const $548e1aa4ef862e44$var$classNamePrefix = 'fabric-user-picker';
class $548e1aa4ef862e44$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    static{
        this.defaultProps = {
            isMulti: false,
            subtle: false,
            noBorder: false,
            textFieldBackgroundColor: false,
            isClearable: true,
            loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                    ...(0, $h4CIG.messages).errorMessage
                }),
            openMenuOnClick: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $1KHUB.optionToSelectableOptions)(nextProps.value);
        else if ((0, $1KHUB.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $1KHUB.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    constructor(props){
        super(props), this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined, this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            }, this.nextOption = this.withSelectRef((select)=>select.focusOption('down')), this.previousOption = this.withSelectRef((select)=>select.focusOption('up')), this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        }, this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        }, this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        }), // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $1KHUB.callCallback)(onChange, (0, $1KHUB.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $1KHUB.callCallback)(onSelection, (0, $1KHUB.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $dbkle.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $dbkle.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $1KHUB.callCallback)(onClear);
                    this.fireEvent((0, $dbkle.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $dbkle.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $dbkle.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        }, this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        }, this.addOptions = (0, $ieUAe.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        }), this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $dbkle.failedEvent));
        }, this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($eVMQF)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $1KHUB.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200), this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $ff1v8.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        }, this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $1KHUB.callCallback)(this.props.onFocus, this.getSessionId());
            const openMenuOnFocus = this.props.openMenuOnFocus ?? true;
            if (!this.isMenuOpenOnClickForSingleSelect && openMenuOnFocus) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $1KHUB.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        }, this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $1KHUB.callCallback)(this.props.onInputChange, '', this.getSessionId());
        }, this.handleOpen = ()=>{
            (0, $1KHUB.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        }, this.handleBlur = ()=>{
            if (this.props.isFooterFocused || this.props.isHeaderFocused) return;
            (0, $1KHUB.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $1KHUB.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        }, this.handleClose = ()=>{
            if (this.props.isFooterFocused || this.props.isHeaderFocused) return;
            this.resetInputState();
            (0, $1KHUB.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }, this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $1KHUB.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $dbkle.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        }, this.startSession = ()=>{
            this.session = (0, $dbkle.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $dbkle.focusEvent));
        }, this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
            if (event.key === 'Escape') {
                this.setState({
                    menuIsOpen: false,
                    options: []
                });
                this.props.setIsFooterFocused && this.props.setIsFooterFocused(false);
                this.props.setIsHeaderFocused && this.props.setIsHeaderFocused(false);
            }
            if (event.key === 'Tab' && this.props.setIsFooterFocused && this.props.footer) this.props.setIsFooterFocused(true);
            if (event.key === 'Tab' && this.props.setIsHeaderFocused && this.props.header) this.props.setIsHeaderFocused(true);
        }, this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        }, this.getOptionsOld = ()=>{
            const options = (0, $1KHUB.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder ? (0, $ZAz94.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder ? (0, $ZAz94.groupOptionsByType)(options, groupByTypeOrder) : options;
        }, this.getOptionsNew = ()=>{
            const options = (0, $1KHUB.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder, customGroupLabels: customGroupLabels } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder ? (0, $ZAz94.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder, customGroupLabels) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder ? (0, $ZAz94.groupOptionsByType)(options, groupByTypeOrder, customGroupLabels) : options;
        }, this.getOptions = ()=>{
            return (0, $iqfTZ.fg)('jsm-wfo-assignee-recommendation-on-queues') ? this.getOptionsNew() : this.getOptionsOld();
        }, this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal', this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        }, this.shouldKeepMenuOpen = ()=>Boolean(!!this.props.footer) && Boolean(this.props.isFooterFocused) || Boolean(!!this.props.header) && Boolean(this.props.isHeaderFocused);
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        (0, $7lJSi.userPickerOptionsShownUfoExperience).getInstance((0, $7TA2J.v4)());
        if (this.props.forwardedRef) {
            const refValue = {
                focus: this.focus,
                blur: this.blur
            };
            if (typeof this.props.forwardedRef === 'function') this.props.forwardedRef(refValue);
            else this.props.forwardedRef.current = refValue;
        }
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Close menu when isFooterFocused or isHeaderFocused changes from true to false
        if (menuIsOpen && (prevProps.isFooterFocused === true && this.props.isFooterFocused === false || prevProps.isHeaderFocused === true && this.props.isHeaderFocused === false) && !this.shouldKeepMenuOpen()) {
            this.resetInputState();
            (0, $1KHUB.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $dbkle.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $dbkle.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!prevProps.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $ff1v8.UFOExperienceState).STARTED.id,
            (0, $ff1v8.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: this.props.openMenuOnFocus ?? true
            }
        };
        const { 'aria-labelledby': ariaLabelledByStandard, 'aria-describedby': ariaDescribedByStandard, ...restAriaProps } = this.ariaProps;
        return /*#__PURE__*/ (0, $e79Pd.jsx)(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            labelId: ariaLabelledBy ?? ariaLabelledByStandard,
            descriptionId: ariaDescribedBy ?? ariaDescribedByStandard,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $548e1aa4ef862e44$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                ...(0, $h4CIG.messages).placeholder
            }),
            label: ariaLabel,
            addMoreMessage: addMoreMessage,
            classNamePrefix: $548e1aa4ef862e44$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...restAriaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
}
$548e1aa4ef862e44$export$b4ff48c8d43b18c3.displayName = "BaseUserPickerWithoutAnalytics";
const $548e1aa4ef862e44$export$d099ade7b4f4d2a4 = (0, $kTviw.default)()($548e1aa4ef862e44$export$b4ff48c8d43b18c3);

});
parcelRegister("dbkle", function(module, exports) {
$parcel$export(module.exports, "startSession", () => $cf0794df7d1f1fe0$export$c0d84948cecf78d8);
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $cf0794df7d1f1fe0$export$53eef0dcd9611650);
$parcel$export(module.exports, "focusEvent", () => $cf0794df7d1f1fe0$export$e7818c470f37c4bd);
$parcel$export(module.exports, "clearEvent", () => $cf0794df7d1f1fe0$export$7b5800e732182efb);
$parcel$export(module.exports, "deleteEvent", () => $cf0794df7d1f1fe0$export$95711ec6c6227e9a);
$parcel$export(module.exports, "cancelEvent", () => $cf0794df7d1f1fe0$export$e9caaaecfee38128);
$parcel$export(module.exports, "selectEvent", () => $cf0794df7d1f1fe0$export$48143d759475d90f);
$parcel$export(module.exports, "searchedEvent", () => $cf0794df7d1f1fe0$export$911fb7184b6037eb);
$parcel$export(module.exports, "failedEvent", () => $cf0794df7d1f1fe0$export$c2aec355fef65c9c);
$parcel$export(module.exports, "userInfoEvent", () => $cf0794df7d1f1fe0$export$f541f04954b0c11e);
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $flpE4 = parcelRequire("flpE4");

var $4LDqh = parcelRequire("4LDqh");

var $iqfTZ = parcelRequire("iqfTZ");

var $7TA2J = parcelRequire("7TA2J");

var $1KHUB = parcelRequire("1KHUB");
const $cf0794df7d1f1fe0$var$packageName = "platform-pkg";
const $cf0794df7d1f1fe0$var$packageVersion = "0.0.0-use.local";
const $cf0794df7d1f1fe0$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $cf0794df7d1f1fe0$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $cf0794df7d1f1fe0$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $cf0794df7d1f1fe0$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $7TA2J.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $cf0794df7d1f1fe0$export$53eef0dcd9611650 = (0, $flpE4.default)('fabric-elements');
const $cf0794df7d1f1fe0$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $cf0794df7d1f1fe0$var$packageName,
            packageVersion: $cf0794df7d1f1fe0$var$packageVersion,
            ...attributes
        }
    });
const $cf0794df7d1f1fe0$var$checkValidId = (id)=>{
    return $cf0794df7d1f1fe0$var$UUID_REGEXP_NEW_AAID.test(id) || $cf0794df7d1f1fe0$var$UUID_REGEXP_OLD_AAID.test(id) || $cf0794df7d1f1fe0$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $cf0794df7d1f1fe0$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $cf0794df7d1f1fe0$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $1KHUB.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $1KHUB.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $cf0794df7d1f1fe0$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$cf0794df7d1f1fe0$var$optionData2Analytics(data));
    }
    return [];
};
const $cf0794df7d1f1fe0$var$selectedCustomGroupAnalyticsAttributes = (props, option)=>{
    if (!props.customGroupLabels) return {};
    const selectedType = option?.data.type;
    const analyticsLabel = selectedType ? props.customGroupAnalyticsLabels?.[selectedType] : undefined;
    return {
        hasCustomGroupLabels: true,
        ...analyticsLabel ? {
            selectedLabel: analyticsLabel
        } : {}
    };
};
const $cf0794df7d1f1fe0$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $cf0794df7d1f1fe0$var$sessionId(session),
        pickerType: $cf0794df7d1f1fe0$var$pickerType(props),
        journeyId: journeyId
    });
const $cf0794df7d1f1fe0$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$cf0794df7d1f1fe0$var$createEvent('ui', 'focused', 'userPicker', {
        ...$cf0794df7d1f1fe0$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $cf0794df7d1f1fe0$var$buildValueForAnalytics(state.value)
    });
const $cf0794df7d1f1fe0$export$7b5800e732182efb = (props, state, session, journeyId)=>$cf0794df7d1f1fe0$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$cf0794df7d1f1fe0$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $cf0794df7d1f1fe0$var$values(state)
    });
const $cf0794df7d1f1fe0$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$cf0794df7d1f1fe0$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $cf0794df7d1f1fe0$var$sessionId(session),
        journeyId: journeyId,
        value: $cf0794df7d1f1fe0$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen,
        ...(0, $4LDqh.default).getExperimentValue('team_member_suggestions_while_creating_team', 'isEnabled', false) && args[0]?.isSuggestedMember !== undefined ? {
            isSuggestedMember: args[0].isSuggestedMember
        } : {}
    });
const $cf0794df7d1f1fe0$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$cf0794df7d1f1fe0$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$cf0794df7d1f1fe0$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $cf0794df7d1f1fe0$var$sessionDuration(session),
        queryLength: $cf0794df7d1f1fe0$var$queryLength(args[0]),
        spaceInQuery: $cf0794df7d1f1fe0$var$spaceInQuery(args[0]),
        upKeyCount: $cf0794df7d1f1fe0$var$upKeyCount(session),
        downKeyCount: $cf0794df7d1f1fe0$var$downKeyCount(session)
    });
const $cf0794df7d1f1fe0$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $cf0794df7d1f1fe0$var$createEvent('ui', $cf0794df7d1f1fe0$var$selectEventType(session), 'userPicker', {
        ...$cf0794df7d1f1fe0$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $cf0794df7d1f1fe0$var$sessionDuration(session),
        position: $cf0794df7d1f1fe0$var$position(state, args[0]),
        queryLength: $cf0794df7d1f1fe0$var$queryLength(state),
        spaceInQuery: $cf0794df7d1f1fe0$var$spaceInQuery(state),
        upKeyCount: $cf0794df7d1f1fe0$var$upKeyCount(session),
        downKeyCount: $cf0794df7d1f1fe0$var$downKeyCount(session),
        result: $cf0794df7d1f1fe0$var$result(args[0]),
        numberOfResults: $cf0794df7d1f1fe0$var$numberOfResults(state),
        ...(0, $iqfTZ.fg)('jsm_routing_recommended_agent_minor_fix') ? $cf0794df7d1f1fe0$var$selectedCustomGroupAnalyticsAttributes(props, args[0]) : {}
    });
};
const $cf0794df7d1f1fe0$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $cf0794df7d1f1fe0$var$results(state);
    return $cf0794df7d1f1fe0$var$createEvent('operational', 'searched', 'userPicker', {
        ...$cf0794df7d1f1fe0$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $cf0794df7d1f1fe0$var$sessionDuration(session),
        durationSinceInputChange: $cf0794df7d1f1fe0$var$durationSinceInputChange(session),
        queryLength: $cf0794df7d1f1fe0$var$queryLength(state),
        isLoading: $cf0794df7d1f1fe0$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $cf0794df7d1f1fe0$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$cf0794df7d1f1fe0$var$createEvent('operational', 'failed', 'userPicker', {
        ...$cf0794df7d1f1fe0$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $cf0794df7d1f1fe0$export$f541f04954b0c11e = (sources, accountId)=>$cf0794df7d1f1fe0$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $cf0794df7d1f1fe0$var$checkValidId(accountId) ? accountId : null
    });
function $cf0794df7d1f1fe0$var$queryLength(state) {
    return state.inputValue.length;
}
function $cf0794df7d1f1fe0$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $cf0794df7d1f1fe0$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $cf0794df7d1f1fe0$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $cf0794df7d1f1fe0$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $cf0794df7d1f1fe0$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $cf0794df7d1f1fe0$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $cf0794df7d1f1fe0$var$sessionId(session) {
    return session && session.id;
}
function $cf0794df7d1f1fe0$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $cf0794df7d1f1fe0$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $cf0794df7d1f1fe0$var$result(option) {
    return option ? $cf0794df7d1f1fe0$var$optionData2Analytics(option.data) : null;
}
function $cf0794df7d1f1fe0$var$results(state) {
    return (state.options || []).map($cf0794df7d1f1fe0$var$optionData2Analytics);
}
function $cf0794df7d1f1fe0$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $cf0794df7d1f1fe0$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$cf0794df7d1f1fe0$var$optionData2Analytics(option.data)) : [
        $cf0794df7d1f1fe0$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $cf0794df7d1f1fe0$var$numberOfResults(state) {
    return (state.options || []).length;
}

});
parcelRegister("1KHUB", function(module, exports) {
$parcel$export(module.exports, "isExternalUser", () => $53e564aadf92cc8e$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $53e564aadf92cc8e$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $53e564aadf92cc8e$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $53e564aadf92cc8e$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $53e564aadf92cc8e$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $53e564aadf92cc8e$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $53e564aadf92cc8e$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $53e564aadf92cc8e$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $53e564aadf92cc8e$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $53e564aadf92cc8e$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $53e564aadf92cc8e$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $53e564aadf92cc8e$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $53e564aadf92cc8e$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $53e564aadf92cc8e$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $53e564aadf92cc8e$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $53e564aadf92cc8e$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $53e564aadf92cc8e$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $53e564aadf92cc8e$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $53e564aadf92cc8e$export$5419897287f5f1c7);

var $emCaV = parcelRequire("emCaV");


var $9EqJn = parcelRequire("9EqJn");
const $53e564aadf92cc8e$export$f6058dbcb5980cb = (option)=>option.type === (0, $46a69102f5d06a1b$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $53e564aadf92cc8e$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $46a69102f5d06a1b$export$8436e53e45ffe15b);
const $53e564aadf92cc8e$export$f8c4277cb588611f = (option)=>option?.type === (0, $46a69102f5d06a1b$export$26bc40b960693765);
const $53e564aadf92cc8e$export$d7976824e9f55785 = (option)=>option.type === (0, $46a69102f5d06a1b$export$d460f747b73abb10);
const $53e564aadf92cc8e$export$7fbbfbca30081d0 = (option)=>option.type === (0, $46a69102f5d06a1b$export$6662b3461398ef8c);
const $53e564aadf92cc8e$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $46a69102f5d06a1b$export$eafd0979afa5b224);
const $53e564aadf92cc8e$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $53e564aadf92cc8e$var$isOptionData = (option)=>option.name !== undefined;
const $53e564aadf92cc8e$export$3f993c492bd6c728 = (option)=>{
    if ($53e564aadf92cc8e$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $53e564aadf92cc8e$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $53e564aadf92cc8e$export$9652023d9040757 = (a)=>typeof a?.[Symbol.iterator] === 'function';
const $53e564aadf92cc8e$export$d2312e68e1f5ad00 = (0, $emCaV.default)((options)=>options.map($53e564aadf92cc8e$export$3f993c492bd6c728));
const $53e564aadf92cc8e$export$e6fda14a194bcbcc = (0, $emCaV.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($53e564aadf92cc8e$export$3f993c492bd6c728);
    return $53e564aadf92cc8e$export$3f993c492bd6c728(defaultValue);
});
const $53e564aadf92cc8e$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xxsmall' : 'small';
const $53e564aadf92cc8e$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $53e564aadf92cc8e$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $53e564aadf92cc8e$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $53e564aadf92cc8e$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
    return undefined;
};
const $53e564aadf92cc8e$export$b4f8f1f54acec99b = (optionData)=>{
    if ($53e564aadf92cc8e$export$2e44165f1da65304(optionData) || $53e564aadf92cc8e$export$f8c4277cb588611f(optionData) || $53e564aadf92cc8e$export$d3a8f0b77e9737fc(optionData) || $53e564aadf92cc8e$export$f6058dbcb5980cb(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $53e564aadf92cc8e$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $9EqJn.PopupSelect);
const $53e564aadf92cc8e$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $53e564aadf92cc8e$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $46a69102f5d06a1b$export$8436e53e45ffe15b = 'user';
const $46a69102f5d06a1b$export$50042ec1d2e00e63 = 'external_user';
const $46a69102f5d06a1b$export$26bc40b960693765 = 'team';
const $46a69102f5d06a1b$export$d460f747b73abb10 = 'group';
const $46a69102f5d06a1b$export$6662b3461398ef8c = 'email';
const $46a69102f5d06a1b$export$eafd0979afa5b224 = 'custom';

parcelRegister("9EqJn", function(module, exports) {
$parcel$export(module.exports, "PopupSelect", () => $b10156b6a4c774dc$export$4c5821a1fa94a0e6);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $85XPu = parcelRequire("85XPu");

var $g6TgS = parcelRequire("g6TgS");

var $2iEQi = parcelRequire("2iEQi");
var $4YIiC = parcelRequire("4YIiC");
var $hNMyT = parcelRequire("hNMyT");

var $cLMB7 = parcelRequire("cLMB7");

var $hipxU = parcelRequire("hipxU");

var $iqfTZ = parcelRequire("iqfTZ");

var $8vYl3 = parcelRequire("8vYl3");
var $k17rf = parcelRequire("k17rf");
var $iqmNT = parcelRequire("iqmNT");

var $2eNhP = parcelRequire("2eNhP");

var $baIdH = parcelRequire("baIdH");

var $lHQGB = parcelRequire("lHQGB");

var $5vT1z = parcelRequire("5vT1z");

var $a2btN = parcelRequire("a2btN");

var $fq62x = parcelRequire("fq62x");

var $ieVCH = parcelRequire("ieVCH");
/**
 * Are we rendering on the client or server?
 */ const $b10156b6a4c774dc$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
function $b10156b6a4c774dc$var$getPopperComponents() {
    if ((0, $iqfTZ.fg)('platform-dst-popper-consolidation')) return {
        Manager: (0, $8vYl3.Manager),
        Popper: (0, $k17rf.Popper),
        Reference: (0, $iqmNT.Reference)
    };
    return {
        Manager: (0, $2iEQi.Manager),
        Popper: (0, $4YIiC.Popper),
        Reference: (0, $hNMyT.Reference)
    };
}
// ==============================
// Class
// ==============================
const $b10156b6a4c774dc$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $b10156b6a4c774dc$var$defaultPopperProps = {
    modifiers: $b10156b6a4c774dc$var$modifiers,
    placement: 'bottom-start'
};
const $b10156b6a4c774dc$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $b10156b6a4c774dc$export$4c5821a1fa94a0e6 extends (0, $euxye.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$b10156b6a4c774dc$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $cLMB7.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $lHQGB.defaultComponents),
            ...props.components
        };
        if (!(0, $cLMB7.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$b10156b6a4c774dc$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $glbdM.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        // Top-layer rendering path: native Popover API via @atlaskit/top-layer
        if ((0, $iqfTZ.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ieVCH.PopupSelectTopLayer), {
            ...this.props
        });
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        const { Manager: Manager, Reference: Reference } = $b10156b6a4c774dc$var$getPopperComponents();
        return /*#__PURE__*/ (0, $e79Pd.jsxs)(Manager, {
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hipxU.IdProvider), {
                    postfix: "-popup-select",
                    children: ({ id: id })=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)(Reference, {
                                    children: ({ ref: ref })=>target && target({
                                            isOpen: isOpen,
                                            onKeyDown: this.handleTargetKeyDown,
                                            ref: this.resolveTargetRef(ref),
                                            // Should technically be 'dialog' by default instead of 'true' via AriaAttributes, but will require further changes.
                                            // See go/DSP-22283
                                            'aria-haspopup': 'true',
                                            'aria-expanded': isOpen,
                                            'aria-controls': isOpen ? id : undefined
                                        })
                                }),
                                this.renderSelect(id)
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fq62x.NotifyOpenLayerObserver), {
                    isOpen: this.state.isOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
            groupHeading: (provided)=>({
                    ...provided,
                    color: "var(--ds-text-subtlest, #6B6E76)"
                })
        }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $lHQGB.defaultComponents),
            mergedPopperProps: $b10156b6a4c774dc$var$defaultPopperProps
        }, // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        }, this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    if (this.props.shouldPreventEscapePropagation) event.stopPropagation();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        }, this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        }, this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        }, this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        }, // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $glbdM.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        }, /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }, // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            }, this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        }, // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        }, this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        }, // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        }, // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: _target, testId: testId, onMenuOpen: _onMenuOpen, onMenuClose: _onMenuClose, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const { Popper: Popper } = $b10156b6a4c774dc$var$getPopperComponents();
            const showSearchControl = this.showSearchControl();
            const portalDestination = $b10156b6a4c774dc$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $5vT1z.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
                return undefined;
            };
            const popper = /*#__PURE__*/ (0, $e79Pd.jsx)(Popper, {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                },
                children: ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $a2btN.MenuDialog), {
                        // There is not a limited amount of values for the widths, so they need to remain dynamic.
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            ...style,
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-placement": placement,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref),
                        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $g6TgS.default), {
                            disabled: !focusLockEnabled,
                            returnFocus: true,
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $baIdH.default), {
                                    label: getLabel(),
                                    backspaceRemovesValue: false,
                                    controlShouldRenderValue: false,
                                    isClearable: false,
                                    tabSelectsValue: false,
                                    menuIsOpen: true,
                                    placeholder: placeholder,
                                    ref: this.getSelectRef,
                                    ...props,
                                    isSearchable: showSearchControl,
                                    styles: (0, $2eNhP.mergeStyles)(this.defaultStyles, props.styles || {}),
                                    maxMenuHeight: this.getMaxHeight(),
                                    components: selectComponents,
                                    onChange: this.handleSelectChange,
                                    testId: testId
                                }),
                                footer
                            ]
                        })
                    })
            });
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $85XPu.createPortal)(popper, portalDestination);
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.close();
        };
    }
}
$b10156b6a4c774dc$export$4c5821a1fa94a0e6.displayName = "PopupSelect";

});
parcelRegister("2iEQi", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $1accf1b0409e7e3e$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $1accf1b0409e7e3e$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $1accf1b0409e7e3e$export$d0d38e7dec7a1a61);

var $euxye = parcelRequire("euxye");
var $1accf1b0409e7e3e$export$3dbd3405086fec7b = $euxye.createContext();
var $1accf1b0409e7e3e$export$cbabb21c2529b130 = $euxye.createContext();
function $1accf1b0409e7e3e$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $euxye.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $euxye.useRef(false);
    $euxye.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $euxye.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $euxye.createElement($1accf1b0409e7e3e$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $euxye.createElement($1accf1b0409e7e3e$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("4YIiC", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $39ff20f5f8f54fb8$export$badac9ada3a0bdf9);

var $euxye = parcelRequire("euxye");

var $2iEQi = parcelRequire("2iEQi");

var $3pNGD = parcelRequire("3pNGD");

var $iDTO7 = parcelRequire("iDTO7");
var $39ff20f5f8f54fb8$var$NOOP = function NOOP() {
    return void 0;
};
var $39ff20f5f8f54fb8$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $39ff20f5f8f54fb8$var$EMPTY_MODIFIERS = [];
function $39ff20f5f8f54fb8$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $39ff20f5f8f54fb8$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $euxye.useContext((0, $2iEQi.ManagerReferenceNodeContext));
    var _React$useState = $euxye.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $euxye.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $euxye.useEffect(function() {
        (0, $3pNGD.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $euxye.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $iDTO7.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $euxye.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $39ff20f5f8f54fb8$var$NOOP,
            update: update || $39ff20f5f8f54fb8$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $3pNGD.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("3pNGD", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $27ca3fa5c8b31e89$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $27ca3fa5c8b31e89$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $27ca3fa5c8b31e89$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $27ca3fa5c8b31e89$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $27ca3fa5c8b31e89$export$700979bc83e7db82);

var $euxye = parcelRequire("euxye");
var $27ca3fa5c8b31e89$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $27ca3fa5c8b31e89$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $27ca3fa5c8b31e89$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $27ca3fa5c8b31e89$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $27ca3fa5c8b31e89$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $27ca3fa5c8b31e89$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $euxye.useLayoutEffect : $euxye.useEffect;

});

parcelRegister("iDTO7", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $d92728b583ba4784$export$f4d5bf230a36dd6e);

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $fT3ol = parcelRequire("fT3ol");

var $6BUH0 = parcelRequire("6BUH0");

var $3pNGD = parcelRequire("3pNGD");
var $d92728b583ba4784$var$EMPTY_MODIFIERS = [];
var $d92728b583ba4784$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $euxye.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $d92728b583ba4784$var$EMPTY_MODIFIERS
    };
    var _React$useState = $euxye.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $euxye.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $85XPu.flushSync(function() {
                    setState({
                        styles: (0, $3pNGD.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $3pNGD.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $euxye.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6BUH0)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $euxye.useRef();
    (0, $3pNGD.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $3pNGD.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $fT3ol.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("fT3ol", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $b90e9f974841b0d8$export$8f7491d57c8f97a9);

var $iyPCK = parcelRequire("iyPCK");

var $hbNb5 = parcelRequire("hbNb5");

var $eV4b6 = parcelRequire("eV4b6");

var $9fkIo = parcelRequire("9fkIo");

var $aqeNW = parcelRequire("aqeNW");

var $5f8S7 = parcelRequire("5f8S7");

var $20Jv5 = parcelRequire("20Jv5");

var $50ohQ = parcelRequire("50ohQ");

var $bbEof = parcelRequire("bbEof");

var $f7KNT = parcelRequire("f7KNT");


var $b90e9f974841b0d8$export$d34966752335dd47 = [
    (0, $hbNb5.default),
    (0, $eV4b6.default),
    (0, $9fkIo.default),
    (0, $aqeNW.default),
    (0, $5f8S7.default),
    (0, $20Jv5.default),
    (0, $50ohQ.default),
    (0, $bbEof.default),
    (0, $f7KNT.default)
];
var $b90e9f974841b0d8$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $iyPCK.popperGenerator)({
    defaultModifiers: $b90e9f974841b0d8$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("iyPCK", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $d833726b1d78a1da$export$ed5e13716264f202);

var $a9oy8 = parcelRequire("a9oy8");

var $8u3sc = parcelRequire("8u3sc");

var $a9YOS = parcelRequire("a9YOS");

var $cac2h = parcelRequire("cac2h");

var $3P6pz = parcelRequire("3P6pz");

var $hMY00 = parcelRequire("hMY00");

var $57wDY = parcelRequire("57wDY");


var $8e4dK = parcelRequire("8e4dK");
var $d833726b1d78a1da$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $d833726b1d78a1da$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $d833726b1d78a1da$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $d833726b1d78a1da$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $d833726b1d78a1da$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $8e4dK.isElement)(reference) ? (0, $a9YOS.default)(reference) : reference.contextElement ? (0, $a9YOS.default)(reference.contextElement) : [],
                    popper: (0, $a9YOS.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $3P6pz.default)((0, $57wDY.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$d833726b1d78a1da$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $a9oy8.default)(reference, (0, $cac2h.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $8u3sc.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $hMY00.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$d833726b1d78a1da$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $d833726b1d78a1da$export$8f7491d57c8f97a9 = /*#__PURE__*/ $d833726b1d78a1da$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("a9oy8", function(module, exports) {
$parcel$export(module.exports, "default", () => $763dc9b00d5e6755$export$2e2bcd8739ae039);

var $3GPTj = parcelRequire("3GPTj");

var $8Nrpd = parcelRequire("8Nrpd");

var $dPKF0 = parcelRequire("dPKF0");

var $8e4dK = parcelRequire("8e4dK");

var $lsQ9o = parcelRequire("lsQ9o");

var $46rBs = parcelRequire("46rBs");

var $9Jwtc = parcelRequire("9Jwtc");

var $f17IG = parcelRequire("f17IG");
function $763dc9b00d5e6755$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $f17IG.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $f17IG.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $763dc9b00d5e6755$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $8e4dK.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $8e4dK.isHTMLElement)(offsetParent) && $763dc9b00d5e6755$var$isElementScaled(offsetParent);
    var documentElement = (0, $46rBs.default)(offsetParent);
    var rect = (0, $3GPTj.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $dPKF0.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9Jwtc.default)(documentElement)) scroll = (0, $8Nrpd.default)(offsetParent);
        if ((0, $8e4dK.isHTMLElement)(offsetParent)) {
            offsets = (0, $3GPTj.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $lsQ9o.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("3GPTj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2afd8bd51fceaf75$export$2e2bcd8739ae039);

var $8e4dK = parcelRequire("8e4dK");

var $f17IG = parcelRequire("f17IG");

var $jZmT7 = parcelRequire("jZmT7");

var $lrlTR = parcelRequire("lrlTR");
function $2afd8bd51fceaf75$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $8e4dK.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $f17IG.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $f17IG.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $8e4dK.isElement)(element) ? (0, $jZmT7.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $lrlTR.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("8e4dK", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $5fd2e7aee429d601$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $5fd2e7aee429d601$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $5fd2e7aee429d601$export$af51f0f06c0f328a);

var $jZmT7 = parcelRequire("jZmT7");
function $5fd2e7aee429d601$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $jZmT7.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $5fd2e7aee429d601$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $jZmT7.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $5fd2e7aee429d601$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $jZmT7.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("jZmT7", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8d577e3c660a4bd$export$2e2bcd8739ae039);
function $e8d577e3c660a4bd$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("f17IG", function(module, exports) {
$parcel$export(module.exports, "max", () => $aeeceffbf8bf601a$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $aeeceffbf8bf601a$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $aeeceffbf8bf601a$export$2077e0241d6afd3c);
var $aeeceffbf8bf601a$export$8960430cfd85939f = Math.max;
var $aeeceffbf8bf601a$export$96ec731ed4dcb222 = Math.min;
var $aeeceffbf8bf601a$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("lrlTR", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9bd1b79fb5faf57$export$2e2bcd8739ae039);

var $24FkW = parcelRequire("24FkW");
function $f9bd1b79fb5faf57$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $24FkW.default)());
}

});
parcelRegister("24FkW", function(module, exports) {
$parcel$export(module.exports, "default", () => $182c051ca53764ae$export$2e2bcd8739ae039);
function $182c051ca53764ae$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("8Nrpd", function(module, exports) {
$parcel$export(module.exports, "default", () => $66782884c0deccdc$export$2e2bcd8739ae039);

var $6fpcA = parcelRequire("6fpcA");

var $jZmT7 = parcelRequire("jZmT7");

var $8e4dK = parcelRequire("8e4dK");

var $lcboI = parcelRequire("lcboI");
function $66782884c0deccdc$export$2e2bcd8739ae039(node) {
    if (node === (0, $jZmT7.default)(node) || !(0, $8e4dK.isHTMLElement)(node)) return (0, $6fpcA.default)(node);
    else return (0, $lcboI.default)(node);
}

});
parcelRegister("6fpcA", function(module, exports) {
$parcel$export(module.exports, "default", () => $48c7b16467f197d0$export$2e2bcd8739ae039);

var $jZmT7 = parcelRequire("jZmT7");
function $48c7b16467f197d0$export$2e2bcd8739ae039(node) {
    var win = (0, $jZmT7.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("lcboI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6e38f5115b291a2$export$2e2bcd8739ae039);
function $f6e38f5115b291a2$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("dPKF0", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1243b8d717827cf$export$2e2bcd8739ae039);
function $a1243b8d717827cf$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("lsQ9o", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa04aa7da4bf3ff8$export$2e2bcd8739ae039);

var $3GPTj = parcelRequire("3GPTj");

var $46rBs = parcelRequire("46rBs");

var $6fpcA = parcelRequire("6fpcA");
function $fa04aa7da4bf3ff8$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $3GPTj.default)((0, $46rBs.default)(element)).left + (0, $6fpcA.default)(element).scrollLeft;
}

});
parcelRegister("46rBs", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fcd225ba2bdb75b$export$2e2bcd8739ae039);

var $8e4dK = parcelRequire("8e4dK");
function $2fcd225ba2bdb75b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $8e4dK.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("9Jwtc", function(module, exports) {
$parcel$export(module.exports, "default", () => $716180de25b7e31c$export$2e2bcd8739ae039);

var $eWPK1 = parcelRequire("eWPK1");
function $716180de25b7e31c$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $eWPK1.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("eWPK1", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae1e9e3687700b73$export$2e2bcd8739ae039);

var $jZmT7 = parcelRequire("jZmT7");
function $ae1e9e3687700b73$export$2e2bcd8739ae039(element) {
    return (0, $jZmT7.default)(element).getComputedStyle(element);
}

});



parcelRegister("8u3sc", function(module, exports) {
$parcel$export(module.exports, "default", () => $62d3cded5053ac0e$export$2e2bcd8739ae039);

var $3GPTj = parcelRequire("3GPTj");
function $62d3cded5053ac0e$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $3GPTj.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("a9YOS", function(module, exports) {
$parcel$export(module.exports, "default", () => $7659ec2cf3bb460f$export$2e2bcd8739ae039);

var $7mT1V = parcelRequire("7mT1V");

var $3jGzw = parcelRequire("3jGzw");

var $jZmT7 = parcelRequire("jZmT7");

var $9Jwtc = parcelRequire("9Jwtc");
function $7659ec2cf3bb460f$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $7mT1V.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $jZmT7.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9Jwtc.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($7659ec2cf3bb460f$export$2e2bcd8739ae039((0, $3jGzw.default)(target)));
}

});
parcelRegister("7mT1V", function(module, exports) {
$parcel$export(module.exports, "default", () => $55d5465215bac983$export$2e2bcd8739ae039);

var $3jGzw = parcelRequire("3jGzw");

var $9Jwtc = parcelRequire("9Jwtc");

var $dPKF0 = parcelRequire("dPKF0");

var $8e4dK = parcelRequire("8e4dK");
function $55d5465215bac983$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $dPKF0.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $8e4dK.isHTMLElement)(node) && (0, $9Jwtc.default)(node)) return node;
    return $55d5465215bac983$export$2e2bcd8739ae039((0, $3jGzw.default)(node));
}

});
parcelRegister("3jGzw", function(module, exports) {
$parcel$export(module.exports, "default", () => $26a42b57eb87c196$export$2e2bcd8739ae039);

var $dPKF0 = parcelRequire("dPKF0");

var $46rBs = parcelRequire("46rBs");

var $8e4dK = parcelRequire("8e4dK");
function $26a42b57eb87c196$export$2e2bcd8739ae039(element) {
    if ((0, $dPKF0.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $8e4dK.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $46rBs.default)(element) // fallback
    );
}

});



parcelRegister("cac2h", function(module, exports) {
$parcel$export(module.exports, "default", () => $8dafc144205345c0$export$2e2bcd8739ae039);

var $jZmT7 = parcelRequire("jZmT7");

var $dPKF0 = parcelRequire("dPKF0");

var $eWPK1 = parcelRequire("eWPK1");

var $8e4dK = parcelRequire("8e4dK");

var $jMKt1 = parcelRequire("jMKt1");

var $3jGzw = parcelRequire("3jGzw");

var $24FkW = parcelRequire("24FkW");
function $8dafc144205345c0$var$getTrueOffsetParent(element) {
    if (!(0, $8e4dK.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $eWPK1.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $8dafc144205345c0$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $24FkW.default)());
    var isIE = /Trident/i.test((0, $24FkW.default)());
    if (isIE && (0, $8e4dK.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $eWPK1.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $3jGzw.default)(element);
    if ((0, $8e4dK.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $8e4dK.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $dPKF0.default)(currentNode)) < 0){
        var css = (0, $eWPK1.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $8dafc144205345c0$export$2e2bcd8739ae039(element) {
    var window = (0, $jZmT7.default)(element);
    var offsetParent = $8dafc144205345c0$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $jMKt1.default)(offsetParent) && (0, $eWPK1.default)(offsetParent).position === 'static')offsetParent = $8dafc144205345c0$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $dPKF0.default)(offsetParent) === 'html' || (0, $dPKF0.default)(offsetParent) === 'body' && (0, $eWPK1.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $8dafc144205345c0$var$getContainingBlock(element) || window;
}

});
parcelRegister("jMKt1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6768b6fcf71c503$export$2e2bcd8739ae039);

var $dPKF0 = parcelRequire("dPKF0");
function $e6768b6fcf71c503$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $dPKF0.default)(element)) >= 0;
}

});


parcelRegister("3P6pz", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c8b1bae13138377$export$2e2bcd8739ae039);

var $hylc7 = parcelRequire("hylc7");
function $2c8b1bae13138377$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $2c8b1bae13138377$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $2c8b1bae13138377$var$order(modifiers); // order based on phase
    return (0, $hylc7.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("hylc7", function(module, exports) {
$parcel$export(module.exports, "top", () => $cc760d6caf22e25d$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $cc760d6caf22e25d$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $cc760d6caf22e25d$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $cc760d6caf22e25d$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $cc760d6caf22e25d$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $cc760d6caf22e25d$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $cc760d6caf22e25d$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $cc760d6caf22e25d$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $cc760d6caf22e25d$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $cc760d6caf22e25d$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $cc760d6caf22e25d$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $cc760d6caf22e25d$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $cc760d6caf22e25d$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $cc760d6caf22e25d$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $cc760d6caf22e25d$export$d087d3878fdf71d5);
var $cc760d6caf22e25d$export$1e95b668f3b82d = 'top';
var $cc760d6caf22e25d$export$40e543e69a8b3fbb = 'bottom';
var $cc760d6caf22e25d$export$79ffe56a765070d2 = 'right';
var $cc760d6caf22e25d$export$eabcd2c8791e7bf4 = 'left';
var $cc760d6caf22e25d$export$dfb5619354ba860 = 'auto';
var $cc760d6caf22e25d$export$aec2ce47c367b8c3 = [
    $cc760d6caf22e25d$export$1e95b668f3b82d,
    $cc760d6caf22e25d$export$40e543e69a8b3fbb,
    $cc760d6caf22e25d$export$79ffe56a765070d2,
    $cc760d6caf22e25d$export$eabcd2c8791e7bf4
];
var $cc760d6caf22e25d$export$b3571188c770cc5a = 'start';
var $cc760d6caf22e25d$export$bd5df0f255a350f8 = 'end';
var $cc760d6caf22e25d$export$390fd549c5303b4d = 'clippingParents';
var $cc760d6caf22e25d$export$d7b7311ec04a3e8f = 'viewport';
var $cc760d6caf22e25d$export$ae5ab1c730825774 = 'popper';
var $cc760d6caf22e25d$export$ca50aac9f3ba507f = 'reference';
var $cc760d6caf22e25d$export$368f9a87e87fa4e1 = /*#__PURE__*/ $cc760d6caf22e25d$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $cc760d6caf22e25d$export$b3571188c770cc5a,
        placement + "-" + $cc760d6caf22e25d$export$bd5df0f255a350f8
    ]);
}, []);
var $cc760d6caf22e25d$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($cc760d6caf22e25d$export$aec2ce47c367b8c3, [
    $cc760d6caf22e25d$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $cc760d6caf22e25d$export$b3571188c770cc5a,
        placement + "-" + $cc760d6caf22e25d$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $cc760d6caf22e25d$export$421679a7c3d56e = 'beforeRead';
var $cc760d6caf22e25d$export$aafa59e2e03f2942 = 'read';
var $cc760d6caf22e25d$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $cc760d6caf22e25d$export$c65e99957a05207c = 'beforeMain';
var $cc760d6caf22e25d$export$f22da7240b7add18 = 'main';
var $cc760d6caf22e25d$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $cc760d6caf22e25d$export$8d4d2d70e7d46032 = 'beforeWrite';
var $cc760d6caf22e25d$export$68d8715fc104d294 = 'write';
var $cc760d6caf22e25d$export$70a6e5159acce2e6 = 'afterWrite';
var $cc760d6caf22e25d$export$d087d3878fdf71d5 = [
    $cc760d6caf22e25d$export$421679a7c3d56e,
    $cc760d6caf22e25d$export$aafa59e2e03f2942,
    $cc760d6caf22e25d$export$6964f6c886723980,
    $cc760d6caf22e25d$export$c65e99957a05207c,
    $cc760d6caf22e25d$export$f22da7240b7add18,
    $cc760d6caf22e25d$export$bab79516f2d662fe,
    $cc760d6caf22e25d$export$8d4d2d70e7d46032,
    $cc760d6caf22e25d$export$68d8715fc104d294,
    $cc760d6caf22e25d$export$70a6e5159acce2e6
];

});


parcelRegister("hMY00", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf3575f17794dcad$export$2e2bcd8739ae039);
function $cf3575f17794dcad$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("57wDY", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ba6ed8a3ea6cc55$export$2e2bcd8739ae039);
function $3ba6ed8a3ea6cc55$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("hbNb5", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8399c6c8c266739$export$2e2bcd8739ae039);

var $jZmT7 = parcelRequire("jZmT7");
var $c8399c6c8c266739$var$passive = {
    passive: true
};
function $c8399c6c8c266739$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $jZmT7.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $c8399c6c8c266739$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $c8399c6c8c266739$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $c8399c6c8c266739$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $c8399c6c8c266739$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $c8399c6c8c266739$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $c8399c6c8c266739$var$effect,
    data: {}
};

});

parcelRegister("eV4b6", function(module, exports) {
$parcel$export(module.exports, "default", () => $adc9a139097f3f4a$export$2e2bcd8739ae039);

var $l3bjp = parcelRequire("l3bjp");
function $adc9a139097f3f4a$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $l3bjp.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $adc9a139097f3f4a$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $adc9a139097f3f4a$var$popperOffsets,
    data: {}
};

});
parcelRegister("l3bjp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f532a71eb0c6d0a8$export$2e2bcd8739ae039);

var $gs9mI = parcelRequire("gs9mI");

var $j3uWb = parcelRequire("j3uWb");

var $3TouH = parcelRequire("3TouH");

var $hylc7 = parcelRequire("hylc7");
function $f532a71eb0c6d0a8$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $gs9mI.default)(placement) : null;
    var variation = placement ? (0, $j3uWb.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $hylc7.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $hylc7.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $hylc7.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $hylc7.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $3TouH.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $hylc7.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $hylc7.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("gs9mI", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfa686a550790512$export$2e2bcd8739ae039);

function $bfa686a550790512$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("j3uWb", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddf64baa80d2ede1$export$2e2bcd8739ae039);
function $ddf64baa80d2ede1$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("3TouH", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d5982315fa787dd$export$2e2bcd8739ae039);
function $2d5982315fa787dd$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("9fkIo", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bb5955ba16e9dd7$export$2e2bcd8739ae039);

var $hylc7 = parcelRequire("hylc7");

var $cac2h = parcelRequire("cac2h");

var $jZmT7 = parcelRequire("jZmT7");

var $46rBs = parcelRequire("46rBs");

var $eWPK1 = parcelRequire("eWPK1");

var $gs9mI = parcelRequire("gs9mI");

var $j3uWb = parcelRequire("j3uWb");

var $f17IG = parcelRequire("f17IG");
var $6bb5955ba16e9dd7$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $6bb5955ba16e9dd7$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $f17IG.round)(x * dpr) / dpr || 0,
        y: (0, $f17IG.round)(y * dpr) / dpr || 0
    };
}
function $6bb5955ba16e9dd7$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $hylc7.left);
    var sideY = (0, $hylc7.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $cac2h.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $jZmT7.default)(popper)) {
            offsetParent = (0, $46rBs.default)(popper);
            if ((0, $eWPK1.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $hylc7.top) || (placement === (0, $hylc7.left) || placement === (0, $hylc7.right)) && variation === (0, $hylc7.end)) {
            sideY = (0, $hylc7.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $hylc7.left) || (placement === (0, $hylc7.top) || placement === (0, $hylc7.bottom)) && variation === (0, $hylc7.end)) {
            sideX = (0, $hylc7.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $6bb5955ba16e9dd7$var$unsetSides);
    var _ref4 = roundOffsets === true ? $6bb5955ba16e9dd7$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $jZmT7.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $6bb5955ba16e9dd7$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $gs9mI.default)(state.placement),
        variation: (0, $j3uWb.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $6bb5955ba16e9dd7$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $6bb5955ba16e9dd7$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $6bb5955ba16e9dd7$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $6bb5955ba16e9dd7$var$computeStyles,
    data: {}
};

});

parcelRegister("aqeNW", function(module, exports) {
$parcel$export(module.exports, "default", () => $7967d0f941f42760$export$2e2bcd8739ae039);

var $dPKF0 = parcelRequire("dPKF0");

var $8e4dK = parcelRequire("8e4dK");
// and applies them to the HTMLElements such as popper and arrow
function $7967d0f941f42760$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $8e4dK.isHTMLElement)(element) || !(0, $dPKF0.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7967d0f941f42760$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $8e4dK.isHTMLElement)(element) || !(0, $dPKF0.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7967d0f941f42760$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7967d0f941f42760$var$applyStyles,
    effect: $7967d0f941f42760$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("5f8S7", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d153c3ce5d31300$export$2e2bcd8739ae039);

var $gs9mI = parcelRequire("gs9mI");

var $hylc7 = parcelRequire("hylc7");
function $3d153c3ce5d31300$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $gs9mI.default)(placement);
    var invertDistance = [
        (0, $hylc7.left),
        (0, $hylc7.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $hylc7.left),
        (0, $hylc7.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $3d153c3ce5d31300$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $hylc7.placements).reduce(function(acc, placement) {
        acc[placement] = $3d153c3ce5d31300$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3d153c3ce5d31300$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $3d153c3ce5d31300$var$offset
};

});

parcelRegister("20Jv5", function(module, exports) {
$parcel$export(module.exports, "default", () => $176ee044b9237ed9$export$2e2bcd8739ae039);

var $01vw0 = parcelRequire("01vw0");

var $gs9mI = parcelRequire("gs9mI");

var $glBkd = parcelRequire("glBkd");

var $kKJXn = parcelRequire("kKJXn");

var $7Hn9C = parcelRequire("7Hn9C");

var $hylc7 = parcelRequire("hylc7");

var $j3uWb = parcelRequire("j3uWb");
function $176ee044b9237ed9$var$getExpandedFallbackPlacements(placement) {
    if ((0, $gs9mI.default)(placement) === (0, $hylc7.auto)) return [];
    var oppositePlacement = (0, $01vw0.default)(placement);
    return [
        (0, $glBkd.default)(placement),
        oppositePlacement,
        (0, $glBkd.default)(oppositePlacement)
    ];
}
function $176ee044b9237ed9$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $gs9mI.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $01vw0.default)(preferredPlacement)
    ] : $176ee044b9237ed9$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $gs9mI.default)(placement) === (0, $hylc7.auto) ? (0, $7Hn9C.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $gs9mI.default)(placement);
        var isStartVariation = (0, $j3uWb.default)(placement) === (0, $hylc7.start);
        var isVertical = [
            (0, $hylc7.top),
            (0, $hylc7.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $kKJXn.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $hylc7.right) : (0, $hylc7.left) : isStartVariation ? (0, $hylc7.bottom) : (0, $hylc7.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $01vw0.default)(mainVariationSide);
        var altVariationSide = (0, $01vw0.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $176ee044b9237ed9$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $176ee044b9237ed9$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("01vw0", function(module, exports) {
$parcel$export(module.exports, "default", () => $00488a5ba48d69ee$export$2e2bcd8739ae039);
var $00488a5ba48d69ee$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $00488a5ba48d69ee$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $00488a5ba48d69ee$var$hash[matched];
    });
}

});

parcelRegister("glBkd", function(module, exports) {
$parcel$export(module.exports, "default", () => $be6b8f818ae438e3$export$2e2bcd8739ae039);
var $be6b8f818ae438e3$var$hash = {
    start: 'end',
    end: 'start'
};
function $be6b8f818ae438e3$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $be6b8f818ae438e3$var$hash[matched];
    });
}

});

parcelRegister("kKJXn", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1bbc08f0fdbbd73$export$2e2bcd8739ae039);

var $5KGOg = parcelRequire("5KGOg");

var $46rBs = parcelRequire("46rBs");

var $3GPTj = parcelRequire("3GPTj");

var $l3bjp = parcelRequire("l3bjp");

var $cjnAC = parcelRequire("cjnAC");

var $hylc7 = parcelRequire("hylc7");

var $8e4dK = parcelRequire("8e4dK");

var $auZDo = parcelRequire("auZDo");

var $7kKRk = parcelRequire("7kKRk");
function $f1bbc08f0fdbbd73$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $hylc7.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $hylc7.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $hylc7.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $auZDo.default)(typeof padding !== 'number' ? padding : (0, $7kKRk.default)(padding, (0, $hylc7.basePlacements)));
    var altContext = elementContext === (0, $hylc7.popper) ? (0, $hylc7.reference) : (0, $hylc7.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5KGOg.default)((0, $8e4dK.isElement)(element) ? element : element.contextElement || (0, $46rBs.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $3GPTj.default)(state.elements.reference);
    var popperOffsets = (0, $l3bjp.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $cjnAC.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $hylc7.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $hylc7.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $hylc7.right),
                (0, $hylc7.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $hylc7.top),
                (0, $hylc7.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5KGOg", function(module, exports) {
$parcel$export(module.exports, "default", () => $430274bdbc923358$export$2e2bcd8739ae039);

var $hylc7 = parcelRequire("hylc7");

var $kqKon = parcelRequire("kqKon");

var $bsmpf = parcelRequire("bsmpf");

var $a9YOS = parcelRequire("a9YOS");

var $cac2h = parcelRequire("cac2h");

var $46rBs = parcelRequire("46rBs");

var $eWPK1 = parcelRequire("eWPK1");

var $8e4dK = parcelRequire("8e4dK");

var $3GPTj = parcelRequire("3GPTj");

var $3jGzw = parcelRequire("3jGzw");

var $fpA0l = parcelRequire("fpA0l");

var $dPKF0 = parcelRequire("dPKF0");

var $cjnAC = parcelRequire("cjnAC");

var $f17IG = parcelRequire("f17IG");
function $430274bdbc923358$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $3GPTj.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $430274bdbc923358$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $hylc7.viewport) ? (0, $cjnAC.default)((0, $kqKon.default)(element, strategy)) : (0, $8e4dK.isElement)(clippingParent) ? $430274bdbc923358$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $cjnAC.default)((0, $bsmpf.default)((0, $46rBs.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $430274bdbc923358$var$getClippingParents(element) {
    var clippingParents = (0, $a9YOS.default)((0, $3jGzw.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $eWPK1.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $8e4dK.isHTMLElement)(element) ? (0, $cac2h.default)(element) : element;
    if (!(0, $8e4dK.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $8e4dK.isElement)(clippingParent) && (0, $fpA0l.default)(clippingParent, clipperElement) && (0, $dPKF0.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $430274bdbc923358$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $430274bdbc923358$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $430274bdbc923358$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $f17IG.max)(rect.top, accRect.top);
        accRect.right = (0, $f17IG.min)(rect.right, accRect.right);
        accRect.bottom = (0, $f17IG.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $f17IG.max)(rect.left, accRect.left);
        return accRect;
    }, $430274bdbc923358$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("kqKon", function(module, exports) {
$parcel$export(module.exports, "default", () => $edfa38e61ca7ffa8$export$2e2bcd8739ae039);

var $jZmT7 = parcelRequire("jZmT7");

var $46rBs = parcelRequire("46rBs");

var $lsQ9o = parcelRequire("lsQ9o");

var $lrlTR = parcelRequire("lrlTR");
function $edfa38e61ca7ffa8$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $jZmT7.default)(element);
    var html = (0, $46rBs.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $lrlTR.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $lsQ9o.default)(element),
        y: y
    };
}

});

parcelRegister("bsmpf", function(module, exports) {
$parcel$export(module.exports, "default", () => $8573b0aa0b67ee7d$export$2e2bcd8739ae039);

var $46rBs = parcelRequire("46rBs");

var $eWPK1 = parcelRequire("eWPK1");

var $lsQ9o = parcelRequire("lsQ9o");

var $6fpcA = parcelRequire("6fpcA");

var $f17IG = parcelRequire("f17IG");
function $8573b0aa0b67ee7d$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $46rBs.default)(element);
    var winScroll = (0, $6fpcA.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $f17IG.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $f17IG.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $lsQ9o.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $eWPK1.default)(body || html).direction === 'rtl') x += (0, $f17IG.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("fpA0l", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3851e8e1cb3b530$export$2e2bcd8739ae039);

var $8e4dK = parcelRequire("8e4dK");
function $b3851e8e1cb3b530$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $8e4dK.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("cjnAC", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f698ec76337383e$export$2e2bcd8739ae039);
function $8f698ec76337383e$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("auZDo", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a4c8402dc9ce178$export$2e2bcd8739ae039);

var $lVjKu = parcelRequire("lVjKu");
function $7a4c8402dc9ce178$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $lVjKu.default)(), paddingObject);
}

});
parcelRegister("lVjKu", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff5e3d930865626d$export$2e2bcd8739ae039);
function $ff5e3d930865626d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("7kKRk", function(module, exports) {
$parcel$export(module.exports, "default", () => $556ebfed30f18b3a$export$2e2bcd8739ae039);
function $556ebfed30f18b3a$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("7Hn9C", function(module, exports) {
$parcel$export(module.exports, "default", () => $59ae827979b59576$export$2e2bcd8739ae039);

var $j3uWb = parcelRequire("j3uWb");

var $hylc7 = parcelRequire("hylc7");

var $kKJXn = parcelRequire("kKJXn");

var $gs9mI = parcelRequire("gs9mI");
function $59ae827979b59576$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $hylc7.placements) : _options$allowedAutoP;
    var variation = (0, $j3uWb.default)(placement);
    var placements = variation ? flipVariations ? (0, $hylc7.variationPlacements) : (0, $hylc7.variationPlacements).filter(function(placement) {
        return (0, $j3uWb.default)(placement) === variation;
    }) : (0, $hylc7.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $kKJXn.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $gs9mI.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("50ohQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a4fcaabf5c37491$export$2e2bcd8739ae039);

var $hylc7 = parcelRequire("hylc7");

var $gs9mI = parcelRequire("gs9mI");

var $3TouH = parcelRequire("3TouH");

var $4L1Hm = parcelRequire("4L1Hm");

var $92BXG = parcelRequire("92BXG");

var $8u3sc = parcelRequire("8u3sc");

var $cac2h = parcelRequire("cac2h");

var $kKJXn = parcelRequire("kKJXn");

var $j3uWb = parcelRequire("j3uWb");

var $lVjKu = parcelRequire("lVjKu");

var $f17IG = parcelRequire("f17IG");
function $3a4fcaabf5c37491$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $kKJXn.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $gs9mI.default)(state.placement);
    var variation = (0, $j3uWb.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $3TouH.default)(basePlacement);
    var altAxis = (0, $4L1Hm.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $hylc7.top) : (0, $hylc7.left);
        var altSide = mainAxis === 'y' ? (0, $hylc7.bottom) : (0, $hylc7.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $hylc7.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $hylc7.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $8u3sc.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $lVjKu.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $92BXG.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $cac2h.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $92BXG.within)(tether ? (0, $f17IG.min)(min, tetherMin) : min, offset, tether ? (0, $f17IG.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $hylc7.top) : (0, $hylc7.left);
        var _altSide = mainAxis === 'x' ? (0, $hylc7.bottom) : (0, $hylc7.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $hylc7.top),
            (0, $hylc7.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $92BXG.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $92BXG.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3a4fcaabf5c37491$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $3a4fcaabf5c37491$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("4L1Hm", function(module, exports) {
$parcel$export(module.exports, "default", () => $376cde77b2431af6$export$2e2bcd8739ae039);
function $376cde77b2431af6$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("92BXG", function(module, exports) {
$parcel$export(module.exports, "within", () => $6951bf5335a4a233$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $6951bf5335a4a233$export$86c8af6d3ef0b4a);

var $f17IG = parcelRequire("f17IG");
function $6951bf5335a4a233$export$f28d906d67a997f3(min, value, max) {
    return (0, $f17IG.max)(min, (0, $f17IG.min)(value, max));
}
function $6951bf5335a4a233$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $6951bf5335a4a233$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("bbEof", function(module, exports) {
$parcel$export(module.exports, "default", () => $82500d66201ade6c$export$2e2bcd8739ae039);

var $gs9mI = parcelRequire("gs9mI");

var $8u3sc = parcelRequire("8u3sc");

var $fpA0l = parcelRequire("fpA0l");

var $cac2h = parcelRequire("cac2h");

var $3TouH = parcelRequire("3TouH");

var $92BXG = parcelRequire("92BXG");

var $auZDo = parcelRequire("auZDo");

var $7kKRk = parcelRequire("7kKRk");

var $hylc7 = parcelRequire("hylc7");
var $82500d66201ade6c$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $auZDo.default)(typeof padding !== 'number' ? padding : (0, $7kKRk.default)(padding, (0, $hylc7.basePlacements)));
};
function $82500d66201ade6c$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $gs9mI.default)(state.placement);
    var axis = (0, $3TouH.default)(basePlacement);
    var isVertical = [
        (0, $hylc7.left),
        (0, $hylc7.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $82500d66201ade6c$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $8u3sc.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $hylc7.top) : (0, $hylc7.left);
    var maxProp = axis === 'y' ? (0, $hylc7.bottom) : (0, $hylc7.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $cac2h.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $92BXG.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $82500d66201ade6c$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $fpA0l.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $82500d66201ade6c$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $82500d66201ade6c$var$arrow,
    effect: $82500d66201ade6c$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("f7KNT", function(module, exports) {
$parcel$export(module.exports, "default", () => $b02bd0b39b6e3561$export$2e2bcd8739ae039);

var $hylc7 = parcelRequire("hylc7");

var $kKJXn = parcelRequire("kKJXn");
function $b02bd0b39b6e3561$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $b02bd0b39b6e3561$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $hylc7.top),
        (0, $hylc7.right),
        (0, $hylc7.bottom),
        (0, $hylc7.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $b02bd0b39b6e3561$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $kKJXn.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $kKJXn.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $b02bd0b39b6e3561$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $b02bd0b39b6e3561$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $b02bd0b39b6e3561$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $b02bd0b39b6e3561$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $b02bd0b39b6e3561$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $b02bd0b39b6e3561$var$hide
};

});




parcelRegister("hNMyT", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $cf5cae9c3beaf021$export$e0be378c32fb70a7);

var $euxye = parcelRequire("euxye");

var $89doV = parcelRequire("89doV");

var $2iEQi = parcelRequire("2iEQi");

var $3pNGD = parcelRequire("3pNGD");
function $cf5cae9c3beaf021$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $euxye.useContext((0, $2iEQi.ManagerReferenceNodeSetterContext));
    var refHandler = $euxye.useCallback(function(node) {
        (0, $3pNGD.setRef)(innerRef, node);
        (0, $3pNGD.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $euxye.useEffect(function() {
        return function() {
            return (0, $3pNGD.setRef)(innerRef, null);
        };
    }, []);
    $euxye.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($89doV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $3pNGD.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("cLMB7", function(module, exports) {
$parcel$export(module.exports, "shallowEqualObjects", () => $94bf9251673a95ca$export$3e67810a3f0e9f1c);
function $94bf9251673a95ca$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $94bf9251673a95ca$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $94bf9251673a95ca$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $94bf9251673a95ca$export$967a6b9924a689f7(a, b);
    return $94bf9251673a95ca$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("hipxU", function(module, exports) {
$parcel$export(module.exports, "IdProvider", () => $24080fc0e5f8e371$export$6be90bcb437e928f);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $gUxVT = parcelRequire("gUxVT");
const $24080fc0e5f8e371$export$6be90bcb437e928f = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${(0, $gUxVT.useId)()}${postfix}`;
    (0, $euxye.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});

});

parcelRegister("2eNhP", function(module, exports) {
$parcel$export(module.exports, "mergeStyles", () => $97d4d4b025257a31$export$e618dc39ac9ad607);
function $97d4d4b025257a31$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});

parcelRegister("lHQGB", function(module, exports) {
$parcel$export(module.exports, "defaultComponents", () => $18ec8ff4ae6122f7$export$71abc632aa29e6fe);
/* components.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $eAQb7 = parcelRequire("eAQb7");

var $3xX0E = parcelRequire("3xX0E");
// ==============================
// Custom Components
// ==============================
const $18ec8ff4ae6122f7$var$dropdownStyles = null;
const $18ec8ff4ae6122f7$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_1bsbzwfg _12l2v77o _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAQb7))), {
            color: "currentColor",
            label: ""
        })
    });
$18ec8ff4ae6122f7$var$DropdownIndicator.displayName = "DropdownIndicator";
const $18ec8ff4ae6122f7$var$controlStyles = null;
const $18ec8ff4ae6122f7$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: innerRef,
        className: (0, $4jQY2.default)([
            "_85i51b66 _1q51u2gc _y4tiu2gc _bozgu2gc"
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3xX0E.components).Control, {
            ...props,
            innerProps: innerProps
        })
    });
$18ec8ff4ae6122f7$var$Control.displayName = "Control";
// NOTE `props` intentionally omitted from `Fragment`
const $18ec8ff4ae6122f7$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ...innerProps,
        children: children
    });
$18ec8ff4ae6122f7$var$Menu.displayName = "Menu";
const $18ec8ff4ae6122f7$var$ClearIndicator = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3xX0E.components).ClearIndicator, {
        ...props
    });
$18ec8ff4ae6122f7$var$ClearIndicator.displayName = "ClearIndicator";
const $18ec8ff4ae6122f7$var$MultiValueRemove = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3xX0E.components).MultiValueRemove, {
        ...props
    });
$18ec8ff4ae6122f7$var$MultiValueRemove.displayName = "MultiValueRemove";
const $18ec8ff4ae6122f7$export$71abc632aa29e6fe = {
    Control: $18ec8ff4ae6122f7$var$Control,
    DropdownIndicator: $18ec8ff4ae6122f7$var$DropdownIndicator,
    Menu: $18ec8ff4ae6122f7$var$Menu,
    ClearIndicator: $18ec8ff4ae6122f7$var$ClearIndicator,
    MultiValueRemove: $18ec8ff4ae6122f7$var$MultiValueRemove
};

});

parcelRegister("5vT1z", function(module, exports) {
$parcel$export(module.exports, "DummyControl", () => $23f37aab377bdf39$export$87ce933b7fc29b8c);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $3xX0E = parcelRequire("3xX0E");

var $apUrw = parcelRequire("apUrw");
const $23f37aab377bdf39$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3xX0E.components).Control, {
            ...props
        })
    });
$23f37aab377bdf39$export$87ce933b7fc29b8c.displayName = "DummyControl";

});

parcelRegister("a2btN", function(module, exports) {
$parcel$export(module.exports, "MenuDialog", () => $87fca35753bb0cbf$export$c94219dad7c0e37d);
/* menu-dialog.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $iqfTZ = parcelRequire("iqfTZ");
const $87fca35753bb0cbf$var$menuDialogStyles = null;
const $87fca35753bb0cbf$var$menuDialogStylesT26Shape = null;
const $87fca35753bb0cbf$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, id: id, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: ref,
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, $4jQY2.default)([
            "_2rko12b0 _1pby16oo _bfhk1bhr _16qs130s",
            (0, $iqfTZ.fg)('platform-dst-shape-theme-default') && "_2rko1mok"
        ]),
        children: children
    });
});

});

parcelRegister("fq62x", function(module, exports) {
$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $2ca5100b52c92753$export$17baa7c95b6ba1b8);

var $9fOPQ = parcelRequire("9fOPQ");
function $2ca5100b52c92753$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    (0, $9fOPQ.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}
$2ca5100b52c92753$export$17baa7c95b6ba1b8.displayName = "NotifyOpenLayerObserver";

});

parcelRegister("ieVCH", function(module, exports) {
$parcel$export(module.exports, "PopupSelectTopLayer", () => $858a01d1b8bc3438$export$25125c0cb8e7659a);
/* popup-select-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $glbdM = parcelRequire("glbdM");

var $iqfTZ = parcelRequire("iqfTZ");

var $2eNhP = parcelRequire("2eNhP");

var $gkWVj = parcelRequire("gkWVj");

var $Yce2Z = parcelRequire("Yce2Z");

var $j0Y0H = parcelRequire("j0Y0H");

var $fEJPe = parcelRequire("fEJPe");

var $kUmcP = parcelRequire("kUmcP");

var $baIdH = parcelRequire("baIdH");

var $lHQGB = parcelRequire("lHQGB");

var $5vT1z = parcelRequire("5vT1z");
// Styles.
const $858a01d1b8bc3438$var$menuDialogStyles = null;
const $858a01d1b8bc3438$var$menuDialogStylesT26Shape = null;
function $858a01d1b8bc3438$export$25125c0cb8e7659a({ closeMenuOnSelect: // PopupSelect-specific props.
closeMenuOnSelect = true, shouldCloseMenuOnTab: shouldCloseMenuOnTab = true, footer: footer, searchThreshold: searchThreshold = 5, maxMenuWidth: maxMenuWidth = 440, minMenuWidth: minMenuWidth = 220, maxMenuHeight: maxMenuHeight = 300, target: target, label: label, placeholder: placeholder, testId: testId, isOpen: controlledIsOpen, defaultIsOpen: defaultIsOpen, spacing: _spacing, options: options = [], isSearchable: isSearchable = true, components: consumerComponents, styles: consumerStyles, onChange: onChange, onKeyDown: onKeyDown, onOpen: // Lifecycle callbacks.
onOpen, onClose: onClose, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, popperProps: // No-op props in top-layer path.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
popperProps, // eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldPreventEscapePropagation: _shouldPreventEscapePropagation, // Remaining props spread to Select.
...selectProps }) {
    // State.
    const isControlled = controlledIsOpen !== undefined;
    const [internalIsOpen, setInternalIsOpen] = (0, $euxye.useState)(isControlled ? Boolean(controlledIsOpen) : Boolean(defaultIsOpen));
    const isOpen = isControlled ? Boolean(controlledIsOpen) : internalIsOpen;
    const selectRef = (0, $euxye.useRef)(null);
    const triggerRef = (0, $euxye.useRef)(null);
    const popoverRef = (0, $euxye.useRef)(null);
    const popoverId = (0, $kUmcP.usePopoverId)();
    // Placement.
    const legacyPlacement = popperProps?.placement ?? 'bottom-start';
    // `popup-select` historically defaulted to an `[along, away] = [0, 8]` popper offset
    // modifier; consumers can override it via `popperProps.modifiers`. Honour both here so
    // the top-layer rendering matches the legacy popper output.
    const legacyOffset = (0, $euxye.useMemo)(()=>{
        const modifiers = popperProps?.modifiers;
        const value = modifiers?.find((modifier)=>modifier?.name === 'offset')?.options?.offset;
        if (Array.isArray(value) && value.length === 2) return [
            Number(value[0]) || 0,
            Number(value[1]) || 0
        ];
        return [
            0,
            8
        ];
    }, [
        popperProps?.modifiers
    ]);
    const topLayerPlacement = (0, $euxye.useMemo)(()=>(0, $gkWVj.fromLegacyPlacement)({
            legacy: legacyPlacement,
            offset: legacyOffset
        }), [
        legacyPlacement,
        legacyOffset
    ]);
    (0, $fEJPe.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen
    });
    // Merged components.
    const mergedComponents = (0, $euxye.useMemo)(()=>({
            ...(0, $lHQGB.defaultComponents),
            ...consumerComponents
        }), [
        consumerComponents
    ]);
    // Default styles.
    const defaultStyles = (0, $euxye.useMemo)(()=>({
            groupHeading: (provided)=>({
                    ...provided,
                    color: "var(--ds-text-subtlest, #6B6E76)"
                })
        }), []);
    // Utils.
    const getItemCount = (0, $euxye.useCallback)(()=>{
        return options.reduce((count, groupOrOption)=>{
            const group = groupOrOption;
            if (group.options) return count + group.options.length;
            return count + 1;
        }, 0);
    }, [
        options
    ]);
    const showSearchControl = isSearchable && getItemCount() > searchThreshold;
    const getMaxHeight = (0, $euxye.useCallback)(()=>{
        if (!selectRef.current) return maxMenuHeight;
        const controlRef = selectRef.current.select?.controlRef;
        const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
        return maxMenuHeight - offsetHeight;
    }, [
        maxMenuHeight,
        showSearchControl
    ]);
    const getLabel = (0, $euxye.useCallback)(()=>{
        if (label) return label;
        if (typeof placeholder === 'string') return placeholder;
        return undefined;
    }, [
        label,
        placeholder
    ]);
    // Open / Close.
    const open = (0, $euxye.useCallback)(()=>{
        if (!isControlled) setInternalIsOpen(true);
        onOpen?.();
        onMenuOpen?.();
    }, [
        isControlled,
        onOpen,
        onMenuOpen
    ]);
    const close = (0, $euxye.useCallback)(()=>{
        if (!isControlled) setInternalIsOpen(false);
        onClose?.();
        onMenuClose?.();
    }, [
        isControlled,
        onClose,
        onMenuClose
    ]);
    // Sync controlled isOpen.
    (0, $euxye.useEffect)(()=>{
        if (!isControlled) return;
        if (controlledIsOpen) {
            onOpen?.();
            onMenuOpen?.();
        } else {
            onClose?.();
            onMenuClose?.();
        }
    // Only react to changes in the controlled value
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        controlledIsOpen
    ]);
    // Open the react-select menu when isOpen becomes true.
    (0, $euxye.useEffect)(()=>{
        if (isOpen && selectRef.current) selectRef.current.select?.openMenu('first');
    }, [
        isOpen
    ]);
    // Event Handlers.
    const handleTargetKeyDown = (0, $euxye.useCallback)((event)=>{
        if (event.key === 'ArrowDown') open();
    }, [
        open
    ]);
    // Open the menu when the trigger is clicked. Mirrors the legacy
    // `PopupSelect` global-click listener: consumers are not required to
    // spread an `onClick`, so we walk up from the event target to the
    // trigger ref instead.
    (0, $euxye.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        return (0, $glbdM.bind)(window, {
            type: 'click',
            listener: (event)=>{
                const target = event.target;
                if (!(target instanceof Element)) return;
                const trigger = triggerRef.current;
                if (!trigger || !trigger.contains(target)) return;
                if (isOpen) {
                    close();
                    return;
                }
                open();
            },
            options: {
                capture: true
            }
        });
    }, [
        isOpen,
        open,
        close
    ]);
    // Focus restoration on close is handled automatically by Popover
    // based on the content role (role="dialog" -> auto-restore).
    const handleOnClose = (0, $euxye.useCallback)(({ reason: _reason })=>{
        if (isControlled) {
            // For controlled mode, notify consumer but do not change internal state
            onClose?.();
            onMenuClose?.();
            return;
        }
        close();
    }, [
        close,
        isControlled,
        onClose,
        onMenuClose
    ]);
    const handleSelectChange = (0, $euxye.useCallback)((value, actionMeta)=>{
        if (closeMenuOnSelect && actionMeta.action !== 'clear') {
            close();
            // Return focus to trigger after selection
            triggerRef.current?.focus();
        }
        onChange?.(value, actionMeta);
    }, [
        closeMenuOnSelect,
        close,
        onChange
    ]);
    const handleKeyDown = (0, $euxye.useCallback)((event)=>{
        const tabEvent = event.key === 'Tab';
        if (shouldCloseMenuOnTab && tabEvent) {
            close();
            triggerRef.current?.focus();
        }
        // Escape closes the menu and returns focus to the trigger.
        // The browser auto-restores focus on Escape, but we close
        // explicitly here so isOpen state stays in sync with the popover.
        if (event.key === 'Escape') {
            close();
            triggerRef.current?.focus();
        }
        onKeyDown?.(event);
    }, [
        shouldCloseMenuOnTab,
        close,
        onKeyDown
    ]);
    // Select components.
    // Type assertion needed because defaultComponents uses concrete OptionType/boolean
    // but Select expects the generic Option/IsMulti parameters. The components are
    // structurally compatible regardless of the generic parameters.
    const selectComponentsMerged = (0, $euxye.useMemo)(()=>({
            ...mergedComponents,
            Control: showSearchControl ? mergedComponents.Control : (0, $5vT1z.DummyControl),
            // Render react-select's menu inline; PopupSelectTopLayer's own
            // `Popover` is already the top-layer host. Otherwise the flag-on
            // `MenuPortalTopLayer` would nest a second popover.
            MenuPortal: ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {
                    children: children
                })
        }), [
        mergedComponents,
        showSearchControl
    ]);
    const getSelectRef = (0, $euxye.useCallback)((ref)=>{
        selectRef.current = ref;
    }, []);
    const triggerProps = {
        ref: (node)=>{
            triggerRef.current = node;
        },
        // No `onClick` on `triggerProps`: the trigger click is observed via
        // the capture-phase global `click` listener in the effect above,
        // matching the legacy `PopupSelect` contract for consumers that do
        // not spread `triggerProps` onto their target.
        onKeyDown: handleTargetKeyDown,
        // Maintain existing aria attribute format for backwards compatibility.
        // Should technically be 'dialog' instead of 'true', but preserving
        // legacy behavior. See go/DSP-22283
        'aria-haspopup': 'true',
        'aria-expanded': isOpen,
        // Always emit aria-controls referencing the controlled element.
        // Matches the behavior of `getAriaForTrigger` (see
        // `@atlaskit/top-layer/get-aria-for-trigger`) and aligns with the
        // WAI-ARIA spec recommendation.
        'aria-controls': popoverId,
        isOpen: isOpen
    };
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            target?.(triggerProps),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $Yce2Z.Popover), {
                ref: popoverRef,
                id: popoverId,
                role: "dialog",
                label: getLabel() ?? 'Popup select',
                isOpen: isOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--content`,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $j0Y0H.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                        style: {
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-testid": testId && `${testId}--menu`,
                        className: (0, $4jQY2.default)([
                            "_2rko12b0 _bfhk1bhr _16qs130s",
                            (0, $iqfTZ.fg)('platform-dst-shape-theme-default') && "_2rko1mok"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $baIdH.default), {
                                label: getLabel(),
                                backspaceRemovesValue: false,
                                controlShouldRenderValue: false,
                                isClearable: false,
                                tabSelectsValue: false,
                                menuIsOpen: true,
                                placeholder: placeholder,
                                ref: getSelectRef,
                                ...selectProps,
                                options: options,
                                isSearchable: showSearchControl,
                                styles: (0, $2eNhP.mergeStyles)(defaultStyles, consumerStyles || {}),
                                maxMenuHeight: getMaxHeight(),
                                components: selectComponentsMerged,
                                onChange: handleSelectChange,
                                onKeyDown: handleKeyDown,
                                testId: testId
                            }),
                            footer
                        ]
                    })
                })
            })
        ]
    });
}
$858a01d1b8bc3438$export$25125c0cb8e7659a.displayName = "PopupSelectTopLayer";

});




parcelRegister("ieUAe", function(module, exports) {
$parcel$export(module.exports, "batchByKey", () => $0b43d73044532a9d$export$da86c38211c1c0a8);
function $0b43d73044532a9d$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("h4CIG", function(module, exports) {
$parcel$export(module.exports, "messages", () => $5d6b29b731080030$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $5d6b29b731080030$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    placeholder: {
        id: 'fabric.elements.user-picker.placeholder',
        defaultMessage: 'Enter people or teams...',
        description: 'Placeholder description for empty user/team/email select field.'
    },
    addMore: {
        id: 'fabric.elements.user-picker.placeholder.add-more',
        defaultMessage: 'add more people...',
        description: 'Placeholder for multi user picker when the field is not empty.'
    },
    remove: {
        id: 'fabric.elements.user-picker.multi.remove-item',
        defaultMessage: 'Remove',
        description: 'Tooltip for the single item remove button in a multi user select field.'
    },
    clear: {
        id: 'fabric.elements.user-picker.single.clear',
        defaultMessage: 'Clear',
        description: 'Tooltip for clear button in the single user select field.'
    },
    errorMessage: {
        id: 'fabric.elements.user-picker.error.message',
        defaultMessage: 'Something went wrong',
        description: 'Error message to display when options fail to load.'
    },
    teamByline: {
        id: 'fabric.elements.user-picker.team.byline',
        defaultMessage: 'Team',
        description: 'Secondary text shown below a team name in the user picker drop-down list to indicate the option is a team.'
    },
    officialTeamByline: {
        id: 'fabric.elements.user-picker.team.byline.official',
        defaultMessage: '{teamTypeName} {verifiedIcon}',
        description: 'Byline for official/verified team with dynamic team type name'
    },
    officialMemberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count.official',
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    officialMemberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.official.including.you',
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.including.you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    officialPlus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.official',
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    officialPlus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.official.including.you',
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    addEmail: {
        id: 'fabric.elements.user-picker.email.add',
        defaultMessage: 'Add user',
        description: 'Label for the add-user option shown in the user picker when the user has typed a valid email address.'
    },
    selectToAddEmail: {
        id: 'fabric.elements.user-picker.email.select.to.add',
        defaultMessage: 'Select an email address',
        description: 'Instruction text shown in the user picker prompting the user to select a typed email address to add it.'
    },
    continueToAddEmail: {
        id: 'fabric.elements.user-picker.email.add.potential',
        defaultMessage: 'Enter an email address',
        description: 'Byline for a potentially valid email option.'
    },
    adminManagedGroupByline: {
        id: 'fabric.elements.user-picker.group.byline.admin-managed',
        defaultMessage: 'Admin group {verifiedIcon}',
        description: 'Byline for admin-managed groups with verified icon'
    },
    groupByline: {
        id: 'fabric.elements.user-picker.group.byline',
        defaultMessage: 'Admin-managed group',
        description: 'Secondary text shown below a group name in the user picker drop-down list to indicate the option is an admin-managed group.'
    },
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'Label shown in the user picker beside the list of sources where an external user was found (e.g. Jira, Confluence).'
    },
    externalUserSourcesError: {
        id: 'fabric.elements.user-picker.external.sourced.error',
        defaultMessage: "We can't connect you right now.",
        description: "Error message when we can't fetch a user's import sources"
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    jiraSource: {
        id: 'fabric.elements.user-picker.source.jira',
        defaultMessage: 'Jira',
        description: 'Source label shown in the user picker to indicate that an external user was found via Jira.'
    },
    confluenceSource: {
        id: 'fabric.elements.user-picker.source.confluence',
        defaultMessage: 'Confluence',
        description: 'This external user is sourced from Confluence'
    },
    otherAtlassianSource: {
        id: 'fabric.elements.user-picker.source.other-atlassian',
        defaultMessage: 'Other Atlassian products',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    otherAtlassianSourceAppify: {
        id: 'fabric.elements.user-picker.source.other-atlassian-appify',
        defaultMessage: 'Other Atlassian apps',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    },
    archivedLozenge: {
        id: 'fabric.elements.user-picker.archived.lozenge.text',
        defaultMessage: 'Archived',
        description: 'Text within the lozenge when the selected team has been archived/disbanded'
    },
    userTypeLabel: {
        id: 'fabric.elements.user-picker.user.type.label',
        defaultMessage: 'People',
        description: 'Tab or section heading label in the user picker that groups results of type People (individual users).'
    },
    teamTypeLabel: {
        id: 'fabric.elements.user-picker.team.type.label',
        defaultMessage: 'Teams',
        description: 'Tab or section heading label in the user picker that groups results of type Teams.'
    },
    emailTypeLabel: {
        id: 'fabric.elements.user-picker.email.type.label',
        defaultMessage: 'Emails',
        description: 'Tab or section heading label in the user picker that groups results of type Emails.'
    },
    groupTypeLabel: {
        id: 'fabric.elements.user-picker.group.type.label',
        defaultMessage: 'Groups',
        description: 'Tab or section heading label in the user picker that groups results of type Groups.'
    },
    externalUserTypeLabel: {
        id: 'fabric.elements.user-picker.external.user.type.label',
        defaultMessage: 'External Users',
        description: 'Tab or section heading label in the user picker that groups results of type External Users.'
    },
    customTypeLabel: {
        id: 'fabric.elements.user-picker.custom.type.label',
        defaultMessage: 'Customs',
        description: 'Tab or section heading label in the user picker that groups results of a custom type defined by the host application.'
    },
    otherTypeLabel: {
        id: 'fabric.elements.user-picker.other.type.label',
        defaultMessage: 'Others',
        description: 'Tab or section heading label in the user picker that groups results that do not fit any standard type category.'
    }
});

});

parcelRegister("ZAz94", function(module, exports) {
$parcel$export(module.exports, "groupOptionsByType", () => $18fc0cf2110c3174$export$393a985f7dd07cfe);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $55qdj = parcelRequire("55qdj");

var $emCaV = parcelRequire("emCaV");

var $h4CIG = parcelRequire("h4CIG");
const $18fc0cf2110c3174$var$getLabelForType = (type, customLabels)=>{
    if (customLabels && type in customLabels && (0, $iqfTZ.fg)('jsm-wfo-assignee-recommendation-on-queues')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: customLabels[type]
    });
    switch(type){
        case 'user':
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                ...(0, $h4CIG.messages).userTypeLabel
            });
        case 'team':
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                ...(0, $h4CIG.messages).teamTypeLabel
            });
        case 'group':
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                ...(0, $h4CIG.messages).groupTypeLabel
            });
        case 'custom':
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                ...(0, $h4CIG.messages).customTypeLabel
            });
        case 'external_user':
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                ...(0, $h4CIG.messages).externalUserTypeLabel
            });
        default:
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                ...(0, $h4CIG.messages).otherTypeLabel
            });
    }
};
const $18fc0cf2110c3174$export$393a985f7dd07cfe = (0, $emCaV.default)((options, groupByTypeOrder, customGroupLabels)=>{
    // If groupByTypeOrder is empty, just return the original options
    if (groupByTypeOrder.length === 0) return options;
    const groupedMap = new Map();
    options.forEach((option)=>{
        const type = option.data.type || 'other';
        if (!groupedMap.has(type)) groupedMap.set(type, []);
        groupedMap.get(type).push(option);
    });
    const result = [];
    // add groups in the specified order
    // type is not in groupByTypeOrder, don't add it to the result
    groupByTypeOrder.forEach((type)=>{
        if (groupedMap.has(type)) {
            result.push({
                label: $18fc0cf2110c3174$var$getLabelForType(type, customGroupLabels),
                options: groupedMap.get(type)
            });
            groupedMap.delete(type);
        }
    });
    return result;
});

});

parcelRegister("7lJSi", function(module, exports) {
$parcel$export(module.exports, "userPickerRenderedUfoExperience", () => $70d22c5886a491f7$export$b49757166e1acfc2);
$parcel$export(module.exports, "userPickerOptionsShownUfoExperience", () => $70d22c5886a491f7$export$135a264e0da507ae);
$parcel$export(module.exports, "UfoErrorBoundary", () => $70d22c5886a491f7$export$5ef1c2550074a375);

var $euxye = parcelRequire("euxye");

var $5X4ZM = parcelRequire("5X4ZM");
var $3nsUD = parcelRequire("3nsUD");
var $ff1v8 = parcelRequire("ff1v8");
const $70d22c5886a491f7$export$b49757166e1acfc2 = new (0, $5X4ZM.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $3nsUD.ExperienceTypes).Load,
    performanceType: (0, $3nsUD.ExperiencePerformanceTypes).PageSegmentLoad
});
const $70d22c5886a491f7$export$135a264e0da507ae = new (0, $5X4ZM.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $3nsUD.ExperienceTypes).Operation,
    performanceType: (0, $3nsUD.ExperiencePerformanceTypes).InlineResult
});
class $70d22c5886a491f7$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    componentDidCatch() {
        const instance = $70d22c5886a491f7$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $ff1v8.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}
$70d22c5886a491f7$export$5ef1c2550074a375.displayName = "UfoErrorBoundary";

});
parcelRegister("5X4ZM", function(module, exports) {
$parcel$export(module.exports, "ConcurrentExperience", () => $52d44397f660519b$export$ac1cddfee07ba6ac);

var $2KKsB = parcelRequire("2KKsB");

var $1fOu9 = parcelRequire("1fOu9");
class $52d44397f660519b$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $1fOu9.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $2KKsB.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});



parcelRegister("izN9o", function(module, exports) {
$parcel$export(module.exports, "getStyles", () => $97ed4a50a96099d6$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "getPopupStyles", () => $97ed4a50a96099d6$export$4e983f376ad8a3af);

var $iqfTZ = parcelRequire("iqfTZ");

var $2eNhP = parcelRequire("2eNhP");

var $emCaV = parcelRequire("emCaV");
const $97ed4a50a96099d6$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $97ed4a50a96099d6$export$53937c04f7dfc2ae = 6;
const $97ed4a50a96099d6$export$2c62ba763e976c54 = 39;
const $97ed4a50a96099d6$export$ffd58b7f6f099a57 = (0, $emCaV.default)((width, isMulti, isCompact, overrideStyles, isVisualRefresh, isPopupStyles, height, minHeight)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: state.isFocused ? "var(--ds-border-focused, #4688EC)" : state.isInvalid ? "var(--ds-border-danger, #E2483D)" : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : "var(--ds-border-input, #8C8F97)",
                backgroundColor: state.isFocused ? "var(--ds-background-input, #FFFFFF)" : state.selectProps.subtle ? 'transparent' : state.isDisabled && (0, $iqfTZ.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-background-disabled, #0515240F)" : state.selectProps.textFieldBackgroundColor ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)",
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: state.isFocused ? css[':hover'] ? "var(--ds-border-focused, #4688EC)" : "var(--ds-border-focused, #4688EC)" : state.isInvalid ? "var(--ds-border-danger, #E2483D)" : state.selectProps.subtle ? 'transparent' : "var(--ds-border-input, #8C8F97)",
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? "var(--ds-background-danger, #FFECEB)" : state.isFocused ? css[':hover'] ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)" : state.isDisabled ? "var(--ds-background-disabled, #0515240F)" : "var(--ds-background-input-hovered, #F8F8F8)"
                },
                padding: 0,
                minHeight: minHeight ? minHeight : height || isCompact ? isMulti && (0, $iqfTZ.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 30 : 'none' : isMulti && (0, $iqfTZ.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 42 : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: height ? height : isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ _paddingTop: _paddingTop, _paddingBottom: _paddingBottom, _paddingLeft: _paddingLeft, _paddingRight: _paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: "var(--ds-icon-danger, #C9372C)"
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ _paddingTop: _paddingTop, _paddingBottom: _paddingBottom, _position: _position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? isMulti && (0, $iqfTZ.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-025, 2px)" : 0 : isMulti && (0, $iqfTZ.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-100, 8px)" : $97ed4a50a96099d6$export$59c188914e58c94b,
                paddingBottom: isCompact ? isMulti && (0, $iqfTZ.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-025, 2px)" : 0 : isMulti && (0, $iqfTZ.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-100, 8px)" : $97ed4a50a96099d6$export$59c188914e58c94b,
                // Match pre–tag-uplift leading inset when only the placeholder shows (share dialog VR, etc.).
                paddingLeft: isMulti ? state.hasValue && state.selectProps.controlShouldRenderValue !== false && (0, $iqfTZ.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-100, 8px)" : $97ed4a50a96099d6$export$59c188914e58c94b : 0,
                gap: isMulti && (0, $iqfTZ.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-050, 4px)" : undefined,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$97ed4a50a96099d6$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $97ed4a50a96099d6$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: isMulti && (0, $iqfTZ.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 0 : `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                ...isMulti && (0, $iqfTZ.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && {
                    height: "var(--ds-space-250, 20px)",
                    alignItems: 'center'
                },
                paddingLeft: state.selectProps.isMulti ? 0 : $97ed4a50a96099d6$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: "var(--ds-text-subtlest, #6B6E76)",
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: "var(--ds-text-subtlest, #6B6E76)"
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $2eNhP.mergeStyles)(styles, overrideStyles) : styles;
});
const $97ed4a50a96099d6$export$4e983f376ad8a3af = (0, $emCaV.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$97ed4a50a96099d6$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, isVisualRefresh, true)
    }));

});

parcelRegister("g3DsG", function(module, exports) {
$parcel$export(module.exports, "getComponents", () => $9c86bf8fc91cd05f$export$4e811121b221213b);
$parcel$export(module.exports, "getPopupComponents", () => $9c86bf8fc91cd05f$export$19205fd341a6bb08);

var $emCaV = parcelRequire("emCaV");

var $53P3N = parcelRequire("53P3N");

var $gseHl = parcelRequire("gseHl");

var $eGL2v = parcelRequire("eGL2v");

var $9ja1D = parcelRequire("9ja1D");

var $2VUjO = parcelRequire("2VUjO");

var $dTNIY = parcelRequire("dTNIY");

var $120UA = parcelRequire("120UA");

var $hf0xy = parcelRequire("hf0xy");

var $dghO7 = parcelRequire("dghO7");

var $kykcP = parcelRequire("kykcP");

var $cWBH9 = parcelRequire("cWBH9");
const $9c86bf8fc91cd05f$export$4e811121b221213b = (0, $emCaV.default)((multi, anchor, showClearIndicator, customComponents)=>{
    if (anchor) return {
        Control: anchor,
        Option: $9ja1D.Option
    };
    else return {
        MultiValue: $gseHl.MultiValue,
        DropdownIndicator: null,
        SingleValue: $2VUjO.SingleValue,
        ClearIndicator: showClearIndicator || !multi ? (0, $53P3N.ClearIndicator) : null,
        Option: $9ja1D.Option,
        ValueContainer: multi ? (0, $eGL2v.MultiValueContainer) : (0, $120UA.SingleValueContainer),
        Input: $dTNIY.Input,
        Menu: $kykcP.Menu,
        Control: $cWBH9.default,
        ...customComponents ? customComponents : {}
    };
});
const $9c86bf8fc91cd05f$export$19205fd341a6bb08 = (0, $emCaV.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $2VUjO.SingleValue,
        ClearIndicator: $53P3N.ClearIndicator,
        Option: $9ja1D.Option,
        ValueContainer: (0, $120UA.SingleValueContainer),
        Input: (0, $hf0xy.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $dghO7.PopupControl)
    };
    return baseProps;
});

});
parcelRegister("53P3N", function(module, exports) {
$parcel$export(module.exports, "ClearIndicator", () => $8d39e904babe48f4$export$ecf9cf59142dd54a);
/* ClearIndicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $3xX0E = parcelRequire("3xX0E");

const $8d39e904babe48f4$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).lazy(()=>(parcelRequire("99vKB")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $8d39e904babe48f4$var$clearIndicatorStyles = {
    root: "_v5641ppt _tzy4kb7n _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _30l3s4qr _1mhjgrf3"
};
class $8d39e904babe48f4$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).PureComponent {
    render() {
        const { selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3xX0E.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            },
            xcss: $8d39e904babe48f4$var$clearIndicatorStyles.root
        });
        return clearValueLabel ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Suspense, {
            fallback: Indicator,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)($8d39e904babe48f4$var$AsyncTooltip, {
                content: clearValueLabel,
                children: Indicator
            })
        }) : Indicator;
    }
    constructor(...args){
        super(...args), this.handleMouseDown = (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        };
    }
}
$8d39e904babe48f4$export$ecf9cf59142dd54a.displayName = "ClearIndicator";

});
parcelRegister("99vKB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5DCQX").then(()=>parcelRequire('6tF6K'));

});


parcelRegister("gseHl", function(module, exports) {
$parcel$export(module.exports, "MultiValue", () => $b74ec396199569c2$export$419cdf50db8b579);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");
var $2BUXh = parcelRequire("2BUXh");
var $fbAgj = parcelRequire("fbAgj");

var $3xX0E = parcelRequire("3xX0E");

var $hStPE = parcelRequire("hStPE");

var $8z2GW = parcelRequire("8z2GW");

var $iqfTZ = parcelRequire("iqfTZ");

var $jI5oo = parcelRequire("jI5oo");
var $d0F9p = parcelRequire("d0F9p");

var $8dkEA = parcelRequire("8dkEA");

var $lCzPN = parcelRequire("lCzPN");

var $7EDVG = parcelRequire("7EDVG");

var $5Ps6w = parcelRequire("5Ps6w");

var $1KHUB = parcelRequire("1KHUB");

var $2EFuW = parcelRequire("2EFuW");

var $2q0vg = parcelRequire("2q0vg");

var $4XWUs = parcelRequire("4XWUs");

var $55qdj = parcelRequire("55qdj");

var $h4CIG = parcelRequire("h4CIG");
function $b74ec396199569c2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b74ec396199569c2$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $b74ec396199569c2$var$groupTagContainerOld = (0, $fbAgj.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $b74ec396199569c2$var$groupTagContainer = (0, $fbAgj.xcss)({
    paddingLeft: 'space.050'
});
const $b74ec396199569c2$var$archivedLozengeWrapper = (0, $fbAgj.xcss)({
    display: 'flex',
    paddingLeft: 'space.050'
});
const $b74ec396199569c2$var$iconStyle = {
    name: "1sq8lny",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0;width:20px;height:20px"
};
const $b74ec396199569c2$var$nameWrapper = {
    name: "1b3uxdh",
    styles: "font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
const $b74ec396199569c2$var$avatarTagWrapperStyle = {
    name: "14413o7",
    styles: "display:flex;font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
class $b74ec396199569c2$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    constructor(props){
        super(props), this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $1KHUB.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $hStPE.jsx)((0, $lCzPN.AddOptionAvatar), {
                isLozenge: true,
                isPendingAction: data.isPendingAction
            });
            if ((0, $1KHUB.isGroup)(data)) return /*#__PURE__*/ (0, $hStPE.jsx)((0, $c69sa.Box), {
                xcss: $b74ec396199569c2$var$groupTagContainerOld
            }, /*#__PURE__*/ (0, $hStPE.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2q0vg))), {
                color: "currentColor",
                label: ""
            }));
            if (data.icon) return /*#__PURE__*/ (0, $hStPE.jsx)((0, $7EDVG.AvatarOrIcon), {
                appearance: "multi",
                icon: data.icon,
                iconColor: data.iconColor,
                src: (0, $1KHUB.getAvatarUrl)(data),
                type: (0, $1KHUB.isTeam)(data) ? 'team' : 'person'
            });
            // Fallback to original behavior
            return /*#__PURE__*/ (0, $hStPE.jsx)((0, $5Ps6w.SizeableAvatar), {
                appearance: "multi",
                src: (0, $1KHUB.getAvatarUrl)(data),
                type: (0, $1KHUB.isTeam)(data) ? 'team' : 'person'
            });
        }, this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            const canShowArchivedLozenge = (0, $1KHUB.isTeam)(data) && data?.state === 'DISBANDED';
            if ((0, $1KHUB.isGroup)(data) && data.includeTeamsUpdates || (0, $1KHUB.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $hStPE.jsx)((0, $4XWUs.VerifiedTeamIcon), {
                size: data.includeTeamsUpdates ? 'small' : 'medium'
            });
            if (canShowArchivedLozenge) return /*#__PURE__*/ (0, $hStPE.jsx)((0, $c69sa.Box), {
                xcss: $b74ec396199569c2$var$archivedLozengeWrapper
            }, /*#__PURE__*/ (0, $hStPE.jsx)((0, $2EFuW.default), {
                appearance: "neutral"
            }, /*#__PURE__*/ (0, $hStPE.jsx)((0, $55qdj.default), (0, $h4CIG.messages).archivedLozenge)));
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createRef();
    }
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $b74ec396199569c2$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: option, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: nextOption, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        if (option == null || nextOption == null) return option !== nextOption || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
        const { label: label, data: data } = option;
        const { label: nextLabel, data: nextData } = nextOption;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: _innerProps, removeProps: removeProps, data: option, ...rest } = this.props;
        if ((0, $iqfTZ.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const { data: data, label: label } = option;
            const isTeamOption = (0, $1KHUB.isTeam)(data);
            const isGroupOption = (0, $1KHUB.isGroup)(data);
            const isEmailOption = (0, $1KHUB.isEmail)(data);
            const avatarUrl = (0, $1KHUB.getAvatarUrl)(data);
            const isDisabled = Boolean(this.props.selectProps?.isDisabled);
            const canShowArchivedLozenge = (0, $1KHUB.isTeam)(data) && data?.state === 'DISBANDED';
            const avatarProps = avatarUrl ? {
                name: data.name,
                src: avatarUrl
            } : {
                name: data.name
            };
            const onAfterRemoveAction = ()=>{
                removeProps.onClick({});
            };
            if (isEmailOption) return /*#__PURE__*/ (0, $hStPE.jsx)("span", {
                ref: this.containerRef,
                css: $b74ec396199569c2$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, /*#__PURE__*/ (0, $hStPE.jsx)((0, $d0F9p.default), {
                text: label,
                elemBefore: /*#__PURE__*/ (0, $hStPE.jsx)((0, $lCzPN.AddOptionAvatar), {
                    isLozenge: true,
                    isPendingAction: data.isPendingAction
                }),
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                hasMargin: false
            }));
            if (isGroupOption) return /*#__PURE__*/ (0, $hStPE.jsx)("span", {
                ref: this.containerRef,
                css: $b74ec396199569c2$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, /*#__PURE__*/ (0, $hStPE.jsx)((0, $d0F9p.default), {
                text: label,
                elemBefore: /*#__PURE__*/ (0, $hStPE.jsx)((0, $c69sa.Box), {
                    xcss: $b74ec396199569c2$var$groupTagContainer
                }, /*#__PURE__*/ (0, $hStPE.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2q0vg))), {
                    color: "currentColor",
                    label: "",
                    size: "small"
                })),
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                hasMargin: false
            }));
            if (data.icon) return /*#__PURE__*/ (0, $hStPE.jsx)("span", {
                ref: this.containerRef,
                css: $b74ec396199569c2$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, /*#__PURE__*/ (0, $hStPE.jsx)((0, $d0F9p.default), {
                text: label,
                elemBefore: /*#__PURE__*/ (0, $hStPE.jsx)("div", {
                    css: $b74ec396199569c2$var$iconStyle,
                    style: {
                        color: data.iconColor
                    }
                }, data.icon),
                isRemovable: !isDisabled,
                hasMargin: false,
                onAfterRemoveAction: onAfterRemoveAction
            }));
            return /*#__PURE__*/ (0, $hStPE.jsx)("span", {
                ref: this.containerRef,
                css: $b74ec396199569c2$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, isTeamOption ? /*#__PURE__*/ (0, $hStPE.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, $hStPE.jsx)((0, $jI5oo.default), {
                type: "other",
                text: label,
                isVerified: isTeamOption ? data.verified : undefined,
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                avatar: (props)=>// AvatarTag always supplies size="xxsmall", which is a valid
                    // TeamAvatarSize; TeamAvatar does not support UNSAFE_xsmall.
                    /*#__PURE__*/ (0, $hStPE.jsx)((0, $8dkEA.default), {
                        ...props,
                        ...avatarProps
                    }),
                hasMargin: false
            }), canShowArchivedLozenge ? /*#__PURE__*/ (0, $hStPE.jsx)((0, $c69sa.Box), {
                xcss: $b74ec396199569c2$var$archivedLozengeWrapper
            }, /*#__PURE__*/ (0, $hStPE.jsx)((0, $2EFuW.default), {
                appearance: "neutral"
            }, /*#__PURE__*/ (0, $hStPE.jsx)((0, $55qdj.default), (0, $h4CIG.messages).archivedLozenge))) : null) : /*#__PURE__*/ (0, $hStPE.jsx)((0, $jI5oo.default), {
                type: "user",
                text: label,
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                avatar: (props)=>/*#__PURE__*/ (0, $hStPE.jsx)((0, $8z2GW.default), {
                        ...props,
                        ...avatarProps
                    }),
                hasMargin: false
            }));
        }
        return /*#__PURE__*/ (0, $hStPE.jsx)((0, $3xX0E.components).MultiValue, {
            ...rest,
            data: option,
            removeProps: removeProps,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $hStPE.jsx)((0, $2BUXh.Inline), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $hStPE.jsx)("div", {
            css: $b74ec396199569c2$var$nameWrapper
        }, children), this.getElemAfter()));
    }
}
$b74ec396199569c2$export$419cdf50db8b579.displayName = "MultiValue";

});
parcelRegister("jI5oo", function(module, exports) {
$parcel$export(module.exports, "default", () => $54cecf655bf7ca32$export$2e2bcd8739ae039);
/* avatar-tag.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $j7qEN = parcelRequire("j7qEN");

var $cBgWk = parcelRequire("cBgWk");

var $l6ERj = parcelRequire("l6ERj");

var $7jp8W = parcelRequire("7jp8W");

var $8cVIY = parcelRequire("8cVIY");

var $2M8pZ = parcelRequire("2M8pZ");

var $33N7D = parcelRequire("33N7D");
const $54cecf655bf7ca32$var$styles = {
    baseStyles: "_zulpv77o _2rko1rr0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcze3t _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3iv47k _kqswh2mm _4cvr1h6o _s7n4nkob _bfhk1w7a _syazi7uo _80om73ad _y4tii2wt _bozgze3t",
    noMarginStyles: "_1mouze3t _195gze3t",
    otherBaseStyles: "_2rko12b0 _y4ti1b66",
    agentBaseStyles: "_2rko12b0 _y4ti1b66",
    removableStyles: "_y4ti1l7b _1ul98pqr",
    userRemovableStyles: "_y4ti1l7b _1ul98pqr",
    avatarStyles: "_4bfu18uv _1hmsglyw _ajmmnqa1 _2rko1rr0 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _1o9zidpf _ahbq1n1a",
    otherAvatarStyles: "_2rko12b0",
    agentAvatarStyles: "_2rkoidpf",
    textStyles: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1bto1l2s _o5721q9c _1ul9idpf _syazi7uo",
    afterStyles: "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _lcxv1wug _ahbqv77o _kqswh2mm",
    verifiedIconStyles: "_1e0c116y _4cvr1h6o _1o9zidpf _syaz6txe _ahbqt94y",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _7nm0v77o _593818uv _yha2glyw _1nmznqa1 _1ufy15vq _turg15vq _jr6g1snc _1ymragmp _1y1s10yn _1hw7116y _6wji1h6o _1k6fidpf _43dsjdj5 _jwdiagmp _1cayjdj5 _102s1snc _yi8hagmp _h79h10yn _9m7f18uv _w7swglyw _15a9nqa1 _jxlhagmp",
    interactiveHoverStyles: "_fs7a18uv _1uxk8stv _12u8nqa1 _irr31dpa _oxk4jdj5 _1di6fcek"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles */ // Border color style - gray only for AvatarTag.
// Uses the new color.border.accent.gray.subtle token directly so no OKLCH/color-mix
// runtime transforms are needed.
const $54cecf655bf7ca32$var$borderColorStyles = {
    root: "_119bmsup"
};
// Border filter styles - base state
const $54cecf655bf7ca32$var$borderFilterStyles = {
    root: "_1h6dip4g"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles */ /**
 * __AvatarTag__
 *
 * AvatarTag is a specialized tag for representing people, teams/other entities, or agents with an avatar and name.
 * The visual appearance (round, square, or hexagonal) is determined by the `type` prop.
 */ const $54cecf655bf7ca32$var$AvatarTagComponent = /*#__PURE__*/ (0, $euxye.forwardRef)(function AvatarTag({ text: text, type: type, avatar: AvatarComponent, href: href, linkComponent: linkComponent, isRemovable: isRemovable = true, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, isVerified: isVerified, maxWidth: // Shows verified icon for 'other' type tags
maxWidth, hasMargin: hasMargin = true, onClick: onClick, ...other }, ref) {
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $33N7D.useTagRemoval)(onBeforeRemoveAction);
    const onShrinkOutExitComplete = (0, $euxye.useCallback)(()=>{
        onAfterRemoveAction?.(text);
    }, [
        onAfterRemoveAction,
        text
    ]);
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $8cVIY.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $7jp8W.useButtonInteraction)();
    // Determine styles based on type
    const isOtherType = type === 'other';
    const isAgentType = type === 'agent';
    const isUserType = type === 'user';
    // isVerified is only available for 'other' type
    const showVerified = isOtherType && isVerified;
    // Determine avatar appearance based on type
    const avatarAppearance = isUserType ? 'circle' : isAgentType ? 'hexagon' : 'square';
    // Determine remove button shape based on type
    const removeButtonShape = isUserType ? 'circle' : 'default';
    const removeButton = (0, $2M8pZ.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: text,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        shape: removeButtonShape,
        buttonHandlers: buttonHandlers
    });
    // Render the avatar with controlled props, then clone so our props are applied
    const controlledProps = {
        size: 'xxsmall',
        appearance: avatarAppearance,
        borderColor: 'transparent'
    };
    const AvatarComponentTyped = AvatarComponent;
    const rendered = /*#__PURE__*/ (0, $e79Pd.jsx)(AvatarComponentTyped, {
        ...controlledProps
    });
    const avatarElement = // eslint-disable-next-line @repo/internal/react/no-clone-element
    /*#__PURE__*/ (0, $euxye.isValidElement)(rendered) ? /*#__PURE__*/ (0, $euxye.cloneElement)(rendered, controlledProps) : rendered;
    const tagContent = /*#__PURE__*/ (0, $e79Pd.jsxs)("span", {
        ...other,
        ref: ref,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined,
        className: (0, $4jQY2.default)([
            $54cecf655bf7ca32$var$styles.baseStyles,
            !hasMargin && $54cecf655bf7ca32$var$styles.noMarginStyles,
            isOtherType && $54cecf655bf7ca32$var$styles.otherBaseStyles,
            isAgentType && $54cecf655bf7ca32$var$styles.agentBaseStyles,
            $54cecf655bf7ca32$var$borderColorStyles.root,
            $54cecf655bf7ca32$var$borderFilterStyles.root,
            isLink && $54cecf655bf7ca32$var$styles.interactiveBaseStyles,
            isLink && $54cecf655bf7ca32$var$styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && $54cecf655bf7ca32$var$styles.interactiveHoverStyles,
            isRemovable && !isUserType && $54cecf655bf7ca32$var$styles.removableStyles,
            isRemovable && isUserType && $54cecf655bf7ca32$var$styles.userRemovableStyles,
            isLinkFocused && !isButtonFocused && $54cecf655bf7ca32$var$styles.childFocusRingStyles
        ]),
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $cBgWk.LinkWrapper), {
                isLink: isLink,
                href: href,
                LinkComponent: LinkComponent,
                testId: testId,
                linkHandlers: linkHandlers,
                onClick: onClick,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        className: (0, $4jQY2.default)([
                            $54cecf655bf7ca32$var$styles.avatarStyles,
                            isOtherType && $54cecf655bf7ca32$var$styles.otherAvatarStyles,
                            isAgentType && $54cecf655bf7ca32$var$styles.agentAvatarStyles
                        ]),
                        children: avatarElement
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        "data-tag-text": true,
                        className: (0, $4jQY2.default)([
                            $54cecf655bf7ca32$var$styles.textStyles
                        ]),
                        children: text
                    })
                ]
            }),
            showVerified && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    $54cecf655bf7ca32$var$styles.verifiedIconStyles
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($j7qEN))), {
                    label: "Verified",
                    size: "small"
                })
            }),
            removeButton && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    $54cecf655bf7ca32$var$styles.afterStyles
                ]),
                children: removeButton
            })
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $l6ERj.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        children: tagContent
    });
});
/**
 * __Avatar tag__
 */ const $54cecf655bf7ca32$var$AvatarTag = /*#__PURE__*/ (0, $euxye.memo)($54cecf655bf7ca32$var$AvatarTagComponent);
var $54cecf655bf7ca32$export$2e2bcd8739ae039 = $54cecf655bf7ca32$var$AvatarTag;

});
parcelRegister("j7qEN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7af42e4ed582afb1138c492d59100fd3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $deb3595031bb17ca$var$_react = $deb3595031bb17ca$var$_interopRequireDefault((parcelRequire("euxye")));

var $deb3595031bb17ca$var$_baseNew = $deb3595031bb17ca$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $deb3595031bb17ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-verified
 * Usage guidance:
 * Reserved for representing verified content.
 * Filled status icons provide higher visual contrast draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $deb3595031bb17ca$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $deb3595031bb17ca$var$_react.default.createElement($deb3595031bb17ca$var$_baseNew.default, Object.assign({
        name: "StatusVerifiedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.85.444a1.713 1.713 0 0 1 2.301 0L10.3 1.486a.2.2 0 0 0 .15.055L12 1.48a1.71 1.71 0 0 1 1.762 1.479l.21 1.537a.2.2 0 0 0 .081.139l1.226.95c.696.54.87 1.52.4 2.266l-.828 1.312a.2.2 0 0 0-.027.158l.328 1.516a1.713 1.713 0 0 1-1.151 1.993l-1.477.474a.2.2 0 0 0-.123.103l-.723 1.372a1.713 1.713 0 0 1-2.162.787l-1.435-.587a.2.2 0 0 0-.161 0l-1.436.587a1.713 1.713 0 0 1-2.162-.787l-.723-1.372a.22.22 0 0 0-.124-.103L2 12.83a1.713 1.713 0 0 1-1.15-1.993l.327-1.516a.2.2 0 0 0-.027-.158L.322 7.852a1.713 1.713 0 0 1 .4-2.266l1.225-.95a.2.2 0 0 0 .081-.14l.21-1.536a1.71 1.71 0 0 1 1.763-1.48l1.55.06a.2.2 0 0 0 .15-.055zm-.1 9.384L4.826 7.519l-1.152.961 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$deb3595031bb17ca$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $deb3595031bb17ca$var$_default = module.exports.default = $deb3595031bb17ca$var$StatusVerifiedIcon;

});


parcelRegister("8dkEA", function(module, exports) {
$parcel$export(module.exports, "default", () => $34c210d6b368449a$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $jduYm = parcelRequire("jduYm");
var $8z2GW = parcelRequire("8z2GW");

var $iqfTZ = parcelRequire("iqfTZ");

var $kBFGv = parcelRequire("kBFGv");
const $34c210d6b368449a$export$ebe0b8fe8b6acbfd = "var(--ds-icon-inverse, #FFFFFF)";
const $34c210d6b368449a$export$72502e51aebdd94e = "var(--ds-icon-subtle, #505258)";
function $34c210d6b368449a$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', teamId: teamId = '', compact: compact = false, ...props }) {
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    if ((0, $iqfTZ.fg)('enable_teams_t26_design_drop_core_experiences')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8z2GW.default), {
        ...props,
        appearance: "square",
        size: size,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jduYm.AvatarContent), {
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kBFGv.TeamAvatarImage), {
                src: src,
                size: size,
                testId: testId,
                teamId: teamId
            }, teamId)
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8z2GW.default), {
        appearance: "square",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kBFGv.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            teamId: teamId,
            compact: compact
        })
    });
}
$34c210d6b368449a$export$2e2bcd8739ae039.displayName = "TeamAvatar";

});
parcelRegister("kBFGv", function(module, exports) {
$parcel$export(module.exports, "TeamAvatarImage", () => $2c3a3e41a4ebfd5a$export$ac3673635a5387be);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $iqfTZ = parcelRequire("iqfTZ");

var $ihEDU = parcelRequire("ihEDU");

var $hSqqn = parcelRequire("hSqqn");

var $iA44E = parcelRequire("iA44E");

var $gBiFv = parcelRequire("gBiFv");
const $2c3a3e41a4ebfd5a$var$boxShadowCssVar = '--avatar-box-shadow';
const $2c3a3e41a4ebfd5a$var$bgColorCssVar = '--avatar-bg-color';
/**
 * We need to maintan the container styles manually until Avatar provides the correct border radius.
 * After that we can return to wrapping in <AvatarContent> rather than span
 */ const $2c3a3e41a4ebfd5a$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw",
    nonCompactSpacing: "_6rthv77o _1pfhv77o _12l2v77o _ahbqv77o",
    compactSpacing: "_6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t",
    circle: "_2rko1qll _14mj1qll",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
const $2c3a3e41a4ebfd5a$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y"
};
const $2c3a3e41a4ebfd5a$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $2c3a3e41a4ebfd5a$var$SIZES = {
    xxsmall: 16,
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $2c3a3e41a4ebfd5a$var$borderRadiusMap = {
    xxsmall: "_2rkol0p1",
    xsmall: "_2rkol0p1",
    small: "_2rkol0p1",
    medium: "_2rkol0p1",
    large: "_2rkol0p1",
    xlarge: "_2rkol0p1",
    xxlarge: "_2rkol0p1"
};
const $2c3a3e41a4ebfd5a$var$widthHeightMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz",
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $2c3a3e41a4ebfd5a$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, teamId: teamId, compact: compact = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $euxye.useState)(false);
    const avatarSrc = (0, $gBiFv.getTeamAvatarSrc)(src, teamId);
    (0, $euxye.useEffect)(()=>{
        if ((0, $iqfTZ.fg)('enable_teams_t26_design_drop_core_experiences')) return;
        setHasImageErrored(false);
    }, [
        avatarSrc
    ]);
    if ((!avatarSrc || hasImageErrored) && !(0, $iqfTZ.fg)('enable_teams_t26_design_drop_core_experiences')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hSqqn.FallbackAvatar), {
        "aria-label": alt,
        width: $2c3a3e41a4ebfd5a$var$SIZES[size],
        height: $2c3a3e41a4ebfd5a$var$SIZES[size],
        "data-testid": testId,
        compact: compact
    });
    if ((0, $iqfTZ.fg)('enable_teams_t26_design_drop_core_experiences')) {
        const resolvedSrc = hasImageErrored ? (0, $iA44E.TEAM_FALLBACK_AVATAR_DATA_URI) : avatarSrc;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
            as: "img",
            src: resolvedSrc,
            alt: alt,
            testId: testId && `${testId}--image`,
            xcss: $2c3a3e41a4ebfd5a$var$avatarImageStyles.image,
            onError: ()=>setHasImageErrored(true)
        });
    }
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $4jQY2.default)([
            $2c3a3e41a4ebfd5a$var$unboundStyles.root,
            $2c3a3e41a4ebfd5a$var$containerStyles.root,
            $2c3a3e41a4ebfd5a$var$borderRadiusMap[size],
            $2c3a3e41a4ebfd5a$var$widthHeightMap[size],
            compact ? $2c3a3e41a4ebfd5a$var$containerStyles.compactSpacing : $2c3a3e41a4ebfd5a$var$containerStyles.nonCompactSpacing
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("img", {
            src: avatarSrc,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $4jQY2.default)([
                $2c3a3e41a4ebfd5a$var$avatarImageStyles.image
            ])
        })
    });
};
$2c3a3e41a4ebfd5a$export$ac3673635a5387be.displayName = "TeamAvatarImage";

});
parcelRegister("hSqqn", function(module, exports) {
$parcel$export(module.exports, "FallbackAvatar", () => $e9b25250749009a0$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $ihEDU = parcelRequire("ihEDU");
const $e9b25250749009a0$var$styles = {
    wrapper: "_1reo15vq _18m915vq _2rkol0p1 _1e0c1txw",
    wrapperSpacing: "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
    compactWrapperSpacing: "_19pkze3t _2hwxze3t _otyrze3t _18u0ze3t"
};
function $e9b25250749009a0$export$eb63dcc490f6bbcd({ compact: compact, ...props }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: (0, $1MNmN.cx)($e9b25250749009a0$var$styles.wrapper, compact ? $e9b25250749009a0$var$styles.compactWrapperSpacing : $e9b25250749009a0$var$styles.wrapperSpacing),
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}
$e9b25250749009a0$export$eb63dcc490f6bbcd.displayName = "FallbackAvatar";

});

parcelRegister("iA44E", function(module, exports) {
$parcel$export(module.exports, "TEAM_FALLBACK_AVATAR_DATA_URI", () => $1b938e0d1dd4c6e7$export$215bd25cfab1a96);
const $1b938e0d1dd4c6e7$export$215bd25cfab1a96 = `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2032_552)">
<rect width="32" height="32" rx="4" fill="#DCDFE4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z" fill="#44546F"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z" fill="#44546F"/>
<path d="M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z" fill="#44546F"/>
<path d="M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z" fill="#44546F"/>
</g>
<defs>
<clipPath id="clip0_2032_552">
<rect width="32" height="32" rx="4" fill="white"/>
</clipPath>
</defs>
</svg>`)}`;

});

parcelRegister("gBiFv", function(module, exports) {
$parcel$export(module.exports, "getTeamAvatarSrc", () => $e35d6333adf9003b$export$59ff7d19feb890b6);

var $iqfTZ = parcelRequire("iqfTZ");

var $iA44E = parcelRequire("iA44E");
function $e35d6333adf9003b$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return `/gateway/api/v4/teams/${teamId}/avatar`;
    return (0, $iqfTZ.fg)('enable_teams_t26_design_drop_core_experiences') ? (0, $iA44E.TEAM_FALLBACK_AVATAR_DATA_URI) : undefined;
}

});



parcelRegister("lCzPN", function(module, exports) {
$parcel$export(module.exports, "AddOptionAvatar", () => $bf3a282f23ab4f94$export$df396db45e491922);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $2EZ2h = parcelRequire("2EZ2h");

var $hStPE = parcelRequire("hStPE");
parcelRequire("euxye");
const $bf3a282f23ab4f94$var$getEmailAvatarWrapperStyle = (isLozenge, isPendingAction)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    const backgroundColor = isPendingAction ? "var(--ds-background-warning, #FFF5DB)" : "var(--ds-background-neutral, #0515240F)";
    return /*#__PURE__*/ (0, $hStPE.css)({
        padding: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding,
        backgroundColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor,
        borderRadius: "var(--ds-radius-full, 9999px)",
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $bf3a282f23ab4f94$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label, isPendingAction: isPendingAction })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: $bf3a282f23ab4f94$var$getEmailAvatarWrapperStyle(isLozenge, isPendingAction)
    }, /*#__PURE__*/ (0, $hStPE.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2EZ2h))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        color: isPendingAction ? "var(--ds-text-warning, #9E4C00)" : "var(--ds-text-subtle, #505258)"
    })));
};
$bf3a282f23ab4f94$export$df396db45e491922.displayName = "AddOptionAvatar";

});

parcelRegister("7EDVG", function(module, exports) {
$parcel$export(module.exports, "AvatarOrIcon", () => $648611e4e8ad5a31$export$60751fd23180a0ed);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5Ps6w = parcelRequire("5Ps6w");

var $1KHUB = parcelRequire("1KHUB");

var $hStPE = parcelRequire("hStPE");
function $648611e4e8ad5a31$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $648611e4e8ad5a31$var$iconStyle = {
    name: "sjfyf",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0"
};
const $648611e4e8ad5a31$var$iconSizes = {
    xxsmall: {
        name: "1aynuae",
        styles: "width:20px;height:20px"
    },
    xsmall: {
        name: "1aynuae",
        styles: "width:20px;height:20px"
    },
    small: {
        name: "1c76jn8",
        styles: "width:28px;height:28px"
    },
    medium: {
        name: "bgbjt4",
        styles: "width:36px;height:36px"
    }
};
const $648611e4e8ad5a31$export$60751fd23180a0ed = ({ appearance: appearance = 'big', avatarAppearanceShape: avatarAppearanceShape, icon: icon, iconColor: iconColor, presence: presence, src: src, type: type = 'person' })=>{
    // If icon is provided, render it instead of avatar
    if (icon) {
        const avatarSize = (0, $1KHUB.getAvatarSize)(appearance);
        return /*#__PURE__*/ (0, $hStPE.jsx)("div", {
            css: [
                $648611e4e8ad5a31$var$iconStyle,
                $648611e4e8ad5a31$var$iconSizes[avatarSize]
            ],
            style: {
                color: iconColor
            }
        }, icon);
    }
    // Otherwise, render the avatar as before
    return /*#__PURE__*/ (0, $hStPE.jsx)((0, $5Ps6w.SizeableAvatar), {
        appearance: appearance,
        src: src,
        presence: presence,
        type: type,
        avatarAppearanceShape: avatarAppearanceShape
    });
};
$648611e4e8ad5a31$export$60751fd23180a0ed.displayName = "AvatarOrIcon";

});
parcelRegister("5Ps6w", function(module, exports) {
$parcel$export(module.exports, "SizeableAvatar", () => $3db666b6261127a4$export$44d81a88129649da);

var $e79Pd = parcelRequire("e79Pd");

var $8z2GW = parcelRequire("8z2GW");

var $8dkEA = parcelRequire("8dkEA");

var $euxye = parcelRequire("euxye");

var $1KHUB = parcelRequire("1KHUB");
class $3db666b6261127a4$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person', avatarAppearanceShape: avatarAppearanceShape } = this.props;
        const size = (0, $1KHUB.getAvatarSize)(appearance);
        const props = {
            size: size,
            src: src,
            borderColor: 'transparent',
            presence: presence,
            ...avatarAppearanceShape && {
                appearance: avatarAppearanceShape
            }
        };
        return type === 'team' ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8dkEA.default), {
            ...props
        }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8z2GW.default), {
            ...props
        });
    }
}
$3db666b6261127a4$export$44d81a88129649da.displayName = "SizeableAvatar";

});


parcelRegister("2q0vg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df4fc88f40749d293570c808b4b489c6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c2e6670324ab024$var$_react = $1c2e6670324ab024$var$_interopRequireDefault((parcelRequire("euxye")));

var $1c2e6670324ab024$var$_baseNew = $1c2e6670324ab024$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $1c2e6670324ab024$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/people-group
 * Usage guidance:
 * Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1c2e6670324ab024$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $1c2e6670324ab024$var$_react.default.createElement($1c2e6670324ab024$var$_baseNew.default, Object.assign({
        name: "PeopleGroupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$1c2e6670324ab024$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $1c2e6670324ab024$var$_default = module.exports.default = $1c2e6670324ab024$var$PeopleGroupIcon;

});

parcelRegister("4XWUs", function(module, exports) {
$parcel$export(module.exports, "VerifiedTeamIcon", () => $51efd276a1ff74e9$export$d7949f68d31e5edd);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $j7qEN = parcelRequire("j7qEN");

var $hZDXn = parcelRequire("hZDXn");

var $7x2dO = parcelRequire("7x2dO");
const $51efd276a1ff74e9$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent, size: size = 'medium', spacing: spacing = 'spacious' })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $7x2dO.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($j7qEN))), {
                    color: "var(--ds-icon-accent-blue, #357DE8)",
                    size: size,
                    label: tooltipContent,
                    spacing: spacing
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($j7qEN))), {
        color: "var(--ds-icon-accent-blue, #357DE8)",
        size: size,
        spacing: spacing,
        label: label
    });
};
$51efd276a1ff74e9$export$d7949f68d31e5edd.displayName = "VerifiedTeamIcon";

});
parcelRegister("7x2dO", function(module, exports) {
$parcel$export(module.exports, "messages", () => $cfc27b3d53ec67ea$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $cfc27b3d53ec67ea$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
        defaultMessage: 'This team is verified because it can only be changed by admin.',
        description: 'Tooltip text for the verified team icon'
    }
});

});



parcelRegister("eGL2v", function(module, exports) {
$parcel$export(module.exports, "MultiValueContainer", () => $860310c6eb416bb7$export$cf9cf2a30a59265c);
/* MultiValueContainer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $3xX0E = parcelRequire("3xX0E");

var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $iqfTZ = parcelRequire("iqfTZ");

var $h4CIG = parcelRequire("h4CIG");

var $1KHUB = parcelRequire("1KHUB");

var $3V1Tp = parcelRequire("3V1Tp");

var $9S1b6 = parcelRequire("9S1b6");
const $860310c6eb416bb7$var$valueContainerStyles = {
    root: "_yv0e5bpd _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf",
    paddingLegacy: "_ca0qu2gc _n3tdu2gc _19bvu2gc",
    tagUpliftVerticalDefault: "_ca0qu2gc _n3tdu2gc",
    tagUpliftVerticalCompact: "_ca0qv77o _n3tdv77o",
    paddingLeftTight: "_19bv12x7",
    paddingLeftWide: "_19bvu2gc",
    withFlexAndGap: "_zulp1b66 _yv0en7od _1n261g80"
};
class $860310c6eb416bb7$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    constructor(props){
        super(props), this.timeoutId = null, this.scrollToBottom = ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) current.scrollTop = current.scrollHeight;
                this.timeoutId = null;
            });
        }, this.showPlaceholder = ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        }, this.addPlaceholder = (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Children.map(this.props.children, (child)=>(0, $1KHUB.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {
                children: children
            });
        }, this.renderChildren = ()=>{
            const { selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
            // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                ...(0, $h4CIG.messages).addMore,
                children: (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                }
            });
            return this.addPlaceholder(addMoreMessage);
        }, this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createRef()
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: _children, innerProps: _innerProps, hasValue: hasValue, isCompact: isCompact, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            hasValue: hasValue,
            isCompact: isCompact,
            innerProps: this.valueContainerInnerProps
        };
        const ffTagUplifts = (0, $iqfTZ.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
        const controlRendersValueInControl = this.props.selectProps.controlShouldRenderValue !== false;
        const tagUpliftChipRow = ffTagUplifts && hasValue && controlRendersValueInControl;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3V1Tp.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3xX0E.components).ValueContainer, {
                ...props,
                xcss: (0, $9S1b6.cx)($860310c6eb416bb7$var$valueContainerStyles.root, !ffTagUplifts && $860310c6eb416bb7$var$valueContainerStyles.paddingLegacy, ffTagUplifts && (isCompact ? $860310c6eb416bb7$var$valueContainerStyles.tagUpliftVerticalCompact : $860310c6eb416bb7$var$valueContainerStyles.tagUpliftVerticalDefault), ffTagUplifts && (tagUpliftChipRow ? $860310c6eb416bb7$var$valueContainerStyles.paddingLeftWide : $860310c6eb416bb7$var$valueContainerStyles.paddingLeftTight), tagUpliftChipRow && $860310c6eb416bb7$var$valueContainerStyles.withFlexAndGap),
                children: this.renderChildren()
            })
        });
    }
}
$860310c6eb416bb7$export$cf9cf2a30a59265c.displayName = "MultiValueContainer";

});
parcelRegister("3V1Tp", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed219bcaf0e30e6d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");
function $ed219bcaf0e30e6d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $ed219bcaf0e30e6d$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $ed219bcaf0e30e6d$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlassian/a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: $ed219bcaf0e30e6d$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
$ed219bcaf0e30e6d$var$ValueContainerWrapper.displayName = "ValueContainerWrapper";
var $ed219bcaf0e30e6d$export$2e2bcd8739ae039 = $ed219bcaf0e30e6d$var$ValueContainerWrapper;

});


parcelRegister("9ja1D", function(module, exports) {
$parcel$export(module.exports, "Option", () => $2e2d5bf2bc460880$export$36d18380658d5d20);

var $e79Pd = parcelRequire("e79Pd");

var $ihEDU = parcelRequire("ihEDU");

var $3xX0E = parcelRequire("3xX0E");

var $hZDXn = parcelRequire("hZDXn");

var $euxye = parcelRequire("euxye");

var $fQkJq = parcelRequire("fQkJq");

var $29FNk = parcelRequire("29FNk");

var $ekN99 = parcelRequire("ekN99");

var $iKX16 = parcelRequire("iKX16");

var $2e90V = parcelRequire("2e90V");

var $8T10a = parcelRequire("8T10a");

var $1KHUB = parcelRequire("1KHUB");

var $gp9sb = parcelRequire("gp9sb");
const $2e2d5bf2bc460880$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fQkJq.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $2e2d5bf2bc460880$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $1KHUB.isExternalUser)(data)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $29FNk.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $1KHUB.isUser)(data)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fQkJq.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $1KHUB.isEmail)(data)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2e90V.default), {
        email: data,
        emailValidity: (0, $gp9sb.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $1KHUB.isTeam)(data)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ekN99.default), {
        team: data,
        isSelected: isSelected,
        includeTeamsUpdates: data.includeTeamsUpdates
    });
    if ((0, $1KHUB.isGroup)(data)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iKX16.default), {
        group: data,
        isSelected: isSelected,
        includeTeamsUpdates: data.includeTeamsUpdates
    });
    if ((0, $1KHUB.isCustom)(data)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8T10a.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $2e2d5bf2bc460880$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        content: props.data?.data?.tooltip,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                ...tooltipProps,
                children: $2e2d5bf2bc460880$var$dataOption(props)
            })
    });
    return $2e2d5bf2bc460880$var$dataOption(props);
};
const $2e2d5bf2bc460880$export$36d18380658d5d20 = ({ renderOptionContent: renderOptionContent, ...props })=>{
    const defaultContent = /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Suspense, {
        fallback: $2e2d5bf2bc460880$var$defaultOption(props),
        children: $2e2d5bf2bc460880$var$dataOptionWithTooltip(props)
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3xX0E.components).Option, {
        ...props,
        children: renderOptionContent ? renderOptionContent(defaultContent) : defaultContent
    });
};
$2e2d5bf2bc460880$export$36d18380658d5d20.displayName = "Option";

});
parcelRegister("fQkJq", function(module, exports) {
$parcel$export(module.exports, "UserOption", () => $b877cfcdb846f039$export$8e59f78010871662);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3G4RD = parcelRequire("3G4RD");

var $hStPE = parcelRequire("hStPE");

var $euxye = parcelRequire("euxye");

var $kxUoa = parcelRequire("kxUoa");

var $Ewyor = parcelRequire("Ewyor");

var $7EDVG = parcelRequire("7EDVG");

var $5Ps6w = parcelRequire("5Ps6w");

var $1KHUB = parcelRequire("1KHUB");

var $iqfTZ = parcelRequire("iqfTZ");
class $b877cfcdb846f039$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $hStPE.jsx)((0, $kxUoa.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args), this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $hStPE.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $kxUoa.textWrapper)(this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text, #292A2E)")
                }, /*#__PURE__*/ (0, $hStPE.jsx)((0, $Ewyor.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $1KHUB.hasValue)(publicName) && name.trim() !== publicName.trim()) {
                const color = this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtlest, #6B6E76)";
                result.push(/*#__PURE__*/ (0, $hStPE.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, {
                    key: "publicName"
                }, ' ', /*#__PURE__*/ (0, $hStPE.jsx)("span", {
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $kxUoa.textWrapper)(color)
                }, "(", /*#__PURE__*/ (0, $hStPE.jsx)((0, $Ewyor.HighlightText), {
                    highlights: highlight && highlight.publicName
                }, publicName), ")")));
            }
            return result;
        }, this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $hStPE.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $kxUoa.textWrapper)(this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtlest, #6B6E76)")
            }, this.props.user.byline) : undefined, this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl, appType: appType, icon: icon, iconColor: iconColor }, status: status } = this.props;
            const appearance = (0, $iqfTZ.fg)('platform-component-visual-refresh') ? 'medium' : 'big';
            if (icon) return /*#__PURE__*/ (0, $hStPE.jsx)((0, $7EDVG.AvatarOrIcon), {
                appearance: appearance,
                icon: icon,
                iconColor: iconColor,
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $3G4RD.default)(appType)
            });
            // Fallback to original behavior
            return /*#__PURE__*/ (0, $hStPE.jsx)((0, $5Ps6w.SizeableAvatar), {
                appearance: appearance,
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $3G4RD.default)(appType)
            });
        }, this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}
$b877cfcdb846f039$export$8e59f78010871662.displayName = "UserOption";

});
parcelRegister("3G4RD", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7d920df59948d0c$export$2e2bcd8739ae039);
const $e7d920df59948d0c$var$getAppearanceForAppType = (appType)=>{
    switch(appType){
        case 'agent':
            return 'hexagon';
        case 'user':
        case 'system':
        default:
            return 'circle';
    }
};
var $e7d920df59948d0c$export$2e2bcd8739ae039 = $e7d920df59948d0c$var$getAppearanceForAppType;

});

parcelRegister("kxUoa", function(module, exports) {
$parcel$export(module.exports, "textWrapper", () => $05f7600432ef6772$export$aa6223da92b253dd);
$parcel$export(module.exports, "AvatarItemOption", () => $05f7600432ef6772$export$164a9d9b3b86dd0c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $2EFuW = parcelRequire("2EFuW");

var $d0F9p = parcelRequire("d0F9p");

var $1KHUB = parcelRequire("1KHUB");

var $iqfTZ = parcelRequire("iqfTZ");
function $05f7600432ef6772$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $05f7600432ef6772$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).lazy(()=>(parcelRequire("99vKB")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $05f7600432ef6772$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $hStPE.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $05f7600432ef6772$var$optionWrapper = {
    name: "13552d7",
    styles: "max-width:100%;min-width:0;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $05f7600432ef6772$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    return /*#__PURE__*/ (0, $hStPE.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $05f7600432ef6772$var$additionalInfo = {
    name: "1hvgowa",
    styles: "float:right;margin-left:var(--ds-space-100, 8px)"
};
const $05f7600432ef6772$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $hStPE.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $05f7600432ef6772$var$lozengeAppearanceToTagColor = {
    default: 'standard',
    success: 'lime',
    removed: 'red',
    inprogress: 'blue',
    new: 'purple',
    moved: 'orange'
};
const $05f7600432ef6772$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderTag = ()=>{
        if ((0, $1KHUB.isLozengeText)(lozenge) && !lozenge.isBold) {
            const color = lozenge.appearance ? $05f7600432ef6772$var$lozengeAppearanceToTagColor[lozenge.appearance] : 'standard';
            const tag = /*#__PURE__*/ (0, $hStPE.jsx)((0, $d0F9p.default), {
                text: lozenge.text,
                color: color,
                isRemovable: false,
                migration_fallback: "lozenge"
            });
            if (lozenge.tooltip) return /*#__PURE__*/ (0, $hStPE.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Suspense, {
                fallback: tag
            }, /*#__PURE__*/ (0, $hStPE.jsx)($05f7600432ef6772$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, tag));
            return tag;
        }
        return renderLozenge();
    };
    const renderLozenge = ()=>{
        if ((0, $1KHUB.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $hStPE.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Suspense, {
                fallback: /*#__PURE__*/ (0, $hStPE.jsx)((0, $2EFuW.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $hStPE.jsx)($05f7600432ef6772$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $hStPE.jsx)((0, $2EFuW.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $hStPE.jsx)((0, $2EFuW.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $hStPE.jsx)("span", {
        css: $05f7600432ef6772$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: $05f7600432ef6772$var$optionWrapper
    }, /*#__PURE__*/ (0, $hStPE.jsx)("div", null, /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: $05f7600432ef6772$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: $05f7600432ef6772$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: $05f7600432ef6772$var$additionalInfo
    }, (0, $iqfTZ.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? renderTag() : renderLozenge())));
};
$05f7600432ef6772$export$164a9d9b3b86dd0c.displayName = "AvatarItemOption";

});

parcelRegister("Ewyor", function(module, exports) {
$parcel$export(module.exports, "HighlightText", () => $15016c5be5a4632c$export$bb02e7bc6e1a7119);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
class $15016c5be5a4632c$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, $e79Pd.jsx)("b", {
                children: part.value
            }, index);
            return part.value;
        });
    }
}
$15016c5be5a4632c$export$bb02e7bc6e1a7119.displayName = "HighlightText";

});


parcelRegister("29FNk", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c2238d58f84bda2$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

const $5c2238d58f84bda2$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).lazy(()=>(parcelRequire("bCMoh")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $5c2238d58f84bda2$export$2e2bcd8739ae039 = $5c2238d58f84bda2$var$AsyncExternalUserOption;

});
parcelRegister("bCMoh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("jCi7t")
]).then(()=>parcelRequire('byFpt'));

});


parcelRegister("ekN99", function(module, exports) {
$parcel$export(module.exports, "default", () => $31336292c1e928fb$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

const $31336292c1e928fb$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).lazy(()=>(parcelRequire("g1cmd")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $31336292c1e928fb$export$2e2bcd8739ae039 = $31336292c1e928fb$var$AsyncTeamOption;

});
parcelRegister("g1cmd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("29qLa").then(()=>parcelRequire('8LSoS'));

});


parcelRegister("iKX16", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a0e6283befec2b0$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

const $1a0e6283befec2b0$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).lazy(()=>(parcelRequire("jkhgP")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $1a0e6283befec2b0$export$2e2bcd8739ae039 = $1a0e6283befec2b0$var$AsyncGroupOption;

});
parcelRegister("jkhgP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3we5R").then(()=>parcelRequire('b8BXe'));

});


parcelRegister("2e90V", function(module, exports) {
$parcel$export(module.exports, "default", () => $eed341e18356699a$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

const $eed341e18356699a$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).lazy(()=>(parcelRequire("23AQZ")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $eed341e18356699a$export$2e2bcd8739ae039 = $eed341e18356699a$var$AsyncEmailOption;

});
parcelRegister("23AQZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("awwGu").then(()=>parcelRequire('cC5dB'));

});


parcelRegister("8T10a", function(module, exports) {
$parcel$export(module.exports, "default", () => $a213391a55e0a499$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

const $a213391a55e0a499$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).lazy(()=>(parcelRequire("j85Ro")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $a213391a55e0a499$export$2e2bcd8739ae039 = $a213391a55e0a499$var$AsyncCustomOption;

});
parcelRegister("j85Ro", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8h5go").then(()=>parcelRequire('ayh4t'));

});


parcelRegister("gp9sb", function(module, exports) {
$parcel$export(module.exports, "isValidEmail", () => $72f8571147fb64d0$export$371e338370561054);
const $72f8571147fb64d0$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $72f8571147fb64d0$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $72f8571147fb64d0$export$371e338370561054 = (inputText)=>{
    if (inputText.match($72f8571147fb64d0$var$validRegex)) return 'VALID';
    if (inputText.match($72f8571147fb64d0$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});


parcelRegister("2VUjO", function(module, exports) {
$parcel$export(module.exports, "SingleValue", () => $b6d900fcd449c2c1$export$1949dac661ba6e3a);
/* SingleValue.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $3xX0E = parcelRequire("3xX0E");

var $2EFuW = parcelRequire("2EFuW");

var $7EDVG = parcelRequire("7EDVG");

var $5Ps6w = parcelRequire("5Ps6w");

var $1KHUB = parcelRequire("1KHUB");

var $3G4RD = parcelRequire("3G4RD");

var $4XWUs = parcelRequire("4XWUs");

var $55qdj = parcelRequire("55qdj");

var $ihEDU = parcelRequire("ihEDU");
var $2XXtG = parcelRequire("2XXtG");
var $defJG = parcelRequire("defJG");

var $h4CIG = parcelRequire("h4CIG");
const $b6d900fcd449c2c1$var$styles = {
    avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
    avatarItemText: "_syazi7uo _1reo15vq _1bto1l2s _o5721q9c",
    archivedLozengeWrapper: "_1e0c1txw _19bv1b66"
};
const $b6d900fcd449c2c1$var$ElementAfter = (props)=>{
    const { data: { data: data }, shouldShowVerifiedIcon: shouldShowVerifiedIcon } = props;
    const showIcon = shouldShowVerifiedIcon ? shouldShowVerifiedIcon(data) : (0, $1KHUB.isTeam)(data) && data.verified || (0, $1KHUB.isGroup)(data) && data.includeTeamsUpdates;
    if (showIcon) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4XWUs.VerifiedTeamIcon), {
        size: data.includeTeamsUpdates ? 'small' : 'medium'
    });
    return null;
};
$b6d900fcd449c2c1$var$ElementAfter.displayName = "ElementAfter";
const $b6d900fcd449c2c1$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    const canShowArchivedLozenge = (0, $1KHUB.isTeam)(data) && data?.state === 'DISBANDED';
    return !isFocused ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3xX0E.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2XXtG.Flex), {
            xcss: $b6d900fcd449c2c1$var$styles.avatarItem,
            children: [
                data.icon ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7EDVG.AvatarOrIcon), {
                    icon: data.icon,
                    iconColor: data.iconColor,
                    src: (0, $1KHUB.getAvatarUrl)(data),
                    appearance: appearance,
                    type: (0, $1KHUB.isTeam)(data) ? 'team' : 'person',
                    avatarAppearanceShape: (0, $3G4RD.default)(data.appType)
                }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5Ps6w.SizeableAvatar), {
                    src: (0, $1KHUB.getAvatarUrl)(data),
                    appearance: appearance,
                    type: (0, $1KHUB.isTeam)(data) ? 'team' : 'person',
                    avatarAppearanceShape: (0, $3G4RD.default)(data.appType)
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                    xcss: $b6d900fcd449c2c1$var$styles.avatarItem,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        className: (0, $4jQY2.default)([
                            $b6d900fcd449c2c1$var$styles.avatarItemTextWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                            xcss: $b6d900fcd449c2c1$var$styles.avatarItemText,
                            children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.Inline), {
                                alignBlock: "center",
                                children: [
                                    label,
                                    /*#__PURE__*/ (0, $e79Pd.jsx)($b6d900fcd449c2c1$var$ElementAfter, {
                                        ...props
                                    }),
                                    canShowArchivedLozenge ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                                        xcss: $b6d900fcd449c2c1$var$styles.archivedLozengeWrapper,
                                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2EFuW.default), {
                                            appearance: "neutral",
                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                ...(0, $h4CIG.messages).archivedLozenge
                                            })
                                        })
                                    }) : null
                                ]
                            })
                        })
                    })
                })
            ]
        })
    }) : null;
};
$b6d900fcd449c2c1$export$1949dac661ba6e3a.displayName = "SingleValue";

});

parcelRegister("dTNIY", function(module, exports) {
$parcel$export(module.exports, "Input", () => $4da55e9cefceaa16$export$f5b8910cec6cf069);
/* Input.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $3xX0E = parcelRequire("3xX0E");
const $4da55e9cefceaa16$var$inputStyles = {
    root: "_5ce61rpy _1ir3kb7n _h5gq1rpy"
};
class $4da55e9cefceaa16$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    /**
   * Overrides the default behaviour of react-select lib
   *
   * The getter is a workaround for original behaviour of the react-select lib.
   * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
   * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
   * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
   *
   * This reassignment should only apply when the input has no other accessible name.
   */ get ariaLabelledBy() {
        // A11Y-37267: An explicit aria-labelledby is a deliberate association with a visible label
        // element and is the field's true accessible name (WCAG 2.5.3 Label in Name), so it always
        // wins. Otherwise we promote aria-describedby -> aria-labelledby to work around
        // react-select's placeholder linkage bug, but skip that promotion when the input already
        // has an accessible name via aria-label so the description is announced via
        // aria-describedby instead.
        if (this.props['aria-labelledby']) return this.props['aria-labelledby'];
        if (this.props['aria-label']) return undefined;
        return this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3xX0E.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress,
            xcss: $4da55e9cefceaa16$var$inputStyles.root
        });
    }
    constructor(...args){
        super(...args), // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        this.handleKeyPress = (e)=>{
            if (e.key === 'Enter') e.preventDefault();
            if (this.props.selectProps?.disableInput) e.preventDefault();
        };
    }
}
$4da55e9cefceaa16$export$f5b8910cec6cf069.displayName = "Input";

});

parcelRegister("120UA", function(module, exports) {
$parcel$export(module.exports, "SingleValueContainer", () => $1c4ae693f4571d2a$export$afa5f855316c6a48);
/* SingleValueContainer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $3xX0E = parcelRequire("3xX0E");

var $7EDVG = parcelRequire("7EDVG");

var $5Ps6w = parcelRequire("5Ps6w");

var $3V1Tp = parcelRequire("3V1Tp");

var $3G4RD = parcelRequire("3G4RD");
const $1c4ae693f4571d2a$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bvze3t _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf"
};
const $1c4ae693f4571d2a$var$placeholderIconContainer = null;
const $1c4ae693f4571d2a$var$wrapperStyle = null;
const $1c4ae693f4571d2a$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
class $1c4ae693f4571d2a$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3V1Tp.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3xX0E.components).ValueContainer, {
                ...valueContainerProps,
                xcss: $1c4ae693f4571d2a$var$valueContainerStyles.root,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        className: (0, $4jQY2.default)([
                            "_nd5l1kqh _19bv12x7 _vwz4idpf"
                        ]),
                        children: this.renderAvatar()
                    }),
                    children
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.renderAvatar = ()=>{
            const { hasValue: hasValue, selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) {
                const userData = $1c4ae693f4571d2a$var$showUserAvatar(inputValue, value) ? value.data : undefined;
                if (userData?.icon) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7EDVG.AvatarOrIcon), {
                    appearance: appearance,
                    icon: userData.icon,
                    iconColor: userData.iconColor,
                    type: placeholderAvatar,
                    src: userData.avatarUrl,
                    avatarAppearanceShape: userData ? (0, $3G4RD.default)(userData.appType) : undefined
                });
                // Fallback to original behavior
                return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5Ps6w.SizeableAvatar), {
                    appearance: appearance,
                    type: placeholderAvatar,
                    src: userData?.avatarUrl,
                    avatarAppearanceShape: userData ? (0, $3G4RD.default)(userData.appType) : undefined
                });
            }
            return null;
        }, this.onValueContainerClick = this.props.selectProps.onValueContainerClick, this.Wrapper = ({ children: children })=>{
            return this.onValueContainerClick ? /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                onMouseDown: this.onValueContainerClick,
                className: (0, $4jQY2.default)([
                    "_16jlkb7n"
                ]),
                children: children
            }) : children;
        };
    }
}
$1c4ae693f4571d2a$export$afa5f855316c6a48.displayName = "SingleValueContainer";

});

parcelRegister("hf0xy", function(module, exports) {
$parcel$export(module.exports, "PopupInput", () => $f878de9d42acebbe$export$d8edbfd510a7db82);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $dTNIY = parcelRequire("dTNIY");
class $f878de9d42acebbe$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dTNIY.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args), this.ref = null, this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}
$f878de9d42acebbe$export$d8edbfd510a7db82.displayName = "PopupInput";

});

parcelRegister("dghO7", function(module, exports) {
$parcel$export(module.exports, "PopupControl", () => $208aae0520589bfe$export$a0cb1b4352357fcc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $cWBH9 = parcelRequire("cWBH9");
function $208aae0520589bfe$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $208aae0520589bfe$var$controlWrapper = /*#__PURE__*/ (0, $hStPE.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $208aae0520589bfe$var$labelStyle = {
    name: "14uum76",
    styles: "color:var(--ds-text-subtlest, #6B6E76);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);padding-bottom:var(--ds-space-050, 4px);padding-left:var(--ds-space-0, 0px);padding-right:var(--ds-space-0, 0px);padding-top:var(--ds-space-250, 20px)"
};
class $208aae0520589bfe$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).PureComponent {
    render() {
        const { selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $hStPE.jsx)("div", {
            css: $208aae0520589bfe$var$controlWrapper
        }, /*#__PURE__*/ (0, $hStPE.jsx)("div", {
            css: $208aae0520589bfe$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $hStPE.jsx)((0, $cWBH9.default), this.props));
    }
}
$208aae0520589bfe$export$a0cb1b4352357fcc.displayName = "PopupControl";

});
parcelRegister("cWBH9", function(module, exports) {
$parcel$export(module.exports, "default", () => $40cc9c7128d0e94a$export$2e2bcd8739ae039);
/* Control.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $3xX0E = parcelRequire("3xX0E");

var $9S1b6 = parcelRequire("9S1b6");
const $40cc9c7128d0e94a$var$controlStyles = {
    invalid: "_1h6d1bqt _4cvx1bqt",
    focused: "_1h6d1v1w _bfhk1j9a _4cvx1v1w _irr31j9a",
    disabled: "_irr3187o",
    subtle: "_1h6d3acm _bfhk18uv _4cvx3acm _irr31gly",
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1h6drsbi _bfhk1j9a _p12f1osq _14regrf3 _4cvxrsbi _irr3l4ek _1a98zg3v",
    compact: "_1tke1wug"
};
const $40cc9c7128d0e94a$var$Control = (props)=>{
    const isCompact = props.appearance === 'compact';
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3xX0E.components).Control, {
        ...props,
        xcss: (0, $9S1b6.cx)($40cc9c7128d0e94a$var$controlStyles.root, isCompact && $40cc9c7128d0e94a$var$controlStyles.compact, (props.selectProps.subtle || props.selectProps.noBorder) && $40cc9c7128d0e94a$var$controlStyles.subtle, props.isFocused && $40cc9c7128d0e94a$var$controlStyles.focused, props.isInvalid && $40cc9c7128d0e94a$var$controlStyles.invalid, props.isDisabled && $40cc9c7128d0e94a$var$controlStyles.disabled)
    });
};
$40cc9c7128d0e94a$var$Control.displayName = "Control";
var $40cc9c7128d0e94a$export$2e2bcd8739ae039 = $40cc9c7128d0e94a$var$Control;

});


parcelRegister("kykcP", function(module, exports) {
$parcel$export(module.exports, "Menu", () => $5ff4e9eab0607be1$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $3xX0E = parcelRequire("3xX0E");

var $hStPE = parcelRequire("hStPE");
const $5ff4e9eab0607be1$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $hStPE.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $5ff4e9eab0607be1$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    render() {
        return /*#__PURE__*/ (0, $hStPE.jsx)((0, $3xX0E.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $hStPE.jsx)("div", {
            css: $5ff4e9eab0607be1$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}
$5ff4e9eab0607be1$export$d9b273488cd8ce6f.displayName = "Menu";

});


parcelRegister("eYbgp", function(module, exports) {
$parcel$export(module.exports, "getCreatableProps", () => $a0be66c970ac026a$export$36f97d8afa97203d);

var $emCaV = parcelRequire("emCaV");


var $gp9sb = parcelRequire("gp9sb");

var $1KHUB = parcelRequire("1KHUB");
const $a0be66c970ac026a$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $a0be66c970ac026a$var$isValidNewOption = (isValidEmail = (0, $gp9sb.isValidEmail))=>(inputValue)=>inputValue && $a0be66c970ac026a$var$validOption.includes(isValidEmail(inputValue));
const $a0be66c970ac026a$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $46a69102f5d06a1b$export$6662b3461398ef8c)
        }
    });
const $a0be66c970ac026a$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $a0be66c970ac026a$var$isOptionDisabled = (isValidEmail = (0, $gp9sb.isValidEmail))=>(option)=>{
        if ((0, $1KHUB.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $a0be66c970ac026a$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $a0be66c970ac026a$var$isValidNewOption(isValidEmail),
        getNewOptionData: $a0be66c970ac026a$var$getNewOptionData,
        formatCreateLabel: $a0be66c970ac026a$var$formatCreateLabel,
        isOptionDisabled: $a0be66c970ac026a$var$isOptionDisabled(isValidEmail)
    };
}
const $a0be66c970ac026a$export$36f97d8afa97203d = (0, $emCaV.default)($a0be66c970ac026a$var$creatableProps);

});

parcelRegister("gCEkc", function(module, exports) {
$parcel$export(module.exports, "getCreatableSuggestedEmailProps", () => $a457951645af0130$export$34b9dd2dd6a225e5);

var $emCaV = parcelRequire("emCaV");


var $gp9sb = parcelRequire("gp9sb");

var $1KHUB = parcelRequire("1KHUB");
const $a457951645af0130$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $a457951645af0130$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $a457951645af0130$var$getNewOptionData = (isValidEmail = (0, $gp9sb.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $a457951645af0130$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $46a69102f5d06a1b$export$6662b3461398ef8c),
                suggestion: true
            }
        };
    };
const $a457951645af0130$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $a457951645af0130$var$isOptionDisabled = (isValidEmail = (0, $gp9sb.isValidEmail))=>(option)=>{
        if ((0, $1KHUB.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $a457951645af0130$export$34b9dd2dd6a225e5 = (0, $emCaV.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $a457951645af0130$var$isValidNewOption,
        getNewOptionData: $a457951645af0130$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $a457951645af0130$var$formatCreateLabel,
        isOptionDisabled: $a457951645af0130$var$isOptionDisabled(isValidEmail)
    }));

});

parcelRegister("330y8", function(module, exports) {
$parcel$export(module.exports, "default", () => $9861ab3df405790f$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $5KKyn = parcelRequire("5KKyn");
var $1YIbA = parcelRequire("1YIbA");

var $1w1Zi = parcelRequire("1w1Zi");
const $9861ab3df405790f$var$EMPTY = {};
const $9861ab3df405790f$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useState($9861ab3df405790f$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useEffect(()=>{
        let aborted = false;
        setMessages($9861ab3df405790f$var$EMPTY);
        (0, $1w1Zi.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $9861ab3df405790f$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $1YIbA.default)();
    const { children: children } = props;
    const messages = $9861ab3df405790f$var$useI18n(intl.locale);
    const mergedMessages = (0, $euxye.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5KKyn.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
$9861ab3df405790f$var$MessagesIntlProvider.displayName = "MessagesIntlProvider";
var $9861ab3df405790f$export$2e2bcd8739ae039 = $9861ab3df405790f$var$MessagesIntlProvider;

});
parcelRegister("1w1Zi", function(module, exports) {
$parcel$export(module.exports, "getMessagesForLocale", () => $4cf62fdd72c0feff$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $4cf62fdd72c0feff$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("8gbpA")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("4MGqZ")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("glof8")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("ii1Al")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("b1KOE")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("hLaRX")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("lzi6I")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("9w7QA")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("gehl7")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("55iPt")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("lCDS6")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("dnmBp")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("3B6hl")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("c4iyQ")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("hvqUL")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("fBMCi")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("dvuTa")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("bvl3Z")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("cZHg2")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("WFYTj")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("HLxzs")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("ED9m9")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("2Hv4y")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("iBraL")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("7wJpU")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("1EqD7")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("6EYPP")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("gF6o9")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("kfoVQ")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("jS2XA")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $4cf62fdd72c0feff$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("ii1Al")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("8gbpA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("abJ6C").then(()=>parcelRequire('fs3lW'));

});

parcelRegister("4MGqZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bpqAd").then(()=>parcelRequire('fhlke'));

});

parcelRegister("glof8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dZxQg").then(()=>parcelRequire('77MHR'));

});

parcelRegister("ii1Al", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3YQsy").then(()=>parcelRequire('7eR1o'));

});

parcelRegister("b1KOE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8tSiz").then(()=>parcelRequire('4ocGv'));

});

parcelRegister("hLaRX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("f6KzJ").then(()=>parcelRequire('8rgmL'));

});

parcelRegister("lzi6I", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("38mH6").then(()=>parcelRequire('cTMeS'));

});

parcelRegister("9w7QA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iXaZH").then(()=>parcelRequire('23IK4'));

});

parcelRegister("gehl7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l24jD").then(()=>parcelRequire('VLSqF'));

});

parcelRegister("55iPt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("32zZs").then(()=>parcelRequire('gvzO9'));

});

parcelRegister("lCDS6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l8GC2").then(()=>parcelRequire('aCLx5'));

});

parcelRegister("dnmBp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hBw00").then(()=>parcelRequire('cK0Jn'));

});

parcelRegister("3B6hl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("PddHK").then(()=>parcelRequire('b1gW8'));

});

parcelRegister("c4iyQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("isKjm").then(()=>parcelRequire('9lAla'));

});

parcelRegister("hvqUL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6tRlK").then(()=>parcelRequire('80ZYe'));

});

parcelRegister("fBMCi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5Zha6").then(()=>parcelRequire('6XuBR'));

});

parcelRegister("dvuTa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9gCgw").then(()=>parcelRequire('fNde0'));

});

parcelRegister("bvl3Z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hsOHV").then(()=>parcelRequire('2rsBx'));

});

parcelRegister("cZHg2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8hAyJ").then(()=>parcelRequire('9Cnyj'));

});

parcelRegister("WFYTj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9Neah").then(()=>parcelRequire('iSplX'));

});

parcelRegister("HLxzs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5LkAw").then(()=>parcelRequire('ayAdr'));

});

parcelRegister("ED9m9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7Itg8").then(()=>parcelRequire('4e5vj'));

});

parcelRegister("2Hv4y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9OVaI").then(()=>parcelRequire('cdNz2'));

});

parcelRegister("iBraL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iau3M").then(()=>parcelRequire('k8NTv'));

});

parcelRegister("7wJpU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a3DS4").then(()=>parcelRequire('1ptJ4'));

});

parcelRegister("1EqD7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2MvZf").then(()=>parcelRequire('3rJMN'));

});

parcelRegister("6EYPP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("heiKt").then(()=>parcelRequire('dTCzc'));

});

parcelRegister("gF6o9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c7VJd").then(()=>parcelRequire('gIiox'));

});

parcelRegister("kfoVQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cNGmO").then(()=>parcelRequire('kqj27'));

});

parcelRegister("jS2XA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kQUGZ").then(()=>parcelRequire('35XQ9'));

});



parcelRegister("cBTht", function(module, exports) {
$parcel$export(module.exports, "ExusUserSourceProvider", () => $a0363ce6ed9ff809$export$bcd5c65b586ee3c3);
$parcel$export(module.exports, "useUserSource", () => $a0363ce6ed9ff809$export$c6c0c1a2bac363f);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $a0363ce6ed9ff809$var$ExusUserSourceContext = /*#__PURE__*/ (0, $euxye.createContext)({});
const $a0363ce6ed9ff809$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)($a0363ce6ed9ff809$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        },
        children: children
    });
$a0363ce6ed9ff809$export$bcd5c65b586ee3c3.displayName = "ExusUserSourceProvider";
const $a0363ce6ed9ff809$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $euxye.useContext)($a0363ce6ed9ff809$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $euxye.useState)([]);
    const [loading, setLoading] = (0, $euxye.useState)(true);
    const [error, setError] = (0, $euxye.useState)(null);
    const abortController = (0, $euxye.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $euxye.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $euxye.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};

});


parcelRegister("korPW", function(module, exports) {
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $4eb572927062b963$export$53eef0dcd9611650);
$parcel$export(module.exports, "preparedUsersLoadedEvent", () => $4eb572927062b963$export$185f4c3d9b7ef9bf);
$parcel$export(module.exports, "mountedWithPrefetchEvent", () => $4eb572927062b963$export$9cfb4251e50d7b91);
$parcel$export(module.exports, "filterUsersEvent", () => $4eb572927062b963$export$fbba77127d7cb173);
$parcel$export(module.exports, "requestUsersEvent", () => $4eb572927062b963$export$1762ed8845ff2d9b);
$parcel$export(module.exports, "successfulRequestUsersEvent", () => $4eb572927062b963$export$bfc020018aa738d0);
$parcel$export(module.exports, "failedRequestUsersEvent", () => $4eb572927062b963$export$738aca68b593db8e);
$parcel$export(module.exports, "failedUserResolversEvent", () => $4eb572927062b963$export$b9358131e14a4b0b);
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $flpE4 = parcelRequire("flpE4");

var $7TA2J = parcelRequire("7TA2J");
const $4eb572927062b963$var$packageName = "platform-pkg";
const $4eb572927062b963$var$packageVersion = "0.0.0-use.local";
const $4eb572927062b963$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $7TA2J.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $4eb572927062b963$export$53eef0dcd9611650 = (0, $flpE4.default)('fabric-elements');
const $4eb572927062b963$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $4eb572927062b963$var$packageName,
            packageVersion: $4eb572927062b963$var$packageVersion,
            ...attributes
        }
    });
const $4eb572927062b963$var$createDefaultSmartPickerAttributes = (props, state)=>{
    const { fieldId: fieldId, objectId: objectId, containerId: containerId, childObjectId: childObjectId, prefetch: prefetch, maxOptions: maxOptions, includeTeams: includeTeams, productKey: productKey, principalId: principalId, siteId: siteId, orgId: orgId, filterOptions: filterOptions } = props;
    const { sessionId: sessionId, query: query } = state;
    const maxNumberOfResults = maxOptions || 100;
    return {
        context: fieldId,
        childObjectId: childObjectId,
        containerId: containerId,
        hasFilterOptions: Boolean(filterOptions),
        includeTeams: includeTeams,
        maxNumberOfResults: maxNumberOfResults,
        objectId: objectId,
        prefetch: prefetch,
        principalId: principalId,
        productKey: productKey,
        queryLength: (query || '').length,
        siteId: siteId,
        orgId: orgId,
        sessionId: sessionId
    };
};
const $4eb572927062b963$var$createSmartUserPickerEvent = (action, actionSubect, attributes = {})=>({
        source: 'smart-user-picker',
        ...$4eb572927062b963$var$createEvent('operational', action, actionSubect, attributes)
    });
const $4eb572927062b963$export$185f4c3d9b7ef9bf = (props, state, attributes = {})=>$4eb572927062b963$var$createSmartUserPickerEvent('loaded', 'preparedUsers', {
        ...$4eb572927062b963$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $4eb572927062b963$export$9cfb4251e50d7b91 = (props, state, attributes = {})=>$4eb572927062b963$var$createSmartUserPickerEvent('mounted', 'prefetch', {
        ...$4eb572927062b963$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $4eb572927062b963$export$fbba77127d7cb173 = (props, state, attributes = {})=>$4eb572927062b963$var$createSmartUserPickerEvent('filtered', 'users', {
        ...$4eb572927062b963$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $4eb572927062b963$export$1762ed8845ff2d9b = (props, state, attributes = {})=>$4eb572927062b963$var$createSmartUserPickerEvent('requested', 'users', {
        ...$4eb572927062b963$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $4eb572927062b963$export$bfc020018aa738d0 = (props, state, attributes = {})=>$4eb572927062b963$var$createSmartUserPickerEvent('successful', 'usersRequest', {
        ...$4eb572927062b963$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $4eb572927062b963$export$738aca68b593db8e = (props, state, attributes = {})=>$4eb572927062b963$var$createSmartUserPickerEvent('failed', 'usersRequest', {
        ...$4eb572927062b963$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $4eb572927062b963$export$b9358131e14a4b0b = (props, state, attributes = {})=>$4eb572927062b963$var$createSmartUserPickerEvent('failed', 'userResolversRequest', {
        ...$4eb572927062b963$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });

});

parcelRegister("iIpBG", function(module, exports) {
$parcel$export(module.exports, "default", () => $efe1f57a44d1a138$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1jztF = parcelRequire("1jztF");
var $5KKyn = parcelRequire("5KKyn");

var $3FAgz = parcelRequire("3FAgz");
const $efe1f57a44d1a138$var$EMPTY = {};
const $efe1f57a44d1a138$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useState($efe1f57a44d1a138$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useEffect(()=>{
        let aborted = false;
        setMessages($efe1f57a44d1a138$var$EMPTY);
        (0, $3FAgz.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $efe1f57a44d1a138$var$MessagesIntlProvider = (props)=>{
    const { intl: intl, children: children } = props;
    const messages = $efe1f57a44d1a138$var$useI18n(intl.locale);
    const mergedMessages = (0, $euxye.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5KKyn.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
$efe1f57a44d1a138$var$MessagesIntlProvider.displayName = "MessagesIntlProvider";
const $efe1f57a44d1a138$var$_default_1 = (0, $1jztF.default)($efe1f57a44d1a138$var$MessagesIntlProvider);
var $efe1f57a44d1a138$export$2e2bcd8739ae039 = $efe1f57a44d1a138$var$_default_1;

});
parcelRegister("3FAgz", function(module, exports) {
$parcel$export(module.exports, "getMessagesForLocale", () => $e06c00be79275473$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $e06c00be79275473$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("lnLgy")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("CH0DH")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("ekieD")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("cL5j2")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("a1FHS")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("dgmel")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("d0HqU")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("sBBLK")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("opWZN")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("gjFWp")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("d5RTo")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("6BmGY")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("dznWQ")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("aR7NW")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("jTUEC")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("1Fkbo")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("jShcP")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("8HTSK")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("33Coz")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("4WiSl")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("9hOyY")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("erAyM")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("eo9kF")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("74fVv")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("7yukP")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("3ACaR")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("cWVTS")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("f7Eua")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("1YauF")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $e06c00be79275473$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("cL5j2")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("lnLgy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("K8rdi").then(()=>parcelRequire('620Wd'));

});

parcelRegister("CH0DH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4dbUe").then(()=>parcelRequire('dWJbj'));

});

parcelRegister("ekieD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8ysmc").then(()=>parcelRequire('j5TIY'));

});

parcelRegister("cL5j2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aVoqz").then(()=>parcelRequire('dbLcc'));

});

parcelRegister("a1FHS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9YkAm").then(()=>parcelRequire('bQSUU'));

});

parcelRegister("dgmel", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gnZzd").then(()=>parcelRequire('711L3'));

});

parcelRegister("d0HqU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5yT1z").then(()=>parcelRequire('5wbyo'));

});

parcelRegister("sBBLK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eFQsa").then(()=>parcelRequire('BNJMm'));

});

parcelRegister("opWZN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lDpHx").then(()=>parcelRequire('6iJDH'));

});

parcelRegister("gjFWp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5zfs4").then(()=>parcelRequire('h7Yk8'));

});

parcelRegister("d5RTo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2eehu").then(()=>parcelRequire('e15yf'));

});

parcelRegister("6BmGY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dDK5P").then(()=>parcelRequire('hD3m5'));

});

parcelRegister("dznWQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4pxr1").then(()=>parcelRequire('8H6dn'));

});

parcelRegister("aR7NW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jpaTK").then(()=>parcelRequire('bIwsp'));

});

parcelRegister("jTUEC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1RWAp").then(()=>parcelRequire('jtY2R'));

});

parcelRegister("1Fkbo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aQFaB").then(()=>parcelRequire('Nkbje'));

});

parcelRegister("jShcP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lDC84").then(()=>parcelRequire('81eXZ'));

});

parcelRegister("8HTSK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bllKe").then(()=>parcelRequire('ki9R2'));

});

parcelRegister("33Coz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hBTBn").then(()=>parcelRequire('joBZg'));

});

parcelRegister("4WiSl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1G6mi").then(()=>parcelRequire('69n16'));

});

parcelRegister("9hOyY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("euqUt").then(()=>parcelRequire('lwhg8'));

});

parcelRegister("erAyM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6vC6Z").then(()=>parcelRequire('fkTHA'));

});

parcelRegister("eo9kF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aAwep").then(()=>parcelRequire('8XrYk'));

});

parcelRegister("74fVv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i2h9O").then(()=>parcelRequire('hlDzi'));

});

parcelRegister("7yukP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4XaHr").then(()=>parcelRequire('1dUZA'));

});

parcelRegister("3ACaR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gkXLy").then(()=>parcelRequire('kzp4z'));

});

parcelRegister("cWVTS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jJGrV").then(()=>parcelRequire('4QxZ9'));

});

parcelRegister("f7Eua", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d5Lym").then(()=>parcelRequire('2xUeY'));

});

parcelRegister("1YauF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c0lp1").then(()=>parcelRequire('2oX3R'));

});



parcelRegister("hOUPX", function(module, exports) {
$parcel$export(module.exports, "EntityType", () => $be6a272faad4c609$export$8eda7e02f8f033b2);
$parcel$export(module.exports, "UserEntityType", () => $be6a272faad4c609$export$ef0ef29634e52a6b);
var $be6a272faad4c609$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});
var $be6a272faad4c609$export$ef0ef29634e52a6b = /*#__PURE__*/ function(UserEntityType) {
    UserEntityType["DEFAULT"] = "DEFAULT";
    UserEntityType["APP"] = "APP";
    UserEntityType["CUSTOMER"] = "CUSTOMER";
    UserEntityType["SYSTEM"] = "SYSTEM";
    return UserEntityType;
}({});

});

parcelRegister("hJiIs", function(module, exports) {
$parcel$export(module.exports, "default", () => $49722451b9131273$export$2e2bcd8739ae039);

var $gMYxQ = parcelRequire("gMYxQ");

var $ikYS3 = parcelRequire("ikYS3");
const $49722451b9131273$var$getUserRecommendations = (request, intl)=>{
    const url = (0, $ikYS3.config).getRecommendationServiceUrl(request.baseUrl || '');
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            includeNonLicensedUsers: request.includeNonLicensedUsers,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                ...request.verifiedTeams === true && {
                    isVerifiedTeamFilter: true
                },
                ...request.isTeamSyncedToGroupDirectoryFilter === true && {
                    isTeamSyncedToGroupDirectoryFilter: true
                },
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                ...request.context?.productAttributes?.isEntitledConfluenceExternalCollaborator && {
                    productAccessPermissionIds: [
                        'write',
                        'external-collaborator-write'
                    ]
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: request.restrictTo || {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false,
                searchEmail: request.searchEmail
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
            statusCode: response.status
        });
    }).then((response)=>(0, $gMYxQ.transformUsers)(response, intl));
};
var $49722451b9131273$export$2e2bcd8739ae039 = $49722451b9131273$var$getUserRecommendations;

});
parcelRegister("gMYxQ", function(module, exports) {
$parcel$export(module.exports, "transformUsers", () => $e2b5071f44c67423$export$fb8c90bfc4beaa59);


var $j2Hy2 = parcelRequire("j2Hy2");

var $hOUPX = parcelRequire("hOUPX");

var $iqfTZ = parcelRequire("iqfTZ");
const $e2b5071f44c67423$var$getLozenzeProperties = (entity, intl)=>{
    if (entity.attributes?.workspaceMember) return intl.formatMessage((0, $j2Hy2.messages).memberLozengeText);
    if (entity.attributes?.isConfluenceExternalCollaborator) {
        const lozengeTooltipMessage = entity.entityType === (0, $hOUPX.EntityType).GROUP ? (0, $j2Hy2.messages).guestGroupLozengeTooltip : (0, $j2Hy2.messages).guestUserLozengeTooltip;
        return {
            text: intl.formatMessage((0, $j2Hy2.messages).guestLozengeText),
            tooltip: intl.formatMessage(lozengeTooltipMessage),
            appearance: 'default'
        };
    }
    const isJiraGuestUser = (0, $iqfTZ.fg)('user_picker_guest_lozenges') && entity.attributes?.isJiraGuest;
    if (isJiraGuestUser) return intl.formatMessage((0, $j2Hy2.messages).guestLozengeText);
    return undefined;
};
const $e2b5071f44c67423$var$transformUser = (item, intl)=>{
    const type = item.entityType;
    if (type === (0, $hOUPX.EntityType).USER) {
        const user = item;
        const lozenge = $e2b5071f44c67423$var$getLozenzeProperties(user, intl);
        return {
            id: user.id,
            type: user.nonLicensedUser ? (0, $46a69102f5d06a1b$export$50042ec1d2e00e63) : (0, $46a69102f5d06a1b$export$8436e53e45ffe15b),
            userType: user.userType,
            avatarUrl: user.avatarUrl,
            name: user.name,
            email: user.email,
            title: user.title,
            lozenge: lozenge,
            tooltip: user.name,
            isExternal: Boolean(user.nonLicensedUser),
            sources: user.nonLicensedUser ? [
                'other-atlassian'
            ] : undefined,
            appType: user.appType !== undefined ? user.appType : user.attributes?.appType
        };
    }
    if (type === (0, $hOUPX.EntityType).TEAM) {
        const team = item;
        return {
            id: team.id,
            type: (0, $46a69102f5d06a1b$export$26bc40b960693765),
            description: team.description || '',
            name: team.displayName || '',
            memberCount: team.memberCount,
            members: team.members,
            includesYou: team.includesYou,
            avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
            tooltip: team.displayName,
            verified: team.verified,
            teamTypeName: team.type?.name,
            state: team.state
        };
    }
    if (type === (0, $hOUPX.EntityType).GROUP) {
        const group = item;
        const lozenge = $e2b5071f44c67423$var$getLozenzeProperties(group, intl);
        return {
            id: group.id,
            type: (0, $46a69102f5d06a1b$export$d460f747b73abb10),
            name: group.name || '',
            lozenge: lozenge
        };
    }
    return;
};
const $e2b5071f44c67423$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$e2b5071f44c67423$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);

});
parcelRegister("j2Hy2", function(module, exports) {
$parcel$export(module.exports, "messages", () => $39fac9f0c9291893$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $39fac9f0c9291893$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'The text is shown as a label in the user picker dropdown preceding the list of external organizations or directories where the external user account was found (e.g. a guest directory or external workspace).'
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});


parcelRegister("ikYS3", function(module, exports) {
$parcel$export(module.exports, "config", () => $daada62893500163$export$e506a1d27d1eaa20);
const $daada62893500163$export$e506a1d27d1eaa20 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey, baseUrl = '') {
        return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (id, baseUrl, siteId) {
        return baseUrl ? `${baseUrl}/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}` : `/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}`;
    }
};

});


parcelRegister("67xwM", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d9b84db806d1da8$export$2e2bcd8739ae039);


var $ikYS3 = parcelRequire("ikYS3");

var $3Ou0J = parcelRequire("3Ou0J");

var $3Amrk = parcelRequire("3Amrk");

var $gefPa = parcelRequire("gefPa");
const $6d9b84db806d1da8$var$getHydratedUsersFromProducts = (request)=>{
    const url = `${(0, $ikYS3.config).getUsersServiceUrl(request.productKey, request.baseUrl)}`;
    let params = new URLSearchParams();
    request.accountIds.map((id)=>params.append('accountId', id));
    params.append('maxResults', '2000');
    return fetch(`${url}?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling users service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then(request.productKey === 'jira' ? $6d9b84db806d1da8$var$transformJiraUsers : $6d9b84db806d1da8$var$transformConfluenceUsers);
};
const $6d9b84db806d1da8$var$transformJiraUsers = (userResponse)=>userResponse.values.map($6d9b84db806d1da8$var$transformJiraUser).filter((user)=>!!user).map((user)=>user);
const $6d9b84db806d1da8$var$transformJiraUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $46a69102f5d06a1b$export$8436e53e45ffe15b),
        avatarUrl: item.avatarUrls ? item.avatarUrls['16x16'] : '',
        name: item.displayName,
        email: item.emailAddress
    };
};
const $6d9b84db806d1da8$var$transformConfluenceUsers = (userResponse)=>userResponse.results.map($6d9b84db806d1da8$var$transformConfluenceUser).filter((user)=>!!user).map((user)=>user);
const $6d9b84db806d1da8$var$transformConfluenceUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $46a69102f5d06a1b$export$8436e53e45ffe15b),
        avatarUrl: item.profilePicture ? item.profilePicture.path : '',
        name: item.publicName,
        email: item.email
    };
};
const $6d9b84db806d1da8$var$sortResults = (options, sortIds)=>{
    const resultsMap = new Map(options.map((option)=>[
            option && option.id,
            option
        ]));
    return sortIds.map((option)=>{
        const user = resultsMap.get(option.id);
        if (user) return user;
        return {
            id: option.id,
            type: option.type,
            name: (0, $gefPa.UNKNOWN)
        };
    });
};
const $6d9b84db806d1da8$var$isOptionData = (option)=>{
    return option.name !== undefined;
};
const $6d9b84db806d1da8$var$hydrateTeamIds = async (baseUrl, values, siteId)=>{
    if (values.length === 0) return [];
    const legionPromises = values.map((value)=>(0, $3Amrk.default)({
            baseUrl: baseUrl,
            id: value.id,
            siteId: siteId
        }));
    return await Promise.all(legionPromises);
};
const $6d9b84db806d1da8$var$hydrateAccountIds = async (baseUrl, productKey, values, atlAttributes)=>{
    if (values.length === 0) return [];
    const accountIds = values.map((val)=>val.id);
    //if we are not jira or confluence then use PRS platform hydration
    return productKey === 'jira' || productKey === 'confluence' ? await $6d9b84db806d1da8$var$getHydratedUsersFromProducts({
        baseUrl: baseUrl,
        productKey: productKey,
        accountIds: accountIds
    }) : await (0, $3Ou0J.default)(baseUrl, accountIds, {
        product: productKey,
        ...atlAttributes
    });
};
async function $6d9b84db806d1da8$var$hydrateDefaultValues(baseUrl, value, productKey, siteId, atlAttributes) {
    //return if no value
    if (!value || Array.isArray(value) && value.length === 0) return [];
    const values = Array.isArray(value) ? value : [
        value
    ];
    // return if all hydrated
    if (!values.some((val)=>!$6d9b84db806d1da8$var$isOptionData(val))) return value;
    const [hydratedUsers, hydratedTeams] = await Promise.all([
        $6d9b84db806d1da8$var$hydrateAccountIds(baseUrl, productKey, values.filter((val)=>!$6d9b84db806d1da8$var$isOptionData(val) && val.type === 'user'), atlAttributes),
        $6d9b84db806d1da8$var$hydrateTeamIds(baseUrl, values.filter((val)=>!$6d9b84db806d1da8$var$isOptionData(val) && val.type === 'team'), siteId)
    ]);
    const hydratedOptions = values.filter((val)=>$6d9b84db806d1da8$var$isOptionData(val)).map((val)=>val).concat(hydratedUsers).concat(hydratedTeams);
    return $6d9b84db806d1da8$var$sortResults(hydratedOptions, values);
}
var $6d9b84db806d1da8$export$2e2bcd8739ae039 = $6d9b84db806d1da8$var$hydrateDefaultValues;

});
parcelRegister("3Ou0J", function(module, exports) {
$parcel$export(module.exports, "default", () => $7be4dc1f67325912$export$2e2bcd8739ae039);

var $gefPa = parcelRequire("gefPa");

var $eNnoo = parcelRequire("eNnoo");

var $ikYS3 = parcelRequire("ikYS3");
/**
 * @param  {string} accountIds ids to hydrate
 * @return GraphQL Query
 */ const $7be4dc1f67325912$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
      picture
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $7be4dc1f67325912$var$makeRequest = async (url, accountIds, attributionData)=>{
    const query = $7be4dc1f67325912$var$buildUsersQuery(accountIds);
    return await (0, $eNnoo.graphqlQuery)(url, query, attributionData);
};
const $7be4dc1f67325912$var$modifyResponse = (users)=>users.map(({ accountId: accountId, name: name, picture: picture })=>({
            avatarUrl: picture,
            id: accountId,
            name: name,
            type: 'user'
        }));
const $7be4dc1f67325912$var$getHydratedUsers = (baseUrl, userIds, attributionData)=>{
    const url = (0, $ikYS3.config).getGraphQLUrl(baseUrl);
    return new Promise((resolve)=>{
        $7be4dc1f67325912$var$makeRequest(url, userIds, attributionData).then((data)=>{
            resolve($7be4dc1f67325912$var$modifyResponse(data.users));
        }).catch(()=>{
            // on network error, return original list with label 'Unknown'
            resolve(userIds.map((id)=>({
                    ...(0, $gefPa.UNKNOWN_USER),
                    id: id
                })));
        });
    });
};
var $7be4dc1f67325912$export$2e2bcd8739ae039 = $7be4dc1f67325912$var$getHydratedUsers;

});
parcelRegister("gefPa", function(module, exports) {
$parcel$export(module.exports, "UNKNOWN", () => $40b32fc5a1d7a621$export$78244dbb77cfa6b6);
$parcel$export(module.exports, "UNKNOWN_USER", () => $40b32fc5a1d7a621$export$d1f5101c0939e3fe);
$parcel$export(module.exports, "UNKNOWN_TEAM", () => $40b32fc5a1d7a621$export$8144dcfc9025ca57);
const $40b32fc5a1d7a621$export$78244dbb77cfa6b6 = 'Unknown';
const $40b32fc5a1d7a621$export$d1f5101c0939e3fe = {
    id: $40b32fc5a1d7a621$export$78244dbb77cfa6b6,
    name: $40b32fc5a1d7a621$export$78244dbb77cfa6b6,
    type: 'user'
};
const $40b32fc5a1d7a621$export$8144dcfc9025ca57 = {
    id: $40b32fc5a1d7a621$export$78244dbb77cfa6b6,
    name: $40b32fc5a1d7a621$export$78244dbb77cfa6b6,
    type: 'team'
};

});

parcelRegister("eNnoo", function(module, exports) {
$parcel$export(module.exports, "graphqlQuery", () => $376713e62aec159d$export$74eb8d79ae3e02b5);

var $cZ5Pq = parcelRequire("cZ5Pq");
const $376713e62aec159d$var$buildHeaders = (attributionData)=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const atlAttributionHeader = (0, $cZ5Pq.createAtlAttributionHeader)(attributionData);
    headers.append('atl-attribution', atlAttributionHeader['atl-attribution']);
    return headers;
};
function $376713e62aec159d$export$74eb8d79ae3e02b5(serviceUrl, query, attributionData) {
    const headers = $376713e62aec159d$var$buildHeaders(attributionData);
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}

});
parcelRegister("cZ5Pq", function(module, exports) {
$parcel$export(module.exports, "createAtlAttributionHeader", () => $fd5a5d9ed02dae02$export$14ef296862e3705e);
/**
 * Utility for creating the atl-attribution header for AGG requests
 * Reference: https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
 */ function $fd5a5d9ed02dae02$export$14ef296862e3705e({ product: product = 'platform', activationId: activationId, ...props } = {}) {
    const headerData = {
        service: 'smart-experiences/smart-user-picker',
        product: product,
        atlWorkspaceId: activationId && props.tenantId ? `ari:cloud:${product}:${props.tenantId}:workspace/${activationId}` : undefined,
        ...props
    };
    return {
        'atl-attribution': JSON.stringify(headerData)
    };
}

});



parcelRegister("3Amrk", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddece33c6eb9882f$export$2e2bcd8739ae039);

var $ikYS3 = parcelRequire("ikYS3");

var $gefPa = parcelRequire("gefPa");
const $ddece33c6eb9882f$var$transformTeam = (team, id)=>{
    return {
        id: id,
        name: team.displayName,
        type: 'team',
        avatarUrl: team.smallAvatarImageUrl,
        ...team.state && {
            state: team.state
        }
    };
};
const $ddece33c6eb9882f$var$hydrateTeamFromLegion = (request)=>{
    const url = (0, $ikYS3.config).getTeamsUrl(request.id, request.baseUrl, request.siteId);
    return fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>{
        return $ddece33c6eb9882f$var$transformTeam(response, request.id);
    }).catch(()=>({
            ...(0, $gefPa.UNKNOWN_TEAM),
            id: request.id
        }));
};
var $ddece33c6eb9882f$export$2e2bcd8739ae039 = $ddece33c6eb9882f$var$hydrateTeamFromLegion;

});


parcelRegister("lmLyy", function(module, exports) {
$parcel$export(module.exports, "smartUserPickerRenderedUfoExperience", () => $86585a48b0bcf213$export$df77da4c0210f1c1);
$parcel$export(module.exports, "smartUserPickerOptionsShownUfoExperience", () => $86585a48b0bcf213$export$a0e7cca3ab9586eb);
$parcel$export(module.exports, "useUFOConcurrentExperience", () => $86585a48b0bcf213$export$e5e0512991825310);
$parcel$export(module.exports, "UfoErrorBoundary", () => $86585a48b0bcf213$export$5ef1c2550074a375);

var $euxye = parcelRequire("euxye");

var $5X4ZM = parcelRequire("5X4ZM");
var $3nsUD = parcelRequire("3nsUD");
var $ff1v8 = parcelRequire("ff1v8");
const $86585a48b0bcf213$var$COMPONENT_NAME = 'smart-user-picker';
const $86585a48b0bcf213$export$df77da4c0210f1c1 = new (0, $5X4ZM.ConcurrentExperience)('smart-user-picker-rendered', {
    platform: {
        component: $86585a48b0bcf213$var$COMPONENT_NAME
    },
    type: (0, $3nsUD.ExperienceTypes).Load,
    performanceType: (0, $3nsUD.ExperiencePerformanceTypes).PageSegmentLoad
});
const $86585a48b0bcf213$export$a0e7cca3ab9586eb = new (0, $5X4ZM.ConcurrentExperience)('smart-user-picker-options-shown', {
    platform: {
        component: $86585a48b0bcf213$var$COMPONENT_NAME
    },
    type: (0, $3nsUD.ExperienceTypes).Operation,
    performanceType: (0, $3nsUD.ExperiencePerformanceTypes).InlineResult
});
const $86585a48b0bcf213$export$e5e0512991825310 = (experience, id)=>{
    const experienceForId = experience.getInstance(id);
    // Equivalent to componentWillMount - replace with @atlaskit/ufo's
    // useUFOComponentExperience when it supports ConcurrentExperience.
    (0, $euxye.useState)(()=>{
        experienceForId.start();
    });
    // Replace with @atlaskit/ufo's <ExperienceSuccess> when it supports ConcurrentExperience
    (0, $euxye.useEffect)(()=>{
        if (experienceForId.state !== (0, $ff1v8.UFOExperienceState)['FAILED']) experienceForId.success();
        return ()=>{
            if ([
                (0, $ff1v8.UFOExperienceState)['STARTED'],
                (0, $ff1v8.UFOExperienceState)['IN_PROGRESS']
            ].includes(experienceForId.state)) experienceForId.abort();
        };
    // We only want this useEffect to run once after component mount, so no deps are needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
class $86585a48b0bcf213$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    componentDidCatch() {
        $86585a48b0bcf213$export$df77da4c0210f1c1.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}
$86585a48b0bcf213$export$5ef1c2550074a375.displayName = "UfoErrorBoundary";

});



const $972e0d003317efb6$export$53782b65600ab96d = '__UNASSIGNED_TEAM__';

parcelRegister("qfZuH", function(module, exports) {
$parcel$export(module.exports, "fetchTeamsFilter", () => $ca0d187375d45bf9$export$ebe57e82b9cbe99a);

var $i860n = parcelRequire("i860n");

var $h2wCv = parcelRequire("h2wCv");
const $ca0d187375d45bf9$var$TEAMS_FILTER_QUERY = `
	query GetTeamsFilterForTeamPicker($cloudId: ID!, $filter: JiraFieldContextualDataFilterInput!) {
		jira {
			jiraFieldContextualData(
				cloudId: $cloudId
				first: 1
				filter: $filter
			) {
				edges {
					node {
						... on JiraFieldContextualDataTeamsFilter {
							fieldId
							teamsFilter
						}
					}
				}
			}
		}
	}
`;
const $ca0d187375d45bf9$var$TEAMS_FILTER_FOR_ISSUE_QUERY = `
	query GetTeamsFilterForIssueTeamPicker($cloudId: ID!, $filter: JiraFieldContextualDataForIssueFilterInput!) {
		jira {
			jiraFieldContextualDataForIssue(
				cloudId: $cloudId
				first: 1
				filter: $filter
			) {
				edges {
					node {
						... on JiraFieldContextualDataTeamsFilter {
							fieldId
							teamsFilter
						}
					}
				}
			}
		}
	}
`;
const $ca0d187375d45bf9$export$ebe57e82b9cbe99a = async (fieldId, cloudId, projectId)=>{
    try {
        // TODO: Migrate to Relay when this component is migrated
        if ((0, $i860n.fg)('_managed_team_graphql_fix_ken_4267')) {
            // eslint-disable-next-line jira/js/no-jira-fetch
            const response = await (0, $h2wCv.performPostRequest)('/gateway/api/graphql?operation=teamFilterQuery', {
                body: JSON.stringify({
                    query: $ca0d187375d45bf9$var$TEAMS_FILTER_FOR_ISSUE_QUERY,
                    variables: {
                        cloudId: cloudId,
                        filter: {
                            fieldIds: [
                                fieldId
                            ],
                            scopes: [
                                {
                                    projectId: projectId
                                }
                            ]
                        }
                    }
                }),
                headers: {
                    'content-type': 'application/json'
                }
            });
            return response?.data?.jira?.jiraFieldContextualDataForIssue?.edges?.[0]?.node?.teamsFilter ?? null;
        }
        // eslint-disable-next-line jira/js/no-jira-fetch
        const response = await (0, $h2wCv.performPostRequest)('/gateway/api/graphql?operation=teamFilterQuery', {
            body: JSON.stringify({
                query: $ca0d187375d45bf9$var$TEAMS_FILTER_QUERY,
                variables: {
                    cloudId: cloudId,
                    filter: {
                        fieldIds: [
                            fieldId
                        ]
                    }
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        return response?.data?.jira?.jiraFieldContextualData?.edges?.[0]?.node?.teamsFilter ?? null;
    } catch  {
        return null;
    }
};

});

parcelRegister("6cePc", function(module, exports) {
$parcel$export(module.exports, "CreateTeamOption", () => $3510265f42ea417e$export$8920795307e75f7e);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $32jVZ = parcelRequire("32jVZ");

var $ihEDU = parcelRequire("ihEDU");

var $defJG = parcelRequire("defJG");

var $ikOED = parcelRequire("ikOED");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $a8EUd = parcelRequire("a8EUd");

var $i860n = parcelRequire("i860n");

var $iYrOY = parcelRequire("iYrOY");
const $3510265f42ea417e$var$styles = {
    iconWrapper: "_1e0c1txw _4cvr1h6o _1bah1h6o _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7",
    optionWrapper: "_80omtlke"
};
const $3510265f42ea417e$var$createTeamButtonTextMessage = (0, $7eNDO.defineMessage)({
    id: "issue-field-team.create-team-button-text",
    defaultMessage: "Create a team"
});
function $3510265f42ea417e$export$8920795307e75f7e(t0) {
    const $ = (0, $e7boj.c)(15);
    const { onClick: onClick, isFocused: isFocused, setIsFooterFocused: t1 } = t0;
    const setIsFooterFocused = t1 === undefined ? $3510265f42ea417e$var$_temp : t1;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage($3510265f42ea417e$var$createTeamButtonTextMessage);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    const formattedCreateTeamText = t2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    let t3;
    if ($[2] !== createAnalyticsEvent || $[3] !== onClick) {
        t3 = ()=>{
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), "button clicked", "createTeamInline", {
                teamsFieldEmptyState: false
            });
            onClick();
        };
        $[2] = createAnalyticsEvent;
        $[3] = onClick;
        $[4] = t3;
    } else t3 = $[4];
    const handleCreateTeamOptionClick = t3;
    const setIsFooterFocusedWithFG = (0, $i860n.fg)("a11y-create-team-is-not-focusable-and-has-no-btn") ? setIsFooterFocused : $3510265f42ea417e$var$_temp2;
    let t4;
    if ($[5] !== handleCreateTeamOptionClick || $[6] !== setIsFooterFocusedWithFG) {
        t4 = (event)=>{
            if (event.key === "Escape" || event.key === "Tab") {
                setIsFooterFocusedWithFG(false);
                return;
            }
            if (event.key === "Enter" && (0, $i860n.fg)("a11y-open-create-team-dialog-with-enter")) {
                event.preventDefault();
                event.stopPropagation();
                handleCreateTeamOptionClick();
            }
        };
        $[5] = handleCreateTeamOptionClick;
        $[6] = setIsFooterFocusedWithFG;
        $[7] = t4;
    } else t4 = $[7];
    const handleFooterButtonKeyDown = t4;
    const { canCreateTeams: canCreateTeams } = (0, $iYrOY.useTeamPermissions)();
    let t5;
    if ($[8] !== canCreateTeams || $[9] !== formattedCreateTeamText || $[10] !== handleCreateTeamOptionClick || $[11] !== handleFooterButtonKeyDown || $[12] !== isFocused || $[13] !== setIsFooterFocusedWithFG) {
        t5 = canCreateTeams ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.PlaceholderWithNativeSuspense), {
            fallback: null,
            name: "CreateTeamOption"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $32jVZ.Bleed), {
            inline: "space.200",
            block: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3510265f42ea417e$var$CreateButtonBorder, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3510265f42ea417e$var$Container, {
            onClick: handleCreateTeamOptionClick,
            isFocused: isFocused,
            "data-testid": "issue-field-team.ui.edit-mode.create-team-option.create-team-inline-option"
        }, (0, $i860n.fg)("a11y-create-team-is-not-focusable-and-has-no-btn") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("button", {
            onFocus: ()=>setIsFooterFocusedWithFG(true),
            onBlur: ()=>setIsFooterFocusedWithFG(false),
            onKeyDown: handleFooterButtonKeyDown,
            className: (0, $4jQY2.default)([
                "_19itglyw _11q7glyw _1bsb1osq _4t3i1osq"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3510265f42ea417e$var$OptionDataWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.Inline), {
            xcss: $3510265f42ea417e$var$styles.optionWrapper,
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
            xcss: $3510265f42ea417e$var$styles.iconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ikOED))), {
            label: "",
            spacing: "spacious"
        })), formattedCreateTeamText))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3510265f42ea417e$var$OptionDataWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.Inline), {
            xcss: $3510265f42ea417e$var$styles.optionWrapper,
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
            xcss: $3510265f42ea417e$var$styles.iconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ikOED))), {
            label: "",
            spacing: "spacious"
        })), formattedCreateTeamText))))) : null;
        $[8] = canCreateTeams;
        $[9] = formattedCreateTeamText;
        $[10] = handleCreateTeamOptionClick;
        $[11] = handleFooterButtonKeyDown;
        $[12] = isFocused;
        $[13] = setIsFooterFocusedWithFG;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
}
$3510265f42ea417e$export$8920795307e75f7e.displayName = "CreateTeamOption";
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
function $3510265f42ea417e$var$_temp2() {
    return null;
}
function $3510265f42ea417e$var$_temp() {
    return null;
}
const $3510265f42ea417e$var$CreateButtonBorder = /*#__PURE__*/ (0, $euxye.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $e7boj.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $4jQY2.default)([
            "_x3doia51",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $3510265f42ea417e$var$wrapperButtonStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3510265f42ea417e$var$Container = /*#__PURE__*/ (0, $euxye.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $e7boj.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isFocused: isFocused, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $4jQY2.default)([
            "_19pkv77o _1bsb1osq _4t3i1osq _irr31dpa _1dbz1x9r",
            __cmplp.isFocused ? "_bfhk1dpa" : "_bfhk18uv",
            __cmplp.isFocused ? "_16qs1x9r" : "_16qsglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // Matching spacing of other options
const $3510265f42ea417e$var$OptionDataWrapper = /*#__PURE__*/ (0, $euxye.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $e7boj.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $4jQY2.default)([
            "_ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});

});
parcelRegister("32jVZ", function(module, exports) {
$parcel$export(module.exports, "Bleed", () => $928da3a5816acf17$export$a8307195dd50fcbf);
/* bleed.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");
// NOTE: This maintains a full map of 10 styles as Bleed is a bit of a semantic outlier
const $928da3a5816acf17$var$styles = {
    root: "_vchhusvi",
    'inline.space.025': "_195g4pxn",
    'inline.space.050': "_195ggp71",
    'inline.space.100': "_195gtdkl",
    'inline.space.150': "_195gkqjj",
    'inline.space.200': "_195g1e8l",
    'block.space.025': "_1mou4pxn",
    'block.space.050': "_1mougp71",
    'block.space.100': "_1moutdkl",
    'block.space.150': "_1moukqjj",
    'block.space.200': "_1mou1e8l"
};
const $928da3a5816acf17$export$a8307195dd50fcbf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $928da3a5816acf17$var$styles.root,
            all && $928da3a5816acf17$var$styles[`inline.${all}`],
            inline && $928da3a5816acf17$var$styles[`inline.${inline}`],
            all && $928da3a5816acf17$var$styles[`block.${all}`],
            block && $928da3a5816acf17$var$styles[`block.${block}`],
            xcss
        ]),
        "data-testid": testId,
        children: children
    });
});
$928da3a5816acf17$export$a8307195dd50fcbf.displayName = 'Bleed';

});

parcelRegister("iYrOY", function(module, exports) {
$parcel$export(module.exports, "useTeamPermissions", () => $0da66868a54da16e$export$8cbbe0c59dd60253);

var $e7boj = parcelRequire("e7boj");

var $6zTYs = parcelRequire("6zTYs");

var $eijVy = parcelRequire("eijVy");

var $5Q8dB = parcelRequire("5Q8dB");
const $0da66868a54da16e$export$8cbbe0c59dd60253 = ()=>{
    const $ = (0, $e7boj.c)(4);
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    const { cloudId: cloudId } = (0, $eijVy.useTenantContext)();
    let t0;
    if ($[0] !== cloudId || $[1] !== orgId) {
        t0 = {
            orgId: orgId,
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = orgId;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            enabled: false
        };
        $[3] = t1;
    } else t1 = $[3];
    const { permissions: permissions } = (0, $5Q8dB.useTeamsPermissionsService)(t0, t1);
    return permissions;
};

});


parcelRegister("47ukV", function(module, exports) {
$parcel$export(module.exports, "TeamPickerEmptyState", () => $27bc7bca846e3d74$export$f53d61da818dafb4);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $4yvWZ = parcelRequire("4yvWZ");

var $4qNCE = parcelRequire("4qNCE");

var $c69sa = parcelRequire("c69sa");

var $7eNDO = parcelRequire("7eNDO");
var $55qdj = parcelRequire("55qdj");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $iYrOY = parcelRequire("iYrOY");
const $27bc7bca846e3d74$var$Description = /*#__PURE__*/ (0, $euxye.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $e7boj.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $4jQY2.default)([
            "_syazi7uo _otyr1ejb _19pkze3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $27bc7bca846e3d74$var$imageWrapperStylesNew = null;
const $27bc7bca846e3d74$var$emptyStateDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "issue-field-team.empty-state-description",
    defaultMessage: "Create a team to assign work across Jira and track it on your team\u2019s profile"
});
const $27bc7bca846e3d74$var$createTeamButtonTextMessage = (0, $7eNDO.defineMessage)({
    id: "issue-field-team.create-team-button-text",
    defaultMessage: "Create a team"
});
const $27bc7bca846e3d74$var$noOptionsMessage = (0, $7eNDO.defineMessage)({
    id: "issue-field-team.no-options-message",
    defaultMessage: "No options"
});
const $27bc7bca846e3d74$export$f53d61da818dafb4 = (t0)=>{
    const $ = (0, $e7boj.c)(6);
    const { onActionClick: onActionClick } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { canCreateTeams: canCreateTeams } = (0, $iYrOY.useTeamPermissions)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== onActionClick) {
        t1 = ()=>{
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), "button clicked", "createTeamInline", {
                teamsFieldEmptyState: true
            });
            onActionClick();
        };
        $[0] = createAnalyticsEvent;
        $[1] = onActionClick;
        $[2] = t1;
    } else t1 = $[2];
    const handleCreateTeamOptionClick = t1;
    let t2;
    if ($[3] !== canCreateTeams || $[4] !== handleCreateTeamOptionClick) {
        t2 = canCreateTeams ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            paddingBlock: "space.200",
            testId: "issue-field-team.ui.edit-mode.team-picker-empty-state.empty-state"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
            className: (0, $4jQY2.default)([
                "_otyrpxbi _1e0c1txw _4cvr1h6o _1bah1h6o _1biu1qi0"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4yvWZ.default), {
            alt: "",
            width: 130,
            height: 122
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($27bc7bca846e3d74$var$Description, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55qdj.default), $27bc7bca846e3d74$var$emptyStateDescriptionMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
            appearance: "primary",
            onClick: handleCreateTeamOptionClick,
            testId: "issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button",
            interactionName: "auto-generated.issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button.button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55qdj.default), $27bc7bca846e3d74$var$createTeamButtonTextMessage))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55qdj.default), $27bc7bca846e3d74$var$noOptionsMessage);
        $[3] = canCreateTeams;
        $[4] = handleCreateTeamOptionClick;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
$27bc7bca846e3d74$export$f53d61da818dafb4.displayName = "TeamPickerEmptyState";

});
parcelRegister("4yvWZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fad4d5f44341f8a$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $gboXr = parcelRequire("gboXr");

var $8szJ5 = parcelRequire("8szJ5");
const $4fad4d5f44341f8a$var$Illustration = (0, $gboXr.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8szJ5)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8szJ5))
});
var $4fad4d5f44341f8a$export$2e2bcd8739ae039 = $4fad4d5f44341f8a$var$Illustration;
// for advanced use only
const $4fad4d5f44341f8a$export$a179c88182cb9d56 = [
    0,
    0,
    130,
    122
];

});
parcelRegister("8szJ5", function(module, exports) {
module.exports = new URL("people-and-tasks.dedc2456.svg", import.meta.url).toString();

});



parcelRegister("53rpp", function(module, exports) {
$parcel$export(module.exports, "VerifiedTeamFooter", () => $d834bbb523981276$export$a25faf0df6e3156a);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $32jVZ = parcelRequire("32jVZ");

var $ihEDU = parcelRequire("ihEDU");

var $8Sdzy = parcelRequire("8Sdzy");

var $6SSLX = parcelRequire("6SSLX");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $d834bbb523981276$var$verifiedTeamsOnlyMessage = (0, $7eNDO.defineMessage)({
    id: "issue-field-team.verified-team-footer.verified-teams-only-message",
    defaultMessage: "Only verified teams are shown"
});
const $d834bbb523981276$var$styles = {
    footerBorder: "_uwhke4h9 _15a5nqa1 _1i531l7x",
    outerContainer: "_1e0c1txw _4cvr1h6o _1wpz1fhb _ca0qu2gc _n3tdu2gc _19bv12x7 _u5f312x7",
    innerContainer: "_2rko12b0 _1e0c1txw _1bsb1osq _ca0qu2gc _n3tdu2gc _19bv12x7 _u5f312x7 _4cvr1h6o _bfhkl4ek _1wpz1fhb",
    contentWrapper: "_zulp12x7 _1e0c1txw _4cvr1h6o"
};
function $d834bbb523981276$export$a25faf0df6e3156a() {
    const $ = (0, $e7boj.c)(6);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
            xcss: $d834bbb523981276$var$styles.footerBorder
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6SSLX))), {
            label: "",
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage($d834bbb523981276$var$verifiedTeamsOnlyMessage);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $32jVZ.Bleed), {
            inline: "space.200",
            block: "space.100"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
            xcss: $d834bbb523981276$var$styles.outerContainer,
            testId: "field-team.verified-team-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
            xcss: $d834bbb523981276$var$styles.innerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
            xcss: $d834bbb523981276$var$styles.contentWrapper
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
            color: "color.text.subtlest"
        }, t2)))));
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
}
$d834bbb523981276$export$a25faf0df6e3156a.displayName = "VerifiedTeamFooter";

});
parcelRegister("6SSLX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::698cdbb7157fae3127e51e636cf7a8d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $503245ec2c676e9f$var$_react = $503245ec2c676e9f$var$_interopRequireDefault((parcelRequire("euxye")));

var $503245ec2c676e9f$var$_baseNew = $503245ec2c676e9f$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $503245ec2c676e9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/information-circle
 * Usage guidance:
 * Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $503245ec2c676e9f$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $503245ec2c676e9f$var$_react.default.createElement($503245ec2c676e9f$var$_baseNew.default, Object.assign({
        name: "InformationCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$503245ec2c676e9f$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $503245ec2c676e9f$var$_default = module.exports.default = $503245ec2c676e9f$var$InformationCircleIcon;

});






parcelRegister("5cWMt", function(module, exports) {
$parcel$export(module.exports, "validateFormData", () => $10878978740c1e88$export$cc0ea38c9ab56613);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $9ml7h = parcelRequire("9ml7h");
const $10878978740c1e88$var$validateBoardName = (value)=>{
    return !value || value.trim().length === 0 ? (0, $9ml7h.VALIDATION_ERROR_EMPTY) : undefined;
};
const $10878978740c1e88$var$validateSourceType = (value)=>{
    return value === undefined ? (0, $9ml7h.VALIDATION_ERROR_EMPTY) : undefined;
};
const $10878978740c1e88$var$validateSourceValue = (value)=>{
    if (Array.isArray(value) && !value.length || !Array.isArray(value) && !value) return 0, $9ml7h.VALIDATION_ERROR_EMPTY;
};
const $10878978740c1e88$export$cc0ea38c9ab56613 = (data)=>({
        boardName: $10878978740c1e88$var$validateBoardName(data.boardName),
        sourceType: $10878978740c1e88$var$validateSourceType(data.sourceType),
        sourceValue: data.sourceType ? $10878978740c1e88$var$validateSourceValue(data.sourceValue) : undefined
    });

});







parcelRegister("bSAZj", function(module, exports) {
$parcel$export(module.exports, "FlyoutMenuContentFallback", () => $0a71df5160f4b246$export$aad294dc6c6989e8);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $kENFC = parcelRequire("kENFC");

var $fbAgj = parcelRequire("fbAgj");

var $c69sa = parcelRequire("c69sa");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $9fNci = parcelRequire("9fNci");
const $0a71df5160f4b246$var$loadingLabel = (0, $7eNDO.defineMessage)({
    id: "software-board-create.flyout-menu.flyout-menu-content.flyout-menu-content-fallback.loading-label",
    defaultMessage: "Loading"
});
const $0a71df5160f4b246$export$aad294dc6c6989e8 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9fNci.FlyoutContentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        paddingBlockStart: "space.100",
        xcss: $0a71df5160f4b246$var$skeletonItemContainerStyles,
        role: "menuitem",
        "aria-label": formatMessage($0a71df5160f4b246$var$loadingLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), {
        hasIcon: true,
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        paddingBlockStart: "space.100",
        xcss: $0a71df5160f4b246$var$skeletonItemContainerStyles,
        role: "menuitem",
        "aria-label": formatMessage($0a71df5160f4b246$var$loadingLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), {
        hasIcon: true,
        width: "100%"
    })));
};
$0a71df5160f4b246$export$aad294dc6c6989e8.displayName = "FlyoutMenuContentFallback";
const $0a71df5160f4b246$var$skeletonItemContainerStyles = (0, $fbAgj.xcss)({
    height: '56px'
});

});




parcelRegister("kVWDZ", function(module, exports) {
$parcel$export(module.exports, "isCompanyManagedSoftwareProject", () => $8bb35d8f3cb15815$export$531964df831b0883);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");
const $8bb35d8f3cb15815$export$531964df831b0883 = (projectStyle, projectType)=>projectStyle === 'COMPANY_MANAGED_PROJECT' && projectType === (0, $f99M0.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT);

});


parcelRegister("9bydH", function(module, exports) {
$parcel$export(module.exports, "AsyncJcsProjectMenuContent", () => $ae97361b54f4e625$export$3c6ecddd0c68d049);

var $kx6mf = parcelRequire("kx6mf");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $gVkjO = parcelRequire("gVkjO");

var $gEDfa = parcelRequire("gEDfa");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");
const $ae97361b54f4e625$var$Skeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null);
$ae97361b54f4e625$var$Skeleton.displayName = "Skeleton";

const $ae97361b54f4e625$var$LazyJcsProjectMenuContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("gx648")).then(({ JcsProjectMenuContent: JcsProjectMenuContent })=>JcsProjectMenuContent), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-content-projects-jcs-project-menu/src/ui/project-menu/JcsProjectMenuContent.tsx"
});
const $ae97361b54f4e625$export$3c6ecddd0c68d049 = /*#__PURE__*/ (0, $euxye.memo)(({ projectFragment: projectFragment })=>{
    const asyncJcsProjectMenuContent = (0, $n67Vb.useFragment)((0, $kx6mf.default), projectFragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.jcs-project-menu-content",
        packageName: "jiraNavigationAppsSidebarNav4JcsProjectMenu",
        teamName: "Boysenberry",
        ufoName: "nav4.sidebar.jcs-project-menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.jcs-project-menu-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ae97361b54f4e625$var$Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ae97361b54f4e625$var$LazyJcsProjectMenuContent, {
        projectData: asyncJcsProjectMenuContent
    })));
});

});
parcelRegister("kx6mf", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ee80a1375862613$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<35ab783299fc75219c3bf943e8136b52>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9ee80a1375862613$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AsyncJcsProjectMenuContent_jiraProject",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "JcsProjectMenuContent"
        }
    ],
    "type": "JiraProject"
};
$9ee80a1375862613$var$node.hash = "633aa77648aa4d621c44a51fe9107db8";
var $9ee80a1375862613$export$2e2bcd8739ae039 = $9ee80a1375862613$var$node;

});

parcelRegister("gx648", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("85yrX").then(()=>parcelRequire('1VZOg'));

});



parcelRegister("f54oL", function(module, exports) {
$parcel$export(module.exports, "JswProjectMenu", () => $52e9416e3e7e2aa6$export$6bfce83b67850c4);

var $e7boj = parcelRequire("e7boj");

var $iHDjs = parcelRequire("iHDjs");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $f99M0 = parcelRequire("f99M0");

var $aJDWs = parcelRequire("aJDWs");

var $6hgaW = parcelRequire("6hgaW");

var $5xf3O = parcelRequire("5xf3O");

var $8oRL2 = parcelRequire("8oRL2");
const $52e9416e3e7e2aa6$export$6bfce83b67850c4 = (t0)=>{
    const $ = (0, $e7boj.c)(6);
    const { projectData: projectData, menuItemAnchorRef: menuItemAnchorRef, menuItemButtonRef: menuItemButtonRef } = t0;
    const project = (0, $n67Vb.useFragment)((0, $iHDjs.default), projectData);
    if (project.softwareBoardCount && project.softwareBoardCount > 0 && project.projectStyle === (0, $f99M0.COMPANY_MANAGED_PROJECT) || project.subspaceCount != null && project.subspaceCount > 0 && (0, $aJDWs.isProjectsInJiraM2Enabled)()) {
        let t1;
        if ($[0] !== menuItemButtonRef || $[1] !== project) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6hgaW.WillRedirectOnLoadProviders), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5xf3O.JswExpandableProject), {
                projectData: project,
                menuItemButtonRef: menuItemButtonRef
            }));
            $[0] = menuItemButtonRef;
            $[1] = project;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== menuItemAnchorRef || $[4] !== project) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8oRL2.JswNonExpandableProject), {
            projectData: project,
            menuItemAnchorRef: menuItemAnchorRef
        });
        $[3] = menuItemAnchorRef;
        $[4] = project;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
$52e9416e3e7e2aa6$export$6bfce83b67850c4.displayName = "JswProjectMenu";

});
parcelRegister("iHDjs", function(module, exports) {
$parcel$export(module.exports, "default", () => $f88c549c01fe2e22$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<85c6e2c9cc566fd789d515d41d3dfd8f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f88c549c01fe2e22$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "JswProjectMenu",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        },
        {
            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "alias": "subspaceCount",
                            "kind": "ScalarField",
                            "name": "subspaceCount_cse"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "FragmentSpread",
            "name": "JswNonExpandableProject"
        },
        {
            "kind": "FragmentSpread",
            "name": "JswExpandableProject"
        }
    ],
    "type": "JiraProject"
};
$f88c549c01fe2e22$var$node.hash = "aac3937718007b5e6d6122bdeb2f5b27";
var $f88c549c01fe2e22$export$2e2bcd8739ae039 = $f88c549c01fe2e22$var$node;

});

parcelRegister("6hgaW", function(module, exports) {
$parcel$export(module.exports, "WillRedirectOnLoadProviders", () => $196be6298606a1d4$export$e5e54b40f58f4bf4);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iLL0K = parcelRequire("iLL0K");
const $196be6298606a1d4$export$e5e54b40f58f4bf4 = ({ children: children })=>{
    const [willRedirectOnLoad, setWillRedirectOnLoad] = (0, $euxye.useState)(false);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iLL0K.WillRedirectOnLoadContext).Provider, {
        value: willRedirectOnLoad,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iLL0K.SetWillRedirectOnLoadContext).Provider, {
            value: setWillRedirectOnLoad,
            children: children
        })
    });
};
$196be6298606a1d4$export$e5e54b40f58f4bf4.displayName = "WillRedirectOnLoadProviders";

});
parcelRegister("iLL0K", function(module, exports) {
$parcel$export(module.exports, "WillRedirectOnLoadContext", () => $b9226f645426b568$export$7c9713df22ffd008);
$parcel$export(module.exports, "SetWillRedirectOnLoadContext", () => $b9226f645426b568$export$61b58f7123070fe1);

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");
const $b9226f645426b568$export$7c9713df22ffd008 = /*#__PURE__*/ (0, $euxye.createContext)(false);
const $b9226f645426b568$export$61b58f7123070fe1 = /*#__PURE__*/ (0, $euxye.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))));

});


parcelRegister("5xf3O", function(module, exports) {
$parcel$export(module.exports, "JswExpandableProject", () => $539a3035104f2305$export$a77599e713340697);

var $e7boj = parcelRequire("e7boj");

var $cwgpK = parcelRequire("cwgpK");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $f99M0 = parcelRequire("f99M0");

var $aJDWs = parcelRequire("aJDWs");

var $jreC0 = parcelRequire("jreC0");

var $82ATR = parcelRequire("82ATR");

var $ekhRy = parcelRequire("ekhRy");

var $5IkoH = parcelRequire("5IkoH");

var $4VtOS = parcelRequire("4VtOS");

var $gEDfa = parcelRequire("gEDfa");

var $c4aX7 = parcelRequire("c4aX7");

var $jzXAj = parcelRequire("jzXAj");

var $hDvet = parcelRequire("hDvet");

var $l69gK = parcelRequire("l69gK");

var $f1JKW = parcelRequire("f1JKW");


var $btoiF = parcelRequire("btoiF");

var $dXmF1 = parcelRequire("dXmF1");

var $dWplX = parcelRequire("dWplX");

var $i0CFV = parcelRequire("i0CFV");

var $2v6ed = parcelRequire("2v6ed");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");
var $3D7ce = parcelRequire("3D7ce");

var $kFgCO = parcelRequire("kFgCO");

var $4PUMe = parcelRequire("4PUMe");

var $g5ZVO = parcelRequire("g5ZVO");

var $fFNvS = parcelRequire("fFNvS");

var $cZjb4 = parcelRequire("cZjb4");

var $i860n = parcelRequire("i860n");

var $kt86l = parcelRequire("kt86l");

var $h3LJR = parcelRequire("h3LJR");


var $9BxTS = parcelRequire("9BxTS");
const $539a3035104f2305$export$a77599e713340697 = (t0)=>{
    const $ = (0, $e7boj.c)(102);
    const { projectData: projectData, menuItemButtonRef: menuItemButtonRef } = t0;
    const { sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent } = (0, $ekhRy.useProjectsAnalyticsL1)();
    const project = (0, $n67Vb.useFragment)((0, $cwgpK.default), projectData);
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const { data: t1 } = (0, $kFgCO.useCurrentUser)();
    const { user: t2 } = t1;
    const { accountId: accountId } = t2;
    const t3 = accountId || "";
    let t4;
    if ($[0] !== activationId || $[1] !== cloudId || $[2] !== t3) {
        t4 = {
            cloudId: cloudId,
            atlassianAccountId: t3,
            activationId: activationId
        };
        $[0] = activationId;
        $[1] = cloudId;
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== project.projectKey || $[5] !== project.projectStyle) {
        t5 = {
            match: {
                params: {
                    projectKey: project.projectKey,
                    projectStyle: project.projectStyle
                }
            }
        };
        $[4] = project.projectKey;
        $[5] = project.projectStyle;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== t4 || $[8] !== t5) {
        t6 = {
            tenantContext: t4,
            context: t5
        };
        $[7] = t4;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    const entryPointParams = t6;
    const leftSidebarEPRef = (0, $btoiF.usePageLayoutEntryPoint)((0, $b666e36d39b806ff$export$50ea883ba6f28ff5));
    const boardsEPRef = leftSidebarEPRef?.entryPoints?.boards;
    const [projectKeyPathParam] = (0, $cZjb4.usePathParam)("projectKey");
    const [issueKeyPathParam] = (0, $cZjb4.usePathParam)("issueKey");
    let projectKey = projectKeyPathParam;
    if (issueKeyPathParam && (0, $i860n.fg)("move-issue-view-to-entrypoint")) {
        let t7;
        if ($[10] !== issueKeyPathParam) {
            t7 = (0, $i0CFV.getProjectKeyFromProjectOrIssueKey)("", issueKeyPathParam);
            $[10] = issueKeyPathParam;
            $[11] = t7;
        } else t7 = $[11];
        projectKey = t7;
    }
    const shouldRenderBoardsEntryPoint = project.projectKey === projectKey;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $9BxTS.nav4JSWProjectEntryPoint), entryPointParams);
    const triggerRef = (0, $hDvet.useExpandableEntryPointTrigger)(entryPointActions);
    const { getLinkProps: getLinkProps } = (0, $c4aX7.useGetLinkProps)();
    let t7;
    if ($[12] !== boardsEPRef || $[13] !== entryPointParams || $[14] !== entryPointReferenceSubject || $[15] !== shouldRenderBoardsEntryPoint) {
        t7 = ()=>({
                Component: ()=>{
                    const epContainerProps = {
                        id: "jsw-expandable-project",
                        packageName: (0, $3b4da905a4c4a13f$export$b8b9d90f9e5bd72b),
                        teamName: (0, $3b4da905a4c4a13f$export$d57b6b390e78d90f),
                        errorFallback: "flag",
                        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null),
                        runtimeProps: entryPointParams
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f1JKW.RouteEntryPointContainer), {
                        epContainerProps: epContainerProps,
                        jiraEPRef: entryPointReferenceSubject,
                        nestedEPRef: boardsEPRef,
                        placeholderEntryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint),
                        shouldRenderNestedEntryPoint: shouldRenderBoardsEntryPoint
                    });
                }
            });
        $[12] = boardsEPRef;
        $[13] = entryPointParams;
        $[14] = entryPointReferenceSubject;
        $[15] = shouldRenderBoardsEntryPoint;
        $[16] = t7;
    } else t7 = $[16];
    const [entryPointConfig] = (0, $euxye.useState)(t7);
    const setWillRedirectOnLoad = (0, $g5ZVO.useSetWillRedirectOnLoad)();
    let t8;
    if ($[17] !== entryPointActions || $[18] !== setWillRedirectOnLoad) {
        t8 = (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
            else setWillRedirectOnLoad(false);
        };
        $[17] = entryPointActions;
        $[18] = setWillRedirectOnLoad;
        $[19] = t8;
    } else t8 = $[19];
    const onSystemToggle = t8;
    let t9;
    if ($[20] !== entryPointActions || $[21] !== project.isFavourite || $[22] !== project.projectId || $[23] !== project.projectType || $[24] !== sendProjectMenuItemAnalyticsEvent || $[25] !== setWillRedirectOnLoad) {
        t9 = (hasExpanded_0)=>{
            if (hasExpanded_0) {
                entryPointActions.load();
                sendProjectMenuItemAnalyticsEvent({
                    starred: project.isFavourite ?? false,
                    recent: !project.isFavourite,
                    projectId: project.projectId,
                    projectType: project.projectType
                });
            } else setWillRedirectOnLoad(false);
        };
        $[20] = entryPointActions;
        $[21] = project.isFavourite;
        $[22] = project.projectId;
        $[23] = project.projectType;
        $[24] = sendProjectMenuItemAnalyticsEvent;
        $[25] = setWillRedirectOnLoad;
        $[26] = t9;
    } else t9 = $[26];
    const onExpansionToggle = t9;
    let t10;
    if ($[27] !== project.projectStyle) {
        t10 = (ev)=>{
            if ((0, $82ATR.isNormalClick)(ev)) {
                if (project.projectStyle === (0, $f99M0.TEAM_MANAGED_PROJECT) && (0, $aJDWs.isProjectsInJiraM2Enabled)()) return;
                ev.preventDefault();
            }
        };
        $[27] = project.projectStyle;
        $[28] = t10;
    } else t10 = $[28];
    const onClick = t10;
    const t11 = !!project.isFavourite;
    let t12;
    if ($[29] !== project.avatar || $[30] !== project.isFavourite || $[31] !== project.name || $[32] !== project.projectId || $[33] !== project.projectKey || $[34] !== t11) {
        t12 = {
            projectId: project.projectId,
            projectKey: project.projectKey,
            isFavourite: project.isFavourite,
            name: project.name,
            avatar: project.avatar,
            isEnabled: t11
        };
        $[29] = project.avatar;
        $[30] = project.isFavourite;
        $[31] = project.name;
        $[32] = project.projectId;
        $[33] = project.projectKey;
        $[34] = t11;
        $[35] = t12;
    } else t12 = $[35];
    const { state: state, draggableAnchorRef: draggableAnchorRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, dragPreview: dragPreview, hasDragIndicator: hasDragIndicator } = (0, $dWplX.useProjectMenuItemDragAndDrop)(t12);
    if (!project) return null;
    let T0;
    let T1;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t19;
    let t20;
    let t21;
    let t22;
    let t23;
    let t24;
    if ($[36] !== draggableAnchorRef || $[37] !== dropIndicator || $[38] !== dropTargetRef || $[39] !== getLinkProps || $[40] !== menuItemButtonRef || $[41] !== onClick || $[42] !== onExpansionToggle || $[43] !== onSystemToggle || $[44] !== project || $[45] !== state.type || $[46] !== triggerRef) {
        const menuId = (0, $5IkoH.ENTITY_ID).PROJECT(project.projectKey);
        T1 = (0, $4VtOS.Nav4ExpandableMenuItem);
        t19 = menuId;
        t20 = onSystemToggle;
        t21 = onExpansionToggle;
        t22 = dropIndicator;
        t23 = dropTargetRef;
        t24 = state.type === "dragging";
        T0 = $539a3035104f2305$var$ExpandableMenuItemTriggerWithSetWillRedirectOnLoad;
        let t25;
        if ($[61] !== project.defaultNavigationItem?.url || $[62] !== project.projectStyle || $[63] !== project.webUrl) {
            t25 = (0, $aJDWs.isProjectsInJiraM2Enabled)() && project.projectStyle === (0, $f99M0.TEAM_MANAGED_PROJECT) ? project.defaultNavigationItem?.url ?? (0, $l69gK.removeBaseUrl)(project.webUrl) : (0, $l69gK.removeBaseUrl)(project.webUrl);
            $[61] = project.defaultNavigationItem?.url;
            $[62] = project.projectStyle;
            $[63] = project.webUrl;
            $[64] = t25;
        } else t25 = $[64];
        if ($[65] !== getLinkProps || $[66] !== t25) {
            t13 = getLinkProps(t25);
            $[65] = getLinkProps;
            $[66] = t25;
            $[67] = t13;
        } else t13 = $[67];
        if ($[68] !== project) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dXmF1.ProjectActions), {
                projectFragment: project
            });
            $[68] = project;
            $[69] = t14;
        } else t14 = $[69];
        if ($[70] !== project.avatar.large) {
            t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v6ed.ContainerAvatar), {
                src: project.avatar.large
            });
            $[70] = project.avatar.large;
            $[71] = t15;
        } else t15 = $[71];
        if ($[72] !== draggableAnchorRef || $[73] !== menuItemButtonRef || $[74] !== triggerRef) {
            t16 = (0, $fFNvS.mergeRefs)(draggableAnchorRef, ...[
                triggerRef,
                menuItemButtonRef
            ].filter(Boolean));
            $[72] = draggableAnchorRef;
            $[73] = menuItemButtonRef;
            $[74] = triggerRef;
            $[75] = t16;
        } else t16 = $[75];
        t17 = onClick;
        t18 = (0, $jzXAj.getTestId)(menuId);
        $[36] = draggableAnchorRef;
        $[37] = dropIndicator;
        $[38] = dropTargetRef;
        $[39] = getLinkProps;
        $[40] = menuItemButtonRef;
        $[41] = onClick;
        $[42] = onExpansionToggle;
        $[43] = onSystemToggle;
        $[44] = project;
        $[45] = state.type;
        $[46] = triggerRef;
        $[47] = T0;
        $[48] = T1;
        $[49] = t13;
        $[50] = t14;
        $[51] = t15;
        $[52] = t16;
        $[53] = t17;
        $[54] = t18;
        $[55] = t19;
        $[56] = t20;
        $[57] = t21;
        $[58] = t22;
        $[59] = t23;
        $[60] = t24;
    } else {
        T0 = $[47];
        T1 = $[48];
        t13 = $[49];
        t14 = $[50];
        t15 = $[51];
        t16 = $[52];
        t17 = $[53];
        t18 = $[54];
        t19 = $[55];
        t20 = $[56];
        t21 = $[57];
        t22 = $[58];
        t23 = $[59];
        t24 = $[60];
    }
    const t25 = state.type === "dragging";
    let t26;
    if ($[76] !== T0 || $[77] !== hasDragIndicator || $[78] !== project.name || $[79] !== t13 || $[80] !== t14 || $[81] !== t15 || $[82] !== t16 || $[83] !== t17 || $[84] !== t18 || $[85] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(T0, {
            ...t13,
            actionsOnHover: t14,
            elemBefore: t15,
            ref: t16,
            onClick: t17,
            testId: t18,
            hasDragIndicator: hasDragIndicator,
            isDragging: t25,
            interactionName: "nav4-sidebar-jsw-project"
        }, project.name);
        $[76] = T0;
        $[77] = hasDragIndicator;
        $[78] = project.name;
        $[79] = t13;
        $[80] = t14;
        $[81] = t15;
        $[82] = t16;
        $[83] = t17;
        $[84] = t18;
        $[85] = t25;
        $[86] = t26;
    } else t26 = $[86];
    let t27;
    if ($[87] !== entryPointConfig.Component) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(entryPointConfig.Component, null));
        $[87] = entryPointConfig.Component;
        $[88] = t27;
    } else t27 = $[88];
    let t28;
    if ($[89] !== T1 || $[90] !== t19 || $[91] !== t20 || $[92] !== t21 || $[93] !== t22 || $[94] !== t23 || $[95] !== t24 || $[96] !== t26 || $[97] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(T1, {
            menuId: t19,
            onSystemToggle: t20,
            onExpansionToggle: t21,
            dropIndicator: t22,
            dropTargetRef: t23,
            isDragging: t24
        }, t26, t27);
        $[89] = T1;
        $[90] = t19;
        $[91] = t20;
        $[92] = t21;
        $[93] = t22;
        $[94] = t23;
        $[95] = t24;
        $[96] = t26;
        $[97] = t27;
        $[98] = t28;
    } else t28 = $[98];
    let t29;
    if ($[99] !== dragPreview || $[100] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, t28, dragPreview);
        $[99] = dragPreview;
        $[100] = t28;
        $[101] = t29;
    } else t29 = $[101];
    return t29;
};
$539a3035104f2305$export$a77599e713340697.displayName = "JswExpandableProject";
// A thin wrapper so we can access `isExpanded` via hook.
// We redirect on load when the label is clicked, so we only do this in `onClick` and not in any of the toggle handlers (which the chevron also uses).
const $539a3035104f2305$var$ExpandableMenuItemTriggerWithSetWillRedirectOnLoad = /*#__PURE__*/ (0, $euxye.forwardRef)((t0, ref)=>{
    const $ = (0, $e7boj.c)(9);
    let children;
    let onClick;
    let props;
    if ($[0] !== t0) {
        ({ children: children, onClick: onClick, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = onClick;
        $[3] = props;
    } else {
        children = $[1];
        onClick = $[2];
        props = $[3];
    }
    const isExpanded = (0, $3D7ce.useIsExpanded)();
    const onClickActual = (0, $4PUMe.useWithSetWillRedirectOnLoad)(onClick, true, !isExpanded);
    let t1;
    if ($[4] !== children || $[5] !== onClickActual || $[6] !== props || $[7] !== ref) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
            onClick: onClickActual,
            ref: ref,
            ...props
        }, children);
        $[4] = children;
        $[5] = onClickActual;
        $[6] = props;
        $[7] = ref;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
});

});
parcelRegister("cwgpK", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5e18dee6cd6c6ef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e7e92559163d52dfbc3d17c8e1e9d891>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d5e18dee6cd6c6ef$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "JswExpandableProject",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW"
                    }
                ]
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "webUrl"
            },
            "action": "THROW"
        },
        {
            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "defaultNavigationItem",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                }
                            ],
                            "type": "JiraNavigationItem",
                            "abstractKey": "__isJiraNavigationItem"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ProjectActions"
        }
    ],
    "type": "JiraProject"
};
$d5e18dee6cd6c6ef$var$node.hash = "2b8d7282fae2122fe5e52846af3731b6";
var $d5e18dee6cd6c6ef$export$2e2bcd8739ae039 = $d5e18dee6cd6c6ef$var$node;

});

parcelRegister("82ATR", function(module, exports) {
$parcel$export(module.exports, "isNormalClick", () => $1d4cee71c84956f5$export$729f3684d5c2b9b9);
/* eslint-disable jira/filename-case */ const $1d4cee71c84956f5$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);

});

parcelRegister("l69gK", function(module, exports) {
$parcel$export(module.exports, "removeBaseUrl", () => $5fe4c1cc43a8f529$export$d401b6140b158f69);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Removes the base URL from the given URL string.
 *
 * @param url - The URL string from which to remove the base URL.
 * @returns The URL string with the base URL removed.
 */ const $5fe4c1cc43a8f529$export$d401b6140b158f69 = (url)=>url.replace(/https?:\/\/[^/]+/, '');

});

parcelRegister("4PUMe", function(module, exports) {
$parcel$export(module.exports, "useWithSetWillRedirectOnLoad", () => $ef7a2ab0ec652248$export$6d74e9ac9c6fcd64);

var $euxye = parcelRequire("euxye");

var $g5ZVO = parcelRequire("g5ZVO");
const $ef7a2ab0ec652248$export$6d74e9ac9c6fcd64 = (f, value, condition = true)=>{
    const setWillRedirectOnLoad = (0, $g5ZVO.useSetWillRedirectOnLoad)();
    return (0, $euxye.useCallback)((...args)=>{
        if (condition) setWillRedirectOnLoad(value);
        f?.(...args);
    }, [
        condition,
        f,
        setWillRedirectOnLoad,
        value
    ]);
};

});
parcelRegister("g5ZVO", function(module, exports) {
$parcel$export(module.exports, "useSetWillRedirectOnLoad", () => $d51840343c9871a9$export$61738ae72e3e0690);

var $euxye = parcelRequire("euxye");

var $iLL0K = parcelRequire("iLL0K");
const $d51840343c9871a9$export$61738ae72e3e0690 = ()=>(0, $euxye.useContext)((0, $iLL0K.SetWillRedirectOnLoadContext));

});


/* eslint-disable jira/filename-case */ const $3b4da905a4c4a13f$export$b8b9d90f9e5bd72b = '@jira/navigation-apps__sidebar-nav4-sidebars-content-projects-jsw-project-menu';
const $3b4da905a4c4a13f$export$d57b6b390e78d90f = 'jira-cosmos';
const $3b4da905a4c4a13f$export$420a3ee5deb615a9 = 25;
const $3b4da905a4c4a13f$export$99240e55cc48c47e = 5;

parcelRegister("9BxTS", function(module, exports) {
$parcel$export(module.exports, "nav4JSWProjectEntryPoint", () => $f1c17975c8758c5b$export$b1c3a10bbf92ce74);

var $i0CFV = parcelRequire("i0CFV");

var $i860n = parcelRequire("i860n");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $2NSbF = parcelRequire("2NSbF");

var $6fsuc = parcelRequire("6fsuc");

var $18sMq = parcelRequire("18sMq");

var $lDG1P = parcelRequire("lDG1P");
const $f1c17975c8758c5b$var$NO_OF_BOARDS_TO_FETCH = 25;

const $f1c17975c8758c5b$export$b1c3a10bbf92ce74 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("lGA5q")), {
        moduleId: "be754bb2",
        moduleName: "JswExpandableProjectQuery",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId ?? '';
        const accountId = params.tenantContext?.atlassianAccountId;
        const activationId = params.tenantContext?.activationId ?? '';
        if (!accountId) return {
            extraProps: {
                cloudId: '',
                entityAri: '',
                ownerAri: ''
            }
        };
        let projectKey = '';
        if (params.context?.match.params?.projectKey) projectKey = params.context.match.params.projectKey;
        else if (params.context?.match.params?.issueKey && (0, $i860n.fg)('move-issue-view-to-entrypoint')) projectKey = (0, $i0CFV.getProjectKey)(params.context.match, params.context.query);
        const entityAri = (0, $i860n.fg)('navx-3660-fix-l2-l3-aris') ? (0, $18sMq.NavigationSettingAri).create({
            activationId: activationId,
            firstPartyApp: 'jira',
            siteId: cloudId,
            settingId: `project-${projectKey.toLowerCase()}-subcontainer`
        }).toString() : (0, $6fsuc.AnyAri).create({
            cloudId: cloudId,
            resourceType: 'project',
            resourceId: projectKey,
            resourceOwner: 'jira'
        }).toString();
        const ownerAri = (0, $2NSbF.IdentityUserAri).create({
            userId: accountId || 'UNKNOWN'
        }).toString();
        // Feature gate variables - original query doesn't have entityAri and ownerAri
        const variables = {
            cloudId: cloudId,
            projectKey: projectKey,
            noOfBoardsToFetch: $f1c17975c8758c5b$var$NO_OF_BOARDS_TO_FETCH,
            ownerAri: ownerAri,
            entityAri: entityAri,
            skipOrderQuery: false
        };
        return {
            queries: {
                projects: {
                    parameters: $lDG1P.default,
                    variables: variables
                }
            },
            extraProps: {
                cloudId: cloudId,
                entityAri: entityAri,
                ownerAri: ownerAri
            }
        };
    }
});

});
parcelRegister("lDG1P", function(module, exports) {
$parcel$export(module.exports, "default", () => $42fb6f7576e38680$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d7ebf31c83bc8248a077ced9a12c1c0>>
 * @relayHash 382838e0d9a03f82d53ca3c4ff84f473
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ff172a02eccf823631baeca802bb406c0f5202def8904b3bb358415fd619d79b

var $lIGkE = parcelRequire("lIGkE");
const $42fb6f7576e38680$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "noOfBoardsToFetch"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipOrderQuery"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "Variable",
        "name": "entityAri",
        "variableName": "entityAri"
    }, v8 = {
        "kind": "Variable",
        "name": "noOfBoardsToFetch",
        "variableName": "noOfBoardsToFetch"
    }, v9 = {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
    }, v10 = [
        v6 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v11 = [
        v7 /*: any*/ ,
        v9 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "noOfBoardsToFetch"
        }
    ], v19 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v15 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v17 /*: any*/ 
        ]
    }, v20 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            v14 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v22 = [
        v12 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "subspaceId"
        },
        v13 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "subspaceUrl"
        },
        v14 /*: any*/ 
    ], v23 = [
        {
            "concreteType": "SubcontainerEdge_CSE",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v16 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ],
                            "type": "JiraBoard"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v22 /*: any*/ ,
                            "type": "JiraSubspace_CSE"
                        },
                        v17 /*: any*/ 
                    ]
                }
            ]
        }
    ], v24 = [
        {
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsMenuItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "menuId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "visible"
                        }
                    ]
                }
            ]
        },
        v12 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JswExpandableProjectQuery",
            "selections": [
                {
                    "args": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "skipOrderQuery",
                            "variableName": "skipOrderQuery"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "SubContainer"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                v8 /*: any*/ 
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "JswBoards"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                },
                {
                    "condition": "skipOrderQuery",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": "boardsOrder",
                            "args": v11 /*: any*/ ,
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "JswBoards_navigationCustomisation"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "JswExpandableProjectQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v12 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "alias": "projectKey",
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                v13 /*: any*/ ,
                                {
                                    "alias": "canEditProjectConfig",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "mostRecentlyViewedBoard",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v16 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v18 /*: any*/ ,
                                    "concreteType": "JiraBoardConnection",
                                    "kind": "LinkedField",
                                    "name": "boards",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraBoard",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardType"
                                                        },
                                                        v21 /*: any*/ ,
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "alias": "subspaces",
                                            "concreteType": "JiraSubspaceConnection_CSE",
                                            "kind": "LinkedField",
                                            "name": "subspaces_cse",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSubspaceEdge_CSE",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSubspace_CSE",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ 
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "subcontainersMenu",
                                            "concreteType": "JiraSubcontainersSidebarMenu_CSE",
                                            "kind": "LinkedField",
                                            "name": "subcontainersMenu_cse",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v18 /*: any*/ ,
                                                    "concreteType": "SubcontainerConnection_CSE",
                                                    "kind": "LinkedField",
                                                    "name": "favourites",
                                                    "plural": false,
                                                    "selections": v23 /*: any*/ 
                                                },
                                                {
                                                    "args": v18 /*: any*/ ,
                                                    "concreteType": "SubcontainerConnection_CSE",
                                                    "kind": "LinkedField",
                                                    "name": "recents",
                                                    "plural": false,
                                                    "selections": v23 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v11 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "condition": "skipOrderQuery",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": "boardsOrder",
                            "args": v11 /*: any*/ ,
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": v24 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ff172a02eccf823631baeca802bb406c0f5202def8904b3bb358415fd619d79b",
            "metadata": {},
            "name": "JswExpandableProjectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$42fb6f7576e38680$var$node.hash = "8d065c186c9efd7cbdab8b8ad93f7ed4";
(0, $lIGkE.PreloadableQueryRegistry).set($42fb6f7576e38680$var$node.params.id, $42fb6f7576e38680$var$node);
var $42fb6f7576e38680$export$2e2bcd8739ae039 = $42fb6f7576e38680$var$node;

});

parcelRegister("lGA5q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("goYqM").then(()=>parcelRequire('64wwf'));

});



parcelRegister("8oRL2", function(module, exports) {
$parcel$export(module.exports, "JswNonExpandableProject", () => $89bd612af201a7af$export$cbea0eaf70f0156d);

var $e7boj = parcelRequire("e7boj");

var $3Haex = parcelRequire("3Haex");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $ekhRy = parcelRequire("ekhRy");

var $5IkoH = parcelRequire("5IkoH");

var $aQCoC = parcelRequire("aQCoC");

var $dXmF1 = parcelRequire("dXmF1");

var $dWplX = parcelRequire("dWplX");

var $2v6ed = parcelRequire("2v6ed");

var $fFNvS = parcelRequire("fFNvS");
const $89bd612af201a7af$export$cbea0eaf70f0156d = (t0)=>{
    const $ = (0, $e7boj.c)(38);
    const { projectData: projectData, menuItemAnchorRef: menuItemAnchorRef } = t0;
    const { sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent } = (0, $ekhRy.useProjectsAnalyticsL1)();
    const project = (0, $n67Vb.useFragment)((0, $3Haex.default), projectData);
    project.defaultNavigationItem?.url;
    const t1 = project.defaultNavigationItem?.url ?? `/browse/${project.projectKey}`;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            to: t1,
            prefetch: "hover"
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const routerLinkConfig = t2;
    const { projectId: projectId, projectKey: projectKey, isFavourite: isFavourite, name: name, avatar: avatar } = project;
    const t3 = !!isFavourite;
    let t4;
    if ($[2] !== avatar || $[3] !== isFavourite || $[4] !== name || $[5] !== projectId || $[6] !== projectKey || $[7] !== t3) {
        t4 = {
            projectId: projectId,
            projectKey: projectKey,
            isFavourite: isFavourite,
            name: name,
            avatar: avatar,
            isEnabled: t3
        };
        $[2] = avatar;
        $[3] = isFavourite;
        $[4] = name;
        $[5] = projectId;
        $[6] = projectKey;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    const { state: state, draggableAnchorRef: draggableAnchorRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, dragPreview: dragPreview, hasDragIndicator: hasDragIndicator } = (0, $dWplX.useProjectMenuItemDragAndDrop)(t4);
    const t5 = menuItemAnchorRef || null;
    const t6 = draggableAnchorRef || null;
    let t7;
    if ($[9] !== t5 || $[10] !== t6) {
        t7 = (0, $fFNvS.mergeRefs)(t5, t6);
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    const t8 = state.type === "dragging";
    const t9 = project.avatar.large || "";
    let t10;
    if ($[12] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v6ed.ContainerAvatar), {
            src: t9
        });
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== project.projectKey) {
        t11 = (0, $5IkoH.ENTITY_ID).PROJECT(project.projectKey);
        $[14] = project.projectKey;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== project.isFavourite || $[17] !== project.projectId || $[18] !== project.projectType || $[19] !== sendProjectMenuItemAnalyticsEvent) {
        t12 = ()=>{
            sendProjectMenuItemAnalyticsEvent({
                starred: project.isFavourite ?? false,
                recent: !project.isFavourite,
                projectId: project.projectId,
                projectType: project.projectType
            });
        };
        $[16] = project.isFavourite;
        $[17] = project.projectId;
        $[18] = project.projectType;
        $[19] = sendProjectMenuItemAnalyticsEvent;
        $[20] = t12;
    } else t12 = $[20];
    const t13 = t12;
    let t14;
    if ($[21] !== project) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dXmF1.ProjectActions), {
            projectFragment: project
        });
        $[21] = project;
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== dropIndicator || $[24] !== dropTargetRef || $[25] !== hasDragIndicator || $[26] !== project.name || $[27] !== routerLinkConfig || $[28] !== t10 || $[29] !== t11 || $[30] !== t13 || $[31] !== t14 || $[32] !== t7 || $[33] !== t8) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
            ref: t7,
            visualContentRef: dropTargetRef,
            dropIndicator: dropIndicator,
            isDragging: t8,
            hasDragIndicator: hasDragIndicator,
            elemBefore: t10,
            href: routerLinkConfig,
            menuId: t11,
            onClick: t13,
            actionsOnHover: t14
        }, project.name);
        $[23] = dropIndicator;
        $[24] = dropTargetRef;
        $[25] = hasDragIndicator;
        $[26] = project.name;
        $[27] = routerLinkConfig;
        $[28] = t10;
        $[29] = t11;
        $[30] = t13;
        $[31] = t14;
        $[32] = t7;
        $[33] = t8;
        $[34] = t15;
    } else t15 = $[34];
    let t16;
    if ($[35] !== dragPreview || $[36] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, t15, dragPreview);
        $[35] = dragPreview;
        $[36] = t15;
        $[37] = t16;
    } else t16 = $[37];
    return t16;
};
$89bd612af201a7af$export$cbea0eaf70f0156d.displayName = "JswNonExpandableProject";

});
parcelRegister("3Haex", function(module, exports) {
$parcel$export(module.exports, "default", () => $336e03a09ce4add2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<328288de088f42e4c56dba2f04ac3a31>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $336e03a09ce4add2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JswNonExpandableProject",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW"
                    }
                ]
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraNavigationItem",
                    "abstractKey": "__isJiraNavigationItem"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ProjectActions"
        }
    ],
    "type": "JiraProject"
};
$336e03a09ce4add2$var$node.hash = "1c2cfe3c81902a2ea33e2fc3b9f6c4bb";
var $336e03a09ce4add2$export$2e2bcd8739ae039 = $336e03a09ce4add2$var$node;

});



parcelRegister("kGgTY", function(module, exports) {
$parcel$export(module.exports, "ProjectRestoreContext", () => $fb6ea58efc3fc506$export$bc50e4f0d149dd7c);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");
const $fb6ea58efc3fc506$export$bc50e4f0d149dd7c = /*#__PURE__*/ (0, $euxye.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))));

});

parcelRegister("3jutG", function(module, exports) {
$parcel$export(module.exports, "ContentWithDragAndDrop", () => $add470c70387e5de$export$97d3213e96ec57ec);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jo8j7 = parcelRequire("jo8j7");
function $add470c70387e5de$export$97d3213e96ec57ec({ children: children }) {
    const [shouldRestoreFocus, setShouldRestoreFocus] = (0, $euxye.useState)(false);
    const enableRestoreFocus = (0, $euxye.useCallback)(()=>{
        setShouldRestoreFocus(true);
    }, []);
    const clearRestoreFocus = (0, $euxye.useCallback)(()=>{
        setShouldRestoreFocus(false);
    }, []);
    const contextValue = (0, $euxye.useMemo)(()=>({
            shouldRestoreFocus: shouldRestoreFocus,
            enableRestoreFocus: enableRestoreFocus,
            clearRestoreFocus: clearRestoreFocus
        }), [
        clearRestoreFocus,
        enableRestoreFocus,
        shouldRestoreFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jo8j7.FocusRestorationContext).Provider, {
        value: contextValue
    }, children);
}
$add470c70387e5de$export$97d3213e96ec57ec.displayName = "ContentWithDragAndDrop";

});


parcelRegister("gfpqC", function(module, exports) {
$parcel$export(module.exports, "Nav4ProjectsSections", () => $7950cc90b2979cc3$export$f0f2073bdea7c56e);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $j2avE = parcelRequire("j2avE");

var $lrV75 = parcelRequire("lrV75");

var $8gY0p = parcelRequire("8gY0p");
const $7950cc90b2979cc3$var$Nav4ProjectsSectionsInternal = (t0)=>{
    const $ = (0, $e7boj.c)(12);
    const { favoriteItems: favoriteItems, recentItems: recentItems, mostRecentProjectItem: mostRecentProjectItem, canCreateProject: canCreateProject } = t0;
    let t1;
    if ($[0] !== canCreateProject || $[1] !== favoriteItems) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lrV75.RenderStarredSection), {
            favoriteItems: favoriteItems,
            canCreateProject: canCreateProject
        });
        $[0] = canCreateProject;
        $[1] = favoriteItems;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== canCreateProject || $[4] !== recentItems) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j2avE.RenderRecentSection), {
            recentItems: recentItems,
            canCreateProject: canCreateProject
        });
        $[3] = canCreateProject;
        $[4] = recentItems;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== mostRecentProjectItem) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8gY0p.RenderMostRecentProjectSection), {
            projectItem: mostRecentProjectItem
        });
        $[6] = mostRecentProjectItem;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, t1, t2, t3);
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
};
$7950cc90b2979cc3$var$Nav4ProjectsSectionsInternal.displayName = "Nav4ProjectsSectionsInternal";
const $7950cc90b2979cc3$export$f0f2073bdea7c56e = /*#__PURE__*/ (0, $euxye.memo)($7950cc90b2979cc3$var$Nav4ProjectsSectionsInternal);

});
parcelRegister("j2avE", function(module, exports) {
$parcel$export(module.exports, "RenderRecentSection", () => $9acda5bc945f93a3$export$d2b3549b269002a1);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $6Qg24 = parcelRequire("6Qg24");


var $djYhH = parcelRequire("djYhH");

var $ar9gx = parcelRequire("ar9gx");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $9acda5bc945f93a3$var$recent = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.recent",
    defaultMessage: "Recent"
});
function $9acda5bc945f93a3$export$d2b3549b269002a1(t0) {
    const $ = (0, $e7boj.c)(8);
    const { recentItems: recentItems, canCreateProject: canCreateProject } = t0;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { sendProjectMenuContentSectionAnalyticsEvent: sendProjectMenuContentSectionAnalyticsEvent } = (0, $6Qg24.useProjectsAnalyticsL2)();
    let t1;
    let t2;
    if ($[0] !== canCreateProject || $[1] !== sendProjectMenuContentSectionAnalyticsEvent) {
        t1 = ()=>{
            sendProjectMenuContentSectionAnalyticsEvent({
                projectSection: (0, $615be7bb373efe0b$export$66f42658510ce4ab),
                canCreateProject: canCreateProject
            });
        };
        t2 = [
            canCreateProject,
            sendProjectMenuContentSectionAnalyticsEvent
        ];
        $[0] = canCreateProject;
        $[1] = sendProjectMenuContentSectionAnalyticsEvent;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $euxye.useEffect)(t1, t2);
    let t3;
    if ($[4] !== formatMessage || $[5] !== recentItems.hasItems || $[6] !== recentItems.list) {
        t3 = recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), {
            testId: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.recent-section.recent-section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($9acda5bc945f93a3$var$recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, recentItems.list)));
        $[4] = formatMessage;
        $[5] = recentItems.hasItems;
        $[6] = recentItems.list;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
}
$9acda5bc945f93a3$export$d2b3549b269002a1.displayName = "RenderRecentSection";

});
/* eslint-disable jira/filename-case */ const $615be7bb373efe0b$export$3086f5b2b9faf5ae = 'starred';
const $615be7bb373efe0b$export$66f42658510ce4ab = 'recent';


parcelRegister("lrV75", function(module, exports) {
$parcel$export(module.exports, "RenderStarredSection", () => $08d0813aa825e4bf$export$e2cc6b3e240d5148);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $5IkoH = parcelRequire("5IkoH");

var $aQCoC = parcelRequire("aQCoC");

var $1syth = parcelRequire("1syth");

var $6Qg24 = parcelRequire("6Qg24");


var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $ar9gx = parcelRequire("ar9gx");

var $djYhH = parcelRequire("djYhH");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $08d0813aa825e4bf$var$starred = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.starred",
    defaultMessage: "Starred"
});
const $08d0813aa825e4bf$var$viewAllStarred = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.view-all-starred",
    defaultMessage: "View all starred"
});
const $08d0813aa825e4bf$var$viewAllStarredSpaces = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.view-all-starred-spaces",
    defaultMessage: "View all starred spaces"
});
const $08d0813aa825e4bf$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
const $08d0813aa825e4bf$var$VIEW_ALL_STARRED_PROJECTS_HREF = '/jira/projects?sortKey=favourite&sortOrder=DESC';
function $08d0813aa825e4bf$export$e2cc6b3e240d5148(t0) {
    const $ = (0, $e7boj.c)(9);
    const { favoriteItems: favoriteItems, canCreateProject: canCreateProject } = t0;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { sendProjectMenuContentSectionAnalyticsEvent: sendProjectMenuContentSectionAnalyticsEvent } = (0, $6Qg24.useProjectsAnalyticsL2)();
    let t1;
    let t2;
    if ($[0] !== canCreateProject || $[1] !== sendProjectMenuContentSectionAnalyticsEvent) {
        t1 = ()=>{
            sendProjectMenuContentSectionAnalyticsEvent({
                projectSection: (0, $615be7bb373efe0b$export$3086f5b2b9faf5ae),
                canCreateProject: canCreateProject
            });
        };
        t2 = [
            canCreateProject,
            sendProjectMenuContentSectionAnalyticsEvent
        ];
        $[0] = canCreateProject;
        $[1] = sendProjectMenuContentSectionAnalyticsEvent;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $euxye.useEffect)(t1, t2);
    let t3;
    if ($[4] !== favoriteItems.hasItems || $[5] !== favoriteItems.hasNextPage || $[6] !== favoriteItems.list || $[7] !== formatMessage) {
        t3 = favoriteItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1syth.ProjectsDroppableGroupIndicator), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), {
            testId: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.starred-section.starred-section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($08d0813aa825e4bf$var$starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, favoriteItems.list))), favoriteItems.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
            href: (0, $2700E.expVal)("jjj5-cosmos-navigation", "isEnabled", false) ? $08d0813aa825e4bf$var$VIEW_ALL_STARRED_PROJECTS_HREF : $08d0813aa825e4bf$var$VIEW_ALL_STARRED_HREF,
            menuId: (0, $5IkoH.MENU_ID_PROJECTS_VIEW_ALL_STARRED)
        }, formatMessage((0, $2700E.expVal)("jjj5-cosmos-navigation", "isEnabled", false) ? $08d0813aa825e4bf$var$viewAllStarredSpaces : $08d0813aa825e4bf$var$viewAllStarred)));
        $[4] = favoriteItems.hasItems;
        $[5] = favoriteItems.hasNextPage;
        $[6] = favoriteItems.list;
        $[7] = formatMessage;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
}
$08d0813aa825e4bf$export$e2cc6b3e240d5148.displayName = "RenderStarredSection";

});
parcelRegister("1syth", function(module, exports) {
$parcel$export(module.exports, "ProjectsDroppableGroupIndicator", () => $2f564051b04ae33a$export$2fb821b6490fad6e);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4uPjr = parcelRequire("4uPjr");

var $dCnIn = parcelRequire("dCnIn");
const $2f564051b04ae33a$export$2fb821b6490fad6e = (props)=>{
    const { children: children } = props;
    const dropTarget = (0, $dCnIn.useDropTargetForProjects)();
    const { ref: ref, state: state } = dropTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4uPjr.GroupDropIndicator), {
        isActive: state === 'is-over',
        ref: ref
    }, children);
};
$2f564051b04ae33a$export$2fb821b6490fad6e.displayName = "ProjectsDroppableGroupIndicator";

});
parcelRegister("dCnIn", function(module, exports) {
$parcel$export(module.exports, "useDropTargetForProjects", () => $5d0b6bc72b2081b0$export$bf27ec69454698cb);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3nfFb = parcelRequire("3nfFb");

var $ijI7P = parcelRequire("ijI7P");

var $6rsYi = parcelRequire("6rsYi");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $enaee = parcelRequire("enaee");


var $5V8K3 = parcelRequire("5V8K3");

var $3mtaC = parcelRequire("3mtaC");
const $5d0b6bc72b2081b0$export$bf27ec69454698cb = ()=>{
    const ref = (0, $euxye.useRef)(null);
    const [state, setState] = (0, $euxye.useState)();
    const updateFavouriteOrder = (0, $5V8K3.useUpdateFavouriteOrder)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({});
    (0, $euxye.useEffect)(()=>{
        const element = ref.current;
        // might have no projects
        if (!element) return;
        return (0, $3nfFb.dropTargetForElements)({
            element: element,
            canDrop: ({ source: source })=>{
                return (0, $enaee.isDraggableProject)(source.data);
            },
            onDragStart ({ source: source }) {
                setState('is-over');
                const dragging = source.data;
                (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, {
                    ...(0, $3mtaC.ANALYTIC_PAYLOAD).DRAG_STARTED,
                    attributes: {
                        ...(0, $3mtaC.ANALYTIC_PAYLOAD).ATTRIBUTES,
                        itemId: dragging.id
                    }
                });
            },
            onDragEnter ({ source: source }) {
                setState('is-over');
                const dragging = source.data;
                (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, {
                    ...(0, $3mtaC.ANALYTIC_PAYLOAD).DRAG_ENTERED,
                    attributes: {
                        ...(0, $3mtaC.ANALYTIC_PAYLOAD).ATTRIBUTES,
                        itemId: dragging.id
                    }
                });
            },
            onDragLeave ({ source: source }) {
                setState('idle');
                const dragging = source.data;
                (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, {
                    ...(0, $3mtaC.ANALYTIC_PAYLOAD).DRAG_LEFT,
                    attributes: {
                        ...(0, $3mtaC.ANALYTIC_PAYLOAD).ATTRIBUTES,
                        itemId: dragging.id
                    }
                });
            },
            onDrop ({ source: source, location: location }) {
                setState('idle');
                let successfulReorder = false;
                const dragging = source.data;
                const [innerMost] = location.current.dropTargets;
                const dropTargetData = innerMost.data;
                if (!(0, $enaee.isDraggableProject)(dragging) || !(0, $enaee.isDraggableProject)(dropTargetData)) {
                    (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, {
                        ...(0, $3mtaC.ANALYTIC_PAYLOAD).DRAG_ENDED,
                        attributes: {
                            ...(0, $3mtaC.ANALYTIC_PAYLOAD).ATTRIBUTES,
                            itemId: dragging.id,
                            successfulReorder: successfulReorder
                        }
                    });
                    return;
                }
                const instruction = (0, $6rsYi.extractInstruction)(dropTargetData);
                const operation = instruction && $5d0b6bc72b2081b0$var$instructionToOperation(instruction);
                if (operation) {
                    updateFavouriteOrder(operation, dragging.id, dropTargetData.id);
                    successfulReorder = true;
                    if (!source.element) return;
                    (0, $ijI7P.triggerPostMoveFlash)(source.element);
                }
                (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, {
                    ...(0, $3mtaC.ANALYTIC_PAYLOAD).DRAG_ENDED,
                    attributes: {
                        ...(0, $3mtaC.ANALYTIC_PAYLOAD).ATTRIBUTES,
                        itemId: dragging.id,
                        successfulReorder: successfulReorder
                    }
                });
            }
        });
    });
    return {
        ref: ref,
        state: state
    };
};
const $5d0b6bc72b2081b0$var$instructionToOperation = (instruction)=>{
    switch(instruction?.operation){
        case 'reorder-before':
            return 0, $64b535ea8d9765d9$export$4cff6e48b6cc73b5;
        case 'reorder-after':
            return 0, $64b535ea8d9765d9$export$e0420f7fed62e74b;
        default:
            return null;
    }
};

});
parcelRegister("enaee", function(module, exports) {
$parcel$export(module.exports, "isDraggableProject", () => $2037bff55191ecbb$export$1338b07381f36262);
/* eslint-disable jira/filename-case */ 
var $3mtaC = parcelRequire("3mtaC");
const $2037bff55191ecbb$export$1338b07381f36262 = (data)=>{
    return Boolean(data.type === (0, $3mtaC.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP));
};

});

/* eslint-disable jira/filename-case */ const $64b535ea8d9765d9$export$5ff59e4f08b9b299 = 'MOVE_TO_TOP';
const $64b535ea8d9765d9$export$9964b4a63620a911 = 'MOVE_UP';
const $64b535ea8d9765d9$export$2692a384035c5ef7 = 'MOVE_DOWN';
const $64b535ea8d9765d9$export$a5a45050b97fca24 = 'MOVE_TO_BOTTOM';
const $64b535ea8d9765d9$export$e0420f7fed62e74b = 'AFTER';
const $64b535ea8d9765d9$export$4cff6e48b6cc73b5 = 'BEFORE';

parcelRegister("5V8K3", function(module, exports) {
$parcel$export(module.exports, "useUpdateFavouriteOrder", () => $5024221c62fc90d5$export$63ac7262a5a1464f);

var $ksEyb = parcelRequire("ksEyb");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $fMgNj = parcelRequire("fMgNj");

var $kt86l = parcelRequire("kt86l");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $3mtaC = parcelRequire("3mtaC");

var $faL4K = parcelRequire("faL4K");

var $g4Pqo = parcelRequire("g4Pqo");

var $fyh8T = parcelRequire("fyh8T");
const $5024221c62fc90d5$export$63ac7262a5a1464f = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [commitMutation] = (0, $n67Vb.useMutation)((0, $ksEyb.default));
    const handleError = (0, $g4Pqo.useHandleError)();
    const updateFavouriteOrder = (0, $euxye.useCallback)((operation, projectId, relativeProjectId)=>{
        commitMutation({
            variables: {
                input: {
                    cloudId: cloudId,
                    reorderMode: operation,
                    menuItem: {
                        // eslint-disable-next-line jira/relay/mutation-variables-from-relay-data
                        itemId: projectId
                    },
                    // include relative menu item if provided
                    ...relativeProjectId && {
                        relativeMenuItem: {
                            itemId: relativeProjectId
                        }
                    }
                }
            },
            optimisticUpdater: (store)=>{
                (0, $fyh8T.optimisticUpdater)(store, operation, projectId, cloudId, relativeProjectId);
            },
            onCompleted: (_, errors)=>{
                if (errors && errors.length > 0) {
                    const error = new (0, $fMgNj.MutationError)(errors[0]);
                    handleError(error);
                } else {
                    const analyticsEvent = createAnalyticsEvent({});
                    (0, $aJ81Y.fireTrackAnalytics)(analyticsEvent, {
                        ...(0, $3mtaC.ANALYTIC_PAYLOAD).UPDATED_ORDER,
                        attributes: {
                            ...(0, $3mtaC.ANALYTIC_PAYLOAD).ATTRIBUTES,
                            itemId: projectId,
                            action: (0, $faL4K.menuItemReorderOperationToAction)(operation)
                        }
                    });
                }
            },
            onError: (error)=>{
                handleError(new (0, $fMgNj.MutationError)(error));
            }
        });
    }, [
        commitMutation,
        cloudId,
        handleError,
        createAnalyticsEvent
    ]);
    return updateFavouriteOrder;
};

});
parcelRegister("ksEyb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8e27674afb4cac1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<98e8c28d1e4ef6c45f8b1502a5ac003e>>
 * @relayHash 9d91aa3f7becae583ad5408383448d07
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 098bb25886a095ee63c8d5d3d6af5c1ecd65df43231a6e25010a867de02103e7

var $25bhx = parcelRequire("25bhx");

var $fpAD9 = parcelRequire("fpAD9");
const $d8e27674afb4cac1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 15
        }
    ], v4 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v5 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateFavouriteOrderMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "Nav4ProjectMenuItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx"
                }
            ],
            "kind": "Operation",
            "name": "useUpdateFavouriteOrderMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "large"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "defaultNavigationItem",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "url"
                                                                }
                                                            ],
                                                            "type": "JiraNavigationItem",
                                                            "abstractKey": "__isJiraNavigationItem"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v2 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "softwareBoardCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "alias": "subspaceCount",
                                                                    "kind": "ScalarField",
                                                                    "name": "subspaceCount_cse"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "098bb25886a095ee63c8d5d3d6af5c1ecd65df43231a6e25010a867de02103e7",
            "metadata": {},
            "name": "useUpdateFavouriteOrderMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": (0, $fpAD9.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx": (0, $25bhx.default)
            }
        }
    };
}();
$d8e27674afb4cac1$var$node.hash = "66de2e69da219bee3821eec0cafe8fb9";
var $d8e27674afb4cac1$export$2e2bcd8739ae039 = $d8e27674afb4cac1$var$node;

});

parcelRegister("faL4K", function(module, exports) {
$parcel$export(module.exports, "menuItemReorderOperationToAction", () => $720ef2b799311d3b$export$8357c82608ac73da);
/* eslint-disable jira/filename-case */ 
const $720ef2b799311d3b$export$8357c82608ac73da = (operation)=>{
    switch(operation){
        case 0, $64b535ea8d9765d9$export$5ff59e4f08b9b299:
            return 'moveToTop';
        case 0, $64b535ea8d9765d9$export$9964b4a63620a911:
            return 'moveUp';
        case 0, $64b535ea8d9765d9$export$2692a384035c5ef7:
            return 'moveDown';
        case 0, $64b535ea8d9765d9$export$a5a45050b97fca24:
            return 'moveToBottom';
        case 0, $64b535ea8d9765d9$export$e0420f7fed62e74b:
            return 'dragged';
        case 0, $64b535ea8d9765d9$export$4cff6e48b6cc73b5:
            return 'dragged';
        default:
            return '';
    }
};

});

parcelRegister("g4Pqo", function(module, exports) {
$parcel$export(module.exports, "useHandleError", () => $ce29bce6a0e63b16$export$7ab84fea33af0d21);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $iQPOZ = parcelRequire("iQPOZ");

var $7eNDO = parcelRequire("7eNDO");

var $3mtaC = parcelRequire("3mtaC");
const $ce29bce6a0e63b16$var$defaultErrorMessage = (0, $7eNDO.defineMessage)({
    id: "jira-navigation-apps-sidebar-nav4-projects-customise-order.default-error-message",
    defaultMessage: "Check your connection and try again."
});
const $ce29bce6a0e63b16$var$defaultErrorTitle = (0, $7eNDO.defineMessage)({
    id: "jira-navigation-apps-sidebar-nav4-projects-customise-order.default-error-title",
    defaultMessage: "We couldn't update your view."
});
const $ce29bce6a0e63b16$var$FLAG = {
    type: 'error',
    title: $ce29bce6a0e63b16$var$defaultErrorTitle,
    description: $ce29bce6a0e63b16$var$defaultErrorMessage,
    // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
    messageId: 'navigation-apps-sidebar-nav4-projects-customise-order.services.update-favourite-order.flag.error',
    messageType: 'transactional'
};
function $ce29bce6a0e63b16$export$7ab84fea33af0d21() {
    const { showFlag: showFlag } = (0, $iQPOZ.useFlagsService)();
    const handleError = (0, $euxye.useCallback)((error)=>{
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'useUpdateFavouriteOrder',
                packageName: (0, $3mtaC.PACKAGE_NAME),
                teamName: (0, $3mtaC.TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag($ce29bce6a0e63b16$var$FLAG);
    }, [
        showFlag
    ]);
    return handleError;
}

});

parcelRegister("fyh8T", function(module, exports) {
$parcel$export(module.exports, "optimisticUpdater", () => $e307f03cc45c028c$export$32fd5c97e0eb451);
/* eslint-disable jira/filename-case */ 
var $i9VOW = parcelRequire("i9VOW");
function $e307f03cc45c028c$export$32fd5c97e0eb451(store, operation, targetProjectId, cloudId, relativeProjectId) {
    const sidebarMenuRecord = store.getRoot().getLinkedRecord('jira_projectsSidebarMenu', {
        cloudId: cloudId
    });
    const favoriteConnection = sidebarMenuRecord && sidebarMenuRecord.getLinkedRecord('favourites', {
        first: 15
    });
    if (!favoriteConnection) return;
    const edges = favoriteConnection.getLinkedRecords('edges') ?? [];
    if (!edges.length || edges.length <= 1) return;
    const projectIdToEdgeMap = edges.reduce((map, edge)=>{
        const projectId = edge.getLinkedRecord('node')?.getValue('projectId')?.toString();
        return projectId ? map.set(projectId, edge) : map;
    }, new Map());
    const projectIds = Array.from(projectIdToEdgeMap.keys());
    const sortedProjectIds = (0, $i9VOW.reorder)(operation, projectIds, targetProjectId, relativeProjectId);
    const sortedEdges = sortedProjectIds.map((projectId)=>projectIdToEdgeMap.get(projectId) ?? null);
    favoriteConnection.setLinkedRecords(sortedEdges, 'edges');
}

});
parcelRegister("i9VOW", function(module, exports) {
$parcel$export(module.exports, "reorder", () => $5ab0068f5815d7f4$export$fc77a6137e3f91c);
/* eslint-disable jira/filename-case */ 
const $5ab0068f5815d7f4$export$f2c5cc4c3f787c3e = (projectsList, projectId)=>{
    const filteredList = projectsList.filter((id)=>id !== projectId);
    return [
        projectId,
        ...filteredList
    ];
};
const $5ab0068f5815d7f4$export$8ff471d483515a76 = (projectsList, projectId)=>{
    const filteredList = projectsList.filter((id)=>id !== projectId);
    return [
        ...filteredList,
        projectId
    ];
};
const $5ab0068f5815d7f4$export$44935f8a884b57b9 = (projectsList, projectId)=>{
    const index = projectsList.indexOf(projectId);
    if (index > 0) {
        const newList = [
            ...projectsList
        ];
        newList.splice(index, 1);
        newList.splice(index - 1, 0, projectId);
        return newList;
    }
    return projectsList;
};
const $5ab0068f5815d7f4$export$8eba228b343b3599 = (projectsList, projectId)=>{
    const index = projectsList.indexOf(projectId);
    if (index >= 0) {
        const newList = [
            ...projectsList
        ];
        newList.splice(index, 1);
        newList.splice(index + 1, 0, projectId);
        return newList;
    }
    return projectsList;
};
const $5ab0068f5815d7f4$export$86b68c7dbeb53c22 = (projectsList, projectId, relativeProject)=>{
    const index = projectsList.indexOf(relativeProject);
    if (index >= 0) {
        const filteredList = projectsList.filter((id)=>id !== projectId);
        const newList = [
            ...filteredList
        ];
        newList.splice(filteredList.indexOf(relativeProject), 0, projectId);
        return newList;
    }
    return projectsList;
};
const $5ab0068f5815d7f4$export$c4f94c8b3850a5a9 = (projectsList, projectId, relativeProject)=>{
    const index = projectsList.indexOf(relativeProject);
    if (index >= 0) {
        const filteredList = projectsList.filter((id)=>id !== projectId);
        const newList = [
            ...filteredList
        ];
        newList.splice(filteredList.indexOf(relativeProject) + 1, 0, projectId);
        return newList;
    }
    return projectsList;
};
const $5ab0068f5815d7f4$export$4583b779aad6d7dc = (projectsList, projectId)=>{
    return [
        projectId,
        ...projectsList
    ];
};
const $5ab0068f5815d7f4$export$a7bc06cf61a60193 = (projectsList, projectId)=>{
    return [
        ...projectsList,
        projectId
    ];
};
const $5ab0068f5815d7f4$export$fc77a6137e3f91c = (operation, projectIds, projectId, relativeId)=>{
    switch(operation){
        case 0, $64b535ea8d9765d9$export$5ff59e4f08b9b299:
            return $5ab0068f5815d7f4$export$f2c5cc4c3f787c3e(projectIds, projectId);
        case 0, $64b535ea8d9765d9$export$9964b4a63620a911:
            return $5ab0068f5815d7f4$export$44935f8a884b57b9(projectIds, projectId);
        case 0, $64b535ea8d9765d9$export$2692a384035c5ef7:
            return $5ab0068f5815d7f4$export$8eba228b343b3599(projectIds, projectId);
        case 0, $64b535ea8d9765d9$export$a5a45050b97fca24:
            return $5ab0068f5815d7f4$export$8ff471d483515a76(projectIds, projectId);
        case 0, $64b535ea8d9765d9$export$4cff6e48b6cc73b5:
            return relativeId ? $5ab0068f5815d7f4$export$86b68c7dbeb53c22(projectIds, projectId, relativeId) : projectIds;
        case 0, $64b535ea8d9765d9$export$e0420f7fed62e74b:
            return relativeId ? $5ab0068f5815d7f4$export$c4f94c8b3850a5a9(projectIds, projectId, relativeId) : projectIds;
        default:
            return projectIds;
    }
};

});






parcelRegister("8gY0p", function(module, exports) {
$parcel$export(module.exports, "RenderMostRecentProjectSection", () => $dcbf4cbcbd61a4e6$export$6269b4a1c127cf98);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $ar9gx = parcelRequire("ar9gx");

var $6w18e = parcelRequire("6w18e");

var $djYhH = parcelRequire("djYhH");
const $dcbf4cbcbd61a4e6$export$6269b4a1c127cf98 = (t0)=>{
    const $ = (0, $e7boj.c)(2);
    const { projectItem: projectItem } = t0;
    let t1;
    if ($[0] !== projectItem) {
        t1 = !!projectItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), {
            testId: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.most-recent-project-section.most-recent-project-section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, projectItem)));
        $[0] = projectItem;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
$dcbf4cbcbd61a4e6$export$6269b4a1c127cf98.displayName = "RenderMostRecentProjectSection";

});






parcelRegister("j951J", function(module, exports) {
$parcel$export(module.exports, "Recent", () => $063f5535ac064b6e$export$1147d6e1036afec);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $gDdYI = parcelRequire("gDdYI");


var $7GX3H = parcelRequire("7GX3H");
const $063f5535ac064b6e$export$1147d6e1036afec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-recent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "flag",
        id: "recent",
        packageName: (0, $b10cfeab38ca86b5$export$b8b9d90f9e5bd72b),
        teamName: (0, $b10cfeab38ca86b5$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7GX3H.RecentMenu), null)));
$063f5535ac064b6e$export$1147d6e1036afec.displayName = "Recent";

});
/* eslint-disable jira/filename-case */ const $b10cfeab38ca86b5$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Recent';
const $b10cfeab38ca86b5$export$d57b6b390e78d90f = 'jira-cosmos';
const $b10cfeab38ca86b5$export$56ff071570537731 = 15;
const $b10cfeab38ca86b5$export$fe791c4fa892e400 = 'PROJECT';
const $b10cfeab38ca86b5$export$c303e491e026ebc6 = 'PLAN';
const $b10cfeab38ca86b5$export$c1c49903035a02df = 'FILTER';
const $b10cfeab38ca86b5$export$dcd4d5ae3bbf4efe = 'JPD_COLLECTION';
const $b10cfeab38ca86b5$export$4695c1a423ffe431 = 'DASHBOARD';
const $b10cfeab38ca86b5$export$9b8283d5878d2491 = 'BOARD';
const $b10cfeab38ca86b5$export$5828682c822c26e7 = 'QUEUE';
const $b10cfeab38ca86b5$export$76a449e52fa0e1e8 = 'ISSUE';
const $b10cfeab38ca86b5$export$fd6cd74eeb4b51a7 = 'searchRecentItems';
const $b10cfeab38ca86b5$export$f91d73dc0ffb6584 = 'viewAllRecentItems';
const $b10cfeab38ca86b5$export$ee6bbe0a973ca0e8 = 'today';
const $b10cfeab38ca86b5$export$91c1c08ffbb5f1be = 'yesterday';
const $b10cfeab38ca86b5$export$4bada75a9cb45bec = 'thisWeek';
const $b10cfeab38ca86b5$export$1385d821597ee807 = 'thisMonth';
const $b10cfeab38ca86b5$export$d64d14c448d5a065 = 'moreThanAMonth';

parcelRegister("7GX3H", function(module, exports) {
$parcel$export(module.exports, "RecentMenu", () => $07ec4ec3fd146b98$export$9051cd0d0927b696);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6ouZy = parcelRequire("6ouZy");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");


var $bOwox = parcelRequire("bOwox");

var $ggvFe = parcelRequire("ggvFe");

var $6GljB = parcelRequire("6GljB");

var $gEDfa = parcelRequire("gEDfa");

var $KL7Bq = parcelRequire("KL7Bq");

var $4U30j = parcelRequire("4U30j");
var $iozCP = parcelRequire("iozCP");
var $02ogW = parcelRequire("02ogW");

var $3xiQi = parcelRequire("3xiQi");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $kt86l = parcelRequire("kt86l");

var $7eNDO = parcelRequire("7eNDO");


var $gOK4T = parcelRequire("gOK4T");
const $07ec4ec3fd146b98$var$recent = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-recent.recent",
    defaultMessage: "Recent"
});
const $07ec4ec3fd146b98$var$EMPTY_OBJECT = {};
function $07ec4ec3fd146b98$export$9051cd0d0927b696() {
    const cloudId = (0, $kt86l.useCloudId)();
    const { formattedMessage: formattedMessage, icon: icon } = (0, $KL7Bq.useFormattedMessageAndIcon)($07ec4ec3fd146b98$var$recent, (0, (/*@__PURE__*/$parcel$interopDefault($3xiQi))));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $gOK4T.sidebarRecentMenuEntryPoint), (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            count: (0, $b10cfeab38ca86b5$export$56ff071570537731)
        }), [
        cloudId
    ]));
    const triggerRef = (0, $6ouZy.useEntryPointButtonTrigger)(entryPointActions);
    const { moreMenuIds: moreMenuIds } = (0, $euxye.useContext)((0, $ggvFe.NavItemsContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const onOpenChange = (0, $euxye.useCallback)((isMenuOpen)=>{
        if (isMenuOpen) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $6GljB.L1_MENU_ID).RECENT);
            (0, $aJ81Y.fireUIAnalytics)(event, (0, $bOwox.SECTION_ITEM_RECENT), {
                isInMore: isInMore
            });
        }
    }, [
        moreMenuIds,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4U30j.FlyoutMenuItem), {
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $02ogW.FlyoutMenuItemTrigger), {
        interactionName: "nav4-sidebar-recent",
        ref: triggerRef,
        elemBefore: icon
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iozCP.FlyoutMenuItemContent), {
        maxHeight: (0, $i860n.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? 460 : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "nav4-sidebar-recent-default",
        packageName: (0, $b10cfeab38ca86b5$export$b8b9d90f9e5bd72b),
        teamName: (0, $b10cfeab38ca86b5$export$d57b6b390e78d90f),
        errorFallback: "flag",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), {
            withHeading: true,
            withSearch: true,
            withSubHeading: true,
            withSubTitle: true,
            isFlyout: true
        }),
        runtimeProps: $07ec4ec3fd146b98$var$EMPTY_OBJECT
    })));
}
$07ec4ec3fd146b98$export$9051cd0d0927b696.displayName = "RecentMenu";

});
parcelRegister("gOK4T", function(module, exports) {
$parcel$export(module.exports, "sidebarRecentMenuEntryPoint", () => $441a2e486af68350$export$52be5f9ca0100885);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $eIrBi = parcelRequire("eIrBi");

const $441a2e486af68350$export$52be5f9ca0100885 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("i0b1K")), {
        moduleId: "c490a11e",
        moduleName: "RecentMenuWithAnalytic",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, count: count })=>({
            queries: {
                recentMenuData: {
                    parameters: $eIrBi.default,
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        count: count,
                        keyword: ''
                    }
                }
            }
        })
});

});
parcelRegister("eIrBi", function(module, exports) {
$parcel$export(module.exports, "default", () => $4755bc99619dfa7e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<80b14dd2ff3a4471c838ec9097c9116c>>
 * @relayHash f3c952de09fc76e5ee6e1ce2c3c2650a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 08845a0b487cfc3ae6b4d57055a9e1ae5e4d7e1b99be8298a0d2957aa28283be

var $kSjiz = parcelRequire("kSjiz");

var $lIGkE = parcelRequire("lIGkE");
const $4755bc99619dfa7e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "keyword"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "fields": [
            {
                "kind": "Variable",
                "name": "keyword",
                "variableName": "keyword"
            }
        ],
        "kind": "ObjectValue",
        "name": "filter"
    }, v5 = {
        "kind": "Literal",
        "name": "types",
        "value": [
            "PROJECT",
            "FILTER",
            "DASHBOARD",
            "BOARD",
            "QUEUE",
            "ISSUE",
            "PLAN",
            "JPD_COLLECTION"
        ]
    }, v6 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        v5 /*: any*/ 
    ], v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v8 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        v5 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v10 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = [
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": "filterName",
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterId"
                }
            ],
            "type": "JiraFilter",
            "abstractKey": "__isJiraFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RecentMenuWithAnalyticQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "recent",
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v7 /*: any*/ ,
                                            "action": "THROW"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "RecentMenuWithAnalytic"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled"
                }
            ],
            "kind": "Operation",
            "name": "RecentMenuWithAnalyticQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "recent",
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "issueWebUrl",
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v12 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        }
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "alias": "roadmapName",
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "emoji"
                                                                }
                                                            ],
                                                            "type": "JiraProductDiscoveryCollection"
                                                        }
                                                    ]
                                                },
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v8 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "types",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "RecentMenuContent__recentItems",
                            "kind": "LinkedHandle",
                            "name": "recentItems"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "08845a0b487cfc3ae6b4d57055a9e1ae5e4d7e1b99be8298a0d2957aa28283be",
            "metadata": {},
            "name": "RecentMenuWithAnalyticQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled": (0, $kSjiz.default)
            }
        }
    };
}();
$4755bc99619dfa7e$var$node.hash = "3419b3b56f8e1131710f1858357f2538";
(0, $lIGkE.PreloadableQueryRegistry).set($4755bc99619dfa7e$var$node.params.id, $4755bc99619dfa7e$var$node);
var $4755bc99619dfa7e$export$2e2bcd8739ae039 = $4755bc99619dfa7e$var$node;

});

parcelRegister("i0b1K", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a8hGW").then(()=>parcelRequire('a5MyY'));

});




parcelRegister("4S9lF", function(module, exports) {
$parcel$export(module.exports, "Nav4Roadmaps", () => $0eedf5fcfd951859$export$257bbde911c73386);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $gEDfa = parcelRequire("gEDfa");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $2UM84 = parcelRequire("2UM84");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $i860n = parcelRequire("i860n");

var $b1YRJ = parcelRequire("b1YRJ");

var $aLQYs = parcelRequire("aLQYs");

var $78GR0 = parcelRequire("78GR0");

var $aayMc = parcelRequire("aayMc");

var $2wODd = parcelRequire("2wODd");

/**
 *
 * The continued usage of RLL goes against the guidance given to teams that implemented Nav4:
 * "Do not use RLL. Use entrypoints instead."
 *
 * See https://go/entrypoints-migration-runbook
 *
 * Due to the recent SSR & performance changes made to this module, more consulting is needed with
 * the Magma before it can be fully removed.
 */ const $0eedf5fcfd951859$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("fwm0V")).then(({ Nav4RoadmapsContainer: Nav4RoadmapsContainer })=>Nav4RoadmapsContainer), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-content-roadmaps/src/ui/roadmaps/index.tsx"
});
const $0eedf5fcfd951859$var$EMPTY_EP_PARAMS = {};
const $0eedf5fcfd951859$export$257bbde911c73386 = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    const { isExpanded: isExpanded, ...dndProps } = props;
    const isCollectionSelected = (0, $78GR0.useIsCollectionSelected)();
    const isExpandedValue = (0, $i860n.fg)('navx-global-side-nav') ? !!dndProps.isExpandOrFlyoutOpen && isExpanded : isExpanded;
    const [localIsExpanded, setLocalIsExpanded] = (0, $aayMc.useLocalIsExpanded)(isExpandedValue);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $2wODd.asyncActionButtons), $0eedf5fcfd951859$var$EMPTY_EP_PARAMS);
    const triggerRef = (0, $2UM84.useHoverEntryPointTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.roadmaps",
        packageName: (0, $b1YRJ.PACKAGE_NAME),
        teamName: (0, $b1YRJ.TEAM_NAME),
        ufoName: "nav4-sidebar-roadmaps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aLQYs.RoadmapsStatic), {
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-sidebar-roadmaps-action-menu",
            packageName: (0, $b1YRJ.PACKAGE_NAME),
            errorFallback: "flag",
            teamName: (0, $b1YRJ.TEAM_NAME),
            runtimeProps: $0eedf5fcfd951859$var$EMPTY_EP_PARAMS
        }),
        isExpanded: localIsExpanded,
        onExpansionToggle: setLocalIsExpanded,
        triggerRef: triggerRef,
        ...dndProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4-sidebar-roadmaps",
        fallback: isCollectionSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0eedf5fcfd951859$var$LazySidebarContent, {
        isExpanded: localIsExpanded,
        ...dndProps
    }))));
});

});
parcelRegister("b1YRJ", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $f7044ff569cb5177$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $f7044ff569cb5177$export$d57b6b390e78d90f);
$parcel$export(module.exports, "VIEW_ALL_ROADMAPS", () => $f7044ff569cb5177$export$3fc15b6d7f7757ac);
$parcel$export(module.exports, "CREATE_ROADMAP", () => $f7044ff569cb5177$export$862abc666c31a61a);
$parcel$export(module.exports, "MEATBALL_DROPDOWN", () => $f7044ff569cb5177$export$f06dfcec5ff912e);
$parcel$export(module.exports, "PERMISSIONS_CACHE_TTL", () => $f7044ff569cb5177$export$5448370085586a5f);
/* eslint-disable jira/filename-case */ const $f7044ff569cb5177$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Roadmaps';
const $f7044ff569cb5177$export$d57b6b390e78d90f = 'jpd-aurora';
const $f7044ff569cb5177$export$3fc15b6d7f7757ac = 'viewAllRoadmaps';
const $f7044ff569cb5177$export$862abc666c31a61a = 'createRoadmaps';
const $f7044ff569cb5177$export$f06dfcec5ff912e = 'meatballDropdown';
const $f7044ff569cb5177$export$5448370085586a5f = 600000; // 10 minutes

});

parcelRegister("aLQYs", function(module, exports) {
$parcel$export(module.exports, "RoadmapsStatic", () => $5d4f112b9bb9c33b$export$4c4071eb62c5e1cf);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gA92M = parcelRequire("gA92M");

var $eYbIq = parcelRequire("eYbIq");

var $9pOfV = parcelRequire("9pOfV");

var $aOGXw = parcelRequire("aOGXw");

var $cee3w = parcelRequire("cee3w");

var $bOwox = parcelRequire("bOwox");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $4VtOS = parcelRequire("4VtOS");

var $jzXAj = parcelRequire("jzXAj");

var $3rqDf = parcelRequire("3rqDf");

var $dx7aH = parcelRequire("dx7aH");

var $jepRN = parcelRequire("jepRN");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $fFNvS = parcelRequire("fFNvS");

var $78GR0 = parcelRequire("78GR0");

var $7RdH9 = parcelRequire("7RdH9");
const $5d4f112b9bb9c33b$var$RoadmapsStaticGSN = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    const { actionsOnHover: actionsOnHover, children: children, draggableRef: draggableRef, dropIndicator: dropIndicator, hasDragIndicator: hasDragIndicator, isDragging: isDragging, isExpanded: isExpanded, onExpansionToggle: onExpansionToggle, onExpandFlyoutToggle: onExpandFlyoutToggle, triggerRef: triggerRef, visualContentRef: visualContentRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).ROADMAPS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const isJpdProjectView = (0, $78GR0.useIsJpdProjectView)();
    const handleExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        onExpansionToggle?.(hasExpanded);
        if (hasExpanded) sendSectionItemAnalyticsEvent({
            menuId: (0, $6GljB.L1_MENU_ID).ROADMAPS,
            sectionItem: (0, $bOwox.SECTION_ITEM_ROADMAPS)
        });
        onExpandFlyoutToggle?.(hasExpanded);
    }, [
        onExpansionToggle,
        onExpandFlyoutToggle,
        sendSectionItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gA92M.SpotlightTarget), {
        name: (0, $eYbIq.ROADMAP_INTRODUCTION_SPOTLIGHT),
        isFullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        dropTargetRef: visualContentRef,
        dropIndicator: dropIndicator,
        isDragging: isDragging,
        isExpanded: isExpanded,
        menuId: (0, $5IkoH.MENU_ID_ROADMAPS),
        onExpansionToggle: handleExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-roadmaps-default",
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cee3w.PremiumLozenge), null),
        hasDragIndicator: hasDragIndicator,
        isDragging: isDragging,
        ref: $5d4f112b9bb9c33b$var$getRefs(draggableRef, triggerRef),
        testId: (0, $jzXAj.getTestId)((0, $5IkoH.MENU_ID_ROADMAPS))
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7RdH9.Footer), null))), isJpdProjectView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9pOfV.RoadmapIntroductionSpotlight), {
        collectionsUrl: (0, $aOGXw.getCollectionsPageUrl)(),
        placement: "right middle"
    }));
});
const $5d4f112b9bb9c33b$var$RoadmapsStaticNav4 = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    const { isExpanded: isExpanded, onExpansionToggle: onExpansionToggle, actionsOnHover: actionsOnHover, children: children, triggerRef: triggerRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).ROADMAPS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const isJpdProjectView = (0, $78GR0.useIsJpdProjectView)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gA92M.SpotlightTarget), {
        name: (0, $eYbIq.ROADMAP_INTRODUCTION_SPOTLIGHT),
        isFullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: (0, $5IkoH.MENU_ID_ROADMAPS),
        onExpansionToggle: (hasExpanded)=>{
            onExpansionToggle?.(hasExpanded);
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $6GljB.L1_MENU_ID).ROADMAPS,
                sectionItem: (0, $bOwox.SECTION_ITEM_ROADMAPS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-roadmaps-default",
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cee3w.PremiumLozenge), null),
        ref: $5d4f112b9bb9c33b$var$getRefs(null, triggerRef),
        testId: (0, $jzXAj.getTestId)((0, $5IkoH.MENU_ID_ROADMAPS))
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7RdH9.Footer), null))), isJpdProjectView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9pOfV.RoadmapIntroductionSpotlight), {
        collectionsUrl: (0, $aOGXw.getCollectionsPageUrl)(),
        placement: "right middle"
    }));
});
const $5d4f112b9bb9c33b$export$4c4071eb62c5e1cf = (0, $jepRN.componentWithFG)('navx-global-side-nav', $5d4f112b9bb9c33b$var$RoadmapsStaticGSN, $5d4f112b9bb9c33b$var$RoadmapsStaticNav4);
function $5d4f112b9bb9c33b$var$getRefs(draggableRef, triggerRef) {
    return draggableRef ? (0, $fFNvS.mergeRefs)(draggableRef, triggerRef || null) : triggerRef;
}

});
parcelRegister("gA92M", function(module, exports) {
$parcel$export(module.exports, "SpotlightTarget", () => $78c69aedca2c77ed$export$e29577842f211e22);
/* SpotlightTarget.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $8maDC = parcelRequire("8maDC");
const $78c69aedca2c77ed$var$styles = {
    root: "_1bsb1ns9",
    fullWidth: "_1bsb1osq"
};
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $78c69aedca2c77ed$export$e29577842f211e22 = ({ children: children, name: name, isFullWidth: isFullWidth = false })=>{
    const id = (0, $8maDC.targetTranslation)(name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        id: id,
        className: (0, $4jQY2.default)([
            $78c69aedca2c77ed$var$styles.root,
            isFullWidth && $78c69aedca2c77ed$var$styles.fullWidth
        ])
    }, children);
};
$78c69aedca2c77ed$export$e29577842f211e22.displayName = "SpotlightTarget";
$78c69aedca2c77ed$export$e29577842f211e22.displayName = 'SpotlightTarget';

});
parcelRegister("8maDC", function(module, exports) {
$parcel$export(module.exports, "targetTranslation", () => $955264891535364f$export$1d49f6eff744367d);
const $955264891535364f$export$1d49f6eff744367d = (value)=>{
    if (!value || value.length === 0) return '';
    /**
	 * All of the following are actually invalid in CSS selectors.
	 * It's unlikely that a lot of these are actually used as `Spotlight` `name` prop values.
	 * If it turns out other characters are used, add them as needed.
	 *
	 * (space) — descendant combinator
	 * > — child combinator
	 * + — adjacent sibling combinator
	 * ~ — general sibling combinator
	 * # — ID selector
	 * : — pseudo-class/element
	 * [ ] — attribute selectors
	 * ( ) — functional notation
	 * , — selector list separator
	 * * — universal selector
	 * | — namespace separator
	 * " ' — string delimiters
	 * \ — escape character
	 * Characters not allowed in unescaped identifiers:
	 * Digits 0-9 cannot be the first character
	 * !, @, $, %, ^, &, =, {, }, ;, /, and most other punctuation
	 */ return value.replace(/[ /.]/g, '-');
};

});


parcelRegister("eYbIq", function(module, exports) {
$parcel$export(module.exports, "GO_TO_PROJECT_SPOTLIGHT_DISMISSED", () => $279e626f52cf69ea$export$d4b65c1c7753dab5);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_DISMISSED", () => $279e626f52cf69ea$export$5ca3ca33630ba93c);
$parcel$export(module.exports, "EXPLORE_SECTION_MESSAGE_DISMISSED", () => $279e626f52cf69ea$export$a81698c00c65eb4a);
$parcel$export(module.exports, "SEEN_PULSATING_FIELDS_BUTTON", () => $279e626f52cf69ea$export$3085446206860099);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_DISMISSED", () => $279e626f52cf69ea$export$d32c1bbde6ae670d);
$parcel$export(module.exports, "PROJECT_FIELDS_PAGE_VIEWED", () => $279e626f52cf69ea$export$ca2e8a74c8b43637);
$parcel$export(module.exports, "TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED", () => $279e626f52cf69ea$export$c6877be73b5f3d5a);
$parcel$export(module.exports, "GLOBAL_VIEWS_SECTION_MESSAGE_DISMISSED", () => $279e626f52cf69ea$export$97770ecea7daef74);
$parcel$export(module.exports, "TIMELINE_WEEKLY_MODE_SPOTLIGHT_SEEN", () => $279e626f52cf69ea$export$e941c5ec24e60769);
$parcel$export(module.exports, "TIMELINE_CONNECTIONS_SPOTLIGHT_SEEN", () => $279e626f52cf69ea$export$64cee8faac01fb4f);
$parcel$export(module.exports, "COLLECTIONS_TOUR_DISMISSED", () => $279e626f52cf69ea$export$9a1ee3e31621d60);
$parcel$export(module.exports, "PREMIUM_MODAL_DISMISSED", () => $279e626f52cf69ea$export$522f4dc72dc494f2);
$parcel$export(module.exports, "PREMIUM_LAST_VISIT", () => $279e626f52cf69ea$export$34f7000ddecc0e7f);
$parcel$export(module.exports, "CROSS_PROJECT_LIST_VIEW_FIELDS_DISMISSED_KEY", () => $279e626f52cf69ea$export$c176277d0ae24685);
$parcel$export(module.exports, "CROSS_PROJECT_TIMELINE_VIEW_FIELDS_DISMISSED_KEY", () => $279e626f52cf69ea$export$dc14a417cdf40a4e);
$parcel$export(module.exports, "CROSS_PROJECT_BOARD_VIEW_FIELDS_DISMISSED_KEY", () => $279e626f52cf69ea$export$76d94539e8fefb4a);
$parcel$export(module.exports, "CROSS_PROJECT_MATRIX_VIEW_FIELDS_DISMISSED_KEY", () => $279e626f52cf69ea$export$c98b8b1065f15440);
$parcel$export(module.exports, "USER_PROPERTY_BY_STATE_KEY", () => $279e626f52cf69ea$export$61a0683bfb4060d7);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_1", () => $279e626f52cf69ea$export$34cb8e95f71c5026);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_2", () => $279e626f52cf69ea$export$7f842ac8d21dd77c);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_3", () => $279e626f52cf69ea$export$bd207a2522aeeba4);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_4", () => $279e626f52cf69ea$export$204b6702ab1fae0e);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_LAST", () => $279e626f52cf69ea$export$14b1ce7029803351);
$parcel$export(module.exports, "GLOBAL_FIELDS_GO_TO_PROJECT_SPOTLIGHT", () => $279e626f52cf69ea$export$4aa3d2e1dc759f3c);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_1", () => $279e626f52cf69ea$export$c1ff7f4df78bdbc4);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_2", () => $279e626f52cf69ea$export$465e1e9058d0a33e);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_3", () => $279e626f52cf69ea$export$22cb3b19b9a67a4);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_4", () => $279e626f52cf69ea$export$639255389f81ee25);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_5", () => $279e626f52cf69ea$export$5420b6f468b681cb);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_LAST", () => $279e626f52cf69ea$export$b51c0dd69192efcd);
$parcel$export(module.exports, "COLLECTIONS_CREATE_ROADMAP_SPOTLIGHT", () => $279e626f52cf69ea$export$1e3c409324b9e1c8);
$parcel$export(module.exports, "COLLECTIONS_CREATE_ROADMAP_SPOTLIGHT_DISMISSED", () => $279e626f52cf69ea$export$960902aa280e7c02);
$parcel$export(module.exports, "NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED", () => $279e626f52cf69ea$export$6e3db205cdfcc126);
$parcel$export(module.exports, "PRIORITIZATION_VIEW_TOUR_DISMISSED", () => $279e626f52cf69ea$export$2c379250399a65);
$parcel$export(module.exports, "ROADMAP_VIEW_SPOTLIGHT_DISMISSED", () => $279e626f52cf69ea$export$6ec637a8d4b52e12);
$parcel$export(module.exports, "ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED", () => $279e626f52cf69ea$export$4c25160b46095f67);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT", () => $279e626f52cf69ea$export$ec0f5ceae1abcc93);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED", () => $279e626f52cf69ea$export$4aa206dd068119fd);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT_PREREQUISITE_DISMISSALS", () => $279e626f52cf69ea$export$84d5c6b713e2a436);
$parcel$export(module.exports, "PRODUCT_START_TIMESTAMP", () => $279e626f52cf69ea$export$810ba1749ac4ea65);
$parcel$export(module.exports, "IMPORT_BULK_CREATE_ONBOARDING", () => $279e626f52cf69ea$export$e65d607810623c19);
$parcel$export(module.exports, "CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT", () => $279e626f52cf69ea$export$89ec57c839f38d47);
$parcel$export(module.exports, "CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED", () => $279e626f52cf69ea$export$d39bf566f27a11d7);
$parcel$export(module.exports, "JQL_FILTERS_SPOTLIGHT", () => $279e626f52cf69ea$export$45a9f68a250f6f7e);
$parcel$export(module.exports, "JQL_FILTERS_SPOTLIGHT_DISMISSED", () => $279e626f52cf69ea$export$fc054e9e1c3b2f02);
$parcel$export(module.exports, "UNIFIED_SHARE_DIALOG_SPOTLIGHT", () => $279e626f52cf69ea$export$dfa04a2f77057fc0);
$parcel$export(module.exports, "TREE_VIEW_ONBOARDING_SPOTLIGHT", () => $279e626f52cf69ea$export$b40948f0860a6e2d);
$parcel$export(module.exports, "TREE_VIEW_ONBOARDING_SPOTLIGHT_DISMISSED", () => $279e626f52cf69ea$export$377e0ba104dddd07);
$parcel$export(module.exports, "CARD_COVERS_SPOTLIGHT", () => $279e626f52cf69ea$export$d18c252eb7765b54);
$parcel$export(module.exports, "START_WITH_TEMPLATE_SPOTLIGHT", () => $279e626f52cf69ea$export$43612f8a4f05447f);
$parcel$export(module.exports, "START_WITH_TEMPLATE_SPOTLIGHT_DISMISSED", () => $279e626f52cf69ea$export$f6d037824d85e937);
// User property names
const $279e626f52cf69ea$export$d4b65c1c7753dab5 = 'polaris.global-fields.go-to-project-spotlight-dismissed';
const $279e626f52cf69ea$export$5ca3ca33630ba93c = 'polaris.global-fields.tour-dismissed';
const $279e626f52cf69ea$export$a81698c00c65eb4a = 'polaris.project-fields.explore-section-message-dismissed';
const $279e626f52cf69ea$export$3085446206860099 = 'polaris.project-fields.seen-pulsating-fields-button';
const $279e626f52cf69ea$export$d32c1bbde6ae670d = 'polaris.project-fields.tour-dismissed';
const $279e626f52cf69ea$export$ca2e8a74c8b43637 = 'polaris.project-fields.page-viewed';
const $279e626f52cf69ea$export$c6877be73b5f3d5a = 'polaris.timeline.dates-config-section-message-dismissed';
const $279e626f52cf69ea$export$97770ecea7daef74 = 'polaris.global-views.section-message-dismissed';
const $279e626f52cf69ea$export$e941c5ec24e60769 = 'polaris.timeline.weekly-mode-spotlight-seen';
const $279e626f52cf69ea$export$64cee8faac01fb4f = 'polaris.timeline.connections-spotlight-seen';
const $279e626f52cf69ea$export$9a1ee3e31621d60 = 'polaris.collections.tour-dismissed';
const $279e626f52cf69ea$export$522f4dc72dc494f2 = 'polaris.premium.modal-dismissed';
const $279e626f52cf69ea$export$34f7000ddecc0e7f = 'polaris.premium.last-visit';
// Cross project roadmaps
const $279e626f52cf69ea$var$CROSS_PROJECT_VIEW_LIST_FIELDS_DISMISSED = 'polaris.cross-project-view.list-fields-dismissed';
const $279e626f52cf69ea$var$CROSS_PROJECT_VIEW_TIMELINE_FIELDS_DISMISSED = 'polaris.cross-project-view.timeline-fields-dismissed';
const $279e626f52cf69ea$var$CROSS_PROJECT_VIEW_BOARD_FIELDS_DISMISSED = 'polaris.cross-project-view.board-fields-dismissed';
const $279e626f52cf69ea$var$CROSS_PROJECT_VIEW_MATRIX_FIELDS_DISMISSED = 'polaris.cross-project-view.matrix-fields-dismissed';
const $279e626f52cf69ea$export$c176277d0ae24685 = 'listViewfieldsDismissed';
const $279e626f52cf69ea$export$dc14a417cdf40a4e = 'timelineViewfieldsDismissed';
const $279e626f52cf69ea$export$76d94539e8fefb4a = 'boardViewfieldsDismissed';
const $279e626f52cf69ea$export$c98b8b1065f15440 = 'matrixViewfieldsDismissed';
const $279e626f52cf69ea$export$61a0683bfb4060d7 = {
    [$279e626f52cf69ea$export$c176277d0ae24685]: $279e626f52cf69ea$var$CROSS_PROJECT_VIEW_LIST_FIELDS_DISMISSED,
    [$279e626f52cf69ea$export$dc14a417cdf40a4e]: $279e626f52cf69ea$var$CROSS_PROJECT_VIEW_TIMELINE_FIELDS_DISMISSED,
    [$279e626f52cf69ea$export$76d94539e8fefb4a]: $279e626f52cf69ea$var$CROSS_PROJECT_VIEW_BOARD_FIELDS_DISMISSED,
    [$279e626f52cf69ea$export$c98b8b1065f15440]: $279e626f52cf69ea$var$CROSS_PROJECT_VIEW_MATRIX_FIELDS_DISMISSED
};
const $279e626f52cf69ea$export$34cb8e95f71c5026 = 'global-fields.tour.spotlights.step-1';
const $279e626f52cf69ea$export$7f842ac8d21dd77c = 'global-fields.tour.spotlights.step-2';
const $279e626f52cf69ea$export$bd207a2522aeeba4 = 'global-fields.tour.spotlights.step-3';
const $279e626f52cf69ea$export$204b6702ab1fae0e = 'global-fields.tour.spotlights.step-4';
const $279e626f52cf69ea$export$14b1ce7029803351 = 'global-fields.tour.spotlights.step-last';
const $279e626f52cf69ea$export$4aa3d2e1dc759f3c = 'global-fields.go-to-project.spotlight';
const $279e626f52cf69ea$export$c1ff7f4df78bdbc4 = 'project-fields.tour.spotlights.step-1';
const $279e626f52cf69ea$export$465e1e9058d0a33e = 'project-fields.tour.spotlights.step-2';
const $279e626f52cf69ea$export$22cb3b19b9a67a4 = 'project-fields.tour.spotlights.step-3';
const $279e626f52cf69ea$export$639255389f81ee25 = 'project-fields.tour.spotlights.step-4';
const $279e626f52cf69ea$export$5420b6f468b681cb = 'project-fields.tour.spotlights.step-5';
const $279e626f52cf69ea$export$b51c0dd69192efcd = 'project-fields.tour.spotlights.step-last';
const $279e626f52cf69ea$export$1e3c409324b9e1c8 = 'collections.create-roadmap.spotlight';
const $279e626f52cf69ea$export$960902aa280e7c02 = 'collections.create-roadmap.spotlight-dismissed';
const $279e626f52cf69ea$export$f0a483c398048551 = 'jpd-nav-views.spotlight';
const $279e626f52cf69ea$export$6e3db205cdfcc126 = 'polaris.nav-jpd-views.spotlight-dismissed';
const $279e626f52cf69ea$export$6231ca46e95bc736 = 'prioritization-view.tour.spotlights.step-1';
const $279e626f52cf69ea$export$cd247efd7ec3525c = 'prioritization-view.tour.spotlights.step-last';
const $279e626f52cf69ea$export$2c379250399a65 = 'polaris.prioritization-view.tour-dismissed';
const $279e626f52cf69ea$export$3134ae340fb4ae39 = 'roadmap-view.spotlight';
const $279e626f52cf69ea$export$6ec637a8d4b52e12 = 'polaris.roadmap-view.spotlight-dismissed';
const $279e626f52cf69ea$export$10bda8c91e48ff2c = 'roadmap-view.column-config.spotlight';
const $279e626f52cf69ea$export$4c25160b46095f67 = 'polaris.roadmap-view.column-config-spotlight-dismissed';
const $279e626f52cf69ea$export$ec0f5ceae1abcc93 = 'roadmap.introduction.spotlight';
const $279e626f52cf69ea$export$4aa206dd068119fd = 'roadmap.introduction.spotlight.dismissed';
const $279e626f52cf69ea$export$ef2e4b0f650c3249 = 'roadmap-view.initial-prompt.spotlight';
const $279e626f52cf69ea$export$84d5c6b713e2a436 = [
    $279e626f52cf69ea$export$522f4dc72dc494f2,
    $279e626f52cf69ea$export$6e3db205cdfcc126
];
const $279e626f52cf69ea$export$810ba1749ac4ea65 = 'polaris.product-start-timestamp';
const $279e626f52cf69ea$export$e65d607810623c19 = 'polaris.import.bulk-create';
const $279e626f52cf69ea$export$89ec57c839f38d47 = 'polaris.custom-dates.customize.spotlight';
const $279e626f52cf69ea$export$d39bf566f27a11d7 = 'polaris.custom-dates.customize.spotlight-dismissed';
const $279e626f52cf69ea$export$45a9f68a250f6f7e = 'polaris.jql-filters.spotlight';
const $279e626f52cf69ea$export$fc054e9e1c3b2f02 = 'polaris.jql-filters.spotlight-dismissed';
const $279e626f52cf69ea$export$dfa04a2f77057fc0 = 'polaris.unified-share.spotlight';
const $279e626f52cf69ea$export$b40948f0860a6e2d = 'polaris.tree-view.create-menu.spotlight';
const $279e626f52cf69ea$export$377e0ba104dddd07 = 'polaris.tree-view.onboarding.spotlight-dismissed';
const $279e626f52cf69ea$export$d18c252eb7765b54 = 'polaris.card-covers.spotlight';
const $279e626f52cf69ea$export$43612f8a4f05447f = 'polaris.start-with-template.spotlight';
const $279e626f52cf69ea$export$f6d037824d85e937 = 'polaris.start-with-template.spotlight-dismissed';

});

parcelRegister("9pOfV", function(module, exports) {
$parcel$export(module.exports, "RoadmapIntroductionSpotlight", () => $47e1eae5bcd17bcf$export$71e9b7b9d410b300);
/* eslint-disable jira/choreographer/message-id-by-folder-structure */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $kYJqR = parcelRequire("kYJqR");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $g5ruf = parcelRequire("g5ruf");

var $55BnK = parcelRequire("55BnK");

var $eYbIq = parcelRequire("eYbIq");

var $gvtNj = parcelRequire("gvtNj");

var $5Vnw3 = parcelRequire("5Vnw3");

var $ZQYug = parcelRequire("ZQYug");

var $cTqdV = parcelRequire("cTqdV");

var $gZZFp = parcelRequire("gZZFp");

var $dDnRG = parcelRequire("dDnRG");
const $47e1eae5bcd17bcf$var$giveItATry = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-onboarding-flows.collections.tour.introduction.give-it-a-try",
    defaultMessage: "Give it a try!"
});
const $47e1eae5bcd17bcf$var$heading = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-onboarding-flows.collections.tour.roadmap-introduction-spotlight.heading",
    defaultMessage: "Build executive roadmaps"
});
const $47e1eae5bcd17bcf$var$messageNew = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-onboarding-flows.collections.tour.roadmap-introduction-spotlight.message",
    defaultMessage: "Choose which projects and ideas to include so your stakeholders see what matters most."
});
const $47e1eae5bcd17bcf$var$messageNewGalaxia = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-onboarding-flows.collections.tour.roadmap-introduction-spotlight.message-galaxia",
    defaultMessage: "Choose which spaces and ideas to include so your stakeholders see what matters most."
});
const $47e1eae5bcd17bcf$export$3b3e465f2052300a = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window?.location.href.includes('roadmap');
};
const $47e1eae5bcd17bcf$export$71e9b7b9d410b300 = ({ collectionsUrl: collectionsUrl, placement: placement })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const isLicensedUser = (0, $gZZFp.useIsLicensedUser)();
    const { push: push } = (0, $55BnK.useRouterActions)();
    const expandSideNav = (0, $kYJqR.useExpandSideNav)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const isAlreadyInRoadmaps = $47e1eae5bcd17bcf$export$3b3e465f2052300a();
    const { loadRoadmapIntroductionDismissed: loadRoadmapIntroductionDismissed, loadRoadmapIntroductionPrerequisiteDismissalsMet: loadRoadmapIntroductionPrerequisiteDismissalsMet, loadProductUsageStartTimestamp: loadProductUsageStartTimestamp, setRoadmapIntroductionDismissed: setRoadmapIntroductionDismissed } = (0, $gvtNj.useOnboardingFlowsActions)();
    (0, $euxye.useEffect)(()=>{
        // we can prevent unnecessary calls in these cases
        if (isAlreadyInRoadmaps || !isLicensedUser) return;
        loadRoadmapIntroductionDismissed();
        loadRoadmapIntroductionPrerequisiteDismissalsMet();
        loadProductUsageStartTimestamp();
    }, [
        isAlreadyInRoadmaps,
        isLicensedUser,
        loadProductUsageStartTimestamp,
        loadRoadmapIntroductionDismissed,
        loadRoadmapIntroductionPrerequisiteDismissalsMet
    ]);
    const isIntroductionDismissed = (0, $5Vnw3.useCollectionsIntroductionDismissed)();
    const arePrerequisiteDismissalsMet = (0, $5Vnw3.useCollectionsIntroductionPrerequisiteDismissalsMet)();
    const productUsageStartTimestamp = (0, $ZQYug.useProductUsageStartTimestamp)();
    const hasAtLeastTwoSpaces = (0, $dDnRG.useHasAtLeastTwoJpdSpaces)();
    const dismiss = (0, $euxye.useCallback)((analyticsEvent)=>{
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, {
            activeSpotlight: (0, $eYbIq.ROADMAP_INTRODUCTION_SPOTLIGHT)
        });
        setRoadmapIntroductionDismissed();
    }, [
        setRoadmapIntroductionDismissed
    ]);
    const onCloseButtonDismiss = (0, $euxye.useCallback)(()=>{
        dismiss(createAnalyticsEvent({
            action: 'dismissed',
            actionSubject: 'jpdSpotlight'
        }));
    }, [
        dismiss,
        createAnalyticsEvent
    ]);
    if (isAlreadyInRoadmaps || !isLicensedUser || isIntroductionDismissed === undefined || isIntroductionDismissed || !arePrerequisiteDismissalsMet || !(0, $cTqdV.checkIfOlderThanNDays)(productUsageStartTimestamp) || !hasAtLeastTwoSpaces) return null;
    const openRoadmaps = (analyticsEvent)=>{
        if (analyticsEvent) (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'openRoadmaps');
        else (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'openRoadmaps');
        setRoadmapIntroductionDismissed();
        push(collectionsUrl);
    };
    expandSideNav();
    const getNewMessage = ()=>{
        return formatMessage((0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $47e1eae5bcd17bcf$var$messageNewGalaxia : $47e1eae5bcd17bcf$var$messageNew);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g5ruf.JiraSpotlight), {
        actions: [
            {
                onClick: (_, analyticsEvent)=>openRoadmaps(analyticsEvent),
                text: formatMessage($47e1eae5bcd17bcf$var$giveItATry)
            }
        ],
        dialogPlacement: placement,
        dialogWidth: 275,
        heading: formatMessage($47e1eae5bcd17bcf$var$heading),
        target: (0, $eYbIq.ROADMAP_INTRODUCTION_SPOTLIGHT),
        key: (0, $eYbIq.ROADMAP_INTRODUCTION_SPOTLIGHT),
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetOnClick: (_event)=>openRoadmaps(),
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: "polaris-lib-onboarding-flows.ui.collections.tour.roadmap-introduction-spotlight.jira-spotlight",
        messageType: "engagement",
        isMigrated: true,
        onDismiss: onCloseButtonDismiss
    }, getNewMessage());
};
$47e1eae5bcd17bcf$export$71e9b7b9d410b300.displayName = "RoadmapIntroductionSpotlight";

});
parcelRegister("g5ruf", function(module, exports) {
$parcel$export(module.exports, "JiraSpotlight", () => $fa1683280848d225$export$e209c6be9ab8c4f4);
/* jira-spotlight.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-disable-next-line jira/filename-case

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $5inXb = parcelRequire("5inXb");

var $gu6Rp = parcelRequire("gu6Rp");

var $i2sOf = parcelRequire("i2sOf");

var $12j6D = parcelRequire("12j6D");

var $fxLck = parcelRequire("fxLck");

var $g5k19 = parcelRequire("g5k19");

var $5Gxfr = parcelRequire("5Gxfr");

var $jFNyB = parcelRequire("jFNyB");

var $liP0D = parcelRequire("liP0D");

var $8CDnU = parcelRequire("8CDnU");

var $8qQ8A = parcelRequire("8qQ8A");

var $8guPH = parcelRequire("8guPH");

var $7okqc = parcelRequire("7okqc");

var $KcP1c = parcelRequire("KcP1c");

var $413te = parcelRequire("413te");

var $54cWg = parcelRequire("54cWg");

var $jukA2 = parcelRequire("jukA2");

var $bEy1I = parcelRequire("bEy1I");

var $7Bcvd = parcelRequire("7Bcvd");

var $54AB6 = parcelRequire("54AB6");

var $jleyn = parcelRequire("jleyn");

var $8Sdzy = parcelRequire("8Sdzy");

var $1eqxq = parcelRequire("1eqxq");

var $36L2B = parcelRequire("36L2B");

var $kl1eU = parcelRequire("kl1eU");

var $dyfJ5 = parcelRequire("dyfJ5");

var $8KGcg = parcelRequire("8KGcg");

var $8maDC = parcelRequire("8maDC");

var $3S3Wx = parcelRequire("3S3Wx");
const $fa1683280848d225$var$styles = {
    image: "_1bsb1osq",
    contentReset: "_y3gn18uv _o5724jg8 _1p1dglyw _1nmz4jg8 _1i4q4jg8"
};
const $fa1683280848d225$var$translations = {
    actions: (0, $36L2B.actionsTranslation),
    heading: (0, $kl1eU.headingTranslation),
    children: (0, $dyfJ5.childrenTranslation),
    dialogPlacement: (0, $8KGcg.dialogPlacementTranslation),
    target: (0, $8maDC.targetTranslation)
};
const $fa1683280848d225$var$ContentStylesReset = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": "spotlight.ui.content-styles-reset",
        className: (0, $4jQY2.default)([
            $fa1683280848d225$var$styles.contentReset
        ])
    }, children);
};
$fa1683280848d225$var$ContentStylesReset.displayName = "ContentStylesReset";
const $fa1683280848d225$export$e209c6be9ab8c4f4 = ({ isMigrated: isMigrated = false, ...props })=>{
    if (isMigrated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fa1683280848d225$var$Spotlight, props);
    if ((0, $gu6Rp.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1eqxq.ChoreographerSpotlight), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $12j6D.default), rest);
};
$fa1683280848d225$export$e209c6be9ab8c4f4.displayName = "JiraSpotlight";
const $fa1683280848d225$var$Spotlight = (props)=>{
    const placement = $fa1683280848d225$var$translations.dialogPlacement(props.dialogPlacement);
    const actions = $fa1683280848d225$var$translations.actions(props.actions);
    const heading = $fa1683280848d225$var$translations.heading(props.heading);
    const body = $fa1683280848d225$var$translations.children(props.children);
    const id = $fa1683280848d225$var$translations.target(props.target);
    const [isVisible, setIsVisible] = (0, $euxye.useState)(true);
    const { onDismiss: onDismiss } = props;
    const dismiss = (0, $euxye.useCallback)(()=>{
        setIsVisible(false);
        onDismiss?.();
    }, [
        setIsVisible,
        onDismiss
    ]);
    const renderInline = (0, $5inXb.useMountToHtmlElement)({
        selectors: id ? `#${id}` : undefined,
        as: 'inline',
        position: 'inside',
        observeRoot: props.shouldObserveRootForTarget && typeof globalThis.document !== 'undefined' ? globalThis.document.body : undefined
    });
    const { messageType: messageType, messageId: messageId } = props;
    return renderInline(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3S3Wx.ChoreographedComponent), {
        messageId: messageId,
        messageType: messageType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g5k19.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5Gxfr.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fxLck.PopoverContent), {
        offset: props.offset,
        dismiss: dismiss,
        placement: placement,
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fa1683280848d225$var$ContentStylesReset, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8CDnU.SpotlightCard), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $KcP1c.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $413te.SpotlightHeadline), null, heading), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8qQ8A.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8guPH.SpotlightDismissControl), null))), props.image && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $54cWg.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $i2sOf.default), {
        src: props.image,
        alt: "",
        className: (0, $4jQY2.default)([
            $fa1683280848d225$var$styles.image
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $liP0D.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7okqc.SpotlightFooter), null, props.actionsBeforeElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7Bcvd.SpotlightStepCount), null, props.actionsBeforeElement), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jFNyB.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, actions?.secondary && (actions.secondary.href !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $54AB6.SpotlightSecondaryLink), actions.secondary, actions.secondary.text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEy1I.SpotlightSecondaryAction), actions.secondary, actions.secondary.text)), actions?.primary && (actions.primary.href !== undefined ? // oxlint-disable-next-line typescript/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jleyn.SpotlightPrimaryLink), actions.primary, actions.primary.text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jukA2.SpotlightPrimaryAction), actions.primary, actions.primary.text)))))))))));
};
$fa1683280848d225$var$Spotlight.displayName = "Spotlight";

});
parcelRegister("1eqxq", function(module, exports) {
$parcel$export(module.exports, "ChoreographerSpotlight", () => $4e0ee9f5e54a8b3e$export$e01943d134357d00);
/* eslint-disable jira/filename-case */ 
var $l6b8t = parcelRequire("l6b8t");

var $12j6D = parcelRequire("12j6D");
const $4e0ee9f5e54a8b3e$export$e01943d134357d00 = (0, $l6b8t.withChoreographedRender)((0, $12j6D.default));

});

parcelRegister("36L2B", function(module, exports) {
$parcel$export(module.exports, "actionsTranslation", () => $4f8308ff1fe72235$export$fdc4cd80d14b26e1);
const $4f8308ff1fe72235$var$sanitizeAction = (action)=>{
    if (action === undefined) return undefined;
    const { appearance: _ignoredAppearance, ...remainingActionProps } = action;
    return remainingActionProps;
};
const $4f8308ff1fe72235$export$fdc4cd80d14b26e1 = (value)=>{
    if (!value || value.length === 0) return {};
    if (value.length === 1) {
        const [primary] = value;
        return {
            primary: $4f8308ff1fe72235$var$sanitizeAction(primary)
        };
    }
    const primary = value.find((action)=>action.ctaType === 'primary');
    const secondary = value.find((action)=>action.ctaType === 'secondary');
    if (primary && secondary) return {
        primary: $4f8308ff1fe72235$var$sanitizeAction(primary),
        secondary: $4f8308ff1fe72235$var$sanitizeAction(secondary)
    };
    if (primary) {
        // Only primary found, assign the other as secondary
        const other = value.find((action)=>action !== primary);
        return {
            primary: $4f8308ff1fe72235$var$sanitizeAction(primary),
            secondary: $4f8308ff1fe72235$var$sanitizeAction(other)
        };
    }
    if (secondary) {
        // Only secondary found, assign the other as primary
        const other = value.find((action)=>action !== secondary);
        return {
            primary: $4f8308ff1fe72235$var$sanitizeAction(other),
            secondary: $4f8308ff1fe72235$var$sanitizeAction(secondary)
        };
    }
    // Neither ctaType is set, assume second is primary, first is secondary
    const [secondaryFallback, primaryFallback] = value;
    return {
        primary: $4f8308ff1fe72235$var$sanitizeAction(primaryFallback),
        secondary: $4f8308ff1fe72235$var$sanitizeAction(secondaryFallback)
    };
};

});

parcelRegister("kl1eU", function(module, exports) {
$parcel$export(module.exports, "headingTranslation", () => $333e34f20462d2e8$export$1e4b2a404c8d1178);
const $333e34f20462d2e8$export$1e4b2a404c8d1178 = (value)=>{
    return value;
};

});

parcelRegister("dyfJ5", function(module, exports) {
$parcel$export(module.exports, "childrenTranslation", () => $04ca7d869fb94a80$export$ec845ea6496bc16d);
const $04ca7d869fb94a80$export$ec845ea6496bc16d = (value)=>{
    return value;
};

});

parcelRegister("8KGcg", function(module, exports) {
$parcel$export(module.exports, "dialogPlacementTranslation", () => $7e6d943d5f990e00$export$36d3ec26072cdd7a);
const $7e6d943d5f990e00$var$placementMap = {
    'top right': 'top-start',
    'top center': 'top-center',
    'top left': 'top-end',
    'right bottom': 'right-start',
    'right middle': 'right-start',
    'right top': 'right-end',
    'bottom left': 'bottom-end',
    'bottom center': 'bottom-center',
    'bottom right': 'bottom-start',
    'left top': 'left-end',
    'left middle': 'left-start',
    'left bottom': 'left-start'
};
const $7e6d943d5f990e00$export$36d3ec26072cdd7a = (value)=>{
    // `bottom left` is the default placement when `undefined` is passed.
    return $7e6d943d5f990e00$var$placementMap[value || 'bottom left'];
};

});

parcelRegister("3S3Wx", function(module, exports) {
$parcel$export(module.exports, "ChoreographedComponent", () => $3a4e735171ef0575$export$2d56cb44b2c5f8dc);
$parcel$export(module.exports, "ChoreographedComponentWithFG", () => $3a4e735171ef0575$export$91df99a78c24b15b);

var $euxye = parcelRequire("euxye");

var $gu6Rp = parcelRequire("gu6Rp");

var $l6b8t = parcelRequire("l6b8t");

var $jepRN = parcelRequire("jepRN");
const $3a4e735171ef0575$var$ChildrenWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
$3a4e735171ef0575$var$ChildrenWrapper.displayName = "ChildrenWrapper";
const $3a4e735171ef0575$var$ChoreographedChildrenWrapper = (0, $l6b8t.withChoreographedRender)($3a4e735171ef0575$var$ChildrenWrapper);
const $3a4e735171ef0575$export$2d56cb44b2c5f8dc = ({ messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, children: children })=>{
    if (!(0, $gu6Rp.shouldBeChoreographed)({
        messageId: messageId,
        messageType: messageType,
        onMessageDisposition: onMessageDisposition
    })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3a4e735171ef0575$var$ChoreographedChildrenWrapper, {
        messageId: messageId,
        onMessageDisposition: onMessageDisposition
    }, children);
};
$3a4e735171ef0575$export$2d56cb44b2c5f8dc.displayName = "ChoreographedComponent";
const $3a4e735171ef0575$export$91df99a78c24b15b = (0, $jepRN.componentWithFG)('post-office_enable_choroegraphed_spotlight_card', $3a4e735171ef0575$export$2d56cb44b2c5f8dc, $3a4e735171ef0575$var$ChildrenWrapper);

});


parcelRegister("gvtNj", function(module, exports) {
$parcel$export(module.exports, "useOnboardingFlowsActions", () => $904851d83228ca09$export$e3d86ac85365138c);
$parcel$export(module.exports, "createHook", () => $904851d83228ca09$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "OnboardingFlowsContainer", () => $904851d83228ca09$export$214c4fcbf19b9a1d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gtDeG = parcelRequire("gtDeG");

var $5QDqc = parcelRequire("5QDqc");

var $8SRwh = parcelRequire("8SRwh");

var $16245 = parcelRequire("16245");
const $904851d83228ca09$export$46c52354b8798e89 = (0, $5QDqc.createStore)({
    name: 'PolarisLibOnboardingFlowsStore',
    initialState: {
        containerProps: {
            accountId: undefined
        },
        productUsageStartTimestamp: undefined,
        globalFields: {
            goToProjectSpotlightDismissed: undefined,
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        projectFields: {
            exploreSectionMessageDismissed: undefined,
            seenPulsatingFieldsButton: undefined,
            tourDismissed: undefined,
            tourSpotlightStep: null,
            pageViewed: undefined
        },
        collections: {
            tourDismissed: undefined,
            tourSpotlightStep: null,
            introductionDismissed: undefined,
            introductionPrerequisiteDismissalsMet: undefined
        },
        crossProjectView: {},
        import: {
            successNotificationViewed: undefined
        },
        timeline: {
            sectionMessageDismissed: undefined,
            weeklyModeSpotlightSeen: undefined,
            connectionsSpotlightSeen: undefined
        },
        allViews: {
            spotlightDismissed: undefined
        },
        prioritizationView: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        roadmapView: {
            spotlightDismissed: undefined,
            columnConfigSpotlightDismissed: undefined
        },
        premium: {
            modalDismissed: undefined,
            lastVisit: {
                isPremium: undefined,
                updated: undefined
            },
            promise: (0, $8SRwh.createDeferredPromise)()
        },
        customDates: {
            customizeSpotlightDismissed: undefined
        },
        jqlFilters: {
            spotlightDismissed: undefined
        },
        unifiedShareDialog: {
            spotlightDismissed: undefined
        },
        treeViewOnboarding: {
            spotlightDismissed: undefined
        },
        cardCoverSpotlight: {
            spotlightDismissed: undefined
        },
        globalViews: {
            sectionMessageDismissed: undefined
        },
        startWithTemplateSpotlight: {
            spotlightDismissed: undefined
        }
    },
    actions: $16245.actions
});
const $904851d83228ca09$var$dest = (0, $gtDeG.createJpdContainer)($904851d83228ca09$export$46c52354b8798e89);
const $904851d83228ca09$export$2e28a971a45925e3 = $904851d83228ca09$var$dest.Container;
const $904851d83228ca09$export$e3d86ac85365138c = $904851d83228ca09$var$dest.useActions;
const $904851d83228ca09$export$e7f733c8fc2b8a24 = $904851d83228ca09$var$dest.createHook;
const $904851d83228ca09$export$757252247e722815 = $904851d83228ca09$var$dest.createHigherLevelHook;
const $904851d83228ca09$export$214c4fcbf19b9a1d = ({ accountId: accountId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($904851d83228ca09$export$2e28a971a45925e3, {
        isGlobal: true,
        accountId: accountId
    }, children);
$904851d83228ca09$export$214c4fcbf19b9a1d.displayName = "OnboardingFlowsContainer";

});
parcelRegister("gtDeG", function(module, exports) {
$parcel$export(module.exports, "createJpdContainer", () => $acc48ac3998e8b04$export$7ed5db99dcc39128);
$parcel$export(module.exports, "getCreateHigherLevelHook", () => $acc48ac3998e8b04$export$fe2399e6da52af99);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aUPBc = parcelRequire("aUPBc");

var $aACsh = parcelRequire("aACsh");

var $3h1FP = parcelRequire("3h1FP");

var $euq4d = parcelRequire("euq4d");
const $acc48ac3998e8b04$var$createSelectorHook = (store, selector)=>{
    const innerHook = (0, $3h1FP.createHook)(store, {
        selector: (state)=>selector(state, state.containerProps)
    });
    return ()=>{
        const [val] = innerHook();
        return val;
    };
};
const $acc48ac3998e8b04$export$757252247e722815 = (store, selectorCreator)=>{
    // TODO POL-2195 memoize one is not suitable for this task, as it will only memoize the last invocation. while this
    //               improves subsequent calls with the same argument set, it does not improve calls with different args
    //               this case should be solved with a generic memoization lib, e.g. reselect (4.1+) or moize
    //               discussion: https://hello.atlassian.net/wiki/spaces/TGR/pages/1416371989/Dependency+review+moize
    const memoizedSelectorCreator = (0, $aACsh.cacheSelectorCreator)(selectorCreator);
    // TODO POL-2195 in the meantime, we can use lodash/memoize to at least solve the 1-ary case,
    //               which should be 99% of our selector creators anyway
    const monadicSelectorCreatorMemoized = (0, (/*@__PURE__*/$parcel$interopDefault($aUPBc)))(selectorCreator);
    const rssHook = (0, $3h1FP.createHook)(store, {
        selector: (state, args)=>{
            if (args.length <= 1) return monadicSelectorCreatorMemoized(...args)(state, state.containerProps);
            return memoizedSelectorCreator(...args)(state, state.containerProps);
        }
    });
    return (...args)=>{
        // @ts-expect-error - TS2345 - Argument of type 'SelectorCreatorArgs' is not assignable to parameter
        const [val] = rssHook(args);
        return val;
    };
};
const $acc48ac3998e8b04$export$7ed5db99dcc39128 = (store, options)=>{
    const Container = (0, $euq4d.createContainerWithContext)(store, options);
    const useEmptyState = (0, $3h1FP.createHook)(store, {
        selector: null
    });
    const useActions = ()=>{
        const [, actions] = useEmptyState();
        return actions;
    };
    return {
        createHook: (selector)=>$acc48ac3998e8b04$var$createSelectorHook(store, selector),
        createHigherLevelHook: (selectorCreator)=>$acc48ac3998e8b04$export$757252247e722815(store, selectorCreator),
        useActions: useActions,
        Container: Container
    };
};
const $acc48ac3998e8b04$export$fe2399e6da52af99 = (store)=>(selectorCreator)=>$acc48ac3998e8b04$export$757252247e722815(store, selectorCreator);

});
parcelRegister("aACsh", function(module, exports) {
$parcel$export(module.exports, "cacheSelectorCreator", () => $bf8270deac871878$export$413433974f0869c3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $gXtG2 = parcelRequire("gXtG2");
let $bf8270deac871878$var$cache = new WeakMap();
let $bf8270deac871878$var$jsonEqualityMap = new WeakMap();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $bf8270deac871878$var$cache = new WeakMap();
    $bf8270deac871878$var$jsonEqualityMap = new WeakMap();
});
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $bf8270deac871878$var$getValueFromJsonEqualityCache = (f, value, options)=>{
    if (options?.useJsonEquality !== true) return value;
    if (!$bf8270deac871878$var$jsonEqualityMap.has(f)) $bf8270deac871878$var$jsonEqualityMap.set(f, new Map());
    const storage = $bf8270deac871878$var$jsonEqualityMap.get(f);
    try {
        const key = JSON.stringify(value);
        if (storage.has(key)) return storage.get(key);
        storage.set(key, value);
    } catch  {
    // do nothing
    }
    return value;
};
function $bf8270deac871878$export$413433974f0869c3(f, options) {
    if (f.__isCachedSelectorCreator === true) return f;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const cacheFunction = (...args)=>{
        if ($bf8270deac871878$var$cache.has(f)) {
            let lastNode = $bf8270deac871878$var$cache.get(f);
            for(let i = 0; i < args.length; i += 1){
                const value = $bf8270deac871878$var$getValueFromJsonEqualityCache(f, args[i], options);
                if (!lastNode.args.has(value)) {
                    lastNode = null;
                    break;
                }
                lastNode = lastNode.args.get(value);
            }
            if (lastNode?.selector) return lastNode.selector;
        }
        const maybeSelector = f(...args);
        if (typeof maybeSelector?.resultFunc === 'function' || typeof maybeSelector === 'function') {
            if (!$bf8270deac871878$var$cache.has(f)) $bf8270deac871878$var$cache.set(f, {
                args: new Map(),
                selector: null
            });
            let lastNode = $bf8270deac871878$var$cache.get(f);
            for(let i = 0; i < args.length; i += 1){
                const value = $bf8270deac871878$var$getValueFromJsonEqualityCache(f, args[i], options);
                if (!lastNode.args.has(value)) lastNode.args.set(value, {
                    args: new Map(),
                    selector: null
                });
                lastNode = lastNode.args.get(value);
            }
            lastNode.selector = maybeSelector;
        }
        return maybeSelector;
    };
    cacheFunction.__isCachedSelectorCreator = true;
    cacheFunction.__origin = f;
    cacheFunction.displayName = f.name || f.displayName;
    return cacheFunction;
}
const $bf8270deac871878$export$e2575ed62a2f107b = ()=>$bf8270deac871878$var$cache;
const $bf8270deac871878$export$e15acfbd8ab989dd = (key)=>$bf8270deac871878$var$cache.get(key);
const $bf8270deac871878$export$6e5dca841bdf93e3 = ()=>{
    $bf8270deac871878$var$cache = new WeakMap();
    $bf8270deac871878$var$jsonEqualityMap = new WeakMap();
};

});

parcelRegister("euq4d", function(module, exports) {
$parcel$export(module.exports, "createContainerWithContext", () => $bced25cdf66438ae$export$ce6d80db779db7dc);
$parcel$export(module.exports, "getStoreHandlersWithStatefullContainerProps", () => $bced25cdf66438ae$export$6933e4b57e7277c6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $dB6ay = parcelRequire("dB6ay");

var $fAsyH = parcelRequire("fAsyH");
const $bced25cdf66438ae$export$ce6d80db779db7dc = (store, options)=>(0, $dB6ay.createContainer)(store, {
        ...options,
        onInit: ()=>(api, containerProps)=>{
                (0, $fAsyH.batchStateUpdates)(({ dispatch: dispatch, setState: setState }, props)=>{
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props
                    });
                    options?.onInit && dispatch(options.onInit());
                })(api, containerProps);
            },
        onUpdate: ()=>(api, containerProps)=>{
                (0, $fAsyH.batchStateUpdates)(({ dispatch: dispatch, setState: setState, getState: getState }, props)=>{
                    const prevContainerProps = getState().containerProps;
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props,
                        prevContainerProps: prevContainerProps
                    });
                    options?.onUpdate && dispatch(options.onUpdate());
                })(api, containerProps);
            }
    });
const $bced25cdf66438ae$export$6933e4b57e7277c6 = (handlers)=>({
        onInit: ()=>(api, containerProps)=>{
                (0, $fAsyH.batchStateUpdates)(({ dispatch: dispatch, setState: setState }, props)=>{
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props
                    });
                    handlers?.onInit && dispatch(handlers?.onInit());
                })(api, containerProps);
            },
        onUpdate: ()=>(api, containerProps)=>{
                (0, $fAsyH.batchStateUpdates)(({ dispatch: dispatch, setState: setState, getState: getState }, props)=>{
                    const prevContainerProps = getState().containerProps;
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props,
                        prevContainerProps: prevContainerProps
                    });
                    handlers?.onUpdate && dispatch(handlers?.onUpdate());
                })(api, containerProps);
            }
    });

});
parcelRegister("fAsyH", function(module, exports) {
$parcel$export(module.exports, "batchStateUpdates", () => $a1cc06d1e81ca92b$export$4f8b20404a906ca3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $a1cc06d1e81ca92b$export$4f8b20404a906ca3 = (cb)=>(api, containerProps)=>{
        let finalized = false;
        let localState = api.getState();
        const setState = (newState)=>{
            if (finalized) {
                api.setState(newState);
                return;
            }
            localState = {
                ...localState,
                ...newState
            };
        };
        const getState = ()=>finalized ? api.getState() : localState;
        const dispatch = (action)=>finalized ? action(api, containerProps) : action({
                dispatch: dispatch,
                setState: setState,
                getState: getState
            }, containerProps);
        const patchedApi = {
            setState: setState,
            getState: getState,
            dispatch: dispatch
        };
        cb(patchedApi, containerProps);
        finalized = true;
        api.setState({
            ...localState
        });
        // oxlint-disable-next-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
        localState = null;
    };

});



parcelRegister("8SRwh", function(module, exports) {
$parcel$export(module.exports, "normalizeError", () => $5993a87b43ba5235$export$e7bd538fb0c5db1a);
$parcel$export(module.exports, "createDeferredPromise", () => $5993a87b43ba5235$export$87a845ded7190bfc);
$parcel$export(module.exports, "checkPrerequisiteDismissals", () => $5993a87b43ba5235$export$b20d00c7cb810f65);

var $kM0go = parcelRequire("kM0go");
const $5993a87b43ba5235$export$e7bd538fb0c5db1a = (error)=>{
    if (error instanceof Error) return error;
    return new Error('Unknown error');
};
function $5993a87b43ba5235$export$87a845ded7190bfc() {
    // These will be properly initialized in the Promise constructor
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
const $5993a87b43ba5235$export$b20d00c7cb810f65 = async (prerequisiteDismissals, accountId)=>{
    if (!accountId) return;
    const prerequisiteDismissalsPromises = prerequisiteDismissals.map((prerequisite)=>{
        return (0, $kM0go.getUserProperty)(accountId, prerequisite);
    });
    return Promise.all(prerequisiteDismissalsPromises);
};

});

parcelRegister("16245", function(module, exports) {
$parcel$export(module.exports, "actions", () => $6dcf1187d3b76dec$export$e324594224ef24da);
/* eslint-disable jira/filename-case */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $LRfq0 = parcelRequire("LRfq0");

var $7t9Sr = parcelRequire("7t9Sr");

var $58Dvu = parcelRequire("58Dvu");

var $fcHoo = parcelRequire("fcHoo");

var $jm6w2 = parcelRequire("jm6w2");

var $5z6XI = parcelRequire("5z6XI");

var $3bEEU = parcelRequire("3bEEU");

var $aHjGI = parcelRequire("aHjGI");

var $fkKne = parcelRequire("fkKne");

var $jskrU = parcelRequire("jskrU");

var $7gFEa = parcelRequire("7gFEa");

var $dCkp5 = parcelRequire("dCkp5");

var $eiikA = parcelRequire("eiikA");

var $diDNO = parcelRequire("diDNO");

var $bf6a4 = parcelRequire("bf6a4");

var $cZZnh = parcelRequire("cZZnh");

var $ipBVZ = parcelRequire("ipBVZ");

var $9n3KG = parcelRequire("9n3KG");

var $kwGPB = parcelRequire("kwGPB");

var $kESPo = parcelRequire("kESPo");

var $bG2f7 = parcelRequire("bG2f7");

var $cUi4O = parcelRequire("cUi4O");

var $joQUw = parcelRequire("joQUw");

var $38huT = parcelRequire("38huT");

var $hUyAI = parcelRequire("hUyAI");

var $aaq2c = parcelRequire("aaq2c");

var $YY7RB = parcelRequire("YY7RB");

var $lG4yo = parcelRequire("lG4yo");

var $ip08d = parcelRequire("ip08d");

var $7ciXq = parcelRequire("7ciXq");
const $6dcf1187d3b76dec$export$e324594224ef24da = {
    loadProductUsageStartTimestamp: $cUi4O.loadProductUsageStartTimestamp,
    loadGoToProjectSpotlightDismissed: $jm6w2.loadGoToProjectSpotlightDismissed,
    setGoToProjectSpotlightDismissed: $jm6w2.setGoToProjectSpotlightDismissed,
    setGlobalFieldsTourSpotlightStep: $5z6XI.setGlobalFieldsTourSpotlightStep,
    loadGlobalFieldsTourDismissed: $3bEEU.loadGlobalFieldsTourDismissed,
    setGlobalFieldsTourDismissed: $3bEEU.setGlobalFieldsTourDismissed,
    loadExploreSectionMessageDismissed: $aHjGI.loadExploreSectionMessageDismissed,
    setExploreSectionMessageDismissed: $aHjGI.setExploreSectionMessageDismissed,
    loadProjectFieldsPageViewed: $fkKne.loadProjectFieldsPageViewed,
    setProjectFieldsPageViewed: $fkKne.setProjectFieldsPageViewed,
    loadSeenPulsatingFieldsButton: $jskrU.loadSeenPulsatingFieldsButton,
    setSeenPulsatingFieldsButton: $jskrU.setSeenPulsatingFieldsButton,
    loadProjectFieldsTourDismissed: $dCkp5.loadProjectFieldsTourDismissed,
    setProjectFieldsTourDismissed: $dCkp5.setProjectFieldsTourDismissed,
    setProjectFieldsTourSpotlightStep: $7gFEa.setProjectFieldsTourSpotlightStep,
    loadCollectionsTourDismissed: $7t9Sr.loadCollectionsTourDismissed,
    loadRoadmapIntroductionPrerequisiteDismissalsMet: $fcHoo.loadRoadmapIntroductionPrerequisiteDismissalsMet,
    setCollectionsTourDismissed: $7t9Sr.setCollectionsTourDismissed,
    setCollectionsTourSpotlightStep: $LRfq0.setCollectionsTourSpotlightStep,
    loadRoadmapIntroductionDismissed: $fcHoo.loadRoadmapIntroductionDismissed,
    setRoadmapIntroductionDismissed: $fcHoo.setRoadmapIntroductionDismissed,
    loadTimelineSectionMessageDismissed: $eiikA.loadTimelineSectionMessageDismissed,
    setTimelineSectionMessageDismissed: $eiikA.setTimelineSectionMessageDismissed,
    loadWeeklyModeSpotlightSeen: $cZZnh.loadWeeklyModeSpotlightSeen,
    setWeeklyModeSpotlightSeen: $cZZnh.setWeeklyModeSpotlightSeen,
    loadConnectionsSpotlightSeen: $ipBVZ.loadConnectionsSpotlightSeen,
    setConnectionsSpotlightSeen: $ipBVZ.setConnectionsSpotlightSeen,
    loadCrossProjectViewFieldsDismissed: $58Dvu.loadCrossProjectViewFieldsDismissed,
    setCrossProjectViewFieldsDismissed: $58Dvu.setCrossProjectViewFieldsDismissed,
    loadAllViewsSpotlightDismissed: $9n3KG.loadAllViewsSpotlightDismissed,
    setAllViewsSpotlightDismissed: $9n3KG.setAllViewsSpotlightDismissed,
    loadRoadmapViewSpotlightDismissed: $kESPo.loadRoadmapViewSpotlightDismissed,
    setRoadmapViewSpotlightDismissed: $kESPo.setRoadmapViewSpotlightDismissed,
    loadRoadmapColumnConfigSpotlightDismissed: $kESPo.loadRoadmapColumnConfigSpotlightDismissed,
    setRoadmapColumnConfigSpotlightDismissed: $kESPo.setRoadmapColumnConfigSpotlightDismissed,
    loadPrioritizationViewTourDismissed: $kwGPB.loadPrioritizationViewTourDismissed,
    setPrioritizationViewTourDismissed: $kwGPB.setPrioritizationViewTourDismissed,
    setPrioritizationViewTourSpotlightStep: $kwGPB.setPrioritizationViewTourSpotlightStep,
    loadPremiumLastVisit: $bG2f7.loadPremiumLastVisit,
    loadPremiumModalDismissed: $bG2f7.loadPremiumModalDismissed,
    setPremiumLastVisit: $bG2f7.setPremiumLastVisit,
    setPremiumModalDismissed: $bG2f7.setPremiumModalDismissed,
    loadCustomDatesCustomizeSpotlightDismissed: $joQUw.loadCustomDatesCustomizeSpotlightDismissed,
    setCustomDatesCustomizeSpotlightDismissed: $joQUw.setCustomDatesCustomizeSpotlightDismissed,
    unlockOnboardingFlow: $bG2f7.unlockOnboardingFlow,
    loadImportState: $38huT.loadImportState,
    setSuccessNotificationViewed: $38huT.setSuccessNotificationViewed,
    loadUnifiedShareDialogSpotlightState: $hUyAI.loadUnifiedShareDialogSpotlightState,
    setUnifiedShareDialogSpotlightDismissed: $hUyAI.setUnifiedShareDialogSpotlightDismissed,
    loadTreeViewOnboardingSpotlightDismissed: $aaq2c.loadTreeViewOnboardingSpotlightDismissed,
    setTreeViewOnboardingSpotlightDismissed: $aaq2c.setTreeViewOnboardingSpotlightDismissed,
    loadCardCoverSpotlightState: $YY7RB.loadCardCoverSpotlightState,
    setCardCoverSpotlightDismissed: $lG4yo.setCardCoverSpotlightDismissed,
    loadGlobalViewsSectionMessageDismissed: $diDNO.loadGlobalViewsSectionMessageDismissed,
    setGlobalViewsSectionMessageDismissed: $bf6a4.setGlobalViewsSectionMessageDismissed,
    loadStartWithTemplateSpotlightDismissed: $ip08d.loadStartWithTemplateSpotlightDismissed,
    setStartWithTemplateSpotlightDismissed: $ip08d.setStartWithTemplateSpotlightDismissed,
    loadJqlFiltersSpotlightDismissed: $7ciXq.loadJqlFiltersSpotlightDismissed,
    setJqlFiltersSpotlightDismissed: $7ciXq.setJqlFiltersSpotlightDismissed
};

});
parcelRegister("LRfq0", function(module, exports) {
$parcel$export(module.exports, "setCollectionsTourSpotlightStep", () => $e78db479312fa843$export$501a98d23141dc4d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e78db479312fa843$export$501a98d23141dc4d = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("7t9Sr", function(module, exports) {
$parcel$export(module.exports, "loadCollectionsTourDismissed", () => $d8fda07f87f2da32$export$c7e2395278267e1d);
$parcel$export(module.exports, "setCollectionsTourDismissed", () => $d8fda07f87f2da32$export$2a7240b702e8d617);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $d8fda07f87f2da32$export$c7e2395278267e1d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().collections.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.COLLECTIONS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                collections: {
                    ...state.collections,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    collections: {
                        ...state.collections,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $eYbIq.COLLECTIONS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().collections.tourDismissed;
    };
const $d8fda07f87f2da32$export$2a7240b702e8d617 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                tourDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.COLLECTIONS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $eYbIq.COLLECTIONS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});
parcelRegister("kc0Nx", function(module, exports) {
$parcel$export(module.exports, "maybeWaitForPremiumModal", () => $39a618a225054029$export$b797d1ff3b371e8a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $39a618a225054029$export$b797d1ff3b371e8a = async (getState)=>{
    // Await the resolution of the deferred promise associated with the premium modal.
    // This ensures that the premium modal has either never been displayed or has already been closed.
    // This mechanism allows for seamless orchestration of all spotlights within a single package,
    // ensuring they are postponed until the premium modal can be displayed and is dismissed.
    // Treat this similar to the `!accountId`, as every loading action
    // in the `onboarding-flow` package should incorporate this check.
    await getState().premium.promise.promise;
};

});


parcelRegister("58Dvu", function(module, exports) {
$parcel$export(module.exports, "loadCrossProjectViewFieldsDismissed", () => $039032373122481d$export$e6e8b16aaeac983b);
$parcel$export(module.exports, "setCrossProjectViewFieldsDismissed", () => $039032373122481d$export$2468c71857d0e133);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $039032373122481d$export$e6e8b16aaeac983b = (viewKindStateKey)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().crossProjectView[viewKindStateKey] === 'boolean') return;
        const userProperty = (0, $eYbIq.USER_PROPERTY_BY_STATE_KEY)[viewKindStateKey];
        try {
            const viewfieldsDismissed = await (0, $kM0go.getUserProperty)(accountId, userProperty);
            const state = getState();
            setState({
                ...state,
                crossProjectView: {
                    ...state.crossProjectView,
                    [viewKindStateKey]: viewfieldsDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    crossProjectView: {
                        ...state.crossProjectView,
                        [viewKindStateKey]: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)(userProperty, `Failed to get user property with key: ${userProperty}`, error instanceof Error ? error : undefined);
        }
        return getState().crossProjectView[viewKindStateKey];
    };
const $039032373122481d$export$2468c71857d0e133 = (viewKindStateKey)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                [viewKindStateKey]: true
            }
        });
        const userProperty = (0, $eYbIq.USER_PROPERTY_BY_STATE_KEY)[viewKindStateKey];
        try {
            await (0, $kM0go.setUserProperties)(accountId, userProperty, 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)(userProperty, `Failed to set user property with key: ${userProperty}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("fcHoo", function(module, exports) {
$parcel$export(module.exports, "loadRoadmapIntroductionDismissed", () => $8d4982862eaf3a27$export$1a7b263d41622a5b);
$parcel$export(module.exports, "loadRoadmapIntroductionPrerequisiteDismissalsMet", () => $8d4982862eaf3a27$export$de983a99630cdc7d);
$parcel$export(module.exports, "setRoadmapIntroductionDismissed", () => $8d4982862eaf3a27$export$19c464c17f9739ab);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");

var $8SRwh = parcelRequire("8SRwh");
const $8d4982862eaf3a27$export$1a7b263d41622a5b = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().collections.introductionDismissed === 'boolean') return;
        try {
            const introductionDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                collections: {
                    ...state.collections,
                    introductionDismissed: introductionDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    collections: {
                        ...state.collections,
                        introductionDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to get user property with key: ${(0, $eYbIq.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().collections.introductionDismissed;
    };
const $8d4982862eaf3a27$export$de983a99630cdc7d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        let dismissals = [];
        try {
            dismissals = await (0, $8SRwh.checkPrerequisiteDismissals)((0, $eYbIq.ROADMAP_INTRODUCTION_SPOTLIGHT_PREREQUISITE_DISMISSALS), accountId);
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.prerequisites', 'Failed to get user properties for roadmap introduction spotlight prerequisites', error instanceof Error ? error : undefined);
        }
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                introductionPrerequisiteDismissalsMet: dismissals?.every((dismissal)=>dismissal) ?? false
            }
        });
        return getState().collections.introductionPrerequisiteDismissalsMet;
    };
const $8d4982862eaf3a27$export$19c464c17f9739ab = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                introductionDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to set user property with key: ${(0, $eYbIq.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("jm6w2", function(module, exports) {
$parcel$export(module.exports, "loadGoToProjectSpotlightDismissed", () => $ea5c1c974e73da6b$export$4c8d16771ecf8930);
$parcel$export(module.exports, "setGoToProjectSpotlightDismissed", () => $ea5c1c974e73da6b$export$3ea7a545c4faccd4);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $ea5c1c974e73da6b$export$4c8d16771ecf8930 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().globalFields.goToProjectSpotlightDismissed === 'boolean') return;
        try {
            const goToProjectSpotlightDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.GO_TO_PROJECT_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                globalFields: {
                    ...state.globalFields,
                    goToProjectSpotlightDismissed: goToProjectSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    globalFields: {
                        ...state.globalFields,
                        goToProjectSpotlightDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.go-to-project-spotlight', `Failed to get user property with key: ${(0, $eYbIq.GO_TO_PROJECT_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $ea5c1c974e73da6b$export$3ea7a545c4faccd4 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                goToProjectSpotlightDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.GO_TO_PROJECT_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.go-to-project-spotlight', `Failed to set user property with key: ${(0, $eYbIq.GO_TO_PROJECT_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("5z6XI", function(module, exports) {
$parcel$export(module.exports, "setGlobalFieldsTourSpotlightStep", () => $efbbace800bd5be0$export$71a13f0fff467880);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $efbbace800bd5be0$export$71a13f0fff467880 = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("3bEEU", function(module, exports) {
$parcel$export(module.exports, "loadGlobalFieldsTourDismissed", () => $c205b3e77e455584$export$6dbef36cf5394497);
$parcel$export(module.exports, "setGlobalFieldsTourDismissed", () => $c205b3e77e455584$export$7ddbf8611b7a51e2);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $c205b3e77e455584$export$6dbef36cf5394497 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().globalFields.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.GLOBAL_FIELDS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                globalFields: {
                    ...state.globalFields,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    globalFields: {
                        ...state.globalFields,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.tour', `Failed to get user property with key: ${(0, $eYbIq.GLOBAL_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $c205b3e77e455584$export$7ddbf8611b7a51e2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                tourDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.GLOBAL_FIELDS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.tour', `Failed to set user property with key: ${(0, $eYbIq.GLOBAL_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("aHjGI", function(module, exports) {
$parcel$export(module.exports, "loadExploreSectionMessageDismissed", () => $36f966130679ff98$export$178c75cc028231a2);
$parcel$export(module.exports, "setExploreSectionMessageDismissed", () => $36f966130679ff98$export$994e754bbe4537c1);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $36f966130679ff98$export$178c75cc028231a2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.exploreSectionMessageDismissed === 'boolean') return;
        try {
            const exploreSectionMessageDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.EXPLORE_SECTION_MESSAGE_DISMISSED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    exploreSectionMessageDismissed: exploreSectionMessageDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        exploreSectionMessageDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.explore-section-message', `Failed to get user property with key: ${(0, $eYbIq.EXPLORE_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $36f966130679ff98$export$994e754bbe4537c1 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                exploreSectionMessageDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.EXPLORE_SECTION_MESSAGE_DISMISSED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.explore-section-message', `Failed to set user property with key: ${(0, $eYbIq.EXPLORE_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("fkKne", function(module, exports) {
$parcel$export(module.exports, "loadProjectFieldsPageViewed", () => $f14b618b3a625dc5$export$2932bbb803f6ab52);
$parcel$export(module.exports, "setProjectFieldsPageViewed", () => $f14b618b3a625dc5$export$5425efd17972eca4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $f14b618b3a625dc5$export$2932bbb803f6ab52 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.pageViewed === 'boolean') return;
        try {
            const pageViewed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.PROJECT_FIELDS_PAGE_VIEWED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    pageViewed: pageViewed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        pageViewed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.page-viewed', `Failed to get user property with key: ${(0, $eYbIq.PROJECT_FIELDS_PAGE_VIEWED)}`, error instanceof Error ? error : undefined);
        }
    };
const $f14b618b3a625dc5$export$5425efd17972eca4 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                pageViewed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.PROJECT_FIELDS_PAGE_VIEWED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.page-viewed', `Failed to set user property with key: ${(0, $eYbIq.PROJECT_FIELDS_PAGE_VIEWED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("jskrU", function(module, exports) {
$parcel$export(module.exports, "loadSeenPulsatingFieldsButton", () => $4ce6cd74b3a95bfb$export$4248149cb54f9a58);
$parcel$export(module.exports, "setSeenPulsatingFieldsButton", () => $4ce6cd74b3a95bfb$export$ef1450ffea0c5a63);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $4ce6cd74b3a95bfb$export$4248149cb54f9a58 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.seenPulsatingFieldsButton === 'boolean') return;
        try {
            const seenPulsatingFieldsButton = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.SEEN_PULSATING_FIELDS_BUTTON));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    seenPulsatingFieldsButton: seenPulsatingFieldsButton
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        seenPulsatingFieldsButton: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.pulsating-fields-button', `Failed to get user property with key: ${(0, $eYbIq.SEEN_PULSATING_FIELDS_BUTTON)}`, error instanceof Error ? error : undefined);
        }
    };
const $4ce6cd74b3a95bfb$export$ef1450ffea0c5a63 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                seenPulsatingFieldsButton: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.SEEN_PULSATING_FIELDS_BUTTON), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.pulsating-fields-button', `Failed to set user property with key: ${(0, $eYbIq.SEEN_PULSATING_FIELDS_BUTTON)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("7gFEa", function(module, exports) {
$parcel$export(module.exports, "setProjectFieldsTourSpotlightStep", () => $eff8a0d87f8c91f5$export$a6b8eee670a4eb2f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $eff8a0d87f8c91f5$export$a6b8eee670a4eb2f = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("dCkp5", function(module, exports) {
$parcel$export(module.exports, "loadProjectFieldsTourDismissed", () => $a96b56ed6415a1a9$export$9be5e6fba10e92ef);
$parcel$export(module.exports, "setProjectFieldsTourDismissed", () => $a96b56ed6415a1a9$export$2ad2aec3cf81b681);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $a96b56ed6415a1a9$export$9be5e6fba10e92ef = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.PROJECT_FIELDS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $eYbIq.PROJECT_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $a96b56ed6415a1a9$export$2ad2aec3cf81b681 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                tourDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.PROJECT_FIELDS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $eYbIq.PROJECT_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("eiikA", function(module, exports) {
$parcel$export(module.exports, "loadTimelineSectionMessageDismissed", () => $241bc5b0a29e8ff8$export$85213c72021b1243);
$parcel$export(module.exports, "setTimelineSectionMessageDismissed", () => $241bc5b0a29e8ff8$export$f5452ae8fa9e3836);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $241bc5b0a29e8ff8$export$85213c72021b1243 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().timeline.sectionMessageDismissed === 'boolean') return;
        try {
            const timelineSectionMessageDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED));
            const state = getState();
            setState({
                ...state,
                timeline: {
                    sectionMessageDismissed: timelineSectionMessageDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    timeline: {
                        sectionMessageDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.spotlight', `Failed to get user property with key: ${(0, $eYbIq.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $241bc5b0a29e8ff8$export$f5452ae8fa9e3836 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            timeline: {
                sectionMessageDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.spotlight', `Failed to set user property with key: ${(0, $eYbIq.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("diDNO", function(module, exports) {
$parcel$export(module.exports, "loadGlobalViewsSectionMessageDismissed", () => $2752e068435919ed$export$11400a98213614f5);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");
const $2752e068435919ed$export$11400a98213614f5 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().globalViews.sectionMessageDismissed === 'boolean') return;
        try {
            const sectionMessageDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.GLOBAL_VIEWS_SECTION_MESSAGE_DISMISSED));
            const state = getState();
            setState({
                ...state,
                globalViews: {
                    sectionMessageDismissed: sectionMessageDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    globalViews: {
                        sectionMessageDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-views.section-message', `Failed to get user property with key: ${(0, $eYbIq.GLOBAL_VIEWS_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("bf6a4", function(module, exports) {
$parcel$export(module.exports, "setGlobalViewsSectionMessageDismissed", () => $4f4c694188ae7354$export$f5b19f89debb1225);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $eYbIq = parcelRequire("eYbIq");
const $4f4c694188ae7354$export$f5b19f89debb1225 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            globalViews: {
                sectionMessageDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.GLOBAL_VIEWS_SECTION_MESSAGE_DISMISSED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-views.section-message', `Failed to set user property with key: ${(0, $eYbIq.GLOBAL_VIEWS_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("cZZnh", function(module, exports) {
$parcel$export(module.exports, "loadWeeklyModeSpotlightSeen", () => $48d6c8a4bc3eca1f$export$da2cbdca7853c014);
$parcel$export(module.exports, "setWeeklyModeSpotlightSeen", () => $48d6c8a4bc3eca1f$export$f69aea5e1a6558df);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $48d6c8a4bc3eca1f$export$da2cbdca7853c014 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().timeline.weeklyModeSpotlightSeen === 'boolean') return;
        try {
            const weeklyModeSpotlightSeen = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.TIMELINE_WEEKLY_MODE_SPOTLIGHT_SEEN));
            const state = getState();
            setState({
                timeline: {
                    ...state.timeline,
                    weeklyModeSpotlightSeen: weeklyModeSpotlightSeen
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    timeline: {
                        ...state.timeline,
                        weeklyModeSpotlightSeen: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.weekly-mode-spotlight', `Failed to get user property with key: ${(0, $eYbIq.TIMELINE_WEEKLY_MODE_SPOTLIGHT_SEEN)}`, error instanceof Error ? error : undefined);
        }
    };
const $48d6c8a4bc3eca1f$export$f69aea5e1a6558df = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            timeline: {
                ...state.timeline,
                weeklyModeSpotlightSeen: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.TIMELINE_WEEKLY_MODE_SPOTLIGHT_SEEN), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.weekly-mode-spotlight', `Failed to set user property with key: ${(0, $eYbIq.TIMELINE_WEEKLY_MODE_SPOTLIGHT_SEEN)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("ipBVZ", function(module, exports) {
$parcel$export(module.exports, "loadConnectionsSpotlightSeen", () => $e515ea969b4390c8$export$bc77b6302a3f83bd);
$parcel$export(module.exports, "setConnectionsSpotlightSeen", () => $e515ea969b4390c8$export$a2d72629e31ea428);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $e515ea969b4390c8$export$bc77b6302a3f83bd = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        if (typeof getState().timeline.connectionsSpotlightSeen === 'boolean') return;
        try {
            const connectionsSpotlightSeen = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.TIMELINE_CONNECTIONS_SPOTLIGHT_SEEN));
            const state = getState();
            setState({
                timeline: {
                    ...state.timeline,
                    connectionsSpotlightSeen: connectionsSpotlightSeen
                }
            });
        } catch (error) {
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    timeline: {
                        ...state.timeline,
                        connectionsSpotlightSeen: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.connections-spotlight', `Failed to get user property with key: ${(0, $eYbIq.TIMELINE_CONNECTIONS_SPOTLIGHT_SEEN)}`, error instanceof Error ? error : undefined);
        }
    };
const $e515ea969b4390c8$export$a2d72629e31ea428 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            timeline: {
                ...state.timeline,
                connectionsSpotlightSeen: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.TIMELINE_CONNECTIONS_SPOTLIGHT_SEEN), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.connections-spotlight', `Failed to set user property with key: ${(0, $eYbIq.TIMELINE_CONNECTIONS_SPOTLIGHT_SEEN)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("9n3KG", function(module, exports) {
$parcel$export(module.exports, "loadAllViewsSpotlightDismissed", () => $b031241df6c14ac2$export$73f482a9822cc952);
$parcel$export(module.exports, "setAllViewsSpotlightDismissed", () => $b031241df6c14ac2$export$84df3d965709961e);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $b031241df6c14ac2$export$73f482a9822cc952 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().allViews.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                allViews: {
                    ...state.allViews,
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    allViews: {
                        ...state.allViews,
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to get user property with key: ${(0, $eYbIq.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $b031241df6c14ac2$export$84df3d965709961e = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            allViews: {
                ...state.allViews,
                spotlightDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to set user property with key: ${(0, $eYbIq.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };

});

parcelRegister("kwGPB", function(module, exports) {
$parcel$export(module.exports, "loadPrioritizationViewTourDismissed", () => $1f1acc3508025918$export$f610fdf8823d3e34);
$parcel$export(module.exports, "setPrioritizationViewTourDismissed", () => $1f1acc3508025918$export$a72bdc987d4b2c7d);
$parcel$export(module.exports, "setPrioritizationViewTourSpotlightStep", () => $1f1acc3508025918$export$a76ccd1e602a886c);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $1f1acc3508025918$export$f610fdf8823d3e34 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().prioritizationView.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.PRIORITIZATION_VIEW_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                prioritizationView: {
                    ...state.prioritizationView,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    prioritizationView: {
                        ...state.prioritizationView,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.prioritization-view.tour', `Failed to get user property with key: ${(0, $eYbIq.PRIORITIZATION_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $1f1acc3508025918$export$a72bdc987d4b2c7d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            prioritizationView: {
                ...state.prioritizationView,
                tourDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.PRIORITIZATION_VIEW_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.prioritization-view.tour', `Failed to set user property with key: ${(0, $eYbIq.PRIORITIZATION_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $1f1acc3508025918$export$a76ccd1e602a886c = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            prioritizationView: {
                ...state.prioritizationView,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("kESPo", function(module, exports) {
$parcel$export(module.exports, "loadRoadmapViewSpotlightDismissed", () => $51088d955965880e$export$7efa8325e0de15f);
$parcel$export(module.exports, "setRoadmapViewSpotlightDismissed", () => $51088d955965880e$export$b55083c189662aa5);
$parcel$export(module.exports, "loadRoadmapColumnConfigSpotlightDismissed", () => $51088d955965880e$export$9e6f136ba325b100);
$parcel$export(module.exports, "setRoadmapColumnConfigSpotlightDismissed", () => $51088d955965880e$export$866ee7083694a75f);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $51088d955965880e$export$7efa8325e0de15f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().roadmapView.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.ROADMAP_VIEW_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                roadmapView: {
                    ...state.roadmapView,
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    roadmapView: {
                        ...state.roadmapView,
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-spotlight', `Failed to get user property with key: ${(0, $eYbIq.ROADMAP_VIEW_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $51088d955965880e$export$b55083c189662aa5 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            roadmapView: {
                ...state.roadmapView,
                spotlightDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.ROADMAP_VIEW_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-spotlight', `Failed to set user property with key: ${(0, $eYbIq.ROADMAP_VIEW_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $51088d955965880e$export$9e6f136ba325b100 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().roadmapView.columnConfigSpotlightDismissed === 'boolean') return;
        try {
            const columnConfigSpotlightDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                roadmapView: {
                    ...state.roadmapView,
                    columnConfigSpotlightDismissed: columnConfigSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    roadmapView: {
                        ...state.roadmapView,
                        columnConfigSpotlightDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to get user property with key: ${(0, $eYbIq.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $51088d955965880e$export$866ee7083694a75f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            roadmapView: {
                ...state.roadmapView,
                columnConfigSpotlightDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-column-config-spotlight', `Failed to set user property with key: ${(0, $eYbIq.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("bG2f7", function(module, exports) {
$parcel$export(module.exports, "loadPremiumModalDismissed", () => $601055910c706edc$export$f4ca311cb4b4350f);
$parcel$export(module.exports, "setPremiumModalDismissed", () => $601055910c706edc$export$99d8813bb6724f28);
$parcel$export(module.exports, "loadPremiumLastVisit", () => $601055910c706edc$export$6825e78fd5bc05f5);
$parcel$export(module.exports, "setPremiumLastVisit", () => $601055910c706edc$export$c2d4fef533f3196c);
$parcel$export(module.exports, "unlockOnboardingFlow", () => $601055910c706edc$export$f92cc7ff16154919);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");
const $601055910c706edc$export$f4ca311cb4b4350f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().premium.modalDismissed === 'boolean') return;
        try {
            const modalDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.PREMIUM_MODAL_DISMISSED));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    modalDismissed: modalDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    premium: {
                        ...state.premium,
                        modalDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.modal-dismissed', `Failed to get user property with key: ${(0, $eYbIq.PREMIUM_MODAL_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().premium.modalDismissed;
    };
const $601055910c706edc$export$99d8813bb6724f28 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        // we need to pass isPremium to the lastVisit object to ensure that the modal is dismissed
        // when the user is on the premium edition and the last visit was on the free edition
        setState({
            premium: {
                ...state.premium,
                modalDismissed: true,
                lastVisit: {
                    ...state.premium.lastVisit,
                    isPremium: true
                }
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.PREMIUM_MODAL_DISMISSED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.modal-dismissed', `Failed to set user property with key: ${(0, $eYbIq.PREMIUM_MODAL_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $601055910c706edc$export$6825e78fd5bc05f5 = (isPremiumEdition)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().premium.lastVisit.isPremium === 'boolean') return;
        try {
            const lastVisitOnPremium = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.PREMIUM_LAST_VISIT));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    lastVisit: {
                        ...state.premium.lastVisit,
                        isPremium: lastVisitOnPremium
                    }
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    premium: {
                        ...state.premium,
                        lastVisit: {
                            ...state.premium.lastVisit,
                            isPremium: isPremiumEdition
                        }
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.last-visit', `Failed to get user property with key: ${(0, $eYbIq.PREMIUM_LAST_VISIT)}`, error instanceof Error ? error : undefined);
        }
        return getState().premium.modalDismissed;
    };
const $601055910c706edc$export$c2d4fef533f3196c = (isPremium)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if (getState().premium.lastVisit.updated) // If lastVisit has been updated already
        // then don't do it again
        return;
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.PREMIUM_LAST_VISIT), String(isPremium));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    lastVisit: {
                        ...state.premium.lastVisit,
                        updated: true
                    }
                }
            });
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.last-visit', `Failed to set user property with key: ${(0, $eYbIq.PREMIUM_LAST_VISIT)}`, error instanceof Error ? error : undefined);
        }
    };
const $601055910c706edc$export$f92cc7ff16154919 = ()=>async ({ getState: getState })=>{
        getState().premium.promise.resolve();
    };

});

parcelRegister("cUi4O", function(module, exports) {
$parcel$export(module.exports, "loadProductUsageStartTimestamp", () => $94f03617f48e9a93$export$7cb2c6cd0d7c32c0);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $lCetP = parcelRequire("lCetP");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");
const $94f03617f48e9a93$export$7cb2c6cd0d7c32c0 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // usage timestamp already loaded
        if (getState().productUsageStartTimestamp) return;
        try {
            const { isoDateString: productUsageStartTimestamp } = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.PRODUCT_START_TIMESTAMP));
            const state = getState();
            setState({
                ...state,
                productUsageStartTimestamp: productUsageStartTimestamp
            });
        } catch (error) {
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404 || (0, $lCetP.isClientFetchError)(error)) return;
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to get user property with key: ${(0, $eYbIq.PRODUCT_START_TIMESTAMP)}`, error instanceof Error ? error : undefined);
        }
        return getState().productUsageStartTimestamp;
    };

});

parcelRegister("joQUw", function(module, exports) {
$parcel$export(module.exports, "loadCustomDatesCustomizeSpotlightDismissed", () => $3af1b46b0cb16c47$export$4a8766eb957669c8);
$parcel$export(module.exports, "setCustomDatesCustomizeSpotlightDismissed", () => $3af1b46b0cb16c47$export$82bd3ea030c97bbd);

var $63gbl = parcelRequire("63gbl");

var $7Pr7y = parcelRequire("7Pr7y");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $3af1b46b0cb16c47$export$4a8766eb957669c8 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().customDates.customizeSpotlightDismissed === 'boolean') return getState().customDates.customizeSpotlightDismissed;
        try {
            const customizeSpotlightDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                customDates: {
                    ...state.customDates,
                    customizeSpotlightDismissed: customizeSpotlightDismissed
                }
            });
            return customizeSpotlightDismissed;
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    customDates: {
                        customizeSpotlightDismissed: false
                    }
                });
                return false;
            }
            const errorMessage = `Failed to get user property with key: ${(0, $eYbIq.CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED)}`;
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.custom-dates.customize.spotlight', errorMessage, error instanceof Error ? error : new (0, $7Pr7y.UnknownError)(errorMessage, error));
        }
    };
const $3af1b46b0cb16c47$export$82bd3ea030c97bbd = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            customDates: {
                customizeSpotlightDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            const errorMessage = `Failed to set user property with key: ${(0, $eYbIq.CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED)}`;
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.custom-dates.customize.spotlight', errorMessage, error instanceof Error ? error : new (0, $7Pr7y.UnknownError)(errorMessage, error));
        }
    };

});

parcelRegister("38huT", function(module, exports) {
$parcel$export(module.exports, "loadImportState", () => $773ae59bb04e33ac$export$32a519c7542a933);
$parcel$export(module.exports, "setSuccessNotificationViewed", () => $773ae59bb04e33ac$export$c4970fff383b7bfb);

var $2TFAL = parcelRequire("2TFAL");

var $hFtK7 = parcelRequire("hFtK7");

var $63gbl = parcelRequire("63gbl");

var $ifsAO = parcelRequire("ifsAO");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $kc0Nx = parcelRequire("kc0Nx");

var $eYbIq = parcelRequire("eYbIq");

var $8SRwh = parcelRequire("8SRwh");
const $773ae59bb04e33ac$export$32a519c7542a933 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (getState().import.successNotificationViewed !== undefined) return;
        try {
            const remoteState = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.IMPORT_BULK_CREATE_ONBOARDING));
            const state = getState();
            setState({
                ...state,
                import: {
                    ...state.import,
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($2TFAL)))(remoteState, {
                        successNotificationViewed: false
                    })
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    import: {
                        ...state.import,
                        successNotificationViewed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.import-spotlight', `Failed to get user property with key: ${(0, $eYbIq.IMPORT_BULK_CREATE_ONBOARDING)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $773ae59bb04e33ac$export$c4970fff383b7bfb = (successNotificationViewed)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newImportState = {
            ...state.import,
            successNotificationViewed: successNotificationViewed
        };
        setState({
            ...state,
            import: newImportState
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.IMPORT_BULK_CREATE_ONBOARDING), JSON.stringify(newImportState));
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.onboarding.imports-notification', (0, $8SRwh.normalizeError)(error)));
        }
    };

});
parcelRegister("2TFAL", function(module, exports) {

var $3GDE1 = parcelRequire("3GDE1");

var $citK5 = parcelRequire("citK5");

var $cQeQs = parcelRequire("cQeQs");

var $2BDxZ = parcelRequire("2BDxZ");
/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */ var $21c0fb2413ff0805$var$defaultsDeep = $citK5(function(args) {
    args.push(undefined, $cQeQs);
    return $3GDE1($2BDxZ, undefined, args);
});
module.exports = $21c0fb2413ff0805$var$defaultsDeep;

});
parcelRegister("cQeQs", function(module, exports) {

var $evgDw = parcelRequire("evgDw");

var $cslvQ = parcelRequire("cslvQ");
/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */ function $9595db446551ad47$var$customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if ($cslvQ(objValue) && $cslvQ(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        $evgDw(objValue, srcValue, undefined, $9595db446551ad47$var$customDefaultsMerge, stack);
        stack['delete'](srcValue);
    }
    return objValue;
}
module.exports = $9595db446551ad47$var$customDefaultsMerge;

});

parcelRegister("2BDxZ", function(module, exports) {

var $evgDw = parcelRequire("evgDw");

var $luC8x = parcelRequire("luC8x");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $1e5db6bdbaf1f826$var$mergeWith = $luC8x(function(object, source, srcIndex, customizer) {
    $evgDw(object, source, srcIndex, customizer);
});
module.exports = $1e5db6bdbaf1f826$var$mergeWith;

});


parcelRegister("ifsAO", function(module, exports) {
$parcel$export(module.exports, "createErrorAnalytics", () => $bbe086a2044d8577$export$9841879b4fea885b);
$parcel$export(module.exports, "useErrorHandlers", () => $bbe086a2044d8577$export$e0b4869c7401cacb);
$parcel$export(module.exports, "useOnCyclicFormulaFieldError", () => $bbe086a2044d8577$export$4e01d30cacaf82b8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $26fxr = parcelRequire("26fxr");

var $ah9qo = parcelRequire("ah9qo");

var $2EFuW = parcelRequire("2EFuW");

var $d0F9p = parcelRequire("d0F9p");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $fV62N = parcelRequire("fV62N");

var $l9N6c = parcelRequire("l9N6c");

var $f6qTB = parcelRequire("f6qTB");
const $bbe086a2044d8577$var$errorTitle = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.error-title",
    defaultMessage: "Something went wrong."
});
const $bbe086a2044d8577$var$permissionErrorDescription = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.permission-error-description",
    defaultMessage: "You may not have the permissions required to perform this operation."
});
const $bbe086a2044d8577$var$configErrorTitle = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.config-error-title",
    defaultMessage: "We couldn't save that."
});
const $bbe086a2044d8577$var$configErrorDescription = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.config-error-description",
    defaultMessage: "This usually happens because the configuration data on this field is too big. Contact support for more details"
});
const $bbe086a2044d8577$var$serverLoadFailedDescription = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.server-load-failed-description",
    defaultMessage: "We had difficulties to fetch some data from the server. Please refresh the page."
});
const $bbe086a2044d8577$var$serverUpdateFailedDescription = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.server-update-failed-description",
    defaultMessage: "We had some difficulties to save some data to the server. Please try again or refresh the page."
});
const $bbe086a2044d8577$var$errorDescription = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.error-description",
    defaultMessage: "We failed to execute your last operation. Our team has been notified. Please refresh the page to try again."
});
const $bbe086a2044d8577$var$errorPossibleAccessLoss = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.error-possible-access-loss",
    defaultMessage: "You may have lost access to the project or site. Please refresh the page."
});
const $bbe086a2044d8577$var$cyclicFormulaFieldDescription = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.cyclic-formula-field-description",
    defaultMessage: "We cannot calculate the value of some fields because they contain a cyclic formula. Please edit the field configurations and refresh: {fieldLabels}"
});
const $bbe086a2044d8577$var$entityLimitErrorTitle = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error-title",
    defaultMessage: "You\u2019ve hit a limit"
});
const $bbe086a2044d8577$var$errorPossibleAccessLossGalaxia = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.error-possible-access-loss-galaxia",
    defaultMessage: "You may have lost access to the space or site. Please refresh the page."
});
const $bbe086a2044d8577$export$9841879b4fea885b = (id, error, options)=>({
        meta: {
            id: id
        },
        error: error,
        sendToPrivacyUnsafeSplunk: options?.sendToPrivacyUnsafeSplunk ?? true,
        skipSentry: options?.skipSentry ?? false
    });
const $bbe086a2044d8577$var$handleCallback = (errorObject, callback)=>{
    callback && callback((0, $f6qTB.getMetadata)(errorObject));
};
const $bbe086a2044d8577$var$useGeneralDataLoadingFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $26fxr.useNotifications)();
    return (0, $euxye.useCallback)((errorObject, callback)=>{
        $bbe086a2044d8577$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage($bbe086a2044d8577$var$errorTitle),
            description: formatMessage($bbe086a2044d8577$var$serverLoadFailedDescription)
        });
        (0, $hFtK7.fireErrorAnalytics)($bbe086a2044d8577$export$9841879b4fea885b('polaris.error.generalDataLoadingFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $bbe086a2044d8577$var$useGeneralDataUpdateFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { error: error, errorWithRefresh: errorWithRefresh, customFlag: customFlag } = (0, $26fxr.useNotifications)();
    return (0, $euxye.useCallback)((errorObject, callback)=>{
        $bbe086a2044d8577$var$handleCallback(errorObject, callback);
        (0, $hFtK7.fireErrorAnalytics)($bbe086a2044d8577$export$9841879b4fea885b('polaris.error.generalDataUpdateFailed', errorObject));
        const entityLimitError = (0, $fV62N.getEntityLimitError)(errorObject);
        if (entityLimitError) {
            const errorMessage = (0, $fV62N.getErrorMessageDescriptor)(entityLimitError);
            return errorMessage ? customFlag({
                title: formatMessage($bbe086a2044d8577$var$entityLimitErrorTitle),
                description: formatMessage(errorMessage, {
                    item: (chunks)=>// we are using feature gate here, because tag's text type is different then lozenge's children type. we need to convert chunks to string when feature gate is on.
                        (0, $i860n.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d0F9p.default), {
                            text: chunks.map(String).join(''),
                            color: "standard",
                            isRemovable: false,
                            hasMargin: false,
                            migration_fallback: "lozenge"
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), null, chunks)
                }),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ah9qo))), {
                    spacing: "spacious",
                    label: "Error",
                    color: "var(--ds-icon-danger, #C9372C)"
                })
            }) : null;
        }
        if ((0, $f6qTB.isPermissionError)(errorObject)) return error({
            title: formatMessage($bbe086a2044d8577$var$errorTitle),
            description: formatMessage($bbe086a2044d8577$var$permissionErrorDescription)
        });
        if ((0, $f6qTB.isConfigError)(errorObject)) return error({
            title: formatMessage($bbe086a2044d8577$var$configErrorTitle),
            description: formatMessage($bbe086a2044d8577$var$configErrorDescription)
        });
        errorWithRefresh({
            title: formatMessage($bbe086a2044d8577$var$errorTitle),
            description: formatMessage($bbe086a2044d8577$var$serverUpdateFailedDescription)
        });
    }, [
        customFlag,
        error,
        errorWithRefresh,
        formatMessage
    ]);
};
const $bbe086a2044d8577$var$useGeneralActionFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $26fxr.useNotifications)();
    return (0, $euxye.useCallback)((errorObject, callback)=>{
        $bbe086a2044d8577$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage($bbe086a2044d8577$var$errorTitle),
            description: formatMessage($bbe086a2044d8577$var$errorDescription)
        });
        (0, $hFtK7.fireErrorAnalytics)($bbe086a2044d8577$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $bbe086a2044d8577$var$usePossibleAccessLossError = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $26fxr.useNotifications)();
    return (0, $euxye.useCallback)((errorObject, callback)=>{
        $bbe086a2044d8577$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage($bbe086a2044d8577$var$errorTitle),
            description: formatMessage((0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $bbe086a2044d8577$var$errorPossibleAccessLossGalaxia : $bbe086a2044d8577$var$errorPossibleAccessLoss)
        });
        // Skip Sentry for PolarisAccessLossError since it's an expected business scenario
        // (e.g. 403 when user loses access to a view).
        const skipSentry = errorObject instanceof (0, $l9N6c.PolarisAccessLossError);
        (0, $hFtK7.fireErrorAnalytics)($bbe086a2044d8577$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject, {
            skipSentry: skipSentry
        }));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $bbe086a2044d8577$export$e0b4869c7401cacb = ()=>{
    const possibleAccessLossError = $bbe086a2044d8577$var$usePossibleAccessLossError();
    const generalActionFailedError = $bbe086a2044d8577$var$useGeneralActionFailedHandling();
    const generalDataUpdateFailedError = $bbe086a2044d8577$var$useGeneralDataUpdateFailedHandling();
    const generalDataLoadingFailedError = $bbe086a2044d8577$var$useGeneralDataLoadingFailedHandling();
    return (0, $euxye.useMemo)(()=>({
            possibleAccessLossError: possibleAccessLossError,
            generalActionFailedError: generalActionFailedError,
            generalDataUpdateFailedError: generalDataUpdateFailedError,
            generalDataLoadingFailedError: generalDataLoadingFailedError
        }), [
        possibleAccessLossError,
        generalActionFailedError,
        generalDataUpdateFailedError,
        generalDataLoadingFailedError
    ]);
};
const $bbe086a2044d8577$export$4e01d30cacaf82b8 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { error: error } = (0, $26fxr.useNotifications)();
    return (0, $euxye.useCallback)((fieldLabels)=>{
        error({
            title: formatMessage($bbe086a2044d8577$var$errorTitle),
            description: formatMessage($bbe086a2044d8577$var$cyclicFormulaFieldDescription, {
                fieldLabels: fieldLabels.join(', ')
            })
        });
        (0, $hFtK7.fireErrorAnalytics)($bbe086a2044d8577$export$9841879b4fea885b('polaris.error.cyclicFormula', new Error('Cyclic formula field')));
    }, [
        error,
        formatMessage
    ]);
};

});
parcelRegister("26fxr", function(module, exports) {
$parcel$export(module.exports, "useNotifications", () => $6c1ecbef9fb0a71d$export$53d5ca6c3f53e109);

var $euxye = parcelRequire("euxye");

var $7TA2J = parcelRequire("7TA2J");

var $8Qvei = parcelRequire("8Qvei");

var $ah9qo = parcelRequire("ah9qo");

var $bzpbb = parcelRequire("bzpbb");
var $aR9wy = parcelRequire("aR9wy");
var $acwzf = parcelRequire("acwzf");
var $iQPOZ = parcelRequire("iQPOZ");
const $6c1ecbef9fb0a71d$var$customFlagCommon = (notification, onDismiss, AkFlagComponent)=>{
    const id = (0, $7TA2J.v4)();
    return {
        id: id,
        render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(AkFlagComponent, {
                id: id,
                ...notification,
                // oxlint-disable-next-line typescript/consistent-type-assertions
                onDismissed: (flagId)=>onDismiss(flagId),
                ...props,
                messageId: notification.messageId ?? `polaris-lib-notifications.controllers.ak-flag-component.${id}`,
                messageType: notification.messageType ?? 'transactional'
            })
    };
};
const $6c1ecbef9fb0a71d$var$customFlag = (notification, onDismiss)=>$6c1ecbef9fb0a71d$var$customFlagCommon(notification, onDismiss, (0, $aR9wy.default));
const $6c1ecbef9fb0a71d$var$customAutoDismissFlag = (notification, onDismiss)=>$6c1ecbef9fb0a71d$var$customFlagCommon(notification, onDismiss, (0, $bzpbb.default));
const $6c1ecbef9fb0a71d$var$success = (notification, onDismiss)=>$6c1ecbef9fb0a71d$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.success.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Qvei))), {
            spacing: "spacious",
            label: "Success icon",
            color: "var(--ds-icon-success, #6A9A23)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.success',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.success',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $6c1ecbef9fb0a71d$var$errorWithRefresh = (notification, onDismiss)=>$6c1ecbef9fb0a71d$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: [
            ...notification.actions || [],
            {
                content: 'Refresh',
                testId: 'refresh',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.reload()
            }
        ].map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error-refresh.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ah9qo))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error-refresh',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.errorWithRefresh',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $6c1ecbef9fb0a71d$var$error = (notification, onDismiss)=>$6c1ecbef9fb0a71d$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ah9qo))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.error',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $6c1ecbef9fb0a71d$export$53d5ca6c3f53e109 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $iQPOZ.useFlagsService)();
    return (0, $euxye.useMemo)(()=>({
            customFlag: (notification)=>{
                const flagId = showFlag($6c1ecbef9fb0a71d$var$customFlag(notification, dismissFlag));
                // oxlint-disable-next-line typescript/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            success: (notification)=>{
                const flagId = showFlag($6c1ecbef9fb0a71d$var$success(notification, dismissFlag));
                // oxlint-disable-next-line typescript/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            errorWithRefresh: (notification)=>{
                const flagId = showFlag($6c1ecbef9fb0a71d$var$errorWithRefresh(notification, dismissFlag));
                // oxlint-disable-next-line typescript/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            error: (notification)=>{
                const flagId = showFlag($6c1ecbef9fb0a71d$var$error(notification, dismissFlag));
                // oxlint-disable-next-line typescript/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $acwzf.toFlagId)((0, $7TA2J.v4)());
                const flagId = showFlag({
                    ...flag,
                    id: id,
                    key: id,
                    messageId: flag.messageId ?? `polaris-lib-notifications.controllers.showFlag.${id}`,
                    messageType: flag.messageType ?? 'transactional'
                });
                // oxlint-disable-next-line typescript/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showCustomFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $acwzf.toFlagId)((0, $7TA2J.v4)());
                const flagId = showFlag({
                    messageId: `polaris-lib-notifications.controllers.showCustomFlag.${id}`,
                    messageType: 'transactional',
                    ...flag,
                    id: id
                });
                // oxlint-disable-next-line typescript/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            dismissFlag: dismissFlag
        }), [
        showFlag,
        dismissFlag
    ]);
};

});
parcelRegister("bzpbb", function(module, exports) {
$parcel$export(module.exports, "default", () => $559b3c736f67ed77$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bafqJ = parcelRequire("bafqJ");

var $3mYdc = parcelRequire("3mYdc");
const $559b3c736f67ed77$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3mYdc.CommonFlag), {
        isAutoDismiss: true,
        ...props,
        flagType: "info"
    }));
$559b3c736f67ed77$var$AkAutoDismissFlag.displayName = "AkAutoDismissFlag";
var $559b3c736f67ed77$export$2e2bcd8739ae039 = $559b3c736f67ed77$var$AkAutoDismissFlag;

});

parcelRegister("aR9wy", function(module, exports) {
$parcel$export(module.exports, "default", () => $02a3de1e09014466$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bafqJ = parcelRequire("bafqJ");

var $3mYdc = parcelRequire("3mYdc");
const $02a3de1e09014466$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3mYdc.CommonFlag), {
        flagType: "info",
        ...props
    }));
$02a3de1e09014466$var$AkFlag.displayName = "AkFlag";
var $02a3de1e09014466$export$2e2bcd8739ae039 = $02a3de1e09014466$var$AkFlag;

});


parcelRegister("fV62N", function(module, exports) {
$parcel$export(module.exports, "EntityLimitError", () => $37df1b32c58e21b8$export$c4e01b2c2ba95919);
$parcel$export(module.exports, "getEntityLimitError", () => $37df1b32c58e21b8$export$13f6f9a6b905ebbd);
$parcel$export(module.exports, "getErrorMessageDescriptor", () => $37df1b32c58e21b8$export$cf58cbb2768ea4f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6Tm5Y = parcelRequire("6Tm5Y");

var $65397 = parcelRequire("65397");

var $2KgJI = parcelRequire("2KgJI");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");

var $7TWAO = parcelRequire("7TWAO");
const $37df1b32c58e21b8$var$commentsPerViewMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.comments-per-view",
    defaultMessage: "We couldn\u2019t create a new <item>comment</item> because this <item>view</item> has reached its limit for <item>comments</item>. Remove <item>comment</item> to create a new <item>comment</item>"
});
const $37df1b32c58e21b8$var$fieldsPerViewMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.fields-per-view",
    defaultMessage: "We couldn\u2019t create a new <item>field</item> because this <item>view</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
});
const $37df1b32c58e21b8$var$fieldsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.fields-per-project",
    defaultMessage: "We couldn\u2019t create a new <item>field</item> because this <item>project</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
});
const $37df1b32c58e21b8$var$insightsPerIdeaMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.insights-per-idea",
    defaultMessage: "We couldn\u2019t create a new <item>insight</item> because this <item>idea</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
});
const $37df1b32c58e21b8$var$insightsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.insights-per-project",
    defaultMessage: "We couldn\u2019t create a new <item>insight</item> because this <item>project</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
});
const $37df1b32c58e21b8$var$labelsPerSnippetMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.labels-per-snippet",
    defaultMessage: "We couldn\u2019t create a new <item>label</item> because this <item>snippet</item> has reached its limit for <item>labels</item>. Remove <item>label</item> to create a new <item>label</item>"
});
const $37df1b32c58e21b8$var$optionsPerFieldMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.options-per-field",
    defaultMessage: "We couldn\u2019t create a new <item>option</item> because this <item>field</item> has reached its limit for <item>options</item>. Remove <item>option</item> to create a new <item>option</item>"
});
const $37df1b32c58e21b8$var$playContributionsPerPlayMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-play",
    defaultMessage: "We couldn\u2019t create a new <item>vote contribution</item> because this <item>vote</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
});
const $37df1b32c58e21b8$var$playContributionsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-project",
    defaultMessage: "We couldn\u2019t create a new <item>vote contribution</item> because this <item>project</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
});
const $37df1b32c58e21b8$var$playsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.plays-per-project",
    defaultMessage: "We couldn\u2019t create a new <item>vote</item> because this <item>project</item> has reached its limit for <item>votes</item>. Remove <item>vote</item> to create a new <item>vote</item>"
});
const $37df1b32c58e21b8$var$snippetsPerInsightMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.snippets-per-insight",
    defaultMessage: "We couldn\u2019t create a new <item>snippet</item> because this <item>insight</item> has reached its limit for <item>snippets</item>. Remove <item>snippet</item> to create a new <item>snippet</item>"
});
const $37df1b32c58e21b8$var$viewsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.views-per-project",
    defaultMessage: "We couldn\u2019t create a new <item>view</item> because this <item>project</item> has reached its limit for <item>views</item>. Remove <item>view</item> to create a new <item>view</item>"
});
const $37df1b32c58e21b8$var$viewsPerCollectionMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.views-per-collection",
    defaultMessage: "We couldn\u2019t create a new <item>view</item> because this <item>roadmap</item> has reached its limit for <item>views</item>. Remove <item>view</item> to create a new <item>view</item>"
});
const $37df1b32c58e21b8$var$viewsetsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-project",
    defaultMessage: "We couldn\u2019t create a new <item>section</item> because this <item>project</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
});
const $37df1b32c58e21b8$var$viewsetsPerCollectionMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-collection",
    defaultMessage: "We couldn\u2019t create a new <item>section</item> because this <item>roadmap</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
});
const $37df1b32c58e21b8$var$viewsetsPerProjectGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-project-galaxia",
    defaultMessage: "We couldn\u2019t create a new <item>section</item> because this <item>space</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
});
const $37df1b32c58e21b8$var$messages = {
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).COMMENTS_PER_VIEW]: $37df1b32c58e21b8$var$commentsPerViewMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_VIEW]: $37df1b32c58e21b8$var$fieldsPerViewMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_PROJECT]: $37df1b32c58e21b8$var$fieldsPerProjectMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_IDEA]: $37df1b32c58e21b8$var$insightsPerIdeaMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_PROJECT]: $37df1b32c58e21b8$var$insightsPerProjectMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).LABELS_PER_SNIPPET]: $37df1b32c58e21b8$var$labelsPerSnippetMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).OPTIONS_PER_FIELD]: $37df1b32c58e21b8$var$optionsPerFieldMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PLAY]: $37df1b32c58e21b8$var$playContributionsPerPlayMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PROJECT]: $37df1b32c58e21b8$var$playContributionsPerProjectMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).PLAYS_PER_PROJECT]: $37df1b32c58e21b8$var$playsPerProjectMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).SNIPPETS_PER_INSIGHT]: $37df1b32c58e21b8$var$snippetsPerInsightMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).VIEWS_PER_PROJECT]: $37df1b32c58e21b8$var$viewsPerProjectMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).VIEWS_PER_COLLECTION]: $37df1b32c58e21b8$var$viewsPerCollectionMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT]: $37df1b32c58e21b8$var$viewsetsPerProjectMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_COLLECTION]: $37df1b32c58e21b8$var$viewsetsPerCollectionMessage,
    viewsetsPerProjectGalaxia: $37df1b32c58e21b8$var$viewsetsPerProjectGalaxiaMessage
};
class $37df1b32c58e21b8$export$c4e01b2c2ba95919 extends (0, $2KgJI.default) {
    constructor(message, errors = [], statusCode = null, type){
        super(message, {
            cause: errors[0]
        }), this.name = 'EntityLimitError';
        this.errors = errors;
        this.statusCode = statusCode;
        this.type = type;
    }
}
$37df1b32c58e21b8$export$c4e01b2c2ba95919.displayName = "EntityLimitError";
const $37df1b32c58e21b8$var$findEntityLimitError = (graphQLErrors)=>{
    const entityLimitError = graphQLErrors.filter((err)=>err.extensions?.limitType)[0];
    if (!entityLimitError?.extensions) return null;
    const { statusCode: statusCode, limitType: limitType } = entityLimitError.extensions;
    if (!limitType) return null;
    const entityLimitErrorType = (0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE)[limitType];
    return new $37df1b32c58e21b8$export$c4e01b2c2ba95919(entityLimitError.message, [
        {
            error: entityLimitError.message
        }
    ], statusCode, entityLimitErrorType);
};
const $37df1b32c58e21b8$export$13f6f9a6b905ebbd = (error)=>{
    if (error instanceof $37df1b32c58e21b8$export$c4e01b2c2ba95919) return error;
    return error instanceof (0, $65397.RelayNetworkError) || error instanceof (0, $6Tm5Y.GraphQLResponseError) ? $37df1b32c58e21b8$var$findEntityLimitError(error.graphQLErrors) : null;
};
const $37df1b32c58e21b8$export$cf58cbb2768ea4f = (error)=>{
    if (error.type === (0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT && (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false)) return $37df1b32c58e21b8$var$messages[`${error.type}Galaxia`];
    return $37df1b32c58e21b8$var$messages[error.type] || null;
};

});
parcelRegister("6Tm5Y", function(module, exports) {
$parcel$export(module.exports, "GraphQLResponseError", () => $4fd845211c7cfcf5$export$e79568ed5ed78a3);
class $4fd845211c7cfcf5$export$e79568ed5ed78a3 extends Error {
    constructor(message, graphQLErrors){
        super(message);
        this.name = 'GraphQLResponseError';
        this.graphQLErrors = graphQLErrors;
    }
}
$4fd845211c7cfcf5$export$e79568ed5ed78a3.displayName = "GraphQLResponseError";

});

parcelRegister("65397", function(module, exports) {
$parcel$export(module.exports, "RelayNetworkError", () => $a65a76d15dc0438a$export$e13695f8013e7a53);
$parcel$export(module.exports, "createRelayNetworkError", () => $a65a76d15dc0438a$export$92f5ce6ff48e5a7b);
class $a65a76d15dc0438a$export$e13695f8013e7a53 extends Error {
    constructor(error){
        super(error.message), this.type = 'network', this.graphQLErrors = [];
        this.name = 'NetworkError';
        this.originalError = error;
        this.networkError = error;
        this.statusCode = 'statusCode' in error && typeof error.statusCode === 'number' ? error.statusCode : undefined;
    }
}
$a65a76d15dc0438a$export$e13695f8013e7a53.displayName = "RelayNetworkError";
const $a65a76d15dc0438a$export$92f5ce6ff48e5a7b = (error)=>new $a65a76d15dc0438a$export$e13695f8013e7a53(error);

});

parcelRegister("7TWAO", function(module, exports) {
$parcel$export(module.exports, "ENTITY_LIMIT_ERROR_TYPE", () => $c20076fc63673537$export$a197d88688faa32c);
/* eslint-disable jira/filename-case */ const $c20076fc63673537$export$a197d88688faa32c = {
    COMMENTS_PER_VIEW: 'commentsPerView',
    FIELDS_PER_VIEW: 'fieldsPerView',
    FIELDS_PER_PROJECT: 'fieldsPerProject',
    INSIGHTS_PER_IDEA: 'insightsPerIdea',
    INSIGHTS_PER_PROJECT: 'insightsPerProject',
    LABELS_PER_SNIPPET: 'labelsPerSnippet',
    OPTIONS_PER_FIELD: 'optionsPerField',
    PLAY_CONTRIBUTIONS_PER_PLAY: 'playContributionsPerPlay',
    PLAY_CONTRIBUTIONS_PER_PROJECT: 'playContributionsPerProject',
    PLAYS_PER_PROJECT: 'playsPerProject',
    SNIPPETS_PER_INSIGHT: 'snippetsPerInsight',
    VIEWS_PER_PROJECT: 'viewsPerProject',
    VIEWS_PER_COLLECTION: 'viewsPerCollection',
    VIEWSETS_PER_PROJECT: 'viewsetsPerProject',
    VIEWSETS_PER_COLLECTION: 'viewsetsPerCollection'
};

});


parcelRegister("l9N6c", function(module, exports) {
$parcel$export(module.exports, "PolarisAccessLossError", () => $0b62b55e266078bb$export$53d8cc65d6486762);

var $2KgJI = parcelRequire("2KgJI");
class $0b62b55e266078bb$export$53d8cc65d6486762 extends (0, $2KgJI.default) {
    constructor(...args){
        super(...args), this.name = 'PolarisAccessLossError';
    }
}
$0b62b55e266078bb$export$53d8cc65d6486762.displayName = "PolarisAccessLossError";

});

parcelRegister("f6qTB", function(module, exports) {
$parcel$export(module.exports, "isPermissionError", () => $65e957623186e840$export$e11674744930cd15);
$parcel$export(module.exports, "isRateLimitError", () => $65e957623186e840$export$a8908c3867f6f20b);
$parcel$export(module.exports, "isAccessForbiddenError", () => $65e957623186e840$export$443ae86cf12ba84);
$parcel$export(module.exports, "isNotFoundError", () => $65e957623186e840$export$6ccdb59d3479f4f1);
$parcel$export(module.exports, "isBadRequestError", () => $65e957623186e840$export$cb878a62cae2cb6);
$parcel$export(module.exports, "isClientClosedError", () => $65e957623186e840$export$ce14333297f1d017);
$parcel$export(module.exports, "isBadRequest", () => $65e957623186e840$export$9ec5d1f0bf2939c);
$parcel$export(module.exports, "isConflictError", () => $65e957623186e840$export$b43c7b888ac6458);
$parcel$export(module.exports, "isConfigError", () => $65e957623186e840$export$5e48c9e1c3c8f299);
$parcel$export(module.exports, "getMetadata", () => $65e957623186e840$export$8548546c0aa631e6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6Tcej = parcelRequire("6Tcej");

var $jOlpf = parcelRequire("jOlpf");

var $gznU1 = parcelRequire("gznU1");
const $65e957623186e840$export$e11674744930cd15 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 401 || errorObject.statusCode === 403;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'graphQLErrors') && (0, (/*@__PURE__*/$parcel$interopDefault($jOlpf)))(errorObject.graphQLErrors)) // graphql response error, check polaris-specific payload
    return (0, (/*@__PURE__*/$parcel$interopDefault($gznU1)))(errorObject.graphQLErrors, (error)=>{
        const safeMessage = error.message || '';
        return(// that's probably obsolete
        // that's probably obsolete
        error.extensions?.statusCode === 403 || error.extensions?.statusCode === 401 || safeMessage.includes('JIRA_ACCESS_NOT_PERMITTED') || safeMessage.includes('RequestStatus: 401') || safeMessage.includes('RequestStatus: 403') || safeMessage.includes('status code 401') || safeMessage.includes('status code 403'));
    });
    return false;
};
const $65e957623186e840$var$checkRateLimitErrorMatch = (error)=>{
    const safeMessage = error?.message || '';
    return error && 'statusCode' in error && error?.statusCode === 429 || error && 'extensions' in error && error.extensions?.statusCode === 429 || safeMessage.includes('RequestStatus: 429') || safeMessage.includes('status code 429');
};
const $65e957623186e840$export$a8908c3867f6f20b = (errorObject)=>{
    return $65e957623186e840$var$checkRateLimitErrorMatch(errorObject) || errorObject.networkError && $65e957623186e840$var$checkRateLimitErrorMatch(errorObject.networkError) || errorObject?.graphQLErrors?.some((error)=>$65e957623186e840$var$checkRateLimitErrorMatch(error)) || false;
};
const $65e957623186e840$export$443ae86cf12ba84 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 403;
    return false;
};
const $65e957623186e840$export$6ccdb59d3479f4f1 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 404;
    return false;
};
const $65e957623186e840$export$cb878a62cae2cb6 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 400;
    return false;
};
const $65e957623186e840$export$ce14333297f1d017 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 499;
    return false;
};
const $65e957623186e840$export$9ec5d1f0bf2939c = (errorObject)=>{
    if (errorObject?.statusCode) // http response error, check status code
    return errorObject?.statusCode >= 400 && errorObject?.statusCode < 500;
    return false;
};
const $65e957623186e840$export$b43c7b888ac6458 = (errorObject)=>errorObject.statusCode === 409;
const $65e957623186e840$export$5e48c9e1c3c8f299 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'statusCode') && (0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'message')) return errorObject.statusCode === 500 && errorObject.message === 'Property is too long';
    return false;
};
const $65e957623186e840$export$8548546c0aa631e6 = (errorObject)=>({
        metadata: {
            error: errorObject.message
        }
    });

});
parcelRegister("gznU1", function(module, exports) {

var $crqhp = parcelRequire("crqhp");

var $9JUaE = parcelRequire("9JUaE");

var $4N94P = parcelRequire("4N94P");

var $jOlpf = parcelRequire("jOlpf");

var $4qbYM = parcelRequire("4qbYM");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $c10274c993e2d0d6$var$some(collection, predicate, guard) {
    var func = $jOlpf(collection) ? $crqhp : $4N94P;
    if (guard && $4qbYM(collection, predicate, guard)) predicate = undefined;
    return func(collection, $9JUaE(predicate, 3));
}
module.exports = $c10274c993e2d0d6$var$some;

});
parcelRegister("4N94P", function(module, exports) {

var $73ZOi = parcelRequire("73ZOi");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $37d2c77eb2ade812$var$baseSome(collection, predicate) {
    var result;
    $73ZOi(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $37d2c77eb2ade812$var$baseSome;

});





parcelRegister("hUyAI", function(module, exports) {
$parcel$export(module.exports, "loadUnifiedShareDialogSpotlightState", () => $5e4bcc2ea610ded2$export$6bcae6c74c588cf);
$parcel$export(module.exports, "setUnifiedShareDialogSpotlightDismissed", () => $5e4bcc2ea610ded2$export$3f7f2ce2f5c73fe1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $kc0Nx = parcelRequire("kc0Nx");

var $eYbIq = parcelRequire("eYbIq");
const $5e4bcc2ea610ded2$export$6bcae6c74c588cf = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().unifiedShareDialog.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.UNIFIED_SHARE_DIALOG_SPOTLIGHT));
            const state = getState();
            setState({
                ...state,
                unifiedShareDialog: {
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    unifiedShareDialog: {
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.unified-share-dialog-spotlight', `Failed to get user property with key: ${(0, $eYbIq.UNIFIED_SHARE_DIALOG_SPOTLIGHT)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $5e4bcc2ea610ded2$export$3f7f2ce2f5c73fe1 = (spotlightDismissed)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newUnifiedShareDialogState = {
            spotlightDismissed: spotlightDismissed
        };
        setState({
            ...state,
            unifiedShareDialog: newUnifiedShareDialogState
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.UNIFIED_SHARE_DIALOG_SPOTLIGHT), JSON.stringify(spotlightDismissed));
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.unified-share-dialog-spotlight', `Failed to set user property with key: ${(0, $eYbIq.UNIFIED_SHARE_DIALOG_SPOTLIGHT)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };

});

parcelRegister("aaq2c", function(module, exports) {
$parcel$export(module.exports, "loadTreeViewOnboardingSpotlightDismissed", () => $4d4d21f35f9435a6$export$57fa97add3b29d09);
$parcel$export(module.exports, "setTreeViewOnboardingSpotlightDismissed", () => $4d4d21f35f9435a6$export$4e829d5bda8ebf71);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $4d4d21f35f9435a6$export$57fa97add3b29d09 = ()=>({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return Promise.resolve();
        // If a load is already in flight, join it instead of firing a duplicate request
        const existing = getState().treeViewOnboarding.loadingPromise;
        if (existing !== undefined) return existing;
        // User property is already loaded — no need to fetch
        if (typeof getState().treeViewOnboarding.spotlightDismissed === 'boolean') return Promise.resolve();
        const promise = (async ()=>{
            await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
            try {
                const spotlightDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.TREE_VIEW_ONBOARDING_SPOTLIGHT_DISMISSED));
                const state = getState();
                setState({
                    ...state,
                    treeViewOnboarding: {
                        ...state.treeViewOnboarding,
                        spotlightDismissed: spotlightDismissed,
                        loadingPromise: undefined
                    }
                });
            } catch (error) {
                // Expected error, the property is not set yet
                if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                    const state = getState();
                    setState({
                        ...state,
                        treeViewOnboarding: {
                            ...state.treeViewOnboarding,
                            spotlightDismissed: false,
                            loadingPromise: undefined
                        }
                    });
                    return;
                }
                const state = getState();
                setState({
                    ...state,
                    treeViewOnboarding: {
                        ...state.treeViewOnboarding,
                        loadingPromise: undefined
                    }
                });
                (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.tree-view-onboarding-spotlight', `Failed to get user property with key: ${(0, $eYbIq.TREE_VIEW_ONBOARDING_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
            }
        })();
        const state = getState();
        setState({
            ...state,
            treeViewOnboarding: {
                ...state.treeViewOnboarding,
                loadingPromise: promise
            }
        });
        return promise;
    };
const $4d4d21f35f9435a6$export$4e829d5bda8ebf71 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            treeViewOnboarding: {
                ...state.treeViewOnboarding,
                spotlightDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.TREE_VIEW_ONBOARDING_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            // Roll back the optimistic update so the spotlight can still show this session
            const currentState = getState();
            setState({
                ...currentState,
                treeViewOnboarding: {
                    ...currentState.treeViewOnboarding,
                    spotlightDismissed: false
                }
            });
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.tree-view-onboarding-spotlight', `Failed to set user property with key: ${(0, $eYbIq.TREE_VIEW_ONBOARDING_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };

});

parcelRegister("YY7RB", function(module, exports) {
$parcel$export(module.exports, "loadCardCoverSpotlightState", () => $5437b47508cdd189$export$c065628912956a12);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $kc0Nx = parcelRequire("kc0Nx");

var $eYbIq = parcelRequire("eYbIq");
const $5437b47508cdd189$export$c065628912956a12 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().cardCoverSpotlight.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.CARD_COVERS_SPOTLIGHT));
            const state = getState();
            setState({
                ...state,
                cardCoverSpotlight: {
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    cardCoverSpotlight: {
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.card-cover-spotlight', `Failed to get user property with key: ${(0, $eYbIq.CARD_COVERS_SPOTLIGHT)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };

});

parcelRegister("lG4yo", function(module, exports) {
$parcel$export(module.exports, "setCardCoverSpotlightDismissed", () => $395c719e41d64628$export$babb0e140c360893);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $eYbIq = parcelRequire("eYbIq");
const $395c719e41d64628$export$babb0e140c360893 = (spotlightDismissed)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newCardCoverSpotlightState = {
            spotlightDismissed: spotlightDismissed
        };
        setState({
            ...state,
            cardCoverSpotlight: newCardCoverSpotlightState
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.CARD_COVERS_SPOTLIGHT), JSON.stringify(spotlightDismissed));
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.card-cover-spotlight', `Failed to set user property with key: ${(0, $eYbIq.CARD_COVERS_SPOTLIGHT)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };

});

parcelRegister("ip08d", function(module, exports) {
$parcel$export(module.exports, "loadStartWithTemplateSpotlightDismissed", () => $9ee960a7565b0eba$export$d2662af5df54cf6c);
$parcel$export(module.exports, "setStartWithTemplateSpotlightDismissed", () => $9ee960a7565b0eba$export$59694d61aadf168);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $9ee960a7565b0eba$export$d2662af5df54cf6c = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        if (typeof getState().startWithTemplateSpotlight.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.START_WITH_TEMPLATE_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                startWithTemplateSpotlight: {
                    ...state.startWithTemplateSpotlight,
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    startWithTemplateSpotlight: {
                        ...state.startWithTemplateSpotlight,
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.start-with-template-spotlight', `Failed to get user property with key: ${(0, $eYbIq.START_WITH_TEMPLATE_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $9ee960a7565b0eba$export$59694d61aadf168 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            startWithTemplateSpotlight: {
                ...state.startWithTemplateSpotlight,
                spotlightDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.START_WITH_TEMPLATE_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.start-with-template-spotlight', `Failed to set user property with key: ${(0, $eYbIq.START_WITH_TEMPLATE_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };

});

parcelRegister("7ciXq", function(module, exports) {
$parcel$export(module.exports, "loadJqlFiltersSpotlightDismissed", () => $9da2f487032706b7$export$8c178a5c424826e0);
$parcel$export(module.exports, "setJqlFiltersSpotlightDismissed", () => $9da2f487032706b7$export$624e09f8f82f1e3b);

var $63gbl = parcelRequire("63gbl");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $eYbIq = parcelRequire("eYbIq");

var $kc0Nx = parcelRequire("kc0Nx");
const $9da2f487032706b7$export$8c178a5c424826e0 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $kc0Nx.maybeWaitForPremiumModal)(getState);
        if (typeof getState().jqlFilters.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $kM0go.getUserProperty)(accountId, (0, $eYbIq.JQL_FILTERS_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                jqlFilters: {
                    ...state.jqlFilters,
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    jqlFilters: {
                        ...state.jqlFilters,
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.jql-filters-spotlight', `Failed to get user property with key: ${(0, $eYbIq.JQL_FILTERS_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $9da2f487032706b7$export$624e09f8f82f1e3b = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            jqlFilters: {
                ...state.jqlFilters,
                spotlightDismissed: true
            }
        });
        try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $eYbIq.JQL_FILTERS_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.jql-filters-spotlight', `Failed to set user property with key: ${(0, $eYbIq.JQL_FILTERS_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});



parcelRegister("5Vnw3", function(module, exports) {
$parcel$export(module.exports, "useCollectionsTourDismissed", () => $ecb2b61bd8694fdb$export$17de768881ff6446);
$parcel$export(module.exports, "useTourSpotlightStep", () => $ecb2b61bd8694fdb$export$152b14ddbe17966d);
$parcel$export(module.exports, "useCollectionsIntroductionDismissed", () => $ecb2b61bd8694fdb$export$2c88e8fbdc79e33c);
$parcel$export(module.exports, "useCollectionsIntroductionPrerequisiteDismissalsMet", () => $ecb2b61bd8694fdb$export$45df47b92137b673);
// eslint-disable-next-line jira/filename-case

var $gvtNj = parcelRequire("gvtNj");

var $84SBQ = parcelRequire("84SBQ");
const $ecb2b61bd8694fdb$export$17de768881ff6446 = (0, $gvtNj.createHook)((0, $84SBQ.getCollectionsTourDismissed));
const $ecb2b61bd8694fdb$export$152b14ddbe17966d = (0, $gvtNj.createHook)((0, $84SBQ.getTourSpotlightStep));
const $ecb2b61bd8694fdb$export$2c88e8fbdc79e33c = (0, $gvtNj.createHook)((0, $84SBQ.getCollectionsIntroductionDismissed));
const $ecb2b61bd8694fdb$export$45df47b92137b673 = (0, $gvtNj.createHook)((0, $84SBQ.getCollectionsIntroductionPrerequisiteDismissalsMet));

});
parcelRegister("84SBQ", function(module, exports) {
$parcel$export(module.exports, "getCollectionsTourDismissed", () => $a7b946dad0b027af$export$2f4e8052c0c8cc36);
$parcel$export(module.exports, "getTourSpotlightStep", () => $a7b946dad0b027af$export$c0777ba57d86bcd1);
$parcel$export(module.exports, "getCollectionsIntroductionDismissed", () => $a7b946dad0b027af$export$df23a375f28a4c0f);
$parcel$export(module.exports, "getCollectionsIntroductionPrerequisiteDismissalsMet", () => $a7b946dad0b027af$export$e6b937f1096fabf9);

var $a7e1f = parcelRequire("a7e1f");
const $a7b946dad0b027af$export$9bc19dcd1978ec48 = (state)=>state.collections;
const $a7b946dad0b027af$export$2f4e8052c0c8cc36 = (0, $a7e1f.createSelector)($a7b946dad0b027af$export$9bc19dcd1978ec48, (collections)=>collections.tourDismissed);
const $a7b946dad0b027af$export$c0777ba57d86bcd1 = (0, $a7e1f.createSelector)($a7b946dad0b027af$export$9bc19dcd1978ec48, (collections)=>collections.tourSpotlightStep);
const $a7b946dad0b027af$export$df23a375f28a4c0f = (0, $a7e1f.createSelector)($a7b946dad0b027af$export$9bc19dcd1978ec48, (collections)=>collections.introductionDismissed);
const $a7b946dad0b027af$export$e6b937f1096fabf9 = (0, $a7e1f.createSelector)($a7b946dad0b027af$export$9bc19dcd1978ec48, (collections)=>collections.introductionPrerequisiteDismissalsMet);

});


parcelRegister("ZQYug", function(module, exports) {
$parcel$export(module.exports, "useProductUsageStartTimestamp", () => $bfb597e29028d586$export$935abb673611c138);
// eslint-disable-next-line jira/filename-case

var $gvtNj = parcelRequire("gvtNj");

var $85yz9 = parcelRequire("85yz9");
const $bfb597e29028d586$export$935abb673611c138 = (0, $gvtNj.createHook)((0, $85yz9.getProductUsageStartTimestamp));

});
parcelRegister("85yz9", function(module, exports) {
$parcel$export(module.exports, "getProductUsageStartTimestamp", () => $641371299db22cd3$export$e96fba6f475323c2);
const $641371299db22cd3$export$e96fba6f475323c2 = (state)=>state.productUsageStartTimestamp;

});


parcelRegister("cTqdV", function(module, exports) {
$parcel$export(module.exports, "checkIfOlderThanNDays", () => $7dbbc004990f914d$export$cbcf9869d63af9cf);
const $7dbbc004990f914d$export$cbcf9869d63af9cf = (productStartTimestamp, days = 7)=>{
    if (!productStartTimestamp) return false;
    const daysInMs = days * 86400000;
    const currentDate = new Date();
    const productAge = currentDate.getTime() - new Date(productStartTimestamp).getTime();
    return productAge > daysInMs;
};

});

parcelRegister("gZZFp", function(module, exports) {
$parcel$export(module.exports, "useIsLicensedUser", () => $c81253a4aad8c732$export$8130629f6db139c2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $1KydW = parcelRequire("1KydW");

var $5Vnw3 = parcelRequire("5Vnw3");

var $ZQYug = parcelRequire("ZQYug");

var $cTqdV = parcelRequire("cTqdV");

var $dDnRG = parcelRequire("dDnRG");
const $c81253a4aad8c732$export$8130629f6db139c2 = ()=>{
    const { hasProductDiscoveryAccess: hasProductDiscoveryAccess } = (0, $1KydW.useApplicationPermissions)() ?? {};
    return Boolean(hasProductDiscoveryAccess);
};
const $c81253a4aad8c732$export$d3d8da452c4b6372 = ()=>{
    const isLicensedUser = $c81253a4aad8c732$export$8130629f6db139c2();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const isAlreadyInRoadmaps = window?.location.href.includes('roadmap');
    const isIntroductionDismissed = (0, $5Vnw3.useCollectionsIntroductionDismissed)();
    const arePrerequisiteDismissalsMet = (0, $5Vnw3.useCollectionsIntroductionPrerequisiteDismissalsMet)();
    const productUsageStartTimestamp = (0, $ZQYug.useProductUsageStartTimestamp)();
    const hasAtLeastTwoSpaces = (0, $dDnRG.useHasAtLeastTwoJpdSpaces)();
    // Determine if should show the spotlight
    return !(isAlreadyInRoadmaps || !isLicensedUser || !hasAtLeastTwoSpaces || isIntroductionDismissed === undefined || isIntroductionDismissed || !arePrerequisiteDismissalsMet || !(0, $cTqdV.checkIfOlderThanNDays)(productUsageStartTimestamp));
};

});
parcelRegister("dDnRG", function(module, exports) {
$parcel$export(module.exports, "useHasAtLeastTwoJpdSpaces", () => $e5ac2891fdf1afdd$export$267efb281dd480d2);

var $euxye = parcelRequire("euxye");

var $6sLuf = parcelRequire("6sLuf");
// Module-level cache so the network call is made at most once per page load.
let $e5ac2891fdf1afdd$var$cachedResult;
const $e5ac2891fdf1afdd$export$267efb281dd480d2 = ()=>{
    const [hasAtLeastTwo, setHasAtLeastTwo] = (0, $euxye.useState)($e5ac2891fdf1afdd$var$cachedResult);
    const fetchFn = (0, $euxye.useRef)((0, $6sLuf.hasAtLeastNJpdProjects));
    fetchFn.current = (0, $6sLuf.hasAtLeastNJpdProjects);
    (0, $euxye.useEffect)(()=>{
        if ($e5ac2891fdf1afdd$var$cachedResult !== undefined) return;
        let cancelled = false;
        (async ()=>{
            try {
                const result = await fetchFn.current(2);
                if (!cancelled) {
                    $e5ac2891fdf1afdd$var$cachedResult = result;
                    setHasAtLeastTwo(result);
                }
            } catch  {
                // fail closed
                if (!cancelled) {
                    $e5ac2891fdf1afdd$var$cachedResult = false;
                    setHasAtLeastTwo(false);
                }
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, []);
    return hasAtLeastTwo;
};
const $e5ac2891fdf1afdd$export$c6dbb5fbc9c618a8 = ()=>{
    $e5ac2891fdf1afdd$var$cachedResult = undefined;
};

});
parcelRegister("6sLuf", function(module, exports) {
$parcel$export(module.exports, "getJpdProjects", () => $fa8fe18d36ea2086$export$e47ac985e655d4a9);
$parcel$export(module.exports, "hasJpdProjects", () => $fa8fe18d36ea2086$export$2e251c4cc90a1013);
$parcel$export(module.exports, "hasAtLeastNJpdProjects", () => $fa8fe18d36ea2086$export$dc0d088715c81473);
$parcel$export(module.exports, "getRecentJpdProjects", () => $fa8fe18d36ea2086$export$a137abc4c3c49ac6);

var $f99M0 = parcelRequire("f99M0");

var $4fhEY = parcelRequire("4fhEY");
const $fa8fe18d36ea2086$var$createGetJpdProjectsUrl = (startAt, maxResults)=>{
    const queryParams = new URLSearchParams({
        typeKey: (0, $f99M0.PRODUCT_DISCOVERY_PROJECT),
        expand: 'issueTypes',
        maxResults: maxResults.toString(),
        startAt: startAt.toString()
    });
    return `/rest/api/3/project/search?${queryParams.toString()}`;
};
const $fa8fe18d36ea2086$var$mapRawProjectToProject = (rawProject)=>({
        id: rawProject.id,
        key: rawProject.key,
        name: rawProject.name,
        projectTypeKey: rawProject.projectTypeKey,
        avatarUrl: rawProject.avatarUrls['16x16'],
        ideaIssueTypeId: rawProject.issueTypes[0]?.id || ''
    });
const $fa8fe18d36ea2086$export$e47ac985e655d4a9 = async ()=>{
    const maxPageSize = 50; // a value more than 50 fallbacks to 50
    const firstProjectsPage = await (0, $4fhEY.default)($fa8fe18d36ea2086$var$createGetJpdProjectsUrl(0, maxPageSize));
    const projects = firstProjectsPage.values;
    let isLastPage = firstProjectsPage.isLast;
    let nextPageUrl = firstProjectsPage.nextPage;
    while(!isLastPage){
        // oxlint-disable-next-line no-await-in-loop
        const nextProjectsPage = await (0, $4fhEY.default)(nextPageUrl);
        isLastPage = nextProjectsPage.isLast;
        nextPageUrl = nextProjectsPage.nextPage;
        projects.push(...nextProjectsPage.values);
    }
    return projects.map($fa8fe18d36ea2086$var$mapRawProjectToProject);
};
const $fa8fe18d36ea2086$export$2e251c4cc90a1013 = async ()=>{
    try {
        const { total: total } = await (0, $4fhEY.default)($fa8fe18d36ea2086$var$createGetJpdProjectsUrl(0, 0));
        return total > 0;
    } catch (error) {
        return false;
    }
};
const $fa8fe18d36ea2086$export$dc0d088715c81473 = async (n)=>{
    if (n <= 0) return true;
    try {
        const { values: values } = await (0, $4fhEY.default)($fa8fe18d36ea2086$var$createGetJpdProjectsUrl(0, n));
        return Array.isArray(values) && values.length >= n;
    } catch  {
        return false;
    }
};
const $fa8fe18d36ea2086$export$a137abc4c3c49ac6 = async ()=>{
    const recentProjects = await (0, $4fhEY.default)('/rest/api/3/project/recent');
    return recentProjects.filter((project)=>project.projectTypeKey === (0, $f99M0.PRODUCT_DISCOVERY_PROJECT));
};

});




parcelRegister("aOGXw", function(module, exports) {
$parcel$export(module.exports, "getCollectionDetailsPageUrl", () => $e193e4161c0c3208$export$6d4e7a90e74e9b12);
$parcel$export(module.exports, "getCollectionViewPageUrl", () => $e193e4161c0c3208$export$32ac8841347e1f79);
$parcel$export(module.exports, "getCollectionDetailsPageUrlWithQuery", () => $e193e4161c0c3208$export$2ed2276e7ac487d7);
$parcel$export(module.exports, "getCollectionsPageUrl", () => $e193e4161c0c3208$export$d15219b9c6a3e2f7);
$parcel$export(module.exports, "useCollectionIdeasCount", () => $e193e4161c0c3208$export$28cc502c982e0868);

var $euxye = parcelRequire("euxye");

var $eVMQF = parcelRequire("eVMQF");

var $5WP8k = parcelRequire("5WP8k");

var $4V0al = parcelRequire("4V0al");
const $e193e4161c0c3208$var$withQueryParams = (path, queryParams)=>{
    if (queryParams) {
        const searchParams = new URLSearchParams();
        Object.keys(queryParams).forEach((key)=>{
            if (queryParams[key]) searchParams.set(key, queryParams[key]);
        });
        if (searchParams.size > 0) return `${path}?${searchParams.toString()}`;
    }
    return path;
};
const $e193e4161c0c3208$export$6d4e7a90e74e9b12 = (collectionUUID)=>`/jira/polaris/roadmaps/${collectionUUID}/view`;
const $e193e4161c0c3208$export$32ac8841347e1f79 = (collectionUUID, viewUUID, queryParams)=>$e193e4161c0c3208$var$withQueryParams(`/jira/polaris/roadmaps/${collectionUUID}/view/${viewUUID}`, queryParams);
const $e193e4161c0c3208$export$2ed2276e7ac487d7 = (collectionUUID, queryParams)=>$e193e4161c0c3208$var$withQueryParams(`/jira/polaris/roadmaps/${collectionUUID}/view`, queryParams);
const $e193e4161c0c3208$export$d15219b9c6a3e2f7 = (queryParams)=>$e193e4161c0c3208$var$withQueryParams('/jira/polaris/roadmaps', queryParams);
const $e193e4161c0c3208$var$debouncedGetIdeasCountWithJQL = (0, (/*@__PURE__*/$parcel$interopDefault($eVMQF)))((jql, setRequest, res, rej)=>{
    const request = (0, $5WP8k.getIdeasCountForCollection)(jql);
    setRequest(request);
    request.then(res, rej).finally(()=>setRequest(undefined));
}, 500);
const $e193e4161c0c3208$export$28cc502c982e0868 = (projectKeys, filtersJql)=>{
    const jql = (0, $4V0al.getJQLForCollection)(projectKeys, filtersJql);
    const [ideasCount, setIdeasCount] = (0, $euxye.useState)(undefined);
    const [isLoading, setLoading] = (0, $euxye.useState)(false);
    const [error, setError] = (0, $euxye.useState)(null);
    const [request, setRequest] = (0, $euxye.useState)(undefined);
    (0, $euxye.useEffect)(()=>{
        if (jql && projectKeys.length) {
            setLoading(true);
            $e193e4161c0c3208$var$debouncedGetIdeasCountWithJQL(jql, setRequest, (newCount)=>{
                setIdeasCount(newCount);
                setLoading(false);
                setError(null);
            }, (err)=>{
                setIdeasCount(undefined);
                setLoading(false);
                setError(err);
            });
        } else setIdeasCount(undefined);
    }, [
        jql,
        projectKeys.length
    ]);
    return [
        ideasCount,
        isLoading,
        error,
        request
    ];
};

});
parcelRegister("5WP8k", function(module, exports) {
$parcel$export(module.exports, "createCollection", () => $ebcc99cb04734ba0$export$c74125a8e3af6bb2);
$parcel$export(module.exports, "fetchCollection", () => $ebcc99cb04734ba0$export$efeb96fc7f2aeaf9);
$parcel$export(module.exports, "fetchAllCollections", () => $ebcc99cb04734ba0$export$fb62ec897a9d1e05);
$parcel$export(module.exports, "deleteCollection", () => $ebcc99cb04734ba0$export$3d16e031f6551662);
$parcel$export(module.exports, "updateCollection", () => $ebcc99cb04734ba0$export$c0683150b517c317);
$parcel$export(module.exports, "fetchCollectionsViewsCounts", () => $ebcc99cb04734ba0$export$4ead91e2f6058f41);
$parcel$export(module.exports, "fetchCollectionDescription", () => $ebcc99cb04734ba0$export$8cd86b5346d1e786);
$parcel$export(module.exports, "cloneCollection", () => $ebcc99cb04734ba0$export$d753eba18153f51e);
$parcel$export(module.exports, "getIdeasCountForCollection", () => $ebcc99cb04734ba0$export$d355ccab36abee74);

var $hFtK7 = parcelRequire("hFtK7");

var $lJ3Ts = parcelRequire("lJ3Ts");

var $2wtso = parcelRequire("2wtso");

var $ifsAO = parcelRequire("ifsAO");

var $4fhEY = parcelRequire("4fhEY");

var $h2wCv = parcelRequire("h2wCv");

var $i860n = parcelRequire("i860n");

var $4V0al = parcelRequire("4V0al");

var $6njZO = parcelRequire("6njZO");
/**
 * Collections are being migrated from the JPD Views Service to Gravity. Gravity
 * mirrors the VS wire contract, so only the base path changes behind the flag.
 */ const $ebcc99cb04734ba0$var$getCollectionsServicePathPrefix = ()=>(0, $i860n.fg)('jpd_collections_gravity_migration_fe') ? (0, $lJ3Ts.getGravityServicePathPrefix)() : (0, $2wtso.getJpdViewsServicePathPrefix)();
const $ebcc99cb04734ba0$var$generateProjectKeys = (jql)=>{
    return (0, $4V0al.extractProjectKeysFromJql)(jql);
};
const $ebcc99cb04734ba0$export$c74125a8e3af6bb2 = (collectionToCreate)=>(0, $h2wCv.performPostRequest)(`${$ebcc99cb04734ba0$var$getCollectionsServicePathPrefix()}/v1/collections`, {
        body: JSON.stringify(collectionToCreate)
    }).then((response)=>({
            uuid: response.uuid,
            name: response.name,
            emoji: response.emoji,
            color: response.color,
            jql: response.jql,
            ownerId: response.owner,
            projectKeys: $ebcc99cb04734ba0$var$generateProjectKeys(response.jql),
            filtersJql: (0, $4V0al.extractFiltersJqlFromJql)(response.jql)
        }));
const $ebcc99cb04734ba0$export$efeb96fc7f2aeaf9 = (collectionUUID, shouldIncludeViews = false)=>(0, $4fhEY.default)(`${$ebcc99cb04734ba0$var$getCollectionsServicePathPrefix()}/v1/collections/${collectionUUID}${shouldIncludeViews ? '?expand=views' : ''}`).then((response)=>({
            uuid: response.uuid,
            name: response.name,
            emoji: response.emoji,
            color: response.color,
            jql: response.jql,
            ownerId: response.owner,
            views: response.views?.map((0, $6njZO.transformView)),
            projectKeys: $ebcc99cb04734ba0$var$generateProjectKeys(response.jql),
            filtersJql: (0, $4V0al.extractFiltersJqlFromJql)(response.jql)
        }));
const $ebcc99cb04734ba0$export$fb62ec897a9d1e05 = ()=>(0, $4fhEY.default)(`${$ebcc99cb04734ba0$var$getCollectionsServicePathPrefix()}/v1/collections`).then(({ collections: collections })=>collections.map((collection)=>({
                uuid: collection.uuid,
                name: collection.name,
                emoji: collection.emoji,
                color: collection.color,
                jql: collection.jql,
                ownerId: collection.owner,
                projectKeys: $ebcc99cb04734ba0$var$generateProjectKeys(collection.jql),
                filtersJql: (0, $4V0al.extractFiltersJqlFromJql)(collection.jql)
            })));
const $ebcc99cb04734ba0$export$3d16e031f6551662 = async (collectionUUID)=>{
    await (0, $h2wCv.performDeleteRequest)(`${$ebcc99cb04734ba0$var$getCollectionsServicePathPrefix()}/v1/collections/${collectionUUID}`);
};
const $ebcc99cb04734ba0$export$c0683150b517c317 = async (collectionUUID, collectionToUpdate)=>{
    await (0, $h2wCv.performPutRequest)(`${$ebcc99cb04734ba0$var$getCollectionsServicePathPrefix()}/v1/collections/${collectionUUID}`, {
        body: JSON.stringify(collectionToUpdate)
    });
};
const $ebcc99cb04734ba0$export$4ead91e2f6058f41 = (collectionsUUIDs)=>(0, $h2wCv.performPostRequest)(`${$ebcc99cb04734ba0$var$getCollectionsServicePathPrefix()}/v1/collections/views-count`, {
        body: JSON.stringify({
            uuids: collectionsUUIDs
        })
    });
const $ebcc99cb04734ba0$export$8cd86b5346d1e786 = (collectionUUID)=>(0, $4fhEY.default)(`${$ebcc99cb04734ba0$var$getCollectionsServicePathPrefix()}/v1/collections/${collectionUUID}/description`);
const $ebcc99cb04734ba0$export$d753eba18153f51e = (collectionUUID, newCollectionName)=>(0, $h2wCv.performPostRequest)(`${$ebcc99cb04734ba0$var$getCollectionsServicePathPrefix()}/v1/collections/${collectionUUID}/clone`, {
        body: JSON.stringify({
            name: newCollectionName
        })
    });
const $ebcc99cb04734ba0$export$d355ccab36abee74 = (jql)=>(0, $h2wCv.performPostRequest)('/rest/polaris/issues/searchCountForJql', {
        body: JSON.stringify({
            jql: jql,
            archived: 'ACTIVE_ONLY'
        })
    }).then((response)=>response.count).catch((error)=>{
        (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.error.getIdeasCountForCollectionFailed', error));
        throw error;
    });

});
parcelRegister("lJ3Ts", function(module, exports) {
$parcel$export(module.exports, "getGravityServicePathPrefix", () => $0fc866454f5a3bc2$export$e23c82578f49318c);
/**
 * Path prefix for the Gravity Stargate route.
 */ const $0fc866454f5a3bc2$export$e23c82578f49318c = ()=>'/gateway/api/jpd/gravity';

});

parcelRegister("2wtso", function(module, exports) {
$parcel$export(module.exports, "getJpdViewsServicePathPrefix", () => $d1a90e77646e7600$export$1d2754f769c8a3c6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $d1a90e77646e7600$export$1d2754f769c8a3c6 = ()=>'/gateway/api/jpd/views';

});

parcelRegister("4V0al", function(module, exports) {
$parcel$export(module.exports, "getJQLForCollection", () => $321504c9a0604180$export$8d4a8272ec8d3589);
$parcel$export(module.exports, "extractProjectKeysFromJql", () => $321504c9a0604180$export$35840c54e03d7673);
$parcel$export(module.exports, "extractFiltersJqlFromJql", () => $321504c9a0604180$export$bcd3615366d8d128);
$parcel$export(module.exports, "getFieldsFromJql", () => $321504c9a0604180$export$54e99094db1a28af);


var $2Uq3M = parcelRequire("2Uq3M");

var $7sSiI = parcelRequire("7sSiI");

var $9FSd1 = parcelRequire("9FSd1");

var $dTd4l = parcelRequire("dTd4l");

const $321504c9a0604180$var$quoteProjectKey = (projectKey)=>`"${projectKey}"`;
const $321504c9a0604180$var$PROJECT_FIELD_KEY = 'project';
const $321504c9a0604180$export$8d4a8272ec8d3589 = (projectsKeys = [], filtersJql = '')=>{
    const jast = new (0, $dTd4l.JastBuilder)().build(filtersJql);
    projectsKeys.length && jast.query?.appendClause((0, $2Uq3M.default).terminalClause((0, $2Uq3M.default).field($321504c9a0604180$var$PROJECT_FIELD_KEY), (0, $2Uq3M.default).operator((0, $7sSiI.OPERATOR_IN)), (0, $2Uq3M.default).listOperand(projectsKeys.map($321504c9a0604180$var$quoteProjectKey).map((0, $2Uq3M.default).byText.valueOperand))), (0, $ceee4f50115ff1c6$export$6d6d48d210d3ca97));
    if (jast.query?.orderBy) jast.query.removeOrderBy();
    return (0, $9FSd1.print)(jast);
};
const $321504c9a0604180$var$projectInRegex = /project\s+in\s+\((.*?)\)/;
const $321504c9a0604180$var$projectKeyRegex = /"(.*?)"/g;
const $321504c9a0604180$export$35840c54e03d7673 = (jql)=>{
    // Extract the part of the JQL related to `project in (...)`
    const projectInMatch = $321504c9a0604180$var$projectInRegex.exec(jql);
    const projectKeys = [];
    if (projectInMatch) {
        const projectInClause = projectInMatch[1];
        let match;
        // Extract all project keys inside the quotes within the `project in (...)` clause
        // oxlint-disable-next-line no-cond-assign
        while((match = $321504c9a0604180$var$projectKeyRegex.exec(projectInClause)) !== null)projectKeys.push(match[1]);
    }
    return projectKeys;
};
const $321504c9a0604180$export$bcd3615366d8d128 = (jql)=>{
    const jast = new (0, $dTd4l.JastBuilder)().build(jql);
    const { where: where } = jast.query ?? {};
    if (!where) return '';
    const clauses = where.clauseType === (0, $45358584c5e1587f$export$7a58b23488ea076b) ? where.clauses : [
        where
    ];
    const projectKeysClause = clauses.find((c)=>c.clauseType === (0, $45358584c5e1587f$export$ae56b4ef248a2b6a) && c.field.value === $321504c9a0604180$var$PROJECT_FIELD_KEY);
    if (projectKeysClause) projectKeysClause.remove();
    return (0, $9FSd1.print)(jast);
};
const $321504c9a0604180$var$getFieldsFromClauses = ([clause, ...rest])=>{
    if (!clause) return [];
    if (clause.clauseType === (0, $45358584c5e1587f$export$ae56b4ef248a2b6a)) return [
        clause.field.value,
        ...$321504c9a0604180$var$getFieldsFromClauses(rest)
    ];
    if (clause.clauseType === (0, $45358584c5e1587f$export$e356b89f8c8d2fcb)) return $321504c9a0604180$var$getFieldsFromClauses([
        clause.clause,
        ...rest
    ]);
    return $321504c9a0604180$var$getFieldsFromClauses([
        ...clause.clauses,
        ...rest
    ]);
};
const $321504c9a0604180$var$getFieldKeyFromFieldName = (fieldKeys)=>(fieldName)=>{
        const fieldNameClean = fieldName.replace(/\[[^\]]+\]$/, '');
        return fieldKeys[fieldNameClean.toLowerCase()];
    };
const $321504c9a0604180$export$54e99094db1a28af = (jql, fieldKeys)=>{
    const jast = new (0, $dTd4l.JastBuilder)().build(jql);
    const { where: where } = jast.query ?? {};
    if (!where) return [];
    const clauses = where.clauseType === (0, $45358584c5e1587f$export$7a58b23488ea076b) ? where.clauses : [
        where
    ];
    return $321504c9a0604180$var$getFieldsFromClauses(clauses).map($321504c9a0604180$var$getFieldKeyFromFieldName(fieldKeys)).filter((field)=>!!field);
};

});
const $ceee4f50115ff1c6$export$6d6d48d210d3ca97 = 'and';
const $ceee4f50115ff1c6$export$7b8f0a728d79a753 = 'or';

parcelRegister("2Uq3M", function(module, exports) {
$parcel$export(module.exports, "internalCreators", () => $48d3ffef8c422ab1$export$64d991963cfb5532);
$parcel$export(module.exports, "default", () => $48d3ffef8c422ab1$export$2e2bcd8739ae039);

var $9byge = parcelRequire("9byge");

var $h5ps6 = parcelRequire("h5ps6");

var $4spzA = parcelRequire("4spzA");

var $eTqTE = parcelRequire("eTqTE");

var $8Z9X5 = parcelRequire("8Z9X5");

var $7Kv9Z = parcelRequire("7Kv9Z");

var $hwbMX = parcelRequire("hwbMX");

var $hkpA4 = parcelRequire("hkpA4");

var $i7s2S = parcelRequire("i7s2S");

var $6813s = parcelRequire("6813s");

var $kTJBF = parcelRequire("kTJBF");

var $4j1I4 = parcelRequire("4j1I4");

var $1bKwy = parcelRequire("1bKwy");

var $1KT8M = parcelRequire("1KT8M");

var $d7ASl = parcelRequire("d7ASl");

var $eSCw7 = parcelRequire("eSCw7");

var $8IgBR = parcelRequire("8IgBR");

var $KpZhL = parcelRequire("KpZhL");

var $guMUP = parcelRequire("guMUP");

var $a1phL = parcelRequire("a1phL");

var $4o173 = parcelRequire("4o173");

var $1K8Za = parcelRequire("1K8Za");
const $48d3ffef8c422ab1$export$64d991963cfb5532 = {
    query: (0, $a1phL.queryInternal),
    compoundClause: (0, $h5ps6.compoundClauseInternal),
    compoundOperator: (0, $4spzA.compoundOperatorInternal),
    terminalClause: (0, $4o173.terminalClauseInternal),
    notClause: (0, $6813s.notClauseInternal),
    notClauseOperator: (0, $kTJBF.notClauseOperatorInternal),
    predicate: (0, $8IgBR.predicateInternal),
    predicateOperator: (0, $KpZhL.predicateOperatorInternal),
    field: (0, $eTqTE.fieldInternal),
    property: (0, $guMUP.propertyInternal),
    operator: (0, $4j1I4.operatorInternal),
    valueOperand: (0, $1K8Za.valueOperandInternal),
    keywordOperand: (0, $hkpA4.keywordOperandInternal),
    functionOperand: (0, $8Z9X5.functionOperandInternal),
    functionString: (0, $7Kv9Z.functionStringInternal),
    argument: (0, $9byge.argumentInternal),
    listOperand: (0, $i7s2S.listOperandInternal),
    orderBy: (0, $1bKwy.orderByInternal),
    orderByOperator: (0, $eSCw7.orderByOperatorInternal),
    orderByField: (0, $d7ASl.orderByFieldInternal),
    orderByDirection: (0, $1KT8M.orderByDirectionInternal)
};
const $48d3ffef8c422ab1$var$_default_1 = {
    jast: $hwbMX.jast,
    query: $a1phL.query,
    compoundClause: $h5ps6.compoundClause,
    compoundOperator: $4spzA.compoundOperator,
    terminalClause: $4o173.terminalClause,
    notClause: $6813s.notClause,
    notClauseOperator: $kTJBF.notClauseOperator,
    predicate: $8IgBR.predicate,
    predicateOperator: $KpZhL.predicateOperator,
    field: $eTqTE.field,
    property: $guMUP.property,
    operator: $4j1I4.operator,
    valueOperand: $1K8Za.valueOperand,
    keywordOperand: $hkpA4.keywordOperand,
    functionOperand: $8Z9X5.functionOperand,
    functionString: $7Kv9Z.functionString,
    argument: $9byge.argument,
    listOperand: $i7s2S.listOperand,
    orderBy: $1bKwy.orderBy,
    orderByOperator: $eSCw7.orderByOperator,
    orderByField: $d7ASl.orderByField,
    orderByDirection: $1KT8M.orderByDirection,
    byText: {
        argument: (0, $9byge.argumentByText),
        valueOperand: (0, $1K8Za.valueOperandByText)
    }
};
var $48d3ffef8c422ab1$export$2e2bcd8739ae039 = $48d3ffef8c422ab1$var$_default_1;

});
parcelRegister("9byge", function(module, exports) {
$parcel$export(module.exports, "argument", () => $7cdfba71a9153fd1$export$6ea29ee575e3f5ff);
$parcel$export(module.exports, "argumentInternal", () => $7cdfba71a9153fd1$export$5b341d50fa5bcdd5);
$parcel$export(module.exports, "argumentByText", () => $7cdfba71a9153fd1$export$84c43d23f51170cb);

var $5d17Q = parcelRequire("5d17Q");
var $dPIaU = parcelRequire("dPIaU");

var $aDydw = parcelRequire("aDydw");
function $7cdfba71a9153fd1$var$acceptArgument(visitor) {
    return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
}
function $7cdfba71a9153fd1$var$enterNode(listener) {
    listener.enterArgument && listener.enterArgument(this);
}
function $7cdfba71a9153fd1$var$exitNode(listener) {
    listener.exitArgument && listener.exitArgument(this);
}
const $7cdfba71a9153fd1$export$6ea29ee575e3f5ff = (value)=>$7cdfba71a9153fd1$export$5b341d50fa5bcdd5(value, (0, $dPIaU.sanitiseJqlString)(value));
const $7cdfba71a9153fd1$export$84c43d23f51170cb = (text)=>$7cdfba71a9153fd1$export$5b341d50fa5bcdd5((0, $5d17Q.normaliseJqlString)(text), text);
const $7cdfba71a9153fd1$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $7cdfba71a9153fd1$var$acceptArgument,
        enterNode: $7cdfba71a9153fd1$var$enterNode,
        exitNode: $7cdfba71a9153fd1$var$exitNode,
        getChildren: (0, $aDydw.noChildren),
        parent: null
    });

});
parcelRegister("5d17Q", function(module, exports) {
$parcel$export(module.exports, "normaliseJqlString", () => $0b9cc2cf47336359$export$cecf78a779acc0ff);
const $0b9cc2cf47336359$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $0b9cc2cf47336359$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $0b9cc2cf47336359$export$b86601123607fee5 = (maybeQuotedString)=>$0b9cc2cf47336359$export$7a0b99b892e0dda8(maybeQuotedString) || $0b9cc2cf47336359$export$d5efd6512db694fd(maybeQuotedString);
const $0b9cc2cf47336359$export$cecf78a779acc0ff = (maybeQuotedString)=>{
    if ($0b9cc2cf47336359$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};

});

parcelRegister("dPIaU", function(module, exports) {
$parcel$export(module.exports, "sanitiseJqlString", () => $a065d6d2ca67996b$export$3eb9033c48208278);

var $iqfTZ = parcelRequire("iqfTZ");

var $5fdaQ = parcelRequire("5fdaQ");
const $a065d6d2ca67996b$export$3eb9033c48208278 = (jqlString)=>{
    // If the string contains special characters, perform a proper escape
    if ((0, $5fdaQ.RESERVED_CHARACTERS_REGEX).test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
    // If the string matches a reserved word, wrap it in quotes since any
    // special characters would have been caught above already
    if ((0, $5fdaQ.RESERVED_WORDS).has(jqlString.toLowerCase()) && (0, $iqfTZ.fg)('queue-setting-page-jql-bug')) return `"${jqlString}"`;
    return jqlString;
};

});
parcelRegister("5fdaQ", function(module, exports) {
$parcel$export(module.exports, "RESERVED_CHARACTERS_REGEX", () => $bc9a8c6a5562288a$export$c11f53c00e0a0ad4);
$parcel$export(module.exports, "RESERVED_WORDS", () => $bc9a8c6a5562288a$export$1fa3c1f0578bafad);

var $j5UfA = parcelRequire("j5UfA");
const $bc9a8c6a5562288a$export$c11f53c00e0a0ad4 = new RegExp(`[\\s${(0, (/*@__PURE__*/$parcel$interopDefault($j5UfA)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
const $bc9a8c6a5562288a$export$1fa3c1f0578bafad = new Set([
    'a',
    'an',
    'abort',
    'access',
    'add',
    'after',
    'alias',
    'all',
    'alter',
    'and',
    'any',
    'are',
    'as',
    'asc',
    'at',
    'audit',
    'avg',
    'be',
    'before',
    'begin',
    'between',
    'boolean',
    'break',
    'but',
    'by',
    'byte',
    'catch',
    'cf',
    'char',
    'character',
    'check',
    'checkpoint',
    'collate',
    'collation',
    'column',
    'commit',
    'connect',
    'continue',
    'count',
    'create',
    'current',
    'date',
    'decimal',
    'declare',
    'decrement',
    'default',
    'defaults',
    'define',
    'delete',
    'delimiter',
    'desc',
    'difference',
    'distinct',
    'divide',
    'do',
    'double',
    'drop',
    'else',
    'empty',
    'encoding',
    'end',
    'equals',
    'escape',
    'exclusive',
    'exec',
    'execute',
    'exists',
    'explain',
    'false',
    'fetch',
    'file',
    'field',
    'first',
    'float',
    'for',
    'from',
    'function',
    'go',
    'goto',
    'grant',
    'greater',
    'group',
    'having',
    'identified',
    'if',
    'immediate',
    'in',
    'increment',
    'index',
    'initial',
    'inner',
    'inout',
    'input',
    'insert',
    'int',
    'integer',
    'intersect',
    'intersection',
    'into',
    'is',
    'isempty',
    'isnull',
    'it',
    'join',
    'last',
    'left',
    'less',
    'like',
    'limit',
    'lock',
    'long',
    'max',
    'min',
    'minus',
    'mode',
    'modify',
    'modulo',
    'more',
    'multiply',
    'next',
    'no',
    'noaudit',
    'not',
    'notin',
    'nowait',
    'null',
    'number',
    'object',
    'of',
    'on',
    'option',
    'or',
    'order',
    'outer',
    'output',
    'power',
    'previous',
    'prior',
    'privileges',
    'public',
    'raise',
    'raw',
    'remainder',
    'rename',
    'resource',
    'return',
    'returns',
    'revoke',
    'right',
    'row',
    'rowid',
    'rownum',
    'rows',
    'select',
    'session',
    'set',
    'share',
    'size',
    'sqrt',
    'start',
    'strict',
    'string',
    'subtract',
    'such',
    'sum',
    'synonym',
    'table',
    'that',
    'the',
    'their',
    'then',
    'there',
    'these',
    'they',
    'this',
    'to',
    'trans',
    'transaction',
    'trigger',
    'true',
    'uid',
    'union',
    'unique',
    'update',
    'user',
    'validate',
    'values',
    'view',
    'was',
    'when',
    'whenever',
    'where',
    'while',
    'will',
    'with'
]);

});
parcelRegister("j5UfA", function(module, exports) {

var $lyiHY = parcelRequire("lyiHY");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $de6a1e18943a32ab$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $de6a1e18943a32ab$var$reHasRegExpChar = RegExp($de6a1e18943a32ab$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $de6a1e18943a32ab$var$escapeRegExp(string) {
    string = $lyiHY(string);
    return string && $de6a1e18943a32ab$var$reHasRegExpChar.test(string) ? string.replace($de6a1e18943a32ab$var$reRegExpChar, '\\$&') : string;
}
module.exports = $de6a1e18943a32ab$var$escapeRegExp;

});



parcelRegister("aDydw", function(module, exports) {
$parcel$export(module.exports, "noChildren", () => $5a1fc83e0f64db45$export$470bef71e654b804);
$parcel$export(module.exports, "assignParent", () => $5a1fc83e0f64db45$export$a4685923af2913a);
const $5a1fc83e0f64db45$export$470bef71e654b804 = ()=>[];
const $5a1fc83e0f64db45$export$a4685923af2913a = (node)=>{
    node.getChildren().forEach((child)=>{
        child.parent = node;
    });
};

});


parcelRegister("h5ps6", function(module, exports) {
$parcel$export(module.exports, "compoundClause", () => $5638da4b2285ce49$export$ab714e56a32c25f2);
$parcel$export(module.exports, "compoundClauseInternal", () => $5638da4b2285ce49$export$cd65eed8c10b0911);


var $enaUP = parcelRequire("enaUP");

var $aDydw = parcelRequire("aDydw");
function $5638da4b2285ce49$var$acceptCompoundClause(visitor) {
    return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
}
function $5638da4b2285ce49$var$enterNode(listener) {
    listener.enterCompoundClause && listener.enterCompoundClause(this);
}
function $5638da4b2285ce49$var$exitNode(listener) {
    listener.exitCompoundClause && listener.exitCompoundClause(this);
}
function $5638da4b2285ce49$var$getChildren() {
    return [
        this.operator,
        ...this.clauses
    ];
}
const $5638da4b2285ce49$export$ab714e56a32c25f2 = (operator, clauses)=>{
    return $5638da4b2285ce49$export$cd65eed8c10b0911(operator, clauses);
};
const $5638da4b2285ce49$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
    const node = {
        type: (0, $cf20d4e3958ad98b$export$2d205682cc545947),
        clauseType: (0, $45358584c5e1587f$export$7a58b23488ea076b),
        operator: operator,
        clauses: clauses,
        position: position,
        accept: $5638da4b2285ce49$var$acceptCompoundClause,
        enterNode: $5638da4b2285ce49$var$enterNode,
        exitNode: $5638da4b2285ce49$var$exitNode,
        getChildren: $5638da4b2285ce49$var$getChildren,
        parent: null,
        appendClause: $enaUP.appendClause,
        remove: $enaUP.remove,
        removeClause: $enaUP.removeClause,
        replace: $enaUP.replace,
        replaceClause: $enaUP.replaceClause
    };
    (0, $aDydw.assignParent)(node);
    return node;
};

});
const $45358584c5e1587f$export$7a58b23488ea076b = 'compound';
const $45358584c5e1587f$export$ae56b4ef248a2b6a = 'terminal';
const $45358584c5e1587f$export$e356b89f8c8d2fcb = 'not';

const $cf20d4e3958ad98b$export$98dda21ec825792 = 'query';
const $cf20d4e3958ad98b$export$2d205682cc545947 = 'clause';
const $cf20d4e3958ad98b$export$d2f212d8ddbc8d1d = 'operand';
const $cf20d4e3958ad98b$export$da0f73edded4a63d = 'order_by';

parcelRegister("enaUP", function(module, exports) {
$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);


var $aDydw = parcelRequire("aDydw");
function appendClause(clause) {
    let clausesToAppend = [
        clause
    ];
    // If the clause to append is compound with a matching operator then we flatten it into the current clause
    if (clause.clauseType === (0, $45358584c5e1587f$export$7a58b23488ea076b) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
    this.clauses.push(...clausesToAppend);
    (0, $aDydw.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    this.clauses = this.clauses.filter((val)=>val !== clause);
    if (this.clauses.length === 1) this.replace(this.clauses[0]);
    else if (this.clauses.length === 0) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    this.clauses = this.clauses.map((child)=>{
        return child === clause ? nextClause : child;
    });
    (0, $aDydw.assignParent)(this);
}

});


parcelRegister("4spzA", function(module, exports) {
$parcel$export(module.exports, "compoundOperator", () => $1591cca9d6cc1c33$export$84bb3ebbba491aee);
$parcel$export(module.exports, "compoundOperatorInternal", () => $1591cca9d6cc1c33$export$63c33bc3fe74fee6);

var $aDydw = parcelRequire("aDydw");
function $1591cca9d6cc1c33$var$acceptCompoundOperator(visitor) {
    return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
}
function $1591cca9d6cc1c33$var$enterNode(listener) {
    listener.enterCompoundOperator && listener.enterCompoundOperator(this);
}
function $1591cca9d6cc1c33$var$exitNode(listener) {
    listener.exitCompoundOperator && listener.exitCompoundOperator(this);
}
const $1591cca9d6cc1c33$export$84bb3ebbba491aee = (value)=>$1591cca9d6cc1c33$export$63c33bc3fe74fee6(value, []);
const $1591cca9d6cc1c33$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
        value: value,
        positions: operatorPositions,
        position: null,
        accept: $1591cca9d6cc1c33$var$acceptCompoundOperator,
        enterNode: $1591cca9d6cc1c33$var$enterNode,
        exitNode: $1591cca9d6cc1c33$var$exitNode,
        getChildren: (0, $aDydw.noChildren),
        parent: null
    });

});

parcelRegister("eTqTE", function(module, exports) {
$parcel$export(module.exports, "field", () => $8b70df096a614b53$export$e0f35d825088c098);
$parcel$export(module.exports, "fieldInternal", () => $8b70df096a614b53$export$2193f8c541622b6);

var $dPIaU = parcelRequire("dPIaU");

var $aDydw = parcelRequire("aDydw");
function $8b70df096a614b53$var$acceptField(visitor) {
    return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
}
function $8b70df096a614b53$var$enterNode(listener) {
    listener.enterField && listener.enterField(this);
}
function $8b70df096a614b53$var$exitNode(listener) {
    listener.exitField && listener.exitField(this);
}
function $8b70df096a614b53$var$getChildren() {
    return this.properties ? [
        ...this.properties
    ] : [];
}
const $8b70df096a614b53$export$e0f35d825088c098 = (value, properties)=>{
    return $8b70df096a614b53$export$2193f8c541622b6(value, (0, $dPIaU.sanitiseJqlString)(value), properties);
};
const $8b70df096a614b53$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
    const node = {
        text: text,
        value: value,
        properties: properties,
        position: position,
        accept: $8b70df096a614b53$var$acceptField,
        enterNode: $8b70df096a614b53$var$enterNode,
        exitNode: $8b70df096a614b53$var$exitNode,
        getChildren: $8b70df096a614b53$var$getChildren,
        parent: null
    };
    (0, $aDydw.assignParent)(node);
    return node;
};

});

parcelRegister("8Z9X5", function(module, exports) {
$parcel$export(module.exports, "functionOperand", () => $e74057144fbce5f6$export$4f981b0e83488ce);
$parcel$export(module.exports, "functionOperandInternal", () => $e74057144fbce5f6$export$c1f2ce91dc05872a);


var $aDydw = parcelRequire("aDydw");
function $e74057144fbce5f6$var$acceptFunctionOperand(visitor) {
    return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
}
function $e74057144fbce5f6$var$enterNode(listener) {
    listener.enterFunctionOperand && listener.enterFunctionOperand(this);
}
function $e74057144fbce5f6$var$exitNode(listener) {
    listener.exitFunctionOperand && listener.exitFunctionOperand(this);
}
function $e74057144fbce5f6$var$getChildren() {
    return [
        this.function,
        ...this.arguments
    ];
}
const $e74057144fbce5f6$export$4f981b0e83488ce = (functionString, args = [])=>$e74057144fbce5f6$export$c1f2ce91dc05872a(functionString, args);
const $e74057144fbce5f6$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
    const node = {
        type: (0, $cf20d4e3958ad98b$export$d2f212d8ddbc8d1d),
        operandType: (0, $1bca8a68bc08e4bf$export$19c7c729db381f9d),
        function: functionString,
        arguments: args,
        position: position,
        accept: $e74057144fbce5f6$var$acceptFunctionOperand,
        enterNode: $e74057144fbce5f6$var$enterNode,
        exitNode: $e74057144fbce5f6$var$exitNode,
        getChildren: $e74057144fbce5f6$var$getChildren,
        parent: null
    };
    (0, $aDydw.assignParent)(node);
    return node;
};

});
const $1bca8a68bc08e4bf$export$38accfc5a5d1c113 = 'value';
const $1bca8a68bc08e4bf$export$f6049126fd97001f = 'keyword';
const $1bca8a68bc08e4bf$export$19c7c729db381f9d = 'function';
const $1bca8a68bc08e4bf$export$fabec4aebba3f4df = 'list';
const $1bca8a68bc08e4bf$export$1c46dca02aac24dd = 'empty';


parcelRegister("7Kv9Z", function(module, exports) {
$parcel$export(module.exports, "functionString", () => $fd0f483c065e92cf$export$4e1bb9a7ff8d0ef9);
$parcel$export(module.exports, "functionStringInternal", () => $fd0f483c065e92cf$export$7aa9944588b7a69f);

var $dPIaU = parcelRequire("dPIaU");

var $aDydw = parcelRequire("aDydw");
function $fd0f483c065e92cf$var$acceptFunctionString(visitor) {
    return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
}
function $fd0f483c065e92cf$var$enterNode(listener) {
    listener.enterFunction && listener.enterFunction(this);
}
function $fd0f483c065e92cf$var$exitNode(listener) {
    listener.exitFunction && listener.exitFunction(this);
}
const $fd0f483c065e92cf$export$4e1bb9a7ff8d0ef9 = (value)=>$fd0f483c065e92cf$export$7aa9944588b7a69f(value, (0, $dPIaU.sanitiseJqlString)(value));
const $fd0f483c065e92cf$export$7aa9944588b7a69f = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $fd0f483c065e92cf$var$acceptFunctionString,
        enterNode: $fd0f483c065e92cf$var$enterNode,
        exitNode: $fd0f483c065e92cf$var$exitNode,
        getChildren: (0, $aDydw.noChildren),
        parent: null
    });

});

parcelRegister("hwbMX", function(module, exports) {
$parcel$export(module.exports, "jast", () => $be30ffb3b4457e78$export$b9e70a00f479ff43);
const $be30ffb3b4457e78$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
        query: query,
        represents: represents,
        errors: errors
    });

});

parcelRegister("hkpA4", function(module, exports) {
$parcel$export(module.exports, "keywordOperand", () => $bd5a2246e4c42975$export$2edd4971ed69f2ce);
$parcel$export(module.exports, "keywordOperandInternal", () => $bd5a2246e4c42975$export$7cc55480b054047b);


var $aDydw = parcelRequire("aDydw");
function $bd5a2246e4c42975$var$acceptKeywordOperand(visitor) {
    return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
}
function $bd5a2246e4c42975$var$enterNode(listener) {
    listener.enterKeywordOperand && listener.enterKeywordOperand(this);
}
function $bd5a2246e4c42975$var$exitNode(listener) {
    listener.exitKeywordOperand && listener.exitKeywordOperand(this);
}
const $bd5a2246e4c42975$export$2edd4971ed69f2ce = ()=>$bd5a2246e4c42975$export$7cc55480b054047b((0, $1bca8a68bc08e4bf$export$1c46dca02aac24dd));
const $bd5a2246e4c42975$export$7cc55480b054047b = (value, position = null)=>({
        type: (0, $cf20d4e3958ad98b$export$d2f212d8ddbc8d1d),
        operandType: (0, $1bca8a68bc08e4bf$export$f6049126fd97001f),
        value: value,
        position: position,
        accept: $bd5a2246e4c42975$var$acceptKeywordOperand,
        enterNode: $bd5a2246e4c42975$var$enterNode,
        exitNode: $bd5a2246e4c42975$var$exitNode,
        getChildren: (0, $aDydw.noChildren),
        parent: null
    });

});

parcelRegister("i7s2S", function(module, exports) {
$parcel$export(module.exports, "listOperand", () => $d6ee2c72fd6947e2$export$769866c3e9d41d50);
$parcel$export(module.exports, "listOperandInternal", () => $d6ee2c72fd6947e2$export$663c7831528c984b);


var $4w00b = parcelRequire("4w00b");

var $aDydw = parcelRequire("aDydw");
function $d6ee2c72fd6947e2$var$acceptListOperand(visitor) {
    return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
}
function $d6ee2c72fd6947e2$var$enterNode(listener) {
    listener.enterListOperand && listener.enterListOperand(this);
}
function $d6ee2c72fd6947e2$var$exitNode(listener) {
    listener.exitListOperand && listener.exitListOperand(this);
}
function $d6ee2c72fd6947e2$var$getChildren() {
    return [
        ...this.values
    ];
}
const $d6ee2c72fd6947e2$export$769866c3e9d41d50 = (values)=>$d6ee2c72fd6947e2$export$663c7831528c984b(values);
const $d6ee2c72fd6947e2$export$663c7831528c984b = (values, position = null)=>{
    const node = {
        type: (0, $cf20d4e3958ad98b$export$d2f212d8ddbc8d1d),
        operandType: (0, $1bca8a68bc08e4bf$export$fabec4aebba3f4df),
        values: values,
        position: position,
        accept: $d6ee2c72fd6947e2$var$acceptListOperand,
        enterNode: $d6ee2c72fd6947e2$var$enterNode,
        exitNode: $d6ee2c72fd6947e2$var$exitNode,
        getChildren: $d6ee2c72fd6947e2$var$getChildren,
        parent: null,
        appendOperand: $4w00b.appendOperand
    };
    (0, $aDydw.assignParent)(node);
    return node;
};

});
parcelRegister("4w00b", function(module, exports) {
$parcel$export(module.exports, "appendOperand", () => $8e96af8cb965d796$export$d94c54f1aee177c4);


var $aDydw = parcelRequire("aDydw");
function $8e96af8cb965d796$export$d94c54f1aee177c4(operand) {
    this.values.push(...operand.operandType === (0, $1bca8a68bc08e4bf$export$fabec4aebba3f4df) ? operand.values : [
        operand
    ]);
    (0, $aDydw.assignParent)(this);
}

});


parcelRegister("6813s", function(module, exports) {
$parcel$export(module.exports, "notClause", () => $044df99bb6949019$export$b4734a9fedb4d44e);
$parcel$export(module.exports, "notClauseInternal", () => $044df99bb6949019$export$b25621824fea4548);


var $gm7Xj = parcelRequire("gm7Xj");

var $aDydw = parcelRequire("aDydw");

var $kTJBF = parcelRequire("kTJBF");
function $044df99bb6949019$var$acceptNotClause(visitor) {
    return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
}
function $044df99bb6949019$var$enterNode(listener) {
    listener.enterNotClause && listener.enterNotClause(this);
}
function $044df99bb6949019$var$exitNode(listener) {
    listener.exitNotClause && listener.exitNotClause(this);
}
function $044df99bb6949019$var$getChildren() {
    return [
        this.operator,
        this.clause
    ];
}
const $044df99bb6949019$export$b4734a9fedb4d44e = (clause)=>{
    return $044df99bb6949019$export$b25621824fea4548(clause, (0, $kTJBF.notClauseOperator)());
};
const $044df99bb6949019$export$b25621824fea4548 = (clause, operator, position = null)=>{
    const node = {
        type: (0, $cf20d4e3958ad98b$export$2d205682cc545947),
        clauseType: (0, $45358584c5e1587f$export$e356b89f8c8d2fcb),
        clause: clause,
        operator: operator,
        position: position,
        accept: $044df99bb6949019$var$acceptNotClause,
        enterNode: $044df99bb6949019$var$enterNode,
        exitNode: $044df99bb6949019$var$exitNode,
        getChildren: $044df99bb6949019$var$getChildren,
        parent: null,
        remove: $gm7Xj.remove,
        removeClause: $gm7Xj.removeClause,
        replace: $gm7Xj.replace,
        replaceClause: $gm7Xj.replaceClause
    };
    (0, $aDydw.assignParent)(node);
    return node;
};

});
parcelRegister("gm7Xj", function(module, exports) {
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);

var $aDydw = parcelRequire("aDydw");
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    if (this.clause === clause) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    if (this.clause === clause) {
        this.clause = nextClause;
        (0, $aDydw.assignParent)(this);
    }
}

});

parcelRegister("kTJBF", function(module, exports) {
$parcel$export(module.exports, "notClauseOperator", () => $02ac319ca7febda1$export$d2cd8239f99c13d3);
$parcel$export(module.exports, "notClauseOperatorInternal", () => $02ac319ca7febda1$export$1b15a32bb57b9020);

var $7sSiI = parcelRequire("7sSiI");

var $aDydw = parcelRequire("aDydw");
function $02ac319ca7febda1$var$acceptNotClauseOperator(visitor) {
    return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
}
function $02ac319ca7febda1$var$enterNode(listener) {
    listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
}
function $02ac319ca7febda1$var$exitNode(listener) {
    listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
}
const $02ac319ca7febda1$export$d2cd8239f99c13d3 = ()=>$02ac319ca7febda1$export$1b15a32bb57b9020();
const $02ac319ca7febda1$export$1b15a32bb57b9020 = (position = null)=>({
        value: (0, $7sSiI.CLAUSE_OPERATOR_NOT),
        position: position,
        accept: $02ac319ca7febda1$var$acceptNotClauseOperator,
        enterNode: $02ac319ca7febda1$var$enterNode,
        exitNode: $02ac319ca7febda1$var$exitNode,
        getChildren: (0, $aDydw.noChildren),
        parent: null
    });

});
parcelRegister("7sSiI", function(module, exports) {
$parcel$export(module.exports, "CLAUSE_OPERATOR_NOT", () => $ba006da76aaca3f3$export$c6c71ceedb15cda9);
$parcel$export(module.exports, "OPERATOR_EQUALS", () => $ba006da76aaca3f3$export$466517a888d00195);
$parcel$export(module.exports, "OPERATOR_NOT_EQUALS", () => $ba006da76aaca3f3$export$6d0d8810623974a5);
$parcel$export(module.exports, "OPERATOR_GT", () => $ba006da76aaca3f3$export$bcbb090ab3c498b3);
$parcel$export(module.exports, "OPERATOR_LT", () => $ba006da76aaca3f3$export$4bf1a4aa659c6ea4);
$parcel$export(module.exports, "OPERATOR_GT_EQUALS", () => $ba006da76aaca3f3$export$83ce674214a54b2a);
$parcel$export(module.exports, "OPERATOR_LT_EQUALS", () => $ba006da76aaca3f3$export$9629fd1727ef62ee);
$parcel$export(module.exports, "OPERATOR_IN", () => $ba006da76aaca3f3$export$c4e3fb55e320e979);
$parcel$export(module.exports, "OPERATOR_NOT_IN", () => $ba006da76aaca3f3$export$f9857532eaa24ddc);
$parcel$export(module.exports, "OPERATOR_LIKE", () => $ba006da76aaca3f3$export$221595834b8766ab);
$parcel$export(module.exports, "OPERATOR_NOT_LIKE", () => $ba006da76aaca3f3$export$fcefabf94a9bffbf);
$parcel$export(module.exports, "OPERATOR_IS", () => $ba006da76aaca3f3$export$4feeb3f4ff56bcef);
$parcel$export(module.exports, "OPERATOR_IS_NOT", () => $ba006da76aaca3f3$export$d08d969a0da27188);
$parcel$export(module.exports, "OPERATOR_WAS", () => $ba006da76aaca3f3$export$8f907e179985256d);
$parcel$export(module.exports, "OPERATOR_WAS_IN", () => $ba006da76aaca3f3$export$cc7b9d0b3ee23193);
$parcel$export(module.exports, "OPERATOR_WAS_NOT_IN", () => $ba006da76aaca3f3$export$585d3c004af078bb);
$parcel$export(module.exports, "OPERATOR_WAS_NOT", () => $ba006da76aaca3f3$export$123eaa9ccc2d9445);
$parcel$export(module.exports, "OPERATOR_CHANGED", () => $ba006da76aaca3f3$export$15f5b446ba8c941e);
$parcel$export(module.exports, "EQUALS_OPERATORS", () => $ba006da76aaca3f3$export$643c6101f3fc8547);
$parcel$export(module.exports, "LIKE_OPERATORS", () => $ba006da76aaca3f3$export$329664c9cf18cca6);
$parcel$export(module.exports, "COMPARISON_OPERATORS", () => $ba006da76aaca3f3$export$1b167a3705885a8b);
$parcel$export(module.exports, "IN_OPERATORS", () => $ba006da76aaca3f3$export$f25cf16c2270312f);
$parcel$export(module.exports, "IS_OPERATORS", () => $ba006da76aaca3f3$export$eb58cfffe4a6b805);
$parcel$export(module.exports, "WAS_OPERATORS", () => $ba006da76aaca3f3$export$c22a981f581de218);
$parcel$export(module.exports, "WAS_IN_OPERATORS", () => $ba006da76aaca3f3$export$6d08c4699bb75284);
$parcel$export(module.exports, "CHANGED_OPERATORS", () => $ba006da76aaca3f3$export$b7dc214eef214c1c);
$parcel$export(module.exports, "OPERATORS", () => $ba006da76aaca3f3$export$184799fc79ccac89);
$parcel$export(module.exports, "LIST_OPERATORS", () => $ba006da76aaca3f3$export$77c793736847e030);
const $ba006da76aaca3f3$export$c6c71ceedb15cda9 = 'not';
const $ba006da76aaca3f3$export$466517a888d00195 = '=';
const $ba006da76aaca3f3$export$6d0d8810623974a5 = '!=';
const $ba006da76aaca3f3$export$bcbb090ab3c498b3 = '>';
const $ba006da76aaca3f3$export$4bf1a4aa659c6ea4 = '<';
const $ba006da76aaca3f3$export$83ce674214a54b2a = '>=';
const $ba006da76aaca3f3$export$9629fd1727ef62ee = '<=';
const $ba006da76aaca3f3$export$c4e3fb55e320e979 = 'in';
const $ba006da76aaca3f3$export$f9857532eaa24ddc = 'not in';
const $ba006da76aaca3f3$export$221595834b8766ab = '~';
const $ba006da76aaca3f3$export$fcefabf94a9bffbf = '!~';
const $ba006da76aaca3f3$export$4feeb3f4ff56bcef = 'is';
const $ba006da76aaca3f3$export$d08d969a0da27188 = 'is not';
const $ba006da76aaca3f3$export$8f907e179985256d = 'was';
const $ba006da76aaca3f3$export$cc7b9d0b3ee23193 = 'was in';
const $ba006da76aaca3f3$export$585d3c004af078bb = 'was not in';
const $ba006da76aaca3f3$export$123eaa9ccc2d9445 = 'was not';
const $ba006da76aaca3f3$export$15f5b446ba8c941e = 'changed';
const $ba006da76aaca3f3$export$643c6101f3fc8547 = [
    $ba006da76aaca3f3$export$466517a888d00195,
    $ba006da76aaca3f3$export$6d0d8810623974a5
];
const $ba006da76aaca3f3$export$329664c9cf18cca6 = [
    $ba006da76aaca3f3$export$221595834b8766ab,
    $ba006da76aaca3f3$export$fcefabf94a9bffbf
];
const $ba006da76aaca3f3$export$1b167a3705885a8b = [
    $ba006da76aaca3f3$export$4bf1a4aa659c6ea4,
    $ba006da76aaca3f3$export$bcbb090ab3c498b3,
    $ba006da76aaca3f3$export$9629fd1727ef62ee,
    $ba006da76aaca3f3$export$83ce674214a54b2a
];
const $ba006da76aaca3f3$export$f25cf16c2270312f = [
    $ba006da76aaca3f3$export$c4e3fb55e320e979,
    $ba006da76aaca3f3$export$f9857532eaa24ddc
];
const $ba006da76aaca3f3$export$eb58cfffe4a6b805 = [
    $ba006da76aaca3f3$export$4feeb3f4ff56bcef,
    $ba006da76aaca3f3$export$d08d969a0da27188
];
const $ba006da76aaca3f3$export$c22a981f581de218 = [
    $ba006da76aaca3f3$export$8f907e179985256d,
    $ba006da76aaca3f3$export$123eaa9ccc2d9445
];
const $ba006da76aaca3f3$export$6d08c4699bb75284 = [
    $ba006da76aaca3f3$export$cc7b9d0b3ee23193,
    $ba006da76aaca3f3$export$585d3c004af078bb
];
const $ba006da76aaca3f3$export$b7dc214eef214c1c = [
    $ba006da76aaca3f3$export$15f5b446ba8c941e
];
const $ba006da76aaca3f3$export$184799fc79ccac89 = [
    ...$ba006da76aaca3f3$export$643c6101f3fc8547,
    ...$ba006da76aaca3f3$export$329664c9cf18cca6,
    ...$ba006da76aaca3f3$export$1b167a3705885a8b,
    ...$ba006da76aaca3f3$export$f25cf16c2270312f,
    ...$ba006da76aaca3f3$export$eb58cfffe4a6b805,
    ...$ba006da76aaca3f3$export$c22a981f581de218,
    ...$ba006da76aaca3f3$export$6d08c4699bb75284,
    ...$ba006da76aaca3f3$export$b7dc214eef214c1c
];
const $ba006da76aaca3f3$export$77c793736847e030 = [
    $ba006da76aaca3f3$export$c4e3fb55e320e979,
    $ba006da76aaca3f3$export$f9857532eaa24ddc,
    $ba006da76aaca3f3$export$cc7b9d0b3ee23193,
    $ba006da76aaca3f3$export$585d3c004af078bb
];

});



parcelRegister("4j1I4", function(module, exports) {
$parcel$export(module.exports, "operator", () => $8004881b4a0c3525$export$dbd72860f701d4f3);
$parcel$export(module.exports, "operatorInternal", () => $8004881b4a0c3525$export$649025bc60ab9c3b);

var $aDydw = parcelRequire("aDydw");
function $8004881b4a0c3525$var$acceptOperator(visitor) {
    return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
}
function $8004881b4a0c3525$var$enterNode(listener) {
    listener.enterOperator && listener.enterOperator(this);
}
function $8004881b4a0c3525$var$exitNode(listener) {
    listener.exitOperator && listener.exitOperator(this);
}
const $8004881b4a0c3525$export$dbd72860f701d4f3 = (value)=>$8004881b4a0c3525$export$649025bc60ab9c3b(value, value);
const $8004881b4a0c3525$export$649025bc60ab9c3b = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $8004881b4a0c3525$var$acceptOperator,
        enterNode: $8004881b4a0c3525$var$enterNode,
        exitNode: $8004881b4a0c3525$var$exitNode,
        getChildren: (0, $aDydw.noChildren),
        parent: null
    });

});

parcelRegister("1bKwy", function(module, exports) {
$parcel$export(module.exports, "orderBy", () => $7fa0b36b8045d64a$export$f18af21d6f4dafd8);
$parcel$export(module.exports, "orderByInternal", () => $7fa0b36b8045d64a$export$e4eb1fa6bc8465c1);


var $8C6iE = parcelRequire("8C6iE");

var $aDydw = parcelRequire("aDydw");

var $eSCw7 = parcelRequire("eSCw7");
function $7fa0b36b8045d64a$var$acceptOrderBy(visitor) {
    return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
}
function $7fa0b36b8045d64a$var$enterNode(listener) {
    listener.enterOrderBy && listener.enterOrderBy(this);
}
function $7fa0b36b8045d64a$var$exitNode(listener) {
    listener.exitOrderBy && listener.exitOrderBy(this);
}
function $7fa0b36b8045d64a$var$getChildren() {
    return [
        this.operator,
        ...this.fields
    ];
}
const $7fa0b36b8045d64a$export$f18af21d6f4dafd8 = (fields)=>{
    return $7fa0b36b8045d64a$export$e4eb1fa6bc8465c1(fields, (0, $eSCw7.orderByOperator)());
};
const $7fa0b36b8045d64a$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
    const node = {
        type: (0, $cf20d4e3958ad98b$export$da0f73edded4a63d),
        operator: operator,
        fields: fields,
        position: position,
        accept: $7fa0b36b8045d64a$var$acceptOrderBy,
        enterNode: $7fa0b36b8045d64a$var$enterNode,
        exitNode: $7fa0b36b8045d64a$var$exitNode,
        getChildren: $7fa0b36b8045d64a$var$getChildren,
        parent: null,
        prependOrderField: $8C6iE.prependOrderField,
        setOrderDirection: $8C6iE.setOrderDirection,
        replace: $8C6iE.replace,
        replaceOrderField: $8C6iE.replaceOrderField,
        remove: $8C6iE.remove,
        removeOrderField: $8C6iE.removeOrderField
    };
    (0, $aDydw.assignParent)(node);
    return node;
};

});
parcelRegister("8C6iE", function(module, exports) {
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceOrderField", () => replaceOrderField);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeOrderField", () => removeOrderField);

var $aDydw = parcelRequire("aDydw");
function prependOrderField(orderField) {
    this.fields.unshift(orderField);
    (0, $aDydw.assignParent)(this);
}
function setOrderDirection(orderDirection) {
    if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
}
function replace(nextOrderBy) {
    if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
}
function replaceOrderField(orderByField, nextOrderByField) {
    this.fields = this.fields.map((child)=>{
        return child === orderByField ? nextOrderByField : child;
    });
    (0, $aDydw.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeOrderBy();
}
function removeOrderField(orderByField) {
    this.fields = this.fields.filter((field)=>field !== orderByField);
    if (this.fields.length === 0) this.remove();
}

});

parcelRegister("eSCw7", function(module, exports) {
$parcel$export(module.exports, "orderByOperator", () => $7a7afe0d37f27488$export$c7307b67924c61ea);
$parcel$export(module.exports, "orderByOperatorInternal", () => $7a7afe0d37f27488$export$739e30af23a08da0);


var $aDydw = parcelRequire("aDydw");
function $7a7afe0d37f27488$var$acceptOrderByOperator(visitor) {
    return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
}
function $7a7afe0d37f27488$var$enterNode(listener) {
    listener.enterOrderByOperator && listener.enterOrderByOperator(this);
}
function $7a7afe0d37f27488$var$exitNode(listener) {
    listener.exitOrderByOperator && listener.exitOrderByOperator(this);
}
const $7a7afe0d37f27488$export$c7307b67924c61ea = ()=>$7a7afe0d37f27488$export$739e30af23a08da0();
const $7a7afe0d37f27488$export$739e30af23a08da0 = (position = null)=>({
        value: (0, $76fbc49409d18be4$export$ca51f5fd60a74517),
        position: position,
        accept: $7a7afe0d37f27488$var$acceptOrderByOperator,
        enterNode: $7a7afe0d37f27488$var$enterNode,
        exitNode: $7a7afe0d37f27488$var$exitNode,
        getChildren: (0, $aDydw.noChildren),
        parent: null
    });

});
const $76fbc49409d18be4$export$ca51f5fd60a74517 = 'ORDER BY';
const $76fbc49409d18be4$export$6d60017b9e092e73 = 'ASC';
const $76fbc49409d18be4$export$2ea27ea5f2121899 = 'DESC';



parcelRegister("1KT8M", function(module, exports) {
$parcel$export(module.exports, "orderByDirection", () => $18a911f5ed3b9f13$export$864d934efed3ccaa);
$parcel$export(module.exports, "orderByDirectionInternal", () => $18a911f5ed3b9f13$export$8c65cac1a7852d1f);

var $aDydw = parcelRequire("aDydw");
function $18a911f5ed3b9f13$var$acceptOrderByDirection(visitor) {
    return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
}
function $18a911f5ed3b9f13$var$enterNode(listener) {
    listener.enterOrderByDirection && listener.enterOrderByDirection(this);
}
function $18a911f5ed3b9f13$var$exitNode(listener) {
    listener.exitOrderByDirection && listener.exitOrderByDirection(this);
}
const $18a911f5ed3b9f13$export$864d934efed3ccaa = (value)=>$18a911f5ed3b9f13$export$8c65cac1a7852d1f(value);
const $18a911f5ed3b9f13$export$8c65cac1a7852d1f = (value, position = null)=>({
        value: value,
        position: position,
        accept: $18a911f5ed3b9f13$var$acceptOrderByDirection,
        enterNode: $18a911f5ed3b9f13$var$enterNode,
        exitNode: $18a911f5ed3b9f13$var$exitNode,
        getChildren: (0, $aDydw.noChildren),
        parent: null
    });

});

parcelRegister("d7ASl", function(module, exports) {
$parcel$export(module.exports, "orderByField", () => $086fb3748eb77435$export$942df63e5e3d3899);
$parcel$export(module.exports, "orderByFieldInternal", () => $086fb3748eb77435$export$661a7786e3d15926);

var $LfjIH = parcelRequire("LfjIH");

var $aDydw = parcelRequire("aDydw");
function $086fb3748eb77435$var$acceptOrderByField(visitor) {
    return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
}
function $086fb3748eb77435$var$enterNode(listener) {
    listener.enterOrderByField && listener.enterOrderByField(this);
}
function $086fb3748eb77435$var$exitNode(listener) {
    listener.exitOrderByField && listener.exitOrderByField(this);
}
function $086fb3748eb77435$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.direction) children.push(this.direction);
    return children;
}
const $086fb3748eb77435$export$942df63e5e3d3899 = (field, direction)=>$086fb3748eb77435$export$661a7786e3d15926(field, direction);
const $086fb3748eb77435$export$661a7786e3d15926 = (field, direction, position = null)=>{
    const node = {
        field: field,
        direction: direction,
        position: position,
        accept: $086fb3748eb77435$var$acceptOrderByField,
        enterNode: $086fb3748eb77435$var$enterNode,
        exitNode: $086fb3748eb77435$var$exitNode,
        getChildren: $086fb3748eb77435$var$getChildren,
        parent: null,
        setOrderDirection: $LfjIH.setOrderDirection,
        replace: $LfjIH.replace,
        remove: $LfjIH.remove
    };
    (0, $aDydw.assignParent)(node);
    return node;
};

});
parcelRegister("LfjIH", function(module, exports) {
$parcel$export(module.exports, "setOrderDirection", () => $95889886e1ef02fb$export$b596730931a09703);
$parcel$export(module.exports, "replace", () => $95889886e1ef02fb$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "remove", () => $95889886e1ef02fb$export$cd7f480d6b8286c3);

var $aDydw = parcelRequire("aDydw");
function $95889886e1ef02fb$export$b596730931a09703(orderDirection) {
    this.direction = orderDirection;
    (0, $aDydw.assignParent)(this);
}
function $95889886e1ef02fb$export$77ad94ebf1c2b9ed(orderByField) {
    if (this.parent) this.parent.replaceOrderField(this, orderByField);
}
function $95889886e1ef02fb$export$cd7f480d6b8286c3() {
    if (this.parent) this.parent.removeOrderField(this);
}

});


parcelRegister("8IgBR", function(module, exports) {
$parcel$export(module.exports, "predicate", () => $1ecdbf998a0e2651$export$5fc51e445ce24faf);
$parcel$export(module.exports, "predicateInternal", () => $1ecdbf998a0e2651$export$a767a27ad05a38a2);

var $aDydw = parcelRequire("aDydw");
function $1ecdbf998a0e2651$var$acceptPredicate(visitor) {
    return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
}
function $1ecdbf998a0e2651$var$enterNode(listener) {
    listener.enterPredicate && listener.enterPredicate(this);
}
function $1ecdbf998a0e2651$var$exitNode(listener) {
    listener.exitPredicate && listener.exitPredicate(this);
}
function $1ecdbf998a0e2651$var$getChildren() {
    const children = [
        this.operator
    ];
    if (this.operand) children.push(this.operand);
    return children;
}
const $1ecdbf998a0e2651$export$5fc51e445ce24faf = (operator, operand)=>$1ecdbf998a0e2651$export$a767a27ad05a38a2(operator, operand);
const $1ecdbf998a0e2651$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
    const node = {
        operator: operator,
        operand: operand,
        position: position,
        accept: $1ecdbf998a0e2651$var$acceptPredicate,
        enterNode: $1ecdbf998a0e2651$var$enterNode,
        exitNode: $1ecdbf998a0e2651$var$exitNode,
        getChildren: $1ecdbf998a0e2651$var$getChildren,
        parent: null
    };
    (0, $aDydw.assignParent)(node);
    return node;
};

});

parcelRegister("KpZhL", function(module, exports) {
$parcel$export(module.exports, "predicateOperator", () => $6341fe5d8cfb766a$export$5419b7f16910ea62);
$parcel$export(module.exports, "predicateOperatorInternal", () => $6341fe5d8cfb766a$export$c69d893689716768);

var $aDydw = parcelRequire("aDydw");
function $6341fe5d8cfb766a$var$acceptPredicateOperator(visitor) {
    return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
}
function $6341fe5d8cfb766a$var$enterNode(listener) {
    listener.enterPredicateOperator && listener.enterPredicateOperator(this);
}
function $6341fe5d8cfb766a$var$exitNode(listener) {
    listener.exitPredicateOperator && listener.exitPredicateOperator(this);
}
const $6341fe5d8cfb766a$export$5419b7f16910ea62 = (value)=>$6341fe5d8cfb766a$export$c69d893689716768(value, value);
const $6341fe5d8cfb766a$export$c69d893689716768 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $6341fe5d8cfb766a$var$acceptPredicateOperator,
        enterNode: $6341fe5d8cfb766a$var$enterNode,
        exitNode: $6341fe5d8cfb766a$var$exitNode,
        getChildren: (0, $aDydw.noChildren),
        parent: null
    });

});

parcelRegister("guMUP", function(module, exports) {
$parcel$export(module.exports, "property", () => $39e4632739f65248$export$d541bacb2bda4494);
$parcel$export(module.exports, "propertyInternal", () => $39e4632739f65248$export$1cbd90994fef1fad);

var $aDydw = parcelRequire("aDydw");
function $39e4632739f65248$var$acceptProperty(visitor) {
    return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
}
function $39e4632739f65248$var$enterNode(listener) {
    listener.enterProperty && listener.enterProperty(this);
}
function $39e4632739f65248$var$exitNode(listener) {
    listener.exitProperty && listener.exitProperty(this);
}
function $39e4632739f65248$var$getChildren() {
    const children = [];
    if (this.key) children.push(this.key);
    if (this.path) return children.concat(this.path);
    return children;
}
const $39e4632739f65248$export$d541bacb2bda4494 = (key, path = [])=>$39e4632739f65248$export$1cbd90994fef1fad(key, path);
const $39e4632739f65248$export$1cbd90994fef1fad = (key, path, position = null)=>{
    const node = {
        key: key,
        path: path,
        position: position,
        accept: $39e4632739f65248$var$acceptProperty,
        enterNode: $39e4632739f65248$var$enterNode,
        exitNode: $39e4632739f65248$var$exitNode,
        getChildren: $39e4632739f65248$var$getChildren,
        parent: null
    };
    (0, $aDydw.assignParent)(node);
    return node;
};

});

parcelRegister("a1phL", function(module, exports) {
$parcel$export(module.exports, "query", () => $015732f7fccd3847$export$2fa187e846a241c4);
$parcel$export(module.exports, "queryInternal", () => $015732f7fccd3847$export$bc2d6e2e1fd9014);


var $1c1Fw = parcelRequire("1c1Fw");

var $aDydw = parcelRequire("aDydw");
/**
 * AstNode accept functions. We define them outside of the creator function so the same function reference is returned
 * when a creator is invoked multiple times (which is helpful when testing for equality of AST objects).
 */ function $015732f7fccd3847$var$acceptQuery(visitor) {
    return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
}
function $015732f7fccd3847$var$enterNode(listener) {
    listener.enterQuery && listener.enterQuery(this);
}
function $015732f7fccd3847$var$exitNode(listener) {
    listener.exitQuery && listener.exitQuery(this);
}
function $015732f7fccd3847$var$getChildren() {
    const children = [];
    if (this.where) children.push(this.where);
    if (this.orderBy) children.push(this.orderBy);
    return children;
}
const $015732f7fccd3847$export$2fa187e846a241c4 = (where, orderBy)=>$015732f7fccd3847$export$bc2d6e2e1fd9014(where, orderBy);
const $015732f7fccd3847$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
    const node = {
        type: (0, $cf20d4e3958ad98b$export$98dda21ec825792),
        where: where,
        orderBy: orderBy,
        position: position,
        accept: $015732f7fccd3847$var$acceptQuery,
        enterNode: $015732f7fccd3847$var$enterNode,
        exitNode: $015732f7fccd3847$var$exitNode,
        getChildren: $015732f7fccd3847$var$getChildren,
        parent: null,
        appendClause: $1c1Fw.appendClause,
        prependOrderField: $1c1Fw.prependOrderField,
        setOrderDirection: $1c1Fw.setOrderDirection,
        removeClause: $1c1Fw.removeClause,
        replaceClause: $1c1Fw.replaceClause,
        replaceOrderBy: $1c1Fw.replaceOrderBy,
        removeOrderBy: $1c1Fw.removeOrderBy
    };
    (0, $aDydw.assignParent)(node);
    return node;
};

});
parcelRegister("1c1Fw", function(module, exports) {
$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replaceOrderBy", () => replaceOrderBy);
$parcel$export(module.exports, "replaceClause", () => replaceClause);
$parcel$export(module.exports, "removeOrderBy", () => removeOrderBy);

var $2Uq3M = parcelRequire("2Uq3M");

var $aDydw = parcelRequire("aDydw");
function appendClause(clause, compoundOperatorValue) {
    if (!this.where) this.where = clause;
    else {
        const nextCompoundOperator = (0, $2Uq3M.default).compoundOperator(compoundOperatorValue);
        const nextClause = (0, $2Uq3M.default).compoundClause(nextCompoundOperator, []);
        // Append previous and new clause which will flatten compound clauses with matching operators.
        nextClause.appendClause(this.where);
        nextClause.appendClause(clause);
        this.where = nextClause;
    }
    (0, $aDydw.assignParent)(this);
}
function prependOrderField(orderField) {
    if (!this.orderBy) {
        this.orderBy = (0, $2Uq3M.default).orderBy([
            orderField
        ]);
        (0, $aDydw.assignParent)(this);
    } else this.orderBy.prependOrderField(orderField);
}
function setOrderDirection(orderDirection) {
    if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
}
function removeClause(clause) {
    if (this.where === clause) this.where = undefined;
}
function replaceOrderBy(orderBy) {
    if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
    else {
        this.orderBy = orderBy;
        (0, $aDydw.assignParent)(this);
    }
}
function replaceClause(clause, nextClause) {
    if (this.where === clause) {
        this.where = nextClause;
        (0, $aDydw.assignParent)(this);
    }
}
function removeOrderBy() {
    this.orderBy = undefined;
}

});


parcelRegister("4o173", function(module, exports) {
$parcel$export(module.exports, "terminalClause", () => $fe083ee023afc524$export$2627cbe08dd86b00);
$parcel$export(module.exports, "terminalClauseInternal", () => $fe083ee023afc524$export$cc08e43598d091fc);


var $XiGXE = parcelRequire("XiGXE");

var $aDydw = parcelRequire("aDydw");
function $fe083ee023afc524$var$acceptTerminalClause(visitor) {
    return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
}
function $fe083ee023afc524$var$enterNode(listener) {
    listener.enterTerminalClause && listener.enterTerminalClause(this);
}
function $fe083ee023afc524$var$exitNode(listener) {
    listener.exitTerminalClause && listener.exitTerminalClause(this);
}
function $fe083ee023afc524$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.operator) children.push(this.operator);
    if (this.operand) children.push(this.operand);
    return children.concat(this.predicates);
}
const $fe083ee023afc524$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
    return $fe083ee023afc524$export$cc08e43598d091fc(field, operator, operand, predicates);
};
const $fe083ee023afc524$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
    const node = {
        type: (0, $cf20d4e3958ad98b$export$2d205682cc545947),
        clauseType: (0, $45358584c5e1587f$export$ae56b4ef248a2b6a),
        field: field,
        operator: operator,
        operand: operand,
        predicates: predicates,
        position: position,
        accept: $fe083ee023afc524$var$acceptTerminalClause,
        enterNode: $fe083ee023afc524$var$enterNode,
        exitNode: $fe083ee023afc524$var$exitNode,
        getChildren: $fe083ee023afc524$var$getChildren,
        parent: null,
        setOperator: $XiGXE.setOperator,
        setOperand: $XiGXE.setOperand,
        appendOperand: $XiGXE.appendOperand,
        remove: $XiGXE.remove,
        replace: $XiGXE.replace
    };
    (0, $aDydw.assignParent)(node);
    return node;
};

});
parcelRegister("XiGXE", function(module, exports) {
$parcel$export(module.exports, "setOperator", () => setOperator);
$parcel$export(module.exports, "setOperand", () => setOperand);
$parcel$export(module.exports, "appendOperand", () => appendOperand);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replace", () => replace);


var $2Uq3M = parcelRequire("2Uq3M");

var $aDydw = parcelRequire("aDydw");
function setOperator(operator) {
    this.operator = operator;
    (0, $aDydw.assignParent)(this);
}
function setOperand(operand) {
    this.operand = operand;
    (0, $aDydw.assignParent)(this);
}
function appendOperand(operand) {
    if (this.operand) {
        if (this.operand.operandType === (0, $1bca8a68bc08e4bf$export$fabec4aebba3f4df)) this.operand.appendOperand(operand);
        else this.setOperand((0, $2Uq3M.default).listOperand([
            this.operand,
            ...operand.operandType === (0, $1bca8a68bc08e4bf$export$fabec4aebba3f4df) ? operand.values : [
                operand
            ]
        ]));
    } else this.setOperand(operand);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}

});


parcelRegister("1K8Za", function(module, exports) {
$parcel$export(module.exports, "valueOperand", () => $498d2fa555d286ae$export$2b6e4d2ed8d53bf3);
$parcel$export(module.exports, "valueOperandInternal", () => $498d2fa555d286ae$export$79c37d97caac8627);
$parcel$export(module.exports, "valueOperandByText", () => $498d2fa555d286ae$export$3ac9155bde56a45f);


var $5d17Q = parcelRequire("5d17Q");
var $dPIaU = parcelRequire("dPIaU");

var $aDydw = parcelRequire("aDydw");
function $498d2fa555d286ae$var$acceptValueOperand(visitor) {
    return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
}
function $498d2fa555d286ae$var$enterNode(listener) {
    listener.enterValueOperand && listener.enterValueOperand(this);
}
function $498d2fa555d286ae$var$exitNode(listener) {
    listener.exitValueOperand && listener.exitValueOperand(this);
}
const $498d2fa555d286ae$export$2b6e4d2ed8d53bf3 = (value)=>$498d2fa555d286ae$export$79c37d97caac8627(value, (0, $dPIaU.sanitiseJqlString)(value));
const $498d2fa555d286ae$export$3ac9155bde56a45f = (text)=>$498d2fa555d286ae$export$79c37d97caac8627((0, $5d17Q.normaliseJqlString)(text), text);
const $498d2fa555d286ae$export$79c37d97caac8627 = (value, text, position = null)=>({
        type: (0, $cf20d4e3958ad98b$export$d2f212d8ddbc8d1d),
        operandType: (0, $1bca8a68bc08e4bf$export$38accfc5a5d1c113),
        text: text,
        value: value,
        position: position,
        accept: $498d2fa555d286ae$var$acceptValueOperand,
        enterNode: $498d2fa555d286ae$var$enterNode,
        exitNode: $498d2fa555d286ae$var$exitNode,
        getChildren: (0, $aDydw.noChildren),
        parent: null
    });

});


parcelRegister("9FSd1", function(module, exports) {
$parcel$export(module.exports, "print", () => $e3cd52a04d4058a2$export$c2d084dc44961371);

var $gVFE3 = parcelRequire("gVFE3");

var $7yzVg = parcelRequire("7yzVg");

var $7YMXc = parcelRequire("7YMXc");
const $e3cd52a04d4058a2$export$c2d084dc44961371 = (jast, options = {})=>{
    return (0, $7YMXc.printDocToString)((0, $7yzVg.printAstToDoc)(jast, (0, (/*@__PURE__*/$parcel$interopDefault($gVFE3)))(options, [
        'operatorCase'
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($gVFE3)))(options, [
        'printWidth'
    ]));
};

});
parcelRegister("gVFE3", function(module, exports) {

var $bbfDv = parcelRequire("bbfDv");

var $5skZT = parcelRequire("5skZT");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $c532460ce91509de$var$pick = $5skZT(function(object, paths) {
    return object == null ? {} : $bbfDv(object, paths);
});
module.exports = $c532460ce91509de$var$pick;

});
parcelRegister("bbfDv", function(module, exports) {

var $gAOXx = parcelRequire("gAOXx");

var $27fbA = parcelRequire("27fbA");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $823cd9cb930fa0f5$var$basePick(object, paths) {
    return $gAOXx(object, paths, function(value, path) {
        return $27fbA(object, path);
    });
}
module.exports = $823cd9cb930fa0f5$var$basePick;

});


parcelRegister("7yzVg", function(module, exports) {
$parcel$export(module.exports, "printAstToDoc", () => $ab36a590e820b24a$export$f0ef38932978952);


var $aVek2 = parcelRequire("aVek2");

var $l2fFf = parcelRequire("l2fFf");
const $ab36a590e820b24a$var$formatOperator = (operator, operatorCase)=>{
    switch(operatorCase){
        case 'lower':
            return operator.toLowerCase();
        case 'upper':
            return operator.toUpperCase();
        case 'preserve':
            return operator;
    }
};
class $ab36a590e820b24a$export$27a275559a5c8102 extends (0, $aVek2.AbstractJastVisitor) {
    constructor({ operatorCase: operatorCase } = {}){
        super();
        this.operatorCase = operatorCase || 'preserve';
    }
    visitArgument(argument) {
        return argument.text;
    }
    /**
	 * Visit each of the provided nodes and form a new array with each `Doc` joined by the provided separator.
	 */ joinNodes(nodes, separator) {
        const docs = [];
        nodes.forEach((node)=>{
            if (separator !== undefined && docs.length > 0) docs.push(separator);
            docs.push(node.accept(this));
        });
        return docs;
    }
    visitCompoundClause(compoundClause) {
        const operatorDoc = compoundClause.operator.accept(this);
        const clauseDocs = [];
        compoundClause.clauses.forEach((clause)=>{
            if (clauseDocs.length > 0) clauseDocs.push((0, $l2fFf.ifBreak)((0, $l2fFf.newLine)(), ' '), operatorDoc, ' ');
            // Wrap nested compound clauses in parentheses
            if (clause.clauseType === (0, $45358584c5e1587f$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
            else clauseDocs.push(clause.accept(this));
        });
        return (0, $l2fFf.group)(clauseDocs);
    }
    visitCompoundOperator(compoundOperator) {
        return $ab36a590e820b24a$var$formatOperator(compoundOperator.value, this.operatorCase);
    }
    visitField(field) {
        const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
        return (0, $l2fFf.group)([
            field.text,
            ...propertyDocs
        ]);
    }
    visitFunction(functionString) {
        return functionString.text;
    }
    visitFunctionOperand(functionOperand) {
        const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
        return (0, $l2fFf.group)([
            functionOperand.function.accept(this),
            '(',
            ...argumentDocs,
            ')'
        ]);
    }
    visitKeywordOperand(keywordOperand) {
        return keywordOperand.value;
    }
    visitListOperand(listOperand) {
        const operandDocs = this.joinNodes(listOperand.values, ', ');
        return (0, $l2fFf.group)([
            '(',
            ...operandDocs,
            ')'
        ]);
    }
    visitOperator(operator) {
        return $ab36a590e820b24a$var$formatOperator(operator.text, this.operatorCase);
    }
    visitOrderBy(orderBy) {
        const fieldDocs = this.joinNodes(orderBy.fields, ', ');
        return (0, $l2fFf.group)([
            orderBy.operator.accept(this),
            ' ',
            ...fieldDocs
        ]);
    }
    visitOrderByDirection(orderByDirection) {
        return orderByDirection.value;
    }
    visitOrderByField(orderByField) {
        const docs = [
            orderByField.field.accept(this)
        ];
        if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
        return (0, $l2fFf.group)(docs);
    }
    visitOrderByOperator(orderByOperator) {
        return $ab36a590e820b24a$var$formatOperator(orderByOperator.value, this.operatorCase);
    }
    visitPredicate(predicate) {
        const docs = [
            predicate.operator.accept(this)
        ];
        if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
        return (0, $l2fFf.group)(docs);
    }
    visitPredicateOperator(predicateOperator) {
        return $ab36a590e820b24a$var$formatOperator(predicateOperator.text, this.operatorCase);
    }
    visitProperty(property) {
        const docs = [];
        if (property.key) docs.push('[', property.key.accept(this), ']');
        if (property.path) {
            const pathDocs = this.joinNodes(property.path, ' ');
            docs.push(...pathDocs);
        }
        return (0, $l2fFf.group)(docs);
    }
    visitQuery(query) {
        if (query.where && query.orderBy) return (0, $l2fFf.group)([
            query.where.accept(this),
            (0, $l2fFf.ifBreak)((0, $l2fFf.newLine)(), ' '),
            query.orderBy.accept(this)
        ]);
        else if (query.where) return query.where.accept(this);
        else if (query.orderBy) return query.orderBy.accept(this);
        return '';
    }
    visitTerminalClause(terminalClause) {
        const docs = [
            terminalClause.field.accept(this)
        ];
        if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
        if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
        terminalClause.predicates.forEach((predicate)=>{
            docs.push(' ', predicate.accept(this));
        });
        return (0, $l2fFf.group)(docs);
    }
    visitValueOperand(valueOperand) {
        return valueOperand.text;
    }
    visitNotClause(notClause) {
        const clauseDocs = [];
        // Wrap nested compound clauses in parentheses
        if (notClause.clause.clauseType === (0, $45358584c5e1587f$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
        else clauseDocs.push(notClause.clause.accept(this));
        return (0, $l2fFf.group)([
            notClause.operator.accept(this),
            ' ',
            ...clauseDocs
        ]);
    }
    visitNotClauseOperator(notClauseOperator) {
        return notClauseOperator.value;
    }
    visitChildren() {
        throw new Error('Required visit method not implemented for node');
    }
    defaultResult() {
        return '';
    }
}
const $ab36a590e820b24a$export$f0ef38932978952 = (jast, options)=>{
    const astToDocVisitor = new $ab36a590e820b24a$export$27a275559a5c8102(options);
    return jast.query ? jast.query.accept(astToDocVisitor) : '';
};

});
parcelRegister("aVek2", function(module, exports) {
$parcel$export(module.exports, "AbstractJastVisitor", () => $8ad729d10683d1fe$export$51be62b46ee668fd);
class $8ad729d10683d1fe$export$51be62b46ee668fd {
    /**
	 * The default implementation calls AstNode#accept on the specified node.
	 * @param node
	 */ visit(node) {
        return node.accept(this);
    }
    /**
	 * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
	 * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
	 * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
	 * aggregate result and the result of visiting the child.
	 */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
	 * Aggregates the results of visiting multiple children of a node.
	 *
	 * The default implementation returns `nextResult`, meaning
	 * {@link #visitChildren} will return the result of the last child visited
	 * (or return the initial value if the node has no children).
	 *
	 * @param _aggregate The previous aggregate value. In the default
	 * implementation, the aggregate value is initialized to
	 * {@link #defaultResult}, which is passed as the `aggregate` argument
	 * to this method after the first child node is visited.
	 * @param nextResult The result of the immediately preceeding call to visit
	 * a child node.
	 *
	 * @returns The updated aggregate result.
	 */ aggregateResult(_aggregate, nextResult) {
        return nextResult;
    }
    /**
	 * This method is called before visiting each child in
	 * {@link #visitChildren}. When the method is first called\ `currentResult`
	 * will be the initial value (in the default implementation, the initial value
	 * is returned by a call to {@link #defaultResult}).
	 *
	 * The default implementation always returns `true`, indicating that
	 * `visitChildren` should only return after all children are visited.
	 * One reason to override this method is to provide a "short circuit"
	 * evaluation option for situations where the result of visiting a single
	 * child has the potential to determine the result of the visit operation as
	 * a whole.
	 *
	 * @param _node The {@link AstNode} whose children are currently being
	 * visited.
	 * @param _currentResult The current aggregate result of the children visited
	 * to the current point.
	 *
	 * @returns `true` to continue visiting children. Otherwise return
	 * `false` to stop visiting children and immediately return the
	 * current aggregate result from {@link #visitChildren}.
	 */ shouldVisitNextChild(_node, _currentResult) {
        return true;
    }
}

});

parcelRegister("l2fFf", function(module, exports) {
$parcel$export(module.exports, "group", () => $db323cee1c2a0a6e$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "ifBreak", () => $db323cee1c2a0a6e$export$1db8e61901dcb0fa);
$parcel$export(module.exports, "newLine", () => $db323cee1c2a0a6e$export$dc84f6841f96b7da);
const $db323cee1c2a0a6e$export$e5e25fbcc1f7affe = (contents)=>{
    return {
        type: 'group',
        contents: contents
    };
};
const $db323cee1c2a0a6e$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
    return {
        type: 'if-break',
        breakContents: breakContents,
        flatContents: flatContents
    };
};
const $db323cee1c2a0a6e$export$dc84f6841f96b7da = ()=>{
    return {
        type: 'new-line'
    };
};

});


parcelRegister("7YMXc", function(module, exports) {
$parcel$export(module.exports, "printDocToString", () => $c57a22a375f3aa71$export$316fc7e94b95b118);
const $c57a22a375f3aa71$var$computeFlatWidth = (doc)=>{
    if (typeof doc === 'string') return doc.length;
    if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $c57a22a375f3aa71$var$computeFlatWidth(innerDoc), 0);
    switch(doc.type){
        case 'group':
            return $c57a22a375f3aa71$var$computeFlatWidth(doc.contents);
        case 'if-break':
            return $c57a22a375f3aa71$var$computeFlatWidth(doc.flatContents);
        case 'new-line':
            // TODO This probably represents a bug as we don't expect new lines in the flat path
            return 0;
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $c57a22a375f3aa71$var$printDoc = (doc, context)=>{
    if (typeof doc === 'string') return {
        result: doc,
        endIndex: context.startIndex + doc.length
    };
    switch(doc.type){
        case 'group':
            return $c57a22a375f3aa71$var$printGroup(doc, context);
        case 'if-break':
            return $c57a22a375f3aa71$var$printIfBreak(doc, context);
        case 'new-line':
            return $c57a22a375f3aa71$var$printNewLine();
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $c57a22a375f3aa71$var$printGroup = (doc, context)=>{
    const docWidth = context.startIndex + $c57a22a375f3aa71$var$computeFlatWidth(doc);
    const breakContents = context.printWidth !== null && docWidth > context.printWidth;
    return doc.contents.reduce((agg, innerDoc)=>{
        const innerContext = {
            ...context,
            startIndex: agg.endIndex,
            breakContents: breakContents
        };
        const output = $c57a22a375f3aa71$var$printDoc(innerDoc, innerContext);
        return {
            result: agg.result + output.result,
            endIndex: output.endIndex
        };
    }, {
        result: '',
        endIndex: context.startIndex
    });
};
const $c57a22a375f3aa71$var$printIfBreak = (doc, context)=>{
    if (context.breakContents) return $c57a22a375f3aa71$var$printDoc(doc.breakContents, context);
    return $c57a22a375f3aa71$var$printDoc(doc.flatContents, context);
};
const $c57a22a375f3aa71$var$printNewLine = ()=>{
    return {
        result: '\n',
        // Reset our end index as a new line is being output.
        endIndex: 0
    };
};
// TODO Tweak this number with design
const $c57a22a375f3aa71$var$defaultPrintWidth = 100;
const $c57a22a375f3aa71$export$316fc7e94b95b118 = (doc, options = {})=>{
    const { printWidth: printWidth = $c57a22a375f3aa71$var$defaultPrintWidth } = options;
    const output = $c57a22a375f3aa71$var$printDoc(doc, {
        printWidth: printWidth,
        startIndex: 0,
        breakContents: false
    });
    return output.result;
};

});


parcelRegister("dTd4l", function(module, exports) {
$parcel$export(module.exports, "JastBuilder", () => $894cc587bc6d9f31$export$99cae18a5a6ba8cf);

var $aIhFs = parcelRequire("aIhFs");

var $emCaV = parcelRequire("emCaV");

var $9G9l9 = parcelRequire("9G9l9");
var $bidr5 = parcelRequire("bidr5");

var $2Uq3M = parcelRequire("2Uq3M");

var $8bTpV = parcelRequire("8bTpV");
var $fd0IB = parcelRequire("fd0IB");

var $tWMHa = parcelRequire("tWMHa");
class $894cc587bc6d9f31$export$99cae18a5a6ba8cf {
    setErrorHandler(errorHandler) {
        this.errorHandler = errorHandler;
        return this;
    }
    setErrorListeners(errorListeners) {
        this.errorListeners = this.errorListeners.concat(errorListeners);
        return this;
    }
    build(value) {
        const tokens = this.getTokens(value);
        const parser = this.getParser(tokens);
        const astErrorListener = new (0, $8bTpV.JastBuilderErrorListener)();
        parser.removeErrorListeners();
        parser.addErrorListener(astErrorListener);
        this.errorListeners.forEach((errorListener)=>parser.addErrorListener(errorListener));
        if (this.errorHandler) {
            parser.errorHandler = this.errorHandler;
            this.errorHandler.reset(parser);
        }
        const visitor = new (0, $tWMHa.QueryVisitor)(tokens);
        try {
            const parseTree = parser.jqlQuery();
            const query = parseTree.accept(visitor);
            return (0, $2Uq3M.default).jast(query, value, astErrorListener.errors);
        } catch (error) {
            return (0, $2Uq3M.default).jast(undefined, value, [
                new (0, $fd0IB.JQLParseError)(error.message, error)
            ]);
        }
    }
    constructor(){
        this.errorListeners = [];
        this.errorHandler = undefined;
        this.getTokens = (0, $emCaV.default)((value)=>{
            const chars = (0, $aIhFs.CharStreams).fromString(value);
            const lexer = new (0, $9G9l9.JQLLexer)(chars);
            return new (0, $aIhFs.CommonTokenStream)(lexer);
        });
        this.getParser = (0, $emCaV.default)((tokens)=>new (0, $bidr5.JQLParser)(tokens));
    }
}

});
parcelRegister("aIhFs", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7ccbb7db91eae1f1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7ccbb7db91eae1f1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7ccbb7db91eae1f1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("k1WPI")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("eirkU")), module.exports);

// export * from "./ANTLRFileStream";
$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("57Nek")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("8X739")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("kIRsr")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("4EZNt")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("inqNA")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("9UJYq")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("bKaDe")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("boV1Q")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("fnPjW")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("3pdFy")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("2gnp0")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("8PzbJ")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("1JWAI")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("7gDoN")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("aaCqm")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("2ITdp")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("dGXa2")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("hPLPA")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("ipeIv")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("j4A7G")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("hqoEr")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("hxaTJ")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("1O6nA")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("5ncBC")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("i3DCp")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("1jn1l")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("gN8af")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("kmhhl")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("2WiKh")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("2XZxT")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("dlP2K")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("aNa7I")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("29eGm")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("1Bl34")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("h3HYk")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("iLVZN")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("bDpCo")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("fiyYX")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("an5fx")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("f7WvC")), module.exports);

// export * from "./UnbufferedCharStream";
// export * from "./UnbufferedTokenStream";
$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("c8fWz")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("7DbrH")), module.exports);

$7ccbb7db91eae1f1$var$__exportStar((parcelRequire("gnNeB")), module.exports);

});
parcelRegister("k1WPI", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eirkU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("57Nek", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ // ConvertTo-TS run at 2016-10-04T11:26:49.0828748-07:00
var $3bb3cb4081388328$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ANTLRInputStream = void 0;

var $lzl5a = parcelRequire("lzl5a");

var $60gAE = parcelRequire("60gAE");

var $hPLPA = parcelRequire("hPLPA");
const $3bb3cb4081388328$var$READ_BUFFER_SIZE = 1024;
const $3bb3cb4081388328$var$INITIAL_BUFFER_SIZE = 1024;
/**
 * Vacuum all input from a {@link Reader}/{@link InputStream} and then treat it
 * like a `char[]` buffer. Can also pass in a {@link String} or
 * `char[]` to use.
 *
 * If you need encoding, pass in stream/reader with correct encoding.
 *
 * @deprecated as of 4.7, please use `CharStreams` interface.
 */ class $3bb3cb4081388328$var$ANTLRInputStream {
    /** Copy data in string to a local char array */ constructor(input){
        /** 0..n-1 index into string of next char */ this.p = 0;
        this.data = input;
        this.n = input.length;
    }
    /** Reset the stream so that it's in the same state it was
     *  when the object was created *except* the data array is not
     *  touched.
     */ reset() {
        this.p = 0;
    }
    consume() {
        if (this.p >= this.n) {
            $lzl5a(this.LA(1) === $hPLPA.IntStream.EOF);
            throw new Error("cannot consume EOF");
        }
        //System.out.println("prev p="+p+", c="+(char)data[p]);
        if (this.p < this.n) this.p++;
    }
    LA(i) {
        if (i === 0) return 0; // undefined
        if (i < 0) {
            i++; // e.g., translate LA(-1) to use offset i=0; then data[p+0-1]
            if (this.p + i - 1 < 0) return $hPLPA.IntStream.EOF; // invalid; no char before first char
        }
        if (this.p + i - 1 >= this.n) //System.out.println("char LA("+i+")=EOF; p="+p);
        return $hPLPA.IntStream.EOF;
        //System.out.println("char LA("+i+")="+(char)data[p+i-1]+"; p="+p);
        //System.out.println("LA("+i+"); p="+p+" n="+n+" data.length="+data.length);
        return this.data.charCodeAt(this.p + i - 1);
    }
    LT(i) {
        return this.LA(i);
    }
    /** Return the current input symbol index 0..n where n indicates the
     *  last symbol has been read.  The index is the index of char to
     *  be returned from LA(1).
     */ get index() {
        return this.p;
    }
    get size() {
        return this.n;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    /** consume() ahead until p==index; can't just set p=index as we must
     *  update line and charPositionInLine. If we seek backwards, just set p
     */ seek(index) {
        if (index <= this.p) {
            this.p = index; // just jump; don't update stream state (line, ...)
            return;
        }
        // seek forward, consume until p hits index or n (whichever comes first)
        index = Math.min(index, this.n);
        while(this.p < index)this.consume();
    }
    getText(interval) {
        let start = interval.a;
        let stop = interval.b;
        if (stop >= this.n) stop = this.n - 1;
        let count = stop - start + 1;
        if (start >= this.n) return "";
        // System.err.println("data: "+Arrays.toString(data)+", n="+n+
        // 				   ", start="+start+
        // 				   ", stop="+stop);
        return this.data.substr(start, count);
    }
    get sourceName() {
        if (!this.name) return $hPLPA.IntStream.UNKNOWN_SOURCE_NAME;
        return this.name;
    }
    toString() {
        return this.data;
    }
}
$3bb3cb4081388328$var$__decorate([
    $60gAE.Override
], $3bb3cb4081388328$var$ANTLRInputStream.prototype, "consume", null);
$3bb3cb4081388328$var$__decorate([
    $60gAE.Override
], $3bb3cb4081388328$var$ANTLRInputStream.prototype, "LA", null);
$3bb3cb4081388328$var$__decorate([
    $60gAE.Override
], $3bb3cb4081388328$var$ANTLRInputStream.prototype, "index", null);
$3bb3cb4081388328$var$__decorate([
    $60gAE.Override
], $3bb3cb4081388328$var$ANTLRInputStream.prototype, "size", null);
$3bb3cb4081388328$var$__decorate([
    $60gAE.Override
], $3bb3cb4081388328$var$ANTLRInputStream.prototype, "mark", null);
$3bb3cb4081388328$var$__decorate([
    $60gAE.Override
], $3bb3cb4081388328$var$ANTLRInputStream.prototype, "release", null);
$3bb3cb4081388328$var$__decorate([
    $60gAE.Override
], $3bb3cb4081388328$var$ANTLRInputStream.prototype, "seek", null);
$3bb3cb4081388328$var$__decorate([
    $60gAE.Override
], $3bb3cb4081388328$var$ANTLRInputStream.prototype, "getText", null);
$3bb3cb4081388328$var$__decorate([
    $60gAE.Override
], $3bb3cb4081388328$var$ANTLRInputStream.prototype, "sourceName", null);
$3bb3cb4081388328$var$__decorate([
    $60gAE.Override
], $3bb3cb4081388328$var$ANTLRInputStream.prototype, "toString", null);
module.exports.ANTLRInputStream = $3bb3cb4081388328$var$ANTLRInputStream;

});
parcelRegister("lzl5a", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $gIMgJ = parcelRequire("gIMgJ");
'use strict';
function $fb3d3862fbfa4899$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fb3d3862fbfa4899$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fb3d3862fbfa4899$var$_typeof(o);
}
function $fb3d3862fbfa4899$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $fb3d3862fbfa4899$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $fb3d3862fbfa4899$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fb3d3862fbfa4899$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fb3d3862fbfa4899$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $fb3d3862fbfa4899$var$_toPropertyKey(arg) {
    var key = $fb3d3862fbfa4899$var$_toPrimitive(arg, "string");
    return $fb3d3862fbfa4899$var$_typeof(key) === "symbol" ? key : String(key);
}
function $fb3d3862fbfa4899$var$_toPrimitive(input, hint) {
    if ($fb3d3862fbfa4899$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($fb3d3862fbfa4899$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $fb3d3862fbfa4899$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $9mauO = parcelRequire("9mauO");
var $fb3d3862fbfa4899$var$_require$codes = $9mauO.codes, $fb3d3862fbfa4899$var$ERR_AMBIGUOUS_ARGUMENT = $fb3d3862fbfa4899$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $fb3d3862fbfa4899$var$ERR_INVALID_ARG_TYPE = $fb3d3862fbfa4899$var$_require$codes.ERR_INVALID_ARG_TYPE, $fb3d3862fbfa4899$var$ERR_INVALID_ARG_VALUE = $fb3d3862fbfa4899$var$_require$codes.ERR_INVALID_ARG_VALUE, $fb3d3862fbfa4899$var$ERR_INVALID_RETURN_VALUE = $fb3d3862fbfa4899$var$_require$codes.ERR_INVALID_RETURN_VALUE, $fb3d3862fbfa4899$var$ERR_MISSING_ARGS = $fb3d3862fbfa4899$var$_require$codes.ERR_MISSING_ARGS;

var $6Ppb0 = parcelRequire("6Ppb0");

var $3djl0 = parcelRequire("3djl0");
var $fb3d3862fbfa4899$var$inspect = $3djl0.inspect;

var $3djl0 = parcelRequire("3djl0");
var $fb3d3862fbfa4899$require$_require$types = $3djl0.types;
var $fb3d3862fbfa4899$var$isPromise = $fb3d3862fbfa4899$require$_require$types.isPromise, $fb3d3862fbfa4899$var$isRegExp = $fb3d3862fbfa4899$require$_require$types.isRegExp;

var $fb3d3862fbfa4899$var$objectAssign = (parcelRequire("57lgS"))();

var $fb3d3862fbfa4899$var$objectIs = (parcelRequire("eVVx0"))();

var $fb3d3862fbfa4899$var$RegExpPrototypeTest = (parcelRequire("4lGI7"))('RegExp.prototype.test');
var $fb3d3862fbfa4899$var$errorCache = new Map();
var $fb3d3862fbfa4899$var$isDeepEqual;
var $fb3d3862fbfa4899$var$isDeepStrictEqual;
var $fb3d3862fbfa4899$var$parseExpressionAt;
var $fb3d3862fbfa4899$var$findNodeAround;
var $fb3d3862fbfa4899$var$decoder;

function $fb3d3862fbfa4899$var$lazyLoadComparison() {
    var comparison = (parcelRequire("jOMIF"));
    $fb3d3862fbfa4899$var$isDeepEqual = comparison.isDeepEqual;
    $fb3d3862fbfa4899$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $fb3d3862fbfa4899$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $fb3d3862fbfa4899$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $fb3d3862fbfa4899$var$escapeFn = function escapeFn(str) {
    return $fb3d3862fbfa4899$var$meta[str.charCodeAt(0)];
};
var $fb3d3862fbfa4899$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $fb3d3862fbfa4899$var$assert = module.exports = $fb3d3862fbfa4899$var$ok;
var $fb3d3862fbfa4899$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $fb3d3862fbfa4899$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $6Ppb0(obj);
}
function $fb3d3862fbfa4899$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($fb3d3862fbfa4899$var$warned === false) {
            $fb3d3862fbfa4899$var$warned = true;
            var warn = $gIMgJ.emitWarning ? $gIMgJ.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $fb3d3862fbfa4899$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $6Ppb0(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$fb3d3862fbfa4899$var$assert.fail = $fb3d3862fbfa4899$var$fail;
// The AssertionError is defined in internal/error.
$fb3d3862fbfa4899$var$assert.AssertionError = $6Ppb0;
function $fb3d3862fbfa4899$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $6Ppb0({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $fb3d3862fbfa4899$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $fb3d3862fbfa4899$var$innerOk.apply(void 0, [
        $fb3d3862fbfa4899$var$ok,
        args.length
    ].concat(args));
}
$fb3d3862fbfa4899$var$assert.ok = $fb3d3862fbfa4899$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $fb3d3862fbfa4899$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $fb3d3862fbfa4899$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $fb3d3862fbfa4899$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$fb3d3862fbfa4899$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $fb3d3862fbfa4899$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $fb3d3862fbfa4899$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$fb3d3862fbfa4899$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $fb3d3862fbfa4899$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($fb3d3862fbfa4899$var$isDeepEqual === undefined) $fb3d3862fbfa4899$var$lazyLoadComparison();
    if (!$fb3d3862fbfa4899$var$isDeepEqual(actual, expected)) $fb3d3862fbfa4899$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$fb3d3862fbfa4899$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $fb3d3862fbfa4899$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($fb3d3862fbfa4899$var$isDeepEqual === undefined) $fb3d3862fbfa4899$var$lazyLoadComparison();
    if ($fb3d3862fbfa4899$var$isDeepEqual(actual, expected)) $fb3d3862fbfa4899$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $fb3d3862fbfa4899$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $fb3d3862fbfa4899$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($fb3d3862fbfa4899$var$isDeepEqual === undefined) $fb3d3862fbfa4899$var$lazyLoadComparison();
    if (!$fb3d3862fbfa4899$var$isDeepStrictEqual(actual, expected)) $fb3d3862fbfa4899$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$fb3d3862fbfa4899$var$assert.notDeepStrictEqual = $fb3d3862fbfa4899$var$notDeepStrictEqual;
function $fb3d3862fbfa4899$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $fb3d3862fbfa4899$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($fb3d3862fbfa4899$var$isDeepEqual === undefined) $fb3d3862fbfa4899$var$lazyLoadComparison();
    if ($fb3d3862fbfa4899$var$isDeepStrictEqual(actual, expected)) $fb3d3862fbfa4899$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $fb3d3862fbfa4899$var$notDeepStrictEqual
    });
}
$fb3d3862fbfa4899$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $fb3d3862fbfa4899$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$fb3d3862fbfa4899$var$objectIs(actual, expected)) $fb3d3862fbfa4899$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$fb3d3862fbfa4899$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $fb3d3862fbfa4899$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($fb3d3862fbfa4899$var$objectIs(actual, expected)) $fb3d3862fbfa4899$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $fb3d3862fbfa4899$var$Comparison = /*#__PURE__*/ $fb3d3862fbfa4899$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $fb3d3862fbfa4899$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $fb3d3862fbfa4899$var$isRegExp(obj[key]) && $fb3d3862fbfa4899$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $fb3d3862fbfa4899$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$fb3d3862fbfa4899$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $fb3d3862fbfa4899$var$Comparison(actual, keys);
            var b = new $fb3d3862fbfa4899$var$Comparison(expected, keys, actual);
            var err = new $6Ppb0({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $fb3d3862fbfa4899$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $fb3d3862fbfa4899$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($fb3d3862fbfa4899$var$isRegExp(expected)) return $fb3d3862fbfa4899$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $fb3d3862fbfa4899$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($fb3d3862fbfa4899$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $6Ppb0({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $fb3d3862fbfa4899$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($fb3d3862fbfa4899$var$isDeepEqual === undefined) $fb3d3862fbfa4899$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $fb3d3862fbfa4899$var$isRegExp(expected[key]) && $fb3d3862fbfa4899$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $fb3d3862fbfa4899$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $fb3d3862fbfa4899$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $fb3d3862fbfa4899$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $fb3d3862fbfa4899$var$NO_EXCEPTION_SENTINEL;
}
function $fb3d3862fbfa4899$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $fb3d3862fbfa4899$var$isPromise(obj) || obj !== null && $fb3d3862fbfa4899$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $fb3d3862fbfa4899$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$fb3d3862fbfa4899$var$checkIsPromise(resultPromise)) throw new $fb3d3862fbfa4899$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($fb3d3862fbfa4899$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $fb3d3862fbfa4899$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $fb3d3862fbfa4899$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $fb3d3862fbfa4899$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $fb3d3862fbfa4899$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($fb3d3862fbfa4899$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $fb3d3862fbfa4899$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $fb3d3862fbfa4899$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $fb3d3862fbfa4899$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $fb3d3862fbfa4899$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $fb3d3862fbfa4899$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $fb3d3862fbfa4899$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$fb3d3862fbfa4899$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $fb3d3862fbfa4899$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $fb3d3862fbfa4899$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $fb3d3862fbfa4899$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $fb3d3862fbfa4899$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$fb3d3862fbfa4899$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $fb3d3862fbfa4899$var$expectsError.apply(void 0, [
        throws,
        $fb3d3862fbfa4899$var$getActual(promiseFn)
    ].concat(args));
};
$fb3d3862fbfa4899$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $fb3d3862fbfa4899$var$waitForActual(promiseFn).then(function(result) {
        return $fb3d3862fbfa4899$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$fb3d3862fbfa4899$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $fb3d3862fbfa4899$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $fb3d3862fbfa4899$var$getActual(fn)
    ].concat(args));
};
$fb3d3862fbfa4899$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $fb3d3862fbfa4899$var$waitForActual(fn).then(function(result) {
        return $fb3d3862fbfa4899$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$fb3d3862fbfa4899$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($fb3d3862fbfa4899$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $fb3d3862fbfa4899$var$inspect(err);
        var newErr = new $6Ppb0({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $fb3d3862fbfa4899$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$fb3d3862fbfa4899$var$isRegExp(regexp)) throw new $fb3d3862fbfa4899$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $fb3d3862fbfa4899$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($fb3d3862fbfa4899$var$_typeof(string), " (").concat($fb3d3862fbfa4899$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($fb3d3862fbfa4899$var$inspect(regexp), ". Input:\n\n").concat($fb3d3862fbfa4899$var$inspect(string), "\n"));
        var err = new $6Ppb0({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$fb3d3862fbfa4899$var$assert.match = function match(string, regexp, message) {
    $fb3d3862fbfa4899$var$internalMatch(string, regexp, message, match, 'match');
};
$fb3d3862fbfa4899$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $fb3d3862fbfa4899$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $fb3d3862fbfa4899$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $fb3d3862fbfa4899$var$innerOk.apply(void 0, [
        $fb3d3862fbfa4899$var$strict,
        args.length
    ].concat(args));
}
$fb3d3862fbfa4899$var$assert.strict = $fb3d3862fbfa4899$var$objectAssign($fb3d3862fbfa4899$var$strict, $fb3d3862fbfa4899$var$assert, {
    equal: $fb3d3862fbfa4899$var$assert.strictEqual,
    deepEqual: $fb3d3862fbfa4899$var$assert.deepStrictEqual,
    notEqual: $fb3d3862fbfa4899$var$assert.notStrictEqual,
    notDeepEqual: $fb3d3862fbfa4899$var$assert.notDeepStrictEqual
});
$fb3d3862fbfa4899$var$assert.strict.strict = $fb3d3862fbfa4899$var$assert.strict;

});
parcelRegister("9mauO", function(module, exports) {
$parcel$export(module.exports, "codes", () => $6cfe4f662148db35$export$e45cb6485273080e, (v) => $6cfe4f662148db35$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $6cfe4f662148db35$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $6cfe4f662148db35$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6cfe4f662148db35$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6cfe4f662148db35$var$_typeof(o);
}
function $6cfe4f662148db35$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6cfe4f662148db35$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6cfe4f662148db35$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6cfe4f662148db35$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6cfe4f662148db35$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6cfe4f662148db35$var$_toPropertyKey(arg) {
    var key = $6cfe4f662148db35$var$_toPrimitive(arg, "string");
    return $6cfe4f662148db35$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6cfe4f662148db35$var$_toPrimitive(input, hint) {
    if ($6cfe4f662148db35$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6cfe4f662148db35$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6cfe4f662148db35$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6cfe4f662148db35$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6cfe4f662148db35$var$_setPrototypeOf(subClass, superClass);
}
function $6cfe4f662148db35$var$_setPrototypeOf(o, p) {
    $6cfe4f662148db35$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6cfe4f662148db35$var$_setPrototypeOf(o, p);
}
function $6cfe4f662148db35$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6cfe4f662148db35$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6cfe4f662148db35$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6cfe4f662148db35$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6cfe4f662148db35$var$_possibleConstructorReturn(this, result);
    };
}
function $6cfe4f662148db35$var$_possibleConstructorReturn(self, call) {
    if (call && ($6cfe4f662148db35$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6cfe4f662148db35$var$_assertThisInitialized(self);
}
function $6cfe4f662148db35$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6cfe4f662148db35$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6cfe4f662148db35$var$_getPrototypeOf(o) {
    $6cfe4f662148db35$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6cfe4f662148db35$var$_getPrototypeOf(o);
}
var $6cfe4f662148db35$var$codes = {};
// Lazy loaded
var $6cfe4f662148db35$var$assert;
var $6cfe4f662148db35$var$util;
function $6cfe4f662148db35$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $6cfe4f662148db35$var$_inherits(NodeError, _Base);
        var _super = $6cfe4f662148db35$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $6cfe4f662148db35$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $6cfe4f662148db35$var$_createClass(NodeError);
    }(Base);
    $6cfe4f662148db35$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $6cfe4f662148db35$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $6cfe4f662148db35$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $6cfe4f662148db35$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $6cfe4f662148db35$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$6cfe4f662148db35$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$6cfe4f662148db35$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($6cfe4f662148db35$var$assert === undefined) $6cfe4f662148db35$var$assert = (parcelRequire("lzl5a"));
    $6cfe4f662148db35$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $6cfe4f662148db35$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($6cfe4f662148db35$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($6cfe4f662148db35$var$oneOf(expected, 'type'));
    else {
        var type = $6cfe4f662148db35$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($6cfe4f662148db35$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($6cfe4f662148db35$var$_typeof(actual));
    return msg;
}, TypeError);

$6cfe4f662148db35$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($6cfe4f662148db35$var$util === undefined) $6cfe4f662148db35$var$util = (parcelRequire("3djl0"));
    var inspected = $6cfe4f662148db35$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$6cfe4f662148db35$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($6cfe4f662148db35$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$6cfe4f662148db35$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($6cfe4f662148db35$var$assert === undefined) $6cfe4f662148db35$var$assert = (parcelRequire("lzl5a"));
    $6cfe4f662148db35$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$6cfe4f662148db35$export$e45cb6485273080e = $6cfe4f662148db35$var$codes;

});
parcelRegister("3djl0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $gIMgJ = parcelRequire("gIMgJ");
var $25719614f38ee77d$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $25719614f38ee77d$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$25719614f38ee77d$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($25719614f38ee77d$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($25719614f38ee77d$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($25719614f38ee77d$var$isNull(x) || !$25719614f38ee77d$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $25719614f38ee77d$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $gIMgJ !== 'undefined' && $gIMgJ.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $gIMgJ === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($gIMgJ.throwDeprecation) throw new Error(msg);
            else if ($gIMgJ.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $25719614f38ee77d$var$debugs = {};
var $25719614f38ee77d$var$debugEnvRegex = /^$/;
var $25719614f38ee77d$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$25719614f38ee77d$var$debugs[set]) {
        if ($25719614f38ee77d$var$debugEnvRegex.test(set)) {
            var pid = $gIMgJ.pid;
            $25719614f38ee77d$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $25719614f38ee77d$var$debugs[set] = function() {};
    }
    return $25719614f38ee77d$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $25719614f38ee77d$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $25719614f38ee77d$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($25719614f38ee77d$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($25719614f38ee77d$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($25719614f38ee77d$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($25719614f38ee77d$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($25719614f38ee77d$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $25719614f38ee77d$var$stylizeWithColor;
    return $25719614f38ee77d$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $25719614f38ee77d$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$25719614f38ee77d$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$25719614f38ee77d$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $25719614f38ee77d$var$stylizeWithColor(str, styleType) {
    var style = $25719614f38ee77d$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $25719614f38ee77d$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $25719614f38ee77d$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $25719614f38ee77d$var$stylizeNoColor(str, styleType) {
    return str;
}
function $25719614f38ee77d$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $25719614f38ee77d$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $25719614f38ee77d$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$25719614f38ee77d$var$isString(ret)) ret = $25719614f38ee77d$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $25719614f38ee77d$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $25719614f38ee77d$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($25719614f38ee77d$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $25719614f38ee77d$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($25719614f38ee77d$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($25719614f38ee77d$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($25719614f38ee77d$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($25719614f38ee77d$var$isError(value)) return $25719614f38ee77d$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($25719614f38ee77d$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($25719614f38ee77d$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($25719614f38ee77d$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($25719614f38ee77d$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($25719614f38ee77d$var$isError(value)) base = ' ' + $25719614f38ee77d$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($25719614f38ee77d$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $25719614f38ee77d$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $25719614f38ee77d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $25719614f38ee77d$var$reduceToSingleString(output, base, braces);
}
function $25719614f38ee77d$var$formatPrimitive(ctx, value) {
    if ($25719614f38ee77d$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($25719614f38ee77d$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($25719614f38ee77d$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($25719614f38ee77d$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($25719614f38ee77d$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $25719614f38ee77d$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $25719614f38ee77d$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($25719614f38ee77d$var$hasOwnProperty(value, String(i))) output.push($25719614f38ee77d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($25719614f38ee77d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $25719614f38ee77d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$25719614f38ee77d$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($25719614f38ee77d$var$isNull(recurseTimes)) str = $25719614f38ee77d$var$formatValue(ctx, desc.value, null);
            else str = $25719614f38ee77d$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($25719614f38ee77d$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $25719614f38ee77d$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("4xIWm"));
function $25719614f38ee77d$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $25719614f38ee77d$var$isArray;
function $25719614f38ee77d$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $25719614f38ee77d$var$isBoolean;
function $25719614f38ee77d$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $25719614f38ee77d$var$isNull;
function $25719614f38ee77d$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $25719614f38ee77d$var$isNullOrUndefined;
function $25719614f38ee77d$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $25719614f38ee77d$var$isNumber;
function $25719614f38ee77d$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $25719614f38ee77d$var$isString;
function $25719614f38ee77d$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $25719614f38ee77d$var$isSymbol;
function $25719614f38ee77d$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $25719614f38ee77d$var$isUndefined;
function $25719614f38ee77d$var$isRegExp(re) {
    return $25719614f38ee77d$var$isObject(re) && $25719614f38ee77d$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $25719614f38ee77d$var$isRegExp;
module.exports.types.isRegExp = $25719614f38ee77d$var$isRegExp;
function $25719614f38ee77d$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $25719614f38ee77d$var$isObject;
function $25719614f38ee77d$var$isDate(d) {
    return $25719614f38ee77d$var$isObject(d) && $25719614f38ee77d$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $25719614f38ee77d$var$isDate;
module.exports.types.isDate = $25719614f38ee77d$var$isDate;
function $25719614f38ee77d$var$isError(e) {
    return $25719614f38ee77d$var$isObject(e) && ($25719614f38ee77d$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $25719614f38ee77d$var$isError;
module.exports.types.isNativeError = $25719614f38ee77d$var$isError;
function $25719614f38ee77d$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $25719614f38ee77d$var$isFunction;
function $25719614f38ee77d$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $25719614f38ee77d$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("dDWvW"));
function $25719614f38ee77d$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $25719614f38ee77d$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $25719614f38ee77d$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $25719614f38ee77d$var$timestamp() {
    var d = new Date();
    var time = [
        $25719614f38ee77d$var$pad(d.getHours()),
        $25719614f38ee77d$var$pad(d.getMinutes()),
        $25719614f38ee77d$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $25719614f38ee77d$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $25719614f38ee77d$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("cirL3"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$25719614f38ee77d$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $25719614f38ee77d$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $25719614f38ee77d$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($25719614f38ee77d$var$kCustomPromisifiedSymbol && original[$25719614f38ee77d$var$kCustomPromisifiedSymbol]) {
        var fn = original[$25719614f38ee77d$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $25719614f38ee77d$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($25719614f38ee77d$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $25719614f38ee77d$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $25719614f38ee77d$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $25719614f38ee77d$var$kCustomPromisifiedSymbol;
function $25719614f38ee77d$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $25719614f38ee77d$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $gIMgJ.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $gIMgJ.nextTick($25719614f38ee77d$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $25719614f38ee77d$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $25719614f38ee77d$var$callbackify;

});
parcelRegister("4xIWm", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $lMb5V = parcelRequire("lMb5V");

var $jEwLY = parcelRequire("jEwLY");

var $e0krh = parcelRequire("e0krh");

var $aAJ08 = parcelRequire("aAJ08");
function $34ed1ab3ba469d6c$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $34ed1ab3ba469d6c$var$BigIntSupported = typeof BigInt !== 'undefined';
var $34ed1ab3ba469d6c$var$SymbolSupported = typeof Symbol !== 'undefined';
var $34ed1ab3ba469d6c$var$ObjectToString = $34ed1ab3ba469d6c$var$uncurryThis(Object.prototype.toString);
var $34ed1ab3ba469d6c$var$numberValue = $34ed1ab3ba469d6c$var$uncurryThis(Number.prototype.valueOf);
var $34ed1ab3ba469d6c$var$stringValue = $34ed1ab3ba469d6c$var$uncurryThis(String.prototype.valueOf);
var $34ed1ab3ba469d6c$var$booleanValue = $34ed1ab3ba469d6c$var$uncurryThis(Boolean.prototype.valueOf);
if ($34ed1ab3ba469d6c$var$BigIntSupported) var $34ed1ab3ba469d6c$var$bigIntValue = $34ed1ab3ba469d6c$var$uncurryThis(BigInt.prototype.valueOf);
if ($34ed1ab3ba469d6c$var$SymbolSupported) var $34ed1ab3ba469d6c$var$symbolValue = $34ed1ab3ba469d6c$var$uncurryThis(Symbol.prototype.valueOf);
function $34ed1ab3ba469d6c$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $lMb5V;
module.exports.isGeneratorFunction = $jEwLY;
module.exports.isTypedArray = $aAJ08;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $34ed1ab3ba469d6c$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $34ed1ab3ba469d6c$var$isPromise;
function $34ed1ab3ba469d6c$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $aAJ08(value) || $34ed1ab3ba469d6c$var$isDataView(value);
}
module.exports.isArrayBufferView = $34ed1ab3ba469d6c$var$isArrayBufferView;
function $34ed1ab3ba469d6c$var$isUint8Array(value) {
    return $e0krh(value) === 'Uint8Array';
}
module.exports.isUint8Array = $34ed1ab3ba469d6c$var$isUint8Array;
function $34ed1ab3ba469d6c$var$isUint8ClampedArray(value) {
    return $e0krh(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $34ed1ab3ba469d6c$var$isUint8ClampedArray;
function $34ed1ab3ba469d6c$var$isUint16Array(value) {
    return $e0krh(value) === 'Uint16Array';
}
module.exports.isUint16Array = $34ed1ab3ba469d6c$var$isUint16Array;
function $34ed1ab3ba469d6c$var$isUint32Array(value) {
    return $e0krh(value) === 'Uint32Array';
}
module.exports.isUint32Array = $34ed1ab3ba469d6c$var$isUint32Array;
function $34ed1ab3ba469d6c$var$isInt8Array(value) {
    return $e0krh(value) === 'Int8Array';
}
module.exports.isInt8Array = $34ed1ab3ba469d6c$var$isInt8Array;
function $34ed1ab3ba469d6c$var$isInt16Array(value) {
    return $e0krh(value) === 'Int16Array';
}
module.exports.isInt16Array = $34ed1ab3ba469d6c$var$isInt16Array;
function $34ed1ab3ba469d6c$var$isInt32Array(value) {
    return $e0krh(value) === 'Int32Array';
}
module.exports.isInt32Array = $34ed1ab3ba469d6c$var$isInt32Array;
function $34ed1ab3ba469d6c$var$isFloat32Array(value) {
    return $e0krh(value) === 'Float32Array';
}
module.exports.isFloat32Array = $34ed1ab3ba469d6c$var$isFloat32Array;
function $34ed1ab3ba469d6c$var$isFloat64Array(value) {
    return $e0krh(value) === 'Float64Array';
}
module.exports.isFloat64Array = $34ed1ab3ba469d6c$var$isFloat64Array;
function $34ed1ab3ba469d6c$var$isBigInt64Array(value) {
    return $e0krh(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $34ed1ab3ba469d6c$var$isBigInt64Array;
function $34ed1ab3ba469d6c$var$isBigUint64Array(value) {
    return $e0krh(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $34ed1ab3ba469d6c$var$isBigUint64Array;
function $34ed1ab3ba469d6c$var$isMapToString(value) {
    return $34ed1ab3ba469d6c$var$ObjectToString(value) === '[object Map]';
}
$34ed1ab3ba469d6c$var$isMapToString.working = typeof Map !== 'undefined' && $34ed1ab3ba469d6c$var$isMapToString(new Map());
function $34ed1ab3ba469d6c$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $34ed1ab3ba469d6c$var$isMapToString.working ? $34ed1ab3ba469d6c$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $34ed1ab3ba469d6c$var$isMap;
function $34ed1ab3ba469d6c$var$isSetToString(value) {
    return $34ed1ab3ba469d6c$var$ObjectToString(value) === '[object Set]';
}
$34ed1ab3ba469d6c$var$isSetToString.working = typeof Set !== 'undefined' && $34ed1ab3ba469d6c$var$isSetToString(new Set());
function $34ed1ab3ba469d6c$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $34ed1ab3ba469d6c$var$isSetToString.working ? $34ed1ab3ba469d6c$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $34ed1ab3ba469d6c$var$isSet;
function $34ed1ab3ba469d6c$var$isWeakMapToString(value) {
    return $34ed1ab3ba469d6c$var$ObjectToString(value) === '[object WeakMap]';
}
$34ed1ab3ba469d6c$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $34ed1ab3ba469d6c$var$isWeakMapToString(new WeakMap());
function $34ed1ab3ba469d6c$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $34ed1ab3ba469d6c$var$isWeakMapToString.working ? $34ed1ab3ba469d6c$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $34ed1ab3ba469d6c$var$isWeakMap;
function $34ed1ab3ba469d6c$var$isWeakSetToString(value) {
    return $34ed1ab3ba469d6c$var$ObjectToString(value) === '[object WeakSet]';
}
$34ed1ab3ba469d6c$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $34ed1ab3ba469d6c$var$isWeakSetToString(new WeakSet());
function $34ed1ab3ba469d6c$var$isWeakSet(value) {
    return $34ed1ab3ba469d6c$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $34ed1ab3ba469d6c$var$isWeakSet;
function $34ed1ab3ba469d6c$var$isArrayBufferToString(value) {
    return $34ed1ab3ba469d6c$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$34ed1ab3ba469d6c$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $34ed1ab3ba469d6c$var$isArrayBufferToString(new ArrayBuffer());
function $34ed1ab3ba469d6c$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $34ed1ab3ba469d6c$var$isArrayBufferToString.working ? $34ed1ab3ba469d6c$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $34ed1ab3ba469d6c$var$isArrayBuffer;
function $34ed1ab3ba469d6c$var$isDataViewToString(value) {
    return $34ed1ab3ba469d6c$var$ObjectToString(value) === '[object DataView]';
}
$34ed1ab3ba469d6c$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $34ed1ab3ba469d6c$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $34ed1ab3ba469d6c$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $34ed1ab3ba469d6c$var$isDataViewToString.working ? $34ed1ab3ba469d6c$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $34ed1ab3ba469d6c$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $34ed1ab3ba469d6c$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $34ed1ab3ba469d6c$var$isSharedArrayBufferToString(value) {
    return $34ed1ab3ba469d6c$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $34ed1ab3ba469d6c$var$isSharedArrayBuffer(value) {
    if (typeof $34ed1ab3ba469d6c$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $34ed1ab3ba469d6c$var$isSharedArrayBufferToString.working === 'undefined') $34ed1ab3ba469d6c$var$isSharedArrayBufferToString.working = $34ed1ab3ba469d6c$var$isSharedArrayBufferToString(new $34ed1ab3ba469d6c$var$SharedArrayBufferCopy());
    return $34ed1ab3ba469d6c$var$isSharedArrayBufferToString.working ? $34ed1ab3ba469d6c$var$isSharedArrayBufferToString(value) : value instanceof $34ed1ab3ba469d6c$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $34ed1ab3ba469d6c$var$isSharedArrayBuffer;
function $34ed1ab3ba469d6c$var$isAsyncFunction(value) {
    return $34ed1ab3ba469d6c$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $34ed1ab3ba469d6c$var$isAsyncFunction;
function $34ed1ab3ba469d6c$var$isMapIterator(value) {
    return $34ed1ab3ba469d6c$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $34ed1ab3ba469d6c$var$isMapIterator;
function $34ed1ab3ba469d6c$var$isSetIterator(value) {
    return $34ed1ab3ba469d6c$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $34ed1ab3ba469d6c$var$isSetIterator;
function $34ed1ab3ba469d6c$var$isGeneratorObject(value) {
    return $34ed1ab3ba469d6c$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $34ed1ab3ba469d6c$var$isGeneratorObject;
function $34ed1ab3ba469d6c$var$isWebAssemblyCompiledModule(value) {
    return $34ed1ab3ba469d6c$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $34ed1ab3ba469d6c$var$isWebAssemblyCompiledModule;
function $34ed1ab3ba469d6c$var$isNumberObject(value) {
    return $34ed1ab3ba469d6c$var$checkBoxedPrimitive(value, $34ed1ab3ba469d6c$var$numberValue);
}
module.exports.isNumberObject = $34ed1ab3ba469d6c$var$isNumberObject;
function $34ed1ab3ba469d6c$var$isStringObject(value) {
    return $34ed1ab3ba469d6c$var$checkBoxedPrimitive(value, $34ed1ab3ba469d6c$var$stringValue);
}
module.exports.isStringObject = $34ed1ab3ba469d6c$var$isStringObject;
function $34ed1ab3ba469d6c$var$isBooleanObject(value) {
    return $34ed1ab3ba469d6c$var$checkBoxedPrimitive(value, $34ed1ab3ba469d6c$var$booleanValue);
}
module.exports.isBooleanObject = $34ed1ab3ba469d6c$var$isBooleanObject;
function $34ed1ab3ba469d6c$var$isBigIntObject(value) {
    return $34ed1ab3ba469d6c$var$BigIntSupported && $34ed1ab3ba469d6c$var$checkBoxedPrimitive(value, $34ed1ab3ba469d6c$var$bigIntValue);
}
module.exports.isBigIntObject = $34ed1ab3ba469d6c$var$isBigIntObject;
function $34ed1ab3ba469d6c$var$isSymbolObject(value) {
    return $34ed1ab3ba469d6c$var$SymbolSupported && $34ed1ab3ba469d6c$var$checkBoxedPrimitive(value, $34ed1ab3ba469d6c$var$symbolValue);
}
module.exports.isSymbolObject = $34ed1ab3ba469d6c$var$isSymbolObject;
function $34ed1ab3ba469d6c$var$isBoxedPrimitive(value) {
    return $34ed1ab3ba469d6c$var$isNumberObject(value) || $34ed1ab3ba469d6c$var$isStringObject(value) || $34ed1ab3ba469d6c$var$isBooleanObject(value) || $34ed1ab3ba469d6c$var$isBigIntObject(value) || $34ed1ab3ba469d6c$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $34ed1ab3ba469d6c$var$isBoxedPrimitive;
function $34ed1ab3ba469d6c$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($34ed1ab3ba469d6c$var$isArrayBuffer(value) || $34ed1ab3ba469d6c$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $34ed1ab3ba469d6c$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("lMb5V", function(module, exports) {
'use strict';

var $fda6afcb26a05931$var$hasToStringTag = (parcelRequire("lRZoK"))();

var $4lGI7 = parcelRequire("4lGI7");
var $fda6afcb26a05931$var$$toString = $4lGI7('Object.prototype.toString');
var $fda6afcb26a05931$var$isStandardArguments = function isArguments(value) {
    if ($fda6afcb26a05931$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $fda6afcb26a05931$var$$toString(value) === '[object Arguments]';
};
var $fda6afcb26a05931$var$isLegacyArguments = function isArguments(value) {
    if ($fda6afcb26a05931$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $fda6afcb26a05931$var$$toString(value) !== '[object Array]' && $fda6afcb26a05931$var$$toString(value.callee) === '[object Function]';
};
var $fda6afcb26a05931$var$supportsStandardArguments = function() {
    return $fda6afcb26a05931$var$isStandardArguments(arguments);
}();
$fda6afcb26a05931$var$isStandardArguments.isLegacyArguments = $fda6afcb26a05931$var$isLegacyArguments; // for tests
module.exports = $fda6afcb26a05931$var$supportsStandardArguments ? $fda6afcb26a05931$var$isStandardArguments : $fda6afcb26a05931$var$isLegacyArguments;

});
parcelRegister("lRZoK", function(module, exports) {
'use strict';

var $73hXS = parcelRequire("73hXS");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $73hXS() && !!Symbol.toStringTag;
};

});

parcelRegister("4lGI7", function(module, exports) {
'use strict';

var $jVgSm = parcelRequire("jVgSm");

var $gnafl = parcelRequire("gnafl");
var $32aa41095c3d3876$var$$indexOf = $gnafl($jVgSm('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $jVgSm(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $32aa41095c3d3876$var$$indexOf(name, '.prototype.') > -1) return $gnafl(intrinsic);
    return intrinsic;
};

});
parcelRegister("gnafl", function(module, exports) {
'use strict';

var $gTwMl = parcelRequire("gTwMl");

var $fhmL4 = parcelRequire("fhmL4");

var $2TrMG = parcelRequire("2TrMG");

var $hTnkD = parcelRequire("hTnkD");
module.exports = function callBind(originalFunction) {
    var func = $2TrMG(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $gTwMl(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($fhmL4) $fhmL4(module.exports, 'apply', {
    value: $hTnkD
});
else module.exports.apply = $hTnkD;

});
parcelRegister("gTwMl", function(module, exports) {
'use strict';

var $jVgSm = parcelRequire("jVgSm");

var $hYnE9 = parcelRequire("hYnE9");

var $c4cb3591b08b8acf$var$hasDescriptors = (parcelRequire("aoiUo"))();

var $fgwiZ = parcelRequire("fgwiZ");

var $ewY92 = parcelRequire("ewY92");
var $c4cb3591b08b8acf$var$$floor = $jVgSm('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $ewY92('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $c4cb3591b08b8acf$var$$floor(length) !== length) throw new $ewY92('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $fgwiZ) {
        var desc = $fgwiZ(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($c4cb3591b08b8acf$var$hasDescriptors) $hYnE9(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $hYnE9(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("hYnE9", function(module, exports) {
'use strict';

var $fhmL4 = parcelRequire("fhmL4");

var $6kymX = parcelRequire("6kymX");

var $ewY92 = parcelRequire("ewY92");

var $fgwiZ = parcelRequire("fgwiZ");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $ewY92('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $ewY92('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $ewY92('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $ewY92('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $ewY92('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $ewY92('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$fgwiZ && $fgwiZ(obj, property);
    if ($fhmL4) $fhmL4(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $6kymX('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("aoiUo", function(module, exports) {
'use strict';

var $fhmL4 = parcelRequire("fhmL4");
var $790ad020dee60063$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$fhmL4;
};
$790ad020dee60063$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$fhmL4) return null;
    try {
        return $fhmL4([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $790ad020dee60063$var$hasPropertyDescriptors;

});


parcelRegister("hTnkD", function(module, exports) {
'use strict';

var $aW2KH = parcelRequire("aW2KH");

var $6z6Ry = parcelRequire("6z6Ry");

var $aNcun = parcelRequire("aNcun");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $aNcun($aW2KH, $6z6Ry, arguments);
};

});




parcelRegister("jEwLY", function(module, exports) {
'use strict';
var $e4eb2cb6bc721243$var$toStr = Object.prototype.toString;
var $e4eb2cb6bc721243$var$fnToStr = Function.prototype.toString;
var $e4eb2cb6bc721243$var$isFnRegex = /^\s*(?:function)?\*/;

var $e4eb2cb6bc721243$var$hasToStringTag = (parcelRequire("lRZoK"))();
var $e4eb2cb6bc721243$var$getProto = Object.getPrototypeOf;
var $e4eb2cb6bc721243$var$getGeneratorFunc = function() {
    if (!$e4eb2cb6bc721243$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $e4eb2cb6bc721243$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($e4eb2cb6bc721243$var$isFnRegex.test($e4eb2cb6bc721243$var$fnToStr.call(fn))) return true;
    if (!$e4eb2cb6bc721243$var$hasToStringTag) {
        var str = $e4eb2cb6bc721243$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$e4eb2cb6bc721243$var$getProto) return false;
    if (typeof $e4eb2cb6bc721243$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $e4eb2cb6bc721243$var$getGeneratorFunc();
        $e4eb2cb6bc721243$var$GeneratorFunction = generatorFunc ? $e4eb2cb6bc721243$var$getProto(generatorFunc) : false;
    }
    return $e4eb2cb6bc721243$var$getProto(fn) === $e4eb2cb6bc721243$var$GeneratorFunction;
};

});

parcelRegister("e0krh", function(module, exports) {
'use strict';

var $cMOlP = parcelRequire("cMOlP");

var $85RMX = parcelRequire("85RMX");

var $gnafl = parcelRequire("gnafl");

var $5hUyV = parcelRequire("5hUyV");

var $fgwiZ = parcelRequire("fgwiZ");

var $3Y2Zp = parcelRequire("3Y2Zp");
var $a320eb89393e04c8$var$$toString = $5hUyV('Object.prototype.toString');

var $a320eb89393e04c8$var$hasToStringTag = (parcelRequire("lRZoK"))();
var $a320eb89393e04c8$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $a320eb89393e04c8$var$typedArrays = $85RMX();
var $a320eb89393e04c8$var$$slice = $5hUyV('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $a320eb89393e04c8$var$$indexOf = $5hUyV('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $a320eb89393e04c8$var$cache = {
    __proto__: null
};
if ($a320eb89393e04c8$var$hasToStringTag && $fgwiZ && $3Y2Zp) $cMOlP($a320eb89393e04c8$var$typedArrays, function(typedArray) {
    var arr = new $a320eb89393e04c8$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $3Y2Zp) {
        var proto = $3Y2Zp(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $fgwiZ(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $3Y2Zp(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $fgwiZ(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $a320eb89393e04c8$var$cache['$' + typedArray] = $gnafl(descriptor.get);
    }
});
else $cMOlP($a320eb89393e04c8$var$typedArrays, function(typedArray) {
    var arr = new $a320eb89393e04c8$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $a320eb89393e04c8$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $gnafl(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $a320eb89393e04c8$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $cMOlP(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $a320eb89393e04c8$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $a320eb89393e04c8$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $a320eb89393e04c8$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $cMOlP(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $a320eb89393e04c8$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $a320eb89393e04c8$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$a320eb89393e04c8$var$hasToStringTag) {
        /** @type {string} */ var tag = $a320eb89393e04c8$var$$slice($a320eb89393e04c8$var$$toString(value), 8, -1);
        if ($a320eb89393e04c8$var$$indexOf($a320eb89393e04c8$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $a320eb89393e04c8$var$trySlices(value);
    }
    if (!$fgwiZ) return null;
     // unknown engine
    return $a320eb89393e04c8$var$tryTypedArrays(value);
};

});
parcelRegister("cMOlP", function(module, exports) {
'use strict';

var $khfQY = parcelRequire("khfQY");
var $94f1066919a62897$var$toStr = Object.prototype.toString;
var $94f1066919a62897$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $94f1066919a62897$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($94f1066919a62897$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $94f1066919a62897$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $94f1066919a62897$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($94f1066919a62897$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $94f1066919a62897$var$isArray(x) {
    return $94f1066919a62897$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$khfQY(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($94f1066919a62897$var$isArray(list)) $94f1066919a62897$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $94f1066919a62897$var$forEachString(list, iterator, receiver);
    else $94f1066919a62897$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("khfQY", function(module, exports) {
'use strict';
var $ec31b15a4ac0aa33$var$fnToStr = Function.prototype.toString;
var $ec31b15a4ac0aa33$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $ec31b15a4ac0aa33$var$badArrayLike;
var $ec31b15a4ac0aa33$var$isCallableMarker;
if (typeof $ec31b15a4ac0aa33$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $ec31b15a4ac0aa33$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $ec31b15a4ac0aa33$var$isCallableMarker;
        }
    });
    $ec31b15a4ac0aa33$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $ec31b15a4ac0aa33$var$reflectApply(function() {
        throw 42;
    }, null, $ec31b15a4ac0aa33$var$badArrayLike);
} catch (_) {
    if (_ !== $ec31b15a4ac0aa33$var$isCallableMarker) $ec31b15a4ac0aa33$var$reflectApply = null;
}
else $ec31b15a4ac0aa33$var$reflectApply = null;
var $ec31b15a4ac0aa33$var$constructorRegex = /^\s*class\b/;
var $ec31b15a4ac0aa33$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $ec31b15a4ac0aa33$var$fnToStr.call(value);
        return $ec31b15a4ac0aa33$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $ec31b15a4ac0aa33$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($ec31b15a4ac0aa33$var$isES6ClassFn(value)) return false;
        $ec31b15a4ac0aa33$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $ec31b15a4ac0aa33$var$toStr = Object.prototype.toString;
var $ec31b15a4ac0aa33$var$objectClass = '[object Object]';
var $ec31b15a4ac0aa33$var$fnClass = '[object Function]';
var $ec31b15a4ac0aa33$var$genClass = '[object GeneratorFunction]';
var $ec31b15a4ac0aa33$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $ec31b15a4ac0aa33$var$ddaClass2 = '[object HTML document.all class]';
var $ec31b15a4ac0aa33$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $ec31b15a4ac0aa33$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $ec31b15a4ac0aa33$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $ec31b15a4ac0aa33$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $ec31b15a4ac0aa33$var$all = document.all;
    if ($ec31b15a4ac0aa33$var$toStr.call($ec31b15a4ac0aa33$var$all) === $ec31b15a4ac0aa33$var$toStr.call(document.all)) $ec31b15a4ac0aa33$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($ec31b15a4ac0aa33$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $ec31b15a4ac0aa33$var$toStr.call(value);
            return (str === $ec31b15a4ac0aa33$var$ddaClass || str === $ec31b15a4ac0aa33$var$ddaClass2 || str === $ec31b15a4ac0aa33$var$ddaClass3 // opera 12.16
             || str === $ec31b15a4ac0aa33$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $ec31b15a4ac0aa33$var$reflectApply ? function isCallable(value) {
    if ($ec31b15a4ac0aa33$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $ec31b15a4ac0aa33$var$reflectApply(value, null, $ec31b15a4ac0aa33$var$badArrayLike);
    } catch (e) {
        if (e !== $ec31b15a4ac0aa33$var$isCallableMarker) return false;
    }
    return !$ec31b15a4ac0aa33$var$isES6ClassFn(value) && $ec31b15a4ac0aa33$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($ec31b15a4ac0aa33$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($ec31b15a4ac0aa33$var$hasToStringTag) return $ec31b15a4ac0aa33$var$tryFunctionObject(value);
    if ($ec31b15a4ac0aa33$var$isES6ClassFn(value)) return false;
    var strClass = $ec31b15a4ac0aa33$var$toStr.call(value);
    if (strClass !== $ec31b15a4ac0aa33$var$fnClass && strClass !== $ec31b15a4ac0aa33$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $ec31b15a4ac0aa33$var$tryFunctionObject(value);
};

});


parcelRegister("85RMX", function(module, exports) {
'use strict';

var $k04Xf = parcelRequire("k04Xf");
var $5e4883aaafefa444$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $k04Xf.length; i++)if (typeof $5e4883aaafefa444$var$g[$k04Xf[i]] === 'function') // @ts-expect-error
    out[out.length] = $k04Xf[i];
    return out;
};

});
parcelRegister("k04Xf", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});



parcelRegister("aAJ08", function(module, exports) {
'use strict';

var $e0krh = parcelRequire("e0krh");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$e0krh(value);
};

});


parcelRegister("dDWvW", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("cirL3", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("6Ppb0", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $gIMgJ = parcelRequire("gIMgJ");
'use strict';
function $4f8b0909e1df0a8c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4f8b0909e1df0a8c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4f8b0909e1df0a8c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4f8b0909e1df0a8c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4f8b0909e1df0a8c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4f8b0909e1df0a8c$var$_defineProperty(obj, key, value) {
    key = $4f8b0909e1df0a8c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4f8b0909e1df0a8c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4f8b0909e1df0a8c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4f8b0909e1df0a8c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4f8b0909e1df0a8c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4f8b0909e1df0a8c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4f8b0909e1df0a8c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4f8b0909e1df0a8c$var$_toPropertyKey(arg) {
    var key = $4f8b0909e1df0a8c$var$_toPrimitive(arg, "string");
    return $4f8b0909e1df0a8c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4f8b0909e1df0a8c$var$_toPrimitive(input, hint) {
    if ($4f8b0909e1df0a8c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4f8b0909e1df0a8c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $4f8b0909e1df0a8c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $4f8b0909e1df0a8c$var$_setPrototypeOf(subClass, superClass);
}
function $4f8b0909e1df0a8c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4f8b0909e1df0a8c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $4f8b0909e1df0a8c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $4f8b0909e1df0a8c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4f8b0909e1df0a8c$var$_possibleConstructorReturn(this, result);
    };
}
function $4f8b0909e1df0a8c$var$_possibleConstructorReturn(self, call) {
    if (call && ($4f8b0909e1df0a8c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4f8b0909e1df0a8c$var$_assertThisInitialized(self);
}
function $4f8b0909e1df0a8c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4f8b0909e1df0a8c$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $4f8b0909e1df0a8c$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$4f8b0909e1df0a8c$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $4f8b0909e1df0a8c$var$_construct(Class, arguments, $4f8b0909e1df0a8c$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $4f8b0909e1df0a8c$var$_setPrototypeOf(Wrapper, Class);
    };
    return $4f8b0909e1df0a8c$var$_wrapNativeSuper(Class);
}
function $4f8b0909e1df0a8c$var$_construct(Parent, args, Class) {
    if ($4f8b0909e1df0a8c$var$_isNativeReflectConstruct()) $4f8b0909e1df0a8c$var$_construct = Reflect.construct.bind();
    else $4f8b0909e1df0a8c$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $4f8b0909e1df0a8c$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $4f8b0909e1df0a8c$var$_construct.apply(null, arguments);
}
function $4f8b0909e1df0a8c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4f8b0909e1df0a8c$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $4f8b0909e1df0a8c$var$_setPrototypeOf(o, p) {
    $4f8b0909e1df0a8c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4f8b0909e1df0a8c$var$_setPrototypeOf(o, p);
}
function $4f8b0909e1df0a8c$var$_getPrototypeOf(o) {
    $4f8b0909e1df0a8c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4f8b0909e1df0a8c$var$_getPrototypeOf(o);
}
function $4f8b0909e1df0a8c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4f8b0909e1df0a8c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4f8b0909e1df0a8c$var$_typeof(o);
}

var $3djl0 = parcelRequire("3djl0");
var $4f8b0909e1df0a8c$var$inspect = $3djl0.inspect;

var $9mauO = parcelRequire("9mauO");
var $4f8b0909e1df0a8c$var$ERR_INVALID_ARG_TYPE = $9mauO.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $4f8b0909e1df0a8c$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $4f8b0909e1df0a8c$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $4f8b0909e1df0a8c$var$blue = '';
var $4f8b0909e1df0a8c$var$green = '';
var $4f8b0909e1df0a8c$var$red = '';
var $4f8b0909e1df0a8c$var$white = '';
var $4f8b0909e1df0a8c$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $4f8b0909e1df0a8c$var$kMaxShortLength = 10;
function $4f8b0909e1df0a8c$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $4f8b0909e1df0a8c$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $4f8b0909e1df0a8c$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $4f8b0909e1df0a8c$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $4f8b0909e1df0a8c$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $4f8b0909e1df0a8c$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $4f8b0909e1df0a8c$var$_typeof(actual) === 'object' && $4f8b0909e1df0a8c$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $4f8b0909e1df0a8c$var$kMaxShortLength) {
            if (($4f8b0909e1df0a8c$var$_typeof(actual) !== 'object' || actual === null) && ($4f8b0909e1df0a8c$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($4f8b0909e1df0a8c$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $gIMgJ.stderr && $gIMgJ.stderr.isTTY ? $gIMgJ.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($4f8b0909e1df0a8c$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($4f8b0909e1df0a8c$var$blue, "...").concat($4f8b0909e1df0a8c$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($4f8b0909e1df0a8c$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($4f8b0909e1df0a8c$var$blue, "...").concat($4f8b0909e1df0a8c$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $4f8b0909e1df0a8c$var$kReadableOperator[operator] + "\n".concat($4f8b0909e1df0a8c$var$green, "+ actual").concat($4f8b0909e1df0a8c$var$white, " ").concat($4f8b0909e1df0a8c$var$red, "- expected").concat($4f8b0909e1df0a8c$var$white);
    var skippedMsg = " ".concat($4f8b0909e1df0a8c$var$blue, "...").concat($4f8b0909e1df0a8c$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($4f8b0909e1df0a8c$var$blue, "...").concat($4f8b0909e1df0a8c$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($4f8b0909e1df0a8c$var$red, "-").concat($4f8b0909e1df0a8c$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($4f8b0909e1df0a8c$var$blue, "...").concat($4f8b0909e1df0a8c$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($4f8b0909e1df0a8c$var$green, "+").concat($4f8b0909e1df0a8c$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$4f8b0909e1df0a8c$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $4f8b0909e1df0a8c$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($4f8b0909e1df0a8c$var$blue, "...").concat($4f8b0909e1df0a8c$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($4f8b0909e1df0a8c$var$green, "+").concat($4f8b0909e1df0a8c$var$white, " ").concat(actualLine);
                other += "\n".concat($4f8b0909e1df0a8c$var$red, "-").concat($4f8b0909e1df0a8c$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($4f8b0909e1df0a8c$var$blue, "...").concat($4f8b0909e1df0a8c$var$white).concat(other, "\n") + "".concat($4f8b0909e1df0a8c$var$blue, "...").concat($4f8b0909e1df0a8c$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $4f8b0909e1df0a8c$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $4f8b0909e1df0a8c$var$_inherits(AssertionError, _Error);
    var _super = $4f8b0909e1df0a8c$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $4f8b0909e1df0a8c$var$_classCallCheck(this, AssertionError);
        if ($4f8b0909e1df0a8c$var$_typeof(options) !== 'object' || options === null) throw new $4f8b0909e1df0a8c$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($gIMgJ.stderr && $gIMgJ.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($gIMgJ.stderr && $gIMgJ.stderr.getColorDepth && $gIMgJ.stderr.getColorDepth() !== 1) {
                    $4f8b0909e1df0a8c$var$blue = "\x1B[34m";
                    $4f8b0909e1df0a8c$var$green = "\x1B[32m";
                    $4f8b0909e1df0a8c$var$white = "\x1B[39m";
                    $4f8b0909e1df0a8c$var$red = "\x1B[31m";
                } else {
                    $4f8b0909e1df0a8c$var$blue = '';
                    $4f8b0909e1df0a8c$var$green = '';
                    $4f8b0909e1df0a8c$var$white = '';
                    $4f8b0909e1df0a8c$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($4f8b0909e1df0a8c$var$_typeof(actual) === 'object' && actual !== null && $4f8b0909e1df0a8c$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $4f8b0909e1df0a8c$var$copyError(actual);
                expected = $4f8b0909e1df0a8c$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $4f8b0909e1df0a8c$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $4f8b0909e1df0a8c$var$kReadableOperator[operator];
                var res = $4f8b0909e1df0a8c$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $4f8b0909e1df0a8c$var$_typeof(actual) === 'object' && actual !== null) base = $4f8b0909e1df0a8c$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($4f8b0909e1df0a8c$var$blue, "...").concat($4f8b0909e1df0a8c$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $4f8b0909e1df0a8c$var$inspectValue(actual);
                var other = '';
                var knownOperators = $4f8b0909e1df0a8c$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($4f8b0909e1df0a8c$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($4f8b0909e1df0a8c$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($4f8b0909e1df0a8c$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($4f8b0909e1df0a8c$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $4f8b0909e1df0a8c$var$_possibleConstructorReturn(_this);
    }
    $4f8b0909e1df0a8c$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $4f8b0909e1df0a8c$var$inspect(this, $4f8b0909e1df0a8c$var$_objectSpread($4f8b0909e1df0a8c$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $4f8b0909e1df0a8c$var$_wrapNativeSuper(Error), $4f8b0909e1df0a8c$var$inspect.custom);
module.exports = $4f8b0909e1df0a8c$var$AssertionError;

});

parcelRegister("57lgS", function(module, exports) {
'use strict';

var $kpj0O = parcelRequire("kpj0O");
var $3b9e1b3a299bf892$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $3b9e1b3a299bf892$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $kpj0O;
    if ($3b9e1b3a299bf892$var$lacksProperEnumerationOrder()) return $kpj0O;
    if ($3b9e1b3a299bf892$var$assignHasPendingExceptions()) return $kpj0O;
    return Object.assign;
};

});
parcelRegister("kpj0O", function(module, exports) {
'use strict';

var $9anit = parcelRequire("9anit");

var $edb4e3d7a5f57e12$var$hasSymbols = (parcelRequire("73hXS"))();

var $5hUyV = parcelRequire("5hUyV");

var $ZSQvF = parcelRequire("ZSQvF");
var $edb4e3d7a5f57e12$var$$push = $5hUyV('Array.prototype.push');
var $edb4e3d7a5f57e12$var$$propIsEnumerable = $5hUyV('Object.prototype.propertyIsEnumerable');
var $edb4e3d7a5f57e12$var$originalGetSymbols = $edb4e3d7a5f57e12$var$hasSymbols ? $ZSQvF.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $ZSQvF(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $ZSQvF(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $9anit(from);
        var getSymbols = $edb4e3d7a5f57e12$var$hasSymbols && ($ZSQvF.getOwnPropertySymbols || $edb4e3d7a5f57e12$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($edb4e3d7a5f57e12$var$$propIsEnumerable(from, key)) $edb4e3d7a5f57e12$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($edb4e3d7a5f57e12$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("9anit", function(module, exports) {
'use strict';
var $6ac71e8115d42ee3$var$slice = Array.prototype.slice;

var $hqHUC = parcelRequire("hqHUC");
var $6ac71e8115d42ee3$var$origKeys = Object.keys;

var $6ac71e8115d42ee3$var$keysShim = $6ac71e8115d42ee3$var$origKeys ? function keys(o) {
    return $6ac71e8115d42ee3$var$origKeys(o);
} : (parcelRequire("789aZ"));
var $6ac71e8115d42ee3$var$originalKeys = Object.keys;
$6ac71e8115d42ee3$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($hqHUC(object)) return $6ac71e8115d42ee3$var$originalKeys($6ac71e8115d42ee3$var$slice.call(object));
            return $6ac71e8115d42ee3$var$originalKeys(object);
        };
    } else Object.keys = $6ac71e8115d42ee3$var$keysShim;
    return Object.keys || $6ac71e8115d42ee3$var$keysShim;
};
module.exports = $6ac71e8115d42ee3$var$keysShim;

});
parcelRegister("hqHUC", function(module, exports) {
'use strict';
var $cb06ed6a6da70830$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $cb06ed6a6da70830$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $cb06ed6a6da70830$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("789aZ", function(module, exports) {
'use strict';
var $531065fa574edbf1$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $531065fa574edbf1$var$has = Object.prototype.hasOwnProperty;
    var $531065fa574edbf1$var$toStr = Object.prototype.toString;
    var $531065fa574edbf1$var$isArgs = (parcelRequire("hqHUC")); // eslint-disable-line global-require
    var $531065fa574edbf1$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $531065fa574edbf1$var$hasDontEnumBug = !$531065fa574edbf1$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $531065fa574edbf1$var$hasProtoEnumBug = $531065fa574edbf1$var$isEnumerable.call(function() {}, 'prototype');
    var $531065fa574edbf1$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $531065fa574edbf1$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $531065fa574edbf1$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $531065fa574edbf1$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$531065fa574edbf1$var$excludedKeys['$' + k] && $531065fa574edbf1$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $531065fa574edbf1$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $531065fa574edbf1$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$531065fa574edbf1$var$hasAutomationEqualityBug) return $531065fa574edbf1$var$equalsConstructorPrototype(o);
        try {
            return $531065fa574edbf1$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $531065fa574edbf1$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $531065fa574edbf1$var$toStr.call(object) === '[object Function]';
        var isArguments = $531065fa574edbf1$var$isArgs(object);
        var isString = isObject && $531065fa574edbf1$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $531065fa574edbf1$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$531065fa574edbf1$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $531065fa574edbf1$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($531065fa574edbf1$var$hasDontEnumBug) {
            var skipConstructor = $531065fa574edbf1$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $531065fa574edbf1$var$dontEnums.length; ++k)if (!(skipConstructor && $531065fa574edbf1$var$dontEnums[k] === 'constructor') && $531065fa574edbf1$var$has.call(object, $531065fa574edbf1$var$dontEnums[k])) theKeys.push($531065fa574edbf1$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $531065fa574edbf1$var$keysShim;

});




parcelRegister("eVVx0", function(module, exports) {
'use strict';

var $6RrOA = parcelRequire("6RrOA");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $6RrOA;
};

});
parcelRegister("6RrOA", function(module, exports) {
'use strict';
var $4fed44c65e0eb073$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($4fed44c65e0eb073$var$numberIsNaN(a) && $4fed44c65e0eb073$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("jOMIF", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $e6d87a7c690a1ef3$var$_slicedToArray(arr, i) {
    return $e6d87a7c690a1ef3$var$_arrayWithHoles(arr) || $e6d87a7c690a1ef3$var$_iterableToArrayLimit(arr, i) || $e6d87a7c690a1ef3$var$_unsupportedIterableToArray(arr, i) || $e6d87a7c690a1ef3$var$_nonIterableRest();
}
function $e6d87a7c690a1ef3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e6d87a7c690a1ef3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e6d87a7c690a1ef3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e6d87a7c690a1ef3$var$_arrayLikeToArray(o, minLen);
}
function $e6d87a7c690a1ef3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e6d87a7c690a1ef3$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e6d87a7c690a1ef3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e6d87a7c690a1ef3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e6d87a7c690a1ef3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e6d87a7c690a1ef3$var$_typeof(o);
}
var $e6d87a7c690a1ef3$var$regexFlagsSupported = /a/g.flags !== undefined;
var $e6d87a7c690a1ef3$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $e6d87a7c690a1ef3$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $e6d87a7c690a1ef3$var$objectIs = Object.is ? Object.is : (parcelRequire("BjUAs"));
var $e6d87a7c690a1ef3$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $e6d87a7c690a1ef3$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("1zFdm"));
function $e6d87a7c690a1ef3$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $e6d87a7c690a1ef3$var$hasOwnProperty = $e6d87a7c690a1ef3$var$uncurryThis(Object.prototype.hasOwnProperty);
var $e6d87a7c690a1ef3$var$propertyIsEnumerable = $e6d87a7c690a1ef3$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $e6d87a7c690a1ef3$var$objectToString = $e6d87a7c690a1ef3$var$uncurryThis(Object.prototype.toString);

var $3djl0 = parcelRequire("3djl0");
var $e6d87a7c690a1ef3$require$_require$types = $3djl0.types;
var $e6d87a7c690a1ef3$var$isAnyArrayBuffer = $e6d87a7c690a1ef3$require$_require$types.isAnyArrayBuffer, $e6d87a7c690a1ef3$var$isArrayBufferView = $e6d87a7c690a1ef3$require$_require$types.isArrayBufferView, $e6d87a7c690a1ef3$var$isDate = $e6d87a7c690a1ef3$require$_require$types.isDate, $e6d87a7c690a1ef3$var$isMap = $e6d87a7c690a1ef3$require$_require$types.isMap, $e6d87a7c690a1ef3$var$isRegExp = $e6d87a7c690a1ef3$require$_require$types.isRegExp, $e6d87a7c690a1ef3$var$isSet = $e6d87a7c690a1ef3$require$_require$types.isSet, $e6d87a7c690a1ef3$var$isNativeError = $e6d87a7c690a1ef3$require$_require$types.isNativeError, $e6d87a7c690a1ef3$var$isBoxedPrimitive = $e6d87a7c690a1ef3$require$_require$types.isBoxedPrimitive, $e6d87a7c690a1ef3$var$isNumberObject = $e6d87a7c690a1ef3$require$_require$types.isNumberObject, $e6d87a7c690a1ef3$var$isStringObject = $e6d87a7c690a1ef3$require$_require$types.isStringObject, $e6d87a7c690a1ef3$var$isBooleanObject = $e6d87a7c690a1ef3$require$_require$types.isBooleanObject, $e6d87a7c690a1ef3$var$isBigIntObject = $e6d87a7c690a1ef3$require$_require$types.isBigIntObject, $e6d87a7c690a1ef3$var$isSymbolObject = $e6d87a7c690a1ef3$require$_require$types.isSymbolObject, $e6d87a7c690a1ef3$var$isFloat32Array = $e6d87a7c690a1ef3$require$_require$types.isFloat32Array, $e6d87a7c690a1ef3$var$isFloat64Array = $e6d87a7c690a1ef3$require$_require$types.isFloat64Array;
function $e6d87a7c690a1ef3$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $e6d87a7c690a1ef3$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($e6d87a7c690a1ef3$var$isNonIndex).concat($e6d87a7c690a1ef3$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $e6d87a7c690a1ef3$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $e6d87a7c690a1ef3$var$ONLY_ENUMERABLE = undefined;
var $e6d87a7c690a1ef3$var$kStrict = true;
var $e6d87a7c690a1ef3$var$kLoose = false;
var $e6d87a7c690a1ef3$var$kNoIterator = 0;
var $e6d87a7c690a1ef3$var$kIsArray = 1;
var $e6d87a7c690a1ef3$var$kIsSet = 2;
var $e6d87a7c690a1ef3$var$kIsMap = 3;
// Check if they have the same source and flags
function $e6d87a7c690a1ef3$var$areSimilarRegExps(a, b) {
    return $e6d87a7c690a1ef3$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $e6d87a7c690a1ef3$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $e6d87a7c690a1ef3$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $e6d87a7c690a1ef3$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $e6d87a7c690a1ef3$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $e6d87a7c690a1ef3$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $e6d87a7c690a1ef3$var$isEqualBoxedPrimitive(val1, val2) {
    if ($e6d87a7c690a1ef3$var$isNumberObject(val1)) return $e6d87a7c690a1ef3$var$isNumberObject(val2) && $e6d87a7c690a1ef3$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($e6d87a7c690a1ef3$var$isStringObject(val1)) return $e6d87a7c690a1ef3$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($e6d87a7c690a1ef3$var$isBooleanObject(val1)) return $e6d87a7c690a1ef3$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($e6d87a7c690a1ef3$var$isBigIntObject(val1)) return $e6d87a7c690a1ef3$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $e6d87a7c690a1ef3$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $e6d87a7c690a1ef3$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $e6d87a7c690a1ef3$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($e6d87a7c690a1ef3$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $e6d87a7c690a1ef3$var$numberIsNaN(val1) && $e6d87a7c690a1ef3$var$numberIsNaN(val2);
        if ($e6d87a7c690a1ef3$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $e6d87a7c690a1ef3$var$_typeof(val1) !== 'object') {
            if (val2 === null || $e6d87a7c690a1ef3$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $e6d87a7c690a1ef3$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $e6d87a7c690a1ef3$var$objectToString(val1);
    var val2Tag = $e6d87a7c690a1ef3$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $e6d87a7c690a1ef3$var$getOwnNonIndexProperties(val1, $e6d87a7c690a1ef3$var$ONLY_ENUMERABLE);
        var keys2 = $e6d87a7c690a1ef3$var$getOwnNonIndexProperties(val2, $e6d87a7c690a1ef3$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $e6d87a7c690a1ef3$var$keyCheck(val1, val2, strict, memos, $e6d87a7c690a1ef3$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$e6d87a7c690a1ef3$var$isMap(val1) && $e6d87a7c690a1ef3$var$isMap(val2) || !$e6d87a7c690a1ef3$var$isSet(val1) && $e6d87a7c690a1ef3$var$isSet(val2)) return false;
    }
    if ($e6d87a7c690a1ef3$var$isDate(val1)) {
        if (!$e6d87a7c690a1ef3$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($e6d87a7c690a1ef3$var$isRegExp(val1)) {
        if (!$e6d87a7c690a1ef3$var$isRegExp(val2) || !$e6d87a7c690a1ef3$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($e6d87a7c690a1ef3$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($e6d87a7c690a1ef3$var$isArrayBufferView(val1)) {
        if (!strict && ($e6d87a7c690a1ef3$var$isFloat32Array(val1) || $e6d87a7c690a1ef3$var$isFloat64Array(val1))) {
            if (!$e6d87a7c690a1ef3$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$e6d87a7c690a1ef3$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $e6d87a7c690a1ef3$var$getOwnNonIndexProperties(val1, $e6d87a7c690a1ef3$var$ONLY_ENUMERABLE);
        var _keys2 = $e6d87a7c690a1ef3$var$getOwnNonIndexProperties(val2, $e6d87a7c690a1ef3$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $e6d87a7c690a1ef3$var$keyCheck(val1, val2, strict, memos, $e6d87a7c690a1ef3$var$kNoIterator, _keys);
    } else if ($e6d87a7c690a1ef3$var$isSet(val1)) {
        if (!$e6d87a7c690a1ef3$var$isSet(val2) || val1.size !== val2.size) return false;
        return $e6d87a7c690a1ef3$var$keyCheck(val1, val2, strict, memos, $e6d87a7c690a1ef3$var$kIsSet);
    } else if ($e6d87a7c690a1ef3$var$isMap(val1)) {
        if (!$e6d87a7c690a1ef3$var$isMap(val2) || val1.size !== val2.size) return false;
        return $e6d87a7c690a1ef3$var$keyCheck(val1, val2, strict, memos, $e6d87a7c690a1ef3$var$kIsMap);
    } else if ($e6d87a7c690a1ef3$var$isAnyArrayBuffer(val1)) {
        if (!$e6d87a7c690a1ef3$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($e6d87a7c690a1ef3$var$isBoxedPrimitive(val1) && !$e6d87a7c690a1ef3$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $e6d87a7c690a1ef3$var$keyCheck(val1, val2, strict, memos, $e6d87a7c690a1ef3$var$kNoIterator);
}
function $e6d87a7c690a1ef3$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $e6d87a7c690a1ef3$var$propertyIsEnumerable(val, k);
    });
}
function $e6d87a7c690a1ef3$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$e6d87a7c690a1ef3$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $e6d87a7c690a1ef3$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($e6d87a7c690a1ef3$var$propertyIsEnumerable(val1, key)) {
                    if (!$e6d87a7c690a1ef3$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($e6d87a7c690a1ef3$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $e6d87a7c690a1ef3$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $e6d87a7c690a1ef3$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $e6d87a7c690a1ef3$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $e6d87a7c690a1ef3$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $e6d87a7c690a1ef3$var$kNoIterator || iterationType === $e6d87a7c690a1ef3$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $e6d87a7c690a1ef3$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $e6d87a7c690a1ef3$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $e6d87a7c690a1ef3$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($e6d87a7c690a1ef3$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $e6d87a7c690a1ef3$var$findLooseMatchingPrimitives(prim) {
    switch($e6d87a7c690a1ef3$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($e6d87a7c690a1ef3$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $e6d87a7c690a1ef3$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $e6d87a7c690a1ef3$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $e6d87a7c690a1ef3$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $e6d87a7c690a1ef3$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$e6d87a7c690a1ef3$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $e6d87a7c690a1ef3$var$innerDeepEqual(item, curB, false, memo);
}
function $e6d87a7c690a1ef3$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $e6d87a7c690a1ef3$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($e6d87a7c690a1ef3$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$e6d87a7c690a1ef3$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $e6d87a7c690a1ef3$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($e6d87a7c690a1ef3$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$e6d87a7c690a1ef3$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$e6d87a7c690a1ef3$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $e6d87a7c690a1ef3$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $e6d87a7c690a1ef3$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($e6d87a7c690a1ef3$var$innerDeepEqual(key1, key2, strict, memo) && $e6d87a7c690a1ef3$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $e6d87a7c690a1ef3$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $e6d87a7c690a1ef3$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $e6d87a7c690a1ef3$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($e6d87a7c690a1ef3$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$e6d87a7c690a1ef3$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$e6d87a7c690a1ef3$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $e6d87a7c690a1ef3$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $e6d87a7c690a1ef3$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($e6d87a7c690a1ef3$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$e6d87a7c690a1ef3$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$e6d87a7c690a1ef3$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$e6d87a7c690a1ef3$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $e6d87a7c690a1ef3$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $e6d87a7c690a1ef3$var$kIsSet) {
        if (!$e6d87a7c690a1ef3$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $e6d87a7c690a1ef3$var$kIsMap) {
        if (!$e6d87a7c690a1ef3$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $e6d87a7c690a1ef3$var$kIsArray) for(; i < a.length; i++){
        if ($e6d87a7c690a1ef3$var$hasOwnProperty(a, i)) {
            if (!$e6d87a7c690a1ef3$var$hasOwnProperty(b, i) || !$e6d87a7c690a1ef3$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($e6d87a7c690a1ef3$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$e6d87a7c690a1ef3$var$hasOwnProperty(b, key) || !$e6d87a7c690a1ef3$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$e6d87a7c690a1ef3$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $e6d87a7c690a1ef3$var$isDeepEqual(val1, val2) {
    return $e6d87a7c690a1ef3$var$innerDeepEqual(val1, val2, $e6d87a7c690a1ef3$var$kLoose);
}
function $e6d87a7c690a1ef3$var$isDeepStrictEqual(val1, val2) {
    return $e6d87a7c690a1ef3$var$innerDeepEqual(val1, val2, $e6d87a7c690a1ef3$var$kStrict);
}
module.exports = {
    isDeepEqual: $e6d87a7c690a1ef3$var$isDeepEqual,
    isDeepStrictEqual: $e6d87a7c690a1ef3$var$isDeepStrictEqual
};

});
parcelRegister("BjUAs", function(module, exports) {
'use strict';

var $5xyn6 = parcelRequire("5xyn6");

var $gnafl = parcelRequire("gnafl");

var $6RrOA = parcelRequire("6RrOA");

var $eVVx0 = parcelRequire("eVVx0");

var $5GhWy = parcelRequire("5GhWy");
var $0702e6dd2c05f024$var$polyfill = $gnafl($eVVx0(), Object);
$5xyn6($0702e6dd2c05f024$var$polyfill, {
    getPolyfill: $eVVx0,
    implementation: $6RrOA,
    shim: $5GhWy
});
module.exports = $0702e6dd2c05f024$var$polyfill;

});
parcelRegister("5xyn6", function(module, exports) {
'use strict';

var $9anit = parcelRequire("9anit");
var $408ab249f105baf7$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $408ab249f105baf7$var$toStr = Object.prototype.toString;
var $408ab249f105baf7$var$concat = Array.prototype.concat;

var $hYnE9 = parcelRequire("hYnE9");
var $408ab249f105baf7$var$isFunction = function(fn) {
    return typeof fn === 'function' && $408ab249f105baf7$var$toStr.call(fn) === '[object Function]';
};

var $408ab249f105baf7$var$supportsDescriptors = (parcelRequire("aoiUo"))();
var $408ab249f105baf7$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$408ab249f105baf7$var$isFunction(predicate) || !predicate()) return;
    }
    if ($408ab249f105baf7$var$supportsDescriptors) $hYnE9(object, name, value, true);
    else $hYnE9(object, name, value);
};
var $408ab249f105baf7$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $9anit(map);
    if ($408ab249f105baf7$var$hasSymbols) props = $408ab249f105baf7$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$408ab249f105baf7$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$408ab249f105baf7$var$defineProperties.supportsDescriptors = !!$408ab249f105baf7$var$supportsDescriptors;
module.exports = $408ab249f105baf7$var$defineProperties;

});

parcelRegister("5GhWy", function(module, exports) {
'use strict';

var $eVVx0 = parcelRequire("eVVx0");

var $5xyn6 = parcelRequire("5xyn6");
module.exports = function shimObjectIs() {
    var polyfill = $eVVx0();
    $5xyn6(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("1zFdm", function(module, exports) {
'use strict';

var $gnafl = parcelRequire("gnafl");

var $5xyn6 = parcelRequire("5xyn6");

var $dz1nP = parcelRequire("dz1nP");

var $gz2AB = parcelRequire("gz2AB");

var $f05D0 = parcelRequire("f05D0");
var $125907ae926a71d1$var$polyfill = $gnafl($gz2AB(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $5xyn6($125907ae926a71d1$var$polyfill, {
    getPolyfill: $gz2AB,
    implementation: $dz1nP,
    shim: $f05D0
});
module.exports = $125907ae926a71d1$var$polyfill;

});
parcelRegister("dz1nP", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("gz2AB", function(module, exports) {
'use strict';

var $dz1nP = parcelRequire("dz1nP");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $dz1nP;
};

});

parcelRegister("f05D0", function(module, exports) {
'use strict';

var $5xyn6 = parcelRequire("5xyn6");

var $gz2AB = parcelRequire("gz2AB");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $gz2AB();
    $5xyn6(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("60gAE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SuppressWarnings = module.exports.Override = module.exports.Nullable = module.exports.NotNull = void 0;
function $45ef9c998315d604$var$NotNull(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.NotNull = $45ef9c998315d604$var$NotNull;
function $45ef9c998315d604$var$Nullable(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.Nullable = $45ef9c998315d604$var$Nullable;
function $45ef9c998315d604$var$Override(target, propertyKey, propertyDescriptor) {
// do something with 'target' ...
}
module.exports.Override = $45ef9c998315d604$var$Override;
function $45ef9c998315d604$var$SuppressWarnings(options) {
    return (target, propertyKey, descriptor)=>{
    // intentionally empty
    };
}
module.exports.SuppressWarnings = $45ef9c998315d604$var$SuppressWarnings;

});

parcelRegister("hPLPA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntStream = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.6934376-07:00
var $cfbc4d552b96f185$var$IntStream;
(function(IntStream) {
    /**
     * The value returned by {@link #LA LA()} when the end of the stream is
     * reached.
     */ IntStream.EOF = -1;
    /**
     * The value returned by {@link #getSourceName} when the actual name of the
     * underlying source is not known.
     */ IntStream.UNKNOWN_SOURCE_NAME = "<unknown>";
})($cfbc4d552b96f185$var$IntStream = module.exports.IntStream || (module.exports.IntStream = {}));

});


parcelRegister("8X739", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $68494d5f647d1c50$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BailErrorStrategy = void 0;

var $8PzbJ = parcelRequire("8PzbJ");

var $2ITdp = parcelRequire("2ITdp");

var $60gAE = parcelRequire("60gAE");

var $13JKH = parcelRequire("13JKH");
/**
 * This implementation of {@link ANTLRErrorStrategy} responds to syntax errors
 * by immediately canceling the parse operation with a
 * {@link ParseCancellationException}. The implementation ensures that the
 * {@link ParserRuleContext#exception} field is set for all parse tree nodes
 * that were not completed prior to encountering the error.
 *
 * This error strategy is useful in the following scenarios.
 *
 * * **Two-stage parsing:** This error strategy allows the first
 *   stage of two-stage parsing to immediately terminate if an error is
 *   encountered, and immediately fall back to the second stage. In addition to
 *   avoiding wasted work by attempting to recover from errors here, the empty
 *   implementation of {@link BailErrorStrategy#sync} improves the performance of
 *   the first stage.
 * * **Silent validation:** When syntax errors are not being
 *   reported or logged, and the parse result is simply ignored if errors occur,
 *   the {@link BailErrorStrategy} avoids wasting work on recovering from errors
 *   when the result will be ignored either way.
 *
 * ```
 * myparser.errorHandler = new BailErrorStrategy();
 * ```
 *
 * @see Parser.errorHandler
 */ class $68494d5f647d1c50$var$BailErrorStrategy extends $8PzbJ.DefaultErrorStrategy {
    /** Instead of recovering from exception `e`, re-throw it wrapped
     *  in a {@link ParseCancellationException} so it is not caught by the
     *  rule function catches.  Use {@link Exception#getCause()} to get the
     *  original {@link RecognitionException}.
     */ recover(recognizer, e) {
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $13JKH.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover inline; if the parser
     *  successfully recovers, it won't throw an exception.
     */ recoverInline(recognizer) {
        let e = new $2ITdp.InputMismatchException(recognizer);
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $13JKH.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover from problems in subrules. */ sync(recognizer) {
    // intentionally empty
    }
}
$68494d5f647d1c50$var$__decorate([
    $60gAE.Override
], $68494d5f647d1c50$var$BailErrorStrategy.prototype, "recover", null);
$68494d5f647d1c50$var$__decorate([
    $60gAE.Override
], $68494d5f647d1c50$var$BailErrorStrategy.prototype, "recoverInline", null);
$68494d5f647d1c50$var$__decorate([
    $60gAE.Override
], $68494d5f647d1c50$var$BailErrorStrategy.prototype, "sync", null);
module.exports.BailErrorStrategy = $68494d5f647d1c50$var$BailErrorStrategy;

});
parcelRegister("8PzbJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $66de61c79a6a181a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $66de61c79a6a181a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultErrorStrategy = void 0;

var $gh8QV = parcelRequire("gh8QV");

var $4txXj = parcelRequire("4txXj");

var $aaCqm = parcelRequire("aaCqm");

var $2ITdp = parcelRequire("2ITdp");

var $fkZzb = parcelRequire("fkZzb");

var $1O6nA = parcelRequire("1O6nA");

var $gT9VD = parcelRequire("gT9VD");

var $iLVZN = parcelRequire("iLVZN");

var $60gAE = parcelRequire("60gAE");
/**
 * This is the default implementation of {@link ANTLRErrorStrategy} used for
 * error reporting and recovery in ANTLR parsers.
 */ class $66de61c79a6a181a$var$DefaultErrorStrategy {
    constructor(){
        /**
         * Indicates whether the error strategy is currently "recovering from an
         * error". This is used to suppress reporting multiple error messages while
         * attempting to recover from a detected syntax error.
         *
         * @see #inErrorRecoveryMode
         */ this.errorRecoveryMode = false;
        /** The index into the input stream where the last error occurred.
         * 	This is used to prevent infinite loops where an error is found
         *  but no token is consumed during recovery...another error is found,
         *  ad nauseum.  This is a failsafe mechanism to guarantee that at least
         *  one token/tree node is consumed for two errors.
         */ this.lastErrorIndex = -1;
        /**
         * @see #nextTokensContext
         */ this.nextTokensState = $gh8QV.ATNState.INVALID_STATE_NUMBER;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition} to
     * ensure that the handler is not in error recovery mode.
     */ reset(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * This method is called to enter error recovery mode when a recognition
     * exception is reported.
     *
     * @param recognizer the parser instance
     */ beginErrorCondition(recognizer) {
        this.errorRecoveryMode = true;
    }
    /**
     * {@inheritDoc}
     */ inErrorRecoveryMode(recognizer) {
        return this.errorRecoveryMode;
    }
    /**
     * This method is called to leave error recovery mode after recovering from
     * a recognition exception.
     *
     * @param recognizer
     */ endErrorCondition(recognizer) {
        this.errorRecoveryMode = false;
        this.lastErrorStates = undefined;
        this.lastErrorIndex = -1;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition}.
     */ reportMatch(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation returns immediately if the handler is already
     * in error recovery mode. Otherwise, it calls {@link #beginErrorCondition}
     * and dispatches the reporting task based on the runtime type of `e`
     * according to the following table.
     *
     * * {@link NoViableAltException}: Dispatches the call to
     *   {@link #reportNoViableAlternative}
     * * {@link InputMismatchException}: Dispatches the call to
     *   {@link #reportInputMismatch}
     * * {@link FailedPredicateException}: Dispatches the call to
     *   {@link #reportFailedPredicate}
     * * All other types: calls {@link Parser#notifyErrorListeners} to report
     *   the exception
     */ reportError(recognizer, e) {
        // if we've already reported an error and have not matched a token
        // yet successfully, don't report any errors.
        if (this.inErrorRecoveryMode(recognizer)) //			System.err.print("[SPURIOUS] ");
        return; // don't report spurious errors
        this.beginErrorCondition(recognizer);
        if (e instanceof $1O6nA.NoViableAltException) this.reportNoViableAlternative(recognizer, e);
        else if (e instanceof $2ITdp.InputMismatchException) this.reportInputMismatch(recognizer, e);
        else if (e instanceof $aaCqm.FailedPredicateException) this.reportFailedPredicate(recognizer, e);
        else {
            console.error(`unknown recognition error type: ${e}`);
            this.notifyErrorListeners(recognizer, e.toString(), e);
        }
    }
    notifyErrorListeners(recognizer, message, e) {
        let offendingToken = e.getOffendingToken(recognizer);
        if (offendingToken === undefined) // Pass null to notifyErrorListeners so it in turn calls the error listeners with undefined as the offending
        // token. If we passed undefined, it would instead call the listeners with currentToken from the parser.
        offendingToken = null;
        recognizer.notifyErrorListeners(message, offendingToken, e);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation resynchronizes the parser by consuming tokens
     * until we find one in the resynchronization set--loosely the set of tokens
     * that can follow the current rule.
     */ recover(recognizer, e) {
        //		System.out.println("recover in "+recognizer.getRuleInvocationStack()+
        //						   " index="+recognizer.inputStream.index+
        //						   ", lastErrorIndex="+
        //						   lastErrorIndex+
        //						   ", states="+lastErrorStates);
        if (this.lastErrorIndex === recognizer.inputStream.index && this.lastErrorStates && this.lastErrorStates.contains(recognizer.state)) // uh oh, another error at same token index and previously-visited
        // state in ATN; must be a case where LT(1) is in the recovery
        // token set so nothing got consumed. Consume a single token
        // at least to prevent an infinite loop; this is a failsafe.
        //			System.err.println("seen error condition before index="+
        //							   lastErrorIndex+", states="+lastErrorStates);
        //			System.err.println("FAILSAFE consumes "+recognizer.getTokenNames()[recognizer.inputStream.LA(1)]);
        recognizer.consume();
        this.lastErrorIndex = recognizer.inputStream.index;
        if (!this.lastErrorStates) this.lastErrorStates = new $fkZzb.IntervalSet();
        this.lastErrorStates.add(recognizer.state);
        let followSet = this.getErrorRecoverySet(recognizer);
        this.consumeUntil(recognizer, followSet);
    }
    /**
     * The default implementation of {@link ANTLRErrorStrategy#sync} makes sure
     * that the current lookahead symbol is consistent with what were expecting
     * at this point in the ATN. You can call this anytime but ANTLR only
     * generates code to check before subrules/loops and each iteration.
     *
     * Implements Jim Idle's magic sync mechanism in closures and optional
     * subrules. E.g.,
     *
     * ```antlr
     * a : sync ( stuff sync )* ;
     * sync : {consume to what can follow sync} ;
     * ```
     *
     * At the start of a sub rule upon error, {@link #sync} performs single
     * token deletion, if possible. If it can't do that, it bails on the current
     * rule and uses the default error recovery, which consumes until the
     * resynchronization set of the current rule.
     *
     * If the sub rule is optional (`(...)?`, `(...)*`, or block
     * with an empty alternative), then the expected set includes what follows
     * the subrule.
     *
     * During loop iteration, it consumes until it sees a token that can start a
     * sub rule or what follows loop. Yes, that is pretty aggressive. We opt to
     * stay in the loop as long as possible.
     *
     * **ORIGINS**
     *
     * Previous versions of ANTLR did a poor job of their recovery within loops.
     * A single mismatch token or missing token would force the parser to bail
     * out of the entire rules surrounding the loop. So, for rule
     *
     * ```antlr
     * classDef : 'class' ID '{' member* '}'
     * ```
     *
     * input with an extra token between members would force the parser to
     * consume until it found the next class definition rather than the next
     * member definition of the current class.
     *
     * This functionality cost a little bit of effort because the parser has to
     * compare token set at the start of the loop and at each iteration. If for
     * some reason speed is suffering for you, you can turn off this
     * functionality by simply overriding this method as a blank { }.
     */ sync(recognizer) {
        let s = recognizer.interpreter.atn.states[recognizer.state];
        //		System.err.println("sync @ "+s.stateNumber+"="+s.getClass().getSimpleName());
        // If already recovering, don't try to sync
        if (this.inErrorRecoveryMode(recognizer)) return;
        let tokens = recognizer.inputStream;
        let la = tokens.LA(1);
        // try cheaper subset first; might get lucky. seems to shave a wee bit off
        let nextTokens = recognizer.atn.nextTokens(s);
        if (nextTokens.contains(la)) {
            // We are sure the token matches
            this.nextTokensContext = undefined;
            this.nextTokensState = $gh8QV.ATNState.INVALID_STATE_NUMBER;
            return;
        }
        if (nextTokens.contains($iLVZN.Token.EPSILON)) {
            if (this.nextTokensContext === undefined) {
                // It's possible the next token won't match; information tracked
                // by sync is restricted for performance.
                this.nextTokensContext = recognizer.context;
                this.nextTokensState = recognizer.state;
            }
            return;
        }
        switch(s.stateType){
            case $4txXj.ATNStateType.BLOCK_START:
            case $4txXj.ATNStateType.STAR_BLOCK_START:
            case $4txXj.ATNStateType.PLUS_BLOCK_START:
            case $4txXj.ATNStateType.STAR_LOOP_ENTRY:
                // report error and recover if possible
                if (this.singleTokenDeletion(recognizer)) return;
                throw new $2ITdp.InputMismatchException(recognizer);
            case $4txXj.ATNStateType.PLUS_LOOP_BACK:
            case $4txXj.ATNStateType.STAR_LOOP_BACK:
                //			System.err.println("at loop back: "+s.getClass().getSimpleName());
                this.reportUnwantedToken(recognizer);
                let expecting = recognizer.getExpectedTokens();
                let whatFollowsLoopIterationOrRule = expecting.or(this.getErrorRecoverySet(recognizer));
                this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
                break;
            default:
                break;
        }
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link NoViableAltException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportNoViableAlternative(recognizer, e) {
        let tokens = recognizer.inputStream;
        let input;
        if (tokens) {
            if (e.startToken.type === $iLVZN.Token.EOF) input = "<EOF>";
            else input = tokens.getTextFromRange(e.startToken, e.getOffendingToken());
        } else input = "<unknown input>";
        let msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is an
     * {@link InputMismatchException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportInputMismatch(recognizer, e) {
        let expected = e.expectedTokens;
        let expectedString = expected ? expected.toStringVocabulary(recognizer.vocabulary) : "";
        let msg = "mismatched input " + this.getTokenErrorDisplay(e.getOffendingToken(recognizer)) + " expecting " + expectedString;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link FailedPredicateException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportFailedPredicate(recognizer, e) {
        let ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
        let msg = "rule " + ruleName + " " + e.message;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This method is called to report a syntax error which requires the removal
     * of a token from the input stream. At the time this method is called, the
     * erroneous symbol is current `LT(1)` symbol and has not yet been
     * removed from the input stream. When this method returns,
     * `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenDeletion} identifies
     * single-token deletion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportUnwantedToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let tokenName = this.getTokenErrorDisplay(t);
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "extraneous input " + tokenName + " expecting " + expecting.toStringVocabulary(recognizer.vocabulary);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * This method is called to report a syntax error which requires the
     * insertion of a missing token into the input stream. At the time this
     * method is called, the missing token has not yet been inserted. When this
     * method returns, `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenInsertion} identifies
     * single-token insertion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportMissingToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "missing " + expecting.toStringVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation attempts to recover from the mismatched input
     * by using single token insertion and deletion as described below. If the
     * recovery attempt fails, this method
     * {@link InputMismatchException}.
     *
     * **EXTRA TOKEN** (single token deletion)
     *
     * `LA(1)` is not what we are looking for. If `LA(2)` has the
     * right token, however, then assume `LA(1)` is some extra spurious
     * token and delete it. Then consume and return the next token (which was
     * the `LA(2)` token) as the successful result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenDeletion}.
     *
     * **MISSING TOKEN** (single token insertion)
     *
     * If current token (at `LA(1)`) is consistent with what could come
     * after the expected `LA(1)` token, then assume the token is missing
     * and use the parser's {@link TokenFactory} to create it on the fly. The
     * "insertion" is performed by returning the created token as the successful
     * result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenInsertion}.
     *
     * **EXAMPLE**
     *
     * For example, Input `i=(3;` is clearly missing the `')'`. When
     * the parser returns from the nested call to `expr`, it will have
     * call chain:
     *
     * ```
     * stat → expr → atom
     * ```
     *
     * and it will be trying to match the `')'` at this point in the
     * derivation:
     *
     * ```
     * => ID '=' '(' INT ')' ('+' atom)* ';'
     *                    ^
     * ```
     *
     * The attempt to match `')'` will fail when it sees `';'` and
     * call {@link #recoverInline}. To recover, it sees that `LA(1)==';'`
     * is in the set of tokens that can follow the `')'` token reference
     * in rule `atom`. It can assume that you forgot the `')'`.
     */ recoverInline(recognizer) {
        // SINGLE TOKEN DELETION
        let matchedSymbol = this.singleTokenDeletion(recognizer);
        if (matchedSymbol) {
            // we have deleted the extra token.
            // now, move past ttype token as if all were ok
            recognizer.consume();
            return matchedSymbol;
        }
        // SINGLE TOKEN INSERTION
        if (this.singleTokenInsertion(recognizer)) return this.getMissingSymbol(recognizer);
        // even that didn't work; must throw the exception
        if (this.nextTokensContext === undefined) throw new $2ITdp.InputMismatchException(recognizer);
        else throw new $2ITdp.InputMismatchException(recognizer, this.nextTokensState, this.nextTokensContext);
    }
    /**
     * This method implements the single-token insertion inline error recovery
     * strategy. It is called by {@link #recoverInline} if the single-token
     * deletion strategy fails to recover from the mismatched input. If this
     * method returns `true`, `recognizer` will be in error recovery
     * mode.
     *
     * This method determines whether or not single-token insertion is viable by
     * checking if the `LA(1)` input symbol could be successfully matched
     * if it were instead the `LA(2)` symbol. If this method returns
     * `true`, the caller is responsible for creating and inserting a
     * token with the correct type to produce this behavior.
     *
     * @param recognizer the parser instance
     * @returns `true` if single-token insertion is a viable recovery
     * strategy for the current mismatched input, otherwise `false`
     */ singleTokenInsertion(recognizer) {
        let currentSymbolType = recognizer.inputStream.LA(1);
        // if current token is consistent with what could come after current
        // ATN state, then we know we're missing a token; error recovery
        // is free to conjure up and insert the missing token
        let currentState = recognizer.interpreter.atn.states[recognizer.state];
        let next = currentState.transition(0).target;
        let atn = recognizer.interpreter.atn;
        let expectingAtLL2 = atn.nextTokens(next, $gT9VD.PredictionContext.fromRuleContext(atn, recognizer.context));
        //		console.warn("LT(2) set="+expectingAtLL2.toString(recognizer.getTokenNames()));
        if (expectingAtLL2.contains(currentSymbolType)) {
            this.reportMissingToken(recognizer);
            return true;
        }
        return false;
    }
    /**
     * This method implements the single-token deletion inline error recovery
     * strategy. It is called by {@link #recoverInline} to attempt to recover
     * from mismatched input. If this method returns `undefined`, the parser and error
     * handler state will not have changed. If this method returns non-`undefined`,
     * `recognizer` will *not* be in error recovery mode since the
     * returned token was a successful match.
     *
     * If the single-token deletion is successful, this method calls
     * {@link #reportUnwantedToken} to report the error, followed by
     * {@link Parser#consume} to actually "delete" the extraneous token. Then,
     * before returning {@link #reportMatch} is called to signal a successful
     * match.
     *
     * @param recognizer the parser instance
     * @returns the successfully matched {@link Token} instance if single-token
     * deletion successfully recovers from the mismatched input, otherwise
     * `undefined`
     */ singleTokenDeletion(recognizer) {
        let nextTokenType = recognizer.inputStream.LA(2);
        let expecting = this.getExpectedTokens(recognizer);
        if (expecting.contains(nextTokenType)) {
            this.reportUnwantedToken(recognizer);
            /*
            System.err.println("recoverFromMismatchedToken deleting "+
                               ((TokenStream)recognizer.inputStream).LT(1)+
                               " since "+((TokenStream)recognizer.inputStream).LT(2)+
                               " is what we want");
            */ recognizer.consume(); // simply delete extra token
            // we want to return the token we're actually matching
            let matchedSymbol = recognizer.currentToken;
            this.reportMatch(recognizer); // we know current token is correct
            return matchedSymbol;
        }
        return undefined;
    }
    /** Conjure up a missing token during error recovery.
     *
     *  The recognizer attempts to recover from single missing
     *  symbols. But, actions might refer to that missing symbol.
     *  For example, x=ID {f($x);}. The action clearly assumes
     *  that there has been an identifier matched previously and that
     *  $x points at that token. If that token is missing, but
     *  the next token in the stream is what we want we assume that
     *  this token is missing and we keep going. Because we
     *  have to return some token to replace the missing token,
     *  we have to conjure one up. This method gives the user control
     *  over the tokens returned for missing tokens. Mostly,
     *  you will want to create something special for identifier
     *  tokens. For literals such as '{' and ',', the default
     *  action in the parser or tree parser works. It simply creates
     *  a CommonToken of the appropriate type. The text will be the token.
     *  If you change what tokens must be created by the lexer,
     *  override this method to create the appropriate tokens.
     */ getMissingSymbol(recognizer) {
        let currentSymbol = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let expectedTokenType = $iLVZN.Token.INVALID_TYPE;
        if (!expecting.isNil) // get any element
        expectedTokenType = expecting.minElement;
        let tokenText;
        if (expectedTokenType === $iLVZN.Token.EOF) tokenText = "<missing EOF>";
        else tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
        let current = currentSymbol;
        let lookback = recognizer.inputStream.tryLT(-1);
        if (current.type === $iLVZN.Token.EOF && lookback != null) current = lookback;
        return this.constructToken(recognizer.inputStream.tokenSource, expectedTokenType, tokenText, current);
    }
    constructToken(tokenSource, expectedTokenType, tokenText, current) {
        let factory = tokenSource.tokenFactory;
        let x = current.tokenSource;
        let stream = x ? x.inputStream : undefined;
        return factory.create({
            source: tokenSource,
            stream: stream
        }, expectedTokenType, tokenText, $iLVZN.Token.DEFAULT_CHANNEL, -1, -1, current.line, current.charPositionInLine);
    }
    getExpectedTokens(recognizer) {
        return recognizer.getExpectedTokens();
    }
    /** How should a token be displayed in an error message? The default
     *  is to display just the text, but during development you might
     *  want to have a lot of information spit out.  Override in that case
     *  to use t.toString() (which, for CommonToken, dumps everything about
     *  the token). This is better than forcing you to override a method in
     *  your token objects because you don't have to go modify your lexer
     *  so that it creates a new Java type.
     */ getTokenErrorDisplay(t) {
        if (!t) return "<no token>";
        let s = this.getSymbolText(t);
        if (!s) {
            if (this.getSymbolType(t) === $iLVZN.Token.EOF) s = "<EOF>";
            else s = `<${this.getSymbolType(t)}>`;
        }
        return this.escapeWSAndQuote(s);
    }
    getSymbolText(symbol) {
        return symbol.text;
    }
    getSymbolType(symbol) {
        return symbol.type;
    }
    escapeWSAndQuote(s) {
        //		if ( s==null ) return s;
        s = s.replace("\n", "\\n");
        s = s.replace("\r", "\\r");
        s = s.replace("\t", "\\t");
        return "'" + s + "'";
    }
    /*  Compute the error recovery set for the current rule.  During
     *  rule invocation, the parser pushes the set of tokens that can
     *  follow that rule reference on the stack; this amounts to
     *  computing FIRST of what follows the rule reference in the
     *  enclosing rule. See LinearApproximator.FIRST().
     *  This local follow set only includes tokens
     *  from within the rule; i.e., the FIRST computation done by
     *  ANTLR stops at the end of a rule.
     *
     *  EXAMPLE
     *
     *  When you find a "no viable alt exception", the input is not
     *  consistent with any of the alternatives for rule r.  The best
     *  thing to do is to consume tokens until you see something that
     *  can legally follow a call to r *or* any rule that called r.
     *  You don't want the exact set of viable next tokens because the
     *  input might just be missing a token--you might consume the
     *  rest of the input looking for one of the missing tokens.
     *
     *  Consider grammar:
     *
     *  a : '[' b ']'
     *    | '(' b ')'
     *    ;
     *  b : c '^' INT ;
     *  c : ID
     *    | INT
     *    ;
     *
     *  At each rule invocation, the set of tokens that could follow
     *  that rule is pushed on a stack.  Here are the various
     *  context-sensitive follow sets:
     *
     *  FOLLOW(b1_in_a) = FIRST(']') = ']'
     *  FOLLOW(b2_in_a) = FIRST(')') = ')'
     *  FOLLOW(c_in_b) = FIRST('^') = '^'
     *
     *  Upon erroneous input "[]", the call chain is
     *
     *  a -> b -> c
     *
     *  and, hence, the follow context stack is:
     *
     *  depth     follow set       start of rule execution
     *    0         <EOF>                    a (from main())
     *    1          ']'                     b
     *    2          '^'                     c
     *
     *  Notice that ')' is not included, because b would have to have
     *  been called from a different context in rule a for ')' to be
     *  included.
     *
     *  For error recovery, we cannot consider FOLLOW(c)
     *  (context-sensitive or otherwise).  We need the combined set of
     *  all context-sensitive FOLLOW sets--the set of all tokens that
     *  could follow any reference in the call chain.  We need to
     *  resync to one of those tokens.  Note that FOLLOW(c)='^' and if
     *  we resync'd to that token, we'd consume until EOF.  We need to
     *  sync to context-sensitive FOLLOWs for a, b, and c: {']','^'}.
     *  In this case, for input "[]", LA(1) is ']' and in the set, so we would
     *  not consume anything. After printing an error, rule c would
     *  return normally.  Rule b would not find the required '^' though.
     *  At this point, it gets a mismatched token error and
     *  exception (since LA(1) is not in the viable following token
     *  set).  The rule exception handler tries to recover, but finds
     *  the same recovery set and doesn't consume anything.  Rule b
     *  exits normally returning to rule a.  Now it finds the ']' (and
     *  with the successful match exits errorRecovery mode).
     *
     *  So, you can see that the parser walks up the call chain looking
     *  for the token that was a member of the recovery set.
     *
     *  Errors are not generated in errorRecovery mode.
     *
     *  ANTLR's error recovery mechanism is based upon original ideas:
     *
     *  "Algorithms + Data Structures = Programs" by Niklaus Wirth
     *
     *  and
     *
     *  "A note on error recovery in recursive descent parsers":
     *  http://portal.acm.org/citation.cfm?id=947902.947905
     *
     *  Later, Josef Grosch had some good ideas:
     *
     *  "Efficient and Comfortable Error Recovery in Recursive Descent
     *  Parsers":
     *  ftp://www.cocolab.com/products/cocktail/doca4.ps/ell.ps.zip
     *
     *  Like Grosch I implement context-sensitive FOLLOW sets that are combined
     *  at run-time upon error to avoid overhead during parsing.
     */ getErrorRecoverySet(recognizer) {
        let atn = recognizer.interpreter.atn;
        let ctx = recognizer.context;
        let recoverSet = new $fkZzb.IntervalSet();
        while(ctx && ctx.invokingState >= 0){
            // compute what follows who invoked us
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            let follow = atn.nextTokens(rt.followState);
            recoverSet.addAll(follow);
            ctx = ctx._parent;
        }
        recoverSet.remove($iLVZN.Token.EPSILON);
        //		System.out.println("recover set "+recoverSet.toString(recognizer.getTokenNames()));
        return recoverSet;
    }
    /** Consume tokens until one matches the given token set. */ consumeUntil(recognizer, set) {
        //		System.err.println("consumeUntil("+set.toString(recognizer.getTokenNames())+")");
        let ttype = recognizer.inputStream.LA(1);
        while(ttype !== $iLVZN.Token.EOF && !set.contains(ttype)){
            //System.out.println("consume during recover LA(1)="+getTokenNames()[input.LA(1)]);
            //			recognizer.inputStream.consume();
            recognizer.consume();
            ttype = recognizer.inputStream.LA(1);
        }
    }
}
$66de61c79a6a181a$var$__decorate([
    $60gAE.Override
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "reset", null);
$66de61c79a6a181a$var$__decorate([
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "beginErrorCondition", null);
$66de61c79a6a181a$var$__decorate([
    $60gAE.Override
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "inErrorRecoveryMode", null);
$66de61c79a6a181a$var$__decorate([
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "endErrorCondition", null);
$66de61c79a6a181a$var$__decorate([
    $60gAE.Override
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "reportMatch", null);
$66de61c79a6a181a$var$__decorate([
    $60gAE.Override
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "reportError", null);
$66de61c79a6a181a$var$__decorate([
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "notifyErrorListeners", null);
$66de61c79a6a181a$var$__decorate([
    $60gAE.Override
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "recover", null);
$66de61c79a6a181a$var$__decorate([
    $60gAE.Override
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "sync", null);
$66de61c79a6a181a$var$__decorate([
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull),
    $66de61c79a6a181a$var$__param(1, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "reportNoViableAlternative", null);
$66de61c79a6a181a$var$__decorate([
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull),
    $66de61c79a6a181a$var$__param(1, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "reportInputMismatch", null);
$66de61c79a6a181a$var$__decorate([
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull),
    $66de61c79a6a181a$var$__param(1, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "reportFailedPredicate", null);
$66de61c79a6a181a$var$__decorate([
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "reportUnwantedToken", null);
$66de61c79a6a181a$var$__decorate([
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "reportMissingToken", null);
$66de61c79a6a181a$var$__decorate([
    $60gAE.Override
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "recoverInline", null);
$66de61c79a6a181a$var$__decorate([
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "singleTokenInsertion", null);
$66de61c79a6a181a$var$__decorate([
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "singleTokenDeletion", null);
$66de61c79a6a181a$var$__decorate([
    $60gAE.NotNull,
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "getMissingSymbol", null);
$66de61c79a6a181a$var$__decorate([
    $60gAE.NotNull,
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "getExpectedTokens", null);
$66de61c79a6a181a$var$__decorate([
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "getSymbolText", null);
$66de61c79a6a181a$var$__decorate([
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "getSymbolType", null);
$66de61c79a6a181a$var$__decorate([
    $60gAE.NotNull,
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "escapeWSAndQuote", null);
$66de61c79a6a181a$var$__decorate([
    $60gAE.NotNull,
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "getErrorRecoverySet", null);
$66de61c79a6a181a$var$__decorate([
    $66de61c79a6a181a$var$__param(0, $60gAE.NotNull),
    $66de61c79a6a181a$var$__param(1, $60gAE.NotNull)
], $66de61c79a6a181a$var$DefaultErrorStrategy.prototype, "consumeUntil", null);
module.exports.DefaultErrorStrategy = $66de61c79a6a181a$var$DefaultErrorStrategy;

});
parcelRegister("gh8QV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bd9519cd0e184434$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNState = void 0;

var $60gAE = parcelRequire("60gAE");
const $bd9519cd0e184434$var$INITIAL_NUM_TRANSITIONS = 4;
/**
 * The following images show the relation of states and
 * {@link ATNState#transitions} for various grammar constructs.
 *
 * * Solid edges marked with an &#0949; indicate a required
 *   {@link EpsilonTransition}.
 *
 * * Dashed edges indicate locations where any transition derived from
 *   {@link Transition} might appear.
 *
 * * Dashed nodes are place holders for either a sequence of linked
 *   {@link BasicState} states or the inclusion of a block representing a nested
 *   construct in one of the forms below.
 *
 * * Nodes showing multiple outgoing alternatives with a `...` support
 *   any number of alternatives (one or more). Nodes without the `...` only
 *   support the exact number of alternatives shown in the diagram.
 *
 * <h2>Basic Blocks</h2>
 *
 * <h3>Rule</h3>
 *
 * <embed src="images/Rule.svg" type="image/svg+xml"/>
 *
 * <h3>Block of 1 or more alternatives</h3>
 *
 * <embed src="images/Block.svg" type="image/svg+xml"/>
 *
 * <h2>Greedy Loops</h2>
 *
 * <h3>Greedy Closure: `(...)*`</h3>
 *
 * <embed src="images/ClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Positive Closure: `(...)+`</h3>
 *
 * <embed src="images/PositiveClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Optional: `(...)?`</h3>
 *
 * <embed src="images/OptionalGreedy.svg" type="image/svg+xml"/>
 *
 * <h2>Non-Greedy Loops</h2>
 *
 * <h3>Non-Greedy Closure: `(...)*?`</h3>
 *
 * <embed src="images/ClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Positive Closure: `(...)+?`</h3>
 *
 * <embed src="images/PositiveClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Optional: `(...)??`</h3>
 *
 * <embed src="images/OptionalNonGreedy.svg" type="image/svg+xml"/>
 */ class $bd9519cd0e184434$var$ATNState {
    constructor(){
        this.stateNumber = $bd9519cd0e184434$var$ATNState.INVALID_STATE_NUMBER;
        this.ruleIndex = 0; // at runtime, we don't have Rule objects
        this.epsilonOnlyTransitions = false;
        /** Track the transitions emanating from this ATN state. */ this.transitions = [];
        this.optimizedTransitions = this.transitions;
    }
    /**
     * Gets the state number.
     *
     * @returns the state number
     */ getStateNumber() {
        return this.stateNumber;
    }
    /**
     * For all states except {@link RuleStopState}, this returns the state
     * number. Returns -1 for stop states.
     *
     * @returns -1 for {@link RuleStopState}, otherwise the state number
     */ get nonStopStateNumber() {
        return this.getStateNumber();
    }
    hashCode() {
        return this.stateNumber;
    }
    equals(o) {
        // are these states same object?
        if (o instanceof $bd9519cd0e184434$var$ATNState) return this.stateNumber === o.stateNumber;
        return false;
    }
    get isNonGreedyExitState() {
        return false;
    }
    toString() {
        return String(this.stateNumber);
    }
    getTransitions() {
        return this.transitions.slice(0);
    }
    get numberOfTransitions() {
        return this.transitions.length;
    }
    addTransition(e, index) {
        if (this.transitions.length === 0) this.epsilonOnlyTransitions = e.isEpsilon;
        else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
            this.epsilonOnlyTransitions = false;
            throw new Error("ATN state " + this.stateNumber + " has both epsilon and non-epsilon transitions.");
        }
        this.transitions.splice(index !== undefined ? index : this.transitions.length, 0, e);
    }
    transition(i) {
        return this.transitions[i];
    }
    setTransition(i, e) {
        this.transitions[i] = e;
    }
    removeTransition(index) {
        return this.transitions.splice(index, 1)[0];
    }
    get onlyHasEpsilonTransitions() {
        return this.epsilonOnlyTransitions;
    }
    setRuleIndex(ruleIndex) {
        this.ruleIndex = ruleIndex;
    }
    get isOptimized() {
        return this.optimizedTransitions !== this.transitions;
    }
    get numberOfOptimizedTransitions() {
        return this.optimizedTransitions.length;
    }
    getOptimizedTransition(i) {
        return this.optimizedTransitions[i];
    }
    addOptimizedTransition(e) {
        if (!this.isOptimized) this.optimizedTransitions = new Array();
        this.optimizedTransitions.push(e);
    }
    setOptimizedTransition(i, e) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions[i] = e;
    }
    removeOptimizedTransition(i) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions.splice(i, 1);
    }
}
$bd9519cd0e184434$var$__decorate([
    $60gAE.Override
], $bd9519cd0e184434$var$ATNState.prototype, "hashCode", null);
$bd9519cd0e184434$var$__decorate([
    $60gAE.Override
], $bd9519cd0e184434$var$ATNState.prototype, "equals", null);
$bd9519cd0e184434$var$__decorate([
    $60gAE.Override
], $bd9519cd0e184434$var$ATNState.prototype, "toString", null);
module.exports.ATNState = $bd9519cd0e184434$var$ATNState;
(function(ATNState) {
    ATNState.INVALID_STATE_NUMBER = -1;
})($bd9519cd0e184434$var$ATNState = module.exports.ATNState || (module.exports.ATNState = {}));

});

parcelRegister("4txXj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNStateType = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:27.4734328-07:00
var $342435bc84ab92c9$var$ATNStateType;
(function(ATNStateType) {
    ATNStateType[ATNStateType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
    ATNStateType[ATNStateType["BASIC"] = 1] = "BASIC";
    ATNStateType[ATNStateType["RULE_START"] = 2] = "RULE_START";
    ATNStateType[ATNStateType["BLOCK_START"] = 3] = "BLOCK_START";
    ATNStateType[ATNStateType["PLUS_BLOCK_START"] = 4] = "PLUS_BLOCK_START";
    ATNStateType[ATNStateType["STAR_BLOCK_START"] = 5] = "STAR_BLOCK_START";
    ATNStateType[ATNStateType["TOKEN_START"] = 6] = "TOKEN_START";
    ATNStateType[ATNStateType["RULE_STOP"] = 7] = "RULE_STOP";
    ATNStateType[ATNStateType["BLOCK_END"] = 8] = "BLOCK_END";
    ATNStateType[ATNStateType["STAR_LOOP_BACK"] = 9] = "STAR_LOOP_BACK";
    ATNStateType[ATNStateType["STAR_LOOP_ENTRY"] = 10] = "STAR_LOOP_ENTRY";
    ATNStateType[ATNStateType["PLUS_LOOP_BACK"] = 11] = "PLUS_LOOP_BACK";
    ATNStateType[ATNStateType["LOOP_END"] = 12] = "LOOP_END";
})($342435bc84ab92c9$var$ATNStateType = module.exports.ATNStateType || (module.exports.ATNStateType = {}));

});

parcelRegister("aaCqm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7678a4cea2fc91a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7678a4cea2fc91a7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FailedPredicateException = void 0;

var $2XZxT = parcelRequire("2XZxT");

var $60gAE = parcelRequire("60gAE");

var $jrz9M = parcelRequire("jrz9M");
/** A semantic predicate failed during validation.  Validation of predicates
 *  occurs when normally parsing the alternative just like matching a token.
 *  Disambiguating predicate evaluation occurs when we test a predicate during
 *  prediction.
 */ let $7678a4cea2fc91a7$var$FailedPredicateException = class FailedPredicateException extends $2XZxT.RecognitionException {
    constructor(recognizer, predicate, message){
        super(recognizer, recognizer.inputStream, recognizer.context, FailedPredicateException.formatMessage(predicate, message));
        let s = recognizer.interpreter.atn.states[recognizer.state];
        let trans = s.transition(0);
        if (trans instanceof $jrz9M.PredicateTransition) {
            this._ruleIndex = trans.ruleIndex;
            this._predicateIndex = trans.predIndex;
        } else {
            this._ruleIndex = 0;
            this._predicateIndex = 0;
        }
        this._predicate = predicate;
        super.setOffendingToken(recognizer, recognizer.currentToken);
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
    get predicateIndex() {
        return this._predicateIndex;
    }
    get predicate() {
        return this._predicate;
    }
    static formatMessage(predicate, message) {
        if (message) return message;
        return `failed predicate: {${predicate}}?`;
    }
};
$7678a4cea2fc91a7$var$__decorate([
    $60gAE.NotNull
], $7678a4cea2fc91a7$var$FailedPredicateException, "formatMessage", null);
$7678a4cea2fc91a7$var$FailedPredicateException = $7678a4cea2fc91a7$var$__decorate([
    $7678a4cea2fc91a7$var$__param(0, $60gAE.NotNull)
], $7678a4cea2fc91a7$var$FailedPredicateException);
module.exports.FailedPredicateException = $7678a4cea2fc91a7$var$FailedPredicateException;

});
parcelRegister("2XZxT", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionException = void 0;
/** The root of the ANTLR exception hierarchy. In general, ANTLR tracks just
 *  3 kinds of errors: prediction errors, failed predicate errors, and
 *  mismatched input errors. In each case, the parser knows where it is
 *  in the input, where it is in the ATN, the rule invocation stack,
 *  and what kind of problem occurred.
 */ class $2290d52258e0be4a$var$RecognitionException extends Error {
    constructor(recognizer, input, ctx, message){
        super(message);
        this._offendingState = -1;
        this._recognizer = recognizer;
        this.input = input;
        this.ctx = ctx;
        if (recognizer) this._offendingState = recognizer.state;
    }
    /**
     * Get the ATN state number the parser was in at the time the error
     * occurred. For {@link NoViableAltException} and
     * {@link LexerNoViableAltException} exceptions, this is the
     * {@link DecisionState} number. For others, it is the state whose outgoing
     * edge we couldn't match.
     *
     * If the state number is not known, this method returns -1.
     */ get offendingState() {
        return this._offendingState;
    }
    setOffendingState(offendingState) {
        this._offendingState = offendingState;
    }
    /**
     * Gets the set of input symbols which could potentially follow the
     * previously matched symbol at the time this exception was thrown.
     *
     * If the set of expected tokens is not known and could not be computed,
     * this method returns `undefined`.
     *
     * @returns The set of token types that could potentially follow the current
     * state in the ATN, or `undefined` if the information is not available.
     */ get expectedTokens() {
        if (this._recognizer) return this._recognizer.atn.getExpectedTokens(this._offendingState, this.ctx);
        return undefined;
    }
    /**
     * Gets the {@link RuleContext} at the time this exception was thrown.
     *
     * If the context is not available, this method returns `undefined`.
     *
     * @returns The {@link RuleContext} at the time this exception was thrown.
     * If the context is not available, this method returns `undefined`.
     */ get context() {
        return this.ctx;
    }
    /**
     * Gets the input stream which is the symbol source for the recognizer where
     * this exception was thrown.
     *
     * If the input stream is not available, this method returns `undefined`.
     *
     * @returns The input stream which is the symbol source for the recognizer
     * where this exception was thrown, or `undefined` if the stream is not
     * available.
     */ get inputStream() {
        return this.input;
    }
    getOffendingToken(recognizer) {
        if (recognizer && recognizer !== this._recognizer) return undefined;
        return this.offendingToken;
    }
    setOffendingToken(recognizer, offendingToken) {
        if (recognizer === this._recognizer) this.offendingToken = offendingToken;
    }
    /**
     * Gets the {@link Recognizer} where this exception occurred.
     *
     * If the recognizer is not available, this method returns `undefined`.
     *
     * @returns The recognizer where this exception occurred, or `undefined` if
     * the recognizer is not available.
     */ get recognizer() {
        return this._recognizer;
    }
}
module.exports.RecognitionException = $2290d52258e0be4a$var$RecognitionException;

});

parcelRegister("jrz9M", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e27bcf57af7d8731$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e27bcf57af7d8731$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredicateTransition = void 0;

var $22TGw = parcelRequire("22TGw");

var $60gAE = parcelRequire("60gAE");

var $gt6ZZ = parcelRequire("gt6ZZ");
/** TODO: this is old comment:
 *  A tree of semantic predicates from the grammar AST if label==SEMPRED.
 *  In the ATN, labels will always be exactly one predicate, but the DFA
 *  may have to combine a bunch of them as it collects predicates from
 *  multiple ATN configurations into a single DFA state.
 */ let $e27bcf57af7d8731$var$PredicateTransition = class PredicateTransition extends $22TGw.AbstractPredicateTransition {
    constructor(target, ruleIndex, predIndex, isCtxDependent){
        super(target);
        this.ruleIndex = ruleIndex;
        this.predIndex = predIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 4 /* PREDICATE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $gt6ZZ.SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
    }
    toString() {
        return "pred_" + this.ruleIndex + ":" + this.predIndex;
    }
};
$e27bcf57af7d8731$var$__decorate([
    $60gAE.Override
], $e27bcf57af7d8731$var$PredicateTransition.prototype, "serializationType", null);
$e27bcf57af7d8731$var$__decorate([
    $60gAE.Override
], $e27bcf57af7d8731$var$PredicateTransition.prototype, "isEpsilon", null);
$e27bcf57af7d8731$var$__decorate([
    $60gAE.Override
], $e27bcf57af7d8731$var$PredicateTransition.prototype, "matches", null);
$e27bcf57af7d8731$var$__decorate([
    $60gAE.Override,
    $60gAE.NotNull
], $e27bcf57af7d8731$var$PredicateTransition.prototype, "toString", null);
$e27bcf57af7d8731$var$PredicateTransition = $e27bcf57af7d8731$var$__decorate([
    $e27bcf57af7d8731$var$__param(0, $60gAE.NotNull)
], $e27bcf57af7d8731$var$PredicateTransition);
module.exports.PredicateTransition = $e27bcf57af7d8731$var$PredicateTransition;

});
parcelRegister("22TGw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractPredicateTransition = void 0;

var $lhxCK = parcelRequire("lhxCK");
/**
 *
 * @author Sam Harwell
 */ class $17d6f682a64f3f74$var$AbstractPredicateTransition extends $lhxCK.Transition {
    constructor(target){
        super(target);
    }
}
module.exports.AbstractPredicateTransition = $17d6f682a64f3f74$var$AbstractPredicateTransition;

});
parcelRegister("lhxCK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f7e54487b672e072$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f7e54487b672e072$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transition = void 0;

var $60gAE = parcelRequire("60gAE");
/** An ATN transition between any two ATN states.  Subclasses define
 *  atom, set, epsilon, action, predicate, rule transitions.
 *
 *  This is a one way link.  It emanates from a state (usually via a list of
 *  transitions) and has a target state.
 *
 *  Since we never have to change the ATN transitions once we construct it,
 *  we can fix these transitions as specific classes. The DFA transitions
 *  on the other hand need to update the labels as it adds transitions to
 *  the states. We'll use the term Edge for the DFA to distinguish them from
 *  ATN transitions.
 */ let $f7e54487b672e072$var$Transition = class Transition {
    constructor(target){
        if (target == null) throw new Error("target cannot be null.");
        this.target = target;
    }
    /**
     * Determines if the transition is an "epsilon" transition.
     *
     * The default implementation returns `false`.
     *
     * @returns `true` if traversing this transition in the ATN does not
     * consume an input symbol; otherwise, `false` if traversing this
     * transition consumes (matches) an input symbol.
     */ get isEpsilon() {
        return false;
    }
    get label() {
        return undefined;
    }
};
$f7e54487b672e072$var$Transition.serializationNames = [
    "INVALID",
    "EPSILON",
    "RANGE",
    "RULE",
    "PREDICATE",
    "ATOM",
    "ACTION",
    "SET",
    "NOT_SET",
    "WILDCARD",
    "PRECEDENCE"
];
$f7e54487b672e072$var$__decorate([
    $60gAE.NotNull
], $f7e54487b672e072$var$Transition.prototype, "target", void 0);
$f7e54487b672e072$var$Transition = $f7e54487b672e072$var$__decorate([
    $f7e54487b672e072$var$__param(0, $60gAE.NotNull)
], $f7e54487b672e072$var$Transition);
module.exports.Transition = $f7e54487b672e072$var$Transition;

});


parcelRegister("gt6ZZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bfd4c899dbec2398$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $bfd4c899dbec2398$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SemanticContext = void 0;

var $fqc4S = parcelRequire("fqc4S");

var $faPBd = parcelRequire("faPBd");

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");

var $cWz6y = parcelRequire("cWz6y");

var $5lo68 = parcelRequire("5lo68");
function $bfd4c899dbec2398$var$max(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison < 0) result = current;
    }
    return result;
}
function $bfd4c899dbec2398$var$min(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison > 0) result = current;
    }
    return result;
}
/** A tree structure used to record the semantic context in which
 *  an ATN configuration is valid.  It's either a single predicate,
 *  a conjunction `p1&&p2`, or a sum of products `p1||p2`.
 *
 *  I have scoped the {@link AND}, {@link OR}, and {@link Predicate} subclasses of
 *  {@link SemanticContext} within the scope of this outer class.
 */ class $bfd4c899dbec2398$var$SemanticContext {
    /**
     * The default {@link SemanticContext}, which is semantically equivalent to
     * a predicate of the form `{true}?`.
     */ static get NONE() {
        if ($bfd4c899dbec2398$var$SemanticContext._NONE === undefined) $bfd4c899dbec2398$var$SemanticContext._NONE = new $bfd4c899dbec2398$var$SemanticContext.Predicate();
        return $bfd4c899dbec2398$var$SemanticContext._NONE;
    }
    /**
     * Evaluate the precedence predicates for the context and reduce the result.
     *
     * @param parser The parser instance.
     * @param parserCallStack
     * @returns The simplified semantic context after precedence predicates are
     * evaluated, which will be one of the following values.
     *
     * * {@link #NONE}: if the predicate simplifies to `true` after
     *   precedence predicates are evaluated.
     * * `undefined`: if the predicate simplifies to `false` after
     *   precedence predicates are evaluated.
     * * `this`: if the semantic context is not changed as a result of
     *   precedence predicate evaluation.
     * * A non-`undefined` {@link SemanticContext}: the new simplified
     *   semantic context after precedence predicates are evaluated.
     */ evalPrecedence(parser, parserCallStack) {
        return this;
    }
    static and(a, b) {
        if (!a || a === $bfd4c899dbec2398$var$SemanticContext.NONE) return b;
        if (b === $bfd4c899dbec2398$var$SemanticContext.NONE) return a;
        let result = new $bfd4c899dbec2398$var$SemanticContext.AND(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
    /**
     *
     *  @see ParserATNSimulator#getPredsForAmbigAlts
     */ static or(a, b) {
        if (!a) return b;
        if (a === $bfd4c899dbec2398$var$SemanticContext.NONE || b === $bfd4c899dbec2398$var$SemanticContext.NONE) return $bfd4c899dbec2398$var$SemanticContext.NONE;
        let result = new $bfd4c899dbec2398$var$SemanticContext.OR(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
}
module.exports.SemanticContext = $bfd4c899dbec2398$var$SemanticContext;
(function(SemanticContext) {
    /**
     * This random 30-bit prime represents the value of `AND.class.hashCode()`.
     */ const AND_HASHCODE = 40363613;
    /**
     * This random 30-bit prime represents the value of `OR.class.hashCode()`.
     */ const OR_HASHCODE = 486279973;
    function filterPrecedencePredicates(collection) {
        let result = [];
        for(let i = 0; i < collection.length; i++){
            let context = collection[i];
            if (context instanceof SemanticContext.PrecedencePredicate) {
                result.push(context);
                // Remove the item from 'collection' and move i back so we look at the same index again
                collection.splice(i, 1);
                i--;
            }
        }
        return result;
    }
    class Predicate extends SemanticContext {
        constructor(ruleIndex = -1, predIndex = -1, isCtxDependent = false){
            super();
            this.ruleIndex = ruleIndex;
            this.predIndex = predIndex;
            this.isCtxDependent = isCtxDependent;
        }
        eval(parser, parserCallStack) {
            let localctx = this.isCtxDependent ? parserCallStack : undefined;
            return parser.sempred(localctx, this.ruleIndex, this.predIndex);
        }
        hashCode() {
            let hashCode = $ecbo5.MurmurHash.initialize();
            hashCode = $ecbo5.MurmurHash.update(hashCode, this.ruleIndex);
            hashCode = $ecbo5.MurmurHash.update(hashCode, this.predIndex);
            hashCode = $ecbo5.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
            hashCode = $ecbo5.MurmurHash.finish(hashCode, 3);
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof Predicate)) return false;
            if (this === obj) return true;
            return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
        }
        toString() {
            return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
        }
    }
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], Predicate.prototype, "eval", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], Predicate.prototype, "hashCode", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], Predicate.prototype, "equals", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], Predicate.prototype, "toString", null);
    SemanticContext.Predicate = Predicate;
    class PrecedencePredicate extends SemanticContext {
        constructor(precedence){
            super();
            this.precedence = precedence;
        }
        eval(parser, parserCallStack) {
            return parser.precpred(parserCallStack, this.precedence);
        }
        evalPrecedence(parser, parserCallStack) {
            if (parser.precpred(parserCallStack, this.precedence)) return SemanticContext.NONE;
            else return undefined;
        }
        compareTo(o) {
            return this.precedence - o.precedence;
        }
        hashCode() {
            let hashCode = 1;
            hashCode = 31 * hashCode + this.precedence;
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof PrecedencePredicate)) return false;
            if (this === obj) return true;
            return this.precedence === obj.precedence;
        }
        toString() {
            return "{" + this.precedence + ">=prec}?";
        }
    }
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], PrecedencePredicate.prototype, "eval", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], PrecedencePredicate.prototype, "evalPrecedence", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], PrecedencePredicate.prototype, "compareTo", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], PrecedencePredicate.prototype, "hashCode", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], PrecedencePredicate.prototype, "equals", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], PrecedencePredicate.prototype, "toString", null);
    SemanticContext.PrecedencePredicate = PrecedencePredicate;
    /**
     * This is the base class for semantic context "operators", which operate on
     * a collection of semantic context "operands".
     *
     * @since 4.3
     */ class Operator extends SemanticContext {
    }
    SemanticContext.Operator = Operator;
    /**
     * A semantic context which is true whenever none of the contained contexts
     * is false.
     */ let AND = class AND extends Operator {
        constructor(a, b){
            super();
            let operands = new $fqc4S.Array2DHashSet($cWz6y.ObjectEqualityComparator.INSTANCE);
            if (a instanceof AND) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof AND) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the lowest precedence
            let reduced = $bfd4c899dbec2398$var$min(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof AND)) return false;
            return $faPBd.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $ecbo5.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (!opnd.eval(parser, parserCallStack)) return false;
            }
            return true;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated == null) // The AND context is false if any element is false
                return undefined;
                else if (evaluated !== SemanticContext.NONE) // Reduce the result by skipping true elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were true, so the AND context is true
            return SemanticContext.NONE;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.and(result, operands[i]);
            return result;
        }
        toString() {
            return $5lo68.join(this.opnds, "&&");
        }
    };
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], AND.prototype, "operands", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], AND.prototype, "equals", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], AND.prototype, "hashCode", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], AND.prototype, "eval", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], AND.prototype, "evalPrecedence", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], AND.prototype, "toString", null);
    AND = $bfd4c899dbec2398$var$__decorate([
        $bfd4c899dbec2398$var$__param(0, $60gAE.NotNull),
        $bfd4c899dbec2398$var$__param(1, $60gAE.NotNull)
    ], AND);
    SemanticContext.AND = AND;
    /**
     * A semantic context which is true whenever at least one of the contained
     * contexts is true.
     */ let OR = class OR extends Operator {
        constructor(a, b){
            super();
            let operands = new $fqc4S.Array2DHashSet($cWz6y.ObjectEqualityComparator.INSTANCE);
            if (a instanceof OR) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof OR) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the highest precedence
            let reduced = $bfd4c899dbec2398$var$max(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof OR)) return false;
            return $faPBd.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $ecbo5.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (opnd.eval(parser, parserCallStack)) return true;
            }
            return false;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated === SemanticContext.NONE) // The OR context is true if any element is true
                return SemanticContext.NONE;
                else if (evaluated) // Reduce the result by skipping false elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were false, so the OR context is false
            return undefined;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.or(result, operands[i]);
            return result;
        }
        toString() {
            return $5lo68.join(this.opnds, "||");
        }
    };
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], OR.prototype, "operands", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], OR.prototype, "equals", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], OR.prototype, "hashCode", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], OR.prototype, "eval", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], OR.prototype, "evalPrecedence", null);
    $bfd4c899dbec2398$var$__decorate([
        $60gAE.Override
    ], OR.prototype, "toString", null);
    OR = $bfd4c899dbec2398$var$__decorate([
        $bfd4c899dbec2398$var$__param(0, $60gAE.NotNull),
        $bfd4c899dbec2398$var$__param(1, $60gAE.NotNull)
    ], OR);
    SemanticContext.OR = OR;
})($bfd4c899dbec2398$var$SemanticContext = module.exports.SemanticContext || (module.exports.SemanticContext = {}));

});
parcelRegister("fqc4S", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b3a2a71d2bd93b9a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b3a2a71d2bd93b9a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashSet = void 0;

var $lzl5a = parcelRequire("lzl5a");

var $E05h0 = parcelRequire("E05h0");

var $60gAE = parcelRequire("60gAE");

var $ecbo5 = parcelRequire("ecbo5");
/** {@link Set} implementation with closed hashing (open addressing). */ // NOTE:  JavaScript's Set interface has on significant different diffrence from Java's:
// 		  e.g. the return type of add() differs!
//        For this reason I've commented tweaked the implements clause
const $b3a2a71d2bd93b9a$var$INITAL_CAPACITY = 16; // must be power of 2
const $b3a2a71d2bd93b9a$var$LOAD_FACTOR = 0.75;
class $b3a2a71d2bd93b9a$var$Array2DHashSet {
    constructor(comparatorOrSet, initialCapacity = $b3a2a71d2bd93b9a$var$INITAL_CAPACITY){
        /** How many elements in set */ this.n = 0;
        this.threshold = Math.floor($b3a2a71d2bd93b9a$var$INITAL_CAPACITY * $b3a2a71d2bd93b9a$var$LOAD_FACTOR); // when to expand
        if (comparatorOrSet instanceof $b3a2a71d2bd93b9a$var$Array2DHashSet) {
            this.comparator = comparatorOrSet.comparator;
            this.buckets = comparatorOrSet.buckets.slice(0);
            for(let i = 0; i < this.buckets.length; i++){
                let bucket = this.buckets[i];
                if (bucket) this.buckets[i] = bucket.slice(0);
            }
            this.n = comparatorOrSet.n;
            this.threshold = comparatorOrSet.threshold;
        } else {
            this.comparator = comparatorOrSet || $E05h0.DefaultEqualityComparator.INSTANCE;
            this.buckets = this.createBuckets(initialCapacity);
        }
    }
    /**
     * Add `o` to set if not there; return existing value if already
     * there. This method performs the same operation as {@link #add} aside from
     * the return value.
     */ getOrAdd(o) {
        if (this.n > this.threshold) this.expand();
        return this.getOrAddImpl(o);
    }
    getOrAddImpl(o) {
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        // NEW BUCKET
        if (!bucket) {
            bucket = [
                o
            ];
            this.buckets[b] = bucket;
            this.n++;
            return o;
        }
        // LOOK FOR IT IN BUCKET
        for (let existing of bucket){
            if (this.comparator.equals(existing, o)) return existing; // found existing, quit
        }
        // FULL BUCKET, expand and add to end
        bucket.push(o);
        this.n++;
        return o;
    }
    get(o) {
        if (o == null) return o;
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        if (!bucket) // no bucket
        return undefined;
        for (let e of bucket){
            if (this.comparator.equals(e, o)) return e;
        }
        return undefined;
    }
    getBucket(o) {
        let hash = this.comparator.hashCode(o);
        let b = hash & this.buckets.length - 1; // assumes len is power of 2
        return b;
    }
    hashCode() {
        let hash = $ecbo5.MurmurHash.initialize();
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                hash = $ecbo5.MurmurHash.update(hash, this.comparator.hashCode(o));
            }
        }
        hash = $ecbo5.MurmurHash.finish(hash, this.size);
        return hash;
    }
    equals(o) {
        if (o === this) return true;
        if (!(o instanceof $b3a2a71d2bd93b9a$var$Array2DHashSet)) return false;
        if (o.size !== this.size) return false;
        let same = this.containsAll(o);
        return same;
    }
    expand() {
        let old = this.buckets;
        let newCapacity = this.buckets.length * 2;
        let newTable = this.createBuckets(newCapacity);
        this.buckets = newTable;
        this.threshold = Math.floor(newCapacity * $b3a2a71d2bd93b9a$var$LOAD_FACTOR);
        //		System.out.println("new size="+newCapacity+", thres="+threshold);
        // rehash all existing entries
        let oldSize = this.size;
        for (let bucket of old){
            if (!bucket) continue;
            for (let o of bucket){
                let b = this.getBucket(o);
                let newBucket = this.buckets[b];
                if (!newBucket) {
                    newBucket = [];
                    this.buckets[b] = newBucket;
                }
                newBucket.push(o);
            }
        }
        $lzl5a(this.n === oldSize);
    }
    add(t) {
        let existing = this.getOrAdd(t);
        return existing === t;
    }
    get size() {
        return this.n;
    }
    get isEmpty() {
        return this.n === 0;
    }
    contains(o) {
        return this.containsFast(this.asElementType(o));
    }
    containsFast(obj) {
        if (obj == null) return false;
        return this.get(obj) != null;
    }
    *[Symbol.iterator]() {
        yield* this.toArray();
    }
    toArray() {
        const a = new Array(this.size);
        // Copy elements from the nested arrays into the destination array
        let i = 0; // Position within destination array
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                a[i++] = o;
            }
        }
        return a;
    }
    containsAll(collection) {
        if (collection instanceof $b3a2a71d2bd93b9a$var$Array2DHashSet) {
            let s = collection;
            for (let bucket of s.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    if (!this.containsFast(this.asElementType(o))) return false;
                }
            }
        } else for (let o of collection){
            if (!this.containsFast(this.asElementType(o))) return false;
        }
        return true;
    }
    addAll(c) {
        let changed = false;
        for (let o of c){
            let existing = this.getOrAdd(o);
            if (existing !== o) changed = true;
        }
        return changed;
    }
    clear() {
        this.buckets = this.createBuckets($b3a2a71d2bd93b9a$var$INITAL_CAPACITY);
        this.n = 0;
        this.threshold = Math.floor($b3a2a71d2bd93b9a$var$INITAL_CAPACITY * $b3a2a71d2bd93b9a$var$LOAD_FACTOR);
    }
    toString() {
        if (this.size === 0) return "{}";
        let buf = "{";
        let first = true;
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                if (first) first = false;
                else buf += ", ";
                buf += o.toString();
            }
        }
        buf += "}";
        return buf;
    }
    toTableString() {
        let buf = "";
        for (let bucket of this.buckets){
            if (bucket == null) {
                buf += "null\n";
                continue;
            }
            buf += "[";
            let first = true;
            for (let o of bucket){
                if (first) first = false;
                else buf += " ";
                if (o == null) buf += "_";
                else buf += o.toString();
            }
            buf += "]\n";
        }
        return buf;
    }
    /**
     * Return `o` as an instance of the element type `T`. If
     * `o` is non-undefined but known to not be an instance of `T`, this
     * method returns `undefined`. The base implementation does not perform any
     * type checks; override this method to provide strong type checks for the
     * {@link #contains} and {@link #remove} methods to ensure the arguments to
     * the {@link EqualityComparator} for the set always have the expected
     * types.
     *
     * @param o the object to try and cast to the element type of the set
     * @returns `o` if it could be an instance of `T`, otherwise
     * `undefined`.
     */ asElementType(o) {
        return o;
    }
    /**
     * Return an array of `T[]` with length `capacity`.
     *
     * @param capacity the length of the array to return
     * @returns the newly constructed array
     */ createBuckets(capacity) {
        return new Array(capacity);
    }
}
$b3a2a71d2bd93b9a$var$__decorate([
    $60gAE.NotNull
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, "comparator", void 0);
$b3a2a71d2bd93b9a$var$__decorate([
    $60gAE.Override
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, "hashCode", null);
$b3a2a71d2bd93b9a$var$__decorate([
    $60gAE.Override
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, "equals", null);
$b3a2a71d2bd93b9a$var$__decorate([
    $60gAE.Override
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, "add", null);
$b3a2a71d2bd93b9a$var$__decorate([
    $60gAE.Override
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, "size", null);
$b3a2a71d2bd93b9a$var$__decorate([
    $60gAE.Override
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, "isEmpty", null);
$b3a2a71d2bd93b9a$var$__decorate([
    $60gAE.Override
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, "contains", null);
$b3a2a71d2bd93b9a$var$__decorate([
    $b3a2a71d2bd93b9a$var$__param(0, $60gAE.Nullable)
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, "containsFast", null);
$b3a2a71d2bd93b9a$var$__decorate([
    $60gAE.Override
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, Symbol.iterator, null);
$b3a2a71d2bd93b9a$var$__decorate([
    $60gAE.Override
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, "toArray", null);
$b3a2a71d2bd93b9a$var$__decorate([
    $60gAE.Override
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, "containsAll", null);
$b3a2a71d2bd93b9a$var$__decorate([
    $60gAE.Override
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, "addAll", null);
$b3a2a71d2bd93b9a$var$__decorate([
    $60gAE.Override
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, "clear", null);
$b3a2a71d2bd93b9a$var$__decorate([
    $60gAE.Override
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, "toString", null);
$b3a2a71d2bd93b9a$var$__decorate([
    $60gAE.SuppressWarnings("unchecked")
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, "asElementType", null);
$b3a2a71d2bd93b9a$var$__decorate([
    $60gAE.SuppressWarnings("unchecked")
], $b3a2a71d2bd93b9a$var$Array2DHashSet.prototype, "createBuckets", null);
module.exports.Array2DHashSet = $b3a2a71d2bd93b9a$var$Array2DHashSet;

});
parcelRegister("E05h0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0783cd3b8dd78d0d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultEqualityComparator = void 0;

var $60gAE = parcelRequire("60gAE");

var $ecbo5 = parcelRequire("ecbo5");

var $cWz6y = parcelRequire("cWz6y");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $0783cd3b8dd78d0d$var$DefaultEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        else if (typeof obj === "string" || typeof obj === "number") return $ecbo5.MurmurHash.hashCode([
            obj
        ]);
        else return $cWz6y.ObjectEqualityComparator.INSTANCE.hashCode(obj);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (typeof a === "string" || typeof a === "number") return a === b;
        else return $cWz6y.ObjectEqualityComparator.INSTANCE.equals(a, b);
    }
}
$0783cd3b8dd78d0d$var$DefaultEqualityComparator.INSTANCE = new $0783cd3b8dd78d0d$var$DefaultEqualityComparator();
$0783cd3b8dd78d0d$var$__decorate([
    $60gAE.Override
], $0783cd3b8dd78d0d$var$DefaultEqualityComparator.prototype, "hashCode", null);
$0783cd3b8dd78d0d$var$__decorate([
    $60gAE.Override
], $0783cd3b8dd78d0d$var$DefaultEqualityComparator.prototype, "equals", null);
module.exports.DefaultEqualityComparator = $0783cd3b8dd78d0d$var$DefaultEqualityComparator;

});
parcelRegister("ecbo5", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MurmurHash = void 0;
/**
 *
 * @author Sam Harwell
 */ var $a55b04fd49e08114$var$MurmurHash;
(function(MurmurHash) {
    const DEFAULT_SEED = 0;
    /**
     * Initialize the hash using the specified `seed`.
     *
     * @param seed the seed (optional)
     * @returns the intermediate hash value
     */ function initialize(seed = DEFAULT_SEED) {
        return seed;
    }
    MurmurHash.initialize = initialize;
    /**
     * Update the intermediate hash value for the next input `value`.
     *
     * @param hash the intermediate hash value
     * @param value the value to add to the current hash
     * @returns the updated intermediate hash value
     */ function update(hash, value) {
        const c1 = 0xCC9E2D51;
        const c2 = 0x1B873593;
        const r1 = 15;
        const r2 = 13;
        const m = 5;
        const n = 0xE6546B64;
        if (value == null) value = 0;
        else if (typeof value === "string") value = hashString(value);
        else if (typeof value === "object") value = value.hashCode();
        let k = value;
        k = Math.imul(k, c1);
        k = k << r1 | k >>> 32 - r1;
        k = Math.imul(k, c2);
        hash = hash ^ k;
        hash = hash << r2 | hash >>> 32 - r2;
        hash = Math.imul(hash, m) + n;
        return hash & 0xFFFFFFFF;
    }
    MurmurHash.update = update;
    /**
     * Apply the final computation steps to the intermediate value `hash`
     * to form the final result of the MurmurHash 3 hash function.
     *
     * @param hash the intermediate hash value
     * @param numberOfWords the number of integer values added to the hash
     * @returns the final hash result
     */ function finish(hash, numberOfWords) {
        hash = hash ^ numberOfWords * 4;
        hash = hash ^ hash >>> 16;
        hash = Math.imul(hash, 0x85EBCA6B);
        hash = hash ^ hash >>> 13;
        hash = Math.imul(hash, 0xC2B2AE35);
        hash = hash ^ hash >>> 16;
        return hash;
    }
    MurmurHash.finish = finish;
    /**
     * Utility function to compute the hash code of an array using the
     * MurmurHash algorithm.
     *
     * @param <T> the array element type
     * @param data the array data
     * @param seed the seed for the MurmurHash algorithm
     * @returns the hash code of the data
     */ function hashCode(data, seed = DEFAULT_SEED) {
        let hash = initialize(seed);
        let length = 0;
        for (let value of data){
            hash = update(hash, value);
            length++;
        }
        hash = finish(hash, length);
        return hash;
    }
    MurmurHash.hashCode = hashCode;
    /**
     * Function to hash a string. Based on the implementation found here:
     * http://stackoverflow.com/a/7616484
     */ function hashString(str) {
        let len = str.length;
        if (len === 0) return 0;
        let hash = 0;
        for(let i = 0; i < len; i++){
            let c = str.charCodeAt(i);
            hash = (hash << 5 >>> 0) - hash + c;
            hash |= 0;
        }
        return hash;
    }
})($a55b04fd49e08114$var$MurmurHash = module.exports.MurmurHash || (module.exports.MurmurHash = {}));

});

parcelRegister("cWz6y", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $96c621e7cd7e27df$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectEqualityComparator = void 0;

var $60gAE = parcelRequire("60gAE");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $96c621e7cd7e27df$var$ObjectEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return obj.hashCode();
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        return a.equals(b);
    }
}
$96c621e7cd7e27df$var$ObjectEqualityComparator.INSTANCE = new $96c621e7cd7e27df$var$ObjectEqualityComparator();
$96c621e7cd7e27df$var$__decorate([
    $60gAE.Override
], $96c621e7cd7e27df$var$ObjectEqualityComparator.prototype, "hashCode", null);
$96c621e7cd7e27df$var$__decorate([
    $60gAE.Override
], $96c621e7cd7e27df$var$ObjectEqualityComparator.prototype, "equals", null);
module.exports.ObjectEqualityComparator = $96c621e7cd7e27df$var$ObjectEqualityComparator;

});



parcelRegister("faPBd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b0bfd0bbb97007e7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrayEqualityComparator = void 0;

var $60gAE = parcelRequire("60gAE");

var $ecbo5 = parcelRequire("ecbo5");

var $cWz6y = parcelRequire("cWz6y");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $b0bfd0bbb97007e7$var$ArrayEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return $ecbo5.MurmurHash.hashCode(obj, 0);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined`, this method returns `true`. Otherwise if only
     * `a` is `undefined`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (b == null) return false;
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$cWz6y.ObjectEqualityComparator.INSTANCE.equals(a[i], b[i])) return false;
        }
        return true;
    }
}
$b0bfd0bbb97007e7$var$ArrayEqualityComparator.INSTANCE = new $b0bfd0bbb97007e7$var$ArrayEqualityComparator();
$b0bfd0bbb97007e7$var$__decorate([
    $60gAE.Override
], $b0bfd0bbb97007e7$var$ArrayEqualityComparator.prototype, "hashCode", null);
$b0bfd0bbb97007e7$var$__decorate([
    $60gAE.Override
], $b0bfd0bbb97007e7$var$ArrayEqualityComparator.prototype, "equals", null);
module.exports.ArrayEqualityComparator = $b0bfd0bbb97007e7$var$ArrayEqualityComparator;

});

parcelRegister("5lo68", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toCharArray = module.exports.toMap = module.exports.equals = module.exports.join = module.exports.escapeWhitespace = void 0;
function $3e419b40b1a4e51a$var$escapeWhitespace(s, escapeSpaces) {
    return escapeSpaces ? s.replace(/ /, "\u00B7") : s.replace(/\t/, "\\t").replace(/\n/, "\\n").replace(/\r/, "\\r");
}
module.exports.escapeWhitespace = $3e419b40b1a4e51a$var$escapeWhitespace;
// Seriously: why isn't this built in to java? ugh!
function $3e419b40b1a4e51a$var$join(collection, separator) {
    let buf = "";
    let first = true;
    for (let current of collection){
        if (first) first = false;
        else buf += separator;
        buf += current;
    }
    return buf;
}
module.exports.join = $3e419b40b1a4e51a$var$join;
function $3e419b40b1a4e51a$var$equals(x, y) {
    if (x === y) return true;
    if (x === undefined || y === undefined) return false;
    return x.equals(y);
}
module.exports.equals = $3e419b40b1a4e51a$var$equals;
// export function numNonnull(data: any[]): number {
// 	let n: number =  0;
// 	if ( data == null ) return n;
// 	for (let o of data) {
// 		if ( o!=null ) n++;
// 	}
// 	return n;
// }
// export function removeAllElements<T>(data: Collection<T>, value: T): void {
// 	if ( data==null ) return;
// 	while ( data.contains(value) ) data.remove(value);
// }
// export function writeFile(@NotNull file: File, @NotNull content: Uint8Array): void {
// 	let fos: FileOutputStream = new FileOutputStream(file);
// 	try {
// 		fos.write(content);
// 	} finally {
// 		fos.close();
// 	}
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string): void {
// 	writeFile(fileName, content, null);
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string, @Nullable encoding: string): void {
// 	let f: File =  new File(fileName);
// 	let fos: FileOutputStream =  new FileOutputStream(f);
// 	let osw: OutputStreamWriter;
// 	if (encoding != null) {
// 		osw = new OutputStreamWriter(fos, encoding);
// 	}
// 	else {
// 		osw = new OutputStreamWriter(fos);
// 	}
// 	try {
// 		osw.write(content);
// 	}
// 	finally {
// 		osw.close();
// 	}
// }
// @NotNull
// export function readFile(@NotNull fileName: string): char[] {
// 	return readFile(fileName, null);
// }
// @NotNull
// export function readFile(@NotNull fileName: string, @Nullable encoding: string): char[] {
// 	let f: File =  new File(fileName);
// 	let size: number =  (int)f.length();
// 	let isr: InputStreamReader;
// 	let fis: FileInputStream =  new FileInputStream(fileName);
// 	if ( encoding!=null ) {
// 		isr = new InputStreamReader(fis, encoding);
// 	}
// 	else {
// 		isr = new InputStreamReader(fis);
// 	}
// 	let data: char[] =  null;
// 	try {
// 		data = new char[size];
// 		let n: number =  isr.read(data);
// 		if (n < data.length) {
// 			data = Arrays.copyOf(data, n);
// 		}
// 	}
// 	finally {
// 		isr.close();
// 	}
// 	return data;
// }
// export function removeAll<T>(@NotNull predicate: List<T> list,@NotNull Predicate<? super T>): void {
// 	let j: number =  0;
// 	for (let i = 0; i < list.size; i++) {
// 		let item: T =  list.get(i);
// 		if (!predicate.eval(item)) {
// 			if (j != i) {
// 				list.set(j, item);
// 			}
// 			j++;
// 		}
// 	}
// 	if (j < list.size) {
// 		list.subList(j, list.size).clear();
// 	}
// }
// export function removeAll<T>(@NotNull predicate: Iterable<T> iterable,@NotNull Predicate<? super T>): void {
// 	if (iterable instanceof List<?>) {
// 		removeAll((List<T>)iterable, predicate);
// 		return;
// 	}
// 	for (Iterator<T> iterator = iterable.iterator(); iterator.hasNext(); ) {
// 		let item: T =  iterator.next();
// 		if (predicate.eval(item)) {
// 			iterator.remove();
// 		}
// 	}
// }
/** Convert array of strings to string&rarr;index map. Useful for
 *  converting rulenames to name&rarr;ruleindex map.
 */ function $3e419b40b1a4e51a$var$toMap(keys) {
    let m = new Map();
    for(let i = 0; i < keys.length; i++)m.set(keys[i], i);
    return m;
}
module.exports.toMap = $3e419b40b1a4e51a$var$toMap;
function $3e419b40b1a4e51a$var$toCharArray(str) {
    if (typeof str === "string") {
        let result = new Uint16Array(str.length);
        for(let i = 0; i < str.length; i++)result[i] = str.charCodeAt(i);
        return result;
    } else return str.toCharArray();
}
module.exports.toCharArray = $3e419b40b1a4e51a$var$toCharArray; // /**
 // 	* @since 4.5
 // 	*/
 // @NotNull
 // export function toSet(@NotNull bits: BitSet): IntervalSet {
 // 	let s: IntervalSet =  new IntervalSet();
 // 	let i: number =  bits.nextSetBit(0);
 // 	while ( i >= 0 ) {
 // 		s.add(i);
 // 		i = bits.nextSetBit(i+1);
 // 	}
 // 	return s;
 // }

});




parcelRegister("2ITdp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1fba856925d48300$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1fba856925d48300$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InputMismatchException = void 0;

var $2XZxT = parcelRequire("2XZxT");

var $60gAE = parcelRequire("60gAE");
/** This signifies any kind of mismatched input exceptions such as
 *  when the current input does not match the expected token.
 */ let $1fba856925d48300$var$InputMismatchException = class InputMismatchException extends $2XZxT.RecognitionException {
    constructor(recognizer, state, context){
        if (context === undefined) context = recognizer.context;
        super(recognizer, recognizer.inputStream, context);
        if (state !== undefined) this.setOffendingState(state);
        this.setOffendingToken(recognizer, recognizer.currentToken);
    }
};
$1fba856925d48300$var$InputMismatchException = $1fba856925d48300$var$__decorate([
    $1fba856925d48300$var$__param(0, $60gAE.NotNull)
], $1fba856925d48300$var$InputMismatchException);
module.exports.InputMismatchException = $1fba856925d48300$var$InputMismatchException;

});

parcelRegister("fkZzb", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b2a87b1b775df43d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b2a87b1b775df43d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntervalSet = void 0;

var $faPBd = parcelRequire("faPBd");

var $jL0Xb = parcelRequire("jL0Xb");

var $312SH = parcelRequire("312SH");

var $ipeIv = parcelRequire("ipeIv");

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");

var $iLVZN = parcelRequire("iLVZN");
/**
 * This class implements the {@link IntSet} backed by a sorted array of
 * non-overlapping intervals. It is particularly efficient for representing
 * large collections of numbers, where the majority of elements appear as part
 * of a sequential range of numbers that are all part of the set. For example,
 * the set { 1, 2, 3, 4, 7, 8 } may be represented as { [1, 4], [7, 8] }.
 *
 * This class is able to represent sets containing any combination of values in
 * the range {@link Integer#MIN_VALUE} to {@link Integer#MAX_VALUE}
 * (inclusive).
 */ class $b2a87b1b775df43d$var$IntervalSet {
    constructor(intervals){
        this.readonly = false;
        if (intervals != null) this._intervals = intervals.slice(0);
        else this._intervals = [];
    }
    static get COMPLETE_CHAR_SET() {
        if ($b2a87b1b775df43d$var$IntervalSet._COMPLETE_CHAR_SET === undefined) {
            $b2a87b1b775df43d$var$IntervalSet._COMPLETE_CHAR_SET = $b2a87b1b775df43d$var$IntervalSet.of($ipeIv.Lexer.MIN_CHAR_VALUE, $ipeIv.Lexer.MAX_CHAR_VALUE);
            $b2a87b1b775df43d$var$IntervalSet._COMPLETE_CHAR_SET.setReadonly(true);
        }
        return $b2a87b1b775df43d$var$IntervalSet._COMPLETE_CHAR_SET;
    }
    static get EMPTY_SET() {
        if ($b2a87b1b775df43d$var$IntervalSet._EMPTY_SET == null) {
            $b2a87b1b775df43d$var$IntervalSet._EMPTY_SET = new $b2a87b1b775df43d$var$IntervalSet();
            $b2a87b1b775df43d$var$IntervalSet._EMPTY_SET.setReadonly(true);
        }
        return $b2a87b1b775df43d$var$IntervalSet._EMPTY_SET;
    }
    /**
     * Create a set with all ints within range [a..b] (inclusive). If b is omitted, the set contains the single element
     * a.
     */ static of(a, b = a) {
        let s = new $b2a87b1b775df43d$var$IntervalSet();
        s.add(a, b);
        return s;
    }
    clear() {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        this._intervals.length = 0;
    }
    /** Add interval; i.e., add all integers from a to b to set.
     *  If b&lt;a, do nothing.
     *  Keep list in sorted order (by left range value).
     *  If overlap, combine ranges.  For example,
     *  If this is {1..5, 10..20}, adding 6..7 yields
     *  {1..5, 6..7, 10..20}.  Adding 4..8 yields {1..8, 10..20}.
     */ add(a, b = a) {
        this.addRange($312SH.Interval.of(a, b));
    }
    // copy on write so we can cache a..a intervals and sets of that
    addRange(addition) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        //System.out.println("add "+addition+" to "+intervals.toString());
        if (addition.b < addition.a) return;
        // find position in list
        // Use iterators as we modify list in place
        for(let i = 0; i < this._intervals.length; i++){
            let r = this._intervals[i];
            if (addition.equals(r)) return;
            if (addition.adjacent(r) || !addition.disjoint(r)) {
                // next to each other, make a single larger interval
                let bigger = addition.union(r);
                this._intervals[i] = bigger;
                // make sure we didn't just create an interval that
                // should be merged with next interval in list
                while(i < this._intervals.length - 1){
                    i++;
                    let next = this._intervals[i];
                    if (!bigger.adjacent(next) && bigger.disjoint(next)) break;
                    // if we bump up against or overlap next, merge
                    // remove this one
                    this._intervals.splice(i, 1);
                    i--;
                    // move backwards to what we just set
                    this._intervals[i] = bigger.union(next);
                // set to 3 merged ones
                }
                // first call to next after previous duplicates the result
                return;
            }
            if (addition.startsBeforeDisjoint(r)) {
                // insert before r
                this._intervals.splice(i, 0, addition);
                return;
            }
        // if disjoint and after r, a future iteration will handle it
        }
        // ok, must be after last interval (and disjoint from last interval)
        // just add it
        this._intervals.push(addition);
    }
    /** combine all sets in the array returned the or'd value */ static or(sets) {
        let r = new $b2a87b1b775df43d$var$IntervalSet();
        for (let s of sets)r.addAll(s);
        return r;
    }
    addAll(set) {
        if (set == null) return this;
        if (set instanceof $b2a87b1b775df43d$var$IntervalSet) {
            let other = set;
            // walk set and add each interval
            let n = other._intervals.length;
            for(let i = 0; i < n; i++){
                let I = other._intervals[i];
                this.add(I.a, I.b);
            }
        } else for (let value of set.toArray())this.add(value);
        return this;
    }
    complementRange(minElement, maxElement) {
        return this.complement($b2a87b1b775df43d$var$IntervalSet.of(minElement, maxElement));
    }
    /** {@inheritDoc} */ complement(vocabulary) {
        if (vocabulary.isNil) // nothing in common with null set
        return $b2a87b1b775df43d$var$IntervalSet.EMPTY_SET;
        let vocabularyIS;
        if (vocabulary instanceof $b2a87b1b775df43d$var$IntervalSet) vocabularyIS = vocabulary;
        else {
            vocabularyIS = new $b2a87b1b775df43d$var$IntervalSet();
            vocabularyIS.addAll(vocabulary);
        }
        return vocabularyIS.subtract(this);
    }
    subtract(a) {
        if (a == null || a.isNil) return new $b2a87b1b775df43d$var$IntervalSet(this._intervals);
        if (a instanceof $b2a87b1b775df43d$var$IntervalSet) return $b2a87b1b775df43d$var$IntervalSet.subtract(this, a);
        let other = new $b2a87b1b775df43d$var$IntervalSet();
        other.addAll(a);
        return $b2a87b1b775df43d$var$IntervalSet.subtract(this, other);
    }
    /**
     * Compute the set difference between two interval sets. The specific
     * operation is `left - right`.
     */ static subtract(left, right) {
        if (left.isNil) return new $b2a87b1b775df43d$var$IntervalSet();
        let result = new $b2a87b1b775df43d$var$IntervalSet(left._intervals);
        if (right.isNil) // right set has no elements; just return the copy of the current set
        return result;
        let resultI = 0;
        let rightI = 0;
        while(resultI < result._intervals.length && rightI < right._intervals.length){
            let resultInterval = result._intervals[resultI];
            let rightInterval = right._intervals[rightI];
            // operation: (resultInterval - rightInterval) and update indexes
            if (rightInterval.b < resultInterval.a) {
                rightI++;
                continue;
            }
            if (rightInterval.a > resultInterval.b) {
                resultI++;
                continue;
            }
            let beforeCurrent;
            let afterCurrent;
            if (rightInterval.a > resultInterval.a) beforeCurrent = new $312SH.Interval(resultInterval.a, rightInterval.a - 1);
            if (rightInterval.b < resultInterval.b) afterCurrent = new $312SH.Interval(rightInterval.b + 1, resultInterval.b);
            if (beforeCurrent) {
                if (afterCurrent) {
                    // split the current interval into two
                    result._intervals[resultI] = beforeCurrent;
                    result._intervals.splice(resultI + 1, 0, afterCurrent);
                    resultI++;
                    rightI++;
                    continue;
                } else {
                    // replace the current interval
                    result._intervals[resultI] = beforeCurrent;
                    resultI++;
                    continue;
                }
            } else if (afterCurrent) {
                // replace the current interval
                result._intervals[resultI] = afterCurrent;
                rightI++;
                continue;
            } else {
                // remove the current interval (thus no need to increment resultI)
                result._intervals.splice(resultI, 1);
                continue;
            }
        }
        // If rightI reached right.intervals.size, no more intervals to subtract from result.
        // If resultI reached result.intervals.size, we would be subtracting from an empty set.
        // Either way, we are done.
        return result;
    }
    or(a) {
        let o = new $b2a87b1b775df43d$var$IntervalSet();
        o.addAll(this);
        o.addAll(a);
        return o;
    }
    /** {@inheritDoc} */ and(other) {
        if (other.isNil) // nothing in common with null set
        return new $b2a87b1b775df43d$var$IntervalSet();
        let myIntervals = this._intervals;
        let theirIntervals = other._intervals;
        let intersection;
        let mySize = myIntervals.length;
        let theirSize = theirIntervals.length;
        let i = 0;
        let j = 0;
        // iterate down both interval lists looking for nondisjoint intervals
        while(i < mySize && j < theirSize){
            let mine = myIntervals[i];
            let theirs = theirIntervals[j];
            //System.out.println("mine="+mine+" and theirs="+theirs);
            if (mine.startsBeforeDisjoint(theirs)) // move this iterator looking for interval that might overlap
            i++;
            else if (theirs.startsBeforeDisjoint(mine)) // move other iterator looking for interval that might overlap
            j++;
            else if (mine.properlyContains(theirs)) {
                // overlap, add intersection, get next theirs
                if (!intersection) intersection = new $b2a87b1b775df43d$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                j++;
            } else if (theirs.properlyContains(mine)) {
                // overlap, add intersection, get next mine
                if (!intersection) intersection = new $b2a87b1b775df43d$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                i++;
            } else if (!mine.disjoint(theirs)) {
                // overlap, add intersection
                if (!intersection) intersection = new $b2a87b1b775df43d$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                // Move the iterator of lower range [a..b], but not
                // the upper range as it may contain elements that will collide
                // with the next iterator. So, if mine=[0..115] and
                // theirs=[115..200], then intersection is 115 and move mine
                // but not theirs as theirs may collide with the next range
                // in thisIter.
                // move both iterators to next ranges
                if (mine.startsAfterNonDisjoint(theirs)) j++;
                else if (theirs.startsAfterNonDisjoint(mine)) i++;
            }
        }
        if (!intersection) return new $b2a87b1b775df43d$var$IntervalSet();
        return intersection;
    }
    /** {@inheritDoc} */ contains(el) {
        let n = this._intervals.length;
        let l = 0;
        let r = n - 1;
        // Binary search for the element in the (sorted, disjoint) array of intervals.
        while(l <= r){
            let m = l + r >> 1;
            let I = this._intervals[m];
            let a = I.a;
            let b = I.b;
            if (b < el) l = m + 1;
            else if (a > el) r = m - 1;
            else // el >= a && el <= b
            return true;
        }
        return false;
    }
    /** {@inheritDoc} */ get isNil() {
        return this._intervals == null || this._intervals.length === 0;
    }
    /**
     * Returns the maximum value contained in the set if not isNil.
     *
     * @return the maximum value contained in the set.
     * @throws RangeError if set is empty
     */ get maxElement() {
        if (this.isNil) throw new RangeError("set is empty");
        let last = this._intervals[this._intervals.length - 1];
        return last.b;
    }
    /**
     * Returns the minimum value contained in the set if not isNil.
     *
     * @return the minimum value contained in the set.
     * @throws RangeError if set is empty
     */ get minElement() {
        if (this.isNil) throw new RangeError("set is empty");
        return this._intervals[0].a;
    }
    /** Return a list of Interval objects. */ get intervals() {
        return this._intervals;
    }
    hashCode() {
        let hash = $ecbo5.MurmurHash.initialize();
        for (let I of this._intervals){
            hash = $ecbo5.MurmurHash.update(hash, I.a);
            hash = $ecbo5.MurmurHash.update(hash, I.b);
        }
        hash = $ecbo5.MurmurHash.finish(hash, this._intervals.length * 2);
        return hash;
    }
    /** Are two IntervalSets equal?  Because all intervals are sorted
     *  and disjoint, equals is a simple linear walk over both lists
     *  to make sure they are the same.  Interval.equals() is used
     *  by the List.equals() method to check the ranges.
     */ equals(o) {
        if (o == null || !(o instanceof $b2a87b1b775df43d$var$IntervalSet)) return false;
        return $faPBd.ArrayEqualityComparator.INSTANCE.equals(this._intervals, o._intervals);
    }
    toString(elemAreChar = false) {
        let buf = "";
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) {
                if (a === $iLVZN.Token.EOF) buf += "<EOF>";
                else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'";
                else buf += a;
            } else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'..'" + String.fromCodePoint(b) + "'";
            else buf += a + ".." + b;
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    toStringVocabulary(vocabulary) {
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        let buf = "";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) buf += this.elementName(vocabulary, a);
            else for(let i = a; i <= b; i++){
                if (i > a) buf += ", ";
                buf += this.elementName(vocabulary, i);
            }
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    elementName(vocabulary, a) {
        if (a === $iLVZN.Token.EOF) return "<EOF>";
        else if (a === $iLVZN.Token.EPSILON) return "<EPSILON>";
        else return vocabulary.getDisplayName(a);
    }
    get size() {
        let n = 0;
        let numIntervals = this._intervals.length;
        if (numIntervals === 1) {
            let firstInterval = this._intervals[0];
            return firstInterval.b - firstInterval.a + 1;
        }
        for(let i = 0; i < numIntervals; i++){
            let I = this._intervals[i];
            n += I.b - I.a + 1;
        }
        return n;
    }
    toIntegerList() {
        let values = new $jL0Xb.IntegerList(this.size);
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.add(v);
        }
        return values;
    }
    toSet() {
        let s = new Set();
        for (let I of this._intervals){
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)s.add(v);
        }
        return s;
    }
    toArray() {
        let values = new Array();
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.push(v);
        }
        return values;
    }
    remove(el) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            if (el < a) break; // list is sorted and el is before this interval; not here
            // if whole interval x..x, rm
            if (el === a && el === b) {
                this._intervals.splice(i, 1);
                break;
            }
            // if on left edge x..b, adjust left
            if (el === a) {
                this._intervals[i] = $312SH.Interval.of(I.a + 1, I.b);
                break;
            }
            // if on right edge a..x, adjust right
            if (el === b) {
                this._intervals[i] = $312SH.Interval.of(I.a, I.b - 1);
                break;
            }
            // if in middle a..x..b, split interval
            if (el > a && el < b) {
                let oldb = I.b;
                this._intervals[i] = $312SH.Interval.of(I.a, el - 1); // [a..x-1]
                this.add(el + 1, oldb); // add [x+1..b]
            }
        }
    }
    get isReadonly() {
        return this.readonly;
    }
    setReadonly(readonly) {
        if (this.readonly && !readonly) throw new Error("can't alter readonly IntervalSet");
        this.readonly = readonly;
    }
}
$b2a87b1b775df43d$var$__decorate([
    $60gAE.Override
], $b2a87b1b775df43d$var$IntervalSet.prototype, "addAll", null);
$b2a87b1b775df43d$var$__decorate([
    $60gAE.Override
], $b2a87b1b775df43d$var$IntervalSet.prototype, "complement", null);
$b2a87b1b775df43d$var$__decorate([
    $60gAE.Override
], $b2a87b1b775df43d$var$IntervalSet.prototype, "subtract", null);
$b2a87b1b775df43d$var$__decorate([
    $60gAE.Override
], $b2a87b1b775df43d$var$IntervalSet.prototype, "or", null);
$b2a87b1b775df43d$var$__decorate([
    $60gAE.Override
], $b2a87b1b775df43d$var$IntervalSet.prototype, "and", null);
$b2a87b1b775df43d$var$__decorate([
    $60gAE.Override
], $b2a87b1b775df43d$var$IntervalSet.prototype, "contains", null);
$b2a87b1b775df43d$var$__decorate([
    $60gAE.Override
], $b2a87b1b775df43d$var$IntervalSet.prototype, "isNil", null);
$b2a87b1b775df43d$var$__decorate([
    $60gAE.Override
], $b2a87b1b775df43d$var$IntervalSet.prototype, "hashCode", null);
$b2a87b1b775df43d$var$__decorate([
    $60gAE.Override
], $b2a87b1b775df43d$var$IntervalSet.prototype, "equals", null);
$b2a87b1b775df43d$var$__decorate([
    $b2a87b1b775df43d$var$__param(0, $60gAE.NotNull)
], $b2a87b1b775df43d$var$IntervalSet.prototype, "toStringVocabulary", null);
$b2a87b1b775df43d$var$__decorate([
    $60gAE.NotNull,
    $b2a87b1b775df43d$var$__param(0, $60gAE.NotNull)
], $b2a87b1b775df43d$var$IntervalSet.prototype, "elementName", null);
$b2a87b1b775df43d$var$__decorate([
    $60gAE.Override
], $b2a87b1b775df43d$var$IntervalSet.prototype, "size", null);
$b2a87b1b775df43d$var$__decorate([
    $60gAE.Override
], $b2a87b1b775df43d$var$IntervalSet.prototype, "remove", null);
$b2a87b1b775df43d$var$__decorate([
    $60gAE.NotNull
], $b2a87b1b775df43d$var$IntervalSet, "of", null);
$b2a87b1b775df43d$var$__decorate([
    $60gAE.NotNull
], $b2a87b1b775df43d$var$IntervalSet, "subtract", null);
module.exports.IntervalSet = $b2a87b1b775df43d$var$IntervalSet;

});
parcelRegister("jL0Xb", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e6232575087e86d9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerList = void 0;

var $5Zd5d = parcelRequire("5Zd5d");

var $60gAE = parcelRequire("60gAE");
const $e6232575087e86d9$var$EMPTY_DATA = new Int32Array(0);
const $e6232575087e86d9$var$INITIAL_SIZE = 4;
const $e6232575087e86d9$var$MAX_ARRAY_SIZE = 2147483639;
/**
 *
 * @author Sam Harwell
 */ class $e6232575087e86d9$var$IntegerList {
    constructor(arg){
        if (!arg) {
            this._data = $e6232575087e86d9$var$EMPTY_DATA;
            this._size = 0;
        } else if (arg instanceof $e6232575087e86d9$var$IntegerList) {
            this._data = arg._data.slice(0);
            this._size = arg._size;
        } else if (typeof arg === "number") {
            if (arg === 0) {
                this._data = $e6232575087e86d9$var$EMPTY_DATA;
                this._size = 0;
            } else {
                this._data = new Int32Array(arg);
                this._size = 0;
            }
        } else {
            // arg is Iterable<number>
            this._data = $e6232575087e86d9$var$EMPTY_DATA;
            this._size = 0;
            for (let value of arg)this.add(value);
        }
    }
    add(value) {
        if (this._data.length === this._size) this.ensureCapacity(this._size + 1);
        this._data[this._size] = value;
        this._size++;
    }
    addAll(list) {
        if (Array.isArray(list)) {
            this.ensureCapacity(this._size + list.length);
            this._data.subarray(this._size, this._size + list.length).set(list);
            this._size += list.length;
        } else if (list instanceof $e6232575087e86d9$var$IntegerList) {
            this.ensureCapacity(this._size + list._size);
            this._data.subarray(this._size, this._size + list.size).set(list._data);
            this._size += list._size;
        } else {
            // list is JavaCollection<number>
            this.ensureCapacity(this._size + list.size);
            let current = 0;
            for (let xi of list){
                this._data[this._size + current] = xi;
                current++;
            }
            this._size += list.size;
        }
    }
    get(index) {
        if (index < 0 || index >= this._size) throw RangeError();
        return this._data[index];
    }
    contains(value) {
        for(let i = 0; i < this._size; i++){
            if (this._data[i] === value) return true;
        }
        return false;
    }
    set(index, value) {
        if (index < 0 || index >= this._size) throw RangeError();
        let previous = this._data[index];
        this._data[index] = value;
        return previous;
    }
    removeAt(index) {
        let value = this.get(index);
        this._data.copyWithin(index, index + 1, this._size);
        this._data[this._size - 1] = 0;
        this._size--;
        return value;
    }
    removeRange(fromIndex, toIndex) {
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw RangeError();
        if (fromIndex > toIndex) throw RangeError();
        this._data.copyWithin(toIndex, fromIndex, this._size);
        this._data.fill(0, this._size - (toIndex - fromIndex), this._size);
        this._size -= toIndex - fromIndex;
    }
    get isEmpty() {
        return this._size === 0;
    }
    get size() {
        return this._size;
    }
    trimToSize() {
        if (this._data.length === this._size) return;
        this._data = this._data.slice(0, this._size);
    }
    clear() {
        this._data.fill(0, 0, this._size);
        this._size = 0;
    }
    toArray() {
        if (this._size === 0) return [];
        return Array.from(this._data.subarray(0, this._size));
    }
    sort() {
        this._data.subarray(0, this._size).sort();
    }
    /**
     * Compares the specified object with this list for equality.  Returns
     * `true` if and only if the specified object is also an {@link IntegerList},
     * both lists have the same size, and all corresponding pairs of elements in
     * the two lists are equal.  In other words, two lists are defined to be
     * equal if they contain the same elements in the same order.
     *
     * This implementation first checks if the specified object is this
     * list. If so, it returns `true`; if not, it checks if the
     * specified object is an {@link IntegerList}. If not, it returns `false`;
     * if so, it checks the size of both lists. If the lists are not the same size,
     * it returns `false`; otherwise it iterates over both lists, comparing
     * corresponding pairs of elements.  If any comparison returns `false`,
     * this method returns `false`.
     *
     * @param o the object to be compared for equality with this list
     * @returns `true` if the specified object is equal to this list
     */ equals(o) {
        if (o === this) return true;
        if (!(o instanceof $e6232575087e86d9$var$IntegerList)) return false;
        if (this._size !== o._size) return false;
        for(let i = 0; i < this._size; i++){
            if (this._data[i] !== o._data[i]) return false;
        }
        return true;
    }
    /**
     * Returns the hash code value for this list.
     *
     * This implementation uses exactly the code that is used to define the
     * list hash function in the documentation for the {@link List#hashCode}
     * method.
     *
     * @returns the hash code value for this list
     */ hashCode() {
        let hashCode = 1;
        for(let i = 0; i < this._size; i++)hashCode = 31 * hashCode + this._data[i];
        return hashCode;
    }
    /**
     * Returns a string representation of this list.
     */ toString() {
        return this._data.toString();
    }
    binarySearch(key, fromIndex, toIndex) {
        if (fromIndex === undefined) fromIndex = 0;
        if (toIndex === undefined) toIndex = this._size;
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw new RangeError();
        if (fromIndex > toIndex) throw new RangeError();
        return $5Zd5d.Arrays.binarySearch(this._data, key, fromIndex, toIndex);
    }
    ensureCapacity(capacity) {
        if (capacity < 0 || capacity > $e6232575087e86d9$var$MAX_ARRAY_SIZE) throw new RangeError();
        let newLength;
        if (this._data.length === 0) newLength = $e6232575087e86d9$var$INITIAL_SIZE;
        else newLength = this._data.length;
        while(newLength < capacity){
            newLength = newLength * 2;
            if (newLength < 0 || newLength > $e6232575087e86d9$var$MAX_ARRAY_SIZE) newLength = $e6232575087e86d9$var$MAX_ARRAY_SIZE;
        }
        let tmp = new Int32Array(newLength);
        tmp.set(this._data);
        this._data = tmp;
    }
    /** Convert the list to a UTF-16 encoded char array. If all values are less
     *  than the 0xFFFF 16-bit code point limit then this is just a char array
     *  of 16-bit char as usual. For values in the supplementary range, encode
     * them as two UTF-16 code units.
     */ toCharArray() {
        // Optimize for the common case (all data values are < 0xFFFF) to avoid an extra scan
        let resultArray = new Uint16Array(this._size);
        let resultIdx = 0;
        let calculatedPreciseResultSize = false;
        for(let i = 0; i < this._size; i++){
            let codePoint = this._data[i];
            if (codePoint >= 0 && codePoint < 0x10000) {
                resultArray[resultIdx] = codePoint;
                resultIdx++;
                continue;
            }
            // Calculate the precise result size if we encounter a code point > 0xFFFF
            if (!calculatedPreciseResultSize) {
                let newResultArray = new Uint16Array(this.charArraySize());
                newResultArray.set(resultArray, 0);
                resultArray = newResultArray;
                calculatedPreciseResultSize = true;
            }
            // This will throw RangeError if the code point is not a valid Unicode code point
            let pair = String.fromCodePoint(codePoint);
            resultArray[resultIdx] = pair.charCodeAt(0);
            resultArray[resultIdx + 1] = pair.charCodeAt(1);
            resultIdx += 2;
        }
        return resultArray;
    }
    charArraySize() {
        let result = 0;
        for(let i = 0; i < this._size; i++)result += this._data[i] >= 0x10000 ? 2 : 1;
        return result;
    }
}
$e6232575087e86d9$var$__decorate([
    $60gAE.NotNull
], $e6232575087e86d9$var$IntegerList.prototype, "_data", void 0);
$e6232575087e86d9$var$__decorate([
    $60gAE.Override
], $e6232575087e86d9$var$IntegerList.prototype, "equals", null);
$e6232575087e86d9$var$__decorate([
    $60gAE.Override
], $e6232575087e86d9$var$IntegerList.prototype, "hashCode", null);
$e6232575087e86d9$var$__decorate([
    $60gAE.Override
], $e6232575087e86d9$var$IntegerList.prototype, "toString", null);
module.exports.IntegerList = $e6232575087e86d9$var$IntegerList;

});
parcelRegister("5Zd5d", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Arrays = void 0;
var $45bccc4b5a8d51f0$var$Arrays;
(function(Arrays) {
    /**
     * Searches the specified array of numbers for the specified value using the binary search algorithm. The array must
     * be sorted prior to making this call. If it is not sorted, the results are unspecified. If the array contains
     * multiple elements with the specified value, there is no guarantee which one will be found.
     *
     * @returns index of the search key, if it is contained in the array; otherwise, (-(insertion point) - 1). The
     * insertion point is defined as the point at which the key would be inserted into the array: the index of the first
     * element greater than the key, or array.length if all elements in the array are less than the specified key. Note
     * that this guarantees that the return value will be >= 0 if and only if the key is found.
     */ function binarySearch(array, key, fromIndex, toIndex) {
        return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
    }
    Arrays.binarySearch = binarySearch;
    function binarySearch0(array, fromIndex, toIndex, key) {
        let low = fromIndex;
        let high = toIndex - 1;
        while(low <= high){
            let mid = low + high >>> 1;
            let midVal = array[mid];
            if (midVal < key) low = mid + 1;
            else if (midVal > key) high = mid - 1;
            else // key found
            return mid;
        }
        // key not found.
        return -(low + 1);
    }
    function toString(array) {
        let result = "[";
        let first = true;
        for (let element of array){
            if (first) first = false;
            else result += ", ";
            if (element === null) result += "null";
            else if (element === undefined) result += "undefined";
            else result += element;
        }
        result += "]";
        return result;
    }
    Arrays.toString = toString;
})($45bccc4b5a8d51f0$var$Arrays = module.exports.Arrays || (module.exports.Arrays = {}));

});


parcelRegister("312SH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2323b33b8e38d921$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Interval = void 0;

var $60gAE = parcelRequire("60gAE");
const $2323b33b8e38d921$var$INTERVAL_POOL_MAX_VALUE = 1000;
/** An immutable inclusive interval a..b */ class $2323b33b8e38d921$var$Interval {
    /**
     * @param a The start of the interval
     * @param b The end of the interval (inclusive)
     */ constructor(a, b){
        this.a = a;
        this.b = b;
    }
    static get INVALID() {
        return $2323b33b8e38d921$var$Interval._INVALID;
    }
    /** Interval objects are used readonly so share all with the
     *  same single value a==b up to some max size.  Use an array as a perfect hash.
     *  Return shared object for 0..INTERVAL_POOL_MAX_VALUE or a new
     *  Interval object with a..a in it.  On Java.g4, 218623 IntervalSets
     *  have a..a (set with 1 element).
     */ static of(a, b) {
        // cache just a..a
        if (a !== b || a < 0 || a > $2323b33b8e38d921$var$INTERVAL_POOL_MAX_VALUE) return new $2323b33b8e38d921$var$Interval(a, b);
        if ($2323b33b8e38d921$var$Interval.cache[a] == null) $2323b33b8e38d921$var$Interval.cache[a] = new $2323b33b8e38d921$var$Interval(a, a);
        return $2323b33b8e38d921$var$Interval.cache[a];
    }
    /** return number of elements between a and b inclusively. x..x is length 1.
     *  if b &lt; a, then length is 0.  9..10 has length 2.
     */ get length() {
        if (this.b < this.a) return 0;
        return this.b - this.a + 1;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof $2323b33b8e38d921$var$Interval)) return false;
        return this.a === o.a && this.b === o.b;
    }
    hashCode() {
        let hash = 23;
        hash = hash * 31 + this.a;
        hash = hash * 31 + this.b;
        return hash;
    }
    /** Does this start completely before other? Disjoint */ startsBeforeDisjoint(other) {
        return this.a < other.a && this.b < other.a;
    }
    /** Does this start at or before other? Nondisjoint */ startsBeforeNonDisjoint(other) {
        return this.a <= other.a && this.b >= other.a;
    }
    /** Does this.a start after other.b? May or may not be disjoint */ startsAfter(other) {
        return this.a > other.a;
    }
    /** Does this start completely after other? Disjoint */ startsAfterDisjoint(other) {
        return this.a > other.b;
    }
    /** Does this start after other? NonDisjoint */ startsAfterNonDisjoint(other) {
        return this.a > other.a && this.a <= other.b; // this.b>=other.b implied
    }
    /** Are both ranges disjoint? I.e., no overlap? */ disjoint(other) {
        return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
    }
    /** Are two intervals adjacent such as 0..41 and 42..42? */ adjacent(other) {
        return this.a === other.b + 1 || this.b === other.a - 1;
    }
    properlyContains(other) {
        return other.a >= this.a && other.b <= this.b;
    }
    /** Return the interval computed from combining this and other */ union(other) {
        return $2323b33b8e38d921$var$Interval.of(Math.min(this.a, other.a), Math.max(this.b, other.b));
    }
    /** Return the interval in common between this and o */ intersection(other) {
        return $2323b33b8e38d921$var$Interval.of(Math.max(this.a, other.a), Math.min(this.b, other.b));
    }
    /** Return the interval with elements from `this` not in `other`;
     *  `other` must not be totally enclosed (properly contained)
     *  within `this`, which would result in two disjoint intervals
     *  instead of the single one returned by this method.
     */ differenceNotProperlyContained(other) {
        let diff;
        if (other.startsBeforeNonDisjoint(this)) // other.a to left of this.a (or same)
        diff = $2323b33b8e38d921$var$Interval.of(Math.max(this.a, other.b + 1), this.b);
        else if (other.startsAfterNonDisjoint(this)) // other.a to right of this.a
        diff = $2323b33b8e38d921$var$Interval.of(this.a, other.a - 1);
        return diff;
    }
    toString() {
        return this.a + ".." + this.b;
    }
}
$2323b33b8e38d921$var$Interval._INVALID = new $2323b33b8e38d921$var$Interval(-1, -2);
$2323b33b8e38d921$var$Interval.cache = new Array($2323b33b8e38d921$var$INTERVAL_POOL_MAX_VALUE + 1);
$2323b33b8e38d921$var$__decorate([
    $60gAE.Override
], $2323b33b8e38d921$var$Interval.prototype, "equals", null);
$2323b33b8e38d921$var$__decorate([
    $60gAE.Override
], $2323b33b8e38d921$var$Interval.prototype, "hashCode", null);
$2323b33b8e38d921$var$__decorate([
    $60gAE.Override
], $2323b33b8e38d921$var$Interval.prototype, "toString", null);
module.exports.Interval = $2323b33b8e38d921$var$Interval;

});

parcelRegister("ipeIv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d665fa3ba8dcebfa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Lexer = void 0;

var $fnPjW = parcelRequire("fnPjW");

var $i8JNJ = parcelRequire("i8JNJ");

var $312SH = parcelRequire("312SH");

var $hPLPA = parcelRequire("hPLPA");

var $7yK40 = parcelRequire("7yK40");

var $hqoEr = parcelRequire("hqoEr");

var $60gAE = parcelRequire("60gAE");

var $dlP2K = parcelRequire("dlP2K");

var $iLVZN = parcelRequire("iLVZN");
/** A lexer is recognizer that draws input symbols from a character stream.
 *  lexer grammars result in a subclass of this object. A Lexer object
 *  uses simplified match() and error recovery mechanisms in the interest
 *  of speed.
 */ class $d665fa3ba8dcebfa$var$Lexer extends $dlP2K.Recognizer {
    constructor(input){
        super();
        /** How to create token objects */ this._factory = $fnPjW.CommonTokenFactory.DEFAULT;
        /** What character index in the stream did the current token start at?
         *  Needed, for example, to get the text for current token.  Set at
         *  the start of nextToken.
         */ this._tokenStartCharIndex = -1;
        /** The line on which the first character of the token resides */ this._tokenStartLine = 0;
        /** The character position of first character within the line */ this._tokenStartCharPositionInLine = 0;
        /** Once we see EOF on char stream, next token will be EOF.
         *  If you have DONE : EOF ; then you see DONE EOF.
         */ this._hitEOF = false;
        /** The channel number for the current token */ this._channel = 0;
        /** The token type for the current token */ this._type = 0;
        this._modeStack = new $i8JNJ.IntegerStack();
        this._mode = $d665fa3ba8dcebfa$var$Lexer.DEFAULT_MODE;
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: input
        };
    }
    static get DEFAULT_TOKEN_CHANNEL() {
        return $iLVZN.Token.DEFAULT_CHANNEL;
    }
    static get HIDDEN() {
        return $iLVZN.Token.HIDDEN_CHANNEL;
    }
    reset(resetInput) {
        // wack Lexer state variables
        if (resetInput === undefined || resetInput) this._input.seek(0); // rewind the input
        this._token = undefined;
        this._type = $iLVZN.Token.INVALID_TYPE;
        this._channel = $iLVZN.Token.DEFAULT_CHANNEL;
        this._tokenStartCharIndex = -1;
        this._tokenStartCharPositionInLine = -1;
        this._tokenStartLine = -1;
        this._text = undefined;
        this._hitEOF = false;
        this._mode = $d665fa3ba8dcebfa$var$Lexer.DEFAULT_MODE;
        this._modeStack.clear();
        this.interpreter.reset();
    }
    /** Return a token from this source; i.e., match a token on the char
     *  stream.
     */ nextToken() {
        if (this._input == null) throw new Error("nextToken requires a non-null input stream.");
        // Mark start location in char stream so unbuffered streams are
        // guaranteed at least have text of current token
        let tokenStartMarker = this._input.mark();
        try {
            outer: while(true){
                if (this._hitEOF) return this.emitEOF();
                this._token = undefined;
                this._channel = $iLVZN.Token.DEFAULT_CHANNEL;
                this._tokenStartCharIndex = this._input.index;
                this._tokenStartCharPositionInLine = this.interpreter.charPositionInLine;
                this._tokenStartLine = this.interpreter.line;
                this._text = undefined;
                do {
                    this._type = $iLVZN.Token.INVALID_TYPE;
                    //				System.out.println("nextToken line "+tokenStartLine+" at "+((char)input.LA(1))+
                    //								   " in mode "+mode+
                    //								   " at index "+input.index);
                    let ttype;
                    try {
                        ttype = this.interpreter.match(this._input, this._mode);
                    } catch (e) {
                        if (e instanceof $hqoEr.LexerNoViableAltException) {
                            this.notifyListeners(e); // report error
                            this.recover(e);
                            ttype = $d665fa3ba8dcebfa$var$Lexer.SKIP;
                        } else throw e;
                    }
                    if (this._input.LA(1) === $hPLPA.IntStream.EOF) this._hitEOF = true;
                    if (this._type === $iLVZN.Token.INVALID_TYPE) this._type = ttype;
                    if (this._type === $d665fa3ba8dcebfa$var$Lexer.SKIP) continue outer;
                }while (this._type === $d665fa3ba8dcebfa$var$Lexer.MORE);
                if (this._token == null) return this.emit();
                return this._token;
            }
        } finally{
            // make sure we release marker after match or
            // unbuffered char stream will keep buffering
            this._input.release(tokenStartMarker);
        }
    }
    /** Instruct the lexer to skip creating a token for current lexer rule
     *  and look for another token.  nextToken() knows to keep looking when
     *  a lexer rule finishes with token set to SKIP_TOKEN.  Recall that
     *  if token==undefined at end of any token rule, it creates one for you
     *  and emits it.
     */ skip() {
        this._type = $d665fa3ba8dcebfa$var$Lexer.SKIP;
    }
    more() {
        this._type = $d665fa3ba8dcebfa$var$Lexer.MORE;
    }
    mode(m) {
        this._mode = m;
    }
    pushMode(m) {
        if ($7yK40.LexerATNSimulator.debug) console.log("pushMode " + m);
        this._modeStack.push(this._mode);
        this.mode(m);
    }
    popMode() {
        if (this._modeStack.isEmpty) throw new Error("EmptyStackException");
        if ($7yK40.LexerATNSimulator.debug) console.log("popMode back to " + this._modeStack.peek());
        this.mode(this._modeStack.pop());
        return this._mode;
    }
    get tokenFactory() {
        return this._factory;
    }
    // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the char stream and reset the lexer */ set inputStream(input) {
        this.reset(false);
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: this._input
        };
    }
    get sourceName() {
        return this._input.sourceName;
    }
    emit(token) {
        if (!token) token = this._factory.create(this._tokenFactorySourcePair, this._type, this._text, this._channel, this._tokenStartCharIndex, this.charIndex - 1, this._tokenStartLine, this._tokenStartCharPositionInLine);
        this._token = token;
        return token;
    }
    emitEOF() {
        let cpos = this.charPositionInLine;
        let line = this.line;
        let eof = this._factory.create(this._tokenFactorySourcePair, $iLVZN.Token.EOF, undefined, $iLVZN.Token.DEFAULT_CHANNEL, this._input.index, this._input.index - 1, line, cpos);
        this.emit(eof);
        return eof;
    }
    get line() {
        return this.interpreter.line;
    }
    set line(line) {
        this.interpreter.line = line;
    }
    get charPositionInLine() {
        return this.interpreter.charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this.interpreter.charPositionInLine = charPositionInLine;
    }
    /** What is the index of the current character of lookahead? */ get charIndex() {
        return this._input.index;
    }
    /** Return the text matched so far for the current token or any
     *  text override.
     */ get text() {
        if (this._text != null) return this._text;
        return this.interpreter.getText(this._input);
    }
    /** Set the complete text of this token; it wipes any previous
     *  changes to the text.
     */ set text(text) {
        this._text = text;
    }
    /** Override if emitting multiple tokens. */ get token() {
        return this._token;
    }
    set token(_token) {
        this._token = _token;
    }
    set type(ttype) {
        this._type = ttype;
    }
    get type() {
        return this._type;
    }
    set channel(channel) {
        this._channel = channel;
    }
    get channel() {
        return this._channel;
    }
    /** Return a list of all Token objects in input char stream.
     *  Forces load of all tokens. Does not include EOF token.
     */ getAllTokens() {
        let tokens = [];
        let t = this.nextToken();
        while(t.type !== $iLVZN.Token.EOF){
            tokens.push(t);
            t = this.nextToken();
        }
        return tokens;
    }
    notifyListeners(e) {
        let text = this._input.getText($312SH.Interval.of(this._tokenStartCharIndex, this._input.index));
        let msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, undefined, this._tokenStartLine, this._tokenStartCharPositionInLine, msg, e);
    }
    getErrorDisplay(s) {
        if (typeof s === "number") {
            switch(s){
                case $iLVZN.Token.EOF:
                    return "<EOF>";
                case 0x0a:
                    return "\\n";
                case 0x09:
                    return "\\t";
                case 0x0d:
                    return "\\r";
            }
            return String.fromCharCode(s);
        }
        return s.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
    }
    getCharErrorDisplay(c) {
        let s = this.getErrorDisplay(c);
        return "'" + s + "'";
    }
    recover(re) {
        if (re instanceof $hqoEr.LexerNoViableAltException) {
            if (this._input.LA(1) !== $hPLPA.IntStream.EOF) // skip a char and try again
            this.interpreter.consume(this._input);
        } else //System.out.println("consuming char "+(char)input.LA(1)+" during recovery");
        //re.printStackTrace();
        // TODO: Do we lose character or line position information?
        this._input.consume();
    }
}
$d665fa3ba8dcebfa$var$Lexer.DEFAULT_MODE = 0;
$d665fa3ba8dcebfa$var$Lexer.MORE = -2;
$d665fa3ba8dcebfa$var$Lexer.SKIP = -3;
$d665fa3ba8dcebfa$var$Lexer.MIN_CHAR_VALUE = 0x0000;
$d665fa3ba8dcebfa$var$Lexer.MAX_CHAR_VALUE = 0x10FFFF;
$d665fa3ba8dcebfa$var$__decorate([
    $60gAE.Override
], $d665fa3ba8dcebfa$var$Lexer.prototype, "nextToken", null);
$d665fa3ba8dcebfa$var$__decorate([
    $60gAE.Override
], $d665fa3ba8dcebfa$var$Lexer.prototype, "tokenFactory", null);
$d665fa3ba8dcebfa$var$__decorate([
    $60gAE.Override
], $d665fa3ba8dcebfa$var$Lexer.prototype, "inputStream", null);
$d665fa3ba8dcebfa$var$__decorate([
    $60gAE.Override
], $d665fa3ba8dcebfa$var$Lexer.prototype, "sourceName", null);
$d665fa3ba8dcebfa$var$__decorate([
    $60gAE.Override
], $d665fa3ba8dcebfa$var$Lexer.prototype, "line", null);
$d665fa3ba8dcebfa$var$__decorate([
    $60gAE.Override
], $d665fa3ba8dcebfa$var$Lexer.prototype, "charPositionInLine", null);
module.exports.Lexer = $d665fa3ba8dcebfa$var$Lexer;

});
parcelRegister("fnPjW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b330d03151793b15$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenFactory = void 0;

var $boV1Q = parcelRequire("boV1Q");

var $312SH = parcelRequire("312SH");

var $60gAE = parcelRequire("60gAE");
/**
 * This default implementation of {@link TokenFactory} creates
 * {@link CommonToken} objects.
 */ class $b330d03151793b15$var$CommonTokenFactory {
    /**
     * Constructs a {@link CommonTokenFactory} with the specified value for
     * {@link #copyText}.
     *
     * When `copyText` is `false`, the {@link #DEFAULT} instance
     * should be used instead of constructing a new instance.
     *
     * @param copyText The value for {@link #copyText}.
     */ constructor(copyText = false){
        this.copyText = copyText;
    }
    create(source, type, text, channel, start, stop, line, charPositionInLine) {
        let t = new $boV1Q.CommonToken(type, text, source, channel, start, stop);
        t.line = line;
        t.charPositionInLine = charPositionInLine;
        if (text == null && this.copyText && source.stream != null) t.text = source.stream.getText($312SH.Interval.of(start, stop));
        return t;
    }
    createSimple(type, text) {
        return new $boV1Q.CommonToken(type, text);
    }
}
$b330d03151793b15$var$__decorate([
    $60gAE.Override
], $b330d03151793b15$var$CommonTokenFactory.prototype, "create", null);
$b330d03151793b15$var$__decorate([
    $60gAE.Override
], $b330d03151793b15$var$CommonTokenFactory.prototype, "createSimple", null);
module.exports.CommonTokenFactory = $b330d03151793b15$var$CommonTokenFactory;
(function(CommonTokenFactory) {
    /**
     * The default {@link CommonTokenFactory} instance.
     *
     * This token factory does not explicitly copy token text when constructing
     * tokens.
     */ CommonTokenFactory.DEFAULT = new CommonTokenFactory();
})($b330d03151793b15$var$CommonTokenFactory = module.exports.CommonTokenFactory || (module.exports.CommonTokenFactory = {}));

});
parcelRegister("boV1Q", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $84ce2c554805800d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $84ce2c554805800d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonToken = void 0;

var $312SH = parcelRequire("312SH");

var $60gAE = parcelRequire("60gAE");

var $iLVZN = parcelRequire("iLVZN");
let $84ce2c554805800d$var$CommonToken = class CommonToken {
    constructor(type, text, source = CommonToken.EMPTY_SOURCE, channel = $iLVZN.Token.DEFAULT_CHANNEL, start = 0, stop = 0){
        /**
         * This is the backing field for {@link #getLine} and {@link #setLine}.
         */ this._line = 0;
        /**
         * This is the backing field for {@link #getCharPositionInLine} and
         * {@link #setCharPositionInLine}.
         */ this._charPositionInLine = -1; // set to invalid position
        /**
         * This is the backing field for {@link #getChannel} and
         * {@link #setChannel}.
         */ this._channel = $iLVZN.Token.DEFAULT_CHANNEL;
        /**
         * This is the backing field for `tokenIndex`.
         */ this.index = -1;
        this._text = text;
        this._type = type;
        this.source = source;
        this._channel = channel;
        this.start = start;
        this.stop = stop;
        if (source.source != null) {
            this._line = source.source.line;
            this._charPositionInLine = source.source.charPositionInLine;
        }
    }
    /**
     * Constructs a new {@link CommonToken} as a copy of another {@link Token}.
     *
     * If `oldToken` is also a {@link CommonToken} instance, the newly
     * constructed token will share a reference to the {@link #text} field and
     * the {@link Tuple2} stored in {@link #source}. Otherwise, {@link #text} will
     * be assigned the result of calling {@link #getText}, and {@link #source}
     * will be constructed from the result of {@link Token#getTokenSource} and
     * {@link Token#getInputStream}.
     *
     * @param oldToken The token to copy.
     */ static fromToken(oldToken) {
        let result = new CommonToken(oldToken.type, undefined, CommonToken.EMPTY_SOURCE, oldToken.channel, oldToken.startIndex, oldToken.stopIndex);
        result._line = oldToken.line;
        result.index = oldToken.tokenIndex;
        result._charPositionInLine = oldToken.charPositionInLine;
        if (oldToken instanceof CommonToken) {
            result._text = oldToken._text;
            result.source = oldToken.source;
        } else {
            result._text = oldToken.text;
            result.source = {
                source: oldToken.tokenSource,
                stream: oldToken.inputStream
            };
        }
        return result;
    }
    get type() {
        return this._type;
    }
    // @Override
    set type(type) {
        this._type = type;
    }
    get line() {
        return this._line;
    }
    // @Override
    set line(line) {
        this._line = line;
    }
    get text() {
        if (this._text != null) return this._text;
        let input = this.inputStream;
        if (input == null) return undefined;
        let n = input.size;
        if (this.start < n && this.stop < n) return input.getText($312SH.Interval.of(this.start, this.stop));
        else return "<EOF>";
    }
    /**
     * Explicitly set the text for this token. If {code text} is not
     * `undefined`, then {@link #getText} will return this value rather than
     * extracting the text from the input.
     *
     * @param text The explicit text of the token, or `undefined` if the text
     * should be obtained from the input along with the start and stop indexes
     * of the token.
     */ // @Override
    set text(text) {
        this._text = text;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    // @Override
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    get channel() {
        return this._channel;
    }
    // @Override
    set channel(channel) {
        this._channel = channel;
    }
    get startIndex() {
        return this.start;
    }
    set startIndex(start) {
        this.start = start;
    }
    get stopIndex() {
        return this.stop;
    }
    set stopIndex(stop) {
        this.stop = stop;
    }
    get tokenIndex() {
        return this.index;
    }
    // @Override
    set tokenIndex(index) {
        this.index = index;
    }
    get tokenSource() {
        return this.source.source;
    }
    get inputStream() {
        return this.source.stream;
    }
    toString(recognizer) {
        let channelStr = "";
        if (this._channel > 0) channelStr = ",channel=" + this._channel;
        let txt = this.text;
        if (txt != null) {
            txt = txt.replace(/\n/g, "\\n");
            txt = txt.replace(/\r/g, "\\r");
            txt = txt.replace(/\t/g, "\\t");
        } else txt = "<no text>";
        let typeString = String(this._type);
        if (recognizer) typeString = recognizer.vocabulary.getDisplayName(this._type);
        return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + txt + "',<" + typeString + ">" + channelStr + "," + this._line + ":" + this.charPositionInLine + "]";
    }
};
/**
 * An empty {@link Tuple2} which is used as the default value of
 * {@link #source} for tokens that do not have a source.
 */ $84ce2c554805800d$var$CommonToken.EMPTY_SOURCE = {
    source: undefined,
    stream: undefined
};
$84ce2c554805800d$var$__decorate([
    $60gAE.NotNull
], $84ce2c554805800d$var$CommonToken.prototype, "source", void 0);
$84ce2c554805800d$var$__decorate([
    $60gAE.Override
], $84ce2c554805800d$var$CommonToken.prototype, "type", null);
$84ce2c554805800d$var$__decorate([
    $60gAE.Override
], $84ce2c554805800d$var$CommonToken.prototype, "line", null);
$84ce2c554805800d$var$__decorate([
    $60gAE.Override
], $84ce2c554805800d$var$CommonToken.prototype, "text", null);
$84ce2c554805800d$var$__decorate([
    $60gAE.Override
], $84ce2c554805800d$var$CommonToken.prototype, "charPositionInLine", null);
$84ce2c554805800d$var$__decorate([
    $60gAE.Override
], $84ce2c554805800d$var$CommonToken.prototype, "channel", null);
$84ce2c554805800d$var$__decorate([
    $60gAE.Override
], $84ce2c554805800d$var$CommonToken.prototype, "startIndex", null);
$84ce2c554805800d$var$__decorate([
    $60gAE.Override
], $84ce2c554805800d$var$CommonToken.prototype, "stopIndex", null);
$84ce2c554805800d$var$__decorate([
    $60gAE.Override
], $84ce2c554805800d$var$CommonToken.prototype, "tokenIndex", null);
$84ce2c554805800d$var$__decorate([
    $60gAE.Override
], $84ce2c554805800d$var$CommonToken.prototype, "tokenSource", null);
$84ce2c554805800d$var$__decorate([
    $60gAE.Override
], $84ce2c554805800d$var$CommonToken.prototype, "inputStream", null);
$84ce2c554805800d$var$__decorate([
    $60gAE.Override
], $84ce2c554805800d$var$CommonToken.prototype, "toString", null);
$84ce2c554805800d$var$__decorate([
    $84ce2c554805800d$var$__param(0, $60gAE.NotNull)
], $84ce2c554805800d$var$CommonToken, "fromToken", null);
$84ce2c554805800d$var$CommonToken = $84ce2c554805800d$var$__decorate([
    $84ce2c554805800d$var$__param(2, $60gAE.NotNull)
], $84ce2c554805800d$var$CommonToken);
module.exports.CommonToken = $84ce2c554805800d$var$CommonToken;

});
parcelRegister("iLVZN", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Token = void 0;

var $hPLPA = parcelRequire("hPLPA");
var $daa99a8a61394450$var$Token;
(function(Token) {
    Token.INVALID_TYPE = 0;
    /** During lookahead operations, this "token" signifies we hit rule end ATN state
     *  and did not follow it despite needing to.
     */ Token.EPSILON = -2;
    Token.MIN_USER_TOKEN_TYPE = 1;
    Token.EOF = $hPLPA.IntStream.EOF;
    /** All tokens go to the parser (unless skip() is called in that rule)
     *  on a particular "channel".  The parser tunes to a particular channel
     *  so that whitespace etc... can go to the parser on a "hidden" channel.
     */ Token.DEFAULT_CHANNEL = 0;
    /** Anything on different channel than DEFAULT_CHANNEL is not parsed
     *  by parser.
     */ Token.HIDDEN_CHANNEL = 1;
    /**
     * This is the minimum constant value which can be assigned to a
     * user-defined token channel.
     *
     * The non-negative numbers less than {@link #MIN_USER_CHANNEL_VALUE} are
     * assigned to the predefined channels {@link #DEFAULT_CHANNEL} and
     * {@link #HIDDEN_CHANNEL}.
     *
     * @see `Token.channel`
     */ Token.MIN_USER_CHANNEL_VALUE = 2;
})($daa99a8a61394450$var$Token = module.exports.Token || (module.exports.Token = {}));

});



parcelRegister("i8JNJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerStack = void 0;

var $jL0Xb = parcelRequire("jL0Xb");
/**
 *
 * @author Sam Harwell
 */ class $d34c807fd4f549fb$var$IntegerStack extends $jL0Xb.IntegerList {
    constructor(arg){
        super(arg);
    }
    push(value) {
        this.add(value);
    }
    pop() {
        return this.removeAt(this.size - 1);
    }
    peek() {
        return this.get(this.size - 1);
    }
}
module.exports.IntegerStack = $d34c807fd4f549fb$var$IntegerStack;

});

parcelRegister("7yK40", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $580f70ab950828b4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $580f70ab950828b4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerATNSimulator = void 0;

var $kytPQ = parcelRequire("kytPQ");

var $dQ2fw = parcelRequire("dQ2fw");

var $lz4Ok = parcelRequire("lz4Ok");

var $3cXWi = parcelRequire("3cXWi");

var $d5Bh2 = parcelRequire("d5Bh2");

var $g3I27 = parcelRequire("g3I27");

var $312SH = parcelRequire("312SH");

var $hPLPA = parcelRequire("hPLPA");

var $ipeIv = parcelRequire("ipeIv");

var $cVbvA = parcelRequire("cVbvA");

var $hqoEr = parcelRequire("hqoEr");

var $60gAE = parcelRequire("60gAE");

var $489CF = parcelRequire("489CF");

var $gT9VD = parcelRequire("gT9VD");

var $830He = parcelRequire("830He");

var $iLVZN = parcelRequire("iLVZN");

var $lzl5a = parcelRequire("lzl5a");
/** "dup" of ParserInterpreter */ let $580f70ab950828b4$var$LexerATNSimulator = class LexerATNSimulator extends $d5Bh2.ATNSimulator {
    constructor(atn, recog){
        super(atn);
        this.optimize_tail_calls = true;
        /** The current token's starting index into the character stream.
         *  Shared across DFA to ATN simulation in case the ATN fails and the
         *  DFA did not have a previous accept state. In this case, we use the
         *  ATN-generated exception object.
         */ this.startIndex = -1;
        /** line number 1..n within the input */ this._line = 1;
        /** The index of the character relative to the beginning of the line 0..n-1 */ this._charPositionInLine = 0;
        this.mode = $ipeIv.Lexer.DEFAULT_MODE;
        /** Used during DFA/ATN exec to record the most recent accept configuration info */ this.prevAccept = new LexerATNSimulator.SimState();
        this.recog = recog;
    }
    copyState(simulator) {
        this._charPositionInLine = simulator.charPositionInLine;
        this._line = simulator._line;
        this.mode = simulator.mode;
        this.startIndex = simulator.startIndex;
    }
    match(input, mode) {
        this.mode = mode;
        let mark = input.mark();
        try {
            this.startIndex = input.index;
            this.prevAccept.reset();
            let s0 = this.atn.modeToDFA[mode].s0;
            if (s0 == null) return this.matchATN(input);
            else return this.execATN(input, s0);
        } finally{
            input.release(mark);
        }
    }
    reset() {
        this.prevAccept.reset();
        this.startIndex = -1;
        this._line = 1;
        this._charPositionInLine = 0;
        this.mode = $ipeIv.Lexer.DEFAULT_MODE;
    }
    matchATN(input) {
        let startState = this.atn.modeToStartState[this.mode];
        if (LexerATNSimulator.debug) console.log(`matchATN mode ${this.mode} start: ${startState}`);
        let old_mode = this.mode;
        let s0_closure = this.computeStartState(input, startState);
        let suppressEdge = s0_closure.hasSemanticContext;
        if (suppressEdge) s0_closure.hasSemanticContext = false;
        let next = this.addDFAState(s0_closure);
        if (!suppressEdge) {
            let dfa = this.atn.modeToDFA[this.mode];
            if (!dfa.s0) dfa.s0 = next;
            else next = dfa.s0;
        }
        let predict = this.execATN(input, next);
        if (LexerATNSimulator.debug) console.log(`DFA after matchATN: ${this.atn.modeToDFA[old_mode].toLexerString()}`);
        return predict;
    }
    execATN(input, ds0) {
        // console.log("enter exec index "+input.index+" from "+ds0.configs);
        if (LexerATNSimulator.debug) console.log(`start state closure=${ds0.configs}`);
        if (ds0.isAcceptState) // allow zero-length tokens
        this.captureSimState(this.prevAccept, input, ds0);
        let t = input.LA(1);
        // @NotNull
        let s = ds0; // s is current/from DFA state
        while(true){
            if (LexerATNSimulator.debug) console.log(`execATN loop starting closure: ${s.configs}`);
            // As we move src->trg, src->trg, we keep track of the previous trg to
            // avoid looking up the DFA state again, which is expensive.
            // If the previous target was already part of the DFA, we might
            // be able to avoid doing a reach operation upon t. If s!=null,
            // it means that semantic predicates didn't prevent us from
            // creating a DFA state. Once we know s!=null, we check to see if
            // the DFA state has an edge already for t. If so, we can just reuse
            // it's configuration set; there's no point in re-computing it.
            // This is kind of like doing DFA simulation within the ATN
            // simulation because DFA simulation is really just a way to avoid
            // computing reach/closure sets. Technically, once we know that
            // we have a previously added DFA state, we could jump over to
            // the DFA simulator. But, that would mean popping back and forth
            // a lot and making things more complicated algorithmically.
            // This optimization makes a lot of sense for loops within DFA.
            // A character will take us back to an existing DFA state
            // that already has lots of edges out of it. e.g., .* in comments.
            let target = this.getExistingTargetState(s, t);
            if (target == null) target = this.computeTargetState(input, s, t);
            if (target === $d5Bh2.ATNSimulator.ERROR) break;
            // If this is a consumable input element, make sure to consume before
            // capturing the accept state so the input index, line, and char
            // position accurately reflect the state of the interpreter at the
            // end of the token.
            if (t !== $hPLPA.IntStream.EOF) this.consume(input);
            if (target.isAcceptState) {
                this.captureSimState(this.prevAccept, input, target);
                if (t === $hPLPA.IntStream.EOF) break;
            }
            t = input.LA(1);
            s = target; // flip; current DFA target becomes new src/from state
        }
        return this.failOrAccept(this.prevAccept, input, s.configs, t);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        let target = s.getTarget(t);
        if (LexerATNSimulator.debug && target != null) console.log("reuse state " + s.stateNumber + " edge to " + target.stateNumber);
        return target;
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param input The input stream
     * @param s The current DFA state
     * @param t The next input symbol
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(input, s, t) {
        let reach = new $489CF.OrderedATNConfigSet();
        // if we don't find an existing DFA state
        // Fill reach starting from closure, following t transitions
        this.getReachableConfigSet(input, s.configs, reach, t);
        if (reach.isEmpty) {
            if (!reach.hasSemanticContext) // we got nowhere on t, don't throw out this knowledge; it'd
            // cause a failover from DFA later.
            this.addDFAEdge(s, t, $d5Bh2.ATNSimulator.ERROR);
            // stop when we can't match any more char
            return $d5Bh2.ATNSimulator.ERROR;
        }
        // Add an edge from s to target DFA found/created for reach
        return this.addDFAEdge(s, t, reach);
    }
    failOrAccept(prevAccept, input, reach, t) {
        if (prevAccept.dfaState != null) {
            let lexerActionExecutor = prevAccept.dfaState.lexerActionExecutor;
            this.accept(input, lexerActionExecutor, this.startIndex, prevAccept.index, prevAccept.line, prevAccept.charPos);
            return prevAccept.dfaState.prediction;
        } else {
            // if no accept and EOF is first char, return EOF
            if (t === $hPLPA.IntStream.EOF && input.index === this.startIndex) return $iLVZN.Token.EOF;
            throw new $hqoEr.LexerNoViableAltException(this.recog, input, this.startIndex, reach);
        }
    }
    /** Given a starting configuration set, figure out all ATN configurations
     *  we can reach upon input `t`. Parameter `reach` is a return
     *  parameter.
     */ getReachableConfigSet(input, closure, reach, t) {
        // this is used to skip processing for configs which have a lower priority
        // than a config that already reached an accept state for the same rule
        let skipAlt = $dQ2fw.ATN.INVALID_ALT_NUMBER;
        for (let c of closure){
            let currentAltReachedAcceptState = c.alt === skipAlt;
            if (currentAltReachedAcceptState && c.hasPassedThroughNonGreedyDecision) continue;
            if (LexerATNSimulator.debug) console.log(`testing ${this.getTokenName(t)} at ${c.toString(this.recog, true)}`);
            let n = c.state.numberOfOptimizedTransitions;
            for(let ti = 0; ti < n; ti++){
                let trans = c.state.getOptimizedTransition(ti);
                let target = this.getReachableTarget(trans, t);
                if (target != null) {
                    let lexerActionExecutor = c.lexerActionExecutor;
                    let config;
                    if (lexerActionExecutor != null) {
                        lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
                        config = c.transform(target, true, lexerActionExecutor);
                    } else {
                        $lzl5a(c.lexerActionExecutor == null);
                        config = c.transform(target, true);
                    }
                    let treatEofAsEpsilon = t === $hPLPA.IntStream.EOF;
                    if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
                        // any remaining configs for this alt have a lower priority than
                        // the one that just reached an accept state.
                        skipAlt = c.alt;
                        break;
                    }
                }
            }
        }
    }
    accept(input, lexerActionExecutor, startIndex, index, line, charPos) {
        if (LexerATNSimulator.debug) console.log(`ACTION ${lexerActionExecutor}`);
        // seek to after last char in token
        input.seek(index);
        this._line = line;
        this._charPositionInLine = charPos;
        if (lexerActionExecutor != null && this.recog != null) lexerActionExecutor.execute(this.recog, input, startIndex);
    }
    getReachableTarget(trans, t) {
        if (trans.matches(t, $ipeIv.Lexer.MIN_CHAR_VALUE, $ipeIv.Lexer.MAX_CHAR_VALUE)) return trans.target;
        return undefined;
    }
    computeStartState(input, p) {
        let initialContext = $gT9VD.PredictionContext.EMPTY_FULL;
        let configs = new $489CF.OrderedATNConfigSet();
        for(let i = 0; i < p.numberOfTransitions; i++){
            let target = p.transition(i).target;
            let c = $lz4Ok.ATNConfig.create(target, i + 1, initialContext);
            this.closure(input, c, configs, false, false, false);
        }
        return configs;
    }
    /**
     * Since the alternatives within any lexer decision are ordered by
     * preference, this method stops pursuing the closure as soon as an accept
     * state is reached. After the first accept state is reached by depth-first
     * search from `config`, all other (potentially reachable) states for
     * this rule would have a lower priority.
     *
     * @returns `true` if an accept state is reached, otherwise
     * `false`.
     */ closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
        if (LexerATNSimulator.debug) console.log("closure(" + config.toString(this.recog, true) + ")");
        if (config.state instanceof $830He.RuleStopState) {
            if (LexerATNSimulator.debug) {
                if (this.recog != null) console.log(`closure at ${this.recog.ruleNames[config.state.ruleIndex]} rule stop ${config}`);
                else console.log(`closure at rule stop ${config}`);
            }
            let context = config.context;
            if (context.isEmpty) {
                configs.add(config);
                return true;
            } else if (context.hasEmpty) {
                configs.add(config.transform(config.state, true, $gT9VD.PredictionContext.EMPTY_FULL));
                currentAltReachedAcceptState = true;
            }
            for(let i = 0; i < context.size; i++){
                let returnStateNumber = context.getReturnState(i);
                if (returnStateNumber === $gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                let newContext = context.getParent(i); // "pop" return state
                let returnState = this.atn.states[returnStateNumber];
                let c = config.transform(returnState, false, newContext);
                currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
            }
            return currentAltReachedAcceptState;
        }
        // optimization
        if (!config.state.onlyHasEpsilonTransitions) {
            if (!currentAltReachedAcceptState || !config.hasPassedThroughNonGreedyDecision) configs.add(config);
        }
        let p = config.state;
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            let t = p.getOptimizedTransition(i);
            let c = this.getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon);
            if (c != null) currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
        }
        return currentAltReachedAcceptState;
    }
    // side-effect: can alter configs.hasSemanticContext
    getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon) {
        let c;
        switch(t.serializationType){
            case 3 /* RULE */ :
                let ruleTransition = t;
                if (this.optimize_tail_calls && ruleTransition.optimizedTailCall && !config.context.hasEmpty) c = config.transform(t.target, true);
                else {
                    let newContext = config.context.getChild(ruleTransition.followState.stateNumber);
                    c = config.transform(t.target, true, newContext);
                }
                break;
            case 10 /* PRECEDENCE */ :
                throw new Error("Precedence predicates are not supported in lexers.");
            case 4 /* PREDICATE */ :
                /*  Track traversing semantic predicates. If we traverse,
                    we cannot add a DFA state for this "reach" computation
                    because the DFA would not test the predicate again in the
                    future. Rather than creating collections of semantic predicates
                    like v3 and testing them on prediction, v4 will test them on the
                    fly all the time using the ATN not the DFA. This is slower but
                    semantically it's not used that often. One of the key elements to
                    this predicate mechanism is not adding DFA states that see
                    predicates immediately afterwards in the ATN. For example,
    
                    a : ID {p1}? | ID {p2}? ;
    
                    should create the start state for rule 'a' (to save start state
                    competition), but should not create target of ID state. The
                    collection of ATN states the following ID references includes
                    states reached by traversing predicates. Since this is when we
                    test them, we cannot cash the DFA state target of ID.
                */ let pt = t;
                if (LexerATNSimulator.debug) console.log("EVAL rule " + pt.ruleIndex + ":" + pt.predIndex);
                configs.hasSemanticContext = true;
                if (this.evaluatePredicate(input, pt.ruleIndex, pt.predIndex, speculative)) c = config.transform(t.target, true);
                else c = undefined;
                break;
            case 6 /* ACTION */ :
                if (config.context.hasEmpty) {
                    // execute actions anywhere in the start rule for a token.
                    //
                    // TODO: if the entry rule is invoked recursively, some
                    // actions may be executed during the recursive call. The
                    // problem can appear when hasEmpty is true but
                    // isEmpty is false. In this case, the config needs to be
                    // split into two contexts - one with just the empty path
                    // and another with everything but the empty path.
                    // Unfortunately, the current algorithm does not allow
                    // getEpsilonTarget to return two configurations, so
                    // additional modifications are needed before we can support
                    // the split operation.
                    let lexerActionExecutor = $cVbvA.LexerActionExecutor.append(config.lexerActionExecutor, this.atn.lexerActions[t.actionIndex]);
                    c = config.transform(t.target, true, lexerActionExecutor);
                    break;
                } else {
                    // ignore actions in referenced rules
                    c = config.transform(t.target, true);
                    break;
                }
            case 1 /* EPSILON */ :
                c = config.transform(t.target, true);
                break;
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                if (treatEofAsEpsilon) {
                    if (t.matches($hPLPA.IntStream.EOF, $ipeIv.Lexer.MIN_CHAR_VALUE, $ipeIv.Lexer.MAX_CHAR_VALUE)) {
                        c = config.transform(t.target, false);
                        break;
                    }
                }
                c = undefined;
                break;
            default:
                c = undefined;
                break;
        }
        return c;
    }
    /**
     * Evaluate a predicate specified in the lexer.
     *
     * If `speculative` is `true`, this method was called before
     * {@link #consume} for the matched character. This method should call
     * {@link #consume} before evaluating the predicate to ensure position
     * sensitive values, including {@link Lexer#getText}, {@link Lexer#getLine},
     * and {@link Lexer#getCharPositionInLine}, properly reflect the current
     * lexer state. This method should restore `input` and the simulator
     * to the original state before returning (i.e. undo the actions made by the
     * call to {@link #consume}.
     *
     * @param input The input stream.
     * @param ruleIndex The rule containing the predicate.
     * @param predIndex The index of the predicate within the rule.
     * @param speculative `true` if the current index in `input` is
     * one character before the predicate's location.
     *
     * @returns `true` if the specified predicate evaluates to
     * `true`.
     */ evaluatePredicate(input, ruleIndex, predIndex, speculative) {
        // assume true if no recognizer was provided
        if (this.recog == null) return true;
        if (!speculative) return this.recog.sempred(undefined, ruleIndex, predIndex);
        let savedCharPositionInLine = this._charPositionInLine;
        let savedLine = this._line;
        let index = input.index;
        let marker = input.mark();
        try {
            this.consume(input);
            return this.recog.sempred(undefined, ruleIndex, predIndex);
        } finally{
            this._charPositionInLine = savedCharPositionInLine;
            this._line = savedLine;
            input.seek(index);
            input.release(marker);
        }
    }
    captureSimState(settings, input, dfaState) {
        settings.index = input.index;
        settings.line = this._line;
        settings.charPos = this._charPositionInLine;
        settings.dfaState = dfaState;
    }
    addDFAEdge(p, t, q) {
        if (q instanceof $3cXWi.ATNConfigSet) {
            /* leading to this call, ATNConfigSet.hasSemanticContext is used as a
            * marker indicating dynamic predicate evaluation makes this edge
            * dependent on the specific input sequence, so the static edge in the
            * DFA should be omitted. The target DFAState is still created since
            * execATN has the ability to resynchronize with the DFA state cache
            * following the predicate evaluation step.
            *
            * TJP notes: next time through the DFA, we see a pred again and eval.
            * If that gets us to a previously created (but dangling) DFA
            * state, we can continue in pure DFA mode from there.
            */ let suppressEdge = q.hasSemanticContext;
            if (suppressEdge) q.hasSemanticContext = false;
            // @NotNull
            let to = this.addDFAState(q);
            if (suppressEdge) return to;
            this.addDFAEdge(p, t, to);
            return to;
        } else {
            if (LexerATNSimulator.debug) console.log("EDGE " + p + " -> " + q + " upon " + String.fromCharCode(t));
            if (p != null) p.setTarget(t, q);
        }
    }
    /** Add a new DFA state if there isn't one with this set of
     * 	configurations already. This method also detects the first
     * 	configuration containing an ATN rule stop state. Later, when
     * 	traversing the DFA, we will know which rule to accept.
     */ addDFAState(configs) {
        /* the lexer evaluates predicates on-the-fly; by this point configs
         * should not contain any configurations with unevaluated predicates.
         */ $lzl5a(!configs.hasSemanticContext);
        let proposed = new $g3I27.DFAState(configs);
        let existing = this.atn.modeToDFA[this.mode].states.get(proposed);
        if (existing != null) return existing;
        configs.optimizeConfigs(this);
        let newState = new $g3I27.DFAState(configs.clone(true));
        let firstConfigWithRuleStopState;
        for (let c of configs)if (c.state instanceof $830He.RuleStopState) {
            firstConfigWithRuleStopState = c;
            break;
        }
        if (firstConfigWithRuleStopState != null) {
            let prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
            let lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
            newState.acceptStateInfo = new $kytPQ.AcceptStateInfo(prediction, lexerActionExecutor);
        }
        return this.atn.modeToDFA[this.mode].addState(newState);
    }
    getDFA(mode) {
        return this.atn.modeToDFA[mode];
    }
    /** Get the text matched so far for the current token.
     */ getText(input) {
        // index is first lookahead char, don't include.
        return input.getText($312SH.Interval.of(this.startIndex, input.index - 1));
    }
    get line() {
        return this._line;
    }
    set line(line) {
        this._line = line;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    consume(input) {
        let curChar = input.LA(1);
        if (curChar === "\n".charCodeAt(0)) {
            this._line++;
            this._charPositionInLine = 0;
        } else this._charPositionInLine++;
        input.consume();
    }
    getTokenName(t) {
        if (t === -1) return "EOF";
        //if ( atn.g!=null ) return atn.g.getTokenDisplayName(t);
        return "'" + String.fromCharCode(t) + "'";
    }
};
$580f70ab950828b4$var$__decorate([
    $60gAE.NotNull
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "prevAccept", void 0);
$580f70ab950828b4$var$__decorate([
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "copyState", null);
$580f70ab950828b4$var$__decorate([
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "match", null);
$580f70ab950828b4$var$__decorate([
    $60gAE.Override
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "reset", null);
$580f70ab950828b4$var$__decorate([
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "matchATN", null);
$580f70ab950828b4$var$__decorate([
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull),
    $580f70ab950828b4$var$__param(1, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "execATN", null);
$580f70ab950828b4$var$__decorate([
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "getExistingTargetState", null);
$580f70ab950828b4$var$__decorate([
    $60gAE.NotNull,
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull),
    $580f70ab950828b4$var$__param(1, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "computeTargetState", null);
$580f70ab950828b4$var$__decorate([
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull),
    $580f70ab950828b4$var$__param(1, $60gAE.NotNull),
    $580f70ab950828b4$var$__param(2, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "getReachableConfigSet", null);
$580f70ab950828b4$var$__decorate([
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "accept", null);
$580f70ab950828b4$var$__decorate([
    $60gAE.NotNull,
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull),
    $580f70ab950828b4$var$__param(1, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "computeStartState", null);
$580f70ab950828b4$var$__decorate([
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull),
    $580f70ab950828b4$var$__param(1, $60gAE.NotNull),
    $580f70ab950828b4$var$__param(2, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "closure", null);
$580f70ab950828b4$var$__decorate([
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull),
    $580f70ab950828b4$var$__param(1, $60gAE.NotNull),
    $580f70ab950828b4$var$__param(2, $60gAE.NotNull),
    $580f70ab950828b4$var$__param(3, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "getEpsilonTarget", null);
$580f70ab950828b4$var$__decorate([
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "evaluatePredicate", null);
$580f70ab950828b4$var$__decorate([
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull),
    $580f70ab950828b4$var$__param(1, $60gAE.NotNull),
    $580f70ab950828b4$var$__param(2, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "captureSimState", null);
$580f70ab950828b4$var$__decorate([
    $60gAE.NotNull,
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "addDFAState", null);
$580f70ab950828b4$var$__decorate([
    $60gAE.NotNull
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "getDFA", null);
$580f70ab950828b4$var$__decorate([
    $60gAE.NotNull,
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "getText", null);
$580f70ab950828b4$var$__decorate([
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "consume", null);
$580f70ab950828b4$var$__decorate([
    $60gAE.NotNull
], $580f70ab950828b4$var$LexerATNSimulator.prototype, "getTokenName", null);
$580f70ab950828b4$var$LexerATNSimulator = $580f70ab950828b4$var$__decorate([
    $580f70ab950828b4$var$__param(0, $60gAE.NotNull)
], $580f70ab950828b4$var$LexerATNSimulator);
module.exports.LexerATNSimulator = $580f70ab950828b4$var$LexerATNSimulator;
(function(LexerATNSimulator) {
    LexerATNSimulator.debug = false;
    LexerATNSimulator.dfa_debug = false;
    /** When we hit an accept state in either the DFA or the ATN, we
     *  have to notify the character stream to start buffering characters
     *  via {@link IntStream#mark} and record the current state. The current sim state
     *  includes the current index into the input, the current line,
     *  and current character position in that line. Note that the Lexer is
     *  tracking the starting line and characterization of the token. These
     *  variables track the "state" of the simulator when it hits an accept state.
     *
     *  We track these variables separately for the DFA and ATN simulation
     *  because the DFA simulation often has to fail over to the ATN
     *  simulation. If the ATN simulation fails, we need the DFA to fall
     *  back to its previously accepted state, if any. If the ATN succeeds,
     *  then the ATN does the accept and the DFA simulator that invoked it
     *  can simply return the predicted token type.
     */ class SimState {
        constructor(){
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
        }
        reset() {
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
            this.dfaState = undefined;
        }
    }
    LexerATNSimulator.SimState = SimState;
})($580f70ab950828b4$var$LexerATNSimulator = module.exports.LexerATNSimulator || (module.exports.LexerATNSimulator = {}));
module.exports.LexerATNSimulator = $580f70ab950828b4$var$LexerATNSimulator;

});
parcelRegister("kytPQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AcceptStateInfo = void 0;
/**
 * Stores information about a {@link DFAState} which is an accept state under
 * some condition. Certain settings, such as
 * {@link ParserATNSimulator#getPredictionMode()}, may be used in addition to
 * this information to determine whether or not a particular state is an accept
 * state.
 *
 * @author Sam Harwell
 */ class $ef6e2047ae99a360$var$AcceptStateInfo {
    constructor(prediction, lexerActionExecutor){
        this._prediction = prediction;
        this._lexerActionExecutor = lexerActionExecutor;
    }
    /**
     * Gets the prediction made by this accept state. Note that this value
     * assumes the predicates, if any, in the {@link DFAState} evaluate to
     * `true`. If predicate evaluation is enabled, the final prediction of
     * the accept state will be determined by the result of predicate
     * evaluation.
     */ get prediction() {
        return this._prediction;
    }
    /**
     * Gets the {@link LexerActionExecutor} which can be used to execute actions
     * and/or commands after the lexer matches a token.
     */ get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
}
module.exports.AcceptStateInfo = $ef6e2047ae99a360$var$AcceptStateInfo;

});

parcelRegister("dQ2fw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a131e060aacb7dac$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a131e060aacb7dac$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATN = void 0;

var $cqAje = parcelRequire("cqAje");

var $ll18S = parcelRequire("ll18S");

var $fkZzb = parcelRequire("fkZzb");

var $dwSPu = parcelRequire("dwSPu");

var $9cygq = parcelRequire("9cygq");

var $60gAE = parcelRequire("60gAE");

var $cWz6y = parcelRequire("cWz6y");

var $gT9VD = parcelRequire("gT9VD");

var $iLVZN = parcelRequire("iLVZN");

var $lzl5a = parcelRequire("lzl5a");
/** */ let $a131e060aacb7dac$var$ATN = class ATN {
    /** Used for runtime deserialization of ATNs from strings */ constructor(grammarType, maxTokenType){
        this.states = [];
        /** Each subrule/rule is a decision point and we must track them so we
         *  can go back later and build DFA predictors for them.  This includes
         *  all the rules, subrules, optional blocks, ()+, ()* etc...
         */ this.decisionToState = [];
        this.modeNameToStartState = new Map();
        this.modeToStartState = [];
        this.contextCache = new $cqAje.Array2DHashMap($cWz6y.ObjectEqualityComparator.INSTANCE);
        this.decisionToDFA = [];
        this.modeToDFA = [];
        this.LL1Table = new Map();
        this.grammarType = grammarType;
        this.maxTokenType = maxTokenType;
    }
    clearDFA() {
        this.decisionToDFA = new Array(this.decisionToState.length);
        for(let i = 0; i < this.decisionToDFA.length; i++)this.decisionToDFA[i] = new $ll18S.DFA(this.decisionToState[i], i);
        this.modeToDFA = new Array(this.modeToStartState.length);
        for(let i = 0; i < this.modeToDFA.length; i++)this.modeToDFA[i] = new $ll18S.DFA(this.modeToStartState[i]);
        this.contextCache.clear();
        this.LL1Table.clear();
    }
    get contextCacheSize() {
        return this.contextCache.size;
    }
    getCachedContext(context) {
        return $gT9VD.PredictionContext.getCachedContext(context, this.contextCache, new $gT9VD.PredictionContext.IdentityHashMap());
    }
    getDecisionToDFA() {
        $lzl5a(this.decisionToDFA != null && this.decisionToDFA.length === this.decisionToState.length);
        return this.decisionToDFA;
    }
    nextTokens(s, ctx) {
        if (ctx) {
            let anal = new $9cygq.LL1Analyzer(this);
            let next = anal.LOOK(s, ctx);
            return next;
        } else {
            if (s.nextTokenWithinRule) return s.nextTokenWithinRule;
            s.nextTokenWithinRule = this.nextTokens(s, $gT9VD.PredictionContext.EMPTY_LOCAL);
            s.nextTokenWithinRule.setReadonly(true);
            return s.nextTokenWithinRule;
        }
    }
    addState(state) {
        state.atn = this;
        state.stateNumber = this.states.length;
        this.states.push(state);
    }
    removeState(state) {
        // just replace the state, don't shift states in list
        let invalidState = new $dwSPu.InvalidState();
        invalidState.atn = this;
        invalidState.stateNumber = state.stateNumber;
        this.states[state.stateNumber] = invalidState;
    }
    defineMode(name, s) {
        this.modeNameToStartState.set(name, s);
        this.modeToStartState.push(s);
        this.modeToDFA.push(new $ll18S.DFA(s));
        this.defineDecisionState(s);
    }
    defineDecisionState(s) {
        this.decisionToState.push(s);
        s.decision = this.decisionToState.length - 1;
        this.decisionToDFA.push(new $ll18S.DFA(s, s.decision));
        return s.decision;
    }
    getDecisionState(decision) {
        if (this.decisionToState.length > 0) return this.decisionToState[decision];
        return undefined;
    }
    get numberOfDecisions() {
        return this.decisionToState.length;
    }
    /**
     * Computes the set of input symbols which could follow ATN state number
     * `stateNumber` in the specified full `context`. This method
     * considers the complete parser context, but does not evaluate semantic
     * predicates (i.e. all predicates encountered during the calculation are
     * assumed true). If a path in the ATN exists from the starting state to the
     * {@link RuleStopState} of the outermost context without matching any
     * symbols, {@link Token#EOF} is added to the returned set.
     *
     * If `context` is `undefined`, it is treated as
     * {@link ParserRuleContext#EMPTY}.
     *
     * Note that this does NOT give you the set of all tokens that could
     * appear at a given token position in the input phrase.  In other words, it
     * does not answer:
     *
     * > Given a specific partial input phrase, return the set of all
     * > tokens that can follow the last token in the input phrase.
     *
     * The big difference is that with just the input, the parser could land
     * right in the middle of a lookahead decision. Getting all
     * *possible* tokens given a partial input stream is a separate
     * computation. See https://github.com/antlr/antlr4/issues/1428
     *
     * For this function, we are specifying an ATN state and call stack to
     * compute what token(s) can come next and specifically: outside of a
     * lookahead decision. That is what you want for error reporting and
     * recovery upon parse error.
     *
     * @param stateNumber the ATN state number
     * @param context the full parse context
     * @returns The set of potentially valid input symbols which could follow the
     * specified state in the specified context.
     * @ if the ATN does not contain a state with
     * number `stateNumber`
     */ getExpectedTokens(stateNumber, context) {
        if (stateNumber < 0 || stateNumber >= this.states.length) throw new RangeError("Invalid state number.");
        let ctx = context;
        let s = this.states[stateNumber];
        let following = this.nextTokens(s);
        if (!following.contains($iLVZN.Token.EPSILON)) return following;
        let expected = new $fkZzb.IntervalSet();
        expected.addAll(following);
        expected.remove($iLVZN.Token.EPSILON);
        while(ctx != null && ctx.invokingState >= 0 && following.contains($iLVZN.Token.EPSILON)){
            let invokingState = this.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = this.nextTokens(rt.followState);
            expected.addAll(following);
            expected.remove($iLVZN.Token.EPSILON);
            ctx = ctx._parent;
        }
        if (following.contains($iLVZN.Token.EPSILON)) expected.add($iLVZN.Token.EOF);
        return expected;
    }
};
$a131e060aacb7dac$var$__decorate([
    $60gAE.NotNull
], $a131e060aacb7dac$var$ATN.prototype, "states", void 0);
$a131e060aacb7dac$var$__decorate([
    $60gAE.NotNull
], $a131e060aacb7dac$var$ATN.prototype, "decisionToState", void 0);
$a131e060aacb7dac$var$__decorate([
    $60gAE.NotNull
], $a131e060aacb7dac$var$ATN.prototype, "modeNameToStartState", void 0);
$a131e060aacb7dac$var$__decorate([
    $60gAE.NotNull
], $a131e060aacb7dac$var$ATN.prototype, "modeToStartState", void 0);
$a131e060aacb7dac$var$__decorate([
    $60gAE.NotNull
], $a131e060aacb7dac$var$ATN.prototype, "decisionToDFA", void 0);
$a131e060aacb7dac$var$__decorate([
    $60gAE.NotNull
], $a131e060aacb7dac$var$ATN.prototype, "modeToDFA", void 0);
$a131e060aacb7dac$var$__decorate([
    $60gAE.NotNull
], $a131e060aacb7dac$var$ATN.prototype, "nextTokens", null);
$a131e060aacb7dac$var$__decorate([
    $a131e060aacb7dac$var$__param(0, $60gAE.NotNull)
], $a131e060aacb7dac$var$ATN.prototype, "removeState", null);
$a131e060aacb7dac$var$__decorate([
    $a131e060aacb7dac$var$__param(0, $60gAE.NotNull),
    $a131e060aacb7dac$var$__param(1, $60gAE.NotNull)
], $a131e060aacb7dac$var$ATN.prototype, "defineMode", null);
$a131e060aacb7dac$var$__decorate([
    $a131e060aacb7dac$var$__param(0, $60gAE.NotNull)
], $a131e060aacb7dac$var$ATN.prototype, "defineDecisionState", null);
$a131e060aacb7dac$var$__decorate([
    $60gAE.NotNull
], $a131e060aacb7dac$var$ATN.prototype, "getExpectedTokens", null);
$a131e060aacb7dac$var$ATN = $a131e060aacb7dac$var$__decorate([
    $a131e060aacb7dac$var$__param(0, $60gAE.NotNull)
], $a131e060aacb7dac$var$ATN);
module.exports.ATN = $a131e060aacb7dac$var$ATN;
(function(ATN) {
    ATN.INVALID_ALT_NUMBER = 0;
})($a131e060aacb7dac$var$ATN = module.exports.ATN || (module.exports.ATN = {}));
module.exports.ATN = $a131e060aacb7dac$var$ATN;

});
parcelRegister("cqAje", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashMap = void 0;

var $fqc4S = parcelRequire("fqc4S");
class $90c413ffaa84717b$var$MapKeyEqualityComparator {
    constructor(keyComparator){
        this.keyComparator = keyComparator;
    }
    hashCode(obj) {
        return this.keyComparator.hashCode(obj.key);
    }
    equals(a, b) {
        return this.keyComparator.equals(a.key, b.key);
    }
}
class $90c413ffaa84717b$var$Array2DHashMap {
    constructor(keyComparer){
        if (keyComparer instanceof $90c413ffaa84717b$var$Array2DHashMap) this.backingStore = new $fqc4S.Array2DHashSet(keyComparer.backingStore);
        else this.backingStore = new $fqc4S.Array2DHashSet(new $90c413ffaa84717b$var$MapKeyEqualityComparator(keyComparer));
    }
    clear() {
        this.backingStore.clear();
    }
    containsKey(key) {
        return this.backingStore.contains({
            key: key
        });
    }
    get(key) {
        let bucket = this.backingStore.get({
            key: key
        });
        if (!bucket) return undefined;
        return bucket.value;
    }
    get isEmpty() {
        return this.backingStore.isEmpty;
    }
    put(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else {
            result = element.value;
            element.value = value;
        }
        return result;
    }
    putIfAbsent(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else result = element.value;
        return result;
    }
    get size() {
        return this.backingStore.size;
    }
    hashCode() {
        return this.backingStore.hashCode();
    }
    equals(o) {
        if (!(o instanceof $90c413ffaa84717b$var$Array2DHashMap)) return false;
        return this.backingStore.equals(o.backingStore);
    }
}
module.exports.Array2DHashMap = $90c413ffaa84717b$var$Array2DHashMap;

});

parcelRegister("ll18S", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f88c71ef4ccf1ea7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f88c71ef4ccf1ea7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFA = void 0;

var $fqc4S = parcelRequire("fqc4S");

var $3cXWi = parcelRequire("3cXWi");

var $hkiZ3 = parcelRequire("hkiZ3");

var $g3I27 = parcelRequire("g3I27");

var $epB7E = parcelRequire("epB7E");

var $60gAE = parcelRequire("60gAE");

var $cWz6y = parcelRequire("cWz6y");

var $1UcbM = parcelRequire("1UcbM");

var $7DbrH = parcelRequire("7DbrH");
let $f88c71ef4ccf1ea7$var$DFA = class DFA {
    constructor(atnStartState, decision = 0){
        /**
         * A set of all states in the `DFA`.
         *
         * Note that this collection of states holds the DFA states for both SLL and LL prediction. Only the start state
         * needs to be differentiated for these cases, which is tracked by the `s0` and `s0full` fields.
         */ this.states = new $fqc4S.Array2DHashSet($cWz6y.ObjectEqualityComparator.INSTANCE);
        this.nextStateNumber = 0;
        if (!atnStartState.atn) throw new Error("The ATNState must be associated with an ATN");
        this.atnStartState = atnStartState;
        this.atn = atnStartState.atn;
        this.decision = decision;
        // Precedence DFAs are associated with the special precedence decision created for left-recursive rules which
        // evaluate their alternatives using a precedence hierarchy. When such a decision is encountered, we mark this
        // DFA instance as a precedence DFA and initialize the initial states s0 and s0full to special DFAState
        // instances which use outgoing edges to link to the actual start state used for each precedence level.
        let isPrecedenceDfa = false;
        if (atnStartState instanceof $1UcbM.StarLoopEntryState) {
            if (atnStartState.precedenceRuleDecision) {
                isPrecedenceDfa = true;
                this.s0 = new $g3I27.DFAState(new $3cXWi.ATNConfigSet());
                this.s0full = new $g3I27.DFAState(new $3cXWi.ATNConfigSet());
            }
        }
        this.precedenceDfa = isPrecedenceDfa;
    }
    /**
     * Gets whether this DFA is a precedence DFA. Precedence DFAs use a special
     * start state {@link #s0} which is not stored in {@link #states}. The
     * {@link DFAState#edges} array for this start state contains outgoing edges
     * supplying individual start states corresponding to specific precedence
     * values.
     *
     * @returns `true` if this is a precedence DFA; otherwise,
     * `false`.
     * @see Parser.precedence
     */ get isPrecedenceDfa() {
        return this.precedenceDfa;
    }
    /**
     * Get the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @returns The start state corresponding to the specified precedence, or
     * `undefined` if no start state exists for the specified precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ getPrecedenceStartState(precedence, fullContext) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        // s0 and s0full are never null for a precedence DFA
        if (fullContext) return this.s0full.getTarget(precedence);
        else return this.s0.getTarget(precedence);
    }
    /**
     * Set the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @param startState The start state corresponding to the specified
     * precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ setPrecedenceStartState(precedence, fullContext, startState) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        if (precedence < 0) return;
        if (fullContext) // s0full is never null for a precedence DFA
        this.s0full.setTarget(precedence, startState);
        else // s0 is never null for a precedence DFA
        this.s0.setTarget(precedence, startState);
    }
    get isEmpty() {
        if (this.isPrecedenceDfa) // s0 and s0full are never null for a precedence DFA
        return this.s0.getEdgeMap().size === 0 && this.s0full.getEdgeMap().size === 0;
        return this.s0 == null && this.s0full == null;
    }
    get isContextSensitive() {
        if (this.isPrecedenceDfa) // s0full is never null for a precedence DFA
        return this.s0full.getEdgeMap().size > 0;
        return this.s0full != null;
    }
    addState(state) {
        state.stateNumber = this.nextStateNumber++;
        return this.states.getOrAdd(state);
    }
    toString(vocabulary, ruleNames) {
        if (!vocabulary) vocabulary = $7DbrH.VocabularyImpl.EMPTY_VOCABULARY;
        if (!this.s0) return "";
        let serializer;
        if (ruleNames) serializer = new $hkiZ3.DFASerializer(this, vocabulary, ruleNames, this.atnStartState.atn);
        else serializer = new $hkiZ3.DFASerializer(this, vocabulary);
        return serializer.toString();
    }
    toLexerString() {
        if (!this.s0) return "";
        let serializer = new $epB7E.LexerDFASerializer(this);
        return serializer.toString();
    }
};
$f88c71ef4ccf1ea7$var$__decorate([
    $60gAE.NotNull
], $f88c71ef4ccf1ea7$var$DFA.prototype, "states", void 0);
$f88c71ef4ccf1ea7$var$__decorate([
    $60gAE.NotNull
], $f88c71ef4ccf1ea7$var$DFA.prototype, "atnStartState", void 0);
$f88c71ef4ccf1ea7$var$__decorate([
    $60gAE.NotNull
], $f88c71ef4ccf1ea7$var$DFA.prototype, "atn", void 0);
$f88c71ef4ccf1ea7$var$DFA = $f88c71ef4ccf1ea7$var$__decorate([
    $f88c71ef4ccf1ea7$var$__param(0, $60gAE.NotNull)
], $f88c71ef4ccf1ea7$var$DFA);
module.exports.DFA = $f88c71ef4ccf1ea7$var$DFA;

});
parcelRegister("3cXWi", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2560fcc4d6753538$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfigSet = void 0;

var $cqAje = parcelRequire("cqAje");

var $fqc4S = parcelRequire("fqc4S");

var $faPBd = parcelRequire("faPBd");

var $dQ2fw = parcelRequire("dQ2fw");

var $lz4Ok = parcelRequire("lz4Ok");

var $igr91 = parcelRequire("igr91");

var $60gAE = parcelRequire("60gAE");

var $cWz6y = parcelRequire("cWz6y");

var $gT9VD = parcelRequire("gT9VD");

var $fCMxU = parcelRequire("fCMxU");

var $gt6ZZ = parcelRequire("gt6ZZ");

var $lzl5a = parcelRequire("lzl5a");

var $5lo68 = parcelRequire("5lo68");
class $2560fcc4d6753538$var$KeyTypeEqualityComparer {
    hashCode(key) {
        return key.state ^ key.alt;
    }
    equals(a, b) {
        return a.state === b.state && a.alt === b.alt;
    }
}
$2560fcc4d6753538$var$KeyTypeEqualityComparer.INSTANCE = new $2560fcc4d6753538$var$KeyTypeEqualityComparer();
function $2560fcc4d6753538$var$NewKeyedConfigMap(map) {
    if (map) return new $cqAje.Array2DHashMap(map);
    else return new $cqAje.Array2DHashMap($2560fcc4d6753538$var$KeyTypeEqualityComparer.INSTANCE);
}
/**
 * Represents a set of ATN configurations (see `ATNConfig`). As configurations are added to the set, they are merged
 * with other `ATNConfig` instances already in the set when possible using the graph-structured stack.
 *
 * An instance of this class represents the complete set of positions (with context) in an ATN which would be associated
 * with a single DFA state. Its internal representation is more complex than traditional state used for NFA to DFA
 * conversion due to performance requirements (both improving speed and reducing memory overhead) as well as supporting
 * features such as semantic predicates and non-greedy operators in a form to support ANTLR's prediction algorithm.
 *
 * @author Sam Harwell
 */ class $2560fcc4d6753538$var$ATNConfigSet {
    constructor(set, readonly){
        this._uniqueAlt = 0;
        // Used in parser and lexer. In lexer, it indicates we hit a pred
        // while computing a closure operation.  Don't make a DFA state from this.
        this._hasSemanticContext = false;
        this._dipsIntoOuterContext = false;
        /**
         * When `true`, this config set represents configurations where the entire
         * outer context has been consumed by the ATN interpreter. This prevents the
         * {@link ParserATNSimulator#closure} from pursuing the global FOLLOW when a
         * rule stop state is reached with an empty prediction context.
         *
         * Note: `outermostConfigSet` and {@link #dipsIntoOuterContext} should never
         * be true at the same time.
         */ this.outermostConfigSet = false;
        this.cachedHashCode = -1;
        if (!set) {
            this.mergedConfigs = $2560fcc4d6753538$var$NewKeyedConfigMap();
            this.unmerged = [];
            this.configs = [];
            this._uniqueAlt = $dQ2fw.ATN.INVALID_ALT_NUMBER;
        } else {
            if (readonly) {
                this.mergedConfigs = undefined;
                this.unmerged = undefined;
            } else if (!set.isReadOnly) {
                this.mergedConfigs = $2560fcc4d6753538$var$NewKeyedConfigMap(set.mergedConfigs);
                this.unmerged = set.unmerged.slice(0);
            } else {
                this.mergedConfigs = $2560fcc4d6753538$var$NewKeyedConfigMap();
                this.unmerged = [];
            }
            this.configs = set.configs.slice(0);
            this._dipsIntoOuterContext = set._dipsIntoOuterContext;
            this._hasSemanticContext = set._hasSemanticContext;
            this.outermostConfigSet = set.outermostConfigSet;
            if (readonly || !set.isReadOnly) {
                this._uniqueAlt = set._uniqueAlt;
                this._conflictInfo = set._conflictInfo;
            }
        // if (!readonly && set.isReadOnly) -> addAll is called from clone()
        }
    }
    /**
     * Get the set of all alternatives represented by configurations in this
     * set.
     */ getRepresentedAlternatives() {
        if (this._conflictInfo != null) return this._conflictInfo.conflictedAlts.clone();
        let alts = new $igr91.BitSet();
        for (let config of this)alts.set(config.alt);
        return alts;
    }
    get isReadOnly() {
        return this.mergedConfigs == null;
    }
    get isOutermostConfigSet() {
        return this.outermostConfigSet;
    }
    set isOutermostConfigSet(outermostConfigSet) {
        if (this.outermostConfigSet && !outermostConfigSet) throw new Error("IllegalStateException");
        $lzl5a(!outermostConfigSet || !this._dipsIntoOuterContext);
        this.outermostConfigSet = outermostConfigSet;
    }
    getStates() {
        let states = new $fqc4S.Array2DHashSet($cWz6y.ObjectEqualityComparator.INSTANCE);
        for (let c of this.configs)states.add(c.state);
        return states;
    }
    optimizeConfigs(interpreter) {
        if (this.configs.length === 0) return;
        for (let config of this.configs)config.context = interpreter.atn.getCachedContext(config.context);
    }
    clone(readonly) {
        let copy = new $2560fcc4d6753538$var$ATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this.configs);
        return copy;
    }
    get size() {
        return this.configs.length;
    }
    get isEmpty() {
        return this.configs.length === 0;
    }
    contains(o) {
        if (!(o instanceof $lz4Ok.ATNConfig)) return false;
        if (this.mergedConfigs && this.unmerged) {
            let config = o;
            let configKey = this.getKey(config);
            let mergedConfig = this.mergedConfigs.get(configKey);
            if (mergedConfig != null && this.canMerge(config, configKey, mergedConfig)) return mergedConfig.contains(config);
            for (let c of this.unmerged){
                if (c.contains(o)) return true;
            }
        } else for (let c of this.configs){
            if (c.contains(o)) return true;
        }
        return false;
    }
    *[Symbol.iterator]() {
        yield* this.configs;
    }
    toArray() {
        return this.configs;
    }
    add(e, contextCache) {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        $lzl5a(!this.outermostConfigSet || !e.reachesIntoOuterContext);
        if (contextCache == null) contextCache = $fCMxU.PredictionContextCache.UNCACHED;
        let addKey;
        let key = this.getKey(e);
        let mergedConfig = this.mergedConfigs.get(key);
        addKey = mergedConfig == null;
        if (mergedConfig != null && this.canMerge(e, key, mergedConfig)) {
            mergedConfig.outerContextDepth = Math.max(mergedConfig.outerContextDepth, e.outerContextDepth);
            if (e.isPrecedenceFilterSuppressed) mergedConfig.isPrecedenceFilterSuppressed = true;
            let joined = $gT9VD.PredictionContext.join(mergedConfig.context, e.context, contextCache);
            this.updatePropertiesForMergedConfig(e);
            if (mergedConfig.context === joined) return false;
            mergedConfig.context = joined;
            return true;
        }
        for(let i = 0; i < this.unmerged.length; i++){
            let unmergedConfig = this.unmerged[i];
            if (this.canMerge(e, key, unmergedConfig)) {
                unmergedConfig.outerContextDepth = Math.max(unmergedConfig.outerContextDepth, e.outerContextDepth);
                if (e.isPrecedenceFilterSuppressed) unmergedConfig.isPrecedenceFilterSuppressed = true;
                let joined = $gT9VD.PredictionContext.join(unmergedConfig.context, e.context, contextCache);
                this.updatePropertiesForMergedConfig(e);
                if (unmergedConfig.context === joined) return false;
                unmergedConfig.context = joined;
                if (addKey) {
                    this.mergedConfigs.put(key, unmergedConfig);
                    this.unmerged.splice(i, 1);
                }
                return true;
            }
        }
        this.configs.push(e);
        if (addKey) this.mergedConfigs.put(key, e);
        else this.unmerged.push(e);
        this.updatePropertiesForAddedConfig(e);
        return true;
    }
    updatePropertiesForMergedConfig(config) {
        // merged configs can't change the alt or semantic context
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $lzl5a(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    updatePropertiesForAddedConfig(config) {
        if (this.configs.length === 1) this._uniqueAlt = config.alt;
        else if (this._uniqueAlt !== config.alt) this._uniqueAlt = $dQ2fw.ATN.INVALID_ALT_NUMBER;
        this._hasSemanticContext = this._hasSemanticContext || !$gt6ZZ.SemanticContext.NONE.equals(config.semanticContext);
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $lzl5a(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    canMerge(left, leftKey, right) {
        if (left.state.stateNumber !== right.state.stateNumber) return false;
        if (leftKey.alt !== right.alt) return false;
        return left.semanticContext.equals(right.semanticContext);
    }
    getKey(e) {
        return {
            state: e.state.stateNumber,
            alt: e.alt
        };
    }
    containsAll(c) {
        for (let o of c){
            if (!(o instanceof $lz4Ok.ATNConfig)) return false;
            if (!this.contains(o)) return false;
        }
        return true;
    }
    addAll(c, contextCache) {
        this.ensureWritable();
        let changed = false;
        for (let group of c)if (this.add(group, contextCache)) changed = true;
        return changed;
    }
    clear() {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        this.mergedConfigs.clear();
        this.unmerged.length = 0;
        this.configs.length = 0;
        this._dipsIntoOuterContext = false;
        this._hasSemanticContext = false;
        this._uniqueAlt = $dQ2fw.ATN.INVALID_ALT_NUMBER;
        this._conflictInfo = undefined;
    }
    equals(obj) {
        if (this === obj) return true;
        if (!(obj instanceof $2560fcc4d6753538$var$ATNConfigSet)) return false;
        return this.outermostConfigSet === obj.outermostConfigSet && $5lo68.equals(this._conflictInfo, obj._conflictInfo) && $faPBd.ArrayEqualityComparator.INSTANCE.equals(this.configs, obj.configs);
    }
    hashCode() {
        if (this.isReadOnly && this.cachedHashCode !== -1) return this.cachedHashCode;
        let hashCode = 1;
        hashCode = 5 * hashCode ^ (this.outermostConfigSet ? 1 : 0);
        hashCode = 5 * hashCode ^ $faPBd.ArrayEqualityComparator.INSTANCE.hashCode(this.configs);
        if (this.isReadOnly) this.cachedHashCode = hashCode;
        return hashCode;
    }
    toString(showContext) {
        if (showContext == null) showContext = false;
        let buf = "";
        let sortedConfigs = this.configs.slice(0);
        sortedConfigs.sort((o1, o2)=>{
            if (o1.alt !== o2.alt) return o1.alt - o2.alt;
            else if (o1.state.stateNumber !== o2.state.stateNumber) return o1.state.stateNumber - o2.state.stateNumber;
            else return o1.semanticContext.toString().localeCompare(o2.semanticContext.toString());
        });
        buf += "[";
        for(let i = 0; i < sortedConfigs.length; i++){
            if (i > 0) buf += ", ";
            buf += sortedConfigs[i].toString(undefined, true, showContext);
        }
        buf += "]";
        if (this._hasSemanticContext) buf += ",hasSemanticContext=" + this._hasSemanticContext;
        if (this._uniqueAlt !== $dQ2fw.ATN.INVALID_ALT_NUMBER) buf += ",uniqueAlt=" + this._uniqueAlt;
        if (this._conflictInfo != null) {
            buf += ",conflictingAlts=" + this._conflictInfo.conflictedAlts;
            if (!this._conflictInfo.isExact) buf += "*";
        }
        if (this._dipsIntoOuterContext) buf += ",dipsIntoOuterContext";
        return buf.toString();
    }
    get uniqueAlt() {
        return this._uniqueAlt;
    }
    get hasSemanticContext() {
        return this._hasSemanticContext;
    }
    set hasSemanticContext(value) {
        this.ensureWritable();
        this._hasSemanticContext = value;
    }
    get conflictInfo() {
        return this._conflictInfo;
    }
    set conflictInfo(conflictInfo) {
        this.ensureWritable();
        this._conflictInfo = conflictInfo;
    }
    get conflictingAlts() {
        if (this._conflictInfo == null) return undefined;
        return this._conflictInfo.conflictedAlts;
    }
    get isExactConflict() {
        if (this._conflictInfo == null) return false;
        return this._conflictInfo.isExact;
    }
    get dipsIntoOuterContext() {
        return this._dipsIntoOuterContext;
    }
    get(index) {
        return this.configs[index];
    }
    ensureWritable() {
        if (this.isReadOnly) throw new Error("This ATNConfigSet is read only.");
    }
}
$2560fcc4d6753538$var$__decorate([
    $60gAE.NotNull
], $2560fcc4d6753538$var$ATNConfigSet.prototype, "getRepresentedAlternatives", null);
$2560fcc4d6753538$var$__decorate([
    $60gAE.Override
], $2560fcc4d6753538$var$ATNConfigSet.prototype, "size", null);
$2560fcc4d6753538$var$__decorate([
    $60gAE.Override
], $2560fcc4d6753538$var$ATNConfigSet.prototype, "isEmpty", null);
$2560fcc4d6753538$var$__decorate([
    $60gAE.Override
], $2560fcc4d6753538$var$ATNConfigSet.prototype, "contains", null);
$2560fcc4d6753538$var$__decorate([
    $60gAE.Override
], $2560fcc4d6753538$var$ATNConfigSet.prototype, Symbol.iterator, null);
$2560fcc4d6753538$var$__decorate([
    $60gAE.Override
], $2560fcc4d6753538$var$ATNConfigSet.prototype, "toArray", null);
$2560fcc4d6753538$var$__decorate([
    $60gAE.Override
], $2560fcc4d6753538$var$ATNConfigSet.prototype, "containsAll", null);
$2560fcc4d6753538$var$__decorate([
    $60gAE.Override
], $2560fcc4d6753538$var$ATNConfigSet.prototype, "clear", null);
$2560fcc4d6753538$var$__decorate([
    $60gAE.Override
], $2560fcc4d6753538$var$ATNConfigSet.prototype, "equals", null);
$2560fcc4d6753538$var$__decorate([
    $60gAE.Override
], $2560fcc4d6753538$var$ATNConfigSet.prototype, "hashCode", null);
module.exports.ATNConfigSet = $2560fcc4d6753538$var$ATNConfigSet;

});
parcelRegister("lz4Ok", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fb30992b95214277$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fb30992b95214277$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfig = void 0;

var $cqAje = parcelRequire("cqAje");

var $cpDvh = parcelRequire("cpDvh");

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");

var $cWz6y = parcelRequire("cWz6y");

var $gT9VD = parcelRequire("gT9VD");

var $gt6ZZ = parcelRequire("gt6ZZ");

var $lzl5a = parcelRequire("lzl5a");
/**
 * This field stores the bit mask for implementing the
 * {@link #isPrecedenceFilterSuppressed} property as a bit within the
 * existing {@link #altAndOuterContextDepth} field.
 */ const $fb30992b95214277$var$SUPPRESS_PRECEDENCE_FILTER = 0x80000000;
/**
 * Represents a location with context in an ATN. The location is identified by the following values:
 *
 * * The current ATN state
 * * The predicted alternative
 * * The semantic context which must be true for this configuration to be enabled
 * * The syntactic context, which is represented as a graph-structured stack whose path(s) lead to the root of the rule
 *   invocations leading to this state
 *
 * In addition to these values, `ATNConfig` stores several properties about paths taken to get to the location which
 * were added over time to help with performance, correctness, and/or debugging.
 *
 * * `reachesIntoOuterContext`:: Used to ensure semantic predicates are not evaluated in the wrong context.
 * * `hasPassedThroughNonGreedyDecision`: Used for enabling first-match-wins instead of longest-match-wins after
 *   crossing a non-greedy decision.
 * * `lexerActionExecutor`: Used for tracking the lexer action(s) to execute should this instance be selected during
 *   lexing.
 * * `isPrecedenceFilterSuppressed`: A state variable for one of the dynamic disambiguation strategies employed by
 *   `ParserATNSimulator.applyPrecedenceFilter`.
 *
 * Due to the use of a graph-structured stack, a single `ATNConfig` is capable of representing many individual ATN
 * configurations which reached the same location in an ATN by following different paths.
 *
 * PERF: To conserve memory, `ATNConfig` is split into several different concrete types. `ATNConfig` itself stores the
 * minimum amount of information typically used to define an `ATNConfig` instance. Various derived types provide
 * additional storage space for cases where a non-default value is used for some of the object properties. The
 * `ATNConfig.create` and `ATNConfig.transform` methods automatically select the smallest concrete type capable of
 * representing the unique information for any given `ATNConfig`.
 */ let $fb30992b95214277$var$ATNConfig = class ATNConfig {
    constructor(state, altOrConfig, context){
        if (typeof altOrConfig === "number") {
            $lzl5a((altOrConfig & 0xFFFFFF) === altOrConfig);
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig;
            this._context = context;
        } else {
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig.altAndOuterContextDepth;
            this._context = context;
        }
    }
    static create(state, alt, context, semanticContext = $gt6ZZ.SemanticContext.NONE, lexerActionExecutor) {
        if (semanticContext !== $gt6ZZ.SemanticContext.NONE) {
            if (lexerActionExecutor != null) return new $fb30992b95214277$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, alt, context, false);
            else return new $fb30992b95214277$var$SemanticContextATNConfig(semanticContext, state, alt, context);
        } else if (lexerActionExecutor != null) return new $fb30992b95214277$var$ActionATNConfig(lexerActionExecutor, state, alt, context, false);
        else return new ATNConfig(state, alt, context);
    }
    /** Gets the ATN state associated with this configuration */ get state() {
        return this._state;
    }
    /** What alt (or lexer rule) is predicted by this configuration */ get alt() {
        return this.altAndOuterContextDepth & 0x00FFFFFF;
    }
    get context() {
        return this._context;
    }
    set context(context) {
        this._context = context;
    }
    get reachesIntoOuterContext() {
        return this.outerContextDepth !== 0;
    }
    /**
     * We cannot execute predicates dependent upon local context unless
     * we know for sure we are in the correct context. Because there is
     * no way to do this efficiently, we simply cannot evaluate
     * dependent predicates unless we are in the rule that initially
     * invokes the ATN simulator.
     *
     * closure() tracks the depth of how far we dip into the outer context:
     * depth &gt; 0.  Note that it may not be totally accurate depth since I
     * don't ever decrement. TODO: make it a boolean then
     */ get outerContextDepth() {
        return this.altAndOuterContextDepth >>> 24 & 0x7F;
    }
    set outerContextDepth(outerContextDepth) {
        $lzl5a(outerContextDepth >= 0);
        // saturate at 0x7F - everything but zero/positive is only used for debug information anyway
        outerContextDepth = Math.min(outerContextDepth, 0x7F);
        this.altAndOuterContextDepth = outerContextDepth << 24 | (this.altAndOuterContextDepth & -2130706433) >>> 0;
    }
    get lexerActionExecutor() {
        return undefined;
    }
    get semanticContext() {
        return $gt6ZZ.SemanticContext.NONE;
    }
    get hasPassedThroughNonGreedyDecision() {
        return false;
    }
    clone() {
        return this.transform(this.state, false);
    }
    transform(/*@NotNull*/ state, checkNonGreedy, arg2) {
        if (arg2 == null) return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $gT9VD.PredictionContext) return this.transformImpl(state, arg2, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $gt6ZZ.SemanticContext) return this.transformImpl(state, this._context, arg2, checkNonGreedy, this.lexerActionExecutor);
        else return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, arg2);
    }
    transformImpl(state, context, semanticContext, checkNonGreedy, lexerActionExecutor) {
        let passedThroughNonGreedy = checkNonGreedy && ATNConfig.checkNonGreedyDecision(this, state);
        if (semanticContext !== $gt6ZZ.SemanticContext.NONE) {
            if (lexerActionExecutor != null || passedThroughNonGreedy) return new $fb30992b95214277$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, this, context, passedThroughNonGreedy);
            else return new $fb30992b95214277$var$SemanticContextATNConfig(semanticContext, state, this, context);
        } else if (lexerActionExecutor != null || passedThroughNonGreedy) return new $fb30992b95214277$var$ActionATNConfig(lexerActionExecutor, state, this, context, passedThroughNonGreedy);
        else return new ATNConfig(state, this, context);
    }
    static checkNonGreedyDecision(source, target) {
        return source.hasPassedThroughNonGreedyDecision || target instanceof $cpDvh.DecisionState && target.nonGreedy;
    }
    appendContext(context, contextCache) {
        if (typeof context === "number") {
            let appendedContext = this.context.appendSingleContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        } else {
            let appendedContext = this.context.appendContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        }
    }
    /**
     * Determines if this `ATNConfig` fully contains another `ATNConfig`.
     *
     * An ATN configuration represents a position (including context) in an ATN during parsing. Since `ATNConfig` stores
     * the context as a graph, a single `ATNConfig` instance is capable of representing many ATN configurations which
     * are all in the same "location" but have different contexts. These `ATNConfig` instances are again merged when
     * they are added to an `ATNConfigSet`. This method supports `ATNConfigSet.contains` by evaluating whether a
     * particular `ATNConfig` contains all of the ATN configurations represented by another `ATNConfig`.
     *
     * An `ATNConfig` _a_ contains another `ATNConfig` _b_ if all of the following conditions are met:
     *
     * * The configurations are in the same state (`state`)
     * * The configurations predict the same alternative (`alt`)
     * * The semantic context of _a_ implies the semantic context of _b_ (this method performs a weaker equality check)
     * * Joining the prediction contexts of _a_ and _b_ results in the prediction context of _a_
     *
     * This method implements a conservative approximation of containment. As a result, when this method returns `true`
     * it is known that parsing from `subconfig` can only recognize a subset of the inputs which can be recognized
     * starting at the current `ATNConfig`. However, due to the imprecise evaluation of implication for the semantic
     * contexts, no assumptions can be made about the relationship between the configurations when this method returns
     * `false`.
     *
     * @param subconfig The sub configuration.
     * @returns `true` if this configuration contains `subconfig`; otherwise, `false`.
     */ contains(subconfig) {
        if (this.state.stateNumber !== subconfig.state.stateNumber || this.alt !== subconfig.alt || !this.semanticContext.equals(subconfig.semanticContext)) return false;
        let leftWorkList = [];
        let rightWorkList = [];
        leftWorkList.push(this.context);
        rightWorkList.push(subconfig.context);
        while(true){
            let left = leftWorkList.pop();
            let right = rightWorkList.pop();
            if (!left || !right) break;
            if (left === right) return true;
            if (left.size < right.size) return false;
            if (right.isEmpty) return left.hasEmpty;
            else for(let i = 0; i < right.size; i++){
                let index = left.findReturnState(right.getReturnState(i));
                if (index < 0) // assumes invokingStates has no duplicate entries
                return false;
                leftWorkList.push(left.getParent(index));
                rightWorkList.push(right.getParent(i));
            }
        }
        return false;
    }
    get isPrecedenceFilterSuppressed() {
        return (this.altAndOuterContextDepth & $fb30992b95214277$var$SUPPRESS_PRECEDENCE_FILTER) !== 0;
    }
    set isPrecedenceFilterSuppressed(value) {
        if (value) this.altAndOuterContextDepth |= $fb30992b95214277$var$SUPPRESS_PRECEDENCE_FILTER;
        else this.altAndOuterContextDepth &= ~$fb30992b95214277$var$SUPPRESS_PRECEDENCE_FILTER;
    }
    /** An ATN configuration is equal to another if both have
     *  the same state, they predict the same alternative, and
     *  syntactic/semantic contexts are the same.
     */ equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ATNConfig)) return false;
        return this.state.stateNumber === o.state.stateNumber && this.alt === o.alt && this.reachesIntoOuterContext === o.reachesIntoOuterContext && this.context.equals(o.context) && this.semanticContext.equals(o.semanticContext) && this.isPrecedenceFilterSuppressed === o.isPrecedenceFilterSuppressed && this.hasPassedThroughNonGreedyDecision === o.hasPassedThroughNonGreedyDecision && $cWz6y.ObjectEqualityComparator.INSTANCE.equals(this.lexerActionExecutor, o.lexerActionExecutor);
    }
    hashCode() {
        let hashCode = $ecbo5.MurmurHash.initialize(7);
        hashCode = $ecbo5.MurmurHash.update(hashCode, this.state.stateNumber);
        hashCode = $ecbo5.MurmurHash.update(hashCode, this.alt);
        hashCode = $ecbo5.MurmurHash.update(hashCode, this.reachesIntoOuterContext ? 1 : 0);
        hashCode = $ecbo5.MurmurHash.update(hashCode, this.context);
        hashCode = $ecbo5.MurmurHash.update(hashCode, this.semanticContext);
        hashCode = $ecbo5.MurmurHash.update(hashCode, this.hasPassedThroughNonGreedyDecision ? 1 : 0);
        hashCode = $ecbo5.MurmurHash.update(hashCode, this.lexerActionExecutor);
        hashCode = $ecbo5.MurmurHash.finish(hashCode, 7);
        return hashCode;
    }
    /**
     * Returns a graphical representation of the current `ATNConfig` in Graphviz format. The graph can be stored to a
     * **.dot** file and then rendered to an image using Graphviz.
     *
     * @returns A Graphviz graph representing the current `ATNConfig`.
     *
     * @see http://www.graphviz.org/
     */ toDotString() {
        let builder = "";
        builder += "digraph G {\n";
        builder += "rankdir=LR;\n";
        let visited = new $cqAje.Array2DHashMap($gT9VD.PredictionContext.IdentityEqualityComparator.INSTANCE);
        let workList = [];
        function getOrAddContext(context) {
            let newNumber = visited.size;
            let result = visited.putIfAbsent(context, newNumber);
            if (result != null) // Already saw this context
            return result;
            workList.push(context);
            return newNumber;
        }
        workList.push(this.context);
        visited.put(this.context, 0);
        while(true){
            let current = workList.pop();
            if (!current) break;
            for(let i = 0; i < current.size; i++){
                builder += "  s" + getOrAddContext(current);
                builder += "->";
                builder += "s" + getOrAddContext(current.getParent(i));
                builder += "[label=\"" + current.getReturnState(i) + "\"];\n";
            }
        }
        builder += "}\n";
        return builder.toString();
    }
    toString(recog, showAlt, showContext) {
        // Must check showContext before showAlt to preserve original overload behavior
        if (showContext == null) showContext = showAlt != null;
        if (showAlt == null) showAlt = true;
        let buf = "";
        // if (this.state.ruleIndex >= 0) {
        // 	if (recog != null) {
        // 		buf += (recog.ruleNames[this.state.ruleIndex] + ":");
        // 	} else {
        // 		buf += (this.state.ruleIndex + ":");
        // 	}
        // }
        let contexts;
        if (showContext) contexts = this.context.toStrings(recog, this.state.stateNumber);
        else contexts = [
            "?"
        ];
        let first = true;
        for (let contextDesc of contexts){
            if (first) first = false;
            else buf += ", ";
            buf += "(";
            buf += this.state;
            if (showAlt) {
                buf += ",";
                buf += this.alt;
            }
            if (this.context) {
                buf += ",";
                buf += contextDesc;
            }
            if (this.semanticContext !== $gt6ZZ.SemanticContext.NONE) {
                buf += ",";
                buf += this.semanticContext;
            }
            if (this.reachesIntoOuterContext) buf += ",up=" + this.outerContextDepth;
            buf += ")";
        }
        return buf.toString();
    }
};
$fb30992b95214277$var$__decorate([
    $60gAE.NotNull
], $fb30992b95214277$var$ATNConfig.prototype, "_state", void 0);
$fb30992b95214277$var$__decorate([
    $60gAE.NotNull
], $fb30992b95214277$var$ATNConfig.prototype, "_context", void 0);
$fb30992b95214277$var$__decorate([
    $60gAE.NotNull
], $fb30992b95214277$var$ATNConfig.prototype, "state", null);
$fb30992b95214277$var$__decorate([
    $60gAE.NotNull,
    $fb30992b95214277$var$__param(0, $60gAE.NotNull)
], $fb30992b95214277$var$ATNConfig.prototype, "context", null);
$fb30992b95214277$var$__decorate([
    $60gAE.NotNull
], $fb30992b95214277$var$ATNConfig.prototype, "semanticContext", null);
$fb30992b95214277$var$__decorate([
    $60gAE.Override
], $fb30992b95214277$var$ATNConfig.prototype, "clone", null);
$fb30992b95214277$var$__decorate([
    $fb30992b95214277$var$__param(0, $60gAE.NotNull),
    $fb30992b95214277$var$__param(2, $60gAE.NotNull)
], $fb30992b95214277$var$ATNConfig.prototype, "transformImpl", null);
$fb30992b95214277$var$__decorate([
    $60gAE.Override
], $fb30992b95214277$var$ATNConfig.prototype, "equals", null);
$fb30992b95214277$var$__decorate([
    $60gAE.Override
], $fb30992b95214277$var$ATNConfig.prototype, "hashCode", null);
$fb30992b95214277$var$__decorate([
    $fb30992b95214277$var$__param(0, $60gAE.NotNull),
    $fb30992b95214277$var$__param(3, $60gAE.NotNull)
], $fb30992b95214277$var$ATNConfig, "create", null);
$fb30992b95214277$var$ATNConfig = $fb30992b95214277$var$__decorate([
    $fb30992b95214277$var$__param(0, $60gAE.NotNull),
    $fb30992b95214277$var$__param(2, $60gAE.NotNull)
], $fb30992b95214277$var$ATNConfig);
module.exports.ATNConfig = $fb30992b95214277$var$ATNConfig;
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $fb30992b95214277$var$SemanticContextATNConfig = class SemanticContextATNConfig extends $fb30992b95214277$var$ATNConfig {
    constructor(semanticContext, state, altOrConfig, context){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else super(state, altOrConfig, context);
        this._semanticContext = semanticContext;
    }
    get semanticContext() {
        return this._semanticContext;
    }
};
$fb30992b95214277$var$__decorate([
    $60gAE.NotNull
], $fb30992b95214277$var$SemanticContextATNConfig.prototype, "_semanticContext", void 0);
$fb30992b95214277$var$__decorate([
    $60gAE.Override
], $fb30992b95214277$var$SemanticContextATNConfig.prototype, "semanticContext", null);
$fb30992b95214277$var$SemanticContextATNConfig = $fb30992b95214277$var$__decorate([
    $fb30992b95214277$var$__param(1, $60gAE.NotNull),
    $fb30992b95214277$var$__param(2, $60gAE.NotNull)
], $fb30992b95214277$var$SemanticContextATNConfig);
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a lexer action.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $fb30992b95214277$var$ActionATNConfig = class ActionATNConfig extends $fb30992b95214277$var$ATNConfig {
    constructor(lexerActionExecutor, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else {
            super(state, altOrConfig, context);
            if (altOrConfig.semanticContext !== $gt6ZZ.SemanticContext.NONE) throw new Error("Not supported");
        }
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$fb30992b95214277$var$__decorate([
    $60gAE.Override
], $fb30992b95214277$var$ActionATNConfig.prototype, "lexerActionExecutor", null);
$fb30992b95214277$var$__decorate([
    $60gAE.Override
], $fb30992b95214277$var$ActionATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$fb30992b95214277$var$ActionATNConfig = $fb30992b95214277$var$__decorate([
    $fb30992b95214277$var$__param(1, $60gAE.NotNull),
    $fb30992b95214277$var$__param(2, $60gAE.NotNull)
], $fb30992b95214277$var$ActionATNConfig);
/**
 * This class was derived from `SemanticContextATNConfig` purely as a memory optimization. It allows for the creation of
 * an `ATNConfig` with both a lexer action and a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $fb30992b95214277$var$ActionSemanticContextATNConfig = class ActionSemanticContextATNConfig extends $fb30992b95214277$var$SemanticContextATNConfig {
    constructor(lexerActionExecutor, semanticContext, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(semanticContext, state, altOrConfig, context);
        else super(semanticContext, state, altOrConfig, context);
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$fb30992b95214277$var$__decorate([
    $60gAE.Override
], $fb30992b95214277$var$ActionSemanticContextATNConfig.prototype, "lexerActionExecutor", null);
$fb30992b95214277$var$__decorate([
    $60gAE.Override
], $fb30992b95214277$var$ActionSemanticContextATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$fb30992b95214277$var$ActionSemanticContextATNConfig = $fb30992b95214277$var$__decorate([
    $fb30992b95214277$var$__param(1, $60gAE.NotNull),
    $fb30992b95214277$var$__param(2, $60gAE.NotNull)
], $fb30992b95214277$var$ActionSemanticContextATNConfig);

});
parcelRegister("cpDvh", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionState = void 0;

var $gh8QV = parcelRequire("gh8QV");
class $9096766d69945747$var$DecisionState extends $gh8QV.ATNState {
    constructor(){
        super(...arguments);
        this.decision = -1;
        this.nonGreedy = false;
        this.sll = false;
    }
}
module.exports.DecisionState = $9096766d69945747$var$DecisionState;

});

parcelRegister("gT9VD", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c4b97c064e122f9e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c4b97c064e122f9e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SingletonPredictionContext = module.exports.PredictionContext = void 0;

var $cqAje = parcelRequire("cqAje");

var $fqc4S = parcelRequire("fqc4S");

var $5Zd5d = parcelRequire("5Zd5d");

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");

var $fCMxU = parcelRequire("fCMxU");

var $lzl5a = parcelRequire("lzl5a");
const $c4b97c064e122f9e$var$INITIAL_HASH = 1;
class $c4b97c064e122f9e$var$PredictionContext {
    constructor(cachedHashCode){
        this.cachedHashCode = cachedHashCode;
    }
    static calculateEmptyHashCode() {
        let hash = $ecbo5.MurmurHash.initialize($c4b97c064e122f9e$var$INITIAL_HASH);
        hash = $ecbo5.MurmurHash.finish(hash, 0);
        return hash;
    }
    static calculateSingleHashCode(parent, returnState) {
        let hash = $ecbo5.MurmurHash.initialize($c4b97c064e122f9e$var$INITIAL_HASH);
        hash = $ecbo5.MurmurHash.update(hash, parent);
        hash = $ecbo5.MurmurHash.update(hash, returnState);
        hash = $ecbo5.MurmurHash.finish(hash, 2);
        return hash;
    }
    static calculateHashCode(parents, returnStates) {
        let hash = $ecbo5.MurmurHash.initialize($c4b97c064e122f9e$var$INITIAL_HASH);
        for (let parent of parents)hash = $ecbo5.MurmurHash.update(hash, parent);
        for (let returnState of returnStates)hash = $ecbo5.MurmurHash.update(hash, returnState);
        hash = $ecbo5.MurmurHash.finish(hash, 2 * parents.length);
        return hash;
    }
    static fromRuleContext(atn, outerContext, fullContext = true) {
        if (outerContext.isEmpty) return fullContext ? $c4b97c064e122f9e$var$PredictionContext.EMPTY_FULL : $c4b97c064e122f9e$var$PredictionContext.EMPTY_LOCAL;
        let parent;
        if (outerContext._parent) parent = $c4b97c064e122f9e$var$PredictionContext.fromRuleContext(atn, outerContext._parent, fullContext);
        else parent = fullContext ? $c4b97c064e122f9e$var$PredictionContext.EMPTY_FULL : $c4b97c064e122f9e$var$PredictionContext.EMPTY_LOCAL;
        let state = atn.states[outerContext.invokingState];
        let transition = state.transition(0);
        return parent.getChild(transition.followState.stateNumber);
    }
    static addEmptyContext(context) {
        return context.addEmptyContext();
    }
    static removeEmptyContext(context) {
        return context.removeEmptyContext();
    }
    static join(context0, context1, contextCache = $fCMxU.PredictionContextCache.UNCACHED) {
        if (context0 === context1) return context0;
        if (context0.isEmpty) return $c4b97c064e122f9e$var$PredictionContext.isEmptyLocal(context0) ? context0 : $c4b97c064e122f9e$var$PredictionContext.addEmptyContext(context1);
        else if (context1.isEmpty) return $c4b97c064e122f9e$var$PredictionContext.isEmptyLocal(context1) ? context1 : $c4b97c064e122f9e$var$PredictionContext.addEmptyContext(context0);
        let context0size = context0.size;
        let context1size = context1.size;
        if (context0size === 1 && context1size === 1 && context0.getReturnState(0) === context1.getReturnState(0)) {
            let merged = contextCache.join(context0.getParent(0), context1.getParent(0));
            if (merged === context0.getParent(0)) return context0;
            else if (merged === context1.getParent(0)) return context1;
            else return merged.getChild(context0.getReturnState(0));
        }
        let count = 0;
        let parentsList = new Array(context0size + context1size);
        let returnStatesList = new Array(parentsList.length);
        let leftIndex = 0;
        let rightIndex = 0;
        let canReturnLeft = true;
        let canReturnRight = true;
        while(leftIndex < context0size && rightIndex < context1size){
            if (context0.getReturnState(leftIndex) === context1.getReturnState(rightIndex)) {
                parentsList[count] = contextCache.join(context0.getParent(leftIndex), context1.getParent(rightIndex));
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnLeft = canReturnLeft && parentsList[count] === context0.getParent(leftIndex);
                canReturnRight = canReturnRight && parentsList[count] === context1.getParent(rightIndex);
                leftIndex++;
                rightIndex++;
            } else if (context0.getReturnState(leftIndex) < context1.getReturnState(rightIndex)) {
                parentsList[count] = context0.getParent(leftIndex);
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnRight = false;
                leftIndex++;
            } else {
                $lzl5a(context1.getReturnState(rightIndex) < context0.getReturnState(leftIndex));
                parentsList[count] = context1.getParent(rightIndex);
                returnStatesList[count] = context1.getReturnState(rightIndex);
                canReturnLeft = false;
                rightIndex++;
            }
            count++;
        }
        while(leftIndex < context0size){
            parentsList[count] = context0.getParent(leftIndex);
            returnStatesList[count] = context0.getReturnState(leftIndex);
            leftIndex++;
            canReturnRight = false;
            count++;
        }
        while(rightIndex < context1size){
            parentsList[count] = context1.getParent(rightIndex);
            returnStatesList[count] = context1.getReturnState(rightIndex);
            rightIndex++;
            canReturnLeft = false;
            count++;
        }
        if (canReturnLeft) return context0;
        else if (canReturnRight) return context1;
        if (count < parentsList.length) {
            parentsList = parentsList.slice(0, count);
            returnStatesList = returnStatesList.slice(0, count);
        }
        if (parentsList.length === 0) // if one of them was EMPTY_LOCAL, it would be empty and handled at the beginning of the method
        return $c4b97c064e122f9e$var$PredictionContext.EMPTY_FULL;
        else if (parentsList.length === 1) return new $c4b97c064e122f9e$var$SingletonPredictionContext(parentsList[0], returnStatesList[0]);
        else return new $c4b97c064e122f9e$var$ArrayPredictionContext(parentsList, returnStatesList);
    }
    static isEmptyLocal(context) {
        return context === $c4b97c064e122f9e$var$PredictionContext.EMPTY_LOCAL;
    }
    static getCachedContext(context, contextCache, visited) {
        if (context.isEmpty) return context;
        let existing = visited.get(context);
        if (existing) return existing;
        existing = contextCache.get(context);
        if (existing) {
            visited.put(context, existing);
            return existing;
        }
        let changed = false;
        let parents = new Array(context.size);
        for(let i = 0; i < parents.length; i++){
            let parent = $c4b97c064e122f9e$var$PredictionContext.getCachedContext(context.getParent(i), contextCache, visited);
            if (changed || parent !== context.getParent(i)) {
                if (!changed) {
                    parents = new Array(context.size);
                    for(let j = 0; j < context.size; j++)parents[j] = context.getParent(j);
                    changed = true;
                }
                parents[i] = parent;
            }
        }
        if (!changed) {
            existing = contextCache.putIfAbsent(context, context);
            visited.put(context, existing != null ? existing : context);
            return context;
        }
        // We know parents.length>0 because context.isEmpty is checked at the beginning of the method.
        let updated;
        if (parents.length === 1) updated = new $c4b97c064e122f9e$var$SingletonPredictionContext(parents[0], context.getReturnState(0));
        else {
            let returnStates = new Array(context.size);
            for(let i = 0; i < context.size; i++)returnStates[i] = context.getReturnState(i);
            updated = new $c4b97c064e122f9e$var$ArrayPredictionContext(parents, returnStates, context.hashCode());
        }
        existing = contextCache.putIfAbsent(updated, updated);
        visited.put(updated, existing || updated);
        visited.put(context, existing || updated);
        return updated;
    }
    appendSingleContext(returnContext, contextCache) {
        return this.appendContext($c4b97c064e122f9e$var$PredictionContext.EMPTY_FULL.getChild(returnContext), contextCache);
    }
    getChild(returnState) {
        return new $c4b97c064e122f9e$var$SingletonPredictionContext(this, returnState);
    }
    hashCode() {
        return this.cachedHashCode;
    }
    toStrings(recognizer, currentState, stop = $c4b97c064e122f9e$var$PredictionContext.EMPTY_FULL) {
        let result = [];
        outer: for(let perm = 0;; perm++){
            let offset = 0;
            let last = true;
            let p = this;
            let stateNumber = currentState;
            let localBuffer = "";
            localBuffer += "[";
            while(!p.isEmpty && p !== stop){
                let index = 0;
                if (p.size > 0) {
                    let bits = 1;
                    while(1 << bits >>> 0 < p.size)bits++;
                    let mask = (1 << bits >>> 0) - 1;
                    index = perm >> offset & mask;
                    last = last && index >= p.size - 1;
                    if (index >= p.size) continue outer;
                    offset += bits;
                }
                if (recognizer) {
                    if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                    localBuffer += " ";
                    let atn = recognizer.atn;
                    let s = atn.states[stateNumber];
                    let ruleName = recognizer.ruleNames[s.ruleIndex];
                    localBuffer += ruleName;
                } else if (p.getReturnState(index) !== $c4b97c064e122f9e$var$PredictionContext.EMPTY_FULL_STATE_KEY) {
                    if (!p.isEmpty) {
                        if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                        localBuffer += " ";
                        localBuffer += p.getReturnState(index);
                    }
                }
                stateNumber = p.getReturnState(index);
                p = p.getParent(index);
            }
            localBuffer += "]";
            result.push(localBuffer);
            if (last) break;
        }
        return result;
    }
}
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$PredictionContext.prototype, "hashCode", null);
$c4b97c064e122f9e$var$__decorate([
    $c4b97c064e122f9e$var$__param(0, $60gAE.NotNull),
    $c4b97c064e122f9e$var$__param(1, $60gAE.NotNull),
    $c4b97c064e122f9e$var$__param(2, $60gAE.NotNull)
], $c4b97c064e122f9e$var$PredictionContext, "join", null);
$c4b97c064e122f9e$var$__decorate([
    $c4b97c064e122f9e$var$__param(0, $60gAE.NotNull),
    $c4b97c064e122f9e$var$__param(1, $60gAE.NotNull),
    $c4b97c064e122f9e$var$__param(2, $60gAE.NotNull)
], $c4b97c064e122f9e$var$PredictionContext, "getCachedContext", null);
module.exports.PredictionContext = $c4b97c064e122f9e$var$PredictionContext;
class $c4b97c064e122f9e$var$EmptyPredictionContext extends $c4b97c064e122f9e$var$PredictionContext {
    constructor(fullContext){
        super($c4b97c064e122f9e$var$PredictionContext.calculateEmptyHashCode());
        this.fullContext = fullContext;
    }
    get isFullContext() {
        return this.fullContext;
    }
    addEmptyContext() {
        return this;
    }
    removeEmptyContext() {
        throw new Error("Cannot remove the empty context from itself.");
    }
    getParent(index) {
        throw new Error("index out of bounds");
    }
    getReturnState(index) {
        throw new Error("index out of bounds");
    }
    findReturnState(returnState) {
        return -1;
    }
    get size() {
        return 0;
    }
    appendSingleContext(returnContext, contextCache) {
        return contextCache.getChild(this, returnContext);
    }
    appendContext(suffix, contextCache) {
        return suffix;
    }
    get isEmpty() {
        return true;
    }
    get hasEmpty() {
        return true;
    }
    equals(o) {
        return this === o;
    }
    toStrings(recognizer, currentState, stop) {
        return [
            "[]"
        ];
    }
}
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$EmptyPredictionContext.prototype, "addEmptyContext", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$EmptyPredictionContext.prototype, "removeEmptyContext", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$EmptyPredictionContext.prototype, "getParent", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$EmptyPredictionContext.prototype, "getReturnState", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$EmptyPredictionContext.prototype, "findReturnState", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$EmptyPredictionContext.prototype, "size", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$EmptyPredictionContext.prototype, "appendSingleContext", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$EmptyPredictionContext.prototype, "appendContext", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$EmptyPredictionContext.prototype, "isEmpty", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$EmptyPredictionContext.prototype, "hasEmpty", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$EmptyPredictionContext.prototype, "equals", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$EmptyPredictionContext.prototype, "toStrings", null);
let $c4b97c064e122f9e$var$ArrayPredictionContext = class ArrayPredictionContext extends $c4b97c064e122f9e$var$PredictionContext {
    constructor(parents, returnStates, hashCode){
        super(hashCode || $c4b97c064e122f9e$var$PredictionContext.calculateHashCode(parents, returnStates));
        $lzl5a(parents.length === returnStates.length);
        $lzl5a(returnStates.length > 1 || returnStates[0] !== $c4b97c064e122f9e$var$PredictionContext.EMPTY_FULL_STATE_KEY, "Should be using PredictionContext.EMPTY instead.");
        this.parents = parents;
        this.returnStates = returnStates;
    }
    getParent(index) {
        return this.parents[index];
    }
    getReturnState(index) {
        return this.returnStates[index];
    }
    findReturnState(returnState) {
        return $5Zd5d.Arrays.binarySearch(this.returnStates, returnState);
    }
    get size() {
        return this.returnStates.length;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return this.returnStates[this.returnStates.length - 1] === $c4b97c064e122f9e$var$PredictionContext.EMPTY_FULL_STATE_KEY;
    }
    addEmptyContext() {
        if (this.hasEmpty) return this;
        let parents2 = this.parents.slice(0);
        let returnStates2 = this.returnStates.slice(0);
        parents2.push($c4b97c064e122f9e$var$PredictionContext.EMPTY_FULL);
        returnStates2.push($c4b97c064e122f9e$var$PredictionContext.EMPTY_FULL_STATE_KEY);
        return new ArrayPredictionContext(parents2, returnStates2);
    }
    removeEmptyContext() {
        if (!this.hasEmpty) return this;
        if (this.returnStates.length === 2) return new $c4b97c064e122f9e$var$SingletonPredictionContext(this.parents[0], this.returnStates[0]);
        else {
            let parents2 = this.parents.slice(0, this.parents.length - 1);
            let returnStates2 = this.returnStates.slice(0, this.returnStates.length - 1);
            return new ArrayPredictionContext(parents2, returnStates2);
        }
    }
    appendContext(suffix, contextCache) {
        return ArrayPredictionContext.appendContextImpl(this, suffix, new $c4b97c064e122f9e$var$PredictionContext.IdentityHashMap());
    }
    static appendContextImpl(context, suffix, visited) {
        if (suffix.isEmpty) {
            if ($c4b97c064e122f9e$var$PredictionContext.isEmptyLocal(suffix)) {
                if (context.hasEmpty) return $c4b97c064e122f9e$var$PredictionContext.EMPTY_LOCAL;
                throw new Error("what to do here?");
            }
            return context;
        }
        if (suffix.size !== 1) throw new Error("Appending a tree suffix is not yet supported.");
        let result = visited.get(context);
        if (!result) {
            if (context.isEmpty) result = suffix;
            else {
                let parentCount = context.size;
                if (context.hasEmpty) parentCount--;
                let updatedParents = new Array(parentCount);
                let updatedReturnStates = new Array(parentCount);
                for(let i = 0; i < parentCount; i++)updatedReturnStates[i] = context.getReturnState(i);
                for(let i = 0; i < parentCount; i++)updatedParents[i] = ArrayPredictionContext.appendContextImpl(context.getParent(i), suffix, visited);
                if (updatedParents.length === 1) result = new $c4b97c064e122f9e$var$SingletonPredictionContext(updatedParents[0], updatedReturnStates[0]);
                else {
                    $lzl5a(updatedParents.length > 1);
                    result = new ArrayPredictionContext(updatedParents, updatedReturnStates);
                }
                if (context.hasEmpty) result = $c4b97c064e122f9e$var$PredictionContext.join(result, suffix);
            }
            visited.put(context, result);
        }
        return result;
    }
    equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ArrayPredictionContext)) return false;
        if (this.hashCode() !== o.hashCode()) // can't be same if hash is different
        return false;
        let other = o;
        return this.equalsImpl(other, new $fqc4S.Array2DHashSet());
    }
    equalsImpl(other, visited) {
        let selfWorkList = [];
        let otherWorkList = [];
        selfWorkList.push(this);
        otherWorkList.push(other);
        while(true){
            let currentSelf = selfWorkList.pop();
            let currentOther = otherWorkList.pop();
            if (!currentSelf || !currentOther) break;
            let operands = new $fCMxU.PredictionContextCache.IdentityCommutativePredictionContextOperands(currentSelf, currentOther);
            if (!visited.add(operands)) continue;
            let selfSize = operands.x.size;
            if (selfSize === 0) {
                if (!operands.x.equals(operands.y)) return false;
                continue;
            }
            let otherSize = operands.y.size;
            if (selfSize !== otherSize) return false;
            for(let i = 0; i < selfSize; i++){
                if (operands.x.getReturnState(i) !== operands.y.getReturnState(i)) return false;
                let selfParent = operands.x.getParent(i);
                let otherParent = operands.y.getParent(i);
                if (selfParent.hashCode() !== otherParent.hashCode()) return false;
                if (selfParent !== otherParent) {
                    selfWorkList.push(selfParent);
                    otherWorkList.push(otherParent);
                }
            }
        }
        return true;
    }
};
$c4b97c064e122f9e$var$__decorate([
    $60gAE.NotNull
], $c4b97c064e122f9e$var$ArrayPredictionContext.prototype, "parents", void 0);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.NotNull
], $c4b97c064e122f9e$var$ArrayPredictionContext.prototype, "returnStates", void 0);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$ArrayPredictionContext.prototype, "getParent", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$ArrayPredictionContext.prototype, "getReturnState", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$ArrayPredictionContext.prototype, "findReturnState", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$ArrayPredictionContext.prototype, "size", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$ArrayPredictionContext.prototype, "isEmpty", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$ArrayPredictionContext.prototype, "hasEmpty", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$ArrayPredictionContext.prototype, "addEmptyContext", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$ArrayPredictionContext.prototype, "removeEmptyContext", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$ArrayPredictionContext.prototype, "appendContext", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$ArrayPredictionContext.prototype, "equals", null);
$c4b97c064e122f9e$var$ArrayPredictionContext = $c4b97c064e122f9e$var$__decorate([
    $c4b97c064e122f9e$var$__param(0, $60gAE.NotNull)
], $c4b97c064e122f9e$var$ArrayPredictionContext);
let $c4b97c064e122f9e$var$SingletonPredictionContext = class SingletonPredictionContext extends $c4b97c064e122f9e$var$PredictionContext {
    constructor(parent, returnState){
        super($c4b97c064e122f9e$var$PredictionContext.calculateSingleHashCode(parent, returnState));
        // assert(returnState != PredictionContext.EMPTY_FULL_STATE_KEY && returnState != PredictionContext.EMPTY_LOCAL_STATE_KEY);
        this.parent = parent;
        this.returnState = returnState;
    }
    getParent(index) {
        // assert(index == 0);
        return this.parent;
    }
    getReturnState(index) {
        // assert(index == 0);
        return this.returnState;
    }
    findReturnState(returnState) {
        return this.returnState === returnState ? 0 : -1;
    }
    get size() {
        return 1;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return false;
    }
    appendContext(suffix, contextCache) {
        return contextCache.getChild(this.parent.appendContext(suffix, contextCache), this.returnState);
    }
    addEmptyContext() {
        let parents = [
            this.parent,
            $c4b97c064e122f9e$var$PredictionContext.EMPTY_FULL
        ];
        let returnStates = [
            this.returnState,
            $c4b97c064e122f9e$var$PredictionContext.EMPTY_FULL_STATE_KEY
        ];
        return new $c4b97c064e122f9e$var$ArrayPredictionContext(parents, returnStates);
    }
    removeEmptyContext() {
        return this;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof SingletonPredictionContext)) return false;
        let other = o;
        if (this.hashCode() !== other.hashCode()) return false;
        return this.returnState === other.returnState && this.parent.equals(other.parent);
    }
};
$c4b97c064e122f9e$var$__decorate([
    $60gAE.NotNull
], $c4b97c064e122f9e$var$SingletonPredictionContext.prototype, "parent", void 0);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$SingletonPredictionContext.prototype, "getParent", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$SingletonPredictionContext.prototype, "getReturnState", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$SingletonPredictionContext.prototype, "findReturnState", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$SingletonPredictionContext.prototype, "size", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$SingletonPredictionContext.prototype, "isEmpty", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$SingletonPredictionContext.prototype, "hasEmpty", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$SingletonPredictionContext.prototype, "appendContext", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$SingletonPredictionContext.prototype, "addEmptyContext", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$SingletonPredictionContext.prototype, "removeEmptyContext", null);
$c4b97c064e122f9e$var$__decorate([
    $60gAE.Override
], $c4b97c064e122f9e$var$SingletonPredictionContext.prototype, "equals", null);
$c4b97c064e122f9e$var$SingletonPredictionContext = $c4b97c064e122f9e$var$__decorate([
    $c4b97c064e122f9e$var$__param(0, $60gAE.NotNull)
], $c4b97c064e122f9e$var$SingletonPredictionContext);
module.exports.SingletonPredictionContext = $c4b97c064e122f9e$var$SingletonPredictionContext;
(function(PredictionContext) {
    PredictionContext.EMPTY_LOCAL = new $c4b97c064e122f9e$var$EmptyPredictionContext(false);
    PredictionContext.EMPTY_FULL = new $c4b97c064e122f9e$var$EmptyPredictionContext(true);
    PredictionContext.EMPTY_LOCAL_STATE_KEY = -2147483648;
    PredictionContext.EMPTY_FULL_STATE_KEY = 2147483647;
    class IdentityHashMap extends $cqAje.Array2DHashMap {
        constructor(){
            super(IdentityEqualityComparator.INSTANCE);
        }
    }
    PredictionContext.IdentityHashMap = IdentityHashMap;
    class IdentityEqualityComparator {
        IdentityEqualityComparator() {
        // intentionally empty
        }
        hashCode(obj) {
            return obj.hashCode();
        }
        equals(a, b) {
            return a === b;
        }
    }
    IdentityEqualityComparator.INSTANCE = new IdentityEqualityComparator();
    $c4b97c064e122f9e$var$__decorate([
        $60gAE.Override
    ], IdentityEqualityComparator.prototype, "hashCode", null);
    $c4b97c064e122f9e$var$__decorate([
        $60gAE.Override
    ], IdentityEqualityComparator.prototype, "equals", null);
    PredictionContext.IdentityEqualityComparator = IdentityEqualityComparator;
})($c4b97c064e122f9e$var$PredictionContext = module.exports.PredictionContext || (module.exports.PredictionContext = {}));

});
parcelRegister("fCMxU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b6000fda887cf1ad$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionContextCache = void 0;

var $cqAje = parcelRequire("cqAje");

var $60gAE = parcelRequire("60gAE");

var $cWz6y = parcelRequire("cWz6y");

var $gT9VD = parcelRequire("gT9VD");

var $lzl5a = parcelRequire("lzl5a");
/** Used to cache {@link PredictionContext} objects. Its used for the shared
 *  context cash associated with contexts in DFA states. This cache
 *  can be used for both lexers and parsers.
 *
 * @author Sam Harwell
 */ class $b6000fda887cf1ad$var$PredictionContextCache {
    constructor(enableCache = true){
        this.contexts = new $cqAje.Array2DHashMap($cWz6y.ObjectEqualityComparator.INSTANCE);
        this.childContexts = new $cqAje.Array2DHashMap($cWz6y.ObjectEqualityComparator.INSTANCE);
        this.joinContexts = new $cqAje.Array2DHashMap($cWz6y.ObjectEqualityComparator.INSTANCE);
        this.enableCache = enableCache;
    }
    getAsCached(context) {
        if (!this.enableCache) return context;
        let result = this.contexts.get(context);
        if (!result) {
            result = context;
            this.contexts.put(context, context);
        }
        return result;
    }
    getChild(context, invokingState) {
        if (!this.enableCache) return context.getChild(invokingState);
        let operands = new $b6000fda887cf1ad$var$PredictionContextCache.PredictionContextAndInt(context, invokingState);
        let result = this.childContexts.get(operands);
        if (!result) {
            result = context.getChild(invokingState);
            result = this.getAsCached(result);
            this.childContexts.put(operands, result);
        }
        return result;
    }
    join(x, y) {
        if (!this.enableCache) return $gT9VD.PredictionContext.join(x, y, this);
        let operands = new $b6000fda887cf1ad$var$PredictionContextCache.IdentityCommutativePredictionContextOperands(x, y);
        let result = this.joinContexts.get(operands);
        if (result) return result;
        result = $gT9VD.PredictionContext.join(x, y, this);
        result = this.getAsCached(result);
        this.joinContexts.put(operands, result);
        return result;
    }
}
module.exports.PredictionContextCache = $b6000fda887cf1ad$var$PredictionContextCache;
$b6000fda887cf1ad$var$PredictionContextCache.UNCACHED = new $b6000fda887cf1ad$var$PredictionContextCache(false);
(function(PredictionContextCache) {
    class PredictionContextAndInt {
        constructor(obj, value){
            this.obj = obj;
            this.value = value;
        }
        equals(obj) {
            if (!(obj instanceof PredictionContextAndInt)) return false;
            else if (obj === this) return true;
            let other = obj;
            return this.value === other.value && (this.obj === other.obj || this.obj != null && this.obj.equals(other.obj));
        }
        hashCode() {
            let hashCode = 5;
            hashCode = 7 * hashCode + (this.obj != null ? this.obj.hashCode() : 0);
            hashCode = 7 * hashCode + this.value;
            return hashCode;
        }
    }
    $b6000fda887cf1ad$var$__decorate([
        $60gAE.Override
    ], PredictionContextAndInt.prototype, "equals", null);
    $b6000fda887cf1ad$var$__decorate([
        $60gAE.Override
    ], PredictionContextAndInt.prototype, "hashCode", null);
    PredictionContextCache.PredictionContextAndInt = PredictionContextAndInt;
    class IdentityCommutativePredictionContextOperands {
        constructor(x, y){
            $lzl5a(x != null);
            $lzl5a(y != null);
            this._x = x;
            this._y = y;
        }
        get x() {
            return this._x;
        }
        get y() {
            return this._y;
        }
        equals(o) {
            if (!(o instanceof IdentityCommutativePredictionContextOperands)) return false;
            else if (this === o) return true;
            let other = o;
            return this._x === other._x && this._y === other._y || this._x === other._y && this._y === other._x;
        }
        hashCode() {
            return this._x.hashCode() ^ this._y.hashCode();
        }
    }
    $b6000fda887cf1ad$var$__decorate([
        $60gAE.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "equals", null);
    $b6000fda887cf1ad$var$__decorate([
        $60gAE.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "hashCode", null);
    PredictionContextCache.IdentityCommutativePredictionContextOperands = IdentityCommutativePredictionContextOperands;
})($b6000fda887cf1ad$var$PredictionContextCache = module.exports.PredictionContextCache || (module.exports.PredictionContextCache = {}));

});



parcelRegister("igr91", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BitSet = void 0;

var $3djl0 = parcelRequire("3djl0");

var $ecbo5 = parcelRequire("ecbo5");
/**
 * Private empty array used to construct empty BitSets
 */ const $d4bec6fa89cf084e$var$EMPTY_DATA = new Uint16Array(0);
/**
 * Gets the word index of the `UInt16` element in `BitSet.data` containing the bit with the specified index.
 */ function $d4bec6fa89cf084e$var$getIndex(bitNumber) {
    return bitNumber >>> 4;
}
/**
 * Convert a word index into the bit index of the LSB of that word
 */ function $d4bec6fa89cf084e$var$unIndex(n) {
    return n * 16;
}
/**
 * Get's the bit number of the least signficant bit set LSB which is set in a word non-zero word;
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $d4bec6fa89cf084e$var$findLSBSet(word) {
    let bit = 1;
    for(let i = 0; i < 16; i++){
        if ((word & bit) !== 0) return i;
        bit = bit << 1 >>> 0;
    }
    throw new RangeError("No specified bit found");
}
function $d4bec6fa89cf084e$var$findMSBSet(word) {
    let bit = 32768;
    for(let i = 15; i >= 0; i--){
        if ((word & bit) !== 0) return i;
        bit = bit >>> 1;
    }
    throw new RangeError("No specified bit found");
}
/**
 * Gets a 16-bit mask with bit numbers fromBit to toBit (inclusive) set.
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $d4bec6fa89cf084e$var$bitsFor(fromBit, toBit) {
    fromBit &= 0xF;
    toBit &= 0xF;
    if (fromBit === toBit) return 1 << fromBit >>> 0;
    return 0xFFFF >>> 15 - toBit ^ 0xFFFF >>> 16 - fromBit;
}
/**
 * A lookup table for number of set bits in a 16-bit integer.   This is used to quickly count the cardinality (number of unique elements) of a BitSet.
 */ const $d4bec6fa89cf084e$var$POP_CNT = new Uint8Array(65536);
for(let i = 0; i < 16; i++){
    const stride = 1 << i >>> 0;
    let index = 0;
    while(index < $d4bec6fa89cf084e$var$POP_CNT.length){
        // skip the numbers where the bit isn't set
        index += stride;
        // increment the ones where the bit is set
        for(let j = 0; j < stride; j++){
            $d4bec6fa89cf084e$var$POP_CNT[index]++;
            index++;
        }
    }
}
class $d4bec6fa89cf084e$var$BitSet {
    /*
    ** constructor implementation
    */ constructor(arg){
        if (!arg) // covering the case of unspecified and nbits===0
        this.data = $d4bec6fa89cf084e$var$EMPTY_DATA;
        else if (typeof arg === "number") {
            if (arg < 0) throw new RangeError("nbits cannot be negative");
            else this.data = new Uint16Array($d4bec6fa89cf084e$var$getIndex(arg - 1) + 1);
        } else if (arg instanceof $d4bec6fa89cf084e$var$BitSet) this.data = arg.data.slice(0); // Clone the data
        else {
            let max = -1;
            for (let v of arg)if (max < v) max = v;
            this.data = new Uint16Array($d4bec6fa89cf084e$var$getIndex(max - 1) + 1);
            for (let v of arg)this.set(v);
        }
    }
    /**
     * Performs a logical **AND** of this target bit set with the argument bit set. This bit set is modified so that
     * each bit in it has the value `true` if and only if it both initially had the value `true` and the corresponding
     * bit in the bit set argument also had the value `true`.
     */ and(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $d4bec6fa89cf084e$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Clears all of the bits in this `BitSet` whose corresponding bit is set in the specified `BitSet`.
     */ andNot(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i] ^ 0xFFFF;
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $d4bec6fa89cf084e$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Returns the number of bits set to `true` in this `BitSet`.
     */ cardinality() {
        if (this.isEmpty) return 0;
        const data = this.data;
        const length = data.length;
        let result = 0;
        for(let i = 0; i < length; i++)result += $d4bec6fa89cf084e$var$POP_CNT[data[i]];
        return result;
    }
    clear(fromIndex, toIndex) {
        if (fromIndex == null) this.data.fill(0);
        else if (toIndex == null) this.set(fromIndex, false);
        else this.set(fromIndex, toIndex, false);
    }
    flip(fromIndex, toIndex) {
        if (toIndex == null) toIndex = fromIndex;
        if (fromIndex < 0 || toIndex < fromIndex) throw new RangeError();
        let word = $d4bec6fa89cf084e$var$getIndex(fromIndex);
        const lastWord = $d4bec6fa89cf084e$var$getIndex(toIndex);
        if (word === lastWord) this.data[word] ^= $d4bec6fa89cf084e$var$bitsFor(fromIndex, toIndex);
        else {
            this.data[word++] ^= $d4bec6fa89cf084e$var$bitsFor(fromIndex, 15);
            while(word < lastWord)this.data[word++] ^= 0xFFFF;
            this.data[word++] ^= $d4bec6fa89cf084e$var$bitsFor(0, toIndex);
        }
    }
    get(fromIndex, toIndex) {
        if (toIndex === undefined) return !!(this.data[$d4bec6fa89cf084e$var$getIndex(fromIndex)] & $d4bec6fa89cf084e$var$bitsFor(fromIndex, fromIndex));
        else {
            // return a BitSet
            let result = new $d4bec6fa89cf084e$var$BitSet(toIndex + 1);
            for(let i = fromIndex; i <= toIndex; i++)result.set(i, this.get(i));
            return result;
        }
    }
    /**
     * Returns true if the specified `BitSet` has any bits set to `true` that are also set to `true` in this `BitSet`.
     *
     * @param set `BitSet` to intersect with
     */ intersects(set) {
        let smallerLength = Math.min(this.length(), set.length());
        if (smallerLength === 0) return false;
        let bound = $d4bec6fa89cf084e$var$getIndex(smallerLength - 1);
        for(let i = 0; i <= bound; i++){
            if ((this.data[i] & set.data[i]) !== 0) return true;
        }
        return false;
    }
    /**
     * Returns true if this `BitSet` contains no bits that are set to `true`.
     */ get isEmpty() {
        return this.length() === 0;
    }
    /**
     * Returns the "logical size" of this `BitSet`: the index of the highest set bit in the `BitSet` plus one. Returns
     * zero if the `BitSet` contains no set bits.
     */ length() {
        if (!this.data.length) return 0;
        return this.previousSetBit($d4bec6fa89cf084e$var$unIndex(this.data.length) - 1) + 1;
    }
    /**
     * Returns the index of the first bit that is set to `false` that occurs on or after the specified starting index,
     * If no such bit exists then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $d4bec6fa89cf084e$var$getIndex(fromIndex);
        if (word > length) return -1;
        let ignore = 0xFFFF ^ $d4bec6fa89cf084e$var$bitsFor(fromIndex, 15);
        if ((data[word] | ignore) === 0xFFFF) {
            word++;
            ignore = 0;
            for(; word < length; word++){
                if (data[word] !== 0xFFFF) break;
            }
            if (word === length) // Hit the end
            return -1;
        }
        return $d4bec6fa89cf084e$var$unIndex(word) + $d4bec6fa89cf084e$var$findLSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the first bit that is set to `true` that occurs on or after the specified starting index.
     * If no such bit exists then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.nextSetBit(0); i >= 0; i = bs.nextSetBit(i + 1)) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $d4bec6fa89cf084e$var$getIndex(fromIndex);
        if (word > length) return -1;
        let mask = $d4bec6fa89cf084e$var$bitsFor(fromIndex, 15);
        if ((data[word] & mask) === 0) {
            word++;
            mask = 0xFFFF;
            for(; word < length; word++){
                if (data[word] !== 0) break;
            }
            if (word >= length) return -1;
        }
        return $d4bec6fa89cf084e$var$unIndex(word) + $d4bec6fa89cf084e$var$findLSBSet(data[word] & mask);
    }
    /**
     * Performs a logical **OR** of this bit set with the bit set argument. This bit set is modified so that a bit in it
     * has the value `true` if and only if it either already had the value `true` or the corresponding bit in the bit
     * set argument has the value `true`.
     */ or(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Or those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] | other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $d4bec6fa89cf084e$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord);
    }
    /**
     * Returns the index of the nearest bit that is set to `false` that occurs on or before the specified starting
     * index. If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $d4bec6fa89cf084e$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let ignore = 0xFFFF ^ $d4bec6fa89cf084e$var$bitsFor(0, fromIndex);
        if ((data[word] | ignore) === 0xFFFF) {
            ignore = 0;
            word--;
            for(; word >= 0; word--){
                if (data[word] !== 0xFFFF) break;
            }
            if (word < 0) // Hit the end
            return -1;
        }
        return $d4bec6fa89cf084e$var$unIndex(word) + $d4bec6fa89cf084e$var$findMSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the nearest bit that is set to `true` that occurs on or before the specified starting index.
     * If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.length(); (i = bs.previousSetBit(i-1)) >= 0; ) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $d4bec6fa89cf084e$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let mask = $d4bec6fa89cf084e$var$bitsFor(0, fromIndex);
        if ((data[word] & mask) === 0) {
            word--;
            mask = 0xFFFF;
            for(; word >= 0; word--){
                if (data[word] !== 0) break;
            }
            if (word < 0) return -1;
        }
        return $d4bec6fa89cf084e$var$unIndex(word) + $d4bec6fa89cf084e$var$findMSBSet(data[word] & mask);
    }
    set(fromIndex, toIndex, value) {
        if (toIndex === undefined) {
            toIndex = fromIndex;
            value = true;
        } else if (typeof toIndex === "boolean") {
            value = toIndex;
            toIndex = fromIndex;
        }
        if (value === undefined) value = true;
        if (fromIndex < 0 || fromIndex > toIndex) throw new RangeError();
        let word = $d4bec6fa89cf084e$var$getIndex(fromIndex);
        let lastWord = $d4bec6fa89cf084e$var$getIndex(toIndex);
        if (value && lastWord >= this.data.length) {
            // Grow array "just enough" for bits we need to set
            let temp = new Uint16Array(lastWord + 1);
            this.data.forEach((value, index)=>temp[index] = value);
            this.data = temp;
        } else if (!value) {
            // But there is no need to grow array to clear bits.
            if (word >= this.data.length) // Early exit
            return;
            if (lastWord >= this.data.length) {
                // Adjust work to fit array
                lastWord = this.data.length - 1;
                toIndex = this.data.length * 16 - 1;
            }
        }
        if (word === lastWord) this._setBits(word, value, $d4bec6fa89cf084e$var$bitsFor(fromIndex, toIndex));
        else {
            this._setBits(word++, value, $d4bec6fa89cf084e$var$bitsFor(fromIndex, 15));
            while(word < lastWord)this.data[word++] = value ? 0xFFFF : 0;
            this._setBits(word, value, $d4bec6fa89cf084e$var$bitsFor(0, toIndex));
        }
    }
    _setBits(word, value, mask) {
        if (value) this.data[word] |= mask;
        else this.data[word] &= 0xFFFF ^ mask;
    }
    /**
     * Returns the number of bits of space actually in use by this `BitSet` to represent bit values. The maximum element
     * in the set is the size - 1st element.
     */ get size() {
        return this.data.byteLength * 8;
    }
    /**
     * Returns a new byte array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let bytes = s.toByteArray();`
     * then `bytes.length === (s.length()+7)/8` and `s.get(n) === ((bytes[n/8] & (1<<(n%8))) != 0)` for all
     * `n < 8 * bytes.length`.
     */ // toByteArray(): Int8Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Returns a new integer array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let integers = s.toIntegerArray();`
     * then `integers.length === (s.length()+31)/32` and `s.get(n) === ((integers[n/32] & (1<<(n%32))) != 0)` for all
     * `n < 32 * integers.length`.
     */ // toIntegerArray(): Int32Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    hashCode() {
        return $ecbo5.MurmurHash.hashCode(this.data, 22);
    }
    /**
     * Compares this object against the specified object. The result is `true` if and only if the argument is not
     * `undefined` and is a `Bitset` object that has exactly the same set of bits set to `true` as this bit set. That
     * is, for every nonnegative index `k`,
     *
     * ```
     * ((BitSet)obj).get(k) == this.get(k)
     * ```
     *
     * must be true. The current sizes of the two bit sets are not compared.
     */ equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $d4bec6fa89cf084e$var$BitSet)) return false;
        const len = this.length();
        if (len !== obj.length()) return false;
        if (len === 0) return true;
        let bound = $d4bec6fa89cf084e$var$getIndex(len - 1);
        for(let i = 0; i <= bound; i++){
            if (this.data[i] !== obj.data[i]) return false;
        }
        return true;
    }
    /**
     * Returns a string representation of this bit set. For every index for which this `BitSet` contains a bit in the
     * set state, the decimal representation of that index is included in the result. Such indices are listed in order
     * from lowest to highest, separated by ", " (a comma and a space) and surrounded by braces, resulting in the usual
     * mathematical notation for a set of integers.
     *
     * Example:
     *
     *     BitSet drPepper = new BitSet();
     *
     * Now `drPepper.toString()` returns `"{}"`.
     *
     *     drPepper.set(2);
     *
     * Now `drPepper.toString()` returns `"{2}"`.
     *
     *     drPepper.set(4);
     *     drPepper.set(10);
     *
     * Now `drPepper.toString()` returns `"{2, 4, 10}"`.
     */ toString() {
        let result = "{";
        let first = true;
        for(let i = this.nextSetBit(0); i >= 0; i = this.nextSetBit(i + 1)){
            if (first) first = false;
            else result += ", ";
            result += i;
        }
        result += "}";
        return result;
    }
    // static valueOf(bytes: Int8Array): BitSet;
    // static valueOf(buffer: ArrayBuffer): BitSet;
    // static valueOf(integers: Int32Array): BitSet;
    // static valueOf(data: Int8Array | Int32Array | ArrayBuffer): BitSet {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Performs a logical **XOR** of this bit set with the bit set argument. This bit set is modified so that a bit in
     * it has the value `true` if and only if one of the following statements holds:
     *
     * * The bit initially has the value `true`, and the corresponding bit in the argument has the value `false`.
     * * The bit initially has the value `false`, and the corresponding bit in the argument has the value `true`.
     */ xor(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Xor those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] ^ other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $d4bec6fa89cf084e$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord + 1);
    }
    clone() {
        return new $d4bec6fa89cf084e$var$BitSet(this);
    }
    [Symbol.iterator]() {
        return new $d4bec6fa89cf084e$var$BitSetIterator(this.data);
    }
    // Overrides formatting for nodejs assert etc.
    [$3djl0.inspect.custom]() {
        return "BitSet " + this.toString();
    }
}
module.exports.BitSet = $d4bec6fa89cf084e$var$BitSet;
class $d4bec6fa89cf084e$var$BitSetIterator {
    constructor(data){
        this.data = data;
        this.index = 0;
        this.mask = 0xFFFF;
    }
    next() {
        while(this.index < this.data.length){
            const bits = this.data[this.index] & this.mask;
            if (bits !== 0) {
                const bitNumber = $d4bec6fa89cf084e$var$unIndex(this.index) + $d4bec6fa89cf084e$var$findLSBSet(bits);
                this.mask = $d4bec6fa89cf084e$var$bitsFor(bitNumber + 1, 15);
                return {
                    done: false,
                    value: bitNumber
                };
            }
            this.index++;
            this.mask = 0xFFFF;
        }
        return {
            done: true,
            value: -1
        };
    }
    [Symbol.iterator]() {
        return this;
    }
}

});


parcelRegister("hkiZ3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c9d307b51c5ae571$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFASerializer = void 0;

var $d5Bh2 = parcelRequire("d5Bh2");

var $60gAE = parcelRequire("60gAE");

var $gT9VD = parcelRequire("gT9VD");

var $dlP2K = parcelRequire("dlP2K");

var $7DbrH = parcelRequire("7DbrH");
/** A DFA walker that knows how to dump them to serialized strings. */ class $c9d307b51c5ae571$var$DFASerializer {
    constructor(dfa, vocabulary, ruleNames, atn){
        if (vocabulary instanceof $dlP2K.Recognizer) {
            ruleNames = vocabulary.ruleNames;
            atn = vocabulary.atn;
            vocabulary = vocabulary.vocabulary;
        } else if (!vocabulary) vocabulary = $7DbrH.VocabularyImpl.EMPTY_VOCABULARY;
        this.dfa = dfa;
        this.vocabulary = vocabulary;
        this.ruleNames = ruleNames;
        this.atn = atn;
    }
    toString() {
        if (!this.dfa.s0) return "";
        let buf = "";
        if (this.dfa.states) {
            let states = new Array(...this.dfa.states.toArray());
            states.sort((o1, o2)=>o1.stateNumber - o2.stateNumber);
            for (let s of states){
                let edges = s.getEdgeMap();
                let edgeKeys = [
                    ...edges.keys()
                ].sort((a, b)=>a - b);
                let contextEdges = s.getContextEdgeMap();
                let contextEdgeKeys = [
                    ...contextEdges.keys()
                ].sort((a, b)=>a - b);
                for (let entry of edgeKeys){
                    let value = edges.get(entry);
                    if ((value == null || value === $d5Bh2.ATNSimulator.ERROR) && !s.isContextSymbol(entry)) continue;
                    let contextSymbol = false;
                    buf += this.getStateString(s) + "-" + this.getEdgeLabel(entry) + "->";
                    if (s.isContextSymbol(entry)) {
                        buf += "!";
                        contextSymbol = true;
                    }
                    let t = value;
                    if (t && t.stateNumber !== $d5Bh2.ATNSimulator.ERROR.stateNumber) buf += this.getStateString(t) + "\n";
                    else if (contextSymbol) buf += "ctx\n";
                }
                if (s.isContextSensitive) for (let entry of contextEdgeKeys)buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
            }
        }
        let output = buf;
        if (output.length === 0) return "";
        //return Utils.sortLinesInString(output);
        return output;
    }
    getContextLabel(i) {
        if (i === $gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY) return "ctx:EMPTY_FULL";
        else if (i === $gT9VD.PredictionContext.EMPTY_LOCAL_STATE_KEY) return "ctx:EMPTY_LOCAL";
        if (this.atn && i > 0 && i <= this.atn.states.length) {
            let state = this.atn.states[i];
            let ruleIndex = state.ruleIndex;
            if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
        }
        return "ctx:" + String(i);
    }
    getEdgeLabel(i) {
        return this.vocabulary.getDisplayName(i);
    }
    getStateString(s) {
        if (s === $d5Bh2.ATNSimulator.ERROR) return "ERROR";
        let n = s.stateNumber;
        let stateStr = "s" + n;
        if (s.isAcceptState) {
            if (s.predicates) stateStr = ":s" + n + "=>" + s.predicates;
            else stateStr = ":s" + n + "=>" + s.prediction;
        }
        if (s.isContextSensitive) {
            stateStr += "*";
            for (let config of s.configs)if (config.reachesIntoOuterContext) {
                stateStr += "*";
                break;
            }
        }
        return stateStr;
    }
}
$c9d307b51c5ae571$var$__decorate([
    $60gAE.NotNull
], $c9d307b51c5ae571$var$DFASerializer.prototype, "dfa", void 0);
$c9d307b51c5ae571$var$__decorate([
    $60gAE.NotNull
], $c9d307b51c5ae571$var$DFASerializer.prototype, "vocabulary", void 0);
$c9d307b51c5ae571$var$__decorate([
    $60gAE.Override
], $c9d307b51c5ae571$var$DFASerializer.prototype, "toString", null);
module.exports.DFASerializer = $c9d307b51c5ae571$var$DFASerializer;

});
parcelRegister("d5Bh2", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9878a7ce9fa1b951$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9878a7ce9fa1b951$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNSimulator = void 0;

var $3cXWi = parcelRequire("3cXWi");

var $g3I27 = parcelRequire("g3I27");

var $60gAE = parcelRequire("60gAE");

var $gT9VD = parcelRequire("gT9VD");
let $9878a7ce9fa1b951$var$ATNSimulator = class ATNSimulator {
    constructor(atn){
        this.atn = atn;
    }
    static get ERROR() {
        if (!ATNSimulator._ERROR) {
            ATNSimulator._ERROR = new $g3I27.DFAState(new $3cXWi.ATNConfigSet());
            ATNSimulator._ERROR.stateNumber = $gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY;
        }
        return ATNSimulator._ERROR;
    }
    /**
     * Clear the DFA cache used by the current instance. Since the DFA cache may
     * be shared by multiple ATN simulators, this method may affect the
     * performance (but not accuracy) of other parsers which are being used
     * concurrently.
     *
     * @ if the current instance does not
     * support clearing the DFA.
     *
     * @since 4.3
     */ clearDFA() {
        this.atn.clearDFA();
    }
};
$9878a7ce9fa1b951$var$__decorate([
    $60gAE.NotNull
], $9878a7ce9fa1b951$var$ATNSimulator.prototype, "atn", void 0);
$9878a7ce9fa1b951$var$__decorate([
    $60gAE.NotNull
], $9878a7ce9fa1b951$var$ATNSimulator, "ERROR", null);
$9878a7ce9fa1b951$var$ATNSimulator = $9878a7ce9fa1b951$var$__decorate([
    $9878a7ce9fa1b951$var$__param(0, $60gAE.NotNull)
], $9878a7ce9fa1b951$var$ATNSimulator);
module.exports.ATNSimulator = $9878a7ce9fa1b951$var$ATNSimulator;
(function(ATNSimulator) {
    const RULE_VARIANT_DELIMITER = "$";
    const RULE_LF_VARIANT_MARKER = "$lf$";
    const RULE_NOLF_VARIANT_MARKER = "$nolf$";
})($9878a7ce9fa1b951$var$ATNSimulator = module.exports.ATNSimulator || (module.exports.ATNSimulator = {}));
module.exports.ATNSimulator = $9878a7ce9fa1b951$var$ATNSimulator;

});
parcelRegister("g3I27", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bb0f1536b26a8ac1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $bb0f1536b26a8ac1$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFAState = void 0;

var $dQ2fw = parcelRequire("dQ2fw");

var $igr91 = parcelRequire("igr91");

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");

var $gT9VD = parcelRequire("gT9VD");

var $lzl5a = parcelRequire("lzl5a");
/** A DFA state represents a set of possible ATN configurations.
 *  As Aho, Sethi, Ullman p. 117 says "The DFA uses its state
 *  to keep track of all possible states the ATN can be in after
 *  reading each input symbol.  That is to say, after reading
 *  input a1a2..an, the DFA is in a state that represents the
 *  subset T of the states of the ATN that are reachable from the
 *  ATN's start state along some path labeled a1a2..an."
 *  In conventional NFA&rarr;DFA conversion, therefore, the subset T
 *  would be a bitset representing the set of states the
 *  ATN could be in.  We need to track the alt predicted by each
 *  state as well, however.  More importantly, we need to maintain
 *  a stack of states, tracking the closure operations as they
 *  jump from rule to rule, emulating rule invocations (method calls).
 *  I have to add a stack to simulate the proper lookahead sequences for
 *  the underlying LL grammar from which the ATN was derived.
 *
 *  I use a set of ATNConfig objects not simple states.  An ATNConfig
 *  is both a state (ala normal conversion) and a RuleContext describing
 *  the chain of rules (if any) followed to arrive at that state.
 *
 *  A DFA state may have multiple references to a particular state,
 *  but with different ATN contexts (with same or different alts)
 *  meaning that state was reached via a different set of rule invocations.
 */ class $bb0f1536b26a8ac1$var$DFAState {
    /**
     * Constructs a new `DFAState`.
     *
     * @param configs The set of ATN configurations defining this state.
     */ constructor(configs){
        this.stateNumber = -1;
        this.configs = configs;
        this.edges = new Map();
        this.contextEdges = new Map();
    }
    get isContextSensitive() {
        return !!this.contextSymbols;
    }
    isContextSymbol(symbol) {
        if (!this.isContextSensitive) return false;
        return this.contextSymbols.get(symbol);
    }
    setContextSymbol(symbol) {
        $lzl5a(this.isContextSensitive);
        this.contextSymbols.set(symbol);
    }
    setContextSensitive(atn) {
        $lzl5a(!this.configs.isOutermostConfigSet);
        if (this.isContextSensitive) return;
        if (!this.contextSymbols) this.contextSymbols = new $igr91.BitSet();
    }
    get acceptStateInfo() {
        return this._acceptStateInfo;
    }
    set acceptStateInfo(acceptStateInfo) {
        this._acceptStateInfo = acceptStateInfo;
    }
    get isAcceptState() {
        return !!this._acceptStateInfo;
    }
    get prediction() {
        if (!this._acceptStateInfo) return $dQ2fw.ATN.INVALID_ALT_NUMBER;
        return this._acceptStateInfo.prediction;
    }
    get lexerActionExecutor() {
        if (!this._acceptStateInfo) return undefined;
        return this._acceptStateInfo.lexerActionExecutor;
    }
    getTarget(symbol) {
        return this.edges.get(symbol);
    }
    setTarget(symbol, target) {
        this.edges.set(symbol, target);
    }
    getEdgeMap() {
        return this.edges;
    }
    getContextTarget(invokingState) {
        if (invokingState === $gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        return this.contextEdges.get(invokingState);
    }
    setContextTarget(invokingState, target) {
        if (!this.isContextSensitive) throw new Error("The state is not context sensitive.");
        if (invokingState === $gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        this.contextEdges.set(invokingState, target);
    }
    getContextEdgeMap() {
        let map = new Map(this.contextEdges);
        let existing = map.get(-1);
        if (existing !== undefined) {
            if (map.size === 1) {
                let result = new Map();
                result.set($gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                return result;
            } else {
                map.delete(-1);
                map.set($gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
            }
        }
        return map;
    }
    hashCode() {
        let hash = $ecbo5.MurmurHash.initialize(7);
        hash = $ecbo5.MurmurHash.update(hash, this.configs.hashCode());
        hash = $ecbo5.MurmurHash.finish(hash, 1);
        return hash;
    }
    /**
     * Two {@link DFAState} instances are equal if their ATN configuration sets
     * are the same. This method is used to see if a state already exists.
     *
     * Because the number of alternatives and number of ATN configurations are
     * finite, there is a finite number of DFA states that can be processed.
     * This is necessary to show that the algorithm terminates.
     *
     * Cannot test the DFA state numbers here because in
     * {@link ParserATNSimulator#addDFAState} we need to know if any other state
     * exists that has this exact set of ATN configurations. The
     * {@link #stateNumber} is irrelevant.
     */ equals(o) {
        // compare set of ATN configurations in this set with other
        if (this === o) return true;
        if (!(o instanceof $bb0f1536b26a8ac1$var$DFAState)) return false;
        let other = o;
        let sameSet = this.configs.equals(other.configs);
        //		System.out.println("DFAState.equals: "+configs+(sameSet?"==":"!=")+other.configs);
        return sameSet;
    }
    toString() {
        let buf = "";
        buf += this.stateNumber + ":" + this.configs;
        if (this.isAcceptState) {
            buf += "=>";
            if (this.predicates) buf += this.predicates;
            else buf += this.prediction;
        }
        return buf.toString();
    }
}
$bb0f1536b26a8ac1$var$__decorate([
    $60gAE.NotNull
], $bb0f1536b26a8ac1$var$DFAState.prototype, "configs", void 0);
$bb0f1536b26a8ac1$var$__decorate([
    $60gAE.NotNull
], $bb0f1536b26a8ac1$var$DFAState.prototype, "edges", void 0);
$bb0f1536b26a8ac1$var$__decorate([
    $60gAE.NotNull
], $bb0f1536b26a8ac1$var$DFAState.prototype, "contextEdges", void 0);
$bb0f1536b26a8ac1$var$__decorate([
    $60gAE.Override
], $bb0f1536b26a8ac1$var$DFAState.prototype, "hashCode", null);
$bb0f1536b26a8ac1$var$__decorate([
    $60gAE.Override
], $bb0f1536b26a8ac1$var$DFAState.prototype, "equals", null);
$bb0f1536b26a8ac1$var$__decorate([
    $60gAE.Override
], $bb0f1536b26a8ac1$var$DFAState.prototype, "toString", null);
module.exports.DFAState = $bb0f1536b26a8ac1$var$DFAState;
(function(DFAState) {
    /** Map a predicate to a predicted alternative. */ let PredPrediction = class PredPrediction {
        constructor(pred, alt){
            this.alt = alt;
            this.pred = pred;
        }
        toString() {
            return "(" + this.pred + ", " + this.alt + ")";
        }
    };
    $bb0f1536b26a8ac1$var$__decorate([
        $60gAE.NotNull
    ], PredPrediction.prototype, "pred", void 0);
    $bb0f1536b26a8ac1$var$__decorate([
        $60gAE.Override
    ], PredPrediction.prototype, "toString", null);
    PredPrediction = $bb0f1536b26a8ac1$var$__decorate([
        $bb0f1536b26a8ac1$var$__param(0, $60gAE.NotNull)
    ], PredPrediction);
    DFAState.PredPrediction = PredPrediction;
})($bb0f1536b26a8ac1$var$DFAState = module.exports.DFAState || (module.exports.DFAState = {}));

});


parcelRegister("dlP2K", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9b84d4a80464f7cc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9b84d4a80464f7cc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $2gnp0 = parcelRequire("2gnp0");

var $kmhhl = parcelRequire("kmhhl");

var $60gAE = parcelRequire("60gAE");

var $iLVZN = parcelRequire("iLVZN");

var $5lo68 = parcelRequire("5lo68");
class $9b84d4a80464f7cc$var$Recognizer {
    constructor(){
        this._listeners = [
            $2gnp0.ConsoleErrorListener.INSTANCE
        ];
        this._stateNumber = -1;
    }
    /**
     * Get a map from token names to token types.
     *
     * Used for XPath and tree pattern compilation.
     */ getTokenTypeMap() {
        let vocabulary = this.vocabulary;
        let result = $9b84d4a80464f7cc$var$Recognizer.tokenTypeMapCache.get(vocabulary);
        if (result == null) {
            let intermediateResult = new Map();
            for(let i = 0; i <= this.atn.maxTokenType; i++){
                let literalName = vocabulary.getLiteralName(i);
                if (literalName != null) intermediateResult.set(literalName, i);
                let symbolicName = vocabulary.getSymbolicName(i);
                if (symbolicName != null) intermediateResult.set(symbolicName, i);
            }
            intermediateResult.set("EOF", $iLVZN.Token.EOF);
            result = intermediateResult;
            $9b84d4a80464f7cc$var$Recognizer.tokenTypeMapCache.set(vocabulary, result);
        }
        return result;
    }
    /**
     * Get a map from rule names to rule indexes.
     *
     * Used for XPath and tree pattern compilation.
     */ getRuleIndexMap() {
        let ruleNames = this.ruleNames;
        if (ruleNames == null) throw new Error("The current recognizer does not provide a list of rule names.");
        let result = $9b84d4a80464f7cc$var$Recognizer.ruleIndexMapCache.get(ruleNames);
        if (result == null) {
            result = $5lo68.toMap(ruleNames);
            $9b84d4a80464f7cc$var$Recognizer.ruleIndexMapCache.set(ruleNames, result);
        }
        return result;
    }
    getTokenType(tokenName) {
        let ttype = this.getTokenTypeMap().get(tokenName);
        if (ttype != null) return ttype;
        return $iLVZN.Token.INVALID_TYPE;
    }
    /**
     * If this recognizer was generated, it will have a serialized ATN
     * representation of the grammar.
     *
     * For interpreters, we don't know their serialized ATN despite having
     * created the interpreter from it.
     */ get serializedATN() {
        throw new Error("there is no serialized ATN");
    }
    /**
     * Get the {@link ATN} used by the recognizer for prediction.
     *
     * @returns The {@link ATN} used by the recognizer for prediction.
     */ get atn() {
        return this._interp.atn;
    }
    /**
     * Get the ATN interpreter used by the recognizer for prediction.
     *
     * @returns The ATN interpreter used by the recognizer for prediction.
     */ get interpreter() {
        return this._interp;
    }
    /**
     * Set the ATN interpreter used by the recognizer for prediction.
     *
     * @param interpreter The ATN interpreter used by the recognizer for
     * prediction.
     */ set interpreter(interpreter) {
        this._interp = interpreter;
    }
    /** If profiling during the parse/lex, this will return DecisionInfo records
     *  for each decision in recognizer in a ParseInfo object.
     *
     * @since 4.3
     */ get parseInfo() {
        return Promise.resolve(undefined);
    }
    /** What is the error header, normally line/character position information? */ getErrorHeader(e) {
        let token = e.getOffendingToken();
        if (!token) return "";
        let line = token.line;
        let charPositionInLine = token.charPositionInLine;
        return "line " + line + ":" + charPositionInLine;
    }
    /**
     * @exception NullPointerException if `listener` is `undefined`.
     */ addErrorListener(listener) {
        if (!listener) throw new TypeError("listener must not be null");
        this._listeners.push(listener);
    }
    removeErrorListener(listener) {
        let position = this._listeners.indexOf(listener);
        if (position !== -1) this._listeners.splice(position, 1);
    }
    removeErrorListeners() {
        this._listeners.length = 0;
    }
    getErrorListeners() {
        return this._listeners.slice(0);
    }
    getErrorListenerDispatch() {
        return new $kmhhl.ProxyErrorListener(this.getErrorListeners());
    }
    // subclass needs to override these if there are sempreds or actions
    // that the ATN interp needs to execute
    sempred(_localctx, ruleIndex, actionIndex) {
        return true;
    }
    precpred(localctx, precedence) {
        return true;
    }
    action(_localctx, ruleIndex, actionIndex) {
    // intentionally empty
    }
    get state() {
        return this._stateNumber;
    }
    /** Indicate that the recognizer has changed internal state that is
     *  consistent with the ATN state passed in.  This way we always know
     *  where we are in the ATN as the parser goes along. The rule
     *  context objects form a stack that lets us see the stack of
     *  invoking rules. Combine this and we have complete ATN
     *  configuration information.
     */ set state(atnState) {
        //		System.err.println("setState "+atnState);
        this._stateNumber = atnState;
    //		if ( traceATNStates ) _ctx.trace(atnState);
    }
}
$9b84d4a80464f7cc$var$Recognizer.EOF = -1;
$9b84d4a80464f7cc$var$Recognizer.tokenTypeMapCache = new WeakMap();
$9b84d4a80464f7cc$var$Recognizer.ruleIndexMapCache = new WeakMap();
$9b84d4a80464f7cc$var$__decorate([
    $60gAE.SuppressWarnings("serial"),
    $60gAE.NotNull
], $9b84d4a80464f7cc$var$Recognizer.prototype, "_listeners", void 0);
$9b84d4a80464f7cc$var$__decorate([
    $60gAE.NotNull
], $9b84d4a80464f7cc$var$Recognizer.prototype, "getTokenTypeMap", null);
$9b84d4a80464f7cc$var$__decorate([
    $60gAE.NotNull
], $9b84d4a80464f7cc$var$Recognizer.prototype, "getRuleIndexMap", null);
$9b84d4a80464f7cc$var$__decorate([
    $60gAE.NotNull
], $9b84d4a80464f7cc$var$Recognizer.prototype, "serializedATN", null);
$9b84d4a80464f7cc$var$__decorate([
    $60gAE.NotNull
], $9b84d4a80464f7cc$var$Recognizer.prototype, "atn", null);
$9b84d4a80464f7cc$var$__decorate([
    $60gAE.NotNull,
    $9b84d4a80464f7cc$var$__param(0, $60gAE.NotNull)
], $9b84d4a80464f7cc$var$Recognizer.prototype, "interpreter", null);
$9b84d4a80464f7cc$var$__decorate([
    $60gAE.NotNull,
    $9b84d4a80464f7cc$var$__param(0, $60gAE.NotNull)
], $9b84d4a80464f7cc$var$Recognizer.prototype, "getErrorHeader", null);
$9b84d4a80464f7cc$var$__decorate([
    $9b84d4a80464f7cc$var$__param(0, $60gAE.NotNull)
], $9b84d4a80464f7cc$var$Recognizer.prototype, "addErrorListener", null);
$9b84d4a80464f7cc$var$__decorate([
    $9b84d4a80464f7cc$var$__param(0, $60gAE.NotNull)
], $9b84d4a80464f7cc$var$Recognizer.prototype, "removeErrorListener", null);
$9b84d4a80464f7cc$var$__decorate([
    $60gAE.NotNull
], $9b84d4a80464f7cc$var$Recognizer.prototype, "getErrorListeners", null);
module.exports.Recognizer = $9b84d4a80464f7cc$var$Recognizer;

});
parcelRegister("2gnp0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleErrorListener = void 0;
/**
 *
 * @author Sam Harwell
 */ class $1a5f3a9a096d65d9$var$ConsoleErrorListener {
    /**
     * {@inheritDoc}
     *
     * This implementation prints messages to {@link System#err} containing the
     * values of `line`, `charPositionInLine`, and `msg` using
     * the following format.
     *
     * <pre>
     * line *line*:*charPositionInLine* *msg*
     * </pre>
     */ syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        console.error(`line ${line}:${charPositionInLine} ${msg}`);
    }
}
module.exports.ConsoleErrorListener = $1a5f3a9a096d65d9$var$ConsoleErrorListener;
/**
 * Provides a default instance of {@link ConsoleErrorListener}.
 */ $1a5f3a9a096d65d9$var$ConsoleErrorListener.INSTANCE = new $1a5f3a9a096d65d9$var$ConsoleErrorListener();

});

parcelRegister("kmhhl", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ed2343ea79d4f820$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ed2343ea79d4f820$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyErrorListener = void 0;

var $60gAE = parcelRequire("60gAE");
/**
 * This implementation of {@link ANTLRErrorListener} dispatches all calls to a
 * collection of delegate listeners. This reduces the effort required to support multiple
 * listeners.
 *
 * @author Sam Harwell
 */ class $ed2343ea79d4f820$var$ProxyErrorListener {
    constructor(delegates){
        this.delegates = delegates;
        if (!delegates) throw new Error("Invalid delegates");
    }
    getDelegates() {
        return this.delegates;
    }
    syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        this.delegates.forEach((listener)=>{
            if (listener.syntaxError) listener.syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e);
        });
    }
}
$ed2343ea79d4f820$var$__decorate([
    $60gAE.Override,
    $ed2343ea79d4f820$var$__param(0, $60gAE.NotNull),
    $ed2343ea79d4f820$var$__param(4, $60gAE.NotNull)
], $ed2343ea79d4f820$var$ProxyErrorListener.prototype, "syntaxError", null);
module.exports.ProxyErrorListener = $ed2343ea79d4f820$var$ProxyErrorListener;

});


parcelRegister("7DbrH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $58e50dd30cf41a11$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VocabularyImpl = void 0;

var $60gAE = parcelRequire("60gAE");

var $iLVZN = parcelRequire("iLVZN");
/**
 * This class provides a default implementation of the {@link Vocabulary}
 * interface.
 *
 * @author Sam Harwell
 */ class $58e50dd30cf41a11$var$VocabularyImpl {
    /**
     * Constructs a new instance of {@link VocabularyImpl} from the specified
     * literal, symbolic, and display token names.
     *
     * @param literalNames The literal names assigned to tokens, or an empty array
     * if no literal names are assigned.
     * @param symbolicNames The symbolic names assigned to tokens, or
     * an empty array if no symbolic names are assigned.
     * @param displayNames The display names assigned to tokens, or an empty array
     * to use the values in `literalNames` and `symbolicNames` as
     * the source of display names, as described in
     * {@link #getDisplayName(int)}.
     *
     * @see #getLiteralName(int)
     * @see #getSymbolicName(int)
     * @see #getDisplayName(int)
     */ constructor(literalNames, symbolicNames, displayNames){
        this.literalNames = literalNames;
        this.symbolicNames = symbolicNames;
        this.displayNames = displayNames;
        // See note here on -1 part: https://github.com/antlr/antlr4/pull/1146
        this._maxTokenType = Math.max(this.displayNames.length, Math.max(this.literalNames.length, this.symbolicNames.length)) - 1;
    }
    get maxTokenType() {
        return this._maxTokenType;
    }
    getLiteralName(tokenType) {
        if (tokenType >= 0 && tokenType < this.literalNames.length) return this.literalNames[tokenType];
        return undefined;
    }
    getSymbolicName(tokenType) {
        if (tokenType >= 0 && tokenType < this.symbolicNames.length) return this.symbolicNames[tokenType];
        if (tokenType === $iLVZN.Token.EOF) return "EOF";
        return undefined;
    }
    getDisplayName(tokenType) {
        if (tokenType >= 0 && tokenType < this.displayNames.length) {
            let displayName = this.displayNames[tokenType];
            if (displayName) return displayName;
        }
        let literalName = this.getLiteralName(tokenType);
        if (literalName) return literalName;
        let symbolicName = this.getSymbolicName(tokenType);
        if (symbolicName) return symbolicName;
        return String(tokenType);
    }
}
/**
 * Gets an empty {@link Vocabulary} instance.
 *
 * No literal or symbol names are assigned to token types, so
 * {@link #getDisplayName(int)} returns the numeric value for all tokens
 * except {@link Token#EOF}.
 */ $58e50dd30cf41a11$var$VocabularyImpl.EMPTY_VOCABULARY = new $58e50dd30cf41a11$var$VocabularyImpl([], [], []);
$58e50dd30cf41a11$var$__decorate([
    $60gAE.NotNull
], $58e50dd30cf41a11$var$VocabularyImpl.prototype, "literalNames", void 0);
$58e50dd30cf41a11$var$__decorate([
    $60gAE.NotNull
], $58e50dd30cf41a11$var$VocabularyImpl.prototype, "symbolicNames", void 0);
$58e50dd30cf41a11$var$__decorate([
    $60gAE.NotNull
], $58e50dd30cf41a11$var$VocabularyImpl.prototype, "displayNames", void 0);
$58e50dd30cf41a11$var$__decorate([
    $60gAE.Override
], $58e50dd30cf41a11$var$VocabularyImpl.prototype, "maxTokenType", null);
$58e50dd30cf41a11$var$__decorate([
    $60gAE.Override
], $58e50dd30cf41a11$var$VocabularyImpl.prototype, "getLiteralName", null);
$58e50dd30cf41a11$var$__decorate([
    $60gAE.Override
], $58e50dd30cf41a11$var$VocabularyImpl.prototype, "getSymbolicName", null);
$58e50dd30cf41a11$var$__decorate([
    $60gAE.Override,
    $60gAE.NotNull
], $58e50dd30cf41a11$var$VocabularyImpl.prototype, "getDisplayName", null);
$58e50dd30cf41a11$var$__decorate([
    $60gAE.NotNull
], $58e50dd30cf41a11$var$VocabularyImpl, "EMPTY_VOCABULARY", void 0);
module.exports.VocabularyImpl = $58e50dd30cf41a11$var$VocabularyImpl;

});


parcelRegister("epB7E", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a7e03233ec85c164$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a7e03233ec85c164$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerDFASerializer = void 0;

var $hkiZ3 = parcelRequire("hkiZ3");

var $60gAE = parcelRequire("60gAE");

var $7DbrH = parcelRequire("7DbrH");
let $a7e03233ec85c164$var$LexerDFASerializer = class LexerDFASerializer extends $hkiZ3.DFASerializer {
    constructor(dfa){
        super(dfa, $7DbrH.VocabularyImpl.EMPTY_VOCABULARY);
    }
    getEdgeLabel(i) {
        return "'" + String.fromCodePoint(i) + "'";
    }
};
$a7e03233ec85c164$var$__decorate([
    $60gAE.Override,
    $60gAE.NotNull
], $a7e03233ec85c164$var$LexerDFASerializer.prototype, "getEdgeLabel", null);
$a7e03233ec85c164$var$LexerDFASerializer = $a7e03233ec85c164$var$__decorate([
    $a7e03233ec85c164$var$__param(0, $60gAE.NotNull)
], $a7e03233ec85c164$var$LexerDFASerializer);
module.exports.LexerDFASerializer = $a7e03233ec85c164$var$LexerDFASerializer;

});

parcelRegister("1UcbM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $163479dd0b6b1ac9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopEntryState = void 0;

var $4txXj = parcelRequire("4txXj");

var $igr91 = parcelRequire("igr91");

var $cpDvh = parcelRequire("cpDvh");

var $60gAE = parcelRequire("60gAE");
class $163479dd0b6b1ac9$var$StarLoopEntryState extends $cpDvh.DecisionState {
    constructor(){
        super(...arguments);
        /**
         * Indicates whether this state can benefit from a precedence DFA during SLL
         * decision making.
         *
         * This is a computed property that is calculated during ATN deserialization
         * and stored for use in {@link ParserATNSimulator} and
         * {@link ParserInterpreter}.
         *
         * @see `DFA.isPrecedenceDfa`
         */ this.precedenceRuleDecision = false;
        /**
         * For precedence decisions, this set marks states *S* which have all
         * of the following characteristics:
         *
         * * One or more invocation sites of the current rule returns to
         *   *S*.
         * * The closure from *S* includes the current decision without
         *   passing through any rule invocations or stepping out of the current
         *   rule.
         *
         * This field is not used when {@link #precedenceRuleDecision} is
         * `false`.
         */ this.precedenceLoopbackStates = new $igr91.BitSet();
    }
    get stateType() {
        return $4txXj.ATNStateType.STAR_LOOP_ENTRY;
    }
}
$163479dd0b6b1ac9$var$__decorate([
    $60gAE.Override
], $163479dd0b6b1ac9$var$StarLoopEntryState.prototype, "stateType", null);
module.exports.StarLoopEntryState = $163479dd0b6b1ac9$var$StarLoopEntryState;

});


parcelRegister("dwSPu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9d98cb7e6286b916$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidState = void 0;

var $4txXj = parcelRequire("4txXj");

var $gVntA = parcelRequire("gVntA");

var $60gAE = parcelRequire("60gAE");
/**
 *
 * @author Sam Harwell
 */ class $9d98cb7e6286b916$var$InvalidState extends $gVntA.BasicState {
    get stateType() {
        return $4txXj.ATNStateType.INVALID_TYPE;
    }
}
$9d98cb7e6286b916$var$__decorate([
    $60gAE.Override
], $9d98cb7e6286b916$var$InvalidState.prototype, "stateType", null);
module.exports.InvalidState = $9d98cb7e6286b916$var$InvalidState;

});
parcelRegister("gVntA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c5242e131e36ab15$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicState = void 0;

var $gh8QV = parcelRequire("gh8QV");

var $4txXj = parcelRequire("4txXj");

var $60gAE = parcelRequire("60gAE");
/**
 *
 * @author Sam Harwell
 */ class $c5242e131e36ab15$var$BasicState extends $gh8QV.ATNState {
    get stateType() {
        return $4txXj.ATNStateType.BASIC;
    }
}
$c5242e131e36ab15$var$__decorate([
    $60gAE.Override
], $c5242e131e36ab15$var$BasicState.prototype, "stateType", null);
module.exports.BasicState = $c5242e131e36ab15$var$BasicState;

});


parcelRegister("9cygq", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6b2fd022d9cebcda$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6b2fd022d9cebcda$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LL1Analyzer = void 0;

var $22TGw = parcelRequire("22TGw");

var $fqc4S = parcelRequire("fqc4S");

var $lz4Ok = parcelRequire("lz4Ok");

var $igr91 = parcelRequire("igr91");

var $fkZzb = parcelRequire("fkZzb");

var $60gAE = parcelRequire("60gAE");

var $gYz0f = parcelRequire("gYz0f");

var $cWz6y = parcelRequire("cWz6y");

var $gT9VD = parcelRequire("gT9VD");

var $830He = parcelRequire("830He");

var $9ITLj = parcelRequire("9ITLj");

var $iLVZN = parcelRequire("iLVZN");

var $dhddq = parcelRequire("dhddq");
let $6b2fd022d9cebcda$var$LL1Analyzer = class LL1Analyzer {
    constructor(atn){
        this.atn = atn;
    }
    /**
     * Calculates the SLL(1) expected lookahead set for each outgoing transition
     * of an {@link ATNState}. The returned array has one element for each
     * outgoing transition in `s`. If the closure from transition
     * *i* leads to a semantic predicate before matching a symbol, the
     * element at index *i* of the result will be `undefined`.
     *
     * @param s the ATN state
     * @returns the expected symbols for each outgoing transition of `s`.
     */ getDecisionLookahead(s) {
        //		System.out.println("LOOK("+s.stateNumber+")");
        if (s == null) return undefined;
        let look = new Array(s.numberOfTransitions);
        for(let alt = 0; alt < s.numberOfTransitions; alt++){
            let current = new $fkZzb.IntervalSet();
            look[alt] = current;
            let lookBusy = new $fqc4S.Array2DHashSet($cWz6y.ObjectEqualityComparator.INSTANCE);
            let seeThruPreds = false; // fail to get lookahead upon pred
            this._LOOK(s.transition(alt).target, undefined, $gT9VD.PredictionContext.EMPTY_LOCAL, current, lookBusy, new $igr91.BitSet(), seeThruPreds, false);
            // Wipe out lookahead for this alternative if we found nothing
            // or we had a predicate when we !seeThruPreds
            if (current.size === 0 || current.contains(LL1Analyzer.HIT_PRED)) {
                current = undefined;
                look[alt] = current;
            }
        }
        return look;
    }
    LOOK(s, ctx, stopState) {
        if (stopState === undefined) {
            if (s.atn == null) throw new Error("Illegal state");
            stopState = s.atn.ruleToStopState[s.ruleIndex];
        } else if (stopState === null) // This is an explicit request to pass undefined as the stopState to _LOOK. Used to distinguish an overload
        // from the method which simply omits the stopState parameter.
        stopState = undefined;
        let r = new $fkZzb.IntervalSet();
        let seeThruPreds = true; // ignore preds; get all lookahead
        let addEOF = true;
        this._LOOK(s, stopState, ctx, r, new $fqc4S.Array2DHashSet(), new $igr91.BitSet(), seeThruPreds, addEOF);
        return r;
    }
    /**
     * Compute set of tokens that can follow `s` in the ATN in the
     * specified `ctx`.
     * <p/>
     * If `ctx` is {@link PredictionContext#EMPTY_LOCAL} and
     * `stopState` or the end of the rule containing `s` is reached,
     * {@link Token#EPSILON} is added to the result set. If `ctx` is not
     * {@link PredictionContext#EMPTY_LOCAL} and `addEOF` is `true`
     * and `stopState` or the end of the outermost rule is reached,
     * {@link Token#EOF} is added to the result set.
     *
     * @param s the ATN state.
     * @param stopState the ATN state to stop at. This can be a
     * {@link BlockEndState} to detect epsilon paths through a closure.
     * @param ctx The outer context, or {@link PredictionContext#EMPTY_LOCAL} if
     * the outer context should not be used.
     * @param look The result lookahead set.
     * @param lookBusy A set used for preventing epsilon closures in the ATN
     * from causing a stack overflow. Outside code should pass
     * `new HashSet<ATNConfig>` for this argument.
     * @param calledRuleStack A set used for preventing left recursion in the
     * ATN from causing a stack overflow. Outside code should pass
     * `new BitSet()` for this argument.
     * @param seeThruPreds `true` to true semantic predicates as
     * implicitly `true` and "see through them", otherwise `false`
     * to treat semantic predicates as opaque and add {@link #HIT_PRED} to the
     * result if one is encountered.
     * @param addEOF Add {@link Token#EOF} to the result if the end of the
     * outermost context is reached. This parameter has no effect if `ctx`
     * is {@link PredictionContext#EMPTY_LOCAL}.
     */ _LOOK(s, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
        //		System.out.println("_LOOK("+s.stateNumber+", ctx="+ctx);
        let c = $lz4Ok.ATNConfig.create(s, 0, ctx);
        if (!lookBusy.add(c)) return;
        if (s === stopState) {
            if ($gT9VD.PredictionContext.isEmptyLocal(ctx)) {
                look.add($iLVZN.Token.EPSILON);
                return;
            } else if (ctx.isEmpty) {
                if (addEOF) look.add($iLVZN.Token.EOF);
                return;
            }
        }
        if (s instanceof $830He.RuleStopState) {
            if (ctx.isEmpty && !$gT9VD.PredictionContext.isEmptyLocal(ctx)) {
                if (addEOF) look.add($iLVZN.Token.EOF);
                return;
            }
            let removed = calledRuleStack.get(s.ruleIndex);
            try {
                calledRuleStack.clear(s.ruleIndex);
                for(let i = 0; i < ctx.size; i++){
                    if (ctx.getReturnState(i) === $gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                    let returnState = this.atn.states[ctx.getReturnState(i)];
                    //					System.out.println("popping back to "+retState);
                    this._LOOK(returnState, stopState, ctx.getParent(i), look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                }
            } finally{
                if (removed) calledRuleStack.set(s.ruleIndex);
            }
        }
        let n = s.numberOfTransitions;
        for(let i = 0; i < n; i++){
            let t = s.transition(i);
            if (t instanceof $9ITLj.RuleTransition) {
                if (calledRuleStack.get(t.ruleIndex)) continue;
                let newContext = ctx.getChild(t.followState.stateNumber);
                try {
                    calledRuleStack.set(t.ruleIndex);
                    this._LOOK(t.target, stopState, newContext, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                } finally{
                    calledRuleStack.clear(t.ruleIndex);
                }
            } else if (t instanceof $22TGw.AbstractPredicateTransition) {
                if (seeThruPreds) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                else look.add(LL1Analyzer.HIT_PRED);
            } else if (t.isEpsilon) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
            else if (t instanceof $dhddq.WildcardTransition) look.addAll($fkZzb.IntervalSet.of($iLVZN.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
            else {
                //				System.out.println("adding "+ t);
                let set = t.label;
                if (set != null) {
                    if (t instanceof $gYz0f.NotSetTransition) set = set.complement($fkZzb.IntervalSet.of($iLVZN.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                    look.addAll(set);
                }
            }
        }
    }
};
/** Special value added to the lookahead sets to indicate that we hit
 *  a predicate during analysis if `seeThruPreds==false`.
 */ $6b2fd022d9cebcda$var$LL1Analyzer.HIT_PRED = $iLVZN.Token.INVALID_TYPE;
$6b2fd022d9cebcda$var$__decorate([
    $60gAE.NotNull
], $6b2fd022d9cebcda$var$LL1Analyzer.prototype, "atn", void 0);
$6b2fd022d9cebcda$var$__decorate([
    $60gAE.NotNull,
    $6b2fd022d9cebcda$var$__param(0, $60gAE.NotNull),
    $6b2fd022d9cebcda$var$__param(1, $60gAE.NotNull)
], $6b2fd022d9cebcda$var$LL1Analyzer.prototype, "LOOK", null);
$6b2fd022d9cebcda$var$__decorate([
    $6b2fd022d9cebcda$var$__param(0, $60gAE.NotNull),
    $6b2fd022d9cebcda$var$__param(2, $60gAE.NotNull),
    $6b2fd022d9cebcda$var$__param(3, $60gAE.NotNull),
    $6b2fd022d9cebcda$var$__param(4, $60gAE.NotNull),
    $6b2fd022d9cebcda$var$__param(5, $60gAE.NotNull)
], $6b2fd022d9cebcda$var$LL1Analyzer.prototype, "_LOOK", null);
$6b2fd022d9cebcda$var$LL1Analyzer = $6b2fd022d9cebcda$var$__decorate([
    $6b2fd022d9cebcda$var$__param(0, $60gAE.NotNull)
], $6b2fd022d9cebcda$var$LL1Analyzer);
module.exports.LL1Analyzer = $6b2fd022d9cebcda$var$LL1Analyzer;

});
parcelRegister("gYz0f", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c5bd66c762e545bd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c5bd66c762e545bd$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotSetTransition = void 0;

var $60gAE = parcelRequire("60gAE");

var $cxnFA = parcelRequire("cxnFA");
let $c5bd66c762e545bd$var$NotSetTransition = class NotSetTransition extends $cxnFA.SetTransition {
    constructor(target, set){
        super(target, set);
    }
    get serializationType() {
        return 8 /* NOT_SET */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
    }
    toString() {
        return "~" + super.toString();
    }
};
$c5bd66c762e545bd$var$__decorate([
    $60gAE.Override
], $c5bd66c762e545bd$var$NotSetTransition.prototype, "serializationType", null);
$c5bd66c762e545bd$var$__decorate([
    $60gAE.Override
], $c5bd66c762e545bd$var$NotSetTransition.prototype, "matches", null);
$c5bd66c762e545bd$var$__decorate([
    $60gAE.Override
], $c5bd66c762e545bd$var$NotSetTransition.prototype, "toString", null);
$c5bd66c762e545bd$var$NotSetTransition = $c5bd66c762e545bd$var$__decorate([
    $c5bd66c762e545bd$var$__param(0, $60gAE.NotNull),
    $c5bd66c762e545bd$var$__param(1, $60gAE.Nullable)
], $c5bd66c762e545bd$var$NotSetTransition);
module.exports.NotSetTransition = $c5bd66c762e545bd$var$NotSetTransition;

});
parcelRegister("cxnFA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $920aed71dbffeb75$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $920aed71dbffeb75$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetTransition = void 0;

var $fkZzb = parcelRequire("fkZzb");

var $60gAE = parcelRequire("60gAE");

var $iLVZN = parcelRequire("iLVZN");

var $lhxCK = parcelRequire("lhxCK");
/** A transition containing a set of values. */ let $920aed71dbffeb75$var$SetTransition = class SetTransition extends $lhxCK.Transition {
    // TODO (sam): should we really allow undefined here?
    constructor(target, set){
        super(target);
        if (set == null) set = $fkZzb.IntervalSet.of($iLVZN.Token.INVALID_TYPE);
        this.set = set;
    }
    get serializationType() {
        return 7 /* SET */ ;
    }
    get label() {
        return this.set;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this.set.contains(symbol);
    }
    toString() {
        return this.set.toString();
    }
};
$920aed71dbffeb75$var$__decorate([
    $60gAE.NotNull
], $920aed71dbffeb75$var$SetTransition.prototype, "set", void 0);
$920aed71dbffeb75$var$__decorate([
    $60gAE.Override
], $920aed71dbffeb75$var$SetTransition.prototype, "serializationType", null);
$920aed71dbffeb75$var$__decorate([
    $60gAE.Override,
    $60gAE.NotNull
], $920aed71dbffeb75$var$SetTransition.prototype, "label", null);
$920aed71dbffeb75$var$__decorate([
    $60gAE.Override
], $920aed71dbffeb75$var$SetTransition.prototype, "matches", null);
$920aed71dbffeb75$var$__decorate([
    $60gAE.Override,
    $60gAE.NotNull
], $920aed71dbffeb75$var$SetTransition.prototype, "toString", null);
$920aed71dbffeb75$var$SetTransition = $920aed71dbffeb75$var$__decorate([
    $920aed71dbffeb75$var$__param(0, $60gAE.NotNull),
    $920aed71dbffeb75$var$__param(1, $60gAE.Nullable)
], $920aed71dbffeb75$var$SetTransition);
module.exports.SetTransition = $920aed71dbffeb75$var$SetTransition;

});


parcelRegister("830He", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $5dbf24d025ef9a0b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStopState = void 0;

var $gh8QV = parcelRequire("gh8QV");

var $4txXj = parcelRequire("4txXj");

var $60gAE = parcelRequire("60gAE");
/** The last node in the ATN for a rule, unless that rule is the start symbol.
 *  In that case, there is one transition to EOF. Later, we might encode
 *  references to all calls to this rule to compute FOLLOW sets for
 *  error handling.
 */ class $5dbf24d025ef9a0b$var$RuleStopState extends $gh8QV.ATNState {
    get nonStopStateNumber() {
        return -1;
    }
    get stateType() {
        return $4txXj.ATNStateType.RULE_STOP;
    }
}
$5dbf24d025ef9a0b$var$__decorate([
    $60gAE.Override
], $5dbf24d025ef9a0b$var$RuleStopState.prototype, "nonStopStateNumber", null);
$5dbf24d025ef9a0b$var$__decorate([
    $60gAE.Override
], $5dbf24d025ef9a0b$var$RuleStopState.prototype, "stateType", null);
module.exports.RuleStopState = $5dbf24d025ef9a0b$var$RuleStopState;

});

parcelRegister("9ITLj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $71437a4a43248907$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $71437a4a43248907$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleTransition = void 0;

var $60gAE = parcelRequire("60gAE");

var $lhxCK = parcelRequire("lhxCK");
/** */ let $71437a4a43248907$var$RuleTransition = class RuleTransition extends $lhxCK.Transition {
    constructor(ruleStart, ruleIndex, precedence, followState){
        super(ruleStart);
        this.tailCall = false;
        this.optimizedTailCall = false;
        this.ruleIndex = ruleIndex;
        this.precedence = precedence;
        this.followState = followState;
    }
    get serializationType() {
        return 3 /* RULE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
};
$71437a4a43248907$var$__decorate([
    $60gAE.NotNull
], $71437a4a43248907$var$RuleTransition.prototype, "followState", void 0);
$71437a4a43248907$var$__decorate([
    $60gAE.Override
], $71437a4a43248907$var$RuleTransition.prototype, "serializationType", null);
$71437a4a43248907$var$__decorate([
    $60gAE.Override
], $71437a4a43248907$var$RuleTransition.prototype, "isEpsilon", null);
$71437a4a43248907$var$__decorate([
    $60gAE.Override
], $71437a4a43248907$var$RuleTransition.prototype, "matches", null);
$71437a4a43248907$var$RuleTransition = $71437a4a43248907$var$__decorate([
    $71437a4a43248907$var$__param(0, $60gAE.NotNull),
    $71437a4a43248907$var$__param(3, $60gAE.NotNull)
], $71437a4a43248907$var$RuleTransition);
module.exports.RuleTransition = $71437a4a43248907$var$RuleTransition;

});

parcelRegister("dhddq", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9aa71d3967208f97$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9aa71d3967208f97$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WildcardTransition = void 0;

var $60gAE = parcelRequire("60gAE");

var $lhxCK = parcelRequire("lhxCK");
let $9aa71d3967208f97$var$WildcardTransition = class WildcardTransition extends $lhxCK.Transition {
    constructor(target){
        super(target);
    }
    get serializationType() {
        return 9 /* WILDCARD */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
    }
    toString() {
        return ".";
    }
};
$9aa71d3967208f97$var$__decorate([
    $60gAE.Override
], $9aa71d3967208f97$var$WildcardTransition.prototype, "serializationType", null);
$9aa71d3967208f97$var$__decorate([
    $60gAE.Override
], $9aa71d3967208f97$var$WildcardTransition.prototype, "matches", null);
$9aa71d3967208f97$var$__decorate([
    $60gAE.Override,
    $60gAE.NotNull
], $9aa71d3967208f97$var$WildcardTransition.prototype, "toString", null);
$9aa71d3967208f97$var$WildcardTransition = $9aa71d3967208f97$var$__decorate([
    $9aa71d3967208f97$var$__param(0, $60gAE.NotNull)
], $9aa71d3967208f97$var$WildcardTransition);
module.exports.WildcardTransition = $9aa71d3967208f97$var$WildcardTransition;

});



parcelRegister("cVbvA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9683bc3fb09d6558$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9683bc3fb09d6558$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerActionExecutor = void 0;

var $faPBd = parcelRequire("faPBd");

var $dlToG = parcelRequire("dlToG");

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");
/**
 * Represents an executor for a sequence of lexer actions which traversed during
 * the matching operation of a lexer rule (token).
 *
 * The executor tracks position information for position-dependent lexer actions
 * efficiently, ensuring that actions appearing only at the end of the rule do
 * not cause bloating of the {@link DFA} created for the lexer.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $9683bc3fb09d6558$var$LexerActionExecutor = class LexerActionExecutor {
    /**
     * Constructs an executor for a sequence of {@link LexerAction} actions.
     * @param lexerActions The lexer actions to execute.
     */ constructor(lexerActions){
        this._lexerActions = lexerActions;
        let hash = $ecbo5.MurmurHash.initialize();
        for (let lexerAction of lexerActions)hash = $ecbo5.MurmurHash.update(hash, lexerAction);
        this.cachedHashCode = $ecbo5.MurmurHash.finish(hash, lexerActions.length);
    }
    /**
     * Creates a {@link LexerActionExecutor} which executes the actions for
     * the input `lexerActionExecutor` followed by a specified
     * `lexerAction`.
     *
     * @param lexerActionExecutor The executor for actions already traversed by
     * the lexer while matching a token within a particular
     * {@link ATNConfig}. If this is `undefined`, the method behaves as though
     * it were an empty executor.
     * @param lexerAction The lexer action to execute after the actions
     * specified in `lexerActionExecutor`.
     *
     * @returns A {@link LexerActionExecutor} for executing the combine actions
     * of `lexerActionExecutor` and `lexerAction`.
     */ static append(lexerActionExecutor, lexerAction) {
        if (!lexerActionExecutor) return new LexerActionExecutor([
            lexerAction
        ]);
        let lexerActions = lexerActionExecutor._lexerActions.slice(0);
        lexerActions.push(lexerAction);
        return new LexerActionExecutor(lexerActions);
    }
    /**
     * Creates a {@link LexerActionExecutor} which encodes the current offset
     * for position-dependent lexer actions.
     *
     * Normally, when the executor encounters lexer actions where
     * {@link LexerAction#isPositionDependent} returns `true`, it calls
     * {@link IntStream#seek} on the input {@link CharStream} to set the input
     * position to the *end* of the current token. This behavior provides
     * for efficient DFA representation of lexer actions which appear at the end
     * of a lexer rule, even when the lexer rule matches a variable number of
     * characters.
     *
     * Prior to traversing a match transition in the ATN, the current offset
     * from the token start index is assigned to all position-dependent lexer
     * actions which have not already been assigned a fixed offset. By storing
     * the offsets relative to the token start index, the DFA representation of
     * lexer actions which appear in the middle of tokens remains efficient due
     * to sharing among tokens of the same length, regardless of their absolute
     * position in the input stream.
     *
     * If the current executor already has offsets assigned to all
     * position-dependent lexer actions, the method returns `this`.
     *
     * @param offset The current offset to assign to all position-dependent
     * lexer actions which do not already have offsets assigned.
     *
     * @returns A {@link LexerActionExecutor} which stores input stream offsets
     * for all position-dependent lexer actions.
     */ fixOffsetBeforeMatch(offset) {
        let updatedLexerActions;
        for(let i = 0; i < this._lexerActions.length; i++)if (this._lexerActions[i].isPositionDependent && !(this._lexerActions[i] instanceof $dlToG.LexerIndexedCustomAction)) {
            if (!updatedLexerActions) updatedLexerActions = this._lexerActions.slice(0);
            updatedLexerActions[i] = new $dlToG.LexerIndexedCustomAction(offset, this._lexerActions[i]);
        }
        if (!updatedLexerActions) return this;
        return new LexerActionExecutor(updatedLexerActions);
    }
    /**
     * Gets the lexer actions to be executed by this executor.
     * @returns The lexer actions to be executed by this executor.
     */ get lexerActions() {
        return this._lexerActions;
    }
    /**
     * Execute the actions encapsulated by this executor within the context of a
     * particular {@link Lexer}.
     *
     * This method calls {@link IntStream#seek} to set the position of the
     * `input` {@link CharStream} prior to calling
     * {@link LexerAction#execute} on a position-dependent action. Before the
     * method returns, the input position will be restored to the same position
     * it was in when the method was invoked.
     *
     * @param lexer The lexer instance.
     * @param input The input stream which is the source for the current token.
     * When this method is called, the current {@link IntStream#index} for
     * `input` should be the start of the following token, i.e. 1
     * character past the end of the current token.
     * @param startIndex The token start index. This value may be passed to
     * {@link IntStream#seek} to set the `input` position to the beginning
     * of the token.
     */ execute(lexer, input, startIndex) {
        let requiresSeek = false;
        let stopIndex = input.index;
        try {
            for (let lexerAction of this._lexerActions){
                if (lexerAction instanceof $dlToG.LexerIndexedCustomAction) {
                    let offset = lexerAction.offset;
                    input.seek(startIndex + offset);
                    lexerAction = lexerAction.action;
                    requiresSeek = startIndex + offset !== stopIndex;
                } else if (lexerAction.isPositionDependent) {
                    input.seek(stopIndex);
                    requiresSeek = false;
                }
                lexerAction.execute(lexer);
            }
        } finally{
            if (requiresSeek) input.seek(stopIndex);
        }
    }
    hashCode() {
        return this.cachedHashCode;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerActionExecutor)) return false;
        return this.cachedHashCode === obj.cachedHashCode && $faPBd.ArrayEqualityComparator.INSTANCE.equals(this._lexerActions, obj._lexerActions);
    }
};
$9683bc3fb09d6558$var$__decorate([
    $60gAE.NotNull
], $9683bc3fb09d6558$var$LexerActionExecutor.prototype, "_lexerActions", void 0);
$9683bc3fb09d6558$var$__decorate([
    $60gAE.NotNull
], $9683bc3fb09d6558$var$LexerActionExecutor.prototype, "lexerActions", null);
$9683bc3fb09d6558$var$__decorate([
    $9683bc3fb09d6558$var$__param(0, $60gAE.NotNull)
], $9683bc3fb09d6558$var$LexerActionExecutor.prototype, "execute", null);
$9683bc3fb09d6558$var$__decorate([
    $60gAE.Override
], $9683bc3fb09d6558$var$LexerActionExecutor.prototype, "hashCode", null);
$9683bc3fb09d6558$var$__decorate([
    $60gAE.Override
], $9683bc3fb09d6558$var$LexerActionExecutor.prototype, "equals", null);
$9683bc3fb09d6558$var$__decorate([
    $60gAE.NotNull,
    $9683bc3fb09d6558$var$__param(1, $60gAE.NotNull)
], $9683bc3fb09d6558$var$LexerActionExecutor, "append", null);
$9683bc3fb09d6558$var$LexerActionExecutor = $9683bc3fb09d6558$var$__decorate([
    $9683bc3fb09d6558$var$__param(0, $60gAE.NotNull)
], $9683bc3fb09d6558$var$LexerActionExecutor);
module.exports.LexerActionExecutor = $9683bc3fb09d6558$var$LexerActionExecutor;

});
parcelRegister("dlToG", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9b883543ab215a91$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9b883543ab215a91$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerIndexedCustomAction = void 0;

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");
/**
 * This implementation of {@link LexerAction} is used for tracking input offsets
 * for position-dependent actions within a {@link LexerActionExecutor}.
 *
 * This action is not serialized as part of the ATN, and is only required for
 * position-dependent lexer actions which appear at a location other than the
 * end of a rule. For more information about DFA optimizations employed for
 * lexer actions, see {@link LexerActionExecutor#append} and
 * {@link LexerActionExecutor#fixOffsetBeforeMatch}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $9b883543ab215a91$var$LexerIndexedCustomAction = class LexerIndexedCustomAction {
    /**
     * Constructs a new indexed custom action by associating a character offset
     * with a {@link LexerAction}.
     *
     * Note: This class is only required for lexer actions for which
     * {@link LexerAction#isPositionDependent} returns `true`.
     *
     * @param offset The offset into the input {@link CharStream}, relative to
     * the token start index, at which the specified lexer action should be
     * executed.
     * @param action The lexer action to execute at a particular offset in the
     * input {@link CharStream}.
     */ constructor(offset, action){
        this._offset = offset;
        this._action = action;
    }
    /**
     * Gets the location in the input {@link CharStream} at which the lexer
     * action should be executed. The value is interpreted as an offset relative
     * to the token start index.
     *
     * @returns The location in the input {@link CharStream} at which the lexer
     * action should be executed.
     */ get offset() {
        return this._offset;
    }
    /**
     * Gets the lexer action to execute.
     *
     * @returns A {@link LexerAction} object which executes the lexer action.
     */ get action() {
        return this._action;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns the result of calling {@link #getActionType}
     * on the {@link LexerAction} returned by {@link #getAction}.
     */ get actionType() {
        return this._action.actionType;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * This method calls {@link #execute} on the result of {@link #getAction}
     * using the provided `lexer`.
     */ execute(lexer) {
        // assume the input stream position was properly set by the calling code
        this._action.execute(lexer);
    }
    hashCode() {
        let hash = $ecbo5.MurmurHash.initialize();
        hash = $ecbo5.MurmurHash.update(hash, this._offset);
        hash = $ecbo5.MurmurHash.update(hash, this._action);
        return $ecbo5.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerIndexedCustomAction)) return false;
        return this._offset === obj._offset && this._action.equals(obj._action);
    }
};
$9b883543ab215a91$var$__decorate([
    $60gAE.NotNull
], $9b883543ab215a91$var$LexerIndexedCustomAction.prototype, "action", null);
$9b883543ab215a91$var$__decorate([
    $60gAE.Override
], $9b883543ab215a91$var$LexerIndexedCustomAction.prototype, "actionType", null);
$9b883543ab215a91$var$__decorate([
    $60gAE.Override
], $9b883543ab215a91$var$LexerIndexedCustomAction.prototype, "isPositionDependent", null);
$9b883543ab215a91$var$__decorate([
    $60gAE.Override
], $9b883543ab215a91$var$LexerIndexedCustomAction.prototype, "execute", null);
$9b883543ab215a91$var$__decorate([
    $60gAE.Override
], $9b883543ab215a91$var$LexerIndexedCustomAction.prototype, "hashCode", null);
$9b883543ab215a91$var$__decorate([
    $60gAE.Override
], $9b883543ab215a91$var$LexerIndexedCustomAction.prototype, "equals", null);
$9b883543ab215a91$var$LexerIndexedCustomAction = $9b883543ab215a91$var$__decorate([
    $9b883543ab215a91$var$__param(1, $60gAE.NotNull)
], $9b883543ab215a91$var$LexerIndexedCustomAction);
module.exports.LexerIndexedCustomAction = $9b883543ab215a91$var$LexerIndexedCustomAction;

});


parcelRegister("hqoEr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $caf7fc99948df53a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $caf7fc99948df53a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerNoViableAltException = void 0;

var $2XZxT = parcelRequire("2XZxT");

var $60gAE = parcelRequire("60gAE");

var $312SH = parcelRequire("312SH");

var $5lo68 = parcelRequire("5lo68");
let $caf7fc99948df53a$var$LexerNoViableAltException = class LexerNoViableAltException extends $2XZxT.RecognitionException {
    constructor(lexer, input, startIndex, deadEndConfigs){
        super(lexer, input);
        this._startIndex = startIndex;
        this._deadEndConfigs = deadEndConfigs;
    }
    get startIndex() {
        return this._startIndex;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
    get inputStream() {
        return super.inputStream;
    }
    toString() {
        let symbol = "";
        if (this._startIndex >= 0 && this._startIndex < this.inputStream.size) {
            symbol = this.inputStream.getText($312SH.Interval.of(this._startIndex, this._startIndex));
            symbol = $5lo68.escapeWhitespace(symbol, false);
        }
        // return String.format(Locale.getDefault(), "%s('%s')", LexerNoViableAltException.class.getSimpleName(), symbol);
        return `LexerNoViableAltException('${symbol}')`;
    }
};
$caf7fc99948df53a$var$__decorate([
    $60gAE.Override
], $caf7fc99948df53a$var$LexerNoViableAltException.prototype, "inputStream", null);
$caf7fc99948df53a$var$__decorate([
    $60gAE.Override
], $caf7fc99948df53a$var$LexerNoViableAltException.prototype, "toString", null);
$caf7fc99948df53a$var$LexerNoViableAltException = $caf7fc99948df53a$var$__decorate([
    $caf7fc99948df53a$var$__param(1, $60gAE.NotNull)
], $caf7fc99948df53a$var$LexerNoViableAltException);
module.exports.LexerNoViableAltException = $caf7fc99948df53a$var$LexerNoViableAltException;

});

parcelRegister("489CF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $301f5fa391e50be0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OrderedATNConfigSet = void 0;

var $3cXWi = parcelRequire("3cXWi");

var $60gAE = parcelRequire("60gAE");
/**
 *
 * @author Sam Harwell
 */ class $301f5fa391e50be0$var$OrderedATNConfigSet extends $3cXWi.ATNConfigSet {
    constructor(set, readonly){
        if (set != null && readonly != null) super(set, readonly);
        else super();
    }
    clone(readonly) {
        let copy = new $301f5fa391e50be0$var$OrderedATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this);
        return copy;
    }
    getKey(e) {
        // This is a specially crafted key to ensure configurations are only merged if they are equal
        return {
            state: 0,
            alt: e.hashCode()
        };
    }
    canMerge(left, leftKey, right) {
        return left.equals(right);
    }
}
$301f5fa391e50be0$var$__decorate([
    $60gAE.Override
], $301f5fa391e50be0$var$OrderedATNConfigSet.prototype, "clone", null);
$301f5fa391e50be0$var$__decorate([
    $60gAE.Override
], $301f5fa391e50be0$var$OrderedATNConfigSet.prototype, "getKey", null);
$301f5fa391e50be0$var$__decorate([
    $60gAE.Override
], $301f5fa391e50be0$var$OrderedATNConfigSet.prototype, "canMerge", null);
module.exports.OrderedATNConfigSet = $301f5fa391e50be0$var$OrderedATNConfigSet;

});




parcelRegister("1O6nA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $150f68c8e64f802f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoViableAltException = void 0;

var $5ncBC = parcelRequire("5ncBC");

var $2XZxT = parcelRequire("2XZxT");

var $60gAE = parcelRequire("60gAE");
/** Indicates that the parser could not decide which of two or more paths
 *  to take based upon the remaining input. It tracks the starting token
 *  of the offending input and also knows where the parser was
 *  in the various paths when the error. Reported by reportNoViableAlternative()
 */ class $150f68c8e64f802f$var$NoViableAltException extends $2XZxT.RecognitionException {
    constructor(recognizer, input, startToken, offendingToken, deadEndConfigs, ctx){
        if (recognizer instanceof $5ncBC.Parser) {
            if (input === undefined) input = recognizer.inputStream;
            if (startToken === undefined) startToken = recognizer.currentToken;
            if (offendingToken === undefined) offendingToken = recognizer.currentToken;
            if (ctx === undefined) ctx = recognizer.context;
        }
        super(recognizer, input, ctx);
        this._deadEndConfigs = deadEndConfigs;
        this._startToken = startToken;
        this.setOffendingToken(recognizer, offendingToken);
    }
    get startToken() {
        return this._startToken;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
}
$150f68c8e64f802f$var$__decorate([
    $60gAE.NotNull
], $150f68c8e64f802f$var$NoViableAltException.prototype, "_startToken", void 0);
module.exports.NoViableAltException = $150f68c8e64f802f$var$NoViableAltException;

});
parcelRegister("5ncBC", function(module, exports) {

var $gIMgJ = parcelRequire("gIMgJ");
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3e98e0fb2a29ccee$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3e98e0fb2a29ccee$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var $3e98e0fb2a29ccee$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $5lo68 = parcelRequire("5lo68");

var $fPTtK = parcelRequire("fPTtK");

var $1HaB7 = parcelRequire("1HaB7");

var $8PzbJ = parcelRequire("8PzbJ");

var $6hJiO = parcelRequire("6hJiO");

var $i8JNJ = parcelRequire("i8JNJ");

var $ipeIv = parcelRequire("ipeIv");

var $60gAE = parcelRequire("60gAE");

var $k18FW = parcelRequire("k18FW");

var $e3RBK = parcelRequire("e3RBK");

var $2WiKh = parcelRequire("2WiKh");

var $dlP2K = parcelRequire("dlP2K");

var $6AyGj = parcelRequire("6AyGj");

var $iLVZN = parcelRequire("iLVZN");
class $3e98e0fb2a29ccee$var$TraceListener {
    constructor(ruleNames, tokenStream){
        this.ruleNames = ruleNames;
        this.tokenStream = tokenStream;
    }
    enterEveryRule(ctx) {
        console.log("enter   " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    exitEveryRule(ctx) {
        console.log("exit    " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    visitErrorNode(node) {
    // intentionally empty
    }
    visitTerminal(node) {
        let parent = node.parent.ruleContext;
        let token = node.symbol;
        console.log("consume " + token + " rule " + this.ruleNames[parent.ruleIndex]);
    }
}
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.Override
], $3e98e0fb2a29ccee$var$TraceListener.prototype, "enterEveryRule", null);
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.Override
], $3e98e0fb2a29ccee$var$TraceListener.prototype, "exitEveryRule", null);
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.Override
], $3e98e0fb2a29ccee$var$TraceListener.prototype, "visitErrorNode", null);
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.Override
], $3e98e0fb2a29ccee$var$TraceListener.prototype, "visitTerminal", null);



/** This is all the parsing support code essentially; most of it is error recovery stuff. */ class $3e98e0fb2a29ccee$var$Parser extends $dlP2K.Recognizer {
    constructor(input){
        super();
        /**
         * The error handling strategy for the parser. The default value is a new
         * instance of {@link DefaultErrorStrategy}.
         *
         * @see #getErrorHandler
         * @see #setErrorHandler
         */ this._errHandler = new $8PzbJ.DefaultErrorStrategy();
        this._precedenceStack = new $i8JNJ.IntegerStack();
        /**
         * Specifies whether or not the parser should construct a parse tree during
         * the parsing process. The default value is `true`.
         *
         * @see `buildParseTree`
         */ this._buildParseTrees = true;
        /**
         * The list of {@link ParseTreeListener} listeners registered to receive
         * events during the parse.
         *
         * @see #addParseListener
         */ this._parseListeners = [];
        /**
         * The number of syntax errors reported during parsing. This value is
         * incremented each time {@link #notifyErrorListeners} is called.
         */ this._syntaxErrors = 0;
        /** Indicates parser has match()ed EOF token. See {@link #exitRule()}. */ this.matchedEOF = false;
        this._precedenceStack.push(0);
        this.inputStream = input;
    }
    reset(resetInput) {
        // Note: this method executes when not parsing, so _ctx can be undefined
        if (resetInput === undefined || resetInput) this.inputStream.seek(0);
        this._errHandler.reset(this);
        this._ctx = undefined;
        this._syntaxErrors = 0;
        this.matchedEOF = false;
        this.isTrace = false;
        this._precedenceStack.clear();
        this._precedenceStack.push(0);
        let interpreter = this.interpreter;
        if (interpreter != null) interpreter.reset();
    }
    /**
     * Match current input symbol against `ttype`. If the symbol type
     * matches, {@link ANTLRErrorStrategy#reportMatch} and {@link #consume} are
     * called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @param ttype the token type to match
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * `ttype` and the error strategy could not recover from the
     * mismatched symbol
     */ match(ttype) {
        let t = this.currentToken;
        if (t.type === ttype) {
            if (ttype === $iLVZN.Token.EOF) this.matchedEOF = true;
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Match current input symbol as a wildcard. If the symbol type matches
     * (i.e. has a value greater than 0), {@link ANTLRErrorStrategy#reportMatch}
     * and {@link #consume} are called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link Parser#createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * a wildcard and the error strategy could not recover from the mismatched
     * symbol
     */ matchWildcard() {
        let t = this.currentToken;
        if (t.type > 0) {
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Track the {@link ParserRuleContext} objects during the parse and hook
     * them up using the {@link ParserRuleContext#children} list so that it
     * forms a parse tree. The {@link ParserRuleContext} returned from the start
     * rule represents the root of the parse tree.
     *
     * Note that if we are not building parse trees, rule contexts only point
     * upwards. When a rule exits, it returns the context but that gets garbage
     * collected if nobody holds a reference. It points upwards but nobody
     * points at it.
     *
     * When we build parse trees, we are adding all of these contexts to
     * {@link ParserRuleContext#children} list. Contexts are then not candidates
     * for garbage collection.
     */ set buildParseTree(buildParseTrees) {
        this._buildParseTrees = buildParseTrees;
    }
    /**
     * Gets whether or not a complete parse tree will be constructed while
     * parsing. This property is `true` for a newly constructed parser.
     *
     * @returns `true` if a complete parse tree will be constructed while
     * parsing, otherwise `false`
     */ get buildParseTree() {
        return this._buildParseTrees;
    }
    getParseListeners() {
        return this._parseListeners;
    }
    /**
     * Registers `listener` to receive events during the parsing process.
     *
     * To support output-preserving grammar transformations (including but not
     * limited to left-recursion removal, automated left-factoring, and
     * optimized code generation), calls to listener methods during the parse
     * may differ substantially from calls made by
     * {@link ParseTreeWalker#DEFAULT} used after the parse is complete. In
     * particular, rule entry and exit events may occur in a different order
     * during the parse than after the parser. In addition, calls to certain
     * rule entry methods may be omitted.
     *
     * With the following specific exceptions, calls to listener events are
     * *deterministic*, i.e. for identical input the calls to listener
     * methods will be the same.
     *
     * * Alterations to the grammar used to generate code may change the
     *   behavior of the listener calls.
     * * Alterations to the command line options passed to ANTLR 4 when
     *   generating the parser may change the behavior of the listener calls.
     * * Changing the version of the ANTLR Tool used to generate the parser
     *   may change the behavior of the listener calls.
     *
     * @param listener the listener to add
     *
     * @throws {@link TypeError} if `listener` is `undefined`
     */ addParseListener(listener) {
        if (listener == null) throw new TypeError("listener cannot be null");
        this._parseListeners.push(listener);
    }
    /**
     * Remove `listener` from the list of parse listeners.
     *
     * If `listener` is `undefined` or has not been added as a parse
     * listener, this method does nothing.
     *
     * @see #addParseListener
     *
     * @param listener the listener to remove
     */ removeParseListener(listener) {
        let index = this._parseListeners.findIndex((l)=>l === listener);
        if (index !== -1) this._parseListeners.splice(index, 1);
    }
    /**
     * Remove all parse listeners.
     *
     * @see #addParseListener
     */ removeParseListeners() {
        this._parseListeners.length = 0;
    }
    /**
     * Notify any parse listeners of an enter rule event.
     *
     * @see #addParseListener
     */ triggerEnterRuleEvent() {
        for (let listener of this._parseListeners){
            if (listener.enterEveryRule) listener.enterEveryRule(this._ctx);
            this._ctx.enterRule(listener);
        }
    }
    /**
     * Notify any parse listeners of an exit rule event.
     *
     * @see #addParseListener
     */ triggerExitRuleEvent() {
        // reverse order walk of listeners
        for(let i = this._parseListeners.length - 1; i >= 0; i--){
            let listener = this._parseListeners[i];
            this._ctx.exitRule(listener);
            if (listener.exitEveryRule) listener.exitEveryRule(this._ctx);
        }
    }
    /**
     * Gets the number of syntax errors reported during parsing. This value is
     * incremented each time {@link #notifyErrorListeners} is called.
     *
     * @see #notifyErrorListeners
     */ get numberOfSyntaxErrors() {
        return this._syntaxErrors;
    }
    get tokenFactory() {
        return this._input.tokenSource.tokenFactory;
    }
    /**
     * The ATN with bypass alternatives is expensive to create so we create it
     * lazily.
     *
     * @ if the current parser does not
     * implement the `serializedATN` property.
     */ getATNWithBypassAlts() {
        let serializedAtn = this.serializedATN;
        if (serializedAtn == null) throw new Error("The current parser does not support an ATN with bypass alternatives.");
        let result = $3e98e0fb2a29ccee$var$Parser.bypassAltsAtnCache.get(serializedAtn);
        if (result == null) {
            let deserializationOptions = new $fPTtK.ATNDeserializationOptions();
            deserializationOptions.isGenerateRuleBypassTransitions = true;
            result = new $1HaB7.ATNDeserializer(deserializationOptions).deserialize($5lo68.toCharArray(serializedAtn));
            $3e98e0fb2a29ccee$var$Parser.bypassAltsAtnCache.set(serializedAtn, result);
        }
        return result;
    }
    compileParseTreePattern(pattern, patternRuleIndex, lexer) {
        return $3e98e0fb2a29ccee$var$__awaiter(this, void 0, void 0, function*() {
            if (!lexer) {
                if (this.inputStream) {
                    let tokenSource = this.inputStream.tokenSource;
                    if (tokenSource instanceof $ipeIv.Lexer) lexer = tokenSource;
                }
                if (!lexer) throw new Error("Parser can't discover a lexer to use");
            }
            let currentLexer = lexer;
            let m = yield Promise.resolve().then(()=>(parcelRequire("5iiSP")));
            let matcher = new m.ParseTreePatternMatcher(currentLexer, this);
            return matcher.compile(pattern, patternRuleIndex);
        });
    }
    get errorHandler() {
        return this._errHandler;
    }
    set errorHandler(handler) {
        this._errHandler = handler;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the token stream and reset the parser. */ set inputStream(input) {
        this.reset(false);
        this._input = input;
    }
    /** Match needs to return the current input symbol, which gets put
     *  into the label for the associated token ref; e.g., x=ID.
     */ get currentToken() {
        return this._input.LT(1);
    }
    notifyErrorListeners(msg, offendingToken, e) {
        if (offendingToken === undefined) offendingToken = this.currentToken;
        else if (offendingToken === null) offendingToken = undefined;
        this._syntaxErrors++;
        let line = -1;
        let charPositionInLine = -1;
        if (offendingToken != null) {
            line = offendingToken.line;
            charPositionInLine = offendingToken.charPositionInLine;
        }
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, offendingToken, line, charPositionInLine, msg, e);
    }
    /**
     * Consume and return the [current symbol](`currentToken`).
     *
     * E.g., given the following input with `A` being the current
     * lookahead symbol, this function moves the cursor to `B` and returns
     * `A`.
     *
     * ```
     * A B
     * ^
     * ```
     *
     * If the parser is not in error recovery mode, the consumed symbol is added
     * to the parse tree using {@link ParserRuleContext#addChild(TerminalNode)}, and
     * {@link ParseTreeListener#visitTerminal} is called on any parse listeners.
     * If the parser *is* in error recovery mode, the consumed symbol is
     * added to the parse tree using {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)} and
     * {@link ParseTreeListener#visitErrorNode} is called on any parse
     * listeners.
     */ consume() {
        let o = this.currentToken;
        if (o.type !== $3e98e0fb2a29ccee$var$Parser.EOF) this.inputStream.consume();
        let hasListener = this._parseListeners.length !== 0;
        if (this._buildParseTrees || hasListener) {
            if (this._errHandler.inErrorRecoveryMode(this)) {
                let node = this._ctx.addErrorNode(this.createErrorNode(this._ctx, o));
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitErrorNode) listener.visitErrorNode(node);
                }
            } else {
                let node = this.createTerminalNode(this._ctx, o);
                this._ctx.addChild(node);
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitTerminal) listener.visitTerminal(node);
                }
            }
        }
        return o;
    }
    /**
     * How to create a token leaf node associated with a parent.
     * Typically, the terminal node to create is not a function of the parent.
     *
     * @since 4.7
     */ createTerminalNode(parent, t) {
        return new $6AyGj.TerminalNode(t);
    }
    /**
     * How to create an error node, given a token, associated with a parent.
     * Typically, the error node to create is not a function of the parent.
     *
     * @since 4.7
     */ createErrorNode(parent, t) {
        return new $6hJiO.ErrorNode(t);
    }
    addContextToParseTree() {
        let parent = this._ctx._parent;
        // add current context to parent if we have a parent
        if (parent != null) parent.addChild(this._ctx);
    }
    /**
     * Always called by generated parsers upon entry to a rule. Access field
     * {@link #_ctx} get the current context.
     */ enterRule(localctx, state, ruleIndex) {
        this.state = state;
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    enterLeftFactoredRule(localctx, state, ruleIndex) {
        this.state = state;
        if (this._buildParseTrees) {
            let factoredContext = this._ctx.getChild(this._ctx.childCount - 1);
            this._ctx.removeLastChild();
            factoredContext._parent = localctx;
            localctx.addChild(factoredContext);
        }
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    exitRule() {
        if (this.matchedEOF) // if we have matched EOF, it cannot consume past EOF so we use LT(1) here
        this._ctx._stop = this._input.LT(1); // LT(1) will be end of file
        else this._ctx._stop = this._input.tryLT(-1); // stop node is what we just matched
        // trigger event on _ctx, before it reverts to parent
        this.triggerExitRuleEvent();
        this.state = this._ctx.invokingState;
        this._ctx = this._ctx._parent;
    }
    enterOuterAlt(localctx, altNum) {
        localctx.altNumber = altNum;
        // if we have new localctx, make sure we replace existing ctx
        // that is previous child of parse tree
        if (this._buildParseTrees && this._ctx !== localctx) {
            let parent = this._ctx._parent;
            if (parent != null) {
                parent.removeLastChild();
                parent.addChild(localctx);
            }
        }
        this._ctx = localctx;
    }
    /**
     * Get the precedence level for the top-most precedence rule.
     *
     * @returns The precedence level for the top-most precedence rule, or -1 if
     * the parser context is not nested within a precedence rule.
     */ get precedence() {
        if (this._precedenceStack.isEmpty) return -1;
        return this._precedenceStack.peek();
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this.state = state;
        this._precedenceStack.push(precedence);
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    /** Like {@link #enterRule} but for recursive rules.
     *  Make the current context the child of the incoming localctx.
     */ pushNewRecursionContext(localctx, state, ruleIndex) {
        let previous = this._ctx;
        previous._parent = localctx;
        previous.invokingState = state;
        previous._stop = this._input.tryLT(-1);
        this._ctx = localctx;
        this._ctx._start = previous._start;
        if (this._buildParseTrees) this._ctx.addChild(previous);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    unrollRecursionContexts(_parentctx) {
        this._precedenceStack.pop();
        this._ctx._stop = this._input.tryLT(-1);
        let retctx = this._ctx; // save current ctx (return value)
        // unroll so _ctx is as it was before call to recursive method
        if (this._parseListeners.length > 0) while(this._ctx !== _parentctx){
            this.triggerExitRuleEvent();
            this._ctx = this._ctx._parent;
        }
        else this._ctx = _parentctx;
        // hook into tree
        retctx._parent = _parentctx;
        if (this._buildParseTrees && _parentctx != null) // add return ctx into invoking rule's tree
        _parentctx.addChild(retctx);
    }
    getInvokingContext(ruleIndex) {
        let p = this._ctx;
        while(p && p.ruleIndex !== ruleIndex)p = p._parent;
        return p;
    }
    get context() {
        return this._ctx;
    }
    set context(ctx) {
        this._ctx = ctx;
    }
    precpred(localctx, precedence) {
        return precedence >= this._precedenceStack.peek();
    }
    getErrorListenerDispatch() {
        return new $2WiKh.ProxyParserErrorListener(this.getErrorListeners());
    }
    inContext(context) {
        // TODO: useful in parser?
        return false;
    }
    /**
     * Checks whether or not `symbol` can follow the current state in the
     * ATN. The behavior of this method is equivalent to the following, but is
     * implemented such that the complete context-sensitive follow set does not
     * need to be explicitly constructed.
     *
     * ```
     * return getExpectedTokens().contains(symbol);
     * ```
     *
     * @param symbol the symbol type to check
     * @returns `true` if `symbol` can follow the current state in
     * the ATN, otherwise `false`.
     */ isExpectedToken(symbol) {
        //   		return interpreter.atn.nextTokens(_ctx);
        let atn = this.interpreter.atn;
        let ctx = this._ctx;
        let s = atn.states[this.state];
        let following = atn.nextTokens(s);
        if (following.contains(symbol)) return true;
        //        System.out.println("following "+s+"="+following);
        if (!following.contains($iLVZN.Token.EPSILON)) return false;
        while(ctx != null && ctx.invokingState >= 0 && following.contains($iLVZN.Token.EPSILON)){
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = atn.nextTokens(rt.followState);
            if (following.contains(symbol)) return true;
            ctx = ctx._parent;
        }
        if (following.contains($iLVZN.Token.EPSILON) && symbol === $iLVZN.Token.EOF) return true;
        return false;
    }
    get isMatchedEOF() {
        return this.matchedEOF;
    }
    /**
     * Computes the set of input symbols which could follow the current parser
     * state and context, as given by {@link #getState} and {@link #getContext},
     * respectively.
     *
     * @see ATN#getExpectedTokens(int, RuleContext)
     */ getExpectedTokens() {
        return this.atn.getExpectedTokens(this.state, this.context);
    }
    getExpectedTokensWithinCurrentRule() {
        let atn = this.interpreter.atn;
        let s = atn.states[this.state];
        return atn.nextTokens(s);
    }
    /** Get a rule's index (i.e., `RULE_ruleName` field) or -1 if not found. */ getRuleIndex(ruleName) {
        let ruleIndex = this.getRuleIndexMap().get(ruleName);
        if (ruleIndex != null) return ruleIndex;
        return -1;
    }
    get ruleContext() {
        return this._ctx;
    }
    /** Return List&lt;String&gt; of the rule names in your parser instance
     *  leading up to a call to the current rule.  You could override if
     *  you want more details such as the file/line info of where
     *  in the ATN a rule is invoked.
     *
     *  This is very useful for error messages.
     */ getRuleInvocationStack(ctx = this._ctx) {
        let p = ctx; // Workaround for Microsoft/TypeScript#14487
        let ruleNames = this.ruleNames;
        let stack = [];
        while(p != null){
            // compute what follows who invoked us
            let ruleIndex = p.ruleIndex;
            if (ruleIndex < 0) stack.push("n/a");
            else stack.push(ruleNames[ruleIndex]);
            p = p._parent;
        }
        return stack;
    }
    /** For debugging and other purposes. */ getDFAStrings() {
        let s = [];
        for (let dfa of this._interp.atn.decisionToDFA)s.push(dfa.toString(this.vocabulary, this.ruleNames));
        return s;
    }
    /** For debugging and other purposes. */ dumpDFA() {
        let seenOne = false;
        for (let dfa of this._interp.atn.decisionToDFA)if (!dfa.isEmpty) {
            if (seenOne) console.log();
            console.log("Decision " + dfa.decision + ":");
            $gIMgJ.stdout.write(dfa.toString(this.vocabulary, this.ruleNames));
            seenOne = true;
        }
    }
    get sourceName() {
        return this._input.sourceName;
    }
    get parseInfo() {
        return Promise.resolve().then(()=>(parcelRequire("5PSjt"))).then((m)=>{
            let interp = this.interpreter;
            if (interp instanceof m.ProfilingATNSimulator) return new $k18FW.ParseInfo(interp);
            return undefined;
        });
    }
    /**
     * @since 4.3
     */ setProfile(profile) {
        return $3e98e0fb2a29ccee$var$__awaiter(this, void 0, void 0, function*() {
            let m = yield Promise.resolve().then(()=>(parcelRequire("5PSjt")));
            let interp = this.interpreter;
            if (profile) {
                if (!(interp instanceof m.ProfilingATNSimulator)) this.interpreter = new m.ProfilingATNSimulator(this);
            } else if (interp instanceof m.ProfilingATNSimulator) this.interpreter = new $e3RBK.ParserATNSimulator(this.atn, this);
            this.interpreter.setPredictionMode(interp.getPredictionMode());
        });
    }
    /** During a parse is sometimes useful to listen in on the rule entry and exit
     *  events as well as token matches. This is for quick and dirty debugging.
     */ set isTrace(trace) {
        if (!trace) {
            if (this._tracer) {
                this.removeParseListener(this._tracer);
                this._tracer = undefined;
            }
        } else {
            if (this._tracer) this.removeParseListener(this._tracer);
            else this._tracer = new $3e98e0fb2a29ccee$var$TraceListener(this.ruleNames, this._input);
            this.addParseListener(this._tracer);
        }
    }
    /**
     * Gets whether a {@link TraceListener} is registered as a parse listener
     * for the parser.
     */ get isTrace() {
        return this._tracer != null;
    }
}
/**
 * This field maps from the serialized ATN string to the deserialized {@link ATN} with
 * bypass alternatives.
 *
 * @see ATNDeserializationOptions.isGenerateRuleBypassTransitions
 */ $3e98e0fb2a29ccee$var$Parser.bypassAltsAtnCache = new Map();
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.NotNull
], $3e98e0fb2a29ccee$var$Parser.prototype, "_errHandler", void 0);
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.NotNull
], $3e98e0fb2a29ccee$var$Parser.prototype, "match", null);
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.NotNull
], $3e98e0fb2a29ccee$var$Parser.prototype, "matchWildcard", null);
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.NotNull
], $3e98e0fb2a29ccee$var$Parser.prototype, "getParseListeners", null);
$3e98e0fb2a29ccee$var$__decorate([
    $3e98e0fb2a29ccee$var$__param(0, $60gAE.NotNull)
], $3e98e0fb2a29ccee$var$Parser.prototype, "addParseListener", null);
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.NotNull
], $3e98e0fb2a29ccee$var$Parser.prototype, "getATNWithBypassAlts", null);
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.NotNull,
    $3e98e0fb2a29ccee$var$__param(0, $60gAE.NotNull)
], $3e98e0fb2a29ccee$var$Parser.prototype, "errorHandler", null);
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.Override
], $3e98e0fb2a29ccee$var$Parser.prototype, "inputStream", null);
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.NotNull
], $3e98e0fb2a29ccee$var$Parser.prototype, "currentToken", null);
$3e98e0fb2a29ccee$var$__decorate([
    $3e98e0fb2a29ccee$var$__param(0, $60gAE.NotNull)
], $3e98e0fb2a29ccee$var$Parser.prototype, "enterRule", null);
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.Override,
    $3e98e0fb2a29ccee$var$__param(0, $60gAE.Nullable)
], $3e98e0fb2a29ccee$var$Parser.prototype, "precpred", null);
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.Override
], $3e98e0fb2a29ccee$var$Parser.prototype, "getErrorListenerDispatch", null);
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.NotNull
], $3e98e0fb2a29ccee$var$Parser.prototype, "getExpectedTokens", null);
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.NotNull
], $3e98e0fb2a29ccee$var$Parser.prototype, "getExpectedTokensWithinCurrentRule", null);
$3e98e0fb2a29ccee$var$__decorate([
    $60gAE.Override
], $3e98e0fb2a29ccee$var$Parser.prototype, "parseInfo", null);
module.exports.Parser = $3e98e0fb2a29ccee$var$Parser;

});
parcelRegister("fPTtK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b876a7589fc2a4e1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializationOptions = void 0;

var $60gAE = parcelRequire("60gAE");
/**
 *
 * @author Sam Harwell
 */ class $b876a7589fc2a4e1$var$ATNDeserializationOptions {
    constructor(options){
        this.readOnly = false;
        if (options) {
            this.verifyATN = options.verifyATN;
            this.generateRuleBypassTransitions = options.generateRuleBypassTransitions;
            this.optimize = options.optimize;
        } else {
            this.verifyATN = true;
            this.generateRuleBypassTransitions = false;
            this.optimize = true;
        }
    }
    static get defaultOptions() {
        if ($b876a7589fc2a4e1$var$ATNDeserializationOptions._defaultOptions == null) {
            $b876a7589fc2a4e1$var$ATNDeserializationOptions._defaultOptions = new $b876a7589fc2a4e1$var$ATNDeserializationOptions();
            $b876a7589fc2a4e1$var$ATNDeserializationOptions._defaultOptions.makeReadOnly();
        }
        return $b876a7589fc2a4e1$var$ATNDeserializationOptions._defaultOptions;
    }
    get isReadOnly() {
        return this.readOnly;
    }
    makeReadOnly() {
        this.readOnly = true;
    }
    get isVerifyATN() {
        return this.verifyATN;
    }
    set isVerifyATN(verifyATN) {
        this.throwIfReadOnly();
        this.verifyATN = verifyATN;
    }
    get isGenerateRuleBypassTransitions() {
        return this.generateRuleBypassTransitions;
    }
    set isGenerateRuleBypassTransitions(generateRuleBypassTransitions) {
        this.throwIfReadOnly();
        this.generateRuleBypassTransitions = generateRuleBypassTransitions;
    }
    get isOptimize() {
        return this.optimize;
    }
    set isOptimize(optimize) {
        this.throwIfReadOnly();
        this.optimize = optimize;
    }
    throwIfReadOnly() {
        if (this.isReadOnly) throw new Error("The object is read only.");
    }
}
$b876a7589fc2a4e1$var$__decorate([
    $60gAE.NotNull
], $b876a7589fc2a4e1$var$ATNDeserializationOptions, "defaultOptions", null);
module.exports.ATNDeserializationOptions = $b876a7589fc2a4e1$var$ATNDeserializationOptions;

});

parcelRegister("1HaB7", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $13c20715f85c8f33$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $13c20715f85c8f33$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializer = void 0;

var $9PZbb = parcelRequire("9PZbb");

var $fqc4S = parcelRequire("fqc4S");

var $dQ2fw = parcelRequire("dQ2fw");

var $fPTtK = parcelRequire("fPTtK");

var $4txXj = parcelRequire("4txXj");

var $bj9S6 = parcelRequire("bj9S6");

var $dMOpV = parcelRequire("dMOpV");

var $gVntA = parcelRequire("gVntA");

var $igr91 = parcelRequire("igr91");

var $auJWg = parcelRequire("auJWg");

var $hxAlL = parcelRequire("hxAlL");

var $cpDvh = parcelRequire("cpDvh");

var $ll18S = parcelRequire("ll18S");

var $krcCb = parcelRequire("krcCb");

var $fkZzb = parcelRequire("fkZzb");

var $dwSPu = parcelRequire("dwSPu");

var $2ci2Z = parcelRequire("2ci2Z");

var $dIbl0 = parcelRequire("dIbl0");

var $cJknI = parcelRequire("cJknI");

var $3QeLH = parcelRequire("3QeLH");

var $eDCNN = parcelRequire("eDCNN");

var $lsd4Y = parcelRequire("lsd4Y");

var $52ZMw = parcelRequire("52ZMw");

var $1Y2n7 = parcelRequire("1Y2n7");

var $915XK = parcelRequire("915XK");

var $60gAE = parcelRequire("60gAE");

var $gYz0f = parcelRequire("gYz0f");

var $e3RBK = parcelRequire("e3RBK");

var $ia3fa = parcelRequire("ia3fa");

var $abJj4 = parcelRequire("abJj4");

var $1ZXDH = parcelRequire("1ZXDH");

var $jrz9M = parcelRequire("jrz9M");

var $kHPTE = parcelRequire("kHPTE");

var $95fyx = parcelRequire("95fyx");

var $830He = parcelRequire("830He");

var $9ITLj = parcelRequire("9ITLj");

var $cxnFA = parcelRequire("cxnFA");

var $4BHtX = parcelRequire("4BHtX");

var $iTtiT = parcelRequire("iTtiT");

var $1UcbM = parcelRequire("1UcbM");

var $iLVZN = parcelRequire("iLVZN");

var $aiReF = parcelRequire("aiReF");

var $dpMFH = parcelRequire("dpMFH");

var $dhddq = parcelRequire("dhddq");
var $13c20715f85c8f33$var$UnicodeDeserializingMode;
(function(UnicodeDeserializingMode) {
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_BMP"] = 0] = "UNICODE_BMP";
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_SMP"] = 1] = "UNICODE_SMP";
})($13c20715f85c8f33$var$UnicodeDeserializingMode || ($13c20715f85c8f33$var$UnicodeDeserializingMode = {}));
/**
 *
 * @author Sam Harwell
 */ class $13c20715f85c8f33$var$ATNDeserializer {
    constructor(deserializationOptions){
        if (deserializationOptions === undefined) deserializationOptions = $fPTtK.ATNDeserializationOptions.defaultOptions;
        this.deserializationOptions = deserializationOptions;
    }
    static get SERIALIZED_VERSION() {
        /* This value should never change. Updates following this version are
         * reflected as change in the unique ID SERIALIZED_UUID.
         */ return 3;
    }
    /**
     * Determines if a particular serialized representation of an ATN supports
     * a particular feature, identified by the {@link UUID} used for serializing
     * the ATN at the time the feature was first introduced.
     *
     * @param feature The {@link UUID} marking the first time the feature was
     * supported in the serialized ATN.
     * @param actualUuid The {@link UUID} of the actual serialized ATN which is
     * currently being deserialized.
     * @returns `true` if the `actualUuid` value represents a
     * serialized ATN at or after the feature identified by `feature` was
     * introduced; otherwise, `false`.
     */ static isFeatureSupported(feature, actualUuid) {
        let featureIndex = $13c20715f85c8f33$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(feature));
        if (featureIndex < 0) return false;
        return $13c20715f85c8f33$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(actualUuid)) >= featureIndex;
    }
    static getUnicodeDeserializer(mode) {
        if (mode === 0 /* UNICODE_BMP */ ) return {
            readUnicode: (data, p)=>{
                return $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p]);
            },
            size: 1
        };
        else return {
            readUnicode: (data, p)=>{
                return $13c20715f85c8f33$var$ATNDeserializer.toInt32(data, p);
            },
            size: 2
        };
    }
    deserialize(data) {
        data = data.slice(0);
        // Each Uint16 value in data is shifted by +2 at the entry to this method. This is an encoding optimization
        // targeting the serialized values 0 and -1 (serialized to 0xFFFF), each of which are very common in the
        // serialized form of the ATN. In the modified UTF-8 that Java uses for compiled string literals, these two
        // character values have multi-byte forms. By shifting each value by +2, they become characters 2 and 1 prior to
        // writing the string, each of which have single-byte representations. Since the shift occurs in the tool during
        // ATN serialization, each target is responsible for adjusting the values during deserialization.
        //
        // As a special case, note that the first element of data is not adjusted because it contains the major version
        // number of the serialized ATN, which was fixed at 3 at the time the value shifting was implemented.
        for(let i = 1; i < data.length; i++)data[i] = data[i] - 2 & 0xFFFF;
        let p = 0;
        let version = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
        if (version !== $13c20715f85c8f33$var$ATNDeserializer.SERIALIZED_VERSION) {
            let reason = `Could not deserialize ATN with version ${version} (expected ${$13c20715f85c8f33$var$ATNDeserializer.SERIALIZED_VERSION}).`;
            throw new Error(reason);
        }
        let uuid = $13c20715f85c8f33$var$ATNDeserializer.toUUID(data, p);
        p += 8;
        if ($13c20715f85c8f33$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(uuid)) < 0) {
            let reason = `Could not deserialize ATN with UUID ${uuid} (expected ${$13c20715f85c8f33$var$ATNDeserializer.SERIALIZED_UUID} or a legacy UUID).`;
            throw new Error(reason);
        }
        let supportsLexerActions = $13c20715f85c8f33$var$ATNDeserializer.isFeatureSupported($13c20715f85c8f33$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid);
        let grammarType = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
        let maxTokenType = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
        let atn = new $dQ2fw.ATN(grammarType, maxTokenType);
        //
        // STATES
        //
        let loopBackStateNumbers = [];
        let endStateNumbers = [];
        let nstates = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nstates; i++){
            let stype = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
            // ignore bad type of states
            if (stype === $4txXj.ATNStateType.INVALID_TYPE) {
                atn.addState(new $dwSPu.InvalidState());
                continue;
            }
            let ruleIndex = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
            if (ruleIndex === 0xFFFF) ruleIndex = -1;
            let s = this.stateFactory(stype, ruleIndex);
            if (stype === $4txXj.ATNStateType.LOOP_END) {
                let loopBackStateNumber = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
                loopBackStateNumbers.push([
                    s,
                    loopBackStateNumber
                ]);
            } else if (s instanceof $hxAlL.BlockStartState) {
                let endStateNumber = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
                endStateNumbers.push([
                    s,
                    endStateNumber
                ]);
            }
            atn.addState(s);
        }
        // delay the assignment of loop back and end states until we know all the state instances have been initialized
        for (let pair of loopBackStateNumbers)pair[0].loopBackState = atn.states[pair[1]];
        for (let pair of endStateNumbers)pair[0].endState = atn.states[pair[1]];
        let numNonGreedyStates = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numNonGreedyStates; i++){
            let stateNumber = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].nonGreedy = true;
        }
        let numSllDecisions = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numSllDecisions; i++){
            let stateNumber = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].sll = true;
        }
        let numPrecedenceStates = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numPrecedenceStates; i++){
            let stateNumber = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].isPrecedenceRule = true;
        }
        //
        // RULES
        //
        let nrules = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
        if (atn.grammarType === 0 /* LEXER */ ) atn.ruleToTokenType = new Int32Array(nrules);
        atn.ruleToStartState = new Array(nrules);
        for(let i = 0; i < nrules; i++){
            let s = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
            let startState = atn.states[s];
            startState.leftFactored = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]) !== 0;
            atn.ruleToStartState[i] = startState;
            if (atn.grammarType === 0 /* LEXER */ ) {
                let tokenType = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
                if (tokenType === 0xFFFF) tokenType = $iLVZN.Token.EOF;
                atn.ruleToTokenType[i] = tokenType;
                if (!$13c20715f85c8f33$var$ATNDeserializer.isFeatureSupported($13c20715f85c8f33$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid)) {
                    // this piece of unused metadata was serialized prior to the
                    // addition of LexerAction
                    let actionIndexIgnored = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
                    if (actionIndexIgnored === 0xFFFF) actionIndexIgnored = -1;
                }
            }
        }
        atn.ruleToStopState = new Array(nrules);
        for (let state of atn.states){
            if (!(state instanceof $830He.RuleStopState)) continue;
            atn.ruleToStopState[state.ruleIndex] = state;
            atn.ruleToStartState[state.ruleIndex].stopState = state;
        }
        //
        // MODES
        //
        let nmodes = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nmodes; i++){
            let s = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
            atn.modeToStartState.push(atn.states[s]);
        }
        atn.modeToDFA = new Array(nmodes);
        for(let i = 0; i < nmodes; i++)atn.modeToDFA[i] = new $ll18S.DFA(atn.modeToStartState[i]);
        //
        // SETS
        //
        let sets = [];
        // First, read all sets with 16-bit Unicode code points <= U+FFFF.
        p = this.deserializeSets(data, p, sets, $13c20715f85c8f33$var$ATNDeserializer.getUnicodeDeserializer(0 /* UNICODE_BMP */ ));
        // Next, if the ATN was serialized with the Unicode SMP feature,
        // deserialize sets with 32-bit arguments <= U+10FFFF.
        if ($13c20715f85c8f33$var$ATNDeserializer.isFeatureSupported($13c20715f85c8f33$var$ATNDeserializer.ADDED_UNICODE_SMP, uuid)) p = this.deserializeSets(data, p, sets, $13c20715f85c8f33$var$ATNDeserializer.getUnicodeDeserializer(1 /* UNICODE_SMP */ ));
        //
        // EDGES
        //
        let nedges = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nedges; i++){
            let src = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p]);
            let trg = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p + 1]);
            let ttype = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p + 2]);
            let arg1 = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p + 3]);
            let arg2 = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p + 4]);
            let arg3 = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p + 5]);
            let trans = this.edgeFactory(atn, ttype, src, trg, arg1, arg2, arg3, sets);
            // console.log(`EDGE ${trans.constructor.name} ${src}->${trg} ${Transition.serializationNames[ttype]} ${arg1},${arg2},${arg3}`);
            let srcState = atn.states[src];
            srcState.addTransition(trans);
            p += 6;
        }
        let returnTransitionsSet = new $fqc4S.Array2DHashSet({
            hashCode: (o)=>o.stopState ^ o.returnState ^ o.outermostPrecedenceReturn,
            equals: (a, b)=>{
                return a.stopState === b.stopState && a.returnState === b.returnState && a.outermostPrecedenceReturn === b.outermostPrecedenceReturn;
            }
        });
        let returnTransitions = [];
        for (let state of atn.states){
            let returningToLeftFactored = state.ruleIndex >= 0 && atn.ruleToStartState[state.ruleIndex].leftFactored;
            for(let i = 0; i < state.numberOfTransitions; i++){
                let t = state.transition(i);
                if (!(t instanceof $9ITLj.RuleTransition)) continue;
                let ruleTransition = t;
                let returningFromLeftFactored = atn.ruleToStartState[ruleTransition.target.ruleIndex].leftFactored;
                if (!returningFromLeftFactored && returningToLeftFactored) continue;
                let outermostPrecedenceReturn = -1;
                if (atn.ruleToStartState[ruleTransition.target.ruleIndex].isPrecedenceRule) {
                    if (ruleTransition.precedence === 0) outermostPrecedenceReturn = ruleTransition.target.ruleIndex;
                }
                let current = {
                    stopState: ruleTransition.target.ruleIndex,
                    returnState: ruleTransition.followState.stateNumber,
                    outermostPrecedenceReturn: outermostPrecedenceReturn
                };
                if (returnTransitionsSet.add(current)) returnTransitions.push(current);
            }
        }
        // Add all elements from returnTransitions to the ATN
        for (let returnTransition of returnTransitions){
            let transition = new $krcCb.EpsilonTransition(atn.states[returnTransition.returnState], returnTransition.outermostPrecedenceReturn);
            atn.ruleToStopState[returnTransition.stopState].addTransition(transition);
        }
        for (let state of atn.states){
            if (state instanceof $hxAlL.BlockStartState) {
                // we need to know the end state to set its start state
                if (state.endState === undefined) throw new Error("IllegalStateException");
                // block end states can only be associated to a single block start state
                if (state.endState.startState !== undefined) throw new Error("IllegalStateException");
                state.endState.startState = state;
            }
            if (state instanceof $abJj4.PlusLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $ia3fa.PlusBlockStartState) target.loopBackState = loopbackState;
                }
            } else if (state instanceof $iTtiT.StarLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $1UcbM.StarLoopEntryState) target.loopBackState = loopbackState;
                }
            }
        }
        //
        // DECISIONS
        //
        let ndecisions = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 1; i <= ndecisions; i++){
            let s = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
            let decState = atn.states[s];
            atn.decisionToState.push(decState);
            decState.decision = i - 1;
        }
        //
        // LEXER ACTIONS
        //
        if (atn.grammarType === 0 /* LEXER */ ) {
            if (supportsLexerActions) {
                atn.lexerActions = new Array($13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]));
                for(let i = 0; i < atn.lexerActions.length; i++){
                    let actionType = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
                    let data1 = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
                    if (data1 === 0xFFFF) data1 = -1;
                    let data2 = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
                    if (data2 === 0xFFFF) data2 = -1;
                    let lexerAction = this.lexerActionFactory(actionType, data1, data2);
                    atn.lexerActions[i] = lexerAction;
                }
            } else {
                // for compatibility with older serialized ATNs, convert the old
                // serialized action index for action transitions to the new
                // form, which is the index of a LexerCustomAction
                let legacyLexerActions = [];
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (!(transition instanceof $9PZbb.ActionTransition)) continue;
                    let ruleIndex = transition.ruleIndex;
                    let actionIndex = transition.actionIndex;
                    let lexerAction = new $dIbl0.LexerCustomAction(ruleIndex, actionIndex);
                    state.setTransition(i, new $9PZbb.ActionTransition(transition.target, ruleIndex, legacyLexerActions.length, false));
                    legacyLexerActions.push(lexerAction);
                }
                atn.lexerActions = legacyLexerActions;
            }
        }
        this.markPrecedenceDecisions(atn);
        atn.decisionToDFA = new Array(ndecisions);
        for(let i = 0; i < ndecisions; i++)atn.decisionToDFA[i] = new $ll18S.DFA(atn.decisionToState[i], i);
        if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
        if (this.deserializationOptions.isGenerateRuleBypassTransitions && atn.grammarType === 1 /* PARSER */ ) {
            atn.ruleToTokenType = new Int32Array(atn.ruleToStartState.length);
            for(let i = 0; i < atn.ruleToStartState.length; i++)atn.ruleToTokenType[i] = atn.maxTokenType + i + 1;
            for(let i = 0; i < atn.ruleToStartState.length; i++){
                let bypassStart = new $dMOpV.BasicBlockStartState();
                bypassStart.ruleIndex = i;
                atn.addState(bypassStart);
                let bypassStop = new $auJWg.BlockEndState();
                bypassStop.ruleIndex = i;
                atn.addState(bypassStop);
                bypassStart.endState = bypassStop;
                atn.defineDecisionState(bypassStart);
                bypassStop.startState = bypassStart;
                let endState;
                let excludeTransition;
                if (atn.ruleToStartState[i].isPrecedenceRule) {
                    // wrap from the beginning of the rule to the StarLoopEntryState
                    endState = undefined;
                    for (let state of atn.states){
                        if (state.ruleIndex !== i) continue;
                        if (!(state instanceof $1UcbM.StarLoopEntryState)) continue;
                        let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                        if (!(maybeLoopEndState instanceof $915XK.LoopEndState)) continue;
                        if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $830He.RuleStopState) {
                            endState = state;
                            break;
                        }
                    }
                    if (!endState) throw new Error("Couldn't identify final state of the precedence rule prefix section.");
                    excludeTransition = endState.loopBackState.transition(0);
                } else endState = atn.ruleToStopState[i];
                // all non-excluded transitions that currently target end state need to target blockEnd instead
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (transition === excludeTransition) continue;
                    if (transition.target === endState) transition.target = bypassStop;
                }
                // all transitions leaving the rule start state need to leave blockStart instead
                while(atn.ruleToStartState[i].numberOfTransitions > 0){
                    let transition = atn.ruleToStartState[i].removeTransition(atn.ruleToStartState[i].numberOfTransitions - 1);
                    bypassStart.addTransition(transition);
                }
                // link the new states
                atn.ruleToStartState[i].addTransition(new $krcCb.EpsilonTransition(bypassStart));
                bypassStop.addTransition(new $krcCb.EpsilonTransition(endState));
                let matchState = new $gVntA.BasicState();
                atn.addState(matchState);
                matchState.addTransition(new $bj9S6.AtomTransition(bypassStop, atn.ruleToTokenType[i]));
                bypassStart.addTransition(new $krcCb.EpsilonTransition(matchState));
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        if (this.deserializationOptions.isOptimize) {
            while(true){
                let optimizationCount = 0;
                optimizationCount += $13c20715f85c8f33$var$ATNDeserializer.inlineSetRules(atn);
                optimizationCount += $13c20715f85c8f33$var$ATNDeserializer.combineChainedEpsilons(atn);
                let preserveOrder = atn.grammarType === 0 /* LEXER */ ;
                optimizationCount += $13c20715f85c8f33$var$ATNDeserializer.optimizeSets(atn, preserveOrder);
                if (optimizationCount === 0) break;
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        $13c20715f85c8f33$var$ATNDeserializer.identifyTailCalls(atn);
        return atn;
    }
    deserializeSets(data, p, sets, unicodeDeserializer) {
        let nsets = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nsets; i++){
            let nintervals = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p]);
            p++;
            let set = new $fkZzb.IntervalSet();
            sets.push(set);
            let containsEof = $13c20715f85c8f33$var$ATNDeserializer.toInt(data[p++]) !== 0;
            if (containsEof) set.add(-1);
            for(let j = 0; j < nintervals; j++){
                let a = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                let b = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                set.add(a, b);
            }
        }
        return p;
    }
    /**
     * Analyze the {@link StarLoopEntryState} states in the specified ATN to set
     * the {@link StarLoopEntryState#precedenceRuleDecision} field to the
     * correct value.
     *
     * @param atn The ATN.
     */ markPrecedenceDecisions(atn) {
        // Map rule index -> precedence decision for that rule
        let rulePrecedenceDecisions = new Map();
        for (let state of atn.states){
            if (!(state instanceof $1UcbM.StarLoopEntryState)) continue;
            /* We analyze the ATN to determine if this ATN decision state is the
             * decision for the closure block that determines whether a
             * precedence rule should continue or complete.
             */ if (atn.ruleToStartState[state.ruleIndex].isPrecedenceRule) {
                let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                if (maybeLoopEndState instanceof $915XK.LoopEndState) {
                    if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $830He.RuleStopState) {
                        rulePrecedenceDecisions.set(state.ruleIndex, state);
                        state.precedenceRuleDecision = true;
                        state.precedenceLoopbackStates = new $igr91.BitSet(atn.states.length);
                    }
                }
            }
        }
        // After marking precedence decisions, we go back through and fill in
        // StarLoopEntryState.precedenceLoopbackStates.
        for (let precedenceDecision of rulePrecedenceDecisions)for (let transition of atn.ruleToStopState[precedenceDecision[0]].getTransitions()){
            if (transition.serializationType !== 1 /* EPSILON */ ) continue;
            let epsilonTransition = transition;
            if (epsilonTransition.outermostPrecedenceReturn !== -1) continue;
            precedenceDecision[1].precedenceLoopbackStates.set(transition.target.stateNumber);
        }
    }
    verifyATN(atn) {
        // verify assumptions
        for (let state of atn.states){
            this.checkCondition(state !== undefined, "ATN states should not be undefined.");
            if (state.stateType === $4txXj.ATNStateType.INVALID_TYPE) continue;
            this.checkCondition(state.onlyHasEpsilonTransitions || state.numberOfTransitions <= 1);
            if (state instanceof $ia3fa.PlusBlockStartState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $1UcbM.StarLoopEntryState) {
                let starLoopEntryState = state;
                this.checkCondition(starLoopEntryState.loopBackState !== undefined);
                this.checkCondition(starLoopEntryState.numberOfTransitions === 2);
                if (starLoopEntryState.transition(0).target instanceof $4BHtX.StarBlockStartState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $915XK.LoopEndState);
                    this.checkCondition(!starLoopEntryState.nonGreedy);
                } else if (starLoopEntryState.transition(0).target instanceof $915XK.LoopEndState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $4BHtX.StarBlockStartState);
                    this.checkCondition(starLoopEntryState.nonGreedy);
                } else throw new Error("IllegalStateException");
            }
            if (state instanceof $iTtiT.StarLoopbackState) {
                this.checkCondition(state.numberOfTransitions === 1);
                this.checkCondition(state.transition(0).target instanceof $1UcbM.StarLoopEntryState);
            }
            if (state instanceof $915XK.LoopEndState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $95fyx.RuleStartState) this.checkCondition(state.stopState !== undefined);
            if (state instanceof $hxAlL.BlockStartState) this.checkCondition(state.endState !== undefined);
            if (state instanceof $auJWg.BlockEndState) this.checkCondition(state.startState !== undefined);
            if (state instanceof $cpDvh.DecisionState) {
                let decisionState = state;
                this.checkCondition(decisionState.numberOfTransitions <= 1 || decisionState.decision >= 0);
            } else this.checkCondition(state.numberOfTransitions <= 1 || state instanceof $830He.RuleStopState);
        }
    }
    checkCondition(condition, message) {
        if (!condition) throw new Error("IllegalStateException: " + message);
    }
    static inlineSetRules(atn) {
        let inlinedCalls = 0;
        let ruleToInlineTransition = new Array(atn.ruleToStartState.length);
        for(let i = 0; i < atn.ruleToStartState.length; i++){
            let startState = atn.ruleToStartState[i];
            let middleState = startState;
            while(middleState.onlyHasEpsilonTransitions && middleState.numberOfOptimizedTransitions === 1 && middleState.getOptimizedTransition(0).serializationType === 1 /* EPSILON */ )middleState = middleState.getOptimizedTransition(0).target;
            if (middleState.numberOfOptimizedTransitions !== 1) continue;
            let matchTransition = middleState.getOptimizedTransition(0);
            let matchTarget = matchTransition.target;
            if (matchTransition.isEpsilon || !matchTarget.onlyHasEpsilonTransitions || matchTarget.numberOfOptimizedTransitions !== 1 || !(matchTarget.getOptimizedTransition(0).target instanceof $830He.RuleStopState)) continue;
            switch(matchTransition.serializationType){
                case 5 /* ATOM */ :
                case 2 /* RANGE */ :
                case 7 /* SET */ :
                    ruleToInlineTransition[i] = matchTransition;
                    break;
                case 8 /* NOT_SET */ :
                case 9 /* WILDCARD */ :
                    continue;
                default:
                    continue;
            }
        }
        for (let state of atn.states){
            if (state.ruleIndex < 0) continue;
            let optimizedTransitions;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $9ITLj.RuleTransition)) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                let ruleTransition = transition;
                let effective = ruleToInlineTransition[ruleTransition.target.ruleIndex];
                if (effective === undefined) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(i));
                }
                inlinedCalls++;
                let target = ruleTransition.followState;
                let intermediateState = new $gVntA.BasicState();
                intermediateState.setRuleIndex(target.ruleIndex);
                atn.addState(intermediateState);
                optimizedTransitions.push(new $krcCb.EpsilonTransition(intermediateState));
                switch(effective.serializationType){
                    case 5 /* ATOM */ :
                        intermediateState.addTransition(new $bj9S6.AtomTransition(target, effective._label));
                        break;
                    case 2 /* RANGE */ :
                        intermediateState.addTransition(new $kHPTE.RangeTransition(target, effective.from, effective.to));
                        break;
                    case 7 /* SET */ :
                        intermediateState.addTransition(new $cxnFA.SetTransition(target, effective.label));
                        break;
                    default:
                        throw new Error("UnsupportedOperationException");
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($e3RBK.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + inlinedCalls + " rule invocations by inlining sets.");
        return inlinedCalls;
    }
    static combineChainedEpsilons(atn) {
        let removedEdges = 0;
        for (let state of atn.states){
            if (!state.onlyHasEpsilonTransitions || state instanceof $830He.RuleStopState) continue;
            let optimizedTransitions;
            nextTransition: for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                let intermediate = transition.target;
                if (transition.serializationType !== 1 /* EPSILON */  || transition.outermostPrecedenceReturn !== -1 || intermediate.stateType !== $4txXj.ATNStateType.BASIC || !intermediate.onlyHasEpsilonTransitions) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++)if (intermediate.getOptimizedTransition(j).serializationType !== 1 /* EPSILON */  || intermediate.getOptimizedTransition(j).outermostPrecedenceReturn !== -1) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                removedEdges++;
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(j));
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++){
                    let target = intermediate.getOptimizedTransition(j).target;
                    optimizedTransitions.push(new $krcCb.EpsilonTransition(target));
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($e3RBK.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedEdges + " transitions by combining chained epsilon transitions.");
        return removedEdges;
    }
    static optimizeSets(atn, preserveOrder) {
        if (preserveOrder) // this optimization currently doesn't preserve edge order.
        return 0;
        let removedPaths = 0;
        let decisions = atn.decisionToState;
        for (let decision of decisions){
            let setTransitions = new $fkZzb.IntervalSet();
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++){
                let epsTransition = decision.getOptimizedTransition(i);
                if (!(epsTransition instanceof $krcCb.EpsilonTransition)) continue;
                if (epsTransition.target.numberOfOptimizedTransitions !== 1) continue;
                let transition = epsTransition.target.getOptimizedTransition(0);
                if (!(transition.target instanceof $auJWg.BlockEndState)) continue;
                if (transition instanceof $gYz0f.NotSetTransition) continue;
                if (transition instanceof $bj9S6.AtomTransition || transition instanceof $kHPTE.RangeTransition || transition instanceof $cxnFA.SetTransition) setTransitions.add(i);
            }
            if (setTransitions.size <= 1) continue;
            let optimizedTransitions = [];
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++)if (!setTransitions.contains(i)) optimizedTransitions.push(decision.getOptimizedTransition(i));
            let blockEndState = decision.getOptimizedTransition(setTransitions.minElement).target.getOptimizedTransition(0).target;
            let matchSet = new $fkZzb.IntervalSet();
            for (let interval of setTransitions.intervals)for(let j = interval.a; j <= interval.b; j++){
                let matchTransition = decision.getOptimizedTransition(j).target.getOptimizedTransition(0);
                if (matchTransition instanceof $gYz0f.NotSetTransition) throw new Error("Not yet implemented.");
                else matchSet.addAll(matchTransition.label);
            }
            let newTransition;
            if (matchSet.intervals.length === 1) {
                if (matchSet.size === 1) newTransition = new $bj9S6.AtomTransition(blockEndState, matchSet.minElement);
                else {
                    let matchInterval = matchSet.intervals[0];
                    newTransition = new $kHPTE.RangeTransition(blockEndState, matchInterval.a, matchInterval.b);
                }
            } else newTransition = new $cxnFA.SetTransition(blockEndState, matchSet);
            let setOptimizedState = new $gVntA.BasicState();
            setOptimizedState.setRuleIndex(decision.ruleIndex);
            atn.addState(setOptimizedState);
            setOptimizedState.addTransition(newTransition);
            optimizedTransitions.push(new $krcCb.EpsilonTransition(setOptimizedState));
            removedPaths += decision.numberOfOptimizedTransitions - optimizedTransitions.length;
            if (decision.isOptimized) while(decision.numberOfOptimizedTransitions > 0)decision.removeOptimizedTransition(decision.numberOfOptimizedTransitions - 1);
            for (let transition of optimizedTransitions)decision.addOptimizedTransition(transition);
        }
        if ($e3RBK.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedPaths + " paths by collapsing sets.");
        return removedPaths;
    }
    static identifyTailCalls(atn) {
        for (let state of atn.states){
            for(let i = 0; i < state.numberOfTransitions; i++){
                let transition = state.transition(i);
                if (!(transition instanceof $9ITLj.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
            if (!state.isOptimized) continue;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $9ITLj.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
        }
    }
    static testTailCall(atn, transition, optimizedPath) {
        if (!optimizedPath && transition.tailCall) return true;
        if (optimizedPath && transition.optimizedTailCall) return true;
        let reachable = new $igr91.BitSet(atn.states.length);
        let worklist = [];
        worklist.push(transition.followState);
        while(true){
            let state = worklist.pop();
            if (!state) break;
            if (reachable.get(state.stateNumber)) continue;
            if (state instanceof $830He.RuleStopState) continue;
            if (!state.onlyHasEpsilonTransitions) return false;
            let transitionCount = optimizedPath ? state.numberOfOptimizedTransitions : state.numberOfTransitions;
            for(let i = 0; i < transitionCount; i++){
                let t = optimizedPath ? state.getOptimizedTransition(i) : state.transition(i);
                if (t.serializationType !== 1 /* EPSILON */ ) return false;
                worklist.push(t.target);
            }
        }
        return true;
    }
    static toInt(c) {
        return c;
    }
    static toInt32(data, offset) {
        return (data[offset] | data[offset + 1] << 16) >>> 0;
    }
    static toUUID(data, offset) {
        let leastSigBits = $13c20715f85c8f33$var$ATNDeserializer.toInt32(data, offset);
        let lessSigBits = $13c20715f85c8f33$var$ATNDeserializer.toInt32(data, offset + 2);
        let moreSigBits = $13c20715f85c8f33$var$ATNDeserializer.toInt32(data, offset + 4);
        let mostSigBits = $13c20715f85c8f33$var$ATNDeserializer.toInt32(data, offset + 6);
        return new $dpMFH.UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    edgeFactory(atn, type, src, trg, arg1, arg2, arg3, sets) {
        let target = atn.states[trg];
        switch(type){
            case 1 /* EPSILON */ :
                return new $krcCb.EpsilonTransition(target);
            case 2 /* RANGE */ :
                if (arg3 !== 0) return new $kHPTE.RangeTransition(target, $iLVZN.Token.EOF, arg2);
                else return new $kHPTE.RangeTransition(target, arg1, arg2);
            case 3 /* RULE */ :
                let rt = new $9ITLj.RuleTransition(atn.states[arg1], arg2, arg3, target);
                return rt;
            case 4 /* PREDICATE */ :
                let pt = new $jrz9M.PredicateTransition(target, arg1, arg2, arg3 !== 0);
                return pt;
            case 10 /* PRECEDENCE */ :
                return new $1ZXDH.PrecedencePredicateTransition(target, arg1);
            case 5 /* ATOM */ :
                if (arg3 !== 0) return new $bj9S6.AtomTransition(target, $iLVZN.Token.EOF);
                else return new $bj9S6.AtomTransition(target, arg1);
            case 6 /* ACTION */ :
                let a = new $9PZbb.ActionTransition(target, arg1, arg2, arg3 !== 0);
                return a;
            case 7 /* SET */ :
                return new $cxnFA.SetTransition(target, sets[arg1]);
            case 8 /* NOT_SET */ :
                return new $gYz0f.NotSetTransition(target, sets[arg1]);
            case 9 /* WILDCARD */ :
                return new $dhddq.WildcardTransition(target);
        }
        throw new Error("The specified transition type is not valid.");
    }
    stateFactory(type, ruleIndex) {
        let s;
        switch(type){
            case $4txXj.ATNStateType.INVALID_TYPE:
                return new $dwSPu.InvalidState();
            case $4txXj.ATNStateType.BASIC:
                s = new $gVntA.BasicState();
                break;
            case $4txXj.ATNStateType.RULE_START:
                s = new $95fyx.RuleStartState();
                break;
            case $4txXj.ATNStateType.BLOCK_START:
                s = new $dMOpV.BasicBlockStartState();
                break;
            case $4txXj.ATNStateType.PLUS_BLOCK_START:
                s = new $ia3fa.PlusBlockStartState();
                break;
            case $4txXj.ATNStateType.STAR_BLOCK_START:
                s = new $4BHtX.StarBlockStartState();
                break;
            case $4txXj.ATNStateType.TOKEN_START:
                s = new $aiReF.TokensStartState();
                break;
            case $4txXj.ATNStateType.RULE_STOP:
                s = new $830He.RuleStopState();
                break;
            case $4txXj.ATNStateType.BLOCK_END:
                s = new $auJWg.BlockEndState();
                break;
            case $4txXj.ATNStateType.STAR_LOOP_BACK:
                s = new $iTtiT.StarLoopbackState();
                break;
            case $4txXj.ATNStateType.STAR_LOOP_ENTRY:
                s = new $1UcbM.StarLoopEntryState();
                break;
            case $4txXj.ATNStateType.PLUS_LOOP_BACK:
                s = new $abJj4.PlusLoopbackState();
                break;
            case $4txXj.ATNStateType.LOOP_END:
                s = new $915XK.LoopEndState();
                break;
            default:
                let message = `The specified state type ${type} is not valid.`;
                throw new Error(message);
        }
        s.ruleIndex = ruleIndex;
        return s;
    }
    lexerActionFactory(type, data1, data2) {
        switch(type){
            case 0 /* CHANNEL */ :
                return new $2ci2Z.LexerChannelAction(data1);
            case 1 /* CUSTOM */ :
                return new $dIbl0.LexerCustomAction(data1, data2);
            case 2 /* MODE */ :
                return new $cJknI.LexerModeAction(data1);
            case 3 /* MORE */ :
                return $3QeLH.LexerMoreAction.INSTANCE;
            case 4 /* POP_MODE */ :
                return $eDCNN.LexerPopModeAction.INSTANCE;
            case 5 /* PUSH_MODE */ :
                return new $lsd4Y.LexerPushModeAction(data1);
            case 6 /* SKIP */ :
                return $52ZMw.LexerSkipAction.INSTANCE;
            case 7 /* TYPE */ :
                return new $1Y2n7.LexerTypeAction(data1);
            default:
                let message = `The specified lexer action type ${type} is not valid.`;
                throw new Error(message);
        }
    }
}
/* WARNING: DO NOT MERGE THESE LINES. If UUIDs differ during a merge,
 * resolve the conflict by generating a new ID!
 */ /**
 * This is the earliest supported serialized UUID.
 */ $13c20715f85c8f33$var$ATNDeserializer.BASE_SERIALIZED_UUID = $dpMFH.UUID.fromString("E4178468-DF95-44D0-AD87-F22A5D5FB6D3");
/**
 * This UUID indicates an extension of {@link #ADDED_PRECEDENCE_TRANSITIONS}
 * for the addition of lexer actions encoded as a sequence of
 * {@link LexerAction} instances.
 */ $13c20715f85c8f33$var$ATNDeserializer.ADDED_LEXER_ACTIONS = $dpMFH.UUID.fromString("AB35191A-1603-487E-B75A-479B831EAF6D");
/**
 * This UUID indicates the serialized ATN contains two sets of
 * IntervalSets, where the second set's values are encoded as
 * 32-bit integers to support the full Unicode SMP range up to U+10FFFF.
 */ $13c20715f85c8f33$var$ATNDeserializer.ADDED_UNICODE_SMP = $dpMFH.UUID.fromString("C23FEA89-0605-4f51-AFB8-058BCAB8C91B");
/**
 * This list contains all of the currently supported UUIDs, ordered by when
 * the feature first appeared in this branch.
 */ $13c20715f85c8f33$var$ATNDeserializer.SUPPORTED_UUIDS = [
    $13c20715f85c8f33$var$ATNDeserializer.BASE_SERIALIZED_UUID,
    $13c20715f85c8f33$var$ATNDeserializer.ADDED_LEXER_ACTIONS,
    $13c20715f85c8f33$var$ATNDeserializer.ADDED_UNICODE_SMP
];
/**
 * This is the current serialized UUID.
 */ $13c20715f85c8f33$var$ATNDeserializer.SERIALIZED_UUID = $13c20715f85c8f33$var$ATNDeserializer.ADDED_UNICODE_SMP;
$13c20715f85c8f33$var$__decorate([
    $60gAE.NotNull
], $13c20715f85c8f33$var$ATNDeserializer.prototype, "deserializationOptions", void 0);
$13c20715f85c8f33$var$__decorate([
    $13c20715f85c8f33$var$__param(0, $60gAE.NotNull)
], $13c20715f85c8f33$var$ATNDeserializer.prototype, "deserialize", null);
$13c20715f85c8f33$var$__decorate([
    $13c20715f85c8f33$var$__param(0, $60gAE.NotNull)
], $13c20715f85c8f33$var$ATNDeserializer.prototype, "markPrecedenceDecisions", null);
$13c20715f85c8f33$var$__decorate([
    $60gAE.NotNull,
    $13c20715f85c8f33$var$__param(0, $60gAE.NotNull)
], $13c20715f85c8f33$var$ATNDeserializer.prototype, "edgeFactory", null);
module.exports.ATNDeserializer = $13c20715f85c8f33$var$ATNDeserializer;

});
parcelRegister("9PZbb", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7298556829c44a20$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7298556829c44a20$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionTransition = void 0;

var $60gAE = parcelRequire("60gAE");

var $lhxCK = parcelRequire("lhxCK");
let $7298556829c44a20$var$ActionTransition = class ActionTransition extends $lhxCK.Transition {
    constructor(target, ruleIndex, actionIndex = -1, isCtxDependent = false){
        super(target);
        this.ruleIndex = ruleIndex;
        this.actionIndex = actionIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 6 /* ACTION */ ;
    }
    get isEpsilon() {
        return true; // we are to be ignored by analysis 'cept for predicates
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "action_" + this.ruleIndex + ":" + this.actionIndex;
    }
};
$7298556829c44a20$var$__decorate([
    $60gAE.Override
], $7298556829c44a20$var$ActionTransition.prototype, "serializationType", null);
$7298556829c44a20$var$__decorate([
    $60gAE.Override
], $7298556829c44a20$var$ActionTransition.prototype, "isEpsilon", null);
$7298556829c44a20$var$__decorate([
    $60gAE.Override
], $7298556829c44a20$var$ActionTransition.prototype, "matches", null);
$7298556829c44a20$var$__decorate([
    $60gAE.Override
], $7298556829c44a20$var$ActionTransition.prototype, "toString", null);
$7298556829c44a20$var$ActionTransition = $7298556829c44a20$var$__decorate([
    $7298556829c44a20$var$__param(0, $60gAE.NotNull)
], $7298556829c44a20$var$ActionTransition);
module.exports.ActionTransition = $7298556829c44a20$var$ActionTransition;

});

parcelRegister("bj9S6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $83b9206100534304$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $83b9206100534304$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtomTransition = void 0;

var $fkZzb = parcelRequire("fkZzb");

var $60gAE = parcelRequire("60gAE");

var $lhxCK = parcelRequire("lhxCK");
/** TODO: make all transitions sets? no, should remove set edges */ let $83b9206100534304$var$AtomTransition = class AtomTransition extends $lhxCK.Transition {
    constructor(target, label){
        super(target);
        this._label = label;
    }
    get serializationType() {
        return 5 /* ATOM */ ;
    }
    get label() {
        return $fkZzb.IntervalSet.of(this._label);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this._label === symbol;
    }
    toString() {
        return String(this.label);
    }
};
$83b9206100534304$var$__decorate([
    $60gAE.Override
], $83b9206100534304$var$AtomTransition.prototype, "serializationType", null);
$83b9206100534304$var$__decorate([
    $60gAE.Override,
    $60gAE.NotNull
], $83b9206100534304$var$AtomTransition.prototype, "label", null);
$83b9206100534304$var$__decorate([
    $60gAE.Override
], $83b9206100534304$var$AtomTransition.prototype, "matches", null);
$83b9206100534304$var$__decorate([
    $60gAE.Override,
    $60gAE.NotNull
], $83b9206100534304$var$AtomTransition.prototype, "toString", null);
$83b9206100534304$var$AtomTransition = $83b9206100534304$var$__decorate([
    $83b9206100534304$var$__param(0, $60gAE.NotNull)
], $83b9206100534304$var$AtomTransition);
module.exports.AtomTransition = $83b9206100534304$var$AtomTransition;

});

parcelRegister("dMOpV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a096ddd600148c96$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicBlockStartState = void 0;

var $4txXj = parcelRequire("4txXj");

var $hxAlL = parcelRequire("hxAlL");

var $60gAE = parcelRequire("60gAE");
/**
 *
 * @author Sam Harwell
 */ class $a096ddd600148c96$var$BasicBlockStartState extends $hxAlL.BlockStartState {
    get stateType() {
        return $4txXj.ATNStateType.BLOCK_START;
    }
}
$a096ddd600148c96$var$__decorate([
    $60gAE.Override
], $a096ddd600148c96$var$BasicBlockStartState.prototype, "stateType", null);
module.exports.BasicBlockStartState = $a096ddd600148c96$var$BasicBlockStartState;

});
parcelRegister("hxAlL", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockStartState = void 0;

var $cpDvh = parcelRequire("cpDvh");
/**  The start of a regular `(...)` block. */ class $cc51b71917969b68$var$BlockStartState extends $cpDvh.DecisionState {
}
module.exports.BlockStartState = $cc51b71917969b68$var$BlockStartState;

});


parcelRegister("auJWg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7a405736209c92ab$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockEndState = void 0;

var $gh8QV = parcelRequire("gh8QV");

var $4txXj = parcelRequire("4txXj");

var $60gAE = parcelRequire("60gAE");
/** Terminal node of a simple `(a|b|c)` block. */ class $7a405736209c92ab$var$BlockEndState extends $gh8QV.ATNState {
    get stateType() {
        return $4txXj.ATNStateType.BLOCK_END;
    }
}
$7a405736209c92ab$var$__decorate([
    $60gAE.Override
], $7a405736209c92ab$var$BlockEndState.prototype, "stateType", null);
module.exports.BlockEndState = $7a405736209c92ab$var$BlockEndState;

});

parcelRegister("krcCb", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ee101d520c5289af$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ee101d520c5289af$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EpsilonTransition = void 0;

var $60gAE = parcelRequire("60gAE");

var $lhxCK = parcelRequire("lhxCK");
let $ee101d520c5289af$var$EpsilonTransition = class EpsilonTransition extends $lhxCK.Transition {
    constructor(target, outermostPrecedenceReturn = -1){
        super(target);
        this._outermostPrecedenceReturn = outermostPrecedenceReturn;
    }
    /**
     * @returns the rule index of a precedence rule for which this transition is
     * returning from, where the precedence value is 0; otherwise, -1.
     *
     * @see ATNConfig.isPrecedenceFilterSuppressed
     * @see ParserATNSimulator#applyPrecedenceFilter(ATNConfigSet, ParserRuleContext, PredictionContextCache)
     * @since 4.4.1
     */ get outermostPrecedenceReturn() {
        return this._outermostPrecedenceReturn;
    }
    get serializationType() {
        return 1 /* EPSILON */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "epsilon";
    }
};
$ee101d520c5289af$var$__decorate([
    $60gAE.Override
], $ee101d520c5289af$var$EpsilonTransition.prototype, "serializationType", null);
$ee101d520c5289af$var$__decorate([
    $60gAE.Override
], $ee101d520c5289af$var$EpsilonTransition.prototype, "isEpsilon", null);
$ee101d520c5289af$var$__decorate([
    $60gAE.Override
], $ee101d520c5289af$var$EpsilonTransition.prototype, "matches", null);
$ee101d520c5289af$var$__decorate([
    $60gAE.Override,
    $60gAE.NotNull
], $ee101d520c5289af$var$EpsilonTransition.prototype, "toString", null);
$ee101d520c5289af$var$EpsilonTransition = $ee101d520c5289af$var$__decorate([
    $ee101d520c5289af$var$__param(0, $60gAE.NotNull)
], $ee101d520c5289af$var$EpsilonTransition);
module.exports.EpsilonTransition = $ee101d520c5289af$var$EpsilonTransition;

});

parcelRegister("2ci2Z", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $199ab390e4e2dd6d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $199ab390e4e2dd6d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerChannelAction = void 0;

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");
/**
 * Implements the `channel` lexer action by calling
 * {@link Lexer#setChannel} with the assigned channel.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $199ab390e4e2dd6d$var$LexerChannelAction {
    /**
     * Constructs a new `channel` action with the specified channel value.
     * @param channel The channel value to pass to {@link Lexer#setChannel}.
     */ constructor(channel){
        this._channel = channel;
    }
    /**
     * Gets the channel to use for the {@link Token} created by the lexer.
     *
     * @returns The channel to use for the {@link Token} created by the lexer.
     */ get channel() {
        return this._channel;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#CHANNEL}.
     */ get actionType() {
        return 0 /* CHANNEL */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#setChannel} with the
     * value provided by {@link #getChannel}.
     */ execute(lexer) {
        lexer.channel = this._channel;
    }
    hashCode() {
        let hash = $ecbo5.MurmurHash.initialize();
        hash = $ecbo5.MurmurHash.update(hash, this.actionType);
        hash = $ecbo5.MurmurHash.update(hash, this._channel);
        return $ecbo5.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $199ab390e4e2dd6d$var$LexerChannelAction)) return false;
        return this._channel === obj._channel;
    }
    toString() {
        return `channel(${this._channel})`;
    }
}
$199ab390e4e2dd6d$var$__decorate([
    $60gAE.Override
], $199ab390e4e2dd6d$var$LexerChannelAction.prototype, "actionType", null);
$199ab390e4e2dd6d$var$__decorate([
    $60gAE.Override
], $199ab390e4e2dd6d$var$LexerChannelAction.prototype, "isPositionDependent", null);
$199ab390e4e2dd6d$var$__decorate([
    $60gAE.Override,
    $199ab390e4e2dd6d$var$__param(0, $60gAE.NotNull)
], $199ab390e4e2dd6d$var$LexerChannelAction.prototype, "execute", null);
$199ab390e4e2dd6d$var$__decorate([
    $60gAE.Override
], $199ab390e4e2dd6d$var$LexerChannelAction.prototype, "hashCode", null);
$199ab390e4e2dd6d$var$__decorate([
    $60gAE.Override
], $199ab390e4e2dd6d$var$LexerChannelAction.prototype, "equals", null);
$199ab390e4e2dd6d$var$__decorate([
    $60gAE.Override
], $199ab390e4e2dd6d$var$LexerChannelAction.prototype, "toString", null);
module.exports.LexerChannelAction = $199ab390e4e2dd6d$var$LexerChannelAction;

});

parcelRegister("dIbl0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9fb82ddfc4a1ce63$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9fb82ddfc4a1ce63$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerCustomAction = void 0;

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");
/**
 * Executes a custom lexer action by calling {@link Recognizer#action} with the
 * rule and action indexes assigned to the custom action. The implementation of
 * a custom action is added to the generated code for the lexer in an override
 * of {@link Recognizer#action} when the grammar is compiled.
 *
 * This class may represent embedded actions created with the `{...}`
 * syntax in ANTLR 4, as well as actions created for lexer commands where the
 * command argument could not be evaluated when the grammar was compiled.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $9fb82ddfc4a1ce63$var$LexerCustomAction {
    /**
     * Constructs a custom lexer action with the specified rule and action
     * indexes.
     *
     * @param ruleIndex The rule index to use for calls to
     * {@link Recognizer#action}.
     * @param actionIndex The action index to use for calls to
     * {@link Recognizer#action}.
     */ constructor(ruleIndex, actionIndex){
        this._ruleIndex = ruleIndex;
        this._actionIndex = actionIndex;
    }
    /**
     * Gets the rule index to use for calls to {@link Recognizer#action}.
     *
     * @returns The rule index for the custom action.
     */ get ruleIndex() {
        return this._ruleIndex;
    }
    /**
     * Gets the action index to use for calls to {@link Recognizer#action}.
     *
     * @returns The action index for the custom action.
     */ get actionIndex() {
        return this._actionIndex;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns {@link LexerActionType#CUSTOM}.
     */ get actionType() {
        return 1 /* CUSTOM */ ;
    }
    /**
     * Gets whether the lexer action is position-dependent. Position-dependent
     * actions may have different semantics depending on the {@link CharStream}
     * index at the time the action is executed.
     *
     * Custom actions are position-dependent since they may represent a
     * user-defined embedded action which makes calls to methods like
     * {@link Lexer#getText}.
     *
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * Custom actions are implemented by calling {@link Lexer#action} with the
     * appropriate rule and action indexes.
     */ execute(lexer) {
        lexer.action(undefined, this._ruleIndex, this._actionIndex);
    }
    hashCode() {
        let hash = $ecbo5.MurmurHash.initialize();
        hash = $ecbo5.MurmurHash.update(hash, this.actionType);
        hash = $ecbo5.MurmurHash.update(hash, this._ruleIndex);
        hash = $ecbo5.MurmurHash.update(hash, this._actionIndex);
        return $ecbo5.MurmurHash.finish(hash, 3);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $9fb82ddfc4a1ce63$var$LexerCustomAction)) return false;
        return this._ruleIndex === obj._ruleIndex && this._actionIndex === obj._actionIndex;
    }
}
$9fb82ddfc4a1ce63$var$__decorate([
    $60gAE.Override
], $9fb82ddfc4a1ce63$var$LexerCustomAction.prototype, "actionType", null);
$9fb82ddfc4a1ce63$var$__decorate([
    $60gAE.Override
], $9fb82ddfc4a1ce63$var$LexerCustomAction.prototype, "isPositionDependent", null);
$9fb82ddfc4a1ce63$var$__decorate([
    $60gAE.Override,
    $9fb82ddfc4a1ce63$var$__param(0, $60gAE.NotNull)
], $9fb82ddfc4a1ce63$var$LexerCustomAction.prototype, "execute", null);
$9fb82ddfc4a1ce63$var$__decorate([
    $60gAE.Override
], $9fb82ddfc4a1ce63$var$LexerCustomAction.prototype, "hashCode", null);
$9fb82ddfc4a1ce63$var$__decorate([
    $60gAE.Override
], $9fb82ddfc4a1ce63$var$LexerCustomAction.prototype, "equals", null);
module.exports.LexerCustomAction = $9fb82ddfc4a1ce63$var$LexerCustomAction;

});

parcelRegister("cJknI", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $94497f571f781ccc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $94497f571f781ccc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerModeAction = void 0;

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");
/**
 * Implements the `mode` lexer action by calling {@link Lexer#mode} with
 * the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $94497f571f781ccc$var$LexerModeAction {
    /**
     * Constructs a new `mode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#mode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `mode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MODE}.
     */ get actionType() {
        return 2 /* MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#mode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.mode(this._mode);
    }
    hashCode() {
        let hash = $ecbo5.MurmurHash.initialize();
        hash = $ecbo5.MurmurHash.update(hash, this.actionType);
        hash = $ecbo5.MurmurHash.update(hash, this._mode);
        return $ecbo5.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $94497f571f781ccc$var$LexerModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `mode(${this._mode})`;
    }
}
$94497f571f781ccc$var$__decorate([
    $60gAE.Override
], $94497f571f781ccc$var$LexerModeAction.prototype, "actionType", null);
$94497f571f781ccc$var$__decorate([
    $60gAE.Override
], $94497f571f781ccc$var$LexerModeAction.prototype, "isPositionDependent", null);
$94497f571f781ccc$var$__decorate([
    $60gAE.Override,
    $94497f571f781ccc$var$__param(0, $60gAE.NotNull)
], $94497f571f781ccc$var$LexerModeAction.prototype, "execute", null);
$94497f571f781ccc$var$__decorate([
    $60gAE.Override
], $94497f571f781ccc$var$LexerModeAction.prototype, "hashCode", null);
$94497f571f781ccc$var$__decorate([
    $60gAE.Override
], $94497f571f781ccc$var$LexerModeAction.prototype, "equals", null);
$94497f571f781ccc$var$__decorate([
    $60gAE.Override
], $94497f571f781ccc$var$LexerModeAction.prototype, "toString", null);
module.exports.LexerModeAction = $94497f571f781ccc$var$LexerModeAction;

});

parcelRegister("3QeLH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2cc1af1ed525ede0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2cc1af1ed525ede0$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerMoreAction = void 0;

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");
/**
 * Implements the `more` lexer action by calling {@link Lexer#more}.
 *
 * The `more` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $2cc1af1ed525ede0$var$LexerMoreAction {
    /**
     * Constructs the singleton instance of the lexer `more` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MORE}.
     */ get actionType() {
        return 3 /* MORE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#more}.
     */ execute(lexer) {
        lexer.more();
    }
    hashCode() {
        let hash = $ecbo5.MurmurHash.initialize();
        hash = $ecbo5.MurmurHash.update(hash, this.actionType);
        return $ecbo5.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "more";
    }
}
$2cc1af1ed525ede0$var$__decorate([
    $60gAE.Override
], $2cc1af1ed525ede0$var$LexerMoreAction.prototype, "actionType", null);
$2cc1af1ed525ede0$var$__decorate([
    $60gAE.Override
], $2cc1af1ed525ede0$var$LexerMoreAction.prototype, "isPositionDependent", null);
$2cc1af1ed525ede0$var$__decorate([
    $60gAE.Override,
    $2cc1af1ed525ede0$var$__param(0, $60gAE.NotNull)
], $2cc1af1ed525ede0$var$LexerMoreAction.prototype, "execute", null);
$2cc1af1ed525ede0$var$__decorate([
    $60gAE.Override
], $2cc1af1ed525ede0$var$LexerMoreAction.prototype, "hashCode", null);
$2cc1af1ed525ede0$var$__decorate([
    $60gAE.Override
], $2cc1af1ed525ede0$var$LexerMoreAction.prototype, "equals", null);
$2cc1af1ed525ede0$var$__decorate([
    $60gAE.Override
], $2cc1af1ed525ede0$var$LexerMoreAction.prototype, "toString", null);
module.exports.LexerMoreAction = $2cc1af1ed525ede0$var$LexerMoreAction;
(function(LexerMoreAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerMoreAction.INSTANCE = new LexerMoreAction();
})($2cc1af1ed525ede0$var$LexerMoreAction = module.exports.LexerMoreAction || (module.exports.LexerMoreAction = {}));

});

parcelRegister("eDCNN", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $aa82ce8093bd78df$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $aa82ce8093bd78df$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPopModeAction = void 0;

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");
/**
 * Implements the `popMode` lexer action by calling {@link Lexer#popMode}.
 *
 * The `popMode` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $aa82ce8093bd78df$var$LexerPopModeAction {
    /**
     * Constructs the singleton instance of the lexer `popMode` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#POP_MODE}.
     */ get actionType() {
        return 4 /* POP_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#popMode}.
     */ execute(lexer) {
        lexer.popMode();
    }
    hashCode() {
        let hash = $ecbo5.MurmurHash.initialize();
        hash = $ecbo5.MurmurHash.update(hash, this.actionType);
        return $ecbo5.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "popMode";
    }
}
$aa82ce8093bd78df$var$__decorate([
    $60gAE.Override
], $aa82ce8093bd78df$var$LexerPopModeAction.prototype, "actionType", null);
$aa82ce8093bd78df$var$__decorate([
    $60gAE.Override
], $aa82ce8093bd78df$var$LexerPopModeAction.prototype, "isPositionDependent", null);
$aa82ce8093bd78df$var$__decorate([
    $60gAE.Override,
    $aa82ce8093bd78df$var$__param(0, $60gAE.NotNull)
], $aa82ce8093bd78df$var$LexerPopModeAction.prototype, "execute", null);
$aa82ce8093bd78df$var$__decorate([
    $60gAE.Override
], $aa82ce8093bd78df$var$LexerPopModeAction.prototype, "hashCode", null);
$aa82ce8093bd78df$var$__decorate([
    $60gAE.Override
], $aa82ce8093bd78df$var$LexerPopModeAction.prototype, "equals", null);
$aa82ce8093bd78df$var$__decorate([
    $60gAE.Override
], $aa82ce8093bd78df$var$LexerPopModeAction.prototype, "toString", null);
module.exports.LexerPopModeAction = $aa82ce8093bd78df$var$LexerPopModeAction;
(function(LexerPopModeAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerPopModeAction.INSTANCE = new LexerPopModeAction();
})($aa82ce8093bd78df$var$LexerPopModeAction = module.exports.LexerPopModeAction || (module.exports.LexerPopModeAction = {}));

});

parcelRegister("lsd4Y", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f9e65bbcde0d3afb$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f9e65bbcde0d3afb$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPushModeAction = void 0;

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");
/**
 * Implements the `pushMode` lexer action by calling
 * {@link Lexer#pushMode} with the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $f9e65bbcde0d3afb$var$LexerPushModeAction {
    /**
     * Constructs a new `pushMode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#pushMode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `pushMode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#PUSH_MODE}.
     */ get actionType() {
        return 5 /* PUSH_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#pushMode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.pushMode(this._mode);
    }
    hashCode() {
        let hash = $ecbo5.MurmurHash.initialize();
        hash = $ecbo5.MurmurHash.update(hash, this.actionType);
        hash = $ecbo5.MurmurHash.update(hash, this._mode);
        return $ecbo5.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $f9e65bbcde0d3afb$var$LexerPushModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `pushMode(${this._mode})`;
    }
}
$f9e65bbcde0d3afb$var$__decorate([
    $60gAE.Override
], $f9e65bbcde0d3afb$var$LexerPushModeAction.prototype, "actionType", null);
$f9e65bbcde0d3afb$var$__decorate([
    $60gAE.Override
], $f9e65bbcde0d3afb$var$LexerPushModeAction.prototype, "isPositionDependent", null);
$f9e65bbcde0d3afb$var$__decorate([
    $60gAE.Override,
    $f9e65bbcde0d3afb$var$__param(0, $60gAE.NotNull)
], $f9e65bbcde0d3afb$var$LexerPushModeAction.prototype, "execute", null);
$f9e65bbcde0d3afb$var$__decorate([
    $60gAE.Override
], $f9e65bbcde0d3afb$var$LexerPushModeAction.prototype, "hashCode", null);
$f9e65bbcde0d3afb$var$__decorate([
    $60gAE.Override
], $f9e65bbcde0d3afb$var$LexerPushModeAction.prototype, "equals", null);
$f9e65bbcde0d3afb$var$__decorate([
    $60gAE.Override
], $f9e65bbcde0d3afb$var$LexerPushModeAction.prototype, "toString", null);
module.exports.LexerPushModeAction = $f9e65bbcde0d3afb$var$LexerPushModeAction;

});

parcelRegister("52ZMw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3acd102bb91c9dbd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3acd102bb91c9dbd$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerSkipAction = void 0;

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");
/**
 * Implements the `skip` lexer action by calling {@link Lexer#skip}.
 *
 * The `skip` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $3acd102bb91c9dbd$var$LexerSkipAction {
    /**
     * Constructs the singleton instance of the lexer `skip` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#SKIP}.
     */ get actionType() {
        return 6 /* SKIP */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#skip}.
     */ execute(lexer) {
        lexer.skip();
    }
    hashCode() {
        let hash = $ecbo5.MurmurHash.initialize();
        hash = $ecbo5.MurmurHash.update(hash, this.actionType);
        return $ecbo5.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "skip";
    }
}
$3acd102bb91c9dbd$var$__decorate([
    $60gAE.Override
], $3acd102bb91c9dbd$var$LexerSkipAction.prototype, "actionType", null);
$3acd102bb91c9dbd$var$__decorate([
    $60gAE.Override
], $3acd102bb91c9dbd$var$LexerSkipAction.prototype, "isPositionDependent", null);
$3acd102bb91c9dbd$var$__decorate([
    $60gAE.Override,
    $3acd102bb91c9dbd$var$__param(0, $60gAE.NotNull)
], $3acd102bb91c9dbd$var$LexerSkipAction.prototype, "execute", null);
$3acd102bb91c9dbd$var$__decorate([
    $60gAE.Override
], $3acd102bb91c9dbd$var$LexerSkipAction.prototype, "hashCode", null);
$3acd102bb91c9dbd$var$__decorate([
    $60gAE.Override
], $3acd102bb91c9dbd$var$LexerSkipAction.prototype, "equals", null);
$3acd102bb91c9dbd$var$__decorate([
    $60gAE.Override
], $3acd102bb91c9dbd$var$LexerSkipAction.prototype, "toString", null);
module.exports.LexerSkipAction = $3acd102bb91c9dbd$var$LexerSkipAction;
(function(LexerSkipAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerSkipAction.INSTANCE = new LexerSkipAction();
})($3acd102bb91c9dbd$var$LexerSkipAction = module.exports.LexerSkipAction || (module.exports.LexerSkipAction = {}));

});

parcelRegister("1Y2n7", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $16ed3c07e351a95a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $16ed3c07e351a95a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerTypeAction = void 0;

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");
/**
 * Implements the `type` lexer action by setting `Lexer.type`
 * with the assigned type.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $16ed3c07e351a95a$var$LexerTypeAction {
    /**
     * Constructs a new `type` action with the specified token type value.
     * @param type The type to assign to the token using `Lexer.type`.
     */ constructor(type){
        this._type = type;
    }
    /**
     * Gets the type to assign to a token created by the lexer.
     * @returns The type to assign to a token created by the lexer.
     */ get type() {
        return this._type;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#TYPE}.
     */ get actionType() {
        return 7 /* TYPE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by setting `Lexer.type` with the
     * value provided by `type`.
     */ execute(lexer) {
        lexer.type = this._type;
    }
    hashCode() {
        let hash = $ecbo5.MurmurHash.initialize();
        hash = $ecbo5.MurmurHash.update(hash, this.actionType);
        hash = $ecbo5.MurmurHash.update(hash, this._type);
        return $ecbo5.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $16ed3c07e351a95a$var$LexerTypeAction)) return false;
        return this._type === obj._type;
    }
    toString() {
        return `type(${this._type})`;
    }
}
$16ed3c07e351a95a$var$__decorate([
    $60gAE.Override
], $16ed3c07e351a95a$var$LexerTypeAction.prototype, "actionType", null);
$16ed3c07e351a95a$var$__decorate([
    $60gAE.Override
], $16ed3c07e351a95a$var$LexerTypeAction.prototype, "isPositionDependent", null);
$16ed3c07e351a95a$var$__decorate([
    $60gAE.Override,
    $16ed3c07e351a95a$var$__param(0, $60gAE.NotNull)
], $16ed3c07e351a95a$var$LexerTypeAction.prototype, "execute", null);
$16ed3c07e351a95a$var$__decorate([
    $60gAE.Override
], $16ed3c07e351a95a$var$LexerTypeAction.prototype, "hashCode", null);
$16ed3c07e351a95a$var$__decorate([
    $60gAE.Override
], $16ed3c07e351a95a$var$LexerTypeAction.prototype, "equals", null);
$16ed3c07e351a95a$var$__decorate([
    $60gAE.Override
], $16ed3c07e351a95a$var$LexerTypeAction.prototype, "toString", null);
module.exports.LexerTypeAction = $16ed3c07e351a95a$var$LexerTypeAction;

});

parcelRegister("915XK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6908d5231b00bc92$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoopEndState = void 0;

var $gh8QV = parcelRequire("gh8QV");

var $4txXj = parcelRequire("4txXj");

var $60gAE = parcelRequire("60gAE");
/** Mark the end of a * or + loop. */ class $6908d5231b00bc92$var$LoopEndState extends $gh8QV.ATNState {
    get stateType() {
        return $4txXj.ATNStateType.LOOP_END;
    }
}
$6908d5231b00bc92$var$__decorate([
    $60gAE.Override
], $6908d5231b00bc92$var$LoopEndState.prototype, "stateType", null);
module.exports.LoopEndState = $6908d5231b00bc92$var$LoopEndState;

});

parcelRegister("e3RBK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a3caede9058c1b2e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a3caede9058c1b2e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserATNSimulator = void 0;

var $kytPQ = parcelRequire("kytPQ");

var $9PZbb = parcelRequire("9PZbb");

var $fqc4S = parcelRequire("fqc4S");

var $5Zd5d = parcelRequire("5Zd5d");

var $dQ2fw = parcelRequire("dQ2fw");

var $lz4Ok = parcelRequire("lz4Ok");

var $3cXWi = parcelRequire("3cXWi");

var $d5Bh2 = parcelRequire("d5Bh2");

var $4txXj = parcelRequire("4txXj");

var $bj9S6 = parcelRequire("bj9S6");

var $igr91 = parcelRequire("igr91");

var $1wHaf = parcelRequire("1wHaf");

var $cpDvh = parcelRequire("cpDvh");

var $g3I27 = parcelRequire("g3I27");

var $jL0Xb = parcelRequire("jL0Xb");

var $312SH = parcelRequire("312SH");

var $hPLPA = parcelRequire("hPLPA");

var $60gAE = parcelRequire("60gAE");

var $gYz0f = parcelRequire("gYz0f");

var $1O6nA = parcelRequire("1O6nA");

var $cWz6y = parcelRequire("cWz6y");

var $gN8af = parcelRequire("gN8af");

var $gT9VD = parcelRequire("gT9VD");

var $fCMxU = parcelRequire("fCMxU");

var $iAyfo = parcelRequire("iAyfo");

var $830He = parcelRequire("830He");

var $9ITLj = parcelRequire("9ITLj");

var $gt6ZZ = parcelRequire("gt6ZZ");

var $cxnFA = parcelRequire("cxnFA");

var $hTR8H = parcelRequire("hTR8H");

var $iLVZN = parcelRequire("iLVZN");

var $7DbrH = parcelRequire("7DbrH");

var $lzl5a = parcelRequire("lzl5a");
const $a3caede9058c1b2e$var$MAX_SHORT_VALUE = 0xFFFF;
const $a3caede9058c1b2e$var$MIN_INTEGER_VALUE = -2147483648;
/**
 * The embodiment of the adaptive LL(*), ALL(*), parsing strategy.
 *
 * The basic complexity of the adaptive strategy makes it harder to understand.
 * We begin with ATN simulation to build paths in a DFA. Subsequent prediction
 * requests go through the DFA first. If they reach a state without an edge for
 * the current symbol, the algorithm fails over to the ATN simulation to
 * complete the DFA path for the current input (until it finds a conflict state
 * or uniquely predicting state).
 *
 * All of that is done without using the outer context because we want to create
 * a DFA that is not dependent upon the rule invocation stack when we do a
 * prediction. One DFA works in all contexts. We avoid using context not
 * necessarily because it's slower, although it can be, but because of the DFA
 * caching problem. The closure routine only considers the rule invocation stack
 * created during prediction beginning in the decision rule. For example, if
 * prediction occurs without invoking another rule's ATN, there are no context
 * stacks in the configurations. When lack of context leads to a conflict, we
 * don't know if it's an ambiguity or a weakness in the strong LL(*) parsing
 * strategy (versus full LL(*)).
 *
 * When SLL yields a configuration set with conflict, we rewind the input and
 * retry the ATN simulation, this time using full outer context without adding
 * to the DFA. Configuration context stacks will be the full invocation stacks
 * from the start rule. If we get a conflict using full context, then we can
 * definitively say we have a true ambiguity for that input sequence. If we
 * don't get a conflict, it implies that the decision is sensitive to the outer
 * context. (It is not context-sensitive in the sense of context-sensitive
 * grammars.)
 *
 * The next time we reach this DFA state with an SLL conflict, through DFA
 * simulation, we will again retry the ATN simulation using full context mode.
 * This is slow because we can't save the results and have to "interpret" the
 * ATN each time we get that input.
 *
 * **CACHING FULL CONTEXT PREDICTIONS**
 *
 * We could cache results from full context to predicted alternative easily and
 * that saves a lot of time but doesn't work in presence of predicates. The set
 * of visible predicates from the ATN start state changes depending on the
 * context, because closure can fall off the end of a rule. I tried to cache
 * tuples (stack context, semantic context, predicted alt) but it was slower
 * than interpreting and much more complicated. Also required a huge amount of
 * memory. The goal is not to create the world's fastest parser anyway. I'd like
 * to keep this algorithm simple. By launching multiple threads, we can improve
 * the speed of parsing across a large number of files.
 *
 * There is no strict ordering between the amount of input used by SLL vs LL,
 * which makes it really hard to build a cache for full context. Let's say that
 * we have input A B C that leads to an SLL conflict with full context X. That
 * implies that using X we might only use A B but we could also use A B C D to
 * resolve conflict. Input A B C D could predict alternative 1 in one position
 * in the input and A B C E could predict alternative 2 in another position in
 * input. The conflicting SLL configurations could still be non-unique in the
 * full context prediction, which would lead us to requiring more input than the
 * original A B C.	To make a	prediction cache work, we have to track	the exact
 * input	used during the previous prediction. That amounts to a cache that maps
 * X to a specific DFA for that context.
 *
 * Something should be done for left-recursive expression predictions. They are
 * likely LL(1) + pred eval. Easier to do the whole SLL unless error and retry
 * with full LL thing Sam does.
 *
 * **AVOIDING FULL CONTEXT PREDICTION**
 *
 * We avoid doing full context retry when the outer context is empty, we did not
 * dip into the outer context by falling off the end of the decision state rule,
 * or when we force SLL mode.
 *
 * As an example of the not dip into outer context case, consider as super
 * constructor calls versus function calls. One grammar might look like
 * this:
 *
 * ```antlr
 * ctorBody
 *   : '{' superCall? stat* '}'
 *   ;
 * ```
 *
 * Or, you might see something like
 *
 * ```antlr
 * stat
 *   : superCall ';'
 *   | expression ';'
 *   | ...
 *   ;
 * ```
 *
 * In both cases I believe that no closure operations will dip into the outer
 * context. In the first case ctorBody in the worst case will stop at the '}'.
 * In the 2nd case it should stop at the ';'. Both cases should stay within the
 * entry rule and not dip into the outer context.
 *
 * **PREDICATES**
 *
 * Predicates are always evaluated if present in either SLL or LL both. SLL and
 * LL simulation deals with predicates differently. SLL collects predicates as
 * it performs closure operations like ANTLR v3 did. It delays predicate
 * evaluation until it reaches and accept state. This allows us to cache the SLL
 * ATN simulation whereas, if we had evaluated predicates on-the-fly during
 * closure, the DFA state configuration sets would be different and we couldn't
 * build up a suitable DFA.
 *
 * When building a DFA accept state during ATN simulation, we evaluate any
 * predicates and return the sole semantically valid alternative. If there is
 * more than 1 alternative, we report an ambiguity. If there are 0 alternatives,
 * we throw an exception. Alternatives without predicates act like they have
 * true predicates. The simple way to think about it is to strip away all
 * alternatives with false predicates and choose the minimum alternative that
 * remains.
 *
 * When we start in the DFA and reach an accept state that's predicated, we test
 * those and return the minimum semantically viable alternative. If no
 * alternatives are viable, we throw an exception.
 *
 * During full LL ATN simulation, closure always evaluates predicates and
 * on-the-fly. This is crucial to reducing the configuration set size during
 * closure. It hits a landmine when parsing with the Java grammar, for example,
 * without this on-the-fly evaluation.
 *
 * **SHARING DFA**
 *
 * All instances of the same parser share the same decision DFAs through a
 * static field. Each instance gets its own ATN simulator but they share the
 * same {@link ATN#decisionToDFA} field. They also share a
 * {@link PredictionContextCache} object that makes sure that all
 * {@link PredictionContext} objects are shared among the DFA states. This makes
 * a big size difference.
 *
 * **THREAD SAFETY**
 *
 * The {@link ParserATNSimulator} locks on the {@link ATN#decisionToDFA} field when
 * it adds a new DFA object to that array. {@link #addDFAEdge}
 * locks on the DFA for the current decision when setting the
 * {@link DFAState#edges} field. {@link #addDFAState} locks on
 * the DFA for the current decision when looking up a DFA state to see if it
 * already exists. We must make sure that all requests to add DFA states that
 * are equivalent result in the same shared DFA object. This is because lots of
 * threads will be trying to update the DFA at once. The
 * {@link #addDFAState} method also locks inside the DFA lock
 * but this time on the shared context cache when it rebuilds the
 * configurations' {@link PredictionContext} objects using cached
 * subgraphs/nodes. No other locking occurs, even during DFA simulation. This is
 * safe as long as we can guarantee that all threads referencing
 * `s.edge[t]` get the same physical target {@link DFAState}, or
 * `undefined`. Once into the DFA, the DFA simulation does not reference the
 * {@link DFA#states} map. It follows the {@link DFAState#edges} field to new
 * targets. The DFA simulator will either find {@link DFAState#edges} to be
 * `undefined`, to be non-`undefined` and `dfa.edges[t]` undefined, or
 * `dfa.edges[t]` to be non-undefined. The
 * {@link #addDFAEdge} method could be racing to set the field
 * but in either case the DFA simulator works; if `undefined`, and requests ATN
 * simulation. It could also race trying to get `dfa.edges[t]`, but either
 * way it will work because it's not doing a test and set operation.
 *
 * **Starting with SLL then failing to combined SLL/LL (Two-Stage
 * Parsing)**
 *
 * Sam pointed out that if SLL does not give a syntax error, then there is no
 * point in doing full LL, which is slower. We only have to try LL if we get a
 * syntax error. For maximum speed, Sam starts the parser set to pure SLL
 * mode with the {@link BailErrorStrategy}:
 *
 * ```
 * parser.interpreter.{@link #setPredictionMode setPredictionMode}`(`{@link PredictionMode#SLL}`)`;
 * parser.{@link Parser#setErrorHandler setErrorHandler}(new {@link BailErrorStrategy}());
 * ```
 *
 * If it does not get a syntax error, then we're done. If it does get a syntax
 * error, we need to retry with the combined SLL/LL strategy.
 *
 * The reason this works is as follows. If there are no SLL conflicts, then the
 * grammar is SLL (at least for that input set). If there is an SLL conflict,
 * the full LL analysis must yield a set of viable alternatives which is a
 * subset of the alternatives reported by SLL. If the LL set is a singleton,
 * then the grammar is LL but not SLL. If the LL set is the same size as the SLL
 * set, the decision is SLL. If the LL set has size &gt; 1, then that decision
 * is truly ambiguous on the current input. If the LL set is smaller, then the
 * SLL conflict resolution might choose an alternative that the full LL would
 * rule out as a possibility based upon better context information. If that's
 * the case, then the SLL parse will definitely get an error because the full LL
 * analysis says it's not viable. If SLL conflict resolution chooses an
 * alternative within the LL set, them both SLL and LL would choose the same
 * alternative because they both choose the minimum of multiple conflicting
 * alternatives.
 *
 * Let's say we have a set of SLL conflicting alternatives `{1, 2, 3}` and
 * a smaller LL set called *s*. If *s* is `{2, 3}`, then SLL
 * parsing will get an error because SLL will pursue alternative 1. If
 * *s* is `{1, 2}` or `{1, 3}` then both SLL and LL will
 * choose the same alternative because alternative one is the minimum of either
 * set. If *s* is `{2}` or `{3}` then SLL will get a syntax
 * error. If *s* is `{1}` then SLL will succeed.
 *
 * Of course, if the input is invalid, then we will get an error for sure in
 * both SLL and LL parsing. Erroneous input will therefore require 2 passes over
 * the input.
 */ let $a3caede9058c1b2e$var$ParserATNSimulator = class ParserATNSimulator extends $d5Bh2.ATNSimulator {
    constructor(atn, parser){
        super(atn);
        this.predictionMode = $iAyfo.PredictionMode.LL;
        this.force_global_context = false;
        this.always_try_local_context = true;
        /**
         * Determines whether the DFA is used for full-context predictions. When
         * `true`, the DFA stores transition information for both full-context
         * and SLL parsing; otherwise, the DFA only stores SLL transition
         * information.
         *
         * For some grammars, enabling the full-context DFA can result in a
         * substantial performance improvement. However, this improvement typically
         * comes at the expense of memory used for storing the cached DFA states,
         * configuration sets, and prediction contexts.
         *
         * The default value is `false`.
         */ this.enable_global_context_dfa = false;
        this.optimize_unique_closure = true;
        this.optimize_ll1 = true;
        this.optimize_tail_calls = true;
        this.tail_call_preserves_sll = true;
        this.treat_sllk1_conflict_as_ambiguity = false;
        /**
         * When `true`, ambiguous alternatives are reported when they are
         * encountered within {@link #execATN}. When `false`, these messages
         * are suppressed. The default is `false`.
         *
         * When messages about ambiguous alternatives are not required, setting this
         * to `false` enables additional internal optimizations which may lose
         * this information.
         */ this.reportAmbiguities = false;
        /** By default we do full context-sensitive LL(*) parsing not
         *  Strong LL(*) parsing. If we fail with Strong LL(*) we
         *  try full LL(*). That means we rewind and use context information
         *  when closure operations fall off the end of the rule that
         *  holds the decision were evaluating.
         */ this.userWantsCtxSensitive = true;
        this._parser = parser;
    }
    getPredictionMode() {
        return this.predictionMode;
    }
    setPredictionMode(predictionMode) {
        this.predictionMode = predictionMode;
    }
    reset() {
    // intentionally empty
    }
    adaptivePredict(input, decision, outerContext, useContext) {
        if (useContext === undefined) useContext = false;
        let dfa = this.atn.decisionToDFA[decision];
        $lzl5a(dfa != null);
        if (this.optimize_ll1 && !dfa.isPrecedenceDfa && !dfa.isEmpty) {
            let ll_1 = input.LA(1);
            if (ll_1 >= 0 && ll_1 <= 0xFFFF) {
                let key = (decision << 16 >>> 0) + ll_1;
                let alt = this.atn.LL1Table.get(key);
                if (alt != null) return alt;
            }
        }
        this.dfa = dfa;
        if (this.force_global_context) useContext = true;
        else if (!this.always_try_local_context) useContext = useContext || dfa.isContextSensitive;
        this.userWantsCtxSensitive = useContext || this.predictionMode !== $iAyfo.PredictionMode.SLL && outerContext != null && !this.atn.decisionToState[decision].sll;
        if (outerContext == null) outerContext = $gN8af.ParserRuleContext.emptyContext();
        let state;
        if (!dfa.isEmpty) state = this.getStartState(dfa, input, outerContext, useContext);
        if (state == null) {
            if (outerContext == null) outerContext = $gN8af.ParserRuleContext.emptyContext();
            if (ParserATNSimulator.debug) console.log("ATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
            state = this.computeStartState(dfa, outerContext, useContext);
        }
        let m = input.mark();
        let index = input.index;
        try {
            let alt = this.execDFA(dfa, input, index, state);
            if (ParserATNSimulator.debug) console.log("DFA after predictATN: " + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
            return alt;
        } finally{
            this.dfa = undefined;
            input.seek(index);
            input.release(m);
        }
    }
    getStartState(dfa, input, outerContext, useContext) {
        if (!useContext) {
            if (dfa.isPrecedenceDfa) {
                // the start state for a precedence DFA depends on the current
                // parser precedence, and is provided by a DFA method.
                let state = dfa.getPrecedenceStartState(this._parser.precedence, false);
                if (state == null) return undefined;
                return new $hTR8H.SimulatorState(outerContext, state, false, outerContext);
            } else {
                if (dfa.s0 == null) return undefined;
                return new $hTR8H.SimulatorState(outerContext, dfa.s0, false, outerContext);
            }
        }
        if (!this.enable_global_context_dfa) return undefined;
        let remainingContext = outerContext;
        $lzl5a(outerContext != null);
        let s0;
        if (dfa.isPrecedenceDfa) s0 = dfa.getPrecedenceStartState(this._parser.precedence, true);
        else s0 = dfa.s0full;
        while(remainingContext != null && s0 != null && s0.isContextSensitive){
            remainingContext = this.skipTailCalls(remainingContext);
            s0 = s0.getContextTarget(this.getReturnState(remainingContext));
            if (remainingContext.isEmpty) $lzl5a(s0 == null || !s0.isContextSensitive);
            else remainingContext = remainingContext.parent;
        }
        if (s0 == null) return undefined;
        return new $hTR8H.SimulatorState(outerContext, s0, useContext, remainingContext);
    }
    execDFA(dfa, input, startIndex, state) {
        let outerContext = state.outerContext;
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
        if (ParserATNSimulator.dfa_debug) console.log(dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
        let s = state.s0;
        let t = input.LA(1);
        let remainingOuterContext = state.remainingOuterContext;
        while(true){
            if (ParserATNSimulator.dfa_debug) console.log("DFA state " + s.stateNumber + " LA(1)==" + this.getLookaheadName(input));
            if (state.useContext) while(s.isContextSymbol(t)){
                let next;
                if (remainingOuterContext != null) {
                    remainingOuterContext = this.skipTailCalls(remainingOuterContext);
                    next = s.getContextTarget(this.getReturnState(remainingOuterContext));
                }
                if (next == null) {
                    // fail over to ATN
                    let initialState = new $hTR8H.SimulatorState(state.outerContext, s, state.useContext, remainingOuterContext);
                    return this.execATN(dfa, input, startIndex, initialState);
                }
                $lzl5a(remainingOuterContext != null);
                remainingOuterContext = remainingOuterContext.parent;
                s = next;
            }
            if (this.isAcceptState(s, state.useContext)) {
                if (s.predicates != null) {
                    if (ParserATNSimulator.dfa_debug) console.log("accept " + s);
                } else if (ParserATNSimulator.dfa_debug) console.log("accept; predict " + s.prediction + " in state " + s.stateNumber);
                break;
            }
            // t is not updated if one of these states is reached
            $lzl5a(!this.isAcceptState(s, state.useContext));
            // if no edge, pop over to ATN interpreter, update DFA and return
            let target = this.getExistingTargetState(s, t);
            if (target == null) {
                if (ParserATNSimulator.dfa_debug && t >= 0) console.log("no edge for " + this._parser.vocabulary.getDisplayName(t));
                let alt;
                if (ParserATNSimulator.dfa_debug) {
                    let interval = $312SH.Interval.of(startIndex, this._parser.inputStream.index);
                    console.log("ATN exec upon " + this._parser.inputStream.getText(interval) + " at DFA state " + s.stateNumber);
                }
                let initialState = new $hTR8H.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                alt = this.execATN(dfa, input, startIndex, initialState);
                if (ParserATNSimulator.dfa_debug) console.log("back from DFA update, alt=" + alt + ", dfa=\n" + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                // action already executed
                if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + alt);
                return alt; // we've updated DFA, exec'd action, and have our deepest answer
            } else if (target === $d5Bh2.ATNSimulator.ERROR) {
                let errorState = new $hTR8H.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                return this.handleNoViableAlt(input, startIndex, errorState);
            }
            s = target;
            if (!this.isAcceptState(s, state.useContext) && t !== $hPLPA.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
        //		if ( acceptState==null ) {
        //			if ( debug ) System.out.println("!!! no viable alt in dfa");
        //			return -1;
        //		}
        if (!state.useContext && s.configs.conflictInfo != null) {
            if (dfa.atnStartState instanceof $cpDvh.DecisionState) {
                if (!this.userWantsCtxSensitive || !s.configs.dipsIntoOuterContext && s.configs.isExactConflict || this.treat_sllk1_conflict_as_ambiguity && input.index === startIndex) ;
                else {
                    $lzl5a(!state.useContext);
                    // Before attempting full context prediction, check to see if there are
                    // disambiguating or validating predicates to evaluate which allow an
                    // immediate decision
                    let conflictingAlts;
                    let predicates = s.predicates;
                    if (predicates != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        conflictingAlts = this.evalSemanticContext(predicates, outerContext, true);
                        if (conflictingAlts.cardinality() === 1) return conflictingAlts.nextSetBit(0);
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                    if (this.reportAmbiguities) {
                        let conflictState = new $hTR8H.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                        this.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, input.index);
                    }
                    input.seek(startIndex);
                    return this.adaptivePredict(input, dfa.decision, outerContext, true);
                }
            }
        }
        // Before jumping to prediction, check to see if there are
        // disambiguating or validating predicates to evaluate
        let predicates = s.predicates;
        if (predicates != null) {
            let stopIndex = input.index;
            if (startIndex !== stopIndex) input.seek(startIndex);
            let alts = this.evalSemanticContext(predicates, outerContext, this.reportAmbiguities && this.predictionMode === $iAyfo.PredictionMode.LL_EXACT_AMBIG_DETECTION);
            switch(alts.cardinality()){
                case 0:
                    throw this.noViableAlt(input, outerContext, s.configs, startIndex);
                case 1:
                    return alts.nextSetBit(0);
                default:
                    // report ambiguity after predicate evaluation to make sure the correct
                    // set of ambig alts is reported.
                    if (startIndex !== stopIndex) input.seek(stopIndex);
                    this.reportAmbiguity(dfa, s, startIndex, stopIndex, s.configs.isExactConflict, alts, s.configs);
                    return alts.nextSetBit(0);
            }
        }
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + s.prediction);
        return s.prediction;
    }
    /**
     * Determines if a particular DFA state should be treated as an accept state
     * for the current prediction mode. In addition to the `useContext`
     * parameter, the {@link #getPredictionMode()} method provides the
     * prediction mode controlling the prediction algorithm as a whole.
     *
     * The default implementation simply returns the value of
     * `DFAState.isAcceptState` except for conflict states when
     * `useContext` is `true` and {@link #getPredictionMode()} is
     * {@link PredictionMode#LL_EXACT_AMBIG_DETECTION}. In that case, only
     * conflict states where {@link ATNConfigSet#isExactConflict} is
     * `true` are considered accept states.
     *
     * @param state The DFA state to check.
     * @param useContext `true` if the prediction algorithm is currently
     * considering the full parser context; otherwise, `false` if the
     * algorithm is currently performing a local context prediction.
     *
     * @returns `true` if the specified `state` is an accept state;
     * otherwise, `false`.
     */ isAcceptState(state, useContext) {
        if (!state.isAcceptState) return false;
        if (state.configs.conflictingAlts == null) // unambiguous
        return true;
        // More picky when we need exact conflicts
        if (useContext && this.predictionMode === $iAyfo.PredictionMode.LL_EXACT_AMBIG_DETECTION) return state.configs.isExactConflict;
        return true;
    }
    /** Performs ATN simulation to compute a predicted alternative based
     *  upon the remaining input, but also updates the DFA cache to avoid
     *  having to traverse the ATN again for the same input sequence.
     *
     * There are some key conditions we're looking for after computing a new
     * set of ATN configs (proposed DFA state):
     *
     * * if the set is empty, there is no viable alternative for current symbol
     * * does the state uniquely predict an alternative?
     * * does the state have a conflict that would prevent us from
     *   putting it on the work list?
     * * if in non-greedy decision is there a config at a rule stop state?
     *
     * We also have some key operations to do:
     *
     * * add an edge from previous DFA state to potentially new DFA state, D,
     *   upon current symbol but only if adding to work list, which means in all
     *   cases except no viable alternative (and possibly non-greedy decisions?)
     * * collecting predicates and adding semantic context to DFA accept states
     * * adding rule context to context-sensitive DFA accept states
     * * consuming an input symbol
     * * reporting a conflict
     * * reporting an ambiguity
     * * reporting a context sensitivity
     * * reporting insufficient predicates
     *
     * We should isolate those operations, which are side-effecting, to the
     * main work loop. We can isolate lots of code into other functions, but
     * they should be side effect free. They can return package that
     * indicates whether we should report something, whether we need to add a
     * DFA edge, whether we need to augment accept state with semantic
     * context or rule invocation context. Actually, it seems like we always
     * add predicates if they exist, so that can simply be done in the main
     * loop for any accept state creation or modification request.
     *
     * cover these cases:
     *   dead end
     *   single alt
     *   single alt + preds
     *   conflict
     *   conflict + preds
     *
     * TODO: greedy + those
     */ execATN(dfa, input, startIndex, initialState) {
        if (ParserATNSimulator.debug) console.log("execATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input));
        let outerContext = initialState.outerContext;
        let useContext = initialState.useContext;
        let t = input.LA(1);
        let previous = initialState;
        let contextCache = new $fCMxU.PredictionContextCache();
        while(true){
            let nextState = this.computeReachSet(dfa, previous, t, contextCache);
            if (nextState == null) {
                this.setDFAEdge(previous.s0, input.LA(1), $d5Bh2.ATNSimulator.ERROR);
                return this.handleNoViableAlt(input, startIndex, previous);
            }
            let D = nextState.s0;
            // predicted alt => accept state
            $lzl5a(D.isAcceptState || D.prediction === $dQ2fw.ATN.INVALID_ALT_NUMBER);
            // conflicted => accept state
            $lzl5a(D.isAcceptState || D.configs.conflictInfo == null);
            if (this.isAcceptState(D, useContext)) {
                let conflictingAlts = D.configs.conflictingAlts;
                let predictedAlt = conflictingAlts == null ? D.prediction : $dQ2fw.ATN.INVALID_ALT_NUMBER;
                if (predictedAlt !== $dQ2fw.ATN.INVALID_ALT_NUMBER) {
                    if (this.optimize_ll1 && input.index === startIndex && !dfa.isPrecedenceDfa && nextState.outerContext === nextState.remainingOuterContext && dfa.decision >= 0 && !D.configs.hasSemanticContext) {
                        if (t >= 0 && t <= $a3caede9058c1b2e$var$MAX_SHORT_VALUE) {
                            let key = (dfa.decision << 16 >>> 0) + t;
                            this.atn.LL1Table.set(key, predictedAlt);
                        }
                    }
                    if (useContext && this.always_try_local_context) this.reportContextSensitivity(dfa, predictedAlt, nextState, startIndex, input.index);
                }
                predictedAlt = D.prediction;
                //				int k = input.index - startIndex + 1; // how much input we used
                //				System.out.println("used k="+k);
                let attemptFullContext = conflictingAlts != null && this.userWantsCtxSensitive;
                if (attemptFullContext) // Only exact conflicts are known to be ambiguous when local
                // prediction does not step out of the decision rule.
                attemptFullContext = !useContext && (D.configs.dipsIntoOuterContext || !D.configs.isExactConflict) && (!this.treat_sllk1_conflict_as_ambiguity || input.index !== startIndex);
                if (D.configs.hasSemanticContext) {
                    let predPredictions = D.predicates;
                    if (predPredictions != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        // use complete evaluation here if we'll want to retry with full context if still ambiguous
                        conflictingAlts = this.evalSemanticContext(predPredictions, outerContext, attemptFullContext || this.reportAmbiguities);
                        switch(conflictingAlts.cardinality()){
                            case 0:
                                throw this.noViableAlt(input, outerContext, D.configs, startIndex);
                            case 1:
                                return conflictingAlts.nextSetBit(0);
                            default:
                                break;
                        }
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                }
                if (!attemptFullContext) {
                    if (conflictingAlts != null) {
                        if (this.reportAmbiguities && conflictingAlts.cardinality() > 1) this.reportAmbiguity(dfa, D, startIndex, input.index, D.configs.isExactConflict, conflictingAlts, D.configs);
                        predictedAlt = conflictingAlts.nextSetBit(0);
                    }
                    return predictedAlt;
                } else {
                    $lzl5a(!useContext);
                    $lzl5a(this.isAcceptState(D, false));
                    if (ParserATNSimulator.debug) console.log("RETRY with outerContext=" + outerContext);
                    let fullContextState = this.computeStartState(dfa, outerContext, true);
                    if (this.reportAmbiguities) this.reportAttemptingFullContext(dfa, conflictingAlts, nextState, startIndex, input.index);
                    input.seek(startIndex);
                    return this.execATN(dfa, input, startIndex, fullContextState);
                }
            }
            previous = nextState;
            if (t !== $hPLPA.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
    }
    /**
     * This method is used to improve the localization of error messages by
     * choosing an alternative rather than throwing a
     * {@link NoViableAltException} in particular prediction scenarios where the
     * {@link #ERROR} state was reached during ATN simulation.
     *
     * The default implementation of this method uses the following
     * algorithm to identify an ATN configuration which successfully parsed the
     * decision entry rule. Choosing such an alternative ensures that the
     * {@link ParserRuleContext} returned by the calling rule will be complete
     * and valid, and the syntax error will be reported later at a more
     * localized location.
     *
     * * If no configuration in `configs` reached the end of the
     *   decision rule, return {@link ATN#INVALID_ALT_NUMBER}.
     * * If all configurations in `configs` which reached the end of the
     *   decision rule predict the same alternative, return that alternative.
     * * If the configurations in `configs` which reached the end of the
     *   decision rule predict multiple alternatives (call this *S*),
     *   choose an alternative in the following order.
     *
     *     1. Filter the configurations in `configs` to only those
     *        configurations which remain viable after evaluating semantic predicates.
     *        If the set of these filtered configurations which also reached the end of
     *        the decision rule is not empty, return the minimum alternative
     *        represented in this set.
     *     1. Otherwise, choose the minimum alternative in *S*.
     *
     * In some scenarios, the algorithm described above could predict an
     * alternative which will result in a {@link FailedPredicateException} in
     * parser. Specifically, this could occur if the *only* configuration
     * capable of successfully parsing to the end of the decision rule is
     * blocked by a semantic predicate. By choosing this alternative within
     * {@link #adaptivePredict} instead of throwing a
     * {@link NoViableAltException}, the resulting
     * {@link FailedPredicateException} in the parser will identify the specific
     * predicate which is preventing the parser from successfully parsing the
     * decision rule, which helps developers identify and correct logic errors
     * in semantic predicates.
     *
     * @param input The input {@link TokenStream}
     * @param startIndex The start index for the current prediction, which is
     * the input index where any semantic context in `configs` should be
     * evaluated
     * @param previous The ATN simulation state immediately before the
     * {@link #ERROR} state was reached
     *
     * @returns The value to return from {@link #adaptivePredict}, or
     * {@link ATN#INVALID_ALT_NUMBER} if a suitable alternative was not
     * identified and {@link #adaptivePredict} should report an error instead.
     */ handleNoViableAlt(input, startIndex, previous) {
        if (previous.s0 != null) {
            let alts = new $igr91.BitSet();
            let maxAlt = 0;
            for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $830He.RuleStopState) {
                alts.set(config.alt);
                maxAlt = Math.max(maxAlt, config.alt);
            }
            switch(alts.cardinality()){
                case 0:
                    break;
                case 1:
                    return alts.nextSetBit(0);
                default:
                    if (!previous.s0.configs.hasSemanticContext) // configs doesn't contain any predicates, so the predicate
                    // filtering code below would be pointless
                    return alts.nextSetBit(0);
                    /*
                     * Try to find a configuration set that not only dipped into the outer
                     * context, but also isn't eliminated by a predicate.
                     */ let filteredConfigs = new $3cXWi.ATNConfigSet();
                    for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $830He.RuleStopState) filteredConfigs.add(config);
                    /* The following code blocks are adapted from predicateDFAState with
                     * the following key changes.
                     *
                     *  1. The code operates on an ATNConfigSet rather than a DFAState.
                     *  2. Predicates are collected for all alternatives represented in
                     *     filteredConfigs, rather than restricting the evaluation to
                     *     conflicting and/or unique configurations.
                     */ let altToPred = this.getPredsForAmbigAlts(alts, filteredConfigs, maxAlt);
                    if (altToPred != null) {
                        let predicates = this.getPredicatePredictions(alts, altToPred);
                        if (predicates != null) {
                            let stopIndex = input.index;
                            try {
                                input.seek(startIndex);
                                let filteredAlts = this.evalSemanticContext(predicates, previous.outerContext, false);
                                if (!filteredAlts.isEmpty) return filteredAlts.nextSetBit(0);
                            } finally{
                                input.seek(stopIndex);
                            }
                        }
                    }
                    return alts.nextSetBit(0);
            }
        }
        throw this.noViableAlt(input, previous.outerContext, previous.s0.configs, startIndex);
    }
    computeReachSet(dfa, previous, t, contextCache) {
        let useContext = previous.useContext;
        let remainingGlobalContext = previous.remainingOuterContext;
        let s = previous.s0;
        if (useContext) while(s.isContextSymbol(t)){
            let next;
            if (remainingGlobalContext != null) {
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                next = s.getContextTarget(this.getReturnState(remainingGlobalContext));
            }
            if (next == null) break;
            $lzl5a(remainingGlobalContext != null);
            remainingGlobalContext = remainingGlobalContext.parent;
            s = next;
        }
        $lzl5a(!this.isAcceptState(s, useContext));
        if (this.isAcceptState(s, useContext)) return new $hTR8H.SimulatorState(previous.outerContext, s, useContext, remainingGlobalContext);
        let s0 = s;
        let target = this.getExistingTargetState(s0, t);
        if (target == null) {
            let result = this.computeTargetState(dfa, s0, remainingGlobalContext, t, useContext, contextCache);
            target = result[0];
            remainingGlobalContext = result[1];
        }
        if (target === $d5Bh2.ATNSimulator.ERROR) return undefined;
        $lzl5a(!useContext || !target.configs.dipsIntoOuterContext);
        return new $hTR8H.SimulatorState(previous.outerContext, target, useContext, remainingGlobalContext);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        return s.getTarget(t);
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param dfa
     * @param s The current DFA state
     * @param remainingGlobalContext
     * @param t The next input symbol
     * @param useContext
     * @param contextCache
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
        let closureConfigs = s.configs.toArray();
        let contextElements;
        let reach = new $3cXWi.ATNConfigSet();
        let stepIntoGlobal;
        do {
            let hasMoreContext = !useContext || remainingGlobalContext != null;
            if (!hasMoreContext) reach.isOutermostConfigSet = true;
            let reachIntermediate = new $3cXWi.ATNConfigSet();
            /* Configurations already in a rule stop state indicate reaching the end
             * of the decision rule (local context) or end of the start rule (full
             * context). Once reached, these configurations are never updated by a
             * closure operation, so they are handled separately for the performance
             * advantage of having a smaller intermediate set when calling closure.
             *
             * For full-context reach operations, separate handling is required to
             * ensure that the alternative matching the longest overall sequence is
             * chosen when multiple such configurations can match the input.
             */ let skippedStopStates;
            for (let c of closureConfigs){
                if (ParserATNSimulator.debug) console.log("testing " + this.getTokenName(t) + " at " + c.toString());
                if (c.state instanceof $830He.RuleStopState) {
                    $lzl5a(c.context.isEmpty);
                    if (useContext && !c.reachesIntoOuterContext || t === $hPLPA.IntStream.EOF) {
                        if (skippedStopStates == null) skippedStopStates = [];
                        skippedStopStates.push(c);
                    }
                    continue;
                }
                let n = c.state.numberOfOptimizedTransitions;
                for(let ti = 0; ti < n; ti++){
                    let trans = c.state.getOptimizedTransition(ti);
                    let target = this.getReachableTarget(c, trans, t);
                    if (target != null) reachIntermediate.add(c.transform(target, false), contextCache);
                }
            }
            /* This block optimizes the reach operation for intermediate sets which
             * trivially indicate a termination state for the overall
             * adaptivePredict operation.
             *
             * The conditions assume that intermediate
             * contains all configurations relevant to the reach set, but this
             * condition is not true when one or more configurations have been
             * withheld in skippedStopStates, or when the current symbol is EOF.
             */ if (this.optimize_unique_closure && skippedStopStates == null && t !== $iLVZN.Token.EOF && reachIntermediate.uniqueAlt !== $dQ2fw.ATN.INVALID_ALT_NUMBER) {
                reachIntermediate.isOutermostConfigSet = reach.isOutermostConfigSet;
                reach = reachIntermediate;
                break;
            }
            /* If the reach set could not be trivially determined, perform a closure
             * operation on the intermediate set to compute its initial value.
             */ let collectPredicates = false;
            let treatEofAsEpsilon = t === $iLVZN.Token.EOF;
            this.closure(reachIntermediate, reach, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon);
            stepIntoGlobal = reach.dipsIntoOuterContext;
            if (t === $hPLPA.IntStream.EOF) /* After consuming EOF no additional input is possible, so we are
                 * only interested in configurations which reached the end of the
                 * decision rule (local context) or end of the start rule (full
                 * context). Update reach to contain only these configurations. This
                 * handles both explicit EOF transitions in the grammar and implicit
                 * EOF transitions following the end of the decision or start rule.
                 *
                 * This is handled before the configurations in skippedStopStates,
                 * because any configurations potentially added from that list are
                 * already guaranteed to meet this condition whether or not it's
                 * required.
                 */ reach = this.removeAllConfigsNotInRuleStopState(reach, contextCache);
            /* If skippedStopStates is not undefined, then it contains at least one
             * configuration. For full-context reach operations, these
             * configurations reached the end of the start rule, in which case we
             * only add them back to reach if no configuration during the current
             * closure operation reached such a state. This ensures adaptivePredict
             * chooses an alternative matching the longest overall sequence when
             * multiple alternatives are viable.
             */ if (skippedStopStates != null && (!useContext || !$iAyfo.PredictionMode.hasConfigInRuleStopState(reach))) {
                $lzl5a(skippedStopStates.length > 0);
                for (let c of skippedStopStates)reach.add(c, contextCache);
            }
            if (useContext && stepIntoGlobal) {
                reach.clear();
                // We know remainingGlobalContext is not undefined at this point (why?)
                remainingGlobalContext;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                let nextContextElement = this.getReturnState(remainingGlobalContext);
                if (contextElements == null) contextElements = new $jL0Xb.IntegerList();
                if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                else remainingGlobalContext = remainingGlobalContext.parent;
                contextElements.add(nextContextElement);
                if (nextContextElement !== $gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY) for(let i = 0; i < closureConfigs.length; i++)closureConfigs[i] = closureConfigs[i].appendContext(nextContextElement, contextCache);
            }
        }while (useContext && stepIntoGlobal);
        if (reach.isEmpty) {
            this.setDFAEdge(s, t, $d5Bh2.ATNSimulator.ERROR);
            return [
                $d5Bh2.ATNSimulator.ERROR,
                remainingGlobalContext
            ];
        }
        let result = this.addDFAEdge(dfa, s, t, contextElements, reach, contextCache);
        return [
            result,
            remainingGlobalContext
        ];
    }
    /**
     * Return a configuration set containing only the configurations from
     * `configs` which are in a {@link RuleStopState}. If all
     * configurations in `configs` are already in a rule stop state, this
     * method simply returns `configs`.
     *
     * @param configs the configuration set to update
     * @param contextCache the {@link PredictionContext} cache
     *
     * @returns `configs` if all configurations in `configs` are in a
     * rule stop state, otherwise return a new configuration set containing only
     * the configurations from `configs` which are in a rule stop state
     */ removeAllConfigsNotInRuleStopState(configs, contextCache) {
        if ($iAyfo.PredictionMode.allConfigsInRuleStopStates(configs)) return configs;
        let result = new $3cXWi.ATNConfigSet();
        for (let config of configs){
            if (!(config.state instanceof $830He.RuleStopState)) continue;
            result.add(config, contextCache);
        }
        return result;
    }
    computeStartState(dfa, globalContext, useContext) {
        let s0 = dfa.isPrecedenceDfa ? dfa.getPrecedenceStartState(this._parser.precedence, useContext) : useContext ? dfa.s0full : dfa.s0;
        if (s0 != null) {
            if (!useContext) return new $hTR8H.SimulatorState(globalContext, s0, useContext, globalContext);
            s0.setContextSensitive(this.atn);
        }
        let decision = dfa.decision;
        // @NotNull
        let p = dfa.atnStartState;
        let previousContext = 0;
        let remainingGlobalContext = globalContext;
        let initialContext = useContext ? $gT9VD.PredictionContext.EMPTY_FULL : $gT9VD.PredictionContext.EMPTY_LOCAL; // always at least the implicit call to start rule
        let contextCache = new $fCMxU.PredictionContextCache();
        if (useContext) {
            if (!this.enable_global_context_dfa) {
                while(remainingGlobalContext != null)if (remainingGlobalContext.isEmpty) {
                    previousContext = $gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
            }
            while(s0 != null && s0.isContextSensitive && remainingGlobalContext != null){
                let next;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                if (remainingGlobalContext.isEmpty) {
                    next = s0.getContextTarget($gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY);
                    previousContext = $gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    next = s0.getContextTarget(previousContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
                if (next == null) break;
                s0 = next;
            }
        }
        if (s0 != null && !s0.isContextSensitive) return new $hTR8H.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
        let configs = new $3cXWi.ATNConfigSet();
        while(true){
            let reachIntermediate = new $3cXWi.ATNConfigSet();
            let n = p.numberOfTransitions;
            for(let ti = 0; ti < n; ti++){
                // for each transition
                let target = p.transition(ti).target;
                reachIntermediate.add($lz4Ok.ATNConfig.create(target, ti + 1, initialContext));
            }
            let hasMoreContext = remainingGlobalContext != null;
            if (!hasMoreContext) configs.isOutermostConfigSet = true;
            let collectPredicates = true;
            this.closure(reachIntermediate, configs, collectPredicates, hasMoreContext, contextCache, false);
            let stepIntoGlobal = configs.dipsIntoOuterContext;
            let next;
            if (useContext && !this.enable_global_context_dfa) {
                s0 = this.addDFAState(dfa, configs, contextCache);
                break;
            } else if (s0 == null) {
                if (!dfa.isPrecedenceDfa) {
                    next = this.addDFAState(dfa, configs, contextCache);
                    if (useContext) {
                        if (!dfa.s0full) dfa.s0full = next;
                        else next = dfa.s0full;
                    } else if (!dfa.s0) dfa.s0 = next;
                    else next = dfa.s0;
                } else {
                    /* If this is a precedence DFA, we use applyPrecedenceFilter
                     * to convert the computed start state to a precedence start
                     * state. We then use DFA.setPrecedenceStartState to set the
                     * appropriate start state for the precedence level rather
                     * than simply setting DFA.s0.
                     */ configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                    next = this.addDFAState(dfa, configs, contextCache);
                    dfa.setPrecedenceStartState(this._parser.precedence, useContext, next);
                }
            } else {
                if (dfa.isPrecedenceDfa) configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                next = this.addDFAState(dfa, configs, contextCache);
                s0.setContextTarget(previousContext, next);
            }
            s0 = next;
            if (!useContext || !stepIntoGlobal) break;
            // TODO: make sure it distinguishes empty stack states
            next.setContextSensitive(this.atn);
            // We know remainingGlobalContext is not undefined at this point (why?)
            remainingGlobalContext;
            configs.clear();
            remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
            let nextContextElement = this.getReturnState(remainingGlobalContext);
            if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
            else remainingGlobalContext = remainingGlobalContext.parent;
            if (nextContextElement !== $gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY) initialContext = initialContext.appendSingleContext(nextContextElement, contextCache);
            previousContext = nextContextElement;
        }
        return new $hTR8H.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
    }
    /**
     * This method transforms the start state computed by
     * {@link #computeStartState} to the special start state used by a
     * precedence DFA for a particular precedence value. The transformation
     * process applies the following changes to the start state's configuration
     * set.
     *
     * 1. Evaluate the precedence predicates for each configuration using
     *    {@link SemanticContext#evalPrecedence}.
     * 1. When {@link ATNConfig#isPrecedenceFilterSuppressed} is `false`,
     *    remove all configurations which predict an alternative greater than 1,
     *    for which another configuration that predicts alternative 1 is in the
     *    same ATN state with the same prediction context. This transformation is
     *    valid for the following reasons:
     *
     *     * The closure block cannot contain any epsilon transitions which bypass
     *       the body of the closure, so all states reachable via alternative 1 are
     *       part of the precedence alternatives of the transformed left-recursive
     *       rule.
     *     * The "primary" portion of a left recursive rule cannot contain an
     *       epsilon transition, so the only way an alternative other than 1 can exist
     *       in a state that is also reachable via alternative 1 is by nesting calls
     *       to the left-recursive rule, with the outer calls not being at the
     *       preferred precedence level. The
     *       {@link ATNConfig#isPrecedenceFilterSuppressed} property marks ATN
     *       configurations which do not meet this condition, and therefore are not
     *       eligible for elimination during the filtering process.
     *
     * The prediction context must be considered by this filter to address
     * situations like the following.
     *
     * ```antlr
     * grammar TA;
     * prog: statement* EOF;
     * statement: letterA | statement letterA 'b' ;
     * letterA: 'a';
     * ```
     *
     * If the above grammar, the ATN state immediately before the token
     * reference `'a'` in `letterA` is reachable from the left edge
     * of both the primary and closure blocks of the left-recursive rule
     * `statement`. The prediction context associated with each of these
     * configurations distinguishes between them, and prevents the alternative
     * which stepped out to `prog` (and then back in to `statement`
     * from being eliminated by the filter.
     *
     * @param configs The configuration set computed by
     * {@link #computeStartState} as the start state for the DFA.
     * @returns The transformed configuration set representing the start state
     * for a precedence DFA at a particular precedence level (determined by
     * calling {@link Parser#getPrecedence}).
     */ applyPrecedenceFilter(configs, globalContext, contextCache) {
        let statesFromAlt1 = new Map();
        let configSet = new $3cXWi.ATNConfigSet();
        for (let config of configs){
            // handle alt 1 first
            if (config.alt !== 1) continue;
            let updatedContext = config.semanticContext.evalPrecedence(this._parser, globalContext);
            if (updatedContext == null) continue;
            statesFromAlt1.set(config.state.stateNumber, config.context);
            if (updatedContext !== config.semanticContext) configSet.add(config.transform(config.state, false, updatedContext), contextCache);
            else configSet.add(config, contextCache);
        }
        for (let config of configs){
            if (config.alt === 1) continue;
            if (!config.isPrecedenceFilterSuppressed) {
                /* In the future, this elimination step could be updated to also
                 * filter the prediction context for alternatives predicting alt>1
                 * (basically a graph subtraction algorithm).
                 */ let context = statesFromAlt1.get(config.state.stateNumber);
                if (context != null && context.equals(config.context)) continue;
            }
            configSet.add(config, contextCache);
        }
        return configSet;
    }
    getReachableTarget(source, trans, ttype) {
        if (trans.matches(ttype, 0, this.atn.maxTokenType)) return trans.target;
        return undefined;
    }
    /** collect and set D's semantic context */ predicateDFAState(D, configs, nalts) {
        let conflictingAlts = this.getConflictingAltsFromConfigSet(configs);
        if (!conflictingAlts) throw new Error("This unhandled scenario is intended to be unreachable, but I'm currently not sure of why we know that's the case.");
        if (ParserATNSimulator.debug) console.log("predicateDFAState " + D);
        let altToPred = this.getPredsForAmbigAlts(conflictingAlts, configs, nalts);
        // altToPred[uniqueAlt] is now our validating predicate (if any)
        let predPredictions;
        if (altToPred != null) {
            // we have a validating predicate; test it
            // Update DFA so reach becomes accept state with predicate
            predPredictions = this.getPredicatePredictions(conflictingAlts, altToPred);
            D.predicates = predPredictions;
        }
        return predPredictions;
    }
    getPredsForAmbigAlts(ambigAlts, configs, nalts) {
        // REACH=[1|1|[]|0:0, 1|2|[]|0:1]
        /* altToPred starts as an array of all undefined contexts. The entry at index i
         * corresponds to alternative i. altToPred[i] may have one of three values:
         *   1. undefined: no ATNConfig c is found such that c.alt===i
         *   2. SemanticContext.NONE: At least one ATNConfig c exists such that
         *      c.alt===i and c.semanticContext===SemanticContext.NONE. In other words,
         *      alt i has at least one unpredicated config.
         *   3. Non-NONE Semantic Context: There exists at least one, and for all
         *      ATNConfig c such that c.alt===i, c.semanticContext!==SemanticContext.NONE.
         *
         * From this, it is clear that NONE||anything==NONE.
         */ let altToPred = new Array(nalts + 1);
        let n = altToPred.length;
        for (let c of configs)if (ambigAlts.get(c.alt)) altToPred[c.alt] = $gt6ZZ.SemanticContext.or(altToPred[c.alt], c.semanticContext);
        let nPredAlts = 0;
        for(let i = 0; i < n; i++){
            if (altToPred[i] == null) altToPred[i] = $gt6ZZ.SemanticContext.NONE;
            else if (altToPred[i] !== $gt6ZZ.SemanticContext.NONE) nPredAlts++;
        }
        // At this point we know `altToPred` doesn't contain any undefined entries
        let result = altToPred;
        // nonambig alts are undefined in result
        if (nPredAlts === 0) result = undefined;
        if (ParserATNSimulator.debug) console.log("getPredsForAmbigAlts result " + (result ? $5Zd5d.Arrays.toString(result) : "undefined"));
        return result;
    }
    getPredicatePredictions(ambigAlts, altToPred) {
        let pairs = [];
        let containsPredicate = false;
        for(let i = 1; i < altToPred.length; i++){
            let pred = altToPred[i];
            // unpredicated is indicated by SemanticContext.NONE
            $lzl5a(pred != null);
            // find first unpredicated but ambig alternative, if any.
            // Only ambiguous alternatives will have SemanticContext.NONE.
            // Any unambig alts or ambig naked alts after first ambig naked are ignored
            // (undefined, i) means alt i is the default prediction
            // if no (undefined, i), then no default prediction.
            if (ambigAlts != null && ambigAlts.get(i) && pred === $gt6ZZ.SemanticContext.NONE) pairs.push(new $g3I27.DFAState.PredPrediction(pred, i));
            else if (pred !== $gt6ZZ.SemanticContext.NONE) {
                containsPredicate = true;
                pairs.push(new $g3I27.DFAState.PredPrediction(pred, i));
            }
        }
        if (!containsPredicate) return undefined;
        //		System.out.println(Arrays.toString(altToPred)+"->"+pairs);
        return pairs;
    }
    /** Look through a list of predicate/alt pairs, returning alts for the
     *  pairs that win. An `undefined` predicate indicates an alt containing an
     *  unpredicated config which behaves as "always true."
     */ evalSemanticContext(predPredictions, outerContext, complete) {
        let predictions = new $igr91.BitSet();
        for (let pair of predPredictions){
            if (pair.pred === $gt6ZZ.SemanticContext.NONE) {
                predictions.set(pair.alt);
                if (!complete) break;
                continue;
            }
            let evaluatedResult = this.evalSemanticContextImpl(pair.pred, outerContext, pair.alt);
            if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("eval pred " + pair + "=" + evaluatedResult);
            if (evaluatedResult) {
                if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("PREDICT " + pair.alt);
                predictions.set(pair.alt);
                if (!complete) break;
            }
        }
        return predictions;
    }
    /**
     * Evaluate a semantic context within a specific parser context.
     *
     * This method might not be called for every semantic context evaluated
     * during the prediction process. In particular, we currently do not
     * evaluate the following but it may change in the future:
     *
     * * Precedence predicates (represented by
     *   {@link SemanticContext.PrecedencePredicate}) are not currently evaluated
     *   through this method.
     * * Operator predicates (represented by {@link SemanticContext.AND} and
     *   {@link SemanticContext.OR}) are evaluated as a single semantic
     *   context, rather than evaluating the operands individually.
     *   Implementations which require evaluation results from individual
     *   predicates should override this method to explicitly handle evaluation of
     *   the operands within operator predicates.
     *
     * @param pred The semantic context to evaluate
     * @param parserCallStack The parser context in which to evaluate the
     * semantic context
     * @param alt The alternative which is guarded by `pred`
     *
     * @since 4.3
     */ evalSemanticContextImpl(pred, parserCallStack, alt) {
        return pred.eval(this._parser, parserCallStack);
    }
    /* TODO: If we are doing predicates, there is no point in pursuing
         closure operations if we reach a DFA state that uniquely predicts
         alternative. We will not be caching that DFA state and it is a
         waste to pursue the closure. Might have to advance when we do
         ambig detection thought :(
          */ closure(sourceConfigs, configs, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon) {
        if (contextCache == null) contextCache = $fCMxU.PredictionContextCache.UNCACHED;
        let currentConfigs = sourceConfigs;
        let closureBusy = new $fqc4S.Array2DHashSet($cWz6y.ObjectEqualityComparator.INSTANCE);
        while(currentConfigs.size > 0){
            let intermediate = new $3cXWi.ATNConfigSet();
            for (let config of currentConfigs)this.closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContext, contextCache, 0, treatEofAsEpsilon);
            currentConfigs = intermediate;
        }
    }
    closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth, treatEofAsEpsilon) {
        if (ParserATNSimulator.debug) console.log("closure(" + config.toString(this._parser, true) + ")");
        if (config.state instanceof $830He.RuleStopState) {
            // We hit rule end. If we have context info, use it
            if (!config.context.isEmpty) {
                let hasEmpty = config.context.hasEmpty;
                let nonEmptySize = config.context.size - (hasEmpty ? 1 : 0);
                for(let i = 0; i < nonEmptySize; i++){
                    let newContext = config.context.getParent(i); // "pop" return state
                    let returnState = this.atn.states[config.context.getReturnState(i)];
                    let c = $lz4Ok.ATNConfig.create(returnState, config.alt, newContext, config.semanticContext);
                    // While we have context to pop back from, we may have
                    // gotten that context AFTER having fallen off a rule.
                    // Make sure we track that we are now out of context.
                    c.outerContextDepth = config.outerContextDepth;
                    c.isPrecedenceFilterSuppressed = config.isPrecedenceFilterSuppressed;
                    $lzl5a(depth > $a3caede9058c1b2e$var$MIN_INTEGER_VALUE);
                    this.closureImpl(c, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth - 1, treatEofAsEpsilon);
                }
                if (!hasEmpty || !hasMoreContexts) return;
                config = config.transform(config.state, false, $gT9VD.PredictionContext.EMPTY_LOCAL);
            } else if (!hasMoreContexts) {
                configs.add(config, contextCache);
                return;
            } else {
                // else if we have no context info, just chase follow links (if greedy)
                if (ParserATNSimulator.debug) console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
                if (config.context === $gT9VD.PredictionContext.EMPTY_FULL) // no need to keep full context overhead when we step out
                config = config.transform(config.state, false, $gT9VD.PredictionContext.EMPTY_LOCAL);
                else if (!config.reachesIntoOuterContext && $gT9VD.PredictionContext.isEmptyLocal(config.context)) // add stop state when leaving decision rule for the first time
                configs.add(config, contextCache);
            }
        }
        let p = config.state;
        // optimization
        if (!p.onlyHasEpsilonTransitions) {
            configs.add(config, contextCache);
            // make sure to not return here, because EOF transitions can act as
            // both epsilon transitions and non-epsilon transitions.
            if (ParserATNSimulator.debug) console.log("added config " + configs);
        }
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            // This block implements first-edge elimination of ambiguous LR
            // alternatives as part of dynamic disambiguation during prediction.
            // See antlr/antlr4#1398.
            if (i === 0 && p.stateType === $4txXj.ATNStateType.STAR_LOOP_ENTRY && p.precedenceRuleDecision && !config.context.hasEmpty) {
                let precedenceDecision = p;
                // When suppress is true, it means the outgoing edge i==0 is
                // ambiguous with the outgoing edge i==1, and thus the closure
                // operation can dynamically disambiguate by suppressing this
                // edge during the closure operation.
                let suppress = true;
                for(let j = 0; j < config.context.size; j++)if (!precedenceDecision.precedenceLoopbackStates.get(config.context.getReturnState(j))) {
                    suppress = false;
                    break;
                }
                if (suppress) continue;
            }
            let t = p.getOptimizedTransition(i);
            let continueCollecting = !(t instanceof $9PZbb.ActionTransition) && collectPredicates;
            let c = this.getEpsilonTarget(config, t, continueCollecting, depth === 0, contextCache, treatEofAsEpsilon);
            if (c != null) {
                if (t instanceof $9ITLj.RuleTransition) {
                    if (intermediate != null && !collectPredicates) {
                        intermediate.add(c, contextCache);
                        continue;
                    }
                }
                let newDepth = depth;
                if (config.state instanceof $830He.RuleStopState) {
                    // target fell off end of rule; mark resulting c as having dipped into outer context
                    // We can't get here if incoming config was rule stop and we had context
                    // track how far we dip into outer context.  Might
                    // come in handy and we avoid evaluating context dependent
                    // preds if this is > 0.
                    if (this.dfa != null && this.dfa.isPrecedenceDfa) {
                        let outermostPrecedenceReturn = t.outermostPrecedenceReturn;
                        if (outermostPrecedenceReturn === this.dfa.atnStartState.ruleIndex) c.isPrecedenceFilterSuppressed = true;
                    }
                    c.outerContextDepth = c.outerContextDepth + 1;
                    if (!closureBusy.add(c)) continue;
                    $lzl5a(newDepth > $a3caede9058c1b2e$var$MIN_INTEGER_VALUE);
                    newDepth--;
                    if (ParserATNSimulator.debug) console.log("dips into outer ctx: " + c);
                } else if (t instanceof $9ITLj.RuleTransition) {
                    if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$gT9VD.PredictionContext.isEmptyLocal(config.context))) {
                        $lzl5a(c.context === config.context);
                        if (newDepth === 0) {
                            // the pop/push of a tail call would keep the depth
                            // constant, except we latch if it goes negative
                            newDepth--;
                            if (!this.tail_call_preserves_sll && $gT9VD.PredictionContext.isEmptyLocal(config.context)) // make sure the SLL config "dips into the outer context" or prediction may not fall back to LL on conflict
                            c.outerContextDepth = c.outerContextDepth + 1;
                        }
                    } else // latch when newDepth goes negative - once we step out of the entry context we can't return
                    if (newDepth >= 0) newDepth++;
                } else {
                    if (!t.isEpsilon && !closureBusy.add(c)) continue;
                }
                this.closureImpl(c, configs, intermediate, closureBusy, continueCollecting, hasMoreContexts, contextCache, newDepth, treatEofAsEpsilon);
            }
        }
    }
    getRuleName(index) {
        if (this._parser != null && index >= 0) return this._parser.ruleNames[index];
        return "<rule " + index + ">";
    }
    getEpsilonTarget(config, t, collectPredicates, inContext, contextCache, treatEofAsEpsilon) {
        switch(t.serializationType){
            case 3 /* RULE */ :
                return this.ruleTransition(config, t, contextCache);
            case 10 /* PRECEDENCE */ :
                return this.precedenceTransition(config, t, collectPredicates, inContext);
            case 4 /* PREDICATE */ :
                return this.predTransition(config, t, collectPredicates, inContext);
            case 6 /* ACTION */ :
                return this.actionTransition(config, t);
            case 1 /* EPSILON */ :
                return config.transform(t.target, false);
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                // EOF transitions act like epsilon transitions after the first EOF
                // transition is traversed
                if (treatEofAsEpsilon) {
                    if (t.matches($iLVZN.Token.EOF, 0, 1)) return config.transform(t.target, false);
                }
                return undefined;
            default:
                return undefined;
        }
    }
    actionTransition(config, t) {
        if (ParserATNSimulator.debug) console.log("ACTION edge " + t.ruleIndex + ":" + t.actionIndex);
        return config.transform(t.target, false);
    }
    precedenceTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.precedence + ">=_p" + ", ctx dependent=true");
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && inContext) {
            let newSemCtx = $gt6ZZ.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    predTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.ruleIndex + ":" + pt.predIndex + ", ctx dependent=" + pt.isCtxDependent);
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && (!pt.isCtxDependent || pt.isCtxDependent && inContext)) {
            let newSemCtx = $gt6ZZ.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    ruleTransition(config, t, contextCache) {
        if (ParserATNSimulator.debug) console.log("CALL rule " + this.getRuleName(t.target.ruleIndex) + ", ctx=" + config.context);
        let returnState = t.followState;
        let newContext;
        if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$gT9VD.PredictionContext.isEmptyLocal(config.context))) newContext = config.context;
        else if (contextCache != null) newContext = contextCache.getChild(config.context, returnState.stateNumber);
        else newContext = config.context.getChild(returnState.stateNumber);
        return config.transform(t.target, false, newContext);
    }
    isConflicted(configset, contextCache) {
        if (configset.uniqueAlt !== $dQ2fw.ATN.INVALID_ALT_NUMBER || configset.size <= 1) return undefined;
        let configs = configset.toArray();
        configs.sort(ParserATNSimulator.STATE_ALT_SORT_COMPARATOR);
        let exact = !configset.dipsIntoOuterContext;
        let alts = new $igr91.BitSet();
        let minAlt = configs[0].alt;
        alts.set(minAlt);
        /* Quick checks come first (single pass, no context joining):
         *  1. Make sure first config in the sorted list predicts the minimum
         *     represented alternative.
         *  2. Make sure every represented state has at least one configuration
         *     which predicts the minimum represented alternative.
         *  3. (exact only) make sure every represented state has at least one
         *     configuration which predicts each represented alternative.
         */ // quick check 1 & 2 => if we assume #1 holds and check #2 against the
        // minAlt from the first state, #2 will fail if the assumption was
        // incorrect
        let currentState = configs[0].state.nonStopStateNumber;
        for (let config of configs){
            let stateNumber = config.state.nonStopStateNumber;
            if (stateNumber !== currentState) {
                if (config.alt !== minAlt) return undefined;
                currentState = stateNumber;
            }
        }
        let representedAlts;
        if (exact) {
            currentState = configs[0].state.nonStopStateNumber;
            // get the represented alternatives of the first state
            representedAlts = new $igr91.BitSet();
            let maxAlt = minAlt;
            for (let config of configs){
                if (config.state.nonStopStateNumber !== currentState) break;
                let alt = config.alt;
                representedAlts.set(alt);
                maxAlt = alt;
            }
            // quick check #3:
            currentState = configs[0].state.nonStopStateNumber;
            let currentAlt = minAlt;
            for (let config of configs){
                let stateNumber = config.state.nonStopStateNumber;
                let alt = config.alt;
                if (stateNumber !== currentState) {
                    if (currentAlt !== maxAlt) {
                        exact = false;
                        break;
                    }
                    currentState = stateNumber;
                    currentAlt = minAlt;
                } else if (alt !== currentAlt) {
                    if (alt !== representedAlts.nextSetBit(currentAlt + 1)) {
                        exact = false;
                        break;
                    }
                    currentAlt = alt;
                }
            }
        }
        currentState = configs[0].state.nonStopStateNumber;
        let firstIndexCurrentState = 0;
        let lastIndexCurrentStateMinAlt = 0;
        let joinedCheckContext = configs[0].context;
        for(let i = 1; i < configs.length; i++){
            let config = configs[i];
            if (config.alt !== minAlt) break;
            if (config.state.nonStopStateNumber !== currentState) break;
            lastIndexCurrentStateMinAlt = i;
            joinedCheckContext = contextCache.join(joinedCheckContext, configs[i].context);
        }
        for(let i = lastIndexCurrentStateMinAlt + 1; i < configs.length; i++){
            let config = configs[i];
            let state = config.state;
            alts.set(config.alt);
            if (state.nonStopStateNumber !== currentState) {
                currentState = state.nonStopStateNumber;
                firstIndexCurrentState = i;
                lastIndexCurrentStateMinAlt = i;
                joinedCheckContext = config.context;
                for(let j = firstIndexCurrentState + 1; j < configs.length; j++){
                    let config2 = configs[j];
                    if (config2.alt !== minAlt) break;
                    if (config2.state.nonStopStateNumber !== currentState) break;
                    lastIndexCurrentStateMinAlt = j;
                    joinedCheckContext = contextCache.join(joinedCheckContext, config2.context);
                }
                i = lastIndexCurrentStateMinAlt;
                continue;
            }
            let joinedCheckContext2 = config.context;
            let currentAlt = config.alt;
            let lastIndexCurrentStateCurrentAlt = i;
            for(let j = lastIndexCurrentStateCurrentAlt + 1; j < configs.length; j++){
                let config2 = configs[j];
                if (config2.alt !== currentAlt) break;
                if (config2.state.nonStopStateNumber !== currentState) break;
                lastIndexCurrentStateCurrentAlt = j;
                joinedCheckContext2 = contextCache.join(joinedCheckContext2, config2.context);
            }
            i = lastIndexCurrentStateCurrentAlt;
            let check = contextCache.join(joinedCheckContext, joinedCheckContext2);
            if (!joinedCheckContext.equals(check)) return undefined;
            // update exact if necessary
            exact = exact && joinedCheckContext.equals(joinedCheckContext2);
        }
        return new $1wHaf.ConflictInfo(alts, exact);
    }
    getConflictingAltsFromConfigSet(configs) {
        let conflictingAlts = configs.conflictingAlts;
        if (conflictingAlts == null && configs.uniqueAlt !== $dQ2fw.ATN.INVALID_ALT_NUMBER) {
            conflictingAlts = new $igr91.BitSet();
            conflictingAlts.set(configs.uniqueAlt);
        }
        return conflictingAlts;
    }
    getTokenName(t) {
        if (t === $iLVZN.Token.EOF) return "EOF";
        let vocabulary = this._parser != null ? this._parser.vocabulary : $7DbrH.VocabularyImpl.EMPTY_VOCABULARY;
        let displayName = vocabulary.getDisplayName(t);
        if (displayName === String(t)) return displayName;
        return displayName + "<" + t + ">";
    }
    getLookaheadName(input) {
        return this.getTokenName(input.LA(1));
    }
    dumpDeadEndConfigs(nvae) {
        console.log("dead end configs: ");
        let deadEndConfigs = nvae.deadEndConfigs;
        if (!deadEndConfigs) return;
        for (let c of deadEndConfigs){
            let trans = "no edges";
            if (c.state.numberOfOptimizedTransitions > 0) {
                let t = c.state.getOptimizedTransition(0);
                if (t instanceof $bj9S6.AtomTransition) trans = "Atom " + this.getTokenName(t._label);
                else if (t instanceof $cxnFA.SetTransition) {
                    let not = t instanceof $gYz0f.NotSetTransition;
                    trans = (not ? "~" : "") + "Set " + t.set.toString();
                }
            }
            console.log(c.toString(this._parser, true) + ":" + trans);
        }
    }
    noViableAlt(input, outerContext, configs, startIndex) {
        return new $1O6nA.NoViableAltException(this._parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
    }
    getUniqueAlt(configs) {
        let alt = $dQ2fw.ATN.INVALID_ALT_NUMBER;
        for (let c of configs){
            if (alt === $dQ2fw.ATN.INVALID_ALT_NUMBER) alt = c.alt; // found first alt
            else if (c.alt !== alt) return $dQ2fw.ATN.INVALID_ALT_NUMBER;
        }
        return alt;
    }
    configWithAltAtStopState(configs, alt) {
        for (let c of configs)if (c.alt === alt) {
            if (c.state instanceof $830He.RuleStopState) return true;
        }
        return false;
    }
    addDFAEdge(dfa, fromState, t, contextTransitions, toConfigs, contextCache) {
        $lzl5a(contextTransitions == null || contextTransitions.isEmpty || dfa.isContextSensitive);
        let from = fromState;
        let to = this.addDFAState(dfa, toConfigs, contextCache);
        if (contextTransitions != null) for (let context of contextTransitions.toArray()){
            if (context === $gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY) {
                if (from.configs.isOutermostConfigSet) continue;
            }
            from.setContextSensitive(this.atn);
            from.setContextSymbol(t);
            let next = from.getContextTarget(context);
            if (next != null) {
                from = next;
                continue;
            }
            next = this.addDFAContextState(dfa, from.configs, context, contextCache);
            $lzl5a(context !== $gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY || next.configs.isOutermostConfigSet);
            from.setContextTarget(context, next);
            from = next;
        }
        if (ParserATNSimulator.debug) console.log("EDGE " + from + " -> " + to + " upon " + this.getTokenName(t));
        this.setDFAEdge(from, t, to);
        if (ParserATNSimulator.debug) console.log("DFA=\n" + dfa.toString(this._parser != null ? this._parser.vocabulary : $7DbrH.VocabularyImpl.EMPTY_VOCABULARY, this._parser != null ? this._parser.ruleNames : undefined));
        return to;
    }
    setDFAEdge(p, t, q) {
        if (p != null) p.setTarget(t, q);
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAContextState(dfa, configs, returnContext, contextCache) {
        if (returnContext !== $gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY) {
            let contextConfigs = new $3cXWi.ATNConfigSet();
            for (let config of configs)contextConfigs.add(config.appendContext(returnContext, contextCache));
            return this.addDFAState(dfa, contextConfigs, contextCache);
        } else {
            $lzl5a(!configs.isOutermostConfigSet, "Shouldn't be adding a duplicate edge.");
            configs = configs.clone(true);
            configs.isOutermostConfigSet = true;
            return this.addDFAState(dfa, configs, contextCache);
        }
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAState(dfa, configs, contextCache) {
        let enableDfa = this.enable_global_context_dfa || !configs.isOutermostConfigSet;
        if (enableDfa) {
            if (!configs.isReadOnly) configs.optimizeConfigs(this);
            let proposed = this.createDFAState(dfa, configs);
            let existing = dfa.states.get(proposed);
            if (existing != null) return existing;
        }
        if (!configs.isReadOnly) {
            if (configs.conflictInfo == null) configs.conflictInfo = this.isConflicted(configs, contextCache);
        }
        let newState = this.createDFAState(dfa, configs.clone(true));
        // getDecisionState won't return undefined when we request a known valid decision
        let decisionState = this.atn.getDecisionState(dfa.decision);
        let predictedAlt = this.getUniqueAlt(configs);
        if (predictedAlt !== $dQ2fw.ATN.INVALID_ALT_NUMBER) newState.acceptStateInfo = new $kytPQ.AcceptStateInfo(predictedAlt);
        else if (configs.conflictingAlts != null) {
            let conflictingAlts = configs.conflictingAlts;
            if (conflictingAlts) newState.acceptStateInfo = new $kytPQ.AcceptStateInfo(conflictingAlts.nextSetBit(0));
        }
        if (newState.isAcceptState && configs.hasSemanticContext) this.predicateDFAState(newState, configs, decisionState.numberOfTransitions);
        if (!enableDfa) return newState;
        let added = dfa.addState(newState);
        if (ParserATNSimulator.debug && added === newState) console.log("adding new DFA state: " + newState);
        return added;
    }
    createDFAState(dfa, configs) {
        return new $g3I27.DFAState(configs);
    }
    reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $312SH.Interval.of(startIndex, stopIndex);
            console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + conflictState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(this._parser, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        }
    }
    reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $312SH.Interval.of(startIndex, stopIndex);
            console.log("reportContextSensitivity decision=" + dfa.decision + ":" + acceptState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(this._parser, dfa, startIndex, stopIndex, prediction, acceptState);
        }
    }
    /** If context sensitive parsing, we know it's ambiguity not conflict */ reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $312SH.Interval.of(startIndex, stopIndex);
            console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAmbiguity) listener.reportAmbiguity(this._parser, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        }
    }
    getReturnState(context) {
        if (context.isEmpty) return $gT9VD.PredictionContext.EMPTY_FULL_STATE_KEY;
        let state = this.atn.states[context.invokingState];
        let transition = state.transition(0);
        return transition.followState.stateNumber;
    }
    skipTailCalls(context) {
        if (!this.optimize_tail_calls) return context;
        while(!context.isEmpty){
            let state = this.atn.states[context.invokingState];
            $lzl5a(state.numberOfTransitions === 1 && state.transition(0).serializationType === 3 /* RULE */ );
            let transition = state.transition(0);
            if (!transition.tailCall) break;
            // This method requires that the root ancestor of the ParserRuleContext be empty. If we make it to this
            // line, we know the current node is not empty, which means it does have a parent.
            context = context.parent;
        }
        return context;
    }
    /**
     * @since 4.3
     */ get parser() {
        return this._parser;
    }
};
$a3caede9058c1b2e$var$ParserATNSimulator.debug = false;
$a3caede9058c1b2e$var$ParserATNSimulator.dfa_debug = false;
$a3caede9058c1b2e$var$ParserATNSimulator.retry_debug = false;
$a3caede9058c1b2e$var$ParserATNSimulator.STATE_ALT_SORT_COMPARATOR = (o1, o2)=>{
    let diff = o1.state.nonStopStateNumber - o2.state.nonStopStateNumber;
    if (diff !== 0) return diff;
    diff = o1.alt - o2.alt;
    if (diff !== 0) return diff;
    return 0;
};
$a3caede9058c1b2e$var$__decorate([
    $60gAE.NotNull
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "predictionMode", void 0);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.NotNull
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "getPredictionMode", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "setPredictionMode", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.Override
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "reset", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "adaptivePredict", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(2, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "getStartState", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(3, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "execDFA", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(3, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "execATN", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(2, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "handleNoViableAlt", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "getExistingTargetState", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.NotNull,
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "computeTargetState", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.NotNull,
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "removeAllConfigsNotInRuleStopState", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.NotNull
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "computeStartState", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.NotNull,
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "applyPrecedenceFilter", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "getReachableTarget", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "getPredsForAmbigAlts", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "evalSemanticContext", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "evalSemanticContextImpl", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(4, $60gAE.Nullable)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "closure", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(2, $60gAE.Nullable),
    $a3caede9058c1b2e$var$__param(3, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(6, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "closureImpl", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.NotNull
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "getRuleName", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "getEpsilonTarget", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.NotNull,
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "actionTransition", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.Nullable,
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "precedenceTransition", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.Nullable,
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "predTransition", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.NotNull,
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(2, $60gAE.Nullable)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "ruleTransition", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "isConflicted", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.NotNull
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "getTokenName", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "dumpDeadEndConfigs", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.NotNull,
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(2, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "noViableAlt", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "getUniqueAlt", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "configWithAltAtStopState", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.NotNull,
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(4, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "addDFAEdge", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.Nullable),
    $a3caede9058c1b2e$var$__param(2, $60gAE.Nullable)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "setDFAEdge", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.NotNull,
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "addDFAContextState", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.NotNull,
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "addDFAState", null);
$a3caede9058c1b2e$var$__decorate([
    $60gAE.NotNull,
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(1, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "createDFAState", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(2, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "reportAttemptingFullContext", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(2, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "reportContextSensitivity", null);
$a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(5, $60gAE.NotNull),
    $a3caede9058c1b2e$var$__param(6, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator.prototype, "reportAmbiguity", null);
$a3caede9058c1b2e$var$ParserATNSimulator = $a3caede9058c1b2e$var$__decorate([
    $a3caede9058c1b2e$var$__param(0, $60gAE.NotNull)
], $a3caede9058c1b2e$var$ParserATNSimulator);
module.exports.ParserATNSimulator = $a3caede9058c1b2e$var$ParserATNSimulator;

});
parcelRegister("1wHaf", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $11ca43283f0e2b2b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConflictInfo = void 0;

var $60gAE = parcelRequire("60gAE");

var $5lo68 = parcelRequire("5lo68");
/**
 * This class stores information about a configuration conflict.
 *
 * @author Sam Harwell
 */ class $11ca43283f0e2b2b$var$ConflictInfo {
    constructor(conflictedAlts, exact){
        this._conflictedAlts = conflictedAlts;
        this.exact = exact;
    }
    /**
     * Gets the set of conflicting alternatives for the configuration set.
     */ get conflictedAlts() {
        return this._conflictedAlts;
    }
    /**
     * Gets whether or not the configuration conflict is an exact conflict.
     * An exact conflict occurs when the prediction algorithm determines that
     * the represented alternatives for a particular configuration set cannot be
     * further reduced by consuming additional input. After reaching an exact
     * conflict during an SLL prediction, only switch to full-context prediction
     * could reduce the set of viable alternatives. In LL prediction, an exact
     * conflict indicates a true ambiguity in the input.
     *
     * For the {@link PredictionMode#LL_EXACT_AMBIG_DETECTION} prediction mode,
     * accept states are conflicting but not exact are treated as non-accept
     * states.
     */ get isExact() {
        return this.exact;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $11ca43283f0e2b2b$var$ConflictInfo)) return false;
        return this.isExact === obj.isExact && $5lo68.equals(this.conflictedAlts, obj.conflictedAlts);
    }
    hashCode() {
        return this.conflictedAlts.hashCode();
    }
}
$11ca43283f0e2b2b$var$__decorate([
    $60gAE.Override
], $11ca43283f0e2b2b$var$ConflictInfo.prototype, "equals", null);
$11ca43283f0e2b2b$var$__decorate([
    $60gAE.Override
], $11ca43283f0e2b2b$var$ConflictInfo.prototype, "hashCode", null);
module.exports.ConflictInfo = $11ca43283f0e2b2b$var$ConflictInfo;

});

parcelRegister("gN8af", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c3978e3376a7cfd5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserRuleContext = void 0;

var $6hJiO = parcelRequire("6hJiO");

var $312SH = parcelRequire("312SH");

var $60gAE = parcelRequire("60gAE");

var $aNa7I = parcelRequire("aNa7I");

var $6AyGj = parcelRequire("6AyGj");
/** A rule invocation record for parsing.
 *
 *  Contains all of the information about the current rule not stored in the
 *  RuleContext. It handles parse tree children list, Any ATN state
 *  tracing, and the default values available for rule invocations:
 *  start, stop, rule index, current alt number.
 *
 *  Subclasses made for each rule and grammar track the parameters,
 *  return values, locals, and labels specific to that rule. These
 *  are the objects that are returned from rules.
 *
 *  Note text is not an actual field of a rule return value; it is computed
 *  from start and stop using the input stream's toString() method.  I
 *  could add a ctor to this so that we can pass in and store the input
 *  stream, but I'm not sure we want to do that.  It would seem to be undefined
 *  to get the .text property anyway if the rule matches tokens from multiple
 *  input streams.
 *
 *  I do not use getters for fields of objects that are used simply to
 *  group values such as this aggregate.  The getters/setters are there to
 *  satisfy the superclass interface.
 */ class $c3978e3376a7cfd5$var$ParserRuleContext extends $aNa7I.RuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber == null) super();
        else super(parent, invokingStateNumber);
    }
    static emptyContext() {
        return $c3978e3376a7cfd5$var$ParserRuleContext.EMPTY;
    }
    /**
     * COPY a ctx (I'm deliberately not using copy constructor) to avoid
     * confusion with creating node with parent. Does not copy children
     * (except error leaves).
     *
     * This is used in the generated parser code to flip a generic XContext
     * node for rule X to a YContext for alt label Y. In that sense, it is not
     * really a generic copy function.
     *
     * If we do an error sync() at start of a rule, we might add error nodes
     * to the generic XContext so this function must copy those nodes to the
     * YContext as well else they are lost!
     */ copyFrom(ctx) {
        this._parent = ctx._parent;
        this.invokingState = ctx.invokingState;
        this._start = ctx._start;
        this._stop = ctx._stop;
        // copy any error nodes to alt label node
        if (ctx.children) {
            this.children = [];
            // reset parent pointer for any error nodes
            for (let child of ctx.children)if (child instanceof $6hJiO.ErrorNode) this.addChild(child);
        }
    }
    // Double dispatch methods for listeners
    enterRule(listener) {
    // intentionally empty
    }
    exitRule(listener) {
    // intentionally empty
    }
    /** Add a parse tree node to this as a child.  Works for
     *  internal and leaf nodes. Does not set parent link;
     *  other add methods must do that. Other addChild methods
     *  call this.
     *
     *  We cannot set the parent pointer of the incoming node
     *  because the existing interfaces do not have a setParent()
     *  method and I don't want to break backward compatibility for this.
     *
     *  @since 4.7
     */ addAnyChild(t) {
        if (!this.children) this.children = [
            t
        ];
        else this.children.push(t);
        return t;
    }
    addChild(t) {
        let result;
        if (t instanceof $6AyGj.TerminalNode) {
            t.setParent(this);
            this.addAnyChild(t);
            return;
        } else if (t instanceof $aNa7I.RuleContext) {
            // Does not set parent link
            this.addAnyChild(t);
            return;
        } else {
            // Deprecated code path
            t = new $6AyGj.TerminalNode(t);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    addErrorNode(node) {
        if (node instanceof $6hJiO.ErrorNode) {
            const errorNode = node;
            errorNode.setParent(this);
            return this.addAnyChild(errorNode);
        } else {
            // deprecated path
            const badToken = node;
            let t = new $6hJiO.ErrorNode(badToken);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    //	public void trace(int s) {
    //		if ( states==null ) states = new ArrayList<Integer>();
    //		states.add(s);
    //	}
    /** Used by enterOuterAlt to toss out a RuleContext previously added as
     *  we entered a rule. If we have # label, we will need to remove
     *  generic ruleContext object.
     */ removeLastChild() {
        if (this.children) this.children.pop();
    }
    get parent() {
        let parent = super.parent;
        if (parent === undefined || parent instanceof $c3978e3376a7cfd5$var$ParserRuleContext) return parent;
        throw new TypeError("Invalid parent type for ParserRuleContext");
    }
    // Note: in TypeScript, order or arguments reversed
    getChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) throw new RangeError("index parameter must be between >= 0 and <= number of children.");
        if (ctxType == null) return this.children[i];
        let result = this.tryGetChild(i, ctxType);
        if (result === undefined) throw new Error("The specified node does not exist");
        return result;
    }
    tryGetChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what node with ctxType have we found?
        for (let o of this.children)if (o instanceof ctxType) {
            j++;
            if (j === i) return o;
        }
        return undefined;
    }
    getToken(ttype, i) {
        let result = this.tryGetToken(ttype, i);
        if (result === undefined) throw new Error("The specified token does not exist");
        return result;
    }
    tryGetToken(ttype, i) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what token with ttype have we found?
        for (let o of this.children)if (o instanceof $6AyGj.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) {
                j++;
                if (j === i) return o;
            }
        }
        return undefined;
    }
    getTokens(ttype) {
        let tokens = [];
        if (!this.children) return tokens;
        for (let o of this.children)if (o instanceof $6AyGj.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) tokens.push(o);
        }
        return tokens;
    }
    get ruleContext() {
        return this;
    }
    // NOTE: argument order change from Java version
    getRuleContext(i, ctxType) {
        return this.getChild(i, ctxType);
    }
    tryGetRuleContext(i, ctxType) {
        return this.tryGetChild(i, ctxType);
    }
    getRuleContexts(ctxType) {
        let contexts = [];
        if (!this.children) return contexts;
        for (let o of this.children)if (o instanceof ctxType) contexts.push(o);
        return contexts;
    }
    get childCount() {
        return this.children ? this.children.length : 0;
    }
    get sourceInterval() {
        if (!this._start) return $312SH.Interval.INVALID;
        if (!this._stop || this._stop.tokenIndex < this._start.tokenIndex) return $312SH.Interval.of(this._start.tokenIndex, this._start.tokenIndex - 1); // empty
        return $312SH.Interval.of(this._start.tokenIndex, this._stop.tokenIndex);
    }
    /**
     * Get the initial token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may exceed stop.
     */ get start() {
        return this._start;
    }
    /**
     * Get the final token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may precede start.
     */ get stop() {
        return this._stop;
    }
    /** Used for rule context info debugging during parse-time, not so much for ATN debugging */ toInfoString(recognizer) {
        let rules = recognizer.getRuleInvocationStack(this).reverse();
        return "ParserRuleContext" + rules + "{" + "start=" + this._start + ", stop=" + this._stop + "}";
    }
}
$c3978e3376a7cfd5$var$ParserRuleContext.EMPTY = new $c3978e3376a7cfd5$var$ParserRuleContext();
$c3978e3376a7cfd5$var$__decorate([
    $60gAE.Override
], $c3978e3376a7cfd5$var$ParserRuleContext.prototype, "parent", null);
$c3978e3376a7cfd5$var$__decorate([
    $60gAE.Override
], $c3978e3376a7cfd5$var$ParserRuleContext.prototype, "childCount", null);
$c3978e3376a7cfd5$var$__decorate([
    $60gAE.Override
], $c3978e3376a7cfd5$var$ParserRuleContext.prototype, "sourceInterval", null);
module.exports.ParserRuleContext = $c3978e3376a7cfd5$var$ParserRuleContext;

});
parcelRegister("6hJiO", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $493778bac9c09931$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorNode = void 0;

var $60gAE = parcelRequire("60gAE");

var $6AyGj = parcelRequire("6AyGj");
/** Represents a token that was consumed during resynchronization
 *  rather than during a valid match operation. For example,
 *  we will create this kind of a node during single token insertion
 *  and deletion as well as during "consume until error recovery set"
 *  upon no viable alternative exceptions.
 */ class $493778bac9c09931$var$ErrorNode extends $6AyGj.TerminalNode {
    constructor(token){
        super(token);
    }
    accept(visitor) {
        return visitor.visitErrorNode(this);
    }
}
$493778bac9c09931$var$__decorate([
    $60gAE.Override
], $493778bac9c09931$var$ErrorNode.prototype, "accept", null);
module.exports.ErrorNode = $493778bac9c09931$var$ErrorNode;

});
parcelRegister("6AyGj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4cc101e3e2b0c8cc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TerminalNode = void 0;

var $312SH = parcelRequire("312SH");

var $60gAE = parcelRequire("60gAE");

var $iLVZN = parcelRequire("iLVZN");
class $4cc101e3e2b0c8cc$var$TerminalNode {
    constructor(symbol){
        this._symbol = symbol;
    }
    getChild(i) {
        throw new RangeError("Terminal Node has no children.");
    }
    get symbol() {
        return this._symbol;
    }
    get parent() {
        return this._parent;
    }
    setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this._symbol;
    }
    get sourceInterval() {
        let tokenIndex = this._symbol.tokenIndex;
        return new $312SH.Interval(tokenIndex, tokenIndex);
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitTerminal(this);
    }
    get text() {
        return this._symbol.text || "";
    }
    toStringTree(parser) {
        return this.toString();
    }
    toString() {
        if (this._symbol.type === $iLVZN.Token.EOF) return "<EOF>";
        return this._symbol.text || "";
    }
}
$4cc101e3e2b0c8cc$var$__decorate([
    $60gAE.Override
], $4cc101e3e2b0c8cc$var$TerminalNode.prototype, "getChild", null);
$4cc101e3e2b0c8cc$var$__decorate([
    $60gAE.Override
], $4cc101e3e2b0c8cc$var$TerminalNode.prototype, "parent", null);
$4cc101e3e2b0c8cc$var$__decorate([
    $60gAE.Override
], $4cc101e3e2b0c8cc$var$TerminalNode.prototype, "setParent", null);
$4cc101e3e2b0c8cc$var$__decorate([
    $60gAE.Override
], $4cc101e3e2b0c8cc$var$TerminalNode.prototype, "payload", null);
$4cc101e3e2b0c8cc$var$__decorate([
    $60gAE.Override
], $4cc101e3e2b0c8cc$var$TerminalNode.prototype, "sourceInterval", null);
$4cc101e3e2b0c8cc$var$__decorate([
    $60gAE.Override
], $4cc101e3e2b0c8cc$var$TerminalNode.prototype, "childCount", null);
$4cc101e3e2b0c8cc$var$__decorate([
    $60gAE.Override
], $4cc101e3e2b0c8cc$var$TerminalNode.prototype, "accept", null);
$4cc101e3e2b0c8cc$var$__decorate([
    $60gAE.Override
], $4cc101e3e2b0c8cc$var$TerminalNode.prototype, "text", null);
$4cc101e3e2b0c8cc$var$__decorate([
    $60gAE.Override
], $4cc101e3e2b0c8cc$var$TerminalNode.prototype, "toStringTree", null);
$4cc101e3e2b0c8cc$var$__decorate([
    $60gAE.Override
], $4cc101e3e2b0c8cc$var$TerminalNode.prototype, "toString", null);
module.exports.TerminalNode = $4cc101e3e2b0c8cc$var$TerminalNode;

});


parcelRegister("aNa7I", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7db6554c6481f3b8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContext = void 0;

var $dQ2fw = parcelRequire("dQ2fw");

var $dlP2K = parcelRequire("dlP2K");

var $1PjR5 = parcelRequire("1PjR5");

var $312SH = parcelRequire("312SH");

var $60gAE = parcelRequire("60gAE");

var $kkJZ4 = parcelRequire("kkJZ4");

var $gN8af = parcelRequire("gN8af");
/** A rule context is a record of a single rule invocation.
 *
 *  We form a stack of these context objects using the parent
 *  pointer. A parent pointer of `undefined` indicates that the current
 *  context is the bottom of the stack. The ParserRuleContext subclass
 *  as a children list so that we can turn this data structure into a
 *  tree.
 *
 *  The root node always has a `undefined` pointer and invokingState of -1.
 *
 *  Upon entry to parsing, the first invoked rule function creates a
 *  context object (a subclass specialized for that rule such as
 *  SContext) and makes it the root of a parse tree, recorded by field
 *  Parser._ctx.
 *
 *  public final SContext s() throws RecognitionException {
 *      SContext _localctx = new SContext(_ctx, state); <-- create new node
 *      enterRule(_localctx, 0, RULE_s);                     <-- push it
 *      ...
 *      exitRule();                                          <-- pop back to _localctx
 *      return _localctx;
 *  }
 *
 *  A subsequent rule invocation of r from the start rule s pushes a
 *  new context object for r whose parent points at s and use invoking
 *  state is the state with r emanating as edge label.
 *
 *  The invokingState fields from a context object to the root
 *  together form a stack of rule indication states where the root
 *  (bottom of the stack) has a -1 sentinel value. If we invoke start
 *  symbol s then call r1, which calls r2, the  would look like
 *  this:
 *
 *     SContext[-1]   <- root node (bottom of the stack)
 *     R1Context[p]   <- p in rule s called r1
 *     R2Context[q]   <- q in rule r1 called r2
 *
 *  So the top of the stack, _ctx, represents a call to the current
 *  rule and it holds the return address from another rule that invoke
 *  to this rule. To invoke a rule, we must always have a current context.
 *
 *  The parent contexts are useful for computing lookahead sets and
 *  getting error information.
 *
 *  These objects are used during parsing and prediction.
 *  For the special case of parsers, we use the subclass
 *  ParserRuleContext.
 *
 *  @see ParserRuleContext
 */ class $7db6554c6481f3b8$var$RuleContext extends $1PjR5.RuleNode {
    constructor(parent, invokingState){
        super();
        this._parent = parent;
        this.invokingState = invokingState != null ? invokingState : -1;
    }
    static getChildContext(parent, invokingState) {
        return new $7db6554c6481f3b8$var$RuleContext(parent, invokingState);
    }
    depth() {
        let n = 0;
        let p = this;
        while(p){
            p = p._parent;
            n++;
        }
        return n;
    }
    /** A context is empty if there is no invoking state; meaning nobody called
     *  current context.
     */ get isEmpty() {
        return this.invokingState === -1;
    }
    // satisfy the ParseTree / SyntaxTree interface
    get sourceInterval() {
        return $312SH.Interval.INVALID;
    }
    get ruleContext() {
        return this;
    }
    get parent() {
        return this._parent;
    }
    /** @since 4.7. {@see ParseTree#setParent} comment */ setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this;
    }
    /** Return the combined text of all child nodes. This method only considers
     *  tokens which have been added to the parse tree.
     *
     *  Since tokens on hidden channels (e.g. whitespace or comments) are not
     *  added to the parse trees, they will not appear in the output of this
     *  method.
     */ get text() {
        if (this.childCount === 0) return "";
        let builder = "";
        for(let i = 0; i < this.childCount; i++)builder += this.getChild(i).text;
        return builder.toString();
    }
    get ruleIndex() {
        return -1;
    }
    /** For rule associated with this parse tree internal node, return
     *  the outer alternative number used to match the input. Default
     *  implementation does not compute nor store this alt num. Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *  to set it.
     *
     *  @since 4.5.3
     */ get altNumber() {
        return $dQ2fw.ATN.INVALID_ALT_NUMBER;
    }
    /** Set the outer alternative number for this context node. Default
     *  implementation does nothing to avoid backing field overhead for
     *  trees that don't need it.  Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *
     *  @since 4.5.3
     */ set altNumber(altNumber) {
    // intentionally ignored by the base implementation
    }
    getChild(i) {
        throw new RangeError("i must be greater than or equal to 0 and less than childCount");
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitChildren(this);
    }
    toStringTree(recog) {
        return $kkJZ4.Trees.toStringTree(this, recog);
    }
    toString(arg1, stop) {
        const ruleNames = arg1 instanceof $dlP2K.Recognizer ? arg1.ruleNames : arg1;
        stop = stop || $gN8af.ParserRuleContext.emptyContext();
        let buf = "";
        let p = this;
        buf += "[";
        while(p && p !== stop){
            if (!ruleNames) {
                if (!p.isEmpty) buf += p.invokingState;
            } else {
                let ruleIndex = p.ruleIndex;
                let ruleName = ruleIndex >= 0 && ruleIndex < ruleNames.length ? ruleNames[ruleIndex] : ruleIndex.toString();
                buf += ruleName;
            }
            if (p._parent && (ruleNames || !p._parent.isEmpty)) buf += " ";
            p = p._parent;
        }
        buf += "]";
        return buf.toString();
    }
}
$7db6554c6481f3b8$var$__decorate([
    $60gAE.Override
], $7db6554c6481f3b8$var$RuleContext.prototype, "sourceInterval", null);
$7db6554c6481f3b8$var$__decorate([
    $60gAE.Override
], $7db6554c6481f3b8$var$RuleContext.prototype, "ruleContext", null);
$7db6554c6481f3b8$var$__decorate([
    $60gAE.Override
], $7db6554c6481f3b8$var$RuleContext.prototype, "parent", null);
$7db6554c6481f3b8$var$__decorate([
    $60gAE.Override
], $7db6554c6481f3b8$var$RuleContext.prototype, "setParent", null);
$7db6554c6481f3b8$var$__decorate([
    $60gAE.Override
], $7db6554c6481f3b8$var$RuleContext.prototype, "payload", null);
$7db6554c6481f3b8$var$__decorate([
    $60gAE.Override
], $7db6554c6481f3b8$var$RuleContext.prototype, "text", null);
$7db6554c6481f3b8$var$__decorate([
    $60gAE.Override
], $7db6554c6481f3b8$var$RuleContext.prototype, "getChild", null);
$7db6554c6481f3b8$var$__decorate([
    $60gAE.Override
], $7db6554c6481f3b8$var$RuleContext.prototype, "childCount", null);
$7db6554c6481f3b8$var$__decorate([
    $60gAE.Override
], $7db6554c6481f3b8$var$RuleContext.prototype, "accept", null);
$7db6554c6481f3b8$var$__decorate([
    $60gAE.Override
], $7db6554c6481f3b8$var$RuleContext.prototype, "toStringTree", null);
module.exports.RuleContext = $7db6554c6481f3b8$var$RuleContext;

});
parcelRegister("1PjR5", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleNode = void 0;
class $1549f4b195accba6$var$RuleNode {
}
module.exports.RuleNode = $1549f4b195accba6$var$RuleNode;

});

parcelRegister("kkJZ4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ecd9585ffc4c4bf9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ecd9585ffc4c4bf9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Trees = void 0;

var $dQ2fw = parcelRequire("dQ2fw");

var $boV1Q = parcelRequire("boV1Q");

var $6hJiO = parcelRequire("6hJiO");

var $60gAE = parcelRequire("60gAE");

var $5ncBC = parcelRequire("5ncBC");

var $gN8af = parcelRequire("gN8af");

var $1PjR5 = parcelRequire("1PjR5");

var $6AyGj = parcelRequire("6AyGj");

var $iLVZN = parcelRequire("iLVZN");

var $5lo68 = parcelRequire("5lo68");
/** A set of utility routines useful for all kinds of ANTLR trees. */ class $ecd9585ffc4c4bf9$var$Trees {
    static toStringTree(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $5ncBC.Parser) ruleNames = arg2.ruleNames;
        else ruleNames = arg2;
        let s = $5lo68.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        if (t.childCount === 0) return s;
        let buf = "";
        buf += "(";
        s = $5lo68.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        buf += s;
        buf += " ";
        for(let i = 0; i < t.childCount; i++){
            if (i > 0) buf += " ";
            buf += this.toStringTree(t.getChild(i), ruleNames);
        }
        buf += ")";
        return buf;
    }
    static getNodeText(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $5ncBC.Parser) ruleNames = arg2.ruleNames;
        else if (arg2) ruleNames = arg2;
        else {
            // no recog or rule names
            let payload = t.payload;
            if (typeof payload.text === "string") return payload.text;
            return t.payload.toString();
        }
        if (t instanceof $1PjR5.RuleNode) {
            let ruleContext = t.ruleContext;
            let ruleIndex = ruleContext.ruleIndex;
            let ruleName = ruleNames[ruleIndex];
            let altNumber = ruleContext.altNumber;
            if (altNumber !== $dQ2fw.ATN.INVALID_ALT_NUMBER) return ruleName + ":" + altNumber;
            return ruleName;
        } else if (t instanceof $6hJiO.ErrorNode) return t.toString();
        else if (t instanceof $6AyGj.TerminalNode) {
            let symbol = t.symbol;
            return symbol.text || "";
        }
        throw new TypeError("Unexpected node type");
    }
    static getChildren(t) {
        let kids = [];
        for(let i = 0; i < t.childCount; i++)kids.push(t.getChild(i));
        return kids;
    }
    static getAncestors(t) {
        let ancestors = [];
        let p = t.parent;
        while(p){
            ancestors.unshift(p); // insert at start
            p = p.parent;
        }
        return ancestors;
    }
    /** Return true if t is u's parent or a node on path to root from u.
     *  Use === not equals().
     *
     *  @since 4.5.1
     */ static isAncestorOf(t, u) {
        if (!t || !u || !t.parent) return false;
        let p = u.parent;
        while(p){
            if (t === p) return true;
            p = p.parent;
        }
        return false;
    }
    static findAllTokenNodes(t, ttype) {
        return $ecd9585ffc4c4bf9$var$Trees.findAllNodes(t, ttype, true);
    }
    static findAllRuleNodes(t, ruleIndex) {
        return $ecd9585ffc4c4bf9$var$Trees.findAllNodes(t, ruleIndex, false);
    }
    static findAllNodes(t, index, findTokens) {
        let nodes = [];
        $ecd9585ffc4c4bf9$var$Trees._findAllNodes(t, index, findTokens, nodes);
        return nodes;
    }
    static _findAllNodes(t, index, findTokens, nodes) {
        // check this node (the root) first
        if (findTokens && t instanceof $6AyGj.TerminalNode) {
            if (t.symbol.type === index) nodes.push(t);
        } else if (!findTokens && t instanceof $gN8af.ParserRuleContext) {
            if (t.ruleIndex === index) nodes.push(t);
        }
        // check children
        for(let i = 0; i < t.childCount; i++)$ecd9585ffc4c4bf9$var$Trees._findAllNodes(t.getChild(i), index, findTokens, nodes);
    }
    /** Get all descendents; includes t itself.
     *
     * @since 4.5.1
     */ static getDescendants(t) {
        let nodes = [];
        function recurse(e) {
            nodes.push(e);
            const n = e.childCount;
            for(let i = 0; i < n; i++)recurse(e.getChild(i));
        }
        recurse(t);
        return nodes;
    }
    /** Find smallest subtree of t enclosing range startTokenIndex..stopTokenIndex
     *  inclusively using postorder traversal.  Recursive depth-first-search.
     *
     *  @since 4.5
     */ static getRootOfSubtreeEnclosingRegion(t, startTokenIndex, stopTokenIndex) {
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let child = t.getChild(i);
            let r = $ecd9585ffc4c4bf9$var$Trees.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
            if (r) return r;
        }
        if (t instanceof $gN8af.ParserRuleContext) {
            let stopToken = t.stop;
            if (startTokenIndex >= t.start.tokenIndex && // is range fully contained in t?
            (stopToken == null || stopTokenIndex <= stopToken.tokenIndex)) // note: r.stop==null likely implies that we bailed out of parser and there's nothing to the right
            return t;
        }
        return undefined;
    }
    /** Replace any subtree siblings of root that are completely to left
     *  or right of lookahead range with a CommonToken(Token.INVALID_TYPE,"...")
     *  node. The source interval for t is not altered to suit smaller range!
     *
     *  WARNING: destructive to t.
     *
     *  @since 4.5.1
     */ static stripChildrenOutOfRange(t, root, startIndex, stopIndex) {
        if (!t) return;
        let count = t.childCount;
        for(let i = 0; i < count; i++){
            let child = t.getChild(i);
            let range = child.sourceInterval;
            if (child instanceof $gN8af.ParserRuleContext && (range.b < startIndex || range.a > stopIndex)) {
                if ($ecd9585ffc4c4bf9$var$Trees.isAncestorOf(child, root)) {
                    let abbrev = new $boV1Q.CommonToken($iLVZN.Token.INVALID_TYPE, "...");
                    t.children[i] = new $6AyGj.TerminalNode(abbrev); // HACK access to private
                }
            }
        }
    }
    static findNodeSuchThat(t, pred) {
        // No type check needed as long as users only use one of the available overloads
        if (pred(t)) return t;
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let u = $ecd9585ffc4c4bf9$var$Trees.findNodeSuchThat(t.getChild(i), pred);
            if (u !== undefined) return u;
        }
        return undefined;
    }
}
$ecd9585ffc4c4bf9$var$__decorate([
    $ecd9585ffc4c4bf9$var$__param(0, $60gAE.NotNull)
], $ecd9585ffc4c4bf9$var$Trees, "toStringTree", null);
$ecd9585ffc4c4bf9$var$__decorate([
    $60gAE.NotNull,
    $ecd9585ffc4c4bf9$var$__param(0, $60gAE.NotNull)
], $ecd9585ffc4c4bf9$var$Trees, "getAncestors", null);
$ecd9585ffc4c4bf9$var$__decorate([
    $ecd9585ffc4c4bf9$var$__param(0, $60gAE.NotNull)
], $ecd9585ffc4c4bf9$var$Trees, "getRootOfSubtreeEnclosingRegion", null);
module.exports.Trees = $ecd9585ffc4c4bf9$var$Trees;

});



parcelRegister("iAyfo", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d88627933be65d54$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionMode = void 0;

var $cqAje = parcelRequire("cqAje");

var $ecbo5 = parcelRequire("ecbo5");

var $60gAE = parcelRequire("60gAE");

var $830He = parcelRequire("830He");
/**
 * This enumeration defines the prediction modes available in ANTLR 4 along with
 * utility methods for analyzing configuration sets for conflicts and/or
 * ambiguities.
 */ var $d88627933be65d54$var$PredictionMode;
(function(PredictionMode) {
    /**
     * The SLL(*) prediction mode. This prediction mode ignores the current
     * parser context when making predictions. This is the fastest prediction
     * mode, and provides correct results for many grammars. This prediction
     * mode is more powerful than the prediction mode provided by ANTLR 3, but
     * may result in syntax errors for grammar and input combinations which are
     * not SLL.
     *
     * When using this prediction mode, the parser will either return a correct
     * parse tree (i.e. the same parse tree that would be returned with the
     * {@link #LL} prediction mode), or it will report a syntax error. If a
     * syntax error is encountered when using the {@link #SLL} prediction mode,
     * it may be due to either an actual syntax error in the input or indicate
     * that the particular combination of grammar and input requires the more
     * powerful {@link #LL} prediction abilities to complete successfully.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["SLL"] = 0] = "SLL";
    /**
     * The LL(*) prediction mode. This prediction mode allows the current parser
     * context to be used for resolving SLL conflicts that occur during
     * prediction. This is the fastest prediction mode that guarantees correct
     * parse results for all combinations of grammars with syntactically correct
     * inputs.
     *
     * When using this prediction mode, the parser will make correct decisions
     * for all syntactically-correct grammar and input combinations. However, in
     * cases where the grammar is truly ambiguous this prediction mode might not
     * report a precise answer for *exactly which* alternatives are
     * ambiguous.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL"] = 1] = "LL";
    /**
     * The LL(*) prediction mode with exact ambiguity detection. In addition to
     * the correctness guarantees provided by the {@link #LL} prediction mode,
     * this prediction mode instructs the prediction algorithm to determine the
     * complete and exact set of ambiguous alternatives for every ambiguous
     * decision encountered while parsing.
     *
     * This prediction mode may be used for diagnosing ambiguities during
     * grammar development. Due to the performance overhead of calculating sets
     * of ambiguous alternatives, this prediction mode should be avoided when
     * the exact results are not necessary.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL_EXACT_AMBIG_DETECTION"] = 2] = "LL_EXACT_AMBIG_DETECTION";
})($d88627933be65d54$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
(function(PredictionMode) {
    /** A Map that uses just the state and the stack context as the key. */ // NOTE: Base type used to be FlexibleHashMap<ATNConfig, BitSet>
    class AltAndContextMap extends $cqAje.Array2DHashMap {
        constructor(){
            super(AltAndContextConfigEqualityComparator.INSTANCE);
        }
    }
    class AltAndContextConfigEqualityComparator {
        AltAndContextConfigEqualityComparator() {
        // intentionally empty
        }
        /**
         * The hash code is only a function of the {@link ATNState#stateNumber}
         * and {@link ATNConfig#context}.
         */ hashCode(o) {
            let hashCode = $ecbo5.MurmurHash.initialize(7);
            hashCode = $ecbo5.MurmurHash.update(hashCode, o.state.stateNumber);
            hashCode = $ecbo5.MurmurHash.update(hashCode, o.context);
            hashCode = $ecbo5.MurmurHash.finish(hashCode, 2);
            return hashCode;
        }
        equals(a, b) {
            if (a === b) return true;
            if (a == null || b == null) return false;
            return a.state.stateNumber === b.state.stateNumber && a.context.equals(b.context);
        }
    }
    AltAndContextConfigEqualityComparator.INSTANCE = new AltAndContextConfigEqualityComparator();
    $d88627933be65d54$var$__decorate([
        $60gAE.Override
    ], AltAndContextConfigEqualityComparator.prototype, "hashCode", null);
    $d88627933be65d54$var$__decorate([
        $60gAE.Override
    ], AltAndContextConfigEqualityComparator.prototype, "equals", null);
    /**
     * Checks if any configuration in `configs` is in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if any configuration in `configs` is in a
     * {@link RuleStopState}, otherwise `false`
     */ function hasConfigInRuleStopState(configs) {
        for (let c of configs){
            if (c.state instanceof $830He.RuleStopState) return true;
        }
        return false;
    }
    PredictionMode.hasConfigInRuleStopState = hasConfigInRuleStopState;
    /**
     * Checks if all configurations in `configs` are in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if all configurations in `configs` are in a
     * {@link RuleStopState}, otherwise `false`
     */ function allConfigsInRuleStopStates(/*@NotNull*/ configs) {
        for (let config of configs){
            if (!(config.state instanceof $830He.RuleStopState)) return false;
        }
        return true;
    }
    PredictionMode.allConfigsInRuleStopStates = allConfigsInRuleStopStates;
})($d88627933be65d54$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));

});

parcelRegister("hTR8H", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d080cb1148b45861$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d080cb1148b45861$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimulatorState = void 0;

var $60gAE = parcelRequire("60gAE");

var $gN8af = parcelRequire("gN8af");
/**
 *
 * @author Sam Harwell
 */ let $d080cb1148b45861$var$SimulatorState = class SimulatorState {
    constructor(outerContext, s0, useContext, remainingOuterContext){
        this.outerContext = outerContext != null ? outerContext : $gN8af.ParserRuleContext.emptyContext();
        this.s0 = s0;
        this.useContext = useContext;
        this.remainingOuterContext = remainingOuterContext;
    }
};
$d080cb1148b45861$var$SimulatorState = $d080cb1148b45861$var$__decorate([
    $d080cb1148b45861$var$__param(1, $60gAE.NotNull)
], $d080cb1148b45861$var$SimulatorState);
module.exports.SimulatorState = $d080cb1148b45861$var$SimulatorState;

});


parcelRegister("ia3fa", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d38bad4f635a5285$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusBlockStartState = void 0;

var $4txXj = parcelRequire("4txXj");

var $hxAlL = parcelRequire("hxAlL");

var $60gAE = parcelRequire("60gAE");
/** Start of `(A|B|...)+` loop. Technically a decision state, but
 *  we don't use for code generation; somebody might need it, so I'm defining
 *  it for completeness. In reality, the {@link PlusLoopbackState} node is the
 *  real decision-making note for `A+`.
 */ class $d38bad4f635a5285$var$PlusBlockStartState extends $hxAlL.BlockStartState {
    get stateType() {
        return $4txXj.ATNStateType.PLUS_BLOCK_START;
    }
}
$d38bad4f635a5285$var$__decorate([
    $60gAE.Override
], $d38bad4f635a5285$var$PlusBlockStartState.prototype, "stateType", null);
module.exports.PlusBlockStartState = $d38bad4f635a5285$var$PlusBlockStartState;

});

parcelRegister("abJj4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $76ae136b17d97b18$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusLoopbackState = void 0;

var $4txXj = parcelRequire("4txXj");

var $cpDvh = parcelRequire("cpDvh");

var $60gAE = parcelRequire("60gAE");
/** Decision state for `A+` and `(A|B)+`.  It has two transitions:
 *  one to the loop back to start of the block and one to exit.
 */ class $76ae136b17d97b18$var$PlusLoopbackState extends $cpDvh.DecisionState {
    get stateType() {
        return $4txXj.ATNStateType.PLUS_LOOP_BACK;
    }
}
$76ae136b17d97b18$var$__decorate([
    $60gAE.Override
], $76ae136b17d97b18$var$PlusLoopbackState.prototype, "stateType", null);
module.exports.PlusLoopbackState = $76ae136b17d97b18$var$PlusLoopbackState;

});

parcelRegister("1ZXDH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1749c00e0cf3aa79$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1749c00e0cf3aa79$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecedencePredicateTransition = void 0;

var $22TGw = parcelRequire("22TGw");

var $60gAE = parcelRequire("60gAE");

var $gt6ZZ = parcelRequire("gt6ZZ");
/**
 *
 * @author Sam Harwell
 */ let $1749c00e0cf3aa79$var$PrecedencePredicateTransition = class PrecedencePredicateTransition extends $22TGw.AbstractPredicateTransition {
    constructor(target, precedence){
        super(target);
        this.precedence = precedence;
    }
    get serializationType() {
        return 10 /* PRECEDENCE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $gt6ZZ.SemanticContext.PrecedencePredicate(this.precedence);
    }
    toString() {
        return this.precedence + " >= _p";
    }
};
$1749c00e0cf3aa79$var$__decorate([
    $60gAE.Override
], $1749c00e0cf3aa79$var$PrecedencePredicateTransition.prototype, "serializationType", null);
$1749c00e0cf3aa79$var$__decorate([
    $60gAE.Override
], $1749c00e0cf3aa79$var$PrecedencePredicateTransition.prototype, "isEpsilon", null);
$1749c00e0cf3aa79$var$__decorate([
    $60gAE.Override
], $1749c00e0cf3aa79$var$PrecedencePredicateTransition.prototype, "matches", null);
$1749c00e0cf3aa79$var$__decorate([
    $60gAE.Override
], $1749c00e0cf3aa79$var$PrecedencePredicateTransition.prototype, "toString", null);
$1749c00e0cf3aa79$var$PrecedencePredicateTransition = $1749c00e0cf3aa79$var$__decorate([
    $1749c00e0cf3aa79$var$__param(0, $60gAE.NotNull)
], $1749c00e0cf3aa79$var$PrecedencePredicateTransition);
module.exports.PrecedencePredicateTransition = $1749c00e0cf3aa79$var$PrecedencePredicateTransition;

});

parcelRegister("kHPTE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f130145cde342280$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f130145cde342280$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RangeTransition = void 0;

var $fkZzb = parcelRequire("fkZzb");

var $60gAE = parcelRequire("60gAE");

var $lhxCK = parcelRequire("lhxCK");
let $f130145cde342280$var$RangeTransition = class RangeTransition extends $lhxCK.Transition {
    constructor(target, from, to){
        super(target);
        this.from = from;
        this.to = to;
    }
    get serializationType() {
        return 2 /* RANGE */ ;
    }
    get label() {
        return $fkZzb.IntervalSet.of(this.from, this.to);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= this.from && symbol <= this.to;
    }
    toString() {
        return "'" + String.fromCodePoint(this.from) + "'..'" + String.fromCodePoint(this.to) + "'";
    }
};
$f130145cde342280$var$__decorate([
    $60gAE.Override
], $f130145cde342280$var$RangeTransition.prototype, "serializationType", null);
$f130145cde342280$var$__decorate([
    $60gAE.Override,
    $60gAE.NotNull
], $f130145cde342280$var$RangeTransition.prototype, "label", null);
$f130145cde342280$var$__decorate([
    $60gAE.Override
], $f130145cde342280$var$RangeTransition.prototype, "matches", null);
$f130145cde342280$var$__decorate([
    $60gAE.Override,
    $60gAE.NotNull
], $f130145cde342280$var$RangeTransition.prototype, "toString", null);
$f130145cde342280$var$RangeTransition = $f130145cde342280$var$__decorate([
    $f130145cde342280$var$__param(0, $60gAE.NotNull)
], $f130145cde342280$var$RangeTransition);
module.exports.RangeTransition = $f130145cde342280$var$RangeTransition;

});

parcelRegister("95fyx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $69d0a5c9582b8883$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStartState = void 0;

var $gh8QV = parcelRequire("gh8QV");

var $4txXj = parcelRequire("4txXj");

var $60gAE = parcelRequire("60gAE");
class $69d0a5c9582b8883$var$RuleStartState extends $gh8QV.ATNState {
    constructor(){
        super(...arguments);
        this.isPrecedenceRule = false;
        this.leftFactored = false;
    }
    get stateType() {
        return $4txXj.ATNStateType.RULE_START;
    }
}
$69d0a5c9582b8883$var$__decorate([
    $60gAE.Override
], $69d0a5c9582b8883$var$RuleStartState.prototype, "stateType", null);
module.exports.RuleStartState = $69d0a5c9582b8883$var$RuleStartState;

});

parcelRegister("4BHtX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $35ac58c7f19e4ab4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarBlockStartState = void 0;

var $4txXj = parcelRequire("4txXj");

var $hxAlL = parcelRequire("hxAlL");

var $60gAE = parcelRequire("60gAE");
/** The block that begins a closure loop. */ class $35ac58c7f19e4ab4$var$StarBlockStartState extends $hxAlL.BlockStartState {
    get stateType() {
        return $4txXj.ATNStateType.STAR_BLOCK_START;
    }
}
$35ac58c7f19e4ab4$var$__decorate([
    $60gAE.Override
], $35ac58c7f19e4ab4$var$StarBlockStartState.prototype, "stateType", null);
module.exports.StarBlockStartState = $35ac58c7f19e4ab4$var$StarBlockStartState;

});

parcelRegister("iTtiT", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $dc14182243755b7b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopbackState = void 0;

var $gh8QV = parcelRequire("gh8QV");

var $4txXj = parcelRequire("4txXj");

var $60gAE = parcelRequire("60gAE");
class $dc14182243755b7b$var$StarLoopbackState extends $gh8QV.ATNState {
    get loopEntryState() {
        return this.transition(0).target;
    }
    get stateType() {
        return $4txXj.ATNStateType.STAR_LOOP_BACK;
    }
}
$dc14182243755b7b$var$__decorate([
    $60gAE.Override
], $dc14182243755b7b$var$StarLoopbackState.prototype, "stateType", null);
module.exports.StarLoopbackState = $dc14182243755b7b$var$StarLoopbackState;

});

parcelRegister("aiReF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7804e1485d24f6a2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokensStartState = void 0;

var $4txXj = parcelRequire("4txXj");

var $cpDvh = parcelRequire("cpDvh");

var $60gAE = parcelRequire("60gAE");
/** The Tokens rule start state linking to each lexer rule start state */ class $7804e1485d24f6a2$var$TokensStartState extends $cpDvh.DecisionState {
    get stateType() {
        return $4txXj.ATNStateType.TOKEN_START;
    }
}
$7804e1485d24f6a2$var$__decorate([
    $60gAE.Override
], $7804e1485d24f6a2$var$TokensStartState.prototype, "stateType", null);
module.exports.TokensStartState = $7804e1485d24f6a2$var$TokensStartState;

});

parcelRegister("dpMFH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = void 0;

var $ecbo5 = parcelRequire("ecbo5");
class $9c435d55f1b3dd80$var$UUID {
    constructor(mostSigBits, moreSigBits, lessSigBits, leastSigBits){
        this.data = new Uint32Array(4);
        this.data[0] = mostSigBits;
        this.data[1] = moreSigBits;
        this.data[2] = lessSigBits;
        this.data[3] = leastSigBits;
    }
    static fromString(data) {
        if (!/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(data)) throw new Error("Incorrectly formatted UUID");
        let segments = data.split("-");
        let mostSigBits = parseInt(segments[0], 16);
        let moreSigBits = (parseInt(segments[1], 16) << 16 >>> 0) + parseInt(segments[2], 16);
        let lessSigBits = (parseInt(segments[3], 16) << 16 >>> 0) + parseInt(segments[4].substr(0, 4), 16);
        let leastSigBits = parseInt(segments[4].substr(-8), 16);
        return new $9c435d55f1b3dd80$var$UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    hashCode() {
        return $ecbo5.MurmurHash.hashCode([
            this.data[0],
            this.data[1],
            this.data[2],
            this.data[3]
        ]);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $9c435d55f1b3dd80$var$UUID)) return false;
        return this.data[0] === obj.data[0] && this.data[1] === obj.data[1] && this.data[2] === obj.data[2] && this.data[3] === obj.data[3];
    }
    toString() {
        return ("00000000" + this.data[0].toString(16)).substr(-8) + "-" + ("0000" + (this.data[1] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[1].toString(16)).substr(-4) + "-" + ("0000" + (this.data[2] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[2].toString(16)).substr(-4) + ("00000000" + this.data[3].toString(16)).substr(-8);
    }
}
module.exports.UUID = $9c435d55f1b3dd80$var$UUID;

});


parcelRegister("k18FW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e92aa1651632c965$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e92aa1651632c965$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseInfo = void 0;

var $60gAE = parcelRequire("60gAE");
/**
 * This class provides access to specific and aggregate statistics gathered
 * during profiling of a parser.
 *
 * @since 4.3
 */ let $e92aa1651632c965$var$ParseInfo = class ParseInfo {
    constructor(atnSimulator){
        this.atnSimulator = atnSimulator;
    }
    /**
     * Gets an array of {@link DecisionInfo} instances containing the profiling
     * information gathered for each decision in the ATN.
     *
     * @returns An array of {@link DecisionInfo} instances, indexed by decision
     * number.
     */ getDecisionInfo() {
        return this.atnSimulator.getDecisionInfo();
    }
    /**
     * Gets the decision numbers for decisions that required one or more
     * full-context predictions during parsing. These are decisions for which
     * {@link DecisionInfo#LL_Fallback} is non-zero.
     *
     * @returns A list of decision numbers which required one or more
     * full-context predictions during parsing.
     */ getLLDecisions() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let LL = [];
        for(let i = 0; i < decisions.length; i++){
            let fallBack = decisions[i].LL_Fallback;
            if (fallBack > 0) LL.push(i);
        }
        return LL;
    }
    /**
     * Gets the total time spent during prediction across all decisions made
     * during parsing. This value is the sum of
     * {@link DecisionInfo#timeInPrediction} for all decisions.
     */ getTotalTimeInPrediction() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let t = 0;
        for (let decision of decisions)t += decision.timeInPrediction;
        return t;
    }
    /**
     * Gets the total number of SLL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#SLL_TotalLook} for all decisions.
     */ getTotalSLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of LL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#LL_TotalLook} for all decisions.
     */ getTotalLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL prediction
     * across all decisions made during parsing.
     */ getTotalSLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for LL prediction
     * across all decisions made during parsing.
     */ getTotalLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL and LL
     * prediction across all decisions made during parsing.
     *
     * This value is the sum of {@link #getTotalSLLATNLookaheadOps} and
     * {@link #getTotalLLATNLookaheadOps}.
     */ getTotalATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions){
            k += decision.SLL_ATNTransitions;
            k += decision.LL_ATNTransitions;
        }
        return k;
    }
    getDFASize(decision) {
        if (decision) {
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
            return decisionToDFA.states.size;
        } else {
            let n = 0;
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA;
            for(let i = 0; i < decisionToDFA.length; i++)n += this.getDFASize(i);
            return n;
        }
    }
};
$e92aa1651632c965$var$__decorate([
    $60gAE.NotNull
], $e92aa1651632c965$var$ParseInfo.prototype, "getDecisionInfo", null);
$e92aa1651632c965$var$__decorate([
    $60gAE.NotNull
], $e92aa1651632c965$var$ParseInfo.prototype, "getLLDecisions", null);
$e92aa1651632c965$var$ParseInfo = $e92aa1651632c965$var$__decorate([
    $e92aa1651632c965$var$__param(0, $60gAE.NotNull)
], $e92aa1651632c965$var$ParseInfo);
module.exports.ParseInfo = $e92aa1651632c965$var$ParseInfo;

});

parcelRegister("2WiKh", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $223f8a0529d178ff$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyParserErrorListener = void 0;

var $kmhhl = parcelRequire("kmhhl");

var $60gAE = parcelRequire("60gAE");
/**
 * @author Sam Harwell
 */ class $223f8a0529d178ff$var$ProxyParserErrorListener extends $kmhhl.ProxyErrorListener {
    constructor(delegates){
        super(delegates);
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAmbiguity) listener.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        });
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        });
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState);
        });
    }
}
$223f8a0529d178ff$var$__decorate([
    $60gAE.Override
], $223f8a0529d178ff$var$ProxyParserErrorListener.prototype, "reportAmbiguity", null);
$223f8a0529d178ff$var$__decorate([
    $60gAE.Override
], $223f8a0529d178ff$var$ProxyParserErrorListener.prototype, "reportAttemptingFullContext", null);
$223f8a0529d178ff$var$__decorate([
    $60gAE.Override
], $223f8a0529d178ff$var$ProxyParserErrorListener.prototype, "reportContextSensitivity", null);
module.exports.ProxyParserErrorListener = $223f8a0529d178ff$var$ProxyParserErrorListener;

});

parcelRegister("5iiSP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hxIgm").then(()=>parcelRequire('9pq2z'));

});

parcelRegister("5PSjt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2XcDf").then(()=>parcelRequire('jIh9Z'));

});




parcelRegister("13JKH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseCancellationException = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:42.5447085-07:00
/**
 * This exception is thrown to cancel a parsing operation. This exception does
 * not extend {@link RecognitionException}, allowing it to bypass the standard
 * error recovery mechanisms. {@link BailErrorStrategy} throws this exception in
 * response to a parse error.
 *
 * @author Sam Harwell
 */ class $0c598fb5a13c0a15$var$ParseCancellationException extends Error {
    constructor(cause){
        super(cause.message);
        this.cause = cause;
        this.stack = cause.stack;
    }
    getCause() {
        return this.cause;
    }
}
module.exports.ParseCancellationException = $0c598fb5a13c0a15$var$ParseCancellationException;

});


parcelRegister("kIRsr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f1616251b2539a07$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f1616251b2539a07$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferedTokenStream = void 0;

var $lzl5a = parcelRequire("lzl5a");

var $boV1Q = parcelRequire("boV1Q");

var $312SH = parcelRequire("312SH");

var $ipeIv = parcelRequire("ipeIv");

var $60gAE = parcelRequire("60gAE");

var $iLVZN = parcelRequire("iLVZN");
/**
 * This implementation of {@link TokenStream} loads tokens from a
 * {@link TokenSource} on-demand, and places the tokens in a buffer to provide
 * access to any previous token by index.
 *
 * This token stream ignores the value of {@link Token#getChannel}. If your
 * parser requires the token stream filter tokens to only those on a particular
 * channel, such as {@link Token#DEFAULT_CHANNEL} or
 * {@link Token#HIDDEN_CHANNEL}, use a filtering token stream such a
 * {@link CommonTokenStream}.
 */ let $f1616251b2539a07$var$BufferedTokenStream = class BufferedTokenStream {
    constructor(tokenSource){
        /**
         * A collection of all tokens fetched from the token source. The list is
         * considered a complete view of the input once {@link #fetchedEOF} is set
         * to `true`.
         */ this.tokens = [];
        /**
         * The index into {@link #tokens} of the current token (next token to
         * {@link #consume}). {@link #tokens}`[`{@link #p}`]` should be
         * {@link #LT LT(1)}.
         *
         * This field is set to -1 when the stream is first constructed or when
         * {@link #setTokenSource} is called, indicating that the first token has
         * not yet been fetched from the token source. For additional information,
         * see the documentation of {@link IntStream} for a description of
         * Initializing Methods.
         */ this.p = -1;
        /**
         * Indicates whether the {@link Token#EOF} token has been fetched from
         * {@link #tokenSource} and added to {@link #tokens}. This field improves
         * performance for the following cases:
         *
         * * {@link #consume}: The lookahead check in {@link #consume} to prevent
         *   consuming the EOF symbol is optimized by checking the values of
         *   {@link #fetchedEOF} and {@link #p} instead of calling {@link #LA}.
         * * {@link #fetch}: The check to prevent adding multiple EOF symbols into
         *   {@link #tokens} is trivial with this field.
         */ this.fetchedEOF = false;
        if (tokenSource == null) throw new Error("tokenSource cannot be null");
        this._tokenSource = tokenSource;
    }
    get tokenSource() {
        return this._tokenSource;
    }
    /** Reset this token stream by setting its token source. */ set tokenSource(tokenSource) {
        this._tokenSource = tokenSource;
        this.tokens.length = 0;
        this.p = -1;
        this.fetchedEOF = false;
    }
    get index() {
        return this.p;
    }
    mark() {
        return 0;
    }
    release(marker) {
    // no resources to release
    }
    seek(index) {
        this.lazyInit();
        this.p = this.adjustSeekIndex(index);
    }
    get size() {
        return this.tokens.length;
    }
    consume() {
        let skipEofCheck;
        if (this.p >= 0) {
            if (this.fetchedEOF) // the last token in tokens is EOF. skip check if p indexes any
            // fetched token except the last.
            skipEofCheck = this.p < this.tokens.length - 1;
            else // no EOF token in tokens. skip check if p indexes a fetched token.
            skipEofCheck = this.p < this.tokens.length;
        } else // not yet initialized
        skipEofCheck = false;
        if (!skipEofCheck && this.LA(1) === $iLVZN.Token.EOF) throw new Error("cannot consume EOF");
        if (this.sync(this.p + 1)) this.p = this.adjustSeekIndex(this.p + 1);
    }
    /** Make sure index `i` in tokens has a token.
     *
     * @returns `true` if a token is located at index `i`, otherwise
     *    `false`.
     * @see #get(int i)
     */ sync(i) {
        $lzl5a(i >= 0);
        let n = i - this.tokens.length + 1; // how many more elements we need?
        //System.out.println("sync("+i+") needs "+n);
        if (n > 0) {
            let fetched = this.fetch(n);
            return fetched >= n;
        }
        return true;
    }
    /** Add `n` elements to buffer.
     *
     * @returns The actual number of elements added to the buffer.
     */ fetch(n) {
        if (this.fetchedEOF) return 0;
        for(let i = 0; i < n; i++){
            let t = this.tokenSource.nextToken();
            if (this.isWritableToken(t)) t.tokenIndex = this.tokens.length;
            this.tokens.push(t);
            if (t.type === $iLVZN.Token.EOF) {
                this.fetchedEOF = true;
                return i + 1;
            }
        }
        return n;
    }
    get(i) {
        if (i < 0 || i >= this.tokens.length) throw new RangeError("token index " + i + " out of range 0.." + (this.tokens.length - 1));
        return this.tokens[i];
    }
    /** Get all tokens from start..stop inclusively. */ getRange(start, stop) {
        if (start < 0 || stop < 0) return [];
        this.lazyInit();
        let subset = new Array();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $iLVZN.Token.EOF) break;
            subset.push(t);
        }
        return subset;
    }
    LA(i) {
        let token = this.LT(i);
        if (!token) return $iLVZN.Token.INVALID_TYPE;
        return token.type;
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        return this.tokens[this.p - k];
    }
    LT(k) {
        let result = this.tryLT(k);
        if (result === undefined) throw new RangeError("requested lookback index out of range");
        return result;
    }
    tryLT(k) {
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p + k - 1;
        this.sync(i);
        if (i >= this.tokens.length) // return EOF token
        // EOF must be last token
        return this.tokens[this.tokens.length - 1];
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /**
     * Allowed derived classes to modify the behavior of operations which change
     * the current stream position by adjusting the target token index of a seek
     * operation. The default implementation simply returns `i`. If an
     * exception is thrown in this method, the current stream index should not be
     * changed.
     *
     * For example, {@link CommonTokenStream} overrides this method to ensure that
     * the seek target is always an on-channel token.
     *
     * @param i The target token index.
     * @returns The adjusted target token index.
     */ adjustSeekIndex(i) {
        return i;
    }
    lazyInit() {
        if (this.p === -1) this.setup();
    }
    setup() {
        this.sync(0);
        this.p = this.adjustSeekIndex(0);
    }
    /** Given a start and stop index, return a `List` of all tokens in
     *  the token type `BitSet`.  Return an empty array if no tokens were found.  This
     *  method looks at both on and off channel tokens.
     */ getTokens(start, stop, types) {
        this.lazyInit();
        if (start === undefined) {
            $lzl5a(stop === undefined && types === undefined);
            return this.tokens;
        } else if (stop === undefined) stop = this.tokens.length - 1;
        if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
        if (start > stop) return [];
        if (types === undefined) return this.tokens.slice(start, stop + 1);
        else if (typeof types === "number") types = new Set().add(types);
        let typesSet = types;
        // list = tokens[start:stop]:{T t, t.type in types}
        let filteredTokens = this.tokens.slice(start, stop + 1);
        filteredTokens = filteredTokens.filter((value)=>typesSet.has(value.type));
        return filteredTokens;
    }
    /**
     * Given a starting index, return the index of the next token on channel.
     * Return `i` if `tokens[i]` is on channel. Return the index of
     * the EOF token if there are no tokens on channel between `i` and
     * EOF.
     */ nextTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) return this.size - 1;
        let token = this.tokens[i];
        while(token.channel !== channel){
            if (token.type === $iLVZN.Token.EOF) return i;
            i++;
            this.sync(i);
            token = this.tokens[i];
        }
        return i;
    }
    /**
     * Given a starting index, return the index of the previous token on
     * channel. Return `i` if `tokens[i]` is on channel. Return -1
     * if there are no tokens on channel between `i` and 0.
     *
     * If `i` specifies an index at or after the EOF token, the EOF token
     * index is returned. This is due to the fact that the EOF token is treated
     * as though it were on every channel.
     */ previousTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) // the EOF token is on every channel
        return this.size - 1;
        while(i >= 0){
            let token = this.tokens[i];
            if (token.type === $iLVZN.Token.EOF || token.channel === channel) return i;
            i--;
        }
        return i;
    }
    /** Collect all tokens on specified channel to the right of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL} or
     *  EOF. If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToRight(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        let nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, $ipeIv.Lexer.DEFAULT_TOKEN_CHANNEL);
        let to;
        let from = tokenIndex + 1;
        // if none onchannel to right, nextOnChannel=-1 so set to = last token
        if (nextOnChannel === -1) to = this.size - 1;
        else to = nextOnChannel;
        return this.filterForChannel(from, to, channel);
    }
    /** Collect all tokens on specified channel to the left of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL}.
     *  If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToLeft(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        if (tokenIndex === 0) // obviously no tokens can appear before the first token
        return [];
        let prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, $ipeIv.Lexer.DEFAULT_TOKEN_CHANNEL);
        if (prevOnChannel === tokenIndex - 1) return [];
        // if none onchannel to left, prevOnChannel=-1 then from=0
        let from = prevOnChannel + 1;
        let to = tokenIndex - 1;
        return this.filterForChannel(from, to, channel);
    }
    filterForChannel(from, to, channel) {
        let hidden = new Array();
        for(let i = from; i <= to; i++){
            let t = this.tokens[i];
            if (channel === -1) {
                if (t.channel !== $ipeIv.Lexer.DEFAULT_TOKEN_CHANNEL) hidden.push(t);
            } else if (t.channel === channel) hidden.push(t);
        }
        return hidden;
    }
    get sourceName() {
        return this.tokenSource.sourceName;
    }
    getText(interval) {
        if (interval === undefined) interval = $312SH.Interval.of(0, this.size - 1);
        else if (!(interval instanceof $312SH.Interval)) // Note: the more obvious check for 'instanceof RuleContext' results in a circular dependency problem
        interval = interval.sourceInterval;
        let start = interval.a;
        let stop = interval.b;
        if (start < 0 || stop < 0) return "";
        this.fill();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        let buf = "";
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $iLVZN.Token.EOF) break;
            buf += t.text;
        }
        return buf.toString();
    }
    getTextFromRange(start, stop) {
        if (this.isToken(start) && this.isToken(stop)) return this.getText($312SH.Interval.of(start.tokenIndex, stop.tokenIndex));
        return "";
    }
    /** Get all tokens from lexer until EOF. */ fill() {
        this.lazyInit();
        const blockSize = 1000;
        while(true){
            let fetched = this.fetch(blockSize);
            if (fetched < blockSize) return;
        }
    }
    // TODO: Figure out a way to make this more flexible?
    isWritableToken(t) {
        return t instanceof $boV1Q.CommonToken;
    }
    // TODO: Figure out a way to make this more flexible?
    isToken(t) {
        return t instanceof $boV1Q.CommonToken;
    }
};
$f1616251b2539a07$var$__decorate([
    $60gAE.NotNull
], $f1616251b2539a07$var$BufferedTokenStream.prototype, "_tokenSource", void 0);
$f1616251b2539a07$var$__decorate([
    $60gAE.Override
], $f1616251b2539a07$var$BufferedTokenStream.prototype, "tokenSource", null);
$f1616251b2539a07$var$__decorate([
    $60gAE.Override
], $f1616251b2539a07$var$BufferedTokenStream.prototype, "index", null);
$f1616251b2539a07$var$__decorate([
    $60gAE.Override
], $f1616251b2539a07$var$BufferedTokenStream.prototype, "mark", null);
$f1616251b2539a07$var$__decorate([
    $60gAE.Override
], $f1616251b2539a07$var$BufferedTokenStream.prototype, "release", null);
$f1616251b2539a07$var$__decorate([
    $60gAE.Override
], $f1616251b2539a07$var$BufferedTokenStream.prototype, "seek", null);
$f1616251b2539a07$var$__decorate([
    $60gAE.Override
], $f1616251b2539a07$var$BufferedTokenStream.prototype, "size", null);
$f1616251b2539a07$var$__decorate([
    $60gAE.Override
], $f1616251b2539a07$var$BufferedTokenStream.prototype, "consume", null);
$f1616251b2539a07$var$__decorate([
    $60gAE.Override
], $f1616251b2539a07$var$BufferedTokenStream.prototype, "get", null);
$f1616251b2539a07$var$__decorate([
    $60gAE.Override
], $f1616251b2539a07$var$BufferedTokenStream.prototype, "LA", null);
$f1616251b2539a07$var$__decorate([
    $60gAE.NotNull,
    $60gAE.Override
], $f1616251b2539a07$var$BufferedTokenStream.prototype, "LT", null);
$f1616251b2539a07$var$__decorate([
    $60gAE.Override
], $f1616251b2539a07$var$BufferedTokenStream.prototype, "sourceName", null);
$f1616251b2539a07$var$__decorate([
    $60gAE.NotNull,
    $60gAE.Override
], $f1616251b2539a07$var$BufferedTokenStream.prototype, "getText", null);
$f1616251b2539a07$var$__decorate([
    $60gAE.NotNull,
    $60gAE.Override
], $f1616251b2539a07$var$BufferedTokenStream.prototype, "getTextFromRange", null);
$f1616251b2539a07$var$BufferedTokenStream = $f1616251b2539a07$var$__decorate([
    $f1616251b2539a07$var$__param(0, $60gAE.NotNull)
], $f1616251b2539a07$var$BufferedTokenStream);
module.exports.BufferedTokenStream = $f1616251b2539a07$var$BufferedTokenStream;

});

parcelRegister("4EZNt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("inqNA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CharStreams = void 0;

var $9UJYq = parcelRequire("9UJYq");

var $bKaDe = parcelRequire("bKaDe");

var $hPLPA = parcelRequire("hPLPA");
// const DEFAULT_BUFFER_SIZE: number = 4096;
/** This class represents the primary interface for creating {@link CharStream}s
 *  from a variety of sources as of 4.7.  The motivation was to support
 *  Unicode code points > U+FFFF.  {@link ANTLRInputStream} and
 *  {@link ANTLRFileStream} are now deprecated in favor of the streams created
 *  by this interface.
 *
 *  DEPRECATED: {@code new ANTLRFileStream("myinputfile")}
 *  NEW:        {@code CharStreams.fromFileName("myinputfile")}
 *
 *  WARNING: If you use both the deprecated and the new streams, you will see
 *  a nontrivial performance degradation. This speed hit is because the
 *  {@link Lexer}'s internal code goes from a monomorphic to megamorphic
 *  dynamic dispatch to get characters from the input stream. Java's
 *  on-the-fly compiler (JIT) is unable to perform the same optimizations
 *  so stick with either the old or the new streams, if performance is
 *  a primary concern. See the extreme debugging and spelunking
 *  needed to identify this issue in our timing rig:
 *
 *      https://github.com/antlr/antlr4/pull/1781
 *
 *  The ANTLR character streams still buffer all the input when you create
 *  the stream, as they have done for ~20 years. If you need unbuffered
 *  access, please note that it becomes challenging to create
 *  parse trees. The parse tree has to point to tokens which will either
 *  point into a stale location in an unbuffered stream or you have to copy
 *  the characters out of the buffer into the token. That defeats the purpose
 *  of unbuffered input. Per the ANTLR book, unbuffered streams are primarily
 *  useful for processing infinite streams *during the parse.*
 *
 *  The new streams also use 8-bit buffers when possible so this new
 *  interface supports character streams that use half as much memory
 *  as the old {@link ANTLRFileStream}, which assumed 16-bit characters.
 *
 *  A big shout out to Ben Hamilton (github bhamiltoncx) for his superhuman
 *  efforts across all targets to get true Unicode 3.1 support for U+10FFFF.
 *
 *  @since 4.7
 */ var $d60f29aa78557832$var$CharStreams;
(function(CharStreams) {
    // /**
    //  * Creates a {@link CharStream} given a path to a UTF-8
    //  * encoded file on disk.
    //  *
    //  * Reads the entire contents of the file into the result before returning.
    //  */
    // export function fromFile(file: File): CharStream;
    // export function fromFile(file: File, charset: Charset): CharStream;
    // export function fromFile(file: File, charset?: Charset): CharStream {
    // 	if (charset === undefined) {
    // 		charset = Charset.forName("UTF-8");
    // 	}
    function fromString(s, sourceName) {
        if (sourceName === undefined || sourceName.length === 0) sourceName = $hPLPA.IntStream.UNKNOWN_SOURCE_NAME;
        // Initial guess assumes no code points > U+FFFF: one code
        // point for each code unit in the string
        let codePointBufferBuilder = $9UJYq.CodePointBuffer.builder(s.length);
        // TODO: CharBuffer.wrap(String) rightfully returns a read-only buffer
        // which doesn't expose its array, so we make a copy.
        let cb = new Uint16Array(s.length);
        for(let i = 0; i < s.length; i++)cb[i] = s.charCodeAt(i);
        codePointBufferBuilder.append(cb);
        return $bKaDe.CodePointCharStream.fromBuffer(codePointBufferBuilder.build(), sourceName);
    }
    CharStreams.fromString = fromString;
// export function bufferFromChannel(
// 	channel: ReadableByteChannel,
// 	charset: Charset,
// 	bufferSize: number,
// 	decodingErrorAction: CodingErrorAction,
// 	inputSize: number): CodePointBuffer {
// 	try {
// 		let utf8BytesIn: Uint8Array = new Uint8Array(bufferSize);
// 		let utf16CodeUnitsOut: Uint16Array = new Uint16Array(bufferSize);
// 		if (inputSize === -1) {
// 			inputSize = bufferSize;
// 		} else if (inputSize > Integer.MAX_VALUE) {
// 			// ByteBuffer et al don't support long sizes
// 			throw new RangeError(`inputSize ${inputSize} larger than max ${Integer.MAX_VALUE}`);
// 		}
// 		let codePointBufferBuilder: CodePointBuffer.Builder = CodePointBuffer.builder(inputSize);
// 		let decoder: CharsetDecoder = charset
// 				.newDecoder()
// 				.onMalformedInput(decodingErrorAction)
// 				.onUnmappableCharacter(decodingErrorAction);
// 		let endOfInput: boolean = false;
// 		while (!endOfInput) {
// 			let bytesRead: number = channel.read(utf8BytesIn);
// 			endOfInput = (bytesRead === -1);
// 			utf8BytesIn.flip();
// 			let result: CoderResult = decoder.decode(
// 				utf8BytesIn,
// 				utf16CodeUnitsOut,
// 				endOfInput);
// 			if (result.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 				result.throwException();
// 			}
// 			utf16CodeUnitsOut.flip();
// 			codePointBufferBuilder.append(utf16CodeUnitsOut);
// 			utf8BytesIn.compact();
// 			utf16CodeUnitsOut.compact();
// 		}
// 		// Handle any bytes at the end of the file which need to
// 		// be represented as errors or substitution characters.
// 		let flushResult: CoderResult = decoder.flush(utf16CodeUnitsOut);
// 		if (flushResult.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 			flushResult.throwException();
// 		}
// 		utf16CodeUnitsOut.flip();
// 		codePointBufferBuilder.append(utf16CodeUnitsOut);
// 		return codePointBufferBuilder.build();
// 	}
// 	finally {
// 		channel.close();
// 	}
// }
})($d60f29aa78557832$var$CharStreams = module.exports.CharStreams || (module.exports.CharStreams = {}));

});
parcelRegister("9UJYq", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointBuffer = void 0;

var $lzl5a = parcelRequire("lzl5a");

var $jgkMa = parcelRequire("jgkMa");
/**
 * Wrapper for `Uint8Array` / `Uint16Array` / `Int32Array`.
 */ class $737d01667b854a2b$var$CodePointBuffer {
    constructor(buffer, size){
        this.buffer = buffer;
        this._position = 0;
        this._size = size;
    }
    static withArray(buffer) {
        return new $737d01667b854a2b$var$CodePointBuffer(buffer, buffer.length);
    }
    get position() {
        return this._position;
    }
    set position(newPosition) {
        if (newPosition < 0 || newPosition > this._size) throw new RangeError();
        this._position = newPosition;
    }
    get remaining() {
        return this._size - this.position;
    }
    get(offset) {
        return this.buffer[offset];
    }
    array() {
        return this.buffer.slice(0, this._size);
    }
    static builder(initialBufferSize) {
        return new $737d01667b854a2b$var$CodePointBuffer.Builder(initialBufferSize);
    }
}
module.exports.CodePointBuffer = $737d01667b854a2b$var$CodePointBuffer;
(function(CodePointBuffer) {
    let Type;
    (function(Type) {
        Type[Type["BYTE"] = 0] = "BYTE";
        Type[Type["CHAR"] = 1] = "CHAR";
        Type[Type["INT"] = 2] = "INT";
    })(Type || (Type = {}));
    class Builder {
        constructor(initialBufferSize){
            this.type = 0 /* BYTE */ ;
            this.buffer = new Uint8Array(initialBufferSize);
            this.prevHighSurrogate = -1;
            this.position = 0;
        }
        build() {
            return new CodePointBuffer(this.buffer, this.position);
        }
        static roundUpToNextPowerOfTwo(i) {
            let nextPowerOfTwo = 32 - Math.clz32(i - 1);
            return Math.pow(2, nextPowerOfTwo);
        }
        ensureRemaining(remainingNeeded) {
            switch(this.type){
                case 0 /* BYTE */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint8Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 1 /* CHAR */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint16Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 2 /* INT */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Int32Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
            }
        }
        append(utf16In) {
            this.ensureRemaining(utf16In.length);
            this.appendArray(utf16In);
        }
        appendArray(utf16In) {
            switch(this.type){
                case 0 /* BYTE */ :
                    this.appendArrayByte(utf16In);
                    break;
                case 1 /* CHAR */ :
                    this.appendArrayChar(utf16In);
                    break;
                case 2 /* INT */ :
                    this.appendArrayInt(utf16In);
                    break;
            }
        }
        appendArrayByte(utf16In) {
            $lzl5a(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outByte = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (c <= 0xFF) outByte[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    if (!$jgkMa.isHighSurrogate(c)) {
                        this.byteToCharBuffer(utf16In.length);
                        this.appendArrayChar(utf16In);
                        return;
                    } else {
                        this.byteToIntBuffer(utf16In.length);
                        this.appendArrayInt(utf16In);
                        return;
                    }
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayChar(utf16In) {
            $lzl5a(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outChar = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (!$jgkMa.isHighSurrogate(c)) outChar[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    this.charToIntBuffer(utf16In.length);
                    this.appendArrayInt(utf16In);
                    return;
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayInt(utf16In) {
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outInt = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                inOffset++;
                if (this.prevHighSurrogate !== -1) {
                    if ($jgkMa.isLowSurrogate(c)) {
                        outInt[outOffset] = String.fromCharCode(this.prevHighSurrogate, c).codePointAt(0);
                        outOffset++;
                        this.prevHighSurrogate = -1;
                    } else {
                        // Dangling high surrogate
                        outInt[outOffset] = this.prevHighSurrogate;
                        outOffset++;
                        if ($jgkMa.isHighSurrogate(c)) this.prevHighSurrogate = c;
                        else {
                            outInt[outOffset] = c;
                            outOffset++;
                            this.prevHighSurrogate = -1;
                        }
                    }
                } else if ($jgkMa.isHighSurrogate(c)) this.prevHighSurrogate = c;
                else {
                    outInt[outOffset] = c;
                    outOffset++;
                }
            }
            if (this.prevHighSurrogate !== -1) {
                // Dangling high surrogate
                outInt[outOffset] = this.prevHighSurrogate;
                outOffset++;
            }
            this.position = outOffset;
        }
        byteToCharBuffer(toAppend) {
            // CharBuffers hold twice as much per unit as ByteBuffers, so start with half the capacity.
            let newBuffer = new Uint16Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 1 /* CHAR */ ;
            this.buffer = newBuffer;
        }
        byteToIntBuffer(toAppend) {
            // IntBuffers hold four times as much per unit as ByteBuffers, so start with one quarter the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 2));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
        charToIntBuffer(toAppend) {
            // IntBuffers hold two times as much per unit as ByteBuffers, so start with one half the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
    }
    CodePointBuffer.Builder = Builder;
})($737d01667b854a2b$var$CodePointBuffer = module.exports.CodePointBuffer || (module.exports.CodePointBuffer = {}));

});
parcelRegister("jgkMa", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSupplementaryCodePoint = module.exports.isLowSurrogate = module.exports.isHighSurrogate = void 0;
function $e05fa09d8b0aa247$var$isHighSurrogate(ch) {
    return ch >= 0xD800 && ch <= 0xDBFF;
}
module.exports.isHighSurrogate = $e05fa09d8b0aa247$var$isHighSurrogate;
function $e05fa09d8b0aa247$var$isLowSurrogate(ch) {
    return ch >= 0xDC00 && ch <= 0xDFFF;
}
module.exports.isLowSurrogate = $e05fa09d8b0aa247$var$isLowSurrogate;
function $e05fa09d8b0aa247$var$isSupplementaryCodePoint(ch) {
    return ch >= 0x10000;
}
module.exports.isSupplementaryCodePoint = $e05fa09d8b0aa247$var$isSupplementaryCodePoint;

});


parcelRegister("bKaDe", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $88cc3cd81ea7b539$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointCharStream = void 0;

var $lzl5a = parcelRequire("lzl5a");

var $hPLPA = parcelRequire("hPLPA");

var $312SH = parcelRequire("312SH");

var $60gAE = parcelRequire("60gAE");
/**
 * Alternative to {@link ANTLRInputStream} which treats the input
 * as a series of Unicode code points, instead of a series of UTF-16
 * code units.
 *
 * Use this if you need to parse input which potentially contains
 * Unicode values > U+FFFF.
 */ class $88cc3cd81ea7b539$var$CodePointCharStream {
    // Use the factory method {@link #fromBuffer(CodePointBuffer)} to
    // construct instances of this type.
    constructor(array, position, remaining, name){
        // TODO
        $lzl5a(position === 0);
        this._array = array;
        this._size = remaining;
        this._name = name;
        this._position = 0;
    }
    get internalStorage() {
        return this._array;
    }
    static fromBuffer(codePointBuffer, name) {
        if (name === undefined || name.length === 0) name = $hPLPA.IntStream.UNKNOWN_SOURCE_NAME;
        // Java lacks generics on primitive types.
        //
        // To avoid lots of calls to virtual methods in the
        // very hot codepath of LA() below, we construct one
        // of three concrete subclasses.
        //
        // The concrete subclasses directly access the code
        // points stored in the underlying array (byte[],
        // char[], or int[]), so we can avoid lots of virtual
        // method calls to ByteBuffer.get(offset).
        return new $88cc3cd81ea7b539$var$CodePointCharStream(codePointBuffer.array(), codePointBuffer.position, codePointBuffer.remaining, name);
    }
    consume() {
        if (this._size - this._position === 0) {
            $lzl5a(this.LA(1) === $hPLPA.IntStream.EOF);
            throw new RangeError("cannot consume EOF");
        }
        this._position++;
    }
    get index() {
        return this._position;
    }
    get size() {
        return this._size;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    seek(index) {
        this._position = index;
    }
    get sourceName() {
        return this._name;
    }
    toString() {
        return this.getText($312SH.Interval.of(0, this.size - 1));
    }
    LA(i) {
        let offset;
        switch(Math.sign(i)){
            case -1:
                offset = this.index + i;
                if (offset < 0) return $hPLPA.IntStream.EOF;
                return this._array[offset];
            case 0:
                // Undefined
                return 0;
            case 1:
                offset = this.index + i - 1;
                if (offset >= this.size) return $hPLPA.IntStream.EOF;
                return this._array[offset];
        }
        throw new RangeError("Not reached");
    }
    /** Return the UTF-16 encoded string for the given interval */ getText(interval) {
        const startIdx = Math.min(interval.a, this.size);
        const len = Math.min(interval.b - interval.a + 1, this.size - startIdx);
        if (this._array instanceof Int32Array) return String.fromCodePoint(...Array.from(this._array.subarray(startIdx, startIdx + len)));
        else return String.fromCharCode(...Array.from(this._array.subarray(startIdx, startIdx + len)));
    }
}
$88cc3cd81ea7b539$var$__decorate([
    $60gAE.Override
], $88cc3cd81ea7b539$var$CodePointCharStream.prototype, "consume", null);
$88cc3cd81ea7b539$var$__decorate([
    $60gAE.Override
], $88cc3cd81ea7b539$var$CodePointCharStream.prototype, "index", null);
$88cc3cd81ea7b539$var$__decorate([
    $60gAE.Override
], $88cc3cd81ea7b539$var$CodePointCharStream.prototype, "size", null);
$88cc3cd81ea7b539$var$__decorate([
    $60gAE.Override
], $88cc3cd81ea7b539$var$CodePointCharStream.prototype, "mark", null);
$88cc3cd81ea7b539$var$__decorate([
    $60gAE.Override
], $88cc3cd81ea7b539$var$CodePointCharStream.prototype, "release", null);
$88cc3cd81ea7b539$var$__decorate([
    $60gAE.Override
], $88cc3cd81ea7b539$var$CodePointCharStream.prototype, "seek", null);
$88cc3cd81ea7b539$var$__decorate([
    $60gAE.Override
], $88cc3cd81ea7b539$var$CodePointCharStream.prototype, "sourceName", null);
$88cc3cd81ea7b539$var$__decorate([
    $60gAE.Override
], $88cc3cd81ea7b539$var$CodePointCharStream.prototype, "toString", null);
$88cc3cd81ea7b539$var$__decorate([
    $60gAE.Override
], $88cc3cd81ea7b539$var$CodePointCharStream.prototype, "LA", null);
$88cc3cd81ea7b539$var$__decorate([
    $60gAE.Override
], $88cc3cd81ea7b539$var$CodePointCharStream.prototype, "getText", null);
module.exports.CodePointCharStream = $88cc3cd81ea7b539$var$CodePointCharStream;

});


parcelRegister("3pdFy", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $27ae4f5730926b27$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $27ae4f5730926b27$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenStream = void 0;

var $kIRsr = parcelRequire("kIRsr");

var $60gAE = parcelRequire("60gAE");

var $iLVZN = parcelRequire("iLVZN");
/**
 * This class extends {@link BufferedTokenStream} with functionality to filter
 * token streams to tokens on a particular channel (tokens where
 * {@link Token#getChannel} returns a particular value).
 *
 * This token stream provides access to all tokens by index or when calling
 * methods like {@link #getText}. The channel filtering is only used for code
 * accessing tokens via the lookahead methods {@link #LA}, {@link #LT}, and
 * {@link #LB}.
 *
 * By default, tokens are placed on the default channel
 * ({@link Token#DEFAULT_CHANNEL}), but may be reassigned by using the
 * `->channel(HIDDEN)` lexer command, or by using an embedded action to
 * call {@link Lexer#setChannel}.
 *
 * Note: lexer rules which use the `->skip` lexer command or call
 * {@link Lexer#skip} do not produce tokens at all, so input text matched by
 * such a rule will not be available as part of the token stream, regardless of
 * channel.
 */ let $27ae4f5730926b27$var$CommonTokenStream = class CommonTokenStream extends $kIRsr.BufferedTokenStream {
    /**
     * Constructs a new {@link CommonTokenStream} using the specified token
     * source and filtering tokens to the specified channel. Only tokens whose
     * {@link Token#getChannel} matches `channel` or have the
     * `Token.type` equal to {@link Token#EOF} will be returned by the
     * token stream lookahead methods.
     *
     * @param tokenSource The token source.
     * @param channel The channel to use for filtering tokens.
     */ constructor(tokenSource, channel = $iLVZN.Token.DEFAULT_CHANNEL){
        super(tokenSource);
        this.channel = channel;
    }
    adjustSeekIndex(i) {
        return this.nextTokenOnChannel(i, this.channel);
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        let i = this.p;
        let n = 1;
        // find k good tokens looking backwards
        while(n <= k && i > 0){
            // skip off-channel tokens
            i = this.previousTokenOnChannel(i - 1, this.channel);
            n++;
        }
        if (i < 0) return undefined;
        return this.tokens[i];
    }
    tryLT(k) {
        //System.out.println("enter LT("+k+")");
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p;
        let n = 1; // we know tokens[p] is a good one
        // find k good tokens
        while(n < k){
            // skip off-channel tokens, but make sure to not look past EOF
            if (this.sync(i + 1)) i = this.nextTokenOnChannel(i + 1, this.channel);
            n++;
        }
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /** Count EOF just once. */ getNumberOfOnChannelTokens() {
        let n = 0;
        this.fill();
        for (let t of this.tokens){
            if (t.channel === this.channel) n++;
            if (t.type === $iLVZN.Token.EOF) break;
        }
        return n;
    }
};
$27ae4f5730926b27$var$__decorate([
    $60gAE.Override
], $27ae4f5730926b27$var$CommonTokenStream.prototype, "adjustSeekIndex", null);
$27ae4f5730926b27$var$__decorate([
    $60gAE.Override
], $27ae4f5730926b27$var$CommonTokenStream.prototype, "tryLB", null);
$27ae4f5730926b27$var$__decorate([
    $60gAE.Override
], $27ae4f5730926b27$var$CommonTokenStream.prototype, "tryLT", null);
$27ae4f5730926b27$var$CommonTokenStream = $27ae4f5730926b27$var$__decorate([
    $27ae4f5730926b27$var$__param(0, $60gAE.NotNull)
], $27ae4f5730926b27$var$CommonTokenStream);
module.exports.CommonTokenStream = $27ae4f5730926b27$var$CommonTokenStream;

});

parcelRegister("1JWAI", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dependents = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.1349829-07:00
/**
 *
 * @author Sam Harwell
 */ var $14477164ca147ad9$var$Dependents;
(function(Dependents) {
    /**
     * The element is dependent upon the specified rule.
     */ Dependents[Dependents["SELF"] = 0] = "SELF";
    /**
     * The element is dependent upon the set of the specified rule's parents
     * (rules which directly reference it).
     */ Dependents[Dependents["PARENTS"] = 1] = "PARENTS";
    /**
     * The element is dependent upon the set of the specified rule's children
     * (rules which it directly references).
     */ Dependents[Dependents["CHILDREN"] = 2] = "CHILDREN";
    /**
     * The element is dependent upon the set of the specified rule's ancestors
     * (the transitive closure of `PARENTS` rules).
     */ Dependents[Dependents["ANCESTORS"] = 3] = "ANCESTORS";
    /**
     * The element is dependent upon the set of the specified rule's descendants
     * (the transitive closure of `CHILDREN` rules).
     */ Dependents[Dependents["DESCENDANTS"] = 4] = "DESCENDANTS";
    /**
     * The element is dependent upon the set of the specified rule's siblings
     * (the union of `CHILDREN` of its `PARENTS`).
     */ Dependents[Dependents["SIBLINGS"] = 5] = "SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear before a reference to the rule).
     */ Dependents[Dependents["PRECEEDING_SIBLINGS"] = 6] = "PRECEEDING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's following
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear after a reference to the rule).
     */ Dependents[Dependents["FOLLOWING_SIBLINGS"] = 7] = "FOLLOWING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * elements (rules which might end before the start of the specified rule
     * while parsing). This is calculated by taking the
     * `PRECEEDING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["PRECEEDING"] = 8] = "PRECEEDING";
    /**
     * The element is dependent upon the set of the specified rule's following
     * elements (rules which might start after the end of the specified rule
     * while parsing). This is calculated by taking the
     * `FOLLOWING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["FOLLOWING"] = 9] = "FOLLOWING";
})($14477164ca147ad9$var$Dependents = module.exports.Dependents || (module.exports.Dependents = {}));

});

parcelRegister("7gDoN", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $54a896d6aa779eea$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $54a896d6aa779eea$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiagnosticErrorListener = void 0;

var $igr91 = parcelRequire("igr91");

var $60gAE = parcelRequire("60gAE");

var $312SH = parcelRequire("312SH");
/**
 * This implementation of {@link ANTLRErrorListener} can be used to identify
 * certain potential correctness and performance problems in grammars. "Reports"
 * are made by calling {@link Parser#notifyErrorListeners} with the appropriate
 * message.
 *
 * * **Ambiguities**: These are cases where more than one path through the
 *   grammar can match the input.
 * * **Weak context sensitivity**: These are cases where full-context
 *   prediction resolved an SLL conflict to a unique alternative which equaled the
 *   minimum alternative of the SLL conflict.
 * * **Strong (forced) context sensitivity**: These are cases where the
 *   full-context prediction resolved an SLL conflict to a unique alternative,
 *   *and* the minimum alternative of the SLL conflict was found to not be
 *   a truly viable alternative. Two-stage parsing cannot be used for inputs where
 *   this situation occurs.
 *
 * @author Sam Harwell
 */ class $54a896d6aa779eea$var$DiagnosticErrorListener {
    /**
     * Initializes a new instance of {@link DiagnosticErrorListener}, specifying
     * whether all ambiguities or only exact ambiguities are reported.
     *
     * @param exactOnly `true` to report only exact ambiguities, otherwise
     * `false` to report all ambiguities.  Defaults to true.
     */ constructor(exactOnly = true){
        this.exactOnly = exactOnly;
        this.exactOnly = exactOnly;
    }
    syntaxError(/*@NotNull*/ recognizer, offendingSymbol, line, charPositionInLine, /*@NotNull*/ msg, e) {
    // intentionally empty
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (this.exactOnly && !exact) return;
        let decision = this.getDecisionDescription(recognizer, dfa);
        let conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
        let text = recognizer.inputStream.getText($312SH.Interval.of(startIndex, stopIndex));
        let message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        let format = "reportAttemptingFullContext d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($312SH.Interval.of(startIndex, stopIndex));
        let message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        let format = "reportContextSensitivity d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($312SH.Interval.of(startIndex, stopIndex));
        let message = `reportContextSensitivity d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    getDecisionDescription(recognizer, dfa) {
        let decision = dfa.decision;
        let ruleIndex = dfa.atnStartState.ruleIndex;
        let ruleNames = recognizer.ruleNames;
        if (ruleIndex < 0 || ruleIndex >= ruleNames.length) return decision.toString();
        let ruleName = ruleNames[ruleIndex];
        if (!ruleName) return decision.toString();
        return `${decision} (${ruleName})`;
    }
    /**
     * Computes the set of conflicting or ambiguous alternatives from a
     * configuration set, if that information was not already provided by the
     * parser.
     *
     * @param reportedAlts The set of conflicting or ambiguous alternatives, as
     * reported by the parser.
     * @param configs The conflicting or ambiguous configuration set.
     * @returns Returns `reportedAlts` if it is not `undefined`, otherwise
     * returns the set of alternatives represented in `configs`.
     */ getConflictingAlts(reportedAlts, configs) {
        if (reportedAlts != null) return reportedAlts;
        let result = new $igr91.BitSet();
        for (let config of configs)result.set(config.alt);
        return result;
    }
}
$54a896d6aa779eea$var$__decorate([
    $60gAE.Override
], $54a896d6aa779eea$var$DiagnosticErrorListener.prototype, "syntaxError", null);
$54a896d6aa779eea$var$__decorate([
    $60gAE.Override,
    $54a896d6aa779eea$var$__param(0, $60gAE.NotNull),
    $54a896d6aa779eea$var$__param(1, $60gAE.NotNull),
    $54a896d6aa779eea$var$__param(6, $60gAE.NotNull)
], $54a896d6aa779eea$var$DiagnosticErrorListener.prototype, "reportAmbiguity", null);
$54a896d6aa779eea$var$__decorate([
    $60gAE.Override,
    $54a896d6aa779eea$var$__param(0, $60gAE.NotNull),
    $54a896d6aa779eea$var$__param(1, $60gAE.NotNull),
    $54a896d6aa779eea$var$__param(5, $60gAE.NotNull)
], $54a896d6aa779eea$var$DiagnosticErrorListener.prototype, "reportAttemptingFullContext", null);
$54a896d6aa779eea$var$__decorate([
    $60gAE.Override,
    $54a896d6aa779eea$var$__param(0, $60gAE.NotNull),
    $54a896d6aa779eea$var$__param(1, $60gAE.NotNull),
    $54a896d6aa779eea$var$__param(5, $60gAE.NotNull)
], $54a896d6aa779eea$var$DiagnosticErrorListener.prototype, "reportContextSensitivity", null);
$54a896d6aa779eea$var$__decorate([
    $54a896d6aa779eea$var$__param(0, $60gAE.NotNull),
    $54a896d6aa779eea$var$__param(1, $60gAE.NotNull)
], $54a896d6aa779eea$var$DiagnosticErrorListener.prototype, "getDecisionDescription", null);
$54a896d6aa779eea$var$__decorate([
    $60gAE.NotNull,
    $54a896d6aa779eea$var$__param(1, $60gAE.NotNull)
], $54a896d6aa779eea$var$DiagnosticErrorListener.prototype, "getConflictingAlts", null);
module.exports.DiagnosticErrorListener = $54a896d6aa779eea$var$DiagnosticErrorListener;

});

parcelRegister("dGXa2", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9f7d16be22727d76$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InterpreterRuleContext = void 0;

var $60gAE = parcelRequire("60gAE");

var $gN8af = parcelRequire("gN8af");
/**
 * This class extends {@link ParserRuleContext} by allowing the value of
 * {@link #getRuleIndex} to be explicitly set for the context.
 *
 * {@link ParserRuleContext} does not include field storage for the rule index
 * since the context classes created by the code generator override the
 * {@link #getRuleIndex} method to return the correct value for that context.
 * Since the parser interpreter does not use the context classes generated for a
 * parser, this class (with slightly more memory overhead per node) is used to
 * provide equivalent functionality.
 */ class $9f7d16be22727d76$var$InterpreterRuleContext extends $gN8af.ParserRuleContext {
    constructor(ruleIndex, parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._ruleIndex = ruleIndex;
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
}
$9f7d16be22727d76$var$__decorate([
    $60gAE.Override
], $9f7d16be22727d76$var$InterpreterRuleContext.prototype, "ruleIndex", null);
module.exports.InterpreterRuleContext = $9f7d16be22727d76$var$InterpreterRuleContext;

});

parcelRegister("j4A7G", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $de2a69521521263b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $de2a69521521263b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerInterpreter = void 0;

var $ipeIv = parcelRequire("ipeIv");

var $7yK40 = parcelRequire("7yK40");

var $60gAE = parcelRequire("60gAE");

var $60gAE = parcelRequire("60gAE");
let $de2a69521521263b$var$LexerInterpreter = class LexerInterpreter extends $ipeIv.Lexer {
    constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input){
        super(input);
        if (atn.grammarType !== 0 /* LEXER */ ) throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
        this._grammarFileName = grammarFileName;
        this._atn = atn;
        this._ruleNames = ruleNames.slice(0);
        this._channelNames = channelNames.slice(0);
        this._modeNames = modeNames.slice(0);
        this._vocabulary = vocabulary;
        this._interp = new $7yK40.LexerATNSimulator(atn, this);
    }
    get atn() {
        return this._atn;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get channelNames() {
        return this._channelNames;
    }
    get modeNames() {
        return this._modeNames;
    }
    get vocabulary() {
        return this._vocabulary;
    }
};
$de2a69521521263b$var$__decorate([
    $60gAE.NotNull
], $de2a69521521263b$var$LexerInterpreter.prototype, "_vocabulary", void 0);
$de2a69521521263b$var$__decorate([
    $60gAE.Override
], $de2a69521521263b$var$LexerInterpreter.prototype, "atn", null);
$de2a69521521263b$var$__decorate([
    $60gAE.Override
], $de2a69521521263b$var$LexerInterpreter.prototype, "grammarFileName", null);
$de2a69521521263b$var$__decorate([
    $60gAE.Override
], $de2a69521521263b$var$LexerInterpreter.prototype, "ruleNames", null);
$de2a69521521263b$var$__decorate([
    $60gAE.Override
], $de2a69521521263b$var$LexerInterpreter.prototype, "channelNames", null);
$de2a69521521263b$var$__decorate([
    $60gAE.Override
], $de2a69521521263b$var$LexerInterpreter.prototype, "modeNames", null);
$de2a69521521263b$var$__decorate([
    $60gAE.Override
], $de2a69521521263b$var$LexerInterpreter.prototype, "vocabulary", null);
$de2a69521521263b$var$LexerInterpreter = $de2a69521521263b$var$__decorate([
    $de2a69521521263b$var$__param(1, $60gAE.NotNull)
], $de2a69521521263b$var$LexerInterpreter);
module.exports.LexerInterpreter = $de2a69521521263b$var$LexerInterpreter;

});

parcelRegister("hxaTJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cc3df8cf850f011e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $cc3df8cf850f011e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ListTokenSource = void 0;

var $fnPjW = parcelRequire("fnPjW");

var $60gAE = parcelRequire("60gAE");

var $iLVZN = parcelRequire("iLVZN");
/**
 * Provides an implementation of {@link TokenSource} as a wrapper around a list
 * of {@link Token} objects.
 *
 * If the final token in the list is an {@link Token#EOF} token, it will be used
 * as the EOF token for every call to {@link #nextToken} after the end of the
 * list is reached. Otherwise, an EOF token will be created.
 */ let $cc3df8cf850f011e$var$ListTokenSource = class ListTokenSource {
    /**
     * Constructs a new {@link ListTokenSource} instance from the specified
     * collection of {@link Token} objects and source name.
     *
     * @param tokens The collection of {@link Token} objects to provide as a
     * {@link TokenSource}.
     * @param sourceName The name of the {@link TokenSource}. If this value is
     * `undefined`, {@link #getSourceName} will attempt to infer the name from
     * the next {@link Token} (or the previous token if the end of the input has
     * been reached).
     *
     * @exception NullPointerException if `tokens` is `undefined`
     */ constructor(tokens, sourceName){
        /**
         * The index into {@link #tokens} of token to return by the next call to
         * {@link #nextToken}. The end of the input is indicated by this value
         * being greater than or equal to the number of items in {@link #tokens}.
         */ this.i = 0;
        /**
         * This is the backing field for {@link #getTokenFactory} and
         * {@link setTokenFactory}.
         */ this._factory = $fnPjW.CommonTokenFactory.DEFAULT;
        if (tokens == null) throw new Error("tokens cannot be null");
        this.tokens = tokens;
        this._sourceName = sourceName;
    }
    /**
     * {@inheritDoc}
     */ get charPositionInLine() {
        if (this.i < this.tokens.length) return this.tokens[this.i].charPositionInLine;
        else if (this.eofToken != null) return this.eofToken.charPositionInLine;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let tokenText = lastToken.text;
            if (tokenText != null) {
                let lastNewLine = tokenText.lastIndexOf("\n");
                if (lastNewLine >= 0) return tokenText.length - lastNewLine - 1;
            }
            return lastToken.charPositionInLine + lastToken.stopIndex - lastToken.startIndex + 1;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 0;
    }
    /**
     * {@inheritDoc}
     */ nextToken() {
        if (this.i >= this.tokens.length) {
            if (this.eofToken == null) {
                let start = -1;
                if (this.tokens.length > 0) {
                    let previousStop = this.tokens[this.tokens.length - 1].stopIndex;
                    if (previousStop !== -1) start = previousStop + 1;
                }
                let stop = Math.max(-1, start - 1);
                this.eofToken = this._factory.create({
                    source: this,
                    stream: this.inputStream
                }, $iLVZN.Token.EOF, "EOF", $iLVZN.Token.DEFAULT_CHANNEL, start, stop, this.line, this.charPositionInLine);
            }
            return this.eofToken;
        }
        let t = this.tokens[this.i];
        if (this.i === this.tokens.length - 1 && t.type === $iLVZN.Token.EOF) this.eofToken = t;
        this.i++;
        return t;
    }
    /**
     * {@inheritDoc}
     */ get line() {
        if (this.i < this.tokens.length) return this.tokens[this.i].line;
        else if (this.eofToken != null) return this.eofToken.line;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let line = lastToken.line;
            let tokenText = lastToken.text;
            if (tokenText != null) {
                for(let i = 0; i < tokenText.length; i++)if (tokenText.charAt(i) === "\n") line++;
            }
            // if no text is available, assume the token did not contain any newline characters.
            return line;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 1;
    }
    /**
     * {@inheritDoc}
     */ get inputStream() {
        if (this.i < this.tokens.length) return this.tokens[this.i].inputStream;
        else if (this.eofToken != null) return this.eofToken.inputStream;
        else if (this.tokens.length > 0) return this.tokens[this.tokens.length - 1].inputStream;
        // no input stream information is available
        return undefined;
    }
    /**
     * {@inheritDoc}
     */ get sourceName() {
        if (this._sourceName) return this._sourceName;
        let inputStream = this.inputStream;
        if (inputStream != null) return inputStream.sourceName;
        return "List";
    }
    /**
     * {@inheritDoc}
     */ // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    /**
     * {@inheritDoc}
     */ get tokenFactory() {
        return this._factory;
    }
};
$cc3df8cf850f011e$var$__decorate([
    $60gAE.Override
], $cc3df8cf850f011e$var$ListTokenSource.prototype, "charPositionInLine", null);
$cc3df8cf850f011e$var$__decorate([
    $60gAE.Override
], $cc3df8cf850f011e$var$ListTokenSource.prototype, "nextToken", null);
$cc3df8cf850f011e$var$__decorate([
    $60gAE.Override
], $cc3df8cf850f011e$var$ListTokenSource.prototype, "line", null);
$cc3df8cf850f011e$var$__decorate([
    $60gAE.Override
], $cc3df8cf850f011e$var$ListTokenSource.prototype, "inputStream", null);
$cc3df8cf850f011e$var$__decorate([
    $60gAE.Override
], $cc3df8cf850f011e$var$ListTokenSource.prototype, "sourceName", null);
$cc3df8cf850f011e$var$__decorate([
    $60gAE.Override,
    $60gAE.NotNull,
    $cc3df8cf850f011e$var$__param(0, $60gAE.NotNull)
], $cc3df8cf850f011e$var$ListTokenSource.prototype, "tokenFactory", null);
$cc3df8cf850f011e$var$ListTokenSource = $cc3df8cf850f011e$var$__decorate([
    $cc3df8cf850f011e$var$__param(0, $60gAE.NotNull)
], $cc3df8cf850f011e$var$ListTokenSource);
module.exports.ListTokenSource = $cc3df8cf850f011e$var$ListTokenSource;

});

parcelRegister("i3DCp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1jn1l", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0f496c3a01b188cf$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0f496c3a01b188cf$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserInterpreter = void 0;

var $gh8QV = parcelRequire("gh8QV");

var $4txXj = parcelRequire("4txXj");

var $igr91 = parcelRequire("igr91");

var $aaCqm = parcelRequire("aaCqm");

var $2ITdp = parcelRequire("2ITdp");

var $dGXa2 = parcelRequire("dGXa2");

var $915XK = parcelRequire("915XK");

var $60gAE = parcelRequire("60gAE");

var $60gAE = parcelRequire("60gAE");

var $5ncBC = parcelRequire("5ncBC");

var $e3RBK = parcelRequire("e3RBK");

var $2XZxT = parcelRequire("2XZxT");

var $1UcbM = parcelRequire("1UcbM");

var $iLVZN = parcelRequire("iLVZN");
/** A parser simulator that mimics what ANTLR's generated
 *  parser code does. A ParserATNSimulator is used to make
 *  predictions via adaptivePredict but this class moves a pointer through the
 *  ATN to simulate parsing. ParserATNSimulator just
 *  makes us efficient rather than having to backtrack, for example.
 *
 *  This properly creates parse trees even for left recursive rules.
 *
 *  We rely on the left recursive rule invocation and special predicate
 *  transitions to make left recursive rules work.
 *
 *  See TestParserInterpreter for examples.
 */ let $0f496c3a01b188cf$var$ParserInterpreter = class ParserInterpreter extends $5ncBC.Parser {
    constructor(grammarFileName, vocabulary, ruleNames, atn, input){
        super(grammarFileName instanceof ParserInterpreter ? grammarFileName.inputStream : input);
        /** This stack corresponds to the _parentctx, _parentState pair of locals
         *  that would exist on call stack frames with a recursive descent parser;
         *  in the generated function for a left-recursive rule you'd see:
         *
         *  private EContext e(int _p) {
         *      ParserRuleContext _parentctx = _ctx;    // Pair.a
         *      int _parentState = state;          // Pair.b
         *      ...
         *  }
         *
         *  Those values are used to create new recursive rule invocation contexts
         *  associated with left operand of an alt like "expr '*' expr".
         */ this._parentContextStack = [];
        /** We need a map from (decision,inputIndex)->forced alt for computing ambiguous
         *  parse trees. For now, we allow exactly one override.
         */ this.overrideDecision = -1;
        this.overrideDecisionInputIndex = -1;
        this.overrideDecisionAlt = -1;
        this.overrideDecisionReached = false; // latch and only override once; error might trigger infinite loop
        /** What is the current context when we override a decisions?  This tells
         *  us what the root of the parse tree is when using override
         *  for an ambiguity/lookahead check.
         */ this._overrideDecisionRoot = undefined;
        if (grammarFileName instanceof ParserInterpreter) {
            let old = grammarFileName;
            this._grammarFileName = old._grammarFileName;
            this._atn = old._atn;
            this.pushRecursionContextStates = old.pushRecursionContextStates;
            this._ruleNames = old._ruleNames;
            this._vocabulary = old._vocabulary;
            this.interpreter = new $e3RBK.ParserATNSimulator(this._atn, this);
        } else {
            // The second constructor requires non-null arguments
            vocabulary;
            ruleNames;
            atn;
            this._grammarFileName = grammarFileName;
            this._atn = atn;
            this._ruleNames = ruleNames.slice(0);
            this._vocabulary = vocabulary;
            // identify the ATN states where pushNewRecursionContext() must be called
            this.pushRecursionContextStates = new $igr91.BitSet(atn.states.length);
            for (let state of atn.states){
                if (!(state instanceof $1UcbM.StarLoopEntryState)) continue;
                if (state.precedenceRuleDecision) this.pushRecursionContextStates.set(state.stateNumber);
            }
            // get atn simulator that knows how to do predictions
            this.interpreter = new $e3RBK.ParserATNSimulator(atn, this);
        }
    }
    reset(resetInput) {
        if (resetInput === undefined) super.reset();
        else super.reset(resetInput);
        this.overrideDecisionReached = false;
        this._overrideDecisionRoot = undefined;
    }
    get atn() {
        return this._atn;
    }
    get vocabulary() {
        return this._vocabulary;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    /** Begin parsing at startRuleIndex */ parse(startRuleIndex) {
        let startRuleStartState = this._atn.ruleToStartState[startRuleIndex];
        this._rootContext = this.createInterpreterRuleContext(undefined, $gh8QV.ATNState.INVALID_STATE_NUMBER, startRuleIndex);
        if (startRuleStartState.isPrecedenceRule) this.enterRecursionRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
        else this.enterRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex);
        while(true){
            let p = this.atnState;
            switch(p.stateType){
                case $4txXj.ATNStateType.RULE_STOP:
                    // pop; return from rule
                    if (this._ctx.isEmpty) {
                        if (startRuleStartState.isPrecedenceRule) {
                            let result = this._ctx;
                            let parentContext = this._parentContextStack.pop();
                            this.unrollRecursionContexts(parentContext[0]);
                            return result;
                        } else {
                            this.exitRule();
                            return this._rootContext;
                        }
                    }
                    this.visitRuleStopState(p);
                    break;
                default:
                    try {
                        this.visitState(p);
                    } catch (e) {
                        if (e instanceof $2XZxT.RecognitionException) {
                            this.state = this._atn.ruleToStopState[p.ruleIndex].stateNumber;
                            this.context.exception = e;
                            this.errorHandler.reportError(this, e);
                            this.recover(e);
                        } else throw e;
                    }
                    break;
            }
        }
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this._parentContextStack.push([
            this._ctx,
            localctx.invokingState
        ]);
        super.enterRecursionRule(localctx, state, ruleIndex, precedence);
    }
    get atnState() {
        return this._atn.states[this.state];
    }
    visitState(p) {
        let predictedAlt = 1;
        if (p.numberOfTransitions > 1) predictedAlt = this.visitDecisionState(p);
        let transition = p.transition(predictedAlt - 1);
        switch(transition.serializationType){
            case 1 /* EPSILON */ :
                if (this.pushRecursionContextStates.get(p.stateNumber) && !(transition.target instanceof $915XK.LoopEndState)) {
                    // We are at the start of a left recursive rule's (...)* loop
                    // and we're not taking the exit branch of loop.
                    let parentContext = this._parentContextStack[this._parentContextStack.length - 1];
                    let localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this._ctx.ruleIndex);
                    this.pushNewRecursionContext(localctx, this._atn.ruleToStartState[p.ruleIndex].stateNumber, this._ctx.ruleIndex);
                }
                break;
            case 5 /* ATOM */ :
                this.match(transition._label);
                break;
            case 2 /* RANGE */ :
            case 7 /* SET */ :
            case 8 /* NOT_SET */ :
                if (!transition.matches(this._input.LA(1), $iLVZN.Token.MIN_USER_TOKEN_TYPE, 65535)) this.recoverInline();
                this.matchWildcard();
                break;
            case 9 /* WILDCARD */ :
                this.matchWildcard();
                break;
            case 3 /* RULE */ :
                let ruleStartState = transition.target;
                let ruleIndex = ruleStartState.ruleIndex;
                let newctx = this.createInterpreterRuleContext(this._ctx, p.stateNumber, ruleIndex);
                if (ruleStartState.isPrecedenceRule) this.enterRecursionRule(newctx, ruleStartState.stateNumber, ruleIndex, transition.precedence);
                else this.enterRule(newctx, transition.target.stateNumber, ruleIndex);
                break;
            case 4 /* PREDICATE */ :
                let predicateTransition = transition;
                if (!this.sempred(this._ctx, predicateTransition.ruleIndex, predicateTransition.predIndex)) throw new $aaCqm.FailedPredicateException(this);
                break;
            case 6 /* ACTION */ :
                let actionTransition = transition;
                this.action(this._ctx, actionTransition.ruleIndex, actionTransition.actionIndex);
                break;
            case 10 /* PRECEDENCE */ :
                if (!this.precpred(this._ctx, transition.precedence)) {
                    let precedence = transition.precedence;
                    throw new $aaCqm.FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
                }
                break;
            default:
                throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
        }
        this.state = transition.target.stateNumber;
    }
    /** Method visitDecisionState() is called when the interpreter reaches
     *  a decision state (instance of DecisionState). It gives an opportunity
     *  for subclasses to track interesting things.
     */ visitDecisionState(p) {
        let predictedAlt;
        this.errorHandler.sync(this);
        let decision = p.decision;
        if (decision === this.overrideDecision && this._input.index === this.overrideDecisionInputIndex && !this.overrideDecisionReached) {
            predictedAlt = this.overrideDecisionAlt;
            this.overrideDecisionReached = true;
        } else predictedAlt = this.interpreter.adaptivePredict(this._input, decision, this._ctx);
        return predictedAlt;
    }
    /** Provide simple "factory" for InterpreterRuleContext's.
     *  @since 4.5.1
     */ createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
        return new $dGXa2.InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
    }
    visitRuleStopState(p) {
        let ruleStartState = this._atn.ruleToStartState[p.ruleIndex];
        if (ruleStartState.isPrecedenceRule) {
            let parentContext = this._parentContextStack.pop();
            this.unrollRecursionContexts(parentContext[0]);
            this.state = parentContext[1];
        } else this.exitRule();
        let ruleTransition = this._atn.states[this.state].transition(0);
        this.state = ruleTransition.followState.stateNumber;
    }
    /** Override this parser interpreters normal decision-making process
     *  at a particular decision and input token index. Instead of
     *  allowing the adaptive prediction mechanism to choose the
     *  first alternative within a block that leads to a successful parse,
     *  force it to take the alternative, 1..n for n alternatives.
     *
     *  As an implementation limitation right now, you can only specify one
     *  override. This is sufficient to allow construction of different
     *  parse trees for ambiguous input. It means re-parsing the entire input
     *  in general because you're never sure where an ambiguous sequence would
     *  live in the various parse trees. For example, in one interpretation,
     *  an ambiguous input sequence would be matched completely in expression
     *  but in another it could match all the way back to the root.
     *
     *  s : e '!'? ;
     *  e : ID
     *    | ID '!'
     *    ;
     *
     *  Here, x! can be matched as (s (e ID) !) or (s (e ID !)). In the first
     *  case, the ambiguous sequence is fully contained only by the root.
     *  In the second case, the ambiguous sequences fully contained within just
     *  e, as in: (e ID !).
     *
     *  Rather than trying to optimize this and make
     *  some intelligent decisions for optimization purposes, I settled on
     *  just re-parsing the whole input and then using
     *  {link Trees#getRootOfSubtreeEnclosingRegion} to find the minimal
     *  subtree that contains the ambiguous sequence. I originally tried to
     *  record the call stack at the point the parser detected and ambiguity but
     *  left recursive rules create a parse tree stack that does not reflect
     *  the actual call stack. That impedance mismatch was enough to make
     *  it it challenging to restart the parser at a deeply nested rule
     *  invocation.
     *
     *  Only parser interpreters can override decisions so as to avoid inserting
     *  override checking code in the critical ALL(*) prediction execution path.
     *
     *  @since 4.5
     */ addDecisionOverride(decision, tokenIndex, forcedAlt) {
        this.overrideDecision = decision;
        this.overrideDecisionInputIndex = tokenIndex;
        this.overrideDecisionAlt = forcedAlt;
    }
    get overrideDecisionRoot() {
        return this._overrideDecisionRoot;
    }
    /** Rely on the error handler for this parser but, if no tokens are consumed
     *  to recover, add an error node. Otherwise, nothing is seen in the parse
     *  tree.
     */ recover(e) {
        let i = this._input.index;
        this.errorHandler.recover(this, e);
        if (this._input.index === i) {
            // no input consumed, better add an error node
            let tok = e.getOffendingToken();
            if (!tok) throw new Error("Expected exception to have an offending token");
            let source = tok.tokenSource;
            let stream = source !== undefined ? source.inputStream : undefined;
            let sourcePair = {
                source: source,
                stream: stream
            };
            if (e instanceof $2ITdp.InputMismatchException) {
                let expectedTokens = e.expectedTokens;
                if (expectedTokens === undefined) throw new Error("Expected the exception to provide expected tokens");
                let expectedTokenType = $iLVZN.Token.INVALID_TYPE;
                if (!expectedTokens.isNil) // get any element
                expectedTokenType = expectedTokens.minElement;
                let errToken = this.tokenFactory.create(sourcePair, expectedTokenType, tok.text, $iLVZN.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            } else {
                let source = tok.tokenSource;
                let errToken = this.tokenFactory.create(sourcePair, $iLVZN.Token.INVALID_TYPE, tok.text, $iLVZN.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            }
        }
    }
    recoverInline() {
        return this._errHandler.recoverInline(this);
    }
    /** Return the root of the parse, which can be useful if the parser
     *  bails out. You still can access the top node. Note that,
     *  because of the way left recursive rules add children, it's possible
     *  that the root will not have any children if the start rule immediately
     *  called and left recursive rule that fails.
     *
     * @since 4.5.1
     */ get rootContext() {
        return this._rootContext;
    }
};
$0f496c3a01b188cf$var$__decorate([
    $60gAE.NotNull
], $0f496c3a01b188cf$var$ParserInterpreter.prototype, "_vocabulary", void 0);
$0f496c3a01b188cf$var$__decorate([
    $60gAE.Override
], $0f496c3a01b188cf$var$ParserInterpreter.prototype, "reset", null);
$0f496c3a01b188cf$var$__decorate([
    $60gAE.Override
], $0f496c3a01b188cf$var$ParserInterpreter.prototype, "atn", null);
$0f496c3a01b188cf$var$__decorate([
    $60gAE.Override
], $0f496c3a01b188cf$var$ParserInterpreter.prototype, "vocabulary", null);
$0f496c3a01b188cf$var$__decorate([
    $60gAE.Override
], $0f496c3a01b188cf$var$ParserInterpreter.prototype, "ruleNames", null);
$0f496c3a01b188cf$var$__decorate([
    $60gAE.Override
], $0f496c3a01b188cf$var$ParserInterpreter.prototype, "grammarFileName", null);
$0f496c3a01b188cf$var$__decorate([
    $60gAE.Override
], $0f496c3a01b188cf$var$ParserInterpreter.prototype, "enterRecursionRule", null);
$0f496c3a01b188cf$var$ParserInterpreter = $0f496c3a01b188cf$var$__decorate([
    $0f496c3a01b188cf$var$__param(1, $60gAE.NotNull)
], $0f496c3a01b188cf$var$ParserInterpreter);
module.exports.ParserInterpreter = $0f496c3a01b188cf$var$ParserInterpreter;

});

parcelRegister("29eGm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1907cfa518e9f4a5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContextWithAltNum = void 0;

var $dQ2fw = parcelRequire("dQ2fw");

var $60gAE = parcelRequire("60gAE");

var $gN8af = parcelRequire("gN8af");
/** A handy class for use with
 *
 *  options {contextSuperClass=org.antlr.v4.runtime.RuleContextWithAltNum;}
 *
 *  that provides a backing field / impl for the outer alternative number
 *  matched for an internal parse tree node.
 *
 *  I'm only putting into Java runtime as I'm certain I'm the only one that
 *  will really every use this.
 */ class $1907cfa518e9f4a5$var$RuleContextWithAltNum extends $gN8af.ParserRuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._altNumber = $dQ2fw.ATN.INVALID_ALT_NUMBER;
    }
    get altNumber() {
        return this._altNumber;
    }
    // @Override
    set altNumber(altNum) {
        this._altNumber = altNum;
    }
}
$1907cfa518e9f4a5$var$__decorate([
    $60gAE.Override
], $1907cfa518e9f4a5$var$RuleContextWithAltNum.prototype, "altNumber", null);
module.exports.RuleContextWithAltNum = $1907cfa518e9f4a5$var$RuleContextWithAltNum;

});

parcelRegister("1Bl34", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleDependency = void 0;
/**
 * Declares a dependency upon a grammar rule, along with a set of zero or more dependent rules.
 *
 * Version numbers within a grammar should be assigned on a monotonically increasing basis to allow for accurate
 * tracking of dependent rules.
 *
 * @author Sam Harwell
 */ function $12a992eeb6c5e10d$var$RuleDependency(dependency) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleDependency = $12a992eeb6c5e10d$var$RuleDependency;

});

parcelRegister("h3HYk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleVersion = void 0;
/**
 *
 * @author Sam Harwell
 */ function $c6b4d362de42a572$var$RuleVersion(version) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleVersion = $c6b4d362de42a572$var$RuleVersion;

});

parcelRegister("bDpCo", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fiyYX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("an5fx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("f7WvC", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b034e5235bedd4a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RewriteOperation = module.exports.TokenStreamRewriter = void 0;

var $312SH = parcelRequire("312SH");

var $60gAE = parcelRequire("60gAE");

var $iLVZN = parcelRequire("iLVZN");
/**
 * Useful for rewriting out a buffered input token stream after doing some
 * augmentation or other manipulations on it.
 *
 * You can insert stuff, replace, and delete chunks. Note that the operations
 * are done lazily--only if you convert the buffer to a {@link String} with
 * {@link TokenStream#getText()}. This is very efficient because you are not
 * moving data around all the time. As the buffer of tokens is converted to
 * strings, the {@link #getText()} method(s) scan the input token stream and
 * check to see if there is an operation at the current index. If so, the
 * operation is done and then normal {@link String} rendering continues on the
 * buffer. This is like having multiple Turing machine instruction streams
 * (programs) operating on a single input tape. :)
 *
 * This rewriter makes no modifications to the token stream. It does not ask the
 * stream to fill itself up nor does it advance the input cursor. The token
 * stream `TokenStream.index` will return the same value before and
 * after any {@link #getText()} call.
 *
 * The rewriter only works on tokens that you have in the buffer and ignores the
 * current input cursor. If you are buffering tokens on-demand, calling
 * {@link #getText()} halfway through the input will only do rewrites for those
 * tokens in the first half of the file.
 *
 * Since the operations are done lazily at {@link #getText}-time, operations do
 * not screw up the token index values. That is, an insert operation at token
 * index `i` does not change the index values for tokens
 * `i`+1..n-1.
 *
 * Because operations never actually alter the buffer, you may always get the
 * original token stream back without undoing anything. Since the instructions
 * are queued up, you can easily simulate transactions and roll back any changes
 * if there is an error just by removing instructions. For example,
 *
 * ```
 * CharStream input = new ANTLRFileStream("input");
 * TLexer lex = new TLexer(input);
 * CommonTokenStream tokens = new CommonTokenStream(lex);
 * T parser = new T(tokens);
 * TokenStreamRewriter rewriter = new TokenStreamRewriter(tokens);
 * parser.startRule();
 * ```
 *
 * Then in the rules, you can execute (assuming rewriter is visible):
 *
 * ```
 * Token t,u;
 * ...
 * rewriter.insertAfter(t, "text to put after t");}
 * rewriter.insertAfter(u, "text after u");}
 * System.out.println(rewriter.getText());
 * ```
 *
 * You can also have multiple "instruction streams" and get multiple rewrites
 * from a single pass over the input. Just name the instruction streams and use
 * that name again when printing the buffer. This could be useful for generating
 * a C file and also its header file--all from the same buffer:
 *
 * ```
 * rewriter.insertAfter("pass1", t, "text to put after t");}
 * rewriter.insertAfter("pass2", u, "text after u");}
 * System.out.println(rewriter.getText("pass1"));
 * System.out.println(rewriter.getText("pass2"));
 * ```
 *
 * If you don't use named rewrite streams, a "default" stream is used as the
 * first example shows.
 */ class $b034e5235bedd4a7$var$TokenStreamRewriter {
    constructor(tokens){
        this.tokens = tokens;
        this.programs = new Map();
        this.programs.set($b034e5235bedd4a7$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME, []);
        this.lastRewriteTokenIndexes = new Map();
    }
    getTokenStream() {
        return this.tokens;
    }
    rollback(instructionIndex, programName = $b034e5235bedd4a7$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let is = this.programs.get(programName);
        if (is != null) this.programs.set(programName, is.slice($b034e5235bedd4a7$var$TokenStreamRewriter.MIN_TOKEN_INDEX, instructionIndex));
    }
    deleteProgram(programName = $b034e5235bedd4a7$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        this.rollback($b034e5235bedd4a7$var$TokenStreamRewriter.MIN_TOKEN_INDEX, programName);
    }
    insertAfter(tokenOrIndex, text, programName = $b034e5235bedd4a7$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        // to insert after, just insert before next index (even if past end)
        let rewrites = this.getProgram(programName);
        let op = new $b034e5235bedd4a7$var$InsertAfterOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    insertBefore(tokenOrIndex, text, programName = $b034e5235bedd4a7$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        let rewrites = this.getProgram(programName);
        let op = new $b034e5235bedd4a7$var$InsertBeforeOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    replaceSingle(index, text) {
        if (typeof index === "number") this.replace(index, index, text);
        else this.replace(index, index, text);
    }
    replace(from, to, text, programName = $b034e5235bedd4a7$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (typeof from !== "number") from = from.tokenIndex;
        if (typeof to !== "number") to = to.tokenIndex;
        if (from > to || from < 0 || to < 0 || to >= this.tokens.size) throw new RangeError(`replace: range invalid: ${from}..${to}(size=${this.tokens.size})`);
        let rewrites = this.getProgram(programName);
        let op = new $b034e5235bedd4a7$var$ReplaceOp(this.tokens, from, to, rewrites.length, text);
        rewrites.push(op);
    }
    delete(from, to, programName = $b034e5235bedd4a7$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (to === undefined) to = from;
        if (typeof from === "number") this.replace(from, to, "", programName);
        else this.replace(from, to, "", programName);
    }
    getLastRewriteTokenIndex(programName = $b034e5235bedd4a7$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let I = this.lastRewriteTokenIndexes.get(programName);
        if (I == null) return -1;
        return I;
    }
    setLastRewriteTokenIndex(programName, i) {
        this.lastRewriteTokenIndexes.set(programName, i);
    }
    getProgram(name) {
        let is = this.programs.get(name);
        if (is == null) is = this.initializeProgram(name);
        return is;
    }
    initializeProgram(name) {
        let is = [];
        this.programs.set(name, is);
        return is;
    }
    getText(intervalOrProgram, programName = $b034e5235bedd4a7$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let interval;
        if (intervalOrProgram instanceof $312SH.Interval) interval = intervalOrProgram;
        else interval = $312SH.Interval.of(0, this.tokens.size - 1);
        if (typeof intervalOrProgram === "string") programName = intervalOrProgram;
        let rewrites = this.programs.get(programName);
        let start = interval.a;
        let stop = interval.b;
        // ensure start/end are in range
        if (stop > this.tokens.size - 1) stop = this.tokens.size - 1;
        if (start < 0) start = 0;
        if (rewrites == null || rewrites.length === 0) return this.tokens.getText(interval); // no instructions to execute
        let buf = [];
        // First, optimize instruction stream
        let indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
        // Walk buffer, executing instructions and emitting tokens
        let i = start;
        while(i <= stop && i < this.tokens.size){
            let op = indexToOp.get(i);
            indexToOp.delete(i); // remove so any left have index size-1
            let t = this.tokens.get(i);
            if (op == null) {
                // no operation at that index, just dump token
                if (t.type !== $iLVZN.Token.EOF) buf.push(String(t.text));
                i++; // move to next token
            } else i = op.execute(buf); // execute operation and skip
        }
        // include stuff after end if it's last index in buffer
        // So, if they did an insertAfter(lastValidIndex, "foo"), include
        // foo if end==lastValidIndex.
        if (stop === this.tokens.size - 1) {
            // Scan any remaining operations after last token
            // should be included (they will be inserts).
            for (let op of indexToOp.values())if (op.index >= this.tokens.size - 1) buf.push(op.text.toString());
        }
        return buf.join("");
    }
    /** We need to combine operations and report invalid operations (like
     *  overlapping replaces that are not completed nested). Inserts to
     *  same index need to be combined etc...  Here are the cases:
     *
     *  I.i.u I.j.v								leave alone, nonoverlapping
     *  I.i.u I.i.v								combine: Iivu
     *
     *  R.i-j.u R.x-y.v	| i-j in x-y			delete first R
     *  R.i-j.u R.i-j.v							delete first R
     *  R.i-j.u R.x-y.v	| x-y in i-j			ERROR
     *  R.i-j.u R.x-y.v	| boundaries overlap	ERROR
     *
     *  Delete special case of replace (text==undefined):
     *  D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
     *
     *  I.i.u R.x-y.v | i in (x+1)-y			delete I (since insert before
     * 											we're not deleting i)
     *  I.i.u R.x-y.v | i not in (x+1)-y		leave alone, nonoverlapping
     *  R.x-y.v I.i.u | i in x-y				ERROR
     *  R.x-y.v I.x.u 							R.x-y.uv (combine, delete I)
     *  R.x-y.v I.i.u | i not in x-y			leave alone, nonoverlapping
     *
     *  I.i.u = insert u before op @ index i
     *  R.x-y.u = replace x-y indexed tokens with u
     *
     *  First we need to examine replaces. For any replace op:
     *
     * 		1. wipe out any insertions before op within that range.
     * 		2. Drop any replace op before that is contained completely within
     * 	 that range.
     * 		3. Throw exception upon boundary overlap with any previous replace.
     *
     *  Then we can deal with inserts:
     *
     * 		1. for any inserts to same index, combine even if not adjacent.
     * 		2. for any prior replace with same left boundary, combine this
     * 	 insert with replace and delete this replace.
     * 		3. throw exception if index in same range as previous replace
     *
     *  Don't actually delete; make op undefined in list. Easier to walk list.
     *  Later we can throw as we add to index &rarr; op map.
     *
     *  Note that I.2 R.2-2 will wipe out I.2 even though, technically, the
     *  inserted stuff would be before the replace range. But, if you
     *  add tokens in front of a method body '{' and then delete the method
     *  body, I think the stuff before the '{' you added should disappear too.
     *
     *  Return a map from token index to operation.
     */ reduceToSingleOperationPerIndex(rewrites) {
        // console.log(`rewrites=[${Utils.join(rewrites, ", ")}]`);
        // WALK REPLACES
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $b034e5235bedd4a7$var$ReplaceOp)) continue;
            let rop = op;
            // Wipe prior inserts within range
            let inserts = this.getKindOfOps(rewrites, $b034e5235bedd4a7$var$InsertBeforeOp, i);
            for (let iop of inserts){
                if (iop.index === rop.index) {
                    // E.g., insert before 2, delete 2..2; update replace
                    // text to include insert before, kill insert
                    rewrites[iop.instructionIndex] = undefined;
                    rop.text = iop.text.toString() + (rop.text != null ? rop.text.toString() : "");
                } else if (iop.index > rop.index && iop.index <= rop.lastIndex) // delete insert as it's a no-op.
                rewrites[iop.instructionIndex] = undefined;
            }
            // Drop any prior replaces contained within
            let prevReplaces = this.getKindOfOps(rewrites, $b034e5235bedd4a7$var$ReplaceOp, i);
            for (let prevRop of prevReplaces){
                if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
                    // delete replace as it's a no-op.
                    rewrites[prevRop.instructionIndex] = undefined;
                    continue;
                }
                // throw exception unless disjoint or identical
                let disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
                // Delete special case of replace (text==null):
                // D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
                if (prevRop.text == null && rop.text == null && !disjoint) {
                    // console.log(`overlapping deletes: ${prevRop}, ${rop}`);
                    rewrites[prevRop.instructionIndex] = undefined; // kill first delete
                    rop.index = Math.min(prevRop.index, rop.index);
                    rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
                // console.log(`new rop ${rop}`);
                } else if (!disjoint) throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
            }
        }
        // WALK INSERTS
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $b034e5235bedd4a7$var$InsertBeforeOp)) continue;
            let iop = op;
            // combine current insert with prior if any at same index
            let prevInserts = this.getKindOfOps(rewrites, $b034e5235bedd4a7$var$InsertBeforeOp, i);
            for (let prevIop of prevInserts)if (prevIop.index === iop.index) {
                if (prevIop instanceof $b034e5235bedd4a7$var$InsertAfterOp) {
                    iop.text = this.catOpText(prevIop.text, iop.text);
                    rewrites[prevIop.instructionIndex] = undefined;
                } else if (prevIop instanceof $b034e5235bedd4a7$var$InsertBeforeOp) {
                    // convert to strings...we're in process of toString'ing
                    // whole token buffer so no lazy eval issue with any templates
                    iop.text = this.catOpText(iop.text, prevIop.text);
                    // delete redundant prior insert
                    rewrites[prevIop.instructionIndex] = undefined;
                }
            }
            // look for replaces where iop.index is in range; error
            let prevReplaces = this.getKindOfOps(rewrites, $b034e5235bedd4a7$var$ReplaceOp, i);
            for (let rop of prevReplaces){
                if (iop.index === rop.index) {
                    rop.text = this.catOpText(iop.text, rop.text);
                    rewrites[i] = undefined; // delete current insert
                    continue;
                }
                if (iop.index >= rop.index && iop.index <= rop.lastIndex) throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
            }
        }
        // console.log(`rewrites after=[${Utils.join(rewrites, ", ")}]`);
        let m = new Map();
        for (let op of rewrites){
            if (op == null) continue;
            if (m.get(op.index) != null) throw new Error("should only be one op per index");
            m.set(op.index, op);
        }
        // console.log(`index to op: ${m}`);
        return m;
    }
    catOpText(a, b) {
        let x = "";
        let y = "";
        if (a != null) x = a.toString();
        if (b != null) y = b.toString();
        return x + y;
    }
    /** Get all operations before an index of a particular kind */ getKindOfOps(rewrites, kind, before) {
        let ops = [];
        for(let i = 0; i < before && i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (op instanceof kind) ops.push(op);
        }
        return ops;
    }
}
module.exports.TokenStreamRewriter = $b034e5235bedd4a7$var$TokenStreamRewriter;
$b034e5235bedd4a7$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME = "default";
$b034e5235bedd4a7$var$TokenStreamRewriter.PROGRAM_INIT_SIZE = 100;
$b034e5235bedd4a7$var$TokenStreamRewriter.MIN_TOKEN_INDEX = 0;
// Define the rewrite operation hierarchy
class $b034e5235bedd4a7$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        this.tokens = tokens;
        this.instructionIndex = instructionIndex;
        this.index = index;
        this.text = text === undefined ? "" : text;
    }
    /** Execute the rewrite operation by possibly adding to the buffer.
     *  Return the index of the next token to operate on.
     */ execute(buf) {
        return this.index;
    }
    toString() {
        let opName = this.constructor.name;
        let $index = opName.indexOf("$");
        opName = opName.substring($index + 1, opName.length);
        return "<" + opName + "@" + this.tokens.get(this.index) + ":\"" + this.text + "\">";
    }
}
$b034e5235bedd4a7$var$__decorate([
    $60gAE.Override
], $b034e5235bedd4a7$var$RewriteOperation.prototype, "toString", null);
module.exports.RewriteOperation = $b034e5235bedd4a7$var$RewriteOperation;
class $b034e5235bedd4a7$var$InsertBeforeOp extends $b034e5235bedd4a7$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index, instructionIndex, text);
    }
    execute(buf) {
        buf.push(this.text.toString());
        if (this.tokens.get(this.index).type !== $iLVZN.Token.EOF) buf.push(String(this.tokens.get(this.index).text));
        return this.index + 1;
    }
}
$b034e5235bedd4a7$var$__decorate([
    $60gAE.Override
], $b034e5235bedd4a7$var$InsertBeforeOp.prototype, "execute", null);
/** Distinguish between insert after/before to do the "insert afters"
 *  first and then the "insert befores" at same index. Implementation
 *  of "insert after" is "insert before index+1".
 */ class $b034e5235bedd4a7$var$InsertAfterOp extends $b034e5235bedd4a7$var$InsertBeforeOp {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index + 1, instructionIndex, text); // insert after is insert before index+1
    }
}
/** I'm going to try replacing range from x..y with (y-x)+1 ReplaceOp
 *  instructions.
 */ class $b034e5235bedd4a7$var$ReplaceOp extends $b034e5235bedd4a7$var$RewriteOperation {
    constructor(tokens, from, to, instructionIndex, text){
        super(tokens, from, instructionIndex, text);
        this.lastIndex = to;
    }
    execute(buf) {
        if (this.text != null) buf.push(this.text.toString());
        return this.lastIndex + 1;
    }
    toString() {
        if (this.text == null) return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
        return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ":\"" + this.text + "\">";
    }
}
$b034e5235bedd4a7$var$__decorate([
    $60gAE.Override
], $b034e5235bedd4a7$var$ReplaceOp.prototype, "execute", null);
$b034e5235bedd4a7$var$__decorate([
    $60gAE.Override
], $b034e5235bedd4a7$var$ReplaceOp.prototype, "toString", null);

});

parcelRegister("c8fWz", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gnNeB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("9G9l9", function(module, exports) {
$parcel$export(module.exports, "JQLLexer", () => $6dcaf930f1fe9510$export$375c79404cc64c7f);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLLexer.g4 by ANTLR 4.7.3-SNAPSHOT

var $1HaB7 = parcelRequire("1HaB7");

var $ipeIv = parcelRequire("ipeIv");

var $7yK40 = parcelRequire("7yK40");

var $7DbrH = parcelRequire("7DbrH");

var $5lo68 = parcelRequire("5lo68");
class $6dcaf930f1fe9510$export$375c79404cc64c7f extends (0, $ipeIv.Lexer) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.QUOTED_STR = 1;
    }
    static{
        this.SQUOTED_STR = 2;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.channelNames = [
            'DEFAULT_TOKEN_CHANNEL',
            'HIDDEN'
        ];
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.modeNames = [
            'DEFAULT_MODE',
            'QUOTED_STR',
            'SQUOTED_STR'
        ];
    }
    static{
        this.ruleNames = [
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'LQUOTE',
            'LSQUOTE',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'QUOTED_CONTENT',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'SQUOTED_CONTENT',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING',
            'VALID_UNQUOTED_CHARS',
            'VALID_QUOTED_CHARS',
            'VALID_SQUOTED_CHARS',
            'RESERVED_CHARS',
            'QUOTE',
            'SQUOTE',
            'BSLASH',
            'NL',
            'CR',
            'SPACE',
            'AMPER',
            'AMPER_AMPER',
            'PIPE',
            'PIPE_PIPE',
            'ESCAPE',
            'NEWLINE',
            'HEXDIGIT',
            'WS',
            'MINUS',
            'DIGIT',
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $7DbrH.VocabularyImpl)($6dcaf930f1fe9510$export$375c79404cc64c7f._LITERAL_NAMES, $6dcaf930f1fe9510$export$375c79404cc64c7f._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $6dcaf930f1fe9510$export$375c79404cc64c7f.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    constructor(input){
        super(input);
        this._interp = new (0, $7yK40.LexerATNSimulator)($6dcaf930f1fe9510$export$375c79404cc64c7f._ATN, this);
    }
    // @Override
    get grammarFileName() {
        return 'JQLLexer.g4';
    }
    // @Override
    get ruleNames() {
        return $6dcaf930f1fe9510$export$375c79404cc64c7f.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $6dcaf930f1fe9510$export$375c79404cc64c7f._serializedATN;
    }
    // @Override
    get channelNames() {
        return $6dcaf930f1fe9510$export$375c79404cc64c7f.channelNames;
    }
    // @Override
    get modeNames() {
        return $6dcaf930f1fe9510$export$375c79404cc64c7f.modeNames;
    }
    static{
        this._serializedATNSegments = 3;
    }
    static{
        this._serializedATNSegment0 = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x020\u062E\b\x01\b\x01\b\x01\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04\"	\"\x04#	#\x04$	$\x04%	%\x04&	&\x04'	'\x04(	(\x04)	)\x04*	*\x04+	+\x04,	,\x04-	-\x04.	.\x04/	/\x040	0\x041	1\x042	2\x043	3\x044	4\x045	5\x046	6\x047	7\x048	8\x049	9\x04:	:\x04;	;\x04<	<\x04=	=\x04>	>\x04?	?\x04@	@\x04A	A\x04B	B\x04C	C\x04D	D\x04E	E\x04F	F\x04G	G\x04H	H\x04I	I\x04J	J\x04K	K\x04L	L\x04M	M\x04N	N\x04O	O\x04P	P\x04Q	Q\x04R	R\x04S	S\x04T	T\x04U	U\x04V	V\x04W	W\x04X	X\x04Y	Y\x04Z	Z\x04[	[\x04\\	\\\x04]	]\x04^	^\x04_	_\x04`	`\x04a	a\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03	\x03	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0e\x03\x0e\x03\x0f\x03\x0f\x03\x0f\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\xfc\n\x14\x03\x15\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u0103\n\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\u0114\n\x17\x03\x18\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03 \x03 \x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03$\x06$\u0154\n$\r$\x0e$\u0155\x03%\x03%\x06%\u015A\n%\r%\x0e%\u015B\x03&\x03&\x03&\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x05'\u0582\n'\x03(\x03(\x06(\u0586\n(\r(\x0e(\u0587\x03)\x06)\u058B\n)\r)\x0e)\u058C\x03)\x03)\x03*\x03*\x03+\x03+\x03,\x03,\x03,\x03,\x03-\x03-\x05-\u059B\n-\x03-\x03-\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x030\x030\x030\x030\x031\x031\x051\u05AD\n1\x031\x031\x032\x032\x032\x032\x033\x033\x033\x033\x034\x034\x035\x035\x036\x036\x037\x037\x038\x038\x039\x039\x03:\x03:\x03;\x03;\x03<\x03<\x03=\x03=\x03>\x03>\x03?\x03?\x03?\x03@\x03@\x03A\x03A\x03A\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x05B\u05E3\nB\x03C\x03C\x05C\u05E7\nC\x03D\x03D\x03D\x03D\x03D\x03D\x03D\x05D\u05F0\nD\x03E\x03E\x03E\x05E\u05F5\nE\x03F\x03F\x03G\x03G\x03H\x03H\x03I\x03I\x03J\x03J\x03K\x03K\x03L\x03L\x03M\x03M\x03N\x03N\x03O\x03O\x03P\x03P\x03Q\x03Q\x03R\x03R\x03S\x03S\x03T\x03T\x03U\x03U\x03V\x03V\x03W\x03W\x03X\x03X\x03Y\x03Y\x03Z\x03Z\x03[\x03[\x03\\\x03\\\x03]\x03]\x03^\x03^\x03_\x03_\x03`\x03`\x03a\x03a\x02\x02\x02b\x05\x02\x03\x07\x02\x04	\x02\x05\v\x02\x06\r\x02\x07\x0f\x02\x02\x11\x02\x02\x13\x02\b\x15\x02	\x17\x02\n\x19\x02\v\x1b\x02\f\x1d\x02\r\x1f\x02\x0e!\x02\x0f#\x02\x10%\x02\x11'\x02\x12)\x02\x13+\x02\x14-\x02\x15/\x02\x161\x02\x173\x02\x185\x02\x197\x02\x1a9\x02\x1b;\x02\x1c=\x02\x1d?\x02\x1eA\x02\x1fC\x02 E\x02!G\x02\"I\x02#K\x02$M\x02%O\x02&Q\x02'S\x02(U\x02)W\x02*Y\x02+[\x02\x02]\x02,_\x02-a\x02.c\x02\x02e\x02/g\x020i\x02\x02k\x02\x02m\x02\x02o\x02\x02q\x02\x02s\x02\x02u\x02\x02w\x02\x02y\x02\x02{\x02\x02}\x02\x02\x7f\x02\x02\x81\x02\x02\x83\x02\x02\x85\x02\x02\x87\x02\x02\x89\x02\x02\x8b\x02\x02\x8d\x02\x02\x8f\x02\x02\x91\x02\x02\x93\x02\x02\x95\x02\x02\x97\x02\x02\x99\x02\x02\x9b\x02\x02\x9d\x02\x02\x9f\x02\x02\xa1\x02\x02\xa3\x02\x02\xa5\x02\x02\xa7\x02\x02\xa9\x02\x02\xab\x02\x02\xad\x02\x02\xaf\x02\x02\xb1\x02\x02\xb3\x02\x02\xb5\x02\x02\xb7\x02\x02\xb9\x02\x02\xbb\x02\x02\xbd\x02\x02\xbf\x02\x02\xc1\x02\x02\xc3\x02\x02\x05\x02\x03\x04\"	\x02\x02.11=B]`}\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!$$^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!))^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02%',-11==AB``}}\x7f\x7f\x05\x02ppttvv\x03\x022;\x04\x02CCcc\x04\x02DDdd\x04\x02EEee\x04\x02FFff\x04\x02GGgg\x04\x02HHhh\x04\x02IIii\x04\x02JJjj\x04\x02KKkk\x04\x02LLll\x04\x02MMmm\x04\x02NNnn\x04\x02OOoo\x04\x02PPpp\x04\x02QQqq\x04\x02RRrr\x04\x02SSss\x04\x02TTtt\x04\x02UUuu\x04\x02VVvv\x04\x02WWww\x04\x02XXxx\x04\x02YYyy\x04\x02ZZzz\x04\x02[[{{\x04\x02\\\\||\x02\u06B5\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02	\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0f\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1b\x03\x02\x02\x02\x02\x1d\x03\x02\x02\x02\x02\x1f\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x03Y\x03\x02\x02\x02\x03[\x03\x02\x02\x02\x03]\x03\x02\x02\x02\x03_\x03\x02\x02\x02\x04a\x03\x02\x02\x02\x04c\x03\x02\x02\x02\x04e\x03\x02\x02\x02\x04g\x03\x02\x02\x02\x05\xc5\x03\x02\x02\x02\x07\xc7\x03\x02\x02\x02	\xc9\x03\x02\x02\x02\v\xcb\x03\x02\x02\x02\r\xcd\x03\x02\x02\x02\x0f\xcf\x03\x02\x02\x02\x11\xd4\x03\x02\x02\x02\x13\xd9\x03\x02\x02\x02\x15\xdb\x03\x02\x02\x02\x17\xdd\x03\x02\x02\x02\x19\xdf\x03\x02\x02\x02\x1b\xe2\x03\x02\x02\x02\x1d\xe5\x03\x02\x02\x02\x1f\xe7\x03\x02\x02\x02!\xea\x03\x02\x02\x02#\xec\x03\x02\x02\x02%\xef\x03\x02\x02\x02'\xf2\x03\x02\x02\x02)\xfb\x03\x02\x02\x02+\u0102\x03\x02\x02\x02-\u0104\x03\x02\x02\x02/\u0113\x03\x02\x02\x021\u0115\x03\x02\x02\x023\u0119\x03\x02\x02\x025\u0121\x03\x02\x02\x027\u0128\x03\x02\x02\x029\u012E\x03\x02\x02\x02;\u0133\x03\x02\x02\x02=\u0136\x03\x02\x02\x02?\u0139\x03\x02\x02\x02A\u0140\x03\x02\x02\x02C\u0146\x03\x02\x02\x02E\u0149\x03\x02\x02\x02G\u014D\x03\x02\x02\x02I\u0153\x03\x02\x02\x02K\u0157\x03\x02\x02\x02M\u015D\x03\x02\x02\x02O\u0581\x03\x02\x02\x02Q\u0585\x03\x02\x02\x02S\u058A\x03\x02\x02\x02U\u0590\x03\x02\x02\x02W\u0592\x03\x02\x02\x02Y\u0594\x03\x02\x02\x02[\u059A\x03\x02\x02\x02]\u059E\x03\x02\x02\x02_\u05A2\x03\x02\x02\x02a\u05A6\x03\x02\x02\x02c\u05AC\x03\x02\x02\x02e\u05B0\x03\x02\x02\x02g\u05B4\x03\x02\x02\x02i\u05B8\x03\x02\x02\x02k\u05BA\x03\x02\x02\x02m\u05BC\x03\x02\x02\x02o\u05BE\x03\x02\x02\x02q\u05C0\x03\x02\x02\x02s\u05C2\x03\x02\x02\x02u\u05C4\x03\x02\x02\x02w\u05C6\x03\x02\x02\x02y\u05C8\x03\x02\x02\x02{\u05CA\x03\x02\x02\x02}\u05CC\x03\x02\x02\x02\x7f\u05CE\x03\x02\x02\x02\x81\u05D1\x03\x02\x02\x02\x83\u05D3\x03\x02\x02\x02\x85\u05D6\x03\x02\x02\x02\x87\u05E6\x03\x02\x02\x02\x89\u05EF\x03\x02\x02\x02\x8b\u05F4\x03\x02\x02\x02\x8d\u05F6\x03\x02\x02\x02\x8f\u05F8\x03\x02\x02\x02\x91\u05FA\x03\x02\x02\x02\x93\u05FC\x03\x02\x02\x02\x95\u05FE\x03\x02\x02\x02\x97\u0600\x03\x02\x02\x02\x99\u0602\x03\x02\x02\x02\x9b\u0604\x03\x02\x02\x02\x9d\u0606\x03\x02\x02\x02\x9f\u0608\x03\x02\x02\x02\xa1\u060A\x03\x02\x02\x02\xa3\u060C\x03\x02\x02\x02\xa5\u060E\x03\x02\x02\x02\xa7\u0610\x03\x02\x02\x02\xa9\u0612\x03\x02\x02\x02\xab\u0614\x03\x02\x02\x02\xad\u0616\x03\x02\x02\x02\xaf\u0618\x03\x02\x02\x02\xb1\u061A\x03\x02\x02\x02\xb3\u061C\x03\x02\x02\x02\xb5\u061E\x03\x02\x02\x02\xb7\u0620\x03\x02\x02\x02\xb9\u0622\x03\x02\x02\x02\xbb\u0624\x03\x02\x02\x02\xbd\u0626\x03\x02\x02\x02\xbf\u0628\x03\x02\x02\x02\xc1\u062A\x03\x02\x02\x02\xc3\u062C\x03\x02\x02\x02\xc5\xc6\x07*\x02\x02\xc6\x06\x03\x02\x02\x02\xc7\xc8\x07+\x02\x02\xc8\b\x03\x02\x02\x02\xc9\xca\x07.\x02\x02\xca\n\x03\x02\x02\x02\xcb\xcc\x07]\x02\x02\xcc\f\x03\x02\x02\x02\xcd\xce\x07_\x02\x02\xce\x0e\x03\x02\x02\x02\xcf\xd0\x05q8\x02\xd0\xd1\x03\x02\x02\x02\xd1\xd2\b\x07\x02\x02\xd2\xd3\b\x07\x03\x02\xd3\x10\x03\x02\x02\x02\xd4\xd5\x05s9\x02\xd5\xd6\x03\x02\x02\x02\xd6\xd7\b\b\x02\x02\xd7\xd8\b\b\x04\x02\xd8\x12\x03\x02\x02\x02\xd9\xda\x07#\x02\x02\xda\x14\x03\x02\x02\x02\xdb\xdc\x07>\x02\x02\xdc\x16\x03\x02\x02\x02\xdd\xde\x07@\x02\x02\xde\x18\x03\x02\x02\x02\xdf\xe0\x07@\x02\x02\xe0\xe1\x07?\x02\x02\xe1\x1a\x03\x02\x02\x02\xe2\xe3\x07>\x02\x02\xe3\xe4\x07?\x02\x02\xe4\x1c\x03\x02\x02\x02\xe5\xe6\x07?\x02\x02\xe6\x1e\x03\x02\x02\x02\xe7\xe8\x07#\x02\x02\xe8\xe9\x07?\x02\x02\xe9 \x03\x02\x02\x02\xea\xeb\x07\x80\x02\x02\xeb\"\x03\x02\x02\x02\xec\xed\x07#\x02\x02\xed\xee\x07\x80\x02\x02\xee$\x03\x02\x02\x02\xef\xf0\x05\xa1P\x02\xf0\xf1\x05\xabU\x02\xf1&\x03\x02\x02\x02\xf2\xf3\x05\xa1P\x02\xf3\xf4\x05\xb5Z\x02\xf4(\x03\x02\x02\x02\xf5\xf6\x05\x91H\x02\xf6\xf7\x05\xabU\x02\xf7\xf8\x05\x97K\x02\xf8\xfc\x03\x02\x02\x02\xf9\xfc\x05}>\x02\xfa\xfc\x05\x7f?\x02\xfb\xf5\x03\x02\x02\x02\xfb\xf9\x03\x02\x02\x02\xfb\xfa\x03\x02\x02\x02\xfc*\x03\x02\x02\x02\xfd\xfe\x05\xadV\x02\xfe\xff\x05\xb3Y\x02\xff\u0103\x03\x02\x02\x02\u0100\u0103\x05\x81@\x02\u0101\u0103\x05\x83A\x02\u0102\xfd\x03\x02\x02\x02\u0102\u0100\x03\x02\x02\x02\u0102\u0101\x03\x02\x02\x02\u0103";
    }
    static{
        this._serializedATNSegment1 = ",\x03\x02\x02\x02\u0104\u0105\x05\xabU\x02\u0105\u0106\x05\xadV\x02\u0106\u0107\x05\xb7[\x02\u0107.\x03\x02\x02\x02\u0108\u0109\x05\x99L\x02\u0109\u010A\x05\xa9T\x02\u010A\u010B\x05\xafW\x02\u010B\u010C\x05\xb7[\x02\u010C\u010D\x05\xc1`\x02\u010D\u0114\x03\x02\x02\x02\u010E\u010F\x05\xabU\x02\u010F\u0110\x05\xb9\\\x02\u0110\u0111\x05\xa7S\x02\u0111\u0112\x05\xa7S\x02\u0112\u0114\x03\x02\x02\x02\u0113\u0108\x03\x02\x02\x02\u0113\u010E\x03\x02\x02\x02\u01140\x03\x02\x02\x02\u0115\u0116\x05\xbd^\x02\u0116\u0117\x05\x91H\x02\u0117\u0118\x05\xb5Z\x02\u01182\x03\x02\x02\x02\u0119\u011A\x05\x95J\x02\u011A\u011B\x05\x9fO\x02\u011B\u011C\x05\x91H\x02\u011C\u011D\x05\xabU\x02\u011D\u011E\x05\x9dN\x02\u011E\u011F\x05\x99L\x02\u011F\u0120\x05\x97K\x02\u01204\x03\x02\x02\x02\u0121\u0122\x05\x93I\x02\u0122\u0123\x05\x99L\x02\u0123\u0124\x05\x9bM\x02\u0124\u0125\x05\xadV\x02\u0125\u0126\x05\xb3Y\x02\u0126\u0127\x05\x99L\x02\u01276\x03\x02\x02\x02\u0128\u0129\x05\x91H\x02\u0129\u012A\x05\x9bM\x02\u012A\u012B\x05\xb7[\x02\u012B\u012C\x05\x99L\x02\u012C\u012D\x05\xb3Y\x02\u012D8\x03\x02\x02\x02\u012E\u012F\x05\x9bM\x02\u012F\u0130\x05\xb3Y\x02\u0130\u0131\x05\xadV\x02\u0131\u0132\x05\xa9T\x02\u0132:\x03\x02\x02\x02\u0133\u0134\x05\xb7[\x02\u0134\u0135\x05\xadV\x02\u0135<\x03\x02\x02\x02\u0136\u0137\x05\xadV\x02\u0137\u0138\x05\xabU\x02\u0138>\x03\x02\x02\x02\u0139\u013A\x05\x97K\x02\u013A\u013B\x05\xb9\\\x02\u013B\u013C\x05\xb3Y\x02\u013C\u013D\x05\xa1P\x02\u013D\u013E\x05\xabU\x02\u013E\u013F\x05\x9dN\x02\u013F@\x03\x02\x02\x02\u0140\u0141\x05\xadV\x02\u0141\u0142\x05\xb3Y\x02\u0142\u0143\x05\x97K\x02\u0143\u0144\x05\x99L\x02\u0144\u0145\x05\xb3Y\x02\u0145B\x03\x02\x02\x02\u0146\u0147\x05\x93I\x02\u0147\u0148\x05\xc1`\x02\u0148D\x03\x02\x02\x02\u0149\u014A\x05\x91H\x02\u014A\u014B\x05\xb5Z\x02\u014B\u014C\x05\x95J\x02\u014CF\x03\x02\x02\x02\u014D\u014E\x05\x97K\x02\u014E\u014F\x05\x99L\x02\u014F\u0150\x05\xb5Z\x02\u0150\u0151\x05\x95J\x02\u0151H\x03\x02\x02\x02\u0152\u0154\x05\x8fG\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02\u0156J\x03\x02\x02\x02\u0157\u0159\x05\x8dF\x02\u0158\u015A\x05\x8fG\x02\u0159\u0158\x03\x02\x02\x02\u015A\u015B\x03\x02\x02\x02\u015B\u0159\x03\x02\x02\x02\u015B\u015C\x03\x02\x02\x02\u015CL\x03\x02\x02\x02\u015D\u015E\x05\x95J\x02\u015E\u015F\x05\x9bM\x02\u015FN\x03\x02\x02\x02\u0160\u0161\x05\x91H\x02\u0161\u0162\x05\x93I\x02\u0162\u0163\x05\xadV\x02\u0163\u0164\x05\xb3Y\x02\u0164\u0165\x05\xb7[\x02\u0165\u0582\x03\x02\x02\x02\u0166\u0167\x05\x91H\x02\u0167\u0168\x05\x95J\x02\u0168\u0169\x05\x95J\x02\u0169\u016A\x05\x99L\x02\u016A\u016B\x05\xb5Z\x02\u016B\u016C\x05\xb5Z\x02\u016C\u0582\x03\x02\x02\x02\u016D\u016E\x05\x91H\x02\u016E\u016F\x05\x97K\x02\u016F\u0170\x05\x97K\x02\u0170\u0582\x03\x02\x02\x02\u0171\u0172\x05\x91H\x02\u0172\u0173\x05\xa7S\x02\u0173\u0174\x05\xa1P\x02\u0174\u0175\x05\x91H\x02\u0175\u0176\x05\xb5Z\x02\u0176\u0582\x03\x02\x02\x02\u0177\u0178\x05\x91H\x02\u0178\u0179\x05\xa7S\x02\u0179\u017A\x05\xb7[\x02\u017A\u017B\x05\x99L\x02\u017B\u017C\x05\xb3Y\x02\u017C\u0582\x03\x02\x02\x02\u017D\u017E\x05\x91H\x02\u017E\u017F\x05\xabU\x02\u017F\u0180\x05\xc1`\x02\u0180\u0582\x03\x02\x02\x02\u0181\u0182\x05\x91H\x02\u0182\u0183\x05\xb5Z\x02\u0183\u0582\x03\x02\x02\x02\u0184\u0185\x05\x91H\x02\u0185\u0186\x05\xb9\\\x02\u0186\u0187\x05\x97K\x02\u0187\u0188\x05\xa1P\x02\u0188\u0189\x05\xb7[\x02\u0189\u0582\x03\x02\x02\x02\u018A\u018B\x05\x91H\x02\u018B\u018C\x05\xbb]\x02\u018C\u018D\x05\x9dN\x02\u018D\u0582\x03\x02\x02\x02\u018E\u018F\x05\x93I\x02\u018F\u0190\x05\x99L\x02\u0190\u0191\x05\x9dN\x02\u0191\u0192\x05\xa1P\x02\u0192\u0193\x05\xabU\x02\u0193\u0582\x03\x02\x02\x02\u0194\u0195\x05\x93I\x02\u0195\u0196\x05\x99L\x02\u0196\u0197\x05\xb7[\x02\u0197\u0198\x05\xbd^\x02\u0198\u0199\x05\x99L\x02\u0199\u019A\x05\x99L\x02\u019A\u019B\x05\xabU\x02\u019B\u0582\x03\x02\x02\x02\u019C\u019D\x05\x93I\x02\u019D\u019E\x05\xadV\x02\u019E\u019F\x05\xadV\x02\u019F\u01A0\x05\xa7S\x02\u01A0\u01A1\x05\x99L\x02\u01A1\u01A2\x05\x91H\x02\u01A2\u01A3\x05\xabU\x02\u01A3\u0582\x03\x02\x02\x02\u01A4\u01A5\x05\x93I\x02\u01A5\u01A6\x05\xb3Y\x02\u01A6\u01A7\x05\x99L\x02\u01A7\u01A8\x05\x91H\x02\u01A8\u01A9\x05\xa5R\x02\u01A9\u0582\x03\x02\x02\x02\u01AA\u01AB\x05\x93I\x02\u01AB\u01AC\x05\xc1`\x02\u01AC\u01AD\x05\xb7[\x02\u01AD\u01AE\x05\x99L\x02\u01AE\u0582\x03\x02\x02\x02\u01AF\u01B0\x05\x95J\x02\u01B0\u01B1\x05\x91H\x02\u01B1\u01B2\x05\xb7[\x02\u01B2\u01B3\x05\x95J\x02\u01B3\u01B4\x05\x9fO\x02\u01B4\u0582\x03\x02\x02\x02\u01B5\u01B6\x05\x95J\x02\u01B6\u01B7\x05\x9fO\x02\u01B7\u01B8\x05\x91H\x02\u01B8\u01B9\x05\xb3Y\x02\u01B9\u0582\x03\x02\x02\x02\u01BA\u01BB\x05\x95J\x02\u01BB\u01BC\x05\x9fO\x02\u01BC\u01BD\x05\x91H\x02\u01BD\u01BE\x05\xb3Y\x02\u01BE\u01BF\x05\x91H\x02\u01BF\u01C0\x05\x95J\x02\u01C0\u01C1\x05\xb7[\x02\u01C1\u01C2\x05\x99L\x02\u01C2\u01C3\x05\xb3Y\x02\u01C3\u0582\x03\x02\x02\x02\u01C4\u01C5\x05\x95J\x02\u01C5\u01C6\x05\x9fO\x02\u01C6\u01C7\x05\x99L\x02\u01C7\u01C8\x05\x95J\x02\u01C8\u01C9\x05\xa5R\x02\u01C9\u0582\x03\x02\x02\x02\u01CA\u01CB\x05\x95J\x02\u01CB\u01CC\x05\x9fO\x02\u01CC\u01CD\x05\x99L\x02\u01CD\u01CE\x05\x95J\x02\u01CE\u01CF\x05\xa5R\x02\u01CF\u01D0\x05\xafW\x02\u01D0\u01D1\x05\xadV\x02\u01D1\u01D2\x05\xa1P\x02\u01D2\u01D3\x05\xabU\x02\u01D3\u01D4\x05\xb7[\x02\u01D4\u0582\x03\x02\x02\x02\u01D5\u01D6\x05\x95J\x02\u01D6\u01D7\x05\xadV\x02\u01D7\u01D8\x05\xa7S\x02\u01D8\u01D9\x05\xa7S\x02\u01D9\u01DA\x05\x91H\x02\u01DA\u01DB\x05\xb7[\x02\u01DB\u01DC\x05\x99L\x02\u01DC\u0582\x03\x02\x02\x02\u01DD\u01DE\x05\x95J\x02\u01DE\u01DF\x05\xadV\x02\u01DF\u01E0\x05\xa7S\x02\u01E0\u01E1\x05\xa7S\x02\u01E1\u01E2\x05\x91H\x02\u01E2\u01E3\x05\xb7[\x02\u01E3\u01E4\x05\xa1P\x02\u01E4\u01E5\x05\xadV\x02\u01E5\u01E6\x05\xabU\x02\u01E6\u0582\x03\x02\x02\x02\u01E7\u01E8\x05\x95J\x02\u01E8\u01E9\x05\xadV\x02\u01E9\u01EA\x05\xa7S\x02\u01EA\u01EB\x05\xb9\\\x02\u01EB\u01EC\x05\xa9T\x02\u01EC\u01ED\x05\xabU\x02\u01ED\u0582\x03\x02\x02\x02\u01EE\u01EF\x05\x95J\x02\u01EF\u01F0\x05\xadV\x02\u01F0\u01F1\x05\xa9T\x02\u01F1\u01F2\x05\xa9T\x02\u01F2\u01F3\x05\xa1P\x02\u01F3\u01F4\x05\xb7[\x02\u01F4\u0582\x03\x02\x02\x02\u01F5\u01F6\x05\x95J\x02\u01F6\u01F7\x05\xadV\x02\u01F7\u01F8\x05\xabU\x02\u01F8\u01F9\x05\xabU\x02\u01F9\u01FA\x05\x99L\x02\u01FA\u01FB\x05\x95J\x02\u01FB\u01FC\x05\xb7[\x02\u01FC\u0582\x03\x02\x02\x02\u01FD\u01FE\x05\x95J\x02\u01FE\u01FF\x05\xadV\x02\u01FF\u0200\x05\xabU\x02\u0200\u0201\x05\xb7[\x02\u0201\u0202\x05\xa1P\x02\u0202\u0203\x05\xabU\x02\u0203\u0204\x05\xb9\\\x02\u0204\u0205\x05\x99L\x02\u0205\u0582\x03\x02\x02\x02\u0206\u0207\x05\x95J\x02\u0207\u0208\x05\xadV\x02\u0208\u0209\x05\xb9\\\x02\u0209\u020A\x05\xabU\x02\u020A\u020B\x05\xb7[\x02\u020B\u0582\x03\x02\x02\x02\u020C\u020D\x05\x95J\x02\u020D\u020E\x05\xb3Y\x02\u020E\u020F\x05\x99L\x02\u020F\u0210\x05\x91H\x02\u0210\u0211\x05\xb7[\x02\u0211\u0212\x05\x99L\x02\u0212\u0582\x03\x02\x02\x02\u0213\u0214\x05\x95J\x02\u0214\u0215\x05\xb9\\\x02\u0215\u0216\x05\xb3Y\x02\u0216\u0217\x05\xb3Y\x02\u0217\u0218\x05\x99L\x02\u0218\u0219\x05\xabU\x02\u0219\u021A\x05\xb7[\x02\u021A\u0582\x03\x02\x02\x02\u021B\u021C\x05\x97K\x02\u021C\u021D\x05\x91H\x02\u021D\u021E\x05\xb7[\x02\u021E\u021F\x05\x99L\x02\u021F\u0582\x03\x02\x02\x02\u0220\u0221\x05\x97K\x02\u0221\u0222\x05\x99L\x02\u0222\u0223\x05\x95J\x02\u0223\u0224\x05\xa1P\x02\u0224\u0225\x05\xa9T\x02\u0225\u0226\x05\x91H\x02\u0226\u0227\x05\xa7S\x02\u0227\u0582\x03\x02\x02\x02\u0228\u0229\x05\x97K\x02\u0229\u022A\x05\x99L\x02\u022A\u022B\x05\x95J\x02\u022B\u022C\x05\xa7S\x02\u022C\u022D\x05\x91H\x02\u022D\u022E\x05\xb3Y\x02\u022E\u022F\x05\x99L\x02\u022F\u0582\x03\x02\x02\x02\u0230\u0231\x05\x97K\x02\u0231\u0232\x05\x99L\x02\u0232\u0233\x05\x95J\x02\u0233\u0234\x05\xb3Y\x02\u0234\u0235\x05\x99L\x02\u0235\u0236\x05\xa9T\x02\u0236\u0237\x05\x99L\x02\u0237\u0238\x05\xabU\x02\u0238\u0239\x05\xb7[\x02\u0239\u0582\x03\x02\x02\x02\u023A\u023B\x05\x97K\x02\u023B\u023C\x05\x99L\x02\u023C\u023D\x05\x9bM\x02\u023D\u023E\x05\x91H\x02\u023E\u023F\x05\xb9\\\x02\u023F\u0240\x05\xa7S\x02\u0240\u0241\x05\xb7[\x02\u0241\u0582\x03\x02\x02\x02\u0242\u0243\x05\x97K\x02\u0243\u0244\x05\x99L\x02\u0244\u0245\x05\x9bM\x02\u0245\u0246\x05\x91H\x02\u0246\u0247\x05\xb9\\\x02\u0247\u0248\x05\xa7S\x02\u0248\u0249\x05\xb7[\x02\u0249\u024A\x05\xb5Z\x02\u024A\u0582\x03\x02\x02\x02\u024B\u024C\x05\x97K\x02\u024C\u024D\x05\x99L\x02\u024D\u024E\x05\x9bM\x02\u024E\u024F\x05\xa1P\x02\u024F\u0250\x05\xabU\x02\u0250\u0251\x05\x99L\x02\u0251\u0582\x03\x02\x02\x02\u0252\u0253\x05\x97K\x02\u0253\u0254\x05\x99L\x02\u0254\u0255\x05\xa7S\x02\u0255\u0256\x05\x99L\x02\u0256\u0257\x05\xb7[\x02\u0257\u0258\x05\x99L\x02\u0258\u0582\x03\x02\x02\x02\u0259\u025A\x05\x97K\x02\u025A\u025B\x05\x99L\x02\u025B\u025C\x05\xa7S\x02\u025C\u025D\x05\xa1P\x02\u025D\u025E\x05\xa9T\x02\u025E\u025F\x05\xa1P\x02\u025F\u0260\x05\xb7[\x02\u0260\u0261\x05\x99L\x02\u0261\u0262\x05\xb3Y\x02\u0262\u0582\x03\x02\x02\x02\u0263\u0264\x05\x97K\x02\u0264\u0265\x05\xa1P\x02\u0265\u0266\x05\x9bM\x02\u0266\u0267\x05\x9bM\x02\u0267\u0268\x05\x99L\x02\u0268\u0269\x05\xb3Y\x02\u0269\u026A\x05\x99L\x02\u026A\u026B\x05\xabU\x02\u026B\u026C\x05\x95J\x02\u026C\u026D\x05\x99L\x02\u026D\u0582\x03\x02\x02\x02\u026E\u026F\x05\x97K\x02\u026F\u0270\x05\xa1P\x02\u0270\u0271\x05\xb5Z\x02\u0271\u0272\x05\xb7[\x02\u0272\u0273\x05\xa1P\x02\u0273\u0274\x05\xabU\x02\u0274\u0275\x05\x95J\x02\u0275\u0276\x05\xb7[\x02\u0276\u0582\x03\x02\x02\x02\u0277\u0278\x05\x97K\x02\u0278\u0279\x05\xa1P\x02\u0279\u027A\x05\xbb]\x02\u027A\u027B\x05\xa1P\x02\u027B\u027C\x05\x97K\x02\u027C\u027D\x05\x99L\x02\u027D\u0582\x03\x02\x02\x02\u027E\u027F\x05\x97K\x02\u027F\u0280\x05\xadV\x02\u0280\u0582\x03\x02\x02\x02\u0281\u0282\x05\x97K\x02\u0282\u0283\x05\xadV\x02\u0283\u0284\x05\xb9\\\x02\u0284\u0285\x05\x93I\x02\u0285\u0286\x05\xa7S\x02\u0286\u0287\x05\x99L\x02\u0287\u0582\x03\x02\x02\x02\u0288\u0289\x05\x97K\x02\u0289\u028A\x05\xb3Y\x02\u028A\u028B\x05\xadV\x02\u028B\u028C\x05\xafW\x02\u028C\u0582\x03\x02\x02\x02\u028D\u028E\x05\x99L\x02\u028E\u028F\x05\xa7S\x02\u028F\u0290\x05\xb5Z\x02\u0290\u0291\x05\x99L\x02\u0291\u0582\x03\x02\x02\x02\u0292\u0293\x05\x99L\x02\u0293\u0294\x05\xabU\x02\u0294\u0295\x05\x95J\x02\u0295\u0296\x05\xadV\x02\u0296\u0297\x05\x97K\x02\u0297\u0298\x05\xa1P\x02\u0298\u0299\x05\xabU\x02\u0299\u029A\x05\x9dN\x02\u029A\u0582\x03\x02\x02\x02\u029B\u029C\x05\x99L\x02\u029C\u029D\x05\xabU\x02\u029D\u029E\x05\x97K\x02\u029E\u0582\x03\x02\x02\x02\u029F\u02A0\x05\x99L\x02\u02A0\u02A1\x05\xb1X\x02\u02A1\u02A2\x05\xb9\\\x02\u02A2\u02A3\x05\x91H\x02\u02A3\u02A4\x05\xa7S\x02\u02A4\u02A5\x05\xb5Z\x02\u02A5\u0582\x03\x02\x02\x02\u02A6\u02A7\x05\x99L\x02\u02A7\u02A8\x05\xb5Z\x02\u02A8\u02A9\x05\x95J\x02\u02A9\u02AA\x05\x91H\x02\u02AA\u02AB\x05\xafW\x02\u02AB\u02AC\x05\x99L\x02\u02AC\u0582\x03\x02\x02\x02\u02AD\u02AE\x05\x99L\x02\u02AE\u02AF\x05\xbf_\x02\u02AF\u02B0\x05\x95J\x02\u02B0\u02B1\x05\xa7S\x02\u02B1\u02B2\x05\xb9\\\x02\u02B2\u02B3\x05\xb5Z\x02\u02B3\u02B4\x05\xa1P\x02\u02B4\u02B5\x05\xbb]\x02\u02B5\u02B6\x05\x99L\x02\u02B6\u0582\x03\x02\x02\x02\u02B7\u02B8\x05\x99L\x02\u02B8\u02B9\x05\xbf_\x02\u02B9\u02BA\x05\x99L\x02\u02BA\u02BB\x05\x95J\x02\u02BB\u0582\x03\x02\x02\x02\u02BC\u02BD\x05\x99L\x02\u02BD\u02BE\x05\xbf_\x02\u02BE\u02BF\x05\x99L\x02\u02BF\u02C0\x05\x95J\x02\u02C0\u02C1\x05\xb9\\\x02\u02C1\u02C2\x05\xb7[\x02\u02C2\u02C3\x05\x99L\x02\u02C3\u0582\x03\x02\x02\x02\u02C4\u02C5\x05\x99L\x02\u02C5\u02C6\x05\xbf_\x02\u02C6\u02C7\x05\xa1P\x02\u02C7\u02C8\x05\xb5Z\x02\u02C8\u02C9\x05\xb7[\x02\u02C9\u02CA\x05\xb5Z\x02\u02CA\u0582\x03\x02\x02\x02\u02CB\u02CC\x05\x99L\x02\u02CC\u02CD\x05\xbf_\x02\u02CD\u02CE\x05\xafW\x02\u02CE\u02CF\x05\xa7S\x02\u02CF\u02D0\x05\x91H\x02\u02D0\u02D1\x05\xa1P\x02\u02D1\u02D2\x05\xabU\x02\u02D2\u0582\x03\x02\x02\x02\u02D3\u02D4\x05\x9bM\x02\u02D4\u02D5\x05\x91H\x02\u02D5\u02D6\x05\xa7S\x02\u02D6\u02D7\x05\xb5Z\x02\u02D7\u02D8\x05\x99L\x02\u02D8\u0582\x03\x02\x02\x02\u02D9\u02DA\x05\x9bM\x02\u02DA\u02DB\x05\x99L\x02\u02DB\u02DC\x05\xb7[\x02\u02DC\u02DD\x05\x95J\x02\u02DD\u02DE\x05\x9fO\x02\u02DE\u0582\x03\x02\x02\x02\u02DF\u02E0\x05\x9bM\x02\u02E0\u02E1\x05\xa1P\x02\u02E1\u02E2\x05\xa7S\x02\u02E2\u02E3\x05\x99L\x02\u02E3\u0582\x03\x02\x02\x02\u02E4\u02E5\x05\x9bM\x02\u02E5\u02E6\x05\xa1P\x02\u02E6\u02E7\x05\x99L\x02\u02E7\u02E8\x05\xa7S\x02\u02E8\u02E9\x05\x97K\x02\u02E9\u0582\x03\x02\x02\x02\u02EA\u02EB\x05\x9bM\x02\u02EB\u02EC\x05\xa1P\x02\u02EC\u02ED\x05\xb3Y\x02\u02ED\u02EE\x05\xb5Z\x02\u02EE\u02EF\x05\xb7[\x02\u02EF\u0582\x03\x02\x02\x02\u02F0\u02F1\x05\x9bM\x02\u02F1\u02F2\x05\xa7S\x02\u02F2\u02F3\x05\xadV\x02\u02F3\u02F4\x05\x91H\x02\u02F4\u02F5\x05\xb7[\x02\u02F5\u0582\x03\x02\x02\x02\u02F6\u02F7\x05\x9bM\x02\u02F7\u02F8\x05\xadV\x02\u02F8\u02F9\x05\xb3Y\x02\u02F9\u0582\x03\x02\x02\x02\u02FA\u02FB\x05\x9bM\x02\u02FB\u02FC\x05\xb9\\\x02\u02FC\u02FD\x05\xabU\x02\u02FD\u02FE\x05\x95J\x02\u02FE\u02FF\x05\xb7[\x02\u02FF\u0300\x05\xa1P\x02\u0300\u0301\x05\xadV\x02\u0301\u0302\x05\xabU\x02\u0302\u0582\x03\x02\x02\x02\u0303\u0304\x05\x9dN\x02\u0304\u0305\x05\xadV\x02\u0305\u0582\x03\x02\x02\x02\u0306\u0307\x05\x9dN\x02\u0307\u0308\x05\xadV\x02\u0308\u0309\x05\xb7[\x02\u0309\u030A\x05\xadV\x02\u030A\u0582\x03\x02\x02\x02\u030B\u030C\x05\x9dN\x02\u030C\u030D\x05\xb3Y\x02\u030D\u030E\x05\x91H\x02\u030E\u030F\x05\xabU\x02\u030F\u0310\x05\xb7[\x02\u0310\u0582\x03\x02\x02\x02\u0311\u0312\x05\x9dN\x02\u0312\u0313\x05\xb3Y\x02\u0313\u0314\x05\x99L\x02\u0314\u0315\x05\x91H\x02\u0315\u0316\x05\xb7[\x02\u0316\u0317\x05\x99L\x02\u0317\u0318\x05\xb3Y\x02\u0318\u0582\x03\x02\x02\x02\u0319\u031A\x05\x9dN\x02\u031A\u031B\x05\xb3Y\x02\u031B\u031C\x05\xadV\x02\u031C\u031D\x05\xb9\\\x02\u031D\u031E\x05\xafW\x02\u031E\u0582\x03\x02\x02\x02\u031F\u0320\x05\x9fO\x02\u0320\u0321\x05\x91H\x02\u0321\u0322\x05\xbb]\x02\u0322\u0323\x05\xa1P\x02\u0323\u0324\x05\xabU\x02\u0324\u0325\x05\x9dN\x02\u0325\u0582\x03\x02\x02\x02\u0326\u0327\x05\xa1P\x02\u0327\u0328\x05\x97K\x02\u0328\u0329\x05\x99L\x02\u0329\u032A\x05\xabU\x02\u032A\u032B\x05\xb7[\x02\u032B\u032C\x05\xa1P\x02\u032C\u032D\x05\x9bM\x02\u032D\u032E\x05\xa1P\x02\u032E\u032F\x05\x99L\x02\u032F\u0330\x05\x97K\x02\u0330\u0582\x03\x02\x02\x02\u0331\u0332\x05\xa1P\x02\u0332\u0333\x05\x9bM\x02\u0333\u0582\x03\x02\x02\x02\u0334\u0335\x05\xa1P\x02\u0335\u0336\x05\xa9T\x02\u0336\u0337\x05\xa9T\x02\u0337\u0338\x05\x99L\x02\u0338\u0339\x05\x97K\x02\u0339\u033A\x05\xa1P\x02\u033A\u033B\x05\x91H\x02\u033B\u033C\x05\xb7[\x02\u033C\u033D\x05\x99L\x02\u033D\u0582\x03\x02\x02\x02\u033E\u033F\x05\xa1P\x02\u033F\u0340\x05\xabU\x02\u0340\u0341\x05\x95J\x02\u0341\u0342\x05\xb3Y\x02\u0342\u0343\x05\x99L\x02\u0343\u0344\x05\xa9T\x02\u0344\u0345\x05\x99L\x02\u0345\u0346\x05\xabU\x02\u0346\u0347\x05\xb7[\x02\u0347\u0582\x03\x02\x02\x02\u0348\u0349\x05\xa1P\x02\u0349\u034A\x05\xabU\x02\u034A\u034B\x05\x97K\x02\u034B\u034C\x05\x99L\x02\u034C\u034D\x05\xbf_\x02\u034D\u0582\x03\x02\x02\x02\u034E\u034F\x05\xa1P\x02\u034F\u0350\x05\xabU\x02\u0350\u0351\x05\xa1P\x02\u0351\u0352\x05\xb7[\x02\u0352\u0353\x05\xa1P\x02\u0353\u0354\x05\x91H\x02\u0354\u0355\x05\xa7S\x02\u0355\u0582\x03\x02\x02\x02\u0356\u0357\x05\xa1P\x02\u0357\u0358\x05\xabU\x02\u0358\u0359\x05\xabU\x02\u0359\u035A\x05\x99L\x02\u035A\u035B\x05\xb3Y\x02\u035B\u0582\x03\x02\x02\x02\u035C\u035D\x05\xa1P\x02\u035D\u035E\x05\xabU\x02\u035E\u035F\x05\xadV\x02\u035F\u0360\x05\xb9\\\x02\u0360\u0361\x05\xb7[\x02\u0361\u0582\x03\x02\x02\x02\u0362\u0363\x05\xa1P\x02\u0363\u0364\x05\xabU\x02\u0364\u0365\x05\xafW\x02\u0365\u0366\x05\xb9\\\x02\u0366\u0367\x05\xb7[\x02\u0367\u0582\x03\x02\x02\x02\u0368\u0369\x05\xa1P\x02\u0369\u036A\x05\xabU\x02\u036A\u036B\x05\xb5Z\x02\u036B\u036C\x05\x99L\x02\u036C\u036D\x05\xb3Y\x02\u036D\u036E\x05\xb7[\x02\u036E\u0582\x03\x02\x02\x02\u036F\u0370\x05\xa1P\x02\u0370\u0371\x05\xabU\x02\u0371\u0372\x05\xb7[\x02\u0372\u0582\x03\x02\x02\x02\u0373\u0374\x05\xa1P\x02\u0374\u0375\x05\xabU\x02\u0375\u0376\x05\xb7[\x02\u0376\u0377\x05\x99L\x02\u0377\u0378\x05\x9dN\x02\u0378\u0379\x05\x99L\x02\u0379\u037A\x05\xb3Y\x02\u037A\u0582\x03\x02\x02\x02\u037B\u037C\x05\xa1P\x02\u037C\u037D\x05\xabU\x02\u037D\u037E\x05\xb7[\x02\u037E\u037F\x05\x99L\x02\u037F\u0380\x05\xb3Y\x02\u0380\u0381\x05\xb5Z\x02\u0381\u0382\x05\x99L\x02\u0382\u0383\x05\x95J\x02\u0383\u0384\x05\xb7[\x02\u0384\u0582\x03\x02\x02\x02\u0385\u0386\x05\xa1P\x02\u0386\u0387\x05\xabU\x02\u0387\u0388\x05\xb7[\x02\u0388\u0389\x05\x99L\x02\u0389\u038A\x05\xb3Y\x02\u038A\u038B\x05\xb5Z\x02\u038B\u038C\x05\x99L\x02\u038C\u038D\x05\x95J\x02\u038D\u038E\x05\xb7[\x02\u038E\u038F\x05\xa1P\x02\u038F\u0390\x05\xadV\x02\u0390\u0391\x05\xabU\x02\u0391\u0582\x03\x02\x02\x02\u0392\u0393\x05\xa1P\x02\u0393\u0394\x05\xabU\x02\u0394\u0395\x05\xb7[\x02\u0395\u0396\x05\xadV\x02\u0396\u0582\x03\x02\x02\x02\u0397\u0398\x05\xa1P\x02\u0398\u0399\x05\xb5Z\x02\u0399\u039A\x05\x99L\x02\u039A\u039B\x05\xa9T\x02\u039B\u039C\x05\xafW\x02\u039C\u039D\x05\xb7[\x02\u039D\u039E\x05\xc1`\x02\u039E\u0582\x03\x02\x02\x02\u039F\u03A0\x05\xa1P\x02\u03A0\u03A1\x05\xb5Z\x02\u03A1\u03A2\x05\xabU\x02\u03A2\u03A3\x05\xb9\\\x02\u03A3\u03A4\x05\xa7S\x02\u03A4\u03A5\x05\xa7S\x02\u03A5\u0582\x03\x02\x02\x02\u03A6\u03A7\x05\xa3Q\x02\u03A7\u03A8\x05\xadV\x02\u03A8\u03A9\x05\xa1P\x02\u03A9\u03AA\x05\xabU\x02\u03AA\u0582\x03\x02\x02\x02\u03AB\u03AC\x05\xa7S\x02\u03AC\u03AD\x05\x91H\x02\u03AD\u03AE\x05\xb5Z\x02\u03AE\u03AF\x05\xb7[\x02\u03AF\u0582\x03\x02\x02\x02\u03B0\u03B1\x05\xa7S\x02\u03B1\u03B2\x05\x99L\x02\u03B2\u03B3\x05\x9bM\x02\u03B3\u03B4\x05\xb7[\x02\u03B4\u0582\x03\x02\x02\x02\u03B5\u03B6\x05\xa7S\x02\u03B6\u03B7\x05\x99L\x02\u03B7\u03B8\x05\xb5Z\x02\u03B8\u03B9\x05\xb5Z\x02\u03B9\u0582\x03\x02\x02\x02\u03BA\u03BB\x05\xa7S\x02\u03BB\u03BC\x05\xa1P\x02\u03BC\u03BD\x05\xa5R\x02\u03BD\u03BE\x05\x99L\x02\u03BE\u0582\x03\x02\x02\x02\u03BF\u03C0\x05\xa7S\x02\u03C0\u03C1\x05\xa1P\x02\u03C1\u03C2\x05\xa9T\x02\u03C2\u03C3\x05\xa1P\x02\u03C3\u03C4\x05\xb7[\x02\u03C4\u0582\x03\x02\x02\x02\u03C5\u03C6\x05\xa7S\x02\u03C6\u03C7\x05\xadV\x02\u03C7\u03C8\x05\x95J\x02\u03C8\u03C9\x05\xa5R\x02\u03C9\u0582\x03\x02\x02\x02\u03CA\u03CB\x05\xa7S\x02\u03CB\u03CC\x05\xadV\x02\u03CC\u03CD\x05\xabU\x02\u03CD\u03CE\x05\x9dN\x02\u03CE\u0582\x03\x02\x02\x02\u03CF\u03D0\x05\xa9T\x02\u03D0\u03D1\x05\x91H\x02\u03D1\u03D2\x05\xbf_\x02\u03D2\u0582\x03\x02\x02\x02\u03D3\u03D4\x05\xa9T\x02\u03D4\u03D5\x05\xa1P\x02\u03D5\u03D6\x05\xabU\x02\u03D6\u0582\x03\x02\x02\x02\u03D7\u03D8\x05\xa9T\x02\u03D8\u03D9\x05\xa1P\x02\u03D9\u03DA\x05\xabU\x02\u03DA\u03DB\x05\xb9\\\x02\u03DB\u03DC\x05\xb5Z\x02\u03DC\u0582\x03\x02\x02\x02\u03DD\u03DE\x05\xa9T\x02\u03DE\u03DF\x05\xadV\x02\u03DF\u03E0\x05\x97K\x02\u03E0\u03E1\x05\x99L\x02\u03E1\u0582\x03\x02\x02\x02\u03E2\u03E3\x05\xa9T\x02\u03E3\u03E4\x05\xadV\x02\u03E4\u03E5\x05\x97K\x02\u03E5\u03E6\x05\xa1P\x02\u03E6\u03E7\x05\x9bM\x02\u03E7\u03E8\x05\xc1`\x02\u03E8\u0582\x03\x02\x02\x02\u03E9\u03EA\x05\xa9T\x02\u03EA\u03EB\x05\xadV\x02\u03EB\u03EC\x05\x97K\x02\u03EC\u03ED\x05\xb9\\\x02\u03ED\u03EE\x05\xa7S\x02\u03EE\u03EF\x05\xadV\x02\u03EF\u0582\x03\x02\x02\x02\u03F0\u03F1\x05\xa9T\x02\u03F1\u03F2\x05\xadV\x02\u03F2\u03F3\x05\xb3Y\x02\u03F3\u03F4\x05\x99L\x02\u03F4\u0582\x03\x02\x02\x02\u03F5\u03F6\x05\xa9T\x02\u03F6\u03F7\x05\xb9\\\x02\u03F7\u03F8\x05\xa7S\x02\u03F8\u03F9\x05\xb7[\x02\u03F9\u03FA\x05\xa1P\x02\u03FA\u03FB\x05\xafW\x02\u03FB\u03FC\x05\xa7S\x02\u03FC\u03FD\x05\xc1`\x02\u03FD\u0582\x03\x02\x02\x02\u03FE\u03FF\x05\xabU\x02\u03FF\u0400\x05\x99L\x02\u0400\u0401\x05\xbf_\x02\u0401\u0402\x05\xb7[\x02\u0402\u0582\x03\x02\x02\x02\u0403\u0404\x05\xabU\x02\u0404\u0405\x05\xadV\x02\u0405\u0406\x05\x91H\x02\u0406\u0407\x05\xb9\\\x02\u0407\u0408\x05\x97K\x02\u0408\u0409\x05\xa1P\x02\u0409\u040A\x05\xb7[\x02\u040A\u0582\x03\x02\x02\x02\u040B\u040C\x05\xabU\x02\u040C\u040D\x05\xadV\x02\u040D\u040E\x05\xb7[\x02\u040E\u040F\x05\xa1P\x02\u040F\u0410\x05\xabU\x02\u0410\u0582\x03\x02\x02\x02\u0411\u0412\x05\xabU\x02\u0412\u0413\x05\xadV\x02\u0413\u0414\x05\xbd^\x02\u0414\u0415\x05\x91H\x02\u0415\u0416\x05\xa1P\x02\u0416\u0417\x05\xb7[\x02\u0417\u0582\x03\x02\x02\x02\u0418\u0419\x05\xabU\x02\u0419\u041A\x05\xb9\\\x02\u041A\u041B\x05\xa9T\x02\u041B\u041C\x05\x93I\x02\u041C\u041D\x05\x99L\x02\u041D\u041E\x05\xb3Y\x02\u041E\u0582\x03\x02\x02\x02\u041F\u0420\x05\xadV\x02\u0420\u0421\x05\x93I\x02\u0421\u0422\x05\xa3Q\x02\u0422\u0423\x05\x99L\x02\u0423\u0424\x05\x95J\x02\u0424\u0425\x05\xb7[\x02\u0425\u0582\x03\x02\x02\x02\u0426\u0427\x05\xadV\x02\u0427\u0428\x05\x9bM\x02\u0428\u0582\x03\x02\x02\x02\u0429\u042A\x05\xadV\x02\u042A\u042B\x05\xafW\x02\u042B\u042C\x05\xb7[\x02\u042C\u042D\x05\xa1P\x02\u042D\u042E\x05\xadV\x02\u042E\u042F\x05\xabU\x02\u042F\u0582\x03\x02\x02\x02\u0430\u0431\x05\xadV\x02\u0431\u0432\x05\xb9\\\x02\u0432\u0433\x05\xb7[\x02\u0433\u0434\x05\x99L\x02\u0434\u0435\x05\xb3Y\x02\u0435\u0582\x03\x02\x02\x02\u0436\u0437\x05\xadV\x02\u0437\u0438\x05\xb9\\\x02\u0438\u0439\x05\xb7[\x02\u0439\u043A\x05\xafW\x02\u043A\u043B\x05\xb9\\\x02\u043B\u043C\x05\xb7[\x02\u043C\u0582\x03\x02\x02\x02\u043D\u043E\x05\xafW\x02\u043E\u043F\x05\xadV\x02\u043F\u0440\x05\xbd^\x02\u0440\u0441\x05\x99L\x02\u0441\u0442\x05";
    }
    static{
        this._serializedATNSegment2 = '\xb3Y\x02\u0442\u0582\x03\x02\x02\x02\u0443\u0444\x05\xafW\x02\u0444\u0445\x05\xb3Y\x02\u0445\u0446\x05\x99L\x02\u0446\u0447\x05\xbb]\x02\u0447\u0448\x05\xa1P\x02\u0448\u0449\x05\xadV\x02\u0449\u044A\x05\xb9\\\x02\u044A\u044B\x05\xb5Z\x02\u044B\u0582\x03\x02\x02\x02\u044C\u044D\x05\xafW\x02\u044D\u044E\x05\xb3Y\x02\u044E\u044F\x05\xa1P\x02\u044F\u0450\x05\xadV\x02\u0450\u0451\x05\xb3Y\x02\u0451\u0582\x03\x02\x02\x02\u0452\u0453\x05\xafW\x02\u0453\u0454\x05\xb3Y\x02\u0454\u0455\x05\xa1P\x02\u0455\u0456\x05\xbb]\x02\u0456\u0457\x05\xa1P\x02\u0457\u0458\x05\xa7S\x02\u0458\u0459\x05\x99L\x02\u0459\u045A\x05\x9dN\x02\u045A\u045B\x05\x99L\x02\u045B\u045C\x05\xb5Z\x02\u045C\u0582\x03\x02\x02\x02\u045D\u045E\x05\xafW\x02\u045E\u045F\x05\xb9\\\x02\u045F\u0460\x05\x93I\x02\u0460\u0461\x05\xa7S\x02\u0461\u0462\x05\xa1P\x02\u0462\u0463\x05\x95J\x02\u0463\u0582\x03\x02\x02\x02\u0464\u0465\x05\xb3Y\x02\u0465\u0466\x05\x91H\x02\u0466\u0467\x05\xa1P\x02\u0467\u0468\x05\xb5Z\x02\u0468\u0469\x05\x99L\x02\u0469\u0582\x03\x02\x02\x02\u046A\u046B\x05\xb3Y\x02\u046B\u046C\x05\x91H\x02\u046C\u046D\x05\xbd^\x02\u046D\u0582\x03\x02\x02\x02\u046E\u046F\x05\xb3Y\x02\u046F\u0470\x05\x99L\x02\u0470\u0471\x05\xa9T\x02\u0471\u0472\x05\x91H\x02\u0472\u0473\x05\xa1P\x02\u0473\u0474\x05\xabU\x02\u0474\u0475\x05\x97K\x02\u0475\u0476\x05\x99L\x02\u0476\u0477\x05\xb3Y\x02\u0477\u0582\x03\x02\x02\x02\u0478\u0479\x05\xb3Y\x02\u0479\u047A\x05\x99L\x02\u047A\u047B\x05\xabU\x02\u047B\u047C\x05\x91H\x02\u047C\u047D\x05\xa9T\x02\u047D\u047E\x05\x99L\x02\u047E\u0582\x03\x02\x02\x02\u047F\u0480\x05\xb3Y\x02\u0480\u0481\x05\x99L\x02\u0481\u0482\x05\xb5Z\x02\u0482\u0483\x05\xadV\x02\u0483\u0484\x05\xb9\\\x02\u0484\u0485\x05\xb3Y\x02\u0485\u0486\x05\x95J\x02\u0486\u0487\x05\x99L\x02\u0487\u0582\x03\x02\x02\x02\u0488\u0489\x05\xb3Y\x02\u0489\u048A\x05\x99L\x02\u048A\u048B\x05\xb7[\x02\u048B\u048C\x05\xb9\\\x02\u048C\u048D\x05\xb3Y\x02\u048D\u048E\x05\xabU\x02\u048E\u0582\x03\x02\x02\x02\u048F\u0490\x05\xb3Y\x02\u0490\u0491\x05\x99L\x02\u0491\u0492\x05\xb7[\x02\u0492\u0493\x05\xb9\\\x02\u0493\u0494\x05\xb3Y\x02\u0494\u0495\x05\xabU\x02\u0495\u0496\x05\xb5Z\x02\u0496\u0582\x03\x02\x02\x02\u0497\u0498\x05\xb3Y\x02\u0498\u0499\x05\x99L\x02\u0499\u049A\x05\xbb]\x02\u049A\u049B\x05\xadV\x02\u049B\u049C\x05\xa5R\x02\u049C\u049D\x05\x99L\x02\u049D\u0582\x03\x02\x02\x02\u049E\u049F\x05\xb3Y\x02\u049F\u04A0\x05\xa1P\x02\u04A0\u04A1\x05\x9dN\x02\u04A1\u04A2\x05\x9fO\x02\u04A2\u04A3\x05\xb7[\x02\u04A3\u0582\x03\x02\x02\x02\u04A4\u04A5\x05\xb3Y\x02\u04A5\u04A6\x05\xadV\x02\u04A6\u04A7\x05\xbd^\x02\u04A7\u0582\x03\x02\x02\x02\u04A8\u04A9\x05\xb3Y\x02\u04A9\u04AA\x05\xadV\x02\u04AA\u04AB\x05\xbd^\x02\u04AB\u04AC\x05\xa1P\x02\u04AC\u04AD\x05\x97K\x02\u04AD\u0582\x03\x02\x02\x02\u04AE\u04AF\x05\xb3Y\x02\u04AF\u04B0\x05\xadV\x02\u04B0\u04B1\x05\xbd^\x02\u04B1\u04B2\x05\xabU\x02\u04B2\u04B3\x05\xb9\\\x02\u04B3\u04B4\x05\xa9T\x02\u04B4\u0582\x03\x02\x02\x02\u04B5\u04B6\x05\xb3Y\x02\u04B6\u04B7\x05\xadV\x02\u04B7\u04B8\x05\xbd^\x02\u04B8\u04B9\x05\xb5Z\x02\u04B9\u0582\x03\x02\x02\x02\u04BA\u04BB\x05\xb5Z\x02\u04BB\u04BC\x05\x99L\x02\u04BC\u04BD\x05\xa7S\x02\u04BD\u04BE\x05\x99L\x02\u04BE\u04BF\x05\x95J\x02\u04BF\u04C0\x05\xb7[\x02\u04C0\u0582\x03\x02\x02\x02\u04C1\u04C2\x05\xb5Z\x02\u04C2\u04C3\x05\x99L\x02\u04C3\u04C4\x05\xb5Z\x02\u04C4\u04C5\x05\xb5Z\x02\u04C5\u04C6\x05\xa1P\x02\u04C6\u04C7\x05\xadV\x02\u04C7\u04C8\x05\xabU\x02\u04C8\u0582\x03\x02\x02\x02\u04C9\u04CA\x05\xb5Z\x02\u04CA\u04CB\x05\x99L\x02\u04CB\u04CC\x05\xb7[\x02\u04CC\u0582\x03\x02\x02\x02\u04CD\u04CE\x05\xb5Z\x02\u04CE\u04CF\x05\x9fO\x02\u04CF\u04D0\x05\x91H\x02\u04D0\u04D1\x05\xb3Y\x02\u04D1\u04D2\x05\x99L\x02\u04D2\u0582\x03\x02\x02\x02\u04D3\u04D4\x05\xb5Z\x02\u04D4\u04D5\x05\xa1P\x02\u04D5\u04D6\x05\xc3a\x02\u04D6\u04D7\x05\x99L\x02\u04D7\u0582\x03\x02\x02\x02\u04D8\u04D9\x05\xb5Z\x02\u04D9\u04DA\x05\xb1X\x02\u04DA\u04DB\x05\xb3Y\x02\u04DB\u04DC\x05\xb7[\x02\u04DC\u0582\x03\x02\x02\x02\u04DD\u04DE\x05\xb5Z\x02\u04DE\u04DF\x05\xb7[\x02\u04DF\u04E0\x05\x91H\x02\u04E0\u04E1\x05\xb3Y\x02\u04E1\u04E2\x05\xb7[\x02\u04E2\u0582\x03\x02\x02\x02\u04E3\u04E4\x05\xb5Z\x02\u04E4\u04E5\x05\xb7[\x02\u04E5\u04E6\x05\xb3Y\x02\u04E6\u04E7\x05\xa1P\x02\u04E7\u04E8\x05\x95J\x02\u04E8\u04E9\x05\xb7[\x02\u04E9\u0582\x03\x02\x02\x02\u04EA\u04EB\x05\xb5Z\x02\u04EB\u04EC\x05\xb7[\x02\u04EC\u04ED\x05\xb3Y\x02\u04ED\u04EE\x05\xa1P\x02\u04EE\u04EF\x05\xabU\x02\u04EF\u04F0\x05\x9dN\x02\u04F0\u0582\x03\x02\x02\x02\u04F1\u04F2\x05\xb5Z\x02\u04F2\u04F3\x05\xb9\\\x02\u04F3\u04F4\x05\x93I\x02\u04F4\u04F5\x05\xb7[\x02\u04F5\u04F6\x05\xb3Y\x02\u04F6\u04F7\x05\x91H\x02\u04F7\u04F8\x05\x95J\x02\u04F8\u04F9\x05\xb7[\x02\u04F9\u0582\x03\x02\x02\x02\u04FA\u04FB\x05\xb5Z\x02\u04FB\u04FC\x05\xb9\\\x02\u04FC\u04FD\x05\xa9T\x02\u04FD\u0582\x03\x02\x02\x02\u04FE\u04FF\x05\xb5Z\x02\u04FF\u0500\x05\xc1`\x02\u0500\u0501\x05\xabU\x02\u0501\u0502\x05\xadV\x02\u0502\u0503\x05\xabU\x02\u0503\u0504\x05\xc1`\x02\u0504\u0505\x05\xa9T\x02\u0505\u0582\x03\x02\x02\x02\u0506\u0507\x05\xb7[\x02\u0507\u0508\x05\x91H\x02\u0508\u0509\x05\x93I\x02\u0509\u050A\x05\xa7S\x02\u050A\u050B\x05\x99L\x02\u050B\u0582\x03\x02\x02\x02\u050C\u050D\x05\xb7[\x02\u050D\u050E\x05\x9fO\x02\u050E\u050F\x05\x99L\x02\u050F\u0510\x05\xabU\x02\u0510\u0582\x03\x02\x02\x02\u0511\u0512\x05\xb7[\x02\u0512\u0513\x05\xb3Y\x02\u0513\u0514\x05\x91H\x02\u0514\u0515\x05\xabU\x02\u0515\u0516\x05\xb5Z\x02\u0516\u0582\x03\x02\x02\x02\u0517\u0518\x05\xb7[\x02\u0518\u0519\x05\xb3Y\x02\u0519\u051A\x05\x91H\x02\u051A\u051B\x05\xabU\x02\u051B\u051C\x05\xb5Z\x02\u051C\u051D\x05\x91H\x02\u051D\u051E\x05\x95J\x02\u051E\u051F\x05\xb7[\x02\u051F\u0520\x05\xa1P\x02\u0520\u0521\x05\xadV\x02\u0521\u0522\x05\xabU\x02\u0522\u0582\x03\x02\x02\x02\u0523\u0524\x05\xb7[\x02\u0524\u0525\x05\xb3Y\x02\u0525\u0526\x05\xa1P\x02\u0526\u0527\x05\x9dN\x02\u0527\u0528\x05\x9dN\x02\u0528\u0529\x05\x99L\x02\u0529\u052A\x05\xb3Y\x02\u052A\u0582\x03\x02\x02\x02\u052B\u052C\x05\xb7[\x02\u052C\u052D\x05\xb3Y\x02\u052D\u052E\x05\xb9\\\x02\u052E\u052F\x05\x99L\x02\u052F\u0582\x03\x02\x02\x02\u0530\u0531\x05\xb9\\\x02\u0531\u0532\x05\xa1P\x02\u0532\u0533\x05\x97K\x02\u0533\u0582\x03\x02\x02\x02\u0534\u0535\x05\xb9\\\x02\u0535\u0536\x05\xabU\x02\u0536\u0537\x05\xa1P\x02\u0537\u0538\x05\xadV\x02\u0538\u0539\x05\xabU\x02\u0539\u0582\x03\x02\x02\x02\u053A\u053B\x05\xb9\\\x02\u053B\u053C\x05\xabU\x02\u053C\u053D\x05\xa1P\x02\u053D\u053E\x05\xb1X\x02\u053E\u053F\x05\xb9\\\x02\u053F\u0540\x05\x99L\x02\u0540\u0582\x03\x02\x02\x02\u0541\u0542\x05\xb9\\\x02\u0542\u0543\x05\xafW\x02\u0543\u0544\x05\x97K\x02\u0544\u0545\x05\x91H\x02\u0545\u0546\x05\xb7[\x02\u0546\u0547\x05\x99L\x02\u0547\u0582\x03\x02\x02\x02\u0548\u0549\x05\xb9\\\x02\u0549\u054A\x05\xb5Z\x02\u054A\u054B\x05\x99L\x02\u054B\u054C\x05\xb3Y\x02\u054C\u0582\x03\x02\x02\x02\u054D\u054E\x05\xbb]\x02\u054E\u054F\x05\x91H\x02\u054F\u0550\x05\xa7S\x02\u0550\u0551\x05\xa1P\x02\u0551\u0552\x05\x97K\x02\u0552\u0553\x05\x91H\x02\u0553\u0554\x05\xb7[\x02\u0554\u0555\x05\x99L\x02\u0555\u0582\x03\x02\x02\x02\u0556\u0557\x05\xbb]\x02\u0557\u0558\x05\x91H\x02\u0558\u0559\x05\xa7S\x02\u0559\u055A\x05\xb9\\\x02\u055A\u055B\x05\x99L\x02\u055B\u055C\x05\xb5Z\x02\u055C\u0582\x03\x02\x02\x02\u055D\u055E\x05\xbb]\x02\u055E\u055F\x05\xa1P\x02\u055F\u0560\x05\x99L\x02\u0560\u0561\x05\xbd^\x02\u0561\u0582\x03\x02\x02\x02\u0562\u0563\x05\xbd^\x02\u0563\u0564\x05\x9fO\x02\u0564\u0565\x05\x99L\x02\u0565\u0566\x05\xabU\x02\u0566\u0582\x03\x02\x02\x02\u0567\u0568\x05\xbd^\x02\u0568\u0569\x05\x9fO\x02\u0569\u056A\x05\x99L\x02\u056A\u056B\x05\xabU\x02\u056B\u056C\x05\x99L\x02\u056C\u056D\x05\xbb]\x02\u056D\u056E\x05\x99L\x02\u056E\u056F\x05\xb3Y\x02\u056F\u0582\x03\x02\x02\x02\u0570\u0571\x05\xbd^\x02\u0571\u0572\x05\x9fO\x02\u0572\u0573\x05\x99L\x02\u0573\u0574\x05\xb3Y\x02\u0574\u0575\x05\x99L\x02\u0575\u0582\x03\x02\x02\x02\u0576\u0577\x05\xbd^\x02\u0577\u0578\x05\x9fO\x02\u0578\u0579\x05\xa1P\x02\u0579\u057A\x05\xa7S\x02\u057A\u057B\x05\x99L\x02\u057B\u0582\x03\x02\x02\x02\u057C\u057D\x05\xbd^\x02\u057D\u057E\x05\xa1P\x02\u057E\u057F\x05\xb7[\x02\u057F\u0580\x05\x9fO\x02\u0580\u0582\x03\x02\x02\x02\u0581\u0160\x03\x02\x02\x02\u0581\u0166\x03\x02\x02\x02\u0581\u016D\x03\x02\x02\x02\u0581\u0171\x03\x02\x02\x02\u0581\u0177\x03\x02\x02\x02\u0581\u017D\x03\x02\x02\x02\u0581\u0181\x03\x02\x02\x02\u0581\u0184\x03\x02\x02\x02\u0581\u018A\x03\x02\x02\x02\u0581\u018E\x03\x02\x02\x02\u0581\u0194\x03\x02\x02\x02\u0581\u019C\x03\x02\x02\x02\u0581\u01A4\x03\x02\x02\x02\u0581\u01AA\x03\x02\x02\x02\u0581\u01AF\x03\x02\x02\x02\u0581\u01B5\x03\x02\x02\x02\u0581\u01BA\x03\x02\x02\x02\u0581\u01C4\x03\x02\x02\x02\u0581\u01CA\x03\x02\x02\x02\u0581\u01D5\x03\x02\x02\x02\u0581\u01DD\x03\x02\x02\x02\u0581\u01E7\x03\x02\x02\x02\u0581\u01EE\x03\x02\x02\x02\u0581\u01F5\x03\x02\x02\x02\u0581\u01FD\x03\x02\x02\x02\u0581\u0206\x03\x02\x02\x02\u0581\u020C\x03\x02\x02\x02\u0581\u0213\x03\x02\x02\x02\u0581\u021B\x03\x02\x02\x02\u0581\u0220\x03\x02\x02\x02\u0581\u0228\x03\x02\x02\x02\u0581\u0230\x03\x02\x02\x02\u0581\u023A\x03\x02\x02\x02\u0581\u0242\x03\x02\x02\x02\u0581\u024B\x03\x02\x02\x02\u0581\u0252\x03\x02\x02\x02\u0581\u0259\x03\x02\x02\x02\u0581\u0263\x03\x02\x02\x02\u0581\u026E\x03\x02\x02\x02\u0581\u0277\x03\x02\x02\x02\u0581\u027E\x03\x02\x02\x02\u0581\u0281\x03\x02\x02\x02\u0581\u0288\x03\x02\x02\x02\u0581\u028D\x03\x02\x02\x02\u0581\u0292\x03\x02\x02\x02\u0581\u029B\x03\x02\x02\x02\u0581\u029F\x03\x02\x02\x02\u0581\u02A6\x03\x02\x02\x02\u0581\u02AD\x03\x02\x02\x02\u0581\u02B7\x03\x02\x02\x02\u0581\u02BC\x03\x02\x02\x02\u0581\u02C4\x03\x02\x02\x02\u0581\u02CB\x03\x02\x02\x02\u0581\u02D3\x03\x02\x02\x02\u0581\u02D9\x03\x02\x02\x02\u0581\u02DF\x03\x02\x02\x02\u0581\u02E4\x03\x02\x02\x02\u0581\u02EA\x03\x02\x02\x02\u0581\u02F0\x03\x02\x02\x02\u0581\u02F6\x03\x02\x02\x02\u0581\u02FA\x03\x02\x02\x02\u0581\u0303\x03\x02\x02\x02\u0581\u0306\x03\x02\x02\x02\u0581\u030B\x03\x02\x02\x02\u0581\u0311\x03\x02\x02\x02\u0581\u0319\x03\x02\x02\x02\u0581\u031F\x03\x02\x02\x02\u0581\u0326\x03\x02\x02\x02\u0581\u0331\x03\x02\x02\x02\u0581\u0334\x03\x02\x02\x02\u0581\u033E\x03\x02\x02\x02\u0581\u0348\x03\x02\x02\x02\u0581\u034E\x03\x02\x02\x02\u0581\u0356\x03\x02\x02\x02\u0581\u035C\x03\x02\x02\x02\u0581\u0362\x03\x02\x02\x02\u0581\u0368\x03\x02\x02\x02\u0581\u036F\x03\x02\x02\x02\u0581\u0373\x03\x02\x02\x02\u0581\u037B\x03\x02\x02\x02\u0581\u0385\x03\x02\x02\x02\u0581\u0392\x03\x02\x02\x02\u0581\u0397\x03\x02\x02\x02\u0581\u039F\x03\x02\x02\x02\u0581\u03A6\x03\x02\x02\x02\u0581\u03AB\x03\x02\x02\x02\u0581\u03B0\x03\x02\x02\x02\u0581\u03B5\x03\x02\x02\x02\u0581\u03BA\x03\x02\x02\x02\u0581\u03BF\x03\x02\x02\x02\u0581\u03C5\x03\x02\x02\x02\u0581\u03CA\x03\x02\x02\x02\u0581\u03CF\x03\x02\x02\x02\u0581\u03D3\x03\x02\x02\x02\u0581\u03D7\x03\x02\x02\x02\u0581\u03DD\x03\x02\x02\x02\u0581\u03E2\x03\x02\x02\x02\u0581\u03E9\x03\x02\x02\x02\u0581\u03F0\x03\x02\x02\x02\u0581\u03F5\x03\x02\x02\x02\u0581\u03FE\x03\x02\x02\x02\u0581\u0403\x03\x02\x02\x02\u0581\u040B\x03\x02\x02\x02\u0581\u0411\x03\x02\x02\x02\u0581\u0418\x03\x02\x02\x02\u0581\u041F\x03\x02\x02\x02\u0581\u0426\x03\x02\x02\x02\u0581\u0429\x03\x02\x02\x02\u0581\u0430\x03\x02\x02\x02\u0581\u0436\x03\x02\x02\x02\u0581\u043D\x03\x02\x02\x02\u0581\u0443\x03\x02\x02\x02\u0581\u044C\x03\x02\x02\x02\u0581\u0452\x03\x02\x02\x02\u0581\u045D\x03\x02\x02\x02\u0581\u0464\x03\x02\x02\x02\u0581\u046A\x03\x02\x02\x02\u0581\u046E\x03\x02\x02\x02\u0581\u0478\x03\x02\x02\x02\u0581\u047F\x03\x02\x02\x02\u0581\u0488\x03\x02\x02\x02\u0581\u048F\x03\x02\x02\x02\u0581\u0497\x03\x02\x02\x02\u0581\u049E\x03\x02\x02\x02\u0581\u04A4\x03\x02\x02\x02\u0581\u04A8\x03\x02\x02\x02\u0581\u04AE\x03\x02\x02\x02\u0581\u04B5\x03\x02\x02\x02\u0581\u04BA\x03\x02\x02\x02\u0581\u04C1\x03\x02\x02\x02\u0581\u04C9\x03\x02\x02\x02\u0581\u04CD\x03\x02\x02\x02\u0581\u04D3\x03\x02\x02\x02\u0581\u04D8\x03\x02\x02\x02\u0581\u04DD\x03\x02\x02\x02\u0581\u04E3\x03\x02\x02\x02\u0581\u04EA\x03\x02\x02\x02\u0581\u04F1\x03\x02\x02\x02\u0581\u04FA\x03\x02\x02\x02\u0581\u04FE\x03\x02\x02\x02\u0581\u0506\x03\x02\x02\x02\u0581\u050C\x03\x02\x02\x02\u0581\u0511\x03\x02\x02\x02\u0581\u0517\x03\x02\x02\x02\u0581\u0523\x03\x02\x02\x02\u0581\u052B\x03\x02\x02\x02\u0581\u0530\x03\x02\x02\x02\u0581\u0534\x03\x02\x02\x02\u0581\u053A\x03\x02\x02\x02\u0581\u0541\x03\x02\x02\x02\u0581\u0548\x03\x02\x02\x02\u0581\u054D\x03\x02\x02\x02\u0581\u0556\x03\x02\x02\x02\u0581\u055D\x03\x02\x02\x02\u0581\u0562\x03\x02\x02\x02\u0581\u0567\x03\x02\x02\x02\u0581\u0570\x03\x02\x02\x02\u0581\u0576\x03\x02\x02\x02\u0581\u057C\x03\x02\x02\x02\u0582P\x03\x02\x02\x02\u0583\u0586\x05\x85B\x02\u0584\u0586\x05i4\x02\u0585\u0583\x03\x02\x02\x02\u0585\u0584\x03\x02\x02\x02\u0586\u0587\x03\x02\x02\x02\u0587\u0585\x03\x02\x02\x02\u0587\u0588\x03\x02\x02\x02\u0588R\x03\x02\x02\x02\u0589\u058B\x05\x8bE\x02\u058A\u0589\x03\x02\x02\x02\u058B\u058C\x03\x02\x02\x02\u058C\u058A\x03\x02\x02\x02\u058C\u058D\x03\x02\x02\x02\u058D\u058E\x03\x02\x02\x02\u058E\u058F\b)\x05\x02\u058FT\x03\x02\x02\x02\u0590\u0591\x05o7\x02\u0591V\x03\x02\x02\x02\u0592\u0593\v\x02\x02\x02\u0593X\x03\x02\x02\x02\u0594\u0595\x05q8\x02\u0595\u0596\x03\x02\x02\x02\u0596\u0597\b,\x06\x02\u0597Z\x03\x02\x02\x02\u0598\u059B\x05\x85B\x02\u0599\u059B\x05k5\x02\u059A\u0598\x03\x02\x02\x02\u059A\u0599\x03\x02\x02\x02\u059B\u059C\x03\x02\x02\x02\u059C\u059D\b-\x02\x02\u059D\\\x03\x02\x02\x02\u059E\u059F\x07\x02\x02\x03\u059F\u05A0\x03\x02\x02\x02\u05A0\u05A1\b.\x06\x02\u05A1^\x03\x02\x02\x02\u05A2\u05A3\v\x02\x02\x02\u05A3\u05A4\x03\x02\x02\x02\u05A4\u05A5\b/\x06\x02\u05A5`\x03\x02\x02\x02\u05A6\u05A7\x05s9\x02\u05A7\u05A8\x03\x02\x02\x02\u05A8\u05A9\b0\x06\x02\u05A9b\x03\x02\x02\x02\u05AA\u05AD\x05\x85B\x02\u05AB\u05AD\x05m6\x02\u05AC\u05AA\x03\x02\x02\x02\u05AC\u05AB\x03\x02\x02\x02\u05AD\u05AE\x03\x02\x02\x02\u05AE\u05AF\b1\x02\x02\u05AFd\x03\x02\x02\x02\u05B0\u05B1\x07\x02\x02\x03\u05B1\u05B2\x03\x02\x02\x02\u05B2\u05B3\b2\x06\x02\u05B3f\x03\x02\x02\x02\u05B4\u05B5\v\x02\x02\x02\u05B5\u05B6\x03\x02\x02\x02\u05B6\u05B7\b3\x06\x02\u05B7h\x03\x02\x02\x02\u05B8\u05B9\n\x02\x02\x02\u05B9j\x03\x02\x02\x02\u05BA\u05BB\n\x03\x02\x02\u05BBl\x03\x02\x02\x02\u05BC\u05BD\n\x04\x02\x02\u05BDn\x03\x02\x02\x02\u05BE\u05BF	\x05\x02\x02\u05BFp\x03\x02\x02\x02\u05C0\u05C1\x07$\x02\x02\u05C1r\x03\x02\x02\x02\u05C2\u05C3\x07)\x02\x02\u05C3t\x03\x02\x02\x02\u05C4\u05C5\x07^\x02\x02\u05C5v\x03\x02\x02\x02\u05C6\u05C7\x07\x0f\x02\x02\u05C7x\x03\x02\x02\x02\u05C8\u05C9\x07\f\x02\x02\u05C9z\x03\x02\x02\x02\u05CA\u05CB\x07"\x02\x02\u05CB|\x03\x02\x02\x02\u05CC\u05CD\x07(\x02\x02\u05CD~\x03\x02\x02\x02\u05CE\u05CF\x07(\x02\x02\u05CF\u05D0\x07(\x02\x02\u05D0\x80\x03\x02\x02\x02\u05D1\u05D2\x07~\x02\x02\u05D2\x82\x03\x02\x02\x02\u05D3\u05D4\x07~\x02\x02\u05D4\u05D5\x07~\x02\x02\u05D5\x84\x03\x02\x02\x02\u05D6\u05E2\x05u:\x02\u05D7\u05E3	\x06\x02\x02\u05D8\u05E3\x05q8\x02\u05D9\u05E3\x05s9\x02\u05DA\u05E3\x05u:\x02\u05DB\u05E3\x05{=\x02\u05DC\u05DD\x07w\x02\x02\u05DD\u05DE\x05\x89D\x02\u05DE\u05DF\x05\x89D\x02\u05DF\u05E0\x05\x89D\x02\u05E0\u05E1\x05\x89D\x02\u05E1\u05E3\x03\x02\x02\x02\u05E2\u05D7\x03\x02\x02\x02\u05E2\u05D8\x03\x02\x02\x02\u05E2\u05D9\x03\x02\x02\x02\u05E2\u05DA\x03\x02\x02\x02\u05E2\u05DB\x03\x02\x02\x02\u05E2\u05DC\x03\x02\x02\x02\u05E3\x86\x03\x02\x02\x02\u05E4\u05E7\x05w;\x02\u05E5\u05E7\x05y<\x02\u05E6\u05E4\x03\x02\x02\x02\u05E6\u05E5\x03\x02\x02\x02\u05E7\x88\x03\x02\x02\x02\u05E8\u05F0\x05\x8fG\x02\u05E9\u05F0\x05\x91H\x02\u05EA\u05F0\x05\x93I\x02\u05EB\u05F0\x05\x95J\x02\u05EC\u05F0\x05\x97K\x02\u05ED\u05F0\x05\x99L\x02\u05EE\u05F0\x05\x9bM\x02\u05EF\u05E8\x03\x02\x02\x02\u05EF\u05E9\x03\x02\x02\x02\u05EF\u05EA\x03\x02\x02\x02\u05EF\u05EB\x03\x02\x02\x02\u05EF\u05EC\x03\x02\x02\x02\u05EF\u05ED\x03\x02\x02\x02\u05EF\u05EE\x03\x02\x02\x02\u05F0\x8a\x03\x02\x02\x02\u05F1\u05F5\x05{=\x02\u05F2\u05F5\x07\v\x02\x02\u05F3\u05F5\x05\x87C\x02\u05F4\u05F1\x03\x02\x02\x02\u05F4\u05F2\x03\x02\x02\x02\u05F4\u05F3\x03\x02\x02\x02\u05F5\x8c\x03\x02\x02\x02\u05F6\u05F7\x07/\x02\x02\u05F7\x8e\x03\x02\x02\x02\u05F8\u05F9	\x07\x02\x02\u05F9\x90\x03\x02\x02\x02\u05FA\u05FB	\b\x02\x02\u05FB\x92\x03\x02\x02\x02\u05FC\u05FD		\x02\x02\u05FD\x94\x03\x02\x02\x02\u05FE\u05FF	\n\x02\x02\u05FF\x96\x03\x02\x02\x02\u0600\u0601	\v\x02\x02\u0601\x98\x03\x02\x02\x02\u0602\u0603	\f\x02\x02\u0603\x9a\x03\x02\x02\x02\u0604\u0605	\r\x02\x02\u0605\x9c\x03\x02\x02\x02\u0606\u0607	\x0e\x02\x02\u0607\x9e\x03\x02\x02\x02\u0608\u0609	\x0f\x02\x02\u0609\xa0\x03\x02\x02\x02\u060A\u060B	\x10\x02\x02\u060B\xa2\x03\x02\x02\x02\u060C\u060D	\x11\x02\x02\u060D\xa4\x03\x02\x02\x02\u060E\u060F	\x12\x02\x02\u060F\xa6\x03\x02\x02\x02\u0610\u0611	\x13\x02\x02\u0611\xa8\x03\x02\x02\x02\u0612\u0613	\x14\x02\x02\u0613\xaa\x03\x02\x02\x02\u0614\u0615	\x15\x02\x02\u0615\xac\x03\x02\x02\x02\u0616\u0617	\x16\x02\x02\u0617\xae\x03\x02\x02\x02\u0618\u0619	\x17\x02\x02\u0619\xb0\x03\x02\x02\x02\u061A\u061B	\x18\x02\x02\u061B\xb2\x03\x02\x02\x02\u061C\u061D	\x19\x02\x02\u061D\xb4\x03\x02\x02\x02\u061E\u061F	\x1a\x02\x02\u061F\xb6\x03\x02\x02\x02\u0620\u0621	\x1b\x02\x02\u0621\xb8\x03\x02\x02\x02\u0622\u0623	\x1c\x02\x02\u0623\xba\x03\x02\x02\x02\u0624\u0625	\x1d\x02\x02\u0625\xbc\x03\x02\x02\x02\u0626\u0627	\x1e\x02\x02\u0627\xbe\x03\x02\x02\x02\u0628\u0629	\x1f\x02\x02\u0629\xc0\x03\x02\x02\x02\u062A\u062B	 \x02\x02\u062B\xc2\x03\x02\x02\x02\u062C\u062D	!\x02\x02\u062D\xc4\x03\x02\x02\x02\x14\x02\x03\x04\xfb\u0102\u0113\u0155\u015B\u0581\u0585\u0587\u058C\u059A\u05AC\u05E2\u05E6\u05EF\u05F4\x07\x05\x02\x02\x04\x03\x02\x04\x04\x02\x02\x03\x02\x04\x02\x02';
    }
    static{
        this._serializedATN = $5lo68.join([
            $6dcaf930f1fe9510$export$375c79404cc64c7f._serializedATNSegment0,
            $6dcaf930f1fe9510$export$375c79404cc64c7f._serializedATNSegment1,
            $6dcaf930f1fe9510$export$375c79404cc64c7f._serializedATNSegment2
        ], '');
    }
    static get _ATN() {
        if (!$6dcaf930f1fe9510$export$375c79404cc64c7f.__ATN) $6dcaf930f1fe9510$export$375c79404cc64c7f.__ATN = new (0, $1HaB7.ATNDeserializer)().deserialize($5lo68.toCharArray($6dcaf930f1fe9510$export$375c79404cc64c7f._serializedATN));
        return $6dcaf930f1fe9510$export$375c79404cc64c7f.__ATN;
    }
}

});

parcelRegister("bidr5", function(module, exports) {
$parcel$export(module.exports, "JQLParser", () => $74d8442d41ec6752$export$9c4772e191bdb810);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLParser.g4 by ANTLR 4.7.3-SNAPSHOT

var $1HaB7 = parcelRequire("1HaB7");

var $1O6nA = parcelRequire("1O6nA");

var $5ncBC = parcelRequire("5ncBC");

var $gN8af = parcelRequire("gN8af");

var $e3RBK = parcelRequire("e3RBK");

var $2XZxT = parcelRequire("2XZxT");

var $iLVZN = parcelRequire("iLVZN");

var $7DbrH = parcelRequire("7DbrH");

var $5lo68 = parcelRequire("5lo68");
class $74d8442d41ec6752$export$9c4772e191bdb810 extends (0, $5ncBC.Parser) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.RULE_jqlQuery = 0;
    }
    static{
        this.RULE_jqlWhere = 1;
    }
    static{
        this.RULE_jqlOrClause = 2;
    }
    static{
        this.RULE_jqlAndClause = 3;
    }
    static{
        this.RULE_jqlNotClause = 4;
    }
    static{
        this.RULE_jqlSubClause = 5;
    }
    static{
        this.RULE_jqlTerminalClause = 6;
    }
    static{
        this.RULE_jqlTerminalClauseRhs = 7;
    }
    static{
        this.RULE_jqlEqualsOperator = 8;
    }
    static{
        this.RULE_jqlLikeOperator = 9;
    }
    static{
        this.RULE_jqlComparisonOperator = 10;
    }
    static{
        this.RULE_jqlInOperator = 11;
    }
    static{
        this.RULE_jqlIsOperator = 12;
    }
    static{
        this.RULE_jqlWasOperator = 13;
    }
    static{
        this.RULE_jqlWasInOperator = 14;
    }
    static{
        this.RULE_jqlChangedOperator = 15;
    }
    static{
        this.RULE_jqlField = 16;
    }
    static{
        this.RULE_jqlFieldProperty = 17;
    }
    static{
        this.RULE_jqlCustomField = 18;
    }
    static{
        this.RULE_jqlString = 19;
    }
    static{
        this.RULE_jqlNumber = 20;
    }
    static{
        this.RULE_jqlOperand = 21;
    }
    static{
        this.RULE_jqlEmpty = 22;
    }
    static{
        this.RULE_jqlValue = 23;
    }
    static{
        this.RULE_jqlFunction = 24;
    }
    static{
        this.RULE_jqlFunctionName = 25;
    }
    static{
        this.RULE_jqlArgumentList = 26;
    }
    static{
        this.RULE_jqlList = 27;
    }
    static{
        this.RULE_jqlListStart = 28;
    }
    static{
        this.RULE_jqlListEnd = 29;
    }
    static{
        this.RULE_jqlPropertyArgument = 30;
    }
    static{
        this.RULE_jqlArgument = 31;
    }
    static{
        this.RULE_jqlWasPredicate = 32;
    }
    static{
        this.RULE_jqlChangedPredicate = 33;
    }
    static{
        this.RULE_jqlDatePredicateOperator = 34;
    }
    static{
        this.RULE_jqlDateRangePredicateOperator = 35;
    }
    static{
        this.RULE_jqlUserPredicateOperator = 36;
    }
    static{
        this.RULE_jqlValuePredicateOperator = 37;
    }
    static{
        this.RULE_jqlPredicateOperand = 38;
    }
    static{
        this.RULE_jqlOrderBy = 39;
    }
    static{
        this.RULE_jqlSearchSort = 40;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.ruleNames = [
            'jqlQuery',
            'jqlWhere',
            'jqlOrClause',
            'jqlAndClause',
            'jqlNotClause',
            'jqlSubClause',
            'jqlTerminalClause',
            'jqlTerminalClauseRhs',
            'jqlEqualsOperator',
            'jqlLikeOperator',
            'jqlComparisonOperator',
            'jqlInOperator',
            'jqlIsOperator',
            'jqlWasOperator',
            'jqlWasInOperator',
            'jqlChangedOperator',
            'jqlField',
            'jqlFieldProperty',
            'jqlCustomField',
            'jqlString',
            'jqlNumber',
            'jqlOperand',
            'jqlEmpty',
            'jqlValue',
            'jqlFunction',
            'jqlFunctionName',
            'jqlArgumentList',
            'jqlList',
            'jqlListStart',
            'jqlListEnd',
            'jqlPropertyArgument',
            'jqlArgument',
            'jqlWasPredicate',
            'jqlChangedPredicate',
            'jqlDatePredicateOperator',
            'jqlDateRangePredicateOperator',
            'jqlUserPredicateOperator',
            'jqlValuePredicateOperator',
            'jqlPredicateOperand',
            'jqlOrderBy',
            'jqlSearchSort'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $7DbrH.VocabularyImpl)($74d8442d41ec6752$export$9c4772e191bdb810._LITERAL_NAMES, $74d8442d41ec6752$export$9c4772e191bdb810._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    // @Override
    get grammarFileName() {
        return 'JQLParser.g4';
    }
    // @Override
    get ruleNames() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $74d8442d41ec6752$export$9c4772e191bdb810._serializedATN;
    }
    constructor(input){
        super(input);
        this._interp = new (0, $e3RBK.ParserATNSimulator)($74d8442d41ec6752$export$9c4772e191bdb810._ATN, this);
    }
    // @RuleVersion(0)
    jqlQuery() {
        let _localctx = new $74d8442d41ec6752$export$ff413535b9575c8(this._ctx, this.state);
        this.enterRule(_localctx, 0, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlQuery);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 83;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la & -32) === 0 && (1 << _la & (1 << $74d8442d41ec6752$export$9c4772e191bdb810.LPAREN | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.BANG | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.NOT)) !== 0 || (_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $74d8442d41ec6752$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.CUSTOMFIELD - 33 | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.STRING - 33 | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 82;
                this.jqlWhere();
            }
            this.state = 86;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $74d8442d41ec6752$export$9c4772e191bdb810.ORDER) {
                this.state = 85;
                this.jqlOrderBy();
            }
            this.state = 88;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.EOF);
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWhere() {
        let _localctx = new $74d8442d41ec6752$export$4148a879cab28017(this._ctx, this.state);
        this.enterRule(_localctx, 2, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlWhere);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 90;
            this.jqlOrClause();
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrClause() {
        let _localctx = new $74d8442d41ec6752$export$d69831d387793480(this._ctx, this.state);
        this.enterRule(_localctx, 4, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlOrClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 92;
            this.jqlAndClause();
            this.state = 97;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $74d8442d41ec6752$export$9c4772e191bdb810.OR){
                this.state = 93;
                this.match($74d8442d41ec6752$export$9c4772e191bdb810.OR);
                this.state = 94;
                this.jqlAndClause();
                this.state = 99;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlAndClause() {
        let _localctx = new $74d8442d41ec6752$export$f16819001158b9e(this._ctx, this.state);
        this.enterRule(_localctx, 6, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlAndClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 100;
            this.jqlNotClause();
            this.state = 105;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $74d8442d41ec6752$export$9c4772e191bdb810.AND){
                this.state = 101;
                this.match($74d8442d41ec6752$export$9c4772e191bdb810.AND);
                this.state = 102;
                this.jqlNotClause();
                this.state = 107;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNotClause() {
        let _localctx = new $74d8442d41ec6752$export$5e9146f8d5cf1330(this._ctx, this.state);
        this.enterRule(_localctx, 8, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlNotClause);
        let _la;
        try {
            this.state = 112;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $74d8442d41ec6752$export$9c4772e191bdb810.BANG:
                case $74d8442d41ec6752$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 108;
                    _la = this._input.LA(1);
                    if (!(_la === $74d8442d41ec6752$export$9c4772e191bdb810.BANG || _la === $74d8442d41ec6752$export$9c4772e191bdb810.NOT)) this._errHandler.recoverInline(this);
                    else {
                        if (this._input.LA(1) === (0, $iLVZN.Token).EOF) this.matchedEOF = true;
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 109;
                    this.jqlNotClause();
                    break;
                case $74d8442d41ec6752$export$9c4772e191bdb810.LPAREN:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 110;
                    this.jqlSubClause();
                    break;
                case $74d8442d41ec6752$export$9c4772e191bdb810.POSNUMBER:
                case $74d8442d41ec6752$export$9c4772e191bdb810.NEGNUMBER:
                case $74d8442d41ec6752$export$9c4772e191bdb810.CUSTOMFIELD:
                case $74d8442d41ec6752$export$9c4772e191bdb810.STRING:
                case $74d8442d41ec6752$export$9c4772e191bdb810.QUOTE_STRING:
                case $74d8442d41ec6752$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 111;
                    this.jqlTerminalClause();
                    break;
                default:
                    throw new (0, $1O6nA.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSubClause() {
        let _localctx = new $74d8442d41ec6752$export$a136a0e9655bfb04(this._ctx, this.state);
        this.enterRule(_localctx, 10, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlSubClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 114;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.LPAREN);
            this.state = 115;
            this.jqlOrClause();
            this.state = 116;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClause() {
        let _localctx = new $74d8442d41ec6752$export$23486a2f2ddd5bcd(this._ctx, this.state);
        this.enterRule(_localctx, 12, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlTerminalClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 118;
            this.jqlField();
            this.state = 119;
            this.jqlTerminalClauseRhs();
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClauseRhs() {
        let _localctx = new $74d8442d41ec6752$export$93924a205c12d32c(this._ctx, this.state);
        this.enterRule(_localctx, 14, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs);
        let _la;
        try {
            this.state = 176;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 14, this._ctx)){
                case 1:
                    _localctx = new $74d8442d41ec6752$export$c428f709a58396e5(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 121;
                    this.jqlEqualsOperator();
                    this.state = 125;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 5, this._ctx)){
                        case 1:
                            this.state = 122;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 123;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 124;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 2:
                    _localctx = new $74d8442d41ec6752$export$1b131204ef9fa33d(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 127;
                    this.jqlLikeOperator();
                    this.state = 131;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 6, this._ctx)){
                        case 1:
                            this.state = 128;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 129;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 130;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 3:
                    _localctx = new $74d8442d41ec6752$export$d83706ee80a9852a(_localctx);
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 133;
                    this.jqlComparisonOperator();
                    this.state = 136;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 7, this._ctx)){
                        case 1:
                            this.state = 134;
                            this.jqlValue();
                            break;
                        case 2:
                            this.state = 135;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 4:
                    _localctx = new $74d8442d41ec6752$export$2934b8ff22fddd2d(_localctx);
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 138;
                    this.jqlInOperator();
                    this.state = 141;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $74d8442d41ec6752$export$9c4772e191bdb810.LPAREN:
                            this.state = 139;
                            this.jqlList();
                            break;
                        case $74d8442d41ec6752$export$9c4772e191bdb810.POSNUMBER:
                        case $74d8442d41ec6752$export$9c4772e191bdb810.NEGNUMBER:
                        case $74d8442d41ec6752$export$9c4772e191bdb810.STRING:
                        case $74d8442d41ec6752$export$9c4772e191bdb810.QUOTE_STRING:
                        case $74d8442d41ec6752$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 140;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $1O6nA.NoViableAltException)(this);
                    }
                    break;
                case 5:
                    _localctx = new $74d8442d41ec6752$export$8b84310182afcf93(_localctx);
                    this.enterOuterAlt(_localctx, 5);
                    this.state = 143;
                    this.jqlIsOperator();
                    this.state = 144;
                    this.jqlEmpty();
                    break;
                case 6:
                    _localctx = new $74d8442d41ec6752$export$5df295dc7a2cac7c(_localctx);
                    this.enterOuterAlt(_localctx, 6);
                    this.state = 146;
                    this.jqlWasOperator();
                    this.state = 150;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 9, this._ctx)){
                        case 1:
                            this.state = 147;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 148;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 149;
                            this.jqlFunction();
                            break;
                    }
                    this.state = 155;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $74d8442d41ec6752$export$9c4772e191bdb810.BEFORE | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.AFTER | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.ON | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.DURING | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 152;
                        this.jqlWasPredicate();
                        this.state = 157;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 7:
                    _localctx = new $74d8442d41ec6752$export$9ac3367aee261b32(_localctx);
                    this.enterOuterAlt(_localctx, 7);
                    this.state = 158;
                    this.jqlWasInOperator();
                    this.state = 161;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $74d8442d41ec6752$export$9c4772e191bdb810.LPAREN:
                            this.state = 159;
                            this.jqlList();
                            break;
                        case $74d8442d41ec6752$export$9c4772e191bdb810.POSNUMBER:
                        case $74d8442d41ec6752$export$9c4772e191bdb810.NEGNUMBER:
                        case $74d8442d41ec6752$export$9c4772e191bdb810.STRING:
                        case $74d8442d41ec6752$export$9c4772e191bdb810.QUOTE_STRING:
                        case $74d8442d41ec6752$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 160;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $1O6nA.NoViableAltException)(this);
                    }
                    this.state = 166;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $74d8442d41ec6752$export$9c4772e191bdb810.BEFORE | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.AFTER | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.ON | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.DURING | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 163;
                        this.jqlWasPredicate();
                        this.state = 168;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 8:
                    _localctx = new $74d8442d41ec6752$export$7a7defca8628a13c(_localctx);
                    this.enterOuterAlt(_localctx, 8);
                    this.state = 169;
                    this.jqlChangedOperator();
                    this.state = 173;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $74d8442d41ec6752$export$9c4772e191bdb810.BEFORE | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.AFTER | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.FROM | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.TO | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.ON | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.DURING | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 170;
                        this.jqlChangedPredicate();
                        this.state = 175;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEqualsOperator() {
        let _localctx = new $74d8442d41ec6752$export$41e475fc1988e413(this._ctx, this.state);
        this.enterRule(_localctx, 16, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlEqualsOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 178;
            _la = this._input.LA(1);
            if (!(_la === $74d8442d41ec6752$export$9c4772e191bdb810.EQUALS || _la === $74d8442d41ec6752$export$9c4772e191bdb810.NOT_EQUALS)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $iLVZN.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlLikeOperator() {
        let _localctx = new $74d8442d41ec6752$export$b76fe5387fdd7efd(this._ctx, this.state);
        this.enterRule(_localctx, 18, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlLikeOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 180;
            _la = this._input.LA(1);
            if (!(_la === $74d8442d41ec6752$export$9c4772e191bdb810.LIKE || _la === $74d8442d41ec6752$export$9c4772e191bdb810.NOT_LIKE)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $iLVZN.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlComparisonOperator() {
        let _localctx = new $74d8442d41ec6752$export$d821da0716b3ec95(this._ctx, this.state);
        this.enterRule(_localctx, 20, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlComparisonOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 182;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $74d8442d41ec6752$export$9c4772e191bdb810.LT | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.GT | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.GTEQ | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.LTEQ)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $iLVZN.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlInOperator() {
        let _localctx = new $74d8442d41ec6752$export$178478bfa8292f72(this._ctx, this.state);
        this.enterRule(_localctx, 22, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlInOperator);
        try {
            this.state = 187;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $74d8442d41ec6752$export$9c4772e191bdb810.IN:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 184;
                    this.match($74d8442d41ec6752$export$9c4772e191bdb810.IN);
                    break;
                case $74d8442d41ec6752$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 185;
                    this.match($74d8442d41ec6752$export$9c4772e191bdb810.NOT);
                    this.state = 186;
                    this.match($74d8442d41ec6752$export$9c4772e191bdb810.IN);
                    break;
                default:
                    throw new (0, $1O6nA.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlIsOperator() {
        let _localctx = new $74d8442d41ec6752$export$e64c31d2830b66e4(this._ctx, this.state);
        this.enterRule(_localctx, 24, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlIsOperator);
        try {
            this.state = 192;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 16, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 189;
                    this.match($74d8442d41ec6752$export$9c4772e191bdb810.IS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 190;
                    this.match($74d8442d41ec6752$export$9c4772e191bdb810.IS);
                    this.state = 191;
                    this.match($74d8442d41ec6752$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasOperator() {
        let _localctx = new $74d8442d41ec6752$export$7e283636700e4a6c(this._ctx, this.state);
        this.enterRule(_localctx, 26, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlWasOperator);
        try {
            this.state = 197;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 17, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 194;
                    this.match($74d8442d41ec6752$export$9c4772e191bdb810.WAS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 195;
                    this.match($74d8442d41ec6752$export$9c4772e191bdb810.WAS);
                    this.state = 196;
                    this.match($74d8442d41ec6752$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasInOperator() {
        let _localctx = new $74d8442d41ec6752$export$b9118b1ed9a78d66(this._ctx, this.state);
        this.enterRule(_localctx, 28, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlWasInOperator);
        try {
            this.state = 204;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 18, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 199;
                    this.match($74d8442d41ec6752$export$9c4772e191bdb810.WAS);
                    this.state = 200;
                    this.match($74d8442d41ec6752$export$9c4772e191bdb810.IN);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 201;
                    this.match($74d8442d41ec6752$export$9c4772e191bdb810.WAS);
                    this.state = 202;
                    this.match($74d8442d41ec6752$export$9c4772e191bdb810.NOT);
                    this.state = 203;
                    this.match($74d8442d41ec6752$export$9c4772e191bdb810.IN);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedOperator() {
        let _localctx = new $74d8442d41ec6752$export$493d626ed78ca66(this._ctx, this.state);
        this.enterRule(_localctx, 30, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlChangedOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 206;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.CHANGED);
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlField() {
        let _localctx = new $74d8442d41ec6752$export$b33300c3d916229a(this._ctx, this.state);
        this.enterRule(_localctx, 32, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlField);
        let _la;
        try {
            this.state = 219;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $74d8442d41ec6752$export$9c4772e191bdb810.POSNUMBER:
                case $74d8442d41ec6752$export$9c4772e191bdb810.NEGNUMBER:
                    _localctx = new $74d8442d41ec6752$export$11fec15307d2e17b(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 208;
                    this.jqlNumber();
                    break;
                case $74d8442d41ec6752$export$9c4772e191bdb810.CUSTOMFIELD:
                case $74d8442d41ec6752$export$9c4772e191bdb810.STRING:
                case $74d8442d41ec6752$export$9c4772e191bdb810.QUOTE_STRING:
                case $74d8442d41ec6752$export$9c4772e191bdb810.SQUOTE_STRING:
                    _localctx = new $74d8442d41ec6752$export$b8b24f99f985ebb3(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 211;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $74d8442d41ec6752$export$9c4772e191bdb810.STRING:
                        case $74d8442d41ec6752$export$9c4772e191bdb810.QUOTE_STRING:
                        case $74d8442d41ec6752$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 209;
                            this.jqlString();
                            break;
                        case $74d8442d41ec6752$export$9c4772e191bdb810.CUSTOMFIELD:
                            this.state = 210;
                            this.jqlCustomField();
                            break;
                        default:
                            throw new (0, $1O6nA.NoViableAltException)(this);
                    }
                    this.state = 216;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la === $74d8442d41ec6752$export$9c4772e191bdb810.LBRACKET){
                        this.state = 213;
                        this.jqlFieldProperty();
                        this.state = 218;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                default:
                    throw new (0, $1O6nA.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFieldProperty() {
        let _localctx = new $74d8442d41ec6752$export$b02d0b6637ce0593(this._ctx, this.state);
        this.enterRule(_localctx, 34, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlFieldProperty);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 221;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.LBRACKET);
            this.state = 222;
            this.jqlArgument();
            this.state = 223;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.RBRACKET);
            this.state = 228;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $74d8442d41ec6752$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.STRING - 33 | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0){
                this.state = 225;
                this.jqlPropertyArgument();
                this.state = 230;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlCustomField() {
        let _localctx = new $74d8442d41ec6752$export$401a038855cc5b15(this._ctx, this.state);
        this.enterRule(_localctx, 36, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlCustomField);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 231;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.CUSTOMFIELD);
            this.state = 232;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.LBRACKET);
            this.state = 233;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.POSNUMBER);
            this.state = 234;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.RBRACKET);
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlString() {
        let _localctx = new $74d8442d41ec6752$export$bde73d8ad7c8b71e(this._ctx, this.state);
        this.enterRule(_localctx, 38, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlString);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 236;
            _la = this._input.LA(1);
            if (!((_la - 37 & -32) === 0 && (1 << _la - 37 & (1 << $74d8442d41ec6752$export$9c4772e191bdb810.STRING - 37 | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.QUOTE_STRING - 37 | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.SQUOTE_STRING - 37)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $iLVZN.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNumber() {
        let _localctx = new $74d8442d41ec6752$export$8737d94a1880e8b3(this._ctx, this.state);
        this.enterRule(_localctx, 40, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlNumber);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 238;
            _localctx._jqlNum = this._input.LT(1);
            _la = this._input.LA(1);
            if (!(_la === $74d8442d41ec6752$export$9c4772e191bdb810.POSNUMBER || _la === $74d8442d41ec6752$export$9c4772e191bdb810.NEGNUMBER)) _localctx._jqlNum = this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $iLVZN.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOperand() {
        let _localctx = new $74d8442d41ec6752$export$2eaac5a9828bf647(this._ctx, this.state);
        this.enterRule(_localctx, 42, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlOperand);
        try {
            this.state = 244;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 23, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 240;
                    this.jqlEmpty();
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 241;
                    this.jqlValue();
                    break;
                case 3:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 242;
                    this.jqlFunction();
                    break;
                case 4:
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 243;
                    this.jqlList();
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEmpty() {
        let _localctx = new $74d8442d41ec6752$export$d85a062f90025e5c(this._ctx, this.state);
        this.enterRule(_localctx, 44, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlEmpty);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 246;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.EMPTY);
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValue() {
        let _localctx = new $74d8442d41ec6752$export$2e17d457b0933bec(this._ctx, this.state);
        this.enterRule(_localctx, 46, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlValue);
        try {
            this.state = 250;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $74d8442d41ec6752$export$9c4772e191bdb810.STRING:
                case $74d8442d41ec6752$export$9c4772e191bdb810.QUOTE_STRING:
                case $74d8442d41ec6752$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 248;
                    this.jqlString();
                    break;
                case $74d8442d41ec6752$export$9c4772e191bdb810.POSNUMBER:
                case $74d8442d41ec6752$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 249;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $1O6nA.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunction() {
        let _localctx = new $74d8442d41ec6752$export$ebf0cc785e9ee41a(this._ctx, this.state);
        this.enterRule(_localctx, 48, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlFunction);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 252;
            this.jqlFunctionName();
            this.state = 253;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.LPAREN);
            this.state = 255;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $74d8442d41ec6752$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.STRING - 33 | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 254;
                this.jqlArgumentList();
            }
            this.state = 257;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunctionName() {
        let _localctx = new $74d8442d41ec6752$export$1f5f7ac816788f44(this._ctx, this.state);
        this.enterRule(_localctx, 50, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlFunctionName);
        try {
            this.state = 261;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $74d8442d41ec6752$export$9c4772e191bdb810.STRING:
                case $74d8442d41ec6752$export$9c4772e191bdb810.QUOTE_STRING:
                case $74d8442d41ec6752$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 259;
                    this.jqlString();
                    break;
                case $74d8442d41ec6752$export$9c4772e191bdb810.POSNUMBER:
                case $74d8442d41ec6752$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 260;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $1O6nA.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgumentList() {
        let _localctx = new $74d8442d41ec6752$export$83d7c13849b931c3(this._ctx, this.state);
        this.enterRule(_localctx, 52, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlArgumentList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 263;
            this.jqlArgument();
            this.state = 268;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $74d8442d41ec6752$export$9c4772e191bdb810.COMMA){
                this.state = 264;
                this.match($74d8442d41ec6752$export$9c4772e191bdb810.COMMA);
                this.state = 265;
                this.jqlArgument();
                this.state = 270;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlList() {
        let _localctx = new $74d8442d41ec6752$export$9cb97a63f2be4864(this._ctx, this.state);
        this.enterRule(_localctx, 54, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 271;
            this.jqlListStart();
            this.state = 272;
            this.jqlOperand();
            this.state = 277;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $74d8442d41ec6752$export$9c4772e191bdb810.COMMA){
                this.state = 273;
                this.match($74d8442d41ec6752$export$9c4772e191bdb810.COMMA);
                this.state = 274;
                this.jqlOperand();
                this.state = 279;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 280;
            this.jqlListEnd();
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListStart() {
        let _localctx = new $74d8442d41ec6752$export$c419f717bfc46a5d(this._ctx, this.state);
        this.enterRule(_localctx, 56, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlListStart);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 282;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.LPAREN);
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListEnd() {
        let _localctx = new $74d8442d41ec6752$export$f6cd3e372f5ab120(this._ctx, this.state);
        this.enterRule(_localctx, 58, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlListEnd);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 284;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPropertyArgument() {
        let _localctx = new $74d8442d41ec6752$export$e20ce4a2ed16372c(this._ctx, this.state);
        this.enterRule(_localctx, 60, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlPropertyArgument);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 286;
            this.jqlArgument();
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgument() {
        let _localctx = new $74d8442d41ec6752$export$a95583953c237f88(this._ctx, this.state);
        this.enterRule(_localctx, 62, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlArgument);
        try {
            this.state = 290;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $74d8442d41ec6752$export$9c4772e191bdb810.STRING:
                case $74d8442d41ec6752$export$9c4772e191bdb810.QUOTE_STRING:
                case $74d8442d41ec6752$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 288;
                    this.jqlString();
                    break;
                case $74d8442d41ec6752$export$9c4772e191bdb810.POSNUMBER:
                case $74d8442d41ec6752$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 289;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $1O6nA.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasPredicate() {
        let _localctx = new $74d8442d41ec6752$export$9fa1e4d63f31b911(this._ctx, this.state);
        this.enterRule(_localctx, 64, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlWasPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 295;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $74d8442d41ec6752$export$9c4772e191bdb810.BEFORE:
                case $74d8442d41ec6752$export$9c4772e191bdb810.AFTER:
                case $74d8442d41ec6752$export$9c4772e191bdb810.ON:
                    this.state = 292;
                    this.jqlDatePredicateOperator();
                    break;
                case $74d8442d41ec6752$export$9c4772e191bdb810.DURING:
                    this.state = 293;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $74d8442d41ec6752$export$9c4772e191bdb810.BY:
                    this.state = 294;
                    this.jqlUserPredicateOperator();
                    break;
                default:
                    throw new (0, $1O6nA.NoViableAltException)(this);
            }
            this.state = 297;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedPredicate() {
        let _localctx = new $74d8442d41ec6752$export$e77e479a48133015(this._ctx, this.state);
        this.enterRule(_localctx, 66, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlChangedPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 303;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $74d8442d41ec6752$export$9c4772e191bdb810.BEFORE:
                case $74d8442d41ec6752$export$9c4772e191bdb810.AFTER:
                case $74d8442d41ec6752$export$9c4772e191bdb810.ON:
                    this.state = 299;
                    this.jqlDatePredicateOperator();
                    break;
                case $74d8442d41ec6752$export$9c4772e191bdb810.DURING:
                    this.state = 300;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $74d8442d41ec6752$export$9c4772e191bdb810.BY:
                    this.state = 301;
                    this.jqlUserPredicateOperator();
                    break;
                case $74d8442d41ec6752$export$9c4772e191bdb810.FROM:
                case $74d8442d41ec6752$export$9c4772e191bdb810.TO:
                    this.state = 302;
                    this.jqlValuePredicateOperator();
                    break;
                default:
                    throw new (0, $1O6nA.NoViableAltException)(this);
            }
            this.state = 305;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDatePredicateOperator() {
        let _localctx = new $74d8442d41ec6752$export$dc01290aee731418(this._ctx, this.state);
        this.enterRule(_localctx, 68, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 307;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $74d8442d41ec6752$export$9c4772e191bdb810.BEFORE | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.AFTER | 1 << $74d8442d41ec6752$export$9c4772e191bdb810.ON)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $iLVZN.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDateRangePredicateOperator() {
        let _localctx = new $74d8442d41ec6752$export$75412b8b6a6442e1(this._ctx, this.state);
        this.enterRule(_localctx, 70, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 309;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.DURING);
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlUserPredicateOperator() {
        let _localctx = new $74d8442d41ec6752$export$ad402332075c8656(this._ctx, this.state);
        this.enterRule(_localctx, 72, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 311;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.BY);
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValuePredicateOperator() {
        let _localctx = new $74d8442d41ec6752$export$4239d7c0fbafd3f1(this._ctx, this.state);
        this.enterRule(_localctx, 74, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 313;
            _la = this._input.LA(1);
            if (!(_la === $74d8442d41ec6752$export$9c4772e191bdb810.FROM || _la === $74d8442d41ec6752$export$9c4772e191bdb810.TO)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $iLVZN.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPredicateOperand() {
        let _localctx = new $74d8442d41ec6752$export$6b796c5a4b8c18e(this._ctx, this.state);
        this.enterRule(_localctx, 76, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlPredicateOperand);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 315;
            this.jqlOperand();
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrderBy() {
        let _localctx = new $74d8442d41ec6752$export$534469b9c8f44139(this._ctx, this.state);
        this.enterRule(_localctx, 78, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlOrderBy);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 317;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.ORDER);
            this.state = 318;
            this.match($74d8442d41ec6752$export$9c4772e191bdb810.BY);
            this.state = 319;
            this.jqlSearchSort();
            this.state = 324;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $74d8442d41ec6752$export$9c4772e191bdb810.COMMA){
                this.state = 320;
                this.match($74d8442d41ec6752$export$9c4772e191bdb810.COMMA);
                this.state = 321;
                this.jqlSearchSort();
                this.state = 326;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSearchSort() {
        let _localctx = new $74d8442d41ec6752$export$c7d8f03f36952a46(this._ctx, this.state);
        this.enterRule(_localctx, 80, $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlSearchSort);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 327;
            this.jqlField();
            this.state = 329;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $74d8442d41ec6752$export$9c4772e191bdb810.ASC || _la === $74d8442d41ec6752$export$9c4772e191bdb810.DESC) {
                this.state = 328;
                _la = this._input.LA(1);
                if (!(_la === $74d8442d41ec6752$export$9c4772e191bdb810.ASC || _la === $74d8442d41ec6752$export$9c4772e191bdb810.DESC)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $iLVZN.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        } catch (re) {
            if (re instanceof (0, $2XZxT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    static{
        this._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x030\u014E\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04"	"\x04#	#\x04$	$\x04%	%\x04&	&\x04\'	\'\x04(	(\x04)	)\x04*	*\x03\x02\x05\x02V\n\x02\x03\x02\x05\x02Y\n\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04b\n\x04\f\x04\x0e\x04e\v\x04\x03\x05\x03\x05\x03\x05\x07\x05j\n\x05\f\x05\x0e\x05m\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06s\n\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03	\x03	\x03	\x03	\x05	\x80\n	\x03	\x03	\x03	\x03	\x05	\x86\n	\x03	\x03	\x03	\x05	\x8b\n	\x03	\x03	\x03	\x05	\x90\n	\x03	\x03	\x03	\x03	\x03	\x03	\x03	\x05	\x99\n	\x03	\x07	\x9c\n	\f	\x0e	\x9f\v	\x03	\x03	\x03	\x05	\xa4\n	\x03	\x07	\xa7\n	\f	\x0e	\xaa\v	\x03	\x03	\x07	\xae\n	\f	\x0e	\xb1\v	\x05	\xb3\n	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x05\r\xbe\n\r\x03\x0e\x03\x0e\x03\x0e\x05\x0e\xc3\n\x0e\x03\x0f\x03\x0f\x03\x0f\x05\x0f\xc8\n\x0f\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x05\x10\xcf\n\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x05\x12\xd6\n\x12\x03\x12\x07\x12\xd9\n\x12\f\x12\x0e\x12\xdc\v\x12\x05\x12\xde\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x03\x13\x07\x13\xe5\n\x13\f\x13\x0e\x13\xe8\v\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\xf7\n\x17\x03\x18\x03\x18\x03\x19\x03\x19\x05\x19\xfd\n\x19\x03\x1a\x03\x1a\x03\x1a\x05\x1a\u0102\n\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x05\x1b\u0108\n\x1b\x03\x1c\x03\x1c\x03\x1c\x07\x1c\u010D\n\x1c\f\x1c\x0e\x1c\u0110\v\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1d\x07\x1d\u0116\n\x1d\f\x1d\x0e\x1d\u0119\v\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03 \x03 \x03!\x03!\x05!\u0125\n!\x03"\x03"\x03"\x05"\u012A\n"\x03"\x03"\x03#\x03#\x03#\x03#\x05#\u0132\n#\x03#\x03#\x03$\x03$\x03%\x03%\x03&\x03&\x03\'\x03\'\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x07)\u0145\n)\f)\x0e)\u0148\v)\x03*\x03*\x05*\u014C\n*\x03*\x02\x02\x02+\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0e\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1a\x02\x1c\x02\x1e\x02 \x02"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x028\x02:\x02<\x02>\x02@\x02B\x02D\x02F\x02H\x02J\x02L\x02N\x02P\x02R\x02\x02\v\x04\x02\b\b\x15\x15\x03\x02\r\x0e\x03\x02\x0f\x10\x03\x02	\f\x05\x02\'\'++..\x03\x02#$\x04\x02\x19\x1a\x1d\x1d\x03\x02\x1b\x1c\x03\x02!"\x02\u0155\x02U\x03\x02\x02\x02\x04\\\x03\x02\x02\x02\x06^\x03\x02\x02\x02\bf\x03\x02\x02\x02\nr\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0ex\x03\x02\x02\x02\x10\xb2\x03\x02\x02\x02\x12\xb4\x03\x02\x02\x02\x14\xb6\x03\x02\x02\x02\x16\xb8\x03\x02\x02\x02\x18\xbd\x03\x02\x02\x02\x1a\xc2\x03\x02\x02\x02\x1c\xc7\x03\x02\x02\x02\x1e\xce\x03\x02\x02\x02 \xd0\x03\x02\x02\x02"\xdd\x03\x02\x02\x02$\xdf\x03\x02\x02\x02&\xe9\x03\x02\x02\x02(\xee\x03\x02\x02\x02*\xf0\x03\x02\x02\x02,\xf6\x03\x02\x02\x02.\xf8\x03\x02\x02\x020\xfc\x03\x02\x02\x022\xfe\x03\x02\x02\x024\u0107\x03\x02\x02\x026\u0109\x03\x02\x02\x028\u0111\x03\x02\x02\x02:\u011C\x03\x02\x02\x02<\u011E\x03\x02\x02\x02>\u0120\x03\x02\x02\x02@\u0124\x03\x02\x02\x02B\u0129\x03\x02\x02\x02D\u0131\x03\x02\x02\x02F\u0135\x03\x02\x02\x02H\u0137\x03\x02\x02\x02J\u0139\x03\x02\x02\x02L\u013B\x03\x02\x02\x02N\u013D\x03\x02\x02\x02P\u013F\x03\x02\x02\x02R\u0149\x03\x02\x02\x02TV\x05\x04\x03\x02UT\x03\x02\x02\x02UV\x03\x02\x02\x02VX\x03\x02\x02\x02WY\x05P)\x02XW\x03\x02\x02\x02XY\x03\x02\x02\x02YZ\x03\x02\x02\x02Z[\x07\x02\x02\x03[\x03\x03\x02\x02\x02\\]\x05\x06\x04\x02]\x05\x03\x02\x02\x02^c\x05\b\x05\x02_`\x07\x14\x02\x02`b\x05\b\x05\x02a_\x03\x02\x02\x02be\x03\x02\x02\x02ca\x03\x02\x02\x02cd\x03\x02\x02\x02d\x07\x03\x02\x02\x02ec\x03\x02\x02\x02fk\x05\n\x06\x02gh\x07\x13\x02\x02hj\x05\n\x06\x02ig\x03\x02\x02\x02jm\x03\x02\x02\x02ki\x03\x02\x02\x02kl\x03\x02\x02\x02l	\x03\x02\x02\x02mk\x03\x02\x02\x02no	\x02\x02\x02os\x05\n\x06\x02ps\x05\f\x07\x02qs\x05\x0e\b\x02rn\x03\x02\x02\x02rp\x03\x02\x02\x02rq\x03\x02\x02\x02s\v\x03\x02\x02\x02tu\x07\x03\x02\x02uv\x05\x06\x04\x02vw\x07\x04\x02\x02w\r\x03\x02\x02\x02xy\x05"\x12\x02yz\x05\x10	\x02z\x0f\x03\x02\x02\x02{\x7f\x05\x12\n\x02|\x80\x05.\x18\x02}\x80\x050\x19\x02~\x80\x052\x1a\x02\x7f|\x03\x02\x02\x02\x7f}\x03\x02\x02\x02\x7f~\x03\x02\x02\x02\x80\xb3\x03\x02\x02\x02\x81\x85\x05\x14\v\x02\x82\x86\x05.\x18\x02\x83\x86\x050\x19\x02\x84\x86\x052\x1a\x02\x85\x82\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x84\x03\x02\x02\x02\x86\xb3\x03\x02\x02\x02\x87\x8a\x05\x16\f\x02\x88\x8b\x050\x19\x02\x89\x8b\x052\x1a\x02\x8a\x88\x03\x02\x02\x02\x8a\x89\x03\x02\x02\x02\x8b\xb3\x03\x02\x02\x02\x8c\x8f\x05\x18\r\x02\x8d\x90\x058\x1d\x02\x8e\x90\x052\x1a\x02\x8f\x8d\x03\x02\x02\x02\x8f\x8e\x03\x02\x02\x02\x90\xb3\x03\x02\x02\x02\x91\x92\x05\x1a\x0e\x02\x92\x93\x05.\x18\x02\x93\xb3\x03\x02\x02\x02\x94\x98\x05\x1c\x0f\x02\x95\x99\x05.\x18\x02\x96\x99\x050\x19\x02\x97\x99\x052\x1a\x02\x98\x95\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x97\x03\x02\x02\x02\x99\x9d\x03\x02\x02\x02\x9a\x9c\x05B"\x02\x9b\x9a\x03\x02\x02\x02\x9c\x9f\x03\x02\x02\x02\x9d\x9b\x03\x02\x02\x02\x9d\x9e\x03\x02\x02\x02\x9e\xb3\x03\x02\x02\x02\x9f\x9d\x03\x02\x02\x02\xa0\xa3\x05\x1e\x10\x02\xa1\xa4\x058\x1d\x02\xa2\xa4\x052\x1a\x02\xa3\xa1\x03\x02\x02\x02\xa3\xa2\x03\x02\x02\x02\xa4\xa8\x03\x02\x02\x02\xa5\xa7\x05B"\x02\xa6\xa5\x03\x02\x02\x02\xa7\xaa\x03\x02\x02\x02\xa8\xa6\x03\x02\x02\x02\xa8\xa9\x03\x02\x02\x02\xa9\xb3\x03\x02\x02\x02\xaa\xa8\x03\x02\x02\x02\xab\xaf\x05 \x11\x02\xac\xae\x05D#\x02\xad\xac\x03\x02\x02\x02\xae\xb1\x03\x02\x02\x02\xaf\xad\x03\x02\x02\x02\xaf\xb0\x03\x02\x02\x02\xb0\xb3\x03\x02\x02\x02\xb1\xaf\x03\x02\x02\x02\xb2{\x03\x02\x02\x02\xb2\x81\x03\x02\x02\x02\xb2\x87\x03\x02\x02\x02\xb2\x8c\x03\x02\x02\x02\xb2\x91\x03\x02\x02\x02\xb2\x94\x03\x02\x02\x02\xb2\xa0\x03\x02\x02\x02\xb2\xab\x03\x02\x02\x02\xb3\x11\x03\x02\x02\x02\xb4\xb5	\x03\x02\x02\xb5\x13\x03\x02\x02\x02\xb6\xb7	\x04\x02\x02\xb7\x15\x03\x02\x02\x02\xb8\xb9	\x05\x02\x02\xb9\x17\x03\x02\x02\x02\xba\xbe\x07\x11\x02\x02\xbb\xbc\x07\x15\x02\x02\xbc\xbe\x07\x11\x02\x02\xbd\xba\x03\x02\x02\x02\xbd\xbb\x03\x02\x02\x02\xbe\x19\x03\x02\x02\x02\xbf\xc3\x07\x12\x02\x02\xc0\xc1\x07\x12\x02\x02\xc1\xc3\x07\x15\x02\x02\xc2\xbf\x03\x02\x02\x02\xc2\xc0\x03\x02\x02\x02\xc3\x1b\x03\x02\x02\x02\xc4\xc8\x07\x17\x02\x02\xc5\xc6\x07\x17\x02\x02\xc6\xc8\x07\x15\x02\x02\xc7\xc4\x03\x02\x02\x02\xc7\xc5\x03\x02\x02\x02\xc8\x1d\x03\x02\x02\x02\xc9\xca\x07\x17\x02\x02\xca\xcf\x07\x11\x02\x02\xcb\xcc\x07\x17\x02\x02\xcc\xcd\x07\x15\x02\x02\xcd\xcf\x07\x11\x02\x02\xce\xc9\x03\x02\x02\x02\xce\xcb\x03\x02\x02\x02\xcf\x1f\x03\x02\x02\x02\xd0\xd1\x07\x18\x02\x02\xd1!\x03\x02\x02\x02\xd2\xde\x05*\x16\x02\xd3\xd6\x05(\x15\x02\xd4\xd6\x05&\x14\x02\xd5\xd3\x03\x02\x02\x02\xd5\xd4\x03\x02\x02\x02\xd6\xda\x03\x02\x02\x02\xd7\xd9\x05$\x13\x02\xd8\xd7\x03\x02\x02\x02\xd9\xdc\x03\x02\x02\x02\xda\xd8\x03\x02\x02\x02\xda\xdb\x03\x02\x02\x02\xdb\xde\x03\x02\x02\x02\xdc\xda\x03\x02\x02\x02\xdd\xd2\x03\x02\x02\x02\xdd\xd5\x03\x02\x02\x02\xde#\x03\x02\x02\x02\xdf\xe0\x07\x06\x02\x02\xe0\xe1\x05@!\x02\xe1\xe2\x07\x07\x02\x02\xe2\xe6\x03\x02\x02\x02\xe3\xe5\x05> \x02\xe4\xe3\x03\x02\x02\x02\xe5\xe8\x03\x02\x02\x02\xe6\xe4\x03\x02\x02\x02\xe6\xe7\x03\x02\x02\x02\xe7%\x03\x02\x02\x02\xe8\xe6\x03\x02\x02\x02\xe9\xea\x07%\x02\x02\xea\xeb\x07\x06\x02\x02\xeb\xec\x07#\x02\x02\xec\xed\x07\x07\x02\x02\xed\'\x03\x02\x02\x02\xee\xef	\x06\x02\x02\xef)\x03\x02\x02\x02\xf0\xf1	\x07\x02\x02\xf1+\x03\x02\x02\x02\xf2\xf7\x05.\x18\x02\xf3\xf7\x050\x19\x02\xf4\xf7\x052\x1a\x02\xf5\xf7\x058\x1d\x02\xf6\xf2\x03\x02\x02\x02\xf6\xf3\x03\x02\x02\x02\xf6\xf4\x03\x02\x02\x02\xf6\xf5\x03\x02\x02\x02\xf7-\x03\x02\x02\x02\xf8\xf9\x07\x16\x02\x02\xf9/\x03\x02\x02\x02\xfa\xfd\x05(\x15\x02\xfb\xfd\x05*\x16\x02\xfc\xfa\x03\x02\x02\x02\xfc\xfb\x03\x02\x02\x02\xfd1\x03\x02\x02\x02\xfe\xff\x054\x1b\x02\xff\u0101\x07\x03\x02\x02\u0100\u0102\x056\x1c\x02\u0101\u0100\x03\x02\x02\x02\u0101\u0102\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103\u0104\x07\x04\x02\x02\u01043\x03\x02\x02\x02\u0105\u0108\x05(\x15\x02\u0106\u0108\x05*\x16\x02\u0107\u0105\x03\x02\x02\x02\u0107\u0106\x03\x02\x02\x02\u01085\x03\x02\x02\x02\u0109\u010E\x05@!\x02\u010A\u010B\x07\x05\x02\x02\u010B\u010D\x05@!\x02\u010C\u010A\x03\x02\x02\x02\u010D\u0110\x03\x02\x02\x02\u010E\u010C\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F7\x03\x02\x02\x02\u0110\u010E\x03\x02\x02\x02\u0111\u0112\x05:\x1e\x02\u0112\u0117\x05,\x17\x02\u0113\u0114\x07\x05\x02\x02\u0114\u0116\x05,\x17\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0119\x03\x02\x02\x02\u0117\u0115\x03\x02\x02\x02\u0117\u0118\x03\x02\x02\x02\u0118\u011A\x03\x02\x02\x02\u0119\u0117\x03\x02\x02\x02\u011A\u011B\x05<\x1f\x02\u011B9\x03\x02\x02\x02\u011C\u011D\x07\x03\x02\x02\u011D;\x03\x02\x02\x02\u011E\u011F\x07\x04\x02\x02\u011F=\x03\x02\x02\x02\u0120\u0121\x05@!\x02\u0121?\x03\x02\x02\x02\u0122\u0125\x05(\x15\x02\u0123\u0125\x05*\x16\x02\u0124\u0122\x03\x02\x02\x02\u0124\u0123\x03\x02\x02\x02\u0125A\x03\x02\x02\x02\u0126\u012A\x05F$\x02\u0127\u012A\x05H%\x02\u0128\u012A\x05J&\x02\u0129\u0126\x03\x02\x02\x02\u0129\u0127\x03\x02\x02\x02\u0129\u0128\x03\x02\x02\x02\u012A\u012B\x03\x02\x02\x02\u012B\u012C\x05N(\x02\u012CC\x03\x02\x02\x02\u012D\u0132\x05F$\x02\u012E\u0132\x05H%\x02\u012F\u0132\x05J&\x02\u0130\u0132\x05L\'\x02\u0131\u012D\x03\x02\x02\x02\u0131\u012E\x03\x02\x02\x02\u0131\u012F\x03\x02\x02\x02\u0131\u0130\x03\x02\x02\x02\u0132\u0133\x03\x02\x02\x02\u0133\u0134\x05N(\x02\u0134E\x03\x02\x02\x02\u0135\u0136	\b\x02\x02\u0136G\x03\x02\x02\x02\u0137\u0138\x07\x1e\x02\x02\u0138I\x03\x02\x02\x02\u0139\u013A\x07 \x02\x02\u013AK\x03\x02\x02\x02\u013B\u013C		\x02\x02\u013CM\x03\x02\x02\x02\u013D\u013E\x05,\x17\x02\u013EO\x03\x02\x02\x02\u013F\u0140\x07\x1f\x02\x02\u0140\u0141\x07 \x02\x02\u0141\u0146\x05R*\x02\u0142\u0143\x07\x05\x02\x02\u0143\u0145\x05R*\x02\u0144\u0142\x03\x02\x02\x02\u0145\u0148\x03\x02\x02\x02\u0146\u0144\x03\x02\x02\x02\u0146\u0147\x03\x02\x02\x02\u0147Q\x03\x02\x02\x02\u0148\u0146\x03\x02\x02\x02\u0149\u014B\x05"\x12\x02\u014A\u014C	\n\x02\x02\u014B\u014A\x03\x02\x02\x02\u014B\u014C\x03\x02\x02\x02\u014CS\x03\x02\x02\x02$UXckr\x7f\x85\x8a\x8f\x98\x9d\xa3\xa8\xaf\xb2\xbd\xc2\xc7\xce\xd5\xda\xdd\xe6\xf6\xfc\u0101\u0107\u010E\u0117\u0124\u0129\u0131\u0146\u014B';
    }
    static get _ATN() {
        if (!$74d8442d41ec6752$export$9c4772e191bdb810.__ATN) $74d8442d41ec6752$export$9c4772e191bdb810.__ATN = new (0, $1HaB7.ATNDeserializer)().deserialize($5lo68.toCharArray($74d8442d41ec6752$export$9c4772e191bdb810._serializedATN));
        return $74d8442d41ec6752$export$9c4772e191bdb810.__ATN;
    }
}
class $74d8442d41ec6752$export$ff413535b9575c8 extends (0, $gN8af.ParserRuleContext) {
    EOF() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.EOF, 0);
    }
    jqlWhere() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$4148a879cab28017);
    }
    jqlOrderBy() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$534469b9c8f44139);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlQuery;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlQuery) listener.enterJqlQuery(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlQuery) listener.exitJqlQuery(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlQuery) return visitor.visitJqlQuery(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$4148a879cab28017 extends (0, $gN8af.ParserRuleContext) {
    jqlOrClause() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$d69831d387793480);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlWhere;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWhere) listener.enterJqlWhere(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWhere) listener.exitJqlWhere(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWhere) return visitor.visitJqlWhere(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$d69831d387793480 extends (0, $gN8af.ParserRuleContext) {
    jqlAndClause(i) {
        if (i === undefined) return this.getRuleContexts($74d8442d41ec6752$export$f16819001158b9e);
        else return this.getRuleContext(i, $74d8442d41ec6752$export$f16819001158b9e);
    }
    OR(i) {
        if (i === undefined) return this.getTokens($74d8442d41ec6752$export$9c4772e191bdb810.OR);
        else return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.OR, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlOrClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrClause) listener.enterJqlOrClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrClause) listener.exitJqlOrClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrClause) return visitor.visitJqlOrClause(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$f16819001158b9e extends (0, $gN8af.ParserRuleContext) {
    jqlNotClause(i) {
        if (i === undefined) return this.getRuleContexts($74d8442d41ec6752$export$5e9146f8d5cf1330);
        else return this.getRuleContext(i, $74d8442d41ec6752$export$5e9146f8d5cf1330);
    }
    AND(i) {
        if (i === undefined) return this.getTokens($74d8442d41ec6752$export$9c4772e191bdb810.AND);
        else return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.AND, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlAndClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlAndClause) listener.enterJqlAndClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlAndClause) listener.exitJqlAndClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlAndClause) return visitor.visitJqlAndClause(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$5e9146f8d5cf1330 extends (0, $gN8af.ParserRuleContext) {
    jqlNotClause() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$5e9146f8d5cf1330);
    }
    NOT() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.NOT, 0);
    }
    BANG() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.BANG, 0);
    }
    jqlSubClause() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$a136a0e9655bfb04);
    }
    jqlTerminalClause() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$23486a2f2ddd5bcd);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlNotClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNotClause) listener.enterJqlNotClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNotClause) listener.exitJqlNotClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNotClause) return visitor.visitJqlNotClause(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$a136a0e9655bfb04 extends (0, $gN8af.ParserRuleContext) {
    LPAREN() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.LPAREN, 0);
    }
    jqlOrClause() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$d69831d387793480);
    }
    RPAREN() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlSubClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSubClause) listener.enterJqlSubClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSubClause) listener.exitJqlSubClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSubClause) return visitor.visitJqlSubClause(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$23486a2f2ddd5bcd extends (0, $gN8af.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$b33300c3d916229a);
    }
    jqlTerminalClauseRhs() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$93924a205c12d32c);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlTerminalClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlTerminalClause) listener.enterJqlTerminalClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlTerminalClause) listener.exitJqlTerminalClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlTerminalClause) return visitor.visitJqlTerminalClause(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$93924a205c12d32c extends (0, $gN8af.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $74d8442d41ec6752$export$c428f709a58396e5 extends $74d8442d41ec6752$export$93924a205c12d32c {
    jqlEqualsOperator() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$41e475fc1988e413);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsClause) listener.enterJqlEqualsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsClause) listener.exitJqlEqualsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsClause) return visitor.visitJqlEqualsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$1b131204ef9fa33d extends $74d8442d41ec6752$export$93924a205c12d32c {
    jqlLikeOperator() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$b76fe5387fdd7efd);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeClause) listener.enterJqlLikeClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeClause) listener.exitJqlLikeClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeClause) return visitor.visitJqlLikeClause(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$d83706ee80a9852a extends $74d8442d41ec6752$export$93924a205c12d32c {
    jqlComparisonOperator() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$d821da0716b3ec95);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonClause) listener.enterJqlComparisonClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonClause) listener.exitJqlComparisonClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonClause) return visitor.visitJqlComparisonClause(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$2934b8ff22fddd2d extends $74d8442d41ec6752$export$93924a205c12d32c {
    jqlInOperator() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$178478bfa8292f72);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInClause) listener.enterJqlInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInClause) listener.exitJqlInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInClause) return visitor.visitJqlInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$8b84310182afcf93 extends $74d8442d41ec6752$export$93924a205c12d32c {
    jqlIsOperator() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$e64c31d2830b66e4);
    }
    jqlEmpty() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$d85a062f90025e5c);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsClause) listener.enterJqlIsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsClause) listener.exitJqlIsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsClause) return visitor.visitJqlIsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$5df295dc7a2cac7c extends $74d8442d41ec6752$export$93924a205c12d32c {
    jqlWasOperator() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$7e283636700e4a6c);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($74d8442d41ec6752$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $74d8442d41ec6752$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasClause) listener.enterJqlWasClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasClause) listener.exitJqlWasClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasClause) return visitor.visitJqlWasClause(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$9ac3367aee261b32 extends $74d8442d41ec6752$export$93924a205c12d32c {
    jqlWasInOperator() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$b9118b1ed9a78d66);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($74d8442d41ec6752$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $74d8442d41ec6752$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInClause) listener.enterJqlWasInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInClause) listener.exitJqlWasInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInClause) return visitor.visitJqlWasInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$7a7defca8628a13c extends $74d8442d41ec6752$export$93924a205c12d32c {
    jqlChangedOperator() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$493d626ed78ca66);
    }
    jqlChangedPredicate(i) {
        if (i === undefined) return this.getRuleContexts($74d8442d41ec6752$export$e77e479a48133015);
        else return this.getRuleContext(i, $74d8442d41ec6752$export$e77e479a48133015);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedClause) listener.enterJqlChangedClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedClause) listener.exitJqlChangedClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedClause) return visitor.visitJqlChangedClause(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$41e475fc1988e413 extends (0, $gN8af.ParserRuleContext) {
    EQUALS() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.EQUALS, 0);
    }
    NOT_EQUALS() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.NOT_EQUALS, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlEqualsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsOperator) listener.enterJqlEqualsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsOperator) listener.exitJqlEqualsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsOperator) return visitor.visitJqlEqualsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$b76fe5387fdd7efd extends (0, $gN8af.ParserRuleContext) {
    LIKE() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.LIKE, 0);
    }
    NOT_LIKE() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.NOT_LIKE, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlLikeOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeOperator) listener.enterJqlLikeOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeOperator) listener.exitJqlLikeOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeOperator) return visitor.visitJqlLikeOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$d821da0716b3ec95 extends (0, $gN8af.ParserRuleContext) {
    LT() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.LT, 0);
    }
    GT() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.GT, 0);
    }
    LTEQ() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.LTEQ, 0);
    }
    GTEQ() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.GTEQ, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlComparisonOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonOperator) listener.enterJqlComparisonOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonOperator) listener.exitJqlComparisonOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonOperator) return visitor.visitJqlComparisonOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$178478bfa8292f72 extends (0, $gN8af.ParserRuleContext) {
    IN() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInOperator) listener.enterJqlInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInOperator) listener.exitJqlInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInOperator) return visitor.visitJqlInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$e64c31d2830b66e4 extends (0, $gN8af.ParserRuleContext) {
    IS() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.IS, 0);
    }
    NOT() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlIsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsOperator) listener.enterJqlIsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsOperator) listener.exitJqlIsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsOperator) return visitor.visitJqlIsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$7e283636700e4a6c extends (0, $gN8af.ParserRuleContext) {
    WAS() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.WAS, 0);
    }
    NOT() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlWasOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasOperator) listener.enterJqlWasOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasOperator) listener.exitJqlWasOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasOperator) return visitor.visitJqlWasOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$b9118b1ed9a78d66 extends (0, $gN8af.ParserRuleContext) {
    WAS() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.WAS, 0);
    }
    IN() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlWasInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInOperator) listener.enterJqlWasInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInOperator) listener.exitJqlWasInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInOperator) return visitor.visitJqlWasInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$493d626ed78ca66 extends (0, $gN8af.ParserRuleContext) {
    CHANGED() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.CHANGED, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlChangedOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedOperator) listener.enterJqlChangedOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedOperator) listener.exitJqlChangedOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedOperator) return visitor.visitJqlChangedOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$b33300c3d916229a extends (0, $gN8af.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlField;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $74d8442d41ec6752$export$11fec15307d2e17b extends $74d8442d41ec6752$export$b33300c3d916229a {
    jqlNumber() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$8737d94a1880e8b3);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumberField) listener.enterJqlNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumberField) listener.exitJqlNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumberField) return visitor.visitJqlNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$b8b24f99f985ebb3 extends $74d8442d41ec6752$export$b33300c3d916229a {
    jqlString() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$bde73d8ad7c8b71e);
    }
    jqlCustomField() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$401a038855cc5b15);
    }
    jqlFieldProperty(i) {
        if (i === undefined) return this.getRuleContexts($74d8442d41ec6752$export$b02d0b6637ce0593);
        else return this.getRuleContext(i, $74d8442d41ec6752$export$b02d0b6637ce0593);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNonNumberField) listener.enterJqlNonNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNonNumberField) listener.exitJqlNonNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNonNumberField) return visitor.visitJqlNonNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$b02d0b6637ce0593 extends (0, $gN8af.ParserRuleContext) {
    LBRACKET() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.LBRACKET, 0);
    }
    RBRACKET() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.RBRACKET, 0);
    }
    jqlPropertyArgument(i) {
        if (i === undefined) return this.getRuleContexts($74d8442d41ec6752$export$e20ce4a2ed16372c);
        else return this.getRuleContext(i, $74d8442d41ec6752$export$e20ce4a2ed16372c);
    }
    jqlArgument() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlFieldProperty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFieldProperty) listener.enterJqlFieldProperty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFieldProperty) listener.exitJqlFieldProperty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFieldProperty) return visitor.visitJqlFieldProperty(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$401a038855cc5b15 extends (0, $gN8af.ParserRuleContext) {
    CUSTOMFIELD() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.CUSTOMFIELD, 0);
    }
    LBRACKET() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.LBRACKET, 0);
    }
    POSNUMBER() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    RBRACKET() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.RBRACKET, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlCustomField;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlCustomField) listener.enterJqlCustomField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlCustomField) listener.exitJqlCustomField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlCustomField) return visitor.visitJqlCustomField(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$bde73d8ad7c8b71e extends (0, $gN8af.ParserRuleContext) {
    STRING() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.STRING, 0);
    }
    QUOTE_STRING() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.QUOTE_STRING, 0);
    }
    SQUOTE_STRING() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.SQUOTE_STRING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlString;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlString) listener.enterJqlString(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlString) listener.exitJqlString(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlString) return visitor.visitJqlString(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$8737d94a1880e8b3 extends (0, $gN8af.ParserRuleContext) {
    POSNUMBER() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    NEGNUMBER() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.NEGNUMBER, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlNumber;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumber) listener.enterJqlNumber(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumber) listener.exitJqlNumber(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumber) return visitor.visitJqlNumber(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$2eaac5a9828bf647 extends (0, $gN8af.ParserRuleContext) {
    jqlEmpty() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$ebf0cc785e9ee41a);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$9cb97a63f2be4864);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOperand) listener.enterJqlOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOperand) listener.exitJqlOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOperand) return visitor.visitJqlOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$d85a062f90025e5c extends (0, $gN8af.ParserRuleContext) {
    EMPTY() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.EMPTY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlEmpty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEmpty) listener.enterJqlEmpty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEmpty) listener.exitJqlEmpty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEmpty) return visitor.visitJqlEmpty(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$2e17d457b0933bec extends (0, $gN8af.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlValue;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValue) listener.enterJqlValue(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValue) listener.exitJqlValue(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValue) return visitor.visitJqlValue(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$ebf0cc785e9ee41a extends (0, $gN8af.ParserRuleContext) {
    jqlFunctionName() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$1f5f7ac816788f44);
    }
    LPAREN() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.RPAREN, 0);
    }
    jqlArgumentList() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$83d7c13849b931c3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlFunction;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunction) listener.enterJqlFunction(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunction) listener.exitJqlFunction(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunction) return visitor.visitJqlFunction(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$1f5f7ac816788f44 extends (0, $gN8af.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlFunctionName;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunctionName) listener.enterJqlFunctionName(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunctionName) listener.exitJqlFunctionName(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunctionName) return visitor.visitJqlFunctionName(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$83d7c13849b931c3 extends (0, $gN8af.ParserRuleContext) {
    jqlArgument(i) {
        if (i === undefined) return this.getRuleContexts($74d8442d41ec6752$export$a95583953c237f88);
        else return this.getRuleContext(i, $74d8442d41ec6752$export$a95583953c237f88);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($74d8442d41ec6752$export$9c4772e191bdb810.COMMA);
        else return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlArgumentList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgumentList) listener.enterJqlArgumentList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgumentList) listener.exitJqlArgumentList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgumentList) return visitor.visitJqlArgumentList(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$9cb97a63f2be4864 extends (0, $gN8af.ParserRuleContext) {
    jqlListStart() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$c419f717bfc46a5d);
    }
    jqlOperand(i) {
        if (i === undefined) return this.getRuleContexts($74d8442d41ec6752$export$2eaac5a9828bf647);
        else return this.getRuleContext(i, $74d8442d41ec6752$export$2eaac5a9828bf647);
    }
    jqlListEnd() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$f6cd3e372f5ab120);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($74d8442d41ec6752$export$9c4772e191bdb810.COMMA);
        else return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlList) listener.enterJqlList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlList) listener.exitJqlList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlList) return visitor.visitJqlList(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$c419f717bfc46a5d extends (0, $gN8af.ParserRuleContext) {
    LPAREN() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.LPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlListStart;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListStart) listener.enterJqlListStart(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListStart) listener.exitJqlListStart(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListStart) return visitor.visitJqlListStart(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$f6cd3e372f5ab120 extends (0, $gN8af.ParserRuleContext) {
    RPAREN() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlListEnd;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListEnd) listener.enterJqlListEnd(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListEnd) listener.exitJqlListEnd(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListEnd) return visitor.visitJqlListEnd(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$e20ce4a2ed16372c extends (0, $gN8af.ParserRuleContext) {
    jqlArgument() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlPropertyArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPropertyArgument) listener.enterJqlPropertyArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPropertyArgument) listener.exitJqlPropertyArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPropertyArgument) return visitor.visitJqlPropertyArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$a95583953c237f88 extends (0, $gN8af.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgument) listener.enterJqlArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgument) listener.exitJqlArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgument) return visitor.visitJqlArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$9fa1e4d63f31b911 extends (0, $gN8af.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$ad402332075c8656);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlWasPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasPredicate) listener.enterJqlWasPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasPredicate) listener.exitJqlWasPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasPredicate) return visitor.visitJqlWasPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$e77e479a48133015 extends (0, $gN8af.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$ad402332075c8656);
    }
    jqlValuePredicateOperator() {
        return this.tryGetRuleContext(0, $74d8442d41ec6752$export$4239d7c0fbafd3f1);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlChangedPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedPredicate) listener.enterJqlChangedPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedPredicate) listener.exitJqlChangedPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedPredicate) return visitor.visitJqlChangedPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$dc01290aee731418 extends (0, $gN8af.ParserRuleContext) {
    AFTER() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.AFTER, 0);
    }
    BEFORE() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.BEFORE, 0);
    }
    ON() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.ON, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDatePredicateOperator) listener.enterJqlDatePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDatePredicateOperator) listener.exitJqlDatePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDatePredicateOperator) return visitor.visitJqlDatePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$75412b8b6a6442e1 extends (0, $gN8af.ParserRuleContext) {
    DURING() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.DURING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDateRangePredicateOperator) listener.enterJqlDateRangePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDateRangePredicateOperator) listener.exitJqlDateRangePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDateRangePredicateOperator) return visitor.visitJqlDateRangePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$ad402332075c8656 extends (0, $gN8af.ParserRuleContext) {
    BY() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.BY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlUserPredicateOperator) listener.enterJqlUserPredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlUserPredicateOperator) listener.exitJqlUserPredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlUserPredicateOperator) return visitor.visitJqlUserPredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$4239d7c0fbafd3f1 extends (0, $gN8af.ParserRuleContext) {
    FROM() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.FROM, 0);
    }
    TO() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.TO, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValuePredicateOperator) listener.enterJqlValuePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValuePredicateOperator) listener.exitJqlValuePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValuePredicateOperator) return visitor.visitJqlValuePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$6b796c5a4b8c18e extends (0, $gN8af.ParserRuleContext) {
    jqlOperand() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$2eaac5a9828bf647);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlPredicateOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPredicateOperand) listener.enterJqlPredicateOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPredicateOperand) listener.exitJqlPredicateOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPredicateOperand) return visitor.visitJqlPredicateOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$534469b9c8f44139 extends (0, $gN8af.ParserRuleContext) {
    ORDER() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.ORDER, 0);
    }
    BY() {
        return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.BY, 0);
    }
    jqlSearchSort(i) {
        if (i === undefined) return this.getRuleContexts($74d8442d41ec6752$export$c7d8f03f36952a46);
        else return this.getRuleContext(i, $74d8442d41ec6752$export$c7d8f03f36952a46);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($74d8442d41ec6752$export$9c4772e191bdb810.COMMA);
        else return this.getToken($74d8442d41ec6752$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlOrderBy;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrderBy) listener.enterJqlOrderBy(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrderBy) listener.exitJqlOrderBy(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrderBy) return visitor.visitJqlOrderBy(this);
        else return visitor.visitChildren(this);
    }
}
class $74d8442d41ec6752$export$c7d8f03f36952a46 extends (0, $gN8af.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $74d8442d41ec6752$export$b33300c3d916229a);
    }
    DESC() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.DESC, 0);
    }
    ASC() {
        return this.tryGetToken($74d8442d41ec6752$export$9c4772e191bdb810.ASC, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $74d8442d41ec6752$export$9c4772e191bdb810.RULE_jqlSearchSort;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSearchSort) listener.enterJqlSearchSort(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSearchSort) listener.exitJqlSearchSort(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSearchSort) return visitor.visitJqlSearchSort(this);
        else return visitor.visitChildren(this);
    }
}

});

parcelRegister("8bTpV", function(module, exports) {
$parcel$export(module.exports, "JastBuilderErrorListener", () => $978ea8f6c4c788d5$export$d0857f60ff1f385);

var $fd0IB = parcelRequire("fd0IB");

var $gD9wc = parcelRequire("gD9wc");
class $978ea8f6c4c788d5$export$d0857f60ff1f385 {
    constructor(){
        this.errors = [];
        this.syntaxError = (_recognizer, offendingSymbol, line, charPositionInLine, msg)=>{
            if (offendingSymbol === undefined) this.errors.push(new (0, $fd0IB.JQLParseError)(msg));
            else this.errors.push(new (0, $gD9wc.JQLSyntaxError)(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
        };
    }
}

});
parcelRegister("fd0IB", function(module, exports) {
$parcel$export(module.exports, "JQLParseError", () => $cc1bb8fc9addad8f$export$e8cfe2b2c93fbd4b);
/**
 * Represents a error occurring when trying to parse JQL into a Jast.
 */ class $cc1bb8fc9addad8f$export$e8cfe2b2c93fbd4b extends Error {
    constructor(message, cause){
        super(message);
        this.name = 'JQLParseError';
        this.cause = cause;
        this.description = message;
    }
}

});

parcelRegister("gD9wc", function(module, exports) {
$parcel$export(module.exports, "JQLSyntaxError", () => $3c5cb89350cfbbb5$export$3276184116160c41);

var $fd0IB = parcelRequire("fd0IB");
class $3c5cb89350cfbbb5$export$3276184116160c41 extends (0, $fd0IB.JQLParseError) {
    constructor(message, start, stop, line, charPositionInLine){
        super(message);
        this.name = 'JQLSyntaxError';
        this.start = start;
        this.stop = stop;
        this.line = line;
        this.charPositionInLine = charPositionInLine;
    }
}

});


parcelRegister("tWMHa", function(module, exports) {
$parcel$export(module.exports, "QueryVisitor", () => $6453c48a9cc7f292$export$418003b930734805);

var $2Uq3M = parcelRequire("2Uq3M");

var $fqqu5 = parcelRequire("fqqu5");

var $sNxR4 = parcelRequire("sNxR4");

var $gSaTU = parcelRequire("gSaTU");
class $6453c48a9cc7f292$export$418003b930734805 extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.whereVisitor = new (0, $gSaTU.WhereVisitor)(this.tokens), this.orderByVisitor = new (0, $sNxR4.OrderByVisitor)(this.tokens), this.visitJqlQuery = (ctx)=>{
            const whereContext = ctx.jqlWhere();
            const orderByContext = ctx.jqlOrderBy();
            return (0, $2Uq3M.internalCreators).query(whereContext && whereContext.accept(this.whereVisitor), orderByContext && orderByContext.accept(this.orderByVisitor), (0, $fqqu5.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("fqqu5", function(module, exports) {
$parcel$export(module.exports, "JastBuildingVisitor", () => $cac6410c1433b34e$export$d3c14d7188b09387);
$parcel$export(module.exports, "getPositionFromToken", () => $cac6410c1433b34e$export$85a4e6d858dbc6fb);
$parcel$export(module.exports, "getPositionFromContext", () => $cac6410c1433b34e$export$264629d4cd3cad3f);
$parcel$export(module.exports, "getPositionsFromTerminalNodes", () => $cac6410c1433b34e$export$30d51184879cbaa8);
$parcel$export(module.exports, "normalizeText", () => $cac6410c1433b34e$export$7c2714a5250b9239);
class $cac6410c1433b34e$export$d3c14d7188b09387 {
    constructor(tokens){
        this.tokens = tokens;
    }
    visit(_tree) {
        throw new Error('Unsupported operation visit(ParseTree)');
    }
    visitChildren(_node) {
        throw new Error('Unsupported operation visitChildren(RuleNode)');
    }
    visitErrorNode(_node) {
        throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
    }
    visitTerminal(_node) {
        throw new Error('Unsupported operation visitTerminal(TerminalNode)');
    }
}
const $cac6410c1433b34e$export$85a4e6d858dbc6fb = (startToken, stopToken)=>[
        startToken.startIndex,
        (stopToken || startToken).stopIndex + 1
    ];
const $cac6410c1433b34e$export$264629d4cd3cad3f = (ctx)=>[
        ctx.start.startIndex,
        ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex
    ];
const $cac6410c1433b34e$export$30d51184879cbaa8 = (terminalNodes)=>terminalNodes.map((node)=>$cac6410c1433b34e$export$85a4e6d858dbc6fb(node.payload));
const $cac6410c1433b34e$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ');

});

parcelRegister("sNxR4", function(module, exports) {
$parcel$export(module.exports, "OrderByVisitor", () => $db8d4c5522fcce53$export$2774b71b99734811);


var $2Uq3M = parcelRequire("2Uq3M");

var $jYuey = parcelRequire("jYuey");

var $fqqu5 = parcelRequire("fqqu5");

var $6sWeW = parcelRequire("6sWeW");
class $db8d4c5522fcce53$export$2774b71b99734811 extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.searchSortVisitor = new $db8d4c5522fcce53$var$SearchSortVisitor(this.tokens), this.visitJqlOrderBy = (ctx)=>{
            // If this rule returned due to an exception then the order by operator is incomplete so we should exit early,
            // e.g. 'order '.
            if (ctx.exception) return undefined;
            const operator = (0, $2Uq3M.internalCreators).orderByOperator((0, $fqqu5.getPositionFromToken)(ctx.ORDER().payload, ctx.BY().payload));
            const fields = ctx.jqlSearchSort().map((searchSortCtx)=>searchSortCtx.accept(this.searchSortVisitor)).filter((0, $jYuey.notUndefined));
            return (0, $2Uq3M.internalCreators).orderBy(fields, operator, (0, $fqqu5.getPositionFromContext)(ctx));
        };
    }
}
class $db8d4c5522fcce53$var$SearchSortVisitor extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.fieldVisitor = new (0, $6sWeW.FieldVisitor)(this.tokens), this.visitJqlSearchSort = (ctx)=>{
            const fieldCtx = ctx.jqlField();
            // If the field rule is returned due to an exception then we should ignore this search search rule. This happens
            // when there are no fields following and order by clause, e.g. 'order by '
            if (fieldCtx.exception) return undefined;
            let direction;
            const desc = ctx.DESC();
            const asc = ctx.ASC();
            if (desc !== undefined) direction = (0, $2Uq3M.internalCreators).orderByDirection((0, $76fbc49409d18be4$export$2ea27ea5f2121899), (0, $fqqu5.getPositionFromToken)(desc.payload));
            else if (asc !== undefined) direction = (0, $2Uq3M.internalCreators).orderByDirection((0, $76fbc49409d18be4$export$6d60017b9e092e73), (0, $fqqu5.getPositionFromToken)(asc.payload));
            return (0, $2Uq3M.internalCreators).orderByField(ctx.jqlField().accept(this.fieldVisitor), direction, (0, $fqqu5.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("jYuey", function(module, exports) {
$parcel$export(module.exports, "notUndefined", () => $9f5da4f09aa12a8b$export$9a1adf421b69c6a);
/**
 * Type predicate to assert an argument is not undefined.
 */ function $9f5da4f09aa12a8b$export$9a1adf421b69c6a(x) {
    return x !== undefined;
}

});

parcelRegister("6sWeW", function(module, exports) {
$parcel$export(module.exports, "FieldVisitor", () => $5457d09ec8dfa2b1$export$c6a85c4c3bf2317d);

var $2Uq3M = parcelRequire("2Uq3M");

var $jMBCA = parcelRequire("jMBCA");

var $fqqu5 = parcelRequire("fqqu5");

var $cEMHY = parcelRequire("cEMHY");
class $5457d09ec8dfa2b1$export$c6a85c4c3bf2317d extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $cEMHY.StringVisitor)(this.tokens), this.fieldPropertyVisitor = new $5457d09ec8dfa2b1$var$FieldPropertyVisitor(this.tokens), this.visitJqlNumberField = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $2Uq3M.internalCreators).field(text, text, undefined, (0, $fqqu5.getPositionFromContext)(ctx));
        }, this.visitJqlNonNumberField = (ctx)=>{
            const stringContext = ctx.jqlString();
            const properties = ctx.jqlFieldProperty().map((context)=>context.accept(this.fieldPropertyVisitor));
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $2Uq3M.internalCreators).field(stringValue.value, stringValue.text, properties, (0, $fqqu5.getPositionFromContext)(ctx));
            }
            const text = this.tokens.getText(ctx);
            return (0, $2Uq3M.internalCreators).field(text, text, properties, (0, $fqqu5.getPositionFromContext)(ctx));
        };
    }
}
class $5457d09ec8dfa2b1$var$FieldPropertyVisitor extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $jMBCA.ArgumentVisitor)(this.tokens), this.propertyArgumentVisitor = new $5457d09ec8dfa2b1$var$PropertyArgumentVisitor(this.tokens), this.visitJqlFieldProperty = (ctx)=>{
            const argumentContext = ctx.jqlArgument();
            const propertyArgumentContext = ctx.jqlPropertyArgument();
            const path = propertyArgumentContext.map((context)=>context.accept(this.propertyArgumentVisitor));
            return (0, $2Uq3M.internalCreators).property(argumentContext && argumentContext.accept(this.argumentVisitor), path, (0, $fqqu5.getPositionFromContext)(ctx));
        };
    }
}
class $5457d09ec8dfa2b1$var$PropertyArgumentVisitor extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $jMBCA.ArgumentVisitor)(this.tokens), this.visitJqlPropertyArgument = (ctx)=>{
            return ctx.jqlArgument().accept(this.argumentVisitor);
        };
    }
}

});
parcelRegister("jMBCA", function(module, exports) {
$parcel$export(module.exports, "ArgumentVisitor", () => $49952d6965b39200$export$46b5a1f6d962d533);

var $2Uq3M = parcelRequire("2Uq3M");

var $fqqu5 = parcelRequire("fqqu5");

var $cEMHY = parcelRequire("cEMHY");
class $49952d6965b39200$export$46b5a1f6d962d533 extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $cEMHY.StringVisitor)(this.tokens), this.visitJqlArgument = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $2Uq3M.internalCreators).argument(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $2Uq3M.internalCreators).argument(text, text, (0, $fqqu5.getPositionFromContext)(ctx));
            }
        };
    }
}

});
parcelRegister("cEMHY", function(module, exports) {
$parcel$export(module.exports, "StringVisitor", () => $1351aad6c43497ea$export$617850cb96304515);

var $fqqu5 = parcelRequire("fqqu5");
class $1351aad6c43497ea$export$617850cb96304515 extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlString = (ctx)=>{
            const text = this.tokens.getText(ctx);
            const position = (0, $fqqu5.getPositionFromContext)(ctx);
            let value;
            if (ctx.QUOTE_STRING()) value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
            else if (ctx.SQUOTE_STRING()) value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
            else // unquoted string
            value = text;
            return {
                text: text,
                value: value,
                position: position
            };
        };
    }
}

});




parcelRegister("gSaTU", function(module, exports) {
$parcel$export(module.exports, "WhereVisitor", () => $b525a3b37342270d$export$c573472f1d20e15d);


var $2Uq3M = parcelRequire("2Uq3M");

var $jYuey = parcelRequire("jYuey");

var $fqqu5 = parcelRequire("fqqu5");

var $riWSz = parcelRequire("riWSz");
class $b525a3b37342270d$export$c573472f1d20e15d extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.terminalClauseVisitor = new (0, $riWSz.TerminalClauseVisitor)(this.tokens), this.visitJqlWhere = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        }, this.visitJqlOrClause = (ctx)=>{
            const clauses = ctx.jqlAndClause().map((andClauseContext)=>andClauseContext.accept(this)).filter((0, $jYuey.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $2Uq3M.internalCreators).compoundOperator((0, $ceee4f50115ff1c6$export$7b8f0a728d79a753), (0, $fqqu5.getPositionsFromTerminalNodes)(ctx.OR()));
                return (0, $2Uq3M.internalCreators).compoundClause(operator, clauses, (0, $fqqu5.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        }, this.visitJqlAndClause = (ctx)=>{
            const clauses = ctx.jqlNotClause().map((notClauseContext)=>notClauseContext.accept(this)).filter((0, $jYuey.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $2Uq3M.internalCreators).compoundOperator((0, $ceee4f50115ff1c6$export$6d6d48d210d3ca97), (0, $fqqu5.getPositionsFromTerminalNodes)(ctx.AND()));
                return (0, $2Uq3M.internalCreators).compoundClause(operator, clauses, (0, $fqqu5.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        }, this.visitJqlNotClause = (ctx)=>{
            const notClauseContext = ctx.jqlNotClause();
            const subClauseContext = ctx.jqlSubClause();
            const terminalClauseContext = ctx.jqlTerminalClause();
            let clause;
            if (notClauseContext !== undefined) clause = notClauseContext.accept(this) || undefined;
            else if (subClauseContext !== undefined) clause = subClauseContext.accept(this) || undefined;
            else if (terminalClauseContext !== undefined) clause = terminalClauseContext.accept(this.terminalClauseVisitor);
            // Our token can be either NOT or !
            let notToken = ctx.NOT();
            notToken = notToken === undefined ? ctx.BANG() : notToken;
            if (notToken && clause) return (0, $2Uq3M.internalCreators).notClause(clause, (0, $2Uq3M.internalCreators).notClauseOperator((0, $fqqu5.getPositionFromToken)(notToken.payload)), (0, $fqqu5.getPositionFromContext)(ctx));
            return clause;
        }, this.visitJqlSubClause = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
    }
}

});
parcelRegister("riWSz", function(module, exports) {
$parcel$export(module.exports, "TerminalClauseVisitor", () => $6d4f71f714823d04$export$14576ae5bd1874a9);

var $2Uq3M = parcelRequire("2Uq3M");

var $jYuey = parcelRequire("jYuey");

var $fqqu5 = parcelRequire("fqqu5");

var $6sWeW = parcelRequire("6sWeW");

var $deLAo = parcelRequire("deLAo");

var $aaR9Q = parcelRequire("aaR9Q");

var $d0yJq = parcelRequire("d0yJq");
class $6d4f71f714823d04$export$14576ae5bd1874a9 extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.fieldVisitor = new (0, $6sWeW.FieldVisitor)(this.tokens), this.terminalClauseRhsVisitor = new $6d4f71f714823d04$var$TerminalClauseRhsVisitor(this.tokens), this.visitJqlTerminalClause = (ctx)=>{
            const field = ctx.jqlField().accept(this.fieldVisitor);
            const { operator: operator, operand: operand, predicates: predicates } = ctx.jqlTerminalClauseRhs().accept(this.terminalClauseRhsVisitor);
            const position = (0, $fqqu5.getPositionFromContext)(ctx);
            return (0, $2Uq3M.internalCreators).terminalClause(field, operator, operand, predicates, position);
        };
    }
}
class $6d4f71f714823d04$var$TerminalClauseRhsVisitor extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operatorVisitor = new (0, $aaR9Q.OperatorVisitor)(this.tokens), this.terminalClauseOperandVisitor = new $6d4f71f714823d04$var$TerminalClauseOperandVisitor(this.tokens), this.predicateVisitor = new (0, $d0yJq.PredicateVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
            const operator = ctx.jqlEqualsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlLikeClause = (ctx)=>{
            const operator = ctx.jqlLikeOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlComparisonClause = (ctx)=>{
            const operator = ctx.jqlComparisonOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlInClause = (ctx)=>{
            const operator = ctx.jqlInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlIsClause = (ctx)=>{
            const operator = ctx.jqlIsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlWasClause = (ctx)=>{
            const operator = ctx.jqlWasOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $jYuey.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        }, this.visitJqlWasInClause = (ctx)=>{
            const operator = ctx.jqlWasInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $jYuey.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        }, this.visitJqlChangedClause = (ctx)=>{
            const operator = ctx.jqlChangedOperator().accept(this.operatorVisitor);
            const predicates = ctx.jqlChangedPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $jYuey.notUndefined));
            return {
                operator: operator,
                operand: undefined,
                predicates: predicates
            };
        }, // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const operator = node.accept(this.operatorVisitor);
            return {
                operator: operator,
                operand: undefined,
                predicates: []
            };
        };
    }
}
class $6d4f71f714823d04$var$TerminalClauseOperandVisitor extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operandVisitor = new (0, $deLAo.OperandVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlLikeClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlComparisonClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlIsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty()
            ]);
        }, this.visitJqlWasClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlWasInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        }, this.getOperandForContexts = (contexts)=>{
            const operandContext = contexts.find((0, $jYuey.notUndefined));
            return operandContext?.accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("deLAo", function(module, exports) {
$parcel$export(module.exports, "OperandVisitor", () => $8d61332b2eb9889e$export$ef8ae1aa15d9c9af);


var $2Uq3M = parcelRequire("2Uq3M");

var $jYuey = parcelRequire("jYuey");

var $jMBCA = parcelRequire("jMBCA");

var $fqqu5 = parcelRequire("fqqu5");

var $2rzJb = parcelRequire("2rzJb");

var $cEMHY = parcelRequire("cEMHY");
class $8d61332b2eb9889e$export$ef8ae1aa15d9c9af extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $cEMHY.StringVisitor)(this.tokens), this.numberVisitor = new (0, $2rzJb.NumberVisitor)(this.tokens), this.functionNameVisitor = new $8d61332b2eb9889e$var$FunctionNameVisitor(this.tokens), this.argumentListVisitor = new $8d61332b2eb9889e$var$ArgumentListVisitor(this.tokens), this.visitJqlOperand = (ctx)=>{
            const operandContext = [
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlList(),
                ctx.jqlFunction()
            ].find((0, $jYuey.notUndefined));
            return operandContext?.accept(this);
        }, this.visitJqlEmpty = (ctx)=>{
            // ANTLR will optimistically create a jqlEmpty node in some situations where user input doesn't match the EMPTY
            // token, e.g. when using value operands in IS clauses ("field is value"), where EMPTY is the only valid operand.
            if (ctx.exception) return undefined;
            return (0, $2Uq3M.internalCreators).keywordOperand((0, $1bca8a68bc08e4bf$export$1c46dca02aac24dd), (0, $fqqu5.getPositionFromToken)(ctx.EMPTY().payload));
        }, this.visitJqlValue = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $2Uq3M.internalCreators).valueOperand(stringValue.value, stringValue.text, stringValue.position);
            }
            const numberContext = ctx.jqlNumber();
            if (numberContext !== undefined) return numberContext.accept(this.numberVisitor);
        }, this.visitJqlList = (ctx)=>{
            const values = ctx.jqlOperand().map((operandCtx)=>operandCtx.accept(this)).filter((0, $jYuey.notUndefined));
            return (0, $2Uq3M.internalCreators).listOperand(values, (0, $fqqu5.getPositionFromContext)(ctx));
        }, this.visitJqlFunction = (ctx)=>{
            const argumentListContext = ctx.jqlArgumentList();
            return (0, $2Uq3M.internalCreators).functionOperand(ctx.jqlFunctionName().accept(this.functionNameVisitor), argumentListContext === undefined ? [] : argumentListContext.accept(this.argumentListVisitor), (0, $fqqu5.getPositionFromContext)(ctx));
        };
    }
}
class $8d61332b2eb9889e$var$FunctionNameVisitor extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $cEMHY.StringVisitor)(this.tokens), this.visitJqlFunctionName = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $2Uq3M.internalCreators).functionString(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $2Uq3M.internalCreators).functionString(text, text, (0, $fqqu5.getPositionFromContext)(ctx));
            }
        };
    }
}
class $8d61332b2eb9889e$var$ArgumentListVisitor extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $jMBCA.ArgumentVisitor)(this.tokens), this.visitJqlArgumentList = (ctx)=>{
            return ctx.jqlArgument().map((argumentCtx)=>argumentCtx.accept(this.argumentVisitor));
        };
    }
}

});
parcelRegister("2rzJb", function(module, exports) {
$parcel$export(module.exports, "NumberVisitor", () => $28491f0bd5fb0093$export$a55432f0884633e4);

var $2Uq3M = parcelRequire("2Uq3M");

var $fqqu5 = parcelRequire("fqqu5");
class $28491f0bd5fb0093$export$a55432f0884633e4 extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlNumber = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $2Uq3M.internalCreators).valueOperand(text, text, (0, $fqqu5.getPositionFromContext)(ctx));
        };
    }
}

});


parcelRegister("aaR9Q", function(module, exports) {
$parcel$export(module.exports, "OperatorVisitor", () => $f74029a8ffdfadb4$export$e56f89ba95b51d2a);

var $2Uq3M = parcelRequire("2Uq3M");

var $d3SdK = parcelRequire("d3SdK");

var $fqqu5 = parcelRequire("fqqu5");
class $f74029a8ffdfadb4$export$e56f89ba95b51d2a extends (0, $fqqu5.JastBuildingVisitor) {
    visitJqlEqualsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $d3SdK.isEqualsOperator)(text)) throw new Error(`'${text}' does not match any of the recognised equals operators`);
        return (0, $2Uq3M.internalCreators).operator(text, text, (0, $fqqu5.getPositionFromContext)(ctx));
    }
    visitJqlLikeOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $d3SdK.isLikeOperator)(text)) throw new Error(`'${text}' does not match any of the recognised like operators`);
        return (0, $2Uq3M.internalCreators).operator(text, text, (0, $fqqu5.getPositionFromContext)(ctx));
    }
    visitJqlComparisonOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $d3SdK.isComparisonOperator)(text)) throw new Error(`'${text}' does not match any of the recognised comparison operators`);
        return (0, $2Uq3M.internalCreators).operator(text, text, (0, $fqqu5.getPositionFromContext)(ctx));
    }
    visitJqlInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $fqqu5.normalizeText)(text);
        if (!(0, $d3SdK.isInOperator)(value)) // This can happen if an incomplete operator is used, e.g. `status not open`.
        return undefined;
        return (0, $2Uq3M.internalCreators).operator(value, text, (0, $fqqu5.getPositionFromContext)(ctx));
    }
    visitJqlIsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $fqqu5.normalizeText)(text);
        if (!(0, $d3SdK.isIsOperator)(value)) throw new Error(`'${text}' does not match any of the recognised is operators`);
        return (0, $2Uq3M.internalCreators).operator(value, text, (0, $fqqu5.getPositionFromContext)(ctx));
    }
    visitJqlWasOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $fqqu5.normalizeText)(text);
        if (!(0, $d3SdK.isWasOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was operators`);
        return (0, $2Uq3M.internalCreators).operator(value, text, (0, $fqqu5.getPositionFromContext)(ctx));
    }
    visitJqlWasInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $fqqu5.normalizeText)(text);
        if (!(0, $d3SdK.isWasInOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was in operators`);
        return (0, $2Uq3M.internalCreators).operator(value, text, (0, $fqqu5.getPositionFromContext)(ctx));
    }
    visitJqlChangedOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $fqqu5.normalizeText)(text);
        if (!(0, $d3SdK.isChangedOperator)(value)) throw new Error(`'${text}' does not match any of the recognised changed operators`);
        return (0, $2Uq3M.internalCreators).operator(value, text, (0, $fqqu5.getPositionFromContext)(ctx));
    }
    constructor(...args){
        super(...args), // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const { sourceInterval: sourceInterval } = node;
            const text = this.tokens.getText(sourceInterval);
            if (text) {
                const value = (0, $fqqu5.normalizeText)(text);
                const { a: startIndex, b: stopIndex } = sourceInterval;
                const startToken = this.tokens.get(startIndex);
                const stopToken = this.tokens.get(stopIndex);
                const position = (0, $fqqu5.getPositionFromToken)(startToken, stopToken);
                if ((0, $d3SdK.isOperator)(value)) return (0, $2Uq3M.internalCreators).operator(value, text, position);
            }
            return undefined;
        };
    }
}

});
parcelRegister("d3SdK", function(module, exports) {
$parcel$export(module.exports, "isOperator", () => $dc5bd7e292c4b8bb$export$4e40859592ee7ac2);
$parcel$export(module.exports, "isEqualsOperator", () => $dc5bd7e292c4b8bb$export$6d0fc196fa8a1673);
$parcel$export(module.exports, "isLikeOperator", () => $dc5bd7e292c4b8bb$export$ad91b6d6a89cb64e);
$parcel$export(module.exports, "isComparisonOperator", () => $dc5bd7e292c4b8bb$export$4477c442bd5c2a6d);
$parcel$export(module.exports, "isInOperator", () => $dc5bd7e292c4b8bb$export$c5e1cdef30e30bff);
$parcel$export(module.exports, "isIsOperator", () => $dc5bd7e292c4b8bb$export$ccc3334744e395c7);
$parcel$export(module.exports, "isWasOperator", () => $dc5bd7e292c4b8bb$export$2b1c5d7e7856f91d);
$parcel$export(module.exports, "isWasInOperator", () => $dc5bd7e292c4b8bb$export$55d8c9b20d99509f);
$parcel$export(module.exports, "isChangedOperator", () => $dc5bd7e292c4b8bb$export$b65d23d23ade534b);
$parcel$export(module.exports, "isListOperator", () => $dc5bd7e292c4b8bb$export$b09522e4061bbdd6);

var $7sSiI = parcelRequire("7sSiI");
const $dc5bd7e292c4b8bb$export$4e40859592ee7ac2 = (operator)=>(0, $7sSiI.OPERATORS).includes(operator);
const $dc5bd7e292c4b8bb$export$6d0fc196fa8a1673 = (operator)=>(0, $7sSiI.EQUALS_OPERATORS).includes(operator);
const $dc5bd7e292c4b8bb$export$ad91b6d6a89cb64e = (operator)=>(0, $7sSiI.LIKE_OPERATORS).includes(operator);
const $dc5bd7e292c4b8bb$export$4477c442bd5c2a6d = (operator)=>(0, $7sSiI.COMPARISON_OPERATORS).includes(operator);
const $dc5bd7e292c4b8bb$export$c5e1cdef30e30bff = (operator)=>(0, $7sSiI.IN_OPERATORS).includes(operator);
const $dc5bd7e292c4b8bb$export$ccc3334744e395c7 = (operator)=>(0, $7sSiI.IS_OPERATORS).includes(operator);
const $dc5bd7e292c4b8bb$export$2b1c5d7e7856f91d = (operator)=>(0, $7sSiI.WAS_OPERATORS).includes(operator);
const $dc5bd7e292c4b8bb$export$55d8c9b20d99509f = (operator)=>(0, $7sSiI.WAS_IN_OPERATORS).includes(operator);
const $dc5bd7e292c4b8bb$export$b65d23d23ade534b = (operator)=>(0, $7sSiI.CHANGED_OPERATORS).includes(operator);
const $dc5bd7e292c4b8bb$export$b09522e4061bbdd6 = (operator)=>(0, $7sSiI.LIST_OPERATORS).includes(operator);

});


parcelRegister("d0yJq", function(module, exports) {
$parcel$export(module.exports, "PredicateVisitor", () => $04deb53b8c494409$export$33bb52a35c693109);

var $2Uq3M = parcelRequire("2Uq3M");

var $4AEXp = parcelRequire("4AEXp");

var $jYuey = parcelRequire("jYuey");

var $fqqu5 = parcelRequire("fqqu5");

var $deLAo = parcelRequire("deLAo");
class $04deb53b8c494409$export$33bb52a35c693109 extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.predicateOperatorVisitor = new $04deb53b8c494409$var$PredicateOperatorVisitor(this.tokens), this.predicateOperandVisitor = new $04deb53b8c494409$var$PredicateOperandVisitor(this.tokens), this.visitJqlWasPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $fqqu5.getPositionFromContext)(ctx);
            return (0, $2Uq3M.internalCreators).predicate(operator, operand, position);
        }, this.visitJqlChangedPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator(),
                ctx.jqlValuePredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $fqqu5.getPositionFromContext)(ctx);
            return (0, $2Uq3M.internalCreators).predicate(operator, operand, position);
        }, this.getOperatorForContexts = (contexts)=>{
            const operatorContext = contexts.find((0, $jYuey.notUndefined));
            if (operatorContext !== undefined) return operatorContext.accept(this.predicateOperatorVisitor);
            else throw new Error('Undefined predicate operator context');
        };
    }
}
class $04deb53b8c494409$var$PredicateOperatorVisitor extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlDatePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlDateRangePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlUserPredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlValuePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.getPredicateOperator = (ctx)=>{
            const text = this.tokens.getText(ctx);
            // Replace consecutive whitespace chars with single space
            const value = text.toLowerCase().replace(/\s+/g, ' ');
            if (!(0, $4AEXp.isPredicateOperator)(value)) throw new Error(`Found a history predicate operator which does not map to a changed time predicate operator in the ast: ${text}`);
            return (0, $2Uq3M.internalCreators).predicateOperator(value, text, (0, $fqqu5.getPositionFromContext)(ctx));
        };
    }
}
class $04deb53b8c494409$var$PredicateOperandVisitor extends (0, $fqqu5.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operandVisitor = new (0, $deLAo.OperandVisitor)(this.tokens), this.visitJqlPredicateOperand = (ctx)=>{
            return ctx.jqlOperand().accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("4AEXp", function(module, exports) {
$parcel$export(module.exports, "isPredicateOperator", () => $31f67de87a18b363$export$188978ad94919403);

var $lzI0n = parcelRequire("lzI0n");
const $31f67de87a18b363$export$188978ad94919403 = (operator)=>(0, $lzI0n.PREDICATE_OPERATORS).includes(operator);

});
parcelRegister("lzI0n", function(module, exports) {
$parcel$export(module.exports, "PREDICATE_OPERATORS", () => $7cf0681fa8f26b45$export$e200440af9f1d9f);
const $7cf0681fa8f26b45$export$3d56e2ae1b4bbbf9 = 'after';
const $7cf0681fa8f26b45$export$f0a816341603bb63 = 'before';
const $7cf0681fa8f26b45$export$cdc81c84f768d513 = 'by';
const $7cf0681fa8f26b45$export$8a5280c65e704c3d = 'during';
const $7cf0681fa8f26b45$export$71f882dcac65f97a = 'from';
const $7cf0681fa8f26b45$export$5685a35c6b0a7ee8 = 'on';
const $7cf0681fa8f26b45$export$5a83c4789e531a = 'to';
const $7cf0681fa8f26b45$export$e200440af9f1d9f = [
    $7cf0681fa8f26b45$export$3d56e2ae1b4bbbf9,
    $7cf0681fa8f26b45$export$f0a816341603bb63,
    $7cf0681fa8f26b45$export$cdc81c84f768d513,
    $7cf0681fa8f26b45$export$8a5280c65e704c3d,
    $7cf0681fa8f26b45$export$71f882dcac65f97a,
    $7cf0681fa8f26b45$export$5685a35c6b0a7ee8,
    $7cf0681fa8f26b45$export$5a83c4789e531a
];

});








parcelRegister("6njZO", function(module, exports) {
$parcel$export(module.exports, "transformView", () => $9d240a5ce910c8c3$export$601ea8be46c5c28c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $9d240a5ce910c8c3$export$601ea8be46c5c28c = (view)=>({
        uuid: view.uuid,
        ownerId: view.owner,
        kind: view.visualizationType,
        title: view.name,
        emoji: view.emoji,
        description: view.description,
        apiResponse: view
    });

});



parcelRegister("cee3w", function(module, exports) {
$parcel$export(module.exports, "PremiumLozenge", () => $0473ec32c6d6d109$export$b37ef9640eaa3746);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $2EFuW = parcelRequire("2EFuW");

var $hZDXn = parcelRequire("hZDXn");

var $55qdj = parcelRequire("55qdj");

var $i860n = parcelRequire("i860n");

var $5Mpda = parcelRequire("5Mpda");
const $0473ec32c6d6d109$export$b37ef9640eaa3746 = ({ children: children })=>{
    const isVisible = (0, $5Mpda.useIsPremiumLozengeVisible)();
    return isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55qdj.default), {
            id: "polaris.premium-lozenge.tooltip",
            defaultMessage: "This is a Premium plan feature"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
        appearance: (0, $i860n.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 'discovery' : 'new'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55qdj.default), {
        id: "polaris.premium-lozenge.label",
        defaultMessage: "Premium"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
};
$0473ec32c6d6d109$export$b37ef9640eaa3746.displayName = "PremiumLozenge";

});
parcelRegister("5Mpda", function(module, exports) {
$parcel$export(module.exports, "useIsPremiumLozengeVisible", () => $aeb4549e8ef5082b$export$894065ae16e309f2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $dV3gw = parcelRequire("dV3gw");

var $eQUOE = parcelRequire("eQUOE");

const $aeb4549e8ef5082b$export$894065ae16e309f2 = ()=>{
    const isPremium = (0, $dV3gw.useIsPremiumEdition)();
    const productEntitlementDetails = (0, $eQUOE.useProductEntitlementDetails)();
    const trialEndDate = productEntitlementDetails?.[0, $c90c8c868d21e91e$export$9062e724eddb8377]?.trialEndTime;
    return (0, $euxye.useMemo)(()=>{
        return isPremium && trialEndDate && trialEndDate - Date.now() > 0;
    }, [
        trialEndDate,
        isPremium
    ]);
};

});
parcelRegister("dV3gw", function(module, exports) {
$parcel$export(module.exports, "useIsPremiumEdition", () => $77e78bfe64e53724$export$8aa8a7878fd61770);
$parcel$export(module.exports, "useIsStandardEdition", () => $77e78bfe64e53724$export$642bac71144485ad);
$parcel$export(module.exports, "useIsViewPermissionsEnabled", () => $77e78bfe64e53724$export$a94405ffcb20c356);
$parcel$export(module.exports, "useIsCrossProjectViewsEnabled", () => $77e78bfe64e53724$export$34d097b1cd6f89c1);
$parcel$export(module.exports, "useIsConnectionsEnabled", () => $77e78bfe64e53724$export$304793dd2c5f4db0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");

var $hJL79 = parcelRequire("hJL79");

var $ccEzE = parcelRequire("ccEzE");

var $fTdDx = parcelRequire("fTdDx");
const $77e78bfe64e53724$export$e03262ab59c85d02 = ()=>{
    return (0, $fTdDx.useIsEnterpriseEdition)();
};
const $77e78bfe64e53724$export$8aa8a7878fd61770 = ()=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    const jpdEdition = (0, $d8LhJ.getEdition)((0, $hJL79.JIRA_PRODUCT_DISCOVERY), appEditions);
    // TODO: POL-10089 use entitlements instead of the edition when it will be available
    return jpdEdition === (0, $d8LhJ.toEdition)((0, $d8LhJ.PREMIUM_EDITION));
};
const $77e78bfe64e53724$export$642bac71144485ad = ()=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    const jpdEdition = (0, $d8LhJ.getEdition)((0, $hJL79.JIRA_PRODUCT_DISCOVERY), appEditions);
    return jpdEdition === (0, $d8LhJ.toEdition)((0, $d8LhJ.STANDARD_EDITION));
};
const $77e78bfe64e53724$export$a94405ffcb20c356 = ()=>{
    const isPremium = $77e78bfe64e53724$export$8aa8a7878fd61770();
    return isPremium;
};
const $77e78bfe64e53724$export$34d097b1cd6f89c1 = ()=>{
    const isPremium = $77e78bfe64e53724$export$8aa8a7878fd61770();
    return isPremium;
};
const $77e78bfe64e53724$export$304793dd2c5f4db0 = ()=>{
    const isPremium = $77e78bfe64e53724$export$8aa8a7878fd61770();
    return isPremium;
};

});
parcelRegister("fTdDx", function(module, exports) {
$parcel$export(module.exports, "useLoadEditionMeta", () => $d03be57e209d1b54$export$8119112215805711);
$parcel$export(module.exports, "useIsEditionMetaLoading", () => $d03be57e209d1b54$export$cbbfe499fe6b5f2e);
$parcel$export(module.exports, "useIsEnterpriseEdition", () => $d03be57e209d1b54$export$e03262ab59c85d02);

var $03ij3 = parcelRequire("03ij3");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $1eJCD = parcelRequire("1eJCD");
const $d03be57e209d1b54$var$initialState = {
    editionMeta: (0, $03ij3.asyncValues).idle()
};
const $d03be57e209d1b54$var$actions = {
    loadEditionMeta: $1eJCD.loadEditionMeta
};
const $d03be57e209d1b54$export$fe446f49c1c8e2e = (0, $5QDqc.createStore)({
    initialState: $d03be57e209d1b54$var$initialState,
    actions: $d03be57e209d1b54$var$actions,
    name: 'PolarisEntitlementStore'
});
const $d03be57e209d1b54$var$useEntitlementStoreActions = (0, $3h1FP.createActionsHook)($d03be57e209d1b54$export$fe446f49c1c8e2e);
const $d03be57e209d1b54$export$8119112215805711 = ()=>{
    const storeActions = $d03be57e209d1b54$var$useEntitlementStoreActions();
    return storeActions.loadEditionMeta;
};
const $d03be57e209d1b54$export$cbbfe499fe6b5f2e = (0, $3h1FP.createStateHook)($d03be57e209d1b54$export$fe446f49c1c8e2e, {
    selector: (state)=>state.editionMeta.status === 'idle' || state.editionMeta.status === 'loading'
});
const $d03be57e209d1b54$export$e03262ab59c85d02 = (0, $3h1FP.createStateHook)($d03be57e209d1b54$export$fe446f49c1c8e2e, {
    selector: (state)=>state.editionMeta.status === 'loaded' && state.editionMeta.value === 'enterprise'
});

});
parcelRegister("03ij3", function(module, exports) {
$parcel$export(module.exports, "asyncValues", () => $f321ab8e66d37beb$export$fb83ab75bba707aa);
/* eslint-disable jira/filename-case */ const $f321ab8e66d37beb$var$asyncStatuses = {
    idle: 'idle',
    loading: 'loading',
    loaded: 'loaded',
    failed: 'failed'
};
const $f321ab8e66d37beb$export$fb83ab75bba707aa = {
    idle: ()=>({
            status: $f321ab8e66d37beb$var$asyncStatuses.idle
        }),
    loading: ()=>({
            status: $f321ab8e66d37beb$var$asyncStatuses.loading
        }),
    loaded: (value)=>({
            status: $f321ab8e66d37beb$var$asyncStatuses.loaded,
            value: value
        }),
    failed: (error)=>({
            status: $f321ab8e66d37beb$var$asyncStatuses.failed,
            error: error
        })
};

});

parcelRegister("1eJCD", function(module, exports) {
$parcel$export(module.exports, "loadEditionMeta", () => $4f9ec0a9feab3690$export$78c38838d239f422);

var $hFtK7 = parcelRequire("hFtK7");

var $ifsAO = parcelRequire("ifsAO");

var $03ij3 = parcelRequire("03ij3");

var $i860n = parcelRequire("i860n");

var $fIaIz = parcelRequire("fIaIz");
const $4f9ec0a9feab3690$export$78c38838d239f422 = ({ shouldLoad: shouldLoad, onLoadingFailed: onLoadingFailed })=>async ({ getState: getState, setState: setState })=>{
        if (!(0, $i860n.fg)('jpd_enterprise_edition_support')) return;
        if (!shouldLoad) {
            // We don't need to load the edition meta
            // but at the same time we want to set the state to loaded
            setState({
                editionMeta: (0, $03ij3.asyncValues).loaded(undefined)
            });
            return;
        }
        if (getState().editionMeta.status === 'loading' || getState().editionMeta.status === 'loaded') return;
        setState({
            editionMeta: (0, $03ij3.asyncValues).loading()
        });
        return (0, $fIaIz.getEditionMeta)().then((response)=>{
            setState({
                editionMeta: (0, $03ij3.asyncValues).loaded(response.edition)
            });
        }).catch((error)=>{
            (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('getEditionMeta failure', error));
            onLoadingFailed(error);
            setState({
                editionMeta: (0, $03ij3.asyncValues).failed(error)
            });
        });
    };

});
parcelRegister("fIaIz", function(module, exports) {
$parcel$export(module.exports, "getEditionMeta", () => $f8bc5c845c8e0234$export$14a724b9d67e77ce);

var $4fhEY = parcelRequire("4fhEY");
const $f8bc5c845c8e0234$export$14a724b9d67e77ce = ()=>(0, $4fhEY.default)('/rest/polaris/edition?operation=getEditionMeta');

});




parcelRegister("eQUOE", function(module, exports) {
$parcel$export(module.exports, "useProductEntitlementDetails", () => $4989c6c1b50045d3$export$e02d6385b5d47f5d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $4989c6c1b50045d3$export$e02d6385b5d47f5d = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.productEntitlementDetails || null;
};

});

/* eslint-disable jira/filename-case */ const $c90c8c868d21e91e$export$9062e724eddb8377 = 'jira-product-discovery';



parcelRegister("78GR0", function(module, exports) {
$parcel$export(module.exports, "useCollectionSelectedMatch", () => $d35a227161a5ab31$export$f8678ffe77a81702);
$parcel$export(module.exports, "useIsCollectionsSelected", () => $d35a227161a5ab31$export$bff956e91a23208e);
$parcel$export(module.exports, "useIsJpdProjectView", () => $d35a227161a5ab31$export$dbf8a4da34593bdd);
$parcel$export(module.exports, "useIsCollectionSelected", () => $d35a227161a5ab31$export$d1d2d8dc13ec1cf);
$parcel$export(module.exports, "getViewUrl", () => $d35a227161a5ab31$export$bdccd6a672e4a607);
// eslint-disable-next-line jira/filename-case

var $aOGXw = parcelRequire("aOGXw");

var $f2wVS = parcelRequire("f2wVS");
const $d35a227161a5ab31$export$f8678ffe77a81702 = (0, $f2wVS.createRouterSelector)(({ route: route, match: match })=>{
    const viewUUID = match.params?.resource || undefined;
    const collectionUUID = match.params?.collectionUUID || undefined;
    const isCollectionSelected = route.name === 'polaris-collections' && collectionUUID !== undefined && viewUUID !== undefined;
    return isCollectionSelected ? {
        collectionUUID: collectionUUID,
        viewUUID: viewUUID
    } : undefined;
});
const $d35a227161a5ab31$export$bff956e91a23208e = (0, $f2wVS.createRouterSelector)(({ route: route, match: match })=>{
    const viewUUID = match.params?.resource || undefined;
    const collectionUUID = match.params?.collectionUUID || undefined;
    return route.name === 'polaris-collections' && viewUUID === undefined && collectionUUID === undefined;
});
const $d35a227161a5ab31$export$dbf8a4da34593bdd = (0, $f2wVS.createRouterSelector)(({ route: route, match: match })=>{
    const viewUUID = match.params?.resource || undefined;
    return route.name === 'polaris-ideas' && viewUUID !== undefined;
});
const $d35a227161a5ab31$export$d1d2d8dc13ec1cf = (options)=>{
    const collectionMatched = $d35a227161a5ab31$export$f8678ffe77a81702();
    if (options?.collectionUUID) return collectionMatched && collectionMatched.collectionUUID === options.collectionUUID;
    return Boolean(collectionMatched);
};
const $d35a227161a5ab31$export$bdccd6a672e4a607 = ({ container: container, view: view })=>{
    // In collections we don't use `view.polarisId` like we do in jpd-project-menu
    // but instead we use `view.id` that contains UUID
    return (0, $aOGXw.getCollectionViewPageUrl)(container.collectionUUID, view.id);
};

});

parcelRegister("7RdH9", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $95cedc1e66232540$export$a06f1c675e846f6f);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $5IkoH = parcelRequire("5IkoH");

var $bEZ9g = parcelRequire("bEZ9g");

var $aOGXw = parcelRequire("aOGXw");

var $djYhH = parcelRequire("djYhH");

var $ar9gx = parcelRequire("ar9gx");

var $6w18e = parcelRequire("6w18e");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $kaswN = parcelRequire("kaswN");
const $95cedc1e66232540$var$viewAllRoadmaps = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.footer.view-all-roadmaps",
    defaultMessage: "View all roadmaps"
});
const $95cedc1e66232540$export$a06f1c675e846f6f = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem } = (0, $euxye.useContext)((0, $kaswN.AnalyticContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEZ9g.ViewAllEntityMenuItem), {
        href: (0, $aOGXw.getCollectionsPageUrl)(),
        menuId: (0, $5IkoH.MENU_ID_ROADMAPS_VIEW_ALL),
        onClick: (e)=>{
            fireUIAnalyticForFixMenuItem();
            onClose?.(e);
        }
    }, formatMessage($95cedc1e66232540$var$viewAllRoadmaps)))));
};
$95cedc1e66232540$export$a06f1c675e846f6f.displayName = "Footer";

});
parcelRegister("kaswN", function(module, exports) {
$parcel$export(module.exports, "AnalyticContext", () => $55500fed77f4d580$export$da0556bf821b3494);
$parcel$export(module.exports, "AnalyticContextProvider", () => $55500fed77f4d580$export$aea8e3edcdec81e3);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");




var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $b1YRJ = parcelRequire("b1YRJ");
const $55500fed77f4d580$export$da0556bf821b3494 = /*#__PURE__*/ (0, $euxye.createContext)({
    fireUIAnalyticForFixMenuItem: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    fireUIAnalyticForFixButton: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    fireUIAnalyticForFavouriteToggle: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    fireUIAnalyticForRoadmapsItems: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
});
const $55500fed77f4d580$export$aea8e3edcdec81e3 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireUIAnalyticForFixMenuItem = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                itemId: (0, $b1YRJ.VIEW_ALL_ROADMAPS)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFixButton = (0, $euxye.useCallback)(({ itemId: itemId })=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
                itemId: itemId
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFavouriteToggle = (0, $euxye.useCallback)(({ starType: starType, parentItemId: parentItemId })=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                componentType: (0, $6e2f51712bb2e810$export$74712b62056d422e),
                parentItemId: parentItemId,
                parentItemType: 'roadmap',
                itemId: starType
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForRoadmapsItems = (0, $euxye.useCallback)(({ itemId: itemId, section: section })=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
                itemType: (0, $687cb22024c607c7$export$bb8a37ab8d9ba82b).toLowerCase(),
                itemId: itemId,
                section: section
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const value = (0, $euxye.useMemo)(()=>({
            fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem,
            fireUIAnalyticForFixButton: fireUIAnalyticForFixButton,
            fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle,
            fireUIAnalyticForRoadmapsItems: fireUIAnalyticForRoadmapsItems
        }), [
        fireUIAnalyticForFavouriteToggle,
        fireUIAnalyticForFixButton,
        fireUIAnalyticForFixMenuItem,
        fireUIAnalyticForRoadmapsItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($55500fed77f4d580$export$da0556bf821b3494.Provider, {
        value: value
    }, children);
};
$55500fed77f4d580$export$aea8e3edcdec81e3.displayName = "AnalyticContextProvider";

});



parcelRegister("aayMc", function(module, exports) {
$parcel$export(module.exports, "useLocalIsExpanded", () => $9da5b4fc46a0337d$export$5e6f0a1b568ed2c9);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $5IkoH = parcelRequire("5IkoH");

var $19zz3 = parcelRequire("19zz3");
function $9da5b4fc46a0337d$export$5e6f0a1b568ed2c9(isExpanded) {
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $19zz3.useSidebarNav4)();
    const isExpandedByDefault = (0, $euxye.useMemo)(()=>isInitialSelectedPath((0, $5IkoH.MENU_ID_ROADMAPS)) || isInitialSelectedPath((0, $5IkoH.MENU_ID_ROADMAPS_VIEW_ALL)), [
        isInitialSelectedPath
    ]);
    return (0, $euxye.useState)(isExpandedByDefault || isExpanded);
}

});

parcelRegister("2wODd", function(module, exports) {
$parcel$export(module.exports, "asyncActionButtons", () => $c2da519b56d50fde$export$be20d197fd307caa);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $c2da519b56d50fde$export$be20d197fd307caa = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("bVb9L")), {
        moduleId: "95639c57",
        moduleName: "AsyncActionButtons",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bVb9L", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8oFiu").then(()=>parcelRequire('fsaIv'));

});


parcelRegister("fwm0V", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("66SE5").then(()=>parcelRequire('hrAkj'));

});


parcelRegister("g4ceC", function(module, exports) {
$parcel$export(module.exports, "Nav4RoadmapsNew", () => $d46973209cd78b4b$export$67489e5bb9e05055);

var $euxye = parcelRequire("euxye");

var $eQT0r = parcelRequire("eQT0r");

var $dV3gw = parcelRequire("dV3gw");

var $gVkjO = parcelRequire("gVkjO");

var $dx7aH = parcelRequire("dx7aH");

var $6GljB = parcelRequire("6GljB");

var $i860n = parcelRequire("i860n");

var $b1YRJ = parcelRequire("b1YRJ");

var $4S9lF = parcelRequire("4S9lF");
const $d46973209cd78b4b$var$RoadmapsUpsellItem = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).ROADMAPS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eQT0r.RoadmapsUpsell), {
        formattedMessage: formattedMessage,
        icon: icon,
        ...props
    });
});
const $d46973209cd78b4b$export$67489e5bb9e05055 = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    const { isExpanded: isExpanded, ...dndProps } = props;
    const isCrossProjectViewsEnabled = (0, $dV3gw.useIsCrossProjectViewsEnabled)();
    if (!isCrossProjectViewsEnabled) {
        const actualProps = (0, $i860n.fg)('navx-global-side-nav') ? dndProps : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
            id: "nav4.sidebar.roadmaps.upsell",
            packageName: (0, $b1YRJ.PACKAGE_NAME),
            teamName: "JPD - Juno",
            ufoName: "nav4-sidebar-roadmaps-upsell"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d46973209cd78b4b$var$RoadmapsUpsellItem, actualProps));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4S9lF.Nav4Roadmaps), {
        isExpanded: isExpanded,
        ...dndProps
    });
});

});
parcelRegister("eQT0r", function(module, exports) {
$parcel$export(module.exports, "RoadmapsUpsell", () => $393f9c83441b7cc9$export$774f55bdd60fe8e6);
/* RoadmapsUpsell.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $1Io8b = parcelRequire("1Io8b");

var $2EFuW = parcelRequire("2EFuW");

var $55qdj = parcelRequire("55qdj");

var $6LigW = parcelRequire("6LigW");

var $aHm5X = parcelRequire("aHm5X");

var $aZMdt = parcelRequire("aZMdt");
var $aqPkH = parcelRequire("aqPkH");

var $hYI7R = parcelRequire("hYI7R");

var $5rZe5 = parcelRequire("5rZe5");

var $7luds = parcelRequire("7luds");

var $1yYbK = parcelRequire("1yYbK");

var $8vZXc = parcelRequire("8vZXc");

var $8Pseh = parcelRequire("8Pseh");
const $393f9c83441b7cc9$var$TryLozenge = ()=>{
    return /*#__PURE__*/ $euxye.createElement((0, $2EFuW.default), {
        appearance: "discovery"
    }, /*#__PURE__*/ $euxye.createElement((0, $55qdj.default), {
        id: "polaris.try-lozenge.label",
        defaultMessage: "Try"
    }));
};
$393f9c83441b7cc9$var$TryLozenge.displayName = "TryLozenge";
const $393f9c83441b7cc9$export$774f55bdd60fe8e6 = (props)=>{
    const licensedProducts = (0, $5rZe5.useLicensedProducts)();
    const hasJpd = licensedProducts['jira-product-discovery'] === true;
    const errorBoundaryAttributes = (0, $euxye.useMemo)(()=>({
            errorContext: 'Failed rendering JpdRoadmapNav',
            isJpdLicensed: hasJpd
        }), [
        hasJpd
    ]);
    return /*#__PURE__*/ $euxye.createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "jpdRoadmapNav",
        packageName: "jiraRoadmapNav",
        teamName: "JPD - Juno",
        attributes: errorBoundaryAttributes
    }, /*#__PURE__*/ $euxye.createElement($393f9c83441b7cc9$var$JpdRoadmapNavInternal, {
        ...props,
        hasJpd: hasJpd
    }));
};
$393f9c83441b7cc9$export$774f55bdd60fe8e6.displayName = "RoadmapsUpsell";
const $393f9c83441b7cc9$var$JpdRoadmapNavInternal = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    const { draggableRef: draggableRef, dropIndicator: dropIndicator, hasDragIndicator: hasDragIndicator, isDragging: isDragging, visualContentRef: visualContentRef, formattedMessage: formattedMessage, icon: icon, hasJpd: hasJpd } = props; // oxlint-disable-next-line typescript/consistent-type-assertions
    const dragRef = draggableRef;
    (0, $1yYbK.useRoadmapUpsellAdAutoDismissal)();
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $6LigW.useFireCrossFlowAnalyticsEvents)();
    const openCrossFlow = (0, $8vZXc.useOpenCrossFlow)();
    const handleClick = (0, $euxye.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'roadmaps'
        }, {
            recommendedProductIds: [
                (0, $aHm5X.SURFACE_ANALYTICS_PRODUCT_MAP).products['jira-product-discovery']
            ],
            targetProductId: (0, $aHm5X.SURFACE_ANALYTICS_PRODUCT_MAP).products['jira-product-discovery'],
            source: 'jiraNavigationSection'
        }, {
            isJpdLicensed: hasJpd
        });
        openCrossFlow();
    }, [
        fireInteractedUIEvent,
        hasJpd,
        openCrossFlow
    ]);
    (0, $hYI7R.useEffectWithoutConcurrency)(()=>{
        fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'button',
            actionSubjectId: 'jiraNavigation'
        }, {
            recommendedProductIds: [
                (0, $aHm5X.SURFACE_ANALYTICS_PRODUCT_MAP).products['jira-product-discovery']
            ],
            source: 'jiraNavigationSection'
        }, {
            isJpdLicensed: hasJpd
        });
    }, [
        fireViewedUIEvent,
        hasJpd
    ]);
    return /*#__PURE__*/ $euxye.createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceType: (0, $46f069e6c968f461$export$f636b5b56f1d624a),
        sourceName: "roadmapOnNav"
    }, /*#__PURE__*/ $euxye.createElement((0, $7luds.default), null, /*#__PURE__*/ $euxye.createElement((0, $1Io8b.ButtonMenuItem), {
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ $euxye.createElement($393f9c83441b7cc9$var$TryLozenge, null),
        ref: dragRef,
        hasDragIndicator: hasDragIndicator,
        actionsOnHover: /*#__PURE__*/ $euxye.createElement((0, $8Pseh.RoadmapUpsellAdControlsButton), null),
        dropIndicator: dropIndicator,
        isDragging: isDragging,
        visualContentRef: visualContentRef,
        onClick: handleClick,
        testId: "jira-roadmap-in-nav.jpd-roadmap-nav-button"
    }, formattedMessage)), /*#__PURE__*/ $euxye.createElement((0, $aqPkH.FireScreenAnalytics), {
        attributes: {
            name: 'roadmapOnNav',
            isJpdLicensed: hasJpd
        }
    }));
});

});
parcelRegister("8vZXc", function(module, exports) {
$parcel$export(module.exports, "useOpenCrossFlow", () => $674bcf3b875aa43d$export$f6033fcc5716710c);

var $euxye = parcelRequire("euxye");

var $8oFkF = parcelRequire("8oFkF");

var $lfqQU = parcelRequire("lfqQU");

var $di8d5 = parcelRequire("di8d5");

var $5azn7 = parcelRequire("5azn7");
const $674bcf3b875aa43d$export$f6033fcc5716710c = ()=>{
    const crossFlow = (0, $8oFkF.useCrossFlow)();
    const templateId = 'jpd.product-roadmap';
    const extensions = (0, $di8d5.createProvisioningApiExtensions)({
        actions: {
            primary: {
                behaviour: (0, $5azn7.Behaviours).LAND,
                prompt: (0, $5azn7.Prompts).NEXT,
                options: {
                    targetTab: (0, $5azn7.TargetTabs).SAME,
                    urlParams: {
                        templateId: templateId
                    }
                }
            }
        },
        jobName: 'activate-and-ensure-project-created',
        jobParams: {
            sourceComponent: 'jiraNavigation',
            sourceContext: 'roadmaps',
            requestedEditionId: 'premium'
        }
    });
    return (0, $euxye.useCallback)(()=>{
        crossFlow.isEnabled && crossFlow.apiV1.open({
            journey: (0, $8oFkF.Journeys).GET_STARTED,
            targetProduct: (0, $lfqQU.Targets).JIRA_PRODUCT_DISCOVERY,
            sourceComponent: 'jiraNavigation',
            sourceContext: 'roadmaps',
            extensions: extensions,
            v1: true
        });
    }, [
        crossFlow,
        extensions
    ]);
};

});
parcelRegister("di8d5", function(module, exports) {
$parcel$export(module.exports, "createProvisioningApiExtensions", () => $f5f8731f86b34312$export$530ae557c94159b9);

var $cD4as = parcelRequire("cD4as");
const $f5f8731f86b34312$export$bba48927994d7f26 = [
    'provisioningApiParams'
];
const $f5f8731f86b34312$export$530ae557c94159b9 = (options)=>(0, $cD4as.createProductExtensions)($f5f8731f86b34312$export$bba48927994d7f26)({
        provisioningApiParams: options
    });

});


parcelRegister("8Pseh", function(module, exports) {
$parcel$export(module.exports, "RoadmapUpsellAdControlsButton", () => $a4f10f1a0f1b205b$export$d998229780625aba);

var $euxye = parcelRequire("euxye");

var $g3dxg = parcelRequire("g3dxg");

var $7eNDO = parcelRequire("7eNDO");

var $1yYbK = parcelRequire("1yYbK");
const $a4f10f1a0f1b205b$var$dismissFlagTitle = (0, $7eNDO.defineMessage)({
    id: "jira-roadmap-in-nav.ad-controls.dismiss-flag.title",
    defaultMessage: "Dismiss this recommendation"
});
const $a4f10f1a0f1b205b$var$dismissFlagDescription = (0, $7eNDO.defineMessage)({
    id: "jira-roadmap-in-nav.ad-controls.dismiss-flag.description",
    defaultMessage: "This will remove this recommendation from your view"
});
const $a4f10f1a0f1b205b$var$reasonsModalTitle = (0, $7eNDO.defineMessage)({
    id: "jira-roadmap-in-nav.ad-controls.reasons-modal.title",
    defaultMessage: "Why am I seeing this?"
});
const $a4f10f1a0f1b205b$var$reasonsModalExplanation = (0, $7eNDO.defineMessage)({
    id: "jira-roadmap-in-nav.ad-controls.reasons-modal.explanation",
    defaultMessage: "We think <strong>Roadmaps</strong> will help your product teams connect high-level strategy directly to Jira work items. This recommendation is based on:"
});
const $a4f10f1a0f1b205b$var$reasonsModalBulletOne = (0, $7eNDO.defineMessage)({
    id: "jira-roadmap-in-nav.ad-controls.reasons-modal.bullet-one",
    defaultMessage: "<strong>Your Jira Premium plan.</strong> Roadmaps is a Jira Product Discovery Premium feature designed to bridge the gap between discovery and delivery."
});
const $a4f10f1a0f1b205b$var$reasonsModalBulletTwo = (0, $7eNDO.defineMessage)({
    id: "jira-roadmap-in-nav.ad-controls.reasons-modal.bullet-two",
    defaultMessage: "<strong>Your role as an Admin.</strong> We want to provide best practices on how to manage roadmaps for an entire portfolio."
});
const $a4f10f1a0f1b205b$export$d998229780625aba = ()=>{
    const { dismiss: dismiss } = (0, $1yYbK.useRoadmapUpsellAdControls)();
    const analyticsConfig = {
        errorBoundary: {
            id: 'jpdRoadmapNavButton',
            context: 'Failed rendering RoadmapsUpsell ad controls button',
            packageName: 'jiraRoadmapNav',
            teamName: 'JPD - Juno'
        },
        screen: {
            sourceName: 'roadmapsUpsellAdControls',
            name: 'roadmapsUpsellAdControls',
            messageId: 'roadmaps-upsell.adcontrols.dropdown'
        },
        reasonsModal: {
            screenName: 'roadmaps-upsell.ad-controls.reasons-modal',
            linkAttributes: {}
        }
    };
    const reasonsModalConfig = {
        explanation: $a4f10f1a0f1b205b$var$reasonsModalExplanation,
        reasons: [
            {
                id: 'jira-premium-plan',
                message: $a4f10f1a0f1b205b$var$reasonsModalBulletOne
            },
            {
                id: 'admin-role',
                message: $a4f10f1a0f1b205b$var$reasonsModalBulletTwo
            }
        ],
        dismissFlag: {
            title: $a4f10f1a0f1b205b$var$dismissFlagTitle,
            description: $a4f10f1a0f1b205b$var$dismissFlagDescription
        },
        modalTitle: $a4f10f1a0f1b205b$var$reasonsModalTitle
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g3dxg.AdControlsButton), {
        dismiss: dismiss,
        itemId: "roadmaps-upsell-ad-controls",
        analytics: analyticsConfig,
        productName: "Jira",
        reasonsModalConfig: reasonsModalConfig
    });
};
$a4f10f1a0f1b205b$export$d998229780625aba.displayName = "RoadmapUpsellAdControlsButton";

});
parcelRegister("g3dxg", function(module, exports) {
$parcel$export(module.exports, "AdControlsButton", () => $8054ee1fd817a9b7$export$df21aa67bcc8d6de);
/* AdControlsButton.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $jreC0 = parcelRequire("jreC0");

var $7nEKi = parcelRequire("7nEKi");

var $m9iwH = parcelRequire("m9iwH");

var $7Fzpe = parcelRequire("7Fzpe");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $eMhe9 = parcelRequire("eMhe9");

var $9B8I1 = parcelRequire("9B8I1");
const $8054ee1fd817a9b7$var$adControls = (0, $7eNDO.defineMessage)({
    id: "jira-adcontrols.button.ad-controls",
    defaultMessage: "Ad controls"
});
const $8054ee1fd817a9b7$export$df21aa67bcc8d6de = ({ dismiss: dismiss, itemId: itemId, analytics: analytics, productName: productName, reasonsModalConfig: reasonsModalConfig })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $9B8I1.adControlsDropDownEntryPoint), {});
    (0, $euxye.useEffect)(()=>{
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eMhe9.default), {
        itemId: itemId,
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, onClick: onClick, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
                ...props,
                appearance: "subtle",
                spacing: "compact",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Fzpe))),
                label: formatMessage($8054ee1fd817a9b7$var$adControls),
                ref: triggerRef,
                onClick: (e)=>{
                    e.stopPropagation();
                    entryPointActions.load();
                    onClick?.(e);
                }
            })
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: `${itemId}-dropdown`,
            runtimeProps: {
                ...props,
                onDismiss: dismiss,
                itemId: itemId,
                analytics: analytics,
                productName: productName,
                reasonsModalConfig: reasonsModalConfig
            }
        }));
};
$8054ee1fd817a9b7$export$df21aa67bcc8d6de.displayName = "AdControlsButton";

});
parcelRegister("9B8I1", function(module, exports) {
$parcel$export(module.exports, "adControlsDropDownEntryPoint", () => $9d239e34a6b22353$export$fd3aa76f727a6048);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $9d239e34a6b22353$export$fd3aa76f727a6048 = (0, $fiVog.createEntryPoint)({
    // eslint-disable-next-line @atlassian/react-entrypoint/entrypoint-jsresource-prefer-string-module
    root: (0, $7NTte.JSResourceForInteraction)(async ()=>{
        return (parcelRequire("8B1NZ"));
    }, {
        moduleId: "f8b5ed14",
        moduleName: "AdControlsDropDown",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8B1NZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bZgHB").then(()=>parcelRequire('csvnS'));

});






parcelRegister("l0TTR", function(module, exports) {
$parcel$export(module.exports, "Nav4RoadmapsNewWithRecent", () => $ed5a6470a730f8ba$export$c73926380f810500);

var $euxye = parcelRequire("euxye");

var $eQT0r = parcelRequire("eQT0r");

var $dV3gw = parcelRequire("dV3gw");

var $gVkjO = parcelRequire("gVkjO");

var $dx7aH = parcelRequire("dx7aH");

var $6GljB = parcelRequire("6GljB");

var $jepRN = parcelRequire("jepRN");

var $i860n = parcelRequire("i860n");

var $hWidM = parcelRequire("hWidM");

var $b1YRJ = parcelRequire("b1YRJ");
const $ed5a6470a730f8ba$var$RoadmapsUpsellItem = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).ROADMAPS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eQT0r.RoadmapsUpsell), {
        formattedMessage: formattedMessage,
        icon: icon,
        ...props
    });
});
const $ed5a6470a730f8ba$export$67489e5bb9e05055 = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    const { isExpanded: isExpanded, queryRef: queryRef, ...restProps } = props;
    const isCrossProjectViewsEnabled = (0, $dV3gw.useIsCrossProjectViewsEnabled)();
    if (!isCrossProjectViewsEnabled) {
        const actualProps = (0, $i860n.fg)('navx-global-side-nav') ? restProps : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
            id: "nav4.sidebar.roadmaps.upsell",
            packageName: (0, $b1YRJ.PACKAGE_NAME),
            teamName: "JPD - Juno",
            ufoName: "nav4-sidebar-roadmaps-upsell"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ed5a6470a730f8ba$var$RoadmapsUpsellItem, actualProps));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hWidM.Nav4Roadmaps), {
        isExpanded: isExpanded,
        queryRef: queryRef,
        ...restProps
    });
});
const $ed5a6470a730f8ba$export$c73926380f810500 = (0, $jepRN.componentWithFG)('jpd-roadmaps-in-jira', $ed5a6470a730f8ba$export$67489e5bb9e05055, (0, $hWidM.Nav4Roadmaps));

});
parcelRegister("hWidM", function(module, exports) {
$parcel$export(module.exports, "Nav4Roadmaps", () => $5a155cc0770d98c1$export$257bbde911c73386);

var $14iUW = parcelRequire("14iUW");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $j3D0C = parcelRequire("j3D0C");
const $5a155cc0770d98c1$export$257bbde911c73386 = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    const { queryRef: queryRef, ...rest } = props;
    const dataQuery = (0, $n67Vb.useFragment)((0, $14iUW.default), // Needs to be done in all navigations for navx-global-side-nav to work
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j3D0C.Nav4RoadmapsWithRecent), {
        ...rest,
        queryRefFragment: dataQuery
    });
});

});
parcelRegister("14iUW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d2bc1ac8674501c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<20eb1f3015bfa6ca779e1d531571bcff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8d2bc1ac8674501c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Roadmaps_query",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "currentURL",
                    "variableName": "currentURL"
                }
            ],
            "kind": "FragmentSpread",
            "name": "Nav4RoadmapsWithRecent_query"
        }
    ],
    "type": "Query"
};
$8d2bc1ac8674501c$var$node.hash = "47fec372203af44a34a1cc7d09c55e56";
var $8d2bc1ac8674501c$export$2e2bcd8739ae039 = $8d2bc1ac8674501c$var$node;

});

parcelRegister("j3D0C", function(module, exports) {
$parcel$export(module.exports, "Nav4RoadmapsWithRecent", () => $64e185d1bbe16fa4$export$e56f56dcc2061dd8);

var $dSmPX = parcelRequire("dSmPX");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $gVkjO = parcelRequire("gVkjO");

var $19zz3 = parcelRequire("19zz3");

var $5IkoH = parcelRequire("5IkoH");

var $i860n = parcelRequire("i860n");

var $b1YRJ = parcelRequire("b1YRJ");

var $dD4TM = parcelRequire("dD4TM");

var $9z50I = parcelRequire("9z50I");

var $48Afu = parcelRequire("48Afu");

var $6JpuJ = parcelRequire("6JpuJ");
const $64e185d1bbe16fa4$export$e56f56dcc2061dd8 = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    const { isExpanded: isExpanded, queryRefFragment: queryRefFragment, ...dndProps } = props;
    const roadmapNavigationQuery = (0, $n67Vb.useFragment)((0, $dSmPX.default), queryRefFragment);
    const actionButtons = (0, $euxye.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dD4TM.ActionButtons), null), []);
    const { isSelectedPath: isSelectedPath, isInitialSelectedPath: isInitialSelectedPath } = (0, $19zz3.useSidebarNav4)();
    const isRoadmapSelectedPath = isSelectedPath((0, $5IkoH.MENU_ID_ROADMAPS));
    const isRoadmapInitialSelectedPath = (0, $i860n.fg)('jpd_fix_expand_roadmap_recent') ? isInitialSelectedPath((0, $5IkoH.MENU_ID_ROADMAPS)) : false;
    const isExpandedValue = (0, $i860n.fg)('navx-global-side-nav') ? !!dndProps.isExpandOrFlyoutOpen && isExpanded : isExpanded;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.roadmaps",
        packageName: (0, $b1YRJ.PACKAGE_NAME),
        teamName: (0, $b1YRJ.TEAM_NAME),
        ufoName: "nav4-sidebar-roadmaps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9z50I.RoadmapsProviders), null, (isRoadmapSelectedPath || isRoadmapInitialSelectedPath) && roadmapNavigationQuery ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6JpuJ.RoadmapNavExpanded), {
        actionsOnHover: actionButtons,
        isExpanded: isExpandedValue,
        queryRefFragment: roadmapNavigationQuery,
        ...dndProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $48Afu.Nav4RoadmapsDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpandedValue,
        ...dndProps
    })));
});

});
parcelRegister("dSmPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $42f84726405597fc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<85793bfef3f0eb98452fcf155d20e31e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $42f84726405597fc$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4RoadmapsWithRecent_query",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "currentURL",
                    "variableName": "currentURL"
                }
            ],
            "kind": "FragmentSpread",
            "name": "RoadmapNavExpanded_query"
        }
    ],
    "type": "Query"
};
$42f84726405597fc$var$node.hash = "468aac4b59c904dc566a05789c11dc6a";
var $42f84726405597fc$export$2e2bcd8739ae039 = $42f84726405597fc$var$node;

});

parcelRegister("dD4TM", function(module, exports) {
$parcel$export(module.exports, "ActionButtons", () => $c3857f414c91514f$export$88c65d2d98aab183);

var $euxye = parcelRequire("euxye");

var $gbTMi = parcelRequire("gbTMi");

var $2DbWL = parcelRequire("2DbWL");

var $6GljB = parcelRequire("6GljB");

var $72ldR = parcelRequire("72ldR");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $jca8H = parcelRequire("jca8H");

var $b1YRJ = parcelRequire("b1YRJ");

var $kaswN = parcelRequire("kaswN");
const $c3857f414c91514f$var$roadmaps = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons-static.roadmaps",
    defaultMessage: "Roadmaps"
});
const $c3857f414c91514f$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2DbWL.HideL1MenuItemSection), {
        menuId: (0, $6GljB.L1_MENU_ID).ROADMAPS,
        hasSeparator: false
    }));
$c3857f414c91514f$var$MenuItems.displayName = "MenuItems";
const $c3857f414c91514f$export$88c65d2d98aab183 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton } = (0, $euxye.useContext)((0, $kaswN.AnalyticContext));
    const handleNavMenuOpen = (0, $euxye.useCallback)(()=>{
        fireUIAnalyticForFixButton({
            itemId: (0, $b1YRJ.MEATBALL_DROPDOWN)
        });
    }, [
        fireUIAnalyticForFixButton
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jca8H.CreateRoadmapButton), null), !(0, $i860n.fg)('navx-global-side-nav') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
        onOpen: handleNavMenuOpen,
        MenuItems: $c3857f414c91514f$var$MenuItems,
        name: formatMessage($c3857f414c91514f$var$roadmaps)
    }));
};
$c3857f414c91514f$export$88c65d2d98aab183.displayName = "ActionButtons";

});
parcelRegister("jca8H", function(module, exports) {
$parcel$export(module.exports, "CreateRoadmapButton", () => $cd9a2bcd541cdc38$export$7248fbc1f26d6ff5);

var $euxye = parcelRequire("euxye");

var $7SOt3 = parcelRequire("7SOt3");

var $iPHqm = parcelRequire("iPHqm");

var $fsonl = parcelRequire("fsonl");

var $80YCM = parcelRequire("80YCM");

var $e1DnH = parcelRequire("e1DnH");

var $eO8S8 = parcelRequire("eO8S8");

var $hZDXn = parcelRequire("hZDXn");

var $ikOED = parcelRequire("ikOED");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $bycIq = parcelRequire("bycIq");

var $dE7qU = parcelRequire("dE7qU");

var $3VCGs = parcelRequire("3VCGs");

var $kaswN = parcelRequire("kaswN");

var $bVDHZ = parcelRequire("bVDHZ");

var $ehPBs = parcelRequire("ehPBs");
const $cd9a2bcd541cdc38$export$862abc666c31a61a = 'createRoadmaps';
const $cd9a2bcd541cdc38$var$createRoadmap = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons.create-roadmap",
    defaultMessage: "Create roadmap"
});
const $cd9a2bcd541cdc38$var$errorTitle = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons.error-title",
    defaultMessage: "We couldn\u2019t create roadmap"
});
const $cd9a2bcd541cdc38$var$errorDescription = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons.error-description",
    defaultMessage: "Please try again or refresh the page."
});
const $cd9a2bcd541cdc38$var$errorRefresh = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons.error-refresh",
    defaultMessage: "Try again"
});
const $cd9a2bcd541cdc38$var$infoTitleLimit = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons.info-title-limit",
    defaultMessage: "Reached limit"
});
const $cd9a2bcd541cdc38$var$useHasReachedCollectionsLimitMessage = ()=>{
    const entityLimitMessage = (0, $fsonl.useEntityLimitMessage)();
    const collectionsLimit = (0, $e1DnH.useEntityLimitsByType)((0, $7SOt3.ENTITY_LIMIT_TYPE).COLLECTIONS_PER_SITE);
    return (0, $euxye.useCallback)((collectionsCount)=>{
        if (collectionsLimit && collectionsCount >= collectionsLimit) return entityLimitMessage((0, $7SOt3.ENTITY_LIMIT_TYPE).COLLECTIONS_PER_SITE, collectionsLimit);
        return null;
    }, [
        collectionsLimit,
        entityLimitMessage
    ]);
};
const $cd9a2bcd541cdc38$export$7248fbc1f26d6ff5 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [isLoading, setIsLoading] = (0, $euxye.useState)(false);
    const isReadOnly = (0, $bVDHZ.useIsReadOnly)();
    const { loadCollections: loadCollections } = (0, $iPHqm.useNavigationCollectionsActions)();
    const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton } = (0, $euxye.useContext)((0, $kaswN.AnalyticContext));
    const collectionsCount = (0, $80YCM.useCollectionsDataCount)();
    const hasReachedCollectionsLimitMessage = $cd9a2bcd541cdc38$var$useHasReachedCollectionsLimitMessage();
    const reachedCollectionsLimitMessage = hasReachedCollectionsLimitMessage(collectionsCount);
    const collectionsIsLoading = (0, $80YCM.useCollectionsIsLoading)();
    const collectionsInitialized = (0, $80YCM.useCollectionsInitialized)();
    const collectionsError = (0, $80YCM.useCollectionsError)();
    const notifications = (0, $3VCGs.useNotifications)();
    const onCreateRoadmapClick = (0, $euxye.useCallback)(async ()=>{
        fireUIAnalyticForFixButton({
            itemId: $cd9a2bcd541cdc38$export$862abc666c31a61a
        });
        if (collectionsInitialized && !collectionsError) return;
        const init = async (refresh)=>{
            setIsLoading(true);
            try {
                const loadedCollections = await loadCollections({
                    refresh: refresh
                });
                const reachedLimitMessage = hasReachedCollectionsLimitMessage(loadedCollections.length);
                if (reachedLimitMessage) notifications.info({
                    title: formatMessage($cd9a2bcd541cdc38$var$infoTitleLimit),
                    description: reachedLimitMessage
                });
            } catch  {
                notifications.error({
                    title: formatMessage($cd9a2bcd541cdc38$var$errorTitle),
                    description: formatMessage($cd9a2bcd541cdc38$var$errorDescription),
                    actionLabel: formatMessage($cd9a2bcd541cdc38$var$errorRefresh),
                    actionTestId: 'create-roadmap',
                    onActionClick: ()=>init(true)
                });
            } finally{
                setIsLoading(false);
            }
        };
        await init(Boolean(collectionsError));
    }, [
        collectionsError,
        collectionsInitialized,
        fireUIAnalyticForFixButton,
        formatMessage,
        hasReachedCollectionsLimitMessage,
        loadCollections,
        notifications
    ]);
    const { Panel: Panel, trigger: trigger } = (0, $dE7qU.usePanel)();
    const onClosePanel = (0, $euxye.useCallback)(()=>{
        trigger.setPanel(null);
    }, [
        trigger
    ]);
    const entryPointProps = (0, $euxye.useMemo)(()=>({
            onClose: onClosePanel
        }), [
        onClosePanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bycIq.Trigger), {
        trigger: trigger,
        entryPoint: (0, $ehPBs.createRoadmapPanelAsync),
        entryPointProps: entryPointProps
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
            content: reachedCollectionsLimitMessage || formatMessage($cd9a2bcd541cdc38$var$createRoadmap)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eO8S8.CommonNavMenuButton), {
            // oxlint-disable-next-line typescript/consistent-type-assertions
            ref: ref,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ikOED))), {
                    ...iconProps,
                    size: "small"
                }),
            label: formatMessage($cd9a2bcd541cdc38$var$createRoadmap),
            isLoading: isLoading && collectionsIsLoading,
            isDisabled: Boolean(reachedCollectionsLimitMessage),
            onClick: onCreateRoadmapClick
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Panel, null)));
};
$cd9a2bcd541cdc38$export$7248fbc1f26d6ff5.displayName = "CreateRoadmapButton";

});
parcelRegister("7SOt3", function(module, exports) {
$parcel$export(module.exports, "ENTITY_LIMIT_TYPE", () => $03da64a14790952c$export$f1b0aa924e1e86ca);
/* eslint-disable jira/filename-case */ /**
 * The types of entity limits for collections
 */ const $03da64a14790952c$export$f1b0aa924e1e86ca = {
    VIEWS_PER_COLLECTION: 'viewsPerCollection',
    COLLECTIONS_PER_SITE: 'collectionsPerSite',
    VIEWSETS_PER_COLLECTION: 'viewsetsPerCollection'
};

});

parcelRegister("iPHqm", function(module, exports) {
$parcel$export(module.exports, "NavigationCollectionsStore", () => $76ea2e00ef1cc6f5$export$d1d31f5824439428);
$parcel$export(module.exports, "NavigationCollectionsContainer", () => $76ea2e00ef1cc6f5$export$706091b9dcc1c93c);
$parcel$export(module.exports, "useNavigationCollectionsActions", () => $76ea2e00ef1cc6f5$export$f352a6870c4cf8e4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $dB6ay = parcelRequire("dB6ay");
var $5QDqc = parcelRequire("5QDqc");

var $i860n = parcelRequire("i860n");

var $6i3TB = parcelRequire("6i3TB");

var $3g6We = parcelRequire("3g6We");

var $hrJcW = parcelRequire("hrJcW");

var $kU6AH = parcelRequire("kU6AH");

var $joTDZ = parcelRequire("joTDZ");

var $8FTQI = parcelRequire("8FTQI");
const $76ea2e00ef1cc6f5$var$addDeleteListener = (callback)=>({ getState: getState, setState: setState })=>{
        if (!getState().deleteCallbacks.includes(callback) && (0, $i860n.fg)('jpd-enable-roadmaps-recents-fe')) setState({
            deleteCallbacks: [
                ...getState().deleteCallbacks,
                callback
            ]
        });
    };
const $76ea2e00ef1cc6f5$var$removeDeleteListener = (callback)=>({ getState: getState, setState: setState })=>{
        if ((0, $i860n.fg)('jpd-enable-roadmaps-recents-fe')) setState({
            deleteCallbacks: getState().deleteCallbacks.filter((cb)=>cb !== callback)
        });
    };
const $76ea2e00ef1cc6f5$var$runDeleteListeners = ()=>({ getState: getState })=>{
        if ((0, $i860n.fg)('jpd-enable-roadmaps-recents-fe')) getState().deleteCallbacks.forEach((cb)=>cb());
    };
const $76ea2e00ef1cc6f5$var$actions = {
    addCollection: $6i3TB.addCollection,
    loadCollections: $3g6We.loadCollections,
    expandSectionForSelectedCollection: $joTDZ.expandSectionForSelectedCollection,
    updateCollection: $8FTQI.updateCollection,
    deleteCollection: $hrJcW.deleteCollection,
    copyCollection: $kU6AH.copyCollection,
    addDeleteListener: $76ea2e00ef1cc6f5$var$addDeleteListener,
    removeDeleteListener: $76ea2e00ef1cc6f5$var$removeDeleteListener,
    runDeleteListeners: $76ea2e00ef1cc6f5$var$runDeleteListeners
};
const $76ea2e00ef1cc6f5$var$initialState = {
    collections: {
        data: [],
        error: null,
        initialized: false,
        isLoading: false
    },
    activeCollectionUUID: undefined,
    deleteCallbacks: []
};
const $76ea2e00ef1cc6f5$export$d1d31f5824439428 = (0, $5QDqc.createStore)({
    initialState: $76ea2e00ef1cc6f5$var$initialState,
    actions: $76ea2e00ef1cc6f5$var$actions,
    name: 'PolarisNavigationCollectionsStore'
});
const $76ea2e00ef1cc6f5$var$onPropsChange = ({ setState: setState }, props)=>{
    setState({
        activeCollectionUUID: props.activeCollectionUUID
    });
};
const $76ea2e00ef1cc6f5$export$706091b9dcc1c93c = (0, $dB6ay.createContainer)($76ea2e00ef1cc6f5$export$d1d31f5824439428, {
    onInit: ()=>$76ea2e00ef1cc6f5$var$onPropsChange,
    onUpdate: ()=>$76ea2e00ef1cc6f5$var$onPropsChange
});
const $76ea2e00ef1cc6f5$export$f352a6870c4cf8e4 = (0, $3h1FP.createActionsHook)($76ea2e00ef1cc6f5$export$d1d31f5824439428);

});
parcelRegister("6i3TB", function(module, exports) {
$parcel$export(module.exports, "addCollection", () => $a1e5c02a83898021$export$933f273b2a11730f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $53TIi = parcelRequire("53TIi");
const $a1e5c02a83898021$export$933f273b2a11730f = (collection)=>async ({ setState: setState, getState: getState }, { cloudId: cloudId, onSuccess: onSuccess })=>{
        const state = getState();
        if (!cloudId || getState().collections?.isLoading || !getState().collections?.initialized) return;
        const isCollectionAlreadyAdded = state.collections.data.some((currentCollection)=>currentCollection.uuid === collection.uuid);
        if (isCollectionAlreadyAdded) return;
        setState({
            collections: {
                ...state.collections,
                data: (0, $53TIi.sortedInsertCollection)(state.collections.data, collection)
            }
        });
        onSuccess?.('addCollection');
    };

});
parcelRegister("53TIi", function(module, exports) {
$parcel$export(module.exports, "updateCollectionsState", () => $aa2673ac42e81116$export$8df89fb7c4993dc);
$parcel$export(module.exports, "transformRemoteNavigationCollection", () => $aa2673ac42e81116$export$7a2bbd8e91947e59);
$parcel$export(module.exports, "sortCollectionsComparator", () => $aa2673ac42e81116$export$2cd1058da15f4128);
$parcel$export(module.exports, "sortedInsertCollection", () => $aa2673ac42e81116$export$c3b09a1eb31c40b9);
$parcel$export(module.exports, "normalizeError", () => $aa2673ac42e81116$export$e7bd538fb0c5db1a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $aa2673ac42e81116$export$8df89fb7c4993dc = (state, collectionUUID, update)=>{
    let hasFoundCollection = false;
    const nextCollections = state.collections.data.map((navigationCollection)=>{
        if (navigationCollection.uuid === collectionUUID) {
            hasFoundCollection = true;
            return update(navigationCollection);
        }
        return navigationCollection;
    });
    if (!hasFoundCollection) // There is nothing to update, bail out
    return undefined;
    return {
        ...state,
        collections: {
            ...state.collections,
            data: nextCollections
        }
    };
};
const $aa2673ac42e81116$export$7a2bbd8e91947e59 = (remoteNavigationCollection)=>({
        ...remoteNavigationCollection,
        isExpanded: false
    });
function $aa2673ac42e81116$export$29b1844f9b066c27(arr, element, comparator) {
    const result = [];
    let inserted = false;
    for(let i = 0; i < arr.length; i += 1){
        if (!inserted && comparator(arr[i], element)) {
            inserted = true;
            result.push(element);
        }
        result.push(arr[i]);
    }
    if (!inserted) result.push(element);
    return result;
}
const $aa2673ac42e81116$export$2cd1058da15f4128 = (a, b)=>{
    return a.name.localeCompare(b.name, undefined, {
        numeric: true
    });
};
const $aa2673ac42e81116$export$c3b09a1eb31c40b9 = (collections, collection)=>{
    return $aa2673ac42e81116$export$29b1844f9b066c27(collections, collection, (a, b)=>$aa2673ac42e81116$export$2cd1058da15f4128(a, b) === 1);
};
const $aa2673ac42e81116$export$e7bd538fb0c5db1a = (error)=>{
    if (error instanceof Error) return error;
    return new Error('Unexpected error - catched value is not an instance of an Error class');
};

});


parcelRegister("3g6We", function(module, exports) {
$parcel$export(module.exports, "loadCollections", () => $1f00f345f6a30a4c$export$569b2ddb07e9ef58);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $joTDZ = parcelRequire("joTDZ");

var $53TIi = parcelRequire("53TIi");
const $1f00f345f6a30a4c$export$569b2ddb07e9ef58 = (options)=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { navigationCollectionsRemote: navigationCollectionsRemote, cloudId: cloudId, onFailure: onFailure, onSuccess: onSuccess })=>{
        if (!cloudId || !navigationCollectionsRemote || !navigationCollectionsRemote.fetch || getState().collections.isLoading || getState().collections.initialized && !options?.refresh) return getState().collections.data;
        setState({
            collections: {
                ...getState().collections,
                isLoading: true,
                initialized: true,
                error: null,
                data: []
            }
        });
        try {
            const collectionsRemote = await navigationCollectionsRemote.fetch();
            const data = collectionsRemote.map((0, $53TIi.transformRemoteNavigationCollection)).sort((0, $53TIi.sortCollectionsComparator));
            setState({
                collections: {
                    ...getState().collections,
                    isLoading: false,
                    initialized: true,
                    error: null,
                    data: data
                }
            });
            dispatch((0, $joTDZ.expandSectionForSelectedCollection)());
            onSuccess?.('loadCollections');
            return data;
        } catch (maybeError) {
            const error = (0, $53TIi.normalizeError)(maybeError);
            setState({
                collections: {
                    isLoading: false,
                    initialized: true,
                    error: error,
                    data: []
                }
            });
            onFailure?.(error, 'loadCollections');
            throw maybeError;
        }
    };

});
parcelRegister("joTDZ", function(module, exports) {
$parcel$export(module.exports, "expandSectionForSelectedCollection", () => $ee94964f0bf7c1e9$export$fe12972b084f1fb8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8FTQI = parcelRequire("8FTQI");
const $ee94964f0bf7c1e9$export$fe12972b084f1fb8 = ()=>async ({ dispatch: dispatch }, { activeCollectionUUID: activeCollectionUUID, onSuccess: onSuccess })=>{
        if (activeCollectionUUID) {
            dispatch((0, $8FTQI.updateCollection)(activeCollectionUUID, {
                isExpanded: true
            }));
            onSuccess?.('expandSectionForSelectedCollection');
        }
    };

});
parcelRegister("8FTQI", function(module, exports) {
$parcel$export(module.exports, "updateCollection", () => $b3d582f74f7cd78e$export$c0683150b517c317);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $53TIi = parcelRequire("53TIi");
const $b3d582f74f7cd78e$export$c0683150b517c317 = (collectionUUID, patch)=>async ({ setState: setState, getState: getState }, { cloudId: cloudId, onSuccess: onSuccess })=>{
        const state = getState();
        if (!cloudId || state.collections.isLoading || !state.collections.initialized) return;
        if (!collectionUUID) return;
        const nextState = (0, $53TIi.updateCollectionsState)(state, collectionUUID, (prevNavigationCollection)=>({
                ...prevNavigationCollection,
                ...patch
            }));
        if (nextState) {
            setState(nextState);
            onSuccess?.('updateCollection');
        }
    };

});



parcelRegister("hrJcW", function(module, exports) {
$parcel$export(module.exports, "deleteCollection", () => $4301feb381b8f411$export$3d16e031f6551662);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $4301feb381b8f411$export$3d16e031f6551662 = (collectionUUID)=>async ({ setState: setState, getState: getState }, { onSuccess: onSuccess })=>{
        const state = getState();
        let removed = false;
        const filteredCollections = state.collections.data.filter((collection)=>{
            const shouldRemove = collection.uuid === collectionUUID;
            if (shouldRemove) removed = true;
            return !shouldRemove;
        });
        if (!removed) return;
        setState({
            collections: {
                ...state.collections,
                data: filteredCollections
            }
        });
        onSuccess?.('deleteCollection');
    };

});

parcelRegister("kU6AH", function(module, exports) {
$parcel$export(module.exports, "copyCollection", () => $2ab5d5348eaf8120$export$36928e43600c4b00);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $53TIi = parcelRequire("53TIi");
const $2ab5d5348eaf8120$export$36928e43600c4b00 = (collectionUUID, patch)=>async ({ setState: setState, getState: getState }, { onSuccess: onSuccess })=>{
        const state = getState();
        if (!patch.uuid) return;
        const originalCollection = state.collections.data.find((collection)=>collection.uuid === collectionUUID);
        if (originalCollection) {
            const clonedCollection = {
                ...originalCollection,
                uuid: patch.uuid,
                name: patch.name,
                ownerId: patch.ownerId || ''
            };
            setState({
                collections: {
                    ...state.collections,
                    data: (0, $53TIi.sortedInsertCollection)(state.collections.data, clonedCollection)
                }
            });
            onSuccess?.('copyCollection');
        }
    };

});


parcelRegister("fsonl", function(module, exports) {
$parcel$export(module.exports, "useEntityLimitMessage", () => $ed13324b1a00c6bd$export$5742ba1ea30fad0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $6Kj8L = parcelRequire("6Kj8L");
const $ed13324b1a00c6bd$export$5742ba1ea30fad0 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return (0, $euxye.useCallback)((limitType, limitValue)=>{
        const message = (0, $6Kj8L.getLimitMessageDescriptor)(limitType);
        return message ? formatMessage(message, {
            limit: limitValue
        }) : null;
    }, [
        formatMessage
    ]);
};

});
parcelRegister("6Kj8L", function(module, exports) {
$parcel$export(module.exports, "getLimitMessageDescriptor", () => $27331746fbbe6087$export$73d6edc517ef6f51);
/* eslint-disable jira/filename-case, jira/i18n/id-named-by-package, jira/naming/disallow-filenames */ 
var $7SOt3 = parcelRequire("7SOt3");

var $hfv9m = parcelRequire("hfv9m");

var $7eNDO = parcelRequire("7eNDO");
const $27331746fbbe6087$var$commentsPerViewMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.comments-per-view",
    defaultMessage: "This view has reached its maximum of {limit, plural, one {# comment} other {# comments}}."
});
const $27331746fbbe6087$var$fieldsPerViewMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.fields-per-view",
    defaultMessage: "This view has reached its maximum of {limit, plural, one {# field} other {# fields}}."
});
const $27331746fbbe6087$var$fieldsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.fields-per-project",
    defaultMessage: "This project has reached its maximum of {limit, plural, one {# field} other {# fields}}."
});
const $27331746fbbe6087$var$ideasSearchMaxResultsMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.ideas-search-max-results",
    defaultMessage: "This search has reached its maximum of {limit, plural, one {# result} other {# results}}."
});
const $27331746fbbe6087$var$insightsPerIdeaMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.insights-per-idea",
    defaultMessage: "This idea has reached its maximum of {limit, plural, one {# insight} other {# insights}}."
});
const $27331746fbbe6087$var$insightsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.insights-per-project",
    defaultMessage: "This project has reached its maximum of {limit, plural, one {# insight} other {# insights}}."
});
const $27331746fbbe6087$var$labelsPerSnippetMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.labels-per-snippet",
    defaultMessage: "This snippet has reached its maximum of {limit, plural, one {# label} other {# labels}}."
});
const $27331746fbbe6087$var$optionsPerFieldMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.options-per-field",
    defaultMessage: "This field has reached its maximum of {limit, plural, one {# option} other {# options}}."
});
const $27331746fbbe6087$var$playContributionsPerPlayMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.play-contributions-per-play",
    defaultMessage: "This vote has reached its maximum of {limit, plural, one {# vote contribution} other {# vote contributions}}."
});
const $27331746fbbe6087$var$playContributionsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.play-contributions-per-project",
    defaultMessage: "This project has reached its maximum of {limit, plural, one {# vote contribution} other {# vote contributions}}."
});
const $27331746fbbe6087$var$playsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.plays-per-project",
    defaultMessage: "You've reached a {limit, plural, one {# vote field} other {# vote fields}} limit per project."
});
const $27331746fbbe6087$var$snippetsPerInsightMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.snippets-per-insight",
    defaultMessage: "This insight has reached its maximum of {limit, plural, one {# snippet} other {# snippets}}."
});
const $27331746fbbe6087$var$viewsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.views-per-project",
    defaultMessage: "This project has reached its maximum of {limit, plural, one {# view} other {# views}}."
});
const $27331746fbbe6087$var$viewsPerCollectionMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.views-per-collection",
    defaultMessage: "This roadmap has reached its maximum of {limit, plural, one {# view} other {# views}}."
});
const $27331746fbbe6087$var$viewsetsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.viewsets-per-project",
    defaultMessage: "This project has reached its maximum of {limit, plural, one {# section} other {# sections}}."
});
const $27331746fbbe6087$var$viewsetsPerCollectionMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.viewsets-per-collection",
    defaultMessage: "This roadmap has reached its maximum of {limit, plural, one {# section} other {# sections}}."
});
const $27331746fbbe6087$var$collectionsPerSiteMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.common.collections-per-site",
    defaultMessage: "This site has reached its maximum of {limit, plural, one {# roadmap} other {# roadmaps}}."
});
const $27331746fbbe6087$var$messages = {
    [(0, $hfv9m.ENTITY_LIMIT_TYPE).COMMENTS_PER_VIEW]: $27331746fbbe6087$var$commentsPerViewMessage,
    [(0, $hfv9m.ENTITY_LIMIT_TYPE).FIELDS_PER_VIEW]: $27331746fbbe6087$var$fieldsPerViewMessage,
    [(0, $hfv9m.ENTITY_LIMIT_TYPE).FIELDS_PER_PROJECT]: $27331746fbbe6087$var$fieldsPerProjectMessage,
    [(0, $hfv9m.ENTITY_LIMIT_TYPE).IDEAS_SEARCH_MAX_RESULTS]: $27331746fbbe6087$var$ideasSearchMaxResultsMessage,
    [(0, $hfv9m.ENTITY_LIMIT_TYPE).INSIGHTS_PER_IDEA]: $27331746fbbe6087$var$insightsPerIdeaMessage,
    [(0, $hfv9m.ENTITY_LIMIT_TYPE).INSIGHTS_PER_PROJECT]: $27331746fbbe6087$var$insightsPerProjectMessage,
    [(0, $hfv9m.ENTITY_LIMIT_TYPE).LABELS_PER_SNIPPET]: $27331746fbbe6087$var$labelsPerSnippetMessage,
    [(0, $hfv9m.ENTITY_LIMIT_TYPE).OPTIONS_PER_FIELD]: $27331746fbbe6087$var$optionsPerFieldMessage,
    [(0, $hfv9m.ENTITY_LIMIT_TYPE).PLAY_CONTRIBUTIONS_PER_PLAY]: $27331746fbbe6087$var$playContributionsPerPlayMessage,
    [(0, $hfv9m.ENTITY_LIMIT_TYPE).PLAY_CONTRIBUTIONS_PER_PROJECT]: $27331746fbbe6087$var$playContributionsPerProjectMessage,
    [(0, $hfv9m.ENTITY_LIMIT_TYPE).PLAYS_PER_PROJECT]: $27331746fbbe6087$var$playsPerProjectMessage,
    [(0, $hfv9m.ENTITY_LIMIT_TYPE).SNIPPETS_PER_INSIGHT]: $27331746fbbe6087$var$snippetsPerInsightMessage,
    [(0, $hfv9m.ENTITY_LIMIT_TYPE).VIEWS_PER_PROJECT]: $27331746fbbe6087$var$viewsPerProjectMessage,
    [(0, $7SOt3.ENTITY_LIMIT_TYPE).VIEWS_PER_COLLECTION]: $27331746fbbe6087$var$viewsPerCollectionMessage,
    [(0, $hfv9m.ENTITY_LIMIT_TYPE).VIEWSETS_PER_PROJECT]: $27331746fbbe6087$var$viewsetsPerProjectMessage,
    [(0, $7SOt3.ENTITY_LIMIT_TYPE).VIEWSETS_PER_COLLECTION]: $27331746fbbe6087$var$viewsetsPerCollectionMessage,
    [(0, $7SOt3.ENTITY_LIMIT_TYPE).COLLECTIONS_PER_SITE]: $27331746fbbe6087$var$collectionsPerSiteMessage
};
const $27331746fbbe6087$export$73d6edc517ef6f51 = (limitType)=>$27331746fbbe6087$var$messages[limitType] || null;

});
parcelRegister("hfv9m", function(module, exports) {
$parcel$export(module.exports, "ENTITY_LIMIT_TYPE", () => $e1fc42cfe0a00e78$export$f1b0aa924e1e86ca);
$parcel$export(module.exports, "TEMPORARY_PROJECT_TEMPLATE_KEYS", () => $e1fc42cfe0a00e78$export$d47328eb6ca36753);
/* eslint-disable jira/filename-case */ /**
 * The types of entity limits for a project
 */ const $e1fc42cfe0a00e78$export$f1b0aa924e1e86ca = {
    COMMENTS_PER_VIEW: 'commentsPerView',
    FIELDS_PER_PROJECT: 'fieldsPerProject',
    FIELDS_PER_VIEW: 'fieldsPerView',
    IDEAS_SEARCH_MAX_RESULTS: 'ideasSearchMaxResults',
    INSIGHTS_PER_IDEA: 'insightsPerIdea',
    INSIGHTS_PER_PROJECT: 'insightsPerProject',
    LABELS_PER_SNIPPET: 'labelsPerSnippet',
    OPTIONS_PER_FIELD: 'optionsPerField',
    PLAY_CONTRIBUTIONS_PER_PLAY: 'playContributionsPerPlay',
    PLAY_CONTRIBUTIONS_PER_PROJECT: 'playContributionsPerProject',
    PLAYS_PER_PROJECT: 'playsPerProject',
    SNIPPETS_PER_INSIGHT: 'snippetsPerInsight',
    VIEWS_PER_PROJECT: 'viewsPerProject',
    VIEWSETS_PER_PROJECT: 'viewsetsPerProject'
};
const $e1fc42cfe0a00e78$export$d47328eb6ca36753 = {
    OPPORTUNITY_SOLUTION: 'jira.polaris.opportunity-solution',
    PORTFOLIO_ROADMAP: 'jira.polaris.portfolio-roadmap'
};

});



parcelRegister("80YCM", function(module, exports) {
$parcel$export(module.exports, "useCollectionsInitialized", () => $cbb548c04cebc002$export$46b6d9c007ee80ff);
$parcel$export(module.exports, "useCollectionsIsLoading", () => $cbb548c04cebc002$export$220cef4c213f9f8c);
$parcel$export(module.exports, "useCollectionsError", () => $cbb548c04cebc002$export$9ee25d19d08e6165);
$parcel$export(module.exports, "useCollectionsData", () => $cbb548c04cebc002$export$42079ab957ed5ef3);
$parcel$export(module.exports, "useCollectionsDataCount", () => $cbb548c04cebc002$export$58d41e4df33f533b);
// eslint-disable-next-line jira/filename-case, jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");

var $iPHqm = parcelRequire("iPHqm");

var $6CIQy = parcelRequire("6CIQy");
const $cbb548c04cebc002$export$46b6d9c007ee80ff = (0, $3h1FP.createStateHook)((0, $iPHqm.NavigationCollectionsStore), {
    selector: (0, $6CIQy.getCollectionsInitialized)
});
const $cbb548c04cebc002$export$220cef4c213f9f8c = (0, $3h1FP.createStateHook)((0, $iPHqm.NavigationCollectionsStore), {
    selector: (0, $6CIQy.getCollectionsIsLoading)
});
const $cbb548c04cebc002$export$9ee25d19d08e6165 = (0, $3h1FP.createStateHook)((0, $iPHqm.NavigationCollectionsStore), {
    selector: (0, $6CIQy.getCollectionsError)
});
const $cbb548c04cebc002$export$42079ab957ed5ef3 = (0, $3h1FP.createStateHook)((0, $iPHqm.NavigationCollectionsStore), {
    selector: (0, $6CIQy.getCollectionsData)
});
const $cbb548c04cebc002$export$58d41e4df33f533b = (0, $3h1FP.createStateHook)((0, $iPHqm.NavigationCollectionsStore), {
    selector: (0, $6CIQy.getCollectionsDataCount)
});

});
parcelRegister("6CIQy", function(module, exports) {
$parcel$export(module.exports, "getCollectionsInitialized", () => $c54c7d38deb48dab$export$d27d15e9feab8557);
$parcel$export(module.exports, "getCollectionsIsLoading", () => $c54c7d38deb48dab$export$2bac8c18281a52e0);
$parcel$export(module.exports, "getCollectionsError", () => $c54c7d38deb48dab$export$66d4708c2e689cee);
$parcel$export(module.exports, "getCollectionsData", () => $c54c7d38deb48dab$export$2ab06e12c74a99c3);
$parcel$export(module.exports, "getCollectionsDataCount", () => $c54c7d38deb48dab$export$bf8e5d2f298f4f42);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3K7NP = parcelRequire("3K7NP");
const $c54c7d38deb48dab$export$d27d15e9feab8557 = (state)=>state.collections.initialized;
const $c54c7d38deb48dab$export$2bac8c18281a52e0 = (state)=>state.collections.isLoading;
const $c54c7d38deb48dab$export$66d4708c2e689cee = (state)=>state.collections.error;
const $c54c7d38deb48dab$export$2ab06e12c74a99c3 = (0, $3K7NP.createSelector)((state)=>state.collections.data, (state)=>state.activeCollectionUUID, (collections, activeCollectionUUID)=>collections.filter((collection)=>collection.uuid === activeCollectionUUID));
const $c54c7d38deb48dab$export$bf8e5d2f298f4f42 = (state)=>state.collections.data.length;

});


parcelRegister("e1DnH", function(module, exports) {
$parcel$export(module.exports, "useEntityLimits", () => $e36aea0f0a976de2$export$27563114e215d5d2);
$parcel$export(module.exports, "useEntityLimitsByType", () => $e36aea0f0a976de2$export$131d1f6522e0008b);
// eslint-disable-next-line jira/filename-case, jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");

var $fdPS1 = parcelRequire("fdPS1");

var $kEpDv = parcelRequire("kEpDv");
const $e36aea0f0a976de2$export$27563114e215d5d2 = (0, $3h1FP.createHook)((0, $fdPS1.EntityLimitsStore), {
    selector: (0, $kEpDv.getEntityLimits)
});
const $e36aea0f0a976de2$export$131d1f6522e0008b = (limitType)=>{
    const [entityLimits] = $e36aea0f0a976de2$export$27563114e215d5d2();
    return entityLimits?.[limitType] ?? null;
};

});
parcelRegister("fdPS1", function(module, exports) {
$parcel$export(module.exports, "EntityLimitsStore", () => $a33166a6974c5823$export$1ae04e764bd1943c);
$parcel$export(module.exports, "EntityLimitsContainer", () => $a33166a6974c5823$export$6cb5289bbfe5ddf1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $dB6ay = parcelRequire("dB6ay");
var $5QDqc = parcelRequire("5QDqc");

var $cSMX6 = parcelRequire("cSMX6");

var $brj0i = parcelRequire("brj0i");
const $a33166a6974c5823$var$actions = {
    loadEntityLimits: $cSMX6.loadEntityLimits
};
const $a33166a6974c5823$export$1ae04e764bd1943c = (0, $5QDqc.createStore)({
    initialState: (0, $brj0i.EMPTY_STATE),
    actions: $a33166a6974c5823$var$actions,
    name: 'PolarisEntityLimitsStore'
});
const $a33166a6974c5823$export$3ad3f015953a20eb = (0, $3h1FP.createActionsHook)($a33166a6974c5823$export$1ae04e764bd1943c);
const $a33166a6974c5823$export$6cb5289bbfe5ddf1 = (0, $dB6ay.createContainer)($a33166a6974c5823$export$1ae04e764bd1943c, {
    onInit: ()=>({ dispatch: dispatch })=>dispatch((0, $cSMX6.loadEntityLimits)())
});

});
parcelRegister("cSMX6", function(module, exports) {
$parcel$export(module.exports, "loadEntityLimits", () => $2ba093aaf6617aa8$export$793a286ad01e9c6a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4BBh0 = parcelRequire("4BBh0");

var $jFyox = parcelRequire("jFyox");
const $2ba093aaf6617aa8$export$793a286ad01e9c6a = ()=>async ({ getState: getState, setState: setState }, { createAnalyticsEvent: createAnalyticsEvent })=>{
        const { meta: { loaded: loaded, loading: loading } } = getState();
        // Fetch only once
        if (loaded || loading) return;
        setState({
            meta: {
                loaded: false,
                loading: true
            },
            entityLimits: undefined
        });
        try {
            const entityLimits = await (0, $jFyox.fetchEntityLimits)();
            setState({
                meta: {
                    loaded: true,
                    loading: false
                },
                entityLimits: entityLimits
            });
        } catch  {
            (0, $4BBh0.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'loadLimits failure');
        }
    };

});
parcelRegister("jFyox", function(module, exports) {
$parcel$export(module.exports, "fetchEntityLimits", () => $ce2742531aa07c09$export$bd0a928e99c83c9f);

var $7SOt3 = parcelRequire("7SOt3");

var $hfv9m = parcelRequire("hfv9m");

var $4fhEY = parcelRequire("4fhEY");
const $ce2742531aa07c09$var$ENTITY_LIMIT_TYPE = {
    ...(0, $hfv9m.ENTITY_LIMIT_TYPE),
    ...(0, $7SOt3.ENTITY_LIMIT_TYPE)
};
const $ce2742531aa07c09$export$bd0a928e99c83c9f = async ()=>{
    const entityLimits = {};
    const response = await (0, $4fhEY.default)('/gateway/api/jpd/gravity/v1/limits');
    // Convert the response to the format expected by the UI
    for (const [key, value] of Object.entries(response?.limits ?? {})){
        // oxlint-disable-next-line typescript/consistent-type-assertions
        const limitType = $ce2742531aa07c09$var$ENTITY_LIMIT_TYPE[key];
        if (limitType) entityLimits[limitType] = value;
    }
    return entityLimits;
};

});


parcelRegister("brj0i", function(module, exports) {
$parcel$export(module.exports, "EMPTY_STATE", () => $758e1b8de1058388$export$f040258c471d4154);
/* eslint-disable jira/filename-case */ const $758e1b8de1058388$export$f040258c471d4154 = {
    entityLimits: undefined,
    meta: {
        loaded: false,
        loading: false,
        loadingError: undefined
    }
};

});


parcelRegister("kEpDv", function(module, exports) {
$parcel$export(module.exports, "getEntityLimits", () => $1b7df87c132a4fe2$export$cb3b1a64aebe85bd);
/* eslint-disable jira/filename-case */ const $1b7df87c132a4fe2$export$cb3b1a64aebe85bd = (state)=>state?.entityLimits ?? null;

});


parcelRegister("bycIq", function(module, exports) {
$parcel$export(module.exports, "Trigger", () => $4cd2d437b0820f50$export$41fb9f06171c75f4);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $fsEVO = parcelRequire("fsEVO");

var $8EpkY = parcelRequire("8EpkY");

var $gAEFP = parcelRequire("gAEFP");

var $cxpqA = parcelRequire("cxpqA");

var $lTVYD = parcelRequire("lTVYD");
const $4cd2d437b0820f50$var$emptyEntryPointParams = {};
const $4cd2d437b0820f50$var$emptyEntryPointProps = {};
function $4cd2d437b0820f50$export$41fb9f06171c75f4({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, forwardedRef: forwardedRef, trigger: trigger, loadOnFocus: loadOnFocus = false }) {
    const { setPanel: setPanel } = trigger;
    const environmentProvider = (0, $cxpqA.useRelayEnvironmentProvider)();
    const id = (0, $euxye.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = ()=>(0, $n67Vb.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $4cd2d437b0820f50$var$emptyEntryPointParams);
    const onLoad = (0, $euxye.useCallback)(({ reference: entryPointReference })=>{
        setPanel(/*#__PURE__*/ (0, $e79Pd.jsx)((0, $gAEFP.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lTVYD.DefaultFallback), {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $4cd2d437b0820f50$var$emptyEntryPointProps
        }));
    }, [
        setPanel,
        id,
        entryPointProps,
        fallback,
        errorFallback
    ]);
    const triggerRef = (0, $8EpkY.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        loadOnFocus: loadOnFocus
    });
    const mergedRef = (0, $fsEVO.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}
$4cd2d437b0820f50$export$41fb9f06171c75f4.displayName = "Trigger";

});
parcelRegister("lTVYD", function(module, exports) {
$parcel$export(module.exports, "DefaultFallback", () => $6f7574434bc04906$export$93c734e924cdbdaa);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $kENFC = parcelRequire("kENFC");
function $6f7574434bc04906$export$93c734e924cdbdaa() {
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kENFC.default), {}),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kENFC.default), {}),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kENFC.default), {}),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kENFC.default), {})
        ]
    });
}
$6f7574434bc04906$export$93c734e924cdbdaa.displayName = "DefaultFallback";

});


parcelRegister("dE7qU", function(module, exports) {
$parcel$export(module.exports, "usePanel", () => $e6b93dc0f044528f$export$9168a42f32e3d071);

var $euxye = parcelRequire("euxye");
function $e6b93dc0f044528f$export$9168a42f32e3d071(preloadedPanel) {
    const [panel, setPanel] = (0, $euxye.useState)(preloadedPanel);
    const Panel = (0, $euxye.useMemo)(()=>{
        const PanelComponent = ()=>panel ?? null;
        return PanelComponent;
    }, [
        panel
    ]);
    const trigger = (0, $euxye.useMemo)(()=>({
            setPanel: (panel)=>setPanel(panel)
        }), [
        setPanel
    ]);
    return (0, $euxye.useMemo)(()=>({
            Panel: Panel,
            trigger: trigger
        }), [
        Panel,
        trigger
    ]);
}

});

parcelRegister("3VCGs", function(module, exports) {
$parcel$export(module.exports, "useNotifications", () => $064b2eb211780233$export$53d5ca6c3f53e109);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $26fxr = parcelRequire("26fxr");

var $bgJDP = parcelRequire("bgJDP");
const $064b2eb211780233$export$53d5ca6c3f53e109 = ()=>{
    const { error: errorFlag, customFlag: customFlag } = (0, $26fxr.useNotifications)();
    const error = (0, $euxye.useCallback)(({ title: title, description: description, actionLabel: actionLabel, actionTestId: actionTestId, onActionClick: onActionClick })=>{
        const dismissErrorFlag = errorFlag({
            title: title,
            description: description,
            actions: [
                {
                    content: actionLabel,
                    testId: actionTestId,
                    onClick: ()=>{
                        onActionClick();
                        dismissErrorFlag();
                    }
                }
            ]
        });
    }, [
        errorFlag
    ]);
    const info = (0, $euxye.useCallback)(({ title: title, description: description })=>{
        customFlag({
            title: title,
            description: description,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bgJDP))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-information, #357DE8)"
            })
        });
    }, [
        customFlag
    ]);
    return (0, $euxye.useMemo)(()=>({
            error: error,
            info: info
        }), [
        error,
        info
    ]);
};

});

parcelRegister("bVDHZ", function(module, exports) {
$parcel$export(module.exports, "useIsReadOnly", () => $4bfb20777d5d8869$export$692360c94a69c4f6);
// eslint-disable-next-line jira/filename-case

var $1KydW = parcelRequire("1KydW");
const $4bfb20777d5d8869$export$692360c94a69c4f6 = ()=>{
    const { hasProductDiscoveryAccess: hasProductDiscoveryAccess } = (0, $1KydW.useApplicationPermissions)();
    return !hasProductDiscoveryAccess;
};

});

parcelRegister("ehPBs", function(module, exports) {
$parcel$export(module.exports, "createRoadmapPanelAsync", () => $029d20686e8251ed$export$39eae036a6d21547);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $029d20686e8251ed$export$39eae036a6d21547 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("2tu6N")), {
        moduleId: "9dab0e7a",
        moduleName: "CreateRoadmapPanel",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2tu6N", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3MlBX").then(()=>parcelRequire('gAVVh'));

});




parcelRegister("9z50I", function(module, exports) {
$parcel$export(module.exports, "RoadmapsProviders", () => $2410b590deb991ca$export$a79ba30f39031198);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $8wdvw = parcelRequire("8wdvw");

var $fdPS1 = parcelRequire("fdPS1");

var $iPHqm = parcelRequire("iPHqm");

var $gvtNj = parcelRequire("gvtNj");

var $kt86l = parcelRequire("kt86l");

var $3GN2r = parcelRequire("3GN2r");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $1rRWW = parcelRequire("1rRWW");

var $kaswN = parcelRequire("kaswN");

var $78GR0 = parcelRequire("78GR0");
const $2410b590deb991ca$export$a79ba30f39031198 = ({ children: children })=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const currentUser = (0, $3GN2r.useAccountId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kaswN.AnalyticContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gvtNj.OnboardingFlowsContainer), {
        accountId: currentUser
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1rRWW.NavigationCollectionsRemoteProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1rRWW.NavigationViewRemoteProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($2410b590deb991ca$var$NavigationCollectionsContainerWithRemote, {
        cloudId: cloudId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fdPS1.EntityLimitsContainer), {
        isGlobal: true,
        createAnalyticsEvent: createAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8wdvw.EmojiContainer), {
        cloudId: cloudId,
        currentUser: currentUser || undefined
    }, children)))))));
};
$2410b590deb991ca$export$a79ba30f39031198.displayName = "RoadmapsProviders";
const $2410b590deb991ca$var$NavigationCollectionsContainerWithRemote = ({ cloudId: cloudId, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const remote = (0, $1rRWW.useNavigationCollectionsRemote)();
    const collectionSelectedMatched = (0, $78GR0.useCollectionSelectedMatch)();
    const handleFailure = (0, $euxye.useCallback)((error, identifier)=>{
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'jpdNavigationV4Action'
            },
            attributes: {
                action: identifier,
                type: 'collections'
            }
        });
    }, []);
    const handleSuccess = (0, $euxye.useCallback)((action)=>{
        (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jpdNavigationV4Action success', {
            action: action,
            type: 'collections'
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iPHqm.NavigationCollectionsContainer), {
        isGlobal: true,
        cloudId: cloudId,
        navigationCollectionsRemote: remote,
        activeCollectionUUID: collectionSelectedMatched?.collectionUUID,
        onFailure: handleFailure,
        onSuccess: handleSuccess
    }, children);
};
$2410b590deb991ca$var$NavigationCollectionsContainerWithRemote.displayName = "NavigationCollectionsContainerWithRemote";

});
parcelRegister("8wdvw", function(module, exports) {
$parcel$export(module.exports, "useEmoji", () => $318c3ae525c263dd$export$482903c4ce3f5633);
$parcel$export(module.exports, "useEmojiById", () => $318c3ae525c263dd$export$659ae98cb5b73fba);
$parcel$export(module.exports, "useEmojiProviderPromise", () => $318c3ae525c263dd$export$d020ccccbff96c19);
$parcel$export(module.exports, "EmojiContainer", () => $318c3ae525c263dd$export$5138cd734f185a21);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $fmH48 = parcelRequire("fmH48");

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $3K7NP = parcelRequire("3K7NP");
var $5QDqc = parcelRequire("5QDqc");
const $318c3ae525c263dd$var$actions = {
    loadEmoji: (emojiId)=>async ({ getState: getState, setState: setState })=>{
            const { provider: provider } = getState();
            if (!provider) return;
            const resolvedProvider = await provider;
            const optionalDescription = await resolvedProvider.findById(emojiId);
            const emoji = optionalDescription !== undefined ? await resolvedProvider.getMediaEmojiDescriptionURLWithInlineToken(optionalDescription) : optionalDescription;
            setState({
                cachedEmojis: {
                    ...getState().cachedEmojis,
                    [emojiId]: emoji ?? null
                }
            });
        }
};
const $318c3ae525c263dd$var$initialState = {
    provider: undefined,
    cachedEmojis: {}
};
const $318c3ae525c263dd$var$EmojiStore = (0, $5QDqc.createStore)({
    initialState: $318c3ae525c263dd$var$initialState,
    actions: $318c3ae525c263dd$var$actions,
    name: 'PolarisEmojiStore'
});
const $318c3ae525c263dd$var$useEmojis = (0, $3h1FP.createHook)($318c3ae525c263dd$var$EmojiStore);
const $318c3ae525c263dd$export$482903c4ce3f5633 = (emojiId)=>{
    const [emoji, setEmoji] = (0, $euxye.useState)(undefined);
    const [{ provider: provider }] = $318c3ae525c263dd$var$useEmojis();
    (0, $euxye.useEffect)(()=>{
        if (emojiId !== undefined && provider !== undefined) provider.then((resolvedProvider)=>{
            Promise.resolve(resolvedProvider.findById(emojiId)).then((optionalDescription)=>optionalDescription !== undefined ? resolvedProvider.getMediaEmojiDescriptionURLWithInlineToken(optionalDescription) : optionalDescription).then(setEmoji);
        });
        else setEmoji(undefined);
    }, [
        provider,
        emojiId
    ]);
    return emojiId !== undefined ? emoji : undefined;
};
const $318c3ae525c263dd$export$659ae98cb5b73fba = (0, $3h1FP.createHook)($318c3ae525c263dd$var$EmojiStore, {
    selector: (0, $3K7NP.createSelector)((state, { emojiId: emojiId })=>emojiId ? state.cachedEmojis[emojiId] : undefined, (emoji)=>emoji)
});
const $318c3ae525c263dd$export$d020ccccbff96c19 = ()=>{
    const [{ provider: provider }] = $318c3ae525c263dd$var$useEmojis();
    return provider !== undefined ? provider : Promise.reject(new Error('emoji provider not initialized'));
};
const $318c3ae525c263dd$export$5138cd734f185a21 = (0, $dB6ay.createContainer)($318c3ae525c263dd$var$EmojiStore, {
    onInit: ()=>(storeActionApi, { cloudId: cloudId, currentUser: currentUser })=>{
            storeActionApi.setState({
                provider: (0, $fmH48.getEmojiProviderWithCustomEmoji)(cloudId, currentUser) || undefined
            });
        }
});

});
parcelRegister("fmH48", function(module, exports) {
$parcel$export(module.exports, "getEmojiProvider", () => $636132c08723a66f$export$8210f5f78c0bcf27);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmoji", () => $636132c08723a66f$export$f9c5a1e85ff0cb72);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmojiUploadDisabled", () => $636132c08723a66f$export$7cda0fc535c2710f);
$parcel$export(module.exports, "fetchEmojiProvider", () => $636132c08723a66f$export$12c2b0bd175ad5c1);
/* eslint-disable jira/filename-case */ 
var $jYrce = parcelRequire("jYrce");

var $46jy7 = parcelRequire("46jy7");
const $636132c08723a66f$var$baseProviders = (serviceBaseUrl)=>[
        {
            url: `${serviceBaseUrl}/emoji/standard`
        },
        {
            url: `${serviceBaseUrl}/emoji/atlassian`
        }
    ];
const $636132c08723a66f$export$8210f5f78c0bcf27 = ()=>(0, $46jy7.getServiceProvider)((0, $46jy7.EMOJI_SERVICEID), (serviceBaseUrl)=>{
        const emojiResource = new (0, $jYrce.default)({
            providers: $636132c08723a66f$var$baseProviders(serviceBaseUrl)
        });
        return emojiResource.getEmojiProvider();
    });
const $636132c08723a66f$export$f9c5a1e85ff0cb72 = (cloudId, accountId, // fetchAtStart allows you to delay emoji fetching
// however, if it is used in an editor, remember to call `fetchEmojiProvider` on mount
// because typing `:` does not trigger emoji fetching
fetchAtStart = true)=>(0, $46jy7.getServiceProvider)((0, $46jy7.EMOJI_WITH_CUSTOM_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$636132c08723a66f$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $636132c08723a66f$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $jYrce.default)({
            providers: providers,
            allowUpload: true,
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider({
            fetchAtStart: fetchAtStart
        });
    });
const $636132c08723a66f$export$7cda0fc535c2710f = (cloudId, accountId, // fetchAtStart allows you to delay emoji fetching
// however, if it is used in an editor, remember to call `fetchEmojiProvider` on mount
// because typing `:` does not trigger emoji fetching
fetchAtStart = true)=>(0, $46jy7.getServiceProvider)((0, $46jy7.EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$636132c08723a66f$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $636132c08723a66f$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $jYrce.default)({
            providers: providers,
            allowUpload: false,
            // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider({
            fetchAtStart: fetchAtStart
        });
    });
const $636132c08723a66f$export$12c2b0bd175ad5c1 = async (emojiProviderPromise)=>{
    (await emojiProviderPromise)?.fetchEmojiProvider();
};

});
parcelRegister("jYrce", function(module, exports) {
$parcel$export(module.exports, "default", () => $33bb73cce9f548eb$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $4LDqh = parcelRequire("4LDqh");

var $iqfTZ = parcelRequire("iqfTZ");
parcelRequire("eGjD9");
var $gwfr5 = parcelRequire("gwfr5");
var $1x6rV = parcelRequire("1x6rV");

var $1uzV7 = parcelRequire("1uzV7");

var $3mucV = parcelRequire("3mucV");

var $gq0pG = parcelRequire("gq0pG");

var $3UnZm = parcelRequire("3UnZm");

var $d251u = parcelRequire("d251u");

var $5aCXJ = parcelRequire("5aCXJ");

var $7vSev = parcelRequire("7vSev");

var $SrGJC = parcelRequire("SrGJC");

var $krEHM = parcelRequire("krEHM");

var $5kzLc = parcelRequire("5kzLc");

var $gItxt = parcelRequire("gItxt");

var $fUSdm = parcelRequire("fUSdm");

var $gXn22 = parcelRequire("gXn22");

const $33bb73cce9f548eb$var$teamoji26RefreshEmojiPickerExperimentName = 'platform_teamoji_26_refresh_emoji_picker';
const $33bb73cce9f548eb$var$teamoji26QueryParam = 'useTeamoji26=true';
const $33bb73cce9f548eb$var$isTeamoji26RefreshEmojiPickerEnabled = ()=>{
    if (!(0, $4LDqh.default).initializeCompleted()) return false;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    return (0, $4LDqh.default).getExperimentValue($33bb73cce9f548eb$var$teamoji26RefreshEmojiPickerExperimentName, 'isEnabled', false);
};
const $33bb73cce9f548eb$var$addTeamoji26QueryParam = (url)=>{
    if (!url.includes('/atlassian') || /[?&]useTeamoji26=/.test(url)) return url;
    const hashIndex = url.indexOf('#');
    const urlWithoutHash = hashIndex === -1 ? url : url.slice(0, hashIndex);
    const hash = hashIndex === -1 ? '' : url.slice(hashIndex);
    const separator = urlWithoutHash.includes('?') ? '&' : '?';
    return `${urlWithoutHash}${separator}${$33bb73cce9f548eb$var$teamoji26QueryParam}${hash}`;
};
class $33bb73cce9f548eb$export$b5efafc6dd611ec5 extends (0, $gwfr5.AbstractResource) {
    constructor(config){
        super(), this.activeLoaders = 0, this.initialLoaders = 0, this.retries = new Map(), this.isInitialised = false, this.fetchOnDemand = false, this.getOptimisticImageURL = (emojiId)=>{
            if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
            return;
        }, this.isRepositoryAvailable = (repository)=>{
            return !!repository;
        }, this.isLoaded = ()=>this.initialLoaders !== 0 && this.activeLoaders === 0;
        const rewriteEmojiGatewayPath = (url)=>url.replace('/gateway/api/emoji', '/gateway/api/elements/emoji');
        const stargateEmojiPathEnabled = (0, $iqfTZ.fg)('use-elements-stargate-emoji-path');
        const teamoji26RefreshEmojiPickerEnabled = $33bb73cce9f548eb$var$isTeamoji26RefreshEmojiPickerEnabled();
        const singleEmojiApi = config.singleEmojiApi;
        const optimisticImageApi = config.optimisticImageApi;
        const providers = config.providers.map((provider)=>{
            const rewrittenUrl = stargateEmojiPathEnabled ? rewriteEmojiGatewayPath(provider.url) : provider.url;
            return {
                ...provider,
                url: teamoji26RefreshEmojiPickerEnabled ? $33bb73cce9f548eb$var$addTeamoji26QueryParam(rewrittenUrl) : rewrittenUrl
            };
        });
        this.emojiProviderConfig = {
            ...config,
            providers: providers,
            singleEmojiApi: stargateEmojiPathEnabled && singleEmojiApi ? {
                ...singleEmojiApi,
                getUrl: (emojiId)=>rewriteEmojiGatewayPath(singleEmojiApi.getUrl(emojiId))
            } : singleEmojiApi,
            optimisticImageApi: stargateEmojiPathEnabled && optimisticImageApi ? {
                ...optimisticImageApi,
                getUrl: (emojiId)=>rewriteEmojiGatewayPath(optimisticImageApi.getUrl(emojiId))
            } : optimisticImageApi
        };
        this.recordConfig = config.recordConfig;
        this.currentUser = config.currentUser;
        if ((0, $SrGJC.default)('localStorage')) this.selectedTone = this.loadStoredTone();
        if (config.providers.length === 0) throw new Error('No providers specified');
        this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
        this.initialLoaders = this.emojiProviderConfig.providers.length;
        this.activeLoaders = this.emojiProviderConfig.providers.length;
        this.emojiResponses = [];
    }
    /**
	 * Get the emoji provider from Emoji Resource
	 * @returns Promise<EmojiProvider>
	 */ async getEmojiProvider(options = {
        fetchAtStart: !this.fetchOnDemand
    }) {
        if (options.fetchAtStart) try {
            await this.fetchEmojiProvider();
        } catch (error) {
            (0, $7vSev.default)(error);
            return Promise.resolve(this);
        }
        return Promise.resolve(this);
    }
    async fetchIndividualProvider(provider, index) {
        const providerType = this.getProviderType(provider);
        try {
            (0, $3mucV.sampledUfoEmojiResourceFetched)(providerType).start({
                samplingRate: (0, $3UnZm.SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
            });
            (0, $3mucV.sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                type: providerType
            });
            const loader = new (0, $gItxt.default)(provider);
            // fetch emoji from provider url and denormalise
            const emojiResponse = await loader.loadEmoji();
            (0, $3mucV.sampledUfoEmojiResourceFetched)(providerType).success();
            // setup emoji repository
            this.emojiResponses[index] = emojiResponse;
            this.initEmojiRepository(this.emojiResponses);
            await this.initSiteEmojiResource(emojiResponse, provider);
            this.activeLoaders--;
            this.performRetries();
            this.refreshLastFilter();
        } catch (error) {
            this.activeLoaders--;
            this.notifyError(error);
            (0, $3mucV.sampledUfoEmojiResourceFetched)(providerType).failure({
                metadata: {
                    reason: error,
                    source: 'EmojiProvider',
                    providerUrl: provider.url
                }
            });
            (0, $7vSev.default)(`failed to fetch emoji provider for ${provider.url}`, error);
            throw new Error(`failed to fetch emoji from ${provider.url}`);
        }
    }
    async fetchEmojiProvider(force = false) {
        // unless (re-)fetch is being forced, fetching will only
        // happen if no emojiRepository exists
        // in case this method is called and emojiRepository has already been populated
        // the method will just return the existing emojiRepository
        if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
            this.isInitialised = true;
            this.emojiResponses = [];
            // fetch emoji providers
            await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
        }
        return Promise.resolve(this.emojiRepository);
    }
    onlyFetchOnDemand() {
        return this.fetchOnDemand;
    }
    async fetchByEmojiId(emojiId, optimistic) {
        // Check if repository exists and emoji is defined.
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
            const emoji = await this.findByEmojiId(emojiId);
            if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        // If optimistic is fetched
        if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
            // if config has singleEmojiApi then fetch single emoji
            const provider = {
                url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
            };
            const loader = new (0, $gItxt.default)(provider);
            try {
                const loadEmoji = await loader.loadEmoji();
                if (!loadEmoji.emojis[0]) return;
                if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
            } catch  {
                const emoji = await this.findByEmojiId(emojiId);
                if (!emoji) return;
                return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
        }
        const emoji = await this.findByEmojiId(emojiId);
        if (!emoji) return;
        return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
    }
    getProviderType(provider) {
        if (provider.url.includes('/site')) return (0, $1uzV7.ProviderTypes).SITE;
        else if (provider.url.includes('/standard')) return (0, $1uzV7.ProviderTypes).STANDARD;
        else if (provider.url.includes('/atlassian')) return (0, $1uzV7.ProviderTypes).ATLASSIAN;
        return (0, $1uzV7.ProviderTypes).UNKNOWN;
    }
    initEmojiRepository(emojiResponses) {
        let emojis = [];
        emojiResponses.forEach((emojiResponse)=>{
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new (0, $fUSdm.default)(emojis);
    }
    initSiteEmojiResource(emojiResponse, provider) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new (0, $gXn22.default)(provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            const { emojis: emojis } = emojiResponse;
            if (emojis.length) {
                const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if ((0, $5aCXJ.isPromise)(done)) return done.then(()=>{
                    (0, $7vSev.default)('Primed siteEmojiResource');
                }).catch(()=>{
                    (0, $7vSev.default)('Failed to prime siteEmojiResource');
                });
                else (0, $7vSev.default)('Already primed siteEmojiResource');
            } else (0, $7vSev.default)('No emoji to prime siteEmojiResource with');
        }
        return Promise.resolve();
    }
    performRetries() {
        const currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach((resolveReject, retry)=>{
            const result = retry();
            if ((0, $5aCXJ.isPromise)(result)) result.then((response)=>{
                resolveReject.resolve(response);
            }).catch((reason)=>{
                resolveReject.reject(reason);
            });
            else resolveReject.resolve(result);
        });
    }
    loadStoredTone() {
        if (typeof window === 'undefined') return undefined;
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const storedToneString = window.localStorage.getItem((0, $3UnZm.selectedToneStorageKey));
        if (storedToneString) {
            const storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    }
    refreshLastFilter() {
        if (typeof this.lastQuery !== 'undefined') {
            const { query: query, options: options } = this.lastQuery;
            this.filter(query, options);
        }
    }
    retryIfLoading(retry, defaultResponse) {
        if (!this.isLoaded()) return new Promise((resolve, reject)=>{
            this.retries.set(retry, {
                resolve: resolve,
                reject: reject
            });
        });
        return Promise.resolve(defaultResponse);
    }
    notifyResult(result) {
        if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
    }
    /**
	 *  Returns the EmojiDescription with a valid media path that includes query token and client attributes to access the emoji media inline.
	 */ async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) {
            const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
            return {
                ...emoji,
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
        return emoji;
    }
    loadMediaEmoji(emoji, useAlt) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, $d251u.isMediaEmoji)(emoji)) return emoji;
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    }
    optimisticMediaRendering(emoji, useAlt) {
        if (!(0, $d251u.isMediaEmoji)(emoji)) return true;
        if (!this.isRepositoryAvailable(this.siteEmojiResource)) // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
        return false;
        const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if ((0, $5aCXJ.isPromise)(optimistic)) // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
        return false;
        return optimistic;
    }
    filter(query, options) {
        (0, $gq0pG.ufoExperiences)['emoji-searched'].start();
        (0, $gq0pG.ufoExperiences)['emoji-searched'].addMetadata({
            queryLength: query?.length || 0
        });
        this.lastQuery = {
            query: query,
            options: options
        };
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            const searchResults = this.emojiRepository.search(query, options);
            this.notifyResult(searchResults);
            (0, $gq0pG.ufoExperiences)['emoji-searched'].success({
                metadata: {
                    emojisLength: searchResults.emojis.length,
                    source: options?.source || 'typeahead'
                }
            });
        } else // not ready
        this.notifyNotReady();
    }
    findByShortName(shortName) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) // Wait for all emoji to load before looking by shortName (to ensure correct priority)
        return this.emojiRepository.findByShortName(shortName);
        return this.retryIfLoading(()=>this.findByShortName(shortName), undefined);
    }
    findByEmojiId(emojiId) {
        const { id: id, shortName: shortName } = emojiId;
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            if (id) {
                const emoji = this.emojiRepository.findById(id);
                if (emoji) return emoji;
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                        if (!emoji) // if not, fallback to searching by shortName to
                        // at least render an alternative
                        return this.findByShortName(shortName);
                        this.addUnknownEmoji(emoji);
                        return emoji;
                    });
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName);
                }
            } else // no id fallback to shortName
            return this.findByShortName(shortName);
        }
        return this.retryIfLoading(()=>this.findByEmojiId(emojiId), undefined);
    }
    findById(id) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
        return this.retryIfLoading(()=>this.findById(id), undefined);
    }
    /**
	 * Synchronously reads the emoji type from the local cache for the given emojiId.
	 * Returns `undefined` when the emoji is not in the cache or no repository is initialised.
	 * This is a pure cache read — no network requests are made.
	 */ getCachedEmojiType(emojiId) {
        if (!this.isRepositoryAvailable(this.emojiRepository)) return undefined;
        const { id: id, shortName: shortName } = emojiId;
        if (id) {
            const emoji = this.emojiRepository.findById(id);
            if (emoji) return emoji.type;
        }
        if (shortName) {
            const result = this.emojiRepository.findByShortName(shortName);
            if (result && !('then' in result)) return result.type;
        }
        return undefined;
    }
    findInCategory(categoryId) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
    }
    getAsciiMap() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
        return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
    }
    getFrequentlyUsed(options) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
    }
    /**
	 * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
	 * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
	 * for the purposes of tracking the frequency of use.
	 *
	 * @param emoji The full description of the emoji to record usage for.
	 */ recordSelection(emoji) {
        const { recordConfig: recordConfig } = this;
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
        if (recordConfig) {
            const queryParams = {
                emojiId: (0, $5kzLc.toEmojiId)(emoji)
            };
            const requestInit = {
                method: 'POST'
            };
            return (0, $1x6rV.utils).requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit
            });
        }
        return Promise.resolve();
    }
    deleteSiteEmoji(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
            if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                this.emojiRepository.delete(emoji);
                return true;
            }
            return false;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('failed to delete site emoji', err);
            return false;
        });
        return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
    }
    getSelectedTone() {
        return this.selectedTone;
    }
    setSelectedTone(tone) {
        this.selectedTone = tone;
        if (typeof window === 'undefined') return;
        if ((0, $SrGJC.default)('localStorage')) try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.setItem((0, $3UnZm.selectedToneStorageKey), tone ? tone.toString() : '');
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('failed to store selected emoji skin tone', e);
        }
    }
    calculateDynamicCategories() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
    }
    getCurrentUser() {
        return this.currentUser;
    }
    addUnknownEmoji(emoji) {
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
    }
}
class $33bb73cce9f548eb$export$2e2bcd8739ae039 extends $33bb73cce9f548eb$export$b5efafc6dd611ec5 {
    constructor(config){
        super(config);
        this.allowUpload = !!config.allowUpload;
    }
    isUploadSupported() {
        if (!this.allowUpload) return Promise.resolve(false);
        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
        return this.retryIfLoading(()=>this.isUploadSupported(), false);
    }
    uploadCustomEmoji(upload, retry = false, timeout = 30000) {
        return this.isUploadSupported().then((supported)=>{
            if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
            const uploadPromise = this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                // Use file preview blob URL to temporarily fix the graybox issue after uploading,
                // Because the media service takes time to process the image.
                // Ideally should improve CachingMediaImage by using mediaClient or mediaImage,
                // But that requires more efforts in FE & BE.
                // TODO: revist this when pick up COLLAB-2294
                emoji.representation.imagePath = upload.dataURL;
                this.addUnknownEmoji(emoji);
                this.refreshLastFilter();
                return emoji;
            });
            return (0, $krEHM.promiseWithTimeout)(uploadPromise, timeout, 'uploadCustomEmoji timed out');
        });
    }
    prepareForUpload() {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
        return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
    }
}

});
parcelRegister("eGjD9", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("gwfr5")).AbstractResource);
$parcel$export(module.exports, "utils", () => (parcelRequire("1x6rV")).utils);
parcelRequire("2aL34");
parcelRequire("gwfr5");

var $1x6rV = parcelRequire("1x6rV");

});
parcelRegister("2aL34", function(module, exports) {
$parcel$export(module.exports, "buildCredentials", () => $a71ad56b01699935$export$2ac26f1ab7eda637);
const $a71ad56b01699935$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});

parcelRegister("gwfr5", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => $23e889acd14a74a7$export$4529f10aed0950d4);
class $23e889acd14a74a7$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("1x6rV", function(module, exports) {
$parcel$export(module.exports, "utils", () => $b618b9c94bea1f50$export$eab97d15b1788b8d);

var $9FjJF = parcelRequire("9FjJF");

var $4SXMK = parcelRequire("4SXMK");
const $b618b9c94bea1f50$export$eab97d15b1788b8d = $9FjJF;
const $b618b9c94bea1f50$export$3b4c04cf7dad0e50 = $4SXMK;

});
parcelRegister("9FjJF", function(module, exports) {
$parcel$export(module.exports, "extractTracingHeaders", () => $d9e79fba914e4bb9$export$4f34edf253146101);
$parcel$export(module.exports, "requestService", () => $d9e79fba914e4bb9$export$97bfde5a702aaeca);

var $anDmR = parcelRequire("anDmR");

var $2aL34 = parcelRequire("2aL34");

var $2G5fZ = parcelRequire("2G5fZ");
const $d9e79fba914e4bb9$var$TRACING_RESPONSE_HEADERS = [
    'x-trace-id',
    'atl-request-id'
];
const $d9e79fba914e4bb9$export$4f34edf253146101 = (response)=>{
    const headers = {};
    for (const name of $d9e79fba914e4bb9$var$TRACING_RESPONSE_HEADERS){
        const value = response.headers.get(name);
        if (value) headers[name] = value;
    }
    return headers;
};
const $d9e79fba914e4bb9$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $2G5fZ.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2G5fZ.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2G5fZ.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $2aL34.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    // Get tracing headers from UFO
    const tracingHeaders = (0, $anDmR.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (options?.reportTracingHeaders) {
            const tracingHeaders = $d9e79fba914e4bb9$export$4f34edf253146101(response);
            if (Object.keys(tracingHeaders).length > 0) options.reportTracingHeaders(tracingHeaders);
        }
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $d9e79fba914e4bb9$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});
parcelRegister("2G5fZ", function(module, exports) {
$parcel$export(module.exports, "defaultRequestServiceOptions", () => $7e4f256579822fbd$export$160dbda113bfad3b);
$parcel$export(module.exports, "buildUrl", () => $7e4f256579822fbd$export$b5cd97dee32de81d);
$parcel$export(module.exports, "buildHeaders", () => $7e4f256579822fbd$export$7d6ed858a91629c3);
const $7e4f256579822fbd$export$160dbda113bfad3b = {};
const $7e4f256579822fbd$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $7e4f256579822fbd$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $7e4f256579822fbd$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $7e4f256579822fbd$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $7e4f256579822fbd$var$addToHeaders(headers, secOptions.headers);
    return headers;
};

});


parcelRegister("4SXMK", function(module, exports) {
$parcel$export(module.exports, "requestServiceMultipart", () => $74066e2ac5296540$export$8b13532c81e8ac89);

var $gfbUA = parcelRequire("gfbUA");

var $2aL34 = parcelRequire("2aL34");

var $2G5fZ = parcelRequire("2G5fZ");

var $anDmR = parcelRequire("anDmR");
const $74066e2ac5296540$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $2G5fZ.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2G5fZ.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2G5fZ.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $2aL34.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const tracingHeaders = (0, $anDmR.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $gfbUA.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $74066e2ac5296540$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};

});
parcelRegister("gfbUA", function(module, exports) {
$parcel$export(module.exports, "meros", () => $bd37497c25371cc4$export$74e0a034be2368c7);
var $bd37497c25371cc4$var$e = new TextDecoder;
async function $bd37497c25371cc4$export$74e0a034be2368c7(t, n) {
    if (!t.ok || !t.body || t.bodyUsed) return t;
    let i = t.headers.get("content-type");
    if (!i || !~i.indexOf("multipart/")) return t;
    let l = i.indexOf("boundary="), r = "-";
    if (~l) {
        let e = l + 9, t = i.indexOf(";", e);
        r = i.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(t, n, i) {
        let l, r, d, o = t.getReader(), a = !i || !i.multiple, f = n.length, s = "", c = [];
        try {
            let t;
            e: for(; !(t = await o.read()).done;){
                let i = $bd37497c25371cc4$var$e.decode(t.value);
                l = s.length, s += i;
                let o = i.indexOf(n);
                for(~o ? l += o : l = s.indexOf(n), c = []; ~l;){
                    let e = s.slice(0, l), t = s.slice(l + f);
                    if (r) {
                        let n = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", n), l = !1, r = e.slice(n, i > -1 ? void 0 : i), o = String(e.slice(0, n)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; d = o[--s]; d = d.split(": "), f[d.shift().toLowerCase()] = d.join(": "));
                        if (d = f["content-type"], d && ~d.indexOf("application/json")) try {
                            r = JSON.parse(r), l = !0;
                        } catch (e) {}
                        if (d = {
                            headers: f,
                            body: r,
                            json: l
                        }, a ? yield d : c.push(d), "--" === t.slice(0, 2)) break e;
                    } else n = "\r\n" + n, r = f += 2;
                    s = t, l = s.indexOf(n);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(t.body, `--${r}`, n);
}

});




parcelRegister("1uzV7", function(module, exports) {
$parcel$export(module.exports, "SearchSort", () => $ef28d954a8fb5ad4$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $ef28d954a8fb5ad4$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $ef28d954a8fb5ad4$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $ef28d954a8fb5ad4$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $ef28d954a8fb5ad4$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $ef28d954a8fb5ad4$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $ef28d954a8fb5ad4$export$482549d945a3723);
var $ef28d954a8fb5ad4$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
var $ef28d954a8fb5ad4$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
var $ef28d954a8fb5ad4$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
var $ef28d954a8fb5ad4$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
var $ef28d954a8fb5ad4$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
var $ef28d954a8fb5ad4$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
var $ef28d954a8fb5ad4$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});

});

parcelRegister("3mucV", function(module, exports) {
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $d5573dbfefb75a6a$export$1466212a1606133);

var $gq0pG = parcelRequire("gq0pG");

var $7eMKD = parcelRequire("7eMKD");
const $d5573dbfefb75a6a$export$1466212a1606133 = (providerType)=>{
    return (0, $7eMKD.withSampling)((0, $gq0pG.ufoExperiences)['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("gq0pG", function(module, exports) {
$parcel$export(module.exports, "ufoExperiences", () => $f4329a88c3e9e062$export$615f888019c45765);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $5X4ZM = parcelRequire("5X4ZM");
var $3nsUD = parcelRequire("3nsUD");
var $1fOu9 = parcelRequire("1fOu9");

var $1uzV7 = parcelRequire("1uzV7");



const $f4329a88c3e9e062$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $3nsUD.ExperienceTypes).Load,
        performanceType: (0, $3nsUD.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $f4329a88c3e9e062$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $3nsUD.ExperienceTypes).Experience,
        performanceType: (0, $3nsUD.ExperiencePerformanceTypes).InlineResult
    };
};
const $f4329a88c3e9e062$var$customEmojiTimings = [
    {
        key: (0, $1uzV7.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $1uzV7.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $1uzV7.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $1uzV7.UfoEmojiTimings).METADATA_START,
        endMark: (0, $1uzV7.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $1uzV7.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $1uzV7.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $1uzV7.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $1uzV7.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $1uzV7.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $1uzV7.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $1uzV7.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $1uzV7.UfoEmojiTimings).ONLOAD_END
    }
];
const $f4329a88c3e9e062$export$615f888019c45765 = {
    'emoji-rendered': new (0, $5X4ZM.ConcurrentExperience)((0, $1uzV7.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $1uzV7.UfoComponentName).EMOJI
        },
        type: (0, $3nsUD.ExperienceTypes).Operation,
        performanceType: (0, $3nsUD.ExperiencePerformanceTypes).Custom,
        timings: $f4329a88c3e9e062$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $5X4ZM.ConcurrentExperience)((0, $1uzV7.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $f4329a88c3e9e062$var$createRenderExperience((0, $1uzV7.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $1fOu9.UFOExperience)((0, $1uzV7.UfoExperienceName).EMOJI_PICKER_OPENED, $f4329a88c3e9e062$var$createRenderExperience((0, $1uzV7.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $1fOu9.UFOExperience)((0, $1uzV7.UfoExperienceName).EMOJI_SELECTION_RECORDED, $f4329a88c3e9e062$var$createInlineExperience((0, $1uzV7.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $1fOu9.UFOExperience)((0, $1uzV7.UfoExperienceName).EMOJI_UPLOADED, $f4329a88c3e9e062$var$createInlineExperience((0, $1uzV7.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $1fOu9.UFOExperience)((0, $1uzV7.UfoExperienceName).EMOJI_SEARCHED, $f4329a88c3e9e062$var$createInlineExperience((0, $1uzV7.UfoComponentName).EMOJI_PICKER))
};

});

parcelRegister("7eMKD", function(module, exports) {
$parcel$export(module.exports, "withSampling", () => $59fc8f939133a0f9$export$dc2f0946255b3f89);

var $2frQB = parcelRequire("2frQB");

var $5ctQn = parcelRequire("5ctQn");
const $59fc8f939133a0f9$var$hasSampledFromStart = (experience)=>{
    if (!(0, $5ctQn.ufoExperiencesSampled)[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return (0, $5ctQn.ufoExperiencesSampled)[experience.id].sampledInstance[experience.instanceId];
    return (0, $5ctQn.ufoExperiencesSampled)[experience.id].sampled;
};
const $59fc8f939133a0f9$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!(0, $5ctQn.ufoExperiencesSampled)[ufoExperience.id]) (0, $5ctQn.ufoExperiencesSampled)[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($59fc8f939133a0f9$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || (0, $2frQB.isExperienceSampled);
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) (0, $5ctQn.ufoExperiencesSampled)[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            (0, $5ctQn.ufoExperiencesSampled)[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            (0, $5ctQn.ufoExperiencesSampled)[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            (0, $5ctQn.ufoExperiencesSampled)[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$59fc8f939133a0f9$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$59fc8f939133a0f9$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$59fc8f939133a0f9$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$59fc8f939133a0f9$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$59fc8f939133a0f9$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$59fc8f939133a0f9$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$59fc8f939133a0f9$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});
parcelRegister("2frQB", function(module, exports) {
$parcel$export(module.exports, "isExperienceSampled", () => $80a1984bf65f9152$export$1c967630b3ea2d58);
/**
 * A random sampling function
 * sampling algorithm is from @atlassian/jira-coinflip at https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/browse/src/packages/platform/app-framework/coinflip/src/index.tsx
 * E.g. isExperienceSampled(2) will pass 50% of the time
 * @param rate The chance that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ // default sampling function to determine which one to be sampled
const $80a1984bf65f9152$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};

});

parcelRegister("5ctQn", function(module, exports) {
$parcel$export(module.exports, "ufoExperiencesSampled", () => $ee02f5d56b0d2762$export$c7c4959fece2f3ec);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 


const $ee02f5d56b0d2762$export$c7c4959fece2f3ec = {};

});



parcelRegister("3UnZm", function(module, exports) {
$parcel$export(module.exports, "customCategory", () => $1e173c1ac5579433$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $1e173c1ac5579433$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $1e173c1ac5579433$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $1e173c1ac5579433$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $1e173c1ac5579433$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $1e173c1ac5579433$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $1e173c1ac5579433$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $1e173c1ac5579433$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $1e173c1ac5579433$export$1a817f1886276c6d);
$parcel$export(module.exports, "scaledEmojiHeightH1", () => $1e173c1ac5579433$export$2e7088017339c92);
$parcel$export(module.exports, "scaledEmojiHeightH2", () => $1e173c1ac5579433$export$4cb591b57c224c0);
$parcel$export(module.exports, "scaledEmojiHeightH3", () => $1e173c1ac5579433$export$b31a41e904161dc1);
$parcel$export(module.exports, "scaledEmojiHeightH4", () => $1e173c1ac5579433$export$7dd039b460c61389);
$parcel$export(module.exports, "denseEmojiHeightH1", () => $1e173c1ac5579433$export$96ee6614460413a0);
$parcel$export(module.exports, "denseEmojiHeightH2", () => $1e173c1ac5579433$export$103771a4cd74af90);
$parcel$export(module.exports, "denseEmojiHeightH3", () => $1e173c1ac5579433$export$5cc2afcf38309ce9);
$parcel$export(module.exports, "denseEmojiHeightH4", () => $1e173c1ac5579433$export$9a9984214a4bd724);
$parcel$export(module.exports, "defaultEmojiHeight", () => $1e173c1ac5579433$export$3f99ac31dc0406db);
$parcel$export(module.exports, "defaultDenseEmojiHeight", () => $1e173c1ac5579433$export$8efb414216030943);
$parcel$export(module.exports, "defaultInlineEmojiHeight", () => $1e173c1ac5579433$export$4adebc94e462aea5);
$parcel$export(module.exports, "emojiPickerWidth", () => $1e173c1ac5579433$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $1e173c1ac5579433$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $1e173c1ac5579433$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerListHeight", () => $1e173c1ac5579433$export$7722b8e9522021df);
$parcel$export(module.exports, "emojiPickerListHeightNew", () => $1e173c1ac5579433$export$9f36457335d8859f);
$parcel$export(module.exports, "emojiPickerPreviewHeight", () => $1e173c1ac5579433$export$e218e5cb105a0e22);
$parcel$export(module.exports, "localStoragePrefix", () => $1e173c1ac5579433$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $1e173c1ac5579433$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "selectedProductivityColorStorageKey", () => $1e173c1ac5579433$export$ec5e3f6f684720d7);
$parcel$export(module.exports, "defaultCategories", () => $1e173c1ac5579433$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $1e173c1ac5579433$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $1e173c1ac5579433$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $1e173c1ac5579433$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $1e173c1ac5579433$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $1e173c1ac5579433$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $1e173c1ac5579433$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $1e173c1ac5579433$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $1e173c1ac5579433$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $1e173c1ac5579433$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $1e173c1ac5579433$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $1e173c1ac5579433$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $1e173c1ac5579433$export$66cabad5e268b05e);
const $1e173c1ac5579433$export$5e4e3d1c3e43156a = 'CUSTOM';
const $1e173c1ac5579433$export$78ccdc4be403c468 = 'FREQUENT';
const $1e173c1ac5579433$export$2c4b04c3aacdf1b3 = 'SITE';
const $1e173c1ac5579433$export$1b0258512be88334 = 'SEARCH';
const $1e173c1ac5579433$export$42b510423367f354 = 'USER_CUSTOM';
const $1e173c1ac5579433$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $1e173c1ac5579433$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $1e173c1ac5579433$export$8ac325bfd32359b0 = 'data:';
const $1e173c1ac5579433$export$a330961542edfe6f = 'delete-emoji';
const $1e173c1ac5579433$export$1a817f1886276c6d = 100000;
const $1e173c1ac5579433$export$2e7088017339c92 = 28;
const $1e173c1ac5579433$export$4cb591b57c224c0 = 26;
const $1e173c1ac5579433$export$b31a41e904161dc1 = 24;
const $1e173c1ac5579433$export$7dd039b460c61389 = 22;
const $1e173c1ac5579433$export$96ee6614460413a0 = 24.25;
const $1e173c1ac5579433$export$103771a4cd74af90 = 22.25;
const $1e173c1ac5579433$export$5cc2afcf38309ce9 = 20.25;
const $1e173c1ac5579433$export$9a9984214a4bd724 = 18.25;
const $1e173c1ac5579433$export$3f99ac31dc0406db = 20;
const $1e173c1ac5579433$export$8efb414216030943 = 16.25;
const $1e173c1ac5579433$export$4adebc94e462aea5 = 16;
const $1e173c1ac5579433$export$d171dc12fee2b1da = 350;
const $1e173c1ac5579433$export$c10ac8125a260041 = 80;
const $1e173c1ac5579433$export$5248fb9e0cccc41f = 'medium';
const $1e173c1ac5579433$export$94f75d625e7801d3 = 260;
const $1e173c1ac5579433$export$7ed599d166d65aea = 295;
const $1e173c1ac5579433$export$7722b8e9522021df = $1e173c1ac5579433$export$7ed599d166d65aea - 58; // picker height - actions height
const $1e173c1ac5579433$export$9f36457335d8859f = $1e173c1ac5579433$export$7ed599d166d65aea - 102; // picker height - actions height - preview height
const $1e173c1ac5579433$export$e218e5cb105a0e22 = 54;
const $1e173c1ac5579433$export$e67f617938b111f1 = $1e173c1ac5579433$export$7ed599d166d65aea + $1e173c1ac5579433$export$e218e5cb105a0e22;
const $1e173c1ac5579433$export$e394a0c530ae5631 = 'fabric.emoji';
const $1e173c1ac5579433$export$79ee4ef84c545f8f = `${$1e173c1ac5579433$export$e394a0c530ae5631}.selectedTone`;
const $1e173c1ac5579433$export$ec5e3f6f684720d7 = `${$1e173c1ac5579433$export$e394a0c530ae5631}.selectedProductivityColor`;
const $1e173c1ac5579433$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $1e173c1ac5579433$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $1e173c1ac5579433$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $1e173c1ac5579433$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $1e173c1ac5579433$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $1e173c1ac5579433$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $1e173c1ac5579433$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $1e173c1ac5579433$export$4f0ee90b28d6efc5 = 0;
const $1e173c1ac5579433$export$9f7de4293d27f3aa = 50;
const $1e173c1ac5579433$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $1e173c1ac5579433$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $1e173c1ac5579433$export$2829f3ec323f8ec0 = 8;
const $1e173c1ac5579433$export$ce3a0e7d2d7d6ba2 = 5;
const $1e173c1ac5579433$export$858e8dc100a97278 = 150;
const $1e173c1ac5579433$export$83aab2ae64548423 = 20;
const $1e173c1ac5579433$export$66cabad5e268b05e = 100;

});

parcelRegister("d251u", function(module, exports) {
$parcel$export(module.exports, "isMediaEmoji", () => $90c95f2c19afd3c4$export$a7e82c67204c73a1);

var $lzAfn = parcelRequire("lzAfn");
const $90c95f2c19afd3c4$export$a7e82c67204c73a1 = (emoji)=>(0, $lzAfn.isMediaRepresentation)(emoji.representation);

});
parcelRegister("lzAfn", function(module, exports) {
$parcel$export(module.exports, "isMediaRepresentation", () => $26e599d447454a00$export$979133dc1df141c6);
const $26e599d447454a00$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);

});


parcelRegister("5aCXJ", function(module, exports) {
$parcel$export(module.exports, "isPromise", () => $5889ab7b3c4dfa17$export$4369c812aac99591);
const $5889ab7b3c4dfa17$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("7vSev", function(module, exports) {
$parcel$export(module.exports, "default", () => $19ba639fbec73348$export$2e2bcd8739ae039);
let $19ba639fbec73348$var$debugEnabled = false;
let $19ba639fbec73348$var$stacktracesEnabled = false;
function $19ba639fbec73348$export$748ada60eaf985cc(enable) {
    $19ba639fbec73348$var$debugEnabled = enable;
}
function $19ba639fbec73348$export$4f7017086af31c25(enable) {
    $19ba639fbec73348$var$stacktracesEnabled = enable;
}
function $19ba639fbec73348$export$2a858f450a2f66d() {
    if ($19ba639fbec73348$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $19ba639fbec73348$export$2e2bcd8739ae039(msg, ...args) {
    if ($19ba639fbec73348$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("SrGJC", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b9ed9f02587c0b4$export$2e2bcd8739ae039);
function $7b9ed9f02587c0b4$export$2e2bcd8739ae039(type) {
    if (typeof window === 'undefined') return false;
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}

});

parcelRegister("krEHM", function(module, exports) {
$parcel$export(module.exports, "promiseWithTimeout", () => $5758bfd79a4bdc68$export$a9cd205a244d9f54);
function $5758bfd79a4bdc68$export$a9cd205a244d9f54(promise, timeout, errorMessage = 'Timed out') {
    // Create a promise that rejects after the specified timeout
    const timeoutPromise = new Promise((_, reject)=>setTimeout(()=>reject(new Error(errorMessage)), timeout));
    // Use Promise.race to race the provided promise against the timeout promise
    return Promise.race([
        promise,
        timeoutPromise
    ]);
}

});

parcelRegister("5kzLc", function(module, exports) {
$parcel$export(module.exports, "toEmojiId", () => $d75ffee37a903c3a$export$8d7d3de6b5b305d1);
const $d75ffee37a903c3a$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });

});

parcelRegister("gItxt", function(module, exports) {
$parcel$export(module.exports, "default", () => $f89baadbb666f34e$export$2e2bcd8739ae039);

var $2gBFJ = parcelRequire("2gBFJ");

var $fcawt = parcelRequire("fcawt");

var $2x7IR = parcelRequire("2x7IR");
/**
 * Shared cache of in-flight/resolved emoji load promises, keyed by the request URL so that
 * multiple loaders created for the same provider config reuse a single request instead of
 * refetching.
 */ const $f89baadbb666f34e$var$emojiPromiseCache = new Map();
class $f89baadbb666f34e$export$2e2bcd8739ae039 {
    constructor(config){
        this.config = config;
    }
    /**
	 * Returns a promise with an array of Emoji from all providers.
	 */ loadEmoji() {
        // The cache is module-level and outlives individual loaders, so under test it would leak
        // responses between cases sharing a provider url. Always refetch there instead.
        if ((0, $2gBFJ.isTestEnvironment)()) return this.fetchEmoji();
        const cacheKey = this.config.url;
        const cachedPromise = $f89baadbb666f34e$var$emojiPromiseCache.get(cacheKey);
        if (cachedPromise) return cachedPromise;
        const emojiPromise = this.fetchEmoji();
        // Evict on failure so a rejected promise is not cached, allowing retries to refetch.
        emojiPromise.catch(()=>{
            if ($f89baadbb666f34e$var$emojiPromiseCache.get(cacheKey) === emojiPromise) $f89baadbb666f34e$var$emojiPromiseCache.delete(cacheKey);
        });
        $f89baadbb666f34e$var$emojiPromiseCache.set(cacheKey, emojiPromise);
        return emojiPromise;
    }
    fetchEmoji() {
        return (0, $2x7IR.emojiRequest)(this.config).then((emojiServiceResponse)=>(0, $fcawt.denormaliseEmojiServiceResponse)(emojiServiceResponse));
    }
}

});
parcelRegister("2gBFJ", function(module, exports) {
$parcel$export(module.exports, "isTestEnvironment", () => $49fc82fe774512db$export$43ea16ac36fe59f1);
/**
 * Detects Jest unit tests and automated browsers (Playwright and other WebDriver-based drivers).
 *
 * Used to opt out of module-level caching that outlives individual instances. Such a cache leaks
 * state between test cases that share an input, which makes tests order-dependent and forces every
 * consumer to reset shared internals from their own suites.
 */ 
var $gIMgJ = parcelRequire("gIMgJ");
function $49fc82fe774512db$export$43ea16ac36fe59f1() {
    try {
        return Boolean(typeof $gIMgJ !== 'undefined' && // NODE_ENV can be overridden by consumers, so also check for a Jest worker
        ($gIMgJ?.env?.NODE_ENV === 'test' || $gIMgJ?.env?.JEST_WORKER_ID !== undefined) || // Playwright serves examples with NODE_ENV=development, but sets navigator.webdriver
        typeof navigator !== 'undefined' && navigator.webdriver);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});

parcelRegister("fcawt", function(module, exports) {
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $caa531f1db99f314$export$afaea97e40b5ca70);

var $dFmib = parcelRequire("dFmib");

var $4U7Pt = parcelRequire("4U7Pt");

var $4TLOZ = parcelRequire("4TLOZ");

var $8ZOkA = parcelRequire("8ZOkA");
const $caa531f1db99f314$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = (0, $8ZOkA.denormaliseStandardRepresentation)(emoji, emojiData.meta);
        const altRepresentation = (0, $4U7Pt.denormaliseServiceAltRepresentation)(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = (0, $4TLOZ.denormaliseSkinEmoji)(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: _representation, skinVariations: _skinVariations, altRepresentations: _altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $dFmib.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};

});
parcelRegister("dFmib", function(module, exports) {
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $2705c6a682e9d9d8$export$a48c58c688a3131);
const $2705c6a682e9d9d8$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};

});

parcelRegister("4U7Pt", function(module, exports) {
$parcel$export(module.exports, "denormaliseServiceAltRepresentation", () => $dc6cab36dac0de45$export$aa9faa01267cb2e7);

var $eBxyh = parcelRequire("eBxyh");

var $8OPkL = parcelRequire("8OPkL");
const $dc6cab36dac0de45$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : (0, $eBxyh.denormaliseServiceRepresentation)((0, $8OPkL.getAltRepresentation)(altReps), meta);
};

});
parcelRegister("eBxyh", function(module, exports) {
$parcel$export(module.exports, "denormaliseServiceRepresentation", () => $1cc702a023ff9e3b$export$55077db3efc820aa);

var $fSEjD = parcelRequire("fSEjD");

var $ktoNx = parcelRequire("ktoNx");

var $eBzSV = parcelRequire("eBzSV");

var $7vSev = parcelRequire("7vSev");

var $fMq3G = parcelRequire("fMq3G");
const $1cc702a023ff9e3b$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $eBzSV.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $ktoNx.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ((0, $fMq3G.isMediaApiUrl)(imagePath, meta)) return (0, $fSEjD.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $7vSev.default)('failed conversion for representation', representation, meta);
    return undefined;
};

});
parcelRegister("fSEjD", function(module, exports) {
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $a211a9ec01ce0977$export$20a1bd1d33069ce7);
const $a211a9ec01ce0977$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });

});

parcelRegister("ktoNx", function(module, exports) {
$parcel$export(module.exports, "isImageRepresentation", () => $d535375092fe733f$export$90b099a26fbd8b41);
const $d535375092fe733f$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);

});

parcelRegister("eBzSV", function(module, exports) {
$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $21f61b4a16ef6fe7$export$1c52f72b88b558e8);
const $21f61b4a16ef6fe7$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);

});

parcelRegister("fMq3G", function(module, exports) {
$parcel$export(module.exports, "isMediaApiUrl", () => $ed8f1f39bf025235$export$db05e6ae1fd416af);
const $ed8f1f39bf025235$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);

});


parcelRegister("8OPkL", function(module, exports) {
$parcel$export(module.exports, "getAltRepresentation", () => $68fb05d44f0b02a9$export$4a0301d636367e1d);

var $kkh1l = parcelRequire("kkh1l");

var $lFGDz = parcelRequire("lFGDz");
const $68fb05d44f0b02a9$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[(0, $kkh1l.calculateScale)((0, $lFGDz.getPixelRatio)).altScale];
};

});
parcelRegister("kkh1l", function(module, exports) {
$parcel$export(module.exports, "calculateScale", () => $be6b30d3606977fe$export$1d78826433168f34);

var $1PA5z = parcelRequire("1PA5z");
const $be6b30d3606977fe$export$1d78826433168f34 = (getRatio)=>{
    if ((0, $1PA5z.expValEquals)('platform_editor_emoji_default_scale', 'isEnabled', true)) {
        // retina display
        if (getRatio() > 1) return {
            scale: 'XXXHDPI',
            altScale: 'XXXHDPI'
        };
        // default set used for desktop
        return {
            altScale: 'XXXHDPI'
        };
    }
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};

});
parcelRegister("1PA5z", function(module, exports) {
$parcel$export(module.exports, "expValEquals", () => $65dd51cb353305d2$export$45abdb3f977b5b14);

var $3mK4j = parcelRequire("3mK4j");
function $65dd51cb353305d2$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $3mK4j.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("3mK4j", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $64bfc6a5e4c43e5f$export$58e581060588c6bb);

var $4LDqh = parcelRequire("4LDqh");

var $hbvZL = parcelRequire("hbvZL");

var $bzstt = parcelRequire("bzstt");

var $djzuo = parcelRequire("djzuo");
// This internal representation doesn't currently support productKeys
// the way expVal(...) does, this adds temporary support for some keys while
// we determine our preferred approach forward
const $64bfc6a5e4c43e5f$var$allowsProductKeys = [
    'cc-maui-experiment',
    'cc_maui_create_keyword',
    'cc_maui_create_keyword_aa',
    'platform_use_unicode_emojis'
];
function $64bfc6a5e4c43e5f$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    if ((0, $djzuo._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $djzuo._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $4LDqh.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // Typescript is complaining here about accessing the productKeys property
    const experimentKeyName = $64bfc6a5e4c43e5f$var$allowsProductKeys.includes(experimentName) ? (0, $bzstt.editorExperimentsConfig)[experimentName]?.productKeys?.[0, $djzuo._product] ?? experimentName : experimentName;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $4LDqh.default).getExperimentValue(experimentKeyName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $4LDqh.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $hbvZL.addFeatureFlagAccessed)(`${experimentKeyName}:${experimentParam}`, experimentValue);
    return experimentValue === experimentExpectedValue;
}

});



parcelRegister("lFGDz", function(module, exports) {
$parcel$export(module.exports, "getPixelRatio", () => $309ccdab50069b77$export$d39ce20a37bba061);
const $309ccdab50069b77$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};

});



parcelRegister("4TLOZ", function(module, exports) {
$parcel$export(module.exports, "denormaliseSkinEmoji", () => $da7e56b7d1cd8b33$export$e3da49c88c2e54d5);

var $4U7Pt = parcelRequire("4U7Pt");

var $8ZOkA = parcelRequire("8ZOkA");
const $da7e56b7d1cd8b33$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: _representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: (0, $8ZOkA.denormaliseStandardRepresentation)(skin, meta),
            altRepresentation: (0, $4U7Pt.denormaliseServiceAltRepresentation)(altRepresentations, meta),
            ...other
        };
    });
};

});
parcelRegister("8ZOkA", function(module, exports) {
$parcel$export(module.exports, "denormaliseStandardRepresentation", () => $93a1b52433f7a750$export$1878ebc2c7851724);

var $cn5fq = parcelRequire("cn5fq");

var $1uzV7 = parcelRequire("1uzV7");

var $hD6uR = parcelRequire("hD6uR");

var $eBxyh = parcelRequire("eBxyh");
const $93a1b52433f7a750$export$1878ebc2c7851724 = (emoji, meta)=>{
    const unicodeEmoji = (0, $hD6uR.emojiIdToEmoji)(emoji.id);
    const useUnicodeRepresentation = !!(emoji.id && emoji.type === (0, $1uzV7.ProviderTypes).STANDARD && unicodeEmoji && (0, $cn5fq.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true));
    return useUnicodeRepresentation ? {
        unicodeEmoji: unicodeEmoji
    } : (0, $eBxyh.denormaliseServiceRepresentation)(emoji.representation, meta);
};

});
parcelRegister("cn5fq", function(module, exports) {
$parcel$export(module.exports, "expValEqualsNoExposure", () => $3d04ec5c231c88f6$export$63eebf86443a0a61);

var $3mK4j = parcelRequire("3mK4j");
function $3d04ec5c231c88f6$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $3mK4j.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}

});

parcelRegister("hD6uR", function(module, exports) {
$parcel$export(module.exports, "emojiIdToEmoji", () => $89f267d42834df85$export$ad632d8144af7c7b);

var $cn5fq = parcelRequire("cn5fq");
const $89f267d42834df85$var$KEYCAP_COMBINING = 0x20e3;
const $89f267d42834df85$var$VARIATION_SELECTOR_16 = 0xfe0f;
const $89f267d42834df85$var$VARIATION_SELECTOR_15 = 0xfe0e;
const $89f267d42834df85$var$EMOJI_MODIFIER_START = 0x1f3fb;
const $89f267d42834df85$var$EMOJI_MODIFIER_END = 0x1f3ff;
const $89f267d42834df85$var$REGIONAL_INDICATOR_START = 0x1f1e6;
const $89f267d42834df85$var$REGIONAL_INDICATOR_END = 0x1f1ff;
const $89f267d42834df85$var$FLAG_BASES = new Set([
    0x1f38c,
    0x1f3c1,
    0x1f3f3,
    0x1f3f4,
    0x1f6a9
]);
// Emoji variation bases from Unicode 14.0 emoji-variation-sequences.txt.
// These are the code points with a defined U+FE0F emoji-style variant.
const $89f267d42834df85$var$EMOJI_VARIATION_BASES = new Set([
    0x0023,
    0x002a,
    0x0030,
    0x0031,
    0x0032,
    0x0033,
    0x0034,
    0x0035,
    0x0036,
    0x0037,
    0x0038,
    0x0039,
    0x00a9,
    0x00ae,
    0x203c,
    0x2049,
    0x2122,
    0x2139,
    0x2194,
    0x2195,
    0x2196,
    0x2197,
    0x2198,
    0x2199,
    0x21a9,
    0x21aa,
    0x2328,
    0x23cf,
    0x23ed,
    0x23ee,
    0x23ef,
    0x23f1,
    0x23f2,
    0x23f8,
    0x23f9,
    0x23fa,
    0x24c2,
    0x25aa,
    0x25ab,
    0x25b6,
    0x25c0,
    0x25fb,
    0x25fc,
    0x2600,
    0x2601,
    0x2602,
    0x2603,
    0x2604,
    0x260e,
    0x2611,
    0x2618,
    0x261d,
    0x2620,
    0x2622,
    0x2623,
    0x2626,
    0x262a,
    0x262e,
    0x262f,
    0x2638,
    0x2639,
    0x263a,
    0x2640,
    0x2642,
    0x265f,
    0x2660,
    0x2663,
    0x2665,
    0x2666,
    0x2668,
    0x267b,
    0x267e,
    0x2692,
    0x2694,
    0x2695,
    0x2696,
    0x2697,
    0x2699,
    0x269b,
    0x269c,
    0x26a0,
    0x26a7,
    0x26b0,
    0x26b1,
    0x26c8,
    0x26cf,
    0x26d1,
    0x26d3,
    0x26e9,
    0x26f0,
    0x26f1,
    0x26f4,
    0x26f7,
    0x26f8,
    0x26f9,
    0x2702,
    0x2708,
    0x2709,
    0x270c,
    0x270d,
    0x270f,
    0x2712,
    0x2714,
    0x2716,
    0x271d,
    0x2721,
    0x2733,
    0x2734,
    0x2744,
    0x2747,
    0x2763,
    0x2764,
    0x27a1,
    0x2934,
    0x2935,
    0x2b05,
    0x2b06,
    0x2b07,
    0x3030,
    0x303d,
    0x3297,
    0x3299,
    0x1f170,
    0x1f171,
    0x1f17e,
    0x1f17f,
    0x1f202,
    0x1f237,
    0x1f321,
    0x1f324,
    0x1f325,
    0x1f326,
    0x1f327,
    0x1f328,
    0x1f329,
    0x1f32a,
    0x1f32b,
    0x1f32c,
    0x1f336,
    0x1f37d,
    0x1f396,
    0x1f397,
    0x1f399,
    0x1f39a,
    0x1f39b,
    0x1f39e,
    0x1f39f,
    0x1f3cb,
    0x1f3cc,
    0x1f3cd,
    0x1f3ce,
    0x1f3d4,
    0x1f3d5,
    0x1f3d6,
    0x1f3d7,
    0x1f3d8,
    0x1f3d9,
    0x1f3da,
    0x1f3db,
    0x1f3dc,
    0x1f3dd,
    0x1f3de,
    0x1f3df,
    0x1f3f3,
    0x1f3f5,
    0x1f3f7,
    0x1f43f,
    0x1f441,
    0x1f4fd,
    0x1f549,
    0x1f54a,
    0x1f56f,
    0x1f570,
    0x1f573,
    0x1f574,
    0x1f575,
    0x1f576,
    0x1f577,
    0x1f578,
    0x1f579,
    0x1f587,
    0x1f58a,
    0x1f58b,
    0x1f58c,
    0x1f58d,
    0x1f590,
    0x1f5a5,
    0x1f5a8,
    0x1f5b1,
    0x1f5b2,
    0x1f5bc,
    0x1f5c2,
    0x1f5c3,
    0x1f5c4,
    0x1f5d1,
    0x1f5d2,
    0x1f5d3,
    0x1f5dc,
    0x1f5dd,
    0x1f5de,
    0x1f5e1,
    0x1f5e3,
    0x1f5e8,
    0x1f5ef,
    0x1f5f3,
    0x1f5fa,
    0x1f6cb,
    0x1f6cd,
    0x1f6ce,
    0x1f6cf,
    0x1f6e0,
    0x1f6e1,
    0x1f6e2,
    0x1f6e3,
    0x1f6e4,
    0x1f6e5,
    0x1f6e9,
    0x1f6f0,
    0x1f6f3,
    0x231a,
    0x231b,
    0x23e9,
    0x23ea,
    0x23f3,
    0x25fd,
    0x25fe,
    0x2614,
    0x2615,
    0x2648,
    0x2649,
    0x264a,
    0x264b,
    0x264c,
    0x264d,
    0x264e,
    0x264f,
    0x2650,
    0x2651,
    0x2652,
    0x2653,
    0x267f,
    0x2693,
    0x26a1,
    0x26aa,
    0x26ab,
    0x26bd,
    0x26be,
    0x26c4,
    0x26c5,
    0x26d4,
    0x26ea,
    0x26f2,
    0x26f3,
    0x26f5,
    0x26fa,
    0x26fd,
    0x2753,
    0x2757,
    0x2b1b,
    0x2b1c,
    0x2b50,
    0x2b55,
    0x1f004,
    0x1f21a,
    0x1f22f,
    0x1f30d,
    0x1f30e,
    0x1f30f,
    0x1f315,
    0x1f31c,
    0x1f378,
    0x1f393,
    0x1f3a7,
    0x1f3ac,
    0x1f3ad,
    0x1f3ae,
    0x1f3c2,
    0x1f3c4,
    0x1f3c6,
    0x1f3ca,
    0x1f3e0,
    0x1f3ed,
    0x1f408,
    0x1f415,
    0x1f41f,
    0x1f426,
    0x1f442,
    0x1f446,
    0x1f447,
    0x1f448,
    0x1f449,
    0x1f44d,
    0x1f44e,
    0x1f453,
    0x1f46a,
    0x1f47d,
    0x1f4a3,
    0x1f4b0,
    0x1f4b3,
    0x1f4bb,
    0x1f4bf,
    0x1f4cb,
    0x1f4da,
    0x1f4df,
    0x1f4e4,
    0x1f4e5,
    0x1f4e6,
    0x1f4ea,
    0x1f4eb,
    0x1f4ec,
    0x1f4ed,
    0x1f4f7,
    0x1f4f9,
    0x1f4fa,
    0x1f4fb,
    0x1f508,
    0x1f50d,
    0x1f512,
    0x1f513,
    0x1f550,
    0x1f551,
    0x1f552,
    0x1f553,
    0x1f554,
    0x1f555,
    0x1f556,
    0x1f557,
    0x1f558,
    0x1f559,
    0x1f55a,
    0x1f55b,
    0x1f55c,
    0x1f55d,
    0x1f55e,
    0x1f55f,
    0x1f560,
    0x1f561,
    0x1f562,
    0x1f563,
    0x1f564,
    0x1f565,
    0x1f566,
    0x1f567,
    0x1f610,
    0x1f687,
    0x1f68d,
    0x1f691,
    0x1f694,
    0x1f698,
    0x1f6ad,
    0x1f6b2,
    0x1f6b9,
    0x1f6ba,
    0x1f6bc
]);
const $89f267d42834df85$var$isEmojiModifier = (codePoint)=>typeof codePoint === 'number' && codePoint >= $89f267d42834df85$var$EMOJI_MODIFIER_START && codePoint <= $89f267d42834df85$var$EMOJI_MODIFIER_END;
const $89f267d42834df85$var$shouldAddEmojiPresentationSelector = (codePoint, nextCodePoint)=>$89f267d42834df85$var$EMOJI_VARIATION_BASES.has(codePoint) && nextCodePoint !== $89f267d42834df85$var$VARIATION_SELECTOR_16 && nextCodePoint !== $89f267d42834df85$var$VARIATION_SELECTOR_15 && nextCodePoint !== $89f267d42834df85$var$KEYCAP_COMBINING && !$89f267d42834df85$var$isEmojiModifier(nextCodePoint);
const $89f267d42834df85$var$isRegionalIndicator = (codePoint)=>codePoint >= $89f267d42834df85$var$REGIONAL_INDICATOR_START && codePoint <= $89f267d42834df85$var$REGIONAL_INDICATOR_END;
const $89f267d42834df85$var$isStandaloneRegionalIndicator = (codePoints)=>codePoints.length === 1 && $89f267d42834df85$var$isRegionalIndicator(codePoints[0]);
const $89f267d42834df85$var$parseEmojiIdCodePoints = (id)=>{
    const segments = id.split('-');
    const codePoints = [];
    for (const segment of segments){
        if (!/^[0-9a-fA-F]+$/.test(segment)) return undefined;
        const cp = parseInt(segment, 16);
        // Valid Unicode scalar values: U+0000–U+10FFFF, excluding surrogates.
        if (isNaN(cp) || cp < 0 || cp > 0x10ffff || cp >= 0xd800 && cp <= 0xdfff) return undefined;
        codePoints.push(cp);
    }
    return codePoints.length ? codePoints : undefined;
};
const $89f267d42834df85$var$isFlagEmoji = (codePoints)=>{
    if (codePoints.length === 2 && codePoints.every($89f267d42834df85$var$isRegionalIndicator)) return true;
    return $89f267d42834df85$var$FLAG_BASES.has(codePoints[0]);
};
function $89f267d42834df85$export$ad632d8144af7c7b(id) {
    if (!(0, $cn5fq.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) return undefined;
    if (!id) return undefined;
    const codePoints = $89f267d42834df85$var$parseEmojiIdCodePoints(id);
    if (!codePoints) return undefined;
    if ($89f267d42834df85$var$isStandaloneRegionalIndicator(codePoints) || $89f267d42834df85$var$isFlagEmoji(codePoints)) return undefined;
    const processedCodePoints = [];
    for(let i = 0; i < codePoints.length; i++){
        const cp = codePoints[i];
        const next = codePoints[i + 1];
        processedCodePoints.push(cp);
        // Insert U+FE0F before U+20E3 if not already present.
        // Keycap sequences: digit/# /* followed by U+20E3 need U+FE0F between them.
        if (next === $89f267d42834df85$var$KEYCAP_COMBINING && cp !== $89f267d42834df85$var$VARIATION_SELECTOR_16) processedCodePoints.push($89f267d42834df85$var$VARIATION_SELECTOR_16);
        // Emoji variation bases need U+FE0F immediately after the base code point,
        // including when the base appears inside a ZWJ sequence.
        if ($89f267d42834df85$var$shouldAddEmojiPresentationSelector(cp, next)) processedCodePoints.push($89f267d42834df85$var$VARIATION_SELECTOR_16);
    }
    try {
        return String.fromCodePoint(...processedCodePoints);
    } catch  {
        return undefined;
    }
}

});




parcelRegister("2x7IR", function(module, exports) {
$parcel$export(module.exports, "emojiRequest", () => $f6d1ea802d6a6e06$export$ea1accde4cc117f4);
parcelRequire("eGjD9");
var $1x6rV = parcelRequire("1x6rV");

var $kkh1l = parcelRequire("kkh1l");

var $lFGDz = parcelRequire("lFGDz");
const $f6d1ea802d6a6e06$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = (0, $lFGDz.getPixelRatio), ...serviceConfig } = provider;
    const scaleQueryParams = (0, $kkh1l.calculateScale)(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $1x6rV.utils).requestService(serviceConfig, requestOptions);
};

});


parcelRegister("fUSdm", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccf6aefc9dbc4e71$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $lnmJa = parcelRequire("lnmJa");

var $4LDqh = parcelRequire("4LDqh");

var $iqfTZ = parcelRequire("iqfTZ");

var $1uzV7 = parcelRequire("1uzV7");

var $3UnZm = parcelRequire("3UnZm");

var $8OZxa = parcelRequire("8OZxa");

var $cvbxx = parcelRequire("cvbxx");

var $lK1Z0 = parcelRequire("lK1Z0");

var $7ZEto = parcelRequire("7ZEto");

var $a11NW = parcelRequire("a11NW");

var $cqQ4S = parcelRequire("cqQ4S");

var $1ctjM = parcelRequire("1ctjM");
// FS-1097 - duplicated in mentions - extract at some point into a shared library
class $ccf6aefc9dbc4e71$var$Tokenizer {
    tokenize(text) {
        return this.tokenizeAsTokens(text).map((token)=>token.token);
    }
    tokenizeAsTokens(text) {
        let match;
        let tokens = [];
        (0, $lK1Z0.tokenizerRegex).lastIndex = 0;
        while((match = (0, $lK1Z0.tokenizerRegex).exec(text)) !== null)if (match[0]) tokens.push({
            token: match[0],
            start: match.index
        });
        return tokens;
    }
}
const $ccf6aefc9dbc4e71$var$addAllVariants = (emoji, fnKey, map)=>{
    const key = fnKey(emoji);
    if (!map.has(key)) map.set(key, []);
    const emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) emojisForKey.push(emoji);
    if ((0, $cvbxx.isEmojiDescriptionWithVariations)(emoji)) {
        // map variations too
        const variations = emoji.skinVariations;
        if (variations) variations.forEach((variation)=>$ccf6aefc9dbc4e71$var$addAllVariants(variation, fnKey, map));
    }
};
const $ccf6aefc9dbc4e71$var$findByKey = (map, key)=>{
    const emojis = map.get(key);
    if (emojis && emojis.length) // Priority is always to source from the last emoji set (last overrides first)
    return emojis[emojis.length - 1];
    return undefined;
};
const $ccf6aefc9dbc4e71$var$splitQuery = (query = '')=>{
    const isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) return {
        nameQuery: query.slice(1),
        asciiQuery: query
    };
    return {
        nameQuery: query,
        asciiQuery: ''
    };
};
const $ccf6aefc9dbc4e71$var$findEmojiIndex = (emojis, toFind)=>{
    const findId = toFind.id;
    let match = -1;
    emojis.forEach((emoji, index)=>{
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
            match = index;
            return;
        }
    });
    return match;
};
const $ccf6aefc9dbc4e71$var$teamojiRefreshExperimentName = 'platform_teamoji_26_refresh_emoji_picker';
const $ccf6aefc9dbc4e71$var$isRefreshEmojiPickerEnabled = ()=>{
    if (!(0, $4LDqh.default).initializeCompleted()) return false;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const isEnabled = (0, $4LDqh.default).getExperimentValue($ccf6aefc9dbc4e71$var$teamojiRefreshExperimentName, 'isEnabled', false);
    return isEnabled;
};
class $ccf6aefc9dbc4e71$export$2e2bcd8739ae039 {
    static{
        this.defaultEmojiWeight = 1000000;
    }
    constructor(emojis, usageTracker){
        this.fullSearchReady = false;
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
    /**
	 * Returns all available (and searchable) emoji in some default order.
	 */ all() {
        const options = {
            sort: (0, $1uzV7.SearchSort).None
        };
        return this.search('', options);
    }
    /**
	 * Text search of emoji shortName and name field for suitable matches.
	 *
	 * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
	 *
	 * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
	 * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
	 * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
	 */ search(query, options) {
        let filteredEmoji = [];
        const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $ccf6aefc9dbc4e71$var$splitQuery(query);
        if (nameQuery) {
            filteredEmoji = this.getSearchIndex().search(nameQuery);
            if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
        } else filteredEmoji = this.getAllSearchableEmojis();
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query
        };
    }
    /**
	 * Returns all emoji with matching shortName
	 */ findAllMatchingShortName(shortName) {
        return this.shortNameMap.get(shortName) || [];
    }
    /**
	 * Returns the first matching emoji matching the shortName, or null if none found.
	 */ findByShortName(shortName) {
        return $ccf6aefc9dbc4e71$var$findByKey(this.shortNameMap, shortName);
    }
    /**
	 * Returns the first matching emoji matching the id, or null if none found.
	 */ findById(id) {
        return $ccf6aefc9dbc4e71$var$findByKey(this.idMap, id);
    }
    findByAsciiRepresentation(asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    }
    findInCategory(categoryId) {
        if (categoryId === (0, $3UnZm.frequentCategory)) return this.getFrequentlyUsed();
        else if (categoryId === 'ATLASSIAN') return this.all().emojis.filter((emoji)=>emoji.category === categoryId || emoji.type === 'ATLASSIAN');
        else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
    }
    addUnknownEmoji(emoji) {
        this.emojis = [
            ...this.emojis,
            emoji
        ];
        this.getSearchIndex().addDocuments([
            emoji
        ]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    }
    getAsciiMap() {
        return this.asciiMap;
    }
    /**
	 * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
	 * there are none.
	 *
	 * @param options optional settings to be applied to the set of frequently used emoji
	 */ getFrequentlyUsed(options) {
        const emojiIds = this.usageTracker.getOrder();
        let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
        if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
        return emojiResult;
    }
    getDynamicCategoryList() {
        return this.dynamicCategoryList.slice();
    }
    /**
	 * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
	 * in sorting, etc).
	 *
	 * @param emoji the emoji that was just used
	 */ used(emoji) {
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf((0, $3UnZm.frequentCategory)) === -1) {
            if (typeof window === 'undefined') return;
            window.setTimeout(()=>{
                this.dynamicCategoryList.push((0, $3UnZm.frequentCategory));
            });
        }
    }
    delete(emoji) {
        const deletedIndex = $ccf6aefc9dbc4e71$var$findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    }
    withAsciiMatch(ascii, emojis) {
        let result = emojis;
        const asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter((e)=>e.id !== asciiEmoji.id);
            result = [
                asciiEmoji,
                ...result
            ];
        }
        return result;
    }
    applySearchOptions(emojis, query, options) {
        if (!options) options = {};
        if (options.sort === undefined) options.sort = (0, $1uzV7.SearchSort).Default;
        let comparator;
        if (options.sort === (0, $1uzV7.SearchSort).Default) comparator = (0, $cqQ4S.createSearchEmojiComparator)(query, this.usageTracker.getOrder());
        else if (options.sort === (0, $1uzV7.SearchSort).UsageFrequency) comparator = (0, $1ctjM.createUsageOnlyEmojiComparator)(this.usageTracker.getOrder());
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
        if (options.skinTone) return emojis.map((emoji)=>{
            return (0, $7ZEto.getEmojiVariation)(emoji, options);
        });
        return emojis;
    }
    initMembers(usageTracker) {
        this.usageTracker = usageTracker || new (0, $a11NW.UsageFrequencyTracker)();
        this.initRepositoryMetadata();
        if (!(0, $iqfTZ.fg)('platform_index_emoji_just_in_time')) this.initSearchIndex();
    }
    /**
	 * Optimisation to initialise all map member variables in single loop over emojis
	 */ initRepositoryMetadata() {
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        const categorySet = new Set();
        this.emojis.forEach((emoji)=>{
            categorySet.add(this.getDynamicCategoryForEmoji(emoji));
            this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) categorySet.add((0, $3UnZm.frequentCategory));
        this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, $3UnZm.defaultCategories).indexOf(category) === -1);
    }
    initSearchIndex() {
        this.fullSearch = new (0, $lnmJa.Search)('id');
        this.fullSearch.tokenizer = new $ccf6aefc9dbc4e71$var$Tokenizer();
        this.fullSearch.searchIndex = new (0, $lnmJa.UnorderedSearchIndex)();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        if ($ccf6aefc9dbc4e71$var$isRefreshEmojiPickerEnabled()) this.fullSearch.addIndex('keywords');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
        this.fullSearchReady = true;
    }
    getSearchIndex() {
        if (!this.fullSearchReady) this.initSearchIndex();
        return this.fullSearch;
    }
    getAllSearchableEmojis() {
        return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
    }
    addToMaps(emoji) {
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $ccf6aefc9dbc4e71$export$2e2bcd8739ae039.defaultEmojiWeight;
        if (typeof emoji.id === 'undefined') emoji.id = $ccf6aefc9dbc4e71$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
        $ccf6aefc9dbc4e71$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
        $ccf6aefc9dbc4e71$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
        if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
    }
    addToDynamicCategories(emoji) {
        const category = this.getDynamicCategoryForEmoji(emoji);
        if ((0, $3UnZm.defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
    }
    getDynamicCategoryForEmoji(emoji) {
        const category = (0, $8OZxa.getCategoryId)(emoji);
        if (emoji.type === 'ATLASSIAN' && category !== (0, $3UnZm.frequentCategory)) return 'ATLASSIAN';
        return category;
    }
}

});
parcelRegister("lnmJa", function(module, exports) {
$parcel$export(module.exports, "UnorderedSearchIndex", () => $f8fd60264ecd8122$export$5e70dbef3f0d47db);
$parcel$export(module.exports, "Search", () => $f8fd60264ecd8122$export$4b85d3515bd863a5);
/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */ var $f8fd60264ecd8122$export$58ac23006833dfe0 = /*#__PURE__*/ function() {
    function AllSubstringsIndexStrategy() {}
    var _proto = AllSubstringsIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string;
        for(var i = 0, length = token.length; i < length; ++i){
            string = '';
            for(var j = i; j < length; ++j){
                string += token.charAt(j);
                expandedTokens.push(string);
            }
        }
        return expandedTokens;
    };
    return AllSubstringsIndexStrategy;
}();
/**
 * Indexes for exact word matches.
 */ var $f8fd60264ecd8122$export$1dcc2d6a64836c8f = /*#__PURE__*/ function() {
    function ExactWordIndexStrategy() {}
    var _proto = ExactWordIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        return token ? [
            token
        ] : [];
    };
    return ExactWordIndexStrategy;
}();
/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */ var $f8fd60264ecd8122$export$eb7fc80cfe9abfe6 = /*#__PURE__*/ function() {
    function PrefixIndexStrategy() {}
    var _proto = PrefixIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string = '';
        for(var i = 0, length = token.length; i < length; ++i){
            string += token.charAt(i);
            expandedTokens.push(string);
        }
        return expandedTokens;
    };
    return PrefixIndexStrategy;
}();
/**
 * Enforces case-sensitive text matches.
 */ var $f8fd60264ecd8122$export$b88ffe9b5486f99a = /*#__PURE__*/ function() {
    function CaseSensitiveSanitizer() {}
    var _proto = CaseSensitiveSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.trim() : '';
    };
    return CaseSensitiveSanitizer;
}();
/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */ var $f8fd60264ecd8122$export$147e8ac43c84713a = /*#__PURE__*/ function() {
    function LowerCaseSanitizer() {}
    var _proto = LowerCaseSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.toLocaleLowerCase().trim() : '';
    };
    return LowerCaseSanitizer;
}();
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */ function $f8fd60264ecd8122$var$getNestedFieldValue(object, path) {
    path = path || [];
    object = object || {};
    var value = object; // walk down the property path
    for(var i = 0; i < path.length; i++){
        value = value[path[i]];
        if (value == null) return null;
    }
    return value;
}
/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */ var $f8fd60264ecd8122$export$a1138c79781169cc = /*#__PURE__*/ function() {
    function TfIdfSearchIndex(uidFieldName) {
        this._uidFieldName = uidFieldName;
        this._tokenToIdfCache = {};
        this._tokenMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = TfIdfSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        this._tokenToIdfCache = {}; // New index invalidates previous IDF caches
        var tokenMap = this._tokenMap;
        var tokenDatum;
        if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
            $numDocumentOccurrences: 0,
            $totalNumOccurrences: 1,
            $uidMap: {}
        };
        else {
            tokenDatum = tokenMap[token];
            tokenDatum.$totalNumOccurrences++;
        }
        var uidMap = tokenDatum.$uidMap;
        if (typeof uidMap[uid] !== 'object') {
            tokenDatum.$numDocumentOccurrences++;
            uidMap[uid] = {
                $document: doc,
                $numTokenOccurrences: 1
            };
        } else uidMap[uid].$numTokenOccurrences++;
    };
    _proto.search = function search(tokens, corpus) {
        var uidToDocumentMap = {};
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var tokenMetadata = this._tokenMap[token]; // Short circuit if no matches were found for any given token.
            if (!tokenMetadata) return [];
            if (i === 0) {
                var keys = Object.keys(tokenMetadata.$uidMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                }
            } else {
                var keys = Object.keys(uidToDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                }
            }
        }
        var documents = [];
        for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
        var calculateTfIdf = this._createCalculateTfIdf(); // Return documents sorted by TF-IDF
        return documents.sort(function(documentA, documentB) {
            return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
        });
    };
    _proto._createCalculateIdf = function _createCalculateIdf() {
        var tokenMap = this._tokenMap;
        var tokenToIdfCache = this._tokenToIdfCache;
        return function calculateIdf(token, documents) {
            if (!tokenToIdfCache[token]) {
                var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
            }
            return tokenToIdfCache[token];
        };
    };
    _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
        var tokenMap = this._tokenMap;
        var uidFieldName = this._uidFieldName;
        var calculateIdf = this._createCalculateIdf();
        return function calculateTfIdf(tokens, document, documents) {
            var score = 0;
            for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                var token = tokens[i];
                var inverseDocumentFrequency = calculateIdf(token, documents);
                if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                var uid;
                if (uidFieldName instanceof Array) uid = document && $f8fd60264ecd8122$var$getNestedFieldValue(document, uidFieldName);
                else uid = document && document[uidFieldName];
                var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                score += termFrequency * inverseDocumentFrequency;
            }
            return score;
        };
    };
    return TfIdfSearchIndex;
}();
/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */ var $f8fd60264ecd8122$export$5e70dbef3f0d47db = /*#__PURE__*/ function() {
    function UnorderedSearchIndex() {
        this._tokenToUidToDocumentMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = UnorderedSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
        this._tokenToUidToDocumentMap[token][uid] = doc;
    };
    _proto.search = function search(tokens, corpus) {
        var intersectingDocumentMap = {};
        var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var documentMap = tokenToUidToDocumentMap[token]; // Short circuit if no matches were found for any given token.
            if (!documentMap) return [];
            if (i === 0) {
                var keys = Object.keys(documentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    intersectingDocumentMap[uid] = documentMap[uid];
                }
            } else {
                var keys = Object.keys(intersectingDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                }
            }
        }
        var keys = Object.keys(intersectingDocumentMap);
        var documents = [];
        for(var i = 0, numKeys = keys.length; i < numKeys; i++){
            var uid = keys[i];
            documents.push(intersectingDocumentMap[uid]);
        }
        return documents;
    };
    return UnorderedSearchIndex;
}();
var $f8fd60264ecd8122$var$REGEX = /[^a-zа-яё0-9\-']+/i;
/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */ var $f8fd60264ecd8122$export$f5ac5ec3cb556ad6 = /*#__PURE__*/ function() {
    function SimpleTokenizer() {}
    var _proto = SimpleTokenizer.prototype;
    /**
   * @inheritDocs
   */ _proto.tokenize = function tokenize(text) {
        return text.split($f8fd60264ecd8122$var$REGEX).filter(function(text) {
            return text;
        } // Filter empty tokens
        );
    };
    return SimpleTokenizer;
}();
/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */ var $f8fd60264ecd8122$export$d2c689c98d4dcb27 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
        this._stemmingFunction = stemmingFunction;
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StemmingTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    };
    return StemmingTokenizer;
}();
/**
 * Stop words list copied from Lunr JS.
 */ var $f8fd60264ecd8122$export$eeaf491a400e882a = {
    a: true,
    able: true,
    about: true,
    across: true,
    after: true,
    all: true,
    almost: true,
    also: true,
    am: true,
    among: true,
    an: true,
    and: true,
    any: true,
    are: true,
    as: true,
    at: true,
    be: true,
    because: true,
    been: true,
    but: true,
    by: true,
    can: true,
    cannot: true,
    could: true,
    dear: true,
    did: true,
    'do': true,
    does: true,
    either: true,
    'else': true,
    ever: true,
    every: true,
    'for': true,
    from: true,
    'get': true,
    got: true,
    had: true,
    has: true,
    have: true,
    he: true,
    her: true,
    hers: true,
    him: true,
    his: true,
    how: true,
    however: true,
    i: true,
    'if': true,
    'in': true,
    into: true,
    is: true,
    it: true,
    its: true,
    just: true,
    least: true,
    "let": true,
    like: true,
    likely: true,
    may: true,
    me: true,
    might: true,
    most: true,
    must: true,
    my: true,
    neither: true,
    no: true,
    nor: true,
    not: true,
    of: true,
    off: true,
    often: true,
    on: true,
    only: true,
    or: true,
    other: true,
    our: true,
    own: true,
    rather: true,
    said: true,
    say: true,
    says: true,
    she: true,
    should: true,
    since: true,
    so: true,
    some: true,
    than: true,
    that: true,
    the: true,
    their: true,
    them: true,
    then: true,
    there: true,
    these: true,
    they: true,
    'this': true,
    tis: true,
    to: true,
    too: true,
    twas: true,
    us: true,
    wants: true,
    was: true,
    we: true,
    were: true,
    what: true,
    when: true,
    where: true,
    which: true,
    'while': true,
    who: true,
    whom: true,
    why: true,
    will: true,
    'with': true,
    would: true,
    yet: true,
    you: true,
    your: true
}; // Prevent false positives for inherited properties
$f8fd60264ecd8122$export$eeaf491a400e882a.constructor = false;
$f8fd60264ecd8122$export$eeaf491a400e882a.hasOwnProperty = false;
$f8fd60264ecd8122$export$eeaf491a400e882a.isPrototypeOf = false;
$f8fd60264ecd8122$export$eeaf491a400e882a.propertyIsEnumerable = false;
$f8fd60264ecd8122$export$eeaf491a400e882a.toLocaleString = false;
$f8fd60264ecd8122$export$eeaf491a400e882a.toString = false;
$f8fd60264ecd8122$export$eeaf491a400e882a.valueOf = false;
/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */ var $f8fd60264ecd8122$export$59d4dfff8ed0ca89 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StopWordsTokenizer(decoratedTokenizer) {
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StopWordsTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).filter(function(token) {
            return !$f8fd60264ecd8122$export$eeaf491a400e882a[token];
        });
    };
    return StopWordsTokenizer;
}();
function $f8fd60264ecd8122$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f8fd60264ecd8122$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f8fd60264ecd8122$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f8fd60264ecd8122$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */ var $f8fd60264ecd8122$export$4b85d3515bd863a5 = /*#__PURE__*/ function() {
    /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */ /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */ function Search(uidFieldName) {
        if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
        this._uidFieldName = uidFieldName; // Set default/recommended strategies
        this._indexStrategy = new $f8fd60264ecd8122$export$eb7fc80cfe9abfe6();
        this._searchIndex = new $f8fd60264ecd8122$export$a1138c79781169cc(uidFieldName);
        this._sanitizer = new $f8fd60264ecd8122$export$147e8ac43c84713a();
        this._tokenizer = new $f8fd60264ecd8122$export$f5ac5ec3cb556ad6();
        this._documents = [];
        this._searchableFields = [];
    }
    /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */ var _proto = Search.prototype;
    /**
   * Add a searchable document to the index. Document will automatically be indexed for search.
   * @param document
   */ _proto.addDocument = function addDocument(document) {
        this.addDocuments([
            document
        ]);
    };
    _proto.addDocuments = function addDocuments(documents) {
        this._documents = this._documents.concat(documents);
        this.indexDocuments_(documents, this._searchableFields);
    };
    _proto.addIndex = function addIndex(field) {
        this._searchableFields.push(field);
        this.indexDocuments_(this._documents, [
            field
        ]);
    };
    _proto.search = function search(query) {
        var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
        return this._searchIndex.search(tokens, this._documents);
    };
    _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
        this._initialized = true;
        var indexStrategy = this._indexStrategy;
        var sanitizer = this._sanitizer;
        var searchIndex = this._searchIndex;
        var tokenizer = this._tokenizer;
        var uidFieldName = this._uidFieldName;
        for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
            var doc = documents[di];
            var uid;
            if (uidFieldName instanceof Array) uid = $f8fd60264ecd8122$var$getNestedFieldValue(doc, uidFieldName);
            else uid = doc[uidFieldName];
            for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                var fieldValue;
                var searchableField = _searchableFields[sfi];
                if (searchableField instanceof Array) fieldValue = $f8fd60264ecd8122$var$getNestedFieldValue(doc, searchableField);
                else fieldValue = doc[searchableField];
                if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                if (typeof fieldValue === 'string') {
                    var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                    for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                        var fieldToken = fieldTokens[fti];
                        var expandedTokens = indexStrategy.expandToken(fieldToken);
                        for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                            var expandedToken = expandedTokens[eti];
                            searchIndex.indexDocument(expandedToken, uid, doc);
                        }
                    }
                }
            }
        }
    };
    $f8fd60264ecd8122$var$_createClass(Search, [
        {
            key: "indexStrategy",
            set: function set(value) {
                if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                this._indexStrategy = value;
            },
            get: function get() {
                return this._indexStrategy;
            }
        },
        {
            key: "sanitizer",
            set: function set(value) {
                if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                this._sanitizer = value;
            },
            get: function get() {
                return this._sanitizer;
            }
        },
        {
            key: "searchIndex",
            set: function set(value) {
                if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                this._searchIndex = value;
            },
            get: function get() {
                return this._searchIndex;
            }
        },
        {
            key: "tokenizer",
            set: function set(value) {
                if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                this._tokenizer = value;
            },
            get: function get() {
                return this._tokenizer;
            }
        }
    ]);
    return Search;
}();
/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */ var $f8fd60264ecd8122$export$11e693a7f8ce1bcc = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */ function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
        this._indexStrategy = opt_indexStrategy || new $f8fd60264ecd8122$export$eb7fc80cfe9abfe6();
        this._sanitizer = opt_sanitizer || new $f8fd60264ecd8122$export$147e8ac43c84713a();
        this._wrapperTagName = opt_wrapperTagName || 'mark';
    }
    /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */ var _proto = TokenHighlighter.prototype;
    _proto.highlight = function highlight(text, tokens) {
        var tagsLength = this._wrapText('').length;
        var tokenDictionary = Object.create(null); // Create a token map for easier lookup below.
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = this._sanitizer.sanitize(tokens[i]);
            var expandedTokens = this._indexStrategy.expandToken(token);
            for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                var expandedToken = expandedTokens[j];
                if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                    token
                ];
                else tokenDictionary[expandedToken].push(token);
            }
        } // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
        var actualCurrentWord = '';
        var sanitizedCurrentWord = '';
        var currentWordStartIndex = 0; // Note this assumes either prefix or full word matching.
        for(var i = 0, textLength = text.length; i < textLength; i++){
            var character = text.charAt(i);
            if (character === ' ') {
                actualCurrentWord = '';
                sanitizedCurrentWord = '';
                currentWordStartIndex = i + 1;
            } else {
                actualCurrentWord += character;
                sanitizedCurrentWord += this._sanitizer.sanitize(character);
            }
            if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                actualCurrentWord = this._wrapText(actualCurrentWord);
                text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                i += tagsLength;
                textLength += tagsLength;
            }
        }
        return text;
    };
    _proto._wrapText = function _wrapText(text) {
        var tagName = this._wrapperTagName;
        return "<" + tagName + ">" + text + "</" + tagName + ">";
    };
    return TokenHighlighter;
}();

});

parcelRegister("8OZxa", function(module, exports) {
$parcel$export(module.exports, "getCategoryId", () => $57f9f6fe323290a0$export$4bcbf61cb6832a8e);
const $57f9f6fe323290a0$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});

parcelRegister("cvbxx", function(module, exports) {
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $e3cc13b2e8ca88d2$export$b0ed6d8df471f3cc);
const $e3cc13b2e8ca88d2$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);

});

parcelRegister("lK1Z0", function(module, exports) {
$parcel$export(module.exports, "tokenizerRegex", () => $9696b394cb1afd96$export$6558e5d0f0e834f8);
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: Regex compiled to unicode charsets using xregexp-transformer, refer to it if you need to compile it again.
//       @atlaskit/xregexp-transformer (https://bitbucket.org/atlassian/xregexp-transformer)
// eslint-disable-next-line no-misleading-character-class
const $9696b394cb1afd96$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');

});

parcelRegister("7ZEto", function(module, exports) {
$parcel$export(module.exports, "getEmojiVariation", () => $9c58f0dbbb14a349$export$e55e46e1520c899d);

var $cvbxx = parcelRequire("cvbxx");
const $9c58f0dbbb14a349$export$e55e46e1520c899d = (emoji, options)=>{
    if ((0, $cvbxx.isEmojiDescriptionWithVariations)(emoji) && options) {
        const skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            const skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) return skinToneEmoji;
        }
    }
    return emoji;
};

});

parcelRegister("a11NW", function(module, exports) {
$parcel$export(module.exports, "UsageFrequencyTracker", () => $8f7e30358b727d85$export$3f86810331c44209);

var $9c4PQ = parcelRequire("9c4PQ");

var $fonFa = parcelRequire("fonFa");

var $3UnZm = parcelRequire("3UnZm");

var $crbnf = parcelRequire("crbnf");

var $SrGJC = parcelRequire("SrGJC");

var $azwhz = parcelRequire("azwhz");
class $8f7e30358b727d85$export$3f86810331c44209 {
    static{
        this.queueOptions = {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storage: (0, $SrGJC.default)('localStorage') ? window.localStorage : undefined,
            storagePrefix: (0, $3UnZm.localStoragePrefix),
            maxDuplicates: 25,
            minUniqueItems: 5
        };
    }
    constructor(useStorageIfPossible = true){
        const options = $8f7e30358b727d85$export$3f86810331c44209.queueOptions;
        if (useStorageIfPossible && options.storage) {
            const queueOptions = {
                ...options,
                storage: options.storage
            };
            this.queue = new (0, $fonFa.default)(queueOptions);
        } else this.queue = new (0, $9c4PQ.default)(options);
        this.gateway = new (0, $azwhz.Gateway)(10);
    }
    /**
	 * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
	 * count on getOrder() reflecting this usage immediately.
	 *
	 * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
	 */ recordUsage(emoji) {
        let emojiId = emoji.id;
        if (emojiId) {
            if ((0, $crbnf.isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
            this.gateway.submit(()=>{
                if (emojiId) this.queue.enqueue(emojiId);
            });
        }
    }
    /**
	 * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
	 * are no usages then an empty array will be returned.
	 */ getOrder() {
        return this.queue.getItemsOrderedByDuplicateCount();
    }
    /**
	 * Exposed for testing only. Clear any recorded usage.
	 */ clear() {
        this.queue.clear();
    }
}

});
parcelRegister("9c4PQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e742ff8f923a8dd1$export$2e2bcd8739ae039);
/**
 * The options used to configure a newly constructed queue.
 */ class $e742ff8f923a8dd1$export$2e2bcd8739ae039 {
    /**
	 * Construct a new DuplicateLimitedQueue.
	 *
	 * @param options the options for this queue.
	 */ constructor(options){
        if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
        if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
    /**
	 * @param item the item to add to the queue.
	 */ enqueue(item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
	 * Return the items in the queue, ordered by how often they are duplicated. The items with the
	 * most duplicates come first in the returned Array.
	 *
	 * If there are no items in the queue then an empty Array will be returned.
	 */ getItemsOrderedByDuplicateCount() {
        return this.itemsOrderedByFrequency;
    }
    /**
	 * Exposed for storybook/testing purposes only. Clear the contents of the queue.
	 */ clear() {
        this.createEmptyState();
    }
    /**
	 * A more efficient mechanism for adding multiple items. Ordering is only performed once all
	 * the items have been added.
	 *
	 * @param items the items to be enqueued, which happens in their presented order.
	 */ bulkEnqueue(items) {
        items.map((item)=>this.enqueueWithoutOrdering(item));
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
	 * Return the items currently stored in the queue.
	 */ getItems() {
        return this.items;
    }
    createEmptyState() {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    }
    /**
	 * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
	 * performed by this enqueuing. You must trigger that manually if required.
	 *
	 * @param item the item to be queued
	 */ enqueueWithoutOrdering(item) {
        const count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) // find the first item with that key in the array and remove it
        this.removeFirstOccurrence(item);
        else if (this.items.length >= this.maximumSize) this.remove();
        this.add(item);
    }
    /**
	 * Get an array of items from the queue ordered by how often they are duplicated in the queue.
	 */ orderItemsByFrequency() {
        const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
            return b[1] - a[1];
        });
        return orderedEntries.map((value)=>value[0]);
    }
    decrementCount(item) {
        let count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) this.itemCountMap.set(item, count);
            else this.itemCountMap.delete(item);
        }
    }
    /**
	 * Walk the list of items and remove the first occurrence of the matching item.
	 *
	 * @param item the item to be removed.
	 */ removeFirstOccurrence(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    }
    /**
	 * Remove the first item from the queue and update the itemCountMap accordingly.
	 * @return the item add the front of the queue or undefined if the queue is empty
	 */ remove() {
        const removed = this.items.shift();
        if (removed !== undefined) this.decrementCount(removed);
        return removed;
    }
    /**
	 * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
	 * @param item the item to be added to the queue
	 */ add(item) {
        this.items.push(item);
        const count = this.itemCountMap.get(item);
        if (count) this.itemCountMap.set(item, count + 1);
        else this.itemCountMap.set(item, 1);
    }
}

});

parcelRegister("fonFa", function(module, exports) {
$parcel$export(module.exports, "default", () => $1186713f7c05940e$export$2e2bcd8739ae039);

var $9c4PQ = parcelRequire("9c4PQ");

var $7vSev = parcelRequire("7vSev");
class $1186713f7c05940e$export$2e2bcd8739ae039 extends (0, $9c4PQ.default) {
    static{
        this.storageKey = 'lastUsed';
    }
    constructor(options){
        super(options);
        this.storage = options.storage;
        this.prefixedStorageKey = `${options.storagePrefix}.${$1186713f7c05940e$export$2e2bcd8739ae039.storageKey}`;
        this.load();
    }
    /**
	 * Enqueue the supplied item and also persist the new contents of the queue to storage.
	 *
	 * @param item the item to be enqueued
	 */ enqueue(item) {
        super.enqueue(item);
        this.save();
    }
    /**
	 * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
	 */ clear() {
        super.clear();
        this.storage.removeItem(this.prefixedStorageKey);
    }
    /**
	 * Initialise the queue contents from the configured Storage. If there is no data found in
	 * storage then the queue will have no items added. Likewise, a failure to read or parse stored
	 * data will be swallowed and no items are added to the queue.
	 */ load() {
        const itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson) try {
            const items = JSON.parse(itemsJson);
            this.bulkEnqueue(items);
        } catch (e) {
            (0, $7vSev.default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
        }
    }
    /**
	 * Save the current items in the queue, overwriting any previously stored queue.
	 * Any failure in saving will be silently ignored with the likely outcome that any previous
	 * saved items will remain unchanged in storage.
	 */ save() {
        const itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        } catch (e) {
            (0, $7vSev.default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
        }
    }
}

});

parcelRegister("crbnf", function(module, exports) {
$parcel$export(module.exports, "isEmojiVariationDescription", () => $12e737509c0f1a97$export$82a0350e1f6b5c0a);
const $12e737509c0f1a97$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};

});

parcelRegister("azwhz", function(module, exports) {
$parcel$export(module.exports, "Gateway", () => $5430c19b87bb34d2$export$a0e1fa6601cae894);
class $5430c19b87bb34d2$export$a0e1fa6601cae894 {
    constructor(maximumPermitted){
        if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
    /**
	 * Run the supplied function if the count of already submitted work allows it. Drop the work
	 * if it's not allowed to run.
	 *
	 * Will return true if the function has been submitted or false if it was not submitted.
	 */ submit(f) {
        if (this.count >= this.maximumPermitted) return false;
        this.count++;
        const wrappedFunc = ()=>{
            try {
                f();
            } finally{
                this.completed();
            }
        };
        if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
        return true;
    }
    completed() {
        this.count--;
    }
}

});


parcelRegister("cqQ4S", function(module, exports) {
$parcel$export(module.exports, "createSearchEmojiComparator", () => $52288c4c445239a4$export$e6097b005751df7);

var $jiZJm = parcelRequire("jiZJm");

var $l0HMR = parcelRequire("l0HMR");

var $7syIE = parcelRequire("7syIE");

var $2y7O6 = parcelRequire("2y7O6");

var $fKIFn = parcelRequire("fKIFn");

var $5mycY = parcelRequire("5mycY");

var $eKU8X = parcelRequire("eKU8X");
function $52288c4c445239a4$export$e6097b005751df7(query, orderedIds) {
    const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
    const comparators = [];
    if (query) comparators.push(new (0, $l0HMR.AsciiMatchComparator)(query));
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) comparators.push(new (0, $2y7O6.ExactShortNameMatchComparator)(textQuery));
    if (orderedIds && orderedIds.length) comparators.push(new (0, $eKU8X.UsageFrequencyComparator)(orderedIds));
    if (textQuery) comparators.push(new (0, $5mycY.QueryStringPositionMatchComparator)(textQuery, 'shortName'), new (0, $5mycY.QueryStringPositionMatchComparator)(textQuery, 'name'));
    comparators.push((0, $fKIFn.OrderComparator).Instance, (0, $jiZJm.AlphabeticalShortnameComparator).Instance);
    const comparator = new (0, $7syIE.ChainedEmojiComparator)(...comparators);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}

});
parcelRegister("jiZJm", function(module, exports) {
$parcel$export(module.exports, "AlphabeticalShortnameComparator", () => $ce46d3b05c5bfe80$export$30ce221e1adf48c1);
class $ce46d3b05c5bfe80$export$30ce221e1adf48c1 {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    }
}

});

parcelRegister("l0HMR", function(module, exports) {
$parcel$export(module.exports, "AsciiMatchComparator", () => $0a2498606b923382$export$ff92575cd1bbad0e);
class $0a2498606b923382$export$ff92575cd1bbad0e {
    constructor(query){
        this.query = query;
    }
    compare(e1, e2) {
        const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) return -1;
        else if (!e1HasAscii && e2HasAscii) return 1;
        return 0;
    }
}

});

parcelRegister("7syIE", function(module, exports) {
$parcel$export(module.exports, "ChainedEmojiComparator", () => $ec9fe41bd6095609$export$a8052d0852821684);
class $ec9fe41bd6095609$export$a8052d0852821684 {
    constructor(...comparators){
        this.chain = comparators;
    }
    compare(e1, e2) {
        for(let i = 0; i < this.chain.length; i++){
            const result = this.chain[i].compare(e1, e2);
            if (result !== 0) return result;
        }
        return 0;
    }
}

});

parcelRegister("2y7O6", function(module, exports) {
$parcel$export(module.exports, "ExactShortNameMatchComparator", () => $6f2b982f3a1ddba9$export$3026b08b79541139);

var $8PWeU = parcelRequire("8PWeU");
class $6f2b982f3a1ddba9$export$3026b08b79541139 {
    constructor(query){
        this.colonQuery = `:${query}:`;
        this.typeComparator = new (0, $8PWeU.EmojiTypeComparator)(true);
    }
    compare(e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
        else if (e1.shortName === this.colonQuery) return -1;
        else if (e2.shortName === this.colonQuery) return 1;
        return 0;
    }
}

});
parcelRegister("8PWeU", function(module, exports) {
$parcel$export(module.exports, "EmojiTypeComparator", () => $028298dfae180954$export$a7f7a0b04013a8a8);
class $028298dfae180954$export$a7f7a0b04013a8a8 {
    constructor(reverse){
        if (reverse) this.typeToNumber = new Map([
            [
                'SITE',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'STANDARD',
                2
            ]
        ]);
        else this.typeToNumber = new Map([
            [
                'STANDARD',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'SITE',
                2
            ]
        ]);
    }
    compare(e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    }
    emojiTypeToOrdinal(emoji) {
        let ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) ordinal = 10;
        return ordinal;
    }
}

});


parcelRegister("fKIFn", function(module, exports) {
$parcel$export(module.exports, "OrderComparator", () => $d1b3d3b4532d0a4a$export$165e96ceead77edd);

var $3UnZm = parcelRequire("3UnZm");
class $d1b3d3b4532d0a4a$export$165e96ceead77edd {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        let o1 = e1.order ? e1.order : (0, $3UnZm.MAX_ORDINAL);
        let o2 = e2.order ? e2.order : (0, $3UnZm.MAX_ORDINAL);
        return o1 - o2;
    }
}

});

parcelRegister("5mycY", function(module, exports) {
$parcel$export(module.exports, "QueryStringPositionMatchComparator", () => $8ada4bc32b258a04$export$587c775915dc4869);

var $3UnZm = parcelRequire("3UnZm");
class $8ada4bc32b258a04$export$587c775915dc4869 {
    /**
	 * @param query the query to match
	 * @param propertyToCompare the property of EmojiDescription to check for query within
	 */ constructor(query, propertyToCompare){
        this.query = query;
        if (!propertyToCompare) throw new Error('propertyToCompare is required');
        this.propertyName = propertyToCompare;
    }
    getScore(emoji) {
        // It is fine to do override the null check here because we are checking
        // it on the constructor.
        const propertyValue = emoji[this.propertyName];
        const score = propertyValue ? propertyValue.indexOf(this.query) : (0, $3UnZm.MAX_ORDINAL);
        return score === -1 ? (0, $3UnZm.MAX_ORDINAL) : score;
    }
    compare(e1, e2) {
        return this.getScore(e1) - this.getScore(e2);
    }
}

});

parcelRegister("eKU8X", function(module, exports) {
$parcel$export(module.exports, "UsageFrequencyComparator", () => $d379f92a1f532084$export$55e24837a4bf653);

var $3UnZm = parcelRequire("3UnZm");

var $crbnf = parcelRequire("crbnf");
class $d379f92a1f532084$export$55e24837a4bf653 {
    constructor(orderedIds){
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
    }
    compare(e1, e2) {
        if (!e1.id || !e2.id) return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        let i1 = this.getPositionInOrder(e1);
        let i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    }
    /**
	 * Get the ordinal representing the position of this emoji.
	 *
	 * @param id the id of the emoji
	 */ getPositionInOrder(emoji) {
        let id = emoji.id ? emoji.id : '0';
        if ((0, $crbnf.isEmojiVariationDescription)(emoji)) id = emoji.baseId;
        const position = this.positionLookup.get(id);
        if (position) return position;
        else return 0, $3UnZm.MAX_ORDINAL;
    }
}

});


parcelRegister("1ctjM", function(module, exports) {
$parcel$export(module.exports, "createUsageOnlyEmojiComparator", () => $6ef582342e26b7be$export$1bd055808eeccb4e);

var $7syIE = parcelRequire("7syIE");

var $8PWeU = parcelRequire("8PWeU");

var $fKIFn = parcelRequire("fKIFn");

var $eKU8X = parcelRequire("eKU8X");
function $6ef582342e26b7be$export$1bd055808eeccb4e(orderedIds) {
    const comparator = new (0, $7syIE.ChainedEmojiComparator)(new (0, $eKU8X.UsageFrequencyComparator)(orderedIds), new (0, $8PWeU.EmojiTypeComparator)(), (0, $fKIFn.OrderComparator).Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}

});


parcelRegister("gXn22", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc8422688167ad3f$export$2e2bcd8739ae039);

var $hLj2J = parcelRequire("hLj2J");

var $iqfTZ = parcelRequire("iqfTZ");
parcelRequire("eGjD9");
var $1x6rV = parcelRequire("1x6rV");

var $dFmib = parcelRequire("dFmib");

var $fSEjD = parcelRequire("fSEjD");

var $eB0wS = parcelRequire("eB0wS");

var $d251u = parcelRequire("d251u");

var $lzAfn = parcelRequire("lzAfn");

var $7vSev = parcelRequire("7vSev");

var $fcawt = parcelRequire("fcawt");

var $2x7IR = parcelRequire("2x7IR");

var $8OPkL = parcelRequire("8OPkL");

var $irP7u = parcelRequire("irP7u");

var $dXaLZ = parcelRequire("dXaLZ");
const $fc8422688167ad3f$export$6f3a08dea02a7b2b = 0.95;
class $fc8422688167ad3f$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig, mediaApiToken){
        this.postToEmojiService = (upload, fileId)=>{
            const { shortName: shortName, name: name } = upload;
            const { width: width, height: height } = upload;
            const requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId
                })
            };
            return (0, $1x6rV.utils).requestService(this.siteServiceConfig, {
                requestInit: requestInit
            }).then((response)=>{
                const { emojis: emojis } = response;
                if (emojis.length) {
                    const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                    const response = {
                        ...emoji,
                        representation: (0, $fSEjD.convertImageToMediaRepresentation)(emoji.representation)
                    };
                    const altRepresentation = (0, $8OPkL.getAltRepresentation)(altRepresentations || {});
                    const imgAltRepresentation = altRepresentation ? (0, $fSEjD.convertImageToMediaRepresentation)(altRepresentation) : undefined;
                    return (0, $dFmib.buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        };
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new (0, $dXaLZ.default)(siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new (0, $irP7u.default)(this.tokenManager);
    }
    /**
	 * Will generate an emoji media path that is inclusive of client and token within the query parameter for media representation and altRepresentation
	 */ async generateTokenisedMediaURLS(representation, altRepresentation) {
        if (!(0, $lzAfn.isMediaRepresentation)(representation)) return {
            representation: representation,
            altRepresentation: altRepresentation
        };
        try {
            const readToken = await this.tokenManager.getToken('read');
            return Object.entries({
                representation: representation,
                altRepresentation: altRepresentation
            }).reduce((acc, [key, value])=>{
                if (value && (0, $lzAfn.isMediaRepresentation)(value)) {
                    const path = new URL(value.mediaPath);
                    const params = path.searchParams;
                    if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                    if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                    acc[key] = {
                        ...value,
                        mediaPath: path.toString()
                    };
                }
                return acc;
            }, {
                representation: representation,
                altRepresentation: altRepresentation
            });
        } catch (error) {
            return {
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
    }
    /**
	 * Will load media emoji, returning a new EmojiDescription if, for example,
	 * the URL has changed.
	 */ loadMediaEmoji(emoji, useAlt) {
        if (!(0, $d251u.isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(emoji, useAlt) {
        const representation = useAlt ? emoji.altRepresentation : emoji.representation;
        if (!(0, $lzAfn.isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
        const { mediaPath: mediaPath } = representation;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    }
    uploadEmoji(upload, retry = false, progressCallback) {
        const startTime = Date.now();
        return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
            const tokenLoadTime = Date.now() - startTime;
            (0, $7vSev.default)('upload token load time', tokenLoadTime);
            return new Promise((resolve, reject)=>{
                const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                const mediaClient = (0, $hLj2J.getMediaClient)({
                    authProvider: ()=>Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url
                        }),
                    useSha256ForUploads: true
                });
                if ((0, $iqfTZ.fg)('add_emoji_media_size_to_media_file_upload_request')) mediaClient.file.uploadExternal(upload.dataURL, collectionName, undefined, true).then(({ uploadableFileUpfrontIds: uploadableFileUpfrontIds })=>{
                    const subscription = mediaClient.file.getFileState(uploadableFileUpfrontIds.id, {
                        collectionName: collectionName
                    }).subscribe({
                        next: (state)=>{
                            if (state.status === 'uploading' && progressCallback) progressCallback({
                                percent: state.progress * $fc8422688167ad3f$export$6f3a08dea02a7b2b
                            });
                            else if (state.status === 'processing' || state.status === 'processed') {
                                subscription.unsubscribe();
                                const totalUploadTime = Date.now() - startTime;
                                const mediaUploadTime = totalUploadTime - tokenLoadTime;
                                (0, $7vSev.default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                                this.postToEmojiService(upload, uploadableFileUpfrontIds.id).then((emoji)=>{
                                    resolve(emoji);
                                }).catch((httpError)=>{
                                    reject(httpError.reason || httpError);
                                });
                            }
                        },
                        error (error) {
                            reject(error);
                        }
                    });
                }).catch((error)=>{
                    reject(error);
                });
                else {
                    const subscription = mediaClient.file.upload({
                        content: upload.dataURL,
                        name: upload.filename,
                        collection: collectionName
                    }).subscribe({
                        next: (state)=>{
                            if (state.status === 'uploading' && progressCallback) progressCallback({
                                percent: state.progress * $fc8422688167ad3f$export$6f3a08dea02a7b2b
                            });
                            else if (state.status === 'processing' || state.status === 'processed') {
                                subscription.unsubscribe();
                                const totalUploadTime = Date.now() - startTime;
                                const mediaUploadTime = totalUploadTime - tokenLoadTime;
                                (0, $7vSev.default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                                this.postToEmojiService(upload, state.id).then((emoji)=>{
                                    resolve(emoji);
                                }).catch((httpError)=>{
                                    reject(httpError.reason || httpError);
                                });
                            }
                        },
                        error (error) {
                            reject(error);
                        }
                    });
                }
            });
        });
    }
    /**
	 * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
	 * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
	 * completes with failure then the Promise will resolve to false.
	 */ hasUploadToken() {
        const tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then((token)=>{
            return token !== undefined;
        }, ()=>{
            return false;
        });
    }
    prepareForUpload() {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    }
    findEmoji(emojiId) {
        if (!emojiId.id) return Promise.reject(false);
        const path = `../${encodeURIComponent(emojiId.id)}`;
        return (0, $2x7IR.emojiRequest)(this.siteServiceConfig, {
            path: path
        }).then((serviceResponse)=>{
            const response = (0, $fcawt.denormaliseEmojiServiceResponse)(serviceResponse);
            return response.emojis[0];
        }).catch((error)=>{
            (0, $7vSev.default)('failed to load emoji', emojiId, error);
            return undefined;
        });
    }
    /**
	 * Calls to site-scoped EmojiResource to delete emoji
	 * @param emoji media emoji to delete
	 * @returns Promise.resolve() if success and Promise.reject() for failure
	 */ deleteEmoji(emoji) {
        if (!(0, $d251u.isMediaEmoji)(emoji) && !(0, $eB0wS.isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
        if (!emoji.id) return Promise.reject(false);
        const path = `${encodeURIComponent(emoji.id)}`;
        const requestInit = {
            method: 'DELETE'
        };
        return (0, $1x6rV.utils).requestService(this.siteServiceConfig, {
            path: path,
            requestInit: requestInit
        })// Successful delete on Promise.resolve
        .then(()=>true)// Unsuccessful delete on Promise.reject
        .catch(()=>false);
    }
}

});
parcelRegister("hLj2J", function(module, exports) {
$parcel$export(module.exports, "getMediaClient", () => $3b90724b980b7472$export$c9ecbc1b719fd417);

var $iamEj = parcelRequire("iamEj");
const $3b90724b980b7472$export$f92e83e86b03c398 = new Map();
const $3b90724b980b7472$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $iamEj.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $3b90724b980b7472$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $iamEj.MediaClient)(mediaClientConfig);
        $3b90724b980b7472$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};

});
parcelRegister("iamEj", function(module, exports) {
$parcel$export(module.exports, "MediaClient", () => $54af462118ed574f$export$fba8b4ca6d386aec);

var $4tn2W = parcelRequire("4tn2W");
parcelRequire("dnJXJ");
var $eyW2Z = parcelRequire("eyW2Z");

var $hXVBO = parcelRequire("hXVBO");

var $dH5I0 = parcelRequire("dH5I0");

var $jFaRs = parcelRequire("jFaRs");

var $grIM4 = parcelRequire("grIM4");

class $54af462118ed574f$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $grIM4.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $hXVBO.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: (0, $eyW2Z.ChunkHashAlgorithm).Sha256,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $dH5I0.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $4tn2W.EventEmitter2)();
        this.stargate = new (0, $jFaRs.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
	 * @internal
	 */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getClientId(collectionName) {
        return this.mediaStore.getClientId(collectionName);
    }
    getClientIdSync() {
        return this.mediaStore.getClientIdSync();
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("2XO7C"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("4tn2W", function(module, exports) {
/*!
 * EventEmitter2
 * https://github.com/hij1nx/EventEmitter2
 *
 * Copyright (c) 2013 hij1nx
 * Licensed under the MIT license.
 */ 
var $gIMgJ = parcelRequire("gIMgJ");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $gIMgJ !== 'undefined' && $gIMgJ.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $gIMgJ.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("dnJXJ", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => (parcelRequire("7PqSD")).mediaState);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("a8jgR")).authToOwner);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("kO6sh")).isClientBasedAuth);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("eyW2Z")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $7PqSD = parcelRequire("7PqSD");

var $a8jgR = parcelRequire("a8jgR");

var $j0yIR = parcelRequire("j0yIR");

var $kO6sh = parcelRequire("kO6sh");

var $eyW2Z = parcelRequire("eyW2Z");

});
parcelRegister("7PqSD", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => $d978470e0adb03d1$export$8cef61637918b288);

var $4tn2W = parcelRequire("4tn2W");

var $lN2R9 = parcelRequire("lN2R9");
const $d978470e0adb03d1$export$8cef61637918b288 = {
    streams: new (0, $lN2R9.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $4tn2W.EventEmitter2)()
};

});

parcelRegister("a8jgR", function(module, exports) {
$parcel$export(module.exports, "authToOwner", () => $0079f15c1d3bbb11$export$17f6055767a8d96a);

var $j0yIR = parcelRequire("j0yIR");
const $0079f15c1d3bbb11$export$17f6055767a8d96a = (auth)=>{
    if ((0, $j0yIR.isAsapBasedAuth)(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});
parcelRegister("j0yIR", function(module, exports) {
$parcel$export(module.exports, "isAsapBasedAuth", () => $119af05b79d58ddc$export$af1ab14f2246ef72);
function $119af05b79d58ddc$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}

});


parcelRegister("kO6sh", function(module, exports) {
$parcel$export(module.exports, "isClientBasedAuth", () => $f1622d2cda62356b$export$6ba49fcac9c46e54);
function $f1622d2cda62356b$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}

});

parcelRegister("eyW2Z", function(module, exports) {
$parcel$export(module.exports, "ChunkHashAlgorithm", () => $9c6f966dd6e5c932$export$d3e73a50cc549c2e);
var $9c6f966dd6e5c932$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});


parcelRegister("hXVBO", function(module, exports) {
$parcel$export(module.exports, "MediaStore", () => $99818ddea2b24ac9$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $99818ddea2b24ac9$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $99818ddea2b24ac9$export$20f9315304dd6726);

var $1PA5z = parcelRequire("1PA5z");
parcelRequire("dnJXJ");
var $eyW2Z = parcelRequire("eyW2Z");
var $kO6sh = parcelRequire("kO6sh");

var $iGFGS = parcelRequire("iGFGS");

var $4HYJj = parcelRequire("4HYJj");

var $ab1R9 = parcelRequire("ab1R9");
var $euhlJ = parcelRequire("euhlJ");

var $2tMx2 = parcelRequire("2tMx2");

var $ev1Tj = parcelRequire("ev1Tj");

var $91qfe = parcelRequire("91qfe");

var $bf4HK = parcelRequire("bf4HK");

var $7oqJN = parcelRequire("7oqJN");

var $iqfTZ = parcelRequire("iqfTZ");
const $99818ddea2b24ac9$var$MEDIA_API_REGION = 'media-api-region';
const $99818ddea2b24ac9$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $99818ddea2b24ac9$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $iGFGS.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $iGFGS.MAX_RESOLUTION),
            height: (0, $iGFGS.MAX_RESOLUTION)
        } : {}
    };
};
const $99818ddea2b24ac9$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $99818ddea2b24ac9$var$cdnFeatureFlag = (endpoint)=>{
    let result = endpoint;
    if ((0, $ev1Tj.isCDNEnabled)()) result += '/cdn';
    return result;
};
const $99818ddea2b24ac9$var$decodeJwtToken = (token)=>{
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
};
class $99818ddea2b24ac9$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.getArtifactBinary = async (artifacts, artifactName, { collectionName: collectionName, abortController: abortController, maxAge: maxAge = (0, $iGFGS.FILE_CACHE_MAX_AGE), traceContext: traceContext })=>{
            const metadata = {
                method: 'GET',
                endpoint: `artifact-cdn-url`
            };
            const extendedTraceContext = (0, $2tMx2.extendTraceContext)(traceContext);
            const options = {
                ...metadata,
                traceContext: extendedTraceContext
            };
            const artifactUrl = await this.getArtifactURL(artifacts, artifactName, collectionName, maxAge);
            return (0, $euhlJ.request)(artifactUrl, options, abortController).then((0, $2tMx2.createMapResponseToBlob)(metadata));
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const metadata = {
                method: 'POST',
                endpoint: '/file/{fileId}/artifact/binary'
            };
            const headers = {
                Accept: 'application/json',
                'Content-Type': file.type
            };
            const extendedParams = {
                ...params,
                name: file.name,
                collection: collectionName
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                headers: headers,
                params: extendedParams,
                body: file,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/artifact/binary`, options).then((0, $2tMx2.createMapResponseToJson)(metadata));
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            const metadata = {
                method: 'DELETE',
                endpoint: '/file/{fileId}/artifact/{artifactName}'
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                traceContext: traceContext,
                params: {
                    collection: collectionName
                }
            };
            await this.request(`/file/${id}/artifact/${artifactName}`, options);
        };
        this.resolveAuth = (authContext)=>(0, $91qfe.resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $91qfe.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $eyW2Z.ChunkHashAlgorithm).Sha256;
    }
    async getClientId(collectionName) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return $99818ddea2b24ac9$export$572b8a2a9fd7cbba.extractClientIdFromAuth(auth);
    }
    getClientIdSync() {
        try {
            const auth = this.resolveInitialAuth();
            return $99818ddea2b24ac9$export$572b8a2a9fd7cbba.extractClientIdFromAuth(auth);
        } catch  {
            // initialAuth may not be available, return undefined
            return undefined;
        }
    }
    static extractClientIdFromAuth(auth) {
        if ((0, $kO6sh.isClientBasedAuth)(auth)) return auth.clientId;
        // decode JWT token and get clientId (or iss) from payload
        try {
            const jwtPayload = $99818ddea2b24ac9$var$decodeJwtToken(auth.token);
            return jwtPayload.clientId;
        } catch  {
        // leave clientId as undefined
        }
        return undefined;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $2tMx2.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext, options) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const headers = {
            ...$99818ddea2b24ac9$var$jsonHeaders
        };
        if (options?.expectedFileSize !== undefined && (0, $iqfTZ.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: headers,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', requestOptions).then((0, $2tMx2.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext, options) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const headers = {
            ...$99818ddea2b24ac9$var$jsonHeaders
        };
        if (options?.expectedFileSize !== undefined && (0, $iqfTZ.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: headers,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', requestOptions).then((0, $2tMx2.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $2tMx2.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const wmv = (0, $iqfTZ.fg)('confluence_watermark_admin_ui') ? (0, $7oqJN.getWatermarkVersionFromToken)(auth.token) : undefined;
        const options = {
            params: {
                ...$99818ddea2b24ac9$var$extendImageParams(params),
                ...wmv ? {
                    wmv: wmv
                } : {}
            },
            auth: auth
        };
        const imageEndpoint = $99818ddea2b24ac9$var$cdnFeatureFlag('image');
        if ((0, $bf4HK.isPathBasedEnabled)()) return (0, $bf4HK.mapToPathBasedUrl)((0, $2tMx2.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options));
        return (0, $ev1Tj.mapToMediaCdnUrl)((0, $2tMx2.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, abortController, maxAge = (0, $iGFGS.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = $99818ddea2b24ac9$var$cdnFeatureFlag('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, $2tMx2.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $iGFGS.FILE_CACHE_MAX_AGE), name) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge,
                ...name && (0, $1PA5z.expValEquals)('platform_editor_media_download_fallback_name', 'isEnabled', true) ? {
                    name: name
                } : {}
            },
            auth: auth
        };
        const binaryEndpoint = $99818ddea2b24ac9$var$cdnFeatureFlag('binary');
        if ((0, $bf4HK.isPathBasedEnabled)()) return (0, $bf4HK.mapToPathBasedUrl)((0, $2tMx2.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options));
        return (0, $ev1Tj.mapToMediaCdnUrl)((0, $2tMx2.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName, maxAge = (0, $iGFGS.FILE_CACHE_MAX_AGE)) {
        // ----- WARNING ----------
        // DO NOT USE!!!!!
        // artifact.cdnUrl fails in Jira.
        // ----------------------------------
        // getArtifactURL returns a constructed url PATH, not the full Media/CDN Url.
        // We use the provided cdnUrl from metadata first.
        /* if (isCommercial() && fg('platform_media_cdn_delivery')) {
			const cdnUrl = artifacts[artifactName]?.cdnUrl;
			if (cdnUrl) {
				return cdnUrl;
			}
		} */ const artifactUrl = (0, $4HYJj.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const url = (0, $ev1Tj.mapToMediaCdnUrl)((0, $2tMx2.createUrl)(`${auth.baseUrl}${artifactUrl}`, options), auth.token);
        if ((0, $bf4HK.isPathBasedEnabled)()) return (0, $bf4HK.mapToPathBasedUrl)(url);
        return url;
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = $99818ddea2b24ac9$var$cdnFeatureFlag('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        let wmvParams = {};
        let authOptions = {
            authContext: {
                collectionName: params && params.collection
            }
        };
        if ((0, $iqfTZ.fg)('confluence_watermark_admin_ui')) {
            const auth = await this.resolveAuth(authOptions.authContext);
            const wmv = (0, $7oqJN.getWatermarkVersionFromToken)(auth.token);
            if (wmv) wmvParams = {
                wmv: wmv
            };
            authOptions = {
                resolvedAuth: auth
            };
        }
        const options = {
            ...metadata,
            ...authOptions,
            params: {
                ...$99818ddea2b24ac9$var$extendImageParams(params, fetchMaxRes),
                ...wmvParams
            },
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $2tMx2.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $99818ddea2b24ac9$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $2tMx2.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $2tMx2.createMapResponseToJson)(metadata));
    }
    async getDocumentContent(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $99818ddea2b24ac9$var$cdnFeatureFlag('contents') : 'contents';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                pageStart: options.pageStart,
                pageEnd: options.pageEnd,
                'max-age': shouldCache ? (0, $iGFGS.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $2tMx2.createMapResponseToJson)(metadata));
    }
    async getDocumentPageImage(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $99818ddea2b24ac9$var$cdnFeatureFlag('page') : 'page';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                page: options.page,
                zoom: options.zoom,
                'max-age': shouldCache ? (0, $iGFGS.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $2tMx2.createMapResponseToBlob)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext, options) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const headers = {
            ...$99818ddea2b24ac9$var$jsonHeaders
        };
        if (options?.expectedFileSize !== undefined && (0, $iqfTZ.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, requestOptions);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $99818ddea2b24ac9$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $2tMx2.createMapResponseToJson)(metadata));
    }
    copyFile(id, params, traceContext, clientId) {
        const metadata = {
            method: 'POST',
            endpoint: '/v2/file/copy'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $99818ddea2b24ac9$var$jsonHeaders,
            body: JSON.stringify({
                id: id,
                clientId: clientId
            }),
            traceContext: traceContext,
            clientOptions: {
                retryOptions: {
                    shouldRetryError: (err)=>(0, $2tMx2.defaultShouldRetryError)(err) || (0, $ab1R9.isRequestError)(err) && err?.metadata?.statusCode === 401
                }
            }
        };
        return this.request('/v2/file/copy', options).then((0, $2tMx2.createMapResponseToJson)(metadata));
    }
    async registerCopyIntents(files, traceContext, resolvedAuth) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/intents'
        };
        const options = {
            ...metadata,
            headers: $99818ddea2b24ac9$var$jsonHeaders,
            body: JSON.stringify({
                files: files
            }),
            traceContext: traceContext,
            resolvedAuth: resolvedAuth
        };
        await this.request('/file/copy/intents', options);
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam, resolvedAuth: resolvedAuth } = options;
        const auth = resolvedAuth ?? await this.resolveAuth(authContext);
        const clientId = (0, $kO6sh.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = (0, $2tMx2.extendTraceContext)(traceContext);
        const extendedParams = addMediaClientParam ? {
            ...params,
            clientId: clientId
        } : params;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $ev1Tj.mapToMediaCdnUrl)(url, auth.token);
        if ((0, $bf4HK.isPathBasedEnabled)()) url = (0, $bf4HK.mapToPathBasedUrl)(url);
        const response = await (0, $euhlJ.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: extendedParams,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $99818ddea2b24ac9$var$setKeyValueInSessionStorage($99818ddea2b24ac9$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $99818ddea2b24ac9$var$setKeyValueInSessionStorage($99818ddea2b24ac9$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    async testUrl(url, options = {}) {
        const { traceContext: traceContext } = options;
        await (0, $euhlJ.request)(url, {
            method: 'HEAD',
            traceContext: (0, $2tMx2.extendTraceContext)(traceContext),
            clientOptions: {
                retryOptions: {
                    maxAttempts: 1
                }
            }
        });
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $99818ddea2b24ac9$var$getValueFromSessionStorage = (key)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $99818ddea2b24ac9$var$setKeyValueInSessionStorage = (key, value)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    if (!value || !(window && window.sessionStorage)) return;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    window.sessionStorage.setItem(key, value);
};
const $99818ddea2b24ac9$export$c8b741e18397852a = ()=>{
    return $99818ddea2b24ac9$var$getValueFromSessionStorage($99818ddea2b24ac9$var$MEDIA_API_ENVIRONMENT);
};
const $99818ddea2b24ac9$export$20f9315304dd6726 = ()=>{
    return $99818ddea2b24ac9$var$getValueFromSessionStorage($99818ddea2b24ac9$var$MEDIA_API_REGION);
};

});
parcelRegister("iGFGS", function(module, exports) {
$parcel$export(module.exports, "RECENTS_COLLECTION", () => $93276e713e3053f0$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $93276e713e3053f0$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $93276e713e3053f0$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $93276e713e3053f0$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $93276e713e3053f0$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $93276e713e3053f0$export$f14f521f3d306044);
$parcel$export(module.exports, "FILE_READER_FALLBACK_ERROR_NAME", () => $93276e713e3053f0$export$b3e78a9a23c941e9);

var $6a2Ft = parcelRequire("6a2Ft");
const $93276e713e3053f0$export$860a16125e30000b = 'recents';
const $93276e713e3053f0$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $93276e713e3053f0$export$6e70f30e392bc53f = 4096;
const $93276e713e3053f0$export$c1abb8bab1e615cd = 5 * (0, $6a2Ft.DATA_UNIT).MB;
const $93276e713e3053f0$export$3d5157f0def70e54 = 1000;
const $93276e713e3053f0$export$f14f521f3d306044 = 2 * (0, $6a2Ft.DATA_UNIT).TB;
const $93276e713e3053f0$export$b3e78a9a23c941e9 = 'FileReaderError';

});
parcelRegister("6a2Ft", function(module, exports) {
$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $feb1db5978c8fbbd$export$fd27d7abbc4a746d);
$parcel$export(module.exports, "DATA_UNIT", () => $feb1db5978c8fbbd$export$76cfea4c354af843);
const $feb1db5978c8fbbd$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
const $feb1db5978c8fbbd$export$fd27d7abbc4a746d = (itemDetails)=>{
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};
var $feb1db5978c8fbbd$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("4HYJj", function(module, exports) {
$parcel$export(module.exports, "getArtifactUrl", () => $5377b3d23d28d33f$export$1cc24defa44e7f84);

var $ev1Tj = parcelRequire("ev1Tj");
const $5377b3d23d28d33f$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $ev1Tj.isCDNEnabled)() && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
    return artifacts[prop]?.url;
};

});
parcelRegister("ev1Tj", function(module, exports) {
$parcel$export(module.exports, "isCDNEnabled", () => $9f7bc83450b79507$export$3e47d0e609e44278);
$parcel$export(module.exports, "mapToMediaCdnUrl", () => $9f7bc83450b79507$export$fb88a576cf28364d);

var $iqfTZ = parcelRequire("iqfTZ");

var $cBDnr = parcelRequire("cBDnr");

var $lRYAe = parcelRequire("lRYAe");

var $7lmFG = parcelRequire("7lmFG");

var $94Tlr = parcelRequire("94Tlr");

var $bf4HK = parcelRequire("bf4HK");
const $9f7bc83450b79507$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $9f7bc83450b79507$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $9f7bc83450b79507$export$3e47d0e609e44278() {
    return (0, $cBDnr.isCommercial)() && !(0, $lRYAe.isIsolatedCloud)() && !((0, $7lmFG.isGoogleCloudPlatform)() || (0, $94Tlr.isGCPtenant)()) && (0, $iqfTZ.fg)('platform_media_cdn_delivery') && !(0, $bf4HK.isPathBasedEnabled)();
}
function $9f7bc83450b79507$export$fb88a576cf28364d(url, token) {
    const tokenLength = token?.length ?? 0;
    if (!$9f7bc83450b79507$export$3e47d0e609e44278() || tokenLength > $9f7bc83450b79507$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    const isGcpTenant = (0, $7lmFG.isGoogleCloudPlatform)() || (0, $94Tlr.isGCPtenant)();
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if (!isGcpTenant && (0, $iqfTZ.fg)('platform_media_cdn_delivery') && (0, $iqfTZ.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $9f7bc83450b79507$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});
parcelRegister("cBDnr", function(module, exports) {
$parcel$export(module.exports, "isCommercial", () => $cf2db0a62088a8bc$export$df69ff6733e73e50);
function $cf2db0a62088a8bc$export$df69ff6733e73e50() {
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
}

});

parcelRegister("7lmFG", function(module, exports) {
$parcel$export(module.exports, "isGoogleCloudPlatform", () => $c64404b3b93f2d03$export$d62bd105df52518a);


var $bI52x = parcelRequire("bI52x");
function $c64404b3b93f2d03$export$d62bd105df52518a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext?.isInGCP ?? false;
    try {
        const cookies = globalThis.document.cookie;
        const cloudServiceProvider = (0, $bI52x.getRawCookieValue)((0, $8fdfc4bb9d992697$export$74814ca8786924c3), cookies);
        return cloudServiceProvider === (0, $8fdfc4bb9d992697$export$b61e047ddcc35726);
    } catch (e) {
        return false;
    }
}

});
const $8fdfc4bb9d992697$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $8fdfc4bb9d992697$export$f005e2e9f707cb5f = 'commercial';
const $8fdfc4bb9d992697$export$17b81a3d6c98013c = 'isolated-cloud';
const $8fdfc4bb9d992697$export$a739cd5aac835909 = 'staging';
const $8fdfc4bb9d992697$export$42dd0cdd351a4a9 = 'prod';
const $8fdfc4bb9d992697$export$404582bc18fe4d9e = 'dev';
const $8fdfc4bb9d992697$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $8fdfc4bb9d992697$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $8fdfc4bb9d992697$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $8fdfc4bb9d992697$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $8fdfc4bb9d992697$export$b61e047ddcc35726 = 'GCP';
const $8fdfc4bb9d992697$export$1baf17f3e645a2b2 = 'AWS';


parcelRegister("94Tlr", function(module, exports) {
$parcel$export(module.exports, "isGCPtenant", () => $5803681f9126841b$export$1e98abd71682b665);
/**
 * Returns true if the current hostname matches the GCP tenant pattern.
 * GCP tenants follow the pattern: <name>-cdp-<cdp-id>.jira-dev.com
 *
 * CDN (CloudFront) is an AWS service and is not available on GCP tenants.
 * This function is used to gate CDN delivery, mirroring the isIsolatedCloud() pattern.
 *
 * @deprecated This is a staging-only hostname heuristic and should not be used for
 * new code. Prefer `isGoogleCloudPlatform()` from `@atlaskit/atlassian-context/cloud-provider`
 * (cookie/SSR-based) to detect GCP tenants. This helper is retained only as a fallback for
 * staging tenants, which do not reliably have a proper value for the
 * `Bifrost-Atl-Ctx-Cloud-Service-Provider` cookie.
 *
 * @param hostname - Optional hostname override (defaults to globalThis.location?.hostname). Used for testing.
 */ function $5803681f9126841b$export$1e98abd71682b665(hostname) {
    const host = hostname ?? (typeof globalThis !== 'undefined' ? globalThis.location?.hostname : undefined);
    if (!host) return false;
    const gcpTenantPattern = /^.*-cdp-\w+\.jira-dev\.com$/;
    return gcpTenantPattern.test(host);
}

});

parcelRegister("bf4HK", function(module, exports) {
$parcel$export(module.exports, "isPathBasedEnabled", () => $d9949ad4758d4675$export$6de3392754e98e65);
$parcel$export(module.exports, "mapToPathBasedUrl", () => $d9949ad4758d4675$export$774e2add1fbe26aa);
$parcel$export(module.exports, "mapRetryUrlToPathBasedUrl", () => $d9949ad4758d4675$export$e71b0af0000b3cfa);

var $iqfTZ = parcelRequire("iqfTZ");

var $9v2so = parcelRequire("9v2so");
const $d9949ad4758d4675$var$mediaApiPathPrefix = '/media-api';
function $d9949ad4758d4675$var$getRelativeUrl(absoluteUrl) {
    const url = new URL(absoluteUrl);
    return `${url.pathname}${url.search}${url.hash}`;
}
function $d9949ad4758d4675$export$6de3392754e98e65() {
    const isLocalhost = (0, $9v2so.default)()?.location?.hostname === 'localhost';
    return (0, $iqfTZ.fg)('platform_media_path_based_route') && !isLocalhost;
}
function $d9949ad4758d4675$export$774e2add1fbe26aa(url) {
    if ($d9949ad4758d4675$export$6de3392754e98e65()) {
        const parsedUrl = new URL(url);
        if (!parsedUrl.pathname.startsWith($d9949ad4758d4675$var$mediaApiPathPrefix)) parsedUrl.pathname = `${$d9949ad4758d4675$var$mediaApiPathPrefix}${parsedUrl.pathname}`;
        const location = (0, $9v2so.default)()?.location;
        // in this case we are most likely in SSR / a non browser environment so just return a relative URL
        if (!location) return $d9949ad4758d4675$var$getRelativeUrl(parsedUrl.toString());
        parsedUrl.host = location.host;
        return parsedUrl.toString();
    }
    return url;
}
function $d9949ad4758d4675$export$e71b0af0000b3cfa(url) {
    const parsedUrl = new URL(url);
    parsedUrl.host = (0, $9v2so.default)()?.location.host ?? '';
    // remove CDN from the URL for retry if it exists
    const pathname = parsedUrl.pathname;
    if (pathname.endsWith('/cdn')) parsedUrl.pathname = pathname.replace('/cdn', '');
    if (!parsedUrl.pathname.startsWith($d9949ad4758d4675$var$mediaApiPathPrefix)) parsedUrl.pathname = `${$d9949ad4758d4675$var$mediaApiPathPrefix}${parsedUrl.pathname}`;
    return parsedUrl;
}

});
parcelRegister("9v2so", function(module, exports) {
$parcel$export(module.exports, "default", () => $46a76a8ca1a56b68$export$2e2bcd8739ae039);
var $46a76a8ca1a56b68$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});




parcelRegister("ab1R9", function(module, exports) {
$parcel$export(module.exports, "RequestError", () => $f415f7a07d10cee4$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $f415f7a07d10cee4$export$3717b1ffef4428ea);

var $cTY6x = parcelRequire("cTY6x");
class $f415f7a07d10cee4$export$43ee7d0e4f429743 extends (0, $cTY6x.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            metadata: {
                traceContext: traceContext
            },
            innerError: innerError
        };
    }
}
function $f415f7a07d10cee4$export$3717b1ffef4428ea(err) {
    return err instanceof $f415f7a07d10cee4$export$43ee7d0e4f429743;
}

});
parcelRegister("cTY6x", function(module, exports) {
$parcel$export(module.exports, "BaseMediaClientError", () => $f15340a1bc0ec0e5$export$2b0aca14d61c3190);
$parcel$export(module.exports, "CommonMediaClientError", () => $f15340a1bc0ec0e5$export$e574d1724215079f);
$parcel$export(module.exports, "isCommonMediaClientError", () => $f15340a1bc0ec0e5$export$881f0f9bc813e1f3);
$parcel$export(module.exports, "toCommonMediaClientError", () => $f15340a1bc0ec0e5$export$a5db89cfc88eff9);
$parcel$export(module.exports, "fromCommonMediaClientError", () => $f15340a1bc0ec0e5$export$c2b89b9a32286816);

var $8kY0g = parcelRequire("8kY0g");
class $f15340a1bc0ec0e5$export$2b0aca14d61c3190 extends Error {
    constructor(reason, metadata, innerError){
        super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $f15340a1bc0ec0e5$export$e574d1724215079f extends $f15340a1bc0ec0e5$export$2b0aca14d61c3190 {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    get attributes() {
        return {
            reason: this.reason
        };
    }
}
function $f15340a1bc0ec0e5$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof $f15340a1bc0ec0e5$export$e574d1724215079f) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}
const $f15340a1bc0ec0e5$export$a5db89cfc88eff9 = (errorFileState)=>{
    const error = errorFileState.details?.error;
    return new $f15340a1bc0ec0e5$export$e574d1724215079f(error?.reason || 'unknown-reason', error?.metadata, error?.innerError);
};
const $f15340a1bc0ec0e5$export$c2b89b9a32286816 = (id, occurrenceKey, error)=>{
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: {
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error?.reason,
                metadata: error?.metadata,
                innerError: error?.innerError
            },
            // Legacy details
            ...error?.attributes
        },
        message: error?.message
    };
};

});
parcelRegister("8kY0g", function(module, exports) {
$parcel$export(module.exports, "getMediaClientErrorReason", () => $f7c922243ddc1012$export$c15d72765ee2baa4);
function $f7c922243ddc1012$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $f7c922243ddc1012$export$c15d72765ee2baa4(err) {
    return $f7c922243ddc1012$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("euhlJ", function(module, exports) {
$parcel$export(module.exports, "request", () => $320e875b30ab3c4d$export$b5fe3f66a567bec0);

var $ab1R9 = parcelRequire("ab1R9");

var $2tMx2 = parcelRequire("2tMx2");

var $iqfTZ = parcelRequire("iqfTZ");

var $bf4HK = parcelRequire("bf4HK");

var $a3JiQ = parcelRequire("a3JiQ");
async function $320e875b30ab3c4d$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $2tMx2.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $2tMx2.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $2tMx2.createProcessFetchResponse)(metadata));
    if ((0, $iqfTZ.fg)('platform_media_retry_edge_error')) {
        const shouldRetryError = (err)=>{
            if ((0, $2tMx2.isFetchNetworkError)(err) && (0, $a3JiQ.default)()?.userAgent.includes('Edg/')) return false;
            return (0, $2tMx2.defaultShouldRetryError)(err);
        };
        try {
            return await (0, $2tMx2.fetchRetry)(doFetch, metadata, {
                ...retryOptions,
                shouldRetryError: shouldRetryError
            });
        } catch (error) {
            if ((0, $2tMx2.isFetchNetworkError)(error) && (0, $a3JiQ.default)()?.userAgent.includes('Edg/')) {
                const doFetchWithPathBasedUrl = ()=>fetch((0, $2tMx2.createUrl)((0, $bf4HK.mapRetryUrlToPathBasedUrl)(url).toString(), {
                        params: params
                    }), {
                        method: method,
                        body: body,
                        headers: (0, $2tMx2.extendHeaders)(headers, auth, traceContext),
                        signal: controller && controller.signal
                    }).then((0, $2tMx2.createProcessFetchResponse)(metadata));
                return (0, $2tMx2.fetchRetry)(doFetchWithPathBasedUrl, metadata, retryOptions);
            }
            throw error;
        }
    }
    return (0, $2tMx2.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("2tMx2", function(module, exports) {
$parcel$export(module.exports, "isFetchNetworkError", () => $48ebe0b5795221b0$export$ad8c5cf7dd4c3caf);
$parcel$export(module.exports, "extendTraceContext", () => $48ebe0b5795221b0$export$ee24a95986dfd173);
$parcel$export(module.exports, "createUrl", () => $48ebe0b5795221b0$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $48ebe0b5795221b0$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $48ebe0b5795221b0$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $48ebe0b5795221b0$export$5cc7b0795397da86);
$parcel$export(module.exports, "defaultShouldRetryError", () => $48ebe0b5795221b0$export$fee2242cbb339663);
$parcel$export(module.exports, "fetchRetry", () => $48ebe0b5795221b0$export$782df2acbe10b22c);
$parcel$export(module.exports, "createProcessFetchResponse", () => $48ebe0b5795221b0$export$6e2e477edb7d6032);
parcelRequire("dnJXJ");
var $kO6sh = parcelRequire("kO6sh");

var $gXaBe = parcelRequire("gXaBe");

var $aJAxu = parcelRequire("aJAxu");

var $ab1R9 = parcelRequire("ab1R9");
const $48ebe0b5795221b0$var$getStatusCode = (error)=>(0, $ab1R9.isRequestError)(error) && error.metadata?.statusCode && error.metadata.statusCode;
function $48ebe0b5795221b0$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $48ebe0b5795221b0$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $48ebe0b5795221b0$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $48ebe0b5795221b0$export$bc96a6a479480590(error) {
    const statusCode = error && $48ebe0b5795221b0$var$getStatusCode(error);
    return statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $48ebe0b5795221b0$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
        ...traceContext,
        spanId: traceContext?.spanId || (0, $gXaBe.getRandomTelemetryId)()
    } : undefined;
const $48ebe0b5795221b0$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $48ebe0b5795221b0$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$48ebe0b5795221b0$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$48ebe0b5795221b0$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $48ebe0b5795221b0$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $kO6sh.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $48ebe0b5795221b0$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $aJAxu.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.set(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $48ebe0b5795221b0$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$48ebe0b5795221b0$export$eaf4479116d2f925(auth),
        ...$48ebe0b5795221b0$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $48ebe0b5795221b0$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $ab1R9.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$48ebe0b5795221b0$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $48ebe0b5795221b0$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $ab1R9.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$48ebe0b5795221b0$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $48ebe0b5795221b0$export$fee2242cbb339663 = (err)=>{
    const statusCode = $48ebe0b5795221b0$var$getStatusCode(err);
    return $48ebe0b5795221b0$export$ad8c5cf7dd4c3caf(err) || (statusCode ? statusCode >= 500 : false);
};
const $48ebe0b5795221b0$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $48ebe0b5795221b0$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $ab1R9.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $48ebe0b5795221b0$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$48ebe0b5795221b0$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor, shouldRetryError: shouldRetryError = $48ebe0b5795221b0$export$fee2242cbb339663 } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $48ebe0b5795221b0$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($48ebe0b5795221b0$export$de0b576cf7ce4a53(err)) throw new (0, $ab1R9.RequestError)('clientAbortedRequest', metadata, err);
        if (!shouldRetryError(err)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $ab1R9.isRequestError)(lastError)) throw $48ebe0b5795221b0$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $ab1R9.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $48ebe0b5795221b0$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 422:
            return 'serverUnprocessableEntity';
        case 423:
            return 'serverEntityLocked';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $48ebe0b5795221b0$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $48ebe0b5795221b0$export$6397609af718d008(statusCode);
    return new (0, $ab1R9.RequestError)(reason, {
        ...metadata,
        ...$48ebe0b5795221b0$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $48ebe0b5795221b0$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $48ebe0b5795221b0$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $48ebe0b5795221b0$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("gXaBe", function(module, exports) {
$parcel$export(module.exports, "isUndefined", () => $5ee29efb3dda67e6$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $5ee29efb3dda67e6$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $5ee29efb3dda67e6$export$456b25e3a9b4a843);
$parcel$export(module.exports, "getRandomTelemetryId", () => $5ee29efb3dda67e6$export$2e36de8639bad0ad);
const $5ee29efb3dda67e6$export$fce6876652108ab = (value)=>value === undefined;
const $5ee29efb3dda67e6$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $5ee29efb3dda67e6$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $5ee29efb3dda67e6$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $5ee29efb3dda67e6$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $5ee29efb3dda67e6$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $5ee29efb3dda67e6$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $5ee29efb3dda67e6$var$getRandomHexValues(byte);
    }
    else randomHex = $5ee29efb3dda67e6$var$getRandomHexValues(byte);
    return randomHex;
}
function $5ee29efb3dda67e6$export$2e36de8639bad0ad() {
    return $5ee29efb3dda67e6$export$456b25e3a9b4a843(8);
}

});

parcelRegister("aJAxu", function(module, exports) {
$parcel$export(module.exports, "mapAuthToQueryParameters", () => $3148900cd48d43bf$export$6833b130611df767);
parcelRequire("dnJXJ");
var $kO6sh = parcelRequire("kO6sh");
function $3148900cd48d43bf$export$6833b130611df767(auth) {
    if ((0, $kO6sh.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});


parcelRegister("a3JiQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac900721ff52f47c$export$2e2bcd8739ae039);
var $ac900721ff52f47c$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.navigator === 'undefined') return;
    return window.navigator;
};

});


parcelRegister("91qfe", function(module, exports) {
$parcel$export(module.exports, "resolveAuth", () => $62bb7e17260d5ecc$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $62bb7e17260d5ecc$export$5211e1371264aec3);

var $iqfTZ = parcelRequire("iqfTZ");

var $4HOa3 = parcelRequire("4HOa3");

var $5Gbkk = parcelRequire("5Gbkk");

var $lbsPG = parcelRequire("lbsPG");
const $62bb7e17260d5ecc$export$560085fe411c0660 = 10000;
const $62bb7e17260d5ecc$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $62bb7e17260d5ecc$export$560085fe411c0660)=>{
    const startTime = performance.now();
    let eventEmitted = false;
    // Feature flag: wrap authProvider with analytics event emission
    const authProviderPromise = (0, $iqfTZ.fg)('platform_media_auth_provider_analytics') ? authProvider(authContext).then((result)=>{
        const durationMs = performance.now() - startTime;
        if (!eventEmitted) {
            eventEmitted = true;
            (0, $lbsPG.globalMediaEventEmitter).emit('auth-provider-succeeded', {
                durationMs: durationMs,
                timeoutMs: authProviderTimeout,
                authContext: authContext
            });
        } else {
            // Timeout already fired - auth arrived too late
            const timeoutError = new (0, $4HOa3.MediaStoreError)('authProviderTimedOut');
            (0, $lbsPG.globalMediaEventEmitter).emit('auth-provider-failed', {
                durationMs: durationMs,
                timeoutMs: authProviderTimeout,
                authContext: authContext,
                error: timeoutError
            });
        }
        return result;
    }).catch((error)=>{
        const durationMs = performance.now() - startTime;
        eventEmitted = true;
        (0, $lbsPG.globalMediaEventEmitter).emit('auth-provider-failed', {
            durationMs: durationMs,
            timeoutMs: authProviderTimeout,
            authContext: authContext,
            error: error
        });
        throw error;
    }) : authProvider(authContext); // Original behavior when FG off
    let auth;
    try {
        auth = await Promise.race([
            authProviderPromise,
            (0, $5Gbkk.rejectTimeout)(authProviderTimeout, new (0, $4HOa3.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        // Mark as emitted so late arrivals are handled correctly by .then()/.catch()
        if (!eventEmitted && (0, $iqfTZ.fg)('platform_media_auth_provider_analytics')) eventEmitted = true;
        // PRESERVE ORIGINAL ERROR HANDLING
        if (err instanceof (0, $4HOa3.MediaStoreError)) throw err;
        throw new (0, $4HOa3.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $4HOa3.MediaStoreError)('emptyAuth');
    /*
	Only client-based auth carries a clientId. Fail fast when it is present but empty, instead of
	letting the request reach dt-auth and get rejected with `Client id "" is invalid`.
  */ if ('clientId' in auth && !auth.clientId && (0, $iqfTZ.fg)('platform_media_validate_client_id')) throw new (0, $4HOa3.MediaStoreError)('emptyClientId');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $62bb7e17260d5ecc$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $4HOa3.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("4HOa3", function(module, exports) {
$parcel$export(module.exports, "MediaStoreError", () => $770575b9e21081a2$export$b78480bd311630bc);

var $cTY6x = parcelRequire("cTY6x");
class $770575b9e21081a2$export$b78480bd311630bc extends (0, $cTY6x.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason, undefined, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $770575b9e21081a2$export$8d2a9b675b2ce37a(err) {
    return err instanceof $770575b9e21081a2$export$b78480bd311630bc;
}

});

parcelRegister("5Gbkk", function(module, exports) {
$parcel$export(module.exports, "rejectTimeout", () => $7831f1002b5c0f53$export$cf2d2a1124beacb2);
const $7831f1002b5c0f53$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $7831f1002b5c0f53$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});

parcelRegister("lbsPG", function(module, exports) {
$parcel$export(module.exports, "globalMediaEventEmitter", () => $b4d08157f8b3d83a$export$68d003d3105952ad);
parcelRequire("dnJXJ");
var $7PqSD = parcelRequire("7PqSD");
const $b4d08157f8b3d83a$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $7PqSD.mediaState).eventEmitter) (0, $7PqSD.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $7PqSD.mediaState).eventEmitter) (0, $7PqSD.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $7PqSD.mediaState).eventEmitter) return (0, $7PqSD.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});


parcelRegister("7oqJN", function(module, exports) {
$parcel$export(module.exports, "getWatermarkVersionFromToken", () => $1ac750e405f1b17f$export$5296269cf74e58e);
function $1ac750e405f1b17f$export$5296269cf74e58e(token) {
    try {
        const parts = token.split('.');
        if (parts.length < 2) return undefined;
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        if (!payload.watermark) return undefined;
        const watermarkData = JSON.parse(payload.watermark);
        return watermarkData.v;
    } catch  {
        return undefined;
    }
}

});


parcelRegister("dH5I0", function(module, exports) {
$parcel$export(module.exports, "FileFetcherImpl", () => $f7a3070aefc738a0$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("a0yue")).FileFetcherError);

var $lkLFz = parcelRequire("lkLFz");

var $dAgSf = parcelRequire("dAgSf");

var $6IpLl = parcelRequire("6IpLl");
parcelRequire("dnJXJ");
var $a8jgR = parcelRequire("a8jgR");

var $ghm2v = parcelRequire("ghm2v");

var $309fS = parcelRequire("309fS");

var $1PA5z = parcelRequire("1PA5z");

var $hXVBO = parcelRequire("hXVBO");

var $f53AU = parcelRequire("f53AU");

var $6a2Ft = parcelRequire("6a2Ft");

var $a0yue = parcelRequire("a0yue");

var $7AWNM = parcelRequire("7AWNM");

var $9CNsj = parcelRequire("9CNsj");

var $lbsPG = parcelRequire("lbsPG");

var $iGFGS = parcelRequire("iGFGS");

var $heFMZ = parcelRequire("heFMZ");

var $bsuz1 = parcelRequire("bsuz1");

var $6gese = parcelRequire("6gese");

var $9U29T = parcelRequire("9U29T");

var $3G5hJ = parcelRequire("3G5hJ");
var $gLnvu = parcelRequire("gLnvu");

var $jXtvt = parcelRequire("jXtvt");

var $9RXrz = parcelRequire("9RXrz");

var $KY3oR = parcelRequire("KY3oR");

var $cSqIk = parcelRequire("cSqIk");

var $1AkSq = parcelRequire("1AkSq");

var $fphkZ = parcelRequire("fphkZ");

var $grIM4 = parcelRequire("grIM4");

var $15k4Y = parcelRequire("15k4Y");

var $2tMx2 = parcelRequire("2tMx2");

var $cTY6x = parcelRequire("cTY6x");
const $f7a3070aefc738a0$var$isCopySourceFileWithToken = (token)=>!!token.authProvider;
const $f7a3070aefc738a0$var$isCopyDestinationWithToken = (token)=>!!token.authProvider;
class $f7a3070aefc738a0$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $grIM4.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>{
            if ((0, $cTY6x.isCommonMediaClientError)(error)) return (0, $cTY6x.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                const err = new (0, $cTY6x.CommonMediaClientError)(error);
                return (0, $cTY6x.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                const err = new (0, $cTY6x.CommonMediaClientError)(error?.reason || 'unknown', error?.metadata, error?.innerError);
                return (0, $cTY6x.fromCommonMediaClientError)(id, occurrenceKey, err);
            }
        };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        // TODO: ----- ADD TICKET TO PASS TRACE ID to this.dataloader.load
        this.createDownloadFileStream = (id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh, initialFileState)=>{
            const subject = (0, $9RXrz.createMediaSubject)(initialFileState);
            const poll = new (0, $1AkSq.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                if (!forceRefresh && initialFileState?.status === 'processed') {
                    subject.complete();
                    return;
                }
                if (forceRefresh) this.dataloader.clear({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                if ((0, $6a2Ft.isNotFoundMediaItemDetails)(response)) throw new (0, $a0yue.FileFetcherError)('emptyItems', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                if ((0, $fphkZ.isEmptyFile)(response)) throw new (0, $a0yue.FileFetcherError)('zeroVersionFile', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                const fileState = (0, $f53AU.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $9U29T.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $bsuz1.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const { data: data } = await this.mediaApi.uploadArtifact(id, file, params, collectionName, traceContext);
            /* TEMPORARYLY PULLING NEW METADATA till the endpoint is fixed */ const { data: altData } = await this.mediaApi.getItems([
                id
            ], collectionName, traceContext);
            const itemDetails = altData.items[0].details;
            // ------------------------------------------------------------
            this.setFileState(id, (0, $f53AU.mapMediaItemToFileState)(id, itemDetails));
            return data;
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            await this.mediaApi.deleteArtifact(id, artifactName, collectionName, traceContext);
            // Manually remove the artifact from file state instead of re-requesting the entire payload.
            const file = this.store.getState().files[id];
            if (file && file.status === 'processed' && file.artifacts) {
                const updatedArtifacts = {
                    ...file.artifacts
                };
                delete updatedArtifacts[artifactName];
                const updatedFileState = {
                    ...file,
                    artifacts: updatedArtifacts
                };
                this.setFileState(id, updatedFileState);
            }
        };
        this.getOrFetchFileState = async (id, collectionName)=>{
            let fileState = this.store.getState().files[id];
            return fileState ?? await this.getCurrentState(id, {
                collectionName: collectionName
            });
        };
        this.getDurationOfVideo = async (id, collectionName)=>{
            const fileState = await this.getOrFetchFileState(id, collectionName);
            if (fileState.status !== 'processed' || fileState.mediaType !== 'video' || !fileState.artifacts['video.mp4']) throw new Error('File is not a video');
            if ('mediaMetadata' in fileState && fileState.mediaMetadata?.duration) return fileState.mediaMetadata.duration;
            // If the duration is not present, we need to fetch it from the artifact
            const artifactUrlString = await this.getArtifactURL(fileState.artifacts, 'video.mp4', collectionName);
            const artifactUrl = new URL(artifactUrlString);
            const artifactPath = `${artifactUrl.pathname}${artifactUrl.search}`;
            const res = await this.mediaApi.request(artifactPath, {
                headers: {
                    Range: 'bytes=0-199'
                }
            });
            // Get the response as ArrayBuffer
            const arrayBuffer = await res.arrayBuffer();
            const uint8Array = new Uint8Array(arrayBuffer);
            const mvhdBytes = new Uint8Array([
                109,
                118,
                104,
                100
            ]); // "mvhd" in ASCII
            let mvhdIndex = -1;
            for(let i = 0; i <= uint8Array.length - mvhdBytes.length; i++){
                mvhdIndex = i;
                for(let j = 0; j < mvhdBytes.length; j++)if (uint8Array[i + j] !== mvhdBytes[j]) {
                    mvhdIndex = -1;
                    break;
                }
                if (mvhdIndex !== -1) break;
            }
            if (mvhdIndex === -1) throw new Error('Unable to find mvhd bytes');
            // Create DataView for reading big-endian integers
            const dataView = new DataView(arrayBuffer);
            const start = mvhdIndex + 16; // Skip atom header and version/flags
            // Check if we have enough bytes to read timescale and duration
            if (start + 8 > arrayBuffer.byteLength) return 0;
            // flase as second parameter indicates big-endian 32-bit integers
            const timeScale = dataView.getUint32(start, false);
            const duration = dataView.getUint32(start + 4, false);
            if (timeScale === 0) throw new Error('Timescale is invalid');
            // get the video length in seconds
            const videoLength = Math.floor(duration / timeScale);
            return videoLength;
        };
        this.getVideoDurations = async (files)=>{
            // get all the duration promises
            const promises = files.map(async ({ id: id, collectionName: collectionName })=>{
                try {
                    return await this.getDurationOfVideo(id, collectionName);
                } catch  {
                    return -1;
                }
            });
            const durations = await Promise.all(promises);
            // only return the durations that are present;
            return durations.reduce((acc, curr, i)=>{
                if (curr !== -1) {
                    const id = files[i].id;
                    acc[id] = curr;
                }
                return acc;
            }, {});
        };
        this.dataloader = (0, $heFMZ.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $15k4Y.createCopyIntentRegisterationBatcher)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey, includeHashForDuplicateFiles: includeHashForDuplicateFiles, forceRefresh: forceRefresh, initialFileState: initialFileState } = options;
        if (!(0, $ghm2v.isValidUuid)(id)) {
            // Do NOT pass initialFileState here — for an invalid UUID the SSR seed
            // is meaningless and would cause subscribers to briefly see a
            // valid-looking file state before the error is emitted.
            const subject = (0, $9RXrz.createMediaSubject)();
            const err = new (0, $a0yue.FileFetcherError)('invalidFileId', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $3G5hJ.fromObservable)(subject);
        }
        if (forceRefresh) (0, $9CNsj.getFileStreamsCache)().remove(id);
        return (0, $3G5hJ.fromObservable)((0, $9CNsj.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh, initialFileState);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $gLnvu.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge, name) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge, name);
    }
    touchFiles(descriptors, collection, traceContext, expectedFileSize) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext, {
            expectedFileSize: expectedFileSize
        }).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext, expectedFileSize) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($6IpLl)))();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($6IpLl)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext, expectedFileSize).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext, anonymizeFilename) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $9RXrz.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = anonymizeFilename ? crypto.randomUUID() : url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $9CNsj.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $KY3oR.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $jXtvt.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext, file.size);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $9RXrz.createMediaSubject)();
        (0, $9CNsj.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $lkLFz.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $dAgSf.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $6gese.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $7AWNM.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $3G5hJ.fromObservable)(subject);
    }
    async downloadBinary(id, name, collectionName, traceContext) {
        const downloadName = name ?? 'download';
        const url = (0, $1PA5z.expValEquals)('platform_editor_media_download_fallback_name', 'isEnabled', true) ? await this.mediaApi.getFileBinaryURL(id, collectionName, undefined, name) : await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $309fS.downloadUrl)(url, {
            name: downloadName
        });
        (0, $lbsPG.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $iGFGS.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
        // Test the download after initiated the Browser process to catch any potential errors.
        await this.mediaApi.testUrl(url, {
            traceContext: traceContext
        });
    }
    async registerCopyIntent(id, collectionName) {
        // pre-resolving auth to add it to the key
        const auth = await this.mediaApi.resolveAuth({
            collectionName: collectionName
        });
        const key = {
            id: id,
            collectionName: collectionName,
            resolvedAuth: auth
        };
        const error = await this.copyIntentRegisterationBatcher.load(key);
        if (error) {
            // if the error is retryable then it should not be cached
            if ((0, $2tMx2.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
            throw error;
        }
    }
    async copyFileWithToken(source, destination, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const mediaStore = destination.mediaStore || new (0, $hXVBO.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $a8jgR.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const { data: data } = await mediaStore.copyFileWithToken(body, params, traceContext);
        return data;
    }
    async copyFileWithIntent(source, destination, traceContext) {
        const res = await this.mediaApi.copyFile(source.id, {
            sourceCollection: source.collection,
            collection: destination.collection,
            replaceFileId: destination.replaceFileId
        }, traceContext, source.clientId);
        const { data: data } = res;
        return data;
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { id: id } = source;
        const { collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const cache = (0, $9CNsj.getFileStreamsCache)();
        let processingSubscription;
        try {
            let copiedFile;
            if ($f7a3070aefc738a0$var$isCopySourceFileWithToken(source) && $f7a3070aefc738a0$var$isCopyDestinationWithToken(destination)) copiedFile = await this.copyFileWithToken(source, destination, traceContext);
            else copiedFile = await this.copyFileWithIntent(source, destination, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $KY3oR.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $f53AU.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $9RXrz.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $f53AU.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $f53AU.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $cSqIk.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $6gese.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $6gese.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $f53AU.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $f53AU.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $f53AU.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $9CNsj.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $9RXrz.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("ghm2v", function(module, exports) {
$parcel$export(module.exports, "isValidUuid", () => $e51b2c2bd8792d3e$export$6ad459db9a6bcc76);
const $e51b2c2bd8792d3e$var$BASIC_UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const $e51b2c2bd8792d3e$export$6ad459db9a6bcc76 = (value)=>{
    if (typeof value !== 'string') return false;
    const normalizedValue = value.toLowerCase();
    if (!$e51b2c2bd8792d3e$var$BASIC_UUID_REGEX.test(normalizedValue)) return false;
    const version = normalizedValue[14];
    if (version === '1' || version === '2') return true;
    if (version === '3' || version === '4' || version === '5') {
        const variant = normalizedValue[19];
        return variant === '8' || variant === '9' || variant === 'a' || variant === 'b';
    }
    return false;
};

});

parcelRegister("309fS", function(module, exports) {
$parcel$export(module.exports, "downloadUrl", () => $d469b3373d827449$export$8a96edb1c96563f4);
const $d469b3373d827449$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("f53AU", function(module, exports) {
$parcel$export(module.exports, "isUploadingFileState", () => $aa2bef81607d3c1b$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $aa2bef81607d3c1b$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $aa2bef81607d3c1b$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $aa2bef81607d3c1b$export$f863e1e09c8a926);
$parcel$export(module.exports, "isFinalFileState", () => $aa2bef81607d3c1b$export$270b3fc27120edd0);
$parcel$export(module.exports, "isNonErrorFinalFileState", () => $aa2bef81607d3c1b$export$8f33148a37b0c72f);
$parcel$export(module.exports, "hasArtifacts", () => $aa2bef81607d3c1b$export$ecdf3dee1d148302);
$parcel$export(module.exports, "isImageRepresentationReady", () => $aa2bef81607d3c1b$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $aa2bef81607d3c1b$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $aa2bef81607d3c1b$export$ea3730792e8bebfb);
const $aa2bef81607d3c1b$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $aa2bef81607d3c1b$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $aa2bef81607d3c1b$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $aa2bef81607d3c1b$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $aa2bef81607d3c1b$export$92dd692b31e42e64 = (fileState)=>!$aa2bef81607d3c1b$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $aa2bef81607d3c1b$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $aa2bef81607d3c1b$export$8f33148a37b0c72f = (fileState)=>[
        'processed',
        'failed-processing'
    ].includes(fileState.status);
const $aa2bef81607d3c1b$export$ecdf3dee1d148302 = (fileState)=>'artifacts' in fileState && fileState.artifacts !== undefined;
const $aa2bef81607d3c1b$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $aa2bef81607d3c1b$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext, hash: hash, abuseClassification: abuseClassification, mediaMetadata: mediaMetadata, failReason: failReason, previewCdnUrl: previewCdnUrl } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification,
        mediaMetadata: mediaMetadata,
        previewCdnUrl: previewCdnUrl
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing',
                failReason: failReason
            };
    }
};
const $aa2bef81607d3c1b$export$ea3730792e8bebfb = (id, item)=>{
    return $aa2bef81607d3c1b$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("a0yue", function(module, exports) {
$parcel$export(module.exports, "FileFetcherError", () => $ec6185ee27cd9e28$export$e3e60f0dab8641de);

var $cTY6x = parcelRequire("cTY6x");
class $ec6185ee27cd9e28$export$e3e60f0dab8641de extends (0, $cTY6x.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            ...traceContext && {
                metadata: {
                    traceContext: traceContext
                }
            }
        };
    }
}
function $ec6185ee27cd9e28$export$5c3435f75ce0ce70(err) {
    return err instanceof $ec6185ee27cd9e28$export$e3e60f0dab8641de;
}

});

parcelRegister("7AWNM", function(module, exports) {
$parcel$export(module.exports, "uploadFile", () => $2508ad5092fb6a36$export$a5575dbeeffdad98);

var $9ipLB = parcelRequire("9ipLB");

var $gDVn3 = parcelRequire("gDVn3");

var $aCHyH = parcelRequire("aCHyH");

var $lc1TD = parcelRequire("lc1TD");

var $ktAC9 = parcelRequire("ktAC9");

var $iGFGS = parcelRequire("iGFGS");

var $2tq8R = parcelRequire("2tq8R");
const $2508ad5092fb6a36$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $lc1TD.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $2508ad5092fb6a36$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $2508ad5092fb6a36$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext, size)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $2508ad5092fb6a36$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext, {
            expectedFileSize: size
        });
        offset += chunks.length;
    };
};
const $2508ad5092fb6a36$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext, {
        expectedFileSize: file.size
    });
};
const $2508ad5092fb6a36$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $iGFGS.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $2tq8R.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $2tq8R.fileSizeError)) callbacks?.onUploadFinish(new (0, $ktAC9.UploaderError)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $9ipLB.chunkinator)(content, {
        hashingFunction: (blob)=>$2508ad5092fb6a36$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $2508ad5092fb6a36$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $iGFGS.PROCESSING_BATCH_SIZE),
        processingFunction: $2508ad5092fb6a36$var$createProcessingFunction(store, deferredUploadId, collection, traceContext, file.size)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $gDVn3.from)(deferredUploadId).pipe((0, $aCHyH.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $aCHyH.concatMap)(()=>(0, $gDVn3.from)($2508ad5092fb6a36$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $2508ad5092fb6a36$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("9ipLB", function(module, exports) {
$parcel$export(module.exports, "chunkinator", () => $d5a458e8dc4835ac$export$9ab6bef3838698f8);

var $3J3dy = parcelRequire("3J3dy");

var $aCHyH = parcelRequire("aCHyH");

var $7lzMj = parcelRequire("7lzMj");

var $eoo15 = parcelRequire("eoo15");

var $eiby4 = parcelRequire("eiby4");

var $c4XFR = parcelRequire("c4XFR");

var $4HgqG = parcelRequire("4HgqG");

var $bWj1f = parcelRequire("bWj1f");

var $czSp6 = parcelRequire("czSp6");

var $gDVn3 = parcelRequire("gDVn3");
const $d5a458e8dc4835ac$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $eoo15.fromPromise)((0, $czSp6.fetchBlob)(file)).pipe((0, $aCHyH.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $eiby4.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $c4XFR.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $4HgqG.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $3J3dy.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $bWj1f.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $aCHyH.concatMap)((batchedChunks)=>{
            return (0, $gDVn3.from)(batchedChunks);
        }), (0, $7lzMj.bufferCount)(totalChunks));
    }));
const $d5a458e8dc4835ac$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $d5a458e8dc4835ac$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("eiby4", function(module, exports) {
$parcel$export(module.exports, "slicenator", () => $39aec6976f5d56fc$export$5b92d769f2f57509);

var $5LUxV = parcelRequire("5LUxV");

var $dAgSf = parcelRequire("dAgSf");
const $39aec6976f5d56fc$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $5LUxV.range)(0, totalChunks).pipe((0, $dAgSf.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("c4XFR", function(module, exports) {
$parcel$export(module.exports, "hashinator", () => $19175708de712b2a$export$d5f5a550a38ec367);

var $czSp6 = parcelRequire("czSp6");
const $19175708de712b2a$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $19175708de712b2a$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $czSp6.asyncMap)($19175708de712b2a$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("czSp6", function(module, exports) {
$parcel$export(module.exports, "fetchBlob", () => $db6b87084e372b41$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $db6b87084e372b41$export$707ee4c4c95d39e3);

var $dmX0B = parcelRequire("dmX0B");

var $f8gPD = parcelRequire("f8gPD");
async function $db6b87084e372b41$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $db6b87084e372b41$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $db6b87084e372b41$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $dmX0B.Observable)((sub)=>{
            notifiers.push($db6b87084e372b41$var$notify(project(value), sub, onReady));
        });
};
const $db6b87084e372b41$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $f8gPD.mergeMap)($db6b87084e372b41$var$mapper(project), concurrent);

});


parcelRegister("4HgqG", function(module, exports) {
$parcel$export(module.exports, "uploadinator", () => $6cc00738ae2bcf47$export$94ce0f3fcf999415);

var $czSp6 = parcelRequire("czSp6");
const $6cc00738ae2bcf47$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $czSp6.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("bWj1f", function(module, exports) {
$parcel$export(module.exports, "processinator", () => $4b13af7927f47590$export$2f21790600302ed);

var $7lzMj = parcelRequire("7lzMj");

var $aCHyH = parcelRequire("aCHyH");
const $4b13af7927f47590$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $7lzMj.bufferCount)(options.batchSize)).pipe((0, $aCHyH.concatMap)(process));
};

});


parcelRegister("lc1TD", function(module, exports) {
$parcel$export(module.exports, "createHasher", () => $4dbe1fa24aa52906$export$14b114effbc08b6b);
parcelRequire("dnJXJ");
var $eyW2Z = parcelRequire("eyW2Z");
let $4dbe1fa24aa52906$var$hasher = null;
let $4dbe1fa24aa52906$var$sha256Hasher = null;
const $4dbe1fa24aa52906$export$d9c9d11cd648a505 = ()=>{
    $4dbe1fa24aa52906$var$hasher = null;
    $4dbe1fa24aa52906$var$sha256Hasher = null;
};


const $4dbe1fa24aa52906$export$14b114effbc08b6b = async (algorithm)=>{
    try {
        if (algorithm === (0, $eyW2Z.ChunkHashAlgorithm).Sha256) {
            if (!$4dbe1fa24aa52906$var$sha256Hasher) {
                // TODO this needs to support worker sha256 hasher as well
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("3QHqX"));
                $4dbe1fa24aa52906$var$sha256Hasher = new SimpleHasher();
            }
            return $4dbe1fa24aa52906$var$sha256Hasher;
        }
    } catch (error) {}
    const { SimpleHasher: SimpleHasher } = await (parcelRequire("Jqdzi"));
    $4dbe1fa24aa52906$var$hasher = new SimpleHasher();
    return $4dbe1fa24aa52906$var$hasher;
};

});
parcelRegister("3QHqX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lHx8Q").then(()=>parcelRequire('5XApd'));

});

parcelRegister("Jqdzi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5al8Z").then(()=>parcelRequire('8jh9e'));

});


parcelRegister("ktAC9", function(module, exports) {
$parcel$export(module.exports, "UploaderError", () => $2291d575982d02aa$export$515240c3f059c807);

var $cTY6x = parcelRequire("cTY6x");
class $2291d575982d02aa$export$515240c3f059c807 extends (0, $cTY6x.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $2291d575982d02aa$export$80ee180172bc336(err) {
    return err instanceof $2291d575982d02aa$export$515240c3f059c807;
}

});

parcelRegister("2tq8R", function(module, exports) {
$parcel$export(module.exports, "fileSizeError", () => $8d4afa083245ff78$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $8d4afa083245ff78$export$71f452e02035c1e2);

var $6a2Ft = parcelRequire("6a2Ft");

var $iGFGS = parcelRequire("iGFGS");
const $8d4afa083245ff78$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $8d4afa083245ff78$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $iGFGS.MAX_UPLOAD_FILE_SIZE)) throw new Error($8d4afa083245ff78$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $6a2Ft.DATA_UNIT).GB) return 5 * (0, $6a2Ft.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $6a2Ft.DATA_UNIT).GB && fileSize <= 50 * (0, $6a2Ft.DATA_UNIT).GB) return 50 * (0, $6a2Ft.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $6a2Ft.DATA_UNIT).GB && fileSize <= 0.95 * (0, $6a2Ft.DATA_UNIT).TB) return 100 * (0, $6a2Ft.DATA_UNIT).MB;
    return 210 * (0, $6a2Ft.DATA_UNIT).MB;
};

});


parcelRegister("9CNsj", function(module, exports) {
$parcel$export(module.exports, "getFileStreamsCache", () => $adab5ab3a16938ff$export$f2f061938c1e6810);
class $adab5ab3a16938ff$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $adab5ab3a16938ff$var$streamCache;

const $adab5ab3a16938ff$export$f2f061938c1e6810 = ()=>{
    if (!$adab5ab3a16938ff$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("7PqSD")).mediaState;
        $adab5ab3a16938ff$var$streamCache = new $adab5ab3a16938ff$export$4293896e79732236(mediaState.streams);
    }
    return $adab5ab3a16938ff$var$streamCache;
};

});

parcelRegister("heFMZ", function(module, exports) {
$parcel$export(module.exports, "createFileDataloader", () => $6d7d78aa5384d560$export$ae188fee39529b82);

var $4Vswo = parcelRequire("4Vswo");

var $gXaBe = parcelRequire("gXaBe");
const $6d7d78aa5384d560$export$b79d95ee17a87a = 100;
const $6d7d78aa5384d560$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $6d7d78aa5384d560$var$isResponseFileItem = (fileItem)=>{
    return 'details' in fileItem;
};
const $6d7d78aa5384d560$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $6d7d78aa5384d560$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $6d7d78aa5384d560$var$makeCacheKey(id, collection);
        if ($6d7d78aa5384d560$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($6d7d78aa5384d560$var$isResponseFileItem(fileItem)) prev[key] = {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $6d7d78aa5384d560$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};
function $6d7d78aa5384d560$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const includeHashByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
            return acc;
        }, {});
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $gXaBe.getRandomTelemetryId)(),
                spanId: (0, $gXaBe.getRandomTelemetryId)()
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
                // add EmptyResponseFileItem for each file ID not included in /items response
                const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                fileIdsNotFound.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        type: 'not-found',
                        metadataTraceContext: metadataTraceContext
                    });
                });
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $6d7d78aa5384d560$export$71cd2e8f8162d47b(keys, items);
    };
}
function $6d7d78aa5384d560$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($4Vswo)))($6d7d78aa5384d560$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $6d7d78aa5384d560$export$b79d95ee17a87a
    });
}

});

parcelRegister("bsuz1", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $846b61ba9b83ebd0$export$ac3214931ffd82af);

var $KY3oR = parcelRequire("KY3oR");
const $846b61ba9b83ebd0$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $KY3oR.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("KY3oR", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $ed3f0b4c8fc3d1d2$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("57Yyl")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("57Yyl")).isVideoMimeTypeSupportedByBrowser);

var $h7kf8 = parcelRequire("h7kf8");

var $57Yyl = parcelRequire("57Yyl");

var $gVe3g = parcelRequire("gVe3g");

var $kvu11 = parcelRequire("kvu11");
const $ed3f0b4c8fc3d1d2$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $h7kf8.isArchive)(mimeType)) return 'archive';
    if ((0, $57Yyl.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $gVe3g.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $57Yyl.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $gVe3g.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $57Yyl.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $gVe3g.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $57Yyl.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $gVe3g.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("h7kf8", function(module, exports) {
$parcel$export(module.exports, "isArchive", () => $f0d38135591a06d9$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $f0d38135591a06d9$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("57Yyl", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $5425bbccc739ec56$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $5425bbccc739ec56$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $5425bbccc739ec56$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $5425bbccc739ec56$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $5425bbccc739ec56$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $5425bbccc739ec56$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $5425bbccc739ec56$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $5425bbccc739ec56$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $5425bbccc739ec56$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $5425bbccc739ec56$export$55ca6cdaf6093034 = (mimeType)=>$5425bbccc739ec56$export$74325e3c843a9555(mimeType) || $5425bbccc739ec56$export$c021f2623a75015f(mimeType) || $5425bbccc739ec56$export$ff36075ea755a717(mimeType) || $5425bbccc739ec56$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("gVe3g", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $d3b132c065c474c5$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $d3b132c065c474c5$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $d3b132c065c474c5$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $d3b132c065c474c5$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $d3b132c065c474c5$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $d3b132c065c474c5$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $d3b132c065c474c5$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $d3b132c065c474c5$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $d3b132c065c474c5$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $d3b132c065c474c5$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $d3b132c065c474c5$export$548d9148a80556a3 = (mimeType)=>$d3b132c065c474c5$export$e9a065a80f76311e(mimeType) || $d3b132c065c474c5$export$86baad7a89d908e9(mimeType) || $d3b132c065c474c5$export$8cba23825d020bbb(mimeType) || $d3b132c065c474c5$export$9c2b4de5fdca2ce3(mimeType) || $d3b132c065c474c5$export$94e1479e01d2af53(mimeType);

});

parcelRegister("kvu11", function(module, exports) {
$parcel$export(module.exports, "isExcelFile", () => $e1571e0df9bae725$export$e5fbc944c6f94589);
// MS Excel MIME types — covers all native Microsoft spreadsheet formats.
// Stored in their canonical form (RFC 4288 mimetypes are case-sensitive;
// the media backend always sends them in this exact casing).
const $e1571e0df9bae725$var$EXCEL_MIME_TYPES = new Set([
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
    'application/vnd.ms-excel.sheet.macroEnabled.12'
]);
const $e1571e0df9bae725$export$e5fbc944c6f94589 = (mimeType)=>$e1571e0df9bae725$var$EXCEL_MIME_TYPES.has(mimeType);

});



parcelRegister("6gese", function(module, exports) {
$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $05c9fb0613d86733$export$89097c0ec1e0dee1);

var $f53AU = parcelRequire("f53AU");
const $05c9fb0613d86733$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $f53AU.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("9U29T", function(module, exports) {
$parcel$export(module.exports, "convertBase64ToBlob", () => $d5fad12207243447$export$ed17558b11b88056);
const $d5fad12207243447$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("3G5hJ", function(module, exports) {
$parcel$export(module.exports, "fromObservable", () => $29b9ba639853cbf1$export$4b2432e2d8723823);

var $9RXrz = parcelRequire("9RXrz");
function $29b9ba639853cbf1$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $29b9ba639853cbf1$export$8659d1f07d151381(item) {
    return $29b9ba639853cbf1$export$4b2432e2d8723823((0, $9RXrz.createMediaSubject)(item));
}

});
parcelRegister("9RXrz", function(module, exports) {
$parcel$export(module.exports, "createMediaSubject", () => $3aa737bd1453829a$export$bc76d51553fa5e35);

var $jBqw1 = parcelRequire("jBqw1");
function $3aa737bd1453829a$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $jBqw1.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("gLnvu", function(module, exports) {
$parcel$export(module.exports, "toPromise", () => $1bbb735b66d4a1ad$export$4dbaaf6c79705e6c);

var $lkLFz = parcelRequire("lkLFz");
const $1bbb735b66d4a1ad$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $lkLFz.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("jXtvt", function(module, exports) {
$parcel$export(module.exports, "getDimensionsFromBlob", () => $1ce91f3db0c84123$export$71797c284d89a3e1);

var $ahAXd = parcelRequire("ahAXd");

var $3K8JJ = parcelRequire("3K8JJ");
const $1ce91f3db0c84123$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $ahAXd.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $3K8JJ.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("ahAXd", function(module, exports) {
$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $91c824d208e611b9$export$a1c3205f28a20414);
const $91c824d208e611b9$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("3K8JJ", function(module, exports) {
$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $96200c0be3e6c2de$export$62aabd5ff85d0451);
const $96200c0be3e6c2de$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("cSqIk", function(module, exports) {
$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $4bae760f938ce2a1$export$2ccdd6f9a9eba6a);

var $57Yyl = parcelRequire("57Yyl");
var $gVe3g = parcelRequire("gVe3g");

var $3K8JJ = parcelRequire("3K8JJ");
async function $4bae760f938ce2a1$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $57Yyl.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $gVe3g.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $3K8JJ.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("1AkSq", function(module, exports) {
$parcel$export(module.exports, "PollingFunction", () => $cc4f15ee33b386c4$export$4c54d536f8e37dc2);

var $gqiaF = parcelRequire("gqiaF");
const $cc4f15ee33b386c4$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $cc4f15ee33b386c4$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$cc4f15ee33b386c4$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $gqiaF.PollingError)('pollingMaxAttemptsExceeded', {
            attempts: this.attempt
        }));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $gqiaF.PollingError)('pollingMaxAttemptsExceeded', {
                attempts: this.attempt
            }));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("gqiaF", function(module, exports) {
$parcel$export(module.exports, "PollingError", () => $dd963ab2d6c998b5$export$c3748c310e92340a);

var $cTY6x = parcelRequire("cTY6x");
class $dd963ab2d6c998b5$export$c3748c310e92340a extends (0, $cTY6x.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { attempts: attempts } } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $dd963ab2d6c998b5$export$541e3e52eea6fece(err) {
    return err instanceof $dd963ab2d6c998b5$export$c3748c310e92340a;
}

});


parcelRegister("fphkZ", function(module, exports) {
$parcel$export(module.exports, "isEmptyFile", () => $b4f0192d7cd8b329$export$728192ce8dd94659);
const $b4f0192d7cd8b329$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $b4f0192d7cd8b329$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $b4f0192d7cd8b329$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("grIM4", function(module, exports) {
$parcel$export(module.exports, "mediaStore", () => $2b36c20f914d5824$export$5785580dea19518d);

var $iX1N1 = parcelRequire("iX1N1");

var $lgqcp = parcelRequire("lgqcp");

var $6pbzb = parcelRequire("6pbzb");
const $2b36c20f914d5824$var$mediaStoreWithoutDevtools = (0, $6pbzb.createStore)()((0, $iX1N1.subscribeWithSelector)((0, $lgqcp.immer)(()=>({
        files: {}
    }))));
const $2b36c20f914d5824$var$mediaStoreWithDevtools = (0, $6pbzb.createStore)()((0, $iX1N1.devtools)((0, $iX1N1.subscribeWithSelector)((0, $lgqcp.immer)(()=>({
        files: {}
    })))));
const $2b36c20f914d5824$export$5785580dea19518d = $2b36c20f914d5824$var$mediaStoreWithoutDevtools;

});
parcelRegister("iX1N1", function(module, exports) {
$parcel$export(module.exports, "devtools", () => $dcbf2011f45587f0$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $dcbf2011f45587f0$export$5c593627aef9f076);
var $dcbf2011f45587f0$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $dcbf2011f45587f0$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $dcbf2011f45587f0$export$4feba8a1bc8e9afd = $dcbf2011f45587f0$var$reduxImpl;
const $dcbf2011f45587f0$var$trackedConnections = /* @__PURE__ */ new Map();
const $dcbf2011f45587f0$var$getTrackedConnectionState = (name)=>{
    const api = $dcbf2011f45587f0$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $dcbf2011f45587f0$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $dcbf2011f45587f0$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $dcbf2011f45587f0$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $dcbf2011f45587f0$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($dcbf2011f45587f0$import_meta.env ? $dcbf2011f45587f0$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_e) {}
        if (!extensionConnector) {
            if (($dcbf2011f45587f0$import_meta.env ? $dcbf2011f45587f0$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $dcbf2011f45587f0$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$dcbf2011f45587f0$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($dcbf2011f45587f0$import_meta.env ? $dcbf2011f45587f0$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $dcbf2011f45587f0$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($dcbf2011f45587f0$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($dcbf2011f45587f0$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $dcbf2011f45587f0$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($dcbf2011f45587f0$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $dcbf2011f45587f0$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $dcbf2011f45587f0$export$6922d3b3a607469e = $dcbf2011f45587f0$var$devtoolsImpl;
const $dcbf2011f45587f0$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $dcbf2011f45587f0$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $dcbf2011f45587f0$export$5c593627aef9f076 = $dcbf2011f45587f0$var$subscribeWithSelectorImpl;
const $dcbf2011f45587f0$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $dcbf2011f45587f0$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (_e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $dcbf2011f45587f0$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $dcbf2011f45587f0$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $dcbf2011f45587f0$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $dcbf2011f45587f0$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (_e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $dcbf2011f45587f0$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $dcbf2011f45587f0$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $dcbf2011f45587f0$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $dcbf2011f45587f0$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $dcbf2011f45587f0$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $dcbf2011f45587f0$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($dcbf2011f45587f0$import_meta.env ? $dcbf2011f45587f0$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $dcbf2011f45587f0$var$oldImpl(config, baseOptions);
    }
    return $dcbf2011f45587f0$var$newImpl(config, baseOptions);
};
const $dcbf2011f45587f0$export$9a6132153fba2e0 = $dcbf2011f45587f0$var$persistImpl;

});

parcelRegister("lgqcp", function(module, exports) {
$parcel$export(module.exports, "immer", () => $f7af6a37cc83a273$export$428de7ec69ac95c);

var $fnmcc = parcelRequire("fnmcc");
const $f7af6a37cc83a273$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $fnmcc.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $f7af6a37cc83a273$export$428de7ec69ac95c = $f7af6a37cc83a273$var$immerImpl;

});
parcelRegister("fnmcc", function(module, exports) {
$parcel$export(module.exports, "produce", () => $b31a389fb47a0201$export$b46cabe22e78bc00);
// src/utils/env.ts
var $b31a389fb47a0201$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $b31a389fb47a0201$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $b31a389fb47a0201$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $b31a389fb47a0201$var$errors = [];
function $b31a389fb47a0201$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $b31a389fb47a0201$var$O = Object;
var $b31a389fb47a0201$var$getPrototypeOf = $b31a389fb47a0201$var$O.getPrototypeOf;
var $b31a389fb47a0201$var$CONSTRUCTOR = "constructor";
var $b31a389fb47a0201$var$PROTOTYPE = "prototype";
var $b31a389fb47a0201$var$CONFIGURABLE = "configurable";
var $b31a389fb47a0201$var$ENUMERABLE = "enumerable";
var $b31a389fb47a0201$var$WRITABLE = "writable";
var $b31a389fb47a0201$var$VALUE = "value";
var $b31a389fb47a0201$export$541ac630993a4c84 = (value)=>!!value && !!value[$b31a389fb47a0201$var$DRAFT_STATE];
function $b31a389fb47a0201$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $b31a389fb47a0201$var$isPlainObject(value) || $b31a389fb47a0201$var$isArray(value) || !!value[$b31a389fb47a0201$export$6ee2082928bcb0ee] || !!value[$b31a389fb47a0201$var$CONSTRUCTOR]?.[$b31a389fb47a0201$export$6ee2082928bcb0ee] || $b31a389fb47a0201$var$isMap(value) || $b31a389fb47a0201$var$isSet(value);
}
var $b31a389fb47a0201$var$objectCtorString = $b31a389fb47a0201$var$O[$b31a389fb47a0201$var$PROTOTYPE][$b31a389fb47a0201$var$CONSTRUCTOR].toString();
var $b31a389fb47a0201$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $b31a389fb47a0201$var$isPlainObject(value) {
    if (!value || !$b31a389fb47a0201$var$isObjectish(value)) return false;
    const proto = $b31a389fb47a0201$var$getPrototypeOf(value);
    if (proto === null || proto === $b31a389fb47a0201$var$O[$b31a389fb47a0201$var$PROTOTYPE]) return true;
    const Ctor = $b31a389fb47a0201$var$O.hasOwnProperty.call(proto, $b31a389fb47a0201$var$CONSTRUCTOR) && proto[$b31a389fb47a0201$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$b31a389fb47a0201$var$isFunction(Ctor)) return false;
    let ctorString = $b31a389fb47a0201$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $b31a389fb47a0201$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $b31a389fb47a0201$var$objectCtorString;
}
function $b31a389fb47a0201$export$22e8af3f75a010e3(value) {
    if (!$b31a389fb47a0201$export$541ac630993a4c84(value)) $b31a389fb47a0201$var$die(15, value);
    return value[$b31a389fb47a0201$var$DRAFT_STATE].base_;
}
function $b31a389fb47a0201$var$each(obj, iter, strict = true) {
    if ($b31a389fb47a0201$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $b31a389fb47a0201$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $b31a389fb47a0201$var$getArchtype(thing) {
    const state = thing[$b31a389fb47a0201$var$DRAFT_STATE];
    return state ? state.type_ : $b31a389fb47a0201$var$isArray(thing) ? 1 /* Array */  : $b31a389fb47a0201$var$isMap(thing) ? 2 /* Map */  : $b31a389fb47a0201$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $b31a389fb47a0201$var$has = (thing, prop, type = $b31a389fb47a0201$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $b31a389fb47a0201$var$O[$b31a389fb47a0201$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $b31a389fb47a0201$var$get = (thing, prop, type = $b31a389fb47a0201$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $b31a389fb47a0201$var$set = (thing, propOrOldValue, value, type = $b31a389fb47a0201$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $b31a389fb47a0201$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $b31a389fb47a0201$var$isArray = Array.isArray;
var $b31a389fb47a0201$var$isMap = (target)=>target instanceof Map;
var $b31a389fb47a0201$var$isSet = (target)=>target instanceof Set;
var $b31a389fb47a0201$var$isObjectish = (target)=>typeof target === "object";
var $b31a389fb47a0201$var$isFunction = (target)=>typeof target === "function";
var $b31a389fb47a0201$var$isBoolean = (target)=>typeof target === "boolean";
function $b31a389fb47a0201$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $b31a389fb47a0201$var$getProxyDraft = (value)=>{
    if (!$b31a389fb47a0201$var$isObjectish(value)) return null;
    return value?.[$b31a389fb47a0201$var$DRAFT_STATE];
};
var $b31a389fb47a0201$var$latest = (state)=>state.copy_ || state.base_;
var $b31a389fb47a0201$var$getValue = (value)=>{
    const proxyDraft = $b31a389fb47a0201$var$getProxyDraft(value);
    return proxyDraft ? proxyDraft.copy_ ?? proxyDraft.base_ : value;
};
var $b31a389fb47a0201$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $b31a389fb47a0201$var$shallowCopy(base, strict) {
    if ($b31a389fb47a0201$var$isMap(base)) return new Map(base);
    if ($b31a389fb47a0201$var$isSet(base)) return new Set(base);
    if ($b31a389fb47a0201$var$isArray(base)) return Array[$b31a389fb47a0201$var$PROTOTYPE].slice.call(base);
    const isPlain = $b31a389fb47a0201$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $b31a389fb47a0201$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$b31a389fb47a0201$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$b31a389fb47a0201$var$WRITABLE] === false) {
                desc[$b31a389fb47a0201$var$WRITABLE] = true;
                desc[$b31a389fb47a0201$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$b31a389fb47a0201$var$CONFIGURABLE]: true,
                [$b31a389fb47a0201$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$b31a389fb47a0201$var$ENUMERABLE]: desc[$b31a389fb47a0201$var$ENUMERABLE],
                [$b31a389fb47a0201$var$VALUE]: base[key]
            };
        }
        return $b31a389fb47a0201$var$O.create($b31a389fb47a0201$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $b31a389fb47a0201$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = $b31a389fb47a0201$var$O.create(proto);
        return $b31a389fb47a0201$var$O.assign(obj, base);
    }
}
function $b31a389fb47a0201$export$792f3d81ea979f55(obj, deep = false) {
    if ($b31a389fb47a0201$var$isFrozen(obj) || $b31a389fb47a0201$export$541ac630993a4c84(obj) || !$b31a389fb47a0201$export$16e3aed3edb85946(obj)) return obj;
    if ($b31a389fb47a0201$var$getArchtype(obj) > 1) $b31a389fb47a0201$var$O.defineProperties(obj, {
        set: $b31a389fb47a0201$var$dontMutateMethodOverride,
        add: $b31a389fb47a0201$var$dontMutateMethodOverride,
        clear: $b31a389fb47a0201$var$dontMutateMethodOverride,
        delete: $b31a389fb47a0201$var$dontMutateMethodOverride
    });
    $b31a389fb47a0201$var$O.freeze(obj);
    if (deep) $b31a389fb47a0201$var$each(obj, (_key, value)=>{
        $b31a389fb47a0201$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $b31a389fb47a0201$var$dontMutateFrozenCollections() {
    $b31a389fb47a0201$var$die(2);
}
var $b31a389fb47a0201$var$dontMutateMethodOverride = {
    [$b31a389fb47a0201$var$VALUE]: $b31a389fb47a0201$var$dontMutateFrozenCollections
};
function $b31a389fb47a0201$var$isFrozen(obj) {
    if (obj === null || !$b31a389fb47a0201$var$isObjectish(obj)) return true;
    return $b31a389fb47a0201$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $b31a389fb47a0201$var$PluginMapSet = "MapSet";
var $b31a389fb47a0201$var$PluginPatches = "Patches";
var $b31a389fb47a0201$var$PluginArrayMethods = "ArrayMethods";
var $b31a389fb47a0201$var$plugins = {};
function $b31a389fb47a0201$var$getPlugin(pluginKey) {
    const plugin = $b31a389fb47a0201$var$plugins[pluginKey];
    if (!plugin) $b31a389fb47a0201$var$die(0, pluginKey);
    return plugin;
}
var $b31a389fb47a0201$var$isPluginLoaded = (pluginKey)=>!!$b31a389fb47a0201$var$plugins[pluginKey];
function $b31a389fb47a0201$var$loadPlugin(pluginKey, implementation) {
    if (!$b31a389fb47a0201$var$plugins[pluginKey]) $b31a389fb47a0201$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $b31a389fb47a0201$var$currentScope;
var $b31a389fb47a0201$var$getCurrentScope = ()=>$b31a389fb47a0201$var$currentScope;
var $b31a389fb47a0201$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $b31a389fb47a0201$var$isPluginLoaded($b31a389fb47a0201$var$PluginMapSet) ? $b31a389fb47a0201$var$getPlugin($b31a389fb47a0201$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $b31a389fb47a0201$var$isPluginLoaded($b31a389fb47a0201$var$PluginArrayMethods) ? $b31a389fb47a0201$var$getPlugin($b31a389fb47a0201$var$PluginArrayMethods) : void 0
    });
function $b31a389fb47a0201$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $b31a389fb47a0201$var$getPlugin($b31a389fb47a0201$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $b31a389fb47a0201$var$revokeScope(scope) {
    $b31a389fb47a0201$var$leaveScope(scope);
    scope.drafts_.forEach($b31a389fb47a0201$var$revokeDraft);
    scope.drafts_ = null;
}
function $b31a389fb47a0201$var$leaveScope(scope) {
    if (scope === $b31a389fb47a0201$var$currentScope) $b31a389fb47a0201$var$currentScope = scope.parent_;
}
var $b31a389fb47a0201$var$enterScope = (immer2)=>$b31a389fb47a0201$var$currentScope = $b31a389fb47a0201$var$createScope($b31a389fb47a0201$var$currentScope, immer2);
function $b31a389fb47a0201$var$revokeDraft(draft) {
    const state = draft[$b31a389fb47a0201$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $b31a389fb47a0201$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$b31a389fb47a0201$var$DRAFT_STATE].modified_) {
            $b31a389fb47a0201$var$revokeScope(scope);
            $b31a389fb47a0201$var$die(4);
        }
        if ($b31a389fb47a0201$export$16e3aed3edb85946(result)) result = $b31a389fb47a0201$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$b31a389fb47a0201$var$DRAFT_STATE].base_, result, scope);
    } else result = $b31a389fb47a0201$var$finalize(scope, baseDraft);
    $b31a389fb47a0201$var$maybeFreeze(scope, result, true);
    $b31a389fb47a0201$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $b31a389fb47a0201$export$45b790e32b2810ee ? result : void 0;
}
function $b31a389fb47a0201$var$finalize(rootScope, value) {
    if ($b31a389fb47a0201$var$isFrozen(value)) return value;
    const state = value[$b31a389fb47a0201$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $b31a389fb47a0201$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$b31a389fb47a0201$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $b31a389fb47a0201$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $b31a389fb47a0201$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $b31a389fb47a0201$export$792f3d81ea979f55(value, deep);
}
function $b31a389fb47a0201$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $b31a389fb47a0201$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $b31a389fb47a0201$var$EMPTY_LOCATIONS_RESULT = [];
function $b31a389fb47a0201$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    const parentCopy = $b31a389fb47a0201$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $b31a389fb47a0201$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $b31a389fb47a0201$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $b31a389fb47a0201$var$each(parentCopy, (key, value)=>{
            if ($b31a389fb47a0201$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = parent.draftLocations_.get(draftValue) ?? $b31a389fb47a0201$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$b31a389fb47a0201$var$set(parentCopy, location, finalizedValue, parentType);
}
function $b31a389fb47a0201$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        const state = child;
        if (!state || !$b31a389fb47a0201$var$isSameScope(state, rootScope)) return;
        rootScope.mapSetPlugin_?.fixSetContents(state);
        const finalizedValue = $b31a389fb47a0201$var$getFinalValue(state);
        $b31a389fb47a0201$var$updateDraftInParent(parent, state.draft_ ?? state, finalizedValue, key);
        $b31a389fb47a0201$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $b31a389fb47a0201$var$generatePatchesAndFinalize(state, rootScope) {
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || (state.assigned_?.size ?? 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $b31a389fb47a0201$var$markStateFinalized(state);
    }
}
function $b31a389fb47a0201$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($b31a389fb47a0201$export$541ac630993a4c84(value)) {
        const state = value[$b31a389fb47a0201$var$DRAFT_STATE];
        if ($b31a389fb47a0201$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $b31a389fb47a0201$var$prepareCopy(target);
            const finalizedValue = $b31a389fb47a0201$var$getFinalValue(state);
            $b31a389fb47a0201$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($b31a389fb47a0201$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        const targetCopy = $b31a389fb47a0201$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $b31a389fb47a0201$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($b31a389fb47a0201$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && (target.assigned_.get(key) ?? false) === true && target.copy_) $b31a389fb47a0201$var$handleValue($b31a389fb47a0201$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $b31a389fb47a0201$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($b31a389fb47a0201$export$541ac630993a4c84(target) || handledSet.has(target) || !$b31a389fb47a0201$export$16e3aed3edb85946(target) || $b31a389fb47a0201$var$isFrozen(target)) return target;
    handledSet.add(target);
    $b31a389fb47a0201$var$each(target, (key, value)=>{
        if ($b31a389fb47a0201$export$541ac630993a4c84(value)) {
            const state = value[$b31a389fb47a0201$var$DRAFT_STATE];
            if ($b31a389fb47a0201$var$isSameScope(state, rootScope)) {
                const updatedValue = $b31a389fb47a0201$var$getFinalValue(state);
                $b31a389fb47a0201$var$set(target, key, updatedValue, target.type_);
                $b31a389fb47a0201$var$markStateFinalized(state);
            }
        } else if ($b31a389fb47a0201$export$16e3aed3edb85946(value)) $b31a389fb47a0201$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $b31a389fb47a0201$var$createProxyProxy(base, parent) {
    const baseIsArray = $b31a389fb47a0201$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $b31a389fb47a0201$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $b31a389fb47a0201$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $b31a389fb47a0201$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $b31a389fb47a0201$var$objectTraps = {
    get (state, prop) {
        if (prop === $b31a389fb47a0201$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin?.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $b31a389fb47a0201$var$latest(state);
        if (!$b31a389fb47a0201$var$has(source, prop, state.type_)) return $b31a389fb47a0201$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$b31a389fb47a0201$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && arrayPlugin?.isMutatingArrayMethod(state.operationMethod) && $b31a389fb47a0201$var$isArrayIndex(prop)) return value;
        if (value === $b31a389fb47a0201$var$peek(state.base_, prop)) {
            $b31a389fb47a0201$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $b31a389fb47a0201$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $b31a389fb47a0201$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($b31a389fb47a0201$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $b31a389fb47a0201$var$getDescriptorFromProto($b31a389fb47a0201$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $b31a389fb47a0201$var$peek($b31a389fb47a0201$var$latest(state), prop);
            const currentState = current2?.[$b31a389fb47a0201$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($b31a389fb47a0201$var$is(value, current2) && (value !== void 0 || $b31a389fb47a0201$var$has(state.base_, prop, state.type_))) return true;
            $b31a389fb47a0201$var$prepareCopy(state);
            $b31a389fb47a0201$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $b31a389fb47a0201$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $b31a389fb47a0201$var$prepareCopy(state);
        if ($b31a389fb47a0201$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $b31a389fb47a0201$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $b31a389fb47a0201$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$b31a389fb47a0201$var$WRITABLE]: true,
            [$b31a389fb47a0201$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$b31a389fb47a0201$var$ENUMERABLE]: desc[$b31a389fb47a0201$var$ENUMERABLE],
            [$b31a389fb47a0201$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $b31a389fb47a0201$var$die(11);
    },
    getPrototypeOf (state) {
        return $b31a389fb47a0201$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $b31a389fb47a0201$var$die(12);
    }
};
var $b31a389fb47a0201$var$arrayTraps = {};
for(let key in $b31a389fb47a0201$var$objectTraps){
    let fn = $b31a389fb47a0201$var$objectTraps[key];
    $b31a389fb47a0201$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$b31a389fb47a0201$var$arrayTraps.deleteProperty = function(state, prop) {
    return $b31a389fb47a0201$var$arrayTraps.set.call(this, state, prop, void 0);
};
$b31a389fb47a0201$var$arrayTraps.set = function(state, prop, value) {
    return $b31a389fb47a0201$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $b31a389fb47a0201$var$peek(draft, prop) {
    const state = draft[$b31a389fb47a0201$var$DRAFT_STATE];
    const source = state ? $b31a389fb47a0201$var$latest(state) : draft;
    return source[prop];
}
function $b31a389fb47a0201$var$readPropFromProto(state, source, prop) {
    const desc = $b31a389fb47a0201$var$getDescriptorFromProto(source, prop);
    return desc ? $b31a389fb47a0201$var$VALUE in desc ? desc[$b31a389fb47a0201$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $b31a389fb47a0201$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $b31a389fb47a0201$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $b31a389fb47a0201$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $b31a389fb47a0201$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $b31a389fb47a0201$var$markChanged(state.parent_);
    }
}
function $b31a389fb47a0201$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $b31a389fb47a0201$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $b31a389fb47a0201$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($b31a389fb47a0201$var$isFunction(base) && !$b31a389fb47a0201$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$b31a389fb47a0201$var$isFunction(recipe)) $b31a389fb47a0201$var$die(6);
            if (patchListener !== void 0 && !$b31a389fb47a0201$var$isFunction(patchListener)) $b31a389fb47a0201$var$die(7);
            let result;
            if ($b31a389fb47a0201$export$16e3aed3edb85946(base)) {
                const scope = $b31a389fb47a0201$var$enterScope(this);
                const proxy = $b31a389fb47a0201$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $b31a389fb47a0201$var$revokeScope(scope);
                    else $b31a389fb47a0201$var$leaveScope(scope);
                }
                $b31a389fb47a0201$var$usePatchesInScope(scope, patchListener);
                return $b31a389fb47a0201$var$processResult(result, scope);
            } else if (!base || !$b31a389fb47a0201$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $b31a389fb47a0201$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $b31a389fb47a0201$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $b31a389fb47a0201$var$getPlugin($b31a389fb47a0201$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $b31a389fb47a0201$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($b31a389fb47a0201$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($b31a389fb47a0201$var$isBoolean(config?.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($b31a389fb47a0201$var$isBoolean(config?.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($b31a389fb47a0201$var$isBoolean(config?.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$b31a389fb47a0201$export$16e3aed3edb85946(base)) $b31a389fb47a0201$var$die(8);
        if ($b31a389fb47a0201$export$541ac630993a4c84(base)) base = $b31a389fb47a0201$export$97aac956da55dae9(base);
        const scope = $b31a389fb47a0201$var$enterScope(this);
        const proxy = $b31a389fb47a0201$var$createProxy(scope, base, void 0);
        proxy[$b31a389fb47a0201$var$DRAFT_STATE].isManual_ = true;
        $b31a389fb47a0201$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$b31a389fb47a0201$var$DRAFT_STATE];
        if (!state || !state.isManual_) $b31a389fb47a0201$var$die(9);
        const { scope_: scope } = state;
        $b31a389fb47a0201$var$usePatchesInScope(scope, patchListener);
        return $b31a389fb47a0201$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $b31a389fb47a0201$var$getPlugin($b31a389fb47a0201$var$PluginPatches).applyPatches_;
        if ($b31a389fb47a0201$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $b31a389fb47a0201$var$createProxy(rootScope, value, parent, key) {
    const [draft, state] = $b31a389fb47a0201$var$isMap(value) ? $b31a389fb47a0201$var$getPlugin($b31a389fb47a0201$var$PluginMapSet).proxyMap_(value, parent) : $b31a389fb47a0201$var$isSet(value) ? $b31a389fb47a0201$var$getPlugin($b31a389fb47a0201$var$PluginMapSet).proxySet_(value, parent) : $b31a389fb47a0201$var$createProxyProxy(value, parent);
    const scope = parent?.scope_ ?? $b31a389fb47a0201$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = parent?.callbacks_ ?? [];
    state.key_ = key;
    if (parent && key !== void 0) $b31a389fb47a0201$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        rootScope2.mapSetPlugin_?.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $b31a389fb47a0201$export$97aac956da55dae9(value) {
    if (!$b31a389fb47a0201$export$541ac630993a4c84(value)) $b31a389fb47a0201$var$die(10, value);
    return $b31a389fb47a0201$var$currentImpl(value);
}
function $b31a389fb47a0201$var$currentImpl(value) {
    if (!$b31a389fb47a0201$export$16e3aed3edb85946(value) || $b31a389fb47a0201$var$isFrozen(value)) return value;
    const state = value[$b31a389fb47a0201$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $b31a389fb47a0201$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $b31a389fb47a0201$var$shallowCopy(value, true);
    $b31a389fb47a0201$var$each(copy, (key, childValue)=>{
        $b31a389fb47a0201$var$set(copy, key, $b31a389fb47a0201$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $b31a389fb47a0201$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        if (state.key_ !== void 0) {
            const parentCopy = state.parent_.copy_ ?? state.parent_.base_;
            const proxyDraft = $b31a389fb47a0201$var$getProxyDraft($b31a389fb47a0201$var$get(parentCopy, state.key_));
            const valueAtKey = $b31a389fb47a0201$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $b31a389fb47a0201$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $b31a389fb47a0201$var$get(current2, key);
            if (!$b31a389fb47a0201$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || assigned_?.get(i.toString());
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem?.[$b31a389fb47a0201$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $b31a389fb47a0201$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $b31a389fb47a0201$var$get(base_, key, type_);
            const value = $b31a389fb47a0201$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $b31a389fb47a0201$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $b31a389fb47a0201$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $b31a389fb47a0201$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $b31a389fb47a0201$var$CONSTRUCTOR)) $b31a389fb47a0201$var$die(errorOffset + 3);
                if ($b31a389fb47a0201$var$isFunction(base) && p === $b31a389fb47a0201$var$PROTOTYPE) $b31a389fb47a0201$var$die(errorOffset + 3);
                base = $b31a389fb47a0201$var$get(base, p);
                if (!$b31a389fb47a0201$var$isObjectish(base)) $b31a389fb47a0201$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $b31a389fb47a0201$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $b31a389fb47a0201$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $b31a389fb47a0201$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$b31a389fb47a0201$export$16e3aed3edb85946(obj)) return obj;
        if ($b31a389fb47a0201$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($b31a389fb47a0201$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($b31a389fb47a0201$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($b31a389fb47a0201$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($b31a389fb47a0201$var$has(obj, $b31a389fb47a0201$export$6ee2082928bcb0ee)) cloned[$b31a389fb47a0201$export$6ee2082928bcb0ee] = obj[$b31a389fb47a0201$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($b31a389fb47a0201$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $b31a389fb47a0201$var$loadPlugin($b31a389fb47a0201$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $b31a389fb47a0201$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$b31a389fb47a0201$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $b31a389fb47a0201$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $b31a389fb47a0201$var$latest(this[$b31a389fb47a0201$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $b31a389fb47a0201$var$latest(this[$b31a389fb47a0201$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$b31a389fb47a0201$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$b31a389fb47a0201$var$latest(state).has(key) || $b31a389fb47a0201$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $b31a389fb47a0201$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $b31a389fb47a0201$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$b31a389fb47a0201$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $b31a389fb47a0201$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$b31a389fb47a0201$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($b31a389fb47a0201$var$latest(state).size) {
                prepareMapCopy(state);
                $b31a389fb47a0201$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $b31a389fb47a0201$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$b31a389fb47a0201$var$DRAFT_STATE];
            $b31a389fb47a0201$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$b31a389fb47a0201$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $b31a389fb47a0201$var$latest(state).get(key);
            if (state.finalized_ || !$b31a389fb47a0201$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $b31a389fb47a0201$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $b31a389fb47a0201$var$latest(this[$b31a389fb47a0201$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($b31a389fb47a0201$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$b31a389fb47a0201$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$b31a389fb47a0201$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $b31a389fb47a0201$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $b31a389fb47a0201$var$latest(this[$b31a389fb47a0201$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$b31a389fb47a0201$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$b31a389fb47a0201$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $b31a389fb47a0201$var$markChanged(state);
                state.copy_.add(value);
                $b31a389fb47a0201$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$b31a389fb47a0201$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $b31a389fb47a0201$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$b31a389fb47a0201$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($b31a389fb47a0201$var$latest(state).size) {
                prepareSetCopy(state);
                $b31a389fb47a0201$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$b31a389fb47a0201$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$b31a389fb47a0201$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($b31a389fb47a0201$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$b31a389fb47a0201$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($b31a389fb47a0201$export$16e3aed3edb85946(value)) {
                    const draft = $b31a389fb47a0201$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $b31a389fb47a0201$var$die(3, JSON.stringify($b31a389fb47a0201$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($b31a389fb47a0201$var$getValue(value));
            });
        }
    }
    $b31a389fb47a0201$var$loadPlugin($b31a389fb47a0201$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $b31a389fb47a0201$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $b31a389fb47a0201$var$prepareCopy(state);
        const result = operation();
        $b31a389fb47a0201$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $b31a389fb47a0201$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex(args[0] ?? 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        const source = $b31a389fb47a0201$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = args[0] ?? 0;
            const rawEnd = args[1] ?? source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $b31a389fb47a0201$var$loadPlugin($b31a389fb47a0201$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $b31a389fb47a0201$var$immer = new $b31a389fb47a0201$export$aaadc6ff0f822719();
var $b31a389fb47a0201$export$b46cabe22e78bc00 = $b31a389fb47a0201$var$immer.produce;
var $b31a389fb47a0201$export$4da66d41c9492c78 = /* @__PURE__ */ $b31a389fb47a0201$var$immer.produceWithPatches.bind($b31a389fb47a0201$var$immer);
var $b31a389fb47a0201$export$573f26f60825c493 = /* @__PURE__ */ $b31a389fb47a0201$var$immer.setAutoFreeze.bind($b31a389fb47a0201$var$immer);
var $b31a389fb47a0201$export$333ce65961cbe047 = /* @__PURE__ */ $b31a389fb47a0201$var$immer.setUseStrictShallowCopy.bind($b31a389fb47a0201$var$immer);
var $b31a389fb47a0201$export$1045b3be3904c489 = /* @__PURE__ */ $b31a389fb47a0201$var$immer.setUseStrictIteration.bind($b31a389fb47a0201$var$immer);
var $b31a389fb47a0201$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $b31a389fb47a0201$var$immer.applyPatches.bind($b31a389fb47a0201$var$immer);
var $b31a389fb47a0201$export$3c3214997190395f = /* @__PURE__ */ $b31a389fb47a0201$var$immer.createDraft.bind($b31a389fb47a0201$var$immer);
var $b31a389fb47a0201$export$c60f5e69c521b528 = /* @__PURE__ */ $b31a389fb47a0201$var$immer.finishDraft.bind($b31a389fb47a0201$var$immer);
var $b31a389fb47a0201$export$c05b21e3257751e5 = (value)=>value;
var $b31a389fb47a0201$export$20f911b3f8cf0b74 = (value)=>value;

});


parcelRegister("6pbzb", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $4a9e0cb660442488$export$f51a9068ac82ea43);
var $4a9e0cb660442488$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $4a9e0cb660442488$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($4a9e0cb660442488$import_meta.env ? $4a9e0cb660442488$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $4a9e0cb660442488$export$f51a9068ac82ea43 = (createState)=>createState ? $4a9e0cb660442488$var$createStoreImpl(createState) : $4a9e0cb660442488$var$createStoreImpl;
var $4a9e0cb660442488$export$2e2bcd8739ae039 = (createState)=>{
    if (($4a9e0cb660442488$import_meta.env ? $4a9e0cb660442488$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $4a9e0cb660442488$export$f51a9068ac82ea43(createState);
};

});


parcelRegister("15k4Y", function(module, exports) {
$parcel$export(module.exports, "createCopyIntentRegisterationBatcher", () => $fa18a020b861b840$export$57945b6819e39246);

var $4Vswo = parcelRequire("4Vswo");

var $gXaBe = parcelRequire("gXaBe");
const $fa18a020b861b840$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $fa18a020b861b840$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return async (keys)=>{
        const keysByToken = keys.reduce((acc, key)=>{
            const token = key.resolvedAuth.token;
            acc[token] = acc[token] || [];
            // de-duplicate ids in collection
            const hasDuplicates = acc[token].some(({ id: id, collectionName: collectionName })=>key.id === id && collectionName === key.collectionName);
            if (!hasDuplicates) acc[token].push(key);
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(keysByToken).map(async (batchKey)=>{
            const metadataTraceContext = {
                traceId: (0, $gXaBe.getRandomTelemetryId)(),
                spanId: (0, $gXaBe.getRandomTelemetryId)()
            };
            const files = keysByToken[batchKey].map((key)=>({
                    id: key.id,
                    collection: key.collectionName
                }));
            // given these are batched by the token the assumption is that they have the same details.
            const resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
            try {
                await mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
            } catch (error) {
                files.forEach(({ id: id, collection: collection })=>{
                    items.push({
                        id: id,
                        collection: collection,
                        error: error
                    });
                });
            }
        }));
        return keys.map(({ id: id, collectionName: collectionName })=>{
            return items.find((item)=>item.id === id && item.collection === collectionName)?.error;
        });
    };
}
function $fa18a020b861b840$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($4Vswo)))($fa18a020b861b840$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $fa18a020b861b840$export$b79d95ee17a87a,
        cacheKeyFn: ({ id: id, collectionName: collectionName = 'default', resolvedAuth: resolvedAuth })=>`${id}-${collectionName}-${resolvedAuth.token}`
    });
}

});


parcelRegister("jFaRs", function(module, exports) {
$parcel$export(module.exports, "StargateClient", () => $919d4282aa6d0c07$export$c66ca190f89caaac);
class $919d4282aa6d0c07$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("2XO7C", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l4d4S").then(()=>parcelRequire('lz01J'));

});



parcelRegister("eB0wS", function(module, exports) {
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $088f4edf73d4f51f$export$d25a80b2c86d7fdf);

var $3UnZm = parcelRequire("3UnZm");

var $h5GTO = parcelRequire("h5GTO");
const $088f4edf73d4f51f$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $3UnZm.customCategory) && (0, $h5GTO.hasDataURLImage)(emoji.representation);

});
parcelRegister("h5GTO", function(module, exports) {
$parcel$export(module.exports, "hasDataURLImage", () => $f3bc8ca27796e2d6$export$7720a4954d6f75f8);

var $3UnZm = parcelRequire("3UnZm");

var $ktoNx = parcelRequire("ktoNx");
const $f3bc8ca27796e2d6$export$7720a4954d6f75f8 = (rep)=>(0, $ktoNx.isImageRepresentation)(rep) && rep.imagePath.indexOf((0, $3UnZm.dataURLPrefix)) === 0;

});


parcelRegister("irP7u", function(module, exports) {
$parcel$export(module.exports, "maxImageCached", () => $4d6eff9662744af7$export$887a842045ce5826);
$parcel$export(module.exports, "maxImageSize", () => $4d6eff9662744af7$export$20a2bfdf672c7448);
$parcel$export(module.exports, "default", () => $4d6eff9662744af7$export$2e2bcd8739ae039);

var $lzAfn = parcelRequire("lzAfn");

var $5aCXJ = parcelRequire("5aCXJ");

var $7vSev = parcelRequire("7vSev");

var $aJpL9 = parcelRequire("aJpL9");

var $2ZObX = parcelRequire("2ZObX");

var $53rlc = parcelRequire("53rlc");

var $jKBwQ = parcelRequire("jKBwQ");
const $4d6eff9662744af7$export$887a842045ce5826 = 1000;
const $4d6eff9662744af7$export$20a2bfdf672c7448 = 10000;
class $4d6eff9662744af7$export$2e2bcd8739ae039 {
    constructor(tokenManager){
        this.waitingInitUrls = [];
        (0, $7vSev.default)('MediaEmojiCache');
        this.mediaImageLoader = new (0, $53rlc.default)(tokenManager);
    }
    loadEmoji(emoji, useAlt) {
        const representation = (0, $2ZObX.getRequiredRepresentation)(emoji, useAlt);
        if (!(0, $lzAfn.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const emojiCache = this.getCache(mediaPath);
        if ((0, $5aCXJ.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
        return emojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(url) {
        const emojiCache = this.getCache(url);
        if ((0, $5aCXJ.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
        return emojiCache.optimisticRendering();
    }
    getCache(url) {
        if (this.cache) return this.cache;
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
            this.cache = cache;
            this.cacheLoading = undefined;
            return cache;
        }).catch((err)=>{
            this.cacheLoading = undefined;
            throw err;
        });
        return this.cacheLoading;
    }
    initCache() {
        const url = this.waitingInitUrls.pop();
        if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
        return (0, $aJpL9.BrowserCacheStrategy).supported(url, this.mediaImageLoader).then((supported)=>{
            this.waitingInitUrls = []; // clear
            this.cacheLoading = undefined;
            if (supported) return new (0, $aJpL9.BrowserCacheStrategy)(this.mediaImageLoader);
            return new (0, $jKBwQ.MemoryCacheStrategy)(this.mediaImageLoader);
        }).catch(()=>{
            return this.initCache();
        });
    }
}

});
parcelRegister("aJpL9", function(module, exports) {
$parcel$export(module.exports, "BrowserCacheStrategy", () => $e36a3eab7434adb9$export$3850f566ce8d817a);

var $lzAfn = parcelRequire("lzAfn");

var $7vSev = parcelRequire("7vSev");

var $2ZObX = parcelRequire("2ZObX");
const $e36a3eab7434adb9$var$isUnsupportedBrowser = ()=>{
    const isIE = !!document.documentMode; // Internet Explorer 6-11
    const isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
class $e36a3eab7434adb9$export$3850f566ce8d817a {
    constructor(mediaImageLoader){
        this.cachedImageUrls = new Set();
        (0, $7vSev.default)('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
    loadEmoji(emoji, useAlt) {
        const representation = (0, $2ZObX.getRequiredRepresentation)(emoji, useAlt);
        if (!(0, $lzAfn.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        if (this.cachedImageUrls.has(mediaPath)) // Already cached
        return emoji;
        return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
            // Media is loaded, can use original URL now, so just return original emoji
            this.cachedImageUrls.add(mediaPath);
            return emoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return true;
    }
    static supported(mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if ($e36a3eab7434adb9$var$isUnsupportedBrowser()) return Promise.resolve(false);
        return mediaImageLoader.loadMediaImage(mediaPath).then(()=>// Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            new Promise((resolve)=>{
                const img = new Image();
                img.addEventListener('load', ()=>{
                    resolve(true);
                });
                img.addEventListener('error', ()=>{
                    resolve(false);
                });
                img.src = mediaPath;
            })).catch(()=>false);
    }
}

});
parcelRegister("2ZObX", function(module, exports) {
$parcel$export(module.exports, "getRequiredRepresentation", () => $6f27979b29a32b4a$export$6875157046b6a22d);
const $6f27979b29a32b4a$export$6875157046b6a22d = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;

});


parcelRegister("53rlc", function(module, exports) {
$parcel$export(module.exports, "default", () => $2469a1a7e0d043e0$export$2e2bcd8739ae039);

var $glLGx = parcelRequire("glLGx");
const $2469a1a7e0d043e0$var$defaultConcurrentDownloadLimit = 16;
const $2469a1a7e0d043e0$var$backoffMaxDelayInMillis = 600;
const $2469a1a7e0d043e0$var$defaultMaxRetriesOnNotFound = 2;
class $2469a1a7e0d043e0$export$2e2bcd8739ae039 {
    constructor(tokenManager, options){
        this.mediaImageQueue = [];
        this.activeProcessing = 0;
        this.pendingRequests = new Map();
        this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $2469a1a7e0d043e0$var$defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
    loadMediaImage(url) {
        const maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) return maybePending;
        const pending = new Promise((resolve, reject)=>{
            this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject
            });
            this.processFromQueue();
        }).then((result)=>{
            this.pendingRequests.delete(url);
            return result;
        }).catch((error)=>{
            this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    }
    getQueueSize() {
        return this.mediaImageQueue.length;
    }
    getActiveDownloads() {
        return this.activeProcessing;
    }
    processFromQueue() {
        while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
            this.activeProcessing++;
            const item = this.mediaImageQueue.shift();
            const { url: url, resolve: resolve, reject: reject } = item;
            this.tokenManager.getToken('read', false).then((token)=>{
                this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                    resolve(dataURL);
                    this.completedItem();
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }).catch((error)=>{
                // Failed to load, just resolve to original emoji
                reject(error);
                this.completedItem();
            });
        }
    }
    completedItem() {
        this.activeProcessing--;
        this.processFromQueue();
    }
    delay(durationInMillis) {
        return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
    }
    requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $2469a1a7e0d043e0$var$defaultMaxRetriesOnNotFound) {
        return (0, $glLGx.imageAcceptHeader)().then((acceptHeader)=>{
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            const options = {
                headers: {
                    Authorization: `Bearer ${token.jwt}`,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader
                }
            };
            return fetch(url, options).then((response)=>{
                // retry if 404
                if (response.status === 404 && retriesOnNotFound > 0) return this.delay($2469a1a7e0d043e0$var$backoffMaxDelayInMillis / retriesOnNotFound) // backoff strategy
                .then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                else if (response.status === 403 && retryOnAuthError) // retry once if 403
                return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
            });
        });
    }
    readBlob(blob) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', ()=>resolve(reader.result));
            reader.addEventListener('error', ()=>reject(reader.error));
            reader.readAsDataURL(blob);
        });
    }
}

});
parcelRegister("glLGx", function(module, exports) {
$parcel$export(module.exports, "getNaturalImageSize", () => $5a7dfde85b5ee955$export$90153ab95f408dfa);
$parcel$export(module.exports, "parseImage", () => $5a7dfde85b5ee955$export$37bbb051492a18a7);
$parcel$export(module.exports, "hasFileExceededSize", () => $5a7dfde85b5ee955$export$a115ddd5941792f1);
$parcel$export(module.exports, "imageAcceptHeader", () => $5a7dfde85b5ee955$export$f8e7886bc155c2e6);
const $5a7dfde85b5ee955$var$maxEmojiSizeInBytes = 1048576;
const $5a7dfde85b5ee955$export$90153ab95f408dfa = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.addEventListener('load', ()=>{
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
const $5a7dfde85b5ee955$export$37bbb051492a18a7 = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        let img = new Image();
        img.onload = ()=>resolve({
                src: img.src
            });
        img.onerror = ()=>reject();
        img.src = dataURL;
    });
};
const $5a7dfde85b5ee955$export$a115ddd5941792f1 = (file)=>{
    return file && file.size > $5a7dfde85b5ee955$var$maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */ let $5a7dfde85b5ee955$var$isWebpSupported;
const $5a7dfde85b5ee955$export$c5a964eb84c7fca8 = ()=>{
    if ($5a7dfde85b5ee955$var$isWebpSupported !== undefined) return Promise.resolve($5a7dfde85b5ee955$var$isWebpSupported);
    return new Promise((resolve)=>{
        const img = new Image();
        const checkSupport = ()=>{
            $5a7dfde85b5ee955$var$isWebpSupported = img.height === 2;
            resolve($5a7dfde85b5ee955$var$isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
const $5a7dfde85b5ee955$export$f8e7886bc155c2e6 = ()=>$5a7dfde85b5ee955$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });

});


parcelRegister("jKBwQ", function(module, exports) {
$parcel$export(module.exports, "MemoryCacheStrategy", () => $60cef3ba160e634c$export$b522858a3709f4c);

var $lN2R9 = parcelRequire("lN2R9");

var $2Tsh1 = parcelRequire("2Tsh1");

var $lzAfn = parcelRequire("lzAfn");

var $7vSev = parcelRequire("7vSev");

var $irP7u = parcelRequire("irP7u");

var $2ZObX = parcelRequire("2ZObX");
class $60cef3ba160e634c$export$b522858a3709f4c {
    constructor(mediaImageLoader){
        (0, $7vSev.default)('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new (0, $lN2R9.LRUMap)((0, $irP7u.maxImageCached));
    }
    loadEmoji(emoji, useAlt) {
        const representation = (0, $2ZObX.getRequiredRepresentation)(emoji, useAlt);
        if (!(0, $lzAfn.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) // Already cached
        return (0, $2Tsh1.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
        // Not cached, load
        return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
            const loadedEmoji = (0, $2Tsh1.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            if (dataURL.length <= (0, $irP7u.maxImageSize)) // Only cache if not large than max size
            this.dataURLCache.set(mediaPath, dataURL);
            else (0, $7vSev.default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            return loadedEmoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return false;
    }
}

});
parcelRegister("2Tsh1", function(module, exports) {
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $2e957b00a841b827$export$f1a89a11f425faaa);

var $dFmib = parcelRequire("dFmib");

var $8JHJV = parcelRequire("8JHJV");

var $lzAfn = parcelRequire("lzAfn");
const $2e957b00a841b827$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!(0, $lzAfn.isMediaRepresentation)(mediaRepresentation) && !(0, $lzAfn.isMediaRepresentation)(mediaAltRepresentation)) return emoji;
    const representation = (0, $lzAfn.isMediaRepresentation)(mediaRepresentation) ? (0, $8JHJV.convertMediaToImageRepresentation)(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = (0, $lzAfn.isMediaRepresentation)(mediaAltRepresentation) ? (0, $8JHJV.convertMediaToImageRepresentation)(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return (0, $dFmib.buildEmojiDescriptionWithAltRepresentation)(baseEmoji, altRepresentation);
};

});
parcelRegister("8JHJV", function(module, exports) {
$parcel$export(module.exports, "convertMediaToImageRepresentation", () => $225fd8dc1ce5b23f$export$3197405d49d2e298);
const $225fd8dc1ce5b23f$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });

});




parcelRegister("dXaLZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3dd0bdecff61d7e4$export$2e2bcd8739ae039);
parcelRequire("eGjD9");
var $1x6rV = parcelRequire("1x6rV");
const $3dd0bdecff61d7e4$export$866c20c059277b6 = 30;
class $3dd0bdecff61d7e4$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig){
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
    isValidToken(mediaApiToken) {
        const nowInSeconds = Date.now() / 1000;
        const expiresAt = mediaApiToken.expiresAt - $3dd0bdecff61d7e4$export$866c20c059277b6;
        if (nowInSeconds < expiresAt) return true;
        return false;
    }
    fetchNewToken(type) {
        return (0, $1x6rV.utils).requestService(this.siteServiceConfig, {
            path: `token/${type}`
        });
    }
    addToken(type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken
        });
    }
    getToken(type, forceRefresh) {
        let tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
        if (mediaApiToken) {
            if (this.isValidToken(mediaApiToken) && !forceRefresh) // still valid
            return Promise.resolve(mediaApiToken);
        }
        if (activeTokenRefresh) // refresh token promise already active, return that
        return activeTokenRefresh;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
            tokenDetail.mediaApiToken = token;
            tokenDetail.activeTokenRefresh = undefined;
            return token;
        });
        return tokenDetail.activeTokenRefresh;
    }
}

});



parcelRegister("46jy7", function(module, exports) {
$parcel$export(module.exports, "EMOJI_SERVICEID", () => $6295504c2eb6b2cd$export$f3c4ed49c0fff3de);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_SERVICEID", () => $6295504c2eb6b2cd$export$f8b39b441e3e8eb2);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID", () => $6295504c2eb6b2cd$export$2cdcb9248b6d4704);
$parcel$export(module.exports, "getServiceProvider", () => $6295504c2eb6b2cd$export$a4c27db78169052e);
/* eslint-disable jira/filename-case */ 
var $6bEm8 = parcelRequire("6bEm8");
const $6295504c2eb6b2cd$var$providersRepository = {};
const $6295504c2eb6b2cd$export$f3c4ed49c0fff3de = 'emoji';
const $6295504c2eb6b2cd$export$f8b39b441e3e8eb2 = 'emoji-with-custom';
const $6295504c2eb6b2cd$export$2cdcb9248b6d4704 = 'emoji-with-custom-upload-disabled';
const $6295504c2eb6b2cd$var$getServiceBaseUrl = (serviceId)=>{
    if (serviceId === $6295504c2eb6b2cd$export$f8b39b441e3e8eb2 || serviceId === $6295504c2eb6b2cd$export$2cdcb9248b6d4704) return (0, $6bEm8.default)('ajs-fabric-emoji-url');
    return (0, $6bEm8.default)(`ajs-fabric-${serviceId}-url`);
};
const $6295504c2eb6b2cd$export$a4c27db78169052e = (serviceId, serviceProviderGenerator)=>{
    try {
        let serviceProvider = $6295504c2eb6b2cd$var$providersRepository[serviceId];
        if (serviceProvider === undefined) {
            const serviceBaseUrl = $6295504c2eb6b2cd$var$getServiceBaseUrl(serviceId);
            if (serviceBaseUrl) {
                serviceProvider = Promise.resolve(serviceProviderGenerator(serviceBaseUrl));
                $6295504c2eb6b2cd$var$providersRepository[serviceId] = serviceProvider;
            }
        }
        return serviceProvider;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
};
const $6295504c2eb6b2cd$export$59790759c19337ec = ()=>{
    Object.keys($6295504c2eb6b2cd$var$providersRepository).forEach((key)=>{
        delete $6295504c2eb6b2cd$var$providersRepository[key];
    });
};
var $6295504c2eb6b2cd$export$2e2bcd8739ae039 = $6295504c2eb6b2cd$var$getServiceBaseUrl;

});



parcelRegister("1rRWW", function(module, exports) {
$parcel$export(module.exports, "NavigationCollectionsRemoteProvider", () => $b3a0e5eacd4c097c$export$8744e6344cf4e8b1);
$parcel$export(module.exports, "useNavigationCollectionsRemote", () => $b3a0e5eacd4c097c$export$5c273718cadebe06);
$parcel$export(module.exports, "NavigationViewRemoteProvider", () => $b3a0e5eacd4c097c$export$b11ce1c7833ed275);
$parcel$export(module.exports, "useNavigationViewRemote", () => $b3a0e5eacd4c097c$export$72a9c3a08b78443a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $kjHBg = parcelRequire("kjHBg");

var $hIuDa = parcelRequire("hIuDa");
const $b3a0e5eacd4c097c$var$createNavigationRemoteProvider = (createRemote)=>{
    const NavigationRemoteContext = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
    const NavigationRemoteProvider = ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
        const remote = (0, $euxye.useMemo)(()=>createRemote(createAnalyticsEvent), [
            createAnalyticsEvent
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(NavigationRemoteContext.Provider, {
            value: remote
        }, children);
    };
    const useNavigationRemote = ()=>(0, $euxye.useContext)(NavigationRemoteContext);
    return {
        NavigationRemoteProvider: NavigationRemoteProvider,
        useNavigationRemote: useNavigationRemote
    };
};
const $b3a0e5eacd4c097c$var$collectionsResult = $b3a0e5eacd4c097c$var$createNavigationRemoteProvider((0, $kjHBg.createNavigationCollectionsRemote));
const $b3a0e5eacd4c097c$export$8744e6344cf4e8b1 = $b3a0e5eacd4c097c$var$collectionsResult.NavigationRemoteProvider;
const $b3a0e5eacd4c097c$export$5c273718cadebe06 = $b3a0e5eacd4c097c$var$collectionsResult.useNavigationRemote;
const $b3a0e5eacd4c097c$var$viewResult = $b3a0e5eacd4c097c$var$createNavigationRemoteProvider((0, $hIuDa.createNavigationViewRemote));
const $b3a0e5eacd4c097c$export$b11ce1c7833ed275 = $b3a0e5eacd4c097c$var$viewResult.NavigationRemoteProvider;
const $b3a0e5eacd4c097c$export$72a9c3a08b78443a = $b3a0e5eacd4c097c$var$viewResult.useNavigationRemote;

});
parcelRegister("kjHBg", function(module, exports) {
$parcel$export(module.exports, "createNavigationCollectionsRemote", () => $63445bfff63a135f$export$505dbb10d5127476);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5WP8k = parcelRequire("5WP8k");
const $63445bfff63a135f$export$505dbb10d5127476 = (_)=>({
        fetch: ()=>(0, $5WP8k.fetchAllCollections)(),
        fetchCollection: (collectionUUID)=>(0, $5WP8k.fetchCollection)(collectionUUID)
    });

});

parcelRegister("hIuDa", function(module, exports) {
$parcel$export(module.exports, "createNavigationViewRemote", () => $3c943e1a11fa6eb4$export$ee65d5a0c3cd45a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $j1KDb = parcelRequire("j1KDb");

var $2Baxe = parcelRequire("2Baxe");

var $5uNbW = parcelRequire("5uNbW");

var $8bsTC = parcelRequire("8bsTC");

var $ecWWk = parcelRequire("ecWWk");

var $cgB0X = parcelRequire("cgB0X");

var $4BBh0 = parcelRequire("4BBh0");

var $aQKzd = parcelRequire("aQKzd");
const $3c943e1a11fa6eb4$export$ee65d5a0c3cd45a = (createAnalyticsEvent)=>({
        // Fetch all views for a specific collection
        fetch: async (collectionUUID)=>{
            const startAt = Date.now();
            try {
                const views = await (0, $j1KDb.fetchCollectionsViews)(collectionUUID).then((0, $aQKzd.transformViews));
                (0, $4BBh0.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({
                    duration: Date.now() - startAt
                }), 'fetchRoadmapsNavigationViews success');
                return views;
            } catch (error) {
                (0, $4BBh0.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({
                    duration: Date.now() - startAt
                }), 'fetchRoadmapsNavigationViews failure');
                throw error;
            }
        },
        fetchView: async (viewUUID)=>(0, $j1KDb.fetchView)(viewUUID).then((0, $aQKzd.transformView)),
        createView: async ({ viewType: viewType, ...rest })=>(0, $5uNbW.createView)({
                viewType: (0, $aQKzd.convertViewTypeToRemote)(viewType),
                ...rest
            }).then((0, $aQKzd.transformView)),
        updateView: async ({ id: id, viewType: viewType, name: name, emoji: emoji })=>{
            const params = {
                viewType: (0, $aQKzd.convertViewTypeToRemote)(viewType),
                name: name,
                emoji: emoji
            };
            return (0, $ecWWk.updateView)(id, params).then((0, $aQKzd.transformView));
        },
        cloneView: async ({ id: id, viewType: viewType, name: name, emoji: emoji })=>{
            const params = {
                viewType: (0, $aQKzd.convertViewTypeToRemote)(viewType),
                name: name,
                emoji: emoji
            };
            return (0, $2Baxe.cloneView)(id, params).then((0, $aQKzd.transformView));
        },
        rankView: async ({ id: id, rankIndex: rankIndex, parentId: parentId, containerId: containerId })=>(0, $cgB0X.collectionRankView)({
                collectionUUID: containerId,
                parentUUID: parentId,
                rank: rankIndex,
                viewUUID: id
            }),
        deleteView: async ({ viewId: viewId })=>(0, $8bsTC.deleteView)(viewId)
    });

});
parcelRegister("j1KDb", function(module, exports) {
$parcel$export(module.exports, "fetchView", () => $d92bd4555e48dc09$export$add2e0e4d5483696);
$parcel$export(module.exports, "fetchProjectsViews", () => $d92bd4555e48dc09$export$be96dda0a2d21597);
$parcel$export(module.exports, "fetchCollectionsViews", () => $d92bd4555e48dc09$export$1a6c876a65389461);

var $2wtso = parcelRequire("2wtso");

var $hn9Lv = parcelRequire("hn9Lv");

var $4fhEY = parcelRequire("4fhEY");

var $i860n = parcelRequire("i860n");

var $aeosY = parcelRequire("aeosY");
const $d92bd4555e48dc09$export$add2e0e4d5483696 = (viewUUID)=>(0, $4fhEY.default)(`${(0, $2wtso.getJpdViewsServicePathPrefix)()}/v1/views/${viewUUID}?operation=getJpdNavigationView`);
const $d92bd4555e48dc09$var$fetchViewsFactory = (type)=>(id)=>(0, $4fhEY.default)(`${(0, $2wtso.getJpdViewsServicePathPrefix)()}/v1/navigation/${type}/${id}/views?operation=getJpdNavigationViews`).then((response)=>(0, $i860n.fg)('polaris_global_views') ? [
                ...(response?.globalViews ?? []).map((view)=>({
                        ...view,
                        global: true
                    })),
                ...response.views ?? []
            ] : response.views ?? []);
const $d92bd4555e48dc09$var$getProjectsViews = $d92bd4555e48dc09$var$fetchViewsFactory('projects');
const $d92bd4555e48dc09$export$be96dda0a2d21597 = (projectId)=>{
    // Check if we have early fetched data
    const cachedPromise = (0, $aeosY.getEarlyFetchResponse)(projectId);
    if (cachedPromise) return (0, $hn9Lv.wrapPromiseWithFetchInteraction)(cachedPromise, 'earlyScript/getJpdNavigationViews').catch(()=>{
        // If the cached promise fails, fall back to a regular fetch
        return $d92bd4555e48dc09$var$getProjectsViews(projectId);
    });
    // If no early fetched data is available, perform the fetch
    return $d92bd4555e48dc09$var$getProjectsViews(projectId);
};
const $d92bd4555e48dc09$export$1a6c876a65389461 = $d92bd4555e48dc09$var$fetchViewsFactory('collections');

});
parcelRegister("hn9Lv", function(module, exports) {
$parcel$export(module.exports, "wrapPromiseWithFetchInteraction", () => $e1b4d6ada02ad3e2$export$6819d892dfd1cee3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $siTdT = parcelRequire("siTdT");
const $e1b4d6ada02ad3e2$export$6819d892dfd1cee3 = (promise, name, type = 'fetch')=>{
    const fetchStartTime = performance.now();
    return promise.then((response)=>{
        (0, $siTdT.addSpanToAll)(type, name, [
            {
                name: 'network'
            },
            {
                name: 'jpdApp'
            }
        ], fetchStartTime, performance.now());
        return response;
    });
};

});

parcelRegister("aeosY", function(module, exports) {
$parcel$export(module.exports, "getEarlyFetchResponse", () => $b4bedabab6abc6b1$export$b9d6f7ad3c414536);
$parcel$export(module.exports, "runGetNavigationProjectViewsEarlyScript", () => $b4bedabab6abc6b1$export$5305ce082de86e9a);

var $3HFzJ = parcelRequire("3HFzJ");

var $7FcOv = parcelRequire("7FcOv");

var $2snMp = parcelRequire("2snMp");

var $7U9nQ = parcelRequire("7U9nQ");

var $hWVxx = parcelRequire("hWVxx");

var $eQXnX = parcelRequire("eQXnX");

var $2wtso = parcelRequire("2wtso");

var $i860n = parcelRequire("i860n");
const $b4bedabab6abc6b1$var$earlyFetchCache = (0, $3HFzJ.createEarlyFetchCache)({
    paramsEqualityFn: (paramsA, paramsB)=>String(paramsA) === String(paramsB)
});
const $b4bedabab6abc6b1$export$b9d6f7ad3c414536 = (projectId)=>{
    return $b4bedabab6abc6b1$var$earlyFetchCache.getCachedResponse(projectId);
};
/**
 * Helper function to fetch project views with proper type
 */ const $b4bedabab6abc6b1$var$fetchProjectViews = (projectId)=>{
    const url = `${(0, $2wtso.getJpdViewsServicePathPrefix)()}/v1/navigation/projects/${projectId}/views?operation=getJpdNavigationViews`;
    return (0, $7FcOv.fetchData)({
        url: url,
        method: 'GET'
    }).then((response)=>(0, $i860n.fg)('polaris_global_views') ? [
            ...(response.globalViews ?? []).map((view)=>({
                    ...view,
                    global: true
                })),
            ...response.views ?? []
        ] : response.views ?? []);
};
const $b4bedabab6abc6b1$export$f468a26906882b9c = (projectId)=>{
    // Execute the actual fetch for project views
    const response = $b4bedabab6abc6b1$var$fetchProjectViews(projectId);
    // Store the fetch promise in the cache
    $b4bedabab6abc6b1$var$earlyFetchCache.setCacheResponse(response, projectId);
};
function $b4bedabab6abc6b1$export$5305ce082de86e9a(location) {
    // Parse the location to extract the necessary parameters
    const projectKey = (0, $eQXnX.getProjectKeyFromLocation)(location);
    if (!projectKey) return false;
    // Use cached projectId if available, otherwise wait for SPA_STATE
    (0, $hWVxx.getProjectIdFromMap)(projectKey, (0, $2snMp.waitForGlobalVariable)).then((projectId)=>{
        if (projectId) $b4bedabab6abc6b1$export$f468a26906882b9c(Number(projectId));
    }).catch((error)=>{
        (0, $7U9nQ.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.project-id-mapping', 'Error fetching project views', error instanceof Error ? error : new Error(String(error)));
    });
    return true;
}

});
parcelRegister("3HFzJ", function(module, exports) {
$parcel$export(module.exports, "createEarlyFetchCache", () => $49cae421f2f8cb98$export$64bbd812926dd865);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bxhpq = parcelRequire("bxhpq");
class $49cae421f2f8cb98$export$60288a72c0bd9021 {
    constructor(options){
        this.paramsEqualityFn = options.paramsEqualityFn || this.defaultParamsEqual;
        this.cache = {
            response: null,
            accessed: false,
            params: null
        };
    }
    /**
	 * Default parameter comparison function
	 * Deep compares two parameter objects to ensure they are equivalent
	 */ defaultParamsEqual(paramsA, paramsB) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(paramsA, paramsB);
    }
    /**
	 * Compares two parameter objects using the configured comparison function
	 */ areParamsEqual(paramsA, paramsB) {
        return this.paramsEqualityFn(paramsA, paramsB);
    }
    /**
	 * Clears the early fetch cache
	 * This function can be called to reset the cache when needed
	 */ clearCache() {
        this.cache.response = null;
        this.cache.accessed = false;
        this.cache.params = null;
    }
    /**
	 * Sets the response in the cache with the associated parameters
	 */ setCacheResponse(response, params) {
        this.cache.response = response;
        this.cache.params = params;
        this.cache.accessed = false;
    }
    /**
	 * Gets the cached response if it matches the provided parameters and marks it as accessed
	 * The cache will be automatically cleared after the promise resolves and has been accessed
	 */ getCachedResponse(params) {
        // Check if there's no response
        if (!this.cache.response) return null;
        // Check if params match the cached params
        if (!this.cache.params || !this.areParamsEqual(this.cache.params, params)) {
            this.clearCache();
            return null;
        }
        // Set up promise settlement handler only on first access to avoid multiple handlers
        if (!this.cache.accessed) {
            // Mark as accessed
            this.cache.accessed = true;
            // Set up promise settlement handler to clear cache after promise settles
            this.cache.response.finally(()=>{
                // Clear cache when promise has settled (resolved or rejected)
                this.clearCache();
            });
        }
        return this.cache.response;
    }
}
$49cae421f2f8cb98$export$60288a72c0bd9021.displayName = "EarlyFetchCache";
function $49cae421f2f8cb98$export$64bbd812926dd865(options) {
    return new $49cae421f2f8cb98$export$60288a72c0bd9021(options);
}

});

parcelRegister("7FcOv", function(module, exports) {
$parcel$export(module.exports, "fetchData", () => $e8b3eb1a56b48056$export$8134c072fddab6a5);
$parcel$export(module.exports, "fetchRelayData", () => $e8b3eb1a56b48056$export$9b25b17ce9a87eca);

var $fcq2N = parcelRequire("fcq2N");

var $fdVFf = parcelRequire("fdVFf");

var $ah85A = parcelRequire("ah85A");

var $5DFoO = parcelRequire("5DFoO");

var $8yIUg = parcelRequire("8yIUg");

var $anDmR = parcelRequire("anDmR");
const $e8b3eb1a56b48056$export$8134c072fddab6a5 = ({ url: url, body: body, method: method = 'GET', headers: headers })=>{
    (0, $fdVFf.setMark)('jira.fe-spa.jpd.early-preload:start');
    return fetch(url, {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            Accept: [
                'application/json',
                'text/javascript'
            ].join(','),
            ...(0, $anDmR.getActiveTraceHttpRequestHeaders)(),
            ...headers
        },
        method: method,
        body: body
    }).then((response)=>{
        (0, $fdVFf.setMark)('jira.fe-spa.jpd.early-preload:end');
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = (0, $fdVFf.getTraceId)(response);
                throw new (0, $ah85A.FetchError)(status, str, traceId || undefined);
            });
        }
        // oxlint-disable-next-line typescript/consistent-type-assertions
        return response.json();
    });
};
// Replace with Promise.withResolvers once available
const $e8b3eb1a56b48056$var$withResolvers = ()=>{
    let resolve = (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)));
    let reject = (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)));
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        resolve: resolve,
        reject: reject,
        promise: promise
    };
};
async function $e8b3eb1a56b48056$export$9b25b17ce9a87eca(query, variables) {
    (0, $fdVFf.setMark)('jira.fe-spa.jpd.early-preload:start');
    // earlyFetch is responsible for storing the promise in the cache map
    // and triggering request in the background
    (0, $5DFoO.earlyFetch)(query, variables);
    // The cache map should already have the promise so we can work with it
    const promiseKey = (0, $8yIUg.getEarlyScriptPromiseKey)(query.params, variables);
    const promise = (0, $8yIUg.EarlyScriptQueryPromisesMap).get(promiseKey);
    if (!promise) throw new Error(`Early script promise not found: ${promiseKey}`);
    // We want to quickly override cache map with a decorated promise that will be resolved later
    // after the actual response is received
    const { promise: decoratedPromise, resolve: resolve } = $e8b3eb1a56b48056$var$withResolvers();
    (0, $8yIUg.EarlyScriptQueryPromisesMap).set(promiseKey, decoratedPromise);
    const response = await promise;
    (0, $fdVFf.setMark)('jira.fe-spa.jpd.early-preload:end');
    if (!response.ok) {
        resolve(response);
        const { status: status } = response;
        const text = await response.text();
        const traceId = (0, $fdVFf.getTraceId)(response);
        throw new (0, $ah85A.FetchError)(status, text, traceId || undefined);
    }
    const responseJson = await response.json();
    const decoratedResponse = Object.assign(response, {
        // Response.json() can be consumed only once, so we need to override it
        // with a new promise that will resolve to the actual data
        // so it can be called multiple times
        json: ()=>Promise.resolve(responseJson)
    });
    resolve(decoratedResponse);
    return responseJson;
}

});
parcelRegister("fdVFf", function(module, exports) {
$parcel$export(module.exports, "setMark", () => $ac945a3211528389$export$f7a1fb90d8604165);
$parcel$export(module.exports, "getTraceId", () => $ac945a3211528389$export$e88cb5bfb57ce9c4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
const $ac945a3211528389$export$f7a1fb90d8604165 = (mark)=>{
    if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
    performance.mark(mark);
};
const $ac945a3211528389$var$TRACE_ID_HEADER = 'atl-traceid';
const $ac945a3211528389$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $ac945a3211528389$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($ac945a3211528389$var$TRACE_ID_HEADER) || response.headers.get($ac945a3211528389$var$TRACE_ID_HEADER_MICROS);

});

parcelRegister("ah85A", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $7798157ede1d6081$export$26e841bcf1aeb894);
$parcel$export(module.exports, "ResponseNullError", () => $7798157ede1d6081$export$895e385291c3b753);
/* eslint-disable jira/filename-case */ /* oxlint-disable max-classes-per-file */ class $7798157ede1d6081$var$ExtensibleError extends Error {
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
$7798157ede1d6081$var$ExtensibleError.displayName = "ExtensibleError";
class $7798157ede1d6081$export$26e841bcf1aeb894 extends $7798157ede1d6081$var$ExtensibleError {
    constructor(statusCode, message, traceId){
        super(message == null ? `Fetch call failed with status code: ${statusCode}` : message), this.graphQLErrors = [];
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.networkError = {
            statusCode: statusCode
        };
        this.skipSentry = true;
        if (traceId != null) this.traceId = traceId;
    }
}
$7798157ede1d6081$export$26e841bcf1aeb894.displayName = "FetchError";
class $7798157ede1d6081$export$895e385291c3b753 extends $7798157ede1d6081$var$ExtensibleError {
    constructor(message){
        super(message);
        this.name = 'ResponseNullError';
        this.skipSentry = true;
    }
}
$7798157ede1d6081$export$895e385291c3b753.displayName = "ResponseNullError";

});

parcelRegister("5DFoO", function(module, exports) {
$parcel$export(module.exports, "earlyFetch", () => $395093a41b9a8be1$export$5b55058781674413);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fdVFf = parcelRequire("fdVFf");

var $6Xwrx = parcelRequire("6Xwrx");

var $cGqKz = parcelRequire("cGqKz");

var $8yIUg = parcelRequire("8yIUg");

var $6b5L5 = parcelRequire("6b5L5");
const $395093a41b9a8be1$export$5b55058781674413 = (compiledQuery, variables)=>{
    (0, $fdVFf.setMark)('jira.fe-spa.early-preload:start');
    const endpoint = (0, $6b5L5.getAggEndpoint)(compiledQuery.params);
    const body = (0, $6b5L5.getRequestBody)(compiledQuery.params, variables);
    const fetchOverNetwork = (0, $6Xwrx.buildGraphqlFetch)(endpoint, (0, $cGqKz.generateOptions)({
        body: body
    }, endpoint));
    (0, $8yIUg.putEarlyScriptPromise)((0, $8yIUg.getEarlyScriptPromiseKey)(compiledQuery.params, variables), fetchOverNetwork().then((response)=>{
        (0, $fdVFf.setMark)('jira.fe-spa.early-preload:end');
        return response;
    }));
};

});
parcelRegister("6Xwrx", function(module, exports) {
$parcel$export(module.exports, "buildGraphqlFetch", () => $600fc4da085d7f03$export$744180da2870332e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6Fltw = parcelRequire("6Fltw");

var $jVTHL = parcelRequire("jVTHL");

var $5cVSt = parcelRequire("5cVSt");

var $ff8AH = parcelRequire("ff8AH");
const $600fc4da085d7f03$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
].join(', ');
function $600fc4da085d7f03$export$744180da2870332e(url, options) {
    const postOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: $600fc4da085d7f03$var$relayDeferAcceptableFormats
        }
    };
    const composedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))((0, $ff8AH.getDefaultOptions)(url), options, postOptions);
    const fetchUrl = (0, $jVTHL.getReroutableURL)(url);
    const fetchHeaders = (0, $5cVSt.applyObservabilityHeaders)(url, composedOptions);
    return ()=>fetch(fetchUrl, fetchHeaders);
}

});



parcelRegister("2snMp", function(module, exports) {
$parcel$export(module.exports, "waitForGlobalVariable", () => $e3dea36fbe337fce$export$8ef1adf6e9aa0f76);

var $63gbl = parcelRequire("63gbl");

var $7U9nQ = parcelRequire("7U9nQ");
const $e3dea36fbe337fce$export$8ef1adf6e9aa0f76 = (varName, timeout = 2000)=>{
    const start = performance.now();
    let promise = new Promise((resolve, reject)=>{
        let rafId;
        let timeoutId;
        let completed = false;
        /**
		 * Cleanup function to cancel animation frames and clear timeouts
		 */ const cleanup = ()=>{
            if (rafId) cancelAnimationFrame(rafId);
            if (timeoutId) clearTimeout(timeoutId);
        };
        /**
		 * Check if the variable is available on the window object
		 */ const check = ()=>{
            // Check if variable exists and is not undefined
            const windowObj = globalThis?.window;
            if (windowObj && Reflect.has(windowObj, varName)) {
                const value = Reflect.get(windowObj, varName);
                if (value !== undefined) {
                    completed = true;
                    cleanup();
                    resolve(value);
                    return;
                }
            }
            // Continue polling using requestAnimationFrame
            rafId = requestAnimationFrame(check);
        };
        // Set up timeout to reject if variable is not found
        timeoutId = setTimeout(()=>{
            if (!completed) {
                completed = true;
                cleanup();
                reject(new Error(`Variable ${varName} not found within ${timeout}ms`));
            }
        }, timeout);
        // Start checking for the variable
        check();
    });
    promise = promise.then((value)=>{
        (0, $7U9nQ.getEarlyScriptObservabilityCache)()?.recordMetric('custom', 'global-variable-polling', [
            {
                name: 'jpdApp'
            },
            {
                name: 'earlyScript'
            }
        ], start, performance.now());
        (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.early-fetch-cache.waitForGlobalVariable', `SPA_STATE variable '${varName}' became available after ${Math.round(performance.now() - start)}ms`);
        return value;
    }).catch((error)=>{
        (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.early-fetch-cache.waitForGlobalVariable', `SPA_STATE variable '${varName}' was not available within ${timeout}ms timeout`, error);
        throw error;
    });
    return promise;
};

});
parcelRegister("7U9nQ", function(module, exports) {
$parcel$export(module.exports, "getEarlyScriptObservabilityCache", () => $64c1824c4e0f5b2f$export$50bbab1d25016c83);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // Types for the cache entries
class $64c1824c4e0f5b2f$export$c22cddd926aebf66 {
    // Error methods following the same pattern as flags.tsx
    recordError(location, message, error) {
        const entry = {
            location: location,
            message: message,
            error: error
        };
        this.errors.push(entry);
        this.trimErrors();
    }
    // Metric methods following the same pattern as addSpanToAll
    recordMetric(spanType, name, tags, start, end, size) {
        const entry = {
            spanType: spanType,
            name: name,
            tags: tags,
            start: start,
            end: end,
            size: size
        };
        this.metrics.push(entry);
        this.trimMetrics();
    }
    // Retrieval methods
    getErrors() {
        return [
            ...this.errors
        ];
    }
    getMetrics() {
        return [
            ...this.metrics
        ];
    }
    // Clear methods
    clearErrors() {
        this.errors = [];
    }
    clearMetrics() {
        this.metrics = [];
    }
    clearAll() {
        this.clearErrors();
        this.clearMetrics();
    }
    // Utility methods for cache maintenance
    trimErrors() {
        if (this.errors.length > this.maxEntries) this.errors = this.errors.slice(-this.maxEntries);
    }
    trimMetrics() {
        if (this.metrics.length > this.maxEntries) this.metrics = this.metrics.slice(-this.maxEntries);
    }
    constructor(){
        this.errors = [];
        this.metrics = [];
        this.maxEntries = 1000; // Prevent unlimited growth
    }
}
$64c1824c4e0f5b2f$export$c22cddd926aebf66.displayName = "EarlyScriptObservabilityCache";
// Export singleton instance
let $64c1824c4e0f5b2f$var$earlyScriptObservabilityCache = null;
const $64c1824c4e0f5b2f$export$50bbab1d25016c83 = ()=>{
    if (!$64c1824c4e0f5b2f$var$earlyScriptObservabilityCache) $64c1824c4e0f5b2f$var$earlyScriptObservabilityCache = new $64c1824c4e0f5b2f$export$c22cddd926aebf66();
    return $64c1824c4e0f5b2f$var$earlyScriptObservabilityCache;
};

});


parcelRegister("hWVxx", function(module, exports) {
$parcel$export(module.exports, "setProjectIdMapping", () => $15f484eaa6d3b112$export$ba6a56c6c4bc8990);
$parcel$export(module.exports, "getProjectIdFromMap", () => $15f484eaa6d3b112$export$7c93669a4602f775);

var $gXtG2 = parcelRequire("gXtG2");

var $8lgjN = parcelRequire("8lgjN");

var $44Y8O = parcelRequire("44Y8O");

var $7U9nQ = parcelRequire("7U9nQ");

// Singleton pattern for database initialization
let $15f484eaa6d3b112$var$dbInstance = null;
// Cache for individual project ID lookups
const $15f484eaa6d3b112$var$projectIdCache = new Map();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $15f484eaa6d3b112$var$projectIdCache.clear();
});
const $15f484eaa6d3b112$export$28e7436902e0cf8b = ()=>{
    // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage -- early-fetch-cache runs pre-bootstrap and needs raw IndexedDB; pre-existing usage frozen for ratcheting
    if (!globalThis.indexedDB) throw new Error('IndexedDB not supported');
    if ($15f484eaa6d3b112$var$dbInstance) return $15f484eaa6d3b112$var$dbInstance;
    $15f484eaa6d3b112$var$dbInstance = new Promise((resolve, reject)=>{
        const request = (0, $8lgjN.atlIndexedDb).open((0, $109cef2208c3f3c4$export$3c22ff8b64b8f565), (0, $109cef2208c3f3c4$export$6a9022b4c5fcea02));
        request.onerror = ()=>{
            // Reset the singleton on error so we can retry
            $15f484eaa6d3b112$var$dbInstance = null;
            reject(request.error);
        };
        // When routed through the Atlassian browser-storage-controls wrapper, a
        // consent-blocked open dispatches a `storageItemBlocked` event instead of
        // `error`, so it would otherwise never settle. `request.error` is null
        // here (this isn't a native IDB error), so reject with an explicit reason
        // instead so callers don't hang and get a meaningful cause.
        request.addEventListener('storageItemBlocked', ()=>{
            // Reset the singleton on error so we can retry
            $15f484eaa6d3b112$var$dbInstance = null;
            reject(new Error('IndexedDB open blocked by consent settings'));
        });
        request.onsuccess = ()=>resolve(request.result);
        request.onupgradeneeded = (_event)=>{
            const db = request.result;
            if (!db.objectStoreNames.contains((0, $109cef2208c3f3c4$export$cd79d01fb3d2f506))) db.createObjectStore((0, $109cef2208c3f3c4$export$cd79d01fb3d2f506), {
                keyPath: 'projectKey'
            });
        };
    });
    return $15f484eaa6d3b112$var$dbInstance;
};
/**
 * Get project ID mapping from IndexedDB
 */ const $15f484eaa6d3b112$var$getProjectIdMappingFromStorage = async (operation)=>{
    try {
        const db = await $15f484eaa6d3b112$export$28e7436902e0cf8b();
        const transaction = db.transaction([
            (0, $109cef2208c3f3c4$export$cd79d01fb3d2f506)
        ], 'readonly');
        const store = transaction.objectStore((0, $109cef2208c3f3c4$export$cd79d01fb3d2f506));
        const result = await Promise.race([
            new Promise((resolve)=>{
                const start = performance.now();
                const request = store.getAll();
                request.onsuccess = ()=>{
                    const records = request.result;
                    const mapping = {};
                    if (Array.isArray(records)) records.forEach((record)=>{
                        mapping[record.projectKey] = record.projectId;
                    });
                    resolve(mapping);
                    (0, $7U9nQ.getEarlyScriptObservabilityCache)()?.recordMetric('custom', `get-project-id-mapping-from-indexdb-success-on-${operation}`, [
                        {
                            name: 'jpdApp'
                        },
                        {
                            name: 'earlyScript'
                        }
                    ], start, performance.now());
                };
                request.onerror = ()=>{
                    (0, $7U9nQ.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.project-id-mapping.indexdb', 'IndexedDB getAll error');
                    resolve({});
                };
            }),
            new Promise((_, reject)=>setTimeout(()=>reject(new Error('IndexedDB read timed out')), (0, $109cef2208c3f3c4$export$c0c8fb0813dd1d2a)))
        ]);
        return result;
    } catch (error) {
        (0, $7U9nQ.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.project-id-mapping.indexdb', 'Error getting projectId from IndexedDB', error instanceof Error ? error : new Error(String(error)));
        // do nothing
        return {};
    }
};
/**
 * Set project ID mapping in IndexedDB
 */ const $15f484eaa6d3b112$var$setProjectIdMappingToStorage = async (mapping)=>{
    try {
        const start = performance.now();
        const db = await $15f484eaa6d3b112$export$28e7436902e0cf8b();
        const transaction = db.transaction([
            (0, $109cef2208c3f3c4$export$cd79d01fb3d2f506)
        ], 'readwrite');
        const store = transaction.objectStore((0, $109cef2208c3f3c4$export$cd79d01fb3d2f506));
        // Clear existing data
        await new Promise((resolve, reject)=>{
            const clearRequest = store.clear();
            clearRequest.onsuccess = ()=>resolve();
            clearRequest.onerror = ()=>{
                (0, $7U9nQ.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.project-id-mapping.indexdb', 'IndexedDB clear error');
                reject(clearRequest.error);
            };
        });
        // Add new data
        const promises = Object.entries(mapping).map(([projectKey, projectId])=>{
            return new Promise((resolve, reject)=>{
                const addRequest = store.add({
                    projectKey: projectKey,
                    projectId: projectId
                });
                addRequest.onsuccess = ()=>resolve();
                addRequest.onerror = ()=>{
                    (0, $7U9nQ.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.project-id-mapping.indexdb', 'IndexedDB add error');
                    reject(addRequest.error);
                };
            });
        });
        await Promise.all(promises);
        (0, $7U9nQ.getEarlyScriptObservabilityCache)()?.recordMetric('custom', 'set-project-id-mapping-to-indexdb', [
            {
                name: 'jpdApp'
            },
            {
                name: 'earlyScript'
            }
        ], start, performance.now());
    } catch (error) {
        (0, $7U9nQ.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.project-id-mapping.indexdb', 'Error setting projectId in IndexedDB', error instanceof Error ? error : new Error(String(error)));
    }
};
const $15f484eaa6d3b112$export$7c2e93c291d763b0 = async (projectKey)=>{
    const start = performance.now();
    const mapping = await $15f484eaa6d3b112$var$getProjectIdMappingFromStorage('read');
    (0, $7U9nQ.getEarlyScriptObservabilityCache)()?.recordMetric('custom', 'get-project-id-from-map', [
        {
            name: 'jpdApp'
        },
        {
            name: 'earlyScript'
        }
    ], start, performance.now());
    return mapping[projectKey] || null;
};
const $15f484eaa6d3b112$export$ba6a56c6c4bc8990 = async (projectKey, projectId)=>{
    const start = performance.now();
    const mapping = await $15f484eaa6d3b112$var$getProjectIdMappingFromStorage('write');
    // Check if the mapping already exists with the same value
    if (mapping?.[projectKey] === projectId) // Mapping already exists with the correct value, no need to update
    return;
    mapping[projectKey] = projectId;
    await $15f484eaa6d3b112$var$setProjectIdMappingToStorage(mapping);
    (0, $7U9nQ.getEarlyScriptObservabilityCache)()?.recordMetric('custom', 'set-project-id-mapping', [
        {
            name: 'jpdApp'
        },
        {
            name: 'earlyScript'
        }
    ], start, performance.now());
};
const $15f484eaa6d3b112$export$7c93669a4602f775 = async (projectKey, waitForGlobalVariable)=>{
    // Check cache first
    const cached = $15f484eaa6d3b112$var$projectIdCache.get(projectKey);
    if (cached && Date.now() < cached.expiry) return cached.promise;
    const createPromise = async ()=>{
        // First, try to get from mapping
        const mappedProjectId = await $15f484eaa6d3b112$export$7c2e93c291d763b0(projectKey);
        if (mappedProjectId !== null) return mappedProjectId;
        // If not in mapping, wait for SPA_STATE and extract projectId
        try {
            await waitForGlobalVariable('SPA_STATE');
            const projectId = (0, $44Y8O.getProjectIdFromSpaState)(projectKey);
            if (projectId) return projectId;
        } catch (error) {
            (0, $7U9nQ.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.wait-for-global-variable', 'Error getting projectId from SPA_STATE', error instanceof Error ? error : new Error(String(error)));
        }
        return null;
    };
    const promise = createPromise();
    // Cache the promise
    $15f484eaa6d3b112$var$projectIdCache.set(projectKey, {
        promise: promise,
        expiry: Date.now() + (0, $109cef2208c3f3c4$export$eca93c456abcab01)
    });
    return promise;
};

});
parcelRegister("8lgjN", function(module, exports) {
$parcel$export(module.exports, "atlIndexedDb", () => $bce5e2949de1a399$export$e65012c747534318);

var $iqfTZ = parcelRequire("iqfTZ");

var $c1I7W = parcelRequire("c1I7W");
var $2rFtA = parcelRequire("2rFtA");

var $bDj2g = parcelRequire("bDj2g");

var $j1sAG = parcelRequire("j1sAG");

var $5MrbU = parcelRequire("5MrbU");

var $lbJxq = parcelRequire("lbJxq");

var $fXApL = parcelRequire("fXApL");

var $vHD2x = parcelRequire("vHD2x");
const $bce5e2949de1a399$export$4702e9fd6e5f70a8 = async (dbName)=>{
    const availability = (0, $vHD2x.checkDBAvailability)();
    if (availability.bypassImplementation) // Fallback to allowing if it bypassed for any reason (support disabled, killswitch, etc)
    return true;
    let isAllowed;
    let resolvedItemCategory;
    ({ isAllowed: isAllowed, itemCategory: resolvedItemCategory } = await (0, $bDj2g.isProcessingAllowedByPreferencesWithCategory)({
        itemKey: dbName,
        storageType: (0, $5MrbU.CategoryStorageType).IndexedDB
    }));
    const categoryAttribute = resolvedItemCategory !== undefined ? {
        itemCategory: resolvedItemCategory ?? (0, $5MrbU.PreferenceCategory).Unknown
    } : {};
    (0, $2rFtA.sendPackageOperationalEvent)({
        action: 'usedAtlIndexedDBOpen',
        attributes: {
            databaseName: dbName,
            wasRejected: !isAllowed,
            ...categoryAttribute
        }
    });
    return isAllowed;
};
/**
 * AtlIndexedDb is a wrapper around the IDBFactory interface that provides
 * additional checks before opening the database, such as:
 * - SSR environment detection
 * - Feature flag checks
 * - Input validation
 * - Error logging
 *
 * When bypass mode is active, this wrapper skips special validation and delegates
 * directly to the configured IDBFactory, allowing the application to fall back to default
 * browser behavior.
 *
 * This class implements the IDBFactory interface and delegates all methods to the wrapped
 * IDBFactory instance.
 */ class $bce5e2949de1a399$export$f623e6c5a836bb02 {
    constructor(config){
        this.config = {
            enableSSRCheck: config?.enableSSRCheck ?? true,
            enableFeatureFlagCheck: config?.enableFeatureFlagCheck ?? true,
            noOpWhenUnavailable: config?.noOpWhenUnavailable ?? false,
            idbFactory: config?.idbFactory ?? globalThis.indexedDB
        };
        // Perform initial availability check
        const availabilityCheck = (0, $vHD2x.checkDBAvailability)(this.config.enableSSRCheck, this.config.enableFeatureFlagCheck);
        this.isAvailable = availabilityCheck.available;
        this.bypassImplementation = availabilityCheck.bypassImplementation ?? false;
        if (!this.isAvailable) {
            if (this.config.noOpWhenUnavailable) (0, $j1sAG.Logger).debug(`AtlIndexedDb unavailable (no-op mode): ${availabilityCheck.reason}`);
            else (0, $j1sAG.Logger).warn(`AtlIndexedDb initialization warning: ${availabilityCheck.reason}`);
        } else if (this.bypassImplementation) (0, $j1sAG.Logger).debug(`AtlIndexedDb bypassing implementation: ${availabilityCheck.reason}`);
    }
    getIsAvailable() {
        return this.isAvailable;
    }
    getIsBypassingImplementation() {
        return this.bypassImplementation;
    }
    /**
	 * Opens a database connection with additional validation and checks
	 * @param dbName - The name of the database to open
	 * @param version - Optional version number for the database
	 * @returns An IDBOpenDBRequest (use with event handlers or wrap in Promise for async/await)
	 * @throws Error if database name is invalid, IndexedDB is not available (unless bypass mode is active), or the wrapped IDBFactory throws an error
	 *
	 * When bypass mode is active, validation is skipped and the wrapped IDBFactory is used directly.
	 */ open(dbName, version) {
        (0, $j1sAG.Logger).debug(`IndexedDB operation: open on database \"${dbName}\"`, {
            version: String(version ?? 'unspecified')
        });
        if (!(0, $c1I7W.getBscGlobalState)().hasInitialized) (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: dbName,
                storageType: 'IndexedDB'
            }
        });
        // If bypass mode is active, skip implementation and use wrapped IDBFactory directly
        if (this.bypassImplementation) return this.config.idbFactory.open(dbName, version);
        if (!(0, $vHD2x.isValidDBName)(dbName)) {
            const error = new Error('Invalid database name: must be a non-empty string');
            (0, $j1sAG.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB open failed: ${error.message}`
            });
            throw error;
        }
        if (!(0, $vHD2x.isValidVersion)(version)) {
            const error = new Error('Invalid version: must be a positive integer or undefined');
            (0, $j1sAG.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB open failed: ${error.message}`
            });
            throw error;
        }
        const availabilityCheck = (0, $vHD2x.checkDBAvailability)(this.config.enableSSRCheck, this.config.enableFeatureFlagCheck);
        if (!availabilityCheck.available) {
            if (this.config.noOpWhenUnavailable) // In some runtimes (SSR/service worker), consumers still want to import a shared
            // instance without having to guard every call.
            return (0, $fXApL.createIDBOpenDBRequestWrapper)();
            const error = new Error(`Cannot open database: ${availabilityCheck.reason || 'IndexedDB is not available'}`);
            (0, $j1sAG.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB open failed: ${error.message}`
            });
            throw error;
        }
        const requestWrapper = (0, $fXApL.createIDBOpenDBRequestWrapper)();
        const globalState = (0, $c1I7W.getBscGlobalState)();
        const productName = globalState.product;
        let disableIndexedDbConsentChecks = globalState.disableIndexedDbConsentChecks ?? false;
        if ((0, $iqfTZ.fg)('jfp-magma-selective-storage-enforcement')) {
            const enforceThisKey = globalState.__UNSAFE_shouldEnforceKeyForRollout?.(dbName, (0, $5MrbU.CategoryStorageType).IndexedDB) === true;
            disableIndexedDbConsentChecks = (globalState.disableIndexedDbConsentChecks ?? false) && !enforceThisKey;
        }
        if (disableIndexedDbConsentChecks) {
            (0, $bDj2g.getItemCategory)(dbName, (0, $5MrbU.CategoryStorageType).IndexedDB, productName).then((itemCategory)=>{
                (0, $2rFtA.sendPackageOperationalEvent)({
                    action: 'usedAtlIndexedDBOpen',
                    attributes: {
                        databaseName: dbName,
                        wasRejected: false,
                        consentChecksDisabled: true,
                        itemCategory: itemCategory ?? (0, $5MrbU.PreferenceCategory).Unknown
                    }
                });
            }).catch((e)=>{
                const errorMessage = e instanceof Error ? e.message : String(e);
                (0, $j1sAG.Logger).errorWithOperationalEvent({
                    action: 'usedAtlIndexedDBOpenError',
                    attributes: {
                        databaseName: dbName
                    },
                    message: `IndexedDB open failed: ${errorMessage}`
                });
            });
            (0, $lbJxq.ItemKeyCache).markSetByPackage((0, $5MrbU.CategoryStorageType).IndexedDB, dbName);
            const actualRequest = this.config.idbFactory.open(dbName, version);
            requestWrapper.wrapRequest(actualRequest);
            return requestWrapper;
        }
        (0, $bDj2g.isProcessingAllowedByPreferencesWithCategory)({
            itemKey: dbName,
            storageType: (0, $5MrbU.CategoryStorageType).IndexedDB,
            productName: productName
        }).then(({ isAllowed: isAllowed, itemCategory: itemCategory })=>{
            const categoryAttribute = {
                itemCategory: itemCategory ?? (0, $5MrbU.PreferenceCategory).Unknown
            };
            if (isAllowed) {
                (0, $lbJxq.ItemKeyCache).markSetByPackage((0, $5MrbU.CategoryStorageType).IndexedDB, dbName);
                (0, $2rFtA.sendPackageOperationalEvent)({
                    action: 'usedAtlIndexedDBOpen',
                    attributes: {
                        databaseName: dbName,
                        wasRejected: false,
                        ...categoryAttribute
                    }
                });
                const actualRequest = this.config.idbFactory.open(dbName, version);
                // Wrap the actual request to forward all events
                requestWrapper.wrapRequest(actualRequest);
            } else {
                (0, $2rFtA.sendPackageOperationalEvent)({
                    action: 'usedAtlIndexedDBOpen',
                    attributes: {
                        databaseName: dbName,
                        wasRejected: true,
                        ...categoryAttribute
                    }
                });
                if (itemCategory === null) (0, $j1sAG.Logger).warn(`indexedDB.open('${dbName}') was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${dbName}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                const blockedEvent = new Event('storageItemBlocked');
                requestWrapper.dispatchEvent(blockedEvent);
            }
        }).catch((e)=>{
            const errorMessage = e instanceof Error ? e.message : String(e);
            (0, $j1sAG.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB open failed during preference check: ${errorMessage}`
            });
            const errorEvent = new ErrorEvent('error', {
                message: errorMessage
            });
            requestWrapper.dispatchEvent(errorEvent);
        });
        return requestWrapper;
    }
    /**
	 * Opens a database connection without checking user consent preferences.
	 * This method should ONLY be used for strictly necessary databases that are critical
	 * for application functionality and do not require user consent.
	 *
	 * @param dbName - The name of the database to open
	 * @param version - Optional version number for the database
	 * @returns An IDBOpenDBRequest
	 * @throws Error if database name is invalid, IndexedDB is not available, or the wrapped IDBFactory throws an error
	 *
	 * This method performs validation and availability checks but bypasses consent enforcement.
	 */ openStrictlyNecessary(dbName, version) {
        (0, $j1sAG.Logger).debug(`IndexedDB operation: openStrictlyNecessary on database \"${dbName}\"`, {
            version: String(version ?? 'unspecified')
        });
        if (!(0, $c1I7W.getBscGlobalState)().hasInitialized) (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: dbName,
                storageType: 'IndexedDB'
            }
        });
        if (!(0, $vHD2x.isValidDBName)(dbName)) {
            const error = new Error('Invalid database name: must be a non-empty string');
            (0, $j1sAG.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenStrictlyNecessaryError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB openStrictlyNecessary failed: ${error.message}`
            });
            throw error;
        }
        if (!(0, $vHD2x.isValidVersion)(version)) {
            const error = new Error('Invalid version: must be a positive integer or undefined');
            (0, $j1sAG.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenStrictlyNecessaryError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB openStrictlyNecessary failed: ${error.message}`
            });
            throw error;
        }
        const availabilityCheck = (0, $vHD2x.checkDBAvailability)(this.config.enableSSRCheck, this.config.enableFeatureFlagCheck);
        if (!availabilityCheck.available) {
            if (this.config.noOpWhenUnavailable) return (0, $fXApL.createIDBOpenDBRequestWrapper)();
            const error = new Error(`Cannot open database: ${availabilityCheck.reason || 'IndexedDB is not available'}`);
            (0, $j1sAG.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenStrictlyNecessaryError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB openStrictlyNecessary failed: ${error.message}`
            });
            throw error;
        }
        try {
            (0, $2rFtA.sendPackageOperationalEvent)({
                action: 'usedAtlIndexedDBOpenStrictlyNecessary',
                attributes: {
                    databaseName: dbName
                }
            });
        } catch (e) {
            // Don't fail the operation if event sending fails
            const errorMessage = e instanceof Error ? e.message : String(e);
            (0, $j1sAG.Logger).warn(`Failed to send operational event for openStrictlyNecessary: ${errorMessage}`);
        }
        return this.config.idbFactory.open(dbName, version);
    }
    /**
	 * Deletes a database by delegating directly to the wrapped IDBFactory instance.
	 * @param dbName - The name of the database to delete
	 * @returns An IDBOpenDBRequest
	 */ deleteDatabase(dbName) {
        if (!this.getIsAvailable() && this.config.noOpWhenUnavailable) return (0, $fXApL.createIDBOpenDBRequestWrapper)();
        return this.config.idbFactory.deleteDatabase(dbName);
    }
    /**
	 * Gets a list of available databases by delegating directly to the wrapped IDBFactory instance.
	 * @returns A promise that resolves to a list of database info objects
	 */ async databases() {
        if (this.config.idbFactory.databases && typeof this.config.idbFactory.databases === 'function') return await this.config.idbFactory.databases();
        return [];
    }
    /**
	 * Compares two values for use as IndexedDB keys by delegating to the wrapped IDBFactory instance.
	 * @param first - The first value to compare
	 * @param second - The second value to compare
	 * @returns A negative, zero, or positive value depending on the comparison result
	 */ cmp(first, second) {
        return this.config.idbFactory.cmp(first, second);
    }
}
const $bce5e2949de1a399$export$e65012c747534318 = new $bce5e2949de1a399$export$f623e6c5a836bb02({
    noOpWhenUnavailable: true
});

});
parcelRegister("fXApL", function(module, exports) {
$parcel$export(module.exports, "createIDBOpenDBRequestWrapper", () => $39725925175b253b$export$4037ef1f5b40c4b6);

var $glbdM = parcelRequire("glbdM");

var $hRda6 = parcelRequire("hRda6");

var $c4w52 = parcelRequire("c4w52");
// Store the browser implementation class here - defined conditionally below
let $39725925175b253b$var$BrowserImpl;
/**
 * Browser-only implementation that extends EventTarget.
 * Only defined in browser environments where EventTarget is available.
 * This conditional definition prevents "EventTarget is not defined" errors in SSR.
 */ if (typeof EventTarget !== 'undefined') // Define the class inside this block so it's never parsed in SSR
$39725925175b253b$var$BrowserImpl = class IDBOpenDBRequestWrapperImpl extends EventTarget {
    // Implementing IDBRequest readonly properties with getters
    get error() {
        return this._wrappedRequest?.error ?? this._error;
    }
    get result() {
        return this._wrappedRequest?.result ?? this._result;
    }
    get readyState() {
        return this._wrappedRequest?.readyState ?? this._readyState;
    }
    get source() {
        return this._wrappedRequest?.source ?? this._source;
    }
    get transaction() {
        return this._wrappedRequest?.transaction ?? this._transaction;
    }
    /**
		 * Wrap an existing IDBOpenDBRequest to proxy its events to this wrapper.
		 * Once wrapped, all property getters will delegate to the wrapped request,
		 * and all events from the wrapped request will be re-dispatched on this wrapper.
		 *
		 * @param request - The real IDBOpenDBRequest to wrap
		 */ wrapRequest(request) {
        if (this._wrappedRequest) throw new Error('This IDBOpenDBRequestWrapper is already wrapping another request');
        this._wrappedRequest = request;
        // Proxy all events from the wrapped request to this wrapper using bindAll
        this._unbindEventListeners = (0, $glbdM.bindAll)(request, [
            {
                type: 'success',
                listener: (e)=>{
                    this.dispatchEvent(new Event('success', e));
                }
            },
            {
                type: 'error',
                listener: (e)=>{
                    this.dispatchEvent(new Event('error', e));
                }
            },
            {
                type: 'blocked',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('blocked', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            },
            {
                type: 'upgradeneeded',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('upgradeneeded', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            }
        ]);
    }
    /**
		 * Check if this mock is wrapping a real request
		 */ isWrapping() {
        return this._wrappedRequest !== null;
    }
    /**
		 * Get the wrapped request (if any)
		 */ getWrappedRequest() {
        return this._wrappedRequest;
    }
    /**
		 * Unbind all event listeners attached to the wrapped request.
		 * Should be called when the wrapper is no longer needed.
		 */ unbind() {
        if (this._unbindEventListeners) {
            this._unbindEventListeners();
            this._unbindEventListeners = null;
        }
        this._wrappedRequest = null;
    }
    /**
		 * Set the error property (normally readonly)
		 * Only works when not wrapping another request
		 */ setError(error) {
        if (this._wrappedRequest) throw new Error('Cannot set error on a wrapping IDBOpenDBRequestWrapper');
        this._error = error;
    }
    /**
		 * Set the result property (normally readonly)
		 * Only works when not wrapping another request
		 */ setResult(result) {
        if (this._wrappedRequest) throw new Error('Cannot set result on a wrapping IDBOpenDBRequestWrapper');
        this._result = result;
    }
    /**
		 * Set the readyState property (normally readonly)
		 * Only works when not wrapping another request
		 */ setReadyState(state) {
        if (this._wrappedRequest) throw new Error('Cannot set readyState on a wrapping IDBOpenDBRequestWrapper');
        this._readyState = state;
    }
    /**
		 * Set the source property (normally readonly)
		 * Only works when not wrapping another request
		 */ setSource(source) {
        if (this._wrappedRequest) throw new Error('Cannot set source on a wrapping IDBOpenDBRequestWrapper');
        this._source = source;
    }
    /**
		 * Set the transaction property (normally readonly)
		 * Only works when not wrapping another request
		 */ setTransaction(transaction) {
        if (this._wrappedRequest) throw new Error('Cannot set transaction on a wrapping IDBOpenDBRequestWrapper');
        this._transaction = transaction;
    }
    /**
		 * Override dispatchEvent to also call the corresponding event handler if set
		 */ dispatchEvent(event) {
        const result = super.dispatchEvent(event);
        // Call the appropriate event handler if it exists
        switch(event.type){
            case 'error':
                if (this.onerror) this.onerror.call(this, event);
                break;
            case 'success':
                if (this.onsuccess) this.onsuccess.call(this, event);
                break;
            case 'blocked':
                if (this.onblocked) this.onblocked.call(this, event);
                break;
            case 'upgradeneeded':
                if (this.onupgradeneeded) this.onupgradeneeded.call(this, event);
                break;
        }
        return result;
    }
    constructor(...args){
        super(...args), this._error = null, this._result = null, this._readyState = 'pending', this._source = null, this._transaction = null, this._wrappedRequest = null, this._unbindEventListeners = null, // Event handler properties (can be set directly by consumers)
        this.onerror = null, this.onsuccess = null, this.onblocked = null, this.onupgradeneeded = null;
    }
};
function $39725925175b253b$export$4037ef1f5b40c4b6() {
    if ((0, $hRda6.isSSR)() || typeof EventTarget === 'undefined' || !$39725925175b253b$var$BrowserImpl) return new (0, $c4w52.IDBOpenDBRequestNoOp)();
    return new $39725925175b253b$var$BrowserImpl();
}
const $39725925175b253b$export$c69b1cb39abae960 = $39725925175b253b$var$BrowserImpl;

});
parcelRegister("c4w52", function(module, exports) {
$parcel$export(module.exports, "IDBOpenDBRequestNoOp", () => $5a6f42954c62a3f7$export$55ffeaf417e03b66);
/**
 * Minimal no-op implementation for SSR environments.
 * Provides the IDBOpenDBRequest interface without relying on EventTarget.
 * This class does not extend EventTarget, making it safe to instantiate in Node.js.
 */ class $5a6f42954c62a3f7$export$55ffeaf417e03b66 {
    get error() {
        return this._error;
    }
    get result() {
        return this._result;
    }
    get readyState() {
        return this._readyState;
    }
    get source() {
        return this._source;
    }
    get transaction() {
        return this._transaction;
    }
    // No-op event methods for SSR
    addEventListener() {}
    removeEventListener() {}
    dispatchEvent() {
        return false;
    }
    // Wrapper-specific methods that shouldn't be called in SSR but are part of the interface
    wrapRequest() {
        throw new Error('IDBOpenDBRequestWrapper cannot wrap requests in SSR environment');
    }
    isWrapping() {
        return false;
    }
    getWrappedRequest() {
        return null;
    }
    unbind() {}
    setError(error) {
        this._error = error;
    }
    setResult(result) {
        this._result = result;
    }
    setReadyState(state) {
        this._readyState = state;
    }
    setSource(source) {
        this._source = source;
    }
    setTransaction(transaction) {
        this._transaction = transaction;
    }
    constructor(){
        this._error = null;
        this._result = null;
        this._readyState = 'pending';
        this._source = null;
        this._transaction = null;
        this.onerror = null;
        this.onsuccess = null;
        this.onblocked = null;
        this.onupgradeneeded = null;
    }
}

});


parcelRegister("vHD2x", function(module, exports) {
$parcel$export(module.exports, "checkDBAvailability", () => $977685054a18df44$export$ae0d255aec75942);
$parcel$export(module.exports, "isValidDBName", () => $977685054a18df44$export$a5be9a74f3347ccf);
$parcel$export(module.exports, "isValidVersion", () => $977685054a18df44$export$396291456af4fc3);

var $c1I7W = parcelRequire("c1I7W");
var $hRda6 = parcelRequire("hRda6");
function $977685054a18df44$export$ae0d255aec75942(enableSSRCheck = true, enableFeatureFlagCheck = true) {
    // Check if running in SSR environment
    if (enableSSRCheck && (0, $hRda6.isSSR)()) return {
        available: false,
        reason: 'IndexedDB is not available in SSR environment'
    };
    if (!globalThis.indexedDB) return {
        available: false,
        reason: 'IndexedDB is not supported in this browser'
    };
    if (enableFeatureFlagCheck) {
        const globalState = (0, $c1I7W.getBscGlobalState)();
        if (globalState.indexedDbEnabled === false) return {
            available: true,
            reason: 'Using native IndexedDB: IndexedDB controls are disabled',
            bypassImplementation: true
        };
    }
    return {
        available: true
    };
}
function $977685054a18df44$export$a5be9a74f3347ccf(dbName) {
    // Database name should not be empty and should be a string
    return typeof dbName === 'string' && dbName.trim().length > 0;
}
function $977685054a18df44$export$396291456af4fc3(version) {
    // Version should be undefined or a positive integer
    if (version === undefined) return true;
    return Number.isInteger(version) && version > 0;
}

});


parcelRegister("44Y8O", function(module, exports) {
$parcel$export(module.exports, "getProjectIdFromSpaState", () => $6f18903cdc8d5292$export$769767595ecc1f62);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $6f18903cdc8d5292$export$769767595ecc1f62 = (projectKey)=>{
    return globalThis?.window?.SPA_STATE?.PROJECT_CONTEXT?.[projectKey]?.data?.projectId;
};

});

/* eslint-disable jira/filename-case */ const $109cef2208c3f3c4$export$3c22ff8b64b8f565 = 'jpd-store';
const $109cef2208c3f3c4$export$6a9022b4c5fcea02 = 1;
const $109cef2208c3f3c4$export$cd79d01fb3d2f506 = 'project-key-to-id-mapping';
const $109cef2208c3f3c4$export$c0c8fb0813dd1d2a = 1000;
const $109cef2208c3f3c4$export$eca93c456abcab01 = 5000;


parcelRegister("eQXnX", function(module, exports) {
$parcel$export(module.exports, "getProjectKeyFromLocation", () => $bbdcbca787feaaf0$export$60093b596b9566ef);
$parcel$export(module.exports, "getViewIdFromLocation", () => $bbdcbca787feaaf0$export$9ba58cbeffd45843);
$parcel$export(module.exports, "getIssueKeyFromLocation", () => $bbdcbca787feaaf0$export$a12d8f0ecf6910fc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Extracts project key from the URL path
 * Pattern matches: /jira/polaris/projects/{projectKey}/...
 * @param location The location object to extract from
 * @returns The project key if found, null otherwise
 */ const $bbdcbca787feaaf0$export$60093b596b9566ef = (location)=>{
    // Handle empty or invalid location
    if (!location || !location.pathname) return null;
    // Get the pathname and remove trailing slash if present
    let pathname = location.pathname;
    if (pathname.endsWith('/') && pathname.length > 1) pathname = pathname.slice(0, -1);
    // Simple regex to extract projectKey from polaris ideas URLs
    // Pattern matches: /jira/polaris/projects/{projectKey}/ideas/...
    const regex = /\/jira\/polaris\/projects\/([^/]+)\/ideas/;
    const match = pathname.match(regex);
    // Return projectKey if found, otherwise null
    return match ? match[1] : null;
};
const $bbdcbca787feaaf0$export$9ba58cbeffd45843 = (location)=>{
    // Handle empty or invalid location
    if (!location || !location.pathname) return null;
    // Get the pathname and remove trailing slash if present
    let pathname = location.pathname;
    if (pathname.endsWith('/') && pathname.length > 1) pathname = pathname.slice(0, -1);
    // Simple regex to extract viewId from polaris ideas view URLs
    // Pattern matches: /jira/polaris/projects/{projectKey}/ideas/view/{viewId}
    const regex = /\/jira\/polaris\/projects\/[^/]+\/ideas\/view\/([^/]+)/;
    const match = pathname.match(regex);
    // Return viewId if found, otherwise null
    return match ? match[1] : null;
};
function $bbdcbca787feaaf0$export$a12d8f0ecf6910fc(location) {
    if (location.search) {
        const params = new URLSearchParams(location.search);
        return params.get('selectedIssue');
    }
    return null;
}

});



parcelRegister("2Baxe", function(module, exports) {
$parcel$export(module.exports, "cloneView", () => $c9a3bae9fcc834bc$export$de60ce8ef9a4993b);

var $2wtso = parcelRequire("2wtso");

var $h2wCv = parcelRequire("h2wCv");
const $c9a3bae9fcc834bc$export$de60ce8ef9a4993b = (viewId, params)=>(0, $h2wCv.performPostRequest)(`${(0, $2wtso.getJpdViewsServicePathPrefix)()}/v1/views/${viewId}/clone`, {
        body: JSON.stringify(params)
    });

});

parcelRegister("5uNbW", function(module, exports) {
$parcel$export(module.exports, "createView", () => $aad22a8e9b62e27f$export$d7febe7b891e79f0);

var $2wtso = parcelRequire("2wtso");

var $h2wCv = parcelRequire("h2wCv");
const $aad22a8e9b62e27f$export$d7febe7b891e79f0 = (params)=>(0, $h2wCv.performPostRequest)(`${(0, $2wtso.getJpdViewsServicePathPrefix)()}/v1/views`, {
        body: JSON.stringify(params)
    });

});

parcelRegister("8bsTC", function(module, exports) {
$parcel$export(module.exports, "deleteView", () => $4ef396ae33b57a61$export$443d89549b135c95);

var $2wtso = parcelRequire("2wtso");

var $h2wCv = parcelRequire("h2wCv");
const $4ef396ae33b57a61$export$443d89549b135c95 = (viewId)=>(0, $h2wCv.performDeleteRequest)(`${(0, $2wtso.getJpdViewsServicePathPrefix)()}/v1/views/${viewId}`);

});

parcelRegister("ecWWk", function(module, exports) {
$parcel$export(module.exports, "updateView", () => $a5dfedeed59663ff$export$827a6c17a85f6d1a);

var $2wtso = parcelRequire("2wtso");

var $h2wCv = parcelRequire("h2wCv");
const $a5dfedeed59663ff$export$827a6c17a85f6d1a = (viewId, params)=>(0, $h2wCv.performPatchRequest)(`${(0, $2wtso.getJpdViewsServicePathPrefix)()}/v1/views/${viewId}`, {
        body: JSON.stringify(params)
    });

});

parcelRegister("cgB0X", function(module, exports) {
$parcel$export(module.exports, "rankView", () => $6d1ed9338769f933$export$a0b4e5c66bf01c3b);
$parcel$export(module.exports, "collectionRankView", () => $6d1ed9338769f933$export$f3488c4d904fda62);

var $2wtso = parcelRequire("2wtso");

var $h2wCv = parcelRequire("h2wCv");
const $6d1ed9338769f933$export$a0b4e5c66bf01c3b = (viewId, params)=>(0, $h2wCv.performPostRequest)(`${(0, $2wtso.getJpdViewsServicePathPrefix)()}/v1/views/${viewId}/rank`, {
        body: JSON.stringify(params)
    });
const $6d1ed9338769f933$export$f3488c4d904fda62 = ({ collectionUUID: collectionUUID, viewUUID: viewUUID, parentUUID: parentUUID, rank: rank })=>(0, $h2wCv.performPutRequest)(`${(0, $2wtso.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/views/${viewUUID}/rank`, {
        body: JSON.stringify({
            rank: rank,
            parent: parentUUID
        })
    });

});

parcelRegister("aQKzd", function(module, exports) {
$parcel$export(module.exports, "convertViewTypeToRemote", () => $73f041ddaab096d5$export$a4560f84350d9295);
$parcel$export(module.exports, "transformView", () => $73f041ddaab096d5$export$601ea8be46c5c28c);
$parcel$export(module.exports, "transformViews", () => $73f041ddaab096d5$export$4d28a19f0f20b9fa);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $73f041ddaab096d5$var$convertViewTypeFromRemote = (viewType)=>{
    switch(viewType){
        case 'LIST':
            return 'TABLE';
        default:
            // oxlint-disable-next-line typescript/consistent-type-assertions
            return viewType;
    }
};
const $73f041ddaab096d5$export$a4560f84350d9295 = (viewType)=>{
    switch(viewType){
        case 'TABLE':
            return 'LIST';
        default:
            return viewType;
    }
};
const $73f041ddaab096d5$export$601ea8be46c5c28c = (view)=>({
        id: view.id,
        polarisId: view.polarisId,
        name: view.name,
        emoji: view.emoji,
        viewType: $73f041ddaab096d5$var$convertViewTypeFromRemote(view.viewType),
        views: view.views?.map((innerView)=>({
                id: innerView.id,
                polarisId: innerView.polarisId,
                name: innerView.name,
                emoji: innerView.emoji,
                viewType: $73f041ddaab096d5$var$convertViewTypeFromRemote(innerView.viewType)
            }))
    });
const $73f041ddaab096d5$export$4d28a19f0f20b9fa = (views)=>views.map($73f041ddaab096d5$export$601ea8be46c5c28c);

});




parcelRegister("48Afu", function(module, exports) {
$parcel$export(module.exports, "Nav4RoadmapsDefault", () => $456d2f9d2cd4dc0e$export$90b0689dbe5e5db3);

var $euxye = parcelRequire("euxye");

var $9h4A8 = parcelRequire("9h4A8");

var $cee3w = parcelRequire("cee3w");

var $bOwox = parcelRequire("bOwox");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $4VtOS = parcelRequire("4VtOS");

var $gEDfa = parcelRequire("gEDfa");

var $jzXAj = parcelRequire("jzXAj");

var $3rqDf = parcelRequire("3rqDf");

var $dx7aH = parcelRequire("dx7aH");

var $kFgCO = parcelRequire("kFgCO");

var $jepRN = parcelRequire("jepRN");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $kt86l = parcelRequire("kt86l");

var $h3LJR = parcelRequire("h3LJR");

var $bycIq = parcelRequire("bycIq");

var $dE7qU = parcelRequire("dE7qU");

var $fFNvS = parcelRequire("fFNvS");

var $7RdH9 = parcelRequire("7RdH9");

var $35xee = parcelRequire("35xee");
function $456d2f9d2cd4dc0e$var$Nav4RoadmapsDefaultGSN(props) {
    const { actionsOnHover: actionsOnHover, draggableRef: draggableRef, dropIndicator: dropIndicator, hasDragIndicator: hasDragIndicator, isDragging: isDragging, isExpanded: isExpanded, onExpandFlyoutToggle: onExpandFlyoutToggle, simulateLoading: simulateLoading = false, visualContentRef: visualContentRef } = props;
    const cloudId = (0, $kt86l.useCloudId)();
    const currentURL = (0, $9h4A8.useGetCurrentUrl)();
    const { data: { user: { accountId: accountId } } } = (0, $kFgCO.useCurrentUser)();
    const activationId = (0, $h3LJR.useActivationId)();
    // Ignore this error as our component does not need the context.
    // @ts-expect-error - Property 'context' is missing in type '{ tenantContext: { cloudId: string; atlassianAccountId: string | null; activationId: string; }; currentURL: string; }' but required in type 'EntryPointRouteParams'.ts(2741)
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId,
                atlassianAccountId: accountId,
                activationId: activationId
            },
            currentURL: currentURL
        }), [
        cloudId,
        accountId,
        activationId,
        currentURL
    ]);
    const { Panel: Panel, trigger: trigger } = (0, $dE7qU.usePanel)();
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).ROADMAPS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const menuId = (0, $5IkoH.MENU_ID_ROADMAPS);
    const handleExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) sendSectionItemAnalyticsEvent({
            menuId: (0, $6GljB.L1_MENU_ID).ROADMAPS,
            sectionItem: (0, $bOwox.SECTION_ITEM_ROADMAPS)
        });
        onExpandFlyoutToggle?.(hasExpanded);
    }, [
        onExpandFlyoutToggle,
        sendSectionItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        dropTargetRef: visualContentRef,
        dropIndicator: dropIndicator,
        isDragging: isDragging,
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: handleExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bycIq.Trigger), {
        trigger: trigger,
        entryPoint: (0, $35xee.nav4RoadmapsContentEntryPoint),
        entryPointParams: entryPointParams,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null)
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
            interactionName: "nav4-sidebar-roadmaps-default",
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemBefore: icon,
            hasDragIndicator: hasDragIndicator,
            isDragging: isDragging,
            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cee3w.PremiumLozenge), null),
            ref: draggableRef ? (0, $fFNvS.mergeRefs)(ref, draggableRef) : ref,
            testId: (0, $jzXAj.getTestId)(menuId)
        }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Panel, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7RdH9.Footer), null)))));
}
$456d2f9d2cd4dc0e$var$Nav4RoadmapsDefaultGSN.displayName = "Nav4RoadmapsDefaultGSN";
function $456d2f9d2cd4dc0e$var$Nav4RoadmapsDefaultNav4(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, simulateLoading: simulateLoading = false } = props;
    const cloudId = (0, $kt86l.useCloudId)();
    const currentURL = (0, $9h4A8.useGetCurrentUrl)();
    const { data: { user: { accountId: accountId } } } = (0, $kFgCO.useCurrentUser)();
    const activationId = (0, $h3LJR.useActivationId)();
    // Ignore this error as our component does not need the context.
    // @ts-expect-error - Property 'context' is missing in type '{ tenantContext: { cloudId: string; atlassianAccountId: string | null; activationId: string; }; currentURL: string; }' but required in type 'EntryPointRouteParams'.ts(2741)
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId,
                atlassianAccountId: accountId,
                activationId: activationId
            },
            currentURL: currentURL
        }), [
        cloudId,
        accountId,
        activationId,
        currentURL
    ]);
    const { Panel: Panel, trigger: trigger } = (0, $dE7qU.usePanel)();
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).ROADMAPS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const menuId = (0, $5IkoH.MENU_ID_ROADMAPS);
    const handleExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) sendSectionItemAnalyticsEvent({
            menuId: (0, $6GljB.L1_MENU_ID).ROADMAPS,
            sectionItem: (0, $bOwox.SECTION_ITEM_ROADMAPS)
        });
    }, [
        sendSectionItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: handleExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bycIq.Trigger), {
        trigger: trigger,
        entryPoint: (0, $35xee.nav4RoadmapsContentEntryPoint),
        entryPointParams: entryPointParams,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null)
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
            interactionName: "nav4-sidebar-roadmaps-default",
            actionsOnHover: actionsOnHover,
            "aria-label": formattedMessage,
            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cee3w.PremiumLozenge), null),
            elemBefore: icon,
            // oxlint-disable-next-line typescript/consistent-type-assertions
            ref: ref,
            testId: (0, $jzXAj.getTestId)(menuId)
        }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Panel, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7RdH9.Footer), null)))));
}
$456d2f9d2cd4dc0e$var$Nav4RoadmapsDefaultNav4.displayName = "Nav4RoadmapsDefaultNav4";
const $456d2f9d2cd4dc0e$export$90b0689dbe5e5db3 = (0, $jepRN.componentWithFG)('navx-global-side-nav', $456d2f9d2cd4dc0e$var$Nav4RoadmapsDefaultGSN, $456d2f9d2cd4dc0e$var$Nav4RoadmapsDefaultNav4);

});
parcelRegister("35xee", function(module, exports) {
$parcel$export(module.exports, "nav4RoadmapsContentEntryPoint", () => $3f81504d1c15b980$export$efcf5591951298e2);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $2NSbF = parcelRequire("2NSbF");

var $bZhC2 = parcelRequire("bZhC2");

var $hx7cf = parcelRequire("hx7cf");

const $3f81504d1c15b980$export$efcf5591951298e2 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("dhYfo")), {
        moduleId: "a0a1fb09",
        moduleName: "RoadmapsContentViewQuery",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId || '';
        const activationId = params.tenantContext?.activationId || '';
        // FG fg('navx-3660-fix-l2-l3-aris') seems to break ordering so it would be skipped for now
        const entityAri = (0, $bZhC2.JiraNavigationSettingsAri).create({
            siteId: cloudId,
            activationId: activationId,
            navigationSettingScope: 'collections'
        }).toString();
        const variables = {
            cloudId: cloudId,
            currentURL: params.currentURL,
            entityAri: entityAri,
            ownerAri: (0, $2NSbF.IdentityUserAri).create({
                userId: params.tenantContext.atlassianAccountId || 'UNKNOWN'
            }).toString(),
            skipOrderQuery: false
        };
        return {
            queries: {
                queryRef: {
                    parameters: $hx7cf.default,
                    variables: variables
                }
            }
        };
    }
});

});
parcelRegister("hx7cf", function(module, exports) {
$parcel$export(module.exports, "default", () => $eaf218dcee38b424$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0725dcb91a3f4d7721d9b20f2b48ad7a>>
 * @relayHash c674cc7869ab43d6a33c0e361b3fbe6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 72e36f96d29cb08589218e38ab81f6ec1f3bed125870500e850fd53945ccd070
const $eaf218dcee38b424$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "72e36f96d29cb08589218e38ab81f6ec1f3bed125870500e850fd53945ccd070",
        "metadata": {},
        "name": "RoadmapsContentViewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $eaf218dcee38b424$export$2e2bcd8739ae039 = $eaf218dcee38b424$var$node;

});

parcelRegister("dhYfo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9WIVf").then(()=>parcelRequire('au9wQ'));

});



parcelRegister("6JpuJ", function(module, exports) {
$parcel$export(module.exports, "RoadmapNavExpanded", () => $99dbb3d39a64c54f$export$37433fe7771f874f);

var $7UqQx = parcelRequire("7UqQx");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");

var $bOwox = parcelRequire("bOwox");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");

var $4VtOS = parcelRequire("4VtOS");

var $jzXAj = parcelRequire("jzXAj");

var $3rqDf = parcelRequire("3rqDf");

var $dx7aH = parcelRequire("dx7aH");

var $jepRN = parcelRequire("jepRN");

var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $gDdYI = parcelRequire("gDdYI");

var $jy9wi = parcelRequire("jy9wi");

var $b1YRJ = parcelRequire("b1YRJ");

var $7RdH9 = parcelRequire("7RdH9");
function $99dbb3d39a64c54f$export$37433fe7771f874f(props) {
    const { queryRefFragment: queryRefFragment } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $6GljB.L1_MENU_ID).ROADMAPS);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const dataRoadmapsQuery = (0, $n67Vb.useFragment)((0, $7UqQx.default), queryRefFragment);
    const handleExpansionToggle = (0, $euxye.useCallback)((hasExpanded)=>{
        if (hasExpanded) sendSectionItemAnalyticsEvent({
            menuId: (0, $6GljB.L1_MENU_ID).ROADMAPS,
            sectionItem: (0, $bOwox.SECTION_ITEM_ROADMAPS)
        });
    }, [
        sendSectionItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($99dbb3d39a64c54f$var$RoadmapNavExpandedInner, {
        ...props,
        formattedMessage: formattedMessage,
        handleExpansionToggle: handleExpansionToggle,
        icon: icon,
        menuId: (0, $5IkoH.MENU_ID_ROADMAPS),
        navigationCustomisationFragment: dataRoadmapsQuery.roadmapsOrder ?? undefined,
        queryRef: dataRoadmapsQuery
    });
}
$99dbb3d39a64c54f$export$37433fe7771f874f.displayName = "RoadmapNavExpanded";
const $99dbb3d39a64c54f$var$RoadmapNavExpandedInner = (0, $jepRN.componentWithFG)('navx-global-side-nav', $99dbb3d39a64c54f$var$RoadmapNavExpandedInnerGSN, $99dbb3d39a64c54f$var$RoadmapNavExpandedInnerNav4);
function $99dbb3d39a64c54f$var$RoadmapNavExpandedInnerGSN(props) {
    const { actionsOnHover: actionsOnHover, draggableRef: draggableRef, dropIndicator: dropIndicator, formattedMessage: formattedMessage, handleExpansionToggle: handleExpansionToggle, hasDragIndicator: hasDragIndicator, icon: icon, isDragging: isDragging, isExpanded: isExpanded, menuId: menuId, navigationCustomisationFragment: navigationCustomisationFragment, onExpandFlyoutToggle: onExpandFlyoutToggle, queryRef: queryRef, visualContentRef: visualContentRef } = props;
    const handleExpansionToggle2 = (0, $euxye.useCallback)((hasExpanded)=>{
        handleExpansionToggle(hasExpanded);
        onExpandFlyoutToggle?.(hasExpanded);
    }, [
        onExpandFlyoutToggle,
        handleExpansionToggle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        dropTargetRef: visualContentRef,
        dropIndicator: dropIndicator,
        isDragging: isDragging,
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: handleExpansionToggle2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        hasDragIndicator: hasDragIndicator,
        interactionName: "nav4-sidebar-roadmaps-landing",
        isDragging: isDragging,
        ref: draggableRef,
        testId: (0, $jzXAj.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-roadmaps-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "nav4-sidebar-roadmaps-landing",
        packageName: (0, $b1YRJ.PACKAGE_NAME),
        teamName: (0, $b1YRJ.TEAM_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jy9wi.RoadmapsContent), {
        queryRef: queryRef,
        navigationCustomisationFragment: navigationCustomisationFragment
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7RdH9.Footer), null)))));
}
$99dbb3d39a64c54f$var$RoadmapNavExpandedInnerGSN.displayName = "RoadmapNavExpandedInnerGSN";
function $99dbb3d39a64c54f$var$RoadmapNavExpandedInnerNav4(props) {
    const { actionsOnHover: actionsOnHover, formattedMessage: formattedMessage, handleExpansionToggle: handleExpansionToggle, icon: icon, isExpanded: isExpanded, menuId: menuId, navigationCustomisationFragment: navigationCustomisationFragment, queryRef: queryRef } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VtOS.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: handleExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon + text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $jzXAj.getTestId)(menuId),
        interactionName: "nav4-sidebar-roadmaps-landing"
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-roadmaps-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "nav4-sidebar-roadmaps-landing",
        packageName: (0, $b1YRJ.PACKAGE_NAME),
        teamName: (0, $b1YRJ.TEAM_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jy9wi.RoadmapsContent), {
        queryRef: queryRef,
        navigationCustomisationFragment: navigationCustomisationFragment
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7RdH9.Footer), null)))));
}
$99dbb3d39a64c54f$var$RoadmapNavExpandedInnerNav4.displayName = "RoadmapNavExpandedInnerNav4";

});
parcelRegister("7UqQx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7e8dafc4e944c01$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d15adb7c881dee6e999cb7194d1b624>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c7e8dafc4e944c01$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        },
        {
            "kind": "RootArgument",
            "name": "entityAriRoadmaps"
        },
        {
            "kind": "RootArgument",
            "name": "ownerAri"
        }
    ],
    "kind": "Fragment",
    "name": "RoadmapNavExpanded_query",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "currentURL",
                    "variableName": "currentURL"
                }
            ],
            "kind": "FragmentSpread",
            "name": "RoadmapsContent"
        },
        {
            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "roadmapsOrder",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "entityAriRoadmaps"
                        },
                        {
                            "kind": "Variable",
                            "name": "ownerAri",
                            "variableName": "ownerAri"
                        }
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "RoadmapsContent_navigationCustomisation"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$c7e8dafc4e944c01$var$node.hash = "6ce248349f18ac34c1458ab0e14ad778";
var $c7e8dafc4e944c01$export$2e2bcd8739ae039 = $c7e8dafc4e944c01$var$node;

});

parcelRegister("jy9wi", function(module, exports) {
$parcel$export(module.exports, "RoadmapsContent", () => $a5d31263d14b69c8$export$751efa31b5c1ed0a);

var $3eaR0 = parcelRequire("3eaR0");

var $6s6eB = parcelRequire("6s6eB");

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $n67Vb = parcelRequire("n67Vb");

var $g1b31 = parcelRequire("g1b31");

var $9AhSr = parcelRequire("9AhSr");

var $gLXQg = parcelRequire("gLXQg");

var $atwsb = parcelRequire("atwsb");

var $5IkoH = parcelRequire("5IkoH");

var $19zz3 = parcelRequire("19zz3");

var $iPHqm = parcelRequire("iPHqm");

var $ar9gx = parcelRequire("ar9gx");

var $djYhH = parcelRequire("djYhH");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $kt86l = parcelRequire("kt86l");

var $aeLE4 = parcelRequire("aeLE4");

var $5axNp = parcelRequire("5axNp");

var $hLi02 = parcelRequire("hLi02");

var $bXIJF = parcelRequire("bXIJF");

var $c3zbo = parcelRequire("c3zbo");

var $7WrJq = parcelRequire("7WrJq");
const $a5d31263d14b69c8$var$MAX_RECENT_ROADMAPS = 5;
const $a5d31263d14b69c8$var$MAX_FAVORITE_ROADMAPS = 15;
const $a5d31263d14b69c8$var$recentMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.content.recent",
    defaultMessage: "Recent"
});
const $a5d31263d14b69c8$var$starredMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.content.starred",
    defaultMessage: "Starred"
});
function $a5d31263d14b69c8$export$751efa31b5c1ed0a({ queryRef: queryRef, navigationCustomisationFragment: navigationCustomisationFragment }) {
    const cloudId = (0, $kt86l.useCloudId)();
    const { isSelectedPath: isSelectedPath } = (0, $19zz3.useSidebarNav4)();
    const [jira, refetch] = (0, $n67Vb.useRefetchableFragment)((0, $6s6eB.default), queryRef);
    (0, $g1b31.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $bXIJF.default,
        refetch: refetch,
        menuId: (0, $5IkoH.MENU_ID_ROADMAPS)
    });
    const refetchOnChange = (0, $euxye.useCallback)(({ onComplete: onComplete })=>{
        refetch({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        cloudId,
        refetch
    ]);
    (0, $9AhSr.useSubscribeAndUpdateFavorites)({
        entityTypename: 'JiraProductDiscoveryCollection',
        favouriteConnectionId: jira.jira.roadmapFavourites.__id || '',
        recentConnectionId: jira.jira.roadmapRecents.__id || '',
        refetch: refetchOnChange
    });
    const { addDeleteListener: addDeleteListener, removeDeleteListener: removeDeleteListener } = (0, $iPHqm.useNavigationCollectionsActions)();
    const refetchOnChangeRef = (0, $euxye.useRef)(refetchOnChange);
    refetchOnChangeRef.current = refetchOnChange;
    (0, $euxye.useEffect)(()=>{
        const handleDeletion = ()=>refetchOnChangeRef.current({
                onComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
            });
        addDeleteListener(handleDeletion);
        return ()=>{
            removeDeleteListener(handleDeletion);
        };
    }, [
        addDeleteListener,
        removeDeleteListener
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a5d31263d14b69c8$var$RoadmapContentInner, {
        jira: jira.jira,
        navigationCustomisationFragment: navigationCustomisationFragment
    });
}
$a5d31263d14b69c8$export$751efa31b5c1ed0a.displayName = "RoadmapsContent";
const $a5d31263d14b69c8$var$RoadmapContentInner = (props)=>{
    const { navigationCustomisationFragment: navigationCustomisationFragment, jira: { roadmapFavourites: roadmapFavourites, roadmapRecents: roadmapRecents } } = props;
    const navigationCustomisationData = (0, $n67Vb.useFragment)((0, $3eaR0.default), navigationCustomisationFragment);
    const { getStableItems: getStableItems } = (0, $gLXQg.useStableItems)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const starred = formatMessage($a5d31263d14b69c8$var$starredMessage);
    const recent = formatMessage($a5d31263d14b69c8$var$recentMessage);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7WrJq.useDragAndDropReorderingAnalytics)();
    const { entityAri: entityAri, ownerAri: ownerAri, group: group } = (0, $hLi02.useRoadmapReorderingIds)();
    const roadmapNodes = (0, $euxye.useMemo)(()=>roadmapFavourites.edges?.reduce((nodes, edge)=>{
            if (edge?.node != null) nodes.push(edge.node);
            return nodes;
        }, []) ?? [], [
        roadmapFavourites.edges
    ]);
    const lastOrder = (0, $euxye.useMemo)(()=>navigationCustomisationData?.sidebar?.nodes?.map((node)=>({
                menuId: node?.menuId,
                visible: node?.visible
            })), [
        navigationCustomisationData?.sidebar?.nodes
    ]);
    const favorites = (0, $atwsb.useReorderableStarredItems)({
        favourites: roadmapNodes,
        lastOrder: lastOrder,
        getId: (item)=>item.id || '',
        getLabel: (item)=>item.title?.toString() || '',
        getHasNextPage: ()=>Boolean(roadmapFavourites?.pageInfo?.hasNextPage),
        renderMenuItem: (edge, currentItems, currentOrder, item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5axNp.RoadmapItem), {
                key: edge.collectionId,
                collectionQueryRefFragment: edge.RoadmapItem_collection,
                currentItems: currentItems,
                currentOrder: currentOrder,
                item: item,
                isDraggable: true
            }),
        maxItems: $a5d31263d14b69c8$var$MAX_FAVORITE_ROADMAPS
    });
    const recentItems = (0, $euxye.useMemo)(()=>{
        const nodes = [];
        roadmapRecents.edges?.forEach((edge)=>{
            if (edge && edge.node.id && !favorites.idSet.has(edge.node.id)) nodes.push(edge.node);
        });
        const limitedNodes = nodes.slice(0, $a5d31263d14b69c8$var$MAX_RECENT_ROADMAPS);
        const stableOrderedNodes = getStableItems({
            nodes: limitedNodes,
            idKey: 'id'
        });
        const list = stableOrderedNodes.map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5axNp.RoadmapItem), {
                key: node.collectionId,
                collectionQueryRefFragment: node.RoadmapItem_collection
            }));
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        roadmapRecents,
        favorites.idSet,
        getStableItems
    ]);
    if (!favorites.hasItems && !recentItems.hasItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c3zbo.RoadmapsEmptyContent), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aeLE4.NestedItemDropTarget), {
        currentItems: favorites.currentItems,
        currentOrder: favorites.currentOrder,
        entityAri: entityAri,
        group: group,
        ownerAri: ownerAri,
        fireAnalyticsEvent: fireAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, favorites.list)))), recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, recentItems.list))));
};
$a5d31263d14b69c8$var$RoadmapContentInner.displayName = "RoadmapContentInner";

});
parcelRegister("3eaR0", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b0797fc3105b17f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<64818bacea198384e05a701e8d56e397>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7b0797fc3105b17f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RoadmapsContent_navigationCustomisation",
    "selections": [
        {
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsMenuItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "menuId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "visible"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SettingsNavigationCustomisation"
};
$7b0797fc3105b17f$var$node.hash = "5d3559e77a966f5cf722d36b5de5e49f";
var $7b0797fc3105b17f$export$2e2bcd8739ae039 = $7b0797fc3105b17f$var$node;

});

parcelRegister("6s6eB", function(module, exports) {
$parcel$export(module.exports, "default", () => $822828461511a452$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bcf57040b077702aba5ba53aba40b48a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $bXIJF = parcelRequire("bXIJF");
const $822828461511a452$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "collectionId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            {
                                "fragment": {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "RoadmapItem_collection"
                                        }
                                    ],
                                    "type": "JiraProductDiscoveryCollection"
                                },
                                "kind": "AliasedInlineFragmentSpread",
                                "name": "RoadmapItem_collection"
                            }
                        ],
                        "type": "JiraProductDiscoveryCollection"
                    }
                ]
            },
            "action": "THROW"
        }
    ], v2 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $bXIJF.default)
            }
        },
        "name": "RoadmapsContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "roadmapFavourites",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "JPD_COLLECTION"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v1 /*: any*/ 
                                    },
                                    v2 /*: any*/ 
                                ]
                            },
                            "action": "THROW"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "roadmapRecents",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "currentURL",
                                        "variableName": "currentURL"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "JPD_COLLECTION"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": v1 /*: any*/ 
                                    },
                                    v2 /*: any*/ 
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                },
                "action": "THROW"
            }
        ],
        "type": "Query"
    };
}();
$822828461511a452$var$node.hash = "cb31d658bc1e59d98b259d4e0c2d9daf";
var $822828461511a452$export$2e2bcd8739ae039 = $822828461511a452$var$node;

});
parcelRegister("bXIJF", function(module, exports) {
$parcel$export(module.exports, "default", () => $d497aca4e44c4114$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<83af3303bc3c64e6435533b926015995>>
 * @relayHash efba23c378c4e21bc9cb49c9ce3af5ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID acfa8bb13b9d9896d845e54c429fc00fe572296ab9ec45c1f8b75bfdd8fda56c
const $d497aca4e44c4114$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "collectionId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "emoji"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraProductDiscoveryCollection"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v3 /*: any*/ 
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                }
            ]
        }
    ], v5 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4RoadmapsContentQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "RoadmapsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4RoadmapsContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "roadmapFavourites",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "JPD_COLLECTION"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v4 /*: any*/ 
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "roadmapRecents",
                            "args": [
                                v2 /*: any*/ ,
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "JPD_COLLECTION"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v4 /*: any*/ 
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "acfa8bb13b9d9896d845e54c429fc00fe572296ab9ec45c1f8b75bfdd8fda56c",
            "metadata": {},
            "name": "Nav4RoadmapsContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d497aca4e44c4114$var$node.hash = "cb31d658bc1e59d98b259d4e0c2d9daf";
var $d497aca4e44c4114$export$2e2bcd8739ae039 = $d497aca4e44c4114$var$node;

});


parcelRegister("5axNp", function(module, exports) {
$parcel$export(module.exports, "RoadmapItem", () => $6fab3f21436a7325$export$1fcd4778932623ed);

var $cxd1Y = parcelRequire("cxd1Y");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $fG3jk = parcelRequire("fG3jk");

var $iPHqm = parcelRequire("iPHqm");

var $aOGXw = parcelRequire("aOGXw");

var $82ATR = parcelRequire("82ATR");

var $c4aX7 = parcelRequire("c4aX7");

var $5F8FY = parcelRequire("5F8FY");

var $hQxjT = parcelRequire("hQxjT");
var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $i6EgM = parcelRequire("i6EgM");

var $55BnK = parcelRequire("55BnK");

var $ffznM = parcelRequire("ffznM");

var $kVWNZ = parcelRequire("kVWNZ");

var $78GR0 = parcelRequire("78GR0");

var $hLi02 = parcelRequire("hLi02");

var $3a4dy = parcelRequire("3a4dy");

var $20Qwn = parcelRequire("20Qwn");

var $7WrJq = parcelRequire("7WrJq");
const $6fab3f21436a7325$export$1fcd4778932623ed = ({ collectionQueryRefFragment: collectionQueryRefFragment = null, currentItems: currentItems, currentOrder: currentOrder, item: item, isDraggable: isDraggable = false })=>{
    const roadmapItemCollectionData = (0, $n67Vb.useFragment)((0, $cxd1Y.default), collectionQueryRefFragment);
    const { push: push } = (0, $55BnK.useRouterActions)();
    const { getLinkProps: getLinkProps } = (0, $c4aX7.useGetLinkProps)();
    const { updateCollection: updateCollection, expandSectionForSelectedCollection: expandSectionForSelectedCollection } = (0, $iPHqm.useNavigationCollectionsActions)();
    const EmojiIcon = (0, $fG3jk.useCollectionEmojiIcon)(roadmapItemCollectionData?.emoji ?? undefined);
    const uuid = roadmapItemCollectionData ? (0, $i6EgM.JiraProductDiscoveryCollectionAri).parse(roadmapItemCollectionData.id).collectionId : '';
    const isCollectionSelected = (0, $78GR0.useIsCollectionSelected)(uuid ? {
        collectionUUID: uuid
    } : undefined) || false;
    const { isOpen: isCollectionExpanded, onToggle: onExpansionToggle, setIsOpen: setIsOpen } = (0, $5F8FY.useOpenable)(isCollectionSelected);
    (0, $euxye.useEffect)(()=>{
        if (isCollectionSelected) {
            expandSectionForSelectedCollection();
            setIsOpen(true);
        }
    }, [
        expandSectionForSelectedCollection,
        isCollectionSelected,
        setIsOpen
    ]);
    const handleExpansionToggle = (0, $euxye.useCallback)((nextIsExpanded)=>{
        onExpansionToggle();
        updateCollection(uuid, {
            isExpanded: nextIsExpanded
        });
    }, [
        onExpansionToggle,
        updateCollection,
        uuid
    ]);
    const onViewCreated = (0, $euxye.useCallback)((view)=>{
        if (isCollectionSelected) return;
        push((0, $aOGXw.getCollectionViewPageUrl)(uuid, view.id));
    }, [
        isCollectionSelected,
        push,
        uuid
    ]);
    const handleRoadmapClick = (0, $euxye.useCallback)((event)=>{
        if ((0, $82ATR.isNormalClick)(event)) event.preventDefault();
    }, []);
    const navigationCollection = (0, $euxye.useMemo)(()=>{
        return {
            collectionUUID: uuid
        };
    }, [
        uuid
    ]);
    if (!roadmapItemCollectionData) return null;
    if (isDraggable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($6fab3f21436a7325$var$DraggableRoadmapItemContent, {
        roadmapItemCollectionData: roadmapItemCollectionData,
        uuid: uuid,
        isCollectionSelected: isCollectionSelected,
        isCollectionExpanded: isCollectionExpanded,
        onExpansionToggle: handleExpansionToggle,
        onViewCreated: onViewCreated,
        onClick: handleRoadmapClick,
        navigationCollection: navigationCollection,
        EmojiIcon: EmojiIcon,
        getLinkProps: getLinkProps,
        currentItems: currentItems,
        currentOrder: currentOrder,
        item: item
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kVWNZ.WithData), {
        collectionUUID: uuid,
        onViewCreated: onViewCreated
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hQxjT.ExpandableMenuItem), {
        isExpanded: isCollectionExpanded,
        onExpansionToggle: handleExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        ...getLinkProps((0, $aOGXw.getCollectionDetailsPageUrl)(uuid)),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(EmojiIcon, {
            label: roadmapItemCollectionData.title,
            fitToHeight: 20
        }),
        onClick: handleRoadmapClick,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3a4dy.ActionButtonsRoadmap), {
            collectionUUID: uuid,
            isCollectionSelected: isCollectionSelected,
            isCollectionExpanded: isCollectionExpanded,
            navigationCollection: navigationCollection,
            onViewCreated: onViewCreated,
            collectionQueryRefFragment: roadmapItemCollectionData,
            currentItems: currentItems,
            currentOrder: currentOrder,
            item: item
        }),
        interactionName: "nav4-sidebar-roadmaps"
    }, roadmapItemCollectionData.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $20Qwn.RoadmapItemViews), {
        isCollectionSelected: isCollectionSelected,
        navigationCollection: navigationCollection
    }))));
};
$6fab3f21436a7325$export$1fcd4778932623ed.displayName = "RoadmapItem";
function $6fab3f21436a7325$var$DraggableRoadmapItemContent({ roadmapItemCollectionData: roadmapItemCollectionData, uuid: uuid, isCollectionSelected: isCollectionSelected, isCollectionExpanded: isCollectionExpanded, onExpansionToggle: onExpansionToggle, onViewCreated: onViewCreated, onClick: onClick, navigationCollection: navigationCollection, EmojiIcon: EmojiIcon, getLinkProps: getLinkProps, currentItems: currentItems, currentOrder: currentOrder, item: item }) {
    const { entityAri: entityAri, ownerAri: ownerAri, group: group } = (0, $hLi02.useRoadmapReorderingIds)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7WrJq.useDragAndDropReorderingAnalytics)();
    const dragAndDropState = (0, $ffznM.useNestedItemDragAndDrop)({
        entityAri: entityAri,
        ownerAri: ownerAri,
        data: {
            id: roadmapItemCollectionData.id,
            label: roadmapItemCollectionData.title
        },
        group: group,
        fireAnalyticsEvent: fireAnalyticsEvent,
        item: undefined,
        isExpandable: true,
        isExpandOrFlyoutOpen: isCollectionExpanded,
        id: roadmapItemCollectionData.id,
        isDragAndDropEnabled: true,
        onExpandFlyoutToggle: (open)=>{
            if (open !== isCollectionExpanded) onExpansionToggle(open);
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kVWNZ.WithData), {
        collectionUUID: uuid,
        onViewCreated: onViewCreated
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hQxjT.ExpandableMenuItem), {
        isExpanded: isCollectionExpanded && !dragAndDropState.isDragging,
        onExpansionToggle: onExpansionToggle,
        ref: dragAndDropState.dropTargetRef,
        dropIndicator: dragAndDropState.dropIndicator
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        ...getLinkProps((0, $aOGXw.getCollectionDetailsPageUrl)(uuid)),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(EmojiIcon, {
            label: roadmapItemCollectionData.title,
            fitToHeight: 20
        }),
        onClick: onClick,
        isDragging: dragAndDropState?.isDragging,
        hasDragIndicator: true,
        ref: dragAndDropState.draggableRef,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3a4dy.ActionButtonsRoadmap), {
            collectionUUID: uuid,
            isCollectionSelected: isCollectionSelected,
            isCollectionExpanded: isCollectionExpanded,
            navigationCollection: navigationCollection,
            onViewCreated: onViewCreated,
            collectionQueryRefFragment: roadmapItemCollectionData,
            currentItems: currentItems,
            currentOrder: currentOrder,
            item: item
        }),
        interactionName: "nav4-sidebar-roadmaps"
    }, roadmapItemCollectionData.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $20Qwn.RoadmapItemViews), {
        isCollectionSelected: isCollectionSelected,
        navigationCollection: navigationCollection
    }))), dragAndDropState.maybeDragPreview);
}
$6fab3f21436a7325$var$DraggableRoadmapItemContent.displayName = "DraggableRoadmapItemContent";

});
parcelRegister("cxd1Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $14b86a2659580456$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca117beec687f0552ef7c8eba7328401>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $14b86a2659580456$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RoadmapItem_collection",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "title"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "collectionId"
            },
            "action": "THROW"
        },
        {
            "kind": "ScalarField",
            "name": "emoji"
        },
        {
            "kind": "FragmentSpread",
            "name": "ActionButtonsRoadmap_collection"
        }
    ],
    "type": "JiraProductDiscoveryCollection"
};
$14b86a2659580456$var$node.hash = "e248e39f34f1992fe9c03519e1a155a5";
var $14b86a2659580456$export$2e2bcd8739ae039 = $14b86a2659580456$var$node;

});

parcelRegister("fG3jk", function(module, exports) {
$parcel$export(module.exports, "useCollectionEmojiTile", () => $b38b52e86ddce8a4$export$5df281f537247ab9);
$parcel$export(module.exports, "useCollectionEmojiIcon", () => $b38b52e86ddce8a4$export$397a03e2ccd6750a);

var $euxye = parcelRequire("euxye");

var $8wdvw = parcelRequire("8wdvw");

var $6ZLJT = parcelRequire("6ZLJT");

var $8rdd5 = parcelRequire("8rdd5");

var $ffudd = parcelRequire("ffudd");

var $ejGIi = parcelRequire("ejGIi");

var $b47ZF = parcelRequire("b47ZF");

var $i860n = parcelRequire("i860n");
const $b38b52e86ddce8a4$var$EmojiIcon = ({ emojiDesc: emojiDesc, ...props })=>{
    let fitToHeight = 24;
    if (props.fitToHeight) fitToHeight = props.fitToHeight;
    else if (props.size && typeof props.size === 'string') fitToHeight = parseInt((0, $ffudd.sizes)[props.size], 10) || 24;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8rdd5.default), {
        emoji: emojiDesc,
        showTooltip: true,
        fitToHeight: fitToHeight
    });
};
$b38b52e86ddce8a4$var$EmojiIcon.displayName = "EmojiIcon";
const $b38b52e86ddce8a4$var$DefaultRoadmapTile = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ejGIi.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b47ZF))),
        label: props.label,
        appearance: "gray",
        size: "small"
    });
};
$b38b52e86ddce8a4$var$DefaultRoadmapTile.displayName = "DefaultRoadmapTile";
const $b38b52e86ddce8a4$var$useCollectionEmojiIconNew = (emoji)=>{
    const emojiDesc = (0, $8wdvw.useEmoji)(emoji);
    return (0, $euxye.useMemo)(()=>{
        if (emojiDesc) return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b38b52e86ddce8a4$var$EmojiIcon, {
                emojiDesc: emojiDesc,
                ...props
            });
        return 0, (/*@__PURE__*/$parcel$interopDefault($b47ZF));
    }, [
        emojiDesc
    ]);
};
const $b38b52e86ddce8a4$export$5df281f537247ab9 = (emoji)=>{
    const emojiDesc = (0, $8wdvw.useEmoji)(emoji);
    return (0, $euxye.useMemo)(()=>{
        if (emojiDesc) return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b38b52e86ddce8a4$var$EmojiIcon, {
                emojiDesc: emojiDesc,
                ...props
            });
        return $b38b52e86ddce8a4$var$DefaultRoadmapTile;
    }, [
        emojiDesc
    ]);
};
const $b38b52e86ddce8a4$export$5b18ebaaa2d87160 = (emoji)=>{
    const emojiDesc = (0, $8wdvw.useEmoji)(emoji);
    return (0, $euxye.useMemo)(()=>{
        if (emojiDesc) return (props)=>{
            let fitToHeight = 24;
            if (props.fitToHeight) fitToHeight = props.fitToHeight;
            else if (props.size) fitToHeight = parseInt((0, $ffudd.sizes)[props.size], 10);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8rdd5.default), {
                emoji: emojiDesc,
                showTooltip: true,
                fitToHeight: fitToHeight
            });
        };
        return (props)=>{
            const tileSize = $b38b52e86ddce8a4$var$sizeMapping(props.size || 'medium');
            if (tileSize === null) // For '16' size, render the icon directly without a tile
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b47ZF))), {
                label: props.label,
                color: "var(--ds-icon-accent-gray, #7D818A)"
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ejGIi.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($b47ZF))),
                label: props.label,
                appearance: "gray",
                size: tileSize
            });
        };
    }, [
        emojiDesc
    ]);
};
const $b38b52e86ddce8a4$export$397a03e2ccd6750a = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jpd-enable-roadmaps-recents-fe'), $b38b52e86ddce8a4$var$useCollectionEmojiIconNew, // oxlint-disable-next-line typescript/consistent-type-assertions
$b38b52e86ddce8a4$export$5b18ebaaa2d87160);
// remove with jpd-enable-roadmaps-recents-fe
const $b38b52e86ddce8a4$var$sizeMapping = (size)=>{
    switch(size){
        case 'small':
            return null;
        case 'medium':
            return 'small';
        case 'large':
            return 'medium';
        case 'xlarge':
            return 'large';
        default:
            return 'small';
    }
};

});
parcelRegister("8rdd5", function(module, exports) {
$parcel$export(module.exports, "unicodeEmojiCanvasSize", () => $73e656a7f8084787$export$6130a4ff6b3c066e);
$parcel$export(module.exports, "EmojiNodeWrapper", () => $73e656a7f8084787$export$ce5eef59d8e46687);
$parcel$export(module.exports, "default", () => $73e656a7f8084787$export$2e2bcd8739ae039);
/* Emoji.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $1jztF = parcelRequire("1jztF");

var $1PA5z = parcelRequire("1PA5z");

var $hZDXn = parcelRequire("hZDXn");

var $1uzV7 = parcelRequire("1uzV7");

var $dCZA2 = parcelRequire("dCZA2");

var $kdJgV = parcelRequire("kdJgV");

var $gq0pG = parcelRequire("gq0pG");

var $02Yv9 = parcelRequire("02Yv9");

var $3UnZm = parcelRequire("3UnZm");

var $7krBE = parcelRequire("7krBE");

var $3Ug00 = parcelRequire("3Ug00");

var $9P5Tw = parcelRequire("9P5Tw");

var $5kzLc = parcelRequire("5kzLc");

var $55nSP = parcelRequire("55nSP");

var $8dHuO = parcelRequire("8dHuO");

var $4346D = parcelRequire("4346D");

var $lNFnt = parcelRequire("lNFnt");

var $lrcrV = parcelRequire("lrcrV");
const $73e656a7f8084787$var$emojiSpriteContainer = null;
const $73e656a7f8084787$var$emojiImageContainer = null;
// Unicode emojis render as text inside a <span>, not an <img>, so they do not need
// borderRadius (which would clip a background on hover) or the img { display: block } rule.
const $73e656a7f8084787$var$emojiUnicodeContainer = null;
const $73e656a7f8084787$export$6130a4ff6b3c066e = 128;
const $73e656a7f8084787$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $3UnZm.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $9P5Tw.leftClick)(event)) {
        if (props.preventFocusOnMouseDown) event.preventDefault();
        onSelected((0, $5kzLc.toEmojiId)(emoji), emoji, event);
    }
};
const $73e656a7f8084787$var$handleKeyDown = (props, event)=>{
    if (!(0, $3UnZm.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $3UnZm.KeyboardKeys).Enter || event.key === (0, $3UnZm.KeyboardKeys).Space)) onSelected((0, $5kzLc.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $3UnZm.KeyboardKeys).Backspace) (0, $8dHuO.handleDelete)(props, event);
};
const $73e656a7f8084787$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $5kzLc.toEmojiId)(emoji), emoji, event);
};
const $73e656a7f8084787$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $5kzLc.toEmojiId)(emoji), emoji, event);
};
const $73e656a7f8084787$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, renderUnicodeEmojiAsImage: renderUnicodeEmojiAsImage, ...other } = props;
    const intl = (0, $euxye.useContext)((0, $1jztF.Context));
    const ariaLabel = editorEmoji ? undefined : intl ? intl.formatMessage((0, $55nSP.messages).changeEmojiShortnameButtonLabel, {
        shortName: emoji.name ?? emoji.shortName
    }) : emoji.shortName;
    const tooltipContent = showTooltip && (0, $1PA5z.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true) ? emoji.shortName || emoji.name || undefined : undefined;
    const emojiSpan = /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        role: editorEmoji ? undefined : shouldBeInteractive ? 'button' : ariaLabel ? 'img' : 'presentation',
        "aria-label": ariaLabel,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $4jQY2.default)([
            type === 'sprite' ? "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _1e0c1o8l _jr50scvx _ylp71o8l _pkaxgktf _1hdcgktf _109tnkob _tn8j1dpa _3naf1dpa _nt751r31 _49pcglyw _1hvw1o36 _7ehi1y54 _491113zc" : type === 'unicode' ? "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _bfhk18uv _1e0c1o8l _s7n4nkob _tn8j1dpa _3naf1dpa _160jewfl _1theewfl _1kogh2mm _qyp0ewfl _nt751r31 _49pcglyw _1hvw1o36 _7ehi1y54 _491113zc" : "_2rkofajl _19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _bfhk18uv _1e0c1o8l _s7n4nkob _v4pn1ule _tn8j1dpa _3naf1dpa _160jewfl _1theewfl _1kogh2mm _qyp0ewfl _nt751r31 _49pcglyw _1hvw1o36 _7ehi1y54 _491113zc",
            className
        ]),
        onKeyDown: (event)=>$73e656a7f8084787$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $73e656a7f8084787$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $73e656a7f8084787$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $73e656a7f8084787$var$handleFocus(props, event);
        },
        title: showTooltip && !(0, $1PA5z.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true) ? emoji.shortName : undefined,
        ...other,
        children: children
    });
    if (tooltipContent) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        content: tooltipContent,
        isScreenReaderAnnouncementDisabled: true,
        position: "top",
        tag: "span",
        children: emojiSpan
    });
    return emojiSpan;
});
const $73e656a7f8084787$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props;
    // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $02Yv9.useSampledUFOComponentExperience)((0, $gq0pG.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $3UnZm.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $euxye.useEffect)(()=>{
        const ufoExp = (0, $kdJgV.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $dCZA2.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $dCZA2.hasUfoMarked)(ufoExp, (0, $1uzV7.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $1uzV7.UfoEmojiTimings).MOUNTED_END);
        if (emoji.type === (0, $1uzV7.ProviderTypes).STANDARD || (0, $3Ug00.isUnicodeRepresentation)(emoji.representation)) (0, $1PA5z.expValEquals)('platform_use_unicode_emojis', 'isEnabled', true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $3Ug00.isUnicodeRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lrcrV.UnicodeEmoji), {
        ...props
    });
    // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $7krBE.isSpriteRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lNFnt.SpriteEmoji), {
        ...props
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4346D.ImageEmoji), {
        ...props
    });
};
$73e656a7f8084787$export$56cc48506ff790a.displayName = "Emoji";
var $73e656a7f8084787$export$2e2bcd8739ae039 = $73e656a7f8084787$export$56cc48506ff790a;

});
parcelRegister("dCZA2", function(module, exports) {
$parcel$export(module.exports, "hasUfoMarked", () => $caf615975421b73d$export$a9be054d2a5cedc0);
const $caf615975421b73d$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};

});

parcelRegister("kdJgV", function(module, exports) {
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $69fed50766d57e53$export$71c8cba6f1251ea9);

var $gq0pG = parcelRequire("gq0pG");

var $7eMKD = parcelRequire("7eMKD");
const $69fed50766d57e53$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $7eMKD.withSampling)((0, $gq0pG.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};

});

parcelRegister("02Yv9", function(module, exports) {
$parcel$export(module.exports, "useSampledUFOComponentExperience", () => $0b2daedaf1340a77$export$f959821a7419dee1);

var $euxye = parcelRequire("euxye");

var $7eMKD = parcelRequire("7eMKD");
const $0b2daedaf1340a77$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $euxye.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $0b2daedaf1340a77$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $euxye.useEffect)(()=>{
        return ()=>{
            (0, $7eMKD.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $0b2daedaf1340a77$var$useConstructor(()=>{
        (0, $7eMKD.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};

});

parcelRegister("7krBE", function(module, exports) {
$parcel$export(module.exports, "isSpriteRepresentation", () => $1c332f5118787728$export$a194199d673d75de);
const $1c332f5118787728$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);

});

parcelRegister("3Ug00", function(module, exports) {
$parcel$export(module.exports, "isUnicodeRepresentation", () => $76dcdcae97fe1217$export$607f0d89b8881fb4);
const $76dcdcae97fe1217$export$607f0d89b8881fb4 = (rep)=>!!(rep && rep.unicodeEmoji);

});

parcelRegister("9P5Tw", function(module, exports) {
$parcel$export(module.exports, "leftClick", () => $ed15824d7ce43281$export$34ebdaf2c517ae75);
function $ed15824d7ce43281$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}

});

parcelRegister("55nSP", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8c2e68fbfeef469e$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $8c2e68fbfeef469e$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Heading text shown at the top of the emoji removal confirmation dialog, prompting the user to confirm removing the selected custom emoji.'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Body text shown inside the emoji removal confirmation dialog. The placeholder {emojiShortName} will be substituted with the short name (e.g. ":smile:") of the replacement emoji.'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Label for the primary action button in the emoji removal confirmation dialog that confirms and executes the removal.'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Label for the button in the emoji picker that opens the custom emoji upload panel, allowing users to add their own emoji.'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiNameLabel: {
        id: 'fabric.emoji.name.label',
        defaultMessage: 'Emoji name',
        description: 'Label for the emoji name input field in the custom emoji upload panel'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Label for the file chooser button in the custom emoji upload panel where users select an image file for their emoji.'
    },
    emojiChooseFileDndTitle: {
        id: 'fabric.emoji.choose.file.dnd.title',
        defaultMessage: 'Select or drop an image',
        description: 'Label for the file chooser button in the custom emoji upload panel where users select or drag and drop an image file for their emoji.'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectColorButtonAriaLabelText: {
        id: 'fabric.emoji.select.color.ariaLabel',
        defaultMessage: 'Productivity emoji color selector',
        description: 'Message indicating the purpose of the color selection button and the selected color'
    },
    emojiSelectColorListAriaLabelText: {
        id: 'fabric.emoji.select.color.list.ariaLabel',
        defaultMessage: 'Productivity emoji colour selector',
        description: 'Message indicating the purpose of the productivity emoji color list selector'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Section heading shown above the emoji preview area in the custom emoji upload panel.'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Success text shown in the emoji preview area after the user uploads a new emoji image. The placeholder {emoji} will be substituted with the rendered emoji image.'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'Label for the submit button in the custom emoji upload panel that saves the new emoji to the workspace.'
    },
    createEmojiWithRovoTitle: {
        id: 'fabric.emoji.ai.create.title',
        defaultMessage: 'Create an emoji with Rovo',
        description: 'Section heading for the AI emoji generation area where users describe an emoji and generate it with AI.'
    },
    createEmojiWithRovoPromptPlaceholder: {
        id: 'fabric.emoji.ai.prompt.placeholder',
        defaultMessage: 'Describe your emoji...',
        description: 'Placeholder text for the input where the user describes the emoji they want the AI to generate.'
    },
    createEmojiWithRovoPromptAriaLabel: {
        id: 'fabric.emoji.ai.prompt.ariaLabel',
        defaultMessage: 'Describe the emoji you want to generate',
        description: 'Accessible label for the AI emoji description input field.'
    },
    createEmojiWithRovoGenerateLabel: {
        id: 'fabric.emoji.ai.generate.label',
        defaultMessage: 'Generate',
        description: 'Label for the button that triggers AI generation of the described emoji.'
    },
    createEmojiWithRovoError: {
        id: 'fabric.emoji.ai.error',
        defaultMessage: 'Something went wrong. Try a different description.',
        description: 'Inline error message shown when AI emoji generation or upload fails, prompting the user to try again.'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'Label for the button in the custom emoji upload panel that retries a previously failed upload attempt.'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'Label for the cancel button in the custom emoji upload panel that dismisses the panel without saving.'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text shown inside the emoji search input field in the emoji picker before the user types a query.'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'Accessible label for the emoji name search input field in the emoji picker, used by screen readers.'
    },
    searchResultsStatus: {
        id: 'fabric.emoji.search.status.count',
        defaultMessage: 'Found {count} emojis',
        description: 'search results status for screenreader to read out'
    },
    searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Category heading label shown in the emoji picker category bar when displaying results from a search query.'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Label for the Frequent category tab in the emoji picker, showing recently used emojis.'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Label for the People category tab in the emoji picker, showing face and person emojis.'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Label for the Nature category tab in the emoji picker, showing animal and nature emojis.'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Label for the Food and Drink category tab in the emoji picker.'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Label for the Activity category tab in the emoji picker, showing sports and activity emojis.'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Label for the Travel and Places category tab in the emoji picker, showing location and travel emojis.'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Label for the Objects category tab in the emoji picker, showing everyday object emojis.'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Label for the Symbols category tab in the emoji picker, showing symbol and sign emojis.'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Label for the Flags category tab in the emoji picker, showing country and regional flag emojis.'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Atlassian & productivity',
        description: 'Label for the Atlassian and productivity category tab in the emoji picker, showing Atlassian product and productivity emojis.'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'Label for the Your Uploads category tab in the emoji picker, showing custom emojis uploaded by the current user.'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'Label for the All Uploads category tab in the emoji picker, showing all custom emojis uploaded across the workspace.'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Error message shown in the custom emoji upload panel when the image upload fails due to an error.'
    },
    emojiUploadTimeout: {
        id: 'fabric.emoji.error.upload.timeout',
        defaultMessage: 'Upload timed out',
        description: 'Error message shown in the custom emoji upload panel when the image upload fails because it timed out.'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiUnsupportedFileType: {
        id: 'fabric.emoji.error.unsupported.file.type',
        defaultMessage: "This file type isn't supported. Select a PNG, JPEG, or GIF to create your emoji.",
        description: 'Error message shown when the selected emoji upload file type is not supported'
    },
    emojiDuplicateName: {
        id: 'fabric.emoji.error.duplicate.name',
        defaultMessage: 'An emoji with this name exists already',
        description: 'Error message shown when the user tries to upload an emoji with a name that already exists in the custom emoji set'
    },
    emojiPickerNoResults: {
        id: 'fabric.emoji.picker.no.results',
        defaultMessage: 'No results',
        description: 'Heading shown in the emoji picker when a search query returns no matching emojis.'
    },
    emojiPickerAddCustomEmoji: {
        id: 'fabric.emoji.picker.add.custom.emoji',
        defaultMessage: 'Add custom emoji',
        description: 'Label for the button shown in the emoji picker no-results screen that opens the custom emoji upload panel.'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Accessible aria-label for the emoji picker dialog, used by screen readers to identify the picker.'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    changeEmojiShortnameButtonLabel: {
        id: 'fabric.emoji.change.shortname.button.label',
        defaultMessage: 'Change emoji, currently {shortName}',
        description: 'Aria label for the button in page title used to change emoji'
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});

parcelRegister("8dHuO", function(module, exports) {
$parcel$export(module.exports, "handleDelete", () => $183a50ec3daf2a9a$export$471c4c6c1d1a0512);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5kzLc = parcelRequire("5kzLc");
const $183a50ec3daf2a9a$export$471c4c6c1d1a0512 = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $5kzLc.toEmojiId)(emoji), emoji, event);
};

});

parcelRegister("4346D", function(module, exports) {
$parcel$export(module.exports, "ImageEmoji", () => $b6f875db2dec4001$export$99dfeb9d71c11788);
/* ImageEmoji.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $eIbOZ = parcelRequire("eIbOZ");

var $hZDXn = parcelRequire("hZDXn");

var $33tT4 = parcelRequire("33tT4");

var $3LebG = parcelRequire("3LebG");

var $1uzV7 = parcelRequire("1uzV7");

var $dCZA2 = parcelRequire("dCZA2");

var $kdJgV = parcelRequire("kdJgV");

var $jbz4B = parcelRequire("jbz4B");

var $ktoNx = parcelRequire("ktoNx");

var $lzAfn = parcelRequire("lzAfn");

var $5kzLc = parcelRequire("5kzLc");

var $5UlPV = parcelRequire("5UlPV");

var $clHWh = parcelRequire("clHWh");

var $cbK1V = parcelRequire("cbK1V");

var $8rdd5 = parcelRequire("8rdd5");

var $8dHuO = parcelRequire("8dHuO");

const $b6f875db2dec4001$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props;
    // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $5kzLc.toEmojiId)(emoji), emoji, event);
};
const $b6f875db2dec4001$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth } = props;
    const [ref, inView] = (0, $3LebG.useInView)({
        triggerOnce: true
    });
    const ufoExp = (0, $euxye.useMemo)(()=>(0, $kdJgV.sampledUfoRenderedEmoji)(emoji), [
        emoji
    ]);
    const classes = `${(0, $735b22fe5e8c8419$export$11462c0756c24ab6)} ${(0, $735b22fe5e8c8419$export$b06c4aab1d012063)} ${selected ? (0, $735b22fe5e8c8419$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $735b22fe5e8c8419$export$860109dfd198259b) : ''} ${(0, $735b22fe5e8c8419$export$da61cef1c8919f7c)} ${className ? className : ''} ${showDelete ? (0, $735b22fe5e8c8419$export$22b19c311e9caa4) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $33tT4.shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $ktoNx.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $lzAfn.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) {
        const sizingWidth = autoWidth ? 'auto' : fitToHeight / height * width;
        // Presize image, to prevent reflow due to size changes after loading
        sizing = {
            width: sizingWidth,
            height: fitToHeight
        };
    }
    const onError = (0, $euxye.useCallback)((event)=>{
        $b6f875db2dec4001$var$handleImageError({
            emoji: props.emoji,
            onLoadError: props.onLoadError
        }, event);
    }, [
        props.emoji,
        props.onLoadError
    ]);
    const onLoad = (0, $euxye.useCallback)(()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $1uzV7.UfoEmojiTimings).MOUNTED_END);
        // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $dCZA2.hasUfoMarked)(ufoExp, (0, $1uzV7.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $1uzV7.UfoEmojiTimings).ONLOAD_START, mountedMark?.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $1uzV7.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
        // onload_start
        if (!(0, $dCZA2.hasUfoMarked)(ufoExp, (0, $1uzV7.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $1uzV7.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $jbz4B.default).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    }, [
        emoji,
        onLoadSuccess,
        ufoExp
    ]);
    const onBeforeLoad = (0, $euxye.useCallback)(()=>{
        if (!(0, $dCZA2.hasUfoMarked)(ufoExp, (0, $1uzV7.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $1uzV7.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    const onMouseOver = (0, $euxye.useCallback)((e)=>{
        // only disable tooltip when not on focus
        if (!(0, $eIbOZ.getDocument)()?.activeElement?.contains(e.target)) e.stopPropagation();
    }, []);
    // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $euxye.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const emojiNode = /*#__PURE__*/ (0, $e79Pd.jsx)("img", {
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        alt: emoji.name || emoji.shortName || '',
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "emoji",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    }, src);
    // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        content: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5UlPV.DeletableEmojiTooltipContent), {}),
        position: "right-start",
        tag: "span",
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8rdd5.EmojiNodeWrapper), {
            ...props,
            "aria-labelledby": `screenreader-emoji-${emoji.id}`,
            type: "image",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: classes,
            ref: ref,
            showTooltip: false,
            onMouseOver: onMouseOver,
            children: [
                emojiNode,
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cbK1V.default), {
                    onClick: (event)=>(0, $8dHuO.handleDelete)(props, event)
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $clHWh.DeletableEmojiTooltipContentForScreenReader), {
                    emoji: emoji
                })
            ]
        })
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8rdd5.EmojiNodeWrapper), {
        ...props,
        type: "image",
        className: classes,
        ref: ref,
        children: emojiNode
    }));
};
$b6f875db2dec4001$export$99dfeb9d71c11788.displayName = "ImageEmoji";

});
parcelRegister("33tT4", function(module, exports) {
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $327cbb6be8bb8341$export$b7e9058f156d8d19);

var $lFGDz = parcelRequire("lFGDz");
const $327cbb6be8bb8341$var$getHeight = (fitToHeight)=>(0, $lFGDz.getPixelRatio)() > 1 ? fitToHeight * 2 : fitToHeight;
const $327cbb6be8bb8341$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && emoji.representation && 'height' in emoji.representation && $327cbb6be8bb8341$var$getHeight(fitToHeight) > emoji.representation.height);

});

parcelRegister("3LebG", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $94c314a9790ab716$export$2f62ee6831462844);

var $8FYqe = parcelRequire("8FYqe");

var $jbz4B = parcelRequire("jbz4B");
const $94c314a9790ab716$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $8FYqe.useInView)(options);
    if (!(0, $jbz4B.default).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};

});
parcelRegister("8FYqe", function(module, exports) {
$parcel$export(module.exports, "InView", () => $651105a5b703df74$export$a62107ca74432f44);
$parcel$export(module.exports, "useInView", () => $651105a5b703df74$export$2f62ee6831462844);

var $euxye = parcelRequire("euxye");
"use client";
var $651105a5b703df74$var$__defProp = Object.defineProperty;
var $651105a5b703df74$var$__defNormalProp = (obj, key, value)=>key in obj ? $651105a5b703df74$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $651105a5b703df74$var$__publicField = (obj, key, value)=>$651105a5b703df74$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/observe.ts
var $651105a5b703df74$var$observerMap = /* @__PURE__ */ new Map();
var $651105a5b703df74$var$RootIds = /* @__PURE__ */ new WeakMap();
var $651105a5b703df74$var$rootId = 0;
var $651105a5b703df74$var$unsupportedValue = void 0;
function $651105a5b703df74$export$2ef3a60ee1f37bec(inView) {
    $651105a5b703df74$var$unsupportedValue = inView;
}
function $651105a5b703df74$var$getRootId(root) {
    if (!root) return "0";
    if ($651105a5b703df74$var$RootIds.has(root)) return $651105a5b703df74$var$RootIds.get(root);
    $651105a5b703df74$var$rootId += 1;
    $651105a5b703df74$var$RootIds.set(root, $651105a5b703df74$var$rootId.toString());
    return $651105a5b703df74$var$RootIds.get(root);
}
function $651105a5b703df74$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $651105a5b703df74$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $651105a5b703df74$var$createObserver(options) {
    const id = $651105a5b703df74$var$optionsToId(options);
    let instance = $651105a5b703df74$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $651105a5b703df74$var$observerMap.set(id, instance);
    }
    return instance;
}
function $651105a5b703df74$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $651105a5b703df74$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $651105a5b703df74$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $651105a5b703df74$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $651105a5b703df74$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $651105a5b703df74$export$a62107ca74432f44 = class extends $euxye.Component {
    constructor(props){
        super(props);
        $651105a5b703df74$var$__publicField(this, "node", null);
        $651105a5b703df74$var$__publicField(this, "_unobserveCb", null);
        $651105a5b703df74$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $651105a5b703df74$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$651105a5b703df74$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $651105a5b703df74$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $euxye.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
};
function $651105a5b703df74$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $euxye.useState(null);
    const callback = $euxye.useRef(onChange);
    const [state, setState] = $euxye.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $euxye.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $651105a5b703df74$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $euxye.useRef(void 0);
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});

parcelRegister("jbz4B", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d6f3704b0ecff2d$export$2e2bcd8739ae039);
const $3d6f3704b0ecff2d$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $3d6f3704b0ecff2d$var$result.mac = /Mac/.test(navigator.platform);
    $3d6f3704b0ecff2d$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $3d6f3704b0ecff2d$export$2e2bcd8739ae039 = $3d6f3704b0ecff2d$var$result;

});


parcelRegister("5UlPV", function(module, exports) {
$parcel$export(module.exports, "DeletableEmojiTooltipContent", () => $bf4273bf948ed895$export$4727956877b6f612);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $3LmOk = parcelRequire("3LmOk");

var $55nSP = parcelRequire("55nSP");

var $kVt94 = parcelRequire("kVt94");
const $bf4273bf948ed895$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kVt94.ToolTipContentWithKeymap), {
        description: formatMessage((0, $55nSP.messages).deleteEmojiTooltip),
        keymap: (0, $3LmOk.backspace)
    });
};
$bf4273bf948ed895$export$4727956877b6f612.displayName = "DeletableEmojiTooltipContent";

});
parcelRegister("3LmOk", function(module, exports) {
$parcel$export(module.exports, "backspace", () => $94a1c4ef471df02e$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "arrowKeysMap", () => $94a1c4ef471df02e$export$8d734690d3a46118);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $f46pA = parcelRequire("f46pA");
const $94a1c4ef471df02e$export$1ea584ca7009bcc1 = (0, $f46pA.makeKeyMapWithCommon)('Backspace', 'Backspace');
const $94a1c4ef471df02e$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};

});
parcelRegister("f46pA", function(module, exports) {
$parcel$export(module.exports, "makeKeyMapWithCommon", () => $d5a791e8667df3d8$export$7e6b588cc98b34f1);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $eveJ3 = parcelRequire("eveJ3");
function $d5a791e8667df3d8$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return (0, $eveJ3.makeKeymap)(description, windows, mac, common);
}

});
parcelRegister("eveJ3", function(module, exports) {
$parcel$export(module.exports, "makeKeymap", () => $8ae341d262fd0e8b$export$d8a7f422d8d42038);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ function $8ae341d262fd0e8b$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}

});



parcelRegister("kVt94", function(module, exports) {
$parcel$export(module.exports, "ToolTipContentWithKeymap", () => $e98d08341de537c5$export$c7308f5f9ed494ac);
/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $cj7xu = parcelRequire("cj7xu");
const $e98d08341de537c5$var$tooltipShortcutStyle = null;
const $e98d08341de537c5$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $cj7xu.formatShortcut)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            description,
            shortcut && description && '\u00A0',
            shortcut && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    "_2rkofajl _bfhk1vck _ca0qidpf _n3tdidpf _19bvv77o _u5f3v77o _jqf61teg"
                ]),
                children: shortcut
            })
        ]
    }) : null;
});

});
parcelRegister("cj7xu", function(module, exports) {
$parcel$export(module.exports, "formatShortcut", () => $1fd266f8df7e5f1c$export$384a290f8c265cc5);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $jbz4B = parcelRequire("jbz4B");

var $3LmOk = parcelRequire("3LmOk");
function $1fd266f8df7e5f1c$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $jbz4B.default).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = (0, $3LmOk.arrowKeysMap)[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $jbz4B.default).mac ? '' : '+');
}

});



parcelRegister("clHWh", function(module, exports) {
$parcel$export(module.exports, "DeletableEmojiTooltipContentForScreenReader", () => $2e74cf7bed8c2261$export$d151e4941072147c);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $apUrw = parcelRequire("apUrw");

var $55nSP = parcelRequire("55nSP");
const $2e74cf7bed8c2261$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
        id: `screenreader-emoji-${emoji.id}`,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            ...(0, $55nSP.messages).deleteEmojiTooltipForScreenreader,
            values: {
                shortName: emoji.shortName
            }
        })
    });
};
$2e74cf7bed8c2261$export$d151e4941072147c.displayName = "DeletableEmojiTooltipContentForScreenReader";

});

parcelRegister("cbK1V", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6ef99348bf0b001$export$2e2bcd8739ae039);
/* DeleteButton.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $4qNCE = parcelRequire("4qNCE");

var $9qT28 = parcelRequire("9qT28");

var $3UnZm = parcelRequire("3UnZm");


var $ihEDU = parcelRequire("ihEDU");

var $4LDqh = parcelRequire("4LDqh");
const $d6ef99348bf0b001$var$isRefreshEmojiPickerEnabled = ()=>{
    if (!(0, $4LDqh.default).initializeCompleted()) return false;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const isEnabled = (0, $4LDqh.default).getExperimentValue('platform_teamoji_26_refresh_emoji_picker', 'isEnabled', false);
    return isEnabled;
};
const $d6ef99348bf0b001$var$styles = {
    boxWrapperStyle: "_1bsbf6fq _4t3if6fq"
};
const $d6ef99348bf0b001$var$deleteButton = null;
const $d6ef99348bf0b001$var$refreshedDeleteButton = null;
const $d6ef99348bf0b001$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $d6ef99348bf0b001$var$DeleteButton = (props)=>{
    const isRefreshEnabled = $d6ef99348bf0b001$var$isRefreshEmojiPickerEnabled();
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $4jQY2.default)([
            "_3um015vq _1e0c1txw _kqswstnw _154ix0bf _1xi2x0bf _1pbykb7n _13t3idpf",
            isRefreshEnabled && "_154ir5cr _1xi2r5cr",
            (0, $735b22fe5e8c8419$export$b11fa39b56a371f6)
        ]),
        "data-testid": $d6ef99348bf0b001$export$28fc7374cf1206d4,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4qNCE.default), {
            iconBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                xcss: $d6ef99348bf0b001$var$styles.boxWrapperStyle,
                children: isRefreshEnabled ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9qT28))), {
                    label: (0, $3UnZm.deleteEmojiLabel),
                    color: "var(--ds-icon, #292A2E)",
                    size: "medium"
                }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9qT28))), {
                    label: (0, $3UnZm.deleteEmojiLabel),
                    color: "var(--ds-text-subtle, #505258)",
                    size: "small"
                })
            }),
            onClick: props.onClick,
            // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
            appearance: "subtle-link",
            spacing: "none",
            testId: "emoji-delete-button",
            tabIndex: -1
        })
    });
};
$d6ef99348bf0b001$var$DeleteButton.displayName = "DeleteButton";
var $d6ef99348bf0b001$export$2e2bcd8739ae039 = $d6ef99348bf0b001$var$DeleteButton;

});
const $735b22fe5e8c8419$export$8633a0edef8e95dd = 'emoji-common-selected';
const $735b22fe5e8c8419$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $735b22fe5e8c8419$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $735b22fe5e8c8419$export$b06c4aab1d012063 = 'emoji-common-node';
const $735b22fe5e8c8419$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $735b22fe5e8c8419$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $735b22fe5e8c8419$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $735b22fe5e8c8419$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $735b22fe5e8c8419$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $735b22fe5e8c8419$export$b0fe756d87022806 = 'emoji-picker-add-emoji';



parcelRegister("lNFnt", function(module, exports) {
$parcel$export(module.exports, "SpriteEmoji", () => $19604926470c0236$export$ef49ddbb198ce334);
/* SpriteEmoji.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1PA5z = parcelRequire("1PA5z");

var $8rdd5 = parcelRequire("8rdd5");

const $19604926470c0236$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $735b22fe5e8c8419$export$b06c4aab1d012063)} ${selected ? (0, $735b22fe5e8c8419$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $735b22fe5e8c8419$export$860109dfd198259b) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) {
        if ((0, $1PA5z.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) sizing = {
            minHeight: `${fitToHeight}px`,
            minWidth: `${fitToHeight}px`
        };
        else sizing = {
            width: `${fitToHeight}px`,
            height: `${fitToHeight}px`,
            minHeight: `${fitToHeight}px`,
            minWidth: `${fitToHeight}px`
        };
    }
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8rdd5.EmojiNodeWrapper), {
        ...props,
        type: "sprite",
        className: classes,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
            className: (0, $735b22fe5e8c8419$export$1c10634420a08d8a),
            style: style
        })
    }));
};
$19604926470c0236$export$ef49ddbb198ce334.displayName = "SpriteEmoji";

});

parcelRegister("lrcrV", function(module, exports) {
$parcel$export(module.exports, "UnicodeEmoji", () => $9f5879e28b3550eb$export$a6bb8d12872402fb);
/* UnicodeEmoji.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $3UnZm = parcelRequire("3UnZm");

var $7lnfT = parcelRequire("7lnfT");

var $aX7y7 = parcelRequire("aX7y7");

var $8rdd5 = parcelRequire("8rdd5");

var $flFtP = parcelRequire("flFtP");

var $4346D = parcelRequire("4346D");

const $9f5879e28b3550eb$var$useUnicodeEmojiImage = (unicodeEmoji)=>{
    const [state, setState] = (0, $euxye.useState)({
        status: 'loading'
    });
    (0, $euxye.useEffect)(()=>{
        let cancelled = false;
        let imagePathToRevoke;
        setState({
            status: 'loading',
            unicodeEmoji: unicodeEmoji
        });
        (0, $aX7y7.renderUnicodeEmojiToImagePath)(unicodeEmoji).then((imagePath)=>{
            if (cancelled) {
                if (imagePath) URL.revokeObjectURL(imagePath);
                return;
            }
            imagePathToRevoke = imagePath;
            setState(imagePath ? {
                status: 'ready',
                unicodeEmoji: unicodeEmoji,
                imagePath: imagePath
            } : {
                status: 'failed',
                unicodeEmoji: unicodeEmoji
            });
        }).catch(()=>{
            if (!cancelled) setState({
                status: 'failed',
                unicodeEmoji: unicodeEmoji
            });
        });
        return ()=>{
            cancelled = true;
            if (imagePathToRevoke) URL.revokeObjectURL(imagePathToRevoke);
        };
    }, [
        unicodeEmoji
    ]);
    return state;
};
const $9f5879e28b3550eb$var$UnicodeEmojiImage = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, showTooltip: showTooltip } = props;
    const emojiText = emoji.representation.unicodeEmoji;
    const unicodeEmojiImage = $9f5879e28b3550eb$var$useUnicodeEmojiImage(emojiText);
    const hasCurrentEmojiImage = unicodeEmojiImage.unicodeEmoji === emojiText;
    if ((0, $7lnfT.isSSR)() || !hasCurrentEmojiImage || unicodeEmojiImage.status === 'loading') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $flFtP.default), {
        shortName: emoji.shortName,
        showTooltip: showTooltip,
        size: fitToHeight,
        loading: true
    });
    if (unicodeEmojiImage.status === 'ready') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4346D.ImageEmoji), {
        ...props,
        emoji: {
            ...emoji,
            altRepresentation: undefined,
            representation: {
                imagePath: unicodeEmojiImage.imagePath,
                width: (0, $8rdd5.unicodeEmojiCanvasSize),
                height: (0, $8rdd5.unicodeEmojiCanvasSize)
            }
        }
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $flFtP.default), {
        shortName: emoji.shortName,
        showTooltip: showTooltip,
        size: fitToHeight
    });
};
$9f5879e28b3550eb$var$UnicodeEmojiImage.displayName = "UnicodeEmojiImage";
const $9f5879e28b3550eb$export$a6bb8d12872402fb = (props)=>{
    const { emoji: emoji, selected: selected, selectOnHover: selectOnHover, className: className, fitToHeight: fitToHeight, renderUnicodeEmojiAsImage: renderUnicodeEmojiAsImage = true } = props;
    if (renderUnicodeEmojiAsImage) return /*#__PURE__*/ (0, $e79Pd.jsx)($9f5879e28b3550eb$var$UnicodeEmojiImage, {
        ...props
    });
    const classes = `${(0, $735b22fe5e8c8419$export$b06c4aab1d012063)} ${selected ? (0, $735b22fe5e8c8419$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $735b22fe5e8c8419$export$860109dfd198259b) : ''} ${className ? className : ''}`;
    const emojiText = emoji.representation.unicodeEmoji;
    const defaultSize = `${fitToHeight ?? (0, $3UnZm.defaultEmojiHeight)}px`;
    const emojiSize = `var(--emoji-common-unicode-size, ${defaultSize})`;
    const style = {
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: emojiSize,
        alignItems: 'center',
        aspectRatio: '1/1'
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8rdd5.EmojiNodeWrapper), {
        ...props,
        type: "unicode",
        className: classes,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
            style: style,
            children: emojiText
        })
    }));
};
$9f5879e28b3550eb$export$a6bb8d12872402fb.displayName = "UnicodeEmoji";

});
parcelRegister("7lnfT", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $404047c3cc29413f$export$48d7c418edadb60c);

var $gIMgJ = parcelRequire("gIMgJ");
function $404047c3cc29413f$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $gIMgJ !== 'undefined' && $gIMgJ?.env?.REACT_SSR);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});

parcelRegister("aX7y7", function(module, exports) {
$parcel$export(module.exports, "renderUnicodeEmojiToImagePath", () => $ffe2a8917b6b4ee0$export$3692f6e5ef5bb18a);

var $7lnfT = parcelRequire("7lnfT");
const $ffe2a8917b6b4ee0$var$unicodeEmojiCanvasSize = 128;
const $ffe2a8917b6b4ee0$var$unicodeEmojiCanvasFontSize = 124;
const $ffe2a8917b6b4ee0$var$unicodeEmojiCanvasTopPadding = 8;
const $ffe2a8917b6b4ee0$export$3692f6e5ef5bb18a = async (unicodeEmoji)=>{
    const OffscreenCanvasCtor = globalThis['OffscreenCanvas'];
    if ((0, $7lnfT.isSSR)() || !OffscreenCanvasCtor || typeof URL === 'undefined') return undefined;
    const canvas = new OffscreenCanvasCtor($ffe2a8917b6b4ee0$var$unicodeEmojiCanvasSize, $ffe2a8917b6b4ee0$var$unicodeEmojiCanvasSize);
    const context = canvas.getContext('2d');
    if (!context) return undefined;
    context.clearRect(0, 0, $ffe2a8917b6b4ee0$var$unicodeEmojiCanvasSize, $ffe2a8917b6b4ee0$var$unicodeEmojiCanvasSize);
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.font = `${$ffe2a8917b6b4ee0$var$unicodeEmojiCanvasFontSize}px sans-serif`;
    context.fillText(unicodeEmoji, $ffe2a8917b6b4ee0$var$unicodeEmojiCanvasSize / 2, $ffe2a8917b6b4ee0$var$unicodeEmojiCanvasSize / 2 + $ffe2a8917b6b4ee0$var$unicodeEmojiCanvasTopPadding);
    const blob = await canvas.convertToBlob({
        type: 'image/png'
    });
    return URL.createObjectURL(blob);
};

});

parcelRegister("flFtP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a57ae04f6e913123$export$2e2bcd8739ae039);
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $1PA5z = parcelRequire("1PA5z");

var $3UnZm = parcelRequire("3UnZm");

var $1yqF7 = parcelRequire("1yqF7");

const $a57ae04f6e913123$var$placeholderContainer = null;
const $a57ae04f6e913123$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $3UnZm.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false, xcss: xcss } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = (0, $1PA5z.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? {
        fill: 'f7f7f7',
        minWidth: `${0, $3UnZm.defaultDenseEmojiHeight}px`,
        minHeight: `${0, $3UnZm.defaultDenseEmojiHeight}px`
    } : {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        "data-testid": (0, $1yqF7.emojiPlaceholderTestId)(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $4jQY2.default)([
            "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _2rkofajl _1reo15vq _18m915vq _kqswh2mm _1e0c1o8l _bfhk1l7x _s7n4nkob _o5721q9c _y3gn1h6o",
            [
                (0, $735b22fe5e8c8419$export$c7187bbd1a7a9244),
                xcss
            ].join(' ')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        title: showTooltip ? shortName : ''
    });
};
$a57ae04f6e913123$var$EmojiPlaceholder.displayName = "EmojiPlaceholder";
var $a57ae04f6e913123$export$2e2bcd8739ae039 = $a57ae04f6e913123$var$EmojiPlaceholder;

});
parcelRegister("1yqF7", function(module, exports) {
$parcel$export(module.exports, "emojiPlaceholderTestId", () => $37ffe97314927c93$export$73987987fac5266b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $37ffe97314927c93$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;

});




parcelRegister("ffudd", function(module, exports) {
$parcel$export(module.exports, "sizes", () => $54bd2ebfd3b94db6$export$c647cb0ee6e282fe);
$parcel$export(module.exports, "sizeMap", () => $54bd2ebfd3b94db6$export$7bd66fc94c81bf84);
const $54bd2ebfd3b94db6$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $54bd2ebfd3b94db6$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $54bd2ebfd3b94db6$export$62ad7b0c781000e9 = {
    small: {
        width: $54bd2ebfd3b94db6$export$c647cb0ee6e282fe.small,
        height: $54bd2ebfd3b94db6$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $54bd2ebfd3b94db6$export$c647cb0ee6e282fe.medium,
        height: $54bd2ebfd3b94db6$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $54bd2ebfd3b94db6$export$c647cb0ee6e282fe.large,
        height: $54bd2ebfd3b94db6$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $54bd2ebfd3b94db6$export$c647cb0ee6e282fe.xlarge,
        height: $54bd2ebfd3b94db6$export$c647cb0ee6e282fe.xlarge
    }
};

});

parcelRegister("ejGIi", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5d6bd8bce1f4e05$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $auo2G = parcelRequire("auo2G");
// Icon color mapping for Tile-based icons
const $c5d6bd8bce1f4e05$var$iconColorMap = {
    blue: "_syaz6txe",
    blueBold: "_syaz1q3r",
    gray: "_syazdgkc",
    grayBold: "_syaz5w2r",
    green: "_syaz17hp",
    greenBold: "_syaz1q3r",
    lime: "_syaz8645",
    limeBold: "_syaz1q3r",
    magenta: "_syazv8hk",
    magentaBold: "_syaz1q3r",
    orange: "_syaz1j6y",
    orangeBold: "_syaz1q3r",
    purple: "_syazuq3u",
    purpleBold: "_syaz1q3r",
    red: "_syaznbxb",
    redBold: "_syaz1q3r",
    teal: "_syaz8uof",
    tealBold: "_syaz1q3r",
    yellow: "_syaz1oqg",
    yellowBold: "_syaz1q3r"
};
const $c5d6bd8bce1f4e05$var$iconWrapperStyles = {
    root: "_vwz4idpf"
};
// Background color mapping for Tile component
const $c5d6bd8bce1f4e05$var$backgroundColorMap = {
    blue: undefined,
    blueBold: 'color.background.accent.blue.subtle',
    gray: undefined,
    grayBold: 'color.background.neutral.bold',
    green: undefined,
    greenBold: 'color.background.accent.green.subtle',
    lime: undefined,
    limeBold: 'color.background.accent.lime.subtle',
    magenta: undefined,
    magentaBold: 'color.background.accent.magenta.subtle',
    orange: undefined,
    orangeBold: 'color.background.accent.orange.subtle',
    purple: undefined,
    purpleBold: 'color.background.accent.purple.subtle',
    red: undefined,
    redBold: 'color.background.accent.red.subtle',
    teal: undefined,
    tealBold: 'color.background.accent.teal.subtle',
    yellow: undefined,
    yellowBold: 'color.background.accent.yellow.subtle'
};
function $c5d6bd8bce1f4e05$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = 'medium', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $auo2G.default), {
        size: size,
        backgroundColor: $c5d6bd8bce1f4e05$var$backgroundColorMap[appearance],
        label: label,
        testId: testId,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
            className: (0, $4jQY2.default)([
                $c5d6bd8bce1f4e05$var$iconColorMap[appearance],
                $c5d6bd8bce1f4e05$var$iconWrapperStyles.root
            ]),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)(ExpandedIcon, {
                color: "currentColor",
                label: "",
                shouldScale: true
            })
        })
    });
}
$c5d6bd8bce1f4e05$export$2e2bcd8739ae039.displayName = "IconTile";

});
parcelRegister("auo2G", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8cae4c364a5c50c$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

// Pixel sizes per tile size, used for retina validation
const $d8cae4c364a5c50c$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $d8cae4c364a5c50c$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf _s7n4nkob",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq _1jpx1dfr"
};
const $d8cae4c364a5c50c$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $d8cae4c364a5c50c$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $d8cae4c364a5c50c$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk18uv",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
};
function $d8cae4c364a5c50c$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    const containerRef = (0, $euxye.useRef)(null);
    // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $euxye.useEffect)(()=>{
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $4jQY2.default)([
            $d8cae4c364a5c50c$var$styles.root,
            $d8cae4c364a5c50c$var$sizeMap[size],
            isInset ? $d8cae4c364a5c50c$var$styles.inset : $d8cae4c364a5c50c$var$styles.nonInset,
            isInset && $d8cae4c364a5c50c$var$insetSizeMap[size],
            $d8cae4c364a5c50c$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $d8cae4c364a5c50c$var$styles.border
        ]),
        children: children
    });
}
$d8cae4c364a5c50c$export$2e2bcd8739ae039.displayName = "Tile";

});



parcelRegister("kVWNZ", function(module, exports) {
$parcel$export(module.exports, "WithData", () => $c8b428d707b39193$export$3b86b58ccfed71df);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $9nfpB = parcelRequire("9nfpB");

var $6yRkP = parcelRequire("6yRkP");

var $kmMHr = parcelRequire("kmMHr");

var $k4bFc = parcelRequire("k4bFc");

var $e1DnH = parcelRequire("e1DnH");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $kt86l = parcelRequire("kt86l");

var $iQPOZ = parcelRequire("iQPOZ");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $cZjb4 = parcelRequire("cZjb4");

var $1rRWW = parcelRequire("1rRWW");

var $b1YRJ = parcelRequire("b1YRJ");
const $c8b428d707b39193$var$errorTitle = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.roadmaps.with-data.error-title",
    defaultMessage: "Something went wrong"
});
const $c8b428d707b39193$var$errorDescription = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.roadmaps.with-data.error-description",
    defaultMessage: "Refresh the page to try again."
});
const $c8b428d707b39193$export$3b86b58ccfed71df = ({ children: children, collectionUUID: collectionUUID, onViewCreated: onViewCreated })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const cloudId = (0, $kt86l.useCloudId)();
    const navigationViewRemote = (0, $1rRWW.useNavigationViewRemote)();
    const [entityLimits] = (0, $e1DnH.useEntityLimits)();
    const [selectedViewUUID] = (0, $cZjb4.usePathParam)('resource');
    const [selectedCollectionUUID] = (0, $cZjb4.usePathParam)('collectionUUID');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $iQPOZ.useFlagsService)();
    const isActiveCollection = selectedCollectionUUID === collectionUUID;
    const onSuccess = (0, $euxye.useCallback)((action)=>{
        (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jpdNavigationV4Action success', {
            action: action,
            type: 'collections-views',
            isActiveCollection: isActiveCollection
        });
    }, [
        createAnalyticsEvent,
        isActiveCollection
    ]);
    const onFailure = (0, $euxye.useCallback)((error, action)=>{
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'jpdNavigationV4Action'
            },
            attributes: {
                action: action,
                type: 'collections-views'
            }
        });
        showFlag({
            id: `${action}-failed`,
            type: 'error',
            title: formatMessage($c8b428d707b39193$var$errorTitle),
            description: formatMessage($c8b428d707b39193$var$errorDescription),
            // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
            messageId: 'navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.ui.with-data.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        formatMessage,
        showFlag
    ]);
    if (!navigationViewRemote) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k4bFc.PermissionsContainer), {
        scope: (0, $6yRkP.getCollectionContainerScope)(collectionUUID),
        cacheTTL: (0, $b1YRJ.PERMISSIONS_CACHE_TTL),
        isCollectionView: true,
        isSharedView: false,
        isEmbeddedView: false,
        onLoadStart: (0, $9nfpB.jpdProjectPageLoadPermissionsStart),
        onLoadEnd: (0, $9nfpB.jpdProjectPageLoadPermissionsEnd)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kmMHr.NavigationContainer), {
        isGlobal: true,
        containerType: "COLLECTION",
        activeViewId: selectedViewUUID,
        isActiveContainer: isActiveCollection,
        navigationRemote: navigationViewRemote,
        cloudId: cloudId,
        containerId: collectionUUID,
        entityLimits: entityLimits,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onViewCreated: onViewCreated,
        createAnalyticsEvent: createAnalyticsEvent
    }, children));
};
$c8b428d707b39193$export$3b86b58ccfed71df.displayName = "WithData";

});
parcelRegister("9nfpB", function(module, exports) {
$parcel$export(module.exports, "PAGE_LOAD_MARK_INITIAL_RENDER_START", () => $dc2d0e4d9589250b$export$d94e22e398b40d3e);
$parcel$export(module.exports, "PAGE_LOAD_MARK_INITIAL_RENDER_END", () => $dc2d0e4d9589250b$export$25faf068e86e1827);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_VIEWS_START", () => $dc2d0e4d9589250b$export$b6e521c1c735f819);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_VIEWS_END", () => $dc2d0e4d9589250b$export$2d39e56eb6bc61e2);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_PROJECT_START", () => $dc2d0e4d9589250b$export$e9ade44ad4706ce2);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_PROJECT_END", () => $dc2d0e4d9589250b$export$62ccc5c18b320a1c);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_INSIGHTS_START", () => $dc2d0e4d9589250b$export$143502466d17e9b1);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_INSIGHTS_END", () => $dc2d0e4d9589250b$export$a8581b9dacd8996a);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_FIELDS_START", () => $dc2d0e4d9589250b$export$bbdca1640a59e683);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_FIELDS_END", () => $dc2d0e4d9589250b$export$77c443b5622981d3);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_ISSUES_START", () => $dc2d0e4d9589250b$export$5899a9a7e5194e40);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_ISSUES_END", () => $dc2d0e4d9589250b$export$b33e4b126300862b);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_VIEW_MAIN_START", () => $dc2d0e4d9589250b$export$7cb35720e348e7d6);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_VIEW_MAIN_END", () => $dc2d0e4d9589250b$export$346e293d7601d12);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_LIST_VIEW_START", () => $dc2d0e4d9589250b$export$7cb16aaae52cb7c4);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_LIST_VIEW_END", () => $dc2d0e4d9589250b$export$c00320feb79e362);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_BOARD_VIEW_START", () => $dc2d0e4d9589250b$export$804cba7c4155c239);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_BOARD_VIEW_END", () => $dc2d0e4d9589250b$export$92f49e88c0cf9398);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_MATRIX_VIEW_START", () => $dc2d0e4d9589250b$export$c7df8588815a5dff);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_MATRIX_VIEW_END", () => $dc2d0e4d9589250b$export$6d58a19b2a5a7d6c);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_TIMELINE_VIEW_START", () => $dc2d0e4d9589250b$export$5c41eba619cf4422);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_TIMELINE_VIEW_END", () => $dc2d0e4d9589250b$export$70d7f5af83b810d1);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_BOARD_SWIMLANE_VIEW_START", () => $dc2d0e4d9589250b$export$f287ddc953d21ba2);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_BOARD_SWIMLANE_VIEW_END", () => $dc2d0e4d9589250b$export$a2ceee803729727c);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_TREE_VIEW_START", () => $dc2d0e4d9589250b$export$ccd863e4abb8cc79);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_TREE_VIEW_END", () => $dc2d0e4d9589250b$export$65ae1a83eeb314cb);
$parcel$export(module.exports, "getJpdProjectPageLoadMetric", () => $dc2d0e4d9589250b$export$fd6d36ad90baf6f6);
$parcel$export(module.exports, "jpdProjectPageLoad", () => $dc2d0e4d9589250b$export$ba35263e5f55f1c8);
$parcel$export(module.exports, "jpdProjectPageLoadPermissionsStart", () => $dc2d0e4d9589250b$export$e8787017048b5d03);
$parcel$export(module.exports, "jpdProjectPageLoadPermissionsEnd", () => $dc2d0e4d9589250b$export$e12eec0846d40def);
/* eslint-disable jira/filename-case */ 
var $jvGCa = parcelRequire("jvGCa");
const $dc2d0e4d9589250b$export$d94e22e398b40d3e = 'PAGE_LOAD_MARK_INITIAL_RENDER_START';
const $dc2d0e4d9589250b$export$25faf068e86e1827 = 'PAGE_LOAD_MARK_INITIAL_RENDER_END';
const $dc2d0e4d9589250b$export$4ba1c1d0a3f1fcf9 = 'PAGE_LOAD_MARK_LOAD_PERMISSIONS_START';
const $dc2d0e4d9589250b$export$c68cd8d9163d8024 = 'PAGE_LOAD_MARK_LOAD_PERMISSIONS_END';
const $dc2d0e4d9589250b$export$b6e521c1c735f819 = 'PAGE_LOAD_MARK_LOAD_VIEWS_START';
const $dc2d0e4d9589250b$export$2d39e56eb6bc61e2 = 'PAGE_LOAD_MARK_LOAD_VIEWS_END';
const $dc2d0e4d9589250b$export$e9ade44ad4706ce2 = 'PAGE_LOAD_MARK_LOAD_PROJECT_START';
const $dc2d0e4d9589250b$export$62ccc5c18b320a1c = 'PAGE_LOAD_MARK_LOAD_PROJECT_END';
const $dc2d0e4d9589250b$export$143502466d17e9b1 = 'PAGE_LOAD_MARK_LOAD_INSIGHTS_START';
const $dc2d0e4d9589250b$export$a8581b9dacd8996a = 'PAGE_LOAD_MARK_LOAD_INSIGHTS_END';
const $dc2d0e4d9589250b$export$bbdca1640a59e683 = 'PAGE_LOAD_MARK_LOAD_FIELDS_START';
const $dc2d0e4d9589250b$export$77c443b5622981d3 = 'PAGE_LOAD_MARK_LOAD_FIELDS_END';
const $dc2d0e4d9589250b$export$5899a9a7e5194e40 = 'PAGE_LOAD_MARK_LOAD_ISSUES_START';
const $dc2d0e4d9589250b$export$b33e4b126300862b = 'PAGE_LOAD_MARK_LOAD_ISSUES_END';
const $dc2d0e4d9589250b$export$7cb35720e348e7d6 = 'PAGE_LOAD_MARK_RENDER_VIEW_MAIN_START';
const $dc2d0e4d9589250b$export$346e293d7601d12 = 'PAGE_LOAD_MARK_RENDER_VIEW_MAIN_END';
const $dc2d0e4d9589250b$export$7cb16aaae52cb7c4 = 'PAGE_LOAD_MARK_RENDER_LIST_VIEW_START';
const $dc2d0e4d9589250b$export$c00320feb79e362 = 'PAGE_LOAD_MARK_RENDER_LIST_VIEW_END';
const $dc2d0e4d9589250b$export$804cba7c4155c239 = 'PAGE_LOAD_MARK_RENDER_BOARD_VIEW_START';
const $dc2d0e4d9589250b$export$92f49e88c0cf9398 = 'PAGE_LOAD_MARK_RENDER_BOARD_VIEW_END';
const $dc2d0e4d9589250b$export$c7df8588815a5dff = 'PAGE_LOAD_MARK_RENDER_MATRIX_VIEW_START';
const $dc2d0e4d9589250b$export$6d58a19b2a5a7d6c = 'PAGE_LOAD_MARK_RENDER_MATRIX_VIEW_END';
const $dc2d0e4d9589250b$export$5c41eba619cf4422 = 'PAGE_LOAD_MARK_RENDER_TIMELINE_VIEW_START';
const $dc2d0e4d9589250b$export$70d7f5af83b810d1 = 'PAGE_LOAD_MARK_RENDER_TIMELINE_VIEW_END';
const $dc2d0e4d9589250b$export$f287ddc953d21ba2 = 'PAGE_LOAD_MARK_RENDER_BOARD_SWIMLANE_VIEW_START';
const $dc2d0e4d9589250b$export$a2ceee803729727c = 'PAGE_LOAD_MARK_RENDER_BOARD_SWIMLANE_VIEW_END';
const $dc2d0e4d9589250b$export$ccd863e4abb8cc79 = 'PAGE_LOAD_MARK_RENDER_TREE_VIEW_START';
const $dc2d0e4d9589250b$export$65ae1a83eeb314cb = 'PAGE_LOAD_MARK_RENDER_TREE_VIEW_END';
const $dc2d0e4d9589250b$var$isSharedView = ()=>/\/jira\/discovery\/share\/views\/[a-zA-Z0-9-]+/.test(globalThis.location?.href);
// Lazily initialize the metric because it depends on the URL
let $dc2d0e4d9589250b$var$jpdProjectPageLoadMetric;
function $dc2d0e4d9589250b$export$fd6d36ad90baf6f6() {
    if ($dc2d0e4d9589250b$var$jpdProjectPageLoadMetric != null) return $dc2d0e4d9589250b$var$jpdProjectPageLoadMetric;
    $dc2d0e4d9589250b$var$jpdProjectPageLoadMetric = (0, $jvGCa.metrics).pageLoad({
        key: $dc2d0e4d9589250b$var$isSharedView() ? 'jpd.shared-view' : 'jpd.project',
        featureFlags: [],
        timings: [
            {
                key: 'product/initial-render',
                startMark: $dc2d0e4d9589250b$export$d94e22e398b40d3e,
                endMark: $dc2d0e4d9589250b$export$25faf068e86e1827
            },
            {
                key: 'product/load-permissions',
                startMark: $dc2d0e4d9589250b$export$4ba1c1d0a3f1fcf9,
                endMark: $dc2d0e4d9589250b$export$c68cd8d9163d8024
            },
            {
                key: 'product/load-views',
                startMark: $dc2d0e4d9589250b$export$b6e521c1c735f819,
                endMark: $dc2d0e4d9589250b$export$2d39e56eb6bc61e2
            },
            {
                key: 'product/load-project',
                startMark: $dc2d0e4d9589250b$export$e9ade44ad4706ce2,
                endMark: $dc2d0e4d9589250b$export$62ccc5c18b320a1c
            },
            {
                key: 'product/load-insights',
                startMark: $dc2d0e4d9589250b$export$143502466d17e9b1,
                endMark: $dc2d0e4d9589250b$export$a8581b9dacd8996a
            },
            {
                key: 'product/load-fields',
                startMark: $dc2d0e4d9589250b$export$bbdca1640a59e683,
                endMark: $dc2d0e4d9589250b$export$77c443b5622981d3
            },
            {
                key: 'product/load-issues',
                startMark: $dc2d0e4d9589250b$export$5899a9a7e5194e40,
                endMark: $dc2d0e4d9589250b$export$b33e4b126300862b
            },
            {
                key: 'product/render-view-main',
                startMark: $dc2d0e4d9589250b$export$7cb35720e348e7d6,
                endMark: $dc2d0e4d9589250b$export$346e293d7601d12
            },
            {
                key: 'product/render-list-view',
                startMark: $dc2d0e4d9589250b$export$7cb16aaae52cb7c4,
                endMark: $dc2d0e4d9589250b$export$c00320feb79e362
            },
            {
                key: 'product/render-board-view',
                startMark: $dc2d0e4d9589250b$export$804cba7c4155c239,
                endMark: $dc2d0e4d9589250b$export$92f49e88c0cf9398
            },
            {
                key: 'product/render-board-swimlane-view',
                startMark: $dc2d0e4d9589250b$export$f287ddc953d21ba2,
                endMark: $dc2d0e4d9589250b$export$a2ceee803729727c
            },
            {
                key: 'product/render-matrix-view',
                startMark: $dc2d0e4d9589250b$export$c7df8588815a5dff,
                endMark: $dc2d0e4d9589250b$export$6d58a19b2a5a7d6c
            },
            {
                key: 'product/render-timeline-view',
                startMark: $dc2d0e4d9589250b$export$5c41eba619cf4422,
                endMark: $dc2d0e4d9589250b$export$70d7f5af83b810d1
            },
            {
                key: 'product/render-tree-view',
                startMark: $dc2d0e4d9589250b$export$ccd863e4abb8cc79,
                endMark: $dc2d0e4d9589250b$export$65ae1a83eeb314cb
            }
        ]
    });
    return $dc2d0e4d9589250b$var$jpdProjectPageLoadMetric;
}
const $dc2d0e4d9589250b$export$ba35263e5f55f1c8 = {
    mark (...args) {
        $dc2d0e4d9589250b$export$fd6d36ad90baf6f6().mark(...args);
    }
};
const $dc2d0e4d9589250b$export$e8787017048b5d03 = ()=>{
    $dc2d0e4d9589250b$export$ba35263e5f55f1c8.mark($dc2d0e4d9589250b$export$4ba1c1d0a3f1fcf9);
};
const $dc2d0e4d9589250b$export$e12eec0846d40def = ()=>{
    $dc2d0e4d9589250b$export$ba35263e5f55f1c8.mark($dc2d0e4d9589250b$export$c68cd8d9163d8024);
};

});

parcelRegister("6yRkP", function(module, exports) {
$parcel$export(module.exports, "getProjectContainerScope", () => $eec57b2773b00c53$export$eb1ae0f84b562a1d);
$parcel$export(module.exports, "getCollectionContainerScope", () => $eec57b2773b00c53$export$b12fc0f4b1dfc0e1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $eec57b2773b00c53$export$eb1ae0f84b562a1d = (projectId)=>`project-${projectId}`;
const $eec57b2773b00c53$export$b12fc0f4b1dfc0e1 = (collectionUUID)=>`collection-${collectionUUID}`;

});

parcelRegister("kmMHr", function(module, exports) {
$parcel$export(module.exports, "NavigationStore", () => $9fd6ed8f945b6cfd$export$eea211cc28a8dc55);
$parcel$export(module.exports, "NavigationContainer", () => $9fd6ed8f945b6cfd$export$d1b98bde82a43bb3);
$parcel$export(module.exports, "useNavigationActions", () => $9fd6ed8f945b6cfd$export$d52b0df9de5d0e40);

var $3h1FP = parcelRequire("3h1FP");
var $dB6ay = parcelRequire("dB6ay");
var $5QDqc = parcelRequire("5QDqc");

var $eGRcA = parcelRequire("eGRcA");

var $eJXYZ = parcelRequire("eJXYZ");

var $6lqGD = parcelRequire("6lqGD");

var $gps3Z = parcelRequire("gps3Z");

var $dP1oY = parcelRequire("dP1oY");

var $6WCf3 = parcelRequire("6WCf3");

var $99xm4 = parcelRequire("99xm4");

var $4V2kc = parcelRequire("4V2kc");

var $7yUkX = parcelRequire("7yUkX");

var $10srQ = parcelRequire("10srQ");

var $iNbpn = parcelRequire("iNbpn");

var $ltNen = parcelRequire("ltNen");

var $iYReo = parcelRequire("iYReo");

var $cSv8d = parcelRequire("cSv8d");

var $isuBy = parcelRequire("isuBy");

var $a5ei5 = parcelRequire("a5ei5");

var $cSA64 = parcelRequire("cSA64");

var $2WV42 = parcelRequire("2WV42");

var $kOePI = parcelRequire("kOePI");

var $5jtR4 = parcelRequire("5jtR4");

var $iZoCI = parcelRequire("iZoCI");
const $9fd6ed8f945b6cfd$var$actions = {
    loadViews: $eGRcA.loadViews,
    refreshView: $eJXYZ.refreshView,
    refreshViews: $6lqGD.refreshViews,
    createViewSet: $gps3Z.createViewSet,
    createView: $dP1oY.createView,
    insertViewSet: $6WCf3.insertViewSet,
    deleteViewSet: $99xm4.deleteViewSet,
    updateViewSet: $4V2kc.updateViewSet,
    renameViewSet: $7yUkX.renameViewSet,
    cancelViewSetRenaming: $7yUkX.cancelViewSetRenaming,
    deleteView: $10srQ.deleteView,
    updateView: $iNbpn.updateView,
    renameView: $ltNen.renameView,
    cancelViewRenaming: $ltNen.cancelViewRenaming,
    addEmoji: $iYReo.addEmoji,
    deleteEmoji: $cSv8d.deleteEmoji,
    cloneView: $isuBy.cloneView,
    toggleView: $a5ei5.toggleView,
    rankView: $cSA64.rankView,
    syncViewName: $2WV42.syncViewName,
    syncViewEmoji: $2WV42.syncViewEmoji,
    syncViewDeletion: $2WV42.syncViewDeletion,
    expandSectionForSelectedView: $kOePI.expandSectionForSelectedView,
    deleteViewFromState: $5jtR4.deleteViewFromState,
    updateEntityLimits: $iZoCI.updateEntityLimits
};
const $9fd6ed8f945b6cfd$export$eea211cc28a8dc55 = (0, $5QDqc.createStore)({
    name: 'NavViewStore',
    initialState: {
        containers: {},
        entityLimits: {}
    },
    actions: $9fd6ed8f945b6cfd$var$actions
});
const $9fd6ed8f945b6cfd$export$d1b98bde82a43bb3 = (0, $dB6ay.createContainer)($9fd6ed8f945b6cfd$export$eea211cc28a8dc55, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch($9fd6ed8f945b6cfd$var$actions.expandSectionForSelectedView());
            dispatch($9fd6ed8f945b6cfd$var$actions.updateEntityLimits());
        },
    onUpdate: ()=>({ dispatch: dispatch })=>{
            dispatch($9fd6ed8f945b6cfd$var$actions.expandSectionForSelectedView());
            dispatch($9fd6ed8f945b6cfd$var$actions.updateEntityLimits());
        }
});
const $9fd6ed8f945b6cfd$export$d52b0df9de5d0e40 = (0, $3h1FP.createActionsHook)($9fd6ed8f945b6cfd$export$eea211cc28a8dc55);

});
parcelRegister("eGRcA", function(module, exports) {
$parcel$export(module.exports, "loadViews", () => $97fb817afa82f252$export$49bbed9aa7a8df7f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $kOePI = parcelRequire("kOePI");

var $PBAU4 = parcelRequire("PBAU4");

var $aGaXs = parcelRequire("aGaXs");
const $97fb817afa82f252$export$49bbed9aa7a8df7f = ({ tryPreload: tryPreload } = {})=>(0, $PBAU4.withRefreshBlocker)(async ({ setState: setState, getState: getState, dispatch: dispatch }, { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId, onFailure: onFailure, onSuccess: onSuccess })=>{
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || getState().containers[containerId]?.initialized) {
            if (!tryPreload && getState().containers[containerId]?.isLoading) // it means preload is in progress and we need to try again if case of preload failure
            setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                tryAgainAfterPreloadFailure: true
            }));
            return;
        }
        setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            isLoading: true,
            initialized: true,
            loadingError: null,
            tryAgainAfterPreloadFailure: false,
            views: []
        }));
        try {
            const views = await navigationRemote.fetch(containerId);
            setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                isLoading: false,
                initialized: true,
                loadingError: null,
                views: views?.map((0, $aGaXs.transformRemoteView))
            }));
            dispatch((0, $kOePI.expandSectionForSelectedView)());
            onSuccess?.('loadViews');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (!tryPreload) {
                setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                    isLoading: false,
                    initialized: true,
                    loadingError: error,
                    views: []
                }));
                onFailure?.(error, 'loadViews');
            } else setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                isLoading: false,
                initialized: false,
                loadingError: null,
                views: []
            }));
            // if preload failed on non onboarded project, we need to try again after project is onboarded
            if (tryPreload && getState().containers[containerId]?.tryAgainAfterPreloadFailure) dispatch($97fb817afa82f252$export$49bbed9aa7a8df7f());
        }
    });

});
parcelRegister("kOePI", function(module, exports) {
$parcel$export(module.exports, "expandSectionForSelectedView", () => $a68bcfb62c8862f7$export$bbce35222c40da17);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $aGaXs = parcelRequire("aGaXs");
const $a68bcfb62c8862f7$export$bbce35222c40da17 = ()=>async ({ setState: setState, getState: getState }, props)=>{
        const { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId, activeViewId: activeViewId, isActiveContainer: isActiveContainer } = props;
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        if (!isActiveContainer) return;
        const { parent: parent } = (0, $aGaXs.findViewBy)(getState().containers[containerId], (innerView)=>String(innerView.polarisId) === activeViewId || innerView.id === activeViewId);
        if (parent) setState((0, $aGaXs.modifyView)(getState(), containerId, (viewToModify)=>{
            if (viewToModify.localId === parent.localId) return {
                ...viewToModify,
                isExpanded: true
            };
            return viewToModify;
        }));
    };

});
parcelRegister("aGaXs", function(module, exports) {
$parcel$export(module.exports, "updateContainerState", () => $ca9a7d45fe5fff7c$export$f2177aaa0fe606dc);
$parcel$export(module.exports, "modifyView", () => $ca9a7d45fe5fff7c$export$d47a9f66421ac6ac);
$parcel$export(module.exports, "findViewBy", () => $ca9a7d45fe5fff7c$export$9e84431b7511903a);
$parcel$export(module.exports, "findView", () => $ca9a7d45fe5fff7c$export$788469894fae0ba2);
$parcel$export(module.exports, "transformRemoteView", () => $ca9a7d45fe5fff7c$export$8a96915f5142e7ef);
$parcel$export(module.exports, "createFakeId", () => $ca9a7d45fe5fff7c$export$999fd399aac8ece2);
$parcel$export(module.exports, "isFakeId", () => $ca9a7d45fe5fff7c$export$3f040eb4c68fedd0);
$parcel$export(module.exports, "makeNewTitle", () => $ca9a7d45fe5fff7c$export$e06c4d163e5a74cb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7TA2J = parcelRequire("7TA2J");

var $vfr75 = parcelRequire("vfr75");
const $ca9a7d45fe5fff7c$export$f2177aaa0fe606dc = (state, containerId, containerState)=>({
        ...state,
        containers: {
            ...state.containers,
            [containerId]: {
                ...state.containers[containerId],
                ...containerState
            }
        }
    });
const $ca9a7d45fe5fff7c$export$d47a9f66421ac6ac = (state, containerId, modify)=>$ca9a7d45fe5fff7c$export$f2177aaa0fe606dc(state, containerId, {
        views: state.containers[containerId].views.map((view)=>{
            const newView = modify(view);
            if (newView === view && view.views) return {
                ...newView,
                views: view.views?.map(modify)
            };
            return newView;
        })
    });
const $ca9a7d45fe5fff7c$export$9e84431b7511903a = (containerState, by)=>{
    let found = containerState.views.find((view)=>by(view));
    if (!found) {
        let parent;
        containerState.views.some((view)=>{
            if (view.views) return view.views.some((innerView)=>{
                if (by(innerView)) {
                    found = innerView;
                    parent = view;
                    return true;
                }
                return false;
            });
            return false;
        });
        return {
            view: found,
            parent: parent
        };
    }
    return {
        view: found,
        parent: undefined
    };
};
const $ca9a7d45fe5fff7c$export$788469894fae0ba2 = (containerState, localId)=>$ca9a7d45fe5fff7c$export$9e84431b7511903a(containerState, (view)=>view.localId === localId);
const $ca9a7d45fe5fff7c$export$8a96915f5142e7ef = (remoteView)=>({
        ...remoteView,
        views: remoteView.views?.map($ca9a7d45fe5fff7c$export$8a96915f5142e7ef),
        localId: (0, $7TA2J.v4)(),
        isExpanded: false
    });
const $ca9a7d45fe5fff7c$var$FAKE_ID_PREFIX = 'fake';
const $ca9a7d45fe5fff7c$export$999fd399aac8ece2 = (name)=>`${$ca9a7d45fe5fff7c$var$FAKE_ID_PREFIX}-${name}-${(0, $7TA2J.v4)()}`;
const $ca9a7d45fe5fff7c$export$3f040eb4c68fedd0 = (id)=>id.startsWith($ca9a7d45fe5fff7c$var$FAKE_ID_PREFIX);
const $ca9a7d45fe5fff7c$export$e06c4d163e5a74cb = (titleSeed)=>{
    const suffix = ' Copy';
    return titleSeed !== undefined ? `${titleSeed.substr(0, (0, $vfr75.VIEW_NAME_MAX_LENGTH) - suffix.length)}${suffix}` : 'New View';
};

});
parcelRegister("vfr75", function(module, exports) {
$parcel$export(module.exports, "CONTAINER", () => $4056b6961f99d152$export$33d8c916a600c5e9);
$parcel$export(module.exports, "VIEW_NAME_MAX_LENGTH", () => $4056b6961f99d152$export$27ce0e417db39a5c);
/* eslint-disable jira/filename-case */ const $4056b6961f99d152$export$33d8c916a600c5e9 = {
    PROJECT: 'PROJECT',
    SECTION: 'SECTION',
    COLLECTION: 'COLLECTION'
};
const $4056b6961f99d152$export$27ce0e417db39a5c = 100;

});



parcelRegister("PBAU4", function(module, exports) {
$parcel$export(module.exports, "withRefreshBlocker", () => $b2b08369fffd2ffb$export$50726dbf475bf444);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6lqGD = parcelRequire("6lqGD");

var $aGaXs = parcelRequire("aGaXs");
const $b2b08369fffd2ffb$var$blockRefresh = ()=>async ({ setState: setState, getState: getState }, props)=>{
        const { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId } = props;
        if (!cloudId || !containerId || !navigationRemote || !getState().containers[containerId]?.initialized) return;
        const numberOfRefreshBlocks = getState().containers[containerId].numberOfRefreshBlocks + 1;
        setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            lastRefreshBlockTime: Date.now(),
            numberOfRefreshBlocks: numberOfRefreshBlocks
        }));
    };
const $b2b08369fffd2ffb$var$unblockRefresh = ()=>async ({ setState: setState, getState: getState, dispatch: dispatch }, props)=>{
        const { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId } = props;
        if (!cloudId || !containerId || !navigationRemote || !getState().containers[containerId]?.initialized) return;
        const numberOfRefreshBlocks = getState().containers[containerId].numberOfRefreshBlocks - 1;
        setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            lastRefreshBlockTime: Date.now(),
            numberOfRefreshBlocks: numberOfRefreshBlocks < 0 ? 0 : numberOfRefreshBlocks
        }));
        if (getState().containers[containerId].scheduledRefresh) dispatch((0, $6lqGD.refreshViews)());
    };
const $b2b08369fffd2ffb$export$50726dbf475bf444 = (fn)=>{
    return async (api, props)=>{
        const { dispatch: dispatch } = api;
        dispatch($b2b08369fffd2ffb$var$blockRefresh());
        try {
            await fn(api, props);
        } finally{
            dispatch($b2b08369fffd2ffb$var$unblockRefresh());
        }
    };
};

});
parcelRegister("6lqGD", function(module, exports) {
$parcel$export(module.exports, "refreshViews", () => $9d0cd9999213268f$export$b00acd54dad6fc3a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eVMQF = parcelRequire("eVMQF");

var $5pMen = parcelRequire("5pMen");

var $aGaXs = parcelRequire("aGaXs");

var $aKjVC = parcelRequire("aKjVC");
const $9d0cd9999213268f$var$debounceInterval = 2000; // 2 seconds
const $9d0cd9999213268f$var$throttleInterval = 12000; // 12 seconds ~ 5 times in min
const $9d0cd9999213268f$var$refreshViewsFunc = async ({ setState: setState, getState: getState, dispatch: dispatch }, { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId, onFailure: onFailure, onSuccess: onSuccess })=>{
    if (!cloudId || !containerId || !navigationRemote || !getState().containers[containerId]?.initialized) return;
    if (getState().containers[containerId]?.isRefreshing || getState().containers[containerId]?.numberOfRefreshBlocks > 0) {
        setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            scheduledRefresh: true
        }));
        return;
    }
    const isScheduredRefresh = getState().containers[containerId]?.scheduledRefresh;
    const lastRefreshViewsTime = Date.now();
    setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
        isRefreshing: true,
        initialized: true,
        scheduledRefresh: false,
        refreshError: null
    }));
    try {
        const views = await navigationRemote.fetch(containerId);
        if (getState().containers[containerId]?.lastRefreshBlockTime > lastRefreshViewsTime || getState().containers[containerId]?.numberOfRefreshBlocks > 0) {
            onSuccess?.('refreshViews.outdated');
            setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                isRefreshing: false,
                scheduledRefresh: true
            }));
        } else {
            if (isScheduredRefresh) onSuccess?.('refreshViews.scheduled');
            else onSuccess?.('refreshViews');
            setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                isRefreshing: false,
                refreshError: null,
                lastRefreshViewsTime: Date.now(),
                views: (0, $aKjVC.mergeViews)(getState().containers[containerId].views, views)
            }));
        }
        // next load if scheduled
        if (getState().containers[containerId]?.scheduledRefresh) dispatch($9d0cd9999213268f$export$b00acd54dad6fc3a());
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            isRefreshing: false,
            refreshError: error
        }));
        onFailure?.(error, 'refreshViews');
    }
};
const $9d0cd9999213268f$export$b00acd54dad6fc3a = ()=>async (storeApi, props)=>{
        const { getState: getState, setState: setState } = storeApi;
        if (!getState().containers[props.containerId]?.controlledRefresh) {
            const controlledRefresh = (0, (/*@__PURE__*/$parcel$interopDefault($5pMen)))((0, (/*@__PURE__*/$parcel$interopDefault($eVMQF)))($9d0cd9999213268f$var$refreshViewsFunc, $9d0cd9999213268f$var$debounceInterval), $9d0cd9999213268f$var$throttleInterval);
            setState((0, $aGaXs.updateContainerState)(getState(), props.containerId, {
                controlledRefresh: controlledRefresh
            }));
        }
        await getState().containers[props.containerId]?.controlledRefresh?.(storeApi, props);
    };

});
parcelRegister("aKjVC", function(module, exports) {
$parcel$export(module.exports, "mergeViews", () => $8e421fc4a3d88325$export$3fa6a6e305032e63);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aGaXs = parcelRequire("aGaXs");
const $8e421fc4a3d88325$var$copyInternalProps = (currentView, newView)=>({
        ...newView,
        localId: currentView.localId,
        isRenaming: currentView.isRenaming,
        isLocked: currentView.isLocked,
        isExpanded: currentView.isExpanded,
        isManuallyCreated: currentView.isManuallyCreated
    });
const $8e421fc4a3d88325$export$3fa6a6e305032e63 = (currentViews, remoteViews)=>{
    const currentViewsMap = new Map();
    currentViews.forEach((view)=>{
        currentViewsMap.set(view.id, view);
        view.views?.forEach((innerView)=>{
            currentViewsMap.set(innerView.id, innerView);
        });
    });
    return remoteViews?.map((0, $aGaXs.transformRemoteView)).map((view)=>{
        if (currentViewsMap.has(view.id)) {
            const currentView = currentViewsMap.get(view.id);
            const newView = {
                ...view,
                views: view.views?.map((innerView)=>{
                    const innerCurrentView = currentViewsMap.get(innerView.id);
                    if (innerCurrentView) return $8e421fc4a3d88325$var$copyInternalProps(innerCurrentView, innerView);
                    return innerView;
                })
            };
            return currentView ? $8e421fc4a3d88325$var$copyInternalProps(currentView, newView) : newView;
        }
        return view;
    });
};

});




parcelRegister("eJXYZ", function(module, exports) {
$parcel$export(module.exports, "refreshView", () => $ed866c85205d8ce0$export$b0a1ec14789ddf70);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6lqGD = parcelRequire("6lqGD");

var $aGaXs = parcelRequire("aGaXs");
const $ed866c85205d8ce0$export$b0a1ec14789ddf70 = (viewUUID)=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId, onFailure: onFailure, onSuccess: onSuccess })=>{
        if (!cloudId || !containerId || !navigationRemote || !getState().containers[containerId]?.initialized) return;
        const { view: viewToRefresh } = (0, $aGaXs.findViewBy)(getState().containers[containerId], (view)=>view.id === viewUUID);
        if (getState().containers[containerId]?.isRefreshing || getState().containers[containerId]?.numberOfRefreshBlocks > 0 || viewToRefresh?.isRefreshing) {
            onSuccess?.('refreshView.conflict');
            // To avoid multiple refreshes, we schedule a whole tree refresh
            return dispatch((0, $6lqGD.refreshViews)());
        }
        setState((0, $aGaXs.modifyView)(getState(), containerId, (viewToModify)=>{
            if (viewToModify.id === viewUUID) return {
                ...viewToModify,
                isRefreshing: true
            };
            return viewToModify;
        }));
        const lastRefreshViewTime = Date.now();
        try {
            const remoteView = await navigationRemote.fetchView(viewUUID);
            if (getState().containers[containerId]?.lastRefreshBlockTime > lastRefreshViewTime || getState().containers[containerId]?.lastRefreshViewsTime > lastRefreshViewTime || getState().containers[containerId]?.numberOfRefreshBlocks > 0 || getState().containers[containerId]?.isRefreshing) {
                onSuccess?.('refreshView.outdated');
                setState((0, $aGaXs.modifyView)(getState(), containerId, (viewToModify)=>{
                    if (viewToModify.id === viewUUID) return {
                        ...viewToModify,
                        isRefreshing: false
                    };
                    return viewToModify;
                }));
                return dispatch((0, $6lqGD.refreshViews)());
            }
            const { view: viewToUpdate } = (0, $aGaXs.findViewBy)(getState().containers[containerId], (view)=>view.id === viewUUID);
            if (!viewToUpdate) return;
            setState((0, $aGaXs.modifyView)(getState(), containerId, (viewToModify)=>{
                if (viewToModify.id === viewUUID) return {
                    ...viewToModify,
                    name: remoteView.name,
                    emoji: remoteView.emoji,
                    isRefreshing: false
                };
                return viewToModify;
            }));
            onSuccess?.('refreshView');
        } catch (err) {
            setState((0, $aGaXs.modifyView)(getState(), containerId, (viewToModify)=>{
                if (viewToModify.id === viewUUID) return {
                    ...viewToModify,
                    isRefreshing: false
                };
                return viewToModify;
            }));
            onFailure?.(err instanceof Error ? err : new Error('Unknown error'), 'refreshView');
        }
    };

});

parcelRegister("gps3Z", function(module, exports) {
$parcel$export(module.exports, "createViewSet", () => $88a00fab9384765c$export$4bfa5d78aaaa4254);

var $dH1Sa = parcelRequire("dH1Sa");

var $PBAU4 = parcelRequire("PBAU4");

var $aGaXs = parcelRequire("aGaXs");
const $88a00fab9384765c$export$4bfa5d78aaaa4254 = (localId, name)=>(0, $PBAU4.withRefreshBlocker)(async ({ setState: setState, getState: getState }, { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId, onFailure: onFailure, onSuccess: onSuccess, containerType: containerType })=>{
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            views: [
                ...getState().containers[containerId].views.map((view)=>view.localId === localId ? {
                        ...view,
                        name: name,
                        isManuallyCreated: true,
                        isLocked: true,
                        isExpanded: false,
                        isRenaming: false
                    } : view)
            ]
        }));
        try {
            const remoteViewSet = await navigationRemote.createView({
                containerId: containerId,
                name: name,
                parentId: containerId,
                parentType: containerType,
                viewType: (0, $dH1Sa.VIEW_KIND_SECTION)
            });
            setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                views: [
                    ...getState().containers[containerId].views.map((view)=>view.localId === localId ? {
                            ...view,
                            id: remoteViewSet.id,
                            polarisId: remoteViewSet.polarisId,
                            name: remoteViewSet.name,
                            isLocked: false
                        } : view)
                ]
            }));
            onSuccess?.('createSection');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                views: [
                    ...getState().containers[containerId].views.map((view)=>view.localId === localId ? {
                            ...view,
                            isLocked: false
                        } : view)
                ]
            }));
            onFailure?.(error, 'createSection');
        }
    });

});
parcelRegister("dH1Sa", function(module, exports) {
$parcel$export(module.exports, "VIEW_KIND_TABLE", () => $6eb1dda2f71a71b1$export$76e8cbc60f99881d);
$parcel$export(module.exports, "VIEW_KIND_BOARD", () => $6eb1dda2f71a71b1$export$1ad049af934b4509);
$parcel$export(module.exports, "VIEW_KIND_MATRIX", () => $6eb1dda2f71a71b1$export$2b0330ebc4df6bb5);
$parcel$export(module.exports, "VIEW_KIND_TIMELINE", () => $6eb1dda2f71a71b1$export$b536e56a69266159);
$parcel$export(module.exports, "VIEW_KIND_SECTION", () => $6eb1dda2f71a71b1$export$4f6053f7f1423a0c);
$parcel$export(module.exports, "VIEW_KIND_TREE", () => $6eb1dda2f71a71b1$export$86d1f6589e2523cd);
$parcel$export(module.exports, "PROPERTY_LOADING_STATE", () => $6eb1dda2f71a71b1$export$94e2c990a618478f);
$parcel$export(module.exports, "ROADMAP_VIEWS_WITH_RANKING", () => $6eb1dda2f71a71b1$export$e393ba013369cf6e);
$parcel$export(module.exports, "CONNECTIONS_LAYOUT_SUMMARY", () => $6eb1dda2f71a71b1$export$15254c04917c5f93);
$parcel$export(module.exports, "CONNECTIONS_LAYOUT_LIST", () => $6eb1dda2f71a71b1$export$1945625338c888a6);
$parcel$export(module.exports, "CONNECTIONS_LAYOUT_CARDS", () => $6eb1dda2f71a71b1$export$6afc036a1671735b);
$parcel$export(module.exports, "COLUMN_SIZE_DEFAULT", () => $6eb1dda2f71a71b1$export$d224351a39160b0c);
$parcel$export(module.exports, "COLUMN_SIZE_SMALL", () => $6eb1dda2f71a71b1$export$b17563c9078b1921);
$parcel$export(module.exports, "COLUMN_SIZE_LARGE", () => $6eb1dda2f71a71b1$export$e9d55f10e8e91f5b);
$parcel$export(module.exports, "COLOR_STYLE_HIGHLIGHT", () => $6eb1dda2f71a71b1$export$a0701d3eebc5b694);
$parcel$export(module.exports, "COLOR_STYLE_BACKGROUND", () => $6eb1dda2f71a71b1$export$da8d0157d7b28066);
const $6eb1dda2f71a71b1$export$76e8cbc60f99881d = 'TABLE';
const $6eb1dda2f71a71b1$export$1ad049af934b4509 = 'BOARD';
const $6eb1dda2f71a71b1$export$2b0330ebc4df6bb5 = 'MATRIX';
const $6eb1dda2f71a71b1$export$b536e56a69266159 = 'TIMELINE';
const $6eb1dda2f71a71b1$export$4f6053f7f1423a0c = 'SECTION';
const $6eb1dda2f71a71b1$export$86d1f6589e2523cd = 'TREE';
const $6eb1dda2f71a71b1$export$94e2c990a618478f = {
    LOADING: 'LOADING',
    LOADED: 'LOADED',
    ERROR: 'ERROR'
};
const $6eb1dda2f71a71b1$export$e393ba013369cf6e = [
    $6eb1dda2f71a71b1$export$76e8cbc60f99881d,
    $6eb1dda2f71a71b1$export$1ad049af934b4509
];
const $6eb1dda2f71a71b1$export$15254c04917c5f93 = 'SUMMARY';
const $6eb1dda2f71a71b1$export$1945625338c888a6 = 'LIST';
const $6eb1dda2f71a71b1$export$6afc036a1671735b = 'CARDS';
const $6eb1dda2f71a71b1$export$d224351a39160b0c = 'DEFAULT';
const $6eb1dda2f71a71b1$export$b17563c9078b1921 = 'SMALL';
const $6eb1dda2f71a71b1$export$e9d55f10e8e91f5b = 'LARGE';
const $6eb1dda2f71a71b1$export$a0701d3eebc5b694 = 'HIGHLIGHT';
const $6eb1dda2f71a71b1$export$da8d0157d7b28066 = 'BACKGROUND';

});


parcelRegister("dP1oY", function(module, exports) {
$parcel$export(module.exports, "createView", () => $29ddaf90725897b4$export$d7febe7b891e79f0);

var $7TA2J = parcelRequire("7TA2J");

var $j85oP = parcelRequire("j85oP");

var $lCetP = parcelRequire("lCetP");

var $vfr75 = parcelRequire("vfr75");

var $PBAU4 = parcelRequire("PBAU4");

var $aGaXs = parcelRequire("aGaXs");
const $29ddaf90725897b4$export$d7febe7b891e79f0 = (viewType, parentId)=>(0, $PBAU4.withRefreshBlocker)(async ({ setState: setState, getState: getState }, { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId, containerType: containerType, onFailure: onFailure, onSuccess: onSuccess, onViewCreated: onViewCreated })=>{
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        if (viewType === 'SECTION') return;
        (0, $j85oP.experience).navBar.createView.start();
        const viewId = (0, $aGaXs.createFakeId)();
        const name = (0, $aGaXs.makeNewTitle)();
        const newView = {
            id: viewId,
            polarisId: 0,
            localId: (0, $7TA2J.v4)(),
            name: name,
            viewType: viewType,
            views: undefined,
            isLocked: true,
            isManuallyCreated: true
        };
        const viewSet = getState().containers[containerId].views.find((view)=>view?.localId === parentId);
        if (viewSet) setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            views: getState().containers[containerId].views.map((view)=>view.localId === parentId ? {
                    ...view,
                    views: [
                        ...view.views || [],
                        newView
                    ]
                } : view)
        }));
        else setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            views: [
                ...getState().containers[containerId].views,
                newView
            ]
        }));
        try {
            const viewsetId = viewSet?.id;
            const parentType = containerType === (0, $vfr75.CONTAINER).PROJECT ? (0, $vfr75.CONTAINER).PROJECT : (0, $vfr75.CONTAINER).COLLECTION;
            const remoteView = await navigationRemote.createView({
                viewType: viewType,
                name: name,
                containerId: containerId,
                parentId: viewSet ? String(viewsetId) : containerId,
                parentType: viewSet ? (0, $vfr75.CONTAINER).SECTION : parentType
            });
            setState((0, $aGaXs.modifyView)(getState(), containerId, (view)=>view.localId === newView.localId ? {
                    ...(0, $aGaXs.transformRemoteView)(remoteView),
                    localId: newView.localId,
                    isManuallyCreated: true,
                    isLocked: false
                } : view));
            onSuccess?.('createView');
            const navView = (0, $aGaXs.findView)(getState().containers[containerId], newView.localId).view;
            if (navView) onViewCreated?.(navView);
            (0, $j85oP.experience).navBar.createView.success();
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState((0, $aGaXs.modifyView)(getState(), containerId, (view)=>view.localId === newView.localId ? {
                    ...view,
                    isLocked: false
                } : view));
            onFailure?.(error, 'createView');
            if ((0, $lCetP.isClientFetchError)(error)) {
                (0, $j85oP.experience).navBar.createView.abort(error);
                return;
            }
            (0, $j85oP.experience).navBar.createView.failure(error);
        }
    });

});
parcelRegister("j85oP", function(module, exports) {
$parcel$export(module.exports, "experience", () => $92e37ed081047a9c$export$45794d16c9d83fe2);
/* eslint-disable jira/filename-case, jira/import/no-wildcard-imports */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $doGAO = parcelRequire("doGAO");

var $dsNvb = parcelRequire("dsNvb");

var $9HmWx = parcelRequire("9HmWx");

var $5sZU4 = parcelRequire("5sZU4");

var $26CTn = parcelRequire("26CTn");

var $x71Fy = parcelRequire("x71Fy");

var $aiiN0 = parcelRequire("aiiN0");

var $7AY0b = parcelRequire("7AY0b");

var $8GK08 = parcelRequire("8GK08");

var $2HTuJ = parcelRequire("2HTuJ");

var $g9QT8 = parcelRequire("g9QT8");

var $jjsUD = parcelRequire("jjsUD");

var $iDZes = parcelRequire("iDZes");

var $efD5O = parcelRequire("efD5O");

var $thFWC = parcelRequire("thFWC");

var $emAnD = parcelRequire("emAnD");

var $jG5Vy = parcelRequire("jG5Vy");

var $f5mQN = parcelRequire("f5mQN");

var $7ZoSr = parcelRequire("7ZoSr");

var $1uGbc = parcelRequire("1uGbc");

var $bcydT = parcelRequire("bcydT");

var $aJp8J = parcelRequire("aJp8J");

var $5rAQE = parcelRequire("5rAQE");

var $bIH77 = parcelRequire("bIH77");

var $7imRA = parcelRequire("7imRA");
const $92e37ed081047a9c$var$issueTypesForProjectsLoad = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issue-types.load-all', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $92e37ed081047a9c$var$issueTypeCreate = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issue-types.create', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $92e37ed081047a9c$var$issueTypeDelete = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issue-types.delete', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $92e37ed081047a9c$var$issueTypeUpdate = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issue-types.update', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $92e37ed081047a9c$var$issueTypePinnedFieldsUpdate = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issue-types.pinned-fields.update', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $92e37ed081047a9c$var$issueTypePinnedFieldsLoad = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issue-types.pinned-fields.load', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $92e37ed081047a9c$var$issueTypes = {
    issueTypeCreate: $92e37ed081047a9c$var$issueTypeCreate,
    issueTypeUpdate: $92e37ed081047a9c$var$issueTypeUpdate,
    issueTypePinnedFieldsLoad: $92e37ed081047a9c$var$issueTypePinnedFieldsLoad,
    issueTypePinnedFieldsUpdate: $92e37ed081047a9c$var$issueTypePinnedFieldsUpdate,
    issueTypeDelete: $92e37ed081047a9c$var$issueTypeDelete,
    issueTypesForProjectsLoad: $92e37ed081047a9c$var$issueTypesForProjectsLoad
};
const $92e37ed081047a9c$export$45794d16c9d83fe2 = {
    listView: $jjsUD,
    formulaField: $x71Fy,
    headerView: $7AY0b,
    boardView: $doGAO,
    ideaView: $2HTuJ,
    ideaViewBentoSidebar: $8GK08,
    matrixView: $iDZes,
    navBar: $efD5O,
    project: $jG5Vy,
    timelineView: $7ZoSr,
    fieldsSidebar: $26CTn,
    issues: $g9QT8,
    deliveryItems: $5sZU4,
    sharing: $f5mQN,
    globalFieldsAdministration: $aiiN0,
    playSidepanel: $emAnD,
    noViewsScreen: $thFWC,
    view: $bcydT,
    viewPermissions: $1uGbc,
    collections: $dsNvb,
    copyProjectConfiguration: $9HmWx,
    connections: $aJp8J,
    issueTypes: $92e37ed081047a9c$var$issueTypes,
    projectTemplateCreationAsync: $5rAQE,
    notification: $bIH77
};

});
parcelRegister("doGAO", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $f2effb848ba29de4$export$94114666844d5f66);
$parcel$export(module.exports, "scrollPerformance", () => $f2effb848ba29de4$export$390e7f040546632b);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $f2effb848ba29de4$export$94114666844d5f66 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.board-view', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $f2effb848ba29de4$export$390e7f040546632b = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.board-view.scroll-performance', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
}));

});
parcelRegister("7imRA", function(module, exports) {
$parcel$export(module.exports, "createMarkedJpdExperience", () => $835b91a22971ccbf$export$bffa5dc83c7b8f85);
$parcel$export(module.exports, "createJpdExperience", () => $835b91a22971ccbf$export$2510480a5584184);
$parcel$export(module.exports, "wrapPromiseWithExperience", () => $835b91a22971ccbf$export$745ef3600a4acb32);
$parcel$export(module.exports, "wrapWithExperience", () => $835b91a22971ccbf$export$9527dfc663dbb238);
$parcel$export(module.exports, "createExperienceWithMetaType", () => $835b91a22971ccbf$export$e3ba910cdcb797bc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $lmKaK = parcelRequire("lmKaK");

var $f6qTB = parcelRequire("f6qTB");

var $75sVW = parcelRequire("75sVW");

var $lCetP = parcelRequire("lCetP");

var $6vlch = parcelRequire("6vlch");
const $835b91a22971ccbf$var$formatUnknownError = (error)=>{
    if (typeof error === 'object') try {
        return JSON.stringify(error);
    } catch  {
        return String(error);
    }
    return String(error);
};
const $835b91a22971ccbf$export$bffa5dc83c7b8f85 = (ufoExperience, marks)=>({
        ...$835b91a22971ccbf$export$2510480a5584184(ufoExperience),
        marks: marks
    });
const $835b91a22971ccbf$export$e91cc315de4accec = (error)=>{
    const errorStatus = 'statusCode' in error && error.statusCode ? `[${error.statusCode}] ` : '';
    const errorName = 'name' in error && error.name ? `${error.name}` : '';
    const errorMessage = 'message' in error ? ` - ${error.message}` : '';
    const traceId = typeof error === 'object' && 'traceId' in error ? String(error.traceId) : undefined;
    const message = `${errorStatus}${errorName}${errorMessage}` || `Unknown error: ${$835b91a22971ccbf$var$formatUnknownError(error)}`;
    return {
        message: message,
        traceId: traceId
    };
};
const $835b91a22971ccbf$var$handleReason = (handler, errorReason, extraMetadata)=>{
    if (errorReason === undefined) {
        handler(extraMetadata);
        return;
    }
    if (typeof errorReason === 'string') {
        handler({
            metadata: {
                error: errorReason,
                ...extraMetadata?.metadata
            }
        });
        return;
    }
    if (errorReason instanceof Error) {
        const { message: message, traceId: traceId } = $835b91a22971ccbf$export$e91cc315de4accec(errorReason);
        return handler({
            metadata: {
                error: message,
                errors: 'errors' in errorReason && Array.isArray(errorReason.errors) ? errorReason.errors.map((err)=>{
                    if (typeof err === 'string') return err;
                    if (typeof err === 'object' && err !== null && 'error' in err) return err.error;
                    return '';
                }).join(', ') : undefined,
                traceId: traceId,
                ...extraMetadata?.metadata
            }
        });
    }
    if ((0, $6vlch.isExperienceMetadata)(errorReason)) {
        handler(errorReason);
        return;
    }
    (0, $lmKaK.assertUnreachable)(errorReason);
};
const $835b91a22971ccbf$export$2510480a5584184 = (ufoExperience)=>({
        ufoExperience: ufoExperience,
        start: (startTime)=>{
            ufoExperience.start();
            // hack to set custom start time
            if (startTime !== undefined) Object.assign(ufoExperience.metrics, {
                ...ufoExperience.metrics,
                startTime: startTime
            });
        },
        mark: (mark)=>{
            ufoExperience.mark(mark);
        },
        success: (meta, endTime)=>{
            ufoExperience.success(meta);
            // hack to set custom end time
            if (endTime !== undefined) Object.assign(ufoExperience.metrics, {
                ...ufoExperience.metrics,
                endTime: endTime
            });
        },
        successWithReason: (reason)=>{
            $835b91a22971ccbf$var$handleReason((meta)=>ufoExperience.success(meta), reason);
        },
        failure: (reason, extraMetadata)=>{
            $835b91a22971ccbf$var$handleReason((meta)=>ufoExperience.failure(meta), reason, extraMetadata);
        },
        abort: (reason, extraMetadata)=>{
            $835b91a22971ccbf$var$handleReason((meta)=>ufoExperience.abort(meta), reason, extraMetadata);
        }
    });
const $835b91a22971ccbf$export$745ef3600a4acb32 = (promise, experience, errorAnalyticsId, isExperienceErrorAborted)=>{
    experience.start();
    return promise.then((response)=>{
        experience.success();
        return response;
    }).catch((error)=>{
        if (errorAnalyticsId) (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: errorAnalyticsId,
                teamName: 'polaris'
            },
            // oxlint-disable-next-line typescript/consistent-type-assertions
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        if ((0, $lCetP.isClientFetchError)(error)) {
            experience.abort(error);
            throw error;
        }
        if ((0, $75sVW.isValidationError)(error)) {
            experience.abort(error);
            throw error;
        }
        if (isExperienceErrorAborted && isExperienceErrorAborted(error)) {
            experience.abort(error);
            throw error;
        }
        experience.failure(error);
        throw error;
    });
};
const $835b91a22971ccbf$export$9527dfc663dbb238 = (experience, callback, options)=>{
    experience.start();
    return callback().then((result)=>{
        experience.success(options?.getMetadata ? {
            metadata: options.getMetadata(result)
        } : undefined);
        return result;
    }).catch((error)=>{
        if ((0, $lCetP.isClientFetchError)(error)) {
            // oxlint-disable-next-line typescript/consistent-type-assertions
            experience.abort(error);
            throw error;
        }
        if (options?.ignorePermissionError && (0, $f6qTB.isPermissionError)(error)) {
            experience.abort(error);
            throw error;
        }
        if (error instanceof Error) experience.failure(error);
        throw error;
    });
};
const $835b91a22971ccbf$export$e3ba910cdcb797bc = (experience, metaType, parseMetadataError)=>({
        ufoExperience: experience.ufoExperience,
        start: experience.start,
        mark: experience.mark,
        success: (meta, endTime)=>{
            experience.success({
                metadata: {
                    type: metaType
                },
                ...meta
            }, endTime);
        },
        successWithReason: (error)=>{
            experience.successWithReason({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
        },
        failure: (error)=>{
            if (error && (0, $lCetP.isClientFetchError)(error)) experience.abort({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
            else experience.failure({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
        },
        abort: (error)=>{
            experience.abort({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
        }
    });

});
parcelRegister("lmKaK", function(module, exports) {
$parcel$export(module.exports, "ensureNonNullable", () => $cf6a7edd57e4d3a8$export$7c574cd5d840bb43);
$parcel$export(module.exports, "assertUnreachable", () => $cf6a7edd57e4d3a8$export$f2525c1d596f8d46);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // If you're looking for typed Object.keys please use
// import { getTypedKeys } from '@atlassian/jira-shared-types/src/narrowing.tsx';
// We dont' re-export things as it's not allowed anymore
function $cf6a7edd57e4d3a8$export$7c574cd5d840bb43(value, label) {
    if (value === undefined || value === null) throw new Error(label || 'Expected value to be NonNullable');
    return value;
}
function $cf6a7edd57e4d3a8$export$f2525c1d596f8d46(value, label) {
    throw new Error(label || `assertUnreachable should never be called, but it was called with value: ${value}`);
}

});

parcelRegister("6vlch", function(module, exports) {
$parcel$export(module.exports, "isExperienceMetadata", () => $4a6a64ae2cfc0587$export$ac5dc0917efe25a2);
/* eslint-disable jira/filename-case */ const $4a6a64ae2cfc0587$export$ac5dc0917efe25a2 = (error)=>{
    return typeof error === 'object' && error !== null && 'metadata' in error;
};

});



parcelRegister("dsNvb", function(module, exports) {
$parcel$export(module.exports, "pageLoad", () => $5140c986fd15eefc$export$791d520f7e8058a5);
$parcel$export(module.exports, "create", () => $5140c986fd15eefc$export$185802fd694ee1f5);
$parcel$export(module.exports, "loadCollections", () => $5140c986fd15eefc$export$569b2ddb07e9ef58);
$parcel$export(module.exports, "loadViewCount", () => $5140c986fd15eefc$export$136390ba2bb25e0b);
$parcel$export(module.exports, "loadUsers", () => $5140c986fd15eefc$export$2c3a8e05396a78be);
$parcel$export(module.exports, "loadProjects", () => $5140c986fd15eefc$export$14ec9adb679a31a1);
$parcel$export(module.exports, "createCollection", () => $5140c986fd15eefc$export$c74125a8e3af6bb2);
$parcel$export(module.exports, "copyCollection", () => $5140c986fd15eefc$export$36928e43600c4b00);
$parcel$export(module.exports, "deleteCollection", () => $5140c986fd15eefc$export$3d16e031f6551662);
$parcel$export(module.exports, "updateCollection", () => $5140c986fd15eefc$export$c0683150b517c317);
$parcel$export(module.exports, "loadCollection", () => $5140c986fd15eefc$export$1f19ddbd9e78c2f5);
$parcel$export(module.exports, "loadCollectionViews", () => $5140c986fd15eefc$export$a86e9e8b7168d682);
$parcel$export(module.exports, "loadCollectionDescription", () => $5140c986fd15eefc$export$da25d48c64ab9a24);
$parcel$export(module.exports, "updateCollectionDescription", () => $5140c986fd15eefc$export$95146d83152efba8);
$parcel$export(module.exports, "createView", () => $5140c986fd15eefc$export$d7febe7b891e79f0);
$parcel$export(module.exports, "deleteView", () => $5140c986fd15eefc$export$443d89549b135c95);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $5140c986fd15eefc$export$791d520f7e8058a5 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageLoad
}));
const $5140c986fd15eefc$export$185802fd694ee1f5 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections.create', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $5140c986fd15eefc$export$569b2ddb07e9ef58 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections.load-collections', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $5140c986fd15eefc$export$136390ba2bb25e0b = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections.load-view-count', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $5140c986fd15eefc$export$2c3a8e05396a78be = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections.load-users', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $5140c986fd15eefc$export$14ec9adb679a31a1 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections.load-projects', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $5140c986fd15eefc$export$c74125a8e3af6bb2 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections.create-collection', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $5140c986fd15eefc$export$36928e43600c4b00 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections.copy-collection', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $5140c986fd15eefc$export$3d16e031f6551662 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections.delete-collection', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $5140c986fd15eefc$export$c0683150b517c317 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections.update-collection', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $5140c986fd15eefc$export$1f19ddbd9e78c2f5 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections.load-collection', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $5140c986fd15eefc$export$a86e9e8b7168d682 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections.load-collection-views', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $5140c986fd15eefc$export$da25d48c64ab9a24 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections.load-collection-description', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $5140c986fd15eefc$export$95146d83152efba8 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections.update-collection-description', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $5140c986fd15eefc$export$d7febe7b891e79f0 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections.create-view', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $5140c986fd15eefc$export$443d89549b135c95 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.collections.delete-view', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("9HmWx", function(module, exports) {
$parcel$export(module.exports, "copy", () => $34f567ccef9743b3$export$784d13d8ee351f07);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $34f567ccef9743b3$export$784d13d8ee351f07 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.copy-project-configuration', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("5sZU4", function(module, exports) {
$parcel$export(module.exports, "loadChildIssues", () => $78557b89d1d5b4de$export$df5c5945eb51ab10);
$parcel$export(module.exports, "loadAggregatedDeliveryProgressBasedOnProjectId", () => $78557b89d1d5b4de$export$531ec6120f223bb8);
$parcel$export(module.exports, "loadAggregatedDeliveryProgress", () => $78557b89d1d5b4de$export$12a1609f29cbb864);
$parcel$export(module.exports, "loadLinkedDeliveryTickets", () => $78557b89d1d5b4de$export$a88d267f7658a3dc);
$parcel$export(module.exports, "loadTransitiveChildrenArjHierarchy", () => $78557b89d1d5b4de$export$ffdb9dea53e75ee5);
$parcel$export(module.exports, "loadTransitiveChildrenInTwoLevelCoreHierarchy", () => $78557b89d1d5b4de$export$f9f3d52ff0f7a0b8);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $78557b89d1d5b4de$export$df5c5945eb51ab10 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.delivery-items.load.childIssues', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $78557b89d1d5b4de$export$531ec6120f223bb8 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.delivery-items.load.aggregatedDeliveryProgressBasedOnProjectId', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $78557b89d1d5b4de$export$12a1609f29cbb864 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.delivery-items.load.aggregatedDeliveryProgress', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $78557b89d1d5b4de$export$a88d267f7658a3dc = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.delivery-items.load.linkedDeliveryTickets', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $78557b89d1d5b4de$export$ffdb9dea53e75ee5 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.delivery-items.load.transitiveChildrenArjHierarchy', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $78557b89d1d5b4de$export$f9f3d52ff0f7a0b8 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.delivery-items.load.transitiveChildrenInTwoLevelCoreHierarchy', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("26CTn", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $9a997be93ea7ada7$export$94114666844d5f66);
$parcel$export(module.exports, "fieldToggle", () => $9a997be93ea7ada7$export$76f0d602d0733e6d);
$parcel$export(module.exports, "fieldHide", () => $9a997be93ea7ada7$export$413c667806d09e8e);
$parcel$export(module.exports, "fieldDelete", () => $9a997be93ea7ada7$export$b246cee4a79b9379);
$parcel$export(module.exports, "fieldRegularCreate", () => $9a997be93ea7ada7$export$9df4f5b7e476ce84);
$parcel$export(module.exports, "fieldFormulaCreate", () => $9a997be93ea7ada7$export$27b3440b11d7d826);
$parcel$export(module.exports, "fieldPlayCreate", () => $9a997be93ea7ada7$export$f2ca0d7a70f0d4fa);
$parcel$export(module.exports, "fieldConfigurationUpdate", () => $9a997be93ea7ada7$export$bb265be09cbcf6b4);
$parcel$export(module.exports, "fieldOptionUpdate", () => $9a997be93ea7ada7$export$dd81c54ce99ca034);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $9a997be93ea7ada7$export$94114666844d5f66 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.fields-sidebar.load', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $9a997be93ea7ada7$export$76f0d602d0733e6d = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.fields-sidebar.field-toggle', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $9a997be93ea7ada7$export$413c667806d09e8e = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.fields-sidebar.field-hide', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $9a997be93ea7ada7$export$b246cee4a79b9379 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.fields-sidebar.field-delete', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $9a997be93ea7ada7$export$9df4f5b7e476ce84 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.fields-sidebar.field-regular-create', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $9a997be93ea7ada7$export$27b3440b11d7d826 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.fields-sidebar.field-formula-create', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $9a997be93ea7ada7$export$f2ca0d7a70f0d4fa = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.fields-sidebar.field-play-create', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $9a997be93ea7ada7$export$bb265be09cbcf6b4 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.fields-sidebar.field-configuration-update', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $9a997be93ea7ada7$export$dd81c54ce99ca034 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.fields-sidebar.field-option-update', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("x71Fy", function(module, exports) {
$parcel$export(module.exports, "precalculateFormulaFieldAllValuesSelector", () => $10c1873ed6d84f42$export$a228cb9f5622e166);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $10c1873ed6d84f42$export$a228cb9f5622e166 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.formula-field.precalculate-all-values-selector', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("aiiN0", function(module, exports) {
$parcel$export(module.exports, "pageLoad", () => $a89194779efa4ad2$export$791d520f7e8058a5);
$parcel$export(module.exports, "globalFieldCreate", () => $a89194779efa4ad2$export$b03352737479563);
$parcel$export(module.exports, "globalFieldDelete", () => $a89194779efa4ad2$export$84497cb573c7d17);
$parcel$export(module.exports, "globalFieldAssociate", () => $a89194779efa4ad2$export$65839e13cd248f9e);
$parcel$export(module.exports, "globalFieldUnassociate", () => $a89194779efa4ad2$export$29a31286f27d1a2e);
$parcel$export(module.exports, "globalFieldCheckViewsUsage", () => $a89194779efa4ad2$export$8b1a216a358cdd80);
$parcel$export(module.exports, "globalFieldUpdate", () => $a89194779efa4ad2$export$62c234d94572bba2);
$parcel$export(module.exports, "globalFieldUpdateConfig", () => $a89194779efa4ad2$export$a17a8741bdd2acf);
$parcel$export(module.exports, "globalFieldCheckProjectUsage", () => $a89194779efa4ad2$export$d30c8e3ea8a9aa57);
$parcel$export(module.exports, "loadGlobalFields", () => $a89194779efa4ad2$export$f71db070ee14476f);
$parcel$export(module.exports, "loadGlobalLabels", () => $a89194779efa4ad2$export$c6682f53b5f48ef8);
$parcel$export(module.exports, "loadJpdProjects", () => $a89194779efa4ad2$export$85d7e1fdff0f01b4);
$parcel$export(module.exports, "loadProjectsWithField", () => $a89194779efa4ad2$export$867e6f0888bf4bd);
$parcel$export(module.exports, "fieldAddOptions", () => $a89194779efa4ad2$export$317ab3380fbbaacc);
$parcel$export(module.exports, "fieldDeleteOption", () => $a89194779efa4ad2$export$d55856fb0a38bf13);
$parcel$export(module.exports, "fieldRenameOption", () => $a89194779efa4ad2$export$12e095e9d4e2e327);
$parcel$export(module.exports, "fieldMoveOptions", () => $a89194779efa4ad2$export$ba026a86e3a2a2ee);
$parcel$export(module.exports, "copyValues", () => $a89194779efa4ad2$export$2b4b550f6684d934);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $a89194779efa4ad2$export$791d520f7e8058a5 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageLoad
}));
const $a89194779efa4ad2$export$b03352737479563 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.field-create', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$84497cb573c7d17 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.field-delete', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$65839e13cd248f9e = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.field-associate', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$29a31286f27d1a2e = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.field-unassociate', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$8b1a216a358cdd80 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.field-check-views-usage', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$62c234d94572bba2 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.field-update', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$a17a8741bdd2acf = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.field-update-config', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$d30c8e3ea8a9aa57 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.field-check-project-usage', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$f71db070ee14476f = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.load-fields', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$c6682f53b5f48ef8 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.load-global-labels', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$85d7e1fdff0f01b4 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.load-jpd-projects', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$867e6f0888bf4bd = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.load-projects-with-field', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$317ab3380fbbaacc = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.field-add-options', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$d55856fb0a38bf13 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.field-delete-option', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$12e095e9d4e2e327 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.field-rename-option', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$ba026a86e3a2a2ee = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.field-move-options', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a89194779efa4ad2$export$2b4b550f6684d934 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-fields-administration.copy-values', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("7AY0b", function(module, exports) {
$parcel$export(module.exports, "updateViewDescription", () => $c6a1d43c7e0f5eb4$export$16660b9e64c03042);
$parcel$export(module.exports, "viewGroupBy", () => $c6a1d43c7e0f5eb4$export$5537a4a396822165);
$parcel$export(module.exports, "viewSort", () => $c6a1d43c7e0f5eb4$export$f29ab69847cb95c0);
$parcel$export(module.exports, "viewFilter", () => $c6a1d43c7e0f5eb4$export$7a7ebd5529ec7d46);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $c6a1d43c7e0f5eb4$export$16660b9e64c03042 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.header-view.update-view-description', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $c6a1d43c7e0f5eb4$export$5537a4a396822165 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.header-view.view-group-by', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $c6a1d43c7e0f5eb4$export$f29ab69847cb95c0 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.header-view.view-sort', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $c6a1d43c7e0f5eb4$export$7a7ebd5529ec7d46 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.header-view.view-filter', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("8GK08", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $7572a4a0782e9d43$export$94114666844d5f66);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $7572a4a0782e9d43$export$94114666844d5f66 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view-bento-sidebar', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
}));

});

parcelRegister("2HTuJ", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $284d4c9b06094657$export$94114666844d5f66);
$parcel$export(module.exports, "directPageSegmentLoad", () => $284d4c9b06094657$export$ee08e8134696f146);
$parcel$export(module.exports, "summaryUpdate", () => $284d4c9b06094657$export$5622e807234df3bb);
$parcel$export(module.exports, "descriptionUpdate", () => $284d4c9b06094657$export$f8fe5931289a9815);
$parcel$export(module.exports, "deliveryTicketCreate", () => $284d4c9b06094657$export$a84a662b970b5ae);
$parcel$export(module.exports, "deliveryTicketExpand", () => $284d4c9b06094657$export$96a1e55091dcd535);
$parcel$export(module.exports, "commentCreate", () => $284d4c9b06094657$export$18cd8f3c0240b0a7);
$parcel$export(module.exports, "insightCreate", () => $284d4c9b06094657$export$5fb856565362db95);
$parcel$export(module.exports, "insightUpdate", () => $284d4c9b06094657$export$db3376d543b8f2f0);
$parcel$export(module.exports, "insightDelete", () => $284d4c9b06094657$export$5cf5d5fb5df27ce4);
$parcel$export(module.exports, "issueLinkCreate", () => $284d4c9b06094657$export$c88b0a5d9f4319fc);
$parcel$export(module.exports, "issueLinkDelete", () => $284d4c9b06094657$export$a1a232cde43cbc25);
$parcel$export(module.exports, "commentsSegmentLoad", () => $284d4c9b06094657$export$c9255b3c7ce3b238);
$parcel$export(module.exports, "insightsSegmentLoad", () => $284d4c9b06094657$export$31d3301eb443a690);
$parcel$export(module.exports, "fileAttach", () => $284d4c9b06094657$export$97a2bd48ad08a74b);
$parcel$export(module.exports, "connectionsSegmentLoad", () => $284d4c9b06094657$export$ea0be4743e48989b);
$parcel$export(module.exports, "makeFieldUpdate", () => $284d4c9b06094657$export$c9a3588491d4a10b);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $284d4c9b06094657$export$94114666844d5f66 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $284d4c9b06094657$export$ee08e8134696f146 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view-direct', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $284d4c9b06094657$export$5622e807234df3bb = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view.summary-update', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $284d4c9b06094657$export$f8fe5931289a9815 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view.description-update', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $284d4c9b06094657$export$a84a662b970b5ae = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view.delivery-ticket-create', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $284d4c9b06094657$export$96a1e55091dcd535 = ()=>(0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view.delivery-ticket-expand', {
        type: (0, $ipvkO.ExperienceTypes).Experience,
        performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
    }));
const $284d4c9b06094657$export$18cd8f3c0240b0a7 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view.comment-create', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $284d4c9b06094657$export$5fb856565362db95 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view.insight-create', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $284d4c9b06094657$export$db3376d543b8f2f0 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view.insight-update', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $284d4c9b06094657$export$5cf5d5fb5df27ce4 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view.insight-delete', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $284d4c9b06094657$export$c88b0a5d9f4319fc = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view.issue-link-create', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $284d4c9b06094657$export$a1a232cde43cbc25 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view.issue-link-delete', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $284d4c9b06094657$export$c9255b3c7ce3b238 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view.comments', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $284d4c9b06094657$export$31d3301eb443a690 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view.insights', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $284d4c9b06094657$export$97a2bd48ad08a74b = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view.attach-file', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $284d4c9b06094657$export$ea0be4743e48989b = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view.connections-tab', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $284d4c9b06094657$export$c9a3588491d4a10b = ()=>(0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.idea-view.field-update', {
        type: (0, $ipvkO.ExperienceTypes).Experience,
        performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
    }));

});

parcelRegister("g9QT8", function(module, exports) {
$parcel$export(module.exports, "loadIssuesRestBatched", () => $24e978eb1c68b3b8$export$b4c4374bf531f011);
$parcel$export(module.exports, "loadIssueRest", () => $24e978eb1c68b3b8$export$f1cca26704284332);
$parcel$export(module.exports, "loadIssuesJpdApi", () => $24e978eb1c68b3b8$export$edc886929f100d7e);
$parcel$export(module.exports, "loadIssueJpdApi", () => $24e978eb1c68b3b8$export$21e6ded5e5c7786);
$parcel$export(module.exports, "loadIssuesRanksRestBatched", () => $24e978eb1c68b3b8$export$7605559f436ef08a);
$parcel$export(module.exports, "loadIssuesRanksJpdApi", () => $24e978eb1c68b3b8$export$173ed5a278c1732b);
$parcel$export(module.exports, "rankIssue", () => $24e978eb1c68b3b8$export$dbff149eb80fd116);
$parcel$export(module.exports, "loadIssuePickerIssuesRest", () => $24e978eb1c68b3b8$export$23a6e22f367c9283);
$parcel$export(module.exports, "globalJpdIssueCreate", () => $24e978eb1c68b3b8$export$792186e7b1057ce9);
$parcel$export(module.exports, "loadGlobalIdeaCreateForm", () => $24e978eb1c68b3b8$export$e363734f0230aa3a);

var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $24e978eb1c68b3b8$export$b4c4374bf531f011 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issues.load.rest-batched', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $24e978eb1c68b3b8$export$f1cca26704284332 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issue.load.rest', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $24e978eb1c68b3b8$export$edc886929f100d7e = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issues.load.jpd-api', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $24e978eb1c68b3b8$export$21e6ded5e5c7786 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issue.load.jpd-api', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $24e978eb1c68b3b8$export$7605559f436ef08a = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issues.ranks.load.rest-batched', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $24e978eb1c68b3b8$export$173ed5a278c1732b = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issues.ranks.load.jpd-api', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $24e978eb1c68b3b8$export$dbff149eb80fd116 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issue.rank', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $24e978eb1c68b3b8$export$23a6e22f367c9283 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issue-picker.load', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $24e978eb1c68b3b8$export$792186e7b1057ce9 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global.jpd.create-issue', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $24e978eb1c68b3b8$export$e363734f0230aa3a = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.global-idea-create-form.load', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("jjsUD", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $ba4dac3afbe9406d$export$94114666844d5f66);
$parcel$export(module.exports, "createIdeaInline", () => $ba4dac3afbe9406d$export$5ea76ff12d204976);
$parcel$export(module.exports, "createIdeaInlineBulk", () => $ba4dac3afbe9406d$export$47ee03b76831577c);
$parcel$export(module.exports, "createIdeaInlineClickResponse", () => $ba4dac3afbe9406d$export$f9ccaf2135e3de7d);
$parcel$export(module.exports, "changeViewName", () => $ba4dac3afbe9406d$export$1375b601692f3137);
$parcel$export(module.exports, "listScrollPerformance", () => $ba4dac3afbe9406d$export$98edb0fcdfb46224);
$parcel$export(module.exports, "makeFieldUpdate", () => $ba4dac3afbe9406d$export$c9a3588491d4a10b);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $ba4dac3afbe9406d$export$94114666844d5f66 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.list-view', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $ba4dac3afbe9406d$export$5ea76ff12d204976 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.list-view.create-idea-inline', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $ba4dac3afbe9406d$export$47ee03b76831577c = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.list-view.create-idea-inline-bulk', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $ba4dac3afbe9406d$export$f9ccaf2135e3de7d = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.list-view.create-idea-inline-button-click', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
}));
const $ba4dac3afbe9406d$export$1375b601692f3137 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.list-view.change-view-name', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $ba4dac3afbe9406d$export$98edb0fcdfb46224 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.list-view.scroll-performance', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
}));
const $ba4dac3afbe9406d$export$c9a3588491d4a10b = ()=>(0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.list-view.field-update', {
        type: (0, $ipvkO.ExperienceTypes).Experience,
        performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult,
        timings: [
            {
                key: 'internal_state',
                endMark: 'backend_request_start'
            },
            {
                key: 'backend_request',
                startMark: 'backend_request_start'
            }
        ]
    }));

});

parcelRegister("iDZes", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $d6d8948fa01b8006$export$94114666844d5f66);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $d6d8948fa01b8006$export$94114666844d5f66 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.matrix-view', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
}));

});

parcelRegister("efD5O", function(module, exports) {
$parcel$export(module.exports, "changeViewName", () => $b553578f64633f65$export$1375b601692f3137);
$parcel$export(module.exports, "changeViewRank", () => $b553578f64633f65$export$52abe324a1859929);
$parcel$export(module.exports, "createView", () => $b553578f64633f65$export$d7febe7b891e79f0);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $b553578f64633f65$export$1375b601692f3137 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.nav-bar.change-view-name', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $b553578f64633f65$export$52abe324a1859929 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.nav-bar.change-view-rank', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $b553578f64633f65$export$d7febe7b891e79f0 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.nav-bar.create-view', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("thFWC", function(module, exports) {
$parcel$export(module.exports, "createView", () => $16b6181b86bb63ad$export$d7febe7b891e79f0);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $16b6181b86bb63ad$export$d7febe7b891e79f0 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.no-views-screen.create-view', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("emAnD", function(module, exports) {
$parcel$export(module.exports, "updatePlayField", () => $18ae34ec02bc2260$export$870e1a1a0d62147f);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $18ae34ec02bc2260$export$870e1a1a0d62147f = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.play-sidepanel.field-update', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("jG5Vy", function(module, exports) {
$parcel$export(module.exports, "applyTemplateMarks", () => $7b4e6591d1a19492$export$e7702071f99306f0);
$parcel$export(module.exports, "pageLoad", () => $7b4e6591d1a19492$export$791d520f7e8058a5);
$parcel$export(module.exports, "pageLoadWithRateLimit", () => $7b4e6591d1a19492$export$5102ef8e92249e0d);
$parcel$export(module.exports, "applyTemplate", () => $7b4e6591d1a19492$export$f78a296632f66e69);
$parcel$export(module.exports, "create", () => $7b4e6591d1a19492$export$185802fd694ee1f5);
$parcel$export(module.exports, "createAsyncOnboarding", () => $7b4e6591d1a19492$export$2740c304994115b2);

var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $7b4e6591d1a19492$export$e7702071f99306f0 = {
    APPLY_TEMPLATE_POLLING_START_MARK: 'apply_template_polling_start',
    APPLY_TEMPLATE_POLLING_STOP_MARK: 'apply_template_polling_stop'
};
const $7b4e6591d1a19492$export$791d520f7e8058a5 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.project', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageLoad
}));
const $7b4e6591d1a19492$export$5102ef8e92249e0d = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.project.rate-limit', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageLoad
}));
const $7b4e6591d1a19492$export$f78a296632f66e69 = (0, $7imRA.createMarkedJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.project.apply-template', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'apply_template_polling',
            startMark: $7b4e6591d1a19492$export$e7702071f99306f0.APPLY_TEMPLATE_POLLING_START_MARK,
            endMark: $7b4e6591d1a19492$export$e7702071f99306f0.APPLY_TEMPLATE_POLLING_STOP_MARK
        }
    ]
}), $7b4e6591d1a19492$export$e7702071f99306f0);
const $7b4e6591d1a19492$export$185802fd694ee1f5 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.project.create', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $7b4e6591d1a19492$export$2740c304994115b2 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.project.create-async-onboarding', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("f5mQN", function(module, exports) {
$parcel$export(module.exports, "dialogLoad", () => $a02e694d0337950d$export$f9bf6b7b75be4461);
$parcel$export(module.exports, "loadStakeholders", () => $a02e694d0337950d$export$da3bab182f5666a9);
$parcel$export(module.exports, "addStakeholders", () => $a02e694d0337950d$export$39dc8a3bc2974ed6);
$parcel$export(module.exports, "removeStakeholders", () => $a02e694d0337950d$export$e7a3e16d74b6c142);
$parcel$export(module.exports, "loadSettings", () => $a02e694d0337950d$export$54453bb1ffd2fd71);
$parcel$export(module.exports, "updateSettings", () => $a02e694d0337950d$export$f558026a994b6051);
$parcel$export(module.exports, "loadSiteConfig", () => $a02e694d0337950d$export$b2e18be8354b8d72);
$parcel$export(module.exports, "loadSitePublicSharingConfig", () => $a02e694d0337950d$export$85d654471364d5f1);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $a02e694d0337950d$export$f9bf6b7b75be4461 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.shared.control-dialog-load', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $a02e694d0337950d$export$da3bab182f5666a9 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.shared.load-stakeholders', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a02e694d0337950d$export$39dc8a3bc2974ed6 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.shared.add-stakeholders', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a02e694d0337950d$export$e7a3e16d74b6c142 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.shared.remove-stakeholders', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a02e694d0337950d$export$54453bb1ffd2fd71 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.shared.load-settings', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a02e694d0337950d$export$f558026a994b6051 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.shared.update-settings', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a02e694d0337950d$export$b2e18be8354b8d72 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.shared.load-site-config', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $a02e694d0337950d$export$85d654471364d5f1 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.shared.load-site-public-sharing-config', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("7ZoSr", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $956803563b2230e9$export$94114666844d5f66);
$parcel$export(module.exports, "timelineDragExperience", () => $956803563b2230e9$export$71771dbfd87b2d9e);
$parcel$export(module.exports, "timelineDropExperience", () => $956803563b2230e9$export$b1b840160cefbbce);
$parcel$export(module.exports, "timelineNextDragExperience", () => $956803563b2230e9$export$69742303be60612b);
$parcel$export(module.exports, "timelineNextDropExperience", () => $956803563b2230e9$export$b7af7919d805c563);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $956803563b2230e9$export$94114666844d5f66 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.timeline-view', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $956803563b2230e9$export$71771dbfd87b2d9e = new (0, $jkqqC.UFOExperience)('jpd.timeline.drag', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
});
const $956803563b2230e9$export$b1b840160cefbbce = new (0, $jkqqC.UFOExperience)('jpd.timeline.drop', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
});
const $956803563b2230e9$export$69742303be60612b = new (0, $jkqqC.UFOExperience)('jpd.timeline-next.drag', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
});
const $956803563b2230e9$export$b7af7919d805c563 = new (0, $jkqqC.UFOExperience)('jpd.timeline-next.drop', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
});

});

parcelRegister("1uGbc", function(module, exports) {
$parcel$export(module.exports, "openDialog", () => $ae91d5987e64942c$export$45f11db5513b93db);
$parcel$export(module.exports, "loadViewAccess", () => $ae91d5987e64942c$export$7894161c427d5a42);
$parcel$export(module.exports, "updateViewAccess", () => $ae91d5987e64942c$export$710acb0a8739a684);
$parcel$export(module.exports, "updatePrincipals", () => $ae91d5987e64942c$export$a9ab5c1920acd4f5);
$parcel$export(module.exports, "loadCurrentUserViewPermissions", () => $ae91d5987e64942c$export$b3a1f4fc3f38595c);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $ae91d5987e64942c$export$45f11db5513b93db = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.view-permissions.open-dialog', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $ae91d5987e64942c$export$7894161c427d5a42 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.view-permissions.load-view-access', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $ae91d5987e64942c$export$710acb0a8739a684 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.view-permissions.update-view-access', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $ae91d5987e64942c$export$a9ab5c1920acd4f5 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.view-permissions.update-principals', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $ae91d5987e64942c$export$b3a1f4fc3f38595c = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.view-permissions.load-current-user-view-permissions', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("bcydT", function(module, exports) {
$parcel$export(module.exports, "getView", () => $6455d8ea454b279a$export$513f42987b822fd7);
$parcel$export(module.exports, "updateView", () => $6455d8ea454b279a$export$827a6c17a85f6d1a);
$parcel$export(module.exports, "deleteView", () => $6455d8ea454b279a$export$443d89549b135c95);
$parcel$export(module.exports, "makeGenericIssueFieldUpdate", () => $6455d8ea454b279a$export$951d66f9bcb4c7fc);
$parcel$export(module.exports, "updateIssueFields", () => $6455d8ea454b279a$export$fb24ad07bc5a0153);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $6455d8ea454b279a$export$513f42987b822fd7 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.view.get-view', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $6455d8ea454b279a$export$827a6c17a85f6d1a = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.view.update-view', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $6455d8ea454b279a$export$443d89549b135c95 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.view.delete-view', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $6455d8ea454b279a$export$951d66f9bcb4c7fc = ()=>(0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issue-update.field', {
        type: (0, $ipvkO.ExperienceTypes).Experience,
        performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult,
        timings: [
            {
                key: 'internal_state',
                endMark: 'backend_request_start'
            },
            {
                key: 'backend_request',
                startMark: 'backend_request_start'
            }
        ]
    }));
const $6455d8ea454b279a$export$fb24ad07bc5a0153 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issue-update.fields', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult,
    timings: [
        {
            key: 'internal_state',
            endMark: 'backend_request_start'
        },
        {
            key: 'backend_request',
            startMark: 'backend_request_start'
        }
    ]
}));

});

parcelRegister("aJp8J", function(module, exports) {
$parcel$export(module.exports, "issueConnectionFieldValueUpdate", () => $c5206307bb25f30d$export$f339c49235963d2a);
$parcel$export(module.exports, "issueConnectionFieldsValuesUpdateBulk", () => $c5206307bb25f30d$export$6fd69dd8cdad62db);
$parcel$export(module.exports, "connectionBetaConfigToggleChange", () => $c5206307bb25f30d$export$f6f1d9ce01ba0990);
$parcel$export(module.exports, "connectionBetaConfigLoad", () => $c5206307bb25f30d$export$dd51d033a6bac611);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $c5206307bb25f30d$export$f339c49235963d2a = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issue-update.connection-field', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $c5206307bb25f30d$export$6fd69dd8cdad62db = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.issue-update-bulk.connection-field', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $c5206307bb25f30d$export$f6f1d9ce01ba0990 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.connection-beta-config.toggle-change', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));
const $c5206307bb25f30d$export$dd51d033a6bac611 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.connection-beta-config.load', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("5rAQE", function(module, exports) {
$parcel$export(module.exports, "projectCreationPollingMarks", () => $1cb7449d0a2b8a7f$export$39a123f63b4818b1);
$parcel$export(module.exports, "apply", () => $1cb7449d0a2b8a7f$export$5635d7ef4b8fee1c);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $1cb7449d0a2b8a7f$export$39a123f63b4818b1 = {
    PROJECT_CREATION_POLLING_START_MARK: 'project_creation_polling_start',
    PROJECT_CREATION_POLLING_STOP_MARK: 'project_creation_polling_stop'
};
const $1cb7449d0a2b8a7f$export$5635d7ef4b8fee1c = (0, $7imRA.createMarkedJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.project-template-creation-async', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'project_creation_polling',
            startMark: $1cb7449d0a2b8a7f$export$39a123f63b4818b1.PROJECT_CREATION_POLLING_START_MARK,
            endMark: $1cb7449d0a2b8a7f$export$39a123f63b4818b1.PROJECT_CREATION_POLLING_STOP_MARK
        }
    ]
}), $1cb7449d0a2b8a7f$export$39a123f63b4818b1);

});

parcelRegister("bIH77", function(module, exports) {
$parcel$export(module.exports, "pageLoad", () => $012b1a4f3ecf41c3$export$791d520f7e8058a5);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $7imRA = parcelRequire("7imRA");
const $012b1a4f3ecf41c3$export$791d520f7e8058a5 = (0, $7imRA.createJpdExperience)(new (0, $jkqqC.UFOExperience)('jpd.notification-settings', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageLoad
}));

});



parcelRegister("6WCf3", function(module, exports) {
$parcel$export(module.exports, "insertViewSet", () => $2397fc8c24cdcece$export$32331e5484d4b068);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7TA2J = parcelRequire("7TA2J");

var $dH1Sa = parcelRequire("dH1Sa");

var $aGaXs = parcelRequire("aGaXs");
const $2397fc8c24cdcece$export$32331e5484d4b068 = ()=>async ({ setState: setState, getState: getState }, props)=>{
        const { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId } = props;
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            views: [
                ...getState().containers[containerId].views,
                {
                    id: (0, $aGaXs.createFakeId)(),
                    polarisId: 0,
                    name: '',
                    localId: (0, $7TA2J.v4)(),
                    isRenaming: true,
                    isExpanded: false,
                    views: [],
                    viewType: (0, $dH1Sa.VIEW_KIND_SECTION)
                }
            ]
        }));
    };

});

parcelRegister("99xm4", function(module, exports) {
$parcel$export(module.exports, "deleteViewSet", () => $269a709401fd91e5$export$117334e66db56300);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $PBAU4 = parcelRequire("PBAU4");

var $aGaXs = parcelRequire("aGaXs");
const $269a709401fd91e5$export$117334e66db56300 = (localId)=>(0, $PBAU4.withRefreshBlocker)(async ({ setState: setState, getState: getState }, { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId, onFailure: onFailure, onSuccess: onSuccess })=>{
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        const { view: view } = (0, $aGaXs.findView)(getState().containers[containerId], localId);
        if (!view) return;
        if ((0, $aGaXs.isFakeId)(view.id)) {
            setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                views: getState().containers[containerId].views.filter((innerView)=>!innerView.views || innerView.localId !== localId)
            }));
            return;
        }
        setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            views: [
                ...getState().containers[containerId].views.map((innerView)=>innerView.localId === localId ? {
                        ...innerView,
                        isRenaming: false,
                        isLocked: true
                    } : innerView)
            ]
        }));
        try {
            await navigationRemote.deleteView({
                viewId: view.id
            });
            setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                views: getState().containers[containerId].views.filter((innerView)=>innerView.viewType !== 'SECTION' || innerView.localId !== localId)
            }));
            onSuccess?.('deleteSection');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                views: [
                    ...getState().containers[containerId].views.map((innerView)=>innerView.localId === localId ? {
                            ...innerView,
                            isLocked: false
                        } : innerView)
                ]
            }));
            onFailure?.(error, 'deleteSection');
        }
    });

});

parcelRegister("4V2kc", function(module, exports) {
$parcel$export(module.exports, "updateViewSet", () => $d8a32e51b8daa9eb$export$8d1dff3b62f9a141);

var $j85oP = parcelRequire("j85oP");

var $lCetP = parcelRequire("lCetP");

var $PBAU4 = parcelRequire("PBAU4");

var $aGaXs = parcelRequire("aGaXs");
const $d8a32e51b8daa9eb$export$8d1dff3b62f9a141 = (localId, newName)=>(0, $PBAU4.withRefreshBlocker)(async ({ setState: setState, getState: getState }, { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId, onFailure: onFailure, onSuccess: onSuccess })=>{
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        const { view: view } = (0, $aGaXs.findView)(getState().containers[containerId], localId);
        if (!view || !view.viewType) return;
        (0, $j85oP.experience).navBar.changeViewName.start();
        setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            views: [
                ...getState().containers[containerId].views.map((innerView)=>innerView.localId === localId ? {
                        ...innerView,
                        name: newName,
                        isRenaming: false,
                        isLocked: true
                    } : innerView)
            ]
        }));
        try {
            const updatedView = await navigationRemote.updateView({
                id: view.id,
                viewType: view.viewType,
                name: newName
            });
            setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                views: [
                    ...getState().containers[containerId].views.map((innerView)=>innerView.localId === localId ? {
                            ...innerView,
                            name: updatedView.name,
                            isLocked: false
                        } : innerView)
                ]
            }));
            onSuccess?.('updateSection');
            (0, $j85oP.experience).navBar.changeViewName.successWithReason({
                metadata: {
                    isViewSet: true
                }
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                views: [
                    ...getState().containers[containerId].views.map((innerView)=>innerView.localId === localId ? {
                            ...innerView,
                            isLocked: false
                        } : innerView)
                ]
            }));
            onFailure?.(error, 'updateSection');
            if ((0, $lCetP.isClientFetchError)(error)) {
                (0, $j85oP.experience).navBar.changeViewName.abort(error);
                return;
            }
            (0, $j85oP.experience).navBar.changeViewName.failure(error, {
                metadata: {
                    isViewSet: true
                }
            });
        }
    });

});

parcelRegister("7yUkX", function(module, exports) {
$parcel$export(module.exports, "renameViewSet", () => $5183527936a28585$export$c2397724ec817914);
$parcel$export(module.exports, "cancelViewSetRenaming", () => $5183527936a28585$export$ce11fc1524e1b1bc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aGaXs = parcelRequire("aGaXs");
const $5183527936a28585$export$c2397724ec817914 = (localId)=>async ({ setState: setState, getState: getState }, props)=>{
        const { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId } = props;
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            views: [
                ...getState().containers[containerId].views.map((view)=>view.localId === localId ? {
                        ...view,
                        isRenaming: true
                    } : view)
            ]
        }));
    };
const $5183527936a28585$export$ce11fc1524e1b1bc = (localId)=>async ({ setState: setState, getState: getState }, props)=>{
        const { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId } = props;
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            views: [
                ...getState().containers[containerId].views.map((view)=>view.localId === localId ? {
                        ...view,
                        isRenaming: false
                    } : view)
            ]
        }));
    };

});

parcelRegister("10srQ", function(module, exports) {
$parcel$export(module.exports, "deleteView", () => $7f5a46395969800b$export$443d89549b135c95);


var $j85oP = parcelRequire("j85oP");

var $f6qTB = parcelRequire("f6qTB");

var $jxSHn = parcelRequire("jxSHn");

var $lCetP = parcelRequire("lCetP");

var $aJ81Y = parcelRequire("aJ81Y");

var $PBAU4 = parcelRequire("PBAU4");

var $aGaXs = parcelRequire("aGaXs");
// oxlint-disable-next-line typescript/consistent-type-assertions
const $7f5a46395969800b$var$toLowerCase = (str)=>str.toLowerCase();
const $7f5a46395969800b$export$443d89549b135c95 = (localId)=>(0, $PBAU4.withRefreshBlocker)(async ({ setState: setState, getState: getState }, { navigationRemote: navigationRemote, cloudId: cloudId, containerType: containerType, containerId: containerId, onFailure: onFailure, onSuccess: onSuccess, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        const { view: view } = (0, $aGaXs.findView)(getState().containers[containerId], localId);
        if (!view) return;
        setState((0, $aGaXs.modifyView)(getState(), containerId, (viewToModify)=>{
            if (viewToModify.id === localId) return {
                ...viewToModify,
                isLocked: true
            };
            return viewToModify;
        }));
        const analyticsMetadata = Object.freeze({
            location: 'navigation',
            containerType: $7f5a46395969800b$var$toLowerCase(containerType),
            viewId: String(view.polarisId),
            // Stable uuid emitted alongside the legacy numeric viewId for analytics continuity
            // through the jpd-aurora-view-uuid-migration rollout and after xid is dropped.
            viewUuid: view.id
        });
        try {
            (0, $j85oP.experience).view.deleteView.start();
            await navigationRemote.deleteView({
                viewId: view.id
            });
            setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                views: getState().containers[containerId].views.filter((innerView)=>innerView.localId !== localId).map((childView)=>{
                    if (childView.views) return {
                        ...childView,
                        views: childView.views?.filter((innerView)=>innerView.localId !== localId)
                    };
                    return childView;
                })
            }));
            onSuccess?.('deleteView');
            if (createAnalyticsEvent) (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'view deleted', analyticsMetadata);
            (0, $jxSHn.sendPendoTrackEvent)({
                actionSubjectAndAction: 'view deleted',
                attributes: analyticsMetadata
            });
            (0, $j85oP.experience).view.deleteView.success({
                metadata: analyticsMetadata
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === (0, $8f860a533cc71fca$export$8bca792d963eb0ef)) {
                setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                    views: getState().containers[containerId].views.filter((innerView)=>innerView.localId !== localId).map((childView)=>{
                        if (childView.views) return {
                            ...childView,
                            views: childView.views?.filter((innerView)=>innerView.localId !== localId)
                        };
                        return childView;
                    })
                }));
                (0, $j85oP.experience).view.deleteView.abort(error);
                return;
            }
            setState((0, $aGaXs.modifyView)(getState(), containerId, (innerView)=>{
                if (innerView.localId === localId) return {
                    ...innerView,
                    isLocked: false
                };
                return innerView;
            }));
            if ((0, $f6qTB.isPermissionError)(error) || (0, $lCetP.isClientFetchError)(error)) (0, $j85oP.experience).view.deleteView.abort(error, {
                metadata: analyticsMetadata
            });
            else (0, $j85oP.experience).view.deleteView.failure(error, {
                metadata: analyticsMetadata
            });
            onFailure?.(error, 'deleteView');
        }
    });

});
/* eslint-disable jira/filename-case */ const $8f860a533cc71fca$export$ff39ebd4bb12b718 = 201;
const $8f860a533cc71fca$export$3288b14b6745c572 = 204;
const $8f860a533cc71fca$export$9de493bcd9b1d977 = 400;
const $8f860a533cc71fca$export$67d19e9a991baa07 = 401;
const $8f860a533cc71fca$export$a3269a3914b007e3 = 403;
const $8f860a533cc71fca$export$8bca792d963eb0ef = 404;
const $8f860a533cc71fca$export$4a3cb39801694eee = 407;
const $8f860a533cc71fca$export$fa405bbf47d510e2 = 408;
const $8f860a533cc71fca$export$c09e7ea0fc79f34f = 409;
const $8f860a533cc71fca$export$5244030134e99 = 412;
const $8f860a533cc71fca$export$f90ac1df0b60853d = 413;
const $8f860a533cc71fca$export$a447d0a965e16776 = 422;
const $8f860a533cc71fca$export$3b48aba8957000cd = 426;
const $8f860a533cc71fca$export$6763168a631449a2 = 429;
const $8f860a533cc71fca$export$e813cd7045fcc98d = 500;
const $8f860a533cc71fca$export$2ce38d41a306034e = 502;
const $8f860a533cc71fca$export$974c37534b0191b1 = 503;
const $8f860a533cc71fca$export$5400e8dddac3fcf3 = 504;

parcelRegister("jxSHn", function(module, exports) {
$parcel$export(module.exports, "sendPendoTrackEvent", () => $3952324875d6b38a$export$c6da4636619f7369);
$parcel$export(module.exports, "updatePendoVisitorOptions", () => $3952324875d6b38a$export$862313c5bc1d6788);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $gXtG2 = parcelRequire("gXtG2");

var $eAZLX = parcelRequire("eAZLX");
const $3952324875d6b38a$var$QUEUE_LIMIT = 50;
let $3952324875d6b38a$var$queue = [];
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $3952324875d6b38a$var$queue.length = 0;
});
const $3952324875d6b38a$var$waitForPendoReadiness = ()=>{
    // This code should not execute on the server.
    if (false) return;
    const interval = setInterval(()=>{
        if ((0, $eAZLX.isPendoReady)()) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            $3952324875d6b38a$var$queue.forEach(([event, attributes])=>window?.pendo?.track(event, attributes));
            $3952324875d6b38a$var$queue = [];
            clearInterval(interval);
        }
    }, 1000);
};
function $3952324875d6b38a$export$c6da4636619f7369(event, properties) {
    let pendoEvent;
    let attributes;
    if (typeof event === 'string') {
        pendoEvent = event;
        attributes = properties;
    } else {
        const fullEvent = [
            event.source,
            event.actionSubjectAndAction,
            event.actionSubjectId
        ].filter((part)=>part !== undefined).join(' - ');
        pendoEvent = fullEvent;
        attributes = event.attributes;
    }
    try {
        if ((0, $eAZLX.isPendoReady)()) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.pendo.track(pendoEvent, attributes);
        else {
            $3952324875d6b38a$var$queue.length < $3952324875d6b38a$var$QUEUE_LIMIT && $3952324875d6b38a$var$queue.push([
                pendoEvent,
                attributes
            ]);
            $3952324875d6b38a$var$waitForPendoReadiness();
        }
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $eAZLX.logError)('pendoTrackEvent', err);
    }
}
const $3952324875d6b38a$export$862313c5bc1d6788 = (metadata)=>{
    try {
        if ((0, $eAZLX.isPendoReady)()) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.pendo.updateOptions(metadata);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $eAZLX.logError)('pendoUpdateOptions', err);
    }
};

});
parcelRegister("eAZLX", function(module, exports) {
$parcel$export(module.exports, "logError", () => $6f20a12be7d966db$export$58da9968c3170cb1);
$parcel$export(module.exports, "isPendoReady", () => $6f20a12be7d966db$export$3f386d356f8c718f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $63gbl = parcelRequire("63gbl");
const $6f20a12be7d966db$export$58da9968c3170cb1 = (errorSubject, error)=>{
    const ERROR_ID = 'polaris-error';
    (0, $hFtK7.fireErrorAnalytics)({
        meta: {
            id: ERROR_ID,
            teamName: 'polaris'
        },
        attributes: {
            subject: errorSubject
        },
        error: error
    });
    (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)(`${ERROR_ID}.${errorSubject}`, error.message, error);
};
const $6f20a12be7d966db$export$3f386d356f8c718f = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window?.pendo?.isReady && typeof window.pendo.isReady === 'function' && window.pendo.isReady();

});



parcelRegister("iNbpn", function(module, exports) {
$parcel$export(module.exports, "updateView", () => $54cd25d5edef0b8b$export$827a6c17a85f6d1a);

var $j85oP = parcelRequire("j85oP");

var $lCetP = parcelRequire("lCetP");

var $PBAU4 = parcelRequire("PBAU4");

var $aGaXs = parcelRequire("aGaXs");
const $54cd25d5edef0b8b$export$827a6c17a85f6d1a = (localId, newName)=>(0, $PBAU4.withRefreshBlocker)(async ({ setState: setState, getState: getState }, { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId, onFailure: onFailure, onSuccess: onSuccess })=>{
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        const { view: view } = (0, $aGaXs.findView)(getState().containers[containerId], localId);
        if (!view || !view.viewType) return;
        (0, $j85oP.experience).navBar.changeViewName.start();
        setState((0, $aGaXs.modifyView)(getState(), containerId, (innerView)=>{
            if (innerView.localId === localId) return {
                ...view,
                name: newName,
                isRenaming: false,
                isLocked: true
            };
            return innerView;
        }));
        try {
            const updatedView = await navigationRemote.updateView({
                id: view.id,
                viewType: view.viewType,
                name: newName
            });
            setState((0, $aGaXs.modifyView)(getState(), containerId, (innerView)=>{
                if (innerView.localId === localId) return {
                    ...innerView,
                    name: updatedView.name,
                    isLocked: false
                };
                return innerView;
            }));
            onSuccess?.('updateView');
            (0, $j85oP.experience).navBar.changeViewName.success();
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState((0, $aGaXs.modifyView)(getState(), containerId, (innerView)=>{
                if (innerView.localId === localId) return {
                    ...innerView,
                    isLocked: false
                };
                return innerView;
            }));
            onFailure?.(error, 'updateView');
            if ((0, $lCetP.isClientFetchError)(error)) {
                (0, $j85oP.experience).navBar.changeViewName.abort(error);
                return;
            }
            (0, $j85oP.experience).navBar.changeViewName.failure(error);
        }
    });

});

parcelRegister("ltNen", function(module, exports) {
$parcel$export(module.exports, "renameView", () => $70704d40a9917e92$export$cbdb30d002054b2e);
$parcel$export(module.exports, "cancelViewRenaming", () => $70704d40a9917e92$export$fd7a156d10540e36);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aGaXs = parcelRequire("aGaXs");
const $70704d40a9917e92$export$cbdb30d002054b2e = (localId)=>async ({ setState: setState, getState: getState }, props)=>{
        const { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId } = props;
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        setState((0, $aGaXs.modifyView)(getState(), containerId, (view)=>{
            if (view.localId === localId) return {
                ...view,
                isRenaming: true
            };
            return view;
        }));
    };
const $70704d40a9917e92$export$fd7a156d10540e36 = (localId)=>async ({ setState: setState, getState: getState }, props)=>{
        const { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId } = props;
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        setState((0, $aGaXs.modifyView)(getState(), containerId, (view)=>{
            if (view.localId === localId) return {
                ...view,
                isRenaming: false
            };
            return view;
        }));
    };

});

parcelRegister("iYReo", function(module, exports) {
$parcel$export(module.exports, "addEmoji", () => $88ae47144c9c75ec$export$9bb52dfdd2a6ce6b);

var $PBAU4 = parcelRequire("PBAU4");

var $aGaXs = parcelRequire("aGaXs");
const $88ae47144c9c75ec$export$9bb52dfdd2a6ce6b = (emojiId, localId)=>(0, $PBAU4.withRefreshBlocker)(async ({ setState: setState, getState: getState }, { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId, onFailure: onFailure, onSuccess: onSuccess })=>{
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        const { view: view } = (0, $aGaXs.findView)(getState().containers[containerId], localId);
        if (!view || !view.viewType) return;
        setState((0, $aGaXs.modifyView)(getState(), containerId, (innerView)=>{
            if (innerView.localId === localId) return {
                ...innerView,
                emoji: emojiId,
                isLocked: true
            };
            return innerView;
        }));
        try {
            const updatedView = await navigationRemote.updateView({
                id: view.id,
                viewType: view.viewType,
                emoji: emojiId
            });
            setState((0, $aGaXs.modifyView)(getState(), containerId, (innerView)=>{
                if (innerView.localId === localId) return {
                    ...innerView,
                    emoji: updatedView.emoji,
                    isLocked: false
                };
                return innerView;
            }));
            onSuccess?.('addEmoji');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState((0, $aGaXs.modifyView)(getState(), containerId, (innerView)=>{
                if (innerView.localId === localId) return {
                    ...innerView,
                    isLocked: false
                };
                return innerView;
            }));
            onFailure?.(error, 'addEmoji');
        }
    });

});

parcelRegister("cSv8d", function(module, exports) {
$parcel$export(module.exports, "deleteEmoji", () => $b28efe76d334ca76$export$10f3c2d1fdd5612);

var $PBAU4 = parcelRequire("PBAU4");

var $aGaXs = parcelRequire("aGaXs");
const $b28efe76d334ca76$export$10f3c2d1fdd5612 = (localId)=>(0, $PBAU4.withRefreshBlocker)(async ({ setState: setState, getState: getState }, { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId, onSuccess: onSuccess, onFailure: onFailure })=>{
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        const { view: view } = (0, $aGaXs.findView)(getState().containers[containerId], localId);
        if (!view || !view.viewType) return;
        setState((0, $aGaXs.modifyView)(getState(), containerId, (innerView)=>{
            if (innerView.localId === localId) return {
                ...innerView,
                emoji: undefined,
                isLocked: true
            };
            return innerView;
        }));
        try {
            await navigationRemote.updateView({
                id: view.id,
                viewType: view.viewType,
                emoji: ''
            });
            setState((0, $aGaXs.modifyView)(getState(), containerId, (innerView)=>{
                if (innerView.localId === localId) return {
                    ...innerView,
                    isLocked: false
                };
                return innerView;
            }));
            onSuccess?.('removeEmoji');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState((0, $aGaXs.modifyView)(getState(), containerId, (innerView)=>{
                if (innerView.localId === localId) return {
                    ...innerView,
                    isLocked: false
                };
                return innerView;
            }));
            onFailure?.(error, 'removeEmoji');
        }
    });

});

parcelRegister("isuBy", function(module, exports) {
$parcel$export(module.exports, "cloneView", () => $b9d46ccb8c5ebb5b$export$de60ce8ef9a4993b);

var $7TA2J = parcelRequire("7TA2J");

var $j85oP = parcelRequire("j85oP");

var $lCetP = parcelRequire("lCetP");

var $PBAU4 = parcelRequire("PBAU4");

var $aGaXs = parcelRequire("aGaXs");
const $b9d46ccb8c5ebb5b$export$de60ce8ef9a4993b = (viewId, viewType)=>(0, $PBAU4.withRefreshBlocker)(async ({ getState: getState, setState: setState }, { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId, onFailure: onFailure, onSuccess: onSuccess, onViewCreated: onViewCreated })=>{
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        const { view: view, parent: parent } = (0, $aGaXs.findView)(getState().containers[containerId], viewId);
        if (!view) return;
        if (viewType === 'SECTION') return;
        (0, $j85oP.experience).navBar.createView.start();
        const newViewId = (0, $aGaXs.createFakeId)();
        const name = (0, $aGaXs.makeNewTitle)(view.name);
        const newView = {
            id: newViewId,
            polarisId: 0,
            localId: (0, $7TA2J.v4)(),
            name: name,
            viewType: viewType,
            views: undefined,
            isLocked: true,
            isManuallyCreated: true
        };
        if (parent) setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            views: getState().containers[containerId].views.map((innerView)=>innerView.localId === parent.localId ? {
                    ...innerView,
                    views: [
                        ...innerView.views || [],
                        newView
                    ]
                } : innerView)
        }));
        else setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            views: [
                ...getState().containers[containerId].views,
                newView
            ]
        }));
        try {
            const remoteView = await navigationRemote.cloneView({
                id: view.id,
                viewType: viewType,
                name: name
            });
            setState((0, $aGaXs.modifyView)(getState(), containerId, (innerView)=>innerView.localId === newView.localId ? {
                    ...(0, $aGaXs.transformRemoteView)(remoteView),
                    localId: newView.localId,
                    isManuallyCreated: true,
                    isLocked: false
                } : innerView));
            onSuccess?.('cloneView');
            const navView = (0, $aGaXs.findView)(getState().containers[containerId], newView.localId).view;
            if (navView) onViewCreated?.(navView);
            (0, $j85oP.experience).navBar.createView.success();
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState((0, $aGaXs.modifyView)(getState(), containerId, (innerView)=>innerView.localId === newView.localId ? {
                    ...innerView,
                    isLocked: false
                } : innerView));
            onFailure?.(error, 'cloneView');
            if ((0, $lCetP.isClientFetchError)(error)) {
                (0, $j85oP.experience).navBar.createView.abort(error);
                return;
            }
            (0, $j85oP.experience).navBar.createView.failure(error);
        }
    });

});

parcelRegister("a5ei5", function(module, exports) {
$parcel$export(module.exports, "toggleView", () => $f728ae25c165d64f$export$d42e969270d335d6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aGaXs = parcelRequire("aGaXs");
const $f728ae25c165d64f$export$d42e969270d335d6 = (localId)=>async ({ getState: getState, setState: setState }, props)=>{
        const { navigationRemote: navigationRemote, cloudId: cloudId, containerId: containerId } = props;
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        setState((0, $aGaXs.modifyView)(getState(), containerId, (viewToModify)=>{
            if (viewToModify.localId === localId) return {
                ...viewToModify,
                isExpanded: !viewToModify.isExpanded
            };
            return viewToModify;
        }));
    };

});

parcelRegister("cSA64", function(module, exports) {
$parcel$export(module.exports, "rankView", () => $5cab2ea067e092d1$export$a0b4e5c66bf01c3b);

var $j85oP = parcelRequire("j85oP");

var $lCetP = parcelRequire("lCetP");

var $vfr75 = parcelRequire("vfr75");

var $PBAU4 = parcelRequire("PBAU4");

var $aGaXs = parcelRequire("aGaXs");
const $5cab2ea067e092d1$export$a0b4e5c66bf01c3b = (rankPayload, onActionSuccess, onActionError)=>(0, $PBAU4.withRefreshBlocker)(async ({ getState: getState, setState: setState }, { containerId: containerId, cloudId: cloudId, navigationRemote: navigationRemote, onFailure: onFailure, onSuccess: onSuccess, containerType: containerType })=>{
        if (!cloudId || !containerId || !navigationRemote || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        const { id: id, index: index, parentId: parentId } = rankPayload;
        if (!parentId) return;
        (0, $j85oP.experience).navBar.changeViewRank.start();
        // Save the original views to revert the changes in case of failure
        const previousViewsState = getState().containers[containerId].views;
        try {
            const { view: viewToMove, parent: viewToMoveParent } = (0, $aGaXs.findView)(getState().containers[containerId], id);
            if (!viewToMove) return;
            const newViews = previousViewsState.filter((view)=>view.localId !== id).map((view)=>{
                if (viewToMoveParent && viewToMoveParent.localId === view.localId) return {
                    ...view,
                    views: view.views?.filter((v)=>v.localId !== id)
                };
                return view;
            });
            const viewToInsert = {
                ...viewToMove,
                isExpanded: rankPayload.isExpandedBeforeDrag
            };
            let moreAfterView;
            let moreBeforeView;
            let moveInEmptySet = false;
            if (parentId === 'root') {
                moreAfterView = newViews[index - 1];
                moreBeforeView = index === 0 ? newViews[index] : undefined;
                newViews.splice(index, 0, viewToInsert);
            } else newViews.map((view)=>{
                if (view.localId === parentId) {
                    if (!view.views?.length) {
                        moveInEmptySet = true;
                        if (view.views === undefined) Object.assign(view, {
                            views: []
                        });
                    } else {
                        moreAfterView = view.views?.[index - 1];
                        moreBeforeView = index === 0 ? view.views?.[index] : undefined;
                    }
                    view.views?.splice(index, 0, viewToInsert);
                    return {
                        ...view
                    };
                }
                return view;
            });
            setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                views: newViews,
                isLocked: true
            }));
            const parent = parentId === 'root' ? containerId : newViews.find((view)=>{
                if (view.localId === parentId) return view;
                return undefined;
            })?.id;
            if (!parent || !moreAfterView && !moreBeforeView && !moveInEmptySet) return;
            const parentType = parentId === 'root' ? containerType : (0, $vfr75.CONTAINER).SECTION;
            const rankViewRequest = {
                containerId: containerId,
                id: viewToMove.id,
                parentType: parentType,
                parentId: parent,
                rankIndex: index,
                moveAfter: undefined,
                moveBefore: undefined
            };
            if (moreAfterView) rankViewRequest.moveAfter = {
                id: moreAfterView.id,
                viewType: moreAfterView.viewType
            };
            else delete rankViewRequest.moveAfter;
            if (moreBeforeView) rankViewRequest.moveBefore = {
                id: moreBeforeView.id,
                viewType: moreBeforeView.viewType
            };
            else delete rankViewRequest.moveBefore;
            await navigationRemote?.rankView(rankViewRequest);
            setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                isLocked: false
            }));
            onSuccess?.('rankView');
            (0, $j85oP.experience).navBar.changeViewRank.success();
            onActionSuccess?.();
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // Reverse the changes in case of failure
            setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
                views: previousViewsState,
                isLocked: false
            }));
            if (error instanceof Error) onActionError?.(error);
            onFailure?.(error, 'rankView');
            if ((0, $lCetP.isClientFetchError)(error)) {
                (0, $j85oP.experience).navBar.changeViewRank.abort(error);
                return;
            }
            (0, $j85oP.experience).navBar.changeViewRank.failure(error);
        }
    });

});

parcelRegister("2WV42", function(module, exports) {
$parcel$export(module.exports, "syncViewName", () => $43d22db549883664$export$55613d1441df52cd);
$parcel$export(module.exports, "syncViewEmoji", () => $43d22db549883664$export$160841d274a6dd);
$parcel$export(module.exports, "syncViewDeletion", () => $43d22db549883664$export$9ac6953b5853098e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5jtR4 = parcelRequire("5jtR4");

var $PBAU4 = parcelRequire("PBAU4");

var $aGaXs = parcelRequire("aGaXs");
const $43d22db549883664$export$55613d1441df52cd = (viewId, type, name)=>(0, $PBAU4.withRefreshBlocker)(async ({ setState: setState, getState: getState }, props)=>{
        const { cloudId: cloudId, containerId: containerId, containerType: containerType } = props;
        if (!cloudId || !containerId || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        const viewIdKey = containerType === 'COLLECTION' ? 'id' : 'polarisId';
        const { view: view } = (0, $aGaXs.findViewBy)(getState().containers[containerId], (innerView)=>String(innerView[viewIdKey]) === viewId && innerView.viewType === type);
        if (!view) return;
        if (view.name === name) return;
        setState((0, $aGaXs.modifyView)(getState(), containerId, (innerView)=>{
            if (String(innerView[viewIdKey]) === viewId && innerView.viewType === type) return {
                ...innerView,
                name: name
            };
            return innerView;
        }));
    });
const $43d22db549883664$export$160841d274a6dd = (viewId, type, emoji)=>(0, $PBAU4.withRefreshBlocker)(async ({ setState: setState, getState: getState }, props)=>{
        const { cloudId: cloudId, containerId: containerId, containerType: containerType } = props;
        if (!cloudId || !containerId || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        const viewIdKey = containerType === 'COLLECTION' ? 'id' : 'polarisId';
        const { view: view } = (0, $aGaXs.findViewBy)(getState().containers[containerId], (innerView)=>String(innerView[viewIdKey]) === viewId && innerView.viewType === type);
        if (!view) return;
        if (view.emoji === emoji) return;
        setState((0, $aGaXs.modifyView)(getState(), containerId, (innerView)=>{
            if (String(innerView[viewIdKey]) === viewId && innerView.viewType === type) return {
                ...innerView,
                emoji: emoji
            };
            return innerView;
        }));
    });
const $43d22db549883664$export$9ac6953b5853098e = (viewId, type)=>(0, $PBAU4.withRefreshBlocker)(async ({ dispatch: dispatch, getState: getState }, props)=>{
        const { cloudId: cloudId, containerId: containerId, containerType: containerType } = props;
        if (!cloudId || !containerId || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        const viewIdKey = containerType === 'COLLECTION' ? 'id' : 'polarisId';
        const { view: view } = (0, $aGaXs.findViewBy)(getState().containers[containerId], (innerView)=>String(innerView[viewIdKey]) === viewId && innerView.viewType === type);
        if (!view) return;
        dispatch((0, $5jtR4.deleteViewFromState)(view.id));
    });

});
parcelRegister("5jtR4", function(module, exports) {
$parcel$export(module.exports, "deleteViewFromState", () => $d9f58fc820f6f377$export$59843b4833b739ab);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $PBAU4 = parcelRequire("PBAU4");

var $aGaXs = parcelRequire("aGaXs");
const $d9f58fc820f6f377$export$59843b4833b739ab = (viewUUID)=>(0, $PBAU4.withRefreshBlocker)(async ({ setState: setState, getState: getState }, { cloudId: cloudId, containerId: containerId, onSuccess: onSuccess })=>{
        if (!cloudId || !containerId || getState().containers[containerId]?.isLoading || !getState().containers[containerId]?.initialized) return;
        if (!viewUUID) return;
        const { view: view } = (0, $aGaXs.findViewBy)(getState().containers[containerId], (innerView)=>innerView.id === viewUUID);
        if (!view) return;
        setState((0, $aGaXs.updateContainerState)(getState(), containerId, {
            views: getState().containers[containerId].views.filter((innerView)=>innerView.id !== viewUUID).map((childView)=>{
                if (childView.views) return {
                    ...childView,
                    views: childView.views?.filter((innerView)=>innerView.id !== viewUUID)
                };
                return childView;
            })
        }));
        onSuccess?.('deleteViewFromState');
    });

});


parcelRegister("iZoCI", function(module, exports) {
$parcel$export(module.exports, "updateEntityLimits", () => $50442d7359fde374$export$5825515625715fdb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6jLTU = parcelRequire("6jLTU");

var $bxhpq = parcelRequire("bxhpq");
const $50442d7359fde374$export$5825515625715fdb = ()=>async ({ setState: setState, getState: getState }, { entityLimits: entityLimits })=>{
        // compare the new entity limits with the existing ones to avoid unnecessary re-renders
        const { entityLimits: existingEntityLimits } = getState();
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(entityLimits) && !(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(entityLimits, existingEntityLimits)) setState({
            entityLimits: entityLimits
        });
    };

});


parcelRegister("k4bFc", function(module, exports) {
$parcel$export(module.exports, "PermissionsStore", () => $df44e51577def711$export$b5908cc5361fefa5);
$parcel$export(module.exports, "usePermissions", () => $df44e51577def711$export$dde803638a7db51f);
$parcel$export(module.exports, "usePermissionActions", () => $df44e51577def711$export$25cd0da818ed2e08);
$parcel$export(module.exports, "PermissionsContainer", () => $df44e51577def711$export$485a62f3e7e4b669);
$parcel$export(module.exports, "useIsPreviewContributorMode", () => $df44e51577def711$export$442469493e9dd6bb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3h1FP = parcelRequire("3h1FP");
var $dB6ay = parcelRequire("dB6ay");
var $5QDqc = parcelRequire("5QDqc");

var $4WDkU = parcelRequire("4WDkU");

var $6E2ar = parcelRequire("6E2ar");

var $yqDqN = parcelRequire("yqDqN");

var $3VYhO = parcelRequire("3VYhO");
const $df44e51577def711$var$actions = {
    loadPermissions: $4WDkU.loadPermissions,
    switchPreviewContributorMode: $yqDqN.switchPreviewContributorMode,
    setContributorCreateIssuePermission: $3VYhO.setContributorCreateIssuePermission,
    loadViewPermissionsForCurrentUser: $6E2ar.loadViewPermissionsForCurrentUser
};
const $df44e51577def711$var$initialState = {
    meta: {
        loaded: false,
        loading: false,
        error: undefined
    },
    permissionsByProjectId: {},
    contributorPermissions: [
        {
            key: 'EDIT_OWN_COMMENTS',
            havePermission: true
        },
        {
            key: 'ADD_COMMENTS',
            havePermission: true
        },
        {
            key: 'DISCOVERY_VOTE',
            havePermission: true
        },
        {
            key: 'CREATE_ISSUES',
            havePermission: true
        },
        {
            key: 'CREATE_ATTACHMENTS',
            havePermission: true
        },
        {
            key: 'DELETE_OWN_ATTACHMENTS',
            havePermission: true
        },
        {
            key: 'CREATE_DISCOVERY_INSIGHTS',
            havePermission: true
        },
        {
            key: 'CREATE_DISCOVERY_VIEW_COMMENTS',
            havePermission: true
        }
    ],
    viewPermissions: {},
    isPreviewContributorMode: false
};
const $df44e51577def711$export$b5908cc5361fefa5 = (0, $5QDqc.createStore)({
    initialState: $df44e51577def711$var$initialState,
    actions: $df44e51577def711$var$actions,
    name: 'PolarisPermissionsStore'
});
const $df44e51577def711$export$dde803638a7db51f = (0, $3h1FP.createHook)($df44e51577def711$export$b5908cc5361fefa5);
const $df44e51577def711$export$25cd0da818ed2e08 = (0, $3h1FP.createActionsHook)($df44e51577def711$export$b5908cc5361fefa5);
const $df44e51577def711$export$485a62f3e7e4b669 = (0, $dB6ay.createContainer)($df44e51577def711$export$b5908cc5361fefa5, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $4WDkU.loadPermissions)());
        },
    onUpdate: ()=>({ dispatch: dispatch })=>dispatch((0, $4WDkU.loadPermissions)())
});
const $df44e51577def711$export$442469493e9dd6bb = (0, $3h1FP.createHook)($df44e51577def711$export$b5908cc5361fefa5, {
    selector: (state)=>state.isPreviewContributorMode
});

});
parcelRegister("4WDkU", function(module, exports) {
$parcel$export(module.exports, "loadPermissions", () => $7f64f8cbc037ef7e$export$52601d1a993d3c1);

var $dz1TB = parcelRequire("dz1TB");

var $bxhpq = parcelRequire("bxhpq");

var $i860n = parcelRequire("i860n");

var $glclq = parcelRequire("glclq");

var $3m5En = parcelRequire("3m5En");
const $7f64f8cbc037ef7e$var$isPreviewContributorModeAllowed = (permissions)=>{
    const canCreateIssues = permissions.find(({ key: key, havePermission: havePermission })=>key === 'CREATE_ISSUES' && havePermission === true);
    const canEditIssues = permissions.find(({ key: key, havePermission: havePermission })=>key === 'EDIT_ISSUES' && havePermission === true);
    return !!(canCreateIssues && canEditIssues);
};
const $7f64f8cbc037ef7e$export$52601d1a993d3c1 = ()=>async ({ getState: getState, setState: setState }, { isSharedView: isSharedView, isCollectionView: isCollectionView, isEmbeddedView: isEmbeddedView, projectIds: projectIds, onLoadStart: onLoadStart, onLoadEnd: onLoadEnd })=>{
        onLoadStart?.();
        const loadingProps = {
            isSharedView: isSharedView,
            isCollectionView: isCollectionView,
            isEmbeddedView: isEmbeddedView,
            projectIds: projectIds
        };
        const { meta: { loadingProps: previousLoadingProps, loading: loading, loaded: loaded }, permissionsByProjectId: previousPermissions, isPreviewContributorMode: previousIsPreviewMode } = getState();
        const isProjectView = !isSharedView && !isCollectionView;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const currUrl = new URL(window.location.href);
        const isPreviewRolePresentInUrl = currUrl.searchParams.get('previewRole') === 'contributor'; // for 1st version only contributor role is available for preview mode
        const isPreviewMode = isPreviewRolePresentInUrl && isProjectView && $7f64f8cbc037ef7e$var$isPreviewContributorModeAllowed(Object.values(previousPermissions)[0] ?? []);
        // Only load again when the props this function depends on have changed
        const isPropsNotChanged = Object.values(previousPermissions).length > 0 && previousLoadingProps !== undefined && previousIsPreviewMode === isPreviewMode && (0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(projectIds, previousLoadingProps?.projectIds);
        if (previousLoadingProps?.isCollectionView !== isCollectionView) setState({
            meta: {
                loaded: loaded,
                loading: loading,
                loadingProps: loadingProps
            }
        });
        if (!isSharedView && isPropsNotChanged) return;
        if (!previousLoadingProps) // init loading props
        setState({
            meta: {
                loaded: false,
                loading: false,
                error: undefined,
                loadingProps: loadingProps
            },
            permissionsByProjectId: {}
        });
        if (!projectIds?.length) return;
        // do not re-fetch permissions
        if ((loading || loaded) && projectIds !== undefined && (0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(projectIds, previousLoadingProps?.projectIds)) return;
        setState({
            meta: {
                loaded: false,
                loading: true,
                error: undefined,
                loadingProps: loadingProps
            },
            permissionsByProjectId: {}
        });
        try {
            let permissionsByProjectId;
            let previewContributorPermissions;
            if ((0, $i860n.fg)('jpd_multi-project-permission-fetch')) {
                permissionsByProjectId = await (0, $3m5En.fetchPermissionsForProjects)(projectIds.map(Number));
                previewContributorPermissions = permissionsByProjectId[projectIds[0]] ?? [];
            } else {
                const allPermissions = await Promise.all(projectIds.map(Number).map((0, $glclq.fetchPermissions)));
                permissionsByProjectId = (0, (/*@__PURE__*/$parcel$interopDefault($dz1TB)))(projectIds, allPermissions);
                previewContributorPermissions = allPermissions[0] ?? [];
            }
            setState({
                meta: {
                    loaded: true,
                    loading: false,
                    error: undefined,
                    loadingProps: loadingProps
                },
                permissionsByProjectId: permissionsByProjectId,
                isPreviewContributorMode: isProjectView ? $7f64f8cbc037ef7e$var$isPreviewContributorModeAllowed(previewContributorPermissions) && isPreviewRolePresentInUrl : false
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                meta: {
                    loaded: true,
                    loading: false,
                    error: error,
                    loadingProps: loadingProps
                },
                permissionsByProjectId: {},
                isPreviewContributorMode: false
            });
        } finally{
            onLoadEnd?.();
        }
    };

});
parcelRegister("dz1TB", function(module, exports) {

var $7b634 = parcelRequire("7b634");

var $hiqXP = parcelRequire("hiqXP");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $9e0003bb3aaa458c$var$zipObject(props, values) {
    return $hiqXP(props || [], values || [], $7b634);
}
module.exports = $9e0003bb3aaa458c$var$zipObject;

});
parcelRegister("hiqXP", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $c979089d40fb0422$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $c979089d40fb0422$var$baseZipObject;

});


parcelRegister("glclq", function(module, exports) {
$parcel$export(module.exports, "fetchPermissions", () => $296b3a2183d9854c$export$4f24ecba11982e9d);
$parcel$export(module.exports, "fetchViewPermissionsForCurrentUser", () => $296b3a2183d9854c$export$9f8ced377026ee41);


var $2wtso = parcelRequire("2wtso");

var $hn9Lv = parcelRequire("hn9Lv");

var $4fhEY = parcelRequire("4fhEY");

var $goaGS = parcelRequire("goaGS");

var $7W7k4 = parcelRequire("7W7k4");
const $296b3a2183d9854c$var$getPermissions = (projectId)=>{
    // Check if we have early fetched data
    const cachedPromise = (0, $goaGS.getEarlyFetchResponse)(projectId);
    if (cachedPromise) return (0, $hn9Lv.wrapPromiseWithFetchInteraction)(cachedPromise, 'earlyScript/getPermissions').catch(()=>{
        // If the cached promise fails, fall back to a regular fetch
        return (0, $4fhEY.default)((0, $7W7k4.getPermissionsUrl)(projectId));
    });
    // If no early fetched data is available, perform the fetch
    return (0, $4fhEY.default)((0, $7W7k4.getPermissionsUrl)(projectId));
};
const $296b3a2183d9854c$export$4f24ecba11982e9d = (projectId)=>$296b3a2183d9854c$var$getPermissions(projectId).then((permissionsResponse)=>Object.keys(permissionsResponse.permissions).map((item)=>({
                key: permissionsResponse.permissions[item].key,
                havePermission: permissionsResponse.permissions[item].havePermission
            }))).catch((error)=>{
        if (error.statusCode === (0, $8f860a533cc71fca$export$8bca792d963eb0ef)) return [];
        throw error;
    });
const $296b3a2183d9854c$export$963556ef97965f0b = ()=>(0, $4fhEY.default)('/rest/api/3/mypermissions?permissions=CREATE_PROJECT').then((response)=>{
        return response.permissions.CREATE_PROJECT.havePermission;
    }).catch((error)=>{
        if (error.statusCode === (0, $8f860a533cc71fca$export$8bca792d963eb0ef)) return false;
        throw error;
    });
const $296b3a2183d9854c$export$9f8ced377026ee41 = async (viewId)=>{
    const response = await (0, $4fhEY.default)(`${(0, $2wtso.getJpdViewsServicePathPrefix)()}/v1/views/${viewId}/access/my-access`);
    if (!response.permissions.read_view && !response.permissions.edit_view) throw new Error('polaris.permissions-store.fetch-view-permissions-for-current-user: invalid response');
    return {
        canView: response.permissions.read_view,
        canEdit: response.permissions.edit_view,
        accessLevel: response.accessLevel
    };
};

});
parcelRegister("goaGS", function(module, exports) {
$parcel$export(module.exports, "getEarlyFetchResponse", () => $95e9016920708d83$export$b9d6f7ad3c414536);
$parcel$export(module.exports, "getEarlyFetchResponseForProjects", () => $95e9016920708d83$export$78edeed1d6e2d12e);
$parcel$export(module.exports, "runGetPermissionsEarlyScript", () => $95e9016920708d83$export$e6254bd6eb2e51ab);

var $3HFzJ = parcelRequire("3HFzJ");

var $7FcOv = parcelRequire("7FcOv");

var $2snMp = parcelRequire("2snMp");

var $7U9nQ = parcelRequire("7U9nQ");

var $hWVxx = parcelRequire("hWVxx");

var $eQXnX = parcelRequire("eQXnX");

var $i860n = parcelRequire("i860n");

var $7W7k4 = parcelRequire("7W7k4");
const $95e9016920708d83$var$earlyFetchCache = (0, $3HFzJ.createEarlyFetchCache)({
    paramsEqualityFn: (paramsA, paramsB)=>String(paramsA) === String(paramsB)
});
const $95e9016920708d83$var$earlyFetchCacheForProjects = (0, $3HFzJ.createEarlyFetchCache)({
    paramsEqualityFn: (paramsA, paramsB)=>paramsA.length === paramsB.length && paramsA.every((id, i)=>id === paramsB[i])
});
const $95e9016920708d83$export$b9d6f7ad3c414536 = (projectId)=>{
    return $95e9016920708d83$var$earlyFetchCache.getCachedResponse(projectId);
};
const $95e9016920708d83$export$78edeed1d6e2d12e = (projectIds)=>{
    return $95e9016920708d83$var$earlyFetchCacheForProjects.getCachedResponse(projectIds);
};
/**
 * Helper function to fetch permissions with proper type
 */ const $95e9016920708d83$var$fetchPermissions = (projectId)=>{
    const url = (0, $7W7k4.getPermissionsUrl)(projectId);
    return (0, $7FcOv.fetchData)({
        url: url,
        method: 'GET'
    });
};
const $95e9016920708d83$var$fetchPermissionsForProjects = (projectIds)=>{
    return (0, $7FcOv.fetchData)({
        url: (0, $7W7k4.PERMISSIONS_CHECK_PATH),
        method: 'POST',
        body: JSON.stringify((0, $7W7k4.buildPermissionsCheckRequestBody)(projectIds))
    });
};
const $95e9016920708d83$export$99f3857f479ef922 = (projectId)=>{
    if ((0, $i860n.fg)('jpd_multi-project-permission-fetch')) {
        const projectIds = [
            projectId
        ];
        const response = $95e9016920708d83$var$fetchPermissionsForProjects(projectIds);
        $95e9016920708d83$var$earlyFetchCacheForProjects.setCacheResponse(response, projectIds);
    } else {
        // Execute the actual fetch for permissions
        const response = $95e9016920708d83$var$fetchPermissions(projectId);
        // Store the fetch promise in the cache
        $95e9016920708d83$var$earlyFetchCache.setCacheResponse(response, projectId);
    }
};
function $95e9016920708d83$export$e6254bd6eb2e51ab(location) {
    // Parse the location to extract the necessary parameters
    const projectKey = (0, $eQXnX.getProjectKeyFromLocation)(location);
    if (!projectKey) return false;
    // Use cached projectId if available, otherwise wait for SPA_STATE
    (0, $hWVxx.getProjectIdFromMap)(projectKey, (0, $2snMp.waitForGlobalVariable)).then((projectId)=>{
        if (projectId) $95e9016920708d83$export$99f3857f479ef922(Number(projectId));
    }).catch((error)=>{
        (0, $7U9nQ.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.project-id-mapping', 'Error fetching permissions', error instanceof Error ? error : new Error(String(error)));
    });
    return true;
}

});
parcelRegister("7W7k4", function(module, exports) {
$parcel$export(module.exports, "getPermissionsUrl", () => $6df7fd6a6169a0dc$export$4bab899e383f47ba);
$parcel$export(module.exports, "PERMISSIONS_CHECK_PATH", () => $6df7fd6a6169a0dc$export$6eb743e8958c5051);
$parcel$export(module.exports, "buildPermissionsCheckRequestBody", () => $6df7fd6a6169a0dc$export$476a1a6eb560744a);

var $hUGBV = parcelRequire("hUGBV");
const $6df7fd6a6169a0dc$export$529b34ddc0bdb55e = ()=>[
        ...(0, $hUGBV.PROJECT_PERMISSIONS),
        ...(0, $hUGBV.GLOBAL_PERMISSIONS)
    ].join();
const $6df7fd6a6169a0dc$export$4bab899e383f47ba = (projectId)=>`/rest/api/3/mypermissions?projectId=${projectId}&permissions=${$6df7fd6a6169a0dc$export$529b34ddc0bdb55e()}&operation=getPermissions`;
const $6df7fd6a6169a0dc$export$6eb743e8958c5051 = '/rest/api/3/permissions/check?operation=getPermissions';
const $6df7fd6a6169a0dc$export$476a1a6eb560744a = (projectIds)=>({
        projectPermissions: [
            {
                // new instance of the array
                permissions: [
                    ...(0, $hUGBV.PROJECT_PERMISSIONS)
                ],
                projects: projectIds
            }
        ],
        // new instance of the array
        globalPermissions: [
            ...(0, $hUGBV.GLOBAL_PERMISSIONS)
        ]
    });

});
parcelRegister("hUGBV", function(module, exports) {
$parcel$export(module.exports, "PROJECT_PERMISSIONS", () => $8c7f53a9e698e868$export$f493d3da3b1bf4c8);
$parcel$export(module.exports, "GLOBAL_PERMISSIONS", () => $8c7f53a9e698e868$export$1922572d6065cfd0);
const $8c7f53a9e698e868$export$f493d3da3b1bf4c8 = [
    'ADMINISTER_PROJECTS',
    'EDIT_WORKFLOW',
    'EDIT_ISSUE_LAYOUT',
    'ADD_COMMENTS',
    'EDIT_OWN_COMMENTS',
    'EDIT_ALL_COMMENTS',
    'CREATE_ISSUES',
    'EDIT_ISSUES',
    'SCHEDULE_ISSUES',
    'DELETE_ISSUES',
    'CREATE_ATTACHMENTS',
    'DELETE_OWN_ATTACHMENTS',
    'DELETE_ALL_ATTACHMENTS',
    'LINK_ISSUES',
    'MOVE_ISSUES',
    'CREATE_DISCOVERY_INSIGHTS',
    'MANAGE_DISCOVERY_INSIGHTS',
    'MANAGE_DISCOVERY_DELIVERY',
    'MERGE_DISCOVERY_ISSUES',
    'ARCHIVE_DISCOVERY_ISSUES',
    'DISCOVERY_VOTE',
    'MANAGE_DISCOVERY_IDEA_TEMPLATES',
    'PIN_DISCOVERY_ISSUE_VIEW_FIELDS',
    'MANAGE_DISCOVERY_VIEWS',
    'SHARE_DISCOVERY_VIEWS',
    'PUBLISH_DISCOVERY_VIEWS',
    'CREATE_DISCOVERY_VIEW_COMMENTS',
    'MANAGE_DISCOVERY_VIEW_COMMENTS',
    'MANAGE_WATCHERS',
    'VIEW_VOTERS_AND_WATCHERS',
    'MODIFY_REPORTER',
    'PUBLISH_PUBLIC_DISCOVERY_VIEWS'
];
const $8c7f53a9e698e868$export$1922572d6065cfd0 = [
    'BULK_CHANGE',
    'CREATE_PROJECT'
];

});




parcelRegister("3m5En", function(module, exports) {
$parcel$export(module.exports, "fetchPermissionsForProjects", () => $6a338c4cecd876ba$export$79e78ee85e8f3ec9);

var $hn9Lv = parcelRequire("hn9Lv");

var $4fhEY = parcelRequire("4fhEY");

var $goaGS = parcelRequire("goaGS");

var $7W7k4 = parcelRequire("7W7k4");

var $hUGBV = parcelRequire("hUGBV");

var $8B7DD = parcelRequire("8B7DD");
const $6a338c4cecd876ba$var$mapPermissionsCheckResponse = (response, projectIds)=>{
    const projectsByPermission = new Map();
    for (const entry of response.projectPermissions)projectsByPermission.set(entry.permission, new Set(entry.projects));
    const grantedGlobalPermissions = new Set(response.globalPermissions);
    const permissionsByProjectId = {};
    for (const projectId of projectIds){
        const permissions = [];
        for (const key of (0, $hUGBV.PROJECT_PERMISSIONS)){
            const grantedProjectIds = projectsByPermission.get(key);
            permissions.push({
                key: key,
                havePermission: grantedProjectIds?.has(projectId) ?? false
            });
        }
        for (const key of (0, $hUGBV.GLOBAL_PERMISSIONS))permissions.push({
            key: key,
            havePermission: grantedGlobalPermissions.has(key)
        });
        permissionsByProjectId[String(projectId)] = permissions;
    }
    return permissionsByProjectId;
};
/** Early preload via the bulk permissions/check POST endpoint. */ const $6a338c4cecd876ba$var$tryGetFromEarlyFetchForProjects = async (projectIds)=>{
    const cachedPromise = (0, $goaGS.getEarlyFetchResponseForProjects)(projectIds);
    if (!cachedPromise) return null;
    try {
        const response = await (0, $hn9Lv.wrapPromiseWithFetchInteraction)(cachedPromise, 'earlyScript/getPermissionsForProjects');
        const mappedResult = $6a338c4cecd876ba$var$mapPermissionsCheckResponse(response, projectIds);
        (0, $8B7DD.comparePermissionsWithLegacy)(projectIds, mappedResult).catch(()=>undefined);
        return mappedResult;
    } catch  {
        return null;
    }
};
const $6a338c4cecd876ba$var$fetchPermissionsCheck = (projectIds)=>(0, $4fhEY.default)((0, $7W7k4.PERMISSIONS_CHECK_PATH), {
        method: 'POST',
        body: JSON.stringify((0, $7W7k4.buildPermissionsCheckRequestBody)(projectIds))
    }).then((response)=>{
        const mappedResult = $6a338c4cecd876ba$var$mapPermissionsCheckResponse(response, projectIds);
        (0, $8B7DD.comparePermissionsWithLegacy)(projectIds, mappedResult).catch(()=>undefined);
        return mappedResult;
    });
const $6a338c4cecd876ba$export$79e78ee85e8f3ec9 = async (projectIds)=>{
    const fromEarlyFetchForProjects = await $6a338c4cecd876ba$var$tryGetFromEarlyFetchForProjects(projectIds);
    if (fromEarlyFetchForProjects) return fromEarlyFetchForProjects;
    return $6a338c4cecd876ba$var$fetchPermissionsCheck(projectIds);
};

});
parcelRegister("8B7DD", function(module, exports) {
$parcel$export(module.exports, "comparePermissionsWithLegacy", () => $272016ed0161f37c$export$a0eea1d2e8d07007);

var $6CfY5 = parcelRequire("6CfY5");

var $glclq = parcelRequire("glclq");
const $272016ed0161f37c$export$a0eea1d2e8d07007 = async (projectIds, bulkPermissionsByProjectId)=>{
    try {
        const legacyPermissionsByProject = await Promise.all(projectIds.map((projectId)=>(0, $glclq.fetchPermissions)(projectId)));
        const mismatches = [];
        projectIds.forEach((projectId, index)=>{
            const legacyPermissions = legacyPermissionsByProject[index] ?? [];
            const bulkPermissions = bulkPermissionsByProjectId[String(projectId)] ?? [];
            for (const bulkPermission of bulkPermissions){
                const legacyPermission = legacyPermissions.find(({ key: key })=>key === bulkPermission.key)?.havePermission ?? false;
                if (bulkPermission.havePermission !== legacyPermission) mismatches.push({
                    projectId: projectId,
                    permission: bulkPermission.key,
                    bulk: bulkPermission.havePermission,
                    legacy: legacyPermission
                });
            }
        });
        if (mismatches.length > 0) await (0, $6CfY5.default).safeWarnWithoutCustomerData('polaris.component-permissions-store.fetchPermissionsForProjects', 'bulk and legacy permissions differ', {
            mismatches: JSON.stringify(mismatches)
        });
    } catch  {
    // This diagnostic comparison must not affect permission loading.
    }
};

});



parcelRegister("6E2ar", function(module, exports) {
$parcel$export(module.exports, "loadViewPermissionsForCurrentUser", () => $1651e1a533ba9fa2$export$7be20f51c91fd811);

var $hFtK7 = parcelRequire("hFtK7");

var $lQWeu = parcelRequire("lQWeu");

var $f6qTB = parcelRequire("f6qTB");

var $j85oP = parcelRequire("j85oP");

var $ifsAO = parcelRequire("ifsAO");

var $lCetP = parcelRequire("lCetP");

var $glclq = parcelRequire("glclq");
const $1651e1a533ba9fa2$var$DEFAULT_CACHE_TTL = 30000; // 30 seconds
const $1651e1a533ba9fa2$export$7be20f51c91fd811 = (containerId)=>async ({ getState: getState, setState: setState }, props)=>{
        const cacheTTL = props.cacheTTL ?? $1651e1a533ba9fa2$var$DEFAULT_CACHE_TTL;
        const cachedViewPermissions = getState().viewPermissions[containerId];
        const isCached = cachedViewPermissions?.loadedTimestamp !== undefined;
        const isExpired = isCached && performance.now() - (getState().viewPermissions[containerId].loadedTimestamp || 0) > cacheTTL;
        if (cachedViewPermissions && isCached && !isExpired || cachedViewPermissions?.loading) {
            let role;
            if (cachedViewPermissions.data?.canEdit) role = (0, $lQWeu.ACCESS_ROLE_EDITOR);
            else if (cachedViewPermissions.data?.canView) role = (0, $lQWeu.ACCESS_ROLE_VIEWER);
            return {
                role: role,
                accessLevel: cachedViewPermissions.data?.accessLevel,
                state: cachedViewPermissions?.loading ? 'loading' : 'succeeded'
            };
        }
        setState({
            viewPermissions: {
                ...getState().viewPermissions,
                [containerId]: {
                    ...getState().viewPermissions[containerId],
                    loading: true
                }
            }
        });
        (0, $j85oP.experience).viewPermissions.loadCurrentUserViewPermissions.start();
        try {
            const { canView: canView, canEdit: canEdit, accessLevel: accessLevel } = await (0, $glclq.fetchViewPermissionsForCurrentUser)(containerId);
            (0, $j85oP.experience).viewPermissions.loadCurrentUserViewPermissions.success();
            setState({
                viewPermissions: {
                    ...getState().viewPermissions,
                    [containerId]: {
                        loading: false,
                        loadedTimestamp: performance.now(),
                        data: {
                            canView: canView,
                            canEdit: canEdit,
                            accessLevel: accessLevel
                        }
                    }
                }
            });
            return {
                role: canEdit ? (0, $lQWeu.ACCESS_ROLE_EDITOR) : (0, $lQWeu.ACCESS_ROLE_VIEWER),
                accessLevel: accessLevel,
                state: 'succeeded'
            };
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if ((0, $f6qTB.isAccessForbiddenError)(error)) {
                (0, $j85oP.experience).viewPermissions.loadCurrentUserViewPermissions.abort(error);
                setState({
                    viewPermissions: {
                        ...getState().viewPermissions,
                        [containerId]: {
                            ...getState().viewPermissions[containerId],
                            data: undefined,
                            loading: false
                        }
                    }
                });
                return {
                    role: undefined,
                    accessLevel: undefined,
                    state: 'no-access'
                };
            }
            if ((0, $lCetP.isClientFetchError)(error)) (0, $j85oP.experience).viewPermissions.loadCurrentUserViewPermissions.abort(error);
            else (0, $j85oP.experience).viewPermissions.loadCurrentUserViewPermissions.failure(error);
            (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.permissions-store.load-view-permissions-for-current-user', error));
            setState({
                viewPermissions: {
                    ...getState().viewPermissions,
                    [containerId]: {
                        ...getState().viewPermissions[containerId],
                        loading: false
                    }
                }
            });
            return {
                role: undefined,
                accessLevel: undefined,
                state: 'failed'
            };
        }
    };

});
parcelRegister("lQWeu", function(module, exports) {
$parcel$export(module.exports, "VIEW_ACCESS_LEVEL_OPEN", () => $8d653985d6cff8c6$export$57830ed530bd3e8c);
$parcel$export(module.exports, "VIEW_ACCESS_LEVELS", () => $8d653985d6cff8c6$export$54010017a2d4d01e);
$parcel$export(module.exports, "ACCESS_ROLE_EDITOR", () => $8d653985d6cff8c6$export$607d7028cf1291b5);
$parcel$export(module.exports, "ACCESS_ROLE_VIEWER", () => $8d653985d6cff8c6$export$7067053a04ed7c90);
$parcel$export(module.exports, "ACCESS_ROLE_EDITOR_ARI", () => $8d653985d6cff8c6$export$3f064e77a6e03694);
$parcel$export(module.exports, "ACCESS_ROLE_VIEWER_ARI", () => $8d653985d6cff8c6$export$180be1cd3d7b9696);
$parcel$export(module.exports, "PRINCIPAL_TYPES", () => $8d653985d6cff8c6$export$89e3f48fb47402b6);
$parcel$export(module.exports, "ACCESS_ROLE_ERRORS", () => $8d653985d6cff8c6$export$21f6b56572a7f593);
/* eslint-disable jira/filename-case */ const $8d653985d6cff8c6$export$57830ed530bd3e8c = 'OPEN';
const $8d653985d6cff8c6$export$85f060b47f6fb5b = 'LIMITED';
const $8d653985d6cff8c6$export$9c2d53699d994b5a = 'RESTRICTED';
const $8d653985d6cff8c6$export$54010017a2d4d01e = {
    OPEN: $8d653985d6cff8c6$export$57830ed530bd3e8c,
    LIMITED: $8d653985d6cff8c6$export$85f060b47f6fb5b,
    RESTRICTED: $8d653985d6cff8c6$export$9c2d53699d994b5a
};
const $8d653985d6cff8c6$export$607d7028cf1291b5 = 'EDITOR';
const $8d653985d6cff8c6$export$7067053a04ed7c90 = 'VIEWER';
const $8d653985d6cff8c6$export$3f064e77a6e03694 = 'ari:cloud:jira-product-discovery::role/view/editor';
const $8d653985d6cff8c6$export$180be1cd3d7b9696 = 'ari:cloud:jira-product-discovery::role/view/viewer';
const $8d653985d6cff8c6$export$895cb5011e48c06d = 'CREATOR';
const $8d653985d6cff8c6$export$6d36c7abacdc3f35 = 'CONTRIBUTOR';
const $8d653985d6cff8c6$export$4a1c887504192e78 = 'user';
const $8d653985d6cff8c6$export$4050c956318f649b = 'group';
const $8d653985d6cff8c6$export$89e3f48fb47402b6 = {
    PROFILE: $8d653985d6cff8c6$export$4a1c887504192e78,
    GROUP: $8d653985d6cff8c6$export$4050c956318f649b
};
const $8d653985d6cff8c6$export$589db1214b30dbd8 = 'MISSING_MANAGE_DISCOVERY_VIEWS_PERMISSION';
const $8d653985d6cff8c6$export$997e64f01159ffc = 'MISSING_BROWSE_PROJECTS_PERMISSION';
const $8d653985d6cff8c6$export$21f6b56572a7f593 = {
    MISSING_MANAGE_DISCOVERY_VIEWS_PERMISSION: $8d653985d6cff8c6$export$589db1214b30dbd8,
    MISSING_BROWSE_PROJECTS_PERMISSION: $8d653985d6cff8c6$export$997e64f01159ffc
};

});


parcelRegister("yqDqN", function(module, exports) {
$parcel$export(module.exports, "switchPreviewContributorMode", () => $47ddbe9232c565a3$export$7b6b520007154142);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $47ddbe9232c565a3$export$7b6b520007154142 = (isPreviewOn)=>({ setState: setState })=>{
        setState({
            isPreviewContributorMode: isPreviewOn
        });
    };

});

parcelRegister("3VYhO", function(module, exports) {
$parcel$export(module.exports, "setContributorCreateIssuePermission", () => $ed373d72ce57745d$export$5f117a61df44cfa2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $ed373d72ce57745d$export$5f117a61df44cfa2 = (enabled)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            contributorPermissions: [
                ...state.contributorPermissions.map((permission)=>permission.key === 'CREATE_ISSUES' ? {
                        key: permission.key,
                        havePermission: enabled
                    } : permission)
            ]
        });
    };

});



parcelRegister("hLi02", function(module, exports) {
$parcel$export(module.exports, "useRoadmapReorderingIds", () => $186a6d88aad842fe$export$3f53d88112e1dd6f);

var $kFgCO = parcelRequire("kFgCO");

var $2NSbF = parcelRequire("2NSbF");

var $bZhC2 = parcelRequire("bZhC2");

var $kt86l = parcelRequire("kt86l");

var $h3LJR = parcelRequire("h3LJR");
const $186a6d88aad842fe$export$3f53d88112e1dd6f = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const { data: { user: { accountId: accountId } } } = (0, $kFgCO.useCurrentUser)();
    // FG fg('navx-3660-fix-l2-l3-aris') seems to break ordering so it would be skipped for now
    const entityAri = (0, $bZhC2.JiraNavigationSettingsAri).create({
        siteId: cloudId,
        activationId: activationId,
        navigationSettingScope: 'collections'
    }).toString();
    const ownerAri = (0, $2NSbF.IdentityUserAri).create({
        userId: accountId || 'UNKNOWN'
    }).toString();
    return {
        entityAri: entityAri,
        ownerAri: ownerAri,
        group: 'SIDE_NAVIGATION_STARRED_ROADMAPS'
    };
};

});

parcelRegister("3a4dy", function(module, exports) {
$parcel$export(module.exports, "ActionButtonsRoadmap", () => $4c7865ddd0b03fa0$export$f9e383196a1fbaef);

var $465lH = parcelRequire("465lH");

var $euxye = parcelRequire("euxye");

var $7SOt3 = parcelRequire("7SOt3");

var $k4bFc = parcelRequire("k4bFc");

var $6yRkP = parcelRequire("6yRkP");

var $fdPS1 = parcelRequire("fdPS1");

var $e1DnH = parcelRequire("e1DnH");

var $kmMHr = parcelRequire("kmMHr");

var $n67Vb = parcelRequire("n67Vb");

var $gbTMi = parcelRequire("gbTMi");

var $1I6IV = parcelRequire("1I6IV");

var $atbVz = parcelRequire("atbVz");

var $kt86l = parcelRequire("kt86l");

var $inMxE = parcelRequire("inMxE");

var $78GR0 = parcelRequire("78GR0");

var $1rRWW = parcelRequire("1rRWW");

var $lwxMv = parcelRequire("lwxMv");

var $gZM30 = parcelRequire("gZM30");

var $29ILa = parcelRequire("29ILa");

var $bVDHZ = parcelRequire("bVDHZ");

var $b1YRJ = parcelRequire("b1YRJ");

var $j42hx = parcelRequire("j42hx");
const $4c7865ddd0b03fa0$export$f9e383196a1fbaef = /*#__PURE__*/ (0, $euxye.memo)(({ collectionUUID: collectionUUID, isCollectionExpanded: isCollectionExpanded, isCollectionSelected: isCollectionSelected, navigationCollection: navigationCollection, onViewCreated: onViewCreated, collectionQueryRefFragment: collectionQueryRefFragment, currentItems: currentItems, currentOrder: currentOrder, item: item })=>{
    const actionButtonsCollectionData = (0, $n67Vb.useFragment)((0, $465lH.default), collectionQueryRefFragment);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const navigationViewRemote = (0, $1rRWW.useNavigationViewRemote)();
    const cloudId = (0, $kt86l.useCloudId)();
    const [entityLimits] = (0, $e1DnH.useEntityLimits)();
    const [preloadPermissions, setPreloadPermissions] = (0, $euxye.useState)(false);
    const { sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent } = (0, $lwxMv.useRoadmapsAnalyticsL2)();
    const handlePermissionsPreloading = (0, $euxye.useCallback)(()=>{
        setPreloadPermissions(true);
    }, [
        setPreloadPermissions
    ]);
    const menuItems = (0, $euxye.useCallback)(({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j42hx.RoadmapMenuItems), {
            collectionUUID: collectionUUID,
            preloadPermissions: preloadPermissions,
            onClose: onClose,
            collectionQueryRefFragment: actionButtonsCollectionData ?? undefined,
            currentItems: currentItems,
            currentOrder: currentOrder,
            item: item
        }), [
        actionButtonsCollectionData,
        collectionUUID,
        currentItems,
        currentOrder,
        item,
        preloadPermissions
    ]);
    const handleNavMenuOpen = (0, $euxye.useCallback)(()=>{
        sendMeatBallDropDownOnProjectsAnalyticsEvent(navigationCollection);
    }, [
        navigationCollection,
        sendMeatBallDropDownOnProjectsAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k4bFc.PermissionsContainer), {
        scope: (0, $6yRkP.getCollectionContainerScope)(collectionUUID),
        cacheTTL: (0, $b1YRJ.PERMISSIONS_CACHE_TTL),
        isCollectionView: true,
        isEmbeddedView: false,
        isSharedView: false
    }, isCollectionExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $atbVz.JpdNavViewsContainer), {
        name: "jpd-roadmaps",
        container: navigationCollection,
        viewsEntityLimitType: (0, $7SOt3.ENTITY_LIMIT_TYPE).VIEWS_PER_COLLECTION,
        viewsetsEntityLimitType: (0, $7SOt3.ENTITY_LIMIT_TYPE).VIEWSETS_PER_COLLECTION,
        sectionsEnabled: true,
        containerTypePermissions: "project",
        getViewUrl: (0, $78GR0.getViewUrl),
        useIsReadOnly: (0, $bVDHZ.useIsReadOnly),
        useAnalyticsL2: (0, $lwxMv.useRoadmapsAnalyticsL2),
        useAnalyticsL3: (0, $gZM30.useRoadmapsAnalyticsL3),
        useAnalyticsL4: (0, $29ILa.useRoadmapsAnalyticsL4)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fdPS1.EntityLimitsContainer), {
        isGlobal: true,
        createAnalyticsEvent: createAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kmMHr.NavigationContainer), {
        isGlobal: true,
        containerType: "COLLECTION",
        isActiveContainer: isCollectionSelected,
        navigationRemote: navigationViewRemote,
        cloudId: cloudId,
        containerId: collectionUUID,
        entityLimits: entityLimits,
        onViewCreated: onViewCreated,
        createAnalyticsEvent: createAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1I6IV.ActionButtonCreateView), {
        navigationContainer: navigationCollection
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        onMouseEnter: handlePermissionsPreloading,
        onFocus: handlePermissionsPreloading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
        onOpen: handleNavMenuOpen,
        MenuItems: menuItems
    })));
});

});
parcelRegister("465lH", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6bee193a599e2dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cffb7f38d44f446b735d4a50989217c6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d6bee193a599e2dd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ActionButtonsRoadmap_collection",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "RoadmapMenuItems_collection"
        }
    ],
    "type": "JiraProductDiscoveryCollection"
};
$d6bee193a599e2dd$var$node.hash = "93db3b7ead7139642a9e3f1c77472ba9";
var $d6bee193a599e2dd$export$2e2bcd8739ae039 = $d6bee193a599e2dd$var$node;

});

parcelRegister("1I6IV", function(module, exports) {
$parcel$export(module.exports, "ActionButtonCreateView", () => $4621b3b7fb656738$export$f8a8709de891aa53);

var $euxye = parcelRequire("euxye");

var $3kW31 = parcelRequire("3kW31");

var $b6kJl = parcelRequire("b6kJl");

var $9zMc9 = parcelRequire("9zMc9");

var $6c08J = parcelRequire("6c08J");

var $kDapy = parcelRequire("kDapy");

var $eO8S8 = parcelRequire("eO8S8");

var $ikOED = parcelRequire("ikOED");

var $hZDXn = parcelRequire("hZDXn");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $fFNvS = parcelRequire("fFNvS");

var $eQCsj = parcelRequire("eQCsj");

var $hj9Qm = parcelRequire("hj9Qm");

var $d8n9z = parcelRequire("d8n9z");
const $4621b3b7fb656738$var$createView = (0, $7eNDO.defineMessage)({
    defaultMessage: "Create a view",
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.action-button-create-view.create-view"
});
const $4621b3b7fb656738$export$f8a8709de891aa53 = ({ container: container, sectionId: sectionId, navigationContainer: navigationContainer })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const navViewName = (0, $hj9Qm.useJpdNavViewName)();
    const containerId = (0, $hj9Qm.useContainerId)();
    const [isNavigationLocked] = (0, $3kW31.useIsNavigationLocked)({
        containerId: containerId
    });
    const [isNavigationLoading] = (0, $3kW31.useIsNavigationLoading)({
        containerId: containerId
    });
    const [isNavigationInitialized] = (0, $3kW31.useIsNavigationInitialized)({
        containerId: containerId
    });
    const [navigationViews] = (0, $3kW31.useNavigationViews)({
        containerId: containerId
    });
    const isSidebarFullyExpanded = (0, $kDapy.useIsFullyExpanded)();
    const canManageViews = (0, $hj9Qm.useJpdNavCanManageViews)();
    const canCreateFields = (0, $b6kJl.useCanCreateFields)();
    const isNavigationProjectContainer = (0, $d8n9z.isNavigationProject)(navigationContainer);
    const projectId = isNavigationProjectContainer ? navigationContainer.projectId : undefined;
    const projectKey = isNavigationProjectContainer ? navigationContainer.projectKey : undefined;
    const isViewTemplateButtonVisible = (0, $6c08J.useIsViewTemplateButtonVisible)({
        canCreateFields: canCreateFields,
        canManageViews: canManageViews,
        projectId: projectId,
        projectKey: projectKey
    });
    const isCreateButtonEnabled = canManageViews && !isNavigationLocked;
    const hasFetchedViews = navigationViews.length > 0;
    const isNavigationStable = isNavigationInitialized && !isNavigationLoading && hasFetchedViews;
    const [spotlightTargetNode, setSpotlightTargetNode] = (0, $euxye.useState)(null);
    const isSpotlightDelayEligible = isNavigationStable && Boolean(spotlightTargetNode);
    const { sendCreateViewOnProjectMenuItemAnalyticsEvent: sendCreateViewOnProjectMenuItemAnalyticsEvent } = (0, $hj9Qm.useAnalyticsL2)();
    const handleAnalyticsEvent = (0, $euxye.useCallback)(()=>{
        sendCreateViewOnProjectMenuItemAnalyticsEvent(navigationContainer);
    }, [
        navigationContainer,
        sendCreateViewOnProjectMenuItemAnalyticsEvent
    ]);
    const renderTrigger = (0, $euxye.useCallback)(({ onClick: onClick, ...rest })=>{
        if (!isCreateButtonEnabled) return null;
        const renderIcon = (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ikOED))), {
                ...iconProps,
                size: "small"
            });
        const handleCreateButtonClick = ()=>{
            onClick();
            handleAnalyticsEvent();
        };
        const createButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eO8S8.CommonNavMenuButton), {
            ...rest,
            ref: (0, $fFNvS.mergeRefs)(rest.ref, setSpotlightTargetNode),
            testId: `navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.action-button-create-view.button-${navViewName}`,
            icon: renderIcon,
            label: formatMessage($4621b3b7fb656738$var$createView),
            onClick: handleCreateButtonClick
        });
        const createButtonWithTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
            content: formatMessage($4621b3b7fb656738$var$createView)
        }, createButton);
        if (!isViewTemplateButtonVisible || !isNavigationStable || !isNavigationProjectContainer || !spotlightTargetNode || !isSidebarFullyExpanded) return createButtonWithTooltip;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9zMc9.StartWithTemplateSpotlightWithModal), {
            projectId: navigationContainer.projectId,
            projectKey: navigationContainer.projectKey,
            containerId: sectionId,
            spotlightTargetNode: spotlightTargetNode,
            isDelayEligible: isSpotlightDelayEligible
        }, createButtonWithTooltip);
    }, [
        formatMessage,
        handleAnalyticsEvent,
        isCreateButtonEnabled,
        isNavigationProjectContainer,
        isNavigationStable,
        isSpotlightDelayEligible,
        isSidebarFullyExpanded,
        isViewTemplateButtonVisible,
        navViewName,
        navigationContainer,
        sectionId,
        spotlightTargetNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eQCsj.CreateViewMenu), {
        navigationContainer: navigationContainer,
        container: container,
        sectionId: sectionId,
        renderTrigger: renderTrigger
    });
};
$4621b3b7fb656738$export$f8a8709de891aa53.displayName = "ActionButtonCreateView";

});
parcelRegister("3kW31", function(module, exports) {
$parcel$export(module.exports, "useNavigationViews", () => $decdcd725cc23b50$export$41796e7f9cd51277);
$parcel$export(module.exports, "useIsNavigationLoading", () => $decdcd725cc23b50$export$350bb653e119ede);
$parcel$export(module.exports, "useIsNavigationInitialized", () => $decdcd725cc23b50$export$3738fa7fe94479c1);
$parcel$export(module.exports, "useIsNavigationLocked", () => $decdcd725cc23b50$export$2624374deceb1adb);
$parcel$export(module.exports, "useNavigationView", () => $decdcd725cc23b50$export$79a1c57b92aa82a2);
$parcel$export(module.exports, "useContainerViewsCount", () => $decdcd725cc23b50$export$996fa5996d0909f0);
$parcel$export(module.exports, "useHasReachedViewsLimit", () => $decdcd725cc23b50$export$251d22dfc7cbc52f);
// eslint-disable-next-line jira/filename-case

var $3h1FP = parcelRequire("3h1FP");
var $3K7NP = parcelRequire("3K7NP");

var $aGaXs = parcelRequire("aGaXs");

var $kmMHr = parcelRequire("kmMHr");

var $lqY9M = parcelRequire("lqY9M");
const $decdcd725cc23b50$var$EMPTY_VIEWS = [];
const $decdcd725cc23b50$export$41796e7f9cd51277 = (0, $3h1FP.createHook)((0, $kmMHr.NavigationStore), {
    selector: (0, $3K7NP.createSelector)((state, { containerId: containerId })=>state.containers[containerId], (containerState)=>{
        if (containerState) return containerState.views;
        return $decdcd725cc23b50$var$EMPTY_VIEWS;
    })
});
const $decdcd725cc23b50$export$350bb653e119ede = (0, $3h1FP.createHook)((0, $kmMHr.NavigationStore), {
    selector: (0, $3K7NP.createSelector)((state, { containerId: containerId })=>state.containers[containerId], (containerState)=>containerState?.isLoading || false)
});
const $decdcd725cc23b50$export$3738fa7fe94479c1 = (0, $3h1FP.createHook)((0, $kmMHr.NavigationStore), {
    selector: (0, $3K7NP.createSelector)((state, { containerId: containerId })=>state.containers[containerId], (containerState)=>containerState?.initialized || false)
});
const $decdcd725cc23b50$export$2624374deceb1adb = (0, $3h1FP.createHook)((0, $kmMHr.NavigationStore), {
    selector: (0, $3K7NP.createSelector)((state, { containerId: containerId })=>state.containers[containerId], (containerState)=>containerState?.isLocked || false)
});
const $decdcd725cc23b50$export$79a1c57b92aa82a2 = (0, $3h1FP.createHook)((0, $kmMHr.NavigationStore), {
    selector: (0, $3K7NP.createSelector)((state, { containerId: containerId })=>state.containers[containerId], (_, { localId: localId })=>localId, (containerState, localId)=>(0, $aGaXs.findView)(containerState, localId)?.view || null)
});
const $decdcd725cc23b50$export$996fa5996d0909f0 = (0, $3h1FP.createStateHook)((0, $kmMHr.NavigationStore), {
    selector: (0, $lqY9M.getContainerViewsCount)
});
const $decdcd725cc23b50$export$251d22dfc7cbc52f = (0, $3h1FP.createStateHook)((0, $kmMHr.NavigationStore), {
    selector: (0, $lqY9M.getHasReachedLimit)
});

});
parcelRegister("lqY9M", function(module, exports) {
$parcel$export(module.exports, "getContainerViewsCount", () => $7995b4a38691bfbb$export$6ef5536c839ccedf);
$parcel$export(module.exports, "getHasReachedLimit", () => $7995b4a38691bfbb$export$48fa0990bdf5dea5);
/* eslint-disable jira/filename-case */ 
var $83clE = parcelRequire("83clE");

var $dH1Sa = parcelRequire("dH1Sa");

var $hfv9m = parcelRequire("hfv9m");

var $7SOt3 = parcelRequire("7SOt3");

var $3K7NP = parcelRequire("3K7NP");
const $7995b4a38691bfbb$export$cb3b1a64aebe85bd = (state, props)=>{
    if (!props.entityLimitType) return null;
    return state.entityLimits[props.entityLimitType] ?? null;
};
// Select views for a specific project
const $7995b4a38691bfbb$var$getContainerViews = (state, props)=>state.containers[props.containerId].views;
const $7995b4a38691bfbb$export$6ef5536c839ccedf = (0, $3K7NP.createSelector)($7995b4a38691bfbb$var$getContainerViews, (containerViews)=>{
    const countViewsRecursive = (view)=>{
        if (view.viewType !== (0, $dH1Sa.VIEW_KIND_SECTION)) return 1;
        return (0, (/*@__PURE__*/$parcel$interopDefault($83clE)))(view?.views?.map((v)=>countViewsRecursive(v)));
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($83clE)))(containerViews.map((v)=>countViewsRecursive(v)));
});
const $7995b4a38691bfbb$export$dd2657465609b6ce = (0, $3K7NP.createSelector)($7995b4a38691bfbb$var$getContainerViews, (containerViews)=>{
    const countViewSetsRecursive = (view)=>{
        if (view.viewType === (0, $dH1Sa.VIEW_KIND_SECTION)) return 1 + (0, (/*@__PURE__*/$parcel$interopDefault($83clE)))(view?.views?.map((v)=>countViewSetsRecursive(v)));
        return 0;
    };
    // 1 for the root view set
    return 1 + (0, (/*@__PURE__*/$parcel$interopDefault($83clE)))(containerViews.map((v)=>countViewSetsRecursive(v)));
});
const $7995b4a38691bfbb$export$48fa0990bdf5dea5 = (0, $3K7NP.createSelector)((_, props)=>props, $7995b4a38691bfbb$export$cb3b1a64aebe85bd, $7995b4a38691bfbb$export$6ef5536c839ccedf, $7995b4a38691bfbb$export$dd2657465609b6ce, ({ entityLimitType: entityLimitType }, limit, viewsCount, viewsetsCount)=>{
    if (!limit) return null;
    switch(entityLimitType){
        case (0, $hfv9m.ENTITY_LIMIT_TYPE).VIEWS_PER_PROJECT:
        case (0, $7SOt3.ENTITY_LIMIT_TYPE).VIEWS_PER_COLLECTION:
            if (limit <= viewsCount) return limit;
            return null;
        case (0, $hfv9m.ENTITY_LIMIT_TYPE).VIEWSETS_PER_PROJECT:
        case (0, $7SOt3.ENTITY_LIMIT_TYPE).VIEWSETS_PER_COLLECTION:
            if (limit <= viewsetsCount) return limit;
            return null;
        default:
            return null;
    }
});

});
parcelRegister("83clE", function(module, exports) {

var $aqyvE = parcelRequire("aqyvE");

var $eSVkV = parcelRequire("eSVkV");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $5dc82ea22d6058dc$var$sum(array) {
    return array && array.length ? $aqyvE(array, $eSVkV) : 0;
}
module.exports = $5dc82ea22d6058dc$var$sum;

});
parcelRegister("aqyvE", function(module, exports) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $797719f871ba91ea$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = $797719f871ba91ea$var$baseSum;

});




parcelRegister("b6kJl", function(module, exports) {
$parcel$export(module.exports, "useCanCreateFields", () => $66d75c3ba171cfbc$export$ef0010943ad667dc);

var $d2cz6 = parcelRequire("d2cz6");

var $lCOqC = parcelRequire("lCOqC");
const $66d75c3ba171cfbc$export$ef0010943ad667dc = (options)=>{
    const canEditFields = (0, $lCOqC.useCanEditFields)(options);
    // TODO: isCollectionView is already checked inside useCanEditFields
    // consider optimizing the check into => !isCollectionView && hasAccess
    const [isCollectionView] = (0, $d2cz6.useIsCollectionView)();
    return canEditFields && !isCollectionView;
};

});
parcelRegister("d2cz6", function(module, exports) {
$parcel$export(module.exports, "useIsCollectionView", () => $064aa520252fc039$export$653454b45dadb2a8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");

var $k4bFc = parcelRequire("k4bFc");
const $064aa520252fc039$export$653454b45dadb2a8 = (0, $3h1FP.createHook)((0, $k4bFc.PermissionsStore), {
    selector: (state)=>state.meta.loadingProps?.isCollectionView || false
});

});

parcelRegister("lCOqC", function(module, exports) {
$parcel$export(module.exports, "useCanEditFields", () => $f15b9653922f855f$export$2d6cbb21e503a5a2);

var $floGU = parcelRequire("floGU");

var $d2cz6 = parcelRequire("d2cz6");

var $koaaE = parcelRequire("koaaE");

var $29zgU = parcelRequire("29zgU");
const $f15b9653922f855f$export$2d6cbb21e503a5a2 = (options)=>{
    const hasAccess = (0, $29zgU.useHasPermissionsWithSiteAdmin)({
        permissionKeys: [
            'ADMINISTER_PROJECTS',
            'EDIT_ISSUE_LAYOUT'
        ],
        allowedForSiteAdmin: false,
        projectIds: options?.projectId ? [
            options.projectId
        ] : undefined
    });
    const [isCollectionView] = (0, $d2cz6.useIsCollectionView)();
    const collectionUUID = (0, $floGU.useEnvironmentContainer)()?.id ?? '';
    const canEditCollection = (0, $koaaE.useCanEditCollection)({
        collectionUUID: collectionUUID
    });
    return isCollectionView ? canEditCollection : hasAccess;
};

});
parcelRegister("floGU", function(module, exports) {
$parcel$export(module.exports, "useActions", () => $90f527307ff06340$export$bc923229a7fa61e7);
$parcel$export(module.exports, "useEnvironmentContainer", () => $90f527307ff06340$export$e56db71314b509dc);
$parcel$export(module.exports, "useEnvironmentContainerId", () => $90f527307ff06340$export$344f61c54a71a2e2);
$parcel$export(module.exports, "useHasEnvironmentContainerError", () => $90f527307ff06340$export$63896abf8138b626);
$parcel$export(module.exports, "useIsEnvironmentContainerAvailable", () => $90f527307ff06340$export$a3cb3b3ca4401bed);

var $6fsuc = parcelRequire("6fsuc");

var $3h1FP = parcelRequire("3h1FP");
var $dB6ay = parcelRequire("dB6ay");
var $5QDqc = parcelRequire("5QDqc");

var $kt86l = parcelRequire("kt86l");

var $4CDCc = parcelRequire("4CDCc");
const $90f527307ff06340$var$initialState = {
    loading: true,
    data: undefined,
    error: undefined
};
const $90f527307ff06340$var$Store = (0, $5QDqc.createStore)({
    initialState: $90f527307ff06340$var$initialState,
    actions: {
        setLoading: (loading)=>({ setState: setState })=>{
                setState({
                    loading: loading
                });
            },
        setError: (error)=>({ setState: setState })=>{
                setState({
                    error: error
                });
            },
        setData: (data)=>({ setState: setState })=>{
                setState({
                    data: data
                });
            },
        setProjectIdForView: (projectId)=>({ setState: setState, getState: getState })=>{
                const data = getState().data;
                if (data?.type === (0, $4CDCc.PolarisEnvironmentContainerTypes).VIEW) setState({
                    data: {
                        ...data,
                        projectId: projectId
                    }
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState($90f527307ff06340$var$initialState);
            }
    },
    name: 'jpd-environment-datacontainer'
});
const $90f527307ff06340$var$onPropsChange = ({ setState: setState }, { projectAri: projectAri, projectId: projectId, projectKey: projectKey })=>{
    setState({
        loading: false,
        data: {
            id: projectId,
            type: (0, $4CDCc.PolarisEnvironmentContainerTypes).PROJECT,
            projectId: projectId,
            projectKey: projectKey,
            projectAri: projectAri
        }
    });
};
const $90f527307ff06340$export$a1a9ff2a0620169 = (0, $dB6ay.createContainer)($90f527307ff06340$var$Store, {
    onInit: ()=>$90f527307ff06340$var$onPropsChange,
    onUpdate: ()=>$90f527307ff06340$var$onPropsChange
});
const $90f527307ff06340$export$bc923229a7fa61e7 = (0, $3h1FP.createActionsHook)($90f527307ff06340$var$Store);
const $90f527307ff06340$export$e56db71314b509dc = (0, $3h1FP.createStateHook)($90f527307ff06340$var$Store, {
    selector: (state)=>state.data
});
const $90f527307ff06340$export$344f61c54a71a2e2 = (0, $3h1FP.createStateHook)($90f527307ff06340$var$Store, {
    selector: (state)=>state.data?.id
});
const $90f527307ff06340$export$fa482684d80284db = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const container = $90f527307ff06340$export$e56db71314b509dc();
    const createARI = (resourceType, resourceId)=>(0, $6fsuc.AnyAri).create({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: resourceType,
            resourceId: resourceId
        }).toString();
    switch(container?.type){
        case (0, $4CDCc.PolarisEnvironmentContainerTypes).PROJECT:
            return container.projectAri.toString();
        case (0, $4CDCc.PolarisEnvironmentContainerTypes).COLLECTION:
            return createARI('collection', container.collectionId);
        case (0, $4CDCc.PolarisEnvironmentContainerTypes).VIEW:
            return createARI('view', container.viewId);
        default:
            return '';
    }
};
const $90f527307ff06340$export$63896abf8138b626 = (0, $3h1FP.createStateHook)($90f527307ff06340$var$Store, {
    selector: (state)=>!state.loading && (state.error || !state.data)
});
const $90f527307ff06340$export$a3cb3b3ca4401bed = (0, $3h1FP.createStateHook)($90f527307ff06340$var$Store, {
    selector: (state, containerType)=>{
        if (containerType) return !state.loading && state.data !== undefined && state.data.type === containerType;
        return !state.loading && state.data !== undefined;
    }
});

});
parcelRegister("4CDCc", function(module, exports) {
$parcel$export(module.exports, "PolarisEnvironmentContainerTypes", () => $3067ccad94c4799a$export$11730091c497ed31);
/* eslint-disable jira/filename-case */ const $3067ccad94c4799a$export$11730091c497ed31 = {
    PROJECT: 'PROJECT',
    VIEW: 'VIEW',
    COLLECTION: 'COLLECTION'
};

});


parcelRegister("koaaE", function(module, exports) {
$parcel$export(module.exports, "useCanPinIssueViewFields", () => $5c972a10415d6073$export$17d39d3d630c7ed1);
$parcel$export(module.exports, "useCanAddAndEditOwnViewComments", () => $5c972a10415d6073$export$d842e8e4bab4e52d);
$parcel$export(module.exports, "useCanEditAllViewComments", () => $5c972a10415d6073$export$5b4a6780ac980719);
$parcel$export(module.exports, "useManageViewPermissions", () => $5c972a10415d6073$export$43c3dc7abe11a490);
$parcel$export(module.exports, "useCanEditCollection", () => $5c972a10415d6073$export$19cfc4d4f1ca4b85);
$parcel$export(module.exports, "useLoadCollectionPermissions", () => $5c972a10415d6073$export$7be30a3447ae6adb);
$parcel$export(module.exports, "useCanManageViews", () => $5c972a10415d6073$export$671c343d594862f4);
$parcel$export(module.exports, "useCanPublishDiscoveryViews", () => $5c972a10415d6073$export$e93f6fd530d6f221);
$parcel$export(module.exports, "useCanPublishPublicDiscoveryViews", () => $5c972a10415d6073$export$635260dd9ed50586);
$parcel$export(module.exports, "useCanExportViews", () => $5c972a10415d6073$export$d7533939148bccb9);

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $floGU = parcelRequire("floGU");

var $dV3gw = parcelRequire("dV3gw");

var $i860n = parcelRequire("i860n");

var $1KydW = parcelRequire("1KydW");

var $3h1FP = parcelRequire("3h1FP");

var $k4bFc = parcelRequire("k4bFc");

var $kU8zi = parcelRequire("kU8zi");

var $d2cz6 = parcelRequire("d2cz6");
const $5c972a10415d6073$var$useIsGlobalViewSettings = (0, $3h1FP.createHook)((0, $k4bFc.PermissionsStore), {
    selector: (state)=>state.meta.loadingProps?.isGlobalViewSettings || false
});
const $5c972a10415d6073$var$useHasManageViewsPermission = (0, $kU8zi.createPermissionHook)('MANAGE_DISCOVERY_VIEWS');
const $5c972a10415d6073$var$useHasPublishDiscoveryViewsPermission = (0, $kU8zi.createPermissionHook)('PUBLISH_DISCOVERY_VIEWS');
const $5c972a10415d6073$var$useHasPublishPublicDiscoveryViewsPermission = (0, $kU8zi.createPermissionHook)('PUBLISH_PUBLIC_DISCOVERY_VIEWS');
const $5c972a10415d6073$var$useHasExportViewsPermission = (0, $kU8zi.createPermissionHook)('SHARE_DISCOVERY_VIEWS');
const $5c972a10415d6073$var$useHasCreateViewCommentsPermission = (0, $kU8zi.createPermissionHook)('CREATE_DISCOVERY_VIEW_COMMENTS');
const $5c972a10415d6073$var$useHasManageViewCommentsPermission = (0, $kU8zi.createPermissionHook)('MANAGE_DISCOVERY_VIEW_COMMENTS');
const $5c972a10415d6073$var$useHasPinIssueViewFieldsPermission = (0, $kU8zi.createPermissionHook)('PIN_DISCOVERY_ISSUE_VIEW_FIELDS');
const $5c972a10415d6073$export$17d39d3d630c7ed1 = (options)=>{
    const [hasPinIsssueViewFieldsPermission] = $5c972a10415d6073$var$useHasPinIssueViewFieldsPermission(options);
    const [isCollectionView] = (0, $d2cz6.useIsCollectionView)();
    return !isCollectionView && hasPinIsssueViewFieldsPermission;
};
const $5c972a10415d6073$export$d842e8e4bab4e52d = (options)=>{
    const [hasCreateViewComments] = $5c972a10415d6073$var$useHasCreateViewCommentsPermission(options);
    return hasCreateViewComments;
};
const $5c972a10415d6073$export$5b4a6780ac980719 = (options)=>{
    const [hasManageViewCommentsPermission] = $5c972a10415d6073$var$useHasManageViewCommentsPermission(options);
    return hasManageViewCommentsPermission;
};
const $5c972a10415d6073$export$43c3dc7abe11a490 = (containerId, options)=>{
    const isViewPermissionsEnabled = (0, $dV3gw.useIsViewPermissionsEnabled)();
    const [canManageViews] = $5c972a10415d6073$var$useHasManageViewsPermission(options);
    const { loadViewPermissionsForCurrentUser: loadViewPermissionsForCurrentUser } = (0, $k4bFc.usePermissionActions)();
    const [state] = (0, $k4bFc.usePermissions)();
    if (!isViewPermissionsEnabled) return {
        canManageView: canManageViews,
        canManageViews: canManageViews,
        canSeeView: true,
        loadViewPermissionsForCurrentUser: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
    };
    if (!containerId) return {
        canManageView: false,
        canManageViews: canManageViews,
        canSeeView: true,
        loadViewPermissionsForCurrentUser: loadViewPermissionsForCurrentUser
    };
    const permissionsForThisView = state.viewPermissions[containerId];
    const canManageView = canManageViews && Boolean(permissionsForThisView?.data?.canEdit);
    return {
        canManageView: canManageView,
        canManageViews: canManageViews,
        canSeeView: permissionsForThisView?.loading || permissionsForThisView?.data === undefined || Boolean(permissionsForThisView?.data.canView),
        viewAccessLevel: permissionsForThisView?.data?.accessLevel,
        loadViewPermissionsForCurrentUser: loadViewPermissionsForCurrentUser
    };
};
const $5c972a10415d6073$export$19cfc4d4f1ca4b85 = ({ collectionUUID: collectionUUID })=>{
    const { hasProductDiscoveryAccess: isLicensedUser } = (0, $1KydW.useApplicationPermissions)() ?? {};
    const { canManageView: canManageView } = $5c972a10415d6073$export$43c3dc7abe11a490(collectionUUID);
    return isLicensedUser && canManageView;
};
const $5c972a10415d6073$export$7be30a3447ae6adb = (collectionUUID)=>{
    const { loadViewPermissionsForCurrentUser: loadViewPermissionsForCurrentUser } = $5c972a10415d6073$export$43c3dc7abe11a490(collectionUUID);
    return (0, $euxye.useCallback)(()=>{
        if (collectionUUID) return loadViewPermissionsForCurrentUser(collectionUUID);
    }, [
        collectionUUID,
        loadViewPermissionsForCurrentUser
    ]);
};
const $5c972a10415d6073$export$671c343d594862f4 = (options)=>{
    const [hasManageViewsPermission] = $5c972a10415d6073$var$useHasManageViewsPermission(options);
    const [isCollectionView] = (0, $d2cz6.useIsCollectionView)();
    const [isGlobalViewSettings] = $5c972a10415d6073$var$useIsGlobalViewSettings();
    return hasManageViewsPermission || // temporarily give everyone manageViews permissions in a collection view
    // TODO: https://pi-dev-sandbox.atlassian.net/browse/POL-17942
    isCollectionView || // On global view settings, there's no view level permissions:
    // all users who can access the global view settings, can create and edit global views
    isGlobalViewSettings && (0, $i860n.fg)('polaris_global_views');
};
const $5c972a10415d6073$export$e93f6fd530d6f221 = (options)=>$5c972a10415d6073$var$useHasPublishDiscoveryViewsPermission(options)[0];
const $5c972a10415d6073$export$635260dd9ed50586 = (options)=>$5c972a10415d6073$var$useHasPublishPublicDiscoveryViewsPermission(options)[0];
const $5c972a10415d6073$export$d7533939148bccb9 = (options)=>{
    const [hasExportViewsPermission] = $5c972a10415d6073$var$useHasExportViewsPermission(options);
    const collectionId = (0, $floGU.useEnvironmentContainer)()?.id ?? '';
    const [isCollectionView] = (0, $d2cz6.useIsCollectionView)();
    const canEditCollection = $5c972a10415d6073$export$19cfc4d4f1ca4b85({
        collectionUUID: collectionId
    });
    return isCollectionView && canEditCollection || hasExportViewsPermission;
};

});
parcelRegister("kU8zi", function(module, exports) {
$parcel$export(module.exports, "createPermissionHook", () => $43c751d02fe8c8f0$export$11712979784fd979);

var $fsyzS = parcelRequire("fsyzS");
const $43c751d02fe8c8f0$export$11712979784fd979 = (permissionKey)=>(options)=>{
        const definedOptions = options ?? {};
        const projectIdInArray = 'projectId' in definedOptions && definedOptions.projectId ? [
            definedOptions.projectId
        ] : undefined;
        const projectIds = 'projectIds' in definedOptions && definedOptions.projectIds ? definedOptions.projectIds : undefined;
        const projectMatch = 'anyProject' in definedOptions && definedOptions.anyProject === true ? 'any' : 'all';
        const result = (0, $fsyzS.useHasPermissions)({
            permissionKeys: [
                permissionKey
            ],
            projectIds: projectIdInArray ?? projectIds,
            projectMatch: projectMatch
        });
        return [
            result
        ];
    };

});
parcelRegister("fsyzS", function(module, exports) {
$parcel$export(module.exports, "selectHasPermissions", () => $de92d6493cdbbc2b$export$c24a60021fe83789);
$parcel$export(module.exports, "useHasPermissions", () => $de92d6493cdbbc2b$export$4700d39b99877d57);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3K7NP = parcelRequire("3K7NP");
var $3h1FP = parcelRequire("3h1FP");

var $k4bFc = parcelRequire("k4bFc");
/**
 * Configuration for permission behavior in different environment contexts
 */ const $de92d6493cdbbc2b$var$PERMISSION_CONTEXT_CONFIG = {
    CREATE_ISSUES: {
        forbiddenInCollectionView: true
    },
    ADMINISTER_PROJECTS: {
        forbiddenInCollectionView: true
    },
    ADD_COMMENTS: {
        availableInSharedView: true
    },
    EDIT_OWN_COMMENTS: {
        availableInSharedView: true
    },
    MANAGE_DISCOVERY_VIEWS: {
        alwaysGrantedInCollectionView: true
    }
};
const $de92d6493cdbbc2b$var$getPermissionConfig = (permissionKey)=>{
    return $de92d6493cdbbc2b$var$PERMISSION_CONTEXT_CONFIG[permissionKey] ?? {};
};
const $de92d6493cdbbc2b$var$isAlwaysGrantedPermission = ({ isCollectionView: isCollectionView, permissionKey: permissionKey })=>{
    const config = $de92d6493cdbbc2b$var$getPermissionConfig(permissionKey);
    if (isCollectionView && 'alwaysGrantedInCollectionView' in config && config.alwaysGrantedInCollectionView) return true;
};
const $de92d6493cdbbc2b$var$selectViewContext = (state)=>{
    const { isEmbeddedView: isEmbeddedView = false, isSharedView: isSharedView = false, isCollectionView: isCollectionView = false } = state.meta.loadingProps ?? {};
    return {
        isEmbeddedView: isEmbeddedView,
        isSharedView: isSharedView,
        isCollectionView: isCollectionView
    };
};
const $de92d6493cdbbc2b$var$selectPermissionsToCheck = (state, props)=>{
    const { projectIds: projectIds, permissionKeys: permissionKeys } = props;
    const { isCollectionView: isCollectionView = false } = state.meta.loadingProps ?? {};
    // Use contributor permissions for preview mode
    if (state.isPreviewContributorMode) return [
        state.contributorPermissions
    ];
    const permissions = projectIds ? projectIds.map((projectId)=>state.permissionsByProjectId[projectId] ?? []) : Object.values(state.permissionsByProjectId);
    if (permissions.flat().length > 0) return permissions;
    // No permissions in store: check for always-granted permissions in collection view
    if (isCollectionView) {
        const alwaysGrantedPermissions = permissionKeys.filter((permissionKey)=>$de92d6493cdbbc2b$var$isAlwaysGrantedPermission({
                permissionKey: permissionKey,
                isCollectionView: isCollectionView
            })).map((key)=>({
                key: key,
                havePermission: true
            }));
        return [
            alwaysGrantedPermissions
        ];
    }
    return [];
};
const $de92d6493cdbbc2b$var$isPermissionGranted = ({ isCollectionView: isCollectionView, isSharedView: isSharedView, permissionKey: permissionKey, grantedKeys: grantedKeys })=>{
    const config = $de92d6493cdbbc2b$var$getPermissionConfig(permissionKey);
    if ($de92d6493cdbbc2b$var$isAlwaysGrantedPermission({
        permissionKey: permissionKey,
        isCollectionView: isCollectionView
    })) return true;
    // Forbidden in collection view
    if (isCollectionView && 'forbiddenInCollectionView' in config && config.forbiddenInCollectionView) return false;
    // Not available in shared view
    if (isSharedView && !('availableInSharedView' in config && config.availableInSharedView)) return false;
    // Check actual permission
    return grantedKeys.has(permissionKey);
};
const $de92d6493cdbbc2b$export$c24a60021fe83789 = (0, $3K7NP.createSelector)($de92d6493cdbbc2b$var$selectViewContext, $de92d6493cdbbc2b$var$selectPermissionsToCheck, (_, props)=>props, (viewContext, allPermissions, { permissionKeys: permissionKeys = [], permissionsMatch: permissionsMatch = 'any', projectMatch: projectMatch = 'all' })=>{
    const { isEmbeddedView: isEmbeddedView, isSharedView: isSharedView, isCollectionView: isCollectionView } = viewContext;
    // Global check: embedded views have no permissions or no permissions to check
    if (isEmbeddedView || !allPermissions.flat().length) return false;
    const projectMatchMethod = projectMatch === 'any' ? 'some' : 'every';
    const permissionMatchMethod = permissionsMatch === 'any' ? 'some' : 'every';
    // Check permissions for each project according to projectMatch strategy
    return allPermissions[projectMatchMethod]((permissions)=>{
        // Build set of granted permission keys
        const grantedKeys = permissions.reduce((acc, permission)=>{
            if (permission.havePermission === true) acc.add(permission.key);
            return acc;
        }, new Set());
        // Check each permission key with context-aware logic
        return permissionKeys[permissionMatchMethod]((permissionKey)=>$de92d6493cdbbc2b$var$isPermissionGranted({
                isCollectionView: isCollectionView,
                isSharedView: isSharedView,
                permissionKey: permissionKey,
                grantedKeys: grantedKeys
            }));
    });
});
const $de92d6493cdbbc2b$export$4700d39b99877d57 = (0, $3h1FP.createStateHook)((0, $k4bFc.PermissionsStore), {
    selector: $de92d6493cdbbc2b$export$c24a60021fe83789
});

});



parcelRegister("29zgU", function(module, exports) {
$parcel$export(module.exports, "useHasPermissionsWithSiteAdmin", () => $05d7d18677128245$export$f73dd991588fabed);

var $3NopQ = parcelRequire("3NopQ");

var $fsyzS = parcelRequire("fsyzS");
const $05d7d18677128245$export$f73dd991588fabed = ({ allowedForSiteAdmin: allowedForSiteAdmin = false, ...payload })=>{
    const hasPermissions = (0, $fsyzS.useHasPermissions)(payload);
    const isJiraAdmin = (0, $3NopQ.useIsAdmin)();
    const isVortexOrgAdminOrNonVortexSiteAdmin = (0, $3NopQ.useIsJiraAdminWithContributorMode)();
    return allowedForSiteAdmin ? isJiraAdmin || isVortexOrgAdminOrNonVortexSiteAdmin || hasPermissions : hasPermissions;
};

});
parcelRegister("3NopQ", function(module, exports) {
$parcel$export(module.exports, "useIsAdmin", () => $033e088527f667da$export$99a5e4bc80d231ca);
$parcel$export(module.exports, "useIsJiraAdminWithContributorMode", () => $033e088527f667da$export$2df934cc453bd6ba);
$parcel$export(module.exports, "useCanManageGlobalFields", () => $033e088527f667da$export$e9176fd48d7ee24e);

var $fNgVF = parcelRequire("fNgVF");

var $bs9jJ = parcelRequire("bs9jJ");

var $3h1FP = parcelRequire("3h1FP");

var $k4bFc = parcelRequire("k4bFc");

var $kU8zi = parcelRequire("kU8zi");

var $i860n = parcelRequire("i860n");

var $6ZLJT = parcelRequire("6ZLJT");
/**
 * @deprecated use src/packages/polaris/component-permissions-store/src/controllers/permissions/hooks/useIsPreviewContributorMode.tsx
 */ const $033e088527f667da$var$useIsInContributorPreviewMode = (0, $3h1FP.createHook)((0, $k4bFc.PermissionsStore), {
    selector: (state)=>state.isPreviewContributorMode
});
const $033e088527f667da$var$useIsSiteAdminOld = ()=>{
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    const [isInContributorPreviewMode] = $033e088527f667da$var$useIsInContributorPreviewMode();
    return isSiteAdmin && !isInContributorPreviewMode;
};
const $033e088527f667da$export$99a5e4bc80d231ca = ()=>{
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const [isInContributorPreviewMode] = $033e088527f667da$var$useIsInContributorPreviewMode();
    return isAdmin && !isInContributorPreviewMode;
};
const $033e088527f667da$export$2df934cc453bd6ba = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jpd_polaris_vortex_admin_migration'), $033e088527f667da$export$99a5e4bc80d231ca, $033e088527f667da$var$useIsSiteAdminOld);
const $033e088527f667da$export$e9176fd48d7ee24e = ()=>{
    const isAdmin = $033e088527f667da$export$99a5e4bc80d231ca();
    return isAdmin;
};
const $033e088527f667da$var$useCanCreateProjectPermission = (0, $kU8zi.createPermissionHook)('CREATE_PROJECT');
const $033e088527f667da$export$5a5bc150b9925cee = ()=>{
    const [canCreateProject] = $033e088527f667da$var$useCanCreateProjectPermission({});
    return canCreateProject;
};

});




parcelRegister("9zMc9", function(module, exports) {
$parcel$export(module.exports, "StartWithTemplateSpotlightWithModal", () => $9494ee8c303df76b$export$e7905ff7edb64b60);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $cocXm = parcelRequire("cocXm");

var $6mEZn = parcelRequire("6mEZn");

var $fFNvS = parcelRequire("fFNvS");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $nh8uJ = parcelRequire("nh8uJ");
const $9494ee8c303df76b$var$hiddenModalTriggerLabel = (0, $7eNDO.defineMessage)({
    id: "component-view-template-library.start-with-template-spotlight-with-modal.hidden-modal-trigger-label",
    defaultMessage: "Open template library"
});
const $9494ee8c303df76b$export$e7905ff7edb64b60 = (t0)=>{
    const $ = (0, $e7boj.c)(17);
    const { children: children, projectId: projectId, projectKey: projectKey, containerId: containerId, spotlightTargetNode: spotlightTargetNode, isDelayEligible: isDelayEligible } = t0;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const triggerRef = (0, $euxye.useRef)(null);
    let t1;
    if ($[0] !== createAnalyticsEvent) {
        t1 = ()=>{
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
                action: "clicked",
                actionSubject: "button"
            }), "button clicked", "openViewTemplateLibrary");
            triggerRef.current?.click();
        };
        $[0] = createAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const handleTryItNow = t1;
    let t2;
    if ($[2] !== formatMessage) {
        t2 = (t3)=>{
            const { ref: ref } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6mEZn.Pressable), {
                hidden: true,
                ref: (0, $fFNvS.mergeRefs)(triggerRef, ref)
            }, formatMessage($9494ee8c303df76b$var$hiddenModalTriggerLabel));
        };
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== containerId || $[5] !== projectId || $[6] !== projectKey || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $nh8uJ.ModalEntryPointTrigger), {
            projectId: projectId,
            projectKey: projectKey,
            containerId: containerId
        }, t2);
        $[4] = containerId;
        $[5] = projectId;
        $[6] = projectKey;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== children || $[10] !== handleTryItNow || $[11] !== isDelayEligible || $[12] !== spotlightTargetNode) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cocXm.StartWithTemplateSpotlight), {
            onTryItNow: handleTryItNow,
            spotlightTargetNode: spotlightTargetNode,
            isDelayEligible: isDelayEligible
        }, children);
        $[9] = children;
        $[10] = handleTryItNow;
        $[11] = isDelayEligible;
        $[12] = spotlightTargetNode;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== t3 || $[15] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, t3, t4);
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
};
$9494ee8c303df76b$export$e7905ff7edb64b60.displayName = "StartWithTemplateSpotlightWithModal";

});
parcelRegister("cocXm", function(module, exports) {
$parcel$export(module.exports, "StartWithTemplateSpotlight", () => $e8249c0e40773024$export$3c1f4447a51c3f1d);

var $euxye = parcelRequire("euxye");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $hYI7R = parcelRequire("hYI7R");

var $2mMhC = parcelRequire("2mMhC");

var $4nYkO = parcelRequire("4nYkO");

var $eYbIq = parcelRequire("eYbIq");

var $gvtNj = parcelRequire("gvtNj");

var $ZQYug = parcelRequire("ZQYug");

var $cCkCp = parcelRequire("cCkCp");

var $bKvDL = parcelRequire("bKvDL");

var $cTqdV = parcelRequire("cTqdV");

var $gA92M = parcelRequire("gA92M");
const $e8249c0e40773024$var$spotlightHeading = (0, $7eNDO.defineMessage)({
    id: "polaris.lib-onboarding-flows.start-with-template-spotlight.heading",
    defaultMessage: "Start with a template"
});
const $e8249c0e40773024$var$spotlightDescription = (0, $7eNDO.defineMessage)({
    id: "polaris.lib-onboarding-flows.start-with-template-spotlight.description",
    defaultMessage: "Create a view based on popular prioritization frameworks."
});
const $e8249c0e40773024$var$spotlightTryItNowButton = (0, $7eNDO.defineMessage)({
    id: "polaris.lib-onboarding-flows.start-with-template-spotlight.try-it-now",
    defaultMessage: "Try it now"
});
const $e8249c0e40773024$var$DISMISS_CLICK_IDENTIFIER_BY_ACTION = {
    tryItNow: 'try-it-now',
    dismiss: 'dismiss',
    close: 'close'
};
const $e8249c0e40773024$var$PO_START_WITH_TEMPLATE_SPOTLIGHT_DELAY_MS = 3000;
const $e8249c0e40773024$export$3c1f4447a51c3f1d = ({ children: children, onTryItNow: onTryItNow, spotlightTargetNode: spotlightTargetNode, isDelayEligible: isDelayEligible = true })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { loadProductUsageStartTimestamp: loadProductUsageStartTimestamp } = (0, $gvtNj.useOnboardingFlowsActions)();
    const productUsageStartTimestamp = (0, $ZQYug.useProductUsageStartTimestamp)();
    const { isPoMessageVisible: isPoMessageVisible, dismiss: dismiss, renderJiraSpotlight: renderJiraSpotlight } = (0, $bKvDL.usePolarisHeadlessSpotlightMessage)({
        placementId: (0, $cCkCp.PO_HEADLESS_PLACEMENT_ID),
        messageTemplateId: (0, $cCkCp.PO_HEADLESS_MESSAGE_TEMPLATE_ID),
        featureId: (0, $cCkCp.OnboardingSpotlightFeatureIds).START_WITH_TEMPLATE,
        clickIdentifiers: {
            dismiss: 'close',
            primary: 'try-it-now'
        }
    });
    (0, $hYI7R.useEffectWithoutConcurrency)(()=>{
        loadProductUsageStartTimestamp();
    }, [
        loadProductUsageStartTimestamp
    ]);
    const isNewCustomer = Boolean(productUsageStartTimestamp) && !(0, $cTqdV.checkIfOlderThanNDays)(productUsageStartTimestamp, 7);
    const isSpotlightEligible = isDelayEligible && isNewCustomer && isPoMessageVisible;
    const isSpotlightVisible = (0, $4nYkO.useDelayedEligibility)({
        isEligible: isSpotlightEligible,
        delayMs: $e8249c0e40773024$var$PO_START_WITH_TEMPLATE_SPOTLIGHT_DELAY_MS
    });
    const dismissSpotlight = (0, $euxye.useCallback)((clickIdentifier)=>{
        dismiss(clickIdentifier === 'try-it-now' ? 'primary' : 'dismiss');
    }, [
        dismiss
    ]);
    const handleTryItNow = (0, $euxye.useCallback)((_event, analyticsEvent)=>{
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'startWithTemplateSpotlightTryItNow');
        dismissSpotlight($e8249c0e40773024$var$DISMISS_CLICK_IDENTIFIER_BY_ACTION.tryItNow);
        onTryItNow?.();
    }, [
        onTryItNow,
        dismissSpotlight
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const onCloseButtonDismiss = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dismissed',
            actionSubject: 'jpdSpotlight'
        }), {
            activeSpotlight: 'startWithTemplateSpotlight'
        });
        dismissSpotlight($e8249c0e40773024$var$DISMISS_CLICK_IDENTIFIER_BY_ACTION.close);
    }, [
        createAnalyticsEvent,
        dismissSpotlight
    ]);
    const actions = (0, $euxye.useMemo)(()=>{
        return [
            {
                onClick: handleTryItNow,
                text: formatMessage($e8249c0e40773024$var$spotlightTryItNowButton),
                ctaType: 'primary',
                testId: 'polaris.lib-onboarding-flows.start-with-template-spotlight.try-it-now-button'
            }
        ];
    }, [
        handleTryItNow,
        formatMessage
    ]);
    if (!isSpotlightVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
    const spotlightContent = renderJiraSpotlight({
        actions: actions,
        dialogPlacement: 'bottom left',
        target: (0, $eYbIq.START_WITH_TEMPLATE_SPOTLIGHT),
        targetNode: spotlightTargetNode ?? undefined,
        heading: formatMessage($e8249c0e40773024$var$spotlightHeading),
        testId: 'lib-onboarding-flows.start-with-template-spotlight',
        image: (0, (/*@__PURE__*/$parcel$interopDefault($2mMhC))),
        shouldWatchTarget: true,
        shouldObserveRootForTarget: true,
        onDismiss: onCloseButtonDismiss,
        children: formatMessage($e8249c0e40773024$var$spotlightDescription),
        fallbackMessageId: (0, $cCkCp.PO_HEADLESS_MESSAGE_TEMPLATE_ID)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gA92M.SpotlightTarget), {
        name: (0, $eYbIq.START_WITH_TEMPLATE_SPOTLIGHT)
    }, children), spotlightContent);
};
$e8249c0e40773024$export$3c1f4447a51c3f1d.displayName = "StartWithTemplateSpotlight";

});
parcelRegister("2mMhC", function(module, exports) {
module.exports = new URL("start-with-template-spotlight.a78106ac.png", import.meta.url).toString();

});

parcelRegister("4nYkO", function(module, exports) {
$parcel$export(module.exports, "useDelayedEligibility", () => $96d7ab412ce0464f$export$b9ebe77b9c85dcdd);

var $euxye = parcelRequire("euxye");
const $96d7ab412ce0464f$export$b9ebe77b9c85dcdd = ({ isEligible: isEligible, delayMs: delayMs })=>{
    const [isDelayElapsed, setIsDelayElapsed] = (0, $euxye.useState)(false);
    (0, $euxye.useEffect)(()=>{
        if (!isEligible || isDelayElapsed) return;
        const timeoutId = globalThis.setTimeout(()=>{
            setIsDelayElapsed(true);
        }, delayMs);
        return ()=>{
            globalThis.clearTimeout(timeoutId);
        };
    }, [
        delayMs,
        isDelayElapsed,
        isEligible
    ]);
    return isEligible && isDelayElapsed;
};

});

parcelRegister("cCkCp", function(module, exports) {
$parcel$export(module.exports, "PO_HEADLESS_PLACEMENT_ID", () => $edf3b6fbe6498347$export$c873eb498bafa725);
$parcel$export(module.exports, "PO_HEADLESS_MESSAGE_TEMPLATE_ID", () => $edf3b6fbe6498347$export$6ecdfc22ef79d350);
$parcel$export(module.exports, "OnboardingSpotlightFeatureIds", () => $edf3b6fbe6498347$export$79425e1e267a0164);
$parcel$export(module.exports, "getDefaultOnboardingSpotlightProps", () => $edf3b6fbe6498347$export$3f363fd8070184eb);
const $edf3b6fbe6498347$export$c873eb498bafa725 = 'headless';
const $edf3b6fbe6498347$export$6ecdfc22ef79d350 = 'jpd-headless-spotlight';
const $edf3b6fbe6498347$export$79425e1e267a0164 = {
    START_WITH_TEMPLATE: 'start-with-template',
    CARD_COVERS: 'card-covers',
    TREE_VIEW_CREATE_MENU: 'tree-view.create-menu',
    CUSTOM_DATES_CUSTOMIZE: 'custom-dates.customize',
    GLOBAL_FIELDS_GO_TO_PROJECT: 'global-fields.go-to-project',
    JPD_NAV_VIEWS: 'jpd-nav-views',
    ROADMAP_VIEW: 'roadmap-view',
    ROADMAP_VIEW_COLUMN_CONFIG: 'roadmap-view.column-config',
    ROADMAP_VIEW_INITIAL_PROMPT: 'roadmap-view.initial-prompt',
    COLLECTIONS_CREATE_ROADMAP: 'collections.create-roadmap',
    UNIFIED_SHARE: 'unified-share'
};
const $edf3b6fbe6498347$export$3f363fd8070184eb = ()=>({
        dialogWidth: 275,
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        messageType: 'engagement',
        isMigrated: true
    });
const $edf3b6fbe6498347$export$2c3f91e7ff5f945f = {};

});

parcelRegister("bKvDL", function(module, exports) {
$parcel$export(module.exports, "usePolarisHeadlessSpotlightMessage", () => $c149cf2618dfaa7c$export$f612534f11646124);
/* eslint-disable jira/choreographer/message-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $f5EyW = parcelRequire("f5EyW");

var $j142y = parcelRequire("j142y");

var $4x0T0 = parcelRequire("4x0T0");

var $lK7pY = parcelRequire("lK7pY");

var $fslfv = parcelRequire("fslfv");

var $8KzDp = parcelRequire("8KzDp");

var $6CfY5 = parcelRequire("6CfY5");

var $fNgVF = parcelRequire("fNgVF");

var $ljbSs = parcelRequire("ljbSs");

var $g5ruf = parcelRequire("g5ruf");

var $cCkCp = parcelRequire("cCkCp");

var $ch3uH = parcelRequire("ch3uH");

var $jVm9O = parcelRequire("jVm9O");
const $c149cf2618dfaa7c$var$DEFAULT_CLICK_IDENTIFIERS = {
    dismiss: 'dismiss',
    primary: 'primary-cta'
};
const $c149cf2618dfaa7c$var$DISMISS_TRACKING_LOG_LOCATION = 'polaris.lib-onboarding-flows.headless-spotlight-message.dismiss-tracking';
const $c149cf2618dfaa7c$var$WARN_LOG_SAMPLE_RATE = 0.02;
const $c149cf2618dfaa7c$var$useMatchByFeatureId = (featureId)=>(0, $euxye.useCallback)(({ matchBuilder: matchBuilder })=>matchBuilder.messageContext((context)=>context?.featureId === featureId), [
        featureId
    ]);
const $c149cf2618dfaa7c$var$useMessageMetadata = (message)=>(0, $euxye.useMemo)(()=>message ? {
            messageTemplateId: message.messageTemplateId,
            featureId: message.context?.featureId,
            // Message type/id can come either at message root or inside context depending on producer.
            messageType: message.messageType ?? message.context?.messageType,
            messageId: message.messageId ?? message.context?.messageId
        } : undefined, [
        message
    ]);
const $c149cf2618dfaa7c$var$useSendDismissTrackingEvent = ({ clickIdentifiers: clickIdentifiers, isInsideMessageLifecycleContext: isInsideMessageLifecycleContext, messageInstanceClicked: messageInstanceClicked, messageInstanceEventClient: messageInstanceEventClient, message: message, messageTemplateId: messageTemplateId, placementId: placementId, postOfficeContext: postOfficeContext, recommendationContext: recommendationContext, additionalMetadataFromFrontend: additionalMetadataFromFrontend })=>{
    const shouldLogSampledWarn = (0, $euxye.useCallback)(()=>Math.random() < $c149cf2618dfaa7c$var$WARN_LOG_SAMPLE_RATE, []);
    const logDismissTrackingFailure = (0, $euxye.useCallback)((source, error)=>{
        if (!shouldLogSampledWarn()) return;
        const logMessage = `Failed to send dismiss tracking event via ${source}`;
        if (error instanceof Error) {
            (0, $6CfY5.default).safeWarnWithoutCustomerData($c149cf2618dfaa7c$var$DISMISS_TRACKING_LOG_LOCATION, logMessage, error);
            return;
        }
        (0, $6CfY5.default).safeWarnWithoutCustomerData($c149cf2618dfaa7c$var$DISMISS_TRACKING_LOG_LOCATION, logMessage);
    }, [
        shouldLogSampledWarn
    ]);
    const buildClickedElement = (0, $euxye.useCallback)((kind)=>({
            clickIdentifier: kind === 'primary' ? clickIdentifiers.primary : clickIdentifiers.dismiss,
            clickedElement: 'button',
            buttonType: kind === 'primary' ? 'primary' : 'secondary'
        }), [
        clickIdentifiers.primary,
        clickIdentifiers.dismiss
    ]);
    return (0, $euxye.useCallback)((kind, currentMessageInstanceId)=>{
        const clickedElement = buildClickedElement(kind);
        if (isInsideMessageLifecycleContext) {
            messageInstanceClicked({
                messageInstanceId: currentMessageInstanceId,
                messageTemplateId: message?.messageTemplateId,
                messageCreationType: message?.messageCreationType,
                messageTriggerId: message?.triggerId,
                messageEventType: 'clicked',
                clickedElement: clickedElement,
                action: {
                    actionType: 'dismiss'
                },
                additionalMetadataFromFrontend: additionalMetadataFromFrontend
            }).catch((error)=>{
                logDismissTrackingFailure('messageInstanceClicked', error);
            });
            return;
        }
        messageInstanceEventClient.sendMessageInstanceEvent({
            messageEventType: 'clicked',
            messageInstanceId: currentMessageInstanceId,
            messageTemplateId: message?.messageTemplateId ?? messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...postOfficeContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? '',
                    itemFeatureSetId: recommendationContext.itemFeatureSetId ?? ''
                }
            },
            messageCreationType: message?.messageCreationType ?? 'implicit',
            messageTriggerId: message?.triggerId ?? '',
            timestamp: Date.now(),
            clickedElement: clickedElement,
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: additionalMetadataFromFrontend
        }).catch((error)=>{
            logDismissTrackingFailure('messageInstanceEventClient', error);
        });
    }, [
        additionalMetadataFromFrontend,
        buildClickedElement,
        isInsideMessageLifecycleContext,
        logDismissTrackingFailure,
        messageInstanceClicked,
        messageInstanceEventClient,
        message?.messageTemplateId,
        message?.messageCreationType,
        message?.triggerId,
        messageTemplateId,
        placementId,
        postOfficeContext,
        recommendationContext.entityId,
        recommendationContext.itemFeatureSetId,
        recommendationContext.sessionId
    ]);
};
const $c149cf2618dfaa7c$var$useSyncLegacyDismiss = ({ legacyDismissed: legacyDismissed, messageInstanceId: messageInstanceId, dismissedIds: dismissedIds, sendDismissTrackingEvent: sendDismissTrackingEvent, dismissMessage: dismissMessage })=>{
    const syncedLegacyDismissMessageInstanceIdRef = (0, $euxye.useRef)(undefined);
    (0, $euxye.useEffect)(()=>{
        if (legacyDismissed === true && messageInstanceId && !dismissedIds.has(messageInstanceId) && syncedLegacyDismissMessageInstanceIdRef.current !== messageInstanceId) {
            sendDismissTrackingEvent('dismiss', messageInstanceId);
            dismissMessage(messageInstanceId);
            syncedLegacyDismissMessageInstanceIdRef.current = messageInstanceId;
        }
    }, [
        legacyDismissed,
        messageInstanceId,
        dismissedIds,
        sendDismissTrackingEvent,
        dismissMessage
    ]);
};
const $c149cf2618dfaa7c$export$f612534f11646124 = ({ placementId: placementId, messageTemplateId: messageTemplateId, featureId: featureId, legacyDismissed: legacyDismissed, clickIdentifiers: clickIdentifiers = $c149cf2618dfaa7c$var$DEFAULT_CLICK_IDENTIFIERS })=>{
    const { messageInstanceClicked: messageInstanceClicked } = (0, $f5EyW.useMessageInstanceEvent)();
    const postOfficeContext = (0, $j142y.usePostOfficeContext)();
    const recommendationContext = (0, $8KzDp.useRecommendationContext)();
    const messageContext = (0, $lK7pY.useMessageContext)();
    const placementContext = (0, $fslfv.usePlacementContext)();
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const premiumFlowResolvedPromise = (0, $ch3uH.usePremiumFlowResolvedPromise)();
    const messageInstanceEventClient = (0, $euxye.useMemo)(()=>new (0, $4x0T0.MessageInstanceEventClient)(), []);
    const [isPremiumFlowResolved, setIsPremiumFlowResolved] = (0, $euxye.useState)(false);
    (0, $euxye.useEffect)(()=>{
        let active = true;
        premiumFlowResolvedPromise.then(()=>{
            if (active) setIsPremiumFlowResolved(true);
        });
        return ()=>{
            active = false;
        };
    }, [
        premiumFlowResolvedPromise
    ]);
    const matchByFeatureId = $c149cf2618dfaa7c$var$useMatchByFeatureId(featureId);
    const { messages: messages, dismissedIds: dismissedIds, dismissMessage: dismissMessage, PostOfficeMessageInstance: PostOfficeMessageInstance, isLoading: isLoading } = (0, $ljbSs.useMessageInstances)({
        placementId: placementId,
        messageTemplateId: messageTemplateId
    }, {
        match: matchByFeatureId
    });
    const message = messages[0];
    const messageInstanceId = message?.messageInstanceId;
    const messageMetadata = $c149cf2618dfaa7c$var$useMessageMetadata(message);
    const isVisibleWhenNoModalOnScreen = (0, $jVm9O.useIsVisibleWhenNoModalOnScreen)();
    const isPoMessageVisible = Boolean(isPremiumFlowResolved && messageInstanceId && !dismissedIds.has(messageInstanceId) && isLoading === false && isVisibleWhenNoModalOnScreen);
    const isInsideMessageLifecycleContext = Boolean(messageContext.messageInstanceId && messageContext.messageTemplateId && placementContext.placementId && messageContext.messageCreationType && messageContext.triggerId);
    const additionalMetadataFromFrontend = (0, $euxye.useMemo)(()=>({
            isSiteAdmin: Boolean(postOfficeContext.isSiteAdmin),
            isAdmin: isAdmin,
            hasAdminRole: isAdmin || Boolean(postOfficeContext.isSiteAdmin)
        }), [
        isAdmin,
        postOfficeContext.isSiteAdmin
    ]);
    const sendDismissTrackingEvent = $c149cf2618dfaa7c$var$useSendDismissTrackingEvent({
        clickIdentifiers: clickIdentifiers,
        isInsideMessageLifecycleContext: isInsideMessageLifecycleContext,
        messageInstanceClicked: messageInstanceClicked,
        messageInstanceEventClient: messageInstanceEventClient,
        message: message,
        messageTemplateId: messageTemplateId,
        placementId: placementId,
        postOfficeContext: postOfficeContext,
        recommendationContext: recommendationContext,
        additionalMetadataFromFrontend: additionalMetadataFromFrontend
    });
    $c149cf2618dfaa7c$var$useSyncLegacyDismiss({
        legacyDismissed: legacyDismissed,
        messageInstanceId: messageInstanceId,
        dismissedIds: dismissedIds,
        sendDismissTrackingEvent: sendDismissTrackingEvent,
        dismissMessage: dismissMessage
    });
    const dismiss = (0, $euxye.useCallback)((kind)=>{
        if (!messageInstanceId) return;
        sendDismissTrackingEvent(kind, messageInstanceId);
        dismissMessage(messageInstanceId);
    }, [
        messageInstanceId,
        sendDismissTrackingEvent,
        dismissMessage
    ]);
    const defaultSpotlightProps = (0, $euxye.useMemo)(()=>(0, $cCkCp.getDefaultOnboardingSpotlightProps)(), []);
    const renderJiraSpotlight = (0, $euxye.useCallback)(({ fallbackMessageId: fallbackMessageId, key: spotlightKey, isVisible: isSpotlightVisible = true, ...spotlightProps })=>{
        if (!isPoMessageVisible || !isSpotlightVisible) return null;
        const spotlight = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g5ruf.JiraSpotlight), {
            key: spotlightKey,
            ...defaultSpotlightProps,
            ...spotlightProps,
            messageId: messageMetadata?.messageTemplateId ?? fallbackMessageId
        });
        if (PostOfficeMessageInstance && messageInstanceId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(PostOfficeMessageInstance, {
            messageInstanceId: messageInstanceId
        }, ()=>spotlight);
        return spotlight;
    }, [
        PostOfficeMessageInstance,
        defaultSpotlightProps,
        isPoMessageVisible,
        messageInstanceId,
        messageMetadata?.messageTemplateId
    ]);
    return {
        isPoMessageVisible: isPoMessageVisible,
        messageInstanceId: messageInstanceId,
        messageMetadata: messageMetadata,
        PostOfficeMessageInstance: PostOfficeMessageInstance,
        dismiss: dismiss,
        renderJiraSpotlight: renderJiraSpotlight
    };
};

});
parcelRegister("ljbSs", function(module, exports) {
$parcel$export(module.exports, "useMessageInstances", () => $f4fe5b007e3a7d89$export$92bc057879827fcf);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $L6ISz = parcelRequire("L6ISz");

var $4szlR = parcelRequire("4szlR");

var $7i1OM = parcelRequire("7i1OM");

var $j9Tmd = parcelRequire("j9Tmd");
const $f4fe5b007e3a7d89$export$92bc057879827fcf = (selector, options)=>{
    const { placementId: placementId = 'headless', messageTemplateId: messageTemplateId } = selector;
    const { match: match, validate: validate, dataSource: dataSource, queryString: queryString } = options ?? {};
    // Store match/validate in refs so inline arrow functions passed by callers don't cause
    // the useMemo to re-run on every render. The latest value is always read inside the memo.
    const matchRef = (0, $euxye.useRef)(match);
    matchRef.current = match;
    const validateRef = (0, $euxye.useRef)(validate);
    validateRef.current = validate;
    const { data: data, dismissedIds: dismissedIds, isLoading: isLoading, error: fetchError, dismissMessage: dismissMessage } = (0, $7i1OM.usePlacementData)(placementId, {
        dataSource: dataSource,
        queryString: queryString
    });
    const { templateMessages: templateMessages, validationError: validationError } = (0, $euxye.useMemo)(()=>{
        if (!data) return {
            templateMessages: [],
            validationError: undefined
        };
        let candidates;
        try {
            const result = matchRef.current ? matchRef.current({
                data: data,
                matchBuilder: (0, $j9Tmd.createMatchBuilder)()
            }) : data.messages ?? [];
            const resolved = (0, $j9Tmd.isMatchBuilder)(result) ? result.match(data) : result;
            candidates = resolved;
        } catch (err) {
            if (err instanceof (0, $j9Tmd.PlacementLocationError)) return {
                templateMessages: [],
                validationError: err
            };
            return {
                templateMessages: [],
                validationError: (0, $j9Tmd.toHookError)(err)
            };
        }
        const templateMatches = candidates.filter((m)=>m.messageTemplateId === messageTemplateId);
        const guard = validateRef.current ?? (0, $j9Tmd.isPlacementMessage);
        let failedCount;
        try {
            failedCount = templateMatches.filter((m)=>!guard(m)).length;
        } catch (err) {
            return {
                templateMessages: [],
                validationError: (0, $j9Tmd.toHookError)(err)
            };
        }
        if (failedCount > 0) return {
            templateMessages: [],
            validationError: new (0, $j9Tmd.PlacementValidationError)({
                placementId: placementId,
                failedCount: failedCount
            })
        };
        return {
            templateMessages: templateMatches,
            validationError: undefined
        };
    }, [
        data,
        messageTemplateId,
        placementId
    ]);
    const messages = (0, $euxye.useMemo)(()=>{
        return templateMessages.filter((m)=>!dismissedIds.has(m.messageInstanceId));
    }, [
        dismissedIds,
        templateMessages
    ]);
    // Build lookup from validated template data (not dismissed-filtered messages)
    // so dismissals and data refreshes don't change PostOfficeMessageInstance identity and remount callers.
    const messageByMessageInstanceId = (0, $euxye.useMemo)(()=>{
        const lookup = {};
        for (const message of templateMessages)lookup[message.messageInstanceId] = message;
        return lookup;
    }, [
        templateMessages
    ]);
    const messageByMessageInstanceIdRef = (0, $euxye.useRef)({});
    messageByMessageInstanceIdRef.current = messageByMessageInstanceId;
    // Single wrapper closed over placementId + messageTemplateId.
    // messageInstanceId is passed per-render by the caller.
    const PostOfficeMessageInstance = (0, $euxye.useMemo)(()=>{
        return (props)=>{
            const message = messageByMessageInstanceIdRef.current[props.messageInstanceId];
            const messageCategory = message?.messageCategory;
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $L6ISz.PostOfficeMessage), {
                placementId: placementId,
                messageTemplateId: messageTemplateId,
                messageCategory: messageCategory,
                ...(0, $4szlR.transformPlacementMessageToMessageLifecycleProps)({
                    message: message
                }),
                ...props
            });
        };
    }, [
        messageTemplateId,
        placementId
    ]);
    return {
        messages: messages,
        PostOfficeMessageInstance: PostOfficeMessageInstance,
        dismissedIds: dismissedIds,
        isLoading: isLoading,
        error: fetchError ?? validationError,
        dismissMessage: dismissMessage
    };
};

});
parcelRegister("L6ISz", function(module, exports) {
$parcel$export(module.exports, "PostOfficeMessage", () => $d4c3b81fe536edde$export$7356a355af87a394);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $lRYAe = parcelRequire("lRYAe");

var $4LDqh = parcelRequire("4LDqh");

var $iMsV9 = parcelRequire("iMsV9");

var $lK7pY = parcelRequire("lK7pY");
var $fslfv = parcelRequire("fslfv");
var $1Ocjm = parcelRequire("1Ocjm");
/**
 * Fires the Post Office "viewed" analytics events on mount.
 *
 * This is a separate inner component so that it only mounts when the choreographer
 * allows the message to render. It fires all three viewed events exactly once:
 *   - messageViewed() (legacy in-app lifecycle endpoint)
 *   - messageInstanceViewed()
 *   - messageInstanceDeliveredSuccessfully()
 *
 * Must be rendered inside a MessageContextProvider and PlacementProvider so that
 * useMessageViewed() can read the required context values.
 */ const $d4c3b81fe536edde$var$ViewedOnMount = ()=>{
    const messageViewed = (0, $1Ocjm.useMessageViewed)();
    (0, $euxye.useEffect)(()=>{
        messageViewed();
    // We intentionally omit deps — this should fire exactly once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
$d4c3b81fe536edde$var$ViewedOnMount.displayName = "ViewedOnMount";
/**
 * Defers evaluation of the children render prop until the message is mounted.
 *
 * This ensures that any side effects in the render prop only execute when the
 * choreographer allows the message to render, not when it is blocked.
 */ const $d4c3b81fe536edde$var$RenderedChildren = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children()
    });
};
$d4c3b81fe536edde$var$RenderedChildren.displayName = "RenderedChildren";
const $d4c3b81fe536edde$var$ChoreographedMessage = ({ children: children, messageId: messageId, useChoreographedRender: useChoreographedRender })=>{
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    return shouldRender ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    }) : null;
};
$d4c3b81fe536edde$var$ChoreographedMessage.displayName = "ChoreographedMessage";
/**
 * Render-time Isolated Cloud gate.
 *
 * Returns `null` when the prop is enabled AND the tenant is in an Isolated Cloud
 * environment. Mirrors the headful behaviour wired by
 * `createBasePlacementComponentV2` (`options.hideInIsolatedCloud`).
 *
 * SSR handling is delegated to `isIsolatedCloud()` itself, which falls back to
 * `globalThis.ssrContext?.isInIC` when `document` is undefined.
 */ const $d4c3b81fe536edde$var$IsolatedCloudGate = ({ children: children, hideInIsolatedCloud: hideInIsolatedCloud })=>{
    if (hideInIsolatedCloud && (0, $lRYAe.isIsolatedCloud)()) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$d4c3b81fe536edde$var$IsolatedCloudGate.displayName = "IsolatedCloudGate";
/**
 * Choreographer gating using the `ChoreographerContext` provided by
 * `StableChoreographerProvider` (from `@atlassian/post-office-context/choreographer`).
 *
 * When the choreographer is disabled or its factory is not yet loaded,
 * the message renders unconditionally.
 *
 * When `disableChoreographer` is `true`, the gate short-circuits and renders
 * children unconditionally — bypassing the choreographer entirely for this message.
 */ const $d4c3b81fe536edde$var$ChoreographerGate = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, disableChoreographer: disableChoreographer, awaitChoreographerFactory: awaitChoreographerFactory })=>{
    // Hooks must run on every render to preserve hook order — do not short-circuit
    // before calling them, even when `disableChoreographer` is set.
    const { factory: choreographerFactory, choreographerEnabled: choreographerEnabled } = (0, $iMsV9.useChoreographerContext)();
    const isChoreographedPostOfficeMessagesEnabled = (0, $4LDqh.default).checkGate('enable_choreographed_post_office_messages');
    if (disableChoreographer) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
    if (awaitChoreographerFactory && choreographerEnabled && isChoreographedPostOfficeMessagesEnabled && !choreographerFactory) return null;
    if (choreographerFactory && choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        const { shouldBeChoreographed: shouldBeChoreographed, useChoreographedRender: useChoreographedRender } = choreographerFactory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            const useMessageTemplateIdAsChoreographerMessageId = (0, $4LDqh.default).checkGate('post-office_use_template_id_for_choreo');
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $e79Pd.jsx)($d4c3b81fe536edde$var$ChoreographedMessage, {
                messageId: choreographerMessageId,
                useChoreographedRender: useChoreographedRender,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$d4c3b81fe536edde$var$ChoreographerGate.displayName = "ChoreographerGate";
/**
 * Provides the choreographer context this component's gating depends on, so headless
 * consumers do not have to mount `StableChoreographerProvider` themselves.
 *
 * Nesting is safe: the underlying choreographer factory is a per-product singleton
 * held on `window`, so a provider mounted here resolves to the same factory (and
 * therefore the same fatigue/concurrency queue) as one mounted by an ancestor.
 *
 */ const $d4c3b81fe536edde$var$ChoreographerProvider = ({ children: children, placementId: placementId, enabled: enabled })=>{
    if (!enabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iMsV9.StableChoreographerProvider), {
        placementId: placementId,
        children: children
    });
};
$d4c3b81fe536edde$var$ChoreographerProvider.displayName = "ChoreographerProvider";
const $d4c3b81fe536edde$export$7356a355af87a394 = ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, placementId: placementId, messageCategory: messageCategory, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, disableChoreographer: disableChoreographer, hideInIsolatedCloud: hideInIsolatedCloud, children: children })=>{
    const messageContext = (0, $euxye.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId
        }), [
        messageInstanceId,
        messageTemplateId,
        messageCategory,
        triggerId,
        messageCreationType,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const placementContext = (0, $euxye.useMemo)(()=>({
            placementId: placementId
        }), [
        placementId
    ]);
    const providesChoreographer = !disableChoreographer && (0, $4LDqh.default).checkGate('post-office_enable_choreographer_provider');
    return /*#__PURE__*/ (0, $e79Pd.jsx)($d4c3b81fe536edde$var$ChoreographerProvider, {
        placementId: placementId,
        enabled: providesChoreographer,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($d4c3b81fe536edde$var$IsolatedCloudGate, {
            hideInIsolatedCloud: hideInIsolatedCloud,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fslfv.PlacementProvider), {
                value: placementContext,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lK7pY.MessageContextProvider), {
                    value: messageContext,
                    children: /*#__PURE__*/ (0, $e79Pd.jsxs)($d4c3b81fe536edde$var$ChoreographerGate, {
                        messageId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        messageCategory: messageCategory,
                        disableChoreographer: disableChoreographer,
                        awaitChoreographerFactory: providesChoreographer,
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsx)($d4c3b81fe536edde$var$ViewedOnMount, {}),
                            /*#__PURE__*/ (0, $e79Pd.jsx)($d4c3b81fe536edde$var$RenderedChildren, {
                                children: children
                            })
                        ]
                    })
                })
            })
        })
    });
};
$d4c3b81fe536edde$export$7356a355af87a394.displayName = "PostOfficeMessage";

});

parcelRegister("4szlR", function(module, exports) {
$parcel$export(module.exports, "transformPlacementMessageToMessageLifecycleProps", () => $8b85af1b465cb11f$export$61e95755e67323e4);
const $8b85af1b465cb11f$var$transformMessageCreationTypeToPostOfficeMessageCreationType = ({ messageCreationType: messageCreationType })=>{
    if (messageCreationType === 'implicit' || messageCreationType === 'explicit') return messageCreationType;
    return undefined;
};
const $8b85af1b465cb11f$export$61e95755e67323e4 = ({ message: message })=>({
        configSetId: message?.configSetId,
        journeyId: message?.journeyId,
        journeyTriggerId: message?.journeyTriggerId,
        messageCreationType: $8b85af1b465cb11f$var$transformMessageCreationTypeToPostOfficeMessageCreationType({
            messageCreationType: message?.messageCreationType
        }),
        triggerId: message?.triggerId
    });

});

parcelRegister("7i1OM", function(module, exports) {
$parcel$export(module.exports, "usePlacementData", () => $631f67feb38803b3$export$a9668c1d52481a0f);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $3YKjt = parcelRequire("3YKjt");
var $lHZq9 = parcelRequire("lHZq9");
var $j142y = parcelRequire("j142y");

var $9KARi = parcelRequire("9KARi");

var $hDw0T = parcelRequire("hDw0T");

var $zhCFd = parcelRequire("zhCFd");

var $L6ISz = parcelRequire("L6ISz");
/**
 * Foundation hook for the Post Office Headless API.
 *
 * Fetches raw Placement API data for a given `placementId` and tracks which
 * message instances have been dismissed in the current session via the Post
 * Office pub/sub system.
 *
 * All higher-level hooks (`useAllMessages`, `useMessageInstances`, `useMessageData`) compose on top
 * of this hook.
 *
 * Automatically reads the current `PostOfficeContext` (product, locale, tenantId, workspaceAri,
 * etc.) via `usePostOfficeContext` and forwards it to the Placement API request as query
 * parameters. No manual context threading is required.
 *
 * Requires `PlacementFetchingProvider` and `MessagePlacementProvider` (or
 * `PostOfficeProvider`) to be present in the React tree.
 *
 * @example
 * ```tsx
 * const { data, dismissedIds, isLoading, error, dismissMessage } = usePlacementData(
 *   'some-placement',
 * );
 *
 * const visibleMessages = data?.messages.filter(
 *   m => !dismissedIds.has(m.messageInstanceId)
 * ) ?? [];
 * ```
 *
 * @typeParam TMessage - A {@link PlacementMessageDiscriminant} or union thereof.
 *   Provide a union to model multiple template types with narrowable `context`:
 *   `usePlacementData<{ messageTemplateId: 'banner'; context: BannerCtx } | { messageTemplateId: 'flag'; context: FlagCtx }>(id)`
 * @typeParam TExtension - Additional top-level fields to expect in the `data` shape.
 * @param placementId - The ID of the placement to fetch data for. Defaults to `'headless'`.
 * @param options - Optional configuration. Pass `{ dataSource: 'DEV_SERVER' }` to point the hook
 *   at the local placement dev server (`yarn placement:v2 dev`, default port `4224`).
 * @see https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/6764207116
 */ /** Base URL used when `dataSource` is `'DEV_SERVER'`. Only included in non-production builds. */ const $631f67feb38803b3$var$DEV_SERVER_BASE_URL = 'http://localhost:4224';
const $631f67feb38803b3$export$a9668c1d52481a0f = (placementId = 'headless', options)=>{
    const fetcher = (0, $hDw0T.usePlacementFetchingContext)();
    const { onMessageDismiss: onMessageDismiss, dismissMessageFromPlacement: dismissMessageFromPlacement } = (0, $lHZq9.useMessagePlacementHooks)();
    const postOfficeContext = (0, $j142y.usePostOfficeContext)();
    const simulationParams = (0, $9KARi.useExtensionBridgeSimulationParams)(placementId);
    const { dataSource: dataSource = 'PRODUCTION', queryString: queryString } = options ?? {};
    const arePlacementsGloballyDisabled = (0, $iqfTZ.fg)('post-office-enable-headless-disable-placement') && (0, $3YKjt.isPostOfficePlacementsGloballyDisabled)(postOfficeContext);
    const placementIdToFetch = arePlacementsGloballyDisabled ? null : placementId;
    // When targeting the dev server, override the fetch so the request goes to
    // `http://localhost:4224` instead of the production gateway. The dev server
    // exposes the same URL path as production.
    let effectiveFetcher = fetcher;
    if (dataSource === 'DEV_SERVER') effectiveFetcher = {
        fetch: (url, init)=>{
            // Replace the origin with the dev server base URL, keeping the path intact.
            // Guard against SSR environments where window is not defined.
            const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
            const originalUrl = new URL(url, origin);
            const devUrl = `${$631f67feb38803b3$var$DEV_SERVER_BASE_URL}${originalUrl.pathname}${originalUrl.search}`;
            return fetcher.fetch(devUrl, init);
        }
    };
    // Merge any caller-provided `queryString` params with the PostOfficeContext params.
    // This is additive only: context values always take precedence, so callers can never
    // override the context-derived query parameters — they can only add new ones.
    // Gated behind `post-office-enable-headless-query`: when the gate is off the caller
    // `queryString` is ignored entirely and only the context-derived params are sent,
    // preserving the pre-existing request shape.
    // Memoised on the stringified queryString so the SWR request key stays stable across
    // renders when an inline object with identical contents is passed.
    //
    // When `post-office_enable_extension-control` is on and this placement has simulation
    // enabled, per-placement simulate params are merged in the same additive way —
    // never overriding PostOfficeContext keys, and never leaking to sibling placements.
    const isHeadlessQueryEnabled = (0, $iqfTZ.fg)('post-office-enable-headless-query');
    const queryStringKey = isHeadlessQueryEnabled && queryString ? JSON.stringify(queryString) : undefined;
    const simulationParamsKey = simulationParams ? JSON.stringify(simulationParams) : undefined;
    const requestContext = (0, $euxye.useMemo)(()=>{
        const additiveParams = {
            ...simulationParams ?? {},
            ...isHeadlessQueryEnabled && queryString ? queryString : {}
        };
        return Object.keys(additiveParams).length > 0 ? {
            ...additiveParams,
            ...postOfficeContext
        } : postOfficeContext;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- keys are stable stringifications of the source objects
    [
        postOfficeContext,
        queryStringKey,
        isHeadlessQueryEnabled,
        simulationParamsKey
    ]);
    const response = (0, $zhCFd.useFetchPlacementData)(placementIdToFetch, 'headless', requestContext, effectiveFetcher, undefined, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    const [dismissedIds, setDismissedIds] = (0, $euxye.useState)(()=>new Set());
    // Synchronously reset dismissedIds in the render path when placementId changes.
    // A useEffect-based reset fires after paint, leaving a one-render window where
    // the new placement is painted with stale dismissed IDs from the previous one.
    // Calling setState during render causes React to discard this render and
    // immediately re-render with the new state; consumers never observe stale IDs.
    //
    // Infinite re-render safety — two independent guards prevent looping:
    //   1. prevPlacementIdRef.current is written BEFORE setDismissedIds is called.
    //      On the re-render React immediately triggers, the ref already equals
    //      placementId so the outer `if` is false — no further setState occurs.
    //   2. After the reset, dismissedIds.size === 0, so the inner size guard is
    //      also false — a second guard independent of the ref. Either alone is
    //      sufficient; both together make the loop prevention unconditional.
    // See: 'infinite re-render safety' tests in usePlacementData.test.tsx.
    const prevPlacementIdRef = (0, $euxye.useRef)(placementId);
    const placementChanged = prevPlacementIdRef.current !== placementId;
    // Return an empty set immediately on the first render with a new placementId —
    // including the discarded render that React produces when setState is called
    // during rendering. This ensures no render ever exposes stale dismissed IDs
    // from the previous placement, even transiently.
    // Reference stability: when dismissedIds is already empty we reuse the same
    // Set reference (no new object, no unnecessary re-render).
    const effectiveDismissedIds = placementChanged && dismissedIds.size > 0 ? new Set() : dismissedIds;
    if (placementChanged) {
        prevPlacementIdRef.current = placementId;
        // Only reset if the set is non-empty to avoid an unnecessary extra render.
        if (dismissedIds.size > 0) setDismissedIds(new Set());
    }
    // Subscribe to pub/sub dismiss events on mount, unsubscribe on unmount.
    (0, $euxye.useEffect)(()=>{
        const unsubscribe = onMessageDismiss(({ messageInstanceId: messageInstanceId })=>{
            setDismissedIds((prev)=>{
                // Guard: do not create a new Set reference if the ID is already dismissed.
                if (prev.has(messageInstanceId)) return prev;
                return new Set([
                    ...prev,
                    messageInstanceId
                ]);
            });
        });
        return unsubscribe;
    }, [
        onMessageDismiss
    ]);
    const dismissMessage = (0, $euxye.useCallback)((messageInstanceId)=>{
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
    }, [
        dismissMessageFromPlacement
    ]);
    const { isLoading: isLoading, error: error } = response;
    const PostOfficePlacementMessage = (0, $euxye.useMemo)(()=>({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $L6ISz.PostOfficeMessage), {
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                placementId: placementId,
                messageCategory: messageCategory,
                triggerId: triggerId,
                messageCreationType: messageCreationType,
                journeyId: journeyId,
                journeyTriggerId: journeyTriggerId,
                configSetId: configSetId,
                children: children
            }), [
        placementId
    ]);
    return {
        data: response.data?.data,
        errors: response.data?.errors ?? [],
        dismissedIds: effectiveDismissedIds,
        isLoading: isLoading,
        error: error,
        dismissMessage: dismissMessage,
        PostOfficePlacementMessage: PostOfficePlacementMessage
    };
};

});
parcelRegister("9KARi", function(module, exports) {
$parcel$export(module.exports, "useExtensionBridgeSimulationParams", () => $e248419d17ba8071$export$8cb502483eccaaa7);

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $gLTiJ = parcelRequire("gLTiJ");
const $e248419d17ba8071$var$getExtensionBridge = ()=>{
    if (typeof window === 'undefined') return undefined;
    return window.postOffice?.extensionControl;
};
const $e248419d17ba8071$export$8cb502483eccaaa7 = (placementId)=>{
    const isEnabled = (0, $iqfTZ.fg)('post-office_enable_extension-control');
    const subscribe = (0, $euxye.useCallback)((onStoreChange)=>{
        if (!isEnabled) return ()=>{};
        return $e248419d17ba8071$var$getExtensionBridge()?.subscribe(onStoreChange) ?? (()=>{});
    }, [
        isEnabled
    ]);
    const getSnapshot = (0, $euxye.useCallback)(()=>{
        if (!isEnabled) return undefined;
        return (0, $gLTiJ.extensionBridgeStore).getEnabledSimulationParamsSnapshot(placementId);
    }, [
        isEnabled,
        placementId
    ]);
    return (0, $euxye.useSyncExternalStore)(subscribe, getSnapshot, ()=>undefined);
};

});


parcelRegister("j9Tmd", function(module, exports) {
$parcel$export(module.exports, "PlacementValidationError", () => $cf49f64cf6b1226b$export$70abd424e1cca8c3);
$parcel$export(module.exports, "MultipleMessageInstancesError", () => $cf49f64cf6b1226b$export$fc2b8b9bcb86a0d0);
$parcel$export(module.exports, "PlacementLocationError", () => $cf49f64cf6b1226b$export$17455b84f403213b);
$parcel$export(module.exports, "isPlacementMessage", () => $cf49f64cf6b1226b$export$a8ba7e6c095216ec);
$parcel$export(module.exports, "toHookError", () => $cf49f64cf6b1226b$export$8364e41b11fd7d3b);
$parcel$export(module.exports, "isMatchBuilder", () => $cf49f64cf6b1226b$export$be507563b85af550);
$parcel$export(module.exports, "createMatchBuilder", () => $cf49f64cf6b1226b$export$861b204abcaa015d);
/** Shared utilities for post-office headless API hooks. */ class $cf49f64cf6b1226b$export$70abd424e1cca8c3 extends Error {
    constructor({ placementId: placementId, failedCount: failedCount }){
        super('One or more messages failed structural validation'), this.name = 'PlacementValidationError';
        this.placementId = placementId;
        this.failedCount = failedCount;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class $cf49f64cf6b1226b$export$fc2b8b9bcb86a0d0 extends Error {
    constructor({ placementId: placementId, messageTemplateId: messageTemplateId, instanceCount: instanceCount }){
        super('Multiple message instances found; the hook is in an unexpected state and no message will be returned. Use useMessageInstances if multiple instances are expected.'), this.name = 'MultipleMessageInstancesError';
        this.placementId = placementId;
        this.messageTemplateId = messageTemplateId;
        this.instanceCount = instanceCount;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class $cf49f64cf6b1226b$export$17455b84f403213b extends Error {
    constructor({ locationKey: locationKey, invalidCount: invalidCount }){
        super('All items at the message location must be valid PlacementMessage objects'), this.name = 'PlacementLocationError';
        this.locationKey = locationKey;
        this.invalidCount = invalidCount;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
const $cf49f64cf6b1226b$export$a8ba7e6c095216ec = (item)=>{
    if (typeof item !== 'object' || item === null) return false;
    const msg = item;
    return typeof msg.messageTemplateId === 'string' && typeof msg.messageInstanceId === 'string' && typeof msg.context === 'object' && msg.context !== null;
};
const $cf49f64cf6b1226b$export$8364e41b11fd7d3b = (thrown, fallbackMessage = 'Hook callback threw')=>{
    if (thrown instanceof Error) return thrown;
    if (typeof thrown === 'string') return new Error(thrown);
    return new Error(fallbackMessage);
};
// Match Builder
/** @internal — used to tag match-builder objects in place of `instanceof`. */ const $cf49f64cf6b1226b$var$MATCH_BUILDER_TAG = Symbol('MatchBuilder');
/** @internal — creates a builder with the given accumulated state (location already resolved). */ const $cf49f64cf6b1226b$var$makeMatchBuilder = (locationKey, contextPredicates, dataPredicates)=>{
    const builder = {
        messageContext (predicate) {
            return $cf49f64cf6b1226b$var$makeMatchBuilder(locationKey, [
                ...contextPredicates,
                predicate
            ], dataPredicates);
        },
        custom (predicate) {
            return $cf49f64cf6b1226b$var$makeMatchBuilder(locationKey, contextPredicates, [
                ...dataPredicates,
                predicate
            ]);
        },
        match (data) {
            if (dataPredicates.some((p)=>!p(data))) return [];
            const raw = data[locationKey] ?? [];
            if (!Array.isArray(raw)) throw new $cf49f64cf6b1226b$export$17455b84f403213b({
                locationKey: locationKey,
                invalidCount: 1
            });
            const items = raw;
            const invalidCount = items.filter((item)=>!$cf49f64cf6b1226b$export$a8ba7e6c095216ec(item)).length;
            if (invalidCount > 0) throw new $cf49f64cf6b1226b$export$17455b84f403213b({
                locationKey: locationKey,
                invalidCount: invalidCount
            });
            const candidates = items;
            return candidates.filter((message)=>contextPredicates.every((p)=>p(message.context)));
        }
    };
    // Tag the builder with a non-enumerable symbol so isMatchBuilder can identify it without
    // relying on instanceof (which would break across module boundaries or after minification).
    Object.defineProperty(builder, $cf49f64cf6b1226b$var$MATCH_BUILDER_TAG, {
        value: true,
        enumerable: false
    });
    return builder;
};
/** @internal — creates the initial builder with `messageLocation` available. */ const $cf49f64cf6b1226b$var$makeInitialMatchBuilder = ()=>{
    const initial = {
        messageLocation (key) {
            return $cf49f64cf6b1226b$var$makeMatchBuilder(key, [], []);
        },
        messageContext (predicate) {
            return $cf49f64cf6b1226b$var$makeMatchBuilder('messages', [
                predicate
            ], []);
        },
        custom (predicate) {
            return $cf49f64cf6b1226b$var$makeMatchBuilder('messages', [], [
                predicate
            ]);
        },
        match (data) {
            return $cf49f64cf6b1226b$var$makeMatchBuilder('messages', [], []).match(data);
        }
    };
    Object.defineProperty(initial, $cf49f64cf6b1226b$var$MATCH_BUILDER_TAG, {
        value: true,
        enumerable: false
    });
    return initial;
};
const $cf49f64cf6b1226b$export$be507563b85af550 = (value)=>{
    return typeof value === 'object' && value !== null && value[$cf49f64cf6b1226b$var$MATCH_BUILDER_TAG] === true;
};
const $cf49f64cf6b1226b$export$861b204abcaa015d = ()=>$cf49f64cf6b1226b$var$makeInitialMatchBuilder();

});


parcelRegister("ch3uH", function(module, exports) {
$parcel$export(module.exports, "usePremiumModalDismissed", () => $b4fdcc3524ce7138$export$f4a580a7d2f2beb5);
$parcel$export(module.exports, "usePremiumLastVisit", () => $b4fdcc3524ce7138$export$9a23eb2f64fbd201);
$parcel$export(module.exports, "usePremiumFlowResolvedPromise", () => $b4fdcc3524ce7138$export$625e3db16c94a84f);
// eslint-disable-next-line jira/filename-case

var $gvtNj = parcelRequire("gvtNj");

var $fxgnC = parcelRequire("fxgnC");
const $b4fdcc3524ce7138$export$f4a580a7d2f2beb5 = (0, $gvtNj.createHook)((0, $fxgnC.getPremiumModalDismissed));
const $b4fdcc3524ce7138$export$9a23eb2f64fbd201 = (0, $gvtNj.createHook)((0, $fxgnC.getPremiumLastVisit));
const $b4fdcc3524ce7138$export$625e3db16c94a84f = (0, $gvtNj.createHook)((0, $fxgnC.getPremiumFlowResolvedPromise));

});
parcelRegister("fxgnC", function(module, exports) {
$parcel$export(module.exports, "getPremiumFlowResolvedPromise", () => $a4c845261acbe54f$export$c25db304e3103df1);
$parcel$export(module.exports, "getPremiumModalDismissed", () => $a4c845261acbe54f$export$6eb4ce527aec80de);
$parcel$export(module.exports, "getPremiumLastVisit", () => $a4c845261acbe54f$export$c2769173e99157bf);

var $a7e1f = parcelRequire("a7e1f");

var $03ij3 = parcelRequire("03ij3");
const $a4c845261acbe54f$export$2b9232e3e08756c9 = (state)=>state.premium;
const $a4c845261acbe54f$export$c25db304e3103df1 = (0, $a7e1f.createSelector)($a4c845261acbe54f$export$2b9232e3e08756c9, (premium)=>premium.promise.promise);
const $a4c845261acbe54f$export$6eb4ce527aec80de = (0, $a7e1f.createSelector)($a4c845261acbe54f$export$2b9232e3e08756c9, (premium)=>{
    if (premium.modalDismissed === undefined) return (0, $03ij3.asyncValues).loading();
    return (0, $03ij3.asyncValues).loaded(premium.modalDismissed);
});
const $a4c845261acbe54f$export$c2769173e99157bf = (0, $a7e1f.createSelector)($a4c845261acbe54f$export$2b9232e3e08756c9, (premium)=>{
    if (premium.lastVisit.isPremium === undefined) return (0, $03ij3.asyncValues).loading();
    return (0, $03ij3.asyncValues).loaded(premium.lastVisit.isPremium);
});

});


parcelRegister("jVm9O", function(module, exports) {
$parcel$export(module.exports, "useIsVisibleWhenNoModalOnScreen", () => $ad7b2c46e27d2c55$export$33b51bfe2dd588a);

var $euxye = parcelRequire("euxye");
const $ad7b2c46e27d2c55$var$MODAL_SELECTOR = '.atlaskit-portal-container .atlaskit-portal [role=dialog]';
const $ad7b2c46e27d2c55$var$isModalOnScreen = ()=>Boolean(globalThis.document?.querySelector($ad7b2c46e27d2c55$var$MODAL_SELECTOR));
const $ad7b2c46e27d2c55$export$33b51bfe2dd588a = ()=>{
    const [isVisible, setIsVisible] = (0, $euxye.useState)(()=>!$ad7b2c46e27d2c55$var$isModalOnScreen());
    (0, $euxye.useEffect)(()=>{
        const body = globalThis.document?.body;
        if (!body) return;
        const updateVisibility = ()=>{
            setIsVisible((previousVisibility)=>{
                const nextVisibility = !$ad7b2c46e27d2c55$var$isModalOnScreen();
                return previousVisibility === nextVisibility ? previousVisibility : nextVisibility;
            });
        };
        // Sync once in case the DOM changed between initial render and effect setup.
        updateVisibility();
        const observer = new MutationObserver(()=>{
            updateVisibility();
        });
        observer.observe(body, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isVisible;
};

});



parcelRegister("nh8uJ", function(module, exports) {
$parcel$export(module.exports, "ModalEntryPointTrigger", () => $38cb2ae6992e8e46$export$90ea0128aea3fb1d);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $ikm5U = parcelRequire("ikm5U");

var $i860n = parcelRequire("i860n");

var $kt86l = parcelRequire("kt86l");

var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $2plXF = parcelRequire("2plXF");

var $aHWGL = parcelRequire("aHWGL");

var $74pMN = parcelRequire("74pMN");
const $38cb2ae6992e8e46$export$90ea0128aea3fb1d = (t0)=>{
    const $ = (0, $e7boj.c)(17);
    const { children: children, projectId: projectId, projectKey: projectKey, containerId: containerId } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { locale: locale } = (0, $1YIbA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            width: (0, $aHWGL.MODAL_WIDTH),
            ...(0, $i860n.fg)("jpd_view_template_library_m2") ? {
                height: (0, $aHWGL.MODAL_HEIGHT)
            } : {}
        };
        $[0] = t1;
    } else t1 = $[0];
    const modalProps = t1;
    const cloudId = (0, $kt86l.useCloudId)();
    let t2;
    if ($[1] !== createAnalyticsEvent) {
        t2 = ()=>{
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
                action: "closed",
                actionSubject: "modal"
            }), "viewTemplatesLibrary");
        };
        $[1] = createAnalyticsEvent;
        $[2] = t2;
    } else t2 = $[2];
    const onClose = t2;
    let t3;
    if ($[3] !== containerId || $[4] !== onClose || $[5] !== projectId || $[6] !== projectKey) {
        t3 = {
            projectId: projectId,
            onClose: onClose,
            projectKey: projectKey,
            containerId: containerId
        };
        $[3] = containerId;
        $[4] = onClose;
        $[5] = projectId;
        $[6] = projectKey;
        $[7] = t3;
    } else t3 = $[7];
    const entryPointProps = t3;
    let t4;
    if ($[8] !== locale) {
        t4 = (0, $i860n.fg)("jpd_view_template_library_m2") ? {
            locale: locale
        } : {};
        $[8] = locale;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== cloudId || $[11] !== t4) {
        t5 = {
            cloudId: cloudId,
            ...t4
        };
        $[10] = cloudId;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    const entryPointParams = t5;
    if (!cloudId) return null;
    let t6;
    if ($[13] !== children || $[14] !== entryPointParams || $[15] !== entryPointProps) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ikm5U.ModalTrigger), {
            entryPoint: (0, $2plXF.modalEntryPoint),
            modalProps: modalProps,
            entryPointProps: entryPointProps,
            entryPointParams: entryPointParams,
            preloadOnFocus: true,
            Fallback: (0, $74pMN.TemplateLibrarySkeleton)
        }, children);
        $[13] = children;
        $[14] = entryPointParams;
        $[15] = entryPointProps;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
};
$38cb2ae6992e8e46$export$90ea0128aea3fb1d.displayName = "ModalEntryPointTrigger";

});
parcelRegister("2plXF", function(module, exports) {
$parcel$export(module.exports, "modalEntryPoint", () => $34a4e0bddc75f34c$export$34743a1848865708);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $imsyv = parcelRequire("imsyv");

const $34a4e0bddc75f34c$export$34743a1848865708 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("2fJUf")), {
        moduleId: "5e556714",
        moduleName: "ViewTemplatesLibraryModalEntryPoint",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, locale: locale })=>{
        return {
            queries: {
                viewTemplatesQuery: {
                    parameters: $imsyv.default,
                    variables: {
                        cloudId: cloudId,
                        ...locale ? {
                            locale: locale
                        } : {}
                    }
                }
            }
        };
    }
});

});
parcelRegister("imsyv", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf9f26be856bcbca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0f856a934f2e8b24b23119410c027fcb>>
 * @relayHash 2ea5c4e6b4b4b7e5eea2703fdbce89b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 059892f6f118fc1e8a494f829489d9b83f271703b5155e1f8f4c7c4fbf64627f
const $bf9f26be856bcbca$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "src"
        },
        {
            "kind": "ScalarField",
            "name": "srcDark"
        },
        {
            "kind": "ScalarField",
            "name": "alt"
        }
    ], v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "GravityViewTemplate",
                "kind": "LinkedField",
                "name": "templates",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "colorScheme"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "shortDescription"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "longDescription"
                    },
                    {
                        "concreteType": "GravityViewTemplateImage",
                        "kind": "LinkedField",
                        "name": "thumbnail",
                        "plural": false,
                        "selections": v3 /*: any*/ 
                    },
                    {
                        "concreteType": "GravityViewTemplateImage",
                        "kind": "LinkedField",
                        "name": "screenshot",
                        "plural": false,
                        "selections": v3 /*: any*/ 
                    },
                    {
                        "concreteType": "GravityViewTemplateDefinitions",
                        "kind": "LinkedField",
                        "name": "definitions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "GravityFieldDefinition",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "ref"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "type"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "description"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "configuration"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "options"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "global"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "nonReplaceable"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "GravityViewTemplatesSuccess"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ViewTemplatesLibraryModalEntryPointQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "gravity_viewTemplates",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ViewTemplatesQueryErrorView_queryError"
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ViewTemplatesLibraryModalEntryPointQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "gravity_viewTemplates",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "identifier"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errorType"
                                        }
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "059892f6f118fc1e8a494f829489d9b83f271703b5155e1f8f4c7c4fbf64627f",
            "metadata": {},
            "name": "ViewTemplatesLibraryModalEntryPointQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bf9f26be856bcbca$var$node.hash = "dee7eb9d90c9337fb136650aa1a1ef8b";
var $bf9f26be856bcbca$export$2e2bcd8739ae039 = $bf9f26be856bcbca$var$node;

});

parcelRegister("2fJUf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("bhdW5")
]).then(()=>parcelRequire('khUND'));

});


parcelRegister("aHWGL", function(module, exports) {
$parcel$export(module.exports, "TEMPLATE_TILE_SHORT_DESCRIPTION_MAX_HEIGHT_PX", () => $03215ac4b24cdf05$export$182d57e936c0f31c);
$parcel$export(module.exports, "MODAL_WIDTH", () => $03215ac4b24cdf05$export$3d931b64f46140b3);
$parcel$export(module.exports, "MODAL_HEIGHT", () => $03215ac4b24cdf05$export$1dd7793cb602b5ab);
/* eslint-disable jira/filename-case */ const $03215ac4b24cdf05$export$a81f88c245e224aa = 300;
const $03215ac4b24cdf05$export$6cd41f6432b30fbd = 252;
const $03215ac4b24cdf05$var$NUMBER_OF_VISIBLE_TILES_VERTICALLY = 3;
const $03215ac4b24cdf05$export$182d57e936c0f31c = 48;
const $03215ac4b24cdf05$export$3d931b64f46140b3 = `calc(3 * ${$03215ac4b24cdf05$export$a81f88c245e224aa}px + 2 * ${"var(--ds-space-200, 16px)"} + 2 * ${"var(--ds-space-300, 24px)"} + ${"var(--ds-space-250, 20px)"})`;
// Line height of a single line of the modal title. `ModalTitle` in
// `@atlaskit/modal-dialog/modal-title` renders with `font.heading.medium`,
// whose line height is 24px.
const $03215ac4b24cdf05$var$MODAL_TITLE_LINE_HEIGHT_IN_PX = 24;
// Height of the modal header (title row). Mirrors `ModalHeader` styles in
// `@atlaskit/modal-dialog/modal-header`:
//   paddingBlockStart: space.300, paddingBlockEnd: space.200, marginBlockEnd: -space.025
// plus one line of the modal title (`font.heading.medium`).
const $03215ac4b24cdf05$var$MODAL_HEADER_HEIGHT = `calc(${"var(--ds-space-300, 24px)"} + ${"var(--ds-space-200, 16px)"} - ${"var(--ds-space-025, 2px)"} + ${$03215ac4b24cdf05$var$MODAL_TITLE_LINE_HEIGHT_IN_PX}px)`;
const $03215ac4b24cdf05$export$1dd7793cb602b5ab = `calc(
	${$03215ac4b24cdf05$var$MODAL_HEADER_HEIGHT} + 2 * ${"var(--ds-space-025, 2px)"} + ${$03215ac4b24cdf05$var$NUMBER_OF_VISIBLE_TILES_VERTICALLY} * ${$03215ac4b24cdf05$export$6cd41f6432b30fbd}px + ${$03215ac4b24cdf05$var$NUMBER_OF_VISIBLE_TILES_VERTICALLY - 1} * ${"var(--ds-space-200, 16px)"} + ${"var(--ds-space-300, 24px)"})`;

});

parcelRegister("74pMN", function(module, exports) {
$parcel$export(module.exports, "TemplateLibrarySkeleton", () => $6cf46f400e812f04$export$cd3bc4d2924b970a);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $2v3yi = parcelRequire("2v3yi");

var $gpyJM = parcelRequire("gpyJM");

var $dNPnD = parcelRequire("dNPnD");

var $i860n = parcelRequire("i860n");

var $ihEDU = parcelRequire("ihEDU");

var $gwWMf = parcelRequire("gwWMf");

var $3NRLa = parcelRequire("3NRLa");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $6cf46f400e812f04$var$templatesLibraryTitle = (0, $7eNDO.defineMessage)({
    id: "component-view-template-library.templates-library.title",
    defaultMessage: "Templates"
});
const $6cf46f400e812f04$var$SKELETON_TILE_COUNT = 6;
const $6cf46f400e812f04$var$styles = {
    categoryButtonsWrapper: "_6rth1ejb",
    tilesGrid: "_yv0e19f7 _85i51ejb",
    tileRoot: "_2rko1qi0 _zulppxbi _1h6d1l7x _1dqonqa1 _189ee4h9 _bfhkvuon _1e0c1txw _2lx21bp4 _n3tdpxbi _19bvze3t _u5f3ze3t _ca0qze3t _1bsb1mjv",
    imageWrapper: "_1reo15vq _18m915vq _13li1qi0 _qrwq1qi0 _4t3i17n1",
    textWrapper: "_zulpu2gc _1e0c1txw _2lx21bp4 _19bvv47k _u5f3v47k"
};
const $6cf46f400e812f04$var$CategoryBarSkeleton = ()=>{
    const $ = (0, $e7boj.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
            xcss: $6cf46f400e812f04$var$styles.categoryButtonsWrapper,
            "aria-hidden": "true",
            testId: "component-view-template-library.template-library-category-bar-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            height: 32,
            width: "560px",
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
$6cf46f400e812f04$var$CategoryBarSkeleton.displayName = "CategoryBarSkeleton";
const $6cf46f400e812f04$var$TemplateTileSkeleton = ()=>{
    const $ = (0, $e7boj.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
            xcss: $6cf46f400e812f04$var$styles.imageWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            height: 146,
            width: "100%",
            borderRadius: 0,
            isShimmering: true
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
            xcss: $6cf46f400e812f04$var$styles.tileRoot,
            "aria-hidden": "true",
            "aria-busy": "true"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
            xcss: $6cf46f400e812f04$var$styles.textWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            height: 20,
            width: "70%",
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            height: 16,
            width: "90%",
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        })));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
$6cf46f400e812f04$var$TemplateTileSkeleton.displayName = "TemplateTileSkeleton";
const $6cf46f400e812f04$export$cd3bc4d2924b970a = /*#__PURE__*/ (0, $euxye.memo)(()=>{
    const $ = (0, $e7boj.c)(8);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($6cf46f400e812f04$var$templatesLibraryTitle);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gpyJM.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dNPnD.default), null, t0));
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $i860n.fg)("jpd_view_template_library_m2") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($6cf46f400e812f04$var$CategoryBarSkeleton, null) : null;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v3yi.default), null, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gwWMf.Grid), {
            gap: "space.200",
            xcss: $6cf46f400e812f04$var$styles.tilesGrid
        }, Array.from({
            length: $6cf46f400e812f04$var$SKELETON_TILE_COUNT
        }, $6cf46f400e812f04$var$_temp)));
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t1) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, t1, t3);
        $[6] = t1;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
});
function $6cf46f400e812f04$var$_temp(_, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($6cf46f400e812f04$var$TemplateTileSkeleton, {
        key: index
    });
}

});
parcelRegister("gwWMf", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $607c0b25003632a3$export$ef2184bd89960b14);
/* grid.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $607c0b25003632a3$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $607c0b25003632a3$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $607c0b25003632a3$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $607c0b25003632a3$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $607c0b25003632a3$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $607c0b25003632a3$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $607c0b25003632a3$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
const $607c0b25003632a3$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $4jQY2.default)([
            $607c0b25003632a3$var$baseStyles.root,
            gap && $607c0b25003632a3$var$columnGapMap[gap],
            columnGap && $607c0b25003632a3$var$columnGapMap[columnGap],
            gap && $607c0b25003632a3$var$rowGapMap[gap],
            rowGap && $607c0b25003632a3$var$rowGapMap[rowGap],
            alignItems && $607c0b25003632a3$var$alignItemsMap[alignItems],
            alignContent && $607c0b25003632a3$var$alignContentMap[alignContent],
            justifyContent && $607c0b25003632a3$var$justifyContentMap[justifyContent],
            autoFlow && $607c0b25003632a3$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$607c0b25003632a3$export$ef2184bd89960b14.displayName = 'Grid';

});




parcelRegister("6c08J", function(module, exports) {
$parcel$export(module.exports, "useIsViewTemplateButtonVisible", () => $78e3b0a8d7e8846c$export$63879b0fda8264ff);
const $78e3b0a8d7e8846c$export$63879b0fda8264ff = ({ canCreateFields: canCreateFields, canManageViews: canManageViews, projectId: projectId, projectKey: projectKey })=>Boolean(canCreateFields && canManageViews && projectId && projectKey);

});

parcelRegister("kDapy", function(module, exports) {
$parcel$export(module.exports, "useIsFullyExpanded", () => $3ea56c8372ded03c$export$7212b6b01271f5d1);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $2KMaX = parcelRequire("2KMaX");
const $3ea56c8372ded03c$var$TIMEOUT = 500;
const $3ea56c8372ded03c$export$7212b6b01271f5d1 = ()=>{
    const $ = (0, $e7boj.c)(3);
    const [ready, setReady] = (0, $euxye.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $2KMaX.useLeftSidebarState)();
    let t0;
    let t1;
    if ($[0] !== isCollapsed) {
        t0 = ()=>{
            const timeoutId = setTimeout(()=>{
                setReady(!isCollapsed);
            }, $3ea56c8372ded03c$var$TIMEOUT);
            return ()=>clearTimeout(timeoutId);
        };
        t1 = [
            isCollapsed
        ];
        $[0] = isCollapsed;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $euxye.useLayoutEffect)(t0, t1);
    return ready && !isCollapsed;
};

});

parcelRegister("eQCsj", function(module, exports) {
$parcel$export(module.exports, "CreateViewMenu", () => $e6fe8cc824f1cc59$export$897bed7d44c888e0);

var $euxye = parcelRequire("euxye");

var $5F8FY = parcelRequire("5F8FY");

var $gNzvf = parcelRequire("gNzvf");

var $d8n9z = parcelRequire("d8n9z");

var $bbcHB = parcelRequire("bbcHB");
const $e6fe8cc824f1cc59$export$897bed7d44c888e0 = ({ container: container, sectionId: sectionId, navigationContainer: navigationContainer, renderTrigger: renderTrigger, onMenuItemClick: onMenuItemClick })=>{
    const { isOpen: isOpen, onClose: onClose, onToggle: onToggle } = (0, $5F8FY.useOpenable)();
    const handleMenuItemClick = (0, $euxye.useCallback)(({ type: type })=>{
        onClose();
        onMenuItemClick?.({
            type: type,
            container: container
        });
    }, [
        container,
        onClose,
        onMenuItemClick
    ]);
    const content = false ? (_contentProps)=>null : (contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bbcHB.Menu), {
            ...contentProps,
            container: container,
            sectionId: sectionId,
            navigationContainer: navigationContainer,
            onMenuItemClick: handleMenuItemClick,
            onPopupClose: onClose
        });
    const trigger = (triggerProps)=>renderTrigger({
            ...triggerProps,
            onClick: onToggle
        });
    const messageId = (0, $d8n9z.isNavigationProject)(navigationContainer) ? `navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.create-view-menu.popup.${navigationContainer.projectKey}` : `navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.create-view-menu.popup.${navigationContainer.collectionUUID}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNzvf.JiraPopup), {
        shouldUseCaptureOnOutsideClick: true,
        placement: "auto-start",
        messageId: messageId,
        messageType: "transactional",
        isOpen: isOpen,
        onClose: onClose,
        content: content,
        trigger: trigger
    });
};
$e6fe8cc824f1cc59$export$897bed7d44c888e0.displayName = "CreateViewMenu";

});
parcelRegister("d8n9z", function(module, exports) {
$parcel$export(module.exports, "isNavigationProject", () => $7059826b89320242$export$b1a1ecd62e5b15c4);
/* eslint-disable jira/filename-case */ const $7059826b89320242$export$b1a1ecd62e5b15c4 = (object)=>{
    return 'projectType' in object;
};

});

parcelRegister("bbcHB", function(module, exports) {
$parcel$export(module.exports, "Menu", () => $8f0ac5a26703659e$export$d9b273488cd8ce6f);
/* Menu.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1AWbd = parcelRequire("1AWbd");

var $b6kJl = parcelRequire("b6kJl");

var $72ldR = parcelRequire("72ldR");

var $g36LP = parcelRequire("g36LP");

var $ihEDU = parcelRequire("ihEDU");

var $2XXtG = parcelRequire("2XXtG");

var $d8n9z = parcelRequire("d8n9z");

var $cJ7mj = parcelRequire("cJ7mj");
const $8f0ac5a26703659e$var$stopEventPropagation = (event)=>event.stopPropagation();
const $8f0ac5a26703659e$var$MIN_WIDTH_IN_PX = 250;
const $8f0ac5a26703659e$var$styles = {
    menu: "_1ul9r0r7"
};
const $8f0ac5a26703659e$export$b649bdc8760447ce = 'navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.create-view-menu.menu.create-view-menu';
const $8f0ac5a26703659e$export$d9b273488cd8ce6f = ({ container: container, sectionId: sectionId, navigationContainer: navigationContainer, onMenuItemClick: onMenuItemClick, onPopupClose: onPopupClose })=>{
    const canCreateFields = (0, $b6kJl.useCanCreateFields)();
    const isViewTemplateLibraryEnabled = canCreateFields && (0, $d8n9z.isNavigationProject)(navigationContainer);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        onMouseEnter: $8f0ac5a26703659e$var$stopEventPropagation,
        onMouseLeave: $8f0ac5a26703659e$var$stopEventPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), {
        minWidth: $8f0ac5a26703659e$var$MIN_WIDTH_IN_PX,
        testId: $8f0ac5a26703659e$export$b649bdc8760447ce
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $8f0ac5a26703659e$var$styles.menu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cJ7mj.ViewMenuItems), {
        container: container,
        navigationContainer: navigationContainer,
        onClick: onMenuItemClick
    }), isViewTemplateLibraryEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1AWbd.ViewTemplatesButton), {
        onClick: onPopupClose,
        projectId: navigationContainer.projectId,
        projectKey: navigationContainer.projectKey,
        containerId: sectionId
    }))))));
};
$8f0ac5a26703659e$export$d9b273488cd8ce6f.displayName = "Menu";

});
parcelRegister("1AWbd", function(module, exports) {
$parcel$export(module.exports, "ViewTemplatesButton", () => $6bbe84ad941bca1e$export$47487ef3cd02de7b);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $ceqcm = parcelRequire("ceqcm");

var $7UPq4 = parcelRequire("7UPq4");

var $ihEDU = parcelRequire("ihEDU");

var $defJG = parcelRequire("defJG");

var $2EFuW = parcelRequire("2EFuW");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aZMdt = parcelRequire("aZMdt");
var $aqPkH = parcelRequire("aqPkH");
var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $i860n = parcelRequire("i860n");

var $nh8uJ = parcelRequire("nh8uJ");
const $6bbe84ad941bca1e$var$button = (0, $7eNDO.defineMessage)({
    id: "polaris-component-view-template-library.button",
    defaultMessage: "Templates"
});
const $6bbe84ad941bca1e$var$iconLabel = (0, $7eNDO.defineMessage)({
    id: "polaris-component-view-template-library.iconLabel",
    defaultMessage: "Templates"
});
const $6bbe84ad941bca1e$var$lozenge = (0, $7eNDO.defineMessage)({
    id: "polaris-component-view-template-library.lozenge",
    defaultMessage: "New"
});
const $6bbe84ad941bca1e$export$47487ef3cd02de7b = (t0)=>{
    const $ = (0, $e7boj.c)(14);
    const { onClick: onClick, projectId: projectId, projectKey: projectKey, containerId: containerId } = t0;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== onClick) {
        t1 = ()=>{
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
                action: "clicked",
                actionSubject: "button"
            }), "viewTemplateLibrary");
            onClick?.();
        };
        $[0] = createAnalyticsEvent;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    let t2;
    if ($[3] !== formatMessage || $[4] !== handleClick) {
        t2 = (t3)=>{
            const { ref: ref } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7UPq4))), {
                    label: formatMessage($6bbe84ad941bca1e$var$iconLabel)
                }),
                onClick: handleClick,
                ref: ref
            }, (0, $i860n.fg)("jpd_tree-view-standard-upgrade") ? formatMessage($6bbe84ad941bca1e$var$button) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.Inline), {
                alignBlock: "center",
                spread: "space-between",
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), null, formatMessage($6bbe84ad941bca1e$var$button)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                appearance: (0, $i860n.fg)("platform-dst-lozenge-tag-badge-visual-uplifts") ? "discovery" : "new"
            }, formatMessage($6bbe84ad941bca1e$var$lozenge))));
        };
        $[3] = formatMessage;
        $[4] = handleClick;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== containerId || $[7] !== projectId || $[8] !== projectKey || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $nh8uJ.ModalEntryPointTrigger), {
            projectId: projectId,
            projectKey: projectKey,
            containerId: containerId
        }, t2);
        $[6] = containerId;
        $[7] = projectId;
        $[8] = projectKey;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireScreenAnalytics), null);
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            id: "viewTemplateLibrary",
            packageName: "jiraViewTemplateLibraryButton",
            teamName: "jpd-juno",
            fallback: "unmount"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
            sourceName: "viewTemplateLibraryItem",
            sourceType: (0, $46f069e6c968f461$export$d1123261ca8831d2)
        }, t3, t4));
        $[12] = t3;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
};
$6bbe84ad941bca1e$export$47487ef3cd02de7b.displayName = "ViewTemplatesButton";

});
parcelRegister("7UPq4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10f3a345717d1c657b50bf7d56307662>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c35a62fc2b82ecd$var$_react = $5c35a62fc2b82ecd$var$_interopRequireDefault((parcelRequire("euxye")));

var $5c35a62fc2b82ecd$var$_baseNew = $5c35a62fc2b82ecd$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $5c35a62fc2b82ecd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Template".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/template
 * Usage guidance:
 * Reserved fore templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c35a62fc2b82ecd$var$TemplateIcon = (props)=>/*#__PURE__*/ $5c35a62fc2b82ecd$var$_react.default.createElement($5c35a62fc2b82ecd$var$_baseNew.default, Object.assign({
        name: "TemplateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 6h-7v7.5H13a.5.5 0 0 0 .5-.5zm-11 7a.5.5 0 0 0 .5.5h2V6H2.5zm11-10a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.5h11zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$5c35a62fc2b82ecd$var$TemplateIcon.displayName = 'TemplateIcon';
var $5c35a62fc2b82ecd$var$_default = module.exports.default = $5c35a62fc2b82ecd$var$TemplateIcon;

});


parcelRegister("cJ7mj", function(module, exports) {
$parcel$export(module.exports, "ViewMenuItems", () => $76e40f4e87540772$export$e2bc84910e6c2497);

var $euxye = parcelRequire("euxye");

var $dH1Sa = parcelRequire("dH1Sa");

var $kmMHr = parcelRequire("kmMHr");

var $3kW31 = parcelRequire("3kW31");

var $7kSWU = parcelRequire("7kSWU");

var $7Lgzx = parcelRequire("7Lgzx");

var $g36LP = parcelRequire("g36LP");

var $hj9Qm = parcelRequire("hj9Qm");

var $69J1d = parcelRequire("69J1d");

var $jfiTi = parcelRequire("jfiTi");
const $76e40f4e87540772$export$e2bc84910e6c2497 = ({ container: container, navigationContainer: navigationContainer, onClick: onClick })=>{
    const { sendCreateViewDropDownOnProjectMenuItemAnalyticsEvent: sendCreateViewDropDownOnProjectMenuItemAnalyticsEvent } = (0, $hj9Qm.useAnalyticsL3)();
    const { createView: createView, insertViewSet: insertViewSet } = (0, $kmMHr.useNavigationActions)();
    const sectionsEnabled = (0, $hj9Qm.useSectionsEnabled)();
    const viewsEntityLimitType = (0, $hj9Qm.useViewsEntityLimitType)();
    const viewsetsEntityLimitType = (0, $hj9Qm.useViewsetsEntityLimitType)();
    const containerId = (0, $hj9Qm.useContainerId)();
    const viewCount = (0, $3kW31.useContainerViewsCount)({
        containerId: containerId
    });
    const hasReachedViewsLimit = (0, $3kW31.useHasReachedViewsLimit)({
        containerId: containerId,
        entityLimitType: viewsEntityLimitType
    });
    const hasReachedViewsetsLimit = (0, $3kW31.useHasReachedViewsLimit)({
        containerId: containerId,
        entityLimitType: viewsetsEntityLimitType
    });
    const trackMenuItemAnalyticsEvent = (0, $euxye.useCallback)((type)=>{
        sendCreateViewDropDownOnProjectMenuItemAnalyticsEvent({
            itemId: type,
            viewParams: {
                viewKind: type
            },
            container: navigationContainer
        });
    }, [
        navigationContainer,
        sendCreateViewDropDownOnProjectMenuItemAnalyticsEvent
    ]);
    const createViewHandler = (0, $euxye.useCallback)((type)=>(event)=>{
            event.preventDefault();
            // Notify the parent component
            onClick?.({
                type: type
            });
            // Track the event
            trackMenuItemAnalyticsEvent(type);
            if (sectionsEnabled && type === 'SECTION') {
                insertViewSet();
                return;
            }
            createView(type, container);
        }, [
        onClick,
        trackMenuItemAnalyticsEvent,
        sectionsEnabled,
        createView,
        container,
        insertViewSet
    ]);
    const createViewHandlers = (0, $euxye.useMemo)(()=>{
        const handlers = {
            [(0, $dH1Sa.VIEW_KIND_TABLE)]: createViewHandler((0, $dH1Sa.VIEW_KIND_TABLE)),
            [(0, $dH1Sa.VIEW_KIND_BOARD)]: createViewHandler((0, $dH1Sa.VIEW_KIND_BOARD)),
            [(0, $dH1Sa.VIEW_KIND_TIMELINE)]: createViewHandler((0, $dH1Sa.VIEW_KIND_TIMELINE)),
            [(0, $dH1Sa.VIEW_KIND_MATRIX)]: createViewHandler((0, $dH1Sa.VIEW_KIND_MATRIX)),
            [(0, $dH1Sa.VIEW_KIND_SECTION)]: createViewHandler((0, $dH1Sa.VIEW_KIND_SECTION)),
            [(0, $dH1Sa.VIEW_KIND_TREE)]: createViewHandler((0, $dH1Sa.VIEW_KIND_TREE))
        };
        return handlers;
    }, [
        createViewHandler
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, hasReachedViewsLimit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7kSWU.ViewLimitBanner), {
        viewCount: viewCount
    }), hasReachedViewsetsLimit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7Lgzx.ViewsetLimitBanner), {
        viewCount: viewCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jfiTi.BasicViewsList), {
        createViewHandlers: createViewHandlers,
        hasReachedViewsLimit: hasReachedViewsLimit
    }), !container && sectionsEnabled && viewsetsEntityLimitType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $69J1d.BasicViewSets), {
        createViewHandlers: createViewHandlers
    })));
};
$76e40f4e87540772$export$e2bc84910e6c2497.displayName = "ViewMenuItems";

});
parcelRegister("7kSWU", function(module, exports) {
$parcel$export(module.exports, "ViewLimitBanner", () => $f1281b85ad242968$export$d2bf41420d2982de);
/* ViewLimitBanner.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $hfv9m = parcelRequire("hfv9m");

var $e1DnH = parcelRequire("e1DnH");

var $inMxE = parcelRequire("inMxE");

var $ihEDU = parcelRequire("ihEDU");

var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");

var $i860n = parcelRequire("i860n");

var $93DVJ = parcelRequire("93DVJ");
const $f1281b85ad242968$var$viewsPerProject = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.section-messages.views-per-project",
    defaultMessage: "Your project has reached the limit of {limit, plural, one {# view} other {# views}}. Delete unused views to create a new one."
});
const $f1281b85ad242968$var$viewsPerProjectGalaxia = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.section-messages.views-per-space-galaxia",
    defaultMessage: "Your space has reached the limit of {limit, plural, one {# view} other {# views}}. Delete unused views to create a new one."
});
const $f1281b85ad242968$var$styles = {
    textContainer: "_p12fmgvx"
};
const $f1281b85ad242968$export$d2bf41420d2982de = ({ viewCount: viewCount })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const ref = (0, $euxye.useRef)(false);
    const viewsPerProjectLimit = (0, $e1DnH.useEntityLimitsByType)((0, $hfv9m.ENTITY_LIMIT_TYPE).VIEWS_PER_PROJECT) ?? 0;
    const limitReached = viewCount >= viewsPerProjectLimit;
    (0, $euxye.useEffect)(()=>{
        if (limitReached && !ref.current) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'viewLimitBanner shown', {
            viewCount: viewCount
        });
        else if (!limitReached && ref.current) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'viewLimitBanner hidden', {
            viewCount: viewCount
        });
        ref.current = limitReached;
    }, [
        limitReached,
        createAnalyticsEvent,
        viewCount
    ]);
    if (!limitReached || !viewsPerProjectLimit) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $93DVJ.LimitSectionMessage), {
        appearance: "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $f1281b85ad242968$var$styles.textContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage((0, $i860n.fg)('project_term_refresh_ga') ? $f1281b85ad242968$var$viewsPerProjectGalaxia : $f1281b85ad242968$var$viewsPerProject, {
        limit: viewsPerProjectLimit
    }))));
};
$f1281b85ad242968$export$d2bf41420d2982de.displayName = "ViewLimitBanner";

});
parcelRegister("93DVJ", function(module, exports) {
$parcel$export(module.exports, "LimitSectionMessage", () => $84ef64b3e74855e7$export$2666dc2345b558fb);

var $euxye = parcelRequire("euxye");

var $aybNy = parcelRequire("aybNy");
const $84ef64b3e74855e7$export$2666dc2345b558fb = /*#__PURE__*/ (0, $euxye.memo)(({ appearance: appearance = 'warning', children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aybNy.default), {
        appearance: appearance
    }, children);
});

});


parcelRegister("7Lgzx", function(module, exports) {
$parcel$export(module.exports, "ViewsetLimitBanner", () => $e01fc28968a55e2a$export$e44797b961890009);
/* ViewsetLimitBanner.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $hfv9m = parcelRequire("hfv9m");

var $e1DnH = parcelRequire("e1DnH");

var $inMxE = parcelRequire("inMxE");

var $ihEDU = parcelRequire("ihEDU");

var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");

var $i860n = parcelRequire("i860n");

var $93DVJ = parcelRequire("93DVJ");
const $e01fc28968a55e2a$var$viewsetsPerProject = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.section-messages.viewset-per-project",
    defaultMessage: "Your project has reached the limit of {limit, plural, one {# section} other {# sections}}. Delete unused sections to create a new one."
});
const $e01fc28968a55e2a$var$viewsetsPerProjectGalaxia = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.section-messages.viewset-per-project-galaxia",
    defaultMessage: "Your space has reached the limit of {limit, plural, one {# section} other {# sections}}. Delete unused sections to create a new one."
});
const $e01fc28968a55e2a$var$styles = {
    textContainer: "_p12fmgvx"
};
const $e01fc28968a55e2a$export$e44797b961890009 = ({ viewCount: viewCount })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const ref = (0, $euxye.useRef)(false);
    const viewsetsPerProjectLimit = (0, $e1DnH.useEntityLimitsByType)((0, $hfv9m.ENTITY_LIMIT_TYPE).VIEWSETS_PER_PROJECT) ?? 0;
    const limitReached = viewCount >= viewsetsPerProjectLimit;
    (0, $euxye.useEffect)(()=>{
        if (limitReached && !ref.current) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'viewsetLimitBanner shown', {
            viewCount: viewCount
        });
        else if (!limitReached && ref.current) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'viewsetLimitBanner hidden', {
            viewCount: viewCount
        });
        ref.current = limitReached;
    }, [
        limitReached,
        createAnalyticsEvent,
        viewCount
    ]);
    if (!limitReached) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $93DVJ.LimitSectionMessage), {
        appearance: "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $e01fc28968a55e2a$var$styles.textContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage((0, $i860n.fg)('project_term_refresh_ga') ? $e01fc28968a55e2a$var$viewsetsPerProjectGalaxia : $e01fc28968a55e2a$var$viewsetsPerProject, {
        limit: viewsetsPerProjectLimit
    }))));
};
$e01fc28968a55e2a$export$e44797b961890009.displayName = "ViewsetLimitBanner";

});

parcelRegister("hj9Qm", function(module, exports) {
$parcel$export(module.exports, "JpdNavViewsProvider", () => $044ec5ecc3ab780b$export$5eefb551bee60262);
$parcel$export(module.exports, "useGetViewUrl", () => $044ec5ecc3ab780b$export$a884448b4a44a355);
$parcel$export(module.exports, "useAnalyticsL2", () => $044ec5ecc3ab780b$export$7cdcda8c1373402);
$parcel$export(module.exports, "useAnalyticsL3", () => $044ec5ecc3ab780b$export$17641a259b627600);
$parcel$export(module.exports, "useAnalyticsL4", () => $044ec5ecc3ab780b$export$64177d5cf62927a);
$parcel$export(module.exports, "useJpdNavViewName", () => $044ec5ecc3ab780b$export$7d6e5838ed725673);
$parcel$export(module.exports, "useSectionsEnabled", () => $044ec5ecc3ab780b$export$c09e399b12cef348);
$parcel$export(module.exports, "useContainerTypePermissions", () => $044ec5ecc3ab780b$export$8471d57404fc98ed);
$parcel$export(module.exports, "useIsReadOnly", () => $044ec5ecc3ab780b$export$692360c94a69c4f6);
$parcel$export(module.exports, "useContainerId", () => $044ec5ecc3ab780b$export$3773952d86dfc97b);
$parcel$export(module.exports, "useJpdNavCanManageViews", () => $044ec5ecc3ab780b$export$7914b616f024d75e);
$parcel$export(module.exports, "useViewsEntityLimitType", () => $044ec5ecc3ab780b$export$3c8bafa930842742);
$parcel$export(module.exports, "useViewsetsEntityLimitType", () => $044ec5ecc3ab780b$export$51194003e9988a46);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $koaaE = parcelRequire("koaaE");

var $d8n9z = parcelRequire("d8n9z");
const $044ec5ecc3ab780b$var$assertFunction = (text)=>()=>{
        throw new Error(`${text} must be implemented`);
    };
const $044ec5ecc3ab780b$var$Context = /*#__PURE__*/ (0, $euxye.createContext)({
    name: undefined,
    container: undefined,
    sectionsEnabled: false,
    containerTypePermissions: 'view',
    viewsEntityLimitType: undefined,
    viewsetsEntityLimitType: undefined,
    getViewUrl: $044ec5ecc3ab780b$var$assertFunction('getViewUrl'),
    useIsReadOnly: ()=>false,
    useAnalyticsL2: $044ec5ecc3ab780b$var$assertFunction('useAnalyticsL2'),
    useAnalyticsL3: $044ec5ecc3ab780b$var$assertFunction('useAnalyticsL3'),
    useAnalyticsL4: $044ec5ecc3ab780b$var$assertFunction('useAnalyticsL4')
});
const $044ec5ecc3ab780b$export$5eefb551bee60262 = $044ec5ecc3ab780b$var$Context.Provider;
const $044ec5ecc3ab780b$export$a884448b4a44a355 = ()=>{
    const { getViewUrl: getViewUrl } = (0, $euxye.useContext)($044ec5ecc3ab780b$var$Context);
    return getViewUrl;
};
const $044ec5ecc3ab780b$export$7cdcda8c1373402 = ()=>{
    const { useAnalyticsL2: useAnalyticsL2Provided } = (0, $euxye.useContext)($044ec5ecc3ab780b$var$Context);
    return useAnalyticsL2Provided();
};
const $044ec5ecc3ab780b$export$17641a259b627600 = ()=>{
    const { useAnalyticsL3: useAnalyticsL3Provided } = (0, $euxye.useContext)($044ec5ecc3ab780b$var$Context);
    return useAnalyticsL3Provided();
};
const $044ec5ecc3ab780b$export$64177d5cf62927a = ()=>{
    const { useAnalyticsL4: useAnalyticsL4Provided } = (0, $euxye.useContext)($044ec5ecc3ab780b$var$Context);
    return useAnalyticsL4Provided();
};
const $044ec5ecc3ab780b$export$7d6e5838ed725673 = ()=>{
    const { name: name } = (0, $euxye.useContext)($044ec5ecc3ab780b$var$Context);
    return name;
};
const $044ec5ecc3ab780b$export$c09e399b12cef348 = ()=>{
    const { sectionsEnabled: sectionsEnabled } = (0, $euxye.useContext)($044ec5ecc3ab780b$var$Context);
    return sectionsEnabled;
};
const $044ec5ecc3ab780b$export$8471d57404fc98ed = ()=>{
    const { containerTypePermissions: containerTypePermissions } = (0, $euxye.useContext)($044ec5ecc3ab780b$var$Context);
    return containerTypePermissions;
};
const $044ec5ecc3ab780b$export$692360c94a69c4f6 = (container)=>{
    const { useIsReadOnly: useIsReadOnlyProvided } = (0, $euxye.useContext)($044ec5ecc3ab780b$var$Context);
    return useIsReadOnlyProvided?.(container) ?? false;
};
const $044ec5ecc3ab780b$export$b537cf6ebaf7ff54 = ()=>{
    const { container: container } = (0, $euxye.useContext)($044ec5ecc3ab780b$var$Context);
    if (!container) throw new Error('Please provide `container` prop');
    return container;
};
const $044ec5ecc3ab780b$export$3773952d86dfc97b = ()=>{
    const container = $044ec5ecc3ab780b$export$b537cf6ebaf7ff54();
    if ((0, $d8n9z.isNavigationProject)(container)) return container.projectId;
    return container.collectionUUID;
};
const $044ec5ecc3ab780b$export$7914b616f024d75e = ()=>{
    const container = $044ec5ecc3ab780b$export$b537cf6ebaf7ff54();
    const containerTypePermissions = $044ec5ecc3ab780b$export$8471d57404fc98ed();
    const canManageViews = (0, $koaaE.useCanManageViews)();
    const containerId = (0, $d8n9z.isNavigationProject)(container) ? undefined : container.collectionUUID;
    const { canManageView: canManageView } = (0, $koaaE.useManageViewPermissions)(containerId);
    const isReadOnly = $044ec5ecc3ab780b$export$692360c94a69c4f6();
    if (containerTypePermissions === 'view') return canManageViews && !isReadOnly;
    return canManageView && !isReadOnly;
};
const $044ec5ecc3ab780b$export$3c8bafa930842742 = ()=>{
    const { viewsEntityLimitType: viewsEntityLimitType } = (0, $euxye.useContext)($044ec5ecc3ab780b$var$Context);
    if (!viewsEntityLimitType) throw new Error('Please provide entityLimitType as `viewsEntityLimitType` prop');
    return viewsEntityLimitType;
};
const $044ec5ecc3ab780b$export$51194003e9988a46 = ()=>{
    const { viewsetsEntityLimitType: viewsetsEntityLimitType } = (0, $euxye.useContext)($044ec5ecc3ab780b$var$Context);
    return viewsetsEntityLimitType;
};

});

parcelRegister("69J1d", function(module, exports) {
$parcel$export(module.exports, "BasicViewSets", () => $9ecbc7b5996f88e5$export$a4c7ebadfd23e782);

var $euxye = parcelRequire("euxye");

var $dH1Sa = parcelRequire("dH1Sa");

var $ceqcm = parcelRequire("ceqcm");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $8g0Rt = parcelRequire("8g0Rt");

var $hj9Qm = parcelRequire("hj9Qm");
const $9ecbc7b5996f88e5$var$createNewSection = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.create-new-section",
    defaultMessage: "Section"
});
const $9ecbc7b5996f88e5$export$a4c7ebadfd23e782 = ({ createViewHandlers: createViewHandlers, hasReachedViewsetsLimit: hasReachedViewsetsLimit })=>{
    const viewsetsEntityLimitType = (0, $hj9Qm.useViewsetsEntityLimitType)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    if (!viewsetsEntityLimitType) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.create-view-menu.menu.section",
        onClick: createViewHandlers[0, $dH1Sa.VIEW_KIND_SECTION],
        isDisabled: !!hasReachedViewsetsLimit,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8g0Rt.ViewItemIcon), {
            viewKind: (0, $dH1Sa.VIEW_KIND_SECTION),
            color: hasReachedViewsetsLimit ? "var(--ds-icon-disabled, #080F214A)" : undefined,
            label: ""
        })
    }, formatMessage($9ecbc7b5996f88e5$var$createNewSection));
};
$9ecbc7b5996f88e5$export$a4c7ebadfd23e782.displayName = "BasicViewSets";

});
parcelRegister("8g0Rt", function(module, exports) {
$parcel$export(module.exports, "ViewItemIcon", () => $778ed9083c911049$export$5dbff0380d392fbc);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $dH1Sa = parcelRequire("dH1Sa");

var $j1V7P = parcelRequire("j1V7P");

var $i5VaD = parcelRequire("i5VaD");

var $829AJ = parcelRequire("829AJ");

var $dwO1n = parcelRequire("dwO1n");

var $fpBld = parcelRequire("fpBld");

var $dgcjP = parcelRequire("dgcjP");

var $8LNQ0 = parcelRequire("8LNQ0");

var $i860n = parcelRequire("i860n");
const $778ed9083c911049$export$5dbff0380d392fbc = ({ isSelected: isSelected, viewKind: viewKind, locked: locked, ...rest })=>{
    const color = isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)";
    if ((0, $i860n.fg)('jpd_tree-view')) {
        if (locked) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8LNQ0))), {
            color: color,
            ...rest
        });
    }
    switch(viewKind){
        case 0, $dH1Sa.VIEW_KIND_TABLE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwO1n))), {
                color: color,
                ...rest
            });
        case 0, $dH1Sa.VIEW_KIND_BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j1V7P))), {
                color: color,
                ...rest
            });
        case 0, $dH1Sa.VIEW_KIND_MATRIX:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i5VaD))), {
                color: color,
                ...rest
            });
        case 0, $dH1Sa.VIEW_KIND_TIMELINE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dgcjP))), {
                color: color,
                ...rest
            });
        case 0, $dH1Sa.VIEW_KIND_TREE:
            if ((0, $i860n.fg)('jpd_tree-view')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fpBld))), {
                color: color,
                ...rest
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwO1n))), {
                color: color,
                ...rest
            });
        case 0, $dH1Sa.VIEW_KIND_SECTION:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($829AJ))), {
                color: color,
                ...rest
            });
        default:
            return null;
    }
};
$778ed9083c911049$export$5dbff0380d392fbc.displayName = "ViewItemIcon";

});
parcelRegister("i5VaD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::379d27dc2254a712c7e5f662436ba8d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2c50a82b74b5d5d$var$_react = $d2c50a82b74b5d5d$var$_interopRequireDefault((parcelRequire("euxye")));

var $d2c50a82b74b5d5d$var$_baseNew = $d2c50a82b74b5d5d$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $d2c50a82b74b5d5d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBubble".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chart-bubble
 * Usage guidance:
 * Known uses: Bubble and matrix charts; Matrix view in in JPD
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2c50a82b74b5d5d$var$ChartBubbleIcon = (props)=>/*#__PURE__*/ $d2c50a82b74b5d5d$var$_react.default.createElement($d2c50a82b74b5d5d$var$_baseNew.default, Object.assign({
        name: "ChartBubbleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M11.27 9.01a1.38 1.38 0 1 1-1.51 1.51l-.01-.14.01-.14A1.38 1.38 0 0 1 11.13 9zM5.75 6.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m4.75-5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"/>`
    }, props));
$d2c50a82b74b5d5d$var$ChartBubbleIcon.displayName = 'ChartBubbleIcon';
var $d2c50a82b74b5d5d$var$_default = module.exports.default = $d2c50a82b74b5d5d$var$ChartBubbleIcon;

});

parcelRegister("829AJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74510fa05808e33e81f85bcea0e54cb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d95f351a4957ac6$var$_react = $5d95f351a4957ac6$var$_interopRequireDefault((parcelRequire("euxye")));

var $5d95f351a4957ac6$var$_baseNew = $5d95f351a4957ac6$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $5d95f351a4957ac6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderOpen".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/folder-open
 * Usage guidance:
 * Single purpose - Reserved for open folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d95f351a4957ac6$var$FolderOpenIcon = (props)=>/*#__PURE__*/ $5d95f351a4957ac6$var$_react.default.createElement($5d95f351a4957ac6$var$_baseNew.default, Object.assign({
        name: "FolderOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v9.473L3.148 6.98c.174-.582.71-.98 1.317-.98H12.5V4.75a.5.5 0 0 0-.5-.5H6.69L4.94 2.5zM14 6h.66c.921 0 1.582.888 1.317 1.77l-1.741 5.805A2 2 0 0 1 12.32 15H1.75A1.75 1.75 0 0 1 0 13.25V3a2 2 0 0 1 2-2h3.56l1.75 1.75H12a2 2 0 0 1 2 2zM2.758 13.5h9.562a.5.5 0 0 0 .479-.356L14.492 7.5H4.558z" clip-rule="evenodd"/>`
    }, props));
$5d95f351a4957ac6$var$FolderOpenIcon.displayName = 'FolderOpenIcon';
var $5d95f351a4957ac6$var$_default = module.exports.default = $5d95f351a4957ac6$var$FolderOpenIcon;

});

parcelRegister("fpBld", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7f8166e4f086af09f2396ad26afb633>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02e542b5ae433013$var$_react = $02e542b5ae433013$var$_interopRequireDefault((parcelRequire("euxye")));

var $02e542b5ae433013$var$_baseNew = $02e542b5ae433013$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $02e542b5ae433013$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Department".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/department
 * Usage guidance:
 * Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02e542b5ae433013$var$DepartmentIcon = (props)=>/*#__PURE__*/ $02e542b5ae433013$var$_react.default.createElement($02e542b5ae433013$var$_baseNew.default, Object.assign({
        name: "DepartmentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5.75A.75.75 0 0 1 6.25 0h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-1v2.25h3.125c.76 0 1.375.616 1.375 1.375V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.75h-7.5V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.625c0-.76.616-1.375 1.375-1.375H7.25V5h-1a.75.75 0 0 1-.75-.75zM7 1.5v2h2v-2zm-4.5 11v2h2v-2zm9 0v2h2v-2z" clip-rule="evenodd"/>`
    }, props));
$02e542b5ae433013$var$DepartmentIcon.displayName = 'DepartmentIcon';
var $02e542b5ae433013$var$_default = module.exports.default = $02e542b5ae433013$var$DepartmentIcon;

});

parcelRegister("dgcjP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::adcc0cfe35572eed101889cd117d62a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a76534235d15e18$var$_react = $9a76534235d15e18$var$_interopRequireDefault((parcelRequire("euxye")));

var $9a76534235d15e18$var$_baseNew = $9a76534235d15e18$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $9a76534235d15e18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Timeline".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/timeline
 * Usage guidance:
 * Single purpose - Reserved for timelines in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a76534235d15e18$var$TimelineIcon = (props)=>/*#__PURE__*/ $9a76534235d15e18$var$_react.default.createElement($9a76534235d15e18$var$_baseNew.default, Object.assign({
        name: "TimelineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11 2.5H1V1h10zm4 4.167H5v-1.5h10zm-4 4.167H1v-1.5h10zM15 15H5v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$9a76534235d15e18$var$TimelineIcon.displayName = 'TimelineIcon';
var $9a76534235d15e18$var$_default = module.exports.default = $9a76534235d15e18$var$TimelineIcon;

});

parcelRegister("8LNQ0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a62885bf2499ce3e3ae53a4060ebf5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66295f419e82180e$var$_react = $66295f419e82180e$var$_interopRequireDefault((parcelRequire("euxye")));

var $66295f419e82180e$var$_baseNew = $66295f419e82180e$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $66295f419e82180e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/lock-locked
 * Usage guidance:
 * Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66295f419e82180e$var$LockLockedIcon = (props)=>/*#__PURE__*/ $66295f419e82180e$var$_react.default.createElement($66295f419e82180e$var$_baseNew.default, Object.assign({
        name: "LockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$66295f419e82180e$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $66295f419e82180e$var$_default = module.exports.default = $66295f419e82180e$var$LockLockedIcon;

});



parcelRegister("jfiTi", function(module, exports) {
$parcel$export(module.exports, "BasicViewsList", () => $68d84d7d9e2d80a0$export$5cac567fa5c10e);

var $euxye = parcelRequire("euxye");

var $dH1Sa = parcelRequire("dH1Sa");

var $ceqcm = parcelRequire("ceqcm");

var $g36LP = parcelRequire("g36LP");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $8g0Rt = parcelRequire("8g0Rt");

var $hPnAm = parcelRequire("hPnAm");

var $6GtaN = parcelRequire("6GtaN");

var $ktZBV = parcelRequire("ktZBV");
const $68d84d7d9e2d80a0$var$createNewList = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.create-new-list",
    defaultMessage: "List view"
});
const $68d84d7d9e2d80a0$var$createNewBoard = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.create-new-board",
    defaultMessage: "Board view"
});
const $68d84d7d9e2d80a0$var$createNewMatrix = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.create-new-matrix",
    defaultMessage: "Matrix view"
});
const $68d84d7d9e2d80a0$var$createNewTimeline = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.create-new-timeline",
    defaultMessage: "Timeline view"
});
const $68d84d7d9e2d80a0$var$createNewTree = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.create-new-tree",
    defaultMessage: "Tree view"
});
const $68d84d7d9e2d80a0$var$itemsConfigOld = [
    {
        viewKind: (0, $dH1Sa.VIEW_KIND_TABLE),
        message: $68d84d7d9e2d80a0$var$createNewList,
        testId: 'navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.create-view-menu.menu.table'
    },
    {
        viewKind: (0, $dH1Sa.VIEW_KIND_BOARD),
        message: $68d84d7d9e2d80a0$var$createNewBoard,
        testId: 'navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.create-view-menu.menu.board'
    },
    {
        viewKind: (0, $dH1Sa.VIEW_KIND_TIMELINE),
        message: $68d84d7d9e2d80a0$var$createNewTimeline,
        testId: 'navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.create-view-menu.menu.timeline'
    },
    {
        viewKind: (0, $dH1Sa.VIEW_KIND_MATRIX),
        message: $68d84d7d9e2d80a0$var$createNewMatrix,
        testId: 'navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.create-view-menu.menu.matrix'
    }
];
const $68d84d7d9e2d80a0$var$itemsConfig = [
    {
        viewKind: (0, $dH1Sa.VIEW_KIND_TABLE),
        message: $68d84d7d9e2d80a0$var$createNewList,
        testId: 'navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.create-view-menu.menu.table'
    },
    {
        viewKind: (0, $dH1Sa.VIEW_KIND_BOARD),
        message: $68d84d7d9e2d80a0$var$createNewBoard,
        testId: 'navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.create-view-menu.menu.board'
    },
    {
        viewKind: (0, $dH1Sa.VIEW_KIND_TIMELINE),
        message: $68d84d7d9e2d80a0$var$createNewTimeline,
        testId: 'navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.create-view-menu.menu.timeline'
    },
    {
        viewKind: (0, $dH1Sa.VIEW_KIND_MATRIX),
        message: $68d84d7d9e2d80a0$var$createNewMatrix,
        testId: 'navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.create-view-menu.menu.matrix'
    },
    {
        viewKind: (0, $dH1Sa.VIEW_KIND_TREE),
        message: $68d84d7d9e2d80a0$var$createNewTree,
        testId: 'navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.create-view-menu.menu.tree'
    }
];
const $68d84d7d9e2d80a0$export$5cac567fa5c10e = ({ createViewHandlers: createViewHandlers, hasReachedViewsLimit: hasReachedViewsLimit })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const isViewKindLocked = (0, $hPnAm.useIsViewKindLocked)();
    const items = (0, $i860n.fg)('jpd_tree-view') ? $68d84d7d9e2d80a0$var$itemsConfig.filter(({ viewKind: viewKind })=>!isViewKindLocked(viewKind)) : $68d84d7d9e2d80a0$var$itemsConfigOld;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true
    }, ((0, $i860n.fg)('jpd_tree-view-standard-upgrade') ? $68d84d7d9e2d80a0$var$itemsConfig : items).map(({ viewKind: viewKind, message: message, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6GtaN.ViewItemTooltip), {
            key: viewKind,
            viewKind: viewKind
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
            testId: testId,
            onClick: createViewHandlers[viewKind],
            isDisabled: !!hasReachedViewsLimit || isViewKindLocked(viewKind),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8g0Rt.ViewItemIcon), {
                viewKind: viewKind,
                color: hasReachedViewsLimit ? "var(--ds-icon-disabled, #080F214A)" : undefined,
                label: ""
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ktZBV.ViewItemIconAfter), {
                viewKind: viewKind
            })
        }, formatMessage(message)))));
};
$68d84d7d9e2d80a0$export$5cac567fa5c10e.displayName = "BasicViewsList";

});
parcelRegister("hPnAm", function(module, exports) {
$parcel$export(module.exports, "useIsViewKindLocked", () => $1881eb92ff9a1ba3$export$760081672621da5);

var $euxye = parcelRequire("euxye");

var $dH1Sa = parcelRequire("dH1Sa");

var $7De3l = parcelRequire("7De3l");

var $6ZLJT = parcelRequire("6ZLJT");

var $i860n = parcelRequire("i860n");
const $1881eb92ff9a1ba3$export$760081672621da5 = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jpd_tree-view'), ()=>{
    const isTreeViewEnabled = (0, $7De3l.useIsTreeViewEnabled)();
    return (0, $euxye.useCallback)((viewKind)=>{
        switch(viewKind){
            case 0, $dH1Sa.VIEW_KIND_TREE:
                return !isTreeViewEnabled;
            default:
                return false;
        }
    }, [
        isTreeViewEnabled
    ]);
}, ()=>()=>false);

});
parcelRegister("7De3l", function(module, exports) {
$parcel$export(module.exports, "useIsTreeViewEnabled", () => $5bad2a414aee3260$export$cf9bbe17dc4f5414);

var $cvA2R = parcelRequire("cvA2R");

var $dV3gw = parcelRequire("dV3gw");
const $5bad2a414aee3260$export$cf9bbe17dc4f5414 = ()=>{
    const isPremium = (0, $dV3gw.useIsPremiumEdition)();
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    // For anonymous users on public views, we enable tree view since the backend won't expose non-premium views anyway
    return isPremium || isAnonymous;
};

});


parcelRegister("6GtaN", function(module, exports) {
$parcel$export(module.exports, "ViewItemTooltip", () => $f9d25724813af71c$export$f209ac53d42f1824);

var $euxye = parcelRequire("euxye");

var $dH1Sa = parcelRequire("dH1Sa");

var $i860n = parcelRequire("i860n");

var $8mkOp = parcelRequire("8mkOp");
const $f9d25724813af71c$export$f209ac53d42f1824 = ({ viewKind: viewKind, children: children })=>{
    if (viewKind === (0, $dH1Sa.VIEW_KIND_TREE) && (0, $i860n.fg)('jpd_tree-view-standard-upgrade')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8mkOp.TreeViewTooltip), null, children);
    return children;
};
$f9d25724813af71c$export$f209ac53d42f1824.displayName = "ViewItemTooltip";

});
parcelRegister("8mkOp", function(module, exports) {
$parcel$export(module.exports, "TreeViewTooltip", () => $da1b6312b0970e8f$export$da6ab419045b1ee0);
/* TreeViewTooltip.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $gboXr = parcelRequire("gboXr");

var $1n6C5 = parcelRequire("1n6C5");

var $2zpkm = parcelRequire("2zpkm");

var $dH1Sa = parcelRequire("dH1Sa");

var $h8QGu = parcelRequire("h8QGu");

var $lsC3n = parcelRequire("lsC3n");

var $3NRLa = parcelRequire("3NRLa");

var $8qjTI = parcelRequire("8qjTI");

var $hZDXn = parcelRequire("hZDXn");

var $ihEDU = parcelRequire("ihEDU");

var $jleyn = parcelRequire("jleyn");

var $413te = parcelRequire("413te");

var $KcP1c = parcelRequire("KcP1c");

var $7okqc = parcelRequire("7okqc");

var $liP0D = parcelRequire("liP0D");

var $jFNyB = parcelRequire("jFNyB");

var $a8EUd = parcelRequire("a8EUd");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $hPnAm = parcelRequire("hPnAm");
const $da1b6312b0970e8f$var$LEARN_MORE_URL = 'https://community.atlassian.com/forums/Jira-Product-Discovery-articles/The-tree-view-is-now-generally-available-Premium-plan/ba-p/3249554#M4142';
const $da1b6312b0970e8f$var$tooltipTitle = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.tree-view-tooltip-title",
    defaultMessage: "Tree view has landed in Premium"
});
const $da1b6312b0970e8f$var$tooltipDescription = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.tree-view-tooltip-description",
    defaultMessage: "Connect customer problems to solutions and experiments in a visual hierarchy."
});
const $da1b6312b0970e8f$var$tooltipLearnMoreButton = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.tree-view-tooltip-learn-more-button",
    defaultMessage: "Learn more"
});
const $da1b6312b0970e8f$var$tooltipIllustrationAlt = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.tree-view-tooltip-illustration-alt",
    defaultMessage: "Tree view premium illustration"
});
const $da1b6312b0970e8f$var$styles = {
    tooltipContainer: "_2rko1mok _zulpu2gc _1reo15vq _18m915vq _1bsbaq3k _1q51u2gc _85i5utpp _1e0c1txw _2lx21bp4 _16qs1nax _vchhusvi"
};
const $da1b6312b0970e8f$var$TooltipContainer = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8qjTI.default), {
        ...rest,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        backgroundColor: "color.background.neutral.bold",
        xcss: $da1b6312b0970e8f$var$styles.tooltipContainer
    }, children)));
const $da1b6312b0970e8f$var$LearnMoreButton = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jleyn.SpotlightPrimaryLink), {
        href: $da1b6312b0970e8f$var$LEARN_MORE_URL,
        appearance: "outline"
    }, formatMessage($da1b6312b0970e8f$var$tooltipLearnMoreButton));
};
$da1b6312b0970e8f$var$LearnMoreButton.displayName = "LearnMoreButton";
const $da1b6312b0970e8f$var$TreeViewLockedTooltipContent = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $KcP1c.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $413te.SpotlightHeadline), null, formatMessage($da1b6312b0970e8f$var$tooltipTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gboXr.Illustration), {
        srcLight: (0, (/*@__PURE__*/$parcel$interopDefault($1n6C5))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($2zpkm))),
        alt: formatMessage($da1b6312b0970e8f$var$tooltipIllustrationAlt),
        width: 295,
        height: 135
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $liP0D.SpotlightBody), null, formatMessage($da1b6312b0970e8f$var$tooltipDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7okqc.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jFNyB.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "jpd.nav-views.tree-view.upgrade-button",
        teamName: "JPD - Sirius",
        packageName: "jiraNavigationAppsSidebarNav4SidebarsCommonJpdNavViews",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "upgrade-button",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: "150px",
            height: "22px"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lsC3n.UpgradeButton), {
        appearance: "spotlight",
        unavailablePlaceholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($da1b6312b0970e8f$var$LearnMoreButton, null)
    }))))));
};
$da1b6312b0970e8f$var$TreeViewLockedTooltipContent.displayName = "TreeViewLockedTooltipContent";
const $da1b6312b0970e8f$export$da6ab419045b1ee0 = ({ children: children })=>{
    const isViewKindLocked = (0, $hPnAm.useIsViewKindLocked)();
    if (isViewKindLocked((0, $dH1Sa.VIEW_KIND_TREE))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        position: "right",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($da1b6312b0970e8f$var$TreeViewLockedTooltipContent, null),
        component: $da1b6312b0970e8f$var$TooltipContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("span", null, children));
    return children;
};
$da1b6312b0970e8f$export$da6ab419045b1ee0.displayName = "TreeViewTooltip";

});
parcelRegister("1n6C5", function(module, exports) {
module.exports = new URL("jpd-treeview-spotlight-image.80f227c5.svg", import.meta.url).toString();

});

parcelRegister("2zpkm", function(module, exports) {
module.exports = new URL("jpd-treeview-spotlight-image-dark.b4bad843.svg", import.meta.url).toString();

});

parcelRegister("lsC3n", function(module, exports) {
$parcel$export(module.exports, "UpgradeButton", () => $19118d0de3483140$export$5f79cadb3a637092);

var $e7boj = parcelRequire("e7boj");

var $dFj4X = parcelRequire("dFj4X");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $3zT69 = parcelRequire("3zT69");

var $9ufM9 = parcelRequire("9ufM9");

var $1Pip6 = parcelRequire("1Pip6");

var $jleyn = parcelRequire("jleyn");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $kt86l = parcelRequire("kt86l");
const $19118d0de3483140$var$upgradeMessage = (0, $7eNDO.defineMessage)({
    id: "polaris__component-entitlements.upgrade-button.upgrade-message",
    defaultMessage: "Upgrade"
});
const $19118d0de3483140$export$5f79cadb3a637092 = (t0)=>{
    const $ = (0, $e7boj.c)(14);
    const { appearance: t1, unavailablePlaceholder: unavailablePlaceholder } = t0;
    const appearance = t1 === undefined ? "discovery" : t1;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const cloudId = (0, $kt86l.useCloudId)();
    let t2;
    if ($[0] !== cloudId) {
        t2 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t2;
    } else t2 = $[1];
    const data = (0, $n67Vb.useLazyLoadQuery)((0, $dFj4X.default), t2);
    const isAvailableToUser = data.tenantContexts?.[0]?.entitlementInfo?.entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser ?? false;
    const experienceUrl = data.tenantContexts?.[0]?.entitlementInfo?.entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl ?? null;
    let t3;
    bb0: {
        if (!experienceUrl) {
            t3 = null;
            break bb0;
        }
        let t4;
        if ($[2] !== experienceUrl) {
            const origin = new (0, $3zT69.default)({
                product: "jira"
            });
            t4 = origin.addToUrl(experienceUrl);
            $[2] = experienceUrl;
            $[3] = t4;
        } else t4 = $[3];
        t3 = t4;
    }
    const experienceUrlWithOrigin = t3;
    if (!isAvailableToUser || !experienceUrlWithOrigin) {
        if (unavailablePlaceholder !== undefined) return unavailablePlaceholder;
        return null;
    }
    if (appearance === "spotlight") {
        let t4;
        if ($[4] !== formatMessage) {
            t4 = formatMessage($19118d0de3483140$var$upgradeMessage);
            $[4] = formatMessage;
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== experienceUrlWithOrigin || $[7] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jleyn.SpotlightPrimaryLink), {
                href: experienceUrlWithOrigin,
                appearance: "outline"
            }, t4);
            $[6] = experienceUrlWithOrigin;
            $[7] = t4;
            $[8] = t5;
        } else t5 = $[8];
        return t5;
    }
    let t4;
    if ($[9] !== formatMessage) {
        t4 = formatMessage($19118d0de3483140$var$upgradeMessage);
        $[9] = formatMessage;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== experienceUrlWithOrigin || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9ufM9.default), {
            href: experienceUrlWithOrigin,
            appearance: "discovery",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($1Pip6)))
        }, t4);
        $[11] = experienceUrlWithOrigin;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
};
$19118d0de3483140$export$5f79cadb3a637092.displayName = "UpgradeButton";

});
parcelRegister("dFj4X", function(module, exports) {
$parcel$export(module.exports, "default", () => $6333f956f71de209$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b2c00b632b253b35364575731aca91f>>
 * @relayHash 945d76fd50457a7f5a0516d151064ab8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 793271a572f03da5e2674b5b4e49dbd16f8147c0f1c9ae4827452690ee71e09d
const $6333f956f71de209$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "jira-product-discovery"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "offeringName",
                        "value": "Premium"
                    }
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "experienceUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isAvailableToUser"
                    }
                ],
                "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
            }
        ],
        "type": "CcpEntitlementExperienceCapabilities"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UpgradeButtonQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"jira-product-discovery\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UpgradeButtonQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"jira-product-discovery\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "793271a572f03da5e2674b5b4e49dbd16f8147c0f1c9ae4827452690ee71e09d",
            "metadata": {},
            "name": "UpgradeButtonQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6333f956f71de209$var$node.hash = "acd636a7e5b9c4352187a3e9e8a66857";
var $6333f956f71de209$export$2e2bcd8739ae039 = $6333f956f71de209$var$node;

});




parcelRegister("ktZBV", function(module, exports) {
$parcel$export(module.exports, "ViewItemIconAfter", () => $6ccd311b3cf0b80d$export$62d104fa9682548f);

var $euxye = parcelRequire("euxye");

var $dH1Sa = parcelRequire("dH1Sa");

var $2EFuW = parcelRequire("2EFuW");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $hPnAm = parcelRequire("hPnAm");
const $6ccd311b3cf0b80d$var$newLozenge = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.tree-view-new-lozenge",
    defaultMessage: "New"
});
const $6ccd311b3cf0b80d$var$premiumLozenge = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.premium-lozenge",
    defaultMessage: "Premium"
});
const $6ccd311b3cf0b80d$export$62d104fa9682548f = ({ viewKind: viewKind })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const isViewKindLocked = (0, $hPnAm.useIsViewKindLocked)();
    if (isViewKindLocked(viewKind) && (0, $i860n.fg)('jpd_tree-view-standard-upgrade')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
        appearance: "discovery"
    }, formatMessage($6ccd311b3cf0b80d$var$premiumLozenge));
    if (viewKind === (0, $dH1Sa.VIEW_KIND_TREE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
        appearance: "discovery"
    }, formatMessage($6ccd311b3cf0b80d$var$newLozenge));
    return null;
};
$6ccd311b3cf0b80d$export$62d104fa9682548f.displayName = "ViewItemIconAfter";

});






parcelRegister("atbVz", function(module, exports) {
$parcel$export(module.exports, "JpdNavViewsContainer", () => $af984dbda4a11906$export$a0c74517cb1fb23b);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $hj9Qm = parcelRequire("hj9Qm");

var $9lZtH = parcelRequire("9lZtH");
const $af984dbda4a11906$var$returnFalse = ()=>false;
const $af984dbda4a11906$export$a0c74517cb1fb23b = ({ children: children, name: name, container: container, sectionsEnabled: sectionsEnabled, containerTypePermissions: containerTypePermissions, viewsEntityLimitType: viewsEntityLimitType, viewsetsEntityLimitType: viewsetsEntityLimitType, getViewUrl: getViewUrl, useIsReadOnly: useIsReadOnly = $af984dbda4a11906$var$returnFalse, useAnalyticsL2: useAnalyticsL2, useAnalyticsL3: useAnalyticsL3, useAnalyticsL4: useAnalyticsL4 })=>{
    const value = (0, $euxye.useMemo)(()=>// oxlint-disable-next-line typescript/consistent-type-assertions
        ({
            name: name,
            container: container,
            sectionsEnabled: sectionsEnabled,
            containerTypePermissions: containerTypePermissions,
            viewsEntityLimitType: viewsEntityLimitType,
            viewsetsEntityLimitType: viewsetsEntityLimitType,
            getViewUrl: getViewUrl,
            useIsReadOnly: useIsReadOnly,
            useAnalyticsL2: useAnalyticsL2,
            useAnalyticsL3: useAnalyticsL3,
            useAnalyticsL4: useAnalyticsL4
        }), [
        name,
        container,
        sectionsEnabled,
        containerTypePermissions,
        viewsEntityLimitType,
        viewsetsEntityLimitType,
        getViewUrl,
        useIsReadOnly,
        useAnalyticsL2,
        useAnalyticsL3,
        useAnalyticsL4
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hj9Qm.JpdNavViewsProvider), {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9lZtH.JpdNavViewsPermissions), null, children));
};
$af984dbda4a11906$export$a0c74517cb1fb23b.displayName = "JpdNavViewsContainer";

});
parcelRegister("9lZtH", function(module, exports) {
$parcel$export(module.exports, "JpdNavViewsPermissions", () => $aa9c477b5c33ab6d$export$503bd621e7581bbc);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $koaaE = parcelRequire("koaaE");

var $hj9Qm = parcelRequire("hj9Qm");
const $aa9c477b5c33ab6d$var$JpdNavViewsPermissionsLoader = ({ children: children })=>{
    const containerId = (0, $hj9Qm.useContainerId)();
    const { loadViewPermissionsForCurrentUser: loadViewPermissionsForCurrentUser } = (0, $koaaE.useManageViewPermissions)(containerId);
    (0, $euxye.useEffect)(()=>{
        loadViewPermissionsForCurrentUser(containerId);
    }, [
        loadViewPermissionsForCurrentUser,
        containerId
    ]);
    return children;
};
$aa9c477b5c33ab6d$var$JpdNavViewsPermissionsLoader.displayName = "JpdNavViewsPermissionsLoader";
const $aa9c477b5c33ab6d$export$503bd621e7581bbc = ({ children: children })=>{
    const containerTypePermissions = (0, $hj9Qm.useContainerTypePermissions)();
    if (containerTypePermissions === 'view') // For `view` based permissions we trigger loading
    // based on user interaction like opening a view menu
    return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($aa9c477b5c33ab6d$var$JpdNavViewsPermissionsLoader, null, children);
};
$aa9c477b5c33ab6d$export$503bd621e7581bbc.displayName = "JpdNavViewsPermissions";

});


parcelRegister("lwxMv", function(module, exports) {
$parcel$export(module.exports, "useRoadmapsAnalyticsL2", () => $378b13ac43bb7a5f$export$3bd6eb92260c52df);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");






var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
const $378b13ac43bb7a5f$export$3bd6eb92260c52df = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const commonAttributes = (0, $euxye.useMemo)(()=>({
            level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1)
        }), []);
    // meatball menu on roadmaps
    const sendMeatBallDropDownOnProjectsAnalyticsEvent = (0, $euxye.useCallback)((container)=>{
        const { collectionUUID: collectionUUID } = container;
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$9bd6c21d500ae611),
            itemId: (0, $90c0351d239ffedb$export$f06dfcec5ff912e),
            parentItemId: collectionUUID,
            parentItemType: (0, $687cb22024c607c7$export$bb8a37ab8d9ba82b)
        };
        (0, $aJ81Y.fireUIAnalytics)(event, 'roadmapsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // view navigation item under each roadmap
    const sendViewNavigationItemInsideProjectsAnalyticsEvent = (0, $euxye.useCallback)(({ container: container, viewParams: viewParams })=>{
        const { collectionUUID: collectionUUID } = container;
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
            itemId: viewParams.viewId,
            itemType: viewParams.viewKind,
            parentItemId: collectionUUID,
            parentItemType: (0, $687cb22024c607c7$export$bb8a37ab8d9ba82b)
        };
        (0, $aJ81Y.fireUIAnalytics)(event, 'roadmapsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // create view button on view navigation item
    const sendCreateViewOnViewNavigationItemAnalyticsEvent = (0, $euxye.useCallback)((container)=>{
        const { collectionUUID: collectionUUID } = container;
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$9bd6c21d500ae611),
            itemId: 'createView',
            parentItemId: collectionUUID,
            parentItemType: (0, $687cb22024c607c7$export$bb8a37ab8d9ba82b)
        };
        (0, $aJ81Y.fireUIAnalytics)(event, 'roadmapsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // create view button on roadmaps menu
    const sendCreateViewOnProjectMenuItemAnalyticsEvent = (0, $euxye.useCallback)((container)=>{
        const { collectionUUID: collectionUUID } = container;
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$9bd6c21d500ae611),
            itemId: 'createView',
            parentItemId: collectionUUID,
            parentItemType: (0, $687cb22024c607c7$export$bb8a37ab8d9ba82b)
        };
        (0, $aJ81Y.fireUIAnalytics)(event, 'roadmapsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent,
        sendViewNavigationItemInsideProjectsAnalyticsEvent: sendViewNavigationItemInsideProjectsAnalyticsEvent,
        sendCreateViewOnViewNavigationItemAnalyticsEvent: sendCreateViewOnViewNavigationItemAnalyticsEvent,
        sendCreateViewOnProjectMenuItemAnalyticsEvent: sendCreateViewOnProjectMenuItemAnalyticsEvent
    };
};

});

parcelRegister("gZM30", function(module, exports) {
$parcel$export(module.exports, "useRoadmapsAnalyticsL3", () => $4c66489f1e143d30$export$9314088c4af39062);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");






var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
const $4c66489f1e143d30$export$9314088c4af39062 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const commonAttributes = (0, $euxye.useMemo)(()=>({
            level: (0, $ef39084c605eb7e8$export$f9db6a58b4aabd18)
        }), []);
    // actions inside meatball menu on projects
    const sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent = (0, $euxye.useCallback)(({ itemId: itemId, container: container })=>{
        const { collectionUUID: collectionUUID } = container;
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: collectionUUID,
            parentItemType: (0, $687cb22024c607c7$export$fe791c4fa892e400)
        };
        (0, $aJ81Y.fireUIAnalytics)(event, 'roadmapsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // meatball menu on views
    const sendMeatBallDropDownOnViewsAnalyticsEvent = (0, $euxye.useCallback)(({ container: container, viewParams: viewParams })=>{
        const { collectionUUID: collectionUUID } = container;
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$9bd6c21d500ae611),
            itemId: (0, $90c0351d239ffedb$export$f06dfcec5ff912e),
            collectionUUID: collectionUUID,
            parentItemId: viewParams.viewId,
            parentItemType: viewParams.viewKind
        };
        (0, $aJ81Y.fireUIAnalytics)(event, 'roadmapsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // actions inside create view menu on projects
    const sendCreateViewDropDownOnProjectMenuItemAnalyticsEvent = (0, $euxye.useCallback)(({ itemId: itemId, container: container, viewParams: viewParams })=>{
        const { collectionUUID: collectionUUID } = container;
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$56981f28056f258e),
            itemId: itemId,
            itemType: viewParams.viewKind,
            parentItemId: collectionUUID,
            parentItemType: (0, $687cb22024c607c7$export$bb8a37ab8d9ba82b),
            collectionUUID: collectionUUID
        };
        (0, $aJ81Y.fireUIAnalytics)(event, 'roadmapsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent: sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent,
        sendMeatBallDropDownOnViewsAnalyticsEvent: sendMeatBallDropDownOnViewsAnalyticsEvent,
        sendCreateViewDropDownOnProjectMenuItemAnalyticsEvent: sendCreateViewDropDownOnProjectMenuItemAnalyticsEvent
    };
};

});

parcelRegister("29ILa", function(module, exports) {
$parcel$export(module.exports, "useRoadmapsAnalyticsL4", () => $aca64102c1ec707e$export$2f10e47de52a2aad);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");




var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
const $aca64102c1ec707e$export$2f10e47de52a2aad = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const commonAttributes = (0, $euxye.useMemo)(()=>({
            level: (0, $ef39084c605eb7e8$export$35ac629b8b943d5a)
        }), []);
    // actions inside meatball menu on views
    const sendMeatBallDropDownOnViewsMenuItemAnalyticsEvent = (0, $euxye.useCallback)(({ itemId: itemId, container: container, viewParams: viewParams })=>{
        const { collectionUUID: collectionUUID } = container;
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $6e2f51712bb2e810$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: viewParams.viewId,
            parentItemType: viewParams.viewKind,
            collectionUUID: collectionUUID
        };
        (0, $aJ81Y.fireUIAnalytics)(event, 'roadmapsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownOnViewsMenuItemAnalyticsEvent: sendMeatBallDropDownOnViewsMenuItemAnalyticsEvent
    };
};

});

parcelRegister("j42hx", function(module, exports) {
$parcel$export(module.exports, "RoadmapMenuItems", () => $405d76c4b4a94a3c$export$454208c8def7920f);

var $f3yp7 = parcelRequire("f3yp7");

var $euxye = parcelRequire("euxye");

var $aOGXw = parcelRequire("aOGXw");

var $anSqv = parcelRequire("anSqv");

var $iPHqm = parcelRequire("iPHqm");

var $l01S5 = parcelRequire("l01S5");

var $koaaE = parcelRequire("koaaE");

var $n67Vb = parcelRequire("n67Vb");

var $hFtK7 = parcelRequire("hFtK7");

var $72ldR = parcelRequire("72ldR");

var $g36LP = parcelRequire("g36LP");

var $ceqcm = parcelRequire("ceqcm");

var $2bpNg = parcelRequire("2bpNg");

var $1Unjk = parcelRequire("1Unjk");

var $gBaKj = parcelRequire("gBaKj");

var $8Sdzy = parcelRequire("8Sdzy");

var $aNG0w = parcelRequire("aNG0w");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $55BnK = parcelRequire("55BnK");

var $3GN2r = parcelRequire("3GN2r");

var $78GR0 = parcelRequire("78GR0");

var $bVDHZ = parcelRequire("bVDHZ");

var $1kCfQ = parcelRequire("1kCfQ");
const $405d76c4b4a94a3c$var$roadmapSettings = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.actions-buttons-roadmap.roadmap-settings",
    defaultMessage: "Roadmap settings"
});
const $405d76c4b4a94a3c$var$roadmapDetails = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.actions-buttons-roadmap.roadmap-details",
    defaultMessage: "Roadmap details"
});
const $405d76c4b4a94a3c$var$duplicateRoadmap = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.actions-buttons-roadmap.duplicate-roadmap",
    defaultMessage: "Duplicate roadmap"
});
const $405d76c4b4a94a3c$var$deleteRoadmap = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.actions-buttons-roadmap.delete-roadmap",
    defaultMessage: "Delete roadmap"
});
const $405d76c4b4a94a3c$var$copiedCollectionNameMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.copied-collection-name",
    defaultMessage: "{collectionName} Copy"
});
const $405d76c4b4a94a3c$export$454208c8def7920f = ({ collectionUUID: collectionUUID, preloadPermissions: preloadPermissions, onClose: onClose, collectionQueryRefFragment: collectionQueryRefFragment, currentItems: currentItems, currentOrder: currentOrder, item: item })=>{
    const collectionRoadmapMenuItemsData = (0, $n67Vb.useFragment)((0, $f3yp7.default), collectionQueryRefFragment);
    const [collectionTemporaryData, setCollectionTemporaryData] = (0, $euxye.useState)();
    const [isDeleteConfirmationDialogOpen, setIsDeleteConfirmationDialogOpen] = (0, $euxye.useState)(false);
    const [isDeleteConfirmationDialogLoading, setIsDeleteConfirmationDialogLoading] = (0, $euxye.useState)(true);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const collectionSelectedMatch = (0, $78GR0.useCollectionSelectedMatch)();
    const isCollectionsSelected = (0, $78GR0.useIsCollectionsSelected)();
    const { push: push, replace: replace } = (0, $55BnK.useRouterActions)();
    const { getCollectionData: getCollectionData, copyCollection: copyCollection } = (0, $anSqv.useCollectionsActions)();
    const { copyCollection: copyCollectionInNavigation, deleteCollection: deleteCollectionFromNavigation } = (0, $iPHqm.useNavigationCollectionsActions)();
    const copiedCollectionOwnerId = (0, $3GN2r.useAccountId)();
    const collectionName = collectionTemporaryData?.name || '';
    (0, $euxye.useEffect)(()=>{
        getCollectionData(collectionUUID).then((data)=>{
            setCollectionTemporaryData(data);
            setIsDeleteConfirmationDialogLoading(false);
        }).catch((error)=>{
            setIsDeleteConfirmationDialogLoading(false);
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'jpdNavigationV4Action'
                },
                attributes: {
                    action: 'getCollectionData',
                    type: 'collections'
                }
            });
        });
    }, [
        collectionUUID,
        getCollectionData
    ]);
    const copiedCollectionName = formatMessage($405d76c4b4a94a3c$var$copiedCollectionNameMessage, {
        collectionName: collectionName
    });
    const isReadOnly = (0, $bVDHZ.useIsReadOnly)();
    const { canManageView: canManageView, loadViewPermissionsForCurrentUser: loadViewPermissionsForCurrentUser } = (0, $koaaE.useManageViewPermissions)(collectionUUID);
    (0, $euxye.useEffect)(()=>{
        if (preloadPermissions) loadViewPermissionsForCurrentUser(collectionUUID);
    }, [
        loadViewPermissionsForCurrentUser,
        collectionUUID,
        preloadPermissions
    ]);
    const canEditCollection = !isReadOnly && canManageView;
    const isCollectionSelected = (0, $78GR0.useIsCollectionSelected)({
        collectionUUID: collectionUUID
    });
    const openSidebar = (0, $euxye.useCallback)((sidebar)=>{
        if (collectionSelectedMatch?.collectionUUID === collectionUUID && collectionSelectedMatch?.viewUUID) replace((0, $aOGXw.getCollectionViewPageUrl)(collectionUUID, collectionSelectedMatch.viewUUID, {
            sidebar: sidebar
        }));
        else if (isCollectionsSelected) replace((0, $aOGXw.getCollectionsPageUrl)({
            sidebar: sidebar,
            roadmap: collectionUUID
        }));
        else push((0, $aOGXw.getCollectionDetailsPageUrlWithQuery)(collectionUUID, {
            sidebar: sidebar
        }));
    }, [
        collectionSelectedMatch,
        collectionUUID,
        isCollectionsSelected,
        push,
        replace
    ]);
    const handleRoadmapSettingsClick = (0, $euxye.useCallback)((event)=>{
        onClose?.(event);
        openSidebar('settings');
    }, [
        onClose,
        openSidebar
    ]);
    const handleCloneRoadmapClick = (0, $euxye.useCallback)((event)=>{
        copyCollection(collectionUUID, copiedCollectionName, copiedCollectionOwnerId, collectionTemporaryData).then((copiedCollectionUuid)=>{
            if (copiedCollectionUuid) {
                copyCollectionInNavigation(collectionUUID, {
                    uuid: copiedCollectionUuid,
                    name: copiedCollectionName,
                    ownerId: copiedCollectionOwnerId
                });
                push((0, $aOGXw.getCollectionDetailsPageUrl)(copiedCollectionUuid));
            }
        });
        onClose?.(event);
    }, [
        collectionTemporaryData,
        collectionUUID,
        copiedCollectionName,
        copiedCollectionOwnerId,
        copyCollection,
        copyCollectionInNavigation,
        onClose,
        push
    ]);
    const handleDeleteRoadmapClick = (0, $euxye.useCallback)(()=>{
        setIsDeleteConfirmationDialogOpen(true);
    }, []);
    const handleDeleteRoadmapModalClose = (0, $euxye.useCallback)((event)=>{
        setIsDeleteConfirmationDialogOpen(false);
        onClose?.(event);
    }, [
        onClose
    ]);
    const handleDeleteRoadmapSuccess = (0, $euxye.useCallback)((event)=>{
        deleteCollectionFromNavigation(collectionUUID);
        if (isCollectionSelected) // If we are on removed collection then redirected
        // to all Roadmaps page instead of showing
        // `This roadmap isn't available screen`
        push((0, $aOGXw.getCollectionsPageUrl)());
        else handleDeleteRoadmapModalClose(event);
    }, [
        collectionUUID,
        deleteCollectionFromNavigation,
        isCollectionSelected,
        push,
        handleDeleteRoadmapModalClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), null, collectionRoadmapMenuItemsData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1kCfQ.RoadmapFavoriteSubmenu), {
        collectionQueryRefFragment: collectionRoadmapMenuItemsData,
        currentItems: currentItems,
        currentOrder: currentOrder,
        item: item,
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true,
        hasSeparator: true
    }, canEditCollection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gBaKj))), {
            label: "",
            spacing: "spacious"
        }),
        onClick: handleRoadmapSettingsClick
    }, formatMessage($405d76c4b4a94a3c$var$roadmapSettings)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))), {
            label: "",
            spacing: "spacious"
        }),
        onClick: handleRoadmapSettingsClick
    }, formatMessage($405d76c4b4a94a3c$var$roadmapDetails)), !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Unjk))), {
            label: "",
            spacing: "spacious"
        }),
        onClick: handleCloneRoadmapClick
    }, formatMessage($405d76c4b4a94a3c$var$duplicateRoadmap))), canEditCollection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bpNg))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)",
            spacing: "spacious"
        }),
        onClick: handleDeleteRoadmapClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        color: "color.text.danger"
    }, formatMessage($405d76c4b4a94a3c$var$deleteRoadmap))), isDeleteConfirmationDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l01S5.CollectionDeleteModal), {
        collectionUUID: collectionUUID,
        isLoading: isDeleteConfirmationDialogLoading,
        views: collectionTemporaryData?.views || [],
        onDelete: handleDeleteRoadmapSuccess,
        onClose: handleDeleteRoadmapModalClose,
        collectionName: collectionTemporaryData?.name
    }))));
};
$405d76c4b4a94a3c$export$454208c8def7920f.displayName = "RoadmapMenuItems";

});
parcelRegister("f3yp7", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d4527c36e39a962$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<84a6472e8646d922a2803b75fd882237>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9d4527c36e39a962$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RoadmapMenuItems_collection",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "RoadmapFavoriteSubmenu_collection"
        }
    ],
    "type": "JiraProductDiscoveryCollection"
};
$9d4527c36e39a962$var$node.hash = "4a5b7b0113e154dbc44ec377ce596954";
var $9d4527c36e39a962$export$2e2bcd8739ae039 = $9d4527c36e39a962$var$node;

});

parcelRegister("anSqv", function(module, exports) {
$parcel$export(module.exports, "CollectionsContainer", () => $770d9c25ab854a31$export$80cb348e37947c6a);
$parcel$export(module.exports, "useCollectionsActions", () => $770d9c25ab854a31$export$ba61932a631ba139);
$parcel$export(module.exports, "useCollectionsOwnersIds", () => $770d9c25ab854a31$export$47ee56d816ebfe18);
$parcel$export(module.exports, "useFilteredCollections", () => $770d9c25ab854a31$export$a4dbccbfbbac764d);
$parcel$export(module.exports, "useCollectionsLoading", () => $770d9c25ab854a31$export$c4791ba8ac9a58e5);
$parcel$export(module.exports, "useCollectionsHasError", () => $770d9c25ab854a31$export$1b07b501c3f8f216);
$parcel$export(module.exports, "useCollectionsError", () => $770d9c25ab854a31$export$9ee25d19d08e6165);
$parcel$export(module.exports, "useCollectionsCount", () => $770d9c25ab854a31$export$41be1fea11eb73ec);
$parcel$export(module.exports, "useCollectionName", () => $770d9c25ab854a31$export$71661e51ce252508);
$parcel$export(module.exports, "useCollectionEmoji", () => $770d9c25ab854a31$export$c35637e36ec6f8fd);
$parcel$export(module.exports, "useCollectionJql", () => $770d9c25ab854a31$export$3ddba651313f7cb0);
$parcel$export(module.exports, "useCollectionViews", () => $770d9c25ab854a31$export$4d3e73040770b6);
$parcel$export(module.exports, "useCollectionLoading", () => $770d9c25ab854a31$export$6073e01a27128de4);
$parcel$export(module.exports, "useCollectionError", () => $770d9c25ab854a31$export$5a7fad0d58c5f5e2);
$parcel$export(module.exports, "useCollectionHasError", () => $770d9c25ab854a31$export$a864c959274a94b8);
$parcel$export(module.exports, "useCollectionViewsCount", () => $770d9c25ab854a31$export$1a42c92187206222);
$parcel$export(module.exports, "useHasFetchedCollectionViews", () => $770d9c25ab854a31$export$32becd83126d3e5b);
$parcel$export(module.exports, "useCollectionOwnerId", () => $770d9c25ab854a31$export$333713f4878fc62d);
$parcel$export(module.exports, "useCollectionDescription", () => $770d9c25ab854a31$export$31549a29278f29ca);
$parcel$export(module.exports, "useCollectionProjectKeys", () => $770d9c25ab854a31$export$627b89d60c64164a);
$parcel$export(module.exports, "useCollectionFiltersJql", () => $770d9c25ab854a31$export$6a559aa025c2caf0);
$parcel$export(module.exports, "useProjectCollectionsCount", () => $770d9c25ab854a31$export$e785641239dc5c88);
$parcel$export(module.exports, "useIsCollectionDescriptionLoading", () => $770d9c25ab854a31$export$d01e52f887fd0aef);
$parcel$export(module.exports, "useCollectionDescriptionHasError", () => $770d9c25ab854a31$export$d8d51044786d761);

var $9O1Qa = parcelRequire("9O1Qa");

var $3h1FP = parcelRequire("3h1FP");
var $dB6ay = parcelRequire("dB6ay");
var $3K7NP = parcelRequire("3K7NP");
var $5QDqc = parcelRequire("5QDqc");

var $k3gSW = parcelRequire("k3gSW");

var $emWKI = parcelRequire("emWKI");
const $770d9c25ab854a31$var$initialState = {
    collections: {},
    isLoading: true,
    error: undefined,
    descriptions: {}
};
const $770d9c25ab854a31$var$Store = (0, $5QDqc.createStore)({
    initialState: $770d9c25ab854a31$var$initialState,
    actions: $k3gSW,
    name: 'PolarisCollections'
});
const $770d9c25ab854a31$export$80cb348e37947c6a = (0, $dB6ay.createContainer)($770d9c25ab854a31$var$Store);
const $770d9c25ab854a31$export$ba61932a631ba139 = (0, $3h1FP.createActionsHook)($770d9c25ab854a31$var$Store);
const $770d9c25ab854a31$var$getCollections = (state)=>state.collections;
const $770d9c25ab854a31$export$7473509e1ca8a32b = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollections, (collections)=>Object.values(collections).map((c)=>c?.data).filter(Boolean));
const $770d9c25ab854a31$var$getCollectionIds = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollections, (collections)=>Object.keys(collections));
const $770d9c25ab854a31$var$getCollectionsLoading = (state)=>state.isLoading;
const $770d9c25ab854a31$var$getCollectionsError = (state)=>state.error;
const $770d9c25ab854a31$var$getCollectionsHasError = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollectionsError, (error)=>!!error);
const $770d9c25ab854a31$var$getCollectionsOwnersIds = (0, $3K7NP.createSelector)($770d9c25ab854a31$export$7473509e1ca8a32b, (collections)=>(0, (/*@__PURE__*/$parcel$interopDefault($9O1Qa)))(collections.map(({ ownerId: ownerId })=>ownerId).filter(Boolean)));
const $770d9c25ab854a31$var$getFilteredCollections = (0, $3K7NP.createSelector)((state)=>$770d9c25ab854a31$export$7473509e1ca8a32b(state), (_, { text: text })=>text, (_, { ownerIds: ownerIds })=>ownerIds, (_, { projects: projects })=>projects, (collections, text, ownerIds, projects)=>collections ? collections.filter((collection)=>(0, $emWKI.filterCollectionByText)(text)(collection) && (0, $emWKI.filterCollectionByOwnerIds)(ownerIds)(collection) && (0, $emWKI.filterCollectionByProjectKeys)(projects)(collection)) : []);
const $770d9c25ab854a31$var$getCollectionsCount = (0, $3K7NP.createSelector)($770d9c25ab854a31$export$7473509e1ca8a32b, (collections)=>collections.length);
const $770d9c25ab854a31$export$47ee56d816ebfe18 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionsOwnersIds
});
const $770d9c25ab854a31$export$a4dbccbfbbac764d = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getFilteredCollections
});
const $770d9c25ab854a31$export$2b5787016ed09c4d = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollections
});
const $770d9c25ab854a31$export$c4791ba8ac9a58e5 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionsLoading
});
const $770d9c25ab854a31$export$1b07b501c3f8f216 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionsHasError
});
const $770d9c25ab854a31$export$9ee25d19d08e6165 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionsError
});
const $770d9c25ab854a31$export$41be1fea11eb73ec = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionsCount
});
const $770d9c25ab854a31$export$e9fd0b8259ad0113 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionIds
});
const $770d9c25ab854a31$var$getCollectionWithMeta = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollections, (_, { collectionUUID: collectionUUID })=>collectionUUID, (collections, collectionUUID)=>collectionUUID ? collections[collectionUUID] : undefined);
const $770d9c25ab854a31$var$getCollection = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollectionWithMeta, (collection)=>collection?.data);
const $770d9c25ab854a31$var$getCollectionName = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollection, (collection)=>collection?.name);
const $770d9c25ab854a31$var$getCollectionEmoji = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollection, (collection)=>collection?.emoji);
const $770d9c25ab854a31$var$getCollectionJql = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollection, (collection)=>collection?.jql);
const $770d9c25ab854a31$var$getCollectionViews = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollection, (collection)=>collection?.views || []);
const $770d9c25ab854a31$var$hasFetchedCollectionViews = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollection, (collection)=>Array.isArray(collection?.views));
const $770d9c25ab854a31$var$getIsCollectionLoading = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollectionWithMeta, (collection)=>!!collection?.isLoading);
const $770d9c25ab854a31$var$getCollectionProjectKeys = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollection, (collection)=>collection?.projectKeys);
const $770d9c25ab854a31$var$getCollectionFiltersJql = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollection, (collection)=>collection?.filtersJql);
const $770d9c25ab854a31$var$getProjectCollectionsCount = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollections, (collections)=>Object.values(collections).flatMap((collection)=>collection?.data?.projectKeys).filter((key)=>!!key).reduce((acc, projectKey)=>{
        acc[projectKey] = (acc[projectKey] ?? 0) + 1;
        return acc;
    }, {}));
const $770d9c25ab854a31$var$getError = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollectionWithMeta, (collection)=>collection?.error);
const $770d9c25ab854a31$var$hasError = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getError, (error)=>!!error);
const $770d9c25ab854a31$var$getCollectionViewsOwnersIds = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollectionViews, (views)=>(0, (/*@__PURE__*/$parcel$interopDefault($9O1Qa)))(views.map(({ ownerId: ownerId })=>ownerId).filter(Boolean)));
const $770d9c25ab854a31$var$getCollectionView = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollectionViews, (_, { viewUUID: viewUUID })=>viewUUID, (views, viewUUID)=>viewUUID ? views.find((view)=>view.uuid === viewUUID) : undefined);
const $770d9c25ab854a31$var$getCollectionViewTitle = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollectionView, (view)=>view?.title);
const $770d9c25ab854a31$var$getCollectionViewsCount = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollection, (collection)=>collection?.views?.length || collection?.viewsCount);
const $770d9c25ab854a31$var$getCollectionOwnerId = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollection, (collection)=>collection?.ownerId);
const $770d9c25ab854a31$var$getDescriptions = (state)=>state.descriptions;
const $770d9c25ab854a31$var$getCollectionDescriptionWithMeta = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getDescriptions, (_, { collectionUUID: collectionUUID })=>collectionUUID, (descriptions, collectionUUID)=>collectionUUID ? descriptions[collectionUUID] : undefined);
const $770d9c25ab854a31$var$getCollectionDescription = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollectionDescriptionWithMeta, (descriptionWithMeta)=>descriptionWithMeta?.description);
const $770d9c25ab854a31$var$getIsCollectionDescriptionLoading = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollectionDescriptionWithMeta, (descriptionWithMeta)=>!!descriptionWithMeta?.isLoading);
const $770d9c25ab854a31$var$getCollectionDescriptionHasError = (0, $3K7NP.createSelector)($770d9c25ab854a31$var$getCollectionDescriptionWithMeta, (descriptionWithMeta)=>!!descriptionWithMeta?.error);
const $770d9c25ab854a31$export$6cd28814d92fa9c9 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollection
});
const $770d9c25ab854a31$export$71661e51ce252508 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionName
});
const $770d9c25ab854a31$export$c35637e36ec6f8fd = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionEmoji
});
const $770d9c25ab854a31$export$3ddba651313f7cb0 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionJql
});
const $770d9c25ab854a31$export$4d3e73040770b6 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionViews
});
const $770d9c25ab854a31$export$6073e01a27128de4 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getIsCollectionLoading
});
const $770d9c25ab854a31$export$5a7fad0d58c5f5e2 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getError
});
const $770d9c25ab854a31$export$a864c959274a94b8 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$hasError
});
const $770d9c25ab854a31$export$794fd3b80c093caa = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionViewsOwnersIds
});
const $770d9c25ab854a31$export$61588707ea3d7293 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionView
});
const $770d9c25ab854a31$export$652691088e3ed5ff = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionViewTitle
});
const $770d9c25ab854a31$export$1a42c92187206222 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionViewsCount
});
const $770d9c25ab854a31$export$32becd83126d3e5b = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$hasFetchedCollectionViews
});
const $770d9c25ab854a31$export$333713f4878fc62d = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionOwnerId
});
const $770d9c25ab854a31$export$31549a29278f29ca = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionDescription
});
const $770d9c25ab854a31$export$627b89d60c64164a = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionProjectKeys
});
const $770d9c25ab854a31$export$6a559aa025c2caf0 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionFiltersJql
});
const $770d9c25ab854a31$export$e785641239dc5c88 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getProjectCollectionsCount
});
const $770d9c25ab854a31$export$d01e52f887fd0aef = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getIsCollectionDescriptionLoading
});
const $770d9c25ab854a31$export$d8d51044786d761 = (0, $3h1FP.createStateHook)($770d9c25ab854a31$var$Store, {
    selector: $770d9c25ab854a31$var$getCollectionDescriptionHasError
});

});
parcelRegister("k3gSW", function(module, exports) {
$parcel$export(module.exports, "initialize", () => (parcelRequire("4hr60")).initialize);
$parcel$export(module.exports, "createCollection", () => (parcelRequire("4hr60")).createCollection);
$parcel$export(module.exports, "deleteCollection", () => (parcelRequire("4hr60")).deleteCollection);
$parcel$export(module.exports, "updateCollection", () => (parcelRequire("4hr60")).updateCollection);
$parcel$export(module.exports, "loadCollection", () => (parcelRequire("4hr60")).loadCollection);
$parcel$export(module.exports, "loadCollections", () => (parcelRequire("4hr60")).loadCollections);
$parcel$export(module.exports, "copyCollection", () => (parcelRequire("4hr60")).copyCollection);
$parcel$export(module.exports, "getCollectionData", () => (parcelRequire("4hr60")).getCollectionData);
$parcel$export(module.exports, "syncStateWithCollectionStoreAfterViewDelete", () => (parcelRequire("4hr60")).syncStateWithCollectionStoreAfterViewDelete);
$parcel$export(module.exports, "createView", () => (parcelRequire("70opI")).createView);
$parcel$export(module.exports, "deleteView", () => (parcelRequire("70opI")).deleteView);
$parcel$export(module.exports, "fetchCollectionsViewsCounts", () => (parcelRequire("70opI")).fetchCollectionsViewsCounts);
$parcel$export(module.exports, "loadCollectionDescription", () => (parcelRequire("dK9AV")).loadCollectionDescription);
$parcel$export(module.exports, "updateCollectionDescription", () => (parcelRequire("dK9AV")).updateCollectionDescription);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $4hr60 = parcelRequire("4hr60");

var $70opI = parcelRequire("70opI");

var $dK9AV = parcelRequire("dK9AV");

});
parcelRegister("4hr60", function(module, exports) {
$parcel$export(module.exports, "createCollection", () => $c86e93707b511450$export$c74125a8e3af6bb2);
$parcel$export(module.exports, "initialize", () => $c86e93707b511450$export$2a47f398eeff8b01);
$parcel$export(module.exports, "loadCollection", () => $c86e93707b511450$export$1f19ddbd9e78c2f5);
$parcel$export(module.exports, "loadCollections", () => $c86e93707b511450$export$569b2ddb07e9ef58);
$parcel$export(module.exports, "deleteCollection", () => $c86e93707b511450$export$3d16e031f6551662);
$parcel$export(module.exports, "updateCollection", () => $c86e93707b511450$export$c0683150b517c317);
$parcel$export(module.exports, "copyCollection", () => $c86e93707b511450$export$36928e43600c4b00);
$parcel$export(module.exports, "getCollectionData", () => $c86e93707b511450$export$d071b5a3ecbd2134);
$parcel$export(module.exports, "syncStateWithCollectionStoreAfterViewDelete", () => $c86e93707b511450$export$64e824699282d339);
/* eslint-disable jira/filename-case */ 
var $hFtK7 = parcelRequire("hFtK7");

var $j85oP = parcelRequire("j85oP");

var $7imRA = parcelRequire("7imRA");

var $jxSHn = parcelRequire("jxSHn");

var $ifsAO = parcelRequire("ifsAO");

var $aJ81Y = parcelRequire("aJ81Y");

var $4V0al = parcelRequire("4V0al");

var $5WP8k = parcelRequire("5WP8k");
const $c86e93707b511450$export$c74125a8e3af6bb2 = ({ name: name, color: color, emoji: emoji, jql: jql, ownerId: ownerId, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState }, { onCollectionCreate: onCollectionCreate })=>{
        try {
            return await (0, $7imRA.wrapWithExperience)((0, $j85oP.experience).collections.createCollection, async ()=>{
                const newCollection = await (0, $5WP8k.createCollection)({
                    name: name,
                    color: color,
                    emoji: emoji,
                    jql: jql
                });
                const state = getState();
                setState({
                    collections: {
                        ...state.collections,
                        [newCollection.uuid]: {
                            data: {
                                ...newCollection,
                                ownerId: ownerId
                            }
                        }
                    }
                });
                const actionSubjectAndAction = 'collection created';
                (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction);
                (0, $jxSHn.sendPendoTrackEvent)({
                    actionSubjectAndAction: actionSubjectAndAction
                });
                // Ensure that onCollectionCreate always receives
                // a fresh reference
                onCollectionCreate?.({
                    ...newCollection
                });
                return newCollection;
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.error.createCollectionFailed', error));
                throw error;
            }
        }
    };
const $c86e93707b511450$export$2a47f398eeff8b01 = (collections)=>({ setState: setState })=>{
        setState({
            collections: collections.reduce((acc, collection)=>{
                acc[collection.uuid] = {
                    data: collection
                };
                return acc;
            }, {}),
            isLoading: false,
            error: undefined
        });
    };
const $c86e93707b511450$export$1f19ddbd9e78c2f5 = (collectionUUID, shouldIncludeViews)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const existingCollection = state.collections[collectionUUID] || {
            data: undefined
        };
        if (existingCollection.isLoading) return;
        const loadExperience = shouldIncludeViews ? (0, $j85oP.experience).collections.loadCollectionViews : (0, $j85oP.experience).collections.loadCollection;
        try {
            await (0, $7imRA.wrapWithExperience)(loadExperience, async ()=>{
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            ...existingCollection,
                            isLoading: true,
                            error: undefined
                        }
                    }
                });
                const newCollection = await (0, $5WP8k.fetchCollection)(collectionUUID, shouldIncludeViews);
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            data: {
                                ...existingCollection.data,
                                ...newCollection
                            },
                            isLoading: false
                        }
                    }
                });
                return newCollection;
            }, {
                ignorePermissionError: true,
                getMetadata: shouldIncludeViews ? (collection)=>({
                        collectionUUID: collectionUUID,
                        collectionViewsCount: collection.views?.length
                    }) : undefined
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.error.collectionLoadingFailed', error));
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            ...existingCollection,
                            isLoading: false,
                            error: error
                        }
                    }
                });
            }
        }
    };
const $c86e93707b511450$export$569b2ddb07e9ef58 = ()=>async ({ setState: setState, dispatch: dispatch })=>{
        try {
            return await (0, $7imRA.wrapWithExperience)((0, $j85oP.experience).collections.loadCollections, async ()=>{
                setState({
                    collections: {},
                    isLoading: true
                });
                const collections = await (0, $5WP8k.fetchAllCollections)();
                dispatch($c86e93707b511450$export$2a47f398eeff8b01(collections));
                return collections;
            }, {
                getMetadata: (collections)=>({
                        collectionsCount: collections.length
                    })
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.error.allCollectionsLoadingFailed', error));
                setState({
                    isLoading: false,
                    error: error
                });
            }
        }
        return undefined;
    };
const $c86e93707b511450$export$3d16e031f6551662 = (collectionUUID, { deleteOnlyOnClientSide: deleteOnlyOnClientSide } = {
    deleteOnlyOnClientSide: false
})=>async ({ setState: setState, getState: getState }, { onCollectionDelete: onCollectionDelete })=>{
        const state = getState();
        try {
            await (0, $7imRA.wrapWithExperience)((0, $j85oP.experience).collections.deleteCollection, async ()=>{
                const { [collectionUUID]: _, ...collections } = state.collections;
                if (!deleteOnlyOnClientSide) await (0, $5WP8k.deleteCollection)(collectionUUID);
                setState({
                    collections: collections
                });
                onCollectionDelete?.(collectionUUID);
            });
        } catch (error) {
            if (error instanceof Error) (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.error.collectionDeletionFailed', error));
            throw error;
        }
    };
const $c86e93707b511450$export$c0683150b517c317 = (collectionUUID, collection)=>async ({ setState: setState, getState: getState }, { onCollectionUpdate: onCollectionUpdate })=>{
        const state = getState();
        const existingCollection = state.collections[collectionUUID];
        const data = existingCollection?.data;
        if (!data) return;
        try {
            await (0, $7imRA.wrapWithExperience)((0, $j85oP.experience).collections.updateCollection, async ()=>{
                const { name: name, color: color, emoji: emoji, projectKeys: projectKeys, filtersJql: filtersJql } = collection;
                const jql = projectKeys !== undefined || filtersJql !== undefined ? (0, $4V0al.getJQLForCollection)(projectKeys ?? data.projectKeys, filtersJql ?? data.filtersJql) : data.jql;
                const updatedCollection = {
                    name: name || data.name,
                    color: 'color' in collection ? color : data.color,
                    emoji: 'emoji' in collection ? emoji : data.emoji,
                    jql: jql
                };
                await (0, $5WP8k.updateCollection)(collectionUUID, updatedCollection);
                const updatedCollectionData = {
                    ...data,
                    ...updatedCollection,
                    projectKeys: projectKeys ?? data.projectKeys,
                    filtersJql: filtersJql ?? data.filtersJql
                };
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            ...existingCollection,
                            data: updatedCollectionData
                        }
                    }
                });
                // Ensure that onCollectionUpdate always receives
                // a fresh reference
                onCollectionUpdate?.({
                    ...updatedCollectionData
                });
            });
        } catch (error) {
            if (error instanceof Error) (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.error.collectionUpdateFailed', error));
            throw error;
        }
    };
const $c86e93707b511450$export$36928e43600c4b00 = (collectionUUID, newCollectionName, newCollectionOwnerId, collectionTemporaryData)=>async ({ setState: setState, getState: getState })=>{
        try {
            const state = getState();
            const collectionToCopy = state.collections[collectionUUID]?.data || collectionTemporaryData;
            if (!collectionToCopy || !newCollectionOwnerId) return;
            return await (0, $7imRA.wrapWithExperience)((0, $j85oP.experience).collections.copyCollection, async ()=>{
                const { uuid: uuid } = await (0, $5WP8k.cloneCollection)(collectionUUID, newCollectionName);
                setState({
                    collections: {
                        ...state.collections,
                        [uuid]: {
                            isLoading: false,
                            error: undefined,
                            data: {
                                ...collectionToCopy,
                                name: newCollectionName,
                                ownerId: newCollectionOwnerId,
                                uuid: uuid
                            }
                        }
                    }
                });
                return uuid;
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.error.copyCollectionFailed', error));
                throw error;
            }
        }
    };
const $c86e93707b511450$export$d071b5a3ecbd2134 = (collectionUUID)=>async ({ getState: getState })=>{
        const state = getState();
        const existingCollection = state.collections[collectionUUID] || {
            data: undefined
        };
        if (existingCollection.data?.views !== undefined) return existingCollection.data;
        try {
            return await (0, $7imRA.wrapWithExperience)((0, $j85oP.experience).collections.loadCollection, async ()=>{
                const collection = await (0, $5WP8k.fetchCollection)(collectionUUID, true);
                return collection;
            });
        } catch (error) {
            if (error instanceof Error) (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.error.collectionLoadingFailed', error));
        }
    };
const $c86e93707b511450$export$64e824699282d339 = (collectionUUID, viewUUID)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const collection = state.collections && state.collections[collectionUUID];
        if (!collection || !collection.data) return;
        const currentViewsCount = collection.data.viewsCount ?? 0;
        const viewsCount = currentViewsCount > 0 ? currentViewsCount - 1 : 0;
        const views = collection.data.views?.filter((view)=>view.uuid !== viewUUID);
        setState({
            collections: {
                ...state.collections,
                [collectionUUID]: {
                    data: {
                        ...collection.data,
                        views: views,
                        viewsCount: viewsCount
                    }
                }
            }
        });
    };

});

parcelRegister("70opI", function(module, exports) {
$parcel$export(module.exports, "createView", () => $6f3f1d03a318b4f1$export$d7febe7b891e79f0);
$parcel$export(module.exports, "fetchCollectionsViewsCounts", () => $6f3f1d03a318b4f1$export$4ead91e2f6058f41);
$parcel$export(module.exports, "deleteView", () => $6f3f1d03a318b4f1$export$443d89549b135c95);
/* eslint-disable jira/filename-case */ 
var $dSJEI = parcelRequire("dSJEI");

var $hFtK7 = parcelRequire("hFtK7");

var $j85oP = parcelRequire("j85oP");

var $7imRA = parcelRequire("7imRA");

var $ifsAO = parcelRequire("ifsAO");

var $5WP8k = parcelRequire("5WP8k");

var $busOP = parcelRequire("busOP");

var $g4eap = parcelRequire("g4eap");
const $6f3f1d03a318b4f1$export$d7febe7b891e79f0 = (collectionUUID, view)=>async ({ setState: setState, getState: getState })=>{
        try {
            const state = getState();
            const existingCollection = state.collections[collectionUUID];
            const data = existingCollection?.data;
            if (!data) return;
            return await (0, $g4eap.wrapWithAbortableExperience)((0, $j85oP.experience).collections.createView, async ()=>{
                const newView = await (0, $busOP.createView)(collectionUUID, view);
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            ...existingCollection,
                            data: {
                                ...data,
                                views: [
                                    ...data?.views || [],
                                    newView
                                ]
                            }
                        }
                    }
                });
                return newView;
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.error.collectionViewCreationFailed', error));
                throw error;
            }
        }
    };
const $6f3f1d03a318b4f1$export$4ead91e2f6058f41 = ()=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const collectionsUUIDs = Object.keys(state.collections);
        if (collectionsUUIDs.length === 0) return;
        try {
            await (0, $7imRA.wrapWithExperience)((0, $j85oP.experience).collections.loadViewCount, async ()=>{
                const collectionsViewsCountMap = await (0, $5WP8k.fetchCollectionsViewsCounts)(collectionsUUIDs);
                setState({
                    collections: (0, (/*@__PURE__*/$parcel$interopDefault($dSJEI)))(state.collections, (collection)=>{
                        if (collection?.data) return {
                            ...collection,
                            data: {
                                ...collection.data,
                                viewsCount: collectionsViewsCountMap[collection.data.uuid] || 0
                            }
                        };
                        return collection;
                    })
                });
            });
        } catch (error) {
            if (error instanceof Error) (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.error.collectionsViewsCountLoadingFailed', error));
            throw error;
        }
    };
const $6f3f1d03a318b4f1$export$443d89549b135c95 = (collectionUUID, viewUUID)=>async ({ setState: setState, getState: getState })=>{
        try {
            const state = getState();
            const existingCollection = state.collections[collectionUUID];
            const data = existingCollection?.data;
            if (!data) return;
            await (0, $7imRA.wrapWithExperience)((0, $j85oP.experience).collections.deleteView, async ()=>{
                await (0, $busOP.deleteView)(collectionUUID, viewUUID);
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            ...existingCollection,
                            data: {
                                ...data,
                                viewsCount: data.viewsCount ? data.viewsCount - 1 : undefined,
                                views: data?.views?.filter((view)=>view.uuid !== viewUUID)
                            }
                        }
                    }
                });
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.error.collectionViewDeletionFailed', error));
                throw error;
            }
        }
    };

});
parcelRegister("dSJEI", function(module, exports) {

var $fOh92 = parcelRequire("fOh92");

var $hmcvL = parcelRequire("hmcvL");

var $9JUaE = parcelRequire("9JUaE");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $a1b3bbc4c114abf1$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $9JUaE(iteratee, 3);
    $hmcvL(object, function(value, key, object) {
        $fOh92(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $a1b3bbc4c114abf1$var$mapValues;

});

parcelRegister("busOP", function(module, exports) {
$parcel$export(module.exports, "createView", () => $30433c4af772a0af$export$d7febe7b891e79f0);
$parcel$export(module.exports, "deleteView", () => $30433c4af772a0af$export$443d89549b135c95);

var $2wtso = parcelRequire("2wtso");

var $h2wCv = parcelRequire("h2wCv");

var $6njZO = parcelRequire("6njZO");
const $30433c4af772a0af$export$d7febe7b891e79f0 = (collectionUUID, viewToCreate)=>(0, $h2wCv.performPostRequest)(`${(0, $2wtso.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/views`, {
        body: JSON.stringify(viewToCreate)
    }).then((0, $6njZO.transformView));
const $30433c4af772a0af$export$443d89549b135c95 = async (collectionUUID, viewUUID)=>{
    await (0, $h2wCv.performDeleteRequest)(`${(0, $2wtso.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/views/${viewUUID}`);
};

});

parcelRegister("g4eap", function(module, exports) {
$parcel$export(module.exports, "wrapWithAbortableExperience", () => $9553543553d7eecb$export$bb817acda5dafb79);

var $eld9X = parcelRequire("eld9X");
const $9553543553d7eecb$export$bb817acda5dafb79 = (experience, callback)=>{
    experience.start();
    return callback().then((result)=>{
        experience.success();
        return result;
    }).catch((err)=>{
        const error = err instanceof Error ? err : new Error('Error during experience', {
            cause: err
        });
        if ((0, $eld9X.isAbortableError)(error)) {
            experience.abort(error);
            throw err;
        }
        experience.failure(error);
        throw err;
    });
};

});
parcelRegister("eld9X", function(module, exports) {
$parcel$export(module.exports, "isAbortableError", () => $de08cfdd713c26ae$export$e05e0fb17c2ab75a);
/* eslint-disable jira/filename-case */ 
var $9McCS = parcelRequire("9McCS");

var $cY22M = parcelRequire("cY22M");

var $75sVW = parcelRequire("75sVW");

var $lCetP = parcelRequire("lCetP");
const $de08cfdd713c26ae$export$e05e0fb17c2ab75a = (error)=>{
    const statusCode = $de08cfdd713c26ae$var$extractStatusCode(error);
    if ((0, $lCetP.isHttpClientErrorStatusCode)(statusCode) || !statusCode && (0, $lCetP.isClientFetchError)(error) || error?.name === (0, $75sVW.VALIDATION_ERROR_NAME)) return true;
    return false;
};
const $de08cfdd713c26ae$var$getStatusCodeFromGraphQLErrors = (graphQLErrors)=>{
    const statusCodes = graphQLErrors.map((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(e, [
            'extensions',
            'statusCode'
        ])).filter((statusCode)=>!!statusCode);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9McCS)))(statusCodes);
    return statusCode || null;
};
const $de08cfdd713c26ae$var$extractStatusCode = (error)=>{
    const errorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'statusCode'
    ], null);
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'graphQLErrors'
    ], null);
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'networkError'
    ], null);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(networkError, [
        'statusCode'
    ], null);
    const relayErrors = (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'source',
        'errors'
    ], null);
    if (typeof errorStatusCode === 'number') return errorStatusCode;
    if (typeof statusCode === 'number') return statusCode;
    if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) return $de08cfdd713c26ae$var$getStatusCodeFromGraphQLErrors(graphQLErrors);
    if (Array.isArray(relayErrors) && relayErrors.length > 0) return $de08cfdd713c26ae$var$getStatusCodeFromGraphQLErrors(relayErrors);
    return null;
};

});
parcelRegister("9McCS", function(module, exports) {

var $iJVyP = parcelRequire("iJVyP");

var $k6J5C = parcelRequire("k6J5C");

var $eSVkV = parcelRequire("eSVkV");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $71e264093bcea6c6$var$max(array) {
    return array && array.length ? $iJVyP(array, $eSVkV, $k6J5C) : undefined;
}
module.exports = $71e264093bcea6c6$var$max;

});
parcelRegister("iJVyP", function(module, exports) {

var $6SfBs = parcelRequire("6SfBs");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $da49145969e53def$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$6SfBs(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $da49145969e53def$var$baseExtremum;

});

parcelRegister("k6J5C", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $ea37580c1d35a967$var$baseGt(value, other) {
    return value > other;
}
module.exports = $ea37580c1d35a967$var$baseGt;

});





parcelRegister("dK9AV", function(module, exports) {
$parcel$export(module.exports, "loadCollectionDescription", () => $a5f9ae983aa6748a$export$da25d48c64ab9a24);
$parcel$export(module.exports, "updateCollectionDescription", () => $a5f9ae983aa6748a$export$95146d83152efba8);

var $hFtK7 = parcelRequire("hFtK7");

var $j85oP = parcelRequire("j85oP");

var $7imRA = parcelRequire("7imRA");

var $ifsAO = parcelRequire("ifsAO");

var $5WP8k = parcelRequire("5WP8k");
const $a5f9ae983aa6748a$export$da25d48c64ab9a24 = (collectionUUID)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const existingDescription = state.descriptions[collectionUUID];
        if (existingDescription?.isLoading || existingDescription && !existingDescription.error) return;
        try {
            await (0, $7imRA.wrapWithExperience)((0, $j85oP.experience).collections.loadCollectionDescription, async ()=>{
                setState({
                    descriptions: {
                        ...state.descriptions,
                        [collectionUUID]: {
                            description: undefined,
                            isLoading: true,
                            error: undefined
                        }
                    }
                });
                const newDescription = await (0, $5WP8k.fetchCollectionDescription)(collectionUUID);
                setState({
                    descriptions: {
                        ...state.descriptions,
                        [collectionUUID]: {
                            description: newDescription ?? undefined,
                            isLoading: false
                        }
                    }
                });
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.error.collectionDescriptionLoadingFailed', error));
                setState({
                    descriptions: {
                        ...state.descriptions,
                        [collectionUUID]: {
                            description: undefined,
                            isLoading: false,
                            error: error
                        }
                    }
                });
            }
            throw error;
        }
    };
const $a5f9ae983aa6748a$export$95146d83152efba8 = (collectionUUID, description)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const existingCollection = state.collections[collectionUUID];
        const data = existingCollection?.data;
        if (!data) return;
        try {
            await (0, $7imRA.wrapWithExperience)((0, $j85oP.experience).collections.updateCollectionDescription, async ()=>{
                await (0, $5WP8k.updateCollection)(collectionUUID, {
                    ...data,
                    description: description
                });
                setState({
                    descriptions: {
                        ...state.descriptions,
                        [collectionUUID]: {
                            isLoading: false,
                            error: undefined,
                            description: description
                        }
                    }
                });
            });
        } catch (error) {
            if (error instanceof Error) (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.error.collectionDescriptionUpdateFailed', error));
            throw error;
        }
    };

});


parcelRegister("emWKI", function(module, exports) {
$parcel$export(module.exports, "filterCollectionByOwnerIds", () => $20c3b89226a7d5a1$export$a5af2fa2fc5a6608);
$parcel$export(module.exports, "filterCollectionByProjectKeys", () => $20c3b89226a7d5a1$export$197fb91166111e5e);
$parcel$export(module.exports, "filterCollectionByText", () => $20c3b89226a7d5a1$export$29aabb123440d65b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $20c3b89226a7d5a1$export$a5af2fa2fc5a6608 = (ownerIds)=>(collection)=>!ownerIds?.length || ownerIds.some((accountId)=>accountId === collection.ownerId);
const $20c3b89226a7d5a1$export$197fb91166111e5e = (projectKeys)=>(collection)=>!projectKeys?.length || projectKeys.some((projectKey)=>collection.projectKeys.includes(projectKey));
const $20c3b89226a7d5a1$export$29aabb123440d65b = (search = '')=>{
    const searchLower = search.toLocaleLowerCase();
    return ({ name: name })=>!search || name?.toLocaleLowerCase().includes(searchLower);
};

});


parcelRegister("l01S5", function(module, exports) {
$parcel$export(module.exports, "CollectionDeleteModal", () => $2650426cb07189e9$export$93342321df9268b2);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $anSqv = parcelRequire("anSqv");

var $iPHqm = parcelRequire("iPHqm");

var $6ZLJT = parcelRequire("6ZLJT");

var $hNS01 = parcelRequire("hNS01");

var $26fxr = parcelRequire("26fxr");

var $4qNCE = parcelRequire("4qNCE");

var $1D4ep = parcelRequire("1D4ep");

var $7tY81 = parcelRequire("7tY81");

var $2v3yi = parcelRequire("2v3yi");

var $gpyJM = parcelRequire("gpyJM");

var $dNPnD = parcelRequire("dNPnD");

var $4vluQ = parcelRequire("4vluQ");

var $9imxF = parcelRequire("9imxF");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $iNFDR = parcelRequire("iNFDR");

var $7aCqr = parcelRequire("7aCqr");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $aZMdt = parcelRequire("aZMdt");
var $aqPkH = parcelRequire("aqPkH");
var $aJ81Y = parcelRequire("aJ81Y");

var $eZMSp = parcelRequire("eZMSp");
const $2650426cb07189e9$var$useNavigationCollectionsActionsFG = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jpd-enable-roadmaps-recents-fe'), (0, $iPHqm.useNavigationCollectionsActions), // oxlint-disable-next-line typescript/consistent-type-assertions
()=>null);
const $2650426cb07189e9$var$header = (0, $7eNDO.defineMessage)({
    id: "polaris-component-collection-delete-modal.header",
    defaultMessage: "Do you want to delete \"{roadmapName}\" roadmap?"
});
const $2650426cb07189e9$var$cancel = (0, $7eNDO.defineMessage)({
    id: "polaris-component-collection-delete-modal.cancel",
    defaultMessage: "Cancel"
});
const $2650426cb07189e9$var$deleteMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component-collection-delete-modal.delete",
    defaultMessage: "Delete"
});
const $2650426cb07189e9$var$confirmationTitle = (0, $7eNDO.defineMessage)({
    id: "polaris-component-collection-delete-modal.confirmation-title",
    defaultMessage: "Type \"{roadmapName}\" to confirm the deletion:"
});
const $2650426cb07189e9$var$description = (0, $7eNDO.defineMessage)({
    id: "polaris-component-collection-delete-modal.description",
    defaultMessage: "This roadmap has <b>{viewsCount, plural, =1 {# view} other {# views}}</b>. If you delete it, <b>the views will be deleted.</b> It will not delete the ideas that were used in the roadmap."
});
const $2650426cb07189e9$var$errorTitle = (0, $7eNDO.defineMessage)({
    id: "polaris-component-collection-delete-modal.error-title",
    defaultMessage: "We couldn\u2019t delete the roadmap"
});
const $2650426cb07189e9$var$errorDescription = (0, $7eNDO.defineMessage)({
    id: "polaris-component-collection-delete-modal.error-description",
    defaultMessage: "Please try again or refresh the page."
});
const $2650426cb07189e9$var$progressBarLabel = (0, $7eNDO.defineMessage)({
    id: "polaris-component-collection-delete-modal.progress-bar-label",
    defaultMessage: "Loading roadmap view list"
});
const $2650426cb07189e9$export$93342321df9268b2 = ({ collectionUUID: collectionUUID, onClose: onClose, onDelete: onDelete, views: views, isLoading: isLoading = false, collectionName: collectionName })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $26fxr.useNotifications)();
    const [isDeleteInProgress, setIsDeleteInProgress] = (0, $euxye.useState)(false);
    const [confirmedCollectionName, setConfirmedCollectionName] = (0, $euxye.useState)('');
    const { deleteCollection: deleteCollection } = (0, $anSqv.useCollectionsActions)();
    const actions = $2650426cb07189e9$var$useNavigationCollectionsActionsFG();
    const viewsCount = views.length;
    const handleCloseClick = (0, $euxye.useCallback)((event, analyticsEvent)=>{
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'close');
        onClose(event);
    }, [
        onClose
    ]);
    const handelCancelClick = (0, $euxye.useCallback)((event, analyticsEvent)=>{
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'cancel');
        onClose(event);
    }, [
        onClose
    ]);
    const handleDeleteClick = (0, $euxye.useCallback)(async (event, analyticsEvent)=>{
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'confirm');
        setIsDeleteInProgress(true);
        try {
            await deleteCollection(collectionUUID);
            if (actions && (0, $i860n.fg)('jpd-enable-roadmaps-recents-fe')) {
                actions.runDeleteListeners?.();
                setIsDeleteInProgress(false);
            }
        } catch (error) {
            if (error instanceof Error) errorWithRefresh({
                title: formatMessage($2650426cb07189e9$var$errorTitle),
                description: formatMessage($2650426cb07189e9$var$errorDescription)
            });
            setIsDeleteInProgress(false);
            return;
        }
        onDelete?.(event);
    }, [
        onDelete,
        deleteCollection,
        collectionUUID,
        actions,
        errorWithRefresh,
        formatMessage
    ]);
    if (!collectionName) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9imxF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceName: "confirmDeleteCollection",
        sourceType: (0, $46f069e6c968f461$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7tY81.default), {
        testId: "polaris-component-collection-delete-modal.ui.delete-confirmation-modal",
        onClose: handleCloseClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gpyJM.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dNPnD.default), {
        appearance: "danger",
        testId: "polaris-component-collection-delete-modal.ui.title"
    }, formatMessage($2650426cb07189e9$var$header, {
        roadmapName: collectionName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v3yi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        space: "space.200"
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iNFDR.default), {
        ariaLabel: (0, $i860n.fg)('jpd_fix_prograssbar_label') ? formatMessage($2650426cb07189e9$var$progressBarLabel) : undefined,
        isIndeterminate: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, viewsCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        testId: "polaris-component-collection-delete-modal.ui.description"
    }, formatMessage($2650426cb07189e9$var$description, {
        viewsCount: viewsCount,
        b: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("b", null, text)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eZMSp.ViewsList), {
        collectionUUID: collectionUUID,
        views: views
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($2650426cb07189e9$var$confirmationTitle, {
        roadmapName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hNS01.CopyToClipboard), {
            text: collectionName
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
        maxLength: 255,
        value: confirmedCollectionName,
        onChange: (event)=>setConfirmedCollectionName(event.target.value),
        placeholder: collectionName,
        autoFocus: true,
        isCompact: true,
        testId: "polaris-component-collection-delete-modal.ui.view-name-confirmation"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4vluQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
        onClick: handelCancelClick
    }, formatMessage($2650426cb07189e9$var$cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1D4ep.default), {
        isDisabled: isLoading || collectionName !== confirmedCollectionName,
        isLoading: isDeleteInProgress,
        onClick: handleDeleteClick,
        appearance: "danger",
        testId: "polaris-component-collection-delete-modal.ui.delete-button"
    }, formatMessage($2650426cb07189e9$var$deleteMessage))))));
};
$2650426cb07189e9$export$93342321df9268b2.displayName = "CollectionDeleteModal";

});
parcelRegister("hNS01", function(module, exports) {
$parcel$export(module.exports, "CopyToClipboard", () => $93a638f6ebdb84a1$export$2e6ef246283472d6);
/* CopyToClipboard.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $hZDXn = parcelRequire("hZDXn");

var $6mEZn = parcelRequire("6mEZn");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $93a638f6ebdb84a1$var$copyToClipboard = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-copy-to-clipboard.copy-to-clipboard",
    defaultMessage: "Copy to clipboard"
});
const $93a638f6ebdb84a1$var$copiedMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-copy-to-clipboard.copied-message",
    defaultMessage: "Copied"
});
const $93a638f6ebdb84a1$var$defaultAriaLabel = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-copy-to-clipboard.default-aria-label",
    defaultMessage: "Copy \"{text}\" to clipboard"
});
const $93a638f6ebdb84a1$var$styles = {
    root: "_11c8fhey _18zrze3t _1rjcze3t _k48p1pd9 _4t3i7vkz _1e0c116y _4cvr1h6o _bfhk18uv _9oik18uv _1bnx8stv _jf4cnqa1 _d0altlke"
};
const $93a638f6ebdb84a1$export$2e6ef246283472d6 = ({ text: text, ariaLabel: ariaLabel })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [isCopied, setCopied] = (0, $euxye.useState)(false);
    const onCopy = (0, $euxye.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        globalThis.navigator.clipboard.writeText(text).then(()=>setCopied(true)).catch(()=>setCopied(false));
    }, [
        text
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isCopied) return;
        const copyTimer = setTimeout(()=>setCopied(false), 2500);
        return ()=>clearTimeout(copyTimer);
    }, [
        isCopied
    ]);
    const defaultAriaLabelText = formatMessage($93a638f6ebdb84a1$var$defaultAriaLabel, {
        text: text
    });
    const ariaLabelText = ariaLabel || defaultAriaLabelText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        position: "top",
        hideTooltipOnMouseDown: true,
        delay: 200,
        content: formatMessage(isCopied ? $93a638f6ebdb84a1$var$copiedMessage : $93a638f6ebdb84a1$var$copyToClipboard)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6mEZn.Pressable), {
            ...tooltipProps,
            "aria-label": ariaLabelText,
            testId: "polaris-lib-copy-to-clipboard.ui.copy-to-clipboard",
            onClick: onCopy,
            xcss: $93a638f6ebdb84a1$var$styles.root
        }, text));
};
$93a638f6ebdb84a1$export$2e6ef246283472d6.displayName = "CopyToClipboard";

});

parcelRegister("iNFDR", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2c77a225521728f$export$2e2bcd8739ae039);
/* progress-bar.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");
const $a2c77a225521728f$var$MIN_VALUE = 0;
const $a2c77a225521728f$var$MAX_VALUE = 1;
const $a2c77a225521728f$var$increasingBarAnimation = null;
const $a2c77a225521728f$var$decreasingBarAnimation = null;
const $a2c77a225521728f$var$containerStyles = null;
const $a2c77a225521728f$var$containerStylesT26Shape = null;
const $a2c77a225521728f$var$containerAppearance = {
    default: "_bfhki8nm",
    success: "_bfhki8nm",
    inverse: "_bfhk1vck"
};
const $a2c77a225521728f$var$barAppearance = {
    default: "_bfhk1aqn",
    success: "_bfhkkcmj",
    inverse: "_bfhkvuon"
};
const $a2c77a225521728f$var$barStyles = null;
const $a2c77a225521728f$var$barStylesT26Shape = null;
const $a2c77a225521728f$var$determinateBarStyles = null;
const $a2c77a225521728f$var$increasingBarStyles = null;
const $a2c77a225521728f$var$decreasingBarStyles = null;
/**
 * __Progress bar__
 *
 * A progress bar displays the status of a given process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/code)
 * - [Usage](https://atlassian.design/components/progress-bar/usage)
 */ const $a2c77a225521728f$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $a2c77a225521728f$var$MIN_VALUE : Math.max($a2c77a225521728f$var$MIN_VALUE, Math.min(value, $a2c77a225521728f$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $a2c77a225521728f$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $a2c77a225521728f$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhki8nm",
            (0, $iqfTZ.fg)('platform-dst-shape-theme-default') && "_2rko1rr0",
            $a2c77a225521728f$var$containerAppearance[appearance]
        ]),
        children: isIndeterminate ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                    className: (0, $4jQY2.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $a2c77a225521728f$var$barAppearance[appearance],
                        "_5sagymdr _tip812c5 _j7hq7g40",
                        (0, $iqfTZ.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
                    ])
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                    className: (0, $4jQY2.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $a2c77a225521728f$var$barAppearance[appearance],
                        "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v",
                        (0, $iqfTZ.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $4jQY2.default)([
                "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                $a2c77a225521728f$var$barAppearance[appearance],
                "_v564calv",
                (0, $iqfTZ.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
            ])
        })
    });
};
$a2c77a225521728f$var$ProgressBar.displayName = "ProgressBar";
var $a2c77a225521728f$export$2e2bcd8739ae039 = $a2c77a225521728f$var$ProgressBar;

});

parcelRegister("eZMSp", function(module, exports) {
$parcel$export(module.exports, "ViewsList", () => $c21eee4933dd943e$export$dcdd274cb82cf91a);
/* ViewsList.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $aOGXw = parcelRequire("aOGXw");

var $4KWdc = parcelRequire("4KWdc");

var $iVCI5 = parcelRequire("iVCI5");

var $ihEDU = parcelRequire("ihEDU");

var $2XXtG = parcelRequire("2XXtG");

var $3PC9r = parcelRequire("3PC9r");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $jpPNt = parcelRequire("jpPNt");
const $c21eee4933dd943e$var$expandableSectionTitle = (0, $7eNDO.defineMessage)({
    id: "polaris-component-collection-delete-modal.views-list.expandable-section-title",
    defaultMessage: "Check the views used in this roadmap"
});
const $c21eee4933dd943e$var$styles = {
    viewsList: "_1rjcze3t _18zrze3t _1mouze3t _195gze3t _c71l1mjv _18m91wug",
    icon: "_4t3i1tcg _1bsb1tcg _2hwx12x7",
    viewTitle: "_1mouze3t _195gze3t _1reo15vq _1bto1l2s _o5721q9c _p12fdgin"
};
const $c21eee4933dd943e$export$e7f917c619841a86 = ({ title: title, emoji: emoji, kind: kind, uuid: uuid, collectionUUID: collectionUUID })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jpPNt.Link), {
        target: "_blank",
        href: (0, $aOGXw.getCollectionViewPageUrl)(collectionUUID, uuid)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $c21eee4933dd943e$var$styles.icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4KWdc.default), {
        emojiId: emoji,
        viewKind: kind,
        isReadOnly: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        as: "p",
        xcss: $c21eee4933dd943e$var$styles.viewTitle
    }, title)));
};
$c21eee4933dd943e$export$e7f917c619841a86.displayName = "ViewItem";
const $c21eee4933dd943e$export$dcdd274cb82cf91a = ({ collectionUUID: collectionUUID, views: views })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iVCI5.ExpandableSection), {
        testId: "polaris-component-collection-delete-modal.ui.views-list.expandable-section",
        title: formatMessage($c21eee4933dd943e$var$expandableSectionTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        space: "space.100",
        as: "ul",
        xcss: $c21eee4933dd943e$var$styles.viewsList
    }, views.map((view)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c21eee4933dd943e$export$e7f917c619841a86, {
            key: view.uuid,
            collectionUUID: collectionUUID,
            ...view
        }))));
};
$c21eee4933dd943e$export$dcdd274cb82cf91a.displayName = "ViewsList";

});
parcelRegister("4KWdc", function(module, exports) {
$parcel$export(module.exports, "TitleIconResolver", () => $18c6b7a1d7cfaf45$export$af7600ec6c79295f);
$parcel$export(module.exports, "default", () => $18c6b7a1d7cfaf45$export$2e2bcd8739ae039);
/* TitleIconResolver.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $bnS7o = parcelRequire("bnS7o");

var $8hGNs = parcelRequire("8hGNs");

var $8wdvw = parcelRequire("8wdvw");

var $8rdd5 = parcelRequire("8rdd5");

var $ihEDU = parcelRequire("ihEDU");
const $18c6b7a1d7cfaf45$var$styles = {
    polarisIconWrapper: "_1e0c1txw _4cvr1h6o"
};
const $18c6b7a1d7cfaf45$export$af7600ec6c79295f = (props)=>{
    const { emojiId: emojiId, viewKind: viewKind } = props;
    const emoji = (0, $8wdvw.useEmoji)(emojiId);
    if (emoji) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8hGNs.EmojiWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8rdd5.default), {
        emoji: emoji,
        fitToHeight: 18,
        showTooltip: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $18c6b7a1d7cfaf45$var$styles.polarisIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bnS7o.ViewItemIcon), {
        viewKind: viewKind
    }));
};
$18c6b7a1d7cfaf45$export$af7600ec6c79295f.displayName = "TitleIconResolver";
var $18c6b7a1d7cfaf45$export$2e2bcd8739ae039 = $18c6b7a1d7cfaf45$export$af7600ec6c79295f;

});
parcelRegister("bnS7o", function(module, exports) {
$parcel$export(module.exports, "CustomIcon", () => $0a88a07b8545013b$export$d69e54ca8782c876);
$parcel$export(module.exports, "iconForPolarisFieldType", () => $0a88a07b8545013b$export$d457606e54e7c075);
$parcel$export(module.exports, "PolarisIconType", () => $0a88a07b8545013b$export$5e8403eb012fd9d);
$parcel$export(module.exports, "PolarisIcon", () => $0a88a07b8545013b$export$a79f21f423588858);
$parcel$export(module.exports, "ViewItemIcon", () => $0a88a07b8545013b$export$5dbff0380d392fbc);
/* iconForPolarisFieldType.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-disable-next-line jira/filename-case

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $5GrX3 = parcelRequire("5GrX3");

var $dH1Sa = parcelRequire("dH1Sa");

var $1AgUj = parcelRequire("1AgUj");

var $i3ifO = parcelRequire("i3ifO");

var $hnMDB = parcelRequire("hnMDB");

var $5AgCP = parcelRequire("5AgCP");

var $8gOwO = parcelRequire("8gOwO");

var $1OuFN = parcelRequire("1OuFN");

var $4bwkt = parcelRequire("4bwkt");

var $JzS9Q = parcelRequire("JzS9Q");

var $3JoEa = parcelRequire("3JoEa");

var $5ijLz = parcelRequire("5ijLz");

var $boKQF = parcelRequire("boKQF");

var $54kqL = parcelRequire("54kqL");

var $6TqiN = parcelRequire("6TqiN");

var $l7nyX = parcelRequire("l7nyX");

var $iIFXS = parcelRequire("iIFXS");

var $jKsOD = parcelRequire("jKsOD");

var $5uQUk = parcelRequire("5uQUk");

var $5FGI7 = parcelRequire("5FGI7");

var $hrZFC = parcelRequire("hrZFC");

var $hpjqQ = parcelRequire("hpjqQ");

var $e8KKk = parcelRequire("e8KKk");

var $eQ4Ca = parcelRequire("eQ4Ca");

var $ahyWn = parcelRequire("ahyWn");

var $f183I = parcelRequire("f183I");

var $hWWad = parcelRequire("hWWad");

var $hI6kF = parcelRequire("hI6kF");

var $5lJpZ = parcelRequire("5lJpZ");

var $9NvBE = parcelRequire("9NvBE");

var $e2Gzd = parcelRequire("e2Gzd");

var $hREeQ = parcelRequire("hREeQ");

var $5khM6 = parcelRequire("5khM6");

var $i7nD0 = parcelRequire("i7nD0");

var $5yMWX = parcelRequire("5yMWX");

var $2Gptm = parcelRequire("2Gptm");

var $azr2y = parcelRequire("azr2y");

var $dEPY2 = parcelRequire("dEPY2");

var $3gf7U = parcelRequire("3gf7U");

var $iH2ek = parcelRequire("iH2ek");

var $4ymzv = parcelRequire("4ymzv");

var $5LiAk = parcelRequire("5LiAk");

var $fpBld = parcelRequire("fpBld");

var $92Vsu = parcelRequire("92Vsu");

var $lyXvc = parcelRequire("lyXvc");

var $aNG0w = parcelRequire("aNG0w");

var $3Ihgk = parcelRequire("3Ihgk");

var $eprc4 = parcelRequire("eprc4");

var $4Olij = parcelRequire("4Olij");

var $52SIy = parcelRequire("52SIy");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $cBpb3 = parcelRequire("cBpb3");
const $0a88a07b8545013b$var$iconWrapperStyles = {
    root: "_w8l5pxbi _1752pxbi _e2oopxbi _1xjxpxbi _1b941txw _14ca1h6o _vr2wpfqs"
};
const $0a88a07b8545013b$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $0a88a07b8545013b$var$iconStyles = null;
const $0a88a07b8545013b$export$d69e54ca8782c876 = ({ label: label, size: size = 'medium', primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, glyph: Glyph })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("span", {
        role: label ? 'img' : undefined,
        "aria-label": label,
        "aria-hidden": label ? undefined : true,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        className: (0, $4jQY2.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _5fdi1osq _zbji1osq _rzyw1osq _17jb1osq _1ksvoz0e _3se1vuon _re2rglyw _1veoyfq0",
            $0a88a07b8545013b$var$sizeStyles[size]
        ])
    }, Glyph && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Glyph, {
        role: "presentation"
    }));
};
$0a88a07b8545013b$export$d69e54ca8782c876.displayName = "CustomIcon";
const $0a88a07b8545013b$var$FIELD_TYPE_GLYPH_MAPPING = {
    [(0, $5GrX3.FIELD_TYPES).ASSIGNEE]: [
        (0, $hWWad.peopleGlyph),
        'assignee'
    ],
    [(0, $5GrX3.FIELD_TYPES).CREATOR]: [
        (0, $hWWad.peopleGlyph),
        'creator'
    ],
    [(0, $5GrX3.FIELD_TYPES).REPORTER]: [
        (0, $hWWad.peopleGlyph),
        'reporter'
    ],
    [(0, $5GrX3.FIELD_TYPES).SUMMARY]: [
        (0, $5khM6.shortTextGlyph),
        'summary'
    ],
    [(0, $5GrX3.FIELD_TYPES).STATUS]: [
        (0, $2Gptm.statusGlyph),
        'status'
    ],
    [(0, $5GrX3.FIELD_TYPES).ISSUE_KEY]: [
        (0, $5FGI7.keyGlyph),
        'issue key'
    ],
    [(0, $5GrX3.FIELD_TYPES).ISSUE_TYPE]: [
        (0, $5uQUk.issueTypeGlyph),
        'issue type'
    ],
    [(0, $5GrX3.FIELD_TYPES).SHORT_TEXT]: [
        (0, $5khM6.shortTextGlyph),
        'short text'
    ],
    [(0, $5GrX3.FIELD_TYPES).HYPERLINK]: [
        (0, $e8KKk.linkGlyph),
        'hyperlink'
    ],
    [(0, $5GrX3.FIELD_TYPES).DATE]: [
        (0, $5ijLz.dateGlyph),
        'date'
    ],
    [(0, $5GrX3.FIELD_TYPES).NUMBER]: [
        (0, $f183I.numberGlyph),
        'number'
    ],
    [(0, $5GrX3.FIELD_TYPES).UPDATED]: [
        (0, $3gf7U.timeStampGlyph),
        'updated'
    ],
    [(0, $5GrX3.FIELD_TYPES).CREATED]: [
        (0, $3gf7U.timeStampGlyph),
        'created'
    ],
    [(0, $5GrX3.FIELD_TYPES).LABELS]: [
        (0, $hrZFC.labelGlyph),
        'labels'
    ],
    [(0, $5GrX3.FIELD_TYPES).CUSTOM_LABELS]: [
        (0, $hrZFC.labelGlyph),
        'labels'
    ],
    [(0, $5GrX3.FIELD_TYPES).SINGLE_SELECT]: [
        (0, $54kqL.dropdownGlyph),
        'single select dropdown'
    ],
    [(0, $5GrX3.FIELD_TYPES).MULTI_SELECT]: [
        (0, $54kqL.dropdownGlyph),
        'multi select dropdown'
    ],
    [(0, $5GrX3.FIELD_TYPES).JSW_MULTI_SELECT]: [
        (0, $54kqL.dropdownGlyph),
        'multi select dropdown'
    ],
    [(0, $5GrX3.FIELD_TYPES).PEOPLE]: [
        (0, $hWWad.peopleGlyph),
        'users'
    ],
    [(0, $5GrX3.FIELD_TYPES).JSW_PEOPLE]: [
        (0, $hWWad.peopleGlyph),
        'users'
    ],
    [(0, $5GrX3.FIELD_TYPES).REACTIONS]: [
        (0, $e2Gzd.reactionGlyph),
        'reactions'
    ],
    [(0, $5GrX3.FIELD_TYPES).CHECKBOX]: [
        (0, $8gOwO.checkboxGlyph),
        'checkbox'
    ],
    [(0, $5GrX3.FIELD_TYPES).SLIDER]: [
        (0, $i7nD0.sliderGlyph),
        'slider'
    ],
    [(0, $5GrX3.FIELD_TYPES).RATING]: [
        (0, $9NvBE.ratingGlyph),
        'rating'
    ],
    [(0, $5GrX3.FIELD_TYPES).FORMULA]: [
        (0, $l7nyX.formulaGlyph),
        'formula'
    ],
    [(0, $5GrX3.FIELD_TYPES).VOTES]: [
        (0, $hpjqQ.likeIconFilledGlyph),
        'play'
    ],
    [(0, $5GrX3.FIELD_TYPES).ISSUE_COMMENTS]: [
        (0, $JzS9Q.commentGlyph),
        'comments'
    ],
    [(0, $5GrX3.FIELD_TYPES).LINKED_ISSUES]: [
        (0, $e8KKk.linkGlyph),
        'linked issues'
    ],
    [(0, $5GrX3.FIELD_TYPES).INSIGHTS]: [
        (0, $jKsOD.insightsGlyph),
        'insights'
    ],
    [(0, $5GrX3.FIELD_TYPES).INSIGHT_IMPACT]: [
        (0, $jKsOD.insightsGlyph),
        'insight impact'
    ],
    [(0, $5GrX3.FIELD_TYPES).ATLAS_GOAL]: [
        (0, $6TqiN.atlasGoalGlyph),
        'Atlas goals'
    ],
    [(0, $5GrX3.FIELD_TYPES).ATLAS_PROJECT]: [
        (0, $6TqiN.atlasProjectGlyph),
        'Atlas project'
    ],
    [(0, $5GrX3.FIELD_TYPES).ATLAS_PROJECT_STATUS]: [
        (0, $6TqiN.atlasProjectStatusGlyph),
        'Atlas project status'
    ],
    [(0, $5GrX3.FIELD_TYPES).PLATFORM_GOALS]: [
        (0, $6TqiN.atlasGoalGlyph),
        'goals'
    ],
    [(0, $5GrX3.FIELD_TYPES).PLATFORM_ATLAS_PROJECT]: [
        (0, $6TqiN.atlasProjectGlyph),
        'project'
    ],
    // Cleanup to be removed with project-terminology-refresh cleanup
    [(0, $5GrX3.FIELD_TYPES).PROJECT]: [
        (0, $5lJpZ.projectGlyph),
        'project'
    ]
};
const $0a88a07b8545013b$var$isFieldTypeGlyphMappingKey = (fieldType)=>fieldType in $0a88a07b8545013b$var$FIELD_TYPE_GLYPH_MAPPING;
const $0a88a07b8545013b$export$d457606e54e7c075 = (fieldType, iconProps, configuration)=>{
    // we need 'isWeightedField' because some field types map to multiple icons, eg. MULTI_SELECT_FIELD_TYPE
    const isWeightedField = configuration?.optionWeightType !== undefined;
    const iconPropsInner = iconProps ?? {};
    if (fieldType === undefined) return null;
    if (fieldType === (0, $5GrX3.FIELD_TYPES).PLATFORM_FOCUS_AREAS) return (0, $i860n.fg)('jpd_focus_areas_field_support') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($52SIy))), {
        size: "small",
        label: "focus areas",
        ...iconPropsInner
    }) : null;
    if (isWeightedField === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lyXvc))), {
        size: "small",
        label: "weight",
        ...iconPropsInner
    });
    if (fieldType === (0, $5GrX3.FIELD_TYPES).DELIVERY_STATUS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.JiraIcon), {
        size: "small",
        ...iconPropsInner,
        label: "delivery status"
    }));
    if (fieldType === (0, $5GrX3.FIELD_TYPES).DELIVERY_PROGRESS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.JiraIcon), {
        size: "small",
        ...iconPropsInner,
        label: "delivery progress"
    }));
    if (fieldType === (0, $5GrX3.FIELD_TYPES).PROJECT && (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Ihgk))), {
        label: ""
    });
    if (fieldType === (0, $5GrX3.FIELD_TYPES).INTERVAL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($92Vsu))), {
        label: "date interval",
        ...iconPropsInner
    });
    if (fieldType === (0, $5GrX3.FIELD_TYPES).ISSUE_ID) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5LiAk))), {
        label: "ideas",
        ...iconPropsInner
    });
    if ($0a88a07b8545013b$var$isFieldTypeGlyphMappingKey(fieldType)) {
        const [glyph, label] = $0a88a07b8545013b$var$FIELD_TYPE_GLYPH_MAPPING[fieldType];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
            glyph: glyph,
            size: "small",
            label: label,
            ...iconPropsInner
        });
    }
    if (fieldType === (0, $5GrX3.FIELD_TYPES).DESCRIPTION) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))), {
        label: "overview",
        color: "var(--ds-icon, #292A2E)",
        ...iconPropsInner
    });
    if (fieldType === (0, $5GrX3.FIELD_TYPES).CONNECTION) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cBpb3.ConnectionFieldIcon), {
        issueTypeFilters: configuration?.issueTypeFilters
    });
    if (fieldType === (0, $5GrX3.FIELD_TYPES).TEAM) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4Olij))), {
        label: "team",
        ...iconPropsInner
    });
    return null;
};
const $0a88a07b8545013b$export$5e8403eb012fd9d = {
    Department: 'PolarisIconDepartment',
    ChevronRight: 'PolarisIconChevronRight',
    ChevronUp: 'PolarisIconChevronUp',
    Datapoint: 'PolarisIconDatapoint',
    Board: 'PolarisIconBoard',
    Matrix: 'PolarisIconMatrix',
    Timeline: 'PolarisIconTimeline',
    BulletList: 'PolarisIconBulletList',
    Visible: 'PolarisIconVisible',
    Hidden: 'PolarisIconHidden',
    Scales: 'PolarisIconScales',
    Downvote: 'PolarisIconDownvote',
    Upvote: 'PolarisIconUpvote',
    Poll: 'PolarisIconPoll',
    Switch: 'PolarisIconSwitch',
    AutosaveOff: 'PolarisIconAutosaveOff',
    AutosaveOn: 'PolarisIconAutosaveOn',
    SortMatrixAsc: 'PolarisIconSortMatrixAsc',
    SortMatrixDesc: 'PolarisIconSortMatrixDesc',
    DisplaySettings: 'PolarisIconDisplaySettings',
    MergeIdeas: 'PolarisIconMergeIdeas',
    DeliveryTickets: 'PolarisIconDeliveryTickets',
    SetUpXAxis: 'PolarisIconSetUpXAxis',
    SetUpYAxis: 'PolarisIconSetUpYAxis',
    Project: 'PolarisIconProject',
    CardLayout: 'PolarisIconCardLayout'
};
const $0a88a07b8545013b$export$a79f21f423588858 = (props)=>{
    switch(props.name){
        case $0a88a07b8545013b$export$5e8403eb012fd9d.ChevronRight:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $1OuFN.chevronRightGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.ChevronUp:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $4bwkt.chevronUpGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.Datapoint:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $3JoEa.datapointGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.Board:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $i3ifO.boardGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.Matrix:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $eQ4Ca.matrixGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.Timeline:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $dEPY2.timelineGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.Department:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fpBld))), {
                label: props.label
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.BulletList:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $hnMDB.bulletListGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.Visible:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $4ymzv.visibleGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.Hidden:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $iIFXS.hiddenGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.Scales:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lyXvc))), {
                label: props.label,
                size: props.size === 'small' ? 'small' : 'medium'
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.Downvote:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $iH2ek.upvoteGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.Upvote:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $iH2ek.upvoteGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.Poll:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $hI6kF.pollGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.Switch:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $azr2y.switchGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.AutosaveOff:
            {
                const AutosaveOffIcon = (0, $1AgUj.autosaveOffGlyph); // Not using CustomIcon because autosaveOffGlyph is 20x24
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(AutosaveOffIcon, null);
            }
        case $0a88a07b8545013b$export$5e8403eb012fd9d.AutosaveOn:
            {
                const AutosaveOnIcon = (0, $1AgUj.autosaveOnGlyph); // Not using CustomIcon because autosaveOnGlyph is 20x24
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(AutosaveOnIcon, null);
            }
        case $0a88a07b8545013b$export$5e8403eb012fd9d.SortMatrixAsc:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $5yMWX.sortAscMatrixGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.SortMatrixDesc:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $5yMWX.sortDescMatrixGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.MergeIdeas:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $ahyWn.mergeIdeasGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.DeliveryTickets:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $boKQF.deliveryTicketsGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.SetUpXAxis:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $hREeQ.setUpXAxisGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.SetUpYAxis:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $hREeQ.setUpYAxisGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.Project:
            return (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $5lJpZ.projectGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.CardLayout:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $5AgCP.cardLayoutGlyph),
                ...props
            });
        case $0a88a07b8545013b$export$5e8403eb012fd9d.DisplaySettings:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
                glyph: (0, $i7nD0.sliderGlyph),
                ...props
            });
        default:
            return null;
    }
};
$0a88a07b8545013b$export$a79f21f423588858.displayName = "PolarisIcon";
const $0a88a07b8545013b$export$5dbff0380d392fbc = ({ viewKind: viewKind, size: size })=>{
    if (viewKind === (0, $dH1Sa.VIEW_KIND_TABLE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$a79f21f423588858, {
        name: $0a88a07b8545013b$export$5e8403eb012fd9d.BulletList,
        size: size ?? 'medium',
        label: ""
    });
    if (viewKind === (0, $dH1Sa.VIEW_KIND_BOARD)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$a79f21f423588858, {
        name: $0a88a07b8545013b$export$5e8403eb012fd9d.Board,
        size: size ?? 'medium',
        label: ""
    });
    if (viewKind === (0, $dH1Sa.VIEW_KIND_MATRIX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$a79f21f423588858, {
        name: $0a88a07b8545013b$export$5e8403eb012fd9d.Matrix,
        size: size ?? 'medium',
        label: ""
    });
    if (viewKind === (0, $dH1Sa.VIEW_KIND_TIMELINE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$a79f21f423588858, {
        name: $0a88a07b8545013b$export$5e8403eb012fd9d.Timeline,
        size: size ?? 'medium',
        label: ""
    });
    if (viewKind === (0, $dH1Sa.VIEW_KIND_TREE)) {
        if ((0, $i860n.fg)('jpd_tree-view')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$a79f21f423588858, {
            name: $0a88a07b8545013b$export$5e8403eb012fd9d.Department,
            size: size ?? 'medium',
            label: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$a79f21f423588858, {
            name: $0a88a07b8545013b$export$5e8403eb012fd9d.BulletList,
            size: size ?? 'medium',
            label: ""
        });
    }
    return null;
};
$0a88a07b8545013b$export$5dbff0380d392fbc.displayName = "ViewItemIcon";
const $0a88a07b8545013b$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            $0a88a07b8545013b$var$iconWrapperStyles.root
        ])
    }, children);
$0a88a07b8545013b$var$IconWrapper.displayName = "IconWrapper";
const $0a88a07b8545013b$export$8f56439194ef8d79 = (providedProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0a88a07b8545013b$export$d69e54ca8782c876, {
            ...props,
            ...providedProps
        });

});
parcelRegister("5GrX3", function(module, exports) {
$parcel$export(module.exports, "POLARIS_SUB_TYPES", () => $5b0c558bf8d39a85$export$cfc148b2220b4b0a);
$parcel$export(module.exports, "GLOBAL_SYSTEM_FIELD_TYPES", () => $5b0c558bf8d39a85$export$b088dac07b311768);
$parcel$export(module.exports, "GLOBAL_FIELD_TYPES", () => $5b0c558bf8d39a85$export$447529f60ce12253);
$parcel$export(module.exports, "JIRA_API_FIELD_TYPES", () => $5b0c558bf8d39a85$export$2dd6be6fd8a6584e);
$parcel$export(module.exports, "FIELD_TYPES", () => $5b0c558bf8d39a85$export$afad353d00ed07eb);
$parcel$export(module.exports, "FIELD_TYPES_CATEGORIES", () => $5b0c558bf8d39a85$export$d750d1973f382c74);
$parcel$export(module.exports, "STANDARD_SPACE_NEW_FIELD_TYPE_LIST", () => $5b0c558bf8d39a85$export$786721a6f5196674);
$parcel$export(module.exports, "STANDARD_GLOBAL_FIELD_TYPE_LIST", () => $5b0c558bf8d39a85$export$53f8575aa15002ba);
$parcel$export(module.exports, "UNSUPPORTED_STABLE_IDS_FOR_PINNING", () => $5b0c558bf8d39a85$export$48d61a522297ba1c);

var $iXFKY = parcelRequire("iXFKY");
const $5b0c558bf8d39a85$export$cfc148b2220b4b0a = {
    ARCHIVED: 'ARCHIVED',
    ARCHIVED_BY: 'ARCHIVED_BY',
    ARCHIVED_ON: 'ARCHIVED_ON',
    DELIVERY_PROGRESS: 'DELIVERY_PROGRESS',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    ISSUE_COMMENTS: 'ISSUE_COMMENTS',
    LINKED_ISSUES: 'LINKED_ISSUES',
    NUM_DATA_POINTS: 'NUM_DATA_POINTS',
    ATLAS_GOAL: 'ATLAS_GOAL',
    ATLAS_PROJECT: 'ATLAS_PROJECT',
    ATLAS_PROJECT_STATUS: 'ATLAS_PROJECT_STATUS'
};
// builtin
const $5b0c558bf8d39a85$var$ISSUE_KEY_FIELD_TYPE = 'key'; // issuekey also works.
const $5b0c558bf8d39a85$var$DESCRIPTION_FIELD_TYPE = 'description';
const $5b0c558bf8d39a85$var$ASSIGNEE_FIELD_TYPE = 'assignee';
const $5b0c558bf8d39a85$var$CREATED_FIELD_TYPE = 'created';
const $5b0c558bf8d39a85$var$CREATOR_FIELD_TYPE = 'creator';
const $5b0c558bf8d39a85$var$STATUS_FIELD_TYPE = 'status';
const $5b0c558bf8d39a85$var$SUMMARY_FIELD_TYPE = 'summary';
const $5b0c558bf8d39a85$var$UPDATED_FIELD_TYPE = 'updated';
const $5b0c558bf8d39a85$var$LABELS_FIELD_TYPE = 'labels';
const $5b0c558bf8d39a85$var$ISSUE_TYPE_FIELD_TYPE = 'issuetype';
const $5b0c558bf8d39a85$var$REPORTER_FIELD_TYPE = 'reporter';
const $5b0c558bf8d39a85$var$ISSUE_LINKS_FIELD_TYPE = 'issuelinks';
const $5b0c558bf8d39a85$var$PRIORITY_FIELD_TYPE = 'priority';
const $5b0c558bf8d39a85$var$PROJECT_FIELD_TYPE = 'project';
const $5b0c558bf8d39a85$var$FIX_VERSIONS_FIELD_TYPE = 'fixVersions';
// jira custom field types
const $5b0c558bf8d39a85$var$SHORT_TEXT_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $5b0c558bf8d39a85$var$NUMBER_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $5b0c558bf8d39a85$var$DATE_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $5b0c558bf8d39a85$var$HYPERLINK_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $5b0c558bf8d39a85$var$CUSTOM_LABELS_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $5b0c558bf8d39a85$var$SINGLE_SELECT_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $5b0c558bf8d39a85$var$MULTI_SELECT_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $5b0c558bf8d39a85$var$JSW_MULTI_SELECT_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $5b0c558bf8d39a85$var$PEOPLE_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $5b0c558bf8d39a85$var$JSW_PEOPLE_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $5b0c558bf8d39a85$var$CF_DEVELOPMENT_FIELD_TYPE = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $5b0c558bf8d39a85$var$TEAM_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $5b0c558bf8d39a85$var$PLATFORM_GOALS_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $5b0c558bf8d39a85$var$PLATFORM_FOCUS_AREAS_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:focus-areas';
const $5b0c558bf8d39a85$var$PLATFORM_ATLAS_PROJECT_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:atlas-project';
// jira api only field types
const $5b0c558bf8d39a85$var$EXTERNAL_REFERENCE_FIELD_TYPE = 'jira.polaris:external-reference';
const $5b0c558bf8d39a85$var$DATE_TIME_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
// polaris only types
const $5b0c558bf8d39a85$var$RATING_FIELD_TYPE = 'jira.polaris:rating';
const $5b0c558bf8d39a85$var$SLIDER_FIELD_TYPE = 'jira.polaris:slider';
const $5b0c558bf8d39a85$var$FORMULA_FIELD_TYPE = 'jira.polaris:formula';
const $5b0c558bf8d39a85$var$CHECKBOX_FIELD_TYPE = 'jira.polaris:boolean';
const $5b0c558bf8d39a85$var$INTERVAL_FIELD_TYPE = 'jira.polaris:interval';
const $5b0c558bf8d39a85$var$REACTIONS_FIELD_TYPE = 'jira.polaris:reactions';
const $5b0c558bf8d39a85$var$VOTES_FIELD_TYPE = 'jira.polaris:votes';
const $5b0c558bf8d39a85$var$CONNECTION_FIELD_TYPE = 'jira.polaris:connection';
// polaris only global system types
const $5b0c558bf8d39a85$var$INSIGHT_IMPACT_FIELD_TYPE = 'jira.polaris:insight-impact';
const $5b0c558bf8d39a85$var$INSIGHTS_GLOBAL_FIELD_TYPE = 'jira.polaris:count-insights';
const $5b0c558bf8d39a85$var$LINKED_ISSUES_GLOBAL_FIELD_TYPE = 'jira.polaris:count-linked-issues';
const $5b0c558bf8d39a85$var$DELIVERY_PROGRESS_GLOBAL_FIELD_TYPE = 'jira.polaris:delivery-progress';
const $5b0c558bf8d39a85$var$DELIVERY_STATUS_GLOBAL_FIELD_TYPE = 'jira.polaris:delivery-status';
const $5b0c558bf8d39a85$var$PLATFORM_PROJECT_FIELD_TYPE = 'jira.polaris:atlassian-project';
const $5b0c558bf8d39a85$var$PLATFORM_PROJECT_STATUS_FIELD_TYPE = 'jira.polaris:atlassian-project-status';
const $5b0c558bf8d39a85$var$ISSUE_COMMENTS_GLOBAL_FIELD_TYPE = 'jira.polaris:count-issue-comments';
// Virtual Fields
const $5b0c558bf8d39a85$var$ISSUE_ID_FIELD_TYPE = 'issueid';
// Frontend only: Jira missing type (formula, external-reference, archive...).
const $5b0c558bf8d39a85$var$ATLAS_PROJECT_FIELD_TYPE = 'atlasProject';
const $5b0c558bf8d39a85$var$ATLAS_GOAL_FIELD_TYPE = 'atlasGoal';
const $5b0c558bf8d39a85$var$ATLAS_PROJECT_STATUS_FIELD_TYPE = 'atlasProjectStatus';
const $5b0c558bf8d39a85$var$DELIVERY_PROGRESS_FIELD_TYPE = 'deliveryProgress';
const $5b0c558bf8d39a85$var$LINKED_ISSUES_FIELD_TYPE = 'linkedIssues';
const $5b0c558bf8d39a85$var$ARCHIVED_BY_FIELD_TYPE = 'archivedBy';
const $5b0c558bf8d39a85$var$ARCHIVED_ON_FIELD_TYPE = 'archivedOn';
const $5b0c558bf8d39a85$var$ARCHIVED_FIELD_TYPE = 'archived';
const $5b0c558bf8d39a85$var$ISSUE_COMMENTS_FIELD_TYPE = 'issueComments'; // issue comments count
const $5b0c558bf8d39a85$var$INSIGHTS_FIELD_TYPE = 'numDataPoints';
const $5b0c558bf8d39a85$var$DELIVERY_STATUS_FIELD_TYPE = 'deliveryStatus';
// others
const $5b0c558bf8d39a85$var$RANK_FIELD_TYPE = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $5b0c558bf8d39a85$var$SPRINT_FIELD_TYPE = 'com.pyxis.greenhopper.jira:gh-sprint';
const $5b0c558bf8d39a85$export$b088dac07b311768 = {
    PLATFORM_GOALS: $5b0c558bf8d39a85$var$PLATFORM_GOALS_FIELD_TYPE,
    PLATFORM_FOCUS_AREAS: $5b0c558bf8d39a85$var$PLATFORM_FOCUS_AREAS_FIELD_TYPE,
    INSIGHTS_GLOBAL: $5b0c558bf8d39a85$var$INSIGHTS_GLOBAL_FIELD_TYPE,
    LINKED_ISSUES_GLOBAL: $5b0c558bf8d39a85$var$LINKED_ISSUES_GLOBAL_FIELD_TYPE,
    DELIVERY_PROGRESS_GLOBAL: $5b0c558bf8d39a85$var$DELIVERY_PROGRESS_GLOBAL_FIELD_TYPE,
    DELIVERY_STATUS_GLOBAL: $5b0c558bf8d39a85$var$DELIVERY_STATUS_GLOBAL_FIELD_TYPE,
    ISSUE_COMMENTS_GLOBAL: $5b0c558bf8d39a85$var$ISSUE_COMMENTS_GLOBAL_FIELD_TYPE,
    PLATFORM_PROJECT: $5b0c558bf8d39a85$var$PLATFORM_PROJECT_FIELD_TYPE,
    PLATFORM_PROJECT_STATUS: $5b0c558bf8d39a85$var$PLATFORM_PROJECT_STATUS_FIELD_TYPE,
    PLATFORM_ATLAS_PROJECT: $5b0c558bf8d39a85$var$PLATFORM_ATLAS_PROJECT_FIELD_TYPE
};
const $5b0c558bf8d39a85$export$447529f60ce12253 = {
    ...$5b0c558bf8d39a85$export$b088dac07b311768,
    CONNECTION: $5b0c558bf8d39a85$var$CONNECTION_FIELD_TYPE,
    CHECKBOX: $5b0c558bf8d39a85$var$CHECKBOX_FIELD_TYPE,
    FORMULA: $5b0c558bf8d39a85$var$FORMULA_FIELD_TYPE,
    INTERVAL: $5b0c558bf8d39a85$var$INTERVAL_FIELD_TYPE,
    HYPERLINK: $5b0c558bf8d39a85$var$HYPERLINK_FIELD_TYPE,
    MULTI_SELECT: $5b0c558bf8d39a85$var$MULTI_SELECT_FIELD_TYPE,
    JSW_MULTI_SELECT: $5b0c558bf8d39a85$var$JSW_MULTI_SELECT_FIELD_TYPE,
    NUMBER: $5b0c558bf8d39a85$var$NUMBER_FIELD_TYPE,
    RATING: $5b0c558bf8d39a85$var$RATING_FIELD_TYPE,
    REACTIONS: $5b0c558bf8d39a85$var$REACTIONS_FIELD_TYPE,
    SHORT_TEXT: $5b0c558bf8d39a85$var$SHORT_TEXT_FIELD_TYPE,
    SINGLE_SELECT: $5b0c558bf8d39a85$var$SINGLE_SELECT_FIELD_TYPE,
    SLIDER: $5b0c558bf8d39a85$var$SLIDER_FIELD_TYPE,
    JSW_PEOPLE: $5b0c558bf8d39a85$var$JSW_PEOPLE_FIELD_TYPE,
    TEAM: $5b0c558bf8d39a85$var$TEAM_FIELD_TYPE
};
const $5b0c558bf8d39a85$var$SHARED_FIELD_TYPES = {
    ...$5b0c558bf8d39a85$export$447529f60ce12253,
    ASSIGNEE: $5b0c558bf8d39a85$var$ASSIGNEE_FIELD_TYPE,
    CF_DEVELOPMENT: $5b0c558bf8d39a85$var$CF_DEVELOPMENT_FIELD_TYPE,
    CREATED: $5b0c558bf8d39a85$var$CREATED_FIELD_TYPE,
    CREATOR: $5b0c558bf8d39a85$var$CREATOR_FIELD_TYPE,
    CUSTOM_LABELS: $5b0c558bf8d39a85$var$CUSTOM_LABELS_FIELD_TYPE,
    DATE: $5b0c558bf8d39a85$var$DATE_FIELD_TYPE,
    DESCRIPTION: $5b0c558bf8d39a85$var$DESCRIPTION_FIELD_TYPE,
    ISSUE_ID: $5b0c558bf8d39a85$var$ISSUE_ID_FIELD_TYPE,
    ISSUE_KEY: $5b0c558bf8d39a85$var$ISSUE_KEY_FIELD_TYPE,
    ISSUE_LINKS: $5b0c558bf8d39a85$var$ISSUE_LINKS_FIELD_TYPE,
    ISSUE_TYPE: $5b0c558bf8d39a85$var$ISSUE_TYPE_FIELD_TYPE,
    LABELS: $5b0c558bf8d39a85$var$LABELS_FIELD_TYPE,
    PEOPLE: $5b0c558bf8d39a85$var$PEOPLE_FIELD_TYPE,
    PRIORITY: $5b0c558bf8d39a85$var$PRIORITY_FIELD_TYPE,
    PROJECT: $5b0c558bf8d39a85$var$PROJECT_FIELD_TYPE,
    RANK: $5b0c558bf8d39a85$var$RANK_FIELD_TYPE,
    REPORTER: $5b0c558bf8d39a85$var$REPORTER_FIELD_TYPE,
    STATUS: $5b0c558bf8d39a85$var$STATUS_FIELD_TYPE,
    SUMMARY: $5b0c558bf8d39a85$var$SUMMARY_FIELD_TYPE,
    UPDATED: $5b0c558bf8d39a85$var$UPDATED_FIELD_TYPE,
    VOTES: $5b0c558bf8d39a85$var$VOTES_FIELD_TYPE,
    CONNECTION: $5b0c558bf8d39a85$var$CONNECTION_FIELD_TYPE,
    FIX_VERSIONS: $5b0c558bf8d39a85$var$FIX_VERSIONS_FIELD_TYPE,
    SPRINT: $5b0c558bf8d39a85$var$SPRINT_FIELD_TYPE
};
const $5b0c558bf8d39a85$export$2dd6be6fd8a6584e = {
    ...$5b0c558bf8d39a85$var$SHARED_FIELD_TYPES,
    EXTERNAL_REFERENCE: $5b0c558bf8d39a85$var$EXTERNAL_REFERENCE_FIELD_TYPE,
    DATE_TIME: $5b0c558bf8d39a85$var$DATE_TIME_FIELD_TYPE
};
const $5b0c558bf8d39a85$export$afad353d00ed07eb = {
    ...$5b0c558bf8d39a85$var$SHARED_FIELD_TYPES,
    ARCHIVED_BY: $5b0c558bf8d39a85$var$ARCHIVED_BY_FIELD_TYPE,
    ARCHIVED_ON: $5b0c558bf8d39a85$var$ARCHIVED_ON_FIELD_TYPE,
    ARCHIVED: $5b0c558bf8d39a85$var$ARCHIVED_FIELD_TYPE,
    ATLAS_GOAL: $5b0c558bf8d39a85$var$ATLAS_GOAL_FIELD_TYPE,
    ATLAS_PROJECT_STATUS: $5b0c558bf8d39a85$var$ATLAS_PROJECT_STATUS_FIELD_TYPE,
    ATLAS_PROJECT: $5b0c558bf8d39a85$var$ATLAS_PROJECT_FIELD_TYPE,
    DELIVERY_PROGRESS: $5b0c558bf8d39a85$var$DELIVERY_PROGRESS_FIELD_TYPE,
    DELIVERY_STATUS: $5b0c558bf8d39a85$var$DELIVERY_STATUS_FIELD_TYPE,
    INSIGHT_IMPACT: $5b0c558bf8d39a85$var$INSIGHT_IMPACT_FIELD_TYPE,
    INSIGHTS: $5b0c558bf8d39a85$var$INSIGHTS_FIELD_TYPE,
    ISSUE_COMMENTS: $5b0c558bf8d39a85$var$ISSUE_COMMENTS_FIELD_TYPE,
    LINKED_ISSUES: $5b0c558bf8d39a85$var$LINKED_ISSUES_FIELD_TYPE,
    CONNECTION: $5b0c558bf8d39a85$var$CONNECTION_FIELD_TYPE
};
const $5b0c558bf8d39a85$export$d750d1973f382c74 = {
    ARCHIVED: [
        $5b0c558bf8d39a85$export$afad353d00ed07eb.ARCHIVED_BY,
        $5b0c558bf8d39a85$export$afad353d00ed07eb.ARCHIVED,
        $5b0c558bf8d39a85$export$afad353d00ed07eb.ARCHIVED_ON
    ],
    ATLAS: [
        $5b0c558bf8d39a85$export$afad353d00ed07eb.ATLAS_GOAL,
        $5b0c558bf8d39a85$export$afad353d00ed07eb.ATLAS_PROJECT,
        $5b0c558bf8d39a85$export$afad353d00ed07eb.ATLAS_PROJECT_STATUS,
        $5b0c558bf8d39a85$export$afad353d00ed07eb.PLATFORM_GOALS,
        $5b0c558bf8d39a85$export$afad353d00ed07eb.PLATFORM_FOCUS_AREAS,
        $5b0c558bf8d39a85$export$afad353d00ed07eb.PLATFORM_PROJECT,
        $5b0c558bf8d39a85$export$afad353d00ed07eb.PLATFORM_PROJECT_STATUS
    ],
    USER: [
        $5b0c558bf8d39a85$export$afad353d00ed07eb.ASSIGNEE,
        $5b0c558bf8d39a85$export$afad353d00ed07eb.CREATOR,
        $5b0c558bf8d39a85$export$afad353d00ed07eb.REPORTER
    ]
};
const $5b0c558bf8d39a85$var$standardFieldTypeList = [
    $5b0c558bf8d39a85$export$afad353d00ed07eb.CHECKBOX,
    $5b0c558bf8d39a85$export$afad353d00ed07eb.INTERVAL,
    $5b0c558bf8d39a85$export$afad353d00ed07eb.HYPERLINK,
    $5b0c558bf8d39a85$export$afad353d00ed07eb.MULTI_SELECT,
    $5b0c558bf8d39a85$export$afad353d00ed07eb.NUMBER,
    $5b0c558bf8d39a85$export$afad353d00ed07eb.RATING,
    $5b0c558bf8d39a85$export$afad353d00ed07eb.REACTIONS,
    $5b0c558bf8d39a85$export$afad353d00ed07eb.SHORT_TEXT,
    $5b0c558bf8d39a85$export$afad353d00ed07eb.SINGLE_SELECT,
    $5b0c558bf8d39a85$export$afad353d00ed07eb.SLIDER
];
const $5b0c558bf8d39a85$export$786721a6f5196674 = [
    ...$5b0c558bf8d39a85$var$standardFieldTypeList,
    $5b0c558bf8d39a85$export$afad353d00ed07eb.PEOPLE
];
const $5b0c558bf8d39a85$export$53f8575aa15002ba = [
    ...$5b0c558bf8d39a85$var$standardFieldTypeList,
    $5b0c558bf8d39a85$export$afad353d00ed07eb.JSW_PEOPLE
];
const $5b0c558bf8d39a85$export$48d61a522297ba1c = [
    (0, $iXFKY.STABLE_IDS).START_DATE
];
const $5b0c558bf8d39a85$export$69fdcab61a28dac3 = $5b0c558bf8d39a85$export$afad353d00ed07eb;

});
parcelRegister("iXFKY", function(module, exports) {
$parcel$export(module.exports, "STABLE_IDS", () => $aa85b88fb497cd66$export$3c40e95743b409fd);
$parcel$export(module.exports, "isGlobalSystemFieldStableId", () => $aa85b88fb497cd66$export$db403227c18eb65d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
const $aa85b88fb497cd66$export$3c40e95743b409fd = {
    PLATFORM_PROJECT: (0, $231b49775e1ec1dd$export$48c1a69bd5564b65),
    PLATFORM_PROJECT_STATUS: (0, $231b49775e1ec1dd$export$cd1b6ac45f51c6e5),
    ISSUE_COMMENTS: (0, $231b49775e1ec1dd$export$798c9f93a02ce7dd),
    DELIVERY_PROGRESS: (0, $231b49775e1ec1dd$export$5c86841152c9af38),
    DELIVERY_STATUS: (0, $231b49775e1ec1dd$export$c41983369cfe1a19),
    ARCHIVED: (0, $231b49775e1ec1dd$export$292571c17f71a537),
    ARCHIVED_BY: (0, $231b49775e1ec1dd$export$cf35a0b8c5585b51),
    ARCHIVED_ON: (0, $231b49775e1ec1dd$export$c520a2556c6211c),
    INSIGHTS: (0, $231b49775e1ec1dd$export$1866edc9dadf522f),
    LINKED_ISSUES: (0, $231b49775e1ec1dd$export$1200cfbac4072d9a),
    START_DATE: (0, $231b49775e1ec1dd$export$8d3252cffbe94888)
};
const $aa85b88fb497cd66$var$GLOBAL_SYSTEM_FIELDS_STABLE_IDS = new Set([
    (0, $231b49775e1ec1dd$export$48c1a69bd5564b65),
    (0, $231b49775e1ec1dd$export$cd1b6ac45f51c6e5),
    (0, $231b49775e1ec1dd$export$798c9f93a02ce7dd),
    (0, $231b49775e1ec1dd$export$5c86841152c9af38),
    (0, $231b49775e1ec1dd$export$c41983369cfe1a19),
    (0, $231b49775e1ec1dd$export$292571c17f71a537),
    (0, $231b49775e1ec1dd$export$cf35a0b8c5585b51),
    (0, $231b49775e1ec1dd$export$c520a2556c6211c),
    (0, $231b49775e1ec1dd$export$1866edc9dadf522f),
    (0, $231b49775e1ec1dd$export$1200cfbac4072d9a)
]);
const $aa85b88fb497cd66$export$db403227c18eb65d = (stableId)=>stableId ? $aa85b88fb497cd66$var$GLOBAL_SYSTEM_FIELDS_STABLE_IDS.has(stableId) : false;

});
/* eslint-disable jira/filename-case */ const $231b49775e1ec1dd$export$48c1a69bd5564b65 = 'sfid:jira-product-discovery:atlassian-project';
const $231b49775e1ec1dd$export$cd1b6ac45f51c6e5 = 'sfid:jira-product-discovery:atlassian-project-status';
const $231b49775e1ec1dd$export$798c9f93a02ce7dd = 'sfid:jira-product-discovery:count-issue-comments';
const $231b49775e1ec1dd$export$5c86841152c9af38 = 'sfid:jira-product-discovery:delivery-progress';
const $231b49775e1ec1dd$export$c41983369cfe1a19 = 'sfid:jira-product-discovery:delivery-status';
const $231b49775e1ec1dd$export$292571c17f71a537 = 'sfid:jira-product-discovery:archived';
const $231b49775e1ec1dd$export$cf35a0b8c5585b51 = 'sfid:jira-product-discovery:archived-by';
const $231b49775e1ec1dd$export$c520a2556c6211c = 'sfid:jira-product-discovery:archived-on';
const $231b49775e1ec1dd$export$1866edc9dadf522f = 'sfid:jira-product-discovery:count-insights';
const $231b49775e1ec1dd$export$1200cfbac4072d9a = 'sfid:jira-product-discovery:count-linked-issues';
const $231b49775e1ec1dd$export$8d3252cffbe94888 = 'sfid:jira-software:start-date';



parcelRegister("1AgUj", function(module, exports) {
$parcel$export(module.exports, "autosaveOffGlyph", () => $43c94072e904d288$export$b5cd12a2bcab99c3);
$parcel$export(module.exports, "autosaveOnGlyph", () => $43c94072e904d288$export$ca975f435a4e5738);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $43c94072e904d288$export$b5cd12a2bcab99c3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "currentColor",
        d: "m6.973 5.221.747-.747a5.214 5.214 0 0 0-3.863 1.543C2.443 7.43 1.96 9.48 2.569 11.282a.87.87 0 0 1-.53 1.08.806.806 0 0 1-1.059-.486C.17 9.475.812 6.74 2.697 4.856c1.451-1.45 3.41-2.17 5.34-2.046L6.972 1.743A.822.822 0 0 1 8.133.581l2.262 2.263a.904.904 0 0 1-.001 1.277l-2.26 2.26a.82.82 0 0 1-1.16-1.16ZM9.606 19.34l2.26-2.26a.82.82 0 0 1 1.16 1.16l-.745.746c1.4.05 2.809-.49 3.861-1.542 1.414-1.414 1.896-3.463 1.288-5.265a.87.87 0 0 1 .991-1.118.786.786 0 0 1 .598.525c.81 2.4.168 5.134-1.716 7.018-1.452 1.452-3.411 2.171-5.341 2.047l1.067 1.067a.822.822 0 0 1-1.162 1.162l-2.262-2.262a.904.904 0 0 1 0-1.278Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.708 19.442a.997.997 0 0 1-1.631-.326.996.996 0 0 1 .216-1.09l5.893-5.892L8.64 7.73h2.722l.057.172 4.88-4.88a.996.996 0 0 1 1.412.003.996.996 0 0 1 .002 1.412L2.708 19.442Zm7.088-9.918.328-.328-.118-.43-.21.758Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "currentColor",
        d: "m9.97 14.294-.113-.001 2.759-2.76L14 15.73h-2.075l-.432-1.582a8.36 8.36 0 0 1-1.523.146Z"
    }));
const $43c94072e904d288$export$ca975f435a4e5738 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "currentColor",
        d: "m7.72 4.744-.747.747a.82.82 0 0 0 1.16 1.16l2.261-2.26a.904.904 0 0 0 .001-1.278L8.133.851A.822.822 0 1 0 6.97 2.013L8.038 3.08c-1.93-.125-3.89.595-5.341 2.046C.812 7.011.169 9.744.98 12.146c.146.432.62.65 1.059.486a.87.87 0 0 0 .53-1.08C1.961 9.75 2.443 7.7 3.857 6.286A5.214 5.214 0 0 1 7.72 4.744ZM11.866 17.35l-2.26 2.26a.904.904 0 0 0-.001 1.277l2.262 2.263a.821.821 0 1 0 1.162-1.162l-1.067-1.068c1.93.125 3.89-.595 5.34-2.046 1.885-1.885 2.528-4.618 1.717-7.019a.786.786 0 0 0-.598-.525.82.82 0 0 0-.462.039.87.87 0 0 0-.53 1.08c.609 1.802.127 3.85-1.287 5.264a5.213 5.213 0 0 1-3.861 1.543l.745-.746a.82.82 0 0 0-1.16-1.16Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.493 14.417a8.36 8.36 0 0 1-1.523.146c-.48 0-.947-.049-1.463-.134L8.075 16H6l2.639-8h2.722L14 16h-2.075l-.432-1.583Zm-2.59-1.388a8.42 8.42 0 0 0 1.067.073c.36 0 .732-.024 1.127-.085l-1.091-3.982-1.103 3.994Z",
        clipRule: "evenodd"
    }));

});

parcelRegister("i3ifO", function(module, exports) {
$parcel$export(module.exports, "boardGlyph", () => $f75b62ce12aa5a89$export$669acf0e57565b4f);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $f75b62ce12aa5a89$export$669acf0e57565b4f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        fill: "currentColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M4 11H12.004C12 11 12 5 12 5H3.996C4 5 4 11 4 11ZM3 4.997C3 4.4465 3.449 4 3.995 4H12.005C12.554 4 13 4.4475 13 4.997V11.003C12.9996 11.267 12.8947 11.52 12.7083 11.7068C12.5218 11.8937 12.269 11.9991 12.005 12H3.995C3.73093 11.9995 3.47785 11.8942 3.29131 11.7073C3.10477 11.5204 3 11.2671 3 11.003V4.997Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M6 5V11H7V5H6ZM9 5V11H10V5H9Z"
    })));

});

parcelRegister("hnMDB", function(module, exports) {
$parcel$export(module.exports, "bulletListGlyph", () => $d24081c8ebfdbcf6$export$a6a7f7b7c0399a2a);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $d24081c8ebfdbcf6$export$a6a7f7b7c0399a2a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M12.1667 10.6667H7.16667C6.70643 10.6667 6.33333 11.0398 6.33333 11.5C6.33333 11.9602 6.70643 12.3333 7.16667 12.3333H12.1667C12.6269 12.3333 13 11.9602 13 11.5C13 11.0398 12.6269 10.6667 12.1667 10.6667Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M4.66667 11.5C4.66667 11.0398 4.29357 10.6667 3.83333 10.6667C3.3731 10.6667 3 11.0398 3 11.5C3 11.9602 3.3731 12.3333 3.83333 12.3333C4.29357 12.3333 4.66667 11.9602 4.66667 11.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M12.1667 7.33333H7.16667C6.70643 7.33333 6.33333 7.70643 6.33333 8.16667C6.33333 8.6269 6.70643 9 7.16667 9H12.1667C12.6269 9 13 8.6269 13 8.16667C13 7.70643 12.6269 7.33333 12.1667 7.33333Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M4.66667 8.16667C4.66667 7.70643 4.29357 7.33333 3.83333 7.33333C3.3731 7.33333 3 7.70643 3 8.16667C3 8.6269 3.3731 9 3.83333 9C4.29357 9 4.66667 8.6269 4.66667 8.16667Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M12.1667 4H7.16667C6.70643 4 6.33333 4.3731 6.33333 4.83333C6.33333 5.29357 6.70643 5.66667 7.16667 5.66667H12.1667C12.6269 5.66667 13 5.29357 13 4.83333C13 4.3731 12.6269 4 12.1667 4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M4.66667 4.83333C4.66667 4.3731 4.29357 4 3.83333 4C3.3731 4 3 4.3731 3 4.83333C3 5.29357 3.3731 5.66667 3.83333 5.66667C4.29357 5.66667 4.66667 5.29357 4.66667 4.83333Z",
        fill: "currentColor"
    }));

});

parcelRegister("5AgCP", function(module, exports) {
$parcel$export(module.exports, "cardLayoutGlyph", () => $63dd7165538c9e0d$export$db0f2d702cac4ae9);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $63dd7165538c9e0d$export$db0f2d702cac4ae9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "currentColor",
        fillOpacity: ".01",
        d: "M0 0h24v24H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 5h14a1 1 0 1 1 0 2H5a1 1 0 0 1 0-2Zm0 12h6a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Zm0-8h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "currentColor",
        d: "m17.11 10.776-.657.944a.604.604 0 1 1-.854-.855l1.581-1.581A.617.617 0 0 1 17.715 9c.232 0 .433.115.534.284l1.581 1.581a.605.605 0 0 1-.854.855l-.657-.944v5.48c0 .294-.27.533-.604.533-.334 0-.605-.239-.605-.533v-5.48Zm1.139 7.845a.617.617 0 0 1-.534.284.617.617 0 0 1-.535-.284L15.6 17.039a.604.604 0 0 1 .854-.855l.657.945v-2.225c0-.294.27-.533.605-.533.333 0 .604.239.604.533v2.225l.657-.945a.605.605 0 0 1 .854.855l-1.581 1.582Z"
    }));

});

parcelRegister("8gOwO", function(module, exports) {
$parcel$export(module.exports, "checkboxGlyph", () => $6065784d3a4c6cff$export$747056db840f2e62);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $6065784d3a4c6cff$export$747056db840f2e62 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 2H13C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44772 2 3 2ZM0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3ZM5.71929 7.30529C5.62704 7.20978 5.5167 7.1336 5.39469 7.08119C5.27269 7.02878 5.14147 7.00119 5.00869 7.00004C4.87591 6.99888 4.74423 7.02419 4.62133 7.07447C4.49844 7.12475 4.38679 7.199 4.29289 7.29289C4.199 7.38679 4.12475 7.49844 4.07447 7.62133C4.02419 7.74423 3.99888 7.87591 4.00004 8.00869C4.00119 8.14147 4.02878 8.27269 4.08119 8.39469C4.1336 8.5167 4.20978 8.62704 4.30529 8.71929L6.30529 10.7193C6.49282 10.9068 6.74712 11.0121 7.01229 11.0121C7.27745 11.0121 7.53176 10.9068 7.71929 10.7193L11.7193 6.71929C11.8148 6.62704 11.891 6.5167 11.9434 6.39469C11.9958 6.27269 12.0234 6.14147 12.0245 6.00869C12.0257 5.87591 12.0004 5.74423 11.9501 5.62133C11.8998 5.49844 11.8256 5.38679 11.7317 5.29289C11.6378 5.199 11.5261 5.12475 11.4032 5.07447C11.2803 5.02419 11.1487 4.99888 11.0159 5.00004C10.8831 5.00119 10.7519 5.02878 10.6299 5.08119C10.5079 5.1336 10.3975 5.20978 10.3053 5.30529L7.01229 8.59829L5.71929 7.30529Z",
        fill: "currentColor"
    }));

});

parcelRegister("1OuFN", function(module, exports) {
$parcel$export(module.exports, "chevronRightGlyph", () => $a24f8d2a6c8184d8$export$52a64ce081d4ec56);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $a24f8d2a6c8184d8$export$52a64ce081d4ec56 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M10.4714 7.52861C10.7131 7.77036 10.7304 8.15159 10.5232 8.41327L10.4714 8.47142L7.13807 11.8047C6.87772 12.0651 6.45561 12.0651 6.19526 11.8047C5.95351 11.563 5.93624 11.1818 6.14346 10.9201L6.19526 10.8619L9.05717 7.99954L6.19526 5.13809C5.95351 4.89634 5.93624 4.5151 6.14346 4.25342L6.19526 4.19529C6.43702 3.95353 6.81824 3.93625 7.07992 4.14347L7.13807 4.19529L10.4714 7.52861Z",
        fill: "currentColor"
    }));

});

parcelRegister("4bwkt", function(module, exports) {
$parcel$export(module.exports, "chevronUpGlyph", () => $8c00ed31bcd212f4$export$16048e54de89de25);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $8c00ed31bcd212f4$export$16048e54de89de25 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.8314 8.48301L6.43781 12.9157C6.15759 13.199 6.00043 13.5814 6.00043 13.9799C6.00043 14.3784 6.15759 14.7609 6.43781 15.0442C6.57543 15.184 6.73947 15.2949 6.92038 15.3707C7.1013 15.4464 7.29547 15.4854 7.49159 15.4854C7.68772 15.4854 7.88189 15.4464 8.0628 15.3707C8.24371 15.2949 8.40775 15.184 8.54537 15.0442L11.9925 11.5686L15.4531 15.0592C15.5911 15.1989 15.7554 15.3097 15.9365 15.3854C16.1177 15.4611 16.3121 15.5 16.5084 15.5C16.7047 15.5 16.899 15.4611 17.0802 15.3854C17.2613 15.3097 17.4257 15.1989 17.5637 15.0592C17.8435 14.7757 18.0004 14.3933 18.0004 13.9949C18.0004 13.5965 17.8435 13.2142 17.5637 12.9307L13.1535 8.48301C12.8434 8.17444 12.424 8.00084 11.9865 8C11.568 8 11.151 8.1605 10.8314 8.48301Z",
        fill: "currentColor"
    }));

});

parcelRegister("JzS9Q", function(module, exports) {
$parcel$export(module.exports, "commentGlyph", () => $7b59547dc19ef4ad$export$835d228e2a9d6a93);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $7b59547dc19ef4ad$export$835d228e2a9d6a93 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.776 11.6782C5.776 8.97778 8.568 6.78044 12 6.78044C15.432 6.78044 18.224 8.97778 18.224 11.6782C18.224 14.3796 15.432 16.576 12 16.576C8.568 16.576 5.776 14.3796 5.776 11.6782ZM18.9671 18.5858V18.584C18.9671 18.584 17.5769 16.5751 18.2853 15.8142L18.2524 15.832C19.3431 14.6907 20 13.248 20 11.6782C20 7.99644 16.4116 5 12 5C7.58844 5 4 7.99556 4 11.6782C4 15.3609 7.58844 18.3573 12 18.3573C13.2622 18.3573 14.4533 18.104 15.5173 17.6676C16.4089 18.576 17.5502 19.0649 18.3973 19.1956L18.3991 19.1929C18.4458 19.2104 18.495 19.2203 18.5449 19.2222C18.6205 19.2222 18.6949 19.2035 18.7615 19.1677C18.8281 19.1319 18.8847 19.0802 18.9265 19.0171C18.9682 18.9541 18.9937 18.8817 19.0006 18.8065C19.0075 18.7312 18.9966 18.6554 18.9671 18.5858Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M15.5556 9.44444H8.44444C7.95352 9.44444 7.55556 9.84241 7.55556 10.3333C7.55556 10.8243 7.95352 11.2222 8.44444 11.2222H15.5556C16.0465 11.2222 16.4444 10.8243 16.4444 10.3333C16.4444 9.84241 16.0465 9.44444 15.5556 9.44444Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M11.1111 12.1111H8.44444C7.95352 12.1111 7.55556 12.5091 7.55556 13C7.55556 13.4909 7.95352 13.8889 8.44444 13.8889H11.1111C11.602 13.8889 12 13.4909 12 13C12 12.5091 11.602 12.1111 11.1111 12.1111Z",
        fill: "currentColor"
    }));

});

parcelRegister("3JoEa", function(module, exports) {
$parcel$export(module.exports, "datapointGlyph", () => $3596a8790b03c840$export$b8ebe0da04ea148b);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $3596a8790b03c840$export$b8ebe0da04ea148b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M12.9667 14.2686C13.1609 14.4627 13.4242 14.5717 13.6988 14.5717C13.9733 14.5717 14.2367 14.4627 14.4308 14.2686L18.5726 10.1268C18.6715 10.0313 18.7503 9.91706 18.8046 9.79073C18.8589 9.6644 18.8874 9.52853 18.8886 9.39105C18.8898 9.25356 18.8636 9.11722 18.8116 8.98997C18.7595 8.86272 18.6826 8.74711 18.5854 8.64989C18.4882 8.55267 18.3726 8.47579 18.2453 8.42372C18.1181 8.37166 17.9817 8.34546 17.8442 8.34666C17.7067 8.34785 17.5709 8.37642 17.4446 8.43068C17.3182 8.48495 17.204 8.56383 17.1085 8.66272L13.6988 12.0724L11.3245 9.69816C11.1304 9.50404 10.867 9.395 10.5925 9.395C10.3179 9.395 10.0546 9.50404 9.86043 9.69816L5.7187 13.8399C5.53009 14.0352 5.42572 14.2967 5.42808 14.5682C5.43044 14.8397 5.53933 15.0994 5.73131 15.2914C5.92329 15.4834 6.18299 15.5922 6.45447 15.5946C6.72596 15.597 6.98751 15.4926 7.1828 15.304L10.5925 11.8943L12.9667 14.2686Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("circle", {
        cx: "18.1896",
        cy: "8.90176",
        r: "1.81042",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("circle", {
        cx: "13.6505",
        cy: "13.2697",
        r: "1.81042",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("circle", {
        cx: "10.5582",
        cy: "10.6119",
        r: "1.81042",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("circle", {
        cx: "5.81042",
        cy: "15.0983",
        r: "1.81042",
        fill: "currentColor"
    }));

});

parcelRegister("5ijLz", function(module, exports) {
$parcel$export(module.exports, "dateGlyph", () => $534175e24258b265$export$54ae6633cc16eed1);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $534175e24258b265$export$54ae6633cc16eed1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.77333 5.77778H18.2267C19.2062 5.77778 20 6.57333 20 7.55022V18.2276C20 18.4604 19.9541 18.6909 19.865 18.906C19.7759 19.1211 19.6452 19.3166 19.4805 19.4812C19.3159 19.6458 19.1204 19.7763 18.9052 19.8653C18.6901 19.9544 18.4595 20.0001 18.2267 20H5.77333C5.30317 20 4.85225 19.8133 4.51971 19.4809C4.18717 19.1485 4.00024 18.6977 4 18.2276V7.55022C4 6.57156 4.79289 5.77778 5.77333 5.77778ZM5.77778 9.33333V17.3333C5.77778 17.5691 5.87143 17.7952 6.03813 17.9619C6.20483 18.1286 6.43092 18.2222 6.66667 18.2222H17.3333C17.5691 18.2222 17.7952 18.1286 17.9619 17.9619C18.1286 17.7952 18.2222 17.5691 18.2222 17.3333V9.33333H5.77778ZM6.66667 4.88889C6.66667 4.65314 6.76032 4.42705 6.92702 4.26035C7.09372 4.09365 7.31981 4 7.55556 4C7.7913 4 8.0174 4.09365 8.18409 4.26035C8.35079 4.42705 8.44444 4.65314 8.44444 4.88889V5.77778H6.66667V4.88889ZM15.5556 4.88889C15.5556 4.65314 15.6492 4.42705 15.8159 4.26035C15.9826 4.09365 16.2087 4 16.4444 4C16.6802 4 16.9063 4.09365 17.073 4.26035C17.2397 4.42705 17.3333 4.65314 17.3333 4.88889V5.77778H15.5556V4.88889ZM7.55556 12.8889V11.1102H9.33333V12.8889H7.55556ZM14.6667 12.8889V11.1102H16.4444V12.8889H14.6667ZM11.1111 12.8889V11.1102H12.8898V12.8889H11.1111ZM7.55556 16.4444V14.6667H9.33333V16.4444H7.55556ZM11.1111 16.4444V14.6667H12.8898V16.4444H11.1111ZM14.6667 16.4444V14.6667H16.4444V16.4444H14.6667Z",
        fill: "currentColor"
    }));

});

parcelRegister("boKQF", function(module, exports) {
$parcel$export(module.exports, "deliveryTicketsGlyph", () => $a14f1769ee095d85$export$6014753f01dee0d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $a14f1769ee095d85$export$6014753f01dee0d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.625 9.401h3.064c.997 0 1.811.803 1.811 1.8-.1.446-.113.504-.148.542l-.017.016-.085.13c-.054.077-.128.18-.223.306l-.4.527-.334.433-.629.807c-.524.67-1.052 1.34-1.581 2.008l-.049.061c-.99 1.25-1.98 2.498-2.973 3.744l-.28.35-.073.083c-.344.344-.679.566-.985.685-.19.074-.37.108-.535.108a1.807 1.807 0 0 1-1.813-1.8v-4.626H6.438l-.168-.014c-.95-.16-1.77-.75-1.77-1.76 0-.526.188-.77 3.375-4.769l.093-.117a667.96 667.96 0 0 1 2.976-3.699l.324-.397.197-.21a1.81 1.81 0 0 1 3.08.665c.053.17.08.348.08.527v4.6Zm-2-4.083v6.083h4.495a400.352 400.352 0 0 1-2.606 3.33l-.048.06-1.602 2.019-1.367 1.717-.122.154v-6.106H6.843c.379-.508 1.023-1.323 2.596-3.296l.046-.059.047-.058c.74-.928 1.484-1.854 2.23-2.778l.863-1.066Z",
        clipRule: "evenodd"
    }));

});

parcelRegister("54kqL", function(module, exports) {
$parcel$export(module.exports, "dropdownGlyph", () => $7a5f1ff7947afeb5$export$d298f123ec74117c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $7a5f1ff7947afeb5$export$d298f123ec74117c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5255 16.5255C15.3253 17.7257 13.6974 18.4 12 18.4C10.3026 18.4 8.67475 17.7257 7.47452 16.5255C6.27428 15.3253 5.6 13.6974 5.6 12C5.6 10.3026 6.27428 8.67475 7.47452 7.47452C8.67475 6.27428 10.3026 5.6 12 5.6C13.6974 5.6 15.3253 6.27428 16.5255 7.47452C17.7257 8.67475 18.4 10.3026 18.4 12C18.4 13.6974 17.7257 15.3253 16.5255 16.5255ZM4 12C4 16.4184 7.5816 20 12 20C16.4184 20 20 16.4184 20 12C20 7.5816 16.4184 4 12 4C7.5816 4 4 7.5816 4 12ZM9.0336 10.6344C8.88415 10.7855 8.80033 10.9895 8.80033 11.202C8.80033 11.4145 8.88415 11.6185 9.0336 11.7696L11.3848 14.1416C11.5592 14.3136 11.7848 14.3992 12.008 14.3992C12.2312 14.3992 12.4528 14.3136 12.6232 14.1416L14.9672 11.7776C15.1165 11.6264 15.2001 11.4225 15.2001 11.21C15.2001 10.9975 15.1165 10.7936 14.9672 10.6424C14.8937 10.5679 14.8062 10.5087 14.7096 10.4683C14.6131 10.4278 14.5095 10.407 14.4048 10.407C14.3001 10.407 14.1965 10.4278 14.1 10.4683C14.0034 10.5087 13.9159 10.5679 13.8424 10.6424L12.004 12.496L10.1584 10.6344C10.0848 10.5602 9.99716 10.5012 9.90064 10.461C9.80411 10.4208 9.70057 10.4001 9.596 10.4001C9.49143 10.4001 9.38789 10.4208 9.29136 10.461C9.19483 10.5012 9.10723 10.5602 9.0336 10.6344Z",
        fill: "currentColor"
    }));

});

parcelRegister("6TqiN", function(module, exports) {
$parcel$export(module.exports, "atlasProjectGlyph", () => $0eed392d0223a480$export$27e1adb59623ce35);
$parcel$export(module.exports, "atlasProjectStatusGlyph", () => $0eed392d0223a480$export$70579ef037a67c66);
$parcel$export(module.exports, "atlasGoalGlyph", () => $0eed392d0223a480$export$a7752c864486c841);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $0eed392d0223a480$export$27e1adb59623ce35 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5 3.00001C13.5 2.72386 13.2761 2.50001 13 2.50001L10.5178 2.5C10.3852 2.5 10.258 2.55268 10.1642 2.64645L7.78033 5.03034C7.63968 5.17099 7.44891 5.25001 7.25 5.25001L3.01777 5.25001C2.88516 5.25001 2.75798 5.30269 2.66421 5.39646L2.31066 5.75001L4.03033 7.46968C4.32322 7.76257 4.32322 8.23745 4.03033 8.53034L1.78033 10.7803L0.719669 9.71968L2.43934 8.00001L0.71967 6.28034C0.426777 5.98745 0.426777 5.51257 0.71967 5.21968L1.60355 4.3358C1.97863 3.96072 2.48733 3.75001 3.01777 3.75001L6.93934 3.75001L9.10355 1.58579C9.47863 1.21071 9.98734 0.999999 10.5178 1L13 1.00001C14.1046 1.00001 15 1.89544 15 3L15 5.48225C15 6.01268 14.7893 6.52139 14.4142 6.89646L12.25 9.06068L12.25 12.9823C12.25 13.5127 12.0393 14.0214 11.6642 14.3965L10.7803 15.2803C10.6397 15.421 10.4489 15.5 10.25 15.5C10.0511 15.5 9.86032 15.421 9.71967 15.2803L8 13.5607L6.28033 15.2803L5.21967 14.2197L7.46967 11.9697C7.61032 11.829 7.80109 11.75 8 11.75C8.19891 11.75 8.38968 11.829 8.53033 11.9697L10.25 13.6894L10.6036 13.3358C10.6973 13.242 10.75 13.1149 10.75 12.9823L10.75 8.75002C10.75 8.5511 10.829 8.36034 10.9697 8.21969L13.3536 5.8358C13.4473 5.74204 13.5 5.61486 13.5 5.48225L13.5 3.00001ZM6.78033 10.2803L1.78033 15.2803L0.71967 14.2197L5.71967 9.21968L6.78033 10.2803Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M12.5 4.62501C12.5 5.24633 11.9963 5.75001 11.375 5.75001C10.7537 5.75001 10.25 5.24633 10.25 4.62501C10.25 4.00369 10.7537 3.50001 11.375 3.50001C11.9963 3.50001 12.5 4.00369 12.5 4.62501Z",
        fill: "currentColor"
    }));
const $0eed392d0223a480$export$70579ef037a67c66 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.5 2.625C3.5 1.17525 4.67525 0 6.125 0H9.875C11.3247 0 12.5 1.17525 12.5 2.625V11.375C12.5 12.8247 11.3247 14 9.875 14H8.75V16H7.25L7.25 14H6.125C4.67525 14 3.5 12.8247 3.5 11.375V2.625ZM6.125 1.5C5.50368 1.5 5 2.00368 5 2.625V11.375C5 11.9963 5.50368 12.5 6.125 12.5H9.875C10.4963 12.5 11 11.9963 11 11.375V2.625C11 2.00368 10.4963 1.5 9.875 1.5H6.125ZM6.5 4.75C6.5 3.92157 7.17157 3.25 8 3.25C8.82843 3.25 9.5 3.92157 9.5 4.75C9.5 5.57843 8.82843 6.25 8 6.25C7.17157 6.25 6.5 5.57843 6.5 4.75ZM6.5 9.25C6.5 8.42157 7.17157 7.75 8 7.75C8.82843 7.75 9.5 8.42157 9.5 9.25C9.5 10.0784 8.82843 10.75 8 10.75C7.17157 10.75 6.5 10.0784 6.5 9.25Z",
        fill: "currentColor"
    }));
const $0eed392d0223a480$export$a7752c864486c841 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5ZM4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8Z",
        fill: "currentColor"
    }));

});

parcelRegister("l7nyX", function(module, exports) {
$parcel$export(module.exports, "formulaGlyph", () => $90b25b2074e5b5de$export$2bd8d6a12707bbca);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $90b25b2074e5b5de$export$2bd8d6a12707bbca = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.2579 6.55387C9.45642 6.55387 9.0148 6.93008 8.85123 7.79697L8.77041 8.24723C8.75286 8.34502 8.82803 8.43488 8.92738 8.43488H10.1646C10.4612 8.43488 10.6864 8.70197 10.6362 8.99428L10.5224 9.65672C10.483 9.88635 10.2839 10.0542 10.0509 10.0542H8.59248C8.51509 10.0542 8.44887 10.1097 8.43543 10.186L6.7946 19.4891C6.75427 19.7178 6.55561 19.8845 6.32344 19.8845H5.47856C5.1814 19.8845 4.95613 19.6164 5.00727 19.3237L6.59408 10.2411C6.61113 10.1435 6.53603 10.0542 6.43698 10.0542H6.01665C5.72006 10.0542 5.49493 9.78709 5.54512 9.49478L5.65887 8.83234C5.6983 8.60271 5.89741 8.43488 6.1304 8.43488H6.78653C6.86428 8.43488 6.9307 8.37881 6.94374 8.30216L7.05201 7.66612C7.33007 6.07953 8.19697 5 10.1925 5C10.485 5 10.7247 5.01922 10.9272 5.04724C11.1781 5.08196 11.3363 5.32569 11.2929 5.57523L11.1937 6.1456C11.1471 6.41311 10.8868 6.58865 10.6161 6.56779C10.4999 6.55883 10.3789 6.55387 10.2579 6.55387ZM17.7688 15.9934C17.9369 16.312 17.7058 16.6949 17.3456 16.6949H16.7477C16.3184 16.6949 15.927 16.4487 15.7413 16.0615L14.5998 13.6824C14.5493 13.5771 14.4065 13.56 14.3326 13.6504L12.1765 16.2855C11.9645 16.5447 11.6474 16.6949 11.3125 16.6949H10.743C10.331 16.6949 10.1117 16.2088 10.3844 15.8999L13.3048 12.5918C13.3493 12.5413 13.3574 12.4683 13.325 12.4094L11.5283 9.14394C11.3529 8.82509 11.5836 8.43488 11.9475 8.43488H12.5256C12.9484 8.43488 13.3349 8.67378 13.524 9.05197L14.6932 11.3902C14.7446 11.493 14.8845 11.5093 14.9582 11.4211L17.1172 8.83569C17.3293 8.58169 17.6431 8.43488 17.974 8.43488H18.5206C18.9348 8.43488 19.1533 8.92538 18.8763 9.23328L16.0051 12.425C15.9604 12.4747 15.9514 12.5469 15.9826 12.606L17.7688 15.9934Z",
        fill: "currentColor"
    }));

});

parcelRegister("iIFXS", function(module, exports) {
$parcel$export(module.exports, "hiddenGlyph", () => $eda2a8a764d9f787$export$a20e687678823cec);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $eda2a8a764d9f787$export$a20e687678823cec = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.2071 3.61907C21.5976 4.00959 21.5976 4.64275 21.2071 5.03328L4.70711 21.5333C4.31658 21.9238 3.68342 21.9238 3.29289 21.5333C2.90237 21.1428 2.90237 20.5096 3.29289 20.1191L19.7929 3.61907C20.1834 3.22854 20.8166 3.22854 21.2071 3.61907Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.1619 5.25008C14.8945 4.67646 13.4849 4.32617 12 4.32617H12.001C6.48 4.32617 2 9.16717 2 12.3262C2 13.7123 2.92324 15.4673 4.43188 16.9801L5.85543 15.5565C4.68982 14.3795 4.001 13.1022 4.001 12.3262C4.001 10.3252 7.46 6.32617 12.001 6.32617C12.9154 6.32617 13.7969 6.49966 14.6193 6.79262L16.1619 5.25008ZM16.5131 7.72727L17.9659 6.27452C18.1973 6.43493 18.4211 6.60231 18.6365 6.77548L17.2019 8.21008C16.9822 8.04196 16.7522 7.88033 16.5131 7.72727ZM12.9757 8.43624C12.6564 8.35395 12.3218 8.31017 11.977 8.31017C9.771 8.31017 7.977 10.1042 7.977 12.3102C7.977 12.6549 8.0208 12.9895 8.10313 13.3088L12.9757 8.43624ZM7.4026 16.8378L5.96313 18.2773C6.19088 18.4398 6.42608 18.5957 6.66807 18.7439L8.12972 17.2822C7.87835 17.1436 7.63571 16.9947 7.4026 16.8378ZM9.76817 15.6438C9.53617 15.4896 9.32112 15.3118 9.12645 15.1139L10.5402 13.7002C10.7364 13.903 10.9751 14.0645 11.2417 14.1702L9.76817 15.6438ZM10.1498 18.0906L8.56336 19.677C9.64041 20.0854 10.7994 20.3262 12 20.3262C17.423 20.3262 22 15.4122 22 12.3262C22 11.0666 21.2878 9.53974 20.0815 8.15889L18.6599 9.58049C19.5044 10.5623 19.999 11.5771 19.999 12.3262C19.999 14.0662 16.537 18.3262 12.001 18.3262H12C11.3597 18.3262 10.7407 18.2413 10.1498 18.0906ZM15.9767 12.2637C15.9769 12.2791 15.977 12.2946 15.977 12.3102C15.977 14.5162 14.184 16.3102 11.977 16.3102C11.9615 16.3102 11.946 16.3101 11.9305 16.3099L15.9767 12.2637ZM15.3108 10.1012C15.1566 9.86917 14.9788 9.65411 14.7809 9.45944L13.3672 10.8732C13.57 11.0694 13.7315 11.3081 13.8371 11.5748L15.3108 10.1012Z",
        fill: "currentColor"
    }));

});

parcelRegister("jKsOD", function(module, exports) {
$parcel$export(module.exports, "InsightsCustomIcon", () => $461671a039cf959a$export$7ee04b8a5a2bfe07);
$parcel$export(module.exports, "insightsGlyph", () => $461671a039cf959a$export$a50b34c2fa26415e);
/* insightsGlyph.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $461671a039cf959a$var$svgStyles = null;
const $461671a039cf959a$export$7ee04b8a5a2bfe07 = ({ label: label, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, testId: testId, className: className })=>/*#__PURE__*/ $euxye.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 16 11",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $4jQY2.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw _s7n4nkob",
            className
        ])
    }, /*#__PURE__*/ $euxye.createElement("path", {
        d: "M16 2.58776C16 3.58763 15.1894 4.39818 14.1896 4.39818C14.1246 4.39818 14.0605 4.39476 13.9973 4.38809L11.4607 6.92467L11.461 6.95571C11.461 7.95558 10.6504 8.76613 9.65057 8.76613C8.6507 8.76613 7.84015 7.95558 7.84015 6.95571C7.84015 6.91418 7.84155 6.87297 7.8443 6.83213L7.05226 6.04009C6.89521 6.08454 6.72949 6.10832 6.55822 6.10832C6.40649 6.10832 6.25913 6.08966 6.11829 6.0545L3.6077 8.56509C3.61637 8.63694 3.62083 8.71008 3.62083 8.78426C3.62083 9.78413 2.81028 10.5947 1.81042 10.5947C0.810551 10.5947 0 9.78413 0 8.78426C0 7.7844 0.810551 6.97385 1.81042 6.97385C1.9525 6.97385 2.09076 6.99021 2.22342 7.02117L4.75756 4.48703C4.75111 4.42487 4.7478 4.36177 4.7478 4.2979C4.7478 3.29804 5.55835 2.48749 6.55822 2.48749C7.55808 2.48749 8.36864 3.29804 8.36864 4.2979C8.36864 4.34027 8.36718 4.3823 8.36432 4.42395L9.15447 5.21411C9.31213 5.16929 9.47854 5.14529 9.65057 5.14529C9.84965 5.14529 10.0412 5.17743 10.2204 5.23679L12.4323 3.0249C12.3976 2.88491 12.3792 2.73849 12.3792 2.58776C12.3792 1.58789 13.1897 0.777344 14.1896 0.777344C15.1894 0.777344 16 1.58789 16 2.58776Z",
        fill: "currentColor"
    }));
$461671a039cf959a$export$7ee04b8a5a2bfe07.displayName = "InsightsCustomIcon";
const $461671a039cf959a$export$a50b34c2fa26415e = (props)=>/*#__PURE__*/ $euxye.createElement("svg", {
        ...props,
        width: "11",
        height: "11",
        viewBox: "0 0 16 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $euxye.createElement("path", {
        d: "M16 2.58776C16 3.58763 15.1894 4.39818 14.1896 4.39818C14.1246 4.39818 14.0605 4.39476 13.9973 4.38809L11.4607 6.92467L11.461 6.95571C11.461 7.95558 10.6504 8.76613 9.65057 8.76613C8.6507 8.76613 7.84015 7.95558 7.84015 6.95571C7.84015 6.91418 7.84155 6.87297 7.8443 6.83213L7.05226 6.04009C6.89521 6.08454 6.72949 6.10832 6.55822 6.10832C6.40649 6.10832 6.25913 6.08966 6.11829 6.0545L3.6077 8.56509C3.61637 8.63694 3.62083 8.71008 3.62083 8.78426C3.62083 9.78413 2.81028 10.5947 1.81042 10.5947C0.810551 10.5947 0 9.78413 0 8.78426C0 7.7844 0.810551 6.97385 1.81042 6.97385C1.9525 6.97385 2.09076 6.99021 2.22342 7.02117L4.75756 4.48703C4.75111 4.42487 4.7478 4.36177 4.7478 4.2979C4.7478 3.29804 5.55835 2.48749 6.55822 2.48749C7.55808 2.48749 8.36864 3.29804 8.36864 4.2979C8.36864 4.34027 8.36718 4.3823 8.36432 4.42395L9.15447 5.21411C9.31213 5.16929 9.47854 5.14529 9.65057 5.14529C9.84965 5.14529 10.0412 5.17743 10.2204 5.23679L12.4323 3.0249C12.3976 2.88491 12.3792 2.73849 12.3792 2.58776C12.3792 1.58789 13.1897 0.777344 14.1896 0.777344C15.1894 0.777344 16 1.58789 16 2.58776Z",
        fill: "currentColor"
    }));

});

parcelRegister("5uQUk", function(module, exports) {
$parcel$export(module.exports, "issueTypeGlyph", () => $19a0017588ff7929$export$4addf6feba40bda0);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $19a0017588ff7929$export$4addf6feba40bda0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 2.25C4.42893 2.25 2.75 3.92893 2.75 6C2.75 7.81422 4.03832 9.32753 5.75 9.67499V7.25C5.75 6.14543 6.64543 5.25 7.75 5.25H10.175C9.82753 3.53832 8.31422 2.25 6.5 2.25ZM11.6968 5.25C11.3329 2.70578 9.14485 0.75 6.5 0.75C3.6005 0.75 1.25 3.1005 1.25 6C1.25 8.64485 3.20578 10.8329 5.75 11.1968V13C5.75 14.1046 6.64543 15 7.75 15H13.5C14.6046 15 15.5 14.1046 15.5 13V7.25C15.5 6.14543 14.6046 5.25 13.5 5.25H11.6968ZM7.75 6.75C7.47386 6.75 7.25 6.97386 7.25 7.25V13C7.25 13.2761 7.47386 13.5 7.75 13.5H13.5C13.7761 13.5 14 13.2761 14 13V7.25C14 6.97386 13.7761 6.75 13.5 6.75H7.75Z",
        fill: "currentColor"
    }));

});

parcelRegister("5FGI7", function(module, exports) {
$parcel$export(module.exports, "keyGlyph", () => $aa11923a05ea1379$export$161505f4144f811b);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $aa11923a05ea1379$export$161505f4144f811b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M5.22889 14.8718V13.0773L5.81078 12.3774L7.51577 14.8718H8.98881L6.69786 11.5717L8.83825 9H7.47101L5.30214 11.6368H5.22889V9H4V14.8718H5.22889Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M13.8067 13.8586H11.1455V12.3733H13.6562V11.4293H11.1455V10.0132H13.8067V9H9.91658V14.8718H13.8067V13.8586Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M17.9573 14.8718V12.6785L20 9H18.6694L17.3795 11.47H17.3062L16.0122 9H14.6816L16.7284 12.6785V14.8718H17.9573Z",
        fill: "currentColor"
    }));

});

parcelRegister("hrZFC", function(module, exports) {
$parcel$export(module.exports, "labelGlyph", () => $822880205cea4e3d$export$fc64eea29ed0831d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $822880205cea4e3d$export$fc64eea29ed0831d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M10.6445 10.6463C10.4961 10.7972 10.3193 10.9172 10.1243 10.9994C9.92932 11.0816 9.71997 11.1243 9.50835 11.1252C9.29673 11.1261 9.08703 11.085 8.89135 11.0045C8.69568 10.9239 8.51789 10.8053 8.36825 10.6557C8.21861 10.5061 8.10009 10.3283 8.0195 10.1326C7.93892 9.93693 7.89788 9.72723 7.89875 9.51561C7.89963 9.30399 7.94239 9.09464 8.02458 8.89963C8.10677 8.70462 8.22675 8.52782 8.37762 8.37942C8.67836 8.07868 9.08625 7.90972 9.51156 7.90972C9.93687 7.90972 10.3448 8.07868 10.6455 8.37942C10.9462 8.68016 11.1152 9.08805 11.1152 9.51336C11.1152 9.93867 10.9462 10.3466 10.6455 10.6473M11.2671 5.01079L7.21914 5.5881C6.80686 5.64729 6.42491 5.83864 6.13065 6.13342C5.8364 6.42819 5.64572 6.81048 5.58727 7.22287L5.00995 11.2708C4.98853 11.4186 5.00181 11.5694 5.04873 11.7112C5.09566 11.8529 5.17495 11.9819 5.28033 12.0877L11.9146 18.721C12.0039 18.8105 12.11 18.8814 12.2267 18.9298C12.3434 18.9782 12.4685 19.0032 12.5949 19.0032C12.7213 19.0032 12.8464 18.9782 12.9631 18.9298C13.0799 18.8814 13.1859 18.8105 13.2752 18.721L18.7183 13.2779C18.8987 13.0975 19 12.8528 19 12.5977C19 12.3425 18.8987 12.0978 18.7183 11.9174L12.084 5.28213C11.9784 5.17628 11.8496 5.09655 11.7078 5.04928C11.5659 5.002 11.415 4.9885 11.2671 5.00983V5.01079Z",
        stroke: "currentColor",
        strokeWidth: "1.5"
    }));

});

parcelRegister("hpjqQ", function(module, exports) {
$parcel$export(module.exports, "likeIconFilledGlyph", () => $9c1035adc84cf2f3$export$d579242b773658ff);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $9c1035adc84cf2f3$export$d579242b773658ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        id: "like-filled-a",
        d: "M4.00029867,12.0000031 L4.00029867,19.0000031 C3.99379083,19.2619469 4.0938648,19.5154845 4.27800285,19.7035645 C4.46214091,19.8916445 4.71487577,19.9984685 4.97933941,20.0000031 L5.99875297,20.0000031 L5.99875297,11.0000031 L4.97933941,11.0000031 C4.71487577,11.0015345 4.46214091,11.1083586 4.27800285,11.2964386 C4.0938648,11.4845186 3.99379083,11.7380562 4.00029867,12.0000031 Z M19.2814088,11.0400031 C18.7031035,10.3648275 17.8537454,9.97663317 16.959972,9.97900342 L14.3256459,9.97900342 C14.3660187,9.79800348 14.4063915,9.61900354 14.4366711,9.4470036 C14.9514245,6.5130046 14.4366711,5.44700497 13.9320109,4.85300517 C13.4705845,4.31076256 12.7907146,3.99849428 12.0748615,4 C10.5305357,4.05274499 9.2630356,5.22781051 9.10745966,6.75100452 C8.71382472,8.59000389 8.6532655,8.75100384 8.13851212,9.47600359 L7.37142865,10.5650032 C7.13702441,10.900368 7.01037109,11.2980817 7.00807332,11.7060028 L7.00807332,17.9790007 C7.0094101,18.5107601 7.22390249,19.0202137 7.60436426,19.3952867 C7.98482603,19.7703597 8.50009148,19.9803277 9.03680723,19.9790426 L16.2837274,19.9790426 C17.7690249,19.9867984 19.0398298,18.9240081 19.2814088,17.4720009 L19.9576535,13.4720022 C20.1064636,12.6021375 19.8588502,11.7116379 19.2814088,11.0400031 Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("use", {
        fill: "currentColor",
        xlinkHref: "#like-filled-a"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "inherit",
        d: "M17.2829545,17.140001 C17.2013522,17.6232979 16.7783039,17.9768163 16.2837274,17.9750077 L9.03680723,17.9750077 L9.03680723,11.7060028 L9.8038907,10.6170032 C10.5252697,9.572607 10.9727451,8.36664508 11.105914,7.1080044 C11.1422788,6.56547046 11.3606605,5.89943888 12.0748615,6.00000478 C12.7890625,6.10057068 12.6501741,7.91600412 12.4382168,9.10000372 C12.2228565,10.0810361 11.9326853,11.0444672 11.5702013,11.9820027 L16.959972,11.9740027 C17.2574249,11.9729101 17.5402185,12.1018688 17.7328364,12.3264423 C17.9254544,12.5510157 18.0082813,12.848334 17.9591992,13.1390023 L17.2829545,17.140001 Z"
    })));

});

parcelRegister("e8KKk", function(module, exports) {
$parcel$export(module.exports, "linkGlyph", () => $b5c2ac4b41f48ea5$export$a5fad9a16577917b);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $b5c2ac4b41f48ea5$export$a5fad9a16577917b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M12.856 5.457l-.937.92a1.002 1.002 0 000 1.437 1.047 1.047 0 001.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 01.203 3.81l-2.903 2.852a2.646 2.646 0 01-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 00-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M11.144 19.543l.937-.92a1.002 1.002 0 000-1.437 1.047 1.047 0 00-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 01-.203-3.81l2.903-2.852a2.646 2.646 0 013.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 00.357 6.82c1.893 1.517 4.695 1.226 6.422-.47"
    })));

});

parcelRegister("eQ4Ca", function(module, exports) {
$parcel$export(module.exports, "matrixGlyph", () => $3215b2024cc812a7$export$1f216f54d87dd5ab);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $3215b2024cc812a7$export$1f216f54d87dd5ab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.995 18H19C19.2652 18 19.5196 18.1054 19.7071 18.2929C19.8946 18.4804 20 18.7348 20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H6.995C6.19899 19.9976 5.43646 19.6794 4.8749 19.1152C4.31335 18.551 3.99868 17.787 4 16.991V5C4 4.73478 4.10536 4.48043 4.2929 4.29289C4.48043 4.10536 4.73479 4 5 4C5.26522 4 5.51957 4.10536 5.70711 4.29289C5.89465 4.48043 6 4.73478 6 5V16.991C6 17.548 6.448 18 6.995 18ZM8 8C8 6.89543 8.89543 6 10 6C11.1046 6 12 6.89543 12 8C12 9.10457 11.1046 10 10 10C8.89543 10 8 9.10457 8 8ZM17 10C16.4477 10 16 10.4477 16 11C16 11.5523 16.4477 12 17 12C17.5523 12 18 11.5523 18 11C18 10.4477 17.5523 10 17 10ZM12.5 13C11.6716 13 11 13.6716 11 14.5C11 15.3284 11.6716 16 12.5 16C13.3284 16 14 15.3284 14 14.5C14 13.6716 13.3284 13 12.5 13Z",
        fill: "currentColor"
    }));

});

parcelRegister("ahyWn", function(module, exports) {
$parcel$export(module.exports, "mergeIdeasGlyph", () => $14f08d005c00cdfc$export$33c5f1d07135f3ff);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $14f08d005c00cdfc$export$33c5f1d07135f3ff = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "currentColor",
        d: "M16.59 13.943a.957.957 0 1 0 1.346 1.357l2.832-2.808a1.053 1.053 0 0 0 .01-1.486l-2.843-2.82a.958.958 0 0 0-1.35 1.361l2.22 2.2-2.215 2.196Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "currentColor",
        d: "M4.706 5.295a.998.998 0 0 0-1.415-.001c-.39.39-.387 1.028.004 1.419l5.233 5.232c.393.394 1.158.713 1.71.713H20.26v-2H10.07L4.706 5.295Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "currentColor",
        d: "M4.706 5.295a.998.998 0 0 0-1.415-.001c-.39.39-.387 1.028.004 1.419l5.233 5.232c.393.394 1.158.713 1.71.713H20.26v-2H10.07L4.706 5.295Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "currentColor",
        d: "M4.706 5.295a.998.998 0 0 0-1.415-.001c-.39.39-.387 1.028.004 1.419l5.233 5.232c.393.394 1.158.713 1.71.713H20.26v-2H10.07L4.706 5.295Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m7.083 13-3.788 3.787a1.006 1.006 0 0 0 .32 1.637.997.997 0 0 0 1.091-.22l4.1-4.1c-.47-.106-.98-.36-1.278-.659L7.083 13Zm12.178-.158v-.684H9.07l-.572-.572.031-.031c.393-.394 1.158-.713 1.71-.713H20.26v2h-1Z",
        clipRule: "evenodd"
    }));

});

parcelRegister("f183I", function(module, exports) {
$parcel$export(module.exports, "numberGlyph", () => $073cf07dfee9ece5$export$b368272069fe93ea);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $073cf07dfee9ece5$export$b368272069fe93ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M17.4413 8C16.3689 8 15.5302 8.54147 15.1904 9.29529L16.3477 9.91108C16.5601 9.53948 16.8786 9.30591 17.4094 9.30591C17.9509 9.30591 18.3756 9.65627 18.3756 10.1871C18.3756 10.6649 18.0783 11.0471 17.4307 11.0471H16.783V12.2256H17.3139C18.1102 12.2256 18.5136 12.6715 18.5136 13.1918C18.5136 13.8076 18.0146 14.1685 17.4307 14.1685C16.7724 14.1685 16.3689 13.8607 16.1778 13.3404L14.925 13.8607C15.2754 14.7843 16.2415 15.4638 17.5368 15.4638C18.9489 15.4638 20 14.6569 20 13.3935C20 12.5441 19.5435 11.939 18.8427 11.6098V11.5886C19.4267 11.2488 19.7877 10.6543 19.7877 9.95355C19.7877 8.70073 18.7366 8 17.4413 8ZM7.36563 8.08494H6.20836L4 9.66689L4.69011 10.7392L5.91108 9.82614V15.3789H7.36563V8.08494ZM11.4214 8C10.2004 8 9.42535 8.60518 9.00066 9.38023L10.0411 10.1234C10.3597 9.59257 10.795 9.33776 11.3046 9.33776C11.8779 9.33776 12.2814 9.76244 12.2814 10.3251C12.2814 10.9091 11.8885 11.4081 11.3046 12.0345L9.03251 14.434L9.05375 15.3789H13.8102V14.0624H11.1453V14.0411L12.5255 12.6184C13.4705 11.6417 13.7359 10.994 13.7359 10.1659C13.7359 8.8069 12.6317 8 11.4214 8Z",
        fill: "currentColor"
    }));

});

parcelRegister("hWWad", function(module, exports) {
$parcel$export(module.exports, "peopleGlyph", () => $5d6d660f6e1aaf3d$export$2ade78849d2113ea);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $5d6d660f6e1aaf3d$export$2ade78849d2113ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.062 13.93C11.158 13.93 10.611 13.196 10.611 11.985C10.611 10.759 11.149 10.033 12.077 10.033C13.005 10.033 13.499 10.797 13.499 12C13.499 13.195 12.997 13.93 12.061 13.93H12.062ZM12 5C8.075 5 5 8.075 5 12C5 16.596 8.522 19 12 19C12.874 19 13.614 18.91 14.26 18.721C14.4417 18.6576 14.5922 18.5269 14.6804 18.3558C14.7686 18.1848 14.7877 17.9863 14.7338 17.8016C14.6799 17.6168 14.5571 17.4598 14.3908 17.3629C14.2245 17.266 14.0273 17.2367 13.84 17.281C13.332 17.428 12.73 17.501 12 17.501C9.352 17.501 6.5 15.779 6.5 12.001C6.5 8.916 8.917 6.501 12 6.501C15.24 6.501 17.5 8.453 17.5 11.251C17.5 13.296 16.457 14.251 15.752 14.251C15.744 14.251 15 14.141 15 13.501V9.501C15 9.30209 14.921 9.11132 14.7803 8.97067C14.6397 8.83002 14.4489 8.751 14.25 8.751C14.0511 8.751 13.8603 8.83002 13.7197 8.97067C13.579 9.11132 13.5 9.30209 13.5 9.501V9.688C13.154 9.103 12.484 8.736 11.705 8.736C10.102 8.736 9 10.04 9 11.938C9 13.922 10.103 15.25 11.753 15.25C12.618 15.25 13.263 14.863 13.618 14.174C13.952 15.19 14.988 15.75 15.75 15.75C17.348 15.75 19 14.067 19 11.25C19 7.628 16.058 5 12 5Z",
        fill: "currentColor"
    }));

});

parcelRegister("hI6kF", function(module, exports) {
$parcel$export(module.exports, "pollGlyph", () => $8331c1d1a327d7b6$export$7613d8d3644b528c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $8331c1d1a327d7b6$export$7613d8d3644b528c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: "0.33728",
        y: "0.349976",
        width: "13.2684",
        height: "13.3",
        rx: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.32363 5.18502L3.88859 7.64752C3.73328 7.80493 3.64618 8.01738 3.64618 8.23877C3.64618 8.46015 3.73328 8.67261 3.88859 8.83002C3.96486 8.90765 4.05577 8.96929 4.15604 9.01137C4.2563 9.05345 4.36392 9.07512 4.47261 9.07512C4.58131 9.07512 4.68892 9.05345 4.78919 9.01137C4.88945 8.96929 4.98037 8.90765 5.05664 8.83002L6.9671 6.89919L8.88503 8.83835C8.96151 8.91593 9.05258 8.97752 9.15298 9.01956C9.25337 9.0616 9.36109 9.08324 9.46989 9.08324C9.5787 9.08324 9.68642 9.0616 9.78681 9.01956C9.88721 8.97752 9.97828 8.91593 10.0548 8.83835C10.2099 8.68084 10.2968 8.46842 10.2968 8.2471C10.2968 8.02578 10.2099 7.81337 10.0548 7.65585L7.61057 5.18502C7.4387 5.01359 7.20623 4.91715 6.96377 4.91669C6.73182 4.91669 6.50071 5.00585 6.32363 5.18502Z",
        fill: "white"
    }));

});

parcelRegister("5lJpZ", function(module, exports) {
$parcel$export(module.exports, "projectGlyph", () => $8d099943f4a7c1cf$export$186325d5cb98f5a8);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $8d099943f4a7c1cf$export$186325d5cb98f5a8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        clipPath: "url(#clip0_2381_27797)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M14.3492 1.9234C14.3492 1.77165 14.226 1.64863 14.0741 1.64863H10.9613C10.8884 1.64863 10.8184 1.67758 10.7668 1.72911L7.54583 4.94589L2.99068 4.9459C2.91771 4.94589 2.84773 4.97484 2.79613 5.02637L2.33456 5.48735L3.69638 6.8474C4.2336 7.38393 4.2336 8.25381 3.69638 8.79033L1.16728 11.3161L0 10.1504L2.33456 7.81887L0.972732 6.45882C0.435507 5.92229 0.435507 5.05241 0.972732 4.51588L1.62886 3.86062C1.99003 3.49991 2.4799 3.29726 2.99068 3.29726L6.86205 3.29726L9.59952 0.563352C9.9607 0.202644 10.4506 0 10.9613 0H14.0741C15.1377 -5.24086e-07 16 0.861136 16 1.9234L16 5.03209C16 5.54221 15.7971 6.03144 15.4359 6.39214L12.6822 9.14223V13.0086C12.6822 13.5187 12.4793 14.0079 12.1182 14.3686L11.4782 15.0077C10.941 15.5442 10.07 15.5442 9.53277 15.0077L8.17094 13.6477L5.81554 16L4.64826 14.8342L7.19821 12.2876C7.73544 11.7511 8.60645 11.7511 9.14367 12.2876L10.5055 13.6477L10.9509 13.2029C11.0025 13.1513 11.0315 13.0814 11.0315 13.0086V8.45935L14.2686 5.22639C14.3202 5.17486 14.3492 5.10497 14.3492 5.03209V1.9234Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M12.84 4.71017C12.4103 5.13939 11.7134 5.13939 11.2837 4.71017C10.8539 4.28095 10.8539 3.58505 11.2837 3.15583C11.7134 2.72661 12.4103 2.72661 12.84 3.15583C13.2698 3.58505 13.2698 4.28095 12.84 4.71017Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M5.83642 8.98468L0.267066 14.5468L1.43434 15.7125L7.0037 10.1504L5.83642 8.98468Z",
        fill: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("clipPath", {
        id: "clip0_2381_27797"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
    }))));

});

parcelRegister("9NvBE", function(module, exports) {
$parcel$export(module.exports, "ratingGlyph", () => $1684b3d884c99773$export$2d7108f282e9f737);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $1684b3d884c99773$export$2d7108f282e9f737 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.25 6C18.2165 6 19 6.7835 19 7.75V16.5C19 17.4665 18.2165 18.25 17.25 18.25C16.2835 18.25 15.5 17.4665 15.5 16.5V7.75C15.5 6.7835 16.2835 6 17.25 6ZM13.75 11.25C13.75 10.2835 12.9665 9.5 12 9.5C11.0335 9.5 10.25 10.2835 10.25 11.25V16.5C10.25 17.4665 11.0335 18.25 12 18.25C12.9665 18.25 13.75 17.4665 13.75 16.5V11.25ZM8.5 14.75C8.5 13.7835 7.7165 13 6.75 13C5.7835 13 5 13.7835 5 14.75V16.5C5 17.4665 5.7835 18.25 6.75 18.25C7.7165 18.25 8.5 17.4665 8.5 16.5V14.75Z",
        fill: "currentColor"
    }));

});

parcelRegister("e2Gzd", function(module, exports) {
$parcel$export(module.exports, "reactionGlyph", () => $4c98d70a1f2b3850$export$f81959c0291a3036);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $4c98d70a1f2b3850$export$f81959c0291a3036 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "3 3 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 10.8181 3.23279 9.64778 3.68508 8.55585C4.13738 7.46392 4.80031 6.47177 5.63604 5.63604C6.47177 4.80031 7.46392 4.13738 8.55585 3.68508C9.64778 3.23279 10.8181 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21ZM12 19C12.9193 19 13.8295 18.8189 14.6788 18.4672C15.5281 18.1154 16.2997 17.5998 16.9497 16.9497C17.5998 16.2997 18.1154 15.5281 18.4672 14.6788C18.8189 13.8295 19 12.9193 19 12C19 11.0807 18.8189 10.1705 18.4672 9.32122C18.1154 8.47194 17.5998 7.70026 16.9497 7.05025C16.2997 6.40024 15.5281 5.88463 14.6788 5.53284C13.8295 5.18106 12.9193 5 12 5C10.1435 5 8.36301 5.7375 7.05025 7.05025C5.7375 8.36301 5 10.1435 5 12C5 13.8565 5.7375 15.637 7.05025 16.9497C8.36301 18.2625 10.1435 19 12 19V19ZM8.05 14.197C7.883 13.72 8.152 13.206 8.651 13.047C9.151 12.888 9.69 13.146 9.856 13.622C9.916 13.796 10.081 14.109 10.351 14.418C10.777 14.906 11.307 15.182 12 15.182C12.693 15.182 13.223 14.906 13.65 14.418C13.92 14.108 14.083 13.796 14.144 13.622C14.31 13.146 14.85 12.888 15.349 13.047C15.848 13.206 16.117 13.72 15.951 14.197C15.7598 14.7068 15.4753 15.1765 15.112 15.582C14.348 16.458 13.306 17 12 17C10.694 17 9.652 16.458 8.888 15.582C8.52472 15.1765 8.2402 14.7068 8.049 14.197H8.05ZM9.5 11C9.10218 11 8.72064 10.842 8.43934 10.5607C8.15804 10.2794 8 9.89782 8 9.5C8 9.10218 8.15804 8.72064 8.43934 8.43934C8.72064 8.15804 9.10218 8 9.5 8C9.89782 8 10.2794 8.15804 10.5607 8.43934C10.842 8.72064 11 9.10218 11 9.5C11 9.89782 10.842 10.2794 10.5607 10.5607C10.2794 10.842 9.89782 11 9.5 11ZM14.5 11C14.1022 11 13.7206 10.842 13.4393 10.5607C13.158 10.2794 13 9.89782 13 9.5C13 9.10218 13.158 8.72064 13.4393 8.43934C13.7206 8.15804 14.1022 8 14.5 8C14.8978 8 15.2794 8.15804 15.5607 8.43934C15.842 8.72064 16 9.10218 16 9.5C16 9.89782 15.842 10.2794 15.5607 10.5607C15.2794 10.842 14.8978 11 14.5 11Z",
        fill: "currentColor"
    }));

});

parcelRegister("hREeQ", function(module, exports) {
$parcel$export(module.exports, "setUpXAxisGlyph", () => $6cdeb382202ec594$export$ec8d9455a0407f05);
$parcel$export(module.exports, "setUpYAxisGlyph", () => $6cdeb382202ec594$export$a18db6c135f629d9);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $6cdeb382202ec594$export$ec8d9455a0407f05 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M3.392 1.607a1 1 0 0 1 2 0v10a1 1 0 1 1-2 0v-10Z",
        fill: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M3.685.858a1 1 0 1 1 1.414 1.414L2.271 5.1A1 1 0 1 1 .856 3.686L3.685.858Z",
        fill: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M3.685 2.272A1 1 0 1 1 5.099.858l2.829 2.828A1 1 0 0 1 6.513 5.1L3.685 2.272Z",
        fill: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M14.393 10.607a1 1 0 1 1 0 2h-10a1 1 0 1 1 0-2h10Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M15.142 10.9a1 1 0 1 1-1.415 1.414L10.9 9.486a1 1 0 0 1 1.414-1.415l2.829 2.829Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M13.727 10.9a1 1 0 1 1 1.415 1.414l-2.829 2.829a1 1 0 0 1-1.414-1.415l2.829-2.828Z",
        fill: "currentColor"
    }));
const $6cdeb382202ec594$export$a18db6c135f629d9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M14.393 10.607a1 1 0 1 1 0 2h-10a1 1 0 1 1 0-2h10Z",
        fill: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M15.142 10.9a1 1 0 0 1-1.414 1.414l-2.829-2.829a1 1 0 1 1 1.415-1.414l2.828 2.828Z",
        fill: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M13.728 10.9a1 1 0 1 1 1.414 1.414l-2.828 2.828a1 1 0 0 1-1.415-1.414l2.829-2.829Z",
        fill: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M3.392 1.607a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0v-10Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M3.685.858a1 1 0 1 1 1.414 1.414L2.271 5.1A1 1 0 1 1 .856 3.686L3.685.858Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M3.685 2.272A1 1 0 1 1 5.099.858l2.829 2.828A1 1 0 0 1 6.513 5.1L3.685 2.272Z",
        fill: "currentColor"
    }));

});

parcelRegister("5khM6", function(module, exports) {
$parcel$export(module.exports, "shortTextGlyph", () => $7bdf19d60bd1c45c$export$1c6cf19eb34bcc14);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $7bdf19d60bd1c45c$export$1c6cf19eb34bcc14 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.90017 6.94518L4.02337 15.4183C4.0008 15.4851 3.99446 15.5563 4.00486 15.626C4.01526 15.6958 4.04211 15.762 4.08318 15.8193C4.12425 15.8766 4.17837 15.9234 4.24106 15.9556C4.30376 15.9879 4.37323 16.0048 4.44373 16.0049H5.3609C5.50353 16.0049 5.6424 15.9591 5.7571 15.8743C5.8718 15.7895 5.95628 15.6702 5.99812 15.5338L6.57401 13.6613H9.89518L10.4702 15.5338C10.512 15.6702 10.5965 15.7895 10.7112 15.8743C10.8259 15.9591 10.9648 16.0049 11.1074 16.0049H12.0966C12.1671 16.0048 12.2365 15.9879 12.2992 15.9556C12.3619 15.9234 12.416 15.8766 12.4571 15.8193C12.4982 15.762 12.525 15.6958 12.5354 15.626C12.5458 15.5563 12.5395 15.4851 12.5169 15.4183L9.63478 6.94429C9.57486 6.7687 9.46148 6.61627 9.31055 6.50837C9.15961 6.40047 8.9787 6.34251 8.79316 6.34262H7.7418C7.55615 6.34257 7.37516 6.40066 7.22421 6.50873C7.07326 6.6168 6.95995 6.76942 6.90017 6.94518ZM8.21193 8.19117H8.25726L9.46948 12.1487H6.99971L8.21193 8.19117ZM18.0883 10.0068V9.71623C18.0883 9.48052 18.182 9.25447 18.3487 9.0878C18.5153 8.92113 18.7414 8.8275 18.9771 8.8275H19.1113C19.347 8.8275 19.573 8.92113 19.7397 9.0878C19.9064 9.25447 20 9.48052 20 9.71623V15.1179C20 15.3536 19.9064 15.5797 19.7397 15.7463C19.573 15.913 19.347 16.0066 19.1113 16.0066H18.9771C18.7414 16.0066 18.5153 15.913 18.3487 15.7463C18.182 15.5797 18.0883 15.3536 18.0883 15.1179V14.8406H18.0101C17.6618 15.6174 16.9152 16.1195 15.8612 16.1195C14.106 16.1195 12.9986 14.686 12.9986 12.4028C12.9986 10.1401 14.1131 8.71463 15.8612 8.71463C16.9028 8.71463 17.6618 9.24342 18.0101 10.0068H18.0883V10.0068ZM18.0484 12.4171C18.0484 11.1106 17.4396 10.2806 16.4895 10.2806C15.5404 10.2806 14.9565 11.0982 14.9565 12.4171C14.9565 13.7422 15.5404 14.5456 16.4895 14.5456C17.4458 14.5456 18.0484 13.7359 18.0484 12.4171Z",
        fill: "currentColor"
    }));

});

parcelRegister("i7nD0", function(module, exports) {
$parcel$export(module.exports, "sliderGlyph", () => $f84be79b467e8813$export$5692f596ef132c32);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $f84be79b467e8813$export$5692f596ef132c32 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 5C6.55229 5 7 4.55228 7 4C7 3.44772 6.55229 3 6 3C5.44772 3 5 3.44772 5 4C5 4.55228 5.44772 5 6 5ZM6 7C7.30622 7 8.41746 6.16519 8.82929 5H15C15.5523 5 16 4.55228 16 4C16 3.44772 15.5523 3 15 3H8.82929C8.41746 1.83481 7.30622 1 6 1C4.69378 1 3.58254 1.83481 3.17071 3H1C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5H3.17071C3.58254 6.16519 4.69378 7 6 7ZM10 11C9.44771 11 9 11.4477 9 12C9 12.5523 9.44771 13 10 13C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11ZM10 9C8.69378 9 7.58254 9.83481 7.17071 11L1 11C0.447714 11 0 11.4477 0 12C0 12.5523 0.447715 13 1 13L7.17071 13C7.58254 14.1652 8.69378 15 10 15C11.3062 15 12.4175 14.1652 12.8293 13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H12.8293C12.4175 9.83481 11.3062 9 10 9Z",
        fill: "currentColor"
    }));

});

parcelRegister("5yMWX", function(module, exports) {
$parcel$export(module.exports, "sortAscMatrixGlyph", () => $d84e9436a450d9b2$export$ab10425340e01420);
$parcel$export(module.exports, "sortDescMatrixGlyph", () => $d84e9436a450d9b2$export$8bec0ec196f8276e);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $d84e9436a450d9b2$export$ab10425340e01420 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M6 4C5.7 4 5.4 4.1 5.2 4.3L2.3 7.2C1.9 7.6 1.9 8.3 2.3 8.7C2.7 9.1 3.3 9.1 3.7 8.7L5 7.4L5 19.1C5 19.6 5.4 20 6 20C6.6 20 7 19.6 7 19.1L7 7.4L8.3 8.7C8.7 9.1 9.3 9.1 9.7 8.7C10.1 8.3 10.1 7.6 9.7 7.2L6.8 4.3C6.6 4.1 6.3 4 6 4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M13 19L21 19C21.6 19 22 18.6 22 18C22 17.4 21.6 17 21 17L13 17C12.4 17 12 17.4 12 18C12 18.6 12.4 19 13 19Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M13 11L18 11C18.6 11 19 11.4 19 12C19 12.6 18.6 13 18 13L13 13C12.4 13 12 12.6 12 12C12 11.4 12.4 11 13 11Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M16 5L13 5C12.4 5 12 5.4 12 6C12 6.6 12.4 7 13 7L16 7C16.6 7 17 6.6 17 6C17 5.4 16.6 5 16 5Z",
        fill: "currentColor"
    }));
const $d84e9436a450d9b2$export$8bec0ec196f8276e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M6 20C5.7 20 5.4 19.9 5.2 19.7L2.3 16.8C1.9 16.4 1.9 15.7 2.3 15.3C2.7 14.9 3.3 14.9 3.7 15.3L5 16.6V4.9C5 4.4 5.4 4 6 4C6.6 4 7 4.4 7 4.9V16.6L8.3 15.3C8.7 14.9 9.3 14.9 9.7 15.3C10.1 15.7 10.1 16.4 9.7 16.8L6.8 19.7C6.6 19.9 6.3 20 6 20Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M13 5H21C21.6 5 22 5.4 22 6C22 6.6 21.6 7 21 7H13C12.4 7 12 6.6 12 6C12 5.4 12.4 5 13 5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M13 13H18C18.6 13 19 12.6 19 12C19 11.4 18.6 11 18 11H13C12.4 11 12 11.4 12 12C12 12.6 12.4 13 13 13Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M16 19H13C12.4 19 12 18.6 12 18C12 17.4 12.4 17 13 17H16C16.6 17 17 17.4 17 18C17 18.6 16.6 19 16 19Z",
        fill: "currentColor"
    }));

});

parcelRegister("2Gptm", function(module, exports) {
$parcel$export(module.exports, "statusGlyph", () => $ccd06c5aa08b79a7$export$18247f10a9c5505b);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $ccd06c5aa08b79a7$export$18247f10a9c5505b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5255 16.5255C15.3253 17.7257 13.6974 18.4 12 18.4C10.3026 18.4 8.67475 17.7257 7.47452 16.5255C6.27428 15.3253 5.6 13.6974 5.6 12C5.6 10.3026 6.27428 8.67475 7.47452 7.47452C8.67475 6.27428 10.3026 5.6 12 5.6C13.6974 5.6 15.3253 6.27428 16.5255 7.47452C17.7257 8.67475 18.4 10.3026 18.4 12C18.4 13.6974 17.7257 15.3253 16.5255 16.5255ZM4 12C4 16.4184 7.5816 20 12 20C16.4184 20 20 16.4184 20 12C20 7.5816 16.4184 4 12 4C7.5816 4 4 7.5816 4 12ZM12.2517 9.23528C12.1017 9.38659 12.0176 9.591 12.0176 9.80404C12.0176 10.0171 12.1017 10.2215 12.2517 10.3728L13.2685 11.3959H8.80075C8.35838 11.3959 8 11.7559 8 12.1999C8 12.6439 8.35838 13.0038 8.80075 13.0038H13.2685L12.2517 14.027C12.1017 14.1783 12.0176 14.3827 12.0176 14.5957C12.0176 14.8088 12.1017 15.0132 12.2517 15.1645C12.4019 15.3145 12.6054 15.3988 12.8177 15.3988C13.0299 15.3988 13.2335 15.3145 13.3836 15.1645L15.7659 12.7686C15.9159 12.6173 16 12.4129 16 12.1999C16 11.9868 15.9159 11.7824 15.7659 11.6311L13.3836 9.23528C13.3095 9.16071 13.2213 9.10154 13.1241 9.06116C13.027 9.02079 12.9229 9 12.8177 9C12.7125 9 12.6083 9.02079 12.5112 9.06116C12.4141 9.10154 12.3259 9.16071 12.2517 9.23528Z",
        fill: "currentColor"
    }));

});

parcelRegister("azr2y", function(module, exports) {
$parcel$export(module.exports, "switchGlyph", () => $f79a86508c52367a$export$38ef90ae72047d20);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $f79a86508c52367a$export$38ef90ae72047d20 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M11.2927 0.293135C11.683 -0.097523 12.3162 -0.097739 12.7069 0.292652L15.7069 3.29061L15.7901 3.38478C15.8065 3.40593 15.822 3.42759 15.8365 3.44969C15.8396 3.45646 15.8435 3.46257 15.8473 3.46871C15.8623 3.49043 15.8755 3.51343 15.8876 3.5368C15.8922 3.54775 15.8978 3.55883 15.9031 3.57001C15.9148 3.59257 15.9245 3.61528 15.9333 3.63825C15.9374 3.65076 15.9421 3.66354 15.9465 3.67645C15.9549 3.69947 15.9619 3.72278 15.968 3.74626C15.9713 3.76084 15.9748 3.77552 15.978 3.79033C15.9828 3.81167 15.9867 3.83337 15.9898 3.85515C15.9964 3.90238 16 3.95078 16 4L15.9961 3.90937C15.9978 3.92874 15.999 3.94816 15.9995 3.96759L16 4C16 4.01122 15.9998 4.0224 15.9994 4.03354C15.9988 4.04932 15.9979 4.06498 15.9966 4.08062C15.9948 4.10513 15.992 4.12919 15.9884 4.15298C15.986 4.16598 15.9835 4.17966 15.9808 4.19329C15.9758 4.2213 15.9693 4.24832 15.9617 4.27489C15.9587 4.2833 15.956 4.29199 15.9533 4.30065C15.945 4.3292 15.9349 4.35701 15.9235 4.38421C15.9189 4.39319 15.9149 4.4025 15.9107 4.41175C15.8563 4.5338 15.7776 4.64241 15.6811 4.73218L12.7073 7.70687L12.6132 7.79009C12.221 8.09525 11.6537 8.06771 11.2931 7.70735L11.2099 7.61317C10.9048 7.22098 10.9323 6.65374 11.2927 6.29313L12.584 5H1L0.883379 4.99327C0.38604 4.93551 0 4.51284 0 4C0 3.44772 0.447715 3 1 3H12.586L11.2931 1.70735L11.2099 1.61317C10.9048 1.22098 10.9323 0.653741 11.2927 0.293135Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M4.70735 8.29313C4.31696 7.90248 3.68379 7.90226 3.29313 8.29265L0.293135 11.2906L0.209914 11.3848C0.19346 11.4059 0.177972 11.4276 0.163452 11.4497C0.160442 11.4565 0.156515 11.4626 0.152653 11.4687C0.137665 11.4904 0.124527 11.5134 0.112375 11.5368C0.107781 11.5478 0.102243 11.5588 0.0969067 11.57C0.0852222 11.5926 0.0755053 11.6153 0.0666666 11.6382C0.0625782 11.6508 0.0579128 11.6635 0.053503 11.6764C0.0450611 11.6995 0.0381117 11.7228 0.0320282 11.7463C0.0286627 11.7608 0.0251751 11.7755 0.0220165 11.7903C0.0171585 11.8117 0.0133133 11.8334 0.0101881 11.8552C0.00355625 11.9024 0 11.9508 0 12L0.0039072 11.9094C0.0021944 11.9287 0.00104523 11.9482 0.000458717 11.9676L0 12C0 12.0112 0.000185013 12.0224 0.000552177 12.0335C0.00119019 12.0493 0.00211239 12.065 0.00340176 12.0806C0.00516224 12.1051 0.00797653 12.1292 0.0116282 12.153C0.014039 12.166 0.0164547 12.1797 0.0191565 12.1933C0.0241671 12.2213 0.0306768 12.2483 0.0382576 12.2749C0.0413313 12.2833 0.0439529 12.292 0.0466957 12.3007C0.0549803 12.3292 0.0651426 12.357 0.0764723 12.3842C0.0810766 12.3932 0.0851307 12.4025 0.0893335 12.4118C0.143727 12.5338 0.222425 12.6424 0.318884 12.7322L3.29265 15.7069L3.38683 15.7901C3.77902 16.0952 4.34626 16.0677 4.70687 15.7073L4.79009 15.6132C5.09525 15.221 5.06771 14.6537 4.70735 14.2931L3.416 13H15L15.1166 12.9933C15.614 12.9355 16 12.5128 16 12C16 11.4477 15.5523 11 15 11H3.414L4.70687 9.70735L4.79009 9.61317C5.09525 9.22098 5.06771 8.65374 4.70735 8.29313Z",
        fill: "currentColor"
    }));

});

parcelRegister("dEPY2", function(module, exports) {
$parcel$export(module.exports, "timelineGlyph", () => $488023106a28d8e0$export$39d896c52e566737);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $488023106a28d8e0$export$39d896c52e566737 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "25",
        height: "24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M.5 0h24v24H.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: "4.5",
        y: "5",
        width: "12",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: "7.5",
        y: "9",
        width: "12",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: "5.5",
        y: "13",
        width: "12",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: "8.5",
        y: "17",
        width: "12",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));

});

parcelRegister("3gf7U", function(module, exports) {
$parcel$export(module.exports, "timeStampGlyph", () => $7d1f68205a9dab14$export$98a4a461fe316fce);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $7d1f68205a9dab14$export$98a4a461fe316fce = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 4C7.588 4 4 7.588 4 12C4 16.412 7.588 20 12 20C16.412 20 20 16.412 20 12C20 7.588 16.412 4 12 4ZM12 18.222C10.3505 18.2199 8.76911 17.5637 7.60272 16.3973C6.43633 15.2309 5.78012 13.6495 5.778 12C5.78012 10.3505 6.43633 8.76911 7.60272 7.60272C8.76911 6.43633 10.3505 5.78012 12 5.778C13.6495 5.78012 15.2309 6.43633 16.3973 7.60272C17.5637 8.76911 18.2199 10.3505 18.222 12C18.2199 13.6495 17.5637 15.2309 16.3973 16.3973C15.2309 17.5637 13.6495 18.2199 12 18.222V18.222ZM12.889 11.632V8.448C12.889 7.959 12.489 7.559 12 7.559C11.511 7.559 11.111 7.959 11.111 8.449V12.004C11.111 12.252 11.214 12.475 11.379 12.637L13.574 14.831C13.741 14.9972 13.9669 15.0904 14.2025 15.0904C14.4381 15.0904 14.664 14.9972 14.831 14.831C14.9969 14.6641 15.0899 14.4383 15.0899 14.203C15.0899 13.9677 14.9969 13.7419 14.831 13.575L12.889 11.632V11.632Z",
        fill: "currentColor"
    }));

});

parcelRegister("iH2ek", function(module, exports) {
$parcel$export(module.exports, "upvoteGlyph", () => $6ae70b6c662b5725$export$1480e696e99a53ae);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $6ae70b6c662b5725$export$1480e696e99a53ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "10",
        viewBox: "0 0 16 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M15.5749 7.42198L9.00169 0.444771H9.00026C8.73188 0.159985 8.36793 0 7.98845 0C7.60896 0 7.24502 0.159985 6.97664 0.444771L0.404905 7.42198C0.143634 7.70498 -0.00186729 8.08598 1.81198e-05 8.48221C0.00190353 8.87843 0.151024 9.25786 0.414975 9.53803C0.678926 9.81821 1.03638 9.9765 1.40966 9.9785L7.98845 9.99998H14.576C14.7633 10.001 14.9489 9.96258 15.1221 9.88697C15.2953 9.81137 15.4526 9.70007 15.585 9.55952C15.7174 9.41896 15.8223 9.25194 15.8935 9.0681C15.9647 8.88427 16.0009 8.68727 16 8.4885C15.999 8.28973 15.961 8.09313 15.888 7.91006C15.815 7.727 15.7086 7.56111 15.5749 7.42198Z",
        fill: "currentColor"
    }));

});

parcelRegister("4ymzv", function(module, exports) {
$parcel$export(module.exports, "visibleGlyph", () => $12685d781c6e2c5e$export$be0c8a08b07ce4a9);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
const $12685d781c6e2c5e$export$be0c8a08b07ce4a9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.99992 12.0001C4.97592 12.0001 2.66725 9.16008 2.66725 8.00008C2.66725 6.66608 4.97325 4.00008 8.00059 4.00008C10.9179 4.00008 13.3326 6.64875 13.3326 8.00008C13.3326 9.16008 11.0246 12.0001 8.00059 12.0001H7.99992ZM8.00059 2.66675C4.31992 2.66675 1.33325 5.89408 1.33325 8.00008C1.33325 10.0574 4.38392 13.3334 7.99992 13.3334C11.6153 13.3334 14.6666 10.0574 14.6666 8.00008C14.6666 5.89408 11.6799 2.66675 7.99992 2.66675",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.98459 9.32275C7.24925 9.32275 6.65125 8.72475 6.65125 7.98941C6.65125 7.25408 7.24925 6.65608 7.98459 6.65608C8.72059 6.65608 9.31792 7.25408 9.31792 7.98941C9.31792 8.72475 8.72059 9.32275 7.98459 9.32275ZM7.98459 5.32275C6.51392 5.32275 5.31792 6.51875 5.31792 7.98941C5.31792 9.46008 6.51392 10.6561 7.98459 10.6561C9.45592 10.6561 10.6513 9.46008 10.6513 7.98941C10.6513 6.51875 9.45592 5.32275 7.98459 5.32275Z",
        fill: "currentColor"
    }));

});

parcelRegister("92Vsu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb6a2be77562ca7b9d4a7ef228c56aab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6960df002e894e72$var$_react = $6960df002e894e72$var$_interopRequireDefault((parcelRequire("euxye")));

var $6960df002e894e72$var$_baseNew = $6960df002e894e72$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $6960df002e894e72$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/calendar
 * Usage guidance:
 * Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6960df002e894e72$var$CalendarIcon = (props)=>/*#__PURE__*/ $6960df002e894e72$var$_react.default.createElement($6960df002e894e72$var$_baseNew.default, Object.assign({
        name: "CalendarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$6960df002e894e72$var$CalendarIcon.displayName = 'CalendarIcon';
var $6960df002e894e72$var$_default = module.exports.default = $6960df002e894e72$var$CalendarIcon;

});

parcelRegister("lyXvc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c236d232ef037a89b043dd6230c311a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb2aedd5a6154f0d$var$_react = $fb2aedd5a6154f0d$var$_interopRequireDefault((parcelRequire("euxye")));

var $fb2aedd5a6154f0d$var$_baseNew = $fb2aedd5a6154f0d$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $fb2aedd5a6154f0d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Scales".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/scales
 * Usage guidance:
 * Multi purpose - Known usages: Customer rating in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fb2aedd5a6154f0d$var$ScalesIcon = (props)=>/*#__PURE__*/ $fb2aedd5a6154f0d$var$_react.default.createElement($fb2aedd5a6154f0d$var$_baseNew.default, Object.assign({
        name: "ScalesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m7.25 3.406-3.672.864a.75.75 0 0 0-.504.405l-3 6.25A.75.75 0 0 0 0 11.25a3.75 3.75 0 1 0 7.5 0 .75.75 0 0 0-.074-.324l-2.595-5.41 6.068-1.428-2.325 4.837a.75.75 0 0 0-.074.325 3.75 3.75 0 1 0 7.5 0 .75.75 0 0 0-.074-.325l-3-6.25a.75.75 0 0 0-.848-.405l-3.328.783V1h-1.5zm5.001 1.33L10.443 8.5h3.615zM14.372 10h-4.244a2.251 2.251 0 0 0 4.244 0M3.751 6.732 1.94 10.5h3.617zM5.872 12H1.628a2.25 2.25 0 0 0 4.244 0" clip-rule="evenodd"/>`
    }, props));
$fb2aedd5a6154f0d$var$ScalesIcon.displayName = 'ScalesIcon';
var $fb2aedd5a6154f0d$var$_default = module.exports.default = $fb2aedd5a6154f0d$var$ScalesIcon;

});

parcelRegister("52SIy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6d9460ea633f4f93b685c8e22232576>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ac795688cb7a087$var$_react = $3ac795688cb7a087$var$_interopRequireDefault((parcelRequire("euxye")));

var $3ac795688cb7a087$var$_baseNew = $3ac795688cb7a087$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $3ac795688cb7a087$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FocusArea".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/focus-area
 * Usage guidance:
 * Reserved for representing Focus Areas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3ac795688cb7a087$var$FocusAreaIcon = (props)=>/*#__PURE__*/ $3ac795688cb7a087$var$_react.default.createElement($3ac795688cb7a087$var$_baseNew.default, Object.assign({
        name: "FocusAreaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13v-3h1.5v3a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2m12.5 0v-3H15v3a2 2 0 0 1-2 2h-3v-1.5h3a.5.5 0 0 0 .5-.5M9.75 8a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0M1 3a2 2 0 0 1 2-2h3v1.5H3a.5.5 0 0 0-.5.5v3H1zm12.5 0a.5.5 0 0 0-.5-.5h-3V1h3a2 2 0 0 1 2 2v3h-1.5zm-2.25 5a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0"/>`
    }, props));
$3ac795688cb7a087$var$FocusAreaIcon.displayName = 'FocusAreaIcon';
var $3ac795688cb7a087$var$_default = module.exports.default = $3ac795688cb7a087$var$FocusAreaIcon;

});

parcelRegister("cBpb3", function(module, exports) {
$parcel$export(module.exports, "ConnectionFieldIcon", () => $8bed466beb63e067$export$965fc0557919aad0);

var $euxye = parcelRequire("euxye");

var $gAxlz = parcelRequire("gAxlz");

var $hMzFD = parcelRequire("hMzFD");

var $6geBQ = parcelRequire("6geBQ");

var $6OFDk = parcelRequire("6OFDk");

var $2XXtG = parcelRequire("2XXtG");

var $g8Aut = parcelRequire("g8Aut");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $8bed466beb63e067$var$connection = (0, $7eNDO.defineMessage)({
    id: "polaris-component-glyphs.glyphs.connection.connection",
    defaultMessage: "Connection"
});
const $8bed466beb63e067$export$965fc0557919aad0 = ({ issueTypeFilters: issueTypeFilters = (0, $6OFDk.defaultProps).emptyArray })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const issueTypeNameFilter = issueTypeFilters.find((0, $gAxlz.isIssueTypeNameFilter));
    const issueTypeByName = (0, $6geBQ.useIssueTypeByNameAndProjectIds)({
        name: issueTypeNameFilter?.names[0],
        projectIds: issueTypeNameFilter?.projectIds
    });
    if (issueTypeByName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hMzFD.IssueTypeIcon), {
        issueTypeId: issueTypeByName.id
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g8Aut))), {
        label: formatMessage($8bed466beb63e067$var$connection),
        color: "var(--ds-icon)"
    });
};
$8bed466beb63e067$export$965fc0557919aad0.displayName = "ConnectionFieldIcon";

});
parcelRegister("gAxlz", function(module, exports) {
$parcel$export(module.exports, "isIssueTypeNameFilter", () => $42ebdcec32cde4c5$export$d122ccde9280af01);
/* eslint-disable jira/filename-case */ const $42ebdcec32cde4c5$export$d122ccde9280af01 = (filter)=>filter.type === 'name';

});

parcelRegister("hMzFD", function(module, exports) {
$parcel$export(module.exports, "IssueTypeIcon", () => $9d5eb685ec361433$export$f315b19fd9da0750);

var $euxye = parcelRequire("euxye");

var $5GK0n = parcelRequire("5GK0n");

var $i860n = parcelRequire("i860n");

var $6geBQ = parcelRequire("6geBQ");

var $84wJV = parcelRequire("84wJV");
const $9d5eb685ec361433$export$f315b19fd9da0750 = ({ issueTypeId: issueTypeId, iconlLabel: iconlLabel, size: size = 'xsmall' })=>{
    const avatarUrl = (0, $6geBQ.useIssueTypeAvatarUrl)({
        issueTypeId: issueTypeId
    });
    const issueTypeName = (0, $6geBQ.useIssueTypeName)({
        issueTypeId: issueTypeId
    });
    const iconName = iconlLabel !== undefined && (0, $i860n.fg)('jpd_a11y_decorative_icons') ? iconlLabel : issueTypeName;
    const skeletonSize = size === 'xsmall' ? 'xxsmall' : size;
    if (avatarUrl === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5GK0n.default), {
        appearance: "square",
        size: skeletonSize
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $84wJV.IssueTypeAvatar), {
        avatarUrl: avatarUrl,
        size: size,
        name: iconName
    });
};
$9d5eb685ec361433$export$f315b19fd9da0750.displayName = "IssueTypeIcon";

});
parcelRegister("5GK0n", function(module, exports) {
$parcel$export(module.exports, "default", () => $0eebb608f59e2593$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $0eebb608f59e2593$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $0eebb608f59e2593$var$styles = {
    root: "_2rko1qll _189e1dm9 _1dqonqa1 _1h6d3acm _1e0c1o8l _bfhk1r8p _tzy4nh7s",
    square: "_2rkol0p1",
    hexagon: "_mkrz1k6g",
    strongOpacity: "_tzy4clii"
};
const $0eebb608f59e2593$var$sizeStyles = {
    xxsmall: "_1bsb7vkz _4t3i7vkz",
    xsmall: "_1bsb7vkz _4t3i7vkz",
    UNSAFE_xsmall: "_1bsbgktf _4t3igktf",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $0eebb608f59e2593$var$Skeleton = ({ size: size, appearance: appearance = 'circle', color: color, weight: weight })=>{
    const avatarSize = size ?? 'medium';
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        style: {
            [$0eebb608f59e2593$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $4jQY2.default)([
            $0eebb608f59e2593$var$styles.root,
            $0eebb608f59e2593$var$sizeStyles[avatarSize],
            appearance === 'square' && $0eebb608f59e2593$var$styles.square,
            appearance === 'hexagon' && $0eebb608f59e2593$var$styles.hexagon,
            weight === 'strong' && $0eebb608f59e2593$var$styles.strongOpacity
        ])
    });
};
$0eebb608f59e2593$var$Skeleton.displayName = "Skeleton";
var $0eebb608f59e2593$export$2e2bcd8739ae039 = $0eebb608f59e2593$var$Skeleton;

});

parcelRegister("6geBQ", function(module, exports) {
$parcel$export(module.exports, "IssueTypesStore", () => $6b3ffaa983d9009e$export$205777c0b2d63939);
$parcel$export(module.exports, "useIssueTypesActions", () => $6b3ffaa983d9009e$export$8748a77548356db8);
$parcel$export(module.exports, "useAllIssueTypesByName", () => $6b3ffaa983d9009e$export$8e5bebacad0580d7);
$parcel$export(module.exports, "useAllIssueTypesById", () => $6b3ffaa983d9009e$export$bb3bddcbabc87129);
$parcel$export(module.exports, "useAllIssueTypeIds", () => $6b3ffaa983d9009e$export$ef415bb7a1b6a479);
$parcel$export(module.exports, "useAllIssueTypeIdsByProjectId", () => $6b3ffaa983d9009e$export$48168bdb536ebd8c);
$parcel$export(module.exports, "useAllIssueTypesByProjectId", () => $6b3ffaa983d9009e$export$b63556251c014141);
$parcel$export(module.exports, "useIssueTypeIdsForProject", () => $6b3ffaa983d9009e$export$89c4ec728abd6d72);
$parcel$export(module.exports, "useIssueTypesForProject", () => $6b3ffaa983d9009e$export$1cef051df1838099);
$parcel$export(module.exports, "useIssueTypesForProjectIds", () => $6b3ffaa983d9009e$export$ab262f3c263d63f4);
$parcel$export(module.exports, "useIssueTypesByNameForProjectIds", () => $6b3ffaa983d9009e$export$191799c541b02493);
$parcel$export(module.exports, "useIssueTypeIdForProject", () => $6b3ffaa983d9009e$export$54a84af513817d94);
$parcel$export(module.exports, "useIssueTypeName", () => $6b3ffaa983d9009e$export$ec3ac562fe41f8db);
$parcel$export(module.exports, "useIssueTypeDescription", () => $6b3ffaa983d9009e$export$d6e733a19eae99d);
$parcel$export(module.exports, "useIssueTypeAvatarId", () => $6b3ffaa983d9009e$export$d3cd0f314915ab90);
$parcel$export(module.exports, "useIssueTypeAvatarUrl", () => $6b3ffaa983d9009e$export$5ab59988e123332e);
$parcel$export(module.exports, "useIsIssueTypeDeletable", () => $6b3ffaa983d9009e$export$5cc5a14a165ffc68);
$parcel$export(module.exports, "useIsIssueTypeEditable", () => $6b3ffaa983d9009e$export$b4c92f9ba36a536e);
$parcel$export(module.exports, "useIssueTypeProjectId", () => $6b3ffaa983d9009e$export$cd4dff2fdb5c9877);
$parcel$export(module.exports, "useIssueTypeValuesForProject", () => $6b3ffaa983d9009e$export$c55bbfadb5d8b5da);
$parcel$export(module.exports, "useIssueTypeValuesForProjectIds", () => $6b3ffaa983d9009e$export$abaecfe2dee8c04a);
$parcel$export(module.exports, "useIssueTypeValuesPrioritizingProjectIds", () => $6b3ffaa983d9009e$export$50d192c1cbd48722);
$parcel$export(module.exports, "useAllIssueTypeValuesById", () => $6b3ffaa983d9009e$export$4bb11ad73c81e599);
$parcel$export(module.exports, "useHasProjectCustomIssueTypes", () => $6b3ffaa983d9009e$export$3fc0643a546c76d0);
$parcel$export(module.exports, "useIssueTypeByNameAndProjectIds", () => $6b3ffaa983d9009e$export$309b535a40496c46);
$parcel$export(module.exports, "useValidTransitionIssueTypeTargetNames", () => $6b3ffaa983d9009e$export$7a2e81e8bca30117);
$parcel$export(module.exports, "useIssueTypePinnedFieldKeys", () => $6b3ffaa983d9009e$export$5f3f38dbb1c1d6aa);
$parcel$export(module.exports, "useAllPinnedFieldKeys", () => $6b3ffaa983d9009e$export$c8bddd4bbce366e6);

var $3gOaP = parcelRequire("3gOaP");

var $3h1FP = parcelRequire("3h1FP");
var $dB6ay = parcelRequire("dB6ay");
var $3K7NP = parcelRequire("3K7NP");
var $5QDqc = parcelRequire("5QDqc");

var $6TZik = parcelRequire("6TZik");
const $6b3ffaa983d9009e$var$EMPTY = [];
const $6b3ffaa983d9009e$var$initialState = {
    issueTypesById: {},
    issueTypesByProjectId: {}
};
const $6b3ffaa983d9009e$export$205777c0b2d63939 = (0, $5QDqc.createStore)({
    initialState: $6b3ffaa983d9009e$var$initialState,
    actions: $6TZik.actions,
    name: 'PolarisIssueTypesStore'
});
const $6b3ffaa983d9009e$var$handlePropsChange = ()=>async ({ dispatch: dispatch }, props)=>{
        await dispatch((0, $6TZik.actions).fetchIssueTypesForProjects([
            props.projectId
        ]));
    };
const $6b3ffaa983d9009e$export$f73e1c449d01ca04 = (0, $dB6ay.createContainer)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    onInit: $6b3ffaa983d9009e$var$handlePropsChange,
    onUpdate: $6b3ffaa983d9009e$var$handlePropsChange
});
const $6b3ffaa983d9009e$export$8748a77548356db8 = (0, $3h1FP.createActionsHook)($6b3ffaa983d9009e$export$205777c0b2d63939);
const $6b3ffaa983d9009e$var$getAllIssueTypesById = (state)=>state.issueTypesById;
const $6b3ffaa983d9009e$var$getAllIssueTypeIds = (state)=>Object.keys(state.issueTypesById);
const $6b3ffaa983d9009e$var$getAllIssueTypeIdsByProjectId = (state)=>state.issueTypesByProjectId;
const $6b3ffaa983d9009e$var$getAllIssueTypesByName = (0, $3K7NP.createSelector)($6b3ffaa983d9009e$var$getAllIssueTypesById, (issueTypesById)=>(0, (/*@__PURE__*/$parcel$interopDefault($3gOaP)))(Object.values(issueTypesById).filter(Boolean), 'name'));
const $6b3ffaa983d9009e$export$8e5bebacad0580d7 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getAllIssueTypesByName
});
const $6b3ffaa983d9009e$export$bb3bddcbabc87129 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getAllIssueTypesById
});
const $6b3ffaa983d9009e$var$getProjectIds = (0, $3K7NP.createSelector)($6b3ffaa983d9009e$var$getAllIssueTypeIdsByProjectId, (issueTypesByProjectId)=>Object.keys(issueTypesByProjectId));
const $6b3ffaa983d9009e$export$dd0dd59b660a1e4 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getProjectIds
});
const $6b3ffaa983d9009e$export$ef415bb7a1b6a479 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getAllIssueTypeIds
});
const $6b3ffaa983d9009e$export$48168bdb536ebd8c = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getAllIssueTypeIdsByProjectId
});
const $6b3ffaa983d9009e$var$getAllIssueTypesByProjectId = (0, $3K7NP.createSelector)($6b3ffaa983d9009e$var$getAllIssueTypeIdsByProjectId, $6b3ffaa983d9009e$var$getAllIssueTypesById, (issueTypesByProjectId, issueTypesById)=>{
    return Object.keys(issueTypesByProjectId).reduce((acc, projectId)=>{
        acc[projectId] = issueTypesByProjectId[projectId]?.map((issueTypeId)=>issueTypesById[issueTypeId]).filter(Boolean);
        return acc;
    }, {});
});
const $6b3ffaa983d9009e$export$b63556251c014141 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getAllIssueTypesByProjectId
});
const $6b3ffaa983d9009e$var$getIssueTypeIdsForProject = (state, { projectId: projectId })=>{
    if (projectId === undefined) return $6b3ffaa983d9009e$var$EMPTY;
    return state.issueTypesByProjectId[projectId] || $6b3ffaa983d9009e$var$EMPTY;
};
const $6b3ffaa983d9009e$var$getIssueTypeIdsForProjectIds = (state, { projectIds: projectIds })=>{
    return projectIds.flatMap((projectId)=>state.issueTypesByProjectId[projectId] || $6b3ffaa983d9009e$var$EMPTY);
};
const $6b3ffaa983d9009e$export$89c4ec728abd6d72 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getIssueTypeIdsForProject
});
const $6b3ffaa983d9009e$var$getIssueTypesForProject = (0, $3K7NP.createSelector)($6b3ffaa983d9009e$var$getAllIssueTypesById, $6b3ffaa983d9009e$var$getIssueTypeIdsForProject, (issueTypesById, issueTypeIds)=>issueTypeIds.map((issueTypeId)=>issueTypesById[issueTypeId]).filter(Boolean));
const $6b3ffaa983d9009e$export$1cef051df1838099 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getIssueTypesForProject
});
const $6b3ffaa983d9009e$var$getIssueTypesForProjectIds = (0, $3K7NP.createSelector)($6b3ffaa983d9009e$var$getAllIssueTypesById, $6b3ffaa983d9009e$var$getIssueTypeIdsForProjectIds, (issueTypesById, issueTypeIds)=>issueTypeIds.map((issueTypeId)=>issueTypesById[issueTypeId]).filter(Boolean));
const $6b3ffaa983d9009e$export$ab262f3c263d63f4 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getIssueTypesForProjectIds
});
const $6b3ffaa983d9009e$var$getIssueTypesByNameForProjectIds = (0, $3K7NP.createSelector)($6b3ffaa983d9009e$var$getIssueTypesForProjectIds, (issueTypes)=>(0, (/*@__PURE__*/$parcel$interopDefault($3gOaP)))(issueTypes, 'name'));
const $6b3ffaa983d9009e$export$191799c541b02493 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getIssueTypesByNameForProjectIds
});
const $6b3ffaa983d9009e$export$54a84af513817d94 = ({ projectId: projectId })=>{
    const issueTypeIds = $6b3ffaa983d9009e$export$89c4ec728abd6d72({
        projectId: projectId
    });
    return issueTypeIds.length > 0 ? issueTypeIds[0] : undefined;
};
const $6b3ffaa983d9009e$export$ec3ac562fe41f8db = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: (state, { issueTypeId: issueTypeId })=>state.issueTypesById[issueTypeId]?.name
});
const $6b3ffaa983d9009e$export$d6e733a19eae99d = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: (state, { issueTypeId: issueTypeId })=>state.issueTypesById[issueTypeId]?.description
});
const $6b3ffaa983d9009e$export$d3cd0f314915ab90 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: (state, { issueTypeId: issueTypeId })=>state.issueTypesById[issueTypeId]?.avatarId
});
const $6b3ffaa983d9009e$export$5ab59988e123332e = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: (state, { issueTypeId: issueTypeId })=>state.issueTypesById[issueTypeId]?.avatarUrl
});
const $6b3ffaa983d9009e$export$5cc5a14a165ffc68 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: (state, { issueTypeId: issueTypeId })=>state.issueTypesById[issueTypeId]?.operation.deletable === true
});
const $6b3ffaa983d9009e$export$b4c92f9ba36a536e = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: (state, { issueTypeId: issueTypeId })=>state.issueTypesById[issueTypeId]?.operation.editable === true
});
const $6b3ffaa983d9009e$export$cd4dff2fdb5c9877 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: (state, { issueTypeId: issueTypeId })=>Object.keys(state.issueTypesByProjectId).find((projectId)=>state.issueTypesByProjectId[projectId]?.includes(issueTypeId))
});
const $6b3ffaa983d9009e$var$transformToFieldValue = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        id: id,
        name: name,
        iconUrl: avatarUrl
    });
const $6b3ffaa983d9009e$var$getIssueTypeValuesForProject = (0, $3K7NP.createSelector)($6b3ffaa983d9009e$var$getIssueTypesForProject, (issueTypes)=>issueTypes.map($6b3ffaa983d9009e$var$transformToFieldValue));
const $6b3ffaa983d9009e$export$c55bbfadb5d8b5da = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getIssueTypeValuesForProject
});
const $6b3ffaa983d9009e$var$getIssueTypeValue = (state, { issueTypeId: issueTypeId })=>{
    if (!issueTypeId) return undefined;
    const issueType = state.issueTypesById[issueTypeId];
    if (!issueType) return undefined;
    return $6b3ffaa983d9009e$var$transformToFieldValue(issueType);
};
const $6b3ffaa983d9009e$export$798b621777f46d13 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getIssueTypeValue
});
const $6b3ffaa983d9009e$var$getIssueTypeValuesForProjectIds = (0, $3K7NP.createSelector)($6b3ffaa983d9009e$var$getIssueTypesForProjectIds, (issueTypes)=>issueTypes.map($6b3ffaa983d9009e$var$transformToFieldValue));
const $6b3ffaa983d9009e$export$abaecfe2dee8c04a = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getIssueTypeValuesForProjectIds
});
const $6b3ffaa983d9009e$export$90ed312fb86370d0 = (0, $3K7NP.createSelector)($6b3ffaa983d9009e$var$getIssueTypesForProjectIds, $6b3ffaa983d9009e$var$getAllIssueTypesById, (projectIssueTypes, allIssueTypesById)=>{
    const prioritizedIssueTypes = [
        ...projectIssueTypes,
        ...Object.values(allIssueTypesById)
    ];
    const issueTypesByName = new Map();
    for (const issueType of prioritizedIssueTypes)if (issueType && !issueTypesByName.has(issueType.name)) issueTypesByName.set(issueType.name, $6b3ffaa983d9009e$var$transformToFieldValue(issueType));
    return Array.from(issueTypesByName.values());
});
const $6b3ffaa983d9009e$export$50d192c1cbd48722 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$export$90ed312fb86370d0
});
const $6b3ffaa983d9009e$var$getAllIssueTypeValuesById = (0, $3K7NP.createSelector)($6b3ffaa983d9009e$var$getAllIssueTypesById, (allIssueTypes)=>{
    const issueTypeMap = new Map();
    Object.values(allIssueTypes).forEach((issueType)=>{
        issueType && issueTypeMap.set(issueType.id, $6b3ffaa983d9009e$var$transformToFieldValue(issueType));
    });
    return issueTypeMap;
});
const $6b3ffaa983d9009e$export$4bb11ad73c81e599 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getAllIssueTypeValuesById
});
const $6b3ffaa983d9009e$var$hasProjectCustomIssueTypes = (0, $3K7NP.createSelector)($6b3ffaa983d9009e$var$getIssueTypeIdsForProject, (issueTypeIds)=>issueTypeIds.length > 1);
const $6b3ffaa983d9009e$export$3fc0643a546c76d0 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$hasProjectCustomIssueTypes
});
const $6b3ffaa983d9009e$var$getIssueTypeByNameAndProjectIds = (state, { name: name, projectIds: projectIds })=>{
    if (!name) return;
    if (!projectIds?.length) return Object.values(state.issueTypesById).find((issueType)=>issueType?.name === name);
    for (const projectId of projectIds){
        const issueTypeId = state.issueTypesByProjectId[projectId]?.find((id)=>state.issueTypesById[id]?.name === name);
        if (issueTypeId) return state.issueTypesById[issueTypeId];
    }
};
const $6b3ffaa983d9009e$export$309b535a40496c46 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getIssueTypeByNameAndProjectIds
});
const $6b3ffaa983d9009e$export$7a2e81e8bca30117 = ({ projectId: projectId })=>{
    const allIssueTypeIdsByProjectId = $6b3ffaa983d9009e$export$48168bdb536ebd8c();
    const allIssueTypesById = $6b3ffaa983d9009e$export$bb3bddcbabc87129();
    if (!projectId) return [];
    return allIssueTypeIdsByProjectId[projectId]?.map((issueTypeId)=>allIssueTypesById[issueTypeId]?.name).filter(Boolean) ?? [];
};
const $6b3ffaa983d9009e$var$getIssueTypePinnedFieldKeys = (state, { issueTypeId: issueTypeId })=>state.issueTypesById[issueTypeId]?.pinnedFields || [];
const $6b3ffaa983d9009e$export$5f3f38dbb1c1d6aa = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getIssueTypePinnedFieldKeys
});
const $6b3ffaa983d9009e$var$getAllPinnedFieldKeys = (state)=>Object.values(state.issueTypesById).flatMap((issueType)=>issueType?.pinnedFields || []);
const $6b3ffaa983d9009e$export$c8bddd4bbce366e6 = (0, $3h1FP.createStateHook)($6b3ffaa983d9009e$export$205777c0b2d63939, {
    selector: $6b3ffaa983d9009e$var$getAllPinnedFieldKeys
});

});
parcelRegister("3gOaP", function(module, exports) {

var $fOh92 = parcelRequire("fOh92");

var $4cz3P = parcelRequire("4cz3P");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $2619c9287685fb3c$var$keyBy = $4cz3P(function(result, value, key) {
    $fOh92(result, key, value);
});
module.exports = $2619c9287685fb3c$var$keyBy;

});

parcelRegister("6TZik", function(module, exports) {
$parcel$export(module.exports, "actions", () => $a71ef2977694d7da$export$e324594224ef24da);
/* eslint-disable jira/filename-case */ 
var $ljixM = parcelRequire("ljixM");

var $fPMU6 = parcelRequire("fPMU6");

var $lHvZS = parcelRequire("lHvZS");

var $j9kKr = parcelRequire("j9kKr");

var $gOKaz = parcelRequire("gOKaz");

var $g3iil = parcelRequire("g3iil");

var $3qB6r = parcelRequire("3qB6r");

var $kwMVo = parcelRequire("kwMVo");
const $a71ef2977694d7da$export$e324594224ef24da = {
    fetchAllIssueTypes: $j9kKr.fetchAllIssueTypes,
    fetchIssueTypesForProjects: $gOKaz.fetchIssueTypesForProjects,
    fetchPinnedFieldsForType: $g3iil.fetchPinnedFieldsForType,
    updateIssueType: $kwMVo.updateIssueType,
    createIssueType: $ljixM.createIssueType,
    deleteIssueType: $lHvZS.deleteIssueType,
    populateIssueTypes: $3qB6r.populateIssueTypes,
    togglePinnedField: $g3iil.togglePinnedField,
    updatePinnedFields: $g3iil.updatePinnedFields,
    clearIssueTypesStore: $fPMU6.clearIssueTypesStore
};

});
parcelRegister("ljixM", function(module, exports) {
$parcel$export(module.exports, "createIssueType", () => $1a22de7f83efda07$export$9557596bf5429867);

var $63gbl = parcelRequire("63gbl");

var $j85oP = parcelRequire("j85oP");

var $f6qTB = parcelRequire("f6qTB");

var $lCetP = parcelRequire("lCetP");

var $iKJAh = parcelRequire("iKJAh");

var $gOKaz = parcelRequire("gOKaz");
const $1a22de7f83efda07$var$transformIssueType = (rest)=>({
        id: String(rest.id),
        name: rest.name,
        entityId: rest.entityId,
        description: rest.description,
        avatarId: String(rest.avatarId),
        avatarUrl: rest.avatarUrl,
        hierarchyLevel: rest.hierarchyLevel,
        operation: {
            deletable: true,
            editable: true
        },
        pinnedFields: []
    });
const $1a22de7f83efda07$export$9557596bf5429867 = (projectId, data)=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        (0, $j85oP.experience).issueTypes.issueTypeCreate.start();
        try {
            const result = await (0, $iKJAh.performCreateIssueType)(projectId, {
                name: data.name,
                description: data.description,
                avatarId: Number(data.avatarId)
            });
            const newIssueType = $1a22de7f83efda07$var$transformIssueType(result);
            const state = getState();
            setState({
                issueTypesById: {
                    ...state.issueTypesById,
                    [newIssueType.id]: newIssueType
                },
                issueTypesByProjectId: {
                    ...state.issueTypesByProjectId,
                    [projectId]: [
                        ...state.issueTypesByProjectId[projectId] ?? [],
                        newIssueType.id
                    ]
                }
            });
            (0, $j85oP.experience).issueTypes.issueTypeCreate.success();
            dispatch((0, $gOKaz.fetchIssueTypesForProjects)([
                projectId
            ]));
            return newIssueType;
        } catch (maybeError) {
            const error = maybeError instanceof Error ? maybeError : new Error('Error while creating issue type');
            if ((0, $lCetP.isClientFetchError)(error) || (0, $f6qTB.isConflictError)(error)) (0, $j85oP.experience).issueTypes.issueTypeCreate.abort();
            else (0, $j85oP.experience).issueTypes.issueTypeCreate.failure(error);
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.issue-types.actions.create-issue-type', 'Failed to create issue type', error);
            throw error;
        }
    };

});
parcelRegister("iKJAh", function(module, exports) {
$parcel$export(module.exports, "performCreateIssueType", () => $ef379f1620993389$export$4b90dd56614eadf8);
/* eslint-disable jira/filename-case */ 
var $h2wCv = parcelRequire("h2wCv");
const $ef379f1620993389$export$4b90dd56614eadf8 = (projectId, data)=>{
    return (0, $h2wCv.performPostRequest)(`/rest/polaris/v2/project/${projectId}/settings/issuetype`, {
        body: JSON.stringify(data)
    });
};

});

parcelRegister("gOKaz", function(module, exports) {
$parcel$export(module.exports, "fetchIssueTypesForProjects", () => $2166397abf2e8b8b$export$59b6e6b26485fa83);

var $3gOaP = parcelRequire("3gOaP");

var $bvvEj = parcelRequire("bvvEj");

var $63gbl = parcelRequire("63gbl");

var $4trzf = parcelRequire("4trzf");

var $j85oP = parcelRequire("j85oP");

var $f6qTB = parcelRequire("f6qTB");

var $lCetP = parcelRequire("lCetP");

var $lDGD2 = parcelRequire("lDGD2");

var $gjqah = parcelRequire("gjqah");
const $2166397abf2e8b8b$var$PROJECT_IDS_LIMIT = 50;
const $2166397abf2e8b8b$var$BATCH_SIZE = 5;
const $2166397abf2e8b8b$var$isPreconditionFailedError = (error)=>'statusCode' in error && error.statusCode === 412;
const $2166397abf2e8b8b$export$59b6e6b26485fa83 = (projectIds)=>async ({ setState: setState, getState: getState })=>{
        (0, $j85oP.experience).issueTypes.issueTypesForProjectsLoad.start();
        const prevState = getState();
        try {
            setState({
                issueTypesByProjectId: {
                    ...prevState.issueTypesByProjectId,
                    ...projectIds.reduce((acc, projectId)=>{
                        acc[projectId] = prevState.issueTypesByProjectId[projectId] ?? [];
                        return acc;
                    }, {})
                }
            });
            const projectIdsChunks = (0, (/*@__PURE__*/$parcel$interopDefault($bvvEj)))(projectIds, $2166397abf2e8b8b$var$PROJECT_IDS_LIMIT);
            const batchResponse = await (0, $4trzf.runInBatch)(projectIdsChunks.map((ids)=>()=>(0, $lDGD2.performGetIssueTypesForProjects)(ids)), $2166397abf2e8b8b$var$BATCH_SIZE);
            const projects = batchResponse.map((c)=>c.projects).flat();
            const { issueTypesById: issueTypesById, issueTypesByProjectId: issueTypesByProjectId } = projects.reduce((acc, { projectId: projectId, issueTypes: issueTypes })=>({
                    issueTypesById: {
                        ...acc.issueTypesById,
                        ...(0, (/*@__PURE__*/$parcel$interopDefault($3gOaP)))(issueTypes.map((0, $gjqah.transformIssueTypeResponse)), ({ id: id })=>id)
                    },
                    issueTypesByProjectId: {
                        ...acc.issueTypesByProjectId,
                        [projectId]: issueTypes.map(({ id: id })=>String(id))
                    }
                }), {
                issueTypesById: {},
                issueTypesByProjectId: {}
            });
            setState({
                issueTypesById: {
                    ...getState().issueTypesById,
                    ...issueTypesById
                },
                issueTypesByProjectId: {
                    ...getState().issueTypesByProjectId,
                    ...issueTypesByProjectId
                }
            });
            (0, $j85oP.experience).issueTypes.issueTypesForProjectsLoad.success();
        } catch (maybeError) {
            const error = maybeError instanceof Error ? maybeError : new Error('Error while fetching issue types for projects');
            const shouldAbortError = (0, $lCetP.isClientFetchError)(error) || // https://pi-dev-sandbox.atlassian.net/browse/POL-19127
            (0, $f6qTB.isNotFoundError)(error) || (0, $f6qTB.isBadRequestError)(error) || // https://pi-dev-sandbox.atlassian.net/browse/POL-20499
            $2166397abf2e8b8b$var$isPreconditionFailedError(error);
            if (shouldAbortError) (0, $j85oP.experience).issueTypes.issueTypesForProjectsLoad.abort();
            else (0, $j85oP.experience).issueTypes.issueTypesForProjectsLoad.failure(error);
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.issue-types.actions.fetch-issue-types-for-projects', 'Failed to fetch issue types for projects', error);
            throw error;
        }
    };

});
parcelRegister("4trzf", function(module, exports) {
$parcel$export(module.exports, "runInBatch", () => $93843b3b93550d59$export$450a3350fc58ff82);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bvvEj = parcelRequire("bvvEj");

var $jx9NW = parcelRequire("jx9NW");

var $b73ki = parcelRequire("b73ki");
const $93843b3b93550d59$var$executeBatchesRecursively = (remainingChunks)=>{
    const currentChunk = (0, (/*@__PURE__*/$parcel$interopDefault($jx9NW)))(remainingChunks) || [];
    const nextChunks = (0, (/*@__PURE__*/$parcel$interopDefault($b73ki)))(remainingChunks);
    return Promise.all(currentChunk.map((promiseProvider)=>promiseProvider())).then((results)=>{
        if (nextChunks.length > 0) return $93843b3b93550d59$var$executeBatchesRecursively(nextChunks).then((recursiveResults)=>[
                ...results,
                ...recursiveResults
            ]);
        return results;
    });
};
const $93843b3b93550d59$export$450a3350fc58ff82 = (promises, batchSize)=>{
    if (promises.length === 0) return Promise.resolve([]);
    const batches = (0, (/*@__PURE__*/$parcel$interopDefault($bvvEj)))(promises, batchSize);
    return $93843b3b93550d59$var$executeBatchesRecursively(batches);
};

});
parcelRegister("jx9NW", function(module, exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $e388b45f1759c570$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = $e388b45f1759c570$var$head;

});

parcelRegister("b73ki", function(module, exports) {

var $g2svi = parcelRequire("g2svi");
/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.tail([1, 2, 3]);
 * // => [2, 3]
 */ function $8172edb0757f5d4a$var$tail(array) {
    var length = array == null ? 0 : array.length;
    return length ? $g2svi(array, 1, length) : [];
}
module.exports = $8172edb0757f5d4a$var$tail;

});


parcelRegister("lDGD2", function(module, exports) {
$parcel$export(module.exports, "performGetIssueTypesForProjects", () => $2cc7a5543a91465f$export$e47c37e7ea368000);

var $hn9Lv = parcelRequire("hn9Lv");

var $4fhEY = parcelRequire("4fhEY");

var $d20Eh = parcelRequire("d20Eh");

var $6wKnL = parcelRequire("6wKnL");
const $2cc7a5543a91465f$export$e47c37e7ea368000 = (projectIds)=>{
    if (!projectIds.length) throw new Error('No project ids provided');
    // Try to get from early fetch cache first
    const earlyFetchResponse = (0, $d20Eh.getEarlyFetchResponse)(projectIds);
    if (earlyFetchResponse) return (0, $hn9Lv.wrapPromiseWithFetchInteraction)(earlyFetchResponse, 'earlyScript/getIssueTypesForProjects').catch(()=>{
        // If the cached promise fails, fall back to a regular fetch
        return (0, $4fhEY.default)((0, $6wKnL.getIssueTypesForProjectsUrl)(projectIds));
    });
    // Fallback to regular fetch if not in cache
    return (0, $4fhEY.default)((0, $6wKnL.getIssueTypesForProjectsUrl)(projectIds));
};

});
parcelRegister("d20Eh", function(module, exports) {
$parcel$export(module.exports, "getEarlyFetchResponse", () => $8cb34e1a73991a89$export$b9d6f7ad3c414536);
$parcel$export(module.exports, "runGetIssueTypesForProjectsEarlyScript", () => $8cb34e1a73991a89$export$f8e676bff6de4a13);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bxhpq = parcelRequire("bxhpq");

var $3HFzJ = parcelRequire("3HFzJ");

var $7FcOv = parcelRequire("7FcOv");

var $2snMp = parcelRequire("2snMp");

var $7U9nQ = parcelRequire("7U9nQ");

var $hWVxx = parcelRequire("hWVxx");

var $eQXnX = parcelRequire("eQXnX");

var $6wKnL = parcelRequire("6wKnL");
// Create a type-specific early fetch cache for issue types
const $8cb34e1a73991a89$var$earlyFetchCache = (0, $3HFzJ.createEarlyFetchCache)({
    paramsEqualityFn: (a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(a.map(String), b.map(String))
});
const $8cb34e1a73991a89$export$b9d6f7ad3c414536 = (projectIds)=>{
    return $8cb34e1a73991a89$var$earlyFetchCache.getCachedResponse(projectIds);
};
/**
 * Helper function to fetch issue types with proper type
 */ const $8cb34e1a73991a89$var$fetchIssueTypesForProjects = (projectIds)=>{
    if (!projectIds.length) throw new Error('No project ids provided');
    const url = (0, $6wKnL.getIssueTypesForProjectsUrl)(projectIds);
    return (0, $7FcOv.fetchData)({
        url: url,
        method: 'GET'
    });
};
const $8cb34e1a73991a89$export$b27be2640a8307fd = (projectIds)=>{
    // Execute the actual fetch for issue types
    const response = $8cb34e1a73991a89$var$fetchIssueTypesForProjects(projectIds);
    // Store the fetch promise in the cache
    $8cb34e1a73991a89$var$earlyFetchCache.setCacheResponse(response, projectIds);
};
function $8cb34e1a73991a89$export$f8e676bff6de4a13(location) {
    // Parse the location to extract the necessary parameters
    const projectKey = (0, $eQXnX.getProjectKeyFromLocation)(location);
    if (!projectKey) return false;
    // Use cached projectId if available, otherwise wait for SPA_STATE
    (0, $hWVxx.getProjectIdFromMap)(projectKey, (0, $2snMp.waitForGlobalVariable)).then((projectId)=>{
        if (projectId) // For now, we fetch issue types for the current project
        // This can be extended to handle multiple projects if needed
        $8cb34e1a73991a89$export$b27be2640a8307fd([
            String(projectId)
        ]);
    }).catch((error)=>{
        (0, $7U9nQ.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.project-id-mapping', 'Error fetching issue types', error instanceof Error ? error : new Error(String(error)));
    });
    return true;
}

});
parcelRegister("6wKnL", function(module, exports) {
$parcel$export(module.exports, "getIssueTypesForProjectsUrl", () => $f96c8e9f16c7c837$export$683fd3ef7e0e9232);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $f96c8e9f16c7c837$export$683fd3ef7e0e9232 = (projectIds)=>{
    const queryParams = new URLSearchParams();
    projectIds.forEach((projectId)=>{
        queryParams.append('projectId', projectId);
    });
    const operationParam = '&operation=GetIssueTypesForProjects';
    return `/rest/polaris/v2/project/settings/issuetype?${queryParams.toString()}${operationParam}`;
};

});



parcelRegister("gjqah", function(module, exports) {
$parcel$export(module.exports, "transformIssueTypeResponse", () => $0d1354ec03acbb6a$export$724e01f0c9c0f809);
$parcel$export(module.exports, "isUpdatingRemovedIssueTypeError", () => $0d1354ec03acbb6a$export$57621b943c7aa3fd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $75sVW = parcelRequire("75sVW");
const $0d1354ec03acbb6a$export$724e01f0c9c0f809 = (rest)=>({
        id: String(rest.id),
        name: rest.name,
        entityId: rest.entityId,
        description: rest.description,
        avatarId: String(rest.avatarId),
        avatarUrl: rest.avatarUrl,
        hierarchyLevel: rest.hierarchyLevel,
        operation: {
            deletable: rest.operation.deletable,
            editable: rest.operation.editable
        },
        pinnedFields: rest.pinnedFields
    });
const $0d1354ec03acbb6a$export$57621b943c7aa3fd = (errorObject)=>errorObject instanceof (0, $75sVW.default) && errorObject.statusCode === 412;

});



parcelRegister("fPMU6", function(module, exports) {
$parcel$export(module.exports, "clearIssueTypesStore", () => $efd86c60b274c5b7$export$45222ad122f02468);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $efd86c60b274c5b7$export$45222ad122f02468 = ()=>({ setState: setState })=>{
        setState({
            issueTypesById: {},
            issueTypesByProjectId: {}
        });
    };

});

parcelRegister("lHvZS", function(module, exports) {
$parcel$export(module.exports, "deleteIssueType", () => $8607e7c5f5908a21$export$5aaa67231e589913);

var $dSJEI = parcelRequire("dSJEI");

var $l28YB = parcelRequire("l28YB");

var $DrN5r = parcelRequire("DrN5r");

var $63gbl = parcelRequire("63gbl");

var $j85oP = parcelRequire("j85oP");

var $f6qTB = parcelRequire("f6qTB");

var $lCetP = parcelRequire("lCetP");

var $lOGR8 = parcelRequire("lOGR8");
const $8607e7c5f5908a21$export$5aaa67231e589913 = (issueTypeId, projectId)=>async ({ dispatch: dispatch })=>{
        (0, $j85oP.experience).issueTypes.issueTypeDelete.start();
        try {
            await (0, $lOGR8.performDeleteIssueType)(issueTypeId, projectId);
            dispatch($8607e7c5f5908a21$var$deleteIssueTypeFromStateOnly(issueTypeId));
            (0, $j85oP.experience).issueTypes.issueTypeDelete.success();
        } catch (maybeError) {
            const error = maybeError instanceof Error ? maybeError : new Error('Error while deleting issue type');
            if ((0, $f6qTB.isNotFoundError)(error)) {
                (0, $j85oP.experience).issueTypes.issueTypeDelete.abort();
                dispatch($8607e7c5f5908a21$var$deleteIssueTypeFromStateOnly(issueTypeId));
            } else if ((0, $lCetP.isClientFetchError)(error) || (0, $f6qTB.isConflictError)(error)) (0, $j85oP.experience).issueTypes.issueTypeDelete.abort();
            else (0, $j85oP.experience).issueTypes.issueTypeDelete.failure(error);
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.issue-types.actions.delete-issue-type', 'Failed to delete issue type', error);
            throw error;
        }
    };
const $8607e7c5f5908a21$var$deleteIssueTypeFromStateOnly = (issueTypeId)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            issueTypesById: (0, (/*@__PURE__*/$parcel$interopDefault($l28YB)))(state.issueTypesById, issueTypeId),
            issueTypesByProjectId: (0, (/*@__PURE__*/$parcel$interopDefault($dSJEI)))(state.issueTypesByProjectId, (issueTypeIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($DrN5r)))(issueTypeIds, issueTypeId))
        });
    };

});
parcelRegister("DrN5r", function(module, exports) {

var $6bRnp = parcelRequire("6bRnp");

var $citK5 = parcelRequire("citK5");

var $d72cD = parcelRequire("d72cD");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $0769334ab630a505$var$without = $citK5(function(array, values) {
    return $d72cD(array) ? $6bRnp(array, values) : [];
});
module.exports = $0769334ab630a505$var$without;

});

parcelRegister("lOGR8", function(module, exports) {
$parcel$export(module.exports, "performDeleteIssueType", () => $b5057fb3fc0b8a4d$export$228c421060a1ae62);
/* eslint-disable jira/filename-case */ 
var $h2wCv = parcelRequire("h2wCv");
const $b5057fb3fc0b8a4d$export$228c421060a1ae62 = (issueTypeId, projectId)=>{
    return (0, $h2wCv.performDeleteRequest)(`/rest/polaris/v2/project/${projectId}/settings/issuetype/${issueTypeId}`);
};

});


parcelRegister("j9kKr", function(module, exports) {
$parcel$export(module.exports, "fetchAllIssueTypes", () => $1d46cadada8715e8$export$95417ce5450f75ee);

var $3gOaP = parcelRequire("3gOaP");

var $63gbl = parcelRequire("63gbl");

var $jY3gt = parcelRequire("jY3gt");
const $1d46cadada8715e8$var$PAGE_SIZE = 100;
// The picker paginates by offset with no "isLast" signal, so arbitrary upper bound.
const $1d46cadada8715e8$var$MAX_PAGES = 50;
const $1d46cadada8715e8$var$toIssueType = ({ id: id, name: name, avatarId: avatarId, avatarUrl: avatarUrl })=>({
        id: id,
        name: name,
        description: '',
        avatarId: String(avatarId),
        avatarUrl: avatarUrl,
        entityId: '',
        hierarchyLevel: 0,
        operation: {
            deletable: false,
            editable: false
        }
    });
const $1d46cadada8715e8$export$95417ce5450f75ee = ()=>async ({ setState: setState, getState: getState })=>{
        try {
            const collected = [];
            for(let page = 0; page < $1d46cadada8715e8$var$MAX_PAGES; page++){
                // Offset pagination is inherently sequential
                // oxlint-disable-next-line no-await-in-loop
                const { issueTypes: issueTypes } = await (0, $jY3gt.performSearchIssueTypes)({
                    nameContains: '',
                    pagination: {
                        startAt: page * $1d46cadada8715e8$var$PAGE_SIZE,
                        max: $1d46cadada8715e8$var$PAGE_SIZE
                    }
                });
                collected.push(...issueTypes);
                if (issueTypes.length < $1d46cadada8715e8$var$PAGE_SIZE) break;
            }
            setState({
                issueTypesById: {
                    ...getState().issueTypesById,
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($3gOaP)))(collected.map($1d46cadada8715e8$var$toIssueType), ({ id: id })=>id)
                }
            });
        } catch (maybeError) {
            const error = maybeError instanceof Error ? maybeError : new Error('Error while fetching all issue types');
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.issue-types.actions.fetch-all-issue-types', 'Failed to fetch all issue types', error);
            throw error;
        }
    };

});
parcelRegister("jY3gt", function(module, exports) {
$parcel$export(module.exports, "performSearchIssueTypes", () => $73224a7a36dc8568$export$553560a2d8def9d4);
/* eslint-disable jira/filename-case */ 
var $h2wCv = parcelRequire("h2wCv");
const $73224a7a36dc8568$export$553560a2d8def9d4 = (request)=>(0, $h2wCv.performPostRequest)('/rest/polaris/v2/project/settings/issuetype/picker', {
        body: JSON.stringify(request)
    });

});


parcelRegister("g3iil", function(module, exports) {
$parcel$export(module.exports, "updatePinnedFields", () => $2653551981e7f469$export$dcb231762343ac0c);
$parcel$export(module.exports, "togglePinnedField", () => $2653551981e7f469$export$81a81e7b93f7de83);
$parcel$export(module.exports, "fetchPinnedFieldsForType", () => $2653551981e7f469$export$c973877177741503);

var $eVMQF = parcelRequire("eVMQF");

var $63gbl = parcelRequire("63gbl");

var $j85oP = parcelRequire("j85oP");

var $f6qTB = parcelRequire("f6qTB");

var $gXtG2 = parcelRequire("gXtG2");

var $lCetP = parcelRequire("lCetP");

var $uGlSk = parcelRequire("uGlSk");

var $8gfFd = parcelRequire("8gfFd");
const $2653551981e7f469$export$53a3736a37a8ee4 = 2000;
/**
 * Keeps the original state of pinned fields
 * (pre first unsent optimistic update) per issueTypeId.
 * Used for rolling back changes on error.
 */ const $2653551981e7f469$var$previousPinnedFieldsStateMap = new Map();
/**
 * Promise handlers waiting for the (debounced) persist per issueTypeId.
 * Every call within the debounce window shares one network request; all
 * returned promises resolve / reject together once it fires (only the last
 * rejects in case of an error).
 */ const $2653551981e7f469$var$pendingPinnedFieldsPromiseHandlersMap = new Map();
/**
 * A map that tracks pending debounced updates for pinned fields by issue type.
 */ const $2653551981e7f469$var$pendingPinnedFieldsUpdatesMap = new Map();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $2653551981e7f469$var$previousPinnedFieldsStateMap.clear();
    $2653551981e7f469$var$pendingPinnedFieldsPromiseHandlersMap.clear();
    $2653551981e7f469$var$pendingPinnedFieldsUpdatesMap.clear();
});
/**
 * Build (or reuse) a debounced function for an issue type
 */ const $2653551981e7f469$var$getDebouncedPerformUpdatePinnedFields = (issueTypeId)=>{
    let pendingPinnedFieldsUpdateForIssueType = $2653551981e7f469$var$pendingPinnedFieldsUpdatesMap.get(issueTypeId);
    if (pendingPinnedFieldsUpdateForIssueType) return pendingPinnedFieldsUpdateForIssueType;
    pendingPinnedFieldsUpdateForIssueType = (0, (/*@__PURE__*/$parcel$interopDefault($eVMQF)))(async ({ projectId: projectId, pinnedFields: pinnedFields, getState: getState, setState: setState })=>{
        // Snapshot current waiting handlers (may be empty).
        const handlers = $2653551981e7f469$var$pendingPinnedFieldsPromiseHandlersMap.get(issueTypeId) ?? [];
        try {
            await (0, $uGlSk.performUpdatePinnedFields)({
                projectId: projectId,
                issueTypeId: issueTypeId,
                pinnedFields: pinnedFields
            });
            handlers.forEach(({ resolve: resolve })=>resolve());
            (0, $j85oP.experience).issueTypes.issueTypePinnedFieldsUpdate.success();
        } catch (maybeError) {
            const error = maybeError instanceof Error ? maybeError : new Error('Error while updating pinned fields');
            if ((0, $lCetP.isClientFetchError)(error) || (0, $f6qTB.isNotFoundError)(error)) (0, $j85oP.experience).issueTypes.issueTypePinnedFieldsUpdate.abort(error);
            else (0, $j85oP.experience).issueTypes.issueTypePinnedFieldsUpdate.failure(error);
            // Roll back only pinnedFields (avoid stomping other parallel optimistic changes)
            const previousPinnedFieldsState = $2653551981e7f469$var$previousPinnedFieldsStateMap.get(issueTypeId);
            if (previousPinnedFieldsState) {
                const state = getState();
                if (state.issueTypesById[issueTypeId]) setState({
                    issueTypesById: {
                        ...state.issueTypesById,
                        [issueTypeId]: {
                            ...state.issueTypesById[issueTypeId],
                            pinnedFields: previousPinnedFieldsState
                        }
                    }
                });
            }
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.issue-types.actions.update-pinned-field', 'Failed to update pinned fields', error);
            // Reject only the last caller so that UI can show a single error screen;
            // resolve the rest (they already got optimistic rollback).
            handlers.forEach(({ reject: reject, resolve: resolve }, index)=>{
                if (index === handlers.length - 1) reject(error);
                else resolve();
            });
        } finally{
            $2653551981e7f469$var$pendingPinnedFieldsUpdatesMap.delete(issueTypeId);
            $2653551981e7f469$var$previousPinnedFieldsStateMap.delete(issueTypeId);
            $2653551981e7f469$var$pendingPinnedFieldsPromiseHandlersMap.delete(issueTypeId);
        }
    }, $2653551981e7f469$export$53a3736a37a8ee4);
    $2653551981e7f469$var$pendingPinnedFieldsUpdatesMap.set(issueTypeId, pendingPinnedFieldsUpdateForIssueType);
    return pendingPinnedFieldsUpdateForIssueType;
};
const $2653551981e7f469$export$dcb231762343ac0c = ({ issueTypeId: issueTypeId, pinnedFields: pinnedFields })=>({ setState: setState, getState: getState })=>{
        return new Promise((resolve, reject)=>{
            const state = getState();
            try {
                const issueType = state.issueTypesById[issueTypeId];
                if (!issueType) throw new Error(`Issue type with ID ${issueTypeId} not found`);
                const projectId = Object.keys(state.issueTypesByProjectId).find((id)=>state.issueTypesByProjectId[id]?.includes(issueTypeId));
                if (!projectId) throw new Error(`Project ID for issue type ${issueTypeId} not found`);
                // Take snapshot only the first time within a pending debounce window
                if (!$2653551981e7f469$var$previousPinnedFieldsStateMap.has(issueTypeId)) {
                    $2653551981e7f469$var$previousPinnedFieldsStateMap.set(issueTypeId, issueType.pinnedFields ?? []);
                    (0, $j85oP.experience).issueTypes.issueTypePinnedFieldsUpdate.start();
                }
                setState({
                    issueTypesById: {
                        ...state.issueTypesById,
                        [issueTypeId]: {
                            ...issueType,
                            pinnedFields: pinnedFields
                        }
                    }
                });
                // Register handlers for this cycle
                const handlers = $2653551981e7f469$var$pendingPinnedFieldsPromiseHandlersMap.get(issueTypeId);
                if (handlers) handlers.push({
                    resolve: resolve,
                    reject: reject
                });
                else $2653551981e7f469$var$pendingPinnedFieldsPromiseHandlersMap.set(issueTypeId, [
                    {
                        resolve: resolve,
                        reject: reject
                    }
                ]);
                // Schedule / refresh debounced call
                $2653551981e7f469$var$getDebouncedPerformUpdatePinnedFields(issueTypeId)({
                    projectId: projectId,
                    pinnedFields: pinnedFields,
                    getState: getState,
                    setState: setState
                });
            } catch (error) {
                (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.issue-types.actions.update-pinned-field', 'Failed to update pinned fields', error instanceof Error ? error : new Error('Error while updating pinned fields'));
                reject(error);
            }
        });
    };
const $2653551981e7f469$export$81a81e7b93f7de83 = ({ issueTypeId: issueTypeId, fieldKey: fieldKey })=>async ({ getState: getState, dispatch: dispatch })=>{
        const state = getState();
        const pinnedFields = state.issueTypesById[issueTypeId]?.pinnedFields ?? [];
        const isPinned = pinnedFields.includes(fieldKey);
        const updatedPinnedFields = isPinned ? pinnedFields.filter((key)=>key !== fieldKey) : [
            ...pinnedFields,
            fieldKey
        ];
        await dispatch($2653551981e7f469$export$dcb231762343ac0c({
            issueTypeId: issueTypeId,
            pinnedFields: updatedPinnedFields
        }));
    };
const $2653551981e7f469$export$c973877177741503 = ({ issueTypeId: issueTypeId, projectId: projectId })=>async ({ setState: setState, getState: getState })=>{
        try {
            (0, $j85oP.experience).issueTypes.issueTypePinnedFieldsLoad.start();
            const { pinnedFields: pinnedFields } = await (0, $8gfFd.performGetPinnedFieldsForType)({
                issueTypeId: issueTypeId,
                projectId: projectId
            });
            const state = getState();
            if (state.issueTypesById[issueTypeId]) setState({
                issueTypesById: {
                    ...state.issueTypesById,
                    [issueTypeId]: {
                        ...state.issueTypesById[issueTypeId],
                        pinnedFields: pinnedFields
                    }
                }
            });
            (0, $j85oP.experience).issueTypes.issueTypePinnedFieldsLoad.success();
        } catch (maybeError) {
            const error = maybeError instanceof Error ? maybeError : new Error('Error while fetching pinned fields for type');
            if ((0, $lCetP.isClientFetchError)(error)) (0, $j85oP.experience).issueTypes.issueTypePinnedFieldsLoad.abort(error);
            else (0, $j85oP.experience).issueTypes.issueTypePinnedFieldsLoad.failure(error);
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.issue-types.actions.fetch-pinned-fields', 'Failed to fetch pinned fields for issue type', error);
            throw error;
        }
    };

});
parcelRegister("uGlSk", function(module, exports) {
$parcel$export(module.exports, "performUpdatePinnedFields", () => $ee52cedbb87bbce1$export$1131639a53d9c2dc);
/* eslint-disable jira/filename-case */ 
var $h2wCv = parcelRequire("h2wCv");
const $ee52cedbb87bbce1$export$1131639a53d9c2dc = ({ projectId: projectId, issueTypeId: issueTypeId, pinnedFields: pinnedFields })=>(0, $h2wCv.performPutRequest)(`/rest/polaris/v2/project/${projectId}/settings/issuetype/${issueTypeId}/pinned-fields`, {
        body: JSON.stringify({
            pinnedFields: pinnedFields
        })
    });

});

parcelRegister("8gfFd", function(module, exports) {
$parcel$export(module.exports, "performGetPinnedFieldsForType", () => $f39797002a06dd70$export$ef76b82000a4627e);
/* eslint-disable jira/filename-case */ 
var $4fhEY = parcelRequire("4fhEY");
const $f39797002a06dd70$export$ef76b82000a4627e = ({ issueTypeId: issueTypeId, projectId: projectId })=>(0, $4fhEY.default)(`/rest/polaris/v2/project/${projectId}/settings/issuetype/${issueTypeId}/pinned-fields`);

});


parcelRegister("3qB6r", function(module, exports) {
$parcel$export(module.exports, "populateIssueTypes", () => $c08454148f072da0$export$f3fcdeef00a622aa);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $c08454148f072da0$export$f3fcdeef00a622aa = ({ issueTypes: issueTypes })=>async ({ setState: setState, getState: getState })=>{
        const issueTypesById = {};
        const issueTypesByProjectId = {};
        issueTypes.forEach((issueType)=>{
            const existingIssueType = getState().issueTypesById[issueType.id];
            issueTypesById[issueType.id] = {
                ...existingIssueType,
                ...issueType,
                operation: existingIssueType?.operation ?? issueType.operation
            };
            if (!issueTypesByProjectId[issueType.projectId]) issueTypesByProjectId[issueType.projectId] = [
                ...getState().issueTypesByProjectId[issueType.projectId] ?? []
            ];
            if (!issueTypesByProjectId[issueType.projectId].includes(issueType.id)) issueTypesByProjectId[issueType.projectId].push(issueType.id);
        });
        setState({
            issueTypesById: {
                ...getState().issueTypesById,
                ...issueTypesById
            },
            issueTypesByProjectId: {
                ...getState().issueTypesByProjectId,
                ...issueTypesByProjectId
            }
        });
    };

});

parcelRegister("kwMVo", function(module, exports) {
$parcel$export(module.exports, "updateIssueType", () => $f10d251468aaceea$export$7c611e2970463da4);

var $63gbl = parcelRequire("63gbl");

var $j85oP = parcelRequire("j85oP");

var $f6qTB = parcelRequire("f6qTB");

var $lCetP = parcelRequire("lCetP");

var $9S98R = parcelRequire("9S98R");

var $gjqah = parcelRequire("gjqah");
const $f10d251468aaceea$export$7c611e2970463da4 = (issueTypeId, projectId, update)=>async ({ setState: setState, getState: getState })=>{
        (0, $j85oP.experience).issueTypes.issueTypeUpdate.start();
        const state = getState();
        const currentIssueType = state.issueTypesById[issueTypeId];
        if (!currentIssueType) return;
        setState({
            issueTypesById: {
                ...state.issueTypesById,
                [issueTypeId]: {
                    ...currentIssueType,
                    ...update
                }
            }
        });
        try {
            await (0, $9S98R.performUpdateIssueType)(issueTypeId, projectId, {
                name: update.name,
                description: update.description,
                avatarId: Number(update.avatarId)
            });
            (0, $j85oP.experience).issueTypes.issueTypeUpdate.success();
        } catch (maybeError) {
            const error = maybeError instanceof Error ? maybeError : new Error('Error while updating issue type');
            if ((0, $lCetP.isClientFetchError)(error) || (0, $f6qTB.isConflictError)(error) || (0, $gjqah.isUpdatingRemovedIssueTypeError)(error)) (0, $j85oP.experience).issueTypes.issueTypeUpdate.abort();
            else (0, $j85oP.experience).issueTypes.issueTypeUpdate.failure(error);
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.issue-types.actions.update-issue-type', 'Failed to update issue type', error);
            setState(state);
            throw error;
        }
    };

});
parcelRegister("9S98R", function(module, exports) {
$parcel$export(module.exports, "performUpdateIssueType", () => $63664e6a67a3743a$export$8faf8e16b0bcf0b3);
/* eslint-disable jira/filename-case */ 
var $h2wCv = parcelRequire("h2wCv");
const $63664e6a67a3743a$export$8faf8e16b0bcf0b3 = (issueTypeId, projectId, update)=>{
    return (0, $h2wCv.performPutRequest)(`/rest/polaris/v2/project/${projectId}/settings/issuetype/${issueTypeId}`, {
        body: JSON.stringify(update)
    });
};

});




parcelRegister("84wJV", function(module, exports) {
$parcel$export(module.exports, "IssueTypeAvatar", () => $1435b84128b95079$export$8d42ebda734216f7);

var $euxye = parcelRequire("euxye");
const $1435b84128b95079$export$e5a269c2eaf3cbbd = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40
};
const $1435b84128b95079$export$8d42ebda734216f7 = ({ avatarUrl: avatarUrl, size: size, name: name = '' })=>{
    const sizeInPx = $1435b84128b95079$export$e5a269c2eaf3cbbd[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("img", {
        src: avatarUrl,
        alt: name,
        width: sizeInPx,
        height: sizeInPx
    });
};
$1435b84128b95079$export$8d42ebda734216f7.displayName = "IssueTypeAvatar";

});




parcelRegister("8hGNs", function(module, exports) {
$parcel$export(module.exports, "EmojiWrapper", () => $3865d19a842fb112$export$e31a6cc0a4c97f0e);
/* EmojiWrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");
const $3865d19a842fb112$export$e31a6cc0a4c97f0e = ({ standalone: standalone, color: color, children: children, className: className, withTagDecoration: withTagDecoration })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            backgroundColor: color
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $4jQY2.default)([
            "_1reo15vq _18m915vq _nd5l2ec4 _1bsb1tcg _4t3iqslr _vchhusvi _1e0c1txw _4cvr1h6o _1bah1h6o",
            standalone && "_2rkofajl",
            !standalone && "_2rko458z",
            withTagDecoration && (0, $i860n.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_1bsbgktf _4t3igktf _uwhke4h9 _15a5nqa1 _1i531l7x _gx38e4h9 _ngwonqa1 _14vn1l7x _1doce4h9 _1il9nqa1 _1o3i1l7x _1ej8idpf",
            className
        ])
    }, children);
};
$3865d19a842fb112$export$e31a6cc0a4c97f0e.displayName = "EmojiWrapper";
const $3865d19a842fb112$var$wrapperStyles = null;
const $3865d19a842fb112$var$borderRadiusStandalone = null;
const $3865d19a842fb112$var$borderRadiusNonStandalone = null;
const $3865d19a842fb112$var$tagDecorationStyles = null;

});


parcelRegister("iVCI5", function(module, exports) {
$parcel$export(module.exports, "ExpandableSection", () => $6aa43148f7144646$export$e86ef41bc845761);
/* ExpandableSection.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $ld25x = parcelRequire("ld25x");

var $aFpts = parcelRequire("aFpts");

var $ihEDU = parcelRequire("ihEDU");

var $8Sdzy = parcelRequire("8Sdzy");

var $6mEZn = parcelRequire("6mEZn");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");
const $6aa43148f7144646$var$toggleButtonLabel = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-expandable-section.toggle-button-label",
    defaultMessage: "Toggle"
});
const $6aa43148f7144646$var$styles = {
    container: "_zulpu2gc _2rko12b0 _1e0c1txw _2lx21bp4 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
    header: "_zulp1b66 _1e0c1txw _1bah1yb4 _4cvr1h6o _80omtlke _bfhk18uv _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t"
};
const $6aa43148f7144646$export$e86ef41bc845761 = ({ title: title, onToggle: onToggle, children: children, backgroundColor: backgroundColor = 'color.background.accent.yellow.subtlest', testId: testId = 'polaris-lib-expandable-section.ui', initialIsExpanded: initialIsExpanded = false })=>{
    const [isExpanded, setIsExpanded] = (0, $euxye.useState)(initialIsExpanded);
    const ToggleIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($aFpts))) : (0, (/*@__PURE__*/$parcel$interopDefault($ld25x)));
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const handleToggleClick = ()=>{
        setIsExpanded((prevIsExpanded)=>{
            onToggle?.(!prevIsExpanded);
            return !prevIsExpanded;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        testId: testId,
        xcss: $6aa43148f7144646$var$styles.container,
        backgroundColor: backgroundColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6mEZn.Pressable), {
        xcss: $6aa43148f7144646$var$styles.header,
        onClick: handleToggleClick,
        ...(0, $i860n.fg)('polaris_a11y_fixes_270726') && {
            'aria-expanded': isExpanded
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, title), (0, $i860n.fg)('jpd_roadmap_publish_fe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ToggleIcon, {
        testId: `${testId}.toggle-button`,
        label: formatMessage($6aa43148f7144646$var$toggleButtonLabel),
        color: "var(--ds-icon, #292A2E)",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
        testId: `${testId}.toggle-button`,
        appearance: "subtle",
        label: formatMessage($6aa43148f7144646$var$toggleButtonLabel),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ToggleIcon, {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)",
                size: "small"
            })
    })), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children));
};
$6aa43148f7144646$export$e86ef41bc845761.displayName = "ExpandableSection";

});



parcelRegister("1kCfQ", function(module, exports) {
$parcel$export(module.exports, "RoadmapFavoriteSubmenu", () => $3a8472918b40dc5b$export$3cdc259a3ef9c28a);

var $5Ytw6 = parcelRequire("5Ytw6");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");


var $9d48B = parcelRequire("9d48B");

var $fbAgT = parcelRequire("fbAgT");

var $g36LP = parcelRequire("g36LP");

var $kaswN = parcelRequire("kaswN");

var $7WrJq = parcelRequire("7WrJq");

var $hLi02 = parcelRequire("hLi02");
/**
 * Inner component that renders the ReorderActionsRenderer.
 * Extracted to isolate the useRoadmapReorderingIds hook call,
 * so it only runs when reordering data is provided.
 */ const $3a8472918b40dc5b$var$RoadmapReorderActions = ({ currentItems: currentItems, currentOrder: currentOrder, item: item, onClose: onClose })=>{
    const { entityAri: entityAri, ownerAri: ownerAri } = (0, $hLi02.useRoadmapReorderingIds)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7WrJq.useDragAndDropReorderingAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fbAgT.ReorderActionsRenderer), {
        currentItems: currentItems,
        currentOrder: currentOrder,
        entityAri: entityAri,
        ownerAri: ownerAri,
        fireAnalyticsEvent: fireAnalyticsEvent,
        item: item,
        onClose: onClose
    });
};
$3a8472918b40dc5b$var$RoadmapReorderActions.displayName = "RoadmapReorderActions";
const $3a8472918b40dc5b$export$3cdc259a3ef9c28a = ({ collectionQueryRefFragment: collectionQueryRefFragment, currentItems: currentItems, currentOrder: currentOrder, item: item, onClose: onClose })=>{
    const collectionFavouriteItem = (0, $n67Vb.useFragment)((0, $5Ytw6.default), collectionQueryRefFragment);
    const { fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle } = (0, $euxye.useContext)((0, $kaswN.AnalyticContext));
    const isFavourite = Boolean(collectionFavouriteItem?.favouriteValue?.isFavourite);
    const handleFavouriteClick = (0, $euxye.useCallback)(()=>{
        fireUIAnalyticForFavouriteToggle({
            starType: isFavourite ? (0, $c6c6aa7a150fa522$export$5fe513938f2c4081) : (0, $c6c6aa7a150fa522$export$54408be40394d82a),
            parentItemId: String(collectionFavouriteItem.collectionId)
        });
    }, [
        collectionFavouriteItem.collectionId,
        fireUIAnalyticForFavouriteToggle,
        isFavourite
    ]);
    const handleClose = (0, $euxye.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9d48B.FavoriteToggleButton), {
        entityId: collectionFavouriteItem.id,
        defaultIsStarred: isFavourite,
        entityTypeName: "JiraProductDiscoveryCollection",
        onClick: handleFavouriteClick
    }), currentItems && currentOrder && item ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3a8472918b40dc5b$var$RoadmapReorderActions, {
        currentItems: currentItems,
        currentOrder: currentOrder,
        item: item,
        onClose: handleClose
    }) : null);
};
$3a8472918b40dc5b$export$3cdc259a3ef9c28a.displayName = "RoadmapFavoriteSubmenu";

});
parcelRegister("5Ytw6", function(module, exports) {
$parcel$export(module.exports, "default", () => $afab49d510337340$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<27873417dd4a7331d3b0fab17548f459>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $afab49d510337340$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RoadmapFavoriteSubmenu_collection",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "collectionId"
            },
            "action": "THROW"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                }
            ]
        }
    ],
    "type": "JiraProductDiscoveryCollection"
};
$afab49d510337340$var$node.hash = "7add7039427714d8a4e0f72ca65c89fc";
var $afab49d510337340$export$2e2bcd8739ae039 = $afab49d510337340$var$node;

});

/* eslint-disable jira/filename-case */ const $c6c6aa7a150fa522$export$54408be40394d82a = 'star';
const $c6c6aa7a150fa522$export$5fe513938f2c4081 = 'unstar';

parcelRegister("7WrJq", function(module, exports) {
$parcel$export(module.exports, "useDragAndDropReorderingAnalytics", () => $e3538db51cc9c7ce$export$80e7e0bb79f001f0);



var $bOwox = parcelRequire("bOwox");

var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
const $e3538db51cc9c7ce$export$80e7e0bb79f001f0 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireAnalyticsEvent = ({ action: action, itemId: itemId, operation: operation, successfulReorder: successfulReorder })=>{
        const analyticsEvent = createAnalyticsEvent({});
        const baseAttributes = {
            level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
            componentType: 'customItem',
            itemType: (0, $687cb22024c607c7$export$bb8a37ab8d9ba82b),
            section: (0, $bOwox.SECTION_ITEM_STARRED),
            itemId: itemId
        };
        if (action === 'updated') (0, $aJ81Y.fireTrackAnalytics)(analyticsEvent, {
            action: action,
            actionSubject: 'sidebarNavigationItems',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_ROADMAPS],
            attributes: {
                ...baseAttributes,
                itemId: itemId,
                action: operation
            }
        });
        else (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, {
            action: action,
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_ROADMAPS],
            attributes: {
                ...baseAttributes,
                itemId: itemId,
                successfulReorder: successfulReorder
            }
        });
    };
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};

});




parcelRegister("20Qwn", function(module, exports) {
$parcel$export(module.exports, "RoadmapItemViews", () => $6cdc20611c763ae3$export$8c65ba25c86b0626);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $7SOt3 = parcelRequire("7SOt3");

var $kmMHr = parcelRequire("kmMHr");

var $hw2CY = parcelRequire("hw2CY");

var $lwxMv = parcelRequire("lwxMv");

var $gZM30 = parcelRequire("gZM30");

var $29ILa = parcelRequire("29ILa");

var $78GR0 = parcelRequire("78GR0");

var $bVDHZ = parcelRequire("bVDHZ");
const $6cdc20611c763ae3$export$8c65ba25c86b0626 = ({ navigationCollection: navigationCollection })=>{
    const { loadViews: loadViews } = (0, $kmMHr.useNavigationActions)();
    (0, $euxye.useEffect)(()=>{
        loadViews();
    }, [
        loadViews
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hw2CY.JpdNavViews), {
        name: "jpd-roadmaps",
        sectionsEnabled: true,
        containerTypePermissions: "project",
        container: navigationCollection,
        viewsEntityLimitType: (0, $7SOt3.ENTITY_LIMIT_TYPE).VIEWS_PER_COLLECTION,
        viewsetsEntityLimitType: (0, $7SOt3.ENTITY_LIMIT_TYPE).VIEWSETS_PER_COLLECTION,
        getViewUrl: (0, $78GR0.getViewUrl),
        dragDropEnabled: true,
        useIsReadOnly: (0, $bVDHZ.useIsReadOnly),
        useAnalyticsL2: (0, $lwxMv.useRoadmapsAnalyticsL2),
        useAnalyticsL3: (0, $gZM30.useRoadmapsAnalyticsL3),
        useAnalyticsL4: (0, $29ILa.useRoadmapsAnalyticsL4)
    });
};
$6cdc20611c763ae3$export$8c65ba25c86b0626.displayName = "RoadmapItemViews";

});
parcelRegister("hw2CY", function(module, exports) {
$parcel$export(module.exports, "JpdNavViews", () => $12cf105590797133$export$416b335925b966cb);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $b6UH6 = parcelRequire("b6UH6");

var $3kW31 = parcelRequire("3kW31");

var $2D2gW = parcelRequire("2D2gW");

var $djYhH = parcelRequire("djYhH");

var $ar9gx = parcelRequire("ar9gx");

var $atbVz = parcelRequire("atbVz");

var $hj9Qm = parcelRequire("hj9Qm");

var $hU0Hv = parcelRequire("hU0Hv");

var $kn1Fi = parcelRequire("kn1Fi");
const $12cf105590797133$var$JpdNavViewsMain = /*#__PURE__*/ (0, $euxye.memo)(({ navigationContainer: navigationContainer, forceLoading: forceLoading, dragDropEnabled: dragDropEnabled, renderComponentAfter: renderComponentAfter })=>{
    const containerId = (0, $hj9Qm.useContainerId)();
    const [isNavigationLoading] = (0, $3kW31.useIsNavigationLoading)({
        containerId: containerId
    });
    const [isNavigationLocked] = (0, $3kW31.useIsNavigationLocked)({
        containerId: containerId
    });
    const [isNavigationInitialized] = (0, $3kW31.useIsNavigationInitialized)({
        containerId: containerId
    });
    const handleFetch = (0, $euxye.useCallback)(()=>{
        return Promise.resolve();
    }, []);
    const menuItems = (0, $euxye.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kn1Fi.MenuItems), {
            navigationContainer: navigationContainer,
            dragDropEnabled: dragDropEnabled
        });
    }, [
        navigationContainer,
        dragDropEnabled
    ]);
    const isFetching = forceLoading || isNavigationLoading || !isNavigationInitialized;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hU0Hv.MenuContainer), {
        isLocked: isNavigationLocked
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b6UH6.L1ExpandableMenuItemSubmenu), {
        fetch: handleFetch,
        isFetching: isFetching,
        MenuItems: menuItems
    }), isFetching && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
        name: "jpd.nav4-menu-loading"
    })))), renderComponentAfter && renderComponentAfter(isNavigationInitialized, isFetching));
});
const $12cf105590797133$export$416b335925b966cb = ({ name: name, container: container, dragDropEnabled: dragDropEnabled, sectionsEnabled: sectionsEnabled, containerTypePermissions: containerTypePermissions, forceLoading: forceLoading, viewsEntityLimitType: viewsEntityLimitType, viewsetsEntityLimitType: viewsetsEntityLimitType, renderComponentAfter: renderComponentAfter, getViewUrl: getViewUrl, useIsReadOnly: useIsReadOnly, useAnalyticsL2: useAnalyticsL2, useAnalyticsL3: useAnalyticsL3, useAnalyticsL4: useAnalyticsL4 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $atbVz.JpdNavViewsContainer), {
        name: name,
        container: container,
        viewsEntityLimitType: viewsEntityLimitType,
        viewsetsEntityLimitType: viewsetsEntityLimitType,
        sectionsEnabled: sectionsEnabled,
        containerTypePermissions: containerTypePermissions,
        getViewUrl: getViewUrl,
        useIsReadOnly: useIsReadOnly,
        useAnalyticsL2: useAnalyticsL2,
        useAnalyticsL3: useAnalyticsL3,
        useAnalyticsL4: useAnalyticsL4
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($12cf105590797133$var$JpdNavViewsMain, {
        navigationContainer: container,
        dragDropEnabled: dragDropEnabled,
        forceLoading: forceLoading,
        renderComponentAfter: renderComponentAfter
    }));
};
$12cf105590797133$export$416b335925b966cb.displayName = "JpdNavViews";

});
parcelRegister("hU0Hv", function(module, exports) {
$parcel$export(module.exports, "MenuContainer", () => $49a13cb36200177b$export$b286f91cddfedb5a);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $dFtgX = parcelRequire("dFtgX");
const $49a13cb36200177b$export$b286f91cddfedb5a = ({ children: children, isLocked: isLocked })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: [
            $49a13cb36200177b$var$position,
            isLocked ? $49a13cb36200177b$var$locked : undefined
        ]
    }, children, isLocked && // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dFtgX.LoadingSpinner), {
        testId: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.menu-container.loading-spinner"
    }));
$49a13cb36200177b$export$b286f91cddfedb5a.displayName = "MenuContainer";
const $49a13cb36200177b$var$position = (0, $fbAgj.xcss)({
    position: 'relative'
});
const $49a13cb36200177b$var$locked = (0, $fbAgj.xcss)({
    opacity: 0.5
});

});
parcelRegister("dFtgX", function(module, exports) {
$parcel$export(module.exports, "LoadingSpinner", () => $6fa1362f8368d56f$export$b08b517936747730);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $abhF2 = parcelRequire("abhF2");
const $6fa1362f8368d56f$export$b08b517936747730 = ({ testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $6fa1362f8368d56f$var$styles,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), null));
$6fa1362f8368d56f$export$b08b517936747730.displayName = "LoadingSpinner";
const $6fa1362f8368d56f$var$styles = (0, $fbAgj.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 'space.0',
    width: '100%',
    height: '100%',
    zIndex: 'blanket'
});

});


parcelRegister("kn1Fi", function(module, exports) {
$parcel$export(module.exports, "MenuItems", () => $b7d5f5d5b8d9d10f$export$15a41fea157b048a);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3kW31 = parcelRequire("3kW31");

var $hj9Qm = parcelRequire("hj9Qm");

var $jW990 = parcelRequire("jW990");
const $b7d5f5d5b8d9d10f$export$15a41fea157b048a = ({ navigationContainer: navigationContainer, dragDropEnabled: dragDropEnabled })=>{
    const containerId = (0, $hj9Qm.useContainerId)();
    const [views] = (0, $3kW31.useNavigationViews)({
        containerId: containerId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jW990.Views), {
        navigationContainer: navigationContainer,
        views: views,
        dragDropEnabled: dragDropEnabled
    });
};
$b7d5f5d5b8d9d10f$export$15a41fea157b048a.displayName = "MenuItems";

});
parcelRegister("jW990", function(module, exports) {
$parcel$export(module.exports, "Views", () => $8c86b0b293c23b04$export$5cb791131c501f6a);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");

var $kmMHr = parcelRequire("kmMHr");

var $lvSVm = parcelRequire("lvSVm");

var $i860n = parcelRequire("i860n");

var $deOYh = parcelRequire("deOYh");

var $hj9Qm = parcelRequire("hj9Qm");

var $lzkou = parcelRequire("lzkou");

var $8BknK = parcelRequire("8BknK");

var $BhWi0 = parcelRequire("BhWi0");

var $fzLeF = parcelRequire("fzLeF");
// Resolve a section's server id from its localId, used to nest template views into the section
const $8c86b0b293c23b04$var$getSectionId = (views, localId)=>views.find((view)=>view.localId === localId)?.id;
const $8c86b0b293c23b04$export$5cb791131c501f6a = /*#__PURE__*/ (0, $euxye.memo)(({ views: views, navigationContainer: navigationContainer, parentId: parentId, dragDropEnabled: dragDropEnabled = true })=>{
    const canManageViews = (0, $hj9Qm.useJpdNavCanManageViews)();
    const containerId = (0, $hj9Qm.useContainerId)();
    const { toggleView: toggleView, rankView: rankView } = (0, $kmMHr.useNavigationActions)();
    const [renderLimit, setRenderLimit] = (0, $euxye.useState)(Math.min(20, views.length));
    const viewRenderLimit = renderLimit || views.length;
    (0, $euxye.useEffect)(()=>{
        // After the component is mounted, we set the renderLimit to null so it can render the remaining items
        (0, $euxye.startTransition)(()=>{
            setRenderLimit(null);
        });
    }, []);
    // Limit the number of views to render if viewRenderLimit is provided
    const limitedViews = (0, $euxye.useMemo)(()=>{
        return views.slice(0, viewRenderLimit);
    }, [
        views,
        viewRenderLimit
    ]);
    const tree = (0, $euxye.useMemo)(()=>(0, $deOYh.createTree)(limitedViews), [
        limitedViews
    ]);
    const globalViewLocalIds = (0, $euxye.useMemo)(()=>{
        const ids = [];
        if (!(0, $i860n.fg)('polaris_global_views')) return ids;
        views.forEach((view)=>{
            if (view.global) ids.push(view.localId);
        });
        return ids;
    }, [
        views
    ]);
    const handleToggle = (0, $euxye.useCallback)((id)=>{
        if (!tree) return;
        toggleView(id);
    }, [
        tree,
        toggleView
    ]);
    const renderItem = (0, $euxye.useCallback)(({ item: item, draggableState: draggableState, onExpand: onExpand, onCollapse: onCollapse })=>{
        const itemType = item.data?.type;
        const isDraggingPreview = draggableState === 'preview';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, itemType === 'section' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fzLeF.ViewSet), {
            onToggle: item.isExpanded ? onCollapse : onExpand,
            isExpanded: item.isExpanded || false,
            localId: item?.id,
            navigationContainer: navigationContainer,
            isDraggingPreview: isDraggingPreview,
            isReadOnly: !canManageViews
        }), itemType === 'view' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lzkou.ViewItem), {
            navigationContainer: navigationContainer,
            localId: item?.id,
            isDraggingPreview: isDraggingPreview
        }), itemType === 'placeholder' && canManageViews && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8BknK.CreateViewMenuItem), {
            container: item?.data.parentId,
            sectionId: (0, $i860n.fg)('pol-21863_refresh_views') ? $8c86b0b293c23b04$var$getSectionId(views, item?.data.parentId) : undefined,
            navigationContainer: navigationContainer
        }));
    }, [
        navigationContainer,
        canManageViews,
        views
    ]);
    const onDragEnd = (0, $euxye.useCallback)((source, destination, isExpandedBeforeDrag)=>{
        if (!tree || !destination) return;
        // Moved item id
        const id = tree.items[source.parentId].children[source.index];
        // Do not allow dropping sections inside sections
        const itemType = tree.items[id]?.data?.type;
        const dstItemType = tree.items[destination.parentId]?.data?.type;
        if (itemType === 'section' && dstItemType === 'section') return;
        // Do not allow dropping placeholders
        if (itemType === 'placeholder' || dstItemType === 'placeholder') return;
        // Do not allow merging views
        if (dstItemType === 'view') return;
        // Do not allow dropping before or between global views — they remain static at the top
        if ((0, $i860n.fg)('polaris_global_views')) {
            const isDroppedOnRootLevel = destination.parentId === tree.rootId;
            const isDroppedBeforeGlobalView = (destination.index ?? 0) < globalViewLocalIds.length;
            if (isDroppedOnRootLevel && isDroppedBeforeGlobalView) return;
        }
        const { parentId: destinationParentId } = destination;
        // Save view ranks.
        rankView({
            id: id,
            parentId: tree.items[destinationParentId].id,
            srcParentId: tree.items[source.parentId].id,
            index: destination.index ?? 0,
            isExpandedBeforeDrag: isExpandedBeforeDrag
        });
    }, [
        rankView,
        tree,
        globalViewLocalIds
    ]);
    const isGlobalView = (0, $euxye.useCallback)((item)=>globalViewLocalIds.includes(item.id), [
        globalViewLocalIds
    ]);
    // Allow dragging for a specific elements and only for a project admin (except for global views)
    const isDragEnabled = (0, $euxye.useCallback)((item)=>canManageViews && item.data?.type !== 'placeholder' && dragDropEnabled && // Global views cannot be reordered in a project's navigation
        !(isGlobalView(item) && (0, $i860n.fg)('polaris_global_views')), [
        canManageViews,
        dragDropEnabled,
        isGlobalView
    ]);
    // Disable dropping for placeholders and global views (to hide the drop indicator on them)
    const isDropEnabled = (0, $euxye.useCallback)((item)=>canManageViews && item.data?.type !== 'placeholder' && dragDropEnabled && !(isGlobalView(item) && (0, $i860n.fg)('polaris_global_views')), [
        canManageViews,
        dragDropEnabled,
        isGlobalView
    ]);
    if (!tree) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lvSVm.Tree), {
        tree: tree,
        itemType: `tree-item-${containerId}`,
        TreeItemContainer: (0, $BhWi0.TreeItemContainer),
        TreeItemHead: (0, $BhWi0.TreeItemHead),
        TreeItemParentContainer: (0, $BhWi0.TreeItemParentContainer),
        renderItem: renderItem,
        onExpand: handleToggle,
        onCollapse: handleToggle,
        onDragEnd: onDragEnd,
        isDragEnabled: isDragEnabled,
        isDropEnabled: isDropEnabled,
        indentPerLevel: 0
    }), canManageViews && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8BknK.CreateViewMenuItem), {
        container: parentId,
        navigationContainer: navigationContainer,
        enableSpotlight: true
    }));
}, (0, (/*@__PURE__*/$parcel$interopDefault($bxhpq))));

});
parcelRegister("lvSVm", function(module, exports) {
$parcel$export(module.exports, "Tree", () => $ae641a51f4847142$export$7fbedc92909ed28e);
/* eslint-disable jira/filename-case */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $7ohZu = parcelRequire("7ohZu");

var $l7nPt = parcelRequire("l7nPt");

var $3nfFb = parcelRequire("3nfFb");

var $ihEDU = parcelRequire("ihEDU");

var $59k7o = parcelRequire("59k7o");

var $6CZ2k = parcelRequire("6CZ2k");

var $1fWai = parcelRequire("1fWai");
const $ae641a51f4847142$var$DEFAULR_INDENT_PER_LEVEL = 24;
const $ae641a51f4847142$var$DEFAULT_ITEM_TYPE = 'tree-item';
const $ae641a51f4847142$var$Child = ({ item: item, pathToParent: pathToParent, parentId: parentId, index: index, parentLevel: parentLevel, isLastInGroup: isLastInGroup, TreeItemComponent: TreeItemComponent, ...shared })=>{
    const { indentPerLevel: indentPerLevel = $ae641a51f4847142$var$DEFAULR_INDENT_PER_LEVEL } = shared;
    const itemType = shared.itemType ?? $ae641a51f4847142$var$DEFAULT_ITEM_TYPE;
    const path = (0, $euxye.useMemo)(()=>[
            ...pathToParent,
            {
                parentId: parentId,
                index: index
            }
        ], [
        pathToParent,
        parentId,
        index
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(TreeItemComponent, {
        key: `${itemType}-${item.id}`,
        item: item,
        renderItem: shared.renderItem,
        indentPerLevel: indentPerLevel,
        currentLevel: parentLevel,
        isExpanded: item.isExpanded,
        onExpand: shared.onExpand,
        onCollapse: shared.onCollapse,
        // draggable props
        index: index,
        TreeItemHead: shared.TreeItemHead,
        TreeItemContainer: shared.TreeItemContainer,
        isLastInGroup: isLastInGroup,
        path: path,
        onDragStart: shared.onDragStart ?? (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        onDragEnd: shared.onDragEnd ?? (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        dragPreview: shared.dragPreview,
        isDragEnabled: shared.isDragEnabled,
        isDropEnabled: shared.isDropEnabled,
        itemType: itemType
    }, item.children.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ae641a51f4847142$var$Parent, {
        parent: item,
        currentPath: path,
        TreeItemParentContainer: shared.TreeItemParentContainer,
        TreeItemComponent: TreeItemComponent,
        ...shared
    }) : shared.renderItemEmptyState?.({
        item: item,
        indent: parentLevel * indentPerLevel
    }));
};
$ae641a51f4847142$var$Child.displayName = "Child";
const $ae641a51f4847142$var$DefaultTreeItemParentContainer = /*#__PURE__*/ (0, $euxye.forwardRef)(({ role: role, children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        ref: ref,
        role: role
    }, children));
// @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
const $ae641a51f4847142$var$Parent = /*#__PURE__*/ (0, $euxye.forwardRef)(({ parent: parent, currentPath: currentPath, ...shared }, ref)=>{
    // If the parent has no children, we don't need to render anything
    if (parent.children.length === 0) return null;
    const parentLevel = currentPath.length;
    const Container = shared.TreeItemParentContainer || $ae641a51f4847142$var$DefaultTreeItemParentContainer;
    const itemType = shared.itemType ?? $ae641a51f4847142$var$DEFAULT_ITEM_TYPE;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Container, {
        ref: ref,
        role: parentLevel === 0 ? 'tree' : 'group'
    }, parent.children.map((childId, index, array)=>{
        const item = shared.tree.items[childId];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ae641a51f4847142$var$Child, {
            key: `${itemType}-${item.id}`,
            item: item,
            pathToParent: currentPath,
            parentLevel: parentLevel,
            parentId: parent.id,
            index: index,
            isLastInGroup: index === array.length - 1,
            ...shared
        });
    }));
});
const $ae641a51f4847142$export$7fbedc92909ed28e = (props)=>{
    const containerRef = (0, $euxye.useRef)(null);
    const TreeItemComponent = (0, $euxye.useMemo)(()=>props.isDragEnabled ? (0, $6CZ2k.TreeItemDraggable) : (0, $59k7o.TreeItemBase), [
        props.isDragEnabled
    ]);
    const [path] = (0, $euxye.useState)([]);
    (0, $euxye.useEffect)(()=>{
        let cleanupAutoScroll = null;
        return (0, $l7nPt.combine)((0, $3nfFb.monitorForElements)({
            onDragStart: ()=>{
                // Setups auto-scrolling only once when dragging starts
                if (cleanupAutoScroll) return;
                // Find the closest scrollable parent element to the tree
                const closestScrollable = (0, $1fWai.getClosestScrollableElement)(containerRef.current);
                if (!closestScrollable) return;
                cleanupAutoScroll = (0, $7ohZu.autoScrollForElements)({
                    element: closestScrollable,
                    canScroll: ({ source: source })=>source.data.type === props.itemType
                });
            },
            canMonitor: ({ source: source })=>source.data.type === props.itemType
        }), ()=>cleanupAutoScroll?.());
    }, [
        props.itemType
    ]);
    const root = props.tree.items[props.tree.rootId];
    // Cannot render a tree without a root tree item
    if (!root) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ae641a51f4847142$var$Parent, {
        parent: root,
        currentPath: path,
        TreeItemComponent: TreeItemComponent,
        ...props
    }));
};
$ae641a51f4847142$export$7fbedc92909ed28e.displayName = "Tree";

});
parcelRegister("59k7o", function(module, exports) {
$parcel$export(module.exports, "TreeItemBase", () => $bfb14100ca101522$export$82d65614150df752);
/* TreeItemBase.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
const $bfb14100ca101522$var$styles = {
    treeItemBaseContainer: "_kqswh2mm"
};
const $bfb14100ca101522$var$DefaultTreeItemBaseContainer = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, item: item, isExpanded: isExpanded, indentPerLevel: indentPerLevel, currentLevel: currentLevel }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        ref: ref,
        role: "treeitem",
        paddingBlockStart: "space.0",
        paddingInline: "space.0",
        ...item.hasChildren && {
            'aria-expanded': isExpanded
        },
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            paddingLeft: `${indentPerLevel * currentLevel}px`
        },
        xcss: $bfb14100ca101522$var$styles.treeItemBaseContainer
    }, children);
});
const $bfb14100ca101522$var$DefaultTreeItemBaseHead = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, ariaLabel: ariaLabel }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        ref: ref,
        "aria-label": ariaLabel
    }, children));
const $bfb14100ca101522$var$TreeItemBaseInner = (props, ref)=>{
    const { children: children, item: item, renderItem: renderItem, isExpanded: isExpanded, onExpand: onExpand, onCollapse: onCollapse, dropIndicator: dropIndicator, draggableState: draggableState, ariaLabel: ariaLabel, TreeItemContainer: TreeItemContainer, TreeItemHead: TreeItemHead } = props;
    const containerRef = (0, $euxye.useRef)(null);
    const draggableRef = (0, $euxye.useRef)(null);
    (0, $euxye.useImperativeHandle)(ref, ()=>({
            containerRef: containerRef,
            draggableRef: draggableRef
        }));
    const Container = TreeItemContainer || $bfb14100ca101522$var$DefaultTreeItemBaseContainer;
    const Head = TreeItemHead || $bfb14100ca101522$var$DefaultTreeItemBaseHead;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Container, {
        ref: containerRef,
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Head, {
        ref: draggableRef,
        ariaLabel: ariaLabel,
        item: item
    }, renderItem({
        item: item,
        onExpand: onExpand,
        onCollapse: onCollapse,
        draggableState: draggableState
    }), dropIndicator), isExpanded && children);
};
$bfb14100ca101522$var$TreeItemBaseInner.displayName = "TreeItemBaseInner";
const $bfb14100ca101522$export$82d65614150df752 = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)($bfb14100ca101522$var$TreeItemBaseInner));

});

parcelRegister("6CZ2k", function(module, exports) {
$parcel$export(module.exports, "TreeItemDraggable", () => $d3fbdd3de55f1bda$export$99f16d89b51266cb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $GmDfp = parcelRequire("GmDfp");

var $fTnRE = parcelRequire("fTnRE");

var $l7nPt = parcelRequire("l7nPt");

var $3nfFb = parcelRequire("3nfFb");

var $fWrp0 = parcelRequire("fWrp0");
parcelRequire("9vRQv");
var $iJs7j = parcelRequire("iJs7j");

var $ij70u = parcelRequire("ij70u");

var $59k7o = parcelRequire("59k7o");

var $2rh2M = parcelRequire("2rh2M");

var $gCb3j = parcelRequire("gCb3j");
function $d3fbdd3de55f1bda$var$getItemMode(isLastInGroup, item) {
    if (item.isExpanded && item.hasChildren) return 'expanded';
    if (isLastInGroup) return 'last-in-group';
    return 'standard';
}
// Shared state between all instances of TreeItemDraggable
const $d3fbdd3de55f1bda$var$idle = {
    type: 'idle'
};
const $d3fbdd3de55f1bda$var$TreeItemDraggableInternal = ({ onDragStart: onDragStart, onDragEnd: onDragEnd, dragPreview: dragPreview, index: index, isLastInGroup: isLastInGroup, path: path, itemType: itemType, isDragEnabled: isDragEnabled, isDropEnabled: isDropEnabled, renderItem: renderItem, ...baseProps })=>{
    const { item: item, indentPerLevel: indentPerLevel, currentLevel: currentLevel, onExpand: onExpand, onCollapse: onCollapse } = baseProps;
    const { parentId: parentId } = path[currentLevel];
    const [draggableState, setDraggableState] = (0, $euxye.useState)($d3fbdd3de55f1bda$var$idle);
    const [dropIndicatorInstruction, setDropIndicatorInstruction] = (0, $euxye.useState)(null);
    const isDragDisabled = !isDragEnabled || typeof isDragEnabled === 'function' && !isDragEnabled(item);
    const isDropDisabled = !isDropEnabled || typeof isDropEnabled === 'function' && !isDropEnabled(item);
    const ref = (0, $euxye.useRef)(null);
    const cancelDelayedFn = (0, $euxye.useRef)(null);
    const makeDraggable = (0, $euxye.useCallback)((el)=>(0, $3nfFb.draggable)({
            element: el,
            onGenerateDragPreview: ({ source: source, nativeSetDragImage: nativeSetDragImage })=>{
                (0, $iJs7j.scrollJustEnoughIntoView)({
                    element: source.element
                });
                (0, $ij70u.setCustomNativeDragPreview)({
                    getOffset: (0, $fWrp0.pointerOutsideOfPreview)({
                        x: '16px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        // this will cause a sync re-render to add a portal
                        setDraggableState({
                            type: 'preview',
                            container: container
                        });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>{
                // Collapse section if expanded to prevent dropping into itself
                if (item.isExpanded) onCollapse?.(item.id);
                setDraggableState({
                    type: 'dragging'
                });
                onDragStart?.();
            },
            getInitialData: ()=>({
                    id: item.id,
                    isExpandedBeforeDrag: item.isExpanded,
                    type: itemType
                }),
            onDrop: ({ location: location, source: source })=>{
                setDraggableState($d3fbdd3de55f1bda$var$idle);
                if (location?.current?.dropTargets[0]) {
                    const { data: targetData } = location.current.dropTargets[0];
                    const instruction = (0, $GmDfp.extractInstruction)(targetData);
                    const target = (0, $2rh2M.isTreeItemData)(targetData) ? targetData : null;
                    if (!target || target.type !== itemType || !instruction || // only allow an item to drop on itself if it's being reparented
                    target.id === item.id && instruction.type !== 'reparent') {
                        // re-expand the item if it was expanded before the drag and not dropped on a valid target
                        if (source.data.isExpandedBeforeDrag) onExpand?.(item.id);
                        return;
                    }
                    // Calculate the desired instruction based if the current instruction is blocked
                    // Allow consumers to handle the move even if it's blocked in onDragEnd
                    const desiredInstruction = instruction.type === 'instruction-blocked' ? instruction.desired : instruction;
                    let destinationPosition = null;
                    switch(desiredInstruction.type){
                        case 'reorder-above':
                            destinationPosition = {
                                parentId: target.parentId,
                                index: target.index
                            };
                            break;
                        case 'reorder-below':
                            destinationPosition = {
                                parentId: target.parentId,
                                index: target.index + 1
                            };
                            break;
                        case 'make-child':
                            destinationPosition = {
                                parentId: target.id,
                                index: undefined
                            };
                            break;
                        case 'reparent':
                            destinationPosition = {
                                parentId: target.path[desiredInstruction.desiredLevel].parentId,
                                index: target.path[desiredInstruction.desiredLevel].index + 1
                            };
                            break;
                        default:
                            break;
                    }
                    // Move item down within same parent. Can happen during reordering or reparenting.
                    if (parentId === destinationPosition?.parentId && typeof destinationPosition?.index === 'number' && index < destinationPosition?.index) destinationPosition.index--;
                    if (destinationPosition) {
                        const sourcePosition = {
                            parentId: parentId,
                            index: index
                        };
                        onDragEnd(sourcePosition, destinationPosition, !!source.data.isExpandedBeforeDrag);
                    }
                } else if (source.data.isExpandedBeforeDrag) // re-expand the item if it was expanded before the drag and not dropped on a valid target
                onExpand?.(item.id);
            }
        }), [
        onDragStart,
        onDragEnd,
        item,
        index,
        parentId,
        onExpand,
        onCollapse,
        itemType
    ]);
    const makeDropTarget = (0, $euxye.useCallback)((el)=>(0, $3nfFb.dropTargetForElements)({
            element: el,
            canDrop: ({ source: source })=>!isDropDisabled && source.data.type === itemType,
            getData: ({ input: input, element: element })=>{
                const data = (0, $2rh2M.getTreeItemData)({
                    id: item.id,
                    type: itemType,
                    parentId: parentId,
                    index: index,
                    hasChildren: !!item.hasChildren,
                    path: path
                });
                return (0, $GmDfp.attachInstruction)(data, {
                    input: input,
                    element: element,
                    currentLevel: currentLevel,
                    indentPerLevel: indentPerLevel,
                    mode: $d3fbdd3de55f1bda$var$getItemMode(isLastInGroup, item),
                    block: item.blockedInstructions
                });
            },
            onDrag: ({ self: self, source: source, location: location })=>{
                const instruction = (0, $GmDfp.extractInstruction)(self.data);
                if (// only show the drag indicator when dragging over the item being dragged in the case of reparenting
                (source.data.id !== item.id || instruction?.type === 'reparent') && location?.current?.dropTargets[0]?.data?.id === item.id) {
                    if (item.hasChildren) {
                        if (instruction?.type === 'make-child' && !item.isExpanded && !cancelDelayedFn.current) cancelDelayedFn.current = (0, $gCb3j.delay)({
                            time: 500,
                            fn: ()=>{
                                onExpand?.(item.id);
                                // set `cancelDelayedFn` to `null` so we know there is no delayed fn running
                                cancelDelayedFn.current = null;
                            }
                        });
                        else if (instruction?.type !== 'make-child') {
                            cancelDelayedFn.current?.();
                            cancelDelayedFn.current = null;
                        }
                    }
                    setDropIndicatorInstruction(instruction);
                } else setDropIndicatorInstruction(null);
            },
            onDragLeave: ()=>{
                cancelDelayedFn.current?.();
                cancelDelayedFn.current = null;
                setDropIndicatorInstruction(null);
            },
            onDrop: ()=>{
                cancelDelayedFn.current?.();
                cancelDelayedFn.current = null;
                setDropIndicatorInstruction(null);
            }
        }), [
        isDropDisabled,
        itemType,
        item,
        parentId,
        index,
        path,
        currentLevel,
        indentPerLevel,
        isLastInGroup,
        onExpand
    ]);
    (0, $euxye.useEffect)(()=>{
        const draggableEl = ref.current?.draggableRef.current;
        const containerEl = ref.current?.containerRef.current;
        if (!draggableEl || !containerEl) return;
        const dropTarget = makeDropTarget(draggableEl);
        if (isDragDisabled) return dropTarget;
        return (0, $l7nPt.combine)(makeDraggable(draggableEl), dropTarget);
    }, [
        isDragDisabled,
        makeDraggable,
        makeDropTarget
    ]);
    (0, $euxye.useEffect)(()=>()=>cancelDelayedFn.current?.(), []);
    const dropIndicator = dropIndicatorInstruction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fTnRE.DropIndicator), {
        instruction: dropIndicatorInstruction
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $59k7o.TreeItemBase), {
        ref: ref,
        dropIndicator: dropIndicator,
        draggableState: draggableState.type,
        renderItem: renderItem,
        ...baseProps
    }), draggableState.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($85XPu))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, dragPreview?.(item) || renderItem({
        item: item,
        draggableState: 'preview'
    })), draggableState.container) : null);
};
$d3fbdd3de55f1bda$var$TreeItemDraggableInternal.displayName = "TreeItemDraggableInternal";
const $d3fbdd3de55f1bda$export$99f16d89b51266cb = /*#__PURE__*/ (0, $euxye.memo)($d3fbdd3de55f1bda$var$TreeItemDraggableInternal);

});
parcelRegister("GmDfp", function(module, exports) {
$parcel$export(module.exports, "attachInstruction", () => $3695c556ff009457$export$267ad49d812c2c7f);
$parcel$export(module.exports, "extractInstruction", () => $3695c556ff009457$export$c8ffecbe249dc8f8);

var $2wKfH = parcelRequire("2wKfH");
// using a symbol so we can guarantee a key with a unique value
const $3695c556ff009457$var$uniqueKey = Symbol('tree-item-instruction');
function $3695c556ff009457$var$getCenter(rect) {
    return {
        x: (rect.right + rect.left) / 2,
        y: (rect.bottom + rect.top) / 2
    };
}
function $3695c556ff009457$var$standardHitbox({ client: client, borderBox: borderBox }) {
    const quarterOfHeight = borderBox.height / 4;
    // In the top 1/4: reorder-above
    // On the line = in the top 1/4 to give this zone a bit more space
    if (client.y <= borderBox.top + quarterOfHeight) return 'reorder-above';
    // In the bottom 1/4: reorder-below
    // On the line = in the bottom 1/4 to give this zone a bit more space
    if (client.y >= borderBox.bottom - quarterOfHeight) return 'reorder-below';
    return 'make-child';
}
function $3695c556ff009457$var$getInstruction({ element: element, input: input, currentLevel: currentLevel, indentPerLevel: indentPerLevel, mode: mode }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    if (mode === 'standard') {
        const type = $3695c556ff009457$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            type: type,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    const center = $3695c556ff009457$var$getCenter(borderBox);
    if (mode === 'expanded') {
        // leveraging "standard" hitbox to ensure that the 'reorder-above' hit zone is
        // exactly the same for "standard" and "expanded" items
        const type = $3695c556ff009457$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            // Use the "standard" hitbox for "reorder above",
            // The rest of the item is "make-child"
            type: type === 'reorder-above' ? type : 'make-child',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // `mode` is "last-in-group"
    const visibleInset = indentPerLevel * currentLevel;
    // Before the left edge of the visible item
    if (client.x < borderBox.left + visibleInset) {
        // Above the center: `reorder-above`
        if (client.y < center.y) return {
            type: 'reorder-above',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
        // On or below the center: `reparent`
        // On the center = `reparent` as we are giving a slightly bigger hitbox to this
        // action as it is the only place a user can do it
        const rawLevel = (client.x - borderBox.left) / indentPerLevel;
        // We can get sub pixel negative numbers as getBoundingClientRect gives sub-pixel accuracy,
        // where as clientX is rounded to the nearest pixel.
        // Using Math.max() ensures we can never get a negative level
        const desiredLevel = Math.max(Math.floor(rawLevel), 0);
        return {
            type: 'reparent',
            desiredLevel: desiredLevel,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // On the visible item
    return {
        type: $3695c556ff009457$var$standardHitbox({
            borderBox: borderBox,
            client: client
        }),
        indentPerLevel: indentPerLevel,
        currentLevel: currentLevel
    };
}
function $3695c556ff009457$var$areInstructionsEqual(a, b) {
    // Shortcut
    if (a.type !== b.type) return false;
    if (a.type === 'instruction-blocked' && b.type === 'instruction-blocked') return $3695c556ff009457$var$areInstructionsEqual(a.desired, b.desired);
    return (0, $2wKfH.isShallowEqual)(a, b);
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $3695c556ff009457$var$memoizeInstruction = (0, $2wKfH.stable)($3695c556ff009457$var$areInstructionsEqual);
function $3695c556ff009457$var$applyInstructionBlock({ desired: desired, block: block }) {
    if (block?.includes(desired.type) && desired.type !== 'instruction-blocked') {
        const blocked = {
            type: 'instruction-blocked',
            desired: desired
        };
        return blocked;
    }
    return desired;
}
function $3695c556ff009457$export$267ad49d812c2c7f(userData, { block: block, ...rest }) {
    const desired = $3695c556ff009457$var$getInstruction(rest);
    const withBlock = $3695c556ff009457$var$applyInstructionBlock({
        desired: desired,
        block: block
    });
    const memoized = $3695c556ff009457$var$memoizeInstruction(withBlock);
    return {
        ...userData,
        [$3695c556ff009457$var$uniqueKey]: memoized
    };
}
function $3695c556ff009457$export$c8ffecbe249dc8f8(userData) {
    return userData[$3695c556ff009457$var$uniqueKey] ?? null;
}

});

parcelRegister("fTnRE", function(module, exports) {
$parcel$export(module.exports, "DropIndicator", () => $f24ad8089e6a3c0b$export$62ed72bc21f6b8a6);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $5VQcl = parcelRequire("5VQcl");

var $76mBo = parcelRequire("76mBo");
function $f24ad8089e6a3c0b$var$getElement({ instruction: instruction, isBlocked: isBlocked }) {
    const indent = `${instruction.currentLevel * instruction.indentPerLevel}px`;
    const appearance = isBlocked ? 'warning' : 'default';
    if (instruction.type === 'reorder-above') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $76mBo.DropIndicator), {
        edge: "top",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reorder-below') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $76mBo.DropIndicator), {
        edge: "bottom",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'make-child') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5VQcl.DropIndicator), {
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reparent') {
        const reparentIndent = `${instruction.desiredLevel * instruction.indentPerLevel}px`;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $76mBo.DropIndicator), {
            edge: "bottom",
            appearance: appearance,
            indent: reparentIndent
        });
    }
    return null;
}
function $f24ad8089e6a3c0b$export$62ed72bc21f6b8a6({ instruction: instruction }) {
    if (instruction.type === 'instruction-blocked') return $f24ad8089e6a3c0b$var$getElement({
        instruction: instruction.desired,
        isBlocked: true
    });
    return $f24ad8089e6a3c0b$var$getElement({
        instruction: instruction,
        isBlocked: false
    });
}

});

parcelRegister("9vRQv", function(module, exports) {
$parcel$export(module.exports, "scrollJustEnoughIntoView", () => (parcelRequire("iJs7j")).scrollJustEnoughIntoView);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @deprecated Use `import { scrollJustEnoughIntoView } from '@atlaskit/pragmatic-drag-and-drop/utils/scroll-just-enough-into-view'` instead.
 */ 
var $iJs7j = parcelRequire("iJs7j");

});
parcelRegister("iJs7j", function(module, exports) {
$parcel$export(module.exports, "scrollJustEnoughIntoView", () => $6b0cf97308d7ae17$export$2725ea6c83710b1f);
/**
 * Scroll an `element` just enough into view so that the element becomes totally visible.
 * If the element is already totally visible then no scrolling will occur.
 */ function $6b0cf97308d7ae17$export$2725ea6c83710b1f({ element: element }) {
    element.scrollIntoView({
        block: 'nearest',
        inline: 'nearest'
    });
}

});


parcelRegister("2rh2M", function(module, exports) {
$parcel$export(module.exports, "getTreeItemData", () => $2fd4753a50f371a0$export$efaa5855b1ed44ba);
$parcel$export(module.exports, "isTreeItemData", () => $2fd4753a50f371a0$export$639584aad8687236);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $1gTLv = parcelRequire("1gTLv");
const $2fd4753a50f371a0$export$efaa5855b1ed44ba = (data)=>({
        [(0, $1gTLv.treeItemDataPrivateKey)]: true,
        ...data
    });
const $2fd4753a50f371a0$export$639584aad8687236 = (data)=>Boolean(data[0, $1gTLv.treeItemDataPrivateKey]);

});
parcelRegister("1gTLv", function(module, exports) {
$parcel$export(module.exports, "treeItemDataPrivateKey", () => $f6ab5798868d8296$export$22b4685226b7e461);
/* eslint-disable jira/filename-case */ // We are using a `Symbol` to guarentee the whole object is a particular shape
const $f6ab5798868d8296$export$22b4685226b7e461 = Symbol('TreeItemData');

});


parcelRegister("gCb3j", function(module, exports) {
$parcel$export(module.exports, "delay", () => $a5066fb558c5c811$export$1391212d75b2ee65);
/* eslint-disable jira/filename-case */ /**
 * Delay the execution of a function by a given amount of time,
 * and return a cleanup function that can be used to cancel the delay.
 */ function $a5066fb558c5c811$export$1391212d75b2ee65({ fn: fn, time: time }) {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let timeoutId = window.setTimeout(()=>{
        timeoutId = null;
        fn();
    }, time);
    return function cleanup() {
        if (timeoutId) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
}

});


parcelRegister("1fWai", function(module, exports) {
$parcel$export(module.exports, "getClosestScrollableElement", () => $dced2daf2c79466a$export$f39f407dd5a0ebdb);
/* eslint-disable jira/filename-case */ // Source: https://github.com/atlassian/react-beautiful-dnd
const $dced2daf2c79466a$var$isEqual = (base)=>(value)=>base === value;
const $dced2daf2c79466a$var$isScroll = $dced2daf2c79466a$var$isEqual('scroll');
const $dced2daf2c79466a$var$isAuto = $dced2daf2c79466a$var$isEqual('auto');
const $dced2daf2c79466a$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $dced2daf2c79466a$var$isElementScrollable = (el)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const style = window.getComputedStyle(el);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $dced2daf2c79466a$var$isEither(overflow, $dced2daf2c79466a$var$isScroll) || $dced2daf2c79466a$var$isEither(overflow, $dced2daf2c79466a$var$isAuto);
};
const $dced2daf2c79466a$export$f39f407dd5a0ebdb = (el)=>{
    if (!el) return null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (el === document.body || el === document.documentElement) return null;
    if (!$dced2daf2c79466a$var$isElementScrollable(el)) return $dced2daf2c79466a$export$f39f407dd5a0ebdb(el.parentElement);
    return el;
};

});


parcelRegister("deOYh", function(module, exports) {
$parcel$export(module.exports, "createTree", () => $9872f7a71f08cf55$export$88af83ec3e03aca6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ class $9872f7a71f08cf55$var$TreeBuilder {
    constructor(rootId, data, isExpanded){
        this.items = {};
        this.createItem = (id, data, blockedInstructions, isExpanded = false)=>({
                id: id,
                data: data,
                isExpanded: isExpanded,
                children: [],
                hasChildren: false,
                blockedInstructions: blockedInstructions
            });
        const rootItem = this.createItem(rootId, data, [], isExpanded);
        this.rootId = rootItem.id;
        this.items[rootItem.id] = rootItem;
    }
    // go/jfe-eslint
    withLeaf(id, data, blockedInstructions) {
        const leafItem = this.createItem(id, data, blockedInstructions);
        this.addItemToRoot(leafItem.id);
        this.items[leafItem.id] = leafItem;
        return this;
    }
    // go/jfe-eslint
    withSubTree(tree) {
        const subTree = tree.build();
        this.addItemToRoot(subTree.rootId);
        this.items = {
            ...this.items,
            ...subTree.items
        };
        return this;
    }
    addItemToRoot(id) {
        const rootItem = this.items[this.rootId];
        rootItem.children.push(id);
        rootItem.hasChildren = true;
    }
    // Builds the tree object
    build() {
        return {
            rootId: this.rootId,
            items: this.items
        };
    }
}
$9872f7a71f08cf55$var$TreeBuilder.displayName = "TreeBuilder";
const $9872f7a71f08cf55$export$88af83ec3e03aca6 = (topLevelViews)=>{
    const viewsTree = new $9872f7a71f08cf55$var$TreeBuilder('root', {});
    const createSectionNode = ({ localId: localId, views: views, isExpanded: isExpanded })=>{
        const subTree = new $9872f7a71f08cf55$var$TreeBuilder(localId, {
            type: 'section'
        }, isExpanded);
        views?.forEach((view)=>{
            subTree.withLeaf(view.localId, {
                type: 'view'
            }, [
                'make-child'
            ]);
        });
        subTree.withLeaf(`${localId}-placeholder`, {
            type: 'placeholder',
            parentId: localId
        }, [
            'reorder-below',
            'make-child'
        ]);
        viewsTree.withSubTree(subTree);
    };
    const createViewNode = (view)=>{
        viewsTree.withLeaf(view.localId, {
            type: 'view',
            view: view
        }, [
            'make-child'
        ]);
    };
    // Sort views and viewsets
    const treeNodes = [];
    topLevelViews.forEach((view)=>{
        treeNodes.push({
            type: view.viewType === 'SECTION' ? 'section' : 'view',
            data: {
                view: view
            }
        });
    });
    // Generate all tree nodes
    treeNodes.forEach(({ type: type, data: data })=>{
        if (type === 'section' && data.view) createSectionNode(data.view);
        if (type === 'view' && data.view) createViewNode(data.view);
    });
    return viewsTree.build();
};

});

parcelRegister("lzkou", function(module, exports) {
$parcel$export(module.exports, "ViewItem", () => $6871f068780fe649$export$e7f917c619841a86);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $aGaXs = parcelRequire("aGaXs");

var $kmMHr = parcelRequire("kmMHr");

var $3kW31 = parcelRequire("3kW31");

var $koaaE = parcelRequire("koaaE");

var $8wdvw = parcelRequire("8wdvw");

var $9f7Jn = parcelRequire("9f7Jn");

var $jYEcG = parcelRequire("jYEcG");

var $fbAgj = parcelRequire("fbAgj");

var $e6rNk = parcelRequire("e6rNk");

var $ar9gx = parcelRequire("ar9gx");

var $djYhH = parcelRequire("djYhH");

var $1MNmN = parcelRequire("1MNmN");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $gNzvf = parcelRequire("gNzvf");

var $f2wVS = parcelRequire("f2wVS");

var $i860n = parcelRequire("i860n");

var $20PTK = parcelRequire("20PTK");

var $5lCvX = parcelRequire("5lCvX");

var $itiPA = parcelRequire("itiPA");

var $6hKmX = parcelRequire("6hKmX");

var $hj9Qm = parcelRequire("hj9Qm");

var $hPnAm = parcelRequire("hPnAm");

var $aMCiy = parcelRequire("aMCiy");
const $6871f068780fe649$var$defaultTitle = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.default-title",
    defaultMessage: "Untitled View"
});
const $6871f068780fe649$var$nameLabel = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.rename-label",
    defaultMessage: "View name"
});
const $6871f068780fe649$var$menuItemEmojiPicker = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu-item-emoji-picker",
    defaultMessage: "Open emoji picker for {viewName}"
});
const $6871f068780fe649$var$styles = {
    emojiButton: "_bfhk18uv",
    emojiButtonDisabled: "_lcxvglyw"
}; // oxlint-disable-next-line typescript/no-invalid-void-type
const $6871f068780fe649$export$2d2c4f6e3379cd4b = (0, $f2wVS.createRouterSelector)((state)=>state.location.pathname);
const $6871f068780fe649$export$e7f917c619841a86 = /*#__PURE__*/ (0, $euxye.memo)(({ localId: localId, isDraggingPreview: isDraggingPreview, navigationContainer: navigationContainer })=>{
    const containerId = (0, $hj9Qm.useContainerId)();
    const getViewUrl = (0, $hj9Qm.useGetViewUrl)();
    const [isPickerOpen, setPickerOpen] = (0, $euxye.useState)(false);
    const emojiProviderPromise = (0, $8wdvw.useEmojiProviderPromise)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [view] = (0, $3kW31.useNavigationView)({
        localId: localId,
        containerId: containerId
    });
    const pathname = $6871f068780fe649$export$2d2c4f6e3379cd4b();
    const draggableRef = (0, $euxye.useContext)((0, $6hKmX.DraggableRefContext));
    const containerTypePermissions = (0, $hj9Qm.useContainerTypePermissions)();
    const isReadOnly = (0, $hj9Qm.useIsReadOnly)();
    const { canManageView: canManageView, canSeeView: canSeeView, loadViewPermissionsForCurrentUser: loadViewPermissionsForCurrentUser } = (0, $koaaE.useManageViewPermissions)(containerTypePermissions === 'view' ? view?.id : containerId);
    const { sendViewNavigationItemInsideProjectsAnalyticsEvent: sendViewNavigationItemInsideProjectsAnalyticsEvent } = (0, $hj9Qm.useAnalyticsL2)();
    const isViewKindLocked = (0, $hPnAm.useIsViewKindLocked)();
    const isGlobalView = Boolean(view?.global) && (0, $i860n.fg)('polaris_global_views');
    const { updateView: updateView, deleteViewFromState: deleteViewFromState, cancelViewRenaming: cancelViewRenaming, addEmoji: addEmoji } = (0, $kmMHr.useNavigationActions)();
    const handleTitleChanged = (0, $euxye.useCallback)((newTitle)=>{
        if (!view) return;
        updateView(view.localId, newTitle || formatMessage($6871f068780fe649$var$defaultTitle));
    }, [
        view,
        formatMessage,
        updateView
    ]);
    const handleTitleChangeCanceled = (0, $euxye.useCallback)(()=>{
        if (!view) return;
        cancelViewRenaming(view.localId);
    }, [
        view,
        cancelViewRenaming
    ]);
    const handleEmojiIconClick = (0, $euxye.useCallback)((e)=>{
        if ((0, $i860n.fg)('jpd_tree-view')) {
            if (!canManageView || isReadOnly || view?.viewType && isViewKindLocked(view.viewType)) return;
        } else if (!canManageView || isReadOnly) return;
        e.preventDefault();
        e.stopPropagation();
        setPickerOpen(!isPickerOpen);
    }, [
        canManageView,
        isPickerOpen,
        isReadOnly,
        isViewKindLocked,
        view
    ]);
    const handleSelectEmoji = (0, $euxye.useCallback)((emoji)=>{
        setPickerOpen(false);
        if (!view) return;
        addEmoji(emoji.id, view.localId);
    }, [
        view,
        setPickerOpen,
        addEmoji
    ]);
    const handleTitleIconHover = (0, $euxye.useCallback)(()=>{
        if (view && !(0, $aGaXs.isFakeId)(view.id)) loadViewPermissionsForCurrentUser(containerTypePermissions === 'view' ? view.id : containerId);
    }, [
        containerId,
        containerTypePermissions,
        loadViewPermissionsForCurrentUser,
        view
    ]);
    const getEmojiPicker = (0, $euxye.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9f7Jn.default), {
            emojiProvider: emojiProviderPromise,
            onSelection: handleSelectEmoji
        }), [
        emojiProviderPromise,
        handleSelectEmoji
    ]);
    const handleClick = (0, $euxye.useCallback)(()=>{
        sendViewNavigationItemInsideProjectsAnalyticsEvent({
            container: navigationContainer,
            viewParams: {
                viewId: view?.id,
                viewKind: view?.viewType
            }
        });
    }, [
        sendViewNavigationItemInsideProjectsAnalyticsEvent,
        navigationContainer,
        view?.id,
        view?.viewType
    ]);
    (0, $euxye.useEffect)(()=>{
        if (view && !canSeeView) deleteViewFromState(view.id);
    }, [
        view,
        canSeeView,
        deleteViewFromState
    ]);
    if (!view) return null;
     // The view is in an editing state if the user is renaming it or if the view was just created and has no name
    const isEditing = view.isRenaming || view.name === '';
    if (isEditing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5lCvX.EditableTitle), {
        label: formatMessage($6871f068780fe649$var$nameLabel),
        value: view.name,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $itiPA.ViewIcon), {
            viewKind: view.viewType,
            emojiId: view.emoji
        }),
        onChanged: handleTitleChanged,
        onCancel: handleTitleChangeCanceled
    }));
    const url = getViewUrl({
        container: navigationContainer,
        view: view
    });
    const isSelected = pathname === url;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $20PTK.WithDragPreview), {
        isEnabled: isDraggingPreview || false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e6rNk.LinkMenuItem // oxlint-disable-next-line typescript/consistent-type-assertions
    ), {
        ref: draggableRef,
        isSelected: isSelected,
        href: url,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNzvf.JiraPopup), {
            placement: "auto-start",
            isOpen: isPickerOpen,
            shouldUseCaptureOnOutsideClick: true,
            onClose: ()=>setPickerOpen(false),
            content: getEmojiPicker,
            messageId: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.menu-items.views.viewset.popup",
            messageType: "transactional",
            trigger: (triggerProps)=>(0, $i860n.fg)('polaris_global_views') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jYEcG.default), {
                    ...triggerProps,
                    onClick: handleEmojiIconClick,
                    onMouseEnter: handleTitleIconHover,
                    isDisabled: isGlobalView && (0, $i860n.fg)('polaris_global_views'),
                    padding: "space.0",
                    xcss: (0, $1MNmN.cx)($6871f068780fe649$var$styles.emojiButton, isGlobalView && $6871f068780fe649$var$styles.emojiButtonDisabled),
                    "aria-label": formatMessage($6871f068780fe649$var$menuItemEmojiPicker, {
                        viewName: view.name
                    })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $itiPA.TitleIconResolver), {
                    emojiId: view.emoji,
                    viewId: containerTypePermissions === 'project' ? containerId : view.id,
                    viewKind: view.viewType,
                    isSelected: isSelected
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jYEcG.default), {
                    ...triggerProps,
                    onClick: handleEmojiIconClick,
                    onMouseEnter: handleTitleIconHover,
                    padding: "space.0",
                    xcss: $6871f068780fe649$var$stylesOld,
                    "aria-label": formatMessage($6871f068780fe649$var$menuItemEmojiPicker, {
                        viewName: view.name
                    })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $itiPA.TitleIconResolver), {
                    emojiId: view.emoji,
                    viewId: containerTypePermissions === 'project' ? containerId : view.id,
                    viewKind: view.viewType,
                    isSelected: isSelected
                }))
        }),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aMCiy.Menu), {
            view: view,
            navigationContainer: navigationContainer
        }),
        onClick: handleClick
    }, view.name)));
});
const $6871f068780fe649$var$stylesOld = (0, $fbAgj.xcss)({
    background: 'transparent'
});

});
parcelRegister("9f7Jn", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8536f206e37955b$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("euxye");

var $kTviw = parcelRequire("kTviw");

var $dpMK8 = parcelRequire("dpMK8");



const $e8536f206e37955b$export$6335145236247192 = (0, $kTviw.default)()((0, $dpMK8.EmojiPickerInternal));
var $e8536f206e37955b$export$2e2bcd8739ae039 = $e8536f206e37955b$export$6335145236247192;

});
parcelRegister("dpMK8", function(module, exports) {
$parcel$export(module.exports, "EmojiPickerInternal", () => $ea9e9ba2907fa2a7$export$bcf219a275f21b24);
/* EmojiPickerInternal.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");
parcelRequire("euxye");

var $4LDqh = parcelRequire("4LDqh");

var $e9q86 = parcelRequire("e9q86");

var $gq0pG = parcelRequire("gq0pG");

var $3UnZm = parcelRequire("3UnZm");

var $OX0zM = parcelRequire("OX0zM");

var $9kdwp = parcelRequire("9kdwp");

var $d8fwQ = parcelRequire("d8fwQ");

var $71fL1 = parcelRequire("71fL1");
const $ea9e9ba2907fa2a7$var$isRefreshEmojiPickerEnabled = ()=>{
    if (!(0, $4LDqh.default).initializeCompleted()) return false;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const isEnabled = (0, $4LDqh.default).getExperimentValue('platform_teamoji_26_refresh_emoji_picker', 'isEnabled', false);
    return isEnabled;
};
const $ea9e9ba2907fa2a7$var$emojiPicker = null;
const $ea9e9ba2907fa2a7$var$emojiPickerNew = null;
class $ea9e9ba2907fa2a7$export$bcf219a275f21b24 extends (0, $OX0zM.default) {
    static{
        this.defaultProps = {
            size: (0, $3UnZm.defaultEmojiPickerSize)
        };
    }
    constructor(props){
        super(props, {}), this.state = {
            asyncLoadedComponent: $ea9e9ba2907fa2a7$export$bcf219a275f21b24.AsyncLoadedComponent
        };
        (0, $gq0pG.ufoExperiences)['emoji-picker-opened'].start();
    }
    asyncLoadComponent() {
        (0, $71fL1.emojiPickerLoader)().then((component)=>{
            $ea9e9ba2907fa2a7$export$bcf219a275f21b24.AsyncLoadedComponent = component;
            this.setAsyncState(component);
        });
    }
    renderLoading() {
        const item = new (0, $d8fwQ.LoadingItem)();
        const handlePickerRef = (ref)=>{
            if (this.props.onPickerRef) this.props.onPickerRef(ref);
        };
        (0, $gq0pG.ufoExperiences)['emoji-picker-opened'].markFMP();
        return $ea9e9ba2907fa2a7$var$isRefreshEmojiPickerEnabled() ? /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            ref: handlePickerRef,
            className: (0, $4jQY2.default)([
                "_19itahnd _2rko1mok _1e0c1txw _2lx21bp4 _1bah1yb4 _bfhk1bhr _16qs130s _4t3iixjv _1bsb1edt _1ul91edt _1tke5x59 _c71l1y6z"
            ]),
            children: item.renderItem()
        }) : /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            ref: handlePickerRef,
            className: (0, $4jQY2.default)([
                "_19itahnd _2rkofajl _1e0c1txw _2lx21bp4 _1bah1yb4 _bfhk1bhr _16qs130s _4t3iixjv _1bsb1edt _1ul91edt _1tke5x59 _c71l1y6z"
            ]),
            children: item.renderItem()
        });
    }
    renderLoaded(loadedEmojiProvider, EmojiPickerComponent) {
        const { emojiProvider: emojiProvider, ...otherProps } = this.props;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9kdwp.UfoErrorBoundary), {
            experiences: [
                (0, $gq0pG.ufoExperiences)['emoji-picker-opened']
            ],
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e9q86.EmojiCommonProvider), {
                emojiProvider: loadedEmojiProvider,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)(EmojiPickerComponent, {
                    ...otherProps
                })
            })
        });
    }
}
$ea9e9ba2907fa2a7$export$bcf219a275f21b24.displayName = "EmojiPickerInternal";

});
parcelRegister("e9q86", function(module, exports) {
$parcel$export(module.exports, "EmojiCommonProvider", () => $4599867ba7228020$export$1120e666998e21b5);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $etTWq = parcelRequire("etTWq");
const $4599867ba7228020$export$1120e666998e21b5 = (props)=>{
    const emojiContextValue = (0, $euxye.useMemo)(()=>props.emojiProvider ? {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        } : undefined, [
        props.emojiProvider
    ]);
    if (!!emojiContextValue) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $etTWq.EmojiContextProvider), {
        emojiContextValue: emojiContextValue,
        children: props.children
    });
    else return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: props.children
    });
};
$4599867ba7228020$export$1120e666998e21b5.displayName = "EmojiCommonProvider";

});
parcelRegister("etTWq", function(module, exports) {
$parcel$export(module.exports, "EmojiContextProvider", () => $544c761541715067$export$f4a09143833145ed);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hyTKl = parcelRequire("hyTKl");

var $7vSev = parcelRequire("7vSev");
const $544c761541715067$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
    const memoizedEmojiContextValue = (0, $euxye.useMemo)(()=>emojiContextValue, [
        emojiContextValue
    ]);
    (0, $euxye.useEffect)(()=>{
        // trigger emoji fetching
        async function fetchEmojiProvider() {
            try {
                await memoizedEmojiContextValue?.emoji.emojiProvider.fetchEmojiProvider();
            } catch (error) {
                (0, $7vSev.default)('fetchEmojiProvider error catched from outside', error);
            }
        }
        if (memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand) {
            const isFetchingOnDemand = memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand();
            if (!isFetchingOnDemand) fetchEmojiProvider();
        } else fetchEmojiProvider();
    }, [
        memoizedEmojiContextValue
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hyTKl.EmojiContext).Provider, {
        value: memoizedEmojiContextValue,
        children: children
    });
};
$544c761541715067$export$f4a09143833145ed.displayName = "EmojiContextProvider";

});
parcelRegister("hyTKl", function(module, exports) {
$parcel$export(module.exports, "EmojiContext", () => $67d38b63f5617020$export$9fab6c37a453c65e);

var $euxye = parcelRequire("euxye");
const $67d38b63f5617020$export$9fab6c37a453c65e = (0, $euxye.createContext)(null);

});



parcelRegister("OX0zM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed998e58027c6477$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
class $ed998e58027c6477$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    constructor(props, state){
        super(props), this.isUnmounted = false, this.loaded = (state)=>!!state.asyncLoadedComponent && !!state.loadedEmojiProvider;
        this.state = state;
        // initializing here instead of componentDidMount to avoid needless
        // rerendering if emojiProvider resolves immediately.
        this.loadEmojiProvider(this.props.emojiProvider);
    }
    componentDidMount() {
        // check for the module has not yet been loaded
        // state.asyncLoadedComponent should be initialised
        // with static field to prevent unnecessary rerender
        if (!this.state.asyncLoadedComponent) this.asyncLoadComponent();
    }
    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) this.loadEmojiProvider(this.props.emojiProvider);
    }
    componentWillUnmount() {
        this.isUnmounted = true;
    }
    loadEmojiProvider(futureEmojiProvider) {
        futureEmojiProvider.then((loadedEmojiProvider)=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: loadedEmojiProvider
            });
        }).catch(()=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: undefined
            });
        });
    }
    setAsyncState(asyncLoadedComponent) {
        if (!this.isUnmounted) this.setState({
            asyncLoadedComponent: asyncLoadedComponent
        });
    }
    renderLoading() {
        return null;
    }
    render() {
        if (this.loaded(this.state)) {
            const { loadedEmojiProvider: loadedEmojiProvider, asyncLoadedComponent: asyncLoadedComponent } = this.state;
            return this.renderLoaded(loadedEmojiProvider, asyncLoadedComponent);
        }
        return this.renderLoading();
    }
}
$ed998e58027c6477$export$2e2bcd8739ae039.displayName = "LoadingEmojiComponent";

});

parcelRegister("9kdwp", function(module, exports) {
$parcel$export(module.exports, "UfoErrorBoundary", () => $aaab930da32e5d25$export$5ef1c2550074a375);

var $euxye = parcelRequire("euxye");
class $aaab930da32e5d25$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences){
            const { name: name, message: message } = error;
            const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
            exp.failure({
                metadata: {
                    source: 'UfoErrorBoundary',
                    reason: 'error',
                    error: {
                        name: name,
                        message: message,
                        infoStack: infoStack
                    }
                }
            });
        }
    }
    render() {
        return this.props.children;
    }
}
$aaab930da32e5d25$export$5ef1c2550074a375.displayName = "UfoErrorBoundary";

});

parcelRegister("d8fwQ", function(module, exports) {
$parcel$export(module.exports, "LoadingItem", () => $e75b9c092725616d$export$a16bfd7fb92e211d);
/* LoadingItem.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $abhF2 = parcelRequire("abhF2");

var $9JqOv = parcelRequire("9JqOv");

var $bpmfe = parcelRequire("bpmfe");
const $e75b9c092725616d$var$emojiPickerSpinner = null;
class $e75b9c092725616d$export$a16bfd7fb92e211d extends (0, $9JqOv.AbstractItem) {
    constructor(){
        super({}, (0, $bpmfe.sizes).loadingRowHeight), this.renderItem = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    "_1e0c1txw _1bsb1osq _4t3i1w81 _1bah1h6o _4cvr1h6o _nphsidpf _t1edidpf _1t3b1wug"
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {
                        size: "medium"
                    })
                })
            });
    }
}
$e75b9c092725616d$export$a16bfd7fb92e211d.displayName = "LoadingItem";

});
parcelRegister("9JqOv", function(module, exports) {
$parcel$export(module.exports, "AbstractItem", () => $95b8cf5c0cddf54b$export$8faa7b3aa4960e00);
class $95b8cf5c0cddf54b$export$8faa7b3aa4960e00 {
    constructor(props, height){
        this.props = props;
        this.height = height;
    }
}

});

parcelRegister("bpmfe", function(module, exports) {
$parcel$export(module.exports, "sizes", () => $99ecb171e2dc7205$export$c647cb0ee6e282fe);

var $3UnZm = parcelRequire("3UnZm");
const $99ecb171e2dc7205$export$c647cb0ee6e282fe = {
    listHeight: (0, $3UnZm.emojiPickerListHeight),
    listHeightNew: (0, $3UnZm.emojiPickerListHeightNew),
    listWidth: (0, $3UnZm.emojiPickerWidth),
    searchHeight: 52,
    categoryHeadingHeight: 30,
    emojiRowHeight: 40,
    addEmojiHeight: 32,
    loadingRowHeight: 150,
    noResultsHeight: 300,
    uploadActionHeight: 40,
    emojiPerRow: 8
};

});


parcelRegister("71fL1", function(module, exports) {
$parcel$export(module.exports, "emojiPickerLoader", () => $4e378b434e14f8f5$export$6b1deaa9ff7c5a6c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("euxye");

var $zgmgV = parcelRequire("zgmgV");
const $4e378b434e14f8f5$export$6b1deaa9ff7c5a6c = ()=>(0, $zgmgV.emojiPickerModuleLoader)().then((module)=>module.default);

});
parcelRegister("zgmgV", function(module, exports) {
$parcel$export(module.exports, "emojiPickerModuleLoader", () => $219c1c62844de590$export$de1ffc44591c1877);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
const $219c1c62844de590$export$de1ffc44591c1877 = ()=>(parcelRequire("dblh1"));

});
parcelRegister("dblh1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("j0uJb")
]).then(()=>parcelRequire('iQIRr'));

});





parcelRegister("20PTK", function(module, exports) {
$parcel$export(module.exports, "WithDragPreview", () => $88cf0cb9b4f692c0$export$2a1bb874975cd433);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");
const $88cf0cb9b4f692c0$export$2a1bb874975cd433 = ({ children: children, isEnabled: isEnabled })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: isEnabled ? [
            $88cf0cb9b4f692c0$var$draggingContanerStyles
        ] : []
    }, children);
};
$88cf0cb9b4f692c0$export$2a1bb874975cd433.displayName = "WithDragPreview";
const $88cf0cb9b4f692c0$var$draggingContanerStyles = (0, $fbAgj.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});

});

parcelRegister("5lCvX", function(module, exports) {
$parcel$export(module.exports, "EditableTitle", () => $472cb5ef371bc981$export$f9d7171ad5f156a8);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $vfr75 = parcelRequire("vfr75");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $7aCqr = parcelRequire("7aCqr");

var $HbfDU = parcelRequire("HbfDU");

var $i860n = parcelRequire("i860n");
const $472cb5ef371bc981$export$f9d7171ad5f156a8 = ({ value: value, elemBefore: elemBefore, onChanged: onChanged, onCancel: onCancel, label: label })=>{
    const textRef = (0, $euxye.useRef)(null);
    const [currentValue, setCurrentValue] = (0, $euxye.useState)(value);
    const triggerRef = (0, $euxye.useRef)(false);
    const hasConfirmIntentRef = (0, $euxye.useRef)(false);
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-reset-all-state-on-prop-change
    (0, $euxye.useEffect)(()=>{
        triggerRef.current = false;
        hasConfirmIntentRef.current = false;
        setCurrentValue(value);
        // focus the textfield async - there seems to be no reliable alternative to that
        const requestId = setTimeout(()=>textRef.current && textRef.current.focus(), 100);
        return ()=>clearTimeout(requestId);
    }, [
        value
    ]);
    const onTriggerCancel = (0, $euxye.useCallback)(()=>{
        if (!triggerRef.current) {
            triggerRef.current = true;
            setCurrentValue(value);
            onCancel();
        }
    }, [
        value,
        onCancel
    ]);
    const onTriggerConfirm = (0, $euxye.useCallback)(()=>{
        const finalValue = currentValue.trim();
        if (!triggerRef.current) {
            triggerRef.current = true;
            onChanged(finalValue);
        } else onCancel(finalValue);
    }, [
        currentValue,
        onCancel,
        onChanged
    ]);
    const onKeyDown = (0, $euxye.useCallback)((event)=>{
        const { key: key } = event;
        if (key === 'Escape' || key === 'Esc') onTriggerCancel();
        if (key === 'Enter') {
            if ((0, $i860n.fg)('pol-23465-section-id-focus-fix')) hasConfirmIntentRef.current = true;
            onTriggerConfirm();
        }
        if (key === 'Tab' && (0, $i860n.fg)('pol-23465-section-id-focus-fix')) {
            hasConfirmIntentRef.current = true;
            onTriggerConfirm();
        }
    }, [
        onTriggerCancel,
        onTriggerConfirm
    ]);
    const onChange = (0, $euxye.useCallback)((e)=>{
        setCurrentValue(e.target.value || '');
    }, []);
    const onBlurWithFocus = (0, $euxye.useCallback)(()=>{
        if (triggerRef.current) {
            hasConfirmIntentRef.current = false;
            return;
        }
        const isUnexpectedBlurOnFreshEmptyTitle = !hasConfirmIntentRef.current && value === '' && currentValue.trim() === '';
        if (isUnexpectedBlurOnFreshEmptyTitle) {
            requestAnimationFrame(()=>textRef.current?.focus());
            return;
        }
        hasConfirmIntentRef.current = false;
        onTriggerConfirm();
    }, [
        currentValue,
        onTriggerConfirm,
        value
    ]);
    const onOutsideClickWithFocus = (0, $euxye.useCallback)(()=>{
        hasConfirmIntentRef.current = true;
        onTriggerConfirm();
    }, [
        onTriggerConfirm
    ]);
    const onBlur = (0, $i860n.fg)('pol-23465-section-id-focus-fix') ? onBlurWithFocus : onTriggerConfirm;
    const onOutsideClick = (0, $i860n.fg)('pol-23465-section-id-focus-fix') ? onOutsideClickWithFocus : onTriggerConfirm;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $HbfDU.OutsideClickAlerter), {
        onClickOutside: onOutsideClick
    }, (outsideClickAlerterProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", outsideClickAlerterProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            ref: textRef,
            "aria-label": label,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.editable-title.ak-text-field",
            value: currentValue,
            onChange: onChange,
            onKeyDown: onKeyDown,
            maxLength: (0, $vfr75.VIEW_NAME_MAX_LENGTH),
            onBlur: onBlur,
            elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
                xcss: $472cb5ef371bc981$var$elementBeforeStyles
            }, elemBefore),
            className: (0, $4jQY2.default)([
                "_1e0c11p5 _yv0e5bpd _4cvr1h6o _vchhusvi _4t3izwfg _zy5bcs5v _13xo1w13 _1ut9azsu _1hxy1wq8 _gd2b1b66 _47hq12x7 _1yse1b66 _1yay12x7"
            ])
        })));
};
$472cb5ef371bc981$export$f9d7171ad5f156a8.displayName = "EditableTitle";
const $472cb5ef371bc981$var$elementBeforeStyles = (0, $fbAgj.xcss)({
    gridColumn: '1',
    display: 'flex',
    flexShrink: 0,
    width: '24px',
    height: '24px',
    alignItems: 'center',
    justifyContent: 'center',
    paddingInlineStart: 'space.075'
});
const $472cb5ef371bc981$var$textFieldStyles = null;

});
parcelRegister("HbfDU", function(module, exports) {
$parcel$export(module.exports, "OutsideClickAlerter", () => $c4dca07f8499cfbd$export$88de4b185c4a8c09);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /* eslint-disable @atlaskit/platform/no-direct-document-usage */ 
var $euxye = parcelRequire("euxye");
const $c4dca07f8499cfbd$export$88de4b185c4a8c09 = ({ onClickOutside: onClickOutside, children: children })=>{
    const innerClickRef = (0, $euxye.useRef)(false);
    const clickStartRef = (0, $euxye.useRef)(false);
    const handleClick = (0, $euxye.useCallback)((e)=>{
        if (clickStartRef.current && !innerClickRef.current && e.target) onClickOutside && onClickOutside(e);
        innerClickRef.current = false;
        clickStartRef.current = false;
    }, [
        onClickOutside
    ]);
    const innerClick = (0, $euxye.useCallback)(()=>{
        innerClickRef.current = true;
    }, []);
    const clickStart = (0, $euxye.useCallback)(()=>{
        clickStartRef.current = true;
    }, []);
    (0, $euxye.useEffect)(()=>{
        document.addEventListener('mousedown', clickStart, true);
        document.addEventListener('touchstart', clickStart, true);
        document.addEventListener('click', handleClick, true);
        document.addEventListener('touchend', handleClick, true);
        document.addEventListener('drop', handleClick, true);
        document.addEventListener('dragend', handleClick, true);
        return ()=>{
            document.removeEventListener('mousedown', clickStart, true);
            document.removeEventListener('touchstart', clickStart, true);
            document.removeEventListener('click', handleClick, true);
            document.removeEventListener('touchend', handleClick, true);
            document.removeEventListener('drop', handleClick, true);
            document.removeEventListener('dragend', handleClick, true);
        };
    }, [
        handleClick,
        clickStart
    ]);
    const childRenderProps = (0, $euxye.useMemo)(()=>({
            onMouseDownCapture: innerClick,
            onTouchEndCapture: innerClick
        }), [
        innerClick
    ]);
    return children(childRenderProps);
};
$c4dca07f8499cfbd$export$88de4b185c4a8c09.displayName = "OutsideClickAlerter";

});


parcelRegister("itiPA", function(module, exports) {
$parcel$export(module.exports, "ViewIcon", () => $7dc58e6d1d3b93fa$export$45097e3fcfc06744);
$parcel$export(module.exports, "TitleIconResolver", () => $7dc58e6d1d3b93fa$export$af7600ec6c79295f);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $koaaE = parcelRequire("koaaE");

var $8wdvw = parcelRequire("8wdvw");

var $8hGNs = parcelRequire("8hGNs");

var $8rdd5 = parcelRequire("8rdd5");

var $e7SYM = parcelRequire("e7SYM");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $8g0Rt = parcelRequire("8g0Rt");

var $hj9Qm = parcelRequire("hj9Qm");

var $hPnAm = parcelRequire("hPnAm");
const $7dc58e6d1d3b93fa$var$emojiButtonCaption = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.title-icon-resolver.emoji-button-caption",
    defaultMessage: "Pick an emoji"
});
const $7dc58e6d1d3b93fa$export$45097e3fcfc06744 = ({ emojiId: emojiId, viewKind: viewKind, isSelected: isSelected })=>{
    const [emoji, { loadEmoji: loadEmoji }] = (0, $8wdvw.useEmojiById)({
        emojiId: emojiId
    });
    const isViewKindLocked = (0, $hPnAm.useIsViewKindLocked)();
    (0, $euxye.useEffect)(()=>{
        // If emojiId is provided but emoji is not loaded yet
        if (emojiId && emoji === undefined) loadEmoji(emojiId);
    }, [
        emojiId,
        emoji,
        loadEmoji
    ]);
    // If emojiId is provided but emoji is not loaded yet show nothing
    if (emojiId && emoji === undefined) return null;
    // If emoji is loaded, render it
    if (emoji && !isViewKindLocked(viewKind)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8hGNs.EmojiWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8rdd5.default), {
        emoji: emoji,
        fitToHeight: 18,
        showTooltip: true
    }));
    // Otherwise, render the default view icon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8g0Rt.ViewItemIcon), {
        isSelected: isSelected,
        viewKind: viewKind,
        locked: isViewKindLocked(viewKind),
        label: ""
    });
};
$7dc58e6d1d3b93fa$export$45097e3fcfc06744.displayName = "ViewIcon";
const $7dc58e6d1d3b93fa$export$af7600ec6c79295f = ({ viewId: viewId, isSelected: isSelected, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { canManageView: canManageView } = (0, $koaaE.useManageViewPermissions)(viewId);
    const isReadOnly = (0, $hj9Qm.useIsReadOnly)();
    const isViewKindLocked = (0, $hPnAm.useIsViewKindLocked)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            "_1e0c11p5 _1lmc2ec4 _4cvr1h6o _1u6i1ule _14evglyw",
            canManageView && ((0, $i860n.fg)('jpd_tree-view') ? !isReadOnly && !isViewKindLocked(rest.viewKind) : !isReadOnly) && "_1e2iglyw _1bzu1ule"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-icon": "polaris-icon-wrapper",
        className: (0, $4jQY2.default)([
            "_nd5l2ec4 _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($7dc58e6d1d3b93fa$export$45097e3fcfc06744, {
        isSelected: isSelected,
        ...rest
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-icon": "add-emoji-container",
        className: (0, $4jQY2.default)([
            "_nd5l2ec4 _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e7SYM))), {
        spacing: "none",
        label: formatMessage($7dc58e6d1d3b93fa$var$emojiButtonCaption),
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    })));
};
$7dc58e6d1d3b93fa$export$af7600ec6c79295f.displayName = "TitleIconResolver";
const $7dc58e6d1d3b93fa$var$iconWrapperStyles = null;
const $7dc58e6d1d3b93fa$var$iconWrapperHoverStyles = null;
const $7dc58e6d1d3b93fa$var$gridChildStyles = null;

});
parcelRegister("e7SYM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b586782516017efdde3e3ed1084f411b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a48c5de239cff85f$var$_react = $a48c5de239cff85f$var$_interopRequireDefault((parcelRequire("euxye")));

var $a48c5de239cff85f$var$_baseNew = $a48c5de239cff85f$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $a48c5de239cff85f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/emoji-add
 * Usage guidance:
 * Single purpose - Reserved for adding an emoji reaction.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a48c5de239cff85f$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $a48c5de239cff85f$var$_react.default.createElement($a48c5de239cff85f$var$_baseNew.default, Object.assign({
        name: "EmojiAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 1 0 13 0H16a8 8 0 1 1-8-8v1.5A6.5 6.5 0 0 0 1.5 8m4.585 2.033c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513M5.75 7.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4.5 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m2.25-4h-2V2h2V0H14v2h2v1.5h-2v2h-1.5z" clip-rule="evenodd"/>`
    }, props));
$a48c5de239cff85f$var$EmojiAddIcon.displayName = 'EmojiAddIcon';
var $a48c5de239cff85f$var$_default = module.exports.default = $a48c5de239cff85f$var$EmojiAddIcon;

});


parcelRegister("6hKmX", function(module, exports) {
$parcel$export(module.exports, "DraggableRefContext", () => $8e5d711193a10d89$export$b0dddb9e0dab1fe7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
const $8e5d711193a10d89$export$b0dddb9e0dab1fe7 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});

parcelRegister("aMCiy", function(module, exports) {
$parcel$export(module.exports, "Menu", () => $8d1b3f7e6d402adf$export$d9b273488cd8ce6f);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4VTGT = parcelRequire("4VTGT");

var $eW8E0 = parcelRequire("eW8E0");

var $eq7Ww = parcelRequire("eq7Ww");

var $1AWbd = parcelRequire("1AWbd");

var $dH1Sa = parcelRequire("dH1Sa");

var $aGaXs = parcelRequire("aGaXs");

var $kmMHr = parcelRequire("kmMHr");

var $3kW31 = parcelRequire("3kW31");

var $koaaE = parcelRequire("koaaE");

var $b6kJl = parcelRequire("b6kJl");

var $anSqv = parcelRequire("anSqv");

var $gbTMi = parcelRequire("gbTMi");

var $72ldR = parcelRequire("72ldR");

var $g36LP = parcelRequire("g36LP");

var $ceqcm = parcelRequire("ceqcm");

var $ihEDU = parcelRequire("ihEDU");

var $8Sdzy = parcelRequire("8Sdzy");

var $a1Bqx = parcelRequire("a1Bqx");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $fNgVF = parcelRequire("fNgVF");

var $d8n9z = parcelRequire("d8n9z");


var $bcDCd = parcelRequire("bcDCd");

var $hVs7r = parcelRequire("hVs7r");

var $hj9Qm = parcelRequire("hj9Qm");

var $hPnAm = parcelRequire("hPnAm");
const $8d1b3f7e6d402adf$var$EMPTY_ARRAY = [];
const $8d1b3f7e6d402adf$var$renameAction = (0, $7eNDO.defineMessage)({
    defaultMessage: "Rename",
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.rename-action"
});
const $8d1b3f7e6d402adf$var$removeEmoji = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.remove-emoji",
    defaultMessage: "Remove emoji"
});
const $8d1b3f7e6d402adf$var$saveAsNewList = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.save-as-new-list",
    defaultMessage: "Save as new list"
});
const $8d1b3f7e6d402adf$var$saveAsNewSpaceList = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.save-as-new-space-list",
    defaultMessage: "Save as new space list"
});
const $8d1b3f7e6d402adf$var$saveAsNewBoard = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.save-as-new-board",
    defaultMessage: "Save as new board"
});
const $8d1b3f7e6d402adf$var$saveAsNewSpaceBoard = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.save-as-new-space-board",
    defaultMessage: "Save as new space board"
});
const $8d1b3f7e6d402adf$var$saveAsNewMatrix = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.save-as-new-matrix",
    defaultMessage: "Save as new matrix"
});
const $8d1b3f7e6d402adf$var$saveAsNewSpaceMatrix = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.save-as-new-space-matrix",
    defaultMessage: "Save as new space matrix"
});
const $8d1b3f7e6d402adf$var$saveAsNewTimeline = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.save-as-new-timeline",
    defaultMessage: "Save as new timeline"
});
const $8d1b3f7e6d402adf$var$saveAsNewSpaceTimeline = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.save-as-new-space-timeline",
    defaultMessage: "Save as new space timeline"
});
const $8d1b3f7e6d402adf$var$saveAsNewTree = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.save-as-new-tree",
    defaultMessage: "Save as new tree"
});
const $8d1b3f7e6d402adf$var$saveAsGlobalViewMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.save-as-global-view",
    defaultMessage: "Save as global view"
});
const $8d1b3f7e6d402adf$var$deleteAction = (0, $7eNDO.defineMessage)({
    defaultMessage: "Delete",
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.delete-action"
});
const $8d1b3f7e6d402adf$var$managedByAdmin = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.managed-by-admin",
    defaultMessage: "Managed by admin"
});
const $8d1b3f7e6d402adf$var$editGlobalViewMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.edit-global-view",
    defaultMessage: "Edit global view"
});
const $8d1b3f7e6d402adf$var$styles = {
    adminNoticeContainer: "_18zrpxbi _1rjcpxbi _mqm2ia51 _bfhki8nm"
};
const $8d1b3f7e6d402adf$var$NavMenuItems = ({ onClose: onClose, onDelete: onDelete, onOpenCloneModal: onOpenCloneModal, onTrack: onTrack, view: view, navigationContainer: navigationContainer })=>{
    const containerId = (0, $hj9Qm.useContainerId)();
    const { renameView: renameView, cloneView: cloneView, deleteEmoji: deleteEmoji } = (0, $kmMHr.useNavigationActions)();
    const containerTypePermissions = (0, $hj9Qm.useContainerTypePermissions)();
    const { canManageView: canManageView, canSeeView: canSeeView, canManageViews: canManageViews } = (0, $koaaE.useManageViewPermissions)(containerTypePermissions === 'view' ? view.id : containerId);
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const isReadOnly = (0, $hj9Qm.useIsReadOnly)();
    const viewsEntityLimitType = (0, $hj9Qm.useViewsEntityLimitType)();
    const containerViewsCount = (0, $3kW31.useContainerViewsCount)({
        containerId: containerId
    });
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const isViewKindLocked = (0, $hPnAm.useIsViewKindLocked)();
    const isViewLocked = isViewKindLocked(view.viewType);
    const isGlobalView = Boolean(view.global) && (0, $i860n.fg)('polaris_global_views');
    const canCreateFields = (0, $b6kJl.useCanCreateFields)();
    const isViewTemplateButtonVisible = canCreateFields && (0, $d8n9z.isNavigationProject)(navigationContainer) && !(0, $2700E.expVal)('polaris_pol-24012-remove-templates-from-view-menu', 'isEnabled', false);
    const handleViewTemplatesClick = (0, $euxye.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    const isLastView = containerViewsCount === 1;
    const canRenameView = (0, $i860n.fg)('jpd_tree-view') ? canManageView && !isViewLocked : canManageView;
    const canDeleteView = canManageView && !isReadOnly && !isLastView;
    const canRemoveEmoji = !isGlobalView && ((0, $i860n.fg)('jpd_tree-view') ? Boolean(view.emoji) && !isViewLocked : Boolean(view.emoji));
    const canSaveAsNewBoard = (0, $i860n.fg)('jpd_tree-view') ? [
        (0, $dH1Sa.VIEW_KIND_TABLE),
        (0, $dH1Sa.VIEW_KIND_BOARD)
    ].includes(view.viewType) : view.viewType !== (0, $dH1Sa.VIEW_KIND_MATRIX) && view.viewType !== (0, $dH1Sa.VIEW_KIND_TIMELINE);
    const canSaveAsNewMatrix = view.viewType === (0, $dH1Sa.VIEW_KIND_MATRIX);
    const canSaveAsNewTimeline = view.viewType === (0, $dH1Sa.VIEW_KIND_TIMELINE);
    const canClone = containerTypePermissions === 'view' ? canManageViews && canSeeView && !isReadOnly : canManageView && canSeeView && !isReadOnly;
    const canSaveAsNewList = view.viewType !== (0, $dH1Sa.VIEW_KIND_TREE);
    const canSaveAsNewTree = view.viewType === (0, $dH1Sa.VIEW_KIND_TREE) && !isViewLocked;
    const canSaveAsGlobalView = (0, $eW8E0.useCanSaveAsGlobalView)({
        isGlobalView: isGlobalView,
        viewKind: view.viewType
    });
    const handleRename = (0, $euxye.useCallback)(()=>{
        onTrack((0, $5728d78b7c955d95$export$5a199ff4838c2d44));
        renameView(view.localId);
    }, [
        onTrack,
        renameView,
        view.localId
    ]);
    const handleRemoveEmoji = (0, $euxye.useCallback)(()=>{
        onTrack((0, $5728d78b7c955d95$export$988c6ce277d2a6d4));
        deleteEmoji(view.localId);
    }, [
        deleteEmoji,
        onTrack,
        view.localId
    ]);
    const handleCloneTable = (0, $euxye.useCallback)(()=>{
        onTrack((0, $5728d78b7c955d95$export$6336d3fe097afb34));
        cloneView(view.localId, (0, $dH1Sa.VIEW_KIND_TABLE));
    }, [
        cloneView,
        onTrack,
        view.localId
    ]);
    const handleCloneBoard = (0, $euxye.useCallback)(()=>{
        onTrack((0, $5728d78b7c955d95$export$6336d3fe097afb34));
        cloneView(view.localId, (0, $dH1Sa.VIEW_KIND_BOARD));
    }, [
        cloneView,
        onTrack,
        view.localId
    ]);
    const handleCloneMatrix = (0, $euxye.useCallback)(()=>{
        onTrack((0, $5728d78b7c955d95$export$6336d3fe097afb34));
        cloneView(view.localId, (0, $dH1Sa.VIEW_KIND_MATRIX));
    }, [
        cloneView,
        onTrack,
        view.localId
    ]);
    const handleCloneTimeline = (0, $euxye.useCallback)(()=>{
        onTrack((0, $5728d78b7c955d95$export$6336d3fe097afb34));
        cloneView(view.localId, (0, $dH1Sa.VIEW_KIND_TIMELINE));
    }, [
        cloneView,
        onTrack,
        view.localId
    ]);
    const handleCloneTree = (0, $euxye.useCallback)(()=>{
        onTrack((0, $5728d78b7c955d95$export$6336d3fe097afb34));
        cloneView(view.localId, (0, $dH1Sa.VIEW_KIND_TREE));
    }, [
        cloneView,
        onTrack,
        view.localId
    ]);
    const handleDelete = (0, $euxye.useCallback)(()=>{
        onTrack((0, $5728d78b7c955d95$export$e42bb9e4ae8f6958));
        onDelete();
    }, [
        onDelete,
        onTrack
    ]);
    const handleEditGlobalView = (0, $euxye.useCallback)(()=>{
        onTrack((0, $5728d78b7c955d95$export$2760493571fa6f99)); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(`/jira/settings/products/jira-product-discovery/global-views/${view.globalViewUuid}`, '_blank', 'noopener,noreferrer');
    }, [
        onTrack,
        view.globalViewUuid
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), {
        minWidth: 250,
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true
    }, !isGlobalView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        onClick: handleRename,
        isDisabled: !canRenameView || isReadOnly
    }, formatMessage($8d1b3f7e6d402adf$var$renameAction)), canRemoveEmoji && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        onClick: handleRemoveEmoji,
        isDisabled: !canManageView || isReadOnly
    }, formatMessage($8d1b3f7e6d402adf$var$removeEmoji)), (canSaveAsNewList || !(0, $i860n.fg)('jpd_tree-view')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hVs7r.HardLimitsTooltip), {
        containerId: containerId,
        entityLimitType: viewsEntityLimitType
    }, ({ isLimitReached: isLimitReached })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
            isDisabled: !canClone || isLimitReached,
            onClick: handleCloneTable
        }, formatMessage(isGlobalView ? $8d1b3f7e6d402adf$var$saveAsNewSpaceList : $8d1b3f7e6d402adf$var$saveAsNewList))), canSaveAsNewBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hVs7r.HardLimitsTooltip), {
        containerId: containerId,
        entityLimitType: viewsEntityLimitType
    }, ({ isLimitReached: isLimitReached })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
            isDisabled: !canClone || isLimitReached,
            onClick: handleCloneBoard
        }, formatMessage(isGlobalView ? $8d1b3f7e6d402adf$var$saveAsNewSpaceBoard : $8d1b3f7e6d402adf$var$saveAsNewBoard))), canSaveAsNewMatrix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hVs7r.HardLimitsTooltip), {
        containerId: containerId,
        entityLimitType: viewsEntityLimitType
    }, ({ isLimitReached: isLimitReached })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
            isDisabled: !canClone || isLimitReached,
            onClick: handleCloneMatrix
        }, formatMessage(isGlobalView ? $8d1b3f7e6d402adf$var$saveAsNewSpaceMatrix : $8d1b3f7e6d402adf$var$saveAsNewMatrix))), canSaveAsNewTimeline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hVs7r.HardLimitsTooltip), {
        containerId: containerId,
        entityLimitType: viewsEntityLimitType
    }, ({ isLimitReached: isLimitReached })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
            isDisabled: !canClone || isLimitReached,
            onClick: handleCloneTimeline
        }, formatMessage(isGlobalView ? $8d1b3f7e6d402adf$var$saveAsNewSpaceTimeline : $8d1b3f7e6d402adf$var$saveAsNewTimeline))), canSaveAsNewTree && (0, $i860n.fg)('jpd_tree-view') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hVs7r.HardLimitsTooltip), {
        containerId: containerId,
        entityLimitType: viewsEntityLimitType
    }, ({ isLimitReached: isLimitReached })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
            isDisabled: !canClone || isLimitReached,
            onClick: handleCloneTree
        }, formatMessage($8d1b3f7e6d402adf$var$saveAsNewTree)))), canSaveAsGlobalView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        onClick: onOpenCloneModal
    }, formatMessage($8d1b3f7e6d402adf$var$saveAsGlobalViewMessage))), isGlobalView && isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        onClick: handleEditGlobalView,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))), {
            label: ""
        })
    }, formatMessage($8d1b3f7e6d402adf$var$editGlobalViewMessage))) : !isGlobalView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        isDisabled: !canDeleteView,
        onClick: handleDelete
    }, !canDeleteView ? formatMessage($8d1b3f7e6d402adf$var$deleteAction) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        color: "color.text.danger"
    }, formatMessage($8d1b3f7e6d402adf$var$deleteAction)))), isViewTemplateButtonVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1AWbd.ViewTemplatesButton), {
        onClick: handleViewTemplatesClick,
        projectId: navigationContainer.projectId,
        projectKey: navigationContainer.projectKey
    })), isGlobalView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $8d1b3f7e6d402adf$var$styles.adminNoticeContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage($8d1b3f7e6d402adf$var$managedByAdmin))));
};
$8d1b3f7e6d402adf$var$NavMenuItems.displayName = "NavMenuItems";
function $8d1b3f7e6d402adf$export$d9b273488cd8ce6f({ view: view, navigationContainer: navigationContainer }) {
    const containerId = (0, $hj9Qm.useContainerId)();
    const { deleteView: deleteView } = (0, $kmMHr.useNavigationActions)();
    const containerTypePermissions = (0, $hj9Qm.useContainerTypePermissions)();
    const { loadViewPermissionsForCurrentUser: loadViewPermissionsForCurrentUser } = (0, $koaaE.useManageViewPermissions)(containerTypePermissions === 'view' ? view.id : containerId);
    const { sendMeatBallDropDownOnViewsMenuItemAnalyticsEvent: sendMeatBallDropDownOnViewsMenuItemAnalyticsEvent } = (0, $hj9Qm.useAnalyticsL4)();
    const { sendMeatBallDropDownOnViewsAnalyticsEvent: sendMeatBallDropDownOnViewsAnalyticsEvent } = (0, $hj9Qm.useAnalyticsL3)();
    const { syncStateWithCollectionStoreAfterViewDelete: syncStateWithCollectionStoreAfterViewDelete } = (0, $anSqv.useCollectionsActions)();
    const cloneViewIntoGlobal = (0, $eq7Ww.useCloneViewIntoGlobal)();
    const trackMenuItemAnalyticsEvent = (0, $euxye.useCallback)((itemId)=>{
        sendMeatBallDropDownOnViewsMenuItemAnalyticsEvent({
            itemId: itemId,
            container: navigationContainer,
            viewParams: {
                viewKind: view.viewType,
                viewId: view.id
            }
        });
    }, [
        navigationContainer,
        sendMeatBallDropDownOnViewsMenuItemAnalyticsEvent,
        view.id,
        view.viewType
    ]);
    const [isDeleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = (0, $euxye.useState)(false);
    const [isCloneIntoGlobalModalOpen, setCloneIntoGlobalModalOpen] = (0, $euxye.useState)(false);
    const viewPermissionsId = containerTypePermissions === 'view' ? view.id : containerId;
    const handleNavMenuOpen = (0, $euxye.useCallback)(()=>{
        sendMeatBallDropDownOnViewsAnalyticsEvent({
            container: navigationContainer,
            viewParams: {
                viewKind: view.viewType,
                viewId: view.id
            }
        });
        loadViewPermissionsForCurrentUser(viewPermissionsId);
    }, [
        loadViewPermissionsForCurrentUser,
        navigationContainer,
        sendMeatBallDropDownOnViewsAnalyticsEvent,
        view.id,
        view.viewType,
        viewPermissionsId
    ]);
    const handleDelete = (0, $euxye.useCallback)(()=>{
        setDeleteConfirmationModalOpen(true);
    }, []);
    const handleDeleteModalCancel = (0, $euxye.useCallback)(()=>{
        setDeleteConfirmationModalOpen(false);
    }, []);
    const handleDeleteModalConfirm = (0, $euxye.useCallback)(()=>{
        setDeleteConfirmationModalOpen(false);
        deleteView(view.localId);
        syncStateWithCollectionStoreAfterViewDelete(containerId, view.id);
    }, [
        containerId,
        deleteView,
        syncStateWithCollectionStoreAfterViewDelete,
        view.id,
        view.localId
    ]);
    const handleOpenCloneModal = (0, $euxye.useCallback)(()=>{
        setCloneIntoGlobalModalOpen(true);
    }, []);
    const handleCloseCloneModal = (0, $euxye.useCallback)(()=>{
        setCloneIntoGlobalModalOpen(false);
    }, []);
    const handleConfirmCloneModal = (0, $euxye.useCallback)(()=>{
        setCloneIntoGlobalModalOpen(false);
        cloneViewIntoGlobal(view.id);
    }, [
        cloneViewIntoGlobal,
        view.id
    ]);
    const MenuItems = (0, $euxye.useCallback)(({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d1b3f7e6d402adf$var$NavMenuItems, {
            onClose: onClose,
            onDelete: handleDelete,
            onOpenCloneModal: handleOpenCloneModal,
            onTrack: trackMenuItemAnalyticsEvent,
            view: view,
            navigationContainer: navigationContainer
        }), [
        handleDelete,
        handleOpenCloneModal,
        navigationContainer,
        trackMenuItemAnalyticsEvent,
        view
    ]);
    if ((0, $aGaXs.isFakeId)(view.id)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
        onOpen: handleNavMenuOpen,
        MenuItems: MenuItems,
        name: view.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bcDCd.DeleteModal), {
        title: view.name,
        isOpen: isDeleteConfirmationModalOpen,
        onCancel: handleDeleteModalCancel,
        onConfirm: handleDeleteModalConfirm
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4VTGT.CloneViewIntoGlobalModal), {
        isOpen: isCloneIntoGlobalModalOpen,
        onClose: handleCloseCloneModal,
        onConfirm: handleConfirmCloneModal,
        fields: $8d1b3f7e6d402adf$var$EMPTY_ARRAY
    }));
}
$8d1b3f7e6d402adf$export$d9b273488cd8ce6f.displayName = "Menu";

});
parcelRegister("4VTGT", function(module, exports) {
$parcel$export(module.exports, "CloneViewIntoGlobalModal", () => $c9ea03880d19adc8$export$f2f85090a86b6afd);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $iyuPe = parcelRequire("iyuPe");

var $8wdvw = parcelRequire("8wdvw");

var $k6sZT = parcelRequire("k6sZT");

var $7tY81 = parcelRequire("7tY81");

var $2v3yi = parcelRequire("2v3yi");

var $4vluQ = parcelRequire("4vluQ");

var $gpyJM = parcelRequire("gpyJM");

var $dNPnD = parcelRequire("dNPnD");

var $9imxF = parcelRequire("9imxF");

var $iOfms = parcelRequire("iOfms");

var $ihEDU = parcelRequire("ihEDU");

var $2XXtG = parcelRequire("2XXtG");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $8rdd5 = parcelRequire("8rdd5");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $c9ea03880d19adc8$var$titleMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component.clone-view-into-global.modal.title",
    defaultMessage: "Save as global view"
});
const $c9ea03880d19adc8$var$descriptionMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component.clone-view-into-global.modal.description",
    defaultMessage: "Converting to a global view will save only the global fields from this view. You can later select where to add this global view from the admin settings."
});
const $c9ea03880d19adc8$var$globalFieldsTitleMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component.clone-view-into-global.modal.global-fields-title",
    defaultMessage: "Global fields will be added"
});
const $c9ea03880d19adc8$var$cancelMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component.clone-view-into-global.modal.cancel",
    defaultMessage: "Cancel"
});
const $c9ea03880d19adc8$var$saveMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component.clone-view-into-global.modal.save",
    defaultMessage: "Save"
});
const $c9ea03880d19adc8$var$spaceFieldsNoteMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-component.clone-view-into-global.modal.space-fields-note",
    defaultMessage: "{fieldNames} {count, plural, one {is a space field and} other {are space fields and}} thus can't be added to global views."
});
const $c9ea03880d19adc8$var$styles = {
    globalFieldsBox: "_2rko1qi0 _1rjcpxbi _18zrpxbi _bfhk19ip",
    fieldItem: "_1reo15vq _18m915vq",
    fieldsGrid: "_zulpu2gc _1e0c11p5 _yv0e1qr0"
};
const $c9ea03880d19adc8$var$FieldIcon = (t0)=>{
    const $ = (0, $e7boj.c)(5);
    const { field: field } = t0;
    let t1;
    if ($[0] !== field.label) {
        t1 = {
            label: field.label,
            size: "small"
        };
        $[0] = field.label;
        $[1] = t1;
    } else t1 = $[1];
    const icon = (0, $iyuPe.useFieldTypeIcon)(field.key, t1);
    const emojiId = (0, $iyuPe.useFieldEmoji)(field.key);
    const emoji = (0, $8wdvw.useEmoji)(emojiId);
    let t2;
    if ($[2] !== emoji || $[3] !== icon) {
        t2 = emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8rdd5.default), {
            emoji: emoji,
            fitToHeight: 16,
            showTooltip: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, icon);
        $[2] = emoji;
        $[3] = icon;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
$c9ea03880d19adc8$var$FieldIcon.displayName = "FieldIcon";
const $c9ea03880d19adc8$var$FieldListItem = (t0)=>{
    const $ = (0, $e7boj.c)(7);
    const { field: field } = t0;
    let t1;
    if ($[0] !== field) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c9ea03880d19adc8$var$FieldIcon, {
            field: field
        });
        $[0] = field;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== field.label) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
            size: "small"
        }, field.label);
        $[2] = field.label;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), {
            alignItems: "center",
            gap: "space.075",
            xcss: $c9ea03880d19adc8$var$styles.fieldItem
        }, t1, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
$c9ea03880d19adc8$var$FieldListItem.displayName = "FieldListItem";
const $c9ea03880d19adc8$export$f2f85090a86b6afd = (t0)=>{
    const $ = (0, $e7boj.c)(14);
    const { isOpen: isOpen, onClose: onClose, onConfirm: onConfirm, fields: fields } = t0;
    const { formatMessage: formatMessage, formatList: formatList } = (0, $1YIbA.default)();
    let t1;
    if ($[0] !== fields) {
        t1 = fields.filter($c9ea03880d19adc8$var$_temp);
        $[0] = fields;
        $[1] = t1;
    } else t1 = $[1];
    const globalFields = t1;
    let t2;
    if ($[2] !== fields) {
        t2 = fields.filter($c9ea03880d19adc8$var$_temp2);
        $[2] = fields;
        $[3] = t2;
    } else t2 = $[3];
    const spaceFields = t2;
    let t3;
    if ($[4] !== formatList || $[5] !== formatMessage || $[6] !== globalFields || $[7] !== isOpen || $[8] !== onClose || $[9] !== onConfirm || $[10] !== spaceFields) {
        t3 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k6sZT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7tY81.default), {
            onClose: onClose
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gpyJM.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dNPnD.default), null, formatMessage($c9ea03880d19adc8$var$titleMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v3yi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
            space: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($c9ea03880d19adc8$var$descriptionMessage)), globalFields.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
            xcss: $c9ea03880d19adc8$var$styles.globalFieldsBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
            weight: "bold",
            size: "medium"
        }, formatMessage($c9ea03880d19adc8$var$globalFieldsTitleMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
            xcss: $c9ea03880d19adc8$var$styles.fieldsGrid
        }, globalFields.map($c9ea03880d19adc8$var$_temp3)))), spaceFields.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($c9ea03880d19adc8$var$spaceFieldsNoteMessage, {
            fieldNames: formatList(spaceFields.map($c9ea03880d19adc8$var$_temp4)),
            count: spaceFields.length
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4vluQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
            onClick: onClose
        }, formatMessage($c9ea03880d19adc8$var$cancelMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
            appearance: "primary",
            onClick: onConfirm
        }, formatMessage($c9ea03880d19adc8$var$saveMessage)))));
        $[4] = formatList;
        $[5] = formatMessage;
        $[6] = globalFields;
        $[7] = isOpen;
        $[8] = onClose;
        $[9] = onConfirm;
        $[10] = spaceFields;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9imxF.default), null, t3);
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
};
$c9ea03880d19adc8$export$f2f85090a86b6afd.displayName = "CloneViewIntoGlobalModal";
function $c9ea03880d19adc8$var$_temp(f) {
    return f.global;
}
function $c9ea03880d19adc8$var$_temp2(f_0) {
    return f_0.custom && !f_0.global;
}
function $c9ea03880d19adc8$var$_temp3(field) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c9ea03880d19adc8$var$FieldListItem, {
        key: field.key,
        field: field
    });
}
function $c9ea03880d19adc8$var$_temp4(f_1) {
    return f_1.label;
}

});
parcelRegister("iyuPe", function(module, exports) {
$parcel$export(module.exports, "useFieldTypeIcon", () => $a7fd7e5bbe7fb5f3$export$dc8276c414bd566b);
$parcel$export(module.exports, "useFieldLabelsMap", () => $a7fd7e5bbe7fb5f3$export$a6b9ad6ff7ac1c3);
$parcel$export(module.exports, "useFieldTypes", () => $a7fd7e5bbe7fb5f3$export$525153244eb07c87);
$parcel$export(module.exports, "useFieldDescription", () => $a7fd7e5bbe7fb5f3$export$a4c269b2393edbad);
$parcel$export(module.exports, "useFieldEmoji", () => $a7fd7e5bbe7fb5f3$export$dd434aee3e47a744);
$parcel$export(module.exports, "useFieldTypeByKey", () => $a7fd7e5bbe7fb5f3$export$3dfe72f75930aa1c);

var $3h1FP = parcelRequire("3h1FP");

var $jxZmP = parcelRequire("jxZmP");

var $2cQDy = parcelRequire("2cQDy");

var $4EUgt = parcelRequire("4EUgt");

var $aVKCJ = parcelRequire("aVKCJ");
const $a7fd7e5bbe7fb5f3$export$dc8276c414bd566b = (0, $aVKCJ.createHigherLevelFieldHook2)((0, $2cQDy.getFieldTypeIcon));
const $a7fd7e5bbe7fb5f3$export$fa3a053d9c0d95bc = (0, $3h1FP.createHook)((0, $jxZmP.FieldStore), {
    selector: (0, $4EUgt.getFieldLabels)
});
const $a7fd7e5bbe7fb5f3$export$a6b9ad6ff7ac1c3 = (0, $3h1FP.createStateHook)((0, $jxZmP.FieldStore), {
    selector: (0, $4EUgt.getFieldLabels)
});
const $a7fd7e5bbe7fb5f3$export$525153244eb07c87 = (0, $3h1FP.createHook)((0, $jxZmP.FieldStore), {
    selector: (0, $4EUgt.getNewFieldTypes)
});
const $a7fd7e5bbe7fb5f3$export$a4c269b2393edbad = (0, $aVKCJ.createHigherLevelFieldHook)((0, $2cQDy.createGetFieldDescription));
const $a7fd7e5bbe7fb5f3$export$dd434aee3e47a744 = (0, $aVKCJ.createHigherLevelFieldHook)((0, $2cQDy.createGetFieldEmoji));
const $a7fd7e5bbe7fb5f3$export$3dfe72f75930aa1c = (0, $jxZmP.createFieldHook)((0, $4EUgt.getFieldTypeByKey));

});
parcelRegister("jxZmP", function(module, exports) {
$parcel$export(module.exports, "FieldStore", () => $0ab22a0321e8c1f8$export$4ad445d34451ebf6);
$parcel$export(module.exports, "FieldContainer", () => $0ab22a0321e8c1f8$export$b5c4b0e7cd7f148b);
$parcel$export(module.exports, "useFieldActions", () => $0ab22a0321e8c1f8$export$e8302bcaff9f6eae);
$parcel$export(module.exports, "createFieldHook", () => $0ab22a0321e8c1f8$export$4cddd3725060adbc);
$parcel$export(module.exports, "createHigherLevelFieldHook", () => $0ab22a0321e8c1f8$export$67d6a9af20f2969f);

var $h3LDK = parcelRequire("h3LDK");

var $gtDeG = parcelRequire("gtDeG");

var $euq4d = parcelRequire("euq4d");

var $3h1FP = parcelRequire("3h1FP");
var $dB6ay = parcelRequire("dB6ay");
var $5QDqc = parcelRequire("5QDqc");

var $k1mjO = parcelRequire("k1mjO");

var $l668O = parcelRequire("l668O");

var $1qyaa = parcelRequire("1qyaa");

var $ibndn = parcelRequire("ibndn");
const $0ab22a0321e8c1f8$export$d4c72bab9d6cc13a = {
    meta: {
        initialized: false,
        loading: false,
        loadingSnippetProviders: false,
        error: undefined,
        loadingProps: undefined,
        projectIsNotOnboardedError: false,
        scheduleFieldsReload: false,
        connectionsLoadingFieldsAssociations: []
    },
    fields: {},
    fieldValueDecorations: {},
    snippetProviders: undefined,
    containerProps: undefined,
    throttledFetchSnippetProviders: undefined,
    newlyAddedGlobalFields: [],
    connectionsFieldsAssociations: {},
    lastFieldsUpdate: null
};
const $0ab22a0321e8c1f8$export$4ad445d34451ebf6 = (0, $5QDqc.createStore)({
    name: 'PolarisFieldStore',
    initialState: $0ab22a0321e8c1f8$export$d4c72bab9d6cc13a,
    actions: $ibndn.actions
});
const $0ab22a0321e8c1f8$export$b5c4b0e7cd7f148b = (0, $dB6ay.createContainer)($0ab22a0321e8c1f8$export$4ad445d34451ebf6, {
    displayName: 'PolarisFieldStoreContainer',
    getIsConcurrentSafe: ()=>true,
    ...(0, $euq4d.getStoreHandlersWithStatefullContainerProps)({
        onInit: ()=>({ dispatch: dispatch })=>{
                dispatch((0, $l668O.loadFields)());
                dispatch((0, $1qyaa.throttledFetchSnippetProviders)());
            },
        onUpdate: ()=>({ dispatch: dispatch, getState: getState }, props)=>{
                const { prevContainerProps: prevContainerProps } = getState();
                if (prevContainerProps?.issueTypeIds && props.issueTypeIds !== prevContainerProps.issueTypeIds) dispatch((0, $k1mjO.syncFieldsIssueTypes)());
                dispatch((0, $l668O.loadFields)());
                dispatch((0, $1qyaa.throttledFetchSnippetProviders)());
            }
    })
});
const $0ab22a0321e8c1f8$export$e8302bcaff9f6eae = (0, $3h1FP.createActionsHook)($0ab22a0321e8c1f8$export$4ad445d34451ebf6);
const $0ab22a0321e8c1f8$export$4cddd3725060adbc = (0, $h3LDK.getCreateStoreHook)($0ab22a0321e8c1f8$export$4ad445d34451ebf6);
const $0ab22a0321e8c1f8$export$67d6a9af20f2969f = (0, $gtDeG.getCreateHigherLevelHook)($0ab22a0321e8c1f8$export$4ad445d34451ebf6);

});
parcelRegister("h3LDK", function(module, exports) {
$parcel$export(module.exports, "getCreateStoreHook", () => $02849b2e977b793e$export$d2975026ec2fe1a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
function $02849b2e977b793e$export$d2975026ec2fe1a(store) {
    return function createStoreHook(selector) {
        return (0, $3h1FP.createStateHook)(store, {
            selector: selector
        });
    };
}

});

parcelRegister("k1mjO", function(module, exports) {
$parcel$export(module.exports, "syncFieldsIssueTypes", () => $802b6e9ffcbe8284$export$d7a3173c9ec3a590);

var $dSJEI = parcelRequire("dSJEI");
const $802b6e9ffcbe8284$export$d7a3173c9ec3a590 = ()=>({ setState: setState, getState: getState }, { issueTypeIds: issueTypeIds = [] })=>{
        setState({
            fields: (0, (/*@__PURE__*/$parcel$interopDefault($dSJEI)))(getState().fields, (field)=>({
                    ...field,
                    issueTypes: issueTypeIds
                }))
        });
    };

});

parcelRegister("l668O", function(module, exports) {
$parcel$export(module.exports, "loadFields", () => $e111e9d234f09203$export$6c106ef18bd092b8);

var $e9KPj = parcelRequire("e9KPj");

var $7zNk8 = parcelRequire("7zNk8");

var $9nfpB = parcelRequire("9nfpB");
// Error message: [...] API-9998 permission check failed [...]
const $e111e9d234f09203$var$isPermissionCheckError = (error)=>error instanceof Error ? error.message.search('API-9998') !== -1 : false;
const $e111e9d234f09203$var$detectAndHandleCyclicFormulaDependency = (containerProps, fields)=>{
    const cyclicFieldLabels = Object.values(fields).map((field)=>field.hasCyclicFormulaDependency ? field.label : undefined).filter(Boolean);
    if (cyclicFieldLabels.length > 0) containerProps.onCyclicFormulaDependencyDetected(cyclicFieldLabels);
};
const $e111e9d234f09203$export$6c106ef18bd092b8 = (forceReload, scheduledReload)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, containerProps)=>{
        const { containerAri: containerAri, isProjectOnboarded: isProjectOnboarded, fieldRemote: fieldRemote, isSiteAdmin: isSiteAdmin } = containerProps;
        const loadingProps = {
            containerAri: containerAri,
            isProjectOnboarded: isProjectOnboarded
        };
        const { meta: { loadingProps: previousLoadingProps, loading: isLoadingInProgress, initialized: initialized } } = getState();
        // Only load again when the props this function depends on have changed
        if (forceReload !== true && (0, $7zNk8.isShallowEqual)(loadingProps, previousLoadingProps)) {
            if (!getState().meta.projectIsNotOnboardedError) return;
        }
        if (forceReload !== true && !scheduledReload) {
            if (initialized) return;
            if (isLoadingInProgress) {
                setState({
                    meta: {
                        ...getState().meta,
                        scheduleFieldsReload: true
                    }
                });
                return;
            }
        }
        (0, $9nfpB.jpdProjectPageLoad).mark((0, $9nfpB.PAGE_LOAD_MARK_LOAD_FIELDS_START));
        setState({
            meta: {
                ...getState().meta,
                initialized: false,
                loading: true,
                error: undefined,
                loadingProps: loadingProps,
                projectIsNotOnboardedError: false
            }
        });
        try {
            const fieldData = await fieldRemote.fetchAllFields();
            (0, $9nfpB.jpdProjectPageLoad).mark((0, $9nfpB.PAGE_LOAD_MARK_LOAD_FIELDS_END));
            setState({
                meta: {
                    ...getState().meta,
                    initialized: true,
                    loading: false,
                    scheduleFieldsReload: false,
                    projectIsNotOnboardedError: false,
                    error: undefined,
                    loadingProps: loadingProps
                },
                ...fieldData
            });
            $e111e9d234f09203$var$detectAndHandleCyclicFormulaDependency(containerProps, fieldData.fields);
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9nfpB.jpdProjectPageLoad).mark((0, $9nfpB.PAGE_LOAD_MARK_LOAD_FIELDS_END));
            if (error instanceof (0, $e9KPj.RemoteFieldsNotInitializedError)) {
                const scheduleFieldsReload = getState().meta.scheduleFieldsReload;
                if (!getState().meta.initialized || forceReload === true) {
                    setState({
                        meta: {
                            ...getState().meta,
                            initialized: false,
                            loading: false,
                            scheduleFieldsReload: false,
                            projectIsNotOnboardedError: true
                        }
                    });
                    if (scheduleFieldsReload) {
                        setState({
                            meta: {
                                ...getState().meta,
                                loading: false,
                                scheduleFieldsReload: false
                            }
                        });
                        dispatch($e111e9d234f09203$export$6c106ef18bd092b8(false, true));
                    }
                }
                // we return early here,
                // we want to try loading again since the project is still loading
                return;
            }
            const scheduleFieldsReload = getState().meta.scheduleFieldsReload;
            setState({
                meta: {
                    ...getState().meta,
                    initialized: false,
                    loading: false,
                    error: error,
                    scheduleFieldsReload: false,
                    projectIsNotOnboardedError: false,
                    loadingProps: undefined
                },
                fields: {},
                fieldValueDecorations: {}
            });
            if (scheduleFieldsReload) {
                dispatch($e111e9d234f09203$export$6c106ef18bd092b8(false, true));
                return;
            }
            if (error instanceof (0, $e9KPj.AccessForbiddenError)) return;
            if (error instanceof (0, $e9KPj.SharedViewFieldsUnavailableError) || error instanceof (0, $e9KPj.SharedViewAuthenticationMissingError)) return;
            if ($e111e9d234f09203$var$isPermissionCheckError(error) && isSiteAdmin) // shallow perms error for site admins as they still need to access setting page
            // even without project permissions
            return;
            containerProps.onFieldLoadingFailed(error);
        }
    };

});
parcelRegister("e9KPj", function(module, exports) {
$parcel$export(module.exports, "SharedViewFieldsUnavailableError", () => $6a4d35c98112c9c9$export$8455a765a5451e58);
$parcel$export(module.exports, "SharedViewAuthenticationMissingError", () => $6a4d35c98112c9c9$export$c50803463abdf78b);
$parcel$export(module.exports, "RemoteFieldsNotInitializedError", () => $6a4d35c98112c9c9$export$c7d5832f2a965ec7);
$parcel$export(module.exports, "AccessForbiddenError", () => $6a4d35c98112c9c9$export$b8482e3dee2b654c);
/* oxlint-disable max-classes-per-file */ 
var $75sVW = parcelRequire("75sVW");
class $6a4d35c98112c9c9$export$8455a765a5451e58 extends (0, $75sVW.default) {
}
$6a4d35c98112c9c9$export$8455a765a5451e58.displayName = "SharedViewFieldsUnavailableError";
class $6a4d35c98112c9c9$export$c50803463abdf78b extends Error {
}
$6a4d35c98112c9c9$export$c50803463abdf78b.displayName = "SharedViewAuthenticationMissingError";
class $6a4d35c98112c9c9$export$c7d5832f2a965ec7 extends Error {
}
$6a4d35c98112c9c9$export$c7d5832f2a965ec7.displayName = "RemoteFieldsNotInitializedError";
class $6a4d35c98112c9c9$export$b8482e3dee2b654c extends Error {
}
$6a4d35c98112c9c9$export$b8482e3dee2b654c.displayName = "AccessForbiddenError";

});

parcelRegister("7zNk8", function(module, exports) {
$parcel$export(module.exports, "isShallowEqual", () => $256b063100ed3b46$export$2225b4c39d37f8b3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6Tcej = parcelRequire("6Tcej");

var $jOlpf = parcelRequire("jOlpf");

var $k4FO8 = parcelRequire("k4FO8");

var $9O1Qa = parcelRequire("9O1Qa");
const $256b063100ed3b46$export$2225b4c39d37f8b3 = (a, b, debug = false)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($jOlpf)))(a) && (0, (/*@__PURE__*/$parcel$interopDefault($jOlpf)))(b)) {
        if (a.length !== b.length) {
            if (debug) // oxlint-disable-next-line no-console
            console.log('arrays not of equal length', a, b);
            return false;
        }
        return a.every((value, index)=>{
            if (value !== b[index]) {
                if (debug) // oxlint-disable-next-line no-console
                console.log(`[${index}]`, value, '!=', b[index]);
                return false;
            }
            return true;
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($9O1Qa)))([
        ...(0, (/*@__PURE__*/$parcel$interopDefault($k4FO8)))(a),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($k4FO8)))(b)
    ]).every((key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(b, key)) {
            if (debug) // oxlint-disable-next-line no-console
            console.log('property missing in [arg2]', key);
            return false;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(a, key)) {
            if (debug) // oxlint-disable-next-line no-console
            console.log('property missing in [arg1]', key);
            return false;
        }
        if (!Object.is(a[key], b[key])) {
            if (debug) /* oxlint-disable-next-line no-console */ console.log(`[${key}]`, a[key], '!=', b[key]);
            return false;
        }
        return true;
    });
};

});


parcelRegister("1qyaa", function(module, exports) {
$parcel$export(module.exports, "throttledFetchSnippetProviders", () => $947a18b2e6d188d3$export$b6b23958a0786a81);
$parcel$export(module.exports, "fetchArchivedSnippetProviders", () => $947a18b2e6d188d3$export$72d2ece9b5657d07);

var $3gOaP = parcelRequire("3gOaP");

var $5pMen = parcelRequire("5pMen");
const $947a18b2e6d188d3$var$fetchSnippetProvidersInternal = (refetch, archivedOnly)=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { onFieldLoadingFailed: onFieldLoadingFailed, fieldRemote: fieldRemote, containerAri: containerAri })=>{
        if (containerAri === undefined) return;
        if (getState().meta.loadingSnippetProviders === true && !archivedOnly) return;
        if (getState().snippetProviders !== undefined && !refetch && !archivedOnly) return;
        try {
            if (getState().throttledFetchSnippetProviders === undefined && !archivedOnly) {
                setState({
                    throttledFetchSnippetProviders: (0, (/*@__PURE__*/$parcel$interopDefault($5pMen)))((rf, onlyArchived)=>{
                        dispatch($947a18b2e6d188d3$var$fetchSnippetProvidersInternal(rf, onlyArchived));
                    }, 60000, {
                        trailing: false,
                        leading: true
                    })
                });
                dispatch($947a18b2e6d188d3$export$b6b23958a0786a81(refetch));
                return;
            }
            if (!archivedOnly) setState({
                meta: {
                    ...getState().meta,
                    loadingSnippetProviders: true
                }
            });
            const archivedMode = archivedOnly ? 'ARCHIVED_ONLY' : 'ACTIVE_ONLY';
            const snippetProviders = await fieldRemote.fetchSnippetProviders(archivedMode);
            const existingSnippetProviders = getState().snippetProviders || [];
            const snippetProvidersById = (0, (/*@__PURE__*/$parcel$interopDefault($3gOaP)))(snippetProviders, 'id');
            existingSnippetProviders.map((snippetProvider)=>{
                if (snippetProvidersById[snippetProvider.id]) {
                    delete snippetProvidersById[snippetProvider.id];
                    return snippetProvidersById[snippetProvider.id];
                }
                return snippetProvidersById;
            });
            setState({
                snippetProviders: [
                    ...existingSnippetProviders,
                    ...Object.values(snippetProvidersById)
                ],
                meta: {
                    ...getState().meta,
                    loadingSnippetProviders: false
                }
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            setState({
                meta: {
                    ...getState().meta,
                    loadingSnippetProviders: false
                }
            });
            onFieldLoadingFailed(e);
        }
    };
const $947a18b2e6d188d3$export$72d2ece9b5657d07 = ()=>async ({ dispatch: dispatch })=>{
        dispatch($947a18b2e6d188d3$var$fetchSnippetProvidersInternal(false, true));
    };
const $947a18b2e6d188d3$export$b6b23958a0786a81 = (refetch = false)=>async ({ getState: getState, dispatch: dispatch })=>{
        if (getState().throttledFetchSnippetProviders === undefined) {
            dispatch($947a18b2e6d188d3$var$fetchSnippetProvidersInternal(refetch, false));
            return;
        }
        getState().throttledFetchSnippetProviders?.(refetch, false);
    };

});

parcelRegister("ibndn", function(module, exports) {
$parcel$export(module.exports, "actions", () => $b4c82603e7492e76$export$e324594224ef24da);
/* eslint-disable jira/filename-case */ 
var $g5btk = parcelRequire("g5btk");

var $i5oXG = parcelRequire("i5oXG");

var $dLaL5 = parcelRequire("dLaL5");

var $l7dPI = parcelRequire("l7dPI");

var $GDDaC = parcelRequire("GDDaC");

var $jVdiV = parcelRequire("jVdiV");

var $1qyaa = parcelRequire("1qyaa");

var $b8Ea6 = parcelRequire("b8Ea6");

var $8IpNj = parcelRequire("8IpNj");

var $6PNhy = parcelRequire("6PNhy");

var $16sP7 = parcelRequire("16sP7");

var $l668O = parcelRequire("l668O");

var $fWjSq = parcelRequire("fWjSq");

var $k4Iq8 = parcelRequire("k4Iq8");

var $93Ip4 = parcelRequire("93Ip4");

var $7rhkw = parcelRequire("7rhkw");

var $9RWf4 = parcelRequire("9RWf4");

var $eZODn = parcelRequire("eZODn");

var $bL4en = parcelRequire("bL4en");

var $2ftzt = parcelRequire("2ftzt");

var $7MXRb = parcelRequire("7MXRb");

var $EJDEo = parcelRequire("EJDEo");

var $uUVQy = parcelRequire("uUVQy");

var $2o3Tm = parcelRequire("2o3Tm");

var $k1mjO = parcelRequire("k1mjO");

var $jMXrz = parcelRequire("jMXrz");

var $gjKEx = parcelRequire("gjKEx");

var $6hRsl = parcelRequire("6hRsl");

var $eDiwg = parcelRequire("eDiwg");

var $i1Tku = parcelRequire("i1Tku");

var $3lq8U = parcelRequire("3lq8U");

var $k7Z4l = parcelRequire("k7Z4l");

var $lhKEw = parcelRequire("lhKEw");

var $hbUcG = parcelRequire("hbUcG");
const $b4c82603e7492e76$export$e324594224ef24da = {
    addOption: $9RWf4.addOption,
    createCalculatedField: $i5oXG.createCalculatedField,
    createField: $i5oXG.createField,
    createPlayField: $i5oXG.createPlayField,
    createConnectionField: $i5oXG.createConnectionField,
    createValueDecoration: $dLaL5.createValueDecoration,
    createValueDecorationBulk: $dLaL5.createValueDecorationBulk,
    deleteField: $jVdiV.deleteField,
    deleteFieldLocally: $jVdiV.deleteFieldLocally,
    deleteOption: $eZODn.deleteOption,
    deleteValueDecoration: $l7dPI.deleteValueDecoration,
    deleteAllValueDecorations: $l7dPI.deleteAllValueDecorations,
    throttledFetchSnippetProviders: $1qyaa.throttledFetchSnippetProviders,
    fetchArchivedSnippetProviders: $1qyaa.fetchArchivedSnippetProviders,
    loadFields: $l668O.loadFields,
    loadSelectedFields: $93Ip4.loadSelectedFields,
    rankOptions: $bL4en.rankOptions,
    renameOption: $2ftzt.renameOption,
    updateFieldFormula: $i1Tku.updateFieldFormula,
    updateDeliveryFieldPresentation: $gjKEx.updateDeliveryFieldPresentation,
    updateDescription: $6hRsl.updateDescription,
    updateEmoji: $eDiwg.updateEmoji,
    updateFieldOptionWeight: $uUVQy.updateFieldOptionWeight,
    createFieldOptionWeightBulk: $2o3Tm.createFieldOptionWeightBulk,
    updateFieldOptionWeightType: $EJDEo.updateFieldOptionWeightType,
    updateFieldOptionAutoFormattingDisabled: $7MXRb.updateFieldOptionAutoFormattingDisabled,
    updateLabel: $3lq8U.updateLabel,
    updateValueDecoration: $GDDaC.updateValueDecoration,
    updatePlayFieldParameters: $i5oXG.updatePlayFieldParameters,
    updatePlayField: $k7Z4l.updatePlayField,
    updateUserFieldDisplayMode: $hbUcG.updateUserFieldDisplayMode,
    updateIntervalFieldSource: $16sP7.updateIntervalFieldSource,
    updateDeliveryDateSelectedField: $6PNhy.updateDeliveryDateSelectedField,
    updateDeliveryDateAggregationType: $8IpNj.updateDeliveryDateAggregationType,
    updateSystemFieldHidden: $lhKEw.updateSystemFieldHidden,
    associateGlobalFields: $g5btk.associateGlobalFields,
    setNewlyAddedGlobalFields: $7rhkw.setNewlyAddedGlobalFields,
    resetNewlyAddedGlobalFields: $7rhkw.resetNewlyAddedGlobalFields,
    captureLastFieldsUpdate: $b8Ea6.captureLastFieldsUpdate,
    loadGlobalLabels: $k4Iq8.loadGlobalLabels,
    updateConnectionFieldFilter: $jMXrz.updateConnectionFieldFilter,
    updateConnectionFieldIssueViewLayout: $jMXrz.updateConnectionFieldIssueViewLayout,
    syncFieldsIssueTypes: $k1mjO.syncFieldsIssueTypes,
    loadGlobalFieldsAssociations: $fWjSq.loadGlobalFieldsAssociations
};

});
parcelRegister("g5btk", function(module, exports) {
$parcel$export(module.exports, "associateGlobalFields", () => $d87f94eef3b3fa25$export$9d121f7dfa52c35a);

var $j85oP = parcelRequire("j85oP");

var $7imRA = parcelRequire("7imRA");

var $aJ81Y = parcelRequire("aJ81Y");

var $93Ip4 = parcelRequire("93Ip4");

var $7rhkw = parcelRequire("7rhkw");
const $d87f94eef3b3fa25$export$9d121f7dfa52c35a = (fieldKeys, dependencies = [])=>async ({ dispatch: dispatch }, { projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, globalFieldRemote: globalFieldRemote })=>{
        if (projectId === undefined) throw new Error('cannot associate field for unknown project');
        await (0, $7imRA.wrapWithExperience)((0, $j85oP.experience).globalFieldsAdministration.globalFieldAssociate, ()=>globalFieldRemote.addGlobalFieldsToProject({
                fieldKeys: fieldKeys,
                projectId: projectId
            }));
        const allNewFields = [
            ...fieldKeys,
            ...dependencies
        ];
        await dispatch((0, $93Ip4.loadSelectedFields)(allNewFields));
        dispatch((0, $7rhkw.setNewlyAddedGlobalFields)(allNewFields));
        (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'field associated', {
            issueFieldKeys: fieldKeys
        });
    };

});
parcelRegister("93Ip4", function(module, exports) {
$parcel$export(module.exports, "loadSelectedFields", () => $a4471e392254b5e1$export$bded8cd1c374b27d);

var $5GrX3 = parcelRequire("5GrX3");
const $a4471e392254b5e1$export$bded8cd1c374b27d = (fieldKeys, loadOnlyIfFieldsKnown)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote })=>{
        const shouldRefetch = !loadOnlyIfFieldsKnown || fieldKeys.every((fieldKey)=>fieldKey in getState().fields);
        if (!shouldRefetch) return [];
        const fieldData = await fieldRemote.fetchFields(fieldKeys);
        const updatedFields = $a4471e392254b5e1$var$preprocessFields(getState().fields, fieldData.fields);
        setState({
            fields: {
                ...getState().fields,
                ...updatedFields
            },
            fieldValueDecorations: {
                ...getState().fieldValueDecorations,
                ...fieldData.fieldValueDecorations
            }
        });
        return Object.values(updatedFields);
    };
const $a4471e392254b5e1$var$preprocessFields = (currentFields, newFields)=>{
    const updatedFields = {};
    for (const field of Object.values(newFields)){
        let updatedField = field;
        const outdatedField = currentFields[field.key];
        const isGlobalLabelsField = updatedField.type === (0, $5GrX3.FIELD_TYPES).CUSTOM_LABELS && updatedField.custom && updatedField.global;
        if (isGlobalLabelsField && outdatedField?.options?.length) // keep loaded global labels
        updatedField = {
            ...updatedField,
            options: outdatedField.options
        };
        updatedFields[field.key] = updatedField;
    }
    return updatedFields;
};

});

parcelRegister("7rhkw", function(module, exports) {
$parcel$export(module.exports, "setNewlyAddedGlobalFields", () => $977a3de8bf63f8ce$export$30bea066a076a4e2);
$parcel$export(module.exports, "resetNewlyAddedGlobalFields", () => $977a3de8bf63f8ce$export$218470d90b3b9e76);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $977a3de8bf63f8ce$export$30bea066a076a4e2 = (fieldKeys)=>async ({ setState: setState })=>{
        setState({
            newlyAddedGlobalFields: fieldKeys
        });
    };
const $977a3de8bf63f8ce$export$218470d90b3b9e76 = ()=>async ({ setState: setState })=>{
        setState({
            newlyAddedGlobalFields: []
        });
    };

});


parcelRegister("i5oXG", function(module, exports) {
$parcel$export(module.exports, "createField", () => $c477268b3f47a23f$export$17fc0a47da34544a);
$parcel$export(module.exports, "createConnectionField", () => $c477268b3f47a23f$export$33d95ef524f03d07);
$parcel$export(module.exports, "createCalculatedField", () => $c477268b3f47a23f$export$1d77878d72c7c60);
$parcel$export(module.exports, "createPlayField", () => $c477268b3f47a23f$export$255b12a413a0ece5);
$parcel$export(module.exports, "updatePlayFieldParameters", () => $c477268b3f47a23f$export$cba5a7c7e64ded21);

var $jx9NW = parcelRequire("jx9NW");

var $63gbl = parcelRequire("63gbl");

var $ayUUg = parcelRequire("ayUUg");

var $fV62N = parcelRequire("fV62N");

var $7TWAO = parcelRequire("7TWAO");

var $75sVW = parcelRequire("75sVW");

var $i8BNs = parcelRequire("i8BNs");
const $c477268b3f47a23f$var$createProjectAri = (siteId, projectId)=>(0, $i8BNs.JiraProjectAri).create({
        projectId: String(projectId),
        siteId: siteId
    }).toString();
const $c477268b3f47a23f$var$updateState = (newFields, getState, setState)=>{
    const state = getState();
    const newState = {
        fields: {
            ...state.fields,
            ...newFields.fields
        },
        fieldValueDecorations: {
            ...state.fieldValueDecorations,
            ...newFields.fieldValueDecorations
        }
    };
    setState(newState);
    return newFields.fields[Object.keys(newFields.fields)[0]];
};
const $c477268b3f47a23f$var$handleFetchError = async (err, callback)=>{
    const { statusCode: statusCode, originalResponse: originalResponse } = err;
    if (statusCode === 409 && originalResponse) {
        const responseJson = await originalResponse.json();
        const errorString = responseJson?.error;
        if ((0, $ayUUg.isDuplicateFieldNameError)(errorString)) throw new (0, $ayUUg.DuplicateNameError)(errorString, [
            {
                error: errorString
            }
        ], statusCode);
        // for now the entity limit error only relies on the statuscode 409, so this is the only else case currently
        const error = new (0, $fV62N.EntityLimitError)(errorString, [
            {
                error: errorString
            }
        ], statusCode, (0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_PROJECT);
        callback(error);
        throw error;
    }
    throw err;
};
const $c477268b3f47a23f$export$17fc0a47da34544a = (name, type, configuration, description, options)=>async ({ getState: getState, setState: setState }, { projectId: projectId, issueTypeIds: issueTypeIds, fieldRemote: fieldRemote, onFieldUpdateFailed: onFieldUpdateFailed })=>{
        const issueTypeId = (0, (/*@__PURE__*/$parcel$interopDefault($jx9NW)))(issueTypeIds);
        if (issueTypeId === undefined || issueTypeIds === undefined || issueTypeIds.length === 0) throw new Error('cannot create field for unknown issue type');
        if (projectId === undefined) throw new Error('cannot create field for unknown project');
        try {
            const fieldsData = await fieldRemote.createField({
                issueTypeIds: issueTypeIds,
                name: name.trim(),
                type: type,
                configuration: configuration,
                description: description,
                options: options
            });
            return $c477268b3f47a23f$var$updateState(fieldsData, getState, setState);
        } catch (err) {
            if (err instanceof (0, $75sVW.default)) await $c477268b3f47a23f$var$handleFetchError(err, onFieldUpdateFailed);
            throw err;
        }
    };
const $c477268b3f47a23f$export$33d95ef524f03d07 = (name, type, configuration, description)=>async ({ dispatch: dispatch })=>{
        try {
            return await dispatch($c477268b3f47a23f$export$17fc0a47da34544a(name, type, {
                issueTypeFilters: configuration?.issueTypeFilters ?? []
            }, description));
        } catch (error) {
            if (error instanceof Error) (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.field.actions.create-field.connection', 'Failed to create a connection field', error);
            throw error;
        }
    };
const $c477268b3f47a23f$export$1d77878d72c7c60 = (name, formula, description)=>async ({ getState: getState, setState: setState }, { issueTypeIds: issueTypeIds, fieldRemote: fieldRemote, onFieldUpdateFailed: onFieldUpdateFailed })=>{
        const issueTypeId = (0, (/*@__PURE__*/$parcel$interopDefault($jx9NW)))(issueTypeIds);
        if (issueTypeId === undefined || issueTypeIds === undefined || issueTypeIds.length === 0) throw new Error('cannot create field for unknown issue type');
        try {
            const fieldsData = await fieldRemote.createCalculatedField({
                label: name.trim(),
                formula: formula,
                issueTypeIds: issueTypeIds,
                description: description
            });
            return $c477268b3f47a23f$var$updateState(fieldsData, getState, setState);
        } catch (err) {
            if (err instanceof (0, $75sVW.default)) await $c477268b3f47a23f$var$handleFetchError(err, onFieldUpdateFailed);
            throw err;
        }
    };
const $c477268b3f47a23f$export$255b12a413a0ece5 = (name, maxSpend, kind = 'PolarisBudgetAllocationPlay', description)=>async ({ getState: getState, setState: setState }, { onActionFailed: onActionFailed, onFieldUpdateFailed: onFieldUpdateFailed, cloudId: cloudId, projectId: projectId, fieldRemote: fieldRemote, issueTypeIds: issueTypeIds })=>{
        try {
            const issueTypeId = (0, (/*@__PURE__*/$parcel$interopDefault($jx9NW)))(issueTypeIds);
            if (issueTypeId === undefined || issueTypeIds === undefined || issueTypeIds.length === 0) throw new Error('cannot create field for unknown issue type');
            const fieldsData = await fieldRemote.createPlayField({
                kind: kind,
                label: name.trim(),
                parameters: {
                    maxSpend: maxSpend
                },
                project: $c477268b3f47a23f$var$createProjectAri(cloudId, projectId),
                issueTypeIds: issueTypeIds,
                description: description
            });
            return $c477268b3f47a23f$var$updateState(fieldsData, getState, setState);
        } catch (err) {
            const error = err instanceof Error ? err : new Error('Unknown error');
            const entityLimitError = (0, $fV62N.getEntityLimitError)(error);
            if (entityLimitError) onFieldUpdateFailed(entityLimitError);
            else onActionFailed(error);
            throw error;
        }
    };
const $c477268b3f47a23f$export$cba5a7c7e64ded21 = (id, parameters)=>({ getState: getState, setState: setState })=>{
        const { fields: fields } = getState();
        Object.keys(fields).forEach((key)=>{
            const field = fields[key];
            if (field.play?.id === id) fields[key] = {
                ...field,
                play: {
                    ...field.play,
                    parameters: parameters
                }
            };
        });
        setState({
            fields: {
                ...fields
            }
        });
    };

});
parcelRegister("ayUUg", function(module, exports) {
$parcel$export(module.exports, "DuplicateNameError", () => $cf222d88ac7bf31b$export$d649d5f2acb6db01);
$parcel$export(module.exports, "isDuplicateFieldNameError", () => $cf222d88ac7bf31b$export$d40fc83bfbdf5161);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2KgJI = parcelRequire("2KgJI");
const $cf222d88ac7bf31b$var$DUPLICATE_FIELD_NAME_ERROR = 'Duplicate field name';
class $cf222d88ac7bf31b$export$d649d5f2acb6db01 extends (0, $2KgJI.default) {
    constructor(message, errors = [], statusCode = null){
        super(message, {
            cause: errors[0]
        }), this.name = 'DuplicateNameError';
        this.errors = errors;
        this.statusCode = statusCode;
    }
}
$cf222d88ac7bf31b$export$d649d5f2acb6db01.displayName = "DuplicateNameError";
const $cf222d88ac7bf31b$export$d40fc83bfbdf5161 = (errorMessage)=>errorMessage === $cf222d88ac7bf31b$var$DUPLICATE_FIELD_NAME_ERROR;

});


parcelRegister("dLaL5", function(module, exports) {
$parcel$export(module.exports, "createValueDecoration", () => $784527739f63651a$export$47ba83e40776877b);
$parcel$export(module.exports, "createValueDecorationBulk", () => $784527739f63651a$export$b68f071dd4cb812d);

var $6g4W9 = parcelRequire("6g4W9");

var $i7bkV = parcelRequire("i7bkV");

var $is1er = parcelRequire("is1er");
const $784527739f63651a$export$47ba83e40776877b = (createProps)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote, onDecorationUpdateFailed: onDecorationUpdateFailed, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { fieldKey: fieldKey, backgroundColor: backgroundColor, highlightContainer: highlightContainer, emoji: emoji, logic: logic } = createProps;
        const state = getState();
        const { fieldValueDecorations: fieldValueDecorations, fields: fields } = state;
        const field = fields[fieldKey];
        const existingValueDecorations = fieldValueDecorations[fieldKey] || [];
        const localDecorationId = (0, $6g4W9.generateLocalDecorationId)();
        const newValueDecorations = [
            ...existingValueDecorations
        ];
        newValueDecorations.push({
            localDecorationId: localDecorationId,
            backgroundColor: backgroundColor,
            emoji: emoji,
            highlightContainer: highlightContainer,
            logic: logic
        });
        setState({
            fieldValueDecorations: {
                ...fieldValueDecorations,
                [fieldKey]: newValueDecorations
            }
        });
        try {
            await (0, $is1er.performJiraConfigurationUpdate)({
                fieldKey: fieldKey,
                fieldRemote: fieldRemote,
                existingDecorations: existingValueDecorations,
                newDecorations: newValueDecorations
            });
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.valueDecorationChanged(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: field.type
            });
        } catch (error) {
            setState({
                fieldValueDecorations: {
                    ...getState().fieldValueDecorations,
                    [fieldKey]: existingValueDecorations
                }
            });
            onDecorationUpdateFailed(error instanceof Error ? error : new Error('Failed to create value decoration'));
        }
        return localDecorationId;
    };
const $784527739f63651a$export$b68f071dd4cb812d = (createProps)=>(stateParams, propParams)=>{
        const { getState: getState, setState: setState } = stateParams;
        const { fieldRemote: fieldRemote, onDecorationUpdateFailed: onDecorationUpdateFailed, createAnalyticsEvent: createAnalyticsEvent } = propParams;
        const { fieldKey: fieldKey, decorations: decorations } = createProps;
        const state = getState();
        const { fieldValueDecorations: fieldValueDecorations, fields: fields } = state;
        const field = fields[fieldKey];
        const existingValueDecorations = fieldValueDecorations[fieldKey] || [];
        const newValueDecorations = [
            ...existingValueDecorations
        ];
        const localDecorationIds = [];
        decorations.forEach((decoration)=>{
            const { backgroundColor: backgroundColor, highlightContainer: highlightContainer, emoji: emoji, logic: logic } = decoration;
            const localDecorationId = (0, $6g4W9.generateLocalDecorationId)();
            localDecorationIds.push(localDecorationId);
            newValueDecorations.push({
                localDecorationId: localDecorationId,
                backgroundColor: backgroundColor,
                emoji: emoji,
                highlightContainer: highlightContainer,
                logic: logic
            });
        });
        (0, $is1er.performJiraConfigurationUpdate)({
            fieldKey: fieldKey,
            fieldRemote: fieldRemote,
            existingDecorations: existingValueDecorations,
            newDecorations: newValueDecorations
        }).catch((error)=>{
            onDecorationUpdateFailed(error);
        });
        setState({
            fieldValueDecorations: {
                ...fieldValueDecorations,
                [fieldKey]: newValueDecorations
            }
        });
        (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.valueDecorationChanged(createAnalyticsEvent({}), {
            issueFieldKey: fieldKey,
            issueFieldType: field.type
        });
        return localDecorationIds;
    };

});
parcelRegister("6g4W9", function(module, exports) {
$parcel$export(module.exports, "generateLocalDecorationId", () => $c54386fe377e41f4$export$9680935a700c2c34);
$parcel$export(module.exports, "containsLogic", () => $c54386fe377e41f4$export$41f0457eb13a2b9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $WqSvO = parcelRequire("WqSvO");

var $7TA2J = parcelRequire("7TA2J");
const $c54386fe377e41f4$export$9680935a700c2c34 = ()=>(0, $7TA2J.v4)();
const $c54386fe377e41f4$export$41f0457eb13a2b9 = (decoration)=>{
    return !(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(decoration.logic);
};

});

parcelRegister("i7bkV", function(module, exports) {
$parcel$export(module.exports, "fireCompoundAnalyticsEvent", () => $696f6cd6d28fb35f$export$48a7e5476d8e07b1);
$parcel$export(module.exports, "fireAnalyticsEventForIssueUpdate", () => $696f6cd6d28fb35f$export$d051bc7a06e14ff4);
$parcel$export(module.exports, "useViewOpenedAnalytics", () => $696f6cd6d28fb35f$export$c44f82646ff7d9c9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $srxic = parcelRequire("srxic");

var $f99M0 = parcelRequire("f99M0");

var $aJ81Y = parcelRequire("aJ81Y");

var $jxSHn = parcelRequire("jxSHn");

var $9p0OU = parcelRequire("9p0OU");

var $31cOS = parcelRequire("31cOS");

var $8wBbD = parcelRequire("8wBbD");

var $6NNTe = parcelRequire("6NNTe");

var $3nTaW = parcelRequire("3nTaW");

var $dwqdq = parcelRequire("dwqdq");

var $fuiX6 = parcelRequire("fuiX6");

var $lOMlp = parcelRequire("lOMlp");

var $okmuj = parcelRequire("okmuj");

var $ewAyW = parcelRequire("ewAyW");
const $696f6cd6d28fb35f$var$mapViewKindToType = (viewKind)=>{
    const map = {
        TABLE: 'List'
    };
    return map[viewKind] ?? (0, (/*@__PURE__*/$parcel$interopDefault($srxic)))(viewKind);
};
const $696f6cd6d28fb35f$export$48a7e5476d8e07b1 = {
    View: $okmuj.View,
    ViewHeader: $lOMlp.ViewHeader,
    IdeaView: $6NNTe.IdeaView,
    FieldConfig: $31cOS.FieldConfig,
    Field: $8wBbD.Field,
    BoardView: $9p0OU.BoardView,
    ListView: $3nTaW.ListView,
    MatrixView: $dwqdq.MatrixView,
    TimelineView: $fuiX6.TimelineView,
    TreeView: $ewAyW.TreeView,
    IdeaCommentCreated: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/yM5d3g_Uey9JJ_eD0aOn3b3fD7s
        (0, $jxSHn.sendPendoTrackEvent)('idea_comment_created');
        // https://data-portal.internal.atlassian.com/analytics/registry/168
        (0, $aJ81Y.fireTrackAnalytics)(event, 'comment created');
    },
    IdeaCommentUpdated: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/1363
        (0, $aJ81Y.fireTrackAnalytics)(event, 'comment updated');
    },
    IdeaCommentPinned: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/89807
        (0, $aJ81Y.fireTrackAnalytics)(event, 'comment pinned');
    },
    IdeaCommentUnpinned: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/89808
        (0, $aJ81Y.fireTrackAnalytics)(event, 'comment unpinned');
    },
    IdeaCommentDeleted: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/1364
        (0, $aJ81Y.fireTrackAnalytics)(event, 'comment deleted');
    },
    IdeaCreated: (event, issueId, attributes)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/xpkc3Fne_s-qq2bS3vILQyJQnNs
        (0, $jxSHn.sendPendoTrackEvent)('idea_created');
        // https://data-portal.internal.atlassian.com/analytics/registry/871
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issue created', String(issueId), {
            ...attributes,
            projectType: (0, $f99M0.PRODUCT_DISCOVERY_PROJECT)
        });
    },
    IssueCreated: (event, issueId, attributes)=>{
        event.context.push({
            objectId: issueId,
            objectType: 'issue'
        });
        // https://data-portal.internal.atlassian.com/analytics/registry/871
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issue created', issueId, attributes);
    },
    IdeaFieldUpdated: (event, fieldType, actionType)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/H3xT1i_BL7YwQIXK8Wtw792AQwo
        (0, $jxSHn.sendPendoTrackEvent)('idea_field_updated');
        // https://data-portal.internal.atlassian.com/analytics/registry/47658
        (0, $aJ81Y.fireTrackAnalytics)(event, 'fieldValue updated', {
            fieldType: fieldType,
            actionType: actionType
        });
    },
    IdeaDescriptionUpdated: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/l93NMzXG9zkSFeDPIZecMkSwNxQ
        (0, $jxSHn.sendPendoTrackEvent)('idea_description_updated');
        // https://data-portal.internal.atlassian.com/analytics/registry/47087
        (0, $aJ81Y.fireTrackAnalytics)(event, 'ideaDescription updated');
    },
    RightSidebarFieldListViewOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/qwLEc_xbDbYQUJrrm3rnaimAl28
        (0, $jxSHn.sendPendoTrackEvent)('rightSidebarFieldListView opened');
    },
    RightSidebarIssueCommentsOpened: (event)=>{
        // there are no separate sidebar for comments, it opens Idea and selects comments section
        // https://app.pendo.io/s/4758009750487040/trackevents/p2-VEQ3cO21s4mmhIfY_66_aFYA
        (0, $jxSHn.sendPendoTrackEvent)('rightSidebarIssueComments opened');
        (0, $aJ81Y.fireUIAnalytics)(event, 'rightSidebarIssueComments opened');
    },
    RightSidebarIssueInsightsOpened: (event)=>{
        // there are no separate sidebar for comments, it opens Idea and selects insights section
        // https://app.pendo.io/s/4758009750487040/trackevents/sGThOdFKoBxg8J_liR0JaC7DXwE
        (0, $jxSHn.sendPendoTrackEvent)('rightSidebarIssueInsights opened');
        (0, $aJ81Y.fireUIAnalytics)(event, 'rightSidebarIssueInsights opened');
    },
    RightSidebarFieldEditViewOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/DQP_0kv1ub59wQZ_mI05gd9eUNA
        (0, $jxSHn.sendPendoTrackEvent)('rightSidebarFieldEditView opened');
    },
    RightSidebarFieldCreateViewOpened: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/5DhE-prOX7zgx38JEKNstW3s2Ng
        (0, $jxSHn.sendPendoTrackEvent)('rightSidebarFieldCreateView opened');
        // https://data-portal.internal.atlassian.com/analytics/registry/47091
        (0, $aJ81Y.fireUIAnalytics)(event, 'rightSidebarFieldCreateView opened');
    },
    RightSidebarFieldCreationTypeSelectOpened: (event)=>{
        (0, $aJ81Y.fireUIAnalytics)(event, 'rightSidebarOnCreateWithTypeSelect opened');
    },
    RightSidebarFieldOptionOpened: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/igbtQ-93jOjhhDLi032TTYep18U
        (0, $jxSHn.sendPendoTrackEvent)('rightSidebarFieldOption opened');
        (0, $aJ81Y.fireUIAnalytics)(event, 'rightSidebarFieldOption opened');
    },
    RightSidebarFieldsFieldToggled: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('viewFields updated fieldToggled');
    },
    RightSidebarFieldsFieldSorted: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('viewFields updated fieldSorted');
    },
    RightSidebarFieldsFieldHidden: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'viewFields updated fieldHidden'
        });
    },
    RightSidebarFieldsFieldAdded: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('viewFields updated fieldAdded');
    },
    RightSidebarOnFilterOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/W8B_-btramlDqbmwblM0sgJ3VMs
        (0, $jxSHn.sendPendoTrackEvent)('rightSidebarOnFilter opened');
    },
    RightSidebarOnIdeaOpened: (event)=>{
        // Does not trigger
        // https://app.pendo.io/s/4758009750487040/trackevents/6Hd4O0gOTewIXzIIRbneohkhyxc
        (0, $jxSHn.sendPendoTrackEvent)('rightSidebarOnIdea opened');
        (0, $aJ81Y.fireUIAnalytics)(event, 'rightSidebarOnIdea opened');
    },
    RightSidebarOnPlayOpened: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/5Mo7NsNavjXsrJ8CzICmEx6XQ3E
        (0, $jxSHn.sendPendoTrackEvent)('rightSidebarOnPlay opened');
        // https://data-portal.internal.atlassian.com/analytics/registry/47093
        (0, $aJ81Y.fireUIAnalytics)(event, 'rightSidebarOnPlay opened');
    },
    RightSidebarOnSortOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/H0HJy3Pb03AFe4FUhziY3RtbePk
        (0, $jxSHn.sendPendoTrackEvent)('rightSidebarOnSort opened');
    },
    RightSidebarViewSortFieldAdded: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('viewSort updated fieldAdded');
    },
    RightSidebarViewSortFieldRemoved: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('viewSort updated fieldRemoved');
    },
    RightSidebarViewSortDirectionChanged: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('viewSort updated directionChanged');
    },
    RightSidebarViewSortReset: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('viewSort updated sortReset');
    },
    RightSidebarViewSortFieldsReordered: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('viewSort updated fieldsReordered');
    },
    RightSidebarViewSortFieldsChanged: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('viewSort updated fieldsChanged');
    },
    RightSidebarGroupByColumnsOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/un0GJBhSAansp_VkWBMpM5IsZF4
        (0, $jxSHn.sendPendoTrackEvent)('openGroupByOptions opened');
    },
    RightSidebarGroupByRowsOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/G7DQd6x0J_7WC1WI7seQw-J-GfY
        (0, $jxSHn.sendPendoTrackEvent)('openVerticalGroupByOptions opened');
    },
    RightSidebarGroupByRowsFieldChanged: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'viewFields updated groupByRowFieldChanged'
        });
    },
    RightSidebarHierarchyOpened: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'rightSidebarHierarchy opened'
        });
    },
    RightSidebarGroupByColumnsFieldChanged: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('viewFields updated groupByColumnFieldChanged');
    },
    OpenMatrixXAxisOptionsOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/yBOlM340T4ZzqcDSGc2XJF2ZRxc
        (0, $jxSHn.sendPendoTrackEvent)('rightSidebarMatrixXAxisOptions opened');
    },
    OpenMatrixYAxisOptionsOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/SL0S3e_8qSbkVLO-O_QjUfvcDQk
        (0, $jxSHn.sendPendoTrackEvent)('rightSidebarMatrixYAxisOptions opened');
    },
    OpenMatrixZAxisOptionsOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/ZnMVz7jumv61RhfycYSPqZ75KFw
        (0, $jxSHn.sendPendoTrackEvent)('rightSidebarMatrixZAxisOptions opened');
    },
    RightSidebarClosed: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/4Qy9buugg-OhEldeBO2__dpJ-Ok
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'rightSidebar closed'
        });
    },
    HyperlinkFieldMaxLengthError: (event)=>{
        (0, $jxSHn.sendPendoTrackEvent)('hyperlink_field_max_length_error');
        (0, $aJ81Y.fireTrackAnalytics)(event, 'error occurred', 'hyperlinkFieldMaxLengthError');
    },
    RightSidebarIdeaTemplatesOpened: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/HjknfGpnKMead8RV2_o3O0IQDSA
        (0, $jxSHn.sendPendoTrackEvent)('rightSidebarIdeaTemplates opened');
        // https://data-portal.internal.atlassian.com/analytics/registry/47101
        (0, $aJ81Y.fireUIAnalytics)(event, 'rightSidebarIdeaTemplates opened');
    },
    RightSidebarIdeasBucketOpened: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/ljVwr3Sv_MYCLsa3UHcOHaD3fNA
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'rightSidebarIdeasBucketOpened opened'
        });
        // https://data-portal.internal.atlassian.com/analytics/registry/47102
        (0, $aJ81Y.fireUIAnalytics)(event, 'rightSidebarIdeasBucket opened');
    },
    RightSidebarTimelineConfigOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/CwJbzYOhkl68z6y843U6qziVc6M
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'rightSidebarTimelineConfig opened'
        });
    },
    RightSidebarFieldOptionsSearchOccured: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('rightSidebarFieldOptionsSearch occured');
    },
    IdeaDescriptionTemplatesButtonClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/JchzwUn3TuabHi4MyumsDRqBQwU
        (0, $jxSHn.sendPendoTrackEvent)('ideaDescriptionTemplatesButton clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47104
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'ideaDescriptionTemplatesButton');
    },
    IdeaDescriptionTemplateApplyClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/KdZV3lpa_O_MOZyzsSub8T0syH4
        (0, $jxSHn.sendPendoTrackEvent)('ideaDescriptionTemplateApply clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47105
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'ideaDescriptionTemplateApply');
    },
    IdeaDescriptionTemplateCreateClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/iDYpmhRk8iYXew9zsLep7s7Bfb4
        (0, $jxSHn.sendPendoTrackEvent)('ideaDescriptionTemplateCreate clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47106
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'ideaDescriptionTemplateCreate');
    },
    IdeaDescriptionTemplateUpdateClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/Y-cdYKUd1JzkhvvS3_u-vo-XmKg
        (0, $jxSHn.sendPendoTrackEvent)('ideaDescriptionTemplateUpdate clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47107
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'ideaDescriptionTemplateUpdate');
    },
    IdeaDescriptionTemplateDeleteClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/Eg4_nuY5UbatLwwO1pI5pCU7SMg
        (0, $jxSHn.sendPendoTrackEvent)('ideaDescriptionTemplateDelete clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47108
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'ideaDescriptionTemplateDelete');
    },
    IdeaDescriptionTemplateApplied: (event, templateId)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/nTQAWILD5CRM2qYw_xH732QrEws
        // https://app.pendo.io/s/4758009750487040/trackevents/crl2tr_HaEyOJpcM9a9qR4YFFx4
        // https://app.pendo.io/s/4758009750487040/trackevents/BVmG9LifMmegmliDAjGlab0NzvQ
        // https://app.pendo.io/s/4758009750487040/trackevents/wTLKudshXTHg45sd2ZsKRC90t_U
        // https://app.pendo.io/s/4758009750487040/trackevents/ilWZEZJMAX4ozUbyEzRW93ZL5sw
        (0, $jxSHn.sendPendoTrackEvent)(`applyDescriptionTemplate${templateId || ''} clicked`);
        // https://data-portal.internal.atlassian.com/analytics/registry/47109
        (0, $aJ81Y.fireTrackAnalytics)(event, 'ideaDescriptionTemplate applied', templateId || '');
    },
    SortChangeToViewRankButtonClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/FqF53XXrRrC5a5tmcjDt6CyjLEE
        (0, $jxSHn.sendPendoTrackEvent)('viewRankButton clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47110
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'sortChangeToViewRankButton');
    },
    SortChangeToProjectRankButtonClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/ayeJj95x4OuyqD-dg33FITDD0-Q
        (0, $jxSHn.sendPendoTrackEvent)('changeToProjectRankButton clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47111
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'sortChangeToProjectRankButton');
    },
    SortChangeToProjectRankAndCommitButtonClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/mqPhVSm3WfHFO6xueL7FjerRVVQ
        (0, $jxSHn.sendPendoTrackEvent)('changeToProjectAndCommitRankButton clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47112
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'sortChangeToProjectAndCommitRankButton');
    },
    IdeaRankedInView: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/Rmc-JGgcaUg6_W5FAwHYzTjNaGs
        (0, $jxSHn.sendPendoTrackEvent)('per-view-rank_updated');
    },
    MatrixBubbleTooltipDisplayed: (event, issueAnalyticsData)=>{
        (0, $jxSHn.sendPendoTrackEvent)('matrixViewBubbleTooltip displayed');
        // https://data-portal.internal.atlassian.com/analytics/registry/50600
        (0, $aJ81Y.fireUIAnalytics)(event, 'tooltip displayed', 'matrixViewBubble', issueAnalyticsData || {});
    },
    ViewControls: {
        openColumnsSidebarButtonClicked: (event, attributes = {})=>{
            // https://app.pendo.io/s/4758009750487040/trackevents/5e7xyzPg4xscjaCRIt0bzKVNbYk
            (0, $jxSHn.sendPendoTrackEvent)('openColumnsSidebarButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/51152
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'columns', attributes);
        },
        openGroupBySidebarButtonClicked: (event)=>{
            // https://app.pendo.io/s/4758009750487040/trackevents/yc-bdFY4nzRIB8HGZFg8nmHLaMw
            (0, $jxSHn.sendPendoTrackEvent)('openGroupBySidebarButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/51098
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'groupBy');
        },
        openFieldsSidebarButtonClicked: (event)=>{
            // https://app.pendo.io/s/4758009750487040/trackevents/XNr3dWjVg28g4Ap2AfrjTSao5vU
            (0, $jxSHn.sendPendoTrackEvent)('openFieldsSidebarButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/51106
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'fields');
        },
        openFilterSidebarButtonClicked: (event)=>{
            // https://app.pendo.io/s/4758009750487040/trackevents/lkQcHgUcckvv4fqRwH5kH43uj0c
            (0, $jxSHn.sendPendoTrackEvent)('openFilterSidebarButton clicked');
            // data-portal.internal.atlassian.com/analytics/registry/51100
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'filter');
        },
        openSortSidebarButtonClicked: (event)=>{
            (0, $jxSHn.sendPendoTrackEvent)('openSortSidebarButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/51102
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'sort');
        },
        openMatrixXAxisSidebarButtonClicked: (event, attributes = {})=>{
            (0, $jxSHn.sendPendoTrackEvent)('openMatrixXSidebarButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/51111
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'xAxis', attributes);
        },
        openMatrixYAxisSidebarButtonClicked: (event, attributes = {})=>{
            (0, $jxSHn.sendPendoTrackEvent)('openMatrixYSidebarButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/51112
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'yAxis', attributes);
        },
        openMatrixZAxisSidebarButtonClicked: (event)=>{
            (0, $jxSHn.sendPendoTrackEvent)('openMatrixZSidebarButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/51115
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'size');
        },
        openHierarchySidebarButtonClicked: (event)=>{
            (0, $jxSHn.sendPendoTrackEvent)({
                actionSubjectAndAction: 'openHierarchySidebarButton clicked'
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/97677
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'hierarchy');
        }
    },
    NavSidebarPlusDropdownitemClicked: (event, viewKind)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/nu1EELTcS0GLr-UHw567_0k4ICk BOARD
        // https://app.pendo.io/s/4758009750487040/trackevents/G4co93jddFLvabbue_FGZlaLaZY MATRIX
        // https://app.pendo.io/s/4758009750487040/trackevents/wafmt5zQbXNRsxAVYtUhBpU85x0 SECTION
        // https://app.pendo.io/s/4758009750487040/trackevents/Md7wujC7XbHk6fcqv2jhB_UmDOQ TABLE
        // https://app.pendo.io/s/4758009750487040/trackevents/994nTMJuZg69jlOiJDdKi147MnA TIMELINE
        (0, $jxSHn.sendPendoTrackEvent)(`navSidebarPlusButtonItem ${viewKind}`);
        // https://data-portal.internal.atlassian.com/analytics/registry/51025
        (0, $aJ81Y.fireUIAnalytics)(event, 'dropdownItem clicked', 'createViewOrSection', {
            selectedActionItem: `create${$696f6cd6d28fb35f$var$mapViewKindToType(viewKind)}`
        });
    // archive this old event https://data-portal.internal.atlassian.com/analytics/registry/32259
    },
    NavSidebarCreateViewDropdownitemClicked: (event, viewKind)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/0EdRA1ITiMFiOSSEp3-dtavyZbo BOARD
        // https://app.pendo.io/s/4758009750487040/trackevents/gzxdZw-0LQeC2g89asY7Np7HLhI MATRIX
        // https://app.pendo.io/s/4758009750487040/trackevents/BkizrhPyoBdyyEvEIVXmLMn91kk SECTION
        // https://app.pendo.io/s/4758009750487040/trackevents/nX3mY7GocKIxPz5Zb4jqE9Wmr-o TABLE
        // https://app.pendo.io/s/4758009750487040/trackevents/SNnVX1fmm7aKSrSOqEt2zx2VWJY TIMELINE
        (0, $jxSHn.sendPendoTrackEvent)(`navSidebarCreateViewButtonItem ${viewKind}`);
        // https://data-portal.internal.atlassian.com/analytics/registry/51025
        (0, $aJ81Y.fireUIAnalytics)(event, 'dropdownItem clicked', 'createViewOrSection', {
            selectedActionItem: `create${$696f6cd6d28fb35f$var$mapViewKindToType(viewKind)}`
        });
    // archive this old event https://data-portal.internal.atlassian.com/analytics/registry/32259
    },
    NavSidebarViewKebabCloneViewAsListClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/lJG7R-6iywlELtqR6-ixHOp4MQo
        (0, $jxSHn.sendPendoTrackEvent)('navSidebar cloneViewAsListKebab clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/51085
        (0, $aJ81Y.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewActionItem', {
            selectedActionItem: 'cloneAsList'
        });
    },
    NavSidebarViewKebabCloneViewAsBoardClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/HA4TEsBJklVPQDHvABXaSh3yhts
        (0, $jxSHn.sendPendoTrackEvent)('navSidebar cloneViewAsBoardKebab clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/51085
        (0, $aJ81Y.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewActionItem', {
            selectedActionItem: 'cloneAsBoard'
        });
    },
    NavSidebarViewKebabCloneViewAsMatrixClicked: (event)=>{
        (0, $jxSHn.sendPendoTrackEvent)('navSidebar cloneViewAsMatrixKebab clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/51085
        (0, $aJ81Y.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewActionItem', {
            selectedActionItem: 'cloneAsMatrix'
        });
    },
    NavSidebarViewKebabCloneViewAsTimelineClicked: (event)=>{
        (0, $jxSHn.sendPendoTrackEvent)('navSidebar cloneViewAsTimelineKebab clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/51085
        (0, $aJ81Y.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewActionItem', {
            selectedActionItem: 'cloneAsTimeline'
        });
    },
    NavSidebarViewKebabDeleteViewClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/nCqpRV9mZzGZbxRlFtNBUc0J2Ik
        (0, $jxSHn.sendPendoTrackEvent)('navSidebar deleteViewKebab clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/51085
        (0, $aJ81Y.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewActionItem', {
            selectedActionItem: 'delete'
        });
    },
    NavSidebarViewKebabRenameViewClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/qov7DM6puEYBB-gy-KtJomlxLb8
        (0, $jxSHn.sendPendoTrackEvent)('navSidebar renameViewKebab clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/51085
        (0, $aJ81Y.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewActionItem', {
            selectedActionItem: 'rename'
        });
    },
    NavSidebarViewEmojiRemove: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/gRjWMaouDLTuByt85NPGsNiq0oU
        (0, $jxSHn.sendPendoTrackEvent)('navSidebar removeEmoji clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/51085
        (0, $aJ81Y.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewActionItem', {
            selectedActionItem: 'removeEmoji'
        });
    },
    NavSidebarViewEmojiAdd: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/OXnJYJtQaJDwoj1Wu9KnkFaoDUE
        (0, $jxSHn.sendPendoTrackEvent)('navSidebar addEmoji clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry
        (0, $aJ81Y.fireUIAnalytics)(event, 'navSidebarItem clicked', 'viewAddEmoji');
    },
    NavSidebarViewClicked: (event, viewKind = '')=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/0PGTFtKgeZmnnSyt6eue3hkZZlM BOARD
        // https://app.pendo.io/s/4758009750487040/trackevents/qXWj21iEeMmo21WvKVW951KZhTo MATRIX
        // https://app.pendo.io/s/4758009750487040/trackevents/xeRrNQmZIZvnUtaRWu4S8lsQQL8 TABLE
        // https://app.pendo.io/s/4758009750487040/trackevents/LoEQ2kACHWa-hBGwG2NcwPP4eCw TIMELINE
        (0, $jxSHn.sendPendoTrackEvent)(`navSidebar ${viewKind} clicked`);
        // https://data-portal.internal.atlassian.com/analytics/registry/47126
        (0, $aJ81Y.fireUIAnalytics)(event, 'navSidebarItem clicked', 'view', {
            viewKind: viewKind
        });
    },
    NavSidebarArchiveViewClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/uZq6qCPnbyTKB84D9kI2c1xY2lM ARCHIVE
        (0, $jxSHn.sendPendoTrackEvent)('navSidebar ARCHIVE clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47126
        (0, $aJ81Y.fireUIAnalytics)(event, 'navSidebarItem clicked', 'view', {
            viewKind: 'ARCHIVE'
        });
    },
    NavSidebarSettingsClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/Bh7L9c2N2UYwt3THvgqrihcH0q0 settings
        (0, $jxSHn.sendPendoTrackEvent)('navSidebar settings clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47126
        (0, $aJ81Y.fireUIAnalytics)(event, 'navSidebarItem clicked', 'settings');
    },
    TimelineGranularityChanged: (event, attributes)=>{
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timelineGranularity clicked',
            attributes: attributes
        });
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'timelineGranularity', attributes);
    },
    TimelineGroupToggled: (event)=>{
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timelineGroup clicked'
        });
        (0, $aJ81Y.fireUIAnalytics)(event, 'timelineGroup clicked', 'view');
    },
    TimelineRangeChanged: (event, attributes)=>{
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timelineRange changed',
            attributes: attributes
        });
        (0, $aJ81Y.fireUIAnalytics)(event, 'timelineRange changed', 'settings', attributes);
    },
    TimelineFieldKeyChanged: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('timelineFieldKey changed');
    },
    DateFilterTypeChanged: (event)=>{
        (0, $jxSHn.sendPendoTrackEvent)('dateFilterType changed');
        (0, $aJ81Y.fireUIAnalytics)(event, 'dateFilterType changed', 'settings');
    },
    ReactionAddedReactionsField: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('reaction added');
    },
    ReactionRemovedReactionsField: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('reaction removed');
    }
};
const $696f6cd6d28fb35f$export$d051bc7a06e14ff4 = (event, issueId, attributes)=>{
    event.context.push({
        objectId: issueId,
        objectType: 'issue'
    });
    issueId ? (0, $aJ81Y.fireTrackAnalytics)(event, 'issue updated', issueId, attributes) : (0, $aJ81Y.fireTrackAnalytics)(event, 'issue updated', attributes);
};
const $696f6cd6d28fb35f$export$c44f82646ff7d9c9 = ({ viewId: viewId, viewAccessLevel: viewAccessLevel, isViewPermissionsEnabled: isViewPermissionsEnabled, isViewConfigured: isViewConfigured, analyticsCallback: analyticsCallback, isSharedView: isSharedView })=>{
    const previousCurrentViewId = (0, $euxye.useRef)(undefined);
    const previousViewAccessLevel = (0, $euxye.useRef)(undefined);
    const previousIsViewConfigured = (0, $euxye.useRef)(undefined);
    (0, $euxye.useEffect)(()=>{
        if (isSharedView) return;
        if (viewId !== previousCurrentViewId.current || isViewConfigured !== previousIsViewConfigured.current) {
            previousCurrentViewId.current = viewId;
            previousIsViewConfigured.current = isViewConfigured;
            previousViewAccessLevel.current = undefined;
        }
        if (isViewPermissionsEnabled) {
            if (viewAccessLevel !== undefined && previousViewAccessLevel.current === undefined) {
                analyticsCallback(viewAccessLevel);
                previousViewAccessLevel.current = viewAccessLevel;
            }
        } else // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        analyticsCallback(undefined);
    }, [
        isViewPermissionsEnabled,
        viewId,
        viewAccessLevel,
        analyticsCallback,
        isViewConfigured,
        isSharedView
    ]);
    (0, $euxye.useEffect)(()=>{
        if (isSharedView) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        analyticsCallback(undefined);
    }, [
        isSharedView,
        analyticsCallback
    ]);
};

});
parcelRegister("9p0OU", function(module, exports) {
$parcel$export(module.exports, "BoardView", () => $472b43d9e87995eb$export$373e09b633948dc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aJ81Y = parcelRequire("aJ81Y");

var $jxSHn = parcelRequire("jxSHn");
const $472b43d9e87995eb$export$373e09b633948dc = {
    opened: (event, accessLevel, attributes)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/qM00ZERYuH-iFTxMnCfYLZpuKgQ
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'boardView opened',
            attributes: {
                accessLevel: accessLevel || ''
            }
        });
        // https://data-portal.internal.atlassian.com/analytics/registry/51089
        (0, $aJ81Y.fireScreenAnalytics)(event, {
            accessLevel: accessLevel,
            ...attributes
        });
    },
    cardDropped: (event, attributes = {})=>{
        (0, $jxSHn.sendPendoTrackEvent)('boardViewCard dropped');
        // https://data-portal.internal.atlassian.com/analytics/registry/50694
        (0, $aJ81Y.fireUIAnalytics)(event, 'card dragged', 'idea', attributes);
    },
    columnDropped: (event, attributes)=>{
        (0, $jxSHn.sendPendoTrackEvent)('boardViewColumn dropped');
        // https://data-portal.internal.atlassian.com/analytics/registry/50789
        (0, $aJ81Y.fireUIAnalytics)(event, 'column dragged', 'fieldValue', attributes);
    },
    fieldValueUpdatedByDragBetweenColumns: (fieldType)=>{
        (0, $jxSHn.sendPendoTrackEvent)(`fieldValue updated ${fieldType} boardDragBetweenColumns`);
    },
    fieldValueUpdatedByDragBetweenSwimlanes: (fieldType)=>{
        (0, $jxSHn.sendPendoTrackEvent)(`fieldValue updated ${fieldType} boardDragBetweenSwimlanes`);
    },
    searchOrCreateClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/75136
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'boardColumnSearchOrCreate', {});
    },
    searchOrCreateNewIdeaClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/75135
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'boardColumnSearchOrCreateNewIdea', {});
    }
};

});

parcelRegister("31cOS", function(module, exports) {
$parcel$export(module.exports, "FieldConfig", () => $41efdf33ed6dafdc$export$2655f228c0cb3e13);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aJ81Y = parcelRequire("aJ81Y");

var $2HasX = parcelRequire("2HasX");
const $41efdf33ed6dafdc$export$2655f228c0cb3e13 = {
    labelChangedSuccess: (event, attributes)=>{
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'label'
                }
            ],
            ...attributes
        });
    },
    labelChangedFailure: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47519
        (0, $aJ81Y.fireTrackAnalytics)(event, 'fieldConfig updated', 'labelChanged', {
            result: (0, $2HasX.RESULTS).FAILURE
        });
    },
    emojiChangedSuccess: (event, attributes)=>{
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'emoji'
                }
            ],
            ...attributes
        });
    },
    emojiChangedFailure: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47519
        (0, $aJ81Y.fireTrackAnalytics)(event, 'fieldConfig updated', 'emojiChanged', {
            result: (0, $2HasX.RESULTS).FAILURE
        });
    },
    descriptionChangedSuccess: (event, attributes)=>{
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'description'
                }
            ],
            ...attributes
        });
    },
    descriptionChangedFailure: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47519
        (0, $aJ81Y.fireTrackAnalytics)(event, 'fieldConfig updated', 'descriptionChanged', {
            result: (0, $2HasX.RESULTS).FAILURE
        });
    },
    fieldDeletedSuccess: (event, attributes)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/51170
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issueField deleted', attributes);
    },
    fieldDeletedFailure: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47519
        (0, $aJ81Y.fireTrackAnalytics)(event, 'fieldConfig updated', 'fieldDeleted', {
            result: (0, $2HasX.RESULTS).FAILURE
        });
    },
    optionLabelChanged: (event, attributes)=>{
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'optionLabel'
                }
            ],
            ...attributes
        });
    },
    optionCreatedSuccess: (event, attributes)=>{
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'optionLabel',
                    updateType: 'created'
                }
            ],
            ...attributes
        });
    },
    optionCreatedFailure: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47519
        (0, $aJ81Y.fireTrackAnalytics)(event, 'fieldConfig updated', 'optionCreated', {
            result: (0, $2HasX.RESULTS).FAILURE
        });
    },
    optionDeletedSuccess: (event, attributes)=>{
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'optionLabel',
                    updateType: 'deleted'
                }
            ],
            ...attributes
        });
    },
    optionDeletedFailure: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47519
        (0, $aJ81Y.fireTrackAnalytics)(event, 'fieldConfig updated', 'optionDeleted', {
            result: (0, $2HasX.RESULTS).FAILURE
        });
    },
    optionWeightChanged: (event, attributes)=>{
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'optionWeight'
                }
            ],
            ...attributes
        });
    },
    optionRankChanged: (event, attributes)=>{
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'optionRank'
                }
            ],
            ...attributes
        });
    },
    optionWeightTypeChanged: (event, attributes)=>{
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'optionWeightType'
                }
            ],
            ...attributes
        });
    },
    valueDecorationChanged: (event, attributes)=>{
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'fieldValueDecorations'
                }
            ],
            ...attributes
        });
    }
};

});
parcelRegister("2HasX", function(module, exports) {
$parcel$export(module.exports, "RESULTS", () => $d30632bfb733dbfa$export$190fdd7c86e5a6c7);
/* eslint-disable jira/filename-case */ const $d30632bfb733dbfa$export$190fdd7c86e5a6c7 = {
    SUCCESS: 'success',
    FAILURE: 'failure'
};

});


parcelRegister("8wBbD", function(module, exports) {
$parcel$export(module.exports, "Field", () => $872aab859b5aa78c$export$a455218a85c89869);
/* eslint-disable jira/filename-case */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aJ81Y = parcelRequire("aJ81Y");

var $2HasX = parcelRequire("2HasX");
const $872aab859b5aa78c$export$a455218a85c89869 = {
    createdSuccess: (event, attributes)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/51308
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issueField created', attributes);
    },
    createdFailure: (event, fieldType)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47737
        (0, $aJ81Y.fireTrackAnalytics)(event, 'ideaField created', {
            result: (0, $2HasX.RESULTS).FAILURE,
            fieldType: fieldType
        });
    }
};

});

parcelRegister("6NNTe", function(module, exports) {
$parcel$export(module.exports, "IdeaView", () => $651671681e4d3e48$export$b0c41ca9ce1c19e6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // TODO: Move isDeliverySection to a lib package to fix layering violation
// eslint-disable-next-line jira/import/no-restricted-import

var $idtgC = parcelRequire("idtgC");

var $aJ81Y = parcelRequire("aJ81Y");

var $jxSHn = parcelRequire("jxSHn");
const $651671681e4d3e48$export$b0c41ca9ce1c19e6 = {
    copyIdeaLinkButtonClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47650
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'copyIdeaLinkButton');
    },
    copyIdeaCommentLinkButtonClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/48687
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'copyIdeaCommentLinkButton');
    },
    copyIdeaInsightLinkButtonClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/50374
        (0, $aJ81Y.fireUIAnalytics)(event, 'icon clicked', 'copyIdeaInsightLink');
    },
    viewed: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/n5034S7jQww7n-LViD6ZpHEP3xM
        (0, $jxSHn.sendPendoTrackEvent)('idea_opened');
        // Fullscreen: https://data-portal.internal.atlassian.com/analytics/registry/893
        // Sidebar: https://data-portal.internal.atlassian.com/analytics/registry/51086
        (0, $aJ81Y.fireScreenAnalytics)(event);
    },
    tabClicked: (event, issueViewSection)=>{
        let actionSubjectId = issueViewSection;
        if (issueViewSection === 'capture') actionSubjectId = 'insights';
        else if ((0, $idtgC.isDeliverySection)(issueViewSection)) actionSubjectId = 'delivery';
        (0, $aJ81Y.fireUIAnalytics)(event, 'tab clicked', actionSubjectId);
    },
    linkIssue: (event, { isRemoteLinked: isRemoteLinked, renderingLocation: renderingLocation, sourceInstanceType: sourceInstanceType })=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/59591
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issueLink added', {
            isRemoteLinked: isRemoteLinked,
            renderingLocation: renderingLocation,
            sourceInstanceType: sourceInstanceType
        });
    },
    linkIssueNew: (event, { isRemoteLinked: isRemoteLinked, renderingLocation: renderingLocation, sourceInstanceType: sourceInstanceType, issueLinkTypeName: issueLinkTypeName, projectType: projectType })=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/59591
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issueLink added', {
            isRemoteLinked: isRemoteLinked,
            renderingLocation: renderingLocation,
            sourceInstanceType: sourceInstanceType,
            issueLinkTypeName: issueLinkTypeName,
            projectType: projectType
        });
    },
    unlinkIssue: (event, { isRemoteLinked: isRemoteLinked, renderingLocation: renderingLocation, sourceInstanceType: sourceInstanceType })=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/59593
        (0, $aJ81Y.fireTrackAnalytics)(event, 'issueLink deleted', {
            isRemoteLinked: isRemoteLinked,
            renderingLocation: renderingLocation,
            sourceInstanceType: sourceInstanceType
        });
    },
    DeliveryTab: {
        createDeliveryTicketButtonClicked: (event, isFromHint = false)=>{
            (0, $jxSHn.sendPendoTrackEvent)('ideaViewDeliveryCreateDeliveryTicketButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/50485
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'createDeliveryTicket', {
                isFromHint: isFromHint
            });
        },
        linkDeliveryTicketButtonClicked: (event, isFromHint = false)=>{
            (0, $jxSHn.sendPendoTrackEvent)('ideaViewDeliveryLinkDeliveryTicketButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/50507
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'addDeliveryTicket', {
                isFromHint: isFromHint
            });
        },
        deliveryTicketsHintClosed: (event)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/50733
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'closeDeliveryTicketsHint');
        },
        learnMoreButtonClicked: (event, isFromHint = false)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/50732
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'learnMoreAboutDeliveryTickets', {
                isFromHint: isFromHint
            });
        },
        deliveryTicketCreated: (event, { createdIssueId: createdIssueId, createdIssueProjectId: createdIssueProjectId, embedIdeaInDescription: embedIdeaInDescription, isRemoteLinked: isRemoteLinked, sourceInstanceType: sourceInstanceType })=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/61825
            (0, $aJ81Y.fireTrackAnalytics)(event, 'deliveryTicket created', {
                createdIssueId: createdIssueId,
                createdIssueProjectId: createdIssueProjectId,
                embedIdeaInDescription: embedIdeaInDescription,
                isRemoteLinked: isRemoteLinked,
                sourceInstanceType: sourceInstanceType
            });
        }
    },
    InsightsTab: {
        createInsightButtonClicked: (event, isFromHint = false)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/50336
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'createInsight', {
                isFromHint: isFromHint
            });
        },
        createInsightHintClosed: (event)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/50739
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'closeCreateInsightsHint');
        },
        createInsightLearnMoreButtonClicked: (event, isFromHint = false)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/50738
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'learnMoreCreateInsightsTickets', {
                isFromHint: isFromHint
            });
        },
        addLinkToInsightsHintClosed: (event)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/50741
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'closeAddLinkToInsightsHint');
        },
        addLinkToInsightsLearnMoreButtonClicked: (event, isFromHint = false)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/50740
            (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'learnMoreAddLinkToInsights', {
                isFromHint: isFromHint
            });
        }
    }
};

});
parcelRegister("idtgC", function(module, exports) {
$parcel$export(module.exports, "isDeliverySection", () => $3af5b15fcc5fe344$export$738d23f035ebf396);

var $FyMPf = parcelRequire("FyMPf");
const $3af5b15fcc5fe344$export$738d23f035ebf396 = (section)=>{
    if (!section) return false;
    return section === (0, $FyMPf.ISSUE_VIEW_SECTION).DELIVER_CREATE || section === (0, $FyMPf.ISSUE_VIEW_SECTION).DELIVER_LINK || section === (0, $FyMPf.ISSUE_VIEW_SECTION).DELIVER;
};

});
parcelRegister("FyMPf", function(module, exports) {
$parcel$export(module.exports, "ISSUE_VIEW_SECTION", () => $479fed04dd38365f$export$700915221513672f);
$parcel$export(module.exports, "ISSUE_VIEW_SECTIONS", () => $479fed04dd38365f$export$23877b55cbd2811a);
const $479fed04dd38365f$export$700915221513672f = {
    OVERVIEW: 'overview',
    COMMENTS: 'comments',
    CAPTURE: 'capture',
    FEEDBACK_INSIGHTS: 'insights',
    DELIVER: 'deliver',
    DELIVER_CREATE: 'deliver_create',
    DELIVER_LINK: 'deliver_link',
    HISTORY: 'history',
    CONNECTIONS: 'connections'
};
const $479fed04dd38365f$export$23877b55cbd2811a = Object.values($479fed04dd38365f$export$700915221513672f);

});



parcelRegister("3nTaW", function(module, exports) {
$parcel$export(module.exports, "ListView", () => $96472f4daae20dc0$export$84d0dd190d551cd1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aJ81Y = parcelRequire("aJ81Y");

var $jxSHn = parcelRequire("jxSHn");
const $96472f4daae20dc0$export$84d0dd190d551cd1 = {
    opened: (event, accessLevel)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/M2-9XepSbr5FNP9yFynxrzIQUZQ
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'listView opened',
            attributes: {
                accessLevel: accessLevel || ''
            }
        });
        // https://data-portal.internal.atlassian.com/analytics/registry/51087
        (0, $aJ81Y.fireScreenAnalytics)(event, {
            accessLevel: accessLevel
        });
    },
    fieldValueUpdatedByDragBetweenSwimlanes: (fieldType)=>{
        (0, $jxSHn.sendPendoTrackEvent)(`fieldValue updated ${fieldType} listDragBetweenSwimlanes`);
    },
    fieldValueUpdatedByInlineEdit: (fieldType)=>{
        (0, $jxSHn.sendPendoTrackEvent)(`fieldValue updated ${fieldType} listInlineEdit`);
    },
    columnActionItemClicked: (event, attributes)=>{
        (0, $jxSHn.sendPendoTrackEvent)(`listViewColumnActionItem ${attributes.selectedActionItem}`);
        (0, $aJ81Y.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewFieldActions', attributes);
    },
    learnMoreAboutArchiveButtonClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/56971
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'learnMoreAboutArchivingIdeas', {});
    },
    addIdeaFixedBottomRowClicked: (event, grouped)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/75128
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'addIdeaFixedRow', {
            grouped: grouped
        });
    }
};

});

parcelRegister("dwqdq", function(module, exports) {
$parcel$export(module.exports, "MatrixView", () => $36988264b7b99a65$export$3f8d83934fd139e9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aJ81Y = parcelRequire("aJ81Y");

var $jxSHn = parcelRequire("jxSHn");
const $36988264b7b99a65$export$3f8d83934fd139e9 = {
    opened: (event, accessLevel)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/5PATMUbxnbpQjTatZdHcElQVLqw
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'matrixView opened',
            attributes: {
                accessLevel: accessLevel || ''
            }
        });
        // https://data-portal.internal.atlassian.com/analytics/registry/51088
        (0, $aJ81Y.fireScreenAnalytics)(event, {
            accessLevel: accessLevel
        });
    },
    fieldUpdatedByDragWithinXAxis: (fieldType)=>{
        (0, $jxSHn.sendPendoTrackEvent)(`fieldValue updated ${fieldType} matrixDragXAxis`);
    },
    fieldUpdatedByDragWithinYAxis: (fieldType)=>{
        (0, $jxSHn.sendPendoTrackEvent)(`fieldValue updated ${fieldType} matrixDragYAxis`);
    }
};

});

parcelRegister("fuiX6", function(module, exports) {
$parcel$export(module.exports, "TimelineView", () => $f07f229236030cc5$export$4e254246a3a175f9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aJ81Y = parcelRequire("aJ81Y");

var $jxSHn = parcelRequire("jxSHn");
const $f07f229236030cc5$export$4e254246a3a175f9 = {
    opened: (event, itemCount, timelineLength, accessLevel)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/zzYGsTOijWyY1VfJ56VtLUI-Rzw
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timelineView opened',
            attributes: {
                accessLevel: accessLevel || ''
            }
        });
        if (itemCount <= 10) (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timeline[0to10] opened'
        });
        else if (itemCount <= 25) (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timeline(10to25] opened'
        });
        else if (itemCount <= 50) (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timeline(25to50] opened'
        });
        else if (itemCount <= 100) (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timeline(50to100] opened'
        });
        else (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timeline>100 opened'
        });
        // https://data-portal.internal.atlassian.com/analytics/registry/51090
        (0, $aJ81Y.fireScreenAnalytics)(event, {
            itemCount: itemCount,
            timelineLength: timelineLength,
            accessLevel: accessLevel
        });
    }
};

});

parcelRegister("lOMlp", function(module, exports) {
$parcel$export(module.exports, "ViewHeader", () => $92e51de8b2e1f9de$export$96d5c22d305e32a0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aJ81Y = parcelRequire("aJ81Y");
const $92e51de8b2e1f9de$export$96d5c22d305e32a0 = {
    copyViewLinkButtonClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47649
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'copyViewLinkButton');
    }
};

});

parcelRegister("okmuj", function(module, exports) {
$parcel$export(module.exports, "View", () => $b8aa82fc589a6ae1$export$27a5bd065ad55220);
/* eslint-disable jira/filename-case */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aJ81Y = parcelRequire("aJ81Y");

var $jxSHn = parcelRequire("jxSHn");

var $2HasX = parcelRequire("2HasX");
const $b8aa82fc589a6ae1$export$27a5bd065ad55220 = {
    createdSuccess: (event, viewKind)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47738
        (0, $aJ81Y.fireTrackAnalytics)(event, 'view created', {
            result: (0, $2HasX.RESULTS).SUCCESS,
            targetViewKind: viewKind
        });
    },
    createdFailure: (event, viewKind)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47738
        (0, $aJ81Y.fireTrackAnalytics)(event, 'view created', {
            result: (0, $2HasX.RESULTS).FAILURE,
            targetViewKind: viewKind
        });
    },
    nameChanged: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47648
        (0, $aJ81Y.fireTrackAnalytics)(event, 'view updated', {
            updatedItems: [
                {
                    name: 'name'
                }
            ]
        });
    },
    emojiChanged: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47648
        (0, $aJ81Y.fireTrackAnalytics)(event, 'view updated', 'emojiChanged');
    },
    copyViewCommentLinkButtonClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/48689
        (0, $aJ81Y.fireUIAnalytics)(event, 'button clicked', 'copyViewCommentLinkButton');
    },
    viewSettingsOpened: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('viewSettings opened');
    },
    autosaveChanged: (event, isEnabled)=>{
        (0, $jxSHn.sendPendoTrackEvent)(isEnabled ? 'autosave enabled' : 'autosave disabled');
        (0, $aJ81Y.fireUIAnalytics)(event, 'autosave changed', {
            isEnabled: isEnabled
        });
    },
    unsavedChangesReset: (event)=>{
        (0, $jxSHn.sendPendoTrackEvent)('unsavedChanges reset');
        (0, $aJ81Y.fireUIAnalytics)(event, 'unsavedChanges reset');
    },
    unsavedChangesSave: (event)=>{
        (0, $jxSHn.sendPendoTrackEvent)('unsavedChanges saved');
        (0, $aJ81Y.fireUIAnalytics)(event, 'unsavedChanges saved');
    },
    unsavedChangesSaveAsNew: (event)=>{
        (0, $jxSHn.sendPendoTrackEvent)('unsavedChanges savedAsNew');
        (0, $aJ81Y.fireUIAnalytics)(event, 'unsavedChanges savedAsNew');
    },
    viewLayoutSettingOpened: ()=>{
        (0, $jxSHn.sendPendoTrackEvent)('viewLayoutSetting opened');
    },
    viewLayoutChanged: (event, layoutType)=>{
        (0, $jxSHn.sendPendoTrackEvent)(`view layout changed - ${layoutType.toLowerCase()}`);
        (0, $aJ81Y.fireUIAnalytics)(event, 'viewLayout changed', {
            layoutType: layoutType
        });
    },
    connectionsLayoutChanged: (event, layoutType)=>{
        (0, $jxSHn.sendPendoTrackEvent)(`connections layout changed - ${layoutType.toLowerCase()}`);
        (0, $aJ81Y.fireUIAnalytics)(event, 'connectionsLayout changed', {
            layoutType: layoutType
        });
    }
};

});

parcelRegister("ewAyW", function(module, exports) {
$parcel$export(module.exports, "TreeView", () => $c915bef48cbc5a0b$export$6940b0d9c820eca7);

var $aJ81Y = parcelRequire("aJ81Y");

var $jxSHn = parcelRequire("jxSHn");
const $c915bef48cbc5a0b$export$6940b0d9c820eca7 = {
    opened: (event, accessLevel)=>{
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'treeView opened',
            attributes: {
                accessLevel: accessLevel || ''
            }
        });
        (0, $aJ81Y.fireScreenAnalytics)(event, {
            accessLevel: accessLevel
        });
    },
    treeDirectionChanged: (event, direction)=>{
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'treeDirection changed',
            attributes: {
                direction: direction || ''
            }
        });
        (0, $aJ81Y.fireTrackAnalytics)(event, 'treeDirection changed', {
            direction: direction || ''
        });
    },
    connectionRemoved: (event)=>{
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'treeConnection removed',
            attributes: {}
        });
        (0, $aJ81Y.fireTrackAnalytics)(event, 'treeConnection removed');
    },
    nodeReordered: (event, parentChangeType)=>{
        (0, $jxSHn.sendPendoTrackEvent)({
            actionSubjectAndAction: 'treeNode reordered',
            attributes: {
                parentChangeType: parentChangeType
            }
        });
        (0, $aJ81Y.fireTrackAnalytics)(event, 'treeNode reordered', {
            parentChangeType: parentChangeType || ''
        });
    }
};

});


parcelRegister("is1er", function(module, exports) {
$parcel$export(module.exports, "remapValueDecorations", () => $33e7fc1e8826869e$export$366e4db7f45672a6);
$parcel$export(module.exports, "performJiraConfigurationUpdate", () => $33e7fc1e8826869e$export$72f886ca488f3f78);
const $33e7fc1e8826869e$export$366e4db7f45672a6 = (decorations)=>decorations.length > 0 ? {
        valueDecorations: decorations.map((decoration)=>({
                ...decoration.backgroundColor ? {
                    backgroundColor: decoration.backgroundColor
                } : {},
                ...decoration.emoji ? {
                    emoji: decoration.emoji
                } : {},
                highlightContainer: decoration.highlightContainer,
                logic: decoration.logic
            }))
    } : {};
const $33e7fc1e8826869e$export$72f886ca488f3f78 = ({ fieldKey: fieldKey, fieldRemote: fieldRemote, existingDecorations: existingDecorations, newDecorations: newDecorations })=>{
    const oldConfiguration = $33e7fc1e8826869e$export$366e4db7f45672a6(existingDecorations);
    const configuration = $33e7fc1e8826869e$export$366e4db7f45672a6(newDecorations);
    return fieldRemote.updateFieldConfiguration({
        fieldKey: fieldKey,
        oldConfiguration: oldConfiguration,
        configuration: configuration,
        type: 'updateFieldDecorations'
    });
};

});


parcelRegister("l7dPI", function(module, exports) {
$parcel$export(module.exports, "deleteValueDecoration", () => $cdeb453e5bcf87db$export$7c9c473571e097ae);
$parcel$export(module.exports, "deleteAllValueDecorations", () => $cdeb453e5bcf87db$export$b56439617c923c6b);

var $i7bkV = parcelRequire("i7bkV");

var $is1er = parcelRequire("is1er");
const $cdeb453e5bcf87db$export$7c9c473571e097ae = (fieldKey, localDecorationId)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent, onDecorationUpdateFailed: onDecorationUpdateFailed })=>{
        const state = getState();
        const { fieldValueDecorations: fieldValueDecorations, fields: fields } = state;
        const field = fields[fieldKey];
        const existingValueDecorations = fieldValueDecorations[fieldKey] || [];
        const newValueDecorations = [
            ...existingValueDecorations
        ];
        const decorationIdx = newValueDecorations.findIndex(({ localDecorationId: id })=>localDecorationId === id);
        newValueDecorations.splice(decorationIdx, 1);
        setState({
            fieldValueDecorations: {
                ...fieldValueDecorations,
                [fieldKey]: newValueDecorations
            }
        });
        try {
            try {
                await (0, $is1er.performJiraConfigurationUpdate)({
                    fieldKey: fieldKey,
                    fieldRemote: fieldRemote,
                    existingDecorations: existingValueDecorations,
                    newDecorations: newValueDecorations
                });
                (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.valueDecorationChanged(createAnalyticsEvent({}), {
                    issueFieldKey: fieldKey,
                    issueFieldType: field.type
                });
            } catch (error) {
                setState({
                    fieldValueDecorations: {
                        ...getState().fieldValueDecorations,
                        [fieldKey]: existingValueDecorations
                    }
                });
                throw error;
            }
        } catch (error) {
            onDecorationUpdateFailed(error instanceof Error ? error : new Error('Failed to delete value decoration'));
        }
    };
const $cdeb453e5bcf87db$export$b56439617c923c6b = ({ fieldKey: fieldKey })=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        try {
            const state = getState();
            const { fieldValueDecorations: fieldValueDecorations, fields: fields } = state;
            const field = fields[fieldKey];
            const existingValueDecorations = fieldValueDecorations[fieldKey] || [];
            setState({
                fieldValueDecorations: {
                    ...fieldValueDecorations,
                    [fieldKey]: []
                }
            });
            await (0, $is1er.performJiraConfigurationUpdate)({
                fieldKey: fieldKey,
                fieldRemote: fieldRemote,
                existingDecorations: existingValueDecorations,
                newDecorations: []
            });
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.valueDecorationChanged(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: field.type
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            onFieldUpdateFailed(e);
        }
        return undefined;
    };

});

parcelRegister("GDDaC", function(module, exports) {
$parcel$export(module.exports, "updateValueDecoration", () => $c798248745565a86$export$57375c08ef65980a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3KC5U = parcelRequire("3KC5U");
const $c798248745565a86$export$57375c08ef65980a = (updateProps)=>({ getState: getState, setState: setState }, { fieldRemote: fieldRemote, onDecorationUpdateFailed: onDecorationUpdateFailed, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $3KC5U.updateInternal)(updateProps, fieldRemote, getState, setState, onDecorationUpdateFailed, createAnalyticsEvent);
    };

});
parcelRegister("3KC5U", function(module, exports) {
$parcel$export(module.exports, "updateInternal", () => $fc56b322dc1e48f9$export$335aa5770c9dcf5b);

var $i7bkV = parcelRequire("i7bkV");

var $is1er = parcelRequire("is1er");
const $fc56b322dc1e48f9$export$335aa5770c9dcf5b = async (updateProps, fieldRemote, getState, setState, onDecorationUpdateFailed, createAnalyticsEvent)=>{
    const { fieldKey: fieldKey, localDecorationId: localDecorationId } = updateProps;
    const state = getState();
    const { fieldValueDecorations: fieldValueDecorations, fields: fields } = state;
    const field = fields[fieldKey];
    const existingValueDecorations = fieldValueDecorations[fieldKey] || [];
    const itemIndex = existingValueDecorations.findIndex((decoration)=>decoration.localDecorationId === localDecorationId);
    if (itemIndex === -1) // noop update of non-existing id
    return;
    const oldDecoration = existingValueDecorations[itemIndex];
    const newValueDecorations = [
        ...existingValueDecorations
    ];
    newValueDecorations[itemIndex] = {
        ...oldDecoration,
        ...updateProps
    };
    setState({
        fieldValueDecorations: {
            ...fieldValueDecorations,
            [fieldKey]: newValueDecorations
        }
    });
    try {
        try {
            await (0, $is1er.performJiraConfigurationUpdate)({
                fieldKey: fieldKey,
                fieldRemote: fieldRemote,
                existingDecorations: existingValueDecorations,
                newDecorations: newValueDecorations
            });
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.valueDecorationChanged(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: field.type
            });
        } catch (error) {
            setState({
                fieldValueDecorations: {
                    ...getState().fieldValueDecorations,
                    [fieldKey]: existingValueDecorations
                }
            });
            throw error;
        }
    } catch (error) {
        onDecorationUpdateFailed(error instanceof Error ? error : new Error('Failed to update value decoration'));
    }
};

});


parcelRegister("jVdiV", function(module, exports) {
$parcel$export(module.exports, "deleteFieldLocally", () => $fecd9a91986658c2$export$35c076545da7e74c);
$parcel$export(module.exports, "deleteField", () => $fecd9a91986658c2$export$2bbad96c62fdba3e);

var $f99M0 = parcelRequire("f99M0");

var $j85oP = parcelRequire("j85oP");

var $7imRA = parcelRequire("7imRA");

var $i7bkV = parcelRequire("i7bkV");
const $fecd9a91986658c2$export$35c076545da7e74c = (fieldKey)=>async ({ getState: getState, setState: setState })=>{
        const updatedFields = {
            ...getState().fields
        };
        delete updatedFields[fieldKey];
        const updatedDecorations = {
            ...getState().fieldValueDecorations
        };
        delete updatedDecorations[fieldKey];
        setState({
            fields: updatedFields,
            fieldValueDecorations: updatedDecorations
        });
    };
const $fecd9a91986658c2$export$2bbad96c62fdba3e = (fieldKey, onSuccess, onError)=>async ({ getState: getState, dispatch: dispatch }, { onFieldUpdateFailed: onFieldUpdateFailed, deletePlay: deletePlay, createAnalyticsEvent: createAnalyticsEvent, fieldRemote: fieldRemote, globalFieldRemote: globalFieldRemote, projectId: projectId })=>{
        try {
            const currFieldMap = getState().fields;
            const { key: key, custom: custom, global: global } = currFieldMap[fieldKey];
            const deletedFieldPlay = currFieldMap[fieldKey]?.play;
            const isGlobalField = custom && global;
            if (!isGlobalField) await fieldRemote.deleteField({
                fieldKey: key
            });
            else {
                if (!projectId) throw new Error('project id is not available');
                await (0, $7imRA.wrapWithExperience)((0, $j85oP.experience).globalFieldsAdministration.globalFieldUnassociate, ()=>globalFieldRemote.removeGlobalFieldFromProject({
                        fieldKey: key,
                        projectId: projectId
                    }));
            }
            // FE state only removal of play; this has no side effects
            if (deletedFieldPlay) deletePlay(deletedFieldPlay);
            dispatch($fecd9a91986658c2$export$35c076545da7e74c(fieldKey));
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.fieldDeletedSuccess(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: currFieldMap[fieldKey]?.type,
                isGlobalField: isGlobalField,
                fieldScope: isGlobalField ? 'global' : 'project',
                projectType: (0, $f99M0.PRODUCT_DISCOVERY_PROJECT)
            });
            onSuccess?.();
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.fieldDeletedFailure(createAnalyticsEvent({}));
            onError?.(e);
            onFieldUpdateFailed(e);
        }
        return undefined;
    };

});

parcelRegister("b8Ea6", function(module, exports) {
$parcel$export(module.exports, "captureLastFieldsUpdate", () => $cfa3466ff2e3cec3$export$f59864139f62d68b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $cfa3466ff2e3cec3$export$f59864139f62d68b = (lastFieldsUpdate)=>async ({ setState: setState })=>{
        setState({
            lastFieldsUpdate: lastFieldsUpdate
        });
    };

});

parcelRegister("8IpNj", function(module, exports) {
$parcel$export(module.exports, "updateDeliveryDateAggregationType", () => $c09560dbf6ac8f59$export$9593c3851a66ed74);

var $aJ81Y = parcelRequire("aJ81Y");

var $2cQDy = parcelRequire("2cQDy");
const $c09560dbf6ac8f59$export$9593c3851a66ed74 = (fieldKey, aggregationType, contextAnalyticsEvent)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote })=>{
        const state = getState();
        // oxlint-disable-next-line typescript/no-non-null-assertion
        const currentField = (0, $2cQDy.createGetFieldByKey)(fieldKey)(state);
        const oldConfiguration = currentField.configuration ? currentField.configuration : {};
        const newConfiguration = {
            ...currentField.configuration
        };
        if (aggregationType) newConfiguration.aggregationType = aggregationType;
        else delete newConfiguration.aggregationType;
        const fields = {
            ...getState().fields
        };
        fields[fieldKey] = {
            ...fields[fieldKey],
            configuration: newConfiguration
        };
        setState({
            fields: fields
        });
        await fieldRemote.updateFieldConfiguration({
            fieldKey: fieldKey,
            oldConfiguration: oldConfiguration,
            configuration: newConfiguration,
            type: 'updateDeliveryDateAggregationType'
        });
        (0, $aJ81Y.fireTrackAnalytics)(contextAnalyticsEvent, 'issueFields updated', {
            issueFieldKey: fieldKey,
            issueFieldType: currentField.type,
            updatedItems: [
                {
                    name: 'aggregationType'
                }
            ]
        });
    };

});
parcelRegister("2cQDy", function(module, exports) {
$parcel$export(module.exports, "createGetFieldByKey", () => $e61ceb2ac8ab5d52$export$f0d43ae105c44a16);
$parcel$export(module.exports, "createGetAllFieldByKey", () => $e61ceb2ac8ab5d52$export$d9cbaffcf8051ce7);
$parcel$export(module.exports, "createGetFieldType", () => $e61ceb2ac8ab5d52$export$cbdf4c7acce43aed);
$parcel$export(module.exports, "createGetFieldLabel", () => $e61ceb2ac8ab5d52$export$c690e8b384bae5e8);
$parcel$export(module.exports, "createGetIsSystemField", () => $e61ceb2ac8ab5d52$export$b95ca9bb53fcdfef);
$parcel$export(module.exports, "createGetFieldPlay", () => $e61ceb2ac8ab5d52$export$ed356202b542678e);
$parcel$export(module.exports, "createGetEditable", () => $e61ceb2ac8ab5d52$export$c0736d3defdc2d16);
$parcel$export(module.exports, "createGetFieldOfType", () => $e61ceb2ac8ab5d52$export$8ab6e7aafdab7605);
$parcel$export(module.exports, "createGetIsDeletable", () => $e61ceb2ac8ab5d52$export$db3f1e906529485e);
$parcel$export(module.exports, "createGetFieldDescription", () => $e61ceb2ac8ab5d52$export$c3a80db9f8f140f0);
$parcel$export(module.exports, "createGetFieldEmoji", () => $e61ceb2ac8ab5d52$export$67716b47d053849d);
$parcel$export(module.exports, "createGetFieldByPlayId", () => $e61ceb2ac8ab5d52$export$45b3e7fa07622627);
$parcel$export(module.exports, "createGetFieldKeysOfType", () => $e61ceb2ac8ab5d52$export$e75cb7c95fc7fe3c);
$parcel$export(module.exports, "createGetFieldConfiguration", () => $e61ceb2ac8ab5d52$export$7828213198a538a2);
$parcel$export(module.exports, "createGetFieldHidden", () => $e61ceb2ac8ab5d52$export$185ec73baae348f);
$parcel$export(module.exports, "createGetFieldRestricted", () => $e61ceb2ac8ab5d52$export$d095f4e3ba265ab2);
$parcel$export(module.exports, "getFieldTypeIcon", () => $e61ceb2ac8ab5d52$export$8746027cc5b4845);

var $a7e1f = parcelRequire("a7e1f");

var $lziWQ = parcelRequire("lziWQ");

var $bnS7o = parcelRequire("bnS7o");

var $eqVei = parcelRequire("eqVei");

var $4EUgt = parcelRequire("4EUgt");
const $e61ceb2ac8ab5d52$export$f0d43ae105c44a16 = (fieldKey)=>(0, $a7e1f.createSelector)((0, $4EUgt.getFields), (fields)=>fieldKey ? fields[fieldKey] : undefined);
const $e61ceb2ac8ab5d52$export$d9cbaffcf8051ce7 = (fieldKey)=>(0, $a7e1f.createSelector)((0, $4EUgt.getAllFields), (fields)=>fieldKey ? fields[fieldKey] : undefined);
const $e61ceb2ac8ab5d52$export$cbdf4c7acce43aed = (fieldKey)=>(0, $a7e1f.createSelector)((0, $4EUgt.getFields), (fields)=>fieldKey !== undefined ? fields[fieldKey]?.type : undefined);
const $e61ceb2ac8ab5d52$export$c690e8b384bae5e8 = (fieldKey)=>(0, $a7e1f.createSelector)((0, $4EUgt.getFields), (fields)=>fieldKey !== undefined ? fields[fieldKey]?.label : undefined);
const $e61ceb2ac8ab5d52$export$b95ca9bb53fcdfef = (fieldKey)=>(0, $a7e1f.createSelector)((0, $4EUgt.getFields), (fields)=>{
        if (fieldKey === undefined) return false;
        const field = fields[fieldKey];
        // field can be undefined because when we delete a field via sidenav it gets optimistically removed from the store and is not present in response from getFields
        return field ? (0, $lziWQ.isSystemFieldType)(field.type) : false;
    });
const $e61ceb2ac8ab5d52$export$ed356202b542678e = (fieldKey)=>(0, $a7e1f.createSelector)((0, $4EUgt.getFields), (fields)=>fieldKey !== undefined ? fields[fieldKey]?.play : undefined);
const $e61ceb2ac8ab5d52$export$c0736d3defdc2d16 = (fieldKey)=>(0, $a7e1f.createSelector)((0, $4EUgt.getFields), (fields)=>fieldKey !== undefined ? fields[fieldKey]?.editable : false);
const $e61ceb2ac8ab5d52$export$8ab6e7aafdab7605 = (ofType)=>(0, $a7e1f.createSelector)((0, $4EUgt.getAllFieldArray), (fields)=>fields.find((field)=>field.type === ofType));
const $e61ceb2ac8ab5d52$export$db3f1e906529485e = (fieldKey)=>(0, $a7e1f.createSelector)((0, $4EUgt.getFields), (fields)=>{
        if (fieldKey === undefined || fields[fieldKey] === undefined) return false;
        return !(0, $lziWQ.isSystemFieldType)(fields[fieldKey].type);
    });
const $e61ceb2ac8ab5d52$export$c3a80db9f8f140f0 = (fieldKey)=>(0, $a7e1f.createSelector)((0, $4EUgt.getFields), (fields)=>{
        const fixedDescriptionFields = [
            'summary',
            'assignee',
            'created',
            'creator',
            'key',
            'reporter',
            'status',
            'updated',
            'labels'
        ];
        const value = fields[fieldKey]?.description ?? '';
        return {
            value: value,
            adf: (0, $eqVei.parseAdfString)(value),
            fixed: fixedDescriptionFields.includes(fieldKey)
        };
    });
const $e61ceb2ac8ab5d52$export$67716b47d053849d = (fieldKey)=>(0, $a7e1f.createSelector)((0, $4EUgt.getFields), (fields)=>fields[fieldKey]?.emoji);
const $e61ceb2ac8ab5d52$export$45b3e7fa07622627 = (playId)=>(0, $a7e1f.createSelector)((0, $4EUgt.getFields), (fields)=>Object.keys(fields).map((key)=>fields[key]).find(({ play: play })=>play?.id === playId));
const $e61ceb2ac8ab5d52$export$e75cb7c95fc7fe3c = (ofType)=>(0, $a7e1f.createSelector)((0, $4EUgt.getAllFieldArray), (fields)=>fields.filter(({ type: type })=>ofType === type).map(({ key: key })=>key));
const $e61ceb2ac8ab5d52$export$7828213198a538a2 = (fieldKey)=>{
    const getFieldByKey = $e61ceb2ac8ab5d52$export$f0d43ae105c44a16(fieldKey);
    return (0, $a7e1f.createSelector)(getFieldByKey, (field)=>field?.configuration);
};
const $e61ceb2ac8ab5d52$export$185ec73baae348f = (fieldKey)=>{
    const getFieldConfiguration = $e61ceb2ac8ab5d52$export$7828213198a538a2(fieldKey);
    return (0, $a7e1f.createSelector)(getFieldConfiguration, (configuration)=>configuration?.hidden ?? false);
};
const $e61ceb2ac8ab5d52$export$d095f4e3ba265ab2 = (fieldKey)=>{
    const getFieldByKey = $e61ceb2ac8ab5d52$export$f0d43ae105c44a16(fieldKey);
    return (0, $a7e1f.createSelector)(getFieldByKey, (field)=>!!field?.hasRestrictedContext);
};
const $e61ceb2ac8ab5d52$export$a39dee5f7c34c244 = (fieldKey)=>{
    const getFieldConfiguration = $e61ceb2ac8ab5d52$export$7828213198a538a2(fieldKey);
    return (0, $a7e1f.createSelector)(getFieldConfiguration, (configuration)=>configuration?.optionWeightType !== undefined);
};
const $e61ceb2ac8ab5d52$export$8746027cc5b4845 = (fieldKey, iconProps)=>{
    const getFieldType = $e61ceb2ac8ab5d52$export$cbdf4c7acce43aed(fieldKey);
    const getFieldConfiguration = $e61ceb2ac8ab5d52$export$7828213198a538a2(fieldKey);
    return (0, $a7e1f.createSelector)(getFieldType, getFieldConfiguration, (fieldType, configuration)=>(0, $bnS7o.iconForPolarisFieldType)(fieldType, iconProps, configuration));
};

});
parcelRegister("lziWQ", function(module, exports) {
$parcel$export(module.exports, "isDeliveryFieldType", () => $e3e8b327b7c6464e$export$b385e3f09b435844);
$parcel$export(module.exports, "isSystemFieldType", () => $e3e8b327b7c6464e$export$89ca1a31640552e2);

var $i860n = parcelRequire("i860n");

var $5GrX3 = parcelRequire("5GrX3");
const $e3e8b327b7c6464e$export$b385e3f09b435844 = (fieldType)=>fieldType === (0, $5GrX3.FIELD_TYPES).DELIVERY_PROGRESS || fieldType === (0, $5GrX3.FIELD_TYPES).DELIVERY_STATUS;
const $e3e8b327b7c6464e$var$JPD_SYSTEM_FIELDS = new Set([
    (0, $5GrX3.FIELD_TYPES).ASSIGNEE,
    (0, $5GrX3.FIELD_TYPES).CREATOR,
    (0, $5GrX3.FIELD_TYPES).CREATED,
    (0, $5GrX3.FIELD_TYPES).DESCRIPTION,
    (0, $5GrX3.FIELD_TYPES).ISSUE_ID,
    (0, $5GrX3.FIELD_TYPES).ISSUE_KEY,
    (0, $5GrX3.FIELD_TYPES).ISSUE_TYPE,
    (0, $5GrX3.FIELD_TYPES).LABELS,
    (0, $5GrX3.FIELD_TYPES).UPDATED,
    (0, $5GrX3.FIELD_TYPES).PROJECT,
    (0, $5GrX3.FIELD_TYPES).REPORTER,
    (0, $5GrX3.FIELD_TYPES).STATUS,
    (0, $5GrX3.FIELD_TYPES).SUMMARY,
    (0, $5GrX3.FIELD_TYPES).PLATFORM_GOALS,
    (0, $5GrX3.FIELD_TYPES).PLATFORM_FOCUS_AREAS,
    (0, $5GrX3.FIELD_TYPES).PLATFORM_ATLAS_PROJECT,
    (0, $5GrX3.FIELD_TYPES).ARCHIVED,
    (0, $5GrX3.FIELD_TYPES).ARCHIVED_BY,
    (0, $5GrX3.FIELD_TYPES).ARCHIVED_ON,
    (0, $5GrX3.FIELD_TYPES).ATLAS_GOAL,
    (0, $5GrX3.FIELD_TYPES).ATLAS_PROJECT,
    (0, $5GrX3.FIELD_TYPES).ATLAS_PROJECT_STATUS,
    (0, $5GrX3.FIELD_TYPES).DELIVERY_PROGRESS,
    (0, $5GrX3.FIELD_TYPES).DELIVERY_STATUS,
    (0, $5GrX3.FIELD_TYPES).INSIGHTS,
    (0, $5GrX3.FIELD_TYPES).ISSUE_COMMENTS,
    (0, $5GrX3.FIELD_TYPES).LINKED_ISSUES
]);
const $e3e8b327b7c6464e$export$89ca1a31640552e2 = (fieldType)=>{
    if (!fieldType) return false;
    if (fieldType === (0, $5GrX3.FIELD_TYPES).PLATFORM_FOCUS_AREAS && !(0, $i860n.fg)('jpd_focus_areas_field_support')) return false;
    return $e3e8b327b7c6464e$var$JPD_SYSTEM_FIELDS.has(fieldType);
};

});

parcelRegister("eqVei", function(module, exports) {
$parcel$export(module.exports, "parseAdfString", () => $f781a7a7e50c058c$export$e9523343c1a01d8b);

var $gqtEw = parcelRequire("gqtEw");

var $njNXW = parcelRequire("njNXW");

var $e4PCO = parcelRequire("e4PCO");
const $f781a7a7e50c058c$export$e9523343c1a01d8b = (value)=>{
    if (!value) return 0, $gqtEw.emptyAdfObject;
    try {
        // case when value is string representation of a number
        if (!Number.isNaN(Number(value))) return (0, $njNXW.doc)((0, $e4PCO.paragraph)(value));
        return JSON.parse(value);
    // this catch is needed for old descriptions that were saved as primitive strings and cannot be parsed as a JSON
    } catch (e) {
        return (0, $njNXW.doc)((0, $e4PCO.paragraph)(value));
    }
};

});
parcelRegister("gqtEw", function(module, exports) {
$parcel$export(module.exports, "emptyAdfObject", () => $c101efc61052a142$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $c101efc61052a142$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $c101efc61052a142$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $c101efc61052a142$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $c101efc61052a142$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $c101efc61052a142$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $c101efc61052a142$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasEmojiNode", () => $c101efc61052a142$export$8c6c40d1455b914a);
$parcel$export(module.exports, "hasHydrationUnsafeRendererNode", () => $c101efc61052a142$export$8af1015721bbfc0);
$parcel$export(module.exports, "hasMediaFileNodes", () => $c101efc61052a142$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $c101efc61052a142$export$80a6e90c7b29d88c);

var $e0DQG = parcelRequire("e0DQG");

var $kmhpG = parcelRequire("kmhpG");

var $6CfY5 = parcelRequire("6CfY5");
const $c101efc61052a142$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $c101efc61052a142$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($c101efc61052a142$export$9e9311e676291037)
    };
    return adf;
};
const $c101efc61052a142$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $c101efc61052a142$export$9e9311e676291037(JSON.parse(adf));
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $c101efc61052a142$export$9e9311e676291037(adf);
};
const $c101efc61052a142$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $c101efc61052a142$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $c101efc61052a142$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $c101efc61052a142$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $c101efc61052a142$export$def86d25f0c7f0bc = (adf)=>$c101efc61052a142$export$cf4bde415465976c(adf) ? $c101efc61052a142$export$202742e99f678c60 : adf;
const $c101efc61052a142$export$8c6c40d1455b914a = (doc)=>{
    let hasEmoji = false;
    (0, $e0DQG.traverse)(doc, {
        emoji: ()=>{
            hasEmoji = true;
            return false; // stop traversing
        }
    });
    return hasEmoji;
};
/**
 * FLASH-927 — `true` if `doc` contains an `@atlaskit/renderer` node type that
 * hydration-mismatches under React 18 concurrent hydration:
 * - `codeBlock` / `windowedCodeBlock`: `@atlaskit/code` `AsyncHighlighter`
 *   reads a class-static `astGenerator` populated only by `componentDidMount`,
 *   so later instances tokenise while SSR emitted plain text.
 * - `mention` / `inlineCard` / `blockCard` / `embedCard`: async-resolved by
 *   providers unavailable in SSR.
 *
 * Callers should wrap output in a hydration-safe boundary (e.g. `RenderOnClient`)
 * when this returns `true`.
 *
 * Throws a sentinel to short-circuit `traverse` because returning `false` only
 * prunes the current subtree — siblings keep being walked.
 */ const $c101efc61052a142$var$HYDRATION_UNSAFE_FOUND = Symbol('hydration-unsafe-renderer-node');
const $c101efc61052a142$export$8af1015721bbfc0 = (doc)=>{
    const throwFound = ()=>{
        throw $c101efc61052a142$var$HYDRATION_UNSAFE_FOUND;
    };
    try {
        (0, $e0DQG.traverse)(doc, {
            codeBlock: throwFound,
            windowedCodeBlock: throwFound,
            mention: throwFound,
            inlineCard: throwFound,
            blockCard: throwFound,
            embedCard: throwFound
        });
    } catch (e) {
        if (e === $c101efc61052a142$var$HYDRATION_UNSAFE_FOUND) return true;
        throw e;
    }
    return false;
};
const $c101efc61052a142$export$9a632b58fb9b287c = (doc)=>{
    const mediaNodes = new Map();
    (0, $e0DQG.traverse)(doc, {
        media: (node)=>{
            // oxlint-disable-next-line typescript/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            mediaNodes.set(mediaNode.attrs.id, node);
        },
        mediaInline: (node)=>{
            // oxlint-disable-next-line typescript/consistent-type-assertions
            const mediaInlineNode = node;
            mediaNodes.set(mediaInlineNode.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $c101efc61052a142$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) (0, $e0DQG.traverse)(newDoc, {
        media: (node)=>{
            // oxlint-disable-next-line typescript/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            newMediaNodes.add(mediaNode.attrs.id);
        },
        mediaInline: (node)=>{
            // oxlint-disable-next-line typescript/consistent-type-assertions
            const mediaInlineNode = node;
            newMediaNodes.add(mediaInlineNode.attrs.id);
        }
    });
    if (currentDoc) (0, $e0DQG.traverse)(currentDoc, {
        media: (node)=>{
            // oxlint-disable-next-line typescript/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            currentMediaNodes.add(mediaNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
            }
        },
        mediaInline: (node)=>{
            // oxlint-disable-next-line typescript/consistent-type-assertions
            const mediaInlineNode = node;
            currentMediaNodes.add(mediaInlineNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $c101efc61052a142$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $kmhpG.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $c101efc61052a142$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await (parcelRequire("228Wb"));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await (parcelRequire("cC0eP"));
    const { JSONTransformer: JSONTransformer } = await (parcelRequire("61O2d"));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("e0DQG", function(module, exports) {
$parcel$export(module.exports, "traverse", () => $a834bed4dfbe6098$export$df3f009e3d155b20);

var $5wH64 = parcelRequire("5wH64");
function $a834bed4dfbe6098$export$df3f009e3d155b20(adf, visitors) {
    if (!(0, $5wH64.validateVisitors)(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $a834bed4dfbe6098$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $a834bed4dfbe6098$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $a834bed4dfbe6098$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});
parcelRegister("5wH64", function(module, exports) {
$parcel$export(module.exports, "validateVisitors", () => $5125b149f9efa8cc$export$735cfea22ce30f58);
function $5125b149f9efa8cc$export$735cfea22ce30f58(_visitors) {
    return true;
}

});


parcelRegister("kmhpG", function(module, exports) {
$parcel$export(module.exports, "filter", () => $5a512604578f66b4$export$3dea766d36a8935f);

var $e0DQG = parcelRequire("e0DQG");
function $5a512604578f66b4$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $e0DQG.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});

parcelRegister("228Wb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fhQjP").then(()=>parcelRequire('aZsfy'));

});

parcelRegister("cC0eP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bagF5").then(()=>parcelRequire('ku4jW'));

});

parcelRegister("61O2d", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("le5qB").then(()=>parcelRequire('EaVfB'));

});


parcelRegister("njNXW", function(module, exports) {
$parcel$export(module.exports, "doc", () => $bf97829f0a5633bf$export$2a111da947c407d2);
const $bf97829f0a5633bf$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });

});

parcelRegister("e4PCO", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $93a90cd4e0d75d8d$export$9c206ddddb32a9b);

var $3NAL1 = parcelRequire("3NAL1");
const $93a90cd4e0d75d8d$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $3NAL1.createTextNodes)(content)
    });

});
parcelRegister("3NAL1", function(module, exports) {
$parcel$export(module.exports, "createTextNodes", () => $76b61554cf37a1b4$export$3a269a5941b62f04);

var $cB2OB = parcelRequire("cB2OB");
function $76b61554cf37a1b4$export$3a269a5941b62f04(nodes) {
    return nodes.map((0, $cB2OB.createTextFromString));
}

});
parcelRegister("cB2OB", function(module, exports) {
$parcel$export(module.exports, "createTextFromString", () => $5d4089b8cd64a664$export$72b9432ea0656b50);

var $5t9u0 = parcelRequire("5t9u0");
function $5d4089b8cd64a664$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $5t9u0.text)(str) : str;
}

});
parcelRegister("5t9u0", function(module, exports) {
$parcel$export(module.exports, "text", () => $090e6622f595f2b7$export$6f093cfa640b7166);
const $090e6622f595f2b7$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});





parcelRegister("4EUgt", function(module, exports) {
$parcel$export(module.exports, "getAllFields", () => $cebe9f70576d4702$export$d90c0acb4bf7532e);
$parcel$export(module.exports, "getFields", () => $cebe9f70576d4702$export$d5523731e7fe4ded);
$parcel$export(module.exports, "getAllFieldArray", () => $cebe9f70576d4702$export$367adca86e2ec47c);
$parcel$export(module.exports, "getAllVisibleFields", () => $cebe9f70576d4702$export$bde76c894b9b669b);
$parcel$export(module.exports, "getGlobalFieldsInUseArray", () => $cebe9f70576d4702$export$9fe2ffdc49a260cd);
$parcel$export(module.exports, "getNonGlobalFieldsInUseArray", () => $cebe9f70576d4702$export$e81f9b8acf88cdda);
$parcel$export(module.exports, "getFieldCount", () => $cebe9f70576d4702$export$23da09631eea700d);
$parcel$export(module.exports, "getGlobalFieldCount", () => $cebe9f70576d4702$export$a314f7fd2cfbe1e3);
$parcel$export(module.exports, "getIssueTypeField", () => $cebe9f70576d4702$export$2fbb07b5166c6040);
$parcel$export(module.exports, "getAtlasFieldsEnabled", () => $cebe9f70576d4702$export$ed944ac7cf49a521);
$parcel$export(module.exports, "getNewlyAddedGlobalFields", () => $cebe9f70576d4702$export$87e7305c7ba63c24);
$parcel$export(module.exports, "getArchivedFieldsConfig", () => $cebe9f70576d4702$export$292fa83c763b98e3);
$parcel$export(module.exports, "getIsArchivingEnabled", () => $cebe9f70576d4702$export$b3fd159b04ba8fc1);
$parcel$export(module.exports, "getFieldLabels", () => $cebe9f70576d4702$export$ad84c8179191fc90);
$parcel$export(module.exports, "getNewFieldTypes", () => $cebe9f70576d4702$export$5b5c91d414e3b813);
$parcel$export(module.exports, "getFieldArray", () => $cebe9f70576d4702$export$26b8f64e04953389);
$parcel$export(module.exports, "getAllStringFields", () => $cebe9f70576d4702$export$30d3db0fb1ab5766);
$parcel$export(module.exports, "getFieldTypeByKey", () => $cebe9f70576d4702$export$2679d3d547e81f);
$parcel$export(module.exports, "getFieldsForPinning", () => $cebe9f70576d4702$export$dc97c1fe18b97578);
$parcel$export(module.exports, "getFieldsByClauseName", () => $cebe9f70576d4702$export$d02c0b7524287d75);

var $a7e1f = parcelRequire("a7e1f");

var $dSJEI = parcelRequire("dSJEI");

var $dAmGh = parcelRequire("dAmGh");

var $5GrX3 = parcelRequire("5GrX3");

var $cYFQJ = parcelRequire("cYFQJ");

var $i860n = parcelRequire("i860n");
const $cebe9f70576d4702$export$d90c0acb4bf7532e = (0, $a7e1f.createSelector)((state)=>state.fields, (state)=>state.containerProps?.isAtlasIntegrationEnabled, (state)=>state.containerProps?.isCollectionView, (state)=>state.containerProps?.isSharedView, (state)=>state.containerProps?.isAnonymousUser, (fields, isAtlasIntegrationEnabled, isCollectionView, isSharedView)=>{
    const shouldShowAtlasFields = !!isAtlasIntegrationEnabled || !!isCollectionView || !!isSharedView && (0, $i860n.fg)('jpd_support_atlas_fields_publish_views');
    return shouldShowAtlasFields ? fields : Object.keys(fields).map((key)=>fields[key]).filter((field)=>{
        return !(0, $5GrX3.FIELD_TYPES_CATEGORIES).ATLAS.some((type)=>type === field.type);
    }).reduce((result, field)=>Object.assign(result, {
            [field.key]: field
        }), {});
});
const $cebe9f70576d4702$export$d5523731e7fe4ded = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$d90c0acb4bf7532e, (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($dAmGh)))(fields, (field)=>{
        // Exclude archived fields
        if ((0, $5GrX3.FIELD_TYPES_CATEGORIES).ARCHIVED.some((type)=>type === field.type)) return false;
        // Exclude atlas project fields based on feature flag
        if ((0, $i860n.fg)('jpd_support_native_atlas_project_field')) {
            // When native field is enabled, exclude PLATFORM_PROJECT and ATLAS_PROJECT
            if (field.type === (0, $5GrX3.FIELD_TYPES).PLATFORM_PROJECT || field.type === (0, $5GrX3.FIELD_TYPES).ATLAS_PROJECT) return false;
        } else if (field.type === (0, $5GrX3.FIELD_TYPES).PLATFORM_ATLAS_PROJECT) // When native field is disabled, exclude PLATFORM_ATLAS_PROJECT
        return false;
        return true;
    }));
const $cebe9f70576d4702$export$367adca86e2ec47c = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$d90c0acb4bf7532e, (fields)=>Object.values(fields));
const $cebe9f70576d4702$export$bde76c894b9b669b = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$d90c0acb4bf7532e, (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($dAmGh)))(fields, (field)=>{
        const isHidden = field.configuration?.hidden;
        const isRestricted = field.hasRestrictedContext;
        return !isHidden && !isRestricted;
    }));
const $cebe9f70576d4702$export$9fe2ffdc49a260cd = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$367adca86e2ec47c, (fields)=>fields.filter((field)=>field.global && !field.hasRestrictedContext));
const $cebe9f70576d4702$export$e81f9b8acf88cdda = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$367adca86e2ec47c, (fields)=>fields.filter((field)=>!field.global && !field.hasRestrictedContext));
const $cebe9f70576d4702$export$23da09631eea700d = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$367adca86e2ec47c, (fields)=>fields.length);
const $cebe9f70576d4702$export$a314f7fd2cfbe1e3 = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$367adca86e2ec47c, (fields)=>fields.filter((f)=>f.global && f.custom).length);
const $cebe9f70576d4702$export$f3602eb1483982a3 = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$367adca86e2ec47c, (fields)=>fields.find((f)=>f.type === (0, $5GrX3.FIELD_TYPES).ARCHIVED && f.global));
const $cebe9f70576d4702$export$fed7b2b824265a77 = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$367adca86e2ec47c, (fields)=>fields.find((f)=>f.type === (0, $5GrX3.FIELD_TYPES).ARCHIVED_BY && f.global));
const $cebe9f70576d4702$export$37636b4ecbc35eae = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$367adca86e2ec47c, (fields)=>fields.find((f)=>f.type === (0, $5GrX3.FIELD_TYPES).ARCHIVED_ON && f.global));
const $cebe9f70576d4702$export$2fbb07b5166c6040 = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$367adca86e2ec47c, (fields)=>fields.find((field)=>field.type === (0, $5GrX3.FIELD_TYPES).ISSUE_TYPE));
const $cebe9f70576d4702$export$ed944ac7cf49a521 = (0, $a7e1f.createSelector)((state)=>state.fields, (fields)=>Object.keys(fields).map((key)=>fields[key]).find((field)=>field.type === (0, $5GrX3.FIELD_TYPES).ATLAS_PROJECT || field.type === (0, $5GrX3.FIELD_TYPES).ATLAS_GOAL) !== undefined);
const $cebe9f70576d4702$export$87e7305c7ba63c24 = (state)=>state.newlyAddedGlobalFields;
const $cebe9f70576d4702$export$292fa83c763b98e3 = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$f3602eb1483982a3, $cebe9f70576d4702$export$fed7b2b824265a77, $cebe9f70576d4702$export$37636b4ecbc35eae, (archivedField, archivedByField, archivedOnField)=>({
        archivedField: archivedField,
        archivedByField: archivedByField,
        archivedOnField: archivedOnField
    }));
const $cebe9f70576d4702$export$b3fd159b04ba8fc1 = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$f3602eb1483982a3, $cebe9f70576d4702$export$fed7b2b824265a77, $cebe9f70576d4702$export$37636b4ecbc35eae, (archivedField, archivedByField, archivedOnField)=>archivedField !== undefined && archivedByField !== undefined && archivedOnField !== undefined);
const $cebe9f70576d4702$export$ad84c8179191fc90 = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$d5523731e7fe4ded, (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($dSJEI)))(fields, (field)=>field.label));
const $cebe9f70576d4702$export$5b5c91d414e3b813 = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$d5523731e7fe4ded, (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($dSJEI)))(fields, (field)=>field.type));
const $cebe9f70576d4702$export$26b8f64e04953389 = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$d5523731e7fe4ded, (fields)=>Object.values(fields));
const $cebe9f70576d4702$export$30d3db0fb1ab5766 = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$367adca86e2ec47c, (fields)=>fields.filter((field)=>field.type === (0, $5GrX3.FIELD_TYPES).SHORT_TEXT));
const $cebe9f70576d4702$export$2679d3d547e81f = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$367adca86e2ec47c, (fields)=>{
    const map = new Map();
    for (const field of fields)if (field.type !== undefined) map.set(field.key, field.type);
    return map;
});
const $cebe9f70576d4702$export$dc97c1fe18b97578 = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$26b8f64e04953389, (fields)=>fields.filter(({ type: type, stableId: stableId })=>!(0, $cYFQJ.getUnsupportedFieldsForPinning)().some((t)=>t === type) && !(0, $5GrX3.UNSUPPORTED_STABLE_IDS_FOR_PINNING).some((id)=>stableId === id)).sort((a, b)=>a.label.localeCompare(b.label)));
const $cebe9f70576d4702$export$d02c0b7524287d75 = (0, $a7e1f.createSelector)($cebe9f70576d4702$export$367adca86e2ec47c, (fields)=>{
    const map = new Map();
    for (const field of fields)for (const clauseName of field.clauseNames ?? [])map.set(clauseName.toLowerCase(), field);
    return map;
});

});
parcelRegister("cYFQJ", function(module, exports) {
$parcel$export(module.exports, "getUnsupportedFieldsForPinning", () => $6d37a617fd4d9c91$export$4fa4268d8526a997);

var $5GrX3 = parcelRequire("5GrX3");
const $6d37a617fd4d9c91$export$4fa4268d8526a997 = ()=>[
        ...(0, $5GrX3.FIELD_TYPES_CATEGORIES).ARCHIVED,
        (0, $5GrX3.FIELD_TYPES).DESCRIPTION,
        (0, $5GrX3.FIELD_TYPES).ISSUE_ID,
        (0, $5GrX3.FIELD_TYPES).ISSUE_TYPE,
        (0, $5GrX3.FIELD_TYPES).CONNECTION,
        (0, $5GrX3.FIELD_TYPES).ISSUE_COMMENTS,
        (0, $5GrX3.FIELD_TYPES).ISSUE_KEY,
        (0, $5GrX3.FIELD_TYPES).SUMMARY,
        (0, $5GrX3.FIELD_TYPES).PROJECT
    ];

});




parcelRegister("6PNhy", function(module, exports) {
$parcel$export(module.exports, "updateDeliveryDateSelectedField", () => $ba19f45d5f8e7f54$export$424642c0e1b678c3);

var $aJ81Y = parcelRequire("aJ81Y");

var $2cQDy = parcelRequire("2cQDy");
const $ba19f45d5f8e7f54$export$424642c0e1b678c3 = (fieldKey, selectedFieldKey, contextAnalyticsEvent)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote })=>{
        const state = getState();
        // oxlint-disable-next-line typescript/no-non-null-assertion
        const currentField = (0, $2cQDy.createGetFieldByKey)(fieldKey)(state);
        const oldConfiguration = currentField.configuration ? currentField.configuration : {};
        const newConfiguration = {
            ...currentField.configuration
        };
        if (selectedFieldKey) newConfiguration.customfieldKey = selectedFieldKey;
        else delete newConfiguration.customfieldKey;
        const fields = {
            ...getState().fields
        };
        fields[fieldKey] = {
            ...fields[fieldKey],
            configuration: newConfiguration
        };
        setState({
            fields: fields
        });
        await fieldRemote.updateFieldConfiguration({
            fieldKey: fieldKey,
            oldConfiguration: oldConfiguration,
            configuration: newConfiguration,
            type: 'updateDeliveryDateSelectedField'
        });
        (0, $aJ81Y.fireTrackAnalytics)(contextAnalyticsEvent, 'issueFields updated', {
            issueFieldKey: fieldKey,
            issueFieldType: currentField.type,
            updatedItems: [
                {
                    name: 'customfieldKey'
                }
            ]
        });
    };

});

parcelRegister("16sP7", function(module, exports) {
$parcel$export(module.exports, "updateIntervalFieldSource", () => $af434f931a0325a1$export$9915f5b3600d481);

var $aJ81Y = parcelRequire("aJ81Y");

var $2cQDy = parcelRequire("2cQDy");
const $af434f931a0325a1$export$9915f5b3600d481 = (fieldKey, source, contextAnalyticsEvent)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote })=>{
        const state = getState();
        // oxlint-disable-next-line typescript/no-non-null-assertion
        const currentField = (0, $2cQDy.createGetFieldByKey)(fieldKey)(state);
        const oldConfiguration = currentField.configuration ? currentField.configuration : {};
        const newConfiguration = {
            ...currentField.configuration
        };
        if (source) newConfiguration.source = source;
        else {
            delete newConfiguration.source;
            delete newConfiguration.aggregationType;
            delete newConfiguration.customfieldKey;
        }
        const fields = {
            ...getState().fields
        };
        fields[fieldKey] = {
            ...fields[fieldKey],
            configuration: newConfiguration
        };
        setState({
            fields: fields
        });
        await fieldRemote.updateFieldConfiguration({
            fieldKey: fieldKey,
            oldConfiguration: oldConfiguration,
            configuration: newConfiguration,
            type: 'updateIntervalFieldSource'
        });
        (0, $aJ81Y.fireTrackAnalytics)(contextAnalyticsEvent, 'issueFields updated', {
            issueFieldKey: fieldKey,
            issueFieldType: currentField.type,
            updatedItems: source ? [
                {
                    name: 'source'
                }
            ] : [
                {
                    name: 'source'
                },
                {
                    name: 'aggregationType'
                },
                {
                    name: 'customfieldKey'
                }
            ]
        });
    };

});

parcelRegister("fWjSq", function(module, exports) {
$parcel$export(module.exports, "loadGlobalFieldsAssociations", () => $12cfb055600e7632$export$8214750359741669);

var $63gbl = parcelRequire("63gbl");
const $12cfb055600e7632$export$8214750359741669 = (fieldKeys)=>async ({ getState: getState, setState: setState }, { globalFieldRemote: globalFieldRemote })=>{
        const { meta: { connectionsLoadingFieldsAssociations: connectionsLoadingFieldsAssociations }, connectionsFieldsAssociations: connectionsFieldsAssociations } = getState();
        const fieldKeysToSend = fieldKeys.filter((fieldKey)=>!connectionsFieldsAssociations[fieldKey] && !connectionsLoadingFieldsAssociations.includes(fieldKey));
        if (!fieldKeysToSend.length) return;
        setState({
            meta: {
                ...getState().meta,
                connectionsLoadingFieldsAssociations: [
                    ...getState().meta.connectionsLoadingFieldsAssociations,
                    ...fieldKeysToSend
                ]
            }
        });
        try {
            const result = await globalFieldRemote.getProjectsForFields({
                fieldKeys: fieldKeysToSend
            });
            const remappedFields = Object.entries(result).reduce((acc, [fieldKey, projects])=>{
                const issueIdsFromProjects = projects.reduce((accInner, project)=>{
                    if (project.issueTypes) return accInner.concat(project.issueTypes.map(({ id: id })=>String(id)));
                    return accInner;
                }, []);
                acc[fieldKey] = issueIdsFromProjects;
                return acc;
            }, {});
            setState({
                meta: {
                    ...getState().meta,
                    connectionsLoadingFieldsAssociations: getState().meta.connectionsLoadingFieldsAssociations.filter((key)=>fieldKeysToSend.includes(key))
                },
                connectionsFieldsAssociations: {
                    ...getState().connectionsFieldsAssociations,
                    ...remappedFields
                }
            });
        } catch (error) {
            (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.fields.connections.loadGlobalFieldsAssociations', 'Failed to load global fields associations for connection highlighted fields', error instanceof Error ? error : new Error('Error while loading global fields associations for connection highlighted fields'));
            setState({
                meta: {
                    ...getState().meta,
                    connectionsLoadingFieldsAssociations: getState().meta.connectionsLoadingFieldsAssociations.filter((key)=>fieldKeysToSend.includes(key))
                }
            });
        }
    };

});

parcelRegister("k4Iq8", function(module, exports) {
$parcel$export(module.exports, "loadGlobalLabels", () => $c38038f2172f1416$export$c6682f53b5f48ef8);

var $5GrX3 = parcelRequire("5GrX3");
const $c38038f2172f1416$export$c6682f53b5f48ef8 = (fieldKey)=>async ({ getState: getState, setState: setState }, { globalFieldRemote: globalFieldRemote })=>{
        const labelField = getState().fields[fieldKey];
        if (labelField.type !== (0, $5GrX3.FIELD_TYPES).CUSTOM_LABELS || !labelField?.global) return;
        if (labelField.options !== undefined) // global labels are already loaded
        return;
        try {
            const globalLabels = await globalFieldRemote.getGlobalLabels({
                fieldKey: fieldKey
            });
            const fields = getState().fields;
            setState({
                fields: {
                    ...fields,
                    [labelField.key]: {
                        ...fields[labelField.key],
                        options: globalLabels.map((label)=>({
                                id: label,
                                jiraOptionId: label,
                                value: label,
                                weight: 1
                            })),
                        meta: {
                            ...fields[labelField.key]?.meta,
                            globalLabels: {
                                error: false
                            }
                        }
                    }
                }
            });
        } catch (err) {
            const fields = getState().fields;
            setState({
                fields: {
                    ...fields,
                    [labelField.key]: {
                        ...fields[labelField.key],
                        options: [],
                        meta: {
                            ...fields[labelField.key]?.meta,
                            globalLabels: {
                                error: true
                            }
                        }
                    }
                }
            });
            throw err;
        }
    };

});

parcelRegister("9RWf4", function(module, exports) {
$parcel$export(module.exports, "addOption", () => $e5a029b88089f658$export$97a332cdbb9101b1);

var $j85oP = parcelRequire("j85oP");

var $7imRA = parcelRequire("7imRA");

var $i7bkV = parcelRequire("i7bkV");

var $fV62N = parcelRequire("fV62N");

var $7TWAO = parcelRequire("7TWAO");

var $75sVW = parcelRequire("75sVW");

var $9Xbcf = parcelRequire("9Xbcf");

var $l668O = parcelRequire("l668O");
const $e5a029b88089f658$var$fieldOptionUpdateExperience = (0, $7imRA.createExperienceWithMetaType)((0, $j85oP.experience).fieldsSidebar.fieldOptionUpdate, 'addOption', (err)=>`FieldOptionUpdate: ${err?.message ?? 'generic error'}`);
const $e5a029b88089f658$export$97a332cdbb9101b1 = (fieldKey, newOption)=>({ getState: getState, setState: setState, dispatch: dispatch }, { onFieldUpdateFailed: onFieldUpdateFailed, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, fieldRemote: fieldRemote })=>{
        if (projectId === undefined) return Promise.resolve(undefined);
        $e5a029b88089f658$var$fieldOptionUpdateExperience.start();
        return fieldRemote.addFieldOption({
            fieldKey: fieldKey,
            newOption: newOption
        }).then((jiraOptionId)=>{
            dispatch((0, $l668O.loadFields)());
            const state = getState();
            const newOptions = [
                ...state?.fields?.[fieldKey]?.options || [],
                {
                    id: String(jiraOptionId),
                    jiraOptionId: String(jiraOptionId),
                    value: newOption,
                    weight: (0, $9Xbcf.DEFAULT_OPTION_WEIGHT)
                }
            ];
            const fields = {
                ...state?.fields ?? {},
                [fieldKey]: {
                    ...state?.fields?.[fieldKey],
                    options: newOptions
                }
            };
            setState({
                fields: fields
            });
            $e5a029b88089f658$var$fieldOptionUpdateExperience.success();
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.optionCreatedSuccess(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: fields[fieldKey].type,
                fieldValueId: jiraOptionId
            });
            return jiraOptionId;
        }).catch((err)=>{
            let ufoExperienceResolved = false;
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.optionCreatedFailure(createAnalyticsEvent({}));
            let error = err;
            if (err instanceof (0, $75sVW.default)) {
                const { message: message, statusCode: statusCode } = err;
                if (statusCode === 409) {
                    error = new (0, $fV62N.EntityLimitError)(message, [
                        {
                            error: message
                        }
                    ], statusCode, (0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).OPTIONS_PER_FIELD);
                    $e5a029b88089f658$var$fieldOptionUpdateExperience.abort(err);
                    ufoExperienceResolved = true;
                }
            }
            if (!ufoExperienceResolved) {
                $e5a029b88089f658$var$fieldOptionUpdateExperience.failure(err);
                ufoExperienceResolved = true;
            }
            onFieldUpdateFailed(error);
            return undefined;
        });
    };

});
parcelRegister("9Xbcf", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_OPTION_WEIGHT", () => $334c3da9653d5e5c$export$841473baf38a5476);
$parcel$export(module.exports, "NEW_FIELD_CREATED_IN_PROJECT", () => $334c3da9653d5e5c$export$848668fbc6030873);
$parcel$export(module.exports, "SINGLE_GLOBAL_FIELD_ADDED_TO_PROJECT", () => $334c3da9653d5e5c$export$55e125740ca2713e);
$parcel$export(module.exports, "MANY_GLOBAL_FIELDS_ADDED_TO_PROJECT", () => $334c3da9653d5e5c$export$148f6fa401beb4ae);
const $334c3da9653d5e5c$export$841473baf38a5476 = 1;
const $334c3da9653d5e5c$export$848668fbc6030873 = Symbol('NEW_FIELD_CREATED_IN_PROJECT');
const $334c3da9653d5e5c$export$55e125740ca2713e = Symbol('SINGLE_GLOBAL_FIELD_ADDED_TO_PROJECT');
const $334c3da9653d5e5c$export$148f6fa401beb4ae = Symbol('MANY_GLOBAL_FIELDS_ADDED_TO_PROJECT');

});


parcelRegister("eZODn", function(module, exports) {
$parcel$export(module.exports, "deleteOption", () => $0dc179c0709b0de9$export$1717f994e126a0c5);

var $j85oP = parcelRequire("j85oP");

var $7imRA = parcelRequire("7imRA");

var $i7bkV = parcelRequire("i7bkV");

var $gjvtV = parcelRequire("gjvtV");

var $is1er = parcelRequire("is1er");
const $0dc179c0709b0de9$var$fieldOptionUpdateExperience = (0, $7imRA.createExperienceWithMetaType)((0, $j85oP.experience).fieldsSidebar.fieldOptionUpdate, 'deleteOption', (err)=>`FieldOptionUpdate: ${err?.message ?? 'generic error'}`);
const $0dc179c0709b0de9$export$1717f994e126a0c5 = (fieldKey, jiraOptionId)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, fieldRemote: fieldRemote })=>{
        const state = getState();
        const field = state.fields[fieldKey];
        const previousOptions = field.options;
        const { valueDecorations: valueDecorations, ...previousConfig } = field?.configuration ?? {};
        const previousOptionWeights = previousConfig.optionWeights ?? [];
        const newOptions = previousOptions?.filter(({ jiraOptionId: optionId })=>optionId !== jiraOptionId);
        if (newOptions === undefined || newOptions.length === 0) // do nothing, the last option cannot be deleted
        return;
        const previousValueDecorations = state.fieldValueDecorations[fieldKey] || [];
        const appliedDecoration = (0, $gjvtV.getAppliedDecoration)(previousValueDecorations, jiraOptionId);
        const newValueDecorations = [
            ...previousValueDecorations.filter((decoration)=>decoration.localDecorationId !== appliedDecoration?.localDecorationId)
        ];
        const jiraOptionIdNumber = parseInt(jiraOptionId, 10);
        const newOptionWeights = previousOptionWeights.filter(({ optionId: optionId })=>optionId !== jiraOptionIdNumber);
        const newConfig = {
            ...previousConfig,
            optionWeights: newOptionWeights
        };
        setState({
            fields: {
                ...state.fields,
                [fieldKey]: {
                    ...field,
                    options: newOptions,
                    configuration: newConfig
                }
            },
            fieldValueDecorations: {
                ...state.fieldValueDecorations,
                [fieldKey]: newValueDecorations
            }
        });
        if (projectId !== undefined) try {
            $0dc179c0709b0de9$var$fieldOptionUpdateExperience.start();
            await fieldRemote.deleteFieldOption({
                fieldKey: fieldKey,
                optionId: jiraOptionIdNumber
            });
            $0dc179c0709b0de9$var$fieldOptionUpdateExperience.success();
            fieldRemote.updateFieldConfiguration({
                fieldKey: fieldKey,
                oldConfiguration: {
                    ...previousOptionWeights.length > 0 ? {
                        optionWeights: previousOptionWeights
                    } : {},
                    ...(0, $is1er.remapValueDecorations)(previousValueDecorations)
                },
                configuration: {
                    ...newOptionWeights.length > 0 ? {
                        optionWeights: newOptionWeights
                    } : {},
                    ...(0, $is1er.remapValueDecorations)(newValueDecorations)
                },
                type: 'deleteOptionRelatedFieldConfiguration'
            }).then(()=>{
                (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.optionWeightChanged(createAnalyticsEvent({}), {
                    issueFieldKey: fieldKey,
                    issueFieldType: field.type,
                    fieldValueId: jiraOptionId
                });
                (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.valueDecorationChanged(createAnalyticsEvent({}), {
                    issueFieldKey: fieldKey,
                    issueFieldType: field.type
                });
            }).catch(onFieldUpdateFailed);
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.optionDeletedSuccess(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: field.type,
                fieldValueId: jiraOptionId
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.optionDeletedFailure(createAnalyticsEvent({}));
            $0dc179c0709b0de9$var$fieldOptionUpdateExperience.failure(err);
            onFieldUpdateFailed(err);
        }
    };

});
parcelRegister("gjvtV", function(module, exports) {
$parcel$export(module.exports, "getAppliedDecoration", () => $e89df6160d654e50$export$f09d56952b1fe9bc);
$parcel$export(module.exports, "getAppliedDecorations", () => $e89df6160d654e50$export$370901a43154af);
$parcel$export(module.exports, "getAppliedNumberDecoration", () => $e89df6160d654e50$export$de8f59b5038e4e6f);
$parcel$export(module.exports, "getAppliedDateDecoration", () => $e89df6160d654e50$export$de751034a645f2e);
$parcel$export(module.exports, "getAppliedIntervalDecoration", () => $e89df6160d654e50$export$8aa279f68ac07db4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fZkaH = parcelRequire("fZkaH");
var $2Q8LI = parcelRequire("2Q8LI");

var $emCaV = parcelRequire("emCaV");

var $DibyB = parcelRequire("DibyB");

var $g22fB = parcelRequire("g22fB");

var $5cPoD = parcelRequire("5cPoD");
const $e89df6160d654e50$export$f09d56952b1fe9bc = (0, $emCaV.default)((decorations, value)=>{
    if (decorations !== undefined && value !== undefined) return decorations.find((decoration)=>(0, $DibyB.applyOptionLogic)(decoration.logic, value));
    return undefined;
});
const $e89df6160d654e50$export$370901a43154af = (0, $emCaV.default)((decorations, values)=>{
    const decorationMap = {};
    for (const value of values)decorationMap[value] = $e89df6160d654e50$export$f09d56952b1fe9bc(decorations, value);
    return decorationMap;
});
const $e89df6160d654e50$export$de8f59b5038e4e6f = (decorations, value)=>{
    if (decorations !== undefined && value !== undefined) return decorations.find((decoration)=>(0, $5cPoD.applyNumberLogic)(decoration.logic, value));
    return undefined;
};
const $e89df6160d654e50$export$de751034a645f2e = (0, $emCaV.default)((decorations, value)=>{
    if (decorations !== undefined && value !== undefined) {
        const given = (0, $2Q8LI.default)(new Date(value));
        const current = (0, $2Q8LI.default)(new Date());
        const diffDays = (0, $fZkaH.default)(given, current);
        return decorations.find((decoration)=>(0, $g22fB.applyDateTimeLogic)(decoration.logic, diffDays));
    }
    return undefined;
});
const $e89df6160d654e50$export$8aa279f68ac07db4 = (0, $emCaV.default)((decorations, value)=>{
    if (decorations !== undefined && value !== undefined) {
        const startDate = (0, $2Q8LI.default)(new Date(value?.start));
        const endDate = (0, $2Q8LI.default)(new Date(value?.end));
        const current = (0, $2Q8LI.default)(new Date());
        const diffDaysBeforeStart = (0, $fZkaH.default)(startDate, current);
        const diffDaysBeforeEnd = (0, $fZkaH.default)(endDate, current);
        return decorations.find((decoration)=>(0, $g22fB.applyDateTimeIntervalLogic)({
                logic: decoration.logic,
                diffDaysBeforeStart: diffDaysBeforeStart,
                diffDaysBeforeEnd: diffDaysBeforeEnd
            }));
    }
    return undefined;
});

});
parcelRegister("DibyB", function(module, exports) {
$parcel$export(module.exports, "applyOptionLogic", () => $c15775f454a9a31d$export$85febbc27cec9e66);
$parcel$export(module.exports, "getOptionLogicValue", () => $c15775f454a9a31d$export$129617db118f502f);

var $2f8fl = parcelRequire("2f8fl");

var $9FcZG = parcelRequire("9FcZG");
const $c15775f454a9a31d$var$LABEL_LOGIC_PATTERN = {
    [(0, $2f8fl.JsonLogicOperator).EQ]: [
        '@',
        {
            var: 'label'
        }
    ]
};
const $c15775f454a9a31d$var$isLabelLogic = (logic)=>{
    return (0, $9FcZG.default).rule_like(logic, $c15775f454a9a31d$var$LABEL_LOGIC_PATTERN);
};
const $c15775f454a9a31d$export$85febbc27cec9e66 = (logic, value)=>{
    const logicVarName = $c15775f454a9a31d$var$isLabelLogic(logic) ? 'label' : 'id';
    return (0, $9FcZG.default).apply(logic, {
        [logicVarName]: value
    });
};
const $c15775f454a9a31d$export$129617db118f502f = (logic)=>{
    const [value] = (0, $9FcZG.default).get_values(logic);
    return value;
};

});
parcelRegister("2f8fl", function(module, exports) {
$parcel$export(module.exports, "JsonLogicOperator", () => $8fc27bcba4b38389$export$861a3fa6bc9fa962);
/* eslint-disable jira/filename-case */ const $8fc27bcba4b38389$var$LOGICEQ = '==';
const $8fc27bcba4b38389$var$LOGICGT = '>';
const $8fc27bcba4b38389$var$LOGICLT = '<';
const $8fc27bcba4b38389$var$LOGICGTE = '>=';
const $8fc27bcba4b38389$var$LOGICLTE = '<=';
const $8fc27bcba4b38389$export$861a3fa6bc9fa962 = {
    EQ: $8fc27bcba4b38389$var$LOGICEQ,
    GT: $8fc27bcba4b38389$var$LOGICGT,
    LT: $8fc27bcba4b38389$var$LOGICLT,
    GTE: $8fc27bcba4b38389$var$LOGICGTE,
    LTE: $8fc27bcba4b38389$var$LOGICLTE
};

});

parcelRegister("9FcZG", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca613f0bb2461ac4$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, camelcase, jira/naming/disallow-filenames */ /* oxlint-disable eqeqeq */ /* oxlint-disable no-else-return */ /* oxlint-disable no-prototype-builtins */ /* oxlint-disable prefer-template */ /* oxlint-disable prefer-spread */ /* oxlint-disable prefer-rest-params */ /* oxlint-disable prefer-arrow-callback */ /* oxlint-disable object-shorthand */ /* oxlint-disable no-var, typescript/no-this-alias, no-console */ /* oxlint-disable @typescript-eslint/no-explicit-any */ /* oxlint-enable @typescript-eslint/no-explicit-any */ /* oxlint-disable @typescript-eslint/no-explicit-any -- iso-decl artefact */ /* oxlint-disable @typescript-eslint/no-explicit-any, typescript/consistent-type-assertions */ const $ca613f0bb2461ac4$var$default1 = (()=>{
    /**
	 * Return an array that contains no duplicates (original not modified)
	 * @param  {array} array   Original reference array
	 * @returns {array}         New array with no duplicates
	 */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    function arrayUnique(array) {
        const a = [];
        for(let i = 0, l = array.length; i < l; i++)if (a.indexOf(array[i]) === -1) a.push(array[i]);
        return a;
    }
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const operations = {
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        '==': function(a, b) {
            return a == b;
        },
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        '===': function(a, b) {
            return a === b;
        },
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        '!=': function(a, b) {
            return a != b;
        },
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        '!==': function(a, b) {
            return a !== b;
        },
        '>': function(a, b) {
            return a > b;
        },
        '>=': function(a, b) {
            return a >= b;
        },
        '<': function(a, b, c) {
            return c === undefined ? a < b : a < b && b < c;
        },
        '<=': function(a, b, c) {
            return c === undefined ? a <= b : a <= b && b <= c;
        },
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        '!!': function(a) {
            return truthy(a);
        },
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        '!': function(a) {
            return !truthy(a);
        },
        '%': function(a, b) {
            return a % b;
        },
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        log: function log(a) {
            console.log(a);
            return a;
        },
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        in: function(a, b) {
            if (!b || typeof b.indexOf === 'undefined') return false;
            return b.indexOf(a) !== -1;
        },
        cat: function cat() {
            return Array.prototype.join.call(arguments, '');
        },
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        substr: function substr(source, start, end) {
            if (end < 0) {
                // JavaScript doesn't support negative end, this emulates PHP behavior
                const temp = String(source).substr(start);
                return temp.substr(0, temp.length + end);
            }
            return String(source).substr(start, end);
        },
        '+': function() {
            return Array.prototype.reduce.call(arguments, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            function(a, b) {
                return parseFloat(a) + parseFloat(b);
            }, 0);
        },
        '*': function() {
            // oxlint-disable-next-line typescript/ban-ts-comment
            // @ts-ignore
            return Array.prototype.reduce.call(arguments, function(a, b) {
                return parseFloat(a) * parseFloat(b);
            });
        },
        '-': function(a, b) {
            if (b === undefined) return -a;
            else return a - b;
        },
        '/': function(a, b) {
            return a / b;
        },
        min: function min() {
            // oxlint-disable-next-line typescript/ban-ts-comment
            // @ts-ignore
            return Math.min.apply(this, arguments);
        },
        max: function max() {
            // oxlint-disable-next-line typescript/ban-ts-comment
            // @ts-ignore
            return Math.max.apply(this, arguments);
        },
        merge: function merge() {
            return Array.prototype.reduce.call(arguments, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            function mergeFunction(a, b) {
                return a.concat(b);
            }, []);
        },
        var: function(a, b) {
            const not_found = b === undefined ? null : b;
            let data = this;
            if (typeof a === 'undefined' || a === '' || a === null) return data;
            const sub_props = String(a).split('.');
            for(let i = 0; i < sub_props.length; i++){
                if (data === null || data === undefined) return not_found;
                // Descending into data
                data = data[sub_props[i]];
                if (data === undefined) return not_found;
            }
            return data;
        },
        missing: function() {
            /*
              Missing can receive many keys as many arguments, like {"missing:[1,2]}
              Missing can also receive *one* argument that is an array of keys,
              which typically happens if it's actually acting on the output of another command
              (like 'if' or 'merge')
              */ const missing = [];
            const keys = Array.isArray(arguments[0]) ? arguments[0] : arguments;
            for(let i = 0; i < keys.length; i++){
                const key = keys[i];
                const value = apply({
                    var: key
                }, this);
                if (value === null || value === '') missing.push(key);
            }
            return missing;
        },
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        missing_some: function missing_some(need_count, options) {
            // missing_some takes two arguments, how many (minimum) items must be present, and an array of keys (just like 'missing') to check for presence.
            const are_missing = apply({
                missing: options
            }, this);
            if (options.length - are_missing.length >= need_count) return [];
            else return are_missing;
        }
    };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const is_logic = function is_logic(logic) {
        return typeof logic === 'object' && // An object
        logic !== null && // but not null
        !Array.isArray(logic) && // and not an array
        Object.keys(logic).length === 1 // with exactly one key
        ;
    };
    /*
    This helper will defer to the JsonLogic spec as a tie-breaker when different language interpreters define different behavior for the truthiness of primitives.  E.g., PHP considers empty arrays to be falsy, but Javascript considers them to be truthy. JsonLogic, as an ecosystem, needs one consistent answer.

    Spec and rationale here: http://jsonlogic.com/truthy
    */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const truthy = function truthy(value) {
        if (Array.isArray(value) && value.length === 0) return false;
        return !!value;
    };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const get_operator = function get_operator(logic) {
        return Object.keys(logic)[0];
    };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const get_values = function get_values(logic) {
        return logic[get_operator(logic)];
    };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const apply = function(logic, data) {
        // Does this array contain logic? Only one way to find out.
        if (Array.isArray(logic)) return logic.map(function(l) {
            return apply(l, data);
        });
        // You've recursed to a primitive, stop!
        if (!is_logic(logic)) return logic;
        const op = get_operator(logic);
        // oxlint-disable-next-line typescript/ban-ts-comment
        // @ts-ignore
        let values = logic[op];
        let i;
        let current;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        let scopedLogic;
        let scopedData;
        let initial;
        // easy syntax for unary operators, like {"var" : "x"} instead of strict {"var" : ["x"]}
        if (!Array.isArray(values)) values = [
            values
        ];
        // 'if', 'and', and 'or' violate the normal rule of depth-first calculating consequents, let each manage recursion as needed.
        if (op === 'if' || op == '?:') {
            /* 'if' should be called with a odd number of parameters, 3 or greater
              This works on the pattern:
              if( 0 ){ 1 }else{ 2 };
              if( 0 ){ 1 }else if( 2 ){ 3 }else{ 4 };
              if( 0 ){ 1 }else if( 2 ){ 3 }else if( 4 ){ 5 }else{ 6 };

              The implementation is:
              For pairs of values (0,1 then 2,3 then 4,5 etc)
              If the first evaluates truthy, evaluate and return the second
              If the first evaluates falsy, jump to the next pair (e.g, 0,1 to 2,3)
              given one parameter, evaluate and return it. (it's an Else and all the If/ElseIf were false)
              given 0 parameters, return NULL (not great practice, but there was no Else)
              */ for(i = 0; i < values.length - 1; i += 2){
                if (truthy(apply(values[i], data))) return apply(values[i + 1], data);
            }
            if (values.length === i + 1) return apply(values[i], data);
            return null;
        } else if (op === 'and') {
            // Return first falsy, or last
            for(i = 0; i < values.length; i += 1){
                current = apply(values[i], data);
                if (!truthy(current)) return current;
            }
            return current; // Last
        } else if (op === 'or') {
            // Return first truthy, or last
            for(i = 0; i < values.length; i += 1){
                current = apply(values[i], data);
                if (truthy(current)) return current;
            }
            return current; // Last
        } else if (op === 'filter') {
            scopedData = apply(values[0], data);
            scopedLogic = values[1];
            if (!Array.isArray(scopedData)) return [];
            // Return only the elements from the array in the first argument,
            // that return truthy when passed to the logic in the second argument.
            // For parity with JavaScript, reindex the returned array
            return scopedData.filter(function(datum) {
                return truthy(apply(scopedLogic, datum));
            });
        } else if (op === 'map') {
            scopedData = apply(values[0], data);
            scopedLogic = values[1];
            if (!Array.isArray(scopedData)) return [];
            return scopedData.map(function(datum) {
                return apply(scopedLogic, datum);
            });
        } else if (op === 'reduce') {
            scopedData = apply(values[0], data);
            scopedLogic = values[1];
            initial = typeof values[2] !== 'undefined' ? apply(values[2], data) : null;
            if (!Array.isArray(scopedData)) return initial;
            // oxlint-disable-next-line no-shadow
            return scopedData.reduce(function(accumulator, current) {
                return apply(scopedLogic, {
                    current: current,
                    accumulator: accumulator
                });
            }, initial);
        } else if (op === 'all') {
            scopedData = apply(values[0], data);
            scopedLogic = values[1];
            // All of an empty set is false. Note, some and none have correct fallback after the for loop
            if (!Array.isArray(scopedData) || !scopedData.length) return false;
            for(i = 0; i < scopedData.length; i += 1){
                if (!truthy(apply(scopedLogic, scopedData[i]))) return false; // First falsy, short circuit
            }
            return true; // All were truthy
        } else if (op === 'none') {
            scopedData = apply(values[0], data);
            scopedLogic = values[1];
            if (!Array.isArray(scopedData) || !scopedData.length) return true;
            for(i = 0; i < scopedData.length; i += 1){
                if (truthy(apply(scopedLogic, scopedData[i]))) return false; // First truthy, short circuit
            }
            return true; // None were truthy
        } else if (op === 'some') {
            scopedData = apply(values[0], data);
            scopedLogic = values[1];
            if (!Array.isArray(scopedData) || !scopedData.length) return false;
            for(i = 0; i < scopedData.length; i += 1){
                if (truthy(apply(scopedLogic, scopedData[i]))) return true; // First truthy, short circuit
            }
            return false; // None were truthy
        }
        // Everyone else gets immediate depth-first recursion
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        values = values.map(function valuesFunction(val) {
            return apply(val, data);
        });
        // The operation is called with "data" bound to its "this" and "values" passed as arguments.
        // Structured commands like % or > can name formal arguments while flexible commands (like missing or merge) can operate on the pseudo-array arguments
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/arguments
        if (operations.hasOwnProperty(op) && typeof operations[op] === 'function') return operations[op].apply(data, values);
        else if (op.indexOf('.') > 0) {
            // Contains a dot, and not in the 0th position
            const sub_ops = String(op).split('.');
            let operation = operations;
            for(i = 0; i < sub_ops.length; i++){
                if (!operation.hasOwnProperty(sub_ops[i])) throw new Error('Unrecognized operation ' + op + ' (failed at ' + sub_ops.slice(0, i + 1).join('.') + ')');
                // Descending into operations
                operation = operation[sub_ops[i]];
            }
            return operation.apply(data, values);
        }
        throw new Error('Unrecognized operation ' + op);
    };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const uses_data = function(logic) {
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        const collection = [];
        if (is_logic(logic)) {
            const op = get_operator(logic);
            let values = logic[op];
            if (!Array.isArray(values)) values = [
                values
            ];
            if (op === 'var') // This doesn't cover the case where the arg to var is itself a rule.
            collection.push(values[0]);
            else // Recursion!
            // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            values.forEach(function(val) {
                collection.push.apply(collection, uses_data(val));
            });
        }
        return arrayUnique(collection);
    };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const add_operation = function add_operation(name, code) {
        operations[name] = code;
    };
    const rm_operation = function rm_operation(name) {
        delete operations[name];
    };
    const rule_like = function(rule, pattern) {
        // console.log("Is ". JSON.stringify(rule) . " like " . JSON.stringify(pattern) . "?");
        if (pattern === rule) return true;
         // TODO : Deep object equivalency?
        if (pattern === '@') return true;
         // Wildcard!
        if (pattern === 'number') return typeof rule === 'number';
        if (pattern === 'string') return typeof rule === 'string';
        if (pattern === 'array') // !logic test might be superfluous in JavaScript
        return Array.isArray(rule) && !is_logic(rule);
        if (is_logic(pattern)) {
            if (is_logic(rule)) {
                const pattern_op = get_operator(pattern);
                const rule_op = get_operator(rule);
                if (pattern_op === '@' || pattern_op === rule_op) // echo "\nOperators match, go deeper\n";
                return rule_like(get_values(rule), get_values(pattern));
            }
            return false; // pattern is logic, rule isn't, can't be eq
        }
        if (Array.isArray(pattern)) {
            if (Array.isArray(rule)) {
                if (pattern.length !== rule.length) return false;
                /*
                  Note, array order MATTERS, because we're using this array test logic to consider arguments, where order can matter. (e.g., + is commutative, but '-' or 'if' or 'var' are NOT)
                */ for(let i = 0; i < pattern.length; i += 1){
                    // If any fail, we fail
                    if (!rule_like(rule[i], pattern[i])) return false;
                }
                return true; // If they *all* passed, we pass
            } else return false; // Pattern is array, rule isn't
        }
        // Not logic, not array, not a === match for rule.
        return false;
    };
    return {
        is_logic: is_logic,
        truthy: truthy,
        get_operator: get_operator,
        get_values: get_values,
        apply: apply,
        uses_data: uses_data,
        add_operation: add_operation,
        rm_operation: rm_operation,
        rule_like: rule_like
    };
})();
var /* oxlint-enable @typescript-eslint/no-explicit-any, typescript/consistent-type-assertions */ $ca613f0bb2461ac4$export$2e2bcd8739ae039 /* oxlint-enable @typescript-eslint/no-explicit-any -- iso-decl artefact */  = $ca613f0bb2461ac4$var$default1;

});


parcelRegister("g22fB", function(module, exports) {
$parcel$export(module.exports, "applyDateTimeLogic", () => $d3f46b0ecea8cec8$export$77232984bf4c4f4a);
$parcel$export(module.exports, "applyDateTimeIntervalLogic", () => $d3f46b0ecea8cec8$export$6eabdf0ec7333ea3);

var $9FcZG = parcelRequire("9FcZG");

var $7MYHs = parcelRequire("7MYHs");
const $d3f46b0ecea8cec8$export$77232984bf4c4f4a = (logic, daysUntilDueDate)=>{
    return (0, $9FcZG.default).apply(logic, {
        daysUntilDueDate: daysUntilDueDate
    });
};
const $d3f46b0ecea8cec8$export$6eabdf0ec7333ea3 = ({ logic: logic, diffDaysBeforeStart: diffDaysBeforeStart, diffDaysBeforeEnd: diffDaysBeforeEnd })=>{
    if ((0, $7MYHs.isDateOverdueOption)(logic)) return $d3f46b0ecea8cec8$export$77232984bf4c4f4a(logic, diffDaysBeforeEnd);
    const [gt, _, lt] = (0, $9FcZG.default).get_values(logic);
    return diffDaysBeforeEnd > gt && diffDaysBeforeStart < lt;
};

});
parcelRegister("7MYHs", function(module, exports) {
$parcel$export(module.exports, "isDateComingSoonOption", () => $60f00a6d9ef10fea$export$2f2cb858f35d536d);
$parcel$export(module.exports, "isDateOverdueOption", () => $60f00a6d9ef10fea$export$3de00231afdb801b);

var $2f8fl = parcelRequire("2f8fl");

var $9FcZG = parcelRequire("9FcZG");
const $60f00a6d9ef10fea$var$DATE_COMING_SOON_LOGIC_PATTERN = {
    [(0, $2f8fl.JsonLogicOperator).LT]: [
        '@',
        {
            var: 'daysUntilDueDate'
        },
        '@'
    ]
};
const $60f00a6d9ef10fea$export$2f2cb858f35d536d = (logic)=>{
    return (0, $9FcZG.default).rule_like(logic, $60f00a6d9ef10fea$var$DATE_COMING_SOON_LOGIC_PATTERN);
};
const $60f00a6d9ef10fea$var$DATE_OVERDUE_LOGIC_PATTERN = {
    [(0, $2f8fl.JsonLogicOperator).LT]: [
        {
            var: 'daysUntilDueDate'
        },
        '@'
    ]
};
const $60f00a6d9ef10fea$export$3de00231afdb801b = (logic)=>{
    return (0, $9FcZG.default).rule_like(logic, $60f00a6d9ef10fea$var$DATE_OVERDUE_LOGIC_PATTERN);
};

});


parcelRegister("5cPoD", function(module, exports) {
$parcel$export(module.exports, "createBetweenLogic", () => $985938aa933b5ddf$export$153a0838eec97535);
$parcel$export(module.exports, "createLessThanLogic", () => $985938aa933b5ddf$export$bfa1ea1051fe6adf);
$parcel$export(module.exports, "createGreaterThanLogic", () => $985938aa933b5ddf$export$1dc320f7a543e731);
$parcel$export(module.exports, "createDefaultLogic", () => $985938aa933b5ddf$export$12b2f01a3cb3b7ce);
$parcel$export(module.exports, "applyNumberLogic", () => $985938aa933b5ddf$export$2b440e3245160710);

var $2f8fl = parcelRequire("2f8fl");

var $9FcZG = parcelRequire("9FcZG");
const $985938aa933b5ddf$export$153a0838eec97535 = (gte = 0, lte = 0)=>{
    return {
        [(0, $2f8fl.JsonLogicOperator).LTE]: [
            gte,
            {
                var: 'value'
            },
            lte
        ]
    };
};
const $985938aa933b5ddf$export$bfa1ea1051fe6adf = (lte = 0)=>{
    return {
        [(0, $2f8fl.JsonLogicOperator).LT]: [
            {
                var: 'value'
            },
            lte
        ]
    };
};
const $985938aa933b5ddf$export$1dc320f7a543e731 = (gte = 0)=>{
    return {
        [(0, $2f8fl.JsonLogicOperator).GT]: [
            {
                var: 'value'
            },
            gte
        ]
    };
};
const $985938aa933b5ddf$export$12b2f01a3cb3b7ce = (type)=>{
    switch(type){
        case 'GT':
            return $985938aa933b5ddf$export$1dc320f7a543e731();
        case 'LT':
            return $985938aa933b5ddf$export$bfa1ea1051fe6adf();
        case 'BT':
            return $985938aa933b5ddf$export$153a0838eec97535();
        default:
            throw new Error('Invalid range type');
    }
};
const $985938aa933b5ddf$export$2b440e3245160710 = (logic, value)=>{
    return (0, $9FcZG.default).apply(logic, {
        value: value
    });
};

});



parcelRegister("bL4en", function(module, exports) {
$parcel$export(module.exports, "rankOptions", () => $16bf6b2fb7d28219$export$ab95c94e35e6cca5);

var $j85oP = parcelRequire("j85oP");

var $7imRA = parcelRequire("7imRA");

var $i7bkV = parcelRequire("i7bkV");
const $16bf6b2fb7d28219$var$fieldOptionUpdateExperience = (0, $7imRA.createExperienceWithMetaType)((0, $j85oP.experience).fieldsSidebar.fieldOptionUpdate, 'rankOptions', (err)=>`FieldOptionUpdate: ${err?.message ?? 'generic error'}`);
const $16bf6b2fb7d28219$export$ab95c94e35e6cca5 = (fieldKey, rankedOptionIds)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, fieldRemote: fieldRemote })=>{
        const state = getState();
        const previousOptions = state.fields[fieldKey].options;
        if (previousOptions === undefined) return;
        const newOptions = rankedOptionIds.map((id)=>previousOptions.find((option)=>option.jiraOptionId === id)).filter(Boolean);
        const fields = {
            ...state.fields,
            [fieldKey]: {
                ...state.fields[fieldKey],
                options: newOptions
            }
        };
        setState({
            fields: fields
        });
        if (projectId !== undefined) {
            $16bf6b2fb7d28219$var$fieldOptionUpdateExperience.start();
            fieldRemote.updateFieldOptionRank({
                fieldKey: fieldKey,
                rankedOptionIds: newOptions.map((option)=>option.jiraOptionId)
            }).then(()=>{
                $16bf6b2fb7d28219$var$fieldOptionUpdateExperience.success();
                (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.optionRankChanged(createAnalyticsEvent({}), {
                    issueFieldKey: fieldKey,
                    issueFieldType: fields[fieldKey].type
                });
            }).catch((error)=>{
                $16bf6b2fb7d28219$var$fieldOptionUpdateExperience.failure(error);
                onFieldUpdateFailed(error);
            });
        }
    };

});

parcelRegister("2ftzt", function(module, exports) {
$parcel$export(module.exports, "renameOption", () => $7452e1ba36a85ac8$export$1aa1b0b279ea3939);

var $j85oP = parcelRequire("j85oP");

var $7imRA = parcelRequire("7imRA");

var $i7bkV = parcelRequire("i7bkV");
const $7452e1ba36a85ac8$var$fieldOptionUpdateExperience = (0, $7imRA.createExperienceWithMetaType)((0, $j85oP.experience).fieldsSidebar.fieldOptionUpdate, 'renameOption', (err)=>`FieldOptionUpdate: ${err?.message ?? 'generic error'}`);
const $7452e1ba36a85ac8$export$1aa1b0b279ea3939 = (fieldKey, jiraOptionId, newValue)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, fieldRemote: fieldRemote })=>{
        const state = getState();
        const previousOptions = state.fields[fieldKey].options;
        const newOptions = previousOptions?.map((option)=>{
            if (option.jiraOptionId === jiraOptionId) return {
                ...option,
                value: newValue
            };
            return option;
        });
        const fields = {
            ...state.fields,
            [fieldKey]: {
                ...state.fields[fieldKey],
                options: newOptions
            }
        };
        setState({
            fields: fields
        });
        if (projectId !== undefined) {
            $7452e1ba36a85ac8$var$fieldOptionUpdateExperience.start();
            fieldRemote.renameFieldOption({
                fieldKey: fieldKey,
                newTitle: newValue,
                optionId: +jiraOptionId
            }).then(()=>{
                $7452e1ba36a85ac8$var$fieldOptionUpdateExperience.success();
                (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.optionLabelChanged(createAnalyticsEvent({}), {
                    issueFieldKey: fieldKey,
                    issueFieldType: fields[fieldKey].type,
                    fieldValueId: jiraOptionId
                });
            }).catch((error)=>{
                $7452e1ba36a85ac8$var$fieldOptionUpdateExperience.failure(error);
                onFieldUpdateFailed(error);
            });
        }
    };

});

parcelRegister("7MXRb", function(module, exports) {
$parcel$export(module.exports, "updateFieldOptionAutoFormattingDisabled", () => $01fef6113843f574$export$7e73e7c429f4b347);
const $01fef6113843f574$export$7e73e7c429f4b347 = (fieldKey, newValue)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, projectId: projectId, fieldRemote: fieldRemote })=>{
        const state = getState();
        const field = state.fields[fieldKey];
        const oldValue = field.configuration?.optionAutoFormatDisabled;
        if (projectId === undefined) return;
        const fields = {
            ...state.fields,
            [fieldKey]: {
                ...field,
                configuration: {
                    ...field.configuration,
                    optionAutoFormatDisabled: newValue
                }
            }
        };
        setState({
            fields: fields
        });
        return fieldRemote.updateFieldConfiguration({
            fieldKey: fieldKey,
            oldConfiguration: oldValue !== undefined ? {
                optionAutoFormatDisabled: oldValue
            } : {},
            configuration: newValue !== undefined ? {
                optionAutoFormatDisabled: newValue
            } : {},
            type: 'updateFieldOptionAutoFormattingDisabled'
        }).catch((err)=>{
            const currentState = getState();
            const currentFieldsData = {
                ...currentState.fields,
                [fieldKey]: {
                    ...currentState.fields[fieldKey],
                    configuration: {
                        ...currentState.fields[fieldKey].configuration,
                        optionAutoFormatDisabled: oldValue
                    }
                }
            };
            setState({
                fields: currentFieldsData
            });
            onFieldUpdateFailed(err);
        });
    };

});

parcelRegister("EJDEo", function(module, exports) {
$parcel$export(module.exports, "updateFieldOptionWeightType", () => $d67a1a3f11076111$export$da6c1255c64ed808);

var $aJ81Y = parcelRequire("aJ81Y");

var $2cQDy = parcelRequire("2cQDy");

var $9Xbcf = parcelRequire("9Xbcf");
const $d67a1a3f11076111$export$da6c1255c64ed808 = (fieldKey, newOptionWeightType)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        const field = (0, $2cQDy.createGetFieldByKey)(fieldKey)(getState());
        if (!field) return undefined;
        const oldConfiguration = field.configuration;
        const newConfiguration = {
            ...field.configuration,
            optionWeightType: newOptionWeightType
        };
        const oldOptions = field.options;
        let newOptions = field.options;
        const isWeightingRemoved = newOptionWeightType === undefined;
        if (isWeightingRemoved) {
            newConfiguration.optionWeights = (field.configuration?.optionWeights || []).map((e)=>({
                    ...e,
                    weight: (0, $9Xbcf.DEFAULT_OPTION_WEIGHT)
                }));
            newOptions = newOptions?.map((optionItem)=>({
                    ...optionItem,
                    weight: (0, $9Xbcf.DEFAULT_OPTION_WEIGHT)
                }));
        }
        try {
            const fields = {
                ...getState().fields
            };
            fields[fieldKey] = {
                ...fields[fieldKey],
                configuration: newConfiguration,
                options: newOptions
            };
            setState({
                fields: fields
            });
            await fieldRemote.updateFieldConfiguration({
                oldConfiguration: oldConfiguration ?? {},
                configuration: newConfiguration,
                fieldKey: field.key,
                type: 'updateFieldOptionWeightType'
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueFields updated', {
                issueFieldKey: fieldKey,
                issueFieldType: field.type,
                updatedItems: Object.keys(newConfiguration).map((name)=>({
                        name: name
                    }))
            });
            return undefined;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const fields = {
                ...getState().fields
            };
            fields[fieldKey] = {
                ...fields[fieldKey],
                configuration: oldConfiguration,
                options: oldOptions
            };
            setState({
                fields: fields
            });
            onFieldUpdateFailed(err);
            return err;
        }
    };

});

parcelRegister("uUVQy", function(module, exports) {
$parcel$export(module.exports, "updateFieldOptionWeight", () => $fe8080a0bc74fd0e$export$aacb3d2067112884);

var $i7bkV = parcelRequire("i7bkV");

var $7kMKd = parcelRequire("7kMKd");
const $fe8080a0bc74fd0e$export$aacb3d2067112884 = (fieldKey, jiraOptionId, newWeight)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, fieldRemote: fieldRemote })=>{
        if (projectId === undefined) return;
        const state = getState();
        const field = state.fields[fieldKey];
        const previousOptions = field.options;
        const optionIds = previousOptions?.map((option)=>option.id) || [];
        const newOptions = previousOptions?.map((option)=>{
            if (option.jiraOptionId === jiraOptionId) return {
                ...option,
                weight: newWeight
            };
            return option;
        });
        const jiraOptionIdNumber = parseInt(jiraOptionId, 10);
        // We need to get the real api configuration to be able to correctly apply the patch to the server
        const oldConfigurationOptions = field.configuration?.optionWeights ?? [];
        // {weight: 3, optionId: 10067}
        const hasOldConfigWeight = oldConfigurationOptions.find((option)=>option.optionId === jiraOptionIdNumber);
        let newConfigurationOptions;
        if (hasOldConfigWeight) newConfigurationOptions = oldConfigurationOptions?.map((option)=>{
            if (option.optionId === jiraOptionIdNumber) return {
                ...option,
                weight: newWeight
            };
            return option;
        });
        else newConfigurationOptions = [
            ...oldConfigurationOptions,
            {
                weight: newWeight,
                optionId: parseInt(jiraOptionId, 10)
            }
        ];
        newConfigurationOptions = (0, $7kMKd.sanitizeOptionWeights)(newConfigurationOptions, optionIds);
        const fields = {
            ...state.fields,
            [fieldKey]: {
                ...field,
                options: newOptions,
                configuration: {
                    ...state.fields[fieldKey].configuration,
                    optionWeights: newConfigurationOptions
                }
            }
        };
        setState({
            fields: fields
        });
        return fieldRemote.updateFieldConfiguration({
            fieldKey: fieldKey,
            oldConfiguration: oldConfigurationOptions?.length > 0 ? {
                optionWeights: oldConfigurationOptions
            } : {},
            configuration: newConfigurationOptions.length > 0 ? {
                optionWeights: newConfigurationOptions
            } : {},
            type: 'updateFieldOptionWeight'
        }).then(()=>{
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.optionWeightChanged(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: fields[fieldKey].type,
                fieldValueId: jiraOptionId
            });
        }).catch((err)=>{
            const currentFields = {
                ...getState().fields
            };
            currentFields[fieldKey] = {
                ...currentFields[fieldKey],
                options: previousOptions,
                configuration: {
                    ...currentFields[fieldKey].configuration,
                    optionWeights: oldConfigurationOptions?.length > 0 ? oldConfigurationOptions : undefined
                }
            };
            setState({
                fields: currentFields
            });
            onFieldUpdateFailed(err);
        });
    };

});
parcelRegister("7kMKd", function(module, exports) {
$parcel$export(module.exports, "sanitizeOptionWeights", () => $5e56862bc0f187ed$export$38737a04fd8c7aea);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Removes obsolete and duplicated option weights originating from select and multiselect fields.
 * https://pi-dev-sandbox.atlassian.net/browse/POL-7929
 */ const $5e56862bc0f187ed$export$38737a04fd8c7aea = (fieldOptions, optionIds)=>{
    const existingOptionIds = {};
    return fieldOptions.filter(({ optionId: optionId })=>{
        if (!optionIds.includes(optionId.toString())) return false;
        if (existingOptionIds[optionId.toString()]) return false;
        existingOptionIds[optionId.toString()] = true;
        return true;
    });
};

});


parcelRegister("2o3Tm", function(module, exports) {
$parcel$export(module.exports, "createFieldOptionWeightBulk", () => $d7d7ec96e3047135$export$86a029ce4e2a8c6b);

var $i7bkV = parcelRequire("i7bkV");

var $7kMKd = parcelRequire("7kMKd");
const $d7d7ec96e3047135$export$86a029ce4e2a8c6b = (fieldKey, options)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, fieldRemote: fieldRemote })=>{
        if (projectId === undefined) return;
        const state = getState();
        const field = state.fields[fieldKey];
        const previousOptions = field.options;
        const optionIds = previousOptions?.map((option)=>option.id) || [];
        const newOptions = previousOptions?.map((option)=>{
            const newValues = options.find((o)=>o.optionId.toString() === option.jiraOptionId);
            if (newValues) return {
                ...option,
                weight: newValues.weight
            };
            return option;
        });
        const oldConfigurationOptions = field.configuration?.optionWeights ?? [];
        const newConfigurationOptions = (0, $7kMKd.sanitizeOptionWeights)(options, optionIds);
        const fields = {
            ...state.fields,
            [fieldKey]: {
                ...field,
                options: newOptions,
                configuration: {
                    ...state.fields[fieldKey].configuration,
                    optionWeights: newConfigurationOptions
                }
            }
        };
        setState({
            fields: fields
        });
        return fieldRemote.updateFieldConfiguration({
            fieldKey: fieldKey,
            oldConfiguration: {},
            configuration: newConfigurationOptions.length > 0 ? {
                optionWeights: newConfigurationOptions
            } : {},
            type: 'updateFieldOptionWeight'
        }).then(()=>{
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.optionWeightChanged(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: fields[fieldKey].type
            });
        }).catch((err)=>{
            const currentFields = {
                ...getState().fields
            };
            currentFields[fieldKey] = {
                ...currentFields[fieldKey],
                options: previousOptions,
                configuration: {
                    ...currentFields[fieldKey].configuration,
                    optionWeights: oldConfigurationOptions
                }
            };
            setState({
                fields: currentFields
            });
            onFieldUpdateFailed(err);
        });
    };

});

parcelRegister("jMXrz", function(module, exports) {
$parcel$export(module.exports, "updateConnectionFieldFilter", () => $9c33f306068663fc$export$c640d81da10e7f54);
$parcel$export(module.exports, "updateConnectionFieldIssueViewLayout", () => $9c33f306068663fc$export$1d6ee092ed076358);

var $63gbl = parcelRequire("63gbl");

var $gAxlz = parcelRequire("gAxlz");


var $bMFIp = parcelRequire("bMFIp");

var $2cQDy = parcelRequire("2cQDy");
const $9c33f306068663fc$export$c640d81da10e7f54 = (fieldKey, filter)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote })=>{
        const state = getState();
        const currentField = (0, $2cQDy.createGetFieldByKey)(fieldKey)(state);
        if (!currentField) return;
        const newConfiguration = {
            ...currentField.configuration,
            issueTypeFilters: filter && (0, $gAxlz.isIssueTypeNameFilter)(filter) ? [
                filter
            ] : []
        };
        try {
            setState({
                fields: {
                    ...state.fields,
                    [fieldKey]: {
                        ...currentField,
                        configuration: newConfiguration
                    }
                }
            });
            await fieldRemote.updateFieldConfiguration({
                fieldKey: fieldKey,
                oldConfiguration: currentField.configuration || {},
                configuration: newConfiguration,
                type: 'updateConnectionField'
            });
        } catch (error) {
            setState({
                fields: {
                    ...state.fields,
                    [fieldKey]: currentField
                }
            });
            if (error instanceof Error) {
                (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.field.actions.update-field-configuration.connection.issue-filters', 'Failed to update connection field issue filters', error);
                onFieldUpdateFailed(error);
            }
        }
    };
const $9c33f306068663fc$export$1d6ee092ed076358 = (fieldKey, config)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote, globalFieldRemote: globalFieldRemote, isSharedView: isSharedView })=>{
        const state = getState();
        const currentField = (0, $2cQDy.createGetFieldByKey)(fieldKey)(state);
        if (!currentField) return;
        const currentConfiguration = currentField.configuration || {};
        let issueViewLayoutFields;
        if (config.selectedFieldKey === undefined) issueViewLayoutFields = currentConfiguration.issueViewLayout?.fields || [];
        else if (config.selectedFieldKey === null) issueViewLayoutFields = [];
        else issueViewLayoutFields = [
            config.selectedFieldKey
        ];
        let issueViewLayoutSort;
        if (config.selectedFieldKey === null && currentConfiguration.issueViewLayout?.sort?.[0]?.fieldKey !== (0, $a5fd42f98fc0f2b5$export$469f8bf472cb9ca)) issueViewLayoutSort = [];
        else if (config.sort === undefined) issueViewLayoutSort = currentConfiguration.issueViewLayout?.sort || [];
        else if (config.sort === null) issueViewLayoutSort = [];
        else issueViewLayoutSort = [
            config.sort
        ];
        const newConfiguration = {
            ...currentConfiguration,
            issueViewLayout: {
                fields: issueViewLayoutFields,
                sort: issueViewLayoutSort
            }
        };
        try {
            setState({
                fields: {
                    ...state.fields,
                    [fieldKey]: {
                        ...currentField,
                        configuration: newConfiguration
                    }
                }
            });
            if (isSharedView) return;
            if (currentField.global) await globalFieldRemote.updateGlobalFieldConfiguration({
                fieldKey: fieldKey,
                patch: (0, $bMFIp.createJsonPatch)(currentConfiguration, newConfiguration)
            });
            else await fieldRemote.updateFieldConfiguration({
                fieldKey: fieldKey,
                oldConfiguration: currentConfiguration,
                configuration: newConfiguration,
                type: 'updateConnectionField'
            });
        } catch (error) {
            setState({
                fields: {
                    ...state.fields,
                    [fieldKey]: currentField
                }
            });
            if (error instanceof Error) {
                (0, $63gbl.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.field.actions.update-field-configuration.connection.issue-view-layout', 'Failed to update connection field issue view layout', error);
                onFieldUpdateFailed(error);
            }
        }
    };

});
/* eslint-disable jira/filename-case */ const $a5fd42f98fc0f2b5$export$3aafeb2daa00df8b = 'key';
const $a5fd42f98fc0f2b5$export$48927a8f78b0130e = 'issueid';
const $a5fd42f98fc0f2b5$export$469f8bf472cb9ca = 'summary';
const $a5fd42f98fc0f2b5$export$29157f6cae91bb2f = 'status';
const $a5fd42f98fc0f2b5$export$dd03acb09519222 = 'issuetype';
const $a5fd42f98fc0f2b5$export$ed9d952d27dea151 = 'labels';
const $a5fd42f98fc0f2b5$export$1f3d7d17213e853b = 'votes';
const $a5fd42f98fc0f2b5$export$cb59b69c70ea9e18 = 'reporter';
const $a5fd42f98fc0f2b5$export$d6749ecf5a14d5b = 'description';
const $a5fd42f98fc0f2b5$export$7e67ea07bd31e757 = 'assignee';
const $a5fd42f98fc0f2b5$export$4b6f00f5eeabd293 = 'creator';
const $a5fd42f98fc0f2b5$export$16313363fca8abe5 = 'created';
const $a5fd42f98fc0f2b5$export$77c57adf6bed37b8 = 'updated';
const $a5fd42f98fc0f2b5$export$1fd24e9c03ef9b18 = 'project';

parcelRegister("bMFIp", function(module, exports) {
$parcel$export(module.exports, "createJsonPatch", () => $8d2beafeca28c50e$export$cc0934c8c9651d07);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bxhpq = parcelRequire("bxhpq");
const $8d2beafeca28c50e$export$cc0934c8c9651d07 = (oldObject, newObject)=>{
    // undefined value for undefined is not a valid value in JSON schema
    // stringify and parse to deep clone the objects to get rid of
    // undefined values are removed when stringified, or replaced with null when makes sense
    const oldObj = JSON.parse(JSON.stringify(oldObject));
    const newObj = JSON.parse(JSON.stringify(newObject));
    const patch = [];
    for (const [oldKey, value] of Object.entries(oldObj)){
        if (!(oldKey in newObj)) patch.push({
            op: 'remove',
            path: `/${oldKey}`
        });
        else if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(value, newObj[oldKey])) patch.push({
            op: 'replace',
            value: newObj[oldKey],
            path: `/${oldKey}`
        });
    }
    for (const [key, value] of Object.entries(newObj))if (!(key in oldObj)) patch.push({
        op: 'add',
        path: `/${key}`,
        value: value
    });
    return patch;
};

});


parcelRegister("gjKEx", function(module, exports) {
$parcel$export(module.exports, "updateDeliveryFieldPresentation", () => $cd7cfeefdbf4117b$export$5a0c65e78b5a9b0f);

var $aJ81Y = parcelRequire("aJ81Y");

var $2cQDy = parcelRequire("2cQDy");
const $cd7cfeefdbf4117b$export$5a0c65e78b5a9b0f = (fieldKey, presentation)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        // oxlint-disable-next-line typescript/no-non-null-assertion
        const currentField = (0, $2cQDy.createGetFieldByKey)(fieldKey)(state);
        (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueFields updated', {
            updatedItems: [
                {
                    name: 'presentation'
                }
            ],
            issueFieldKey: currentField.key,
            issueFieldType: currentField.type
        });
        setState({
            fields: {
                ...state.fields,
                [fieldKey]: {
                    ...state.fields[fieldKey],
                    presentation: {
                        type: presentation
                    }
                }
            }
        });
        await fieldRemote.updateFieldConfiguration({
            fieldKey: fieldKey,
            oldConfiguration: currentField.presentation ? {
                // oxlint-disable-next-line typescript/consistent-type-assertions
                polarisPresentation: currentField.presentation.type
            } : {},
            configuration: {
                polarisPresentation: presentation
            },
            type: 'updateDeliveryFieldPresentation'
        });
    };

});

parcelRegister("6hRsl", function(module, exports) {
$parcel$export(module.exports, "updateDescription", () => $da47f8d65081cede$export$989a858ef0c8fda5);

var $i7bkV = parcelRequire("i7bkV");
const $da47f8d65081cede$var$getUpdatedState = (state, fieldKey, description)=>({
        ...state,
        fields: {
            ...state.fields,
            [fieldKey]: {
                ...state.fields[fieldKey],
                description: description
            }
        }
    });
const $da47f8d65081cede$export$989a858ef0c8fda5 = (fieldKey, description, createAnalyticsEvent)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote })=>{
        const state = getState();
        const oldDescription = state.fields[fieldKey].description;
        if (!state.fields[fieldKey] || state.fields[fieldKey].description === description) return;
        setState($da47f8d65081cede$var$getUpdatedState(state, fieldKey, description));
        try {
            const newFieldState = await fieldRemote.updateField({
                fieldKey: fieldKey,
                description: description
            });
            setState($da47f8d65081cede$var$getUpdatedState(getState(), fieldKey, newFieldState.description));
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState($da47f8d65081cede$var$getUpdatedState(getState(), fieldKey, oldDescription));
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.descriptionChangedFailure(createAnalyticsEvent({}));
            onFieldUpdateFailed(err);
            return;
        }
        (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.descriptionChangedSuccess(createAnalyticsEvent({}), {
            issueFieldKey: fieldKey,
            issueFieldType: state.fields[fieldKey].type
        });
    };

});

parcelRegister("eDiwg", function(module, exports) {
$parcel$export(module.exports, "updateEmoji", () => $d8e0010c9605696a$export$b5424c372b533bed);

var $i7bkV = parcelRequire("i7bkV");
const $d8e0010c9605696a$var$getUpdatedState = (state, fieldKey, emoji)=>({
        ...state,
        fields: {
            ...state.fields,
            [fieldKey]: {
                ...state.fields[fieldKey],
                emoji: emoji
            }
        }
    });
const $d8e0010c9605696a$export$b5424c372b533bed = (fieldKey, emoji, createAnalyticsEvent)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote })=>{
        const state = getState();
        const field = state.fields[fieldKey];
        const oldEmoji = field.emoji;
        if (!field || field.emoji === emoji) return;
        setState($d8e0010c9605696a$var$getUpdatedState(state, fieldKey, emoji));
        try {
            await fieldRemote.updateFieldConfiguration({
                fieldKey: fieldKey,
                oldConfiguration: oldEmoji ? {
                    emoji: oldEmoji
                } : {},
                configuration: emoji ? {
                    emoji: emoji
                } : {},
                type: 'updateEmoji'
            });
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.emojiChangedSuccess(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: field.type
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState($d8e0010c9605696a$var$getUpdatedState(getState(), fieldKey, oldEmoji));
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.emojiChangedFailure(createAnalyticsEvent({}));
            onFieldUpdateFailed(err);
        }
    };

});

parcelRegister("i1Tku", function(module, exports) {
$parcel$export(module.exports, "updateFieldFormula", () => $74906c04c8f17126$export$ae0ab6f53041dfe5);

var $aJ81Y = parcelRequire("aJ81Y");
const $74906c04c8f17126$export$ae0ab6f53041dfe5 = (fieldKey, formula, abortSignal)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        const currentField = state.fields[fieldKey];
        (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueFields updated', {
            updatedItems: [
                {
                    name: 'formula'
                }
            ],
            issueFieldKey: currentField.key,
            issueFieldType: currentField.type
        });
        const oldConfiguration = currentField.formula ? {
            polarisFormula: currentField.formula
        } : {};
        const configuration = {
            polarisFormula: formula
        };
        await fieldRemote.updateFieldConfiguration({
            fieldKey: fieldKey,
            oldConfiguration: oldConfiguration,
            configuration: configuration,
            type: 'updateFieldFormula'
        }, abortSignal);
        const newField = {
            ...currentField,
            formula: formula,
            configuration: {
                ...currentField.configuration,
                ...configuration
            }
        };
        setState({
            fields: {
                ...getState().fields,
                [fieldKey]: newField
            }
        });
        return newField;
    };

});

parcelRegister("3lq8U", function(module, exports) {
$parcel$export(module.exports, "updateLabel", () => $17a7f6d02fc00143$export$b823280c6eab17e9);

var $i7bkV = parcelRequire("i7bkV");
const $17a7f6d02fc00143$var$getUpdatedState = (state, fieldKey, label)=>({
        ...state,
        fields: {
            ...state.fields,
            [fieldKey]: {
                ...state.fields[fieldKey],
                label: label
            }
        }
    });
const $17a7f6d02fc00143$export$b823280c6eab17e9 = (fieldKey, label, createAnalyticsEvent)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote })=>{
        try {
            const state = getState();
            if (!state.fields[fieldKey] || state.fields[fieldKey].label === label) return false;
            await fieldRemote.updateField({
                fieldKey: fieldKey,
                name: label
            });
            setState($17a7f6d02fc00143$var$getUpdatedState(getState(), fieldKey, label));
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.labelChangedSuccess(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: state.fields[fieldKey].type
            });
            return true;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $i7bkV.fireCompoundAnalyticsEvent).FieldConfig.labelChangedFailure(createAnalyticsEvent({}));
            return e;
        }
    };

});

parcelRegister("k7Z4l", function(module, exports) {
$parcel$export(module.exports, "updatePlayField", () => $e0b0f1c19179f2e4$export$870e1a1a0d62147f);

var $aJ81Y = parcelRequire("aJ81Y");
const $e0b0f1c19179f2e4$export$870e1a1a0d62147f = (fieldKey, maxSpend)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        const field = state.fields[fieldKey];
        try {
            if (field?.play?.id === undefined) {
                onFieldUpdateFailed(new Error('Updated failed: field without id cannot be updated'));
                return;
            }
            await fieldRemote.updatePlayField({
                id: field.play.id,
                parameters: {
                    maxSpend: maxSpend
                }
            });
            const oldMaxSpend = field.play?.parameters?.maxSpend;
            await fieldRemote.updateFieldConfiguration({
                fieldKey: fieldKey,
                configuration: {
                    maxSpend: maxSpend
                },
                oldConfiguration: oldMaxSpend ? {
                    maxSpend: oldMaxSpend
                } : {},
                type: 'updatePlayField'
            });
            setState({
                fields: {
                    ...state.fields,
                    [fieldKey]: {
                        ...field,
                        play: {
                            // oxlint-disable-next-line typescript/no-non-null-assertion
                            ...field.play,
                            parameters: {
                                ...field.play?.parameters,
                                maxSpend: maxSpend
                            }
                        }
                    }
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueFields updated', {
                updatedItems: [
                    {
                        name: 'play.maxSpend'
                    }
                ],
                issueFieldKey: fieldKey,
                issueFieldType: field?.type
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onFieldUpdateFailed(error);
        }
    };

});

parcelRegister("lhKEw", function(module, exports) {
$parcel$export(module.exports, "updateSystemFieldHidden", () => $8035bf95b9b18042$export$2a6a1ba980ab5158);

var $gZccD = parcelRequire("gZccD");

var $aJ81Y = parcelRequire("aJ81Y");

var $2cQDy = parcelRequire("2cQDy");
const $8035bf95b9b18042$export$2a6a1ba980ab5158 = (fieldKey, hidden)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        const field = (0, $2cQDy.createGetFieldByKey)(fieldKey)(getState());
        if (!field || !(0, $gZccD.fieldCanBeHidden)(field.type) || field.configuration?.hidden === hidden) return;
        try {
            const configuration = {
                ...field.configuration,
                hidden: hidden
            };
            const fields = {
                ...getState().fields
            };
            setState({
                fields: {
                    ...fields,
                    [fieldKey]: {
                        ...fields[fieldKey],
                        configuration: configuration
                    }
                }
            });
            try {
                await fieldRemote.updateFieldConfiguration({
                    oldConfiguration: field.configuration ?? {},
                    configuration: configuration,
                    fieldKey: field.key,
                    type: 'updateSystemFieldHidden'
                });
            } catch (error) {
                const currentState = getState();
                const currentFields = currentState.fields;
                setState({
                    fields: {
                        ...currentFields,
                        [fieldKey]: {
                            ...currentFields[fieldKey],
                            configuration: {
                                ...currentFields[fieldKey].configuration,
                                hidden: field.configuration?.hidden ?? !hidden
                            }
                        }
                    }
                });
                throw error;
            }
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueFields updated', {
                issueFieldKey: fieldKey,
                issueFieldType: field.type,
                updatedItems: [
                    {
                        name: 'hidden'
                    }
                ]
            });
        } catch (error) {
            onFieldUpdateFailed(error instanceof Error ? error : new Error('failed to update system field hidden'));
            throw error;
        }
    };

});
parcelRegister("gZccD", function(module, exports) {
$parcel$export(module.exports, "getFieldId", () => $188455235e8da887$export$f4457e83c74ac000);
$parcel$export(module.exports, "fieldCanBeHidden", () => $188455235e8da887$export$9da5531535a06a9e);
$parcel$export(module.exports, "canHaveValuesCopiedToGlobalField", () => $188455235e8da887$export$3356aa19195d3185);
$parcel$export(module.exports, "eligibleCopyTargetFilterPredicate", () => $188455235e8da887$export$8d71c4715545b632);
$parcel$export(module.exports, "isGlobalSystem", () => $188455235e8da887$export$a6f71e43ddeb9c);
$parcel$export(module.exports, "isGlobalNonSystem", () => $188455235e8da887$export$d1c5ea1df066a86);
$parcel$export(module.exports, "isGlobalSystemField", () => $188455235e8da887$export$92ddaa0fb1252ade);
$parcel$export(module.exports, "isGlobalNonSystemField", () => $188455235e8da887$export$506e497e6a42b28);
$parcel$export(module.exports, "isGlobalSystemWithProjectLevelConfiguration", () => $188455235e8da887$export$9279b74cb5ca6961);
$parcel$export(module.exports, "isConnectionFieldConfigured", () => $188455235e8da887$export$9c2194f37ac6145e);
$parcel$export(module.exports, "isFieldDependingOnDeliveryData", () => $188455235e8da887$export$5ef1dc9f5e348904);

var $i860n = parcelRequire("i860n");

var $lziWQ = parcelRequire("lziWQ");

var $5GrX3 = parcelRequire("5GrX3");

var $iXFKY = parcelRequire("iXFKY");

var $1vWNL = parcelRequire("1vWNL");
const $188455235e8da887$export$386ed4140989cc75 = (key)=>key;
const $188455235e8da887$export$f4457e83c74ac000 = (fieldKey)=>{
    const customFieldPrefix = 'customfield_';
    if (!fieldKey || !fieldKey.startsWith(customFieldPrefix)) return '';
    return fieldKey.replace(customFieldPrefix, '');
};
const $188455235e8da887$var$FIELDS_CANNOT_BE_HIDDEN = new Set([
    (0, $5GrX3.FIELD_TYPES).SUMMARY,
    (0, $5GrX3.FIELD_TYPES).ISSUE_KEY,
    (0, $5GrX3.FIELD_TYPES).CREATED
]);
const $188455235e8da887$export$9da5531535a06a9e = (fieldType)=>{
    if (!fieldType || !(0, $lziWQ.isSystemFieldType)(fieldType)) return false;
    return !$188455235e8da887$var$FIELDS_CANNOT_BE_HIDDEN.has(fieldType);
};
const $188455235e8da887$var$FIELDS_CANNOT_BE_MAPPED_TO_GLOBAL = new Set([
    (0, $5GrX3.FIELD_TYPES).FORMULA,
    (0, $5GrX3.FIELD_TYPES).REACTIONS,
    (0, $5GrX3.FIELD_TYPES).VOTES,
    (0, $5GrX3.FIELD_TYPES).CONNECTION
]);
const $188455235e8da887$export$3356aa19195d3185 = (fieldType)=>{
    return fieldType && !(0, $lziWQ.isSystemFieldType)(fieldType) && !$188455235e8da887$var$FIELDS_CANNOT_BE_MAPPED_TO_GLOBAL.has(fieldType);
};
const $188455235e8da887$export$8d71c4715545b632 = ({ from: sourceFieldType, to: targetFieldType })=>{
    if (targetFieldType === sourceFieldType) return true;
    return sourceFieldType === (0, $5GrX3.FIELD_TYPES).MULTI_SELECT && targetFieldType === (0, $5GrX3.FIELD_TYPES).JSW_MULTI_SELECT || sourceFieldType === (0, $5GrX3.FIELD_TYPES).PEOPLE && targetFieldType === (0, $5GrX3.FIELD_TYPES).JSW_PEOPLE;
};
const $188455235e8da887$var$SYSTEM_FIELDS = new Set([
    (0, $5GrX3.FIELD_TYPES).ISSUE_COMMENTS,
    (0, $5GrX3.FIELD_TYPES).INSIGHTS,
    (0, $5GrX3.FIELD_TYPES).LINKED_ISSUES,
    (0, $5GrX3.FIELD_TYPES).DELIVERY_PROGRESS,
    (0, $5GrX3.FIELD_TYPES).DELIVERY_STATUS,
    (0, $5GrX3.FIELD_TYPES).ARCHIVED,
    (0, $5GrX3.FIELD_TYPES).ARCHIVED_ON,
    (0, $5GrX3.FIELD_TYPES).ARCHIVED_BY,
    (0, $5GrX3.FIELD_TYPES).ATLAS_GOAL,
    (0, $5GrX3.FIELD_TYPES).ATLAS_PROJECT,
    (0, $5GrX3.FIELD_TYPES).ATLAS_PROJECT_STATUS,
    (0, $5GrX3.FIELD_TYPES).PLATFORM_GOALS,
    (0, $5GrX3.FIELD_TYPES).PLATFORM_FOCUS_AREAS,
    (0, $5GrX3.FIELD_TYPES).INSIGHTS_GLOBAL,
    (0, $5GrX3.FIELD_TYPES).LINKED_ISSUES_GLOBAL,
    (0, $5GrX3.FIELD_TYPES).DELIVERY_PROGRESS_GLOBAL,
    (0, $5GrX3.FIELD_TYPES).DELIVERY_STATUS_GLOBAL,
    (0, $5GrX3.FIELD_TYPES).ISSUE_COMMENTS_GLOBAL,
    (0, $5GrX3.FIELD_TYPES).PLATFORM_PROJECT,
    (0, $5GrX3.FIELD_TYPES).PLATFORM_PROJECT_STATUS,
    (0, $5GrX3.FIELD_TYPES).PLATFORM_ATLAS_PROJECT
]);
const $188455235e8da887$var$SYSTEM_FIELDS_WITH_PROJECT_CONFIGURATION = new Set([
    (0, $5GrX3.FIELD_TYPES).LINKED_ISSUES,
    (0, $5GrX3.FIELD_TYPES).DELIVERY_PROGRESS,
    (0, $5GrX3.FIELD_TYPES).DELIVERY_STATUS,
    (0, $5GrX3.FIELD_TYPES).LINKED_ISSUES_GLOBAL,
    (0, $5GrX3.FIELD_TYPES).DELIVERY_PROGRESS_GLOBAL,
    (0, $5GrX3.FIELD_TYPES).DELIVERY_STATUS_GLOBAL
]);
const $188455235e8da887$export$a6f71e43ddeb9c = (type, global, custom, stableId)=>{
    if (type === (0, $5GrX3.FIELD_TYPES).PLATFORM_FOCUS_AREAS && !(0, $i860n.fg)('jpd_focus_areas_field_support')) return false;
    return !!global && !!custom && ($188455235e8da887$var$SYSTEM_FIELDS.has(type) || (0, $iXFKY.isGlobalSystemFieldStableId)(stableId));
};
const $188455235e8da887$export$d1c5ea1df066a86 = (type, global, custom, stableId)=>{
    return !!global && !!custom && !($188455235e8da887$var$SYSTEM_FIELDS.has(type) || (0, $iXFKY.isGlobalSystemFieldStableId)(stableId));
};
const $188455235e8da887$export$92ddaa0fb1252ade = ({ global: global, custom: custom, type: type, stableId: stableId })=>{
    return $188455235e8da887$export$a6f71e43ddeb9c(type, global, custom, stableId);
};
const $188455235e8da887$export$506e497e6a42b28 = ({ global: global, custom: custom, type: type, stableId: stableId })=>{
    return $188455235e8da887$export$d1c5ea1df066a86(type, global, custom, stableId);
};
const $188455235e8da887$export$9279b74cb5ca6961 = (type, global, custom, stableId)=>{
    return $188455235e8da887$export$a6f71e43ddeb9c(type, global, custom, stableId) && $188455235e8da887$var$SYSTEM_FIELDS_WITH_PROJECT_CONFIGURATION.has(type);
};
const $188455235e8da887$export$31095e7cae078af2 = (field)=>{
    return $188455235e8da887$export$9279b74cb5ca6961(field.type, field.global, field.custom, field.stableId);
};
const $188455235e8da887$export$9c2194f37ac6145e = (field)=>{
    return field.type === (0, $5GrX3.FIELD_TYPES).CONNECTION && field.configuration?.issueTypeFilters !== undefined && field.configuration?.issueTypeFilters.length > 0;
};
const $188455235e8da887$export$5ef1dc9f5e348904 = (field)=>(0, $lziWQ.isDeliveryFieldType)(field.type) || (0, $1vWNL.isIntervalFieldWithDeliveryDateConfig)(field);

});
parcelRegister("1vWNL", function(module, exports) {
$parcel$export(module.exports, "isIntervalFieldSourcesKey", () => $49bbd70628ce24b8$export$92f77cba7c01c50d);
$parcel$export(module.exports, "isValidDeliveryDateConfiguration", () => $49bbd70628ce24b8$export$f7abc37a855e2a00);
$parcel$export(module.exports, "isIntervalFieldWithDeliveryDateConfig", () => $49bbd70628ce24b8$export$6a7402cf653b09f6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5GrX3 = parcelRequire("5GrX3");

var $3Ua1L = parcelRequire("3Ua1L");
const $49bbd70628ce24b8$export$92f77cba7c01c50d = (source)=>source in (0, $3Ua1L.INTERVAL_FIELD_SOURCES);
const $49bbd70628ce24b8$export$f7abc37a855e2a00 = (configuration)=>!!(configuration && configuration.source === (0, $3Ua1L.INTERVAL_FIELD_SOURCES).DELIVERY_DATE && configuration.customfieldKey && configuration.aggregationType);
const $49bbd70628ce24b8$export$6a7402cf653b09f6 = (field)=>field.type === (0, $5GrX3.FIELD_TYPES).INTERVAL && $49bbd70628ce24b8$export$f7abc37a855e2a00(field.configuration);

});
parcelRegister("3Ua1L", function(module, exports) {
$parcel$export(module.exports, "INTERVAL_FIELD_SOURCES", () => $a8b70c49d29bfe17$export$32d458d2bb06643c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $a8b70c49d29bfe17$var$INTERVAL_FIELD_SOURCE_MANUAL = 'MANUAL';
const $a8b70c49d29bfe17$var$INTERVAL_FIELD_SOURCE_ATLAS_PROJECT_START_DATE = 'ATLAS_PROJECT_START_DATE';
const $a8b70c49d29bfe17$var$INTERVAL_FIELD_SOURCE_ATLAS_PROJECT_TARGET_DATE = 'ATLAS_PROJECT_TARGET_DATE';
const $a8b70c49d29bfe17$var$INTERVAL_FIELD_SOURCE_DELIVERY_DATE = 'DELIVERY_DATE';
const $a8b70c49d29bfe17$export$32d458d2bb06643c = {
    MANUAL: $a8b70c49d29bfe17$var$INTERVAL_FIELD_SOURCE_MANUAL,
    ATLAS_PROJECT_START_DATE: $a8b70c49d29bfe17$var$INTERVAL_FIELD_SOURCE_ATLAS_PROJECT_START_DATE,
    ATLAS_PROJECT_TARGET_DATE: $a8b70c49d29bfe17$var$INTERVAL_FIELD_SOURCE_ATLAS_PROJECT_TARGET_DATE,
    DELIVERY_DATE: $a8b70c49d29bfe17$var$INTERVAL_FIELD_SOURCE_DELIVERY_DATE
};

});




parcelRegister("hbUcG", function(module, exports) {
$parcel$export(module.exports, "updateUserFieldDisplayMode", () => $a9706745a1e2bfc4$export$4e721c33f5dab30);

var $aJ81Y = parcelRequire("aJ81Y");

var $2cQDy = parcelRequire("2cQDy");
const $a9706745a1e2bfc4$export$4e721c33f5dab30 = (fieldKey, displayMode, localUpdate = false)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        try {
            const field = (0, $2cQDy.createGetFieldByKey)(fieldKey)(getState());
            if (!field) return undefined;
            const configuration = {
                ...field.configuration,
                displayMode: displayMode
            };
            if (!localUpdate) await fieldRemote.updateFieldConfiguration({
                oldConfiguration: field.configuration ?? {},
                configuration: configuration,
                fieldKey: field.key,
                type: 'updateUserFieldDisplayMode'
            });
            const fields = {
                ...getState().fields
            };
            fields[fieldKey] = {
                ...fields[fieldKey],
                configuration: configuration
            };
            setState({
                fields: fields
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueFields updated', {
                issueFieldKey: fieldKey,
                issueFieldType: field.type,
                updatedItems: [
                    {
                        name: 'displayMode'
                    }
                ]
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            onFieldUpdateFailed(err);
        }
    };

});



parcelRegister("aVKCJ", function(module, exports) {
$parcel$export(module.exports, "createHigherLevelFieldHook", () => $7a969b09db7c4d8a$export$67d6a9af20f2969f);
$parcel$export(module.exports, "createHigherLevelFieldHook2", () => $7a969b09db7c4d8a$export$18156830b448602e);
$parcel$export(module.exports, "createHigherLevelFieldHook3", () => $7a969b09db7c4d8a$export$a2bc3ef72fea1e90);

var $jxZmP = parcelRequire("jxZmP");
const $7a969b09db7c4d8a$export$67d6a9af20f2969f = (selectorCreator)=>(0, $jxZmP.createHigherLevelFieldHook)(selectorCreator);
const $7a969b09db7c4d8a$export$18156830b448602e = (selectorCreator)=>(0, $jxZmP.createHigherLevelFieldHook)(selectorCreator);
const $7a969b09db7c4d8a$export$a2bc3ef72fea1e90 = (selectorCreator)=>(0, $jxZmP.createHigherLevelFieldHook)(selectorCreator);

});



parcelRegister("eW8E0", function(module, exports) {
$parcel$export(module.exports, "useCanSaveAsGlobalView", () => $c2ce7dc01e8ddd1e$export$7210851e4cc7cf42);

var $e7boj = parcelRequire("e7boj");

var $3NopQ = parcelRequire("3NopQ");

var $koaaE = parcelRequire("koaaE");

var $dH1Sa = parcelRequire("dH1Sa");
const $c2ce7dc01e8ddd1e$var$ALLOWED_VIEW_KINDS = [
    (0, $dH1Sa.VIEW_KIND_TABLE),
    (0, $dH1Sa.VIEW_KIND_BOARD),
    (0, $dH1Sa.VIEW_KIND_TIMELINE)
];
const $c2ce7dc01e8ddd1e$export$7210851e4cc7cf42 = (t0)=>{
    const $ = (0, $e7boj.c)(5);
    const { isGlobalView: isGlobalView, viewKind: viewKind } = t0;
    const isAdmin = (0, $3NopQ.useIsAdmin)();
    const canManageViews = (0, $koaaE.useCanManageViews)();
    if (!viewKind) return false;
    let t1;
    if ($[0] !== canManageViews || $[1] !== isAdmin || $[2] !== isGlobalView || $[3] !== viewKind) {
        t1 = !isGlobalView && $c2ce7dc01e8ddd1e$var$ALLOWED_VIEW_KINDS.includes(viewKind) && canManageViews && isAdmin;
        $[0] = canManageViews;
        $[1] = isAdmin;
        $[2] = isGlobalView;
        $[3] = viewKind;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};

});

parcelRegister("eq7Ww", function(module, exports) {
$parcel$export(module.exports, "useCloneViewIntoGlobal", () => $0eddb98d708c8842$export$867451dd4fa0f74f);

var $e7boj = parcelRequire("e7boj");

var $jkfqG = parcelRequire("jkfqG");

var $n67Vb = parcelRequire("n67Vb");

var $hFtK7 = parcelRequire("hFtK7");

var $26fxr = parcelRequire("26fxr");

var $ilJa3 = parcelRequire("ilJa3");

var $2h3cC = parcelRequire("2h3cC");

var $kt86l = parcelRequire("kt86l");

var $h3LJR = parcelRequire("h3LJR");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $0eddb98d708c8842$var$failureTitleMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-ideas.view-header.clone-view-into-global.error-title",
    defaultMessage: "We couldn't save as global view"
});
const $0eddb98d708c8842$var$savingTitleMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-ideas.view-header.clone-view-into-global.saving-title",
    defaultMessage: "Saving view as global..."
});
const $0eddb98d708c8842$var$successTitleMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-ideas.view-header.clone-view-into-global.success-title",
    defaultMessage: "Saved as a global view"
});
const $0eddb98d708c8842$export$867451dd4fa0f74f = ()=>{
    const $ = (0, $e7boj.c)(8);
    const { error: showError, customFlag: customFlag, success: showSuccess } = (0, $26fxr.useNotifications)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const [commitClone] = (0, $n67Vb.useMutation)((0, $jkfqG.default));
    let t0;
    if ($[0] !== activationId || $[1] !== cloudId || $[2] !== commitClone || $[3] !== customFlag || $[4] !== formatMessage || $[5] !== showError || $[6] !== showSuccess) {
        t0 = (viewUUID)=>{
            const viewAri = (0, $ilJa3.JiraProductDiscoveryViewAri).create({
                siteId: cloudId,
                viewId: viewUUID,
                activationId: activationId
            }).toString();
            const dismissSavingFlag = customFlag({
                title: formatMessage($0eddb98d708c8842$var$savingTitleMessage)
            });
            commitClone({
                variables: {
                    input: {
                        id: viewAri
                    }
                },
                onCompleted: (data)=>{
                    const payload = data.jpdViewsService_cloneViewIntoGlobal;
                    if (!payload?.success) {
                        (0, $hFtK7.fireErrorAnalytics)({
                            error: new Error("cloneViewIntoGlobal mutation returned success=false"),
                            meta: {
                                id: "cloneViewIntoGlobal",
                                packageName: "polaris-component-clone-view-into-global",
                                teamName: "jpd-aurora"
                            }
                        });
                        showError({
                            title: formatMessage($0eddb98d708c8842$var$failureTitleMessage)
                        });
                        return;
                    }
                    const globalViewAri = payload?.node?.id;
                    if (globalViewAri) {
                        const globalViewId = (0, $2h3cC.JiraProductDiscoveryGlobalViewAri).parse(globalViewAri).globalViewId;
                        dismissSavingFlag();
                        showSuccess({
                            title: formatMessage($0eddb98d708c8842$var$successTitleMessage)
                        });
                        globalThis.window?.open(`/jira/settings/products/jira-product-discovery/global-views/${globalViewId}`, "_blank");
                    }
                },
                onError: (err)=>{
                    dismissSavingFlag();
                    (0, $hFtK7.fireErrorAnalytics)({
                        error: err,
                        meta: {
                            id: "cloneViewIntoGlobal",
                            packageName: "polaris-component-clone-view-into-global",
                            teamName: "jpd-aurora"
                        }
                    });
                    showError({
                        title: formatMessage($0eddb98d708c8842$var$failureTitleMessage)
                    });
                }
            });
        };
        $[0] = activationId;
        $[1] = cloudId;
        $[2] = commitClone;
        $[3] = customFlag;
        $[4] = formatMessage;
        $[5] = showError;
        $[6] = showSuccess;
        $[7] = t0;
    } else t0 = $[7];
    return t0;
};

});
parcelRegister("jkfqG", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a7e318803459087$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<407e18d01feaa184db4e9776f47e84e3>>
 * @relayHash f1f6274b2752eb7f782581ae11d3b43d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c3c716f0215952ef99d253a24485c8deaf08ed910bf26cabf38298272874c7c8
const $6a7e318803459087$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "JpdViewsServiceCreateGlobalViewPayload2",
            "kind": "LinkedField",
            "name": "jpdViewsService_cloneViewIntoGlobal",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "JpdViewsServiceGlobalView2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCloneViewIntoGlobalMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCloneViewIntoGlobalMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "c3c716f0215952ef99d253a24485c8deaf08ed910bf26cabf38298272874c7c8",
            "metadata": {},
            "name": "useCloneViewIntoGlobalMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$6a7e318803459087$var$node.hash = "e860d9d439dda8eb121e8833ee8d2f89";
var $6a7e318803459087$export$2e2bcd8739ae039 = $6a7e318803459087$var$node;

});

parcelRegister("ilJa3", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryViewAri", () => $d5bd3834f0ca89e1$export$29924e20cd47a677);

var $aoH3S = parcelRequire("aoH3S");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira-product-discovery/view/manifest.ts
var $d5bd3834f0ca89e1$var$jiraProductDiscoveryViewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $aoH3S.JiraProductDiscoveryViewAriResourceOwner),
    resourceType: (0, $aoH3S.JiraProductDiscoveryViewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{viewId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        viewId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-7][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira-product-discovery/view/index.ts
var $d5bd3834f0ca89e1$export$29924e20cd47a677 = class _JiraProductDiscoveryViewAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._viewId = opts.resourceIdSegmentValues.viewId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get viewId() {
        return this._viewId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d5bd3834f0ca89e1$var$jiraProductDiscoveryViewAriStaticOpts.qualifier,
            platformQualifier: $d5bd3834f0ca89e1$var$jiraProductDiscoveryViewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d5bd3834f0ca89e1$var$jiraProductDiscoveryViewAriStaticOpts.resourceOwner,
            resourceType: $d5bd3834f0ca89e1$var$jiraProductDiscoveryViewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.viewId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                viewId: opts.viewId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $d5bd3834f0ca89e1$var$jiraProductDiscoveryViewAriStaticOpts);
        return new _JiraProductDiscoveryViewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $d5bd3834f0ca89e1$var$jiraProductDiscoveryViewAriStaticOpts);
        return new _JiraProductDiscoveryViewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            viewId: this.viewId
        };
    }
};

});
parcelRegister("aoH3S", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryViewAriResourceOwner", () => $791d8c64efd46d49$export$94d713ba5b2c6232);
$parcel$export(module.exports, "JiraProductDiscoveryViewAriResourceType", () => $791d8c64efd46d49$export$aeab97f8e0e098d0);
// src/jira-product-discovery/view/types.ts
var $791d8c64efd46d49$export$94d713ba5b2c6232 = "jira-product-discovery", $791d8c64efd46d49$export$aeab97f8e0e098d0 = "view";

});


parcelRegister("2h3cC", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryGlobalViewAri", () => $1a7fa7422a31136f$export$379cf2b59a640757);

var $jKzz8 = parcelRequire("jKzz8");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira-product-discovery/global-view/manifest.ts
var $1a7fa7422a31136f$var$jiraProductDiscoveryGlobalViewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jKzz8.JiraProductDiscoveryGlobalViewAriResourceOwner),
    resourceType: (0, $jKzz8.JiraProductDiscoveryGlobalViewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{globalViewId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        globalViewId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-7][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira-product-discovery/global-view/index.ts
var $1a7fa7422a31136f$export$379cf2b59a640757 = class _JiraProductDiscoveryGlobalViewAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._globalViewId = opts.resourceIdSegmentValues.globalViewId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get globalViewId() {
        return this._globalViewId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1a7fa7422a31136f$var$jiraProductDiscoveryGlobalViewAriStaticOpts.qualifier,
            platformQualifier: $1a7fa7422a31136f$var$jiraProductDiscoveryGlobalViewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $1a7fa7422a31136f$var$jiraProductDiscoveryGlobalViewAriStaticOpts.resourceOwner,
            resourceType: $1a7fa7422a31136f$var$jiraProductDiscoveryGlobalViewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.globalViewId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                globalViewId: opts.globalViewId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $1a7fa7422a31136f$var$jiraProductDiscoveryGlobalViewAriStaticOpts);
        return new _JiraProductDiscoveryGlobalViewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $1a7fa7422a31136f$var$jiraProductDiscoveryGlobalViewAriStaticOpts);
        return new _JiraProductDiscoveryGlobalViewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            globalViewId: this.globalViewId
        };
    }
};

});
parcelRegister("jKzz8", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryGlobalViewAriResourceOwner", () => $e60de6d1dca398f0$export$576447f33a3db158);
$parcel$export(module.exports, "JiraProductDiscoveryGlobalViewAriResourceType", () => $e60de6d1dca398f0$export$8e754361372a5363);
// src/jira-product-discovery/global-view/types.ts
var $e60de6d1dca398f0$export$576447f33a3db158 = "jira-product-discovery", $e60de6d1dca398f0$export$8e754361372a5363 = "global-view";

});



/* eslint-disable jira/filename-case */ const $5728d78b7c955d95$export$6336d3fe097afb34 = 'cloneView';
const $5728d78b7c955d95$export$ae8de54ba670dece = 'createView';
const $5728d78b7c955d95$export$e42bb9e4ae8f6958 = 'deleteView';
const $5728d78b7c955d95$export$2760493571fa6f99 = 'editGlobalView';
const $5728d78b7c955d95$export$5a199ff4838c2d44 = 'renameView';
const $5728d78b7c955d95$export$988c6ce277d2a6d4 = 'removeEmoji';

parcelRegister("bcDCd", function(module, exports) {
$parcel$export(module.exports, "DeleteModal", () => $37f926f965210d01$export$73392e09138fecd6);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $k6sZT = parcelRequire("k6sZT");

var $iOfms = parcelRequire("iOfms");

var $2v3yi = parcelRequire("2v3yi");

var $4vluQ = parcelRequire("4vluQ");

var $gpyJM = parcelRequire("gpyJM");

var $dNPnD = parcelRequire("dNPnD");

var $9imxF = parcelRequire("9imxF");

var $8Sdzy = parcelRequire("8Sdzy");

var $DIqjH = parcelRequire("DIqjH");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $37f926f965210d01$var$deleteMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.delete-modal.delete",
    defaultMessage: "Delete"
});
const $37f926f965210d01$var$cancel = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.delete-modal.cancel",
    defaultMessage: "Cancel"
});
const $37f926f965210d01$var$deleteHeader = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.delete-modal.delete-header",
    defaultMessage: "Delete \"{title}\" ?"
});
const $37f926f965210d01$var$description = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.delete-modal.description",
    defaultMessage: "This deletes {title}. This action cannot be undone."
});
const $37f926f965210d01$export$73392e09138fecd6 = (props)=>{
    const { isOpen: isOpen, title: title, onCancel: onCancel, onConfirm: onConfirm } = props;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const focusRef = (0, $euxye.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9imxF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k6sZT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $DIqjH.JiraModal), {
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.delete-modal.modal-dialog",
        messageType: "transactional",
        autoFocus: focusRef,
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gpyJM.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dNPnD.default), {
        appearance: "danger"
    }, formatMessage($37f926f965210d01$var$deleteHeader, {
        title: title
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v3yi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, formatMessage($37f926f965210d01$var$description, {
        title: title
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4vluQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
        onClick: onCancel,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.delete-modal.cancel"
    }, formatMessage($37f926f965210d01$var$cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
        appearance: "danger",
        onClick: onConfirm,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.delete-modal.delete",
        ref: focusRef
    }, formatMessage($37f926f965210d01$var$deleteMessage))))));
};
$37f926f965210d01$export$73392e09138fecd6.displayName = "DeleteModal";

});

parcelRegister("hVs7r", function(module, exports) {
$parcel$export(module.exports, "HardLimitsTooltip", () => $844c83cc943f9d82$export$fcd8df0def83ed6d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3kW31 = parcelRequire("3kW31");

var $fsonl = parcelRequire("fsonl");

var $bEJQw = parcelRequire("bEJQw");
const $844c83cc943f9d82$var$ActionItemTooltip = ({ children: children, entityLimitMessage: entityLimitMessage })=>{
    if (entityLimitMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEJQw.CreateEntityLimitTooltip), {
        message: entityLimitMessage
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
};
$844c83cc943f9d82$var$ActionItemTooltip.displayName = "ActionItemTooltip";
const $844c83cc943f9d82$export$fcd8df0def83ed6d = ({ containerId: containerId, entityLimitType: entityLimitType, children: children })=>{
    const limitValue = (0, $3kW31.useHasReachedViewsLimit)({
        containerId: containerId,
        entityLimitType: entityLimitType
    });
    const getEntityLimitMessage = (0, $fsonl.useEntityLimitMessage)();
    const isLimitReached = limitValue !== null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($844c83cc943f9d82$var$ActionItemTooltip, {
        entityLimitMessage: limitValue && getEntityLimitMessage(entityLimitType, limitValue)
    }, children({
        isLimitReached: isLimitReached
    }));
};
$844c83cc943f9d82$export$fcd8df0def83ed6d.displayName = "HardLimitsTooltip";

});
parcelRegister("bEJQw", function(module, exports) {
$parcel$export(module.exports, "CreateEntityLimitTooltip", () => $37d198ad5b900864$export$ecfe1531bb6e9250);
/* CreateEntityLimitTooltip.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $2iotI = parcelRequire("2iotI");

var $8QmUu = parcelRequire("8QmUu");

var $ihEDU = parcelRequire("ihEDU");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $hZDXn = parcelRequire("hZDXn");

var $8qjTI = parcelRequire("8qjTI");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $37d198ad5b900864$var$title = (0, $7eNDO.defineMessage)({
    id: "polaris-component-limits.title",
    defaultMessage: "Unavailable"
});
const $37d198ad5b900864$var$styles = {
    textContainer: "_11c8fhey _bfhkvuon _ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb _syazi7uo",
    tooltip: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko1qi0 _1reo15vq _18m915vq _16qs130s _1bsbnklw"
};
const $37d198ad5b900864$export$b42f1a3500af6e7b = ({ message: message })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $37d198ad5b900864$var$styles.textContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8QmUu))), {
        spacing: "spacious",
        label: formatMessage($37d198ad5b900864$var$title)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "xsmall"
    }, formatMessage($37d198ad5b900864$var$title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.Inline), {
        space: "space.100"
    }, message)));
};
$37d198ad5b900864$export$b42f1a3500af6e7b.displayName = "CreateEntityLimitTooltipContent";
const $37d198ad5b900864$export$ecfe1531bb6e9250 = ({ children: children, message: message })=>{
    if (!message) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        position: "right",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($37d198ad5b900864$export$b42f1a3500af6e7b, {
            message: message
        }),
        component: $37d198ad5b900864$var$TooltipComponent
    }, children);
};
$37d198ad5b900864$export$ecfe1531bb6e9250.displayName = "CreateEntityLimitTooltip";
const $37d198ad5b900864$var$TooltipComponent = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, className: className, ...rest }, ref)=>{
    // https://atlassian.design/components/tooltip/examples#customizing-tooltip
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8qjTI.default), {
        ...rest,
        className: (0, $4jQY2.default)([
            $37d198ad5b900864$var$styles.tooltip,
            className
        ]),
        ref: ref
    }, children);
});

});




parcelRegister("8BknK", function(module, exports) {
$parcel$export(module.exports, "CreateViewMenuItem", () => $c718f9bcd8707caf$export$13d1301a5a5e71c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $dH1Sa = parcelRequire("dH1Sa");

var $gvtNj = parcelRequire("gvtNj");

var $3kW31 = parcelRequire("3kW31");

var $kmMHr = parcelRequire("kmMHr");

var $9jJKJ = parcelRequire("9jJKJ");

var $ikOED = parcelRequire("ikOED");

var $1Io8b = parcelRequire("1Io8b");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $eQCsj = parcelRequire("eQCsj");

var $hj9Qm = parcelRequire("hj9Qm");

var $d8n9z = parcelRequire("d8n9z");
const $c718f9bcd8707caf$var$createView = (0, $7eNDO.defineMessage)({
    defaultMessage: "Create a view",
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.create-view.create-view"
});
const $c718f9bcd8707caf$export$13d1301a5a5e71c = ({ container: container, sectionId: sectionId, navigationContainer: navigationContainer, enableSpotlight: enableSpotlight = false })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const containerId = (0, $hj9Qm.useContainerId)();
    const [isNavigationLocked] = (0, $3kW31.useIsNavigationLocked)({
        containerId: containerId
    });
    const canManageViews = (0, $hj9Qm.useJpdNavCanManageViews)();
    const { sendCreateViewOnViewNavigationItemAnalyticsEvent: sendCreateViewOnViewNavigationItemAnalyticsEvent } = (0, $hj9Qm.useAnalyticsL2)();
    const { createView: createViewAction } = (0, $kmMHr.useNavigationActions)();
    const { setTreeViewOnboardingSpotlightDismissed: setTreeViewOnboardingSpotlightDismissed } = (0, $gvtNj.useOnboardingFlowsActions)();
    const handleAnalyticsEvent = (0, $euxye.useCallback)(()=>{
        sendCreateViewOnViewNavigationItemAnalyticsEvent(navigationContainer);
    }, [
        navigationContainer,
        sendCreateViewOnViewNavigationItemAnalyticsEvent
    ]);
    const handleCreateTreeView = (0, $euxye.useCallback)(()=>{
        // Directly create a tree view used by the spotlight "Create" button
        createViewAction((0, $dH1Sa.VIEW_KIND_TREE), container);
        handleAnalyticsEvent();
    }, [
        createViewAction,
        container,
        handleAnalyticsEvent
    ]);
    const handleMenuItemClick = (0, $euxye.useCallback)(({ type: type })=>{
        // Dismiss the onboarding spotlight if the user creates a tree view via the dropdown
        if (type === (0, $dH1Sa.VIEW_KIND_TREE)) setTreeViewOnboardingSpotlightDismissed();
    }, [
        setTreeViewOnboardingSpotlightDismissed
    ]);
    const renderTrigger = (0, $euxye.useCallback)(({ onClick: onClick, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1Io8b.ButtonMenuItem), {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.menu-items.views.create-view.menu-button-item",
            ...rest,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ikOED))), {
                label: (0, $i860n.fg)('jpd_a11y_decorative_icons') ? '' : formatMessage($c718f9bcd8707caf$var$createView),
                color: "currentColor",
                size: "small"
            }),
            isDisabled: isNavigationLocked || !canManageViews,
            onClick: ()=>{
                onClick();
                handleAnalyticsEvent();
            }
        }, formatMessage($c718f9bcd8707caf$var$createView)), [
        canManageViews,
        formatMessage,
        handleAnalyticsEvent,
        isNavigationLocked
    ]);
    if (enableSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9jJKJ.TreeViewOnboardingSpotlight), {
        isNonProjectContainer: !(0, $d8n9z.isNavigationProject)(navigationContainer),
        onCreateTreeView: handleCreateTreeView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eQCsj.CreateViewMenu), {
        navigationContainer: navigationContainer,
        container: container,
        sectionId: sectionId,
        renderTrigger: renderTrigger,
        onMenuItemClick: handleMenuItemClick
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eQCsj.CreateViewMenu), {
        navigationContainer: navigationContainer,
        container: container,
        sectionId: sectionId,
        renderTrigger: renderTrigger,
        onMenuItemClick: handleMenuItemClick
    });
};
$c718f9bcd8707caf$export$13d1301a5a5e71c.displayName = "CreateViewMenuItem";

});
parcelRegister("9jJKJ", function(module, exports) {
$parcel$export(module.exports, "TreeViewOnboardingSpotlight", () => $5db9110134e2be5c$export$b613c689dd57a368);
/* TreeViewOnboardingSpotlight.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/choreographer/message-id-by-folder-structure */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $jepRN = parcelRequire("jepRN");

var $7De3l = parcelRequire("7De3l");

var $1n6C5 = parcelRequire("1n6C5");

var $2zpkm = parcelRequire("2zpkm");

var $4C7HL = parcelRequire("4C7HL");

var $g5ruf = parcelRequire("g5ruf");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");

var $hYI7R = parcelRequire("hYI7R");

var $gA92M = parcelRequire("gA92M");

var $cCkCp = parcelRequire("cCkCp");

var $gvtNj = parcelRequire("gvtNj");

var $3jZnY = parcelRequire("3jZnY");

var $eYbIq = parcelRequire("eYbIq");

var $bKvDL = parcelRequire("bKvDL");
const $5db9110134e2be5c$var$styles = {
    pulseOutline: "_kqswh2mm _1pbykb7n _1qu2nqa1 _12y31dm9 _12ji1aqn _1cwgze3t"
};
const $5db9110134e2be5c$var$spotlightHeading = (0, $7eNDO.defineMessage)({
    id: "polaris.lib-onboarding-flows.tree-view-onboarding.spotlights.heading",
    defaultMessage: "Explore the new Tree view"
});
const $5db9110134e2be5c$var$spotlightDescription = (0, $7eNDO.defineMessage)({
    id: "polaris.lib-onboarding-flows.tree-view-onboarding.spotlights.description",
    defaultMessage: "Connect customer problems to solutions and experiments in a visual hierarchy."
});
const $5db9110134e2be5c$var$spotlightCreateButton = (0, $7eNDO.defineMessage)({
    id: "polaris.lib-onboarding-flows.tree-view-onboarding.spotlights.create",
    defaultMessage: "Create"
});
const $5db9110134e2be5c$var$spotlightNotNowButton = (0, $7eNDO.defineMessage)({
    id: "polaris.lib-onboarding-flows.tree-view-onboarding.spotlights.not-now",
    defaultMessage: "Not now"
});
const $5db9110134e2be5c$var$TreeViewOnboardingSpotlightOld = ({ children: children, isNonProjectContainer: isNonProjectContainer, onCreateTreeView: onCreateTreeView })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { colorMode: colorMode } = (0, $4C7HL.default)();
    const treeViewOnboardingImage = colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($2zpkm))) : (0, (/*@__PURE__*/$parcel$interopDefault($1n6C5)));
    const isTreeViewEnabled = (0, $7De3l.useIsTreeViewEnabled)();
    const canHaveSpotlight = !isNonProjectContainer && isTreeViewEnabled && (0, $i860n.fg)('jpd_tree-view'); // Tracks whether the pulse outline should be hidden for this session.
    // Set by spotlight buttons (persisted) or X/outside-click (session-only).
    const [isLocallyDismissed, setIsLocallyDismissed] = (0, $euxye.useState)(false);
    const isSpotlightDismissed = (0, $3jZnY.useTreeViewOnboardingSpotlightDismissed)();
    const { loadTreeViewOnboardingSpotlightDismissed: loadTreeViewOnboardingSpotlightDismissed, setTreeViewOnboardingSpotlightDismissed: setTreeViewOnboardingSpotlightDismissed } = (0, $gvtNj.useOnboardingFlowsActions)();
    (0, $hYI7R.useEffectWithoutConcurrency)(()=>{
        if (!canHaveSpotlight) return;
        loadTreeViewOnboardingSpotlightDismissed();
    }, [
        loadTreeViewOnboardingSpotlightDismissed,
        canHaveSpotlight
    ]);
    const handleCreate = (0, $euxye.useCallback)((_event, analyticsEvent)=>{
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'treeViewOnboardingSpotlightCreate');
        setIsLocallyDismissed(true);
        setTreeViewOnboardingSpotlightDismissed();
        onCreateTreeView?.();
    }, [
        setTreeViewOnboardingSpotlightDismissed,
        onCreateTreeView
    ]);
    const handleDismiss = (0, $euxye.useCallback)((_event, analyticsEvent)=>{
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'treeViewOnboardingSpotlightDismiss');
        setIsLocallyDismissed(true);
        setTreeViewOnboardingSpotlightDismissed();
    }, [
        setTreeViewOnboardingSpotlightDismissed
    ]);
    const handleSpotlightDismiss = (0, $euxye.useCallback)(()=>{
        setIsLocallyDismissed(true);
        setTreeViewOnboardingSpotlightDismissed();
    }, [
        setTreeViewOnboardingSpotlightDismissed
    ]);
    const actions = (0, $euxye.useMemo)(()=>[
            {
                onClick: handleCreate,
                text: formatMessage($5db9110134e2be5c$var$spotlightCreateButton),
                ctaType: 'primary',
                testId: 'polaris.lib-onboarding-flows.tree-view-onboarding.spotlights.create-button'
            },
            {
                onClick: handleDismiss,
                text: formatMessage($5db9110134e2be5c$var$spotlightNotNowButton),
                ctaType: 'secondary',
                appearance: 'subtle',
                testId: 'polaris.lib-onboarding-flows.tree-view-onboarding.spotlights.dismiss-button'
            }
        ], [
        handleCreate,
        handleDismiss,
        formatMessage
    ]); // Don't show the spotlight if gate is off, non-project container, or dismissed (or not yet loaded)
    const shouldShowSpotlight = canHaveSpotlight && isSpotlightDismissed === false;
    if (!shouldShowSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gA92M.SpotlightTarget), {
        name: (0, $eYbIq.TREE_VIEW_ONBOARDING_SPOTLIGHT),
        isFullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            !isLocallyDismissed && $5db9110134e2be5c$var$styles.pulseOutline
        ])
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g5ruf.JiraSpotlight), {
        actions: actions,
        image: treeViewOnboardingImage,
        dialogPlacement: "right bottom",
        dialogWidth: 275,
        target: (0, $eYbIq.TREE_VIEW_ONBOARDING_SPOTLIGHT),
        heading: formatMessage($5db9110134e2be5c$var$spotlightHeading),
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        key: (0, $eYbIq.TREE_VIEW_ONBOARDING_SPOTLIGHT),
        messageId: "lib-onboarding-flows.ui.tree-view-onboarding.spotlights.jira-spotlight",
        messageType: "engagement",
        testId: "lib-onboarding-flows.ui.tree-view-onboarding.spotlights.spotlights",
        isMigrated: true,
        onDismiss: handleSpotlightDismiss
    }, formatMessage($5db9110134e2be5c$var$spotlightDescription)));
};
$5db9110134e2be5c$var$TreeViewOnboardingSpotlightOld.displayName = "TreeViewOnboardingSpotlightOld";
const $5db9110134e2be5c$var$TreeViewOnboardingSpotlightNew = ({ children: children, isNonProjectContainer: isNonProjectContainer, onCreateTreeView: onCreateTreeView })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { colorMode: colorMode } = (0, $4C7HL.default)();
    const treeViewOnboardingImage = colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($2zpkm))) : (0, (/*@__PURE__*/$parcel$interopDefault($1n6C5)));
    const isTreeViewEnabled = (0, $7De3l.useIsTreeViewEnabled)();
    const { dismiss: dismiss, renderJiraSpotlight: renderJiraSpotlight } = (0, $bKvDL.usePolarisHeadlessSpotlightMessage)({
        placementId: (0, $cCkCp.PO_HEADLESS_PLACEMENT_ID),
        messageTemplateId: (0, $cCkCp.PO_HEADLESS_MESSAGE_TEMPLATE_ID),
        featureId: (0, $cCkCp.OnboardingSpotlightFeatureIds).TREE_VIEW_CREATE_MENU,
        clickIdentifiers: {
            dismiss: 'not-now',
            primary: 'create'
        }
    });
    const canHaveSpotlight = !isNonProjectContainer && isTreeViewEnabled && (0, $i860n.fg)('jpd_tree-view');
    const [isLocallyDismissed, setIsLocallyDismissed] = (0, $euxye.useState)(false);
    const handleCreate = (0, $euxye.useCallback)((_event, analyticsEvent)=>{
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'treeViewOnboardingSpotlightCreate');
        setIsLocallyDismissed(true);
        dismiss('primary');
        onCreateTreeView?.();
    }, [
        dismiss,
        onCreateTreeView
    ]);
    const handleDismiss = (0, $euxye.useCallback)((_event, analyticsEvent)=>{
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'treeViewOnboardingSpotlightDismiss');
        setIsLocallyDismissed(true);
        dismiss('dismiss');
    }, [
        dismiss
    ]);
    const handleSpotlightDismiss = (0, $euxye.useCallback)(()=>{
        setIsLocallyDismissed(true);
        dismiss('dismiss');
    }, [
        dismiss
    ]);
    const actions = (0, $euxye.useMemo)(()=>[
            {
                onClick: handleCreate,
                text: formatMessage($5db9110134e2be5c$var$spotlightCreateButton),
                ctaType: 'primary',
                testId: 'polaris.lib-onboarding-flows.tree-view-onboarding.spotlights.create-button'
            },
            {
                onClick: handleDismiss,
                text: formatMessage($5db9110134e2be5c$var$spotlightNotNowButton),
                ctaType: 'secondary',
                appearance: 'subtle',
                testId: 'polaris.lib-onboarding-flows.tree-view-onboarding.spotlights.dismiss-button'
            }
        ], [
        handleCreate,
        handleDismiss,
        formatMessage
    ]);
    const spotlightContent = renderJiraSpotlight({
        actions: actions,
        image: treeViewOnboardingImage,
        dialogPlacement: 'right bottom',
        target: (0, $eYbIq.TREE_VIEW_ONBOARDING_SPOTLIGHT),
        heading: formatMessage($5db9110134e2be5c$var$spotlightHeading),
        testId: 'lib-onboarding-flows.ui.tree-view-onboarding.spotlights.spotlights',
        isMigrated: true,
        isVisible: canHaveSpotlight,
        onDismiss: handleSpotlightDismiss,
        children: formatMessage($5db9110134e2be5c$var$spotlightDescription),
        fallbackMessageId: (0, $cCkCp.PO_HEADLESS_MESSAGE_TEMPLATE_ID)
    });
    if (!spotlightContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gA92M.SpotlightTarget), {
        name: (0, $eYbIq.TREE_VIEW_ONBOARDING_SPOTLIGHT),
        isFullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            !isLocallyDismissed && $5db9110134e2be5c$var$styles.pulseOutline
        ])
    }, children)), spotlightContent);
};
$5db9110134e2be5c$var$TreeViewOnboardingSpotlightNew.displayName = "TreeViewOnboardingSpotlightNew";
const $5db9110134e2be5c$export$b613c689dd57a368 = (0, $jepRN.componentWithFG)('post-office_jpd-juno_headless-spotlights-migration', $5db9110134e2be5c$var$TreeViewOnboardingSpotlightNew, $5db9110134e2be5c$var$TreeViewOnboardingSpotlightOld);

});
parcelRegister("3jZnY", function(module, exports) {
$parcel$export(module.exports, "useTreeViewOnboardingSpotlightDismissed", () => $21e4f8348c6704f0$export$5e60a5cc6794dc06);

var $a7e1f = parcelRequire("a7e1f");

var $gvtNj = parcelRequire("gvtNj");
const $21e4f8348c6704f0$var$getTreeViewOnboarding = (state)=>state.treeViewOnboarding;
const $21e4f8348c6704f0$export$4737b2d6f22f69d0 = (0, $a7e1f.createSelector)($21e4f8348c6704f0$var$getTreeViewOnboarding, (treeViewOnboarding)=>treeViewOnboarding.spotlightDismissed);
const $21e4f8348c6704f0$export$5e60a5cc6794dc06 = (0, $gvtNj.createHook)($21e4f8348c6704f0$export$4737b2d6f22f69d0);

});



parcelRegister("BhWi0", function(module, exports) {
$parcel$export(module.exports, "TreeItemParentContainer", () => $fbf20d751473aa53$export$7a564648fd532271);
$parcel$export(module.exports, "TreeItemContainer", () => $fbf20d751473aa53$export$fdd539286ad0c116);
$parcel$export(module.exports, "TreeItemHead", () => $fbf20d751473aa53$export$a21730969c359fa3);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $klGx5 = parcelRequire("klGx5");

var $ar9gx = parcelRequire("ar9gx");

var $6hKmX = parcelRequire("6hKmX");
const $fbf20d751473aa53$export$7a564648fd532271 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, role: role }, ref)=>{
    if (role === 'group') return(// oxlint-disable-next-line typescript/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), {
        ref: ref
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
});
const $fbf20d751473aa53$export$fdd539286ad0c116 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, item: item }, ref)=>{
    if (item.data?.type === 'placeholder') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
    if (item.hasChildren) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        ref: ref,
        "data-expand-state": item.isExpanded ? 'expanded' : 'collapsed',
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.menu-items.views.tree-wrapper.viewset-container-item",
        xcss: $fbf20d751473aa53$var$positionRelative
    }, children)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), {
        // oxlint-disable-next-line typescript/consistent-type-assertions
        ref: ref
    }, children));
});
const $fbf20d751473aa53$export$a21730969c359fa3 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, item: item }, ref)=>{
    if (item.data?.type === 'placeholder') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
    if (item.hasChildren) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.menu-items.views.tree-wrapper.viewset-item",
        "data-component-selector": "navigation-section-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6hKmX.DraggableRefContext).Provider, {
        value: ref
    }, children)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        testId: `navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.menu-items.views.view-item-${item.data?.view?.polarisId}`,
        "data-component-selector": "navigation-view-item",
        xcss: $fbf20d751473aa53$var$positionRelative
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6hKmX.DraggableRefContext).Provider, {
        value: ref
    }, children)));
});
const $fbf20d751473aa53$var$positionRelative = (0, $fbAgj.xcss)({
    position: 'relative'
});

});

parcelRegister("fzLeF", function(module, exports) {
$parcel$export(module.exports, "ViewSet", () => $7ef246b4fada1895$export$453bf14beb623ee6);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $kmMHr = parcelRequire("kmMHr");

var $3kW31 = parcelRequire("3kW31");

var $ld25x = parcelRequire("ld25x");

var $dUPUc = parcelRequire("dUPUc");

var $1Io8b = parcelRequire("1Io8b");

var $ar9gx = parcelRequire("ar9gx");

var $djYhH = parcelRequire("djYhH");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $20PTK = parcelRequire("20PTK");

var $5lCvX = parcelRequire("5lCvX");

var $itiPA = parcelRequire("itiPA");

var $6hKmX = parcelRequire("6hKmX");

var $hj9Qm = parcelRequire("hj9Qm");

var $g84uT = parcelRequire("g84uT");
const $7ef246b4fada1895$var$defaultTitle = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.default-title",
    defaultMessage: "Untitled Section"
});
const $7ef246b4fada1895$var$nameLabel = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.rename-label",
    defaultMessage: "View name"
});
const $7ef246b4fada1895$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($ld25x))) : (0, (/*@__PURE__*/$parcel$interopDefault($dUPUc)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ChevronIcon, {
        ...iconProps,
        label: isExpanded ? 'Collapse' : 'Expand',
        size: "small"
    });
};
$7ef246b4fada1895$var$ExpandableMenuItemIcon.displayName = "ExpandableMenuItemIcon";
const $7ef246b4fada1895$export$453bf14beb623ee6 = ({ isDraggingPreview: isDraggingPreview, localId: localId, navigationContainer: navigationContainer, isExpanded: isExpanded, isReadOnly: isReadOnly, onToggle: onToggle })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const containerId = (0, $hj9Qm.useContainerId)();
    const [view] = (0, $3kW31.useNavigationView)({
        localId: localId,
        containerId: containerId
    });
    const { sendViewNavigationItemInsideProjectsAnalyticsEvent: sendViewNavigationItemInsideProjectsAnalyticsEvent } = (0, $hj9Qm.useAnalyticsL2)();
    const { deleteViewSet: deleteViewSet, createViewSet: createViewSet, updateViewSet: updateViewSet, cancelViewSetRenaming: cancelViewSetRenaming } = (0, $kmMHr.useNavigationActions)();
    const isNew = view?.name === '';
    const draggableRef = (0, $euxye.useContext)((0, $6hKmX.DraggableRefContext));
    const handleTitleChanged = (0, $euxye.useCallback)((newTitle)=>{
        if (!view) return;
        if (isNew) createViewSet(view.localId, newTitle || formatMessage($7ef246b4fada1895$var$defaultTitle));
        else updateViewSet(view.localId, newTitle || formatMessage($7ef246b4fada1895$var$defaultTitle));
    }, [
        view,
        isNew,
        createViewSet,
        formatMessage,
        updateViewSet
    ]);
    const handleTitleChangeCanceled = (0, $euxye.useCallback)(()=>{
        if (!view) return;
        if (isNew) {
            deleteViewSet(view.localId);
            return;
        }
        cancelViewSetRenaming(view.localId);
    }, [
        view,
        isNew,
        cancelViewSetRenaming,
        deleteViewSet
    ]);
    const handleToggle = (0, $euxye.useCallback)(()=>{
        onToggle?.(localId);
        sendViewNavigationItemInsideProjectsAnalyticsEvent({
            container: navigationContainer,
            viewParams: {
                viewId: view?.id,
                viewKind: view?.viewType
            }
        });
    }, [
        onToggle,
        localId,
        sendViewNavigationItemInsideProjectsAnalyticsEvent,
        navigationContainer,
        view?.id,
        view?.viewType
    ]);
    const expandableElemBefore = (0, $euxye.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($7ef246b4fada1895$var$ExpandableMenuItemIcon, {
            "aria-expanded": isExpanded,
            isExpanded: isExpanded
        }), [
        isExpanded
    ]);
    if (!view) return;
    if (isNew) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5lCvX.EditableTitle), {
        label: formatMessage($7ef246b4fada1895$var$nameLabel),
        value: view.name,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $itiPA.ViewIcon), {
            viewKind: view.viewType
        }),
        onChanged: handleTitleChanged,
        onCancel: handleTitleChangeCanceled
    }));
    if (view.isRenaming) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ar9gx.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5lCvX.EditableTitle), {
        label: formatMessage($7ef246b4fada1895$var$nameLabel),
        value: view.name,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $itiPA.ViewIcon), {
            viewKind: view.viewType
        }),
        onChanged: handleTitleChanged,
        onCancel: handleTitleChangeCanceled
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $20PTK.WithDragPreview), {
        isEnabled: isDraggingPreview || false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1Io8b.ButtonMenuItem), {
        // oxlint-disable-next-line typescript/consistent-type-assertions
        ref: draggableRef,
        onClick: handleToggle,
        elemBefore: expandableElemBefore,
        actionsOnHover: !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g84uT.Menu), {
            view: view,
            navigationContainer: navigationContainer
        })
    }, view.name)));
};
$7ef246b4fada1895$export$453bf14beb623ee6.displayName = "ViewSet";

});
parcelRegister("g84uT", function(module, exports) {
$parcel$export(module.exports, "Menu", () => $88abc893580deaad$export$d9b273488cd8ce6f);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gbTMi = parcelRequire("gbTMi");

var $aGaXs = parcelRequire("aGaXs");

var $kmMHr = parcelRequire("kmMHr");

var $72ldR = parcelRequire("72ldR");

var $g36LP = parcelRequire("g36LP");

var $ceqcm = parcelRequire("ceqcm");

var $8Sdzy = parcelRequire("8Sdzy");

var $hZDXn = parcelRequire("hZDXn");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");


var $bcDCd = parcelRequire("bcDCd");

var $1I6IV = parcelRequire("1I6IV");

var $hj9Qm = parcelRequire("hj9Qm");
const $88abc893580deaad$var$renameAction = (0, $7eNDO.defineMessage)({
    defaultMessage: "Rename",
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.rename-action"
});
const $88abc893580deaad$var$deleteAction = (0, $7eNDO.defineMessage)({
    defaultMessage: "Delete",
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.delete-action"
});
const $88abc893580deaad$var$onDeleteTooltip = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.menu-items.views.viewset.menu.on-delete-tooltip",
    defaultMessage: "You can't delete a section that contains views. Please remove all views from this section to delete it"
});
const $88abc893580deaad$var$NavMenuItems = ({ onDelete: onDelete, onRename: onRename, viewsetContainsViews: viewsetContainsViews })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), {
        minWidth: 250
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        onClick: onRename
    }, formatMessage($88abc893580deaad$var$renameAction))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        content: viewsetContainsViews ? formatMessage($88abc893580deaad$var$onDeleteTooltip) : ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        onClick: onDelete,
        isDisabled: viewsetContainsViews
    }, viewsetContainsViews ? formatMessage($88abc893580deaad$var$deleteAction) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        color: "color.text.danger"
    }, formatMessage($88abc893580deaad$var$deleteAction))))));
};
$88abc893580deaad$var$NavMenuItems.displayName = "NavMenuItems";
const $88abc893580deaad$export$d9b273488cd8ce6f = ({ view: view, navigationContainer: navigationContainer })=>{
    const { deleteViewSet: deleteViewSet, renameViewSet: renameViewSet } = (0, $kmMHr.useNavigationActions)();
    const { sendMeatBallDropDownOnViewsMenuItemAnalyticsEvent: sendMeatBallDropDownOnViewsMenuItemAnalyticsEvent } = (0, $hj9Qm.useAnalyticsL4)();
    const { sendMeatBallDropDownOnViewsAnalyticsEvent: sendMeatBallDropDownOnViewsAnalyticsEvent } = (0, $hj9Qm.useAnalyticsL3)();
    const [isDeleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = (0, $euxye.useState)(false);
    const handleNavMenuOpen = (0, $euxye.useCallback)(()=>{
        sendMeatBallDropDownOnViewsAnalyticsEvent({
            container: navigationContainer,
            viewParams: {
                viewKind: view.viewType,
                viewId: view.id
            }
        });
    }, [
        navigationContainer,
        sendMeatBallDropDownOnViewsAnalyticsEvent,
        view.id,
        view.viewType
    ]);
    const viewsetContainsViews = Boolean(view.views?.length);
    const handleDelete = (0, $euxye.useCallback)(()=>{
        sendMeatBallDropDownOnViewsMenuItemAnalyticsEvent({
            itemId: (0, $5728d78b7c955d95$export$e42bb9e4ae8f6958),
            viewParams: {
                viewKind: view.viewType,
                viewId: view.id
            },
            container: navigationContainer
        });
        setDeleteConfirmationModalOpen(true);
    }, [
        navigationContainer,
        sendMeatBallDropDownOnViewsMenuItemAnalyticsEvent,
        view.id,
        view.viewType
    ]);
    const handleRename = (0, $euxye.useCallback)(()=>{
        sendMeatBallDropDownOnViewsMenuItemAnalyticsEvent({
            itemId: (0, $5728d78b7c955d95$export$5a199ff4838c2d44),
            viewParams: {
                viewKind: view.viewType,
                viewId: view.id
            },
            container: navigationContainer
        });
        renameViewSet(view.localId);
    }, [
        navigationContainer,
        renameViewSet,
        sendMeatBallDropDownOnViewsMenuItemAnalyticsEvent,
        view.id,
        view.localId,
        view.viewType
    ]);
    const MenuItems = (0, $euxye.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($88abc893580deaad$var$NavMenuItems, {
            onDelete: handleDelete,
            onRename: handleRename,
            viewsetContainsViews: viewsetContainsViews
        }), [
        handleDelete,
        handleRename,
        viewsetContainsViews
    ]);
    const handleDeleteModalCancel = (0, $euxye.useCallback)(()=>{
        setDeleteConfirmationModalOpen(false);
    }, []);
    const handleDeleteModalConfirm = (0, $euxye.useCallback)(()=>{
        setDeleteConfirmationModalOpen(false);
        deleteViewSet(view.localId);
    }, [
        deleteViewSet,
        view.localId
    ]);
    if ((0, $aGaXs.isFakeId)(view.id)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1I6IV.ActionButtonCreateView), {
        navigationContainer: navigationContainer,
        container: view.localId,
        sectionId: view.id
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
        onOpen: handleNavMenuOpen,
        MenuItems: MenuItems,
        name: view.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bcDCd.DeleteModal), {
        title: view.name,
        isOpen: isDeleteConfirmationModalOpen,
        onCancel: handleDeleteModalCancel,
        onConfirm: handleDeleteModalConfirm
    }));
};
$88abc893580deaad$export$d9b273488cd8ce6f.displayName = "Menu";

});







parcelRegister("c3zbo", function(module, exports) {
$parcel$export(module.exports, "RoadmapsEmptyContent", () => $3cec921a9f7f350c$export$cf926c860f507aa0);

var $euxye = parcelRequire("euxye");

var $biJuK = parcelRequire("biJuK");

var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $3cec921a9f7f350c$var$emptyMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-roadmaps.common.empty-content.no-roadmaps",
    defaultMessage: "Once you open or create roadmap, they'll show up here."
});
function $3cec921a9f7f350c$export$cf926c860f507aa0() {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $biJuK.EmptyContentMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage($3cec921a9f7f350c$var$emptyMessage)));
}
$3cec921a9f7f350c$export$cf926c860f507aa0.displayName = "RoadmapsEmptyContent";

});






parcelRegister("iXNX8", function(module, exports) {
$parcel$export(module.exports, "Starred", () => $26c6dd787be67573$export$8cd2a0520fb55072);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $gDdYI = parcelRequire("gDdYI");

var $4ey3V = parcelRequire("4ey3V");

var $KlPLa = parcelRequire("KlPLa");
const $26c6dd787be67573$export$8cd2a0520fb55072 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-starred"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "flag",
        id: "starred",
        packageName: (0, $4ey3V.PACKAGE_NAME),
        teamName: (0, $4ey3V.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $KlPLa.StarredFlyoutMenuItem), null)));
$26c6dd787be67573$export$8cd2a0520fb55072.displayName = "Starred";

});
parcelRegister("4ey3V", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $2a18550bc13b24e8$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $2a18550bc13b24e8$export$d57b6b390e78d90f);
$parcel$export(module.exports, "FAVOURITE_QUERY_LIMIT", () => $2a18550bc13b24e8$export$77881eca52f4f5a6);
$parcel$export(module.exports, "FAVORITE_TYPE_MAP", () => $2a18550bc13b24e8$export$c2849e00cccc2078);
$parcel$export(module.exports, "FAVORITE_TYPE_FILTER_MAP", () => $2a18550bc13b24e8$export$531e43cc63c1e036);
$parcel$export(module.exports, "VALID_FAVORITE_TYPES", () => $2a18550bc13b24e8$export$336e25f77ad481a9);
$parcel$export(module.exports, "FAVORITE_TYPE_FILTER_MESSAGE_WITH_PROJECT_TERM", () => $2a18550bc13b24e8$export$85266ed7d25f274d);
$parcel$export(module.exports, "FAVORITE_TYPE_FILTER_MESSAGE", () => $2a18550bc13b24e8$export$de9a288dad6f35f1);
$parcel$export(module.exports, "SEARCH_STARRED_ITEMS", () => $2a18550bc13b24e8$export$6b181848cd9c8308);
$parcel$export(module.exports, "FILTER", () => $2a18550bc13b24e8$export$c1c49903035a02df);
/* eslint-disable jira/filename-case */ 
var $7eNDO = parcelRequire("7eNDO");
const $2a18550bc13b24e8$var$projects = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-starred.common.projects",
    defaultMessage: "Projects"
});
const $2a18550bc13b24e8$var$filters = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-starred.common.filters",
    defaultMessage: "Filters"
});
const $2a18550bc13b24e8$var$dashboards = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-starred.common.dashboards",
    defaultMessage: "Dashboards"
});
const $2a18550bc13b24e8$var$plans = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-starred.common.plans",
    defaultMessage: "Plans"
});
const $2a18550bc13b24e8$var$boards = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-starred.common.boards",
    defaultMessage: "Boards"
});
const $2a18550bc13b24e8$var$queues = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-starred.common.queues",
    defaultMessage: "Queues"
});
const $2a18550bc13b24e8$var$all = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-starred.common.all",
    defaultMessage: "All"
});
const $2a18550bc13b24e8$var$projectsGalaxia = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-starred.common.projects-galaxia",
    defaultMessage: "Spaces"
});
const $2a18550bc13b24e8$var$roadmaps = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-starred.common.roadmaps",
    defaultMessage: "Roadmaps"
});
const $2a18550bc13b24e8$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Starred';
const $2a18550bc13b24e8$export$d57b6b390e78d90f = 'jira-cosmos';
const $2a18550bc13b24e8$export$77881eca52f4f5a6 = 15;
const $2a18550bc13b24e8$export$c2849e00cccc2078 = {
    PROJECT: 'PROJECT',
    FILTER: 'FILTER',
    DASHBOARD: 'DASHBOARD',
    PLAN: 'PLAN',
    BOARD: 'BOARD',
    QUEUE: 'QUEUE',
    JPD_COLLECTION: 'JPD_COLLECTION'
};
const $2a18550bc13b24e8$export$531e43cc63c1e036 = {
    ...$2a18550bc13b24e8$export$c2849e00cccc2078,
    ALL: 'ALL'
};
const $2a18550bc13b24e8$export$336e25f77ad481a9 = Object.values($2a18550bc13b24e8$export$c2849e00cccc2078);
const $2a18550bc13b24e8$export$85266ed7d25f274d = {
    [$2a18550bc13b24e8$export$531e43cc63c1e036.PROJECT]: $2a18550bc13b24e8$var$projects,
    [$2a18550bc13b24e8$export$531e43cc63c1e036.FILTER]: $2a18550bc13b24e8$var$filters,
    [$2a18550bc13b24e8$export$531e43cc63c1e036.DASHBOARD]: $2a18550bc13b24e8$var$dashboards,
    [$2a18550bc13b24e8$export$531e43cc63c1e036.PLAN]: $2a18550bc13b24e8$var$plans,
    [$2a18550bc13b24e8$export$531e43cc63c1e036.BOARD]: $2a18550bc13b24e8$var$boards,
    [$2a18550bc13b24e8$export$531e43cc63c1e036.QUEUE]: $2a18550bc13b24e8$var$queues,
    [$2a18550bc13b24e8$export$531e43cc63c1e036.ALL]: $2a18550bc13b24e8$var$all,
    [$2a18550bc13b24e8$export$531e43cc63c1e036.JPD_COLLECTION]: $2a18550bc13b24e8$var$roadmaps
};
const $2a18550bc13b24e8$export$de9a288dad6f35f1 = {
    [$2a18550bc13b24e8$export$531e43cc63c1e036.PROJECT]: $2a18550bc13b24e8$var$projectsGalaxia,
    [$2a18550bc13b24e8$export$531e43cc63c1e036.FILTER]: $2a18550bc13b24e8$var$filters,
    [$2a18550bc13b24e8$export$531e43cc63c1e036.DASHBOARD]: $2a18550bc13b24e8$var$dashboards,
    [$2a18550bc13b24e8$export$531e43cc63c1e036.PLAN]: $2a18550bc13b24e8$var$plans,
    [$2a18550bc13b24e8$export$531e43cc63c1e036.BOARD]: $2a18550bc13b24e8$var$boards,
    [$2a18550bc13b24e8$export$531e43cc63c1e036.QUEUE]: $2a18550bc13b24e8$var$queues,
    [$2a18550bc13b24e8$export$531e43cc63c1e036.JPD_COLLECTION]: $2a18550bc13b24e8$var$roadmaps,
    [$2a18550bc13b24e8$export$531e43cc63c1e036.ALL]: $2a18550bc13b24e8$var$all
};
const $2a18550bc13b24e8$export$6b181848cd9c8308 = 'searchStarredItems';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// oxlint-disable-next-line no-unused-vars
const $2a18550bc13b24e8$var$VIEW_ALL_STARRED_ITEMS = 'viewAllStarredItems';
const $2a18550bc13b24e8$export$c1c49903035a02df = 'filter';

});

parcelRegister("KlPLa", function(module, exports) {
$parcel$export(module.exports, "StarredFlyoutMenuItem", () => $775102e7e492fce6$export$b5a36b539503145d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6ouZy = parcelRequire("6ouZy");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");


var $bOwox = parcelRequire("bOwox");

var $ggvFe = parcelRequire("ggvFe");

var $6GljB = parcelRequire("6GljB");

var $gEDfa = parcelRequire("gEDfa");

var $KL7Bq = parcelRequire("KL7Bq");

var $4U30j = parcelRequire("4U30j");
var $iozCP = parcelRequire("iozCP");
var $02ogW = parcelRequire("02ogW");

var $cXTqc = parcelRequire("cXTqc");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $kt86l = parcelRequire("kt86l");

var $7eNDO = parcelRequire("7eNDO");

var $4ey3V = parcelRequire("4ey3V");

var $fFT9R = parcelRequire("fFT9R");
const $775102e7e492fce6$var$starred = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-starred.starred",
    defaultMessage: "Starred"
});
const $775102e7e492fce6$var$EMPTY_OBJECT = {};
function $775102e7e492fce6$export$b5a36b539503145d() {
    const cloudId = (0, $kt86l.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $euxye.useContext)((0, $ggvFe.NavItemsContext));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $fFT9R.sidebarStarredMenuEntryPoint), (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            filter: {
                types: (0, $4ey3V.VALID_FAVORITE_TYPES),
                sort: {
                    order: 'DESC'
                }
            },
            count: (0, $4ey3V.FAVOURITE_QUERY_LIMIT)
        }), [
        cloudId
    ]));
    const triggerRef = (0, $6ouZy.useEntryPointButtonTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $KL7Bq.useFormattedMessageAndIcon)($775102e7e492fce6$var$starred, (0, (/*@__PURE__*/$parcel$interopDefault($cXTqc))));
    const onOpenChangeHandler = (0, $euxye.useCallback)(async (isOpen)=>{
        if (isOpen) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $6GljB.L1_MENU_ID).STARRED);
            (0, $aJ81Y.fireUIAnalytics)(event, (0, $bOwox.SECTION_ITEM_STARRED), {
                isInMore: isInMore
            });
        }
    }, [
        createAnalyticsEvent,
        moreMenuIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4U30j.FlyoutMenuItem), {
        onOpenChange: onOpenChangeHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $02ogW.FlyoutMenuItemTrigger), {
        interactionName: "nav4-sidebar-starred",
        ref: triggerRef,
        elemBefore: icon
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iozCP.FlyoutMenuItemContent), {
        maxHeight: (0, $i860n.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? 460 : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-starred-default",
        packageName: (0, $4ey3V.PACKAGE_NAME),
        teamName: (0, $4ey3V.TEAM_NAME),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), {
            isFlyout: true,
            withHeading: true,
            withSearch: true
        }),
        // Props for the root component.
        runtimeProps: $775102e7e492fce6$var$EMPTY_OBJECT
    })));
}
$775102e7e492fce6$export$b5a36b539503145d.displayName = "StarredFlyoutMenuItem";

});
parcelRegister("fFT9R", function(module, exports) {
$parcel$export(module.exports, "sidebarStarredMenuEntryPoint", () => $3675ff2bfdf30616$export$72aec40208131d);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $aI0wO = parcelRequire("aI0wO");

const $3675ff2bfdf30616$export$72aec40208131d = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("eSivX")), {
        moduleId: "4c114cfe",
        moduleName: "StarredMenu",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, filter: filter, count: count })=>({
            queries: {
                starredMenuData: {
                    parameters: $aI0wO.default,
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        count: count,
                        filter: filter
                    }
                }
            }
        })
});

});
parcelRegister("aI0wO", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcaf9f7f64c0a429$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<031585e1ecc11fa948c72bcd8c7d5ac9>>
 * @relayHash ed11a2eac6dca17d8aaade2074e9ee82
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b10c54acd88b396d0f54bdd62132a9b7528cc458742767c7d404b9459c86c225

var $kSjiz = parcelRequire("kSjiz");

var $lIGkE = parcelRequire("lIGkE");
const $fcaf9f7f64c0a429$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v5 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v7 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v12 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isNode"
    }, v13 = [
        v9 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v10 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "filterUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterId"
                },
                v12 /*: any*/ 
            ],
            "type": "JiraFilter",
            "abstractKey": "__isJiraFilter"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "title"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "StarredMenuQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "allFavourites",
                                "args": v5 /*: any*/ ,
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v6 /*: any*/ ,
                                        "action": "THROW"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "StarredMenu"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled"
                }
            ],
            "kind": "Operation",
            "name": "StarredMenuQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "allFavourites",
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "starredItems",
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v11 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "emoji"
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraProductDiscoveryCollection"
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "starredItems",
                            "args": v7 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "StarredMenuListContent_starredItems",
                            "kind": "LinkedHandle",
                            "name": "favourites"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b10c54acd88b396d0f54bdd62132a9b7528cc458742767c7d404b9459c86c225",
            "metadata": {},
            "name": "StarredMenuQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled": (0, $kSjiz.default)
            }
        }
    };
}();
$fcaf9f7f64c0a429$var$node.hash = "fe54dd259a64768769310002e3616b4c";
(0, $lIGkE.PreloadableQueryRegistry).set($fcaf9f7f64c0a429$var$node.params.id, $fcaf9f7f64c0a429$var$node);
var $fcaf9f7f64c0a429$export$2e2bcd8739ae039 = $fcaf9f7f64c0a429$var$node;

});

parcelRegister("eSivX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5ldTN").then(()=>parcelRequire('l3BCg'));

});




parcelRegister("7AcIC", function(module, exports) {
$parcel$export(module.exports, "Stub", () => $24e96648abd539b7$export$1ab0b9ce3cf276f8);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $cn1qc = parcelRequire("cn1qc");




var $bOwox = parcelRequire("bOwox");

var $c9cNX = parcelRequire("c9cNX");

var $6GljB = parcelRequire("6GljB");

var $3rqDf = parcelRequire("3rqDf");

var $dx7aH = parcelRequire("dx7aH");

var $2DbWL = parcelRequire("2DbWL");

var $gbTMi = parcelRequire("gbTMi");


var $e6rNk = parcelRequire("e6rNk");

var $72ldR = parcelRequire("72ldR");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $i860n = parcelRequire("i860n");
const $24e96648abd539b7$export$1ab0b9ce3cf276f8 = (t0)=>{
    const $ = (0, $e7boj.c)(12);
    const { menuId: menuId, href: href } = t0;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)(menuId);
    const location = (0, $cn1qc.useLocation)();
    const path = location.pathname + location.search;
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const t1 = path === href;
    let t2;
    if ($[0] !== menuId) {
        t2 = (0, $i860n.fg)("navx-global-side-nav") ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($24e96648abd539b7$var$ActionButtons, {
            menuId: menuId
        });
        $[0] = menuId;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== menuId || $[3] !== sendSectionItemAnalyticsEvent) {
        t3 = ()=>{
            if (menuId === (0, $6GljB.L1_MENU_ID).TEAMS) sendSectionItemAnalyticsEvent({
                menuId: (0, $6GljB.L1_MENU_ID).TEAMS,
                sectionItem: (0, $bOwox.SECTION_ITEM_TEAMS)
            });
        };
        $[2] = menuId;
        $[3] = sendSectionItemAnalyticsEvent;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== formattedMessage || $[6] !== href || $[7] !== icon || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e6rNk.LinkMenuItem), {
            elemBefore: icon,
            href: href,
            isSelected: t1,
            actionsOnHover: t2,
            onClick: t3
        }, formattedMessage);
        $[5] = formattedMessage;
        $[6] = href;
        $[7] = icon;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
};
$24e96648abd539b7$export$1ab0b9ce3cf276f8.displayName = "Stub";
function $24e96648abd539b7$var$ActionButtons(t0) {
    const $ = (0, $e7boj.c)(8);
    const { menuId: menuId } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== menuId) {
        t1 = ()=>{
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: "clicked",
                actionSubject: (0, $6b2913942bd90807$export$b887e88d8d0739f6),
                actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[menuId],
                attributes: {
                    level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                    componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
                    itemId: (0, $00c4a880251c1b35$export$f06dfcec5ff912e)
                }
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = menuId;
        $[2] = t1;
    } else t1 = $[2];
    const handleNavMenuOpen = t1;
    let t2;
    if ($[3] !== menuId) {
        t2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2DbWL.HideL1MenuItemSection), {
                menuId: menuId,
                hasSeparator: false
            }));
        $[3] = menuId;
        $[4] = t2;
    } else t2 = $[4];
    const MenuItems = t2;
    let t3;
    if ($[5] !== MenuItems || $[6] !== handleNavMenuOpen) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
            onOpen: handleNavMenuOpen,
            MenuItems: MenuItems
        });
        $[5] = MenuItems;
        $[6] = handleNavMenuOpen;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
}
$24e96648abd539b7$var$ActionButtons.displayName = "ActionButtons";

});


parcelRegister("c3Eaw", function(module, exports) {
$parcel$export(module.exports, "useFilterL1MenuItemsByEditionAndLicense", () => $42769877bae0e909$export$bf04108d78a3abbe);

var $e7boj = parcelRequire("e7boj");

var $41FAq = parcelRequire("41FAq");

var $hplyg = parcelRequire("hplyg");

var $dV3gw = parcelRequire("dV3gw");

var $6HvWM = parcelRequire("6HvWM");

var $6GljB = parcelRequire("6GljB");

var $dZqFi = parcelRequire("dZqFi");

var $1DCIk = parcelRequire("1DCIk");

var $eFqFr = parcelRequire("eFqFr");

var $ly5Lx = parcelRequire("ly5Lx");

var $bRFCA = parcelRequire("bRFCA");

var $7l6jMC = parcelRequire("7l6jMC");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $lRYAe = parcelRequire("lRYAe");
const $42769877bae0e909$export$bf04108d78a3abbe = (navItems, params)=>{
    const $ = (0, $e7boj.c)(40);
    const showAssets = (0, $dZqFi.useShowAssets)();
    const { shouldUseJSM: shouldUseJSM } = (0, $6HvWM.useOgTenantInfo)();
    const canAccessOperations = (0, $1DCIk.useCanAccessOperations)();
    const shouldShowRoadmaps = (0, $dV3gw.useIsCrossProjectViewsEnabled)();
    const shouldShowRoadmapsUpsell = params?.shouldShowRoadmapsUpsell;
    const shouldShowItam = params?.showItam;
    const [shouldRenderPlans] = (0, $eFqFr.useNavigationPlansVisibility)();
    const showCustomerService = (0, $hplyg.useShowCustomerService)();
    const showCustomers = (0, $ly5Lx.useShowCustomers)();
    const isHelpCenterManagementEligible = (0, $bRFCA.useShowHelpCenterManagement)();
    let t0;
    if ($[0] !== isHelpCenterManagementEligible) {
        t0 = isHelpCenterManagementEligible && (0, $2700E.expVal)("jira_sidebar_show_helpcenter", "isEnabled", false);
        $[0] = isHelpCenterManagementEligible;
        $[1] = t0;
    } else t0 = $[1];
    const showHelpCenterManagement = t0;
    const { goals: goals, assets: assets, confluence: confluence, projects: projects, loom: loom, teams: teams, opsgenie: opsgenie } = (0, $7l6jMC.useGlobalApps)();
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $i860n.fg)("use_frontend_feature_encoding_sdk_remaining") ? (0, $41FAq.isFeatureEnabled)("jira", "jira-apps-menu") : !((0, $i860n.fg)("jira-hide-apps-in-isolated-cloud") && (0, $lRYAe.isIsolatedCloud)());
        $[2] = t1;
    } else t1 = $[2];
    const shouldRenderApps = t1;
    let t2;
    if ($[3] !== assets || $[4] !== canAccessOperations || $[5] !== confluence || $[6] !== goals || $[7] !== loom || $[8] !== navItems || $[9] !== opsgenie || $[10] !== projects || $[11] !== shouldRenderPlans || $[12] !== shouldShowItam || $[13] !== shouldShowRoadmaps || $[14] !== shouldShowRoadmapsUpsell || $[15] !== shouldUseJSM || $[16] !== showAssets || $[17] !== showCustomerService || $[18] !== showCustomers || $[19] !== showHelpCenterManagement || $[20] !== teams) {
        let t3;
        if ($[22] !== assets || $[23] !== canAccessOperations || $[24] !== confluence || $[25] !== goals || $[26] !== loom || $[27] !== opsgenie || $[28] !== projects || $[29] !== shouldRenderPlans || $[30] !== shouldShowItam || $[31] !== shouldShowRoadmaps || $[32] !== shouldShowRoadmapsUpsell || $[33] !== shouldUseJSM || $[34] !== showAssets || $[35] !== showCustomerService || $[36] !== showCustomers || $[37] !== showHelpCenterManagement || $[38] !== teams) {
            t3 = (t4)=>{
                const { menuId: menuId } = t4;
                if (menuId === (0, $6GljB.L1_MENU_ID).OPERATIONS) return shouldUseJSM && canAccessOperations;
                if (menuId === (0, $6GljB.L1_MENU_ID).ASSETS) return showAssets && !assets;
                if (menuId === (0, $6GljB.L1_MENU_ID).ROADMAPS) return shouldShowRoadmaps || shouldShowRoadmapsUpsell;
                if (menuId === (0, $6GljB.L1_MENU_ID).PLANS) return shouldRenderPlans;
                if (menuId === (0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS || menuId === (0, $6GljB.L1_MENU_ID).CUSTOMER_CONVERSATIONS_ANALYTICS) return false;
                if (menuId === (0, $6GljB.L1_MENU_ID).GOALS) return false;
                if (menuId === (0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE) return !(0, $i860n.fg)("csm_appification_standalone_navigation") && showCustomerService;
                if (menuId === (0, $6GljB.L1_MENU_ID).CUSTOMERS) return !(0, $i860n.fg)("csm_appification_standalone_navigation") && showCustomers;
                if (menuId === (0, $6GljB.L1_MENU_ID).HELP_CENTER_MANAGEMENT) return showHelpCenterManagement;
                if (menuId === (0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS) return assets;
                if (menuId === (0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS) return goals;
                if (menuId === (0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE) return confluence;
                if (menuId === (0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS) return projects;
                if (menuId === (0, $6GljB.L1_MENU_ID).GLOBAL_APP_LOOM) return loom;
                if (menuId === (0, $6GljB.L1_MENU_ID).GLOBAL_APP_TEAMS) return teams;
                if (menuId === (0, $6GljB.L1_MENU_ID).GLOBAL_APP_OPSGENIE) return opsgenie;
                if (menuId === (0, $6GljB.L1_MENU_ID).APPS) return shouldRenderApps;
                if (menuId === (0, $6GljB.L1_MENU_ID).ITAM) return (0, $i860n.fg)("itam_ftw") ? Boolean(shouldShowItam) : false;
                return true;
            };
            $[22] = assets;
            $[23] = canAccessOperations;
            $[24] = confluence;
            $[25] = goals;
            $[26] = loom;
            $[27] = opsgenie;
            $[28] = projects;
            $[29] = shouldRenderPlans;
            $[30] = shouldShowItam;
            $[31] = shouldShowRoadmaps;
            $[32] = shouldShowRoadmapsUpsell;
            $[33] = shouldUseJSM;
            $[34] = showAssets;
            $[35] = showCustomerService;
            $[36] = showCustomers;
            $[37] = showHelpCenterManagement;
            $[38] = teams;
            $[39] = t3;
        } else t3 = $[39];
        t2 = navItems.filter(t3);
        $[3] = assets;
        $[4] = canAccessOperations;
        $[5] = confluence;
        $[6] = goals;
        $[7] = loom;
        $[8] = navItems;
        $[9] = opsgenie;
        $[10] = projects;
        $[11] = shouldRenderPlans;
        $[12] = shouldShowItam;
        $[13] = shouldShowRoadmaps;
        $[14] = shouldShowRoadmapsUpsell;
        $[15] = shouldUseJSM;
        $[16] = showAssets;
        $[17] = showCustomerService;
        $[18] = showCustomers;
        $[19] = showHelpCenterManagement;
        $[20] = teams;
        $[21] = t2;
    } else t2 = $[21];
    return t2;
};

});
parcelRegister("hplyg", function(module, exports) {
$parcel$export(module.exports, "useShowCustomerService", () => $e0126f02d5728022$export$e760a809f2958bc7);

var $d8LhJ = parcelRequire("d8LhJ");

var $1KydW = parcelRequire("1KydW");

var $ccEzE = parcelRequire("ccEzE");
const $e0126f02d5728022$export$e760a809f2958bc7 = ()=>{
    const { hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $1KydW.useApplicationPermissions)();
    const { customerService: customerService } = (0, $ccEzE.useAppEditions)();
    if (customerService === (0, $d8LhJ.UNLICENSED)) return false;
    return hasCustomerServiceAccess;
};

});

parcelRegister("dZqFi", function(module, exports) {
$parcel$export(module.exports, "useShowAssets", () => $0f98b3ba681af390$export$6d1797fe1bb33b7a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eBpdw = parcelRequire("eBpdw");

var $eijVy = parcelRequire("eijVy");
function $0f98b3ba681af390$export$6d1797fe1bb33b7a() {
    const tenantContext = (0, $eijVy.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    if ((0, $eBpdw.isCMDBEnabledInEnvironment)() && isJSMUser) return true;
    return false;
}

});

parcelRegister("1DCIk", function(module, exports) {
$parcel$export(module.exports, "useCanAccessOperations", () => $712a1f5166b4b979$export$99ea8fee8b1b32f8);

var $1KydW = parcelRequire("1KydW");

var $6ZLJT = parcelRequire("6ZLJT");

var $i860n = parcelRequire("i860n");
const $712a1f5166b4b979$var$useHasServiceDeskAccess = ()=>(0, $1KydW.useApplicationPermissions)().hasServiceDeskAccess;
const $712a1f5166b4b979$export$99ea8fee8b1b32f8 = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('operations_sidebar_require_jsm_access'), $712a1f5166b4b979$var$useHasServiceDeskAccess, ()=>true);

});

parcelRegister("ly5Lx", function(module, exports) {
$parcel$export(module.exports, "useShowCustomers", () => $d5beebd7150c7e85$export$95344e90e3525854);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");

var $1KydW = parcelRequire("1KydW");

var $ccEzE = parcelRequire("ccEzE");
const $d5beebd7150c7e85$export$95344e90e3525854 = ()=>{
    const { hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $1KydW.useApplicationPermissions)();
    const { customerService: customerService } = (0, $ccEzE.useAppEditions)();
    if (customerService === (0, $d8LhJ.UNLICENSED)) return false;
    return hasCustomerServiceAccess;
};

});

parcelRegister("bRFCA", function(module, exports) {
$parcel$export(module.exports, "useShowHelpCenterManagement", () => $2e469a7ebfeabd67$export$be727a5a849bd94a);

var $d8LhJ = parcelRequire("d8LhJ");

var $ccEzE = parcelRequire("ccEzE");

var $fNgVF = parcelRequire("fNgVF");
const $2e469a7ebfeabd67$export$be727a5a849bd94a = ()=>{
    const { serviceDesk: serviceDesk } = (0, $ccEzE.useAppEditions)();
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    if (serviceDesk === (0, $d8LhJ.UNLICENSED)) return false;
    return isAdmin;
};

});


parcelRegister("AXNe9", function(module, exports) {
$parcel$export(module.exports, "useRefreshL1MenuItems", () => $4e4ad3a9e25aff89$export$6f30ce19c2e3e4c0);

var $e7boj = parcelRequire("e7boj");

var $jvz1H = parcelRequire("jvz1H");

var $6OFDk = parcelRequire("6OFDk");

var $2700E = parcelRequire("2700E");

var $hvbkB = parcelRequire("hvbkB");
const $4e4ad3a9e25aff89$export$6f30ce19c2e3e4c0 = (t0)=>{
    const $ = (0, $e7boj.c)(2);
    const navItems = t0 === undefined ? (0, $6OFDk.defaultProps).emptyArray : t0;
    let t1;
    if ($[0] !== navItems) {
        const missingMenuIds = (0, (/*@__PURE__*/$parcel$interopDefault($jvz1H)))((0, $2700E.expVal)("navx-1982-change-order-of-teams-and-goals", "isEnabled", false) ? (0, $hvbkB.USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS_GOALS_TEAMS_SWITCHED) : (0, $hvbkB.USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS), navItems.map($4e4ad3a9e25aff89$var$_temp));
        t1 = [
            ...navItems,
            ...missingMenuIds.map($4e4ad3a9e25aff89$var$_temp2)
        ];
        $[0] = navItems;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
function $4e4ad3a9e25aff89$var$_temp(t0) {
    const { menuId: menuId } = t0;
    return menuId;
}
function $4e4ad3a9e25aff89$var$_temp2(menuId_0) {
    return {
        menuId: menuId_0,
        isVisible: true
    };
}

});

parcelRegister("95jMh", function(module, exports) {
$parcel$export(module.exports, "OperationsDiscoverabilitySpotlightForAdmins", () => $d4b748b91f913f42$export$afe5247dc30d398d);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $gau8n = parcelRequire("gau8n");

var $fNgVF = parcelRequire("fNgVF");
const $d4b748b91f913f42$export$afe5247dc30d398d = (t0)=>{
    const $ = (0, $e7boj.c)(2);
    const { onClick: onClick } = t0;
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    if (!isAdmin) return null;
    let t1;
    if ($[0] !== onClick) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            id: "operations-overview-discoverability-spotlight",
            packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCore",
            fallback: "unmount",
            teamName: "alexstrasza"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gau8n.SSRPlacement), {
            onClick: onClick
        }));
        $[0] = onClick;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
$d4b748b91f913f42$export$afe5247dc30d398d.displayName = "OperationsDiscoverabilitySpotlightForAdmins";

});
parcelRegister("gau8n", function(module, exports) {
$parcel$export(module.exports, "SSRPlacement", () => $7d951ef30f1ca700$export$7d3d92a960f07a28);
// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

var $kMQQO = parcelRequire("kMQQO");

var $41tPE = parcelRequire("41tPE");

var $d6e0x = parcelRequire("d6e0x");
const $7d951ef30f1ca700$var$messageFrontends = [
    (0, $41tPE.MessageFrontend)({
        messageTemplateId: 'jsm-operations-overview-discoverability-spotlights'
    })
];
const $7d951ef30f1ca700$export$7b621692a0aa2333 = (0, $kMQQO.PlacementFrontend).createPlacementFrontendComponent({
    messageTemplates: $7d951ef30f1ca700$var$messageFrontends
});
const $7d951ef30f1ca700$export$af2bcbdc04a2d456 = (0, $d6e0x.withI18n)($7d951ef30f1ca700$export$7b621692a0aa2333);
const $7d951ef30f1ca700$export$7d3d92a960f07a28 = $7d951ef30f1ca700$export$7b621692a0aa2333;

});
parcelRegister("kMQQO", function(module, exports) {
$parcel$export(module.exports, "PlacementFrontend", () => $d20f6ef2791069da$export$55486c2b6964dcf2);
$parcel$export(module.exports, "PlacementBackend", () => $d20f6ef2791069da$export$d90b37843c84d1c3);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2vhMr = parcelRequire("2vhMr");

var $8VhoU = parcelRequire("8VhoU");
const $d20f6ef2791069da$var$placement = (0, $2vhMr.createPlacement)({
    placementId: 'operations-overview-discoverability-spotlights',
    options: {
        choreographer: {
            isDefaultEnabled: true
        }
    }
});
const $d20f6ef2791069da$export$81df3aa6753d44e2 = $d20f6ef2791069da$var$placement.createFrontend;
const $d20f6ef2791069da$export$da912f58cb37a643 = $d20f6ef2791069da$var$placement.createBackend;
const $d20f6ef2791069da$export$55486c2b6964dcf2 = $d20f6ef2791069da$export$81df3aa6753d44e2((Messages)=>({ preloadedInitialData: preloadedInitialData, onClick: onClick })=>{
        const [dismissedIds, setDismissedIds] = (0, $euxye.useState)(new Set());
        const { data: data, error: error, isLoading: isLoading } = (0, $8VhoU.usePlacementApi)('/', {
            autoRefetch: {
                isEnabled: !preloadedInitialData,
                updateKey: 'operations-overview-discoverability-spotlights'
            }
        });
        const messages = preloadedInitialData?.messages || data?.messages;
        const visibleMessages = messages?.filter((message)=>!dismissedIds.has(message.messageInstanceId))?.slice?.(0, 1); // Only show one message at most
        const handleDismiss = (messageInstanceId)=>{
            setDismissedIds((prev)=>new Set([
                    ...Array.from(prev),
                    messageInstanceId
                ]));
        };
        if (error) throw error;
        if (!preloadedInitialData && isLoading) return null;
        if (!visibleMessages || visibleMessages.length === 0) return null;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
            children: visibleMessages.map((message)=>/*#__PURE__*/ (0, $e79Pd.jsx)(Messages.render, {
                    onDismiss: ()=>handleDismiss(message.messageInstanceId),
                    onClick: onClick,
                    ...message
                }, message.messageInstanceId))
        });
    });
const $d20f6ef2791069da$export$d90b37843c84d1c3 = $d20f6ef2791069da$export$da912f58cb37a643();

});

parcelRegister("41tPE", function(module, exports) {
$parcel$export(module.exports, "MessageFrontend", () => $11ed521c7390e96a$export$fa9bb46961aca2cc);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hF2qZ = parcelRequire("hF2qZ");

var $4LDqh = parcelRequire("4LDqh");
parcelRequire("44Zv4");
var $8hQRz = parcelRequire("8hQRz");
var $8hQRz = parcelRequire("8hQRz");

var $kMQQO = parcelRequire("kMQQO");

var $5inXb = parcelRequire("5inXb");

var $fGrpH = parcelRequire("fGrpH");

var $iKPvC = parcelRequire("iKPvC");

var $kdOoc = parcelRequire("kdOoc");

var $btXTa = parcelRequire("btXTa");

var $1JNT5 = parcelRequire("1JNT5");

var $j4TXa = parcelRequire("j4TXa");
const $11ed521c7390e96a$export$e7843a8f64a8d87c = (0, $kMQQO.PlacementBackend).createMessageBackend((0, $8hQRz.defaultMessageBackend));
// The original experiments will be paused via Switcheroo once the new April experiments below are enabled.
const $11ed521c7390e96a$var$MARKETPLACE_OPS_EXPERIMENT_KEY = 'ops-overview-disc-marketplace-ops';
const $11ed521c7390e96a$var$INACTIVE_OPS_EXPERIMENT_KEY = 'ops-overview-disc-inactive-ops';
// New April experiments with corrected segment targeting.
const $11ed521c7390e96a$var$MARKETPLACE_OPS_APRIL_EXPERIMENT_KEY = 'ops-overview-disc-marketplace-ops-april';
const $11ed521c7390e96a$var$INACTIVE_OPS_APRIL_EXPERIMENT_KEY = 'ops-overview-disc-inactive-ops-april';
const $11ed521c7390e96a$var$HIGH_BUG_LOAD_EXPERIMENT_KEY = 'ops-overview-disc-high-bug';
const $11ed521c7390e96a$var$getActiveExperiment = ()=>{
    // Priority: Marketplace > Inactive Ops > High Bug Load.
    const isMarketplaceOpsAprilEnabled = (0, $4LDqh.default).getExperimentValue($11ed521c7390e96a$var$MARKETPLACE_OPS_APRIL_EXPERIMENT_KEY, 'isEnabled', false);
    if (isMarketplaceOpsAprilEnabled) return {
        experimentKey: $11ed521c7390e96a$var$MARKETPLACE_OPS_APRIL_EXPERIMENT_KEY,
        messages: (0, $btXTa.marketplaceOpsMessages),
        tourMessages: (0, $btXTa.marketplaceOpsTourMessages)
    };
    const isInactiveOpsAprilEnabled = (0, $4LDqh.default).getExperimentValue($11ed521c7390e96a$var$INACTIVE_OPS_APRIL_EXPERIMENT_KEY, 'isEnabled', false);
    if (isInactiveOpsAprilEnabled) return {
        experimentKey: $11ed521c7390e96a$var$INACTIVE_OPS_APRIL_EXPERIMENT_KEY,
        messages: (0, $btXTa.inactiveOpsMessages),
        tourMessages: (0, $btXTa.inactiveOpsTourMessages)
    };
    const isHighBugLoadEnabled = (0, $4LDqh.default).getExperimentValue($11ed521c7390e96a$var$HIGH_BUG_LOAD_EXPERIMENT_KEY, 'isEnabled', false);
    if (isHighBugLoadEnabled) return {
        experimentKey: $11ed521c7390e96a$var$HIGH_BUG_LOAD_EXPERIMENT_KEY,
        messages: (0, $btXTa.highBugLoadMessages),
        tourMessages: (0, $btXTa.highBugLoadTourMessages)
    };
    // Segments were mis-targeted, so messages are intentionally swapped.
    const isInactiveOpsEnabled = (0, $4LDqh.default).getExperimentValue($11ed521c7390e96a$var$INACTIVE_OPS_EXPERIMENT_KEY, 'isEnabled', false);
    if (isInactiveOpsEnabled) return {
        experimentKey: $11ed521c7390e96a$var$INACTIVE_OPS_EXPERIMENT_KEY,
        messages: (0, $btXTa.marketplaceOpsMessages),
        tourMessages: (0, $btXTa.marketplaceOpsTourMessages)
    };
    const isMarketplaceOpsEnabled = (0, $4LDqh.default).getExperimentValue($11ed521c7390e96a$var$MARKETPLACE_OPS_EXPERIMENT_KEY, 'isEnabled', false);
    if (isMarketplaceOpsEnabled) return {
        experimentKey: $11ed521c7390e96a$var$MARKETPLACE_OPS_EXPERIMENT_KEY,
        messages: (0, $btXTa.inactiveOpsMessages),
        tourMessages: (0, $btXTa.inactiveOpsTourMessages)
    };
    return null;
};
const $11ed521c7390e96a$var$isOperationsMenuItemVisible = ()=>{
    return !!globalThis.document?.querySelector('#operations-overview-discoverability-spotlight-target');
};
const $11ed521c7390e96a$export$b3890eb0ae9dca99 = (0, $kMQQO.PlacementFrontend).createFrontendStage({
    type: 'render',
    validate: (0, $8hQRz.noValidation)(),
    Component: ({ onDismiss: onDismiss, onClick: onClick })=>{
        const { messageDismissed: messageDismissed } = (0, $kdOoc.useMessageEvent)();
        const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $iKPvC.useMessageInstanceEvent)();
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
        const activeExperiment = $11ed521c7390e96a$var$getActiveExperiment();
        const operationsVisible = $11ed521c7390e96a$var$isOperationsMenuItemVisible();
        const spotlightType = operationsVisible ? 'single-step' : 'multi-step';
        const [tourStepIndex, setTourStepIndex] = (0, $euxye.useState)(0);
        const selector = operationsVisible ? '#operations-overview-discoverability-spotlight-target' : '#more-button-menu-item';
        const { isStable: isStable } = (0, $hF2qZ.useStableElementPosition)(selector);
        const renderInline = (0, $5inXb.useMountToHtmlElement)({
            selectors: selector,
            as: 'inline',
            position: 'after'
        });
        // Fire viewed event when spotlight is seen by the user
        (0, $euxye.useEffect)(()=>{
            if (!messageInstanceViewed || !isStable || !activeExperiment) return;
            messageInstanceViewed({
                experimentKey: activeExperiment.experimentKey,
                spotlightType: spotlightType
            });
            fireAnalyticsEvent({
                eventType: 'screen',
                name: 'operationsDiscoverabilitySpotlight',
                attributes: {
                    experimentKey: activeExperiment.experimentKey,
                    spotlightType: spotlightType
                }
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            isStable
        ]);
        const dismiss = (0, $euxye.useCallback)(()=>{
            messageDismissed();
            messageInstanceClicked({
                messageEventType: 'clicked',
                clickedElement: {
                    clickIdentifier: 'spotlight-dismissed',
                    clickedElement: 'button',
                    buttonType: 'secondary'
                },
                action: {
                    actionType: 'dismiss'
                },
                additionalMetadataFromFrontend: {
                    experimentKey: activeExperiment?.experimentKey ?? '',
                    spotlightType: spotlightType,
                    tourStep: tourStepIndex
                }
            });
            fireAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'operationsDiscoverabilitySpotlightDismiss',
                attributes: {
                    experimentKey: activeExperiment?.experimentKey ?? '',
                    spotlightType: spotlightType,
                    tourStep: tourStepIndex
                }
            });
            onDismiss?.();
        }, [
            messageDismissed,
            messageInstanceClicked,
            fireAnalyticsEvent,
            onDismiss,
            activeExperiment,
            spotlightType,
            tourStepIndex
        ]);
        const handlePrimaryAction = (0, $euxye.useCallback)(()=>{
            messageDismissed();
            messageInstanceClicked({
                messageEventType: 'clicked',
                clickedElement: {
                    clickIdentifier: 'go-to-operations-overview',
                    clickedElement: 'button',
                    buttonType: 'primary'
                },
                action: {
                    actionType: 'dismiss'
                },
                additionalMetadataFromFrontend: {
                    experimentKey: activeExperiment?.experimentKey ?? '',
                    spotlightType: spotlightType
                }
            });
            fireAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'operationsDiscoverabilitySpotlightGoToOperations',
                attributes: {
                    experimentKey: activeExperiment?.experimentKey ?? '',
                    spotlightType: spotlightType
                }
            });
            onClick?.();
            onDismiss?.();
        }, [
            messageDismissed,
            messageInstanceClicked,
            fireAnalyticsEvent,
            onClick,
            onDismiss,
            activeExperiment,
            spotlightType
        ]);
        const handleTourNext = (0, $euxye.useCallback)(()=>{
            // Click the More button to open the menu
            const moreButton = globalThis.document?.querySelector('#more-button-menu-item button');
            moreButton?.click();
            messageInstanceClicked({
                messageEventType: 'clicked',
                clickedElement: {
                    clickIdentifier: 'tour-next-clicked',
                    clickedElement: 'button',
                    buttonType: 'primary'
                },
                action: {
                    actionType: 'dismiss'
                },
                additionalMetadataFromFrontend: {
                    experimentKey: activeExperiment?.experimentKey ?? '',
                    spotlightType: spotlightType,
                    tourStep: 0
                }
            });
            fireAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'operationsDiscoverabilitySpotlightTourNext',
                attributes: {
                    experimentKey: activeExperiment?.experimentKey ?? '',
                    spotlightType: spotlightType
                }
            });
            // Delay step advance to allow More menu popup to render
            setTimeout(()=>{
                setTourStepIndex(1);
            }, 300);
        }, [
            fireAnalyticsEvent,
            messageInstanceClicked,
            activeExperiment,
            spotlightType
        ]);
        if (!activeExperiment || !isStable) return null;
        // Operations menu item is visible — show single-step spotlight
        if (operationsVisible) {
            const { messages: messages } = activeExperiment;
            return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                children: renderInline(/*#__PURE__*/ (0, $e79Pd.jsx)((0, $1JNT5.OperationsMenuItemSpotlight), {
                    dismiss: dismiss,
                    onPrimaryAction: handlePrimaryAction,
                    messages: messages
                }))
            });
        }
        // Operations menu item is NOT visible — show multi-step tour
        const { tourMessages: tourMessages } = activeExperiment;
        return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            children: renderInline(/*#__PURE__*/ (0, $e79Pd.jsx)((0, $j4TXa.OperationsDiscoverySpotlightTour), {
                dismiss: dismiss,
                next: handleTourNext,
                done: handlePrimaryAction,
                stepIndex: tourStepIndex,
                totalSteps: 2,
                experimentMessages: tourMessages
            }))
        });
    }
});
const $11ed521c7390e96a$export$fa9bb46961aca2cc = (0, $kMQQO.PlacementFrontend).createMessageFrontend({
    render: $11ed521c7390e96a$export$b3890eb0ae9dca99
});

});
parcelRegister("hF2qZ", function(module, exports) {
$parcel$export(module.exports, "useStableElementPosition", () => $50fb6f8b4975bd6f$export$e02f529abf3b3654);

var $euxye = parcelRequire("euxye");
const $50fb6f8b4975bd6f$export$e02f529abf3b3654 = (selector)=>{
    const [isStable, setIsStable] = (0, $euxye.useState)(false);
    (0, $euxye.useEffect)(()=>{
        if (isStable || !selector) return;
        let lastTop = null;
        let stableSince = null;
        const intervalId = setInterval(()=>{
            const el = globalThis.document?.querySelector(selector);
            if (!el) {
                lastTop = null;
                stableSince = null;
                return;
            }
            const currentTop = el.getBoundingClientRect().top;
            const now = Date.now();
            if (lastTop === null || lastTop !== currentTop) {
                lastTop = currentTop;
                stableSince = now;
            } else if (stableSince !== null && now - stableSince >= 300) {
                setIsStable(true);
                clearInterval(intervalId);
            }
        }, 100);
        return ()=>clearInterval(intervalId);
    }, [
        selector,
        isStable
    ]);
    return {
        isStable: isStable
    };
};

});

parcelRegister("btXTa", function(module, exports) {
$parcel$export(module.exports, "marketplaceOpsMessages", () => $a4ae151674b0a262$export$40e924c0a4a3b1bf);
$parcel$export(module.exports, "inactiveOpsMessages", () => $a4ae151674b0a262$export$22230ea86de31a44);
$parcel$export(module.exports, "commonTourMessages", () => $a4ae151674b0a262$export$797cfe3862df1eb3);
$parcel$export(module.exports, "marketplaceOpsTourMessages", () => $a4ae151674b0a262$export$34c63ef142467fe2);
$parcel$export(module.exports, "inactiveOpsTourMessages", () => $a4ae151674b0a262$export$3876b7aa346dadf6);
$parcel$export(module.exports, "highBugLoadMessages", () => $a4ae151674b0a262$export$53639b5db7d54747);
$parcel$export(module.exports, "highBugLoadTourMessages", () => $a4ae151674b0a262$export$11af46da131b0171);

var $7eNDO = parcelRequire("7eNDO");
const $a4ae151674b0a262$export$7a139a23b930a4d7 = (0, $7eNDO.defineMessages)({
    heading: {
        defaultMessage: 'Explore Operations',
        description: 'Heading for the spotlight card shown on the Operations sidebar menu item, shared across cohorts that use the Explore Operations CTA',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.shared.explore-operations.heading'
    },
    primaryAction: {
        defaultMessage: 'Explore',
        description: 'Primary action button on the spotlight card that navigates to Operations, shared across cohorts that use the Explore Operations CTA',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.shared.explore-operations.primary-action'
    }
});
const $a4ae151674b0a262$var$marketplaceOpsDescriptionMessage = (0, $7eNDO.defineMessages)({
    description: {
        defaultMessage: "You're getting notified through third-party integrations today. Instead, set up operations to receive real-time alerts and stay on top of issues as soon as they happen.",
        description: 'Description for the spotlight card shown on the Operations sidebar menu item for marketplace ops experiment',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.marketplace-ops.description'
    }
});
const $a4ae151674b0a262$export$40e924c0a4a3b1bf = {
    heading: $a4ae151674b0a262$export$7a139a23b930a4d7.heading,
    description: $a4ae151674b0a262$var$marketplaceOpsDescriptionMessage.description,
    primaryAction: $a4ae151674b0a262$export$7a139a23b930a4d7.primaryAction
};
const $a4ae151674b0a262$export$22230ea86de31a44 = (0, $7eNDO.defineMessages)({
    heading: {
        defaultMessage: "You're almost there",
        description: 'Heading for the spotlight card shown on the Operations sidebar menu item for inactive ops experiment',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.heading'
    },
    description: {
        defaultMessage: "It's been a while since you started setting up operations. Turn on alerts and on-call schedules to unlock its full potential for your team.",
        description: 'Description for the spotlight card shown on the Operations sidebar menu item for inactive ops experiment',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.description'
    },
    primaryAction: {
        defaultMessage: 'Go to Operations',
        description: 'Primary action button on the spotlight card for inactive ops experiment that navigates to Operations',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.primary-action'
    }
});
const $a4ae151674b0a262$export$797cfe3862df1eb3 = (0, $7eNDO.defineMessages)({
    step1Heading: {
        defaultMessage: 'Complete your Operations setup',
        description: 'Heading for step 1 of the spotlight tour targeting the More button',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.tour.step1-heading'
    },
    step2Heading: {
        defaultMessage: "You're almost there",
        description: 'Heading for step 2 of the spotlight tour targeting Operations inside the More menu',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.tour.step2-heading'
    },
    step2Description: {
        defaultMessage: 'Click on <b>Operations</b> to set up alerts and on-call schedules to make sure your team stay on top of issues as soon as they happen.',
        description: 'Description for step 2 of the spotlight tour',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.tour.step2-description'
    },
    nextButton: {
        defaultMessage: 'Next',
        description: 'Next button text on the first step of the spotlight tour',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.tour.next-button'
    },
    primaryAction: {
        defaultMessage: 'Go to Operations',
        description: 'Primary action button text on the last step of the spotlight tour',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.tour.primary-action'
    },
    stepCount: {
        defaultMessage: '{currentStep} of {totalSteps}',
        description: 'Step count indicator showing current step position in the spotlight tour',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.tour.step-count'
    }
});
const $a4ae151674b0a262$export$34c63ef142467fe2 = (0, $7eNDO.defineMessages)({
    step1Description: {
        defaultMessage: "You're getting notified through third-party integrations today. Click <b>More</b> to set up operations and unlock its full potential for your team.",
        description: 'Description for step 1 of the spotlight tour for marketplace ops experiment',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.marketplace-ops.tour.step1-description'
    }
});
const $a4ae151674b0a262$export$3876b7aa346dadf6 = (0, $7eNDO.defineMessages)({
    step1Description: {
        defaultMessage: "It's been a while since you started setting up operations. Click <b>More</b> to set up operations and unlock its full potential for your team.",
        description: 'Description for step 1 of the spotlight tour for inactive ops experiment',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.tour.step1-description'
    }
});
const $a4ae151674b0a262$var$highBugLoadDescriptionMessage = (0, $7eNDO.defineMessages)({
    description: {
        defaultMessage: "Your team's been logging a lot of bugs. Set up operations to get ahead of the next one \u2014 with on-call, alerting, and incident response built right in.",
        description: 'Description for the spotlight card shown on the Operations sidebar menu item for high bug load experiment',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.high-bug.description'
    }
});
const $a4ae151674b0a262$export$53639b5db7d54747 = {
    heading: $a4ae151674b0a262$export$7a139a23b930a4d7.heading,
    description: $a4ae151674b0a262$var$highBugLoadDescriptionMessage.description,
    primaryAction: $a4ae151674b0a262$export$7a139a23b930a4d7.primaryAction
};
const $a4ae151674b0a262$export$11af46da131b0171 = (0, $7eNDO.defineMessages)({
    step1Description: {
        defaultMessage: "Your team's been logging a lot of bugs. Click <b>More</b> to set up operations and get ahead of the next one \u2014 with on-call, alerting, and incident response built right in.",
        description: 'Description for step 1 of the spotlight tour for high bug load experiment',
        id: 'alexstrasza.operations-overview-discoverability-spotlights.high-bug.tour.step1-description'
    }
});

});

parcelRegister("1JNT5", function(module, exports) {
$parcel$export(module.exports, "OperationsMenuItemSpotlight", () => $5151837e8fdfac22$export$2dde119b668260f0);

var $e79Pd = parcelRequire("e79Pd");

var $i2sOf = parcelRequire("i2sOf");

var $8Sdzy = parcelRequire("8Sdzy");

var $55qdj = parcelRequire("55qdj");
var $1YIbA = parcelRequire("1YIbA");

var $3LBDW = parcelRequire("3LBDW");

var $jukA2 = parcelRequire("jukA2");

var $54cWg = parcelRequire("54cWg");

var $413te = parcelRequire("413te");

var $KcP1c = parcelRequire("KcP1c");

var $7okqc = parcelRequire("7okqc");

var $8guPH = parcelRequire("8guPH");

var $8qQ8A = parcelRequire("8qQ8A");

var $8CDnU = parcelRequire("8CDnU");

var $liP0D = parcelRequire("liP0D");

var $jFNyB = parcelRequire("jFNyB");

var $5Gxfr = parcelRequire("5Gxfr");

var $g5k19 = parcelRequire("g5k19");

var $fxLck = parcelRequire("fxLck");
const $5151837e8fdfac22$export$2dde119b668260f0 = ({ dismiss: dismiss, onPrimaryAction: onPrimaryAction, messages: messages })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $g5k19.PopoverProvider), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5Gxfr.PopoverTarget), {
                children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {})
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fxLck.PopoverContent), {
                dismiss: dismiss,
                placement: "right-end",
                isVisible: true,
                children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8CDnU.SpotlightCard), {
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $KcP1c.SpotlightHeader), {
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $413te.SpotlightHeadline), {
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                        ...messages.heading
                                    })
                                }),
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8qQ8A.SpotlightControls), {
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8guPH.SpotlightDismissControl), {
                                        autoFocus: false
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $54cWg.SpotlightMedia), {
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $i2sOf.default), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3LBDW))),
                                alt: formatMessage(messages.heading)
                            })
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $liP0D.SpotlightBody), {
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                    ...messages.description
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7okqc.SpotlightFooter), {
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jFNyB.SpotlightActions), {
                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jukA2.SpotlightPrimaryAction), {
                                    onClick: onPrimaryAction,
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                        ...messages.primaryAction
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
$5151837e8fdfac22$export$2dde119b668260f0.displayName = "OperationsMenuItemSpotlight";

});
parcelRegister("3LBDW", function(module, exports) {
module.exports = new URL("spotlight-media.5bec468b.svg", import.meta.url).toString();

});


parcelRegister("j4TXa", function(module, exports) {
$parcel$export(module.exports, "OperationsDiscoverySpotlightTour", () => $0cba9b4be500242a$export$151341e0ddf65aed);

var $e79Pd = parcelRequire("e79Pd");

var $i2sOf = parcelRequire("i2sOf");

var $8Sdzy = parcelRequire("8Sdzy");

var $55qdj = parcelRequire("55qdj");
var $1YIbA = parcelRequire("1YIbA");

var $btXTa = parcelRequire("btXTa");

var $3LBDW = parcelRequire("3LBDW");

var $7Bcvd = parcelRequire("7Bcvd");

var $jukA2 = parcelRequire("jukA2");

var $54cWg = parcelRequire("54cWg");

var $413te = parcelRequire("413te");

var $KcP1c = parcelRequire("KcP1c");

var $7okqc = parcelRequire("7okqc");

var $8guPH = parcelRequire("8guPH");

var $8qQ8A = parcelRequire("8qQ8A");

var $8CDnU = parcelRequire("8CDnU");

var $liP0D = parcelRequire("liP0D");

var $jFNyB = parcelRequire("jFNyB");

var $5Gxfr = parcelRequire("5Gxfr");

var $g5k19 = parcelRequire("g5k19");

var $fxLck = parcelRequire("fxLck");
const $0cba9b4be500242a$var$createTour = (experimentMessages)=>[
        {
            // Step 1
            Component: ({ dismiss: dismiss, next: next, stepIndex: stepIndex, totalSteps: totalSteps })=>{
                const { formatMessage: formatMessage } = (0, $1YIbA.default)();
                return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $g5k19.PopoverProvider), {
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5Gxfr.PopoverTarget), {
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {})
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fxLck.PopoverContent), {
                            dismiss: dismiss,
                            placement: "right-start",
                            isVisible: true,
                            children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8CDnU.SpotlightCard), {
                                children: [
                                    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $KcP1c.SpotlightHeader), {
                                        children: [
                                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $413te.SpotlightHeadline), {
                                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                    ...(0, $btXTa.commonTourMessages).step1Heading
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8qQ8A.SpotlightControls), {
                                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8guPH.SpotlightDismissControl), {
                                                    autoFocus: false
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $54cWg.SpotlightMedia), {
                                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $i2sOf.default), {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3LBDW))),
                                            alt: formatMessage((0, $btXTa.commonTourMessages).step1Heading)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $liP0D.SpotlightBody), {
                                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                ...experimentMessages.step1Description,
                                                values: {
                                                    b: (chunks)=>/*#__PURE__*/ (0, $e79Pd.jsx)("b", {
                                                            children: chunks
                                                        })
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $7okqc.SpotlightFooter), {
                                        children: [
                                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7Bcvd.SpotlightStepCount), {
                                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                    ...(0, $btXTa.commonTourMessages).stepCount,
                                                    values: {
                                                        currentStep: stepIndex + 1,
                                                        totalSteps: totalSteps
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jFNyB.SpotlightActions), {
                                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jukA2.SpotlightPrimaryAction), {
                                                    onClick: next,
                                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                        ...(0, $btXTa.commonTourMessages).nextButton
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        },
        {
            // Step 2
            Component: ({ dismiss: dismiss, done: done, stepIndex: stepIndex, totalSteps: totalSteps })=>{
                return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $g5k19.PopoverProvider), {
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5Gxfr.PopoverTarget), {
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {})
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fxLck.PopoverContent), {
                            dismiss: dismiss,
                            placement: "right-start",
                            isVisible: true,
                            children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8CDnU.SpotlightCard), {
                                children: [
                                    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $KcP1c.SpotlightHeader), {
                                        children: [
                                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $413te.SpotlightHeadline), {
                                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                    ...(0, $btXTa.commonTourMessages).step2Heading
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8qQ8A.SpotlightControls), {
                                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8guPH.SpotlightDismissControl), {
                                                    autoFocus: false
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $liP0D.SpotlightBody), {
                                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                ...(0, $btXTa.commonTourMessages).step2Description,
                                                values: {
                                                    b: (chunks)=>/*#__PURE__*/ (0, $e79Pd.jsx)("b", {
                                                            children: chunks
                                                        })
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $7okqc.SpotlightFooter), {
                                        children: [
                                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7Bcvd.SpotlightStepCount), {
                                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                    ...(0, $btXTa.commonTourMessages).stepCount,
                                                    values: {
                                                        currentStep: stepIndex + 1,
                                                        totalSteps: totalSteps
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jFNyB.SpotlightActions), {
                                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jukA2.SpotlightPrimaryAction), {
                                                    onClick: done,
                                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                        ...(0, $btXTa.commonTourMessages).primaryAction
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        }
    ];
const $0cba9b4be500242a$export$151341e0ddf65aed = ({ dismiss: dismiss, next: next, done: done, stepIndex: stepIndex, totalSteps: totalSteps, experimentMessages: experimentMessages })=>{
    const tour = $0cba9b4be500242a$var$createTour(experimentMessages);
    const step = tour[stepIndex];
    const Step = step?.Component || (()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {}));
    return /*#__PURE__*/ (0, $e79Pd.jsx)(Step, {
        dismiss: dismiss,
        next: next,
        done: done,
        stepIndex: stepIndex,
        totalSteps: totalSteps,
        experimentMessages: experimentMessages
    });
};
$0cba9b4be500242a$export$151341e0ddf65aed.displayName = "OperationsDiscoverySpotlightTour";

});


parcelRegister("d6e0x", function(module, exports) {
$parcel$export(module.exports, "withI18n", () => $2237e22d00c14d37$export$bfba3ccd9d9038f9);

var $2I9KJ = parcelRequire("2I9KJ");

var $jvZSQ = parcelRequire("jvZSQ");
const $2237e22d00c14d37$export$bfba3ccd9d9038f9 = (0, $2I9KJ.createWithI18n)((0, $jvZSQ.messagesLoader));

});



parcelRegister("6dvbm", function(module, exports) {
$parcel$export(module.exports, "MoreMenuIsOpenContextProvider", () => $24a1030636cc92d4$export$d11e004ed91611ce);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $dUuNf = parcelRequire("dUuNf");
const $24a1030636cc92d4$export$d11e004ed91611ce = (t0)=>{
    const $ = (0, $e7boj.c)(5);
    const { children: children } = t0;
    const [moreMenuIsOpen, setMoreMenuIsOpen] = (0, $euxye.useState)(false);
    let t1;
    if ($[0] !== moreMenuIsOpen) {
        t1 = {
            moreMenuIsOpen: moreMenuIsOpen,
            setMoreMenuIsOpen: setMoreMenuIsOpen
        };
        $[0] = moreMenuIsOpen;
        $[1] = t1;
    } else t1 = $[1];
    const moreMenuIsOpenContext = t1;
    let t2;
    if ($[2] !== children || $[3] !== moreMenuIsOpenContext) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dUuNf.MoreMenuIsOpenContext).Provider, {
            value: moreMenuIsOpenContext
        }, children);
        $[2] = children;
        $[3] = moreMenuIsOpenContext;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
$24a1030636cc92d4$export$d11e004ed91611ce.displayName = "MoreMenuIsOpenContextProvider";

});
parcelRegister("dUuNf", function(module, exports) {
$parcel$export(module.exports, "MoreMenuIsOpenContext", () => $817a24b1d142fcbb$export$8888ac4b19e27f70);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");
const $817a24b1d142fcbb$export$8888ac4b19e27f70 = /*#__PURE__*/ (0, $euxye.createContext)({
    moreMenuIsOpen: false,
    setMoreMenuIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
});

});


parcelRegister("fIlw4", function(module, exports) {
$parcel$export(module.exports, "SidebarCustomization", () => $a7aacefd4d29cc43$export$64f537f23c5bcad6);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $jyCdG = parcelRequire("jyCdG");

var $bOwox = parcelRequire("bOwox");

var $ggvFe = parcelRequire("ggvFe");

var $3rqDf = parcelRequire("3rqDf");

var $am8wf = parcelRequire("am8wf");

var $jH4ta = parcelRequire("jH4ta");

var $i860n = parcelRequire("i860n");

var $c2v96 = parcelRequire("c2v96");

var $5LseV = parcelRequire("5LseV");

var $vqZek = parcelRequire("vqZek");
function $a7aacefd4d29cc43$export$64f537f23c5bcad6(t0) {
    const $ = (0, $e7boj.c)(27);
    const { menuData: menuData, productItemsData: productItemsData, appItemsData: appItemsData, getAppShortcutURL: getAppShortcutURL } = t0;
    const { moreMenuIds: moreMenuIds } = (0, $euxye.useContext)((0, $ggvFe.NavItemsContext));
    const { peekMenuId: peekMenuId } = (0, $euxye.useContext)((0, $ggvFe.PeekMenuIdContext));
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const pressTracing = (0, $am8wf.default)("nav4-sidebar-more");
    let t1;
    if ($[0] !== pressTracing || $[1] !== sendSectionItemAnalyticsEvent) {
        t1 = ()=>{
            sendSectionItemAnalyticsEvent({
                sectionItem: (0, $bOwox.SECTION_ITEM_MORE)
            });
            pressTracing();
        };
        $[0] = pressTracing;
        $[1] = sendSectionItemAnalyticsEvent;
        $[2] = t1;
    } else t1 = $[2];
    const onClickMoreMenuTrigger = t1;
    if (moreMenuIds.length === 0) {
        let t2;
        if ($[3] !== appItemsData || $[4] !== productItemsData) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $vqZek.CustomizeSidebar), {
                productItemsData: productItemsData,
                appItemsData: appItemsData
            });
            $[3] = appItemsData;
            $[4] = productItemsData;
            $[5] = t2;
        } else t2 = $[5];
        return t2;
    }
    let t2;
    if ($[6] !== getAppShortcutURL) {
        t2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c2v96.MoreMenuItem), {
                ...props,
                getAppShortcutURL: getAppShortcutURL
            });
        $[6] = getAppShortcutURL;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== appItemsData || $[9] !== productItemsData) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $vqZek.CustomizeSidebar), {
            productItemsData: productItemsData,
            appItemsData: appItemsData
        });
        $[8] = appItemsData;
        $[9] = productItemsData;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== peekMenuId) {
        t4 = peekMenuId ? [
            peekMenuId
        ] : undefined;
        $[11] = peekMenuId;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== appItemsData || $[14] !== onClickMoreMenuTrigger || $[15] !== productItemsData || $[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jH4ta.GlobalMoreMenu), {
            productItemsData: productItemsData,
            appItemsData: appItemsData,
            menuItemComponent: t2,
            customizeSidebarMenuItem: t3,
            peekingMenuIds: t4,
            onClickMoreMenuTrigger: onClickMoreMenuTrigger
        });
        $[13] = appItemsData;
        $[14] = onClickMoreMenuTrigger;
        $[15] = productItemsData;
        $[16] = t2;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    const moreMenu = t5;
    let t6;
    if ($[20] !== menuData) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5LseV.PeekMenuItem), {
            menuData: menuData
        });
        $[20] = menuData;
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] !== moreMenu) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
            role: "listitem",
            id: (0, $i860n.fg)("ops-overview-disc-spotlights") ? "more-button-menu-item" : undefined
        }, moreMenu);
        $[22] = moreMenu;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== t6 || $[25] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jyCdG.default), {
            name: "nav4-sidebar-customization"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            fallback: "flag",
            id: "sidebar-customization",
            packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCore",
            teamName: "Navigation"
        }, t6, t7));
        $[24] = t6;
        $[25] = t7;
        $[26] = t8;
    } else t8 = $[26];
    return t8;
}
$a7aacefd4d29cc43$export$64f537f23c5bcad6.displayName = "SidebarCustomization";

});
parcelRegister("c2v96", function(module, exports) {
$parcel$export(module.exports, "MoreMenuItem", () => $a85786d489dd5486$export$e967513bbeba0537);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $dx7aH = parcelRequire("dx7aH");

var $ggvFe = parcelRequire("ggvFe");

var $hFa7f = parcelRequire("hFa7f");

var $3rqDf = parcelRequire("3rqDf");

var $bOwox = parcelRequire("bOwox");

var $7l6jMC = parcelRequire("7l6jMC");

var $5IkoH = parcelRequire("5IkoH");

var $af94c = parcelRequire("af94c");

var $1Io8b = parcelRequire("1Io8b");

var $e6rNk = parcelRequire("e6rNk");

var $i860n = parcelRequire("i860n");
function $a85786d489dd5486$export$e967513bbeba0537(t0) {
    const $ = (0, $e7boj.c)(29);
    const { menuId: menuId, closeMenu: closeMenu, key: key, getAppShortcutURL: getAppShortcutURL } = t0;
    const { setPeekMenuId: setPeekMenuId } = (0, $euxye.useContext)((0, $ggvFe.PeekMenuIdContext));
    let t1;
    if ($[0] !== menuId) {
        t1 = (0, $hFa7f.convertToConfigurableMenuId)(menuId);
        $[0] = menuId;
        $[1] = t1;
    } else t1 = $[1];
    const configurableId = t1;
    let t2;
    if ($[2] !== menuId) {
        t2 = (0, $7l6jMC.isGlobalAppMenuId)(menuId);
        $[2] = menuId;
        $[3] = t2;
    } else t2 = $[3];
    const isGlobalApp = t2;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)(configurableId);
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    let t3;
    if ($[4] !== getAppShortcutURL || $[5] !== isGlobalApp || $[6] !== menuId) {
        t3 = ()=>{
            if (!isGlobalApp || !getAppShortcutURL) return;
            if ((0, $5IkoH.GLOBAL_APP_MENU_ID_TO_APS_KEY)[menuId]) {
                const apsKey = (0, $5IkoH.GLOBAL_APP_MENU_ID_TO_APS_KEY)[menuId];
                return getAppShortcutURL(apsKey);
            }
        };
        $[4] = getAppShortcutURL;
        $[5] = isGlobalApp;
        $[6] = menuId;
        $[7] = t3;
    } else t3 = $[7];
    const getProductUrl = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $af94c.getUserNavigationItemLinks)();
        $[8] = t4;
    } else t4 = $[8];
    const USER_NAVIGATION_ITEM_LINKS = t4;
    let t5;
    if ($[9] !== getProductUrl || $[10] !== menuId) {
        t5 = getProductUrl() || USER_NAVIGATION_ITEM_LINKS[menuId];
        $[9] = getProductUrl;
        $[10] = menuId;
        $[11] = t5;
    } else t5 = $[11];
    const url = t5;
    let t6;
    if ($[12] !== closeMenu || $[13] !== configurableId || $[14] !== isGlobalApp || $[15] !== sendSectionItemAnalyticsEvent || $[16] !== setPeekMenuId) {
        t6 = ()=>{
            closeMenu();
            if (!isGlobalApp) setPeekMenuId(configurableId);
            sendSectionItemAnalyticsEvent({
                menuId: configurableId,
                sectionItem: (0, $bOwox.SECTION_ITEM_MAP)[configurableId]
            });
        };
        $[12] = closeMenu;
        $[13] = configurableId;
        $[14] = isGlobalApp;
        $[15] = sendSectionItemAnalyticsEvent;
        $[16] = setPeekMenuId;
        $[17] = t6;
    } else t6 = $[17];
    const onClick = t6;
    let t7;
    if ($[18] !== formattedMessage || $[19] !== icon || $[20] !== isGlobalApp || $[21] !== key || $[22] !== onClick || $[23] !== url) {
        t7 = url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e6rNk.LinkMenuItem), {
            elemBefore: icon,
            href: url,
            onClick: onClick,
            key: key,
            target: isGlobalApp ? "_blank" : undefined
        }, formattedMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1Io8b.ButtonMenuItem), {
            elemBefore: icon,
            onClick: onClick,
            key: key
        }, formattedMessage);
        $[18] = formattedMessage;
        $[19] = icon;
        $[20] = isGlobalApp;
        $[21] = key;
        $[22] = onClick;
        $[23] = url;
        $[24] = t7;
    } else t7 = $[24];
    const menuItemContent = t7;
    if (configurableId === "jira.sidebar.operations" && (0, $i860n.fg)("ops-overview-disc-spotlights")) {
        let t8;
        if ($[25] !== menuItemContent) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
                id: "ops-disc-operations-menu-item-spotlight-target"
            }, menuItemContent);
            $[25] = menuItemContent;
            $[26] = t8;
        } else t8 = $[26];
        return t8;
    }
    let t8;
    if ($[27] !== menuItemContent) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, menuItemContent);
        $[27] = menuItemContent;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
}
$a85786d489dd5486$export$e967513bbeba0537.displayName = "MoreMenuItem";

});
parcelRegister("hFa7f", function(module, exports) {
$parcel$export(module.exports, "convertToConfigurableMenuId", () => $f0ea1190a5631e4b$export$c54090f9034b2d83);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
const $f0ea1190a5631e4b$export$c54090f9034b2d83 = (menuId)=>{
    switch(menuId){
        case 'jira.sidebar.apps':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).APPS;
        case 'jira.sidebar.assets':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).ASSETS;
        case 'jira.sidebar.dashboards':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).DASHBOARDS;
        case 'jira.sidebar.filters':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).FILTERS;
        case 'jira.sidebar.goals':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).GOALS;
        case 'jira.sidebar.operations':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).OPERATIONS;
        case 'jira.sidebar.plans':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).PLANS;
        case 'jira.sidebar.projects':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).PROJECTS;
        case 'jira.sidebar.recent':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).RECENT;
        case 'jira.sidebar.starred':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).STARRED;
        case 'jira.sidebar.teams':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).TEAMS;
        case 'jira.sidebar.roadmaps':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).ROADMAPS;
        case 'jira.sidebar.customerService':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE;
        case 'jira.sidebar.customerServiceAnalytics':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE_ANALYTICS;
        case 'jira.sidebar.customerConversationsAnalytics':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).CUSTOMER_CONVERSATIONS_ANALYTICS;
        case 'jira.sidebar.customers':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).CUSTOMERS;
        case 'jira.sidebar.globalApp.assets':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).GLOBAL_APP_ASSETS;
        case 'jira.sidebar.globalApp.goals':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).GLOBAL_APP_GOALS;
        case 'jira.sidebar.globalApp.confluence':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).GLOBAL_APP_CONFLUENCE;
        case 'jira.sidebar.globalApp.teams':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).GLOBAL_APP_TEAMS;
        case 'jira.sidebar.globalApp.projects':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).GLOBAL_APP_PROJECTS;
        case 'jira.sidebar.globalApp.loom':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).GLOBAL_APP_LOOM;
        case 'jira.sidebar.globalApp.opsgenie':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).GLOBAL_APP_OPSGENIE;
        case 'jira.sidebar.itam':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).ITAM;
        case 'jira.sidebar.helpCenterManagement':
            return (0, $5IkoH.CONFIGURABLE_MENU_ID).HELP_CENTER_MANAGEMENT;
        default:
            throw new Error(`Invalid menuId: ${menuId}`);
    }
};

});


parcelRegister("5LseV", function(module, exports) {
$parcel$export(module.exports, "PeekMenuItem", () => $9160d5bb0699356b$export$4287f527b7969caa);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $ggvFe = parcelRequire("ggvFe");

var $bGsfC = parcelRequire("bGsfC");
const $9160d5bb0699356b$export$4287f527b7969caa = (t0)=>{
    const $ = (0, $e7boj.c)(4);
    const { menuData: menuData } = t0;
    const { moreMenuIds: moreMenuIds } = (0, $euxye.useContext)((0, $ggvFe.NavItemsContext));
    const { peekMenuId: peekMenuId } = (0, $euxye.useContext)((0, $ggvFe.PeekMenuIdContext));
    let t1;
    if ($[0] !== menuData || $[1] !== moreMenuIds || $[2] !== peekMenuId) {
        t1 = !!peekMenuId && moreMenuIds.includes(peekMenuId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bGsfC.ConfigurableMenuItem), {
            isDefaultOpen: true,
            menuData: menuData,
            menuId: peekMenuId
        });
        $[0] = menuData;
        $[1] = moreMenuIds;
        $[2] = peekMenuId;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
$9160d5bb0699356b$export$4287f527b7969caa.displayName = "PeekMenuItem";

});

parcelRegister("vqZek", function(module, exports) {
$parcel$export(module.exports, "CustomizeSidebar", () => $9088e2e0af4c1832$export$bfa967364825ce72);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $lrnU1 = parcelRequire("lrnU1");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $isqzs = parcelRequire("isqzs");

var $5R5qg = parcelRequire("5R5qg");
const $9088e2e0af4c1832$var$customizeSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu-items.sidebar-customization.customize-sidebar-menu-item.customize-sidebar",
    defaultMessage: "Customize sidebar"
});
const $9088e2e0af4c1832$export$bfa967364825ce72 = /*#__PURE__*/ (0, $euxye.forwardRef)($9088e2e0af4c1832$export$efb28913c0269ef5);
function $9088e2e0af4c1832$export$efb28913c0269ef5(t0, buttonRef) {
    const $ = (0, $e7boj.c)(16);
    let appItemsData;
    let productItemsData;
    let props;
    if ($[0] !== t0) {
        ({ productItemsData: productItemsData, appItemsData: appItemsData, ...props } = t0);
        $[0] = t0;
        $[1] = appItemsData;
        $[2] = productItemsData;
        $[3] = props;
    } else {
        appItemsData = $[1];
        productItemsData = $[2];
        props = $[3];
    }
    let t1;
    if ($[4] !== appItemsData || $[5] !== productItemsData) {
        t1 = {
            productItemsData: productItemsData,
            appItemsData: appItemsData
        };
        $[4] = appItemsData;
        $[5] = productItemsData;
        $[6] = t1;
    } else t1 = $[6];
    const entryPointParams = t1;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    let t2;
    if ($[7] !== formatMessage) {
        t2 = formatMessage($9088e2e0af4c1832$var$customizeSidebar);
        $[7] = formatMessage;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== buttonRef || $[10] !== props) {
        t3 = (t4)=>{
            const { ref: ref } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5R5qg.CustomizeSidebarMenuItem), {
                ...props,
                ref: ref || buttonRef
            });
        };
        $[9] = buttonRef;
        $[10] = props;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== entryPointParams || $[13] !== t2 || $[14] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $isqzs.ModalEntryPointPressableTrigger), {
            entryPoint: (0, $lrnU1.CustomisableSidebarModalEntrypoint),
            entryPointProps: entryPointParams,
            title: t2,
            useInternalModal: false
        }, t3);
        $[12] = entryPointParams;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
    } else t4 = $[15];
    return t4;
}
$9088e2e0af4c1832$export$efb28913c0269ef5.displayName = "CustomizeSidebarInner";

});
parcelRegister("lrnU1", function(module, exports) {
$parcel$export(module.exports, "CustomisableSidebarModalEntrypoint", () => $0c01fb5a14e9fba0$export$420f0b14c9bb574e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $0c01fb5a14e9fba0$export$420f0b14c9bb574e = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("cThrt")), {
        moduleId: "41d4d911",
        moduleName: "JiraCustomizationModal",
        priority: "interaction"
    }),
    getPreloadProps: (props)=>({
            queries: {},
            props: props
        })
});

});
parcelRegister("cThrt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("Ra9VF").then(()=>parcelRequire('d1sFs'));

});


parcelRegister("5R5qg", function(module, exports) {
$parcel$export(module.exports, "CustomizeSidebarMenuItem", () => $94bbd57d57133a39$export$b7fa0daee00ba08b);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $KL7Bq = parcelRequire("KL7Bq");

var $3rqDf = parcelRequire("3rqDf");

var $bOwox = parcelRequire("bOwox");

var $cKxq6 = parcelRequire("cKxq6");

var $1Io8b = parcelRequire("1Io8b");

var $7eNDO = parcelRequire("7eNDO");
const $94bbd57d57133a39$var$customizeSidebar = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu-items.sidebar-customization.customize-sidebar-menu-item.customize-sidebar",
    defaultMessage: "Customize sidebar"
});
const $94bbd57d57133a39$export$b7fa0daee00ba08b = /*#__PURE__*/ (0, $euxye.forwardRef)((t0, ref)=>{
    const $ = (0, $e7boj.c)(12);
    let onClick;
    let props;
    if ($[0] !== t0) {
        ({ onClick: onClick, ...props } = t0);
        $[0] = t0;
        $[1] = onClick;
        $[2] = props;
    } else {
        onClick = $[1];
        props = $[2];
    }
    const { formattedMessage: formattedMessage, icon: icon } = (0, $KL7Bq.useFormattedMessageAndIcon)($94bbd57d57133a39$var$customizeSidebar, (0, (/*@__PURE__*/$parcel$interopDefault($cKxq6))));
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    let t1;
    if ($[3] !== onClick || $[4] !== sendSectionItemAnalyticsEvent) {
        t1 = (event, analyticsEvent)=>{
            sendSectionItemAnalyticsEvent({
                sectionItem: (0, $bOwox.SECTION_ITEM_CUSTOMIZE_SIDEBAR)
            });
            onClick?.(event, analyticsEvent);
        };
        $[3] = onClick;
        $[4] = sendSectionItemAnalyticsEvent;
        $[5] = t1;
    } else t1 = $[5];
    const onClickHandler = t1;
    let t2;
    if ($[6] !== formattedMessage || $[7] !== icon || $[8] !== onClickHandler || $[9] !== props || $[10] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1Io8b.ButtonMenuItem), {
            ...props,
            interactionName: "nav4-sidebar-customise-modal",
            elemBefore: icon,
            onClick: onClickHandler,
            ref: ref
        }, formattedMessage);
        $[6] = formattedMessage;
        $[7] = icon;
        $[8] = onClickHandler;
        $[9] = props;
        $[10] = ref;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
});

});



parcelRegister("37Waq", function(module, exports) {
$parcel$export(module.exports, "PeekMenuIdContextProvider", () => $f21c822633e4ce2c$export$b7d1a20f5a877f18);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $4Onaa = parcelRequire("4Onaa");

var $5IkoH = parcelRequire("5IkoH");

var $19zz3 = parcelRequire("19zz3");

var $1lRyZ = parcelRequire("1lRyZ");

var $ggvFe = parcelRequire("ggvFe");
/**
 * Routes where sidebar peek is disabled.
 * On these routes, the selected path is used for highlighting only, not for auto-expanding.
 * Mirrors the equivalent guard in
 * `@jira/nav-platform-integration__sidebar` (`usePeekMenuId`).
 */ const $f21c822633e4ce2c$var$PEEK_DISABLED_ROUTES = new Set([
    'for-you'
]);
// Eventually this will be all configurable menu ids and can be removed at that point.
// TODO: Adam, I think we've reached that point.
const $f21c822633e4ce2c$var$CONFIGURABLE_MENU_IDS_USING_SIDEBAR_CONTEXT = [
    (0, $5IkoH.CONFIGURABLE_MENU_ID).ASSETS,
    (0, $5IkoH.CONFIGURABLE_MENU_ID).APPS,
    (0, $5IkoH.CONFIGURABLE_MENU_ID).DASHBOARDS,
    (0, $5IkoH.CONFIGURABLE_MENU_ID).FILTERS,
    (0, $5IkoH.CONFIGURABLE_MENU_ID).OPERATIONS,
    (0, $5IkoH.CONFIGURABLE_MENU_ID).PLANS,
    (0, $5IkoH.CONFIGURABLE_MENU_ID).PROJECTS
];
const $f21c822633e4ce2c$export$b7d1a20f5a877f18 = (t0)=>{
    const $ = (0, $e7boj.c)(18);
    const { children: children } = t0;
    const { isSelectedPath: isSelectedPath } = (0, $19zz3.useSidebarNav4)();
    const { isControlledNav: isControlledNav, isControlledPath: isControlledPath } = (0, $1lRyZ.useSidebarNav4Controller)();
    const { moreMenuIds: moreMenuIds } = (0, $euxye.useContext)((0, $ggvFe.NavItemsContext));
    const currentRoute = (0, $4Onaa.useCurrentRoute)();
    const currentRouteName = currentRoute.name;
    let t1;
    if ($[0] !== currentRouteName || $[1] !== isControlledNav || $[2] !== isControlledPath || $[3] !== isSelectedPath || $[4] !== moreMenuIds) {
        t1 = ()=>$f21c822633e4ce2c$var$getAutoPeekMenuId(isSelectedPath, isControlledNav, isControlledPath, moreMenuIds, currentRouteName);
        $[0] = currentRouteName;
        $[1] = isControlledNav;
        $[2] = isControlledPath;
        $[3] = isSelectedPath;
        $[4] = moreMenuIds;
        $[5] = t1;
    } else t1 = $[5];
    const [peekMenuId, setPeekMenuId] = (0, $euxye.useState)(t1);
    let t2;
    let t3;
    if ($[6] !== currentRouteName || $[7] !== isControlledNav || $[8] !== isControlledPath || $[9] !== isSelectedPath || $[10] !== moreMenuIds) {
        t2 = ()=>setPeekMenuId((currentPeekMenuId)=>$f21c822633e4ce2c$var$getAutoPeekMenuId(isSelectedPath, isControlledNav, isControlledPath, moreMenuIds, currentRouteName, currentPeekMenuId));
        t3 = [
            isControlledNav,
            isControlledPath,
            isSelectedPath,
            moreMenuIds,
            currentRouteName
        ];
        $[6] = currentRouteName;
        $[7] = isControlledNav;
        $[8] = isControlledPath;
        $[9] = isSelectedPath;
        $[10] = moreMenuIds;
        $[11] = t2;
        $[12] = t3;
    } else {
        t2 = $[11];
        t3 = $[12];
    }
    (0, $euxye.useLayoutEffect)(t2, t3);
    let t4;
    if ($[13] !== peekMenuId) {
        t4 = {
            peekMenuId: peekMenuId,
            setPeekMenuId: setPeekMenuId
        };
        $[13] = peekMenuId;
        $[14] = t4;
    } else t4 = $[14];
    const peekMenuIdContext = t4;
    let t5;
    if ($[15] !== children || $[16] !== peekMenuIdContext) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ggvFe.PeekMenuIdContext).Provider, {
            value: peekMenuIdContext
        }, children);
        $[15] = children;
        $[16] = peekMenuIdContext;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
};
$f21c822633e4ce2c$export$b7d1a20f5a877f18.displayName = "PeekMenuIdContextProvider";
const $f21c822633e4ce2c$var$getAutoPeekMenuId = (isSelectedPath, isControlledNav, isControlledPath, moreMenuIds, currentRouteName, peekMenuId)=>{
    // When controlled...
    if (isControlledNav) return moreMenuIds.find(isControlledPath);
    // Otherwise selected...
    const autoPeekMenuId = moreMenuIds.find(isSelectedPath);
    if ($f21c822633e4ce2c$var$PEEK_DISABLED_ROUTES.has(currentRouteName)) return undefined;
    // Once all configurable menu ids are using sidebar context we can just return `autoPeekMenuId`.
    if (autoPeekMenuId) return autoPeekMenuId;
    // Unpeek if peek menu id is no longer selected.
    // Only do this for menu ids using the sidebar context for now.
    // Legacy menu ids set peek menu id manually.
    if (peekMenuId && $f21c822633e4ce2c$var$CONFIGURABLE_MENU_IDS_USING_SIDEBAR_CONTEXT.includes(peekMenuId)) return undefined;
    // Otherwise unchanged.
    return peekMenuId;
};

});

parcelRegister("4wRyN", function(module, exports) {
$parcel$export(module.exports, "GlobalShortcutsWithInvitePeopleProvider", () => $bd9b360bb096b174$export$19459237290a4ec4);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $e4f4V = parcelRequire("e4f4V");

var $h8QGu = parcelRequire("h8QGu");

var $jyCdG = parcelRequire("jyCdG");

var $6GljB = parcelRequire("6GljB");

var $ggvFe = parcelRequire("ggvFe");

var $kt86l = parcelRequire("kt86l");

var $lNZ69 = parcelRequire("lNZ69");

var $iurTG = parcelRequire("iurTG");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $58v8Z = parcelRequire("58v8Z");

var $4VlOC = parcelRequire("4VlOC");

var $7UHPj = parcelRequire("7UHPj");

var $bcUWA = parcelRequire("bcUWA");
const $bd9b360bb096b174$var$GlobalShortcutsComponent = /*#__PURE__*/ (0, $euxye.memo)((t0)=>{
    const $ = (0, $e7boj.c)(25);
    const { appItemsData: appItemsData, teamsAppConfig: teamsAppConfig, handleUpdateGetFilteredProductLinks: handleUpdateGetFilteredProductLinks } = t0;
    const cloudId = (0, $kt86l.useCloudId)();
    const { visibleMenuIds: visibleMenuIds } = (0, $euxye.useContext)((0, $ggvFe.NavItemsContext));
    const invitedAppShortcutsExperiment = (0, $bcUWA.useResolveInvitedAppShortcuts)();
    const getFilteredProductLinksRef = (0, $euxye.useRef)(null);
    let t1;
    if ($[0] !== invitedAppShortcutsExperiment) {
        t1 = (0, $i860n.fg)("twcg-460-personalised-invite-notifications-m2-gate") && invitedAppShortcutsExperiment.ineligibilityReason === null && invitedAppShortcutsExperiment.invitedApps?.confluence?.eligible === true;
        $[0] = invitedAppShortcutsExperiment;
        $[1] = t1;
    } else t1 = $[1];
    const isEligibleToSeeInvitedAppShortcuts = t1;
    let t2;
    if ($[2] !== isEligibleToSeeInvitedAppShortcuts) {
        t2 = isEligibleToSeeInvitedAppShortcuts && (0, $2700E.expVal)("twcg-460-personalised-invite-notifications-m2", "isEnabled", false);
        $[2] = isEligibleToSeeInvitedAppShortcuts;
        $[3] = t2;
    } else t2 = $[3];
    const isInvitedAppShortcutsEnabled = t2;
    const licenceFilterMap = (0, $4VlOC.useLicenseFilterMap)(teamsAppConfig);
    const hasConfluenceLicence = Boolean(licenceFilterMap[(0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]);
    const shouldShowInvitedAppShortcuts = isInvitedAppShortcutsEnabled && hasConfluenceLicence;
    let t3;
    if ($[4] !== handleUpdateGetFilteredProductLinks || $[5] !== invitedAppShortcutsExperiment || $[6] !== visibleMenuIds) {
        t3 = (getFilteredProductLinks)=>{
            if (handleUpdateGetFilteredProductLinks) handleUpdateGetFilteredProductLinks(getFilteredProductLinks);
            if ((0, $i860n.fg)("twcg-460-personalised-invite-notifications-m2-gate")) {
                getFilteredProductLinksRef.current = getFilteredProductLinks;
                invitedAppShortcutsExperiment.updateFromAppAccessFilter({
                    getFilteredProductLinks: getFilteredProductLinks,
                    limitToOnlyApsKeys: [
                        "CONFLUENCE"
                    ],
                    visibleMenuIds: visibleMenuIds
                });
            }
        };
        $[4] = handleUpdateGetFilteredProductLinks;
        $[5] = invitedAppShortcutsExperiment;
        $[6] = visibleMenuIds;
        $[7] = t3;
    } else t3 = $[7];
    const onUpdateGetFilteredProductLinks = t3;
    let t4;
    let t5;
    if ($[8] !== invitedAppShortcutsExperiment || $[9] !== isEligibleToSeeInvitedAppShortcuts) {
        t4 = ()=>{
            if (isEligibleToSeeInvitedAppShortcuts) invitedAppShortcutsExperiment.fireFeatureExposed({
                isEnabled: (0, $2700E.expVal)("twcg-460-personalised-invite-notifications-m2", "isEnabled", false)
            });
        };
        t5 = [
            isEligibleToSeeInvitedAppShortcuts,
            invitedAppShortcutsExperiment
        ];
        $[8] = invitedAppShortcutsExperiment;
        $[9] = isEligibleToSeeInvitedAppShortcuts;
        $[10] = t4;
        $[11] = t5;
    } else {
        t4 = $[10];
        t5 = $[11];
    }
    (0, $euxye.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[12] !== invitedAppShortcutsExperiment || $[13] !== visibleMenuIds) {
        t6 = ()=>{
            if (getFilteredProductLinksRef.current) invitedAppShortcutsExperiment.updateFromAppAccessFilter({
                getFilteredProductLinks: getFilteredProductLinksRef.current,
                limitToOnlyApsKeys: [
                    "CONFLUENCE"
                ],
                visibleMenuIds: visibleMenuIds
            });
        };
        t7 = [
            invitedAppShortcutsExperiment,
            visibleMenuIds
        ];
        $[12] = invitedAppShortcutsExperiment;
        $[13] = visibleMenuIds;
        $[14] = t6;
        $[15] = t7;
    } else {
        t6 = $[14];
        t7 = $[15];
    }
    (0, $euxye.useEffect)(t6, t7);
    let t8;
    if ($[16] !== appItemsData || $[17] !== cloudId || $[18] !== invitedAppShortcutsExperiment || $[19] !== licenceFilterMap || $[20] !== onUpdateGetFilteredProductLinks || $[21] !== shouldShowInvitedAppShortcuts) {
        t8 = ()=>{
            if (shouldShowInvitedAppShortcuts) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iurTG.InvitedAppShortcutsContainer), {
                shortcutsConfig: licenceFilterMap,
                resolverResult: invitedAppShortcutsExperiment
            }, (t9)=>{
                const { referrableShortcuts: referrableShortcuts } = t9;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7UHPj.ReorderShortcutsContainer), {
                    shortcutsConfig: referrableShortcuts,
                    appItemsData: appItemsData
                }, (t10)=>{
                    const { shortcuts: shortcuts } = t10;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lNZ69.GlobalShortcuts), {
                        cloudId: cloudId,
                        shortcutItems: shortcuts,
                        product: "jira",
                        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
                    });
                });
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7UHPj.ReorderShortcutsContainer), {
                shortcutsConfig: licenceFilterMap,
                appItemsData: appItemsData
            }, (t11)=>{
                const { shortcuts: shortcuts_0 } = t11;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lNZ69.GlobalShortcuts), {
                    cloudId: cloudId,
                    shortcutItems: shortcuts_0,
                    product: "jira",
                    onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
                });
            });
        };
        $[16] = appItemsData;
        $[17] = cloudId;
        $[18] = invitedAppShortcutsExperiment;
        $[19] = licenceFilterMap;
        $[20] = onUpdateGetFilteredProductLinks;
        $[21] = shouldShowInvitedAppShortcuts;
        $[22] = t8;
    } else t8 = $[22];
    const renderLegacyOrControlSidebar = t8;
    let t9;
    if ($[23] !== renderLegacyOrControlSidebar) {
        t9 = renderLegacyOrControlSidebar();
        $[23] = renderLegacyOrControlSidebar;
        $[24] = t9;
    } else t9 = $[24];
    return t9;
});
// Wrapper required to use teams app shortcut hook
const $bd9b360bb096b174$var$GlobalShortcutsInvitePeopleWrapper = (props)=>{
    const $ = (0, $e7boj.c)(6);
    const { component: teamsAppComponent, config: teamsAppConfig } = (0, $58v8Z.useTeamsAppShortcut)();
    let t0;
    if ($[0] !== props || $[1] !== teamsAppConfig) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($bd9b360bb096b174$var$GlobalShortcutsComponent, {
            ...props,
            teamsAppConfig: teamsAppConfig
        });
        $[0] = props;
        $[1] = teamsAppConfig;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== t0 || $[4] !== teamsAppComponent) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, teamsAppComponent, t0);
        $[3] = t0;
        $[4] = teamsAppComponent;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
$bd9b360bb096b174$var$GlobalShortcutsInvitePeopleWrapper.displayName = "GlobalShortcutsInvitePeopleWrapper";
const $bd9b360bb096b174$var$GlobalShortcutsInvitePeopleWrapperWithErrorBoundary = (props)=>{
    const $ = (0, $e7boj.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            id: "globalShortcutsInvitePeopleWrapper",
            teamName: "People and Teams Collective",
            fallback: "unmount",
            packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCore"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($bd9b360bb096b174$var$GlobalShortcutsInvitePeopleWrapper, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
$bd9b360bb096b174$var$GlobalShortcutsInvitePeopleWrapperWithErrorBoundary.displayName = "GlobalShortcutsInvitePeopleWrapperWithErrorBoundary";
const $bd9b360bb096b174$export$19459237290a4ec4 = (props)=>{
    const $ = (0, $e7boj.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jyCdG.default), {
            name: "nav4-sidebar-global-shortcuts"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e4f4V.JiraInvitePeopleModalContextProvider), {
            renderedInProjectContext: false,
            shouldDisplaySuccessModal: false
        }, (0, $i860n.fg)("teams-shortcut-error-boundary-jira") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($bd9b360bb096b174$var$GlobalShortcutsInvitePeopleWrapperWithErrorBoundary, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($bd9b360bb096b174$var$GlobalShortcutsInvitePeopleWrapper, props)));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
$bd9b360bb096b174$export$19459237290a4ec4.displayName = "GlobalShortcutsWithInvitePeopleProvider";
const $bd9b360bb096b174$export$bae2da217bf9db6 = (props)=>{
    const $ = (0, $e7boj.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jyCdG.default), {
            name: "nav4-sidebar-global-shortcuts"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            id: "globalShortcuts",
            teamName: "Navigation",
            fallback: "unmount",
            packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCore"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($bd9b360bb096b174$var$GlobalShortcutsComponent, props)));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
$bd9b360bb096b174$export$bae2da217bf9db6.displayName = "GlobalShortcuts";

});
parcelRegister("e4f4V", function(module, exports) {
$parcel$export(module.exports, "JiraInvitePeopleModalContextProvider", () => $57831329b5a0b6d6$export$cdc03757c913ed0);
$parcel$export(module.exports, "useJiraInvitePeopleModal", () => $57831329b5a0b6d6$export$39f09976987c1e17);
$parcel$export(module.exports, "useJiraInvitePeopleModalBound", () => $57831329b5a0b6d6$export$569fef33efef0114);

var $euxye = parcelRequire("euxye");

var $3UNZf = parcelRequire("3UNZf");

var $ccEzE = parcelRequire("ccEzE");

var $bs9jJ = parcelRequire("bs9jJ");

var $kt86l = parcelRequire("kt86l");
const $57831329b5a0b6d6$var$noop = ()=>null;
const $57831329b5a0b6d6$var$JiraInvitePeopleModalContext = /*#__PURE__*/ (0, $euxye.createContext)({
    isOpen: false,
    onOpen: $57831329b5a0b6d6$var$noop,
    onClose: $57831329b5a0b6d6$var$noop
});
const $57831329b5a0b6d6$export$cdc03757c913ed0 = ({ children: children, ...props })=>{
    // new invite people modal requirements
    const cloudId = (0, $kt86l.useCloudId)();
    const appEditions = (0, $ccEzE.useAppEditions)();
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    const [providerState, setProviderState] = (0, $euxye.useState)({
        props: {},
        isOpen: false
    });
    const onClose = (0, $euxye.useCallback)(()=>{
        setProviderState({
            props: {},
            isOpen: false
        });
    }, []);
    const onOpen = (0, $euxye.useCallback)((state)=>{
        setProviderState({
            props: state ?? {},
            isOpen: true
        });
    }, []);
    const value = (0, $euxye.useMemo)(()=>({
            isOpen: providerState.isOpen,
            onOpen: onOpen,
            onClose: onClose
        }), [
        providerState.isOpen,
        onOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($57831329b5a0b6d6$var$JiraInvitePeopleModalContext.Provider, {
        value: value
    }, providerState.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3UNZf.default), {
        appEdition: appEditions.software,
        cloudId: cloudId,
        isOpen: providerState.isOpen,
        onClose: onClose,
        isSiteAdmin: isSiteAdmin,
        isAdmin: isSiteAdmin,
        ...props,
        ...providerState.props
    }) : null, children);
};
$57831329b5a0b6d6$export$cdc03757c913ed0.displayName = "JiraInvitePeopleModalContextProvider";
const $57831329b5a0b6d6$export$39f09976987c1e17 = ()=>(0, $euxye.useContext)($57831329b5a0b6d6$var$JiraInvitePeopleModalContext);
const $57831329b5a0b6d6$export$569fef33efef0114 = (props)=>{
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose } = (0, $euxye.useContext)($57831329b5a0b6d6$var$JiraInvitePeopleModalContext);
    const openModal = (0, $euxye.useCallback)(()=>onOpen(props), [
        onOpen,
        props
    ]);
    return {
        isOpen: isOpen,
        openModal: openModal,
        closeModal: onClose
    };
};

});
parcelRegister("3UNZf", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad4e77883256e839$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ad4e77883256e839$var$LazyComponent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7Ehgp")), {
    ssr: false,
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/InvitePeopleWithAnalytics.tsx"
});
const $ad4e77883256e839$var$AsyncCoreInvitesProjectDialogComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ad4e77883256e839$var$LazyComponent, props)));
$ad4e77883256e839$var$AsyncCoreInvitesProjectDialogComponent.displayName = "AsyncCoreInvitesProjectDialogComponent";
var $ad4e77883256e839$export$2e2bcd8739ae039 = $ad4e77883256e839$var$AsyncCoreInvitesProjectDialogComponent;

});
parcelRegister("7Ehgp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("1frj8")
]).then(()=>parcelRequire('9g6eK'));

});



parcelRegister("iurTG", function(module, exports) {
$parcel$export(module.exports, "InvitedAppShortcutsContainer", () => $287ef12d2c94afe0$export$a06354f64c80dd3d);
/* main.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $hmszZ = parcelRequire("hmszZ");

var $aXeE9 = parcelRequire("aXeE9");

var $k7ixb = parcelRequire("k7ixb");

var $eBna3 = parcelRequire("eBna3");

var $itAmB = parcelRequire("itAmB");

var $aYiq4 = parcelRequire("aYiq4");

var $jnjMq = parcelRequire("jnjMq");
const $287ef12d2c94afe0$var$isAppImpressed = (appDetails)=>!!appDetails?.firstImpressionAt;
// eslint-disable-next-line @repo/internal/react/no-class-components -- using a class component for error boundary
class $287ef12d2c94afe0$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, _errorInfo) {
        this.props.fireInvitedAppShortcutsContainerRenderFailed({
            error: error.message,
            errorStack: error.stack,
            targetApps: Object.values(this.props.shortcutsConfig).map((shortcut)=>shortcut.analyticsName).filter(Boolean)
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback({
            referrableShortcuts: this.props.shortcutsConfig
        });
        return this.props.children;
    }
}
$287ef12d2c94afe0$var$ErrorBoundary.displayName = "ErrorBoundary";
const $287ef12d2c94afe0$var$InvitedAppShortcutsContainerExperiment = ({ shortcutsConfig: shortcutsConfig, resolverResult: resolverResult, hoverDelayTimeMs: hoverDelayTimeMs = 300, excludeLastFromRefs: excludeLastFromRefs = 0, children: children })=>{
    const { fireViewedInvitedAppShortcuts: fireViewedInvitedAppShortcuts } = (0, $k7ixb.useInvitedAppAnalytics)();
    // the popup shown state
    const [isPopupShown, setIsPopupShown] = (0, $euxye.useState)(false);
    const closePopupTimerRef = (0, $euxye.useRef)(null);
    // refs for the shortcut items
    const jiraShortcutRef = (0, $euxye.useRef)(null);
    const confluenceShortcutRef = (0, $euxye.useRef)(null);
    // Store unbind functions for cleanup
    const unbindFunctionsRef = (0, $euxye.useRef)(new Map());
    // Ref for the current shortcut item
    // the current shortcut item is unset when the popup is hidden after a delay
    const [currentShortcutRef, setCurrentShortcutRef] = (0, $euxye.useState)();
    // map of the shortcut items to their refs
    const shortcutRefs = (0, $euxye.useMemo)(()=>({
            JIRA_SOFTWARE: jiraShortcutRef,
            CONFLUENCE: confluenceShortcutRef
        }), // Refs are stable, no dependencies needed
    []);
    const showPopup = (0, $euxye.useCallback)(()=>{
        setIsPopupShown(true);
    }, [
        setIsPopupShown
    ]);
    const hidePopup = (0, $euxye.useCallback)(()=>{
        setIsPopupShown(false);
        setCurrentShortcutRef(undefined);
    }, [
        setIsPopupShown,
        setCurrentShortcutRef
    ]);
    const clearClosePopupTimer = (0, $euxye.useCallback)(()=>{
        if (closePopupTimerRef.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, []);
    const startClosePopupTimer = (0, $euxye.useCallback)(()=>{
        clearClosePopupTimer();
        closePopupTimerRef.current = setTimeout(()=>{
            hidePopup();
        }, hoverDelayTimeMs);
    }, [
        clearClosePopupTimer,
        hoverDelayTimeMs,
        hidePopup
    ]);
    /**
   * @param targetRef - the ref to the shortcut item
   * @returns a handler for the mouse over event on the shortcut item
   */ const handleMouseOverWithRef = (0, $euxye.useCallback)((targetRef)=>()=>{
            // clear the close popup timer to avoid closing the popup
            // when moving the mouse from the popup to the shortcut item
            clearClosePopupTimer();
            setCurrentShortcutRef(targetRef);
            showPopup();
        }, [
        clearClosePopupTimer,
        showPopup
    ]);
    /**
   * @param targetRef - the ref to the shortcut item
   * @returns a handler for the mouse leave event on the shortcut item
   */ const handleMouseLeaveWithRef = (0, $euxye.useCallback)(()=>()=>{
            if (currentShortcutRef?.current) currentShortcutRef.current.style.backgroundColor = '';
            startClosePopupTimer();
        }, [
        currentShortcutRef,
        startClosePopupTimer
    ]);
    /**
   * @param targetRef - the ref to the shortcut item
   * @returns a callback ref for a shortcut item
   */ const createShortcutRef = (0, $euxye.useCallback)((targetRef)=>(node)=>{
            // Cleanup previous element if it exists
            const existingUnbind = unbindFunctionsRef.current.get(targetRef);
            if (existingUnbind) {
                existingUnbind();
                unbindFunctionsRef.current.delete(targetRef);
            }
            // Store the new element
            // oxlint-disable-next-line no-param-reassign
            targetRef.current = node;
            // Attach listeners to new element
            if (node) {
                const mouseoverListener = handleMouseOverWithRef(targetRef);
                const focusListener = handleMouseOverWithRef(targetRef);
                const mouseleaveListener = handleMouseLeaveWithRef();
                const blurListener = handleMouseLeaveWithRef();
                // Use bind-event-listener to bind all events and get an unbind function
                const unbind = (0, $glbdM.bindAll)(node, [
                    {
                        type: 'mouseover',
                        listener: mouseoverListener
                    },
                    {
                        type: 'focus',
                        listener: focusListener
                    },
                    {
                        type: 'mouseleave',
                        listener: mouseleaveListener
                    },
                    {
                        type: 'blur',
                        listener: blurListener
                    }
                ]);
                // Store the unbind function for cleanup
                unbindFunctionsRef.current.set(targetRef, unbind);
            }
        }, [
        handleMouseOverWithRef,
        handleMouseLeaveWithRef
    ]);
    /**
   * Handles the popup shown event
   * @returns a handler for the popup shown event
   */ const handleOnMouseEnterPopup = (0, $euxye.useCallback)(()=>{
        // clear the close popup timer to avoid closing the popup too early
        clearClosePopupTimer();
        if (currentShortcutRef?.current) {
            // Get the parent element of the shortcut item
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) // reference the background color variable from the design system
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/4ff76dcfb3ce12b4344e5345be748ce472ac56e7/platform/packages/design-system/navigation-system/src/ui/menu-item/menu-item.tsx#lines-166
            parentElement.style.backgroundColor = "var(--ds-surface-hovered, #F0F1F2)";
        }
        // ensure the popup is shown when mouse leaves the shortcut item and over the popup
        showPopup();
    }, [
        clearClosePopupTimer,
        showPopup,
        currentShortcutRef
    ]);
    /**
   * Handles the popup closed event
   * @returns a handler for the popup closed event
   */ const handleOnMouseLeavePopup = (0, $euxye.useCallback)(()=>{
        if (currentShortcutRef?.current) {
            // Get the parent element of the shortcut item
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) parentElement.style.backgroundColor = '';
        }
        startClosePopupTimer();
    }, [
        currentShortcutRef,
        startClosePopupTimer
    ]);
    const referrableShortcuts = (0, $euxye.useMemo)(()=>{
        const entries = Object.entries(shortcutsConfig);
        const max = Math.min(entries.length, Object.values(resolverResult.invitedApps ?? {}).filter((app)=>app?.eligible).length);
        const refsLimit = max - excludeLastFromRefs;
        let createdRefsCount = 0;
        return entries.reduce((acc, [key, shortcut])=>{
            // only add ref to shortcuts that are within the refs limit
            // and if it is a link and the aps key is allowed
            if (createdRefsCount < refsLimit && shortcut.type === 'link' && shortcut.apsKey && resolverResult.invitedApps?.[(0, $hmszZ.getAppKeyByApsKey)(shortcut.apsKey)]?.eligible) {
                const apsKey = shortcut.apsKey;
                const app = (0, $hmszZ.getAppKeyByApsKey)(apsKey);
                const targetRef = shortcutRefs[apsKey];
                const originalOnClick = shortcut.onClick;
                acc[key] = {
                    ...shortcut,
                    onClick: (evt)=>{
                        resolverResult.registerActivation(app);
                        return originalOnClick?.(evt);
                    },
                    ref: targetRef ? createShortcutRef(targetRef) : undefined,
                    labelElem: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $aYiq4.InvitedAppShortcutLabel), {
                        apsKey: apsKey,
                        label: shortcut.label
                    })
                };
                // oxlint-disable-next-line no-plusplus
                createdRefsCount++;
            } else acc[key] = shortcut;
            return acc;
        }, {});
    }, [
        shortcutsConfig,
        resolverResult,
        createShortcutRef,
        shortcutRefs,
        excludeLastFromRefs
    ]);
    (0, $euxye.useEffect)(()=>{
        const currentUnbindFunctions = unbindFunctionsRef.current;
        const currentShortcutRefs = shortcutRefs;
        return ()=>{
            // Clean up all event listeners using the stored unbind functions
            Object.values(currentShortcutRefs).forEach((ref)=>{
                const unbind = currentUnbindFunctions.get(ref);
                if (unbind) {
                    unbind();
                    currentUnbindFunctions.delete(ref);
                }
            });
            clearClosePopupTimer();
        };
    }, [
        clearClosePopupTimer,
        shortcutRefs
    ]);
    const currentApsKey = (0, $euxye.useMemo)(()=>Object.keys(shortcutRefs).find((apsKey)=>currentShortcutRef?.current === shortcutRefs[apsKey]?.current), [
        shortcutRefs,
        currentShortcutRef
    ]);
    const currentAppKey = currentApsKey && (0, $hmszZ.getAppKeyByApsKey)(currentApsKey);
    const currentAppResolved = currentAppKey && resolverResult.invitedApps?.[currentAppKey];
    const currentAppCollaborators = (0, $euxye.useMemo)(()=>currentAppResolved?.collaborators?.map((collab)=>({
                name: '',
                src: collab?.avatar
            })) ?? [], [
        currentAppResolved?.collaborators
    ]);
    // Stable identity for the popup's discriminated union prop so the popup
    // boundary stays memo-friendly (avoids re-renders on unrelated container
    // updates). PUMA-1997 will introduce a `kind: 'lazy'` branch here.
    const collaboratorsSource = (0, $euxye.useMemo)(()=>({
            kind: 'static',
            collaborators: currentAppCollaborators
        }), [
        currentAppCollaborators
    ]);
    // Stable callback for the popup's accept-invite click. Re-created only
    // when `resolverResult` identity changes.
    const handleAcceptInvite = (0, $euxye.useCallback)((app)=>resolverResult?.registerActivation(app), [
        resolverResult
    ]);
    const currentShortcutLink = (0, $euxye.useMemo)(()=>currentShortcutRef?.current?.href, [
        currentShortcutRef
    ]);
    (0, $euxye.useEffect)(()=>{
        // These are the app keys for which we'll be displaying our treatment
        const invitedAppShortcutKeys = Object.values(referrableShortcuts).reduce((acc, shortcut)=>{
            if (shortcut.type === 'link' && (0, $hmszZ.isAllowedApsKey)(shortcut.apsKey) && !!shortcut.ref) acc.push((0, $hmszZ.getAppKeyByApsKey)(shortcut.apsKey));
            return acc;
        }, []);
        resolverResult.registerImpression({
            products: invitedAppShortcutKeys
        });
        // Fire an analytics event when the user views the invited app shortcuts
        if (invitedAppShortcutKeys.length > 0) {
            const firstImpressedApps = invitedAppShortcutKeys.filter((app)=>!resolverResult.invitedApps?.[app]?.firstImpressionAt);
            fireViewedInvitedAppShortcuts(invitedAppShortcutKeys, firstImpressedApps);
        }
    }, [
        referrableShortcuts,
        resolverResult,
        fireViewedInvitedAppShortcuts
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $aXeE9.InvitedAppShortcutsContext).Provider, {
        value: (0, $euxye.useMemo)(()=>({
                impressedProducts: {
                    JIRA_SOFTWARE: $287ef12d2c94afe0$var$isAppImpressed(resolverResult.invitedApps?.jira),
                    CONFLUENCE: $287ef12d2c94afe0$var$isAppImpressed(resolverResult.invitedApps?.confluence)
                }
            }), [
            resolverResult.invitedApps
        ]),
        children: [
            children({
                referrableShortcuts: referrableShortcuts
            }),
            isPopupShown && currentShortcutRef && currentShortcutLink && currentApsKey && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jnjMq.LazyInvitedAppPopup), {
                trigger: currentShortcutRef,
                onMouseEnterPopup: handleOnMouseEnterPopup,
                onMouseLeavePopup: handleOnMouseLeavePopup,
                currentApsKey: currentApsKey,
                collaboratorsSource: collaboratorsSource,
                currentShortcutLink: currentShortcutLink,
                onAcceptInvite: handleAcceptInvite
            })
        ]
    });
};
$287ef12d2c94afe0$var$InvitedAppShortcutsContainerExperiment.displayName = "InvitedAppShortcutsContainerExperiment";
const $287ef12d2c94afe0$export$a06354f64c80dd3d = (props)=>{
    const { fireInvitedAppShortcutsContainerRenderFailed: fireInvitedAppShortcutsContainerRenderFailed } = (0, $k7ixb.useInvitedAppAnalytics)();
    // Branch first on the discriminant so each branch destructures with
    // full type narrowing (no `as` cast, no IIFE).
    if (props.mode === 'productionisation') {
        const { mode: _mode, cloudId: cloudId, userId: userId, recommendedApps: recommendedApps, sourceApp: sourceApp, ...inner } = props;
        return /*#__PURE__*/ (0, $e79Pd.jsx)($287ef12d2c94afe0$var$ErrorBoundary, {
            fallback: inner.children,
            shortcutsConfig: inner.shortcutsConfig,
            fireInvitedAppShortcutsContainerRenderFailed: fireInvitedAppShortcutsContainerRenderFailed,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $itAmB.InvitedAppCollaboratorsLazyProvider), {
                cloudId: cloudId,
                userId: userId,
                // Collaborator fetching is variant-agnostic, so it keeps taking
                // plain product keys rather than propagating the union.
                eligibleApps: (0, $hmszZ.toRecommendedProducts)(recommendedApps),
                sourceApp: sourceApp,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eBna3.InvitedAppShortcutsContainerProdInner), {
                    ...inner,
                    cloudId: cloudId,
                    sourceApp: sourceApp
                })
            })
        });
    }
    const { mode: _mode, ...inner } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)($287ef12d2c94afe0$var$ErrorBoundary, {
        fallback: inner.children,
        shortcutsConfig: inner.shortcutsConfig,
        fireInvitedAppShortcutsContainerRenderFailed: fireInvitedAppShortcutsContainerRenderFailed,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($287ef12d2c94afe0$var$InvitedAppShortcutsContainerExperiment, {
            ...inner
        })
    });
};
$287ef12d2c94afe0$export$a06354f64c80dd3d.displayName = "InvitedAppShortcutsContainer";

});
parcelRegister("hmszZ", function(module, exports) {
$parcel$export(module.exports, "isAllowedApsKey", () => $9ed5032721563d4e$export$f45e7800f1f61594);
$parcel$export(module.exports, "parseInvitedAppShortcutEntityId", () => $9ed5032721563d4e$export$dbd5a13f1931b53e);
$parcel$export(module.exports, "toRecommendedProducts", () => $9ed5032721563d4e$export$f5547ce9712f2015);
$parcel$export(module.exports, "getAppKeyByApsKey", () => $9ed5032721563d4e$export$b8c071b2cc567f75);

var $eHYqk = parcelRequire("eHYqk");
const $9ed5032721563d4e$export$f45e7800f1f61594 = (apsKey)=>{
    if (!apsKey) return false;
    return (0, $eHYqk.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS).includes(apsKey);
};
const $9ed5032721563d4e$export$ab70dfefed87a731 = (targetApp)=>{
    if (!targetApp) return false;
    return (0, $eHYqk.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS).includes(targetApp);
};
const $9ed5032721563d4e$export$b57e8b9a22725 = 'shortcut';
/**
 * Matches a variant-encoded `entityId` of the form
 * `${product}-${variant}-shortcut`, e.g. `jira-animated-shortcut`.
 *
 * Both segments are captured loosely (not restricted to the known product /
 * variant unions) so the caller can decide how to degrade: an unknown *product*
 * is rejected outright, whereas an unknown *variant* degrades to `none`.
 */ const $9ed5032721563d4e$var$VARIANT_ENCODED_ENTITY_ID_PATTERN = new RegExp(`^([a-z0-9]+)-([a-z0-9]+)-${$9ed5032721563d4e$export$b57e8b9a22725}$`);
const $9ed5032721563d4e$var$isKnownVariant = (value)=>(0, $eHYqk.INVITED_APP_SHORTCUT_VARIANTS).includes(value);
const $9ed5032721563d4e$export$dbd5a13f1931b53e = (entityId)=>{
    if (!entityId) return null;
    // A plain product id (what GRS emitted before variant encoding, and what it
    // emits again if the backend change is rolled back) carries no variant.
    if ($9ed5032721563d4e$export$ab70dfefed87a731(entityId)) return {
        product: entityId,
        variant: 'none'
    };
    const match = $9ed5032721563d4e$var$VARIANT_ENCODED_ENTITY_ID_PATTERN.exec(entityId);
    if (!match) return null;
    const [, product, variant] = match;
    if (!$9ed5032721563d4e$export$ab70dfefed87a731(product)) return null;
    return {
        product: product,
        variant: $9ed5032721563d4e$var$isKnownVariant(variant) ? variant : 'none'
    };
};
const $9ed5032721563d4e$export$f5547ce9712f2015 = (apps)=>apps.map((app)=>app.product);
const $9ed5032721563d4e$export$b8c071b2cc567f75 = (apsKey)=>{
    switch(apsKey){
        case 'JIRA_SOFTWARE':
            return 'jira';
        case 'CONFLUENCE':
            return 'confluence';
        default:
            // This should never happen, throw it just in case if we add a new APS key without adding a new app key
            throw new Error(`Invalid APS key: ${apsKey}`);
    }
};

});
parcelRegister("eHYqk", function(module, exports) {
$parcel$export(module.exports, "INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS", () => $c1a591537c0a6e1d$export$f817d2300729b821);
$parcel$export(module.exports, "INVITED_APP_SHORTCUTS_ALLOWED_SOURCE_APPS", () => $c1a591537c0a6e1d$export$180016b363be5dc);
$parcel$export(module.exports, "INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS", () => $c1a591537c0a6e1d$export$cebe16b091a89fcc);
$parcel$export(module.exports, "INVITED_APP_SHORTCUT_VARIANTS", () => $c1a591537c0a6e1d$export$5595b87e32569a96);
const $c1a591537c0a6e1d$export$f817d2300729b821 = [
    'jira',
    'confluence'
];
const $c1a591537c0a6e1d$export$180016b363be5dc = [
    'confluence',
    'jira',
    'home'
];
const $c1a591537c0a6e1d$export$cebe16b091a89fcc = [
    'JIRA_SOFTWARE',
    'CONFLUENCE'
];
const $c1a591537c0a6e1d$export$5595b87e32569a96 = [
    'animated',
    'static',
    'none'
];

});


parcelRegister("aXeE9", function(module, exports) {
$parcel$export(module.exports, "InvitedAppShortcutsContext", () => $29dc8984beb77076$export$a5c3144306783a42);

var $euxye = parcelRequire("euxye");
const $29dc8984beb77076$export$a5c3144306783a42 = /*#__PURE__*/ (0, $euxye.createContext)({
    impressedProducts: {
        JIRA_SOFTWARE: false,
        CONFLUENCE: false
    }
});

});

parcelRegister("k7ixb", function(module, exports) {
$parcel$export(module.exports, "useInvitedAppAnalytics", () => $3e806dd8387f9fb6$export$43a7f5e28cb0f314);

var $euxye = parcelRequire("euxye");

var $bHcfq = parcelRequire("bHcfq");

var $inMxE = parcelRequire("inMxE");

var $4fPPi = parcelRequire("4fPPi");
const $3e806dd8387f9fb6$export$85183a312807388d = (0, $bHcfq.FabricChannel).growth;
const $3e806dd8387f9fb6$export$43a7f5e28cb0f314 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const isViewedInvitedAppShortcutsFired = (0, $euxye.useRef)(false);
    return (0, $euxye.useMemo)(()=>({
            /**
			 * Fire an analytics event when the user views the invited app shortcuts.
			 */ fireViewedInvitedAppShortcuts: (apps, firstImpressedApps)=>{
                if (isViewedInvitedAppShortcutsFired.current) return;
                createAnalyticsEvent({
                    eventType: 'screen',
                    name: 'invitedAppShortcuts',
                    attributes: {
                        apps: apps,
                        firstImpressedApps: firstImpressedApps
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
                isViewedInvitedAppShortcutsFired.current = true;
            },
            fireViewedInvitedAppShortcutPopup: ({ app: app, collaborators: collaborators })=>{
                createAnalyticsEvent({
                    eventType: 'screen',
                    name: 'invitedAppShortcutPopup',
                    attributes: {
                        app: app,
                        collaborators: collaborators
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
            },
            fireLinkClickedAcceptInvite: ({ app: app })=>{
                createAnalyticsEvent({
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'link',
                    actionSubjectId: 'acceptInvite',
                    attributes: {
                        app: app
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
            },
            fireViewedMoreCollaboratorsTooltip: ({ app: app, collaborators: collaborators })=>{
                createAnalyticsEvent({
                    eventType: 'screen',
                    name: 'moreCollaboratorsTooltip',
                    attributes: {
                        app: app,
                        collaborators: collaborators
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
            },
            /**
			 * Fire an analytics event when eligibility for invited app shortcuts is checked.
			 *
			 * This event is deduplicated across sessions using a hashed key stored in local storage.
			 * If the combination of userId, cloudId, and ineligibilityReason has not changed since the
			 * last time the event was fired, subsequent calls are suppressed — even after page reloads.
			 *
			 * @param ineligibilityReason - the reason the user is ineligible
			 * @param userId - the current user's ID
			 * @param cloudId - the current cloud/site ID
			 */ fireInvitedAppShortcutsEligibilityChecked: async ({ ineligibilityReason: ineligibilityReason, userId: userId, cloudId: cloudId })=>{
                const rawCacheKey = `${userId ?? ''}:${cloudId ?? ''}:${ineligibilityReason}`;
                if (await $3e806dd8387f9fb6$var$hasAlreadyBeenFired($3e806dd8387f9fb6$var$ELIGIBILITY_CHECKED_STORAGE_KEY, rawCacheKey)) return;
                createAnalyticsEvent({
                    eventType: 'track',
                    action: 'checked',
                    actionSubject: 'eligibility',
                    attributes: {
                        flagKey: 'twcg-460-personalised-invite-notifications-m2',
                        ineligibilityReason: ineligibilityReason
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
                await $3e806dd8387f9fb6$var$markAsFired($3e806dd8387f9fb6$var$ELIGIBILITY_CHECKED_STORAGE_KEY, rawCacheKey);
            },
            /**
			 * Fire an analytics event when the feature is exposed.
			 *
			 * This event is deduplicated across sessions using a hashed key stored in local storage.
			 * If the combination of userId, cloudId, and isEnabled has not changed since the last time
			 * the event was fired, subsequent calls are suppressed — even after page reloads.
			 *
			 * When the event fires, the eligibility-checked storage key is also cleared so that
			 * eligibility is re-evaluated after the user enters the experiment.
			 *
			 * @param isEnabled - the experiment's isEnabled value
			 * @param userId - the current user's ID
			 * @param cloudId - the current cloud/site ID
			 */ fireFeatureExposed: async ({ isEnabled: isEnabled, userId: userId, cloudId: cloudId, mode: mode })=>{
                // Include the current date (YYYY-MM-DD) so the event fires at most once per day
                const today = new Date().toISOString().split('T')[0];
                const rawCacheKey = `${userId ?? ''}:${cloudId ?? ''}:${String(isEnabled)}:${today}`;
                if (await $3e806dd8387f9fb6$var$hasAlreadyBeenFired($3e806dd8387f9fb6$var$FEATURE_EXPOSED_STORAGE_KEY, rawCacheKey)) return;
                createAnalyticsEvent({
                    eventType: 'track',
                    action: 'exposed',
                    actionSubject: 'feature',
                    attributes: {
                        featureKey: mode === 'experiment' ? 'twcg-460-personalised-invite-notifications-m2' : 'twcg-460-preload-grs-invited-app-shortcuts',
                        cohort: isEnabled ? 'variant' : 'control',
                        mode: mode
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
                await $3e806dd8387f9fb6$var$markAsFired($3e806dd8387f9fb6$var$FEATURE_EXPOSED_STORAGE_KEY, rawCacheKey);
                // Clear the eligibility checked flag since the feature is now exposed,
                // so that the next eligibility check will fire.
                $3e806dd8387f9fb6$var$clearStorageKey($3e806dd8387f9fb6$var$ELIGIBILITY_CHECKED_STORAGE_KEY);
            },
            fireFetchInvitedAppShortcutsTraitsSucceeded: ({ sourceApp: sourceApp, targetApps: targetApps })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'fetchInvitedAppShortcutsTraits',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
            },
            fireFetchInvitedAppShortcutsTraitsFailed: ({ sourceApp: sourceApp, targetApps: targetApps })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'fetchInvitedAppShortcutsTraits',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
            },
            fireFetchCollaboratorsAccessSucceeded: ({ sourceApp: sourceApp, targetApps: targetApps, collaborators: collaborators })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'fetchCollaboratorsAccess',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps,
                        collaborators: collaborators
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
            },
            fireFetchCollaboratorsAccessFailed: ({ sourceApp: sourceApp, targetApps: targetApps, error: error })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'fetchCollaboratorsAccess',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps,
                        error: error
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
            },
            fireEligibilityUpdateSucceeded: ({ sourceApp: sourceApp, targetApps: targetApps })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'eligibilityUpdate',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
            },
            fireEligibilityUpdateFailed: ({ sourceApp: sourceApp, targetApps: targetApps, error: error })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'eligibilityUpdate',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps,
                        error: error
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
            },
            fireInvitedAppShortcutsCacheRefreshSucceeded: ({ targetApp: targetApp })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'invitedAppShortcutsCacheRefresh',
                    attributes: {
                        targetApp: targetApp
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
            },
            fireInvitedAppShortcutsCacheRefreshFailed: ({ targetApp: targetApp, error: error, errorStack: errorStack })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'invitedAppShortcutsCacheRefresh',
                    attributes: {
                        targetApp: targetApp,
                        error: error,
                        errorStack: errorStack
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
            },
            fireInvitedAppShortcutsContainerRenderFailed: ({ targetApps: targetApps, error: error, errorStack: errorStack })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'invitedAppShortcutsContainerRender',
                    attributes: {
                        targetApps: targetApps,
                        error: error,
                        errorStack: errorStack
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
            },
            fireAppAccessRemoved: ({ targetApps: targetApps })=>{
                createAnalyticsEvent({
                    eventType: 'track',
                    action: 'removed',
                    actionSubject: 'appAccess',
                    attributes: {
                        targetApps: targetApps
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
            },
            fireViewedAnimatedLozenge: ({ app: app })=>{
                createAnalyticsEvent({
                    eventType: 'screen',
                    name: 'animatedLozenge',
                    attributes: {
                        app: app
                    }
                }).fire($3e806dd8387f9fb6$export$85183a312807388d);
            }
        }), [
        createAnalyticsEvent
    ]);
};
// ── Cross-session analytics dedup helpers ──────────────────────────────────────
//
// These helpers store a hashed fingerprint in local storage so that analytics
// events are only fired once per unique combination of parameters — even across
// page reloads. Each event type has its own storage key so they can be checked
// and cleared independently.
const $3e806dd8387f9fb6$var$ELIGIBILITY_CHECKED_STORAGE_KEY = 'invitedAppShortcuts.eligibilityChecked';
const $3e806dd8387f9fb6$var$FEATURE_EXPOSED_STORAGE_KEY = 'invitedAppShortcuts.featureExposed';
// In-memory cache of the latest hash written per analytics storage key.
// This preserves dedupe within the current page session even if localStorage fails.
const $3e806dd8387f9fb6$var$firedHashByStorageKey = new Map();
// Circuit breaker for browser storage writes.
// Once a storage write throws (e.g. quota exceeded), we stop touching localStorage
// and fall back to in-memory dedupe only to avoid repeated runtime errors.
let $3e806dd8387f9fb6$var$shouldUseLocalStorage = true;
/**
 * Produces a non-reversible hash of the given raw string so we never store
 * plain-text identifiers in local storage.
 *
 * Prefers SHA-256 via the Web Crypto API when available, otherwise falls back
 * to a synchronous FNV-1a 32-bit hash for environments where the Web Crypto API
 * is not supported.
 *
 * @param raw - the raw string to hash
 * @returns a hex-encoded hash string
 */ async function $3e806dd8387f9fb6$var$hashString(raw) {
    // Primary path: SHA-256 via the Web Crypto API.
    // crypto.subtle is available in all modern browsers but requires a secure context (HTTPS).
    // It may be unavailable in:
    //   - Non-HTTPS pages (e.g. http://localhost without a secure context flag)
    //   - SSR / Node environments where the Web Crypto API is not globally available
    //   - Very old browsers (pre-Chrome 37, pre-Firefox 34, pre-Safari 11)
    if (typeof crypto !== 'undefined' && crypto.subtle) try {
        const data = new TextEncoder().encode(raw);
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch  {
    // Fall through to the fallback hash
    }
    // Fallback: FNV-1a 32-bit hash.
    // Not cryptographically secure, but sufficient to avoid storing plain-text
    // identifiers in local storage. This path is only reached when the Web Crypto
    // API is unavailable (see conditions above) or throws unexpectedly.
    let hash = 0x811c9dc5;
    for(let i = 0; i < raw.length; i++){
        hash ^= raw.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193);
    }
    return (hash >>> 0).toString(16);
}
/**
 * Checks whether an analytics event has already been fired for the given
 * parameters by comparing a hashed fingerprint stored under `storageKey`.
 *
 * @param storageKey - the local storage key to read from
 * @param raw - the raw string representing the current parameter combination
 * @returns `true` if the stored hash matches, meaning the event should be suppressed.
 *          Returns `false` on any storage error.
 */ async function $3e806dd8387f9fb6$var$hasAlreadyBeenFired(storageKey, raw) {
    try {
        const hashed = await $3e806dd8387f9fb6$var$hashString(raw);
        if ($3e806dd8387f9fb6$var$firedHashByStorageKey.get(storageKey) === hashed) return true;
        if (!$3e806dd8387f9fb6$var$shouldUseLocalStorage) return false;
        const stored = (0, $4fPPi.AtlBrowserStorageLocal).getItem(storageKey);
        return stored === hashed;
    } catch  {
        return false;
    }
}
/**
 * Persists a hashed fingerprint so that future calls to {@link hasAlreadyBeenFired}
 * with the same `storageKey` and `raw` value will return `true`.
 *
 * Storage errors (e.g. private browsing, quota exceeded) are silently ignored.
 *
 * @param storageKey - the local storage key to write to
 * @param raw - the raw string representing the current parameter combination
 */ async function $3e806dd8387f9fb6$var$markAsFired(storageKey, raw) {
    try {
        const hashed = await $3e806dd8387f9fb6$var$hashString(raw);
        // Always keep an in-memory copy so we can still dedupe within a page session
        // even when browser storage is unavailable or full.
        $3e806dd8387f9fb6$var$firedHashByStorageKey.set(storageKey, hashed);
        if (!$3e806dd8387f9fb6$var$shouldUseLocalStorage) return;
        await (0, $4fPPi.AtlBrowserStorageLocal).setItem(storageKey, hashed);
    } catch  {
        // Storage quota/state can change at runtime (e.g. low storage, private mode).
        // Disable future localStorage writes to avoid repeated runtime errors.
        $3e806dd8387f9fb6$var$shouldUseLocalStorage = false;
    // Silently ignore storage errors (e.g. private browsing, quota exceeded)
    }
}
/**
 * Removes the stored fingerprint for the given storage key, allowing the
 * corresponding event to fire again regardless of previous parameters.
 *
 * @param storageKey - the local storage key to clear
 */ function $3e806dd8387f9fb6$var$clearStorageKey(storageKey) {
    try {
        $3e806dd8387f9fb6$var$firedHashByStorageKey.delete(storageKey);
        if (!$3e806dd8387f9fb6$var$shouldUseLocalStorage) return;
        (0, $4fPPi.AtlBrowserStorageLocal).removeItem(storageKey);
    } catch  {
    // Silently ignore storage errors
    }
}

});

parcelRegister("eBna3", function(module, exports) {
$parcel$export(module.exports, "InvitedAppShortcutsContainerProdInner", () => $f07652b291f3f674$export$80ba7e5efcca528b);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $eVMQF = parcelRequire("eVMQF");

var $hmszZ = parcelRequire("hmszZ");

var $aXeE9 = parcelRequire("aXeE9");

var $2aVsL = parcelRequire("2aVsL");

var $k7ixb = parcelRequire("k7ixb");

var $4nfGk = parcelRequire("4nfGk");

var $aYiq4 = parcelRequire("aYiq4");

var $jnjMq = parcelRequire("jnjMq");
const $f07652b291f3f674$var$DEFAULT_HOVER_DELAY_MS = 300;
const $f07652b291f3f674$var$DEFAULT_PREFETCH_DEBOUNCE_MS = 100;
const $f07652b291f3f674$export$80ba7e5efcca528b = ({ shortcutsConfig: shortcutsConfig, resolverResult: resolverResult, hoverDelayTimeMs: hoverDelayTimeMs = $f07652b291f3f674$var$DEFAULT_HOVER_DELAY_MS, prefetchDebounceMs: prefetchDebounceMs = $f07652b291f3f674$var$DEFAULT_PREFETCH_DEBOUNCE_MS, excludeLastFromRefs: excludeLastFromRefs = 0, children: children, cloudId: cloudId, sourceApp: sourceApp })=>{
    const { fireViewedInvitedAppShortcuts: fireViewedInvitedAppShortcuts, fireInvitedAppShortcutsCacheRefreshSucceeded: fireInvitedAppShortcutsCacheRefreshSucceeded, fireInvitedAppShortcutsCacheRefreshFailed: fireInvitedAppShortcutsCacheRefreshFailed } = (0, $k7ixb.useInvitedAppAnalytics)();
    const prefetchAll = (0, $4nfGk.useInvitedAppCollaboratorsLazyPrefetch)();
    const [isPopupShown, setIsPopupShown] = (0, $euxye.useState)(false);
    const closePopupTimerRef = (0, $euxye.useRef)(null);
    const jiraShortcutRef = (0, $euxye.useRef)(null);
    const confluenceShortcutRef = (0, $euxye.useRef)(null);
    const unbindFunctionsRef = (0, $euxye.useRef)(new Map());
    const [currentShortcutRef, setCurrentShortcutRef] = (0, $euxye.useState)();
    const shortcutRefs = (0, $euxye.useMemo)(()=>({
            JIRA_SOFTWARE: jiraShortcutRef,
            CONFLUENCE: confluenceShortcutRef
        }), []);
    const clearClosePopupTimer = (0, $euxye.useCallback)(()=>{
        if (closePopupTimerRef.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, []);
    const hidePopup = (0, $euxye.useCallback)(()=>{
        setIsPopupShown(false);
        setCurrentShortcutRef(undefined);
    }, []);
    const showPopup = (0, $euxye.useCallback)(()=>{
        setIsPopupShown(true);
    }, []);
    const startClosePopupTimer = (0, $euxye.useCallback)(()=>{
        clearClosePopupTimer();
        closePopupTimerRef.current = setTimeout(hidePopup, hoverDelayTimeMs);
    }, [
        clearClosePopupTimer,
        hidePopup,
        hoverDelayTimeMs
    ]);
    // Debounced singleton prefetch — quick cursor sweeps don't fire the
    // request; an already in-flight HTTP request is never cancelled.
    const debouncedPrefetchAll = (0, $euxye.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($eVMQF)))(()=>prefetchAll(), prefetchDebounceMs, {
            leading: false,
            trailing: true
        }), [
        prefetchAll,
        prefetchDebounceMs
    ]);
    (0, $euxye.useEffect)(()=>()=>debouncedPrefetchAll.cancel(), [
        debouncedPrefetchAll
    ]);
    const handleMouseOverWithRef = (0, $euxye.useCallback)((targetRef)=>()=>{
            clearClosePopupTimer();
            setCurrentShortcutRef(targetRef);
            showPopup();
            debouncedPrefetchAll();
        }, [
        clearClosePopupTimer,
        showPopup,
        debouncedPrefetchAll
    ]);
    // Direct handler (no factory) — it doesn't capture per-ref state, so a
    // single stable function can be re-used across both `mouseleave` and
    // `blur` bindings without allocating duplicates per ref.
    const handleMouseLeave = (0, $euxye.useCallback)(()=>{
        debouncedPrefetchAll.cancel();
        startClosePopupTimer();
    }, [
        startClosePopupTimer,
        debouncedPrefetchAll
    ]);
    const setShortcutRef = (0, $euxye.useCallback)((targetRef)=>(node)=>{
            const existing = unbindFunctionsRef.current.get(targetRef);
            if (existing) {
                existing();
                unbindFunctionsRef.current.delete(targetRef);
            }
            // oxlint-disable-next-line no-param-reassign
            targetRef.current = node;
            if (node) {
                const mouseoverListener = handleMouseOverWithRef(targetRef);
                const focusListener = handleMouseOverWithRef(targetRef);
                const unbind = (0, $glbdM.bindAll)(node, [
                    {
                        type: 'mouseover',
                        listener: mouseoverListener
                    },
                    {
                        type: 'focus',
                        listener: focusListener
                    },
                    {
                        type: 'mouseleave',
                        listener: handleMouseLeave
                    },
                    {
                        type: 'blur',
                        listener: handleMouseLeave
                    }
                ]);
                unbindFunctionsRef.current.set(targetRef, unbind);
            }
        }, [
        handleMouseOverWithRef,
        handleMouseLeave
    ]);
    const handleOnMouseEnterPopup = (0, $euxye.useCallback)(()=>{
        clearClosePopupTimer();
        if (currentShortcutRef?.current) {
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) parentElement.style.backgroundColor = "var(--ds-surface-hovered, #F0F1F2)";
        }
        showPopup();
    }, [
        clearClosePopupTimer,
        showPopup,
        currentShortcutRef
    ]);
    const handleOnMouseLeavePopup = (0, $euxye.useCallback)(()=>{
        if (currentShortcutRef?.current) {
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) parentElement.style.backgroundColor = '';
        }
        startClosePopupTimer();
    }, [
        currentShortcutRef,
        startClosePopupTimer
    ]);
    // Warms GRS to the static variant for the next SSR load. Fire-and-forget, so
    // nothing here awaits it — the outcome only goes to analytics, because a failed
    // refresh is what leaves the animation replaying until the cache TTL expires.
    const handleAnimatedImpressed = (0, $euxye.useCallback)((targetApp)=>{
        (0, $2aVsL.requestInvitedAppShortcutsCacheRefresh)({
            cloudId: cloudId,
            sourceApp: sourceApp,
            targetApp: targetApp,
            onSucceeded: ()=>fireInvitedAppShortcutsCacheRefreshSucceeded({
                    targetApp: targetApp
                }),
            onFailed: ({ error: error, errorStack: errorStack })=>fireInvitedAppShortcutsCacheRefreshFailed({
                    targetApp: targetApp,
                    error: error,
                    errorStack: errorStack
                })
        });
    }, [
        cloudId,
        sourceApp,
        fireInvitedAppShortcutsCacheRefreshSucceeded,
        fireInvitedAppShortcutsCacheRefreshFailed
    ]);
    const referrableShortcuts = (0, $euxye.useMemo)(()=>{
        const entries = Object.entries(shortcutsConfig);
        const max = Math.min(entries.length, Object.values(resolverResult.invitedApps ?? {}).filter((app)=>app?.eligible).length);
        const refsLimit = max - excludeLastFromRefs;
        let createdRefsCount = 0;
        return entries.reduce((acc, [key, shortcut])=>{
            if (createdRefsCount < refsLimit && shortcut.type === 'link' && shortcut.apsKey && resolverResult.invitedApps?.[(0, $hmszZ.getAppKeyByApsKey)(shortcut.apsKey)]?.eligible) {
                const apsKey = shortcut.apsKey;
                const targetRef = shortcutRefs[apsKey];
                acc[key] = {
                    ...shortcut,
                    ref: targetRef ? setShortcutRef(targetRef) : undefined,
                    labelElem: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $aYiq4.InvitedAppShortcutLabel), {
                        apsKey: apsKey,
                        label: shortcut.label,
                        // Only this mode resolves a variant; the experiment inner passes none.
                        variant: resolverResult.invitedApps?.[(0, $hmszZ.getAppKeyByApsKey)(apsKey)]?.variant,
                        onAnimatedImpressed: handleAnimatedImpressed
                    })
                };
                // oxlint-disable-next-line no-plusplus
                createdRefsCount++;
            } else acc[key] = shortcut;
            return acc;
        }, {});
    }, [
        shortcutsConfig,
        resolverResult.invitedApps,
        excludeLastFromRefs,
        shortcutRefs,
        setShortcutRef,
        handleAnimatedImpressed
    ]);
    const currentApsKey = (0, $euxye.useMemo)(()=>{
        const entry = Object.entries(shortcutRefs).find(([, ref])=>ref === currentShortcutRef);
        return entry ? entry[0] : undefined;
    }, [
        currentShortcutRef,
        shortcutRefs
    ]);
    const currentApp = currentApsKey ? (0, $hmszZ.getAppKeyByApsKey)(currentApsKey) : undefined;
    const collaboratorsSource = (0, $euxye.useMemo)(()=>currentApp ? {
            kind: 'lazy',
            app: currentApp
        } : undefined, [
        currentApp
    ]);
    const handleAcceptInvite = (0, $euxye.useCallback)((app)=>resolverResult?.registerActivation(app), [
        resolverResult
    ]);
    const currentShortcutLink = (0, $euxye.useMemo)(()=>currentShortcutRef?.current?.href, [
        currentShortcutRef
    ]);
    (0, $euxye.useEffect)(()=>()=>{
            unbindFunctionsRef.current.forEach((unbind)=>unbind());
            unbindFunctionsRef.current.clear();
            clearClosePopupTimer();
        }, [
        clearClosePopupTimer
    ]);
    (0, $euxye.useEffect)(()=>{
        // Collect target-app keys for shortcuts we attached a ref to. Mirrors
        // the Inner reducer pattern; analytics signature expects target-app
        // keys (e.g. `confluence` / `jira`) not aps keys.
        const invitedAppShortcutKeys = Object.values(referrableShortcuts).reduce((acc, shortcut)=>{
            if (shortcut.type === 'link' && (0, $hmszZ.isAllowedApsKey)(shortcut.apsKey) && !!shortcut.ref) acc.push((0, $hmszZ.getAppKeyByApsKey)(shortcut.apsKey));
            return acc;
        }, []);
        if (invitedAppShortcutKeys.length > 0) // Productionisation mode: GRS resolves impressions, so the "first
        // impressed" list is always empty — pass `[]` to keep the analytics
        // signature intact.
        fireViewedInvitedAppShortcuts(invitedAppShortcutKeys, []);
    }, [
        referrableShortcuts,
        fireViewedInvitedAppShortcuts
    ]);
    // Productionisation mode: impression state is resolved by GRS from the TAP
    // first-impression trait and arrives as the lozenge `variant`. The frontend still
    // produces the signal that feeds the trait (the `animatedLozenge` event) — it just
    // no longer reads impression state. The productionisation hook never sets
    // `firstImpressionAt`, so the legacy `impressedProducts` flags are always `false`
    // here by construction.
    const contextValue = (0, $euxye.useMemo)(()=>({
            impressedProducts: {
                JIRA_SOFTWARE: false,
                CONFLUENCE: false
            }
        }), []);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $aXeE9.InvitedAppShortcutsContext).Provider, {
        value: contextValue,
        children: [
            children({
                referrableShortcuts: referrableShortcuts
            }),
            isPopupShown && currentShortcutRef && currentShortcutLink && currentApsKey && collaboratorsSource && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jnjMq.LazyInvitedAppPopup), {
                trigger: currentShortcutRef,
                onMouseEnterPopup: handleOnMouseEnterPopup,
                onMouseLeavePopup: handleOnMouseLeavePopup,
                currentApsKey: currentApsKey,
                collaboratorsSource: collaboratorsSource,
                currentShortcutLink: currentShortcutLink,
                onAcceptInvite: handleAcceptInvite
            })
        ]
    });
};
$f07652b291f3f674$export$80ba7e5efcca528b.displayName = "InvitedAppShortcutsContainerProdInner";

});
parcelRegister("2aVsL", function(module, exports) {
$parcel$export(module.exports, "requestInvitedAppShortcutsCacheRefresh", () => $b825a4499f4517de$export$3d9a75d28d4880bd);
const $b825a4499f4517de$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $b825a4499f4517de$var$OPERATION_NAME = 'invitedAppShortcutsCacheRefresh';
const $b825a4499f4517de$var$USE_CASE = 'invitedAppShortcuts';
/**
 * Deliberately NOT a Relay query. The point of this request is the side effect —
 * GRS recomputes eligibility and repopulates its cache — so the response is
 * discarded, and normalising it into the Relay store risks a mid-view flip of the
 * lozenge the user is currently looking at. A plain POST keeps it out of the store
 * entirely. AGG accepts inline query documents (see `fetchAggResponse` in
 * `central-ai/ai-definitions`), so this needs no persisted-query registration.
 *
 * `__typename` is the whole selection: enough to be a valid query, nothing more.
 */ const $b825a4499f4517de$var$QUERY = `query ${$b825a4499f4517de$var$OPERATION_NAME}($context: GrowthRecContext) {
	growthRecommendations {
		recommendations(context: $context) {
			__typename
		}
	}
}`;
/**
 * Keys already refreshed, as `cloudId:sourceApp:targetApp`. Module-scoped so it
 * survives the frequent subtree remounts a `useRef` would not.
 *
 * This covers repeat renders and retries within one page. It does NOT cover other
 * tabs or a reload — those would need shared storage, and a duplicate refresh is
 * harmless anyway (GRS recomputes to the same value), so the extra request is a
 * better trade than a storage-consent dependency.
 */ const $b825a4499f4517de$var$refreshRequested = new Set();
const $b825a4499f4517de$var$describeError = (cause)=>cause instanceof Error ? {
        error: cause.message,
        errorStack: cause.stack
    } : {
        error: String(cause),
        errorStack: undefined
    };
const $b825a4499f4517de$export$3d9a75d28d4880bd = ({ cloudId: cloudId, sourceApp: sourceApp, targetApp: targetApp, onSucceeded: onSucceeded, onFailed: onFailed })=>{
    if (!cloudId) return;
    const key = `${cloudId}:${sourceApp}:${targetApp}`;
    if ($b825a4499f4517de$var$refreshRequested.has(key)) return;
    // Marked before the request, not after: a rejected refresh is not retried, so
    // recording the attempt is what keeps "exactly once" true.
    $b825a4499f4517de$var$refreshRequested.add(key);
    fetch(`${$b825a4499f4517de$var$GRAPHQL_ENDPOINT}?q=${$b825a4499f4517de$var$OPERATION_NAME}`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            operationName: $b825a4499f4517de$var$OPERATION_NAME,
            query: $b825a4499f4517de$var$QUERY,
            variables: {
                context: {
                    tenantId: cloudId,
                    product: sourceApp,
                    useCase: $b825a4499f4517de$var$USE_CASE,
                    custom: {
                        refreshInvitedAppShortcutsCache: true
                    }
                }
            }
        })
    }).then(async (response)=>{
        if (!response.ok) {
            onFailed?.({
                error: `Request failed with status ${response.status}`,
                errorStack: undefined
            });
            return;
        }
        // AGG answers GraphQL-level failures with HTTP 200 and an `errors` array.
        // The whole point of this request is the recompute, so a 200 carrying
        // errors is a failed refresh, not a success.
        const body = await response.json();
        const messages = body?.errors?.map((graphQlError)=>graphQlError?.message).filter(Boolean);
        if (messages?.length) {
            onFailed?.({
                error: messages.join('; '),
                errorStack: undefined
            });
            return;
        }
        onSucceeded?.();
    }).catch((cause)=>{
        // Transport failure, or a body that would not parse.
        onFailed?.($b825a4499f4517de$var$describeError(cause));
    });
};
const $b825a4499f4517de$export$3b0c1ba57ba1e5a7 = ()=>{
    $b825a4499f4517de$var$refreshRequested.clear();
};

});

parcelRegister("4nfGk", function(module, exports) {
$parcel$export(module.exports, "StateContext", () => $0bbb344453c3bc2f$export$437ae3f50102760d);
$parcel$export(module.exports, "PrefetchContext", () => $0bbb344453c3bc2f$export$66a70772711988d1);
$parcel$export(module.exports, "useInvitedAppCollaboratorsLazy", () => $0bbb344453c3bc2f$export$69c89392124bbb84);
$parcel$export(module.exports, "useInvitedAppCollaboratorsLazyPrefetch", () => $0bbb344453c3bc2f$export$5c3e277aaa23ea00);

var $euxye = parcelRequire("euxye");
const $0bbb344453c3bc2f$export$437ae3f50102760d = (0, $euxye.createContext)({
    status: 'idle'
});
const $0bbb344453c3bc2f$export$66a70772711988d1 = (0, $euxye.createContext)(()=>{});
const $0bbb344453c3bc2f$export$69c89392124bbb84 = ()=>(0, $euxye.useContext)($0bbb344453c3bc2f$export$437ae3f50102760d);
const $0bbb344453c3bc2f$export$5c3e277aaa23ea00 = ()=>(0, $euxye.useContext)($0bbb344453c3bc2f$export$66a70772711988d1);

});

parcelRegister("aYiq4", function(module, exports) {
$parcel$export(module.exports, "InvitedAppShortcutLabel", () => $fa4acd1af0854845$export$f60dc2630a14000a);
/* main.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $55qdj = parcelRequire("55qdj");

var $2EFuW = parcelRequire("2EFuW");

var $8Sdzy = parcelRequire("8Sdzy");

var $bz7rH = parcelRequire("bz7rH");

var $hmszZ = parcelRequire("hmszZ");

var $aXeE9 = parcelRequire("aXeE9");

var $k7ixb = parcelRequire("k7ixb");
const $fa4acd1af0854845$var$styles = {
    container: "_1e0c11p5 _yv0e5bpd _4cvr1h6o _1bsb1osq",
    lozengeContainer: "_1e0c1txw _1bahesu3 _4cvr1h6o _1ul9idpf"
};
const $fa4acd1af0854845$var$INITIAL_ANIMATION_DELAY = 2000;
// apsKeys that have already played their initial animation. Module-scoped so it survives the
// frequent subtree remounts (a `useRef` would be discarded); keyed by apsKey so products stay
// independent; not React state so flipping it can't re-render and cut the animation short.
const $fa4acd1af0854845$var$impressedApsKeys = new Set();

const $fa4acd1af0854845$export$f60dc2630a14000a = ({ label: label, apsKey: apsKey, variant: variant, onAnimatedImpressed: onAnimatedImpressed })=>{
    const { impressedProducts: impressedProducts } = (0, $euxye.useContext)((0, $aXeE9.InvitedAppShortcutsContext));
    const [AnimatedLozengeComponent, setAnimatedLozengeComponent] = (0, $euxye.useState)(null);
    const { fireViewedAnimatedLozenge: fireViewedAnimatedLozenge } = (0, $k7ixb.useInvitedAppAnalytics)();
    // A stale `animated` (already played this session) degrades to static.
    const hasAlreadyAnimated = $fa4acd1af0854845$var$impressedApsKeys.has(apsKey);
    const resolveTreatment = ()=>{
        // Legacy cohort: first sighting animates, thereafter static.
        if (variant === undefined) return impressedProducts[apsKey] || hasAlreadyAnimated ? 'static' : 'animated';
        switch(variant){
            case 'animated':
                return hasAlreadyAnimated ? 'static' : 'animated';
            case 'static':
                return 'static';
            // Keeps an unrecognised future variant from animating.
            default:
                return 'none';
        }
    };
    const treatment = resolveTreatment();
    const wantsAnimated = treatment === 'animated';
    (0, $euxye.useEffect)(()=>{
        // `static` and `none` skip the chunk, so they paint synchronously.
        if (!wantsAnimated) return;
        (parcelRequire("kHPAa")).then((module)=>{
            // Stored via an updater: a bare `setState(fn)` would be treated as an updater
            // function and called with the previous state. Today's default is a `memo()`
            // object so it happens to survive, but a plain function component would not.
            setAnimatedLozengeComponent(()=>module.default);
        });
    }, [
        wantsAnimated
    ]);
    const isRenderingAnimated = wantsAnimated && AnimatedLozengeComponent !== null;
    // The two signals fire at deliberately different moments, and the gap between them is
    // the point.
    //
    // The event feeds the TAP first-impression trait; the refresh asks GRS to re-read that
    // trait. Firing both together left GRS reading a trait that could not have propagated
    // yet, so it recomputed `NOT_IMPRESSED` and the animation replayed. Firing the event as
    // soon as the animated lozenge renders and the refresh only on completion gives the
    // trait the whole animation (~3.6s) to land, and keeps the event cheap to deliver for
    // users who leave early — a session too short to send the refresh still records the
    // impression, so the next load can converge.
    (0, $euxye.useEffect)(()=>{
        if (!isRenderingAnimated) return;
        fireViewedAnimatedLozenge({
            app: (0, $hmszZ.getAppKeyByApsKey)(apsKey)
        });
    }, [
        isRenderingAnimated,
        fireViewedAnimatedLozenge,
        apsKey
    ]);
    const handleAnimationComplete = (0, $euxye.useCallback)(()=>{
        // Tied to completion, not render: a user who leaves mid-animation should get a
        // fresh animation next time rather than being suppressed to static.
        $fa4acd1af0854845$var$impressedApsKeys.add(apsKey);
        // Safe to re-run: the refresher dedupes per app, so a replayed animation after a
        // remount costs nothing.
        onAnimatedImpressed?.((0, $hmszZ.getAppKeyByApsKey)(apsKey));
    }, [
        apsKey,
        onAnimatedImpressed
    ]);
    const LozengeComponent = wantsAnimated && AnimatedLozengeComponent ? AnimatedLozengeComponent : (0, $2EFuW.default);
    const lozengeProps = LozengeComponent === AnimatedLozengeComponent ? {
        initialAnimationDelay: $fa4acd1af0854845$var$INITIAL_ANIMATION_DELAY,
        onAnimationComplete: handleAnimationComplete
    } : {};
    const shouldRenderLozenge = treatment === 'static' || wantsAnimated && AnimatedLozengeComponent !== null;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        className: (0, $4jQY2.default)([
            $fa4acd1af0854845$var$styles.container
        ]),
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                children: label
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    $fa4acd1af0854845$var$styles.lozengeContainer
                ]),
                children: shouldRenderLozenge ? /*#__PURE__*/ (0, $e79Pd.jsx)(LozengeComponent, {
                    appearance: "inprogress",
                    ...lozengeProps,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                        ...(0, $bz7rH.messages).invitedLozenge
                    })
                }) : null
            })
        ]
    });
};
$fa4acd1af0854845$export$f60dc2630a14000a.displayName = "InvitedAppShortcutLabel";
const $fa4acd1af0854845$export$1690c61756ad2618 = ()=>{
    $fa4acd1af0854845$var$impressedApsKeys.clear();
};

});
parcelRegister("bz7rH", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c343cf23420b5c8c$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $c343cf23420b5c8c$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    invitedLozenge: {
        id: 'cross-join-nudges.invited-app-shortcuts.invited-lozenge',
        defaultMessage: 'Invited',
        description: 'A lozenge shown next to the sidebar shorcut apps the user has been invited to but has not yet accessed.'
    },
    popupMainTextWithCollaborators: {
        id: 'cross-join-nudges.invited-app-shortcuts.popup-main-text-with-collaborators',
        defaultMessage: "You're invited to join your team",
        description: 'The main copy of the popup shown when the user hovers an invited app shorcut in the sidebar, if the user has collaborators.'
    },
    popupMainTextWithoutCollaborators: {
        id: 'cross-join-nudges.invited-app-shortcuts.popup-main-text-without-collaborators',
        defaultMessage: "Don't lose access, accept invite now",
        description: 'The main copy of the popup shown when the user hovers an invited app shorcut in the sidebar, if the user does not have collaborators.'
    },
    popupAcceptInviteButton: {
        id: 'cross-join-nudges.invited-app-shortcuts.popup-accept-invite-button',
        defaultMessage: 'Accept invite',
        description: 'Link button text in the popup shown when the user hovers an invited app shorcut in the sidebar. When clicked, the user will go to the app.'
    },
    popupCollaboratorsTooltip: {
        id: 'cross-join-nudges.invited-app-shortcuts.popup-collaborators-tooltip',
        defaultMessage: '{numberOfCollaborators} more {numberOfCollaborators, plural, one {teammate} other {teammates}} are using {app}',
        description: 'Tooltip text for the more indicator in the popup shown when the user hovers an invited app shorcut in the sidebar, if the user has collaborators.'
    },
    jira: {
        id: 'cross-join-nudges.invited-app-shortcuts.jira',
        defaultMessage: 'Jira',
        description: 'The name of the Jira product app shortcut in the sidebar.'
    },
    confluence: {
        id: 'cross-join-nudges.invited-app-shortcuts.confluence',
        defaultMessage: 'Confluence',
        description: 'The name of the Confluence app.'
    }
});

});

parcelRegister("kHPAa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7jvBr").then(()=>parcelRequire('iuvGG'));

});


parcelRegister("jnjMq", function(module, exports) {
$parcel$export(module.exports, "LazyInvitedAppPopup", () => $b723a347558b92ea$export$dcca2f78da63545d);
/* main.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $1qX9F = parcelRequire("1qX9F");

var $hzWaA = parcelRequire("hzWaA");

var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $3NRLa = parcelRequire("3NRLa");

var $bz7rH = parcelRequire("bz7rH");

var $hmszZ = parcelRequire("hmszZ");

var $k7ixb = parcelRequire("k7ixb");

var $4nfGk = parcelRequire("4nfGk");

var $hmjOj = parcelRequire("hmjOj");

// Lazy load the InvitedAppPopup component
const $b723a347558b92ea$var$InvitedAppPopup = /*#__PURE__*/ (0, $euxye.lazy)(()=>(parcelRequire("gymQa")).then((module)=>({
            default: module.InvitedAppPopup
        })));
// Loading skeleton dimensions, matching the "No collaborators (Skeleton)"
// Figma spec: two stacked lines of equal height and different widths that
// stand in for the popup's title + subtitle text while collaborators load.
const $b723a347558b92ea$var$SKELETON_LINE_HEIGHT = '12px';
const $b723a347558b92ea$var$SKELETON_TITLE_WIDTH = '180px';
const $b723a347558b92ea$var$SKELETON_SUBTITLE_WIDTH = '120px';
/**
 * Renders the avatar group + tooltip for the given collaborators.
 * Returns `null` when there are no collaborators to show (error / idle / empty
 * all collapse to this branch).
 */ const $b723a347558b92ea$var$PopupCollaboratorsBody = ({ collaborators: collaborators, currentApsKey: currentApsKey })=>{
    if (collaborators.length === 0) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $defJG.Inline), {
        grow: "hug",
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1qX9F.default), {
            data: collaborators.map((collaborator)=>({
                    ...collaborator,
                    appearance: 'circle',
                    size: 'medium'
                })),
            maxCount: 2,
            overrides: {
                MoreIndicator: {
                    render: (Component, props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $hmjOj.InvitedAppCollaboratorsTooltip), {
                            currentApsKey: currentApsKey,
                            currentAppCollaborators: collaborators,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                                ...props,
                                isActive: false,
                                onClick: ()=>{}
                            })
                        })
                }
            }
        })
    });
};
$b723a347558b92ea$var$PopupCollaboratorsBody.displayName = "PopupCollaboratorsBody";
/**
 * Resolves the collaborator slice + loading flag for a given
 * `CollaboratorsSource`.
 * - `kind: 'static'` — synchronous read from the prop; never loading.
 * - `kind: 'lazy'`   — reads `useInvitedAppCollaboratorsLazy()` and slices
 *   by `app`. `isLoading` is true for every not-yet-resolved state (`idle`
 *   AND `loading`) so the popup shows the skeleton from the first frame
 *   rather than flashing the empty-state text before the fetch starts.
 *   `error` / missing-slice resolve to `[]` with `isLoading: false`.
 */ const $b723a347558b92ea$var$useResolveCollaborators = (collaboratorsSource)=>{
    // Called unconditionally to keep hook order stable across variants. In
    // experiment mode the provider is not mounted, so this reads the default
    // `{ status: 'idle' }` — no re-renders since its identity is fixed at
    // module load.
    const lazyState = (0, $4nfGk.useInvitedAppCollaboratorsLazy)();
    if (collaboratorsSource.kind === 'static') return {
        collaborators: collaboratorsSource.collaborators,
        isLoading: false
    };
    // Not yet resolved (before the fetch starts, or while it's in flight) —
    // treat both as loading so the popup opens straight into the skeleton.
    if (lazyState.status === 'idle' || lazyState.status === 'loading') return {
        collaborators: [],
        isLoading: true
    };
    if (lazyState.status !== 'ready') return {
        collaborators: [],
        isLoading: false
    };
    return {
        collaborators: lazyState.collaboratorsByApp[collaboratorsSource.app] ?? [],
        isLoading: false
    };
};
/** Resolves collaborators + count + `hasCollaborators` + `isLoading` for the popup. */ const $b723a347558b92ea$var$useCollaboratorsInfo = (collaboratorsSource)=>{
    const { collaborators: collaborators, isLoading: isLoading } = $b723a347558b92ea$var$useResolveCollaborators(collaboratorsSource);
    return {
        collaborators: collaborators,
        collaboratorsCount: collaborators.length,
        hasCollaborators: collaborators.length > 0,
        isLoading: isLoading
    };
};
const $b723a347558b92ea$export$dcca2f78da63545d = ({ collaboratorsSource: collaboratorsSource, currentApsKey: currentApsKey, currentShortcutLink: currentShortcutLink, onAcceptInvite: onAcceptInvite, onMouseEnterPopup: onMouseEnterPopup, onMouseLeavePopup: onMouseLeavePopup, trigger: trigger })=>{
    const { fireLinkClickedAcceptInvite: fireLinkClickedAcceptInvite } = (0, $k7ixb.useInvitedAppAnalytics)();
    const { collaborators: collaborators, collaboratorsCount: collaboratorsCount, hasCollaborators: hasCollaborators, isLoading: isLoading } = $b723a347558b92ea$var$useCollaboratorsInfo(collaboratorsSource);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($b723a347558b92ea$var$InvitedAppPopup, {
            trigger: trigger,
            onMouseEnterPopup: onMouseEnterPopup,
            onMouseLeavePopup: onMouseLeavePopup,
            currentApsKey: currentApsKey,
            hasCollaborators: hasCollaborators,
            collaboratorsCount: collaboratorsCount,
            children: isLoading ? // While the lazy collaborators fetch is in flight, show only the
            // loading skeleton — two stacked lines standing in for the title +
            // subtitle text, no descriptive text or accept-invite link.
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
                space: "space.100",
                testId: "invited-app-collaborators-loading",
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
                        width: $b723a347558b92ea$var$SKELETON_TITLE_WIDTH,
                        height: $b723a347558b92ea$var$SKELETON_LINE_HEIGHT,
                        borderRadius: "var(--ds-radius-small, 4px)",
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
                        width: $b723a347558b92ea$var$SKELETON_SUBTITLE_WIDTH,
                        height: $b723a347558b92ea$var$SKELETON_LINE_HEIGHT,
                        borderRadius: "var(--ds-radius-small, 4px)",
                        isShimmering: true
                    })
                ]
            }) : /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.Inline), {
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $defJG.Inline), {
                        grow: "fill",
                        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
                            alignBlock: "start",
                            alignInline: "start",
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                                    children: hasCollaborators ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                        ...(0, $bz7rH.messages).popupMainTextWithCollaborators
                                    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                        ...(0, $bz7rH.messages).popupMainTextWithoutCollaborators
                                    })
                                }),
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hzWaA.default), {
                                    href: currentShortcutLink,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    onClick: ()=>{
                                        const app = (0, $hmszZ.getAppKeyByApsKey)(currentApsKey);
                                        fireLinkClickedAcceptInvite({
                                            app: app
                                        });
                                        onAcceptInvite(app);
                                    },
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                        ...(0, $bz7rH.messages).popupAcceptInviteButton
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)($b723a347558b92ea$var$PopupCollaboratorsBody, {
                        collaborators: collaborators,
                        currentApsKey: currentApsKey
                    })
                ]
            })
        })
    });
};
$b723a347558b92ea$export$dcca2f78da63545d.displayName = "LazyInvitedAppPopup";

});
parcelRegister("hmjOj", function(module, exports) {
$parcel$export(module.exports, "InvitedAppCollaboratorsTooltip", () => $ef49ff31ea4e2b8c$export$cb6b49c74b6579bc);
/* main.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $55qdj = parcelRequire("55qdj");
var $1YIbA = parcelRequire("1YIbA");

var $hZDXn = parcelRequire("hZDXn");
var $8qjTI = parcelRequire("8qjTI");

var $bz7rH = parcelRequire("bz7rH");

var $hmszZ = parcelRequire("hmszZ");

var $k7ixb = parcelRequire("k7ixb");
const $ef49ff31ea4e2b8c$var$styles = {
    root: "_2rkofajl _11c8wadc _vchhusvi _p12f1mjv _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna"
};
/**
 * As truncate is deprecated, we need to use a custom tooltip component to ensure the tooltip can show the message in one line.
 */ const $ef49ff31ea4e2b8c$var$CustomTooltip = /*#__PURE__*/ (0, $euxye.forwardRef)(function CustomTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8qjTI.default), {
        ...rest,
        // Manually passing on `className` so it gets merged correctly in the build output.
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $4jQY2.default)([
            $ef49ff31ea4e2b8c$var$styles.root,
            className
        ]),
        // "css" does not "exist" - it gets transformed into "className" by compiled
        ref: ref,
        testId: "invited-app-collaborators-tooltip",
        children: children
    });
});
const $ef49ff31ea4e2b8c$export$cb6b49c74b6579bc = ({ children: children, currentApsKey: currentApsKey, currentAppCollaborators: currentAppCollaborators })=>{
    const { fireViewedMoreCollaboratorsTooltip: fireViewedMoreCollaboratorsTooltip } = (0, $k7ixb.useInvitedAppAnalytics)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const appMessage = (0, $euxye.useMemo)(()=>{
        switch(currentApsKey){
            case 'JIRA_SOFTWARE':
                return (0, $bz7rH.messages).jira;
            case 'CONFLUENCE':
                return (0, $bz7rH.messages).confluence;
        }
    }, [
        currentApsKey
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        position: "right",
        component: $ef49ff31ea4e2b8c$var$CustomTooltip,
        onShow: ()=>fireViewedMoreCollaboratorsTooltip({
                app: (0, $hmszZ.getAppKeyByApsKey)(currentApsKey),
                collaborators: currentAppCollaborators.length
            }),
        content: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            ...(0, $bz7rH.messages).popupCollaboratorsTooltip,
            values: {
                numberOfCollaborators: currentAppCollaborators.length - 1,
                app: formatMessage(appMessage)
            }
        }),
        children: children
    });
};
$ef49ff31ea4e2b8c$export$cb6b49c74b6579bc.displayName = "InvitedAppCollaboratorsTooltip";

});

parcelRegister("gymQa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("91fFs").then(()=>parcelRequire('eoftY'));

});



parcelRegister("itAmB", function(module, exports) {
$parcel$export(module.exports, "InvitedAppCollaboratorsLazyProvider", () => $e0e4fc76fdafea97$export$86a637885215f4b1);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $kDLwA = parcelRequire("kDLwA");

var $k7ixb = parcelRequire("k7ixb");

var $4nfGk = parcelRequire("4nfGk");
/**
 * Narrows a BFF `CollaboratorProduct` to the subset accepted by
 * `InvitedAppShortcutAllowedTargetAppKey`. Both describe `'jira' | 'confluence'`
 * today; this isolates the cast so the call site stays cast-free, and any
 * future BFF-only product is filtered out at runtime.
 */ const $e0e4fc76fdafea97$var$isAllowedTargetApp = (product, allowed)=>allowed.includes(product);
const $e0e4fc76fdafea97$export$86a637885215f4b1 = ({ cloudId: cloudId, userId: userId, eligibleApps: eligibleApps, sourceApp: sourceApp, children: children })=>{
    const analytics = (0, $k7ixb.useInvitedAppAnalytics)();
    const [state, setState] = (0, $euxye.useState)(()=>eligibleApps.length === 0 ? {
            status: 'ready',
            collaboratorsByApp: {}
        } : {
            status: 'idle'
        });
    // Singleton guard. Cleared on `.catch` for retry; kept after `.then`
    // so a successful fetch is never re-issued.
    const inFlightRef = (0, $euxye.useRef)(null);
    // Prevents state updates after unmount.
    const isMountedRef = (0, $euxye.useRef)(true);
    (0, $euxye.useEffect)(()=>()=>{
            isMountedRef.current = false;
        }, []);
    // Latest-props ref keeps `prefetchAll` identity-stable so an unmemoised
    // `eligibleApps` array doesn't invalidate hover handlers downstream.
    const depsRef = (0, $euxye.useRef)({
        analytics: analytics,
        cloudId: cloudId,
        eligibleApps: eligibleApps,
        sourceApp: sourceApp,
        userId: userId
    });
    depsRef.current = {
        analytics: analytics,
        cloudId: cloudId,
        eligibleApps: eligibleApps,
        sourceApp: sourceApp,
        userId: userId
    };
    const prefetchAll = (0, $euxye.useCallback)(()=>{
        if (inFlightRef.current !== null) return;
        const { analytics: analytics, cloudId: cloudId, eligibleApps: eligibleApps, sourceApp: sourceApp, userId: userId } = depsRef.current;
        if (eligibleApps.length === 0) // Nothing to fetch; provider is already in the `ready` empty state.
        return;
        setState({
            status: 'loading'
        });
        // Cross-validated against `InvitedAppShortcutAllowedTargetAppKey` inside
        // the response loop via `isAllowedTargetApp`. Any future BFF-only
        // product will be filtered out, never indexed into `collaboratorsByApp`.
        const products = eligibleApps;
        // Guard against a synchronous throw before the Promise is created —
        // otherwise `setState('loading')` would leave the provider stuck.
        let pending;
        try {
            pending = (0, $kDLwA.getCollaboratorsInProducts)({
                cloudId: cloudId,
                userId: userId,
                products: products
            });
        } catch (error) {
            inFlightRef.current = null;
            if (!isMountedRef.current) return;
            setState({
                status: 'error',
                error: error
            });
            analytics.fireFetchCollaboratorsAccessFailed({
                sourceApp: sourceApp,
                targetApps: eligibleApps,
                error: error instanceof Error ? error.message : 'unknown'
            });
            return;
        }
        inFlightRef.current = pending.then((rows)=>{
            if (!isMountedRef.current) return;
            const collaboratorsByApp = {};
            for (const { collaborator: collaborator, products: collaboratorProducts } of rows)for (const product of collaboratorProducts){
                if (!$e0e4fc76fdafea97$var$isAllowedTargetApp(product, eligibleApps)) continue;
                // `product` is narrowed to `InvitedAppShortcutAllowedTargetAppKey`.
                const slice = collaboratorsByApp[product] ?? [];
                slice.push({
                    key: collaborator.id,
                    name: collaborator.name,
                    src: collaborator.avatar
                });
                collaboratorsByApp[product] = slice;
            }
            setState({
                status: 'ready',
                collaboratorsByApp: collaboratorsByApp
            });
            analytics.fireFetchCollaboratorsAccessSucceeded({
                sourceApp: sourceApp,
                targetApps: eligibleApps,
                collaborators: rows.length
            });
        }).catch((error)=>{
            // Allow caller-driven retry on the next hover when the fetch
            // failed (network blip, 5xx, etc.). Successful fetches keep
            // the ref set so they are not re-issued.
            inFlightRef.current = null;
            if (!isMountedRef.current) return;
            setState({
                status: 'error',
                error: error
            });
            analytics.fireFetchCollaboratorsAccessFailed({
                sourceApp: sourceApp,
                targetApps: eligibleApps,
                // Normalize to avoid leaking raw server error detail into analytics.
                error: error instanceof Error ? error.message : 'unknown'
            });
        });
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4nfGk.PrefetchContext).Provider, {
        value: prefetchAll,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4nfGk.StateContext).Provider, {
            value: state,
            children: children
        })
    });
};
$e0e4fc76fdafea97$export$86a637885215f4b1.displayName = "InvitedAppCollaboratorsLazyProvider";

});
parcelRegister("kDLwA", function(module, exports) {
$parcel$export(module.exports, "getCollaboratorsInProducts", () => $1ec2621148b43bcc$export$5391c0e0cb095e8a);

var $kOaXe = parcelRequire("kOaXe");

var $5sYd5 = parcelRequire("5sYd5");
const $1ec2621148b43bcc$export$5391c0e0cb095e8a = async ({ cloudId: cloudId, products: products, userId: userId })=>{
    const collaborators = await (0, $kOaXe.getUsersFromCollaborationGraph)('invitedAppShortcuts', cloudId, userId);
    if (collaborators.length === 0) return [];
    const collabsInProducts = await (0, $5sYd5.getPermittedUsersWithProducts)(products, cloudId, collaborators.map((c)=>c.id));
    return $1ec2621148b43bcc$var$mapToCollaboratorsWithProducts(collaborators, collabsInProducts);
};
const $1ec2621148b43bcc$var$mapToCollaboratorsWithProducts = (collaborators, usersWithProducts)=>collaborators.flatMap((collaborator)=>{
        const userWithProducts = usersWithProducts[collaborator.id];
        if (!(userWithProducts && userWithProducts.length > 0)) return [];
        return {
            collaborator: collaborator,
            products: userWithProducts
        };
    });

});
parcelRegister("kOaXe", function(module, exports) {
$parcel$export(module.exports, "getUsersFromCollaborationGraph", () => $8cbb2a814ca6bb05$export$f757fae6e9facd6f);
const $8cbb2a814ca6bb05$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $8cbb2a814ca6bb05$export$f757fae6e9facd6f = async (integration, cloudId, userId)=>{
    const payload = {
        context: {
            contextType: integration,
            principalId: userId,
            siteId: cloudId
        },
        modelRequestParams: {
            experience: 'CgUserNearbyUser'
        },
        expanded: true,
        maxNumberOfResults: $8cbb2a814ca6bb05$var$COLLABORATION_GRAPH_MAX_RESULTS,
        userId: userId
    };
    const response = await fetch('/gateway/api/collaboration/v1/collaborationgraph/user/user', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    const result = (await response.json())?.collaborationGraphEntities?.filter((en)=>en?.userProfile !== undefined && en?.userProfile?.account_type !== 'app' && en?.userProfile?.account_status !== 'deactivated' && en?.userProfile?.account_status !== 'deleted').map(({ userProfile: { account_id: account_id, name: name, picture: picture } })=>({
            id: account_id,
            name: name,
            avatar: picture
        }));
    return result;
};

});

parcelRegister("5sYd5", function(module, exports) {
$parcel$export(module.exports, "getPermittedUsersWithProducts", () => $fbbfb2ad6039c4ca$export$c25eadb566c78ee);
const $fbbfb2ad6039c4ca$export$c25eadb566c78ee = async (products, cloudId, accountIds)=>{
    const response = await fetch('/gateway/api/growth/invite-notify-1p/get-permitted-users-with-products', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            cloudId: cloudId,
            products: products,
            accountIds: accountIds
        })
    });
    return await response.json();
};

});




parcelRegister("58v8Z", function(module, exports) {
$parcel$export(module.exports, "useTeamsAppShortcut", () => $3e2a78a1aab36a04$export$68b2e4594fafcb97);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $adrK8 = parcelRequire("adrK8");

var $dDRge = parcelRequire("dDRge");

var $5tPwf = parcelRequire("5tPwf");

var $rKVUU = parcelRequire("rKVUU");

var $3EXjU = parcelRequire("3EXjU");



var $bOwox = parcelRequire("bOwox");

var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $af94c = parcelRequire("af94c");


var $8Sdzy = parcelRequire("8Sdzy");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $jMVYt = parcelRequire("jMVYt");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");
const $3e2a78a1aab36a04$var$CREATE_A_TEAM = 'createATeam';
const $3e2a78a1aab36a04$var$INVITE_PEOPLE = 'invitePeople';
const $3e2a78a1aab36a04$var$teamsShortcutCreateTeamMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.create-team",
    defaultMessage: "Create a team"
});
const $3e2a78a1aab36a04$var$teamsShortcutInvitePeopleMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.invite-people",
    defaultMessage: "Invite people"
});
function $3e2a78a1aab36a04$export$68b2e4594fafcb97() {
    const $ = (0, $e7boj.c)(30);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $af94c.getUserNavigationItemLinks)();
        $[0] = t0;
    } else t0 = $[0];
    const USER_NAVIGATION_ITEM_LINKS = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $i860n.fg)("teams-app-shortcut-nudge");
        $[1] = t1;
    } else t1 = $[1];
    const peopleMenuWrapperRef = (0, $adrK8.useRegisterNudgeTarget)((0, $99cb2e6a234d7a1f$export$77bc79debbf5c069), t1).ref;
    let t2;
    if ($[2] !== peopleMenuWrapperRef) {
        t2 = {
            ref: peopleMenuWrapperRef
        };
        $[2] = peopleMenuWrapperRef;
        $[3] = t2;
    } else t2 = $[3];
    const teamsConfig = (0, $jMVYt.useTeams)(USER_NAVIGATION_ITEM_LINKS[0, $5IkoH.MENU_ID_TEAMS], t2);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const invitePeopleModalTrigger = (0, $rKVUU.useInvitePeopleModal)((0, $3EXjU.EnablementTouchpoint).NAV4_TEAMS_ADD);
    const [createTeamModal, createTeamModalTrigger] = (0, $5tPwf.useCreateTeamModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const invitePeopleModalTriggerRef = (0, $euxye.useRef)(invitePeopleModalTrigger);
    const createTeamModalTriggerRef = (0, $euxye.useRef)(createTeamModalTrigger);
    const createAnalyticsEventRef = (0, $euxye.useRef)(createAnalyticsEvent);
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== createTeamModalTrigger || $[6] !== invitePeopleModalTrigger) {
        t3 = ()=>{
            invitePeopleModalTriggerRef.current = invitePeopleModalTrigger;
            createTeamModalTriggerRef.current = createTeamModalTrigger;
            createAnalyticsEventRef.current = createAnalyticsEvent;
        };
        $[4] = createAnalyticsEvent;
        $[5] = createTeamModalTrigger;
        $[6] = invitePeopleModalTrigger;
        $[7] = t3;
    } else t3 = $[7];
    (0, $euxye.useEffect)(t3);
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $i860n.fg)("teams-app-shortcut-nudge") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dDRge.InviteTeamNudgeAsync), null);
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== createTeamModal) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, t4, createTeamModal);
        $[9] = createTeamModal;
        $[10] = t5;
    } else t5 = $[10];
    const component = t5;
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEventRef.current({}), {
                action: "clicked",
                actionSubject: "dropdownItem",
                actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_TEAMS],
                attributes: {
                    level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                    componentType: (0, $6e2f51712bb2e810$export$17bca95234dea43b),
                    parentItemId: (0, $bOwox.GLOBAL_APP_SHORTCUT_TEAMS),
                    itemId: $3e2a78a1aab36a04$var$INVITE_PEOPLE
                }
            });
            invitePeopleModalTriggerRef.current();
        };
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== formatMessage) {
        t7 = formatMessage($3e2a78a1aab36a04$var$teamsShortcutInvitePeopleMessage);
        $[12] = formatMessage;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== t7) {
        t8 = [
            {
                onClick: t6,
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, t7)
            }
        ];
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    const invitePeopleAction = t8;
    let t9;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>{
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEventRef.current({}), {
                action: "clicked",
                actionSubject: "dropdownItem",
                actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_TEAMS],
                attributes: {
                    level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                    componentType: (0, $6e2f51712bb2e810$export$17bca95234dea43b),
                    parentItemId: (0, $bOwox.GLOBAL_APP_SHORTCUT_TEAMS),
                    itemId: $3e2a78a1aab36a04$var$CREATE_A_TEAM
                }
            });
            createTeamModalTriggerRef.current();
        };
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== formatMessage) {
        t10 = formatMessage($3e2a78a1aab36a04$var$teamsShortcutCreateTeamMessage);
        $[17] = formatMessage;
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== t10) {
        t11 = {
            onClick: t9,
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), null, t10)
        };
        $[19] = t10;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== invitePeopleAction || $[22] !== t11) {
        t12 = [
            ...invitePeopleAction,
            t11
        ];
        $[21] = invitePeopleAction;
        $[22] = t11;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== t12 || $[25] !== teamsConfig) {
        t13 = {
            ...teamsConfig,
            actions: t12
        };
        $[24] = t12;
        $[25] = teamsConfig;
        $[26] = t13;
    } else t13 = $[26];
    const config = t13;
    let t14;
    if ($[27] !== component || $[28] !== config) {
        t14 = {
            config: config,
            component: component
        };
        $[27] = component;
        $[28] = config;
        $[29] = t14;
    } else t14 = $[29];
    return t14;
}

});
parcelRegister("adrK8", function(module, exports) {
$parcel$export(module.exports, "useNudgeController", () => $6ba8720603f95a91$export$9a533735412babca);
$parcel$export(module.exports, "useRegisterNudgeTarget", () => $6ba8720603f95a91$export$eb8a96124d659f2d);

var $euxye = parcelRequire("euxye");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 *  See some of the history here https://hello.atlassian.net/wiki/spaces/~620663553/pages/2896059847/Shipit+57+-+Out+of+Tree+Nudges
 */ class $6ba8720603f95a91$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $6ba8720603f95a91$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
$6ba8720603f95a91$var$NudgeController.displayName = "NudgeController";
const $6ba8720603f95a91$export$9a533735412babca = ()=>$6ba8720603f95a91$var$NudgeController.instance;
const $6ba8720603f95a91$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $6ba8720603f95a91$export$9a533735412babca();
    const ref = (0, $euxye.useRef)(null);
    (0, $euxye.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};

});

parcelRegister("dDRge", function(module, exports) {
$parcel$export(module.exports, "InviteTeamNudgeAsync", () => $48e976aaf67cc503$export$a4b4061b22dbc897);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");


var $4hGfa = parcelRequire("4hGfa");


var $3yseG = parcelRequire("3yseG");
const $48e976aaf67cc503$var$runtimeProps = {};
const $48e976aaf67cc503$var$entryPointParams = {};
const $48e976aaf67cc503$export$a4b4061b22dbc897 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $3yseG.inviteTeamNudgeEntryPoint), $48e976aaf67cc503$var$entryPointParams);
    const [nudgeStep] = (0, $4hGfa.useNudgeStep)();
    const [hasNudgeActive] = (0, $4hGfa.useHasNudgeActive)();
    const firstLoadRef = (0, $euxye.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $euxye.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $99cb2e6a234d7a1f$export$77bc79debbf5c069)) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        id: (0, $2d67c2e6ae8f10e6$export$3bc551fe07069f89),
        packageName: "jiraInviteTeamOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null),
        runtimeProps: $48e976aaf67cc503$var$runtimeProps
    });
};
$48e976aaf67cc503$export$a4b4061b22dbc897.displayName = "InviteTeamNudgeAsync";

});
parcelRegister("4hGfa", function(module, exports) {
$parcel$export(module.exports, "useJswOnboarding", () => $6a01d2fc90f5432a$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $6a01d2fc90f5432a$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $6a01d2fc90f5432a$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $6a01d2fc90f5432a$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $6a01d2fc90f5432a$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useInviteToProject", () => $6a01d2fc90f5432a$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $6a01d2fc90f5432a$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $6a01d2fc90f5432a$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $6a01d2fc90f5432a$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $6a01d2fc90f5432a$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $6a01d2fc90f5432a$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $6a01d2fc90f5432a$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $6a01d2fc90f5432a$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $6a01d2fc90f5432a$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $6a01d2fc90f5432a$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $6a01d2fc90f5432a$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $6a01d2fc90f5432a$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useHasNudgeActive", () => $6a01d2fc90f5432a$export$521909e3dc7ab811);
$parcel$export(module.exports, "useIsOpenedViaButton", () => $6a01d2fc90f5432a$export$2317d3c684b416ec);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("5ZtCQ")).QUICKSTART_UI_STATUS);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
var $iGu4q = parcelRequire("iGu4q");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $lc0xf = parcelRequire("lc0xf");

var $8ZIK8 = parcelRequire("8ZIK8");

var $ia7JZ = parcelRequire("ia7JZ");

var $1n5q3 = parcelRequire("1n5q3");

var $1DyW0 = parcelRequire("1DyW0");
const $6a01d2fc90f5432a$export$390f32400eaf98c9 = (0, $5QDqc.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $ia7JZ.initialState,
    actions: $lc0xf.actions
});
const $6a01d2fc90f5432a$export$1cbc60d8dd921852 = (0, $iGu4q.createSubscriber)($6a01d2fc90f5432a$export$390f32400eaf98c9);
const $6a01d2fc90f5432a$export$7d91c0af4772787a = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9);
const $6a01d2fc90f5432a$export$638bfcfce1254bb8 = (0, $dB6ay.createContainer)($6a01d2fc90f5432a$export$390f32400eaf98c9, {});
const $6a01d2fc90f5432a$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, $1n5q3.getQuickstartTypeSelector)(state)] === (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $6a01d2fc90f5432a$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $6a01d2fc90f5432a$export$594f006fa6a1b2e5 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: $6a01d2fc90f5432a$export$ea14030920a5d8e6
});
const $6a01d2fc90f5432a$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $6a01d2fc90f5432a$export$c5e63e44ad178ae8 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: $6a01d2fc90f5432a$export$a943afa434e9487a
});
const $6a01d2fc90f5432a$export$2c3cd14fff9d6e43 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: null
});
const $6a01d2fc90f5432a$export$b0db7e46e369e1d9 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: $6a01d2fc90f5432a$export$9d731f44f82af09f
});
const $6a01d2fc90f5432a$export$71de79653346a1ea = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $6a01d2fc90f5432a$export$61185a9266f1f57a = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $8ZIK8.USER_ROLE).JIRA_ADMIN || userRole === (0, $8ZIK8.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $6a01d2fc90f5432a$export$ef4747ba36826d6a = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $6a01d2fc90f5432a$export$522993b46d9f8266 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>{
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        if (state.shouldRenderComponent === false) return (0, $1DyW0.getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, $5ZtCQ.QUICKSTART_UI_STATUS).NOT_LOADED;
        return state.visibility[quickstartType];
    }
});
const $6a01d2fc90f5432a$export$aa4ba29241532382 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $6a01d2fc90f5432a$export$ed5c755b733bf2b1 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $6a01d2fc90f5432a$export$35fe0366802512dd = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>{
        const visibility = state.visibility[(0, $1n5q3.getQuickstartTypeSelector)(state)];
        return visibility === (0, $5ZtCQ.QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, $5ZtCQ.QUICKSTART_UI_STATUS).NOT_LOADED;
    }
});
const $6a01d2fc90f5432a$export$a41ee0d3b6938099 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $6a01d2fc90f5432a$export$4ae7b465b076be9 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $6a01d2fc90f5432a$export$bf6e646c0476acad = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $6a01d2fc90f5432a$export$6b706bff94798d11 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $6a01d2fc90f5432a$export$c98db656edc5b3e1 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $6a01d2fc90f5432a$export$521909e3dc7ab811 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $6a01d2fc90f5432a$export$f4a2be940259bf95 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});
const $6a01d2fc90f5432a$export$6db1f59c8ab54061 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.quickstartButtonRef
});
const $6a01d2fc90f5432a$export$2317d3c684b416ec = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.isOpenedViaButton
});
const $6a01d2fc90f5432a$export$a57f80e92714bb45 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.containerType
});

});
parcelRegister("lc0xf", function(module, exports) {
$parcel$export(module.exports, "actions", () => $95098241613986c7$export$e324594224ef24da);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $lshfi = parcelRequire("lshfi");

var $eahz5 = parcelRequire("eahz5");

var $4sdAq = parcelRequire("4sdAq");

var $k2hbg = parcelRequire("k2hbg");

var $2viaa = parcelRequire("2viaa");

var $agR3I = parcelRequire("agR3I");

var $3riN6 = parcelRequire("3riN6");

var $2yI5h = parcelRequire("2yI5h");

var $7925l = parcelRequire("7925l");

var $2eU4H = parcelRequire("2eU4H");

var $6zJVJ = parcelRequire("6zJVJ");

var $8qaqK = parcelRequire("8qaqK");

var $4BoSU = parcelRequire("4BoSU");

var $gJ2q6 = parcelRequire("gJ2q6");

var $agOGQ = parcelRequire("agOGQ");

var $ljq2N = parcelRequire("ljq2N");

var $2wjIB = parcelRequire("2wjIB");

var $1XEDt = parcelRequire("1XEDt");

var $lhMTU = parcelRequire("lhMTU");

var $ktOmH = parcelRequire("ktOmH");

var $3slnW = parcelRequire("3slnW");

var $hOXkl = parcelRequire("hOXkl");

var $jJY2t = parcelRequire("jJY2t");

var $bNXf6 = parcelRequire("bNXf6");

var $2D5ku = parcelRequire("2D5ku");

var $adLxs = parcelRequire("adLxs");
const $95098241613986c7$export$e324594224ef24da = {
    changeTaskGroupParent: $lshfi.nextChangeTaskGroupParent,
    goBackToPreviousTaskGroup: $lshfi.nextGoBackToPreviousTaskGroup,
    setIsOpen: $eahz5.setIsOpen,
    refreshAppState: $4sdAq.refreshAppState,
    setNudgeStep: $k2hbg.setNudgeStep,
    addMountedNudge: $2viaa.addMountedNudge,
    removeMountedNudge: $2viaa.removeMountedNudge,
    setShouldRenderComponent: $agR3I.setShouldRenderComponent,
    setProjectState: $3riN6.setProjectState,
    setHasNudgeActive: $2yI5h.setHasNudgeActive,
    forceHideNudge: $7925l.forceHideNudge,
    setHasEverSeenRoute: $2eU4H.setHasEverSeenRoute,
    setRoadmapIsCreateEnabled: $6zJVJ.setRoadmapIsCreateEnabled,
    setRoadmapIsListEmpty: $6zJVJ.setRoadmapIsListEmpty,
    openNextTask: $8qaqK.openNextTask,
    resetIsQuickstartLoaded: $4BoSU.resetIsQuickstartLoaded,
    refreshAppStateUiStatusOnly: $gJ2q6.refreshAppStateUiStatusOnly,
    nextMarkAsCompletedTask: $agOGQ.nextMarkAsCompletedTask,
    nextSetChecklistItemSeen: $ljq2N.nextSetChecklistItemSeen,
    nextSetChecklistIsDismissed: $2wjIB.nextSetChecklistIsDismissed,
    nextSetChecklistIsOpen: $1XEDt.nextSetChecklistIsOpen,
    nextOpenTask: $lhMTU.nextOpenTask,
    nextAutoExpand: $ktOmH.nextAutoExpand,
    nextShouldShowNudgeAfterNavigation: $3slnW.nextShouldShowNudgeAfterNavigation,
    nextGetTasks: $hOXkl.nextGetTasks,
    syncVisibilityWithLocal: $jJY2t.syncVisibilityWithLocal,
    universalDispatch: $bNXf6.universalDispatch,
    setContainerType: $2D5ku.setContainerType,
    setQuickstartButtonRef: $adLxs.setQuickstartButtonRef,
    setIsOpenedViaButton: $adLxs.setIsOpenedViaButton,
    focusQuickstartButton: $adLxs.focusQuickstartButton
};

});
parcelRegister("lshfi", function(module, exports) {
$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $daa1afacdb588798$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $daa1afacdb588798$export$57534cbc400a434c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");
const $daa1afacdb588798$var$setTaskGroup = (taskGroup, openTask)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: openTask || ''
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $daa1afacdb588798$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($daa1afacdb588798$var$setTaskGroup(taskGroup));
    };
const $daa1afacdb588798$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
        const lastIndexOfPreviousTaskGroupParents = previousTaskGroupParents.length - 1;
        const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $5ZtCQ.ROOT_TASK) : previousTaskGroupParents[lastIndexOfPreviousTaskGroupParents];
        const newPreviousTaskGroupParents = previousTaskGroupParents.slice(0, lastIndexOfPreviousTaskGroupParents);
        const taskGroup = {
            previousTaskGroupParents: newPreviousTaskGroupParents,
            currentTaskGroupParent: newTaskGroupParent
        };
        dispatch($daa1afacdb588798$var$setTaskGroup(taskGroup, currentTriggerForTaskGroupParent));
    };

});
parcelRegister("kRAaT", function(module, exports) {
$parcel$export(module.exports, "pushToBackend", () => $fe5c7f55be2b2016$export$583b2d2422a6757f);
/* eslint-disable jira/filename-case */ 
var $hFtK7 = parcelRequire("hFtK7");

var $kM0go = parcelRequire("kM0go");

var $2HuOR = parcelRequire("2HuOR");

var $75sVW = parcelRequire("75sVW");
const $fe5c7f55be2b2016$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $2HuOR.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $fe5c7f55be2b2016$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $kM0go.setUserProperties)($fe5c7f55be2b2016$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $75sVW.default)(response.status, response.statusText);
    });
const $fe5c7f55be2b2016$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $fe5c7f55be2b2016$var$setRemoteUserProperties(props);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $fe5c7f55be2b2016$export$583b2d2422a6757f = async (props)=>{
    const success = await $fe5c7f55be2b2016$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $fe5c7f55be2b2016$var$trySetUserProperties(props, 2);
};

});


parcelRegister("eahz5", function(module, exports) {
$parcel$export(module.exports, "setIsOpen", () => $08569e867f217dd5$export$dcf23146e0a40195);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");

var $1n5q3 = parcelRequire("1n5q3");
const $08569e867f217dd5$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN;
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN : (0, $5ZtCQ.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            }
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        // Delete code below when cleaning up isOpen in state
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.KEY_OPEN),
            value: isOpen
        });
    };
var $08569e867f217dd5$export$2e2bcd8739ae039 = $08569e867f217dd5$export$dcf23146e0a40195;

});
parcelRegister("1n5q3", function(module, exports) {
$parcel$export(module.exports, "getQuickstartTypeSelector", () => $9ce6b193d3030c6f$export$eae834ce0286017a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");

var $5ZtCQ = parcelRequire("5ZtCQ");
const $9ce6b193d3030c6f$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $f99M0.SERVICE_DESK_PROJECT);
const $9ce6b193d3030c6f$export$eae834ce0286017a = (state)=>{
    if ($9ce6b193d3030c6f$export$6f17f2cb816105eb(state)) return (0, $5ZtCQ.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $5ZtCQ.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("4sdAq", function(module, exports) {
$parcel$export(module.exports, "refreshAppState", () => $09503d60e1c07774$export$797c35e2e1d0d014);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");


var $5ZtCQ = parcelRequire("5ZtCQ");

var $cXK8c = parcelRequire("cXK8c");

var $3gWPd = parcelRequire("3gWPd");

var $j4vHl = parcelRequire("j4vHl");

var $7rCTA = parcelRequire("7rCTA");

var $1DyW0 = parcelRequire("1DyW0");

var $2wjIB = parcelRequire("2wjIB");
const $09503d60e1c07774$var$allTasks = [
    ...(0, $5ZtCQ.allTasksExcludingJSMBusinessTasks),
    ...(0, $5ZtCQ.JSM_BUSINESS_TASKS)
];
const $09503d60e1c07774$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType, containerType: containerType = 'project' })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectType;
        updatedState.containerType = containerType;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // oxlint-disable-next-line typescript/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).map((type)=>(0, $5ZtCQ.getBackendVisibilityKey)(type));
        if (projectState?.projectId) jsmTaskProjectKeys = (0, $5ZtCQ.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        const backendState = await (0, $cXK8c.pollBackend)({
            keys: [
                (0, $5ZtCQ.KEY_OPEN),
                (0, $5ZtCQ.KEY_DISMISSED),
                (0, $5ZtCQ.KEY_OPEN_TASK),
                (0, $5ZtCQ.KEY_TASK_GROUP),
                (0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $5ZtCQ.KEY_JSW_ONBOARDING),
                (0, $5ZtCQ.KEY_PREMIUM_TRIAL_REOPENED),
                ...$09503d60e1c07774$var$allTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $5ZtCQ.allTasksExcludingJSMBusinessTasks),
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true);
            Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $5ZtCQ.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $5ZtCQ.getBackendVisibilityKey)(type)];
                else if ((0, $5ZtCQ.KEY_DISMISSED) in backendState && backendState[0, $5ZtCQ.KEY_DISMISSED]) updatedState.visibility[type] = (0, $5ZtCQ.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $5ZtCQ.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $5ZtCQ.KEY_OPEN] ? (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN : (0, $5ZtCQ.QUICKSTART_UI_STATUS).MINIMIZED;
                (0, $1DyW0.setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
            });
            // Delete when cleaning up isDismissed in state
            if ((0, $5ZtCQ.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $5ZtCQ.KEY_DISMISSED];
            // Delete when cleaning up isOpen in state
            if ((0, $5ZtCQ.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $5ZtCQ.KEY_OPEN];
            if ((0, $5ZtCQ.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $5ZtCQ.KEY_OPEN_TASK];
            if ((0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $5ZtCQ.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $5ZtCQ.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $5ZtCQ.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $5ZtCQ.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING] !== null && (0, $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe) in backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING][0, $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $5ZtCQ.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $7rCTA.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $2wjIB.nextSetChecklistIsDismissed)(true));
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3gWPd.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $j4vHl.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $d8LhJ.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
parcelRegister("cXK8c", function(module, exports) {
$parcel$export(module.exports, "pollBackend", () => $ce9f9ff38f6815c9$export$8420ef0cee98de);
/* eslint-disable jira/filename-case */ 
var $kklcL = parcelRequire("kklcL");

var $5ZtCQ = parcelRequire("5ZtCQ");
const $ce9f9ff38f6815c9$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $kklcL.get)({
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $5ZtCQ.PACKAGE_NAME),
            teamName: (0, $5ZtCQ.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});

parcelRegister("3gWPd", function(module, exports) {
$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $65a2bdf7de0b5c67$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $65a2bdf7de0b5c67$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $65a2bdf7de0b5c67$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $65a2bdf7de0b5c67$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $65a2bdf7de0b5c67$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $65a2bdf7de0b5c67$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $65a2bdf7de0b5c67$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $65a2bdf7de0b5c67$export$6ccbe54cd3a5a12);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $aJ81Y = parcelRequire("aJ81Y");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $e1PBH = parcelRequire("e1PBH");
const $65a2bdf7de0b5c67$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $5ZtCQ.ACTION_SUBJECT_ID), attributes);
};
const $65a2bdf7de0b5c67$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $65a2bdf7de0b5c67$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $65a2bdf7de0b5c67$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $aJ81Y.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $5ZtCQ.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $65a2bdf7de0b5c67$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $aJ81Y.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $e1PBH.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $65a2bdf7de0b5c67$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $hFtK7.fireErrorAnalytics)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $65a2bdf7de0b5c67$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $5ZtCQ.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $65a2bdf7de0b5c67$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $5ZtCQ.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("e1PBH", function(module, exports) {
$parcel$export(module.exports, "getProductType", () => $f6fc132b152c4d81$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $f6fc132b152c4d81$export$3b914201960fa7a6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $74oEx = parcelRequire("74oEx");

var $f99M0 = parcelRequire("f99M0");
const $f6fc132b152c4d81$export$d64a7dd8c7cd80e0 = {
    [(0, $f99M0.CORE_PROJECT)]: 'workManagement',
    [(0, $f99M0.SOFTWARE_PROJECT)]: 'software',
    [(0, $f99M0.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $f6fc132b152c4d81$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $f6fc132b152c4d81$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))(projectType);
    return null;
};
const $f6fc132b152c4d81$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))(taskId.split('.').pop());
};

});


parcelRegister("j4vHl", function(module, exports) {
$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $85be8d50a9cdd4b5$export$7f2186c37a3d095d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $i860n = parcelRequire("i860n");

var $h2wCv = parcelRequire("h2wCv");

var $aJ81Y = parcelRequire("aJ81Y");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $rNOHK = parcelRequire("rNOHK");
const $85be8d50a9cdd4b5$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $85be8d50a9cdd4b5$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $85be8d50a9cdd4b5$var$ONE_DAY = 86400000;
const $85be8d50a9cdd4b5$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$85be8d50a9cdd4b5$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $h2wCv.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $i860n.fg)('is_synthetic_tenant')
        });
        return result;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $5ZtCQ.PACKAGE_NAME),
                teamName: (0, $5ZtCQ.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $i860n.fg)('is_synthetic_tenant')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $85be8d50a9cdd4b5$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $rNOHK.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $85be8d50a9cdd4b5$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $i860n.fg)('is_synthetic_tenant')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $85be8d50a9cdd4b5$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $85be8d50a9cdd4b5$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("rNOHK", function(module, exports) {
$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $ff998122ab90c822$export$99f3e48748c2a8c3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $cBnIS = parcelRequire("cBnIS");

const $ff998122ab90c822$var$crossProjectBoardTraitSessionProvider = (0, $cBnIS.createSessionExpirableStorageProvider)((0, $cf3747d320ece5f0$export$fac14ff24e5b1e7a));
const $ff998122ab90c822$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        // @browser-storage setter
        $ff998122ab90c822$var$crossProjectBoardTraitSessionProvider.set((0, $cf3747d320ece5f0$export$fac14ff24e5b1e7a), toPersist);
    };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const get = ()=>$ff998122ab90c822$var$crossProjectBoardTraitSessionProvider.get((0, $cf3747d320ece5f0$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
/* eslint-disable jira/filename-case */ const $cf3747d320ece5f0$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("7rCTA", function(module, exports) {
$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $a2d25f665e97755b$export$980c26b6f100081d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $a2d25f665e97755b$export$980c26b6f100081d = ()=>(0, $h2wCv.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("1DyW0", function(module, exports) {
$parcel$export(module.exports, "getNextNonCompleteTask", () => $c23f851187752075$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $c23f851187752075$export$404421ce8f3cbf9a);
$parcel$export(module.exports, "setLocalStorageItem", () => $c23f851187752075$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $c23f851187752075$export$93d719890ad66653);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $iXN50 = parcelRequire("iXN50");

var $b10Xz = parcelRequire("b10Xz");
const $c23f851187752075$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $b10Xz.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $c23f851187752075$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $b10Xz.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};
const $c23f851187752075$var$store = (0, $iXN50.createLocalStorageProvider)('quickstart');
const $c23f851187752075$export$5aa524d86254b4f = (key, value)=>{
    // @browser-storage setter
    $c23f851187752075$var$store.set(key, value);
};
const $c23f851187752075$export$93d719890ad66653 = (key)=>$c23f851187752075$var$store.get(key);

});
parcelRegister("b10Xz", function(module, exports) {
$parcel$export(module.exports, "getTaskIndex", () => $1c91ec05f437a692$export$9ba3adcb1954c00);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $1c91ec05f437a692$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};

});


parcelRegister("2wjIB", function(module, exports) {
$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $b10962e0ec92b529$export$f24c05f83b880547);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");

var $1n5q3 = parcelRequire("1n5q3");

var $1DyW0 = parcelRequire("1DyW0");
const $b10962e0ec92b529$export$f24c05f83b880547 = (isDismissed)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $5ZtCQ.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $5ZtCQ.QUICKSTART_UI_STATUS).DISMISSED : (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN;
        await (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $1DyW0.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
    };

});


parcelRegister("k2hbg", function(module, exports) {
$parcel$export(module.exports, "setNudgeStep", () => $f2eed325adbc91e3$export$4debc323813b6997);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f2eed325adbc91e3$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $f2eed325adbc91e3$export$2e2bcd8739ae039 = $f2eed325adbc91e3$export$4debc323813b6997;

});

parcelRegister("2viaa", function(module, exports) {
$parcel$export(module.exports, "addMountedNudge", () => $181780d386438a22$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $181780d386438a22$export$748f4cda8ab98c91);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $181780d386438a22$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $181780d386438a22$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("agR3I", function(module, exports) {
$parcel$export(module.exports, "setShouldRenderComponent", () => $21faee8cd07c7826$export$1f9c6770ed938b6e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $21faee8cd07c7826$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $21faee8cd07c7826$export$2e2bcd8739ae039 = $21faee8cd07c7826$export$1f9c6770ed938b6e;

});

parcelRegister("3riN6", function(module, exports) {
$parcel$export(module.exports, "setProjectState", () => $8be844875c197b4c$export$1ba498e440c0a1e4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $8be844875c197b4c$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $8be844875c197b4c$export$2e2bcd8739ae039 = $8be844875c197b4c$export$1ba498e440c0a1e4;

});

parcelRegister("2yI5h", function(module, exports) {
$parcel$export(module.exports, "setHasNudgeActive", () => $cb36e2a712e94de8$export$497c281e6eb0786e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $cb36e2a712e94de8$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $cb36e2a712e94de8$export$2e2bcd8739ae039 = $cb36e2a712e94de8$export$497c281e6eb0786e;

});

parcelRegister("7925l", function(module, exports) {
$parcel$export(module.exports, "forceHideNudge", () => $27c0283352888859$export$6d1ed97b83a62e8e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
// We use this action in cases where we want to hide the nudge no matter what.
const $27c0283352888859$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("2eU4H", function(module, exports) {
$parcel$export(module.exports, "setHasEverSeenRoute", () => $eed870853487f8ba$export$28e0a4314a1ce52f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");
const $eed870853487f8ba$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $eed870853487f8ba$export$2e2bcd8739ae039 = $eed870853487f8ba$export$28e0a4314a1ce52f;

});

parcelRegister("6zJVJ", function(module, exports) {
$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $2924f9407820ccff$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $2924f9407820ccff$export$932967764e7a0b31);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2924f9407820ccff$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $2924f9407820ccff$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("8qaqK", function(module, exports) {
$parcel$export(module.exports, "openNextTask", () => $828ec87dd11f6c94$export$867dbb6d61569ae9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1DyW0 = parcelRequire("1DyW0");

var $lhMTU = parcelRequire("lhMTU");
const $828ec87dd11f6c94$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $1DyW0.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $lhMTU.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("lhMTU", function(module, exports) {
$parcel$export(module.exports, "nextOpenTask", () => $5acbe4b4d2edaa6b$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $5acbe4b4d2edaa6b$export$cc5f3544a6cb2922);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");

var $k2hbg = parcelRequire("k2hbg");

var $2yI5h = parcelRequire("2yI5h");
const $5acbe4b4d2edaa6b$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $5acbe4b4d2edaa6b$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($5acbe4b4d2edaa6b$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $2yI5h.setHasNudgeActive)(false, taskId));
        else dispatch((0, $2yI5h.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        dispatch((0, $k2hbg.setNudgeStep)(''));
    };
const $5acbe4b4d2edaa6b$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($5acbe4b4d2edaa6b$var$openTask(taskId));
        dispatch((0, $2yI5h.setHasNudgeActive)(false, taskId));
        dispatch((0, $k2hbg.setNudgeStep)(''));
    };

});


parcelRegister("4BoSU", function(module, exports) {
$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $9832d8441f0ceec4$export$bda085a823763e5a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $1n5q3 = parcelRequire("1n5q3");
const $9832d8441f0ceec4$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $5ZtCQ.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("gJ2q6", function(module, exports) {
$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => $b3410c869ae99198$export$87fe8079a4ed9766);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 

var $5ZtCQ = parcelRequire("5ZtCQ");

var $cXK8c = parcelRequire("cXK8c");

var $3gWPd = parcelRequire("3gWPd");

var $7rCTA = parcelRequire("7rCTA");

var $2wjIB = parcelRequire("2wjIB");
const $b3410c869ae99198$export$87fe8079a4ed9766 = ({ taskList: taskList, containerType: containerType = 'project' })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState } = getState();
        if (!projectState) return;
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectState.projectType;
        updatedState.containerType = containerType;
        let backendVisibilityKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // oxlint-disable-next-line typescript/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).map((type)=>(0, $5ZtCQ.getBackendVisibilityKey)(type));
        const backendState = await (0, $cXK8c.pollBackend)({
            keys: [
                (0, $5ZtCQ.KEY_OPEN),
                (0, $5ZtCQ.KEY_DISMISSED),
                (0, $5ZtCQ.KEY_OPEN_TASK),
                (0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $5ZtCQ.KEY_JSW_ONBOARDING),
                ...(0, $5ZtCQ.allTasksExcludingJSMBusinessTasks),
                ...backendVisibilityKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $5ZtCQ.allTasksExcludingJSMBusinessTasks)
                ].includes(key) && backendState[key] === true);
            Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $5ZtCQ.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $5ZtCQ.getBackendVisibilityKey)(type)];
                else if ((0, $5ZtCQ.KEY_DISMISSED) in backendState && backendState[0, $5ZtCQ.KEY_DISMISSED]) updatedState.visibility[type] = (0, $5ZtCQ.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $5ZtCQ.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $5ZtCQ.KEY_OPEN] ? (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN : (0, $5ZtCQ.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $5ZtCQ.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $5ZtCQ.KEY_DISMISSED];
            if ((0, $5ZtCQ.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $5ZtCQ.KEY_OPEN];
            if ((0, $5ZtCQ.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $5ZtCQ.KEY_OPEN_TASK];
            if ((0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $5ZtCQ.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $5ZtCQ.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $5ZtCQ.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $5ZtCQ.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING] !== null && (0, $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe) in backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING][0, $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $5ZtCQ.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $7rCTA.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $2wjIB.nextSetChecklistIsDismissed)(true));
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3gWPd.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        setState({
            taskList: taskList
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});

parcelRegister("agOGQ", function(module, exports) {
$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $8ffbc9dfb3f298b8$export$d6628d41a3bec42d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $kRAaT = parcelRequire("kRAaT");
const $8ffbc9dfb3f298b8$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $kRAaT.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});

parcelRegister("ljq2N", function(module, exports) {
$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $4dc8711b425ff774$export$4eac017dcde0be8f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");
const $4dc8711b425ff774$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
        const hasSeenTaskId = (0, $5ZtCQ.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.convertToHaveSeenItTask)(taskId),
            value: true
        });
    };

});

parcelRegister("1XEDt", function(module, exports) {
$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $0532a026145990a5$export$4249eabbb34e2e69);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");

var $1n5q3 = parcelRequire("1n5q3");

var $1DyW0 = parcelRequire("1DyW0");
const $0532a026145990a5$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN;
        const currentIsMinimised = state.visibility[quickstartType] === (0, $5ZtCQ.QUICKSTART_UI_STATUS).MINIMIZED;
        if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN : (0, $5ZtCQ.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $1DyW0.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isOpen in state
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.KEY_OPEN),
            value: isOpen
        });
    };

});

parcelRegister("ktOmH", function(module, exports) {
$parcel$export(module.exports, "nextAutoExpand", () => $a4785549688c9665$export$3d24e97d30cfd09e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $wtuZr = parcelRequire("wtuZr");

var $1DyW0 = parcelRequire("1DyW0");

var $lhMTU = parcelRequire("lhMTU");
const $a4785549688c9665$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $wtuZr.localStorageProvider)().get({
            accountId: (0, $5ZtCQ.ACCOUNT_ID),
            key: (0, $5ZtCQ.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $1DyW0.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        // If the openTask is the same as the currentTriggerForTaskGroupParent, we just returned back from a sub menu and don't need to auto open the next task
        if (openTask === currentTriggerForTaskGroupParent) return;
        dispatch((0, $lhMTU.nextAutoOpenTask)(taskIdToExpand));
    };

});
parcelRegister("wtuZr", function(module, exports) {
$parcel$export(module.exports, "localStorageProvider", () => $65ddfd76edbdbdc9$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $65ddfd76edbdbdc9$export$f2666fae743fa5f);
/* eslint-disable jira/filename-case */ 
var $hFtK7 = parcelRequire("hFtK7");

var $cBnIS = parcelRequire("cBnIS");

var $5ZtCQ = parcelRequire("5ZtCQ");
const $65ddfd76edbdbdc9$var$DAYS_BEFORE_EXPIRY = 1;
const $65ddfd76edbdbdc9$var$DAY = 86400000;
const $65ddfd76edbdbdc9$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $65ddfd76edbdbdc9$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $65ddfd76edbdbdc9$var$DAYS_BEFORE_EXPIRY * $65ddfd76edbdbdc9$var$DAY;
};
let $65ddfd76edbdbdc9$var$localStorage;
const $65ddfd76edbdbdc9$export$aa821bfb3308a1f5 = ()=>{
    if ($65ddfd76edbdbdc9$var$localStorage) // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
    return $65ddfd76edbdbdc9$var$localStorage;
    const provider = (0, $cBnIS.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($65ddfd76edbdbdc9$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>// @browser-storage setter
        provider.set($65ddfd76edbdbdc9$var$getKey({
            accountId: accountId,
            key: key
        }), value, $65ddfd76edbdbdc9$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($65ddfd76edbdbdc9$var$getKey({
            accountId: accountId,
            key: key
        }));
    $65ddfd76edbdbdc9$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
    return $65ddfd76edbdbdc9$var$localStorage;
};
const $65ddfd76edbdbdc9$export$f2666fae743fa5f = (value)=>{
    $65ddfd76edbdbdc9$export$aa821bfb3308a1f5().set({
        accountId: (0, $5ZtCQ.ACCOUNT_ID),
        key: (0, $5ZtCQ.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});


parcelRegister("3slnW", function(module, exports) {
$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $990f321ad1af71ae$export$6f336ccb6432fcd0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // Special case for nudges that need to show after a navigation.
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $wtuZr = parcelRequire("wtuZr");

var $2yI5h = parcelRequire("2yI5h");
const $990f321ad1af71ae$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $5ZtCQ.ACCOUNT_ID),
            key: (0, $5ZtCQ.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $wtuZr.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $2yI5h.setHasNudgeActive)(true));
            (0, $wtuZr.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("hOXkl", function(module, exports) {
$parcel$export(module.exports, "nextGetTasks", () => $bb46770c873ac15c$export$15d877e1f3abf489);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $kApfL = parcelRequire("kApfL");

var $lhMTU = parcelRequire("lhMTU");
const $bb46770c873ac15c$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { taskList: taskList, completedTaskList: completedTaskList, openTask: openTask, isQuickstartLoaded: isQuickstartLoaded } = getState();
        const tasks = (0, $kApfL.getAllTasks)({
            ...props,
            taskList: taskList
        });
        setState({
            tasks: tasks
        });
        // Auto-open the first incomplete task if no task is currently open
        // Note: nextGetTasks and refreshAppState can in theory happen in any order
        // Only do this if the quickstart is fully loaded (isQuickstartLoaded = true)
        // This ensures backend state has been restored before we auto-open
        if (tasks?.items && tasks.items.length > 0 && isQuickstartLoaded) {
            const firstIncompleteTask = tasks.items.find((taskId)=>!completedTaskList.includes(taskId));
            // If we found a first incomplete task and no task is currently open, open it
            if (firstIncompleteTask && !openTask) dispatch((0, $lhMTU.nextOpenTask)(firstIncompleteTask));
        }
    };

});
parcelRegister("kApfL", function(module, exports) {
$parcel$export(module.exports, "getAllTasks", () => $22017e3d8b39c720$export$d1f442602a91e7cc);

var $41FAq = parcelRequire("41FAq");

var $lG3WD = parcelRequire("lG3WD");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $8ZIK8 = parcelRequire("8ZIK8");

var $9URGr = parcelRequire("9URGr");

var $jrlyX = parcelRequire("jrlyX");

var $cBvJ0 = parcelRequire("cBvJ0");

var $er8Op = parcelRequire("er8Op");

var $dX7f5 = parcelRequire("dX7f5");

var $gehxg = parcelRequire("gehxg");

var $dvbnR = parcelRequire("dvbnR");

var $jXUhc = parcelRequire("jXUhc");
const $22017e3d8b39c720$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    // Removed jira_rt_quickstart_m1 feature flag - serving true case (no reverse trial task list)
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $5ZtCQ.ROOT_TASK];
    return {
        title: title,
        items: (0, $er8Op.getTasks)(variants, taskVariants, items)
    };
};
const $22017e3d8b39c720$var$createJwmTasks = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList, teamType: teamType })=>{
    return $22017e3d8b39c720$export$568bd601466cd235({
        taskGroupParent: taskGroupParent,
        teamType: teamType,
        projectState: projectState,
        taskList: taskList
    });
};
const $22017e3d8b39c720$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $9URGr.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $9URGr.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $8ZIK8.USER_ROLE).JIRA_ADMIN) variants.push((0, $9URGr.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $8ZIK8.USER_ROLE).SITE_ADMIN) variants.push((0, $9URGr.JSM).userRole.siteAdmin);
    return $22017e3d8b39c720$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $9URGr.JSM).taskVariants,
        taskList: (0, $9URGr.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $22017e3d8b39c720$var$createPlanTasks = (taskGroupParent, features)=>{
    const variants = [];
    if (features?.hasPlanDependencies) variants.push((0, $dvbnR.Feature).hasPlanDependencies);
    if (features?.hasPlanProgram) variants.push((0, $dvbnR.Feature).hasPlanProgram);
    if (features?.hasPlanReleases) variants.push((0, $dvbnR.Feature).hasPlanReleases);
    if (features?.hasPlanTeams) variants.push((0, $dvbnR.Feature).hasPlanTeams);
    return $22017e3d8b39c720$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $cBvJ0.PLAN).taskVariants,
        taskList: (0, $cBvJ0.PLAN).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $22017e3d8b39c720$export$d9d83c8e96505820 = (taskGroupParent, teamType, features, permissions)=>{
    const variants = [];
    if (features?.hasBacklog) variants.push((0, $dvbnR.Feature).hasBacklog);
    if (features?.hasSprint) variants.push((0, $dvbnR.Feature).hasSprint);
    if (features?.hasSummaryPage) variants.push((0, $dvbnR.Feature).hasSummaryPage);
    if (features?.hasRoadmap) variants.push((0, $dvbnR.Feature).hasRoadmap);
    if (features?.hasList) variants.push((0, $dvbnR.Feature).hasList);
    if (features?.hasCalendar) variants.push((0, $dvbnR.Feature).hasCalendar);
    if ((0, $41FAq.isFeatureEnabled)('jira', 'jira-development-tab') && features?.hasCode) variants.push((0, $dvbnR.Feature).hasCode);
    if (features?.hasForms) variants.push((0, $dvbnR.Feature).hasForms);
    if (features?.hasPages) variants.push((0, $dvbnR.Feature).hasPages);
    if (!(0, $41FAq.isFeatureEnabled)('jira', 'jira-quickstart-pages')) variants.push((0, $dvbnR.Experience).fedRamp);
    if (permissions?.canCreateIssue) variants.push((0, $dvbnR.Permissions).canCreateIssue);
    variants.push((0, $dvbnR.FeatureGate).removeInitialProjectTemplateName);
    if (teamType && (0, $lG3WD.isTailoredOnboardingTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    return $22017e3d8b39c720$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $gehxg.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariants,
        taskList: (0, $gehxg.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $22017e3d8b39c720$export$e21b96de210942 = ({ taskGroupParent: taskGroupParent, teamType: teamType })=>{
    const variants = [];
    if (teamType && (0, $lG3WD.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    if (!(0, $41FAq.isFeatureEnabled)('jira', 'jira-quickstart-pages')) variants.push((0, $dvbnR.Experience).fedRamp);
    return $22017e3d8b39c720$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $gehxg.TAILORED_ONBOARDING_M2P5).getM2P5TaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $gehxg.TAILORED_ONBOARDING_M2P5).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $22017e3d8b39c720$export$568bd601466cd235 = ({ taskGroupParent: taskGroupParent, teamType: teamType, projectState: projectState, taskList: taskList })=>{
    const variants = [];
    // When cleaning up M2 and consolidating configs, this team type check should just be updated to include MKT & OPS
    if (teamType && (0, $lG3WD.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    if (projectState?.isTrelloCrossflow) variants.push((0, $jrlyX.JWM).experiments.trelloCrossflow);
    if (projectState?.userRole === (0, $8ZIK8.USER_ROLE).SITE_ADMIN) variants.push((0, $jrlyX.JWM).userRole.siteAdmin);
    if (!(0, $41FAq.isFeatureEnabled)('jira', 'jira-quickstart-pages')) variants.push((0, $dvbnR.Experience).fedRamp);
    return $22017e3d8b39c720$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $jXUhc.TAILORED_ONBOARDING_BUSINESS_CONFIG),
        // This should be cleaned up when M2 is cleaned up. Currently it's like this because M2 populates taskList via the BE
        // and then the FE uses it here, ideally M2 cards are in the business config following conventions so they don't get extra priority bypassing other stuff in the config
        // For now there is also an extra check here to show the trello task list for Trello Crossflow users over M2 https://atlassian.slack.com/archives/C082QR7B16Z/p1755066367960509?thread_ts=1755064885.015779&cid=C082QR7B16Z
        taskList: !projectState?.isTrelloCrossflow && taskList ? taskList : (0, $gehxg.TAILORED_ONBOARDING_BUSINESS).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $22017e3d8b39c720$export$d1f442602a91e7cc = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5, features: features, containerType: containerType, permissions: permissions })=>{
    if (containerType === 'plan') return $22017e3d8b39c720$var$createPlanTasks(taskGroupParent, features);
    if ((0, $dX7f5.isJwmProject)(projectState)) return $22017e3d8b39c720$var$createJwmTasks({
        projectState: projectState,
        taskGroupParent: taskGroupParent,
        taskList: taskList,
        teamType: teamType,
        isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5
    });
    if ((0, $dX7f5.isJsmProject)(projectState)) return $22017e3d8b39c720$var$createJsmTasks(projectState, taskGroupParent);
    // Implicitly JSW
    const tailoredOnboardingTasks = $22017e3d8b39c720$export$d9d83c8e96505820(taskGroupParent, teamType, features, permissions);
    return tailoredOnboardingTasks;
};

});
parcelRegister("lG3WD", function(module, exports) {
$parcel$export(module.exports, "isTailoredOnboardingTeamType", () => $d75906a9b0d008ac$export$b924c0b3ec4d268e);
$parcel$export(module.exports, "isTailoredOnboardingM2P5TailoredTeamType", () => $d75906a9b0d008ac$export$26c385918d734203);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $9tKPh = parcelRequire("9tKPh");
const $d75906a9b0d008ac$export$b924c0b3ec4d268e = (teamType)=>{
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return (0, $9tKPh.tailoredTeamTypes).includes(teamType);
};
const $d75906a9b0d008ac$export$26c385918d734203 = (teamType)=>{
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return (0, $9tKPh.tailoredM2P5TeamTypes).includes(teamType);
};

});
parcelRegister("9tKPh", function(module, exports) {
$parcel$export(module.exports, "tailoredTeamTypes", () => $55524e5bf5684c10$export$a1fbb7d965e15a39);
$parcel$export(module.exports, "tailoredM2P5TeamTypes", () => $55524e5bf5684c10$export$52c5394d6e6cfcf3);
/* eslint-disable jira/filename-case */ 
const $55524e5bf5684c10$export$a1fbb7d965e15a39 = [
    (0, $99cb2e6a234d7a1f$export$e5c438b7501b5a24),
    (0, $99cb2e6a234d7a1f$export$d7de553940261eba),
    (0, $99cb2e6a234d7a1f$export$e4824f74b9879164),
    (0, $99cb2e6a234d7a1f$export$4f3cb0844009af52),
    (0, $99cb2e6a234d7a1f$export$cbc0e551d91a692d),
    (0, $99cb2e6a234d7a1f$export$4f54a09a24fd1d74),
    (0, $99cb2e6a234d7a1f$export$79685802e8ff1098),
    (0, $99cb2e6a234d7a1f$export$b8b1ac856ba1434b)
];
const $55524e5bf5684c10$export$52c5394d6e6cfcf3 = [
    (0, $99cb2e6a234d7a1f$export$e5c438b7501b5a24),
    (0, $99cb2e6a234d7a1f$export$d7de553940261eba),
    (0, $99cb2e6a234d7a1f$export$cbc0e551d91a692d),
    (0, $99cb2e6a234d7a1f$export$4f54a09a24fd1d74),
    (0, $99cb2e6a234d7a1f$export$79685802e8ff1098),
    (0, $99cb2e6a234d7a1f$export$b8b1ac856ba1434b)
];

});


parcelRegister("8ZIK8", function(module, exports) {
$parcel$export(module.exports, "USER_ROLE", () => $00acda1fb13631fd$export$8eeb199b23203523);
/* eslint-disable jira/filename-case */ const $00acda1fb13631fd$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("9URGr", function(module, exports) {
$parcel$export(module.exports, "JSM", () => $964fea8378454aec$export$63f289f2da861d35);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jvANo = parcelRequire("jvANo");
const $964fea8378454aec$export$63f289f2da861d35 = {
    taskList: (0, $jvANo.JSM_TASK_LIST),
    taskVariants: (0, $jvANo.JSM_TASK_VARIANTS),
    userRole: (0, $jvANo.UserRole),
    experiments: (0, $jvANo.Experiments)
};

});
parcelRegister("jvANo", function(module, exports) {
$parcel$export(module.exports, "JSM_TASK_LIST", () => $330594c6136585e6$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $330594c6136585e6$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $330594c6136585e6$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $330594c6136585e6$export$5b68aef408c932d9);
/* eslint-disable jira/filename-case */ 
var $7eNDO = parcelRequire("7eNDO");

var $5ZtCQ = parcelRequire("5ZtCQ");
const $330594c6136585e6$var$rootTitle = (0, $7eNDO.defineMessage)({
    id: "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
    defaultMessage: "Quickstart"
});
const $330594c6136585e6$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: $330594c6136585e6$var$rootTitle,
        items: [
            (0, $5ZtCQ.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $5ZtCQ.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $5ZtCQ.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $330594c6136585e6$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $330594c6136585e6$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $330594c6136585e6$export$5b68aef408c932d9 = {
    [(0, $5ZtCQ.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $5ZtCQ.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $5ZtCQ.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});


parcelRegister("jrlyX", function(module, exports) {
$parcel$export(module.exports, "JWM", () => $7467b6c089b3897b$export$3ff26c80cb588e12);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5gtk6 = parcelRequire("5gtk6");

var $eFRe9 = parcelRequire("eFRe9");

var $fWmos = parcelRequire("fWmos");
const $7467b6c089b3897b$export$3ff26c80cb588e12 = {
    taskList: (0, $5gtk6.TASK_LIST),
    taskVariants: (0, $5gtk6.TASK_VARIANTS),
    userRole: (0, $fWmos.UserRole),
    experiments: (0, $eFRe9.Experiments)
};

});
parcelRegister("5gtk6", function(module, exports) {
$parcel$export(module.exports, "TASK_LIST", () => $2beaab971a6492fd$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "OPS_TAILORED_ONBOARDING_TASK_VARIANTS", () => $2beaab971a6492fd$export$db06b8e338ba9c65);
$parcel$export(module.exports, "MKT_TAILORED_ONBOARDING_TASK_VARIANTS", () => $2beaab971a6492fd$export$bda7075f98246874);
$parcel$export(module.exports, "TASK_VARIANTS", () => $2beaab971a6492fd$export$36f4d47dfe11b613);
/* eslint-disable jira/filename-case */ 
var $7eNDO = parcelRequire("7eNDO");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");

var $eFRe9 = parcelRequire("eFRe9");

var $fWmos = parcelRequire("fWmos");
const $2beaab971a6492fd$var$rootTitle = (0, $7eNDO.defineMessage)({
    id: "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
    defaultMessage: "Quickstart"
});
const $2beaab971a6492fd$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: $2beaab971a6492fd$var$rootTitle,
        items: [
            (0, $5ZtCQ.JWM_CREATE_PROJECT_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $5ZtCQ.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)
        ]
    }
});
const $2beaab971a6492fd$export$db06b8e338ba9c65 = {
    [(0, $5ZtCQ.OPS_JTBD_3_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_3_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_3_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_4_LIST)]: {
        position: {
            default: 400
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_4_CALENDAR)]: {
        position: {
            default: 500
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_4_TIMELINE)]: {
        position: {
            default: 600
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_4_SUMMARY)]: {
        position: {
            default: 700
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_5_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_5_TIMELINE)]: {
        position: {
            default: 900
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_5_PAGES)]: {
        position: {
            default: 1000
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_7_LIST)]: {
        position: {
            default: 1100
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_7_CALENDAR)]: {
        position: {
            default: 1200
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_2_BOARD)]: {
        position: {
            default: 1300
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_2_FORMS)]: {
        position: {
            default: 1400
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_2_SUMMARY)]: {
        position: {
            default: 1500
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_1_LIST)]: {
        position: {
            default: 1600
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_6_PAGES)]: {
        position: {
            default: 1700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_0_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_0_TIMELINE)]: {
        position: {
            default: 1900
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_0_PAGES)]: {
        position: {
            default: 2000
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 2100
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 2200
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2300
        }
    }
};
const $2beaab971a6492fd$export$bda7075f98246874 = {
    [(0, $5ZtCQ.MKT_JTBD_1_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_1_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_1_TIMELINE)]: {
        position: {
            default: 300
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_2_CALENDAR)]: {
        position: {
            default: 400
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_2_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_3_PAGES)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_3_TIMELINE)]: {
        position: {
            default: 700
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_4_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_4_SUMMARY)]: {
        position: {
            default: 900
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_4_PAGES)]: {
        position: {
            default: 1000
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_5_TIMELINE)]: {
        position: {
            default: 1100
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_5_SUMMARY)]: {
        position: {
            default: 1200
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_6_FORMS)]: {
        position: {
            default: 1300
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_0_LIST)]: {
        position: {
            default: 1400
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_0_CALENDAR)]: {
        position: {
            default: 1500
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_0_TIMELINE)]: {
        position: {
            default: 1600
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_0_SUMMARY)]: {
        position: {
            default: 1700
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 1900
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_DEFAULT_PROJECT)]: {
        position: {
            default: 2000
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2100
        }
    }
};
const $2beaab971a6492fd$export$36f4d47dfe11b613 = {
    ...$2beaab971a6492fd$export$db06b8e338ba9c65,
    ...$2beaab971a6492fd$export$bda7075f98246874,
    [(0, $5ZtCQ.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).isNotSampleProject,
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).isNotSampleProject,
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).isNotSampleProject,
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).isNotSampleProject,
                        (0, $eFRe9.Experiments).trelloCrossflow,
                        (0, $fWmos.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("dvbnR", function(module, exports) {
$parcel$export(module.exports, "TeamType", () => $885860f3e92ee151$export$26bc40b960693765);
$parcel$export(module.exports, "Feature", () => $885860f3e92ee151$export$6e91cf7616333d5);
$parcel$export(module.exports, "FeatureGate", () => $885860f3e92ee151$export$d4ba9a3e7000cca8);
$parcel$export(module.exports, "Permissions", () => $885860f3e92ee151$export$2d41982586bbb6be);
$parcel$export(module.exports, "Experience", () => $885860f3e92ee151$export$c90b54e658fc4d7c);
/* eslint-disable jira/filename-case */ 
const $885860f3e92ee151$export$26bc40b960693765 = {
    productManagement: `teamType.${(0, $99cb2e6a234d7a1f$export$4f54a09a24fd1d74)}`,
    projectManagement: `teamType.${(0, $99cb2e6a234d7a1f$export$79685802e8ff1098)}`,
    design: `teamType.${(0, $99cb2e6a234d7a1f$export$e5c438b7501b5a24)}`,
    itSupport: `teamType.${(0, $99cb2e6a234d7a1f$export$d7de553940261eba)}`,
    otherPersonal: `teamType.${(0, $99cb2e6a234d7a1f$export$cbc0e551d91a692d)}`,
    marketing: `teamType.${(0, $99cb2e6a234d7a1f$export$e4824f74b9879164)}`,
    operations: `teamType.${(0, $99cb2e6a234d7a1f$export$4f3cb0844009af52)}`,
    software: `teamType.${(0, $99cb2e6a234d7a1f$export$b8b1ac856ba1434b)}`,
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'teamType.everythingElse'
};
const $885860f3e92ee151$export$6e91cf7616333d5 = {
    hasBacklog: 'feature.hasBacklog',
    hasSprint: 'feature.hasSprint',
    hasSummaryPage: 'feature.hasSummaryPage',
    hasRoadmap: 'feature.hasRoadmap',
    hasList: 'feature.hasList',
    hasCalendar: 'feature.hasCalendar',
    hasCode: 'feature.hasCode',
    hasForms: 'feature.hasForms',
    hasPages: 'feature.hasPages',
    hasPlanDependencies: 'feature.hasPlanDependencies',
    hasPlanProgram: 'feature.hasPlanProgram',
    hasPlanReleases: 'feature.hasPlanReleases',
    hasPlanTeams: 'feature.hasPlanTeams'
};
const $885860f3e92ee151$export$d4ba9a3e7000cca8 = {
    removeInitialProjectTemplateName: 'to-cleanup-remove-initial-project-template-name'
};
const $885860f3e92ee151$export$2d41982586bbb6be = {
    canCreateIssue: 'permissions.canCreateIssue'
};
const $885860f3e92ee151$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    tailoredOnboardingScrumAndSoftwareKanbanEligible: 'experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible'
};
const $885860f3e92ee151$export$c90b54e658fc4d7c = {
    fedRamp: 'experience.fedRamp'
};

});

parcelRegister("eFRe9", function(module, exports) {
$parcel$export(module.exports, "Experiments", () => $f67fafb607dbc7c0$export$c8d6ffd15214553a);
/* eslint-disable jira/filename-case */ const $f67fafb607dbc7c0$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow'
};

});

parcelRegister("fWmos", function(module, exports) {
$parcel$export(module.exports, "UserRole", () => $17521fafdbc867e0$export$eb3485a690c2f0b8);
/* eslint-disable jira/filename-case */ const $17521fafdbc867e0$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("cBvJ0", function(module, exports) {
$parcel$export(module.exports, "PLAN", () => $bfac3d2456178e37$export$c303e491e026ebc6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i6G5g = parcelRequire("i6G5g");
const $bfac3d2456178e37$export$c303e491e026ebc6 = {
    taskList: (0, $i6G5g.PLAN_TASK_LIST),
    taskVariants: (0, $i6G5g.PLAN_TASK_VARIANTS)
};

});
parcelRegister("i6G5g", function(module, exports) {
$parcel$export(module.exports, "PLAN_TASK_LIST", () => $1ab7c646a72e5fed$export$6ddf1195a65583de);
$parcel$export(module.exports, "PLAN_TASK_VARIANTS", () => $1ab7c646a72e5fed$export$73c2f09f0994be4f);
/* eslint-disable jira/filename-case */ 
var $7eNDO = parcelRequire("7eNDO");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $1ab7c646a72e5fed$var$rootTitle = (0, $7eNDO.defineMessage)({
    id: "onboarding-quickstart-core.services.tasks.config.plan.root-title",
    defaultMessage: "Quickstart"
});
const $1ab7c646a72e5fed$export$6ddf1195a65583de = Object.freeze({
    root: {
        title: $1ab7c646a72e5fed$var$rootTitle,
        items: [
            (0, $5ZtCQ.PLAN_TEAM_CAPACITY_TASK),
            (0, $5ZtCQ.PLAN_PROGRAM_BOARD_TASK),
            (0, $5ZtCQ.PLAN_RELEASE_MANAGEMENT_TASK),
            (0, $5ZtCQ.PLAN_DEPENDENCY_TRACKING_TASK)
        ]
    }
});
const $1ab7c646a72e5fed$export$73c2f09f0994be4f = {
    [(0, $5ZtCQ.PLAN_TEAM_CAPACITY_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasPlanTeams
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.PLAN_PROGRAM_BOARD_TASK)]: {
        position: {
            default: 10
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasPlanProgram
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.PLAN_RELEASE_MANAGEMENT_TASK)]: {
        position: {
            default: 20
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasPlanReleases
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.PLAN_DEPENDENCY_TRACKING_TASK)]: {
        position: {
            default: 30
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasPlanDependencies
                    ],
                    value: true
                }
            ]
        }
    }
};

});


parcelRegister("er8Op", function(module, exports) {
$parcel$export(module.exports, "getTasks", () => $078ea27c308f9d74$export$20b82b4a32771893);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $akVgl = parcelRequire("akVgl");
const $078ea27c308f9d74$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $akVgl.getConditional)(visibility, variants) : true;
const $078ea27c308f9d74$var$getTaskPosition = (variants, position)=>(0, $akVgl.getConditional)(position, variants);
const $078ea27c308f9d74$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$078ea27c308f9d74$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$078ea27c308f9d74$var$getTaskPosition(variants, taskVariants[taskA].position) - $078ea27c308f9d74$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("akVgl", function(module, exports) {
$parcel$export(module.exports, "getConditional", () => $eb2f3313899aa233$export$fe3161cde0106bba);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $eb2f3313899aa233$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("dX7f5", function(module, exports) {
$parcel$export(module.exports, "isJwmProject", () => $9eb7081466bad82f$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $9eb7081466bad82f$export$a972ed853ed1d469);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");
const $9eb7081466bad82f$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $f99M0.CORE_PROJECT);
const $9eb7081466bad82f$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $f99M0.SERVICE_DESK_PROJECT);

});

parcelRegister("gehxg", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_WITH_SINGLE_CONFIG", () => $781ea1b3868534c8$export$83849aa73c0a20db);
$parcel$export(module.exports, "TAILORED_ONBOARDING_M2P5", () => $781ea1b3868534c8$export$eb17ad7838835d2a);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BUSINESS", () => $781ea1b3868534c8$export$fe6b8880a507b306);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 

var $7eNDO = parcelRequire("7eNDO");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $hsVn2 = parcelRequire("hsVn2");

var $9W3eX = parcelRequire("9W3eX");

var $eyABc = parcelRequire("eyABc");

var $cHxES = parcelRequire("cHxES");

var $foPEo = parcelRequire("foPEo");

var $aTf9A = parcelRequire("aTf9A");

var $cPgA9 = parcelRequire("cPgA9");

var $kF6m8 = parcelRequire("kF6m8");
const $781ea1b3868534c8$var$rootTitle = (0, $7eNDO.defineMessage)({
    id: "software-onboarding-quickstart.services.tasks.config.tailored-onboarding.root-title.no-translate",
    defaultMessage: "Quickstart"
});
const $781ea1b3868534c8$export$2757f7b23d120b9b = Object.freeze({
    root: {
        title: $781ea1b3868534c8$var$rootTitle,
        items: [
            (0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY),
            (0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR),
            (0, $5ZtCQ.TAILORED_ONBOARDING_LIST),
            (0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE),
            (0, $5ZtCQ.TAILORED_ONBOARDING_PAGES),
            (0, $5ZtCQ.TAILORED_ONBOARDING_FORM),
            (0, $5ZtCQ.TAILORED_ONBOARDING_INVITE),
            (0, $5ZtCQ.TAILORED_ONBOARDING_BOARD),
            (0, $5ZtCQ.TAILORED_ONBOARDING_BACKLOG),
            (0, $5ZtCQ.TAILORED_ONBOARDING_CODE)
        ]
    }
});
const $781ea1b3868534c8$export$83849aa73c0a20db = {
    taskList: $781ea1b3868534c8$export$2757f7b23d120b9b,
    taskVariants: (0, $kF6m8.TAILORED_ONBOARDING_SINGLE_CONFIG)
};
const $781ea1b3868534c8$export$fd94bb9b6d992528 = Object.freeze({
    root: {
        title: $781ea1b3868534c8$var$rootTitle,
        items: [
            (0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY),
            (0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR),
            (0, $5ZtCQ.TAILORED_ONBOARDING_LIST),
            (0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE),
            (0, $5ZtCQ.TAILORED_ONBOARDING_PAGES),
            (0, $5ZtCQ.TAILORED_ONBOARDING_FORM),
            (0, $5ZtCQ.TAILORED_ONBOARDING_INVITE),
            (0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $781ea1b3868534c8$export$3c409334669aec75 = (teamType)=>{
    switch(teamType){
        case 0, $99cb2e6a234d7a1f$export$4f54a09a24fd1d74:
            return 0, $9W3eX.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $99cb2e6a234d7a1f$export$79685802e8ff1098:
            return 0, $hsVn2.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $99cb2e6a234d7a1f$export$e5c438b7501b5a24:
            return 0, $eyABc.DESIGN_VARIANTS;
        case 0, $99cb2e6a234d7a1f$export$d7de553940261eba:
            return 0, $cHxES.IT_SUPPORT_VARIANTS;
        case 0, $99cb2e6a234d7a1f$export$cbc0e551d91a692d:
            return 0, $foPEo.OTHER_PERSONAL_VARIANTS;
        case 0, $99cb2e6a234d7a1f$export$b8b1ac856ba1434b:
            return 0, $cPgA9.SOFTWARE_VARIANTS;
        default:
            return 0, $aTf9A.EVERYTHING_ELSE_VARIANTS;
    }
};
const $781ea1b3868534c8$export$cb2285c4be67df48 = Object.freeze({
    root: {
        title: $781ea1b3868534c8$var$rootTitle,
        items: [
            // JWM Trello Crossflow Tasks
            (0, $5ZtCQ.JWM_CREATE_PROJECT_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $5ZtCQ.JWM_BUILD_FORM_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $5ZtCQ.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            // JSW Tailored Onboarding Tasks
            (0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY),
            (0, $5ZtCQ.TAILORED_ONBOARDING_LIST),
            (0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE),
            (0, $5ZtCQ.TAILORED_ONBOARDING_BOARD),
            (0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR),
            (0, $5ZtCQ.TAILORED_ONBOARDING_PAGES),
            (0, $5ZtCQ.TAILORED_ONBOARDING_FORM),
            (0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)
        ]
    }
});
const $781ea1b3868534c8$export$eb17ad7838835d2a = {
    taskList: $781ea1b3868534c8$export$fd94bb9b6d992528,
    getM2P5TaskVariants: $781ea1b3868534c8$export$3c409334669aec75
};
const $781ea1b3868534c8$export$fe6b8880a507b306 = {
    taskList: $781ea1b3868534c8$export$cb2285c4be67df48
};

});
parcelRegister("hsVn2", function(module, exports) {
$parcel$export(module.exports, "PROJECT_MANAGEMENT_VARIANTS", () => $56d54c062d4173ad$export$bdd338c80f8962df);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $56d54c062d4173ad$export$bdd338c80f8962df = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("9W3eX", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_MANAGEMENT_VARIANTS", () => $39f1fbf4259ebcca$export$b07ea6a2d29f9c08);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $39f1fbf4259ebcca$export$b07ea6a2d29f9c08 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("eyABc", function(module, exports) {
$parcel$export(module.exports, "DESIGN_VARIANTS", () => $a7a546fbc840a986$export$a3c4cd8e420f13a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $a7a546fbc840a986$export$a3c4cd8e420f13a = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("cHxES", function(module, exports) {
$parcel$export(module.exports, "IT_SUPPORT_VARIANTS", () => $8453a6ca22fbb130$export$a25e809b52945082);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $8453a6ca22fbb130$export$a25e809b52945082 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("foPEo", function(module, exports) {
$parcel$export(module.exports, "OTHER_PERSONAL_VARIANTS", () => $eb4ebd50ad83e801$export$916be3c140ae8c0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $eb4ebd50ad83e801$export$916be3c140ae8c0 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("aTf9A", function(module, exports) {
$parcel$export(module.exports, "EVERYTHING_ELSE_VARIANTS", () => $f40aa275376d9c93$export$7a0daeb069f34de3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $f40aa275376d9c93$export$7a0daeb069f34de3 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("cPgA9", function(module, exports) {
$parcel$export(module.exports, "SOFTWARE_VARIANTS", () => $609157f95a04c4bd$export$76a143792cc73994);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $609157f95a04c4bd$export$76a143792cc73994 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("kF6m8", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $bd1d4f54dcaf47e5$export$64855550cee11b78);
/* eslint-disable jira/filename-case */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $bd1d4f54dcaf47e5$export$64855550cee11b78 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasSummaryPage,
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasSummaryPage,
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasSummaryPage,
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasSummaryPage,
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Permissions).canCreateIssue
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasCode
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});


parcelRegister("jXUhc", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_BUSINESS_CONFIG", () => $c62fd069dca23e40$export$474323a35aa36586);
/* eslint-disable jira/filename-case */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");

var $eFRe9 = parcelRequire("eFRe9");

var $fWmos = parcelRequire("fWmos");

var $5gtk6 = parcelRequire("5gtk6");
const $c62fd069dca23e40$export$474323a35aa36586 = {
    ...(0, $5gtk6.OPS_TAILORED_ONBOARDING_TASK_VARIANTS),
    ...(0, $5gtk6.MKT_TAILORED_ONBOARDING_TASK_VARIANTS),
    // Trello Crossflow Cards - These take priority when trelloCrossflow experiment is active
    [(0, $5ZtCQ.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 10
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow,
                        (0, $fWmos.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    // Regular Tailored Onboarding Cards - These are hidden when trelloCrossflow is active
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});



parcelRegister("jJY2t", function(module, exports) {
$parcel$export(module.exports, "syncVisibilityWithLocal", () => $6da4c253db4092e5$export$4aab9a98fc53b894);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1n5q3 = parcelRequire("1n5q3");

var $1DyW0 = parcelRequire("1DyW0");
const $6da4c253db4092e5$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        const visibilityLocal = (0, $1DyW0.getLocalStorageItem)(`${quickstartType}.visibility`);
        if (visibilityLocal === state.visibility[quickstartType]) return;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: visibilityLocal
            }
        });
    };

});

parcelRegister("bNXf6", function(module, exports) {
$parcel$export(module.exports, "universalDispatch", () => $e4798fb7ab0be54b$export$efe980271ca9cc08);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e4798fb7ab0be54b$export$efe980271ca9cc08 = ({ fn: fn })=>({ dispatch: dispatch })=>{
        dispatch(fn());
    };

});

parcelRegister("2D5ku", function(module, exports) {
$parcel$export(module.exports, "setContainerType", () => $11a6776765b237a2$export$24889c6c4e904da4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $11a6776765b237a2$export$24889c6c4e904da4 = (containerType)=>({ getState: getState, setState: setState })=>{
        const { containerType: currentContainerType } = getState();
        if (containerType === currentContainerType) // if state has not been updated we just return
        return;
        setState({
            containerType: containerType
        });
    };
var $11a6776765b237a2$export$2e2bcd8739ae039 = $11a6776765b237a2$export$24889c6c4e904da4;

});

parcelRegister("adLxs", function(module, exports) {
$parcel$export(module.exports, "setQuickstartButtonRef", () => $9773b9b971c00e4a$export$8119a14b79738a24);
$parcel$export(module.exports, "setIsOpenedViaButton", () => $9773b9b971c00e4a$export$8b7fa399fb8c07f);
$parcel$export(module.exports, "focusQuickstartButton", () => $9773b9b971c00e4a$export$8f1aa3f8d2941465);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $9773b9b971c00e4a$export$8119a14b79738a24 = (quickstartButtonRef)=>({ setState: setState })=>{
        setState({
            quickstartButtonRef: quickstartButtonRef
        });
    };
const $9773b9b971c00e4a$export$8b7fa399fb8c07f = (isOpenedViaButton)=>({ setState: setState })=>{
        setState({
            isOpenedViaButton: isOpenedViaButton
        });
    };
// Since the button is visible after 220ms and requestAnimationFrame is called 60 times per second,
// to be safe we can wait for 15 frames (220/1000 * 60)
const $9773b9b971c00e4a$var$MAX_FOCUS_RETRIES = 15;
const $9773b9b971c00e4a$export$8f1aa3f8d2941465 = ()=>({ setState: setState, getState: getState })=>{
        let retryCount = 0;
        const tryFocus = ()=>{
            const { quickstartButtonRef: quickstartButtonRef, isOpenedViaButton: isOpenedViaButton } = getState();
            if (quickstartButtonRef && isOpenedViaButton) {
                quickstartButtonRef.focus({
                    preventScroll: true
                });
                setState({
                    isOpenedViaButton: false
                });
            } else if (!quickstartButtonRef && retryCount < $9773b9b971c00e4a$var$MAX_FOCUS_RETRIES) {
                // If ref not available yet due to button animation delay, try again
                retryCount++;
                requestAnimationFrame(tryFocus);
            }
        };
        // Uses requestAnimationFrame to wait until the ref is available
        requestAnimationFrame(tryFocus);
    };

});


parcelRegister("ia7JZ", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $d4bfa53efccc0000$export$d4c72bab9d6cc13a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");
const $d4bfa53efccc0000$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $5ZtCQ.ROOT_TASK),
    currentTriggerForTaskGroupParent: '',
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $5ZtCQ.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $5ZtCQ.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $5ZtCQ.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $5ZtCQ.QUICKSTART_UI_STATUS).NOT_LOADED
    },
    quickstartButtonRef: null,
    isOpenedViaButton: false
};

});


const $2d67c2e6ae8f10e6$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $2d67c2e6ae8f10e6$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $2d67c2e6ae8f10e6$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $2d67c2e6ae8f10e6$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $2d67c2e6ae8f10e6$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $2d67c2e6ae8f10e6$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $2d67c2e6ae8f10e6$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $2d67c2e6ae8f10e6$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $2d67c2e6ae8f10e6$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $2d67c2e6ae8f10e6$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $2d67c2e6ae8f10e6$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $2d67c2e6ae8f10e6$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $2d67c2e6ae8f10e6$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $2d67c2e6ae8f10e6$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $2d67c2e6ae8f10e6$export$f8bf435a6066832c = 'button clicked';
const $2d67c2e6ae8f10e6$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $2d67c2e6ae8f10e6$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $2d67c2e6ae8f10e6$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $2d67c2e6ae8f10e6$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $2d67c2e6ae8f10e6$export$5908fa8acd2c0739 = 'filterListNudge';
const $2d67c2e6ae8f10e6$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $2d67c2e6ae8f10e6$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $2d67c2e6ae8f10e6$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $2d67c2e6ae8f10e6$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $2d67c2e6ae8f10e6$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $2d67c2e6ae8f10e6$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $2d67c2e6ae8f10e6$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $2d67c2e6ae8f10e6$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $2d67c2e6ae8f10e6$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $2d67c2e6ae8f10e6$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $2d67c2e6ae8f10e6$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $2d67c2e6ae8f10e6$export$29fe6611cc093756 = 'summaryTabNudge';
const $2d67c2e6ae8f10e6$export$f107c06c0830f09d = 'reportsTabNudge';
const $2d67c2e6ae8f10e6$export$9749a972a54ad7ba = 'boardContainerNudge';
const $2d67c2e6ae8f10e6$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $2d67c2e6ae8f10e6$export$b7fd448c62b5fb97 = 'listview';
const $2d67c2e6ae8f10e6$export$10c63dc5c09466d2 = 'boardview';
const $2d67c2e6ae8f10e6$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $2d67c2e6ae8f10e6$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';

parcelRegister("3yseG", function(module, exports) {
$parcel$export(module.exports, "inviteTeamNudgeEntryPoint", () => $f8ea90a01ffdf843$export$ff76bc343b4103b1);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $f8ea90a01ffdf843$export$ff76bc343b4103b1 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("3HkUp")), {
        moduleId: "aca9b293",
        moduleName: "InviteTeamNudge",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3HkUp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("KyJtD").then(()=>parcelRequire('2YgHC'));

});



parcelRegister("5tPwf", function(module, exports) {
$parcel$export(module.exports, "useCreateTeamModal", () => $8e24c0d1c3dfeb00$export$5458b68a653f4bfe);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $kFgCO = parcelRequire("kFgCO");

var $6zTYs = parcelRequire("6zTYs");

var $3LhWS = parcelRequire("3LhWS");

var $eVacJ = parcelRequire("eVacJ");

var $iQPOZ = parcelRequire("iQPOZ");

var $fw5T5 = parcelRequire("fw5T5");

var $e35Ix = parcelRequire("e35Ix");

var $j5bEH = parcelRequire("j5bEH");

var $1YIbA = parcelRequire("1YIbA");

var $a8EUd = parcelRequire("a8EUd");

var $3GN2r = parcelRequire("3GN2r");

var $kt86l = parcelRequire("kt86l");

var $gYZoW = parcelRequire("gYZoW");

var $l8G1z = parcelRequire("l8G1z");

var $1PaAU = parcelRequire("1PaAU");

// Relay entry point is not applicable here because this component does not live in jira frontend.
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8e24c0d1c3dfeb00$var$LazyTeamCreateDialog = (0, $l8G1z.lazy)(()=>(parcelRequire("M2KQ6")).then(({ TeamCreateDialog: TeamCreateDialog })=>TeamCreateDialog), {
    moduleId: "../platform/packages/people-and-teams/people-teams/src/index.ts"
});
const $8e24c0d1c3dfeb00$export$5458b68a653f4bfe = ()=>{
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const { locale: locale } = (0, $1YIbA.default)();
    const { showFlag: showFlag } = (0, $iQPOZ.useFlagsService)();
    const cloudId = (0, $kt86l.useCloudId)();
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    const { data: { user: user } } = (0, $kFgCO.useCurrentUser)();
    const atlassianAccountId = (0, $3GN2r.useAccountId)() || user.accountId;
    const navigateTo = (0, $euxye.useCallback)((url)=>{
        (0, $1PaAU.openInNewTab)((0, $3LhWS.toTeamsAppURL)(url.replace('/jira', '')));
    }, []);
    const addFlag = (0, $euxye.useCallback)(({ appearance: appearance, ...flagProps })=>{
        const Flag = $8e24c0d1c3dfeb00$var$getFlagComponent(appearance);
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Flag, {
                ...flagProps,
                ...serviceProps,
                messageId: `navigation-apps-sidebar-nav4-sidebars-content-teams.ui.use-create-team-modal.flag.showFlag.${appearance}.${flagProps.id}`,
                messageType: "engagement"
            }));
    }, [
        showFlag
    ]);
    const callback = (0, $euxye.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    if (!atlassianAccountId) throw new Error('Missing current user id');
    return [
        isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
            key: "team-create-dialog",
            name: "team-create-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gYZoW.PeopleAndTeamsConfigurationProvider), {
            product: "jira",
            locale: (0, $eVacJ.default)(locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8e24c0d1c3dfeb00$var$LazyTeamCreateDialog, {
            pushRoute: navigateTo,
            cloudId: cloudId,
            orgId: orgId,
            product: "jira",
            onClose: ()=>setIsOpen(false),
            enableMembershipSettingsChoice: true,
            enableTeamPermissionCheck: true,
            currentUser: user.accountId ? {
                id: user.accountId,
                fullName: user.userFullname,
                // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                email: user.emailAddress !== undefined ? user.emailAddress : '',
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
                nickname: user.userFullname
            } : undefined,
            addFlag: addFlag
        }))) : null,
        callback
    ];
};
const $8e24c0d1c3dfeb00$var$getFlagComponent = (appearance)=>{
    switch(appearance){
        case 'warning':
            return 0, $j5bEH.default;
        case 'error':
            return 0, $fw5T5.default;
        case 'success':
        case 'normal':
        default:
            return 0, $e35Ix.default;
    }
};

});
parcelRegister("1PaAU", function(module, exports) {
$parcel$export(module.exports, "openInNewTab", () => $1b79c168935f7bb8$export$9e52b10d57ddf9e3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $1b79c168935f7bb8$export$9e52b10d57ddf9e3 = (url)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.open(url, '_blank');
};

});


parcelRegister("rKVUU", function(module, exports) {
$parcel$export(module.exports, "useInvitePeopleModal", () => $e87350e4ee3077be$export$b9ec44715ae5ad99);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $e4f4V = parcelRequire("e4f4V");

var $jyU6p = parcelRequire("jyU6p");

var $8ANUF = parcelRequire("8ANUF");

var $6zTYs = parcelRequire("6zTYs");

var $kFgCO = parcelRequire("kFgCO");

var $iQPOZ = parcelRequire("iQPOZ");

var $fw5T5 = parcelRequire("fw5T5");

var $e35Ix = parcelRequire("e35Ix");

var $j5bEH = parcelRequire("j5bEH");

var $ccEzE = parcelRequire("ccEzE");

var $i860n = parcelRequire("i860n");
const $e87350e4ee3077be$export$b9ec44715ae5ad99 = (touchpoint)=>{
    const { showFlag: showFlag } = (0, $iQPOZ.useFlagsService)();
    const { data: projectSidebarNavigationData } = (0, $8ANUF.useProjectSidebarNavigation)();
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    const { software: software } = (0, $ccEzE.useAppEditions)();
    const { data: currentUser } = (0, $kFgCO.useCurrentUser)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let continueUrl = window.location.href;
    if (currentUser?.user?.accountId) {
        const url = new URL(continueUrl);
        url.searchParams.append('inviterId', currentUser.user.accountId);
        continueUrl = url.toString();
    }
    const subProduct = (0, $jyU6p.projectTypeToSubProduct)(projectSidebarNavigationData?.projectType);
    const gatedTouchpoint = (0, $i860n.fg)('groot-905-spaces-touchpoint-prop') ? touchpoint : undefined;
    const addFlag = (0, $euxye.useCallback)(({ appearance: appearance, ...flagProps })=>{
        const Flag = $e87350e4ee3077be$var$getFlagComponent(appearance);
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Flag, {
                ...flagProps,
                ...serviceProps,
                messageId: `navigation-apps-sidebar-nav4-sidebars-content-teams.ui.flag.showFlag.${appearance}.${flagProps.id}`,
                messageType: "transactional"
            }));
    }, [
        showFlag
    ]);
    const hookProps = (0, $euxye.useMemo)(()=>({
            continueUrl: continueUrl,
            enableThirdParty: true,
            displayInfiSpotlight: true,
            orgId: orgId,
            showFlag: addFlag,
            source: 'peopleMenu',
            subProduct: subProduct,
            applicationEdition: software,
            navigation: {
                directoryContextEntryPoint: '/jira'
            },
            touchpoint: gatedTouchpoint
        }), [
        continueUrl,
        orgId,
        addFlag,
        subProduct,
        software,
        gatedTouchpoint
    ]);
    const { openModal: invitePeopleModalTrigger } = (0, $e4f4V.useJiraInvitePeopleModalBound)(hookProps);
    return invitePeopleModalTrigger;
};
const $e87350e4ee3077be$var$getFlagComponent = (appearance)=>{
    switch(appearance){
        case 'warning':
            return 0, $j5bEH.default;
        case 'error':
            return 0, $fw5T5.default;
        case 'success':
        case 'normal':
        default:
            return 0, $e35Ix.default;
    }
};

});
parcelRegister("jyU6p", function(module, exports) {
$parcel$export(module.exports, "stripUrlToIssueKey", () => $f395f461a04324a7$export$1f3c6284caef177b);
$parcel$export(module.exports, "useInvitePeopleFlags", () => $f395f461a04324a7$export$ab5fb7206b83c9ad);
$parcel$export(module.exports, "projectTypeToSubProduct", () => $f395f461a04324a7$export$3500077858760067);
$parcel$export(module.exports, "jiraProjectTypeToSubProduct", () => $f395f461a04324a7$export$9ce9c3ad0c2c5c71);

var $euxye = parcelRequire("euxye");

var $iQPOZ = parcelRequire("iQPOZ");

var $fw5T5 = parcelRequire("fw5T5");

var $htweD = parcelRequire("htweD");

var $e35Ix = parcelRequire("e35Ix");

var $j5bEH = parcelRequire("j5bEH");
const $f395f461a04324a7$var$ISSUE_KEY_REGEXP = /(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
const $f395f461a04324a7$export$1f3c6284caef177b = (candidateUrl)=>{
    const match = candidateUrl.match($f395f461a04324a7$var$ISSUE_KEY_REGEXP);
    return match && match[1];
};
const $f395f461a04324a7$export$ab5fb7206b83c9ad = ()=>{
    const { showFlag: showFlag } = (0, $iQPOZ.useFlagsService)();
    const addFlag = (0, $euxye.useCallback)(({ appearance: appearance, ...flagProps })=>{
        let FlagComponent = (0, $htweD.default);
        // oxlint-disable-next-line default-case
        switch(appearance){
            case 'success':
            case 'normal':
                FlagComponent = (0, $e35Ix.default);
                break;
            case 'warning':
                FlagComponent = (0, $j5bEH.default);
                break;
            case 'error':
                FlagComponent = (0, $fw5T5.default);
                break;
        }
        showFlag((serviceProps)=>{
            const props = {
                ...flagProps,
                ...serviceProps,
                messageId: `invite-people-drawer.ui.content.flag-component.${appearance}.${flagProps.id}`,
                messageType: 'transactional'
            };
            // remove-when-ts7
            // oxlint-disable-next-line typescript/ban-ts-comment
            // @ts-ignore - tsgo no longer raises the underlying error here; tsc5 may still need this suppression
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(FlagComponent, props);
        });
    }, [
        showFlag
    ]);
    return {
        addFlag: addFlag
    };
};
const $f395f461a04324a7$export$3500077858760067 = (projectType)=>{
    switch(projectType){
        case 'jira_software':
            return 'software';
        case 'jira_service_management':
            return 'servicedesk';
        case 'jira_work_management':
            return 'core';
        case 'jira_product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};
const $f395f461a04324a7$export$9ce9c3ad0c2c5c71 = (projectType)=>{
    switch(projectType){
        case 'software':
            return 'software';
        case 'service_desk':
            return 'servicedesk';
        case 'business':
            return 'core';
        case 'product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};

});
parcelRegister("htweD", function(module, exports) {
$parcel$export(module.exports, "default", () => $343d77018726a3b4$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3mYdc = parcelRequire("3mYdc");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$343d77018726a3b4$export$2e2bcd8739ae039 = (0, $3mYdc.InfoFlag);

});



parcelRegister("jMVYt", function(module, exports) {
$parcel$export(module.exports, "useTeams", () => $f8fd0e5bd938770b$export$6fe02dcc2001dcb0);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $eprc4 = parcelRequire("eprc4");

var $dpcSS = parcelRequire("dpcSS");

var $6MOeo = parcelRequire("6MOeo");

var $eE9LA = parcelRequire("eE9LA");
const $f8fd0e5bd938770b$var$icon = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.TeamsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $f8fd0e5bd938770b$export$6fe02dcc2001dcb0 = (fallbackUrl, options = {})=>(0, $6MOeo.useAppGlobalShortcutLinkItem)($f8fd0e5bd938770b$var$icon, (0, $eE9LA.messages).label, fallbackUrl, {
        apsKey: (0, $dpcSS.Products).ATLAS_TEAMS,
        analyticsName: (0, $dpcSS.Products).ATLAS_TEAMS,
        ...options
    });

});
parcelRegister("6MOeo", function(module, exports) {
$parcel$export(module.exports, "useAppGlobalShortcutLinkItem", () => $6515e32815b7be90$export$7613f0bd7ffe380c);

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");
function $6515e32815b7be90$export$7613f0bd7ffe380c(icon, label, fallbackUrl, options) {
    const { labelElem: labelElem, apsKey: apsKey, ref: ref, analyticsName: analyticsName, menuItemId: menuItemId } = options ?? {};
    // Resolve the `MessageDescriptor` label up-front against the
    // `IntlProvider` in scope. The hook is called during render, so the
    // result tracks the active locale and re-resolves on locale change.
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const labelText = formatMessage(label);
    return (0, $euxye.useMemo)(()=>({
            type: 'link',
            icon: icon,
            label: labelText,
            labelElem: labelElem,
            apsKey: apsKey,
            fallbackUrl: fallbackUrl,
            ref: ref,
            analyticsName: analyticsName,
            ...menuItemId ? {
                menuItemId: menuItemId
            } : {}
        }), // Intentionally remove the ref, as it isn't needed by useMemo, and can cause extra rendering.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        analyticsName,
        apsKey,
        fallbackUrl,
        icon,
        labelElem,
        labelText,
        menuItemId
    ]);
}

});

parcelRegister("eE9LA", function(module, exports) {
$parcel$export(module.exports, "messages", () => $845659e81e671483$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $845659e81e671483$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.teams',
        defaultMessage: 'Teams',
        description: 'The text is shown as a navigation link label in the global shortcuts menu when the user opens the shortcut menu. This link navigates the user to the Teams application.'
    }
});

});



parcelRegister("4VlOC", function(module, exports) {
$parcel$export(module.exports, "useLicenseFilterMap", () => $6f7376af7403a748$export$bb19044ea3485639);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $kTARF = parcelRequire("kTARF");

var $6GljB = parcelRequire("6GljB");

var $af94c = parcelRequire("af94c");

var $curUp = parcelRequire("curUp");

var $aieBA = parcelRequire("aieBA");

var $chlmx = parcelRequire("chlmx");

var $br3o6 = parcelRequire("br3o6");

var $dO1Ns = parcelRequire("dO1Ns");

var $frNbj = parcelRequire("frNbj");

var $VKXQG = parcelRequire("VKXQG");

var $bF065 = parcelRequire("bF065");

var $2HuOR = parcelRequire("2HuOR");

var $eaLDc = parcelRequire("eaLDc");

var $c4Kh9 = parcelRequire("c4Kh9");
const $6f7376af7403a748$export$bb19044ea3485639 = (teamsAppConfig)=>{
    const $ = (0, $e7boj.c)(16);
    const licenceStates = (0, $eaLDc.useLicenseStates)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $2HuOR.getLicensedProducts)();
        $[0] = t0;
    } else t0 = $[0];
    const products = t0;
    const hasConfluence = !!products[(0, $2HuOR.LICENSED_PRODUCTS).CONFLUENCE];
    const hasLoom = !!products[(0, $2HuOR.LICENSED_PRODUCTS).LOOM];
    const hasProject = !!products[(0, $2HuOR.LICENSED_PRODUCTS).PROJECT] || !!products[(0, $2HuOR.LICENSED_PRODUCTS).TOWNSQUARE];
    const hasGoal = !!products[(0, $2HuOR.LICENSED_PRODUCTS).GOAL] || !!products[(0, $2HuOR.LICENSED_PRODUCTS).TOWNSQUARE];
    const USER_NAVIGATION_ITEM_LINKS = (0, $af94c.getUserNavigationItemLinks)();
    const { isVisible: showAssets, isJsmFreeSiteAdminUpsell: isJsmFreeSiteAdminUpsell, toResolvedAbsoluteUrl: toResolvedAbsoluteUrl } = (0, $aieBA.useAssetsSidebarState)();
    const teamsSupported = !!teamsAppConfig;
    let t1;
    if ($[1] !== licenceStates || $[2] !== showAssets || $[3] !== teamsSupported) {
        t1 = (0, $c4Kh9.getRenderableShortcutMenuIds)({
            licenceStates: licenceStates,
            hasConfluence: hasConfluence,
            hasLoom: hasLoom,
            hasGoal: hasGoal,
            hasProject: hasProject,
            teamsSupported: teamsSupported,
            showAssets: showAssets
        });
        $[1] = licenceStates;
        $[2] = showAssets;
        $[3] = teamsSupported;
        $[4] = t1;
    } else t1 = $[4];
    const renderableMenuIds = t1;
    const resolvedAssetsUrl = toResolvedAbsoluteUrl(USER_NAVIGATION_ITEM_LINKS[(0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS]);
    const confluenceItem = (0, $br3o6.useConfluence)(USER_NAVIGATION_ITEM_LINKS[(0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]);
    const loomItem = (0, $dO1Ns.useLoom)(USER_NAVIGATION_ITEM_LINKS[(0, $6GljB.L1_MENU_ID).GLOBAL_APP_LOOM]);
    const assetsItem = (0, $chlmx.useAssets)(resolvedAssetsUrl);
    const opsgenieItem = (0, $VKXQG.useOpsgenie)(USER_NAVIGATION_ITEM_LINKS[(0, $6GljB.L1_MENU_ID).GLOBAL_APP_OPSGENIE]);
    const goalsItem = (0, $frNbj.useGoals)(USER_NAVIGATION_ITEM_LINKS[(0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS]);
    const projectsItem = (0, $bF065.useProjects)(USER_NAVIGATION_ITEM_LINKS[(0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS]);
    let t2;
    if ($[5] !== assetsItem || $[6] !== confluenceItem || $[7] !== goalsItem || $[8] !== isJsmFreeSiteAdminUpsell || $[9] !== loomItem || $[10] !== opsgenieItem || $[11] !== projectsItem || $[12] !== renderableMenuIds || $[13] !== showAssets || $[14] !== teamsAppConfig) {
        let assetsItemWithComponent;
        if (isJsmFreeSiteAdminUpsell) assetsItemWithComponent = {
            ...assetsItem,
            type: "component",
            component: $6f7376af7403a748$var$AssetsFreeUsersPlacement
        };
        else if (showAssets) assetsItemWithComponent = {
            ...assetsItem,
            type: "component",
            component: $6f7376af7403a748$var$AssetsComponent
        };
        else assetsItemWithComponent = {
            ...assetsItem,
            component: $6f7376af7403a748$var$AssetsComponent
        };
        const allItems = {
            [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: confluenceItem,
            [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_LOOM]: loomItem,
            [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS]: assetsItemWithComponent,
            [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: opsgenieItem,
            [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS]: goalsItem,
            [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS]: projectsItem,
            ...teamsAppConfig ? {
                [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
            } : {}
        };
        t2 = renderableMenuIds.reduce((acc, menuId)=>{
            if (allItems[menuId]) acc[menuId] = allItems[menuId];
            return acc;
        }, {});
        $[5] = assetsItem;
        $[6] = confluenceItem;
        $[7] = goalsItem;
        $[8] = isJsmFreeSiteAdminUpsell;
        $[9] = loomItem;
        $[10] = opsgenieItem;
        $[11] = projectsItem;
        $[12] = renderableMenuIds;
        $[13] = showAssets;
        $[14] = teamsAppConfig;
        $[15] = t2;
    } else t2 = $[15];
    return t2;
};
const $6f7376af7403a748$var$AssetsComponent = ()=>{
    const $ = (0, $e7boj.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $curUp.GlobalAppShortcuts), {
            menuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
$6f7376af7403a748$var$AssetsComponent.displayName = "AssetsComponent";
const $6f7376af7403a748$var$AssetsFreeUsersPlacement = ()=>{
    const $ = (0, $e7boj.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kTARF.AssetsMenuItemFreeUsersPlacement), null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
$6f7376af7403a748$var$AssetsFreeUsersPlacement.displayName = "AssetsFreeUsersPlacement";

});
parcelRegister("kTARF", function(module, exports) {
$parcel$export(module.exports, "AssetsMenuItemFreeUsersPlacement", () => $8aa4da5c8569f05c$export$fa684aae444e578e);

var $euxye = parcelRequire("euxye");

var $jkQd9 = parcelRequire("jkQd9");

var $h8QGu = parcelRequire("h8QGu");

var $35eqr = parcelRequire("35eqr");

var $bxVe8 = parcelRequire("bxVe8");

var $cr9yX = parcelRequire("cr9yX");

var $gDdYI = parcelRequire("gDdYI");
const $8aa4da5c8569f05c$export$fa684aae444e578e = /*#__PURE__*/ (0, $euxye.memo)(()=>{
    const [preloadedInitialData] = (0, $cr9yX.usePlacementPreloadedData)((0, $35eqr.postOfficeAssetsMenuItemFreeUsersPlacementResource));
    const memoizedPlacementProps = (0, $euxye.useMemo)(()=>({
            // oxlint-disable-next-line typescript/consistent-type-assertions
            preloadedInitialData: preloadedInitialData
        }), [
        preloadedInitialData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "assets-menu-item-free-users-placement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "assetsMenuItemFreeUsersPlacement",
        teamName: "Sequoia",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bxVe8.PlacementFetchProvider), {
        resource: (0, $35eqr.postOfficeAssetsMenuItemFreeUsersPlacementResource)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jkQd9.Placement), {
        preloadedInitialData: memoizedPlacementProps.preloadedInitialData
    }))));
});

});
parcelRegister("jkQd9", function(module, exports) {
$parcel$export(module.exports, "Placement", () => $a2767bd4057550c4$export$af2bcbdc04a2d456);
// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

var $isJTY = parcelRequire("isJTY");

var $6TLxh = parcelRequire("6TLxh");

var $eJt2x = parcelRequire("eJt2x");
const $a2767bd4057550c4$var$messageFrontends = [
    (0, $6TLxh.MessageFrontend)({
        messageTemplateId: 'jsm-assets-premium-trial-item'
    })
];
const $a2767bd4057550c4$export$7b621692a0aa2333 = (0, $isJTY.PlacementFrontend).createPlacementFrontendComponent({
    messageTemplates: $a2767bd4057550c4$var$messageFrontends
});
const $a2767bd4057550c4$export$af2bcbdc04a2d456 = (0, $eJt2x.withI18n)($a2767bd4057550c4$export$7b621692a0aa2333);
const $a2767bd4057550c4$export$7d3d92a960f07a28 = $a2767bd4057550c4$export$7b621692a0aa2333;

});
parcelRegister("isJTY", function(module, exports) {
$parcel$export(module.exports, "PlacementBackend", () => $dff723b5f3cac3c2$export$d90b37843c84d1c3);
$parcel$export(module.exports, "PlacementFrontend", () => $dff723b5f3cac3c2$export$55486c2b6964dcf2);

var $e79Pd = parcelRequire("e79Pd");

var $2vhMr = parcelRequire("2vhMr");

var $8VhoU = parcelRequire("8VhoU");

var $euxye = parcelRequire("euxye");
const $dff723b5f3cac3c2$var$placement = (0, $2vhMr.createPlacement)({
    placementId: 'jira-navbar-assets-app-section',
    options: {
        choreographer: {
            isDefaultEnabled: false
        }
    }
});
const $dff723b5f3cac3c2$export$81df3aa6753d44e2 = $dff723b5f3cac3c2$var$placement.createFrontend;
const $dff723b5f3cac3c2$export$da912f58cb37a643 = $dff723b5f3cac3c2$var$placement.createBackend;
const $dff723b5f3cac3c2$export$d90b37843c84d1c3 = $dff723b5f3cac3c2$export$da912f58cb37a643({});
const $dff723b5f3cac3c2$export$55486c2b6964dcf2 = $dff723b5f3cac3c2$export$81df3aa6753d44e2((Messages)=>({ onMessageCountChange: onMessageCountChange, preloadedInitialData: preloadedInitialData, onItemClick: onItemClick, onItemViewed: onItemViewed })=>{
        const [{ messages: messages, status: status }, setMessagesState] = (0, $euxye.useState)(()=>{
            if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? {
                status: 'done',
                messages: preloadedInitialData?.messages
            } : {
                messages: undefined,
                status: 'done'
            };
            return {
                messages: undefined,
                status: 'loading'
            };
        });
        const isDone = status === 'done';
        const { data: data, error: error, isLoading: isLoading } = (0, $8VhoU.usePlacementApi)('/', {
            autoRefetch: {
                isEnabled: !isDone,
                updateKey: 'jira-navbar-assets-app-section'
            }
        });
        (0, $euxye.useEffect)(()=>{
            if (typeof messages === 'undefined') return;
            if (!onMessageCountChange) return;
            onMessageCountChange(messages.length);
        }, [
            messages,
            onMessageCountChange
        ]);
        const handleDismiss = (0, $euxye.useCallback)((messageInstanceId)=>{
            setMessagesState(()=>{
                if (!messages) return {
                    messages: undefined,
                    status: 'done'
                };
                const filteredMessages = messages.filter((message)=>messageInstanceId !== message.messageInstanceId);
                return {
                    messages: filteredMessages,
                    status: 'done'
                };
            });
        }, [
            messages
        ]);
        (0, $euxye.useEffect)(()=>{
            if (!isLoading && !isDone) setMessagesState({
                messages: data?.messages,
                status: 'done'
            });
        }, [
            isLoading,
            isDone,
            data
        ]);
        if (error) return null;
        if (status === 'loading') return null;
        return Array.isArray(messages) && messages.length > 0 ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
            children: messages?.map((props, index)=>/*#__PURE__*/ (0, $e79Pd.jsx)(Messages.render, {
                    dismiss: ()=>handleDismiss(props.messageInstanceId),
                    onItemClick: onItemClick,
                    onItemViewed: onItemViewed,
                    ...props
                }, `${props.messageInstanceId}-${index}`))
        }) : null;
    });

});

parcelRegister("6TLxh", function(module, exports) {
$parcel$export(module.exports, "MessageFrontend", () => $bdb26c538ef0567d$export$fa9bb46961aca2cc);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("44Zv4");
var $8hQRz = parcelRequire("8hQRz");
var $8hQRz = parcelRequire("8hQRz");

var $isJTY = parcelRequire("isJTY");

var $arRDM = parcelRequire("arRDM");
const $bdb26c538ef0567d$export$e7843a8f64a8d87c = (0, $isJTY.PlacementBackend).createMessageBackend((0, $8hQRz.defaultMessageBackend));
const $bdb26c538ef0567d$export$fa9bb46961aca2cc = (0, $isJTY.PlacementFrontend).createMessageFrontend({
    render: {
        validate: (0, $8hQRz.noValidation)(),
        Component: ({ dismiss: dismiss, onItemClick: onItemClick, onItemViewed: onItemViewed })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $arRDM.AssetsPremiumTrialItem), {
                dismiss: dismiss,
                onItemClick: onItemClick,
                onItemViewed: onItemViewed
            })
    }
});

});
parcelRegister("arRDM", function(module, exports) {
$parcel$export(module.exports, "AssetsPremiumTrialItem", () => $0dc6033e2402cbc0$export$b860e1be94e6cb6e);

var $e79Pd = parcelRequire("e79Pd");

var $2EFuW = parcelRequire("2EFuW");

var $iKPvC = parcelRequire("iKPvC");

var $lK7pY = parcelRequire("lK7pY");

var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $x5TBW = parcelRequire("x5TBW");

var $e6rNk = parcelRequire("e6rNk");

var $c69sa = parcelRequire("c69sa");

var $a1Bqx = parcelRequire("a1Bqx");

var $l1ir8 = parcelRequire("l1ir8");
const $0dc6033e2402cbc0$var$whyAmISeeingThisModalContent = {
    title: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "post-office.jsm-assets-premium-trial-item.reasons-modal-title",
        defaultMessage: "Why am I seeing this?",
        description: "Title of the reasons modal explaining why the premium trial is being shown"
    }),
    message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "post-office.jsm-assets-premium-trial-item.reasons-modal-explanation",
        defaultMessage: "We think this premium feature will help you get more out of Assets. The recommendation is based on:",
        description: "Explanation as to why the premium trial is being shown"
    }),
    reasons: [
        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.jsm-assets-premium-trial-item.reasons-modal-bullet-one",
            defaultMessage: "your current product usage",
            description: "First bullet point of the reasons modal"
        }, "reason-1"),
        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.jsm-assets-premium-trial-item.reasons-modal-bullet-two",
            defaultMessage: "features available in premium",
            description: "Second bullet point of the reasons modal"
        }, "reason-2")
    ]
};
const $0dc6033e2402cbc0$var$containerAvatarStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px'
};
const $0dc6033e2402cbc0$export$b860e1be94e6cb6e = ({ dismiss: dismiss, onItemClick: onItemClick, onItemViewed: onItemViewed })=>{
    const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $iKPvC.useMessageInstanceEvent)();
    const { messageInstanceId: messageInstanceId } = (0, $lK7pY.useMessageContext)();
    (0, $euxye.useEffect)(()=>{
        messageInstanceViewed({
            messageEventType: 'viewed'
        });
        onItemViewed?.();
    }, [
        messageInstanceViewed,
        onItemViewed
    ]);
    const handleClick = (0, $euxye.useCallback)(()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'try-premium-trial',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'react'
            },
            additionalMetadataFromFrontend: {}
        });
        // Call the parent's click handler instead of navigating
        onItemClick?.();
    }, [
        messageInstanceClicked,
        onItemClick
    ]);
    const handleDismiss = (0, $euxye.useCallback)(()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        if (messageInstanceId) dismiss(messageInstanceId);
    }, [
        dismiss,
        messageInstanceClicked,
        messageInstanceId
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e6rNk.LinkMenuItem), {
        elemBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $l1ir8.AssetsIcon), {}),
        elemAfter: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2EFuW.default), {
                    appearance: "new",
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        id: "assets-premium-trial-navigation-item-lozenge-try",
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                            id: "post-office.jsm-assets-premium-trial-item.lozenge-try",
                            defaultMessage: "Try",
                            description: "A lozenge to display the try button for premium trial"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $c69sa.Box), {
                    style: $0dc6033e2402cbc0$var$containerAvatarStyle,
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))), {
                        label: "",
                        size: "small",
                        color: "currentColor"
                    })
                })
            ]
        }),
        href: "/jira/assets",
        target: "_blank",
        onClick: handleClick,
        actionsOnHover: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $x5TBW.AdControls), {
            iconSize: "small",
            spacing: "compact",
            onDismissed: handleDismiss,
            showWhyAmISeeingThis: true,
            whyAmISeeingThisModalContent: $0dc6033e2402cbc0$var$whyAmISeeingThisModalContent,
            ariaLabelledby: "assets-premium-trial-navigation-item-message-title"
        }),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
            id: "assets-premium-trial-navigation-item-message-title",
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "post-office.jsm-assets-premium-trial-item.menu-item-label",
                defaultMessage: "Assets",
                description: "Menu item label for the Assets premium trial"
            })
        })
    });
};
$0dc6033e2402cbc0$export$b860e1be94e6cb6e.displayName = "AssetsPremiumTrialItem";

});
parcelRegister("x5TBW", function(module, exports) {
$parcel$export(module.exports, "AdControls", () => $4811cf814f232862$export$c25b8b7217045de9);

var $e79Pd = parcelRequire("e79Pd");

var $m9iwH = parcelRequire("m9iwH");

var $jaPl6 = parcelRequire("jaPl6");

var $7Fzpe = parcelRequire("7Fzpe");

var $fGrpH = parcelRequire("fGrpH");

var $lK7pY = parcelRequire("lK7pY");

var $iKPvC = parcelRequire("iKPvC");

var $kdOoc = parcelRequire("kdOoc");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $6VAgb = parcelRequire("6VAgb");

var $6xvhS = parcelRequire("6xvhS");

var $ewCbW = parcelRequire("ewCbW");

var $hZDXn = parcelRequire("hZDXn");

var $ljVHR = parcelRequire("ljVHR");
const $4811cf814f232862$var$DropdownTrigger = ({ triggerRef: triggerRef, name: name, iconSize: iconSize = 'small', iconColor: iconColor, spacing: spacing = 'default', ariaLabelledby: ariaLabelledby, ...triggerProps })=>{
    const intl = (0, $1YIbA.default)();
    const ariaLabel = intl.formatMessage({
        id: 'post-office.ad-controls-sequoia.dropdown-menu-trigger.aria-label',
        defaultMessage: '{messageInstanceId} options menu',
        description: 'Aria-label for the ad controls options menu button. {messageInstanceId} is the message instance identifier.'
    }, {
        messageInstanceId: name
    });
    const tooltip = intl.formatMessage({
        id: 'post-office.ad-controls-sequoia.dropdown-menu-trigger.tooltip',
        defaultMessage: 'More actions',
        description: 'Tooltip for ad-controls dropdown'
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                hidden: true,
                children: ariaLabel
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
                content: tooltip,
                isScreenReaderAnnouncementDisabled: true,
                position: "top",
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
                    ...triggerProps,
                    label: tooltip,
                    id: "ad-controls-trigger",
                    appearance: "subtle",
                    ref: triggerRef,
                    spacing: spacing,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7Fzpe))), {
                            ...iconProps,
                            color: iconColor,
                            size: iconSize
                        }),
                    "aria-labelledby": ariaLabelledby ? `${ariaLabelledby} ad-controls-trigger` : 'ad-controls-trigger'
                })
            })
        ]
    });
};
$4811cf814f232862$var$DropdownTrigger.displayName = "DropdownTrigger";
const $4811cf814f232862$export$c25b8b7217045de9 = ({ onDismissed: onDismissed, onRemindMeLater: onRemindMeLater, iconSize: iconSize, iconColor: iconColor, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, showWhyAmISeeingThis: showWhyAmISeeingThis, showRemindMeLater: showRemindMeLater, additionalAnalyticsAttributes: additionalAnalyticsAttributes = {}, spacing: spacing = 'default', customDropdownItems: customDropdownItems, ariaLabelledby: ariaLabelledby })=>{
    const [isWhyAmISeeingThisModelOpened, setIsWhyAmISeeingThisModelOpened] = (0, $euxye.useState)(false);
    const { messageDismissed: messageDismissed, messageAcknowledged: messageAcknowledged } = (0, $kdOoc.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $iKPvC.useMessageInstanceEvent)();
    const { messageInstanceId: messageInstanceId } = (0, $lK7pY.useMessageContext)();
    const [currIconColor, setCurrIconColor] = (0, $euxye.useState)(iconColor);
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    const [showDismissedFlag, setShowDismissedFlag] = (0, $euxye.useState)(false);
    const adControlsTriggerReturnFocusRef = (0, $euxye.useRef)(null);
    const { messageSnoozed: messageSnoozed } = (0, $kdOoc.useMessageEvent)();
    const handleRemindMeLater = async ()=>{
        // https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/pre-defined-filters/#snooze-check-filter
        messageSnoozed(1); // DEPRECATED, but used alongside the messageInstanceClicked function just in case. See above page for documentation
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'remindMeLater',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'snooze',
                snoozeDuration: 1 // Snooze message for 1 day
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'remindMeLater'
        }, {
            ...additionalAnalyticsAttributes
        });
        if (messageInstanceId && typeof onRemindMeLater === 'function') // integrating with useMessagePlacementHooks removes the need to pass this callback
        onRemindMeLater(messageInstanceId);
        setShowDismissedFlag(true);
    };
    const handleNotInterested = async ()=>{
        await messageDismissed();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'notInterested',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'notInterested'
        }, {
            ...additionalAnalyticsAttributes
        });
        if (messageInstanceId && typeof onDismissed === 'function') // integrating with useMessagePlacementHooks removes the need to pass this callback
        onDismissed(messageInstanceId);
        setShowDismissedFlag(true);
    };
    const handleWhyAmISeeingThis = async ()=>{
        setIsWhyAmISeeingThisModelOpened(true);
        await messageAcknowledged();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'adControlsReasons',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsReasons'
        }, {
            ...additionalAnalyticsAttributes
        });
    };
    const fireDropdownMenuOpenAnalyticsEvent = (0, $euxye.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsDropdown'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        fireAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jaPl6.default), {
                testId: "post-office-ad-controls-dropdown",
                shouldRenderToParent: true,
                trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $e79Pd.jsx)($4811cf814f232862$var$DropdownTrigger, {
                        ...triggerProps,
                        name: messageInstanceId,
                        triggerRef: (0, $ljVHR.default)([
                            triggerRef,
                            adControlsTriggerReturnFocusRef
                        ]),
                        iconSize: iconSize,
                        iconColor: currIconColor,
                        spacing: spacing,
                        ariaLabelledby: ariaLabelledby
                    }),
                onOpenChange: (args)=>{
                    if (args.isOpen) {
                        fireDropdownMenuOpenAnalyticsEvent();
                        setCurrIconColor("var(--ds-icon-selected, #1868DB)");
                    } else setCurrIconColor(iconColor);
                },
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6xvhS.AdControlsDropdown), {
                    onNotInterested: handleNotInterested,
                    onWhyAmISeeingThis: handleWhyAmISeeingThis,
                    onRemindMeLater: handleRemindMeLater,
                    showWhyAmISeeingThis: showWhyAmISeeingThis,
                    showRemindMeLater: showRemindMeLater ? true : false,
                    customDropdownItems: customDropdownItems
                })
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ewCbW.WhyAmISeeingThisModal), {
                content: whyAmISeeingThisModalContent,
                isOpen: isWhyAmISeeingThisModelOpened,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes,
                onClose: ()=>{
                    setIsWhyAmISeeingThisModelOpened(false);
                    fireAnalyticsEvent({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'adControlsReasonsClose'
                    }, {
                        ...additionalAnalyticsAttributes
                    });
                },
                shouldReturnFocusRef: adControlsTriggerReturnFocusRef
            }),
            showDismissedFlag && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6VAgb.AdControlsFlag), {
                messageInstanceId: messageInstanceId,
                onCloseFlag: ()=>setShowDismissedFlag(false)
            })
        ]
    });
};
$4811cf814f232862$export$c25b8b7217045de9.displayName = "AdControls";

});
parcelRegister("6VAgb", function(module, exports) {
$parcel$export(module.exports, "AdControlsFlag", () => $a3a9c214e3475830$export$6eb98925a948bca3);
/* dismissalFlag.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $63XI1 = parcelRequire("63XI1");
var $8RTvC = parcelRequire("8RTvC");

var $8Qvei = parcelRequire("8Qvei");

var $ihEDU = parcelRequire("ihEDU");

var $55qdj = parcelRequire("55qdj");

var $aN2Fv = parcelRequire("aN2Fv");
const $a3a9c214e3475830$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER = 'post-office-ad-controls-flag-wrapper';
/**-Title--**/ const $a3a9c214e3475830$var$titleContainerStyles = {
    font: "_11c81qyo"
};
const $a3a9c214e3475830$var$Title = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $a3a9c214e3475830$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.ad-controls-sequoia.dismiss-flag.not-interested.title",
            defaultMessage: "Got it, thanks for letting us know",
            description: "The title for a flag which is displayed when the Not Interested button is pressed. https://hello.atlassian.net/l/cp/ssoqm2Fq"
        })
    });
$a3a9c214e3475830$var$Title.displayName = "Title";
/**--Description--**/ const $a3a9c214e3475830$var$Description = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "post-office.ad-controls-sequoia.dismiss-flag.not-interested.subtitle",
        defaultMessage: "You won\u2019t see this here as often.",
        description: "The subtitle for a flag which is displayed when the Not Interested button is pressed. https://hello.atlassian.net/l/cp/ssoqm2Fq"
    });
$a3a9c214e3475830$var$Description.displayName = "Description";
/**--Confirm Icon--*/ const $a3a9c214e3475830$var$ConfirmIcon = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Qvei))), {
        spacing: "spacious",
        label: "Success",
        color: "var(--ds-icon-success, #36B37E)"
    });
$a3a9c214e3475830$var$ConfirmIcon.displayName = "ConfirmIcon";
const $a3a9c214e3475830$export$6eb98925a948bca3 = ({ messageInstanceId: messageInstanceId, onCloseFlag: onCloseFlag })=>{
    (0, $aN2Fv.portalZIndexFix)($a3a9c214e3475830$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8RTvC.default), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            id: $a3a9c214e3475830$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $63XI1.default), {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)($a3a9c214e3475830$var$ConfirmIcon, {}),
                title: /*#__PURE__*/ (0, $e79Pd.jsx)($a3a9c214e3475830$var$Title, {}),
                description: /*#__PURE__*/ (0, $e79Pd.jsx)($a3a9c214e3475830$var$Description, {}),
                id: messageInstanceId,
                onDismissed: ()=>onCloseFlag()
            }, messageInstanceId)
        })
    });
};
$a3a9c214e3475830$export$6eb98925a948bca3.displayName = "AdControlsFlag";

});
parcelRegister("aN2Fv", function(module, exports) {
$parcel$export(module.exports, "portalZIndexFix", () => $1f81cb57929d3b16$export$cef2f5415067aeab);
const $1f81cb57929d3b16$var$collectionHas = (all, curr)=>{
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
};
const $1f81cb57929d3b16$var$findParentBySelector = (elm, selector)=>{
    const all = globalThis.document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$1f81cb57929d3b16$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
};
const $1f81cb57929d3b16$export$cef2f5415067aeab = (wrapperId)=>{
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    setTimeout(()=>{
        if (globalThis.document) {
            const modalContent = globalThis.document.getElementById(wrapperId);
            const portalSelector = '.atlaskit-portal';
            const parentPortal = $1f81cb57929d3b16$var$findParentBySelector(modalContent, portalSelector);
            if (parentPortal) parentPortal.setAttribute('style', 'z-index:900;');
        }
    });
// DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
};

});


parcelRegister("6xvhS", function(module, exports) {
$parcel$export(module.exports, "AdControlsDropdown", () => $46bb21620203c4d1$export$ba7539b3ac68f9f1);

var $e79Pd = parcelRequire("e79Pd");

var $2YPKP = parcelRequire("2YPKP");
var $2Xkyn = parcelRequire("2Xkyn");

var $55qdj = parcelRequire("55qdj");

var $iCEM6 = parcelRequire("iCEM6");

var $2bpNg = parcelRequire("2bpNg");
const $46bb21620203c4d1$export$99f2c116e7ad8950 = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $2YPKP.default), {
        ...props,
        elemBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iCEM6))), {
            label: ""
        }),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.ad-controls-sequoia.dropdown-item.why-am-i-seeing-this.label",
            defaultMessage: "Why am I seeing this?",
            description: "The text for the button which opens a modal showing the reasons a message has been displayed."
        })
    });
$46bb21620203c4d1$export$99f2c116e7ad8950.displayName = "WhyAmISeeingThis";
const $46bb21620203c4d1$export$80eb3e3679dfe382 = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $2YPKP.default), {
        ...props,
        elemBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2bpNg))), {
            label: ""
        }),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.ad-controls-sequoia.dropdown-item.not-interested.label",
            defaultMessage: "Not interested",
            description: "The text for the button which removes a message from a placement."
        })
    });
$46bb21620203c4d1$export$80eb3e3679dfe382.displayName = "NotInterested";
const $46bb21620203c4d1$export$c3a3ff4a62111967 = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $2YPKP.default), {
        ...props,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.ad-controls-sequoia.dropdown-item.remind-me-later.label",
            defaultMessage: "Remind me later",
            description: "The text for the button which removes a message from a placement and makes it reappear at a later date."
        })
    });
$46bb21620203c4d1$export$c3a3ff4a62111967.displayName = "RemindMeLater";
const $46bb21620203c4d1$export$ba7539b3ac68f9f1 = ({ onWhyAmISeeingThis: onWhyAmISeeingThis, onNotInterested: onNotInterested, onRemindMeLater: onRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis = true, showRemindMeLater: showRemindMeLater, customDropdownItems: customDropdownItems })=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2Xkyn.default), {
        children: [
            customDropdownItems?.map((item)=>item),
            showRemindMeLater && /*#__PURE__*/ (0, $e79Pd.jsx)($46bb21620203c4d1$export$c3a3ff4a62111967, {
                testId: "ad-controls-dropdown-remind-me-later",
                onClick: onRemindMeLater
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)($46bb21620203c4d1$export$80eb3e3679dfe382, {
                testId: "ad-controls-dropdown-not-interested",
                onClick: onNotInterested
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $e79Pd.jsx)($46bb21620203c4d1$export$99f2c116e7ad8950, {
                testId: "ad-controls-dropdown-why-am-I-seeing-this",
                onClick: onWhyAmISeeingThis
            })
        ]
    });
$46bb21620203c4d1$export$ba7539b3ac68f9f1.displayName = "AdControlsDropdown";

});

parcelRegister("ewCbW", function(module, exports) {
$parcel$export(module.exports, "WhyAmISeeingThisModal", () => $9f1f37e9f42b9682$export$b29014abf8076d54);
/* modal.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $iOfms = parcelRequire("iOfms");

var $hzWaA = parcelRequire("hzWaA");

var $7tY81 = parcelRequire("7tY81");

var $2v3yi = parcelRequire("2v3yi");

var $4vluQ = parcelRequire("4vluQ");

var $gpyJM = parcelRequire("gpyJM");

var $dNPnD = parcelRequire("dNPnD");

var $9imxF = parcelRequire("9imxF");

var $ihEDU = parcelRequire("ihEDU");

var $fGrpH = parcelRequire("fGrpH");

var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $aN2Fv = parcelRequire("aN2Fv");
const $9f1f37e9f42b9682$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT = 'why-am-i-seeing-this-modal-content';
const $9f1f37e9f42b9682$export$2b77a92f1a5ad772 = ({ children: children, isOpen: isOpen, onClose: onClose, shouldReturnFocusRef: shouldReturnFocusRef })=>{
    (0, $aN2Fv.portalZIndexFix)($9f1f37e9f42b9682$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9imxF.default), {
        children: isOpen && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7tY81.default), {
            shouldCloseOnEscapePress: true,
            onClose: onClose,
            shouldReturnFocus: shouldReturnFocusRef ?? true,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                id: $9f1f37e9f42b9682$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT,
                children: children
            })
        })
    });
};
$9f1f37e9f42b9682$export$2b77a92f1a5ad772.displayName = "Modal";
const $9f1f37e9f42b9682$var$AcceptButton = ({ onClick: onClick })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $iOfms.default), {
        appearance: "primary",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.ad-controls-sequoia.reasons-modal.accept-button.label-ok",
            defaultMessage: "OK",
            description: "The text on the button that dismisses a modal which provides reasons a message has been displayed"
        })
    });
$9f1f37e9f42b9682$var$AcceptButton.displayName = "AcceptButton";
/*--Title--*/ const $9f1f37e9f42b9682$var$titleContainerStyles = {
    font: "_11c81af2"
};
const $9f1f37e9f42b9682$var$Title = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $9f1f37e9f42b9682$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.ad-controls-sequoia.reasons-modal.title",
            defaultMessage: "Why am I seeing this?",
            description: "The title for a modal that displays the reasons a message was displayed."
        })
    });
$9f1f37e9f42b9682$var$Title.displayName = "Title";
/*--Body--*/ const $9f1f37e9f42b9682$var$DefaultBody = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)("p", {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "post-office.ad-controls-sequoia.reasons-modal.body",
            defaultMessage: "We think you'd find this relevant. This is based on:",
            description: "Explanation of why we think the message will be releavant to the customer."
        })
    });
$9f1f37e9f42b9682$var$DefaultBody.displayName = "DefaultBody";
const $9f1f37e9f42b9682$var$reasonsListStyles = null;
const $9f1f37e9f42b9682$var$ReasonsList = ({ reasons: reasons })=>/*#__PURE__*/ (0, $e79Pd.jsx)("ul", {
        className: (0, $4jQY2.default)([
            "_2mzu1wth _19bvv47k _19pkutpp"
        ]),
        children: reasons.map((reason, index)=>/*#__PURE__*/ (0, $e79Pd.jsx)("li", {
                children: reason
            }, index))
    });
$9f1f37e9f42b9682$var$ReasonsList.displayName = "ReasonsList";
const $9f1f37e9f42b9682$var$privacyPolicyLinkWrapperStyles = null;
const $9f1f37e9f42b9682$export$fdd773f48aebb8ab = ({ onClick: onClick })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_19pkutpp"
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hzWaA.default), {
            href: 'https://www.atlassian.com/legal/privacy-policy',
            target: "_blank",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "post-office.ad-controls-sequoia.reasons-modal.privacy-policy-link.text",
                defaultMessage: "Learn more about your data privacy with Atlassian",
                description: "The text linking to Atlassian's privacy policy. https://hello.atlassian.net/l/cp/ssoqm2Fq"
            })
        })
    });
$9f1f37e9f42b9682$export$fdd773f48aebb8ab.displayName = "PrivacyPolicyLink";
const $9f1f37e9f42b9682$var$ReasonsModalDefaultBody = ({ onClose: onClose, content: content, additionalAnalyticsAttributes: additionalAnalyticsAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'adControlsReasonsModal'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        fireAnalyticsEvent,
        additionalAnalyticsAttributes
    ]);
    const handleOnPrivacyPolicy = (0, $euxye.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'adControlsPrivacyPolicy'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        fireAnalyticsEvent,
        additionalAnalyticsAttributes
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gpyJM.default), {
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dNPnD.default), {
                    children: content?.title || /*#__PURE__*/ (0, $e79Pd.jsx)($9f1f37e9f42b9682$var$Title, {})
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2v3yi.default), {
                children: content?.body || /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                    children: [
                        content?.message || /*#__PURE__*/ (0, $e79Pd.jsx)($9f1f37e9f42b9682$var$DefaultBody, {}),
                        content?.reasons && /*#__PURE__*/ (0, $e79Pd.jsx)($9f1f37e9f42b9682$var$ReasonsList, {
                            reasons: content.reasons
                        }),
                        content?.privacyPolicy || /*#__PURE__*/ (0, $e79Pd.jsx)($9f1f37e9f42b9682$export$fdd773f48aebb8ab, {
                            onClick: ()=>handleOnPrivacyPolicy()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4vluQ.default), {
                children: /*#__PURE__*/ (0, $e79Pd.jsx)($9f1f37e9f42b9682$var$AcceptButton, {
                    onClick: onClose
                })
            })
        ]
    });
};
$9f1f37e9f42b9682$var$ReasonsModalDefaultBody.displayName = "ReasonsModalDefaultBody";
const $9f1f37e9f42b9682$export$b29014abf8076d54 = (props)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)($9f1f37e9f42b9682$export$2b77a92f1a5ad772, {
        isOpen: props.isOpen,
        onClose: props.onClose,
        shouldReturnFocusRef: props.shouldReturnFocusRef,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($9f1f37e9f42b9682$var$ReasonsModalDefaultBody, {
            ...props
        })
    });
};
$9f1f37e9f42b9682$export$b29014abf8076d54.displayName = "WhyAmISeeingThisModal";

});


parcelRegister("l1ir8", function(module, exports) {
$parcel$export(module.exports, "AssetsIcon", () => $3fc552ffe1353b7f$export$d89497e7f33ca6f5);

var $e79Pd = parcelRequire("e79Pd");
const $3fc552ffe1353b7f$export$d89497e7f33ca6f5 = ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("g", {
                clipPath: "url(#clip0_1788_42960)",
                children: /*#__PURE__*/ (0, $e79Pd.jsxs)("g", {
                    clipPath: "url(#clip1_1788_42960)",
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                            d: "M2 7C2 4.23858 4.23858 2 7 2H17C19.7614 2 22 4.23858 22 7V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7Z",
                            fill: "#DDDEE1"
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M9.29102 11.6408C10.5161 11.4881 11.4871 10.5171 11.6399 9.29199H13.3535V7.93783H11.4639C11.0622 6.94528 10.0891 6.24512 8.95247 6.24512C7.4567 6.24512 6.24414 7.45768 6.24414 8.95345C6.24414 10.0901 6.9443 11.0631 7.93685 11.4649L7.93685 13.3545H9.29102V11.6408ZM8.95247 9.96908C9.51339 9.96908 9.9681 9.51436 9.9681 8.95345C9.9681 8.39254 9.51339 7.93783 8.95247 7.93783C8.39156 7.93783 7.93685 8.39254 7.93685 8.95345C7.93685 9.51436 8.39156 9.96908 8.95247 9.96908Z",
                            fill: "#1E1F21"
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                            d: "M17.416 8.61491C17.416 9.54977 16.6582 10.3076 15.7233 10.3076C14.7885 10.3076 14.0306 9.54977 14.0306 8.61491C14.0306 7.68005 14.7885 6.9222 15.7233 6.9222C16.6582 6.9222 17.416 7.68005 17.416 8.61491Z",
                            fill: "#1E1F21"
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                            d: "M8.61393 17.417C9.54879 17.417 10.3066 16.6591 10.3066 15.7243C10.3066 14.7894 9.54879 14.0316 8.61393 14.0316C7.67908 14.0316 6.92122 14.7894 6.92122 15.7243C6.92122 16.6591 7.67908 17.417 8.61393 17.417Z",
                            fill: "#1E1F21"
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                            d: "M15.7233 17.417C16.6582 17.417 17.416 16.6591 17.416 15.7243C17.416 14.7894 16.6582 14.0316 15.7233 14.0316C14.7885 14.0316 14.0306 14.7894 14.0306 15.7243C14.0306 16.6591 14.7885 17.417 15.7233 17.417Z",
                            fill: "#1E1F21"
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                            d: "M13.3535 15.0472H10.9837V16.4014H13.3535V15.0472Z",
                            fill: "#1E1F21"
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                            d: "M15.0462 10.9847V13.3545H16.4004V10.9847H15.0462Z",
                            fill: "#1E1F21"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)("clipPath", {
                        id: "clip0_1788_42960",
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                            width: "20",
                            height: "20",
                            fill: "white",
                            transform: "translate(2 2)"
                        })
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("clipPath", {
                        id: "clip1_1788_42960",
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                            width: "20",
                            height: "20",
                            fill: "white",
                            transform: "translate(2 2)"
                        })
                    })
                ]
            })
        ]
    });
$3fc552ffe1353b7f$export$d89497e7f33ca6f5.displayName = "AssetsIcon";

});



parcelRegister("eJt2x", function(module, exports) {
$parcel$export(module.exports, "withI18n", () => $b2a1a37ea7a65962$export$bfba3ccd9d9038f9);

var $2I9KJ = parcelRequire("2I9KJ");

var $bOBrx = parcelRequire("bOBrx");
const $b2a1a37ea7a65962$export$bfba3ccd9d9038f9 = (0, $2I9KJ.createWithI18n)((0, $bOBrx.messagesLoader));

});



parcelRegister("curUp", function(module, exports) {
$parcel$export(module.exports, "GlobalAppShortcuts", () => $165b5b35f73b9dd9$export$69209b4d7b9e00bc);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $3Y4vt = parcelRequire("3Y4vt");

const $165b5b35f73b9dd9$export$69209b4d7b9e00bc = ({ menuId: menuId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "flag",
        id: "global-app-shortcuts-section",
        packageName: (0, $1787c1cd1cf38989$export$b8b9d90f9e5bd72b),
        teamName: (0, $1787c1cd1cf38989$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3Y4vt.GlobalAppShortcuts), {
        menuId: menuId
    }));
$165b5b35f73b9dd9$export$69209b4d7b9e00bc.displayName = "GlobalAppShortcuts";

});
parcelRegister("3Y4vt", function(module, exports) {
$parcel$export(module.exports, "GlobalAppShortcuts", () => $c10e7582e5e371e9$export$69209b4d7b9e00bc);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $5IkoH = parcelRequire("5IkoH");

var $3rqDf = parcelRequire("3rqDf");

var $bOwox = parcelRequire("bOwox");

var $9Nter = parcelRequire("9Nter");

var $aDrZQ = parcelRequire("aDrZQ");

var $9eS3f = parcelRequire("9eS3f");
function $c10e7582e5e371e9$export$69209b4d7b9e00bc({ menuId: menuId }) {
    const sendSectionItemAnalyticsEvent = (0, $3rqDf.useSectionItemAnalytics)();
    const onClick = (0, $euxye.useCallback)(()=>{
        sendSectionItemAnalyticsEvent({
            menuId: menuId,
            sectionItem: (0, $bOwox.SECTION_ITEM_MAP)[menuId]
        });
    }, [
        menuId,
        sendSectionItemAnalyticsEvent
    ]);
    switch(menuId){
        case (0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_GOALS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aDrZQ.Goals), {
                onClick: onClick
            });
        case (0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_ASSETS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9Nter.Assets), {
                onClick: onClick
            });
        case (0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_TEAMS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9eS3f.Teams), {
                onClick: onClick
            });
        default:
            return null;
    }
}
$c10e7582e5e371e9$export$69209b4d7b9e00bc.displayName = "GlobalAppShortcuts";

});
parcelRegister("9Nter", function(module, exports) {
$parcel$export(module.exports, "Assets", () => $9060856578e73248$export$c8eca95e306f7116);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6GljB = parcelRequire("6GljB");

var $aieBA = parcelRequire("aieBA");

var $fBt6f = parcelRequire("fBt6f");

var $a1Bqx = parcelRequire("a1Bqx");

var $eprc4 = parcelRequire("eprc4");

var $e6rNk = parcelRequire("e6rNk");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $ccEzE = parcelRequire("ccEzE");

var $bs9jJ = parcelRequire("bs9jJ");
const $9060856578e73248$var$lozenge = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.assets.lozenge",
    defaultMessage: "Try"
});
const $9060856578e73248$var$assets = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.assets.assets",
    defaultMessage: "Assets"
});
const $9060856578e73248$var$LEGACY_ASSETS_URL = '/jira/assets';
function $9060856578e73248$export$c8eca95e306f7116({ onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { isUpsell: isUpsell, toResolvedAbsoluteUrl: toResolvedAbsoluteUrl } = (0, $aieBA.useAssetsSidebarState)();
    const url = toResolvedAbsoluteUrl($9060856578e73248$var$LEGACY_ASSETS_URL);
    const appEditions = (0, $ccEzE.useAppEditions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    // Fire the upsell "viewed" event once when the shortcut first becomes visible in the upsell
    // state — not on every re-render (keyed on `isUpsell`).
    (0, $euxye.useEffect)(()=>{
        if (isUpsell) (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
            serviceDeskEdition: appEditions.serviceDesk,
            isSiteAdmin: isSiteAdmin
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isUpsell
    ]);
    if (isUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fBt6f.AssetsUpsellButton), {
        configurableMenuId: (0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS,
        lozengeText: formatMessage($9060856578e73248$var$lozenge)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e6rNk.LinkMenuItem), {
        href: url,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))), {
            label: "",
            spacing: "spacious",
            size: "small"
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.AssetsIcon), {
            shouldUseNewLogoDesign: true,
            size: "xsmall"
        }),
        target: "_blank",
        onClick: onClick,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.assets.menu-link-item"
    }, formatMessage($9060856578e73248$var$assets));
}
$9060856578e73248$export$c8eca95e306f7116.displayName = "Assets";

});

parcelRegister("aDrZQ", function(module, exports) {
$parcel$export(module.exports, "Goals", () => $3ce9b62528ba41fb$export$3c4000465299790);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $a1Bqx = parcelRequire("a1Bqx");

var $eprc4 = parcelRequire("eprc4");

var $e6rNk = parcelRequire("e6rNk");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $3ce9b62528ba41fb$var$goals = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.goals.goals",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Goals"
});
function $3ce9b62528ba41fb$export$3c4000465299790({ onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const url = 'https://home.atlassian.com/goals';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e6rNk.LinkMenuItem), {
        href: url,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))), {
            label: "",
            spacing: "spacious",
            size: "small"
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.GoalsIcon), {
            shouldUseNewLogoDesign: true,
            size: "xsmall"
        }),
        target: "_blank",
        onClick: onClick,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.goals.menu-link-item"
    }, formatMessage($3ce9b62528ba41fb$var$goals));
}
$3ce9b62528ba41fb$export$3c4000465299790.displayName = "Goals";

});

parcelRegister("9eS3f", function(module, exports) {
$parcel$export(module.exports, "Teams", () => $73318966db3b8dbf$export$b3a34d915d8dd11e);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $adrK8 = parcelRequire("adrK8");

var $e4f4V = parcelRequire("e4f4V");

var $dDRge = parcelRequire("dDRge");

var $3LhWS = parcelRequire("3LhWS");


var $bOwox = parcelRequire("bOwox");

var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");


var $5tPwf = parcelRequire("5tPwf");

var $rKVUU = parcelRequire("rKVUU");

var $3EXjU = parcelRequire("3EXjU");


var $a1Bqx = parcelRequire("a1Bqx");

var $eprc4 = parcelRequire("eprc4");

var $ceqcm = parcelRequire("ceqcm");

var $m9iwH = parcelRequire("m9iwH");

var $ikOED = parcelRequire("ikOED");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");

var $e6rNk = parcelRequire("e6rNk");

var $fFNvS = parcelRequire("fFNvS");

var $gNzvf = parcelRequire("gNzvf");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $73318966db3b8dbf$var$teams = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.teams.teams",
    defaultMessage: "Teams"
});
const $73318966db3b8dbf$var$invitePeople = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.teams.invite-people",
    defaultMessage: "Invite people"
});
const $73318966db3b8dbf$var$createTeam = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.teams.create-team",
    defaultMessage: "Create a team"
});
const $73318966db3b8dbf$var$CREATE_A_TEAM = 'createATeam';
const $73318966db3b8dbf$var$INVITE_PEOPLE = 'invitePeople';
const $73318966db3b8dbf$var$PopupContent = ({ openTeamsPopup: openTeamsPopup, createTeamModalTrigger: createTeamModalTrigger })=>{
    const invitePeopleModalTrigger = (0, $rKVUU.useInvitePeopleModal)((0, $3EXjU.EnablementTouchpoint).NAV4_TEAMS_ADD);
    const actionSubjectId = (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_TEAMS];
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const onButtonClick = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                componentType: (0, $6e2f51712bb2e810$export$17bca95234dea43b),
                parentItemId: (0, $bOwox.SECTION_ITEM_TEAMS),
                itemId: $73318966db3b8dbf$var$INVITE_PEOPLE
            }
        });
        invitePeopleModalTrigger();
        openTeamsPopup(false);
    }, [
        createAnalyticsEvent,
        actionSubjectId,
        invitePeopleModalTrigger,
        openTeamsPopup
    ]);
    const onCreateTeamClick = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                componentType: (0, $6e2f51712bb2e810$export$17bca95234dea43b),
                parentItemId: (0, $bOwox.SECTION_ITEM_TEAMS),
                itemId: $73318966db3b8dbf$var$CREATE_A_TEAM
            }
        });
        createTeamModalTrigger();
        openTeamsPopup(false);
    }, [
        createAnalyticsEvent,
        actionSubjectId,
        createTeamModalTrigger,
        openTeamsPopup
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        xcss: $73318966db3b8dbf$var$teamsMenuStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        onClick: onButtonClick
    }, formatMessage($73318966db3b8dbf$var$invitePeople)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        onClick: onCreateTeamClick
    }, formatMessage($73318966db3b8dbf$var$createTeam)));
};
$73318966db3b8dbf$var$PopupContent.displayName = "PopupContent";
function $73318966db3b8dbf$var$TeamsInner({ onClick: onClick, ...menuItemProps }) {
    const [isOpenTeamsPopup, openTeamsPopup] = (0, $euxye.useState)(false);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const label = formatMessage($73318966db3b8dbf$var$teams);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [createTeamModal, createTeamModalTrigger] = (0, $5tPwf.useCreateTeamModal)();
    const actionSubjectId = (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_TEAMS];
    const peopleMenuWrapperRef = (0, $adrK8.useRegisterNudgeTarget)((0, $99cb2e6a234d7a1f$export$77bc79debbf5c069), (0, $i860n.fg)('teams-app-shortcut-nudge')).ref;
    const { href: href } = (0, $3LhWS.getNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const onPlusButtonClick = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
                parentItemId: (0, $bOwox.SECTION_ITEM_TEAMS),
                itemId: 'add'
            }
        });
        openTeamsPopup(true);
    }, [
        createAnalyticsEvent,
        actionSubjectId
    ]);
    const renderContent = (0, $euxye.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($73318966db3b8dbf$var$PopupContent, {
            openTeamsPopup: openTeamsPopup,
            createTeamModalTrigger: createTeamModalTrigger
        });
    }, [
        createTeamModalTrigger,
        openTeamsPopup
    ]);
    const { draggableRef: draggableRef, isInMoreMenu: isInMoreMenu, ...restMenuItemProps } = menuItemProps || {};
    const peopleRef = (0, $i860n.fg)('teams-app-shortcut-nudge') ? peopleMenuWrapperRef : undefined;
    const mergedRefs = (0, $fFNvS.mergeRefs)(peopleRef ?? null, draggableRef ?? null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, createTeamModal, !isInMoreMenu && (0, $i860n.fg)('teams-app-shortcut-nudge') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dDRge.InviteTeamNudgeAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e6rNk.LinkMenuItem), {
        ref: mergedRefs,
        href: href,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))), {
            label: "",
            spacing: "spacious",
            size: "small"
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.TeamsIcon), {
            shouldUseNewLogoDesign: true,
            size: "xsmall"
        }),
        target: "_blank",
        onClick: onClick,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.teams.menu-link-item",
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNzvf.JiraPopup), {
            shouldRenderToParent: true,
            placement: "bottom-start",
            // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
            messageId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.teams.popup",
            messageType: "transactional",
            onClose: (0, $euxye.useCallback)(()=>openTeamsPopup(false), []),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
                    ...triggerProps,
                    icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ikOED))), {
                            ...iconProps,
                            size: "small"
                        }),
                    appearance: "subtle",
                    spacing: "compact",
                    // eslint-disable-next-line jira/integration/test-id-by-folder-structure
                    testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.teams.sidenav-teams-popup-trigger",
                    isSelected: isOpenTeamsPopup,
                    label: label,
                    tooltip: {
                        content: label
                    },
                    isTooltipDisabled: false,
                    onClick: onPlusButtonClick
                }),
            isOpen: isOpenTeamsPopup,
            content: renderContent
        })),
        ...restMenuItemProps
    }, formatMessage($73318966db3b8dbf$var$teams)));
}
$73318966db3b8dbf$var$TeamsInner.displayName = "TeamsInner";
function $73318966db3b8dbf$export$b3a34d915d8dd11e(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e4f4V.JiraInvitePeopleModalContextProvider), {
        renderedInProjectContext: false,
        shouldDisplaySuccessModal: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($73318966db3b8dbf$var$TeamsInner, props));
}
$73318966db3b8dbf$export$b3a34d915d8dd11e.displayName = "Teams";
const $73318966db3b8dbf$var$teamsMenuStyle = (0, $fbAgj.xcss)({
    minWidth: '260px',
    paddingBlock: 'space.100'
});

});


/* eslint-disable jira/filename-case */ const $1787c1cd1cf38989$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4GlobalAppShortcuts';
const $1787c1cd1cf38989$export$d57b6b390e78d90f = 'jira-cosmos';


parcelRegister("chlmx", function(module, exports) {
$parcel$export(module.exports, "useAssets", () => $df0f2fb99b8c6da4$export$bd973f06e9aaec8c);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $eprc4 = parcelRequire("eprc4");

var $dpcSS = parcelRequire("dpcSS");

var $6MOeo = parcelRequire("6MOeo");

var $94hO2 = parcelRequire("94hO2");
const $df0f2fb99b8c6da4$var$icon = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.AssetsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $df0f2fb99b8c6da4$export$bd973f06e9aaec8c = (fallbackUrl, options = {})=>(0, $6MOeo.useAppGlobalShortcutLinkItem)($df0f2fb99b8c6da4$var$icon, (0, $94hO2.messages).label, fallbackUrl, {
        apsKey: (0, $dpcSS.Products).ASSETS,
        analyticsName: (0, $dpcSS.Products).ASSETS,
        ...options
    });

});
parcelRegister("94hO2", function(module, exports) {
$parcel$export(module.exports, "messages", () => $13595cb1a54b3e51$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $13595cb1a54b3e51$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.assets',
        defaultMessage: 'Assets',
        description: 'The link label for Assets'
    }
});

});


parcelRegister("br3o6", function(module, exports) {
$parcel$export(module.exports, "useConfluence", () => $b626e672a503ca47$export$4f925a926283ab5);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $eprc4 = parcelRequire("eprc4");

var $dpcSS = parcelRequire("dpcSS");

var $6MOeo = parcelRequire("6MOeo");

var $gJHvs = parcelRequire("gJHvs");
const $b626e672a503ca47$var$icon = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.ConfluenceIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $b626e672a503ca47$export$4f925a926283ab5 = (fallbackUrl, options = {})=>(0, $6MOeo.useAppGlobalShortcutLinkItem)($b626e672a503ca47$var$icon, (0, $gJHvs.messages).label, fallbackUrl, {
        apsKey: (0, $dpcSS.Products).CONFLUENCE,
        analyticsName: (0, $dpcSS.Products).CONFLUENCE,
        ...options
    });

});
parcelRegister("gJHvs", function(module, exports) {
$parcel$export(module.exports, "messages", () => $12a7653908742dd9$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $12a7653908742dd9$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.confluence',
        defaultMessage: 'Confluence',
        description: 'The text is shown as a navigation link label in the global shortcuts menu when the user opens the shortcut menu. This link navigates the user to the Confluence application.'
    }
});

});


parcelRegister("dO1Ns", function(module, exports) {
$parcel$export(module.exports, "useLoom", () => $4b00f448a70c7a76$export$ef6b4021b8157342);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $eprc4 = parcelRequire("eprc4");

var $dpcSS = parcelRequire("dpcSS");

var $6MOeo = parcelRequire("6MOeo");

var $gulGa = parcelRequire("gulGa");
const $4b00f448a70c7a76$var$icon = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.LoomIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $4b00f448a70c7a76$export$ef6b4021b8157342 = (fallbackUrl, options = {})=>(0, $6MOeo.useAppGlobalShortcutLinkItem)($4b00f448a70c7a76$var$icon, (0, $gulGa.messages).label, fallbackUrl, {
        apsKey: (0, $dpcSS.Products).LOOM,
        analyticsName: (0, $dpcSS.Products).LOOM,
        ...options
    });

});
parcelRegister("gulGa", function(module, exports) {
$parcel$export(module.exports, "messages", () => $709bee2c65f505fd$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $709bee2c65f505fd$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.loom',
        defaultMessage: 'Loom',
        description: 'The text is shown as a navigation link label in the global shortcuts menu when the user opens the shortcut menu. This link navigates the user to the Loom application.'
    }
});

});


parcelRegister("frNbj", function(module, exports) {
$parcel$export(module.exports, "useGoals", () => $fc12be2b98e55349$export$1b288bd6ab893e8f);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $eprc4 = parcelRequire("eprc4");

var $dpcSS = parcelRequire("dpcSS");

var $6MOeo = parcelRequire("6MOeo");

var $et4YV = parcelRequire("et4YV");
const $fc12be2b98e55349$var$icon = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.GoalsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $fc12be2b98e55349$export$1b288bd6ab893e8f = (fallbackUrl, options = {})=>(0, $6MOeo.useAppGlobalShortcutLinkItem)($fc12be2b98e55349$var$icon, (0, $et4YV.messages).label, fallbackUrl, {
        apsKey: (0, $dpcSS.Products).ATLAS_GOALS,
        analyticsName: (0, $dpcSS.Products).ATLAS_GOALS,
        ...options
    });

});
parcelRegister("et4YV", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a8b44e66d64e6da1$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $a8b44e66d64e6da1$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.goals',
        defaultMessage: 'Goals',
        description: 'The text is shown as a navigation link label in the global shortcuts menu when the user opens the shortcut menu. This link navigates the user to the Goals application.'
    }
});

});


parcelRegister("VKXQG", function(module, exports) {
$parcel$export(module.exports, "useOpsgenie", () => $ec671ecc4b133ef2$export$1a89b17f91671267);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $eprc4 = parcelRequire("eprc4");

var $dpcSS = parcelRequire("dpcSS");

var $6MOeo = parcelRequire("6MOeo");

var $11Y9K = parcelRequire("11Y9K");
const $ec671ecc4b133ef2$var$icon = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.OpsgenieIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $ec671ecc4b133ef2$export$1a89b17f91671267 = (fallbackUrl, options = {})=>(0, $6MOeo.useAppGlobalShortcutLinkItem)($ec671ecc4b133ef2$var$icon, (0, $11Y9K.messages).label, fallbackUrl, {
        apsKey: (0, $dpcSS.Products).OPSGENIE,
        analyticsName: (0, $dpcSS.Products).OPSGENIE,
        ...options
    });

});
parcelRegister("11Y9K", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e87b696a5cf77769$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $e87b696a5cf77769$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.opsgenie',
        defaultMessage: 'Opsgenie',
        description: 'The text is shown as a navigation link label in the global shortcuts menu when the user opens the shortcut menu. This link navigates the user to the Opsgenie application.'
    }
});

});


parcelRegister("bF065", function(module, exports) {
$parcel$export(module.exports, "useProjects", () => $dd9c4446cdac1b18$export$39d4f31fc4866d70);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $eprc4 = parcelRequire("eprc4");

var $dpcSS = parcelRequire("dpcSS");

var $6MOeo = parcelRequire("6MOeo");

var $ktoOB = parcelRequire("ktoOB");
const $dd9c4446cdac1b18$var$icon = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.ProjectsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $dd9c4446cdac1b18$export$39d4f31fc4866d70 = (fallbackUrl, options = {})=>{
    return (0, $6MOeo.useAppGlobalShortcutLinkItem)($dd9c4446cdac1b18$var$icon, (0, $ktoOB.messages).label, fallbackUrl, {
        apsKey: (0, $dpcSS.Products).PROJECTS,
        analyticsName: (0, $dpcSS.Products).PROJECTS,
        ...options
    });
};

});
parcelRegister("ktoOB", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1e4454bdfd69b26b$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $1e4454bdfd69b26b$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.projects',
        defaultMessage: 'Projects',
        description: 'The text is shown as a navigation link label in the global shortcuts menu when the user opens the shortcut menu. This link navigates the user to the Projects application.'
    },
    labelGalaxia: {
        id: 'navigation.global-shortcuts.apps.projects-galaxia',
        defaultMessage: 'Spaces',
        description: 'The text is shown as a navigation link label in the global shortcuts menu when the user opens the shortcut menu. This is the Galaxia variant label for Projects, which displays as "Spaces" instead of "Projects". This link navigates the user to the Projects (Spaces) application.'
    }
});

});


parcelRegister("c4Kh9", function(module, exports) {
$parcel$export(module.exports, "getRenderableShortcutMenuIds", () => $3967197ea97fab0e$export$54ab7f38734f4fcb);
$parcel$export(module.exports, "useRenderableShortcutMenuIds", () => $3967197ea97fab0e$export$fd101118c122470d);

var $e7boj = parcelRequire("e7boj");

var $6GljB = parcelRequire("6GljB");

var $aieBA = parcelRequire("aieBA");

var $2HuOR = parcelRequire("2HuOR");

var $eaLDc = parcelRequire("eaLDc");
const $3967197ea97fab0e$export$54ab7f38734f4fcb = ({ licenceStates: licenceStates, hasConfluence: hasConfluence, hasLoom: hasLoom, hasGoal: hasGoal, hasProject: hasProject, teamsSupported: teamsSupported, showAssets: showAssets })=>{
    if (licenceStates.core === 'ACTIVE') {
        if (licenceStates.serviceDesk === 'ACTIVE') return [
            ...hasConfluence ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE
            ] : [],
            ...hasLoom ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_LOOM
            ] : [],
            (0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS,
            (0, $6GljB.L1_MENU_ID).GLOBAL_APP_OPSGENIE,
            ...teamsSupported ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_TEAMS
            ] : [],
            ...hasGoal ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS
            ] : [],
            ...hasProject ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS
            ] : []
        ];
        if (licenceStates.productDiscovery === 'ACTIVE') return [
            ...hasConfluence ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE
            ] : [],
            ...hasLoom ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_LOOM
            ] : [],
            ...showAssets ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS
            ] : [],
            ...teamsSupported ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_TEAMS
            ] : [],
            ...hasGoal ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS
            ] : [],
            ...hasProject ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS
            ] : []
        ];
    } else {
        if (licenceStates.serviceDesk === 'ACTIVE') return [
            (0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS,
            (0, $6GljB.L1_MENU_ID).GLOBAL_APP_OPSGENIE,
            ...teamsSupported ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_TEAMS
            ] : [],
            ...hasGoal ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS
            ] : [],
            ...hasProject ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS
            ] : []
        ];
        if (licenceStates.productDiscovery === 'ACTIVE') return [
            ...teamsSupported ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_TEAMS
            ] : [],
            ...hasGoal ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS
            ] : [],
            ...hasProject ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS
            ] : [],
            ...showAssets ? [
                (0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS
            ] : []
        ];
    }
    return [
        ...hasConfluence ? [
            (0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE
        ] : [],
        ...hasLoom ? [
            (0, $6GljB.L1_MENU_ID).GLOBAL_APP_LOOM
        ] : [],
        // Cross-unit Assets fallthrough: include Assets when reachable on a sibling
        // workspace even without a local JSM licence, or when Assets is provisioned /
        // the tenant is Jira Free under `assets-platform-landing-page`. Matches
        // `useLicenseFilterMap`'s fall-through branch.
        ...showAssets ? [
            (0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS
        ] : [],
        ...teamsSupported ? [
            (0, $6GljB.L1_MENU_ID).GLOBAL_APP_TEAMS
        ] : [],
        ...hasGoal ? [
            (0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS
        ] : [],
        ...hasProject ? [
            (0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS
        ] : []
    ];
};
const $3967197ea97fab0e$export$fd101118c122470d = ()=>{
    const $ = (0, $e7boj.c)(4);
    const licenceStates = (0, $eaLDc.useLicenseStates)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $2HuOR.getLicensedProducts)();
        $[0] = t0;
    } else t0 = $[0];
    const products = t0;
    const hasConfluence = !!products[(0, $2HuOR.LICENSED_PRODUCTS).CONFLUENCE];
    const hasLoom = !!products[(0, $2HuOR.LICENSED_PRODUCTS).LOOM];
    const hasProject = !!products[(0, $2HuOR.LICENSED_PRODUCTS).PROJECT] || !!products[(0, $2HuOR.LICENSED_PRODUCTS).TOWNSQUARE];
    const hasGoal = !!products[(0, $2HuOR.LICENSED_PRODUCTS).GOAL] || !!products[(0, $2HuOR.LICENSED_PRODUCTS).TOWNSQUARE];
    const { isVisible: showAssets } = (0, $aieBA.useAssetsSidebarState)();
    let t1;
    if ($[1] !== licenceStates || $[2] !== showAssets) {
        t1 = $3967197ea97fab0e$export$54ab7f38734f4fcb({
            licenceStates: licenceStates,
            hasConfluence: hasConfluence,
            hasLoom: hasLoom,
            hasGoal: hasGoal,
            hasProject: hasProject,
            teamsSupported: true,
            showAssets: showAssets
        });
        $[1] = licenceStates;
        $[2] = showAssets;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};

});


parcelRegister("7UHPj", function(module, exports) {
$parcel$export(module.exports, "ReorderShortcutsContainer", () => $d4012115a215ac57$export$7bd12ce5959bde45);

var $e7boj = parcelRequire("e7boj");

var $dLGYF = parcelRequire("dLGYF");
const $d4012115a215ac57$export$7bd12ce5959bde45 = (t0)=>{
    const $ = (0, $e7boj.c)(3);
    const { shortcutsConfig: shortcutsConfig, appItemsData: appItemsData, children: children } = t0;
    const orderedShortcuts = (0, $dLGYF.useOrderedAppShortcuts)(shortcutsConfig, appItemsData);
    let t1;
    if ($[0] !== children || $[1] !== orderedShortcuts) {
        t1 = children({
            shortcuts: orderedShortcuts
        });
        $[0] = children;
        $[1] = orderedShortcuts;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
$d4012115a215ac57$export$7bd12ce5959bde45.displayName = "ReorderShortcutsContainer";

});
parcelRegister("dLGYF", function(module, exports) {
$parcel$export(module.exports, "useOrderedAppShortcuts", () => $6d32ccee7502d7a5$export$4bb4a114d280c175);

var $e7boj = parcelRequire("e7boj");
const $6d32ccee7502d7a5$export$4bb4a114d280c175 = (shortcuts, appItemsData)=>{
    const $ = (0, $e7boj.c)(7);
    let t0;
    bb0: {
        if (!appItemsData) {
            let t1;
            if ($[0] !== shortcuts) {
                t1 = Object.values(shortcuts);
                $[0] = shortcuts;
                $[1] = t1;
            } else t1 = $[1];
            t0 = t1;
            break bb0;
        }
        let t1;
        if ($[2] !== appItemsData || $[3] !== shortcuts) {
            let t2;
            if ($[5] !== shortcuts) {
                t2 = (acc, value)=>{
                    const config = shortcuts[value.menuId];
                    if (config && value.visible) acc.push(config);
                    return acc;
                };
                $[5] = shortcuts;
                $[6] = t2;
            } else t2 = $[6];
            t1 = appItemsData.reduce(t2, []);
            $[2] = appItemsData;
            $[3] = shortcuts;
            $[4] = t1;
        } else t1 = $[4];
        t0 = t1;
    }
    const orderedShortcuts = t0;
    return orderedShortcuts;
};

});


parcelRegister("bcUWA", function(module, exports) {
$parcel$export(module.exports, "useResolveInvitedAppShortcuts", () => $ddc5ab7be55f48f3$export$e6614be55e8365cd);
$parcel$export(module.exports, "getJiraSsrCookieCacheInstance", () => $ddc5ab7be55f48f3$export$4451d340a4108573);

var $e7boj = parcelRequire("e7boj");

var $gXrrn = parcelRequire("gXrrn");

var $kTLO3 = parcelRequire("kTLO3");

var $i860n = parcelRequire("i860n");

var $3GN2r = parcelRequire("3GN2r");

var $kt86l = parcelRequire("kt86l");

var $614B3 = parcelRequire("614B3");

var $3AgS2 = parcelRequire("3AgS2");
const $ddc5ab7be55f48f3$var$targetProducts = [
    'confluence'
];
const $ddc5ab7be55f48f3$export$e6614be55e8365cd = ()=>{
    const $ = (0, $e7boj.c)(3);
    const cloudId = (0, $kt86l.useCloudId)();
    const userId = (0, $3GN2r.useAccountId)();
    let t0;
    if ($[0] !== cloudId || $[1] !== userId) {
        t0 = (0, $i860n.fg)("twcg-460-personalised-invite-notifications-m2-gate") ? {
            enabled: true,
            sourceProduct: "jira",
            targetProducts: $ddc5ab7be55f48f3$var$targetProducts,
            userId: userId,
            cloudId: cloudId,
            cache: $ddc5ab7be55f48f3$export$4451d340a4108573(),
            fetchTraits: (0, $kTLO3.memoizedFetchSiteUserPersonalization),
            fetchTraitsPolicy: "prefer-cache"
        } : {
            enabled: false
        };
        $[0] = cloudId;
        $[1] = userId;
        $[2] = t0;
    } else t0 = $[2];
    return (0, $3AgS2.useInvitedAppShortcuts)(t0);
};
let $ddc5ab7be55f48f3$var$cache;
const $ddc5ab7be55f48f3$export$4451d340a4108573 = ()=>{
    if (!$ddc5ab7be55f48f3$var$cache) $ddc5ab7be55f48f3$var$cache = new (0, $614B3.InviteAppShortcutsCookieCache)({
        getCookie: $gXrrn.getCookie
    });
    return $ddc5ab7be55f48f3$var$cache;
};

});
parcelRegister("614B3", function(module, exports) {
$parcel$export(module.exports, "InviteAppShortcutsCookieCache", () => $0ae1fd655d7dc7a8$export$7bddb475c47d45d);

var $fg6Qq = parcelRequire("fg6Qq");
var $37LBQ = parcelRequire("37LBQ");
var $hgR5s = parcelRequire("hgR5s");
var $ki0KH = parcelRequire("ki0KH");

var $5V6yk = parcelRequire("5V6yk");
const $0ae1fd655d7dc7a8$var$cacheKey = 'invitedAppShortcuts';
const $0ae1fd655d7dc7a8$var$localStorageCacheDebugKey = `${$0ae1fd655d7dc7a8$var$cacheKey}Debug`;
class $0ae1fd655d7dc7a8$export$7bddb475c47d45d {
    constructor({ getCookie: getCookie = (0, $37LBQ.getCookie), setCookie: setCookie = (0, $hgR5s.setCookie) } = {}){
        this.lastParsedRawValue = null;
        this.lastParsedState = null;
        this.getCookie = getCookie;
        this.setCookie = setCookie;
    }
    async write(state) {
        if ($0ae1fd655d7dc7a8$var$cacheDebugMode() === 'local-storage') {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage[$0ae1fd655d7dc7a8$var$cacheKey] = JSON.stringify(state);
            return true;
        }
        const result = await this.setCookie($0ae1fd655d7dc7a8$var$cacheKey, JSON.stringify(state), {
            expires: new Date(Date.now() + (0, $5V6yk.getConfig)().CACHE_TIME_UNTIL_EXPIRY),
            sameSite: 'strict'
        });
        return result === true || result === (0, $ki0KH.Status).SUCCESS;
    }
    read({ ssr: ssr }) {
        const throwOnError = ssr;
        if ($0ae1fd655d7dc7a8$var$cacheDebugMode() === 'local-storage') {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            if (localStorage?.[$0ae1fd655d7dc7a8$var$cacheKey]) // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            return this.parseCachedState({
                rawValue: localStorage[$0ae1fd655d7dc7a8$var$cacheKey],
                throwOnError: throwOnError
            });
        } else {
            const cookieValueString = this.getCookie($0ae1fd655d7dc7a8$var$cacheKey, ssr);
            if (cookieValueString) return this.parseCachedState({
                rawValue: cookieValueString,
                throwOnError: throwOnError
            });
        }
        return null;
    }
    parseCachedState({ rawValue: rawValue, throwOnError: throwOnError }) {
        // Reuse parsed state for identical cookie/localStorage payloads during the same render lifecycle.
        if (this.lastParsedRawValue === rawValue) return this.lastParsedState;
        try {
            const decoded = $0ae1fd655d7dc7a8$var$isUrlEncodedJson(rawValue) ? decodeURIComponent(rawValue) : rawValue;
            const parsed = JSON.parse(decoded) || null;
            this.lastParsedRawValue = rawValue;
            this.lastParsedState = parsed;
            return parsed;
        } catch (error) {
            if (throwOnError) throw error;
            // Subsequent client reads: swallow parse errors for robustness; treat as cache miss.
            this.lastParsedRawValue = rawValue;
            this.lastParsedState = null;
            return null;
        }
    }
}
$0ae1fd655d7dc7a8$export$7bddb475c47d45d.displayName = "InviteAppShortcutsCookieCache";
const $0ae1fd655d7dc7a8$var$isUrlEncodedJson = (json)=>json && (json.startsWith(`{%22`) || // `{"` with only `"` encoded -- this was value was observed in Confluence
    json.startsWith(`%7B%22`)); // `{"` encoded
const $0ae1fd655d7dc7a8$var$cacheDebugMode = ()=>{
    const debugMode = typeof localStorage !== 'undefined' && localStorage && // Extra safety while we're in the debug-only phase,
    // before we've switched to the proper browser controls (to be removed when that happens).
    // Requires manually setting localStorage.invitedAppShortcutsDebug = "true" in the console
    // to allow our code to write anything into the local storage cache.
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage[$0ae1fd655d7dc7a8$var$localStorageCacheDebugKey];
    if (debugMode === 'cookie-delete') {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage[$0ae1fd655d7dc7a8$var$localStorageCacheDebugKey] = null;
        (0, $fg6Qq.deleteCookie)($0ae1fd655d7dc7a8$var$cacheKey);
    } else if (debugMode && ![
        'null',
        'false'
    ].includes(debugMode)) return 'local-storage';
    return null;
};

});
parcelRegister("ki0KH", function(module, exports) {
$parcel$export(module.exports, "Status", () => $1b454689d2a7b138$export$96e9906d6d93a972);
var $1b454689d2a7b138$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});

});

parcelRegister("5V6yk", function(module, exports) {
$parcel$export(module.exports, "getConfig", () => $8c42189ef12ac072$export$44487a86467333c3);
/**
 * This config setup allows us to debug/QA the experience by adjusting
 * some settings via localStorage overrides.
 *
 * Otherwise, we'd have to wait for days to observe cache expiry/refresh behavior,
 * and in-source-product minimum activity times.
 */ const $8c42189ef12ac072$export$44487a86467333c3 = ()=>$8c42189ef12ac072$var$CONSTANTS_AS_DEBUGGABLE_GETTERS;
const $8c42189ef12ac072$var$timespan = ({ days: days = 0, minutes: minutes = 0, seconds: seconds = 0 })=>((days * 1440 + minutes) * 60 + seconds) * 1000;
const $8c42189ef12ac072$var$CONSTANTS = {
    TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE: $8c42189ef12ac072$var$timespan({
        days: 3
    }),
    /**
	 * When the customer visits after this time since we last wrote data to the cache,
	 * we'll refresh the cache: refetch the required data.
	 */ CACHE_TIME_UNTIL_REFRESH: $8c42189ef12ac072$var$timespan({
        days: 7
    }),
    /**
	 * When the customer visits after this time since we last wrote data to the cache,
	 * we'll consider the cache expired and invalid, and not eligible to see the experiment
	 * (the user will not see the treatment on that visit).
	 * We will refresh the cache at that time, but even if that comes back as eligible,
	 * it will only affect future visits.
	 */ CACHE_TIME_UNTIL_EXPIRY: $8c42189ef12ac072$var$timespan({
        days: 10
    })
};
const $8c42189ef12ac072$var$CONSTANTS_AS_DEBUGGABLE_GETTERS = {
    get TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE () {
        return $8c42189ef12ac072$var$getDebuggableTiming('TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE');
    },
    get CACHE_TIME_UNTIL_REFRESH () {
        return $8c42189ef12ac072$var$getDebuggableTiming('CACHE_TIME_UNTIL_REFRESH');
    },
    get CACHE_TIME_UNTIL_EXPIRY () {
        return $8c42189ef12ac072$var$getDebuggableTiming('CACHE_TIME_UNTIL_EXPIRY');
    }
};
function $8c42189ef12ac072$var$getDebuggableTiming(key) {
    if (typeof localStorage !== 'undefined' && localStorage) {
        const debugLocalStorageKey = `invitedAppShortcutsDebug_${key}_seconds`;
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const overrideValue = parseInt(localStorage[debugLocalStorageKey], 10);
        if (typeof overrideValue === 'number' && overrideValue >= 0) return $8c42189ef12ac072$var$timespan({
            seconds: overrideValue
        });
    }
    return $8c42189ef12ac072$var$CONSTANTS[key];
}

});


parcelRegister("3AgS2", function(module, exports) {
$parcel$export(module.exports, "useInvitedAppShortcuts", () => $052882f1439b8c04$export$c2e2a02c27ed0bc1);

var $euxye = parcelRequire("euxye");

var $eHYqk = parcelRequire("eHYqk");

var $kDLwA = parcelRequire("kDLwA");

var $k7ixb = parcelRequire("k7ixb");

var $eF3pr = parcelRequire("eF3pr");

var $1pEtq = parcelRequire("1pEtq");

var $b3aB4 = parcelRequire("b3aB4");

var $5WmvJ = parcelRequire("5WmvJ");
const $052882f1439b8c04$export$c2e2a02c27ed0bc1 = (input)=>{
    const { enabled: enabled, sourceProduct: sourceProduct, targetProducts: targetProducts, cloudId: cloudId, userId: userId, cache: cache, onCacheNeedsRefresh: onCacheNeedsRefresh } = input;
    const mode = input.mode ?? 'experiment';
    // Productionisation-only field; safe to read because the discriminated union
    // guarantees it is present when `mode === 'productionisation'` and `enabled`.
    const recommendedApps = enabled && input.mode === 'productionisation' ? input.recommendedApps : [];
    // Experiment-only fields; ignored in productionisation mode.
    const traitsArg = enabled && input.mode !== 'productionisation' ? input.traits : undefined;
    const fetchTraits = enabled && input.mode !== 'productionisation' ? input.fetchTraits : undefined;
    const fetchTraitsPolicy = enabled && input.mode !== 'productionisation' ? input.fetchTraitsPolicy : undefined;
    // In productionisation mode, reads and state changes are suppressed
    // (eligibility is delegated to `InvitedAppShortcutsRecommendationsProvider`).
    // Cache writes still flow through; see the JSDoc on `UseInvitedAppShortcutsMode`.
    const isProductionisation = enabled && mode === 'productionisation';
    // This implementation prioritizes performance: avoiding re-renders and state updates.
    // That's why it doesn't have dynamic React state at all.
    const analytics = (0, $k7ixb.useInvitedAppAnalytics)();
    const canWriteToCache = (0, $5WmvJ.useCanWriteToCache)();
    /**
	 * Stores traits fetch status.
	 *
	 * Resolved from props: either directly from `traits` or from `fetchTraits`.
	 */ const traitsDeferredRef = (0, $euxye.useRef)(// Memoize initial ref value to compute it only once:
    (0, $euxye.useMemo)(()=>{
        let resolve;
        const promise = new Promise((res)=>{
            resolve = res;
        });
        return {
            promise: promise,
            resolve: resolve,
            status: 'initial'
        };
    }, []));
    /**
	 * A lock preventing duplicate cache refreshes.
	 */ const isCacheRefreshLockedRef = (0, $euxye.useRef)(false);
    const lostAccessTimeoutRef = (0, $euxye.useRef)(null);
    /**
	 * Main read used to resolve the returned eligibility.
	 *
	 * Read only once, and then stable (non-reactive), ensured by useState with a functional initializer.
	 *
	 * In `mode: 'productionisation'`, eligibility is derived from the
	 * caller-supplied `recommendedApps` (typically produced by
	 * `InvitedAppShortcutsRecommendationsProvider`). The cookie cache is not
	 * consulted; consumers see a populated `invitedApps` map directly.
	 *
	 * In `mode: 'experiment'`, eligibility is read from the cookie cache as before.
	 */ const [cached] = (0, $euxye.useState)(()=>{
        if (!enabled) return {
            eligibility: (0, $b3aB4.ineligible)((0, $eF3pr.IneligibilityReason).EXPERIMENT_OFF)
        };
        if (mode === 'productionisation') return (0, $b3aB4.resolveFromRecommendations)({
            recommendedApps: recommendedApps
        });
        try {
            return (0, $b3aB4.resolveFromCache)({
                sourceProduct: sourceProduct,
                targetProducts: targetProducts,
                cache: cache,
                userId: userId
            });
        // eslint-disable-next-line no-unused-vars
        } catch (_ignoredError) {
            return {
                eligibility: (0, $b3aB4.ineligible)((0, $eF3pr.IneligibilityReason).ERROR)
            };
        }
    });
    /**
	 * Synchronize traits state with the supplied traits arg.
	 *
	 * This arg is passed by Confluence, based on a Confluence GraphQL query. The query
	 * is initially skipped. It stops being skipped when our hook calls `onCacheNeedsRefresh`,
	 * which it does only when it decides that the cache needs a refresh.
	 *
	 * Skipped in `mode: 'productionisation'` — traits feed the legacy
	 * eligibility resolver, which is not run in that mode.
	 *
	 * This effect should be removed when tidying up the A/A test for productionisation
	 */ (0, $euxye.useEffect)(()=>{
        if (enabled && !isProductionisation && traitsArg && traitsDeferredRef.current.status === 'initial') {
            traitsDeferredRef.current.resolve(traitsArg);
            traitsDeferredRef.current.status = 'fulfilled';
        }
    }, [
        enabled,
        isProductionisation,
        traitsArg
    ]);
    /**
	 * Fire analytics when the user is ineligible
	 *
	 * Skipped in `mode: 'productionisation'` because we did not check
	 * eligibility ourselves — firing this event would be misleading.
	 *
	 * This effect should be removed when tidying up the A/A test for productionisation
	 */ (0, $euxye.useEffect)(()=>{
        if (enabled && !isProductionisation && cached.eligibility.ineligibilityReason) analytics.fireInvitedAppShortcutsEligibilityChecked({
            ineligibilityReason: cached.eligibility.ineligibilityReason,
            userId: userId,
            cloudId: cloudId
        });
    }, [
        enabled,
        isProductionisation,
        cached.eligibility.ineligibilityReason,
        analytics,
        userId,
        cloudId
    ]);
    /**
	 * Clear lost access analytics timeout on unmount
	 */ (0, $euxye.useEffect)(()=>()=>{
            if (lostAccessTimeoutRef.current) clearTimeout(lostAccessTimeoutRef.current);
        }, []);
    return (0, $euxye.useMemo)(()=>{
        const updateFromDynamicEligibility = async ({ access: access, visibility: visibility })=>{
            if (!enabled || !userId) return;
            await (0, $b3aB4.updateAccessAndVisibility)({
                access: access ?? {},
                visibility: visibility,
                cache: cache
            });
            if (access === undefined) return;
            maybeFireLostAccessAnalytics(access);
            await $052882f1439b8c04$var$maybeRefreshEligibility({
                access: access,
                visibility: visibility,
                cache: cache,
                sourceProduct: sourceProduct,
                targetProducts: targetProducts,
                traitsDeferred: traitsDeferredRef.current,
                obtainRefreshLock: obtainRefreshLock,
                userId: userId,
                cloudId: cloudId,
                cached: cached,
                canWriteToCache: canWriteToCache,
                onCacheNeedsRefresh: onCacheNeedsRefresh,
                fetchTraits: fetchTraits,
                fetchTraitsPolicy: fetchTraitsPolicy,
                analytics: analytics
            });
        };
        /*
		 * Fire telemetry in the rare case when we returned cached eligibility,
		 * but then we learn that user lost access to the eligible target product(s).
		 *
		 * Do it after a timeout because we might receive multiple dynamic eligibility
		 * updates, and initial ones might happen when not all of the data is loaded,
		 * which could be indistinguishable from "no access" and lead to false positives.
		 * If, during the timeout delay, we get an update indicating that the user has access
		 * after all, we clear the timeout.
		 */ const maybeFireLostAccessAnalytics = (access)=>{
            const lostAccess = lostAccessToAnyEligibleTargetProduct(access);
            if (lostAccess && lostAccessTimeoutRef.current === null) lostAccessTimeoutRef.current = setTimeout(()=>{
                analytics.fireAppAccessRemoved({
                    targetApps: getEligibleInvitedApps().filter((app)=>access[app] === false)
                });
            }, (0, $eF3pr.LOST_ACCESS_CHECK_DEBOUNCE_TIMEOUT));
            else if (!lostAccess && lostAccessTimeoutRef.current) clearTimeout(lostAccessTimeoutRef.current);
        };
        const lostAccessToAnyEligibleTargetProduct = (access)=>{
            const eligibleInvitedApps = getEligibleInvitedApps();
            return eligibleInvitedApps.some((app)=>access[app] === false);
        };
        /**
		 * One-way lock only (no ability to unlock) because we want to make sure we only
		 * do a deep cache refresh once.
		 */ const obtainRefreshLock = ()=>{
            if (isCacheRefreshLockedRef.current) return false;
            isCacheRefreshLockedRef.current = true;
            return true;
        };
        const getEligibleInvitedApps = ()=>Object.keys(cached.eligibility.invitedApps || {}).filter((appName)=>cached.eligibility.invitedApps?.[appName]?.eligible);
        return {
            ...cached.eligibility,
            /**
			 * Call this function when BFF yields a new version of the `getFilteredProductLinks` function.
			 *
			 * It will update our eligibility cache based on app access info from the BFF,
			 * using that filter function.
			 *
			 * Depending on where you're calling the hook from (legacy GAS Nav or new GSN Nav), and the data available,
			 * call EITHER `updateFromAppAccessFilter` OR `updateFromHydratedShortcuts`.
			 *
			 * This function should be removed when tidying up the A/A test for productionisation
			 */ updateFromAppAccessFilter: ({ getFilteredProductLinks: getFilteredProductLinks, limitToOnlyApsKeys: limitToOnlyApsKeys, visibleMenuIds: visibleMenuIds })=>{
                // Active in both modes — the cookie cache is kept warm as
                // a fallback against cohort flips / gate-off.
                if (!enabled) return;
                const access = (0, $b3aB4.getAppAccessFromProductLinksFilter)({
                    getFilteredProductLinks: getFilteredProductLinks,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                const visibility = (0, $b3aB4.getVisibilityFromVisibleMenuIds)({
                    visibleMenuIds: visibleMenuIds,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                updateFromDynamicEligibility({
                    access: access,
                    visibility: visibility
                });
            },
            /**
			 * Call this function when BFF yields a new version of the `getFilteredProductLinks` function.
			 *
			 * It will update our eligibility cache based on app access info from the BFF,
			 * using that filter function.
			 *
			 * Depending on where you're calling the hook from (legacy GAS Nav or new GSN Nav), and the data available,
			 * call EITHER `updateFromAppAccessFilter` OR `updateFromHydratedShortcuts`.
			 *
			 * This function should be removed when tidying up the A/A test for productionisation
			 */ updateFromHydratedShortcuts: ({ shortcuts: shortcuts, limitToOnlyApsKeys: limitToOnlyApsKeys, visibleMenuIds: visibleMenuIds })=>{
                // Active in both modes — see `updateFromAppAccessFilter`.
                if (!enabled) return;
                const access = (0, $b3aB4.getAppAccessFromShortcuts)({
                    shortcuts: shortcuts,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                const visibility = (0, $b3aB4.getVisibilityFromVisibleMenuIds)({
                    visibleMenuIds: visibleMenuIds,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                updateFromDynamicEligibility({
                    access: access,
                    visibility: visibility
                });
            },
            /**
			 * This function should be removed when tidying up the A/A test for productionisation
			 */ updateHydratedProductLinks: (productLinks)=>{
                // Active in both modes — see `updateFromHydratedShortcuts`.
                if (!enabled) return;
                (0, $b3aB4.updateHydratedProductLinks)({
                    productLinks: productLinks,
                    cache: cache
                });
            },
            /**
			 * This function should be removed when tidying up the A/A test for productionisation
			 */ getCachedProductLinks: ()=>{
                // No-op in `mode: 'productionisation'` — callers should read
                // product links from the Relay store seeded by
                // `InvitedAppShortcutsRecommendationsProvider`.
                if (!enabled || isProductionisation) return {};
                return (0, $b3aB4.getCachedProductLinks)({
                    cache: cache
                });
            },
            /**
			 * Call when the user has seen our invited app shortcut in the UI.
			 *
			 * Adds `firstImpressionAt` info to the cache. UI reads that to only
			 * show the `Invited` lozenge animation once (when there hasn't been
			 * a previous impression).
			 *
			 * This function should be removed when tidying up the A/A test for productionisation
			 */ registerImpression: ({ products: products = getEligibleInvitedApps() } = {})=>{
                // Active in both modes — see `updateFromHydratedShortcuts`.
                if (enabled) (0, $b3aB4.updateFirstImpression)({
                    productsSeen: products,
                    cache: cache
                });
            },
            /**
			 * Call when the user converted, i.e. clicked on our invited app shortcut
			 * and went on to activate in the target product.
			 *
			 * Used to mark the user as ineligible so that the treatment does not
			 * show up on the next visit, without having to wait for cache to expire.
			 *
			 * Active in both modes — the cookie cache is kept warm as a
			 * fallback against cohort flips / gate-off.
			 *
			 * This function should be removed when tidying up the A/A test for
			 * productionisation.
			 */ registerActivation: (product)=>{
                if (enabled) (0, $b3aB4.updateActivation)({
                    product: product,
                    cache: cache
                });
            },
            /**
			 * Fire exposure analytics (when the user is eligible).
			 */ fireFeatureExposed: (input)=>{
                if (enabled) analytics.fireFeatureExposed({
                    ...input,
                    userId: userId,
                    cloudId: cloudId,
                    mode: input.overrideMode ?? mode
                });
            }
        };
    }, [
        cache,
        cached,
        enabled,
        isProductionisation,
        mode,
        userId,
        cloudId,
        sourceProduct,
        targetProducts,
        canWriteToCache,
        onCacheNeedsRefresh,
        fetchTraits,
        fetchTraitsPolicy,
        analytics
    ]);
};
/**
 * Main cache refresh flow.
 *
 * Triggers a deep cache refresh (fetch traits, collaborators), but only if
 * access/eligibility prefilters indicate possible eligibility, and cache is empty
 * or needs refresh.
 */ async function $052882f1439b8c04$var$maybeRefreshEligibility({ traitsDeferred: traitsDeferred, analytics: analytics, visibility: visibility, access: access, sourceProduct: sourceProduct, targetProducts: targetProducts, userId: userId, cloudId: cloudId, cache: cache, cached: cached, canWriteToCache: canWriteToCache, onCacheNeedsRefresh: onCacheNeedsRefresh, obtainRefreshLock: obtainRefreshLock, fetchTraits: fetchTraits, fetchTraitsPolicy: fetchTraitsPolicy }) {
    if ((0, $b3aB4.anyTargetProductEligible)({
        targetProducts: targetProducts,
        sourceProduct: sourceProduct,
        dynamicEligibility: {
            visibility: visibility,
            access: access
        }
    })) {
        const cacheNeedsRefresh = doesCacheNeedRefresh();
        // XXX: The 'always-fetch' check was kept here to avoid runtime code changes before QA.
        // But we removed 'always-fetch' from the set of allowed values of fetchTraitsPolicy,
        // because it was dangerous: using it would put unnaceptable load on CollabGraph,
        // even though could be okay for Traits (because Traits are memoized in Jira & already fetched
        // by other experiences). The problem is that fetching collaborators is currently
        // coupled to fetching traits, and 'always-fetch' would also trigger fetching collaborators (!),
        // putting CollabGraph under unnaceptable load.
        // TODO: Remove 'always-fetch' from here, or decouple fetching Collabs from fetching Traits.
        const shouldRefresh = cacheNeedsRefresh || fetchTraits && fetchTraitsPolicy === 'always-fetch';
        if (shouldRefresh && await canWriteToCache({
            cache: cache
        }) && obtainRefreshLock()) {
            if (cacheNeedsRefresh) onCacheNeedsRefresh?.();
            await refreshEligibility();
        }
    }
    function doesCacheNeedRefresh() {
        return cached.eligibility.ineligibilityReason === (0, $eF3pr.IneligibilityReason).CACHE_EMPTY || cached.eligibility.ineligibilityReason === (0, $eF3pr.IneligibilityReason).CACHE_EMPTY_USER_MISMATCH || cached.eligibility.ineligibilityReason === (0, $eF3pr.IneligibilityReason).CACHE_EXPIRED || (0, $b3aB4.isFirstActiveExpiringSoonNeedsRefresh)(cached.state);
    }
    async function refreshEligibility() {
        try {
            const traits = await getTraits();
            const updatedCacheState = await (0, $b3aB4.updateCachedEligibility)({
                traits: traits,
                access: access,
                visibility: visibility,
                userId: userId,
                cache: cache
            });
            const updatedEligibility = (0, $b3aB4.resolveExperimentDetails)({
                sourceProduct: sourceProduct,
                targetProducts: targetProducts
            }, updatedCacheState);
            const willNowBeEligible = updatedEligibility.ineligibilityReason === null;
            if (willNowBeEligible && (0, $1pEtq.expVal)('twcg-460-personalised-invite-notifications-m2', 'isEnabled', false, {
                fireExperimentExposure: false
            })) {
                const products = (0, $eHYqk.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS);
                const collaboratorsAccess = await getCollaborators({
                    products: products
                });
                (0, $b3aB4.updateCollaborators)({
                    collaboratorsWithProducts: collaboratorsAccess,
                    products: products,
                    cache: cache
                });
            }
            analytics.fireEligibilityUpdateSucceeded({
                sourceApp: sourceProduct,
                targetApps: targetProducts
            });
        } catch (error) {
            analytics.fireEligibilityUpdateFailed({
                sourceApp: sourceProduct,
                targetApps: targetProducts,
                error: error instanceof Error ? error.message : `${error}`
            });
        }
    }
    async function getTraits() {
        if (traitsDeferred.status !== 'initial' || !fetchTraits) return traitsDeferred.promise;
        traitsDeferred.status = 'loading';
        try {
            const traitsPromise = fetchTraits({
                cloudId: cloudId,
                userId: userId
            });
            // Resolving with traitsPromise adopts traitsPromise's fulfillment/rejection:
            traitsDeferred.resolve(traitsPromise);
            const traits = await traitsDeferred.promise;
            traitsDeferred.status = 'fulfilled';
            analytics.fireFetchInvitedAppShortcutsTraitsSucceeded({
                sourceApp: sourceProduct,
                targetApps: targetProducts
            });
            return traits;
        } catch (error) {
            traitsDeferred.status = 'rejected';
            analytics.fireFetchInvitedAppShortcutsTraitsFailed({
                sourceApp: sourceProduct,
                targetApps: targetProducts
            });
            throw error;
        }
    }
    async function getCollaborators({ products: products }) {
        return (0, $kDLwA.getCollaboratorsInProducts)({
            products: products,
            cloudId: cloudId,
            userId: userId
        }).then((collaboratorsAccess)=>{
            analytics.fireFetchCollaboratorsAccessSucceeded({
                sourceApp: sourceProduct,
                targetApps: targetProducts,
                collaborators: collaboratorsAccess.length
            });
            return collaboratorsAccess;
        }).catch((error)=>{
            analytics.fireFetchCollaboratorsAccessFailed({
                sourceApp: sourceProduct,
                targetApps: targetProducts,
                error: error instanceof Error ? error.message : `${error}`
            });
            // fallback to empty collaborators access rather than failing the whole process
            return [];
        });
    }
}

});
parcelRegister("eF3pr", function(module, exports) {
$parcel$export(module.exports, "ProductsInState", () => $34a406e9bc411bd5$export$12e73c04b5fd5da2);
$parcel$export(module.exports, "IneligibilityReason", () => $34a406e9bc411bd5$export$130cf0f0f2a54797);
$parcel$export(module.exports, "CACHE_WRITE_ID_KEY", () => $34a406e9bc411bd5$export$fd93bc3ed8f14580);
$parcel$export(module.exports, "LOST_ACCESS_CHECK_DEBOUNCE_TIMEOUT", () => $34a406e9bc411bd5$export$110c7428ebac4f9a);
$parcel$export(module.exports, "FirstActiveSpecialValues", () => $34a406e9bc411bd5$export$ebd0d23278a50416);

var $eHYqk = parcelRequire("eHYqk");
const $34a406e9bc411bd5$export$12e73c04b5fd5da2 = new Set([
    ...(0, $eHYqk.INVITED_APP_SHORTCUTS_ALLOWED_SOURCE_APPS),
    ...(0, $eHYqk.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS)
]);
const $34a406e9bc411bd5$export$130cf0f0f2a54797 = {
    EXPERIMENT_OFF: 'EXPERIMENT_OFF',
    ERROR: 'ERROR',
    CACHE_EMPTY: 'CACHE_EMPTY',
    CACHE_EMPTY_USER_MISMATCH: 'CACHE_EMPTY_USER_MISMATCH',
    CACHE_EXPIRED: 'CACHE_EXPIRED',
    NO_TARGET_PRODUCTS: 'NO_TARGET_PRODUCTS',
    NO_ACCESS_TO_TARGET_PRODUCTS: 'NO_ACCESS_TO_TARGET_PRODUCTS',
    TARGET_PRODUCTS_NOT_VISIBLE: 'TARGET_PRODUCTS_NOT_VISIBLE',
    TARGET_PRODUCTS_ALL_ACTIVE: 'TARGET_PRODUCTS_ALL_ACTIVE',
    SOURCE_PRODUCT_TOO_NEW: 'SOURCE_PRODUCT_TOO_NEW',
    /**
	 * Returned in `mode: 'productionisation'` when the caller passes an
	 * empty `recommendedApps` array — no target product was recommended.
	 */ NO_RECOMMENDED_APPS: 'NO_RECOMMENDED_APPS'
};
const $34a406e9bc411bd5$export$fd93bc3ed8f14580 = 'updateId';
const $34a406e9bc411bd5$export$110c7428ebac4f9a = 5000;
const $34a406e9bc411bd5$export$ebd0d23278a50416 = {
    NOT_CHECKED: undefined,
    INACTIVE: null
};

});

parcelRegister("1pEtq", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $0f4d1a1104745945$export$9db1624a8af791a4);

var $4LDqh = parcelRequire("4LDqh");
const $0f4d1a1104745945$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue, options = {})=>{
    // If client is not initialized, we return the default value
    if (!(0, $4LDqh.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $4LDqh.default).getExperimentValue(experimentName, experimentParam, defaultValue, options);
    return experimentValue;
};

});

parcelRegister("b3aB4", function(module, exports) {
$parcel$export(module.exports, "resolveFromCache", () => $d46d5afd8ca3db24$export$2331136d2a146e0b);
$parcel$export(module.exports, "ineligible", () => $d46d5afd8ca3db24$export$16cb62545527283a);
$parcel$export(module.exports, "resolveExperimentDetails", () => $d46d5afd8ca3db24$export$6d313cb53294e81);
$parcel$export(module.exports, "resolveFromRecommendations", () => $d46d5afd8ca3db24$export$2f93f852bd951b);
$parcel$export(module.exports, "isFirstActiveExpiringSoonNeedsRefresh", () => $d46d5afd8ca3db24$export$fe1089e917806f3c);
$parcel$export(module.exports, "updateCachedEligibility", () => $d46d5afd8ca3db24$export$b97783bc9c26cb8b);
$parcel$export(module.exports, "anyTargetProductEligible", () => $d46d5afd8ca3db24$export$8788f7a1e6d8fdb0);
$parcel$export(module.exports, "getAppAccessFromProductLinksFilter", () => $d46d5afd8ca3db24$export$8ec65f29d950d5d3);
$parcel$export(module.exports, "getAppAccessFromShortcuts", () => $d46d5afd8ca3db24$export$ef01d2a4fe4032bb);
$parcel$export(module.exports, "getVisibilityFromVisibleMenuIds", () => $d46d5afd8ca3db24$export$a8f7dcbfec997a77);
$parcel$export(module.exports, "updateAccessAndVisibility", () => $d46d5afd8ca3db24$export$1c471c34a84a4f55);
$parcel$export(module.exports, "updateFirstImpression", () => $d46d5afd8ca3db24$export$e238a4387f5f61d6);
$parcel$export(module.exports, "updateActivation", () => $d46d5afd8ca3db24$export$a3cc74cdee943c7f);
$parcel$export(module.exports, "updateCollaborators", () => $d46d5afd8ca3db24$export$606587d4eb77e23d);
$parcel$export(module.exports, "updateHydratedProductLinks", () => $d46d5afd8ca3db24$export$a0ae147fc3589eac);
$parcel$export(module.exports, "getCachedProductLinks", () => $d46d5afd8ca3db24$export$b58ff4178d893ad6);

var $eHYqk = parcelRequire("eHYqk");

var $hmszZ = parcelRequire("hmszZ");

var $eF3pr = parcelRequire("eF3pr");

var $xQChL = parcelRequire("xQChL");

var $5V6yk = parcelRequire("5V6yk");
const $d46d5afd8ca3db24$export$2331136d2a146e0b = ({ sourceProduct: sourceProduct, targetProducts: targetProducts, userId: userId, cache: cache })=>{
    if (targetProducts.length === 0) return {
        eligibility: $d46d5afd8ca3db24$export$16cb62545527283a((0, $eF3pr.IneligibilityReason).NO_TARGET_PRODUCTS)
    };
    const cached = cache.read({
        ssr: true
    });
    if (userId && cached && cached.uid && userId !== cached.uid) {
        // Extra protection: clear cache asynchronously in the background, ignoring errors.
        // The hook will then fill the cache for the correct, current user.
        Promise.resolve().then(()=>(0, $xQChL.enqueueUpdate)(cache, ()=>({
                    uid: cached.uid
                }))).catch(()=>{});
        return {
            eligibility: $d46d5afd8ca3db24$export$16cb62545527283a((0, $eF3pr.IneligibilityReason).CACHE_EMPTY_USER_MISMATCH)
        };
    }
    if (!(cached && cached.apps)) return {
        eligibility: $d46d5afd8ca3db24$export$16cb62545527283a((0, $eF3pr.IneligibilityReason).CACHE_EMPTY)
    };
    const resolvedDetails = $d46d5afd8ca3db24$export$6d313cb53294e81({
        sourceProduct: sourceProduct,
        targetProducts: targetProducts
    }, cached);
    return {
        eligibility: resolvedDetails,
        state: cached
    };
};
const $d46d5afd8ca3db24$export$6d313cb53294e81 = ({ sourceProduct: sourceProduct, targetProducts: targetProducts, timestamp: timestamp = Date.now() }, cachedState)=>{
    if (targetProducts.length === 0) return $d46d5afd8ca3db24$export$16cb62545527283a((0, $eF3pr.IneligibilityReason).NO_TARGET_PRODUCTS);
    let invitedApps = {};
    let hasAccessToAtLeastOneTarget = null;
    let atLeastOneTargetVisible = null;
    let atLeastOneTargetInactive = false;
    const ignoreVisibility = $d46d5afd8ca3db24$var$shouldIgnoreVisibility({
        sourceProduct: sourceProduct
    });
    for (const targetProduct of targetProducts){
        const cachedApp = cachedState.apps?.[targetProduct];
        if (!cachedApp) continue;
        if (cachedApp.access != null) hasAccessToAtLeastOneTarget = hasAccessToAtLeastOneTarget || cachedApp.access;
        if (cachedApp.visible != null) atLeastOneTargetVisible = atLeastOneTargetVisible || cachedApp.visible;
        if (cachedApp.access && (cachedApp.visible || ignoreVisibility) && cachedApp.firstActive === (0, $eF3pr.FirstActiveSpecialValues).INACTIVE) {
            atLeastOneTargetInactive = true;
            invitedApps[targetProduct] = {
                eligible: true,
                collaborators: Array.from({
                    length: cachedApp.collaboratorCount ?? 0
                }).map((_, index)=>cachedApp.collaboratorDetails?.[index] ?? null),
                firstImpressionAt: cachedApp?.firstImpressionAt ?? null,
                // The legacy cookie-cache path has no server-resolved variant, so it
                // reports `none`. Experiment-mode lozenge treatment stays on the old
                // client-side heuristic, which does not read this field.
                variant: 'none'
            };
        }
    }
    if (hasAccessToAtLeastOneTarget === null || !ignoreVisibility && atLeastOneTargetVisible === null) return $d46d5afd8ca3db24$export$16cb62545527283a((0, $eF3pr.IneligibilityReason).CACHE_EMPTY);
    if (!hasAccessToAtLeastOneTarget) return $d46d5afd8ca3db24$export$16cb62545527283a((0, $eF3pr.IneligibilityReason).NO_ACCESS_TO_TARGET_PRODUCTS);
    if (!atLeastOneTargetVisible && !ignoreVisibility) return $d46d5afd8ca3db24$export$16cb62545527283a((0, $eF3pr.IneligibilityReason).TARGET_PRODUCTS_NOT_VISIBLE);
    if (!cachedState.firstActiveUpdatedTimestamp) return $d46d5afd8ca3db24$export$16cb62545527283a((0, $eF3pr.IneligibilityReason).CACHE_EMPTY);
    if (!(timestamp <= cachedState.firstActiveUpdatedTimestamp + (0, $5V6yk.getConfig)().CACHE_TIME_UNTIL_EXPIRY)) return $d46d5afd8ca3db24$export$16cb62545527283a((0, $eF3pr.IneligibilityReason).CACHE_EXPIRED);
    if (sourceProduct !== 'home') {
        const firstActiveInSourceProduct = cachedState.apps?.[sourceProduct]?.firstActive;
        if (!firstActiveInSourceProduct) return $d46d5afd8ca3db24$export$16cb62545527283a((0, $eF3pr.IneligibilityReason).CACHE_EMPTY);
        if (timestamp - firstActiveInSourceProduct < (0, $5V6yk.getConfig)().TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE) return $d46d5afd8ca3db24$export$16cb62545527283a((0, $eF3pr.IneligibilityReason).SOURCE_PRODUCT_TOO_NEW);
    }
    if (!atLeastOneTargetInactive) return $d46d5afd8ca3db24$export$16cb62545527283a((0, $eF3pr.IneligibilityReason).TARGET_PRODUCTS_ALL_ACTIVE);
    return {
        ineligibilityReason: null,
        invitedApps: invitedApps
    };
};
const $d46d5afd8ca3db24$export$2f93f852bd951b = ({ recommendedApps: recommendedApps })=>{
    if (recommendedApps.length === 0) return {
        eligibility: $d46d5afd8ca3db24$export$16cb62545527283a((0, $eF3pr.IneligibilityReason).NO_RECOMMENDED_APPS)
    };
    const invitedApps = {};
    for (const { product: product, variant: variant } of recommendedApps)invitedApps[product] = {
        eligible: true,
        variant: variant
    };
    return {
        eligibility: {
            ineligibilityReason: null,
            invitedApps: invitedApps
        }
    };
};
const $d46d5afd8ca3db24$export$16cb62545527283a = (reason)=>({
        ineligibilityReason: reason
    });
const $d46d5afd8ca3db24$export$fe1089e917806f3c = (cachedState)=>!cachedState?.firstActiveUpdatedTimestamp || Date.now() > cachedState.firstActiveUpdatedTimestamp + (0, $5V6yk.getConfig)().CACHE_TIME_UNTIL_REFRESH;
const $d46d5afd8ca3db24$export$b97783bc9c26cb8b = async ({ access: accessMap, visibility: visibilityMap, traits: traits, userId: userId, cache: cache })=>(0, $xQChL.enqueueUpdate)(cache, (prev)=>{
        const draft = {
            ...prev,
            uid: userId,
            apps: {
                ...prev?.apps
            }
        };
        const traitsByName = $d46d5afd8ca3db24$var$groupTraitsByName(traits);
        for (const product of (0, $eF3pr.ProductsInState)){
            const appAccess = accessMap[product];
            const appVisibility = visibilityMap[product];
            const traitValue = $d46d5afd8ca3db24$var$getProductFirstActiveTraitValue(product, traitsByName);
            if (traitValue !== $d46d5afd8ca3db24$var$FIRST_ACTIVE_NOT_APPLICABLE) {
                const firstActive = traitValue ? $d46d5afd8ca3db24$export$bca6124add6e242(traitValue) : null;
                const draftApp = {
                    ...draft.apps[product]
                };
                if (firstActive) draftApp.firstActive = firstActive;
                else if (appAccess === true) draftApp.firstActive = (0, $eF3pr.FirstActiveSpecialValues).INACTIVE;
                if (appAccess !== undefined) draftApp.access = appAccess;
                if (appVisibility !== undefined) draftApp.visible = appVisibility;
                draft.apps[product] = draftApp;
            }
        }
        draft.firstActiveUpdatedTimestamp = Date.now();
        return draft;
    });
const $d46d5afd8ca3db24$var$FIRST_ACTIVE_NOT_APPLICABLE = Symbol('FIRST_ACTIVE_NOT_APPLICABLE');
const $d46d5afd8ca3db24$var$getProductFirstActiveTraitValue = (product, traitsByName)=>{
    switch(product){
        case 'jira':
            return traitsByName['jira_first_active'] || traitsByName['jira-software_first_active'];
        case 'confluence':
            return traitsByName['confluence_first_active'];
        case 'home':
            return $d46d5afd8ca3db24$var$FIRST_ACTIVE_NOT_APPLICABLE;
        default:
            product; // Should never get here - handle all products above!
    }
};
const $d46d5afd8ca3db24$var$shouldIgnoreVisibility = ({ sourceProduct: sourceProduct })=>sourceProduct === 'confluence';
const $d46d5afd8ca3db24$export$8788f7a1e6d8fdb0 = ({ sourceProduct: sourceProduct, targetProducts: targetProducts, dynamicEligibility: dynamicEligibility })=>!!dynamicEligibility && targetProducts.some((product)=>dynamicEligibility.access[product] === true && (dynamicEligibility.visibility[product] === true || $d46d5afd8ca3db24$var$shouldIgnoreVisibility({
            sourceProduct: sourceProduct
        })));
const $d46d5afd8ca3db24$export$8ec65f29d950d5d3 = ({ getFilteredProductLinks: getFilteredProductLinks, limitToOnlyApsKeys: limitToOnlyApsKeys = [
    ...(0, $eHYqk.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS)
] })=>{
    const access = {};
    let atLeastOneComplete = false;
    for (const apsKey of limitToOnlyApsKeys){
        const app = (0, $hmszZ.getAppKeyByApsKey)(apsKey);
        const { links: links, status: status } = getFilteredProductLinks(apsKey);
        if (status === 'complete') {
            atLeastOneComplete = true;
            const hasAccess = links.length > 0;
            access[app] = hasAccess;
        }
    }
    return atLeastOneComplete ? access : undefined;
};
const $d46d5afd8ca3db24$var$menuIdToApsKey = {
    // Jira to Confluence
    'jira.sidebar.globalApp.confluence': 'CONFLUENCE',
    // Confluence to Jira
    jiraShortcut: 'JIRA_SOFTWARE'
};
const $d46d5afd8ca3db24$export$ef01d2a4fe4032bb = ({ shortcuts: shortcuts, limitToOnlyApsKeys: limitToOnlyApsKeys = [
    ...(0, $eHYqk.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS)
] })=>{
    const access = Object.values(shortcuts).reduce((acc, shortcut)=>{
        if (shortcut.type === 'link' && shortcut.apsKey) {
            const { apsKey: apsKey, url: url } = shortcut;
            // if the url is valid then we assume the user has access to the product
            if (url && limitToOnlyApsKeys.includes(apsKey)) try {
                const appKey = (0, $hmszZ.getAppKeyByApsKey)(apsKey);
                acc[appKey] = true;
            // eslint-disable-next-line no-unused-vars
            } catch (_) {
            // if fails to get the app key then it's not an allowed app, skip it
            }
        }
        return acc;
    }, {});
    return $d46d5afd8ca3db24$var$applyDefaultsForApsKeys(access, limitToOnlyApsKeys, false);
};
const $d46d5afd8ca3db24$var$applyDefaultsForApsKeys = (appMap, apsKeys, defaultValue)=>{
    const result = {
        ...appMap
    };
    for (let apsKey of apsKeys){
        const app = (0, $hmszZ.getAppKeyByApsKey)(apsKey);
        if (result[app] === undefined) result[app] = defaultValue;
    }
    return result;
};
const $d46d5afd8ca3db24$export$a8f7dcbfec997a77 = ({ visibleMenuIds: visibleMenuIds, limitToOnlyApsKeys: apsKeys = [
    ...(0, $eHYqk.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS)
] })=>{
    const visibleApsKeys = new Set(visibleMenuIds.map((menuId)=>$d46d5afd8ca3db24$var$menuIdToApsKey[menuId]).filter(Boolean));
    const visibilityMap = {};
    for (const apsKey of apsKeys){
        const appKey = (0, $hmszZ.getAppKeyByApsKey)(apsKey);
        visibilityMap[appKey] = visibleApsKeys.has(apsKey);
    }
    return visibilityMap;
};
const $d46d5afd8ca3db24$export$1c471c34a84a4f55 = async ({ access: accessMap, visibility: visibilityMap, cache: cache })=>(0, $xQChL.enqueueUpdate)(cache, (prev)=>{
        let updated = false;
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        for (const app of (0, $eF3pr.ProductsInState)){
            const appAccess = accessMap[app];
            const appVisibility = visibilityMap[app];
            const prevApp = draft.apps[app] ?? {};
            if (appAccess !== undefined && appAccess !== prevApp.access || appVisibility !== undefined && appVisibility !== prevApp.visible) {
                const draftApp = {
                    ...prevApp
                };
                if (appAccess !== undefined) draftApp.access = appAccess;
                if (appVisibility !== undefined) draftApp.visible = appVisibility;
                draft.apps[app] = draftApp;
                updated = true;
            }
        }
        return updated ? draft : null;
    });
const $d46d5afd8ca3db24$export$e238a4387f5f61d6 = async ({ productsSeen: productsSeen, seenTimestamp: seenTimestamp = Date.now(), cache: cache })=>(0, $xQChL.enqueueUpdate)(cache, (prev)=>{
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        let updated = false;
        for (const product of productsSeen){
            const prevApp = draft.apps[product];
            if (!prevApp?.firstImpressionAt) {
                updated = true;
                draft.apps[product] = {
                    ...prevApp,
                    firstImpressionAt: seenTimestamp
                };
            }
        }
        return updated ? draft : null;
    });
const $d46d5afd8ca3db24$export$a3cc74cdee943c7f = async ({ cache: cache, product: product, timestamp: timestamp = Date.now() })=>(0, $xQChL.enqueueUpdate)(cache, (prev)=>{
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        draft.apps[product] = {
            ...draft.apps[product],
            firstActive: timestamp
        };
        return draft;
    });
const $d46d5afd8ca3db24$export$606587d4eb77e23d = async ({ products: products, collaboratorsWithProducts: collaboratorsWithProducts, cache: cache })=>(0, $xQChL.enqueueUpdate)(cache, (prev)=>{
        const collaboratorsByProduct = $d46d5afd8ca3db24$var$groupCollaboratorsByProduct(collaboratorsWithProducts);
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        for (const product of products){
            const collabs = collaboratorsByProduct[product] ?? [];
            draft.apps[product] = {
                ...draft.apps[product],
                // We display:
                // - 1x avatar for 1 collaborator
                // - 2x avatars for exactly 2 collaborators
                // - 1x avatar + number of remaining collaborators for 3+
                // So store exactly as much detailed data as we need to display:
                collaboratorDetails: collabs.slice(0, collabs.length === 2 ? 2 : 1).map((c)=>({
                        avatar: c.avatar
                    })),
                collaboratorCount: collabs.length
            };
        }
        return draft;
    });
const $d46d5afd8ca3db24$export$a0ae147fc3589eac = async ({ productLinks: productLinks, cache: cache })=>(0, $xQChL.enqueueUpdate)(cache, (prev)=>{
        if (Object.keys(productLinks).length === 0) return null;
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        let updated = false;
        for (const product of (0, $eHYqk.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS)){
            const links = productLinks[product];
            if (!links) continue;
            const prevLinks = draft.apps[product]?.productLinks;
            if (!$d46d5afd8ca3db24$var$areProductLinksEqual(prevLinks, links)) {
                draft.apps[product] = {
                    ...draft.apps[product],
                    productLinks: links
                };
                updated = true;
            }
        }
        return updated ? draft : null;
    });
const $d46d5afd8ca3db24$var$areProductLinksEqual = (prevLinks, nextLinks)=>{
    if (!prevLinks) return false;
    if (prevLinks.length !== nextLinks.length) return false;
    const prevUrls = new Set(prevLinks.map((link)=>link?.url ?? ''));
    const nextUrls = new Set(nextLinks.map((link)=>link?.url ?? ''));
    if (prevUrls.size !== nextUrls.size) return false;
    for (const url of prevUrls){
        if (!nextUrls.has(url)) return false;
    }
    return true;
};
/**
 * Get the cached apps from the cache
 * @param cache - The cache to get the apps from
 * @returns The cached apps, or an empty object if the cache is empty or the cookie value is malformed/truncated
 */ const $d46d5afd8ca3db24$var$getCachedApps = ({ cache: cache })=>{
    try {
        const cachedState = cache.read({
            ssr: true
        });
        return cachedState?.apps ?? {};
    } catch  {
        // During SSR, if the cookie value is malformed/truncated, JSON.parse will throw.
        // Catch the error and treat it as a cache miss, returning an empty product links map.
        return {};
    }
};
const $d46d5afd8ca3db24$export$b58ff4178d893ad6 = ({ cache: cache })=>{
    const apps = $d46d5afd8ca3db24$var$getCachedApps({
        cache: cache
    });
    if (Object.keys(apps).length === 0) return {};
    const cachedProductLinks = {};
    for (const product of (0, $eHYqk.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS)){
        const productLinks = apps?.[product]?.productLinks;
        if (productLinks) cachedProductLinks[product] = productLinks;
    }
    return cachedProductLinks;
};
const $d46d5afd8ca3db24$var$groupCollaboratorsByProduct = (collaboratorsWithProducts)=>{
    const result = {};
    for (const cwp of collaboratorsWithProducts)for (const product of cwp.products){
        if (!result[product]) result[product] = [];
        result[product].push(cwp.collaborator);
    }
    return result;
};
const $d46d5afd8ca3db24$var$groupTraitsByName = (traits)=>{
    const traitsByName = {};
    for (const trait of traits)traitsByName[trait.name] = trait.value;
    return traitsByName;
};
const $d46d5afd8ca3db24$export$bca6124add6e242 = (traitValue)=>typeof traitValue === 'string' && +new Date(traitValue) || null;

});
parcelRegister("xQChL", function(module, exports) {
$parcel$export(module.exports, "enqueueUpdate", () => $f6105e38414b15e4$export$3f9c9dc8b61499e9);
/** Serializes every `enqueueUpdate` globally; `lastCommittedStateByCache` still scopes `prev` per cache instance. */ const $f6105e38414b15e4$var$queue = [];
/**
 * Last state successfully persisted per cache, from this module's queue only.
 * `cache.read()` can lag behind `cache.write()` (e.g. async cookies), so sequential
 * updaters must not rely on read() alone for `prev`.
 *
 * Updated only after `cache.write` resolves **true** (confirmed persist). Not updated
 * when the updater returns null/`prev`, when `write` resolves false, on throw from the
 * updater or `write`, or in `catch` below — so failed updates do not advance the chain.
 */ const $f6105e38414b15e4$var$lastCommittedStateByCache = new WeakMap();
const $f6105e38414b15e4$export$3f9c9dc8b61499e9 = (cache, updater)=>{
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    const processUpdate = async ()=>{
        const prev = $f6105e38414b15e4$var$lastCommittedStateByCache.get(cache) ?? cache.read({
            ssr: false
        }) ?? {};
        try {
            const result = updater(prev);
            if (result === null || result === prev) resolve(prev);
            else {
                const writeSucceeded = await cache.write(result);
                if (writeSucceeded) {
                    $f6105e38414b15e4$var$lastCommittedStateByCache.set(cache, result);
                    resolve(result);
                } else // Do not set lastCommittedStateByCache — storage may not match `result`.
                resolve(prev);
            }
        } catch (error) {
            // Do not update lastCommittedStateByCache; queue still advances below.
            reject(error);
        }
        $f6105e38414b15e4$var$queue.shift(); // Remove the processed update
        if ($f6105e38414b15e4$var$queue.length > 0) {
            const nextProcessUpdate = $f6105e38414b15e4$var$queue[0];
            nextProcessUpdate(); // Start the next update, keep it in the queue (blocking) until processed
        }
    };
    $f6105e38414b15e4$var$queue.push(processUpdate);
    if ($f6105e38414b15e4$var$queue.length === 1) processUpdate();
    return promise;
};

});


parcelRegister("5WmvJ", function(module, exports) {
$parcel$export(module.exports, "useCanWriteToCache", () => $fc087e34a6eb8991$export$55467fcd9e2bb73a);

var $euxye = parcelRequire("euxye");

var $eF3pr = parcelRequire("eF3pr");
const $fc087e34a6eb8991$export$55467fcd9e2bb73a = ()=>{
    const canWriteRef = (0, $euxye.useRef)(null);
    return (0, $euxye.useCallback)(async ({ cache: cache })=>{
        if (canWriteRef.current === null) canWriteRef.current = $fc087e34a6eb8991$var$canWriteToCache({
            cache: cache
        });
        return await canWriteRef.current;
    }, []);
};
/**
 * This implementation does retries.
 *
 * Needed because the browser control library's async `setCookie()` function
 * has a bug/limitation when it doesn't correctly wait for the product context
 * to init. If we call the function "too early", it says the cookie is blocked
 * and doesn't do the write, even though once the product context loads,
 * the write would succeed.
 */ const $fc087e34a6eb8991$var$canWriteToCache = async ({ maxRetries: maxRetries = 2, retry: retry = 0, retryDelay: retryDelay = 1000, cache: cache })=>{
    try {
        const initialRead = cache.read({
            ssr: false
        });
        const writtenId = (initialRead?.[0, $eF3pr.CACHE_WRITE_ID_KEY] ?? 0) + 1;
        const writeResult = await cache.write({
            ...initialRead,
            [(0, $eF3pr.CACHE_WRITE_ID_KEY)]: writtenId
        });
        const wroteSuccessfully = writeResult === true && cache.read({
            ssr: false
        })?.[0, $eF3pr.CACHE_WRITE_ID_KEY] === writtenId;
        if (!wroteSuccessfully && retry < maxRetries) {
            await new Promise((resolve)=>setTimeout(resolve, retryDelay));
            return await $fc087e34a6eb8991$var$canWriteToCache({
                retry: retry + 1,
                maxRetries: maxRetries,
                retryDelay: retryDelay,
                cache: cache
            });
        }
        return wroteSuccessfully;
    } catch  {
        return false;
    }
};

});







parcelRegister("eBmB7", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb01acf3c48f9d1d$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $gKzwi = parcelRequire("gKzwi");

const $eb01acf3c48f9d1d$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("hTdlD")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-board/src/ui/main.tsx"
});
const $eb01acf3c48f9d1d$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.board-settings",
        packageName: "jiraNavigationAppsSidebarNav4BoardSettings",
        ufoName: "nav4.sidebar.board-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.board-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gKzwi.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($eb01acf3c48f9d1d$var$LazySidebarContent, null)));
$eb01acf3c48f9d1d$var$AsyncSidebar.displayName = "AsyncSidebar";
const $eb01acf3c48f9d1d$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($eb01acf3c48f9d1d$var$AsyncSidebar);
var $eb01acf3c48f9d1d$export$2e2bcd8739ae039 = $eb01acf3c48f9d1d$var$ExportedComponent;

});
parcelRegister("gKzwi", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $585977a4dc336260$export$8f31e4c4a37b8e9c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6Elhl = parcelRequire("6Elhl");

var $c69sa = parcelRequire("c69sa");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");
const $585977a4dc336260$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $585977a4dc336260$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $585977a4dc336260$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $585977a4dc336260$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $585977a4dc336260$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $585977a4dc336260$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $585977a4dc336260$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $585977a4dc336260$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $585977a4dc336260$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $585977a4dc336260$var$menuItem
    })));
$585977a4dc336260$export$8f31e4c4a37b8e9c.displayName = "Skeleton";
const $585977a4dc336260$var$containerStyles = (0, $fbAgj.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $585977a4dc336260$var$backButton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small'
});
const $585977a4dc336260$var$headingSkeleton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small',
    flex: 1
});
const $585977a4dc336260$var$menuItem = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});

});

parcelRegister("hTdlD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9Ebdo").then(()=>parcelRequire('PpRz1'));

});


parcelRegister("a2U5J", function(module, exports) {
$parcel$export(module.exports, "default", () => $b68d62399d93ff40$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $jT1ry = parcelRequire("jT1ry");

var $k3x0N = parcelRequire("k3x0N");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $b68d62399d93ff40$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("bHnau")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-global-apps/src/ui/main.tsx"
});
const $b68d62399d93ff40$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.apps-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsAppsSettings",
        ufoName: "nav4.sidebar.global-settings.apps-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jT1ry.SidebarContent), {
        currentPageName: "apps",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-apps.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.global-settings.apps-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k3x0N.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b68d62399d93ff40$var$LazySidebarContent, null))));
};
$b68d62399d93ff40$var$AsyncSidebar.displayName = "AsyncSidebar";
const $b68d62399d93ff40$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($b68d62399d93ff40$var$AsyncSidebar);
var $b68d62399d93ff40$export$2e2bcd8739ae039 = $b68d62399d93ff40$var$ExportedComponent;

});
parcelRegister("jT1ry", function(module, exports) {
$parcel$export(module.exports, "SidebarContent", () => $b937b6b7ef65c6a1$export$49e8f7b58a4df4ea);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $2iotI = parcelRequire("2iotI");

var $c69sa = parcelRequire("c69sa");

var $2BUXh = parcelRequire("2BUXh");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");

var $kYJqR = parcelRequire("kYJqR");

var $djYhH = parcelRequire("djYhH");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $a8EUd = parcelRequire("a8EUd");

var $fTOb9 = parcelRequire("fTOb9");

var $j1hZS = parcelRequire("j1hZS");

var $5ECiv = parcelRequire("5ECiv");
const $b937b6b7ef65c6a1$var$heading = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.heading",
    defaultMessage: "Jira admin settings"
});
const $b937b6b7ef65c6a1$export$49e8f7b58a4df4ea = ({ children: children, currentPageName: currentPageName, testId: testId = 'navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content' })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kYJqR.SideNavHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.200",
        xcss: $b937b6b7ef65c6a1$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2BUXh.default), {
        alignBlock: "center",
        grow: "hug",
        space: "space.100",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content.header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fTOb9.BackButton), null), (0, $i860n.fg)('enable_jsm_admin') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.global-settings.heading",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
            xcss: $b937b6b7ef65c6a1$var$headingSkeletonStyles
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5ECiv.SidebarHeading), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "small",
        as: "h2"
    }, formatMessage($b937b6b7ef65c6a1$var$heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j1hZS.AsyncPageSwitcher), {
        currentPageName: currentPageName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kYJqR.SideNavBody), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, children)));
};
$b937b6b7ef65c6a1$export$49e8f7b58a4df4ea.displayName = "SidebarContent";
const $b937b6b7ef65c6a1$var$headingStyles = (0, $fbAgj.xcss)({
    // 4px of left padding is added to align the back icon with the side nav toggle button
    paddingInlineStart: 'space.050'
});
// Shimmer shown while the JSM-admin permission resolves, so the heading never briefly displays the
// wrong title (matches the page switcher's skeleton treatment).
const $b937b6b7ef65c6a1$var$headingSkeletonStyles = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    width: '120px',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'radius.small'
});

});
parcelRegister("fTOb9", function(module, exports) {
$parcel$export(module.exports, "BackButton", () => $73f08893ca32758e$export$e0d897ee21382f67);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $lMezl = parcelRequire("lMezl");

var $6JMJ2 = parcelRequire("6JMJ2");

var $hZDXn = parcelRequire("hZDXn");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $hmQJh = parcelRequire("hmQJh");
const $73f08893ca32758e$var$tooltip = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.tooltip",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Go back"
});
const $73f08893ca32758e$var$label = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.label",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Navigate back to the previous page"
});
function $73f08893ca32758e$export$e0d897ee21382f67() {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { previousUrl: previousUrl } = (0, $hmQJh.useNavigateBack)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        content: formatMessage($73f08893ca32758e$var$tooltip),
        hideTooltipOnMouseDown: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lMezl.default), {
        href: previousUrl || '',
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6JMJ2))),
        label: formatMessage($73f08893ca32758e$var$label),
        onClick: ()=>{
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
        }
    }));
}
$73f08893ca32758e$export$e0d897ee21382f67.displayName = "BackButton";

});

parcelRegister("j1hZS", function(module, exports) {
$parcel$export(module.exports, "AsyncPageSwitcher", () => $89bbca9ce929bbd1$export$3130bd98029942c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");

var $i860n = parcelRequire("i860n");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $fNgVF = parcelRequire("fNgVF");
const $89bbca9ce929bbd1$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $89bbca9ce929bbd1$var$headingSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $89bbca9ce929bbd1$var$dropdownSkeleton
    }));
$89bbca9ce929bbd1$export$8f31e4c4a37b8e9c.displayName = "Skeleton";

const $89bbca9ce929bbd1$var$LazyPageSwitcher = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("gKvzQ")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-global-common/src/common/ui/page-switcher/main.tsx"
});

const $89bbca9ce929bbd1$var$LazyPageSwitcherWithQuery = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("jucvC")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-global-common/src/common/ui/page-switcher/PageSwitcherWithQuery.tsx"
});
const $89bbca9ce929bbd1$export$3130bd98029942c = ({ currentPageName: currentPageName })=>{
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.global-settings.page-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($89bbca9ce929bbd1$export$8f31e4c4a37b8e9c, null)
    }, !isAdmin && (0, $i860n.fg)('enable_jsm_admin') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($89bbca9ce929bbd1$var$LazyPageSwitcherWithQuery, {
        currentPageName: currentPageName
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($89bbca9ce929bbd1$var$LazyPageSwitcher, {
        currentPageName: currentPageName
    }));
};
$89bbca9ce929bbd1$export$3130bd98029942c.displayName = "AsyncPageSwitcher";
const $89bbca9ce929bbd1$var$headingSkeleton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'radius.small'
});
const $89bbca9ce929bbd1$var$dropdownSkeleton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});

});
parcelRegister("gKvzQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fsN9S").then(()=>parcelRequire('2eFXr'));

});

parcelRegister("jucvC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lga5i").then(()=>parcelRequire('eofRK'));

});


parcelRegister("5ECiv", function(module, exports) {
$parcel$export(module.exports, "SidebarHeading", () => $0dce57d98de576fe$export$801795dd2d9d1bc2);

var $isJT3 = parcelRequire("isJT3");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $2iotI = parcelRequire("2iotI");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $htsFl = parcelRequire("htsFl");

var $4PaLX = parcelRequire("4PaLX");

var $kugnb = parcelRequire("kugnb");
const $0dce57d98de576fe$var$heading = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.heading",
    defaultMessage: "Jira admin settings"
});
const $0dce57d98de576fe$var$jsmAppAdminHeading = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.jsm-app-admin-heading",
    defaultMessage: "App settings"
});
const $0dce57d98de576fe$var$HeadingView = ({ isJsmAppAdmin: isJsmAppAdmin })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "small",
        as: "h2"
    }, formatMessage(isJsmAppAdmin ? $0dce57d98de576fe$var$jsmAppAdminHeading : $0dce57d98de576fe$var$heading));
};
$0dce57d98de576fe$var$HeadingView.displayName = "HeadingView";
const $0dce57d98de576fe$var$SidebarHeadingWithData = ({ queryReference: queryReference })=>{
    const jiraFragment = (0, $kugnb.useSettingsSidebarPermissionRef)(queryReference);
    const jiraData = (0, $n67Vb.useFragment)((0, $isJT3.default), jiraFragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0dce57d98de576fe$var$HeadingView, {
        isJsmAppAdmin: jiraData?.hasJsmAdminAccess === true
    });
};
$0dce57d98de576fe$var$SidebarHeadingWithData.displayName = "SidebarHeadingWithData";
const $0dce57d98de576fe$export$801795dd2d9d1bc2 = ()=>{
    // `suspendWhenLoading` makes this suspend (instead of returning a null reference) while the shared
    // permission resource is still loading. Combined with the <Placeholder> boundary in SidebarContent,
    // this lets the heading resolve during SSR — matching the page switcher — so it renders the correct
    // title in the first paint instead of flickering from the default after hydration.
    const { queryReference: queryReference } = (0, $htsFl.useRelayResource)((0, $4PaLX.nav4SidebarSettingsPageSwitcherResource), {
        suspendWhenLoading: true
    });
    if (queryReference == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0dce57d98de576fe$var$HeadingView, {
        isJsmAppAdmin: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0dce57d98de576fe$var$SidebarHeadingWithData, {
        queryReference: queryReference
    });
};
$0dce57d98de576fe$export$801795dd2d9d1bc2.displayName = "SidebarHeading";

});
parcelRegister("isJT3", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea4a0cf7904c36a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8285308408dbb37ea0a0631c0a9a1e95>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ea4a0cf7904c36a5$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "SidebarHeading_jira",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "hasJsmAdminAccess"
        }
    ],
    "type": "JiraQuery"
};
$ea4a0cf7904c36a5$var$node.hash = "70c016c9c55ec5b845dcf1b13209d267";
var $ea4a0cf7904c36a5$export$2e2bcd8739ae039 = $ea4a0cf7904c36a5$var$node;

});

parcelRegister("kugnb", function(module, exports) {
$parcel$export(module.exports, "useSettingsSidebarPermissionRef", () => $92d28748fc9545cd$export$cba9dd1550b8e869);

var $jj73w = parcelRequire("jj73w");

var $n67Vb = parcelRequire("n67Vb");
const $92d28748fc9545cd$export$54af2f82006027c1 = (0, $jj73w.default);
const $92d28748fc9545cd$export$cba9dd1550b8e869 = (queryReference)=>(0, $n67Vb.usePreloadedQuery)($92d28748fc9545cd$export$54af2f82006027c1, queryReference).jira;

});



parcelRegister("k3x0N", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $07a04cb7c4e25139$export$8f31e4c4a37b8e9c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");
const $07a04cb7c4e25139$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $07a04cb7c4e25139$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $07a04cb7c4e25139$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $07a04cb7c4e25139$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $07a04cb7c4e25139$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $07a04cb7c4e25139$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $07a04cb7c4e25139$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $07a04cb7c4e25139$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $07a04cb7c4e25139$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $07a04cb7c4e25139$var$menuItem
    }));
$07a04cb7c4e25139$export$8f31e4c4a37b8e9c.displayName = "Skeleton";
const $07a04cb7c4e25139$var$sectionHeading = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'radius.small',
    marginTop: 'space.100'
});
const $07a04cb7c4e25139$var$menuItem = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});

});

parcelRegister("bHnau", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5h1uA").then(()=>parcelRequire('4MSPP'));

});


parcelRegister("1aqMC", function(module, exports) {
$parcel$export(module.exports, "default", () => $f77017e3567fbdae$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $jT1ry = parcelRequire("jT1ry");

var $k3x0N = parcelRequire("k3x0N");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $f77017e3567fbdae$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("4Jy0n")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-global-issues/src/ui/main.tsx"
});
const $f77017e3567fbdae$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.issues-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsIssuesSettings",
        ufoName: "nav4.sidebar.global-settings.issues-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jT1ry.SidebarContent), {
        currentPageName: "issues",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-issues.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.global-settings.issues-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k3x0N.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f77017e3567fbdae$var$LazySidebarContent, null))));
};
$f77017e3567fbdae$var$AsyncSidebar.displayName = "AsyncSidebar";
const $f77017e3567fbdae$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($f77017e3567fbdae$var$AsyncSidebar);
var $f77017e3567fbdae$export$2e2bcd8739ae039 = $f77017e3567fbdae$var$ExportedComponent;

});
parcelRegister("4Jy0n", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("huHaF").then(()=>parcelRequire('6IYME'));

});


parcelRegister("c1XB1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "SidebarContentWithRelayResource", () => $4ba6149050ccc7be$export$f9e0a9fab11f158);
$parcel$export(module.exports, "SidebarContentInner", () => $4ba6149050ccc7be$export$a18798f247d81ed3);
$parcel$export(module.exports, "SidebarContentForEntryPoint", () => $4ba6149050ccc7be$export$ece6bd06aa8b2350);
$parcel$export(module.exports, "default", () => $4ba6149050ccc7be$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $chlbQ = parcelRequire("chlbQ");

var $gVkjO = parcelRequire("gVkjO");

var $jT1ry = parcelRequire("jT1ry");

var $k3x0N = parcelRequire("k3x0N");

var $htsFl = parcelRequire("htsFl");

var $7ehYC = parcelRequire("7ehYC");

var $a8EUd = parcelRequire("a8EUd");

var $jSujS = parcelRequire("jSujS");
function $4ba6149050ccc7be$export$f9e0a9fab11f158() {
    const { queryReference: queryReference } = (0, $htsFl.useRelayResource)((0, $chlbQ.nav4SidebarGlobalProductsSettingsResource));
    const queryReferenceRef = (0, $euxye.useRef)(null);
    // We don't want to use null query references. So only remember the non-null ones,
    // and pass the non-null query reference to the children.
    // From Slack: https://atlassian.slack.com/archives/C01E2MPPLE4/p1654736794416059?thread_ts=1654051102.548519&cid=C01E2MPPLE4
    if (queryReference) queryReferenceRef.current = queryReference;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4ba6149050ccc7be$export$a18798f247d81ed3, {
        queryReference: queryReferenceRef.current
    });
}
$4ba6149050ccc7be$export$f9e0a9fab11f158.displayName = "SidebarContentWithRelayResource";
function $4ba6149050ccc7be$export$ece6bd06aa8b2350({ queries: { nav4SidebarGlobalProductsSettings: nav4SidebarGlobalProductsSettings } }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4ba6149050ccc7be$export$a18798f247d81ed3, {
        queryReference: nav4SidebarGlobalProductsSettings
    });
}
$4ba6149050ccc7be$export$ece6bd06aa8b2350.displayName = "SidebarContentForEntryPoint";
function $4ba6149050ccc7be$export$a18798f247d81ed3({ queryReference: queryReference }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.products-settings",
        packageName: "sidebarNav4GlobalProductsSettings",
        ufoName: "nav4.sidebar.global-settings.products-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jT1ry.SidebarContent), {
        currentPageName: "products",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.global-settings.products-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k3x0N.Skeleton), null)
    }, queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jSujS.GlobalProductsSettingsSidebar), {
        queryReference: queryReference
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7ehYC.SidebarReady), null));
}
$4ba6149050ccc7be$export$a18798f247d81ed3.displayName = "SidebarContentInner";
var $4ba6149050ccc7be$export$2e2bcd8739ae039 = $4ba6149050ccc7be$export$ece6bd06aa8b2350;

});
parcelRegister("jSujS", function(module, exports) {
$parcel$export(module.exports, "GlobalProductsSettingsSidebar", () => $ffb32aabf833acfe$export$b53f6a7c7db3c559);

var $cCjMO = parcelRequire("cCjMO");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $dRtPJ = parcelRequire("dRtPJ");

var $k3x0N = parcelRequire("k3x0N");

var $a1Bqx = parcelRequire("a1Bqx");

var $2D2gW = parcelRequire("2D2gW");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $6AWfg = parcelRequire("6AWfg");

var $go0sa = parcelRequire("go0sa");

var $cucS4 = parcelRequire("cucS4");

var $kaxhJ = parcelRequire("kaxhJ");

var $KMWzv = parcelRequire("KMWzv");

var $cEvkX = parcelRequire("cEvkX");

var $6tj9O = parcelRequire("6tj9O");

var $kq3Fo = parcelRequire("kq3Fo");

var $6pxmA = parcelRequire("6pxmA");

var $8M0af = parcelRequire("8M0af");

var $1PXpL = parcelRequire("1PXpL");
const $ffb32aabf833acfe$var$productAccessItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-access-item",
    defaultMessage: "Product access"
});
const $ffb32aabf833acfe$var$productAccessItemAppifyMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-access-item-appify",
    defaultMessage: "App access"
});
const $ffb32aabf833acfe$var$GlobalProductsSettingsSidebarInner = ({ queryReference: queryReference })=>{
    const productAccessItemAppify = (0, $i860n.fg)('product-terminology-refresh') ? $ffb32aabf833acfe$var$productAccessItemAppifyMessage : $ffb32aabf833acfe$var$productAccessItem;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const queryData = (0, $n67Vb.usePreloadedQuery)((0, $cCjMO.default), queryReference);
    const { data: features } = (0, $go0sa.useFeatures)({
        hasJsmAdminAccess: queryData?.jsmAdmin?.hasJsmAdminAccess === true
    });
    if (!features) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k3x0N.Skeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
        name: "products-data-loading"
    }));
    if (features.hasJsmAppAdminOnlyAccess && features.hasServiceManagementSection) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, (0, $i860n.fg)('csm_appification_jira_admin') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1PXpL.default), {
        features: features
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kq3Fo.ServiceManagementSection), {
        features: features
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, features.hasApplicationAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $6AWfg.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'productAccess'
        },
        href: "/secure/admin/ApplicationAccess.jspa",
        target: "_blank",
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))), {
            spacing: "none",
            label: "",
            color: "var(--ds-icon, #292A2E)"
        })
    }, formatMessage(productAccessItemAppify)), features.hasSoftwareSection && features.hasSoftwareConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kaxhJ.default), null), !(features.hasSoftwareSection && features.hasSoftwareConfig) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8M0af.DelegatedAdminJiraSection), {
        queryReference: queryData
    }), features.hasPlansSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cEvkX.default), null), features.hasServiceManagementSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, (0, $i860n.fg)('csm_appification_jira_admin') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1PXpL.default), {
        features: features
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kq3Fo.ServiceManagementSection), {
        features: features,
        queryFragment: queryData
    })), features.hasCustomerServiceSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6pxmA.default), null), features.hasOperationsSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $KMWzv.default), {
        features: features
    }), features.hasProductDiscoverySection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6tj9O.default), null), features.hasIntegrationsSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cucS4.default), {
        features: features
    }));
};
$ffb32aabf833acfe$var$GlobalProductsSettingsSidebarInner.displayName = "GlobalProductsSettingsSidebarInner";
const $ffb32aabf833acfe$export$b53f6a7c7db3c559 = /*#__PURE__*/ (0, $euxye.memo)($ffb32aabf833acfe$var$GlobalProductsSettingsSidebarInner);

});
parcelRegister("6AWfg", function(module, exports) {
$parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", () => $cabd47a2ee9c73d7$export$f21504b774272faa);
/* eslint-disable jira/filename-case */ const $cabd47a2ee9c73d7$export$f21504b774272faa = {
    actionSubjectId: 'globalJiraSettingsNavigationMenuItem',
    componentType: 'fixedItem',
    level: 1,
    settingsGroup: 'products'
};

});

parcelRegister("go0sa", function(module, exports) {
$parcel$export(module.exports, "useFeatures", () => $fccc5a83b12dbb68$export$4a39035bacc4ed76);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");


var $41FAq = parcelRequire("41FAq");

var $4jjTD = parcelRequire("4jjTD");

var $6HvWM = parcelRequire("6HvWM");

var $5mgOF = parcelRequire("5mgOF");

var $j3ksD = parcelRequire("j3ksD");

var $kimlz = parcelRequire("kimlz");

var $ccEzE = parcelRequire("ccEzE");

var $eijVy = parcelRequire("eijVy");

var $i860n = parcelRequire("i860n");

var $l1vE2 = parcelRequire("l1vE2");
var $lRYAe = parcelRequire("lRYAe");

var $2700E = parcelRequire("2700E");
const $fccc5a83b12dbb68$var$isServiceDeskAboveStandard = (serviceDeskEdition)=>serviceDeskEdition !== undefined && serviceDeskEdition !== (0, $d8LhJ.FREE_EDITION) && serviceDeskEdition !== (0, $d8LhJ.STANDARD_EDITION);
const $fccc5a83b12dbb68$var$useFeaturesInternal = ({ hasJsmAdminAccess: hasJsmAdminAccess = false } = {})=>{
    const { data: navigationGlobalResourceData, loading: navigationGlobalResourceLoading, error: navigationGlobalResourceError } = (0, $j3ksD.useNavigationGlobalResource)();
    const { shouldUseJSM: shouldUseJSM, shouldAccessUnlockOperations: shouldAccessUnlockOperations, isTransitioning: isTransitioning, isTransitioned: isTransitioned, loading: ogTenantInfoLoading, error: ogTenantInfoError } = (0, $6HvWM.useOgTenantInfo)();
    const tenantContext = (0, $eijVy.useTenantContext)();
    const appEditions = (0, $ccEzE.useAppEditions)();
    const { hasKeys: hasKeys } = (0, $4jjTD.useApiKeyManagementInfo)();
    // There are two considerations here to prevent flickering in the nav sidebar:
    // 1. When the EOC_TENANT resource (used by `useOgTenantInfo`) fails to fetch from the server,
    // a refetch is triggered *once* from the client. This means that if there is a server-side
    // ogTenantInfoError, we should wait for the client-side refetch to complete before returning
    // a non-null value for `data`.
    // 2. The EOC_CHECK_API_KEY resource (used by `useApiKeyManagementInfo`) is a browser-only
    // resource that is dependent on the EOC_TENANT resource. This means that we shouldn't wait
    // for it to load before rendering the nav sidebar.
    const ogTenantInfoServerError = false ? ogTenantInfoError : null;
    if (navigationGlobalResourceLoading || !navigationGlobalResourceData || ogTenantInfoLoading || ogTenantInfoServerError) return {
        data: null,
        loading: navigationGlobalResourceLoading || ogTenantInfoLoading,
        error: navigationGlobalResourceError || ogTenantInfoServerError
    };
    const hasJsmAboveStandard = Boolean(tenantContext.licensedProducts[0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61]) && $fccc5a83b12dbb68$var$isServiceDeskAboveStandard(appEditions.serviceDesk);
    const hasJsmAppAdminOnlyAccess = !tenantContext.isAdmin && // User is not a Jira admin
    hasJsmAdminAccess; // User has JSM admin permission
    const hasJsmSettingsAdminAccess = tenantContext.isAdmin || hasJsmAppAdminOnlyAccess;
    const hasShiftFromOpsgenieToJira = shouldAccessUnlockOperations;
    const hideFeaturesIsolatedCloud = (0, $lRYAe.isIsolatedCloud)() && !(0, $i860n.fg)('fix_chatops_access_in_isolated_cloud');
    const hasServiceDeskLicense = Boolean(tenantContext.licensedProducts[0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61]);
    const hasChatOpsEnvironmentAccess = (0, $i860n.fg)('aem_nav_global_products') ? (0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-chat-ops') && (!(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-chat-ops-ic-custom-apps') || (0, $i860n.fg)('fix_chatops_access_in_isolated_cloud')) : !(0, $l1vE2.isFedRamp)() && !hideFeaturesIsolatedCloud;
    const hasChatOpsToolAccess = !shouldUseJSM && hasServiceDeskLicense && hasChatOpsEnvironmentAccess;
    return {
        data: {
            hasApiKeyManagementAccess: (isTransitioning || isTransitioned && (0, $i860n.fg)('api_key_management_open_for_transitioned_users')) && shouldUseJSM && hasJsmAboveStandard && tenantContext.isSiteAdmin && hasKeys,
            hasApplicationAccess: (0, $kimlz.hasItemInSidebar)(navigationGlobalResourceData, 'application_access_browser'),
            hasApplicationLinksIntegration: (0, $kimlz.hasItemInSidebar)(navigationGlobalResourceData, 'configure-application-links'),
            hasAuditLogsAccess: (!(0, $i860n.fg)('enable_jsm_admin') || hasJsmSettingsAdminAccess) && shouldUseJSM && !!tenantContext.licensedProducts[0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61],
            hasChatOpsToolAccess: hasChatOpsToolAccess,
            hasCompassPageIntegration: tenantContext.isSiteAdmin && !!tenantContext.licensedProducts[0, $eb8cfa569eede1a9$export$1346c9aa3cbb477d],
            hasConfluencePageIntegration: tenantContext.isAdmin,
            hasCustomerServiceSection: tenantContext.isAdmin && !!tenantContext.licensedProducts[0, $eb8cfa569eede1a9$export$e9c56aa3b027d98f],
            hasDvcsAccountsIntegration: (0, $kimlz.hasItemInSidebar)(navigationGlobalResourceData, 'bitbucket_bulk_repo'),
            hasGlobalIncomingCallAccess: shouldUseJSM && hasJsmAboveStandard,
            hasGlobalIntegrationAccess: shouldUseJSM && hasJsmAboveStandard,
            hasGlobalSyncAccess: shouldUseJSM && hasJsmAboveStandard,
            hasIntegrationsSection: (0, $kimlz.hasItemInSidebar)(navigationGlobalResourceData, 'admin_applications_integrations_section'),
            hasMaintenanceAccess: shouldUseJSM && !!tenantContext.licensedProducts[0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61],
            hasShiftFromOpsgenieToJira: hasShiftFromOpsgenieToJira,
            hasOperationsSection: tenantContext.isAdmin && Boolean(tenantContext.licensedProducts[0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61]) && (hasShiftFromOpsgenieToJira || hasChatOpsToolAccess),
            hasOrganizationsListAccess: !!tenantContext.licensedProducts[0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61] && hasJsmSettingsAdminAccess,
            hasPlansSection: (0, $kimlz.hasItemInSidebar)(navigationGlobalResourceData, 'jpo-ws-main-admin'),
            hasPoliciesAccess: shouldUseJSM && hasJsmAboveStandard,
            hasProductDiscoverySection: tenantContext.isAdmin && appEditions.productDiscovery !== (0, $d8LhJ.UNLICENSED),
            hasRoleBasedNotificationsAccess: shouldUseJSM && tenantContext.isAdmin && hasJsmAboveStandard,
            hasServiceManagementAuthenticationSettings: hasJsmSettingsAdminAccess && appEditions.serviceDesk !== (0, $d8LhJ.UNLICENSED),
            hasServiceManagementConfig: (0, $kimlz.hasItemInSidebar)(navigationGlobalResourceData, 'sd-configuration-link'),
            hasServiceManagementCustomerAccess: hasJsmSettingsAdminAccess && appEditions.serviceDesk !== (0, $d8LhJ.UNLICENSED),
            hasServiceManagementEmailRequests: (0, $kimlz.hasItemInSidebar)(navigationGlobalResourceData, 'sd-admin-mail-info-link'),
            hasServiceManagementIncidentManagementTools: (0, $kimlz.hasItemInSidebar)(navigationGlobalResourceData, 'sd-incident-management-tools-link'),
            hasServiceManagementKbPermissionsAccess: hasJsmSettingsAdminAccess,
            hasServiceManagementSection: hasJsmSettingsAdminAccess && (0, $kimlz.hasItemInSidebar)(navigationGlobalResourceData, 'sd-plugin-admin-section'),
            hasServiceManagementWorkforceSkills: hasJsmSettingsAdminAccess && hasJsmAboveStandard && (0, $i860n.fg)('jsm_wfo_skills'),
            hasSoftwareConfig: tenantContext.isAdmin && (!(0, $2700E.expVal)('sea-3997-hide-jira-global-settings-when-jsm-only', 'isEnabled', false) || !!tenantContext.licensedProducts[0, $eb8cfa569eede1a9$export$1346c9aa3cbb477d]),
            hasSoftwareSection: tenantContext.isAdmin && (!(0, $2700E.expVal)('sea-3997-hide-jira-global-settings-when-jsm-only', 'isEnabled', false) || !!tenantContext.licensedProducts[0, $eb8cfa569eede1a9$export$1346c9aa3cbb477d]),
            hasStatusPageIntegration: !!tenantContext.atlassianAccountId && (0, $kimlz.hasItemInSidebar)(navigationGlobalResourceData, 'jsd-status-page__admin-page'),
            hasJsmAppAdminOnlyAccess: hasJsmAppAdminOnlyAccess
        },
        loading: navigationGlobalResourceLoading,
        error: navigationGlobalResourceError
    };
};
const $fccc5a83b12dbb68$export$4a39035bacc4ed76 = (0, $5mgOF.withThrowOnError)($fccc5a83b12dbb68$var$useFeaturesInternal);

});
parcelRegister("4jjTD", function(module, exports) {
$parcel$export(module.exports, "useApiKeyManagementInfo", () => $48506ff07dc827de$export$19350f4f23ab0aaf);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jyhod = parcelRequire("jyhod");

var $k6ufm = parcelRequire("k6ufm");
const $48506ff07dc827de$export$19350f4f23ab0aaf = ()=>{
    const { loading: loading, error: error, data: data } = (0, $k6ufm.useResource)((0, $jyhod.checkApiKeyManagementKeysResource)());
    return {
        hasKeys: data ?? false,
        loading: loading,
        error: error
    };
};

});

parcelRegister("kimlz", function(module, exports) {
$parcel$export(module.exports, "hasItemInSidebar", () => $ce6dd525edbecc2f$export$57dd40eec4c64521);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $ce6dd525edbecc2f$var$findLink = (arrayOfLinks, legacyId, partialMatch = false)=>{
    if (!Array.isArray(arrayOfLinks)) return undefined;
    for(let i = 0; i < arrayOfLinks.length; i += 1){
        const link = arrayOfLinks[i];
        if (partialMatch && link.id.indexOf(legacyId) === 0) return link;
        if (link.id === legacyId) return link;
        if (link.links) {
            const linkFound = $ce6dd525edbecc2f$var$findLink(link.links, legacyId, partialMatch);
            if (linkFound) return linkFound;
        }
    }
    return undefined;
};
const $ce6dd525edbecc2f$export$f62346e9b1894488 = (sidebarConfig, legacyId, partialMatch = false)=>sidebarConfig && sidebarConfig.product && $ce6dd525edbecc2f$var$findLink(sidebarConfig.product.links, legacyId, partialMatch) || undefined;
const $ce6dd525edbecc2f$export$57dd40eec4c64521 = (sidebarConfig, legacyId, partialMatch)=>Boolean($ce6dd525edbecc2f$export$f62346e9b1894488(sidebarConfig, legacyId, partialMatch));

});


parcelRegister("cucS4", function(module, exports) {
$parcel$export(module.exports, "default", () => $6cf48dbc9e9cca52$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");


var $052eo = parcelRequire("052eo");

var $41FAq = parcelRequire("41FAq");

var $dRtPJ = parcelRequire("dRtPJ");

var $4Onaa = parcelRequire("4Onaa");

var $fS5dR = parcelRequire("fS5dR");

var $lRYAe = parcelRequire("lRYAe");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $djYhH = parcelRequire("djYhH");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $eijVy = parcelRequire("eijVy");

var $i860n = parcelRequire("i860n");

var $472UK = parcelRequire("472UK");
const $6cf48dbc9e9cca52$var$heading = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.heading",
    defaultMessage: "Integrations"
});
const $6cf48dbc9e9cca52$var$applicationLinksItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.application-links-item",
    defaultMessage: "Application links"
});
const $6cf48dbc9e9cca52$var$dvcsAccountsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.dvcs-accounts-item",
    defaultMessage: "DVCS accounts"
});
const $6cf48dbc9e9cca52$var$statuspageItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.statuspage-item",
    defaultMessage: "Statuspage"
});
const $6cf48dbc9e9cca52$var$compassItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.compass-item",
    defaultMessage: "Compass"
});
const $6cf48dbc9e9cca52$var$IntegrationsSection = ({ features: features })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const tenantContext = (0, $eijVy.useTenantContext)();
    const currentRoute = (0, $4Onaa.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), {
        isMenuListItem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($6cf48dbc9e9cca52$var$heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, features.hasApplicationLinksIntegration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $472UK.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'applicationLinks'
        },
        isSelected: currentRoute.name === 'global-settings-products-applinks',
        href: "/plugins/servlet/applinks/listApplicationLinks"
    }, formatMessage($6cf48dbc9e9cca52$var$applicationLinksItem)), features.hasCompassPageIntegration && ((0, $i860n.fg)('aem_nav_global_products') ? (0, $41FAq.isEnvironmentBlockEnabled)('compass') : !(0, $fS5dR.isFedrampModerate)() && !(0, $lRYAe.isIsolatedCloud)()) && (!(0, $i860n.fg)('compass-eos-disable-cross-sell') || tenantContext.licensedProducts[0, $eb8cfa569eede1a9$export$d5e9b613bc4c47f]) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $472UK.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'compass'
        },
        isSelected: currentRoute.name === 'compass-product-settings',
        href: "/jira/settings/products/compass"
    }, formatMessage($6cf48dbc9e9cca52$var$compassItem)), features.hasDvcsAccountsIntegration && !(0, $052eo.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $472UK.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'dvcsAccounts'
        },
        isSelected: currentRoute.name === 'global-settings-products-dvcs',
        href: "/secure/admin/ConfigureDvcsOrganizations!default.jspa"
    }, formatMessage($6cf48dbc9e9cca52$var$dvcsAccountsItem)), features.hasStatusPageIntegration && !!tenantContext.atlassianAccountId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $472UK.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'statuspage'
        },
        isSelected: currentRoute.name === 'global-settings-products-jsd-status',
        href: `/plugins/servlet/ac/jsd-status-page/admin-page?user.key=${tenantContext.atlassianAccountId}&user.id=${tenantContext.atlassianAccountId}`
    }, formatMessage($6cf48dbc9e9cca52$var$statuspageItem))));
};
$6cf48dbc9e9cca52$var$IntegrationsSection.displayName = "IntegrationsSection";
const $6cf48dbc9e9cca52$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($6cf48dbc9e9cca52$var$IntegrationsSection);
var $6cf48dbc9e9cca52$export$2e2bcd8739ae039 = $6cf48dbc9e9cca52$var$ExportedComponent;

});
parcelRegister("052eo", function(module, exports) {
$parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", () => $04c2ab647ff92a62$export$18bfef4995ec57b7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $41FAq = parcelRequire("41FAq");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");
const $04c2ab647ff92a62$export$18bfef4995ec57b7 = ()=>(0, $i860n.fg)('aem_migration_jira') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-software-devops') : (0, $l1vE2.isFedRamp)();

});

parcelRegister("472UK", function(module, exports) {
$parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", () => $d7c731a5b158eeb8$export$f21504b774272faa);
/* eslint-disable jira/filename-case */ 
var $6AWfg = parcelRequire("6AWfg");
const $d7c731a5b158eeb8$export$f21504b774272faa = {
    ...(0, $6AWfg.COMMON_ANALYTICS_ATTRIBUTES),
    section: 'integrations'
};

});


parcelRegister("kaxhJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0033f23b4117b8d3$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $4UGAB = parcelRequire("4UGAB");

var $dRtPJ = parcelRequire("dRtPJ");

var $4Onaa = parcelRequire("4Onaa");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $djYhH = parcelRequire("djYhH");

var $2EFuW = parcelRequire("2EFuW");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $42wGi = parcelRequire("42wGi");
const $0033f23b4117b8d3$var$heading = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.heading",
    defaultMessage: "Jira"
});
const $0033f23b4117b8d3$var$configurationItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.configuration-item",
    defaultMessage: "Jira configuration"
});
const $0033f23b4117b8d3$var$storeManagementItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.store-management-item",
    defaultMessage: "Storage management"
});
const $0033f23b4117b8d3$var$onboardingHubItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.onboarding-hub-item",
    defaultMessage: "Custom onboarding"
});
const $0033f23b4117b8d3$var$newLabel = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.new-label",
    defaultMessage: "New"
});
const $0033f23b4117b8d3$var$premiumLabel = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.premium-label",
    defaultMessage: "Premium"
});
const $0033f23b4117b8d3$var$JiraSection = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const currentRoute = (0, $4Onaa.useCurrentRoute)();
    const isPremium = (0, $4UGAB.useIsPremiumJSW)();
    const customOnboardinLozengeMessage = !isPremium ? $0033f23b4117b8d3$var$premiumLabel : $0033f23b4117b8d3$var$newLabel;
    const shouldShowLozenge = !isPremium || (0, $i860n.fg)('onboarding-hub-new-lozenge');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), {
        isMenuListItem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($0033f23b4117b8d3$var$heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $42wGi.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'jiraConfiguration'
        },
        isSelected: currentRoute.name === 'products-jsw-configuration',
        href: "/jira/settings/products/jira-software-configuration"
    }, formatMessage($0033f23b4117b8d3$var$configurationItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $42wGi.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'storeManagement'
        },
        isSelected: currentRoute.name === 'products-jsw-storage-management',
        href: "/jira/settings/products/jira-software-configuration/storage-management"
    }, formatMessage($0033f23b4117b8d3$var$storeManagementItem)), (0, $i860n.fg)('jira-onboarding-hub-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $42wGi.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'onboardingHub'
        },
        isSelected: [
            'products-onboarding-hub',
            'products-onboarding-hub-create',
            'products-onboarding-hub-edit'
        ].includes(currentRoute.name),
        href: "/jira/settings/products/onboarding",
        elemAfter: shouldShowLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
            appearance: "discovery"
        }, formatMessage(customOnboardinLozengeMessage)) : null
    }, formatMessage($0033f23b4117b8d3$var$onboardingHubItem))));
};
$0033f23b4117b8d3$var$JiraSection.displayName = "JiraSection";
const $0033f23b4117b8d3$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($0033f23b4117b8d3$var$JiraSection);
var $0033f23b4117b8d3$export$2e2bcd8739ae039 = $0033f23b4117b8d3$var$ExportedComponent;

});
parcelRegister("42wGi", function(module, exports) {
$parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", () => $bb45d415efab21cf$export$f21504b774272faa);
/* eslint-disable jira/filename-case */ 
var $6AWfg = parcelRequire("6AWfg");
const $bb45d415efab21cf$export$f21504b774272faa = {
    ...(0, $6AWfg.COMMON_ANALYTICS_ATTRIBUTES),
    section: 'jira'
};

});


parcelRegister("KMWzv", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe72a4e7bde480d4$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $dRtPJ = parcelRequire("dRtPJ");

var $4Onaa = parcelRequire("4Onaa");

var $2EFuW = parcelRequire("2EFuW");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $djYhH = parcelRequire("djYhH");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $jEozp = parcelRequire("jEozp");
const $fe72a4e7bde480d4$var$heading = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.operations-section.heading",
    defaultMessage: "Operations"
});
const $fe72a4e7bde480d4$var$shiftFromOpsgenieToJiraItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.operations-section.shift-from-opsgenie-to-jira-item",
    defaultMessage: "Move from Opsgenie to Jira"
});
const $fe72a4e7bde480d4$var$newLozenge = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.operations-section.new-lozenge",
    defaultMessage: "New"
});
const $fe72a4e7bde480d4$var$chatopsToolsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.operations-section.chatops-tools-item",
    defaultMessage: "Chat and video tools"
});
const $fe72a4e7bde480d4$var$OperationsSection = ({ features: features })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const currentRoute = (0, $4Onaa.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), {
        isMenuListItem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($fe72a4e7bde480d4$var$heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, features?.hasShiftFromOpsgenieToJira && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $jEozp.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'moveFromOpsgenieToJira'
        },
        isSelected: currentRoute.name === 'eoc-unlock-operations',
        href: "/jira/settings/products/ops/unlock",
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
            appearance: "discovery"
        }, formatMessage($fe72a4e7bde480d4$var$newLozenge))
    }, formatMessage($fe72a4e7bde480d4$var$shiftFromOpsgenieToJiraItem)), features?.hasChatOpsToolAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $jEozp.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'jsm-chatops-tools'
        },
        href: "/jira/settings/products/ops/jira-service-management-chatops-and-video-tools",
        isSelected: currentRoute.name === 'products-jsm-chatops-and-videos-tools'
    }, formatMessage($fe72a4e7bde480d4$var$chatopsToolsItem))));
};
$fe72a4e7bde480d4$var$OperationsSection.displayName = "OperationsSection";
const $fe72a4e7bde480d4$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($fe72a4e7bde480d4$var$OperationsSection);
var $fe72a4e7bde480d4$export$2e2bcd8739ae039 = $fe72a4e7bde480d4$var$ExportedComponent;

});
parcelRegister("jEozp", function(module, exports) {
$parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", () => $d2a7f1be781d94ac$export$f21504b774272faa);
/* eslint-disable jira/filename-case */ 
var $6AWfg = parcelRequire("6AWfg");
const $d2a7f1be781d94ac$export$f21504b774272faa = {
    ...(0, $6AWfg.COMMON_ANALYTICS_ATTRIBUTES),
    section: 'operations'
};

});


parcelRegister("cEvkX", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa201634bbceaeb3$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $dRtPJ = parcelRequire("dRtPJ");

var $4Onaa = parcelRequire("4Onaa");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $djYhH = parcelRequire("djYhH");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $auZMT = parcelRequire("auZMT");
const $fa201634bbceaeb3$var$heading = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.heading",
    defaultMessage: "Plans"
});
const $fa201634bbceaeb3$var$permissionsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.permissions-item",
    defaultMessage: "Permissions"
});
const $fa201634bbceaeb3$var$hierarchyItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.hierarchy-item",
    defaultMessage: "Hierarchy configuration"
});
const $fa201634bbceaeb3$var$dependenciesItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.dependencies-item",
    defaultMessage: "Dependencies"
});
const $fa201634bbceaeb3$var$loadingLimitsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.loading-limits-item",
    defaultMessage: "Loading limits"
});
const $fa201634bbceaeb3$var$financialYearItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.financial-year-item",
    defaultMessage: "Financial year"
});
const $fa201634bbceaeb3$var$archiveItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.archive-item",
    defaultMessage: "Archive"
});
const $fa201634bbceaeb3$var$trashedPlansItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.plans-section.trashed-plans-item",
    defaultMessage: "Trash"
});
const $fa201634bbceaeb3$var$PlansSection = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const currentRoute = (0, $4Onaa.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), {
        isMenuListItem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($fa201634bbceaeb3$var$heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $auZMT.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'permissions'
        },
        isSelected: currentRoute.name === 'arj-settings-permissions',
        href: "/jira/plans/settings/permissions"
    }, formatMessage($fa201634bbceaeb3$var$permissionsItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $auZMT.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'hierarchyConfiguration'
        },
        isSelected: currentRoute.name === 'global-settings-issues-hierarchy-view',
        href: "/jira/settings/issues/issue-hierarchy"
    }, formatMessage($fa201634bbceaeb3$var$hierarchyItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $auZMT.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'dependencies'
        },
        isSelected: currentRoute.name === 'arj-settings-dependencies',
        href: "/jira/plans/settings/dependencies"
    }, formatMessage($fa201634bbceaeb3$var$dependenciesItem)), (0, $i860n.fg)('jira_plans_loading_limits_configurability_stsg') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $auZMT.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'loadingLimits'
        },
        isSelected: currentRoute.name === 'arj-settings-loading-limits',
        href: "/jira/plans/settings/loading-limits"
    }, formatMessage($fa201634bbceaeb3$var$loadingLimitsItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $auZMT.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'trash'
        },
        isSelected: currentRoute.name === 'trash-plans-directory',
        href: "/jira/plans/settings/trash"
    }, formatMessage($fa201634bbceaeb3$var$trashedPlansItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $auZMT.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'archive'
        },
        isSelected: currentRoute.name === 'archived-plans-directory',
        href: "/jira/plans/settings/archive"
    }, formatMessage($fa201634bbceaeb3$var$archiveItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $auZMT.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'financialYear'
        },
        isSelected: currentRoute.name === 'arj-settings-financial-year',
        href: "/jira/plans/settings/financial-year"
    }, formatMessage($fa201634bbceaeb3$var$financialYearItem))));
};
$fa201634bbceaeb3$var$PlansSection.displayName = "PlansSection";
const $fa201634bbceaeb3$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($fa201634bbceaeb3$var$PlansSection);
var $fa201634bbceaeb3$export$2e2bcd8739ae039 = $fa201634bbceaeb3$var$ExportedComponent;

});
parcelRegister("auZMT", function(module, exports) {
$parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", () => $7602e7bc4f9a0d3e$export$f21504b774272faa);
/* eslint-disable jira/filename-case */ 
var $6AWfg = parcelRequire("6AWfg");
const $7602e7bc4f9a0d3e$export$f21504b774272faa = {
    ...(0, $6AWfg.COMMON_ANALYTICS_ATTRIBUTES),
    section: 'plans'
};

});


parcelRegister("6tj9O", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2973b584fc6a9bb$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $dRtPJ = parcelRequire("dRtPJ");

var $d8LhJ = parcelRequire("d8LhJ");

var $hJL79 = parcelRequire("hJL79");

var $4Onaa = parcelRequire("4Onaa");

var $2EFuW = parcelRequire("2EFuW");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $djYhH = parcelRequire("djYhH");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $ccEzE = parcelRequire("ccEzE");

var $6wTu7 = parcelRequire("6wTu7");
const $b2973b584fc6a9bb$var$heading = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.heading",
    defaultMessage: "Jira Product Discovery"
});
const $b2973b584fc6a9bb$var$accessItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.access-item",
    defaultMessage: "Access"
});
const $b2973b584fc6a9bb$var$globalFieldsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.global-fields-item",
    defaultMessage: "Global fields"
});
const $b2973b584fc6a9bb$var$globalViewsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.global-views-item",
    defaultMessage: "Global views"
});
const $b2973b584fc6a9bb$var$globalViewsItemNewLozenge = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.global-views-new-lozenge",
    defaultMessage: "New"
});
const $b2973b584fc6a9bb$var$globalViewsItemPremiumLozenge = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.global-views-premium-lozenge",
    defaultMessage: "Premium"
});
const $b2973b584fc6a9bb$var$datesItem = (0, $7eNDO.defineMessage)({
    id: "spa-apps-sidebar-global-settings-products.menu.product-discovery.dates-item",
    defaultMessage: "Dates"
});
const $b2973b584fc6a9bb$var$betaFeaturesItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.beta-features-item",
    defaultMessage: "Beta features"
});
const $b2973b584fc6a9bb$var$useIsPremiumEdition = ()=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    return (0, $d8LhJ.getEdition)((0, $hJL79.JIRA_PRODUCT_DISCOVERY), appEditions) === (0, $d8LhJ.toEdition)((0, $d8LhJ.PREMIUM_EDITION));
};
const $b2973b584fc6a9bb$var$ProductDiscoverySection = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const currentRoute = (0, $4Onaa.useCurrentRoute)();
    const isPremium = $b2973b584fc6a9bb$var$useIsPremiumEdition();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), {
        isMenuListItem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($b2973b584fc6a9bb$var$heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $6wTu7.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'access'
        },
        isSelected: currentRoute.name === 'polaris-settings-access',
        href: "/jira/settings/products/jira-product-discovery/access"
    }, formatMessage($b2973b584fc6a9bb$var$accessItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $6wTu7.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'globalFields'
        },
        isSelected: currentRoute.name === 'polaris-settings-global-fields',
        href: "/jira/settings/products/jira-product-discovery/global-fields"
    }, formatMessage($b2973b584fc6a9bb$var$globalFieldsItem)), (0, $i860n.fg)('polaris_global_views') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $6wTu7.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'globalViews'
        },
        isSelected: currentRoute.name === 'polaris-settings-global-views-list' || currentRoute.name === 'polaris-settings-global-views-details',
        href: "/jira/settings/products/jira-product-discovery/global-views",
        elemAfter: isPremium ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
            appearance: "discovery"
        }, formatMessage($b2973b584fc6a9bb$var$globalViewsItemNewLozenge)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
            appearance: "discovery"
        }, formatMessage($b2973b584fc6a9bb$var$globalViewsItemPremiumLozenge))
    }, formatMessage($b2973b584fc6a9bb$var$globalViewsItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $6wTu7.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'jpdDates'
        },
        isSelected: currentRoute.name === 'polaris-settings-dates',
        href: "/jira/settings/products/jira-product-discovery/dates"
    }, formatMessage($b2973b584fc6a9bb$var$datesItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $6wTu7.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'betaFeatures'
        },
        isSelected: currentRoute.name === 'polaris-settings-early-access-features',
        href: "/jira/settings/products/jira-product-discovery/early-access-features"
    }, formatMessage($b2973b584fc6a9bb$var$betaFeaturesItem))));
};
$b2973b584fc6a9bb$var$ProductDiscoverySection.displayName = "ProductDiscoverySection";
const $b2973b584fc6a9bb$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($b2973b584fc6a9bb$var$ProductDiscoverySection);
var $b2973b584fc6a9bb$export$2e2bcd8739ae039 = $b2973b584fc6a9bb$var$ExportedComponent;

});
parcelRegister("6wTu7", function(module, exports) {
$parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", () => $9020cae2ceaad68a$export$f21504b774272faa);
/* eslint-disable jira/filename-case */ 
var $6AWfg = parcelRequire("6AWfg");
const $9020cae2ceaad68a$export$f21504b774272faa = {
    ...(0, $6AWfg.COMMON_ANALYTICS_ATTRIBUTES),
    section: 'jiraProductDiscovery'
};

});


parcelRegister("kq3Fo", function(module, exports) {
$parcel$export(module.exports, "ServiceManagementSection", () => $d0a6a2a2b5911f6a$export$2324bc215abdb2e5);

var $1CHCJ = parcelRequire("1CHCJ");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $hsTuE = parcelRequire("hsTuE");

var $eBpdw = parcelRequire("eBpdw");

var $6ZLJT = parcelRequire("6ZLJT");

var $kDapy = parcelRequire("kDapy");

var $iL5kN = parcelRequire("iL5kN");

var $dRtPJ = parcelRequire("dRtPJ");

var $4Onaa = parcelRequire("4Onaa");

var $hQxjT = parcelRequire("hQxjT");
var $klGx5 = parcelRequire("klGx5");

var $djYhH = parcelRequire("djYhH");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $l1vE2 = parcelRequire("l1vE2");

var $2HuOR = parcelRequire("2HuOR");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $eijVy = parcelRequire("eijVy");

var $5f2G0 = parcelRequire("5f2G0");
const $d0a6a2a2b5911f6a$var$heading = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.heading",
    defaultMessage: "Jira Service Management"
});
const $d0a6a2a2b5911f6a$var$configurationItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.configuration-item",
    defaultMessage: "Configuration"
});
const $d0a6a2a2b5911f6a$var$complianceSettingsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.compliance-settings-item",
    defaultMessage: "Compliance settings"
});
const $d0a6a2a2b5911f6a$var$emailRequestsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.email-requests-item",
    defaultMessage: "Email requests"
});
const $d0a6a2a2b5911f6a$var$customerAccessItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.customer-access-item",
    defaultMessage: "Customer access"
});
const $d0a6a2a2b5911f6a$var$helpCenterPermissionsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.help-center-permissions-item",
    defaultMessage: "Help center permissions"
});
const $d0a6a2a2b5911f6a$var$incidentManagementItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.incident-management-item",
    defaultMessage: "Incident management"
});
const $d0a6a2a2b5911f6a$var$knowledgeBasePermissionsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.knowledge-base-permissions-item",
    defaultMessage: "Knowledge base permissions"
});
const $d0a6a2a2b5911f6a$var$authenticationItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.authentication-item",
    defaultMessage: "Authentication"
});
const $d0a6a2a2b5911f6a$var$organizationsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.organizations-item",
    defaultMessage: "Organizations"
});
const $d0a6a2a2b5911f6a$var$featureUsageItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.feature-usage-item",
    defaultMessage: "Feature usage"
});
const $d0a6a2a2b5911f6a$var$workforceSkillsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.workforce-skills-item",
    defaultMessage: "Skills directory"
});
const $d0a6a2a2b5911f6a$var$storageManagementItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.storage-management-item",
    defaultMessage: "Storage management"
});
const $d0a6a2a2b5911f6a$var$rovoAiItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.rovo-ai-item",
    defaultMessage: "Rovo"
});
const $d0a6a2a2b5911f6a$var$aiControlsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.ai-controls-item",
    defaultMessage: "Usage"
});
const $d0a6a2a2b5911f6a$var$auditLogsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.ai-governance-audit-logs-item",
    defaultMessage: "Activity"
});
const $d0a6a2a2b5911f6a$var$adminAuditLogItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.audit-log-item",
    defaultMessage: "Audit log"
});
const $d0a6a2a2b5911f6a$var$ROVO_AI_ROUTES = new Set([
    'products-jsm-rovo-ai-usage',
    'products-jsm-rovo-ai-activity'
]);
const $d0a6a2a2b5911f6a$var$useIsFullyExpandedConditional = (0, $6ZLJT.functionUnionWithCondition)(()=>(0, $i860n.fg)('fe_stakeholder_email_templates_in_jsm'), (0, $kDapy.useIsFullyExpanded), ()=>false);
const $d0a6a2a2b5911f6a$var$ServiceManagementSectionInternal = ({ features: features, queryFragment: queryFragment })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const currentRoute = (0, $4Onaa.useCurrentRoute)();
    const { licensedProducts: licensedProducts } = (0, $eijVy.useTenantContext)();
    const queryData = (0, $n67Vb.useFragment)((0, $1CHCJ.default), queryFragment);
    const isFullyExpanded = $d0a6a2a2b5911f6a$var$useIsFullyExpandedConditional();
    const hasConfluence = Boolean(licensedProducts[(0, $2HuOR.LICENSED_PRODUCTS).CONFLUENCE]);
    const hasProjectEnabledWfo = queryData?.agentWorkspace_siteWfoStatus?.hasProjectEnabledWfo ?? false;
    const isOnRovoAiRoute = $d0a6a2a2b5911f6a$var$ROVO_AI_ROUTES.has(currentRoute.name);
    const hasAuditLogsPermission = features.hasAuditLogsAccess;
    const isAuditLogsVisible = (0, $i860n.fg)('enable-rovo-ai-audit-logs-for-jsm') && (!(0, $i860n.fg)('enable_jsm_admin') || hasAuditLogsPermission);
    const incidentManagementServiceDeskMenuItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'incidentManagement'
        },
        isSelected: currentRoute.name === 'products-jsm-incident-management-tools',
        href: "/jira/settings/products/jira-service-management-incident-management-tools"
    }, formatMessage($d0a6a2a2b5911f6a$var$incidentManagementItem));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), {
        isMenuListItem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($d0a6a2a2b5911f6a$var$heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, !(0, $i860n.fg)('csm_appification_jira_admin') && features.hasServiceManagementConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'configuration'
        },
        isSelected: currentRoute.name === 'products-jsm-configuration',
        href: "/jira/settings/products/jira-service-management-configuration"
    }, formatMessage($d0a6a2a2b5911f6a$var$configurationItem)), (0, $2700E.expVal)('jsmgrowth-267_enforce_storage_limits_servco_free', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'storageManagement'
        },
        isSelected: String(currentRoute.name) === 'products-jsm-storage-management',
        href: "/jira/settings/products/jira-service-management-storage-management"
    }, formatMessage($d0a6a2a2b5911f6a$var$storageManagementItem)), ((0, $i860n.fg)('enable-jsm-native-app-ai-capabilities') || isAuditLogsVisible) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hQxjT.ExpandableMenuItem), {
        isDefaultExpanded: isOnRovoAiRoute
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iL5kN.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'rovoAi'
        },
        interactionName: "nav4-global-products-settings-rovo-ai"
    }, formatMessage($d0a6a2a2b5911f6a$var$rovoAiItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klGx5.ExpandableMenuItemContent), null, (0, $i860n.fg)('enable-jsm-native-app-ai-capabilities') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'aiControls'
        },
        isSelected: currentRoute.name === 'products-jsm-rovo-ai-usage',
        href: "/jira/settings/products/jira-service-management-rovo-ai/usage"
    }, formatMessage($d0a6a2a2b5911f6a$var$aiControlsItem)), isAuditLogsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'aiGovernanceAuditLogs'
        },
        isSelected: currentRoute.name === 'products-jsm-rovo-ai-activity',
        href: "/jira/settings/products/jira-service-management-rovo-ai/activity"
    }, formatMessage($d0a6a2a2b5911f6a$var$auditLogsItem)))), !(0, $i860n.fg)('csm_appification_jira_admin') && features.hasServiceManagementEmailRequests && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'emailRequests'
        },
        isSelected: currentRoute.name === 'products-jsm-email-requests',
        href: "/jira/settings/products/jira-service-management-email-requests"
    }, formatMessage($d0a6a2a2b5911f6a$var$emailRequestsItem)), features.hasServiceManagementCustomerAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'customerAccess'
        },
        isSelected: currentRoute.name === 'products-jsm-customer-access',
        href: "/jira/settings/products/servicedesk/customer-access"
    }, formatMessage((0, $i860n.fg)('csm_appification_jira_admin') ? $d0a6a2a2b5911f6a$var$helpCenterPermissionsItem : $d0a6a2a2b5911f6a$var$customerAccessItem)), !(0, $i860n.fg)('csm_appification_jira_admin') && features.hasServiceManagementAuthenticationSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'authentication'
        },
        isSelected: currentRoute.name === 'products-jsm-authentication-settings',
        href: "/jira/settings/products/servicedesk/authentication"
    }, formatMessage($d0a6a2a2b5911f6a$var$authenticationItem)), !(0, $i860n.fg)('csm_appification_jira_admin') && features.hasOrganizationsListAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'organizations'
        },
        isSelected: currentRoute.name === 'products-jsm-organizations',
        href: "/jira/settings/products/servicedesk/organizations"
    }, formatMessage($d0a6a2a2b5911f6a$var$organizationsItem)), features.hasServiceManagementWorkforceSkills && hasProjectEnabledWfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'workforceSkills'
        },
        isSelected: currentRoute.name === 'products-jsm-workforce-skills',
        href: "/jira/settings/products/jira-service-management-workforce-skills"
    }, formatMessage($d0a6a2a2b5911f6a$var$workforceSkillsItem)), features.hasServiceManagementIncidentManagementTools && ((0, $i860n.fg)('fe_stakeholder_email_templates_in_jsm') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hsTuE.default), {
        isFullyExpanded: isFullyExpanded
    }, incidentManagementServiceDeskMenuItem) : incidentManagementServiceDeskMenuItem), !(0, $i860n.fg)('csm_appification_jira_admin') && hasConfluence && features.hasServiceManagementKbPermissionsAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'knowledgeBasePermissions'
        },
        isSelected: currentRoute.name === 'products-jsm-kb-permissions',
        href: "/jira/settings/products/jira-service-management-knowledge-base-permissions"
    }, formatMessage($d0a6a2a2b5911f6a$var$knowledgeBasePermissionsItem)), !(0, $i860n.fg)('csm_appification_jira_admin') && features.hasServiceManagementConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'complianceSettings'
        },
        isSelected: currentRoute.name === 'products-jsm-compliance',
        href: "/jira/settings/products/jira-service-management-compliance"
    }, formatMessage($d0a6a2a2b5911f6a$var$complianceSettingsItem)), ((0, $eBpdw.isCMDBEnabledInEnvironment)() || !(0, $l1vE2.isFedRamp)()) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'featureUsage'
        },
        isSelected: currentRoute.name === 'products-jsm-feature-usage',
        href: "/jira/settings/products/servicedesk/feature-usage"
    }, formatMessage($d0a6a2a2b5911f6a$var$featureUsageItem)), (0, $i860n.fg)('jira_frontend_jsm_admin_audit_log') && (0, $i860n.fg)('enable_jsm_admin') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'auditLog'
        },
        isSelected: currentRoute.name === 'global-settings-products-jsm-audit-logs',
        href: "/jira/settings/products/jira-service-management-audit-logs"
    }, formatMessage($d0a6a2a2b5911f6a$var$adminAuditLogItem))));
};
$d0a6a2a2b5911f6a$var$ServiceManagementSectionInternal.displayName = "ServiceManagementSectionInternal";
const $d0a6a2a2b5911f6a$export$2324bc215abdb2e5 = /*#__PURE__*/ (0, $euxye.memo)($d0a6a2a2b5911f6a$var$ServiceManagementSectionInternal);

});
parcelRegister("1CHCJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $51ea59c7347ac100$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<718b42444c8a677a898f2a8e1dd4f71a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $51ea59c7347ac100$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipSiteWfoStatus"
        }
    ],
    "kind": "Fragment",
    "name": "ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts",
    "selections": [
        {
            "condition": "skipSiteWfoStatus",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "AgentWorkspaceSiteWfoStatus",
                    "kind": "LinkedField",
                    "name": "agentWorkspace_siteWfoStatus",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasProjectEnabledWfo"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasProjectFinishOnboarding"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$51ea59c7347ac100$var$node.hash = "263bbccb65dcc98490c8ac0a16b05950";
var $51ea59c7347ac100$export$2e2bcd8739ae039 = $51ea59c7347ac100$var$node;

});

parcelRegister("hsTuE", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e08f9c7914be75a$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $d8LhJ = parcelRequire("d8LhJ");

var $8jEW8 = parcelRequire("8jEW8");

var $kxDv9 = parcelRequire("kxDv9");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $g5ruf = parcelRequire("g5ruf");

var $ccEzE = parcelRequire("ccEzE");

var $8XKO0 = parcelRequire("8XKO0");
const $4e08f9c7914be75a$var$productSettingsIncidentManagementMenuItemSpotlightHeading = (0, $7eNDO.defineMessage)({
    id: "servicedesk-incident-management-settings.common.ui.setting-menu-onboarding.product-settings-incident-management-menu-item-spotlight-heading",
    defaultMessage: "Save time during incidents with templates"
});
const $4e08f9c7914be75a$var$productSettingsIncidentManagementMenuItemSpotlightDescription = (0, $7eNDO.defineMessage)({
    id: "servicedesk-incident-management-settings.common.ui.setting-menu-onboarding.product-settings-incident-management-menu-item-spotlight-description",
    defaultMessage: "Create and customize email templates to save time and send consistent stakeholder notifications during incidents."
});
const $4e08f9c7914be75a$var$productSettingsIncidentManagementMenuItemSpotlightActionLabel = (0, $7eNDO.defineMessage)({
    id: "servicedesk-incident-management-settings.common.ui.setting-menu-onboarding.product-settings-incident-management-menu-item-spotlight-action-label",
    defaultMessage: "OK"
});
const $4e08f9c7914be75a$var$SPOTLIGHT_KEY = 'jira.servicedesk.incident-management.incident-management-settings.setting-menu-onboarding';
const $4e08f9c7914be75a$var$IncidentManagementProductSettingNavMenuItemOnboarding = ({ children: children, isFullyExpanded: isFullyExpanded })=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    const [isOnboardingActive, setHasSeenOnboarding] = (0, $8XKO0.useHasSeenOnboarding)($4e08f9c7914be75a$var$SPOTLIGHT_KEY);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const hasPremiumServiceDeskAccess = appEditions.serviceDesk === (0, $d8LhJ.PREMIUM_EDITION);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8jEW8.default), {
        name: "jira-servicedesk-incident-management-product-setting-menu-item"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kxDv9.default), null, isOnboardingActive && isFullyExpanded && hasPremiumServiceDeskAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g5ruf.JiraSpotlight), {
        actions: [
            {
                onClick: setHasSeenOnboarding,
                text: formatMessage($4e08f9c7914be75a$var$productSettingsIncidentManagementMenuItemSpotlightActionLabel)
            }
        ],
        heading: formatMessage($4e08f9c7914be75a$var$productSettingsIncidentManagementMenuItemSpotlightHeading),
        target: "jira-servicedesk-incident-management-product-setting-menu-item",
        key: "jira-servicedesk-incident-management-product-setting-menu-item",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        messageType: "engagement",
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: "servicedesk-incident-management-settings.common.ui.setting-menu-onboarding.jira-spotlight.jira-servicedesk-incident-management-product-setting-menu-item",
        dialogPlacement: "right top"
    }, formatMessage($4e08f9c7914be75a$var$productSettingsIncidentManagementMenuItemSpotlightDescription))));
};
$4e08f9c7914be75a$var$IncidentManagementProductSettingNavMenuItemOnboarding.displayName = "IncidentManagementProductSettingNavMenuItemOnboarding";
var $4e08f9c7914be75a$export$2e2bcd8739ae039 = $4e08f9c7914be75a$var$IncidentManagementProductSettingNavMenuItemOnboarding;

});
parcelRegister("8XKO0", function(module, exports) {
$parcel$export(module.exports, "useHasSeenOnboarding", () => $fd6eca3e38c890b2$export$7fa30b35c95cc082);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $fu6p2 = parcelRequire("fu6p2");

var $3GN2r = parcelRequire("3GN2r");
const $fd6eca3e38c890b2$export$7fa30b35c95cc082 = (key)=>{
    const accountId = (0, $3GN2r.useAccountId)();
    const [isOnboardingActive, setIsOnboardingActive] = (0, $euxye.useState)(false);
    const getHasSeenOnboarding = (0, $euxye.useCallback)(async (id)=>{
        const response = await (0, $fu6p2.getUserProperty)({
            accountId: id,
            propertyKey: key,
            defaultValue: false
        });
        return response.value;
    }, [
        key
    ]);
    const setHasSeenOnboarding = (0, $euxye.useCallback)(async ()=>{
        setIsOnboardingActive(false);
        if (accountId !== null) await (0, $fu6p2.setUserProperty)({
            accountId: accountId,
            propertyKey: key,
            propertyValue: true
        });
    }, [
        accountId,
        key
    ]);
    const fetchOnboardingState = (0, $euxye.useCallback)(async ()=>{
        if (accountId !== null) {
            const response = await getHasSeenOnboarding(accountId);
            setIsOnboardingActive(!response);
        }
    }, [
        accountId,
        getHasSeenOnboarding
    ]);
    (0, $euxye.useEffect)(()=>{
        fetchOnboardingState();
    }, [
        fetchOnboardingState
    ]);
    return [
        isOnboardingActive,
        setHasSeenOnboarding
    ];
};

});
parcelRegister("fu6p2", function(module, exports) {
$parcel$export(module.exports, "getUserProperty", () => $ad8c319cab14a6bb$export$b3126db2ef6e34ed);
$parcel$export(module.exports, "setUserProperty", () => $ad8c319cab14a6bb$export$ba821ce5e177c7ef);

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");
const $ad8c319cab14a6bb$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $ad8c319cab14a6bb$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $ad8c319cab14a6bb$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // The API deliberately returns 404 if user property is not found - we will return default value
        if (response.status === 404) return {
            key: propertyKey,
            value: defaultValue
        };
        if (response.ok) return await response.json();
        throw new Error(`Fetching ${propertyKey} user property failed.`);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};
const $ad8c319cab14a6bb$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $ad8c319cab14a6bb$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $h2wCv.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'setUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});



parcelRegister("iL5kN", function(module, exports) {
$parcel$export(module.exports, "default", () => $153a992b650f5cfc$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $ldfa4 = parcelRequire("ldfa4");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
const $153a992b650f5cfc$export$3776992222b2b40f = {
    EXPAND: 'expand',
    COLLAPSE: 'collapse'
};
const $153a992b650f5cfc$var$ExpandableMenuItemTriggerWithAnalytics = ({ analytics: analytics, onClick: onClick, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const handleClick = (event, analyticsEvent, { isExpanded: isExpanded })=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), actionSubjectId, {
            ...analyticsAttributes,
            expandAction: isExpanded ? $153a992b650f5cfc$export$3776992222b2b40f.EXPAND : $153a992b650f5cfc$export$3776992222b2b40f.COLLAPSE
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ldfa4.ExpandableMenuItemTrigger), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
};
$153a992b650f5cfc$var$ExpandableMenuItemTriggerWithAnalytics.displayName = "ExpandableMenuItemTriggerWithAnalytics";
const $153a992b650f5cfc$var$ExpandableMenuItemTriggerWithAnalyticsForwarded = /*#__PURE__*/ (0, $euxye.forwardRef)($153a992b650f5cfc$var$ExpandableMenuItemTriggerWithAnalytics);
var $153a992b650f5cfc$export$2e2bcd8739ae039 = $153a992b650f5cfc$var$ExpandableMenuItemTriggerWithAnalyticsForwarded;

});

parcelRegister("5f2G0", function(module, exports) {
$parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", () => $00a298f5e0a07a11$export$f21504b774272faa);
/* eslint-disable jira/filename-case */ 
var $6AWfg = parcelRequire("6AWfg");
const $00a298f5e0a07a11$export$f21504b774272faa = {
    ...(0, $6AWfg.COMMON_ANALYTICS_ATTRIBUTES),
    section: 'jiraServiceManagement'
};

});


parcelRegister("6pxmA", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6a14a79a2afa70c$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $4Onaa = parcelRequire("4Onaa");

var $dRtPJ = parcelRequire("dRtPJ");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $djYhH = parcelRequire("djYhH");

var $2EFuW = parcelRequire("2EFuW");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $6AWfg = parcelRequire("6AWfg");
const $f6a14a79a2afa70c$var$headingMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.customer-service-section.heading-csm",
    defaultMessage: "Customer Service Management"
});
const $f6a14a79a2afa70c$var$customerAccessItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.customer-service-section.customer-access-item",
    defaultMessage: "Customer access"
});
const $f6a14a79a2afa70c$var$chatItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.customer-service-section.chat-item",
    defaultMessage: "Chat"
});
const $f6a14a79a2afa70c$var$storageManagementItemMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.customer-service-section.storage-management-item",
    defaultMessage: "Storage management"
});
const $f6a14a79a2afa70c$var$betaLozengeMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.customer-service-section.beta-lozenge",
    defaultMessage: "Beta"
});
const $f6a14a79a2afa70c$var$CustomerServiceSection = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const currentRoute = (0, $4Onaa.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), {
        isMenuListItem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($f6a14a79a2afa70c$var$headingMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $6AWfg.COMMON_ANALYTICS_ATTRIBUTES),
            section: 'jiraCustomerService',
            itemId: 'customerAccess'
        },
        isSelected: currentRoute.name === 'products-jcs-customer-access',
        href: "/jira/settings/products/customerservice/customer-access"
    }, formatMessage($f6a14a79a2afa70c$var$customerAccessItemMessage)), (0, $2700E.expVal)('jsmgrowth-267_enforce_storage_limits_servco_free', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $6AWfg.COMMON_ANALYTICS_ATTRIBUTES),
            section: 'jiraCustomerService',
            itemId: 'storageManagement'
        },
        isSelected: currentRoute.name === 'products-jcs-storage-management',
        href: "/jira/settings/products/customerservice/storage-management"
    }, formatMessage($f6a14a79a2afa70c$var$storageManagementItemMessage)), (0, $i860n.fg)('csm-omni-channel-live-chat-in-widget') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $6AWfg.COMMON_ANALYTICS_ATTRIBUTES),
            section: 'jiraCustomerService',
            itemId: 'chat'
        },
        isSelected: currentRoute.name === 'products-csm-chat',
        href: "/jira/settings/products/customerservice/chat",
        elemAfter: !(0, $i860n.fg)('csm-omni-hide-beta-lozenge') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
            appearance: "discovery"
        }, formatMessage($f6a14a79a2afa70c$var$betaLozengeMessage)) : undefined
    }, formatMessage($f6a14a79a2afa70c$var$chatItemMessage))));
};
$f6a14a79a2afa70c$var$CustomerServiceSection.displayName = "CustomerServiceSection";
const $f6a14a79a2afa70c$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($f6a14a79a2afa70c$var$CustomerServiceSection);
var $f6a14a79a2afa70c$export$2e2bcd8739ae039 = $f6a14a79a2afa70c$var$ExportedComponent;

});

parcelRegister("8M0af", function(module, exports) {
$parcel$export(module.exports, "DelegatedAdminJiraSection", () => $c42029d23e25ab05$export$a548d6dff2d43f1f);

var $bhnD2 = parcelRequire("bhnD2");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $dRtPJ = parcelRequire("dRtPJ");

var $4Onaa = parcelRequire("4Onaa");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $djYhH = parcelRequire("djYhH");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $42wGi = parcelRequire("42wGi");
const $c42029d23e25ab05$var$heading = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.heading",
    defaultMessage: "Jira"
});
const $c42029d23e25ab05$var$onboardingHubItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.onboarding-hub-item",
    defaultMessage: "Custom onboarding"
});
const $c42029d23e25ab05$var$DelegatedAdminJiraSectionInternal = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const currentRoute = (0, $4Onaa.useCurrentRoute)();
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const fragmentData = (0, $n67Vb.useFragment)((0, $bhnD2.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryReference);
    if (!fragmentData?.jira?.canManageCustomOnboarding) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), {
        isMenuListItem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($c42029d23e25ab05$var$heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $42wGi.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'onboardingHub'
        },
        isSelected: [
            'products-onboarding-hub',
            'products-onboarding-hub-create',
            'products-onboarding-hub-edit'
        ].includes(currentRoute.name),
        href: "/jira/settings/products/onboarding"
    }, formatMessage($c42029d23e25ab05$var$onboardingHubItem))));
};
$c42029d23e25ab05$var$DelegatedAdminJiraSectionInternal.displayName = "DelegatedAdminJiraSectionInternal";
const $c42029d23e25ab05$export$a548d6dff2d43f1f = /*#__PURE__*/ (0, $euxye.memo)($c42029d23e25ab05$var$DelegatedAdminJiraSectionInternal);

});
parcelRegister("bhnD2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f19a837674074494$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d29f94685980ccb4905b42bd7ba343c6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f19a837674074494$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipDelegatedAdminCheck"
        }
    ],
    "kind": "Fragment",
    "name": "DelegatedAdminJiraSection",
    "selections": [
        {
            "condition": "skipDelegatedAdminCheck",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canManageCustomOnboarding",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "MANAGE_CUSTOM_ONBOARDING"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "hasGlobalPermission"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$f19a837674074494$var$node.hash = "4829d8ab2a5bd80527220204076e7d6a";
var $f19a837674074494$export$2e2bcd8739ae039 = $f19a837674074494$var$node;

});


parcelRegister("1PXpL", function(module, exports) {
$parcel$export(module.exports, "default", () => $e407d9926d068e0c$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $dRtPJ = parcelRequire("dRtPJ");

var $4Onaa = parcelRequire("4Onaa");

var $6w18e = parcelRequire("6w18e");
var $5EY0v = parcelRequire("5EY0v");

var $djYhH = parcelRequire("djYhH");

var $2HuOR = parcelRequire("2HuOR");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $eijVy = parcelRequire("eijVy");

var $5f2G0 = parcelRequire("5f2G0");
const $e407d9926d068e0c$var$headingMessage = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-collection-section.heading",
    defaultMessage: "Service management apps"
});
const $e407d9926d068e0c$var$configurationItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-collection-section.configuration-item",
    defaultMessage: "Configuration"
});
const $e407d9926d068e0c$var$emailRequestsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-collection-section.email-requests-item",
    defaultMessage: "Email requests"
});
const $e407d9926d068e0c$var$knowledgeBasePermissionsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-collection-section.knowledge-base-permissions-item",
    defaultMessage: "Knowledge base permissions"
});
const $e407d9926d068e0c$var$authenticationItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-collection-section.authentication-item",
    defaultMessage: "Authentication"
});
const $e407d9926d068e0c$var$complianceSettingsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-collection-section.compliance-settings-item",
    defaultMessage: "Compliance"
});
const $e407d9926d068e0c$var$organizationsItem = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-collection-section.organizations-item",
    defaultMessage: "Organizations"
});
const $e407d9926d068e0c$var$ServiceCollectionSectionInner = ({ features: features })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const currentRoute = (0, $4Onaa.useCurrentRoute)();
    const { licensedProducts: licensedProducts } = (0, $eijVy.useTenantContext)();
    const hasConfluence = Boolean(licensedProducts[(0, $2HuOR.LICENSED_PRODUCTS).CONFLUENCE]);
    const hasEmailRequests = features.hasServiceManagementEmailRequests;
    const hasKnowledgeBasePermissions = hasConfluence && features.hasServiceManagementKbPermissionsAccess;
    const hasAuthentication = features.hasServiceManagementAuthenticationSettings;
    const hasOrganizations = features.hasOrganizationsListAccess;
    if (!features.hasServiceManagementConfig && !hasEmailRequests && !hasKnowledgeBasePermissions && !hasAuthentication && !hasOrganizations) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6w18e.MenuSection), {
        isMenuListItem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5EY0v.MenuSectionHeading), null, formatMessage($e407d9926d068e0c$var$headingMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, features.hasServiceManagementConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'configuration'
        },
        isSelected: currentRoute.name === 'products-jsm-configuration',
        href: "/jira/settings/products/jira-service-management-configuration"
    }, formatMessage($e407d9926d068e0c$var$configurationItem)), hasEmailRequests && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'emailRequests'
        },
        isSelected: currentRoute.name === 'products-jsm-email-requests',
        href: "/jira/settings/products/jira-service-management-email-requests"
    }, formatMessage($e407d9926d068e0c$var$emailRequestsItem)), hasKnowledgeBasePermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'knowledgeBasePermissions'
        },
        isSelected: currentRoute.name === 'products-jsm-kb-permissions',
        href: "/jira/settings/products/jira-service-management-knowledge-base-permissions"
    }, formatMessage($e407d9926d068e0c$var$knowledgeBasePermissionsItem)), hasAuthentication && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'authentication'
        },
        isSelected: currentRoute.name === 'products-jsm-authentication-settings',
        href: "/jira/settings/products/servicedesk/authentication"
    }, formatMessage($e407d9926d068e0c$var$authenticationItem)), features.hasServiceManagementConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'complianceSettings'
        },
        isSelected: currentRoute.name === 'products-jsm-compliance',
        href: "/jira/settings/products/jira-service-management-compliance"
    }, formatMessage($e407d9926d068e0c$var$complianceSettingsItem)), hasOrganizations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dRtPJ.default), {
        analytics: {
            ...(0, $5f2G0.COMMON_ANALYTICS_ATTRIBUTES),
            itemId: 'organizations'
        },
        isSelected: currentRoute.name === 'products-jsm-organizations',
        href: "/jira/settings/products/servicedesk/organizations"
    }, formatMessage($e407d9926d068e0c$var$organizationsItem))));
};
$e407d9926d068e0c$var$ServiceCollectionSectionInner.displayName = "ServiceCollectionSectionInner";
const $e407d9926d068e0c$var$ServiceCollectionSection = /*#__PURE__*/ (0, $euxye.memo)($e407d9926d068e0c$var$ServiceCollectionSectionInner);
var $e407d9926d068e0c$export$2e2bcd8739ae039 = $e407d9926d068e0c$var$ServiceCollectionSection;

});



parcelRegister("hAefF", function(module, exports) {
$parcel$export(module.exports, "default", () => $84ccb7fc91db0f80$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $jT1ry = parcelRequire("jT1ry");

var $k3x0N = parcelRequire("k3x0N");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $84ccb7fc91db0f80$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("gbzqg")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-global-projects/src/ui/main.tsx"
});
const $84ccb7fc91db0f80$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.projects-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProjectsSettings",
        ufoName: "nav4.sidebar.global-settings.projects-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jT1ry.SidebarContent), {
        currentPageName: "projects",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-projects.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.global-settings.projects-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k3x0N.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($84ccb7fc91db0f80$var$LazySidebarContent, null))));
};
$84ccb7fc91db0f80$var$AsyncSidebar.displayName = "AsyncSidebar";
const $84ccb7fc91db0f80$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($84ccb7fc91db0f80$var$AsyncSidebar);
var $84ccb7fc91db0f80$export$2e2bcd8739ae039 = $84ccb7fc91db0f80$var$ExportedComponent;

});
parcelRegister("gbzqg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fkwQl").then(()=>parcelRequire('liHqz'));

});


parcelRegister("bkrFd", function(module, exports) {
$parcel$export(module.exports, "LazySidebarContent", () => $2b50cf90c0695032$export$5cb783b45e692ee9);
$parcel$export(module.exports, "default", () => $2b50cf90c0695032$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $jT1ry = parcelRequire("jT1ry");

var $k3x0N = parcelRequire("k3x0N");

var $6HvWM = parcelRequire("6HvWM");

var $6RSCO = parcelRequire("6RSCO");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $fNgVF = parcelRequire("fNgVF");

var $gNbXR = parcelRequire("gNbXR");
var $k6ufm = parcelRequire("k6ufm");

var $i860n = parcelRequire("i860n");

const $2b50cf90c0695032$export$5cb783b45e692ee9 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("i4LHZ")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-global-operations/src/ui/main.tsx"
});
const $2b50cf90c0695032$var$AsyncSidebar = ()=>{
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const { isOpsAdmin: isOpsAdmin, shouldUseJSM: shouldUseJSM, loading: loading } = (0, $6HvWM.useOgTenantInfo)();
    // On shell-only new tab loads (IC), getConsolidationStateResource starts with
    // data=null, loading=false on the first render — before useEffect triggers refresh().
    // All check fns (checkShouldUseJSM etc.) return false for null data, so without this
    // guard the redirect fires before the resource is even fetched.
    // We always call useResource (rules of hooks) but only use it when the gate is on.
    const { data: tenantInfoData } = (0, $k6ufm.useResource)((0, $6RSCO.getConsolidationStateResource)());
    const hasOperationsGeneralConfiguration = isAdmin || isOpsAdmin;
    // Guard: wait for resource data before redirecting — prevents premature redirect
    // when data=null, loading=false on first render (IC shell-only new tab cold start).
    // On shell-only new tab, getConsolidationStateResource starts with data=null, loading=false
    // before useEffect triggers refresh() — all check fns return false for null data, causing
    // a premature redirect to /jira/for-you before ops-user-info is even fetched.
    if ((loading || tenantInfoData === null) && (0, $i860n.fg)('fix_chatops_access_in_isolated_cloud')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k3x0N.Skeleton), null);
    if (!shouldUseJSM) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: "/jira/for-you"
    });
    if (!hasOperationsGeneralConfiguration) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.operations-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsOperationsSettings",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: "/jira/ops/overview"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.operations-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsOperationsSettings",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jT1ry.SidebarContent), {
        currentPageName: "operations",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-operations.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.global-settings.operations-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k3x0N.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($2b50cf90c0695032$export$5cb783b45e692ee9, null))));
};
$2b50cf90c0695032$var$AsyncSidebar.displayName = "AsyncSidebar";
const $2b50cf90c0695032$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($2b50cf90c0695032$var$AsyncSidebar);
var $2b50cf90c0695032$export$2e2bcd8739ae039 = $2b50cf90c0695032$var$ExportedComponent;

});
parcelRegister("i4LHZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j5V2B").then(()=>parcelRequire('1j5N7'));

});


parcelRegister("6wqxj", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6c89c49d7dfbb92$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $jT1ry = parcelRequire("jT1ry");

var $k3x0N = parcelRequire("k3x0N");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $d6c89c49d7dfbb92$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("za7kl")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-global-system/src/ui/main.tsx"
});
const $d6c89c49d7dfbb92$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.system-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsSystemSettings",
        ufoName: "nav4.sidebar.global-settings.system-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jT1ry.SidebarContent), {
        currentPageName: "system",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-system.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.global-settings.system-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k3x0N.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d6c89c49d7dfbb92$var$LazySidebarContent, null))));
};
$d6c89c49d7dfbb92$var$AsyncSidebar.displayName = "AsyncSidebar";
const $d6c89c49d7dfbb92$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($d6c89c49d7dfbb92$var$AsyncSidebar);
var $d6c89c49d7dfbb92$export$2e2bcd8739ae039 = $d6c89c49d7dfbb92$var$ExportedComponent;

});
parcelRegister("za7kl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ikOol").then(()=>parcelRequire('fCPGI'));

});


parcelRegister("8fBio", function(module, exports) {
$parcel$export(module.exports, "default", () => $d65bbfcc6a1c1e36$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $l8G1z = parcelRequire("l8G1z");

var $82mR8 = parcelRequire("82mR8");

const $d65bbfcc6a1c1e36$var$LazyCsmAppSidebarViaResource = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("d5UZN")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-content-csm-app/src/CsmAppSidebarViaResource.tsx"
});
const $d65bbfcc6a1c1e36$export$153aad352ca942b2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $82mR8.CsmAppSidebarBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d65bbfcc6a1c1e36$var$LazyCsmAppSidebarViaResource, null));
$d65bbfcc6a1c1e36$export$153aad352ca942b2.displayName = "AsyncCsmAppSidebar";
var $d65bbfcc6a1c1e36$export$2e2bcd8739ae039 = $d65bbfcc6a1c1e36$export$153aad352ca942b2;

});
parcelRegister("82mR8", function(module, exports) {
$parcel$export(module.exports, "CsmAppSidebarBoundary", () => $fb6a207e624c580d$export$1fab84962757598d);

var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $a8EUd = parcelRequire("a8EUd");

var $3Xohz = parcelRequire("3Xohz");
const $fb6a207e624c580d$export$1fab84962757598d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "csm-nav4.sidebar.csm-app",
        packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCsmApp",
        ufoName: "csm-nav4.sidebar.csm-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "csm-nav4.sidebar.csm-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3Xohz.CsmAppSidebarSkeleton), null)
    }, children));
$fb6a207e624c580d$export$1fab84962757598d.displayName = "CsmAppSidebarBoundary";

});
parcelRegister("3Xohz", function(module, exports) {
$parcel$export(module.exports, "CsmAppSidebarSkeleton", () => $af600fd91b81469f$export$74c570c5febd9973);
/* CsmAppSidebarSkeleton.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");
const $af600fd91b81469f$var$containerStyles = null;
const $af600fd91b81469f$var$itemSkeletonStyles = null;
const $af600fd91b81469f$export$74c570c5febd9973 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            "_zulpu2gc _1rjcpxbi _18zrpxbi _1e0c1txw _2lx21bp4"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            "_2rko12b0 _bfhkizff _4t3i7vkz"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            "_2rko12b0 _bfhkizff _4t3i7vkz"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            "_2rko12b0 _bfhkizff _4t3i7vkz"
        ])
    }));
$af600fd91b81469f$export$74c570c5febd9973.displayName = "CsmAppSidebarSkeleton";

});


parcelRegister("d5UZN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hXEBD").then(()=>parcelRequire('2AJWY'));

});


parcelRegister("ln7fJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6469695107cd0570$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $a8EUd = parcelRequire("a8EUd");

var $gDdYI = parcelRequire("gDdYI");

var $l8G1z = parcelRequire("l8G1z");

var $lwFVH = parcelRequire("lwFVH");

const $6469695107cd0570$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("cFMhy")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-content-space-agents/src/SpaceAgentsSidebar.tsx"
});
const $6469695107cd0570$var$AsyncSpaceAgentsSidebarComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "space-agents-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "space-agents.sidebar",
        packageName: "jiraNavigationAppsSidebarNav4SidebarsContentSpaceAgents",
        ufoName: "space-agents.sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "space-agents.sidebar",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lwFVH.SpaceAgentsSidebarSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($6469695107cd0570$var$LazySidebarContent, null))));
$6469695107cd0570$var$AsyncSpaceAgentsSidebarComponent.displayName = "AsyncSpaceAgentsSidebarComponent";
const $6469695107cd0570$var$AsyncSpaceAgentsSidebar = /*#__PURE__*/ (0, $euxye.memo)($6469695107cd0570$var$AsyncSpaceAgentsSidebarComponent);
var $6469695107cd0570$export$2e2bcd8739ae039 = $6469695107cd0570$var$AsyncSpaceAgentsSidebar;

});
parcelRegister("lwFVH", function(module, exports) {
$parcel$export(module.exports, "SpaceAgentsSidebarSkeleton", () => $dd87775ea583939e$export$7fcbae7342a4ddbf);

var $euxye = parcelRequire("euxye");

var $gEDfa = parcelRequire("gEDfa");

var $kYJqR = parcelRequire("kYJqR");
const $dd87775ea583939e$export$7fcbae7342a4ddbf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kYJqR.SideNavBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), null));
$dd87775ea583939e$export$7fcbae7342a4ddbf.displayName = "SpaceAgentsSidebarSkeleton";
var $dd87775ea583939e$export$2e2bcd8739ae039 = $dd87775ea583939e$export$7fcbae7342a4ddbf;

});

parcelRegister("cFMhy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jD5Q4").then(()=>parcelRequire('19y9s'));

});


parcelRegister("9q6Mu", function(module, exports) {
$parcel$export(module.exports, "default", () => $d99093a10bd3b356$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $1qUtu = parcelRequire("1qUtu");

const $d99093a10bd3b356$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("eeiM2")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-help-center/src/ui/ExportedComponent.tsx"
});
const $d99093a10bd3b356$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.help-center-settings",
        packageName: "jiraNavigationAppsSidebarNav4HelpCenterSettings",
        ufoName: "nav4.sidebar.help-center-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.help-center-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1qUtu.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d99093a10bd3b356$var$LazySidebarContent, null)));
$d99093a10bd3b356$var$AsyncSidebar.displayName = "AsyncSidebar";
const $d99093a10bd3b356$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($d99093a10bd3b356$var$AsyncSidebar);
var $d99093a10bd3b356$export$2e2bcd8739ae039 = $d99093a10bd3b356$var$ExportedComponent;

});
parcelRegister("1qUtu", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $b7fa9b637097686f$export$8f31e4c4a37b8e9c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6Elhl = parcelRequire("6Elhl");

var $c69sa = parcelRequire("c69sa");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");
const $b7fa9b637097686f$var$ItemSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $b7fa9b637097686f$var$iconSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $b7fa9b637097686f$var$itemSkeleton
    }));
$b7fa9b637097686f$var$ItemSkeleton.displayName = "ItemSkeleton";
const $b7fa9b637097686f$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.300",
        xcss: $b7fa9b637097686f$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $b7fa9b637097686f$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $b7fa9b637097686f$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $b7fa9b637097686f$var$iconSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $b7fa9b637097686f$var$titleSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b7fa9b637097686f$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b7fa9b637097686f$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b7fa9b637097686f$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b7fa9b637097686f$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b7fa9b637097686f$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b7fa9b637097686f$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b7fa9b637097686f$var$ItemSkeleton, null)));
$b7fa9b637097686f$export$8f31e4c4a37b8e9c.displayName = "Skeleton";
const $b7fa9b637097686f$var$containerStyles = (0, $fbAgj.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $b7fa9b637097686f$var$backButton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'radius.small'
});
const $b7fa9b637097686f$var$iconSkeleton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small'
});
const $b7fa9b637097686f$var$titleSkeleton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    width: '50%',
    borderRadius: 'radius.small'
});
const $b7fa9b637097686f$var$headingSkeleton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    width: "var(--ds-space-1000, 80px)",
    borderRadius: 'radius.small'
});
const $b7fa9b637097686f$var$itemSkeleton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'radius.small',
    flex: 1
});

});

parcelRegister("eeiM2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hSKPB").then(()=>parcelRequire('9kJzo'));

});


parcelRegister("leSe6", function(module, exports) {
$parcel$export(module.exports, "default", () => $43ff49a0e4d0bf99$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $erCCk = parcelRequire("erCCk");

const $43ff49a0e4d0bf99$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("cSt3m")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-personal/src/ui/main.tsx"
});
const $43ff49a0e4d0bf99$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.personal-settings",
        packageName: "jiraNavigationAppsSidebarNav4PersonalSettings",
        ufoName: "nav4.sidebar.personal-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.personal-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $erCCk.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($43ff49a0e4d0bf99$var$LazySidebarContent, null)));
$43ff49a0e4d0bf99$var$AsyncSidebar.displayName = "AsyncSidebar";
const $43ff49a0e4d0bf99$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($43ff49a0e4d0bf99$var$AsyncSidebar);
var $43ff49a0e4d0bf99$export$2e2bcd8739ae039 = $43ff49a0e4d0bf99$var$ExportedComponent;

});
parcelRegister("erCCk", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $50a5bd653359b90f$export$8f31e4c4a37b8e9c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6Elhl = parcelRequire("6Elhl");

var $c69sa = parcelRequire("c69sa");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");
const $50a5bd653359b90f$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $50a5bd653359b90f$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $50a5bd653359b90f$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $50a5bd653359b90f$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $50a5bd653359b90f$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $50a5bd653359b90f$var$menuItem
    })));
$50a5bd653359b90f$export$8f31e4c4a37b8e9c.displayName = "Skeleton";
const $50a5bd653359b90f$var$containerStyles = (0, $fbAgj.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $50a5bd653359b90f$var$backButton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small'
});
const $50a5bd653359b90f$var$headingSkeleton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small',
    flex: 1
});
const $50a5bd653359b90f$var$menuItem = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});

});

parcelRegister("cSt3m", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j2B00").then(()=>parcelRequire('e71wr'));

});


parcelRegister("98b9S", function(module, exports) {
$parcel$export(module.exports, "default", () => $e16c314a240cdd47$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $d78Kw = parcelRequire("d78Kw");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $eijVy = parcelRequire("eijVy");

var $hFu5m = parcelRequire("hFu5m");

const $e16c314a240cdd47$var$LazyPlanSettingsSidebar = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("6V0hH")).then(({ PlanSettingsSidebar: PlanSettingsSidebar })=>PlanSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-plan/src/ui/PlanSettingsSidebar.tsx"
});
const $e16c314a240cdd47$var$toPlanAri = ({ siteId: siteId, activationId: activationId, planId: planId })=>`ari:cloud:jira:${siteId}:plan/activation/${activationId}/${planId}`;
const $e16c314a240cdd47$var$AsyncSidebar = ({ store: store })=>{
    const { params: params } = (0, $d78Kw.useMatch)();
    const { cloudId: cloudId, activationId: activationId } = (0, $eijVy.useTenantContext)();
    const { planId: planId } = params;
    const planIdAri = (0, $euxye.useMemo)(()=>$e16c314a240cdd47$var$toPlanAri({
            siteId: cloudId,
            activationId: activationId,
            planId: String(planId)
        }), [
        cloudId,
        activationId,
        planId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "planSettingsSidebar",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hFu5m.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e16c314a240cdd47$var$LazyPlanSettingsSidebar, {
        store: store,
        planIdAri: planIdAri,
        planId: String(planId)
    }));
};
$e16c314a240cdd47$var$AsyncSidebar.displayName = "AsyncSidebar";
const $e16c314a240cdd47$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($e16c314a240cdd47$var$AsyncSidebar);
var $e16c314a240cdd47$export$2e2bcd8739ae039 = $e16c314a240cdd47$var$ExportedComponent;

});
parcelRegister("hFu5m", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $57494bf8338a1db1$export$8f31e4c4a37b8e9c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6Elhl = parcelRequire("6Elhl");

var $c69sa = parcelRequire("c69sa");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");
const $57494bf8338a1db1$export$8f31e4c4a37b8e9c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$titleSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $57494bf8338a1db1$var$menuItem
    }))));
};
$57494bf8338a1db1$export$8f31e4c4a37b8e9c.displayName = "Skeleton";
const $57494bf8338a1db1$var$titleSkeleton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-800, 64px)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});
const $57494bf8338a1db1$var$backButton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});
const $57494bf8338a1db1$var$headingSkeleton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small',
    flex: 1
});
const $57494bf8338a1db1$var$menuItem = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'radius.small'
});
const $57494bf8338a1db1$var$subtitleItem = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    width: "var(--ds-space-1000, 80px)",
    borderRadius: 'radius.small'
});

});

parcelRegister("6V0hH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("5geQX"),
    $4cvLQ("9pWDr")
]).then(()=>parcelRequire('2F7LM'));

});


parcelRegister("aa4B4", function(module, exports) {
$parcel$export(module.exports, "default", () => $02a021eb94d18e46$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $4TntV = parcelRequire("4TntV");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $02a021eb94d18e46$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("c7ufk")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-project-business-company-managed/src/ui/main.tsx"
});
const $02a021eb94d18e46$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.business.company-managed",
        packageName: "jiraNavigationAppsSidebarNav4BusinessCompanyManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.business.company-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.project-settings.business.company-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4TntV.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($02a021eb94d18e46$var$LazySidebarContent, {
        project: project
    })));
$02a021eb94d18e46$var$AsyncSidebar.displayName = "AsyncSidebar";
const $02a021eb94d18e46$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($02a021eb94d18e46$var$AsyncSidebar);
var $02a021eb94d18e46$export$2e2bcd8739ae039 = $02a021eb94d18e46$var$ExportedComponent;

});
parcelRegister("c7ufk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1z3kR").then(()=>parcelRequire('eMa8G'));

});


parcelRegister("jyKR4", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a7e8ccd38139a42$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $4TntV = parcelRequire("4TntV");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $1a7e8ccd38139a42$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("edLwF")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-project-business-team-managed/src/ui/main.tsx"
});
const $1a7e8ccd38139a42$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.business.team-managed",
        packageName: "jiraNavigationAppsSidebarNav4BusinessTeamManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.business.team-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.project-settings.business.team-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4TntV.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($1a7e8ccd38139a42$var$LazySidebarContent, {
        project: project
    })));
$1a7e8ccd38139a42$var$AsyncSidebar.displayName = "AsyncSidebar";
const $1a7e8ccd38139a42$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($1a7e8ccd38139a42$var$AsyncSidebar);
var $1a7e8ccd38139a42$export$2e2bcd8739ae039 = $1a7e8ccd38139a42$var$ExportedComponent;

});
parcelRegister("edLwF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iCoBs").then(()=>parcelRequire('7KldH'));

});


parcelRegister("b8w1S", function(module, exports) {
$parcel$export(module.exports, "AsyncProjectSettingsSidebar", () => $63e136a87f33c80a$export$50b05a0db97b17e5);

var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $4TntV = parcelRequire("4TntV");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $63e136a87f33c80a$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("gw51z")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-project-product-discovery/src/ui/ProjectSettingsSidebar.tsx"
});
const $63e136a87f33c80a$export$50b05a0db97b17e5 = /*#__PURE__*/ (0, $euxye.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.jpd-settings",
        packageName: "jiraNavigationAppsSidebarNav4ProjectSettingsJpdSettings",
        ufoName: "nav4.sidebar.project-settings.jpd-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.project-settings.jpd-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4TntV.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($63e136a87f33c80a$var$LazySidebarContent, {
        project: project
    }))));

});
parcelRegister("gw51z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gYo8n").then(()=>parcelRequire('6WTlZ'));

});


parcelRegister("aguDt", function(module, exports) {
$parcel$export(module.exports, "AsyncJsmCmpProjectSettingsSidebar", () => $55faca71b8a52ec4$export$2ce6ad449436c545);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4NgYT = parcelRequire("4NgYT");

var $gVkjO = parcelRequire("gVkjO");

var $4TntV = parcelRequire("4TntV");

var $5eDsy = parcelRequire("5eDsy");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $55faca71b8a52ec4$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("eN9XF")).then(({ JSMCmpProjectSettingsSidebar: JSMCmpProjectSettingsSidebar })=>JSMCmpProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-project-service-desk-company-managed/src/main.tsx"
});
const $55faca71b8a52ec4$var$analyticsAttributes = {
    projectStyle: 'cmp',
    // reset '3' being sent from outside-of-nav4 Context. navState is used instead.
    // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
    navVersion: undefined
};
const $55faca71b8a52ec4$export$2ce6ad449436c545 = /*#__PURE__*/ (0, $euxye.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.jsm-cmp-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JsmCmpProjectSettings",
        teamName: "jsm-grape-soju",
        ufoName: "nav4.sidebar.jsm-cmp-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4NgYT.ContextualAnalyticsData), {
        menuId: (0, $5eDsy.MENU_ID_JSM_SETTINGS),
        attributes: $55faca71b8a52ec4$var$analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.jsm-cmp-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4TntV.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($55faca71b8a52ec4$var$LazySidebarContent, {
        project: project
    })))));

});
parcelRegister("5eDsy", function(module, exports) {
$parcel$export(module.exports, "MENU_ID_JSM_SETTINGS", () => $5027cc2b6776066b$export$4c5fa21d31710030);
$parcel$export(module.exports, "PROJECT_SETTINGS_COMMON_ANALYTICS_ATTRIBUTES", () => $5027cc2b6776066b$export$8092325c2fa271de);
/* eslint-disable jira/filename-case */ 

const $5027cc2b6776066b$export$4c5fa21d31710030 = 'project/service-desk/settings';
const $5027cc2b6776066b$var$COMMON_ANALYTICS_ATTRIBUTES = {
    componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
    level: 1
};
const $5027cc2b6776066b$export$8092325c2fa271de = {
    ...$5027cc2b6776066b$var$COMMON_ANALYTICS_ATTRIBUTES,
    actionSubjectId: (0, $47ad9e6c8e8002a4$export$13171e509c859bbf)
};

});

parcelRegister("eN9XF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2SziF").then(()=>parcelRequire('dqB4b'));

});


parcelRegister("gX1HT", function(module, exports) {
$parcel$export(module.exports, "AsyncJsmTmpProjectSettingsSidebar", () => $c1e4d3064139736f$export$dadf0f8c840cb26d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4NgYT = parcelRequire("4NgYT");

var $gVkjO = parcelRequire("gVkjO");

var $4TntV = parcelRequire("4TntV");

var $5eDsy = parcelRequire("5eDsy");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $c1e4d3064139736f$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("aSCye")).then(({ JSMTmpProjectSettingsSidebar: JSMTmpProjectSettingsSidebar })=>JSMTmpProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-project-service-desk-team-managed/src/main.tsx"
});
const $c1e4d3064139736f$var$analyticsAttributes = {
    projectStyle: 'tmp',
    // reset '3' being sent from outside-of-nav4 Context. navState is used instead.
    // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
    navVersion: undefined
};
const $c1e4d3064139736f$export$dadf0f8c840cb26d = /*#__PURE__*/ (0, $euxye.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.jsm-tmp-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JsmTmpProjectSettings",
        teamName: "jsm-grape-soju",
        ufoName: "nav4.sidebar.jsm-tmp-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4NgYT.ContextualAnalyticsData), {
        menuId: (0, $5eDsy.MENU_ID_JSM_SETTINGS),
        attributes: $c1e4d3064139736f$var$analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.jsm-tmp-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4TntV.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c1e4d3064139736f$var$LazySidebarContent, {
        project: project
    })))));

});
parcelRegister("aSCye", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3PWI4").then(()=>parcelRequire('415W6'));

});


parcelRegister("7hxOw", function(module, exports) {
$parcel$export(module.exports, "AsyncJcsProjectSettingsSidebar", () => $17d3a7eb330530b9$export$e82f1de9c94b7cd9);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $4TntV = parcelRequire("4TntV");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $17d3a7eb330530b9$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("4ZTsP")).then(({ JcsProjectSettingsSidebar: JcsProjectSettingsSidebar })=>JcsProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-project-customer-service/src/main.tsx"
});
const $17d3a7eb330530b9$export$e82f1de9c94b7cd9 = /*#__PURE__*/ (0, $euxye.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.jcs-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JCSProjectSettings",
        teamName: "Boysenberry",
        ufoName: "nav4.sidebar.jcs-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.jcs-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4TntV.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($17d3a7eb330530b9$var$LazySidebarContent, {
        project: project
    }))));

});
parcelRegister("4ZTsP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kXnk6").then(()=>parcelRequire('lDSjb'));

});


parcelRegister("31V0r", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9d0c17d30149992$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $4TntV = parcelRequire("4TntV");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $e9d0c17d30149992$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("jR8BD")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-project-software-company-managed/src/ui/main.tsx"
});
const $e9d0c17d30149992$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.software.company-managed",
        packageName: "jiraNavigationAppsSidebarNav4SoftwareCompanyManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.software.company-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.project-settings.software.company-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4TntV.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e9d0c17d30149992$var$LazySidebarContent, {
        project: project
    })));
$e9d0c17d30149992$var$AsyncSidebar.displayName = "AsyncSidebar";
const $e9d0c17d30149992$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($e9d0c17d30149992$var$AsyncSidebar);
var $e9d0c17d30149992$export$2e2bcd8739ae039 = $e9d0c17d30149992$var$ExportedComponent;

});
parcelRegister("jR8BD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eGYuq").then(()=>parcelRequire('3bTSY'));

});


parcelRegister("bz2be", function(module, exports) {
$parcel$export(module.exports, "default", () => $544269d2d0742d53$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $4TntV = parcelRequire("4TntV");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $544269d2d0742d53$var$LazySidebarContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("8U83G")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-project-software-team-managed/src/ui/main.tsx"
});
const $544269d2d0742d53$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.software.team-managed",
        packageName: "jiraNavigationAppsSidebarNav4SoftwareTeamManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.software.team-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.project-settings.software.team-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4TntV.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($544269d2d0742d53$var$LazySidebarContent, {
        project: project
    })));
$544269d2d0742d53$var$AsyncSidebar.displayName = "AsyncSidebar";
const $544269d2d0742d53$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($544269d2d0742d53$var$AsyncSidebar);
var $544269d2d0742d53$export$2e2bcd8739ae039 = $544269d2d0742d53$var$ExportedComponent;

});
parcelRegister("8U83G", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d75Kl").then(()=>parcelRequire('CEqiT'));

});


parcelRegister("hBxGd", function(module, exports) {
$parcel$export(module.exports, "useIsRovoAiEnabledForJiraProduct", () => $d88ad4d5687d863c$export$e857f4d2e23c03ec);

var $6bGyp = parcelRequire("6bGyp");
const $d88ad4d5687d863c$export$e857f4d2e23c03ec = (product)=>{
    const { data: data } = (0, $6bGyp.useRovoEntitlementResource)();
    return data?.rovoEnablementStatus?.rovoAiFeaturesEnabledJiraProducts?.includes(product) ?? false;
};

});


parcelRegister("28RaS", function(module, exports) {
$parcel$export(module.exports, "Nav4JiraSideNavRecommendation", () => $43a20dd94ff876e6$export$ecec3671e31d76fc);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3HdRR = parcelRequire("3HdRR");

var $h8QGu = parcelRequire("h8QGu");

var $35eqr = parcelRequire("35eqr");

var $kWzqm = parcelRequire("kWzqm");

var $bxVe8 = parcelRequire("bxVe8");

var $k11SN = parcelRequire("k11SN");

var $cr9yX = parcelRequire("cr9yX");

var $i860n = parcelRequire("i860n");

var $czLPq = parcelRequire("czLPq");
const $43a20dd94ff876e6$var$PLACEMENT_ID = 'jira-side-nav';
const $43a20dd94ff876e6$var$EmptySideNavPlacement = ()=>{
    if (!(0, $i860n.fg)('ui-sidenav-footer-underline-fix')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-empty-side-nav-placement": true,
        "data-testid": "side-nav-recommendation.empty-placement"
    });
};
$43a20dd94ff876e6$var$EmptySideNavPlacement.displayName = "EmptySideNavPlacement";
const $43a20dd94ff876e6$var$SideNavPlacement = ()=>{
    const [preloadedInitialData, clearPreloadedInitialData] = (0, $cr9yX.usePlacementPreloadedData)((0, $35eqr.postOfficeJiraSideNavResource));
    const handleClearPreloadedData = (0, $euxye.useCallback)(()=>{
        clearPreloadedInitialData();
    }, [
        clearPreloadedInitialData
    ]);
    const memoizedPlacementProps = (0, $euxye.useMemo)(()=>{
        return {
            handleClearPreloadedData: handleClearPreloadedData,
            preloadedInitialData: preloadedInitialData
        };
    }, [
        handleClearPreloadedData,
        preloadedInitialData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $czLPq.default), {
        placementId: $43a20dd94ff876e6$var$PLACEMENT_ID,
        // oxlint-disable-next-line typescript/ban-ts-comment
        // @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $3HdRR.default),
        placementProps: memoizedPlacementProps
    });
};
$43a20dd94ff876e6$var$SideNavPlacement.displayName = "SideNavPlacement";
const $43a20dd94ff876e6$var$SideNavRecommendation = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "sideNavRecommendation",
        packageName: "side-nav-recommendation",
        teamName: "post-office",
        fallback: $43a20dd94ff876e6$var$EmptySideNavPlacement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kWzqm.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": "side-nav-recommendation.jira-side-nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($43a20dd94ff876e6$var$EmptySideNavPlacement, null), (0, $i860n.fg)('post_office_ssr_jira_side_nav_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bxVe8.PlacementFetchProvider), {
        resource: (0, $35eqr.postOfficeJiraSideNavResource)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($43a20dd94ff876e6$var$SideNavPlacement, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($43a20dd94ff876e6$var$SideNavPlacement, null))));
};
$43a20dd94ff876e6$var$SideNavRecommendation.displayName = "SideNavRecommendation";
const $43a20dd94ff876e6$export$ecec3671e31d76fc = /*#__PURE__*/ (0, $euxye.memo)(()=>{
    if (!(0, $k11SN.default)('killswitch_post_office_in_jira')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($43a20dd94ff876e6$var$SideNavRecommendation, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($43a20dd94ff876e6$var$EmptySideNavPlacement, null);
});
const $43a20dd94ff876e6$export$6bbd8731fa84c19f = /*#__PURE__*/ (0, $euxye.memo)(()=>{
    if (!(0, $k11SN.default)('killswitch_post_office_in_jira')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($43a20dd94ff876e6$var$SideNavRecommendation, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($43a20dd94ff876e6$var$EmptySideNavPlacement, null);
});

});
parcelRegister("3HdRR", function(module, exports) {
$parcel$export(module.exports, "default", () => $eac72508647bf407$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $lHZq9 = parcelRequire("lHZq9");

var $7Cbbq = parcelRequire("7Cbbq");

var $eAA3f = parcelRequire("eAA3f");

var $1Pg8F = parcelRequire("1Pg8F");

var $euxye = parcelRequire("euxye");

var $6CLOF = parcelRequire("6CLOF");


var $h1dvI = parcelRequire("h1dvI");
const $eac72508647bf407$export$5f4d7e99d8732fe7 = (0, $7Cbbq.createPlacementComponent)((0, $991a7a7c9587f28e$export$a5cfae247d8360ef), /*#__PURE__*/ (0, $euxye.memo)(({ initialData: initialData, preloadedInitialData: preloadedInitialData, handleClearPreloadedData: handleClearPreloadedData })=>{
    const { data: data, isLoading: isLoading } = (0, $1Pg8F.useInitialData)(initialData);
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents, @typescript-eslint/no-unsafe-assignment
    const [{ message: message, status: status }, setMessageState] = (0, $euxye.useState)(()=>{
        if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            message: (0, $h1dvI.getMessage)(preloadedInitialData.messages),
            status: 'done'
        } : {
            message: undefined,
            status: 'done'
        };
        return {
            message: undefined,
            status: 'loading'
        };
    });
    const handleOnDismissed = (0, $euxye.useCallback)(()=>{
        setMessageState({
            message: undefined,
            status: 'done'
        });
        if (typeof handleClearPreloadedData === 'function') handleClearPreloadedData();
    }, [
        handleClearPreloadedData
    ]);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $lHZq9.useMessagePlacementHooks)();
    (0, $euxye.useEffect)(()=>onMessageDismiss(handleOnDismissed), [
        onMessageDismiss,
        handleOnDismissed
    ]);
    (0, $euxye.useEffect)(()=>onMessageClicked(handleOnDismissed), [
        onMessageClicked,
        handleOnDismissed
    ]);
    (0, $euxye.useEffect)(()=>onMessageSnooze(handleOnDismissed), [
        onMessageSnooze,
        handleOnDismissed
    ]);
    const isDone = status === 'done';
    (0, $euxye.useEffect)(()=>{
        if (!isLoading && !isDone) setMessageState({
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            message: (0, $h1dvI.getMessage)(data?.messages || []),
            status: 'done'
        });
    }, [
        data,
        isLoading,
        isDone
    ]);
    if (status === 'loading' || !message) return null;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6CLOF.MessageRenderer), {
        ...message,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        id: message.messageInstanceId,
        onDismissed: handleOnDismissed,
        SuspenseBoundary: (0, $eAA3f.MaybeSuspenseBoundary)
    });
}), {
    choreographer: {
        isDefaultEnabled: false
    }
});
var $eac72508647bf407$export$2e2bcd8739ae039 = $eac72508647bf407$export$5f4d7e99d8732fe7;

});
parcelRegister("6CLOF", function(module, exports) {
$parcel$export(module.exports, "MessageRenderer", () => $8d1f0a125ecb7134$export$2df1250b8f917a59);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $eAA3f = parcelRequire("eAA3f");

var $gi8sP = parcelRequire("gi8sP");

var $e31Mx = parcelRequire("e31Mx");

var $SnHzh = parcelRequire("SnHzh");

var $cIPCf = parcelRequire("cIPCf");

var $bg49M = parcelRequire("bg49M");

var $6DOe4 = parcelRequire("6DOe4");

var $t3Plh = parcelRequire("t3Plh");

var $8z9Bz = parcelRequire("8z9Bz");

var $bkA7c = parcelRequire("bkA7c");

var $5spIx = parcelRequire("5spIx");

var $2hOEh = parcelRequire("2hOEh");

var $i6HHy = parcelRequire("i6HHy");

var $iQ9EL = parcelRequire("iQ9EL");

var $kJlC4 = parcelRequire("kJlC4");

var $iP45x = parcelRequire("iP45x");

var $38bKN = parcelRequire("38bKN");

var $8uWpN = parcelRequire("8uWpN");
const $8d1f0a125ecb7134$export$e30378e28ad3e6ab = {
    'cjn-jira-to-confluence': (0, $gi8sP.default),
    'cjn-jira-to-jpd': (0, $e31Mx.default),
    'cjn-jira-to-loom': (0, $SnHzh.default),
    'confluence-rovo-onboarding-banner': (0, $cIPCf.default),
    'jira-twcg-190-recommend-retrial-recent-trialing-customers': (0, $bg49M.default),
    'jira-twcg-810-trial-ad': (0, $6DOe4.default),
    'jira-twg-cli-cta': (0, $t3Plh.default),
    'message-template-template': (0, $8z9Bz.default),
    'recommendation-confluence': (0, $bkA7c.default),
    'recommendation-jpd': (0, $5spIx.default),
    'recommendation-jsm': (0, $2hOEh.default),
    'recommendation-jsw-visualize-work': (0, $i6HHy.default),
    'recommendation-loom': (0, $iQ9EL.default),
    'rovo-extension-install-cta-left-nav': (0, $kJlC4.default),
    'rovo-non-mau-chat-cta-jira-confluence-left-nav': (0, $iP45x.default),
    'test-message-inapp': (0, $38bKN.default),
    'twc-sidenav-banner': (0, $8uWpN.default)
};
const $8d1f0a125ecb7134$var$messageRenderer = (0, $eAA3f.asMessageRenderer)($8d1f0a125ecb7134$export$e30378e28ad3e6ab, 'jira-side-nav');
const $8d1f0a125ecb7134$export$bce4e5106d86e473 = $8d1f0a125ecb7134$var$messageRenderer.initializeMessageRenderer;
const $8d1f0a125ecb7134$export$2df1250b8f917a59 = $8d1f0a125ecb7134$var$messageRenderer.MessageRenderer;

});
parcelRegister("gi8sP", function(module, exports) {
$parcel$export(module.exports, "default", () => $79d299cc2c07745d$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $cldBe = parcelRequire("cldBe");

var $4btyr = parcelRequire("4btyr");

var $l8ZY4 = parcelRequire("l8ZY4");
const $79d299cc2c07745d$export$b3890eb0ae9dca99 = (0, $cldBe.createRender)((props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $4btyr.JiraSideNavCrossJoinMessage), {
        ...props,
        targetProduct: (0, $l8ZY4.targetProduct).productKey
    }));
var $79d299cc2c07745d$export$2e2bcd8739ae039 = $79d299cc2c07745d$export$b3890eb0ae9dca99;

});
parcelRegister("cldBe", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $5dd95fc11fc10347$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $5dd95fc11fc10347$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $5dd95fc11fc10347$export$78c758434c34d601 = $5dd95fc11fc10347$var$clientPipeline.createRender;
const $5dd95fc11fc10347$export$2859a83e4d6da57d = $5dd95fc11fc10347$var$clientPipeline.createValidate;
const $5dd95fc11fc10347$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $5dd95fc11fc10347$export$c905bc718befd59b = $5dd95fc11fc10347$var$serverPipeline.createHydrate;
const $5dd95fc11fc10347$export$1f41223e5b0a6622 = $5dd95fc11fc10347$var$serverPipeline.createHydrateExample;
const $5dd95fc11fc10347$export$88fe13b4d13f8423 = $5dd95fc11fc10347$var$serverPipeline.createTransformMetadata;

});

parcelRegister("4btyr", function(module, exports) {
$parcel$export(module.exports, "JiraSideNavCrossJoinMessage", () => $cec2c7e7ec0c72ec$export$f13dac75768db50);

var $e79Pd = parcelRequire("e79Pd");

var $iLF1V = parcelRequire("iLF1V");

var $lK7pY = parcelRequire("lK7pY");

var $1Ocjm = parcelRequire("1Ocjm");

var $8vWeO = parcelRequire("8vWeO");

var $euxye = parcelRequire("euxye");

var $ey5Uh = parcelRequire("ey5Uh");

var $fGrpH = parcelRequire("fGrpH");

var $55qdj = parcelRequire("55qdj");
const $cec2c7e7ec0c72ec$var$whyAmISeeingThisReasons = [
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "puma.common.cjn-nav4.reasons-modal.team-size",
        description: "Reason explaining that the recommendation is based on the size of the user's team",
        defaultMessage: "the size of your team"
    }),
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "puma.common.cjn-nav4.reasons-modal.existing-products",
        description: "Reason explaining that the recommendation is based on the user's existing Atlassian products",
        defaultMessage: "your existing Atlassian products"
    })
];
const $cec2c7e7ec0c72ec$export$f13dac75768db50 = ({ targetProduct: targetProduct, collaborators: collaborators, onDismissed: onDismissed, tenantId: tenantId, userId: userId, sourceProduct: sourceProduct, crossJoinUrl: crossJoinUrl })=>{
    const isFirstRender = (0, $euxye.useRef)(true);
    const [isVisible, setIsVisible] = (0, $euxye.useState)(true);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceViewed: messageInstanceViewed } = (0, $1Ocjm.useMessageInstanceEvent)();
    const [isRequestSentFlagVisible, setIsRequestSentFlagVisible] = (0, $euxye.useState)(false);
    const { messageTemplateId: messageTemplateId } = (0, $lK7pY.useMessageContext)();
    const requestAccess = (0, $ey5Uh.useRequestAccess)({
        targetProduct: targetProduct,
        tenantId: tenantId,
        userId: userId,
        sourceProduct: sourceProduct,
        collaborators: collaborators,
        crossJoinUrl: crossJoinUrl,
        messageTemplateId: messageTemplateId,
        onComplete: ()=>setIsVisible(false),
        showRequestSentFlag: ()=>setIsRequestSentFlagVisible(true)
    });
    (0, $euxye.useEffect)(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            messageInstanceViewed();
            fireAnalyticsEvent({
                name: 'cjnNav4 placement',
                eventType: 'screen',
                attributes: {
                    messageTemplateId: messageTemplateId,
                    collaboratorCount: collaborators.length
                }
            });
        }
    }, []);
    const attributes = (0, $euxye.useMemo)(()=>({
            ...messageTemplateId ? {
                messageTemplateId: messageTemplateId
            } : {}
        }), [
        messageTemplateId
    ]);
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iLF1V.JiraSideNavMessage), {
        onDismissed: onDismissed,
        additionalAnalyticsAttributes: attributes,
        bodyContent: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8vWeO.Body), {
            sourceProduct: sourceProduct,
            targetProduct: targetProduct,
            collaborators: collaborators,
            tenantId: tenantId,
            userId: userId,
            crossJoinUrl: crossJoinUrl,
            messageTemplateId: messageTemplateId,
            onRequestAccess: requestAccess,
            isRequestSentFlagVisible: isRequestSentFlagVisible,
            setIsRequestSentFlagVisible: setIsRequestSentFlagVisible
        }),
        whyAmISeeingThisModalContent: {
            message: /*#__PURE__*/ (0, $e79Pd.jsx)("p", {
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                    id: "puma.common.cjn-nav4.reasons-modal.message",
                    description: "Explanation of why the recommended product may improve the user's team's productivity",
                    defaultMessage: "We think that {productName} will improve your team's productivity. This recommendation is based on:",
                    values: {
                        productName: /*#__PURE__*/ (0, $e79Pd.jsx)("strong", {
                            children: (0, $8vWeO.productNameByVariant)[targetProduct]
                        })
                    }
                })
            }),
            reasons: $cec2c7e7ec0c72ec$var$whyAmISeeingThisReasons
        }
    });
};
$cec2c7e7ec0c72ec$export$f13dac75768db50.displayName = "JiraSideNavCrossJoinMessage";

});
parcelRegister("iLF1V", function(module, exports) {
$parcel$export(module.exports, "JiraSideNavMessage", () => $8226fcad20885fe7$export$ee97a7edb31193a8);
/* message.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $lK7pY = parcelRequire("lK7pY");

var $2V1Jp = parcelRequire("2V1Jp");
const $8226fcad20885fe7$var$jiraSideNavMessageStyle = null;
const $8226fcad20885fe7$export$ee97a7edb31193a8 = ({ onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, bodyContent: bodyContent, showRemindMeLater: showRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis, additionalAnalyticsAttributes: additionalAnalyticsAttributes })=>{
    const { messageInstanceId: messageInstanceId } = (0, $lK7pY.useMessageContext)();
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        "data-testid": "jira-side-nav-message",
        className: (0, $4jQY2.default)([
            "_2rko1mok _18zrpxbi _1rjcutpp _kqswh2mm _1e0c1txw _bfhk1hdx _otyru2gc _1pbyidpf"
        ]),
        children: [
            bodyContent,
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2V1Jp.Actions), {
                whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
                onDismissed: ()=>onDismissed?.(messageInstanceId),
                showRemindMeLater: showRemindMeLater,
                showWhyAmISeeingThis: showWhyAmISeeingThis,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes
            })
        ]
    });
};
$8226fcad20885fe7$export$ee97a7edb31193a8.displayName = "JiraSideNavMessage";

});
parcelRegister("2V1Jp", function(module, exports) {
$parcel$export(module.exports, "Actions", () => $0c40c46a4e0b968c$export$b52183d5cfb26dc9);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $3gxI9 = parcelRequire("3gxI9");
const $0c40c46a4e0b968c$var$actionsStyles = null;
const $0c40c46a4e0b968c$export$b52183d5cfb26dc9 = ({ onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, showRemindMeLater: showRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis, additionalAnalyticsAttributes: additionalAnalyticsAttributes })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_1yt4u2gc _kqswstnw _1e0c1txw _154iidpf _1xi2idpf"
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3gxI9.AdControls), {
            iconSize: "small",
            onDismissed: onDismissed,
            showWhyAmISeeingThis: showWhyAmISeeingThis ?? true,
            whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
            showRemindMeLater: showRemindMeLater,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        })
    });
};
$0c40c46a4e0b968c$export$b52183d5cfb26dc9.displayName = "Actions";

});


parcelRegister("8vWeO", function(module, exports) {
$parcel$export(module.exports, "productNameByVariant", () => $a2efad76a3cd8130$export$7e9cc7d588b4f16);
$parcel$export(module.exports, "Body", () => $a2efad76a3cd8130$export$4b2c32e08f77ff18);
/* Body.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $1qX9F = parcelRequire("1qX9F");

var $2iotI = parcelRequire("2iotI");

var $eprc4 = parcelRequire("eprc4");

var $9MWap = parcelRequire("9MWap");
var $ihEDU = parcelRequire("ihEDU");
var $3PC9r = parcelRequire("3PC9r");

var $5tWvQ = parcelRequire("5tWvQ");

var $55qdj = parcelRequire("55qdj");
var $1YIbA = parcelRequire("1YIbA");
const $a2efad76a3cd8130$var$logoByVariant = {
    loom: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.LoomIcon), {
        appearance: "brand",
        shouldUseNewLogoDesign: true,
        size: "xxsmall"
    }),
    'jira-product-discovery': /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.JiraProductDiscoveryIcon), {
        appearance: "brand",
        shouldUseNewLogoDesign: true,
        size: "xxsmall"
    }),
    confluence: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.ConfluenceIcon), {
        appearance: "brand",
        shouldUseNewLogoDesign: true,
        size: "xxsmall"
    })
};
const $a2efad76a3cd8130$var$facePileBorderColorByVariant = {
    loom: "var(--ds-border-brand, #1868DB)",
    confluence: "var(--ds-border-brand, #1868DB)",
    'jira-product-discovery': "var(--ds-border-discovery, #AF59E1)"
};
const $a2efad76a3cd8130$var$inlineLogoStyles = null;
const $a2efad76a3cd8130$var$styles = {
    facePile: "_lcxvglyw",
    link: "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1",
    inlineBox: "_1e0c1o8l"
};
const $a2efad76a3cd8130$var$renderInlineLogo = (logo)=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        className: (0, $4jQY2.default)([
            "_1e0c116y _vwz4idpf _8hrz1h6o _1oec1ign _k8m01e03 _6fl41d08 _s7n4nkob _1llw96qg _1kxtglyw _1s6xglyw"
        ]),
        children: logo
    });
const $a2efad76a3cd8130$export$7e9cc7d588b4f16 = {
    loom: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "puma.common.side-nav.loom.product-name",
        description: "Product name for Loom, shown inline in the cross-join recommendation",
        defaultMessage: "Loom"
    }),
    'jira-product-discovery': /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "puma.common.side-nav.jpd.product-name",
        description: "Product name for Jira Product Discovery, shown inline in the cross-join recommendation",
        defaultMessage: "Jira Product Discovery"
    }),
    confluence: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "puma.common.side-nav.confluence.product-name",
        description: "Product name for Confluence, shown inline in the cross-join recommendation",
        defaultMessage: "Confluence"
    })
};
const $a2efad76a3cd8130$var$FacePile = ({ targetProduct: targetProduct, collaborators: collaborators })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    if (collaborators.length === 0) return null;
    const avatarBorderColor = $a2efad76a3cd8130$var$facePileBorderColorByVariant[targetProduct];
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $a2efad76a3cd8130$var$styles.facePile,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1qX9F.default), {
            appearance: "stack",
            size: "small",
            maxCount: 2,
            data: collaborators.map(({ name: name, picture: picture })=>({
                    name: name,
                    src: picture,
                    borderColor: avatarBorderColor
                })),
            overrides: {
                MoreIndicator: {
                    render: (Component, props)=>/*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                            ...props,
                            borderColor: "var(--ds-surface-overlay, #FFFFFF)"
                        })
                }
            },
            isTooltipDisabled: true,
            onMoreClick: ()=>{},
            label: formatMessage({
                id: 'puma.common.side-nav.face-pile.label',
                description: 'Accessible label for the face pile of collaborators using the product',
                defaultMessage: 'Collaborators using this product'
            })
        })
    });
};
$a2efad76a3cd8130$var$FacePile.displayName = "FacePile";
const $a2efad76a3cd8130$var$Description = ({ targetProduct: targetProduct, collaborators: collaborators })=>{
    const productName = $a2efad76a3cd8130$export$7e9cc7d588b4f16[targetProduct];
    const logo = $a2efad76a3cd8130$var$logoByVariant[targetProduct];
    const [firstCollaborator, ...rest] = collaborators;
    if (!firstCollaborator) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
        size: "xsmall",
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "puma.common.side-nav.description.team",
            description: "Cross-join recommendation copy shown when the user has no named collaborators on the recommended product",
            defaultMessage: "Your team is using <InlineBlock><Logo></Logo> {productName}</InlineBlock>",
            values: {
                productName: productName,
                Logo: ()=>$a2efad76a3cd8130$var$renderInlineLogo(logo),
                InlineBlock: (chunks)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                        xcss: $a2efad76a3cd8130$var$styles.inlineBox,
                        children: chunks
                    })
            }
        })
    });
    if (rest.length === 0) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
        size: "xsmall",
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "puma.common.side-nav.description.single",
            description: "Cross-join recommendation copy shown when exactly one of the user's collaborators is using the recommended product",
            defaultMessage: "{firstCollaborator} is using <InlineBlock><Logo></Logo> {productName}</InlineBlock>",
            values: {
                firstCollaborator: firstCollaborator.name,
                productName: productName,
                Logo: ()=>$a2efad76a3cd8130$var$renderInlineLogo(logo),
                InlineBlock: (chunks)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                        xcss: $a2efad76a3cd8130$var$styles.inlineBox,
                        children: chunks
                    })
            }
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
        size: "xsmall",
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "puma.common.side-nav.description.multiple",
            description: "Cross-join recommendation copy shown when two or more of the user's collaborators are using the recommended product",
            defaultMessage: "{firstCollaborator} and {collaboratorCount, plural, one {# other} other {# others}} are using <InlineBlock><Logo></Logo> {productName}</InlineBlock>",
            values: {
                firstCollaborator: firstCollaborator.name,
                collaboratorCount: rest.length,
                productName: productName,
                Logo: ()=>$a2efad76a3cd8130$var$renderInlineLogo(logo),
                InlineBlock: (chunks)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                        xcss: $a2efad76a3cd8130$var$styles.inlineBox,
                        children: chunks
                    })
            }
        })
    });
};
$a2efad76a3cd8130$var$Description.displayName = "Description";
const $a2efad76a3cd8130$export$4b2c32e08f77ff18 = ({ targetProduct: targetProduct, collaborators: collaborators, crossJoinUrl: crossJoinUrl, onRequestAccess: onRequestAccess, isRequestSentFlagVisible: isRequestSentFlagVisible, setIsRequestSentFlagVisible: setIsRequestSentFlagVisible })=>{
    const productName = $a2efad76a3cd8130$export$7e9cc7d588b4f16[targetProduct];
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)($a2efad76a3cd8130$var$FacePile, {
                targetProduct: targetProduct,
                collaborators: collaborators
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)($a2efad76a3cd8130$var$Description, {
                targetProduct: targetProduct,
                collaborators: collaborators
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MWap.Anchor), {
                href: crossJoinUrl,
                xcss: $a2efad76a3cd8130$var$styles.link,
                onClick: onRequestAccess,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                    id: "puma.common.side-nav.request-access-link",
                    description: "Call-to-action link inviting the user to request access to the recommended product so they can join their team",
                    defaultMessage: "Join your team"
                })
            }),
            isRequestSentFlagVisible && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5tWvQ.StatusFlag), {
                status: "success",
                title: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                    id: "puma.common.side-nav.request-sent-flag.title",
                    description: "Title of the toast shown after the user successfully requests to join their team on the recommended product",
                    defaultMessage: "Nearly there!"
                }),
                description: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                    id: "puma.common.side-nav.request-sent-flag.description",
                    description: "Body of the toast shown after the user successfully requests to join their team on the recommended product",
                    defaultMessage: "A quick access check is all that's left. We'll email you the moment you're good to try {productName}",
                    values: {
                        productName: productName
                    }
                }),
                actions: [],
                onDismiss: ()=>setIsRequestSentFlagVisible(false)
            })
        ]
    });
};
$a2efad76a3cd8130$export$4b2c32e08f77ff18.displayName = "Body";

});
parcelRegister("5tWvQ", function(module, exports) {
$parcel$export(module.exports, "StatusFlag", () => $8e9b367654de481f$export$167486f2511c3793);

var $e79Pd = parcelRequire("e79Pd");

var $63XI1 = parcelRequire("63XI1");
var $8RTvC = parcelRequire("8RTvC");

var $ah9qo = parcelRequire("ah9qo");

var $bgJDP = parcelRequire("bgJDP");

var $8Qvei = parcelRequire("8Qvei");
const $8e9b367654de481f$var$getFlagIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ah9qo))), {
                spacing: "spacious",
                testId: "error-icon",
                label: "Error",
                color: "var(--ds-icon-danger, #C9372C)"
            });
        case 'success':
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Qvei))), {
                spacing: "spacious",
                testId: "success-icon",
                label: "Success",
                color: "var(--ds-icon-success, #6A9A23)"
            });
        default:
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bgJDP))), {
                spacing: "spacious",
                testId: "info-icon",
                label: "Info"
            });
    }
};
const $8e9b367654de481f$export$167486f2511c3793 = ({ title: title, description: description, actions: actions, status: status, onDismiss: onDismiss })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $8RTvC.default), {
        onDismissed: onDismiss,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $63XI1.default), {
            icon: $8e9b367654de481f$var$getFlagIcon(status),
            description: description,
            id: `${status}-flag`,
            title: title,
            actions: actions
        })
    });
$8e9b367654de481f$export$167486f2511c3793.displayName = "StatusFlag";

});


parcelRegister("ey5Uh", function(module, exports) {
$parcel$export(module.exports, "useRequestAccess", () => $2a054a6a8c6b60f7$export$c5b957d5d6241e83);

var $fGrpH = parcelRequire("fGrpH");

var $iKPvC = parcelRequire("iKPvC");

var $euxye = parcelRequire("euxye");

var $3EXjU = parcelRequire("3EXjU");
var $3b6iI = parcelRequire("3b6iI");
var $kSTWB = parcelRequire("kSTWB");

var $XodBj = parcelRequire("XodBj");

const $2a054a6a8c6b60f7$var$targetProductByVariant = {
    loom: 'loom',
    'jira-product-discovery': 'jira-product-discovery',
    confluence: 'confluence'
};
const $2a054a6a8c6b60f7$var$expansionServicesToPostOfficeMap = {
    sendTrackEvent: (0, $6d4033511f75ada1$export$947dac6c72b26f81),
    sendOperationalEvent: (0, $6d4033511f75ada1$export$12346a674644c156),
    sendUIEvent: (0, $6d4033511f75ada1$export$a1562d08625f5d7e)
};
const $2a054a6a8c6b60f7$var$createAnalyticsEventHandler = (fireAnalyticsEvent, messageTemplateId)=>{
    return ({ type: type, data: data })=>({
            fire: ()=>{
                const eventType = $2a054a6a8c6b60f7$var$expansionServicesToPostOfficeMap[type];
                if (!eventType || !data.action) // Unable to translate event type
                return;
                fireAnalyticsEvent({
                    eventType: eventType,
                    action: data.action,
                    actionSubject: data.actionSubject,
                    actionSubjectId: data.actionSubjectId,
                    attributes: {
                        ...data.attributes,
                        messageTemplateId: messageTemplateId
                    }
                });
            }
        });
};
const $2a054a6a8c6b60f7$var$fetchJSON = async (input)=>{
    const { url: url, ...options } = input;
    const response = await fetch(url, options);
    if (!response.ok) throw new Error(`Fetch failed with status ${response.status}`);
    const data = await response.json();
    const traceId = (0, $3b6iI.getTraceId)(response);
    return traceId === undefined ? {
        data: data
    } : {
        data: data,
        traceId: traceId
    };
};
const $2a054a6a8c6b60f7$export$c5b957d5d6241e83 = ({ targetProduct: targetProduct, tenantId: tenantId, userId: userId, sourceProduct: sourceProduct, collaborators: collaborators, crossJoinUrl: crossJoinUrl, showRequestSentFlag: showRequestSentFlag, messageTemplateId: messageTemplateId, onComplete: onComplete })=>{
    const { messageInstanceClicked: messageInstanceClicked } = (0, $iKPvC.useMessageInstanceEvent)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    const deps = (0, $euxye.useMemo)(()=>({
            createAnalyticsEvent: $2a054a6a8c6b60f7$var$createAnalyticsEventHandler(fireAnalyticsEvent, messageTemplateId),
            fetchJSON: $2a054a6a8c6b60f7$var$fetchJSON,
            getStargateURL: (path)=>`/gateway/api${path}`,
            getCurrentCloudId: ()=>tenantId,
            getCurrentProduct: ()=>sourceProduct,
            getCurrentUserId: ()=>userId
        }), [
        fireAnalyticsEvent,
        tenantId,
        sourceProduct,
        userId
    ]);
    const requestAccess = (0, $XodBj.useService)((0, $kSTWB.requestAccess), deps);
    return (0, $euxye.useCallback)(async (clickEvent)=>{
        clickEvent.preventDefault();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'cjnNav4',
                clickedElement: 'link'
            },
            action: {
                actionType: 'open',
                destinationUrl: crossJoinUrl
            },
            additionalMetadataFromFrontend: {
                targetProduct: targetProduct,
                collaboratorCount: collaborators.length,
                ...messageTemplateId ? {
                    messageTemplateId: messageTemplateId
                } : {}
            }
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cjnNav4',
            attributes: {
                messageTemplateId: messageTemplateId
            }
        });
        try {
            const result = await requestAccess({
                product: $2a054a6a8c6b60f7$var$targetProductByVariant[targetProduct],
                integration: 'jira-side-nav-po-placement',
                touchpoint: (0, $3EXjU.EnablementTouchpoint).CROSSJOIN_NUDGE
            });
            if (result.error) {
                fireAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'requestAccess',
                    actionSubjectId: 'cjnNav4',
                    attributes: {
                        team: 'puma',
                        targetProduct: targetProduct,
                        messageTemplateId: messageTemplateId,
                        errorMessage: result.error.message
                    }
                });
                if (typeof globalThis !== 'undefined' && globalThis.window) globalThis.window.open(crossJoinUrl, '_blank', 'noreferrer');
            } else if (result.result === 'PENDING_REQUEST_CREATED') showRequestSentFlag();
            else if (typeof globalThis !== 'undefined' && globalThis.window) globalThis.window.open(crossJoinUrl, '_blank', 'noreferrer');
        } catch (error) {
            fireAnalyticsEvent({
                eventType: 'operational',
                action: 'unexpectedFailure',
                actionSubject: 'requestAccess',
                actionSubjectId: 'cjnNav4',
                attributes: {
                    team: 'puma',
                    targetProduct: targetProduct,
                    messageTemplateId: messageTemplateId,
                    errorMessage: error instanceof Error ? error.message : undefined
                }
            });
            if (typeof globalThis !== 'undefined' && globalThis.window) globalThis.window.open(crossJoinUrl, '_blank', 'noreferrer');
        } finally{
            onComplete();
        }
    }, [
        messageInstanceClicked,
        crossJoinUrl,
        targetProduct,
        collaborators,
        requestAccess,
        showRequestSentFlag,
        fireAnalyticsEvent
    ]);
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $6d4033511f75ada1$export$a1562d08625f5d7e = 'ui';
const $6d4033511f75ada1$export$947dac6c72b26f81 = 'track';
const $6d4033511f75ada1$export$f1d537d508d2945a = 'screen';
const $6d4033511f75ada1$export$12346a674644c156 = 'operational';
const $6d4033511f75ada1$export$b055de0e665cb20c = 'unknown';



parcelRegister("l8ZY4", function(module, exports) {
$parcel$export(module.exports, "targetProduct", () => $33230e4a5b5dcc48$export$f293fa451cdcae93);

var $bh3q1 = parcelRequire("bh3q1");
const $33230e4a5b5dcc48$export$f293fa451cdcae93 = {
    productId: (0, $bh3q1.ConfluenceCloudCcpId),
    productKey: 'confluence'
};

});


parcelRegister("e31Mx", function(module, exports) {
$parcel$export(module.exports, "default", () => $b150c74a96b8324a$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $383Ee = parcelRequire("383Ee");

var $4btyr = parcelRequire("4btyr");

var $9nZMA = parcelRequire("9nZMA");
const $b150c74a96b8324a$export$b3890eb0ae9dca99 = (0, $383Ee.createRender)((props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $4btyr.JiraSideNavCrossJoinMessage), {
        ...props,
        targetProduct: (0, $9nZMA.targetProduct).productKey
    }));
var $b150c74a96b8324a$export$2e2bcd8739ae039 = $b150c74a96b8324a$export$b3890eb0ae9dca99;

});
parcelRegister("383Ee", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $cadfc0813d55abc0$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $cadfc0813d55abc0$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $cadfc0813d55abc0$export$78c758434c34d601 = $cadfc0813d55abc0$var$clientPipeline.createRender;
const $cadfc0813d55abc0$export$2859a83e4d6da57d = $cadfc0813d55abc0$var$clientPipeline.createValidate;
const $cadfc0813d55abc0$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $cadfc0813d55abc0$export$c905bc718befd59b = $cadfc0813d55abc0$var$serverPipeline.createHydrate;
const $cadfc0813d55abc0$export$1f41223e5b0a6622 = $cadfc0813d55abc0$var$serverPipeline.createHydrateExample;
const $cadfc0813d55abc0$export$88fe13b4d13f8423 = $cadfc0813d55abc0$var$serverPipeline.createTransformMetadata;

});

parcelRegister("9nZMA", function(module, exports) {
$parcel$export(module.exports, "targetProduct", () => $ec32cb391d5fefec$export$f293fa451cdcae93);

var $bh3q1 = parcelRequire("bh3q1");
const $ec32cb391d5fefec$export$f293fa451cdcae93 = {
    productId: (0, $bh3q1.JiraProductDiscoveryCcpId),
    productKey: 'jira-product-discovery'
};

});


parcelRegister("SnHzh", function(module, exports) {
$parcel$export(module.exports, "default", () => $10eefc6e0476fd99$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $5NoCd = parcelRequire("5NoCd");

var $4btyr = parcelRequire("4btyr");

var $jxzID = parcelRequire("jxzID");
const $10eefc6e0476fd99$export$b3890eb0ae9dca99 = (0, $5NoCd.createRender)((props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $4btyr.JiraSideNavCrossJoinMessage), {
        ...props,
        targetProduct: (0, $jxzID.targetProduct).productKey
    }));
var $10eefc6e0476fd99$export$2e2bcd8739ae039 = $10eefc6e0476fd99$export$b3890eb0ae9dca99;

});
parcelRegister("5NoCd", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $21f6a883084d9b18$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $21f6a883084d9b18$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $21f6a883084d9b18$export$78c758434c34d601 = $21f6a883084d9b18$var$clientPipeline.createRender;
const $21f6a883084d9b18$export$2859a83e4d6da57d = $21f6a883084d9b18$var$clientPipeline.createValidate;
const $21f6a883084d9b18$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $21f6a883084d9b18$export$c905bc718befd59b = $21f6a883084d9b18$var$serverPipeline.createHydrate;
const $21f6a883084d9b18$export$1f41223e5b0a6622 = $21f6a883084d9b18$var$serverPipeline.createHydrateExample;
const $21f6a883084d9b18$export$88fe13b4d13f8423 = $21f6a883084d9b18$var$serverPipeline.createTransformMetadata;

});

parcelRegister("jxzID", function(module, exports) {
$parcel$export(module.exports, "targetProduct", () => $cba386170006106a$export$f293fa451cdcae93);

var $bh3q1 = parcelRequire("bh3q1");
const $cba386170006106a$export$f293fa451cdcae93 = {
    productId: (0, $bh3q1.LoomCcpId),
    productKey: 'loom'
};

});


parcelRegister("cIPCf", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ee4012ec0050511$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $fumw8 = parcelRequire("fumw8");

var $bOTQw = parcelRequire("bOTQw");
const $6ee4012ec0050511$export$b3890eb0ae9dca99 = (0, $bOTQw.createRender)(({ rovoOnboardingUrl: rovoOnboardingUrl, onDismissed: onDismissed })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fumw8.RovoOnboardingBanner), {
        action: "ROVO_EXTENSION_CTA",
        onPrimaryActionClick: ()=>rovoOnboardingUrl,
        onDismissClick: onDismissed
    });
});
var $6ee4012ec0050511$export$2e2bcd8739ae039 = $6ee4012ec0050511$export$b3890eb0ae9dca99;

});
parcelRegister("fumw8", function(module, exports) {
$parcel$export(module.exports, "RovoOnboardingBanner", () => $ea088ede0cbd38ea$export$badffec00386b3b8);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $j142y = parcelRequire("j142y");

var $hUqPj = parcelRequire("hUqPj");

var $9ufM9 = parcelRequire("9ufM9");

var $2iotI = parcelRequire("2iotI");

var $ihEDU = parcelRequire("ihEDU");
var $2XXtG = parcelRequire("2XXtG");
var $8Sdzy = parcelRequire("8Sdzy");

var $3gxI9 = parcelRequire("3gxI9");

var $iKPvC = parcelRequire("iKPvC");

var $fGrpH = parcelRequire("fGrpH");

var $7eNDO = parcelRequire("7eNDO");
var $55qdj = parcelRequire("55qdj");

var $cF84f = parcelRequire("cF84f");

var $4hvcz = parcelRequire("4hvcz");
const $ea088ede0cbd38ea$var$i18n = (0, $7eNDO.defineMessages)({
    headingLabel: {
        id: 'post-office.confluence-rovo-onboarding-banner.heading',
        defaultMessage: 'Rovo is ready for you',
        description: 'Heading for the Rovo onboarding banner.'
    },
    bodyLabel: {
        id: 'post-office.confluence-rovo-onboarding-banner.body',
        defaultMessage: "Power up your workspace. Set up and configure connectors to unlock all Rovo's potential.",
        description: 'Body text for the Rovo onboarding banner.'
    },
    callToActionLabel: {
        id: 'post-office.confluence-rovo-onboarding-banner.call.to.action',
        defaultMessage: 'Get started',
        description: 'Call to action button on the Rovo onboarding banner.'
    },
    whyAmISeeingThisModalMessage: {
        id: 'post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.message',
        defaultMessage: "We think setting up Rovo and connecting apps will improve your team's productivity. You're seeing this because Rovo is available to your team, and as an organizational admin you can extend Rovo's features by configuring connectors.",
        description: 'Message explaining why the user is seeing this banner.'
    },
    whyAmISeeingThisModalReason: {
        id: 'post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.reason',
        defaultMessage: 'Rovo is available to your team and you are an organizational admin',
        description: 'Reason for showing the banner.'
    }
});
const $ea088ede0cbd38ea$var$styles = {
    root: "_2rko1mok _kqswh2mm _16jlkb7n _bfhk1s93",
    primaryContentContainer: "_1yt4pxbi _16jlkb7n",
    headingContainer: "_zulpu2gc _1e0c1txw _4cvr1h6o",
    iconContainer: "_1o9zidpf _1bsbzwfg _4t3izwfg",
    ctaWrapper: "_19pk1b66",
    adControlsContainer: "_kqswstnw _154iu2gc _1xi2u2gc"
};
const $ea088ede0cbd38ea$export$badffec00386b3b8 = ({ action: action, orgId: orgIdFromMessage, onPrimaryActionClick: onPrimaryActionClick, onDismissClick: onDismissClick })=>{
    const postOfficeContext = (0, $j142y.usePostOfficeContext)();
    // Use orgId from message context first; fallback to product/placement context (e.g. when message payload omits it but event context has it)
    const orgId = orgIdFromMessage ?? (typeof postOfficeContext?.orgId === 'string' ? postOfficeContext.orgId : undefined);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $iKPvC.useMessageInstanceEvent)();
    (0, $euxye.useEffect)(()=>{
        if (!messageInstanceViewed) return;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'ConfluenceRovoOnboardingBanner'
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireMessageInstanceClicked = ({ actionType: actionType, clickedElement: clickedElement })=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: clickedElement,
            action: {
                actionType: actionType
            },
            additionalMetadataFromFrontend: {}
        });
    };
    const rovoAdminUrl = (0, $euxye.useMemo)(()=>{
        if (!globalThis.location) return '#';
        const envType = (0, $cF84f.getEnvTypeFromHostname)(globalThis.location.hostname);
        return (0, $cF84f.getRovoOnboardingClickUrl)(orgId, envType);
    }, [
        orgId
    ]);
    const handleOnPrimaryActionClick = ()=>{
        fireMessageInstanceClicked({
            actionType: 'open',
            clickedElement: {
                clickIdentifier: 'getStarted',
                clickedElement: 'button',
                buttonType: 'primary'
            }
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoOnboardingBannerCta'
        });
        onPrimaryActionClick?.(action);
        if (rovoAdminUrl && rovoAdminUrl !== '#' && globalThis.location) globalThis.location.href = rovoAdminUrl;
    };
    const handleOnDismissed = (_dismissedMessageInstanceId)=>{
        onDismissClick?.();
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hUqPj.default), {
        data: {
            source: 'confluence-rovo-onboarding-banner'
        },
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2XXtG.Flex), {
            xcss: $ea088ede0cbd38ea$var$styles.root,
            testId: "confluence-rovo-onboarding-banner",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2XXtG.Flex), {
                    xcss: $ea088ede0cbd38ea$var$styles.primaryContentContainer,
                    gap: "space.100",
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2XXtG.Flex), {
                            xcss: $ea088ede0cbd38ea$var$styles.headingContainer,
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                                    xcss: $ea088ede0cbd38ea$var$styles.iconContainer,
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4hvcz.ROVO_ICON), {})
                                }),
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                        ...$ea088ede0cbd38ea$var$i18n.headingLabel
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                            size: "small",
                            color: "color.text.subtle",
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                ...$ea088ede0cbd38ea$var$i18n.bodyLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                            xcss: $ea088ede0cbd38ea$var$styles.ctaWrapper,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9ufM9.default), {
                                href: rovoAdminUrl,
                                onClick: handleOnPrimaryActionClick,
                                spacing: "compact",
                                target: "_self",
                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                    ...$ea088ede0cbd38ea$var$i18n.callToActionLabel
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                    xcss: $ea088ede0cbd38ea$var$styles.adControlsContainer,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3gxI9.AdControls), {
                        iconSize: "small",
                        spacing: "compact",
                        onDismissed: handleOnDismissed,
                        showWhyAmISeeingThis: true,
                        whyAmISeeingThisModalContent: {
                            message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                ...$ea088ede0cbd38ea$var$i18n.whyAmISeeingThisModalMessage
                            }),
                            reasons: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                    ...$ea088ede0cbd38ea$var$i18n.whyAmISeeingThisModalReason
                                }, "reason")
                            ]
                        }
                    })
                })
            ]
        })
    });
};
$ea088ede0cbd38ea$export$badffec00386b3b8.displayName = "RovoOnboardingBanner";

});
parcelRegister("cF84f", function(module, exports) {
$parcel$export(module.exports, "getEnvTypeFromHostname", () => $bb325647ce08b54a$export$469d38ee9e6df4c6);
$parcel$export(module.exports, "getRovoOnboardingClickUrl", () => $bb325647ce08b54a$export$d3d28c6fd94dcc27);
/**
 * Derives environment type from the current hostname (for use in browser).
 * Prod -> admin.atlassian.com; staging/dev/other -> admin.stg.atlassian.com (org path appended when building URLs).
 */ function $bb325647ce08b54a$export$469d38ee9e6df4c6(hostname) {
    if (typeof hostname !== 'string') return 'prod';
    const h = hostname.toLowerCase();
    if (h.includes('dev.') || h.includes('.dev')) return 'dev';
    if (h.includes('stg') || h.includes('staging')) return 'staging';
    return 'prod';
}
function $bb325647ce08b54a$export$76bb37a926058cca(envType) {
    return envType === 'prod' ? 'https://admin.atlassian.com' : 'https://admin.stg.atlassian.com';
}
function $bb325647ce08b54a$export$1f35d872aef2b7bd(orgId, envType) {
    const base = envType === 'prod' ? 'https://admin.atlassian.com' : 'https://admin.stg.atlassian.com';
    return `${base}/o/${orgId}/rovo`;
}
function $bb325647ce08b54a$export$d3d28c6fd94dcc27(orgId, envType) {
    if (orgId && orgId.trim() !== '') return $bb325647ce08b54a$export$1f35d872aef2b7bd(orgId, envType);
    return $bb325647ce08b54a$export$76bb37a926058cca(envType);
}

});

parcelRegister("4hvcz", function(module, exports) {
$parcel$export(module.exports, "ROVO_ICON", () => $eb3a7a3ed8daf61a$export$5b537697406f44db);

var $e79Pd = parcelRequire("e79Pd");

var $5bDMW = parcelRequire("5bDMW");
const $eb3a7a3ed8daf61a$export$5b537697406f44db = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5bDMW))),
        alt: "Rovo",
        width: 32,
        height: 32
    });
$eb3a7a3ed8daf61a$export$5b537697406f44db.displayName = "ROVO_ICON";

});
parcelRegister("5bDMW", function(module, exports) {
module.exports = new URL("rovo-icon.999e8c7b.png", import.meta.url).toString();

});



parcelRegister("bOTQw", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $940352c3733a1a5a$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $940352c3733a1a5a$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $940352c3733a1a5a$export$78c758434c34d601 = $940352c3733a1a5a$var$clientPipeline.createRender;
const $940352c3733a1a5a$export$2859a83e4d6da57d = $940352c3733a1a5a$var$clientPipeline.createValidate;
const $940352c3733a1a5a$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $940352c3733a1a5a$export$c905bc718befd59b = $940352c3733a1a5a$var$serverPipeline.createHydrate;
const $940352c3733a1a5a$export$1f41223e5b0a6622 = $940352c3733a1a5a$var$serverPipeline.createHydrateExample;
const $940352c3733a1a5a$export$88fe13b4d13f8423 = $940352c3733a1a5a$var$serverPipeline.createTransformMetadata;

});


parcelRegister("bg49M", function(module, exports) {
$parcel$export(module.exports, "default", () => $04367fd6f4fb4b9b$export$2e2bcd8739ae039);
/* render.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1PFcg = parcelRequire("1PFcg");

var $m9iwH = parcelRequire("m9iwH");

var $1MNmN = parcelRequire("1MNmN");

var $2XXtG = parcelRequire("2XXtG");
var $6mEZn = parcelRequire("6mEZn");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $i68tN = parcelRequire("i68tN");

var $b8zYL = parcelRequire("b8zYL");

var $i2sOf = parcelRequire("i2sOf");

var $cIG5B = parcelRequire("cIG5B");

var $gIXtk = parcelRequire("gIXtk");

var $4C7HL = parcelRequire("4C7HL");

var $fGrpH = parcelRequire("fGrpH");

var $kdOoc = parcelRequire("kdOoc");

var $iKPvC = parcelRequire("iKPvC");

var $8faAl = parcelRequire("8faAl");

var $65OgE = parcelRequire("65OgE");

const $04367fd6f4fb4b9b$var$LazyRecommendRetrialModal = /*#__PURE__*/ (0, $euxye.lazy)(()=>(parcelRequire("43nFa")).then((module)=>({
            default: module.RecommendRetrialModal
        })));
const $04367fd6f4fb4b9b$var$recommendRetrialStorageClient = new (0, $8faAl.default)('jira-recommend-retrial-modal', {
    storageEngine: 'localStorage'
});
const $04367fd6f4fb4b9b$var$SEEN_KEY = 'seen';
const $04367fd6f4fb4b9b$export$8e631fc40a764b32 = ()=>{
    return $04367fd6f4fb4b9b$var$recommendRetrialStorageClient.getItem($04367fd6f4fb4b9b$var$SEEN_KEY) === true;
};
const $04367fd6f4fb4b9b$export$180a0df46c4dfc10 = ()=>{
    $04367fd6f4fb4b9b$var$recommendRetrialStorageClient.setItemWithExpiry($04367fd6f4fb4b9b$var$SEEN_KEY, true);
};
const $04367fd6f4fb4b9b$var$bannerStyles = {
    banner: "_2rko1mok _1rjcutpp _bfhkhfxm _bozg12x7 _y4tiu2gc _k8m0t8hk _1oecfnf5",
    bannerHovered: "_bfhkysee",
    button: "_zulpv77o _1e0c1txw _4cvr1h6o _y3gn1e5h _bfhk18uv _1bsb1osq"
};
const $04367fd6f4fb4b9b$var$getBannerFormattedMessage = (bannerMessage, suggestedFeature)=>(0, $65OgE.BANNER_MESSAGES)[suggestedFeature][bannerMessage];
const $04367fd6f4fb4b9b$var$BannerIcon = ({ suggestedFeature: suggestedFeature, isDarkMode: isDarkMode })=>{
    if (suggestedFeature === 'Plans') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $i2sOf.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b8zYL))),
        alt: "",
        height: 32,
        width: 32
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $i2sOf.default), {
        src: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($gIXtk))) : (0, (/*@__PURE__*/$parcel$interopDefault($cIG5B))),
        alt: "",
        height: 32,
        width: 32
    });
};
$04367fd6f4fb4b9b$var$BannerIcon.displayName = "BannerIcon";
const $04367fd6f4fb4b9b$var$RecommendRetrialBanner = ({ onCtaClick: onCtaClick, onDismiss: onDismiss, suggestedFeature: suggestedFeature, isDarkMode: isDarkMode })=>{
    const [isHovered, setIsHovered] = (0, $euxye.useState)(false);
    const onMouseEnter = (0, $euxye.useCallback)(()=>{
        setIsHovered(true);
    }, []);
    const onMouseLeave = (0, $euxye.useCallback)(()=>{
        setIsHovered(false);
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2XXtG.Flex), {
        xcss: (0, $1MNmN.cx)($04367fd6f4fb4b9b$var$bannerStyles.banner, isHovered && $04367fd6f4fb4b9b$var$bannerStyles.bannerHovered),
        gap: "space.200",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $6mEZn.Pressable), {
                xcss: $04367fd6f4fb4b9b$var$bannerStyles.button,
                testId: "jira-recommend-retrial-banner-cta",
                onClick: onCtaClick,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)($04367fd6f4fb4b9b$var$BannerIcon, {
                        suggestedFeature: suggestedFeature,
                        isDarkMode: isDarkMode
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
                        space: "space.050",
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                                size: "medium",
                                weight: "medium",
                                children: $04367fd6f4fb4b9b$var$getBannerFormattedMessage('heading', suggestedFeature)
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                                size: "medium",
                                weight: "medium",
                                color: "color.link",
                                children: $04367fd6f4fb4b9b$var$getBannerFormattedMessage('cta', suggestedFeature)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($i68tN))),
                appearance: "subtle",
                label: "Close",
                isTooltipDisabled: false,
                onClick: onDismiss,
                spacing: "compact"
            })
        ]
    });
};
$04367fd6f4fb4b9b$var$RecommendRetrialBanner.displayName = "RecommendRetrialBanner";
const $04367fd6f4fb4b9b$var$MessageFrontend = ({ onDismissed: onDismissed, edition: edition, placeOrderLiteHref: placeOrderLiteHref, suggestedFeature: suggestedFeature, trialLength: trialLength, hasPaymentDetails: hasPaymentDetails, changeOfferingUrl: changeOfferingUrl, permissionsUrl: permissionsUrl, shouldForceOpenModal: shouldForceOpenModal, entitlementId: entitlementId })=>{
    // Lazy initializer: read storage only once at mount, not on every re-render.
    const [isOpen, setIsOpen] = (0, $euxye.useState)(()=>shouldForceOpenModal && !$04367fd6f4fb4b9b$export$8e631fc40a764b32());
    const hasFiredBannerViewedRef = (0, $euxye.useRef)(false);
    const { messageDismissed: messageDismissed } = (0, $kdOoc.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $iKPvC.useMessageInstanceEvent)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    const sendModalViewedEvent = (0, $euxye.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'jiraRecommendRetrialModal',
            attributes: {
                edition: edition,
                suggestedFeature: suggestedFeature,
                trialLength: trialLength,
                hasPaymentDetails: hasPaymentDetails,
                entitlementId: entitlementId
            }
        });
    }, [
        fireAnalyticsEvent,
        edition,
        suggestedFeature,
        trialLength,
        hasPaymentDetails,
        entitlementId
    ]); // Once the modal is open (auto or user-opened), mark as seen so it won't auto-open again after refresh.
    (0, $euxye.useEffect)(()=>{
        if (isOpen) {
            sendModalViewedEvent();
            !$04367fd6f4fb4b9b$export$8e631fc40a764b32() && $04367fd6f4fb4b9b$export$180a0df46c4dfc10();
        }
    }, [
        isOpen,
        sendModalViewedEvent
    ]);
    const handleOpen = (0, $euxye.useCallback)(()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'bannerOpen',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {}
        });
        setIsOpen(true);
    }, [
        messageInstanceClicked
    ]);
    const handleClose = (0, $euxye.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'closeJiraRecommendRetrialModal',
            attributes: {
                edition: edition,
                suggestedFeature: suggestedFeature,
                trialLength: trialLength,
                hasPaymentDetails: hasPaymentDetails,
                entitlementId: entitlementId
            }
        });
        $04367fd6f4fb4b9b$export$180a0df46c4dfc10();
        setIsOpen(false);
    }, [
        fireAnalyticsEvent,
        edition,
        suggestedFeature
    ]);
    const handleOnComplete = (0, $euxye.useCallback)(()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'tryNow',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {
                completionStatus: 'success'
            }
        }).catch(()=>{
            fireAnalyticsEvent({
                eventType: 'operational',
                action: 'failed',
                actionSubject: 'messageInstanceClicked',
                actionSubjectId: 'jiraRecommendRetrialModal'
            });
        });
        switch(suggestedFeature){
            case 'Permissions':
                if (!permissionsUrl) {
                    // Worse case scenario is we don't know the permissions route, reloading them on the
                    // new edition is better than not allowing them to proceed
                    globalThis.window.location.reload();
                    return;
                }
                globalThis.window.location.href = permissionsUrl;
                break;
            case 'Plans':
                globalThis.window.location.href = '/jira/plans?create-plan=true';
                break;
        }
        onDismissed();
    }, [
        messageInstanceClicked,
        fireAnalyticsEvent,
        onDismissed,
        suggestedFeature,
        permissionsUrl
    ]);
    const handleDismissBanner = (0, $euxye.useCallback)(()=>{
        $04367fd6f4fb4b9b$export$180a0df46c4dfc10();
        messageDismissed();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        onDismissed();
    }, [
        messageDismissed,
        messageInstanceClicked,
        onDismissed
    ]);
    (0, $euxye.useEffect)(()=>{
        if (hasFiredBannerViewedRef.current) return;
        hasFiredBannerViewedRef.current = true;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'jiraRecommendRetrialBanner',
            attributes: {
                edition: edition,
                suggestedFeature: suggestedFeature,
                trialLength: trialLength,
                hasPaymentDetails: hasPaymentDetails,
                entitlementId: entitlementId
            }
        });
    }, [
        messageInstanceViewed,
        fireAnalyticsEvent,
        edition,
        suggestedFeature,
        trialLength,
        hasPaymentDetails,
        entitlementId
    ]);
    const { colorMode: colorMode } = (0, $4C7HL.default)();
    const isDarkMode = colorMode === 'dark';
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)($04367fd6f4fb4b9b$var$RecommendRetrialBanner, {
                onCtaClick: handleOpen,
                onDismiss: handleDismissBanner,
                suggestedFeature: suggestedFeature,
                isDarkMode: isDarkMode
            }),
            isOpen && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)($04367fd6f4fb4b9b$var$LazyRecommendRetrialModal, {
                    isOpen: isOpen,
                    onClose: handleClose,
                    onComplete: handleOnComplete,
                    suggestedFeature: suggestedFeature,
                    edition: edition,
                    trialLength: trialLength,
                    placeOrderLiteHref: placeOrderLiteHref,
                    hasPaymentDetails: hasPaymentDetails,
                    changeOfferingUrl: changeOfferingUrl
                })
            })
        ]
    });
};
$04367fd6f4fb4b9b$var$MessageFrontend.displayName = "MessageFrontend";
const $04367fd6f4fb4b9b$export$b3890eb0ae9dca99 = (0, $1PFcg.createRender)((props)=>/*#__PURE__*/ (0, $e79Pd.jsx)($04367fd6f4fb4b9b$var$MessageFrontend, {
        ...props
    }));
var $04367fd6f4fb4b9b$export$2e2bcd8739ae039 = $04367fd6f4fb4b9b$export$b3890eb0ae9dca99;

});
parcelRegister("1PFcg", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $e61e52d0edc4c9fa$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $e61e52d0edc4c9fa$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $e61e52d0edc4c9fa$export$78c758434c34d601 = $e61e52d0edc4c9fa$var$clientPipeline.createRender;
const $e61e52d0edc4c9fa$export$2859a83e4d6da57d = $e61e52d0edc4c9fa$var$clientPipeline.createValidate;
const $e61e52d0edc4c9fa$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $e61e52d0edc4c9fa$export$c905bc718befd59b = $e61e52d0edc4c9fa$var$serverPipeline.createHydrate;
const $e61e52d0edc4c9fa$export$1f41223e5b0a6622 = $e61e52d0edc4c9fa$var$serverPipeline.createHydrateExample;
const $e61e52d0edc4c9fa$export$88fe13b4d13f8423 = $e61e52d0edc4c9fa$var$serverPipeline.createTransformMetadata;

});

parcelRegister("b8zYL", function(module, exports) {
module.exports = new URL("rocket.d43563e7.svg", import.meta.url).toString();

});

parcelRegister("cIG5B", function(module, exports) {
module.exports = new URL("lock-light.32750474.svg", import.meta.url).toString();

});

parcelRegister("gIXtk", function(module, exports) {
module.exports = new URL("lock-dark.46e56ad1.svg", import.meta.url).toString();

});

parcelRegister("65OgE", function(module, exports) {
$parcel$export(module.exports, "BANNER_MESSAGES", () => $1d96356bf3f427cf$export$71ed91b36aca6f1e);
$parcel$export(module.exports, "MODAL_HEADING_MESSAGES", () => $1d96356bf3f427cf$export$94c37fc6c2346fb4);
$parcel$export(module.exports, "FEATURE_MESSAGES", () => $1d96356bf3f427cf$export$9bea6737cd8cf6d4);

var $e79Pd = parcelRequire("e79Pd");

var $55qdj = parcelRequire("55qdj");

var $jEIQf = parcelRequire("jEIQf");

var $4Olij = parcelRequire("4Olij");

var $8LNQ0 = parcelRequire("8LNQ0");

var $iUEwc = parcelRequire("iUEwc");

var $cKxq6 = parcelRequire("cKxq6");
const $1d96356bf3f427cf$export$71ed91b36aca6f1e = {
    Plans: {
        heading: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth-luna.jira-recommend-retrial.banner.title.plans",
            defaultMessage: "See all your timelines in one plan",
            description: "Banner title for suggested Plans paid feature"
        }),
        cta: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth-luna.jira-recommend-retrial.banner.cta.plans",
            defaultMessage: "Create a plan",
            description: "Banner CTA for suggested Plans paid feature"
        })
    },
    Permissions: {
        heading: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth-luna.jira-recommend-retrial.banner.title.permissions",
            defaultMessage: "Keep work secure",
            description: "Banner title for suggested Permissions paid feature"
        }),
        cta: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth-luna.jira-recommend-retrial.banner.cta.permissions",
            defaultMessage: "Set up permissions",
            description: "Banner CTA for suggested Permissions paid feature"
        })
    }
};
const $1d96356bf3f427cf$export$94c37fc6c2346fb4 = {
    Plans: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "growth-luna.jira-recommend-retrial.placement.suggested-feature.plans",
        defaultMessage: "See all your timelines in one plan",
        description: "Heading for suggested Plans paid feature"
    }),
    Permissions: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "growth-luna.jira-recommend-retrial.placement.suggested-feature.permissions",
        defaultMessage: "Keep work secure and organized",
        description: "Heading for suggested Permissions paid feature"
    })
};
const $1d96356bf3f427cf$export$9bea6737cd8cf6d4 = {
    Plans: [
        {
            id: 'growth-luna.jira-recommend-retrial.plans.team-progress',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4Olij))),
            message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth-luna.jira-recommend-retrial.plans.team-progress",
                defaultMessage: "See every team's progress in one place",
                description: "Description for seeing team progress feature"
            })
        },
        {
            id: 'growth-luna.jira-recommend-retrial.plans.break-into-steps',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jEIQf))),
            message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth-luna.jira-recommend-retrial.plans.break-into-steps",
                defaultMessage: "Break plans into achievable steps with AI",
                description: "Description for breaking plans into achievable steps with AI feature"
            })
        },
        {
            id: 'growth-luna.jira-recommend-retrial.plans.customize-view',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cKxq6))),
            message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth-luna.jira-recommend-retrial.plans.customize-view",
                defaultMessage: "Customize your view to suit you",
                description: "Description for customizing your view feature"
            })
        }
    ],
    Permissions: [
        {
            id: 'growth-luna.jira-recommend-retrial.permissions.assign-roles',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4Olij))),
            message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth-luna.jira-recommend-retrial.permissions.assign-roles",
                defaultMessage: "Assign roles for groups, teams, or individuals",
                description: "Description for assigning roles feature"
            })
        },
        {
            id: 'growth-luna.jira-recommend-retrial.permissions.set-custom-permissions',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8LNQ0))),
            message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth-luna.jira-recommend-retrial.permissions.set-custom-permissions",
                defaultMessage: "Set custom permissions for each role",
                description: "Description for setting custom permissions feature"
            })
        },
        {
            id: 'growth-luna.jira-recommend-retrial.permissions.allow-customer-submissions',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iUEwc))),
            message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth-luna.jira-recommend-retrial.permissions.allow-customer-submissions",
                defaultMessage: "Allow customers to submit bugs and requests",
                description: "Description for allowing customer submissions feature"
            })
        }
    ]
};

});
parcelRegister("jEIQf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7431dcc384fff9c6c35ed6e93ee3cd4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4f489652e968c07$var$_react = $e4f489652e968c07$var$_interopRequireDefault((parcelRequire("euxye")));

var $e4f489652e968c07$var$_baseNew = $e4f489652e968c07$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $e4f489652e968c07$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/rovo
 * Usage guidance:
 * Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e4f489652e968c07$var$RovoIcon = (props)=>/*#__PURE__*/ $e4f489652e968c07$var$_react.default.createElement($e4f489652e968c07$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$e4f489652e968c07$var$RovoIcon.displayName = 'RovoIcon';
var $e4f489652e968c07$var$_default = module.exports.default = $e4f489652e968c07$var$RovoIcon;

});

parcelRegister("iUEwc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5d3d9d6e3e85035380dd9bd51f6b6794>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc4ce310f978334f$var$_react = $dc4ce310f978334f$var$_interopRequireDefault((parcelRequire("euxye")));

var $dc4ce310f978334f$var$_baseNew = $dc4ce310f978334f$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $dc4ce310f978334f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Send".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/send
 * Usage guidance:
 * Single purpose - Reserved for sending messages in Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dc4ce310f978334f$var$SendIcon = (props)=>/*#__PURE__*/ $dc4ce310f978334f$var$_react.default.createElement($dc4ce310f978334f$var$_baseNew.default, Object.assign({
        name: "SendIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 1.22a.75.75 0 0 1 .173.79l-5 13.5a.75.75 0 0 1-1.361.1l-2.895-5.307L.391 7.408A.75.75 0 0 1 .49 6.047l13.5-5a.75.75 0 0 1 .79.173M7.177 9.884l1.942 3.56 3.237-8.74zm4.118-6.24L2.556 6.881l3.56 1.942z" clip-rule="evenodd"/>`
    }, props));
$dc4ce310f978334f$var$SendIcon.displayName = 'SendIcon';
var $dc4ce310f978334f$var$_default = module.exports.default = $dc4ce310f978334f$var$SendIcon;

});


parcelRegister("43nFa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kbgN9").then(()=>parcelRequire('7CBej'));

});


parcelRegister("6DOe4", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ec90da529fe2c2c$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $4tQwE = parcelRequire("4tQwE");

var $euxye = parcelRequire("euxye");

var $dy4m1 = parcelRequire("dy4m1");

var $56mAt = parcelRequire("56mAt");

var $Msr28 = parcelRequire("Msr28");

var $8faAl = parcelRequire("8faAl");
const $3ec90da529fe2c2c$var$storageClient = new (0, $8faAl.default)('jira-twcg-810-trial-ad-modal', {
    storageEngine: 'localStorage'
});
const $3ec90da529fe2c2c$var$SEEN_KEY = 'seen';
const $3ec90da529fe2c2c$var$getSeenValue = ()=>$3ec90da529fe2c2c$var$storageClient.getItem($3ec90da529fe2c2c$var$SEEN_KEY) === true;
const $3ec90da529fe2c2c$var$setSeenValue = ()=>$3ec90da529fe2c2c$var$storageClient.setItemWithExpiry($3ec90da529fe2c2c$var$SEEN_KEY, true);
const $3ec90da529fe2c2c$export$b3890eb0ae9dca99 = (0, $4tQwE.createRender)(({ edition: edition, entitlementId: entitlementId, recommendedFeature: recommendedFeature, recommendedFeatureHref: recommendedFeatureHref, trialLength: trialLength, headlineCount: headlineCount, placeOrderLiteHref: placeOrderLiteHref, shouldForceOpenModal: shouldForceOpenModal, onDismissed: onDismissed })=>{
    const [isModalOpen, setIsModalOpen] = (0, $euxye.useState)(()=>shouldForceOpenModal && !$3ec90da529fe2c2c$var$getSeenValue());
    const analyticsAttributes = (0, $euxye.useMemo)(()=>({
            edition: edition,
            recommendedFeature: recommendedFeature,
            trialLength: trialLength,
            entitlementId: entitlementId
        }), [
        edition,
        recommendedFeature,
        trialLength,
        entitlementId
    ]);
    (0, $euxye.useEffect)(()=>{
        if (isModalOpen && !$3ec90da529fe2c2c$var$getSeenValue()) $3ec90da529fe2c2c$var$setSeenValue();
    }, [
        isModalOpen
    ]);
    const handleBannerClick = (0, $euxye.useCallback)(()=>{
        setIsModalOpen(true);
    }, []);
    const handleModalClose = (0, $euxye.useCallback)(()=>{
        $3ec90da529fe2c2c$var$setSeenValue();
        setIsModalOpen(false);
    }, []);
    const handleDismissBanner = (0, $euxye.useCallback)(()=>{
        $3ec90da529fe2c2c$var$setSeenValue();
        onDismissed();
    }, [
        onDismissed
    ]);
    // Trial completed: close modal AND dismiss the banner so it doesn't reappear.
    const handleModalComplete = (0, $euxye.useCallback)(()=>{
        setIsModalOpen(false);
        onDismissed();
        if (recommendedFeature === 'rovo') try {
            const currentUrl = new URL(globalThis.window.location.href);
            currentUrl.searchParams.set('rovoChatTriggerOpen', 'true');
            globalThis.window.location.href = currentUrl.toString();
            return;
        } catch  {
        // Fall back to the recommended feature href below.
        }
        globalThis.window.location.href = recommendedFeatureHref;
    }, [
        onDismissed,
        recommendedFeature,
        recommendedFeatureHref
    ]);
    const { Icon: Icon, TitleMessage: TitleMessage, CtaMessage: CtaMessage } = (0, $56mAt.BANNER_CONTENT)[recommendedFeature];
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dy4m1.SidenavBanner), {
                onClick: handleBannerClick,
                onDismiss: handleDismissBanner,
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {}),
                title: /*#__PURE__*/ (0, $e79Pd.jsx)(TitleMessage, {
                    count: headlineCount
                }),
                cta: /*#__PURE__*/ (0, $e79Pd.jsx)(CtaMessage, {}),
                bannerName: "jiraTwcg810UpgradeFreeCustomersBanner",
                analyticsAttributes: analyticsAttributes
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $Msr28.UpgradeModal), {
                isOpen: isModalOpen,
                onClose: handleModalClose,
                onComplete: handleModalComplete,
                recommendedFeature: recommendedFeature,
                edition: edition,
                trialLength: trialLength,
                headlineCount: headlineCount,
                placeOrderLiteHref: placeOrderLiteHref
            })
        ]
    });
});
var $3ec90da529fe2c2c$export$2e2bcd8739ae039 = $3ec90da529fe2c2c$export$b3890eb0ae9dca99;

});
parcelRegister("4tQwE", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $d24620f88aedc8c5$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $d24620f88aedc8c5$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $d24620f88aedc8c5$export$78c758434c34d601 = $d24620f88aedc8c5$var$clientPipeline.createRender;
const $d24620f88aedc8c5$export$2859a83e4d6da57d = $d24620f88aedc8c5$var$clientPipeline.createValidate;
const $d24620f88aedc8c5$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $d24620f88aedc8c5$export$c905bc718befd59b = $d24620f88aedc8c5$var$serverPipeline.createHydrate;
const $d24620f88aedc8c5$export$1f41223e5b0a6622 = $d24620f88aedc8c5$var$serverPipeline.createHydrateExample;
const $d24620f88aedc8c5$export$88fe13b4d13f8423 = $d24620f88aedc8c5$var$serverPipeline.createTransformMetadata;

});

parcelRegister("dy4m1", function(module, exports) {
$parcel$export(module.exports, "SidenavBanner", () => $545f546a91c93dc3$export$ca5a453a35ef482d);
/* SidenavBanner.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $1MNmN = parcelRequire("1MNmN");

var $2XXtG = parcelRequire("2XXtG");
var $6mEZn = parcelRequire("6mEZn");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $i68tN = parcelRequire("i68tN");

var $fGrpH = parcelRequire("fGrpH");

var $kdOoc = parcelRequire("kdOoc");

var $iKPvC = parcelRequire("iKPvC");
const $545f546a91c93dc3$var$bannerStyles = {
    banner: "_2rko1mok _1rjcutpp _bfhkhfxm _bozg12x7 _y4tiu2gc _k8m0t8hk _1oecfnf5",
    bannerHovered: "_bfhkysee",
    button: "_zulp1b66 _1e0c1txw _4cvr1h6o _y3gn1e5h _bfhk18uv _1bsb1osq",
    contentStack: "_16jlkb7n _1o9zkb7n _i0dlf1ug _uhwnidpf"
};
function $545f546a91c93dc3$export$ca5a453a35ef482d({ onClick: onClick, onDismiss: onDismiss, icon: icon, title: title, cta: cta, bannerName: bannerName, analyticsAttributes: analyticsAttributes }) {
    const hasFiredViewedRef = (0, $euxye.useRef)(false);
    const { messageDismissed: messageDismissed } = (0, $kdOoc.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $iKPvC.useMessageInstanceEvent)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    const [isHovered, setIsHovered] = (0, $euxye.useState)(false);
    const onMouseEnter = (0, $euxye.useCallback)(()=>{
        setIsHovered(true);
    }, []);
    const onMouseLeave = (0, $euxye.useCallback)(()=>{
        setIsHovered(false);
    }, []);
    const handleOnClick = (0, $euxye.useCallback)(()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'bannerOpen',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {}
        });
        onClick();
    }, [
        messageInstanceClicked,
        onClick
    ]);
    const handleDismiss = (0, $euxye.useCallback)(()=>{
        messageDismissed();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        onDismiss();
    }, [
        messageDismissed,
        messageInstanceClicked,
        onDismiss
    ]);
    (0, $euxye.useEffect)(()=>{
        if (hasFiredViewedRef.current) return;
        hasFiredViewedRef.current = true;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: bannerName,
            attributes: analyticsAttributes
        });
    }, [
        messageInstanceViewed,
        fireAnalyticsEvent,
        analyticsAttributes,
        bannerName
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2XXtG.Flex), {
        xcss: (0, $1MNmN.cx)($545f546a91c93dc3$var$bannerStyles.banner, isHovered && $545f546a91c93dc3$var$bannerStyles.bannerHovered),
        gap: "space.200",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $6mEZn.Pressable), {
                xcss: $545f546a91c93dc3$var$bannerStyles.button,
                testId: "jira-twcg-810-banner-cta",
                onClick: handleOnClick,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                children: [
                    icon,
                    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
                        space: "space.050",
                        xcss: $545f546a91c93dc3$var$bannerStyles.contentStack,
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                                size: "medium",
                                weight: "medium",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                                size: "medium",
                                weight: "medium",
                                color: "color.link",
                                children: cta
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($i68tN))),
                appearance: "subtle",
                label: "Close",
                isTooltipDisabled: false,
                onClick: handleDismiss,
                spacing: "compact"
            })
        ]
    });
}
$545f546a91c93dc3$export$ca5a453a35ef482d.displayName = "SidenavBanner";

});

parcelRegister("56mAt", function(module, exports) {
$parcel$export(module.exports, "BANNER_CONTENT", () => $56f44cabb303f940$export$de059a94f61602df);
/* content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $eprc4 = parcelRequire("eprc4");

var $3YQge = parcelRequire("3YQge");

var $udAcI = parcelRequire("udAcI");

var $i2sOf = parcelRequire("i2sOf");

var $ihEDU = parcelRequire("ihEDU");
const $56f44cabb303f940$var$styles = {
    rovoLogo: "_y4ti1b66"
};
function $56f44cabb303f940$var$PlansTitleMessage({ count: count }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "growth-luna.jira-twcg-810-upgrade-free.placement.banner.plans.title",
        defaultMessage: "Keep your {count} projects on track",
        description: "Title of the sidenav banner for the Plans variation, prompting free Jira users to upgrade.",
        values: {
            count: count
        }
    });
}
$56f44cabb303f940$var$PlansTitleMessage.displayName = "PlansTitleMessage";
function $56f44cabb303f940$var$PlansCtaMessage() {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "growth-luna.jira-twcg-810-upgrade-free.placement.banner.plans.cta",
        defaultMessage: "Try Plans",
        description: "CTA link text on the sidenav banner for the Plans variation."
    });
}
$56f44cabb303f940$var$PlansCtaMessage.displayName = "PlansCtaMessage";
function $56f44cabb303f940$var$AutomationsTitleMessage({ count: count }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "growth-luna.jira-twcg-810-upgrade-free.placement.banner.automations.title",
        defaultMessage: "Keep your {count} rules running",
        description: "Title of the sidenav banner for the Automations variation, prompting free Jira users to upgrade.",
        values: {
            count: count
        }
    });
}
$56f44cabb303f940$var$AutomationsTitleMessage.displayName = "AutomationsTitleMessage";
function $56f44cabb303f940$var$AutomationsCtaMessage() {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "growth-luna.jira-twcg-810-upgrade-free.placement.banner.automations.cta",
        defaultMessage: "Get more runs",
        description: "CTA link text on the sidenav banner for the Automations variation."
    });
}
$56f44cabb303f940$var$AutomationsCtaMessage.displayName = "AutomationsCtaMessage";
function $56f44cabb303f940$var$RovoTitleMessage({ count: count }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "growth-luna.jira-twcg-810-upgrade-free.placement.banner.rovo.title",
        defaultMessage: "{count, plural, =0 {Stay across your team's tasks} one {Stay across your team's # task} other {Stay across your team's # tasks}}",
        description: "Title of the sidenav banner for the Rovo variation, prompting free Jira users to upgrade.",
        values: {
            count: count
        }
    });
}
$56f44cabb303f940$var$RovoTitleMessage.displayName = "RovoTitleMessage";
function $56f44cabb303f940$var$RovoCtaMessage() {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "growth-luna.jira-twcg-810-upgrade-free.placement.banner.rovo.cta",
        defaultMessage: "Try Rovo",
        description: "CTA link text on the sidenav banner for the Rovo variation."
    });
}
$56f44cabb303f940$var$RovoCtaMessage.displayName = "RovoCtaMessage";
function $56f44cabb303f940$var$RovoIconWrapper() {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $56f44cabb303f940$var$styles.rovoLogo,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.RovoIcon), {
            label: "",
            size: "small",
            shouldUseHexLogo: true
        })
    });
}
$56f44cabb303f940$var$RovoIconWrapper.displayName = "RovoIconWrapper";
function $56f44cabb303f940$var$Compass() {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $i2sOf.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($udAcI))),
        alt: "",
        height: 32,
        width: 32
    });
}
$56f44cabb303f940$var$Compass.displayName = "Compass";
function $56f44cabb303f940$var$Bolt() {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $i2sOf.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3YQge))),
        alt: "",
        height: 32,
        width: 32
    });
}
$56f44cabb303f940$var$Bolt.displayName = "Bolt";
const $56f44cabb303f940$export$de059a94f61602df = {
    plans: {
        Icon: $56f44cabb303f940$var$Compass,
        TitleMessage: $56f44cabb303f940$var$PlansTitleMessage,
        CtaMessage: $56f44cabb303f940$var$PlansCtaMessage
    },
    automations: {
        Icon: $56f44cabb303f940$var$Bolt,
        TitleMessage: $56f44cabb303f940$var$AutomationsTitleMessage,
        CtaMessage: $56f44cabb303f940$var$AutomationsCtaMessage
    },
    rovo: {
        Icon: $56f44cabb303f940$var$RovoIconWrapper,
        TitleMessage: $56f44cabb303f940$var$RovoTitleMessage,
        CtaMessage: $56f44cabb303f940$var$RovoCtaMessage
    }
};

});
parcelRegister("3YQge", function(module, exports) {
module.exports = new URL("bolt.587bafbb.svg", import.meta.url).toString();

});

parcelRegister("udAcI", function(module, exports) {
module.exports = new URL("compass.f482dc1a.svg", import.meta.url).toString();

});


parcelRegister("Msr28", function(module, exports) {
$parcel$export(module.exports, "UpgradeModal", () => $9e94abb3dcfb8de1$export$72c362f751994d32);
/* UpgradeModal.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2iotI = parcelRequire("2iotI");

var $7tY81 = parcelRequire("7tY81");

var $gpyJM = parcelRequire("gpyJM");

var $9imxF = parcelRequire("9imxF");

var $ihEDU = parcelRequire("ihEDU");
var $2XXtG = parcelRequire("2XXtG");
var $gwWMf = parcelRequire("gwWMf");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $4C7HL = parcelRequire("4C7HL");

var $eprc4 = parcelRequire("eprc4");

var $3NtUb = parcelRequire("3NtUb");

var $fGrpH = parcelRequire("fGrpH");

var $iKPvC = parcelRequire("iKPvC");

var $6Zl63 = parcelRequire("6Zl63");

var $dLdAN = parcelRequire("dLdAN");

var $1YIbA = parcelRequire("1YIbA");
const $9e94abb3dcfb8de1$var$modalStyles = {
    root: "_yv0e1eon _4t3i1osq",
    darkSurface: "_bfhkvuon",
    feature: "_zulputpp _4cvr1h6o",
    left: "_1yt4oahv _zulpoahv _1bah1yb4 _1e0c1txw",
    right: "_1reo15vq _18m915vq _kqswh2mm _qrwq1mok _1o0z1mok _1bsb13bx _4t3iufrr",
    rightHeader: "_kqswstnw _154iidpf _1xi2idpf _1pbykb7n",
    animation: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3i1osq"
};






/**
 * Webpack cannot reliably analyze dynamic paths (template literals) for chunking.
 * Using explicit static import paths ensures Webpack correctly bundles each animation
 * JSON as a separate async chunk.
 */ const $9e94abb3dcfb8de1$var$ModalSideAnimation = ({ isDarkMode: isDarkMode, recommendedFeature: recommendedFeature })=>{
    const [animationData, setAnimationData] = (0, $euxye.useState)(null);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        const loadJson = async ()=>{
            try {
                // Each import path must be a static string literal for Webpack chunking.
                // recommendedFeature and isDarkMode are used to select the correct branch.
                const data = await (recommendedFeature === 'plans' ? isDarkMode ? (parcelRequire("kc4cm")) : (parcelRequire("jUhhs")) : recommendedFeature === 'automations' ? isDarkMode ? (parcelRequire("etRvm")) : (parcelRequire("8ZONB")) : isDarkMode ? (parcelRequire("lpKdl")) : (parcelRequire("bd4H9")));
                const json = data.default || data; /**
                                            * Lottie mutates the animationData object internally during playback.
                                            * We use JSON.parse(JSON.stringify()) to provide a clean deep copy,
                                            * preventing side effects when the same JSON is reused across re-renders or theme changes.
                                            */ 
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                setAnimationData(JSON.parse(JSON.stringify(json)));
            } catch (error) {
                fireAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'lottieAnimationLoad',
                    actionSubjectId: 'jiraTwcg810UpgradeModal',
                    attributes: {
                        team: 'growth-luna',
                        recommendedFeature: recommendedFeature
                    }
                });
            }
        };
        loadJson();
    }, [
        isDarkMode,
        fireAnalyticsEvent,
        recommendedFeature
    ]);
    if (!animationData) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $9e94abb3dcfb8de1$var$modalStyles.animation
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $9e94abb3dcfb8de1$var$modalStyles.animation,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6Zl63))), {
            animationData: animationData,
            loop: true,
            autoplay: true
        })
    });
};
$9e94abb3dcfb8de1$var$ModalSideAnimation.displayName = "ModalSideAnimation";
const $9e94abb3dcfb8de1$export$72c362f751994d32 = ({ isOpen: isOpen, onClose: onClose, onComplete: onComplete, recommendedFeature: recommendedFeature, edition: edition, trialLength: trialLength, headlineCount: headlineCount, placeOrderLiteHref: placeOrderLiteHref })=>{
    const { colorMode: colorMode } = (0, $4C7HL.default)();
    const isDarkMode = colorMode === 'dark';
    const placeOrderHrefWithTheme = `${placeOrderLiteHref}&theme=${isDarkMode ? 'dark' : 'light'}`;
    const hasFiredViewedRef = (0, $euxye.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $iKPvC.useMessageInstanceEvent)();
    const intl = (0, $1YIbA.default)();
    const handleError = (0, $euxye.useCallback)((error)=>{
        fireAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: 'trialAction',
            actionSubjectId: 'jiraTwcg810UpgradeModal',
            attributes: {
                team: 'growth-luna',
                errorMessage: error?.message
            }
        });
    }, [
        fireAnalyticsEvent
    ]);
    const handleOnOrderPlaced = (0, $euxye.useCallback)(()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'tryNow',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {
                completionStatus: 'success',
                wasEffectivelyOnClick: true
            }
        });
    }, [
        messageInstanceClicked
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isOpen) return;
        if (hasFiredViewedRef.current) return;
        hasFiredViewedRef.current = true;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'jiraTwcg810UpgradeModal',
            attributes: {
                team: 'growth-luna',
                recommendedFeature: recommendedFeature,
                edition: edition,
                trialLength: trialLength
            }
        });
    }, [
        isOpen,
        messageInstanceViewed,
        fireAnalyticsEvent,
        recommendedFeature,
        edition,
        trialLength
    ]);
    const { HeadingMessage: HeadingMessage, BodyMessage: BodyMessage, features: features } = (0, $dLdAN.MODAL_CONTENT)[recommendedFeature];
    const handleOnClose = (0, $euxye.useCallback)((_e, analyticEvent)=>{
        // Reuse the event provided by @atlaskit/modal-dialog so we keep its
        // context (e.g. the Modal/component path) while still setting the
        // Post Office actionSubjectId we rely on for reporting.
        analyticEvent.update({
            eventType: 'ui',
            actionSubject: 'button',
            action: 'clicked',
            actionSubjectId: 'jiraTwcg810UpgradeModalClose'
        }).fire((0, $fGrpH.ANALYTICS_CHANNEL));
        onClose();
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9imxF.default), {
        children: isOpen && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7tY81.default), {
            width: 968,
            height: 560,
            onClose: handleOnClose,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                xcss: isDarkMode ? $9e94abb3dcfb8de1$var$modalStyles.darkSurface : undefined,
                children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $gwWMf.Grid), {
                    xcss: $9e94abb3dcfb8de1$var$modalStyles.root,
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
                            xcss: $9e94abb3dcfb8de1$var$modalStyles.left,
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
                                    space: "space.400",
                                    children: [
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.JiraLogo), {
                                            size: "small",
                                            appearance: "brand",
                                            shouldUseNewLogoDesign: true
                                        }),
                                        /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
                                            space: "space.200",
                                            children: [
                                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                                                    size: "large",
                                                    as: "h1",
                                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)(HeadingMessage, {
                                                        count: headlineCount
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
                                                    space: "space.300",
                                                    children: [
                                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)(BodyMessage, {
                                                                trialLength: trialLength,
                                                                edition: edition
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3PC9r.Stack), {
                                                            space: "space.200",
                                                            children: features.map(({ id: id, Icon: Icon, message: message })=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2XXtG.Flex), {
                                                                    xcss: $9e94abb3dcfb8de1$var$modalStyles.feature,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
                                                                            size: "medium",
                                                                            label: "",
                                                                            color: "var(--ds-icon-brand, #1868DB)"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                                                                            children: message
                                                                        })
                                                                    ]
                                                                }, id))
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NtUb.PlaceOrderLite), {
                                    href: placeOrderHrefWithTheme,
                                    product: "jira",
                                    edition: edition,
                                    onComplete: onComplete,
                                    onOrderPlaced: handleOnOrderPlaced,
                                    onError: handleError,
                                    primaryAction: intl.formatMessage({
                                        id: 'growth-luna.jira-twcg-810-upgrade-free.action.primary.pde',
                                        defaultMessage: 'Try it free',
                                        description: 'Start trial with payment details on file'
                                    }),
                                    actionsAlignment: "horizontal"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.Box), {
                            xcss: $9e94abb3dcfb8de1$var$modalStyles.right,
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)($9e94abb3dcfb8de1$var$ModalSideAnimation, {
                                    isDarkMode: isDarkMode,
                                    recommendedFeature: recommendedFeature
                                }),
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                                    xcss: $9e94abb3dcfb8de1$var$modalStyles.rightHeader,
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gpyJM.default), {
                                        hasCloseButton: true
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
$9e94abb3dcfb8de1$export$72c362f751994d32.displayName = "UpgradeModal";

});
parcelRegister("3NtUb", function(module, exports) {
$parcel$export(module.exports, "PlaceOrderLite", () => $22313a3d61750960$export$1ae6db6dd2411e03);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $cxpqA = parcelRequire("cxpqA");

var $4E3Wu = parcelRequire("4E3Wu");

var $ga1EL = parcelRequire("ga1EL");
function $22313a3d61750960$export$1ae6db6dd2411e03({ href: href, product: product, edition: edition, onComplete: onComplete, onOrderPlaced: onOrderPlaced, onError: onError, onMessage: onMessage, onSecondaryAction: onSecondaryAction, secondaryAction: secondaryAction, primaryAction: primaryAction, actionsAlignment: actionsAlignment, trialTrigger: trialTrigger, trialType: trialType }) {
    const [hasUpgraded, setHasUpgraded] = (0, $euxye.useState)(false);
    const handleOnOrderComplete = (0, $euxye.useCallback)(()=>{
        setHasUpgraded(true);
        onOrderPlaced?.();
    }, [
        onOrderPlaced
    ]);
    if (!hasUpgraded) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4E3Wu.CommerceEmbed), {
        onError: onError,
        onComplete: handleOnOrderComplete,
        onMessage: onMessage,
        href: href,
        product: product,
        onSecondaryAction: onSecondaryAction,
        secondaryAction: secondaryAction,
        primaryAction: primaryAction,
        actionsAlignment: actionsAlignment,
        trialTrigger: trialTrigger,
        trialType: trialType
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cxpqA.AtlassianRelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ga1EL.PollingForUpgrade), {
            onComplete: onComplete,
            onError: onError,
            product: product,
            edition: edition
        })
    });
}
$22313a3d61750960$export$1ae6db6dd2411e03.displayName = "PlaceOrderLite";

});
parcelRegister("4E3Wu", function(module, exports) {
$parcel$export(module.exports, "CommerceEmbed", () => $af606fb7120e2eb0$export$a682c90381558c1a);
/* CommerceEmbed.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $3zT69 = parcelRequire("3zT69");

var $ihEDU = parcelRequire("ihEDU");
var $3PC9r = parcelRequire("3PC9r");

var $3NRLa = parcelRequire("3NRLa");

var $4C7HL = parcelRequire("4C7HL");

var $aIqwy = parcelRequire("aIqwy");
const $af606fb7120e2eb0$export$5a01ec5e3068630c = {
    ['confluence']: 'confluence',
    ['jira']: 'jira',
    ['jira-product-discovery']: 'jira',
    ['jira-service-management']: 'jira'
};
const $af606fb7120e2eb0$var$styles = {
    sdkLoading: "_4t3it94y _3um015vq _kqswstnw"
};
function $af606fb7120e2eb0$var$CommerceExperienceContainer({ isLoading: isLoading, children: children }) {
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            isLoading ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
                space: "space.400",
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
                        width: "100%",
                        height: "32px",
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
                        width: "100%",
                        height: "32px",
                        isShimmering: true
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                xcss: isLoading ? $af606fb7120e2eb0$var$styles.sdkLoading : undefined,
                "aria-hidden": isLoading,
                children: children
            })
        ]
    });
}
$af606fb7120e2eb0$var$CommerceExperienceContainer.displayName = "CommerceExperienceContainer";
function $af606fb7120e2eb0$export$a682c90381558c1a({ actionsAlignment: actionsAlignment, href: href, onComplete: onComplete, onError: onError, onMessage: onMessage, product: product, primaryAction: primaryAction, secondaryAction: secondaryAction, onSecondaryAction: onSecondaryAction, trialTrigger: trialTrigger, trialType: trialType }) {
    const { colorMode: colorMode } = (0, $4C7HL.default)();
    const origin = (0, $euxye.useMemo)(()=>new (0, $3zT69.default)({
            product: $af606fb7120e2eb0$export$5a01ec5e3068630c[product]
        }), [
        product
    ]);
    const embeddedUrl = (0, $euxye.useMemo)(()=>origin.addToUrl(href), [
        href,
        origin
    ]);
    const [isLoadingSdk, setIsLoadingSdk] = (0, $euxye.useState)(true);
    const handleOnLoad = (0, $euxye.useCallback)(()=>{
        setIsLoadingSdk(false);
    }, []);
    (0, $euxye.useEffect)(()=>{
        if (!isLoadingSdk) return;
         /**
       * The Commerce SDK iframe is hidden initially while we wait for it to load.
       * But, hiding an iframe on the page _might_ lead to the browser preventing the iframe from loading.
       * So, we always set the loading state to false after 5 seconds just in case.
       */ 
        const timeout = setTimeout(()=>{
            setIsLoadingSdk(false);
        }, 5000);
        return ()=>clearTimeout(timeout);
    }, [
        isLoadingSdk,
        setIsLoadingSdk
    ]);
    const configuration = (0, $euxye.useMemo)(()=>{
        if (!embeddedUrl) return {};
        const config = Object.fromEntries(new URL(embeddedUrl).searchParams);
        if (colorMode === 'dark') config.theme = 'dark';
        if (primaryAction) config.primaryAction = primaryAction;
        if (secondaryAction) config.secondaryAction = secondaryAction;
        if (actionsAlignment) config.actionsAlignment = actionsAlignment;
        if (trialTrigger) config.trialTrigger = trialTrigger;
        if (trialType) config.trialType = trialType;
        return config;
    }, [
        embeddedUrl,
        colorMode,
        primaryAction,
        secondaryAction,
        actionsAlignment,
        trialTrigger,
        trialType
    ]);
    const onMessageHandler = (0, $euxye.useCallback)((message)=>{
        if ('secondaryActionClicked' in message && onSecondaryAction) onSecondaryAction();
        onMessage?.(message);
    }, [
        onSecondaryAction,
        onMessage
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($af606fb7120e2eb0$var$CommerceExperienceContainer, {
        isLoading: isLoadingSdk,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $aIqwy.default), {
            url: embeddedUrl,
            configuration: configuration,
            onError: onError,
            onComplete: onComplete,
            onMessage: onMessageHandler,
            onLoad: handleOnLoad
        })
    });
}
$af606fb7120e2eb0$export$a682c90381558c1a.displayName = "CommerceEmbed";

});
parcelRegister("aIqwy", function(module, exports) {
$parcel$export(module.exports, "default", () => $f555020a5eb99970$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $8g99p = parcelRequire("8g99p");
const $f555020a5eb99970$var$styles = {
    container: "_1reo15vq _18m915vq _4t3i1osq _1bsb1osq"
};
/**
 * Renders a commerce experience iframe.
 *
 * Please ensure you have checked availability of the SDK in this environment before using this component
 * via the useIsAvailableSdk hook from this package.
 * @param {string} props.url The URL for the iframe.
 * @param {Function} props.onComplete Callback for completion events. Should be memoized with useCallback.
 * @param {Function} props.onError Callback for error events. Should be memoized with useCallback.
 * @param {Function} props.onLoad Callback for load events. Should be memoized with useCallback.
 * @param {Object} props.configuration Configuration object for the iframe. Changes to this object will cause the component to re-render.
 * @param {string} props.title Accessible name for the iframe (title attribute). Recommended for accessibility.
 *
 * @returns {React.ReactElement} A div element containing the commerce experience iframe.
 */ const $f555020a5eb99970$var$CommerceExperience = ({ url: url, onComplete: onComplete, onLoad: onLoad, onError: onError, onMessage: onMessage, configuration: configuration, useFullUrl: useFullUrl, title: title, xcss: xcss, testId: testId })=>{
    const containerRef = (0, $euxye.useRef)(null);
    const commerceExperienceIframe = (0, $euxye.useRef)(null);
    // We stringify the configuration in order to make sure the dependency array does not cause re-renders
    const stringifiedConfiguration = JSON.stringify(configuration || {});
    (0, $euxye.useEffect)(()=>{
        if (containerRef.current) {
            commerceExperienceIframe.current = new (0, $8g99p.CommerceExperience)(url, {
                container: containerRef.current,
                onComplete: onComplete,
                onError: onError,
                onMessage: onMessage,
                onLoad: onLoad,
                configuration: JSON.parse(stringifiedConfiguration),
                useFullUrl: useFullUrl,
                title: title
            });
            commerceExperienceIframe.current?.init();
        }
        return ()=>{
            commerceExperienceIframe.current?.cleanup();
        };
    }, [
        url,
        onComplete,
        onError,
        stringifiedConfiguration,
        onMessage,
        onLoad,
        useFullUrl,
        title
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: containerRef,
        className: (0, $4jQY2.default)([
            $f555020a5eb99970$var$styles.container,
            xcss
        ]),
        "data-testid": testId
    });
};
$f555020a5eb99970$var$CommerceExperience.displayName = "CommerceExperience";
var $f555020a5eb99970$export$2e2bcd8739ae039 = $f555020a5eb99970$var$CommerceExperience;

});
parcelRegister("8g99p", function(module, exports) {
$parcel$export(module.exports, "CommerceExperience", () => $cfebb9df47fb2c30$export$65c1176b77c6ad31);

var $egELO = parcelRequire("egELO");
class $cfebb9df47fb2c30$export$65c1176b77c6ad31 {
    /**
	 * Creates an instance of CommerceExperienceIframe.
	 *
	 * @param {string} url The URL to be loaded in the iframe.
	 * @param {IframeOptions} options Options for the iframe.
	 */ constructor(url, options){
        this.options = options;
        this.iframeManager = new (0, $egELO.IFrameManager)(url, options.configuration, options.useFullUrl, options.title);
    }
    /**
	 * Initializes the iframe and sets up callbacks on window.
	 */ init() {
        const iframe = this.iframeManager.create(this.options.container);
        if (this.options.onLoad) iframe.onload = this.options.onLoad;
        if (iframe.contentWindow) iframe.contentWindow.cexp_sdk = {
            onComplete: this.options.onComplete,
            onError: this.options.onError,
            onMessage: this.options.onMessage
        };
    }
    /**
	 * Cleans up resources and stops listening for messages.
	 */ cleanup() {
        this.iframeManager.remove();
    }
}

});
parcelRegister("egELO", function(module, exports) {
$parcel$export(module.exports, "IFrameManager", () => $0185907bac37b5f4$export$5cdd44db74d265ce);

var $g2ycS = parcelRequire("g2ycS");

var $ejZRW = parcelRequire("ejZRW");
class $0185907bac37b5f4$export$5cdd44db74d265ce {
    constructor(href, configurationOptions, useFullUrl, title){
        this.iframe = null;
        const url = useFullUrl ? new URL(href) : (0, $ejZRW.convertToSameOrigin)(href);
        this.iframeURL = (0, $g2ycS.appendQueryParams)(url, configurationOptions);
        this.iframeTitle = title;
    }
    get origin() {
        return this.iframeURL.origin;
    }
    create(container) {
        this.iframe = document.createElement('iframe');
        this.iframe.src = this.iframeURL.href;
        if (this.iframeTitle) this.iframe.title = this.iframeTitle;
        this.iframe.style.border = '0px';
        this.iframe.style.minWidth = '100%';
        this.iframe.style.height = '100%';
        container.appendChild(this.iframe);
        return this.iframe;
    }
    remove() {
        if (this.iframe && this.iframe.parentElement) {
            this.iframe.parentElement.removeChild(this.iframe);
            this.iframe = null;
        }
    }
}

});
parcelRegister("g2ycS", function(module, exports) {
$parcel$export(module.exports, "appendQueryParams", () => $f33f4ab8a8453e1c$export$a0b32aef6b0d7373);

var $iQpeA = parcelRequire("iQpeA");
function $f33f4ab8a8453e1c$export$a0b32aef6b0d7373(url, configurationOptions) {
    if (configurationOptions) {
        const sanitizedConfigurationOptions = $f33f4ab8a8453e1c$export$f69e046d5386ed61(configurationOptions);
        const existingParams = new URLSearchParams(url.search);
        Object.entries(sanitizedConfigurationOptions).forEach(([key, value])=>{
            if (Array.isArray(value)) existingParams.set(key, value.join(','));
            else if ((0, $iQpeA.isOfferingAction)(value)) existingParams.set(key, Object.entries(value).map((item)=>item.join(':')).join(','));
            else if (value) existingParams.set(key, value);
        });
        url.search = existingParams.toString();
    }
    return url;
}
function $f33f4ab8a8453e1c$export$f69e046d5386ed61(options) {
    const sanitizedOptions = {};
    Object.entries(options).forEach(([key, value])=>{
        if (Array.isArray(value)) // Filter out non-string values and null/undefined elements
        sanitizedOptions[key] = value.filter((item)=>typeof item === 'string' && item != null);
        else if (typeof value === 'string') // Include only string values
        sanitizedOptions[key] = value;
        else if ((0, $iQpeA.isOfferingAction)(value)) {
            const filtered = Object.entries(value).filter((item)=>{
                const offering = item[0];
                const action = item[1];
                return (0, $iQpeA.isOffering)(offering) && (0, $iQpeA.isAction)(action);
            });
            sanitizedOptions[key] = Object.fromEntries(filtered);
        }
    // Omit null, undefined, and non-string types
    });
    return sanitizedOptions;
}

});
parcelRegister("iQpeA", function(module, exports) {
$parcel$export(module.exports, "isOffering", () => $8ad1261d86f0f6f0$export$897a334e5115d516);
$parcel$export(module.exports, "isAction", () => $8ad1261d86f0f6f0$export$b956e38827fca970);
$parcel$export(module.exports, "isOfferingAction", () => $8ad1261d86f0f6f0$export$2cfdf9f1b96a75e);
function $8ad1261d86f0f6f0$export$897a334e5115d516(value) {
    return [
        'free',
        'standard',
        'premium'
    ].includes(value);
}
function $8ad1261d86f0f6f0$export$b956e38827fca970(value) {
    return [
        'startTrial',
        'directBuy',
        'addPayment'
    ].includes(value);
}
function $8ad1261d86f0f6f0$export$2cfdf9f1b96a75e(value) {
    if (!value || typeof value !== 'object') return false;
    // Must have at least one valid key value pair
    return Object.entries(value).some((item)=>{
        const offering = item[0];
        const action = item[1];
        return $8ad1261d86f0f6f0$export$897a334e5115d516(offering) && $8ad1261d86f0f6f0$export$b956e38827fca970(action);
    });
}

});


parcelRegister("ejZRW", function(module, exports) {
$parcel$export(module.exports, "convertToSameOrigin", () => $98da06f88a2fd933$export$b3eeb1359be95e5);

const $98da06f88a2fd933$var$replaceBillingEmbedPath = (path)=>path.replace('/billing', (0, $fcb75bf4edd360f1$export$62b1d6bac3360b4e));
function $98da06f88a2fd933$export$b3eeb1359be95e5(originalUrl) {
    // The original URL is expected to be an absolute URL with the AdminHub origin
    const urlWithAdminhubOrigin = new URL(originalUrl);
    // We convert the URL to the same origin as the current window, with the correct pathname for adminhub billing embed
    const url = new URL(window.location.origin + $98da06f88a2fd933$var$replaceBillingEmbedPath(urlWithAdminhubOrigin.pathname));
    url.search = urlWithAdminhubOrigin.search;
    url.hash = urlWithAdminhubOrigin.hash;
    return url;
}

});
const $fcb75bf4edd360f1$export$62b1d6bac3360b4e = '/admin-embed/billing';






parcelRegister("ga1EL", function(module, exports) {
$parcel$export(module.exports, "PollingForUpgrade", () => $cdac93fbea755468$export$1f022349b34d09cc);

var $e79Pd = parcelRequire("e79Pd");

var $2DXYD = parcelRequire("2DXYD");

var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $n67Vb = parcelRequire("n67Vb");

var $ihEDU = parcelRequire("ihEDU");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $iNFDR = parcelRequire("iNFDR");

var $cxpqA = parcelRequire("cxpqA");

var $k4hYj = parcelRequire("k4hYj");
const $cdac93fbea755468$var$POLL_TIMEOUT = 120000;
const $cdac93fbea755468$var$POLL_INTERVAL = 2000;
const $cdac93fbea755468$var$ProductKeyToHAMSMap = {
    ['confluence']: 'confluence',
    ['jira']: 'jira-software',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['jira-service-management']: 'jira-servicedesk'
};
function $cdac93fbea755468$var$isValidEdition(edition) {
    if (typeof edition !== 'string') return false;
    return [
        'free',
        'standard',
        'premium'
    ].includes(edition);
}
async function $cdac93fbea755468$var$getJiraEdition(product) {
    const response = await fetch('/rest/internal/latest/meta/edition');
    if (!response.ok) throw new Error(`Fetching upgrade status failed with ${response.status}`);
    const data = await response.json();
    const edition = data[$cdac93fbea755468$var$ProductKeyToHAMSMap[product]];
    if (!$cdac93fbea755468$var$isValidEdition(edition)) throw new Error(`Invalid edition ${edition}`);
    return edition;
}
async function $cdac93fbea755468$var$getConfluenceEdition(environment) {
    const response = await (0, $n67Vb.fetchQuery)(environment, (0, $2DXYD.default), {}).toPromise();
    const confluence = response?.confluence_tenantContext?.editions?.confluence?.toLowerCase();
    if (!$cdac93fbea755468$var$isValidEdition(confluence)) throw new Error(`Invalid edition ${confluence}`);
    return confluence;
}
async function $cdac93fbea755468$var$getEdition(product, environment) {
    switch(product){
        case 'confluence':
            return $cdac93fbea755468$var$getConfluenceEdition(environment);
        case 'jira':
        case 'jira-product-discovery':
        case 'jira-service-management':
            return $cdac93fbea755468$var$getJiraEdition(product);
        default:
            throw new Error(`Unsupported product ${product}`);
    }
}
function $cdac93fbea755468$var$pollForUpgrade(product, edition, environment, sendAnalyticsEvents) {
    const pollStartTime = Date.now();
    const pollTimeoutTime = new Date(pollStartTime + $cdac93fbea755468$var$POLL_TIMEOUT).getTime();
    let numberOfAttempts = 0;
    sendAnalyticsEvents({
        action: 'start',
        actionSubject: 'pollForUpgrade',
        attributes: {
            timestamp: pollStartTime,
            package: 'place-order-lite'
        }
    });
    async function poll(resolve, reject) {
        numberOfAttempts++;
        try {
            if (Date.now() > pollTimeoutTime) {
                sendAnalyticsEvents({
                    action: 'timeout',
                    actionSubject: 'pollForUpgrade',
                    attributes: {
                        totalAttempts: numberOfAttempts,
                        totalTimeTakenInMs: Date.now() - pollStartTime,
                        package: 'place-order-lite'
                    }
                });
                return reject(new Error('Timeout'));
            }
            const currentEdition = (await $cdac93fbea755468$var$getEdition(product, environment)).toLowerCase();
            if (currentEdition === edition) {
                sendAnalyticsEvents({
                    action: 'success',
                    actionSubject: 'pollForUpgrade',
                    attributes: {
                        totalAttempts: numberOfAttempts,
                        timeElapsed: Date.now() - pollStartTime,
                        package: 'place-order-lite',
                        currentEdition: currentEdition
                    }
                });
                return resolve(true);
            }
            setTimeout(()=>{
                poll(resolve, reject);
            }, $cdac93fbea755468$var$POLL_INTERVAL);
        } catch (err) {
            sendAnalyticsEvents({
                action: 'error',
                actionSubject: 'pollForUpgrade',
                attributes: {
                    totalAttempts: numberOfAttempts,
                    reason: err instanceof Error ? err.message : 'Unknown error',
                    package: 'place-order-lite'
                }
            });
            return reject(err instanceof Error ? err : new Error('Unknown issue in polling'));
        }
    }
    return new Promise((resolve, reject)=>poll(resolve, reject));
}
function $cdac93fbea755468$export$1f022349b34d09cc({ onComplete: onComplete, onError: onError, product: product, edition: edition, isQuiet: isQuiet }) {
    const environment = (0, $n67Vb.useRelayEnvironment)();
    const isPolling = (0, $euxye.useRef)(false);
    const sendAnalyticsEvents = (0, $k4hYj.useOperationalAnalytics)({
        product: product,
        edition: edition
    });
    const waitTime = product === 'confluence' ? 45 : 15;
    sendAnalyticsEvents({
        action: 'setup',
        actionSubject: 'pollForUpgrade',
        attributes: {
            waitTime: waitTime,
            product: product
        }
    });
    (0, $euxye.useEffect)(()=>{
        if (isPolling.current) return;
        const timeoutId = setTimeout(()=>{
            isPolling.current = true;
            $cdac93fbea755468$var$pollForUpgrade(product, edition, environment, sendAnalyticsEvents).then(()=>onComplete()).catch(onError);
        }, waitTime);
        return ()=>clearTimeout(timeoutId);
    }, [
        product,
        edition,
        onComplete,
        onError,
        environment,
        sendAnalyticsEvents,
        waitTime
    ]);
    if (isQuiet) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iNFDR.default), {
                    isIndeterminate: true
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                    align: "center",
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                        defaultMessage: "Upgrading your workspace, less than a minute remaining...",
                        description: "The workspace is being upgraded for this customer",
                        id: "place-order-lite.polling-for-upgrade.upgrading-message"
                    })
                })
            ]
        })
    });
}
$cdac93fbea755468$export$1f022349b34d09cc.displayName = "PollingForUpgrade";
const $cdac93fbea755468$export$8dccd81592f6fe13 = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $cxpqA.AtlassianRelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($cdac93fbea755468$export$1f022349b34d09cc, {
            ...props
        })
    });
$cdac93fbea755468$export$8dccd81592f6fe13.displayName = "PollingForUpgradeWithAtlassianRelayEnvironmentProvider";

});
parcelRegister("2DXYD", function(module, exports) {
$parcel$export(module.exports, "default", () => $aeb7e4b1792cd005$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c40f965439ea0ec8258487ea2a478803>>
 * @relayHash 71f8bde47f6197baa5dadee2d02eea51
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1d03dfcd1fca795af57653031ca500b34f89544e677c122b3baf4567642fe7d3
const $aeb7e4b1792cd005$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Editions",
                    "kind": "LinkedField",
                    "name": "editions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "confluence"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "PollingForUpgradeQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "PollingForUpgradeQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "id": "1d03dfcd1fca795af57653031ca500b34f89544e677c122b3baf4567642fe7d3",
            "metadata": {},
            "name": "PollingForUpgradeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$aeb7e4b1792cd005$var$node.hash = "a995467541fecb5af81b655175b5a0b1";
var $aeb7e4b1792cd005$export$2e2bcd8739ae039 = $aeb7e4b1792cd005$var$node;

});

parcelRegister("k4hYj", function(module, exports) {
$parcel$export(module.exports, "useOperationalAnalytics", () => $99ee7439b4748c35$export$18e9461e904f638a);

var $euxye = parcelRequire("euxye");

var $bHcfq = parcelRequire("bHcfq");

var $inMxE = parcelRequire("inMxE");
function $99ee7439b4748c35$export$18e9461e904f638a({ product: product, edition: edition }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    return (0, $euxye.useCallback)(({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
        const event = createAnalyticsEvent({
            eventType: 'operational',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                product: product,
                targetEdition: edition,
                ...attributes
            }
        });
        event.fire((0, $bHcfq.FabricChannel).growth);
    }, [
        createAnalyticsEvent,
        product,
        edition
    ]);
}

});



parcelRegister("dLdAN", function(module, exports) {
$parcel$export(module.exports, "MODAL_CONTENT", () => $86ba010c0e0af467$export$1d667487890459d5);

var $e79Pd = parcelRequire("e79Pd");

var $55qdj = parcelRequire("55qdj");

var $alDF5 = parcelRequire("alDF5");

var $4Olij = parcelRequire("4Olij");

var $eYjNM = parcelRequire("eYjNM");

var $kJKna = parcelRequire("kJKna");

var $1i1gd = parcelRequire("1i1gd");

var $iueV3 = parcelRequire("iueV3");

var $jEIQf = parcelRequire("jEIQf");

var $bWgx4 = parcelRequire("bWgx4");
// ─── Plans ───────────────────────────────────────────────────────────────────
function $86ba010c0e0af467$var$PlansHeading({ count: count }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "growth-luna.jira-twcg-810-upgrade-free.modal.plans.heading",
        defaultMessage: "Keep your {count} projects on track",
        description: "Modal heading for the Plans variation of the upgrade modal.",
        values: {
            count: count
        }
    });
}
$86ba010c0e0af467$var$PlansHeading.displayName = "PlansHeading";
function $86ba010c0e0af467$var$PlansBody({ trialLength: trialLength, edition: edition }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "growth-luna.jira-twcg-810-upgrade-free.modal.plans.body",
        defaultMessage: "See progress across your team's work in one view. Try Plans free for {trialLength} days with {edition, select, premium {Premium} standard {Standard} other {Standard}}.",
        description: "Modal body text for the Plans variation of the upgrade modal.",
        values: {
            trialLength: trialLength,
            edition: edition
        }
    });
}
$86ba010c0e0af467$var$PlansBody.displayName = "PlansBody";
// ─── Automations ─────────────────────────────────────────────────────────────
function $86ba010c0e0af467$var$AutomationsHeading({ count: count }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "growth-luna.jira-twcg-810-upgrade-free.modal.automations.heading",
        defaultMessage: "Keep your {count} rules running",
        description: "Modal heading for the Automations variation of the upgrade modal.",
        values: {
            count: count
        }
    });
}
$86ba010c0e0af467$var$AutomationsHeading.displayName = "AutomationsHeading";
function $86ba010c0e0af467$var$AutomationsBody({ trialLength: trialLength, edition: edition }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "growth-luna.jira-twcg-810-upgrade-free.modal.automations.body",
        defaultMessage: "Your team has already used half your free automation runs. Try a higher limit free for {trialLength} days with {edition, select, premium {Premium} standard {Standard} other {Standard}}.",
        description: "Modal body text for the Automations variation of the upgrade modal.",
        values: {
            trialLength: trialLength,
            edition: edition
        }
    });
}
$86ba010c0e0af467$var$AutomationsBody.displayName = "AutomationsBody";
// ─── Rovo ────────────────────────────────────────────────────────────────────
function $86ba010c0e0af467$var$RovoHeading({ count: count }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "growth-luna.jira-twcg-810-upgrade-free.modal.rovo.heading",
        defaultMessage: "{count, plural, =0 {Stay across your team's tasks} one {Stay across your team's # task} other {Stay across your team's # tasks}}",
        description: "Modal heading for the Rovo variation of the upgrade modal.",
        values: {
            count: count
        }
    });
}
$86ba010c0e0af467$var$RovoHeading.displayName = "RovoHeading";
function $86ba010c0e0af467$var$RovoBody({ trialLength: trialLength, edition: edition }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "growth-luna.jira-twcg-810-upgrade-free.modal.rovo.body",
        defaultMessage: "Help your team move work in progress faster. Try Rovo AI free for {trialLength} days with {edition, select, premium {Premium} standard {Standard} other {Standard}}.",
        description: "Modal body text for the Rovo variation of the upgrade modal.",
        values: {
            trialLength: trialLength,
            edition: edition
        }
    });
}
$86ba010c0e0af467$var$RovoBody.displayName = "RovoBody";
// ─── Feature rows ─────────────────────────────────────────────────────────────
const $86ba010c0e0af467$var$PLANS_FEATURES = [
    {
        id: 'growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.timelines',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($alDF5))),
        message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.timelines",
            defaultMessage: "Create one view of all your team's timelines",
            description: "Feature bullet: Plans timelines"
        })
    },
    {
        id: 'growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.blockers',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eYjNM))),
        message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.blockers",
            defaultMessage: "Spot blockers early and keep things moving",
            description: "Feature bullet: Plans blockers"
        })
    },
    {
        id: 'growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.goals',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4Olij))),
        message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.goals",
            defaultMessage: "Help your team hit goals together",
            description: "Feature bullet: Plans team goals"
        })
    }
];
const $86ba010c0e0af467$var$AUTOMATIONS_FEATURES = [
    {
        id: 'growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.workflows',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kJKna))),
        message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.workflows",
            defaultMessage: "Keep workflows moving and avoid interruptions",
            description: "Feature bullet: Automations workflows"
        })
    },
    {
        id: 'growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.limit',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1i1gd))),
        message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.limit",
            defaultMessage: "Increase your limit to 1,700 monthly runs",
            description: "Feature bullet: Automations run limit"
        })
    },
    {
        id: 'growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.rovo',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jEIQf))),
        message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.rovo",
            defaultMessage: "Create new automations fast with Rovo AI",
            description: "Feature bullet: Automations with Rovo AI"
        })
    }
];
const $86ba010c0e0af467$var$ROVO_FEATURES = [
    {
        id: 'growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.summaries',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($iueV3))),
        message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.summaries",
            defaultMessage: "Get instant summaries of what's happening",
            description: "Feature bullet: Rovo AI summaries"
        })
    },
    {
        id: 'growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.next-steps',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jEIQf))),
        message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.next-steps",
            defaultMessage: "Turn big work into clearer next steps",
            description: "Feature bullet: Rovo next steps"
        })
    },
    {
        id: 'growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.connect',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bWgx4))),
        message: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.connect",
            defaultMessage: "Connect related and duplicate tasks automatically",
            description: "Feature bullet: Rovo connect tasks"
        })
    }
];
const $86ba010c0e0af467$export$1d667487890459d5 = {
    plans: {
        HeadingMessage: $86ba010c0e0af467$var$PlansHeading,
        BodyMessage: $86ba010c0e0af467$var$PlansBody,
        features: $86ba010c0e0af467$var$PLANS_FEATURES
    },
    automations: {
        HeadingMessage: $86ba010c0e0af467$var$AutomationsHeading,
        BodyMessage: $86ba010c0e0af467$var$AutomationsBody,
        features: $86ba010c0e0af467$var$AUTOMATIONS_FEATURES
    },
    rovo: {
        HeadingMessage: $86ba010c0e0af467$var$RovoHeading,
        BodyMessage: $86ba010c0e0af467$var$RovoBody,
        features: $86ba010c0e0af467$var$ROVO_FEATURES
    }
};

});
parcelRegister("1i1gd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e352727a1bd9b30abdccc90ca5ed341>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f087332725fe54e$var$_react = $0f087332725fe54e$var$_interopRequireDefault((parcelRequire("euxye")));

var $0f087332725fe54e$var$_baseNew = $0f087332725fe54e$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $0f087332725fe54e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/automation
 * Usage guidance:
 * Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f087332725fe54e$var$AutomationIcon = (props)=>/*#__PURE__*/ $0f087332725fe54e$var$_react.default.createElement($0f087332725fe54e$var$_baseNew.default, Object.assign({
        name: "AutomationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$0f087332725fe54e$var$AutomationIcon.displayName = 'AutomationIcon';
var $0f087332725fe54e$var$_default = module.exports.default = $0f087332725fe54e$var$AutomationIcon;

});

parcelRegister("bWgx4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ab14c3313caa89586e17c4b650bccc7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b11ef76fc3d0eef$var$_react = $8b11ef76fc3d0eef$var$_interopRequireDefault((parcelRequire("euxye")));

var $8b11ef76fc3d0eef$var$_baseNew = $8b11ef76fc3d0eef$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $8b11ef76fc3d0eef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItemAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/work-item-add
 * Usage guidance:
 * Reserved for adding or creating a new work item.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b11ef76fc3d0eef$var$WorkItemAddIcon = (props)=>/*#__PURE__*/ $8b11ef76fc3d0eef$var$_react.default.createElement($8b11ef76fc3d0eef$var$_baseNew.default, Object.assign({
        name: "WorkItemAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m11.573 5.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h5.5V14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4v4.5h-1.5z"/><path fill="currentcolor" d="M13.5 9.5V12H16v1.5h-2.5V16H12v-2.5H9.5V12H12V9.5z"/>`
    }, props));
$8b11ef76fc3d0eef$var$WorkItemAddIcon.displayName = 'WorkItemAddIcon';
var $8b11ef76fc3d0eef$var$_default = module.exports.default = $8b11ef76fc3d0eef$var$WorkItemAddIcon;

});


parcelRegister("kc4cm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ktRcT").then(()=>parcelRequire('hAWJu'));

});

parcelRegister("jUhhs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5XHvz").then(()=>parcelRequire('5SEvH'));

});

parcelRegister("etRvm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b2pof").then(()=>parcelRequire('6gKTZ'));

});

parcelRegister("8ZONB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c1Bx3").then(()=>parcelRequire('c221G'));

});

parcelRegister("lpKdl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hyMjF").then(()=>parcelRequire('aCzRr'));

});

parcelRegister("bd4H9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8kGSJ").then(()=>parcelRequire('cvdQq'));

});



parcelRegister("t3Plh", function(module, exports) {
$parcel$export(module.exports, "default", () => $960019fad84dc5ba$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $7ivun = parcelRequire("7ivun");

var $hIYYf = parcelRequire("hIYYf");
const $960019fad84dc5ba$export$b3890eb0ae9dca99 = (0, $7ivun.createRender)(({ onDismissed: onDismissed })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hIYYf.JiraTwgCtaMessage), {
        handleOnDismissed: onDismissed,
        context: {
            source: 'jira-side-nav'
        }
    });
});
var $960019fad84dc5ba$export$2e2bcd8739ae039 = $960019fad84dc5ba$export$b3890eb0ae9dca99;

});
parcelRegister("7ivun", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $b1321b5cc12eec99$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $b1321b5cc12eec99$var$clientPipelineCreator = (0, $k8v9N.createClientPipeline)();
const $b1321b5cc12eec99$export$78c758434c34d601 = $b1321b5cc12eec99$var$clientPipelineCreator.createRender;
const $b1321b5cc12eec99$export$2859a83e4d6da57d = $b1321b5cc12eec99$var$clientPipelineCreator.createValidate;
const $b1321b5cc12eec99$var$serverPipelineCreator = (0, $k8v9N.createServerPipeline)();
const $b1321b5cc12eec99$export$c905bc718befd59b = $b1321b5cc12eec99$var$serverPipelineCreator.createHydrate;
const $b1321b5cc12eec99$export$1f41223e5b0a6622 = $b1321b5cc12eec99$var$serverPipelineCreator.createHydrateExample;
const $b1321b5cc12eec99$export$88fe13b4d13f8423 = $b1321b5cc12eec99$var$serverPipelineCreator.createTransformMetadata;

});

parcelRegister("hIYYf", function(module, exports) {
$parcel$export(module.exports, "JiraTwgCtaMessage", () => $64f3c1cd3aad922c$export$9cc62b74f5ab70eb);
/* JiraTwgCtaMessage.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $3gxI9 = parcelRequire("3gxI9");

var $1MNmN = parcelRequire("1MNmN");

var $4LDqh = parcelRequire("4LDqh");

var $9MWap = parcelRequire("9MWap");
var $ihEDU = parcelRequire("ihEDU");
var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $fGrpH = parcelRequire("fGrpH");

var $iKPvC = parcelRequire("iKPvC");

var $kdOoc = parcelRequire("kdOoc");

var $55qdj = parcelRequire("55qdj");
var $1YIbA = parcelRequire("1YIbA");

var $baIEd = parcelRequire("baIEd");

var $a5TiG = parcelRequire("a5TiG");

var $l6L2Y = parcelRequire("l6L2Y");
const $64f3c1cd3aad922c$var$styles = {
    boxContainer: "_zulpu2gc _2rko1mok _ae4v1h6o _1bah1h6o _1e0c1txw _1bsb1osq _ca0qutpp _n3tdutpp _19bvpxbi _u5f3pxbi _4cvr1y6m _bfhk19ip",
    contentStack: "_zulpu2gc _1bsb1osq",
    headerRow: "_1bah1yb4 _4cvr1h6o _1bsb1osq",
    ctaHeading: "_11c81qyo _18s8ze3t",
    ctaLink: "_1yt4ze3t _2rkolb4i _11c8wadc _4bfu18uv _1hmsglyw _ajmmnqa1 _bfhk1w7a _syaz13af _80omtlke _y3gn1e5h _9oik18uv _1bnx8stv _jf4cnqa1 _9h8h12zz"
};
const $64f3c1cd3aad922c$var$ACTION_SUBJECT = 'rovoJiraTwgCliCta';
const $64f3c1cd3aad922c$var$linkUrl = 'https://teamworkgraph.com/cli?utm_source=jira&utm_medium=cta&utm_campaign=jira_side_nav_v2';
const $64f3c1cd3aad922c$export$9cc62b74f5ab70eb = ({ context: context, handleOnDismissed: handleOnDismissed })=>{
    const { source: source } = context;
    // Exposure is already logged by filterExperimentalMessages in the placement.
    const experimentCohort = (0, $4LDqh.default).getExperimentValue((0, $baIEd.ROVO_JIRA_TWG_CLI_CTA_EXPERIMENT), (0, $baIEd.ROVO_JIRA_TWG_CLI_CTA_TREATMENT_PARAM), (0, $baIEd.RovoJiraTwgCliCtaCohort).CONTROL, {
        fireExperimentExposure: false
    });
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { messageClicked: messageClicked } = (0, $kdOoc.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $iKPvC.useMessageInstanceEvent)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        if (experimentCohort === (0, $baIEd.RovoJiraTwgCliCtaCohort).CONTROL) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: $64f3c1cd3aad922c$var$ACTION_SUBJECT,
            attributes: {
                variant: experimentCohort,
                source: source,
                isTWGGrowthInitiative: true,
                twgInitiativeId: 'rovo_jira_twg_cli_cta_v2',
                twgProductSurface: 'twg_cli',
                engagementType: 'view'
            }
        });
    }, [
        fireAnalyticsEvent,
        experimentCohort,
        source
    ]);
    const handleDismiss = (0, $euxye.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'dismissed',
            actionSubject: $64f3c1cd3aad922c$var$ACTION_SUBJECT,
            attributes: {
                variant: experimentCohort,
                source: source,
                isTWGGrowthInitiative: true,
                twgInitiativeId: 'rovo_jira_twg_cli_cta_v2',
                twgProductSurface: 'twg_cli',
                engagementType: 'dismiss'
            }
        });
        messageClicked();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {
                experimentCohort: experimentCohort,
                source: source
            }
        });
        handleOnDismissed();
    }, [
        fireAnalyticsEvent,
        experimentCohort,
        source,
        messageClicked,
        messageInstanceClicked,
        handleOnDismissed
    ]);
    const handleLinkClick = (0, $euxye.useCallback)(()=>{
        messageClicked();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'installLink',
                clickedElement: 'link'
            },
            action: {
                actionType: 'open',
                destinationUrl: $64f3c1cd3aad922c$var$linkUrl
            },
            additionalMetadataFromFrontend: {
                experimentCohort: experimentCohort,
                source: source
            }
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: $64f3c1cd3aad922c$var$ACTION_SUBJECT,
            attributes: {
                variant: experimentCohort,
                source: source,
                isTWGGrowthInitiative: true,
                twgInitiativeId: 'rovo_jira_twg_cli_cta_v2',
                twgProductSurface: 'twg_cli',
                engagementType: 'click'
            }
        });
    }, [
        experimentCohort,
        source,
        messageClicked,
        messageInstanceClicked
    ]);
    if (experimentCohort === (0, $baIEd.RovoJiraTwgCliCtaCohort).CONTROL) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: (0, $1MNmN.cx)($64f3c1cd3aad922c$var$styles.boxContainer),
        testId: "rovo-jira-twg-cli-cta",
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
            xcss: (0, $1MNmN.cx)($64f3c1cd3aad922c$var$styles.contentStack),
            testId: "rovo-jira-twg-cli-cta-content",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.Inline), {
                    xcss: (0, $1MNmN.cx)($64f3c1cd3aad922c$var$styles.headerRow),
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $l6L2Y.TeamworkGraphIcon), {}),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3gxI9.AdControls), {
                            showWhyAmISeeingThis: true,
                            whyAmISeeingThisModalContent: {
                                reasons: [
                                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                        ...(0, $a5TiG.messages).whyAmISeeingThisReason
                                    }, "reason-1")
                                ]
                            },
                            onDismissed: handleDismiss,
                            spacing: "compact"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                    as: "h3",
                    xcss: (0, $1MNmN.cx)($64f3c1cd3aad922c$var$styles.ctaHeading),
                    children: formatMessage((0, $a5TiG.messages).ctaTitle)
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                    size: "small",
                    color: "color.text.subtlest",
                    children: formatMessage((0, $a5TiG.messages).ctaDescription)
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MWap.Anchor), {
                    href: $64f3c1cd3aad922c$var$linkUrl,
                    onClick: handleLinkClick,
                    testId: "rovo-jira-twg-cli-cta-link",
                    xcss: (0, $1MNmN.cx)($64f3c1cd3aad922c$var$styles.ctaLink),
                    children: formatMessage((0, $a5TiG.messages).ctaLink)
                })
            ]
        })
    });
};
$64f3c1cd3aad922c$export$9cc62b74f5ab70eb.displayName = "JiraTwgCtaMessage";

});
parcelRegister("baIEd", function(module, exports) {
$parcel$export(module.exports, "ROVO_JIRA_TWG_CLI_CTA_EXPERIMENT", () => $5610e407a15fee51$export$34f54fedaffa6788);
$parcel$export(module.exports, "ROVO_JIRA_TWG_CLI_CTA_TREATMENT_PARAM", () => $5610e407a15fee51$export$c6e2c8dcc47b63dd);
$parcel$export(module.exports, "RovoJiraTwgCliCtaCohort", () => $5610e407a15fee51$export$c3022adfd0b04739);
// https://switcheroo.atlassian.com/ui/gates/4f1e2b18-6248-4080-b46a-4e9d2e49af85/key/rovo_jira_twg_cli_cta_filter
// TAP Trait filtering gate
const $5610e407a15fee51$export$a47c5f8e48cc6c05 = 'rovo_jira_twg_cli_cta_filter';
const $5610e407a15fee51$export$2a66ab4662143097 = 'rovo_jira_twg_cli_cta_lifecycle';
const $5610e407a15fee51$export$34f54fedaffa6788 = 'rovo_jira_twg_cli_cta_v2';
const $5610e407a15fee51$export$c6e2c8dcc47b63dd = 'rovo_jira_twg_cli_cta_treatment';
const $5610e407a15fee51$export$c3022adfd0b04739 = {
    CONTROL: 'control',
    TREATMENT: 'treatment'
};

});

parcelRegister("a5TiG", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d87e58eb966f68f1$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $d87e58eb966f68f1$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    ctaTitle: {
        id: 'jira-twg-cli-cta.cta-title',
        defaultMessage: 'Bring Jira context into your terminal',
        description: 'CTA title for the Jira TWG CLI CTA'
    },
    ctaDescription: {
        id: 'jira-twg-cli-cta.cta-description',
        defaultMessage: 'Give your agents better Jira context while using fewer credits. Query open issues and pull tasks from epics with Teamwork Graph CLI.',
        description: 'CTA description for the Jira TWG CLI CTA'
    },
    ctaLink: {
        id: 'jira-twg-cli-cta.cta-link',
        defaultMessage: 'Install the CLI',
        description: 'CTA link text for the Jira TWG CLI CTA'
    },
    whyAmISeeingThisReason: {
        id: 'jira-twg-cli-cta.why-am-i-seeing-this-reason',
        defaultMessage: 'You have indicated interest in using coding agents',
        description: 'Reason for why the user is seeing the Jira TWG CLI CTA'
    }
});

});

parcelRegister("l6L2Y", function(module, exports) {
$parcel$export(module.exports, "TeamworkGraphIcon", () => $cfaf3149963c131a$export$46703f9c3f1cb6ef);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");
const $cfaf3149963c131a$export$46703f9c3f1cb6ef = ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M15.1245 15.125L6.87451 6.875",
                stroke: "#292A2E",
                "stroke-width": "2.0625"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("circle", {
                cx: "4.81201",
                cy: "4.8125",
                r: "2.40625",
                stroke: "#1868DB",
                "stroke-width": "2.0625"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("circle", {
                cx: "4.81201",
                cy: "17.1875",
                r: "2.40625",
                stroke: "#BF63F3",
                "stroke-width": "2.0625"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("circle", {
                cx: "17.187",
                cy: "17.1875",
                r: "2.40625",
                stroke: "#FCA700",
                "stroke-width": "2.0625"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("circle", {
                cx: "17.187",
                cy: "4.8125",
                r: "2.40625",
                stroke: "#6A9A23",
                "stroke-width": "2.0625"
            })
        ]
    });
$cfaf3149963c131a$export$46703f9c3f1cb6ef.displayName = "TeamworkGraphIcon";

});



parcelRegister("8z9Bz", function(module, exports) {
$parcel$export(module.exports, "default", () => $8409da11f2db643a$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $fOJQR = parcelRequire("fOJQR");
const $8409da11f2db643a$export$b3890eb0ae9dca99 = (0, $fOJQR.createRender)(()=>/*#__PURE__*/ (0, $e79Pd.jsx)("button", {
        children: `Hello world!`
    }));
var $8409da11f2db643a$export$2e2bcd8739ae039 = $8409da11f2db643a$export$b3890eb0ae9dca99;

});
parcelRegister("fOJQR", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $03be3e3b5b4e57a5$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $03be3e3b5b4e57a5$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $03be3e3b5b4e57a5$export$78c758434c34d601 = $03be3e3b5b4e57a5$var$clientPipeline.createRender;
const $03be3e3b5b4e57a5$export$2859a83e4d6da57d = $03be3e3b5b4e57a5$var$clientPipeline.createValidate;
const $03be3e3b5b4e57a5$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $03be3e3b5b4e57a5$export$c905bc718befd59b = $03be3e3b5b4e57a5$var$serverPipeline.createHydrate;
const $03be3e3b5b4e57a5$export$1f41223e5b0a6622 = $03be3e3b5b4e57a5$var$serverPipeline.createHydrateExample;
const $03be3e3b5b4e57a5$export$88fe13b4d13f8423 = $03be3e3b5b4e57a5$var$serverPipeline.createTransformMetadata;

});


parcelRegister("bkA7c", function(module, exports) {
$parcel$export(module.exports, "default", () => $41a829ea020e3e81$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $eprc4 = parcelRequire("eprc4");

var $BL2Dl = parcelRequire("BL2Dl");

var $lBqjt = parcelRequire("lBqjt");
parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $fMT7q = parcelRequire("fMT7q");
const $41a829ea020e3e81$var$CCP_PRODUCT_ID = '6aab3f4e-cc71-474d-8d28-abef8b057808';
const $41a829ea020e3e81$var$HAMS_PRODUCT_ID = 'confluence.ondemand';
const $41a829ea020e3e81$var$PRODUCT_NAME = 'Confluence';
const $41a829ea020e3e81$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $e79Pd.jsx)("p", {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth.recommendation-confluence.reasons-modal.message",
            defaultMessage: "We think {confluence} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the Confluence recommendation will be relevant to the customer.",
            values: {
                confluence: /*#__PURE__*/ (0, $e79Pd.jsx)("strong", {
                    children: $41a829ea020e3e81$var$PRODUCT_NAME
                })
            }
        })
    }),
    reasons: (0, $BL2Dl.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $41a829ea020e3e81$export$b3890eb0ae9dca99 = (0, $fMT7q.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $lBqjt.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: $41a829ea020e3e81$var$HAMS_PRODUCT_ID,
            ccpProductId: $41a829ea020e3e81$var$CCP_PRODUCT_ID,
            logo: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.ConfluenceIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth.recommendation-confluence.product-name.header",
                description: "Header for Confluence recommendation message in Jira Side Nav",
                defaultMessage: "Collaborate on pages in real-time"
            }),
            ctaMessage: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth.recommendation-confluence.cta.label",
                description: "CTA text for Confluence recommendation message in Jira Side Nav",
                defaultMessage: "Try Confluence"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $41a829ea020e3e81$var$whyAmISeeingThisModalContent
    }));
var $41a829ea020e3e81$export$2e2bcd8739ae039 = $41a829ea020e3e81$export$b3890eb0ae9dca99;

});
parcelRegister("BL2Dl", function(module, exports) {
$parcel$export(module.exports, "whyAmISeeingThisRecommendationMessageDefaultReason", () => $09818a4a6f186d46$export$5a12ae0dd15a31ed);

var $e79Pd = parcelRequire("e79Pd");

var $55qdj = parcelRequire("55qdj");
const $09818a4a6f186d46$export$5a12ae0dd15a31ed = [
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "post-office.ad-controls.default-reason.team-size",
        description: "the first reason for displaying the message to the customer: the size of the customer's team",
        defaultMessage: "the size of your team"
    }),
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "post-office.ad-controls.default-reason.existing-products",
        description: "the second reason for displaying the message to the customer: the customer's existing Atlassian products",
        defaultMessage: "your existing Atlassian products"
    })
];

});

parcelRegister("lBqjt", function(module, exports) {
$parcel$export(module.exports, "JiraSideNavFirstPartyRecommendation", () => $66cbb87957491383$export$35f6f23f7684ff6);

var $e79Pd = parcelRequire("e79Pd");

var $2iotI = parcelRequire("2iotI");

var $3PC9r = parcelRequire("3PC9r");

var $iLF1V = parcelRequire("iLF1V");

var $lK7pY = parcelRequire("lK7pY");

var $bjE95 = parcelRequire("bjE95");
const $66cbb87957491383$var$BodyContent = ({ app: app })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                children: app.logo
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                size: "xsmall",
                children: app.header
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bjE95.CTAButton), {
                app: app
            })
        ]
    });
};
$66cbb87957491383$var$BodyContent.displayName = "BodyContent";
const $66cbb87957491383$export$35f6f23f7684ff6 = ({ app: app, onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent })=>{
    const { messageInstanceId: messageInstanceId } = (0, $lK7pY.useMessageContext)();
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iLF1V.JiraSideNavMessage), {
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
        bodyContent: /*#__PURE__*/ (0, $e79Pd.jsx)($66cbb87957491383$var$BodyContent, {
            app: app
        })
    });
};
$66cbb87957491383$export$35f6f23f7684ff6.displayName = "JiraSideNavFirstPartyRecommendation";

});
parcelRegister("bjE95", function(module, exports) {
$parcel$export(module.exports, "CTAButton", () => $8cccc496037bbfd7$export$bd36621ef7814117);

var $e79Pd = parcelRequire("e79Pd");

var $fbAgj = parcelRequire("fbAgj");

var $9MNBL = parcelRequire("9MNBL");
const $8cccc496037bbfd7$var$JOURNEY = 'get-started';
const $8cccc496037bbfd7$var$SOURCE_COMPONENT = 'jira-side-nav';
const $8cccc496037bbfd7$var$SOURCE_CONTEXT = 'tryItNow';
const $8cccc496037bbfd7$var$ctaButtonStyles = (0, $fbAgj.xcss)({
    color: 'color.link',
    backgroundColor: 'color.background.accent.blue.subtlest',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    paddingLeft: '0'
});
const $8cccc496037bbfd7$export$bd36621ef7814117 = ({ app: app })=>{
    const crossflowOptions = {
        targetProduct: app.hamsIdentifier,
        journey: $8cccc496037bbfd7$var$JOURNEY,
        sourceComponent: $8cccc496037bbfd7$var$SOURCE_COMPONENT,
        sourceContext: $8cccc496037bbfd7$var$SOURCE_CONTEXT
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MNBL.CrossflowCtaPrimaryPressable), {
        crossflowOptions: crossflowOptions,
        ctaText: app.ctaMessage,
        pressableStyle: $8cccc496037bbfd7$var$ctaButtonStyles
    });
};
$8cccc496037bbfd7$export$bd36621ef7814117.displayName = "CTAButton";

});
parcelRegister("9MNBL", function(module, exports) {
$parcel$export(module.exports, "CrossflowCtaPrimaryLinkButton", () => $4014bd409ca8530a$export$55d6f395fee83ac9);
$parcel$export(module.exports, "CrossflowCtaPrimaryPressable", () => $4014bd409ca8530a$export$585a4ef79f2a8b77);
$parcel$export(module.exports, "CrossflowCtaSecondaryPressable", () => $4014bd409ca8530a$export$ba0dce35a480e0b4);

var $e79Pd = parcelRequire("e79Pd");

var $iOfms = parcelRequire("iOfms");

var $jYEcG = parcelRequire("jYEcG");

var $8nCzf = parcelRequire("8nCzf");
const $4014bd409ca8530a$var$PRIMARY_LINK_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'primary'
};
const $4014bd409ca8530a$export$55d6f395fee83ac9 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, appearance: appearance, alt: alt })=>{
    const { handleClick: handleClick } = (0, $8nCzf.useCrossflowMessageClicked)(crossflowOptions, $4014bd409ca8530a$var$PRIMARY_LINK_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iOfms.default), {
        onClick: handleClick,
        appearance: appearance,
        "aria-label": alt,
        children: ctaText
    });
};
$4014bd409ca8530a$export$55d6f395fee83ac9.displayName = "CrossflowCtaPrimaryLinkButton";
const $4014bd409ca8530a$var$PRIMARY_BUTTON_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'primary'
};
const $4014bd409ca8530a$export$585a4ef79f2a8b77 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, pressableStyle: pressableStyle, alt: alt })=>{
    const { handleClick: handleClick } = (0, $8nCzf.useCrossflowMessageClicked)(crossflowOptions, $4014bd409ca8530a$var$PRIMARY_BUTTON_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jYEcG.Pressable), {
        onClick: handleClick,
        xcss: pressableStyle,
        "aria-label": alt,
        children: ctaText
    });
};
$4014bd409ca8530a$export$585a4ef79f2a8b77.displayName = "CrossflowCtaPrimaryPressable";
const $4014bd409ca8530a$var$SECONDARY_BUTTON_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'secondary'
};
const $4014bd409ca8530a$export$ba0dce35a480e0b4 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, pressableStyle: pressableStyle, alt: alt })=>{
    const { handleClick: handleClick } = (0, $8nCzf.useCrossflowMessageClicked)(crossflowOptions, $4014bd409ca8530a$var$SECONDARY_BUTTON_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jYEcG.Pressable), {
        onClick: handleClick,
        xcss: pressableStyle,
        "aria-label": alt,
        children: ctaText
    });
};
$4014bd409ca8530a$export$ba0dce35a480e0b4.displayName = "CrossflowCtaSecondaryPressable";

});
parcelRegister("8nCzf", function(module, exports) {
$parcel$export(module.exports, "useCrossflowMessageClicked", () => $633d8de03459f187$export$1c3f82bc53516a2a);

var $8oFkF = parcelRequire("8oFkF");

var $iKPvC = parcelRequire("iKPvC");

var $kdOoc = parcelRequire("kdOoc");

var $euxye = parcelRequire("euxye");
const $633d8de03459f187$export$1c3f82bc53516a2a = (crossflowOptions, clickedElement)=>{
    const crossflow = (0, $8oFkF.useCrossFlow)();
    const { messageClicked: messageClicked } = (0, $kdOoc.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $iKPvC.useMessageInstanceEvent)();
    const handleClick = (0, $euxye.useCallback)(()=>{
        messageClicked().catch(()=>{});
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: clickedElement,
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        }).catch(()=>{});
        if (crossflow.isEnabled) crossflow.api.open(crossflowOptions).catch(()=>{});
    }, [
        crossflow,
        crossflowOptions,
        clickedElement,
        messageClicked,
        messageInstanceClicked
    ]);
    return {
        handleClick: handleClick
    };
};

});




parcelRegister("fMT7q", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $7a519701514957c4$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $7a519701514957c4$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $7a519701514957c4$export$78c758434c34d601 = $7a519701514957c4$var$clientPipeline.createRender;
const $7a519701514957c4$export$2859a83e4d6da57d = $7a519701514957c4$var$clientPipeline.createValidate;
const $7a519701514957c4$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $7a519701514957c4$export$c905bc718befd59b = $7a519701514957c4$var$serverPipeline.createHydrate;
const $7a519701514957c4$export$1f41223e5b0a6622 = $7a519701514957c4$var$serverPipeline.createHydrateExample;
const $7a519701514957c4$export$88fe13b4d13f8423 = $7a519701514957c4$var$serverPipeline.createTransformMetadata;

});


parcelRegister("5spIx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6860d3ce5023529$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $eprc4 = parcelRequire("eprc4");

var $BL2Dl = parcelRequire("BL2Dl");

var $lBqjt = parcelRequire("lBqjt");
parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $3fb6i = parcelRequire("3fb6i");
const $c6860d3ce5023529$var$CCP_PRODUCT_ID = 'a6f908c8-709c-45f4-9e2d-eca25b93b94a';
const $c6860d3ce5023529$var$HAMS_PRODUCT_ID = 'jira-product-discovery';
const $c6860d3ce5023529$var$PRODUCT_NAME = 'Jira Product Discovery';
const $c6860d3ce5023529$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $e79Pd.jsx)("p", {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth.recommendation-jpd.reasons-modal.message",
            defaultMessage: "We think {jpd} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the JPD recommendation will be relevant to the customer.",
            values: {
                jpd: /*#__PURE__*/ (0, $e79Pd.jsx)("strong", {
                    children: $c6860d3ce5023529$var$PRODUCT_NAME
                })
            }
        })
    }),
    reasons: (0, $BL2Dl.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $c6860d3ce5023529$export$b3890eb0ae9dca99 = (0, $3fb6i.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $lBqjt.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: $c6860d3ce5023529$var$HAMS_PRODUCT_ID,
            ccpProductId: $c6860d3ce5023529$var$CCP_PRODUCT_ID,
            logo: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.JiraProductDiscoveryIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth.recommendation-jpd.product-name.header",
                description: "Header for Jira Product Discovery recommendation message in Jira Side Nav",
                defaultMessage: "Transform insights into action plans"
            }),
            ctaMessage: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth.recommendation-jpd.cta.label",
                description: "CTA text for Jira Product Discovery recommendation message in Jira Side Nav",
                defaultMessage: "Try Jira Product Discovery"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $c6860d3ce5023529$var$whyAmISeeingThisModalContent
    }));
var $c6860d3ce5023529$export$2e2bcd8739ae039 = $c6860d3ce5023529$export$b3890eb0ae9dca99;

});
parcelRegister("3fb6i", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $fc29c26c4186de56$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $fc29c26c4186de56$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $fc29c26c4186de56$export$78c758434c34d601 = $fc29c26c4186de56$var$clientPipeline.createRender;
const $fc29c26c4186de56$export$2859a83e4d6da57d = $fc29c26c4186de56$var$clientPipeline.createValidate;
const $fc29c26c4186de56$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $fc29c26c4186de56$export$c905bc718befd59b = $fc29c26c4186de56$var$serverPipeline.createHydrate;
const $fc29c26c4186de56$export$1f41223e5b0a6622 = $fc29c26c4186de56$var$serverPipeline.createHydrateExample;
const $fc29c26c4186de56$export$88fe13b4d13f8423 = $fc29c26c4186de56$var$serverPipeline.createTransformMetadata;

});


parcelRegister("2hOEh", function(module, exports) {
$parcel$export(module.exports, "default", () => $f847390c53db7fb4$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $eprc4 = parcelRequire("eprc4");

var $BL2Dl = parcelRequire("BL2Dl");

var $lBqjt = parcelRequire("lBqjt");
parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $9P95f = parcelRequire("9P95f");
const $f847390c53db7fb4$export$3678c6c473f30928 = 'de63a248-1f93-46ed-b6ea-ab8e38af1c88';
const $f847390c53db7fb4$export$5fca8a2477be63d = 'jira-servicedesk.ondemand';
const $f847390c53db7fb4$var$PRODUCT_NAME = 'Jira Service Management';
const $f847390c53db7fb4$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $e79Pd.jsx)("p", {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth.recommendation-jsm.reasons-modal.message",
            defaultMessage: "We think {jsm} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the JSM recommendation will be relevant to the customer.",
            values: {
                jsm: /*#__PURE__*/ (0, $e79Pd.jsx)("strong", {
                    children: $f847390c53db7fb4$var$PRODUCT_NAME
                })
            }
        })
    }),
    reasons: (0, $BL2Dl.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $f847390c53db7fb4$export$b3890eb0ae9dca99 = (0, $9P95f.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $lBqjt.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: $f847390c53db7fb4$export$5fca8a2477be63d,
            ccpProductId: $f847390c53db7fb4$export$3678c6c473f30928,
            logo: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.JiraServiceManagementIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth.recommendation-jsm.product-name.header",
                description: "Header for Jira Service Management recommendation message in Jira Side Nav",
                defaultMessage: "Automate workflows for faster resolutions"
            }),
            ctaMessage: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth.recommendation-jsm.cta.label",
                description: "CTA text for Jira Service Management recommendation message in Jira Side Nav",
                defaultMessage: "Try Jira Service Management"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $f847390c53db7fb4$var$whyAmISeeingThisModalContent
    }));
var $f847390c53db7fb4$export$2e2bcd8739ae039 = $f847390c53db7fb4$export$b3890eb0ae9dca99;

});
parcelRegister("9P95f", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $989e83b8770b659f$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $989e83b8770b659f$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $989e83b8770b659f$export$78c758434c34d601 = $989e83b8770b659f$var$clientPipeline.createRender;
const $989e83b8770b659f$export$2859a83e4d6da57d = $989e83b8770b659f$var$clientPipeline.createValidate;
const $989e83b8770b659f$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $989e83b8770b659f$export$c905bc718befd59b = $989e83b8770b659f$var$serverPipeline.createHydrate;
const $989e83b8770b659f$export$1f41223e5b0a6622 = $989e83b8770b659f$var$serverPipeline.createHydrateExample;
const $989e83b8770b659f$export$88fe13b4d13f8423 = $989e83b8770b659f$var$serverPipeline.createTransformMetadata;

});


parcelRegister("i6HHy", function(module, exports) {
$parcel$export(module.exports, "default", () => $290c86f139f4fdab$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $eprc4 = parcelRequire("eprc4");

var $BL2Dl = parcelRequire("BL2Dl");

var $lBqjt = parcelRequire("lBqjt");
parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $14KXM = parcelRequire("14KXM");

const $290c86f139f4fdab$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $e79Pd.jsx)("p", {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth.recommendation-jsw-visualize-work.reasons-modal.message",
            defaultMessage: "We think {product} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the Jira recommendation will be relevant to the customer.",
            values: {
                product: /*#__PURE__*/ (0, $e79Pd.jsx)("strong", {
                    children: (0, $576e900544de60d7$export$a75e537c279a265a)
                })
            }
        })
    }),
    reasons: (0, $BL2Dl.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $290c86f139f4fdab$export$b3890eb0ae9dca99 = (0, $14KXM.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $lBqjt.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: (0, $576e900544de60d7$export$5fca8a2477be63d),
            ccpProductId: (0, $576e900544de60d7$export$3678c6c473f30928),
            logo: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.JiraIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth.recommendation-jsw-visualize-work.product-name.header",
                description: "Header for Jira recommendation message in Jira Side Nav",
                defaultMessage: "Visualize your projects in lists, boards, and more"
            }),
            ctaMessage: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth.recommendation-jsw-visualize-work.cta.label",
                description: "CTA text for Jira recommendation message in Jira Side Nav",
                defaultMessage: "Try Jira"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $290c86f139f4fdab$var$whyAmISeeingThisModalContent
    }));
var $290c86f139f4fdab$export$2e2bcd8739ae039 = $290c86f139f4fdab$export$b3890eb0ae9dca99;

});
parcelRegister("14KXM", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $4098cc0d4d234d0d$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $4098cc0d4d234d0d$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $4098cc0d4d234d0d$export$78c758434c34d601 = $4098cc0d4d234d0d$var$clientPipeline.createRender;
const $4098cc0d4d234d0d$export$2859a83e4d6da57d = $4098cc0d4d234d0d$var$clientPipeline.createValidate;
const $4098cc0d4d234d0d$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $4098cc0d4d234d0d$export$c905bc718befd59b = $4098cc0d4d234d0d$var$serverPipeline.createHydrate;
const $4098cc0d4d234d0d$export$1f41223e5b0a6622 = $4098cc0d4d234d0d$var$serverPipeline.createHydrateExample;
const $4098cc0d4d234d0d$export$88fe13b4d13f8423 = $4098cc0d4d234d0d$var$serverPipeline.createTransformMetadata;

});

const $576e900544de60d7$export$3678c6c473f30928 = 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f';
const $576e900544de60d7$export$5fca8a2477be63d = 'jira-software.ondemand';
const $576e900544de60d7$export$a75e537c279a265a = 'Jira';


parcelRegister("iQ9EL", function(module, exports) {
$parcel$export(module.exports, "default", () => $5dc89c4c21294fd7$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $eprc4 = parcelRequire("eprc4");

var $BL2Dl = parcelRequire("BL2Dl");

var $lBqjt = parcelRequire("lBqjt");
parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $40HeS = parcelRequire("40HeS");

const $5dc89c4c21294fd7$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $e79Pd.jsx)("p", {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "growth.recommendation-loom.reasons-modal.message",
            defaultMessage: "We think {product} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the Loom recommendation will be relevant to the customer.",
            values: {
                product: /*#__PURE__*/ (0, $e79Pd.jsx)("strong", {
                    children: (0, $70a08192ea03eb8d$export$a75e537c279a265a)
                })
            }
        })
    }),
    reasons: (0, $BL2Dl.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $5dc89c4c21294fd7$export$b3890eb0ae9dca99 = (0, $40HeS.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $lBqjt.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: (0, $70a08192ea03eb8d$export$5fca8a2477be63d),
            ccpProductId: (0, $70a08192ea03eb8d$export$3678c6c473f30928),
            logo: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.LoomIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth.recommendation-loom.product-name.header",
                description: "Header for Loom recommendation message in Jira Side Nav",
                defaultMessage: "Record and share videos easily"
            }),
            ctaMessage: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                id: "growth.recommendation-loom.cta.label",
                description: "CTA text for Loom recommendation message in Jira Side Nav",
                defaultMessage: "Try Loom"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $5dc89c4c21294fd7$var$whyAmISeeingThisModalContent
    }));
var $5dc89c4c21294fd7$export$2e2bcd8739ae039 = $5dc89c4c21294fd7$export$b3890eb0ae9dca99;

});
parcelRegister("40HeS", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $5ca5bff31880cf7a$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $5ca5bff31880cf7a$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $5ca5bff31880cf7a$export$78c758434c34d601 = $5ca5bff31880cf7a$var$clientPipeline.createRender;
const $5ca5bff31880cf7a$export$2859a83e4d6da57d = $5ca5bff31880cf7a$var$clientPipeline.createValidate;
const $5ca5bff31880cf7a$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $5ca5bff31880cf7a$export$c905bc718befd59b = $5ca5bff31880cf7a$var$serverPipeline.createHydrate;
const $5ca5bff31880cf7a$export$1f41223e5b0a6622 = $5ca5bff31880cf7a$var$serverPipeline.createHydrateExample;
const $5ca5bff31880cf7a$export$88fe13b4d13f8423 = $5ca5bff31880cf7a$var$serverPipeline.createTransformMetadata;

});

const $70a08192ea03eb8d$export$ea76e6b040284832 = 'loom';
const $70a08192ea03eb8d$export$5fca8a2477be63d = 'loom';
const $70a08192ea03eb8d$export$a75e537c279a265a = 'Loom';
const $70a08192ea03eb8d$export$3678c6c473f30928 = '7683a73e-423d-41a1-b43f-d497656f8b5d';


parcelRegister("kJlC4", function(module, exports) {
$parcel$export(module.exports, "default", () => $0960306fe4726d0a$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $fGrpH = parcelRequire("fGrpH");

var $5gqLZ = parcelRequire("5gqLZ");

var $gNDXu = parcelRequire("gNDXu");
const $0960306fe4726d0a$var$LAUNCHED_VARIANT = 'existing';
const $0960306fe4726d0a$export$b3890eb0ae9dca99 = (0, $gNDXu.createRender)(({ onDismissed: onDismissed })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: 'jiraRovoExtensionLeftNavCTA',
            actionSubjectId: 'post-office.rovo-extension-install-cta-left-nav.jira-side-nav'
        }, {
            variant: $0960306fe4726d0a$var$LAUNCHED_VARIANT,
            source: 'jira-side-nav'
        });
    }, [
        fireAnalyticsEvent
    ]);
    const handleDismissWithAnalytics = (0, $euxye.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'jiraRovoExtensionLeftNavCTA',
            actionSubjectId: 'post-office.rovo-extension-install-cta-left-nav.dismiss'
        }, {
            variant: $0960306fe4726d0a$var$LAUNCHED_VARIANT,
            source: 'jira-side-nav'
        });
        onDismissed();
    }, [
        fireAnalyticsEvent,
        onDismissed
    ]);
    const handleLinkClickAnalytics = (0, $euxye.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'jiraRovoExtensionLeftNavCTA',
            actionSubjectId: 'post-office.rovo-extension-install-cta-left-nav.install'
        }, {
            variant: $0960306fe4726d0a$var$LAUNCHED_VARIANT,
            source: 'jira-side-nav'
        });
    }, [
        fireAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5gqLZ.LeftNavCtaMessage), {
        context: {
            experimentCohort: 'copy-version-c',
            source: 'jira-side-nav'
        },
        handleOnDismissed: handleDismissWithAnalytics,
        onSideNavClick: ()=>{
            handleLinkClickAnalytics();
            return null;
        }
    });
});
var $0960306fe4726d0a$export$2e2bcd8739ae039 = $0960306fe4726d0a$export$b3890eb0ae9dca99;

});
parcelRegister("5gqLZ", function(module, exports) {
$parcel$export(module.exports, "LeftNavCtaMessage", () => $ef7826ad80f0ae60$export$217ec4c85bc42809);
/* LeftNavCtaMessage.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $1MNmN = parcelRequire("1MNmN");

var $2iotI = parcelRequire("2iotI");

var $i68tN = parcelRequire("i68tN");

var $i2sOf = parcelRequire("i2sOf");

var $hzWaA = parcelRequire("hzWaA");

var $c69sa = parcelRequire("c69sa");
var $2BUXh = parcelRequire("2BUXh");
var $5BP41 = parcelRequire("5BP41");
var $gNHJ8 = parcelRequire("gNHJ8");

var $iKPvC = parcelRequire("iKPvC");

var $kdOoc = parcelRequire("kdOoc");

var $c7azu = parcelRequire("c7azu");

var $2LibE = parcelRequire("2LibE");

var $1YIbA = parcelRequire("1YIbA");

var $ik5tG = parcelRequire("ik5tG");
const $ef7826ad80f0ae60$var$styles = {
    boxContainer: "_1yt4utpp _zulpu2gc _2rko12b0 _ae4v1h6o _1bah1h6o _1e0c1txw _1bsb1osq _4cvr1y6m _bfhk1s93",
    contentStack: "_zulpu2gc _1bsb1osq",
    headerRow: "_1bah1yb4 _4cvr1y6m _1bsb1osq",
    iconAndTitle: "_zulpu2gc",
    iconContainer: "_1e0c1txw _4cvr1h6o"
};
const $ef7826ad80f0ae60$var$getLinkUrl = (cohort)=>{
    const UTM_CONTENT = `side_nav_install_cta_${cohort}`;
    return `https://chromewebstore.google.com/detail/rovo-search-chat-and-more/npbjhobkibekbklkghlhfhieggcggpdb?utm_source=confluence-side-nav&utm_medium=banner&utm_campaign=rovo_extension_side_nav_install_cta&utm_content=${UTM_CONTENT}`;
};
const $ef7826ad80f0ae60$var$selectCopyForCohort = (cohort)=>{
    return (0, $ik5tG.COPY_VARIATIONS)[cohort] || (0, $ik5tG.COPY_VARIATIONS)['copy-version-b'];
};
const $ef7826ad80f0ae60$export$217ec4c85bc42809 = ({ context: context, handleOnDismissed: handleOnDismissed, onSideNavClick: onSideNavClick })=>{
    const { experimentCohort: experimentCohort } = context;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { heading: heading, description: description } = $ef7826ad80f0ae60$var$selectCopyForCohort(experimentCohort);
    const { messageClicked: messageClicked } = (0, $kdOoc.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $iKPvC.useMessageInstanceEvent)();
    const headingText = formatMessage(heading);
    const descriptionText = formatMessage(description);
    const linkText = formatMessage((0, $ik5tG.messages).linkText);
    const rovoIconAlt = formatMessage((0, $ik5tG.messages).rovoIconAlt);
    const chromeIconAlt = formatMessage((0, $ik5tG.messages).chromeIconAlt);
    const dismissLabel = formatMessage((0, $ik5tG.messages).dismissLabel);
    const linkUrl = $ef7826ad80f0ae60$var$getLinkUrl(experimentCohort);
    const handleDismiss = ()=>{
        messageClicked();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {
                experimentCohort: experimentCohort,
                source: 'confluence-side-nav'
            }
        });
        handleOnDismissed();
    };
    const handleLinkClick = ()=>{
        messageClicked();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'installLink',
                clickedElement: 'link'
            },
            action: {
                actionType: 'open',
                destinationUrl: linkUrl
            },
            additionalMetadataFromFrontend: {
                experimentCohort: experimentCohort,
                source: 'confluence-side-nav'
            }
        });
        onSideNavClick('ROVO_EXTENSION_CTA');
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $c69sa.Box), {
        xcss: (0, $1MNmN.cx)($ef7826ad80f0ae60$var$styles.boxContainer),
        style: {
            border: `1px solid ${"var(--ds-border, #0B120E24)"}`
        },
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $5BP41.Stack), {
            xcss: (0, $1MNmN.cx)($ef7826ad80f0ae60$var$styles.contentStack),
            testId: "rovo-left-nav-content",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2BUXh.Inline), {
                    xcss: (0, $1MNmN.cx)($ef7826ad80f0ae60$var$styles.headerRow),
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2BUXh.Inline), {
                            xcss: (0, $1MNmN.cx)($ef7826ad80f0ae60$var$styles.iconAndTitle),
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $c69sa.Box), {
                                    xcss: (0, $1MNmN.cx)($ef7826ad80f0ae60$var$styles.iconContainer),
                                    children: [
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $i2sOf.default), {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($2LibE))),
                                            alt: rovoIconAlt,
                                            width: 24,
                                            height: 24,
                                            style: {
                                                flexShrink: 0,
                                                zIndex: 2
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $i2sOf.default), {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($c7azu))),
                                            alt: chromeIconAlt,
                                            width: 24,
                                            height: 24,
                                            style: {
                                                marginLeft: '-8px',
                                                flexShrink: 0,
                                                zIndex: 1
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                                    size: "xsmall",
                                    children: headingText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($i68tN))),
                            label: dismissLabel,
                            appearance: "subtle",
                            spacing: "compact",
                            onClick: handleDismiss
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gNHJ8.Text), {
                    size: "small",
                    children: descriptionText
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hzWaA.default), {
                    href: linkUrl,
                    target: "blank",
                    onClick: handleLinkClick,
                    children: linkText
                })
            ]
        })
    });
};
$ef7826ad80f0ae60$export$217ec4c85bc42809.displayName = "LeftNavCtaMessage";

});
parcelRegister("c7azu", function(module, exports) {
module.exports = new URL("chrome-icon.875ad4bc.svg", import.meta.url).toString();

});

parcelRegister("2LibE", function(module, exports) {
module.exports = new URL("rovo-icon.c02ccc2a.svg", import.meta.url).toString();

});

parcelRegister("ik5tG", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2acc3b2336cc295e$export$defe85febe8b728c);
$parcel$export(module.exports, "COPY_VARIATIONS", () => $2acc3b2336cc295e$export$1d02164cdbd97674);

var $7eNDO = parcelRequire("7eNDO");
const $2acc3b2336cc295e$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    linkText: {
        id: 'rovo-extension-install-cta-left-nav.link',
        defaultMessage: 'Get the browser extension',
        description: 'Text for rovo extension install cta link left nav'
    },
    jiraLinkText: {
        id: 'rovo-extension-install-cta-left-nav.jira-link',
        defaultMessage: 'Get the browser extension',
        description: 'Text for Jira left nav extension install CTA link'
    },
    jiraRovoLinkText: {
        id: 'rovo-extension-install-cta-left-nav.jira-rovo-link',
        defaultMessage: 'Get the Rovo extension',
        description: 'Text for Jira left nav extension install CTA link (Rovo variant)'
    },
    rovoIconAlt: {
        id: 'rovo-extension-install-cta-left-nav.rovo-icon-alt',
        defaultMessage: 'Rovo Icon',
        description: 'Alt text for Rovo icon image'
    },
    chromeIconAlt: {
        id: 'rovo-extension-install-cta-left-nav.chrome-icon-alt',
        defaultMessage: 'Google Chrome Icon',
        description: 'Alt text for Google Chrome icon image'
    },
    jiraIconAlt: {
        id: 'rovo-extension-install-cta-left-nav.jira-icon-alt',
        defaultMessage: 'Jira Icon',
        description: 'Alt text for Jira icon image'
    },
    dismissLabel: {
        id: 'rovo-extension-install-cta-left-nav.dismiss-label',
        defaultMessage: 'Dismiss message',
        description: 'Label for dismiss button'
    }
});
const $2acc3b2336cc295e$export$1d02164cdbd97674 = {
    'copy-version-b': (0, $7eNDO.defineMessages)({
        heading: {
            id: 'rovo-extension-install-cta-left-nav.heading.copy-version-b',
            defaultMessage: 'Get answers for work, anywhere',
            description: 'Heading text for rovo extension install cta left nav'
        },
        description: {
            id: 'rovo-extension-install-cta-left-nav.description.copy-version-b',
            defaultMessage: 'Ask about your projects, work policies, or anything about your company. Rovo Chat from any tab.',
            description: 'Description text for rovo extension install cta left nav'
        }
    }),
    'copy-version-c': (0, $7eNDO.defineMessages)({
        heading: {
            id: 'rovo-extension-install-cta-left-nav.heading.copy-version-c',
            defaultMessage: 'Unlock Rovo in every tab',
            description: 'Heading text for rovo extension install cta left nav'
        },
        description: {
            id: 'rovo-extension-install-cta-left-nav.description.copy-version-c',
            defaultMessage: '50K+ workers use it to chat with AI that understands their company.',
            description: 'Description text for rovo extension install cta left nav'
        }
    }),
    'jira-take-anywhere': (0, $7eNDO.defineMessages)({
        heading: {
            id: 'rovo-extension-install-cta-left-nav.heading.jira-take-anywhere',
            defaultMessage: 'Jira. Anywhere.',
            description: 'Heading text for Jira left nav extension install CTA'
        },
        description: {
            id: 'rovo-extension-install-cta-left-nav.description.jira-take-anywhere',
            defaultMessage: 'Manage work items, get instant insights, and act on Jira from any tab in your browser.',
            description: 'Description text for Jira left nav extension install CTA'
        }
    }),
    'jira-rovo': (0, $7eNDO.defineMessages)({
        heading: {
            id: 'rovo-extension-install-cta-left-nav.heading.jira-rovo',
            defaultMessage: 'Jira. Anywhere.',
            description: 'Heading text for Jira left nav Rovo extension variant CTA'
        },
        description: {
            id: 'rovo-extension-install-cta-left-nav.description.jira-rovo',
            defaultMessage: 'Manage work items, get instant insights, and act on Jira from any tab in your browser.',
            description: 'Description text for Jira left nav Rovo extension variant CTA'
        }
    })
};

});


parcelRegister("gNDXu", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $38fb5de7d8d31b72$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $38fb5de7d8d31b72$var$clientPipelineCreator = (0, $k8v9N.createClientPipeline)();
const $38fb5de7d8d31b72$export$78c758434c34d601 = $38fb5de7d8d31b72$var$clientPipelineCreator.createRender;
const $38fb5de7d8d31b72$export$2859a83e4d6da57d = $38fb5de7d8d31b72$var$clientPipelineCreator.createValidate;
const $38fb5de7d8d31b72$var$serverPipelineCreator = (0, $k8v9N.createServerPipeline)();
const $38fb5de7d8d31b72$export$c905bc718befd59b = $38fb5de7d8d31b72$var$serverPipelineCreator.createHydrate;
const $38fb5de7d8d31b72$export$1f41223e5b0a6622 = $38fb5de7d8d31b72$var$serverPipelineCreator.createHydrateExample;
const $38fb5de7d8d31b72$export$88fe13b4d13f8423 = $38fb5de7d8d31b72$var$serverPipelineCreator.createTransformMetadata;

});


parcelRegister("iP45x", function(module, exports) {
$parcel$export(module.exports, "default", () => $af6598d991e68a28$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $cBbGa = parcelRequire("cBbGa");

var $eAfw3 = parcelRequire("eAfw3");
const $af6598d991e68a28$export$b3890eb0ae9dca99 = (0, $eAfw3.createRender)(({ onDismissed: onDismissed })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cBbGa.NonMauChatCtaMessage), {
        handleOnDismissed: onDismissed,
        context: {
            source: 'jira-side-nav'
        }
    });
});
var $af6598d991e68a28$export$2e2bcd8739ae039 = $af6598d991e68a28$export$b3890eb0ae9dca99;

});
parcelRegister("cBbGa", function(module, exports) {
$parcel$export(module.exports, "NonMauChatCtaMessage", () => $0fafb60783b37752$export$e6a613b0fe78a30b);
/* NonMauChatCtaMessage.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $3gxI9 = parcelRequire("3gxI9");

var $1MNmN = parcelRequire("1MNmN");

var $2iotI = parcelRequire("2iotI");

var $eprc4 = parcelRequire("eprc4");

var $ihEDU = parcelRequire("ihEDU");
var $defJG = parcelRequire("defJG");
var $6mEZn = parcelRequire("6mEZn");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $9ll9z = parcelRequire("9ll9z");

var $fGrpH = parcelRequire("fGrpH");

var $iKPvC = parcelRequire("iKPvC");

var $kdOoc = parcelRequire("kdOoc");

var $55qdj = parcelRequire("55qdj");
var $1YIbA = parcelRequire("1YIbA");

var $2woGs = parcelRequire("2woGs");
// The rovo_chat_non_mau_jira_confluence_cta experiment shipped v1 as the winning
// variant. Retained as a static analytics attribute so downstream dashboards
// keep receiving the `variant` field.
const $0fafb60783b37752$var$VARIANT = 'v1';
const $0fafb60783b37752$var$styles = {
    boxContainer: "_zulpu2gc _2rko1mok _ae4v1h6o _1bah1h6o _1e0c1txw _1bsb1osq _ca0qutpp _n3tdutpp _19bvpxbi _u5f3pxbi _4cvr1y6m _bfhk19ip",
    contentStack: "_zulpu2gc _1bsb1osq",
    headerRow: "_1bah1yb4 _4cvr1h6o _1bsb1osq",
    ctaLink: "_1yt4ze3t _2rkolb4i _11c8wadc _4bfu18uv _1hmsglyw _ajmmnqa1 _bfhk1w7a _syaz13af _80omtlke _y3gn1e5h _9oik18uv _1bnx8stv _jf4cnqa1 _9h8h12zz"
};
const $0fafb60783b37752$var$ACTION_SUBJECT = 'rovoNonMauChatCta';
const $0fafb60783b37752$export$e6a613b0fe78a30b = ({ context: context, handleOnDismissed: handleOnDismissed })=>{
    const { source: source } = context;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { messageClicked: messageClicked } = (0, $kdOoc.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $iKPvC.useMessageInstanceEvent)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    const chatEventPublish = (0, $9ll9z.usePublish)('ai-mate');
    (0, $euxye.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: $0fafb60783b37752$var$ACTION_SUBJECT,
            attributes: {
                variant: $0fafb60783b37752$var$VARIANT,
                source: source
            }
        });
    }, [
        fireAnalyticsEvent,
        source
    ]);
    const handleDismiss = (0, $euxye.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'dismissed',
            actionSubject: $0fafb60783b37752$var$ACTION_SUBJECT,
            attributes: {
                variant: $0fafb60783b37752$var$VARIANT,
                source: source
            }
        });
        messageClicked();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {
                experimentCohort: $0fafb60783b37752$var$VARIANT,
                source: source
            }
        });
        handleOnDismissed();
    }, [
        fireAnalyticsEvent,
        source,
        messageClicked,
        messageInstanceClicked,
        handleOnDismissed
    ]);
    const handleCtaClick = (0, $euxye.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: $0fafb60783b37752$var$ACTION_SUBJECT,
            attributes: {
                variant: $0fafb60783b37752$var$VARIANT,
                source: source
            }
        });
        messageClicked();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'openRovoChat',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {
                experimentCohort: $0fafb60783b37752$var$VARIANT,
                source: source
            }
        });
        chatEventPublish({
            type: 'chat-new',
            source: 'rovoNonMauChatCta',
            data: {
                prompt: formatMessage((0, $2woGs.messages).chatPrompt),
                dialogues: []
            }
        });
    }, [
        fireAnalyticsEvent,
        source,
        messageClicked,
        messageInstanceClicked,
        chatEventPublish
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: (0, $1MNmN.cx)($0fafb60783b37752$var$styles.boxContainer),
        testId: "rovo-non-mau-chat-cta",
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
            xcss: (0, $1MNmN.cx)($0fafb60783b37752$var$styles.contentStack),
            testId: "rovo-non-mau-chat-cta-content",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.Inline), {
                    xcss: (0, $1MNmN.cx)($0fafb60783b37752$var$styles.headerRow),
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.RovoIcon), {
                            appearance: "brand",
                            size: "xsmall",
                            shouldUseHexLogo: true
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3gxI9.AdControls), {
                            showWhyAmISeeingThis: true,
                            whyAmISeeingThisModalContent: {
                                reasons: [
                                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                        ...(0, $2woGs.messages).whyAmISeeingThisReason1
                                    }, "reason-1"),
                                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                        ...(0, $2woGs.messages).whyAmISeeingThisReason2
                                    }, "reason-2")
                                ]
                            },
                            onDismissed: handleDismiss,
                            spacing: "compact"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                    size: "xsmall",
                    children: formatMessage((0, $2woGs.messages).heading)
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                    size: "small",
                    color: "color.text.subtlest",
                    children: formatMessage((0, $2woGs.messages).description)
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.Pressable), {
                    onClick: handleCtaClick,
                    testId: "rovo-non-mau-chat-cta-link",
                    xcss: (0, $1MNmN.cx)($0fafb60783b37752$var$styles.ctaLink),
                    children: formatMessage((0, $2woGs.messages).ctaLinkText)
                })
            ]
        })
    });
};
$0fafb60783b37752$export$e6a613b0fe78a30b.displayName = "NonMauChatCtaMessage";

});
parcelRegister("2woGs", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c6293299d152481c$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $c6293299d152481c$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    ctaLinkText: {
        id: 'rovo-non-mau-chat-cta-jira-confluence-left-nav.cta-link-text',
        defaultMessage: 'Try Rovo now',
        description: 'CTA link text for the non-MAU Rovo Chat CTA banner'
    },
    chatPrompt: {
        id: 'rovo-non-mau-chat-cta-jira-confluence-left-nav.chat-prompt',
        defaultMessage: 'Hi Rovo, list three things you can do right now for me based on my recent work',
        description: 'Auto-run prompt sent to Rovo Chat when the user clicks the CTA on the non-MAU chat CTA banner'
    },
    whyAmISeeingThisReason1: {
        id: 'rovo-non-mau-chat-cta-jira-confluence-left-nav.why-am-i-seeing-this.reason-1',
        defaultMessage: 'your existing Atlassian products',
        description: 'First reason for showing the Rovo Chat CTA to the user'
    },
    whyAmISeeingThisReason2: {
        id: 'rovo-non-mau-chat-cta-jira-confluence-left-nav.why-am-i-seeing-this.reason-2',
        defaultMessage: 'your organization having AI enabled',
        description: 'Second reason for showing the Rovo Chat CTA to the user'
    },
    heading: {
        id: 'rovo-non-mau-chat-cta-jira-confluence-left-nav.heading.v1',
        defaultMessage: 'Unlock your AI teammate',
        description: 'Heading text for non-MAU Rovo Chat CTA banner - variant v1'
    },
    description: {
        id: 'rovo-non-mau-chat-cta-jira-confluence-left-nav.description.v1',
        defaultMessage: 'Rovo connects your tools and knowledge so work gets done for you.',
        description: 'Description text for non-MAU Rovo Chat CTA banner - variant v1'
    }
});

});


parcelRegister("eAfw3", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $aadd0975c5d3895b$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $aadd0975c5d3895b$var$clientPipelineCreator = (0, $k8v9N.createClientPipeline)();
const $aadd0975c5d3895b$export$78c758434c34d601 = $aadd0975c5d3895b$var$clientPipelineCreator.createRender;
const $aadd0975c5d3895b$export$2859a83e4d6da57d = $aadd0975c5d3895b$var$clientPipelineCreator.createValidate;
const $aadd0975c5d3895b$var$serverPipelineCreator = (0, $k8v9N.createServerPipeline)();
const $aadd0975c5d3895b$export$c905bc718befd59b = $aadd0975c5d3895b$var$serverPipelineCreator.createHydrate;
const $aadd0975c5d3895b$export$1f41223e5b0a6622 = $aadd0975c5d3895b$var$serverPipelineCreator.createHydrateExample;
const $aadd0975c5d3895b$export$88fe13b4d13f8423 = $aadd0975c5d3895b$var$serverPipelineCreator.createTransformMetadata;

});


parcelRegister("38bKN", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c072de9d22fd592$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $8mBRw = parcelRequire("8mBRw");
const $4c072de9d22fd592$export$b3890eb0ae9dca99 = (0, $8mBRw.createRender)(()=>/*#__PURE__*/ (0, $e79Pd.jsx)("button", {
        children: "This is an example test button"
    }));
var $4c072de9d22fd592$export$2e2bcd8739ae039 = $4c072de9d22fd592$export$b3890eb0ae9dca99;

});
parcelRegister("8mBRw", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $22b411d552a65b9c$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $22b411d552a65b9c$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $22b411d552a65b9c$export$78c758434c34d601 = $22b411d552a65b9c$var$clientPipeline.createRender;
const $22b411d552a65b9c$export$2859a83e4d6da57d = $22b411d552a65b9c$var$clientPipeline.createValidate;
const $22b411d552a65b9c$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $22b411d552a65b9c$export$c905bc718befd59b = $22b411d552a65b9c$var$serverPipeline.createHydrate;
const $22b411d552a65b9c$export$1f41223e5b0a6622 = $22b411d552a65b9c$var$serverPipeline.createHydrateExample;
const $22b411d552a65b9c$export$88fe13b4d13f8423 = $22b411d552a65b9c$var$serverPipeline.createTransformMetadata;

});


parcelRegister("8uWpN", function(module, exports) {
$parcel$export(module.exports, "default", () => $cac0ea8fa8fe839e$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $293xq = parcelRequire("293xq");

var $1hrJN = parcelRequire("1hrJN");

var $5RHXL = parcelRequire("5RHXL");

var $bMMox = parcelRequire("bMMox");
const $cac0ea8fa8fe839e$var$getDismissClickIdentifier = (arm)=>{
    switch(arm){
        case 'personalized':
            return 'twc-sidenav-banner-personalized-dismiss';
        case 'generic':
            return 'twc-sidenav-banner-generic-dismiss';
        default:
            return 'twc-sidenav-banner-dismiss';
    }
};
const $cac0ea8fa8fe839e$export$b3890eb0ae9dca99 = (0, $5RHXL.createRender)(({ redirectTo: redirectTo, onboardingUrl: onboardingUrl, onDismissed: onDismissed, messageInstanceId: messageInstanceId, locale: locale, arm: arm, recommendedApp: recommendedApp, experimentKey: experimentKey, actionTier: actionTier, targetTenantId: targetTenantId, collectionEntitlementId: collectionEntitlementId })=>{
    const { handleDismiss: handleDismiss } = (0, $bMMox.useHandleDismiss)({
        onDismissed: onDismissed,
        clickIdentifier: $cac0ea8fa8fe839e$var$getDismissClickIdentifier(arm)
    });
    // arm drives all rendering decisions — no fallback to other conditions.
    if (arm === 'personalized' && recommendedApp && actionTier) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1hrJN.PersonalizedBanner), {
        locale: locale,
        recommendedApp: recommendedApp,
        onClose: handleDismiss,
        onCtaClick: handleDismiss,
        href: onboardingUrl,
        messageInstanceId: messageInstanceId,
        experimentKey: experimentKey,
        actionTier: actionTier,
        targetTenantId: targetTenantId,
        collectionEntitlementId: collectionEntitlementId,
        surfaceProduct: "jira"
    });
    if (arm === 'generic') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $293xq.GenericBanner), {
        locale: locale,
        product: redirectTo,
        onClose: handleDismiss,
        onCtaClick: handleDismiss,
        href: onboardingUrl,
        messageInstanceId: messageInstanceId,
        surfaceProduct: "jira"
    });
    // control (or any unrecognised arm): no banner shown.
    return null;
});
var $cac0ea8fa8fe839e$export$2e2bcd8739ae039 = $cac0ea8fa8fe839e$export$b3890eb0ae9dca99;

});
parcelRegister("293xq", function(module, exports) {
$parcel$export(module.exports, "GenericBanner", () => $bfd8ab00bca98d8d$export$a350437cbfeb32d4);
/* generic-banner.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $inMxE = parcelRequire("inMxE");

var $m9iwH = parcelRequire("m9iwH");
var $9ufM9 = parcelRequire("9ufM9");

var $2iotI = parcelRequire("2iotI");

var $i68tN = parcelRequire("i68tN");

var $i2sOf = parcelRequire("i2sOf");

var $ihEDU = parcelRequire("ihEDU");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $3tcaB = parcelRequire("3tcaB");
const $bfd8ab00bca98d8d$var$styles = {
    root: "_2rko1mok _195gidpf _1mou1b66 _1bsb1osq _bfhk1s93 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
    appTilesWrapper: "_19pkutpp",
    headerRow: "_zulputpp _1e0c1txw _4cvr1y6m _1bah1yb4"
};
const $bfd8ab00bca98d8d$var$messages = (0, $7eNDO.defineMessages)({
    heading: {
        id: 'twc.sidenav.banner.generic.heading',
        defaultMessage: 'Explore Teamwork Collection',
        description: 'Main heading for the generic TWC activation banner in the product sidenav.'
    },
    subheadingJira: {
        id: 'twc.sidenav.banner.generic.subheading.jira',
        defaultMessage: 'Discover how the other apps can accelerate your workflows in Jira.',
        description: 'Subheading for the generic banner when shown in Jira.'
    },
    subheadingConfluence: {
        id: 'twc.sidenav.banner.generic.subheading.confluence',
        defaultMessage: 'Discover how the other apps can accelerate your workflows in Confluence.',
        description: 'Subheading for the generic banner when shown in Confluence.'
    },
    appTilesAlt: {
        id: 'twc.sidenav.banner.generic.app.tiles.alt',
        defaultMessage: 'App tiles illustration',
        description: 'Alt text for the app tiles illustration in the generic banner.'
    },
    ctaButton: {
        id: 'twc.sidenav.banner.generic.cta',
        defaultMessage: 'Try now',
        description: 'CTA button text for the generic TWC activation banner in the product sidenav.'
    },
    closeLabel: {
        id: 'twc.sidenav.banner.generic.close',
        defaultMessage: 'Close',
        description: 'Accessible label for the close button on the generic TWC activation banner.'
    }
});
const $bfd8ab00bca98d8d$export$a350437cbfeb32d4 = ({ heading: heading, href: href, locale: locale, product: product, messageInstanceId: messageInstanceId, onClose: onClose, onCtaClick: onCtaClick, surfaceProduct: surfaceProduct })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'twcGenericBanner',
            attributes: {
                product: product,
                surfaceProduct: surfaceProduct,
                messageInstanceId: messageInstanceId,
                locale: locale,
                arm: 'generic'
            }
        }).fire('growth');
    }, [
        createAnalyticsEvent,
        product,
        surfaceProduct,
        messageInstanceId,
        locale
    ]);
    const handleClose = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcGenericBannerClose',
            attributes: {
                product: product,
                surfaceProduct: surfaceProduct,
                messageInstanceId: messageInstanceId,
                locale: locale,
                arm: 'generic'
            }
        }).fire('growth');
        onClose?.();
    };
    const handleCtaClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcGenericBannerCta',
            attributes: {
                product: product,
                surfaceProduct: surfaceProduct,
                messageInstanceId: messageInstanceId,
                locale: locale,
                arm: 'generic'
            }
        }).fire('growth');
        onCtaClick?.();
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $bfd8ab00bca98d8d$var$styles.root,
        testId: "twc-generic-banner",
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.Box), {
                    xcss: $bfd8ab00bca98d8d$var$styles.headerRow,
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                            xcss: $bfd8ab00bca98d8d$var$styles.appTilesWrapper,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $i2sOf.default), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3tcaB))),
                                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($3tcaB))),
                                alt: formatMessage($bfd8ab00bca98d8d$var$messages.appTilesAlt),
                                testId: "twc-generic-banner-app-tiles",
                                width: 91
                            })
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
                            icon: (iconProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i68tN))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            onClick: handleClose,
                            label: formatMessage($bfd8ab00bca98d8d$var$messages.closeLabel),
                            testId: "twc-generic-banner-close",
                            appearance: "subtle"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                            as: "h3",
                            size: "xsmall",
                            testId: "twc-generic-banner-heading",
                            children: heading ?? formatMessage($bfd8ab00bca98d8d$var$messages.heading)
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                            as: "p",
                            size: "small",
                            color: "color.text.subtle",
                            maxLines: 2,
                            testId: "twc-generic-banner-subheading",
                            children: product === 'jira' ? formatMessage($bfd8ab00bca98d8d$var$messages.subheadingJira) : formatMessage($bfd8ab00bca98d8d$var$messages.subheadingConfluence)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9ufM9.default), {
                    shouldFitContainer: true,
                    href: href,
                    testId: "twc-generic-banner-cta",
                    onClick: handleCtaClick,
                    target: "_blank",
                    children: formatMessage($bfd8ab00bca98d8d$var$messages.ctaButton)
                })
            ]
        })
    });
};
$bfd8ab00bca98d8d$export$a350437cbfeb32d4.displayName = "GenericBanner";

});
parcelRegister("3tcaB", function(module, exports) {
module.exports = new URL("twc-app-tiles.a9ed69c3.svg", import.meta.url).toString();

});


parcelRegister("1hrJN", function(module, exports) {
$parcel$export(module.exports, "PersonalizedBanner", () => $2541ea561c3d68b0$export$44c5a4ad6d35d2bf);
/* personalized-banner.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $inMxE = parcelRequire("inMxE");

var $iOfms = parcelRequire("iOfms");
var $m9iwH = parcelRequire("m9iwH");
var $9ufM9 = parcelRequire("9ufM9");

var $2iotI = parcelRequire("2iotI");

var $i68tN = parcelRequire("i68tN");

var $h53N8 = parcelRequire("h53N8");

var $i2sOf = parcelRequire("i2sOf");

var $ihEDU = parcelRequire("ihEDU");
var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $3tcaB = parcelRequire("3tcaB");
const $2541ea561c3d68b0$var$styles = {
    root: "_2rko1mok _195gidpf _1mou1b66 _1bsb1osq _bfhk1s93 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
    headerRow: "_zulputpp _1e0c1txw _4cvr1y6m _1bah1yb4",
    logoWrapper: "_19pkutpp"
};
const $2541ea561c3d68b0$var$messages = (0, $7eNDO.defineMessages)({
    subheadingConfluence: {
        id: 'twc.sidenav.banner.personalized.subheading.confluence',
        defaultMessage: 'Create with Rovo in Confluence',
        description: 'Personalized banner subheading when the recommended app is Confluence. Shown in the product sidenav.'
    },
    subheadingJira: {
        id: 'twc.sidenav.banner.personalized.subheading.jira',
        defaultMessage: 'Plan your next team project in Jira',
        description: 'Personalized banner subheading when the recommended app is Jira. Shown in the product sidenav.'
    },
    subheadingLoom: {
        id: 'twc.sidenav.banner.personalized.subheading.loom',
        defaultMessage: 'Setup video meetings with Loom AI',
        description: 'Personalized banner subheading when the recommended app is Loom. Shown in the product sidenav.'
    },
    appTilesAlt: {
        id: 'twc.sidenav.banner.personalized.app.tiles.alt',
        defaultMessage: 'App tiles illustration',
        description: 'Alt text for the Teamwork Collection app tiles illustration in the personalized banner.'
    },
    heading: {
        id: 'twc.sidenav.banner.personalized.heading',
        defaultMessage: 'Explore Teamwork Collection',
        description: 'Main heading for the personalized missing-app activation banner in the product sidenav.'
    },
    ctaButton: {
        id: 'twc.sidenav.banner.personalized.cta',
        defaultMessage: 'Get started',
        description: 'CTA button text for the personalized missing-app activation banner in the product sidenav.'
    },
    closeLabel: {
        id: 'twc.sidenav.banner.personalized.close',
        defaultMessage: 'Close',
        description: 'Accessible label for the close button on the personalized missing-app activation banner.'
    }
});
const $2541ea561c3d68b0$var$subheadingByApp = {
    confluence: $2541ea561c3d68b0$var$messages.subheadingConfluence,
    jira: $2541ea561c3d68b0$var$messages.subheadingJira,
    loom: $2541ea561c3d68b0$var$messages.subheadingLoom
};
const $2541ea561c3d68b0$var$destinationTypeByApp = {
    confluence: 'create_with_rovo',
    jira: 'jira_onboarding',
    loom: 'loom_meetings'
};
const $2541ea561c3d68b0$export$44c5a4ad6d35d2bf = ({ heading: heading, href: href, locale: locale, recommendedApp: recommendedApp, messageInstanceId: messageInstanceId, onClose: onClose, onCtaClick: onCtaClick, ctaLabel: ctaLabel, secondaryActionLabel: secondaryActionLabel, onSecondaryAction: onSecondaryAction, experimentKey: experimentKey, actionTier: actionTier, targetTenantId: targetTenantId, collectionEntitlementId: collectionEntitlementId, surfaceProduct: surfaceProduct })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const analyticsAttributes = (0, $euxye.useMemo)(()=>({
            recommendedApp: recommendedApp,
            messageInstanceId: messageInstanceId,
            locale: locale,
            experimentKey: experimentKey,
            actionTier: actionTier,
            targetTenantId: targetTenantId,
            collectionEntitlementId: collectionEntitlementId,
            surfaceProduct: surfaceProduct,
            destinationType: $2541ea561c3d68b0$var$destinationTypeByApp[recommendedApp],
            arm: 'personalized'
        }), [
        recommendedApp,
        messageInstanceId,
        locale,
        experimentKey,
        actionTier,
        targetTenantId,
        collectionEntitlementId,
        surfaceProduct
    ]);
    (0, $euxye.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'twcPersonalizedBanner',
            attributes: analyticsAttributes
        }).fire('growth');
    }, [
        analyticsAttributes,
        createAnalyticsEvent
    ]);
    const handleClose = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcPersonalizedBannerClose',
            attributes: analyticsAttributes
        }).fire('growth');
        onClose?.();
    };
    const handleCtaClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcPersonalizedBannerCta',
            attributes: analyticsAttributes
        }).fire('growth');
        onCtaClick?.();
    };
    const handleSecondaryAction = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcPersonalizedBannerSecondaryAction',
            attributes: analyticsAttributes
        }).fire('growth');
        onSecondaryAction?.();
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $2541ea561c3d68b0$var$styles.root,
        testId: "twc-personalized-banner",
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.Box), {
                    xcss: $2541ea561c3d68b0$var$styles.headerRow,
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                            xcss: $2541ea561c3d68b0$var$styles.logoWrapper,
                            testId: "twc-personalized-banner-logo",
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $i2sOf.default), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3tcaB))),
                                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($3tcaB))),
                                alt: formatMessage($2541ea561c3d68b0$var$messages.appTilesAlt),
                                testId: "twc-personalized-banner-app-tiles",
                                width: 91
                            })
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
                            icon: (iconProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i68tN))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            onClick: handleClose,
                            label: formatMessage($2541ea561c3d68b0$var$messages.closeLabel),
                            testId: "twc-personalized-banner-close",
                            appearance: "subtle"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                            as: "h3",
                            size: "xsmall",
                            testId: "twc-personalized-banner-heading",
                            children: heading ?? formatMessage($2541ea561c3d68b0$var$messages.heading)
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                            as: "p",
                            size: "small",
                            color: "color.text.subtle",
                            maxLines: 2,
                            testId: "twc-personalized-banner-subheading",
                            children: formatMessage($2541ea561c3d68b0$var$subheadingByApp[recommendedApp])
                        })
                    ]
                }),
                secondaryActionLabel ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.Inline), {
                    alignBlock: "center",
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9ufM9.default), {
                            appearance: "subtle",
                            href: href,
                            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($h53N8))),
                            onClick: handleCtaClick,
                            spacing: "compact",
                            target: "_blank",
                            testId: "twc-personalized-banner-cta",
                            children: ctaLabel ?? formatMessage($2541ea561c3d68b0$var$messages.ctaButton)
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                            "aria-hidden": true,
                            children: "\xb7"
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iOfms.default), {
                            appearance: "subtle",
                            onClick: handleSecondaryAction,
                            spacing: "compact",
                            testId: "twc-personalized-banner-secondary-action",
                            children: secondaryActionLabel
                        })
                    ]
                }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9ufM9.default), {
                    shouldFitContainer: true,
                    href: href,
                    testId: "twc-personalized-banner-cta",
                    onClick: handleCtaClick,
                    target: "_blank",
                    children: ctaLabel ?? formatMessage($2541ea561c3d68b0$var$messages.ctaButton)
                })
            ]
        })
    });
};
$2541ea561c3d68b0$export$44c5a4ad6d35d2bf.displayName = "PersonalizedBanner";

});
parcelRegister("h53N8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f883fd20022b67e50ba0c0d40e77f77b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6f5d8386dccc231$var$_react = $c6f5d8386dccc231$var$_interopRequireDefault((parcelRequire("euxye")));

var $c6f5d8386dccc231$var$_baseNew = $c6f5d8386dccc231$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $c6f5d8386dccc231$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Video".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/video
 * Usage guidance:
 * Single purpose - Reserved for representing video content across Atlassian and Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6f5d8386dccc231$var$VideoIcon = (props)=>/*#__PURE__*/ $c6f5d8386dccc231$var$_react.default.createElement($c6f5d8386dccc231$var$_baseNew.default, Object.assign({
        name: "VideoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-7A.5.5 0 0 0 10 4zm-2 .5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v.218l2.137-1.203A1.25 1.25 0 0 1 16 4.605v6.79a1.25 1.25 0 0 1-1.863 1.09L12 11.282v.218a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12 5.061 2.5 1.407V5.032L12 6.44z" clip-rule="evenodd"/>`
    }, props));
$c6f5d8386dccc231$var$VideoIcon.displayName = 'VideoIcon';
var $c6f5d8386dccc231$var$_default = module.exports.default = $c6f5d8386dccc231$var$VideoIcon;

});


parcelRegister("5RHXL", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $d684e31f0b7b25af$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $d684e31f0b7b25af$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $d684e31f0b7b25af$export$78c758434c34d601 = $d684e31f0b7b25af$var$clientPipeline.createRender;
const $d684e31f0b7b25af$export$2859a83e4d6da57d = $d684e31f0b7b25af$var$clientPipeline.createValidate;
const $d684e31f0b7b25af$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $d684e31f0b7b25af$export$c905bc718befd59b = $d684e31f0b7b25af$var$serverPipeline.createHydrate;
const $d684e31f0b7b25af$export$1f41223e5b0a6622 = $d684e31f0b7b25af$var$serverPipeline.createHydrateExample;
const $d684e31f0b7b25af$export$88fe13b4d13f8423 = $d684e31f0b7b25af$var$serverPipeline.createTransformMetadata;

});

parcelRegister("bMMox", function(module, exports) {
$parcel$export(module.exports, "useHandleDismiss", () => $61b1cf7656b314b7$export$f83734c268a0a1ff);

var $iKPvC = parcelRequire("iKPvC");

var $kdOoc = parcelRequire("kdOoc");
const $61b1cf7656b314b7$export$f83734c268a0a1ff = ({ onDismissed: onDismissed, clickIdentifier: clickIdentifier })=>{
    const { messageInstanceClicked: messageInstanceClicked } = (0, $iKPvC.useMessageInstanceEvent)();
    const { messageDismissed: messageDismissed } = (0, $kdOoc.useMessageEvent)();
    const handleDismiss = ()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: clickIdentifier,
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        messageDismissed();
        onDismissed();
    };
    return {
        handleDismiss: handleDismiss
    };
};

});



/* GeneratedContentHash: 9c47655ae0da7c4a10425612f1be5cf9c57ec22e23c4d4b1e4a2589c469dc001 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $991a7a7c9587f28e$export$a5cfae247d8360ef = 'jira-side-nav';

parcelRegister("h1dvI", function(module, exports) {
$parcel$export(module.exports, "getMessage", () => $34f4317a9059ae07$export$2e51780da3c3a61);

var $4LDqh = parcelRequire("4LDqh");
const $34f4317a9059ae07$var$excludedMessages = new Set([
    'test-message-inapp',
    'message-template-template'
]);
/**
 * Checks if the cohort is in the allowed list.
 * Note: This is case-sensitive - cohort names must match exactly as configured in the experiment.
 */ const $34f4317a9059ae07$var$isAllowedCohort = (cohort, allowedCohorts)=>{
    return allowedCohorts.includes(cohort);
};
const $34f4317a9059ae07$export$2e51780da3c3a61 = (initialMessages)=>{
    const filteredMessages = (initialMessages || []).filter(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
    (dataMessage)=>!$34f4317a9059ae07$var$excludedMessages.has(dataMessage.messageTemplateId));
    const messageExperimentConfigs = {
        'jira-twcg-190-recommend-retrial-recent-trialing-customers': {
            experimentKey: 'twcg-190-recommend-retrial-for-recent-customers',
            allowedCohorts: [
                'variation'
            ]
        },
        'jira-twcg-810-trial-ad': {
            experimentKey: 'twcg-810-trial-ad',
            allowedCohorts: [
                'variation'
            ],
            aaExperimentKey: 'twcg-810-trial-ad-aa'
        }
    };
    for (const message of filteredMessages){
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        const messageId = message.messageTemplateId;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const experimentConfig = messageExperimentConfigs[messageId];
        if (!experimentConfig) // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return message;
        const cohort = (0, $4LDqh.default).getExperimentValue(experimentConfig.experimentKey, experimentConfig.statsigParameterName ?? 'cohort', 'not-enrolled', {
            fireExperimentExposure: true
        });
        if (experimentConfig.aaExperimentKey) (0, $4LDqh.default).getExperimentValue(experimentConfig.aaExperimentKey, 'cohort', 'not-enrolled', {
            fireExperimentExposure: true
        });
        // Show message only if user is in one of the allowed variation cohorts
        if ($34f4317a9059ae07$var$isAllowedCohort(cohort, experimentConfig.allowedCohorts)) // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return message;
    }
    return undefined;
};

});



parcelRegister("lw94j", function(module, exports) {
$parcel$export(module.exports, "GSNQueryPreloader", () => $036d28bb4abbe505$export$9dbcfa5e0eb0957a);

var $c1zHX = parcelRequire("c1zHX");

var $n67Vb = parcelRequire("n67Vb");
function $036d28bb4abbe505$export$9dbcfa5e0eb0957a(props) {
    const { queryReference: queryReference, render: render } = props;
    const queryRef = (0, $n67Vb.usePreloadedQuery)(/* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ (0, $c1zHX.default), queryReference);
    return render({
        queryReference: queryRef
    });
}
$036d28bb4abbe505$export$9dbcfa5e0eb0957a.displayName = "GSNQueryPreloader";

});

parcelRegister("i0T2O", function(module, exports) {
$parcel$export(module.exports, "useNetworkStorageParams", () => $ddbe3e310bc89274$export$593ebd48112ae3af);

var $euxye = parcelRequire("euxye");

var $kt86l = parcelRequire("kt86l");

var $h3LJR = parcelRequire("h3LJR");

var $3GN2r = parcelRequire("3GN2r");

var $fDVI0 = parcelRequire("fDVI0");

var $2NSbF = parcelRequire("2NSbF");
function $ddbe3e310bc89274$export$593ebd48112ae3af() {
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const ownerId = (0, $3GN2r.useAccountId)();
    const siteId = cloudId;
    const entityAri = (0, $fDVI0.JiraWorkspaceAri).create({
        siteId: siteId,
        activationId: activationId
    }).toString();
    const ownerAri = ownerId && (0, $2NSbF.IdentityUserAri).create({
        userId: ownerId
    }).toString() || '';
    return (0, $euxye.useMemo)(()=>({
            activationId: activationId,
            entityAri: entityAri,
            ownerAri: ownerAri,
            siteId: siteId
        }), [
        activationId,
        entityAri,
        ownerAri,
        siteId
    ]);
}

});

/* eslint-disable jira/filename-case */ // This id must match the TEST_ID in src/packages/platform/page-container-v2/src/common/ui/sidebar/index.tsx
const $9a699b3f60b99670$export$d8c1419f135e1023 = 'page-layout.sidebar';
const $9a699b3f60b99670$export$b8b9d90f9e5bd72b = 'jira-nav-platform-integration-sidebar';
const $9a699b3f60b99670$export$d57b6b390e78d90f = 'navx';


parcelRegister("9OIox", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "GSNForContentSidebarEntryPoint", () => $441f996aa1504afe$export$acc64564c227b792);
$parcel$export(module.exports, "GSNForContentSidebar", () => $441f996aa1504afe$export$a507175eae481438);
$parcel$export(module.exports, "default", () => $441f996aa1504afe$export$2e2bcd8739ae039);

var $iObX3 = parcelRequire("iObX3");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");

var $4NgYT = parcelRequire("4NgYT");

var $jTATq = parcelRequire("jTATq");

var $19zz3 = parcelRequire("19zz3");

var $c3Eaw = parcelRequire("c3Eaw");

var $hvbkB = parcelRequire("hvbkB");

var $9F8bm = parcelRequire("9F8bm");

var $5JqUt = parcelRequire("5JqUt");


var $4ey3V = parcelRequire("4ey3V");

var $9ujS8 = parcelRequire("9ujS8");

var $bcUWA = parcelRequire("bcUWA");

var $28RaS = parcelRequire("28RaS");

var $5IkoH = parcelRequire("5IkoH");

var $6ZLJT = parcelRequire("6ZLJT");

var $7ghii = parcelRequire("7ghii");

var $3GN2r = parcelRequire("3GN2r");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $1YIbA = parcelRequire("1YIbA");

var $9qH0V = parcelRequire("9qH0V");

var $lt6RH = parcelRequire("lt6RH");

var $9uMYd = parcelRequire("9uMYd");

var $c6RdE = parcelRequire("c6RdE");

var $2lek2 = parcelRequire("2lek2");

var $6r1lK = parcelRequire("6r1lK");

var $9Th3w = parcelRequire("9Th3w");

var $lw94j = parcelRequire("lw94j");

var $i0T2O = parcelRequire("i0T2O");

var $h3ybG = parcelRequire("h3ybG");


var $e5jcx = parcelRequire("e5jcx");
function $441f996aa1504afe$export$acc64564c227b792(props) {
    // This EP has the preloaded query-ref, to pass to the component that will usePreloadedQuery().
    // NavPlatformSidebar guarantees this component is only rendered for authenticated users,
    // so gsnSidebarContent is always defined (non-null assertion is safe here).
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($441f996aa1504afe$export$a507175eae481438, {
        // NavPlatformSidebar guarantees this component is only rendered for authenticated users,
        // so gsnSidebarContent is always defined at runtime. Cast is safe.
        // oxlint-disable-next-line typescript/consistent-type-assertions
        queryReference: props.queries.gsnSidebarContent,
        isShortcutsStatic: props.extraProps?.isShortcutsStatic
    });
}
$441f996aa1504afe$export$acc64564c227b792.displayName = "GSNForContentSidebarEntryPoint";
var $441f996aa1504afe$export$2e2bcd8739ae039 = $441f996aa1504afe$export$acc64564c227b792;
function $441f996aa1504afe$export$a507175eae481438(props) {
    // Add support for the Back button inside non-content sidebars, by storing the previous URL when the content sidebar is showing.
    // To test this component, make sure that it is wrapped in NavigateBackProvider
    (0, $h3ybG.useSaveCurrentContentSidebarRoute)();
    const renderFn = (0, $euxye.useCallback)(({ queryReference: queryReference })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($441f996aa1504afe$var$GSNForContentSidebarInner, {
            queryReference: queryReference,
            isShortcutsStatic: props.isShortcutsStatic
        }), [
        props.isShortcutsStatic
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lw94j.GSNQueryPreloader), {
        queryReference: props.queryReference,
        render: renderFn
    });
}
$441f996aa1504afe$export$a507175eae481438.displayName = "GSNForContentSidebar";
const $441f996aa1504afe$var$useShowRoadmapsUpsell = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jpd-roadmaps-in-jira'), ()=>(0, $jTATq.useShowRoadmapsUpsell)(), ()=>false);
const $441f996aa1504afe$var$useShowItamWithFg = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('itam_ftw'), (data)=>{
    const assetsVerticalWorkspaceAri = (0, $5JqUt.extractWorkspaceAri)(data.assetsVertical_tenantContext);
    const staticResults = (0, $9F8bm.extractPermissionResults)(data.assetsVertical_checkPermissions);
    const { showItam: showItam } = (0, $7ghii.useShowItam)({
        assetsVerticalWorkspaceAri: assetsVerticalWorkspaceAri,
        staticResults: staticResults
    });
    return showItam;
}, ()=>false);
// This is the component that should be referenced in Storybook.
// Each sidebar can have its own overrides (e.g. isShortcutsStatic)
function $441f996aa1504afe$var$GSNForContentSidebarInner(props) {
    const { isShortcutsStatic: isShortcutsStatic = false, queryReference: queryReference } = props;
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)(/* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ /* eslint-disable @atlassian/relay/unused-fields */ (0, $iObX3.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryReference);
    const networkStorageParamsPartial = (0, $i0T2O.useNetworkStorageParams)();
    const networkStorageParams = (0, $euxye.useMemo)(()=>{
        return {
            ...networkStorageParamsPartial,
            queryRef: data
        };
    }, [
        data,
        networkStorageParamsPartial
    ]);
    const { siteId: cloudId } = networkStorageParams;
    const { isSelectedPath: isSelectedPath } = (0, $19zz3.useSidebarNav4)(); // This is needed to support peeking / peekMenuId
    // Items ------
    const shouldShowRoadmapsUpsell = $441f996aa1504afe$var$useShowRoadmapsUpsell();
    const showItam = $441f996aa1504afe$var$useShowItamWithFg(data);
    const navItems = (0, $c3Eaw.useFilterL1MenuItemsByEditionAndLicense)((0, $2700E.expVal)('navx-1982-change-order-of-teams-and-goals', 'isEnabled', false) ? (0, $hvbkB.USER_NAVIGATION_CONFIGURATION_DEFAULT_GOALS_TEAMS_SWITCHED).navItems : (0, $hvbkB.USER_NAVIGATION_CONFIGURATION_DEFAULT).navItems, {
        shouldShowRoadmapsUpsell: shouldShowRoadmapsUpsell,
        showItam: showItam
    });
    const items = (0, $9Th3w.useItemsConfig)(navItems, data);
    // Shortcuts
    const shortcuts = (0, $6r1lK.useShortcuts)();
    // ForYou config --------
    const recentEntryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            count: (0, $b10cfeab38ca86b5$export$56ff071570537731)
        }), [
        cloudId
    ]);
    const starredEntryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            filter: {
                types: (0, $4ey3V.VALID_FAVORITE_TYPES),
                sort: {
                    order: 'DESC'
                }
            },
            count: (0, $4ey3V.FAVOURITE_QUERY_LIMIT)
        }), [
        cloudId
    ]);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const starredFilterMenuItemDataRaw = (0, $9ujS8.useFilterMenuItems)();
    const starredFilterConfig = (0, $euxye.useMemo)(()=>starredFilterMenuItemDataRaw.map((item)=>({
                key: item.filterType,
                label: formatMessage(item.message),
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(item.Icon, null)
            })), [
        formatMessage,
        starredFilterMenuItemDataRaw
    ]);
    const isForYouSelected = isSelectedPath((0, $5IkoH.MENU_ID_FOR_YOU));
    const forYouConfig = (0, $euxye.useMemo)(()=>// oxlint-disable-next-line typescript/consistent-type-assertions
        (0, $c6RdE.getForYouConfig)({
            isForYouSelected: isForYouSelected,
            recentEntryPointParams: recentEntryPointParams,
            starredEntryPointParams: starredEntryPointParams,
            starredFilterConfig: starredFilterConfig
        }), [
        isForYouSelected,
        recentEntryPointParams,
        starredEntryPointParams,
        starredFilterConfig
    ]);
    // Peek Menu ------
    // Determine peekMenuId from selectedPath
    const peekMenuIdWithRouteFilter = (0, $e5jcx.usePeekMenuId)(navItems);
    const peekMenuId = (0, $2700E.expVal)('uxissue-1664-autoexpand-spaces', 'isEnabled', false) ? peekMenuIdWithRouteFilter : navItems.find((item)=>isSelectedPath(item.menuId))?.menuId;
    // Note: When Jira GSN adoption rolls out, it should rollout with "network-migration" for 3 months
    //  to give time for all old user settings to be stored in the new records.
    //
    //    - customizationStore="network-migration"
    //
    //  After 3 months of being rolled-out, create a new FG to:
    //   - Change customizationStore to "network"
    //   - @include(if: $fgVariable) for useNetworkSideNavUserData.
    //   - After that has rolled out, cleanup
    // `as const` so it matches the literal-union type
    // (`'network-migration' | 'local' | 'network'`) expected downstream.
    const customizationStore = 'network-migration';
    const bottomElem = (0, $euxye.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $28RaS.Nav4JiraSideNavRecommendation), null), []);
    // `as const` so it matches the `'inherit'` literal type expected downstream.
    const intlMode = 'inherit';
    // `useAccountId` at the top of the hook order (Rules of Hooks).
    const userId = (0, $3GN2r.useAccountId)();
    // TWCG-460 productionisation dispatch. The recommendations are fetched as
    // part of the GSN query behind `@include(if: $shouldFetchInvitedAppShortcuts)`
    // (the kill-switch gate + experiment, computed where the query variables are
    // built). So `data.growthRecommendations` is present ONLY for the test cohort;
    // deriving dispatch from the field presence keeps it consistent across SSR and
    // hydration (the include decision is fixed at preload). Not read from a live
    // `expVal` here — that would risk an SSR<->client hydration mismatch and would
    // expose before the treatment shows (exposure fires in `useIsInvitedAppshortcutsEnabled`).
    const willDispatchProductionisation = Boolean(cloudId && userId && data.growthRecommendations !== undefined);
    // Build the translated recommendations result from the preloaded field.
    // `undefined` (field not included / control) yields an empty result, which
    // the productionisation wrapper treats as NO_RECOMMENDED_APPS.
    const invitedAppShortcutsRecommendationsResult = (0, $euxye.useMemo)(()=>(0, $9uMYd.getInvitedAppShortcutsRecommendationsResult)(data.growthRecommendations), [
        data.growthRecommendations
    ]);
    // Shortcuts Experiment -----
    const [isInvitedAppShortcutsEnabled, invitedAppShortcutsExperiment, onShortcutsMenuSettled] = $441f996aa1504afe$var$useIsInvitedAppshortcutsEnabled();
    // Config for the `ShortcutsSlot` (experiment/legacy branch). Passed to the
    // module-level `InvitedAppShortcutsSlot` via context so the slot keeps a
    // stable identity and GSN never remounts the shortcuts subtree. Memoised to
    // keep the context value referentially stable across renders.
    const experimentSlotConfig = (0, $euxye.useMemo)(()=>({
            mode: 'experiment',
            resolverResult: invitedAppShortcutsExperiment
        }), [
        invitedAppShortcutsExperiment
    ]);
    // Stable forwarded prop bag for `GSNForContentSidebarWithInvitedAppRecommendations`.
    // Memoised to satisfy `@atlassian/perf-linting/no-unstable-inline-props`
    // and keep downstream `React.memo` identity stable. Runs unconditionally
    // to keep hook order stable.
    // `userId ?? ''` is type-narrowing only: the consuming JSX is gated by
    // `willDispatchProductionisation` which already requires `userId` to be truthy.
    const invitedAppRecommendationsContainerProps = (0, $euxye.useMemo)(()=>({
            bottomElem: bottomElem,
            cloudId: cloudId,
            customizationStore: customizationStore,
            experimental_onShortcutsMenuSettled: onShortcutsMenuSettled,
            forYouConfig: forYouConfig,
            intlMode: intlMode,
            isShortcutsStatic: isShortcutsStatic,
            items: items,
            networkStorageParams: networkStorageParams,
            peekMenuId: peekMenuId,
            shortcuts: shortcuts,
            testId: (0, $9a699b3f60b99670$export$d8c1419f135e1023),
            userId: userId ?? ''
        }), [
        bottomElem,
        cloudId,
        customizationStore,
        onShortcutsMenuSettled,
        forYouConfig,
        intlMode,
        isShortcutsStatic,
        items,
        networkStorageParams,
        peekMenuId,
        shortcuts,
        userId
    ]);
    // Render the legacy experiment branch or the plain control. Used both as
    // the regular fallthrough and as the productionisation `JSErrorBoundary`
    // fallback (so a transport error on the recommendations query degrades to
    // the same sidebar the gate-off cohort would see).
    const renderLegacyOrControlSidebar = (0, $euxye.useCallback)(()=>{
        // GSN always receives the base `shortcuts` config. When the invited-app
        // shortcuts experiment is enabled, the decoration happens inside GSN's
        // `ShortcutsSlot` (`InvitedAppShortcutsSlot`) rather than by swapping the
        // whole `shortcuts` prop, so SSR<->CSR flips of the experiment no longer
        // restructure the nav tree.
        const sharedProps = {
            app: 'jira',
            appLabel: 'Jira',
            bottomElem: bottomElem,
            cloudId: cloudId,
            customizationStore: customizationStore,
            forYou: forYouConfig,
            intlMode: intlMode,
            isShortcutsStatic: isShortcutsStatic,
            items: // Needed for VR tests as the URL can't be mocked
            items,
            networkStorageParams: networkStorageParams,
            peekMenuId: peekMenuId,
            shortcuts: shortcuts,
            testId: (0, $9a699b3f60b99670$export$d8c1419f135e1023),
            ...(0, $i860n.fg)('twcg-460-personalised-invite-notifications-m2-gate') && {
                experimental_onShortcutsMenuSettled: onShortcutsMenuSettled
            }
        };
        if (isInvitedAppShortcutsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2lek2.InvitedAppShortcutsSlotContext).Provider, {
            value: experimentSlotConfig
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9qH0V.GlobalSideNavigation), {
            ...sharedProps,
            ShortcutsSlot: (0, $2lek2.InvitedAppShortcutsSlot)
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9qH0V.GlobalSideNavigation), sharedProps);
    }, [
        bottomElem,
        cloudId,
        customizationStore,
        experimentSlotConfig,
        forYouConfig,
        intlMode,
        isInvitedAppShortcutsEnabled,
        isShortcutsStatic,
        items,
        networkStorageParams,
        onShortcutsMenuSettled,
        peekMenuId,
        shortcuts
    ]);
    // Productionisation render: the recommendations were preloaded as part of the
    // GSN query (test cohort only). `ContextualAnalyticsData` is required so the
    // `JSErrorBoundary` can emit analytics when it catches (per the AFM
    // `handling-errors` skill); the boundary fails open to the legacy / control
    // branch so a transport error on the recommendations doesn't take down the
    // sidebar.
    if (willDispatchProductionisation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4NgYT.ContextualAnalyticsData), {
        menuId: "gsn-invited-app-shortcuts-productionisation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "gsn-invited-app-shortcuts-productionisation",
        packageName: "jiraNavPlatformIntegrationSidebar",
        teamName: "growth-puma",
        fallback: renderLegacyOrControlSidebar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lt6RH.GSNForContentSidebarWithInvitedAppRecommendations), {
        ...invitedAppRecommendationsContainerProps,
        result: invitedAppShortcutsRecommendationsResult
    })));
    return renderLegacyOrControlSidebar();
}
$441f996aa1504afe$var$GSNForContentSidebarInner.displayName = "GSNForContentSidebarInner";
function $441f996aa1504afe$var$useIsInvitedAppshortcutsEnabled() {
    const invitedAppShortcutsExperiment = (0, $bcUWA.useResolveInvitedAppShortcuts)();
    const isEligibleToSeeInvitedAppShortcuts = // we split the kill-switch gate and targeting gate to avoid the overrides precedence issue
    // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $i860n.fg)('twcg-460-personalised-invite-notifications-m2-gate') && invitedAppShortcutsExperiment.ineligibilityReason === null && invitedAppShortcutsExperiment.invitedApps?.confluence?.eligible === true;
    const isInvitedAppShortcutsEnabled = isEligibleToSeeInvitedAppShortcuts && (0, $2700E.expVal)('twcg-460-personalised-invite-notifications-m2', 'isEnabled', false);
    (0, $euxye.useEffect)(()=>{
        if (isEligibleToSeeInvitedAppShortcuts) {
            // Expose the productionisation-preload experiment across the WHOLE
            // kill-switch cohort — both arms — so the A/B is balanced. The gate
            // (not `willDispatchProductionisation`) is the enrolment signal:
            // `willDispatchProductionisation` is true only for treatment (control's
            // mount is experiment-gated), so keying on it would only ever emit
            // `variant`. Exposure is deliberately decoupled from the render/data
            // source — treatment renders AGG recs, control keeps rendering from the
            // cookie cache — while `expVal` resolves the arm at render time on the
            // client. Gate-off users fall through to the legacy m2 exposure.
            if ((0, $i860n.fg)('twcg-460-preload-grs-invited-app-shortcuts-gate')) invitedAppShortcutsExperiment.fireFeatureExposed({
                isEnabled: (0, $2700E.expVal)('twcg-460-preload-grs-invited-app-shortcuts', 'isEnabled', false),
                overrideMode: 'productionisation'
            });
            else invitedAppShortcutsExperiment.fireFeatureExposed({
                isEnabled: (0, $2700E.expVal)('twcg-460-personalised-invite-notifications-m2', 'isEnabled', false)
            });
        }
    }, [
        isEligibleToSeeInvitedAppShortcuts,
        invitedAppShortcutsExperiment
    ]);
    const onShortcutsMenuSettled = (0, $euxye.useCallback)(({ shortcuts: hydratedShortcuts, visibleMenuIds: visibleMenuIds })=>{
        invitedAppShortcutsExperiment.updateFromHydratedShortcuts({
            shortcuts: hydratedShortcuts,
            limitToOnlyApsKeys: [
                'CONFLUENCE'
            ],
            visibleMenuIds: visibleMenuIds
        });
    }, [
        invitedAppShortcutsExperiment
    ]);
    return [
        isInvitedAppShortcutsEnabled,
        invitedAppShortcutsExperiment,
        onShortcutsMenuSettled
    ];
}

});
parcelRegister("iObX3", function(module, exports) {
$parcel$export(module.exports, "default", () => $31728bddb59b66c6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e26c0506a60fb9d860f181ff5da6615a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $31728bddb59b66c6$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
    }, v1 = [
        {
            "kind": "FragmentSpread",
            "name": "useNavSettingsService"
        }
    ], v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "currentURL"
            },
            {
                "kind": "RootArgument",
                "name": "fetchGlobalShortcutsAvailableProducts"
            },
            {
                "kind": "RootArgument",
                "name": "invitedAppShortcutsProduct"
            },
            {
                "kind": "RootArgument",
                "name": "isItamEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "itamStaticChecks"
            },
            {
                "kind": "RootArgument",
                "name": "navPlatMenuDataEntityAri"
            },
            {
                "kind": "RootArgument",
                "name": "navPlatSidebarDataEntityAri"
            },
            {
                "kind": "RootArgument",
                "name": "ownerAri"
            },
            {
                "kind": "RootArgument",
                "name": "shouldFetchInvitedAppShortcuts"
            }
        ],
        "kind": "Fragment",
        "name": "GSNForContentSidebarEntryPoint",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "useNetworkSideNavUserData"
            },
            {
                "condition": "fetchGlobalShortcutsAvailableProducts",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "useGlobalShortcutsDataRelay"
                    }
                ]
            },
            {
                "alias": "navPlatL1MenuData",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "entityAri",
                        "variableName": "navPlatMenuDataEntityAri"
                    },
                    v0 /*: any*/ 
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": v1 /*: any*/ 
            },
            {
                "alias": "navPlatSidebarData",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "entityAri",
                        "variableName": "navPlatSidebarDataEntityAri"
                    },
                    v0 /*: any*/ 
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": v1 /*: any*/ 
            },
            {
                "kind": "FragmentSpread",
                "name": "Nav4Apps"
            },
            {
                "kind": "FragmentSpread",
                "name": "Nav4Filters"
            },
            {
                "kind": "FragmentSpread",
                "name": "Nav4Operations"
            },
            {
                "kind": "FragmentSpread",
                "name": "Nav4Plans"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "currentURL",
                        "variableName": "currentURL"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "Nav4Projects"
            },
            {
                "kind": "FragmentSpread",
                "name": "Nav4Roadmaps_query"
            },
            {
                "condition": "isItamEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            v2 /*: any*/ 
                        ],
                        "kind": "LinkedField",
                        "name": "assetsVertical_tenantContext",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "concreteType": "AssetsVerticalTenantContext",
                                        "kind": "LinkedField",
                                        "name": "tenantContext",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "assetsVerticalWorkspaceAri"
                                            }
                                        ]
                                    }
                                ],
                                "type": "AssetsVerticalTenantContextSuccess"
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "checks",
                                "variableName": "itamStaticChecks"
                            },
                            v2 /*: any*/ 
                        ],
                        "kind": "LinkedField",
                        "name": "assetsVertical_checkPermissions",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "concreteType": "AssetsVerticalPermissionCheckResult",
                                        "kind": "LinkedField",
                                        "name": "results",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "resourceId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "permissionId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "permitted"
                                            }
                                        ]
                                    }
                                ],
                                "type": "AssetsVerticalCheckPermissionsSuccess"
                            }
                        ]
                    },
                    {
                        "args": [
                            v2 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 100
                            },
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "HAM"
                            }
                        ],
                        "concreteType": "AssetsVerticalVerticalInstantiationConnection",
                        "kind": "LinkedField",
                        "name": "assetsVertical_verticalInstantiations",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "AssetsVerticalVerticalInstantiationEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "AssetsVerticalVerticalInstantiation",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "type"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "status"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "shouldFetchInvitedAppShortcuts",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "GrowthRecQuery",
                        "kind": "LinkedField",
                        "name": "growthRecommendations",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "fields": [
                                            {
                                                "kind": "Variable",
                                                "name": "product",
                                                "variableName": "invitedAppShortcutsProduct"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "tenantId",
                                                "variableName": "cloudId"
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "useCase",
                                                "value": "invitedAppShortcuts"
                                            }
                                        ],
                                        "kind": "ObjectValue",
                                        "name": "context"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "recommendations",
                                "plural": false,
                                "selections": [
                                    v3 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "data",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "entityId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "reasons"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "score"
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "GrowthRecContextResult",
                                                "kind": "LinkedField",
                                                "name": "context",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "tenantId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "product"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "useCase"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "sessionId"
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "GrowthRecRecommendations"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "identifier"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "message"
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "statusCode"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "errorType"
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "QueryError"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$31728bddb59b66c6$var$node.hash = "fb2fa053e956548b71a09ef675a3b9f3";
var $31728bddb59b66c6$export$2e2bcd8739ae039 = $31728bddb59b66c6$var$node;

});

parcelRegister("9F8bm", function(module, exports) {
$parcel$export(module.exports, "extractPermissionResults", () => $c015155af3496055$export$612d04558186e9cc);
const $c015155af3496055$export$612d04558186e9cc = (checkPermissions)=>checkPermissions?.__typename === 'AssetsVerticalCheckPermissionsSuccess' ? checkPermissions.results ?? [] : [];

});

parcelRegister("5JqUt", function(module, exports) {
$parcel$export(module.exports, "extractWorkspaceAri", () => $bd951bea439ef139$export$7c8b58c94614c16c);
/** Narrows the `assetsVertical_tenantContext` union to the workspace ARI. */ const $bd951bea439ef139$export$7c8b58c94614c16c = (tenantContext)=>tenantContext?.__typename === 'AssetsVerticalTenantContextSuccess' ? tenantContext.tenantContext?.assetsVerticalWorkspaceAri ?? null : null;

});

parcelRegister("9ujS8", function(module, exports) {
$parcel$export(module.exports, "useFilterMenuItems", () => $4a32580fabeffbcb$export$fe80c8864155689d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $7tjnB = parcelRequire("7tjnB");

var $d8LhJ = parcelRequire("d8LhJ");

var $hJL79 = parcelRequire("hJL79");

var $aNG0w = parcelRequire("aNG0w");

var $j1V7P = parcelRequire("j1V7P");

var $2AOCd = parcelRequire("2AOCd");

var $8A8fZ = parcelRequire("8A8fZ");

var $OFy3z = parcelRequire("OFy3z");

var $faDlH = parcelRequire("faDlH");

var $alDF5 = parcelRequire("alDF5");

var $3Ihgk = parcelRequire("3Ihgk");

var $b47ZF = parcelRequire("b47ZF");

var $i860n = parcelRequire("i860n");

var $ccEzE = parcelRequire("ccEzE");

var $eaLDc = parcelRequire("eaLDc");

var $2700E = parcelRequire("2700E");

var $4ey3V = parcelRequire("4ey3V");
const $4a32580fabeffbcb$export$cc24ef0259e6a436 = [
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).ALL,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).ALL]
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($j1V7P))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).BOARD,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).BOARD]
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($8A8fZ))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).FILTER,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).FILTER]
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2AOCd))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).DASHBOARD,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).DASHBOARD]
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($OFy3z))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).QUEUE,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).QUEUE]
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Ihgk))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).PROJECT,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).PROJECT]
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($alDF5))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).PLAN,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).PLAN]
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($b47ZF))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).JPD_COLLECTION,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).JPD_COLLECTION]
    }
];
const $4a32580fabeffbcb$export$cdb49db321ba1934 = [
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).ALL,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE_WITH_PROJECT_TERM)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).ALL]
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($j1V7P))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).BOARD,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE_WITH_PROJECT_TERM)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).BOARD]
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($8A8fZ))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).FILTER,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE_WITH_PROJECT_TERM)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).FILTER]
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2AOCd))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).DASHBOARD,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE_WITH_PROJECT_TERM)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).DASHBOARD]
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($OFy3z))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).QUEUE,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE_WITH_PROJECT_TERM)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).QUEUE]
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($faDlH))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).PROJECT,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE_WITH_PROJECT_TERM)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).PROJECT]
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($alDF5))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).PLAN,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE_WITH_PROJECT_TERM)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).PLAN]
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($b47ZF))),
        filterType: (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).JPD_COLLECTION,
        message: (0, $4ey3V.FAVORITE_TYPE_FILTER_MESSAGE_WITH_PROJECT_TERM)[(0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).JPD_COLLECTION]
    }
];
const $4a32580fabeffbcb$export$fe80c8864155689d = ()=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    const jpdEdition = appEditions && (0, $i860n.fg)('jpd-enable-roadmaps-recents-fe') ? (0, $d8LhJ.getEdition)((0, $hJL79.JIRA_PRODUCT_DISCOVERY), appEditions) : undefined;
    const licenseStates = (0, $eaLDc.useLicenseStates)();
    const isJSMLicensed = licenseStates?.serviceDesk === (0, $7tjnB.LICENSE_STATE_ACTIVE);
    const isJSWLicensed = licenseStates?.software === (0, $7tjnB.LICENSE_STATE_ACTIVE);
    const isJSWPremium = appEditions?.software === (0, $d8LhJ.PREMIUM_EDITION);
    const isJPDPremium = (0, $i860n.fg)('jpd-enable-roadmaps-recents-fe') ? jpdEdition === (0, $d8LhJ.PREMIUM_EDITION) : false;
    return (0, $euxye.useMemo)(()=>((0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $4a32580fabeffbcb$export$cc24ef0259e6a436 : $4a32580fabeffbcb$export$cdb49db321ba1934).filter(({ filterType: filterType })=>{
            switch(filterType){
                case (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).QUEUE:
                    return isJSMLicensed;
                case (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).BOARD:
                    return isJSWLicensed;
                case (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).PLAN:
                    return isJSWPremium;
                case (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).JPD_COLLECTION:
                    return isJPDPremium;
                default:
                    return true;
            }
        }), [
        isJSMLicensed,
        isJSWLicensed,
        isJSWPremium,
        isJPDPremium
    ]);
};

});

parcelRegister("7ghii", function(module, exports) {
$parcel$export(module.exports, "useShowItam", () => $ab3dd5d66c0cedcd$export$7585f24906448179);

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $1KydW = parcelRequire("1KydW");

var $ccEzE = parcelRequire("ccEzE");

var $kt86l = parcelRequire("kt86l");

var $9CRef = parcelRequire("9CRef");

var $9wFaR = parcelRequire("9wFaR");

var $3D1JC = parcelRequire("3D1JC");
const $ab3dd5d66c0cedcd$export$7585f24906448179 = ({ assetsVerticalWorkspaceAri: assetsVerticalWorkspaceAri, staticResults: staticResults, verticalInstantiationStatus: verticalInstantiationStatus })=>{
    const environment = (0, $n67Vb.useRelayEnvironment)();
    const appPermissions = (0, $1KydW.useApplicationPermissions)();
    const appEditions = (0, $ccEzE.useAppEditions)();
    const cloudId = (0, $kt86l.useCloudId)();
    const [hamResultsState, setHamResultsState] = (0, $euxye.useState)(null);
    (0, $euxye.useEffect)(()=>{
        if (!cloudId || assetsVerticalWorkspaceAri == null) return;
        let isActive = true;
        const subscription = (0, $3D1JC.fetchItamHamWorkspacePermissions)({
            environment: environment,
            cloudId: cloudId,
            assetsVerticalWorkspaceAri: assetsVerticalWorkspaceAri,
            onCompleted: (results)=>{
                if (isActive) setHamResultsState({
                    cloudId: cloudId,
                    assetsVerticalWorkspaceAri: assetsVerticalWorkspaceAri,
                    results: results
                });
            },
            onError: ()=>{
                if (isActive) setHamResultsState({
                    cloudId: cloudId,
                    assetsVerticalWorkspaceAri: assetsVerticalWorkspaceAri,
                    results: []
                });
            }
        });
        return ()=>{
            isActive = false;
            subscription.unsubscribe();
        };
    }, [
        environment,
        cloudId,
        assetsVerticalWorkspaceAri
    ]);
    const hamResults = hamResultsState?.cloudId === cloudId && hamResultsState.assetsVerticalWorkspaceAri === assetsVerticalWorkspaceAri ? hamResultsState.results : [];
    const checks = (0, $9CRef.buildHamPermissionChecksResult)(cloudId ?? '', assetsVerticalWorkspaceAri, staticResults, hamResults);
    const showItam = (0, $9wFaR.computeShouldShowItam)(!!appPermissions?.hasServiceDeskAccess, appEditions?.serviceDesk, checks);
    const hasHardwareSettingsPermission = showItam && (checks.permissions['manage-ham'] || checks.permissions['jira-admin']);
    return {
        showItam: showItam && (checks.permissions['manage-ham'] || checks.permissions['jira-admin'] || checks.permissions['view-ham']),
        showHardwareSettings: hasHardwareSettingsPermission && verticalInstantiationStatus === 'COMPLETED'
    };
};

});
parcelRegister("9CRef", function(module, exports) {
$parcel$export(module.exports, "buildHamPermissionChecksResult", () => $deffbf5e7b335efe$export$4800b3b5d61cc7ea);
const $deffbf5e7b335efe$var$HAM_ADMIN_PERMISSION_ID = 'manage-ham';
const $deffbf5e7b335efe$var$HAM_USER_PERMISSION_ID = 'view-ham';
const $deffbf5e7b335efe$var$SERVICE_DESK_USER_PERMISSION_ID = 'jsd-user';
const $deffbf5e7b335efe$var$JIRA_ADMIN_PERMISSION_ID = 'jira-admin';
const $deffbf5e7b335efe$var$ASSETS_ADMIN_PERMISSION_ID = 'assets-admin';
const $deffbf5e7b335efe$var$ASSETS_USER_PERMISSION_ID = 'assets-user';
const $deffbf5e7b335efe$var$MANAGE_PERMISSION_ID = 'manage';
const $deffbf5e7b335efe$var$WRITE_PERMISSION_ID = 'write';
const $deffbf5e7b335efe$var$getServiceDeskSiteAri = (cloudId)=>`ari:cloud:jira-servicedesk::site/${cloudId}`;
const $deffbf5e7b335efe$var$getJiraSiteAri = (cloudId)=>`ari:cloud:jira::site/${cloudId}`;
const $deffbf5e7b335efe$var$getAssetsSiteAri = (cloudId)=>`ari:cloud:cmdb::site/${cloudId}`;
const $deffbf5e7b335efe$export$4800b3b5d61cc7ea = (cloudId, assetsVerticalWorkspaceAri, staticResults, hamResults)=>{
    const serviceDeskSiteAri = $deffbf5e7b335efe$var$getServiceDeskSiteAri(cloudId);
    const jiraSiteAri = $deffbf5e7b335efe$var$getJiraSiteAri(cloudId);
    const assetsSiteAri = $deffbf5e7b335efe$var$getAssetsSiteAri(cloudId);
    const permissions = {
        [$deffbf5e7b335efe$var$HAM_ADMIN_PERMISSION_ID]: false,
        [$deffbf5e7b335efe$var$HAM_USER_PERMISSION_ID]: false,
        [$deffbf5e7b335efe$var$SERVICE_DESK_USER_PERMISSION_ID]: false,
        [$deffbf5e7b335efe$var$JIRA_ADMIN_PERMISSION_ID]: false,
        [$deffbf5e7b335efe$var$ASSETS_ADMIN_PERMISSION_ID]: false,
        [$deffbf5e7b335efe$var$ASSETS_USER_PERMISSION_ID]: false
    };
    for (const { permissionId: permissionId, permitted: permitted, resourceId: resourceId } of [
        ...staticResults,
        ...hamResults
    ]){
        if (permissionId === $deffbf5e7b335efe$var$HAM_ADMIN_PERMISSION_ID || permissionId === $deffbf5e7b335efe$var$HAM_USER_PERMISSION_ID) permissions[permissionId] = permitted;
        else if (resourceId === serviceDeskSiteAri) permissions[$deffbf5e7b335efe$var$SERVICE_DESK_USER_PERMISSION_ID] = permitted;
        else if (resourceId === jiraSiteAri) permissions[$deffbf5e7b335efe$var$JIRA_ADMIN_PERMISSION_ID] = permitted;
        else if (resourceId === assetsSiteAri) {
            if (permissionId === $deffbf5e7b335efe$var$MANAGE_PERMISSION_ID) permissions[$deffbf5e7b335efe$var$ASSETS_ADMIN_PERMISSION_ID] = permitted;
            else if (permissionId === $deffbf5e7b335efe$var$WRITE_PERMISSION_ID) permissions[$deffbf5e7b335efe$var$ASSETS_USER_PERMISSION_ID] = permitted;
        }
    }
    return {
        assetsVerticalWorkspaceAri: assetsVerticalWorkspaceAri,
        permissions: permissions
    };
};

});

parcelRegister("9wFaR", function(module, exports) {
$parcel$export(module.exports, "computeShouldShowItam", () => $352b584fa4acad15$export$9a50f2e955e0c134);

var $d8LhJ = parcelRequire("d8LhJ");
const $352b584fa4acad15$var$SERVICE_DESK_USER_PERMISSION_ID = 'jsd-user';
const $352b584fa4acad15$export$9a50f2e955e0c134 = (hasServiceDeskAccess, serviceDeskEdition, checks)=>Boolean(checks && hasServiceDeskAccess && serviceDeskEdition === (0, $d8LhJ.PREMIUM_EDITION) && checks.permissions[$352b584fa4acad15$var$SERVICE_DESK_USER_PERMISSION_ID]);

});

parcelRegister("3D1JC", function(module, exports) {
$parcel$export(module.exports, "fetchItamHamWorkspacePermissions", () => $392481d560f7aec1$export$8ea1b072d7aeeeac);

var $eUVj2 = parcelRequire("eUVj2");

var $n67Vb = parcelRequire("n67Vb");

var $e7TQ5 = parcelRequire("e7TQ5");
const $392481d560f7aec1$var$getPermissionResults = (checkPermissions)=>checkPermissions?.__typename === 'AssetsVerticalCheckPermissionsSuccess' ? checkPermissions.results.map(({ resourceId: resourceId, permissionId: permissionId, permitted: permitted })=>({
            resourceId: resourceId,
            permissionId: permissionId,
            permitted: permitted
        })) : [];
const $392481d560f7aec1$export$8ea1b072d7aeeeac = ({ environment: environment, cloudId: cloudId, assetsVerticalWorkspaceAri: assetsVerticalWorkspaceAri, onCompleted: onCompleted, onError: onError })=>(0, $n67Vb.fetchQuery)(environment, (0, $eUVj2.default), {
        cloudId: cloudId,
        checks: (0, $e7TQ5.getHamPermissionChecks)(assetsVerticalWorkspaceAri)
    }).subscribe({
        next: (data)=>onCompleted($392481d560f7aec1$var$getPermissionResults(data.assetsVertical_checkPermissions)),
        error: onError
    });

});
parcelRegister("eUVj2", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0b21bd99c18cc1e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c04fe66b7b42ecbe025ab1dc6f79a664>>
 * @relayHash 75d5038cebaa755baa14667ba330cb3a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf31ede343abcf39655f3d91d05e6dbdd307e2d1833acc93d68031c3df52868b
const $e0b21bd99c18cc1e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "checks"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "checks",
                    "variableName": "checks"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "LinkedField",
            "name": "assetsVertical_checkPermissions",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "AssetsVerticalPermissionCheckResult",
                            "kind": "LinkedField",
                            "name": "results",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "permissionId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "permitted"
                                }
                            ]
                        }
                    ],
                    "type": "AssetsVerticalCheckPermissionsSuccess"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchItamHamWorkspacePermissionsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchItamHamWorkspacePermissionsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "bf31ede343abcf39655f3d91d05e6dbdd307e2d1833acc93d68031c3df52868b",
            "metadata": {},
            "name": "fetchItamHamWorkspacePermissionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e0b21bd99c18cc1e$var$node.hash = "da7c453fc0f6e43da430f072b03fa7f7";
var $e0b21bd99c18cc1e$export$2e2bcd8739ae039 = $e0b21bd99c18cc1e$var$node;

});

parcelRegister("e7TQ5", function(module, exports) {
$parcel$export(module.exports, "getHamPermissionChecks", () => $ec5ec712c6b24adb$export$83bae3db97575055);
const $ec5ec712c6b24adb$var$HAM_ADMIN_PERMISSION_ID = 'manage-ham';
const $ec5ec712c6b24adb$var$HAM_USER_PERMISSION_ID = 'view-ham';
const $ec5ec712c6b24adb$export$83bae3db97575055 = (assetsVerticalWorkspaceAri)=>[
        {
            resourceId: assetsVerticalWorkspaceAri,
            permissionId: $ec5ec712c6b24adb$var$HAM_ADMIN_PERMISSION_ID
        },
        {
            resourceId: assetsVerticalWorkspaceAri,
            permissionId: $ec5ec712c6b24adb$var$HAM_USER_PERMISSION_ID
        }
    ];

});



parcelRegister("lt6RH", function(module, exports) {
$parcel$export(module.exports, "GSNForContentSidebarWithInvitedAppRecommendations", () => $2a88fd7ddfc1c42f$export$9cc3b4b65c2666b6);
/**
 * Productionisation cohort wrapper for `GSNForContentSidebar`.
 *
 * Mounts the AGG-driven productionisation path. Unlike the legacy
 * experiment branch:
 *
 *   1. Receives an already-translated `InvitedAppShortcutsRecommendationsResult`
 *      from `InvitedAppShortcutsRecommendations.tsx` (Jira-owned renderer).
 *   2. Maps the resolved `recommendations` into the typed `recommendedApps`
 *      array used by the productionisation hook.
 *   3. Calls `useInvitedAppShortcuts({ mode: 'productionisation' })` to feed
 *      the cookie-write-only side of the legacy `InvitedAppShortcutsContainer`.
 *
 * Used only when:
 *   - `cloudId` + `userId` are non-empty
 *   - the productionisation cohort gate (`twcg-460-personalised-invite-notifications-m2`)
 *     resolves to `isEnabled === true` in the render-side dispatcher
 *   - the preload-side cohort gate (`twcg-460-preload-grs-invited-app-shortcuts(-gate)`)
 *     was on at preload time so `result` could be computed
 *
 * If the upstream preload fired but produced an error or empty result, the
 * `recommendedApps` list is `[]` and the productionisation hook treats it as
 * `NO_RECOMMENDED_APPS`, matching control behaviour.
 */ 
var $euxye = parcelRequire("euxye");

var $bcUWA = parcelRequire("bcUWA");

var $9qH0V = parcelRequire("9qH0V");

var $hmszZ = parcelRequire("hmszZ");

var $3AgS2 = parcelRequire("3AgS2");

var $2700E = parcelRequire("2700E");

var $2lek2 = parcelRequire("2lek2");
const $2a88fd7ddfc1c42f$var$SOURCE_APP = 'jira';
function $2a88fd7ddfc1c42f$export$9cc3b4b65c2666b6(props) {
    const { bottomElem: bottomElem, cloudId: cloudId, customizationStore: customizationStore, experimental_onShortcutsMenuSettled: experimentalOnShortcutsMenuSettled, forYouConfig: forYouConfig, intlMode: intlMode, isShortcutsStatic: isShortcutsStatic, items: items, networkStorageParams: networkStorageParams, peekMenuId: peekMenuId, result: result, shortcuts: shortcuts, testId: testId, userId: userId } = props;
    // Map the translated `recommendations` into the typed recommended-app list.
    // `result.kind === 'error'` and `'empty'` both fall through to `[]`, which
    // the productionisation hook treats as `NO_RECOMMENDED_APPS`. This matches
    // control / disabled cohort behaviour visually.
    //
    // Keyed off the parsed `product`, NOT the raw `entityId`: since PUMA-2245 GRS
    // encodes the lozenge variant into the id (`confluence-animated-shortcut`), so
    // an entityId match would reject every recommendation. `product` is `null` for
    // ids that do not name a supported target app.
    const recommendedApps = (0, $euxye.useMemo)(()=>result.kind === 'recommendations' ? result.recommendations.reduce((acc, r)=>{
            if (r.product !== null) acc.push({
                product: r.product,
                variant: r.variant
            });
            return acc;
        }, []) : [], [
        result
    ]);
    // `targetProducts` is variant-agnostic by design, so map back down to plain
    // product keys rather than propagating the richer shape into it.
    const targetProducts = (0, $euxye.useMemo)(()=>(0, $hmszZ.toRecommendedProducts)(recommendedApps), [
        recommendedApps
    ]);
    // Reuse the same process-singleton cookie cache as the legacy experiment
    // branch (`useResolveInvitedAppShortcuts`). Productionisation mode does not
    // read from the cache for eligibility (that comes from `recommendedApps`),
    // but the hook's "Active in both modes" code paths
    // (`updateFromHydratedShortcuts`, `registerImpression`, `registerActivation`,
    // `updateHydratedProductLinks`, `updateFromAppAccessFilter`) still enqueue
    // writes to keep the cookie cache warm as a fallback against cohort flips /
    // gate-off. Passing the same singleton avoids divergent cache state.
    const resolverResult = (0, $3AgS2.useInvitedAppShortcuts)({
        enabled: true,
        mode: 'productionisation',
        sourceProduct: $2a88fd7ddfc1c42f$var$SOURCE_APP,
        targetProducts: targetProducts,
        cloudId: cloudId,
        userId: userId,
        cache: (0, $bcUWA.getJiraSsrCookieCacheInstance)(),
        recommendedApps: recommendedApps
    });
    // Destructure only the function we depend on: `resolverResult` is the full
    // `useInvitedAppShortcuts` return, whose `useMemo` includes a potentially
    // unstable `analytics` dep, so depending on the whole object could re-run the
    // effect (and re-fire the exposure) every render.
    const { fireFeatureExposed: fireFeatureExposed } = resolverResult;
    // Fire the productionisation-preload experiment exposure only when there are
    // recommendations to render — i.e. the user is genuinely exposed to the
    // treatment. Preloading is gated by the kill-switch `fg` in the parent
    // entrypoint (where eligibility isn't yet known); dispatch is gated on the m2
    // experiment in `GSNForContentSidebarEntryPoint.tsx`.
    (0, $euxye.useEffect)(()=>{
        if (recommendedApps.length > 0) fireFeatureExposed({
            isEnabled: (0, $2700E.expVal)('twcg-460-preload-grs-invited-app-shortcuts', 'isEnabled', false)
        });
    }, [
        recommendedApps,
        fireFeatureExposed
    ]);
    // Config for GSN's `ShortcutsSlot` (`InvitedAppShortcutsSlot`), passed via
    // context so the slot keeps a stable identity. GSN receives the base
    // `shortcuts` config and the slot decorates its resolved `shortcutItems`.
    const slotConfig = (0, $euxye.useMemo)(()=>({
            mode: 'productionisation',
            resolverResult: resolverResult,
            cloudId: cloudId,
            userId: userId,
            recommendedApps: recommendedApps,
            sourceApp: $2a88fd7ddfc1c42f$var$SOURCE_APP
        }), [
        resolverResult,
        cloudId,
        userId,
        recommendedApps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2lek2.InvitedAppShortcutsSlotContext).Provider, {
        value: slotConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9qH0V.GlobalSideNavigation), {
        app: "jira",
        appLabel: "Jira",
        bottomElem: bottomElem,
        cloudId: cloudId,
        customizationStore: customizationStore,
        experimental_onShortcutsMenuSettled: experimentalOnShortcutsMenuSettled,
        forYou: forYouConfig,
        intlMode: intlMode,
        isShortcutsStatic: isShortcutsStatic,
        items: items,
        networkStorageParams: networkStorageParams,
        peekMenuId: peekMenuId,
        shortcuts: shortcuts,
        testId: testId,
        ShortcutsSlot: (0, $2lek2.InvitedAppShortcutsSlot)
    }));
}
$2a88fd7ddfc1c42f$export$9cc3b4b65c2666b6.displayName = "GSNForContentSidebarWithInvitedAppRecommendations";

});
parcelRegister("2lek2", function(module, exports) {
$parcel$export(module.exports, "InvitedAppShortcutsSlotContext", () => $99a53ec46b10c378$export$a88765f136ccbd75);
$parcel$export(module.exports, "InvitedAppShortcutsSlot", () => $99a53ec46b10c378$export$e336ba51cc712211);
/**
 * Shared `ShortcutsSlot` implementation (NAVX-5236) for the Jira GSN
 * invited-app-shortcuts integration.
 *
 * Instead of wrapping the whole `GlobalSideNavigation` in
 * `InvitedAppShortcutsContainer` and swapping its `shortcuts` config, GSN keeps
 * the base `shortcuts` config and renders this component in its `ShortcutsSlot`.
 * GSN hands us the already-resolved `shortcutItems` (visibility-filtered,
 * ordered, analytics-wrapped) plus a pre-bound `Component`. We feed those items
 * to `InvitedAppShortcutsContainer` as its `shortcutsConfig` so it can decorate
 * the eligible invited-app entries in place (hover popup ref, activation
 * onClick, invited label), then render the decorated result back through
 * `Component`.
 *
 * The container config (resolver result + mode-specific props) reaches this
 * module-level component via React context, so the slot keeps a stable identity
 * and GSN never remounts the shortcuts subtree when the config reference
 * changes. Both call sites (the experiment/legacy branch in
 * `GSNForContentSidebarEntryPoint.tsx` and the productionisation path in
 * `GSNForContentSidebarWithInvitedAppRecommendations.tsx`) share this slot.
 *
 * Config keys are opaque here — we read the values straight back via
 * `Object.values`, so we don't depend on `menuItemId` being present on every
 * item variant, and insertion order (hence GSN's visible order) is preserved.
 */ 
var $euxye = parcelRequire("euxye");

var $iurTG = parcelRequire("iurTG");
const $99a53ec46b10c378$export$a88765f136ccbd75 = /*#__PURE__*/ (0, $euxye.createContext)(null);
function $99a53ec46b10c378$export$e336ba51cc712211({ Component: Component, shortcutItems: shortcutItems }) {
    const config = (0, $euxye.useContext)($99a53ec46b10c378$export$a88765f136ccbd75);
    const shortcutsConfig = (0, $euxye.useMemo)(()=>shortcutItems.reduce((acc, item, index)=>{
            acc[String(index)] = item;
            return acc;
        }, {}), [
        shortcutItems
    ]);
    // Defensive: both call sites always supply a config on this path, but if it
    // is ever missing, fail open to the default (undecorated) shortcuts menu
    // rather than crashing the nav.
    if (!config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, null);
    if (config.mode === 'productionisation') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iurTG.InvitedAppShortcutsContainer), {
        mode: "productionisation",
        cloudId: config.cloudId,
        userId: config.userId,
        recommendedApps: config.recommendedApps,
        sourceApp: config.sourceApp,
        shortcutsConfig: shortcutsConfig,
        resolverResult: config.resolverResult
    }, ({ referrableShortcuts: referrableShortcuts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, {
            shortcutItems: Object.values(referrableShortcuts)
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iurTG.InvitedAppShortcutsContainer), {
        shortcutsConfig: shortcutsConfig,
        resolverResult: config.resolverResult
    }, ({ referrableShortcuts: referrableShortcuts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, {
            shortcutItems: Object.values(referrableShortcuts)
        }));
}
$99a53ec46b10c378$export$e336ba51cc712211.displayName = "InvitedAppShortcutsSlot";

});


parcelRegister("9uMYd", function(module, exports) {
$parcel$export(module.exports, "getInvitedAppShortcutsRecommendationsResult", () => $9c8b743acebfbbb2$export$6f3a68915a6e93b6);
/**
 * Translates the `growthRecommendations` selection of `GSNForContentSidebarEntryPoint`
 * into the discriminated `InvitedAppShortcutsRecommendationsResult` consumed by
 * `GSNForContentSidebarWithInvitedAppRecommendations`.
 *
 * The recommendations are fetched as part of the main GSN query (behind
 * `@include(if: $shouldFetchInvitedAppShortcuts)`) rather than a separate
 * query/entrypoint, so this reads the field off the already-loaded fragment
 * data. The destructure-then-rebuild mirrors `InvitedAppShortcutsRecommendationsResponse`
 * in `cross-join-nudges`, which is the single source of truth for the translator.
 */ 
var $cEcCa = parcelRequire("cEcCa");
function $9c8b743acebfbbb2$export$6f3a68915a6e93b6(growthRecommendations) {
    const node = growthRecommendations?.recommendations;
    let recommendations;
    if (node == null) recommendations = null;
    else if (node.__typename === 'GrowthRecRecommendations') recommendations = {
        __typename: 'GrowthRecRecommendations',
        data: (node.data ?? []).map((item)=>({
                entityId: item?.entityId ?? '',
                reasons: item?.reasons ?? null,
                score: item?.score ?? null
            })),
        context: node.context ? {
            tenantId: node.context.tenantId ?? null,
            product: node.context.product ?? null,
            useCase: node.context.useCase ?? null,
            sessionId: node.context.sessionId ?? null
        } : null
    };
    else if (node.__typename === 'QueryError') recommendations = {
        __typename: 'QueryError',
        identifier: node.identifier ?? null,
        message: node.message ?? null,
        extensions: (node.extensions ?? []).map((ext)=>({
                statusCode: ext?.statusCode ?? null,
                errorType: ext?.errorType ?? null
            }))
    };
    else // Unknown __typename — treat as no recommendations.
    recommendations = {
        __typename: node.__typename
    };
    const response = {
        growthRecommendations: {
            recommendations: recommendations
        }
    };
    return (0, $cEcCa.buildInvitedAppShortcutsRecommendationsResult)(response);
}

});
parcelRegister("cEcCa", function(module, exports) {
$parcel$export(module.exports, "buildInvitedAppShortcutsRecommendationsResult", () => $d1b98ddcbf1712da$export$1d36738cc02616ef);
/**
 * Render-prop provider that normalises a raw Invited App Shortcuts
 * recommendations response into `InvitedAppShortcutsRecommendationsResult`.
 *
 * ## Why this is a pure translator (not a Relay component)
 *
 * The previous version of this provider owned the `graphql\`...\`` document, the
 * `usePreloadedQuery` call, and the `__generated__/<Query>.graphql.ts` import.
 * That coupled the package to a single Relay artifact that lived inside this
 * package's `src/.../__generated__/` directory.
 *
 * Jira and Confluence entrypoint files cannot import that artifact:
 *
 * - Jira's `@atlassian/react-entrypoint/no-imports-in-entrypoint-file` lint rule
 *   restricts imports inside `*.entrypoint.tsx` files to a narrow allowlist
 *   (relative `*\/__generated__/*` paths, `@atlassian/ari/*`, the feature-gate
 *   modules, etc). A subpath export like
 *   `@atlassian/cross-join-nudges/.../recommendations-provider/query` matches
 *   `*\/__generated__/*` after module resolution, but the rule matches against
 *   the literal import-path string and so still rejects it.
 *
 * - There is no comparable rule in Confluence today, but Confluence's SSR
 *   preload pattern follows the same shape (load the query at route resolution
 *   time, render with `usePreloadedQuery`), and we want to keep both consumers
 *   on the same architecture.
 *
 * To unblock SSR preload in both products without a per-product allowlist
 * carve-out, this provider now operates on the **raw AGG response shape** that
 * consumers obtain from their own preloaded Relay query. Each consumer:
 *
 *   1. Owns a local `.graphql` file with the canonical query body (kept in sync
 *      via the drift test exported from `@atlassian/cross-join-nudges/test-helpers`).
 *   2. Preloads that query in their entrypoint and reads it with
 *      `usePreloadedQuery` in their renderer.
 *   3. Passes the resulting raw data to this provider as
 *      `recommendationsResponse`.
 *
 * This file therefore deliberately:
 *
 * - Does NOT `import` anything from `react-relay`. Consumers own the Relay
 *   integration; this file is pure data normalisation.
 * - Does NOT carry a `graphql\`...\`` template literal. The canonical query
 *   source is exported from `./test-helpers` so consumers (and the drift test)
 *   can read it as plain text.
 * - Defines a structural `InvitedAppShortcutsRecommendationsResponse` type that
 *   any Relay-generated type matching the canonical selection set will satisfy.
 *
 * For non-React callers (e.g. SSR adapters, unit tests, analytics middleware)
 * the same normalisation is available via the stand-alone
 * `buildInvitedAppShortcutsRecommendationsResult(response)` helper.
 */ 
var $hmszZ = parcelRequire("hmszZ");
function $d1b98ddcbf1712da$export$1d36738cc02616ef(recommendationsResponse) {
    const node = recommendationsResponse.growthRecommendations?.recommendations;
    if (!node) return {
        kind: 'empty'
    };
    if (node.__typename === 'GrowthRecRecommendations') {
        const growthRecNode = node;
        const recommendations = (growthRecNode.data ?? []).map((item)=>{
            // Derived here rather than supplied by the caller: the variant is
            // encoded in `entityId`, so parsing it is the translator's job and
            // the raw response contract above stays untouched.
            const parsed = (0, $hmszZ.parseInvitedAppShortcutEntityId)(item.entityId);
            return {
                entityId: item.entityId,
                product: parsed?.product ?? null,
                reasons: item.reasons ?? [],
                // GRS can return null/undefined; default to 0 so consumers can rank
                // without null-checking every score.
                score: item.score ?? 0,
                variant: parsed?.variant ?? 'none'
            };
        });
        return {
            kind: 'recommendations',
            recommendations: recommendations,
            context: {
                tenantId: growthRecNode.context?.tenantId ?? null,
                product: growthRecNode.context?.product ?? null,
                useCase: growthRecNode.context?.useCase ?? null,
                sessionId: growthRecNode.context?.sessionId ?? null
            }
        };
    }
    if (node.__typename === 'QueryError') {
        const errorNode = node;
        // `extensions` is an array of {statusCode, errorType} per the AGG schema;
        // surface the first entry which is what AGG conventionally populates.
        const firstExtension = errorNode.extensions?.[0];
        return {
            kind: 'error',
            identifier: errorNode.identifier ?? null,
            message: errorNode.message ?? null,
            statusCode: firstExtension?.statusCode ?? null,
            errorType: firstExtension?.errorType ?? null
        };
    }
    return {
        kind: 'error',
        identifier: null,
        message: `Unknown InvitedAppShortcutsRecommendations response __typename: ${node.__typename}`,
        statusCode: null,
        errorType: null
    };
}
function $d1b98ddcbf1712da$export$ffe033da16b39f1b({ recommendationsResponse: recommendationsResponse, children: children }) {
    // No `useMemo`: `buildInvitedAppShortcutsRecommendationsResult` is a cheap
    // object walk + a `.map()` over `recommendations.data` (typically <10
    // items), and the wrapping `useMemo` only paid off when callers passed a
    // stable `recommendationsResponse` reference. Avoiding the memo removes
    // the foot-gun where fresh-object-literal callers silently re-run the
    // translator on every render and gives a single, predictable code path.
    return children($d1b98ddcbf1712da$export$1d36738cc02616ef(recommendationsResponse));
}

});


parcelRegister("c6RdE", function(module, exports) {
$parcel$export(module.exports, "getForYouConfig", () => $e615c9adcbeaa628$export$7929fceb464f62e7);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $5IkoH = parcelRequire("5IkoH");

var $3T5IC = parcelRequire("3T5IC");

var $gEDfa = parcelRequire("gEDfa");

var $lpMZQ = parcelRequire("lpMZQ");

var $78Tto = parcelRequire("78Tto");

var $4ey3V = parcelRequire("4ey3V");

var $dRabH = parcelRequire("dRabH");

var $ki5u6 = parcelRequire("ki5u6");

var $9vZDD = parcelRequire("9vZDD");

var $526V9 = parcelRequire("526V9");

var $dgOWQ = parcelRequire("dgOWQ");

var $4kWbe = parcelRequire("4kWbe");
function $e615c9adcbeaa628$export$7929fceb464f62e7(params) {
    const { isForYouSelected: isForYouSelected, recentEntryPointParams: recentEntryPointParams, starredEntryPointParams: starredEntryPointParams, starredFilterConfig: starredFilterConfig } = params;
    return {
        forYouItem: {
            isSelected: isForYouSelected,
            menuItemId: (0, $5IkoH.MENU_ID_FOR_YOU),
            url: (0, $3T5IC.jiraHomeRoute).path
        },
        recent: {
            entryPoint: (0, $9vZDD.recentFlyoutEntrypoint),
            entryPointParams: recentEntryPointParams,
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), {
                withHeading: true,
                withSearch: true,
                withSubHeading: true,
                withSubTitle: true,
                isFlyout: true
            }),
            isSearchable: true,
            ItemComponent: (0, $dgOWQ.RecentMenuLinkItemAdaptor),
            menuItemId: 'jira.sidebar.recent',
            MenuContentWrapperComponent: (0, $lpMZQ.AnalyticContextProvider),
            useItems: (0, $dRabH.useRecentItems),
            viewAllUrl: `${(0, $3T5IC.jiraHomeRoute).path}?viewed`
        },
        starred: {
            entryPoint: (0, $526V9.starredFlyoutEntrypoint),
            entryPointParams: starredEntryPointParams,
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gEDfa.SkeletonNavMenuItems), {
                withHeading: true,
                withSearch: true,
                isFlyout: true
            }),
            filterConfig: {
                filters: starredFilterConfig,
                defaultSelected: [
                    (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).ALL
                ],
                hideSelectedFilterTag: [
                    (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).ALL
                ]
            },
            isSearchable: true,
            ItemComponent: (0, $4kWbe.StarredMenuLinkItemAdaptor),
            menuItemId: 'jira.sidebar.starred',
            MenuContentWrapperComponent: (0, $78Tto.AnalyticContextProvider),
            useItems: (0, $ki5u6.useStarredItems),
            viewAllUrl: `${(0, $3T5IC.jiraHomeRoute).path}?starred`
        }
    };
}

});
parcelRegister("lpMZQ", function(module, exports) {
$parcel$export(module.exports, "AnalyticContext", () => $896b0ba9ec32c809$export$da0556bf821b3494);
$parcel$export(module.exports, "AnalyticContextProvider", () => $896b0ba9ec32c809$export$aea8e3edcdec81e3);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");




var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
const $896b0ba9ec32c809$var$COMMON_PAYLOAD = {
    action: 'clicked',
    actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
    actionSubjectId: 'recentNavigationMenuItem'
};
const $896b0ba9ec32c809$export$da0556bf821b3494 = /*#__PURE__*/ (0, $euxye.createContext)({
    fireUIAnalyticForFixItem: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    fireUIAnalyticForRecentItems: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
});
const $896b0ba9ec32c809$export$aea8e3edcdec81e3 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireUIAnalyticForFixItem = (0, $euxye.useCallback)(({ itemId: itemId })=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            ...$896b0ba9ec32c809$var$COMMON_PAYLOAD,
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                itemId: itemId
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForRecentItems = (0, $euxye.useCallback)(({ itemId: itemId, itemType: itemType, timeRange: timeRange })=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            ...$896b0ba9ec32c809$var$COMMON_PAYLOAD,
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
                itemType: itemType.toLowerCase(),
                itemId: itemId,
                section: timeRange
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($896b0ba9ec32c809$export$da0556bf821b3494.Provider, {
        value: {
            fireUIAnalyticForFixItem: fireUIAnalyticForFixItem,
            fireUIAnalyticForRecentItems: fireUIAnalyticForRecentItems
        }
    }, children);
};
$896b0ba9ec32c809$export$aea8e3edcdec81e3.displayName = "AnalyticContextProvider";

});

parcelRegister("78Tto", function(module, exports) {
$parcel$export(module.exports, "AnalyticContext", () => $19b2da089eb281ac$export$da0556bf821b3494);
$parcel$export(module.exports, "AnalyticContextProvider", () => $19b2da089eb281ac$export$aea8e3edcdec81e3);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");




var $c9cNX = parcelRequire("c9cNX");

var $5IkoH = parcelRequire("5IkoH");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $4ey3V = parcelRequire("4ey3V");
const $19b2da089eb281ac$export$da0556bf821b3494 = /*#__PURE__*/ (0, $euxye.createContext)({
    fireUIAnalyticForFixItem: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    fireUIAnalyticForFilterButton: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    fireUIAnalyticForFilterActions: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    fireUIAnalyticForStarredItems: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    fireUIAnalyticForStarrButton: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
});
const $19b2da089eb281ac$export$aea8e3edcdec81e3 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireUIAnalyticForFixItem = (0, $euxye.useCallback)(({ itemId: itemId })=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_STARRED],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$4165a3d0da3bd147),
                itemId: itemId
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFilterButton = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_STARRED],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
                itemId: (0, $4ey3V.FILTER)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFilterActions = (0, $euxye.useCallback)(({ itemId: itemId })=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_STARRED],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                componentType: (0, $6e2f51712bb2e810$export$95b0c331af13d819),
                itemId: itemId,
                parentItemId: (0, $4ey3V.FILTER)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForStarredItems = (0, $euxye.useCallback)(({ itemId: itemId, itemType: itemType })=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_STARRED],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$265c523d1a8f25cf),
                componentType: (0, $6e2f51712bb2e810$export$3ac911b122986477),
                itemType: itemType.toLowerCase(),
                itemId: itemId
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForStarrButton = (0, $euxye.useCallback)(({ starType: starType, parentItemId: parentItemId, parentItemType: parentItemType })=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_STARRED],
            attributes: {
                level: (0, $ef39084c605eb7e8$export$fe3b012b0224e4e1),
                componentType: (0, $6e2f51712bb2e810$export$5374c2c2d3ece55e),
                itemId: starType,
                parentItemId: parentItemId,
                parentItemType: parentItemType.toLowerCase()
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($19b2da089eb281ac$export$da0556bf821b3494.Provider, {
        value: {
            fireUIAnalyticForFixItem: fireUIAnalyticForFixItem,
            fireUIAnalyticForFilterButton: fireUIAnalyticForFilterButton,
            fireUIAnalyticForFilterActions: fireUIAnalyticForFilterActions,
            fireUIAnalyticForStarredItems: fireUIAnalyticForStarredItems,
            fireUIAnalyticForStarrButton: fireUIAnalyticForStarrButton
        }
    }, children);
};
$19b2da089eb281ac$export$aea8e3edcdec81e3.displayName = "AnalyticContextProvider";

});

parcelRegister("dRabH", function(module, exports) {
$parcel$export(module.exports, "useRecentItems", () => $b67a5f42c2fda1e5$export$bc82a767d3a2a41);

var $7x99R = parcelRequire("7x99R");

var $i7pEy = parcelRequire("i7pEy");

var $7gTG5 = parcelRequire("7gTG5");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $kFgCO = parcelRequire("kFgCO");

var $gQJGQ = parcelRequire("gQJGQ");

var $1YIbA = parcelRequire("1YIbA");

var $ksdzi = parcelRequire("ksdzi");

var $iwPMt = parcelRequire("iwPMt");
const $b67a5f42c2fda1e5$var$DEBOUNCE_INTERVAL = 300;
function $b67a5f42c2fda1e5$export$bc82a767d3a2a41(params) {
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const { searchText: searchText, queries: queries } = params;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const userLocale = (0, $gQJGQ.useLocale)();
    const recentMenuData = queries.recentMenuData;
    const { cloudId: cloudId, count: count } = recentMenuData.variables;
    const queryData = (0, $n67Vb.usePreloadedQuery)((0, $7gTG5.default), recentMenuData);
    const [fragmentData, refetch] = (0, $n67Vb.useRefetchableFragment)((0, $i7pEy.default), queryData);
    // NOTE: refetch() returns a Disposable resource. This resource should be dispose()'d of
    // before subsequent calls to refetch.
    // We also want to debounce changes-to-the-search-string.
    const disposableSearchRef = (0, $euxye.useRef)(null);
    const handleFilterChange = (0, $euxye.useCallback)((searchQuery)=>refetch({
            keyword: searchQuery,
            cloudId: cloudId
        }), [
        cloudId,
        refetch
    ]);
    const [handleDebouncedSearchChange] = (0, $ksdzi.default)((newSearchQuery = searchText)=>{
        disposableSearchRef.current?.dispose();
        disposableSearchRef.current = handleFilterChange(newSearchQuery ?? '');
    }, $b67a5f42c2fda1e5$var$DEBOUNCE_INTERVAL);
    (0, $euxye.useEffect)(()=>{
        handleDebouncedSearchChange(searchText ?? '');
    }, [
        handleDebouncedSearchChange,
        searchText
    ]);
    const { data: { user: user } } = (0, $kFgCO.useCurrentUser)();
    const timeZone = typeof user.timeZone === 'string' ? user.timeZone : '';
    const { data: data, hasNext: /* isLoadingNext, */ hasNext, loadNext: loadNext } = (0, $n67Vb.usePaginationFragment)((0, $7x99R.default), fragmentData);
    const accountId = user.accountId;
    const deps = (0, $euxye.useMemo)(()=>({
            formatMessage: formatMessage,
            locale: userLocale,
            cloudId: cloudId,
            accountId: accountId
        }), [
        formatMessage,
        userLocale,
        cloudId,
        accountId
    ]);
    const { sections: sections } = (0, $euxye.useMemo)(()=>{
        const nodes = data.jira._recentItems?.edges?.map((edge)=>edge?.node).filter(Boolean) ?? [];
        return {
            sections: (0, $iwPMt.getSections)(nodes, timeZone, deps)
        };
    }, [
        data.jira._recentItems?.edges,
        timeZone,
        deps
    ]);
    const loadMore = (0, $euxye.useCallback)(()=>loadNext(count), [
        loadNext,
        count
    ]);
    if (searchText === '') return {
        sections: sections,
        hasMore: hasNext,
        isLoading: false,
        loadMore: loadMore
    };
    return {
        hasMore: hasNext,
        isLoading: false,
        loadMore: loadMore,
        sections: sections
    };
}

});
parcelRegister("7x99R", function(module, exports) {
$parcel$export(module.exports, "default", () => $621775caaba6eabe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1052ffd4b76571526f983d42fbbe4115>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $6ZD4t = parcelRequire("6ZD4t");
const $621775caaba6eabe$var$node = function() {
    var v0 = [
        "jira",
        "_recentItems"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v3 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        {
            "alias": "filterName",
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterUrl"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "kind": "RootArgument",
                "name": "keyword"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "count",
                        "cursor": "cursor"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $6ZD4t.default)
            }
        },
        "name": "useRecentItemsPaged",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "_recentItems",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "keyword",
                                            "variableName": "keyword"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "filter"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "PROJECT",
                                        "FILTER",
                                        "DASHBOARD",
                                        "BOARD",
                                        "QUEUE",
                                        "ISSUE",
                                        "PLAN",
                                        "JPD_COLLECTION"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "__useRecentItemsPaged__recentItems_connection",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "alias": "issueWebUrl",
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        },
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v4 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v4 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "alias": "collectionTitle",
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "emoji"
                                                                }
                                                            ],
                                                            "type": "JiraProductDiscoveryCollection"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW"
            }
        ],
        "type": "Query"
    };
}();
$621775caaba6eabe$var$node.hash = "ab96d591cec74d26a65087de1cd896e1";
var $621775caaba6eabe$export$2e2bcd8739ae039 = $621775caaba6eabe$var$node;

});
parcelRegister("6ZD4t", function(module, exports) {
$parcel$export(module.exports, "default", () => $074da93071af3f86$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4d219730b6a54df8278310e3da1a805f>>
 * @relayHash 72803140bbb30f9a74840d1ad0ae21d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ba784a0d7e3336234cff365be95b3f6dad5e8101e2fe38371b31a177165c49eb

var $kSjiz = parcelRequire("kSjiz");
const $074da93071af3f86$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cursor"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJpdRoadmapsRecentsEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "keyword"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "keyword",
                    "variableName": "keyword"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        {
            "kind": "Literal",
            "name": "types",
            "value": [
                "PROJECT",
                "FILTER",
                "DASHBOARD",
                "BOARD",
                "QUEUE",
                "ISSUE",
                "PLAN",
                "JPD_COLLECTION"
            ]
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v10 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v9 /*: any*/ 
        ]
    }, v11 = [
        v7 /*: any*/ ,
        v8 /*: any*/ ,
        {
            "alias": "filterName",
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterUrl"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useRecentItemsPaginationQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        },
                        {
                            "kind": "Variable",
                            "name": "cursor",
                            "variableName": "cursor"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "useRecentItemsPaged"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled"
                }
            ],
            "kind": "Operation",
            "name": "useRecentItemsPaginationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "_recentItems",
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v7 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "issueWebUrl",
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                },
                                                                v7 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        },
                                                        v10 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v11 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v11 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "alias": "collectionTitle",
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "emoji"
                                                                }
                                                            ],
                                                            "type": "JiraProductDiscoveryCollection"
                                                        }
                                                    ]
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v5 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "types",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "useRecentItemsPaged__recentItems",
                            "kind": "LinkedHandle",
                            "name": "recentItems"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ba784a0d7e3336234cff365be95b3f6dad5e8101e2fe38371b31a177165c49eb",
            "metadata": {},
            "name": "useRecentItemsPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "isJpdRoadmapsRecentsEnabled": (0, $kSjiz.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled": (0, $kSjiz.default)
            }
        }
    };
}();
$074da93071af3f86$var$node.hash = "ab96d591cec74d26a65087de1cd896e1";
var $074da93071af3f86$export$2e2bcd8739ae039 = $074da93071af3f86$var$node;

});


parcelRegister("i7pEy", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a67a68fe880fcc1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b30e0a22273f4a358ec73a88f0a6cb43>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $hHNKZ = parcelRequire("hHNKZ");
const $6a67a68fe880fcc1$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "count"
        },
        {
            "kind": "RootArgument",
            "name": "keyword"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $hHNKZ.default)
        }
    },
    "name": "useRecentItems",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "count",
                    "variableName": "count"
                }
            ],
            "kind": "FragmentSpread",
            "name": "useRecentItemsPaged"
        }
    ],
    "type": "Query"
};
$6a67a68fe880fcc1$var$node.hash = "c7427eba8c734344b51198ca307b6328";
var $6a67a68fe880fcc1$export$2e2bcd8739ae039 = $6a67a68fe880fcc1$var$node;

});
parcelRegister("hHNKZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f034a96483b0172a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63eed286f78353b3a8cc5fd4eae14a07>>
 * @relayHash fc25bd3e1f6f12f587a89eeb409790af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f70d763d65596ee4f25bba1704a585a1f2a352b8da0d493f7f55c3c216ec24eb

var $kSjiz = parcelRequire("kSjiz");
const $f034a96483b0172a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "keyword"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "keyword",
                    "variableName": "keyword"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        {
            "kind": "Literal",
            "name": "types",
            "value": [
                "PROJECT",
                "FILTER",
                "DASHBOARD",
                "BOARD",
                "QUEUE",
                "ISSUE",
                "PLAN",
                "JPD_COLLECTION"
            ]
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v8 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v7 /*: any*/ 
        ]
    }, v9 = [
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        {
            "alias": "filterName",
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterUrl"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useRecentItemsRefetchableQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "useRecentItems"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled"
                }
            ],
            "kind": "Operation",
            "name": "useRecentItemsRefetchableQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "_recentItems",
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "issueWebUrl",
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        },
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v9 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v9 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "alias": "collectionTitle",
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "emoji"
                                                                }
                                                            ],
                                                            "type": "JiraProductDiscoveryCollection"
                                                        }
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v3 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "types",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "useRecentItemsPaged__recentItems",
                            "kind": "LinkedHandle",
                            "name": "recentItems"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f70d763d65596ee4f25bba1704a585a1f2a352b8da0d493f7f55c3c216ec24eb",
            "metadata": {},
            "name": "useRecentItemsRefetchableQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled": (0, $kSjiz.default)
            }
        }
    };
}();
$f034a96483b0172a$var$node.hash = "c7427eba8c734344b51198ca307b6328";
var $f034a96483b0172a$export$2e2bcd8739ae039 = $f034a96483b0172a$var$node;

});


parcelRegister("7gTG5", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf47837d884f4b0d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5fd38e7e4be9883c37627ca4139628f4>>
 * @relayHash d23ef79ff70885ec6bdd0a48d7f45aca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 509ec68027aa639e3a3511ddf463a356a7c10a37234e2a8e7cf6671b402fad7f

var $kSjiz = parcelRequire("kSjiz");

var $lIGkE = parcelRequire("lIGkE");
const $cf47837d884f4b0d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "keyword"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "fields": [
            {
                "kind": "Variable",
                "name": "keyword",
                "variableName": "keyword"
            }
        ],
        "kind": "ObjectValue",
        "name": "filter"
    }, v5 = {
        "kind": "Literal",
        "name": "types",
        "value": [
            "PROJECT",
            "FILTER",
            "DASHBOARD",
            "BOARD",
            "QUEUE",
            "ISSUE",
            "PLAN",
            "JPD_COLLECTION"
        ]
    }, v6 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        v5 /*: any*/ 
    ], v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v8 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        v5 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v10 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v12 /*: any*/ 
        ]
    }, v14 = [
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        {
            "alias": "filterName",
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterUrl"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useRecentItemsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "recent",
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v7 /*: any*/ ,
                                            "action": "THROW"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "useRecentItems"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled"
                }
            ],
            "kind": "Operation",
            "name": "useRecentItemsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "recent",
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "issueWebUrl",
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        },
                                                        v13 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v14 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v14 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "alias": "collectionTitle",
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "emoji"
                                                                }
                                                            ],
                                                            "type": "JiraProductDiscoveryCollection"
                                                        }
                                                    ]
                                                },
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v8 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "types",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "useRecentItemsPaged__recentItems",
                            "kind": "LinkedHandle",
                            "name": "recentItems"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "509ec68027aa639e3a3511ddf463a356a7c10a37234e2a8e7cf6671b402fad7f",
            "metadata": {},
            "name": "useRecentItemsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled": (0, $kSjiz.default)
            }
        }
    };
}();
$cf47837d884f4b0d$var$node.hash = "2396b8c64a1fe906a02b17df842b9e44";
(0, $lIGkE.PreloadableQueryRegistry).set($cf47837d884f4b0d$var$node.params.id, $cf47837d884f4b0d$var$node);
var $cf47837d884f4b0d$export$2e2bcd8739ae039 = $cf47837d884f4b0d$var$node;

});

parcelRegister("ksdzi", function(module, exports) {
$parcel$export(module.exports, "default", () => $c030ba2403e97580$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $eVMQF = parcelRequire("eVMQF");
function $c030ba2403e97580$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $euxye.useRef)(options);
    const callbackRef = (0, $euxye.useRef)(callback);
    callbackRef.current = callback;
    const debouncedCallBack = (0, $euxye.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($eVMQF)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $euxye.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("iwPMt", function(module, exports) {
$parcel$export(module.exports, "getSections", () => $c072589d2f6993a1$export$ddbcae0b0bd6b092);

var $euxye = parcelRequire("euxye");

var $gDou3 = parcelRequire("gDou3");
var $fE6LS = parcelRequire("fE6LS");
var $gNN3s = parcelRequire("gNN3s");
var $TsgOl = parcelRequire("TsgOl");
var $kLUAy = parcelRequire("kLUAy");

var $eT4u6 = parcelRequire("eT4u6");

var $emCaV = parcelRequire("emCaV");

var $aOGXw = parcelRequire("aOGXw");

var $fmH48 = parcelRequire("fmH48");

var $d5gEK = parcelRequire("d5gEK");

var $gND04 = parcelRequire("gND04");


var $j1V7P = parcelRequire("j1V7P");

var $2AOCd = parcelRequire("2AOCd");

var $8A8fZ = parcelRequire("8A8fZ");

var $OFy3z = parcelRequire("OFy3z");

var $b47ZF = parcelRequire("b47ZF");

var $alDF5 = parcelRequire("alDF5");

var $8ikZc = parcelRequire("8ikZc");

var $2v6ed = parcelRequire("2v6ed");

var $881dx = parcelRequire("881dx");

var $7eNDO = parcelRequire("7eNDO");

var $i860n = parcelRequire("i860n");

var $i6EgM = parcelRequire("i6EgM");

var $a9QaN = parcelRequire("a9QaN");
const $c072589d2f6993a1$var$timeAgoMessage = (0, $7eNDO.defineMessage)({
    id: "nav-platform-integration.sidebar.common.ui.recent.time-ago",
    defaultMessage: "{timeAgo} ago"
});
const $c072589d2f6993a1$var$todayMessage = (0, $7eNDO.defineMessage)({
    id: "nav-platform-integration.sidebar.common.ui.recent.today-group",
    defaultMessage: "Today"
});
const $c072589d2f6993a1$var$yesterdayMessage = (0, $7eNDO.defineMessage)({
    id: "nav-platform-integration.sidebar.common.ui.recent.yesterday-group",
    defaultMessage: "Yesterday"
});
const $c072589d2f6993a1$var$thisWeekMessage = (0, $7eNDO.defineMessage)({
    id: "nav-platform-integration.sidebar.common.ui.recent.this-week-group",
    defaultMessage: "This week"
});
const $c072589d2f6993a1$var$thisMonthMessage = (0, $7eNDO.defineMessage)({
    id: "nav-platform-integration.sidebar.common.ui.recent.this-month-group",
    defaultMessage: "This month"
});
const $c072589d2f6993a1$var$moreThanAMonthMessage = (0, $7eNDO.defineMessage)({
    id: "nav-platform-integration.sidebar.common.ui.recent.more-than-a-month-group",
    defaultMessage: "More than a month"
});
const $c072589d2f6993a1$var$messages = {
    timeAgo: $c072589d2f6993a1$var$timeAgoMessage,
    today: $c072589d2f6993a1$var$todayMessage,
    yesterday: $c072589d2f6993a1$var$yesterdayMessage,
    thisWeek: $c072589d2f6993a1$var$thisWeekMessage,
    thisMonth: $c072589d2f6993a1$var$thisMonthMessage,
    moreThanAMonth: $c072589d2f6993a1$var$moreThanAMonthMessage
};
const $c072589d2f6993a1$export$ddbcae0b0bd6b092 = (0, $emCaV.default)($c072589d2f6993a1$var$getSectionItems);
function $c072589d2f6993a1$var$getSectionItems(items, timeZone, deps) {
    const now = $c072589d2f6993a1$export$a86190deb5c4a8d0();
    const groups = items.reduce((acc, item)=>{
        const viewTimeAgo = $c072589d2f6993a1$var$getLastViewedTimestamp(item);
        if (viewTimeAgo) {
            const timeAccessed = new Date(viewTimeAgo);
            const dateObj = (0, $eT4u6.utcToZonedTime)(timeAccessed, timeZone);
            if ((0, $gDou3.default)(dateObj, (0, $gNN3s.default)())) acc.today.push(item);
            else if ((0, $gDou3.default)(dateObj, (0, $kLUAy.default)())) acc.yesterday.push(item);
            else if ((0, $gDou3.default)(dateObj, (0, $TsgOl.default)(now))) acc.thisWeek.push(item);
            else if ((0, $gDou3.default)(dateObj, (0, $fE6LS.default)(now))) acc.thisMonth.push(item);
            else acc.moreThanAMonth.push(item);
        }
        return acc;
    }, {
        today: [],
        yesterday: [],
        thisWeek: [],
        thisMonth: [],
        moreThanAMonth: []
    });
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return Object.entries(groups).map(([key, value])=>({
            header: deps.formatMessage($c072589d2f6993a1$var$messages[key]),
            items: value.map((i)=>$c072589d2f6993a1$var$toOLFItem(i, key, deps)).filter(Boolean)
        }));
}
function $c072589d2f6993a1$export$a86190deb5c4a8d0() {
    return Date.now();
}
function $c072589d2f6993a1$var$getLastViewedTimestamp(item) {
    switch(item.__typename){
        case 'JiraIssue':
        case 'JiraProject':
        case 'JiraPlan':
        case 'JiraBoard':
        case 'JiraDashboard':
        case 'JiraSystemFilter':
        case 'JiraCustomFilter':
        case 'JiraServiceManagementQueue':
            return item.lastViewedTimestamp;
        case 'JiraProductDiscoveryCollection':
            return (0, $i860n.fg)('jpd-enable-roadmaps-recents-fe') ? item.lastViewedTimestamp : null;
        default:
            return null;
    }
}
function $c072589d2f6993a1$var$toOLFItem(item, timeRange, deps) {
    switch(item.__typename){
        case 'JiraBoard':
            if (item.defaultNavigationItem?.url == null) return undefined;
            return {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j1V7P))), {
                    spacing: "spacious",
                    color: "currentColor",
                    label: ""
                }),
                href: item.defaultNavigationItem.url,
                primaryLabel: String(item.name ?? ''),
                secondaryLabel: $c072589d2f6993a1$export$16bf0b5dc5cbcfc7({
                    lastViewedTimestamp: item.lastViewedTimestamp,
                    ...deps
                }),
                analytics: {
                    itemId: String(item?.boardId),
                    itemType: (0, $b10cfeab38ca86b5$export$9b8283d5878d2491),
                    timeRange: timeRange
                }
            };
        case 'JiraDashboard':
            return {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AOCd))), {
                    spacing: "spacious",
                    color: "currentColor",
                    label: ""
                }),
                href: item.dashboardUrl ?? '',
                primaryLabel: String(item.dashboardTitle ?? ''),
                secondaryLabel: $c072589d2f6993a1$export$16bf0b5dc5cbcfc7({
                    lastViewedTimestamp: item.lastViewedTimestamp,
                    ...deps
                }),
                analytics: {
                    itemId: String(item?.dashboardId),
                    itemType: (0, $b10cfeab38ca86b5$export$4695c1a423ffe431),
                    timeRange: timeRange
                }
            };
        case 'JiraIssue':
            return {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ikZc))), {
                    spacing: "spacious",
                    color: "currentColor",
                    label: ""
                }),
                href: item.issueWebUrl ?? '',
                primaryLabel: String(item.summaryField?.text ?? ''),
                secondaryLabel: $c072589d2f6993a1$export$16bf0b5dc5cbcfc7({
                    lastViewedTimestamp: item.lastViewedTimestamp,
                    ...deps
                }),
                analytics: {
                    itemId: String(item?.issueId),
                    itemType: (0, $b10cfeab38ca86b5$export$76a449e52fa0e1e8),
                    timeRange: timeRange
                }
            };
        case 'JiraPlan':
            {
                const planId = item.planId;
                const scenarioId = item.scenario?.scenarioId ?? '';
                const planUrl = (0, $881dx.generatePath)((0, $gND04.softwarePlanTimelineRoute).path, {
                    planId: planId,
                    scenarioId: scenarioId
                });
                return {
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($alDF5))), {
                        spacing: "spacious",
                        color: "currentColor",
                        label: ""
                    }),
                    href: planUrl,
                    primaryLabel: String(item.planTitle ?? ''),
                    secondaryLabel: $c072589d2f6993a1$export$16bf0b5dc5cbcfc7({
                        lastViewedTimestamp: item.lastViewedTimestamp,
                        ...deps
                    }),
                    analytics: {
                        itemId: String(item?.planId),
                        itemType: (0, $b10cfeab38ca86b5$export$c303e491e026ebc6),
                        timeRange: timeRange
                    }
                };
            }
        case 'JiraProject':
            return {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v6ed.ContainerAvatar), {
                    src: item.avatar?.large ?? ''
                }),
                href: item.defaultNavigationItem?.url ?? `/browse/${item.key}`,
                primaryLabel: item.title,
                secondaryLabel: $c072589d2f6993a1$export$16bf0b5dc5cbcfc7({
                    lastViewedTimestamp: item.lastViewedTimestamp,
                    ...deps
                }),
                analytics: {
                    itemId: String(item?.projectId),
                    itemType: (0, $b10cfeab38ca86b5$export$fe791c4fa892e400),
                    timeRange: timeRange
                }
            };
        case 'JiraSystemFilter':
        case 'JiraCustomFilter':
            return {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8A8fZ))), {
                    spacing: "spacious",
                    color: "currentColor",
                    label: ""
                }),
                href: item.filterUrl ?? '',
                primaryLabel: item.filterName,
                secondaryLabel: $c072589d2f6993a1$export$16bf0b5dc5cbcfc7({
                    lastViewedTimestamp: item.lastViewedTimestamp,
                    ...deps
                }),
                analytics: {
                    itemId: String(item?.filterId),
                    itemType: (0, $b10cfeab38ca86b5$export$c1c49903035a02df),
                    timeRange: timeRange
                }
            };
        case 'JiraServiceManagementQueue':
            return {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($OFy3z))), {
                    spacing: "spacious",
                    color: "currentColor",
                    label: ""
                }),
                href: item.queueUrl ?? '',
                primaryLabel: String(item.queueTitle || ''),
                secondaryLabel: $c072589d2f6993a1$export$16bf0b5dc5cbcfc7({
                    lastViewedTimestamp: item.lastViewedTimestamp,
                    ...deps
                }),
                analytics: {
                    itemId: String(item?.queueId),
                    itemType: (0, $b10cfeab38ca86b5$export$5828682c822c26e7),
                    timeRange: timeRange
                }
            };
        case 'JiraProductDiscoveryCollection':
            {
                if (!(0, $i860n.fg)('jpd-enable-roadmaps-recents-fe')) return undefined;
                const uuid = item.id ? (0, $i6EgM.JiraProductDiscoveryCollectionAri).parse(item.id).collectionId : '';
                const collectionUrl = (0, $aOGXw.getCollectionDetailsPageUrl)(uuid);
                const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b47ZF))), {
                    spacing: "spacious",
                    color: "currentColor",
                    label: ""
                });
                return {
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9QaN.EmojiItem), {
                        emoji: item.emoji,
                        getEmojiProvider: (0, $fmH48.getEmojiProviderWithCustomEmoji),
                        cloudId: deps.cloudId,
                        accountId: deps.accountId,
                        fallback: fallback
                    }),
                    href: collectionUrl || item.collectionUrl || '',
                    primaryLabel: String(item.collectionTitle ?? ''),
                    secondaryLabel: $c072589d2f6993a1$export$16bf0b5dc5cbcfc7({
                        lastViewedTimestamp: item.lastViewedTimestamp,
                        ...deps
                    }),
                    analytics: {
                        itemId: String(item?.collectionId),
                        itemType: (0, $b10cfeab38ca86b5$export$dcd4d5ae3bbf4efe),
                        timeRange: timeRange
                    }
                };
            }
        default:
            return undefined;
    }
}
function $c072589d2f6993a1$export$16bf0b5dc5cbcfc7(params) {
    const { description: description, formatMessage: formatMessage, lastViewedTimestamp: lastViewedTimestamp, locale: locale } = params;
    const now = $c072589d2f6993a1$export$a86190deb5c4a8d0();
    const lastViewedTimeText = lastViewedTimestamp ? formatMessage($c072589d2f6993a1$var$messages.timeAgo, {
        timeAgo: (0, $d5gEK.formatDistanceStrictWithLocale)(lastViewedTimestamp, now, locale)
    }) : '';
    if ((description?.length ?? 0) > 0 && lastViewedTimeText.length > 0) return `${description} \u2022 ${lastViewedTimeText}`;
    return lastViewedTimeText;
}

});
parcelRegister("a9QaN", function(module, exports) {
$parcel$export(module.exports, "EmojiItem", () => $db1ee167a772a07b$export$8606f8a7e04e3912);

var $euxye = parcelRequire("euxye");

var $fnpYV = parcelRequire("fnpYV");
const $db1ee167a772a07b$export$8606f8a7e04e3912 = ({ getEmojiProvider: getEmojiProvider, cloudId: cloudId, accountId: accountId, emoji: emoji, label: label, fallback: fallback, fitToHeight: fitToHeight })=>{
    const emojiProvider = (0, $euxye.useMemo)(()=>getEmojiProvider ? getEmojiProvider(cloudId, accountId) : undefined, [
        cloudId,
        accountId,
        getEmojiProvider
    ]);
    if (!emoji || !emojiProvider) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, fallback);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fnpYV.default), {
        emojiId: {
            id: emoji,
            shortName: label ?? emoji
        },
        emojiProvider: emojiProvider,
        customFallback: fallback,
        fitToHeight: fitToHeight ?? 20
    });
};
$db1ee167a772a07b$export$8606f8a7e04e3912.displayName = "EmojiItem";

});
parcelRegister("fnpYV", function(module, exports) {
$parcel$export(module.exports, "default", () => $d246510db422ae50$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $dV8Kt = parcelRequire("dV8Kt");

var $kdJgV = parcelRequire("kdJgV");

var $gq0pG = parcelRequire("gq0pG");

var $3UnZm = parcelRequire("3UnZm");

var $9kdwp = parcelRequire("9kdwp");
const $d246510db422ae50$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $euxye.useEffect)(()=>{
        if (!emojiId) return;
        (0, $kdJgV.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $3UnZm.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $gq0pG.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $kdJgV.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9kdwp.UfoErrorBoundary), {
        experiences: [
            (0, $gq0pG.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ],
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dV8Kt.ResourcedEmojiComponent), {
            ...props
        })
    });
};
$d246510db422ae50$var$ResourcedEmoji.displayName = "ResourcedEmoji";
var $d246510db422ae50$export$2e2bcd8739ae039 = $d246510db422ae50$var$ResourcedEmoji;

});
parcelRegister("dV8Kt", function(module, exports) {
$parcel$export(module.exports, "ResourcedEmojiComponent", () => $21450526a53f10fb$export$7bfde52eceb3e2f6);
/* ResourcedEmojiComponent.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $cn5fq = parcelRequire("cn5fq");

var $e9q86 = parcelRequire("e9q86");

var $1uzV7 = parcelRequire("1uzV7");

var $dCZA2 = parcelRequire("dCZA2");

var $kdJgV = parcelRequire("kdJgV");

var $3UnZm = parcelRequire("3UnZm");

var $hD6uR = parcelRequire("hD6uR");

var $ktoNx = parcelRequire("ktoNx");

var $lzAfn = parcelRequire("lzAfn");

var $5aCXJ = parcelRequire("5aCXJ");

var $8rdd5 = parcelRequire("8rdd5");

var $flFtP = parcelRequire("flFtP");
const $21450526a53f10fb$var$ignoreWrapperStyles = null;
var $21450526a53f10fb$var$ResourcedEmojiComponentRenderStatesEnum = /*#__PURE__*/ function(ResourcedEmojiComponentRenderStatesEnum) {
    ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
    ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
    ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    return ResourcedEmojiComponentRenderStatesEnum;
}($21450526a53f10fb$var$ResourcedEmojiComponentRenderStatesEnum || {});
const $21450526a53f10fb$export$7bfde52eceb3e2f6 = ({ emojiProvider: emojiProvider, emojiId: emojiId, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, $3UnZm.defaultEmojiHeight), ignoreWrapper: ignoreWrapper = false, optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji, renderUnicodeEmojiAsImage: renderUnicodeEmojiAsImage = true, pageTitleEmoji: pageTitleEmoji = false, placeholderXcss: placeholderXcss, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    const { shortName: shortName, id: id, fallback: fallback } = emojiId;
    const [emoji, setEmoji] = (0, $euxye.useState)();
    const [loaded, setLoaded] = (0, $euxye.useState)(false);
    const [imageLoadError, setImageLoadError] = (0, $euxye.useState)(false);
    const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $euxye.useState)();
    const fetchOrGetEmoji = (0, $euxye.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
        if (!_emojiProvider.fetchByEmojiId) {
            setEmoji(undefined);
            const reason = 'missing fetchByEmojiId interface';
            onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
            (0, $kdJgV.sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: reason,
                    source: 'ResourcedEmojiComponent'
                }
            });
        }
        const useUnicodeEmojis = (0, $cn5fq.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true);
        const normalizedEmojiId = useUnicodeEmojis ? {
            ...emojiId,
            id: emojiId.id || undefined
        } : emojiId;
        // A shortName-only optimistic request can resolve without an emoji before the catalogue loads.
        // Use the non-optimistic path so it waits for the catalogue and tokenizes custom emoji media.
        const shouldFetchOptimistically = useUnicodeEmojis ? optimisticFetch && Boolean(emojiId.id) : optimisticFetch;
        const foundEmoji = _emojiProvider.fetchByEmojiId(normalizedEmojiId, shouldFetchOptimistically);
        (0, $kdJgV.sampledUfoRenderedEmoji)(emojiId).mark((0, $1uzV7.UfoEmojiTimings).METADATA_START);
        if ((0, $5aCXJ.isPromise)(foundEmoji)) {
            setLoaded(false);
            foundEmoji.then((emoji)=>{
                setEmoji(emoji);
                if (!emoji) {
                    const reason = 'failed to find';
                    onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                    // emoji is undefined
                    (0, $kdJgV.sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: reason,
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            }
                        }
                    });
                }
            }).catch(()=>{
                setEmoji(undefined);
                const reason = 'failed to load';
                onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                (0, $kdJgV.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: reason,
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        }
                    }
                });
            }).finally(()=>{
                setLoaded(true);
                (0, $kdJgV.sampledUfoRenderedEmoji)(emojiId).mark((0, $1uzV7.UfoEmojiTimings).METADATA_END);
            });
        } else {
            setEmoji(foundEmoji);
            setLoaded(true);
            (0, $kdJgV.sampledUfoRenderedEmoji)(emojiId).mark((0, $1uzV7.UfoEmojiTimings).METADATA_END);
        }
    }, [
        onEmojiLoadFail
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!emojiId) return;
        if (!(0, $dCZA2.hasUfoMarked)((0, $kdJgV.sampledUfoRenderedEmoji)(emojiId), (0, $1uzV7.UfoEmojiTimings).FMP_END)) (0, $kdJgV.sampledUfoRenderedEmoji)(emojiId).markFMP();
    }, [
        emojiId
    ]);
    (0, $euxye.useMemo)(()=>{
        if (!resolvedEmojiProvider || !emojiId) return;
        fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
    }, [
        resolvedEmojiProvider,
        emojiId,
        optimistic,
        fetchOrGetEmoji
    ]);
    /**
   * Setting resolved emoji provider for optimistic rendering
   */ (0, $euxye.useEffect)(()=>{
        Promise.resolve(emojiProvider).then((emojiProvider)=>{
            setResolvedEmojiProvider(emojiProvider);
        });
    }, [
        emojiProvider
    ]);
    const emojiRenderState = (0, $euxye.useMemo)(()=>{
        if (!emoji && !loaded && !optimisticImageURL || optimisticImageURL && !emoji && !id && (0, $cn5fq.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) return "INITIAL";
        else if (!emoji && loaded || imageLoadError) return "FALLBACK";
        return "EMOJI";
    }, [
        emoji,
        loaded,
        optimisticImageURL,
        imageLoadError,
        id
    ]);
    const optimisticEmojiDescription = (0, $euxye.useMemo)(()=>{
        // For STANDARD emojis, use native unicode character instead of optimistic image.
        if ((0, $cn5fq.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
            const resolvedId = id || emoji?.id;
            if (!resolvedId) return undefined;
            const unicodeEmoji = (0, $hD6uR.emojiIdToEmoji)(resolvedId);
            if (unicodeEmoji) return {
                ...emoji ?? {
                    id: id,
                    shortName: shortName,
                    fallback: fallback,
                    type: 'STANDARD',
                    category: '',
                    searchable: true
                },
                representation: {
                    unicodeEmoji: unicodeEmoji
                }
            };
        }
        // reduce blast radius by targeting page title
        if (pageTitleEmoji && optimisticImageURL && (0, $iqfTZ.fg)('platform_emoji_prevent_img_src_changing')) return {
            id: id,
            shortName: shortName,
            fallback: fallback,
            type: '',
            category: '',
            searchable: true,
            representation: {
                height: fitToHeight || (0, $3UnZm.defaultEmojiHeight),
                width: fitToHeight || (0, $3UnZm.defaultEmojiHeight),
                imagePath: optimisticImageURL
            }
        };
        // extend prevention to all surfaces
        if (optimisticImageURL && (0, $iqfTZ.fg)('platform_emoji_prevent_img_src_changing_all')) return {
            id: id,
            shortName: shortName,
            fallback: fallback,
            type: '',
            category: '',
            searchable: true,
            representation: {
                height: fitToHeight || (0, $3UnZm.defaultEmojiHeight),
                width: fitToHeight || (0, $3UnZm.defaultEmojiHeight),
                imagePath: optimisticImageURL
            }
        };
        if (optimisticImageURL) {
            if (emoji && ((0, $ktoNx.isImageRepresentation)(emoji.representation) || (0, $lzAfn.isMediaRepresentation)(emoji?.representation))) {
                const { width: width, height: height } = emoji.representation;
                return {
                    ...emoji,
                    representation: {
                        width: width,
                        height: height,
                        imagePath: optimisticImageURL
                    }
                };
            } else return {
                id: id,
                shortName: shortName,
                fallback: fallback,
                type: '',
                category: '',
                representation: {
                    height: fitToHeight || (0, $3UnZm.defaultEmojiHeight),
                    width: fitToHeight || (0, $3UnZm.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true
            };
        }
        return emoji;
    }, [
        emoji,
        optimisticImageURL,
        fallback,
        fitToHeight,
        id,
        shortName,
        pageTitleEmoji
    ]);
    const handleOnLoadError = (0, $euxye.useCallback)((emojiId)=>{
        setImageLoadError(true);
        const reason = 'load error';
        onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
        (0, $kdJgV.sampledUfoRenderedEmoji)(emojiId).failure({
            metadata: {
                reason: reason,
                source: 'ResourcedEmojiComponent',
                emojiId: emojiId.id
            }
        });
    }, [
        onEmojiLoadFail
    ]);
    const handleOnLoadSuccess = (0, $euxye.useCallback)((emojiId)=>{
        onEmojiLoadSuccess && onEmojiLoadSuccess(emojiId.id);
    }, [
        onEmojiLoadSuccess
    ]);
    // use width: auto when fitToHeight is defined
    const autoWidth = !!fitToHeight;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e9q86.EmojiCommonProvider), {
        emojiProvider: resolvedEmojiProvider,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)("span", {
            "data-emoji-id": id,
            "data-emoji-short-name": shortName,
            "data-emoji-text": fallback || shortName,
            "data-ssr-placeholder": `emoji-${id ?? shortName}`,
            "data-ssr-placeholder-replace": `emoji-${id ?? shortName}`,
            className: (0, $4jQY2.default)([
                ignoreWrapper && "_1e0c1bgi"
            ]),
            children: [
                emojiRenderState === "INITIAL" && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $flFtP.default), {
                    shortName: shortName,
                    showTooltip: showTooltip,
                    size: fitToHeight || (0, $3UnZm.defaultEmojiHeight),
                    loading: true,
                    xcss: placeholderXcss
                }),
                emojiRenderState === "FALLBACK" && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
                    children: customFallback || fallback || shortName
                }),
                emojiRenderState === "EMOJI" && optimisticEmojiDescription && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8rdd5.default), {
                    emoji: optimisticEmojiDescription,
                    onLoadError: handleOnLoadError,
                    onLoadSuccess: handleOnLoadSuccess,
                    showTooltip: showTooltip,
                    fitToHeight: fitToHeight,
                    autoWidth: autoWidth,
                    editorEmoji: editorEmoji,
                    renderUnicodeEmojiAsImage: renderUnicodeEmojiAsImage
                })
            ]
        })
    });
};
$21450526a53f10fb$export$7bfde52eceb3e2f6.displayName = "ResourcedEmojiComponent";
var $21450526a53f10fb$export$2e2bcd8739ae039 = $21450526a53f10fb$export$7bfde52eceb3e2f6;

});





parcelRegister("ki5u6", function(module, exports) {
$parcel$export(module.exports, "useStarredItems", () => $25adfabe9710e752$export$9a473b3d087f0f67);

var $1drTk = parcelRequire("1drTk");

var $2uWDA = parcelRequire("2uWDA");

var $hMjyk = parcelRequire("hMjyk");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $4ey3V = parcelRequire("4ey3V");

var $6ZLJT = parcelRequire("6ZLJT");

var $gQJGQ = parcelRequire("gQJGQ");

var $1YIbA = parcelRequire("1YIbA");

var $ksdzi = parcelRequire("ksdzi");

var $3GN2r = parcelRequire("3GN2r");

var $i860n = parcelRequire("i860n");

var $jgEH7 = parcelRequire("jgEH7");
const $25adfabe9710e752$var$useAccountIdWithFG = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jpd-enable-roadmaps-recents-fe'), (0, $3GN2r.useAccountId), ()=>null);
const $25adfabe9710e752$var$DEBOUNCE_INTERVAL = 300;
function $25adfabe9710e752$export$9a473b3d087f0f67(params) {
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const { searchText: searchText, selectedFilters: selectedFilters, queries: queries } = params;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const userLocale = (0, $gQJGQ.useLocale)();
    const { starredMenuData: starredMenuData } = queries;
    const { cloudId: cloudId, count: count } = starredMenuData.variables;
    const selectedFilter = (Array.isArray(selectedFilters) ? selectedFilters[0] : (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).ALL) || (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).ALL;
    const queryData = (0, $n67Vb.usePreloadedQuery)((0, $hMjyk.default), starredMenuData);
    const [fragmentData, refetch] = (0, $n67Vb.useRefetchableFragment)((0, $2uWDA.default), queryData);
    // NOTE: refetch() returns a Disposable resource. This resource should be dispose()'d of
    // before subsequent calls to refetch.
    // We also want to debounce changes-to-the-search-string.
    const disposableSearchRef = (0, $euxye.useRef)(null);
    const handleFilterChange = (0, $euxye.useCallback)((newSearch, newFilter)=>{
        // oxlint-disable-next-line typescript/consistent-type-assertions
        const filterQuery = {
            sort: {
                order: 'DESC'
            },
            ...newFilter === (0, $4ey3V.FAVORITE_TYPE_FILTER_MAP).ALL ? {
                types: (0, $4ey3V.VALID_FAVORITE_TYPES)
            } : {
                type: newFilter
            }
        };
        if (newSearch) filterQuery.keyword = newSearch;
        // Note: To avoid an extra network call, the filterQuery has to match the initial (prefetched)
        //  filterQuery EXACTLY. For example, the initial query had the `sort` prop, but when filterQuery
        //  didn't have this props, it triggered a refetch after the panel had rendered.
        //  refetch() is checking to see if the props change, to determine what it should do.
        // Note 2: We need to add the fetchPolicy so that the data refreshes correctly when using the star-button
        //  on a menu item. Without this fetchPolicy, the star-state can go out-of-sync with the menu item.
        return refetch({
            cloudId: cloudId,
            filter: filterQuery
        }, {
            fetchPolicy: 'store-and-network'
        });
    }, [
        cloudId,
        refetch
    ]);
    const [handleDebouncedSearchChange] = (0, $ksdzi.default)((newSearchQuery = searchText, newFilter = selectedFilter)=>{
        disposableSearchRef.current?.dispose();
        disposableSearchRef.current = handleFilterChange(newSearchQuery ?? '', newFilter);
    }, $25adfabe9710e752$var$DEBOUNCE_INTERVAL);
    (0, $euxye.useEffect)(()=>{
        handleDebouncedSearchChange(searchText ?? '', selectedFilter);
    }, [
        handleDebouncedSearchChange,
        searchText,
        selectedFilter
    ]);
    const { data: data, hasNext: /* isLoadingNext, */ hasNext, loadNext: loadNext } = (0, $n67Vb.usePaginationFragment)((0, $1drTk.default), fragmentData);
    const accountId = $25adfabe9710e752$var$useAccountIdWithFG();
    const deps = (0, $euxye.useMemo)(()=>({
            formatMessage: formatMessage,
            locale: userLocale,
            cloudId: cloudId,
            accountId: accountId
        }), [
        formatMessage,
        userLocale,
        cloudId,
        accountId
    ]);
    const { sections: sections } = (0, $euxye.useMemo)(()=>{
        const nodes = data.jira.starredItems?.edges?.map((edge)=>edge?.node).filter(Boolean) ?? [];
        return {
            sections: (0, $jgEH7.getSections)(nodes, deps)
        };
    }, [
        data.jira.starredItems?.edges,
        deps
    ]);
    const loadMore = (0, $euxye.useCallback)(()=>loadNext(count), [
        loadNext,
        count
    ]);
    if (searchText === '') return {
        sections: sections,
        hasMore: hasNext,
        isLoading: false,
        loadMore: loadMore
    };
    return {
        hasMore: hasNext,
        isLoading: false,
        loadMore: loadMore,
        sections: sections
    };
}

});
parcelRegister("1drTk", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e6dd9fdd9272041$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<accb4b8a60958ce1c08b4fc32099f36b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $e8pRw = parcelRequire("e8pRw");
const $1e6dd9fdd9272041$var$node = function() {
    var v0 = [
        "jira",
        "starredItems"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v3 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        {
            "alias": "filterTitle",
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterUrl"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "kind": "RootArgument",
                "name": "filter"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "count",
                        "cursor": "cursor"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $e8pRw.default)
            }
        },
        "name": "useStarredItemsPaged",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "starredItems",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "filter",
                                    "variableName": "filter"
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "__useStarredItemsPaged_starredItems_connection",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "alias": "projectTitle",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "alias": "boardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        },
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v4 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v4 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "alias": "collectionTitle",
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "emoji"
                                                                }
                                                            ],
                                                            "type": "JiraProductDiscoveryCollection"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW"
            }
        ],
        "type": "Query"
    };
}();
$1e6dd9fdd9272041$var$node.hash = "1968e8f4b90faafeb5bbea5f2ae18f06";
var $1e6dd9fdd9272041$export$2e2bcd8739ae039 = $1e6dd9fdd9272041$var$node;

});
parcelRegister("e8pRw", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8290ff751591711$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a95da472c6acb624c8fb69d3e4429310>>
 * @relayHash d002c55dc86fbf9e63de75f2b478a470
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c5e131700c98e154b6310bf05e45ef415d5ecb1d2e02bf178e0eab5350246a3

var $kSjiz = parcelRequire("kSjiz");
const $b8290ff751591711$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cursor"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJpdRoadmapsRecentsEnabled"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v10 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v9 /*: any*/ 
        ]
    }, v11 = [
        v7 /*: any*/ ,
        v8 /*: any*/ ,
        {
            "alias": "filterTitle",
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterUrl"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useStarredItemsPaginationQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        },
                        {
                            "kind": "Variable",
                            "name": "cursor",
                            "variableName": "cursor"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "useStarredItemsPaged"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled"
                }
            ],
            "kind": "Operation",
            "name": "useStarredItemsPaginationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "starredItems",
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "alias": "projectTitle",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                },
                                                                v7 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "alias": "boardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        },
                                                        v10 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v11 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v11 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "alias": "collectionTitle",
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "emoji"
                                                                }
                                                            ],
                                                            "type": "JiraProductDiscoveryCollection"
                                                        }
                                                    ]
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "starredItems",
                            "args": v5 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "useStarredItemsPaged_starredItems",
                            "kind": "LinkedHandle",
                            "name": "favourites"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8c5e131700c98e154b6310bf05e45ef415d5ecb1d2e02bf178e0eab5350246a3",
            "metadata": {},
            "name": "useStarredItemsPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "isJpdRoadmapsRecentsEnabled": (0, $kSjiz.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled": (0, $kSjiz.default)
            }
        }
    };
}();
$b8290ff751591711$var$node.hash = "1968e8f4b90faafeb5bbea5f2ae18f06";
var $b8290ff751591711$export$2e2bcd8739ae039 = $b8290ff751591711$var$node;

});


parcelRegister("2uWDA", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ca04e96bb439f60$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9c9c6f89b4fa01da8df500f4b0dd0d87>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $bCQsL = parcelRequire("bCQsL");
const $4ca04e96bb439f60$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "count"
        },
        {
            "kind": "RootArgument",
            "name": "filter"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $bCQsL.default)
        }
    },
    "name": "useStarredItems",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "count",
                    "variableName": "count"
                }
            ],
            "kind": "FragmentSpread",
            "name": "useStarredItemsPaged"
        }
    ],
    "type": "Query"
};
$4ca04e96bb439f60$var$node.hash = "b909e4d50c7f00b7a9e6847f3480bf16";
var $4ca04e96bb439f60$export$2e2bcd8739ae039 = $4ca04e96bb439f60$var$node;

});
parcelRegister("bCQsL", function(module, exports) {
$parcel$export(module.exports, "default", () => $f592e0aa8806535a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c9ac1291b334424eae8f72a9893334aa>>
 * @relayHash 9df91ede9907b2073c879aab8f38d6ba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b356e91c9b1774c219c147f95c38a0a4d67f831c551ea758d47e06a6701cfe1

var $kSjiz = parcelRequire("kSjiz");
const $f592e0aa8806535a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v8 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v7 /*: any*/ 
        ]
    }, v9 = [
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        {
            "alias": "filterTitle",
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterUrl"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useStarredItemsRefetchableQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "useStarredItems"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled"
                }
            ],
            "kind": "Operation",
            "name": "useStarredItemsRefetchableQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "starredItems",
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "alias": "projectTitle",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "alias": "boardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        },
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v9 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v9 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "alias": "collectionTitle",
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "emoji"
                                                                }
                                                            ],
                                                            "type": "JiraProductDiscoveryCollection"
                                                        }
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "starredItems",
                            "args": v3 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "useStarredItemsPaged_starredItems",
                            "kind": "LinkedHandle",
                            "name": "favourites"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4b356e91c9b1774c219c147f95c38a0a4d67f831c551ea758d47e06a6701cfe1",
            "metadata": {},
            "name": "useStarredItemsRefetchableQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled": (0, $kSjiz.default)
            }
        }
    };
}();
$f592e0aa8806535a$var$node.hash = "b909e4d50c7f00b7a9e6847f3480bf16";
var $f592e0aa8806535a$export$2e2bcd8739ae039 = $f592e0aa8806535a$var$node;

});


parcelRegister("hMjyk", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e8f716f5c8f341a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2ed51ad63495fc621ca40fff6b35c3b4>>
 * @relayHash 8ae3c137953b4e3e0049335ffb3be3c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 11b6405c2dc7d6e3b438f79bcf5a1758786eff77074374eddefc0a13723f0762

var $kSjiz = parcelRequire("kSjiz");

var $lIGkE = parcelRequire("lIGkE");
const $2e8f716f5c8f341a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v5 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v7 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v12 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v11 /*: any*/ 
        ]
    }, v13 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        {
            "alias": "filterTitle",
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterUrl"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useStarredItemsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "allFavourites",
                                "args": v5 /*: any*/ ,
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v6 /*: any*/ ,
                                        "action": "THROW"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "useStarredItems"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled"
                }
            ],
            "kind": "Operation",
            "name": "useStarredItemsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "allFavourites",
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "starredItems",
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "alias": "projectTitle",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                },
                                                                v9 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "alias": "boardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "alias": "collectionTitle",
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "collectionId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "emoji"
                                                                }
                                                            ],
                                                            "type": "JiraProductDiscoveryCollection"
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "starredItems",
                            "args": v7 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "useStarredItemsPaged_starredItems",
                            "kind": "LinkedHandle",
                            "name": "favourites"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "11b6405c2dc7d6e3b438f79bcf5a1758786eff77074374eddefc0a13723f0762",
            "metadata": {},
            "name": "useStarredItemsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled": (0, $kSjiz.default)
            }
        }
    };
}();
$2e8f716f5c8f341a$var$node.hash = "a990bf62548a878e271579864264b597";
(0, $lIGkE.PreloadableQueryRegistry).set($2e8f716f5c8f341a$var$node.params.id, $2e8f716f5c8f341a$var$node);
var $2e8f716f5c8f341a$export$2e2bcd8739ae039 = $2e8f716f5c8f341a$var$node;

});

parcelRegister("jgEH7", function(module, exports) {
$parcel$export(module.exports, "getSections", () => $e7f2feace138bfff$export$ddbcae0b0bd6b092);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $emCaV = parcelRequire("emCaV");

var $gND04 = parcelRequire("gND04");

var $aOGXw = parcelRequire("aOGXw");


var $fmH48 = parcelRequire("fmH48");

var $j1V7P = parcelRequire("j1V7P");

var $2AOCd = parcelRequire("2AOCd");

var $8A8fZ = parcelRequire("8A8fZ");

var $OFy3z = parcelRequire("OFy3z");

var $alDF5 = parcelRequire("alDF5");

var $2v6ed = parcelRequire("2v6ed");

var $b47ZF = parcelRequire("b47ZF");

var $i860n = parcelRequire("i860n");

var $i6EgM = parcelRequire("i6EgM");

var $881dx = parcelRequire("881dx");

var $a9QaN = parcelRequire("a9QaN");
const $e7f2feace138bfff$export$ddbcae0b0bd6b092 = (0, $emCaV.default)($e7f2feace138bfff$var$getSectionItems);
function $e7f2feace138bfff$var$getSectionItems(items, deps) {
    return [
        {
            items: items.map((i)=>$e7f2feace138bfff$var$toOLFItem(i, deps)).filter(Boolean)
        }
    ];
}
function $e7f2feace138bfff$var$toOLFItem(item, deps) {
    switch(item.__typename){
        case 'JiraBoard':
            if (item.defaultNavigationItem?.url == null) return undefined;
            return {
                analytics: {
                    itemId: String(item?.boardId),
                    itemType: (0, $b10cfeab38ca86b5$export$9b8283d5878d2491)
                },
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j1V7P))), {
                    spacing: "spacious",
                    color: "currentColor",
                    label: ""
                }),
                href: item.defaultNavigationItem.url,
                id: item.id,
                primaryLabel: String(item.boardTitle ?? ''),
                typename: item.__typename
            };
        case 'JiraDashboard':
            return {
                analytics: {
                    itemId: String(item?.dashboardId),
                    itemType: (0, $b10cfeab38ca86b5$export$4695c1a423ffe431)
                },
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AOCd))), {
                    spacing: "spacious",
                    color: "currentColor",
                    label: ""
                }),
                href: item.dashboardUrl ?? '',
                id: item.id,
                primaryLabel: String(item.dashboardTitle ?? ''),
                typename: item.__typename
            };
        case 'JiraPlan':
            {
                const planId = item.planId;
                const scenarioId = item.scenario?.scenarioId ?? '';
                const planUrl = (0, $881dx.generatePath)((0, $gND04.softwarePlanTimelineRoute).path, {
                    planId: planId,
                    scenarioId: scenarioId
                });
                return {
                    analytics: {
                        itemId: String(item?.planId),
                        itemType: (0, $b10cfeab38ca86b5$export$c303e491e026ebc6)
                    },
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($alDF5))), {
                        spacing: "spacious",
                        color: "currentColor",
                        label: ""
                    }),
                    href: planUrl,
                    id: item.id,
                    primaryLabel: String(item.planTitle ?? ''),
                    typename: item.__typename
                };
            }
        case 'JiraProject':
            return {
                analytics: {
                    itemId: String(item?.projectId),
                    itemType: (0, $b10cfeab38ca86b5$export$fe791c4fa892e400)
                },
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v6ed.ContainerAvatar), {
                    src: item.avatar?.large ?? ''
                }),
                href: item.defaultNavigationItem?.url ?? `/browse/${item.key}`,
                id: item.id,
                primaryLabel: item.projectTitle,
                typename: item.__typename
            };
        case 'JiraSystemFilter':
        case 'JiraCustomFilter':
            return {
                analytics: {
                    itemId: String(item?.filterId),
                    itemType: (0, $b10cfeab38ca86b5$export$c1c49903035a02df)
                },
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8A8fZ))), {
                    spacing: "spacious",
                    color: "currentColor",
                    label: ""
                }),
                href: item.filterUrl ?? '',
                id: item.id,
                primaryLabel: item.filterTitle,
                typename: item.__typename
            };
        case 'JiraServiceManagementQueue':
            return {
                analytics: {
                    itemId: String(item?.queueId),
                    itemType: (0, $b10cfeab38ca86b5$export$5828682c822c26e7)
                },
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($OFy3z))), {
                    spacing: "spacious",
                    color: "currentColor",
                    label: ""
                }),
                href: item.queueUrl ?? '',
                id: item.id,
                primaryLabel: String(item.queueTitle ?? ''),
                typename: item.__typename
            };
        case 'JiraProductDiscoveryCollection':
            {
                if (!(0, $i860n.fg)('jpd-enable-roadmaps-recents-fe')) return undefined;
                const uuid = item.id ? (0, $i6EgM.JiraProductDiscoveryCollectionAri).parse(item.id).collectionId : '';
                const collectionUrl = (0, $aOGXw.getCollectionDetailsPageUrl)(uuid);
                const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b47ZF))), {
                    spacing: "spacious",
                    color: "currentColor",
                    label: ""
                });
                return {
                    analytics: {
                        itemId: String(item?.collectionId),
                        itemType: (0, $b10cfeab38ca86b5$export$dcd4d5ae3bbf4efe)
                    },
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9QaN.EmojiItem), {
                        emoji: item.emoji,
                        getEmojiProvider: (0, $fmH48.getEmojiProviderWithCustomEmoji),
                        cloudId: deps.cloudId,
                        accountId: deps.accountId ?? undefined,
                        fallback: fallback
                    }),
                    href: collectionUrl || item.collectionUrl || '',
                    id: item.id || '',
                    primaryLabel: String(item.collectionTitle ?? ''),
                    typename: item.__typename
                };
            }
        default:
            return undefined;
    }
}

});


parcelRegister("9vZDD", function(module, exports) {
$parcel$export(module.exports, "recentFlyoutEntrypoint", () => $eb4f6787d0d3b52a$export$ecaea4121d3b11ae);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/entrypoint-root-module-path */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $7gTG5 = parcelRequire("7gTG5");

const $eb4f6787d0d3b52a$export$ecaea4121d3b11ae = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("eFm0R")), {
        moduleId: "55f97069",
        priority: "interaction",
        moduleId: 'objectListFlyoutEntrypoint'
    }),
    getPreloadProps: ({ cloudId: cloudId, count: count })=>({
            queries: {
                recentMenuData: {
                    parameters: $7gTG5.default,
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        count: count,
                        keyword: ''
                    }
                }
            }
        })
});

});
parcelRegister("eFm0R", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("gdZZt")
]).then(()=>parcelRequire('irNCE'));

});


parcelRegister("526V9", function(module, exports) {
$parcel$export(module.exports, "starredFlyoutEntrypoint", () => $0f60d86f3c98b8ed$export$4efb109f2f09fe21);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/entrypoint-root-module-path */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $hMjyk = parcelRequire("hMjyk");

const $0f60d86f3c98b8ed$export$4efb109f2f09fe21 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("eFm0R")), {
        moduleId: "55f97069",
        priority: "interaction",
        moduleId: 'objectListFlyoutEntrypoint'
    }),
    getPreloadProps: ({ cloudId: cloudId, filter: filter, count: count })=>({
            queries: {
                starredMenuData: {
                    parameters: $hMjyk.default,
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        count: count,
                        filter: filter
                    }
                }
            }
        })
});

});

parcelRegister("dgOWQ", function(module, exports) {
$parcel$export(module.exports, "RecentMenuLinkItemAdaptor", () => $f92323da82b20987$export$482d0a18f93a0080);

var $euxye = parcelRequire("euxye");

var $lpMZQ = parcelRequire("lpMZQ");

var $e6rNk = parcelRequire("e6rNk");
function $f92323da82b20987$export$482d0a18f93a0080(params) {
    const { href: href, elemBefore: elemBefore, primaryLabel: primaryLabel, secondaryLabel: secondaryLabel, tertiaryLabel: tertiaryLabel, analytics: analytics, onClick: onClick } = params;
    const description = secondaryLabel ? `${secondaryLabel}${tertiaryLabel ? ` \u{2022} ${tertiaryLabel}` : ''}` : '';
    const { fireUIAnalyticForRecentItems: fireUIAnalyticForRecentItems } = (0, $euxye.useContext)((0, $lpMZQ.AnalyticContext));
    const handleClick = (0, $euxye.useCallback)((event)=>{
        fireUIAnalyticForRecentItems(analytics);
        // It's important to call onClick so that the flyout closes when the menu item is clicked
        onClick?.(event);
    }, [
        analytics,
        fireUIAnalyticForRecentItems,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e6rNk.LinkMenuItem), {
        elemBefore: elemBefore,
        href: href || '',
        description: description,
        onClick: handleClick
    }, primaryLabel);
}
$f92323da82b20987$export$482d0a18f93a0080.displayName = "RecentMenuLinkItemAdaptor";

});

parcelRegister("4kWbe", function(module, exports) {
$parcel$export(module.exports, "StarredMenuLinkItemAdaptor", () => $09f8f75e14c6cf2e$export$aa6763327edef432);

var $euxye = parcelRequire("euxye");

var $78Tto = parcelRequire("78Tto");

var $e6rNk = parcelRequire("e6rNk");

var $5vYJB = parcelRequire("5vYJB");
function $09f8f75e14c6cf2e$export$aa6763327edef432(params) {
    const { analytics: analytics, defaultIsStarred: defaultIsStarred = true, elemBefore: elemBefore, href: href, id: id, onClick: onClick, primaryLabel: primaryLabel, typename: typename } = params;
    const { fireUIAnalyticForStarredItems: fireUIAnalyticForStarredItems } = (0, $euxye.useContext)((0, $78Tto.AnalyticContext));
    const handleClick = (0, $euxye.useCallback)((event)=>{
        fireUIAnalyticForStarredItems(analytics);
        // It's important to call onClick so that the flyout closes when the menu item is clicked
        onClick?.(event);
    }, [
        analytics,
        fireUIAnalyticForStarredItems,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $e6rNk.LinkMenuItem), {
        elemBefore: elemBefore,
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5vYJB.StarJiraItemButton), {
            analytics: analytics,
            defaultIsStarred: defaultIsStarred,
            id: id,
            name: primaryLabel,
            typename: typename
        }),
        href: href || '',
        onClick: handleClick
    }, primaryLabel);
}
$09f8f75e14c6cf2e$export$aa6763327edef432.displayName = "StarredMenuLinkItemAdaptor";

});
parcelRegister("5vYJB", function(module, exports) {
$parcel$export(module.exports, "StarJiraItemButton", () => $ff174c2d64872f21$export$7f329330fe69fb84);

var $euxye = parcelRequire("euxye");

var $2VfJf = parcelRequire("2VfJf");

var $ip3FN = parcelRequire("ip3FN");


var $hwodR = parcelRequire("hwodR");

var $78Tto = parcelRequire("78Tto");

var $m9iwH = parcelRequire("m9iwH");

var $fZT95 = parcelRequire("fZT95");

var $cXTqc = parcelRequire("cXTqc");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $ff174c2d64872f21$var$starButtonLabelWithName = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred-with-name",
    defaultMessage: "Add \"{name}\" to starred"
});
const $ff174c2d64872f21$var$unstarButtonLabelWithName = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred-with-name",
    defaultMessage: "Remove \"{name}\" from starred"
});
function $ff174c2d64872f21$export$7f329330fe69fb84(params) {
    const { analytics: { itemId: itemId, itemType: itemType }, defaultIsStarred: defaultIsStarred = false, id: id, name: name, typename: typename } = params;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    if (!(0, $2VfJf.isFavoritableItemTypename)(typename)) throw new Error(`Encountered unexpected item type: ${typename}`);
    const [isStarred, setIsStarred] = (0, $euxye.useState)(defaultIsStarred);
    const { changeFavoriteMutation: changeFavoriteMutation } = (0, $ip3FN.useChangeFavorite)();
    const { fireUIAnalyticForStarrButton: fireUIAnalyticForStarrButton } = (0, $euxye.useContext)((0, $78Tto.AnalyticContext));
    const handleOnClick = (0, $euxye.useCallback)(()=>{
        setIsStarred((prevIsStarred)=>{
            const shouldStarJiraItem = !prevIsStarred;
            changeFavoriteMutation({
                id: id,
                typename: typename,
                value: shouldStarJiraItem
            });
            fireUIAnalyticForStarrButton({
                starType: shouldStarJiraItem ? (0, $c6c6aa7a150fa522$export$54408be40394d82a) : (0, $c6c6aa7a150fa522$export$5fe513938f2c4081),
                parentItemId: itemId,
                parentItemType: itemType
            });
            return shouldStarJiraItem;
        });
    }, [
        changeFavoriteMutation,
        id,
        fireUIAnalyticForStarrButton,
        itemId,
        itemType,
        typename
    ]);
    const handleOnClickWithStopPropagation = (0, $hwodR.useStopPropagation)(handleOnClick);
    const unstarLabel = formatMessage($ff174c2d64872f21$var$unstarButtonLabelWithName, {
        name: name || ''
    });
    const starLabel = formatMessage($ff174c2d64872f21$var$starButtonLabelWithName, {
        name: name || ''
    });
    return isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fZT95))), {
                ...iconProps,
                color: "var(--ds-icon-accent-yellow, #B38600)"
            }),
        onClick: handleOnClickWithStopPropagation,
        label: unstarLabel
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cXTqc))),
        onClick: handleOnClickWithStopPropagation,
        label: starLabel
    });
}
$ff174c2d64872f21$export$7f329330fe69fb84.displayName = "StarJiraItemButton";

});



parcelRegister("6r1lK", function(module, exports) {
$parcel$export(module.exports, "useShortcuts", () => $bc84e18c3e0ffb09$export$a1ca853c6e4bb6fb);

var $euxye = parcelRequire("euxye");

var $kTARF = parcelRequire("kTARF");

var $5IkoH = parcelRequire("5IkoH");

var $curUp = parcelRequire("curUp");

var $58v8Z = parcelRequire("58v8Z");

var $aieBA = parcelRequire("aieBA");

var $frNbj = parcelRequire("frNbj");

var $br3o6 = parcelRequire("br3o6");

var $dO1Ns = parcelRequire("dO1Ns");

var $chlmx = parcelRequire("chlmx");

var $VKXQG = parcelRequire("VKXQG");

var $bF065 = parcelRequire("bF065");

var $2HuOR = parcelRequire("2HuOR");

var $eaLDc = parcelRequire("eaLDc");

var $eaxnH = parcelRequire("eaxnH");

var $iZFWm = parcelRequire("iZFWm");
function $bc84e18c3e0ffb09$export$a1ca853c6e4bb6fb() {
    const licenceStates = (0, $eaLDc.useLicenseStates)();
    const products = (0, $2HuOR.getLicensedProducts)();
    const fallbackUrls = (0, $eaxnH.useShortcutFallbackUrls)();
    const { config: teamsAppConfig } = (0, $58v8Z.useTeamsAppShortcut)();
    const { isVisible: showAssets, isJsmFreeSiteAdminUpsell: isJsmFreeSiteAdminUpsell, toResolvedAbsoluteUrl: toResolvedAbsoluteUrl } = (0, $aieBA.useAssetsSidebarState)();
    const resolvedAssetsUrl = toResolvedAbsoluteUrl(fallbackUrls[(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_ASSETS]);
    /**
	 * Base "do we show it" logic based on:
	 * - fast meta (HTML <meta> tags, which are available in SSR render and fed into here from getLicensedProducts)
	 * - other checks as seen in Nav4's useLicenseFilterMap()
	 */ let showConfluence = products?.[(0, $2HuOR.LICENSED_PRODUCTS).CONFLUENCE];
    let showLoom = products[(0, $2HuOR.LICENSED_PRODUCTS).LOOM];
    const showOpsGenie = licenceStates?.serviceDesk === 'ACTIVE';
    // The metadata used in getLicensedProducts() was previously "townsquare" but is now "project" and "goal".
    // This was copied from useLicenseFilterMap() in which it was noted to now use PROJECT/GOAL metadata with TOWNSQUARE fallback.
    let showProjects = true;
    showProjects = !!products[(0, $2HuOR.LICENSED_PRODUCTS).PROJECT] || !!products[(0, $2HuOR.LICENSED_PRODUCTS).TOWNSQUARE];
    let showGoals = true;
    showGoals = !!products[(0, $2HuOR.LICENSED_PRODUCTS).GOAL] || !!products[(0, $2HuOR.LICENSED_PRODUCTS).TOWNSQUARE];
    // Some extra logic for some specific cases.
    // Consolidated from useLicenseFilterMap()
    if (licenceStates?.serviceDesk === 'ACTIVE' || licenceStates?.productDiscovery === 'ACTIVE') {
        showConfluence = licenceStates?.core === 'ACTIVE';
        showLoom = licenceStates?.core === 'ACTIVE';
    }
    /**
	 * Item components
	 */ const goals = (0, $frNbj.useGoals)(fallbackUrls[(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_GOALS], {
        menuItemId: (0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_GOALS
    });
    const confluence = (0, $br3o6.useConfluence)(fallbackUrls[(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_CONFLUENCE], {
        menuItemId: (0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_CONFLUENCE
    });
    const loom = (0, $dO1Ns.useLoom)(fallbackUrls[(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_LOOM], {
        menuItemId: (0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_LOOM
    });
    const opsgenie = (0, $VKXQG.useOpsgenie)(fallbackUrls[(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_OPSGENIE], {
        menuItemId: (0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_OPSGENIE
    });
    const assetsBase = (0, $chlmx.useAssets)(resolvedAssetsUrl, {
        menuItemId: (0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_ASSETS
    });
    // bypass platform AppSwitcher BFF filter via component type.
    const assets = (0, $euxye.useMemo)(()=>showAssets ? {
            ...assetsBase,
            type: 'component',
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $curUp.GlobalAppShortcuts), {
                    menuId: (0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_ASSETS
                })
        } : assetsBase, [
        assetsBase,
        showAssets
    ]);
    const projects = (0, $bF065.useProjects)(fallbackUrls[(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_PROJECTS], {
        menuItemId: (0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_PROJECTS
    });
    /**
	 * Final configuration
	 */ return (0, $euxye.useMemo)(()=>{
        return {
            ...showConfluence ? {
                [(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_CONFLUENCE]: confluence
            } : {},
            ...showLoom && {
                [(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_LOOM]: loom
            },
            ...showAssets && {
                [(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_ASSETS]: {
                    ...assets,
                    ...isJsmFreeSiteAdminUpsell && {
                        type: 'component',
                        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kTARF.AssetsMenuItemFreeUsersPlacement), null)
                    }
                }
            },
            ...showOpsGenie && {
                [(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_OPSGENIE]: opsgenie
            },
            [(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_TEAMS]: {
                ...teamsAppConfig,
                menuItemId: (0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_TEAMS,
                type: 'component',
                isReorderable: true,
                component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iZFWm.CustomShortcutItem), {
                        menuId: (0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_TEAMS,
                        ...props
                    })
            },
            ...showGoals && {
                [(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_GOALS]: goals
            },
            ...showProjects && {
                [(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_PROJECTS]: projects
            }
        };
    }, [
        showConfluence,
        confluence,
        showLoom,
        loom,
        showAssets,
        assets,
        isJsmFreeSiteAdminUpsell,
        showOpsGenie,
        opsgenie,
        teamsAppConfig,
        showGoals,
        goals,
        showProjects,
        projects
    ]);
}

});
parcelRegister("eaxnH", function(module, exports) {
$parcel$export(module.exports, "useShortcutFallbackUrls", () => $ac22436650a67e35$export$5c2abc4575bc9535);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6zTYs = parcelRequire("6zTYs");

var $5IkoH = parcelRequire("5IkoH");
const $ac22436650a67e35$export$5c2abc4575bc9535 = ()=>{
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    // Note: At the time of writing, an empty fallback URL will cause the shortcut
    // to be shown in the customization modal but not in the sidebar, if the URL is not populated elsewhere.
    return {
        [(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_CONFLUENCE]: '/wiki',
        [(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_LOOM]: 'https://www.loom.com',
        [(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_ASSETS]: '/jira/assets',
        [(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_OPSGENIE]: '',
        // Shortcuts to Townsquare apps are based on how Townsquare constructs the fallback URLs in its nav implementation
        // @see townsquare/apps/home/src/sidebar/use-side-nav-app-items-for-nav-platform.tsx
        [(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_GOALS]: orgId ? `/o/${orgId}/goals` : '/goals',
        [(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_PROJECTS]: orgId ? `/o/${orgId}/projects` : '/projects',
        [(0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_TEAMS]: orgId ? `/o/${orgId}/people` : '/people'
    };
};

});

parcelRegister("iZFWm", function(module, exports) {
$parcel$export(module.exports, "CustomShortcutItem", () => $b988e6816e023f6f$export$4f0ed809ec7411dc);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $5IkoH = parcelRequire("5IkoH");

var $9eS3f = parcelRequire("9eS3f");

function $b988e6816e023f6f$export$4f0ed809ec7411dc(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "flag",
        id: `gsn-custom-shortcut-item--${props.menuId}`,
        packageName: (0, $9a699b3f60b99670$export$b8b9d90f9e5bd72b),
        teamName: (0, $9a699b3f60b99670$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b988e6816e023f6f$var$CustomShortcutItemInner, props));
}
$b988e6816e023f6f$export$4f0ed809ec7411dc.displayName = "CustomShortcutItem";
function $b988e6816e023f6f$var$CustomShortcutItemInner({ menuId: menuId, ...props }) {
    switch(menuId){
        case (0, $5IkoH.GLOBAL_APP_MENU_ID).GLOBAL_APP_TEAMS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9eS3f.Teams), props);
        default:
            return null;
    }
}
$b988e6816e023f6f$var$CustomShortcutItemInner.displayName = "CustomShortcutItemInner";

});


parcelRegister("9Th3w", function(module, exports) {
$parcel$export(module.exports, "useItemsConfig", () => $311a98c53038849a$export$57a48857bb5b7ae8);

var $euxye = parcelRequire("euxye");

var $1dk0x = parcelRequire("1dk0x");

var $hTFLW = parcelRequire("hTFLW");

var $6GljB = parcelRequire("6GljB");

var $af94c = parcelRequire("af94c");

var $k3CK1 = parcelRequire("k3CK1");

var $rZMKj = parcelRequire("rZMKj");

var $gaQ4v = parcelRequire("gaQ4v");

var $2zFZk = parcelRequire("2zFZk");

var $3LwTA = parcelRequire("3LwTA");

var $4er6h = parcelRequire("4er6h");

var $9rz84 = parcelRequire("9rz84");

var $jhJde = parcelRequire("jhJde");

var $4S9lF = parcelRequire("4S9lF");

var $g4ceC = parcelRequire("g4ceC");

var $jdVag = parcelRequire("jdVag");

var $l0TTR = parcelRequire("l0TTR");

var $dx7aH = parcelRequire("dx7aH");

var $bZXKt = parcelRequire("bZXKt");

var $1Io8b = parcelRequire("1Io8b");

var $fFNvS = parcelRequire("fFNvS");

var $i860n = parcelRequire("i860n");

var $1YIbA = parcelRequire("1YIbA");
function $311a98c53038849a$export$57a48857bb5b7ae8(navItems, queryRef) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return (0, $euxye.useMemo)(()=>{
        const componentProps = {
            isExpanded: false,
            queryRef: queryRef
        };
        return navItems.reduce((acc, { menuId: menuId })=>{
            // We need a configurable menu id and a component to continue
            if ((0, $bZXKt.isConfigurableMenuId)(menuId)) {
                const { message: message, Icon: Icon } = (0, $dx7aH.getConfigurableMessageAndIcon)(menuId);
                const label = formatMessage(message);
                // See src/packages/navigation-apps/sidebar-nav4-sidebars-common-core/src/common/utils/use-formatted-message-and-icon/index.tsx
                // Icon is decorative in the customization modal — the adjacent text label provides context.
                const elemBefore = (0, $i860n.fg)('ai-a11y-111-29329') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Icon, {
                    label: "",
                    spacing: "spacious",
                    color: "currentColor"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Icon, {
                    label: label,
                    spacing: "spacious",
                    color: "currentColor"
                });
                const itemConfig = $311a98c53038849a$var$mapMenuIdToNavItemConfig({
                    componentProps: componentProps,
                    elemBefore: elemBefore,
                    label: label,
                    menuId: menuId
                });
                if (itemConfig) acc[menuId] = itemConfig;
            }
            return acc;
        }, {});
    }, [
        formatMessage,
        navItems,
        queryRef
    ]);
}
function $311a98c53038849a$var$mapMenuIdToNavItemConfig(params) {
    const { componentProps: componentProps, elemBefore: elemBefore, label: label, menuId: menuId } = params;
    switch(menuId){
        case (0, $6GljB.L1_MENU_ID).APPS:
            return $311a98c53038849a$var$buildCustomComponentConfig({
                Component: (0, $k3CK1.Nav4Apps),
                componentProps: componentProps,
                elemBefore: elemBefore,
                label: label,
                isDraggable: true
            });
        case (0, $6GljB.L1_MENU_ID).ASSETS:
            /* remove this case on
       * assets_as_an_app_v2 cleanup
       */ return $311a98c53038849a$var$buildCustomComponentConfig({
                Component: (0, $rZMKj.Nav4Assets),
                componentProps: componentProps,
                elemBefore: elemBefore,
                label: label,
                isDraggable: false // Not draggable
            });
        case (0, $6GljB.L1_MENU_ID).CUSTOMERS:
            return $311a98c53038849a$var$buildCustomComponentConfig({
                Component: (0, $gaQ4v.Customers),
                componentProps: componentProps,
                elemBefore: elemBefore,
                label: label,
                isDraggable: true
            });
        case (0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE:
            return $311a98c53038849a$var$buildCustomComponentConfig({
                Component: (0, $2zFZk.CustomerService),
                componentProps: componentProps,
                elemBefore: elemBefore,
                label: label,
                isDraggable: true
            });
        case (0, $6GljB.L1_MENU_ID).HELP_CENTER_MANAGEMENT:
            // Visibility (license + admin + experiment) is enforced upstream by
            // `useFilterL1MenuItemsByEditionAndLicense` via `useShowHelpCenterManagement`.
            return $311a98c53038849a$var$buildCustomComponentConfig({
                Component: (0, $jdVag.HelpCenterManagement),
                componentProps: componentProps,
                elemBefore: elemBefore,
                label: label,
                isDraggable: true
            });
        case (0, $6GljB.L1_MENU_ID).DASHBOARDS:
            return $311a98c53038849a$var$buildCustomComponentConfig({
                Component: (0, $3LwTA.Nav4Dashboards),
                componentProps: componentProps,
                elemBefore: elemBefore,
                label: label,
                isDraggable: true
            });
        case (0, $6GljB.L1_MENU_ID).FILTERS:
            return $311a98c53038849a$var$buildCustomComponentConfig({
                Component: (0, $hTFLW.Nav4Filters),
                componentProps: componentProps,
                elemBefore: elemBefore,
                label: label,
                isDraggable: true
            });
        case (0, $6GljB.L1_MENU_ID).GOALS:
            {
                const USER_NAVIGATION_ITEM_LINKS = (0, $af94c.getUserNavigationItemLinks)();
                return {
                    type: 'link',
                    elemBefore: elemBefore,
                    label: label,
                    href: USER_NAVIGATION_ITEM_LINKS[(0, $6GljB.L1_MENU_ID).GOALS]
                };
            }
        case (0, $6GljB.L1_MENU_ID).ITAM:
            return (0, $i860n.fg)('itam_ftw') ? $311a98c53038849a$var$buildCustomComponentConfig({
                Component: (0, $1dk0x.Nav4ITAM),
                componentProps: componentProps,
                elemBefore: elemBefore,
                label: label,
                isDraggable: true
            }) : null;
        case (0, $6GljB.L1_MENU_ID).OPERATIONS:
            return $311a98c53038849a$var$buildCustomComponentConfig({
                Component: (0, $4er6h.Nav4Operations),
                componentProps: componentProps,
                elemBefore: elemBefore,
                label: label,
                isDraggable: true
            });
        case (0, $6GljB.L1_MENU_ID).PLANS:
            return $311a98c53038849a$var$buildCustomComponentConfig({
                Component: (0, $9rz84.Nav4Plans),
                componentProps: componentProps,
                elemBefore: elemBefore,
                label: label,
                isDraggable: true
            });
        case (0, $6GljB.L1_MENU_ID).PROJECTS:
            return $311a98c53038849a$var$buildCustomComponentConfig({
                Component: (0, $jhJde.Nav4Projects),
                componentProps: componentProps,
                elemBefore: elemBefore,
                label: label,
                isDraggable: true
            });
        case (0, $6GljB.L1_MENU_ID).ROADMAPS:
            if ((0, $i860n.fg)('jpd-enable-roadmaps-recents-fe')) return $311a98c53038849a$var$buildCustomComponentConfig({
                Component: (0, $l0TTR.Nav4RoadmapsNewWithRecent),
                componentProps: componentProps,
                elemBefore: elemBefore,
                label: label,
                isDraggable: true
            });
            if ((0, $i860n.fg)('jpd-roadmaps-in-jira')) return $311a98c53038849a$var$buildCustomComponentConfig({
                Component: (0, $g4ceC.Nav4RoadmapsNew),
                componentProps: componentProps,
                elemBefore: elemBefore,
                label: label,
                isDraggable: true
            });
            return $311a98c53038849a$var$buildCustomComponentConfig({
                Component: (0, $4S9lF.Nav4Roadmaps),
                componentProps: componentProps,
                elemBefore: elemBefore,
                label: label,
                isDraggable: true
            });
        case (0, $6GljB.L1_MENU_ID).TEAMS:
            return null;
        default:
            return null;
    }
}
function $311a98c53038849a$var$buildCustomComponentConfig(params) {
    const { Component: Component, componentProps: componentProps, elemBefore: elemBefore, isDraggable: isDraggable, label: label } = params;
    return {
        type: 'custom',
        elemBefore: elemBefore,
        isDraggable: isDraggable && (0, $i860n.fg)('navx-global-side-nav'),
        isMenuListItem: true,
        label: // All of these components are already wrapped in MenuListItem
        label,
        Component: (customItemProps)=>{
            const { isInMoreMenu: isInMoreMenu, visualContentRef: visualContentRef } = customItemProps;
            // When the item isInMoreMenu, we cannot render directly as this breaks the Peek logic.
            if (isInMoreMenu) // TODO: We should handle this internally in GSN to avoid duplicating this logic
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($311a98c53038849a$var$MoreMenuComponent, {
                elemBefore: elemBefore,
                label: label,
                ...customItemProps
            });
            const fixVisualContentRef = // oxlint-disable-next-line typescript/consistent-type-assertions
            visualContentRef;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, {
                ...componentProps,
                ...customItemProps,
                visualContentRef: fixVisualContentRef
            });
        }
    };
}
function $311a98c53038849a$var$MoreMenuComponent(props) {
    const { draggableRef: draggableRef, dropIndicator: dropIndicator, elemBefore: elemBefore, hasDragIndicator: hasDragIndicator, isDragging: isDragging, label: label, onClick: onClick, onPeek: onPeek, visualContentRef: visualContentRef } = props;
    // This is the same transformation happening inside GSN
    const handleClick = ()=>{
        onPeek?.();
        onClick?.();
    };
    // Need to coerce this type for ButtonMenuItem
    const fixVisualContentRef = // oxlint-disable-next-line typescript/consistent-type-assertions
    visualContentRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1Io8b.ButtonMenuItem), {
        dropIndicator: dropIndicator,
        onClick: handleClick,
        elemBefore: elemBefore,
        hasDragIndicator: hasDragIndicator,
        isDragging: isDragging,
        ref: draggableRef ? (0, $fFNvS.mergeRefs)(draggableRef, fixVisualContentRef) : fixVisualContentRef
    }, label);
}
$311a98c53038849a$var$MoreMenuComponent.displayName = "MoreMenuComponent";

});
parcelRegister("1dk0x", function(module, exports) {
$parcel$export(module.exports, "Nav4ITAM", () => $c0b1658e4cfaaf21$export$988f12767bbe8aa5);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $3rqqu = parcelRequire("3rqqu");

var $9F8bm = parcelRequire("9F8bm");

var $5JqUt = parcelRequire("5JqUt");

var $7ghii = parcelRequire("7ghii");

var $gDdYI = parcelRequire("gDdYI");

var $iEXfo = parcelRequire("iEXfo");
const $c0b1658e4cfaaf21$export$b8b9d90f9e5bd72b = 'jiraItamNav4MenuItem';
const $c0b1658e4cfaaf21$export$d57b6b390e78d90f = 'Aurum';
const $c0b1658e4cfaaf21$export$988f12767bbe8aa5 = (props)=>{
    const assetsVerticalWorkspaceAri = (0, $5JqUt.extractWorkspaceAri)(props.queryRef.assetsVertical_tenantContext);
    const staticResults = (0, $9F8bm.extractPermissionResults)(props.queryRef.assetsVertical_checkPermissions);
    const verticalInstantiationStatus = (0, $3rqqu.extractHamVerticalInstantiationStatus)(props.queryRef.assetsVertical_verticalInstantiations);
    const { showHardwareSettings: showHardwareSettings } = (0, $7ghii.useShowItam)({
        assetsVerticalWorkspaceAri: assetsVerticalWorkspaceAri,
        staticResults: staticResults,
        verticalInstantiationStatus: verticalInstantiationStatus
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4-sidebar-itam"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "flag",
        id: "itam-section",
        packageName: $c0b1658e4cfaaf21$export$b8b9d90f9e5bd72b,
        teamName: $c0b1658e4cfaaf21$export$d57b6b390e78d90f
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iEXfo.Nav4ITAMMenuLinkItem), {
        ...props,
        shouldShowHardwareSettings: showHardwareSettings
    })));
};
$c0b1658e4cfaaf21$export$988f12767bbe8aa5.displayName = "Nav4ITAM";

});
parcelRegister("3rqqu", function(module, exports) {
$parcel$export(module.exports, "extractHamVerticalInstantiationStatus", () => $14ba8d8da747e5b3$export$f752a5c0c8615166);
const $14ba8d8da747e5b3$export$f752a5c0c8615166 = (verticalInstantiations)=>verticalInstantiations?.edges?.find((edge)=>{
        const node = edge?.node;
        return node?.type === 'HAM' && node.id !== '';
    })?.node?.status ?? null;

});

parcelRegister("iEXfo", function(module, exports) {
$parcel$export(module.exports, "Nav4ITAMMenuLinkItem", () => $b92e1f71562b01a9$export$536b9b8335a95162);

var $euxye = parcelRequire("euxye");


var $8lHBG = parcelRequire("8lHBG");

var $5IkoH = parcelRequire("5IkoH");

var $aQCoC = parcelRequire("aQCoC");

var $dx7aH = parcelRequire("dx7aH");

var $gbTMi = parcelRequire("gbTMi");

var $hKd0r = parcelRequire("hKd0r");

var $c9cNX = parcelRequire("c9cNX");

var $881dx = parcelRequire("881dx");

var $8g18R = parcelRequire("8g18R");
const $b92e1f71562b01a9$export$536b9b8335a95162 = (props)=>{
    const { draggableRef: draggableRef, dropIndicator: dropIndicator, hasDragIndicator: hasDragIndicator, isDragging: isDragging, shouldShowHardwareSettings: shouldShowHardwareSettings, visualContentRef: visualContentRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dx7aH.useConfigurableMessageAndIconMap)((0, $5IkoH.MENU_ID_ITAM));
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const ref = draggableRef;
    const analytics = (0, $hKd0r.getMenuItemAnalytics)({
        actionSubjectId: (0, $c9cNX.MENU_ID_ANALYTIC_EVENT_IDS)[0, $5IkoH.MENU_ID_ITAM],
        itemId: 'itam',
        level: 1
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQCoC.Nav4MenuLinkItem), {
        analytics: analytics,
        dropIndicator: dropIndicator,
        elemBefore: icon,
        hasDragIndicator: hasDragIndicator,
        href: (0, $881dx.generatePath)((0, $8lHBG.itamRoute).path, {
            practice: (0, $012cccf9198da9e0$export$2ae2266431c5b026)
        }),
        isDragging: isDragging,
        menuId: (0, $5IkoH.MENU_ID_ITAM),
        ref: ref,
        testId: "nav4-menu-item.sidenav-itam",
        visualContentRef: visualContentRef,
        actionsOnHover: shouldShowHardwareSettings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gbTMi.MoreNavMenuButton), {
            MenuItems: (0, $8g18R.HardwareSettingsMenuItems),
            name: formattedMessage
        }) : undefined
    }, formattedMessage);
};
$b92e1f71562b01a9$export$536b9b8335a95162.displayName = "Nav4ITAMMenuLinkItem";

});
const $012cccf9198da9e0$export$2ae2266431c5b026 = 'ham';

parcelRegister("8lHBG", function(module, exports) {
$parcel$export(module.exports, "itamRoute", () => $ac65f384987f9678$export$e2ac8467edb96a95);
const $ac65f384987f9678$export$e2ac8467edb96a95 = {
    name: 'itam',
    path: '/jira/itam/:practice',
    exact: true
};

});

parcelRegister("8g18R", function(module, exports) {
$parcel$export(module.exports, "HardwareSettingsMenuItems", () => $d66d318815851d3d$export$e840797588d9d425);

var $euxye = parcelRequire("euxye");

var $dAhPw = parcelRequire("dAhPw");

var $g36LP = parcelRequire("g36LP");

var $ceqcm = parcelRequire("ceqcm");

var $gBaKj = parcelRequire("gBaKj");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $55BnK = parcelRequire("55BnK");
const $d66d318815851d3d$var$PRACTICE_HAM = 'ham';
const $d66d318815851d3d$var$MENU_ITEM_HARDWARE = 'hardware';
const $d66d318815851d3d$var$hardwareSettingsLabel = (0, $7eNDO.defineMessage)({
    id: "itam.nav4-menu-item.hardware-settings",
    defaultMessage: "Hardware settings"
});
const $d66d318815851d3d$export$e840797588d9d425 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { pushTo: pushTo } = (0, $55BnK.useRouterActions)();
    const handleSettingsClick = (0, $euxye.useCallback)((event)=>{
        pushTo((0, $dAhPw.itamSettingsRoute), {
            params: {
                practice: $d66d318815851d3d$var$PRACTICE_HAM,
                menu_item: $d66d318815851d3d$var$MENU_ITEM_HARDWARE
            }
        });
        onClose?.(event);
    }, [
        pushTo,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        onClick: handleSettingsClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gBaKj))), {
            label: "",
            color: "currentColor"
        })
    }, formatMessage($d66d318815851d3d$var$hardwareSettingsLabel)));
};
$d66d318815851d3d$export$e840797588d9d425.displayName = "HardwareSettingsMenuItems";

});
parcelRegister("dAhPw", function(module, exports) {
$parcel$export(module.exports, "itamSettingsRoute", () => $68bf15447782ae4a$export$4a92b404754514d9);
const $68bf15447782ae4a$export$4a92b404754514d9 = {
    name: 'itam-settings',
    path: '/jira/itam/:practice/settings/:menu_item?',
    exact: true,
    query: [
        'role?'
    ]
};

});





parcelRegister("h3ybG", function(module, exports) {
$parcel$export(module.exports, "useSaveCurrentContentSidebarRoute", () => $e71290ad34d697d0$export$218b19b088c4c7e7);

var $euxye = parcelRequire("euxye");

var $cn1qc = parcelRequire("cn1qc");

var $hmQJh = parcelRequire("hmQJh");

var $bZIAK = parcelRequire("bZIAK");

var $7p0B1 = parcelRequire("7p0B1");
function $e71290ad34d697d0$export$218b19b088c4c7e7() {
    const { saveCurrentRoute: saveCurrentRoute } = (0, $hmQJh.useNavigateBack)();
    const location = (0, $cn1qc.useLocation)();
    const { isActive: isProjectSettingsConnectAppActive } = (0, $7p0B1.useIsConnectAppActive)();
    const isNonRedirectRoute = (0, $bZIAK.useIsNonRedirectRoute)();
    // Derive the URL string during render — stable primitive string for the dep array.
    // Avoids spurious effect executions when the location object reference changes
    // but the actual URL has not.
    const url = `${location.pathname}${location.search}${location.hash}`;
    (0, $euxye.useEffect)(()=>{
        // NOTE: We need to AVOID saving the route if we're on a connect app...
        if (isNonRedirectRoute && !isProjectSettingsConnectAppActive) saveCurrentRoute(url);
    }, [
        isNonRedirectRoute,
        isProjectSettingsConnectAppActive,
        url,
        saveCurrentRoute
    ]);
}

});

parcelRegister("e5jcx", function(module, exports) {
$parcel$export(module.exports, "usePeekMenuId", () => $a3731ac9b6f8fcea$export$5d097184c0f78e68);

var $euxye = parcelRequire("euxye");

var $4Onaa = parcelRequire("4Onaa");

var $19zz3 = parcelRequire("19zz3");
/**
 * Routes where sidebar peek is disabled.
 * On these routes, the selected path is used for highlighting only, not for auto-expanding.
 */ const $a3731ac9b6f8fcea$var$PEEK_DISABLED_ROUTES = new Set([
    'for-you'
]);
function $a3731ac9b6f8fcea$export$5d097184c0f78e68(navItems) {
    const { isSelectedPath: isSelectedPath } = (0, $19zz3.useSidebarNav4)();
    const currentRoute = (0, $4Onaa.useCurrentRoute)();
    return (0, $euxye.useMemo)(()=>{
        if ($a3731ac9b6f8fcea$var$PEEK_DISABLED_ROUTES.has(currentRoute.name)) return undefined;
        return navItems.find((item)=>isSelectedPath(item.menuId))?.menuId;
    }, [
        navItems,
        isSelectedPath,
        currentRoute.name
    ]);
}

});





$parcel$global.rlb("7FBcr")
//# sourceMappingURL=NavPlatformSidebar.b9c6d272.js.map
